/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			modules[moduleId] = moreModules[moduleId];
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		0:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + ".chunk.js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	__webpack_require__(2);
	__webpack_require__(3);
	__webpack_require__(4);
	__webpack_require__(5);
	__webpack_require__(6);
	__webpack_require__(7);
	__webpack_require__(8);
	__webpack_require__(9);
	module.exports = __webpack_require__(10);


/***/ },
/* 1 */
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.5.6
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window) {'use strict';
	
	  /**
	   * @description
	   *
	   * This object provides a utility for producing rich Error messages within
	   * Angular. It can be called as follows:
	   *
	   * var exampleMinErr = minErr('example');
	   * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	   *
	   * The above creates an instance of minErr in the example namespace. The
	   * resulting error will have a namespaced error code of example.one.  The
	   * resulting error will replace {0} with the value of foo, and {1} with the
	   * value of bar. The object is not restricted in the number of arguments it can
	   * take.
	   *
	   * If fewer arguments are specified than necessary for interpolation, the extra
	   * interpolation markers will be preserved in the final string.
	   *
	   * Since data will be parsed statically during a build step, some restrictions
	   * are applied with respect to how minErr instances are created and called.
	   * Instances should have names of the form namespaceMinErr for a minErr created
	   * using minErr('namespace') . Error codes, namespaces and template strings
	   * should all be static strings, not variables or general expressions.
	   *
	   * @param {string} module The namespace to use for the new minErr instance.
	   * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	   *   error from returned function, for cases when a particular type of error is useful.
	   * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	   */
	
	  function minErr(module, ErrorConstructor) {
	    ErrorConstructor = ErrorConstructor || Error;
	    return function() {
	      var SKIP_INDEXES = 2;
	
	      var templateArgs = arguments,
	        code = templateArgs[0],
	        message = '[' + (module ? module + ':' : '') + code + '] ',
	        template = templateArgs[1],
	        paramPrefix, i;
	
	      message += template.replace(/\{\d+\}/g, function(match) {
	        var index = +match.slice(1, -1),
	          shiftedIndex = index + SKIP_INDEXES;
	
	        if (shiftedIndex < templateArgs.length) {
	          return toDebugString(templateArgs[shiftedIndex]);
	        }
	
	        return match;
	      });
	
	      message += '\nhttp://errors.angularjs.org/1.5.6/' +
	        (module ? module + '/' : '') + code;
	
	      for (i = SKIP_INDEXES, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	        message += paramPrefix + 'p' + (i - SKIP_INDEXES) + '=' +
	          encodeURIComponent(toDebugString(templateArgs[i]));
	      }
	
	      return new ErrorConstructor(message);
	    };
	  }
	
	  /* We need to tell jshint what variables are being exported */
	  /* global angular: true,
	   msie: true,
	   jqLite: true,
	   jQuery: true,
	   slice: true,
	   splice: true,
	   push: true,
	   toString: true,
	   ngMinErr: true,
	   angularModule: true,
	   uid: true,
	   REGEX_STRING_REGEXP: true,
	   VALIDITY_STATE_PROPERTY: true,
	
	   lowercase: true,
	   uppercase: true,
	   manualLowercase: true,
	   manualUppercase: true,
	   nodeName_: true,
	   isArrayLike: true,
	   forEach: true,
	   forEachSorted: true,
	   reverseParams: true,
	   nextUid: true,
	   setHashKey: true,
	   extend: true,
	   toInt: true,
	   inherit: true,
	   merge: true,
	   noop: true,
	   identity: true,
	   valueFn: true,
	   isUndefined: true,
	   isDefined: true,
	   isObject: true,
	   isBlankObject: true,
	   isString: true,
	   isNumber: true,
	   isDate: true,
	   isArray: true,
	   isFunction: true,
	   isRegExp: true,
	   isWindow: true,
	   isScope: true,
	   isFile: true,
	   isFormData: true,
	   isBlob: true,
	   isBoolean: true,
	   isPromiseLike: true,
	   trim: true,
	   escapeForRegexp: true,
	   isElement: true,
	   makeMap: true,
	   includes: true,
	   arrayRemove: true,
	   copy: true,
	   shallowCopy: true,
	   equals: true,
	   csp: true,
	   jq: true,
	   concat: true,
	   sliceArgs: true,
	   bind: true,
	   toJsonReplacer: true,
	   toJson: true,
	   fromJson: true,
	   convertTimezoneToLocal: true,
	   timezoneToOffset: true,
	   startingTag: true,
	   tryDecodeURIComponent: true,
	   parseKeyValue: true,
	   toKeyValue: true,
	   encodeUriSegment: true,
	   encodeUriQuery: true,
	   angularInit: true,
	   bootstrap: true,
	   getTestability: true,
	   snake_case: true,
	   bindJQuery: true,
	   assertArg: true,
	   assertArgFn: true,
	   assertNotHasOwnProperty: true,
	   getter: true,
	   getBlockNodes: true,
	   hasOwnProperty: true,
	   createMap: true,
	
	   NODE_TYPE_ELEMENT: true,
	   NODE_TYPE_ATTRIBUTE: true,
	   NODE_TYPE_TEXT: true,
	   NODE_TYPE_COMMENT: true,
	   NODE_TYPE_DOCUMENT: true,
	   NODE_TYPE_DOCUMENT_FRAGMENT: true,
	   */
	
	////////////////////////////////////
	
	  /**
	   * @ngdoc module
	   * @name ng
	   * @module ng
	   * @installation
	   * @description
	   *
	   * # ng (core module)
	   * The ng module is loaded by default when an AngularJS application is started. The module itself
	   * contains the essential components for an AngularJS application to function. The table below
	   * lists a high level breakdown of each of the services/factories, filters, directives and testing
	   * components available within this core module.
	   *
	   * <div doc-module-components="ng"></div>
	   */
	
	  var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	  var VALIDITY_STATE_PROPERTY = 'validity';
	
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	  var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	  var manualLowercase = function(s) {
	    /* jshint bitwise: false */
	    return isString(s)
	      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
	      : s;
	  };
	  var manualUppercase = function(s) {
	    /* jshint bitwise: false */
	    return isString(s)
	      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
	      : s;
	  };
	
	
	// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
	// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
	// with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
	  if ('i' !== 'I'.toLowerCase()) {
	    lowercase = manualLowercase;
	    uppercase = manualUppercase;
	  }
	
	
	  var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	  /**
	   * documentMode is an IE-only property
	   * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	   */
	  msie = window.document.documentMode;
	
	
	  /**
	   * @private
	   * @param {*} obj
	   * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	   *                   String ...)
	   */
	  function isArrayLike(obj) {
	
	    // `null`, `undefined` and `window` are not array-like
	    if (obj == null || isWindow(obj)) return false;
	
	    // arrays, strings and jQuery/jqLite objects are array like
	    // * jqLite is either the jQuery or jqLite constructor function
	    // * we have to check the existence of jqLite first as this method is called
	    //   via the forEach method when constructing the jqLite object in the first place
	    if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;
	
	    // Support: iOS 8.2 (not reproducible in simulator)
	    // "length" in obj used to prevent JIT error (gh-11508)
	    var length = "length" in Object(obj) && obj.length;
	
	    // NodeList objects (with `item` method) and
	    // other objects with suitable length characteristics are array-like
	    return isNumber(length) &&
	      (length >= 0 && ((length - 1) in obj || obj instanceof Array) || typeof obj.item == 'function');
	
	  }
	
	  /**
	   * @ngdoc function
	   * @name angular.forEach
	   * @module ng
	   * @kind function
	   *
	   * @description
	   * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	   * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	   * is the value of an object property or an array element, `key` is the object property key or
	   * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	   *
	   * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	   * using the `hasOwnProperty` method.
	   *
	   * Unlike ES262's
	   * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	   * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	   * return the value provided.
	   *
	   ```js
	   var values = {name: 'misko', gender: 'male'};
	   var log = [];
	   angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	   expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	   *
	   * @param {Object|Array} obj Object to iterate over.
	   * @param {Function} iterator Iterator function.
	   * @param {Object=} context Object to become context (`this`) for the iterator function.
	   * @returns {Object|Array} Reference to `obj`.
	   */
	
	  function forEach(obj, iterator, context) {
	    var key, length;
	    if (obj) {
	      if (isFunction(obj)) {
	        for (key in obj) {
	          // Need to check if hasOwnProperty exists,
	          // as on IE8 the result of querySelectorAll is an object without a hasOwnProperty function
	          if (key != 'prototype' && key != 'length' && key != 'name' && (!obj.hasOwnProperty || obj.hasOwnProperty(key))) {
	            iterator.call(context, obj[key], key, obj);
	          }
	        }
	      } else if (isArray(obj) || isArrayLike(obj)) {
	        var isPrimitive = typeof obj !== 'object';
	        for (key = 0, length = obj.length; key < length; key++) {
	          if (isPrimitive || key in obj) {
	            iterator.call(context, obj[key], key, obj);
	          }
	        }
	      } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	      } else if (isBlankObject(obj)) {
	        // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	        for (key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      } else if (typeof obj.hasOwnProperty === 'function') {
	        // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	        for (key in obj) {
	          if (obj.hasOwnProperty(key)) {
	            iterator.call(context, obj[key], key, obj);
	          }
	        }
	      } else {
	        // Slow path for objects which do not have a method `hasOwnProperty`
	        for (key in obj) {
	          if (hasOwnProperty.call(obj, key)) {
	            iterator.call(context, obj[key], key, obj);
	          }
	        }
	      }
	    }
	    return obj;
	  }
	
	  function forEachSorted(obj, iterator, context) {
	    var keys = Object.keys(obj).sort();
	    for (var i = 0; i < keys.length; i++) {
	      iterator.call(context, obj[keys[i]], keys[i]);
	    }
	    return keys;
	  }
	
	
	  /**
	   * when using forEach the params are value, key, but it is often useful to have key, value.
	   * @param {function(string, *)} iteratorFn
	   * @returns {function(*, string)}
	   */
	  function reverseParams(iteratorFn) {
	    return function(value, key) {iteratorFn(key, value);};
	  }
	
	  /**
	   * A consistent way of creating unique IDs in angular.
	   *
	   * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	   * we hit number precision issues in JavaScript.
	   *
	   * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	   *
	   * @returns {number} an unique alpha-numeric string
	   */
	  function nextUid() {
	    return ++uid;
	  }
	
	
	  /**
	   * Set or clear the hashkey for an object.
	   * @param obj object
	   * @param h the hashkey (!truthy to delete the hashkey)
	   */
	  function setHashKey(obj, h) {
	    if (h) {
	      obj.$$hashKey = h;
	    } else {
	      delete obj.$$hashKey;
	    }
	  }
	
	
	  function baseExtend(dst, objs, deep) {
	    var h = dst.$$hashKey;
	
	    for (var i = 0, ii = objs.length; i < ii; ++i) {
	      var obj = objs[i];
	      if (!isObject(obj) && !isFunction(obj)) continue;
	      var keys = Object.keys(obj);
	      for (var j = 0, jj = keys.length; j < jj; j++) {
	        var key = keys[j];
	        var src = obj[key];
	
	        if (deep && isObject(src)) {
	          if (isDate(src)) {
	            dst[key] = new Date(src.valueOf());
	          } else if (isRegExp(src)) {
	            dst[key] = new RegExp(src);
	          } else if (src.nodeName) {
	            dst[key] = src.cloneNode(true);
	          } else if (isElement(src)) {
	            dst[key] = src.clone();
	          } else {
	            if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	            baseExtend(dst[key], [src], true);
	          }
	        } else {
	          dst[key] = src;
	        }
	      }
	    }
	
	    setHashKey(dst, h);
	    return dst;
	  }
	
	  /**
	   * @ngdoc function
	   * @name angular.extend
	   * @module ng
	   * @kind function
	   *
	   * @description
	   * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	   * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	   * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	   *
	   * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	   * {@link angular.merge} for this.
	   *
	   * @param {Object} dst Destination object.
	   * @param {...Object} src Source object(s).
	   * @returns {Object} Reference to `dst`.
	   */
	  function extend(dst) {
	    return baseExtend(dst, slice.call(arguments, 1), false);
	  }
	
	
	  /**
	   * @ngdoc function
	   * @name angular.merge
	   * @module ng
	   * @kind function
	   *
	   * @description
	   * Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	   * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	   * by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	   *
	   * Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	   * objects, performing a deep copy.
	   *
	   * @param {Object} dst Destination object.
	   * @param {...Object} src Source object(s).
	   * @returns {Object} Reference to `dst`.
	   */
	  function merge(dst) {
	    return baseExtend(dst, slice.call(arguments, 1), true);
	  }
	
	
	
	  function toInt(str) {
	    return parseInt(str, 10);
	  }
	
	
	  function inherit(parent, extra) {
	    return extend(Object.create(parent), extra);
	  }
	
	  /**
	   * @ngdoc function
	   * @name angular.noop
	   * @module ng
	   * @kind function
	   *
	   * @description
	   * A function that performs no operations. This function can be useful when writing code in the
	   * functional style.
	   ```js
	   function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	   */
	  function noop() {}
	  noop.$inject = [];
	
	
	  /**
	   * @ngdoc function
	   * @name angular.identity
	   * @module ng
	   * @kind function
	   *
	   * @description
	   * A function that returns its first argument. This function is useful when writing code in the
	   * functional style.
	   *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	   *
	   * @param {*} value to be returned.
	   * @returns {*} the value passed in.
	   */
	  function identity($) {return $;}
	  identity.$inject = [];
	
	
	  function valueFn(value) {return function valueRef() {return value;};}
	
	  function hasCustomToString(obj) {
	    return isFunction(obj.toString) && obj.toString !== toString;
	  }
	
	
	  /**
	   * @ngdoc function
	   * @name angular.isUndefined
	   * @module ng
	   * @kind function
	   *
	   * @description
	   * Determines if a reference is undefined.
	   *
	   * @param {*} value Reference to check.
	   * @returns {boolean} True if `value` is undefined.
	   */
	  function isUndefined(value) {return typeof value === 'undefined';}
	
	
	  /**
	   * @ngdoc function
	   * @name angular.isDefined
	   * @module ng
	   * @kind function
	   *
	   * @description
	   * Determines if a reference is defined.
	   *
	   * @param {*} value Reference to check.
	   * @returns {boolean} True if `value` is defined.
	   */
	  function isDefined(value) {return typeof value !== 'undefined';}
	
	
	  /**
	   * @ngdoc function
	   * @name angular.isObject
	   * @module ng
	   * @kind function
	   *
	   * @description
	   * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	   * considered to be objects. Note that JavaScript arrays are objects.
	   *
	   * @param {*} value Reference to check.
	   * @returns {boolean} True if `value` is an `Object` but not `null`.
	   */
	  function isObject(value) {
	    // http://jsperf.com/isobject4
	    return value !== null && typeof value === 'object';
	  }
	
	
	  /**
	   * Determine if a value is an object with a null prototype
	   *
	   * @returns {boolean} True if `value` is an `Object` with a null prototype
	   */
	  function isBlankObject(value) {
	    return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	  }
	
	
	  /**
	   * @ngdoc function
	   * @name angular.isString
	   * @module ng
	   * @kind function
	   *
	   * @description
	   * Determines if a reference is a `String`.
	   *
	   * @param {*} value Reference to check.
	   * @returns {boolean} True if `value` is a `String`.
	   */
	  function isString(value) {return typeof value === 'string';}
	
	
	  /**
	   * @ngdoc function
	   * @name angular.isNumber
	   * @module ng
	   * @kind function
	   *
	   * @description
	   * Determines if a reference is a `Number`.
	   *
	   * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	   *
	   * If you wish to exclude these then you can use the native
	   * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	   * method.
	   *
	   * @param {*} value Reference to check.
	   * @returns {boolean} True if `value` is a `Number`.
	   */
	  function isNumber(value) {return typeof value === 'number';}
	
	
	  /**
	   * @ngdoc function
	   * @name angular.isDate
	   * @module ng
	   * @kind function
	   *
	   * @description
	   * Determines if a value is a date.
	   *
	   * @param {*} value Reference to check.
	   * @returns {boolean} True if `value` is a `Date`.
	   */
	  function isDate(value) {
	    return toString.call(value) === '[object Date]';
	  }
	
	
	  /**
	   * @ngdoc function
	   * @name angular.isArray
	   * @module ng
	   * @kind function
	   *
	   * @description
	   * Determines if a reference is an `Array`.
	   *
	   * @param {*} value Reference to check.
	   * @returns {boolean} True if `value` is an `Array`.
	   */
	  var isArray = Array.isArray;
	
	  /**
	   * @ngdoc function
	   * @name angular.isFunction
	   * @module ng
	   * @kind function
	   *
	   * @description
	   * Determines if a reference is a `Function`.
	   *
	   * @param {*} value Reference to check.
	   * @returns {boolean} True if `value` is a `Function`.
	   */
	  function isFunction(value) {return typeof value === 'function';}
	
	
	  /**
	   * Determines if a value is a regular expression object.
	   *
	   * @private
	   * @param {*} value Reference to check.
	   * @returns {boolean} True if `value` is a `RegExp`.
	   */
	  function isRegExp(value) {
	    return toString.call(value) === '[object RegExp]';
	  }
	
	
	  /**
	   * Checks if `obj` is a window object.
	   *
	   * @private
	   * @param {*} obj Object to check
	   * @returns {boolean} True if `obj` is a window obj.
	   */
	  function isWindow(obj) {
	    return obj && obj.window === obj;
	  }
	
	
	  function isScope(obj) {
	    return obj && obj.$evalAsync && obj.$watch;
	  }
	
	
	  function isFile(obj) {
	    return toString.call(obj) === '[object File]';
	  }
	
	
	  function isFormData(obj) {
	    return toString.call(obj) === '[object FormData]';
	  }
	
	
	  function isBlob(obj) {
	    return toString.call(obj) === '[object Blob]';
	  }
	
	
	  function isBoolean(value) {
	    return typeof value === 'boolean';
	  }
	
	
	  function isPromiseLike(obj) {
	    return obj && isFunction(obj.then);
	  }
	
	
	  var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array\]$/;
	  function isTypedArray(value) {
	    return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
	  }
	
	  function isArrayBuffer(obj) {
	    return toString.call(obj) === '[object ArrayBuffer]';
	  }
	
	
	  var trim = function(value) {
	    return isString(value) ? value.trim() : value;
	  };
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	  var escapeForRegexp = function(s) {
	    return s.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\$1').
	    replace(/\x08/g, '\\x08');
	  };
	
	
	  /**
	   * @ngdoc function
	   * @name angular.isElement
	   * @module ng
	   * @kind function
	   *
	   * @description
	   * Determines if a reference is a DOM element (or wrapped jQuery element).
	   *
	   * @param {*} value Reference to check.
	   * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	   */
	  function isElement(node) {
	    return !!(node &&
	    (node.nodeName  // We are a direct element.
	    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
	  }
	
	  /**
	   * @param str 'key1,key2,...'
	   * @returns {object} in the form of {key1:true, key2:true, ...}
	   */
	  function makeMap(str) {
	    var obj = {}, items = str.split(','), i;
	    for (i = 0; i < items.length; i++) {
	      obj[items[i]] = true;
	    }
	    return obj;
	  }
	
	
	  function nodeName_(element) {
	    return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	  }
	
	  function includes(array, obj) {
	    return Array.prototype.indexOf.call(array, obj) != -1;
	  }
	
	  function arrayRemove(array, value) {
	    var index = array.indexOf(value);
	    if (index >= 0) {
	      array.splice(index, 1);
	    }
	    return index;
	  }
	
	  /**
	   * @ngdoc function
	   * @name angular.copy
	   * @module ng
	   * @kind function
	   *
	   * @description
	   * Creates a deep copy of `source`, which should be an object or an array.
	   *
	   * * If no destination is supplied, a copy of the object or array is created.
	   * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	   *   are deleted and then all elements/properties from the source are copied to it.
	   * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	   * * If `source` is identical to 'destination' an exception will be thrown.
	   *
	   * @param {*} source The source that will be used to make a copy.
	   *                   Can be any type, including primitives, `null`, and `undefined`.
	   * @param {(Object|Array)=} destination Destination into which the source is copied. If
	   *     provided, must be of the same type as `source`.
	   * @returns {*} The copy or updated `destination`, if `destination` was specified.
	   *
	   * @example
	   <example module="copyExample">
	   <file name="index.html">
	   <div ng-controller="ExampleController">
	   <form novalidate class="simple-form">
	   Name: <input type="text" ng-model="user.name" /><br />
	   E-mail: <input type="email" ng-model="user.email" /><br />
	   Gender: <input type="radio" ng-model="user.gender" value="male" />male
	   <input type="radio" ng-model="user.gender" value="female" />female<br />
	   <button ng-click="reset()">RESET</button>
	   <button ng-click="update(user)">SAVE</button>
	   </form>
	   <pre>form = {{user | json}}</pre>
	   <pre>master = {{master | json}}</pre>
	   </div>
	
	   <script>
	   angular.module('copyExample', [])
	   .controller('ExampleController', ['$scope', function($scope) {
	      $scope.master= {};
	
	      $scope.update = function(user) {
	        // Example with 1 argument
	        $scope.master= angular.copy(user);
	      };
	
	      $scope.reset = function() {
	        // Example with 2 arguments
	        angular.copy($scope.master, $scope.user);
	      };
	
	      $scope.reset();
	    }]);
	   </script>
	   </file>
	   </example>
	   */
	  function copy(source, destination) {
	    var stackSource = [];
	    var stackDest = [];
	
	    if (destination) {
	      if (isTypedArray(destination) || isArrayBuffer(destination)) {
	        throw ngMinErr('cpta', "Can't copy! TypedArray destination cannot be mutated.");
	      }
	      if (source === destination) {
	        throw ngMinErr('cpi', "Can't copy! Source and destination are identical.");
	      }
	
	      // Empty the destination object
	      if (isArray(destination)) {
	        destination.length = 0;
	      } else {
	        forEach(destination, function(value, key) {
	          if (key !== '$$hashKey') {
	            delete destination[key];
	          }
	        });
	      }
	
	      stackSource.push(source);
	      stackDest.push(destination);
	      return copyRecurse(source, destination);
	    }
	
	    return copyElement(source);
	
	    function copyRecurse(source, destination) {
	      var h = destination.$$hashKey;
	      var key;
	      if (isArray(source)) {
	        for (var i = 0, ii = source.length; i < ii; i++) {
	          destination.push(copyElement(source[i]));
	        }
	      } else if (isBlankObject(source)) {
	        // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	        for (key in source) {
	          destination[key] = copyElement(source[key]);
	        }
	      } else if (source && typeof source.hasOwnProperty === 'function') {
	        // Slow path, which must rely on hasOwnProperty
	        for (key in source) {
	          if (source.hasOwnProperty(key)) {
	            destination[key] = copyElement(source[key]);
	          }
	        }
	      } else {
	        // Slowest path --- hasOwnProperty can't be called as a method
	        for (key in source) {
	          if (hasOwnProperty.call(source, key)) {
	            destination[key] = copyElement(source[key]);
	          }
	        }
	      }
	      setHashKey(destination, h);
	      return destination;
	    }
	
	    function copyElement(source) {
	      // Simple values
	      if (!isObject(source)) {
	        return source;
	      }
	
	      // Already copied values
	      var index = stackSource.indexOf(source);
	      if (index !== -1) {
	        return stackDest[index];
	      }
	
	      if (isWindow(source) || isScope(source)) {
	        throw ngMinErr('cpws',
	          "Can't copy! Making copies of Window or Scope instances is not supported.");
	      }
	
	      var needsRecurse = false;
	      var destination = copyType(source);
	
	      if (destination === undefined) {
	        destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
	        needsRecurse = true;
	      }
	
	      stackSource.push(source);
	      stackDest.push(destination);
	
	      return needsRecurse
	        ? copyRecurse(source, destination)
	        : destination;
	    }
	
	    function copyType(source) {
	      switch (toString.call(source)) {
	        case '[object Int8Array]':
	        case '[object Int16Array]':
	        case '[object Int32Array]':
	        case '[object Float32Array]':
	        case '[object Float64Array]':
	        case '[object Uint8Array]':
	        case '[object Uint8ClampedArray]':
	        case '[object Uint16Array]':
	        case '[object Uint32Array]':
	          return new source.constructor(copyElement(source.buffer));
	
	        case '[object ArrayBuffer]':
	          //Support: IE10
	          if (!source.slice) {
	            var copied = new ArrayBuffer(source.byteLength);
	            new Uint8Array(copied).set(new Uint8Array(source));
	            return copied;
	          }
	          return source.slice(0);
	
	        case '[object Boolean]':
	        case '[object Number]':
	        case '[object String]':
	        case '[object Date]':
	          return new source.constructor(source.valueOf());
	
	        case '[object RegExp]':
	          var re = new RegExp(source.source, source.toString().match(/[^\/]*$/)[0]);
	          re.lastIndex = source.lastIndex;
	          return re;
	
	        case '[object Blob]':
	          return new source.constructor([source], {type: source.type});
	      }
	
	      if (isFunction(source.cloneNode)) {
	        return source.cloneNode(true);
	      }
	    }
	  }
	
	  /**
	   * Creates a shallow copy of an object, an array or a primitive.
	   *
	   * Assumes that there are no proto properties for objects.
	   */
	  function shallowCopy(src, dst) {
	    if (isArray(src)) {
	      dst = dst || [];
	
	      for (var i = 0, ii = src.length; i < ii; i++) {
	        dst[i] = src[i];
	      }
	    } else if (isObject(src)) {
	      dst = dst || {};
	
	      for (var key in src) {
	        if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	          dst[key] = src[key];
	        }
	      }
	    }
	
	    return dst || src;
	  }
	
	
	  /**
	   * @ngdoc function
	   * @name angular.equals
	   * @module ng
	   * @kind function
	   *
	   * @description
	   * Determines if two objects or two values are equivalent. Supports value types, regular
	   * expressions, arrays and objects.
	   *
	   * Two objects or values are considered equivalent if at least one of the following is true:
	   *
	   * * Both objects or values pass `===` comparison.
	   * * Both objects or values are of the same type and all of their properties are equal by
	   *   comparing them with `angular.equals`.
	   * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	   * * Both values represent the same regular expression (In JavaScript,
	   *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	   *   representation matches).
	   *
	   * During a property comparison, properties of `function` type and properties with names
	   * that begin with `$` are ignored.
	   *
	   * Scope and DOMWindow objects are being compared only by identify (`===`).
	   *
	   * @param {*} o1 Object or value to compare.
	   * @param {*} o2 Object or value to compare.
	   * @returns {boolean} True if arguments are equal.
	   *
	   * @example
	   <example module="equalsExample" name="equalsExample">
	   <file name="index.html">
	   <div ng-controller="ExampleController">
	   <form novalidate>
	   <h3>User 1</h3>
	   Name: <input type="text" ng-model="user1.name">
	   Age: <input type="number" ng-model="user1.age">
	
	   <h3>User 2</h3>
	   Name: <input type="text" ng-model="user2.name">
	   Age: <input type="number" ng-model="user2.age">
	
	   <div>
	   <br/>
	   <input type="button" value="Compare" ng-click="compare()">
	   </div>
	   User 1: <pre>{{user1 | json}}</pre>
	   User 2: <pre>{{user2 | json}}</pre>
	   Equal: <pre>{{result}}</pre>
	   </form>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.result;
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	   </file>
	   </example>
	   */
	  function equals(o1, o2) {
	    if (o1 === o2) return true;
	    if (o1 === null || o2 === null) return false;
	    if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	    var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	    if (t1 == t2 && t1 == 'object') {
	      if (isArray(o1)) {
	        if (!isArray(o2)) return false;
	        if ((length = o1.length) == o2.length) {
	          for (key = 0; key < length; key++) {
	            if (!equals(o1[key], o2[key])) return false;
	          }
	          return true;
	        }
	      } else if (isDate(o1)) {
	        if (!isDate(o2)) return false;
	        return equals(o1.getTime(), o2.getTime());
	      } else if (isRegExp(o1)) {
	        if (!isRegExp(o2)) return false;
	        return o1.toString() == o2.toString();
	      } else {
	        if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	          isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	        keySet = createMap();
	        for (key in o1) {
	          if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	          if (!equals(o1[key], o2[key])) return false;
	          keySet[key] = true;
	        }
	        for (key in o2) {
	          if (!(key in keySet) &&
	            key.charAt(0) !== '$' &&
	            isDefined(o2[key]) &&
	            !isFunction(o2[key])) return false;
	        }
	        return true;
	      }
	    }
	    return false;
	  }
	
	  var csp = function() {
	    if (!isDefined(csp.rules)) {
	
	
	      var ngCspElement = (window.document.querySelector('[ng-csp]') ||
	      window.document.querySelector('[data-ng-csp]'));
	
	      if (ngCspElement) {
	        var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	          ngCspElement.getAttribute('data-ng-csp');
	        csp.rules = {
	          noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	          noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	        };
	      } else {
	        csp.rules = {
	          noUnsafeEval: noUnsafeEval(),
	          noInlineStyle: false
	        };
	      }
	    }
	
	    return csp.rules;
	
	    function noUnsafeEval() {
	      try {
	        /* jshint -W031, -W054 */
	        new Function('');
	        /* jshint +W031, +W054 */
	        return false;
	      } catch (e) {
	        return true;
	      }
	    }
	  };
	
	  /**
	   * @ngdoc directive
	   * @module ng
	   * @name ngJq
	   *
	   * @element ANY
	   * @param {string=} ngJq the name of the library available under `window`
	   * to be used for angular.element
	   * @description
	   * Use this directive to force the angular.element library.  This should be
	   * used to force either jqLite by leaving ng-jq blank or setting the name of
	   * the jquery variable under window (eg. jQuery).
	   *
	   * Since angular looks for this directive when it is loaded (doesn't wait for the
	   * DOMContentLoaded event), it must be placed on an element that comes before the script
	   * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	   * others ignored.
	   *
	   * @example
	   * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	   ```html
	   <!doctype html>
	   <html ng-app ng-jq>
	   ...
	   ...
	   </html>
	   ```
	   * @example
	   * This example shows how to use a jQuery based library of a different name.
	   * The library name must be available at the top most 'window'.
	   ```html
	   <!doctype html>
	   <html ng-app ng-jq="jQueryLib">
	   ...
	   ...
	   </html>
	   ```
	   */
	  var jq = function() {
	    if (isDefined(jq.name_)) return jq.name_;
	    var el;
	    var i, ii = ngAttrPrefixes.length, prefix, name;
	    for (i = 0; i < ii; ++i) {
	      prefix = ngAttrPrefixes[i];
	      if (el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]')) {
	        name = el.getAttribute(prefix + 'jq');
	        break;
	      }
	    }
	
	    return (jq.name_ = name);
	  };
	
	  function concat(array1, array2, index) {
	    return array1.concat(slice.call(array2, index));
	  }
	
	  function sliceArgs(args, startIndex) {
	    return slice.call(args, startIndex || 0);
	  }
	
	
	  /* jshint -W101 */
	  /**
	   * @ngdoc function
	   * @name angular.bind
	   * @module ng
	   * @kind function
	   *
	   * @description
	   * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	   * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	   * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	   * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	   *
	   * @param {Object} self Context which `fn` should be evaluated in.
	   * @param {function()} fn Function to be bound.
	   * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	   * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	   */
	  /* jshint +W101 */
	  function bind(self, fn) {
	    var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	    if (isFunction(fn) && !(fn instanceof RegExp)) {
	      return curryArgs.length
	        ? function() {
	        return arguments.length
	          ? fn.apply(self, concat(curryArgs, arguments, 0))
	          : fn.apply(self, curryArgs);
	      }
	        : function() {
	        return arguments.length
	          ? fn.apply(self, arguments)
	          : fn.call(self);
	      };
	    } else {
	      // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	      return fn;
	    }
	  }
	
	
	  function toJsonReplacer(key, value) {
	    var val = value;
	
	    if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	      val = undefined;
	    } else if (isWindow(value)) {
	      val = '$WINDOW';
	    } else if (value &&  window.document === value) {
	      val = '$DOCUMENT';
	    } else if (isScope(value)) {
	      val = '$SCOPE';
	    }
	
	    return val;
	  }
	
	
	  /**
	   * @ngdoc function
	   * @name angular.toJson
	   * @module ng
	   * @kind function
	   *
	   * @description
	   * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	   * stripped since angular uses this notation internally.
	   *
	   * @param {Object|Array|Date|string|number} obj Input to be serialized into JSON.
	   * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	   *    If set to an integer, the JSON output will contain that many spaces per indentation.
	   * @returns {string|undefined} JSON-ified string representing `obj`.
	   * @knownIssue
	   *
	   * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	   * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	   * `Date.prototype.toJSON` method as follows:
	   *
	   * ```
	   * var _DatetoJSON = Date.prototype.toJSON;
	   * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	   * ```
	   *
	   * See https://github.com/angular/angular.js/pull/14221 for more information.
	   */
	  function toJson(obj, pretty) {
	    if (isUndefined(obj)) return undefined;
	    if (!isNumber(pretty)) {
	      pretty = pretty ? 2 : null;
	    }
	    return JSON.stringify(obj, toJsonReplacer, pretty);
	  }
	
	
	  /**
	   * @ngdoc function
	   * @name angular.fromJson
	   * @module ng
	   * @kind function
	   *
	   * @description
	   * Deserializes a JSON string.
	   *
	   * @param {string} json JSON string to deserialize.
	   * @returns {Object|Array|string|number} Deserialized JSON string.
	   */
	  function fromJson(json) {
	    return isString(json)
	      ? JSON.parse(json)
	      : json;
	  }
	
	
	  var ALL_COLONS = /:/g;
	  function timezoneToOffset(timezone, fallback) {
	    // IE/Edge do not "understand" colon (`:`) in timezone
	    timezone = timezone.replace(ALL_COLONS, '');
	    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	  }
	
	
	  function addDateMinutes(date, minutes) {
	    date = new Date(date.getTime());
	    date.setMinutes(date.getMinutes() + minutes);
	    return date;
	  }
	
	
	  function convertTimezoneToLocal(date, timezone, reverse) {
	    reverse = reverse ? -1 : 1;
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	    return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	  }
	
	
	  /**
	   * @returns {string} Returns the string representation of the element.
	   */
	  function startingTag(element) {
	    element = jqLite(element).clone();
	    try {
	      // turns out IE does not let you set .html() on elements which
	      // are not allowed to have children. So we just ignore it.
	      element.empty();
	    } catch (e) {}
	    var elemHtml = jqLite('<div>').append(element).html();
	    try {
	      return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	        match(/^(<[^>]+>)/)[1].
	        replace(/^<([\w\-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
	    } catch (e) {
	      return lowercase(elemHtml);
	    }
	
	  }
	
	
	/////////////////////////////////////////////////
	
	  /**
	   * Tries to decode the URI component without throwing an exception.
	   *
	   * @private
	   * @param str value potential URI component to check.
	   * @returns {boolean} True if `value` can be decoded
	   * with the decodeURIComponent function.
	   */
	  function tryDecodeURIComponent(value) {
	    try {
	      return decodeURIComponent(value);
	    } catch (e) {
	      // Ignore any invalid uri component.
	    }
	  }
	
	
	  /**
	   * Parses an escaped url query string into key-value pairs.
	   * @returns {Object.<string,boolean|Array>}
	   */
	  function parseKeyValue(/**string*/keyValue) {
	    var obj = {};
	    forEach((keyValue || "").split('&'), function(keyValue) {
	      var splitPoint, key, val;
	      if (keyValue) {
	        key = keyValue = keyValue.replace(/\+/g,'%20');
	        splitPoint = keyValue.indexOf('=');
	        if (splitPoint !== -1) {
	          key = keyValue.substring(0, splitPoint);
	          val = keyValue.substring(splitPoint + 1);
	        }
	        key = tryDecodeURIComponent(key);
	        if (isDefined(key)) {
	          val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	          if (!hasOwnProperty.call(obj, key)) {
	            obj[key] = val;
	          } else if (isArray(obj[key])) {
	            obj[key].push(val);
	          } else {
	            obj[key] = [obj[key],val];
	          }
	        }
	      }
	    });
	    return obj;
	  }
	
	  function toKeyValue(obj) {
	    var parts = [];
	    forEach(obj, function(value, key) {
	      if (isArray(value)) {
	        forEach(value, function(arrayValue) {
	          parts.push(encodeUriQuery(key, true) +
	            (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	        });
	      } else {
	        parts.push(encodeUriQuery(key, true) +
	          (value === true ? '' : '=' + encodeUriQuery(value, true)));
	      }
	    });
	    return parts.length ? parts.join('&') : '';
	  }
	
	
	  /**
	   * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	   * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	   * segments:
	   *    segment       = *pchar
	   *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	   *    pct-encoded   = "%" HEXDIG HEXDIG
	   *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	   *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	   *                     / "*" / "+" / "," / ";" / "="
	   */
	  function encodeUriSegment(val) {
	    return encodeUriQuery(val, true).
	    replace(/%26/gi, '&').
	    replace(/%3D/gi, '=').
	    replace(/%2B/gi, '+');
	  }
	
	
	  /**
	   * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	   * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	   * encoded per http://tools.ietf.org/html/rfc3986:
	   *    query       = *( pchar / "/" / "?" )
	   *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	   *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	   *    pct-encoded   = "%" HEXDIG HEXDIG
	   *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	   *                     / "*" / "+" / "," / ";" / "="
	   */
	  function encodeUriQuery(val, pctEncodeSpaces) {
	    return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%3B/gi, ';').
	    replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	  }
	
	  var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	  function getNgAttribute(element, ngAttr) {
	    var attr, i, ii = ngAttrPrefixes.length;
	    for (i = 0; i < ii; ++i) {
	      attr = ngAttrPrefixes[i] + ngAttr;
	      if (isString(attr = element.getAttribute(attr))) {
	        return attr;
	      }
	    }
	    return null;
	  }
	
	  /**
	   * @ngdoc directive
	   * @name ngApp
	   * @module ng
	   *
	   * @element ANY
	   * @param {angular.Module} ngApp an optional application
	   *   {@link angular.module module} name to load.
	   * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	   *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	   *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	   *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	   *   tracking down the root of these bugs.
	   *
	   * @description
	   *
	   * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	   * designates the **root element** of the application and is typically placed near the root element
	   * of the page - e.g. on the `<body>` or `<html>` tags.
	   *
	   * There are a few things to keep in mind when using `ngApp`:
	   * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	   *   found in the document will be used to define the root element to auto-bootstrap as an
	   *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	   *   {@link angular.bootstrap} instead.
	   * - AngularJS applications cannot be nested within each other.
	   * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	   *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	   *   {@link ngRoute.ngView `ngView`}.
	   *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	   *   causing animations to stop working and making the injector inaccessible from outside the app.
	   *
	   * You can specify an **AngularJS module** to be used as the root module for the application.  This
	   * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	   * should contain the application code needed or have dependencies on other modules that will
	   * contain the code. See {@link angular.module} for more information.
	   *
	   * In the example below if the `ngApp` directive were not placed on the `html` element then the
	   * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	   * would not be resolved to `3`.
	   *
	   * `ngApp` is the easiest, and most common way to bootstrap an application.
	   *
	   <example module="ngAppDemo">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	   I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	   </example>
	   *
	   * Using `ngStrictDi`, you would see something like this:
	   *
	   <example ng-app-included="true">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	   <div ng-controller="GoodController1">
	   I can add: {{a}} + {{b}} =  {{ a+b }}
	
	   <p>This renders because the controller does not fail to
	   instantiate, by using explicit annotation style (see
	   script.js for details)
	   </p>
	   </div>
	
	   <div ng-controller="GoodController2">
	   Name: <input ng-model="name"><br />
	   Hello, {{name}}!
	
	   <p>This renders because the controller does not fail to
	   instantiate, by using explicit annotation style
	   (see script.js for details)
	   </p>
	   </div>
	
	   <div ng-controller="BadController">
	   I can add: {{a}} + {{b}} =  {{ a+b }}
	
	   <p>The controller could not be instantiated, due to relying
	   on automatic function annotations (which are disabled in
	   strict mode). As such, the content of this section is not
	   interpolated, and there should be an error in your web console.
	   </p>
	   </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	   // BadController will fail to instantiate, due to relying on automatic function annotation,
	   // rather than an explicit annotation
	   .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	   // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	   // due to using explicit annotations using the array style and $inject property, respectively.
	   .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	   .controller('GoodController2', GoodController2);
	   function GoodController2($scope) {
	       $scope.name = "World";
	     }
	   GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	   </example>
	   */
	  function angularInit(element, bootstrap) {
	    var appElement,
	      module,
	      config = {};
	
	    // The element `element` has priority over any other element.
	    forEach(ngAttrPrefixes, function(prefix) {
	      var name = prefix + 'app';
	
	      if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	        appElement = element;
	        module = element.getAttribute(name);
	      }
	    });
	    forEach(ngAttrPrefixes, function(prefix) {
	      var name = prefix + 'app';
	      var candidate;
	
	      if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	        appElement = candidate;
	        module = candidate.getAttribute(name);
	      }
	    });
	    if (appElement) {
	      config.strictDi = getNgAttribute(appElement, "strict-di") !== null;
	      bootstrap(appElement, module ? [module] : [], config);
	    }
	  }
	
	  /**
	   * @ngdoc function
	   * @name angular.bootstrap
	   * @module ng
	   * @description
	   * Use this function to manually start up angular application.
	   *
	   * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	   *
	   * Angular will detect if it has been loaded into the browser more than once and only allow the
	   * first loaded script to be bootstrapped and will report a warning to the browser console for
	   * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	   * multiple instances of Angular try to work on the DOM.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	   * They must use {@link ng.directive:ngApp ngApp}.
	   * </div>
	   *
	   * <div class="alert alert-warning">
	   * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	   * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	   * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	   * causing animations to stop working and making the injector inaccessible from outside the app.
	   * </div>
	   *
	   * ```html
	   * <!doctype html>
	   * <html>
	   * <body>
	   * <div ng-controller="WelcomeController">
	   *   {{greeting}}
	   * </div>
	   *
	   * <script src="angular.js"></script>
	   * <script>
	   *   var app = angular.module('demo', [])
	   *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	   *   angular.bootstrap(document, ['demo']);
	   * </script>
	   * </body>
	   * </html>
	   * ```
	   *
	   * @param {DOMElement} element DOM element which is the root of angular application.
	   * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	   *     Each item in the array should be the name of a predefined module or a (DI annotated)
	   *     function that will be invoked by the injector as a `config` block.
	   *     See: {@link angular.module modules}
	   * @param {Object=} config an object for defining configuration options for the application. The
	   *     following keys are supported:
	   *
	   * * `strictDi` - disable automatic function annotation for the application. This is meant to
	   *   assist in finding bugs which break minified code. Defaults to `false`.
	   *
	   * @returns {auto.$injector} Returns the newly created injector for this app.
	   */
	  function bootstrap(element, modules, config) {
	    if (!isObject(config)) config = {};
	    var defaultConfig = {
	      strictDi: false
	    };
	    config = extend(defaultConfig, config);
	    var doBootstrap = function() {
	      element = jqLite(element);
	
	      if (element.injector()) {
	        var tag = (element[0] === window.document) ? 'document' : startingTag(element);
	        // Encode angle brackets to prevent input from being sanitized to empty string #8683.
	        throw ngMinErr(
	          'btstrpd',
	          "App already bootstrapped with this element '{0}'",
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	      }
	
	      modules = modules || [];
	      modules.unshift(['$provide', function($provide) {
	        $provide.value('$rootElement', element);
	      }]);
	
	      if (config.debugInfoEnabled) {
	        // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	        modules.push(['$compileProvider', function($compileProvider) {
	          $compileProvider.debugInfoEnabled(true);
	        }]);
	      }
	
	      modules.unshift('ng');
	      var injector = createInjector(modules, config.strictDi);
	      injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	        function bootstrapApply(scope, element, compile, injector) {
	          scope.$apply(function() {
	            element.data('$injector', injector);
	            compile(element)(scope);
	          });
	        }]
	      );
	      return injector;
	    };
	
	    var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	    var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	    if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	      config.debugInfoEnabled = true;
	      window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	    }
	
	    if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	      return doBootstrap();
	    }
	
	    window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	    angular.resumeBootstrap = function(extraModules) {
	      forEach(extraModules, function(module) {
	        modules.push(module);
	      });
	      return doBootstrap();
	    };
	
	    if (isFunction(angular.resumeDeferredBootstrap)) {
	      angular.resumeDeferredBootstrap();
	    }
	  }
	
	  /**
	   * @ngdoc function
	   * @name angular.reloadWithDebugInfo
	   * @module ng
	   * @description
	   * Use this function to reload the current application with debug information turned on.
	   * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	   *
	   * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	   */
	  function reloadWithDebugInfo() {
	    window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	    window.location.reload();
	  }
	
	  /**
	   * @name angular.getTestability
	   * @module ng
	   * @description
	   * Get the testability service for the instance of Angular on the given
	   * element.
	   * @param {DOMElement} element DOM element which is the root of angular application.
	   */
	  function getTestability(rootElement) {
	    var injector = angular.element(rootElement).injector();
	    if (!injector) {
	      throw ngMinErr('test',
	        'no injector found for element argument to getTestability');
	    }
	    return injector.get('$$testability');
	  }
	
	  var SNAKE_CASE_REGEXP = /[A-Z]/g;
	  function snake_case(name, separator) {
	    separator = separator || '_';
	    return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	      return (pos ? separator : '') + letter.toLowerCase();
	    });
	  }
	
	  var bindJQueryFired = false;
	  function bindJQuery() {
	    var originalCleanData;
	
	    if (bindJQueryFired) {
	      return;
	    }
	
	    // bind to jQuery if present;
	    var jqName = jq();
	    jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
	      !jqName             ? undefined     :   // use jqLite
	        window[jqName];   // use jQuery specified by `ngJq`
	
	    // Use jQuery if it exists with proper functionality, otherwise default to us.
	    // Angular 1.2+ requires jQuery 1.7+ for on()/off() support.
	    // Angular 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	    // versions. It will not work for sure with jQuery <1.7, though.
	    if (jQuery && jQuery.fn.on) {
	      jqLite = jQuery;
	      extend(jQuery.fn, {
	        scope: JQLitePrototype.scope,
	        isolateScope: JQLitePrototype.isolateScope,
	        controller: JQLitePrototype.controller,
	        injector: JQLitePrototype.injector,
	        inheritedData: JQLitePrototype.inheritedData
	      });
	
	      // All nodes removed from the DOM via various jQuery APIs like .remove()
	      // are passed through jQuery.cleanData. Monkey-patch this method to fire
	      // the $destroy event on all removed nodes.
	      originalCleanData = jQuery.cleanData;
	      jQuery.cleanData = function(elems) {
	        var events;
	        for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	          events = jQuery._data(elem, "events");
	          if (events && events.$destroy) {
	            jQuery(elem).triggerHandler('$destroy');
	          }
	        }
	        originalCleanData(elems);
	      };
	    } else {
	      jqLite = JQLite;
	    }
	
	    angular.element = jqLite;
	
	    // Prevent double-proxying.
	    bindJQueryFired = true;
	  }
	
	  /**
	   * throw error if the argument is falsy.
	   */
	  function assertArg(arg, name, reason) {
	    if (!arg) {
	      throw ngMinErr('areq', "Argument '{0}' is {1}", (name || '?'), (reason || "required"));
	    }
	    return arg;
	  }
	
	  function assertArgFn(arg, name, acceptArrayAnnotation) {
	    if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	    }
	
	    assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	    return arg;
	  }
	
	  /**
	   * throw error if the name given is hasOwnProperty
	   * @param  {String} name    the name to test
	   * @param  {String} context the context in which the name is used, such as module or directive
	   */
	  function assertNotHasOwnProperty(name, context) {
	    if (name === 'hasOwnProperty') {
	      throw ngMinErr('badname', "hasOwnProperty is not a valid {0} name", context);
	    }
	  }
	
	  /**
	   * Return the value accessible from the object by path. Any undefined traversals are ignored
	   * @param {Object} obj starting object
	   * @param {String} path path to traverse
	   * @param {boolean} [bindFnToScope=true]
	   * @returns {Object} value as accessible by path
	   */
	//TODO(misko): this function needs to be removed
	  function getter(obj, path, bindFnToScope) {
	    if (!path) return obj;
	    var keys = path.split('.');
	    var key;
	    var lastInstance = obj;
	    var len = keys.length;
	
	    for (var i = 0; i < len; i++) {
	      key = keys[i];
	      if (obj) {
	        obj = (lastInstance = obj)[key];
	      }
	    }
	    if (!bindFnToScope && isFunction(obj)) {
	      return bind(lastInstance, obj);
	    }
	    return obj;
	  }
	
	  /**
	   * Return the DOM siblings between the first and last node in the given array.
	   * @param {Array} array like object
	   * @returns {Array} the inputted object or a jqLite collection containing the nodes
	   */
	  function getBlockNodes(nodes) {
	    // TODO(perf): update `nodes` instead of creating a new object?
	    var node = nodes[0];
	    var endNode = nodes[nodes.length - 1];
	    var blockNodes;
	
	    for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
	      if (blockNodes || nodes[i] !== node) {
	        if (!blockNodes) {
	          blockNodes = jqLite(slice.call(nodes, 0, i));
	        }
	        blockNodes.push(node);
	      }
	    }
	
	    return blockNodes || nodes;
	  }
	
	
	  /**
	   * Creates a new object without a prototype. This object is useful for lookup without having to
	   * guard against prototypically inherited properties via hasOwnProperty.
	   *
	   * Related micro-benchmarks:
	   * - http://jsperf.com/object-create2
	   * - http://jsperf.com/proto-map-lookup/2
	   * - http://jsperf.com/for-in-vs-object-keys2
	   *
	   * @returns {Object}
	   */
	  function createMap() {
	    return Object.create(null);
	  }
	
	  var NODE_TYPE_ELEMENT = 1;
	  var NODE_TYPE_ATTRIBUTE = 2;
	  var NODE_TYPE_TEXT = 3;
	  var NODE_TYPE_COMMENT = 8;
	  var NODE_TYPE_DOCUMENT = 9;
	  var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	  /**
	   * @ngdoc type
	   * @name angular.Module
	   * @module ng
	   * @description
	   *
	   * Interface for configuring angular {@link angular.module modules}.
	   */
	
	  function setupModuleLoader(window) {
	
	    var $injectorMinErr = minErr('$injector');
	    var ngMinErr = minErr('ng');
	
	    function ensure(obj, name, factory) {
	      return obj[name] || (obj[name] = factory());
	    }
	
	    var angular = ensure(window, 'angular', Object);
	
	    // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	    angular.$$minErr = angular.$$minErr || minErr;
	
	    return ensure(angular, 'module', function() {
	      /** @type {Object.<string, angular.Module>} */
	      var modules = {};
	
	      /**
	       * @ngdoc function
	       * @name angular.module
	       * @module ng
	       * @description
	       *
	       * The `angular.module` is a global place for creating, registering and retrieving Angular
	       * modules.
	       * All modules (angular core or 3rd party) that should be available to an application must be
	       * registered using this mechanism.
	       *
	       * Passing one argument retrieves an existing {@link angular.Module},
	       * whereas passing more than one argument creates a new {@link angular.Module}
	       *
	       *
	       * # Module
	       *
	       * A module is a collection of services, directives, controllers, filters, and configuration information.
	       * `angular.module` is used to configure the {@link auto.$injector $injector}.
	       *
	       * ```js
	       * // Create a new module
	       * var myModule = angular.module('myModule', []);
	       *
	       * // register a new service
	       * myModule.value('appName', 'MyCoolApp');
	       *
	       * // configure existing services inside initialization blocks.
	       * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	       * ```
	       *
	       * Then you can create an injector and load your modules like this:
	       *
	       * ```js
	       * var injector = angular.injector(['ng', 'myModule'])
	       * ```
	       *
	       * However it's more likely that you'll just use
	       * {@link ng.directive:ngApp ngApp} or
	       * {@link angular.bootstrap} to simplify this process for you.
	       *
	       * @param {!string} name The name of the module to create or retrieve.
	       * @param {!Array.<string>=} requires If specified then new module is being created. If
	       *        unspecified then the module is being retrieved for further configuration.
	       * @param {Function=} configFn Optional configuration function for the module. Same as
	       *        {@link angular.Module#config Module#config()}.
	       * @returns {angular.Module} new module with the {@link angular.Module} api.
	       */
	      return function module(name, requires, configFn) {
	        var assertNotHasOwnProperty = function(name, context) {
	          if (name === 'hasOwnProperty') {
	            throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	          }
	        };
	
	        assertNotHasOwnProperty(name, 'module');
	        if (requires && modules.hasOwnProperty(name)) {
	          modules[name] = null;
	        }
	        return ensure(modules, name, function() {
	          if (!requires) {
	            throw $injectorMinErr('nomod', "Module '{0}' is not available! You either misspelled " +
	              "the module name or forgot to load it. If registering a module ensure that you " +
	              "specify the dependencies as the second argument.", name);
	          }
	
	          /** @type {!Array.<Array.<*>>} */
	          var invokeQueue = [];
	
	          /** @type {!Array.<Function>} */
	          var configBlocks = [];
	
	          /** @type {!Array.<Function>} */
	          var runBlocks = [];
	
	          var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	          /** @type {angular.Module} */
	          var moduleInstance = {
	            // Private state
	            _invokeQueue: invokeQueue,
	            _configBlocks: configBlocks,
	            _runBlocks: runBlocks,
	
	            /**
	             * @ngdoc property
	             * @name angular.Module#requires
	             * @module ng
	             *
	             * @description
	             * Holds the list of modules which the injector will load before the current module is
	             * loaded.
	             */
	            requires: requires,
	
	            /**
	             * @ngdoc property
	             * @name angular.Module#name
	             * @module ng
	             *
	             * @description
	             * Name of the module.
	             */
	            name: name,
	
	
	            /**
	             * @ngdoc method
	             * @name angular.Module#provider
	             * @module ng
	             * @param {string} name service name
	             * @param {Function} providerType Construction function for creating new instance of the
	             *                                service.
	             * @description
	             * See {@link auto.$provide#provider $provide.provider()}.
	             */
	            provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	            /**
	             * @ngdoc method
	             * @name angular.Module#factory
	             * @module ng
	             * @param {string} name service name
	             * @param {Function} providerFunction Function for creating new instance of the service.
	             * @description
	             * See {@link auto.$provide#factory $provide.factory()}.
	             */
	            factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	            /**
	             * @ngdoc method
	             * @name angular.Module#service
	             * @module ng
	             * @param {string} name service name
	             * @param {Function} constructor A constructor function that will be instantiated.
	             * @description
	             * See {@link auto.$provide#service $provide.service()}.
	             */
	            service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	            /**
	             * @ngdoc method
	             * @name angular.Module#value
	             * @module ng
	             * @param {string} name service name
	             * @param {*} object Service instance object.
	             * @description
	             * See {@link auto.$provide#value $provide.value()}.
	             */
	            value: invokeLater('$provide', 'value'),
	
	            /**
	             * @ngdoc method
	             * @name angular.Module#constant
	             * @module ng
	             * @param {string} name constant name
	             * @param {*} object Constant value.
	             * @description
	             * Because the constants are fixed, they get applied before other provide methods.
	             * See {@link auto.$provide#constant $provide.constant()}.
	             */
	            constant: invokeLater('$provide', 'constant', 'unshift'),
	
	            /**
	             * @ngdoc method
	             * @name angular.Module#decorator
	             * @module ng
	             * @param {string} name The name of the service to decorate.
	             * @param {Function} decorFn This function will be invoked when the service needs to be
	             *                           instantiated and should return the decorated service instance.
	             * @description
	             * See {@link auto.$provide#decorator $provide.decorator()}.
	             */
	            decorator: invokeLaterAndSetModuleName('$provide', 'decorator'),
	
	            /**
	             * @ngdoc method
	             * @name angular.Module#animation
	             * @module ng
	             * @param {string} name animation name
	             * @param {Function} animationFactory Factory function for creating new instance of an
	             *                                    animation.
	             * @description
	             *
	             * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	             *
	             *
	             * Defines an animation hook that can be later used with
	             * {@link $animate $animate} service and directives that use this service.
	             *
	             * ```js
	             * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	             * ```
	             *
	             * See {@link ng.$animateProvider#register $animateProvider.register()} and
	             * {@link ngAnimate ngAnimate module} for more information.
	             */
	            animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	            /**
	             * @ngdoc method
	             * @name angular.Module#filter
	             * @module ng
	             * @param {string} name Filter name - this must be a valid angular expression identifier
	             * @param {Function} filterFactory Factory function for creating new instance of filter.
	             * @description
	             * See {@link ng.$filterProvider#register $filterProvider.register()}.
	             *
	             * <div class="alert alert-warning">
	             * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	             * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	             * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	             * (`myapp_subsection_filterx`).
	             * </div>
	             */
	            filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	            /**
	             * @ngdoc method
	             * @name angular.Module#controller
	             * @module ng
	             * @param {string|Object} name Controller name, or an object map of controllers where the
	             *    keys are the names and the values are the constructors.
	             * @param {Function} constructor Controller constructor function.
	             * @description
	             * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	             */
	            controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	            /**
	             * @ngdoc method
	             * @name angular.Module#directive
	             * @module ng
	             * @param {string|Object} name Directive name, or an object map of directives where the
	             *    keys are the names and the values are the factories.
	             * @param {Function} directiveFactory Factory function for creating new instance of
	             * directives.
	             * @description
	             * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	             */
	            directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	            /**
	             * @ngdoc method
	             * @name angular.Module#component
	             * @module ng
	             * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
	             * @param {Object} options Component definition object (a simplified
	             *    {@link ng.$compile#directive-definition-object directive definition object})
	             *
	             * @description
	             * See {@link ng.$compileProvider#component $compileProvider.component()}.
	             */
	            component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
	
	            /**
	             * @ngdoc method
	             * @name angular.Module#config
	             * @module ng
	             * @param {Function} configFn Execute this function on module load. Useful for service
	             *    configuration.
	             * @description
	             * Use this method to register work which needs to be performed on module loading.
	             * For more about how to configure services, see
	             * {@link providers#provider-recipe Provider Recipe}.
	             */
	            config: config,
	
	            /**
	             * @ngdoc method
	             * @name angular.Module#run
	             * @module ng
	             * @param {Function} initializationFn Execute this function after injector creation.
	             *    Useful for application initialization.
	             * @description
	             * Use this method to register work which should be performed when the injector is done
	             * loading all modules.
	             */
	            run: function(block) {
	              runBlocks.push(block);
	              return this;
	            }
	          };
	
	          if (configFn) {
	            config(configFn);
	          }
	
	          return moduleInstance;
	
	          /**
	           * @param {string} provider
	           * @param {string} method
	           * @param {String=} insertMethod
	           * @returns {angular.Module}
	           */
	          function invokeLater(provider, method, insertMethod, queue) {
	            if (!queue) queue = invokeQueue;
	            return function() {
	              queue[insertMethod || 'push']([provider, method, arguments]);
	              return moduleInstance;
	            };
	          }
	
	          /**
	           * @param {string} provider
	           * @param {string} method
	           * @returns {angular.Module}
	           */
	          function invokeLaterAndSetModuleName(provider, method) {
	            return function(recipeName, factoryFunction) {
	              if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	              invokeQueue.push([provider, method, arguments]);
	              return moduleInstance;
	            };
	          }
	        });
	      };
	    });
	
	  }
	
	  /* global: toDebugString: true */
	
	  function serializeObject(obj) {
	    var seen = [];
	
	    return JSON.stringify(obj, function(key, val) {
	      val = toJsonReplacer(key, val);
	      if (isObject(val)) {
	
	        if (seen.indexOf(val) >= 0) return '...';
	
	        seen.push(val);
	      }
	      return val;
	    });
	  }
	
	  function toDebugString(obj) {
	    if (typeof obj === 'function') {
	      return obj.toString().replace(/ \{[\s\S]*$/, '');
	    } else if (isUndefined(obj)) {
	      return 'undefined';
	    } else if (typeof obj !== 'string') {
	      return serializeObject(obj);
	    }
	    return obj;
	  }
	
	  /* global angularModule: true,
	   version: true,
	
	   $CompileProvider,
	
	   htmlAnchorDirective,
	   inputDirective,
	   inputDirective,
	   formDirective,
	   scriptDirective,
	   selectDirective,
	   styleDirective,
	   optionDirective,
	   ngBindDirective,
	   ngBindHtmlDirective,
	   ngBindTemplateDirective,
	   ngClassDirective,
	   ngClassEvenDirective,
	   ngClassOddDirective,
	   ngCloakDirective,
	   ngControllerDirective,
	   ngFormDirective,
	   ngHideDirective,
	   ngIfDirective,
	   ngIncludeDirective,
	   ngIncludeFillContentDirective,
	   ngInitDirective,
	   ngNonBindableDirective,
	   ngPluralizeDirective,
	   ngRepeatDirective,
	   ngShowDirective,
	   ngStyleDirective,
	   ngSwitchDirective,
	   ngSwitchWhenDirective,
	   ngSwitchDefaultDirective,
	   ngOptionsDirective,
	   ngTranscludeDirective,
	   ngModelDirective,
	   ngListDirective,
	   ngChangeDirective,
	   patternDirective,
	   patternDirective,
	   requiredDirective,
	   requiredDirective,
	   minlengthDirective,
	   minlengthDirective,
	   maxlengthDirective,
	   maxlengthDirective,
	   ngValueDirective,
	   ngModelOptionsDirective,
	   ngAttributeAliasDirectives,
	   ngEventDirectives,
	
	   $AnchorScrollProvider,
	   $AnimateProvider,
	   $CoreAnimateCssProvider,
	   $$CoreAnimateJsProvider,
	   $$CoreAnimateQueueProvider,
	   $$AnimateRunnerFactoryProvider,
	   $$AnimateAsyncRunFactoryProvider,
	   $BrowserProvider,
	   $CacheFactoryProvider,
	   $ControllerProvider,
	   $DateProvider,
	   $DocumentProvider,
	   $ExceptionHandlerProvider,
	   $FilterProvider,
	   $$ForceReflowProvider,
	   $InterpolateProvider,
	   $IntervalProvider,
	   $$HashMapProvider,
	   $HttpProvider,
	   $HttpParamSerializerProvider,
	   $HttpParamSerializerJQLikeProvider,
	   $HttpBackendProvider,
	   $xhrFactoryProvider,
	   $LocationProvider,
	   $LogProvider,
	   $ParseProvider,
	   $RootScopeProvider,
	   $QProvider,
	   $$QProvider,
	   $$SanitizeUriProvider,
	   $SceProvider,
	   $SceDelegateProvider,
	   $SnifferProvider,
	   $TemplateCacheProvider,
	   $TemplateRequestProvider,
	   $$TestabilityProvider,
	   $TimeoutProvider,
	   $$RAFProvider,
	   $WindowProvider,
	   $$jqLiteProvider,
	   $$CookieReaderProvider
	   */
	
	
	  /**
	   * @ngdoc object
	   * @name angular.version
	   * @module ng
	   * @description
	   * An object that contains information about the current AngularJS version.
	   *
	   * This object has the following properties:
	   *
	   * - `full` – `{string}` – Full version string, such as "0.9.18".
	   * - `major` – `{number}` – Major version number, such as "0".
	   * - `minor` – `{number}` – Minor version number, such as "9".
	   * - `dot` – `{number}` – Dot version number, such as "18".
	   * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	   */
	  var version = {
	    full: '1.5.6',    // all of these placeholder strings will be replaced by grunt's
	    major: 1,    // package task
	    minor: 5,
	    dot: 6,
	    codeName: 'arrow-stringification'
	  };
	
	
	  function publishExternalAPI(angular) {
	    extend(angular, {
	      'bootstrap': bootstrap,
	      'copy': copy,
	      'extend': extend,
	      'merge': merge,
	      'equals': equals,
	      'element': jqLite,
	      'forEach': forEach,
	      'injector': createInjector,
	      'noop': noop,
	      'bind': bind,
	      'toJson': toJson,
	      'fromJson': fromJson,
	      'identity': identity,
	      'isUndefined': isUndefined,
	      'isDefined': isDefined,
	      'isString': isString,
	      'isFunction': isFunction,
	      'isObject': isObject,
	      'isNumber': isNumber,
	      'isElement': isElement,
	      'isArray': isArray,
	      'version': version,
	      'isDate': isDate,
	      'lowercase': lowercase,
	      'uppercase': uppercase,
	      'callbacks': {counter: 0},
	      'getTestability': getTestability,
	      '$$minErr': minErr,
	      '$$csp': csp,
	      'reloadWithDebugInfo': reloadWithDebugInfo
	    });
	
	    angularModule = setupModuleLoader(window);
	
	    angularModule('ng', ['ngLocale'], ['$provide',
	      function ngModule($provide) {
	        // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	        $provide.provider({
	          $$sanitizeUri: $$SanitizeUriProvider
	        });
	        $provide.provider('$compile', $CompileProvider).
	        directive({
	          a: htmlAnchorDirective,
	          input: inputDirective,
	          textarea: inputDirective,
	          form: formDirective,
	          script: scriptDirective,
	          select: selectDirective,
	          style: styleDirective,
	          option: optionDirective,
	          ngBind: ngBindDirective,
	          ngBindHtml: ngBindHtmlDirective,
	          ngBindTemplate: ngBindTemplateDirective,
	          ngClass: ngClassDirective,
	          ngClassEven: ngClassEvenDirective,
	          ngClassOdd: ngClassOddDirective,
	          ngCloak: ngCloakDirective,
	          ngController: ngControllerDirective,
	          ngForm: ngFormDirective,
	          ngHide: ngHideDirective,
	          ngIf: ngIfDirective,
	          ngInclude: ngIncludeDirective,
	          ngInit: ngInitDirective,
	          ngNonBindable: ngNonBindableDirective,
	          ngPluralize: ngPluralizeDirective,
	          ngRepeat: ngRepeatDirective,
	          ngShow: ngShowDirective,
	          ngStyle: ngStyleDirective,
	          ngSwitch: ngSwitchDirective,
	          ngSwitchWhen: ngSwitchWhenDirective,
	          ngSwitchDefault: ngSwitchDefaultDirective,
	          ngOptions: ngOptionsDirective,
	          ngTransclude: ngTranscludeDirective,
	          ngModel: ngModelDirective,
	          ngList: ngListDirective,
	          ngChange: ngChangeDirective,
	          pattern: patternDirective,
	          ngPattern: patternDirective,
	          required: requiredDirective,
	          ngRequired: requiredDirective,
	          minlength: minlengthDirective,
	          ngMinlength: minlengthDirective,
	          maxlength: maxlengthDirective,
	          ngMaxlength: maxlengthDirective,
	          ngValue: ngValueDirective,
	          ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	        $provide.provider({
	          $anchorScroll: $AnchorScrollProvider,
	          $animate: $AnimateProvider,
	          $animateCss: $CoreAnimateCssProvider,
	          $$animateJs: $$CoreAnimateJsProvider,
	          $$animateQueue: $$CoreAnimateQueueProvider,
	          $$AnimateRunner: $$AnimateRunnerFactoryProvider,
	          $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
	          $browser: $BrowserProvider,
	          $cacheFactory: $CacheFactoryProvider,
	          $controller: $ControllerProvider,
	          $document: $DocumentProvider,
	          $exceptionHandler: $ExceptionHandlerProvider,
	          $filter: $FilterProvider,
	          $$forceReflow: $$ForceReflowProvider,
	          $interpolate: $InterpolateProvider,
	          $interval: $IntervalProvider,
	          $http: $HttpProvider,
	          $httpParamSerializer: $HttpParamSerializerProvider,
	          $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	          $httpBackend: $HttpBackendProvider,
	          $xhrFactory: $xhrFactoryProvider,
	          $location: $LocationProvider,
	          $log: $LogProvider,
	          $parse: $ParseProvider,
	          $rootScope: $RootScopeProvider,
	          $q: $QProvider,
	          $$q: $$QProvider,
	          $sce: $SceProvider,
	          $sceDelegate: $SceDelegateProvider,
	          $sniffer: $SnifferProvider,
	          $templateCache: $TemplateCacheProvider,
	          $templateRequest: $TemplateRequestProvider,
	          $$testability: $$TestabilityProvider,
	          $timeout: $TimeoutProvider,
	          $window: $WindowProvider,
	          $$rAF: $$RAFProvider,
	          $$jqLite: $$jqLiteProvider,
	          $$HashMap: $$HashMapProvider,
	          $$cookieReader: $$CookieReaderProvider
	        });
	      }
	    ]);
	  }
	
	  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	   *     Any commits to this file should be reviewed with security in mind.  *
	   *   Changes to this file can potentially create security vulnerabilities. *
	   *          An approval from 2 Core members with history of modifying      *
	   *                         this file is required.                          *
	   *                                                                         *
	   *  Does the change somehow allow for arbitrary javascript to be executed? *
	   *    Or allows for someone to change the prototype of built-in objects?   *
	   *     Or gives undesired access to variables likes document or window?    *
	   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	  /* global JQLitePrototype: true,
	   addEventListenerFn: true,
	   removeEventListenerFn: true,
	   BOOLEAN_ATTR: true,
	   ALIASED_ATTR: true,
	   */
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	  /**
	   * @ngdoc function
	   * @name angular.element
	   * @module ng
	   * @kind function
	   *
	   * @description
	   * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	   *
	   * If jQuery is available, `angular.element` is an alias for the
	   * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	   * delegates to Angular's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	   *
	   * jqLite is a tiny, API-compatible subset of jQuery that allows
	   * Angular to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	   * commonly needed functionality with the goal of having a very small footprint.
	   *
	   * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	   * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	   * specific version of jQuery if multiple versions exist on the page.
	   *
	   * <div class="alert alert-info">**Note:** All element references in Angular are always wrapped with jQuery or
	   * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	   *
	   * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	   * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	   * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	   *
	   * ## Angular's jqLite
	   * jqLite provides only the following jQuery methods:
	   *
	   * - [`addClass()`](http://api.jquery.com/addClass/)
	   * - [`after()`](http://api.jquery.com/after/)
	   * - [`append()`](http://api.jquery.com/append/)
	   * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	   * - [`bind()`](http://api.jquery.com/bind/) - Does not support namespaces, selectors or eventData
	   * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	   * - [`clone()`](http://api.jquery.com/clone/)
	   * - [`contents()`](http://api.jquery.com/contents/)
	   * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	   *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	   * - [`data()`](http://api.jquery.com/data/)
	   * - [`detach()`](http://api.jquery.com/detach/)
	   * - [`empty()`](http://api.jquery.com/empty/)
	   * - [`eq()`](http://api.jquery.com/eq/)
	   * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	   * - [`hasClass()`](http://api.jquery.com/hasClass/)
	   * - [`html()`](http://api.jquery.com/html/)
	   * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	   * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	   * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	   * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	   * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	   * - [`prepend()`](http://api.jquery.com/prepend/)
	   * - [`prop()`](http://api.jquery.com/prop/)
	   * - [`ready()`](http://api.jquery.com/ready/)
	   * - [`remove()`](http://api.jquery.com/remove/)
	   * - [`removeAttr()`](http://api.jquery.com/removeAttr/)
	   * - [`removeClass()`](http://api.jquery.com/removeClass/)
	   * - [`removeData()`](http://api.jquery.com/removeData/)
	   * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	   * - [`text()`](http://api.jquery.com/text/)
	   * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	   * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	   * - [`unbind()`](http://api.jquery.com/unbind/) - Does not support namespaces or event object as parameter
	   * - [`val()`](http://api.jquery.com/val/)
	   * - [`wrap()`](http://api.jquery.com/wrap/)
	   *
	   * ## jQuery/jqLite Extras
	   * Angular also provides the following additional methods and events to both jQuery and jqLite:
	   *
	   * ### Events
	   * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	   *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	   *    element before it is removed.
	   *
	   * ### Methods
	   * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	   *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	   *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	   *   `'ngModel'`).
	   * - `injector()` - retrieves the injector of the current element or its parent.
	   * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	   *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	   *   be enabled.
	   * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	   *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	   *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	   *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	   * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	   *   parent element is reached.
	   *
	   * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	   * https://github.com/angular/angular.js/issues/14251 for more information.
	   *
	   * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	   * @returns {Object} jQuery object.
	   */
	
	  JQLite.expando = 'ng339';
	
	  var jqCache = JQLite.cache = {},
	    jqId = 1,
	    addEventListenerFn = function(element, type, fn) {
	      element.addEventListener(type, fn, false);
	    },
	    removeEventListenerFn = function(element, type, fn) {
	      element.removeEventListener(type, fn, false);
	    };
	
	  /*
	   * !!! This is an undocumented "private" function !!!
	   */
	  JQLite._data = function(node) {
	    //jQuery always returns an object on cache miss
	    return this.cache[node[this.expando]] || {};
	  };
	
	  function jqNextId() { return ++jqId; }
	
	
	  var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	  var MOZ_HACK_REGEXP = /^moz([A-Z])/;
	  var MOUSE_EVENT_MAP= { mouseleave: "mouseout", mouseenter: "mouseover"};
	  var jqLiteMinErr = minErr('jqLite');
	
	  /**
	   * Converts snake_case to camelCase.
	   * Also there is special case for Moz prefix starting with upper case letter.
	   * @param name Name to normalize
	   */
	  function camelCase(name) {
	    return name.
	    replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    }).
	    replace(MOZ_HACK_REGEXP, 'Moz$1');
	  }
	
	  var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	  var HTML_REGEXP = /<|&#?\w+;/;
	  var TAG_NAME_REGEXP = /<([\w:-]+)/;
	  var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
	
	  var wrapMap = {
	    'option': [1, '<select multiple="multiple">', '</select>'],
	
	    'thead': [1, '<table>', '</table>'],
	    'col': [2, '<table><colgroup>', '</colgroup></table>'],
	    'tr': [2, '<table><tbody>', '</tbody></table>'],
	    'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
	    '_default': [0, "", ""]
	  };
	
	  wrapMap.optgroup = wrapMap.option;
	  wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	  wrapMap.th = wrapMap.td;
	
	
	  function jqLiteIsTextNode(html) {
	    return !HTML_REGEXP.test(html);
	  }
	
	  function jqLiteAcceptsData(node) {
	    // The window object can accept data but has no nodeType
	    // Otherwise we are only interested in elements (1) and documents (9)
	    var nodeType = node.nodeType;
	    return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	  }
	
	  function jqLiteHasData(node) {
	    for (var key in jqCache[node.ng339]) {
	      return true;
	    }
	    return false;
	  }
	
	  function jqLiteCleanData(nodes) {
	    for (var i = 0, ii = nodes.length; i < ii; i++) {
	      jqLiteRemoveData(nodes[i]);
	    }
	  }
	
	  function jqLiteBuildFragment(html, context) {
	    var tmp, tag, wrap,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	    if (jqLiteIsTextNode(html)) {
	      // Convert non-html into a text node
	      nodes.push(context.createTextNode(html));
	    } else {
	      // Convert html into DOM nodes
	      tmp = tmp || fragment.appendChild(context.createElement("div"));
	      tag = (TAG_NAME_REGEXP.exec(html) || ["", ""])[1].toLowerCase();
	      wrap = wrapMap[tag] || wrapMap._default;
	      tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, "<$1></$2>") + wrap[2];
	
	      // Descend through wrappers to the right content
	      i = wrap[0];
	      while (i--) {
	        tmp = tmp.lastChild;
	      }
	
	      nodes = concat(nodes, tmp.childNodes);
	
	      tmp = fragment.firstChild;
	      tmp.textContent = "";
	    }
	
	    // Remove wrapper from fragment
	    fragment.textContent = "";
	    fragment.innerHTML = ""; // Clear inner HTML
	    forEach(nodes, function(node) {
	      fragment.appendChild(node);
	    });
	
	    return fragment;
	  }
	
	  function jqLiteParseHTML(html, context) {
	    context = context || window.document;
	    var parsed;
	
	    if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	      return [context.createElement(parsed[1])];
	    }
	
	    if ((parsed = jqLiteBuildFragment(html, context))) {
	      return parsed.childNodes;
	    }
	
	    return [];
	  }
	
	  function jqLiteWrapNode(node, wrapper) {
	    var parent = node.parentNode;
	
	    if (parent) {
	      parent.replaceChild(wrapper, node);
	    }
	
	    wrapper.appendChild(node);
	  }
	
	
	// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	  var jqLiteContains = window.Node.prototype.contains || function(arg) {
	      // jshint bitwise: false
	      return !!(this.compareDocumentPosition(arg) & 16);
	      // jshint bitwise: true
	    };
	
	/////////////////////////////////////////////
	  function JQLite(element) {
	    if (element instanceof JQLite) {
	      return element;
	    }
	
	    var argIsString;
	
	    if (isString(element)) {
	      element = trim(element);
	      argIsString = true;
	    }
	    if (!(this instanceof JQLite)) {
	      if (argIsString && element.charAt(0) != '<') {
	        throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	      }
	      return new JQLite(element);
	    }
	
	    if (argIsString) {
	      jqLiteAddNodes(this, jqLiteParseHTML(element));
	    } else {
	      jqLiteAddNodes(this, element);
	    }
	  }
	
	  function jqLiteClone(element) {
	    return element.cloneNode(true);
	  }
	
	  function jqLiteDealoc(element, onlyDescendants) {
	    if (!onlyDescendants) jqLiteRemoveData(element);
	
	    if (element.querySelectorAll) {
	      var descendants = element.querySelectorAll('*');
	      for (var i = 0, l = descendants.length; i < l; i++) {
	        jqLiteRemoveData(descendants[i]);
	      }
	    }
	  }
	
	  function jqLiteOff(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var handle = expandoStore && expandoStore.handle;
	
	    if (!handle) return; //no listeners registered
	
	    if (!type) {
	      for (type in events) {
	        if (type !== '$destroy') {
	          removeEventListenerFn(element, type, handle);
	        }
	        delete events[type];
	      }
	    } else {
	
	      var removeHandler = function(type) {
	        var listenerFns = events[type];
	        if (isDefined(fn)) {
	          arrayRemove(listenerFns || [], fn);
	        }
	        if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
	          removeEventListenerFn(element, type, handle);
	          delete events[type];
	        }
	      };
	
	      forEach(type.split(' '), function(type) {
	        removeHandler(type);
	        if (MOUSE_EVENT_MAP[type]) {
	          removeHandler(MOUSE_EVENT_MAP[type]);
	        }
	      });
	    }
	  }
	
	  function jqLiteRemoveData(element, name) {
	    var expandoId = element.ng339;
	    var expandoStore = expandoId && jqCache[expandoId];
	
	    if (expandoStore) {
	      if (name) {
	        delete expandoStore.data[name];
	        return;
	      }
	
	      if (expandoStore.handle) {
	        if (expandoStore.events.$destroy) {
	          expandoStore.handle({}, '$destroy');
	        }
	        jqLiteOff(element);
	      }
	      delete jqCache[expandoId];
	      element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	    }
	  }
	
	
	  function jqLiteExpandoStore(element, createIfNecessary) {
	    var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	    if (createIfNecessary && !expandoStore) {
	      element.ng339 = expandoId = jqNextId();
	      expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	    }
	
	    return expandoStore;
	  }
	
	
	  function jqLiteData(element, key, value) {
	    if (jqLiteAcceptsData(element)) {
	
	      var isSimpleSetter = isDefined(value);
	      var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	      var massGetter = !key;
	      var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	      var data = expandoStore && expandoStore.data;
	
	      if (isSimpleSetter) { // data('key', value)
	        data[key] = value;
	      } else {
	        if (massGetter) {  // data()
	          return data;
	        } else {
	          if (isSimpleGetter) { // data('key')
	            // don't force creation of expandoStore if it doesn't exist yet
	            return data && data[key];
	          } else { // mass-setter: data({key1: val1, key2: val2})
	            extend(data, key);
	          }
	        }
	      }
	    }
	  }
	
	  function jqLiteHasClass(element, selector) {
	    if (!element.getAttribute) return false;
	    return ((" " + (element.getAttribute('class') || '') + " ").replace(/[\n\t]/g, " ").
	    indexOf(" " + selector + " ") > -1);
	  }
	
	  function jqLiteRemoveClass(element, cssClasses) {
	    if (cssClasses && element.setAttribute) {
	      forEach(cssClasses.split(' '), function(cssClass) {
	        element.setAttribute('class', trim(
	          (" " + (element.getAttribute('class') || '') + " ")
	            .replace(/[\n\t]/g, " ")
	            .replace(" " + trim(cssClass) + " ", " "))
	        );
	      });
	    }
	  }
	
	  function jqLiteAddClass(element, cssClasses) {
	    if (cssClasses && element.setAttribute) {
	      var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	        .replace(/[\n\t]/g, " ");
	
	      forEach(cssClasses.split(' '), function(cssClass) {
	        cssClass = trim(cssClass);
	        if (existingClasses.indexOf(' ' + cssClass + ' ') === -1) {
	          existingClasses += cssClass + ' ';
	        }
	      });
	
	      element.setAttribute('class', trim(existingClasses));
	    }
	  }
	
	
	  function jqLiteAddNodes(root, elements) {
	    // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	    if (elements) {
	
	      // if a Node (the most common case)
	      if (elements.nodeType) {
	        root[root.length++] = elements;
	      } else {
	        var length = elements.length;
	
	        // if an Array or NodeList and not a Window
	        if (typeof length === 'number' && elements.window !== elements) {
	          if (length) {
	            for (var i = 0; i < length; i++) {
	              root[root.length++] = elements[i];
	            }
	          }
	        } else {
	          root[root.length++] = elements;
	        }
	      }
	    }
	  }
	
	
	  function jqLiteController(element, name) {
	    return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	  }
	
	  function jqLiteInheritedData(element, name, value) {
	    // if element is the document object work with the html element instead
	    // this makes $(document).scope() possible
	    if (element.nodeType == NODE_TYPE_DOCUMENT) {
	      element = element.documentElement;
	    }
	    var names = isArray(name) ? name : [name];
	
	    while (element) {
	      for (var i = 0, ii = names.length; i < ii; i++) {
	        if (isDefined(value = jqLite.data(element, names[i]))) return value;
	      }
	
	      // If dealing with a document fragment node with a host element, and no parent, use the host
	      // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	      // to lookup parent controllers.
	      element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	    }
	  }
	
	  function jqLiteEmpty(element) {
	    jqLiteDealoc(element, true);
	    while (element.firstChild) {
	      element.removeChild(element.firstChild);
	    }
	  }
	
	  function jqLiteRemove(element, keepData) {
	    if (!keepData) jqLiteDealoc(element);
	    var parent = element.parentNode;
	    if (parent) parent.removeChild(element);
	  }
	
	
	  function jqLiteDocumentLoaded(action, win) {
	    win = win || window;
	    if (win.document.readyState === 'complete') {
	      // Force the action to be run async for consistent behavior
	      // from the action's point of view
	      // i.e. it will definitely not be in a $apply
	      win.setTimeout(action);
	    } else {
	      // No need to unbind this handler as load is only ever called once
	      jqLite(win).on('load', action);
	    }
	  }
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	  var JQLitePrototype = JQLite.prototype = {
	    ready: function(fn) {
	      var fired = false;
	
	      function trigger() {
	        if (fired) return;
	        fired = true;
	        fn();
	      }
	
	      // check if document is already loaded
	      if (window.document.readyState === 'complete') {
	        window.setTimeout(trigger);
	      } else {
	        this.on('DOMContentLoaded', trigger); // works for modern browsers and IE9
	        // we can not use jqLite since we are not done loading and jQuery could be loaded later.
	        // jshint -W064
	        JQLite(window).on('load', trigger); // fallback to window.onload for others
	        // jshint +W064
	      }
	    },
	    toString: function() {
	      var value = [];
	      forEach(this, function(e) { value.push('' + e);});
	      return '[' + value.join(', ') + ']';
	    },
	
	    eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	    },
	
	    length: 0,
	    push: push,
	    sort: [].sort,
	    splice: [].splice
	  };
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	  var BOOLEAN_ATTR = {};
	  forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	    BOOLEAN_ATTR[lowercase(value)] = value;
	  });
	  var BOOLEAN_ELEMENTS = {};
	  forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	    BOOLEAN_ELEMENTS[value] = true;
	  });
	  var ALIASED_ATTR = {
	    'ngMinlength': 'minlength',
	    'ngMaxlength': 'maxlength',
	    'ngMin': 'min',
	    'ngMax': 'max',
	    'ngPattern': 'pattern'
	  };
	
	  function getBooleanAttrName(element, name) {
	    // check dom last since we will most likely fail on name
	    var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	    // booleanAttr is here twice to minimize DOM access
	    return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	  }
	
	  function getAliasedAttrName(name) {
	    return ALIASED_ATTR[name];
	  }
	
	  forEach({
	    data: jqLiteData,
	    removeData: jqLiteRemoveData,
	    hasData: jqLiteHasData,
	    cleanData: jqLiteCleanData
	  }, function(fn, name) {
	    JQLite[name] = fn;
	  });
	
	  forEach({
	    data: jqLiteData,
	    inheritedData: jqLiteInheritedData,
	
	    scope: function(element) {
	      // Can't use jqLiteData here directly so we stay compatible with jQuery!
	      return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	    },
	
	    isolateScope: function(element) {
	      // Can't use jqLiteData here directly so we stay compatible with jQuery!
	      return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	    },
	
	    controller: jqLiteController,
	
	    injector: function(element) {
	      return jqLiteInheritedData(element, '$injector');
	    },
	
	    removeAttr: function(element, name) {
	      element.removeAttribute(name);
	    },
	
	    hasClass: jqLiteHasClass,
	
	    css: function(element, name, value) {
	      name = camelCase(name);
	
	      if (isDefined(value)) {
	        element.style[name] = value;
	      } else {
	        return element.style[name];
	      }
	    },
	
	    attr: function(element, name, value) {
	      var nodeType = element.nodeType;
	      if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT) {
	        return;
	      }
	      var lowercasedName = lowercase(name);
	      if (BOOLEAN_ATTR[lowercasedName]) {
	        if (isDefined(value)) {
	          if (!!value) {
	            element[name] = true;
	            element.setAttribute(name, lowercasedName);
	          } else {
	            element[name] = false;
	            element.removeAttribute(lowercasedName);
	          }
	        } else {
	          return (element[name] ||
	          (element.attributes.getNamedItem(name) || noop).specified)
	            ? lowercasedName
	            : undefined;
	        }
	      } else if (isDefined(value)) {
	        element.setAttribute(name, value);
	      } else if (element.getAttribute) {
	        // the extra argument "2" is to get the right thing for a.href in IE, see jQuery code
	        // some elements (e.g. Document) don't have get attribute, so return undefined
	        var ret = element.getAttribute(name, 2);
	        // normalize non-existing attributes to undefined (as jQuery)
	        return ret === null ? undefined : ret;
	      }
	    },
	
	    prop: function(element, name, value) {
	      if (isDefined(value)) {
	        element[name] = value;
	      } else {
	        return element[name];
	      }
	    },
	
	    text: (function() {
	      getText.$dv = '';
	      return getText;
	
	      function getText(element, value) {
	        if (isUndefined(value)) {
	          var nodeType = element.nodeType;
	          return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	        }
	        element.textContent = value;
	      }
	    })(),
	
	    val: function(element, value) {
	      if (isUndefined(value)) {
	        if (element.multiple && nodeName_(element) === 'select') {
	          var result = [];
	          forEach(element.options, function(option) {
	            if (option.selected) {
	              result.push(option.value || option.text);
	            }
	          });
	          return result.length === 0 ? null : result;
	        }
	        return element.value;
	      }
	      element.value = value;
	    },
	
	    html: function(element, value) {
	      if (isUndefined(value)) {
	        return element.innerHTML;
	      }
	      jqLiteDealoc(element, true);
	      element.innerHTML = value;
	    },
	
	    empty: jqLiteEmpty
	  }, function(fn, name) {
	    /**
	     * Properties: writes return selection, reads return first value
	     */
	    JQLite.prototype[name] = function(arg1, arg2) {
	      var i, key;
	      var nodeCount = this.length;
	
	      // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	      // in a way that survives minification.
	      // jqLiteEmpty takes no arguments but is a setter.
	      if (fn !== jqLiteEmpty &&
	        (isUndefined((fn.length == 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
	        if (isObject(arg1)) {
	
	          // we are a write, but the object properties are the key/values
	          for (i = 0; i < nodeCount; i++) {
	            if (fn === jqLiteData) {
	              // data() takes the whole object in jQuery
	              fn(this[i], arg1);
	            } else {
	              for (key in arg1) {
	                fn(this[i], key, arg1[key]);
	              }
	            }
	          }
	          // return self for chaining
	          return this;
	        } else {
	          // we are a read, so read the first child.
	          // TODO: do we still need this?
	          var value = fn.$dv;
	          // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	          var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
	          for (var j = 0; j < jj; j++) {
	            var nodeValue = fn(this[j], arg1, arg2);
	            value = value ? value + nodeValue : nodeValue;
	          }
	          return value;
	        }
	      } else {
	        // we are a write, so apply to all children
	        for (i = 0; i < nodeCount; i++) {
	          fn(this[i], arg1, arg2);
	        }
	        // return self for chaining
	        return this;
	      }
	    };
	  });
	
	  function createEventHandler(element, events) {
	    var eventHandler = function(event, type) {
	      // jQuery specific api
	      event.isDefaultPrevented = function() {
	        return event.defaultPrevented;
	      };
	
	      var eventFns = events[type || event.type];
	      var eventFnsLength = eventFns ? eventFns.length : 0;
	
	      if (!eventFnsLength) return;
	
	      if (isUndefined(event.immediatePropagationStopped)) {
	        var originalStopImmediatePropagation = event.stopImmediatePropagation;
	        event.stopImmediatePropagation = function() {
	          event.immediatePropagationStopped = true;
	
	          if (event.stopPropagation) {
	            event.stopPropagation();
	          }
	
	          if (originalStopImmediatePropagation) {
	            originalStopImmediatePropagation.call(event);
	          }
	        };
	      }
	
	      event.isImmediatePropagationStopped = function() {
	        return event.immediatePropagationStopped === true;
	      };
	
	      // Some events have special handlers that wrap the real handler
	      var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      if ((eventFnsLength > 1)) {
	        eventFns = shallowCopy(eventFns);
	      }
	
	      for (var i = 0; i < eventFnsLength; i++) {
	        if (!event.isImmediatePropagationStopped()) {
	          handlerWrapper(element, event, eventFns[i]);
	        }
	      }
	    };
	
	    // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	    //       events on `element`
	    eventHandler.elem = element;
	    return eventHandler;
	  }
	
	  function defaultHandlerWrapper(element, event, handler) {
	    handler.call(element, event);
	  }
	
	  function specialMouseHandlerWrapper(target, event, handler) {
	    // Refer to jQuery's implementation of mouseenter & mouseleave
	    // Read about mouseenter and mouseleave:
	    // http://www.quirksmode.org/js/events_mouse.html#link8
	    var related = event.relatedTarget;
	    // For mousenter/leave call the handler if related is outside the target.
	    // NB: No relatedTarget if the mouse left/entered the browser window
	    if (!related || (related !== target && !jqLiteContains.call(target, related))) {
	      handler.call(target, event);
	    }
	  }
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	  forEach({
	    removeData: jqLiteRemoveData,
	
	    on: function jqLiteOn(element, type, fn, unsupported) {
	      if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	      // Do not add event handlers to non-elements because they will not be cleaned up.
	      if (!jqLiteAcceptsData(element)) {
	        return;
	      }
	
	      var expandoStore = jqLiteExpandoStore(element, true);
	      var events = expandoStore.events;
	      var handle = expandoStore.handle;
	
	      if (!handle) {
	        handle = expandoStore.handle = createEventHandler(element, events);
	      }
	
	      // http://jsperf.com/string-indexof-vs-split
	      var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	      var i = types.length;
	
	      var addHandler = function(type, specialHandlerWrapper, noEventListener) {
	        var eventFns = events[type];
	
	        if (!eventFns) {
	          eventFns = events[type] = [];
	          eventFns.specialHandlerWrapper = specialHandlerWrapper;
	          if (type !== '$destroy' && !noEventListener) {
	            addEventListenerFn(element, type, handle);
	          }
	        }
	
	        eventFns.push(fn);
	      };
	
	      while (i--) {
	        type = types[i];
	        if (MOUSE_EVENT_MAP[type]) {
	          addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
	          addHandler(type, undefined, true);
	        } else {
	          addHandler(type);
	        }
	      }
	    },
	
	    off: jqLiteOff,
	
	    one: function(element, type, fn) {
	      element = jqLite(element);
	
	      //add the listener twice so that when it is called
	      //you can remove the original function and still be
	      //able to call element.off(ev, fn) normally
	      element.on(type, function onFn() {
	        element.off(type, fn);
	        element.off(type, onFn);
	      });
	      element.on(type, fn);
	    },
	
	    replaceWith: function(element, replaceNode) {
	      var index, parent = element.parentNode;
	      jqLiteDealoc(element);
	      forEach(new JQLite(replaceNode), function(node) {
	        if (index) {
	          parent.insertBefore(node, index.nextSibling);
	        } else {
	          parent.replaceChild(node, element);
	        }
	        index = node;
	      });
	    },
	
	    children: function(element) {
	      var children = [];
	      forEach(element.childNodes, function(element) {
	        if (element.nodeType === NODE_TYPE_ELEMENT) {
	          children.push(element);
	        }
	      });
	      return children;
	    },
	
	    contents: function(element) {
	      return element.contentDocument || element.childNodes || [];
	    },
	
	    append: function(element, node) {
	      var nodeType = element.nodeType;
	      if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	      node = new JQLite(node);
	
	      for (var i = 0, ii = node.length; i < ii; i++) {
	        var child = node[i];
	        element.appendChild(child);
	      }
	    },
	
	    prepend: function(element, node) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        var index = element.firstChild;
	        forEach(new JQLite(node), function(child) {
	          element.insertBefore(child, index);
	        });
	      }
	    },
	
	    wrap: function(element, wrapNode) {
	      jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
	    },
	
	    remove: jqLiteRemove,
	
	    detach: function(element) {
	      jqLiteRemove(element, true);
	    },
	
	    after: function(element, newElement) {
	      var index = element, parent = element.parentNode;
	      newElement = new JQLite(newElement);
	
	      for (var i = 0, ii = newElement.length; i < ii; i++) {
	        var node = newElement[i];
	        parent.insertBefore(node, index.nextSibling);
	        index = node;
	      }
	    },
	
	    addClass: jqLiteAddClass,
	    removeClass: jqLiteRemoveClass,
	
	    toggleClass: function(element, selector, condition) {
	      if (selector) {
	        forEach(selector.split(' '), function(className) {
	          var classCondition = condition;
	          if (isUndefined(classCondition)) {
	            classCondition = !jqLiteHasClass(element, className);
	          }
	          (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	        });
	      }
	    },
	
	    parent: function(element) {
	      var parent = element.parentNode;
	      return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	    },
	
	    next: function(element) {
	      return element.nextElementSibling;
	    },
	
	    find: function(element, selector) {
	      if (element.getElementsByTagName) {
	        return element.getElementsByTagName(selector);
	      } else {
	        return [];
	      }
	    },
	
	    clone: jqLiteClone,
	
	    triggerHandler: function(element, event, extraParameters) {
	
	      var dummyEvent, eventFnsCopy, handlerArgs;
	      var eventName = event.type || event;
	      var expandoStore = jqLiteExpandoStore(element);
	      var events = expandoStore && expandoStore.events;
	      var eventFns = events && events[eventName];
	
	      if (eventFns) {
	        // Create a dummy event to pass to the handlers
	        dummyEvent = {
	          preventDefault: function() { this.defaultPrevented = true; },
	          isDefaultPrevented: function() { return this.defaultPrevented === true; },
	          stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	          isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	          stopPropagation: noop,
	          type: eventName,
	          target: element
	        };
	
	        // If a custom event was provided then extend our dummy event with it
	        if (event.type) {
	          dummyEvent = extend(dummyEvent, event);
	        }
	
	        // Copy event handlers in case event handlers array is modified during execution.
	        eventFnsCopy = shallowCopy(eventFns);
	        handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	        forEach(eventFnsCopy, function(fn) {
	          if (!dummyEvent.isImmediatePropagationStopped()) {
	            fn.apply(element, handlerArgs);
	          }
	        });
	      }
	    }
	  }, function(fn, name) {
	    /**
	     * chaining functions
	     */
	    JQLite.prototype[name] = function(arg1, arg2, arg3) {
	      var value;
	
	      for (var i = 0, ii = this.length; i < ii; i++) {
	        if (isUndefined(value)) {
	          value = fn(this[i], arg1, arg2, arg3);
	          if (isDefined(value)) {
	            // any function which returns a value needs to be wrapped
	            value = jqLite(value);
	          }
	        } else {
	          jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	        }
	      }
	      return isDefined(value) ? value : this;
	    };
	
	    // bind legacy bind/unbind to on/off
	    JQLite.prototype.bind = JQLite.prototype.on;
	    JQLite.prototype.unbind = JQLite.prototype.off;
	  });
	
	
	// Provider for private $$jqLite service
	  function $$jqLiteProvider() {
	    this.$get = function $$jqLite() {
	      return extend(JQLite, {
	        hasClass: function(node, classes) {
	          if (node.attr) node = node[0];
	          return jqLiteHasClass(node, classes);
	        },
	        addClass: function(node, classes) {
	          if (node.attr) node = node[0];
	          return jqLiteAddClass(node, classes);
	        },
	        removeClass: function(node, classes) {
	          if (node.attr) node = node[0];
	          return jqLiteRemoveClass(node, classes);
	        }
	      });
	    };
	  }
	
	  /**
	   * Computes a hash of an 'obj'.
	   * Hash of a:
	   *  string is string
	   *  number is number as string
	   *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	   *         that is also assigned to the $$hashKey property of the object.
	   *
	   * @param obj
	   * @returns {string} hash string such that the same input will have the same hash string.
	   *         The resulting string key is in 'type:hashKey' format.
	   */
	  function hashKey(obj, nextUidFn) {
	    var key = obj && obj.$$hashKey;
	
	    if (key) {
	      if (typeof key === 'function') {
	        key = obj.$$hashKey();
	      }
	      return key;
	    }
	
	    var objType = typeof obj;
	    if (objType == 'function' || (objType == 'object' && obj !== null)) {
	      key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	    } else {
	      key = objType + ':' + obj;
	    }
	
	    return key;
	  }
	
	  /**
	   * HashMap which can use objects as keys
	   */
	  function HashMap(array, isolatedUid) {
	    if (isolatedUid) {
	      var uid = 0;
	      this.nextUid = function() {
	        return ++uid;
	      };
	    }
	    forEach(array, this.put, this);
	  }
	  HashMap.prototype = {
	    /**
	     * Store key value pair
	     * @param key key to store can be any type
	     * @param value value to store can be any type
	     */
	    put: function(key, value) {
	      this[hashKey(key, this.nextUid)] = value;
	    },
	
	    /**
	     * @param key
	     * @returns {Object} the value for the key
	     */
	    get: function(key) {
	      return this[hashKey(key, this.nextUid)];
	    },
	
	    /**
	     * Remove the key/value pair
	     * @param key
	     */
	    remove: function(key) {
	      var value = this[key = hashKey(key, this.nextUid)];
	      delete this[key];
	      return value;
	    }
	  };
	
	  var $$HashMapProvider = [function() {
	    this.$get = [function() {
	      return HashMap;
	    }];
	  }];
	
	  /**
	   * @ngdoc function
	   * @module ng
	   * @name angular.injector
	   * @kind function
	   *
	   * @description
	   * Creates an injector object that can be used for retrieving services as well as for
	   * dependency injection (see {@link guide/di dependency injection}).
	   *
	   * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	   *     {@link angular.module}. The `ng` module must be explicitly added.
	   * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	   *     disallows argument name annotation inference.
	   * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	   *
	   * @example
	   * Typical usage
	   * ```js
	   *   // create an injector
	   *   var $injector = angular.injector(['ng']);
	   *
	   *   // use the injector to kick off your application
	   *   // use the type inference to auto inject arguments, or use implicit injection
	   *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	   * ```
	   *
	   * Sometimes you want to get access to the injector of a currently running Angular app
	   * from outside Angular. Perhaps, you want to inject and compile some markup after the
	   * application has been bootstrapped. You can do this using the extra `injector()` added
	   * to JQuery/jqLite elements. See {@link angular.element}.
	   *
	   * *This is fairly rare but could be the case if a third party library is injecting the
	   * markup.*
	   *
	   * In the following example a new block of HTML containing a `ng-controller`
	   * directive is added to the end of the document body by JQuery. We then compile and link
	   * it into the current AngularJS scope.
	   *
	   * ```js
	   * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	   * $(document.body).append($div);
	   *
	   * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	   * ```
	   */
	
	
	  /**
	   * @ngdoc module
	   * @name auto
	   * @installation
	   * @description
	   *
	   * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	   */
	
	  var ARROW_ARG = /^([^\(]+?)=>/;
	  var FN_ARGS = /^[^\(]*\(\s*([^\)]*)\)/m;
	  var FN_ARG_SPLIT = /,/;
	  var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	  var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	  var $injectorMinErr = minErr('$injector');
	
	  function stringifyFn(fn) {
	    // Support: Chrome 50-51 only
	    // Creating a new string by adding `' '` at the end, to hack around some bug in Chrome v50/51
	    // (See https://github.com/angular/angular.js/issues/14487.)
	    // TODO (gkalpak): Remove workaround when Chrome v52 is released
	    return Function.prototype.toString.call(fn) + ' ';
	  }
	
	  function extractArgs(fn) {
	    var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
	      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
	    return args;
	  }
	
	  function anonFn(fn) {
	    // For anonymous functions, showing at the very least the function signature can help in
	    // debugging.
	    var args = extractArgs(fn);
	    if (args) {
	      return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	    }
	    return 'fn';
	  }
	
	  function annotate(fn, strictDi, name) {
	    var $inject,
	      argDecl,
	      last;
	
	    if (typeof fn === 'function') {
	      if (!($inject = fn.$inject)) {
	        $inject = [];
	        if (fn.length) {
	          if (strictDi) {
	            if (!isString(name) || !name) {
	              name = fn.name || anonFn(fn);
	            }
	            throw $injectorMinErr('strictdi',
	              '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	          }
	          argDecl = extractArgs(fn);
	          forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	            arg.replace(FN_ARG, function(all, underscore, name) {
	              $inject.push(name);
	            });
	          });
	        }
	        fn.$inject = $inject;
	      }
	    } else if (isArray(fn)) {
	      last = fn.length - 1;
	      assertArgFn(fn[last], 'fn');
	      $inject = fn.slice(0, last);
	    } else {
	      assertArgFn(fn, 'fn', true);
	    }
	    return $inject;
	  }
	
	///////////////////////////////////////
	
	  /**
	   * @ngdoc service
	   * @name $injector
	   *
	   * @description
	   *
	   * `$injector` is used to retrieve object instances as defined by
	   * {@link auto.$provide provider}, instantiate types, invoke methods,
	   * and load modules.
	   *
	   * The following always holds true:
	   *
	   * ```js
	   *   var $injector = angular.injector();
	   *   expect($injector.get('$injector')).toBe($injector);
	   *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	   * ```
	   *
	   * # Injection Function Annotation
	   *
	   * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	   * following are all valid ways of annotating function with injection arguments and are equivalent.
	   *
	   * ```js
	   *   // inferred (only works if code not minified/obfuscated)
	   *   $injector.invoke(function(serviceA){});
	   *
	   *   // annotated
	   *   function explicit(serviceA) {};
	   *   explicit.$inject = ['serviceA'];
	   *   $injector.invoke(explicit);
	   *
	   *   // inline
	   *   $injector.invoke(['serviceA', function(serviceA){}]);
	   * ```
	   *
	   * ## Inference
	   *
	   * In JavaScript calling `toString()` on a function returns the function definition. The definition
	   * can then be parsed and the function arguments can be extracted. This method of discovering
	   * annotations is disallowed when the injector is in strict mode.
	   * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	   * argument names.
	   *
	   * ## `$inject` Annotation
	   * By adding an `$inject` property onto a function the injection parameters can be specified.
	   *
	   * ## Inline
	   * As an array of injection names, where the last item in the array is the function to call.
	   */
	
	  /**
	   * @ngdoc method
	   * @name $injector#get
	   *
	   * @description
	   * Return an instance of the service.
	   *
	   * @param {string} name The name of the instance to retrieve.
	   * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	   * @return {*} The instance.
	   */
	
	  /**
	   * @ngdoc method
	   * @name $injector#invoke
	   *
	   * @description
	   * Invoke the method and supply the method arguments from the `$injector`.
	   *
	   * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	   *   injected according to the {@link guide/di $inject Annotation} rules.
	   * @param {Object=} self The `this` for the invoked method.
	   * @param {Object=} locals Optional object. If preset then any argument names are read from this
	   *                         object first, before the `$injector` is consulted.
	   * @returns {*} the value returned by the invoked `fn` function.
	   */
	
	  /**
	   * @ngdoc method
	   * @name $injector#has
	   *
	   * @description
	   * Allows the user to query if the particular service exists.
	   *
	   * @param {string} name Name of the service to query.
	   * @returns {boolean} `true` if injector has given service.
	   */
	
	  /**
	   * @ngdoc method
	   * @name $injector#instantiate
	   * @description
	   * Create a new instance of JS type. The method takes a constructor function, invokes the new
	   * operator, and supplies all of the arguments to the constructor function as specified by the
	   * constructor annotation.
	   *
	   * @param {Function} Type Annotated constructor function.
	   * @param {Object=} locals Optional object. If preset then any argument names are read from this
	   * object first, before the `$injector` is consulted.
	   * @returns {Object} new instance of `Type`.
	   */
	
	  /**
	   * @ngdoc method
	   * @name $injector#annotate
	   *
	   * @description
	   * Returns an array of service names which the function is requesting for injection. This API is
	   * used by the injector to determine which services need to be injected into the function when the
	   * function is invoked. There are three ways in which the function can be annotated with the needed
	   * dependencies.
	   *
	   * # Argument names
	   *
	   * The simplest form is to extract the dependencies from the arguments of the function. This is done
	   * by converting the function into a string using `toString()` method and extracting the argument
	   * names.
	   * ```js
	   *   // Given
	   *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	   *
	   *   // Then
	   *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	   * ```
	   *
	   * You can disallow this method by using strict injection mode.
	   *
	   * This method does not work with code minification / obfuscation. For this reason the following
	   * annotation strategies are supported.
	   *
	   * # The `$inject` property
	   *
	   * If a function has an `$inject` property and its value is an array of strings, then the strings
	   * represent names of services to be injected into the function.
	   * ```js
	   *   // Given
	   *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	   *   // Define function dependencies
	   *   MyController['$inject'] = ['$scope', '$route'];
	   *
	   *   // Then
	   *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	   * ```
	   *
	   * # The array notation
	   *
	   * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	   * is very inconvenient. In these situations using the array notation to specify the dependencies in
	   * a way that survives minification is a better choice:
	   *
	   * ```js
	   *   // We wish to write this (not minification / obfuscation safe)
	   *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	   *
	   *   // We are forced to write break inlining
	   *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	   *   tmpFn.$inject = ['$compile', '$rootScope'];
	   *   injector.invoke(tmpFn);
	   *
	   *   // To better support inline function the inline annotation is supported
	   *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	   *
	   *   // Therefore
	   *   expect(injector.annotate(
	   *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	   *    ).toEqual(['$compile', '$rootScope']);
	   * ```
	   *
	   * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	   * be retrieved as described above.
	   *
	   * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	   *
	   * @returns {Array.<string>} The names of the services which the function requires.
	   */
	
	
	
	
	  /**
	   * @ngdoc service
	   * @name $provide
	   *
	   * @description
	   *
	   * The {@link auto.$provide $provide} service has a number of methods for registering components
	   * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	   * {@link angular.Module}.
	   *
	   * An Angular **service** is a singleton object created by a **service factory**.  These **service
	   * factories** are functions which, in turn, are created by a **service provider**.
	   * The **service providers** are constructor functions. When instantiated they must contain a
	   * property called `$get`, which holds the **service factory** function.
	   *
	   * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	   * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	   * function to get the instance of the **service**.
	   *
	   * Often services have no configuration options and there is no need to add methods to the service
	   * provider.  The provider will be no more than a constructor function with a `$get` property. For
	   * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	   * services without specifying a provider.
	   *
	   * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	   *     {@link auto.$injector $injector}
	   * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	   *     providers and services.
	   * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	   *     services, not providers.
	   * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	   *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	   *     given factory function.
	   * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	   *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	   *      a new object using the given constructor function.
	   * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	   *      will be able to modify or replace the implementation of another service.
	   *
	   * See the individual methods for more information and examples.
	   */
	
	  /**
	   * @ngdoc method
	   * @name $provide#provider
	   * @description
	   *
	   * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	   * are constructor functions, whose instances are responsible for "providing" a factory for a
	   * service.
	   *
	   * Service provider names start with the name of the service they provide followed by `Provider`.
	   * For example, the {@link ng.$log $log} service has a provider called
	   * {@link ng.$logProvider $logProvider}.
	   *
	   * Service provider objects can have additional methods which allow configuration of the provider
	   * and its service. Importantly, you can configure what kind of service is created by the `$get`
	   * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	   * method {@link ng.$logProvider#debugEnabled debugEnabled}
	   * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	   * console or not.
	   *
	   * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	   'Provider'` key.
	   * @param {(Object|function())} provider If the provider is:
	   *
	   *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	   *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	   *   - `Constructor`: a new instance of the provider will be created using
	   *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	   *
	   * @returns {Object} registered provider instance
	
	   * @example
	   *
	   * The following example shows how to create a simple event tracking service and register it using
	   * {@link auto.$provide#provider $provide.provider()}.
	   *
	   * ```js
	   *  // Define the eventTracker provider
	   *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	   *
	   *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	   * ```
	   */
	
	  /**
	   * @ngdoc method
	   * @name $provide#factory
	   * @description
	   *
	   * Register a **service factory**, which will be called to return the service instance.
	   * This is short for registering a service where its provider consists of only a `$get` property,
	   * which is the given service factory function.
	   * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	   * configure your service in a provider.
	   *
	   * @param {string} name The name of the instance.
	   * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	   *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	   * @returns {Object} registered provider instance
	   *
	   * @example
	   * Here is an example of registering a service
	   * ```js
	   *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	   * ```
	   * You would then inject and use this service like this:
	   * ```js
	   *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	   * ```
	   */
	
	
	  /**
	   * @ngdoc method
	   * @name $provide#service
	   * @description
	   *
	   * Register a **service constructor**, which will be invoked with `new` to create the service
	   * instance.
	   * This is short for registering a service where its provider's `$get` property is a factory
	   * function that returns an instance instantiated by the injector from the service constructor
	   * function.
	   *
	   * Internally it looks a bit like this:
	   *
	   * ```
	   * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	   * ```
	   *
	   *
	   * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	   * as a type/class.
	   *
	   * @param {string} name The name of the instance.
	   * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	   *     that will be instantiated.
	   * @returns {Object} registered provider instance
	   *
	   * @example
	   * Here is an example of registering a service using
	   * {@link auto.$provide#service $provide.service(class)}.
	   * ```js
	   *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	   *
	   *   Ping.$inject = ['$http'];
	   *
	   *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	   *   $provide.service('ping', Ping);
	   * ```
	   * You would then inject and use this service like this:
	   * ```js
	   *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	   * ```
	   */
	
	
	  /**
	   * @ngdoc method
	   * @name $provide#value
	   * @description
	   *
	   * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	   * number, an array, an object or a function. This is short for registering a service where its
	   * provider's `$get` property is a factory function that takes no arguments and returns the **value
	   * service**. That also means it is not possible to inject other services into a value service.
	   *
	   * Value services are similar to constant services, except that they cannot be injected into a
	   * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	   * an Angular {@link auto.$provide#decorator decorator}.
	   *
	   * @param {string} name The name of the instance.
	   * @param {*} value The value.
	   * @returns {Object} registered provider instance
	   *
	   * @example
	   * Here are some examples of creating value services.
	   * ```js
	   *   $provide.value('ADMIN_USER', 'admin');
	   *
	   *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	   *
	   *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	   * ```
	   */
	
	
	  /**
	   * @ngdoc method
	   * @name $provide#constant
	   * @description
	   *
	   * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	   * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	   * possible to inject other services into a constant.
	   *
	   * But unlike {@link auto.$provide#value value}, a constant can be
	   * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	   * be overridden by an Angular {@link auto.$provide#decorator decorator}.
	   *
	   * @param {string} name The name of the constant.
	   * @param {*} value The constant value.
	   * @returns {Object} registered instance
	   *
	   * @example
	   * Here a some examples of creating constants:
	   * ```js
	   *   $provide.constant('SHARD_HEIGHT', 306);
	   *
	   *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	   *
	   *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	   * ```
	   */
	
	
	  /**
	   * @ngdoc method
	   * @name $provide#decorator
	   * @description
	   *
	   * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	   * intercepts the creation of a service, allowing it to override or modify the behavior of the
	   * service. The return value of the decorator function may be the original service, or a new service
	   * that replaces (or wraps and delegates to) the original service.
	   *
	   * You can find out more about using decorators in the {@link guide/decorators} guide.
	   *
	   * @param {string} name The name of the service to decorate.
	   * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	   *    provided and should return the decorated service instance. The function is called using
	   *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	   *    Local injection arguments:
	   *
	   *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	   *      decorated or delegated to.
	   *
	   * @example
	   * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	   * calls to {@link ng.$log#error $log.warn()}.
	   * ```js
	   *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	   * ```
	   */
	
	
	  function createInjector(modulesToLoad, strictDi) {
	    strictDi = (strictDi === true);
	    var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new HashMap([], true),
	      providerCache = {
	        $provide: {
	          provider: supportObject(provider),
	          factory: supportObject(factory),
	          service: supportObject(service),
	          value: supportObject(value),
	          constant: supportObject(constant),
	          decorator: decorator
	        }
	      },
	      providerInjector = (providerCache.$injector =
	        createInternalInjector(providerCache, function(serviceName, caller) {
	          if (angular.isString(caller)) {
	            path.push(caller);
	          }
	          throw $injectorMinErr('unpr', "Unknown provider: {0}", path.join(' <- '));
	        })),
	      instanceCache = {},
	      protoInstanceInjector =
	        createInternalInjector(instanceCache, function(serviceName, caller) {
	          var provider = providerInjector.get(serviceName + providerSuffix, caller);
	          return instanceInjector.invoke(
	            provider.$get, provider, undefined, serviceName);
	        }),
	      instanceInjector = protoInstanceInjector;
	
	    providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
	    var runBlocks = loadModules(modulesToLoad);
	    instanceInjector = protoInstanceInjector.get('$injector');
	    instanceInjector.strictDi = strictDi;
	
	    // TODO: exposed $injector endpoint to load modules dynamically. Keep it when upgrade AngularJS
	    // Added by Nikita Butenko <nik@butenko.me>
	    instanceInjector.loadModule = function(moduleName) {
	      forEach(loadModules([moduleName]), function(fn) { instanceInjector.invoke(fn || noop); });
	    }
	
	
	    forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	    return instanceInjector;
	
	    ////////////////////////////////////
	    // $provider
	    ////////////////////////////////////
	
	    function supportObject(delegate) {
	      return function(key, value) {
	        if (isObject(key)) {
	          forEach(key, reverseParams(delegate));
	        } else {
	          return delegate(key, value);
	        }
	      };
	    }
	
	    function provider(name, provider_) {
	      assertNotHasOwnProperty(name, 'service');
	      if (isFunction(provider_) || isArray(provider_)) {
	        provider_ = providerInjector.instantiate(provider_);
	      }
	      if (!provider_.$get) {
	        throw $injectorMinErr('pget', "Provider '{0}' must define $get factory method.", name);
	      }
	      return providerCache[name + providerSuffix] = provider_;
	    }
	
	    function enforceReturnValue(name, factory) {
	      return function enforcedReturnValue() {
	        var result = instanceInjector.invoke(factory, this);
	        if (isUndefined(result)) {
	          throw $injectorMinErr('undef', "Provider '{0}' must return a value from $get factory method.", name);
	        }
	        return result;
	      };
	    }
	
	    function factory(name, factoryFn, enforce) {
	      return provider(name, {
	        $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	      });
	    }
	
	    function service(name, constructor) {
	      return factory(name, ['$injector', function($injector) {
	        return $injector.instantiate(constructor);
	      }]);
	    }
	
	    function value(name, val) { return factory(name, valueFn(val), false); }
	
	    function constant(name, value) {
	      assertNotHasOwnProperty(name, 'constant');
	      providerCache[name] = value;
	      instanceCache[name] = value;
	    }
	
	    function decorator(serviceName, decorFn) {
	      var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	      origProvider.$get = function() {
	        var origInstance = instanceInjector.invoke(orig$get, origProvider);
	        return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	      };
	    }
	
	    ////////////////////////////////////
	    // Module Loading
	    ////////////////////////////////////
	    function loadModules(modulesToLoad) {
	      assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	      var runBlocks = [], moduleFn;
	      forEach(modulesToLoad, function(module) {
	        if (loadedModules.get(module)) return;
	        loadedModules.put(module, true);
	
	        function runInvokeQueue(queue) {
	          var i, ii;
	          for (i = 0, ii = queue.length; i < ii; i++) {
	            var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	            provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	          }
	        }
	
	        try {
	          if (isString(module)) {
	            moduleFn = angularModule(module);
	            runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	            runInvokeQueue(moduleFn._invokeQueue);
	            runInvokeQueue(moduleFn._configBlocks);
	          } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	          } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	          } else {
	            assertArgFn(module, 'module');
	          }
	        } catch (e) {
	          if (isArray(module)) {
	            module = module[module.length - 1];
	          }
	          if (e.message && e.stack && e.stack.indexOf(e.message) == -1) {
	            // Safari & FF's stack traces don't contain error.message content
	            // unlike those of Chrome and IE
	            // So if stack doesn't contain message, we create a new string that contains both.
	            // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	            /* jshint -W022 */
	            e = e.message + '\n' + e.stack;
	          }
	          throw $injectorMinErr('modulerr', "Failed to instantiate module {0} due to:\n{1}",
	            module, e.stack || e.message || e);
	        }
	      });
	      return runBlocks;
	    }
	
	    ////////////////////////////////////
	    // internal Injector
	    ////////////////////////////////////
	
	    function createInternalInjector(cache, factory) {
	
	      function getService(serviceName, caller) {
	        if (cache.hasOwnProperty(serviceName)) {
	          if (cache[serviceName] === INSTANTIATING) {
	            throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	              serviceName + ' <- ' + path.join(' <- '));
	          }
	          return cache[serviceName];
	        } else {
	          try {
	            path.unshift(serviceName);
	            cache[serviceName] = INSTANTIATING;
	            return cache[serviceName] = factory(serviceName, caller);
	          } catch (err) {
	            if (cache[serviceName] === INSTANTIATING) {
	              delete cache[serviceName];
	            }
	            throw err;
	          } finally {
	            path.shift();
	          }
	        }
	      }
	
	
	      function injectionArgs(fn, locals, serviceName) {
	        var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
	
	        for (var i = 0, length = $inject.length; i < length; i++) {
	          var key = $inject[i];
	          if (typeof key !== 'string') {
	            throw $injectorMinErr('itkn',
	              'Incorrect injection token! Expected service name as string, got {0}', key);
	          }
	          args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
	            getService(key, serviceName));
	        }
	        return args;
	      }
	
	      function isClass(func) {
	        // IE 9-11 do not support classes and IE9 leaks with the code below.
	        if (msie <= 11) {
	          return false;
	        }
	        // Workaround for MS Edge.
	        // Check https://connect.microsoft.com/IE/Feedback/Details/2211653
	        return typeof func === 'function'
	          && /^(?:class\s|constructor\()/.test(stringifyFn(func));
	      }
	
	      function invoke(fn, self, locals, serviceName) {
	        if (typeof locals === 'string') {
	          serviceName = locals;
	          locals = null;
	        }
	
	        var args = injectionArgs(fn, locals, serviceName);
	        if (isArray(fn)) {
	          fn = fn[fn.length - 1];
	        }
	
	        if (!isClass(fn)) {
	          // http://jsperf.com/angularjs-invoke-apply-vs-switch
	          // #5388
	          return fn.apply(self, args);
	        } else {
	          args.unshift(null);
	          return new (Function.prototype.bind.apply(fn, args))();
	        }
	      }
	
	
	      function instantiate(Type, locals, serviceName) {
	        // Check if Type is annotated and use just the given function at n-1 as parameter
	        // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	        var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
	        var args = injectionArgs(Type, locals, serviceName);
	        // Empty object at position 0 is ignored for invocation with `new`, but required.
	        args.unshift(null);
	        return new (Function.prototype.bind.apply(ctor, args))();
	      }
	
	
	      return {
	        invoke: invoke,
	        instantiate: instantiate,
	        get: getService,
	        annotate: createInjector.$$annotate,
	        has: function(name) {
	          return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	        }
	      };
	    }
	  }
	
	  createInjector.$$annotate = annotate;
	
	  /**
	   * @ngdoc provider
	   * @name $anchorScrollProvider
	   *
	   * @description
	   * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	   * {@link ng.$location#hash $location.hash()} changes.
	   */
	  function $AnchorScrollProvider() {
	
	    var autoScrollingEnabled = true;
	
	    /**
	     * @ngdoc method
	     * @name $anchorScrollProvider#disableAutoScrolling
	     *
	     * @description
	     * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	     * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	     * Use this method to disable automatic scrolling.
	     *
	     * If automatic scrolling is disabled, one must explicitly call
	     * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	     * current hash.
	     */
	    this.disableAutoScrolling = function() {
	      autoScrollingEnabled = false;
	    };
	
	    /**
	     * @ngdoc service
	     * @name $anchorScroll
	     * @kind function
	     * @requires $window
	     * @requires $location
	     * @requires $rootScope
	     *
	     * @description
	     * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	     * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	     * in the
	     * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	     *
	     * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	     * match any anchor whenever it changes. This can be disabled by calling
	     * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	     *
	     * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	     * vertical scroll-offset (either fixed or dynamic).
	     *
	     * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	     *                       {@link ng.$location#hash $location.hash()} will be used.
	     *
	     * @property {(number|function|jqLite)} yOffset
	     * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	     * positioned elements at the top of the page, such as navbars, headers etc.
	     *
	     * `yOffset` can be specified in various ways:
	     * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	     * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	     *   a number representing the offset (in pixels).<br /><br />
	     * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	     *   the top of the page to the element's bottom will be used as offset.<br />
	     *   **Note**: The element will be taken into account only as long as its `position` is set to
	     *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	     *   their height and/or positioning according to the viewport's size.
	     *
	     * <br />
	     * <div class="alert alert-warning">
	     * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	     * not some child element.
	     * </div>
	     *
	     * @example
	     <example module="anchorScrollExample">
	     <file name="index.html">
	     <div id="scrollArea" ng-controller="ScrollController">
	     <a ng-click="gotoBottom()">Go to bottom</a>
	     <a id="bottom"></a> You're at the bottom!
	     </div>
	     </file>
	     <file name="script.js">
	     angular.module('anchorScrollExample', [])
	     .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	     function ($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	     </file>
	     <file name="style.css">
	     #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	     #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	     </file>
	     </example>
	     *
	     * <hr />
	     * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	     * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	     *
	     * @example
	     <example module="anchorScrollOffsetExample">
	     <file name="index.html">
	     <div class="fixed-header" ng-controller="headerCtrl">
	     <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	     Go to anchor {{x}}
	     </a>
	     </div>
	     <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	     Anchor {{x}} of 5
	     </div>
	     </file>
	     <file name="script.js">
	     angular.module('anchorScrollOffsetExample', [])
	     .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	     .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	     function ($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	     ]);
	     </file>
	     <file name="style.css">
	     body {
	           padding-top: 50px;
	         }
	
	     .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	     .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	     .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	     </file>
	     </example>
	     */
	    this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	      var document = $window.document;
	
	      // Helper function to get first anchor from a NodeList
	      // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	      //  and working in all supported browsers.)
	      function getFirstAnchor(list) {
	        var result = null;
	        Array.prototype.some.call(list, function(element) {
	          if (nodeName_(element) === 'a') {
	            result = element;
	            return true;
	          }
	        });
	        return result;
	      }
	
	      function getYOffset() {
	
	        var offset = scroll.yOffset;
	
	        if (isFunction(offset)) {
	          offset = offset();
	        } else if (isElement(offset)) {
	          var elem = offset[0];
	          var style = $window.getComputedStyle(elem);
	          if (style.position !== 'fixed') {
	            offset = 0;
	          } else {
	            offset = elem.getBoundingClientRect().bottom;
	          }
	        } else if (!isNumber(offset)) {
	          offset = 0;
	        }
	
	        return offset;
	      }
	
	      function scrollTo(elem) {
	        if (elem) {
	          elem.scrollIntoView();
	
	          var offset = getYOffset();
	
	          if (offset) {
	            // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	            // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	            // top of the viewport.
	            //
	            // IF the number of pixels from the top of `elem` to the end of the page's content is less
	            // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	            // way down the page.
	            //
	            // This is often the case for elements near the bottom of the page.
	            //
	            // In such cases we do not need to scroll the whole `offset` up, just the difference between
	            // the top of the element and the offset, which is enough to align the top of `elem` at the
	            // desired position.
	            var elemTop = elem.getBoundingClientRect().top;
	            $window.scrollBy(0, elemTop - offset);
	          }
	        } else {
	          $window.scrollTo(0, 0);
	        }
	      }
	
	      function scroll(hash) {
	        hash = isString(hash) ? hash : $location.hash();
	        var elm;
	
	        // empty hash, scroll to the top of the page
	        if (!hash) scrollTo(null);
	
	        // element with given id
	        else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	        // first anchor with given name :-D
	        else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	        // no element and hash == 'top', scroll to the top of the page
	        else if (hash === 'top') scrollTo(null);
	      }
	
	      // does not scroll when user clicks on anchor link that is currently on
	      // (no url change, no $location.hash() change), browser native does scroll
	      if (autoScrollingEnabled) {
	        $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	          function autoScrollWatchAction(newVal, oldVal) {
	            // skip the initial scroll if $location.hash is empty
	            if (newVal === oldVal && newVal === '') return;
	
	            jqLiteDocumentLoaded(function() {
	              $rootScope.$evalAsync(scroll);
	            });
	          });
	      }
	
	      return scroll;
	    }];
	  }
	
	  var $animateMinErr = minErr('$animate');
	  var ELEMENT_NODE = 1;
	  var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	  function mergeClasses(a,b) {
	    if (!a && !b) return '';
	    if (!a) return b;
	    if (!b) return a;
	    if (isArray(a)) a = a.join(' ');
	    if (isArray(b)) b = b.join(' ');
	    return a + ' ' + b;
	  }
	
	  function extractElementNode(element) {
	    for (var i = 0; i < element.length; i++) {
	      var elm = element[i];
	      if (elm.nodeType === ELEMENT_NODE) {
	        return elm;
	      }
	    }
	  }
	
	  function splitClasses(classes) {
	    if (isString(classes)) {
	      classes = classes.split(' ');
	    }
	
	    // Use createMap() to prevent class assumptions involving property names in
	    // Object.prototype
	    var obj = createMap();
	    forEach(classes, function(klass) {
	      // sometimes the split leaves empty string values
	      // incase extra spaces were applied to the options
	      if (klass.length) {
	        obj[klass] = true;
	      }
	    });
	    return obj;
	  }
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	  function prepareAnimateOptions(options) {
	    return isObject(options)
	      ? options
	      : {};
	  }
	
	  var $$CoreAnimateJsProvider = function() {
	    this.$get = noop;
	  };
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	  var $$CoreAnimateQueueProvider = function() {
	    var postDigestQueue = new HashMap();
	    var postDigestElements = [];
	
	    this.$get = ['$$AnimateRunner', '$rootScope',
	      function($$AnimateRunner,   $rootScope) {
	        return {
	          enabled: noop,
	          on: noop,
	          off: noop,
	          pin: noop,
	
	          push: function(element, event, options, domOperation) {
	            domOperation        && domOperation();
	
	            options = options || {};
	            options.from        && element.css(options.from);
	            options.to          && element.css(options.to);
	
	            if (options.addClass || options.removeClass) {
	              addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	            }
	
	            var runner = new $$AnimateRunner(); // jshint ignore:line
	
	            // since there are no animations to run the runner needs to be
	            // notified that the animation call is complete.
	            runner.complete();
	            return runner;
	          }
	        };
	
	
	        function updateData(data, classes, value) {
	          var changed = false;
	          if (classes) {
	            classes = isString(classes) ? classes.split(' ') :
	              isArray(classes) ? classes : [];
	            forEach(classes, function(className) {
	              if (className) {
	                changed = true;
	                data[className] = value;
	              }
	            });
	          }
	          return changed;
	        }
	
	        function handleCSSClassChanges() {
	          forEach(postDigestElements, function(element) {
	            var data = postDigestQueue.get(element);
	            if (data) {
	              var existing = splitClasses(element.attr('class'));
	              var toAdd = '';
	              var toRemove = '';
	              forEach(data, function(status, className) {
	                var hasClass = !!existing[className];
	                if (status !== hasClass) {
	                  if (status) {
	                    toAdd += (toAdd.length ? ' ' : '') + className;
	                  } else {
	                    toRemove += (toRemove.length ? ' ' : '') + className;
	                  }
	                }
	              });
	
	              forEach(element, function(elm) {
	                toAdd    && jqLiteAddClass(elm, toAdd);
	                toRemove && jqLiteRemoveClass(elm, toRemove);
	              });
	              postDigestQueue.remove(element);
	            }
	          });
	          postDigestElements.length = 0;
	        }
	
	
	        function addRemoveClassesPostDigest(element, add, remove) {
	          var data = postDigestQueue.get(element) || {};
	
	          var classesAdded = updateData(data, add, true);
	          var classesRemoved = updateData(data, remove, false);
	
	          if (classesAdded || classesRemoved) {
	
	            postDigestQueue.put(element, data);
	            postDigestElements.push(element);
	
	            if (postDigestElements.length === 1) {
	              $rootScope.$$postDigest(handleCSSClassChanges);
	            }
	          }
	        }
	      }];
	  };
	
	  /**
	   * @ngdoc provider
	   * @name $animateProvider
	   *
	   * @description
	   * Default implementation of $animate that doesn't perform any animations, instead just
	   * synchronously performs DOM updates and resolves the returned runner promise.
	   *
	   * In order to enable animations the `ngAnimate` module has to be loaded.
	   *
	   * To see the functional implementation check out `src/ngAnimate/animate.js`.
	   */
	  var $AnimateProvider = ['$provide', function($provide) {
	    var provider = this;
	
	    this.$$registeredAnimations = Object.create(null);
	
	    /**
	     * @ngdoc method
	     * @name $animateProvider#register
	     *
	     * @description
	     * Registers a new injectable animation factory function. The factory function produces the
	     * animation object which contains callback functions for each event that is expected to be
	     * animated.
	     *
	     *   * `eventFn`: `function(element, ... , doneFunction, options)`
	     *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	     *   on the type of animation additional arguments will be injected into the animation function. The
	     *   list below explains the function signatures for the different animation methods:
	     *
	     *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	     *   - addClass: function(element, addedClasses, doneFunction, options)
	     *   - removeClass: function(element, removedClasses, doneFunction, options)
	     *   - enter, leave, move: function(element, doneFunction, options)
	     *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	     *
	     *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	     *
	     * ```js
	     *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	     * ```
	     *
	     * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	     * @param {Function} factory The factory function that will be executed to return the animation
	     *                           object.
	     */
	    this.register = function(name, factory) {
	      if (name && name.charAt(0) !== '.') {
	        throw $animateMinErr('notcsel', "Expecting class selector starting with '.' got '{0}'.", name);
	      }
	
	      var key = name + '-animation';
	      provider.$$registeredAnimations[name.substr(1)] = key;
	      $provide.factory(key, factory);
	    };
	
	    /**
	     * @ngdoc method
	     * @name $animateProvider#classNameFilter
	     *
	     * @description
	     * Sets and/or returns the CSS class regular expression that is checked when performing
	     * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	     * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	     * When setting the `classNameFilter` value, animations will only be performed on elements
	     * that successfully match the filter expression. This in turn can boost performance
	     * for low-powered devices as well as applications containing a lot of structural operations.
	     * @param {RegExp=} expression The className expression which will be checked against all animations
	     * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	     */
	    this.classNameFilter = function(expression) {
	      if (arguments.length === 1) {
	        this.$$classNameFilter = (expression instanceof RegExp) ? expression : null;
	        if (this.$$classNameFilter) {
	          var reservedRegex = new RegExp("(\\s+|\\/)" + NG_ANIMATE_CLASSNAME + "(\\s+|\\/)");
	          if (reservedRegex.test(this.$$classNameFilter.toString())) {
	            throw $animateMinErr('nongcls','$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	
	          }
	        }
	      }
	      return this.$$classNameFilter;
	    };
	
	    this.$get = ['$$animateQueue', function($$animateQueue) {
	      function domInsert(element, parentElement, afterElement) {
	        // if for some reason the previous element was removed
	        // from the dom sometime before this code runs then let's
	        // just stick to using the parent element as the anchor
	        if (afterElement) {
	          var afterNode = extractElementNode(afterElement);
	          if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	            afterElement = null;
	          }
	        }
	        afterElement ? afterElement.after(element) : parentElement.prepend(element);
	      }
	
	      /**
	       * @ngdoc service
	       * @name $animate
	       * @description The $animate service exposes a series of DOM utility methods that provide support
	       * for animation hooks. The default behavior is the application of DOM operations, however,
	       * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	       * to ensure that animation runs with the triggered DOM operation.
	       *
	       * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	       * included and only when it is active then the animation hooks that `$animate` triggers will be
	       * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	       * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	       * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	       *
	       * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	       *
	       * To learn more about enabling animation support, click here to visit the
	       * {@link ngAnimate ngAnimate module page}.
	       */
	      return {
	        // we don't call it directly since non-existant arguments may
	        // be interpreted as null within the sub enabled function
	
	        /**
	         *
	         * @ngdoc method
	         * @name $animate#on
	         * @kind function
	         * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	         *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	         *    is fired with the following params:
	         *
	         * ```js
	         * $animate.on('enter', container,
	         *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	         * );
	         * ```
	         *
	         * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	         * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	         *     as well as among its children
	         * @param {Function} callback the callback function that will be fired when the listener is triggered
	         *
	         * The arguments present in the callback function are:
	         * * `element` - The captured DOM element that the animation was fired on.
	         * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	         */
	        on: $$animateQueue.on,
	
	        /**
	         *
	         * @ngdoc method
	         * @name $animate#off
	         * @kind function
	         * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	         * can be used in three different ways depending on the arguments:
	         *
	         * ```js
	         * // remove all the animation event listeners listening for `enter`
	         * $animate.off('enter');
	         *
	         * // remove listeners for all animation events from the container element
	         * $animate.off(container);
	         *
	         * // remove all the animation event listeners listening for `enter` on the given element and its children
	         * $animate.off('enter', container);
	         *
	         * // remove the event listener function provided by `callback` that is set
	         * // to listen for `enter` on the given `container` as well as its children
	         * $animate.off('enter', container, callback);
	         * ```
	         *
	         * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	         * addClass, removeClass, etc...), or the container element. If it is the element, all other
	         * arguments are ignored.
	         * @param {DOMElement=} container the container element the event listener was placed on
	         * @param {Function=} callback the callback function that was registered as the listener
	         */
	        off: $$animateQueue.off,
	
	        /**
	         * @ngdoc method
	         * @name $animate#pin
	         * @kind function
	         * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	         *    outside of the DOM structure of the Angular application. By doing so, any animation triggered via `$animate` can be issued on the
	         *    element despite being outside the realm of the application or within another application. Say for example if the application
	         *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	         *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	         *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	         *
	         *    Note that this feature is only active when the `ngAnimate` module is used.
	         *
	         * @param {DOMElement} element the external element that will be pinned
	         * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	         */
	        pin: $$animateQueue.pin,
	
	        /**
	         *
	         * @ngdoc method
	         * @name $animate#enabled
	         * @kind function
	         * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	         * function can be called in four ways:
	         *
	         * ```js
	         * // returns true or false
	         * $animate.enabled();
	         *
	         * // changes the enabled state for all animations
	         * $animate.enabled(false);
	         * $animate.enabled(true);
	         *
	         * // returns true or false if animations are enabled for an element
	         * $animate.enabled(element);
	         *
	         * // changes the enabled state for an element and its children
	         * $animate.enabled(element, true);
	         * $animate.enabled(element, false);
	         * ```
	         *
	         * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	         * @param {boolean=} enabled whether or not the animations will be enabled for the element
	         *
	         * @return {boolean} whether or not animations are enabled
	         */
	        enabled: $$animateQueue.enabled,
	
	        /**
	         * @ngdoc method
	         * @name $animate#cancel
	         * @kind function
	         * @description Cancels the provided animation.
	         *
	         * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
	         */
	        cancel: function(runner) {
	          runner.end && runner.end();
	        },
	
	        /**
	         *
	         * @ngdoc method
	         * @name $animate#enter
	         * @kind function
	         * @description Inserts the element into the DOM either after the `after` element (if provided) or
	         *   as the first child within the `parent` element and then triggers an animation.
	         *   A promise is returned that will be resolved during the next digest once the animation
	         *   has completed.
	         *
	         * @param {DOMElement} element the element which will be inserted into the DOM
	         * @param {DOMElement} parent the parent element which will append the element as
	         *   a child (so long as the after element is not present)
	         * @param {DOMElement=} after the sibling element after which the element will be appended
	         * @param {object=} options an optional collection of options/styles that will be applied to the element
	         *
	         * @return {Promise} the animation callback promise
	         */
	        enter: function(element, parent, after, options) {
	          parent = parent && jqLite(parent);
	          after = after && jqLite(after);
	          parent = parent || after.parent();
	          domInsert(element, parent, after);
	          return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	        },
	
	        /**
	         *
	         * @ngdoc method
	         * @name $animate#move
	         * @kind function
	         * @description Inserts (moves) the element into its new position in the DOM either after
	         *   the `after` element (if provided) or as the first child within the `parent` element
	         *   and then triggers an animation. A promise is returned that will be resolved
	         *   during the next digest once the animation has completed.
	         *
	         * @param {DOMElement} element the element which will be moved into the new DOM position
	         * @param {DOMElement} parent the parent element which will append the element as
	         *   a child (so long as the after element is not present)
	         * @param {DOMElement=} after the sibling element after which the element will be appended
	         * @param {object=} options an optional collection of options/styles that will be applied to the element
	         *
	         * @return {Promise} the animation callback promise
	         */
	        move: function(element, parent, after, options) {
	          parent = parent && jqLite(parent);
	          after = after && jqLite(after);
	          parent = parent || after.parent();
	          domInsert(element, parent, after);
	          return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	        },
	
	        /**
	         * @ngdoc method
	         * @name $animate#leave
	         * @kind function
	         * @description Triggers an animation and then removes the element from the DOM.
	         * When the function is called a promise is returned that will be resolved during the next
	         * digest once the animation has completed.
	         *
	         * @param {DOMElement} element the element which will be removed from the DOM
	         * @param {object=} options an optional collection of options/styles that will be applied to the element
	         *
	         * @return {Promise} the animation callback promise
	         */
	        leave: function(element, options) {
	          return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	            element.remove();
	          });
	        },
	
	        /**
	         * @ngdoc method
	         * @name $animate#addClass
	         * @kind function
	         *
	         * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	         *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	         *   animation if element already contains the CSS class or if the class is removed at a later step.
	         *   Note that class-based animations are treated differently compared to structural animations
	         *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	         *   depending if CSS or JavaScript animations are used.
	         *
	         * @param {DOMElement} element the element which the CSS classes will be applied to
	         * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	         * @param {object=} options an optional collection of options/styles that will be applied to the element
	         *
	         * @return {Promise} the animation callback promise
	         */
	        addClass: function(element, className, options) {
	          options = prepareAnimateOptions(options);
	          options.addClass = mergeClasses(options.addclass, className);
	          return $$animateQueue.push(element, 'addClass', options);
	        },
	
	        /**
	         * @ngdoc method
	         * @name $animate#removeClass
	         * @kind function
	         *
	         * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	         *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	         *   animation if element does not contain the CSS class or if the class is added at a later step.
	         *   Note that class-based animations are treated differently compared to structural animations
	         *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	         *   depending if CSS or JavaScript animations are used.
	         *
	         * @param {DOMElement} element the element which the CSS classes will be applied to
	         * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	         * @param {object=} options an optional collection of options/styles that will be applied to the element
	         *
	         * @return {Promise} the animation callback promise
	         */
	        removeClass: function(element, className, options) {
	          options = prepareAnimateOptions(options);
	          options.removeClass = mergeClasses(options.removeClass, className);
	          return $$animateQueue.push(element, 'removeClass', options);
	        },
	
	        /**
	         * @ngdoc method
	         * @name $animate#setClass
	         * @kind function
	         *
	         * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	         *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	         *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	         *    passed. Note that class-based animations are treated differently compared to structural animations
	         *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	         *    depending if CSS or JavaScript animations are used.
	         *
	         * @param {DOMElement} element the element which the CSS classes will be applied to
	         * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	         * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	         * @param {object=} options an optional collection of options/styles that will be applied to the element
	         *
	         * @return {Promise} the animation callback promise
	         */
	        setClass: function(element, add, remove, options) {
	          options = prepareAnimateOptions(options);
	          options.addClass = mergeClasses(options.addClass, add);
	          options.removeClass = mergeClasses(options.removeClass, remove);
	          return $$animateQueue.push(element, 'setClass', options);
	        },
	
	        /**
	         * @ngdoc method
	         * @name $animate#animate
	         * @kind function
	         *
	         * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	         * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	         * on the provided styles. For example, if a transition animation is set for the given classNamem, then the provided `from` and
	         * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	         * style in `to`, the style in `from` is applied immediately, and no animation is run.
	         * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	         * method (or as part of the `options` parameter):
	         *
	         * ```js
	         * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	         * ```
	         *
	         * @param {DOMElement} element the element which the CSS styles will be applied to
	         * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	         * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	         * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	         *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	         *    (Note that if no animation is detected then this value will not be applied to the element.)
	         * @param {object=} options an optional collection of options/styles that will be applied to the element
	         *
	         * @return {Promise} the animation callback promise
	         */
	        animate: function(element, from, to, className, options) {
	          options = prepareAnimateOptions(options);
	          options.from = options.from ? extend(options.from, from) : from;
	          options.to   = options.to   ? extend(options.to, to)     : to;
	
	          className = className || 'ng-inline-animate';
	          options.tempClasses = mergeClasses(options.tempClasses, className);
	          return $$animateQueue.push(element, 'animate', options);
	        }
	      };
	    }];
	  }];
	
	  var $$AnimateAsyncRunFactoryProvider = function() {
	    this.$get = ['$$rAF', function($$rAF) {
	      var waitQueue = [];
	
	      function waitForTick(fn) {
	        waitQueue.push(fn);
	        if (waitQueue.length > 1) return;
	        $$rAF(function() {
	          for (var i = 0; i < waitQueue.length; i++) {
	            waitQueue[i]();
	          }
	          waitQueue = [];
	        });
	      }
	
	      return function() {
	        var passed = false;
	        waitForTick(function() {
	          passed = true;
	        });
	        return function(callback) {
	          passed ? callback() : waitForTick(callback);
	        };
	      };
	    }];
	  };
	
	  var $$AnimateRunnerFactoryProvider = function() {
	    this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$document', '$timeout',
	      function($q,   $sniffer,   $$animateAsyncRun,   $document,   $timeout) {
	
	        var INITIAL_STATE = 0;
	        var DONE_PENDING_STATE = 1;
	        var DONE_COMPLETE_STATE = 2;
	
	        AnimateRunner.chain = function(chain, callback) {
	          var index = 0;
	
	          next();
	          function next() {
	            if (index === chain.length) {
	              callback(true);
	              return;
	            }
	
	            chain[index](function(response) {
	              if (response === false) {
	                callback(false);
	                return;
	              }
	              index++;
	              next();
	            });
	          }
	        };
	
	        AnimateRunner.all = function(runners, callback) {
	          var count = 0;
	          var status = true;
	          forEach(runners, function(runner) {
	            runner.done(onProgress);
	          });
	
	          function onProgress(response) {
	            status = status && response;
	            if (++count === runners.length) {
	              callback(status);
	            }
	          }
	        };
	
	        function AnimateRunner(host) {
	          this.setHost(host);
	
	          var rafTick = $$animateAsyncRun();
	          var timeoutTick = function(fn) {
	            $timeout(fn, 0, false);
	          };
	
	          this._doneCallbacks = [];
	          this._tick = function(fn) {
	            var doc = $document[0];
	
	            // the document may not be ready or attached
	            // to the module for some internal tests
	            if (doc && doc.hidden) {
	              timeoutTick(fn);
	            } else {
	              rafTick(fn);
	            }
	          };
	          this._state = 0;
	        }
	
	        AnimateRunner.prototype = {
	          setHost: function(host) {
	            this.host = host || {};
	          },
	
	          done: function(fn) {
	            if (this._state === DONE_COMPLETE_STATE) {
	              fn();
	            } else {
	              this._doneCallbacks.push(fn);
	            }
	          },
	
	          progress: noop,
	
	          getPromise: function() {
	            if (!this.promise) {
	              var self = this;
	              this.promise = $q(function(resolve, reject) {
	                self.done(function(status) {
	                  status === false ? reject() : resolve();
	                });
	              });
	            }
	            return this.promise;
	          },
	
	          then: function(resolveHandler, rejectHandler) {
	            return this.getPromise().then(resolveHandler, rejectHandler);
	          },
	
	          'catch': function(handler) {
	            return this.getPromise()['catch'](handler);
	          },
	
	          'finally': function(handler) {
	            return this.getPromise()['finally'](handler);
	          },
	
	          pause: function() {
	            if (this.host.pause) {
	              this.host.pause();
	            }
	          },
	
	          resume: function() {
	            if (this.host.resume) {
	              this.host.resume();
	            }
	          },
	
	          end: function() {
	            if (this.host.end) {
	              this.host.end();
	            }
	            this._resolve(true);
	          },
	
	          cancel: function() {
	            if (this.host.cancel) {
	              this.host.cancel();
	            }
	            this._resolve(false);
	          },
	
	          complete: function(response) {
	            var self = this;
	            if (self._state === INITIAL_STATE) {
	              self._state = DONE_PENDING_STATE;
	              self._tick(function() {
	                self._resolve(response);
	              });
	            }
	          },
	
	          _resolve: function(response) {
	            if (this._state !== DONE_COMPLETE_STATE) {
	              forEach(this._doneCallbacks, function(fn) {
	                fn(response);
	              });
	              this._doneCallbacks.length = 0;
	              this._state = DONE_COMPLETE_STATE;
	            }
	          }
	        };
	
	        return AnimateRunner;
	      }];
	  };
	
	  /**
	   * @ngdoc service
	   * @name $animateCss
	   * @kind object
	   *
	   * @description
	   * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	   * then the `$animateCss` service will actually perform animations.
	   *
	   * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	   */
	  var $CoreAnimateCssProvider = function() {
	    this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
	
	      return function(element, initialOptions) {
	        // all of the animation functions should create
	        // a copy of the options data, however, if a
	        // parent service has already created a copy then
	        // we should stick to using that
	        var options = initialOptions || {};
	        if (!options.$$prepared) {
	          options = copy(options);
	        }
	
	        // there is no point in applying the styles since
	        // there is no animation that goes on at all in
	        // this version of $animateCss.
	        if (options.cleanupStyles) {
	          options.from = options.to = null;
	        }
	
	        if (options.from) {
	          element.css(options.from);
	          options.from = null;
	        }
	
	        /* jshint newcap: false */
	        var closed, runner = new $$AnimateRunner();
	        return {
	          start: run,
	          end: run
	        };
	
	        function run() {
	          $$rAF(function() {
	            applyAnimationContents();
	            if (!closed) {
	              runner.complete();
	            }
	            closed = true;
	          });
	          return runner;
	        }
	
	        function applyAnimationContents() {
	          if (options.addClass) {
	            element.addClass(options.addClass);
	            options.addClass = null;
	          }
	          if (options.removeClass) {
	            element.removeClass(options.removeClass);
	            options.removeClass = null;
	          }
	          if (options.to) {
	            element.css(options.to);
	            options.to = null;
	          }
	        }
	      };
	    }];
	  };
	
	  /* global stripHash: true */
	
	  /**
	   * ! This is a private undocumented service !
	   *
	   * @name $browser
	   * @requires $log
	   * @description
	   * This object has two goals:
	   *
	   * - hide all the global state in the browser caused by the window object
	   * - abstract away all the browser specific features and inconsistencies
	   *
	   * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	   * service, which can be used for convenient testing of the application without the interaction with
	   * the real browser apis.
	   */
	  /**
	   * @param {object} window The global window object.
	   * @param {object} document jQuery wrapped document.
	   * @param {object} $log window.console or an object with the same interface.
	   * @param {object} $sniffer $sniffer service
	   */
	  function Browser(window, document, $log, $sniffer) {
	    var self = this,
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {};
	
	    self.isMock = false;
	
	    var outstandingRequestCount = 0;
	    var outstandingRequestCallbacks = [];
	
	    // TODO(vojta): remove this temporary api
	    self.$$completeOutstandingRequest = completeOutstandingRequest;
	    self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };
	
	    /**
	     * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
	     * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
	     */
	    function completeOutstandingRequest(fn) {
	      try {
	        fn.apply(null, sliceArgs(arguments, 1));
	      } finally {
	        outstandingRequestCount--;
	        if (outstandingRequestCount === 0) {
	          while (outstandingRequestCallbacks.length) {
	            try {
	              outstandingRequestCallbacks.pop()();
	            } catch (e) {
	              $log.error(e);
	            }
	          }
	        }
	      }
	    }
	
	    function getHash(url) {
	      var index = url.indexOf('#');
	      return index === -1 ? '' : url.substr(index);
	    }
	
	    /**
	     * @private
	     * Note: this method is used only by scenario runner
	     * TODO(vojta): prefix this method with $$ ?
	     * @param {function()} callback Function that will be called when no outstanding request
	     */
	    self.notifyWhenNoOutstandingRequests = function(callback) {
	      if (outstandingRequestCount === 0) {
	        callback();
	      } else {
	        outstandingRequestCallbacks.push(callback);
	      }
	    };
	
	    //////////////////////////////////////////////////////////////
	    // URL API
	    //////////////////////////////////////////////////////////////
	
	    var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      pendingLocation = null,
	      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
	        try {
	          return history.state;
	        } catch (e) {
	          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	        }
	      };
	
	    cacheState();
	    lastHistoryState = cachedState;
	
	    /**
	     * @name $browser#url
	     *
	     * @description
	     * GETTER:
	     * Without any argument, this method just returns current value of location.href.
	     *
	     * SETTER:
	     * With at least one argument, this method sets url to new value.
	     * If html5 history api supported, pushState/replaceState is used, otherwise
	     * location.href/location.replace is used.
	     * Returns its own instance to allow chaining
	     *
	     * NOTE: this api is intended for use only by the $location service. Please use the
	     * {@link ng.$location $location service} to change url.
	     *
	     * @param {string} url New url (when used as setter)
	     * @param {boolean=} replace Should new url replace current history record?
	     * @param {object=} state object to use with pushState/replaceState
	     */
	    self.url = function(url, replace, state) {
	      // In modern browsers `history.state` is `null` by default; treating it separately
	      // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	      // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	      if (isUndefined(state)) {
	        state = null;
	      }
	
	      // Android Browser BFCache causes location, history reference to become stale.
	      if (location !== window.location) location = window.location;
	      if (history !== window.history) history = window.history;
	
	      // setter
	      if (url) {
	        var sameState = lastHistoryState === state;
	
	        // Don't change anything if previous and current URLs and states match. This also prevents
	        // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	        // See https://github.com/angular/angular.js/commit/ffb2701
	        if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	          return self;
	        }
	        var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	        lastBrowserUrl = url;
	        lastHistoryState = state;
	        // Don't use history API if only the hash changed
	        // due to a bug in IE10/IE11 which leads
	        // to not firing a `hashchange` nor `popstate` event
	        // in some cases (see #9143).
	        if ($sniffer.history && (!sameBase || !sameState)) {
	          history[replace ? 'replaceState' : 'pushState'](state, '', url);
	          cacheState();
	          // Do the assignment again so that those two variables are referentially identical.
	          lastHistoryState = cachedState;
	        } else {
	          if (!sameBase) {
	            pendingLocation = url;
	          }
	          if (replace) {
	            location.replace(url);
	          } else if (!sameBase) {
	            location.href = url;
	          } else {
	            location.hash = getHash(url);
	          }
	          if (location.href !== url) {
	            pendingLocation = url;
	          }
	        }
	        if (pendingLocation) {
	          pendingLocation = url;
	        }
	        return self;
	        // getter
	      } else {
	        // - pendingLocation is needed as browsers don't allow to read out
	        //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	        //   https://openradar.appspot.com/22186109).
	        // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
	        return pendingLocation || location.href.replace(/%27/g,"'");
	      }
	    };
	
	    /**
	     * @name $browser#state
	     *
	     * @description
	     * This method is a getter.
	     *
	     * Return history.state or null if history.state is undefined.
	     *
	     * @returns {object} state
	     */
	    self.state = function() {
	      return cachedState;
	    };
	
	    var urlChangeListeners = [],
	      urlChangeInit = false;
	
	    function cacheStateAndFireUrlChange() {
	      pendingLocation = null;
	      cacheState();
	      fireUrlChange();
	    }
	
	    // This variable should be used *only* inside the cacheState function.
	    var lastCachedState = null;
	    function cacheState() {
	      // This should be the only place in $browser where `history.state` is read.
	      cachedState = getCurrentState();
	      cachedState = isUndefined(cachedState) ? null : cachedState;
	
	      // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	      if (equals(cachedState, lastCachedState)) {
	        cachedState = lastCachedState;
	      }
	      lastCachedState = cachedState;
	    }
	
	    function fireUrlChange() {
	      if (lastBrowserUrl === self.url() && lastHistoryState === cachedState) {
	        return;
	      }
	
	      lastBrowserUrl = self.url();
	      lastHistoryState = cachedState;
	      forEach(urlChangeListeners, function(listener) {
	        listener(self.url(), cachedState);
	      });
	    }
	
	    /**
	     * @name $browser#onUrlChange
	     *
	     * @description
	     * Register callback function that will be called, when url changes.
	     *
	     * It's only called when the url is changed from outside of angular:
	     * - user types different url into address bar
	     * - user clicks on history (forward/back) button
	     * - user clicks on a link
	     *
	     * It's not called when url is changed by $browser.url() method
	     *
	     * The listener gets called with new url as parameter.
	     *
	     * NOTE: this api is intended for use only by the $location service. Please use the
	     * {@link ng.$location $location service} to monitor url changes in angular apps.
	     *
	     * @param {function(string)} listener Listener function to be called when url changes.
	     * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	     */
	    self.onUrlChange = function(callback) {
	      // TODO(vojta): refactor to use node's syntax for events
	      if (!urlChangeInit) {
	        // We listen on both (hashchange/popstate) when available, as some browsers (e.g. Opera)
	        // don't fire popstate when user change the address bar and don't fire hashchange when url
	        // changed by push/replaceState
	
	        // html5 history api - popstate event
	        if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	        // hashchange event
	        jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	        urlChangeInit = true;
	      }
	
	      urlChangeListeners.push(callback);
	      return callback;
	    };
	
	    /**
	     * @private
	     * Remove popstate and hashchange handler from window.
	     *
	     * NOTE: this api is intended for use only by $rootScope.
	     */
	    self.$$applicationDestroyed = function() {
	      jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	    };
	
	    /**
	     * Checks whether the url has changed outside of Angular.
	     * Needs to be exported to be able to check for changes that have been done in sync,
	     * as hashchange/popstate events fire in async.
	     */
	    self.$$checkUrlChange = fireUrlChange;
	
	    //////////////////////////////////////////////////////////////
	    // Misc API
	    //////////////////////////////////////////////////////////////
	
	    /**
	     * @name $browser#baseHref
	     *
	     * @description
	     * Returns current <base href>
	     * (always relative - without domain)
	     *
	     * @returns {string} The current base href
	     */
	    self.baseHref = function() {
	      var href = baseElement.attr('href');
	      return href ? href.replace(/^(https?\:)?\/\/[^\/]*/, '') : '';
	    };
	
	    /**
	     * @name $browser#defer
	     * @param {function()} fn A function, who's execution should be deferred.
	     * @param {number=} [delay=0] of milliseconds to defer the function execution.
	     * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	     *
	     * @description
	     * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	     *
	     * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	     * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	     * via `$browser.defer.flush()`.
	     *
	     */
	    self.defer = function(fn, delay) {
	      var timeoutId;
	      outstandingRequestCount++;
	      timeoutId = setTimeout(function() {
	        delete pendingDeferIds[timeoutId];
	        completeOutstandingRequest(fn);
	      }, delay || 0);
	      pendingDeferIds[timeoutId] = true;
	      return timeoutId;
	    };
	
	
	    /**
	     * @name $browser#defer.cancel
	     *
	     * @description
	     * Cancels a deferred task identified with `deferId`.
	     *
	     * @param {*} deferId Token returned by the `$browser.defer` function.
	     * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	     *                    canceled.
	     */
	    self.defer.cancel = function(deferId) {
	      if (pendingDeferIds[deferId]) {
	        delete pendingDeferIds[deferId];
	        clearTimeout(deferId);
	        completeOutstandingRequest(noop);
	        return true;
	      }
	      return false;
	    };
	
	  }
	
	  function $BrowserProvider() {
	    this.$get = ['$window', '$log', '$sniffer', '$document',
	      function($window, $log, $sniffer, $document) {
	        return new Browser($window, $document, $log, $sniffer);
	      }];
	  }
	
	  /**
	   * @ngdoc service
	   * @name $cacheFactory
	   *
	   * @description
	   * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	   * them.
	   *
	   * ```js
	   *
	   *  var cache = $cacheFactory('cacheId');
	   *  expect($cacheFactory.get('cacheId')).toBe(cache);
	   *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	   *
	   *  cache.put("key", "value");
	   *  cache.put("another key", "another value");
	   *
	   *  // We've specified no options on creation
	   *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	   *
	   * ```
	   *
	   *
	   * @param {string} cacheId Name or id of the newly created cache.
	   * @param {object=} options Options object that specifies the cache behavior. Properties:
	   *
	   *   - `{number=}` `capacity` — turns the cache into LRU cache.
	   *
	   * @returns {object} Newly created cache object with the following set of methods:
	   *
	   * - `{object}` `info()` — Returns id, size, and options of cache.
	   * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	   *   it.
	   * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	   * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	   * - `{void}` `removeAll()` — Removes all cached values.
	   * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	   *
	   * @example
	   <example module="cacheExampleApp">
	   <file name="index.html">
	   <div ng-controller="CacheController">
	   <input ng-model="newCacheKey" placeholder="Key">
	   <input ng-model="newCacheValue" placeholder="Value">
	   <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	   <p ng-if="keys.length">Cached Values</p>
	   <div ng-repeat="key in keys">
	   <span ng-bind="key"></span>
	   <span>: </span>
	   <b ng-bind="cache.get(key)"></b>
	   </div>
	
	   <p>Cache Info</p>
	   <div ng-repeat="(key, value) in cache.info()">
	   <span ng-bind="key"></span>
	   <span>: </span>
	   <b ng-bind="value"></b>
	   </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('cacheExampleApp', []).
	   controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	   </file>
	   <file name="style.css">
	   p {
	         margin: 10px 0 3px;
	       }
	   </file>
	   </example>
	   */
	  function $CacheFactoryProvider() {
	
	    this.$get = function() {
	      var caches = {};
	
	      function cacheFactory(cacheId, options) {
	        if (cacheId in caches) {
	          throw minErr('$cacheFactory')('iid', "CacheId '{0}' is already taken!", cacheId);
	        }
	
	        var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = createMap(),
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = createMap(),
	          freshEnd = null,
	          staleEnd = null;
	
	        /**
	         * @ngdoc type
	         * @name $cacheFactory.Cache
	         *
	         * @description
	         * A cache object used to store and retrieve data, primarily used by
	         * {@link $http $http} and the {@link ng.directive:script script} directive to cache
	         * templates and other data.
	         *
	         * ```js
	         *  angular.module('superCache')
	         *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	         * ```
	         *
	         * Example test:
	         *
	         * ```js
	         *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	         * ```
	         */
	        return caches[cacheId] = {
	
	          /**
	           * @ngdoc method
	           * @name $cacheFactory.Cache#put
	           * @kind function
	           *
	           * @description
	           * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	           * retrieved later, and incrementing the size of the cache if the key was not already
	           * present in the cache. If behaving like an LRU cache, it will also remove stale
	           * entries from the set.
	           *
	           * It will not insert undefined values into the cache.
	           *
	           * @param {string} key the key under which the cached data is stored.
	           * @param {*} value the value to store alongside the key. If it is undefined, the key
	           *    will not be stored.
	           * @returns {*} the value stored.
	           */
	          put: function(key, value) {
	            if (isUndefined(value)) return;
	            if (capacity < Number.MAX_VALUE) {
	              var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	              refresh(lruEntry);
	            }
	
	            if (!(key in data)) size++;
	            data[key] = value;
	
	            if (size > capacity) {
	              this.remove(staleEnd.key);
	            }
	
	            return value;
	          },
	
	          /**
	           * @ngdoc method
	           * @name $cacheFactory.Cache#get
	           * @kind function
	           *
	           * @description
	           * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	           *
	           * @param {string} key the key of the data to be retrieved
	           * @returns {*} the value stored.
	           */
	          get: function(key) {
	            if (capacity < Number.MAX_VALUE) {
	              var lruEntry = lruHash[key];
	
	              if (!lruEntry) return;
	
	              refresh(lruEntry);
	            }
	
	            return data[key];
	          },
	
	
	          /**
	           * @ngdoc method
	           * @name $cacheFactory.Cache#remove
	           * @kind function
	           *
	           * @description
	           * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	           *
	           * @param {string} key the key of the entry to be removed
	           */
	          remove: function(key) {
	            if (capacity < Number.MAX_VALUE) {
	              var lruEntry = lruHash[key];
	
	              if (!lruEntry) return;
	
	              if (lruEntry == freshEnd) freshEnd = lruEntry.p;
	              if (lruEntry == staleEnd) staleEnd = lruEntry.n;
	              link(lruEntry.n,lruEntry.p);
	
	              delete lruHash[key];
	            }
	
	            if (!(key in data)) return;
	
	            delete data[key];
	            size--;
	          },
	
	
	          /**
	           * @ngdoc method
	           * @name $cacheFactory.Cache#removeAll
	           * @kind function
	           *
	           * @description
	           * Clears the cache object of any entries.
	           */
	          removeAll: function() {
	            data = createMap();
	            size = 0;
	            lruHash = createMap();
	            freshEnd = staleEnd = null;
	          },
	
	
	          /**
	           * @ngdoc method
	           * @name $cacheFactory.Cache#destroy
	           * @kind function
	           *
	           * @description
	           * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	           * removing it from the {@link $cacheFactory $cacheFactory} set.
	           */
	          destroy: function() {
	            data = null;
	            stats = null;
	            lruHash = null;
	            delete caches[cacheId];
	          },
	
	
	          /**
	           * @ngdoc method
	           * @name $cacheFactory.Cache#info
	           * @kind function
	           *
	           * @description
	           * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	           *
	           * @returns {object} an object with the following properties:
	           *   <ul>
	           *     <li>**id**: the id of the cache instance</li>
	           *     <li>**size**: the number of entries kept in the cache instance</li>
	           *     <li>**...**: any additional properties from the options object when creating the
	           *       cache.</li>
	           *   </ul>
	           */
	          info: function() {
	            return extend({}, stats, {size: size});
	          }
	        };
	
	
	        /**
	         * makes the `entry` the freshEnd of the LRU linked list
	         */
	        function refresh(entry) {
	          if (entry != freshEnd) {
	            if (!staleEnd) {
	              staleEnd = entry;
	            } else if (staleEnd == entry) {
	              staleEnd = entry.n;
	            }
	
	            link(entry.n, entry.p);
	            link(entry, freshEnd);
	            freshEnd = entry;
	            freshEnd.n = null;
	          }
	        }
	
	
	        /**
	         * bidirectionally links two entries of the LRU linked list
	         */
	        function link(nextEntry, prevEntry) {
	          if (nextEntry != prevEntry) {
	            if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	            if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	          }
	        }
	      }
	
	
	      /**
	       * @ngdoc method
	       * @name $cacheFactory#info
	       *
	       * @description
	       * Get information about all the caches that have been created
	       *
	       * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	       */
	      cacheFactory.info = function() {
	        var info = {};
	        forEach(caches, function(cache, cacheId) {
	          info[cacheId] = cache.info();
	        });
	        return info;
	      };
	
	
	      /**
	       * @ngdoc method
	       * @name $cacheFactory#get
	       *
	       * @description
	       * Get access to a cache object by the `cacheId` used when it was created.
	       *
	       * @param {string} cacheId Name or id of a cache to access.
	       * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	       */
	      cacheFactory.get = function(cacheId) {
	        return caches[cacheId];
	      };
	
	
	      return cacheFactory;
	    };
	  }
	
	  /**
	   * @ngdoc service
	   * @name $templateCache
	   *
	   * @description
	   * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	   * can load templates directly into the cache in a `script` tag, or by consuming the
	   * `$templateCache` service directly.
	   *
	   * Adding via the `script` tag:
	   *
	   * ```html
	   *   <script type="text/ng-template" id="templateId.html">
	   *     <p>This is the content of the template</p>
	   *   </script>
	   * ```
	   *
	   * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	   * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (IE,
	   * element with ng-app attribute), otherwise the template will be ignored.
	   *
	   * Adding via the `$templateCache` service:
	   *
	   * ```js
	   * var myApp = angular.module('myApp', []);
	   * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	   * ```
	   *
	   * To retrieve the template later, simply use it in your HTML:
	   * ```html
	   * <div ng-include=" 'templateId.html' "></div>
	   * ```
	   *
	   * or get it via Javascript:
	   * ```js
	   * $templateCache.get('templateId.html')
	   * ```
	   *
	   * See {@link ng.$cacheFactory $cacheFactory}.
	   *
	   */
	  function $TemplateCacheProvider() {
	    this.$get = ['$cacheFactory', function($cacheFactory) {
	      return $cacheFactory('templates');
	    }];
	  }
	
	  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	   *     Any commits to this file should be reviewed with security in mind.  *
	   *   Changes to this file can potentially create security vulnerabilities. *
	   *          An approval from 2 Core members with history of modifying      *
	   *                         this file is required.                          *
	   *                                                                         *
	   *  Does the change somehow allow for arbitrary javascript to be executed? *
	   *    Or allows for someone to change the prototype of built-in objects?   *
	   *     Or gives undesired access to variables likes document or window?    *
	   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	  /* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	   *
	   * DOM-related variables:
	   *
	   * - "node" - DOM Node
	   * - "element" - DOM Element or Node
	   * - "$node" or "$element" - jqLite-wrapped node or element
	   *
	   *
	   * Compiler related stuff:
	   *
	   * - "linkFn" - linking fn of a single directive
	   * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	   * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	   * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	   */
	
	
	  /**
	   * @ngdoc service
	   * @name $compile
	   * @kind function
	   *
	   * @description
	   * Compiles an HTML string or DOM into a template and produces a template function, which
	   * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	   *
	   * The compilation is a process of walking the DOM tree and matching DOM elements to
	   * {@link ng.$compileProvider#directive directives}.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** This document is an in-depth reference of all directive options.
	   * For a gentle introduction to directives with examples of common use cases,
	   * see the {@link guide/directive directive guide}.
	   * </div>
	   *
	   * ## Comprehensive Directive API
	   *
	   * There are many different options for a directive.
	   *
	   * The difference resides in the return value of the factory function.
	   * You can either return a "Directive Definition Object" (see below) that defines the directive properties,
	   * or just the `postLink` function (all other properties will have the default values).
	   *
	   * <div class="alert alert-success">
	   * **Best Practice:** It's recommended to use the "directive definition object" form.
	   * </div>
	   *
	   * Here's an example directive declared with a Directive Definition Object:
	   *
	   * ```js
	   *   var myModule = angular.module(...);
	   *
	   *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       priority: 0,
	 *       template: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // templateUrl: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       transclude: false,
	 *       restrict: 'A',
	 *       templateNamespace: 'html',
	 *       scope: false,
	 *       controller: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       controllerAs: 'stringIdentifier',
	 *       bindToController: false,
	 *       require: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       compile: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *           pre: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *           post: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // link: {
	 *       //  pre: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  post: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // link: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	   * ```
	   *
	   * <div class="alert alert-warning">
	   * **Note:** Any unspecified options will use the default value. You can see the default values below.
	   * </div>
	   *
	   * Therefore the above can be simplified as:
	   *
	   * ```js
	   *   var myModule = angular.module(...);
	   *
	   *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	   * ```
	   *
	   *
	   *
	   * ### Directive Definition Object
	   *
	   * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	   *
	   * #### `multiElement`
	   * When this property is set to true, the HTML compiler will collect DOM nodes between
	   * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	   * together as the directive elements. It is recommended that this feature be used on directives
	   * which are not strictly behavioral (such as {@link ngClick}), and which
	   * do not manipulate or replace child nodes (such as {@link ngInclude}).
	   *
	   * #### `priority`
	   * When there are multiple directives defined on a single DOM element, sometimes it
	   * is necessary to specify the order in which the directives are applied. The `priority` is used
	   * to sort the directives before their `compile` functions get called. Priority is defined as a
	   * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	   * are also run in priority order, but post-link functions are run in reverse order. The order
	   * of directives with the same priority is undefined. The default priority is `0`.
	   *
	   * #### `terminal`
	   * If set to true then the current `priority` will be the last set of directives
	   * which will execute (any directives at the current priority will still execute
	   * as the order of execution on same `priority` is undefined). Note that expressions
	   * and other directives used in the directive's template will also be excluded from execution.
	   *
	   * #### `scope`
	   * The scope property can be `true`, an object or a falsy value:
	   *
	   * * **falsy:** No scope will be created for the directive. The directive will use its parent's scope.
	   *
	   * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	   * the directive's element. If multiple directives on the same element request a new scope,
	   * only one new scope is created. The new scope rule does not apply for the root of the template
	   * since the root of the template always gets a new scope.
	   *
	   * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's element. The
	   * 'isolate' scope differs from normal scope in that it does not prototypically inherit from its parent
	   * scope. This is useful when creating reusable components, which should not accidentally read or modify
	   * data in the parent scope.
	   *
	   * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	   * directive's element. These local properties are useful for aliasing values for templates. The keys in
	   * the object hash map to the name of the property on the isolate scope; the values define how the property
	   * is bound to the parent scope, via matching attributes on the directive's element:
	   *
	   * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	   *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	   *   attribute name is assumed to be the same as the local name. Given `<my-component
	   *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	   *   the directive's scope property `localName` will reflect the interpolated value of `hello
	   *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	   *   scope. The `name` is read from the parent scope (not the directive's scope).
	   *
	   * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	   *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	   *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	   *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	   *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	   *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
	   *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
	   *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
	   *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
	   *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	   *   method is used for tracking changes, and the equality check is based on object identity.
	   *   However, if an object literal or an array literal is passed as the binding expression, the
	   *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	   *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
	   *
	   * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	   *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	   *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	   *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
	   *
	   *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	   *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	   *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	   *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	   *   two caveats:
	   *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	   *     sets the same value. That means if your bound value is an object, changes to its properties
	   *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	   *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	   *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	   *     to the value has changed. In most cases, this should not be of concern, but can be important
	   *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	   *     If you now change a property of the object in your parent scope, the change will not be
	   *     propagated to the isolated scope, because the identity of the object on the parent scope
	   *     has not changed. Instead you must assign a new object.
	   *
	   *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	   *   back to the parent. However, it does not make this completely impossible.
	   *
	   * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	   *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	   *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	   *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	   *   via an expression to the parent scope. This can be done by passing a map of local variable names
	   *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	   *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	   *
	   * In general it's possible to apply more than one directive to one element, but there might be limitations
	   * depending on the type of scope required by the directives. The following points will help explain these limitations.
	   * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	   *
	   * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	   * * **child scope** + **no scope** =>  Both directives will share one single child scope
	   * * **child scope** + **child scope** =>  Both directives will share one single child scope
	   * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	   * its parent's scope
	   * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	   * be applied to the same element.
	   * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	   * cannot be applied to the same element.
	   *
	   *
	   * #### `bindToController`
	   * This property is used to bind scope properties directly to the controller. It can be either
	   * `true` or an object hash with the same format as the `scope` property. Additionally, a controller
	   * alias must be set, either by using `controllerAs: 'myAlias'` or by specifying the alias in the controller
	   * definition: `controller: 'myCtrl as myAlias'`.
	   *
	   * When an isolate scope is used for a directive (see above), `bindToController: true` will
	   * allow a component to have its properties bound to the controller, rather than to scope.
	   *
	   * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	   * properties. You can access these bindings once they have been initialized by providing a controller method called
	   * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	   * initialized.
	   *
	   * <div class="alert alert-warning">
	   * **Deprecation warning:** although bindings for non-ES6 class controllers are currently
	   * bound to `this` before the controller constructor is called, this use is now deprecated. Please place initialization
	   * code that relies upon bindings inside a `$onInit` method on the controller, instead.
	   * </div>
	   *
	   * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	   * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	   * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	   * scope (useful for component directives).
	   *
	   * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	   *
	   *
	   * #### `controller`
	   * Controller constructor function. The controller is instantiated before the
	   * pre-linking phase and can be accessed by other directives (see
	   * `require` attribute). This allows the directives to communicate with each other and augment
	   * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	   *
	   * * `$scope` - Current scope associated with the element
	   * * `$element` - Current element
	   * * `$attrs` - Current attributes object for the element
	   * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	   *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	   *    * `scope`: (optional) override the scope.
	   *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	   *    * `futureParentElement` (optional):
	   *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	   *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	   *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	   *          and when the `cloneLinkinFn` is passed,
	   *          as those elements need to created and cloned in a special way when they are defined outside their
	   *          usual containers (e.g. like `<svg>`).
	   *        * See also the `directive.templateNamespace` property.
	   *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	   *      then the default translusion is provided.
	   *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	   *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	   *
	   * The controller can provide the following methods that act as life-cycle hooks:
	   * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	   *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	   *   this element). This is a good place to put initialization code for your controller.
	   * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	   *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	   *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	   *   component such as cloning the bound value to prevent accidental mutation of the outer value.
	   * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	   *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	   *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	   *   components will have their `$onDestroy()` hook called before child components.
	   * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	   *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	   *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	   *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	   *   suspended until that occurs.
	   *
	   *
	   * #### `require`
	   * Require another directive and inject its controller as the fourth argument to the linking function. The
	   * `require` property can be a string, an array or an object:
	   * * a **string** containing the name of the directive to pass to the linking function
	   * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	   * linking function will be an array of controllers in the same order as the names in the `require` property
	   * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	   * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	   * controllers.
	   *
	   * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	   * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	   * have been constructed but before `$onInit` is called.
	   * If the name of the required controller is the same as the local name (the key), the name can be
	   * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	   * See the {@link $compileProvider#component} helper for an example of how this can be used.
	   * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	   * raised (unless no link function is specified and the required controllers are not being bound to the directive
	   * controller, in which case error checking is skipped). The name can be prefixed with:
	   *
	   * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	   * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	   * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	   * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	   * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	   *   `null` to the `link` fn if not found.
	   * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	   *   `null` to the `link` fn if not found.
	   *
	   *
	   * #### `controllerAs`
	   * Identifier name for a reference to the controller in the directive's scope.
	   * This allows the controller to be referenced from the directive template. This is especially
	   * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	   * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	   * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	   *
	   *
	   * #### `restrict`
	   * String of subset of `EACM` which restricts the directive to a specific directive
	   * declaration style. If omitted, the defaults (elements and attributes) are used.
	   *
	   * * `E` - Element name (default): `<my-directive></my-directive>`
	   * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	   * * `C` - Class: `<div class="my-directive: exp;"></div>`
	   * * `M` - Comment: `<!-- directive: my-directive exp -->`
	   *
	   *
	   * #### `templateNamespace`
	   * String representing the document type used by the markup in the template.
	   * AngularJS needs this information as those elements need to be created and cloned
	   * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	   *
	   * * `html` - All root nodes in the template are HTML. Root nodes may also be
	   *   top-level elements such as `<svg>` or `<math>`.
	   * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	   * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	   *
	   * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	   *
	   * #### `template`
	   * HTML markup that may:
	   * * Replace the contents of the directive's element (default).
	   * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	   * * Wrap the contents of the directive's element (if `transclude` is true).
	   *
	   * Value may be:
	   *
	   * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	   * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	   *   function api below) and returns a string value.
	   *
	   *
	   * #### `templateUrl`
	   * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	   *
	   * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	   * for later when the template has been resolved.  In the meantime it will continue to compile and link
	   * sibling and parent elements as though this element had not contained any directives.
	   *
	   * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	   * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	   * case when only one deeply nested directive has `templateUrl`.
	   *
	   * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
	   *
	   * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	   * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	   * a string value representing the url.  In either case, the template URL is passed through {@link
	    * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	   *
	   *
	   * #### `replace` ([*DEPRECATED*!], will be removed in next major release - i.e. v2.0)
	   * specify what the template should replace. Defaults to `false`.
	   *
	   * * `true` - the template will replace the directive's element.
	   * * `false` - the template will replace the contents of the directive's element.
	   *
	   * The replacement process migrates all of the attributes / classes from the old element to the new
	   * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	   *
	   * There are very few scenarios where element replacement is required for the application function,
	   * the main one being reusable custom components that are used within SVG contexts
	   * (because SVG doesn't work with custom elements in the DOM tree).
	   *
	   * #### `transclude`
	   * Extract the contents of the element where the directive appears and make it available to the directive.
	   * The contents are compiled and provided to the directive as a **transclusion function**. See the
	   * {@link $compile#transclusion Transclusion} section below.
	   *
	   *
	   * #### `compile`
	   *
	   * ```js
	   *   function compile(tElement, tAttrs, transclude) { ... }
	   * ```
	   *
	   * The compile function deals with transforming the template DOM. Since most directives do not do
	   * template transformation, it is not used often. The compile function takes the following arguments:
	   *
	   *   * `tElement` - template element - The element where the directive has been declared. It is
	   *     safe to do template transformation on the element and child elements only.
	   *
	   *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	   *     between all directive compile functions.
	   *
	   *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	   *
	   * <div class="alert alert-warning">
	   * **Note:** The template instance and the link instance may be different objects if the template has
	   * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	   * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	   * should be done in a linking function rather than in a compile function.
	   * </div>
	
	   * <div class="alert alert-warning">
	   * **Note:** The compile function cannot handle directives that recursively use themselves in their
	   * own templates or compile functions. Compiling these directives results in an infinite loop and
	   * stack overflow errors.
	   *
	   * This can be avoided by manually using $compile in the postLink function to imperatively compile
	   * a directive's template instead of relying on automatic template compilation via `template` or
	   * `templateUrl` declaration or manual compilation inside the compile function.
	   * </div>
	   *
	   * <div class="alert alert-danger">
	   * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	   *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	   *   to the link function instead.
	   * </div>
	
	   * A compile function can have a return value which can be either a function or an object.
	   *
	   * * returning a (post-link) function - is equivalent to registering the linking function via the
	   *   `link` property of the config object when the compile function is empty.
	   *
	   * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	   *   control when a linking function should be called during the linking phase. See info about
	   *   pre-linking and post-linking functions below.
	   *
	   *
	   * #### `link`
	   * This property is used only if the `compile` property is not defined.
	   *
	   * ```js
	   *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	   * ```
	   *
	   * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	   * executed after the template has been cloned. This is where most of the directive logic will be
	   * put.
	   *
	   *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	   *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	   *
	   *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	   *     manipulate the children of the element only in `postLink` function since the children have
	   *     already been linked.
	   *
	   *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	   *     between all directive linking functions.
	   *
	   *   * `controller` - the directive's required controller instance(s) - Instances are shared
	   *     among all directives, which allows the directives to use the controllers as a communication
	   *     channel. The exact value depends on the directive's `require` property:
	   *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	   *       * `string`: the controller instance
	   *       * `array`: array of controller instances
	   *
	   *     If a required controller cannot be found, and it is optional, the instance is `null`,
	   *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	   *
	   *     Note that you can also require the directive's own controller - it will be made available like
	   *     any other controller.
	   *
	   *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	   *     This is the same as the `$transclude`
	   *     parameter of directive controllers, see there for details.
	   *     `function([scope], cloneLinkingFn, futureParentElement)`.
	   *
	   * #### Pre-linking function
	   *
	   * Executed before the child elements are linked. Not safe to do DOM transformation since the
	   * compiler linking function will fail to locate the correct elements for linking.
	   *
	   * #### Post-linking function
	   *
	   * Executed after the child elements are linked.
	   *
	   * Note that child elements that contain `templateUrl` directives will not have been compiled
	   * and linked since they are waiting for their template to load asynchronously and their own
	   * compilation and linking has been suspended until that occurs.
	   *
	   * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	   * for their async templates to be resolved.
	   *
	   *
	   * ### Transclusion
	   *
	   * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	   * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	   * scope from where they were taken.
	   *
	   * Transclusion is used (often with {@link ngTransclude}) to insert the
	   * original contents of a directive's element into a specified place in the template of the directive.
	   * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	   * content has access to the properties on the scope from which it was taken, even if the directive
	   * has isolated scope.
	   * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	   *
	   * This makes it possible for the widget to have private state for its template, while the transcluded
	   * content has access to its originating scope.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	   * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	   * </div>
	   *
	   * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	   * directive's element, the entire element or multiple parts of the element contents:
	   *
	   * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	   * * `'element'` - transclude the whole of the directive's element including any directives on this
	   *   element that defined at a lower priority than this directive. When used, the `template`
	   *   property is ignored.
	   * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	   *
	   * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
	   *
	   * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	   * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	   * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	   *
	   * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	   *
	   * If the element selector is prefixed with a `?` then that slot is optional.
	   *
	   * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	   * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	   *
	   * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	   * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	   * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	   * injectable into the directive's controller.
	   *
	   *
	   * #### Transclusion Functions
	   *
	   * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	   * function** to the directive's `link` function and `controller`. This transclusion function is a special
	   * **linking function** that will return the compiled contents linked to a new transclusion scope.
	   *
	   * <div class="alert alert-info">
	   * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	   * ngTransclude will deal with it for us.
	   * </div>
	   *
	   * If you want to manually control the insertion and removal of the transcluded content in your directive
	   * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
	   * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	   *
	   * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	   * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	   * content and the `scope` is the newly created transclusion scope, to which the clone is bound.
	   *
	   * <div class="alert alert-info">
	   * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	   * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	   * </div>
	   *
	   * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	   * attach function**:
	   *
	   * ```js
	   * var transcludedContent, transclusionScope;
	   *
	   * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	   * ```
	   *
	   * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	   * associated transclusion scope:
	   *
	   * ```js
	   * transcludedContent.remove();
	   * transclusionScope.$destroy();
	   * ```
	   *
	   * <div class="alert alert-info">
	   * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	   * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	   * then you are also responsible for calling `$destroy` on the transclusion scope.
	   * </div>
	   *
	   * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	   * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	   * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	   *
	   *
	   * #### Transclusion Scopes
	   *
	   * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	   * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	   * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	   * was taken.
	   *
	   * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	   * like this:
	   *
	   * ```html
	   * <div ng-app>
	   *   <div isolate>
	   *     <div transclusion>
	   *     </div>
	   *   </div>
	   * </div>
	   * ```
	   *
	   * The `$parent` scope hierarchy will look like this:
	   *
	   ```
	   - $rootScope
	   - isolate
	   - transclusion
	   ```
	   *
	   * but the scopes will inherit prototypically from different scopes to their `$parent`.
	   *
	   ```
	   - $rootScope
	   - transclusion
	   - isolate
	   ```
	   *
	   *
	   * ### Attributes
	   *
	   * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	   * `link()` or `compile()` functions. It has a variety of uses.
	   *
	   * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
	   *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
	   *   to the attributes.
	   *
	   * * *Directive inter-communication:* All directives share the same instance of the attributes
	   *   object which allows the directives to use the attributes object as inter directive
	   *   communication.
	   *
	   * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	   *   allowing other directives to read the interpolated value.
	   *
	   * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	   *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	   *   the only way to easily get the actual value because during the linking phase the interpolation
	   *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	   *
	   * ```js
	   * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	   * ```
	   *
	   * ## Example
	   *
	   * <div class="alert alert-warning">
	   * **Note**: Typically directives are registered with `module.directive`. The example below is
	   * to illustrate how `$compile` works.
	   * </div>
	   *
	   <example module="compileExample">
	   <file name="index.html">
	   <script>
	   angular.module('compileExample', [], function($compileProvider) {
	        // configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects the '$compile'
	        $compileProvider.directive('compile', function($compile) {
	          // directive factory creates a link function
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                 // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // when the 'compile' expression changes
	                // assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current
	                // scope.
	                // NOTE: we only compile .childNodes so that
	                // we don't get into infinite loop compiling ourselves
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	   .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'Angular';
	        $scope.html = 'Hello {{name}}';
	      }]);
	   </script>
	   <div ng-controller="GreeterController">
	   <input ng-model="name"> <br/>
	   <textarea ng-model="html"></textarea> <br/>
	   <div compile="html"></div>
	   </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello Angular'.
	       expect(output.getText()).toBe('Hello Angular');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('Angular!');
	     });
	   </file>
	   </example>
	
	   *
	   *
	   * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	   * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	   *
	   * <div class="alert alert-danger">
	   * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	   *   e.g. will not use the right outer scope. Please pass the transclude function as a
	   *   `parentBoundTranscludeFn` to the link function instead.
	   * </div>
	   *
	   * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	   *                 root element(s), not their children)
	   * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	   * (a DOM element/tree) to a scope. Where:
	   *
	   *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	   *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	   *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	   *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	   *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	   *
	   *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	   *      * `scope` - is the current scope with which the linking function is working with.
	   *
	   *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	   *  keys may be used to control linking behavior:
	   *
	   *      * `parentBoundTranscludeFn` - the transclude function made available to
	   *        directives; if given, it will be passed through to the link functions of
	   *        directives found in `element` during compilation.
	   *      * `transcludeControllers` - an object hash with keys that map controller names
	   *        to a hash with the key `instance`, which maps to the controller instance;
	   *        if given, it will make the controllers available to directives on the compileNode:
	   *        ```
	   *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	   *        ```
	   *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	   *        the cloned elements; only needed for transcludes that are allowed to contain non html
	   *        elements (e.g. SVG elements). See also the directive.controller property.
	   *
	   * Calling the linking function returns the element of the template. It is either the original
	   * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	   *
	   * After linking the view is not updated until after a call to $digest which typically is done by
	   * Angular automatically.
	   *
	   * If you need access to the bound view, there are two ways to do it:
	   *
	   * - If you are not asking the linking function to clone the template, create the DOM element(s)
	   *   before you send them to the compiler and keep this reference around.
	   *   ```js
	   *     var element = $compile('<p>{{total}}</p>')(scope);
	   *   ```
	   *
	   * - if on the other hand, you need the element to be cloned, the view reference from the original
	   *   example would not point to the clone, but rather to the original template that was cloned. In
	   *   this case, you can access the clone via the cloneAttachFn:
	   *   ```js
	   *     var templateElement = angular.element('<p>{{total}}</p>'),
	   *         scope = ....;
	   *
	   *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       //attach the clone to DOM document at the right place
	 *     });
	   *
	   *     //now we have reference to the cloned DOM via `clonedElement`
	   *   ```
	   *
	   *
	   * For information on how the compiler works, see the
	   * {@link guide/compiler Angular HTML Compiler} section of the Developer Guide.
	   */
	
	  var $compileMinErr = minErr('$compile');
	
	  function UNINITIALIZED_VALUE() {}
	  var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
	
	  /**
	   * @ngdoc provider
	   * @name $compileProvider
	   *
	   * @description
	   */
	  $CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	  function $CompileProvider($provide, $$sanitizeUriProvider) {
	    var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive\:\s*([\w\-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w\-]+)(?:\:([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	    // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	    // The assumption is that future DOM event attribute names will begin with
	    // 'on' and be composed of only English letters.
	    var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	    var bindingCache = createMap();
	
	    function parseIsolateBindings(scope, directiveName, isController) {
	      var LOCAL_REGEXP = /^\s*([@&<]|=(\*?))(\??)\s*(\w*)\s*$/;
	
	      var bindings = createMap();
	
	      forEach(scope, function(definition, scopeName) {
	        if (definition in bindingCache) {
	          bindings[scopeName] = bindingCache[definition];
	          return;
	        }
	        var match = definition.match(LOCAL_REGEXP);
	
	        if (!match) {
	          throw $compileMinErr('iscp',
	            "Invalid {3} for directive '{0}'." +
	            " Definition: {... {1}: '{2}' ...}",
	            directiveName, scopeName, definition,
	            (isController ? "controller bindings definition" :
	              "isolate scope definition"));
	        }
	
	        bindings[scopeName] = {
	          mode: match[1][0],
	          collection: match[2] === '*',
	          optional: match[3] === '?',
	          attrName: match[4] || scopeName
	        };
	        if (match[4]) {
	          bindingCache[definition] = bindings[scopeName];
	        }
	      });
	
	      return bindings;
	    }
	
	    function parseDirectiveBindings(directive, directiveName) {
	      var bindings = {
	        isolateScope: null,
	        bindToController: null
	      };
	      if (isObject(directive.scope)) {
	        if (directive.bindToController === true) {
	          bindings.bindToController = parseIsolateBindings(directive.scope,
	            directiveName, true);
	          bindings.isolateScope = {};
	        } else {
	          bindings.isolateScope = parseIsolateBindings(directive.scope,
	            directiveName, false);
	        }
	      }
	      if (isObject(directive.bindToController)) {
	        bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	      }
	      if (isObject(bindings.bindToController)) {
	        var controller = directive.controller;
	        var controllerAs = directive.controllerAs;
	        if (!controller) {
	          // There is no controller, there may or may not be a controllerAs property
	          throw $compileMinErr('noctrl',
	            "Cannot bind to controller without directive '{0}'s controller.",
	            directiveName);
	        } else if (!identifierForController(controller, controllerAs)) {
	          // There is a controller, but no identifier or controllerAs property
	          throw $compileMinErr('noident',
	            "Cannot bind to controller without identifier for directive '{0}'.",
	            directiveName);
	        }
	      }
	      return bindings;
	    }
	
	    function assertValidDirectiveName(name) {
	      var letter = name.charAt(0);
	      if (!letter || letter !== lowercase(letter)) {
	        throw $compileMinErr('baddir', "Directive/Component name '{0}' is invalid. The first character must be a lowercase letter", name);
	      }
	      if (name !== name.trim()) {
	        throw $compileMinErr('baddir',
	          "Directive/Component name '{0}' is invalid. The name should not contain leading or trailing whitespaces",
	          name);
	      }
	    }
	
	    function getDirectiveRequire(directive) {
	      var require = directive.require || (directive.controller && directive.name);
	
	      if (!isArray(require) && isObject(require)) {
	        forEach(require, function(value, key) {
	          var match = value.match(REQUIRE_PREFIX_REGEXP);
	          var name = value.substring(match[0].length);
	          if (!name) require[key] = match[0] + key;
	        });
	      }
	
	      return require;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $compileProvider#directive
	     * @kind function
	     *
	     * @description
	     * Register a new directive with the compiler.
	     *
	     * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
	     *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
	     *    names and the values are the factories.
	     * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	     *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	     * @returns {ng.$compileProvider} Self for chaining.
	     */
	    this.directive = function registerDirective(name, directiveFactory) {
	      assertNotHasOwnProperty(name, 'directive');
	      if (isString(name)) {
	        assertValidDirectiveName(name);
	        assertArg(directiveFactory, 'directiveFactory');
	        if (!hasDirectives.hasOwnProperty(name)) {
	          hasDirectives[name] = [];
	          $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	            function($injector, $exceptionHandler) {
	              var directives = [];
	              forEach(hasDirectives[name], function(directiveFactory, index) {
	                try {
	                  var directive = $injector.invoke(directiveFactory);
	                  if (isFunction(directive)) {
	                    directive = { compile: valueFn(directive) };
	                  } else if (!directive.compile && directive.link) {
	                    directive.compile = valueFn(directive.link);
	                  }
	                  directive.priority = directive.priority || 0;
	                  directive.index = index;
	                  directive.name = directive.name || name;
	                  directive.require = getDirectiveRequire(directive);
	                  directive.restrict = directive.restrict || 'EA';
	                  directive.$$moduleName = directiveFactory.$$moduleName;
	                  directives.push(directive);
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              });
	              return directives;
	            }]);
	        }
	        hasDirectives[name].push(directiveFactory);
	      } else {
	        forEach(name, reverseParams(registerDirective));
	      }
	      return this;
	    };
	
	    /**
	     * @ngdoc method
	     * @name $compileProvider#component
	     * @module ng
	     * @param {string} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`)
	     * @param {Object} options Component definition object (a simplified
	     *    {@link ng.$compile#directive-definition-object directive definition object}),
	     *    with the following properties (all optional):
	     *
	     *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	     *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	     *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	     *      If present, the controller will be published to scope under the `controllerAs` name.
	     *      If not present, this will default to be `$ctrl`.
	     *    - `template` – `{string=|function()=}` – html template as a string or a function that
	     *      returns an html template as a string which should be used as the contents of this component.
	     *      Empty string by default.
	     *
	     *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	     *      the following locals:
	     *
	     *      - `$element` - Current element
	     *      - `$attrs` - Current attributes object for the element
	     *
	     *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	     *      template that should be used  as the contents of this component.
	     *
	     *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	     *      the following locals:
	     *
	     *      - `$element` - Current element
	     *      - `$attrs` - Current attributes object for the element
	     *
	     *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	     *      Component properties are always bound to the component controller and not to the scope.
	     *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	     *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	     *      Disabled by default.
	     *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	     *      this component's controller. The object keys specify the property names under which the required
	     *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	     *    - `$...` – additional properties to attach to the directive factory function and the controller
	     *      constructor function. (This is used by the component router to annotate)
	     *
	     * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	     * @description
	     * Register a **component definition** with the compiler. This is a shorthand for registering a special
	     * type of directive, which represents a self-contained UI component in your application. Such components
	     * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	     *
	     * Component definitions are very simple and do not require as much configuration as defining general
	     * directives. Component definitions usually consist only of a template and a controller backing it.
	     *
	     * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	     * `bindToController`. They always have **isolate scope** and are restricted to elements.
	     *
	     * Here are a few examples of how you would usually define components:
	     *
	     * ```js
	     *   var myMod = angular.module(...);
	     *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	     *
	     *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	     *
	     *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	     *
	     * ```
	     * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	     *
	     * <br />
	     * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	     */
	    this.component = function registerComponent(name, options) {
	      var controller = options.controller || function() {};
	
	      function factory($injector) {
	        function makeInjectable(fn) {
	          if (isFunction(fn) || isArray(fn)) {
	            return function(tElement, tAttrs) {
	              return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
	            };
	          } else {
	            return fn;
	          }
	        }
	
	        var template = (!options.template && !options.templateUrl ? '' : options.template);
	        var ddo = {
	          controller: controller,
	          controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
	          template: makeInjectable(template),
	          templateUrl: makeInjectable(options.templateUrl),
	          transclude: options.transclude,
	          scope: {},
	          bindToController: options.bindings || {},
	          restrict: 'E',
	          require: options.require
	        };
	
	        // Copy annotations (starting with $) over to the DDO
	        forEach(options, function(val, key) {
	          if (key.charAt(0) === '$') ddo[key] = val;
	        });
	
	        return ddo;
	      }
	
	      // TODO(pete) remove the following `forEach` before we release 1.6.0
	      // The component-router@0.2.0 looks for the annotations on the controller constructor
	      // Nothing in Angular looks for annotations on the factory function but we can't remove
	      // it from 1.5.x yet.
	
	      // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	      // These could be used by libraries such as the new component router
	      forEach(options, function(val, key) {
	        if (key.charAt(0) === '$') {
	          factory[key] = val;
	          // Don't try to copy over annotations to named controller
	          if (isFunction(controller)) controller[key] = val;
	        }
	      });
	
	      factory.$inject = ['$injector'];
	
	      return this.directive(name, factory);
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $compileProvider#aHrefSanitizationWhitelist
	     * @kind function
	     *
	     * @description
	     * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	     * urls during a[href] sanitization.
	     *
	     * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	     *
	     * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	     * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	     * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	     * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	     *
	     * @param {RegExp=} regexp New regexp to whitelist urls with.
	     * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	     *    chaining otherwise.
	     */
	    this.aHrefSanitizationWhitelist = function(regexp) {
	      if (isDefined(regexp)) {
	        $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
	        return this;
	      } else {
	        return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
	      }
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $compileProvider#imgSrcSanitizationWhitelist
	     * @kind function
	     *
	     * @description
	     * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	     * urls during img[src] sanitization.
	     *
	     * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	     *
	     * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	     * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	     * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	     * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	     *
	     * @param {RegExp=} regexp New regexp to whitelist urls with.
	     * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	     *    chaining otherwise.
	     */
	    this.imgSrcSanitizationWhitelist = function(regexp) {
	      if (isDefined(regexp)) {
	        $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
	        return this;
	      } else {
	        return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name  $compileProvider#debugInfoEnabled
	     *
	     * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	     * current debugInfoEnabled state
	     * @returns {*} current value if used as getter or itself (chaining) if used as setter
	     *
	     * @kind function
	     *
	     * @description
	     * Call this method to enable/disable various debug runtime information in the compiler such as adding
	     * binding information and a reference to the current scope on to DOM elements.
	     * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	     * * `ng-binding` CSS class
	     * * `$binding` data property containing an array of the binding expressions
	     *
	     * You may want to disable this in production for a significant performance boost. See
	     * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	     *
	     * The default value is true.
	     */
	    var debugInfoEnabled = true;
	    this.debugInfoEnabled = function(enabled) {
	      if (isDefined(enabled)) {
	        debugInfoEnabled = enabled;
	        return this;
	      }
	      return debugInfoEnabled;
	    };
	
	
	    var TTL = 10;
	    /**
	     * @ngdoc method
	     * @name $compileProvider#onChangesTtl
	     * @description
	     *
	     * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	     * assuming that the model is unstable.
	     *
	     * The current default is 10 iterations.
	     *
	     * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	     * in several iterations of calls to these hooks. However if an application needs more than the default 10
	     * iterations to stabilize then you should investigate what is causing the model to continuously change during
	     * the `$onChanges` hook execution.
	     *
	     * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	     *
	     * @param {number} limit The number of `$onChanges` hook iterations.
	     * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	     */
	    this.onChangesTtl = function(value) {
	      if (arguments.length) {
	        TTL = value;
	        return this;
	      }
	      return TTL;
	    };
	
	    this.$get = [
	      '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	      '$controller', '$rootScope', '$sce', '$animate', '$$sanitizeUri',
	      function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	               $controller,   $rootScope,   $sce,   $animate,   $$sanitizeUri) {
	
	        var SIMPLE_ATTR_NAME = /^\w/;
	        var specialAttrHolder = window.document.createElement('div');
	
	
	
	        var onChangesTtl = TTL;
	        // The onChanges hooks should all be run together in a single digest
	        // When changes occur, the call to trigger their hooks will be added to this queue
	        var onChangesQueue;
	
	        // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	        function flushOnChangesQueue() {
	          try {
	            if (!(--onChangesTtl)) {
	              // We have hit the TTL limit so reset everything
	              onChangesQueue = undefined;
	              throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
	            }
	            // We must run this hook in an apply since the $$postDigest runs outside apply
	            $rootScope.$apply(function() {
	              for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
	                onChangesQueue[i]();
	              }
	              // Reset the queue to trigger a new schedule next time there is a change
	              onChangesQueue = undefined;
	            });
	          } finally {
	            onChangesTtl++;
	          }
	        }
	
	
	        function Attributes(element, attributesToCopy) {
	          if (attributesToCopy) {
	            var keys = Object.keys(attributesToCopy);
	            var i, l, key;
	
	            for (i = 0, l = keys.length; i < l; i++) {
	              key = keys[i];
	              this[key] = attributesToCopy[key];
	            }
	          } else {
	            this.$attr = {};
	          }
	
	          this.$$element = element;
	        }
	
	        Attributes.prototype = {
	          /**
	           * @ngdoc method
	           * @name $compile.directive.Attributes#$normalize
	           * @kind function
	           *
	           * @description
	           * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	           * `data-`) to its normalized, camelCase form.
	           *
	           * Also there is special case for Moz prefix starting with upper case letter.
	           *
	           * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	           *
	           * @param {string} name Name to normalize
	           */
	          $normalize: directiveNormalize,
	
	
	          /**
	           * @ngdoc method
	           * @name $compile.directive.Attributes#$addClass
	           * @kind function
	           *
	           * @description
	           * Adds the CSS class value specified by the classVal parameter to the element. If animations
	           * are enabled then an animation will be triggered for the class addition.
	           *
	           * @param {string} classVal The className value that will be added to the element
	           */
	          $addClass: function(classVal) {
	            if (classVal && classVal.length > 0) {
	              $animate.addClass(this.$$element, classVal);
	            }
	          },
	
	          /**
	           * @ngdoc method
	           * @name $compile.directive.Attributes#$removeClass
	           * @kind function
	           *
	           * @description
	           * Removes the CSS class value specified by the classVal parameter from the element. If
	           * animations are enabled then an animation will be triggered for the class removal.
	           *
	           * @param {string} classVal The className value that will be removed from the element
	           */
	          $removeClass: function(classVal) {
	            if (classVal && classVal.length > 0) {
	              $animate.removeClass(this.$$element, classVal);
	            }
	          },
	
	          /**
	           * @ngdoc method
	           * @name $compile.directive.Attributes#$updateClass
	           * @kind function
	           *
	           * @description
	           * Adds and removes the appropriate CSS class values to the element based on the difference
	           * between the new and old CSS class values (specified as newClasses and oldClasses).
	           *
	           * @param {string} newClasses The current CSS className value
	           * @param {string} oldClasses The former CSS className value
	           */
	          $updateClass: function(newClasses, oldClasses) {
	            var toAdd = tokenDifference(newClasses, oldClasses);
	            if (toAdd && toAdd.length) {
	              $animate.addClass(this.$$element, toAdd);
	            }
	
	            var toRemove = tokenDifference(oldClasses, newClasses);
	            if (toRemove && toRemove.length) {
	              $animate.removeClass(this.$$element, toRemove);
	            }
	          },
	
	          /**
	           * Set a normalized attribute on the element in a way such that all directives
	           * can share the attribute. This function properly handles boolean attributes.
	           * @param {string} key Normalized key. (ie ngAttribute)
	           * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	           * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	           *     Defaults to true.
	           * @param {string=} attrName Optional none normalized name. Defaults to key.
	           */
	          $set: function(key, value, writeAttr, attrName) {
	            // TODO: decide whether or not to throw an error if "class"
	            //is set through this function since it may cause $updateClass to
	            //become unstable.
	
	            var node = this.$$element[0],
	              booleanKey = getBooleanAttrName(node, key),
	              aliasedKey = getAliasedAttrName(key),
	              observer = key,
	              nodeName;
	
	            if (booleanKey) {
	              this.$$element.prop(key, value);
	              attrName = booleanKey;
	            } else if (aliasedKey) {
	              this[aliasedKey] = value;
	              observer = aliasedKey;
	            }
	
	            this[key] = value;
	
	            // translate normalized key to actual key
	            if (attrName) {
	              this.$attr[key] = attrName;
	            } else {
	              attrName = this.$attr[key];
	              if (!attrName) {
	                this.$attr[key] = attrName = snake_case(key, '-');
	              }
	            }
	
	            nodeName = nodeName_(this.$$element);
	
	            if ((nodeName === 'a' && (key === 'href' || key === 'xlinkHref')) ||
	              (nodeName === 'img' && key === 'src')) {
	              // sanitize a[href] and img[src] values
	              this[key] = value = $$sanitizeUri(value, key === 'src');
	            } else if (nodeName === 'img' && key === 'srcset' && isDefined(value)) {
	              // sanitize img[srcset] values
	              var result = "";
	
	              // first check if there are spaces because it's not the same pattern
	              var trimmedSrcset = trim(value);
	              //                (   999x   ,|   999w   ,|   ,|,   )
	              var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	              var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	              // split srcset into tuple of uri and descriptor except for the last item
	              var rawUris = trimmedSrcset.split(pattern);
	
	              // for each tuples
	              var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	              for (var i = 0; i < nbrUrisWith2parts; i++) {
	                var innerIdx = i * 2;
	                // sanitize the uri
	                result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
	                // add the descriptor
	                result += (" " + trim(rawUris[innerIdx + 1]));
	              }
	
	              // split the last item into uri and descriptor
	              var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	              // sanitize the last uri
	              result += $$sanitizeUri(trim(lastTuple[0]), true);
	
	              // and add the last descriptor if any
	              if (lastTuple.length === 2) {
	                result += (" " + trim(lastTuple[1]));
	              }
	              this[key] = value = result;
	            }
	
	            if (writeAttr !== false) {
	              if (value === null || isUndefined(value)) {
	                this.$$element.removeAttr(attrName);
	              } else {
	                if (SIMPLE_ATTR_NAME.test(attrName)) {
	                  this.$$element.attr(attrName, value);
	                } else {
	                  setSpecialAttr(this.$$element[0], attrName, value);
	                }
	              }
	            }
	
	            // fire observers
	            var $$observers = this.$$observers;
	            $$observers && forEach($$observers[observer], function(fn) {
	              try {
	                fn(value);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	          },
	
	
	          /**
	           * @ngdoc method
	           * @name $compile.directive.Attributes#$observe
	           * @kind function
	           *
	           * @description
	           * Observes an interpolated attribute.
	           *
	           * The observer function will be invoked once during the next `$digest` following
	           * compilation. The observer is then invoked whenever the interpolated value
	           * changes.
	           *
	           * @param {string} key Normalized key. (ie ngAttribute) .
	           * @param {function(interpolatedValue)} fn Function that will be called whenever
	           the interpolated value of the attribute changes.
	           *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	           * @returns {function()} Returns a deregistration function for this observer.
	           */
	          $observe: function(key, fn) {
	            var attrs = this,
	              $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	              listeners = ($$observers[key] || ($$observers[key] = []));
	
	            listeners.push(fn);
	            $rootScope.$evalAsync(function() {
	              if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	                // no one registered attribute interpolation function, so lets call it manually
	                fn(attrs[key]);
	              }
	            });
	
	            return function() {
	              arrayRemove(listeners, fn);
	            };
	          }
	        };
	
	        function setSpecialAttr(element, attrName, value) {
	          // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	          // so we have to jump through some hoops to get such an attribute
	          // https://github.com/angular/angular.js/pull/13318
	          specialAttrHolder.innerHTML = "<span " + attrName + ">";
	          var attributes = specialAttrHolder.firstChild.attributes;
	          var attribute = attributes[0];
	          // We have to remove the attribute from its container element before we can add it to the destination element
	          attributes.removeNamedItem(attribute.name);
	          attribute.value = value;
	          element.attributes.setNamedItem(attribute);
	        }
	
	        function safeAddClass($element, className) {
	          try {
	            $element.addClass(className);
	          } catch (e) {
	            // ignore, since it means that we are trying to set class on
	            // SVG element, where class name is read-only.
	          }
	        }
	
	
	        var startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          denormalizeTemplate = (startSymbol == '{{' && endSymbol  == '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	            return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	          },
	          NG_ATTR_BINDING = /^ngAttr[A-Z]/;
	        var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
	
	        compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	          var bindings = $element.data('$binding') || [];
	
	          if (isArray(binding)) {
	            bindings = bindings.concat(binding);
	          } else {
	            bindings.push(binding);
	          }
	
	          $element.data('$binding', bindings);
	        } : noop;
	
	        compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	          safeAddClass($element, 'ng-binding');
	        } : noop;
	
	        compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	          var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	          $element.data(dataName, scope);
	        } : noop;
	
	        compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	          safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	        } : noop;
	
	        compile.$$createComment = function(directiveName, comment) {
	          var content = '';
	          if (debugInfoEnabled) {
	            content = ' ' + (directiveName || '') + ': ';
	            if (comment) content += comment + ' ';
	          }
	          return window.document.createComment(content);
	        };
	
	        return compile;
	
	        //================================
	
	        function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                         previousCompileContext) {
	          if (!($compileNodes instanceof jqLite)) {
	            // jquery always rewraps, whereas we need to preserve the original selector so that we can
	            // modify it.
	            $compileNodes = jqLite($compileNodes);
	          }
	
	          var NOT_EMPTY = /\S+/;
	
	          // We can not compile top level text elements since text nodes can be merged and we will
	          // not be able to attach scope data to them, so we will wrap them in <span>
	          for (var i = 0, len = $compileNodes.length; i < len; i++) {
	            var domNode = $compileNodes[i];
	
	            if (domNode.nodeType === NODE_TYPE_TEXT && domNode.nodeValue.match(NOT_EMPTY) /* non-empty */) {
	              jqLiteWrapNode(domNode, $compileNodes[i] = window.document.createElement('span'));
	            }
	          }
	
	          var compositeLinkFn =
	            compileNodes($compileNodes, transcludeFn, $compileNodes,
	              maxPriority, ignoreDirective, previousCompileContext);
	          compile.$$addScopeClass($compileNodes);
	          var namespace = null;
	          return function publicLinkFn(scope, cloneConnectFn, options) {
	            assertArg(scope, 'scope');
	
	            if (previousCompileContext && previousCompileContext.needsNewScope) {
	              // A parent directive did a replace and a directive on this element asked
	              // for transclusion, which caused us to lose a layer of element on which
	              // we could hold the new transclusion scope, so we will create it manually
	              // here.
	              scope = scope.$parent.$new();
	            }
	
	            options = options || {};
	            var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	              transcludeControllers = options.transcludeControllers,
	              futureParentElement = options.futureParentElement;
	
	            // When `parentBoundTranscludeFn` is passed, it is a
	            // `controllersBoundTransclude` function (it was previously passed
	            // as `transclude` to directive.link) so we must unwrap it to get
	            // its `boundTranscludeFn`
	            if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	              parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	            }
	
	            if (!namespace) {
	              namespace = detectNamespaceForChildElements(futureParentElement);
	            }
	            var $linkNode;
	            if (namespace !== 'html') {
	              // When using a directive with replace:true and templateUrl the $compileNodes
	              // (or a child element inside of them)
	              // might change, so we need to recreate the namespace adapted compileNodes
	              // for call to the link function.
	              // Note: This will already clone the nodes...
	              $linkNode = jqLite(
	                wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
	              );
	            } else if (cloneConnectFn) {
	              // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	              // and sometimes changes the structure of the DOM.
	              $linkNode = JQLitePrototype.clone.call($compileNodes);
	            } else {
	              $linkNode = $compileNodes;
	            }
	
	            if (transcludeControllers) {
	              for (var controllerName in transcludeControllers) {
	                $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	              }
	            }
	
	            compile.$$addScopeInfo($linkNode, scope);
	
	            if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	            if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	            return $linkNode;
	          };
	        }
	
	        function detectNamespaceForChildElements(parentElement) {
	          // TODO: Make this detect MathML as well...
	          var node = parentElement && parentElement[0];
	          if (!node) {
	            return 'html';
	          } else {
	            return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
	          }
	        }
	
	        /**
	         * Compile function matches each node in nodeList against the directives. Once all directives
	         * for a particular node are collected their compile functions are executed. The compile
	         * functions return values - the linking functions - are combined into a composite linking
	         * function, which is the a linking function for the node.
	         *
	         * @param {NodeList} nodeList an array of nodes or NodeList to compile
	         * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	         *        scope argument is auto-generated to the new child of the transcluded parent scope.
	         * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	         *        the rootElement must be set the jqLite collection of the compile root. This is
	         *        needed so that the jqLite collection items can be replaced with widgets.
	         * @param {number=} maxPriority Max directive priority.
	         * @returns {Function} A composite linking function of all of the matched directives or null.
	         */
	        function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                              previousCompileContext) {
	          var linkFns = [],
	            attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	          for (var i = 0; i < nodeList.length; i++) {
	            attrs = new Attributes();
	
	            // we must always refer to nodeList[i] since the nodes can be replaced underneath us.
	            directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	              ignoreDirective);
	
	            nodeLinkFn = (directives.length)
	              ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	              null, [], [], previousCompileContext)
	              : null;
	
	            if (nodeLinkFn && nodeLinkFn.scope) {
	              compile.$$addScopeClass(attrs.$$element);
	            }
	
	            childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	            !(childNodes = nodeList[i].childNodes) ||
	            !childNodes.length)
	              ? null
	              : compileNodes(childNodes,
	              nodeLinkFn ? (
	              (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	              && nodeLinkFn.transclude) : transcludeFn);
	
	            if (nodeLinkFn || childLinkFn) {
	              linkFns.push(i, nodeLinkFn, childLinkFn);
	              linkFnFound = true;
	              nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	            }
	
	            //use the previous context only for the first element in the virtual group
	            previousCompileContext = null;
	          }
	
	          // return a linking function if we have found anything, null otherwise
	          return linkFnFound ? compositeLinkFn : null;
	
	          function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	            var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	            var stableNodeList;
	
	
	            if (nodeLinkFnFound) {
	              // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	              // offsets don't get screwed up
	              var nodeListLength = nodeList.length;
	              stableNodeList = new Array(nodeListLength);
	
	              // create a sparse array by only copying the elements which have a linkFn
	              for (i = 0; i < linkFns.length; i+=3) {
	                idx = linkFns[i];
	                stableNodeList[idx] = nodeList[idx];
	              }
	            } else {
	              stableNodeList = nodeList;
	            }
	
	            for (i = 0, ii = linkFns.length; i < ii;) {
	              node = stableNodeList[linkFns[i++]];
	              nodeLinkFn = linkFns[i++];
	              childLinkFn = linkFns[i++];
	
	              if (nodeLinkFn) {
	                if (nodeLinkFn.scope) {
	                  childScope = scope.$new();
	                  compile.$$addScopeInfo(jqLite(node), childScope);
	                } else {
	                  childScope = scope;
	                }
	
	                if (nodeLinkFn.transcludeOnThisElement) {
	                  childBoundTranscludeFn = createBoundTranscludeFn(
	                    scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	                } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	                  childBoundTranscludeFn = parentBoundTranscludeFn;
	
	                } else if (!parentBoundTranscludeFn && transcludeFn) {
	                  childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	                } else {
	                  childBoundTranscludeFn = null;
	                }
	
	                nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	              } else if (childLinkFn) {
	                childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	              }
	            }
	          }
	        }
	
	        function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	          function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	            if (!transcludedScope) {
	              transcludedScope = scope.$new(false, containingScope);
	              transcludedScope.$$transcluded = true;
	            }
	
	            return transcludeFn(transcludedScope, cloneFn, {
	              parentBoundTranscludeFn: previousBoundTranscludeFn,
	              transcludeControllers: controllers,
	              futureParentElement: futureParentElement
	            });
	          }
	
	          // We need  to attach the transclusion slots onto the `boundTranscludeFn`
	          // so that they are available inside the `controllersBoundTransclude` function
	          var boundSlots = boundTranscludeFn.$$slots = createMap();
	          for (var slotName in transcludeFn.$$slots) {
	            if (transcludeFn.$$slots[slotName]) {
	              boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
	            } else {
	              boundSlots[slotName] = null;
	            }
	          }
	
	          return boundTranscludeFn;
	        }
	
	        /**
	         * Looks for directives on the given node and adds them to the directive collection which is
	         * sorted.
	         *
	         * @param node Node to search.
	         * @param directives An array to which the directives are added to. This array is sorted before
	         *        the function returns.
	         * @param attrs The shared attrs object which is used to populate the normalized attributes.
	         * @param {number=} maxPriority Max directive priority.
	         */
	        function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	          var nodeType = node.nodeType,
	            attrsMap = attrs.$attr,
	            match,
	            className;
	
	          switch (nodeType) {
	            case NODE_TYPE_ELEMENT: /* Element */
	              // use the node name: <directive>
	              addDirective(directives,
	                directiveNormalize(nodeName_(node)), 'E', maxPriority, ignoreDirective);
	
	              // iterate over the attributes
	              for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
	                     j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	                var attrStartName = false;
	                var attrEndName = false;
	
	                attr = nAttrs[j];
	                name = attr.name;
	                value = trim(attr.value);
	
	                // support ngAttr attribute binding
	                ngAttrName = directiveNormalize(name);
	                if (isNgAttr = NG_ATTR_BINDING.test(ngAttrName)) {
	                  name = name.replace(PREFIX_REGEXP, '')
	                    .substr(8).replace(/_(.)/g, function(match, letter) {
	                      return letter.toUpperCase();
	                    });
	                }
	
	                var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
	                if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
	                  attrStartName = name;
	                  attrEndName = name.substr(0, name.length - 5) + 'end';
	                  name = name.substr(0, name.length - 6);
	                }
	
	                nName = directiveNormalize(name.toLowerCase());
	                attrsMap[nName] = name;
	                if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                  attrs[nName] = value;
	                  if (getBooleanAttrName(node, nName)) {
	                    attrs[nName] = true; // presence means true
	                  }
	                }
	                addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	                addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                  attrEndName);
	              }
	
	              // use class as directive
	              className = node.className;
	              if (isObject(className)) {
	                // Maybe SVGAnimatedString
	                className = className.animVal;
	              }
	              if (isString(className) && className !== '') {
	                while (match = CLASS_DIRECTIVE_REGEXP.exec(className)) {
	                  nName = directiveNormalize(match[2]);
	                  if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                    attrs[nName] = trim(match[3]);
	                  }
	                  className = className.substr(match.index + match[0].length);
	                }
	              }
	              break;
	            case NODE_TYPE_TEXT: /* Text Node */
	              if (msie === 11) {
	                // Workaround for #11781
	                while (node.parentNode && node.nextSibling && node.nextSibling.nodeType === NODE_TYPE_TEXT) {
	                  node.nodeValue = node.nodeValue + node.nextSibling.nodeValue;
	                  node.parentNode.removeChild(node.nextSibling);
	                }
	              }
	              addTextInterpolateDirective(directives, node.nodeValue);
	              break;
	            case NODE_TYPE_COMMENT: /* Comment */
	              try {
	                match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	                if (match) {
	                  nName = directiveNormalize(match[1]);
	                  if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	                    attrs[nName] = trim(match[2]);
	                  }
	                }
	              } catch (e) {
	                // turns out that under some circumstances IE9 throws errors when one attempts to read
	                // comment's node value.
	                // Just ignore it and continue. (Can't seem to reproduce in test case.)
	              }
	              break;
	          }
	
	          directives.sort(byPriority);
	          return directives;
	        }
	
	        /**
	         * Given a node with an directive-start it collects all of the siblings until it finds
	         * directive-end.
	         * @param node
	         * @param attrStart
	         * @param attrEnd
	         * @returns {*}
	         */
	        function groupScan(node, attrStart, attrEnd) {
	          var nodes = [];
	          var depth = 0;
	          if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	            do {
	              if (!node) {
	                throw $compileMinErr('uterdir',
	                  "Unterminated attribute, found '{0}' but no matching '{1}' found.",
	                  attrStart, attrEnd);
	              }
	              if (node.nodeType == NODE_TYPE_ELEMENT) {
	                if (node.hasAttribute(attrStart)) depth++;
	                if (node.hasAttribute(attrEnd)) depth--;
	              }
	              nodes.push(node);
	              node = node.nextSibling;
	            } while (depth > 0);
	          } else {
	            nodes.push(node);
	          }
	
	          return jqLite(nodes);
	        }
	
	        /**
	         * Wrapper for linking function which converts normal linking function into a grouped
	         * linking function.
	         * @param linkFn
	         * @param attrStart
	         * @param attrEnd
	         * @returns {Function}
	         */
	        function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	          return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
	            element = groupScan(element[0], attrStart, attrEnd);
	            return linkFn(scope, element, attrs, controllers, transcludeFn);
	          };
	        }
	
	        /**
	         * A function generator that is used to support both eager and lazy compilation
	         * linking function.
	         * @param eager
	         * @param $compileNodes
	         * @param transcludeFn
	         * @param maxPriority
	         * @param ignoreDirective
	         * @param previousCompileContext
	         * @returns {Function}
	         */
	        function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
	          var compiled;
	
	          if (eager) {
	            return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	          }
	          return function lazyCompilation() {
	            if (!compiled) {
	              compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	
	              // Null out all of these references in order to make them eligible for garbage collection
	              // since this is a potentially long lived closure
	              $compileNodes = transcludeFn = previousCompileContext = null;
	            }
	            return compiled.apply(this, arguments);
	          };
	        }
	
	        /**
	         * Once the directives have been collected, their compile functions are executed. This method
	         * is responsible for inlining directive templates as well as terminating the application
	         * of the directives if the terminal directive has been reached.
	         *
	         * @param {Array} directives Array of collected directives to execute their compile function.
	         *        this needs to be pre-sorted by priority order.
	         * @param {Node} compileNode The raw DOM node to apply the compile functions to
	         * @param {Object} templateAttrs The shared attribute function
	         * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	         *                                                  scope argument is auto-generated to the new
	         *                                                  child of the transcluded parent scope.
	         * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	         *                              argument has the root jqLite array so that we can replace nodes
	         *                              on it.
	         * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	         *                                           compiling the transclusion.
	         * @param {Array.<Function>} preLinkFns
	         * @param {Array.<Function>} postLinkFns
	         * @param {Object} previousCompileContext Context used for previous compilation of the current
	         *                                        node
	         * @returns {Function} linkFn
	         */
	        function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                       jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                       previousCompileContext) {
	          previousCompileContext = previousCompileContext || {};
	
	          var terminalPriority = -Number.MAX_VALUE,
	            newScopeDirective = previousCompileContext.newScopeDirective,
	            controllerDirectives = previousCompileContext.controllerDirectives,
	            newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	            templateDirective = previousCompileContext.templateDirective,
	            nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	            hasTranscludeDirective = false,
	            hasTemplate = false,
	            hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	            $compileNode = templateAttrs.$$element = jqLite(compileNode),
	            directive,
	            directiveName,
	            $template,
	            replaceDirective = originalReplaceDirective,
	            childTranscludeFn = transcludeFn,
	            linkFn,
	            didScanForMultipleTransclusion = false,
	            mightHaveMultipleTransclusionError = false,
	            directiveValue;
	
	          // executes all directives on the current element
	          for (var i = 0, ii = directives.length; i < ii; i++) {
	            directive = directives[i];
	            var attrStart = directive.$$start;
	            var attrEnd = directive.$$end;
	
	            // collect multiblock sections
	            if (attrStart) {
	              $compileNode = groupScan(compileNode, attrStart, attrEnd);
	            }
	            $template = undefined;
	
	            if (terminalPriority > directive.priority) {
	              break; // prevent further processing of directives
	            }
	
	            if (directiveValue = directive.scope) {
	
	              // skip the check for directives with async templates, we'll check the derived sync
	              // directive when the template arrives
	              if (!directive.templateUrl) {
	                if (isObject(directiveValue)) {
	                  // This directive is trying to add an isolated scope.
	                  // Check that there is no scope of any kind already
	                  assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                    directive, $compileNode);
	                  newIsolateScopeDirective = directive;
	                } else {
	                  // This directive is trying to add a child scope.
	                  // Check that there is no isolated scope already
	                  assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                    $compileNode);
	                }
	              }
	
	              newScopeDirective = newScopeDirective || directive;
	            }
	
	            directiveName = directive.name;
	
	            // If we encounter a condition that can result in transclusion on the directive,
	            // then scan ahead in the remaining directives for others that may cause a multiple
	            // transclusion error to be thrown during the compilation process.  If a matching directive
	            // is found, then we know that when we encounter a transcluded directive, we need to eagerly
	            // compile the `transclude` function rather than doing it lazily in order to throw
	            // exceptions at the correct time
	            if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
	              || (directive.transclude && !directive.$$tlb))) {
	              var candidateDirective;
	
	              for (var scanningIndex = i + 1; candidateDirective = directives[scanningIndex++];) {
	                if ((candidateDirective.transclude && !candidateDirective.$$tlb)
	                  || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
	                  mightHaveMultipleTransclusionError = true;
	                  break;
	                }
	              }
	
	              didScanForMultipleTransclusion = true;
	            }
	
	            if (!directive.templateUrl && directive.controller) {
	              directiveValue = directive.controller;
	              controllerDirectives = controllerDirectives || createMap();
	              assertNoDuplicate("'" + directiveName + "' controller",
	                controllerDirectives[directiveName], directive, $compileNode);
	              controllerDirectives[directiveName] = directive;
	            }
	
	            if (directiveValue = directive.transclude) {
	              hasTranscludeDirective = true;
	
	              // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	              // This option should only be used by directives that know how to safely handle element transclusion,
	              // where the transcluded nodes are added or replaced after linking.
	              if (!directive.$$tlb) {
	                assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	                nonTlbTranscludeDirective = directive;
	              }
	
	              if (directiveValue == 'element') {
	                hasElementTranscludeDirective = true;
	                terminalPriority = directive.priority;
	                $template = $compileNode;
	                $compileNode = templateAttrs.$$element =
	                  jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
	                compileNode = $compileNode[0];
	                replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	                // Support: Chrome < 50
	                // https://github.com/angular/angular.js/issues/14041
	
	                // In the versions of V8 prior to Chrome 50, the document fragment that is created
	                // in the `replaceWith` function is improperly garbage collected despite still
	                // being referenced by the `parentNode` property of all of the child nodes.  By adding
	                // a reference to the fragment via a different property, we can avoid that incorrect
	                // behavior.
	                // TODO: remove this line after Chrome 50 has been released
	                $template[0].$$parentNode = $template[0].parentNode;
	
	                childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
	                  replaceDirective && replaceDirective.name, {
	                    // Don't pass in:
	                    // - controllerDirectives - otherwise we'll create duplicates controllers
	                    // - newIsolateScopeDirective or templateDirective - combining templates with
	                    //   element transclusion doesn't make sense.
	                    //
	                    // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                    // on the same element more than once.
	                    nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                  });
	              } else {
	
	                var slots = createMap();
	
	                $template = jqLite(jqLiteClone(compileNode)).contents();
	
	                if (isObject(directiveValue)) {
	
	                  // We have transclusion slots,
	                  // collect them up, compile them and store their transclusion functions
	                  $template = [];
	
	                  var slotMap = createMap();
	                  var filledSlots = createMap();
	
	                  // Parse the element selectors
	                  forEach(directiveValue, function(elementSelector, slotName) {
	                    // If an element selector starts with a ? then it is optional
	                    var optional = (elementSelector.charAt(0) === '?');
	                    elementSelector = optional ? elementSelector.substring(1) : elementSelector;
	
	                    slotMap[elementSelector] = slotName;
	
	                    // We explicitly assign `null` since this implies that a slot was defined but not filled.
	                    // Later when calling boundTransclusion functions with a slot name we only error if the
	                    // slot is `undefined`
	                    slots[slotName] = null;
	
	                    // filledSlots contains `true` for all slots that are either optional or have been
	                    // filled. This is used to check that we have not missed any required slots
	                    filledSlots[slotName] = optional;
	                  });
	
	                  // Add the matching elements into their slot
	                  forEach($compileNode.contents(), function(node) {
	                    var slotName = slotMap[directiveNormalize(nodeName_(node))];
	                    if (slotName) {
	                      filledSlots[slotName] = true;
	                      slots[slotName] = slots[slotName] || [];
	                      slots[slotName].push(node);
	                    } else {
	                      $template.push(node);
	                    }
	                  });
	
	                  // Check for required slots that were not filled
	                  forEach(filledSlots, function(filled, slotName) {
	                    if (!filled) {
	                      throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
	                    }
	                  });
	
	                  for (var slotName in slots) {
	                    if (slots[slotName]) {
	                      // Only define a transclusion function if the slot was filled
	                      slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
	                    }
	                  }
	                }
	
	                $compileNode.empty(); // clear contents
	                childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
	                  undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
	                childTranscludeFn.$$slots = slots;
	              }
	            }
	
	            if (directive.template) {
	              hasTemplate = true;
	              assertNoDuplicate('template', templateDirective, directive, $compileNode);
	              templateDirective = directive;
	
	              directiveValue = (isFunction(directive.template))
	                ? directive.template($compileNode, templateAttrs)
	                : directive.template;
	
	              directiveValue = denormalizeTemplate(directiveValue);
	
	              if (directive.replace) {
	                replaceDirective = directive;
	                if (jqLiteIsTextNode(directiveValue)) {
	                  $template = [];
	                } else {
	                  $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	                }
	                compileNode = $template[0];
	
	                if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	                  throw $compileMinErr('tplrt',
	                    "Template for directive '{0}' must have exactly one root element. {1}",
	                    directiveName, '');
	                }
	
	                replaceWith(jqCollection, $compileNode, compileNode);
	
	                var newTemplateAttrs = {$attr: {}};
	
	                // combine directives from the original node and from the template:
	                // - take the array of directives for this element
	                // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	                // - collect directives from the template and sort them by priority
	                // - combine directives as: processed + template + unprocessed
	                var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	                var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	                if (newIsolateScopeDirective || newScopeDirective) {
	                  // The original directive caused the current element to be replaced but this element
	                  // also needs to have a new scope, so we need to tell the template directives
	                  // that they would need to get their scope from further up, if they require transclusion
	                  markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
	                }
	                directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	                mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	                ii = directives.length;
	              } else {
	                $compileNode.html(directiveValue);
	              }
	            }
	
	            if (directive.templateUrl) {
	              hasTemplate = true;
	              assertNoDuplicate('template', templateDirective, directive, $compileNode);
	              templateDirective = directive;
	
	              if (directive.replace) {
	                replaceDirective = directive;
	              }
	
	              /* jshint -W021 */
	              nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	                /* jshint +W021 */
	                templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                  controllerDirectives: controllerDirectives,
	                  newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                  newIsolateScopeDirective: newIsolateScopeDirective,
	                  templateDirective: templateDirective,
	                  nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                });
	              ii = directives.length;
	            } else if (directive.compile) {
	              try {
	                linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	                var context = directive.$$originalDirective || directive;
	                if (isFunction(linkFn)) {
	                  addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
	                } else if (linkFn) {
	                  addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
	                }
	              } catch (e) {
	                $exceptionHandler(e, startingTag($compileNode));
	              }
	            }
	
	            if (directive.terminal) {
	              nodeLinkFn.terminal = true;
	              terminalPriority = Math.max(terminalPriority, directive.priority);
	            }
	
	          }
	
	          nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	          nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	          nodeLinkFn.templateOnThisElement = hasTemplate;
	          nodeLinkFn.transclude = childTranscludeFn;
	
	          previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	          // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	          return nodeLinkFn;
	
	          ////////////////////
	
	          function addLinkFns(pre, post, attrStart, attrEnd) {
	            if (pre) {
	              if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	              pre.require = directive.require;
	              pre.directiveName = directiveName;
	              if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	                pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	              }
	              preLinkFns.push(pre);
	            }
	            if (post) {
	              if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	              post.require = directive.require;
	              post.directiveName = directiveName;
	              if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	                post = cloneAndAnnotateFn(post, {isolateScope: true});
	              }
	              postLinkFns.push(post);
	            }
	          }
	
	          function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	            var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
	              attrs, scopeBindingInfo;
	
	            if (compileNode === linkNode) {
	              attrs = templateAttrs;
	              $element = templateAttrs.$$element;
	            } else {
	              $element = jqLite(linkNode);
	              attrs = new Attributes($element, templateAttrs);
	            }
	
	            controllerScope = scope;
	            if (newIsolateScopeDirective) {
	              isolateScope = scope.$new(true);
	            } else if (newScopeDirective) {
	              controllerScope = scope.$parent;
	            }
	
	            if (boundTranscludeFn) {
	              // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	              // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	              transcludeFn = controllersBoundTransclude;
	              transcludeFn.$$boundTransclude = boundTranscludeFn;
	              // expose the slots on the `$transclude` function
	              transcludeFn.isSlotFilled = function(slotName) {
	                return !!boundTranscludeFn.$$slots[slotName];
	              };
	            }
	
	            if (controllerDirectives) {
	              elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
	            }
	
	            if (newIsolateScopeDirective) {
	              // Initialize isolate scope bindings for new isolate scope directive.
	              compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	              compile.$$addScopeClass($element, true);
	              isolateScope.$$isolateBindings =
	                newIsolateScopeDirective.$$isolateBindings;
	              scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
	                isolateScope.$$isolateBindings,
	                newIsolateScopeDirective);
	              if (scopeBindingInfo.removeWatches) {
	                isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
	              }
	            }
	
	            // Initialize bindToController bindings
	            for (var name in elementControllers) {
	              var controllerDirective = controllerDirectives[name];
	              var controller = elementControllers[name];
	              var bindings = controllerDirective.$$bindings.bindToController;
	
	              if (controller.identifier && bindings) {
	                controller.bindingInfo =
	                  initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	              } else {
	                controller.bindingInfo = {};
	              }
	
	              var controllerResult = controller();
	              if (controllerResult !== controller.instance) {
	                // If the controller constructor has a return value, overwrite the instance
	                // from setupControllers
	                controller.instance = controllerResult;
	                $element.data('$' + controllerDirective.name + 'Controller', controllerResult);
	                controller.bindingInfo.removeWatches && controller.bindingInfo.removeWatches();
	                controller.bindingInfo =
	                  initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	              }
	            }
	
	            // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	            forEach(controllerDirectives, function(controllerDirective, name) {
	              var require = controllerDirective.require;
	              if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
	                extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
	              }
	            });
	
	            // Handle the init and destroy lifecycle hooks on all controllers that have them
	            forEach(elementControllers, function(controller) {
	              var controllerInstance = controller.instance;
	              if (isFunction(controllerInstance.$onChanges)) {
	                controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
	              }
	              if (isFunction(controllerInstance.$onInit)) {
	                controllerInstance.$onInit();
	              }
	              if (isFunction(controllerInstance.$onDestroy)) {
	                controllerScope.$on('$destroy', function callOnDestroyHook() {
	                  controllerInstance.$onDestroy();
	                });
	              }
	            });
	
	            // PRELINKING
	            for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	              linkFn = preLinkFns[i];
	              invokeLinkFn(linkFn,
	                linkFn.isolateScope ? isolateScope : scope,
	                $element,
	                attrs,
	                linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	                transcludeFn
	              );
	            }
	
	            // RECURSION
	            // We only pass the isolate scope, if the isolate directive has a template,
	            // otherwise the child elements do not belong to the isolate directive.
	            var scopeToChild = scope;
	            if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	              scopeToChild = isolateScope;
	            }
	            childLinkFn && childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	
	            // POSTLINKING
	            for (i = postLinkFns.length - 1; i >= 0; i--) {
	              linkFn = postLinkFns[i];
	              invokeLinkFn(linkFn,
	                linkFn.isolateScope ? isolateScope : scope,
	                $element,
	                attrs,
	                linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	                transcludeFn
	              );
	            }
	
	            // Trigger $postLink lifecycle hooks
	            forEach(elementControllers, function(controller) {
	              var controllerInstance = controller.instance;
	              if (isFunction(controllerInstance.$postLink)) {
	                controllerInstance.$postLink();
	              }
	            });
	
	            // This is the function that is injected as `$transclude`.
	            // Note: all arguments are optional!
	            function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
	              var transcludeControllers;
	              // No scope passed in:
	              if (!isScope(scope)) {
	                slotName = futureParentElement;
	                futureParentElement = cloneAttachFn;
	                cloneAttachFn = scope;
	                scope = undefined;
	              }
	
	              if (hasElementTranscludeDirective) {
	                transcludeControllers = elementControllers;
	              }
	              if (!futureParentElement) {
	                futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	              }
	              if (slotName) {
	                // slotTranscludeFn can be one of three things:
	                //  * a transclude function - a filled slot
	                //  * `null` - an optional slot that was not filled
	                //  * `undefined` - a slot that was not declared (i.e. invalid)
	                var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
	                if (slotTranscludeFn) {
	                  return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	                } else if (isUndefined(slotTranscludeFn)) {
	                  throw $compileMinErr('noslot',
	                    'No parent directive that requires a transclusion with slot name "{0}". ' +
	                    'Element: {1}',
	                    slotName, startingTag($element));
	                }
	              } else {
	                return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	              }
	            }
	          }
	        }
	
	        function getControllers(directiveName, require, $element, elementControllers) {
	          var value;
	
	          if (isString(require)) {
	            var match = require.match(REQUIRE_PREFIX_REGEXP);
	            var name = require.substring(match[0].length);
	            var inheritType = match[1] || match[3];
	            var optional = match[2] === '?';
	
	            //If only parents then start at the parent element
	            if (inheritType === '^^') {
	              $element = $element.parent();
	              //Otherwise attempt getting the controller from elementControllers in case
	              //the element is transcluded (and has no data) and to avoid .data if possible
	            } else {
	              value = elementControllers && elementControllers[name];
	              value = value && value.instance;
	            }
	
	            if (!value) {
	              var dataName = '$' + name + 'Controller';
	              value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	            }
	
	            if (!value && !optional) {
	              throw $compileMinErr('ctreq',
	                "Controller '{0}', required by directive '{1}', can't be found!",
	                name, directiveName);
	            }
	          } else if (isArray(require)) {
	            value = [];
	            for (var i = 0, ii = require.length; i < ii; i++) {
	              value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	            }
	          } else if (isObject(require)) {
	            value = {};
	            forEach(require, function(controller, property) {
	              value[property] = getControllers(directiveName, controller, $element, elementControllers);
	            });
	          }
	
	          return value || null;
	        }
	
	        function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
	          var elementControllers = createMap();
	          for (var controllerKey in controllerDirectives) {
	            var directive = controllerDirectives[controllerKey];
	            var locals = {
	              $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	              $element: $element,
	              $attrs: attrs,
	              $transclude: transcludeFn
	            };
	
	            var controller = directive.controller;
	            if (controller == '@') {
	              controller = attrs[directive.name];
	            }
	
	            var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	            // For directives with element transclusion the element is a comment.
	            // In this case .data will not attach any data.
	            // Instead, we save the controllers for the element in a local hash and attach to .data
	            // later, once we have the actual element.
	            elementControllers[directive.name] = controllerInstance;
	            $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	          }
	          return elementControllers;
	        }
	
	        // Depending upon the context in which a directive finds itself it might need to have a new isolated
	        // or child scope created. For instance:
	        // * if the directive has been pulled into a template because another directive with a higher priority
	        // asked for element transclusion
	        // * if the directive itself asks for transclusion but it is at the root of a template and the original
	        // element was replaced. See https://github.com/angular/angular.js/issues/12936
	        function markDirectiveScope(directives, isolateScope, newScope) {
	          for (var j = 0, jj = directives.length; j < jj; j++) {
	            directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
	          }
	        }
	
	        /**
	         * looks up the directive and decorates it with exception handling and proper parameters. We
	         * call this the boundDirective.
	         *
	         * @param {string} name name of the directive to look up.
	         * @param {string} location The directive must be found in specific format.
	         *   String containing any of theses characters:
	         *
	         *   * `E`: element name
	         *   * `A': attribute
	         *   * `C`: class
	         *   * `M`: comment
	         * @returns {boolean} true if directive was added.
	         */
	        function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                              endAttrName) {
	          if (name === ignoreDirective) return null;
	          var match = null;
	          if (hasDirectives.hasOwnProperty(name)) {
	            for (var directive, directives = $injector.get(name + Suffix),
	                   i = 0, ii = directives.length; i < ii; i++) {
	              try {
	                directive = directives[i];
	                if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
	                  directive.restrict.indexOf(location) != -1) {
	                  if (startAttrName) {
	                    directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	                  }
	                  if (!directive.$$bindings) {
	                    var bindings = directive.$$bindings =
	                      parseDirectiveBindings(directive, directive.name);
	                    if (isObject(bindings.isolateScope)) {
	                      directive.$$isolateBindings = bindings.isolateScope;
	                    }
	                  }
	                  tDirectives.push(directive);
	                  match = directive;
	                }
	              } catch (e) { $exceptionHandler(e); }
	            }
	          }
	          return match;
	        }
	
	
	        /**
	         * looks up the directive and returns true if it is a multi-element directive,
	         * and therefore requires DOM nodes between -start and -end markers to be grouped
	         * together.
	         *
	         * @param {string} name name of the directive to look up.
	         * @returns true if directive was registered as multi-element.
	         */
	        function directiveIsMultiElement(name) {
	          if (hasDirectives.hasOwnProperty(name)) {
	            for (var directive, directives = $injector.get(name + Suffix),
	                   i = 0, ii = directives.length; i < ii; i++) {
	              directive = directives[i];
	              if (directive.multiElement) {
	                return true;
	              }
	            }
	          }
	          return false;
	        }
	
	        /**
	         * When the element is replaced with HTML template then the new attributes
	         * on the template need to be merged with the existing attributes in the DOM.
	         * The desired effect is to have both of the attributes present.
	         *
	         * @param {object} dst destination attributes (original DOM)
	         * @param {object} src source attributes (from the directive template)
	         */
	        function mergeTemplateAttributes(dst, src) {
	          var srcAttr = src.$attr,
	            dstAttr = dst.$attr,
	            $element = dst.$$element;
	
	          // reapply the old attributes to the new element
	          forEach(dst, function(value, key) {
	            if (key.charAt(0) != '$') {
	              if (src[key] && src[key] !== value) {
	                value += (key === 'style' ? ';' : ' ') + src[key];
	              }
	              dst.$set(key, value, true, srcAttr[key]);
	            }
	          });
	
	          // copy the new attributes on the old attrs object
	          forEach(src, function(value, key) {
	            if (key == 'class') {
	              safeAddClass($element, value);
	              dst['class'] = (dst['class'] ? dst['class'] + ' ' : '') + value;
	            } else if (key == 'style') {
	              $element.attr('style', $element.attr('style') + ';' + value);
	              dst['style'] = (dst['style'] ? dst['style'] + ';' : '') + value;
	              // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	              // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	              // have an attribute like "has-own-property" or "data-has-own-property", etc.
	            } else if (key.charAt(0) != '$' && !dst.hasOwnProperty(key)) {
	              dst[key] = value;
	              dstAttr[key] = srcAttr[key];
	            }
	          });
	        }
	
	
	        function compileTemplateUrl(directives, $compileNode, tAttrs,
	                                    $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	          var linkQueue = [],
	            afterTemplateNodeLinkFn,
	            afterTemplateChildLinkFn,
	            beforeTemplateCompileNode = $compileNode[0],
	            origAsyncDirective = directives.shift(),
	            derivedSyncDirective = inherit(origAsyncDirective, {
	              templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	            }),
	            templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	            templateNamespace = origAsyncDirective.templateNamespace;
	
	          $compileNode.empty();
	
	          $templateRequest(templateUrl)
	            .then(function(content) {
	              var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	              content = denormalizeTemplate(content);
	
	              if (origAsyncDirective.replace) {
	                if (jqLiteIsTextNode(content)) {
	                  $template = [];
	                } else {
	                  $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	                }
	                compileNode = $template[0];
	
	                if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	                  throw $compileMinErr('tplrt',
	                    "Template for directive '{0}' must have exactly one root element. {1}",
	                    origAsyncDirective.name, templateUrl);
	                }
	
	                tempTemplateAttrs = {$attr: {}};
	                replaceWith($rootElement, $compileNode, compileNode);
	                var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	                if (isObject(origAsyncDirective.scope)) {
	                  // the original directive that caused the template to be loaded async required
	                  // an isolate scope
	                  markDirectiveScope(templateDirectives, true);
	                }
	                directives = templateDirectives.concat(directives);
	                mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	              } else {
	                compileNode = beforeTemplateCompileNode;
	                $compileNode.html(content);
	              }
	
	              directives.unshift(derivedSyncDirective);
	
	              afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	                childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	                previousCompileContext);
	              forEach($rootElement, function(node, i) {
	                if (node == compileNode) {
	                  $rootElement[i] = $compileNode[0];
	                }
	              });
	              afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	              while (linkQueue.length) {
	                var scope = linkQueue.shift(),
	                  beforeTemplateLinkNode = linkQueue.shift(),
	                  linkRootElement = linkQueue.shift(),
	                  boundTranscludeFn = linkQueue.shift(),
	                  linkNode = $compileNode[0];
	
	                if (scope.$$destroyed) continue;
	
	                if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	                  var oldClasses = beforeTemplateLinkNode.className;
	
	                  if (!(previousCompileContext.hasElementTranscludeDirective &&
	                    origAsyncDirective.replace)) {
	                    // it was cloned therefore we have to clone as well.
	                    linkNode = jqLiteClone(compileNode);
	                  }
	                  replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	                  // Copy in CSS classes from original node
	                  safeAddClass(jqLite(linkNode), oldClasses);
	                }
	                if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	                  childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	                } else {
	                  childBoundTranscludeFn = boundTranscludeFn;
	                }
	                afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	                  childBoundTranscludeFn);
	              }
	              linkQueue = null;
	            });
	
	          return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	            var childBoundTranscludeFn = boundTranscludeFn;
	            if (scope.$$destroyed) return;
	            if (linkQueue) {
	              linkQueue.push(scope,
	                node,
	                rootElement,
	                childBoundTranscludeFn);
	            } else {
	              if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	                childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	              }
	              afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	            }
	          };
	        }
	
	
	        /**
	         * Sorting function for bound directives.
	         */
	        function byPriority(a, b) {
	          var diff = b.priority - a.priority;
	          if (diff !== 0) return diff;
	          if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	          return a.index - b.index;
	        }
	
	        function assertNoDuplicate(what, previousDirective, directive, element) {
	
	          function wrapModuleNameIfDefined(moduleName) {
	            return moduleName ?
	              (' (module: ' + moduleName + ')') :
	              '';
	          }
	
	          if (previousDirective) {
	            throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	              previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	              directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	          }
	        }
	
	
	        function addTextInterpolateDirective(directives, text) {
	          var interpolateFn = $interpolate(text, true);
	          if (interpolateFn) {
	            directives.push({
	              priority: 0,
	              compile: function textInterpolateCompileFn(templateNode) {
	                var templateNodeParent = templateNode.parent(),
	                  hasCompileParent = !!templateNodeParent.length;
	
	                // When transcluding a template that has bindings in the root
	                // we don't have a parent and thus need to add the class during linking fn.
	                if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	                return function textInterpolateLinkFn(scope, node) {
	                  var parent = node.parent();
	                  if (!hasCompileParent) compile.$$addBindingClass(parent);
	                  compile.$$addBindingInfo(parent, interpolateFn.expressions);
	                  scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                    node[0].nodeValue = value;
	                  });
	                };
	              }
	            });
	          }
	        }
	
	
	        function wrapTemplate(type, template) {
	          type = lowercase(type || 'html');
	          switch (type) {
	            case 'svg':
	            case 'math':
	              var wrapper = window.document.createElement('div');
	              wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	              return wrapper.childNodes[0].childNodes;
	            default:
	              return template;
	          }
	        }
	
	
	        function getTrustedContext(node, attrNormalizedName) {
	          if (attrNormalizedName == "srcdoc") {
	            return $sce.HTML;
	          }
	          var tag = nodeName_(node);
	          // maction[xlink:href] can source SVG.  It's not limited to <maction>.
	          if (attrNormalizedName == "xlinkHref" ||
	            (tag == "form" && attrNormalizedName == "action") ||
	            (tag != "img" && (attrNormalizedName == "src" ||
	            attrNormalizedName == "ngSrc"))) {
	            return $sce.RESOURCE_URL;
	          }
	        }
	
	
	        function addAttrInterpolateDirective(node, directives, value, name, allOrNothing) {
	          var trustedContext = getTrustedContext(node, name);
	          allOrNothing = ALL_OR_NOTHING_ATTRS[name] || allOrNothing;
	
	          var interpolateFn = $interpolate(value, true, trustedContext, allOrNothing);
	
	          // no interpolation found -> ignore
	          if (!interpolateFn) return;
	
	
	          if (name === "multiple" && nodeName_(node) === "select") {
	            throw $compileMinErr("selmulti",
	              "Binding to the 'multiple' attribute is not supported. Element: {0}",
	              startingTag(node));
	          }
	
	          directives.push({
	            priority: 100,
	            compile: function() {
	              return {
	                pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                  var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
	
	                  if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	                    throw $compileMinErr('nodomevents',
	                      "Interpolations for HTML DOM event attributes are disallowed.  Please use the " +
	                      "ng- versions (such as ng-click instead of onclick) instead.");
	                  }
	
	                  // If the attribute has changed since last $interpolate()ed
	                  var newValue = attr[name];
	                  if (newValue !== value) {
	                    // we need to interpolate again since the attribute value has been updated
	                    // (e.g. by another directive's compile function)
	                    // ensure unset/empty values make interpolateFn falsy
	                    interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                    value = newValue;
	                  }
	
	                  // if attribute was updated so that there is no interpolation going on we don't want to
	                  // register any observers
	                  if (!interpolateFn) return;
	
	                  // initialize attr object so that it's ready in case we need the value for isolate
	                  // scope initialization, otherwise the value would not be available from isolate
	                  // directive's linking fn during linking phase
	                  attr[name] = interpolateFn(scope);
	
	                  ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                  (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue != oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	                }
	              };
	            }
	          });
	        }
	
	
	        /**
	         * This is a special jqLite.replaceWith, which can replace items which
	         * have no parents, provided that the containing jqLite collection is provided.
	         *
	         * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	         *                               in the root of the tree.
	         * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	         *                                  the shell, but replace its DOM node reference.
	         * @param {Node} newNode The new DOM node.
	         */
	        function replaceWith($rootElement, elementsToRemove, newNode) {
	          var firstElementToRemove = elementsToRemove[0],
	            removeCount = elementsToRemove.length,
	            parent = firstElementToRemove.parentNode,
	            i, ii;
	
	          if ($rootElement) {
	            for (i = 0, ii = $rootElement.length; i < ii; i++) {
	              if ($rootElement[i] == firstElementToRemove) {
	                $rootElement[i++] = newNode;
	                for (var j = i, j2 = j + removeCount - 1,
	                       jj = $rootElement.length;
	                     j < jj; j++, j2++) {
	                  if (j2 < jj) {
	                    $rootElement[j] = $rootElement[j2];
	                  } else {
	                    delete $rootElement[j];
	                  }
	                }
	                $rootElement.length -= removeCount - 1;
	
	                // If the replaced element is also the jQuery .context then replace it
	                // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	                // http://api.jquery.com/context/
	                if ($rootElement.context === firstElementToRemove) {
	                  $rootElement.context = newNode;
	                }
	                break;
	              }
	            }
	          }
	
	          if (parent) {
	            parent.replaceChild(newNode, firstElementToRemove);
	          }
	
	          // Append all the `elementsToRemove` to a fragment. This will...
	          // - remove them from the DOM
	          // - allow them to still be traversed with .nextSibling
	          // - allow a single fragment.qSA to fetch all elements being removed
	          var fragment = window.document.createDocumentFragment();
	          for (i = 0; i < removeCount; i++) {
	            fragment.appendChild(elementsToRemove[i]);
	          }
	
	          if (jqLite.hasData(firstElementToRemove)) {
	            // Copy over user data (that includes Angular's $scope etc.). Don't copy private
	            // data here because there's no public interface in jQuery to do that and copying over
	            // event listeners (which is the main use of private data) wouldn't work anyway.
	            jqLite.data(newNode, jqLite.data(firstElementToRemove));
	
	            // Remove $destroy event listeners from `firstElementToRemove`
	            jqLite(firstElementToRemove).off('$destroy');
	          }
	
	          // Cleanup any data/listeners on the elements and children.
	          // This includes invoking the $destroy event on any elements with listeners.
	          jqLite.cleanData(fragment.querySelectorAll('*'));
	
	          // Update the jqLite collection to only contain the `newNode`
	          for (i = 1; i < removeCount; i++) {
	            delete elementsToRemove[i];
	          }
	          elementsToRemove[0] = newNode;
	          elementsToRemove.length = 1;
	        }
	
	
	        function cloneAndAnnotateFn(fn, annotation) {
	          return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	        }
	
	
	        function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	          try {
	            linkFn(scope, $element, attrs, controllers, transcludeFn);
	          } catch (e) {
	            $exceptionHandler(e, startingTag($element));
	          }
	        }
	
	
	        // Set up $watches for isolate scope and controller bindings. This process
	        // only occurs for isolate scopes and new scopes with controllerAs.
	        function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
	          var removeWatchCollection = [];
	          var initialChanges = {};
	          var changes;
	          forEach(bindings, function initializeBinding(definition, scopeName) {
	            var attrName = definition.attrName,
	              optional = definition.optional,
	              mode = definition.mode, // @, =, or &
	              lastValue,
	              parentGet, parentSet, compare, removeWatch;
	
	            switch (mode) {
	
	              case '@':
	                if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	                  destination[scopeName] = attrs[attrName] = void 0;
	                }
	                attrs.$observe(attrName, function(value) {
	                  if (isString(value) || isBoolean(value)) {
	                    var oldValue = destination[scopeName];
	                    recordChanges(scopeName, value, oldValue);
	                    destination[scopeName] = value;
	                  }
	                });
	                attrs.$$observers[attrName].$$scope = scope;
	                lastValue = attrs[attrName];
	                if (isString(lastValue)) {
	                  // If the attribute has been provided then we trigger an interpolation to ensure
	                  // the value is there for use in the link fn
	                  destination[scopeName] = $interpolate(lastValue)(scope);
	                } else if (isBoolean(lastValue)) {
	                  // If the attributes is one of the BOOLEAN_ATTR then Angular will have converted
	                  // the value to boolean rather than a string, so we special case this situation
	                  destination[scopeName] = lastValue;
	                }
	                initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	                break;
	
	              case '=':
	                if (!hasOwnProperty.call(attrs, attrName)) {
	                  if (optional) break;
	                  attrs[attrName] = void 0;
	                }
	                if (optional && !attrs[attrName]) break;
	
	                parentGet = $parse(attrs[attrName]);
	                if (parentGet.literal) {
	                  compare = equals;
	                } else {
	                  compare = function simpleCompare(a, b) { return a === b || (a !== a && b !== b); };
	                }
	                parentSet = parentGet.assign || function() {
	                    // reset the change, or we will throw this exception on every $digest
	                    lastValue = destination[scopeName] = parentGet(scope);
	                    throw $compileMinErr('nonassign',
	                      "Expression '{0}' in attribute '{1}' used with directive '{2}' is non-assignable!",
	                      attrs[attrName], attrName, directive.name);
	                  };
	                lastValue = destination[scopeName] = parentGet(scope);
	                var parentValueWatch = function parentValueWatch(parentValue) {
	                  if (!compare(parentValue, destination[scopeName])) {
	                    // we are out of sync and need to copy
	                    if (!compare(parentValue, lastValue)) {
	                      // parent changed and it has precedence
	                      destination[scopeName] = parentValue;
	                    } else {
	                      // if the parent can be assigned then do so
	                      parentSet(scope, parentValue = destination[scopeName]);
	                    }
	                  }
	                  return lastValue = parentValue;
	                };
	                parentValueWatch.$stateful = true;
	                if (definition.collection) {
	                  removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	                } else {
	                  removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	                }
	                removeWatchCollection.push(removeWatch);
	                break;
	
	              case '<':
	                if (!hasOwnProperty.call(attrs, attrName)) {
	                  if (optional) break;
	                  attrs[attrName] = void 0;
	                }
	                if (optional && !attrs[attrName]) break;
	
	                parentGet = $parse(attrs[attrName]);
	
	                var initialValue = destination[scopeName] = parentGet(scope);
	                initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	
	                removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
	                  if (oldValue === newValue) {
	                    if (oldValue === initialValue) return;
	                    oldValue = initialValue;
	                  }
	                  recordChanges(scopeName, newValue, oldValue);
	                  destination[scopeName] = newValue;
	                }, parentGet.literal);
	
	                removeWatchCollection.push(removeWatch);
	                break;
	
	              case '&':
	                // Don't assign Object.prototype method to scope
	                parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	                // Don't assign noop to destination if expression is not valid
	                if (parentGet === noop && optional) break;
	
	                destination[scopeName] = function(locals) {
	                  return parentGet(scope, locals);
	                };
	                break;
	            }
	          });
	
	          function recordChanges(key, currentValue, previousValue) {
	            if (isFunction(destination.$onChanges) && currentValue !== previousValue) {
	              // If we have not already scheduled the top level onChangesQueue handler then do so now
	              if (!onChangesQueue) {
	                scope.$$postDigest(flushOnChangesQueue);
	                onChangesQueue = [];
	              }
	              // If we have not already queued a trigger of onChanges for this controller then do so now
	              if (!changes) {
	                changes = {};
	                onChangesQueue.push(triggerOnChangesHook);
	              }
	              // If the has been a change on this property already then we need to reuse the previous value
	              if (changes[key]) {
	                previousValue = changes[key].previousValue;
	              }
	              // Store this change
	              changes[key] = new SimpleChange(previousValue, currentValue);
	            }
	          }
	
	          function triggerOnChangesHook() {
	            destination.$onChanges(changes);
	            // Now clear the changes so that we schedule onChanges when more changes arrive
	            changes = undefined;
	          }
	
	          return {
	            initialChanges: initialChanges,
	            removeWatches: removeWatchCollection.length && function removeWatches() {
	              for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
	                removeWatchCollection[i]();
	              }
	            }
	          };
	        }
	      }];
	  }
	
	  function SimpleChange(previous, current) {
	    this.previousValue = previous;
	    this.currentValue = current;
	  }
	  SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };
	
	
	  var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;
	  /**
	   * Converts all accepted directives format into proper directive name.
	   * @param name Name to normalize
	   */
	  function directiveNormalize(name) {
	    return camelCase(name.replace(PREFIX_REGEXP, ''));
	  }
	
	  /**
	   * @ngdoc type
	   * @name $compile.directive.Attributes
	   *
	   * @description
	   * A shared object between directive compile / linking functions which contains normalized DOM
	   * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	   * needed since all of these are treated as equivalent in Angular:
	   *
	   * ```
	   *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	   * ```
	   */
	
	  /**
	   * @ngdoc property
	   * @name $compile.directive.Attributes#$attr
	   *
	   * @description
	   * A map of DOM element attribute names to the normalized name. This is
	   * needed to do reverse lookup from normalized name back to actual name.
	   */
	
	
	  /**
	   * @ngdoc method
	   * @name $compile.directive.Attributes#$set
	   * @kind function
	   *
	   * @description
	   * Set DOM element attribute value.
	   *
	   *
	   * @param {string} name Normalized element attribute name of the property to modify. The name is
	   *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	   *          property to the original name.
	   * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	   */
	
	
	
	  /**
	   * Closure compiler type information
	   */
	
	  function nodesetLinkingFn(
	    /* angular.Scope */ scope,
	    /* NodeList */ nodeList,
	    /* Element */ rootElement,
	    /* function(Function) */ boundTranscludeFn
	  ) {}
	
	  function directiveLinkingFn(
	    /* nodesetLinkingFn */ nodesetLinkingFn,
	    /* angular.Scope */ scope,
	    /* Node */ node,
	    /* Element */ rootElement,
	    /* function(Function) */ boundTranscludeFn
	  ) {}
	
	  function tokenDifference(str1, str2) {
	    var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	    outer:
	      for (var i = 0; i < tokens1.length; i++) {
	        var token = tokens1[i];
	        for (var j = 0; j < tokens2.length; j++) {
	          if (token == tokens2[j]) continue outer;
	        }
	        values += (values.length > 0 ? ' ' : '') + token;
	      }
	    return values;
	  }
	
	  function removeComments(jqNodes) {
	    jqNodes = jqLite(jqNodes);
	    var i = jqNodes.length;
	
	    if (i <= 1) {
	      return jqNodes;
	    }
	
	    while (i--) {
	      var node = jqNodes[i];
	      if (node.nodeType === NODE_TYPE_COMMENT) {
	        splice.call(jqNodes, i, 1);
	      }
	    }
	    return jqNodes;
	  }
	
	  var $controllerMinErr = minErr('$controller');
	
	
	  var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
	  function identifierForController(controller, ident) {
	    if (ident && isString(ident)) return ident;
	    if (isString(controller)) {
	      var match = CNTRL_REG.exec(controller);
	      if (match) return match[3];
	    }
	  }
	
	
	  /**
	   * @ngdoc provider
	   * @name $controllerProvider
	   * @description
	   * The {@link ng.$controller $controller service} is used by Angular to create new
	   * controllers.
	   *
	   * This provider allows controller registration via the
	   * {@link ng.$controllerProvider#register register} method.
	   */
	  function $ControllerProvider() {
	    var controllers = {},
	      globals = false;
	
	    /**
	     * @ngdoc method
	     * @name $controllerProvider#has
	     * @param {string} name Controller name to check.
	     */
	    this.has = function(name) {
	      return controllers.hasOwnProperty(name);
	    };
	
	    /**
	     * @ngdoc method
	     * @name $controllerProvider#register
	     * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	     *    the names and the values are the constructors.
	     * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	     *    annotations in the array notation).
	     */
	    this.register = function(name, constructor) {
	      assertNotHasOwnProperty(name, 'controller');
	      if (isObject(name)) {
	        extend(controllers, name);
	      } else {
	        controllers[name] = constructor;
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $controllerProvider#allowGlobals
	     * @description If called, allows `$controller` to find controller constructors on `window`
	     */
	    this.allowGlobals = function() {
	      globals = true;
	    };
	
	
	    this.$get = ['$injector', '$window', function($injector, $window) {
	
	      /**
	       * @ngdoc service
	       * @name $controller
	       * @requires $injector
	       *
	       * @param {Function|string} constructor If called with a function then it's considered to be the
	       *    controller constructor function. Otherwise it's considered to be a string which is used
	       *    to retrieve the controller constructor using the following steps:
	       *
	       *    * check if a controller with given name is registered via `$controllerProvider`
	       *    * check if evaluating the string on the current scope returns a constructor
	       *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
	       *      `window` object (not recommended)
	       *
	       *    The string can use the `controller as property` syntax, where the controller instance is published
	       *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	       *    to work correctly.
	       *
	       * @param {Object} locals Injection locals for Controller.
	       * @return {Object} Instance of given controller.
	       *
	       * @description
	       * `$controller` service is responsible for instantiating controllers.
	       *
	       * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	       * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	       */
	      return function $controller(expression, locals, later, ident) {
	        // PRIVATE API:
	        //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	        //                     If true, $controller will allocate the object with the correct
	        //                     prototype chain, but will not invoke the controller until a returned
	        //                     callback is invoked.
	        //   param `ident` --- An optional label which overrides the label parsed from the controller
	        //                     expression, if any.
	        var instance, match, constructor, identifier;
	        later = later === true;
	        if (ident && isString(ident)) {
	          identifier = ident;
	        }
	
	        if (isString(expression)) {
	          match = expression.match(CNTRL_REG);
	          if (!match) {
	            throw $controllerMinErr('ctrlfmt',
	              "Badly formed controller string '{0}'. " +
	              "Must match `__name__ as __id__` or `__name__`.", expression);
	          }
	          constructor = match[1],
	            identifier = identifier || match[3];
	          expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true) ||
	          (globals ? getter($window, constructor, true) : undefined);
	
	          assertArgFn(expression, constructor, true);
	        }
	
	        if (later) {
	          // Instantiate controller later:
	          // This machinery is used to create an instance of the object before calling the
	          // controller's constructor itself.
	          //
	          // This allows properties to be added to the controller before the constructor is
	          // invoked. Primarily, this is used for isolate scope bindings in $compile.
	          //
	          // This feature is not intended for use by applications, and is thus not documented
	          // publicly.
	          // Object creation: http://jsperf.com/create-constructor/2
	          var controllerPrototype = (isArray(expression) ?
	            expression[expression.length - 1] : expression).prototype;
	          instance = Object.create(controllerPrototype || null);
	
	          if (identifier) {
	            addIdentifier(locals, identifier, instance, constructor || expression.name);
	          }
	
	          var instantiate;
	          return instantiate = extend(function $controllerInit() {
	            var result = $injector.invoke(expression, instance, locals, constructor);
	            if (result !== instance && (isObject(result) || isFunction(result))) {
	              instance = result;
	              if (identifier) {
	                // If result changed, re-assign controllerAs value to scope.
	                addIdentifier(locals, identifier, instance, constructor || expression.name);
	              }
	            }
	            return instance;
	          }, {
	            instance: instance,
	            identifier: identifier
	          });
	        }
	
	        instance = $injector.instantiate(expression, locals, constructor);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        return instance;
	      };
	
	      function addIdentifier(locals, identifier, instance, name) {
	        if (!(locals && isObject(locals.$scope))) {
	          throw minErr('$controller')('noscp',
	            "Cannot export controller '{0}' as '{1}'! No $scope object provided via `locals`.",
	            name, identifier);
	        }
	
	        locals.$scope[identifier] = instance;
	      }
	    }];
	  }
	
	  /**
	   * @ngdoc service
	   * @name $document
	   * @requires $window
	   *
	   * @description
	   * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	   *
	   * @example
	   <example module="documentExample">
	   <file name="index.html">
	   <div ng-controller="ExampleController">
	   <p>$document title: <b ng-bind="title"></b></p>
	   <p>window.document title: <b ng-bind="windowTitle"></b></p>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('documentExample', [])
	   .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	   </file>
	   </example>
	   */
	  function $DocumentProvider() {
	    this.$get = ['$window', function(window) {
	      return jqLite(window.document);
	    }];
	  }
	
	  /**
	   * @ngdoc service
	   * @name $exceptionHandler
	   * @requires ng.$log
	   *
	   * @description
	   * Any uncaught exception in angular expressions is delegated to this service.
	   * The default implementation simply delegates to `$log.error` which logs it into
	   * the browser console.
	   *
	   * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	   * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	   *
	   * ## Example:
	   *
	   * ```js
	   *   angular.module('exceptionOverride', []).factory('$exceptionHandler', function() {
	 *     return function(exception, cause) {
	 *       exception.message += ' (caused by "' + cause + '")';
	 *       throw exception;
	 *     };
	 *   });
	   * ```
	   *
	   * This example will override the normal action of `$exceptionHandler`, to make angular
	   * exceptions fail hard when they happen, instead of just logging to the console.
	   *
	   * <hr />
	   * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	   * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	   * (unless executed during a digest).
	   *
	   * If you wish, you can manually delegate exceptions, e.g.
	   * `try { ... } catch(e) { $exceptionHandler(e); }`
	   *
	   * @param {Error} exception Exception associated with the error.
	   * @param {string=} cause optional information about the context in which
	   *       the error was thrown.
	   *
	   */
	  function $ExceptionHandlerProvider() {
	    this.$get = ['$log', function($log) {
	      return function(exception, cause) {
	        $log.error.apply($log, arguments);
	      };
	    }];
	  }
	
	  var $$ForceReflowProvider = function() {
	    this.$get = ['$document', function($document) {
	      return function(domNode) {
	        //the line below will force the browser to perform a repaint so
	        //that all the animated elements within the animation frame will
	        //be properly updated and drawn on screen. This is required to
	        //ensure that the preparation animation is properly flushed so that
	        //the active state picks up from there. DO NOT REMOVE THIS LINE.
	        //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	        //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	        //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	        if (domNode) {
	          if (!domNode.nodeType && domNode instanceof jqLite) {
	            domNode = domNode[0];
	          }
	        } else {
	          domNode = $document[0].body;
	        }
	        return domNode.offsetWidth + 1;
	      };
	    }];
	  };
	
	  var APPLICATION_JSON = 'application/json';
	  var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	  var JSON_START = /^\[|^\{(?!\{)/;
	  var JSON_ENDS = {
	    '[': /]$/,
	    '{': /}$/
	  };
	  var JSON_PROTECTION_PREFIX = /^\)\]\}',?\n/;
	  var $httpMinErr = minErr('$http');
	  var $httpMinErrLegacyFn = function(method) {
	    return function() {
	      throw $httpMinErr('legacy', 'The method `{0}` on the promise returned from `$http` has been disabled.', method);
	    };
	  };
	
	  function serializeValue(v) {
	    if (isObject(v)) {
	      return isDate(v) ? v.toISOString() : toJson(v);
	    }
	    return v;
	  }
	
	
	  function $HttpParamSerializerProvider() {
	    /**
	     * @ngdoc service
	     * @name $httpParamSerializer
	     * @description
	     *
	     * Default {@link $http `$http`} params serializer that converts objects to strings
	     * according to the following rules:
	     *
	     * * `{'foo': 'bar'}` results in `foo=bar`
	     * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	     * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	     * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D"` (stringified and encoded representation of an object)
	     *
	     * Note that serializer will sort the request parameters alphabetically.
	     * */
	
	    this.$get = function() {
	      return function ngParamSerializer(params) {
	        if (!params) return '';
	        var parts = [];
	        forEachSorted(params, function(value, key) {
	          if (value === null || isUndefined(value)) return;
	          if (isArray(value)) {
	            forEach(value, function(v) {
	              parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	            });
	          } else {
	            parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	          }
	        });
	
	        return parts.join('&');
	      };
	    };
	  }
	
	  function $HttpParamSerializerJQLikeProvider() {
	    /**
	     * @ngdoc service
	     * @name $httpParamSerializerJQLike
	     * @description
	     *
	     * Alternative {@link $http `$http`} params serializer that follows
	     * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	     * The serializer will also sort the params alphabetically.
	     *
	     * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	     *
	     * ```js
	     * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	     * ```
	     *
	     * It is also possible to set it as the default `paramSerializer` in the
	     * {@link $httpProvider#defaults `$httpProvider`}.
	     *
	     * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	     * form data for submission:
	     *
	     * ```js
	     * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	     * ```
	     *
	     * */
	    this.$get = function() {
	      return function jQueryLikeParamSerializer(params) {
	        if (!params) return '';
	        var parts = [];
	        serialize(params, '', true);
	        return parts.join('&');
	
	        function serialize(toSerialize, prefix, topLevel) {
	          if (toSerialize === null || isUndefined(toSerialize)) return;
	          if (isArray(toSerialize)) {
	            forEach(toSerialize, function(value, index) {
	              serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	            });
	          } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	            forEachSorted(toSerialize, function(value, key) {
	              serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	            });
	          } else {
	            parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
	          }
	        }
	      };
	    };
	  }
	
	  function defaultHttpResponseTransform(data, headers) {
	    if (isString(data)) {
	      // Strip json vulnerability protection prefix and trim whitespace
	      var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	      if (tempData) {
	        var contentType = headers('Content-Type');
	        if ((contentType && (contentType.indexOf(APPLICATION_JSON) === 0)) || isJsonLike(tempData)) {
	          data = fromJson(tempData);
	        }
	      }
	    }
	
	    return data;
	  }
	
	  function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	  }
	
	  /**
	   * Parse headers into key value object
	   *
	   * @param {string} headers Raw headers as a string
	   * @returns {Object} Parsed headers as key value object
	   */
	  function parseHeaders(headers) {
	    var parsed = createMap(), i;
	
	    function fillInParsed(key, val) {
	      if (key) {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	
	    if (isString(headers)) {
	      forEach(headers.split('\n'), function(line) {
	        i = line.indexOf(':');
	        fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	      });
	    } else if (isObject(headers)) {
	      forEach(headers, function(headerVal, headerKey) {
	        fillInParsed(lowercase(headerKey), trim(headerVal));
	      });
	    }
	
	    return parsed;
	  }
	
	
	  /**
	   * Returns a function that provides access to parsed headers.
	   *
	   * Headers are lazy parsed when first requested.
	   * @see parseHeaders
	   *
	   * @param {(string|Object)} headers Headers to provide access to.
	   * @returns {function(string=)} Returns a getter function which if called with:
	   *
	   *   - if called with single an argument returns a single header value or null
	   *   - if called with no arguments returns an object containing all headers.
	   */
	  function headersGetter(headers) {
	    var headersObj;
	
	    return function(name) {
	      if (!headersObj) headersObj =  parseHeaders(headers);
	
	      if (name) {
	        var value = headersObj[lowercase(name)];
	        if (value === void 0) {
	          value = null;
	        }
	        return value;
	      }
	
	      return headersObj;
	    };
	  }
	
	
	  /**
	   * Chain all given functions
	   *
	   * This function is used for both request and response transforming
	   *
	   * @param {*} data Data to transform.
	   * @param {function(string=)} headers HTTP headers getter fn.
	   * @param {number} status HTTP status code of the response.
	   * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	   * @returns {*} Transformed data.
	   */
	  function transformData(data, headers, status, fns) {
	    if (isFunction(fns)) {
	      return fns(data, headers, status);
	    }
	
	    forEach(fns, function(fn) {
	      data = fn(data, headers, status);
	    });
	
	    return data;
	  }
	
	
	  function isSuccess(status) {
	    return 200 <= status && status < 300;
	  }
	
	
	  /**
	   * @ngdoc provider
	   * @name $httpProvider
	   * @description
	   * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	   * */
	  function $HttpProvider() {
	    /**
	     * @ngdoc property
	     * @name $httpProvider#defaults
	     * @description
	     *
	     * Object containing default values for all {@link ng.$http $http} requests.
	     *
	     * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	     * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	     * by default. See {@link $http#caching $http Caching} for more information.
	     *
	     * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	     * Defaults value is `'XSRF-TOKEN'`.
	     *
	     * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	     * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	     *
	     * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	     * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	     * setting default headers.
	     *     - **`defaults.headers.common`**
	     *     - **`defaults.headers.post`**
	     *     - **`defaults.headers.put`**
	     *     - **`defaults.headers.patch`**
	     *
	     *
	     * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	     *  used to the prepare string representation of request parameters (specified as an object).
	     *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	     *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	     *
	     **/
	    var defaults = this.defaults = {
	      // transform incoming response data
	      transformResponse: [defaultHttpResponseTransform],
	
	      // transform outgoing request data
	      transformRequest: [function(d) {
	        return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	      }],
	
	      // default headers
	      headers: {
	        common: {
	          'Accept': 'application/json, text/plain, */*'
	        },
	        post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	        put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	        patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	      },
	
	      xsrfCookieName: 'XSRF-TOKEN',
	      xsrfHeaderName: 'X-XSRF-TOKEN',
	
	      paramSerializer: '$httpParamSerializer'
	    };
	
	    var useApplyAsync = false;
	    /**
	     * @ngdoc method
	     * @name $httpProvider#useApplyAsync
	     * @description
	     *
	     * Configure $http service to combine processing of multiple http responses received at around
	     * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	     * significant performance improvement for bigger applications that make many HTTP requests
	     * concurrently (common during application bootstrap).
	     *
	     * Defaults to false. If no value is specified, returns the current configured value.
	     *
	     * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	     *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	     *    to load and share the same digest cycle.
	     *
	     * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	     *    otherwise, returns the current configured value.
	     **/
	    this.useApplyAsync = function(value) {
	      if (isDefined(value)) {
	        useApplyAsync = !!value;
	        return this;
	      }
	      return useApplyAsync;
	    };
	
	    var useLegacyPromise = true;
	    /**
	     * @ngdoc method
	     * @name $httpProvider#useLegacyPromiseExtensions
	     * @description
	     *
	     * Configure `$http` service to return promises without the shorthand methods `success` and `error`.
	     * This should be used to make sure that applications work without these methods.
	     *
	     * Defaults to true. If no value is specified, returns the current configured value.
	     *
	     * @param {boolean=} value If true, `$http` will return a promise with the deprecated legacy `success` and `error` methods.
	     *
	     * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	     *    otherwise, returns the current configured value.
	     **/
	    this.useLegacyPromiseExtensions = function(value) {
	      if (isDefined(value)) {
	        useLegacyPromise = !!value;
	        return this;
	      }
	      return useLegacyPromise;
	    };
	
	    /**
	     * @ngdoc property
	     * @name $httpProvider#interceptors
	     * @description
	     *
	     * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	     * pre-processing of request or postprocessing of responses.
	     *
	     * These service factories are ordered by request, i.e. they are applied in the same order as the
	     * array, on request, but reverse order, on response.
	     *
	     * {@link ng.$http#interceptors Interceptors detailed info}
	     **/
	    var interceptorFactories = this.interceptors = [];
	
	    this.$get = ['$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector',
	      function($httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector) {
	
	        var defaultCache = $cacheFactory('$http');
	
	        /**
	         * Make sure that default param serializer is exposed as a function
	         */
	        defaults.paramSerializer = isString(defaults.paramSerializer) ?
	          $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	        /**
	         * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	         * The reversal is needed so that we can build up the interception chain around the
	         * server request.
	         */
	        var reversedInterceptors = [];
	
	        forEach(interceptorFactories, function(interceptorFactory) {
	          reversedInterceptors.unshift(isString(interceptorFactory)
	            ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	        });
	
	        /**
	         * @ngdoc service
	         * @kind function
	         * @name $http
	         * @requires ng.$httpBackend
	         * @requires $cacheFactory
	         * @requires $rootScope
	         * @requires $q
	         * @requires $injector
	         *
	         * @description
	         * The `$http` service is a core Angular service that facilitates communication with the remote
	         * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	         * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	         *
	         * For unit testing applications that use `$http` service, see
	         * {@link ngMock.$httpBackend $httpBackend mock}.
	         *
	         * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	         *
	         * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	         * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	         * it is important to familiarize yourself with these APIs and the guarantees they provide.
	         *
	         *
	         * ## General usage
	         * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	         * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
	         *
	         * ```js
	         *   // Simple GET request example:
	         *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	         * ```
	         *
	         * The response object has these properties:
	         *
	         *   - **data** – `{string|Object}` – The response body transformed with the transform
	         *     functions.
	         *   - **status** – `{number}` – HTTP status code of the response.
	         *   - **headers** – `{function([headerName])}` – Header getter function.
	         *   - **config** – `{Object}` – The configuration object that was used to generate the request.
	         *   - **statusText** – `{string}` – HTTP status text of the response.
	         *
	         * A response status code between 200 and 299 is considered a success status and will result in
	         * the success callback being called. Any response status code outside of that range is
	         * considered an error status and will result in the error callback being called.
	         * Also, status codes less than -1 are normalized to zero. -1 usually means the request was
	         * aborted, e.g. using a `config.timeout`.
	         * Note that if the response is a redirect, XMLHttpRequest will transparently follow it, meaning
	         * that the outcome (success or error) will be determined by the final response status code.
	         *
	         *
	         * ## Shortcut methods
	         *
	         * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	         * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	         * last argument.
	         *
	         * ```js
	         *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	         *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	         * ```
	         *
	         * Complete list of shortcut methods:
	         *
	         * - {@link ng.$http#get $http.get}
	         * - {@link ng.$http#head $http.head}
	         * - {@link ng.$http#post $http.post}
	         * - {@link ng.$http#put $http.put}
	         * - {@link ng.$http#delete $http.delete}
	         * - {@link ng.$http#jsonp $http.jsonp}
	         * - {@link ng.$http#patch $http.patch}
	         *
	         *
	         * ## Writing Unit Tests that use $http
	         * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	         * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	         * request using trained responses.
	         *
	         * ```
	         * $httpBackend.expectGET(...);
	         * $http.get(...);
	         * $httpBackend.flush();
	         * ```
	         *
	         * ## Deprecation Notice
	         * <div class="alert alert-danger">
	         *   The `$http` legacy promise methods `success` and `error` have been deprecated.
	         *   Use the standard `then` method instead.
	         *   If {@link $httpProvider#useLegacyPromiseExtensions `$httpProvider.useLegacyPromiseExtensions`} is set to
	         *   `false` then these methods will throw {@link $http:legacy `$http/legacy`} error.
	         * </div>
	         *
	         * ## Setting HTTP Headers
	         *
	         * The $http service will automatically add certain HTTP headers to all requests. These defaults
	         * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	         * object, which currently contains this default configuration:
	         *
	         * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	         *   - `Accept: application/json, text/plain, * / *`
	         * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	         *   - `Content-Type: application/json`
	         * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	         *   - `Content-Type: application/json`
	         *
	         * To add or overwrite these defaults, simply add or remove a property from these configuration
	         * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	         * with the lowercased HTTP method name as the key, e.g.
	         * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	         *
	         * The defaults can also be set at runtime via the `$http.defaults` object in the same
	         * fashion. For example:
	         *
	         * ```
	         * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	         * ```
	         *
	         * In addition, you can supply a `headers` property in the config object passed when
	         * calling `$http(config)`, which overrides the defaults without changing them globally.
	         *
	         * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	         * Use the `headers` property, setting the desired header to `undefined`. For example:
	         *
	         * ```js
	         * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	         *
	         * $http(req).then(function(){...}, function(){...});
	         * ```
	         *
	         * ## Transforming Requests and Responses
	         *
	         * Both requests and responses can be transformed using transformation functions: `transformRequest`
	         * and `transformResponse`. These properties can be a single function that returns
	         * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	         * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	         *
	         * <div class="alert alert-warning">
	         * **Note:** Angular does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	         * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	         * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	         * function will be reflected on the scope and in any templates where the object is data-bound.
	         * To prevent this, transform functions should have no side-effects.
	         * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	         * </div>
	         *
	         * ### Default Transformations
	         *
	         * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	         * `defaults.transformResponse` properties. If a request does not provide its own transformations
	         * then these will be applied.
	         *
	         * You can augment or replace the default transformations by modifying these properties by adding to or
	         * replacing the array.
	         *
	         * Angular provides the following default transformations:
	         *
	         * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`):
	         *
	         * - If the `data` property of the request configuration object contains an object, serialize it
	         *   into JSON format.
	         *
	         * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`):
	         *
	         *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	         *  - If JSON response is detected, deserialize it using a JSON parser.
	         *
	         *
	         * ### Overriding the Default Transformations Per Request
	         *
	         * If you wish override the request/response transformations only for a single request then provide
	         * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	         * into `$http`.
	         *
	         * Note that if you provide these properties on the config object the default transformations will be
	         * overwritten. If you wish to augment the default transformations then you must include them in your
	         * local transformation array.
	         *
	         * The following code demonstrates adding a new response transformation to be run after the default response
	         * transformations have been run.
	         *
	         * ```js
	         * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	         *
	         * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	         * ```
	         *
	         *
	         * ## Caching
	         *
	         * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	         * set the config.cache value or the default cache value to TRUE or to a cache object (created
	         * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	         * precedence over the default cache value.
	         *
	         * In order to:
	         *   * cache all responses - set the default cache value to TRUE or to a cache object
	         *   * cache a specific response - set config.cache value to TRUE or to a cache object
	         *
	         * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	         * then the default `$cacheFactory($http)` object is used.
	         *
	         * The default cache value can be set by updating the
	         * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	         * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	         *
	         * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	         * the relevant cache object. The next time the same request is made, the response is returned
	         * from the cache without sending a request to the server.
	         *
	         * Take note that:
	         *
	         *   * Only GET and JSONP requests are cached.
	         *   * The cache key is the request URL including search parameters; headers are not considered.
	         *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	         *   * If multiple identical requests are made using the same cache, which is not yet populated,
	         *     one request will be made to the server and remaining requests will return the same response.
	         *   * A cache-control header on the response does not affect if or how responses are cached.
	         *
	         *
	         * ## Interceptors
	         *
	         * Before you start creating interceptors, be sure to understand the
	         * {@link ng.$q $q and deferred/promise APIs}.
	         *
	         * For purposes of global error handling, authentication, or any kind of synchronous or
	         * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	         * able to intercept requests before they are handed to the server and
	         * responses before they are handed over to the application code that
	         * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	         *
	         * The interceptors are service factories that are registered with the `$httpProvider` by
	         * adding them to the `$httpProvider.interceptors` array. The factory is called and
	         * injected with dependencies (if specified) and returns the interceptor.
	         *
	         * There are two kinds of interceptors (and two kinds of rejection interceptors):
	         *
	         *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	         *     modify the `config` object or create a new one. The function needs to return the `config`
	         *     object directly, or a promise containing the `config` or a new `config` object.
	         *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	         *     resolved with a rejection.
	         *   * `response`: interceptors get called with http `response` object. The function is free to
	         *     modify the `response` object or create a new one. The function needs to return the `response`
	         *     object directly, or as a promise containing the `response` or a new `response` object.
	         *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	         *     resolved with a rejection.
	         *
	         *
	         * ```js
	         *   // register the interceptor as a service
	         *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	         *
	         *   $httpProvider.interceptors.push('myHttpInterceptor');
	         *
	         *
	         *   // alternatively, register the interceptor via an anonymous factory
	         *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	         * ```
	         *
	         * ## Security Considerations
	         *
	         * When designing web applications, consider security threats from:
	         *
	         * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	         * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	         *
	         * Both server and the client must cooperate in order to eliminate these threats. Angular comes
	         * pre-configured with strategies that address these issues, but for this to work backend server
	         * cooperation is required.
	         *
	         * ### JSON Vulnerability Protection
	         *
	         * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	         * allows third party website to turn your JSON resource URL into
	         * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	         * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	         * Angular will automatically strip the prefix before processing it as JSON.
	         *
	         * For example if your server needs to return:
	         * ```js
	         * ['one','two']
	         * ```
	         *
	         * which is vulnerable to attack, your server can return:
	         * ```js
	         * )]}',
	         * ['one','two']
	         * ```
	         *
	         * Angular will strip the prefix, before processing the JSON.
	         *
	         *
	         * ### Cross Site Request Forgery (XSRF) Protection
	         *
	         * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	         * which the attacker can trick an authenticated user into unknowingly executing actions on your
	         * website. Angular provides a mechanism to counter XSRF. When performing XHR requests, the
	         * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	         * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
	         * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
	         * The header will not be set for cross-domain requests.
	         *
	         * To take advantage of this, your server needs to set a token in a JavaScript readable session
	         * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	         * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
	         * that only JavaScript running on your domain could have sent the request. The token must be
	         * unique for each user and must be verifiable by the server (to prevent the JavaScript from
	         * making up its own tokens). We recommend that the token is a digest of your site's
	         * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	         * for added security.
	         *
	         * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
	         * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
	         * or the per-request config object.
	         *
	         * In order to prevent collisions in environments where multiple Angular apps share the
	         * same domain or subdomain, we recommend that each application uses unique cookie name.
	         *
	         * @param {object} config Object describing the request to be made and how it should be
	         *    processed. The object has following properties:
	         *
	         *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	         *    - **url** – `{string}` – Absolute or relative URL of the resource that is being requested.
	         *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	         *      with the `paramSerializer` and appended as GET parameters.
	         *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	         *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	         *      HTTP headers to send to the server. If the return value of a function is null, the
	         *      header will not be sent. Functions accept a config object as an argument.
	         *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	         *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	         *      The handler will be called in the context of a `$apply` block.
	         *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	         *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	         *      The handler will be called in the context of a `$apply` block.
	         *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	         *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	         *    - **transformRequest** –
	         *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	         *      transform function or an array of such functions. The transform function takes the http
	         *      request body and headers and returns its transformed (typically serialized) version.
	         *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	         *    - **transformResponse** –
	         *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	         *      transform function or an array of such functions. The transform function takes the http
	         *      response body, headers and status and returns its transformed (typically deserialized) version.
	         *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	         *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	         *      prepare the string representation of request parameters (specified as an object).
	         *      If specified as string, it is interpreted as function registered with the
	         *      {@link $injector $injector}, which means you can create your own serializer
	         *      by registering it as a {@link auto.$provide#service service}.
	         *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	         *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	         *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	         *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	         *      See {@link $http#caching $http Caching} for more information.
	         *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	         *      that should abort the request when resolved.
	         *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	         *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	         *      for more information.
	         *    - **responseType** - `{string}` - see
	         *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	         *
	         * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
	         *                        when the request succeeds or fails.
	         *
	         *
	         * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	         *   requests. This is primarily meant to be used for debugging purposes.
	         *
	         *
	         * @example
	         <example module="httpExample">
	         <file name="index.html">
	         <div ng-controller="FetchController">
	         <select ng-model="method" aria-label="Request method">
	         <option>GET</option>
	         <option>JSONP</option>
	         </select>
	         <input type="text" ng-model="url" size="80" aria-label="URL" />
	         <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	         <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	         <button id="samplejsonpbtn"
	         ng-click="updateModel('JSONP',
	         'https://angularjs.org/greet.php?callback=JSON_CALLBACK&name=Super%20Hero')">
	         Sample JSONP
	         </button>
	         <button id="invalidjsonpbtn"
	         ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist&callback=JSON_CALLBACK')">
	         Invalid JSONP
	         </button>
	         <pre>http status code: {{status}}</pre>
	         <pre>http response data: {{data}}</pre>
	         </div>
	         </file>
	         <file name="script.js">
	         angular.module('httpExample', [])
	         .controller('FetchController', ['$scope', '$http', '$templateCache',
	         function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || "Request failed";
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	         </file>
	         <file name="http-hello.html">
	         Hello, $http!
	         </file>
	         <file name="protractor.js" type="protractor">
	         var status = element(by.binding('status'));
	         var data = element(by.binding('data'));
	         var fetchBtn = element(by.id('fetchbtn'));
	         var sampleGetBtn = element(by.id('samplegetbtn'));
	         var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	         var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	         it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	         // Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	         // it('should make a JSONP request to angularjs.org', function() {
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	         it('should make JSONP request to invalid URL and invoke the error handler',
	         function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	         </file>
	         </example>
	         */
	        function $http(requestConfig) {
	
	          if (!isObject(requestConfig)) {
	            throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	          }
	
	          if (!isString(requestConfig.url)) {
	            throw minErr('$http')('badreq', 'Http request configuration url must be a string.  Received: {0}', requestConfig.url);
	          }
	
	          var config = extend({
	            method: 'get',
	            transformRequest: defaults.transformRequest,
	            transformResponse: defaults.transformResponse,
	            paramSerializer: defaults.paramSerializer
	          }, requestConfig);
	
	          config.headers = mergeHeaders(requestConfig);
	          config.method = uppercase(config.method);
	          config.paramSerializer = isString(config.paramSerializer) ?
	            $injector.get(config.paramSerializer) : config.paramSerializer;
	
	          var serverRequest = function(config) {
	            var headers = config.headers;
	            var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	            // strip content-type if data is undefined
	            if (isUndefined(reqData)) {
	              forEach(headers, function(value, header) {
	                if (lowercase(header) === 'content-type') {
	                  delete headers[header];
	                }
	              });
	            }
	
	            if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	              config.withCredentials = defaults.withCredentials;
	            }
	
	            // send request
	            return sendReq(config, reqData).then(transformResponse, transformResponse);
	          };
	
	          var chain = [serverRequest, undefined];
	          var promise = $q.when(config);
	
	          // apply interceptors
	          forEach(reversedInterceptors, function(interceptor) {
	            if (interceptor.request || interceptor.requestError) {
	              chain.unshift(interceptor.request, interceptor.requestError);
	            }
	            if (interceptor.response || interceptor.responseError) {
	              chain.push(interceptor.response, interceptor.responseError);
	            }
	          });
	
	          while (chain.length) {
	            var thenFn = chain.shift();
	            var rejectFn = chain.shift();
	
	            promise = promise.then(thenFn, rejectFn);
	          }
	
	          if (useLegacyPromise) {
	            promise.success = function(fn) {
	              assertArgFn(fn, 'fn');
	
	              promise.then(function(response) {
	                fn(response.data, response.status, response.headers, config);
	              });
	              return promise;
	            };
	
	            promise.error = function(fn) {
	              assertArgFn(fn, 'fn');
	
	              promise.then(null, function(response) {
	                fn(response.data, response.status, response.headers, config);
	              });
	              return promise;
	            };
	          } else {
	            promise.success = $httpMinErrLegacyFn('success');
	            promise.error = $httpMinErrLegacyFn('error');
	          }
	
	          return promise;
	
	          function transformResponse(response) {
	            // make a copy since the response must be cacheable
	            var resp = extend({}, response);
	            resp.data = transformData(response.data, response.headers, response.status,
	              config.transformResponse);
	            return (isSuccess(response.status))
	              ? resp
	              : $q.reject(resp);
	          }
	
	          function executeHeaderFns(headers, config) {
	            var headerContent, processedHeaders = {};
	
	            forEach(headers, function(headerFn, header) {
	              if (isFunction(headerFn)) {
	                headerContent = headerFn(config);
	                if (headerContent != null) {
	                  processedHeaders[header] = headerContent;
	                }
	              } else {
	                processedHeaders[header] = headerFn;
	              }
	            });
	
	            return processedHeaders;
	          }
	
	          function mergeHeaders(config) {
	            var defHeaders = defaults.headers,
	              reqHeaders = extend({}, config.headers),
	              defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	            defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	            // using for-in instead of forEach to avoid unnecessary iteration after header has been found
	            defaultHeadersIteration:
	              for (defHeaderName in defHeaders) {
	                lowercaseDefHeaderName = lowercase(defHeaderName);
	
	                for (reqHeaderName in reqHeaders) {
	                  if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	                    continue defaultHeadersIteration;
	                  }
	                }
	
	                reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	              }
	
	            // execute if header value is a function for merged headers
	            return executeHeaderFns(reqHeaders, shallowCopy(config));
	          }
	        }
	
	        $http.pendingRequests = [];
	
	        /**
	         * @ngdoc method
	         * @name $http#get
	         *
	         * @description
	         * Shortcut method to perform `GET` request.
	         *
	         * @param {string} url Relative or absolute URL specifying the destination of the request
	         * @param {Object=} config Optional configuration object
	         * @returns {HttpPromise} Future object
	         */
	
	        /**
	         * @ngdoc method
	         * @name $http#delete
	         *
	         * @description
	         * Shortcut method to perform `DELETE` request.
	         *
	         * @param {string} url Relative or absolute URL specifying the destination of the request
	         * @param {Object=} config Optional configuration object
	         * @returns {HttpPromise} Future object
	         */
	
	        /**
	         * @ngdoc method
	         * @name $http#head
	         *
	         * @description
	         * Shortcut method to perform `HEAD` request.
	         *
	         * @param {string} url Relative or absolute URL specifying the destination of the request
	         * @param {Object=} config Optional configuration object
	         * @returns {HttpPromise} Future object
	         */
	
	        /**
	         * @ngdoc method
	         * @name $http#jsonp
	         *
	         * @description
	         * Shortcut method to perform `JSONP` request.
	         *
	         * @param {string} url Relative or absolute URL specifying the destination of the request.
	         *                     The name of the callback should be the string `JSON_CALLBACK`.
	         * @param {Object=} config Optional configuration object
	         * @returns {HttpPromise} Future object
	         */
	        createShortMethods('get', 'delete', 'head', 'jsonp');
	
	        /**
	         * @ngdoc method
	         * @name $http#post
	         *
	         * @description
	         * Shortcut method to perform `POST` request.
	         *
	         * @param {string} url Relative or absolute URL specifying the destination of the request
	         * @param {*} data Request content
	         * @param {Object=} config Optional configuration object
	         * @returns {HttpPromise} Future object
	         */
	
	        /**
	         * @ngdoc method
	         * @name $http#put
	         *
	         * @description
	         * Shortcut method to perform `PUT` request.
	         *
	         * @param {string} url Relative or absolute URL specifying the destination of the request
	         * @param {*} data Request content
	         * @param {Object=} config Optional configuration object
	         * @returns {HttpPromise} Future object
	         */
	
	        /**
	         * @ngdoc method
	         * @name $http#patch
	         *
	         * @description
	         * Shortcut method to perform `PATCH` request.
	         *
	         * @param {string} url Relative or absolute URL specifying the destination of the request
	         * @param {*} data Request content
	         * @param {Object=} config Optional configuration object
	         * @returns {HttpPromise} Future object
	         */
	        createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	        $http.defaults = defaults;
	
	
	        return $http;
	
	
	        function createShortMethods(names) {
	          forEach(arguments, function(name) {
	            $http[name] = function(url, config) {
	              return $http(extend({}, config || {}, {
	                method: name,
	                url: url
	              }));
	            };
	          });
	        }
	
	
	        function createShortMethodsWithData(name) {
	          forEach(arguments, function(name) {
	            $http[name] = function(url, data, config) {
	              return $http(extend({}, config || {}, {
	                method: name,
	                url: url,
	                data: data
	              }));
	            };
	          });
	        }
	
	
	        /**
	         * Makes the request.
	         *
	         * !!! ACCESSES CLOSURE VARS:
	         * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	         */
	        function sendReq(config, reqData) {
	          var deferred = $q.defer(),
	            promise = deferred.promise,
	            cache,
	            cachedResp,
	            reqHeaders = config.headers,
	            url = buildUrl(config.url, config.paramSerializer(config.params));
	
	          $http.pendingRequests.push(config);
	          promise.then(removePendingReq, removePendingReq);
	
	
	          if ((config.cache || defaults.cache) && config.cache !== false &&
	            (config.method === 'GET' || config.method === 'JSONP')) {
	            cache = isObject(config.cache) ? config.cache
	              : isObject(defaults.cache) ? defaults.cache
	              : defaultCache;
	          }
	
	          if (cache) {
	            cachedResp = cache.get(url);
	            if (isDefined(cachedResp)) {
	              if (isPromiseLike(cachedResp)) {
	                // cached request has already been sent, but there is no response yet
	                cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	              } else {
	                // serving from cache
	                if (isArray(cachedResp)) {
	                  resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3]);
	                } else {
	                  resolvePromise(cachedResp, 200, {}, 'OK');
	                }
	              }
	            } else {
	              // put the promise for the non-transformed response into cache as a placeholder
	              cache.put(url, promise);
	            }
	          }
	
	
	          // if we won't have the response in cache, set the xsrf headers and
	          // send the request to the backend
	          if (isUndefined(cachedResp)) {
	            var xsrfValue = urlIsSameOrigin(config.url)
	              ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	              : undefined;
	            if (xsrfValue) {
	              reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	            }
	
	            $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	              config.withCredentials, config.responseType,
	              createApplyHandlers(config.eventHandlers),
	              createApplyHandlers(config.uploadEventHandlers));
	          }
	
	          return promise;
	
	          function createApplyHandlers(eventHandlers) {
	            if (eventHandlers) {
	              var applyHandlers = {};
	              forEach(eventHandlers, function(eventHandler, key) {
	                applyHandlers[key] = function(event) {
	                  if (useApplyAsync) {
	                    $rootScope.$applyAsync(callEventHandler);
	                  } else if ($rootScope.$$phase) {
	                    callEventHandler();
	                  } else {
	                    $rootScope.$apply(callEventHandler);
	                  }
	
	                  function callEventHandler() {
	                    eventHandler(event);
	                  }
	                };
	              });
	              return applyHandlers;
	            }
	          }
	
	
	          /**
	           * Callback registered to $httpBackend():
	           *  - caches the response if desired
	           *  - resolves the raw $http promise
	           *  - calls $apply
	           */
	          function done(status, response, headersString, statusText) {
	            if (cache) {
	              if (isSuccess(status)) {
	                cache.put(url, [status, response, parseHeaders(headersString), statusText]);
	              } else {
	                // remove promise from the cache
	                cache.remove(url);
	              }
	            }
	
	            function resolveHttpPromise() {
	              resolvePromise(response, status, headersString, statusText);
	            }
	
	            if (useApplyAsync) {
	              $rootScope.$applyAsync(resolveHttpPromise);
	            } else {
	              resolveHttpPromise();
	              if (!$rootScope.$$phase) $rootScope.$apply();
	            }
	          }
	
	
	          /**
	           * Resolves the raw $http promise.
	           */
	          function resolvePromise(response, status, headers, statusText) {
	            //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	            status = status >= -1 ? status : 0;
	
	            (isSuccess(status) ? deferred.resolve : deferred.reject)({
	              data: response,
	              status: status,
	              headers: headersGetter(headers),
	              config: config,
	              statusText: statusText
	            });
	          }
	
	          function resolvePromiseWithResult(result) {
	            resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText);
	          }
	
	          function removePendingReq() {
	            var idx = $http.pendingRequests.indexOf(config);
	            if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	          }
	        }
	
	
	        function buildUrl(url, serializedParams) {
	          if (serializedParams.length > 0) {
	            url += ((url.indexOf('?') == -1) ? '?' : '&') + serializedParams;
	          }
	          return url;
	        }
	      }];
	  }
	
	  /**
	   * @ngdoc service
	   * @name $xhrFactory
	   *
	   * @description
	   * Factory function used to create XMLHttpRequest objects.
	   *
	   * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	   *
	   * ```
	   * angular.module('myApp', [])
	   * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	   * ```
	   *
	   * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	   * @param {string} url URL of the request.
	   */
	  function $xhrFactoryProvider() {
	    this.$get = function() {
	      return function createXhr() {
	        return new window.XMLHttpRequest();
	      };
	    };
	  }
	
	  /**
	   * @ngdoc service
	   * @name $httpBackend
	   * @requires $window
	   * @requires $document
	   * @requires $xhrFactory
	   *
	   * @description
	   * HTTP backend used by the {@link ng.$http service} that delegates to
	   * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	   *
	   * You should never need to use this service directly, instead use the higher-level abstractions:
	   * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	   *
	   * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	   */
	  function $HttpBackendProvider() {
	    this.$get = ['$browser', '$window', '$document', '$xhrFactory', function($browser, $window, $document, $xhrFactory) {
	      return createHttpBackend($browser, $xhrFactory, $browser.defer, $window.angular.callbacks, $document[0]);
	    }];
	  }
	
	  function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	    // TODO(vojta): fix the signature
	    return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
	      $browser.$$incOutstandingRequestCount();
	      url = url || $browser.url();
	
	      if (lowercase(method) == 'jsonp') {
	        var callbackId = '_' + (callbacks.counter++).toString(36);
	        callbacks[callbackId] = function(data) {
	          callbacks[callbackId].data = data;
	          callbacks[callbackId].called = true;
	        };
	
	        var jsonpDone = jsonpReq(url.replace('JSON_CALLBACK', 'angular.callbacks.' + callbackId),
	          callbackId, function(status, text) {
	            completeRequest(callback, status, callbacks[callbackId].data, "", text);
	            callbacks[callbackId] = noop;
	          });
	      } else {
	
	        var xhr = createXhr(method, url);
	
	        xhr.open(method, url, true);
	        forEach(headers, function(value, key) {
	          if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	          }
	        });
	
	        xhr.onload = function requestLoaded() {
	          var statusText = xhr.statusText || '';
	
	          // responseText is the old-school way of retrieving response (supported by IE9)
	          // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	          var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	          // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	          var status = xhr.status === 1223 ? 204 : xhr.status;
	
	          // fix status code when it is 0 (0 status is undocumented).
	          // Occurs when accessing file resources or on Android 4.1 stock browser
	          // while retrieving files from application cache.
	          if (status === 0) {
	            status = response ? 200 : urlResolve(url).protocol == 'file' ? 404 : 0;
	          }
	
	          completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText);
	        };
	
	        var requestError = function() {
	          // The response is always empty
	          // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	          completeRequest(callback, -1, null, null, '');
	        };
	
	        xhr.onerror = requestError;
	        xhr.onabort = requestError;
	
	        forEach(eventHandlers, function(value, key) {
	          xhr.addEventListener(key, value);
	        });
	
	        forEach(uploadEventHandlers, function(value, key) {
	          xhr.upload.addEventListener(key, value);
	        });
	
	        if (withCredentials) {
	          xhr.withCredentials = true;
	        }
	
	        if (responseType) {
	          try {
	            xhr.responseType = responseType;
	          } catch (e) {
	            // WebKit added support for the json responseType value on 09/03/2013
	            // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	            // known to throw when setting the value "json" as the response type. Other older
	            // browsers implementing the responseType
	            //
	            // The json response type can be ignored if not supported, because JSON payloads are
	            // parsed on the client-side regardless.
	            if (responseType !== 'json') {
	              throw e;
	            }
	          }
	        }
	
	        xhr.send(isUndefined(post) ? null : post);
	      }
	
	      if (timeout > 0) {
	        var timeoutId = $browserDefer(timeoutRequest, timeout);
	      } else if (isPromiseLike(timeout)) {
	        timeout.then(timeoutRequest);
	      }
	
	
	      function timeoutRequest() {
	        jsonpDone && jsonpDone();
	        xhr && xhr.abort();
	      }
	
	      function completeRequest(callback, status, response, headersString, statusText) {
	        // cancel timeout and subsequent timeout promise resolution
	        if (isDefined(timeoutId)) {
	          $browserDefer.cancel(timeoutId);
	        }
	        jsonpDone = xhr = null;
	
	        callback(status, response, headersString, statusText);
	        $browser.$$completeOutstandingRequest(noop);
	      }
	    };
	
	    function jsonpReq(url, callbackId, done) {
	      // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	      // - fetches local scripts via XHR and evals them
	      // - adds and immediately removes script elements from the document
	      var script = rawDocument.createElement('script'), callback = null;
	      script.type = "text/javascript";
	      script.src = url;
	      script.async = true;
	
	      callback = function(event) {
	        removeEventListenerFn(script, "load", callback);
	        removeEventListenerFn(script, "error", callback);
	        rawDocument.body.removeChild(script);
	        script = null;
	        var status = -1;
	        var text = "unknown";
	
	        if (event) {
	          if (event.type === "load" && !callbacks[callbackId].called) {
	            event = { type: "error" };
	          }
	          text = event.type;
	          status = event.type === "error" ? 404 : 200;
	        }
	
	        if (done) {
	          done(status, text);
	        }
	      };
	
	      addEventListenerFn(script, "load", callback);
	      addEventListenerFn(script, "error", callback);
	      rawDocument.body.appendChild(script);
	      return callback;
	    }
	  }
	
	  var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	  $interpolateMinErr.throwNoconcat = function(text) {
	    throw $interpolateMinErr('noconcat',
	      "Error while interpolating: {0}\nStrict Contextual Escaping disallows " +
	      "interpolations that concatenate multiple expressions when a trusted value is " +
	      "required.  See http://docs.angularjs.org/api/ng.$sce", text);
	  };
	
	  $interpolateMinErr.interr = function(text, err) {
	    return $interpolateMinErr('interr', "Can't interpolate: {0}\n{1}", text, err.toString());
	  };
	
	  /**
	   * @ngdoc provider
	   * @name $interpolateProvider
	   *
	   * @description
	   *
	   * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	   *
	   * <div class="alert alert-danger">
	   * This feature is sometimes used to mix different markup languages, e.g. to wrap an Angular
	   * template within a Python Jinja template (or any other template language). Mixing templating
	   * languages is **very dangerous**. The embedding template language will not safely escape Angular
	   * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	   * security bugs!
	   * </div>
	   *
	   * @example
	   <example name="custom-interpolation-markup" module="customInterpolationApp">
	   <file name="index.html">
	   <script>
	   var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	   customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	   customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	   </script>
	   <div ng-controller="DemoController as demo">
	   //demo.label//
	   </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	   </file>
	   </example>
	   */
	  function $InterpolateProvider() {
	    var startSymbol = '{{';
	    var endSymbol = '}}';
	
	    /**
	     * @ngdoc method
	     * @name $interpolateProvider#startSymbol
	     * @description
	     * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	     * @param {string=} value new value to set the starting symbol to.
	     * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	     */
	    this.startSymbol = function(value) {
	      if (value) {
	        startSymbol = value;
	        return this;
	      } else {
	        return startSymbol;
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $interpolateProvider#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * @param {string=} value new value to set the ending symbol to.
	     * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	     */
	    this.endSymbol = function(value) {
	      if (value) {
	        endSymbol = value;
	        return this;
	      } else {
	        return endSymbol;
	      }
	    };
	
	
	    this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	      var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	      function escape(ch) {
	        return '\\\\\\' + ch;
	      }
	
	      function unescapeText(text) {
	        return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	      }
	
	      function stringify(value) {
	        if (value == null) { // null || undefined
	          return '';
	        }
	        switch (typeof value) {
	          case 'string':
	            break;
	          case 'number':
	            value = '' + value;
	            break;
	          default:
	            value = toJson(value);
	        }
	
	        return value;
	      }
	
	      //TODO: this is the same as the constantWatchDelegate in parse.js
	      function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
	        var unwatch;
	        return unwatch = scope.$watch(function constantInterpolateWatch(scope) {
	          unwatch();
	          return constantInterp(scope);
	        }, listener, objectEquality);
	      }
	
	      /**
	       * @ngdoc service
	       * @name $interpolate
	       * @kind function
	       *
	       * @requires $parse
	       * @requires $sce
	       *
	       * @description
	       *
	       * Compiles a string with markup into an interpolation function. This service is used by the
	       * HTML {@link ng.$compile $compile} service for data binding. See
	       * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	       * interpolation markup.
	       *
	       *
	       * ```js
	       *   var $interpolate = ...; // injected
	       *   var exp = $interpolate('Hello {{name | uppercase}}!');
	       *   expect(exp({name:'Angular'})).toEqual('Hello ANGULAR!');
	       * ```
	       *
	       * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	       * `true`, the interpolation function will return `undefined` unless all embedded expressions
	       * evaluate to a value other than `undefined`.
	       *
	       * ```js
	       *   var $interpolate = ...; // injected
	       *   var context = {greeting: 'Hello', name: undefined };
	       *
	       *   // default "forgiving" mode
	       *   var exp = $interpolate('{{greeting}} {{name}}!');
	       *   expect(exp(context)).toEqual('Hello !');
	       *
	       *   // "allOrNothing" mode
	       *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	       *   expect(exp(context)).toBeUndefined();
	       *   context.name = 'Angular';
	       *   expect(exp(context)).toEqual('Hello Angular!');
	       * ```
	       *
	       * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	       *
	       * ####Escaped Interpolation
	       * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	       * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	       * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	       * or binding.
	       *
	       * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	       * degree, while also enabling code examples to work without relying on the
	       * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	       *
	       * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	       * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	       * interpolation start/end markers with their escaped counterparts.**
	       *
	       * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	       * output when the $interpolate service processes the text. So, for HTML elements interpolated
	       * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	       * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	       * this is typically useful only when user-data is used in rendering a template from the server, or
	       * when otherwise untrusted data is used by a directive.
	       *
	       * <example>
	       *  <file name="index.html">
	       *    <div ng-init="username='A user'">
	       *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	       *        </p>
	       *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	       *        application, but fails to accomplish their task, because the server has correctly
	       *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	       *        characters.</p>
	       *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	       *        from the database by an administrator.</p>
	       *    </div>
	       *  </file>
	       * </example>
	       *
	       * @knownIssue
	       * It is currently not possible for an interpolated expression to contain the interpolation end
	       * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	       * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	       *
	       * @knownIssue
	       * All directives and components must use the standard `{{` `}}` interpolation symbols
	       * in their templates. If you change the application interpolation symbols the {@link $compile}
	       * service will attempt to denormalize the standard symbols to the custom symbols.
	       * The denormalization process is not clever enough to know not to replace instances of the standard
	       * symbols where they would not normally be treated as interpolation symbols. For example in the following
	       * code snippet the closing braces of the literal object will get incorrectly denormalized:
	       *
	       * ```
	       * <div data-context='{"context":{"id":3,"type":"page"}}">
	       * ```
	       *
	       * The workaround is to ensure that such instances are separated by whitespace:
	       * ```
	       * <div data-context='{"context":{"id":3,"type":"page"} }">
	       * ```
	       *
	       * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	       *
	       * @param {string} text The text with markup to interpolate.
	       * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	       *    embedded expression in order to return an interpolation function. Strings with no
	       *    embedded expression will return null for the interpolation function.
	       * @param {string=} trustedContext when provided, the returned function passes the interpolated
	       *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	       *    provides Strict Contextual Escaping for details.
	       * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	       *    unless all embedded expressions evaluate to a value other than `undefined`.
	       * @returns {function(context)} an interpolation function which is used to compute the
	       *    interpolated string. The function has these parameters:
	       *
	       * - `context`: evaluation context for all expressions embedded in the interpolated text
	       */
	      function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	        // Provide a quick exit and simplified result function for text with no interpolation
	        if (!text.length || text.indexOf(startSymbol) === -1) {
	          var constantInterp;
	          if (!mustHaveExpression) {
	            var unescapedText = unescapeText(text);
	            constantInterp = valueFn(unescapedText);
	            constantInterp.exp = text;
	            constantInterp.expressions = [];
	            constantInterp.$$watchDelegate = constantWatchDelegate;
	          }
	          return constantInterp;
	        }
	
	        allOrNothing = !!allOrNothing;
	        var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns = [],
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [];
	
	        while (index < textLength) {
	          if (((startIndex = text.indexOf(startSymbol, index)) != -1) &&
	            ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) != -1)) {
	            if (index !== startIndex) {
	              concat.push(unescapeText(text.substring(index, startIndex)));
	            }
	            exp = text.substring(startIndex + startSymbolLength, endIndex);
	            expressions.push(exp);
	            parseFns.push($parse(exp, parseStringifyInterceptor));
	            index = endIndex + endSymbolLength;
	            expressionPositions.push(concat.length);
	            concat.push('');
	          } else {
	            // we did not find an interpolation, so we have to add the remainder to the separators array
	            if (index !== textLength) {
	              concat.push(unescapeText(text.substring(index)));
	            }
	            break;
	          }
	        }
	
	        // Concatenating expressions makes it hard to reason about whether some combination of
	        // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	        // single expression be used for iframe[src], object[src], etc., we ensure that the value
	        // that's used is assigned or constructed by some JS code somewhere that is more testable or
	        // make it obvious that you bound the value to some user controlled value.  This helps reduce
	        // the load when auditing for XSS issues.
	        if (trustedContext && concat.length > 1) {
	          $interpolateMinErr.throwNoconcat(text);
	        }
	
	        if (!mustHaveExpression || expressions.length) {
	          var compute = function(values) {
	            for (var i = 0, ii = expressions.length; i < ii; i++) {
	              if (allOrNothing && isUndefined(values[i])) return;
	              concat[expressionPositions[i]] = values[i];
	            }
	            return concat.join('');
	          };
	
	          var getValue = function(value) {
	            return trustedContext ?
	              $sce.getTrusted(trustedContext, value) :
	              $sce.valueOf(value);
	          };
	
	          return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	            // all of these properties are undocumented for now
	            exp: text, //just for compatibility with regular watchers created via $watch
	            expressions: expressions,
	            $$watchDelegate: function(scope, listener) {
	              var lastValue;
	              return scope.$watchGroup(parseFns, function interpolateFnWatcher(values, oldValues) {
	                var currValue = compute(values);
	                if (isFunction(listener)) {
	                  listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	                }
	                lastValue = currValue;
	              });
	            }
	          });
	        }
	
	        function parseStringifyInterceptor(value) {
	          try {
	            value = getValue(value);
	            return allOrNothing && !isDefined(value) ? value : stringify(value);
	          } catch (err) {
	            $exceptionHandler($interpolateMinErr.interr(text, err));
	          }
	        }
	      }
	
	
	      /**
	       * @ngdoc method
	       * @name $interpolate#startSymbol
	       * @description
	       * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	       * @returns {string} start symbol.
	       */
	      $interpolate.startSymbol = function() {
	        return startSymbol;
	      };
	
	
	      /**
	       * @ngdoc method
	       * @name $interpolate#endSymbol
	       * @description
	       * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	       *
	       * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	       * the symbol.
	       *
	       * @returns {string} end symbol.
	       */
	      $interpolate.endSymbol = function() {
	        return endSymbol;
	      };
	
	      return $interpolate;
	    }];
	  }
	
	  function $IntervalProvider() {
	    this.$get = ['$rootScope', '$window', '$q', '$$q', '$browser',
	      function($rootScope,   $window,   $q,   $$q,   $browser) {
	        var intervals = {};
	
	
	        /**
	         * @ngdoc service
	         * @name $interval
	         *
	         * @description
	         * Angular's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	         * milliseconds.
	         *
	         * The return value of registering an interval function is a promise. This promise will be
	         * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	         * run indefinitely if `count` is not defined. The value of the notification will be the
	         * number of iterations that have run.
	         * To cancel an interval, call `$interval.cancel(promise)`.
	         *
	         * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	         * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	         * time.
	         *
	         * <div class="alert alert-warning">
	         * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	         * with them.  In particular they are not automatically destroyed when a controller's scope or a
	         * directive's element are destroyed.
	         * You should take this into consideration and make sure to always cancel the interval at the
	         * appropriate moment.  See the example below for more details on how and when to do this.
	         * </div>
	         *
	         * @param {function()} fn A function that should be called repeatedly.
	         * @param {number} delay Number of milliseconds between each function call.
	         * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	         *   indefinitely.
	         * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	         *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	         * @param {...*=} Pass additional parameters to the executed function.
	         * @returns {promise} A promise which will be notified on each iteration.
	         *
	         * @example
	         * <example module="intervalExample">
	         * <file name="index.html">
	         *   <script>
	         *     angular.module('intervalExample', [])
	         *       .controller('ExampleController', ['$scope', '$interval',
	         *         function($scope, $interval) {
	      *           $scope.format = 'M/d/yy h:mm:ss a';
	      *           $scope.blood_1 = 100;
	      *           $scope.blood_2 = 120;
	      *
	      *           var stop;
	      *           $scope.fight = function() {
	      *             // Don't start a new fight if we are already fighting
	      *             if ( angular.isDefined(stop) ) return;
	      *
	      *             stop = $interval(function() {
	      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	      *                 $scope.blood_1 = $scope.blood_1 - 3;
	      *                 $scope.blood_2 = $scope.blood_2 - 4;
	      *               } else {
	      *                 $scope.stopFight();
	      *               }
	      *             }, 100);
	      *           };
	      *
	      *           $scope.stopFight = function() {
	      *             if (angular.isDefined(stop)) {
	      *               $interval.cancel(stop);
	      *               stop = undefined;
	      *             }
	      *           };
	      *
	      *           $scope.resetFight = function() {
	      *             $scope.blood_1 = 100;
	      *             $scope.blood_2 = 120;
	      *           };
	      *
	      *           $scope.$on('$destroy', function() {
	      *             // Make sure that the interval is destroyed too
	      *             $scope.stopFight();
	      *           });
	      *         }])
	         *       // Register the 'myCurrentTime' directive factory method.
	         *       // We inject $interval and dateFilter service since the factory method is DI.
	         *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	         *         function($interval, dateFilter) {
	      *           // return the directive link function. (compile function not needed)
	      *           return function(scope, element, attrs) {
	      *             var format,  // date format
	      *                 stopTime; // so that we can cancel the time updates
	      *
	      *             // used to update the UI
	      *             function updateTime() {
	      *               element.text(dateFilter(new Date(), format));
	      *             }
	      *
	      *             // watch the expression, and update the UI on change.
	      *             scope.$watch(attrs.myCurrentTime, function(value) {
	      *               format = value;
	      *               updateTime();
	      *             });
	      *
	      *             stopTime = $interval(updateTime, 1000);
	      *
	      *             // listen on DOM destroy (removal) event, and cancel the next UI update
	      *             // to prevent updating time after the DOM element was removed.
	      *             element.on('$destroy', function() {
	      *               $interval.cancel(stopTime);
	      *             });
	      *           }
	      *         }]);
	         *   </script>
	         *
	         *   <div>
	         *     <div ng-controller="ExampleController">
	         *       <label>Date format: <input ng-model="format"></label> <hr/>
	         *       Current time is: <span my-current-time="format"></span>
	         *       <hr/>
	         *       Blood 1 : <font color='red'>{{blood_1}}</font>
	         *       Blood 2 : <font color='red'>{{blood_2}}</font>
	         *       <button type="button" data-ng-click="fight()">Fight</button>
	         *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	         *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	         *     </div>
	         *   </div>
	         *
	         * </file>
	         * </example>
	         */
	        function interval(fn, delay, count, invokeApply) {
	          var hasParams = arguments.length > 4,
	            args = hasParams ? sliceArgs(arguments, 4) : [],
	            setInterval = $window.setInterval,
	            clearInterval = $window.clearInterval,
	            iteration = 0,
	            skipApply = (isDefined(invokeApply) && !invokeApply),
	            deferred = (skipApply ? $$q : $q).defer(),
	            promise = deferred.promise;
	
	          count = isDefined(count) ? count : 0;
	
	          promise.$$intervalId = setInterval(function tick() {
	            if (skipApply) {
	              $browser.defer(callback);
	            } else {
	              $rootScope.$evalAsync(callback);
	            }
	            deferred.notify(iteration++);
	
	            if (count > 0 && iteration >= count) {
	              deferred.resolve(iteration);
	              clearInterval(promise.$$intervalId);
	              delete intervals[promise.$$intervalId];
	            }
	
	            if (!skipApply) $rootScope.$apply();
	
	          }, delay);
	
	          intervals[promise.$$intervalId] = deferred;
	
	          return promise;
	
	          function callback() {
	            if (!hasParams) {
	              fn(iteration);
	            } else {
	              fn.apply(null, args);
	            }
	          }
	        }
	
	
	        /**
	         * @ngdoc method
	         * @name $interval#cancel
	         *
	         * @description
	         * Cancels a task associated with the `promise`.
	         *
	         * @param {Promise=} promise returned by the `$interval` function.
	         * @returns {boolean} Returns `true` if the task was successfully canceled.
	         */
	        interval.cancel = function(promise) {
	          if (promise && promise.$$intervalId in intervals) {
	            intervals[promise.$$intervalId].reject('canceled');
	            $window.clearInterval(promise.$$intervalId);
	            delete intervals[promise.$$intervalId];
	            return true;
	          }
	          return false;
	        };
	
	        return interval;
	      }];
	  }
	
	  /**
	   * @ngdoc service
	   * @name $locale
	   *
	   * @description
	   * $locale service provides localization rules for various Angular components. As of right now the
	   * only public api is:
	   *
	   * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	   */
	
	  var PATH_MATCH = /^([^\?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	  var $locationMinErr = minErr('$location');
	
	
	  /**
	   * Encode path using encodeUriSegment, ignoring forward slashes
	   *
	   * @param {string} path Path to encode
	   * @returns {string}
	   */
	  function encodePath(path) {
	    var segments = path.split('/'),
	      i = segments.length;
	
	    while (i--) {
	      segments[i] = encodeUriSegment(segments[i]);
	    }
	
	    return segments.join('/');
	  }
	
	  function parseAbsoluteUrl(absoluteUrl, locationObj) {
	    var parsedUrl = urlResolve(absoluteUrl);
	
	    locationObj.$$protocol = parsedUrl.protocol;
	    locationObj.$$host = parsedUrl.hostname;
	    locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	  }
	
	
	  function parseAppUrl(relativeUrl, locationObj) {
	    var prefixed = (relativeUrl.charAt(0) !== '/');
	    if (prefixed) {
	      relativeUrl = '/' + relativeUrl;
	    }
	    var match = urlResolve(relativeUrl);
	    locationObj.$$path = decodeURIComponent(prefixed && match.pathname.charAt(0) === '/' ?
	      match.pathname.substring(1) : match.pathname);
	    locationObj.$$search = parseKeyValue(match.search);
	    locationObj.$$hash = decodeURIComponent(match.hash);
	
	    // make sure path starts with '/';
	    if (locationObj.$$path && locationObj.$$path.charAt(0) != '/') {
	      locationObj.$$path = '/' + locationObj.$$path;
	    }
	  }
	
	  function startsWith(haystack, needle) {
	    return haystack.lastIndexOf(needle, 0) === 0;
	  }
	
	  /**
	   *
	   * @param {string} base
	   * @param {string} url
	   * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	   *                   the expected string.
	   */
	  function stripBaseUrl(base, url) {
	    if (startsWith(url, base)) {
	      return url.substr(base.length);
	    }
	  }
	
	
	  function stripHash(url) {
	    var index = url.indexOf('#');
	    return index == -1 ? url : url.substr(0, index);
	  }
	
	  function trimEmptyHash(url) {
	    return url.replace(/(#.+)|#$/, '$1');
	  }
	
	
	  function stripFile(url) {
	    return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	  }
	
	  /* return the server only (scheme://host:port) */
	  function serverBase(url) {
	    return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	  }
	
	
	  /**
	   * LocationHtml5Url represents an url
	   * This object is exposed as $location service when HTML5 mode is enabled and supported
	   *
	   * @constructor
	   * @param {string} appBase application base URL
	   * @param {string} appBaseNoFile application base URL stripped of any filename
	   * @param {string} basePrefix url path prefix
	   */
	  function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	    this.$$html5 = true;
	    basePrefix = basePrefix || '';
	    parseAbsoluteUrl(appBase, this);
	
	
	    /**
	     * Parse given html5 (regular) url string into properties
	     * @param {string} url HTML5 url
	     * @private
	     */
	    this.$$parse = function(url) {
	      var pathUrl = stripBaseUrl(appBaseNoFile, url);
	      if (!isString(pathUrl)) {
	        throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	      }
	
	      parseAppUrl(pathUrl, this);
	
	      if (!this.$$path) {
	        this.$$path = '/';
	      }
	
	      this.$$compose();
	    };
	
	    /**
	     * Compose url and update `absUrl` property
	     * @private
	     */
	    this.$$compose = function() {
	      var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	      this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	      this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
	    };
	
	    this.$$parseLinkUrl = function(url, relHref) {
	      if (relHref && relHref[0] === '#') {
	        // special case for links to hash fragments:
	        // keep the old url and only replace the hash fragment
	        this.hash(relHref.slice(1));
	        return true;
	      }
	      var appUrl, prevAppUrl;
	      var rewrittenUrl;
	
	      if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
	        prevAppUrl = appUrl;
	        if (isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
	          rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
	        } else {
	          rewrittenUrl = appBase + prevAppUrl;
	        }
	      } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
	        rewrittenUrl = appBaseNoFile + appUrl;
	      } else if (appBaseNoFile == url + '/') {
	        rewrittenUrl = appBaseNoFile;
	      }
	      if (rewrittenUrl) {
	        this.$$parse(rewrittenUrl);
	      }
	      return !!rewrittenUrl;
	    };
	  }
	
	
	  /**
	   * LocationHashbangUrl represents url
	   * This object is exposed as $location service when developer doesn't opt into html5 mode.
	   * It also serves as the base class for html5 mode fallback on legacy browsers.
	   *
	   * @constructor
	   * @param {string} appBase application base URL
	   * @param {string} appBaseNoFile application base URL stripped of any filename
	   * @param {string} hashPrefix hashbang prefix
	   */
	  function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	    parseAbsoluteUrl(appBase, this);
	
	
	    /**
	     * Parse given hashbang url into properties
	     * @param {string} url Hashbang url
	     * @private
	     */
	    this.$$parse = function(url) {
	      var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
	      var withoutHashUrl;
	
	      if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	        // The rest of the url starts with a hash so we have
	        // got either a hashbang path or a plain hash fragment
	        withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
	        if (isUndefined(withoutHashUrl)) {
	          // There was no hashbang prefix so we just have a hash fragment
	          withoutHashUrl = withoutBaseUrl;
	        }
	
	      } else {
	        // There was no hashbang path nor hash fragment:
	        // If we are in HTML5 mode we use what is left as the path;
	        // Otherwise we ignore what is left
	        if (this.$$html5) {
	          withoutHashUrl = withoutBaseUrl;
	        } else {
	          withoutHashUrl = '';
	          if (isUndefined(withoutBaseUrl)) {
	            appBase = url;
	            this.replace();
	          }
	        }
	      }
	
	      parseAppUrl(withoutHashUrl, this);
	
	      this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	      this.$$compose();
	
	      /*
	       * In Windows, on an anchor node on documents loaded from
	       * the filesystem, the browser will return a pathname
	       * prefixed with the drive name ('/C:/path') when a
	       * pathname without a drive is set:
	       *  * a.setAttribute('href', '/foo')
	       *   * a.pathname === '/C:/foo' //true
	       *
	       * Inside of Angular, we're always using pathnames that
	       * do not include drive names for routing.
	       */
	      function removeWindowsDriveName(path, url, base) {
	        /*
	         Matches paths for file protocol on windows,
	         such as /C:/foo/bar, and captures only /foo/bar.
	         */
	        var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	        var firstPathSegmentMatch;
	
	        //Get the relative path from the input URL.
	        if (startsWith(url, base)) {
	          url = url.replace(base, '');
	        }
	
	        // The input URL intentionally contains a first path segment that ends with a colon.
	        if (windowsFilePathExp.exec(url)) {
	          return path;
	        }
	
	        firstPathSegmentMatch = windowsFilePathExp.exec(path);
	        return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	      }
	    };
	
	    /**
	     * Compose hashbang url and update `absUrl` property
	     * @private
	     */
	    this.$$compose = function() {
	      var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	      this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	      this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
	    };
	
	    this.$$parseLinkUrl = function(url, relHref) {
	      if (stripHash(appBase) == stripHash(url)) {
	        this.$$parse(url);
	        return true;
	      }
	      return false;
	    };
	  }
	
	
	  /**
	   * LocationHashbangUrl represents url
	   * This object is exposed as $location service when html5 history api is enabled but the browser
	   * does not support it.
	   *
	   * @constructor
	   * @param {string} appBase application base URL
	   * @param {string} appBaseNoFile application base URL stripped of any filename
	   * @param {string} hashPrefix hashbang prefix
	   */
	  function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	    this.$$html5 = true;
	    LocationHashbangUrl.apply(this, arguments);
	
	    this.$$parseLinkUrl = function(url, relHref) {
	      if (relHref && relHref[0] === '#') {
	        // special case for links to hash fragments:
	        // keep the old url and only replace the hash fragment
	        this.hash(relHref.slice(1));
	        return true;
	      }
	
	      var rewrittenUrl;
	      var appUrl;
	
	      if (appBase == stripHash(url)) {
	        rewrittenUrl = url;
	      } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
	        rewrittenUrl = appBase + hashPrefix + appUrl;
	      } else if (appBaseNoFile === url + '/') {
	        rewrittenUrl = appBaseNoFile;
	      }
	      if (rewrittenUrl) {
	        this.$$parse(rewrittenUrl);
	      }
	      return !!rewrittenUrl;
	    };
	
	    this.$$compose = function() {
	      var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	      this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	      // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	      this.$$absUrl = appBase + hashPrefix + this.$$url;
	    };
	
	  }
	
	
	  var locationPrototype = {
	
	    /**
	     * Are we in html5 mode?
	     * @private
	     */
	    $$html5: false,
	
	    /**
	     * Has any change been replacing?
	     * @private
	     */
	    $$replace: false,
	
	    /**
	     * @ngdoc method
	     * @name $location#absUrl
	     *
	     * @description
	     * This method is getter only.
	     *
	     * Return full url representation with all segments encoded according to rules specified in
	     * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	     *
	     *
	     * ```js
	     * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	     * var absUrl = $location.absUrl();
	     * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	     * ```
	     *
	     * @return {string} full url
	     */
	    absUrl: locationGetter('$$absUrl'),
	
	    /**
	     * @ngdoc method
	     * @name $location#url
	     *
	     * @description
	     * This method is getter / setter.
	     *
	     * Return url (e.g. `/path?a=b#hash`) when called without any parameter.
	     *
	     * Change path, search and hash, when called with parameter and return `$location`.
	     *
	     *
	     * ```js
	     * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	     * var url = $location.url();
	     * // => "/some/path?foo=bar&baz=xoxo"
	     * ```
	     *
	     * @param {string=} url New url without base prefix (e.g. `/path?a=b#hash`)
	     * @return {string} url
	     */
	    url: function(url) {
	      if (isUndefined(url)) {
	        return this.$$url;
	      }
	
	      var match = PATH_MATCH.exec(url);
	      if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	      if (match[2] || match[1] || url === '') this.search(match[3] || '');
	      this.hash(match[5] || '');
	
	      return this;
	    },
	
	    /**
	     * @ngdoc method
	     * @name $location#protocol
	     *
	     * @description
	     * This method is getter only.
	     *
	     * Return protocol of current url.
	     *
	     *
	     * ```js
	     * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	     * var protocol = $location.protocol();
	     * // => "http"
	     * ```
	     *
	     * @return {string} protocol of current url
	     */
	    protocol: locationGetter('$$protocol'),
	
	    /**
	     * @ngdoc method
	     * @name $location#host
	     *
	     * @description
	     * This method is getter only.
	     *
	     * Return host of current url.
	     *
	     * Note: compared to the non-angular version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	     *
	     *
	     * ```js
	     * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	     * var host = $location.host();
	     * // => "example.com"
	     *
	     * // given url http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	     * host = $location.host();
	     * // => "example.com"
	     * host = location.host;
	     * // => "example.com:8080"
	     * ```
	     *
	     * @return {string} host of current url.
	     */
	    host: locationGetter('$$host'),
	
	    /**
	     * @ngdoc method
	     * @name $location#port
	     *
	     * @description
	     * This method is getter only.
	     *
	     * Return port of current url.
	     *
	     *
	     * ```js
	     * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	     * var port = $location.port();
	     * // => 80
	     * ```
	     *
	     * @return {Number} port
	     */
	    port: locationGetter('$$port'),
	
	    /**
	     * @ngdoc method
	     * @name $location#path
	     *
	     * @description
	     * This method is getter / setter.
	     *
	     * Return path of current url when called without any parameter.
	     *
	     * Change path when called with parameter and return `$location`.
	     *
	     * Note: Path should always begin with forward slash (/), this method will add the forward slash
	     * if it is missing.
	     *
	     *
	     * ```js
	     * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	     * var path = $location.path();
	     * // => "/some/path"
	     * ```
	     *
	     * @param {(string|number)=} path New path
	     * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	     */
	    path: locationGetterSetter('$$path', function(path) {
	      path = path !== null ? path.toString() : '';
	      return path.charAt(0) == '/' ? path : '/' + path;
	    }),
	
	    /**
	     * @ngdoc method
	     * @name $location#search
	     *
	     * @description
	     * This method is getter / setter.
	     *
	     * Return search part (as object) of current url when called without any parameter.
	     *
	     * Change search part when called with parameter and return `$location`.
	     *
	     *
	     * ```js
	     * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	     * var searchObject = $location.search();
	     * // => {foo: 'bar', baz: 'xoxo'}
	     *
	     * // set foo to 'yipee'
	     * $location.search('foo', 'yipee');
	     * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	     * ```
	     *
	     * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	     * hash object.
	     *
	     * When called with a single argument the method acts as a setter, setting the `search` component
	     * of `$location` to the specified value.
	     *
	     * If the argument is a hash object containing an array of values, these values will be encoded
	     * as duplicate search parameters in the url.
	     *
	     * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	     * will override only a single search property.
	     *
	     * If `paramValue` is an array, it will override the property of the `search` component of
	     * `$location` specified via the first argument.
	     *
	     * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	     *
	     * If `paramValue` is `true`, the property specified via the first argument will be added with no
	     * value nor trailing equal sign.
	     *
	     * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	     * one or more arguments returns `$location` object itself.
	     */
	    search: function(search, paramValue) {
	      switch (arguments.length) {
	        case 0:
	          return this.$$search;
	        case 1:
	          if (isString(search) || isNumber(search)) {
	            search = search.toString();
	            this.$$search = parseKeyValue(search);
	          } else if (isObject(search)) {
	            search = copy(search, {});
	            // remove object undefined or null properties
	            forEach(search, function(value, key) {
	              if (value == null) delete search[key];
	            });
	
	            this.$$search = search;
	          } else {
	            throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	          }
	          break;
	        default:
	          if (isUndefined(paramValue) || paramValue === null) {
	            delete this.$$search[search];
	          } else {
	            this.$$search[search] = paramValue;
	          }
	      }
	
	      this.$$compose();
	      return this;
	    },
	
	    /**
	     * @ngdoc method
	     * @name $location#hash
	     *
	     * @description
	     * This method is getter / setter.
	     *
	     * Returns the hash fragment when called without any parameters.
	     *
	     * Changes the hash fragment when called with a parameter and returns `$location`.
	     *
	     *
	     * ```js
	     * // given url http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	     * var hash = $location.hash();
	     * // => "hashValue"
	     * ```
	     *
	     * @param {(string|number)=} hash New hash fragment
	     * @return {string} hash
	     */
	    hash: locationGetterSetter('$$hash', function(hash) {
	      return hash !== null ? hash.toString() : '';
	    }),
	
	    /**
	     * @ngdoc method
	     * @name $location#replace
	     *
	     * @description
	     * If called, all changes to $location during the current `$digest` will replace the current history
	     * record, instead of adding a new one.
	     */
	    replace: function() {
	      this.$$replace = true;
	      return this;
	    }
	  };
	
	  forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	    Location.prototype = Object.create(locationPrototype);
	
	    /**
	     * @ngdoc method
	     * @name $location#state
	     *
	     * @description
	     * This method is getter / setter.
	     *
	     * Return the history state object when called without any parameter.
	     *
	     * Change the history state object when called with one parameter and return `$location`.
	     * The state object is later passed to `pushState` or `replaceState`.
	     *
	     * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	     * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	     * older browsers (like IE9 or Android < 4.0), don't use this method.
	     *
	     * @param {object=} state State object for pushState or replaceState
	     * @return {object} state
	     */
	    Location.prototype.state = function(state) {
	      if (!arguments.length) {
	        return this.$$state;
	      }
	
	      if (Location !== LocationHtml5Url || !this.$$html5) {
	        throw $locationMinErr('nostate', 'History API state support is available only ' +
	          'in HTML5 mode and only in browsers supporting HTML5 History API');
	      }
	      // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	      // but we're changing the $$state reference to $browser.state() during the $digest
	      // so the modification window is narrow.
	      this.$$state = isUndefined(state) ? null : state;
	
	      return this;
	    };
	  });
	
	
	  function locationGetter(property) {
	    return function() {
	      return this[property];
	    };
	  }
	
	
	  function locationGetterSetter(property, preprocess) {
	    return function(value) {
	      if (isUndefined(value)) {
	        return this[property];
	      }
	
	      this[property] = preprocess(value);
	      this.$$compose();
	
	      return this;
	    };
	  }
	
	
	  /**
	   * @ngdoc service
	   * @name $location
	   *
	   * @requires $rootElement
	   *
	   * @description
	   * The $location service parses the URL in the browser address bar (based on the
	   * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	   * available to your application. Changes to the URL in the address bar are reflected into
	   * $location service and changes to $location are reflected into the browser address bar.
	   *
	   * **The $location service:**
	   *
	   * - Exposes the current URL in the browser address bar, so you can
	   *   - Watch and observe the URL.
	   *   - Change the URL.
	   * - Synchronizes the URL with the browser when the user
	   *   - Changes the address bar.
	   *   - Clicks the back or forward button (or clicks a History link).
	   *   - Clicks on a link.
	   * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	   *
	   * For more information see {@link guide/$location Developer Guide: Using $location}
	   */
	
	  /**
	   * @ngdoc provider
	   * @name $locationProvider
	   * @description
	   * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	   */
	  function $LocationProvider() {
	    var hashPrefix = '',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	    /**
	     * @ngdoc method
	     * @name $locationProvider#hashPrefix
	     * @description
	     * @param {string=} prefix Prefix for hash part (containing path and search)
	     * @returns {*} current value if used as getter or itself (chaining) if used as setter
	     */
	    this.hashPrefix = function(prefix) {
	      if (isDefined(prefix)) {
	        hashPrefix = prefix;
	        return this;
	      } else {
	        return hashPrefix;
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $locationProvider#html5Mode
	     * @description
	     * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	     *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	     *   properties:
	     *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	     *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	     *     support `pushState`.
	     *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	     *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	     *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	     *     See the {@link guide/$location $location guide for more information}
	     *   - **rewriteLinks** - `{boolean}` - (default: `true`) When html5Mode is enabled,
	     *     enables/disables url rewriting for relative links.
	     *
	     * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	     */
	    this.html5Mode = function(mode) {
	      if (isBoolean(mode)) {
	        html5Mode.enabled = mode;
	        return this;
	      } else if (isObject(mode)) {
	
	        if (isBoolean(mode.enabled)) {
	          html5Mode.enabled = mode.enabled;
	        }
	
	        if (isBoolean(mode.requireBase)) {
	          html5Mode.requireBase = mode.requireBase;
	        }
	
	        if (isBoolean(mode.rewriteLinks)) {
	          html5Mode.rewriteLinks = mode.rewriteLinks;
	        }
	
	        return this;
	      } else {
	        return html5Mode;
	      }
	    };
	
	    /**
	     * @ngdoc event
	     * @name $location#$locationChangeStart
	     * @eventType broadcast on root scope
	     * @description
	     * Broadcasted before a URL will change.
	     *
	     * This change can be prevented by calling
	     * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	     * details about event object. Upon successful change
	     * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	     *
	     * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	     * the browser supports the HTML5 History API.
	     *
	     * @param {Object} angularEvent Synthetic event object.
	     * @param {string} newUrl New URL
	     * @param {string=} oldUrl URL that was before it was changed.
	     * @param {string=} newState New history state object
	     * @param {string=} oldState History state object that was before it was changed.
	     */
	
	    /**
	     * @ngdoc event
	     * @name $location#$locationChangeSuccess
	     * @eventType broadcast on root scope
	     * @description
	     * Broadcasted after a URL was changed.
	     *
	     * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	     * the browser supports the HTML5 History API.
	     *
	     * @param {Object} angularEvent Synthetic event object.
	     * @param {string} newUrl New URL
	     * @param {string=} oldUrl URL that was before it was changed.
	     * @param {string=} newState New history state object
	     * @param {string=} oldState History state object that was before it was changed.
	     */
	
	    this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	        var $location,
	          LocationMode,
	          baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	          initialUrl = $browser.url(),
	          appBase;
	
	        if (html5Mode.enabled) {
	          if (!baseHref && html5Mode.requireBase) {
	            throw $locationMinErr('nobase',
	              "$location in HTML5 mode requires a <base> tag to be present!");
	          }
	          appBase = serverBase(initialUrl) + (baseHref || '/');
	          LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	        } else {
	          appBase = stripHash(initialUrl);
	          LocationMode = LocationHashbangUrl;
	        }
	        var appBaseNoFile = stripFile(appBase);
	
	        $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	        $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	        $location.$$state = $browser.state();
	
	        var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	        function setBrowserUrlWithFallback(url, replace, state) {
	          var oldUrl = $location.url();
	          var oldState = $location.$$state;
	          try {
	            $browser.url(url, replace, state);
	
	            // Make sure $location.state() returns referentially identical (not just deeply equal)
	            // state object; this makes possible quick checking if the state changed in the digest
	            // loop. Checking deep equality would be too expensive.
	            $location.$$state = $browser.state();
	          } catch (e) {
	            // Restore old values if pushState fails
	            $location.url(oldUrl);
	            $location.$$state = oldState;
	
	            throw e;
	          }
	        }
	
	        $rootElement.on('click', function(event) {
	          // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	          // currently we open nice url link and redirect then
	
	          if (!html5Mode.rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which == 2 || event.button == 2) return;
	
	          var elm = jqLite(event.target);
	
	          // traverse the DOM up to find first A tag
	          while (nodeName_(elm[0]) !== 'a') {
	            // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	            if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	          }
	
	          var absHref = elm.prop('href');
	          // get the actual href attribute - see
	          // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	          var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	          if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	            // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	            // an animation.
	            absHref = urlResolve(absHref.animVal).href;
	          }
	
	          // Ignore when url is started with javascript: or mailto:
	          if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	          if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	            if ($location.$$parseLinkUrl(absHref, relHref)) {
	              // We do a preventDefault for all urls that are part of the angular application,
	              // in html5mode and also without, so that we are able to abort navigation without
	              // getting double entries in the location history.
	              event.preventDefault();
	              // update location manually
	              if ($location.absUrl() != $browser.url()) {
	                $rootScope.$apply();
	                // hack to work around FF6 bug 684208 when scenario runner clicks on links
	                $window.angular['ff-684208-preventDefault'] = true;
	              }
	            }
	          }
	        });
	
	
	        // rewrite hashbang url <> html5 url
	        if (trimEmptyHash($location.absUrl()) != trimEmptyHash(initialUrl)) {
	          $browser.url($location.absUrl(), true);
	        }
	
	        var initializing = true;
	
	        // update $location when $browser url changes
	        $browser.onUrlChange(function(newUrl, newState) {
	
	          if (isUndefined(stripBaseUrl(appBaseNoFile, newUrl))) {
	            // If we are navigating outside of the app then force a reload
	            $window.location.href = newUrl;
	            return;
	          }
	
	          $rootScope.$evalAsync(function() {
	            var oldUrl = $location.absUrl();
	            var oldState = $location.$$state;
	            var defaultPrevented;
	            newUrl = trimEmptyHash(newUrl);
	            $location.$$parse(newUrl);
	            $location.$$state = newState;
	
	            defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	              newState, oldState).defaultPrevented;
	
	            // if the location was changed by a `$locationChangeStart` handler then stop
	            // processing this location change
	            if ($location.absUrl() !== newUrl) return;
	
	            if (defaultPrevented) {
	              $location.$$parse(oldUrl);
	              $location.$$state = oldState;
	              setBrowserUrlWithFallback(oldUrl, false, oldState);
	            } else {
	              initializing = false;
	              afterLocationChange(oldUrl, oldState);
	            }
	          });
	          if (!$rootScope.$$phase) $rootScope.$digest();
	        });
	
	        // update browser
	        $rootScope.$watch(function $locationWatch() {
	          var oldUrl = trimEmptyHash($browser.url());
	          var newUrl = trimEmptyHash($location.absUrl());
	          var oldState = $browser.state();
	          var currentReplace = $location.$$replace;
	          var urlOrStateChanged = oldUrl !== newUrl ||
	            ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	          if (initializing || urlOrStateChanged) {
	            initializing = false;
	
	            $rootScope.$evalAsync(function() {
	              var newUrl = $location.absUrl();
	              var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	                $location.$$state, oldState).defaultPrevented;
	
	              // if the location was changed by a `$locationChangeStart` handler then stop
	              // processing this location change
	              if ($location.absUrl() !== newUrl) return;
	
	              if (defaultPrevented) {
	                $location.$$parse(oldUrl);
	                $location.$$state = oldState;
	              } else {
	                if (urlOrStateChanged) {
	                  setBrowserUrlWithFallback(newUrl, currentReplace,
	                    oldState === $location.$$state ? null : $location.$$state);
	                }
	                afterLocationChange(oldUrl, oldState);
	              }
	            });
	          }
	
	          $location.$$replace = false;
	
	          // we don't need to return anything because $evalAsync will make the digest loop dirty when
	          // there is a change
	        });
	
	        return $location;
	
	        function afterLocationChange(oldUrl, oldState) {
	          $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	            $location.$$state, oldState);
	        }
	      }];
	  }
	
	  /**
	   * @ngdoc service
	   * @name $log
	   * @requires $window
	   *
	   * @description
	   * Simple service for logging. Default implementation safely writes the message
	   * into the browser's console (if present).
	   *
	   * The main purpose of this service is to simplify debugging and troubleshooting.
	   *
	   * The default is to log `debug` messages. You can use
	   * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	   *
	   * @example
	   <example module="logExample">
	   <file name="script.js">
	   angular.module('logExample', [])
	   .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	   </file>
	   <file name="index.html">
	   <div ng-controller="LogController">
	   <p>Reload this page with open console, enter text and hit the log button...</p>
	   <label>Message:
	   <input type="text" ng-model="message" /></label>
	   <button ng-click="$log.log(message)">log</button>
	   <button ng-click="$log.warn(message)">warn</button>
	   <button ng-click="$log.info(message)">info</button>
	   <button ng-click="$log.error(message)">error</button>
	   <button ng-click="$log.debug(message)">debug</button>
	   </div>
	   </file>
	   </example>
	   */
	
	  /**
	   * @ngdoc provider
	   * @name $logProvider
	   * @description
	   * Use the `$logProvider` to configure how the application logs messages
	   */
	  function $LogProvider() {
	    var debug = true,
	      self = this;
	
	    /**
	     * @ngdoc method
	     * @name $logProvider#debugEnabled
	     * @description
	     * @param {boolean=} flag enable or disable debug level messages
	     * @returns {*} current value if used as getter or itself (chaining) if used as setter
	     */
	    this.debugEnabled = function(flag) {
	      if (isDefined(flag)) {
	        debug = flag;
	        return this;
	      } else {
	        return debug;
	      }
	    };
	
	    this.$get = ['$window', function($window) {
	      return {
	        /**
	         * @ngdoc method
	         * @name $log#log
	         *
	         * @description
	         * Write a log message
	         */
	        log: consoleLog('log'),
	
	        /**
	         * @ngdoc method
	         * @name $log#info
	         *
	         * @description
	         * Write an information message
	         */
	        info: consoleLog('info'),
	
	        /**
	         * @ngdoc method
	         * @name $log#warn
	         *
	         * @description
	         * Write a warning message
	         */
	        warn: consoleLog('warn'),
	
	        /**
	         * @ngdoc method
	         * @name $log#error
	         *
	         * @description
	         * Write an error message
	         */
	        error: consoleLog('error'),
	
	        /**
	         * @ngdoc method
	         * @name $log#debug
	         *
	         * @description
	         * Write a debug message
	         */
	        debug: (function() {
	          var fn = consoleLog('debug');
	
	          return function() {
	            if (debug) {
	              fn.apply(self, arguments);
	            }
	          };
	        }())
	      };
	
	      function formatError(arg) {
	        if (arg instanceof Error) {
	          if (arg.stack) {
	            arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	          } else if (arg.sourceURL) {
	            arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	          }
	        }
	        return arg;
	      }
	
	      function consoleLog(type) {
	        var console = $window.console || {},
	          logFn = console[type] || console.log || noop,
	          hasApply = false;
	
	        // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
	        // The reason behind this is that console.log has type "object" in IE8...
	        try {
	          hasApply = !!logFn.apply;
	        } catch (e) {}
	
	        if (hasApply) {
	          return function() {
	            var args = [];
	            forEach(arguments, function(arg) {
	              args.push(formatError(arg));
	            });
	            return logFn.apply(console, args);
	          };
	        }
	
	        // we are IE which either doesn't have window.console => this is noop and we do nothing,
	        // or we are IE where console.log doesn't have apply so we log at least first 2 args
	        return function(arg1, arg2) {
	          logFn(arg1, arg2 == null ? '' : arg2);
	        };
	      }
	    }];
	  }
	
	  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	   *     Any commits to this file should be reviewed with security in mind.  *
	   *   Changes to this file can potentially create security vulnerabilities. *
	   *          An approval from 2 Core members with history of modifying      *
	   *                         this file is required.                          *
	   *                                                                         *
	   *  Does the change somehow allow for arbitrary javascript to be executed? *
	   *    Or allows for someone to change the prototype of built-in objects?   *
	   *     Or gives undesired access to variables likes document or window?    *
	   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	  var $parseMinErr = minErr('$parse');
	
	// Sandboxing Angular Expressions
	// ------------------------------
	// Angular expressions are generally considered safe because these expressions only have direct
	// access to `$scope` and locals. However, one can obtain the ability to execute arbitrary JS code by
	// obtaining a reference to native JS functions such as the Function constructor.
	//
	// As an example, consider the following Angular expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// This sandboxing technique is not perfect and doesn't aim to be. The goal is to prevent exploits
	// against the expression language, but not to prevent exploits that were enabled by exposing
	// sensitive JavaScript or browser APIs on Scope. Exposing such objects on a Scope is never a good
	// practice and therefore we are not even trying to protect against interaction with an object
	// explicitly exposed in this way.
	//
	// In general, it is not possible to access a Window object from an angular expression unless a
	// window or some DOM object that has a reference to window is published onto a Scope.
	// Similarly we prevent invocations of function known to be dangerous, as well as assignments to
	// native objects.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	  function ensureSafeMemberName(name, fullExpression) {
	    if (name === "__defineGetter__" || name === "__defineSetter__"
	      || name === "__lookupGetter__" || name === "__lookupSetter__"
	      || name === "__proto__") {
	      throw $parseMinErr('isecfld',
	        'Attempting to access a disallowed field in Angular expressions! '
	        + 'Expression: {0}', fullExpression);
	    }
	    return name;
	  }
	
	  function getStringValue(name) {
	    // Property names must be strings. This means that non-string objects cannot be used
	    // as keys in an object. Any non-string object, including a number, is typecasted
	    // into a string via the toString method.
	    // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	    //
	    // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	    // to a string. It's not always possible. If `name` is an object and its `toString` method is
	    // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	    //
	    // TypeError: Cannot convert object to primitive value
	    //
	    // For performance reasons, we don't catch this error here and allow it to propagate up the call
	    // stack. Note that you'll get the same error in JavaScript if you try to access a property using
	    // such a 'broken' object as a key.
	    return name + '';
	  }
	
	  function ensureSafeObject(obj, fullExpression) {
	    // nifty check if obj is Function that is fast and works across iframes and other contexts
	    if (obj) {
	      if (obj.constructor === obj) {
	        throw $parseMinErr('isecfn',
	          'Referencing Function in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	      } else if (// isWindow(obj)
	      obj.window === obj) {
	        throw $parseMinErr('isecwindow',
	          'Referencing the Window in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	      } else if (// isElement(obj)
	      obj.children && (obj.nodeName || (obj.prop && obj.attr && obj.find))) {
	        throw $parseMinErr('isecdom',
	          'Referencing DOM nodes in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	      } else if (// block Object so that we can't get hold of dangerous Object.* methods
	      obj === Object) {
	        throw $parseMinErr('isecobj',
	          'Referencing Object in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	      }
	    }
	    return obj;
	  }
	
	  var CALL = Function.prototype.call;
	  var APPLY = Function.prototype.apply;
	  var BIND = Function.prototype.bind;
	
	  function ensureSafeFunction(obj, fullExpression) {
	    if (obj) {
	      if (obj.constructor === obj) {
	        throw $parseMinErr('isecfn',
	          'Referencing Function in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	      } else if (obj === CALL || obj === APPLY || obj === BIND) {
	        throw $parseMinErr('isecff',
	          'Referencing call, apply or bind in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	      }
	    }
	  }
	
	  function ensureSafeAssignContext(obj, fullExpression) {
	    if (obj) {
	      if (obj === (0).constructor || obj === (false).constructor || obj === ''.constructor ||
	        obj === {}.constructor || obj === [].constructor || obj === Function.constructor) {
	        throw $parseMinErr('isecaf',
	          'Assigning to a constructor is disallowed! Expression: {0}', fullExpression);
	      }
	    }
	  }
	
	  var OPERATORS = createMap();
	  forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	  var ESCAPE = {"n":"\n", "f":"\f", "r":"\r", "t":"\t", "v":"\v", "'":"'", '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	  /**
	   * @constructor
	   */
	  var Lexer = function(options) {
	    this.options = options;
	  };
	
	  Lexer.prototype = {
	    constructor: Lexer,
	
	    lex: function(text) {
	      this.text = text;
	      this.index = 0;
	      this.tokens = [];
	
	      while (this.index < this.text.length) {
	        var ch = this.text.charAt(this.index);
	        if (ch === '"' || ch === "'") {
	          this.readString(ch);
	        } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	          this.readNumber();
	        } else if (this.isIdentifierStart(this.peekMultichar())) {
	          this.readIdent();
	        } else if (this.is(ch, '(){}[].,;:?')) {
	          this.tokens.push({index: this.index, text: ch});
	          this.index++;
	        } else if (this.isWhitespace(ch)) {
	          this.index++;
	        } else {
	          var ch2 = ch + this.peek();
	          var ch3 = ch2 + this.peek(2);
	          var op1 = OPERATORS[ch];
	          var op2 = OPERATORS[ch2];
	          var op3 = OPERATORS[ch3];
	          if (op1 || op2 || op3) {
	            var token = op3 ? ch3 : (op2 ? ch2 : ch);
	            this.tokens.push({index: this.index, text: token, operator: true});
	            this.index += token.length;
	          } else {
	            this.throwError('Unexpected next character ', this.index, this.index + 1);
	          }
	        }
	      }
	      return this.tokens;
	    },
	
	    is: function(ch, chars) {
	      return chars.indexOf(ch) !== -1;
	    },
	
	    peek: function(i) {
	      var num = i || 1;
	      return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	    },
	
	    isNumber: function(ch) {
	      return ('0' <= ch && ch <= '9') && typeof ch === "string";
	    },
	
	    isWhitespace: function(ch) {
	      // IE treats non-breaking space as \u00A0
	      return (ch === ' ' || ch === '\r' || ch === '\t' ||
	      ch === '\n' || ch === '\v' || ch === '\u00A0');
	    },
	
	    isIdentifierStart: function(ch) {
	      return this.options.isIdentifierStart ?
	        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierStart(ch);
	    },
	
	    isValidIdentifierStart: function(ch) {
	      return ('a' <= ch && ch <= 'z' ||
	      'A' <= ch && ch <= 'Z' ||
	      '_' === ch || ch === '$');
	    },
	
	    isIdentifierContinue: function(ch) {
	      return this.options.isIdentifierContinue ?
	        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierContinue(ch);
	    },
	
	    isValidIdentifierContinue: function(ch, cp) {
	      return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
	    },
	
	    codePointAt: function(ch) {
	      if (ch.length === 1) return ch.charCodeAt(0);
	      /*jshint bitwise: false*/
	      return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
	      /*jshint bitwise: true*/
	    },
	
	    peekMultichar: function() {
	      var ch = this.text.charAt(this.index);
	      var peek = this.peek();
	      if (!peek) {
	        return ch;
	      }
	      var cp1 = ch.charCodeAt(0);
	      var cp2 = peek.charCodeAt(0);
	      if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
	        return ch + peek;
	      }
	      return ch;
	    },
	
	    isExpOperator: function(ch) {
	      return (ch === '-' || ch === '+' || this.isNumber(ch));
	    },
	
	    throwError: function(error, start, end) {
	      end = end || this.index;
	      var colStr = (isDefined(start)
	        ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	        : ' ' + end);
	      throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	    },
	
	    readNumber: function() {
	      var number = '';
	      var start = this.index;
	      while (this.index < this.text.length) {
	        var ch = lowercase(this.text.charAt(this.index));
	        if (ch == '.' || this.isNumber(ch)) {
	          number += ch;
	        } else {
	          var peekCh = this.peek();
	          if (ch == 'e' && this.isExpOperator(peekCh)) {
	            number += ch;
	          } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) == 'e') {
	            number += ch;
	          } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) == 'e') {
	            this.throwError('Invalid exponent');
	          } else {
	            break;
	          }
	        }
	        this.index++;
	      }
	      this.tokens.push({
	        index: start,
	        text: number,
	        constant: true,
	        value: Number(number)
	      });
	    },
	
	    readIdent: function() {
	      var start = this.index;
	      this.index += this.peekMultichar().length;
	      while (this.index < this.text.length) {
	        var ch = this.peekMultichar();
	        if (!this.isIdentifierContinue(ch)) {
	          break;
	        }
	        this.index += ch.length;
	      }
	      this.tokens.push({
	        index: start,
	        text: this.text.slice(start, this.index),
	        identifier: true
	      });
	    },
	
	    readString: function(quote) {
	      var start = this.index;
	      this.index++;
	      var string = '';
	      var rawString = quote;
	      var escape = false;
	      while (this.index < this.text.length) {
	        var ch = this.text.charAt(this.index);
	        rawString += ch;
	        if (escape) {
	          if (ch === 'u') {
	            var hex = this.text.substring(this.index + 1, this.index + 5);
	            if (!hex.match(/[\da-f]{4}/i)) {
	              this.throwError('Invalid unicode escape [\\u' + hex + ']');
	            }
	            this.index += 4;
	            string += String.fromCharCode(parseInt(hex, 16));
	          } else {
	            var rep = ESCAPE[ch];
	            string = string + (rep || ch);
	          }
	          escape = false;
	        } else if (ch === '\\') {
	          escape = true;
	        } else if (ch === quote) {
	          this.index++;
	          this.tokens.push({
	            index: start,
	            text: rawString,
	            constant: true,
	            value: string
	          });
	          return;
	        } else {
	          string += ch;
	        }
	        this.index++;
	      }
	      this.throwError('Unterminated quote', start);
	    }
	  };
	
	  var AST = function(lexer, options) {
	    this.lexer = lexer;
	    this.options = options;
	  };
	
	  AST.Program = 'Program';
	  AST.ExpressionStatement = 'ExpressionStatement';
	  AST.AssignmentExpression = 'AssignmentExpression';
	  AST.ConditionalExpression = 'ConditionalExpression';
	  AST.LogicalExpression = 'LogicalExpression';
	  AST.BinaryExpression = 'BinaryExpression';
	  AST.UnaryExpression = 'UnaryExpression';
	  AST.CallExpression = 'CallExpression';
	  AST.MemberExpression = 'MemberExpression';
	  AST.Identifier = 'Identifier';
	  AST.Literal = 'Literal';
	  AST.ArrayExpression = 'ArrayExpression';
	  AST.Property = 'Property';
	  AST.ObjectExpression = 'ObjectExpression';
	  AST.ThisExpression = 'ThisExpression';
	  AST.LocalsExpression = 'LocalsExpression';
	
	// Internal use only
	  AST.NGValueParameter = 'NGValueParameter';
	
	  AST.prototype = {
	    ast: function(text) {
	      this.text = text;
	      this.tokens = this.lexer.lex(text);
	
	      var value = this.program();
	
	      if (this.tokens.length !== 0) {
	        this.throwError('is an unexpected token', this.tokens[0]);
	      }
	
	      return value;
	    },
	
	    program: function() {
	      var body = [];
	      while (true) {
	        if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	          body.push(this.expressionStatement());
	        if (!this.expect(';')) {
	          return { type: AST.Program, body: body};
	        }
	      }
	    },
	
	    expressionStatement: function() {
	      return { type: AST.ExpressionStatement, expression: this.filterChain() };
	    },
	
	    filterChain: function() {
	      var left = this.expression();
	      var token;
	      while ((token = this.expect('|'))) {
	        left = this.filter(left);
	      }
	      return left;
	    },
	
	    expression: function() {
	      return this.assignment();
	    },
	
	    assignment: function() {
	      var result = this.ternary();
	      if (this.expect('=')) {
	        result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	      }
	      return result;
	    },
	
	    ternary: function() {
	      var test = this.logicalOR();
	      var alternate;
	      var consequent;
	      if (this.expect('?')) {
	        alternate = this.expression();
	        if (this.consume(':')) {
	          consequent = this.expression();
	          return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	        }
	      }
	      return test;
	    },
	
	    logicalOR: function() {
	      var left = this.logicalAND();
	      while (this.expect('||')) {
	        left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	      }
	      return left;
	    },
	
	    logicalAND: function() {
	      var left = this.equality();
	      while (this.expect('&&')) {
	        left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	      }
	      return left;
	    },
	
	    equality: function() {
	      var left = this.relational();
	      var token;
	      while ((token = this.expect('==','!=','===','!=='))) {
	        left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	      }
	      return left;
	    },
	
	    relational: function() {
	      var left = this.additive();
	      var token;
	      while ((token = this.expect('<', '>', '<=', '>='))) {
	        left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	      }
	      return left;
	    },
	
	    additive: function() {
	      var left = this.multiplicative();
	      var token;
	      while ((token = this.expect('+','-'))) {
	        left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	      }
	      return left;
	    },
	
	    multiplicative: function() {
	      var left = this.unary();
	      var token;
	      while ((token = this.expect('*','/','%'))) {
	        left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	      }
	      return left;
	    },
	
	    unary: function() {
	      var token;
	      if ((token = this.expect('+', '-', '!'))) {
	        return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	      } else {
	        return this.primary();
	      }
	    },
	
	    primary: function() {
	      var primary;
	      if (this.expect('(')) {
	        primary = this.filterChain();
	        this.consume(')');
	      } else if (this.expect('[')) {
	        primary = this.arrayDeclaration();
	      } else if (this.expect('{')) {
	        primary = this.object();
	      } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
	        primary = copy(this.selfReferential[this.consume().text]);
	      } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
	        primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
	      } else if (this.peek().identifier) {
	        primary = this.identifier();
	      } else if (this.peek().constant) {
	        primary = this.constant();
	      } else {
	        this.throwError('not a primary expression', this.peek());
	      }
	
	      var next;
	      while ((next = this.expect('(', '[', '.'))) {
	        if (next.text === '(') {
	          primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	          this.consume(')');
	        } else if (next.text === '[') {
	          primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	          this.consume(']');
	        } else if (next.text === '.') {
	          primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	        } else {
	          this.throwError('IMPOSSIBLE');
	        }
	      }
	      return primary;
	    },
	
	    filter: function(baseExpression) {
	      var args = [baseExpression];
	      var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	      while (this.expect(':')) {
	        args.push(this.expression());
	      }
	
	      return result;
	    },
	
	    parseArguments: function() {
	      var args = [];
	      if (this.peekToken().text !== ')') {
	        do {
	          args.push(this.expression());
	        } while (this.expect(','));
	      }
	      return args;
	    },
	
	    identifier: function() {
	      var token = this.consume();
	      if (!token.identifier) {
	        this.throwError('is not a valid identifier', token);
	      }
	      return { type: AST.Identifier, name: token.text };
	    },
	
	    constant: function() {
	      // TODO check that it is a constant
	      return { type: AST.Literal, value: this.consume().value };
	    },
	
	    arrayDeclaration: function() {
	      var elements = [];
	      if (this.peekToken().text !== ']') {
	        do {
	          if (this.peek(']')) {
	            // Support trailing commas per ES5.1.
	            break;
	          }
	          elements.push(this.expression());
	        } while (this.expect(','));
	      }
	      this.consume(']');
	
	      return { type: AST.ArrayExpression, elements: elements };
	    },
	
	    object: function() {
	      var properties = [], property;
	      if (this.peekToken().text !== '}') {
	        do {
	          if (this.peek('}')) {
	            // Support trailing commas per ES5.1.
	            break;
	          }
	          property = {type: AST.Property, kind: 'init'};
	          if (this.peek().constant) {
	            property.key = this.constant();
	            property.computed = false;
	            this.consume(':');
	            property.value = this.expression();
	          } else if (this.peek().identifier) {
	            property.key = this.identifier();
	            property.computed = false;
	            if (this.peek(':')) {
	              this.consume(':');
	              property.value = this.expression();
	            } else {
	              property.value = property.key;
	            }
	          } else if (this.peek('[')) {
	            this.consume('[');
	            property.key = this.expression();
	            this.consume(']');
	            property.computed = true;
	            this.consume(':');
	            property.value = this.expression();
	          } else {
	            this.throwError("invalid key", this.peek());
	          }
	          properties.push(property);
	        } while (this.expect(','));
	      }
	      this.consume('}');
	
	      return {type: AST.ObjectExpression, properties: properties };
	    },
	
	    throwError: function(msg, token) {
	      throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	        token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	    },
	
	    consume: function(e1) {
	      if (this.tokens.length === 0) {
	        throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	      }
	
	      var token = this.expect(e1);
	      if (!token) {
	        this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	      }
	      return token;
	    },
	
	    peekToken: function() {
	      if (this.tokens.length === 0) {
	        throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	      }
	      return this.tokens[0];
	    },
	
	    peek: function(e1, e2, e3, e4) {
	      return this.peekAhead(0, e1, e2, e3, e4);
	    },
	
	    peekAhead: function(i, e1, e2, e3, e4) {
	      if (this.tokens.length > i) {
	        var token = this.tokens[i];
	        var t = token.text;
	        if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	          return token;
	        }
	      }
	      return false;
	    },
	
	    expect: function(e1, e2, e3, e4) {
	      var token = this.peek(e1, e2, e3, e4);
	      if (token) {
	        this.tokens.shift();
	        return token;
	      }
	      return false;
	    },
	
	    selfReferential: {
	      'this': {type: AST.ThisExpression },
	      '$locals': {type: AST.LocalsExpression }
	    }
	  };
	
	  function ifDefined(v, d) {
	    return typeof v !== 'undefined' ? v : d;
	  }
	
	  function plusFn(l, r) {
	    if (typeof l === 'undefined') return r;
	    if (typeof r === 'undefined') return l;
	    return l + r;
	  }
	
	  function isStateless($filter, filterName) {
	    var fn = $filter(filterName);
	    return !fn.$stateful;
	  }
	
	  function findConstantAndWatchExpressions(ast, $filter) {
	    var allConstants;
	    var argsToWatch;
	    switch (ast.type) {
	      case AST.Program:
	        allConstants = true;
	        forEach(ast.body, function(expr) {
	          findConstantAndWatchExpressions(expr.expression, $filter);
	          allConstants = allConstants && expr.expression.constant;
	        });
	        ast.constant = allConstants;
	        break;
	      case AST.Literal:
	        ast.constant = true;
	        ast.toWatch = [];
	        break;
	      case AST.UnaryExpression:
	        findConstantAndWatchExpressions(ast.argument, $filter);
	        ast.constant = ast.argument.constant;
	        ast.toWatch = ast.argument.toWatch;
	        break;
	      case AST.BinaryExpression:
	        findConstantAndWatchExpressions(ast.left, $filter);
	        findConstantAndWatchExpressions(ast.right, $filter);
	        ast.constant = ast.left.constant && ast.right.constant;
	        ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	        break;
	      case AST.LogicalExpression:
	        findConstantAndWatchExpressions(ast.left, $filter);
	        findConstantAndWatchExpressions(ast.right, $filter);
	        ast.constant = ast.left.constant && ast.right.constant;
	        ast.toWatch = ast.constant ? [] : [ast];
	        break;
	      case AST.ConditionalExpression:
	        findConstantAndWatchExpressions(ast.test, $filter);
	        findConstantAndWatchExpressions(ast.alternate, $filter);
	        findConstantAndWatchExpressions(ast.consequent, $filter);
	        ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	        ast.toWatch = ast.constant ? [] : [ast];
	        break;
	      case AST.Identifier:
	        ast.constant = false;
	        ast.toWatch = [ast];
	        break;
	      case AST.MemberExpression:
	        findConstantAndWatchExpressions(ast.object, $filter);
	        if (ast.computed) {
	          findConstantAndWatchExpressions(ast.property, $filter);
	        }
	        ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	        ast.toWatch = [ast];
	        break;
	      case AST.CallExpression:
	        allConstants = ast.filter ? isStateless($filter, ast.callee.name) : false;
	        argsToWatch = [];
	        forEach(ast.arguments, function(expr) {
	          findConstantAndWatchExpressions(expr, $filter);
	          allConstants = allConstants && expr.constant;
	          if (!expr.constant) {
	            argsToWatch.push.apply(argsToWatch, expr.toWatch);
	          }
	        });
	        ast.constant = allConstants;
	        ast.toWatch = ast.filter && isStateless($filter, ast.callee.name) ? argsToWatch : [ast];
	        break;
	      case AST.AssignmentExpression:
	        findConstantAndWatchExpressions(ast.left, $filter);
	        findConstantAndWatchExpressions(ast.right, $filter);
	        ast.constant = ast.left.constant && ast.right.constant;
	        ast.toWatch = [ast];
	        break;
	      case AST.ArrayExpression:
	        allConstants = true;
	        argsToWatch = [];
	        forEach(ast.elements, function(expr) {
	          findConstantAndWatchExpressions(expr, $filter);
	          allConstants = allConstants && expr.constant;
	          if (!expr.constant) {
	            argsToWatch.push.apply(argsToWatch, expr.toWatch);
	          }
	        });
	        ast.constant = allConstants;
	        ast.toWatch = argsToWatch;
	        break;
	      case AST.ObjectExpression:
	        allConstants = true;
	        argsToWatch = [];
	        forEach(ast.properties, function(property) {
	          findConstantAndWatchExpressions(property.value, $filter);
	          allConstants = allConstants && property.value.constant && !property.computed;
	          if (!property.value.constant) {
	            argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	          }
	        });
	        ast.constant = allConstants;
	        ast.toWatch = argsToWatch;
	        break;
	      case AST.ThisExpression:
	        ast.constant = false;
	        ast.toWatch = [];
	        break;
	      case AST.LocalsExpression:
	        ast.constant = false;
	        ast.toWatch = [];
	        break;
	    }
	  }
	
	  function getInputs(body) {
	    if (body.length != 1) return;
	    var lastExpression = body[0].expression;
	    var candidate = lastExpression.toWatch;
	    if (candidate.length !== 1) return candidate;
	    return candidate[0] !== lastExpression ? candidate : undefined;
	  }
	
	  function isAssignable(ast) {
	    return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	  }
	
	  function assignableAST(ast) {
	    if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	      return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	    }
	  }
	
	  function isLiteral(ast) {
	    return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	  }
	
	  function isConstant(ast) {
	    return ast.constant;
	  }
	
	  function ASTCompiler(astBuilder, $filter) {
	    this.astBuilder = astBuilder;
	    this.$filter = $filter;
	  }
	
	  ASTCompiler.prototype = {
	    compile: function(expression, expensiveChecks) {
	      var self = this;
	      var ast = this.astBuilder.ast(expression);
	      this.state = {
	        nextId: 0,
	        filters: {},
	        expensiveChecks: expensiveChecks,
	        fn: {vars: [], body: [], own: {}},
	        assign: {vars: [], body: [], own: {}},
	        inputs: []
	      };
	      findConstantAndWatchExpressions(ast, self.$filter);
	      var extra = '';
	      var assignable;
	      this.stage = 'assign';
	      if ((assignable = assignableAST(ast))) {
	        this.state.computing = 'assign';
	        var result = this.nextId();
	        this.recurse(assignable, result);
	        this.return_(result);
	        extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	      }
	      var toWatch = getInputs(ast.body);
	      self.stage = 'inputs';
	      forEach(toWatch, function(watch, key) {
	        var fnKey = 'fn' + key;
	        self.state[fnKey] = {vars: [], body: [], own: {}};
	        self.state.computing = fnKey;
	        var intoId = self.nextId();
	        self.recurse(watch, intoId);
	        self.return_(intoId);
	        self.state.inputs.push(fnKey);
	        watch.watchId = key;
	      });
	      this.state.computing = 'fn';
	      this.stage = 'main';
	      this.recurse(ast);
	      var fnString =
	        // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	        // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	        '"' + this.USE + ' ' + this.STRICT + '";\n' +
	        this.filterPrefix() +
	        'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	        extra +
	        this.watchFns() +
	        'return fn;';
	
	      /* jshint -W054 */
	      var fn = (new Function('$filter',
	        'ensureSafeMemberName',
	        'ensureSafeObject',
	        'ensureSafeFunction',
	        'getStringValue',
	        'ensureSafeAssignContext',
	        'ifDefined',
	        'plus',
	        'text',
	        fnString))(
	        this.$filter,
	        ensureSafeMemberName,
	        ensureSafeObject,
	        ensureSafeFunction,
	        getStringValue,
	        ensureSafeAssignContext,
	        ifDefined,
	        plusFn,
	        expression);
	      /* jshint +W054 */
	      this.state = this.stage = undefined;
	      fn.literal = isLiteral(ast);
	      fn.constant = isConstant(ast);
	      return fn;
	    },
	
	    USE: 'use',
	
	    STRICT: 'strict',
	
	    watchFns: function() {
	      var result = [];
	      var fns = this.state.inputs;
	      var self = this;
	      forEach(fns, function(name) {
	        result.push('var ' + name + '=' + self.generateFunction(name, 's'));
	      });
	      if (fns.length) {
	        result.push('fn.inputs=[' + fns.join(',') + '];');
	      }
	      return result.join('');
	    },
	
	    generateFunction: function(name, params) {
	      return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	    },
	
	    filterPrefix: function() {
	      var parts = [];
	      var self = this;
	      forEach(this.state.filters, function(id, filter) {
	        parts.push(id + '=$filter(' + self.escape(filter) + ')');
	      });
	      if (parts.length) return 'var ' + parts.join(',') + ';';
	      return '';
	    },
	
	    varsPrefix: function(section) {
	      return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	    },
	
	    body: function(section) {
	      return this.state[section].body.join('');
	    },
	
	    recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	      var left, right, self = this, args, expression, computed;
	      recursionFn = recursionFn || noop;
	      if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	        intoId = intoId || this.nextId();
	        this.if_('i',
	          this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	          this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	        );
	        return;
	      }
	      switch (ast.type) {
	        case AST.Program:
	          forEach(ast.body, function(expression, pos) {
	            self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	            if (pos !== ast.body.length - 1) {
	              self.current().body.push(right, ';');
	            } else {
	              self.return_(right);
	            }
	          });
	          break;
	        case AST.Literal:
	          expression = this.escape(ast.value);
	          this.assign(intoId, expression);
	          recursionFn(expression);
	          break;
	        case AST.UnaryExpression:
	          this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	          expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	          this.assign(intoId, expression);
	          recursionFn(expression);
	          break;
	        case AST.BinaryExpression:
	          this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	          this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	          if (ast.operator === '+') {
	            expression = this.plus(left, right);
	          } else if (ast.operator === '-') {
	            expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	          } else {
	            expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	          }
	          this.assign(intoId, expression);
	          recursionFn(expression);
	          break;
	        case AST.LogicalExpression:
	          intoId = intoId || this.nextId();
	          self.recurse(ast.left, intoId);
	          self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	          recursionFn(intoId);
	          break;
	        case AST.ConditionalExpression:
	          intoId = intoId || this.nextId();
	          self.recurse(ast.test, intoId);
	          self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	          recursionFn(intoId);
	          break;
	        case AST.Identifier:
	          intoId = intoId || this.nextId();
	          if (nameId) {
	            nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	            nameId.computed = false;
	            nameId.name = ast.name;
	          }
	          ensureSafeMemberName(ast.name);
	          self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	            function() {
	              self.if_(self.stage === 'inputs' || 's', function() {
	                if (create && create !== 1) {
	                  self.if_(
	                    self.not(self.nonComputedMember('s', ast.name)),
	                    self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	                }
	                self.assign(intoId, self.nonComputedMember('s', ast.name));
	              });
	            }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	          );
	          if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.name)) {
	            self.addEnsureSafeObject(intoId);
	          }
	          recursionFn(intoId);
	          break;
	        case AST.MemberExpression:
	          left = nameId && (nameId.context = this.nextId()) || this.nextId();
	          intoId = intoId || this.nextId();
	          self.recurse(ast.object, left, undefined, function() {
	            self.if_(self.notNull(left), function() {
	              if (create && create !== 1) {
	                self.addEnsureSafeAssignContext(left);
	              }
	              if (ast.computed) {
	                right = self.nextId();
	                self.recurse(ast.property, right);
	                self.getStringValue(right);
	                self.addEnsureSafeMemberName(right);
	                if (create && create !== 1) {
	                  self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	                }
	                expression = self.ensureSafeObject(self.computedMember(left, right));
	                self.assign(intoId, expression);
	                if (nameId) {
	                  nameId.computed = true;
	                  nameId.name = right;
	                }
	              } else {
	                ensureSafeMemberName(ast.property.name);
	                if (create && create !== 1) {
	                  self.if_(self.not(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	                }
	                expression = self.nonComputedMember(left, ast.property.name);
	                if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.property.name)) {
	                  expression = self.ensureSafeObject(expression);
	                }
	                self.assign(intoId, expression);
	                if (nameId) {
	                  nameId.computed = false;
	                  nameId.name = ast.property.name;
	                }
	              }
	            }, function() {
	              self.assign(intoId, 'undefined');
	            });
	            recursionFn(intoId);
	          }, !!create);
	          break;
	        case AST.CallExpression:
	          intoId = intoId || this.nextId();
	          if (ast.filter) {
	            right = self.filter(ast.callee.name);
	            args = [];
	            forEach(ast.arguments, function(expr) {
	              var argument = self.nextId();
	              self.recurse(expr, argument);
	              args.push(argument);
	            });
	            expression = right + '(' + args.join(',') + ')';
	            self.assign(intoId, expression);
	            recursionFn(intoId);
	          } else {
	            right = self.nextId();
	            left = {};
	            args = [];
	            self.recurse(ast.callee, right, left, function() {
	              self.if_(self.notNull(right), function() {
	                self.addEnsureSafeFunction(right);
	                forEach(ast.arguments, function(expr) {
	                  self.recurse(expr, self.nextId(), undefined, function(argument) {
	                    args.push(self.ensureSafeObject(argument));
	                  });
	                });
	                if (left.name) {
	                  if (!self.state.expensiveChecks) {
	                    self.addEnsureSafeObject(left.context);
	                  }
	                  expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	                } else {
	                  expression = right + '(' + args.join(',') + ')';
	                }
	                expression = self.ensureSafeObject(expression);
	                self.assign(intoId, expression);
	              }, function() {
	                self.assign(intoId, 'undefined');
	              });
	              recursionFn(intoId);
	            });
	          }
	          break;
	        case AST.AssignmentExpression:
	          right = this.nextId();
	          left = {};
	          if (!isAssignable(ast.left)) {
	            throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
	          }
	          this.recurse(ast.left, undefined, left, function() {
	            self.if_(self.notNull(left.context), function() {
	              self.recurse(ast.right, right);
	              self.addEnsureSafeObject(self.member(left.context, left.name, left.computed));
	              self.addEnsureSafeAssignContext(left.context);
	              expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	              self.assign(intoId, expression);
	              recursionFn(intoId || expression);
	            });
	          }, 1);
	          break;
	        case AST.ArrayExpression:
	          args = [];
	          forEach(ast.elements, function(expr) {
	            self.recurse(expr, self.nextId(), undefined, function(argument) {
	              args.push(argument);
	            });
	          });
	          expression = '[' + args.join(',') + ']';
	          this.assign(intoId, expression);
	          recursionFn(expression);
	          break;
	        case AST.ObjectExpression:
	          args = [];
	          computed = false;
	          forEach(ast.properties, function(property) {
	            if (property.computed) {
	              computed = true;
	            }
	          });
	          if (computed) {
	            intoId = intoId || this.nextId();
	            this.assign(intoId, '{}');
	            forEach(ast.properties, function(property) {
	              if (property.computed) {
	                left = self.nextId();
	                self.recurse(property.key, left);
	              } else {
	                left = property.key.type === AST.Identifier ?
	                  property.key.name :
	                  ('' + property.key.value);
	              }
	              right = self.nextId();
	              self.recurse(property.value, right);
	              self.assign(self.member(intoId, left, property.computed), right);
	            });
	          } else {
	            forEach(ast.properties, function(property) {
	              self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
	                args.push(self.escape(
	                    property.key.type === AST.Identifier ? property.key.name :
	                      ('' + property.key.value)) +
	                  ':' + expr);
	              });
	            });
	            expression = '{' + args.join(',') + '}';
	            this.assign(intoId, expression);
	          }
	          recursionFn(intoId || expression);
	          break;
	        case AST.ThisExpression:
	          this.assign(intoId, 's');
	          recursionFn('s');
	          break;
	        case AST.LocalsExpression:
	          this.assign(intoId, 'l');
	          recursionFn('l');
	          break;
	        case AST.NGValueParameter:
	          this.assign(intoId, 'v');
	          recursionFn('v');
	          break;
	      }
	    },
	
	    getHasOwnProperty: function(element, property) {
	      var key = element + '.' + property;
	      var own = this.current().own;
	      if (!own.hasOwnProperty(key)) {
	        own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	      }
	      return own[key];
	    },
	
	    assign: function(id, value) {
	      if (!id) return;
	      this.current().body.push(id, '=', value, ';');
	      return id;
	    },
	
	    filter: function(filterName) {
	      if (!this.state.filters.hasOwnProperty(filterName)) {
	        this.state.filters[filterName] = this.nextId(true);
	      }
	      return this.state.filters[filterName];
	    },
	
	    ifDefined: function(id, defaultValue) {
	      return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	    },
	
	    plus: function(left, right) {
	      return 'plus(' + left + ',' + right + ')';
	    },
	
	    return_: function(id) {
	      this.current().body.push('return ', id, ';');
	    },
	
	    if_: function(test, alternate, consequent) {
	      if (test === true) {
	        alternate();
	      } else {
	        var body = this.current().body;
	        body.push('if(', test, '){');
	        alternate();
	        body.push('}');
	        if (consequent) {
	          body.push('else{');
	          consequent();
	          body.push('}');
	        }
	      }
	    },
	
	    not: function(expression) {
	      return '!(' + expression + ')';
	    },
	
	    notNull: function(expression) {
	      return expression + '!=null';
	    },
	
	    nonComputedMember: function(left, right) {
	      var SAFE_IDENTIFIER = /[$_a-zA-Z][$_a-zA-Z0-9]*/;
	      var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
	      if (SAFE_IDENTIFIER.test(right)) {
	        return left + '.' + right;
	      } else {
	        return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
	      }
	    },
	
	    computedMember: function(left, right) {
	      return left + '[' + right + ']';
	    },
	
	    member: function(left, right, computed) {
	      if (computed) return this.computedMember(left, right);
	      return this.nonComputedMember(left, right);
	    },
	
	    addEnsureSafeObject: function(item) {
	      this.current().body.push(this.ensureSafeObject(item), ';');
	    },
	
	    addEnsureSafeMemberName: function(item) {
	      this.current().body.push(this.ensureSafeMemberName(item), ';');
	    },
	
	    addEnsureSafeFunction: function(item) {
	      this.current().body.push(this.ensureSafeFunction(item), ';');
	    },
	
	    addEnsureSafeAssignContext: function(item) {
	      this.current().body.push(this.ensureSafeAssignContext(item), ';');
	    },
	
	    ensureSafeObject: function(item) {
	      return 'ensureSafeObject(' + item + ',text)';
	    },
	
	    ensureSafeMemberName: function(item) {
	      return 'ensureSafeMemberName(' + item + ',text)';
	    },
	
	    ensureSafeFunction: function(item) {
	      return 'ensureSafeFunction(' + item + ',text)';
	    },
	
	    getStringValue: function(item) {
	      this.assign(item, 'getStringValue(' + item + ')');
	    },
	
	    ensureSafeAssignContext: function(item) {
	      return 'ensureSafeAssignContext(' + item + ',text)';
	    },
	
	    lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	      var self = this;
	      return function() {
	        self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	      };
	    },
	
	    lazyAssign: function(id, value) {
	      var self = this;
	      return function() {
	        self.assign(id, value);
	      };
	    },
	
	    stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	    stringEscapeFn: function(c) {
	      return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	    },
	
	    escape: function(value) {
	      if (isString(value)) return "'" + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + "'";
	      if (isNumber(value)) return value.toString();
	      if (value === true) return 'true';
	      if (value === false) return 'false';
	      if (value === null) return 'null';
	      if (typeof value === 'undefined') return 'undefined';
	
	      throw $parseMinErr('esc', 'IMPOSSIBLE');
	    },
	
	    nextId: function(skip, init) {
	      var id = 'v' + (this.state.nextId++);
	      if (!skip) {
	        this.current().vars.push(id + (init ? '=' + init : ''));
	      }
	      return id;
	    },
	
	    current: function() {
	      return this.state[this.state.computing];
	    }
	  };
	
	
	  function ASTInterpreter(astBuilder, $filter) {
	    this.astBuilder = astBuilder;
	    this.$filter = $filter;
	  }
	
	  ASTInterpreter.prototype = {
	    compile: function(expression, expensiveChecks) {
	      var self = this;
	      var ast = this.astBuilder.ast(expression);
	      this.expression = expression;
	      this.expensiveChecks = expensiveChecks;
	      findConstantAndWatchExpressions(ast, self.$filter);
	      var assignable;
	      var assign;
	      if ((assignable = assignableAST(ast))) {
	        assign = this.recurse(assignable);
	      }
	      var toWatch = getInputs(ast.body);
	      var inputs;
	      if (toWatch) {
	        inputs = [];
	        forEach(toWatch, function(watch, key) {
	          var input = self.recurse(watch);
	          watch.input = input;
	          inputs.push(input);
	          watch.watchId = key;
	        });
	      }
	      var expressions = [];
	      forEach(ast.body, function(expression) {
	        expressions.push(self.recurse(expression.expression));
	      });
	      var fn = ast.body.length === 0 ? noop :
	        ast.body.length === 1 ? expressions[0] :
	          function(scope, locals) {
	            var lastValue;
	            forEach(expressions, function(exp) {
	              lastValue = exp(scope, locals);
	            });
	            return lastValue;
	          };
	      if (assign) {
	        fn.assign = function(scope, value, locals) {
	          return assign(scope, locals, value);
	        };
	      }
	      if (inputs) {
	        fn.inputs = inputs;
	      }
	      fn.literal = isLiteral(ast);
	      fn.constant = isConstant(ast);
	      return fn;
	    },
	
	    recurse: function(ast, context, create) {
	      var left, right, self = this, args, expression;
	      if (ast.input) {
	        return this.inputs(ast.input, ast.watchId);
	      }
	      switch (ast.type) {
	        case AST.Literal:
	          return this.value(ast.value, context);
	        case AST.UnaryExpression:
	          right = this.recurse(ast.argument);
	          return this['unary' + ast.operator](right, context);
	        case AST.BinaryExpression:
	          left = this.recurse(ast.left);
	          right = this.recurse(ast.right);
	          return this['binary' + ast.operator](left, right, context);
	        case AST.LogicalExpression:
	          left = this.recurse(ast.left);
	          right = this.recurse(ast.right);
	          return this['binary' + ast.operator](left, right, context);
	        case AST.ConditionalExpression:
	          return this['ternary?:'](
	            this.recurse(ast.test),
	            this.recurse(ast.alternate),
	            this.recurse(ast.consequent),
	            context
	          );
	        case AST.Identifier:
	          ensureSafeMemberName(ast.name, self.expression);
	          return self.identifier(ast.name,
	            self.expensiveChecks || isPossiblyDangerousMemberName(ast.name),
	            context, create, self.expression);
	        case AST.MemberExpression:
	          left = this.recurse(ast.object, false, !!create);
	          if (!ast.computed) {
	            ensureSafeMemberName(ast.property.name, self.expression);
	            right = ast.property.name;
	          }
	          if (ast.computed) right = this.recurse(ast.property);
	          return ast.computed ?
	            this.computedMember(left, right, context, create, self.expression) :
	            this.nonComputedMember(left, right, self.expensiveChecks, context, create, self.expression);
	        case AST.CallExpression:
	          args = [];
	          forEach(ast.arguments, function(expr) {
	            args.push(self.recurse(expr));
	          });
	          if (ast.filter) right = this.$filter(ast.callee.name);
	          if (!ast.filter) right = this.recurse(ast.callee, true);
	          return ast.filter ?
	            function(scope, locals, assign, inputs) {
	              var values = [];
	              for (var i = 0; i < args.length; ++i) {
	                values.push(args[i](scope, locals, assign, inputs));
	              }
	              var value = right.apply(undefined, values, inputs);
	              return context ? {context: undefined, name: undefined, value: value} : value;
	            } :
	            function(scope, locals, assign, inputs) {
	              var rhs = right(scope, locals, assign, inputs);
	              var value;
	              if (rhs.value != null) {
	                ensureSafeObject(rhs.context, self.expression);
	                ensureSafeFunction(rhs.value, self.expression);
	                var values = [];
	                for (var i = 0; i < args.length; ++i) {
	                  values.push(ensureSafeObject(args[i](scope, locals, assign, inputs), self.expression));
	                }
	                value = ensureSafeObject(rhs.value.apply(rhs.context, values), self.expression);
	              }
	              return context ? {value: value} : value;
	            };
	        case AST.AssignmentExpression:
	          left = this.recurse(ast.left, true, 1);
	          right = this.recurse(ast.right);
	          return function(scope, locals, assign, inputs) {
	            var lhs = left(scope, locals, assign, inputs);
	            var rhs = right(scope, locals, assign, inputs);
	            ensureSafeObject(lhs.value, self.expression);
	            ensureSafeAssignContext(lhs.context);
	            lhs.context[lhs.name] = rhs;
	            return context ? {value: rhs} : rhs;
	          };
	        case AST.ArrayExpression:
	          args = [];
	          forEach(ast.elements, function(expr) {
	            args.push(self.recurse(expr));
	          });
	          return function(scope, locals, assign, inputs) {
	            var value = [];
	            for (var i = 0; i < args.length; ++i) {
	              value.push(args[i](scope, locals, assign, inputs));
	            }
	            return context ? {value: value} : value;
	          };
	        case AST.ObjectExpression:
	          args = [];
	          forEach(ast.properties, function(property) {
	            if (property.computed) {
	              args.push({key: self.recurse(property.key),
	                computed: true,
	                value: self.recurse(property.value)
	              });
	            } else {
	              args.push({key: property.key.type === AST.Identifier ?
	                property.key.name :
	                ('' + property.key.value),
	                computed: false,
	                value: self.recurse(property.value)
	              });
	            }
	          });
	          return function(scope, locals, assign, inputs) {
	            var value = {};
	            for (var i = 0; i < args.length; ++i) {
	              if (args[i].computed) {
	                value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
	              } else {
	                value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	              }
	            }
	            return context ? {value: value} : value;
	          };
	        case AST.ThisExpression:
	          return function(scope) {
	            return context ? {value: scope} : scope;
	          };
	        case AST.LocalsExpression:
	          return function(scope, locals) {
	            return context ? {value: locals} : locals;
	          };
	        case AST.NGValueParameter:
	          return function(scope, locals, assign) {
	            return context ? {value: assign} : assign;
	          };
	      }
	    },
	
	    'unary+': function(argument, context) {
	      return function(scope, locals, assign, inputs) {
	        var arg = argument(scope, locals, assign, inputs);
	        if (isDefined(arg)) {
	          arg = +arg;
	        } else {
	          arg = 0;
	        }
	        return context ? {value: arg} : arg;
	      };
	    },
	    'unary-': function(argument, context) {
	      return function(scope, locals, assign, inputs) {
	        var arg = argument(scope, locals, assign, inputs);
	        if (isDefined(arg)) {
	          arg = -arg;
	        } else {
	          arg = 0;
	        }
	        return context ? {value: arg} : arg;
	      };
	    },
	    'unary!': function(argument, context) {
	      return function(scope, locals, assign, inputs) {
	        var arg = !argument(scope, locals, assign, inputs);
	        return context ? {value: arg} : arg;
	      };
	    },
	    'binary+': function(left, right, context) {
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        var arg = plusFn(lhs, rhs);
	        return context ? {value: arg} : arg;
	      };
	    },
	    'binary-': function(left, right, context) {
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	        return context ? {value: arg} : arg;
	      };
	    },
	    'binary*': function(left, right, context) {
	      return function(scope, locals, assign, inputs) {
	        var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	        return context ? {value: arg} : arg;
	      };
	    },
	    'binary/': function(left, right, context) {
	      return function(scope, locals, assign, inputs) {
	        var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	        return context ? {value: arg} : arg;
	      };
	    },
	    'binary%': function(left, right, context) {
	      return function(scope, locals, assign, inputs) {
	        var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	        return context ? {value: arg} : arg;
	      };
	    },
	    'binary===': function(left, right, context) {
	      return function(scope, locals, assign, inputs) {
	        var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	        return context ? {value: arg} : arg;
	      };
	    },
	    'binary!==': function(left, right, context) {
	      return function(scope, locals, assign, inputs) {
	        var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	        return context ? {value: arg} : arg;
	      };
	    },
	    'binary==': function(left, right, context) {
	      return function(scope, locals, assign, inputs) {
	        var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	        return context ? {value: arg} : arg;
	      };
	    },
	    'binary!=': function(left, right, context) {
	      return function(scope, locals, assign, inputs) {
	        var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	        return context ? {value: arg} : arg;
	      };
	    },
	    'binary<': function(left, right, context) {
	      return function(scope, locals, assign, inputs) {
	        var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	        return context ? {value: arg} : arg;
	      };
	    },
	    'binary>': function(left, right, context) {
	      return function(scope, locals, assign, inputs) {
	        var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	        return context ? {value: arg} : arg;
	      };
	    },
	    'binary<=': function(left, right, context) {
	      return function(scope, locals, assign, inputs) {
	        var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	        return context ? {value: arg} : arg;
	      };
	    },
	    'binary>=': function(left, right, context) {
	      return function(scope, locals, assign, inputs) {
	        var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	        return context ? {value: arg} : arg;
	      };
	    },
	    'binary&&': function(left, right, context) {
	      return function(scope, locals, assign, inputs) {
	        var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	        return context ? {value: arg} : arg;
	      };
	    },
	    'binary||': function(left, right, context) {
	      return function(scope, locals, assign, inputs) {
	        var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	        return context ? {value: arg} : arg;
	      };
	    },
	    'ternary?:': function(test, alternate, consequent, context) {
	      return function(scope, locals, assign, inputs) {
	        var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	        return context ? {value: arg} : arg;
	      };
	    },
	    value: function(value, context) {
	      return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	    },
	    identifier: function(name, expensiveChecks, context, create, expression) {
	      return function(scope, locals, assign, inputs) {
	        var base = locals && (name in locals) ? locals : scope;
	        if (create && create !== 1 && base && !(base[name])) {
	          base[name] = {};
	        }
	        var value = base ? base[name] : undefined;
	        if (expensiveChecks) {
	          ensureSafeObject(value, expression);
	        }
	        if (context) {
	          return {context: base, name: name, value: value};
	        } else {
	          return value;
	        }
	      };
	    },
	    computedMember: function(left, right, context, create, expression) {
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs;
	        var value;
	        if (lhs != null) {
	          rhs = right(scope, locals, assign, inputs);
	          rhs = getStringValue(rhs);
	          ensureSafeMemberName(rhs, expression);
	          if (create && create !== 1) {
	            ensureSafeAssignContext(lhs);
	            if (lhs && !(lhs[rhs])) {
	              lhs[rhs] = {};
	            }
	          }
	          value = lhs[rhs];
	          ensureSafeObject(value, expression);
	        }
	        if (context) {
	          return {context: lhs, name: rhs, value: value};
	        } else {
	          return value;
	        }
	      };
	    },
	    nonComputedMember: function(left, right, expensiveChecks, context, create, expression) {
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        if (create && create !== 1) {
	          ensureSafeAssignContext(lhs);
	          if (lhs && !(lhs[right])) {
	            lhs[right] = {};
	          }
	        }
	        var value = lhs != null ? lhs[right] : undefined;
	        if (expensiveChecks || isPossiblyDangerousMemberName(right)) {
	          ensureSafeObject(value, expression);
	        }
	        if (context) {
	          return {context: lhs, name: right, value: value};
	        } else {
	          return value;
	        }
	      };
	    },
	    inputs: function(input, watchId) {
	      return function(scope, value, locals, inputs) {
	        if (inputs) return inputs[watchId];
	        return input(scope, value, locals);
	      };
	    }
	  };
	
	  /**
	   * @constructor
	   */
	  var Parser = function(lexer, $filter, options) {
	    this.lexer = lexer;
	    this.$filter = $filter;
	    this.options = options;
	    this.ast = new AST(lexer, options);
	    this.astCompiler = options.csp ? new ASTInterpreter(this.ast, $filter) :
	      new ASTCompiler(this.ast, $filter);
	  };
	
	  Parser.prototype = {
	    constructor: Parser,
	
	    parse: function(text) {
	      return this.astCompiler.compile(text, this.options.expensiveChecks);
	    }
	  };
	
	  function isPossiblyDangerousMemberName(name) {
	    return name == 'constructor';
	  }
	
	  var objectValueOf = Object.prototype.valueOf;
	
	  function getValueOf(value) {
	    return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	  }
	
	///////////////////////////////////
	
	  /**
	   * @ngdoc service
	   * @name $parse
	   * @kind function
	   *
	   * @description
	   *
	   * Converts Angular {@link guide/expression expression} into a function.
	   *
	   * ```js
	   *   var getter = $parse('user.name');
	   *   var setter = getter.assign;
	   *   var context = {user:{name:'angular'}};
	   *   var locals = {user:{name:'local'}};
	   *
	   *   expect(getter(context)).toEqual('angular');
	   *   setter(context, 'newValue');
	   *   expect(context.user.name).toEqual('newValue');
	   *   expect(getter(context, locals)).toEqual('local');
	   * ```
	   *
	   *
	   * @param {string} expression String expression to compile.
	   * @returns {function(context, locals)} a function which represents the compiled expression:
	   *
	   *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	   *      are evaluated against (typically a scope object).
	   *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	   *      `context`.
	   *
	   *    The returned function also has the following properties:
	   *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	   *        literal.
	   *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	   *        constant literals.
	   *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	   *        set to a function to change its value on the given context.
	   *
	   */
	
	
	  /**
	   * @ngdoc provider
	   * @name $parseProvider
	   *
	   * @description
	   * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	   *  service.
	   */
	  function $ParseProvider() {
	    var cacheDefault = createMap();
	    var cacheExpensive = createMap();
	    var literals = {
	      'true': true,
	      'false': false,
	      'null': null,
	      'undefined': undefined
	    };
	    var identStart, identContinue;
	
	    /**
	     * @ngdoc method
	     * @name $parseProvider#addLiteral
	     * @description
	     *
	     * Configure $parse service to add literal values that will be present as literal at expressions.
	     *
	     * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	     * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	     *
	     **/
	    this.addLiteral = function(literalName, literalValue) {
	      literals[literalName] = literalValue;
	    };
	
	    /**
	     * @ngdoc method
	     * @name $parseProvider#setIdentifierFns
	     * @description
	     *
	     * Allows defining the set of characters that are allowed in Angular expressions. The function
	     * `identifierStart` will get called to know if a given character is a valid character to be the
	     * first character for an identifier. The function `identifierContinue` will get called to know if
	     * a given character is a valid character to be a follow-up identifier character. The functions
	     * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	     * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	     * mind that the `string` parameter can be two characters long depending on the character
	     * representation. It is expected for the function to return `true` or `false`, whether that
	     * character is allowed or not.
	     *
	     * Since this function will be called extensivelly, keep the implementation of these functions fast,
	     * as the performance of these functions have a direct impact on the expressions parsing speed.
	     *
	     * @param {function=} identifierStart The function that will decide whether the given character is
	     *   a valid identifier start character.
	     * @param {function=} identifierContinue The function that will decide whether the given character is
	     *   a valid identifier continue character.
	     */
	    this.setIdentifierFns = function(identifierStart, identifierContinue) {
	      identStart = identifierStart;
	      identContinue = identifierContinue;
	      return this;
	    };
	
	    this.$get = ['$filter', function($filter) {
	      var noUnsafeEval = csp().noUnsafeEval;
	      var $parseOptions = {
	          csp: noUnsafeEval,
	          expensiveChecks: false,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        },
	        $parseOptionsExpensive = {
	          csp: noUnsafeEval,
	          expensiveChecks: true,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        };
	      var runningChecksEnabled = false;
	
	      $parse.$$runningExpensiveChecks = function() {
	        return runningChecksEnabled;
	      };
	
	      return $parse;
	
	      function $parse(exp, interceptorFn, expensiveChecks) {
	        var parsedExpression, oneTime, cacheKey;
	
	        expensiveChecks = expensiveChecks || runningChecksEnabled;
	
	        switch (typeof exp) {
	          case 'string':
	            exp = exp.trim();
	            cacheKey = exp;
	
	            var cache = (expensiveChecks ? cacheExpensive : cacheDefault);
	            parsedExpression = cache[cacheKey];
	
	            if (!parsedExpression) {
	              if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	                oneTime = true;
	                exp = exp.substring(2);
	              }
	              var parseOptions = expensiveChecks ? $parseOptionsExpensive : $parseOptions;
	              var lexer = new Lexer(parseOptions);
	              var parser = new Parser(lexer, $filter, parseOptions);
	              parsedExpression = parser.parse(exp);
	              if (parsedExpression.constant) {
	                parsedExpression.$$watchDelegate = constantWatchDelegate;
	              } else if (oneTime) {
	                parsedExpression.$$watchDelegate = parsedExpression.literal ?
	                  oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
	              } else if (parsedExpression.inputs) {
	                parsedExpression.$$watchDelegate = inputsWatchDelegate;
	              }
	              if (expensiveChecks) {
	                parsedExpression = expensiveChecksInterceptor(parsedExpression);
	              }
	              cache[cacheKey] = parsedExpression;
	            }
	            return addInterceptor(parsedExpression, interceptorFn);
	
	          case 'function':
	            return addInterceptor(exp, interceptorFn);
	
	          default:
	            return addInterceptor(noop, interceptorFn);
	        }
	      }
	
	      function expensiveChecksInterceptor(fn) {
	        if (!fn) return fn;
	        expensiveCheckFn.$$watchDelegate = fn.$$watchDelegate;
	        expensiveCheckFn.assign = expensiveChecksInterceptor(fn.assign);
	        expensiveCheckFn.constant = fn.constant;
	        expensiveCheckFn.literal = fn.literal;
	        for (var i = 0; fn.inputs && i < fn.inputs.length; ++i) {
	          fn.inputs[i] = expensiveChecksInterceptor(fn.inputs[i]);
	        }
	        expensiveCheckFn.inputs = fn.inputs;
	
	        return expensiveCheckFn;
	
	        function expensiveCheckFn(scope, locals, assign, inputs) {
	          var expensiveCheckOldValue = runningChecksEnabled;
	          runningChecksEnabled = true;
	          try {
	            return fn(scope, locals, assign, inputs);
	          } finally {
	            runningChecksEnabled = expensiveCheckOldValue;
	          }
	        }
	      }
	
	      function expressionInputDirtyCheck(newValue, oldValueOfValue) {
	
	        if (newValue == null || oldValueOfValue == null) { // null/undefined
	          return newValue === oldValueOfValue;
	        }
	
	        if (typeof newValue === 'object') {
	
	          // attempt to convert the value to a primitive type
	          // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	          //             be cheaply dirty-checked
	          newValue = getValueOf(newValue);
	
	          if (typeof newValue === 'object') {
	            // objects/arrays are not supported - deep-watching them would be too expensive
	            return false;
	          }
	
	          // fall-through to the primitive equality check
	        }
	
	        //Primitive or NaN
	        return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	      }
	
	      function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	        var inputExpressions = parsedExpression.inputs;
	        var lastResult;
	
	        if (inputExpressions.length === 1) {
	          var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	          inputExpressions = inputExpressions[0];
	          return scope.$watch(function expressionInputWatch(scope) {
	            var newInputValue = inputExpressions(scope);
	            if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf)) {
	              lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	              oldInputValueOf = newInputValue && getValueOf(newInputValue);
	            }
	            return lastResult;
	          }, listener, objectEquality, prettyPrintExpression);
	        }
	
	        var oldInputValueOfValues = [];
	        var oldInputValues = [];
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	          oldInputValues[i] = null;
	        }
	
	        return scope.$watch(function expressionInputsWatch(scope) {
	          var changed = false;
	
	          for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	            var newInputValue = inputExpressions[i](scope);
	            if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i]))) {
	              oldInputValues[i] = newInputValue;
	              oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	            }
	          }
	
	          if (changed) {
	            lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	          }
	
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	        var unwatch, lastValue;
	        return unwatch = scope.$watch(function oneTimeWatch(scope) {
	          return parsedExpression(scope);
	        }, function oneTimeListener(value, old, scope) {
	          lastValue = value;
	          if (isFunction(listener)) {
	            listener.apply(this, arguments);
	          }
	          if (isDefined(value)) {
	            scope.$$postDigest(function() {
	              if (isDefined(lastValue)) {
	                unwatch();
	              }
	            });
	          }
	        }, objectEquality);
	      }
	
	      function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	        var unwatch, lastValue;
	        return unwatch = scope.$watch(function oneTimeWatch(scope) {
	          return parsedExpression(scope);
	        }, function oneTimeListener(value, old, scope) {
	          lastValue = value;
	          if (isFunction(listener)) {
	            listener.call(this, value, old, scope);
	          }
	          if (isAllDefined(value)) {
	            scope.$$postDigest(function() {
	              if (isAllDefined(lastValue)) unwatch();
	            });
	          }
	        }, objectEquality);
	
	        function isAllDefined(value) {
	          var allDefined = true;
	          forEach(value, function(val) {
	            if (!isDefined(val)) allDefined = false;
	          });
	          return allDefined;
	        }
	      }
	
	      function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	        var unwatch;
	        return unwatch = scope.$watch(function constantWatch(scope) {
	          unwatch();
	          return parsedExpression(scope);
	        }, listener, objectEquality);
	      }
	
	      function addInterceptor(parsedExpression, interceptorFn) {
	        if (!interceptorFn) return parsedExpression;
	        var watchDelegate = parsedExpression.$$watchDelegate;
	        var useInputs = false;
	
	        var regularWatch =
	          watchDelegate !== oneTimeLiteralWatchDelegate &&
	          watchDelegate !== oneTimeWatchDelegate;
	
	        var fn = regularWatch ? function regularInterceptedExpression(scope, locals, assign, inputs) {
	          var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	          return interceptorFn(value, scope, locals);
	        } : function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
	          var value = parsedExpression(scope, locals, assign, inputs);
	          var result = interceptorFn(value, scope, locals);
	          // we only return the interceptor's result if the
	          // initial value is defined (for bind-once)
	          return isDefined(value) ? result : value;
	        };
	
	        // Propagate $$watchDelegates other then inputsWatchDelegate
	        if (parsedExpression.$$watchDelegate &&
	          parsedExpression.$$watchDelegate !== inputsWatchDelegate) {
	          fn.$$watchDelegate = parsedExpression.$$watchDelegate;
	        } else if (!interceptorFn.$stateful) {
	          // If there is an interceptor, but no watchDelegate then treat the interceptor like
	          // we treat filters - it is assumed to be a pure function unless flagged with $stateful
	          fn.$$watchDelegate = inputsWatchDelegate;
	          useInputs = !parsedExpression.inputs;
	          fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	        }
	
	        return fn;
	      }
	    }];
	  }
	
	  /**
	   * @ngdoc service
	   * @name $q
	   * @requires $rootScope
	   *
	   * @description
	   * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	   * when they are done processing.
	   *
	   * This is an implementation of promises/deferred objects inspired by
	   * [Kris Kowal's Q](https://github.com/kriskowal/q).
	   *
	   * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	   * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	   *
	   * # $q constructor
	   *
	   * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	   * function as the first argument. This is similar to the native Promise implementation from ES6,
	   * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	   *
	   * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	   * available yet.
	   *
	   * It can be used like so:
	   *
	   * ```js
	   *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	   *   // are available in the current lexical scope (they could have been injected or passed in).
	   *
	   *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	   *
	   *   var promise = asyncGreet('Robin Hood');
	   *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	   * ```
	   *
	   * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	   *
	   * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	   *
	   * However, the more traditional CommonJS-style usage is still available, and documented below.
	   *
	   * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	   * interface for interacting with an object that represents the result of an action that is
	   * performed asynchronously, and may or may not be finished at any given point in time.
	   *
	   * From the perspective of dealing with error handling, deferred and promise APIs are to
	   * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	   *
	   * ```js
	   *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	   *   // are available in the current lexical scope (they could have been injected or passed in).
	   *
	   *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	   *
	   *   var promise = asyncGreet('Robin Hood');
	   *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	   * ```
	   *
	   * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	   * comes in the way of guarantees that promise and deferred APIs make, see
	   * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	   *
	   * Additionally the promise api allows for composition that is very hard to do with the
	   * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	   * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	   * section on serial or parallel joining of promises.
	   *
	   * # The Deferred API
	   *
	   * A new instance of deferred is constructed by calling `$q.defer()`.
	   *
	   * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	   * that can be used for signaling the successful or unsuccessful completion, as well as the status
	   * of the task.
	   *
	   * **Methods**
	   *
	   * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	   *   constructed via `$q.reject`, the promise will be rejected instead.
	   * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	   *   resolving it with a rejection constructed via `$q.reject`.
	   * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	   *   multiple times before the promise is either resolved or rejected.
	   *
	   * **Properties**
	   *
	   * - promise – `{Promise}` – promise object associated with this deferred.
	   *
	   *
	   * # The Promise API
	   *
	   * A new promise instance is created when a deferred instance is created and can be retrieved by
	   * calling `deferred.promise`.
	   *
	   * The purpose of the promise object is to allow for interested parties to get access to the result
	   * of the deferred task when it completes.
	   *
	   * **Methods**
	   *
	   * - `then(successCallback, errorCallback, notifyCallback)` – regardless of when the promise was or
	   *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	   *   as soon as the result is available. The callbacks are called with a single argument: the result
	   *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	   *   provide a progress indication, before the promise is resolved or rejected.
	   *
	   *   This method *returns a new promise* which is resolved or rejected via the return value of the
	   *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	   *   with the value which is resolved in that promise using
	   *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	   *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	   *   resolved or rejected from the notifyCallback method.
	   *
	   * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	   *
	   * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	   *   but to do so without modifying the final value. This is useful to release resources or do some
	   *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	   *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	   *   more information.
	   *
	   * # Chaining promises
	   *
	   * Because calling the `then` method of a promise returns a new derived promise, it is easily
	   * possible to create a chain of promises:
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	   *
	   *   // promiseB will be resolved immediately after promiseA is resolved and its value
	   *   // will be the result of promiseA incremented by 1
	   * ```
	   *
	   * It is possible to create chains of any length and since a promise can be resolved with another
	   * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	   * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	   * $http's response interceptors.
	   *
	   *
	   * # Differences between Kris Kowal's Q and $q
	   *
	   *  There are two main differences:
	   *
	   * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	   *   mechanism in angular, which means faster propagation of resolution or rejection into your
	   *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	   * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	   *   all the important functionality needed for common async tasks.
	   *
	   * # Testing
	   *
	   *  ```js
	   *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	   *  ```
	   *
	   * @param {function(function, function)} resolver Function which is responsible for resolving or
	   *   rejecting the newly created promise. The first parameter is a function which resolves the
	   *   promise, the second parameter is a function which rejects the promise.
	   *
	   * @returns {Promise} The newly created promise.
	   */
	  function $QProvider() {
	
	    this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	      return qFactory(function(callback) {
	        $rootScope.$evalAsync(callback);
	      }, $exceptionHandler);
	    }];
	  }
	
	  function $$QProvider() {
	    this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	      return qFactory(function(callback) {
	        $browser.defer(callback);
	      }, $exceptionHandler);
	    }];
	  }
	
	  /**
	   * Constructs a promise manager.
	   *
	   * @param {function(function)} nextTick Function for executing functions in the next turn.
	   * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	   *     debugging purposes.
	   * @returns {object} Promise manager.
	   */
	  function qFactory(nextTick, exceptionHandler) {
	    var $qMinErr = minErr('$q', TypeError);
	
	    /**
	     * @ngdoc method
	     * @name ng.$q#defer
	     * @kind function
	     *
	     * @description
	     * Creates a `Deferred` object which represents a task which will finish in the future.
	     *
	     * @returns {Deferred} Returns a new instance of deferred.
	     */
	    var defer = function() {
	      var d = new Deferred();
	      //Necessary to support unbound execution :/
	      d.resolve = simpleBind(d, d.resolve);
	      d.reject = simpleBind(d, d.reject);
	      d.notify = simpleBind(d, d.notify);
	      return d;
	    };
	
	    function Promise() {
	      this.$$state = { status: 0 };
	    }
	
	    extend(Promise.prototype, {
	      then: function(onFulfilled, onRejected, progressBack) {
	        if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	          return this;
	        }
	        var result = new Deferred();
	
	        this.$$state.pending = this.$$state.pending || [];
	        this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	        if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	        return result.promise;
	      },
	
	      "catch": function(callback) {
	        return this.then(null, callback);
	      },
	
	      "finally": function(callback, progressBack) {
	        return this.then(function(value) {
	          return handleCallback(value, true, callback);
	        }, function(error) {
	          return handleCallback(error, false, callback);
	        }, progressBack);
	      }
	    });
	
	    //Faster, more basic than angular.bind http://jsperf.com/angular-bind-vs-custom-vs-native
	    function simpleBind(context, fn) {
	      return function(value) {
	        fn.call(context, value);
	      };
	    }
	
	    function processQueue(state) {
	      var fn, deferred, pending;
	
	      pending = state.pending;
	      state.processScheduled = false;
	      state.pending = undefined;
	      for (var i = 0, ii = pending.length; i < ii; ++i) {
	        deferred = pending[i][0];
	        fn = pending[i][state.status];
	        try {
	          if (isFunction(fn)) {
	            deferred.resolve(fn(state.value));
	          } else if (state.status === 1) {
	            deferred.resolve(state.value);
	          } else {
	            deferred.reject(state.value);
	          }
	        } catch (e) {
	          deferred.reject(e);
	          exceptionHandler(e);
	        }
	      }
	    }
	
	    function scheduleProcessQueue(state) {
	      if (state.processScheduled || !state.pending) return;
	      state.processScheduled = true;
	      nextTick(function() { processQueue(state); });
	    }
	
	    function Deferred() {
	      this.promise = new Promise();
	    }
	
	    extend(Deferred.prototype, {
	      resolve: function(val) {
	        if (this.promise.$$state.status) return;
	        if (val === this.promise) {
	          this.$$reject($qMinErr(
	            'qcycle',
	            "Expected promise to be resolved with value other than itself '{0}'",
	            val));
	        } else {
	          this.$$resolve(val);
	        }
	
	      },
	
	      $$resolve: function(val) {
	        var then;
	        var that = this;
	        var done = false;
	        try {
	          if ((isObject(val) || isFunction(val))) then = val && val.then;
	          if (isFunction(then)) {
	            this.promise.$$state.status = -1;
	            then.call(val, resolvePromise, rejectPromise, simpleBind(this, this.notify));
	          } else {
	            this.promise.$$state.value = val;
	            this.promise.$$state.status = 1;
	            scheduleProcessQueue(this.promise.$$state);
	          }
	        } catch (e) {
	          rejectPromise(e);
	          exceptionHandler(e);
	        }
	
	        function resolvePromise(val) {
	          if (done) return;
	          done = true;
	          that.$$resolve(val);
	        }
	        function rejectPromise(val) {
	          if (done) return;
	          done = true;
	          that.$$reject(val);
	        }
	      },
	
	      reject: function(reason) {
	        if (this.promise.$$state.status) return;
	        this.$$reject(reason);
	      },
	
	      $$reject: function(reason) {
	        this.promise.$$state.value = reason;
	        this.promise.$$state.status = 2;
	        scheduleProcessQueue(this.promise.$$state);
	      },
	
	      notify: function(progress) {
	        var callbacks = this.promise.$$state.pending;
	
	        if ((this.promise.$$state.status <= 0) && callbacks && callbacks.length) {
	          nextTick(function() {
	            var callback, result;
	            for (var i = 0, ii = callbacks.length; i < ii; i++) {
	              result = callbacks[i][0];
	              callback = callbacks[i][3];
	              try {
	                result.notify(isFunction(callback) ? callback(progress) : progress);
	              } catch (e) {
	                exceptionHandler(e);
	              }
	            }
	          });
	        }
	      }
	    });
	
	    /**
	     * @ngdoc method
	     * @name $q#reject
	     * @kind function
	     *
	     * @description
	     * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	     * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	     * a promise chain, you don't need to worry about it.
	     *
	     * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	     * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	     * a promise error callback and you want to forward the error to the promise derived from the
	     * current promise, you have to "rethrow" the error by returning a rejection constructed via
	     * `reject`.
	     *
	     * ```js
	     *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	     * ```
	     *
	     * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	     * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	     */
	    var reject = function(reason) {
	      var result = new Deferred();
	      result.reject(reason);
	      return result.promise;
	    };
	
	    var makePromise = function makePromise(value, resolved) {
	      var result = new Deferred();
	      if (resolved) {
	        result.resolve(value);
	      } else {
	        result.reject(value);
	      }
	      return result.promise;
	    };
	
	    var handleCallback = function handleCallback(value, isResolved, callback) {
	      var callbackOutput = null;
	      try {
	        if (isFunction(callback)) callbackOutput = callback();
	      } catch (e) {
	        return makePromise(e, false);
	      }
	      if (isPromiseLike(callbackOutput)) {
	        return callbackOutput.then(function() {
	          return makePromise(value, isResolved);
	        }, function(error) {
	          return makePromise(error, false);
	        });
	      } else {
	        return makePromise(value, isResolved);
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $q#when
	     * @kind function
	     *
	     * @description
	     * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	     * This is useful when you are dealing with an object that might or might not be a promise, or if
	     * the promise comes from a source that can't be trusted.
	     *
	     * @param {*} value Value or a promise
	     * @param {Function=} successCallback
	     * @param {Function=} errorCallback
	     * @param {Function=} progressCallback
	     * @returns {Promise} Returns a promise of the passed value or promise
	     */
	
	
	    var when = function(value, callback, errback, progressBack) {
	      var result = new Deferred();
	      result.resolve(value);
	      return result.promise.then(callback, errback, progressBack);
	    };
	
	    /**
	     * @ngdoc method
	     * @name $q#resolve
	     * @kind function
	     *
	     * @description
	     * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	     *
	     * @param {*} value Value or a promise
	     * @param {Function=} successCallback
	     * @param {Function=} errorCallback
	     * @param {Function=} progressCallback
	     * @returns {Promise} Returns a promise of the passed value or promise
	     */
	    var resolve = when;
	
	    /**
	     * @ngdoc method
	     * @name $q#all
	     * @kind function
	     *
	     * @description
	     * Combines multiple promises into a single promise that is resolved when all of the input
	     * promises are resolved.
	     *
	     * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	     * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	     *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	     *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	     *   with the same rejection value.
	     */
	
	    function all(promises) {
	      var deferred = new Deferred(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	      forEach(promises, function(promise, key) {
	        counter++;
	        when(promise).then(function(value) {
	          if (results.hasOwnProperty(key)) return;
	          results[key] = value;
	          if (!(--counter)) deferred.resolve(results);
	        }, function(reason) {
	          if (results.hasOwnProperty(key)) return;
	          deferred.reject(reason);
	        });
	      });
	
	      if (counter === 0) {
	        deferred.resolve(results);
	      }
	
	      return deferred.promise;
	    }
	
	    var $Q = function Q(resolver) {
	      if (!isFunction(resolver)) {
	        throw $qMinErr('norslvr', "Expected resolverFn, got '{0}'", resolver);
	      }
	
	      var deferred = new Deferred();
	
	      function resolveFn(value) {
	        deferred.resolve(value);
	      }
	
	      function rejectFn(reason) {
	        deferred.reject(reason);
	      }
	
	      resolver(resolveFn, rejectFn);
	
	      return deferred.promise;
	    };
	
	    // Let's make the instanceof operator work for promises, so that
	    // `new $q(fn) instanceof $q` would evaluate to true.
	    $Q.prototype = Promise.prototype;
	
	    $Q.defer = defer;
	    $Q.reject = reject;
	    $Q.when = when;
	    $Q.resolve = resolve;
	    $Q.all = all;
	
	    return $Q;
	  }
	
	  function $$RAFProvider() { //rAF
	    this.$get = ['$window', '$timeout', function($window, $timeout) {
	      var requestAnimationFrame = $window.requestAnimationFrame ||
	        $window.webkitRequestAnimationFrame;
	
	      var cancelAnimationFrame = $window.cancelAnimationFrame ||
	        $window.webkitCancelAnimationFrame ||
	        $window.webkitCancelRequestAnimationFrame;
	
	      var rafSupported = !!requestAnimationFrame;
	      var raf = rafSupported
	        ? function(fn) {
	        var id = requestAnimationFrame(fn);
	        return function() {
	          cancelAnimationFrame(id);
	        };
	      }
	        : function(fn) {
	        var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	        return function() {
	          $timeout.cancel(timer);
	        };
	      };
	
	      raf.supported = rafSupported;
	
	      return raf;
	    }];
	  }
	
	  /**
	   * DESIGN NOTES
	   *
	   * The design decisions behind the scope are heavily favored for speed and memory consumption.
	   *
	   * The typical use of scope is to watch the expressions, which most of the time return the same
	   * value as last time so we optimize the operation.
	   *
	   * Closures construction is expensive in terms of speed as well as memory:
	   *   - No closures, instead use prototypical inheritance for API
	   *   - Internal state needs to be stored on scope directly, which means that private state is
	   *     exposed as $$____ properties
	   *
	   * Loop operations are optimized by using while(count--) { ... }
	   *   - This means that in order to keep the same order of execution as addition we have to add
	   *     items to the array at the beginning (unshift) instead of at the end (push)
	   *
	   * Child scopes are created and removed often
	   *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	   *
	   * There are fewer watches than observers. This is why you don't want the observer to be implemented
	   * in the same way as watch. Watch requires return of the initialization function which is expensive
	   * to construct.
	   */
	
	
	  /**
	   * @ngdoc provider
	   * @name $rootScopeProvider
	   * @description
	   *
	   * Provider for the $rootScope service.
	   */
	
	  /**
	   * @ngdoc method
	   * @name $rootScopeProvider#digestTtl
	   * @description
	   *
	   * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that the dependencies between `$watch`s will result in
	   * several digest iterations. However if an application needs more than the default 10 digest
	   * iterations for its model to stabilize then you should investigate what is causing the model to
	   * continuously change during the digest.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without
	   * proper justification.
	   *
	   * @param {number} limit The number of digest iterations.
	   */
	
	
	  /**
	   * @ngdoc service
	   * @name $rootScope
	   * @description
	   *
	   * Every application has a single root {@link ng.$rootScope.Scope scope}.
	   * All other scopes are descendant scopes of the root scope. Scopes provide separation
	   * between the model and the view, via a mechanism for watching the model for changes.
	   * They also provide event emission/broadcast and subscription facility. See the
	   * {@link guide/scope developer guide on scopes}.
	   */
	  function $RootScopeProvider() {
	    var TTL = 10;
	    var $rootScopeMinErr = minErr('$rootScope');
	    var lastDirtyWatch = null;
	    var applyAsyncId = null;
	
	    this.digestTtl = function(value) {
	      if (arguments.length) {
	        TTL = value;
	      }
	      return TTL;
	    };
	
	    function createChildScopeClass(parent) {
	      function ChildScope() {
	        this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	        this.$$listeners = {};
	        this.$$listenerCount = {};
	        this.$$watchersCount = 0;
	        this.$id = nextUid();
	        this.$$ChildScope = null;
	      }
	      ChildScope.prototype = parent;
	      return ChildScope;
	    }
	
	    this.$get = ['$exceptionHandler', '$parse', '$browser',
	      function($exceptionHandler, $parse, $browser) {
	
	        function destroyChildScope($event) {
	          $event.currentScope.$$destroyed = true;
	        }
	
	        function cleanUpScope($scope) {
	
	          if (msie === 9) {
	            // There is a memory leak in IE9 if all child scopes are not disconnected
	            // completely when a scope is destroyed. So this code will recurse up through
	            // all this scopes children
	            //
	            // See issue https://github.com/angular/angular.js/issues/10706
	            $scope.$$childHead && cleanUpScope($scope.$$childHead);
	            $scope.$$nextSibling && cleanUpScope($scope.$$nextSibling);
	          }
	
	          // The code below works around IE9 and V8's memory leaks
	          //
	          // See:
	          // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	          // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	          // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	          $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
	            $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
	        }
	
	        /**
	         * @ngdoc type
	         * @name $rootScope.Scope
	         *
	         * @description
	         * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	         * {@link auto.$injector $injector}. Child scopes are created using the
	         * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	         * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	         * an in-depth introduction and usage examples.
	         *
	         *
	         * # Inheritance
	         * A scope can inherit from a parent scope, as in this example:
	         * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	         * ```
	         *
	         * When interacting with `Scope` in tests, additional helper methods are available on the
	         * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	         * details.
	         *
	         *
	         * @param {Object.<string, function()>=} providers Map of service factory which need to be
	         *                                       provided for the current scope. Defaults to {@link ng}.
	         * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	         *                              append/override services provided by `providers`. This is handy
	         *                              when unit-testing and having the need to override a default
	         *                              service.
	         * @returns {Object} Newly created scope.
	         *
	         */
	        function Scope() {
	          this.$id = nextUid();
	          this.$$phase = this.$parent = this.$$watchers =
	            this.$$nextSibling = this.$$prevSibling =
	              this.$$childHead = this.$$childTail = null;
	          this.$root = this;
	          this.$$destroyed = false;
	          this.$$listeners = {};
	          this.$$listenerCount = {};
	          this.$$watchersCount = 0;
	          this.$$isolateBindings = null;
	        }
	
	        /**
	         * @ngdoc property
	         * @name $rootScope.Scope#$id
	         *
	         * @description
	         * Unique scope ID (monotonically increasing) useful for debugging.
	         */
	
	        /**
	         * @ngdoc property
	         * @name $rootScope.Scope#$parent
	         *
	         * @description
	         * Reference to the parent scope.
	         */
	
	        /**
	         * @ngdoc property
	         * @name $rootScope.Scope#$root
	         *
	         * @description
	         * Reference to the root scope.
	         */
	
	        Scope.prototype = {
	          constructor: Scope,
	          /**
	           * @ngdoc method
	           * @name $rootScope.Scope#$new
	           * @kind function
	           *
	           * @description
	           * Creates a new child {@link ng.$rootScope.Scope scope}.
	           *
	           * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	           * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	           *
	           * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	           * desired for the scope and its child scopes to be permanently detached from the parent and
	           * thus stop participating in model change detection and listener notification by invoking.
	           *
	           * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	           *         parent scope. The scope is isolated, as it can not see parent scope properties.
	           *         When creating widgets, it is useful for the widget to not accidentally read parent
	           *         state.
	           *
	           * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	           *                              of the newly created scope. Defaults to `this` scope if not provided.
	           *                              This is used when creating a transclude scope to correctly place it
	           *                              in the scope hierarchy while maintaining the correct prototypical
	           *                              inheritance.
	           *
	           * @returns {Object} The newly created child scope.
	           *
	           */
	          $new: function(isolate, parent) {
	            var child;
	
	            parent = parent || this;
	
	            if (isolate) {
	              child = new Scope();
	              child.$root = this.$root;
	            } else {
	              // Only create a child scope class if somebody asks for one,
	              // but cache it to allow the VM to optimize lookups.
	              if (!this.$$ChildScope) {
	                this.$$ChildScope = createChildScopeClass(this);
	              }
	              child = new this.$$ChildScope();
	            }
	            child.$parent = parent;
	            child.$$prevSibling = parent.$$childTail;
	            if (parent.$$childHead) {
	              parent.$$childTail.$$nextSibling = child;
	              parent.$$childTail = child;
	            } else {
	              parent.$$childHead = parent.$$childTail = child;
	            }
	
	            // When the new scope is not isolated or we inherit from `this`, and
	            // the parent scope is destroyed, the property `$$destroyed` is inherited
	            // prototypically. In all other cases, this property needs to be set
	            // when the parent scope is destroyed.
	            // The listener needs to be added after the parent is set
	            if (isolate || parent != this) child.$on('$destroy', destroyChildScope);
	
	            return child;
	          },
	
	          /**
	           * @ngdoc method
	           * @name $rootScope.Scope#$watch
	           * @kind function
	           *
	           * @description
	           * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	           *
	           * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	           *   its value when executed multiple times with the same input because it may be executed multiple
	           *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	           *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).
	           * - The `listener` is called only when the value from the current `watchExpression` and the
	           *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	           *   see below). Inequality is determined according to reference inequality,
	           *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	           *    via the `!==` Javascript operator, unless `objectEquality == true`
	           *   (see next point)
	           * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	           *   according to the {@link angular.equals} function. To save the value of the object for
	           *   later comparison, the {@link angular.copy} function is used. This therefore means that
	           *   watching complex objects will have adverse memory and performance implications.
	           * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	           *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	           *   iteration limit is 10 to prevent an infinite loop deadlock.
	           *
	           *
	           * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	           * you can register a `watchExpression` function with no `listener`. (Be prepared for
	           * multiple calls to your `watchExpression` because it will execute multiple times in a
	           * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	           *
	           * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	           * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	           * watcher. In rare cases, this is undesirable because the listener is called when the result
	           * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	           * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	           * listener was called due to initialization.
	           *
	           *
	           *
	           * # Example
	           * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	           // This function returns the value being watched. It is called for each turn of the $digest loop
	           function() { return food; },
	           // This is the change listener, called when the value returned from the above function changes
	           function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	           * ```
	           *
	           *
	           *
	           * @param {(function()|string)} watchExpression Expression that is evaluated on each
	           *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	           *    a call to the `listener`.
	           *
	           *    - `string`: Evaluated as {@link guide/expression expression}
	           *    - `function(scope)`: called with current `scope` as a parameter.
	           * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	           *    of `watchExpression` changes.
	           *
	           *    - `newVal` contains the current value of the `watchExpression`
	           *    - `oldVal` contains the previous value of the `watchExpression`
	           *    - `scope` refers to the current scope
	           * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	           *     comparing for reference equality.
	           * @returns {function()} Returns a deregistration function for this listener.
	           */
	          $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	            var get = $parse(watchExp);
	
	            if (get.$$watchDelegate) {
	              return get.$$watchDelegate(this, listener, objectEquality, get, watchExp);
	            }
	            var scope = this,
	              array = scope.$$watchers,
	              watcher = {
	                fn: listener,
	                last: initWatchVal,
	                get: get,
	                exp: prettyPrintExpression || watchExp,
	                eq: !!objectEquality
	              };
	
	            lastDirtyWatch = null;
	
	            if (!isFunction(listener)) {
	              watcher.fn = noop;
	            }
	
	            if (!array) {
	              array = scope.$$watchers = [];
	            }
	            // we use unshift since we use a while loop in $digest for speed.
	            // the while loop reads in reverse order.
	            array.unshift(watcher);
	            incrementWatchersCount(this, 1);
	
	            return function deregisterWatch() {
	              if (arrayRemove(array, watcher) >= 0) {
	                incrementWatchersCount(scope, -1);
	              }
	              lastDirtyWatch = null;
	            };
	          },
	
	          /**
	           * @ngdoc method
	           * @name $rootScope.Scope#$watchGroup
	           * @kind function
	           *
	           * @description
	           * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	           * If any one expression in the collection changes the `listener` is executed.
	           *
	           * - The items in the `watchExpressions` array are observed via standard $watch operation and are examined on every
	           *   call to $digest() to see if any items changes.
	           * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	           *
	           * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	           * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	           *
	           * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	           *    expression in `watchExpressions` changes
	           *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	           *    those of `watchExpression`
	           *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	           *    those of `watchExpression`
	           *    The `scope` refers to the current scope.
	           * @returns {function()} Returns a de-registration function for all listeners.
	           */
	          $watchGroup: function(watchExpressions, listener) {
	            var oldValues = new Array(watchExpressions.length);
	            var newValues = new Array(watchExpressions.length);
	            var deregisterFns = [];
	            var self = this;
	            var changeReactionScheduled = false;
	            var firstRun = true;
	
	            if (!watchExpressions.length) {
	              // No expressions means we call the listener ASAP
	              var shouldCall = true;
	              self.$evalAsync(function() {
	                if (shouldCall) listener(newValues, newValues, self);
	              });
	              return function deregisterWatchGroup() {
	                shouldCall = false;
	              };
	            }
	
	            if (watchExpressions.length === 1) {
	              // Special case size of one
	              return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	                newValues[0] = value;
	                oldValues[0] = oldValue;
	                listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	              });
	            }
	
	            forEach(watchExpressions, function(expr, i) {
	              var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
	                newValues[i] = value;
	                oldValues[i] = oldValue;
	                if (!changeReactionScheduled) {
	                  changeReactionScheduled = true;
	                  self.$evalAsync(watchGroupAction);
	                }
	              });
	              deregisterFns.push(unwatchFn);
	            });
	
	            function watchGroupAction() {
	              changeReactionScheduled = false;
	
	              if (firstRun) {
	                firstRun = false;
	                listener(newValues, newValues, self);
	              } else {
	                listener(newValues, oldValues, self);
	              }
	            }
	
	            return function deregisterWatchGroup() {
	              while (deregisterFns.length) {
	                deregisterFns.shift()();
	              }
	            };
	          },
	
	
	          /**
	           * @ngdoc method
	           * @name $rootScope.Scope#$watchCollection
	           * @kind function
	           *
	           * @description
	           * Shallow watches the properties of an object and fires whenever any of the properties change
	           * (for arrays, this implies watching the array items; for object maps, this implies watching
	           * the properties). If a change is detected, the `listener` callback is fired.
	           *
	           * - The `obj` collection is observed via standard $watch operation and is examined on every
	           *   call to $digest() to see if any items have been added, removed, or moved.
	           * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	           *   adding, removing, and moving items belonging to an object or array.
	           *
	           *
	           * # Example
	           * ```js
	           $scope.names = ['igor', 'matias', 'misko', 'james'];
	           $scope.dataCount = 4;
	
	           $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	           expect($scope.dataCount).toEqual(4);
	           $scope.$digest();
	
	           //still at 4 ... no changes
	           expect($scope.dataCount).toEqual(4);
	
	           $scope.names.pop();
	           $scope.$digest();
	
	           //now there's been a change
	           expect($scope.dataCount).toEqual(3);
	           * ```
	           *
	           *
	           * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	           *    expression value should evaluate to an object or an array which is observed on each
	           *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	           *    collection will trigger a call to the `listener`.
	           *
	           * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	           *    when a change is detected.
	           *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	           *    - The `oldCollection` object is a copy of the former collection data.
	           *      Due to performance considerations, the`oldCollection` value is computed only if the
	           *      `listener` function declares two or more arguments.
	           *    - The `scope` argument refers to the current scope.
	           *
	           * @returns {function()} Returns a de-registration function for this listener. When the
	           *    de-registration function is executed, the internal watch operation is terminated.
	           */
	          $watchCollection: function(obj, listener) {
	            $watchCollectionInterceptor.$stateful = true;
	
	            var self = this;
	            // the current value, updated on each dirty-check run
	            var newValue;
	            // a shallow copy of the newValue from the last dirty-check run,
	            // updated to match newValue during dirty-check run
	            var oldValue;
	            // a shallow copy of the newValue from when the last change happened
	            var veryOldValue;
	            // only track veryOldValue if the listener is asking for it
	            var trackVeryOldValue = (listener.length > 1);
	            var changeDetected = 0;
	            var changeDetector = $parse(obj, $watchCollectionInterceptor);
	            var internalArray = [];
	            var internalObject = {};
	            var initRun = true;
	            var oldLength = 0;
	
	            function $watchCollectionInterceptor(_value) {
	              newValue = _value;
	              var newLength, key, bothNaN, newItem, oldItem;
	
	              // If the new value is undefined, then return undefined as the watch may be a one-time watch
	              if (isUndefined(newValue)) return;
	
	              if (!isObject(newValue)) { // if primitive
	                if (oldValue !== newValue) {
	                  oldValue = newValue;
	                  changeDetected++;
	                }
	              } else if (isArrayLike(newValue)) {
	                if (oldValue !== internalArray) {
	                  // we are transitioning from something which was not an array into array.
	                  oldValue = internalArray;
	                  oldLength = oldValue.length = 0;
	                  changeDetected++;
	                }
	
	                newLength = newValue.length;
	
	                if (oldLength !== newLength) {
	                  // if lengths do not match we need to trigger change notification
	                  changeDetected++;
	                  oldValue.length = oldLength = newLength;
	                }
	                // copy the items to oldValue and look for changes.
	                for (var i = 0; i < newLength; i++) {
	                  oldItem = oldValue[i];
	                  newItem = newValue[i];
	
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[i] = newItem;
	                  }
	                }
	              } else {
	                if (oldValue !== internalObject) {
	                  // we are transitioning from something which was not an object into object.
	                  oldValue = internalObject = {};
	                  oldLength = 0;
	                  changeDetected++;
	                }
	                // copy the items to oldValue and look for changes.
	                newLength = 0;
	                for (key in newValue) {
	                  if (hasOwnProperty.call(newValue, key)) {
	                    newLength++;
	                    newItem = newValue[key];
	                    oldItem = oldValue[key];
	
	                    if (key in oldValue) {
	                      bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                      if (!bothNaN && (oldItem !== newItem)) {
	                        changeDetected++;
	                        oldValue[key] = newItem;
	                      }
	                    } else {
	                      oldLength++;
	                      oldValue[key] = newItem;
	                      changeDetected++;
	                    }
	                  }
	                }
	                if (oldLength > newLength) {
	                  // we used to have more keys, need to find them and destroy them.
	                  changeDetected++;
	                  for (key in oldValue) {
	                    if (!hasOwnProperty.call(newValue, key)) {
	                      oldLength--;
	                      delete oldValue[key];
	                    }
	                  }
	                }
	              }
	              return changeDetected;
	            }
	
	            function $watchCollectionAction() {
	              if (initRun) {
	                initRun = false;
	                listener(newValue, newValue, self);
	              } else {
	                listener(newValue, veryOldValue, self);
	              }
	
	              // make a copy for the next time a collection is changed
	              if (trackVeryOldValue) {
	                if (!isObject(newValue)) {
	                  //primitive
	                  veryOldValue = newValue;
	                } else if (isArrayLike(newValue)) {
	                  veryOldValue = new Array(newValue.length);
	                  for (var i = 0; i < newValue.length; i++) {
	                    veryOldValue[i] = newValue[i];
	                  }
	                } else { // if object
	                  veryOldValue = {};
	                  for (var key in newValue) {
	                    if (hasOwnProperty.call(newValue, key)) {
	                      veryOldValue[key] = newValue[key];
	                    }
	                  }
	                }
	              }
	            }
	
	            return this.$watch(changeDetector, $watchCollectionAction);
	          },
	
	          /**
	           * @ngdoc method
	           * @name $rootScope.Scope#$digest
	           * @kind function
	           *
	           * @description
	           * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	           * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	           * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	           * until no more listeners are firing. This means that it is possible to get into an infinite
	           * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	           * iterations exceeds 10.
	           *
	           * Usually, you don't call `$digest()` directly in
	           * {@link ng.directive:ngController controllers} or in
	           * {@link ng.$compileProvider#directive directives}.
	           * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	           * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	           *
	           * If you want to be notified whenever `$digest()` is called,
	           * you can register a `watchExpression` function with
	           * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	           *
	           * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	           *
	           * # Example
	           * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	           * ```
	           *
	           */
	          $digest: function() {
	            var watch, value, last, fn, get,
	              watchers,
	              length,
	              dirty, ttl = TTL,
	              next, current, target = this,
	              watchLog = [],
	              logIdx, asyncTask;
	
	            beginPhase('$digest');
	            // Check for changes to browser url that happened in sync before the call to $digest
	            $browser.$$checkUrlChange();
	
	            if (this === $rootScope && applyAsyncId !== null) {
	              // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	              // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	              $browser.defer.cancel(applyAsyncId);
	              flushApplyAsync();
	            }
	
	            lastDirtyWatch = null;
	
	            do { // "while dirty" loop
	              dirty = false;
	              current = target;
	
	              // It's safe for asyncQueuePosition to be a local variable here because this loop can't
	              // be reentered recursively. Calling $digest from a function passed to $applyAsync would
	              // lead to a '$digest already in progress' error.
	              for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
	                try {
	                  asyncTask = asyncQueue[asyncQueuePosition];
	                  asyncTask.scope.$eval(asyncTask.expression, asyncTask.locals);
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	                lastDirtyWatch = null;
	              }
	              asyncQueue.length = 0;
	
	              traverseScopesLoop:
	                do { // "traverse the scopes" loop
	                  if ((watchers = current.$$watchers)) {
	                    // process our watches
	                    length = watchers.length;
	                    while (length--) {
	                      try {
	                        watch = watchers[length];
	                        // Most common watches are on primitives, in which case we can short
	                        // circuit it with === operator, only when === fails do we use .equals
	                        if (watch) {
	                          get = watch.get;
	                          if ((value = get(current)) !== (last = watch.last) &&
	                            !(watch.eq
	                              ? equals(value, last)
	                              : (typeof value === 'number' && typeof last === 'number'
	                            && isNaN(value) && isNaN(last)))) {
	                            dirty = true;
	                            lastDirtyWatch = watch;
	                            watch.last = watch.eq ? copy(value, null) : value;
	                            fn = watch.fn;
	                            fn(value, ((last === initWatchVal) ? value : last), current);
	                            if (ttl < 5) {
	                              logIdx = 4 - ttl;
	                              if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                              watchLog[logIdx].push({
	                                msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                                newVal: value,
	                                oldVal: last
	                              });
	                            }
	                          } else if (watch === lastDirtyWatch) {
	                            // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                            // have already been tested.
	                            dirty = false;
	                            break traverseScopesLoop;
	                          }
	                        }
	                      } catch (e) {
	                        $exceptionHandler(e);
	                      }
	                    }
	                  }
	
	                  // Insanity Warning: scope depth-first traversal
	                  // yes, this code is a bit crazy, but it works and we have tests to prove it!
	                  // this piece should be kept in sync with the traversal in $broadcast
	                  if (!(next = ((current.$$watchersCount && current.$$childHead) ||
	                    (current !== target && current.$$nextSibling)))) {
	                    while (current !== target && !(next = current.$$nextSibling)) {
	                      current = current.$parent;
	                    }
	                  }
	                } while ((current = next));
	
	              // `break traverseScopesLoop;` takes us to here
	
	              if ((dirty || asyncQueue.length) && !(ttl--)) {
	                clearPhase();
	                throw $rootScopeMinErr('infdig',
	                  '{0} $digest() iterations reached. Aborting!\n' +
	                  'Watchers fired in the last 5 iterations: {1}',
	                  TTL, watchLog);
	              }
	
	            } while (dirty || asyncQueue.length);
	
	            clearPhase();
	
	            // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	            while (postDigestQueuePosition < postDigestQueue.length) {
	              try {
	                postDigestQueue[postDigestQueuePosition++]();
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            }
	            postDigestQueue.length = postDigestQueuePosition = 0;
	          },
	
	
	          /**
	           * @ngdoc event
	           * @name $rootScope.Scope#$destroy
	           * @eventType broadcast on scope being destroyed
	           *
	           * @description
	           * Broadcasted when a scope and its children are being destroyed.
	           *
	           * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	           * clean up DOM bindings before an element is removed from the DOM.
	           */
	
	          /**
	           * @ngdoc method
	           * @name $rootScope.Scope#$destroy
	           * @kind function
	           *
	           * @description
	           * Removes the current scope (and all of its children) from the parent scope. Removal implies
	           * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	           * propagate to the current scope and its children. Removal also implies that the current
	           * scope is eligible for garbage collection.
	           *
	           * The `$destroy()` is usually used by directives such as
	           * {@link ng.directive:ngRepeat ngRepeat} for managing the
	           * unrolling of the loop.
	           *
	           * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	           * Application code can register a `$destroy` event handler that will give it a chance to
	           * perform any necessary cleanup.
	           *
	           * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	           * clean up DOM bindings before an element is removed from the DOM.
	           */
	          $destroy: function() {
	            // We can't destroy a scope that has been already destroyed.
	            if (this.$$destroyed) return;
	            var parent = this.$parent;
	
	            this.$broadcast('$destroy');
	            this.$$destroyed = true;
	
	            if (this === $rootScope) {
	              //Remove handlers attached to window when $rootScope is removed
	              $browser.$$applicationDestroyed();
	            }
	
	            incrementWatchersCount(this, -this.$$watchersCount);
	            for (var eventName in this.$$listenerCount) {
	              decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	            }
	
	            // sever all the references to parent scopes (after this cleanup, the current scope should
	            // not be retained by any of our references and should be eligible for garbage collection)
	            if (parent && parent.$$childHead == this) parent.$$childHead = this.$$nextSibling;
	            if (parent && parent.$$childTail == this) parent.$$childTail = this.$$prevSibling;
	            if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	            if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	            // Disable listeners, watchers and apply/digest methods
	            this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	            this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	            this.$$listeners = {};
	
	            // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	            this.$$nextSibling = null;
	            cleanUpScope(this);
	          },
	
	          /**
	           * @ngdoc method
	           * @name $rootScope.Scope#$eval
	           * @kind function
	           *
	           * @description
	           * Executes the `expression` on the current scope and returns the result. Any exceptions in
	           * the expression are propagated (uncaught). This is useful when evaluating Angular
	           * expressions.
	           *
	           * # Example
	           * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	           * ```
	           *
	           * @param {(string|function())=} expression An angular expression to be executed.
	           *
	           *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	           *    - `function(scope)`: execute the function with the current `scope` parameter.
	           *
	           * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	           * @returns {*} The result of evaluating the expression.
	           */
	          $eval: function(expr, locals) {
	            return $parse(expr)(this, locals);
	          },
	
	          /**
	           * @ngdoc method
	           * @name $rootScope.Scope#$evalAsync
	           * @kind function
	           *
	           * @description
	           * Executes the expression on the current scope at a later point in time.
	           *
	           * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	           * that:
	           *
	           *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	           *     rendering).
	           *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	           *     `expression` execution.
	           *
	           * Any exceptions from the execution of the expression are forwarded to the
	           * {@link ng.$exceptionHandler $exceptionHandler} service.
	           *
	           * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	           * will be scheduled. However, it is encouraged to always call code that changes the model
	           * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	           *
	           * @param {(string|function())=} expression An angular expression to be executed.
	           *
	           *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	           *    - `function(scope)`: execute the function with the current `scope` parameter.
	           *
	           * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	           */
	          $evalAsync: function(expr, locals) {
	            // if we are outside of an $digest loop and this is the first time we are scheduling async
	            // task also schedule async auto-flush
	            if (!$rootScope.$$phase && !asyncQueue.length) {
	              $browser.defer(function() {
	                if (asyncQueue.length) {
	                  $rootScope.$digest();
	                }
	              });
	            }
	
	            asyncQueue.push({scope: this, expression: $parse(expr), locals: locals});
	          },
	
	          $$postDigest: function(fn) {
	            postDigestQueue.push(fn);
	          },
	
	          /**
	           * @ngdoc method
	           * @name $rootScope.Scope#$apply
	           * @kind function
	           *
	           * @description
	           * `$apply()` is used to execute an expression in angular from outside of the angular
	           * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	           * Because we are calling into the angular framework we need to perform proper scope life
	           * cycle of {@link ng.$exceptionHandler exception handling},
	           * {@link ng.$rootScope.Scope#$digest executing watches}.
	           *
	           * ## Life cycle
	           *
	           * # Pseudo-Code of `$apply()`
	           * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	           * ```
	           *
	           *
	           * Scope's `$apply()` method transitions through the following stages:
	           *
	           * 1. The {@link guide/expression expression} is executed using the
	           *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	           * 2. Any exceptions from the execution of the expression are forwarded to the
	           *    {@link ng.$exceptionHandler $exceptionHandler} service.
	           * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	           *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	           *
	           *
	           * @param {(string|function())=} exp An angular expression to be executed.
	           *
	           *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	           *    - `function(scope)`: execute the function with current `scope` parameter.
	           *
	           * @returns {*} The result of evaluating the expression.
	           */
	          $apply: function(expr) {
	            try {
	              beginPhase('$apply');
	              try {
	                return this.$eval(expr);
	              } finally {
	                clearPhase();
	              }
	            } catch (e) {
	              $exceptionHandler(e);
	            } finally {
	              try {
	                $rootScope.$digest();
	              } catch (e) {
	                $exceptionHandler(e);
	                throw e;
	              }
	            }
	          },
	
	          /**
	           * @ngdoc method
	           * @name $rootScope.Scope#$applyAsync
	           * @kind function
	           *
	           * @description
	           * Schedule the invocation of $apply to occur at a later time. The actual time difference
	           * varies across browsers, but is typically around ~10 milliseconds.
	           *
	           * This can be used to queue up multiple expressions which need to be evaluated in the same
	           * digest.
	           *
	           * @param {(string|function())=} exp An angular expression to be executed.
	           *
	           *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	           *    - `function(scope)`: execute the function with current `scope` parameter.
	           */
	          $applyAsync: function(expr) {
	            var scope = this;
	            expr && applyAsyncQueue.push($applyAsyncExpression);
	            expr = $parse(expr);
	            scheduleApplyAsync();
	
	            function $applyAsyncExpression() {
	              scope.$eval(expr);
	            }
	          },
	
	          /**
	           * @ngdoc method
	           * @name $rootScope.Scope#$on
	           * @kind function
	           *
	           * @description
	           * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	           * discussion of event life cycle.
	           *
	           * The event listener function format is: `function(event, args...)`. The `event` object
	           * passed into the listener has the following attributes:
	           *
	           *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	           *     `$broadcast`-ed.
	           *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	           *     event propagates through the scope hierarchy, this property is set to null.
	           *   - `name` - `{string}`: name of the event.
	           *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	           *     further event propagation (available only for events that were `$emit`-ed).
	           *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	           *     to true.
	           *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	           *
	           * @param {string} name Event name to listen on.
	           * @param {function(event, ...args)} listener Function to call when the event is emitted.
	           * @returns {function()} Returns a deregistration function for this listener.
	           */
	          $on: function(name, listener) {
	            var namedListeners = this.$$listeners[name];
	            if (!namedListeners) {
	              this.$$listeners[name] = namedListeners = [];
	            }
	            namedListeners.push(listener);
	
	            var current = this;
	            do {
	              if (!current.$$listenerCount[name]) {
	                current.$$listenerCount[name] = 0;
	              }
	              current.$$listenerCount[name]++;
	            } while ((current = current.$parent));
	
	            var self = this;
	            return function() {
	              var indexOfListener = namedListeners.indexOf(listener);
	              if (indexOfListener !== -1) {
	                namedListeners[indexOfListener] = null;
	                decrementListenerCount(self, 1, name);
	              }
	            };
	          },
	
	
	          /**
	           * @ngdoc method
	           * @name $rootScope.Scope#$emit
	           * @kind function
	           *
	           * @description
	           * Dispatches an event `name` upwards through the scope hierarchy notifying the
	           * registered {@link ng.$rootScope.Scope#$on} listeners.
	           *
	           * The event life cycle starts at the scope on which `$emit` was called. All
	           * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	           * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	           * registered listeners along the way. The event will stop propagating if one of the listeners
	           * cancels it.
	           *
	           * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	           * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	           *
	           * @param {string} name Event name to emit.
	           * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	           * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	           */
	          $emit: function(name, args) {
	            var empty = [],
	              namedListeners,
	              scope = this,
	              stopPropagation = false,
	              event = {
	                name: name,
	                targetScope: scope,
	                stopPropagation: function() {stopPropagation = true;},
	                preventDefault: function() {
	                  event.defaultPrevented = true;
	                },
	                defaultPrevented: false
	              },
	              listenerArgs = concat([event], arguments, 1),
	              i, length;
	
	            do {
	              namedListeners = scope.$$listeners[name] || empty;
	              event.currentScope = scope;
	              for (i = 0, length = namedListeners.length; i < length; i++) {
	
	                // if listeners were deregistered, defragment the array
	                if (!namedListeners[i]) {
	                  namedListeners.splice(i, 1);
	                  i--;
	                  length--;
	                  continue;
	                }
	                try {
	                  //allow all listeners attached to the current scope to run
	                  namedListeners[i].apply(null, listenerArgs);
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	              //if any listener on the current scope stops propagation, prevent bubbling
	              if (stopPropagation) {
	                event.currentScope = null;
	                return event;
	              }
	              //traverse upwards
	              scope = scope.$parent;
	            } while (scope);
	
	            event.currentScope = null;
	
	            return event;
	          },
	
	
	          /**
	           * @ngdoc method
	           * @name $rootScope.Scope#$broadcast
	           * @kind function
	           *
	           * @description
	           * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	           * registered {@link ng.$rootScope.Scope#$on} listeners.
	           *
	           * The event life cycle starts at the scope on which `$broadcast` was called. All
	           * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	           * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	           * scope and calls all registered listeners along the way. The event cannot be canceled.
	           *
	           * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	           * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	           *
	           * @param {string} name Event name to broadcast.
	           * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	           * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	           */
	          $broadcast: function(name, args) {
	            var target = this,
	              current = target,
	              next = target,
	              event = {
	                name: name,
	                targetScope: target,
	                preventDefault: function() {
	                  event.defaultPrevented = true;
	                },
	                defaultPrevented: false
	              };
	
	            if (!target.$$listenerCount[name]) return event;
	
	            var listenerArgs = concat([event], arguments, 1),
	              listeners, i, length;
	
	            //down while you can, then up and next sibling or up and next sibling until back at root
	            while ((current = next)) {
	              event.currentScope = current;
	              listeners = current.$$listeners[name] || [];
	              for (i = 0, length = listeners.length; i < length; i++) {
	                // if listeners were deregistered, defragment the array
	                if (!listeners[i]) {
	                  listeners.splice(i, 1);
	                  i--;
	                  length--;
	                  continue;
	                }
	
	                try {
	                  listeners[i].apply(null, listenerArgs);
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	
	              // Insanity Warning: scope depth-first traversal
	              // yes, this code is a bit crazy, but it works and we have tests to prove it!
	              // this piece should be kept in sync with the traversal in $digest
	              // (though it differs due to having the extra check for $$listenerCount)
	              if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	                while (current !== target && !(next = current.$$nextSibling)) {
	                  current = current.$parent;
	                }
	              }
	            }
	
	            event.currentScope = null;
	            return event;
	          }
	        };
	
	        var $rootScope = new Scope();
	
	        //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	        var asyncQueue = $rootScope.$$asyncQueue = [];
	        var postDigestQueue = $rootScope.$$postDigestQueue = [];
	        var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	        var postDigestQueuePosition = 0;
	
	        return $rootScope;
	
	
	        function beginPhase(phase) {
	          if ($rootScope.$$phase) {
	            throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	          }
	
	          $rootScope.$$phase = phase;
	        }
	
	        function clearPhase() {
	          $rootScope.$$phase = null;
	        }
	
	        function incrementWatchersCount(current, count) {
	          do {
	            current.$$watchersCount += count;
	          } while ((current = current.$parent));
	        }
	
	        function decrementListenerCount(current, count, name) {
	          do {
	            current.$$listenerCount[name] -= count;
	
	            if (current.$$listenerCount[name] === 0) {
	              delete current.$$listenerCount[name];
	            }
	          } while ((current = current.$parent));
	        }
	
	        /**
	         * function used as an initial value for watchers.
	         * because it's unique we can easily tell it apart from other values
	         */
	        function initWatchVal() {}
	
	        function flushApplyAsync() {
	          while (applyAsyncQueue.length) {
	            try {
	              applyAsyncQueue.shift()();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          applyAsyncId = null;
	        }
	
	        function scheduleApplyAsync() {
	          if (applyAsyncId === null) {
	            applyAsyncId = $browser.defer(function() {
	              $rootScope.$apply(flushApplyAsync);
	            });
	          }
	        }
	      }];
	  }
	
	  /**
	   * @ngdoc service
	   * @name $rootElement
	   *
	   * @description
	   * The root element of Angular application. This is either the element where {@link
	    * ng.directive:ngApp ngApp} was declared or the element passed into
	   * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	   * location where the application's {@link auto.$injector $injector} service gets
	   * published, and can be retrieved using `$rootElement.injector()`.
	   */
	
	
	// the implementation is in angular.bootstrap
	
	  /**
	   * @description
	   * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	   */
	  function $$SanitizeUriProvider() {
	    var aHrefSanitizationWhitelist = /^\s*(https?|ftp|mailto|tel|file):/,
	      imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	    /**
	     * @description
	     * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	     * urls during a[href] sanitization.
	     *
	     * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	     *
	     * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	     * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	     * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	     * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	     *
	     * @param {RegExp=} regexp New regexp to whitelist urls with.
	     * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	     *    chaining otherwise.
	     */
	    this.aHrefSanitizationWhitelist = function(regexp) {
	      if (isDefined(regexp)) {
	        aHrefSanitizationWhitelist = regexp;
	        return this;
	      }
	      return aHrefSanitizationWhitelist;
	    };
	
	
	    /**
	     * @description
	     * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	     * urls during img[src] sanitization.
	     *
	     * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	     *
	     * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	     * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	     * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	     * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	     *
	     * @param {RegExp=} regexp New regexp to whitelist urls with.
	     * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	     *    chaining otherwise.
	     */
	    this.imgSrcSanitizationWhitelist = function(regexp) {
	      if (isDefined(regexp)) {
	        imgSrcSanitizationWhitelist = regexp;
	        return this;
	      }
	      return imgSrcSanitizationWhitelist;
	    };
	
	    this.$get = function() {
	      return function sanitizeUri(uri, isImage) {
	        var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
	        var normalizedVal;
	        normalizedVal = urlResolve(uri).href;
	        if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	          return 'unsafe:' + normalizedVal;
	        }
	        return uri;
	      };
	    };
	  }
	
	  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	   *     Any commits to this file should be reviewed with security in mind.  *
	   *   Changes to this file can potentially create security vulnerabilities. *
	   *          An approval from 2 Core members with history of modifying      *
	   *                         this file is required.                          *
	   *                                                                         *
	   *  Does the change somehow allow for arbitrary javascript to be executed? *
	   *    Or allows for someone to change the prototype of built-in objects?   *
	   *     Or gives undesired access to variables likes document or window?    *
	   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	  var $sceMinErr = minErr('$sce');
	
	  var SCE_CONTEXTS = {
	    HTML: 'html',
	    CSS: 'css',
	    URL: 'url',
	    // RESOURCE_URL is a subtype of URL used in contexts where a privileged resource is sourced from a
	    // url.  (e.g. ng-include, script src, templateUrl)
	    RESOURCE_URL: 'resourceUrl',
	    JS: 'js'
	  };
	
	// Helper functions follow.
	
	  function adjustMatcher(matcher) {
	    if (matcher === 'self') {
	      return matcher;
	    } else if (isString(matcher)) {
	      // Strings match exactly except for 2 wildcards - '*' and '**'.
	      // '*' matches any character except those from the set ':/.?&'.
	      // '**' matches any character (like .* in a RegExp).
	      // More than 2 *'s raises an error as it's ill defined.
	      if (matcher.indexOf('***') > -1) {
	        throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	      }
	      matcher = escapeForRegexp(matcher).
	      replace('\\*\\*', '.*').
	      replace('\\*', '[^:/.?&;]*');
	      return new RegExp('^' + matcher + '$');
	    } else if (isRegExp(matcher)) {
	      // The only other type of matcher allowed is a Regexp.
	      // Match entire URL / disallow partial matches.
	      // Flags are reset (i.e. no global, ignoreCase or multiline)
	      return new RegExp('^' + matcher.source + '$');
	    } else {
	      throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	    }
	  }
	
	
	  function adjustMatchers(matchers) {
	    var adjustedMatchers = [];
	    if (isDefined(matchers)) {
	      forEach(matchers, function(matcher) {
	        adjustedMatchers.push(adjustMatcher(matcher));
	      });
	    }
	    return adjustedMatchers;
	  }
	
	
	  /**
	   * @ngdoc service
	   * @name $sceDelegate
	   * @kind function
	   *
	   * @description
	   *
	   * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	   *
	   * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	   * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	   * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	   * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	   * work because `$sce` delegates to `$sceDelegate` for these operations.
	   *
	   * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	   *
	   * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	   * can override it completely to change the behavior of `$sce`, the common case would
	   * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	   * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
	   * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
	    * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	   */
	
	  /**
	   * @ngdoc provider
	   * @name $sceDelegateProvider
	   * @description
	   *
	   * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate} service.  This allows one to get/set the whitelists and blacklists used to ensure
	   * that the URLs used for sourcing Angular templates are safe.  Refer {@link
	    * ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist} and
	   * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	   *
	   * For the general details about this service in Angular, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	   *
	   * **Example**:  Consider the following case. <a name="example"></a>
	   *
	   * - your app is hosted at url `http://myapp.example.com/`
	   * - but some of your templates are hosted on other domains you control such as
	   *   `http://srv01.assets.example.com/`,  `http://srv02.assets.example.com/`, etc.
	   * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	   *
	   * Here is what a secure configuration for this scenario might look like:
	   *
	   * ```
	   *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.resourceUrlWhitelist([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
	 *    $sceDelegateProvider.resourceUrlBlacklist([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	   * ```
	   */
	
	  function $SceDelegateProvider() {
	    this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	    // Resource URLs can also be trusted by policy.
	    var resourceUrlWhitelist = ['self'],
	      resourceUrlBlacklist = [];
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegateProvider#resourceUrlWhitelist
	     * @kind function
	     *
	     * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
	     *    provided.  This must be an array or null.  A snapshot of this array is used so further
	     *    changes to the array are ignored.
	     *
	     *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	     *    allowed in this array.
	     *
	     *    <div class="alert alert-warning">
	     *    **Note:** an empty whitelist array will block all URLs!
	     *    </div>
	     *
	     * @return {Array} the currently set whitelist array.
	     *
	     * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
	     * same origin resource requests.
	     *
	     * @description
	     * Sets/Gets the whitelist of trusted resource URLs.
	     */
	    this.resourceUrlWhitelist = function(value) {
	      if (arguments.length) {
	        resourceUrlWhitelist = adjustMatchers(value);
	      }
	      return resourceUrlWhitelist;
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegateProvider#resourceUrlBlacklist
	     * @kind function
	     *
	     * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
	     *    provided.  This must be an array or null.  A snapshot of this array is used so further
	     *    changes to the array are ignored.
	     *
	     *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	     *    allowed in this array.
	     *
	     *    The typical usage for the blacklist is to **block
	     *    [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	     *    these would otherwise be trusted but actually return content from the redirected domain.
	     *
	     *    Finally, **the blacklist overrides the whitelist** and has the final say.
	     *
	     * @return {Array} the currently set blacklist array.
	     *
	     * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
	     * is no blacklist.)
	     *
	     * @description
	     * Sets/Gets the blacklist of trusted resource URLs.
	     */
	
	    this.resourceUrlBlacklist = function(value) {
	      if (arguments.length) {
	        resourceUrlBlacklist = adjustMatchers(value);
	      }
	      return resourceUrlBlacklist;
	    };
	
	    this.$get = ['$injector', function($injector) {
	
	      var htmlSanitizer = function htmlSanitizer(html) {
	        throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	      };
	
	      if ($injector.has('$sanitize')) {
	        htmlSanitizer = $injector.get('$sanitize');
	      }
	
	
	      function matchUrl(matcher, parsedUrl) {
	        if (matcher === 'self') {
	          return urlIsSameOrigin(parsedUrl);
	        } else {
	          // definitely a regex.  See adjustMatchers()
	          return !!matcher.exec(parsedUrl.href);
	        }
	      }
	
	      function isResourceUrlAllowedByPolicy(url) {
	        var parsedUrl = urlResolve(url.toString());
	        var i, n, allowed = false;
	        // Ensure that at least one item from the whitelist allows this url.
	        for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
	          if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
	            allowed = true;
	            break;
	          }
	        }
	        if (allowed) {
	          // Ensure that no item from the blacklist blocked this url.
	          for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
	            if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
	              allowed = false;
	              break;
	            }
	          }
	        }
	        return allowed;
	      }
	
	      function generateHolderType(Base) {
	        var holderType = function TrustedValueHolderType(trustedValue) {
	          this.$$unwrapTrustedValue = function() {
	            return trustedValue;
	          };
	        };
	        if (Base) {
	          holderType.prototype = new Base();
	        }
	        holderType.prototype.valueOf = function sceValueOf() {
	          return this.$$unwrapTrustedValue();
	        };
	        holderType.prototype.toString = function sceToString() {
	          return this.$$unwrapTrustedValue().toString();
	        };
	        return holderType;
	      }
	
	      var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	      byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	      byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	      byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
	      byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	      byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	      /**
	       * @ngdoc method
	       * @name $sceDelegate#trustAs
	       *
	       * @description
	       * Returns an object that is trusted by angular for use in specified strict
	       * contextual escaping contexts (such as ng-bind-html, ng-include, any src
	       * attribute interpolation, any dom event binding attribute interpolation
	       * such as for onclick,  etc.) that uses the provided value.
	       * See {@link ng.$sce $sce} for enabling strict contextual escaping.
	       *
	       * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
	       *   resourceUrl, html, js and css.
	       * @param {*} value The value that that should be considered trusted/safe.
	       * @returns {*} A value that can be used to stand in for the provided `value` in places
	       * where Angular expects a $sce.trustAs() return value.
	       */
	      function trustAs(type, trustedValue) {
	        var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	        if (!Constructor) {
	          throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	        }
	        if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
	          return trustedValue;
	        }
	        // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	        // mutable objects, we ensure here that the value passed in is actually a string.
	        if (typeof trustedValue !== 'string') {
	          throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	        }
	        return new Constructor(trustedValue);
	      }
	
	      /**
	       * @ngdoc method
	       * @name $sceDelegate#valueOf
	       *
	       * @description
	       * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	        * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	       *
	       * If the passed parameter is not a value that had been returned by {@link
	        * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, returns it as-is.
	       *
	       * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	       *      call or anything else.
	       * @returns {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	       *     `value` unchanged.
	       */
	      function valueOf(maybeTrusted) {
	        if (maybeTrusted instanceof trustedValueHolderBase) {
	          return maybeTrusted.$$unwrapTrustedValue();
	        } else {
	          return maybeTrusted;
	        }
	      }
	
	      /**
	       * @ngdoc method
	       * @name $sceDelegate#getTrusted
	       *
	       * @description
	       * Takes the result of a {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call and
	       * returns the originally supplied value if the queried context type is a supertype of the
	       * created type.  If this condition isn't satisfied, throws an exception.
	       *
	       * <div class="alert alert-danger">
	       * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
	       * (XSS) vulnerability in your application.
	       * </div>
	       *
	       * @param {string} type The kind of context in which this value is to be used.
	       * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call.
	       * @returns {*} The value the was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if valid in this context.  Otherwise, throws an exception.
	       */
	      function getTrusted(type, maybeTrusted) {
	        if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
	          return maybeTrusted;
	        }
	        var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	        if (constructor && maybeTrusted instanceof constructor) {
	          return maybeTrusted.$$unwrapTrustedValue();
	        }
	        // If we get here, then we may only take one of two actions.
	        // 1. sanitize the value for the requested type, or
	        // 2. throw an exception.
	        if (type === SCE_CONTEXTS.RESOURCE_URL) {
	          if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	            return maybeTrusted;
	          } else {
	            throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	          }
	        } else if (type === SCE_CONTEXTS.HTML) {
	          return htmlSanitizer(maybeTrusted);
	        }
	        throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	      }
	
	      return { trustAs: trustAs,
	        getTrusted: getTrusted,
	        valueOf: valueOf };
	    }];
	  }
	
	
	  /**
	   * @ngdoc provider
	   * @name $sceProvider
	   * @description
	   *
	   * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	   * -   enable/disable Strict Contextual Escaping (SCE) in a module
	   * -   override the default implementation with a custom delegate
	   *
	   * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	   */
	
	  /* jshint maxlen: false*/
	
	  /**
	   * @ngdoc service
	   * @name $sce
	   * @kind function
	   *
	   * @description
	   *
	   * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	   *
	   * # Strict Contextual Escaping
	   *
	   * Strict Contextual Escaping (SCE) is a mode in which AngularJS requires bindings in certain
	   * contexts to result in a value that is marked as safe to use for that context.  One example of
	   * such a context is binding arbitrary html controlled by the user via `ng-bind-html`.  We refer
	   * to these contexts as privileged or SCE contexts.
	   *
	   * As of version 1.2, Angular ships with SCE enabled by default.
	   *
	   * Note:  When enabled (the default), IE<11 in quirks mode is not supported.  In this mode, IE<11 allow
	   * one to execute arbitrary javascript by the use of the expression() syntax.  Refer
	   * <http://blogs.msdn.com/b/ie/archive/2008/10/16/ending-expressions.aspx> to learn more about them.
	   * You can ensure your document is in standards mode and not quirks mode by adding `<!doctype html>`
	   * to the top of your HTML document.
	   *
	   * SCE assists in writing code in a way that (a) is secure by default and (b) makes auditing for
	   * security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	   *
	   * Here's an example of a binding in a privileged context:
	   *
	   * ```
	   * <input ng-model="userHtml" aria-label="User input">
	   * <div ng-bind-html="userHtml"></div>
	   * ```
	   *
	   * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	   * disabled, this application allows the user to render arbitrary HTML into the DIV.
	   * In a more realistic example, one may be rendering user comments, blog articles, etc. via
	   * bindings.  (HTML is just one example of a context where rendering user controlled input creates
	   * security vulnerabilities.)
	   *
	   * For the case of HTML, you might use a library, either on the client side, or on the server side,
	   * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	   *
	   * How would you ensure that every place that used these types of bindings was bound to a value that
	   * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	   * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	   * properties/fields and forgot to update the binding to the sanitized value?
	   *
	   * To be secure by default, you want to ensure that any such bindings are disallowed unless you can
	   * determine that something explicitly says it's safe to use a value for binding in that
	   * context.  You can then audit your code (a simple grep would do) to ensure that this is only done
	   * for those values that you can easily tell are safe - because they were received from your server,
	   * sanitized by your library, etc.  You can organize your codebase to help with this - perhaps
	   * allowing only the files in a specific directory to do this.  Ensuring that the internal API
	   * exposed by that code doesn't markup arbitrary values as safe then becomes a more manageable task.
	   *
	   * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	   * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	   * obtain values that will be accepted by SCE / privileged contexts.
	   *
	   *
	   * ## How does it work?
	   *
	   * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Directives use {@link
	    * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs the
	   * {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals.
	   *
	   * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	    * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	   * simplified):
	   *
	   * ```
	   * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	   * ```
	   *
	   * ## Impact on loading templates
	   *
	   * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	   * `templateUrl`'s specified by {@link guide/directive directives}.
	   *
	   * By default, Angular only loads templates from the same domain and protocol as the application
	   * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	   * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
	 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
	   *
	   * *Please note*:
	   * The browser's
	   * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	   * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	   * policy apply in addition to this and may further restrict whether the template is successfully
	   * loaded.  This means that without the right CORS policy, loading templates from a different domain
	   * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	   * browsers.
	   *
	   * ## This feels like too much overhead
	   *
	   * It's important to remember that SCE only applies to interpolation expressions.
	   *
	   * If your expressions are constant literals, they're automatically trusted and you don't need to
	   * call `$sce.trustAs` on them (remember to include the `ngSanitize` module) (e.g.
	   * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works.
	   *
	   * Additionally, `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
	   * through {@link ng.$sce#getTrusted $sce.getTrusted}.  SCE doesn't play a role here.
	   *
	   * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	   * templates in `ng-include` from your application's domain without having to even know about SCE.
	   * It blocks loading templates from other domains or loading templates over http from an https
	   * served document.  You can change these by setting your own custom {@link
	    * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
	    * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
	   *
	   * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	   * application that's secure and can be audited to verify that with much more ease than bolting
	   * security onto an application later.
	   *
	   * <a name="contexts"></a>
	   * ## What trusted context types are supported?
	   *
	   * | Context             | Notes          |
	   * |---------------------|----------------|
	   * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
	   * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
	   * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=` and `<img src=` sanitize their urls and don't constitute an SCE context. |
	   * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
	   * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
	   *
	   * ## Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
	   *
	   *  Each element in these arrays must be one of the following:
	   *
	   *  - **'self'**
	   *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	   *      domain** as the application document using the **same protocol**.
	   *  - **String** (except the special value `'self'`)
	   *    - The string is matched against the full *normalized / absolute URL* of the resource
	   *      being tested (substring matches are not good enough.)
	   *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	   *      match themselves.
	   *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	   *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	   *      in a whitelist.
	   *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	   *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	   *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	   *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	   *      http://foo.example.com/templates/**).
	   *  - **RegExp** (*see caveat below*)
	   *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	   *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	   *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	   *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	   *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	   *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	   *      is highly recommended to use the string patterns and only fall back to regular expressions
	   *      as a last resort.
	   *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	   *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	   *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	   *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	   *    - If you are generating your JavaScript from some other templating engine (not
	   *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	   *      remember to escape your regular expression (and be aware that you might need more than
	   *      one level of escaping depending on your templating engine and the way you interpolated
	   *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	   *      enough before coding your own.  E.g. Ruby has
	   *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	   *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	   *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	   *      Closure library's [goog.string.regExpEscape(s)](
	   *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	   *
	   * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	   *
	   * ## Show me an example using SCE.
	   *
	   * <example module="mySceApp" deps="angular-sanitize.js">
	   * <file name="index.html">
	   *   <div ng-controller="AppController as myCtrl">
	   *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	   *     <b>User comments</b><br>
	   *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	   *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	   *     exploit.
	   *     <div class="well">
	   *       <div ng-repeat="userComment in myCtrl.userComments">
	   *         <b>{{userComment.name}}</b>:
	   *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	   *         <br>
	   *       </div>
	   *     </div>
	   *   </div>
	   * </file>
	   *
	   * <file name="script.js">
	   *   angular.module('mySceApp', ['ngSanitize'])
	   *     .controller('AppController', ['$http', '$templateCache', '$sce',
	   *       function($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get("test_data.json", {cache: $templateCache}).success(function(userComments) {
	 *           self.userComments = userComments;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	   * </file>
	   *
	   * <file name="test_data.json">
	   * [
	   *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	   *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	   * ]
	   * </file>
	   *
	   * <file name="protractor.js" type="protractor">
	   *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getInnerHtml())
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getInnerHtml()).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	   * </file>
	   * </example>
	   *
	   *
	   *
	   * ## Can I disable SCE completely?
	   *
	   * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	   * for little coding overhead.  It will be much harder to take an SCE disabled application and
	   * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	   * for cases where you have a lot of existing code that was written before SCE was introduced and
	   * you're migrating them a module at a time.
	   *
	   * That said, here's how you can completely disable SCE:
	   *
	   * ```
	   * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects.
	 *   $sceProvider.enabled(false);
	 * });
	   * ```
	   *
	   */
	  /* jshint maxlen: 100 */
	
	  function $SceProvider() {
	    var enabled = true;
	
	    /**
	     * @ngdoc method
	     * @name $sceProvider#enabled
	     * @kind function
	     *
	     * @param {boolean=} value If provided, then enables/disables SCE.
	     * @return {boolean} true if SCE is enabled, false otherwise.
	     *
	     * @description
	     * Enables/disables SCE and returns the current value.
	     */
	    this.enabled = function(value) {
	      if (arguments.length) {
	        enabled = !!value;
	      }
	      return enabled;
	    };
	
	
	    /* Design notes on the default implementation for SCE.
	     *
	     * The API contract for the SCE delegate
	     * -------------------------------------
	     * The SCE delegate object must provide the following 3 methods:
	     *
	     * - trustAs(contextEnum, value)
	     *     This method is used to tell the SCE service that the provided value is OK to use in the
	     *     contexts specified by contextEnum.  It must return an object that will be accepted by
	     *     getTrusted() for a compatible contextEnum and return this value.
	     *
	     * - valueOf(value)
	     *     For values that were not produced by trustAs(), return them as is.  For values that were
	     *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	     *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	     *     such a value.
	     *
	     * - getTrusted(contextEnum, value)
	     *     This function should return the a value that is safe to use in the context specified by
	     *     contextEnum or throw and exception otherwise.
	     *
	     * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	     * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	     * instance, an implementation could maintain a registry of all trusted objects by context.  In
	     * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	     * return the same object passed in if it was found in the registry under a compatible context or
	     * throw an exception otherwise.  An implementation might only wrap values some of the time based
	     * on some criteria.  getTrusted() might return a value and not throw an exception for special
	     * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	     *
	     *
	     * A note on the inheritance model for SCE contexts
	     * ------------------------------------------------
	     * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	     * is purely an implementation details.
	     *
	     * The contract is simply this:
	     *
	     *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	     *     will also succeed.
	     *
	     * Inheritance happens to capture this in a natural way.  In some future, we
	     * may not use inheritance anymore.  That is OK because no code outside of
	     * sce.js and sceSpecs.js would need to be aware of this detail.
	     */
	
	    this.$get = ['$parse', '$sceDelegate', function(
	      $parse,   $sceDelegate) {
	      // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	      // the "expression(javascript expression)" syntax which is insecure.
	      if (enabled && msie < 8) {
	        throw $sceMinErr('iequirks',
	          'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	          'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	          'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	      }
	
	      var sce = shallowCopy(SCE_CONTEXTS);
	
	      /**
	       * @ngdoc method
	       * @name $sce#isEnabled
	       * @kind function
	       *
	       * @return {Boolean} true if SCE is enabled, false otherwise.  If you want to set the value, you
	       * have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	       *
	       * @description
	       * Returns a boolean indicating if SCE is enabled.
	       */
	      sce.isEnabled = function() {
	        return enabled;
	      };
	      sce.trustAs = $sceDelegate.trustAs;
	      sce.getTrusted = $sceDelegate.getTrusted;
	      sce.valueOf = $sceDelegate.valueOf;
	
	      if (!enabled) {
	        sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	        sce.valueOf = identity;
	      }
	
	      /**
	       * @ngdoc method
	       * @name $sce#parseAs
	       *
	       * @description
	       * Converts Angular {@link guide/expression expression} into a function.  This is like {@link
	        * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	       * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	       *
	       * @param {string} type The kind of SCE context in which this result will be used.
	       * @param {string} expression String expression to compile.
	       * @returns {function(context, locals)} a function which represents the compiled expression:
	       *
	       *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	       *      are evaluated against (typically a scope object).
	       *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	       *      `context`.
	       */
	      sce.parseAs = function sceParseAs(type, expr) {
	        var parsed = $parse(expr);
	        if (parsed.literal && parsed.constant) {
	          return parsed;
	        } else {
	          return $parse(expr, function(value) {
	            return sce.getTrusted(type, value);
	          });
	        }
	      };
	
	      /**
	       * @ngdoc method
	       * @name $sce#trustAs
	       *
	       * @description
	       * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.  As such,
	       * returns an object that is trusted by angular for use in specified strict contextual
	       * escaping contexts (such as ng-bind-html, ng-include, any src attribute
	       * interpolation, any dom event binding attribute interpolation such as for onclick,  etc.)
	       * that uses the provided value.  See * {@link ng.$sce $sce} for enabling strict contextual
	       * escaping.
	       *
	       * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
	       *   resourceUrl, html, js and css.
	       * @param {*} value The value that that should be considered trusted/safe.
	       * @returns {*} A value that can be used to stand in for the provided `value` in places
	       * where Angular expects a $sce.trustAs() return value.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $sce#trustAsHtml
	       *
	       * @description
	       * Shorthand method.  `$sce.trustAsHtml(value)` →
	       *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	       *
	       * @param {*} value The value to trustAs.
	       * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedHtml
	     *     $sce.getTrustedHtml(value)} to obtain the original value.  (privileged directives
	       *     only accept expressions that are either literal constants or are the
	       *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	       */
	
	      /**
	       * @ngdoc method
	       * @name $sce#trustAsUrl
	       *
	       * @description
	       * Shorthand method.  `$sce.trustAsUrl(value)` →
	       *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	       *
	       * @param {*} value The value to trustAs.
	       * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedUrl
	     *     $sce.getTrustedUrl(value)} to obtain the original value.  (privileged directives
	       *     only accept expressions that are either literal constants or are the
	       *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	       */
	
	      /**
	       * @ngdoc method
	       * @name $sce#trustAsResourceUrl
	       *
	       * @description
	       * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	       *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	       *
	       * @param {*} value The value to trustAs.
	       * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedResourceUrl
	     *     $sce.getTrustedResourceUrl(value)} to obtain the original value.  (privileged directives
	       *     only accept expressions that are either literal constants or are the return
	       *     value of {@link ng.$sce#trustAs $sce.trustAs}.)
	       */
	
	      /**
	       * @ngdoc method
	       * @name $sce#trustAsJs
	       *
	       * @description
	       * Shorthand method.  `$sce.trustAsJs(value)` →
	       *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	       *
	       * @param {*} value The value to trustAs.
	       * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedJs
	     *     $sce.getTrustedJs(value)} to obtain the original value.  (privileged directives
	       *     only accept expressions that are either literal constants or are the
	       *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	       */
	
	      /**
	       * @ngdoc method
	       * @name $sce#getTrusted
	       *
	       * @description
	       * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	       * takes the result of a {@link ng.$sce#trustAs `$sce.trustAs`}() call and returns the
	       * originally supplied value if the queried context type is a supertype of the created type.
	       * If this condition isn't satisfied, throws an exception.
	       *
	       * @param {string} type The kind of context in which this value is to be used.
	       * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs `$sce.trustAs`}
	       *                         call.
	       * @returns {*} The value the was originally provided to
	       *              {@link ng.$sce#trustAs `$sce.trustAs`} if valid in this context.
	       *              Otherwise, throws an exception.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $sce#getTrustedHtml
	       *
	       * @description
	       * Shorthand method.  `$sce.getTrustedHtml(value)` →
	       *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	       *
	       * @param {*} value The value to pass to `$sce.getTrusted`.
	       * @returns {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	       */
	
	      /**
	       * @ngdoc method
	       * @name $sce#getTrustedCss
	       *
	       * @description
	       * Shorthand method.  `$sce.getTrustedCss(value)` →
	       *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	       *
	       * @param {*} value The value to pass to `$sce.getTrusted`.
	       * @returns {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	       */
	
	      /**
	       * @ngdoc method
	       * @name $sce#getTrustedUrl
	       *
	       * @description
	       * Shorthand method.  `$sce.getTrustedUrl(value)` →
	       *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	       *
	       * @param {*} value The value to pass to `$sce.getTrusted`.
	       * @returns {*} The return value of `$sce.getTrusted($sce.URL, value)`
	       */
	
	      /**
	       * @ngdoc method
	       * @name $sce#getTrustedResourceUrl
	       *
	       * @description
	       * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	       *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	       *
	       * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	       * @returns {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	       */
	
	      /**
	       * @ngdoc method
	       * @name $sce#getTrustedJs
	       *
	       * @description
	       * Shorthand method.  `$sce.getTrustedJs(value)` →
	       *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	       *
	       * @param {*} value The value to pass to `$sce.getTrusted`.
	       * @returns {*} The return value of `$sce.getTrusted($sce.JS, value)`
	       */
	
	      /**
	       * @ngdoc method
	       * @name $sce#parseAsHtml
	       *
	       * @description
	       * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	       *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	       *
	       * @param {string} expression String expression to compile.
	       * @returns {function(context, locals)} a function which represents the compiled expression:
	       *
	       *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	       *      are evaluated against (typically a scope object).
	       *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	       *      `context`.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $sce#parseAsCss
	       *
	       * @description
	       * Shorthand method.  `$sce.parseAsCss(value)` →
	       *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	       *
	       * @param {string} expression String expression to compile.
	       * @returns {function(context, locals)} a function which represents the compiled expression:
	       *
	       *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	       *      are evaluated against (typically a scope object).
	       *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	       *      `context`.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $sce#parseAsUrl
	       *
	       * @description
	       * Shorthand method.  `$sce.parseAsUrl(value)` →
	       *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	       *
	       * @param {string} expression String expression to compile.
	       * @returns {function(context, locals)} a function which represents the compiled expression:
	       *
	       *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	       *      are evaluated against (typically a scope object).
	       *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	       *      `context`.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $sce#parseAsResourceUrl
	       *
	       * @description
	       * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	       *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	       *
	       * @param {string} expression String expression to compile.
	       * @returns {function(context, locals)} a function which represents the compiled expression:
	       *
	       *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	       *      are evaluated against (typically a scope object).
	       *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	       *      `context`.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $sce#parseAsJs
	       *
	       * @description
	       * Shorthand method.  `$sce.parseAsJs(value)` →
	       *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	       *
	       * @param {string} expression String expression to compile.
	       * @returns {function(context, locals)} a function which represents the compiled expression:
	       *
	       *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	       *      are evaluated against (typically a scope object).
	       *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	       *      `context`.
	       */
	
	        // Shorthand delegations.
	      var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	      forEach(SCE_CONTEXTS, function(enumValue, name) {
	        var lName = lowercase(name);
	        sce[camelCase("parse_as_" + lName)] = function(expr) {
	          return parse(enumValue, expr);
	        };
	        sce[camelCase("get_trusted_" + lName)] = function(value) {
	          return getTrusted(enumValue, value);
	        };
	        sce[camelCase("trust_as_" + lName)] = function(value) {
	          return trustAs(enumValue, value);
	        };
	      });
	
	      return sce;
	    }];
	  }
	
	  /**
	   * !!! This is an undocumented "private" service !!!
	   *
	   * @name $sniffer
	   * @requires $window
	   * @requires $document
	   *
	   * @property {boolean} history Does the browser support html5 history api ?
	   * @property {boolean} transitions Does the browser support CSS transition events ?
	   * @property {boolean} animations Does the browser support CSS animation events ?
	   *
	   * @description
	   * This is very simple implementation of testing browser's features.
	   */
	  function $SnifferProvider() {
	    this.$get = ['$window', '$document', function($window, $document) {
	      var eventSupport = {},
	        // Chrome Packaged Apps are not allowed to access `history.pushState`. They can be detected by
	        // the presence of `chrome.app.runtime` (see https://developer.chrome.com/apps/api_index)
	        isChromePackagedApp = $window.chrome && $window.chrome.app && $window.chrome.app.runtime,
	        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        vendorPrefix,
	        vendorRegex = /^(Moz|webkit|ms)(?=[A-Z])/,
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false,
	        match;
	
	      if (bodyStyle) {
	        for (var prop in bodyStyle) {
	          if (match = vendorRegex.exec(prop)) {
	            vendorPrefix = match[0];
	            vendorPrefix = vendorPrefix[0].toUpperCase() + vendorPrefix.substr(1);
	            break;
	          }
	        }
	
	        if (!vendorPrefix) {
	          vendorPrefix = ('WebkitOpacity' in bodyStyle) && 'webkit';
	        }
	
	        transitions = !!(('transition' in bodyStyle) || (vendorPrefix + 'Transition' in bodyStyle));
	        animations  = !!(('animation' in bodyStyle) || (vendorPrefix + 'Animation' in bodyStyle));
	
	        if (android && (!transitions ||  !animations)) {
	          transitions = isString(bodyStyle.webkitTransition);
	          animations = isString(bodyStyle.webkitAnimation);
	        }
	      }
	
	
	      return {
	        // Android has history.pushState, but it does not update location correctly
	        // so let's not use the history API at all.
	        // http://code.google.com/p/android/issues/detail?id=17471
	        // https://github.com/angular/angular.js/issues/904
	
	        // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	        // so let's not use the history API also
	        // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	        // jshint -W018
	        history: !!(hasHistoryPushState && !(android < 4) && !boxee),
	        // jshint +W018
	        hasEvent: function(event) {
	          // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	          // it. In particular the event is not fired when backspace or delete key are pressed or
	          // when cut operation is performed.
	          // IE10+ implements 'input' event but it erroneously fires under various situations,
	          // e.g. when placeholder changes, or a form is focused.
	          if (event === 'input' && msie <= 11) return false;
	
	          if (isUndefined(eventSupport[event])) {
	            var divElm = document.createElement('div');
	            eventSupport[event] = 'on' + event in divElm;
	          }
	
	          return eventSupport[event];
	        },
	        csp: csp(),
	        vendorPrefix: vendorPrefix,
	        transitions: transitions,
	        animations: animations,
	        android: android
	      };
	    }];
	  }
	
	  var $templateRequestMinErr = minErr('$compile');
	
	  /**
	   * @ngdoc provider
	   * @name $templateRequestProvider
	   * @description
	   * Used to configure the options passed to the {@link $http} service when making a template request.
	   *
	   * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	   * requesting a template.
	   */
	  function $TemplateRequestProvider() {
	
	    var httpOptions;
	
	    /**
	     * @ngdoc method
	     * @name $templateRequestProvider#httpOptions
	     * @description
	     * The options to be passed to the {@link $http} service when making the request.
	     * You can use this to override options such as the "Accept" header for template requests.
	     *
	     * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	     * options if not overridden here.
	     *
	     * @param {string=} value new value for the {@link $http} options.
	     * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	     */
	    this.httpOptions = function(val) {
	      if (val) {
	        httpOptions = val;
	        return this;
	      }
	      return httpOptions;
	    };
	
	    /**
	     * @ngdoc service
	     * @name $templateRequest
	     *
	     * @description
	     * The `$templateRequest` service runs security checks then downloads the provided template using
	     * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	     * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	     * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	     * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	     * when `tpl` is of type string and `$templateCache` has the matching entry.
	     *
	     * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	     * can configure this via {@link $templateRequestProvider#httpOptions}.
	     *
	     * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	     * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	     *
	     * @return {Promise} a promise for the HTTP response data of the given URL.
	     *
	     * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	     */
	    this.$get = ['$templateCache', '$http', '$q', '$sce', function($templateCache, $http, $q, $sce) {
	
	      function handleRequestFn(tpl, ignoreRequestError) {
	        handleRequestFn.totalPendingRequests++;
	
	        // We consider the template cache holds only trusted templates, so
	        // there's no need to go through whitelisting again for keys that already
	        // are included in there. This also makes Angular accept any script
	        // directive, no matter its name. However, we still need to unwrap trusted
	        // types.
	        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
	          tpl = $sce.getTrustedResourceUrl(tpl);
	        }
	
	        var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	        if (isArray(transformResponse)) {
	          transformResponse = transformResponse.filter(function(transformer) {
	            return transformer !== defaultHttpResponseTransform;
	          });
	        } else if (transformResponse === defaultHttpResponseTransform) {
	          transformResponse = null;
	        }
	
	        return $http.get(tpl, extend({
	          cache: $templateCache,
	          transformResponse: transformResponse
	        }, httpOptions))
	          ['finally'](function() {
	          handleRequestFn.totalPendingRequests--;
	        })
	          .then(function(response) {
	            $templateCache.put(tpl, response.data);
	            return response.data;
	          }, handleError);
	
	        function handleError(resp) {
	          if (!ignoreRequestError) {
	            throw $templateRequestMinErr('tpload', 'Failed to load template: {0} (HTTP status: {1} {2})',
	              tpl, resp.status, resp.statusText);
	          }
	          return $q.reject(resp);
	        }
	      }
	
	      handleRequestFn.totalPendingRequests = 0;
	
	      return handleRequestFn;
	    }];
	  }
	
	  function $$TestabilityProvider() {
	    this.$get = ['$rootScope', '$browser', '$location',
	      function($rootScope,   $browser,   $location) {
	
	        /**
	         * @name $testability
	         *
	         * @description
	         * The private $$testability service provides a collection of methods for use when debugging
	         * or by automated test and debugging tools.
	         */
	        var testability = {};
	
	        /**
	         * @name $$testability#findBindings
	         *
	         * @description
	         * Returns an array of elements that are bound (via ng-bind or {{}})
	         * to expressions matching the input.
	         *
	         * @param {Element} element The element root to search from.
	         * @param {string} expression The binding expression to match.
	         * @param {boolean} opt_exactMatch If true, only returns exact matches
	         *     for the expression. Filters and whitespace are ignored.
	         */
	        testability.findBindings = function(element, expression, opt_exactMatch) {
	          var bindings = element.getElementsByClassName('ng-binding');
	          var matches = [];
	          forEach(bindings, function(binding) {
	            var dataBinding = angular.element(binding).data('$binding');
	            if (dataBinding) {
	              forEach(dataBinding, function(bindingName) {
	                if (opt_exactMatch) {
	                  var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	                  if (matcher.test(bindingName)) {
	                    matches.push(binding);
	                  }
	                } else {
	                  if (bindingName.indexOf(expression) != -1) {
	                    matches.push(binding);
	                  }
	                }
	              });
	            }
	          });
	          return matches;
	        };
	
	        /**
	         * @name $$testability#findModels
	         *
	         * @description
	         * Returns an array of elements that are two-way found via ng-model to
	         * expressions matching the input.
	         *
	         * @param {Element} element The element root to search from.
	         * @param {string} expression The model expression to match.
	         * @param {boolean} opt_exactMatch If true, only returns exact matches
	         *     for the expression.
	         */
	        testability.findModels = function(element, expression, opt_exactMatch) {
	          var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	          for (var p = 0; p < prefixes.length; ++p) {
	            var attributeEquals = opt_exactMatch ? '=' : '*=';
	            var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	            var elements = element.querySelectorAll(selector);
	            if (elements.length) {
	              return elements;
	            }
	          }
	        };
	
	        /**
	         * @name $$testability#getLocation
	         *
	         * @description
	         * Shortcut for getting the location in a browser agnostic way. Returns
	         *     the path, search, and hash. (e.g. /path?a=b#hash)
	         */
	        testability.getLocation = function() {
	          return $location.url();
	        };
	
	        /**
	         * @name $$testability#setLocation
	         *
	         * @description
	         * Shortcut for navigating to a location without doing a full page reload.
	         *
	         * @param {string} url The location url (path, search and hash,
	         *     e.g. /path?a=b#hash) to go to.
	         */
	        testability.setLocation = function(url) {
	          if (url !== $location.url()) {
	            $location.url(url);
	            $rootScope.$digest();
	          }
	        };
	
	        /**
	         * @name $$testability#whenStable
	         *
	         * @description
	         * Calls the callback when $timeout and $http requests are completed.
	         *
	         * @param {function} callback
	         */
	        testability.whenStable = function(callback) {
	          $browser.notifyWhenNoOutstandingRequests(callback);
	        };
	
	        return testability;
	      }];
	  }
	
	  function $TimeoutProvider() {
	    this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	      function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	        var deferreds = {};
	
	
	        /**
	         * @ngdoc service
	         * @name $timeout
	         *
	         * @description
	         * Angular's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	         * block and delegates any exceptions to
	         * {@link ng.$exceptionHandler $exceptionHandler} service.
	         *
	         * The return value of calling `$timeout` is a promise, which will be resolved when
	         * the delay has passed and the timeout function, if provided, is executed.
	         *
	         * To cancel a timeout request, call `$timeout.cancel(promise)`.
	         *
	         * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	         * synchronously flush the queue of deferred functions.
	         *
	         * If you only want a promise that will be resolved after some specified delay
	         * then you can call `$timeout` without the `fn` function.
	         *
	         * @param {function()=} fn A function, whose execution should be delayed.
	         * @param {number=} [delay=0] Delay in milliseconds.
	         * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	         *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	         * @param {...*=} Pass additional parameters to the executed function.
	         * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	         *   will be resolved with the return value of the `fn` function.
	         *
	         */
	        function timeout(fn, delay, invokeApply) {
	          if (!isFunction(fn)) {
	            invokeApply = delay;
	            delay = fn;
	            fn = noop;
	          }
	
	          var args = sliceArgs(arguments, 3),
	            skipApply = (isDefined(invokeApply) && !invokeApply),
	            deferred = (skipApply ? $$q : $q).defer(),
	            promise = deferred.promise,
	            timeoutId;
	
	          timeoutId = $browser.defer(function() {
	            try {
	              deferred.resolve(fn.apply(null, args));
	            } catch (e) {
	              deferred.reject(e);
	              $exceptionHandler(e);
	            }
	            finally {
	              delete deferreds[promise.$$timeoutId];
	            }
	
	            if (!skipApply) $rootScope.$apply();
	          }, delay);
	
	          promise.$$timeoutId = timeoutId;
	          deferreds[timeoutId] = deferred;
	
	          return promise;
	        }
	
	
	        /**
	         * @ngdoc method
	         * @name $timeout#cancel
	         *
	         * @description
	         * Cancels a task associated with the `promise`. As a result of this, the promise will be
	         * resolved with a rejection.
	         *
	         * @param {Promise=} promise Promise returned by the `$timeout` function.
	         * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	         *   canceled.
	         */
	        timeout.cancel = function(promise) {
	          if (promise && promise.$$timeoutId in deferreds) {
	            deferreds[promise.$$timeoutId].reject('canceled');
	            delete deferreds[promise.$$timeoutId];
	            return $browser.defer.cancel(promise.$$timeoutId);
	          }
	          return false;
	        };
	
	        return timeout;
	      }];
	  }
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	  var urlParsingNode = window.document.createElement("a");
	  var originUrl = urlResolve(window.location.href);
	
	
	  /**
	   *
	   * Implementation Notes for non-IE browsers
	   * ----------------------------------------
	   * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	   * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	   * URL will be resolved into an absolute URL in the context of the application document.
	   * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	   * properties are all populated to reflect the normalized URL.  This approach has wide
	   * compatibility - Safari 1+, Mozilla 1+, Opera 7+,e etc.  See
	   * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	   *
	   * Implementation Notes for IE
	   * ---------------------------
	   * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	   * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	   * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	   * work around that by performing the parsing in a 2nd step by taking a previously normalized
	   * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	   * properties such as protocol, hostname, port, etc.
	   *
	   * References:
	   *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	   *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	   *   http://url.spec.whatwg.org/#urlutils
	   *   https://github.com/angular/angular.js/pull/2902
	   *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	   *
	   * @kind function
	   * @param {string} url The URL to be parsed.
	   * @description Normalizes and parses a URL.
	   * @returns {object} Returns the normalized URL as a dictionary.
	   *
	   *   | member name   | Description    |
	   *   |---------------|----------------|
	   *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	   *   | protocol      | The protocol including the trailing colon                              |
	   *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	   *   | search        | The search params, minus the question mark                             |
	   *   | hash          | The hash string, minus the hash symbol
	   *   | hostname      | The hostname
	   *   | port          | The port, without ":"
	   *   | pathname      | The pathname, beginning with "/"
	   *
	   */
	  function urlResolve(url) {
	    var href = url;
	
	    if (msie) {
	      // Normalize before parse.  Refer Implementation Notes on why this is
	      // done in two steps on IE.
	      urlParsingNode.setAttribute("href", href);
	      href = urlParsingNode.href;
	    }
	
	    urlParsingNode.setAttribute('href', href);
	
	    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	    return {
	      href: urlParsingNode.href,
	      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	      host: urlParsingNode.host,
	      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	      hostname: urlParsingNode.hostname,
	      port: urlParsingNode.port,
	      pathname: (urlParsingNode.pathname.charAt(0) === '/')
	        ? urlParsingNode.pathname
	        : '/' + urlParsingNode.pathname
	    };
	  }
	
	  /**
	   * Parse a request URL and determine whether this is a same-origin request as the application document.
	   *
	   * @param {string|object} requestUrl The url of the request as a string that will be resolved
	   * or a parsed URL object.
	   * @returns {boolean} Whether the request is for the same origin as the application document.
	   */
	  function urlIsSameOrigin(requestUrl) {
	    var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
	    return (parsed.protocol === originUrl.protocol &&
	    parsed.host === originUrl.host);
	  }
	
	  /**
	   * @ngdoc service
	   * @name $window
	   *
	   * @description
	   * A reference to the browser's `window` object. While `window`
	   * is globally available in JavaScript, it causes testability problems, because
	   * it is a global variable. In angular we always refer to it through the
	   * `$window` service, so it may be overridden, removed or mocked for testing.
	   *
	   * Expressions, like the one defined for the `ngClick` directive in the example
	   * below, are evaluated with respect to the current scope.  Therefore, there is
	   * no risk of inadvertently coding in a dependency on a global value in such an
	   * expression.
	   *
	   * @example
	   <example module="windowExample">
	   <file name="index.html">
	   <script>
	   angular.module('windowExample', [])
	   .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	   </script>
	   <div ng-controller="ExampleController">
	   <input type="text" ng-model="greeting" aria-label="greeting" />
	   <button ng-click="doGreeting(greeting)">ALERT</button>
	   </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	   </file>
	   </example>
	   */
	  function $WindowProvider() {
	    this.$get = valueFn(window);
	  }
	
	  /**
	   * @name $$cookieReader
	   * @requires $document
	   *
	   * @description
	   * This is a private service for reading cookies used by $http and ngCookies
	   *
	   * @return {Object} a key/value map of the current cookies
	   */
	  function $$CookieReader($document) {
	    var rawDocument = $document[0] || {};
	    var lastCookies = {};
	    var lastCookieString = '';
	
	    function safeDecodeURIComponent(str) {
	      try {
	        return decodeURIComponent(str);
	      } catch (e) {
	        return str;
	      }
	    }
	
	    return function() {
	      var cookieArray, cookie, i, index, name;
	      var currentCookieString = rawDocument.cookie || '';
	
	      if (currentCookieString !== lastCookieString) {
	        lastCookieString = currentCookieString;
	        cookieArray = lastCookieString.split('; ');
	        lastCookies = {};
	
	        for (i = 0; i < cookieArray.length; i++) {
	          cookie = cookieArray[i];
	          index = cookie.indexOf('=');
	          if (index > 0) { //ignore nameless cookies
	            name = safeDecodeURIComponent(cookie.substring(0, index));
	            // the first value that is seen for a cookie is the most
	            // specific one.  values for the same cookie name that
	            // follow are for less specific paths.
	            if (isUndefined(lastCookies[name])) {
	              lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	            }
	          }
	        }
	      }
	      return lastCookies;
	    };
	  }
	
	  $$CookieReader.$inject = ['$document'];
	
	  function $$CookieReaderProvider() {
	    this.$get = $$CookieReader;
	  }
	
	  /* global currencyFilter: true,
	   dateFilter: true,
	   filterFilter: true,
	   jsonFilter: true,
	   limitToFilter: true,
	   lowercaseFilter: true,
	   numberFilter: true,
	   orderByFilter: true,
	   uppercaseFilter: true,
	   */
	
	  /**
	   * @ngdoc provider
	   * @name $filterProvider
	   * @description
	   *
	   * Filters are just functions which transform input to an output. However filters need to be
	   * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	   * annotated with dependencies and is responsible for creating a filter function.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   * (`myapp_subsection_filterx`).
	   * </div>
	   *
	   * ```js
	   *   // Filter registration
	   *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	   * ```
	   *
	   * The filter function is registered with the `$injector` under the filter name suffix with
	   * `Filter`.
	   *
	   * ```js
	   *   it('should be the same instance', inject(
	   *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	   *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	   * ```
	   *
	   *
	   * For more information about how angular filters work, and how to create your own filters, see
	   * {@link guide/filter Filters} in the Angular Developer Guide.
	   */
	
	  /**
	   * @ngdoc service
	   * @name $filter
	   * @kind function
	   * @description
	   * Filters are used for formatting data displayed to the user.
	   *
	   * The general syntax in templates is as follows:
	   *
	   *         {{ expression [| filter_name[:parameter_value] ... ] }}
	   *
	   * @param {String} name Name of the filter function to retrieve
	   * @return {Function} the filter function
	   * @example
	   <example name="$filter" module="filterExample">
	   <file name="index.html">
	   <div ng-controller="MainCtrl">
	   <h3>{{ originalText }}</h3>
	   <h3>{{ filteredText }}</h3>
	   </div>
	   </file>
	
	   <file name="script.js">
	   angular.module('filterExample', [])
	   .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	   </file>
	   </example>
	   */
	  $FilterProvider.$inject = ['$provide'];
	  function $FilterProvider($provide) {
	    var suffix = 'Filter';
	
	    /**
	     * @ngdoc method
	     * @name $filterProvider#register
	     * @param {string|Object} name Name of the filter function, or an object map of filters where
	     *    the keys are the filter names and the values are the filter factories.
	     *
	     *    <div class="alert alert-warning">
	     *    **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	     *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	     *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	     *    (`myapp_subsection_filterx`).
	     *    </div>
	     * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	     * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	     *    of the registered filter instances.
	     */
	    function register(name, factory) {
	      if (isObject(name)) {
	        var filters = {};
	        forEach(name, function(filter, key) {
	          filters[key] = register(key, filter);
	        });
	        return filters;
	      } else {
	        return $provide.factory(name + suffix, factory);
	      }
	    }
	    this.register = register;
	
	    this.$get = ['$injector', function($injector) {
	      return function(name) {
	        return $injector.get(name + suffix);
	      };
	    }];
	
	    ////////////////////////////////////////
	
	    /* global
	     currencyFilter: false,
	     dateFilter: false,
	     filterFilter: false,
	     jsonFilter: false,
	     limitToFilter: false,
	     lowercaseFilter: false,
	     numberFilter: false,
	     orderByFilter: false,
	     uppercaseFilter: false,
	     */
	
	    register('currency', currencyFilter);
	    register('date', dateFilter);
	    register('filter', filterFilter);
	    register('json', jsonFilter);
	    register('limitTo', limitToFilter);
	    register('lowercase', lowercaseFilter);
	    register('number', numberFilter);
	    register('orderBy', orderByFilter);
	    register('uppercase', uppercaseFilter);
	  }
	
	  /**
	   * @ngdoc filter
	   * @name filter
	   * @kind function
	   *
	   * @description
	   * Selects a subset of items from `array` and returns it as a new array.
	   *
	   * @param {Array} array The source array.
	   * @param {string|Object|function()} expression The predicate to be used for selecting items from
	   *   `array`.
	   *
	   *   Can be one of:
	   *
	   *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	   *     objects with string properties in `array` that match this string will be returned. This also
	   *     applies to nested object properties.
	   *     The predicate can be negated by prefixing the string with `!`.
	   *
	   *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	   *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	   *     which have property `name` containing "M" and property `phone` containing "1". A special
	   *     property name `$` can be used (as in `{$:"text"}`) to accept a match against any
	   *     property of the object or its nested object properties. That's equivalent to the simple
	   *     substring match with a `string` as described above. The predicate can be negated by prefixing
	   *     the string with `!`.
	   *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	   *     not containing "M".
	   *
	   *     Note that a named property will match properties on the same level only, while the special
	   *     `$` property will match properties on the same level or deeper. E.g. an array item like
	   *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	   *     **will** be matched by `{$: 'John'}`.
	   *
	   *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	   *     The function is called for each element of the array, with the element, its index, and
	   *     the entire array itself as arguments.
	   *
	   *     The final result is an array of those elements that the predicate returned true for.
	   *
	   * @param {function(actual, expected)|true|undefined} comparator Comparator which is used in
	   *     determining if the expected value (from the filter expression) and actual value (from
	   *     the object in the array) should be considered a match.
	   *
	   *   Can be one of:
	   *
	   *   - `function(actual, expected)`:
	   *     The function will be given the object value and the predicate value to compare and
	   *     should return true if both values should be considered equal.
	   *
	   *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	   *     This is essentially strict comparison of expected and actual.
	   *
	   *   - `false|undefined`: A short hand for a function which will look for a substring match in case
	   *     insensitive way.
	   *
	   *     Primitive values are converted to strings. Objects are not compared against primitives,
	   *     unless they have a custom `toString` method (e.g. `Date` objects).
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <div ng-init="friends = [{name:'John', phone:'555-1276'},
	   {name:'Mary', phone:'800-BIG-MARY'},
	   {name:'Mike', phone:'555-4321'},
	   {name:'Adam', phone:'555-5678'},
	   {name:'Julie', phone:'555-8765'},
	   {name:'Juliette', phone:'555-5678'}]"></div>
	
	   <label>Search: <input ng-model="searchText"></label>
	   <table id="searchTextResults">
	   <tr><th>Name</th><th>Phone</th></tr>
	   <tr ng-repeat="friend in friends | filter:searchText">
	   <td>{{friend.name}}</td>
	   <td>{{friend.phone}}</td>
	   </tr>
	   </table>
	   <hr>
	   <label>Any: <input ng-model="search.$"></label> <br>
	   <label>Name only <input ng-model="search.name"></label><br>
	   <label>Phone only <input ng-model="search.phone"></label><br>
	   <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	   <table id="searchObjResults">
	   <tr><th>Name</th><th>Phone</th></tr>
	   <tr ng-repeat="friendObj in friends | filter:search:strict">
	   <td>{{friendObj.name}}</td>
	   <td>{{friendObj.phone}}</td>
	   </tr>
	   </table>
	   </file>
	   <file name="protractor.js" type="protractor">
	   var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	   it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	   it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	   it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	   </file>
	   </example>
	   */
	  function filterFilter() {
	    return function(array, expression, comparator) {
	      if (!isArrayLike(array)) {
	        if (array == null) {
	          return array;
	        } else {
	          throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	        }
	      }
	
	      var expressionType = getTypeForFilter(expression);
	      var predicateFn;
	      var matchAgainstAnyProp;
	
	      switch (expressionType) {
	        case 'function':
	          predicateFn = expression;
	          break;
	        case 'boolean':
	        case 'null':
	        case 'number':
	        case 'string':
	          matchAgainstAnyProp = true;
	        //jshint -W086
	        case 'object':
	          //jshint +W086
	          predicateFn = createPredicateFn(expression, comparator, matchAgainstAnyProp);
	          break;
	        default:
	          return array;
	      }
	
	      return Array.prototype.filter.call(array, predicateFn);
	    };
	  }
	
	// Helper functions for `filterFilter`
	  function createPredicateFn(expression, comparator, matchAgainstAnyProp) {
	    var shouldMatchPrimitives = isObject(expression) && ('$' in expression);
	    var predicateFn;
	
	    if (comparator === true) {
	      comparator = equals;
	    } else if (!isFunction(comparator)) {
	      comparator = function(actual, expected) {
	        if (isUndefined(actual)) {
	          // No substring matching against `undefined`
	          return false;
	        }
	        if ((actual === null) || (expected === null)) {
	          // No substring matching against `null`; only match against `null`
	          return actual === expected;
	        }
	        if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	          // Should not compare primitives against objects, unless they have custom `toString` method
	          return false;
	        }
	
	        actual = lowercase('' + actual);
	        expected = lowercase('' + expected);
	        return actual.indexOf(expected) !== -1;
	      };
	    }
	
	    predicateFn = function(item) {
	      if (shouldMatchPrimitives && !isObject(item)) {
	        return deepCompare(item, expression.$, comparator, false);
	      }
	      return deepCompare(item, expression, comparator, matchAgainstAnyProp);
	    };
	
	    return predicateFn;
	  }
	
	  function deepCompare(actual, expected, comparator, matchAgainstAnyProp, dontMatchWholeObject) {
	    var actualType = getTypeForFilter(actual);
	    var expectedType = getTypeForFilter(expected);
	
	    if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	      return !deepCompare(actual, expected.substring(1), comparator, matchAgainstAnyProp);
	    } else if (isArray(actual)) {
	      // In case `actual` is an array, consider it a match
	      // if ANY of it's items matches `expected`
	      return actual.some(function(item) {
	        return deepCompare(item, expected, comparator, matchAgainstAnyProp);
	      });
	    }
	
	    switch (actualType) {
	      case 'object':
	        var key;
	        if (matchAgainstAnyProp) {
	          for (key in actual) {
	            if ((key.charAt(0) !== '$') && deepCompare(actual[key], expected, comparator, true)) {
	              return true;
	            }
	          }
	          return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, false);
	        } else if (expectedType === 'object') {
	          for (key in expected) {
	            var expectedVal = expected[key];
	            if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	              continue;
	            }
	
	            var matchAnyProperty = key === '$';
	            var actualVal = matchAnyProperty ? actual : actual[key];
	            if (!deepCompare(actualVal, expectedVal, comparator, matchAnyProperty, matchAnyProperty)) {
	              return false;
	            }
	          }
	          return true;
	        } else {
	          return comparator(actual, expected);
	        }
	        break;
	      case 'function':
	        return false;
	      default:
	        return comparator(actual, expected);
	    }
	  }
	
	// Used for easily differentiating between `null` and actual `object`
	  function getTypeForFilter(val) {
	    return (val === null) ? 'null' : typeof val;
	  }
	
	  var MAX_DIGITS = 22;
	  var DECIMAL_SEP = '.';
	  var ZERO_CHAR = '0';
	
	  /**
	   * @ngdoc filter
	   * @name currency
	   * @kind function
	   *
	   * @description
	   * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	   * symbol for current locale is used.
	   *
	   * @param {number} amount Input to filter.
	   * @param {string=} symbol Currency symbol or identifier to be displayed.
	   * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	   * @returns {string} Formatted number.
	   *
	   *
	   * @example
	   <example module="currencyExample">
	   <file name="index.html">
	   <script>
	   angular.module('currencyExample', [])
	   .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	   </script>
	   <div ng-controller="ExampleController">
	   <input type="number" ng-model="amount" aria-label="amount"> <br>
	   default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	   custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span>
	   no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	   </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	   it('should update', function() {
	         if (browser.params.browser == 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	   </file>
	   </example>
	   */
	  currencyFilter.$inject = ['$locale'];
	  function currencyFilter($locale) {
	    var formats = $locale.NUMBER_FORMATS;
	    return function(amount, currencySymbol, fractionSize) {
	      if (isUndefined(currencySymbol)) {
	        currencySymbol = formats.CURRENCY_SYM;
	      }
	
	      if (isUndefined(fractionSize)) {
	        fractionSize = formats.PATTERNS[1].maxFrac;
	      }
	
	      // if null or undefined pass it through
	      return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	      replace(/\u00A4/g, currencySymbol);
	    };
	  }
	
	  /**
	   * @ngdoc filter
	   * @name number
	   * @kind function
	   *
	   * @description
	   * Formats a number as text.
	   *
	   * If the input is null or undefined, it will just be returned.
	   * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	   * If the input is not a number an empty string is returned.
	   *
	   *
	   * @param {number|string} number Number to format.
	   * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	   * If this is not provided then the fraction size is computed from the current locale's number
	   * formatting pattern. In the case of the default locale, it will be 3.
	   * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	   *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	   *                   include "," group separators after each third digit).
	   *
	   * @example
	   <example module="numberFilterExample">
	   <file name="index.html">
	   <script>
	   angular.module('numberFilterExample', [])
	   .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	   </script>
	   <div ng-controller="ExampleController">
	   <label>Enter number: <input ng-model='val'></label><br>
	   Default formatting: <span id='number-default'>{{val | number}}</span><br>
	   No fractions: <span>{{val | number:0}}</span><br>
	   Negative number: <span>{{-val | number:4}}</span>
	   </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	   it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	   </file>
	   </example>
	   */
	  numberFilter.$inject = ['$locale'];
	  function numberFilter($locale) {
	    var formats = $locale.NUMBER_FORMATS;
	    return function(number, fractionSize) {
	
	      // if null or undefined pass it through
	      return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	        fractionSize);
	    };
	  }
	
	  /**
	   * Parse a number (as a string) into three components that can be used
	   * for formatting the number.
	   *
	   * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	   *
	   * @param  {string} numStr The number to parse
	   * @return {object} An object describing this number, containing the following keys:
	   *  - d : an array of digits containing leading zeros as necessary
	   *  - i : the number of the digits in `d` that are to the left of the decimal point
	   *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	   *
	   */
	  function parse(numStr) {
	    var exponent = 0, digits, numberOfIntegerDigits;
	    var i, j, zeros;
	
	    // Decimal point?
	    if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
	      numStr = numStr.replace(DECIMAL_SEP, '');
	    }
	
	    // Exponential form?
	    if ((i = numStr.search(/e/i)) > 0) {
	      // Work out the exponent.
	      if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
	      numberOfIntegerDigits += +numStr.slice(i + 1);
	      numStr = numStr.substring(0, i);
	    } else if (numberOfIntegerDigits < 0) {
	      // There was no decimal point or exponent so it is an integer.
	      numberOfIntegerDigits = numStr.length;
	    }
	
	    // Count the number of leading zeros.
	    for (i = 0; numStr.charAt(i) == ZERO_CHAR; i++) {/* jshint noempty: false */}
	
	    if (i == (zeros = numStr.length)) {
	      // The digits are all zero.
	      digits = [0];
	      numberOfIntegerDigits = 1;
	    } else {
	      // Count the number of trailing zeros
	      zeros--;
	      while (numStr.charAt(zeros) == ZERO_CHAR) zeros--;
	
	      // Trailing zeros are insignificant so ignore them
	      numberOfIntegerDigits -= i;
	      digits = [];
	      // Convert string to array of digits without leading/trailing zeros.
	      for (j = 0; i <= zeros; i++, j++) {
	        digits[j] = +numStr.charAt(i);
	      }
	    }
	
	    // If the number overflows the maximum allowed digits then use an exponent.
	    if (numberOfIntegerDigits > MAX_DIGITS) {
	      digits = digits.splice(0, MAX_DIGITS - 1);
	      exponent = numberOfIntegerDigits - 1;
	      numberOfIntegerDigits = 1;
	    }
	
	    return { d: digits, e: exponent, i: numberOfIntegerDigits };
	  }
	
	  /**
	   * Round the parsed number to the specified number of decimal places
	   * This function changed the parsedNumber in-place
	   */
	  function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
	    var digits = parsedNumber.d;
	    var fractionLen = digits.length - parsedNumber.i;
	
	    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
	
	    // The index of the digit to where rounding is to occur
	    var roundAt = fractionSize + parsedNumber.i;
	    var digit = digits[roundAt];
	
	    if (roundAt > 0) {
	      // Drop fractional digits beyond `roundAt`
	      digits.splice(Math.max(parsedNumber.i, roundAt));
	
	      // Set non-fractional digits beyond `roundAt` to 0
	      for (var j = roundAt; j < digits.length; j++) {
	        digits[j] = 0;
	      }
	    } else {
	      // We rounded to zero so reset the parsedNumber
	      fractionLen = Math.max(0, fractionLen);
	      parsedNumber.i = 1;
	      digits.length = Math.max(1, roundAt = fractionSize + 1);
	      digits[0] = 0;
	      for (var i = 1; i < roundAt; i++) digits[i] = 0;
	    }
	
	    if (digit >= 5) {
	      if (roundAt - 1 < 0) {
	        for (var k = 0; k > roundAt; k--) {
	          digits.unshift(0);
	          parsedNumber.i++;
	        }
	        digits.unshift(1);
	        parsedNumber.i++;
	      } else {
	        digits[roundAt - 1]++;
	      }
	    }
	
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);
	
	
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var carry = digits.reduceRight(function(carry, d, i, digits) {
	      d = d + carry;
	      digits[i] = d % 10;
	      return Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	      digits.unshift(carry);
	      parsedNumber.i++;
	    }
	  }
	
	  /**
	   * Format a number into a string
	   * @param  {number} number       The number to format
	   * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	   * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	   * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	   * @param  {[type]} fractionSize The size of the fractional part of the number
	   * @return {string}              The number formatted as a string
	   */
	  function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	
	    if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
	
	    var isInfinity = !isFinite(number);
	    var isZero = false;
	    var numStr = Math.abs(number) + '',
	      formattedText = '',
	      parsedNumber;
	
	    if (isInfinity) {
	      formattedText = '\u221e';
	    } else {
	      parsedNumber = parse(numStr);
	
	      roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
	
	      var digits = parsedNumber.d;
	      var integerLen = parsedNumber.i;
	      var exponent = parsedNumber.e;
	      var decimals = [];
	      isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);
	
	      // pad zeros for small numbers
	      while (integerLen < 0) {
	        digits.unshift(0);
	        integerLen++;
	      }
	
	      // extract decimals digits
	      if (integerLen > 0) {
	        decimals = digits.splice(integerLen, digits.length);
	      } else {
	        decimals = digits;
	        digits = [0];
	      }
	
	      // format the integer digits with grouping separators
	      var groups = [];
	      if (digits.length >= pattern.lgSize) {
	        groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	      }
	      while (digits.length > pattern.gSize) {
	        groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	      }
	      if (digits.length) {
	        groups.unshift(digits.join(''));
	      }
	      formattedText = groups.join(groupSep);
	
	      // append the decimal digits
	      if (decimals.length) {
	        formattedText += decimalSep + decimals.join('');
	      }
	
	      if (exponent) {
	        formattedText += 'e+' + exponent;
	      }
	    }
	    if (number < 0 && !isZero) {
	      return pattern.negPre + formattedText + pattern.negSuf;
	    } else {
	      return pattern.posPre + formattedText + pattern.posSuf;
	    }
	  }
	
	  function padNumber(num, digits, trim, negWrap) {
	    var neg = '';
	    if (num < 0 || (negWrap && num <= 0)) {
	      if (negWrap) {
	        num = -num + 1;
	      } else {
	        num = -num;
	        neg = '-';
	      }
	    }
	    num = '' + num;
	    while (num.length < digits) num = ZERO_CHAR + num;
	    if (trim) {
	      num = num.substr(num.length - digits);
	    }
	    return neg + num;
	  }
	
	
	  function dateGetter(name, size, offset, trim, negWrap) {
	    offset = offset || 0;
	    return function(date) {
	      var value = date['get' + name]();
	      if (offset > 0 || value > -offset) {
	        value += offset;
	      }
	      if (value === 0 && offset == -12) value = 12;
	      return padNumber(value, size, trim, negWrap);
	    };
	  }
	
	  function dateStrGetter(name, shortForm, standAlone) {
	    return function(date, formats) {
	      var value = date['get' + name]();
	      var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
	      var get = uppercase(propPrefix + name);
	
	      return formats[get][value];
	    };
	  }
	
	  function timeZoneGetter(date, formats, offset) {
	    var zone = -1 * offset;
	    var paddedZone = (zone >= 0) ? "+" : "";
	
	    paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	      padNumber(Math.abs(zone % 60), 2);
	
	    return paddedZone;
	  }
	
	  function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	  }
	
	  function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	  }
	
	  function weekGetter(size) {
	    return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	        thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	        result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	    };
	  }
	
	  function ampmGetter(date, formats) {
	    return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	  }
	
	  function eraGetter(date, formats) {
	    return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	  }
	
	  function longEraGetter(date, formats) {
	    return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	  }
	
	  var DATE_FORMATS = {
	    yyyy: dateGetter('FullYear', 4, 0, false, true),
	    yy: dateGetter('FullYear', 2, 0, true, true),
	    y: dateGetter('FullYear', 1, 0, false, true),
	    MMMM: dateStrGetter('Month'),
	    MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	    M: dateGetter('Month', 1, 1),
	    LLLL: dateStrGetter('Month', false, true),
	    dd: dateGetter('Date', 2),
	    d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	    H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	    h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	    m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	    s: dateGetter('Seconds', 1),
	    // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	    // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	    sss: dateGetter('Milliseconds', 3),
	    EEEE: dateStrGetter('Day'),
	    EEE: dateStrGetter('Day', true),
	    a: ampmGetter,
	    Z: timeZoneGetter,
	    ww: weekGetter(2),
	    w: weekGetter(1),
	    G: eraGetter,
	    GG: eraGetter,
	    GGG: eraGetter,
	    GGGG: longEraGetter
	  };
	
	  var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))(.*)/,
	    NUMBER_STRING = /^\-?\d+$/;
	
	  /**
	   * @ngdoc filter
	   * @name date
	   * @kind function
	   *
	   * @description
	   *   Formats `date` to a string based on the requested `format`.
	   *
	   *   `format` string can be composed of the following elements:
	   *
	   *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	   *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	   *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	   *   * `'MMMM'`: Month in year (January-December)
	   *   * `'MMM'`: Month in year (Jan-Dec)
	   *   * `'MM'`: Month in year, padded (01-12)
	   *   * `'M'`: Month in year (1-12)
	   *   * `'LLLL'`: Stand-alone month in year (January-December)
	   *   * `'dd'`: Day in month, padded (01-31)
	   *   * `'d'`: Day in month (1-31)
	   *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	   *   * `'EEE'`: Day in Week, (Sun-Sat)
	   *   * `'HH'`: Hour in day, padded (00-23)
	   *   * `'H'`: Hour in day (0-23)
	   *   * `'hh'`: Hour in AM/PM, padded (01-12)
	   *   * `'h'`: Hour in AM/PM, (1-12)
	   *   * `'mm'`: Minute in hour, padded (00-59)
	   *   * `'m'`: Minute in hour (0-59)
	   *   * `'ss'`: Second in minute, padded (00-59)
	   *   * `'s'`: Second in minute (0-59)
	   *   * `'sss'`: Millisecond in second, padded (000-999)
	   *   * `'a'`: AM/PM marker
	   *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	   *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	   *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	   *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	   *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	   *
	   *   `format` string can also be one of the following predefined
	   *   {@link guide/i18n localizable formats}:
	   *
	   *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	   *     (e.g. Sep 3, 2010 12:05:08 PM)
	   *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	   *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	   *     (e.g. Friday, September 3, 2010)
	   *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	   *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	   *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	   *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	   *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	   *
	   *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	   *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	   *   (e.g. `"h 'o''clock'"`).
	   *
	   * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	   *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	   *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	   *    specified in the string input, the time is considered to be in the local timezone.
	   * @param {string=} format Formatting rules (see Description). If not specified,
	   *    `mediumDate` is used.
	   * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	   *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	   *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	   *    If not specified, the timezone of the browser will be used.
	   * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	   <span>{{1288323623006 | date:'medium'}}</span><br>
	   <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	   <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	   <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	   <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	   <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	   <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010\-10\-2\d \d{2}:\d{2}:\d{2} (\-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	   </file>
	   </example>
	   */
	  dateFilter.$inject = ['$locale'];
	  function dateFilter($locale) {
	
	
	    var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	    // 1        2       3         4          5          6          7          8  9     10      11
	    function jsonStringToDate(string) {
	      var match;
	      if (match = string.match(R_ISO8601_STR)) {
	        var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	        if (match[9]) {
	          tzHour = toInt(match[9] + match[10]);
	          tzMin = toInt(match[9] + match[11]);
	        }
	        dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	        var h = toInt(match[4] || 0) - tzHour;
	        var m = toInt(match[5] || 0) - tzMin;
	        var s = toInt(match[6] || 0);
	        var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	        timeSetter.call(date, h, m, s, ms);
	        return date;
	      }
	      return string;
	    }
	
	
	    return function(date, format, timezone) {
	      var text = '',
	        parts = [],
	        fn, match;
	
	      format = format || 'mediumDate';
	      format = $locale.DATETIME_FORMATS[format] || format;
	      if (isString(date)) {
	        date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	      }
	
	      if (isNumber(date)) {
	        date = new Date(date);
	      }
	
	      if (!isDate(date) || !isFinite(date.getTime())) {
	        return date;
	      }
	
	      while (format) {
	        match = DATE_FORMATS_SPLIT.exec(format);
	        if (match) {
	          parts = concat(parts, match, 1);
	          format = parts.pop();
	        } else {
	          parts.push(format);
	          format = null;
	        }
	      }
	
	      var dateTimezoneOffset = date.getTimezoneOffset();
	      if (timezone) {
	        dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	        date = convertTimezoneToLocal(date, timezone, true);
	      }
	      forEach(parts, function(value) {
	        fn = DATE_FORMATS[value];
	        text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	          : value === "''" ? "'" : value.replace(/(^'|'$)/g, '').replace(/''/g, "'");
	      });
	
	      return text;
	    };
	  }
	
	
	  /**
	   * @ngdoc filter
	   * @name json
	   * @kind function
	   *
	   * @description
	   *   Allows you to convert a JavaScript object into JSON string.
	   *
	   *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	   *   the binding is automatically converted to JSON.
	   *
	   * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	   * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	   * @returns {string} JSON string.
	   *
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	   <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n  "name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n    "name": ?"value"\n}/);
	       });
	   </file>
	   </example>
	   *
	   */
	  function jsonFilter() {
	    return function(object, spacing) {
	      if (isUndefined(spacing)) {
	        spacing = 2;
	      }
	      return toJson(object, spacing);
	    };
	  }
	
	
	  /**
	   * @ngdoc filter
	   * @name lowercase
	   * @kind function
	   * @description
	   * Converts string to lowercase.
	   * @see angular.lowercase
	   */
	  var lowercaseFilter = valueFn(lowercase);
	
	
	  /**
	   * @ngdoc filter
	   * @name uppercase
	   * @kind function
	   * @description
	   * Converts string to uppercase.
	   * @see angular.uppercase
	   */
	  var uppercaseFilter = valueFn(uppercase);
	
	  /**
	   * @ngdoc filter
	   * @name limitTo
	   * @kind function
	   *
	   * @description
	   * Creates a new array or string containing only a specified number of elements. The elements
	   * are taken from either the beginning or the end of the source array, string or number, as specified by
	   * the value and sign (positive or negative) of `limit`. If a number is used as input, it is
	   * converted to a string.
	   *
	   * @param {Array|string|number} input Source array, string or number to be limited.
	   * @param {string|number} limit The length of the returned array or string. If the `limit` number
	   *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	   *     If the number is negative, `limit` number  of items from the end of the source array/string
	   *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	   *     the input will be returned unchanged.
	   * @param {(string|number)=} begin Index at which to begin limitation. As a negative index, `begin`
	   *     indicates an offset from the end of `input`. Defaults to `0`.
	   * @returns {Array|string} A new sub-array or substring of length `limit` or less if input array
	   *     had less than `limit` elements.
	   *
	   * @example
	   <example module="limitToExample">
	   <file name="index.html">
	   <script>
	   angular.module('limitToExample', [])
	   .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	   </script>
	   <div ng-controller="ExampleController">
	   <label>
	   Limit {{numbers}} to:
	   <input type="number" step="1" ng-model="numLimit">
	   </label>
	   <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	   <label>
	   Limit {{letters}} to:
	   <input type="number" step="1" ng-model="letterLimit">
	   </label>
	   <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	   <label>
	   Limit {{longNumber}} to:
	   <input type="number" step="1" ng-model="longNumberLimit">
	   </label>
	   <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	   </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	   var numLimitInput = element(by.model('numLimit'));
	   var letterLimitInput = element(by.model('letterLimit'));
	   var longNumberLimitInput = element(by.model('longNumberLimit'));
	   var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	   var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	   var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	   it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	   // There is a bug in safari and protractor that doesn't like the minus key
	   // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	   it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	   </file>
	   </example>
	   */
	  function limitToFilter() {
	    return function(input, limit, begin) {
	      if (Math.abs(Number(limit)) === Infinity) {
	        limit = Number(limit);
	      } else {
	        limit = toInt(limit);
	      }
	      if (isNaN(limit)) return input;
	
	      if (isNumber(input)) input = input.toString();
	      if (!isArray(input) && !isString(input)) return input;
	
	      begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	      begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
	
	      if (limit >= 0) {
	        return input.slice(begin, begin + limit);
	      } else {
	        if (begin === 0) {
	          return input.slice(limit, input.length);
	        } else {
	          return input.slice(Math.max(0, begin + limit), begin);
	        }
	      }
	    };
	  }
	
	  /**
	   * @ngdoc filter
	   * @name orderBy
	   * @kind function
	   *
	   * @description
	   * Orders a specified `array` by the `expression` predicate. It is ordered alphabetically
	   * for strings and numerically for numbers. Note: if you notice numbers are not being sorted
	   * as expected, make sure they are actually being saved as numbers and not strings.
	   * Array-like values (e.g. NodeLists, jQuery objects, TypedArrays, Strings, etc) are also supported.
	   *
	   * @param {Array} array The array (or array-like object) to sort.
	   * @param {function(*)|string|Array.<(function(*)|string)>=} expression A predicate to be
	   *    used by the comparator to determine the order of elements.
	   *
	   *    Can be one of:
	   *
	   *    - `function`: Getter function. The result of this function will be sorted using the
	   *      `<`, `===`, `>` operator.
	   *    - `string`: An Angular expression. The result of this expression is used to compare elements
	   *      (for example `name` to sort by a property called `name` or `name.substr(0, 3)` to sort by
	   *      3 first characters of a property called `name`). The result of a constant expression
	   *      is interpreted as a property name to be used in comparisons (for example `"special name"`
	   *      to sort object by the value of their `special name` property). An expression can be
	   *      optionally prefixed with `+` or `-` to control ascending or descending sort order
	   *      (for example, `+name` or `-name`). If no property is provided, (e.g. `'+'`) then the array
	   *      element itself is used to compare where sorting.
	   *    - `Array`: An array of function or string predicates. The first predicate in the array
	   *      is used for sorting, but when two items are equivalent, the next predicate is used.
	   *
	   *    If the predicate is missing or empty then it defaults to `'+'`.
	   *
	   * @param {boolean=} reverse Reverse the order of the array.
	   * @returns {Array} Sorted copy of the source array.
	   *
	   *
	   * @example
	   * The example below demonstrates a simple ngRepeat, where the data is sorted
	   * by age in descending order (predicate is set to `'-age'`).
	   * `reverse` is not set, which means it defaults to `false`.
	   <example module="orderByExample">
	   <file name="index.html">
	   <div ng-controller="ExampleController">
	   <table class="friend">
	   <tr>
	   <th>Name</th>
	   <th>Phone Number</th>
	   <th>Age</th>
	   </tr>
	   <tr ng-repeat="friend in friends | orderBy:'-age'">
	   <td>{{friend.name}}</td>
	   <td>{{friend.phone}}</td>
	   <td>{{friend.age}}</td>
	   </tr>
	   </table>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('orderByExample', [])
	   .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends =
	               [{name:'John', phone:'555-1212', age:10},
	                {name:'Mary', phone:'555-9876', age:19},
	                {name:'Mike', phone:'555-4321', age:21},
	                {name:'Adam', phone:'555-5678', age:35},
	                {name:'Julie', phone:'555-8765', age:29}];
	         }]);
	   </file>
	   </example>
	   *
	   * The predicate and reverse parameters can be controlled dynamically through scope properties,
	   * as shown in the next example.
	   * @example
	   <example module="orderByExample">
	   <file name="index.html">
	   <div ng-controller="ExampleController">
	   <pre>Sorting predicate = {{predicate}}; reverse = {{reverse}}</pre>
	   <hr/>
	   <button ng-click="predicate=''">Set to unsorted</button>
	   <table class="friend">
	   <tr>
	   <th>
	   <button ng-click="order('name')">Name</button>
	   <span class="sortorder" ng-show="predicate === 'name'" ng-class="{reverse:reverse}"></span>
	   </th>
	   <th>
	   <button ng-click="order('phone')">Phone Number</button>
	   <span class="sortorder" ng-show="predicate === 'phone'" ng-class="{reverse:reverse}"></span>
	   </th>
	   <th>
	   <button ng-click="order('age')">Age</button>
	   <span class="sortorder" ng-show="predicate === 'age'" ng-class="{reverse:reverse}"></span>
	   </th>
	   </tr>
	   <tr ng-repeat="friend in friends | orderBy:predicate:reverse">
	   <td>{{friend.name}}</td>
	   <td>{{friend.phone}}</td>
	   <td>{{friend.age}}</td>
	   </tr>
	   </table>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('orderByExample', [])
	   .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends =
	               [{name:'John', phone:'555-1212', age:10},
	                {name:'Mary', phone:'555-9876', age:19},
	                {name:'Mike', phone:'555-4321', age:21},
	                {name:'Adam', phone:'555-5678', age:35},
	                {name:'Julie', phone:'555-8765', age:29}];
	           $scope.predicate = 'age';
	           $scope.reverse = true;
	           $scope.order = function(predicate) {
	             $scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;
	             $scope.predicate = predicate;
	           };
	         }]);
	   </file>
	   <file name="style.css">
	   .sortorder:after {
	         content: '\25b2';
	       }
	   .sortorder.reverse:after {
	         content: '\25bc';
	       }
	   </file>
	   </example>
	   *
	   * It's also possible to call the orderBy filter manually, by injecting `$filter`, retrieving the
	   * filter routine with `$filter('orderBy')`, and calling the returned filter routine with the
	   * desired parameters.
	   *
	   * Example:
	   *
	   * @example
	   <example module="orderByExample">
	   <file name="index.html">
	   <div ng-controller="ExampleController">
	   <pre>Sorting predicate = {{predicate}}; reverse = {{reverse}}</pre>
	   <table class="friend">
	   <tr>
	   <th>
	   <button ng-click="order('name')">Name</button>
	   <span class="sortorder" ng-show="predicate === 'name'" ng-class="{reverse:reverse}"></span>
	   </th>
	   <th>
	   <button ng-click="order('phone')">Phone Number</button>
	   <span class="sortorder" ng-show="predicate === 'phone'" ng-class="{reverse:reverse}"></span>
	   </th>
	   <th>
	   <button ng-click="order('age')">Age</button>
	   <span class="sortorder" ng-show="predicate === 'age'" ng-class="{reverse:reverse}"></span>
	   </th>
	   </tr>
	   <tr ng-repeat="friend in friends">
	   <td>{{friend.name}}</td>
	   <td>{{friend.phone}}</td>
	   <td>{{friend.age}}</td>
	   </tr>
	   </table>
	   </div>
	   </file>
	
	   <file name="script.js">
	   angular.module('orderByExample', [])
	   .controller('ExampleController', ['$scope', '$filter', function($scope, $filter) {
	          var orderBy = $filter('orderBy');
	          $scope.friends = [
	            { name: 'John',    phone: '555-1212',    age: 10 },
	            { name: 'Mary',    phone: '555-9876',    age: 19 },
	            { name: 'Mike',    phone: '555-4321',    age: 21 },
	            { name: 'Adam',    phone: '555-5678',    age: 35 },
	            { name: 'Julie',   phone: '555-8765',    age: 29 }
	          ];
	          $scope.order = function(predicate) {
	            $scope.predicate = predicate;
	            $scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;
	            $scope.friends = orderBy($scope.friends, predicate, $scope.reverse);
	          };
	          $scope.order('age', true);
	        }]);
	   </file>
	
	   <file name="style.css">
	   .sortorder:after {
	         content: '\25b2';
	       }
	   .sortorder.reverse:after {
	         content: '\25bc';
	       }
	   </file>
	   </example>
	   */
	  orderByFilter.$inject = ['$parse'];
	  function orderByFilter($parse) {
	    return function(array, sortPredicate, reverseOrder) {
	
	      if (array == null) return array;
	      if (!isArrayLike(array)) {
	        throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
	      }
	
	      if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	      if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	      var predicates = processPredicates(sortPredicate, reverseOrder);
	      // Add a predicate at the end that evaluates to the element index. This makes the
	      // sort stable as it works as a tie-breaker when all the input predicates cannot
	      // distinguish between two elements.
	      predicates.push({ get: function() { return {}; }, descending: reverseOrder ? -1 : 1});
	
	      // The next three lines are a version of a Swartzian Transform idiom from Perl
	      // (sometimes called the Decorate-Sort-Undecorate idiom)
	      // See https://en.wikipedia.org/wiki/Schwartzian_transform
	      var compareValues = Array.prototype.map.call(array, getComparisonObject);
	      compareValues.sort(doComparison);
	      array = compareValues.map(function(item) { return item.value; });
	
	      return array;
	
	      function getComparisonObject(value, index) {
	        return {
	          value: value,
	          predicateValues: predicates.map(function(predicate) {
	            return getPredicateValue(predicate.get(value), index);
	          })
	        };
	      }
	
	      function doComparison(v1, v2) {
	        var result = 0;
	        for (var index=0, length = predicates.length; index < length; ++index) {
	          result = compare(v1.predicateValues[index], v2.predicateValues[index]) * predicates[index].descending;
	          if (result) break;
	        }
	        return result;
	      }
	    };
	
	    function processPredicates(sortPredicate, reverseOrder) {
	      reverseOrder = reverseOrder ? -1 : 1;
	      return sortPredicate.map(function(predicate) {
	        var descending = 1, get = identity;
	
	        if (isFunction(predicate)) {
	          get = predicate;
	        } else if (isString(predicate)) {
	          if ((predicate.charAt(0) == '+' || predicate.charAt(0) == '-')) {
	            descending = predicate.charAt(0) == '-' ? -1 : 1;
	            predicate = predicate.substring(1);
	          }
	          if (predicate !== '') {
	            get = $parse(predicate);
	            if (get.constant) {
	              var key = get();
	              get = function(value) { return value[key]; };
	            }
	          }
	        }
	        return { get: get, descending: descending * reverseOrder };
	      });
	    }
	
	    function isPrimitive(value) {
	      switch (typeof value) {
	        case 'number': /* falls through */
	        case 'boolean': /* falls through */
	        case 'string':
	          return true;
	        default:
	          return false;
	      }
	    }
	
	    function objectValue(value, index) {
	      // If `valueOf` is a valid function use that
	      if (typeof value.valueOf === 'function') {
	        value = value.valueOf();
	        if (isPrimitive(value)) return value;
	      }
	      // If `toString` is a valid function and not the one from `Object.prototype` use that
	      if (hasCustomToString(value)) {
	        value = value.toString();
	        if (isPrimitive(value)) return value;
	      }
	      // We have a basic object so we use the position of the object in the collection
	      return index;
	    }
	
	    function getPredicateValue(value, index) {
	      var type = typeof value;
	      if (value === null) {
	        type = 'string';
	        value = 'null';
	      } else if (type === 'string') {
	        value = value.toLowerCase();
	      } else if (type === 'object') {
	        value = objectValue(value, index);
	      }
	      return { value: value, type: type };
	    }
	
	    function compare(v1, v2) {
	      var result = 0;
	      if (v1.type === v2.type) {
	        if (v1.value !== v2.value) {
	          result = v1.value < v2.value ? -1 : 1;
	        }
	      } else {
	        result = v1.type < v2.type ? -1 : 1;
	      }
	      return result;
	    }
	  }
	
	  function ngDirective(directive) {
	    if (isFunction(directive)) {
	      directive = {
	        link: directive
	      };
	    }
	    directive.restrict = directive.restrict || 'AC';
	    return valueFn(directive);
	  }
	
	  /**
	   * @ngdoc directive
	   * @name a
	   * @restrict E
	   *
	   * @description
	   * Modifies the default behavior of the html A tag so that the default action is prevented when
	   * the href attribute is empty.
	   *
	   * This change permits the easy creation of action links with the `ngClick` directive
	   * without changing the location or causing page reloads, e.g.:
	   * `<a href="" ng-click="list.addItem()">Add Item</a>`
	   */
	  var htmlAnchorDirective = valueFn({
	    restrict: 'E',
	    compile: function(element, attr) {
	      if (!attr.href && !attr.xlinkHref) {
	        return function(scope, element) {
	          // If the linked element is not an anchor tag anymore, do nothing
	          if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	          // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	          var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	            'xlink:href' : 'href';
	          element.on('click', function(event) {
	            // if we have no href url, then don't navigate anywhere.
	            if (!element.attr(href)) {
	              event.preventDefault();
	            }
	          });
	        };
	      }
	    }
	  });
	
	  /**
	   * @ngdoc directive
	   * @name ngHref
	   * @restrict A
	   * @priority 99
	   *
	   * @description
	   * Using Angular markup like `{{hash}}` in an href attribute will
	   * make the link go to the wrong URL if the user clicks it before
	   * Angular has a chance to replace the `{{hash}}` markup with its
	   * value. Until Angular replaces the markup the link will be broken
	   * and will most likely return a 404 error. The `ngHref` directive
	   * solves this problem.
	   *
	   * The wrong way to write it:
	   * ```html
	   * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	   * ```
	   *
	   * The correct way to write it:
	   * ```html
	   * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	   * ```
	   *
	   * @element A
	   * @param {template} ngHref any string which can contain `{{}}` markup.
	   *
	   * @example
	   * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	   * in links and their different behaviors:
	   <example>
	   <file name="index.html">
	   <input ng-model="value" /><br />
	   <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	   <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	   <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	   <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	   <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	   <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	   it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	   it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	   it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	   it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	   it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	   </file>
	   </example>
	   */
	
	  /**
	   * @ngdoc directive
	   * @name ngSrc
	   * @restrict A
	   * @priority 99
	   *
	   * @description
	   * Using Angular markup like `{{hash}}` in a `src` attribute doesn't
	   * work right: The browser will fetch from the URL with the literal
	   * text `{{hash}}` until Angular replaces the expression inside
	   * `{{hash}}`. The `ngSrc` directive solves this problem.
	   *
	   * The buggy way to write it:
	   * ```html
	   * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	   * ```
	   *
	   * The correct way to write it:
	   * ```html
	   * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	   * ```
	   *
	   * @element IMG
	   * @param {template} ngSrc any string which can contain `{{}}` markup.
	   */
	
	  /**
	   * @ngdoc directive
	   * @name ngSrcset
	   * @restrict A
	   * @priority 99
	   *
	   * @description
	   * Using Angular markup like `{{hash}}` in a `srcset` attribute doesn't
	   * work right: The browser will fetch from the URL with the literal
	   * text `{{hash}}` until Angular replaces the expression inside
	   * `{{hash}}`. The `ngSrcset` directive solves this problem.
	   *
	   * The buggy way to write it:
	   * ```html
	   * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	   * ```
	   *
	   * The correct way to write it:
	   * ```html
	   * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	   * ```
	   *
	   * @element IMG
	   * @param {template} ngSrcset any string which can contain `{{}}` markup.
	   */
	
	  /**
	   * @ngdoc directive
	   * @name ngDisabled
	   * @restrict A
	   * @priority 100
	   *
	   * @description
	   *
	   * This directive sets the `disabled` attribute on the element if the
	   * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	   *
	   * A special directive is necessary because we cannot use interpolation inside the `disabled`
	   * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	   <button ng-model="button" ng-disabled="checked">Button</button>
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	   </file>
	   </example>
	   *
	   * @element INPUT
	   * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	   *     then the `disabled` attribute will be set on the element
	   */
	
	
	  /**
	   * @ngdoc directive
	   * @name ngChecked
	   * @restrict A
	   * @priority 100
	   *
	   * @description
	   * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	   *
	   * Note that this directive should not be used together with {@link ngModel `ngModel`},
	   * as this can lead to unexpected behavior.
	   *
	   * A special directive is necessary because we cannot use interpolation inside the `checked`
	   * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <label>Check me to check both: <input type="checkbox" ng-model="master"></label><br/>
	   <input id="checkSlave" type="checkbox" ng-checked="master" aria-label="Slave input">
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should check both checkBoxes', function() {
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeFalsy();
	          element(by.model('master')).click();
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeTruthy();
	        });
	   </file>
	   </example>
	   *
	   * @element INPUT
	   * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	   *     then the `checked` attribute will be set on the element
	   */
	
	
	  /**
	   * @ngdoc directive
	   * @name ngReadonly
	   * @restrict A
	   * @priority 100
	   *
	   * @description
	   *
	   * Sets the `readOnly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	   *
	   * A special directive is necessary because we cannot use interpolation inside the `readOnly`
	   * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	   <input type="text" ng-readonly="checked" value="I'm Angular" aria-label="Readonly field" />
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	   </file>
	   </example>
	   *
	   * @element INPUT
	   * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	   *     then special attribute "readonly" will be set on the element
	   */
	
	
	  /**
	   * @ngdoc directive
	   * @name ngSelected
	   * @restrict A
	   * @priority 100
	   *
	   * @description
	   *
	   * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	   *
	   * A special directive is necessary because we cannot use interpolation inside the `selected`
	   * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	   <select aria-label="ngSelected demo">
	   <option>Hello!</option>
	   <option id="greet" ng-selected="selected">Greetings!</option>
	   </select>
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	   </file>
	   </example>
	   *
	   * @element OPTION
	   * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	   *     then special attribute "selected" will be set on the element
	   */
	
	  /**
	   * @ngdoc directive
	   * @name ngOpen
	   * @restrict A
	   * @priority 100
	   *
	   * @description
	   *
	   * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	   *
	   * A special directive is necessary because we cannot use interpolation inside the `open`
	   * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <label>Check me check multiple: <input type="checkbox" ng-model="open"></label><br/>
	   <details id="details" ng-open="open">
	   <summary>Show/Hide me</summary>
	   </details>
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	   </file>
	   </example>
	   *
	   * @element DETAILS
	   * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	   *     then special attribute "open" will be set on the element
	   */
	
	  var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	  forEach(BOOLEAN_ATTR, function(propName, attrName) {
	    // binding to multiple is not supported
	    if (propName == "multiple") return;
	
	    function defaultLinkFn(scope, element, attr) {
	      scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	        attr.$set(attrName, !!value);
	      });
	    }
	
	    var normalized = directiveNormalize('ng-' + attrName);
	    var linkFn = defaultLinkFn;
	
	    if (propName === 'checked') {
	      linkFn = function(scope, element, attr) {
	        // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	        if (attr.ngModel !== attr[normalized]) {
	          defaultLinkFn(scope, element, attr);
	        }
	      };
	    }
	
	    ngAttributeAliasDirectives[normalized] = function() {
	      return {
	        restrict: 'A',
	        priority: 100,
	        link: linkFn
	      };
	    };
	  });
	
	// aliased input attrs are evaluated
	  forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	    ngAttributeAliasDirectives[ngAttr] = function() {
	      return {
	        priority: 100,
	        link: function(scope, element, attr) {
	          //special case ngPattern when a literal regular expression value
	          //is used as the expression (this way we don't have to watch anything).
	          if (ngAttr === "ngPattern" && attr.ngPattern.charAt(0) == "/") {
	            var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	            if (match) {
	              attr.$set("ngPattern", new RegExp(match[1], match[2]));
	              return;
	            }
	          }
	
	          scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	            attr.$set(ngAttr, value);
	          });
	        }
	      };
	    };
	  });
	
	// ng-src, ng-srcset, ng-href are interpolated
	  forEach(['src', 'srcset', 'href'], function(attrName) {
	    var normalized = directiveNormalize('ng-' + attrName);
	    ngAttributeAliasDirectives[normalized] = function() {
	      return {
	        priority: 99, // it needs to run after the attributes are interpolated
	        link: function(scope, element, attr) {
	          var propName = attrName,
	            name = attrName;
	
	          if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	            name = 'xlinkHref';
	            attr.$attr[name] = 'xlink:href';
	            propName = null;
	          }
	
	          attr.$observe(normalized, function(value) {
	            if (!value) {
	              if (attrName === 'href') {
	                attr.$set(name, null);
	              }
	              return;
	            }
	
	            attr.$set(name, value);
	
	            // on IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	            // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	            // to set the property as well to achieve the desired effect.
	            // we use attr[attrName] value since $set can sanitize the url.
	            if (msie && propName) element.prop(propName, attr[name]);
	          });
	        }
	      };
	    };
	  });
	
	  /* global -nullFormCtrl, -SUBMITTED_CLASS, addSetValidityMethod: true
	   */
	  var nullFormCtrl = {
	      $addControl: noop,
	      $$renameControl: nullFormRenameControl,
	      $removeControl: noop,
	      $setValidity: noop,
	      $setDirty: noop,
	      $setPristine: noop,
	      $setSubmitted: noop
	    },
	    SUBMITTED_CLASS = 'ng-submitted';
	
	  function nullFormRenameControl(control, name) {
	    control.$name = name;
	  }
	
	  /**
	   * @ngdoc type
	   * @name form.FormController
	   *
	   * @property {boolean} $pristine True if user has not interacted with the form yet.
	   * @property {boolean} $dirty True if user has already interacted with the form.
	   * @property {boolean} $valid True if all of the containing forms and controls are valid.
	   * @property {boolean} $invalid True if at least one containing control or form is invalid.
	   * @property {boolean} $pending True if at least one containing control or form is pending.
	   * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	   *
	   * @property {Object} $error Is an object hash, containing references to controls or
	   *  forms with failing validators, where:
	   *
	   *  - keys are validation tokens (error names),
	   *  - values are arrays of controls or forms that have a failing validator for given error name.
	   *
	   *  Built-in validation tokens:
	   *
	   *  - `email`
	   *  - `max`
	   *  - `maxlength`
	   *  - `min`
	   *  - `minlength`
	   *  - `number`
	   *  - `pattern`
	   *  - `required`
	   *  - `url`
	   *  - `date`
	   *  - `datetimelocal`
	   *  - `time`
	   *  - `week`
	   *  - `month`
	   *
	   * @description
	   * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	   * such as being valid/invalid or dirty/pristine.
	   *
	   * Each {@link ng.directive:form form} directive creates an instance
	   * of `FormController`.
	   *
	   */
	//asks for $scope to fool the BC controller module
	  FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	  function FormController(element, attrs, $scope, $animate, $interpolate) {
	    var form = this,
	      controls = [];
	
	    // init state
	    form.$error = {};
	    form.$$success = {};
	    form.$pending = undefined;
	    form.$name = $interpolate(attrs.name || attrs.ngForm || '')($scope);
	    form.$dirty = false;
	    form.$pristine = true;
	    form.$valid = true;
	    form.$invalid = false;
	    form.$submitted = false;
	    form.$$parentForm = nullFormCtrl;
	
	    /**
	     * @ngdoc method
	     * @name form.FormController#$rollbackViewValue
	     *
	     * @description
	     * Rollback all form controls pending updates to the `$modelValue`.
	     *
	     * Updates may be pending by a debounced event or because the input is waiting for a some future
	     * event defined in `ng-model-options`. This method is typically needed by the reset button of
	     * a form that uses `ng-model-options` to pend updates.
	     */
	    form.$rollbackViewValue = function() {
	      forEach(controls, function(control) {
	        control.$rollbackViewValue();
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name form.FormController#$commitViewValue
	     *
	     * @description
	     * Commit all form controls pending updates to the `$modelValue`.
	     *
	     * Updates may be pending by a debounced event or because the input is waiting for a some future
	     * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	     * usually handles calling this in response to input events.
	     */
	    form.$commitViewValue = function() {
	      forEach(controls, function(control) {
	        control.$commitViewValue();
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name form.FormController#$addControl
	     * @param {object} control control object, either a {@link form.FormController} or an
	     * {@link ngModel.NgModelController}
	     *
	     * @description
	     * Register a control with the form. Input elements using ngModelController do this automatically
	     * when they are linked.
	     *
	     * Note that the current state of the control will not be reflected on the new parent form. This
	     * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	     * state.
	     *
	     * However, if the method is used programmatically, for example by adding dynamically created controls,
	     * or controls that have been previously removed without destroying their corresponding DOM element,
	     * it's the developers responsibility to make sure the current state propagates to the parent form.
	     *
	     * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	     * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	     */
	    form.$addControl = function(control) {
	      // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	      // and not added to the scope.  Now we throw an error.
	      assertNotHasOwnProperty(control.$name, 'input');
	      controls.push(control);
	
	      if (control.$name) {
	        form[control.$name] = control;
	      }
	
	      control.$$parentForm = form;
	    };
	
	    // Private API: rename a form control
	    form.$$renameControl = function(control, newName) {
	      var oldName = control.$name;
	
	      if (form[oldName] === control) {
	        delete form[oldName];
	      }
	      form[newName] = control;
	      control.$name = newName;
	    };
	
	    /**
	     * @ngdoc method
	     * @name form.FormController#$removeControl
	     * @param {object} control control object, either a {@link form.FormController} or an
	     * {@link ngModel.NgModelController}
	     *
	     * @description
	     * Deregister a control from the form.
	     *
	     * Input elements using ngModelController do this automatically when they are destroyed.
	     *
	     * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	     * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	     * different from case to case. For example, removing the only `$dirty` control from a form may or
	     * may not mean that the form is still `$dirty`.
	     */
	    form.$removeControl = function(control) {
	      if (control.$name && form[control.$name] === control) {
	        delete form[control.$name];
	      }
	      forEach(form.$pending, function(value, name) {
	        form.$setValidity(name, null, control);
	      });
	      forEach(form.$error, function(value, name) {
	        form.$setValidity(name, null, control);
	      });
	      forEach(form.$$success, function(value, name) {
	        form.$setValidity(name, null, control);
	      });
	
	      arrayRemove(controls, control);
	      control.$$parentForm = nullFormCtrl;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name form.FormController#$setValidity
	     *
	     * @description
	     * Sets the validity of a form control.
	     *
	     * This method will also propagate to parent forms.
	     */
	    addSetValidityMethod({
	      ctrl: this,
	      $element: element,
	      set: function(object, property, controller) {
	        var list = object[property];
	        if (!list) {
	          object[property] = [controller];
	        } else {
	          var index = list.indexOf(controller);
	          if (index === -1) {
	            list.push(controller);
	          }
	        }
	      },
	      unset: function(object, property, controller) {
	        var list = object[property];
	        if (!list) {
	          return;
	        }
	        arrayRemove(list, controller);
	        if (list.length === 0) {
	          delete object[property];
	        }
	      },
	      $animate: $animate
	    });
	
	    /**
	     * @ngdoc method
	     * @name form.FormController#$setDirty
	     *
	     * @description
	     * Sets the form to a dirty state.
	     *
	     * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	     * state (ng-dirty class). This method will also propagate to parent forms.
	     */
	    form.$setDirty = function() {
	      $animate.removeClass(element, PRISTINE_CLASS);
	      $animate.addClass(element, DIRTY_CLASS);
	      form.$dirty = true;
	      form.$pristine = false;
	      form.$$parentForm.$setDirty();
	    };
	
	    /**
	     * @ngdoc method
	     * @name form.FormController#$setPristine
	     *
	     * @description
	     * Sets the form to its pristine state.
	     *
	     * This method can be called to remove the 'ng-dirty' class and set the form to its pristine
	     * state (ng-pristine class). This method will also propagate to all the controls contained
	     * in this form.
	     *
	     * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	     * saving or resetting it.
	     */
	    form.$setPristine = function() {
	      $animate.setClass(element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	      form.$dirty = false;
	      form.$pristine = true;
	      form.$submitted = false;
	      forEach(controls, function(control) {
	        control.$setPristine();
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name form.FormController#$setUntouched
	     *
	     * @description
	     * Sets the form to its untouched state.
	     *
	     * This method can be called to remove the 'ng-touched' class and set the form controls to their
	     * untouched state (ng-untouched class).
	     *
	     * Setting a form controls back to their untouched state is often useful when setting the form
	     * back to its pristine state.
	     */
	    form.$setUntouched = function() {
	      forEach(controls, function(control) {
	        control.$setUntouched();
	      });
	    };
	
	    /**
	     * @ngdoc method
	     * @name form.FormController#$setSubmitted
	     *
	     * @description
	     * Sets the form to its submitted state.
	     */
	    form.$setSubmitted = function() {
	      $animate.addClass(element, SUBMITTED_CLASS);
	      form.$submitted = true;
	      form.$$parentForm.$setSubmitted();
	    };
	  }
	
	  /**
	   * @ngdoc directive
	   * @name ngForm
	   * @restrict EAC
	   *
	   * @description
	   * Nestable alias of {@link ng.directive:form `form`} directive. HTML
	   * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
	   * sub-group of controls needs to be determined.
	   *
	   * Note: the purpose of `ngForm` is to group controls,
	   * but not to be a replacement for the `<form>` tag with all of its capabilities
	   * (e.g. posting to the server, ...).
	   *
	   * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
	   *                       related scope, under this name.
	   *
	   */
	
	  /**
	   * @ngdoc directive
	   * @name form
	   * @restrict E
	   *
	   * @description
	   * Directive that instantiates
	   * {@link form.FormController FormController}.
	   *
	   * If the `name` attribute is specified, the form controller is published onto the current scope under
	   * this name.
	   *
	   * # Alias: {@link ng.directive:ngForm `ngForm`}
	   *
	   * In Angular, forms can be nested. This means that the outer form is valid when all of the child
	   * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	   * Angular provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	   * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	   * of controls needs to be determined.
	   *
	   * # CSS classes
	   *  - `ng-valid` is set if the form is valid.
	   *  - `ng-invalid` is set if the form is invalid.
	   *  - `ng-pending` is set if the form is pending.
	   *  - `ng-pristine` is set if the form is pristine.
	   *  - `ng-dirty` is set if the form is dirty.
	   *  - `ng-submitted` is set if the form was submitted.
	   *
	   * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	   *
	   *
	   * # Submitting a form and preventing the default action
	   *
	   * Since the role of forms in client-side Angular applications is different than in classical
	   * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	   * page reload that sends the data to the server. Instead some javascript logic should be triggered
	   * to handle the form submission in an application-specific way.
	   *
	   * For this reason, Angular prevents the default action (form submission to the server) unless the
	   * `<form>` element has an `action` attribute specified.
	   *
	   * You can use one of the following two ways to specify what javascript method should be called when
	   * a form is submitted:
	   *
	   * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	   * - {@link ng.directive:ngClick ngClick} directive on the first
	   *  button or input field of type submit (input[type=submit])
	   *
	   * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	   * or {@link ng.directive:ngClick ngClick} directives.
	   * This is because of the following form submission rules in the HTML specification:
	   *
	   * - If a form has only one input field then hitting enter in this field triggers form submit
	   * (`ngSubmit`)
	   * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	   * doesn't trigger submit
	   * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	   * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	   * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	   *
	   * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	   * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	   * to have access to the updated model.
	   *
	   * ## Animation Hooks
	   *
	   * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	   * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	   * other validations that are performed within the form. Animations in ngForm are similar to how
	   * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	   * as JS animations.
	   *
	   * The following example shows a simple way to utilize CSS transitions to style a form element
	   * that has been rendered as invalid after it has been validated:
	   *
	   * <pre>
	   * //be sure to include ngAnimate as a module to hook into more
	   * //advanced animations
	   * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	   * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	   * </pre>
	   *
	   * @example
	   <example deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	   <file name="index.html">
	   <script>
	   angular.module('formExample', [])
	   .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	   </script>
	   <style>
	   .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	   .my-form.ng-invalid {
	          background: red;
	        }
	   </style>
	   <form name="myForm" ng-controller="FormController" class="my-form">
	   userType: <input name="input" ng-model="userType" required>
	   <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	   <code>userType = {{userType}}</code><br>
	   <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	   <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	   <code>myForm.$valid = {{myForm.$valid}}</code><br>
	   <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	   </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	   it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	   </file>
	   </example>
	   *
	   * @param {string=} name Name of the form. If specified, the form controller will be published into
	   *                       related scope, under this name.
	   */
	  var formDirectiveFactory = function(isNgForm) {
	    return ['$timeout', '$parse', function($timeout, $parse) {
	      var formDirective = {
	        name: 'form',
	        restrict: isNgForm ? 'EAC' : 'E',
	        require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
	        controller: FormController,
	        compile: function ngFormCompile(formElement, attr) {
	          // Setup initial state of the control
	          formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	          var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	          return {
	            pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
	              var controller = ctrls[0];
	
	              // if `action` attr is not present on the form, prevent the default action (submission)
	              if (!('action' in attr)) {
	                // we can't use jq events because if a form is destroyed during submission the default
	                // action is not prevented. see #1238
	                //
	                // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	                // page reload if the form was destroyed by submission of the form via a click handler
	                // on a button in the form. Looks like an IE9 specific bug.
	                var handleFormSubmission = function(event) {
	                  scope.$apply(function() {
	                    controller.$commitViewValue();
	                    controller.$setSubmitted();
	                  });
	
	                  event.preventDefault();
	                };
	
	                addEventListenerFn(formElement[0], 'submit', handleFormSubmission);
	
	                // unregister the preventDefault listener so that we don't not leak memory but in a
	                // way that will achieve the prevention of the default action.
	                formElement.on('$destroy', function() {
	                  $timeout(function() {
	                    removeEventListenerFn(formElement[0], 'submit', handleFormSubmission);
	                  }, 0, false);
	                });
	              }
	
	              var parentFormCtrl = ctrls[1] || controller.$$parentForm;
	              parentFormCtrl.$addControl(controller);
	
	              var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	              if (nameAttr) {
	                setter(scope, controller);
	                attr.$observe(nameAttr, function(newValue) {
	                  if (controller.$name === newValue) return;
	                  setter(scope, undefined);
	                  controller.$$parentForm.$$renameControl(controller, newValue);
	                  setter = getSetter(controller.$name);
	                  setter(scope, controller);
	                });
	              }
	              formElement.on('$destroy', function() {
	                controller.$$parentForm.$removeControl(controller);
	                setter(scope, undefined);
	                extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	              });
	            }
	          };
	        }
	      };
	
	      return formDirective;
	
	      function getSetter(expression) {
	        if (expression === '') {
	          //create an assignable expression, so forms with an empty name can be renamed later
	          return $parse('this[""]').assign;
	        }
	        return $parse(expression).assign || noop;
	      }
	    }];
	  };
	
	  var formDirective = formDirectiveFactory();
	  var ngFormDirective = formDirectiveFactory(true);
	
	  /* global VALID_CLASS: false,
	   INVALID_CLASS: false,
	   PRISTINE_CLASS: false,
	   DIRTY_CLASS: false,
	   UNTOUCHED_CLASS: false,
	   TOUCHED_CLASS: false,
	   ngModelMinErr: false,
	   */
	
	// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	  var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
	// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        555555555555555555555555    666     77777777     8888888     999
	  var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+\])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	  var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
	  var NUMBER_REGEXP = /^\s*(\-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	  var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
	  var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	  var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
	  var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
	  var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	  var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
	  var PARTIAL_VALIDATION_TYPES = createMap();
	  forEach('date,datetime-local,month,time,week'.split(','), function(type) {
	    PARTIAL_VALIDATION_TYPES[type] = true;
	  });
	
	  var inputType = {
	
	    /**
	     * @ngdoc input
	     * @name input[text]
	     *
	     * @description
	     * Standard HTML text input with angular data binding, inherited by most of the `input` elements.
	     *
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} required Adds `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	     *    minlength.
	     * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	     *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	     *    any length.
	     * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	     *    that contains the regular expression body that will be converted to a regular expression
	     *    as in the ngPattern directive.
	     * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	     *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	     *    If the expression evaluates to a RegExp object, then this is used directly.
	     *    If the expression evaluates to a string, then it will be converted to a RegExp
	     *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	     *    `new RegExp('^abc$')`.<br />
	     *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	     *    start at the index of the last search's match, thus not taking the whole input value into
	     *    account.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	     *    This parameter is ignored for input[type=password] controls, which will never trim the
	     *    input.
	     *
	     * @example
	     <example name="text-input-directive" module="textInputExample">
	     <file name="index.html">
	     <script>
	     angular.module('textInputExample', [])
	     .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	     </script>
	     <form name="myForm" ng-controller="ExampleController">
	     <label>Single word:
	     <input type="text" name="input" ng-model="example.text"
	     ng-pattern="example.word" required ng-trim="false">
	     </label>
	     <div role="alert">
	     <span class="error" ng-show="myForm.input.$error.required">
	     Required!</span>
	     <span class="error" ng-show="myForm.input.$error.pattern">
	     Single word only!</span>
	     </div>
	     <code>text = {{example.text}}</code><br/>
	     <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	     <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	     <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	     <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	     </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	     var text = element(by.binding('example.text'));
	     var valid = element(by.binding('myForm.input.$valid'));
	     var input = element(by.model('example.text'));
	
	     it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	     it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	     it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	     </file>
	     </example>
	     */
	    'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise Angular will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	     <script>
	     angular.module('dateInputExample', [])
	     .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	     <label for="exampleInput">Pick a date in 2013:</label>
	     <input type="date" id="exampleInput" name="input" ng-model="example.value"
	     placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	     <div role="alert">
	     <span class="error" ng-show="myForm.input.$error.required">
	     Required!</span>
	     <span class="error" ng-show="myForm.input.$error.date">
	     Not a valid date!</span>
	     </div>
	     <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	     <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	     <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	     <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	     <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	     var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	     var valid = element(by.binding('myForm.input.$valid'));
	     var input = element(by.model('example.value'));
	
	     // currently protractor/webdriver does not support
	     // sending keys to all known HTML5 input controls
	     // for various browsers (see https://github.com/angular/protractor/issues/562).
	     function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	     it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	     it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	     it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	    'date': createDateInputType('date', DATE_REGEXP,
	      createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	      'yyyy-MM-dd'),
	
	    /**
	     * @ngdoc input
	     * @name input[datetime-local]
	     *
	     * @description
	     * Input with datetime validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	     * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	     *
	     * The model must always be a Date object, otherwise Angular will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	     *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	     *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	     *   Note that `min` will also add native HTML5 constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	     *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	     *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	     *   Note that `max` will also add native HTML5 constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="datetimelocal-input-directive" module="dateExample">
	     <file name="index.html">
	     <script>
	     angular.module('dateExample', [])
	     .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	     <label for="exampleInput">Pick a date between in 2013:</label>
	     <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	     placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	     <div role="alert">
	     <span class="error" ng-show="myForm.input.$error.required">
	     Required!</span>
	     <span class="error" ng-show="myForm.input.$error.datetimelocal">
	     Not a valid date!</span>
	     </div>
	     <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	     <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	     <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	     <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	     <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	     var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	     var valid = element(by.binding('myForm.input.$valid'));
	     var input = element(by.model('example.value'));
	
	     // currently protractor/webdriver does not support
	     // sending keys to all known HTML5 input controls
	     // for various browsers (https://github.com/angular/protractor/issues/562).
	     function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	     it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	     it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	     it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	     </file>
	     </example>
	     */
	    'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	    /**
	     * @ngdoc input
	     * @name input[time]
	     *
	     * @description
	     * Input with time validation and transformation. In browsers that do not yet support
	     * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	     * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	     * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	     *
	     * The model must always be a Date object, otherwise Angular will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	     *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	     *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	     *   native HTML5 constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	     *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	     *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	     *   native HTML5 constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	     *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	     *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="time-input-directive" module="timeExample">
	     <file name="index.html">
	     <script>
	     angular.module('timeExample', [])
	     .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	     <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	     <input type="time" id="exampleInput" name="input" ng-model="example.value"
	     placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	     <div role="alert">
	     <span class="error" ng-show="myForm.input.$error.required">
	     Required!</span>
	     <span class="error" ng-show="myForm.input.$error.time">
	     Not a valid date!</span>
	     </div>
	     <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	     <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	     <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	     <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	     <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	     var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	     var valid = element(by.binding('myForm.input.$valid'));
	     var input = element(by.model('example.value'));
	
	     // currently protractor/webdriver does not support
	     // sending keys to all known HTML5 input controls
	     // for various browsers (https://github.com/angular/protractor/issues/562).
	     function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	     it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	     it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	     it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	     </file>
	     </example>
	     */
	    'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	      'HH:mm:ss.sss'),
	
	    /**
	     * @ngdoc input
	     * @name input[week]
	     *
	     * @description
	     * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	     * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	     * week format (yyyy-W##), for example: `2013-W02`.
	     *
	     * The model must always be a Date object, otherwise Angular will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	     *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	     *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	     *   native HTML5 constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	     *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	     *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	     *   native HTML5 constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="week-input-directive" module="weekExample">
	     <file name="index.html">
	     <script>
	     angular.module('weekExample', [])
	     .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	     <label>Pick a date between in 2013:
	     <input id="exampleInput" type="week" name="input" ng-model="example.value"
	     placeholder="YYYY-W##" min="2012-W32"
	     max="2013-W52" required />
	     </label>
	     <div role="alert">
	     <span class="error" ng-show="myForm.input.$error.required">
	     Required!</span>
	     <span class="error" ng-show="myForm.input.$error.week">
	     Not a valid date!</span>
	     </div>
	     <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	     <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	     <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	     <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	     <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	     var value = element(by.binding('example.value | date: "yyyy-Www"'));
	     var valid = element(by.binding('myForm.input.$valid'));
	     var input = element(by.model('example.value'));
	
	     // currently protractor/webdriver does not support
	     // sending keys to all known HTML5 input controls
	     // for various browsers (https://github.com/angular/protractor/issues/562).
	     function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	     it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	     it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	     it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	     </file>
	     </example>
	     */
	    'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	    /**
	     * @ngdoc input
	     * @name input[month]
	     *
	     * @description
	     * Input with month validation and transformation. In browsers that do not yet support
	     * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	     * month format (yyyy-MM), for example: `2009-01`.
	     *
	     * The model must always be a Date object, otherwise Angular will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     * If the model is not set to the first of the month, the next view to model update will set it
	     * to the first of the month.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	     *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	     *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	     *   native HTML5 constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	     *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	     *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	     *   native HTML5 constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="month-input-directive" module="monthExample">
	     <file name="index.html">
	     <script>
	     angular.module('monthExample', [])
	     .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	     <label for="exampleInput">Pick a month in 2013:</label>
	     <input id="exampleInput" type="month" name="input" ng-model="example.value"
	     placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	     <div role="alert">
	     <span class="error" ng-show="myForm.input.$error.required">
	     Required!</span>
	     <span class="error" ng-show="myForm.input.$error.month">
	     Not a valid month!</span>
	     </div>
	     <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	     <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	     <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	     <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	     <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	     var value = element(by.binding('example.value | date: "yyyy-MM"'));
	     var valid = element(by.binding('myForm.input.$valid'));
	     var input = element(by.model('example.value'));
	
	     // currently protractor/webdriver does not support
	     // sending keys to all known HTML5 input controls
	     // for various browsers (https://github.com/angular/protractor/issues/562).
	     function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	     it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	     it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	     it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	     </file>
	     </example>
	     */
	    'month': createDateInputType('month', MONTH_REGEXP,
	      createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	      'yyyy-MM'),
	
	    /**
	     * @ngdoc input
	     * @name input[number]
	     *
	     * @description
	     * Text input with number validation and transformation. Sets the `number` validation
	     * error if not a valid number.
	     *
	     * <div class="alert alert-warning">
	     * The model must always be of type `number` otherwise Angular will throw an error.
	     * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	     * error docs for more information and an example of how to convert your model if necessary.
	     * </div>
	     *
	     * ## Issues with HTML5 constraint validation
	     *
	     * In browsers that follow the
	     * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	     * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	     * If a non-number is entered in the input, the browser will report the value as an empty string,
	     * which means the view / model values in `ngModel` and subsequently the scope value
	     * will also be an empty string.
	     *
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	     *    minlength.
	     * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	     *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	     *    any length.
	     * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	     *    that contains the regular expression body that will be converted to a regular expression
	     *    as in the ngPattern directive.
	     * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	     *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	     *    If the expression evaluates to a RegExp object, then this is used directly.
	     *    If the expression evaluates to a string, then it will be converted to a RegExp
	     *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	     *    `new RegExp('^abc$')`.<br />
	     *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	     *    start at the index of the last search's match, thus not taking the whole input value into
	     *    account.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="number-input-directive" module="numberExample">
	     <file name="index.html">
	     <script>
	     angular.module('numberExample', [])
	     .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	     </script>
	     <form name="myForm" ng-controller="ExampleController">
	     <label>Number:
	     <input type="number" name="input" ng-model="example.value"
	     min="0" max="99" required>
	     </label>
	     <div role="alert">
	     <span class="error" ng-show="myForm.input.$error.required">
	     Required!</span>
	     <span class="error" ng-show="myForm.input.$error.number">
	     Not valid number!</span>
	     </div>
	     <tt>value = {{example.value}}</tt><br/>
	     <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	     <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	     <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	     <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	     var value = element(by.binding('example.value'));
	     var valid = element(by.binding('myForm.input.$valid'));
	     var input = element(by.model('example.value'));
	
	     it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	     it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	     it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	     </file>
	     </example>
	     */
	    'number': numberInputType,
	
	
	    /**
	     * @ngdoc input
	     * @name input[url]
	     *
	     * @description
	     * Text input with URL validation. Sets the `url` validation error key if the content is not a
	     * valid URL.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	     * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	     * the built-in validators (see the {@link guide/forms Forms guide})
	     * </div>
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	     *    minlength.
	     * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	     *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	     *    any length.
	     * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	     *    that contains the regular expression body that will be converted to a regular expression
	     *    as in the ngPattern directive.
	     * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	     *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	     *    If the expression evaluates to a RegExp object, then this is used directly.
	     *    If the expression evaluates to a string, then it will be converted to a RegExp
	     *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	     *    `new RegExp('^abc$')`.<br />
	     *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	     *    start at the index of the last search's match, thus not taking the whole input value into
	     *    account.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="url-input-directive" module="urlExample">
	     <file name="index.html">
	     <script>
	     angular.module('urlExample', [])
	     .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	     </script>
	     <form name="myForm" ng-controller="ExampleController">
	     <label>URL:
	     <input type="url" name="input" ng-model="url.text" required>
	     <label>
	     <div role="alert">
	     <span class="error" ng-show="myForm.input.$error.required">
	     Required!</span>
	     <span class="error" ng-show="myForm.input.$error.url">
	     Not valid url!</span>
	     </div>
	     <tt>text = {{url.text}}</tt><br/>
	     <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	     <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	     <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	     <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	     </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	     var text = element(by.binding('url.text'));
	     var valid = element(by.binding('myForm.input.$valid'));
	     var input = element(by.model('url.text'));
	
	     it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	     it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	     it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	     </file>
	     </example>
	     */
	    'url': urlInputType,
	
	
	    /**
	     * @ngdoc input
	     * @name input[email]
	     *
	     * @description
	     * Text input with email validation. Sets the `email` validation error key if not a valid email
	     * address.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	     * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
	     * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
	     * </div>
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	     *    minlength.
	     * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	     *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	     *    any length.
	     * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	     *    that contains the regular expression body that will be converted to a regular expression
	     *    as in the ngPattern directive.
	     * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	     *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	     *    If the expression evaluates to a RegExp object, then this is used directly.
	     *    If the expression evaluates to a string, then it will be converted to a RegExp
	     *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	     *    `new RegExp('^abc$')`.<br />
	     *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	     *    start at the index of the last search's match, thus not taking the whole input value into
	     *    account.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="email-input-directive" module="emailExample">
	     <file name="index.html">
	     <script>
	     angular.module('emailExample', [])
	     .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	     </script>
	     <form name="myForm" ng-controller="ExampleController">
	     <label>Email:
	     <input type="email" name="input" ng-model="email.text" required>
	     </label>
	     <div role="alert">
	     <span class="error" ng-show="myForm.input.$error.required">
	     Required!</span>
	     <span class="error" ng-show="myForm.input.$error.email">
	     Not valid email!</span>
	     </div>
	     <tt>text = {{email.text}}</tt><br/>
	     <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	     <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	     <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	     <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	     </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	     var text = element(by.binding('email.text'));
	     var valid = element(by.binding('myForm.input.$valid'));
	     var input = element(by.model('email.text'));
	
	     it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	     it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	     it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	     </file>
	     </example>
	     */
	    'email': emailInputType,
	
	
	    /**
	     * @ngdoc input
	     * @name input[radio]
	     *
	     * @description
	     * HTML radio button.
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string} value The value to which the `ngModel` expression should be set when selected.
	     *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	     *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     * @param {string} ngValue Angular expression to which `ngModel` will be be set when the radio
	     *    is selected. Should be used instead of the `value` attribute if you need
	     *    a non-string `ngModel` (`boolean`, `array`, ...).
	     *
	     * @example
	     <example name="radio-input-directive" module="radioExample">
	     <file name="index.html">
	     <script>
	     angular.module('radioExample', [])
	     .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	     </script>
	     <form name="myForm" ng-controller="ExampleController">
	     <label>
	     <input type="radio" ng-model="color.name" value="red">
	     Red
	     </label><br/>
	     <label>
	     <input type="radio" ng-model="color.name" ng-value="specialValue">
	     Green
	     </label><br/>
	     <label>
	     <input type="radio" ng-model="color.name" value="blue">
	     Blue
	     </label><br/>
	     <tt>color = {{color.name | json}}</tt><br/>
	     </form>
	     Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	     </file>
	     <file name="protractor.js" type="protractor">
	     it('should change state', function() {
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            element.all(by.model('color.name')).get(0).click();
	
	            expect(color.getText()).toContain('red');
	          });
	     </file>
	     </example>
	     */
	    'radio': radioInputType,
	
	
	    /**
	     * @ngdoc input
	     * @name input[checkbox]
	     *
	     * @description
	     * HTML checkbox.
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	     * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="checkbox-input-directive" module="checkboxExample">
	     <file name="index.html">
	     <script>
	     angular.module('checkboxExample', [])
	     .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	     </script>
	     <form name="myForm" ng-controller="ExampleController">
	     <label>Value1:
	     <input type="checkbox" ng-model="checkboxModel.value1">
	     </label><br/>
	     <label>Value2:
	     <input type="checkbox" ng-model="checkboxModel.value2"
	     ng-true-value="'YES'" ng-false-value="'NO'">
	     </label><br/>
	     <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	     <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	     </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	     it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	     </file>
	     </example>
	     */
	    'checkbox': checkboxInputType,
	
	    'hidden': noop,
	    'button': noop,
	    'submit': noop,
	    'reset': noop,
	    'file': noop
	  };
	
	  function stringBasedInputType(ctrl) {
	    ctrl.$formatters.push(function(value) {
	      return ctrl.$isEmpty(value) ? value : value.toString();
	    });
	  }
	
	  function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	    stringBasedInputType(ctrl);
	  }
	
	  function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	    var type = lowercase(element[0].type);
	
	    // In composition mode, users are still inputing intermediate text buffer,
	    // hold the listener until composition is done.
	    // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	    if (!$sniffer.android) {
	      var composing = false;
	
	      element.on('compositionstart', function() {
	        composing = true;
	      });
	
	      element.on('compositionend', function() {
	        composing = false;
	        listener();
	      });
	    }
	
	    var timeout;
	
	    var listener = function(ev) {
	      if (timeout) {
	        $browser.defer.cancel(timeout);
	        timeout = null;
	      }
	      if (composing) return;
	      var value = element.val(),
	        event = ev && ev.type;
	
	      // By default we will trim the value
	      // If the attribute ng-trim exists we will avoid trimming
	      // If input type is 'password', the value is never trimmed
	      if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	        value = trim(value);
	      }
	
	      // If a control is suffering from bad input (due to native validators), browsers discard its
	      // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	      // control's value is the same empty value twice in a row.
	      if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	        ctrl.$setViewValue(value, event);
	      }
	    };
	
	    // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	    // input event on backspace, delete or cut
	    if ($sniffer.hasEvent('input')) {
	      element.on('input', listener);
	    } else {
	      var deferListener = function(ev, input, origValue) {
	        if (!timeout) {
	          timeout = $browser.defer(function() {
	            timeout = null;
	            if (!input || input.value !== origValue) {
	              listener(ev);
	            }
	          });
	        }
	      };
	
	      element.on('keydown', function(event) {
	        var key = event.keyCode;
	
	        // ignore
	        //    command            modifiers                   arrows
	        if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	        deferListener(event, this, this.value);
	      });
	
	      // if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
	      if ($sniffer.hasEvent('paste')) {
	        element.on('paste cut', deferListener);
	      }
	    }
	
	    // if user paste into input using mouse on older browser
	    // or form autocomplete on newer browser, we need "change" event to catch it
	    element.on('change', listener);
	
	    // Some native input types (date-family) have the ability to change validity without
	    // firing any input/change events.
	    // For these event types, when native validators are present and the browser supports the type,
	    // check for validity changes on various DOM events.
	    if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
	      element.on(PARTIAL_VALIDATION_EVENTS, function(ev) {
	        if (!timeout) {
	          var validity = this[VALIDITY_STATE_PROPERTY];
	          var origBadInput = validity.badInput;
	          var origTypeMismatch = validity.typeMismatch;
	          timeout = $browser.defer(function() {
	            timeout = null;
	            if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
	              listener(ev);
	            }
	          });
	        }
	      });
	    }
	
	    ctrl.$render = function() {
	      // Workaround for Firefox validation #12102.
	      var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	      if (element.val() !== value) {
	        element.val(value);
	      }
	    };
	  }
	
	  function weekParser(isoWeek, existingDate) {
	    if (isDate(isoWeek)) {
	      return isoWeek;
	    }
	
	    if (isString(isoWeek)) {
	      WEEK_REGEXP.lastIndex = 0;
	      var parts = WEEK_REGEXP.exec(isoWeek);
	      if (parts) {
	        var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	        if (existingDate) {
	          hours = existingDate.getHours();
	          minutes = existingDate.getMinutes();
	          seconds = existingDate.getSeconds();
	          milliseconds = existingDate.getMilliseconds();
	        }
	
	        return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	      }
	    }
	
	    return NaN;
	  }
	
	  function createDateParser(regexp, mapping) {
	    return function(iso, date) {
	      var parts, map;
	
	      if (isDate(iso)) {
	        return iso;
	      }
	
	      if (isString(iso)) {
	        // When a date is JSON'ified to wraps itself inside of an extra
	        // set of double quotes. This makes the date parsing code unable
	        // to match the date string and parse it as a date.
	        if (iso.charAt(0) == '"' && iso.charAt(iso.length - 1) == '"') {
	          iso = iso.substring(1, iso.length - 1);
	        }
	        if (ISO_DATE_REGEXP.test(iso)) {
	          return new Date(iso);
	        }
	        regexp.lastIndex = 0;
	        parts = regexp.exec(iso);
	
	        if (parts) {
	          parts.shift();
	          if (date) {
	            map = {
	              yyyy: date.getFullYear(),
	              MM: date.getMonth() + 1,
	              dd: date.getDate(),
	              HH: date.getHours(),
	              mm: date.getMinutes(),
	              ss: date.getSeconds(),
	              sss: date.getMilliseconds() / 1000
	            };
	          } else {
	            map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	          }
	
	          forEach(parts, function(part, index) {
	            if (index < mapping.length) {
	              map[mapping[index]] = +part;
	            }
	          });
	          return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	        }
	      }
	
	      return NaN;
	    };
	  }
	
	  function createDateInputType(type, regexp, parseDate, format) {
	    return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
	      badInputChecker(scope, element, attr, ctrl);
	      baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	      var timezone = ctrl && ctrl.$options && ctrl.$options.timezone;
	      var previousDate;
	
	      ctrl.$$parserName = type;
	      ctrl.$parsers.push(function(value) {
	        if (ctrl.$isEmpty(value)) return null;
	        if (regexp.test(value)) {
	          // Note: We cannot read ctrl.$modelValue, as there might be a different
	          // parser/formatter in the processing chain so that the model
	          // contains some different data format!
	          var parsedDate = parseDate(value, previousDate);
	          if (timezone) {
	            parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	          }
	          return parsedDate;
	        }
	        return undefined;
	      });
	
	      ctrl.$formatters.push(function(value) {
	        if (value && !isDate(value)) {
	          throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	        }
	        if (isValidDate(value)) {
	          previousDate = value;
	          if (previousDate && timezone) {
	            previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	          }
	          return $filter('date')(value, format, timezone);
	        } else {
	          previousDate = null;
	          return '';
	        }
	      });
	
	      if (isDefined(attr.min) || attr.ngMin) {
	        var minVal;
	        ctrl.$validators.min = function(value) {
	          return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
	        };
	        attr.$observe('min', function(val) {
	          minVal = parseObservedDateValue(val);
	          ctrl.$validate();
	        });
	      }
	
	      if (isDefined(attr.max) || attr.ngMax) {
	        var maxVal;
	        ctrl.$validators.max = function(value) {
	          return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
	        };
	        attr.$observe('max', function(val) {
	          maxVal = parseObservedDateValue(val);
	          ctrl.$validate();
	        });
	      }
	
	      function isValidDate(value) {
	        // Invalid Date: getTime() returns NaN
	        return value && !(value.getTime && value.getTime() !== value.getTime());
	      }
	
	      function parseObservedDateValue(val) {
	        return isDefined(val) && !isDate(val) ? parseDate(val) || undefined : val;
	      }
	    };
	  }
	
	  function badInputChecker(scope, element, attr, ctrl) {
	    var node = element[0];
	    var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	    if (nativeValidation) {
	      ctrl.$parsers.push(function(value) {
	        var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	        return validity.badInput || validity.typeMismatch ? undefined : value;
	      });
	    }
	  }
	
	  function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	    badInputChecker(scope, element, attr, ctrl);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	    ctrl.$$parserName = 'number';
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value))      return null;
	      if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (!ctrl.$isEmpty(value)) {
	        if (!isNumber(value)) {
	          throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	        }
	        value = value.toString();
	      }
	      return value;
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal;
	      ctrl.$validators.min = function(value) {
	        return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
	      };
	
	      attr.$observe('min', function(val) {
	        if (isDefined(val) && !isNumber(val)) {
	          val = parseFloat(val, 10);
	        }
	        minVal = isNumber(val) && !isNaN(val) ? val : undefined;
	        // TODO(matsko): implement validateLater to reduce number of validations
	        ctrl.$validate();
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal;
	      ctrl.$validators.max = function(value) {
	        return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
	      };
	
	      attr.$observe('max', function(val) {
	        if (isDefined(val) && !isNumber(val)) {
	          val = parseFloat(val, 10);
	        }
	        maxVal = isNumber(val) && !isNaN(val) ? val : undefined;
	        // TODO(matsko): implement validateLater to reduce number of validations
	        ctrl.$validate();
	      });
	    }
	  }
	
	  function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	    // Note: no badInputChecker here by purpose as `url` is only a validation
	    // in browsers, i.e. we can always read out input.value even if it is not valid!
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	    stringBasedInputType(ctrl);
	
	    ctrl.$$parserName = 'url';
	    ctrl.$validators.url = function(modelValue, viewValue) {
	      var value = modelValue || viewValue;
	      return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	    };
	  }
	
	  function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	    // Note: no badInputChecker here by purpose as `url` is only a validation
	    // in browsers, i.e. we can always read out input.value even if it is not valid!
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	    stringBasedInputType(ctrl);
	
	    ctrl.$$parserName = 'email';
	    ctrl.$validators.email = function(modelValue, viewValue) {
	      var value = modelValue || viewValue;
	      return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	    };
	  }
	
	  function radioInputType(scope, element, attr, ctrl) {
	    // make the name unique, if not defined
	    if (isUndefined(attr.name)) {
	      element.attr('name', nextUid());
	    }
	
	    var listener = function(ev) {
	      if (element[0].checked) {
	        ctrl.$setViewValue(attr.value, ev && ev.type);
	      }
	    };
	
	    element.on('click', listener);
	
	    ctrl.$render = function() {
	      var value = attr.value;
	      element[0].checked = (value == ctrl.$viewValue);
	    };
	
	    attr.$observe('value', ctrl.$render);
	  }
	
	  function parseConstantExpr($parse, context, name, expression, fallback) {
	    var parseFn;
	    if (isDefined(expression)) {
	      parseFn = $parse(expression);
	      if (!parseFn.constant) {
	        throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	          '`{1}`.', name, expression);
	      }
	      return parseFn(context);
	    }
	    return fallback;
	  }
	
	  function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	    var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	    var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	    var listener = function(ev) {
	      ctrl.$setViewValue(element[0].checked, ev && ev.type);
	    };
	
	    element.on('click', listener);
	
	    ctrl.$render = function() {
	      element[0].checked = ctrl.$viewValue;
	    };
	
	    // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	    // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	    // it to a boolean.
	    ctrl.$isEmpty = function(value) {
	      return value === false;
	    };
	
	    ctrl.$formatters.push(function(value) {
	      return equals(value, trueValue);
	    });
	
	    ctrl.$parsers.push(function(value) {
	      return value ? trueValue : falseValue;
	    });
	  }
	
	
	  /**
	   * @ngdoc directive
	   * @name textarea
	   * @restrict E
	   *
	   * @description
	   * HTML textarea element control with angular data-binding. The data-binding and validation
	   * properties of this element are exactly the same as those of the
	   * {@link ng.directive:input input element}.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	   *    length.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	   */
	
	
	  /**
	   * @ngdoc directive
	   * @name input
	   * @restrict E
	   *
	   * @description
	   * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	   * input state control, and validation.
	   * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** Not every feature offered is available for all input types.
	   * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {boolean=} ngRequired Sets `required` attribute if set to true
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	   *    length.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    value does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	   <example name="input-directive" module="inputExample">
	   <file name="index.html">
	   <script>
	   angular.module('inputExample', [])
	   .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	   </script>
	   <div ng-controller="ExampleController">
	   <form name="myForm">
	   <label>
	   User name:
	   <input type="text" name="userName" ng-model="user.name" required>
	   </label>
	   <div role="alert">
	   <span class="error" ng-show="myForm.userName.$error.required">
	   Required!</span>
	   </div>
	   <label>
	   Last name:
	   <input type="text" name="lastName" ng-model="user.last"
	   ng-minlength="3" ng-maxlength="10">
	   </label>
	   <div role="alert">
	   <span class="error" ng-show="myForm.lastName.$error.minlength">
	   Too short!</span>
	   <span class="error" ng-show="myForm.lastName.$error.maxlength">
	   Too long!</span>
	   </div>
	   </form>
	   <hr>
	   <tt>user = {{user}}</tt><br/>
	   <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	   <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	   <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	   <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	   <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	   <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	   <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	   <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	   </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	   var user = element(by.exactBinding('user'));
	   var userNameValid = element(by.binding('myForm.userName.$valid'));
	   var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	   var lastNameError = element(by.binding('myForm.lastName.$error'));
	   var formValid = element(by.binding('myForm.$valid'));
	   var userNameInput = element(by.model('user.name'));
	   var userLastInput = element(by.model('user.last'));
	
	   it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	   it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	   it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	   it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	   it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	   </file>
	   </example>
	   */
	  var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	      return {
	        restrict: 'E',
	        require: ['?ngModel'],
	        link: {
	          pre: function(scope, element, attr, ctrls) {
	            if (ctrls[0]) {
	              (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                $browser, $filter, $parse);
	            }
	          }
	        }
	      };
	    }];
	
	
	
	  var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	  /**
	   * @ngdoc directive
	   * @name ngValue
	   *
	   * @description
	   * Binds the given expression to the value of `<option>` or {@link input[radio] `input[radio]`},
	   * so that when the element is selected, the {@link ngModel `ngModel`} of that element is set to
	   * the bound value.
	   *
	   * `ngValue` is useful when dynamically generating lists of radio buttons using
	   * {@link ngRepeat `ngRepeat`}, as shown below.
	   *
	   * Likewise, `ngValue` can be used to generate `<option>` elements for
	   * the {@link select `select`} element. In that case however, only strings are supported
	   * for the `value `attribute, so the resulting `ngModel` will always be a string.
	   * Support for `select` models with non-string values is available via `ngOptions`.
	   *
	   * @element input
	   * @param {string=} ngValue angular expression, whose value will be bound to the `value` attribute
	   *   of the `input` element
	   *
	   * @example
	   <example name="ngValue-directive" module="valueExample">
	   <file name="index.html">
	   <script>
	   angular.module('valueExample', [])
	   .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	   </script>
	   <form ng-controller="ExampleController">
	   <h2>Which is your favorite?</h2>
	   <label ng-repeat="name in names" for="{{name}}">
	   {{name}}
	   <input type="radio"
	   ng-model="my.favorite"
	   ng-value="name"
	   id="{{name}}"
	   name="favorite">
	   </label>
	   <div>You chose {{my.favorite}}</div>
	   </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	   var favorite = element(by.binding('my.favorite'));
	
	   it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	   it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	   </file>
	   </example>
	   */
	  var ngValueDirective = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      compile: function(tpl, tplAttr) {
	        if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	          return function ngValueConstantLink(scope, elm, attr) {
	            attr.$set('value', scope.$eval(attr.ngValue));
	          };
	        } else {
	          return function ngValueLink(scope, elm, attr) {
	            scope.$watch(attr.ngValue, function valueWatchAction(value) {
	              attr.$set('value', value);
	            });
	          };
	        }
	      }
	    };
	  };
	
	  /**
	   * @ngdoc directive
	   * @name ngBind
	   * @restrict AC
	   *
	   * @description
	   * The `ngBind` attribute tells Angular to replace the text content of the specified HTML element
	   * with the value of a given expression, and to update the text content when the value of that
	   * expression changes.
	   *
	   * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	   * `{{ expression }}` which is similar but less verbose.
	   *
	   * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	   * displayed by the browser in its raw state before Angular compiles it. Since `ngBind` is an
	   * element attribute, it makes the bindings invisible to the user while the page is loading.
	   *
	   * An alternative solution to this problem would be using the
	   * {@link ng.directive:ngCloak ngCloak} directive.
	   *
	   *
	   * @element ANY
	   * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	   *
	   * @example
	   * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample">
	   <file name="index.html">
	   <script>
	   angular.module('bindExample', [])
	   .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	   </script>
	   <div ng-controller="ExampleController">
	   <label>Enter name: <input type="text" ng-model="name"></label><br>
	   Hello <span ng-bind="name"></span>!
	   </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	   </file>
	   </example>
	   */
	  var ngBindDirective = ['$compile', function($compile) {
	    return {
	      restrict: 'AC',
	      compile: function ngBindCompile(templateElement) {
	        $compile.$$addBindingClass(templateElement);
	        return function ngBindLink(scope, element, attr) {
	          $compile.$$addBindingInfo(element, attr.ngBind);
	          element = element[0];
	          scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	            element.textContent = isUndefined(value) ? '' : value;
	          });
	        };
	      }
	    };
	  }];
	
	
	  /**
	   * @ngdoc directive
	   * @name ngBindTemplate
	   *
	   * @description
	   * The `ngBindTemplate` directive specifies that the element
	   * text content should be replaced with the interpolation of the template
	   * in the `ngBindTemplate` attribute.
	   * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	   * expressions. This directive is needed since some HTML elements
	   * (such as TITLE and OPTION) cannot contain SPAN elements.
	   *
	   * @element ANY
	   * @param {string} ngBindTemplate template of form
	   *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	   *
	   * @example
	   * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample">
	   <file name="index.html">
	   <script>
	   angular.module('bindExample', [])
	   .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	   </script>
	   <div ng-controller="ExampleController">
	   <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	   <label>Name: <input type="text" ng-model="name"></label><br>
	   <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	   </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	   </file>
	   </example>
	   */
	  var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	    return {
	      compile: function ngBindTemplateCompile(templateElement) {
	        $compile.$$addBindingClass(templateElement);
	        return function ngBindTemplateLink(scope, element, attr) {
	          var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	          $compile.$$addBindingInfo(element, interpolateFn.expressions);
	          element = element[0];
	          attr.$observe('ngBindTemplate', function(value) {
	            element.textContent = isUndefined(value) ? '' : value;
	          });
	        };
	      }
	    };
	  }];
	
	
	  /**
	   * @ngdoc directive
	   * @name ngBindHtml
	   *
	   * @description
	   * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	   * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	   * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	    * ngSanitize} in your module's dependencies (not in core Angular). In order to use {@link ngSanitize}
	   * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	   *
	   * You may also bypass sanitization for values you know are safe. To do so, bind to
	   * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	   * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	   *
	   * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	   * will have an exception (instead of an exploit.)
	   *
	   * @element ANY
	   * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	   *
	   * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js">
	   <file name="index.html">
	   <div ng-controller="ExampleController">
	   <p ng-bind-html="myHTML"></p>
	   </div>
	   </file>
	
	   <file name="script.js">
	   angular.module('bindHtmlExample', ['ngSanitize'])
	   .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	   </file>
	
	   <file name="protractor.js" type="protractor">
	   it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	   </file>
	   </example>
	   */
	  var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	    return {
	      restrict: 'A',
	      compile: function ngBindHtmlCompile(tElement, tAttrs) {
	        var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	        var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
	          // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	          return $sce.valueOf(val);
	        });
	        $compile.$$addBindingClass(tElement);
	
	        return function ngBindHtmlLink(scope, element, attr) {
	          $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	          scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	            // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	            var value = ngBindHtmlGetter(scope);
	            element.html($sce.getTrustedHtml(value) || '');
	          });
	        };
	      }
	    };
	  }];
	
	  /**
	   * @ngdoc directive
	   * @name ngChange
	   *
	   * @description
	   * Evaluate the given expression when the user changes the input.
	   * The expression is evaluated immediately, unlike the JavaScript onchange event
	   * which only triggers at the end of a change (usually, when the user leaves the
	   * form element or presses the return key).
	   *
	   * The `ngChange` expression is only evaluated when a change in the input value causes
	   * a new value to be committed to the model.
	   *
	   * It will not be evaluated:
	   * * if the value returned from the `$parsers` transformation pipeline has not changed
	   * * if the input has continued to be invalid since the model will stay `null`
	   * * if the model is changed programmatically and not by a change to the input value
	   *
	   *
	   * Note, this directive requires `ngModel` to be present.
	   *
	   * @element input
	   * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	   * in input value.
	   *
	   * @example
	   * <example name="ngChange-directive" module="changeExample">
	   *   <file name="index.html">
	   *     <script>
	   *       angular.module('changeExample', [])
	   *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	   *     </script>
	   *     <div ng-controller="ExampleController">
	   *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	   *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	   *       <label for="ng-change-example2">Confirmed</label><br />
	   *       <tt>debug = {{confirmed}}</tt><br/>
	   *       <tt>counter = {{counter}}</tt><br/>
	   *     </div>
	   *   </file>
	   *   <file name="protractor.js" type="protractor">
	   *     var counter = element(by.binding('counter'));
	   *     var debug = element(by.binding('confirmed'));
	   *
	   *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	   *
	   *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	   *   </file>
	   * </example>
	   */
	  var ngChangeDirective = valueFn({
	    restrict: 'A',
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      ctrl.$viewChangeListeners.push(function() {
	        scope.$eval(attr.ngChange);
	      });
	    }
	  });
	
	  function classDirective(name, selector) {
	    name = 'ngClass' + name;
	    return ['$animate', function($animate) {
	      return {
	        restrict: 'AC',
	        link: function(scope, element, attr) {
	          var oldVal;
	
	          scope.$watch(attr[name], ngClassWatchAction, true);
	
	          attr.$observe('class', function(value) {
	            ngClassWatchAction(scope.$eval(attr[name]));
	          });
	
	
	          if (name !== 'ngClass') {
	            scope.$watch('$index', function($index, old$index) {
	              // jshint bitwise: false
	              var mod = $index & 1;
	              if (mod !== (old$index & 1)) {
	                var classes = arrayClasses(scope.$eval(attr[name]));
	                mod === selector ?
	                  addClasses(classes) :
	                  removeClasses(classes);
	              }
	            });
	          }
	
	          function addClasses(classes) {
	            var newClasses = digestClassCounts(classes, 1);
	            attr.$addClass(newClasses);
	          }
	
	          function removeClasses(classes) {
	            var newClasses = digestClassCounts(classes, -1);
	            attr.$removeClass(newClasses);
	          }
	
	          function digestClassCounts(classes, count) {
	            // Use createMap() to prevent class assumptions involving property
	            // names in Object.prototype
	            var classCounts = element.data('$classCounts') || createMap();
	            var classesToUpdate = [];
	            forEach(classes, function(className) {
	              if (count > 0 || classCounts[className]) {
	                classCounts[className] = (classCounts[className] || 0) + count;
	                if (classCounts[className] === +(count > 0)) {
	                  classesToUpdate.push(className);
	                }
	              }
	            });
	            element.data('$classCounts', classCounts);
	            return classesToUpdate.join(' ');
	          }
	
	          function updateClasses(oldClasses, newClasses) {
	            var toAdd = arrayDifference(newClasses, oldClasses);
	            var toRemove = arrayDifference(oldClasses, newClasses);
	            toAdd = digestClassCounts(toAdd, 1);
	            toRemove = digestClassCounts(toRemove, -1);
	            if (toAdd && toAdd.length) {
	              $animate.addClass(element, toAdd);
	            }
	            if (toRemove && toRemove.length) {
	              $animate.removeClass(element, toRemove);
	            }
	          }
	
	          function ngClassWatchAction(newVal) {
	            // jshint bitwise: false
	            if (selector === true || (scope.$index & 1) === selector) {
	              // jshint bitwise: true
	              var newClasses = arrayClasses(newVal || []);
	              if (!oldVal) {
	                addClasses(newClasses);
	              } else if (!equals(newVal,oldVal)) {
	                var oldClasses = arrayClasses(oldVal);
	                updateClasses(oldClasses, newClasses);
	              }
	            }
	            if (isArray(newVal)) {
	              oldVal = newVal.map(function(v) { return shallowCopy(v); });
	            } else {
	              oldVal = shallowCopy(newVal);
	            }
	          }
	        }
	      };
	
	      function arrayDifference(tokens1, tokens2) {
	        var values = [];
	
	        outer:
	          for (var i = 0; i < tokens1.length; i++) {
	            var token = tokens1[i];
	            for (var j = 0; j < tokens2.length; j++) {
	              if (token == tokens2[j]) continue outer;
	            }
	            values.push(token);
	          }
	        return values;
	      }
	
	      function arrayClasses(classVal) {
	        var classes = [];
	        if (isArray(classVal)) {
	          forEach(classVal, function(v) {
	            classes = classes.concat(arrayClasses(v));
	          });
	          return classes;
	        } else if (isString(classVal)) {
	          return classVal.split(' ');
	        } else if (isObject(classVal)) {
	          forEach(classVal, function(v, k) {
	            if (v) {
	              classes = classes.concat(k.split(' '));
	            }
	          });
	          return classes;
	        }
	        return classVal;
	      }
	    }];
	  }
	
	  /**
	   * @ngdoc directive
	   * @name ngClass
	   * @restrict AC
	   *
	   * @description
	   * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	   * an expression that represents all classes to be added.
	   *
	   * The directive operates in three different ways, depending on which of three types the expression
	   * evaluates to:
	   *
	   * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	   * names.
	   *
	   * 2. If the expression evaluates to an object, then for each key-value pair of the
	   * object with a truthy value the corresponding key is used as a class name.
	   *
	   * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	   * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	   * to give you more control over what CSS classes appear. See the code below for an example of this.
	   *
	   *
	   * The directive won't add duplicate classes if a particular class was already set.
	   *
	   * When the expression changes, the previously added classes are removed and only then are the
	   * new classes added.
	   *
	   * @animations
	   * | Animation                        | Occurs                              |
	   * |----------------------------------|-------------------------------------|
	   * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	   * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	   *
	   * @element ANY
	   * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	   *   of the evaluation can be a string representing space delimited class
	   *   names, an array, or a map of class names to boolean values. In the case of a map, the
	   *   names of the properties whose values are truthy will be added as css classes to the
	   *   element.
	   *
	   * @example Example that demonstrates basic bindings via ngClass directive.
	   <example>
	   <file name="index.html">
	   <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	   <label>
	   <input type="checkbox" ng-model="deleted">
	   deleted (apply "strike" class)
	   </label><br>
	   <label>
	   <input type="checkbox" ng-model="important">
	   important (apply "bold" class)
	   </label><br>
	   <label>
	   <input type="checkbox" ng-model="error">
	   error (apply "has-error" class)
	   </label>
	   <hr>
	   <p ng-class="style">Using String Syntax</p>
	   <input type="text" ng-model="style"
	   placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	   <hr>
	   <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	   <input ng-model="style1"
	   placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	   <input ng-model="style2"
	   placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	   <input ng-model="style3"
	   placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	   <hr>
	   <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	   <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	   <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	   </file>
	   <file name="style.css">
	   .strike {
	           text-decoration: line-through;
	       }
	   .bold {
	           font-weight: bold;
	       }
	   .red {
	           color: red;
	       }
	   .has-error {
	           color: red;
	           background-color: yellow;
	       }
	   .orange {
	           color: orange;
	       }
	   </file>
	   <file name="protractor.js" type="protractor">
	   var ps = element.all(by.css('p'));
	
	   it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	   it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	   it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	   it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	   </file>
	   </example>
	
	   ## Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true">
	   <file name="index.html">
	   <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	   <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	   <br>
	   <span class="base-class" ng-class="myVar">Sample Text</span>
	   </file>
	   <file name="style.css">
	   .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	   .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	   </file>
	   </example>
	
	
	   ## ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	   */
	  var ngClassDirective = classDirective('', true);
	
	  /**
	   * @ngdoc directive
	   * @name ngClassOdd
	   * @restrict AC
	   *
	   * @description
	   * The `ngClassOdd` and `ngClassEven` directives work exactly as
	   * {@link ng.directive:ngClass ngClass}, except they work in
	   * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	   *
	   * This directive can be applied only within the scope of an
	   * {@link ng.directive:ngRepeat ngRepeat}.
	   *
	   * @element ANY
	   * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	   *   of the evaluation can be a string representing space delimited class names or an array.
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	   <li ng-repeat="name in names">
	   <span ng-class-odd="'odd'" ng-class-even="'even'">
	   {{name}}
	   </span>
	   </li>
	   </ol>
	   </file>
	   <file name="style.css">
	   .odd {
	         color: red;
	       }
	   .even {
	         color: blue;
	       }
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	   </file>
	   </example>
	   */
	  var ngClassOddDirective = classDirective('Odd', 0);
	
	  /**
	   * @ngdoc directive
	   * @name ngClassEven
	   * @restrict AC
	   *
	   * @description
	   * The `ngClassOdd` and `ngClassEven` directives work exactly as
	   * {@link ng.directive:ngClass ngClass}, except they work in
	   * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	   *
	   * This directive can be applied only within the scope of an
	   * {@link ng.directive:ngRepeat ngRepeat}.
	   *
	   * @element ANY
	   * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	   *   result of the evaluation can be a string representing space delimited class names or an array.
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	   <li ng-repeat="name in names">
	   <span ng-class-odd="'odd'" ng-class-even="'even'">
	   {{name}} &nbsp; &nbsp; &nbsp;
	   </span>
	   </li>
	   </ol>
	   </file>
	   <file name="style.css">
	   .odd {
	         color: red;
	       }
	   .even {
	         color: blue;
	       }
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	   </file>
	   </example>
	   */
	  var ngClassEvenDirective = classDirective('Even', 1);
	
	  /**
	   * @ngdoc directive
	   * @name ngCloak
	   * @restrict AC
	   *
	   * @description
	   * The `ngCloak` directive is used to prevent the Angular html template from being briefly
	   * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	   * directive to avoid the undesirable flicker effect caused by the html template display.
	   *
	   * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	   * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	   * of the browser view.
	   *
	   * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	   * `angular.min.js`.
	   * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	   *
	   * ```css
	   * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	   * ```
	   *
	   * When this css rule is loaded by the browser, all html elements (including their children) that
	   * are tagged with the `ngCloak` directive are hidden. When Angular encounters this directive
	   * during the compilation of the template it deletes the `ngCloak` element attribute, making
	   * the compiled element visible.
	   *
	   * For the best result, the `angular.js` script must be loaded in the head section of the html
	   * document; alternatively, the css rule above must be included in the external stylesheet of the
	   * application.
	   *
	   * @element ANY
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <div id="template1" ng-cloak>{{ 'hello' }}</div>
	   <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	   </file>
	   </example>
	   *
	   */
	  var ngCloakDirective = ngDirective({
	    compile: function(element, attr) {
	      attr.$set('ngCloak', undefined);
	      element.removeClass('ng-cloak');
	    }
	  });
	
	  /**
	   * @ngdoc directive
	   * @name ngController
	   *
	   * @description
	   * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	   * supports the principles behind the Model-View-Controller design pattern.
	   *
	   * MVC components in angular:
	   *
	   * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	   *   are accessed through bindings.
	   * * View — The template (HTML with data bindings) that is rendered into the View.
	   * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	   *   logic behind the application to decorate the scope with functions and values
	   *
	   * Note that you can also attach controllers to the DOM by declaring it in a route definition
	   * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	   * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	   * and executed twice.
	   *
	   * @element ANY
	   * @scope
	   * @priority 500
	   * @param {expression} ngController Name of a constructor function registered with the current
	   * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	   * that on the current scope evaluates to a constructor function.
	   *
	   * The controller instance can be published into a scope property by specifying
	   * `ng-controller="as propertyName"`.
	   *
	   * If the current `$controllerProvider` is configured to use globals (via
	   * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
	   * also be the name of a globally accessible constructor function (not recommended).
	   *
	   * @example
	   * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	   * greeting are methods declared on the controller (see source tab). These methods can
	   * easily be called from the angular markup. Any changes to the data are automatically reflected
	   * in the View without the need for a manual update.
	   *
	   * Two different declaration styles are included below:
	   *
	   * * one binds methods and properties directly onto the controller using `this`:
	   * `ng-controller="SettingsController1 as settings"`
	   * * one injects `$scope` into the controller:
	   * `ng-controller="SettingsController2"`
	   *
	   * The second option is more common in the Angular community, and is generally used in boilerplates
	   * and in this guide. However, there are advantages to binding properties directly to the controller
	   * and avoiding scope.
	   *
	   * * Using `controller as` makes it obvious which controller you are accessing in the template when
	   * multiple controllers apply to an element.
	   * * If you are writing your controllers as classes you have easier access to the properties and
	   * methods, which will appear on the scope, from inside the controller code.
	   * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	   * inheritance masking primitives.
	   *
	   * This example demonstrates the `controller as` syntax.
	   *
	   * <example name="ngControllerAs" module="controllerAsExample">
	   *   <file name="index.html">
	   *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	   *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	   *      <button ng-click="settings.greet()">greet</button><br/>
	   *      Contact:
	   *      <ul>
	   *        <li ng-repeat="contact in settings.contacts">
	   *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	   *             <option>phone</option>
	   *             <option>email</option>
	   *          </select>
	   *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	   *          <button ng-click="settings.clearContact(contact)">clear</button>
	   *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	   *        </li>
	   *        <li><button ng-click="settings.addContact()">add</button></li>
	   *     </ul>
	   *    </div>
	   *   </file>
	   *   <file name="app.js">
	   *    angular.module('controllerAsExample', [])
	   *      .controller('SettingsController1', SettingsController1);
	   *
	   *    function SettingsController1() {
	 *      this.name = "John Smith";
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'} ];
	 *    }
	   *
	   *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	   *
	   *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	   *
	   *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	   *
	   *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	   *   </file>
	   *   <file name="protractor.js" type="protractor">
	   *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	   *   </file>
	   * </example>
	   *
	   * This example demonstrates the "attach to `$scope`" style of controller.
	   *
	   * <example name="ngController" module="controllerExample">
	   *  <file name="index.html">
	   *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	   *     <label>Name: <input type="text" ng-model="name"/></label>
	   *     <button ng-click="greet()">greet</button><br/>
	   *     Contact:
	   *     <ul>
	   *       <li ng-repeat="contact in contacts">
	   *         <select ng-model="contact.type" id="select_{{$index}}">
	   *            <option>phone</option>
	   *            <option>email</option>
	   *         </select>
	   *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	   *         <button ng-click="clearContact(contact)">clear</button>
	   *         <button ng-click="removeContact(contact)">X</button>
	   *       </li>
	   *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	   *    </ul>
	   *   </div>
	   *  </file>
	   *  <file name="app.js">
	   *   angular.module('controllerExample', [])
	   *     .controller('SettingsController2', ['$scope', SettingsController2]);
	   *
	   *   function SettingsController2($scope) {
	 *     $scope.name = "John Smith";
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'} ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	   *  </file>
	   *  <file name="protractor.js" type="protractor">
	   *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	   *  </file>
	   *</example>
	
	   */
	  var ngControllerDirective = [function() {
	    return {
	      restrict: 'A',
	      scope: true,
	      controller: '@',
	      priority: 500
	    };
	  }];
	
	  /**
	   * @ngdoc directive
	   * @name ngCsp
	   *
	   * @element html
	   * @description
	   *
	   * Angular has some features that can break certain
	   * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	   *
	   * If you intend to implement these rules then you must tell Angular not to use these features.
	   *
	   * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	   *
	   *
	   * The following rules affect Angular:
	   *
	   * * `unsafe-eval`: this rule forbids apps to use `eval` or `Function(string)` generated functions
	   * (among other things). Angular makes use of this in the {@link $parse} service to provide a 30%
	   * increase in the speed of evaluating Angular expressions.
	   *
	   * * `unsafe-inline`: this rule forbids apps from inject custom styles into the document. Angular
	   * makes use of this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}).
	   * To make these directives work when a CSP rule is blocking inline styles, you must link to the
	   * `angular-csp.css` in your HTML manually.
	   *
	   * If you do not provide `ngCsp` then Angular tries to autodetect if CSP is blocking unsafe-eval
	   * and automatically deactivates this feature in the {@link $parse} service. This autodetection,
	   * however, triggers a CSP error to be logged in the console:
	   *
	   * ```
	   * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	   * script in the following Content Security Policy directive: "default-src 'self'". Note that
	   * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	   * ```
	   *
	   * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	   * directive on an element of the HTML document that appears before the `<script>` tag that loads
	   * the `angular.js` file.
	   *
	   * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	   *
	   * You can specify which of the CSP related Angular features should be deactivated by providing
	   * a value for the `ng-csp` attribute. The options are as follows:
	   *
	   * * no-inline-style: this stops Angular from injecting CSS styles into the DOM
	   *
	   * * no-unsafe-eval: this stops Angular from optimizing $parse with unsafe eval of strings
	   *
	   * You can use these values in the following combinations:
	   *
	   *
	   * * No declaration means that Angular will assume that you can do inline styles, but it will do
	   * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous versions
	   * of Angular.
	   *
	   * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell Angular to deactivate both inline
	   * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous versions
	   * of Angular.
	   *
	   * * Specifying only `no-unsafe-eval` tells Angular that we must not use eval, but that we can inject
	   * inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	   *
	   * * Specifying only `no-inline-style` tells Angular that we must not inject styles, but that we can
	   * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	   *
	   * * Specifying both `no-unsafe-eval` and `no-inline-style` tells Angular that we must not inject
	   * styles nor use eval, which is the same as an empty: ng-csp.
	   * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	   *
	   * @example
	   * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	   <!doctype html>
	   <html ng-app ng-csp>
	   ...
	   ...
	   </html>
	   ```
	   * @example
	   // Note: the suffix `.csp` in the example name triggers
	   // csp mode in our http server!
	   <example name="example.csp" module="cspExample" ng-csp="true">
	   <file name="index.html">
	   <div ng-controller="MainController as ctrl">
	   <div>
	   <button ng-click="ctrl.inc()" id="inc">Increment</button>
	   <span id="counter">
	   {{ctrl.counter}}
	   </span>
	   </div>
	
	   <div>
	   <button ng-click="ctrl.evil()" id="evil">Evil</button>
	   <span id="evilError">
	   {{ctrl.evilError}}
	   </span>
	   </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('cspExample', [])
	   .controller('MainController', function() {
	                this.counter = 0;
	                this.inc = function() {
	                  this.counter++;
	                };
	                this.evil = function() {
	                  // jshint evil:true
	                  try {
	                    eval('1+2');
	                  } catch (e) {
	                    this.evilError = e.message;
	                  }
	                };
	              });
	   </file>
	   <file name="protractor.js" type="protractor">
	   var util, webdriver;
	
	   var incBtn = element(by.id('inc'));
	   var counter = element(by.id('counter'));
	   var evilBtn = element(by.id('evil'));
	   var evilError = element(by.id('evilError'));
	
	   function getAndClearSevereErrors() {
	            return browser.manage().logs().get('browser').then(function(browserLog) {
	              return browserLog.filter(function(logEntry) {
	                return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	              });
	            });
	          }
	
	   function clearErrors() {
	            getAndClearSevereErrors();
	          }
	
	   function expectNoErrors() {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              expect(filteredLog.length).toEqual(0);
	              if (filteredLog.length) {
	                console.log('browser console errors: ' + util.inspect(filteredLog));
	              }
	            });
	          }
	
	   function expectError(regex) {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              var found = false;
	              filteredLog.forEach(function(log) {
	                if (log.message.match(regex)) {
	                  found = true;
	                }
	              });
	              if (!found) {
	                throw new Error('expected an error that matches ' + regex);
	              }
	            });
	          }
	
	   beforeEach(function() {
	            util = require('util');
	            webdriver = require('protractor/node_modules/selenium-webdriver');
	          });
	
	   // For now, we only test on Chrome,
	   // as Safari does not load the page with Protractor's injected scripts,
	   // and Firefox webdriver always disables content security policy (#6358)
	   if (browser.params.browser !== 'chrome') {
	            return;
	          }
	
	   it('should not report errors when the page is loaded', function() {
	            // clear errors so we are not dependent on previous tests
	            clearErrors();
	            // Need to reload the page as the page is already loaded when
	            // we come here
	            browser.driver.getCurrentUrl().then(function(url) {
	              browser.get(url);
	            });
	            expectNoErrors();
	          });
	
	   it('should evaluate expressions', function() {
	            expect(counter.getText()).toEqual('0');
	            incBtn.click();
	            expect(counter.getText()).toEqual('1');
	            expectNoErrors();
	          });
	
	   it('should throw and report an error when using "eval"', function() {
	            evilBtn.click();
	            expect(evilError.getText()).toMatch(/Content Security Policy/);
	            expectError(/Content Security Policy/);
	          });
	   </file>
	   </example>
	   */
	
	// ngCsp is not implemented as a proper directive any more, because we need it be processed while we
	// bootstrap the system (before $parse is instantiated), for this reason we just have
	// the csp() fn that looks for the `ng-csp` attribute anywhere in the current doc
	
	  /**
	   * @ngdoc directive
	   * @name ngClick
	   *
	   * @description
	   * The ngClick directive allows you to specify custom behavior when
	   * an element is clicked.
	   *
	   * @element ANY
	   * @priority 0
	   * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	   * click. ({@link guide/expression#-event- Event object is available as `$event`})
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <button ng-click="count = count + 1" ng-init="count=0">
	   Increment
	   </button>
	   <span>
	   count: {{count}}
	   </span>
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	   </file>
	   </example>
	   */
	  /*
	   * A collection of directives that allows creation of custom event handlers that are defined as
	   * angular expressions and are compiled and executed within the current scope.
	   */
	  var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	  var forceAsyncEvents = {
	    'blur': true,
	    'focus': true
	  };
	  forEach(
	    'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	    function(eventName) {
	      var directiveName = directiveNormalize('ng-' + eventName);
	      ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
	        return {
	          restrict: 'A',
	          compile: function($element, attr) {
	            // We expose the powerful $event object on the scope that provides access to the Window,
	            // etc. that isn't protected by the fast paths in $parse.  We explicitly request better
	            // checks at the cost of speed since event handler expressions are not executed as
	            // frequently as regular change detection.
	            var fn = $parse(attr[directiveName], /* interceptorFn */ null, /* expensiveChecks */ true);
	            return function ngEventHandler(scope, element) {
	              element.on(eventName, function(event) {
	                var callback = function() {
	                  fn(scope, {$event:event});
	                };
	                if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
	                  scope.$evalAsync(callback);
	                } else {
	                  scope.$apply(callback);
	                }
	              });
	            };
	          }
	        };
	      }];
	    }
	  );
	
	  /**
	   * @ngdoc directive
	   * @name ngDblclick
	   *
	   * @description
	   * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	   *
	   * @element ANY
	   * @priority 0
	   * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	   * a dblclick. (The Event object is available as `$event`)
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <button ng-dblclick="count = count + 1" ng-init="count=0">
	   Increment (on double click)
	   </button>
	   count: {{count}}
	   </file>
	   </example>
	   */
	
	
	  /**
	   * @ngdoc directive
	   * @name ngMousedown
	   *
	   * @description
	   * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	   *
	   * @element ANY
	   * @priority 0
	   * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	   * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <button ng-mousedown="count = count + 1" ng-init="count=0">
	   Increment (on mouse down)
	   </button>
	   count: {{count}}
	   </file>
	   </example>
	   */
	
	
	  /**
	   * @ngdoc directive
	   * @name ngMouseup
	   *
	   * @description
	   * Specify custom behavior on mouseup event.
	   *
	   * @element ANY
	   * @priority 0
	   * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	   * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <button ng-mouseup="count = count + 1" ng-init="count=0">
	   Increment (on mouse up)
	   </button>
	   count: {{count}}
	   </file>
	   </example>
	   */
	
	  /**
	   * @ngdoc directive
	   * @name ngMouseover
	   *
	   * @description
	   * Specify custom behavior on mouseover event.
	   *
	   * @element ANY
	   * @priority 0
	   * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	   * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <button ng-mouseover="count = count + 1" ng-init="count=0">
	   Increment (when mouse is over)
	   </button>
	   count: {{count}}
	   </file>
	   </example>
	   */
	
	
	  /**
	   * @ngdoc directive
	   * @name ngMouseenter
	   *
	   * @description
	   * Specify custom behavior on mouseenter event.
	   *
	   * @element ANY
	   * @priority 0
	   * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	   * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <button ng-mouseenter="count = count + 1" ng-init="count=0">
	   Increment (when mouse enters)
	   </button>
	   count: {{count}}
	   </file>
	   </example>
	   */
	
	
	  /**
	   * @ngdoc directive
	   * @name ngMouseleave
	   *
	   * @description
	   * Specify custom behavior on mouseleave event.
	   *
	   * @element ANY
	   * @priority 0
	   * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	   * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <button ng-mouseleave="count = count + 1" ng-init="count=0">
	   Increment (when mouse leaves)
	   </button>
	   count: {{count}}
	   </file>
	   </example>
	   */
	
	
	  /**
	   * @ngdoc directive
	   * @name ngMousemove
	   *
	   * @description
	   * Specify custom behavior on mousemove event.
	   *
	   * @element ANY
	   * @priority 0
	   * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	   * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <button ng-mousemove="count = count + 1" ng-init="count=0">
	   Increment (when mouse moves)
	   </button>
	   count: {{count}}
	   </file>
	   </example>
	   */
	
	
	  /**
	   * @ngdoc directive
	   * @name ngKeydown
	   *
	   * @description
	   * Specify custom behavior on keydown event.
	   *
	   * @element ANY
	   * @priority 0
	   * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	   * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <input ng-keydown="count = count + 1" ng-init="count=0">
	   key down count: {{count}}
	   </file>
	   </example>
	   */
	
	
	  /**
	   * @ngdoc directive
	   * @name ngKeyup
	   *
	   * @description
	   * Specify custom behavior on keyup event.
	   *
	   * @element ANY
	   * @priority 0
	   * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	   * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <p>Typing in the input box below updates the key count</p>
	   <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	   <p>Typing in the input box below updates the keycode</p>
	   <input ng-keyup="event=$event">
	   <p>event keyCode: {{ event.keyCode }}</p>
	   <p>event altKey: {{ event.altKey }}</p>
	   </file>
	   </example>
	   */
	
	
	  /**
	   * @ngdoc directive
	   * @name ngKeypress
	   *
	   * @description
	   * Specify custom behavior on keypress event.
	   *
	   * @element ANY
	   * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	   * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	   * and can be interrogated for keyCode, altKey, etc.)
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <input ng-keypress="count = count + 1" ng-init="count=0">
	   key press count: {{count}}
	   </file>
	   </example>
	   */
	
	
	  /**
	   * @ngdoc directive
	   * @name ngSubmit
	   *
	   * @description
	   * Enables binding angular expressions to onsubmit events.
	   *
	   * Additionally it prevents the default action (which for form means sending the request to the
	   * server and reloading the current page), but only if the form does not contain `action`,
	   * `data-action`, or `x-action` attributes.
	   *
	   * <div class="alert alert-warning">
	   * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	   * `ngSubmit` handlers together. See the
	   * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	   * for a detailed discussion of when `ngSubmit` may be triggered.
	   * </div>
	   *
	   * @element form
	   * @priority 0
	   * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	   * ({@link guide/expression#-event- Event object is available as `$event`})
	   *
	   * @example
	   <example module="submitExample">
	   <file name="index.html">
	   <script>
	   angular.module('submitExample', [])
	   .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	   </script>
	   <form ng-submit="submit()" ng-controller="ExampleController">
	   Enter text and hit enter:
	   <input type="text" ng-model="text" name="text" />
	   <input type="submit" id="submit" value="Submit" />
	   <pre>list={{list}}</pre>
	   </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	   it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	   </file>
	   </example>
	   */
	
	  /**
	   * @ngdoc directive
	   * @name ngFocus
	   *
	   * @description
	   * Specify custom behavior on focus event.
	   *
	   * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	   * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	   * during an `$apply` to ensure a consistent state.
	   *
	   * @element window, input, select, textarea, a
	   * @priority 0
	   * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	   * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	   *
	   * @example
	   * See {@link ng.directive:ngClick ngClick}
	   */
	
	  /**
	   * @ngdoc directive
	   * @name ngBlur
	   *
	   * @description
	   * Specify custom behavior on blur event.
	   *
	   * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	   * an element has lost focus.
	   *
	   * Note: As the `blur` event is executed synchronously also during DOM manipulations
	   * (e.g. removing a focussed input),
	   * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	   * during an `$apply` to ensure a consistent state.
	   *
	   * @element window, input, select, textarea, a
	   * @priority 0
	   * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	   * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	   *
	   * @example
	   * See {@link ng.directive:ngClick ngClick}
	   */
	
	  /**
	   * @ngdoc directive
	   * @name ngCopy
	   *
	   * @description
	   * Specify custom behavior on copy event.
	   *
	   * @element window, input, select, textarea, a
	   * @priority 0
	   * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	   * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	   copied: {{copied}}
	   </file>
	   </example>
	   */
	
	  /**
	   * @ngdoc directive
	   * @name ngCut
	   *
	   * @description
	   * Specify custom behavior on cut event.
	   *
	   * @element window, input, select, textarea, a
	   * @priority 0
	   * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	   * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	   cut: {{cut}}
	   </file>
	   </example>
	   */
	
	  /**
	   * @ngdoc directive
	   * @name ngPaste
	   *
	   * @description
	   * Specify custom behavior on paste event.
	   *
	   * @element window, input, select, textarea, a
	   * @priority 0
	   * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	   * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	   pasted: {{paste}}
	   </file>
	   </example>
	   */
	
	  /**
	   * @ngdoc directive
	   * @name ngIf
	   * @restrict A
	   * @multiElement
	   *
	   * @description
	   * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	   * {expression}. If the expression assigned to `ngIf` evaluates to a false
	   * value then the element is removed from the DOM, otherwise a clone of the
	   * element is reinserted into the DOM.
	   *
	   * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	   * element in the DOM rather than changing its visibility via the `display` css property.  A common
	   * case when this difference is significant is when using css selectors that rely on an element's
	   * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	   *
	   * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	   * is created when the element is restored.  The scope created within `ngIf` inherits from
	   * its parent scope using
	   * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	   * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	   * a javascript primitive defined in the parent scope. In this case any modifications made to the
	   * variable within the child scope will override (hide) the value in the parent scope.
	   *
	   * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	   * is if an element's class attribute is directly modified after it's compiled, using something like
	   * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	   * the added class will be lost because the original compiled state is used to regenerate the element.
	   *
	   * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	   * and `leave` effects.
	   *
	   * @animations
	   * | Animation                        | Occurs                               |
	   * |----------------------------------|-------------------------------------|
	   * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	   * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	   *
	   * @element ANY
	   * @scope
	   * @priority 600
	   * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	   *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	   *     element is added to the DOM tree.
	   *
	   * @example
	   <example module="ngAnimate" deps="angular-animate.js" animations="true">
	   <file name="index.html">
	   <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	   Show when checked:
	   <span ng-if="checked" class="animate-if">
	   This is removed when the checkbox is unchecked.
	   </span>
	   </file>
	   <file name="animations.css">
	   .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	   .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	   .animate-if.ng-enter,
	   .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	   .animate-if.ng-leave,
	   .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	   </file>
	   </example>
	   */
	  var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
	    return {
	      multiElement: true,
	      transclude: 'element',
	      priority: 600,
	      terminal: true,
	      restrict: 'A',
	      $$tlb: true,
	      link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).then(function() {
	                previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	      }
	    };
	  }];
	
	  /**
	   * @ngdoc directive
	   * @name ngInclude
	   * @restrict ECA
	   *
	   * @description
	   * Fetches, compiles and includes an external HTML fragment.
	   *
	   * By default, the template URL is restricted to the same domain and protocol as the
	   * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	   * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
	   * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to Angular's {@link
	    * ng.$sce Strict Contextual Escaping}.
	   *
	   * In addition, the browser's
	   * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	   * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	   * policy may further restrict whether the template is successfully loaded.
	   * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	   * access on some browsers.
	   *
	   * @animations
	   * | Animation                        | Occurs                              |
	   * |----------------------------------|-------------------------------------|
	   * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	   * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	   *
	   * The enter and leave animation occur concurrently.
	   *
	   * @scope
	   * @priority 400
	   *
	   * @param {string} ngInclude|src angular expression evaluating to URL. If the source is a string constant,
	   *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	   * @param {string=} onload Expression to evaluate when a new partial is loaded.
	   *                  <div class="alert alert-warning">
	   *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	   *                  a function with the name on the window element, which will usually throw a
	   *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	   *                  different form that {@link guide/directive#normalization matches} `onload`.
	   *                  </div>
	   *
	   * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	   *
	   *                  - If the attribute is not set, disable scrolling.
	   *                  - If the attribute is set without value, enable scrolling.
	   *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	   *
	   * @example
	   <example module="includeExample" deps="angular-animate.js" animations="true">
	   <file name="index.html">
	   <div ng-controller="ExampleController">
	   <select ng-model="template" ng-options="t.name for t in templates">
	   <option value="">(blank)</option>
	   </select>
	   url of the template: <code>{{template.url}}</code>
	   <hr/>
	   <div class="slide-animate-container">
	   <div class="slide-animate" ng-include="template.url"></div>
	   </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('includeExample', ['ngAnimate'])
	   .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [ { name: 'template1.html', url: 'template1.html'},
	              { name: 'template2.html', url: 'template2.html'} ];
	          $scope.template = $scope.templates[0];
	        }]);
	   </file>
	   <file name="template1.html">
	   Content of template1.html
	   </file>
	   <file name="template2.html">
	   Content of template2.html
	   </file>
	   <file name="animations.css">
	   .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	   .slide-animate {
	        padding:10px;
	      }
	
	   .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	   .slide-animate.ng-enter {
	        top:-50px;
	      }
	   .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	   .slide-animate.ng-leave {
	        top:0;
	      }
	   .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	   </file>
	   <file name="protractor.js" type="protractor">
	   var templateSelect = element(by.model('template'));
	   var includeElem = element(by.css('[ng-include]'));
	
	   it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	   it('should load template2.html', function() {
	        if (browser.params.browser == 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	   it('should change to blank', function() {
	        if (browser.params.browser == 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	   </file>
	   </example>
	   */
	
	
	  /**
	   * @ngdoc event
	   * @name ngInclude#$includeContentRequested
	   * @eventType emit on the scope ngInclude was declared in
	   * @description
	   * Emitted every time the ngInclude content is requested.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {String} src URL of content to load.
	   */
	
	
	  /**
	   * @ngdoc event
	   * @name ngInclude#$includeContentLoaded
	   * @eventType emit on the current ngInclude scope
	   * @description
	   * Emitted every time the ngInclude content is reloaded.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {String} src URL of content to load.
	   */
	
	
	  /**
	   * @ngdoc event
	   * @name ngInclude#$includeContentError
	   * @eventType emit on the scope ngInclude was declared in
	   * @description
	   * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {String} src URL of content to load.
	   */
	  var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	    function($templateRequest,   $anchorScroll,   $animate) {
	      return {
	        restrict: 'ECA',
	        priority: 400,
	        terminal: true,
	        transclude: 'element',
	        controller: angular.noop,
	        compile: function(element, attr) {
	          var srcExp = attr.ngInclude || attr.src,
	            onloadExp = attr.onload || '',
	            autoScrollExp = attr.autoscroll;
	
	          return function(scope, $element, $attr, ctrl, $transclude) {
	            var changeCounter = 0,
	              currentScope,
	              previousElement,
	              currentElement;
	
	            var cleanupLastIncludeContent = function() {
	              if (previousElement) {
	                previousElement.remove();
	                previousElement = null;
	              }
	              if (currentScope) {
	                currentScope.$destroy();
	                currentScope = null;
	              }
	              if (currentElement) {
	                $animate.leave(currentElement).then(function() {
	                  previousElement = null;
	                });
	                previousElement = currentElement;
	                currentElement = null;
	              }
	            };
	
	            scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	              var afterAnimation = function() {
	                if (isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                  $anchorScroll();
	                }
	              };
	              var thisChangeId = ++changeCounter;
	
	              if (src) {
	                //set the 2nd param to true to ignore the template request error so that the inner
	                //contents and scope can be cleaned up.
	                $templateRequest(src, true).then(function(response) {
	                  if (scope.$$destroyed) return;
	
	                  if (thisChangeId !== changeCounter) return;
	                  var newScope = scope.$new();
	                  ctrl.template = response;
	
	                  // Note: This will also link all children of ng-include that were contained in the original
	                  // html. If that content contains controllers, ... they could pollute/change the scope.
	                  // However, using ng-include on an element with additional content does not make sense...
	                  // Note: We can't remove them in the cloneAttchFn of $transclude as that
	                  // function is called before linking the content, which would apply child
	                  // directives to non existing elements.
	                  var clone = $transclude(newScope, function(clone) {
	                    cleanupLastIncludeContent();
	                    $animate.enter(clone, null, $element).then(afterAnimation);
	                  });
	
	                  currentScope = newScope;
	                  currentElement = clone;
	
	                  currentScope.$emit('$includeContentLoaded', src);
	                  scope.$eval(onloadExp);
	                }, function() {
	                  if (scope.$$destroyed) return;
	
	                  if (thisChangeId === changeCounter) {
	                    cleanupLastIncludeContent();
	                    scope.$emit('$includeContentError', src);
	                  }
	                });
	                scope.$emit('$includeContentRequested', src);
	              } else {
	                cleanupLastIncludeContent();
	                ctrl.template = null;
	              }
	            });
	          };
	        }
	      };
	    }];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	  var ngIncludeFillContentDirective = ['$compile',
	    function($compile) {
	      return {
	        restrict: 'ECA',
	        priority: -400,
	        require: 'ngInclude',
	        link: function(scope, $element, $attr, ctrl) {
	          if (toString.call($element[0]).match(/SVG/)) {
	            // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	            // support innerHTML, so detect this here and try to generate the contents
	            // specially.
	            $element.empty();
	            $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	                $element.append(clone);
	              }, {futureParentElement: $element});
	            return;
	          }
	
	          $element.html(ctrl.template);
	          $compile($element.contents())(scope);
	        }
	      };
	    }];
	
	  /**
	   * @ngdoc directive
	   * @name ngInit
	   * @restrict AC
	   *
	   * @description
	   * The `ngInit` directive allows you to evaluate an expression in the
	   * current scope.
	   *
	   * <div class="alert alert-danger">
	   * This directive can be abused to add unnecessary amounts of logic into your templates.
	   * There are only a few appropriate uses of `ngInit`, such as for aliasing special properties of
	   * {@link ng.directive:ngRepeat `ngRepeat`}, as seen in the demo below; and for injecting data via
	   * server side scripting. Besides these few cases, you should use {@link guide/controller controllers}
	   * rather than `ngInit` to initialize values on a scope.
	   * </div>
	   *
	   * <div class="alert alert-warning">
	   * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	   * sure you have parentheses to ensure correct operator precedence:
	   * <pre class="prettyprint">
	   * `<div ng-init="test1 = ($index | toString)"></div>`
	   * </pre>
	   * </div>
	   *
	   * @priority 450
	   *
	   * @element ANY
	   * @param {expression} ngInit {@link guide/expression Expression} to eval.
	   *
	   * @example
	   <example module="initExample">
	   <file name="index.html">
	   <script>
	   angular.module('initExample', [])
	   .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	   <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	   <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	   <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	   </div>
	   </div>
	   </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	   </file>
	   </example>
	   */
	  var ngInitDirective = ngDirective({
	    priority: 450,
	    compile: function() {
	      return {
	        pre: function(scope, element, attrs) {
	          scope.$eval(attrs.ngInit);
	        }
	      };
	    }
	  });
	
	  /**
	   * @ngdoc directive
	   * @name ngList
	   *
	   * @description
	   * Text input that converts between a delimited string and an array of strings. The default
	   * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	   * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	   *
	   * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	   * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	   *   list item is respected. This implies that the user of the directive is responsible for
	   *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	   *   tab or newline character.
	   * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	   *   when joining the list items back together) and whitespace around each list item is stripped
	   *   before it is added to the model.
	   *
	   * ### Example with Validation
	   *
	   * <example name="ngList-directive" module="listExample">
	   *   <file name="app.js">
	   *      angular.module('listExample', [])
	   *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	   *   </file>
	   *   <file name="index.html">
	   *    <form name="myForm" ng-controller="ExampleController">
	   *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	   *      <span role="alert">
	   *        <span class="error" ng-show="myForm.namesInput.$error.required">
	   *        Required!</span>
	   *      </span>
	   *      <br>
	   *      <tt>names = {{names}}</tt><br/>
	   *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	   *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	   *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	   *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	   *     </form>
	   *   </file>
	   *   <file name="protractor.js" type="protractor">
	   *     var listInput = element(by.model('names'));
	   *     var names = element(by.exactBinding('names'));
	   *     var valid = element(by.binding('myForm.namesInput.$valid'));
	   *     var error = element(by.css('span.error'));
	   *
	   *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	   *
	   *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	   *   </file>
	   * </example>
	   *
	   * ### Example - splitting on newline
	   * <example name="ngList-directive-newlines">
	   *   <file name="index.html">
	   *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	   *    <pre>{{ list | json }}</pre>
	   *   </file>
	   *   <file name="protractor.js" type="protractor">
	   *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	   *   </file>
	   * </example>
	   *
	   * @element input
	   * @param {string=} ngList optional delimiter that should be used to split the value.
	   */
	  var ngListDirective = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      require: 'ngModel',
	      link: function(scope, element, attr, ctrl) {
	        // We want to control whitespace trimming so we use this convoluted approach
	        // to access the ngList attribute, which doesn't pre-trim the attribute
	        var ngList = element.attr(attr.$attr.ngList) || ', ';
	        var trimValues = attr.ngTrim !== 'false';
	        var separator = trimValues ? trim(ngList) : ngList;
	
	        var parse = function(viewValue) {
	          // If the viewValue is invalid (say required but empty) it will be `undefined`
	          if (isUndefined(viewValue)) return;
	
	          var list = [];
	
	          if (viewValue) {
	            forEach(viewValue.split(separator), function(value) {
	              if (value) list.push(trimValues ? trim(value) : value);
	            });
	          }
	
	          return list;
	        };
	
	        ctrl.$parsers.push(parse);
	        ctrl.$formatters.push(function(value) {
	          if (isArray(value)) {
	            return value.join(ngList);
	          }
	
	          return undefined;
	        });
	
	        // Override the standard $isEmpty because an empty array means the input is empty.
	        ctrl.$isEmpty = function(value) {
	          return !value || !value.length;
	        };
	      }
	    };
	  };
	
	  /* global VALID_CLASS: true,
	   INVALID_CLASS: true,
	   PRISTINE_CLASS: true,
	   DIRTY_CLASS: true,
	   UNTOUCHED_CLASS: true,
	   TOUCHED_CLASS: true,
	   */
	
	  var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    PENDING_CLASS = 'ng-pending',
	    EMPTY_CLASS = 'ng-empty',
	    NOT_EMPTY_CLASS = 'ng-not-empty';
	
	  var ngModelMinErr = minErr('ngModel');
	
	  /**
	   * @ngdoc type
	   * @name ngModel.NgModelController
	   *
	   * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	   * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	   * is set.
	   * @property {*} $modelValue The value in the model that the control is bound to.
	   * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	   the control reads value from the DOM. The functions are called in array order, each passing
	   its return value through to the next. The last return value is forwarded to the
	   {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	   Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	`$viewValue`}.
	
	   Returning `undefined` from a parser means a parse error occurred. In that case,
	   no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	   will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	   is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	   *
	   * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	   the model value changes. The functions are called in reverse array order, each passing the value through to the
	   next. The last return value is used as the actual DOM value.
	   Used to format / convert values for display in the control.
	   * ```js
	   * function formatter(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	   * ngModel.$formatters.push(formatter);
	   * ```
	   *
	   * @property {Object.<string, function>} $validators A collection of validators that are applied
	   *      whenever the model value changes. The key value within the object refers to the name of the
	   *      validator while the function refers to the validation operation. The validation operation is
	   *      provided with the model value as an argument and must return a true or false value depending
	   *      on the response of that validation.
	   *
	   * ```js
	   * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	   * ```
	   *
	   * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	   *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	   *      is expected to return a promise when it is run during the model validation process. Once the promise
	   *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	   *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	   *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	   *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	   *      will only run once all synchronous validators have passed.
	   *
	   * Please note that if $http is used then it is important that the server returns a success HTTP response code
	   * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	   *
	   * ```js
	   * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	   * ```
	   *
	   * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever the
	   *     view value has changed. It is called with no arguments, and its return value is ignored.
	   *     This can be used in place of additional $watches against the model value.
	   *
	   * @property {Object} $error An object hash with all failing validator ids as keys.
	   * @property {Object} $pending An object hash with all pending validator ids as keys.
	   *
	   * @property {boolean} $untouched True if control has not lost focus yet.
	   * @property {boolean} $touched True if control has lost focus.
	   * @property {boolean} $pristine True if user has not interacted with the control yet.
	   * @property {boolean} $dirty True if user has already interacted with the control.
	   * @property {boolean} $valid True if there is no error.
	   * @property {boolean} $invalid True if at least one error on the control.
	   * @property {string} $name The name attribute of the control.
	   *
	   * @description
	   *
	   * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	   * The controller contains services for data-binding, validation, CSS updates, and value formatting
	   * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	   * listening to DOM events.
	   * Such DOM related logic should be provided by other directives which make use of
	   * `NgModelController` for data-binding to control elements.
	   * Angular provides this DOM logic for most {@link input `input`} elements.
	   * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	   *
	   * @example
	   * ### Custom Control Example
	   * This example shows how to use `NgModelController` with a custom control to achieve
	   * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	   * collaborate together to achieve the desired result.
	   *
	   * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	   * contents be edited in place by the user.
	   *
	   * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	   * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	   * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	   * that content using the `$sce` service.
	   *
	   * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	   <file name="style.css">
	   [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	   .ng-invalid {
	        border: 1px solid red;
	      }
	
	   </file>
	   <file name="script.js">
	   angular.module('customControl', ['ngSanitize']).
	   directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if ( attrs.stripBr && html == '<br>' ) {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	   </file>
	   <file name="index.html">
	   <form name="myForm">
	   <div contenteditable
	   name="myWidget" ng-model="userContent"
	   strip-br="true"
	   required>Change me!</div>
	   <span ng-show="myForm.myWidget.$error.required">Required!</span>
	   <hr>
	   <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	   </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should data-bind and become invalid', function() {
	      if (browser.params.browser == 'safari' || browser.params.browser == 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	   </file>
	   * </example>
	   *
	   *
	   */
	  var NgModelController = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$rootScope', '$q', '$interpolate',
	    function($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $rootScope, $q, $interpolate) {
	      this.$viewValue = Number.NaN;
	      this.$modelValue = Number.NaN;
	      this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	      this.$validators = {};
	      this.$asyncValidators = {};
	      this.$parsers = [];
	      this.$formatters = [];
	      this.$viewChangeListeners = [];
	      this.$untouched = true;
	      this.$touched = false;
	      this.$pristine = true;
	      this.$dirty = false;
	      this.$valid = true;
	      this.$invalid = false;
	      this.$error = {}; // keep invalid keys here
	      this.$$success = {}; // keep valid keys here
	      this.$pending = undefined; // keep pending keys here
	      this.$name = $interpolate($attr.name || '', false)($scope);
	      this.$$parentForm = nullFormCtrl;
	
	      var parsedNgModel = $parse($attr.ngModel),
	        parsedNgModelAssign = parsedNgModel.assign,
	        ngModelGet = parsedNgModel,
	        ngModelSet = parsedNgModelAssign,
	        pendingDebounce = null,
	        parserValid,
	        ctrl = this;
	
	      this.$$setOptions = function(options) {
	        ctrl.$options = options;
	        if (options && options.getterSetter) {
	          var invokeModelGetter = $parse($attr.ngModel + '()'),
	            invokeModelSetter = $parse($attr.ngModel + '($$$p)');
	
	          ngModelGet = function($scope) {
	            var modelValue = parsedNgModel($scope);
	            if (isFunction(modelValue)) {
	              modelValue = invokeModelGetter($scope);
	            }
	            return modelValue;
	          };
	          ngModelSet = function($scope, newValue) {
	            if (isFunction(parsedNgModel($scope))) {
	              invokeModelSetter($scope, {$$$p: newValue});
	            } else {
	              parsedNgModelAssign($scope, newValue);
	            }
	          };
	        } else if (!parsedNgModel.assign) {
	          throw ngModelMinErr('nonassign', "Expression '{0}' is non-assignable. Element: {1}",
	            $attr.ngModel, startingTag($element));
	        }
	      };
	
	      /**
	       * @ngdoc method
	       * @name ngModel.NgModelController#$render
	       *
	       * @description
	       * Called when the view needs to be updated. It is expected that the user of the ng-model
	       * directive will implement this method.
	       *
	       * The `$render()` method is invoked in the following situations:
	       *
	       * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	       *   committed value then `$render()` is called to update the input control.
	       * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	       *   the `$viewValue` are different from last time.
	       *
	       * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	       * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	       * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	       * invoked if you only change a property on the objects.
	       */
	      this.$render = noop;
	
	      /**
	       * @ngdoc method
	       * @name ngModel.NgModelController#$isEmpty
	       *
	       * @description
	       * This is called when we need to determine if the value of an input is empty.
	       *
	       * For instance, the required directive does this to work out if the input has data or not.
	       *
	       * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	       *
	       * You can override this for input directives whose concept of being empty is different from the
	       * default. The `checkboxInputType` directive does this because in its case a value of `false`
	       * implies empty.
	       *
	       * @param {*} value The value of the input to check for emptiness.
	       * @returns {boolean} True if `value` is "empty".
	       */
	      this.$isEmpty = function(value) {
	        return isUndefined(value) || value === '' || value === null || value !== value;
	      };
	
	      this.$$updateEmptyClasses = function(value) {
	        if (ctrl.$isEmpty(value)) {
	          $animate.removeClass($element, NOT_EMPTY_CLASS);
	          $animate.addClass($element, EMPTY_CLASS);
	        } else {
	          $animate.removeClass($element, EMPTY_CLASS);
	          $animate.addClass($element, NOT_EMPTY_CLASS);
	        }
	      };
	
	
	      var currentValidationRunId = 0;
	
	      /**
	       * @ngdoc method
	       * @name ngModel.NgModelController#$setValidity
	       *
	       * @description
	       * Change the validity state, and notify the form.
	       *
	       * This method can be called within $parsers/$formatters or a custom validation implementation.
	       * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	       * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	       *
	       * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	       *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	       *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	       *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	       *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	       *        class and can be bound to as  `{{someForm.someControl.$error.myError}}` .
	       * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	       *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	       *                          Skipped is used by Angular when validators do not run because of parse errors and
	       *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	       */
	      addSetValidityMethod({
	        ctrl: this,
	        $element: $element,
	        set: function(object, property) {
	          object[property] = true;
	        },
	        unset: function(object, property) {
	          delete object[property];
	        },
	        $animate: $animate
	      });
	
	      /**
	       * @ngdoc method
	       * @name ngModel.NgModelController#$setPristine
	       *
	       * @description
	       * Sets the control to its pristine state.
	       *
	       * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	       * state (`ng-pristine` class). A model is considered to be pristine when the control
	       * has not been changed from when first compiled.
	       */
	      this.$setPristine = function() {
	        ctrl.$dirty = false;
	        ctrl.$pristine = true;
	        $animate.removeClass($element, DIRTY_CLASS);
	        $animate.addClass($element, PRISTINE_CLASS);
	      };
	
	      /**
	       * @ngdoc method
	       * @name ngModel.NgModelController#$setDirty
	       *
	       * @description
	       * Sets the control to its dirty state.
	       *
	       * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	       * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	       * from when first compiled.
	       */
	      this.$setDirty = function() {
	        ctrl.$dirty = true;
	        ctrl.$pristine = false;
	        $animate.removeClass($element, PRISTINE_CLASS);
	        $animate.addClass($element, DIRTY_CLASS);
	        ctrl.$$parentForm.$setDirty();
	      };
	
	      /**
	       * @ngdoc method
	       * @name ngModel.NgModelController#$setUntouched
	       *
	       * @description
	       * Sets the control to its untouched state.
	       *
	       * This method can be called to remove the `ng-touched` class and set the control to its
	       * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	       * by default, however this function can be used to restore that state if the model has
	       * already been touched by the user.
	       */
	      this.$setUntouched = function() {
	        ctrl.$touched = false;
	        ctrl.$untouched = true;
	        $animate.setClass($element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	      };
	
	      /**
	       * @ngdoc method
	       * @name ngModel.NgModelController#$setTouched
	       *
	       * @description
	       * Sets the control to its touched state.
	       *
	       * This method can be called to remove the `ng-untouched` class and set the control to its
	       * touched state (`ng-touched` class). A model is considered to be touched when the user has
	       * first focused the control element and then shifted focus away from the control (blur event).
	       */
	      this.$setTouched = function() {
	        ctrl.$touched = true;
	        ctrl.$untouched = false;
	        $animate.setClass($element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	      };
	
	      /**
	       * @ngdoc method
	       * @name ngModel.NgModelController#$rollbackViewValue
	       *
	       * @description
	       * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	       * which may be caused by a pending debounced event or because the input is waiting for a some
	       * future event.
	       *
	       * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	       * depend on special events such as blur, you can have a situation where there is a period when
	       * the `$viewValue` is out of sync with the ngModel's `$modelValue`.
	       *
	       * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	       * and reset the input to the last committed view value.
	       *
	       * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	       * programmatically before these debounced/future events have resolved/occurred, because Angular's
	       * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	       *
	       * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	       * input which may have such events pending. This is important in order to make sure that the
	       * input field will be updated with the new model value and any pending operations are cancelled.
	       *
	       * <example name="ng-model-cancel-update" module="cancel-update-example">
	       *   <file name="app.js">
	       *     angular.module('cancel-update-example', [])
	       *
	       *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode == 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	       *   </file>
	       *   <file name="index.html">
	       *     <div ng-controller="CancelUpdateController">
	       *        <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	       *        empty them. Follow these steps and observe the difference:</p>
	       *       <ol>
	       *         <li>Type something in the input. You will see that the model is not yet updated</li>
	       *         <li>Press the Escape key.
	       *           <ol>
	       *             <li> In the first example, nothing happens, because the model is already '', and no
	       *             update is detected. If you blur the input, the model will be set to the current view.
	       *             </li>
	       *             <li> In the second example, the pending update is cancelled, and the input is set back
	       *             to the last committed view value (''). Blurring the input does nothing.
	       *             </li>
	       *           </ol>
	       *         </li>
	       *       </ol>
	       *
	       *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	       *         <div>
	       *        <p id="inputDescription1">Without $rollbackViewValue():</p>
	       *         <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	       *                ng-keydown="setEmpty($event, 'value1')">
	       *         value1: "{{ model.value1 }}"
	       *         </div>
	       *
	       *         <div>
	       *        <p id="inputDescription2">With $rollbackViewValue():</p>
	       *         <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	       *                ng-keydown="setEmpty($event, 'value2', true)">
	       *         value2: "{{ model.value2 }}"
	       *         </div>
	       *       </form>
	       *     </div>
	       *   </file>
	       <file name="style.css">
	       div {
	            display: table-cell;
	          }
	       div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	       </file>
	       * </example>
	       */
	      this.$rollbackViewValue = function() {
	        $timeout.cancel(pendingDebounce);
	        ctrl.$viewValue = ctrl.$$lastCommittedViewValue;
	        ctrl.$render();
	      };
	
	      /**
	       * @ngdoc method
	       * @name ngModel.NgModelController#$validate
	       *
	       * @description
	       * Runs each of the registered validators (first synchronous validators and then
	       * asynchronous validators).
	       * If the validity changes to invalid, the model will be set to `undefined`,
	       * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	       * If the validity changes to valid, it will set the model to the last available valid
	       * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	       */
	      this.$validate = function() {
	        // ignore $validate before model is initialized
	        if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
	          return;
	        }
	
	        var viewValue = ctrl.$$lastCommittedViewValue;
	        // Note: we use the $$rawModelValue as $modelValue might have been
	        // set to undefined during a view -> model update that found validation
	        // errors. We can't parse the view here, since that could change
	        // the model although neither viewValue nor the model on the scope changed
	        var modelValue = ctrl.$$rawModelValue;
	
	        var prevValid = ctrl.$valid;
	        var prevModelValue = ctrl.$modelValue;
	
	        var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
	
	        ctrl.$$runValidators(modelValue, viewValue, function(allValid) {
	          // If there was no change in validity, don't update the model
	          // This prevents changing an invalid modelValue to undefined
	          if (!allowInvalid && prevValid !== allValid) {
	            // Note: Don't check ctrl.$valid here, as we could have
	            // external validators (e.g. calculated on the server),
	            // that just call $setValidity and need the model value
	            // to calculate their validity.
	            ctrl.$modelValue = allValid ? modelValue : undefined;
	
	            if (ctrl.$modelValue !== prevModelValue) {
	              ctrl.$$writeModelToScope();
	            }
	          }
	        });
	
	      };
	
	      this.$$runValidators = function(modelValue, viewValue, doneCallback) {
	        currentValidationRunId++;
	        var localValidationRunId = currentValidationRunId;
	
	        // check parser error
	        if (!processParseErrors()) {
	          validationDone(false);
	          return;
	        }
	        if (!processSyncValidators()) {
	          validationDone(false);
	          return;
	        }
	        processAsyncValidators();
	
	        function processParseErrors() {
	          var errorKey = ctrl.$$parserName || 'parse';
	          if (isUndefined(parserValid)) {
	            setValidity(errorKey, null);
	          } else {
	            if (!parserValid) {
	              forEach(ctrl.$validators, function(v, name) {
	                setValidity(name, null);
	              });
	              forEach(ctrl.$asyncValidators, function(v, name) {
	                setValidity(name, null);
	              });
	            }
	            // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	            setValidity(errorKey, parserValid);
	            return parserValid;
	          }
	          return true;
	        }
	
	        function processSyncValidators() {
	          var syncValidatorsValid = true;
	          forEach(ctrl.$validators, function(validator, name) {
	            var result = validator(modelValue, viewValue);
	            syncValidatorsValid = syncValidatorsValid && result;
	            setValidity(name, result);
	          });
	          if (!syncValidatorsValid) {
	            forEach(ctrl.$asyncValidators, function(v, name) {
	              setValidity(name, null);
	            });
	            return false;
	          }
	          return true;
	        }
	
	        function processAsyncValidators() {
	          var validatorPromises = [];
	          var allValid = true;
	          forEach(ctrl.$asyncValidators, function(validator, name) {
	            var promise = validator(modelValue, viewValue);
	            if (!isPromiseLike(promise)) {
	              throw ngModelMinErr('nopromise',
	                "Expected asynchronous validator to return a promise but got '{0}' instead.", promise);
	            }
	            setValidity(name, undefined);
	            validatorPromises.push(promise.then(function() {
	              setValidity(name, true);
	            }, function() {
	              allValid = false;
	              setValidity(name, false);
	            }));
	          });
	          if (!validatorPromises.length) {
	            validationDone(true);
	          } else {
	            $q.all(validatorPromises).then(function() {
	              validationDone(allValid);
	            }, noop);
	          }
	        }
	
	        function setValidity(name, isValid) {
	          if (localValidationRunId === currentValidationRunId) {
	            ctrl.$setValidity(name, isValid);
	          }
	        }
	
	        function validationDone(allValid) {
	          if (localValidationRunId === currentValidationRunId) {
	
	            doneCallback(allValid);
	          }
	        }
	      };
	
	      /**
	       * @ngdoc method
	       * @name ngModel.NgModelController#$commitViewValue
	       *
	       * @description
	       * Commit a pending update to the `$modelValue`.
	       *
	       * Updates may be pending by a debounced event or because the input is waiting for a some future
	       * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	       * usually handles calling this in response to input events.
	       */
	      this.$commitViewValue = function() {
	        var viewValue = ctrl.$viewValue;
	
	        $timeout.cancel(pendingDebounce);
	
	        // If the view value has not changed then we should just exit, except in the case where there is
	        // a native validator on the element. In this case the validation state may have changed even though
	        // the viewValue has stayed empty.
	        if (ctrl.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !ctrl.$$hasNativeValidators)) {
	          return;
	        }
	        ctrl.$$updateEmptyClasses(viewValue);
	        ctrl.$$lastCommittedViewValue = viewValue;
	
	        // change to dirty
	        if (ctrl.$pristine) {
	          this.$setDirty();
	        }
	        this.$$parseAndValidate();
	      };
	
	      this.$$parseAndValidate = function() {
	        var viewValue = ctrl.$$lastCommittedViewValue;
	        var modelValue = viewValue;
	        parserValid = isUndefined(modelValue) ? undefined : true;
	
	        if (parserValid) {
	          for (var i = 0; i < ctrl.$parsers.length; i++) {
	            modelValue = ctrl.$parsers[i](modelValue);
	            if (isUndefined(modelValue)) {
	              parserValid = false;
	              break;
	            }
	          }
	        }
	        if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
	          // ctrl.$modelValue has not been touched yet...
	          ctrl.$modelValue = ngModelGet($scope);
	        }
	        var prevModelValue = ctrl.$modelValue;
	        var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
	        ctrl.$$rawModelValue = modelValue;
	
	        if (allowInvalid) {
	          ctrl.$modelValue = modelValue;
	          writeToModelIfNeeded();
	        }
	
	        // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	        // This can happen if e.g. $setViewValue is called from inside a parser
	        ctrl.$$runValidators(modelValue, ctrl.$$lastCommittedViewValue, function(allValid) {
	          if (!allowInvalid) {
	            // Note: Don't check ctrl.$valid here, as we could have
	            // external validators (e.g. calculated on the server),
	            // that just call $setValidity and need the model value
	            // to calculate their validity.
	            ctrl.$modelValue = allValid ? modelValue : undefined;
	            writeToModelIfNeeded();
	          }
	        });
	
	        function writeToModelIfNeeded() {
	          if (ctrl.$modelValue !== prevModelValue) {
	            ctrl.$$writeModelToScope();
	          }
	        }
	      };
	
	      this.$$writeModelToScope = function() {
	        ngModelSet($scope, ctrl.$modelValue);
	        forEach(ctrl.$viewChangeListeners, function(listener) {
	          try {
	            listener();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        });
	      };
	
	      /**
	       * @ngdoc method
	       * @name ngModel.NgModelController#$setViewValue
	       *
	       * @description
	       * Update the view value.
	       *
	       * This method should be called when a control wants to change the view value; typically,
	       * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	       * directive calls it when the value of the input changes and {@link ng.directive:select select}
	       * calls it when an option is selected.
	       *
	       * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	       * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	       * value sent directly for processing, finally to be applied to `$modelValue` and then the
	       * **expression** specified in the `ng-model` attribute. Lastly, all the registered change listeners,
	       * in the `$viewChangeListeners` list, are called.
	       *
	       * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	       * and the `default` trigger is not listed, all those actions will remain pending until one of the
	       * `updateOn` events is triggered on the DOM element.
	       * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	       * directive is used with a custom debounce for this particular event.
	       * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	       * is specified, once the timer runs out.
	       *
	       * When used with standard inputs, the view value will always be a string (which is in some cases
	       * parsed into another type, such as a `Date` object for `input[date]`.)
	       * However, custom controls might also pass objects to this method. In this case, we should make
	       * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	       * perform a deep watch of objects, it only looks for a change of identity. If you only change
	       * the property of the object then ngModel will not realize that the object has changed and
	       * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	       * not change properties of the copy once it has been passed to `$setViewValue`.
	       * Otherwise you may cause the model value on the scope to change incorrectly.
	       *
	       * <div class="alert alert-info">
	       * In any case, the value passed to the method should always reflect the current value
	       * of the control. For example, if you are calling `$setViewValue` for an input element,
	       * you should pass the input DOM value. Otherwise, the control and the scope model become
	       * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	       * the control's DOM value in any way. If we want to change the control's DOM value
	       * programmatically, we should update the `ngModel` scope expression. Its new value will be
	       * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	       * to update the DOM, and finally call `$validate` on it.
	       * </div>
	       *
	       * @param {*} value value from the view.
	       * @param {string} trigger Event that triggered the update.
	       */
	      this.$setViewValue = function(value, trigger) {
	        ctrl.$viewValue = value;
	        if (!ctrl.$options || ctrl.$options.updateOnDefault) {
	          ctrl.$$debounceViewValueCommit(trigger);
	        }
	      };
	
	      this.$$debounceViewValueCommit = function(trigger) {
	        var debounceDelay = 0,
	          options = ctrl.$options,
	          debounce;
	
	        if (options && isDefined(options.debounce)) {
	          debounce = options.debounce;
	          if (isNumber(debounce)) {
	            debounceDelay = debounce;
	          } else if (isNumber(debounce[trigger])) {
	            debounceDelay = debounce[trigger];
	          } else if (isNumber(debounce['default'])) {
	            debounceDelay = debounce['default'];
	          }
	        }
	
	        $timeout.cancel(pendingDebounce);
	        if (debounceDelay) {
	          pendingDebounce = $timeout(function() {
	            ctrl.$commitViewValue();
	          }, debounceDelay);
	        } else if ($rootScope.$$phase) {
	          ctrl.$commitViewValue();
	        } else {
	          $scope.$apply(function() {
	            ctrl.$commitViewValue();
	          });
	        }
	      };
	
	      // model -> value
	      // Note: we cannot use a normal scope.$watch as we want to detect the following:
	      // 1. scope value is 'a'
	      // 2. user enters 'b'
	      // 3. ng-change kicks in and reverts scope value to 'a'
	      //    -> scope value did not change since the last digest as
	      //       ng-change executes in apply phase
	      // 4. view should be changed back to 'a'
	      $scope.$watch(function ngModelWatch() {
	        var modelValue = ngModelGet($scope);
	
	        // if scope model value and ngModel value are out of sync
	        // TODO(perf): why not move this to the action fn?
	        if (modelValue !== ctrl.$modelValue &&
	          // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	          (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	        ) {
	          ctrl.$modelValue = ctrl.$$rawModelValue = modelValue;
	          parserValid = undefined;
	
	          var formatters = ctrl.$formatters,
	            idx = formatters.length;
	
	          var viewValue = modelValue;
	          while (idx--) {
	            viewValue = formatters[idx](viewValue);
	          }
	          if (ctrl.$viewValue !== viewValue) {
	            ctrl.$$updateEmptyClasses(viewValue);
	            ctrl.$viewValue = ctrl.$$lastCommittedViewValue = viewValue;
	            ctrl.$render();
	
	            ctrl.$$runValidators(modelValue, viewValue, noop);
	          }
	        }
	
	        return modelValue;
	      });
	    }];
	
	
	  /**
	   * @ngdoc directive
	   * @name ngModel
	   *
	   * @element input
	   * @priority 1
	   *
	   * @description
	   * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	   * property on the scope using {@link ngModel.NgModelController NgModelController},
	   * which is created and exposed by this directive.
	   *
	   * `ngModel` is responsible for:
	   *
	   * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	   *   require.
	   * - Providing validation behavior (i.e. required, number, email, url).
	   * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	   * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	   *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	   * - Registering the control with its parent {@link ng.directive:form form}.
	   *
	   * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	   * current scope. If the property doesn't already exist on this scope, it will be created
	   * implicitly and added to the scope.
	   *
	   * For best practices on using `ngModel`, see:
	   *
	   *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	   *
	   * For basic examples, how to use `ngModel`, see:
	   *
	   *  - {@link ng.directive:input input}
	   *    - {@link input[text] text}
	   *    - {@link input[checkbox] checkbox}
	   *    - {@link input[radio] radio}
	   *    - {@link input[number] number}
	   *    - {@link input[email] email}
	   *    - {@link input[url] url}
	   *    - {@link input[date] date}
	   *    - {@link input[datetime-local] datetime-local}
	   *    - {@link input[time] time}
	   *    - {@link input[month] month}
	   *    - {@link input[week] week}
	   *  - {@link ng.directive:select select}
	   *  - {@link ng.directive:textarea textarea}
	   *
	   * # Complex Models (objects or collections)
	   *
	   * By default, `ngModel` watches the model by reference, not value. This is important to know when
	   * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	   * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	   *
	   * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	   *
	   * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	   * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	   * if the select is given the `multiple` attribute.
	   *
	   * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	   * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	   * not trigger a re-rendering of the model.
	   *
	   * # CSS classes
	   * The following CSS classes are added and removed on the associated input/select/textarea element
	   * depending on the validity of the model.
	   *
	   *  - `ng-valid`: the model is valid
	   *  - `ng-invalid`: the model is invalid
	   *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	   *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	   *  - `ng-pristine`: the control hasn't been interacted with yet
	   *  - `ng-dirty`: the control has been interacted with
	   *  - `ng-touched`: the control has been blurred
	   *  - `ng-untouched`: the control hasn't been blurred
	   *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	   *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	   *     by the {@link ngModel.NgModelController#$isEmpty} method
	   *  - `ng-not-empty`: the view contains a non-empty value
	   *
	   * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	   *
	   * ## Animation Hooks
	   *
	   * Animations within models are triggered when any of the associated CSS classes are added and removed
	   * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	   * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	   * The animations that are triggered within ngModel are similar to how they work in ngClass and
	   * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	   *
	   * The following example shows a simple way to utilize CSS transitions to style an input element
	   * that has been rendered as invalid after it has been validated:
	   *
	   * <pre>
	   * //be sure to include ngAnimate as a module to hook into more
	   * //advanced animations
	   * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	   * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	   * </pre>
	   *
	   * @example
	   * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample">
	   <file name="index.html">
	   <script>
	   angular.module('inputExample', [])
	   .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	   </script>
	   <style>
	   .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	   .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	   </style>
	   <p id="inputDescription">
	   Update input to see transitions when valid/invalid.
	   Integer is a valid value.
	   </p>
	   <form name="testForm" ng-controller="ExampleController">
	   <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	   aria-describedby="inputDescription" />
	   </form>
	   </file>
	   * </example>
	   *
	   * ## Binding to a getter/setter
	   *
	   * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	   * function that returns a representation of the model when called with zero arguments, and sets
	   * the internal state of a model when called with an argument. It's sometimes useful to use this
	   * for models that have an internal representation that's different from what the model exposes
	   * to the view.
	   *
	   * <div class="alert alert-success">
	   * **Best Practice:** It's best to keep getters fast because Angular is likely to call them more
	   * frequently than other parts of your code.
	   * </div>
	   *
	   * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	   * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	   * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	   * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	   *
	   * The following example shows how to use `ngModel` with a getter/setter:
	   *
	   * @example
	   * <example name="ngModel-getter-setter" module="getterSetterExample">
	   <file name="index.html">
	   <div ng-controller="ExampleController">
	   <form name="userForm">
	   <label>Name:
	   <input type="text" name="userName"
	   ng-model="user.name"
	   ng-model-options="{ getterSetter: true }" />
	   </label>
	   </form>
	   <pre>user.name = <span ng-bind="user.name()"></span></pre>
	   </div>
	   </file>
	   <file name="app.js">
	   angular.module('getterSetterExample', [])
	   .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	   </file>
	   * </example>
	   */
	  var ngModelDirective = ['$rootScope', function($rootScope) {
	    return {
	      restrict: 'A',
	      require: ['ngModel', '^?form', '^?ngModelOptions'],
	      controller: NgModelController,
	      // Prelink needs to run before any input directive
	      // so that we can set the NgModelOptions in NgModelController
	      // before anyone else uses it.
	      priority: 1,
	      compile: function ngModelCompile(element) {
	        // Setup initial state of the control
	        element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	        return {
	          pre: function ngModelPreLink(scope, element, attr, ctrls) {
	            var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || modelCtrl.$$parentForm;
	
	            modelCtrl.$$setOptions(ctrls[2] && ctrls[2].$options);
	
	            // notify others, especially parent forms
	            formCtrl.$addControl(modelCtrl);
	
	            attr.$observe('name', function(newValue) {
	              if (modelCtrl.$name !== newValue) {
	                modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
	              }
	            });
	
	            scope.$on('$destroy', function() {
	              modelCtrl.$$parentForm.$removeControl(modelCtrl);
	            });
	          },
	          post: function ngModelPostLink(scope, element, attr, ctrls) {
	            var modelCtrl = ctrls[0];
	            if (modelCtrl.$options && modelCtrl.$options.updateOn) {
	              element.on(modelCtrl.$options.updateOn, function(ev) {
	                modelCtrl.$$debounceViewValueCommit(ev && ev.type);
	              });
	            }
	
	            element.on('blur', function() {
	              if (modelCtrl.$touched) return;
	
	              if ($rootScope.$$phase) {
	                scope.$evalAsync(modelCtrl.$setTouched);
	              } else {
	                scope.$apply(modelCtrl.$setTouched);
	              }
	            });
	          }
	        };
	      }
	    };
	  }];
	
	  var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	  /**
	   * @ngdoc directive
	   * @name ngModelOptions
	   *
	   * @description
	   * Allows tuning how model updates are done. Using `ngModelOptions` you can specify a custom list of
	   * events that will trigger a model update and/or a debouncing delay so that the actual update only
	   * takes place when a timer expires; this timer will be reset after another change takes place.
	   *
	   * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	   * be different from the value in the actual model. This means that if you update the model you
	   * should also invoke {@link ngModel.NgModelController `$rollbackViewValue`} on the relevant input field in
	   * order to make sure it is synchronized with the model and that any debounced action is canceled.
	   *
	   * The easiest way to reference the control's {@link ngModel.NgModelController `$rollbackViewValue`}
	   * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	   * important because `form` controllers are published to the related scope under the name in their
	   * `name` attribute.
	   *
	   * Any pending changes will take place immediately when an enclosing form is submitted via the
	   * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	   * to have access to the updated model.
	   *
	   * `ngModelOptions` has an effect on the element it's declared on and its descendants.
	   *
	   * @param {Object} ngModelOptions options to apply to the current model. Valid keys are:
	   *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	   *     events using an space delimited list. There is a special event called `default` that
	   *     matches the default events belonging of the control.
	   *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	   *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	   *     custom value for each event. For example:
	   *     `ng-model-options="{ updateOn: 'default blur', debounce: { 'default': 500, 'blur': 0 } }"`
	   *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	   *     not validate correctly instead of the default behavior of setting the model to undefined.
	   *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	   `ngModel` as getters/setters.
	   *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	   *     `<input type="date">`, `<input type="time">`, ... . It understands UTC/GMT and the
	   *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	   *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	   *     If not specified, the timezone of the browser will be used.
	   *
	   * @example
	
	   The following example shows how to override immediate updates. Changes on the inputs within the
	   form will update the model only when the control loses focus (blur event). If `escape` key is
	   pressed while the input field is focused, the value is reset to the value in the current model.
	
	   <example name="ngModelOptions-directive-blur" module="optionsExample">
	   <file name="index.html">
	   <div ng-controller="ExampleController">
	   <form name="userForm">
	   <label>Name:
	   <input type="text" name="userName"
	   ng-model="user.name"
	   ng-model-options="{ updateOn: 'blur' }"
	   ng-keyup="cancel($event)" />
	   </label><br />
	   <label>Other data:
	   <input type="text" ng-model="user.data" />
	   </label><br />
	   </form>
	   <pre>user.name = <span ng-bind="user.name"></span></pre>
	   <pre>user.data = <span ng-bind="user.data"></span></pre>
	   </div>
	   </file>
	   <file name="app.js">
	   angular.module('optionsExample', [])
	   .controller('ExampleController', ['$scope', function($scope) {
	          $scope.user = { name: 'John', data: '' };
	
	          $scope.cancel = function(e) {
	            if (e.keyCode == 27) {
	              $scope.userForm.userName.$rollbackViewValue();
	            }
	          };
	        }]);
	   </file>
	   <file name="protractor.js" type="protractor">
	   var model = element(by.binding('user.name'));
	   var input = element(by.model('user.name'));
	   var other = element(by.model('user.data'));
	
	   it('should allow custom events', function() {
	        input.sendKeys(' Doe');
	        input.click();
	        expect(model.getText()).toEqual('John');
	        other.click();
	        expect(model.getText()).toEqual('John Doe');
	      });
	
	   it('should $rollbackViewValue when model changes', function() {
	        input.sendKeys(' Doe');
	        expect(input.getAttribute('value')).toEqual('John Doe');
	        input.sendKeys(protractor.Key.ESCAPE);
	        expect(input.getAttribute('value')).toEqual('John');
	        other.click();
	        expect(model.getText()).toEqual('John');
	      });
	   </file>
	   </example>
	
	   This one shows how to debounce model changes. Model will be updated only 1 sec after last change.
	   If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	
	   <example name="ngModelOptions-directive-debounce" module="optionsExample">
	   <file name="index.html">
	   <div ng-controller="ExampleController">
	   <form name="userForm">
	   <label>Name:
	   <input type="text" name="userName"
	   ng-model="user.name"
	   ng-model-options="{ debounce: 1000 }" />
	   </label>
	   <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button>
	   <br />
	   </form>
	   <pre>user.name = <span ng-bind="user.name"></span></pre>
	   </div>
	   </file>
	   <file name="app.js">
	   angular.module('optionsExample', [])
	   .controller('ExampleController', ['$scope', function($scope) {
	          $scope.user = { name: 'Igor' };
	        }]);
	   </file>
	   </example>
	
	   This one shows how to bind to getter/setters:
	
	   <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	   <file name="index.html">
	   <div ng-controller="ExampleController">
	   <form name="userForm">
	   <label>Name:
	   <input type="text" name="userName"
	   ng-model="user.name"
	   ng-model-options="{ getterSetter: true }" />
	   </label>
	   </form>
	   <pre>user.name = <span ng-bind="user.name()"></span></pre>
	   </div>
	   </file>
	   <file name="app.js">
	   angular.module('getterSetterExample', [])
	   .controller('ExampleController', ['$scope', function($scope) {
	          var _name = 'Brian';
	          $scope.user = {
	            name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	            }
	          };
	        }]);
	   </file>
	   </example>
	   */
	  var ngModelOptionsDirective = function() {
	    return {
	      restrict: 'A',
	      controller: ['$scope', '$attrs', function($scope, $attrs) {
	        var that = this;
	        this.$options = copy($scope.$eval($attrs.ngModelOptions));
	        // Allow adding/overriding bound events
	        if (isDefined(this.$options.updateOn)) {
	          this.$options.updateOnDefault = false;
	          // extract "default" pseudo-event from list of events that can trigger a model update
	          this.$options.updateOn = trim(this.$options.updateOn.replace(DEFAULT_REGEXP, function() {
	            that.$options.updateOnDefault = true;
	            return ' ';
	          }));
	        } else {
	          this.$options.updateOnDefault = true;
	        }
	      }]
	    };
	  };
	
	
	
	// helper methods
	  function addSetValidityMethod(context) {
	    var ctrl = context.ctrl,
	      $element = context.$element,
	      classCache = {},
	      set = context.set,
	      unset = context.unset,
	      $animate = context.$animate;
	
	    classCache[INVALID_CLASS] = !(classCache[VALID_CLASS] = $element.hasClass(VALID_CLASS));
	
	    ctrl.$setValidity = setValidity;
	
	    function setValidity(validationErrorKey, state, controller) {
	      if (isUndefined(state)) {
	        createAndSet('$pending', validationErrorKey, controller);
	      } else {
	        unsetAndCleanup('$pending', validationErrorKey, controller);
	      }
	      if (!isBoolean(state)) {
	        unset(ctrl.$error, validationErrorKey, controller);
	        unset(ctrl.$$success, validationErrorKey, controller);
	      } else {
	        if (state) {
	          unset(ctrl.$error, validationErrorKey, controller);
	          set(ctrl.$$success, validationErrorKey, controller);
	        } else {
	          set(ctrl.$error, validationErrorKey, controller);
	          unset(ctrl.$$success, validationErrorKey, controller);
	        }
	      }
	      if (ctrl.$pending) {
	        cachedToggleClass(PENDING_CLASS, true);
	        ctrl.$valid = ctrl.$invalid = undefined;
	        toggleValidationCss('', null);
	      } else {
	        cachedToggleClass(PENDING_CLASS, false);
	        ctrl.$valid = isObjectEmpty(ctrl.$error);
	        ctrl.$invalid = !ctrl.$valid;
	        toggleValidationCss('', ctrl.$valid);
	      }
	
	      // re-read the state as the set/unset methods could have
	      // combined state in ctrl.$error[validationError] (used for forms),
	      // where setting/unsetting only increments/decrements the value,
	      // and does not replace it.
	      var combinedState;
	      if (ctrl.$pending && ctrl.$pending[validationErrorKey]) {
	        combinedState = undefined;
	      } else if (ctrl.$error[validationErrorKey]) {
	        combinedState = false;
	      } else if (ctrl.$$success[validationErrorKey]) {
	        combinedState = true;
	      } else {
	        combinedState = null;
	      }
	
	      toggleValidationCss(validationErrorKey, combinedState);
	      ctrl.$$parentForm.$setValidity(validationErrorKey, combinedState, ctrl);
	    }
	
	    function createAndSet(name, value, controller) {
	      if (!ctrl[name]) {
	        ctrl[name] = {};
	      }
	      set(ctrl[name], value, controller);
	    }
	
	    function unsetAndCleanup(name, value, controller) {
	      if (ctrl[name]) {
	        unset(ctrl[name], value, controller);
	      }
	      if (isObjectEmpty(ctrl[name])) {
	        ctrl[name] = undefined;
	      }
	    }
	
	    function cachedToggleClass(className, switchValue) {
	      if (switchValue && !classCache[className]) {
	        $animate.addClass($element, className);
	        classCache[className] = true;
	      } else if (!switchValue && classCache[className]) {
	        $animate.removeClass($element, className);
	        classCache[className] = false;
	      }
	    }
	
	    function toggleValidationCss(validationErrorKey, isValid) {
	      validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	      cachedToggleClass(VALID_CLASS + validationErrorKey, isValid === true);
	      cachedToggleClass(INVALID_CLASS + validationErrorKey, isValid === false);
	    }
	  }
	
	  function isObjectEmpty(obj) {
	    if (obj) {
	      for (var prop in obj) {
	        if (obj.hasOwnProperty(prop)) {
	          return false;
	        }
	      }
	    }
	    return true;
	  }
	
	  /**
	   * @ngdoc directive
	   * @name ngNonBindable
	   * @restrict AC
	   * @priority 1000
	   *
	   * @description
	   * The `ngNonBindable` directive tells Angular not to compile or bind the contents of the current
	   * DOM element. This is useful if the element contains what appears to be Angular directives and
	   * bindings but which should be ignored by Angular. This could be the case if you have a site that
	   * displays snippets of code, for instance.
	   *
	   * @element ANY
	   *
	   * @example
	   * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	   * but the one wrapped in `ngNonBindable` is left alone.
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <div>Normal: {{1 + 2}}</div>
	   <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should check ng-non-bindable', function() {
	         expect(element(by.binding('1 + 2')).getText()).toContain('3');
	         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	       });
	   </file>
	   </example>
	   */
	  var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	  /* global jqLiteRemove */
	
	  var ngOptionsMinErr = minErr('ngOptions');
	
	  /**
	   * @ngdoc directive
	   * @name ngOptions
	   * @restrict A
	   *
	   * @description
	   *
	   * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	   * elements for the `<select>` element using the array or object obtained by evaluating the
	   * `ngOptions` comprehension expression.
	   *
	   * In many cases, `ngRepeat` can be used on `<option>` elements instead of `ngOptions` to achieve a
	   * similar result. However, `ngOptions` provides some benefits such as reducing memory and
	   * increasing speed by not creating a new scope for each repeated instance, as well as providing
	   * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	   * comprehension expression. `ngOptions` should be used when the `<select>` model needs to be bound
	   *  to a non-string value. This is because an option element can only be bound to string values at
	   * present.
	   *
	   * When an item in the `<select>` menu is selected, the array element or object property
	   * represented by the selected option will be bound to the model identified by the `ngModel`
	   * directive.
	   *
	   * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	   * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	   * option. See example below for demonstration.
	   *
	   * ## Complex Models (objects or collections)
	   *
	   * By default, `ngModel` watches the model by reference, not value. This is important to know when
	   * binding the select to a model that is an object or a collection.
	   *
	   * One issue occurs if you want to preselect an option. For example, if you set
	   * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	   * because the objects are not identical. So by default, you should always reference the item in your collection
	   * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	   *
	   * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	   * of the item not by reference, but by the result of the `track by` expression. For example, if your
	   * collection items have an id property, you would `track by item.id`.
	   *
	   * A different issue with objects or collections is that ngModel won't detect if an object property or
	   * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	   * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	   * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	   * has not changed identity, but only a property on the object or an item in the collection changes.
	   *
	   * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	   * if the model is an array). This means that changing a property deeper than the first level inside the
	   * object/collection will not trigger a re-rendering.
	   *
	   * ## `select` **`as`**
	   *
	   * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	   * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	   * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	   * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	   *
	   *
	   * ### `select` **`as`** and **`track by`**
	   *
	   * <div class="alert alert-warning">
	   * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	   * </div>
	   *
	   * Given this array of items on the $scope:
	   *
	   * ```js
	   * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	   * ```
	   *
	   * This will work:
	   *
	   * ```html
	   * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	   * ```
	   * ```js
	   * $scope.selected = $scope.items[0];
	   * ```
	   *
	   * but this will not work:
	   *
	   * ```html
	   * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	   * ```
	   * ```js
	   * $scope.selected = $scope.items[0].subItem;
	   * ```
	   *
	   * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	   * `items` array. Because the selected option has been set programmatically in the controller, the
	   * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	   * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	   * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	   * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	   * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required The control is considered valid only if value is entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {comprehension_expression=} ngOptions in one of the following forms:
	   *
	   *   * for array data sources:
	   *     * `label` **`for`** `value` **`in`** `array`
	   *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	   *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	   *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	   *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	   *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	   *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	   *        (for including a filter with `track by`)
	   *   * for object data sources:
	   *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	   *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	   *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	   *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	   *     * `select` **`as`** `label` **`group by`** `group`
	   *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	   *     * `select` **`as`** `label` **`disable when`** `disable`
	   *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	   *
	   * Where:
	   *
	   *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	   *   * `value`: local variable which will refer to each item in the `array` or each property value
	   *      of `object` during iteration.
	   *   * `key`: local variable which will refer to a property name in `object` during iteration.
	   *   * `label`: The result of this expression will be the label for `<option>` element. The
	   *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	   *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	   *      element. If not specified, `select` expression will default to `value`.
	   *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	   *      DOM element.
	   *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	   *      element. Return `true` to disable.
	   *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	   *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	   *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	   *      even when the options are recreated (e.g. reloaded from the server).
	   *
	   * @example
	   <example module="selectExample">
	   <file name="index.html">
	   <script>
	   angular.module('selectExample', [])
	   .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	   </script>
	   <div ng-controller="ExampleController">
	   <ul>
	   <li ng-repeat="color in colors">
	   <label>Name: <input ng-model="color.name"></label>
	   <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	   <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	   </li>
	   <li>
	   <button ng-click="colors.push({})">add</button>
	   </li>
	   </ul>
	   <hr/>
	   <label>Color (null not allowed):
	   <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	   </label><br/>
	   <label>Color (null allowed):
	   <span  class="nullable">
	   <select ng-model="myColor" ng-options="color.name for color in colors">
	   <option value="">-- choose color --</option>
	   </select>
	   </span></label><br/>
	
	   <label>Color grouped by shade:
	   <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	   </select>
	   </label><br/>
	
	   <label>Color grouped by shade, with some disabled:
	   <select ng-model="myColor"
	   ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	   </select>
	   </label><br/>
	
	
	
	   Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	   <br/>
	   <hr/>
	   Currently selected: {{ {selected_color:myColor} }}
	   <div style="border:solid 1px black; height:20px"
	   ng-style="{'background-color':myColor.name}">
	   </div>
	   </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	   </file>
	   </example>
	   */
	
	// jshint maxlen: false
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555550000000006666666666666660000000777777777777777000000000000000888888888800000000000000000009999999999
	  var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	  // 1: value expression (valueFn)
	  // 2: label expression (displayFn)
	  // 3: group by expression (groupByFn)
	  // 4: disable when expression (disableWhenFn)
	  // 5: array item variable name
	  // 6: object item key variable name
	  // 7: object item value variable name
	  // 8: collection expression
	  // 9: track by expression
	// jshint maxlen: 100
	
	
	  var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
	
	    function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	      var match = optionsExp.match(NG_OPTIONS_REGEXP);
	      if (!(match)) {
	        throw ngOptionsMinErr('iexp',
	          "Expected expression in form of " +
	          "'_select_ (as _label_)? for (_key_,)?_value_ in _collection_'" +
	          " but got '{0}'. Element: {1}",
	          optionsExp, startingTag(selectElement));
	      }
	
	      // Extract the parts from the ngOptions expression
	
	      // The variable name for the value of the item in the collection
	      var valueName = match[5] || match[7];
	      // The variable name for the key of the item in the collection
	      var keyName = match[6];
	
	      // An expression that generates the viewValue for an option if there is a label expression
	      var selectAs = / as /.test(match[0]) && match[1];
	      // An expression that is used to track the id of each object in the options collection
	      var trackBy = match[9];
	      // An expression that generates the viewValue for an option if there is no label expression
	      var valueFn = $parse(match[2] ? match[1] : valueName);
	      var selectAsFn = selectAs && $parse(selectAs);
	      var viewValueFn = selectAsFn || valueFn;
	      var trackByFn = trackBy && $parse(trackBy);
	
	      // Get the value by which we are going to track the option
	      // if we have a trackFn then use that (passing scope and locals)
	      // otherwise just hash the given viewValue
	      var getTrackByValueFn = trackBy ?
	        function(value, locals) { return trackByFn(scope, locals); } :
	        function getHashOfValue(value) { return hashKey(value); };
	      var getTrackByValue = function(value, key) {
	        return getTrackByValueFn(value, getLocals(value, key));
	      };
	
	      var displayFn = $parse(match[2] || match[1]);
	      var groupByFn = $parse(match[3] || '');
	      var disableWhenFn = $parse(match[4] || '');
	      var valuesFn = $parse(match[8]);
	
	      var locals = {};
	      var getLocals = keyName ? function(value, key) {
	        locals[keyName] = key;
	        locals[valueName] = value;
	        return locals;
	      } : function(value) {
	        locals[valueName] = value;
	        return locals;
	      };
	
	
	      function Option(selectValue, viewValue, label, group, disabled) {
	        this.selectValue = selectValue;
	        this.viewValue = viewValue;
	        this.label = label;
	        this.group = group;
	        this.disabled = disabled;
	      }
	
	      function getOptionValuesKeys(optionValues) {
	        var optionValuesKeys;
	
	        if (!keyName && isArrayLike(optionValues)) {
	          optionValuesKeys = optionValues;
	        } else {
	          // if object, extract keys, in enumeration order, unsorted
	          optionValuesKeys = [];
	          for (var itemKey in optionValues) {
	            if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	              optionValuesKeys.push(itemKey);
	            }
	          }
	        }
	        return optionValuesKeys;
	      }
	
	      return {
	        trackBy: trackBy,
	        getTrackByValue: getTrackByValue,
	        getWatchables: $parse(valuesFn, function(optionValues) {
	          // Create a collection of things that we would like to watch (watchedArray)
	          // so that they can all be watched using a single $watchCollection
	          // that only runs the handler once if anything changes
	          var watchedArray = [];
	          optionValues = optionValues || [];
	
	          var optionValuesKeys = getOptionValuesKeys(optionValues);
	          var optionValuesLength = optionValuesKeys.length;
	          for (var index = 0; index < optionValuesLength; index++) {
	            var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	            var value = optionValues[key];
	
	            var locals = getLocals(value, key);
	            var selectValue = getTrackByValueFn(value, locals);
	            watchedArray.push(selectValue);
	
	            // Only need to watch the displayFn if there is a specific label expression
	            if (match[2] || match[1]) {
	              var label = displayFn(scope, locals);
	              watchedArray.push(label);
	            }
	
	            // Only need to watch the disableWhenFn if there is a specific disable expression
	            if (match[4]) {
	              var disableWhen = disableWhenFn(scope, locals);
	              watchedArray.push(disableWhen);
	            }
	          }
	          return watchedArray;
	        }),
	
	        getOptions: function() {
	
	          var optionItems = [];
	          var selectValueMap = {};
	
	          // The option values were already computed in the `getWatchables` fn,
	          // which must have been called to trigger `getOptions`
	          var optionValues = valuesFn(scope) || [];
	          var optionValuesKeys = getOptionValuesKeys(optionValues);
	          var optionValuesLength = optionValuesKeys.length;
	
	          for (var index = 0; index < optionValuesLength; index++) {
	            var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	            var value = optionValues[key];
	            var locals = getLocals(value, key);
	            var viewValue = viewValueFn(scope, locals);
	            var selectValue = getTrackByValueFn(viewValue, locals);
	            var label = displayFn(scope, locals);
	            var group = groupByFn(scope, locals);
	            var disabled = disableWhenFn(scope, locals);
	            var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	            optionItems.push(optionItem);
	            selectValueMap[selectValue] = optionItem;
	          }
	
	          return {
	            items: optionItems,
	            selectValueMap: selectValueMap,
	            getOptionFromViewValue: function(value) {
	              return selectValueMap[getTrackByValue(value)];
	            },
	            getViewValueFromOption: function(option) {
	              // If the viewValue could be an object that may be mutated by the application,
	              // we need to make a copy and not return the reference to the value on the option.
	              return trackBy ? angular.copy(option.viewValue) : option.viewValue;
	            }
	          };
	        }
	      };
	    }
	
	
	    // we can't just jqLite('<option>') since jqLite is not smart enough
	    // to create it in <select> and IE barfs otherwise.
	    var optionTemplate = window.document.createElement('option'),
	      optGroupTemplate = window.document.createElement('optgroup');
	
	    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      var emptyOption;
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      var providedEmptyOption = !!emptyOption;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	      // This stores the newly created options before they are appended to the select.
	      // Since the contents are removed from the fragment when it is appended,
	      // we only need to create it once.
	      var listFragment = $document[0].createDocumentFragment();
	
	      var renderEmptyOption = function() {
	        if (!providedEmptyOption) {
	          selectElement.prepend(emptyOption);
	        }
	        selectElement.val('');
	        emptyOption.prop('selected', true); // needed for IE
	        emptyOption.attr('selected', true);
	      };
	
	      var removeEmptyOption = function() {
	        if (!providedEmptyOption) {
	          emptyOption.remove();
	        }
	      };
	
	
	      var renderUnknownOption = function() {
	        selectElement.prepend(unknownOption);
	        selectElement.val('?');
	        unknownOption.prop('selected', true); // needed for IE
	        unknownOption.attr('selected', true);
	      };
	
	      var removeUnknownOption = function() {
	        unknownOption.remove();
	      };
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          var option = options.getOptionFromViewValue(value);
	
	          if (option) {
	            // Don't update the option when it is already selected.
	            // For example, the browser will select the first option by default. In that case,
	            // most properties are set automatically - except the `selected` attribute, which we
	            // set always
	
	            if (selectElement[0].value !== option.selectValue) {
	              removeUnknownOption();
	              removeEmptyOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	            }
	
	            option.element.setAttribute('selected', 'selected');
	          } else {
	            if (value === null || providedEmptyOption) {
	              removeUnknownOption();
	              renderEmptyOption();
	            } else {
	              removeEmptyOption();
	              renderUnknownOption();
	            }
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            removeEmptyOption();
	            removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(value) {
	          options.items.forEach(function(option) {
	            option.element.selected = false;
	          });
	
	          if (value) {
	            value.forEach(function(item) {
	              var option = options.getOptionFromViewValue(item);
	              if (option) option.element.selected = true;
	            });
	          }
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	            selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	
	      if (providedEmptyOption) {
	
	        // we need to remove it before calling selectElement.empty() because otherwise IE will
	        // remove the label from the element. wtf?
	        emptyOption.remove();
	
	        // compile the element since there might be bindings in it
	        $compile(emptyOption)(scope);
	
	        // remove the class, which is added automatically because we recompile the element and it
	        // becomes the compilation root
	        emptyOption.removeClass('ng-scope');
	      } else {
	        emptyOption = jqLite(optionTemplate.cloneNode(false));
	      }
	
	      selectElement.empty();
	
	      // We need to do this here to ensure that the options object is defined
	      // when we first hit it in writeNgOptionsValue
	      updateOptions();
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	      function addOptionElement(option, parent) {
	        var optionElement = optionTemplate.cloneNode(false);
	        parent.appendChild(optionElement);
	        updateOptionElement(option, optionElement);
	      }
	
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        // NOTE: The label must be set before the value, otherwise IE10/11/EDGE create unresponsive
	        // selects in certain circumstances when multiple selects are next to each other and display
	        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	        // See https://github.com/angular/angular.js/issues/11314 for more info.
	        // This is unfortunately untestable with unit / e2e tests
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	        if (option.value !== element.value) element.value = option.selectValue;
	      }
	
	      function updateOptions() {
	        var previousValue = options && selectCtrl.readValue();
	
	        // We must remove all current options, but cannot simply set innerHTML = null
	        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
	        // must preserve.
	        // Instead, iterate over the current option elements and remove them or their optgroup
	        // parents
	        if (options) {
	
	          for (var i = options.items.length - 1; i >= 0; i--) {
	            var option = options.items[i];
	            if (option.group) {
	              jqLiteRemove(option.element.parentNode);
	            } else {
	              jqLiteRemove(option.element);
	            }
	          }
	        }
	
	        options = ngOptions.getOptions();
	
	        var groupElementMap = {};
	
	        // Ensure that the empty option is always there if it was explicitly provided
	        if (providedEmptyOption) {
	          selectElement.prepend(emptyOption);
	        }
	
	        options.items.forEach(function addOption(option) {
	          var groupElement;
	
	          if (isDefined(option.group)) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            groupElement = groupElementMap[option.group];
	
	            if (!groupElement) {
	
	              groupElement = optGroupTemplate.cloneNode(false);
	              listFragment.appendChild(groupElement);
	
	              // Update the label on the group element
	              groupElement.label = option.group;
	
	              // Store it for use later
	              groupElementMap[option.group] = groupElement;
	            }
	
	            addOptionElement(option, groupElement);
	
	          } else {
	
	            // This option is not in a group
	            addOptionElement(option, listFragment);
	          }
	        });
	
	        selectElement[0].appendChild(listFragment);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          var isNotPrimitive = ngOptions.trackBy || multiple;
	          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	
	      }
	    }
	
	    return {
	      restrict: 'A',
	      terminal: true,
	      require: ['select', 'ngModel'],
	      link: {
	        pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
	          // Deactivate the SelectController.register method to prevent
	          // option directives from accidentally registering themselves
	          // (and unwanted $destroy handlers etc.)
	          ctrls[0].registerOption = noop;
	        },
	        post: ngOptionsPostLink
	      }
	    };
	  }];
	
	  /**
	   * @ngdoc directive
	   * @name ngPluralize
	   * @restrict EA
	   *
	   * @description
	   * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	   * These rules are bundled with angular.js, but can be overridden
	   * (see {@link guide/i18n Angular i18n} dev guide). You configure ngPluralize directive
	   * by specifying the mappings between
	   * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	   * and the strings to be displayed.
	   *
	   * # Plural categories and explicit number rules
	   * There are two
	   * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	   * in Angular's default en-US locale: "one" and "other".
	   *
	   * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	   * any number that is not 1), an explicit number rule can only match one number. For example, the
	   * explicit number rule for "3" matches the number 3. There are examples of plural categories
	   * and explicit number rules throughout the rest of this documentation.
	   *
	   * # Configuring ngPluralize
	   * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	   * You can also provide an optional attribute, `offset`.
	   *
	   * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * Angular expression}; these are evaluated on the current scope for its bound value.
	   *
	   * The `when` attribute specifies the mappings between plural categories and the actual
	   * string to be displayed. The value of the attribute should be a JSON object.
	   *
	   * The following example shows how to configure ngPluralize:
	   *
	   * ```html
	   * <ng-pluralize count="personCount"
	   when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	   * </ng-pluralize>
	   *```
	   *
	   * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	   * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	   * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	   * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	   * show "a dozen people are viewing".
	   *
	   * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	   * into pluralized strings. In the previous example, Angular will replace `{}` with
	   * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	   * for <span ng-non-bindable>{{numberExpression}}</span>.
	   *
	   * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	   * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	   *
	   * # Configuring ngPluralize with offset
	   * The `offset` attribute allows further customization of pluralized text, which can result in
	   * a better user experience. For example, instead of the message "4 people are viewing this document",
	   * you might display "John, Kate and 2 others are viewing this document".
	   * The offset attribute allows you to offset a number by any desired value.
	   * Let's take a look at an example:
	   *
	   * ```html
	   * <ng-pluralize count="personCount" offset=2
	   *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	   * </ng-pluralize>
	   * ```
	   *
	   * Notice that we are still using two plural categories(one, other), but we added
	   * three explicit number rules 0, 1 and 2.
	   * When one person, perhaps John, views the document, "John is viewing" will be shown.
	   * When three people view the document, no explicit number rule is found, so
	   * an offset of 2 is taken off 3, and Angular uses 1 to decide the plural category.
	   * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	   * is shown.
	   *
	   * Note that when you specify offsets, you must provide explicit number rules for
	   * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	   * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	   * plural categories "one" and "other".
	   *
	   * @param {string|expression} count The variable to be bound to.
	   * @param {string} when The mapping between plural category to its corresponding strings.
	   * @param {number=} offset Offset to deduct from the total number.
	   *
	   * @example
	   <example module="pluralizeExample">
	   <file name="index.html">
	   <script>
	   angular.module('pluralizeExample', [])
	   .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	   </script>
	   <div ng-controller="ExampleController">
	   <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	   <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	   <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	   <!--- Example with simple pluralization rules for en locale --->
	   Without Offset:
	   <ng-pluralize count="personCount"
	   when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	   </ng-pluralize><br>
	
	   <!--- Example with offset --->
	   With Offset(2):
	   <ng-pluralize count="personCount" offset=2
	   when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	   </ng-pluralize>
	   </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	   it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	   </file>
	   </example>
	   */
	  var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	    var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	    return {
	      link: function(scope, element, attr) {
	        var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	        forEach(attr, function(expression, attributeName) {
	          var tmpMatch = IS_WHEN.exec(attributeName);
	          if (tmpMatch) {
	            var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	            whens[whenKey] = element.attr(attr.$attr[attributeName]);
	          }
	        });
	        forEach(whens, function(expression, key) {
	          whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	        });
	
	        scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	          var count = parseFloat(newVal);
	          var countIsNaN = isNaN(count);
	
	          if (!countIsNaN && !(count in whens)) {
	            // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	            // Otherwise, check it against pluralization rules in $locale service.
	            count = $locale.pluralCat(count - offset);
	          }
	
	          // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	          // In JS `NaN !== NaN`, so we have to explicitly check.
	          if ((count !== lastCount) && !(countIsNaN && isNumber(lastCount) && isNaN(lastCount))) {
	            watchRemover();
	            var whenExpFn = whensExpFns[count];
	            if (isUndefined(whenExpFn)) {
	              if (newVal != null) {
	                $log.debug("ngPluralize: no rule defined for '" + count + "' in " + whenExp);
	              }
	              watchRemover = noop;
	              updateElementText();
	            } else {
	              watchRemover = scope.$watch(whenExpFn, updateElementText);
	            }
	            lastCount = count;
	          }
	        });
	
	        function updateElementText(newText) {
	          element.text(newText || '');
	        }
	      }
	    };
	  }];
	
	  /**
	   * @ngdoc directive
	   * @name ngRepeat
	   * @multiElement
	   *
	   * @description
	   * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	   * instance gets its own scope, where the given loop variable is set to the current collection item,
	   * and `$index` is set to the item index or key.
	   *
	   * Special properties are exposed on the local scope of each template instance, including:
	   *
	   * | Variable  | Type            | Details                                                                     |
	   * |-----------|-----------------|-----------------------------------------------------------------------------|
	   * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	   * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	   * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	   * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	   * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	   * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	   *
	   * <div class="alert alert-info">
	   *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	   *   This may be useful when, for instance, nesting ngRepeats.
	   * </div>
	   *
	   *
	   * # Iterating over object properties
	   *
	   * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	   * syntax:
	   *
	   * ```js
	   * <div ng-repeat="(key, value) in myObj"> ... </div>
	   * ```
	   *
	   * However, there are a limitations compared to array iteration:
	   *
	   * - The JavaScript specification does not define the order of keys
	   *   returned for an object, so Angular relies on the order returned by the browser
	   *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	   *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	   *   and reinstated. See the
	   *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	   *
	   * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	   *   it's a prefix used by Angular for public (`$`) and private (`$$`) properties.
	   *
	   * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	   *   objects, and will throw if used with one.
	   *
	   * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	   * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	   * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	   * or implement a `$watch` on the object yourself.
	   *
	   *
	   * # Tracking and Duplicates
	   *
	   * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	   * the collection. When a change happens, ngRepeat then makes the corresponding changes to the DOM:
	   *
	   * * When an item is added, a new instance of the template is added to the DOM.
	   * * When an item is removed, its template instance is removed from the DOM.
	   * * When items are reordered, their respective templates are reordered in the DOM.
	   *
	   * To minimize creation of DOM elements, `ngRepeat` uses a function
	   * to "keep track" of all items in the collection and their corresponding DOM elements.
	   * For example, if an item is added to the collection, ngRepeat will know that all other items
	   * already have DOM elements, and will not re-render them.
	   *
	   * The default tracking function (which tracks items by their identity) does not allow
	   * duplicate items in arrays. This is because when there are duplicates, it is not possible
	   * to maintain a one-to-one mapping between collection items and DOM elements.
	   *
	   * If you do need to repeat duplicate items, you can substitute the default tracking behavior
	   * with your own using the `track by` expression.
	   *
	   * For example, you may track items by the index of each item in the collection, using the
	   * special scope property `$index`:
	   * ```html
	   *    <div ng-repeat="n in [42, 42, 43, 43] track by $index">
	   *      {{n}}
	   *    </div>
	   * ```
	   *
	   * You may also use arbitrary expressions in `track by`, including references to custom functions
	   * on the scope:
	   * ```html
	   *    <div ng-repeat="n in [42, 42, 43, 43] track by myTrackingFunction(n)">
	   *      {{n}}
	   *    </div>
	   * ```
	   *
	   * <div class="alert alert-success">
	   * If you are working with objects that have an identifier property, you should track
	   * by the identifier instead of the whole object. Should you reload your data later, `ngRepeat`
	   * will not have to rebuild the DOM elements for items it has already rendered, even if the
	   * JavaScript objects in the collection have been substituted for new ones. For large collections,
	   * this significantly improves rendering performance. If you don't have a unique identifier,
	   * `track by $index` can also provide a performance boost.
	   * </div>
	   * ```html
	   *    <div ng-repeat="model in collection track by model.id">
	   *      {{model.name}}
	   *    </div>
	   * ```
	   *
	   * When no `track by` expression is provided, it is equivalent to tracking by the built-in
	   * `$id` function, which tracks items by their identity:
	   * ```html
	   *    <div ng-repeat="obj in collection track by $id(obj)">
	   *      {{obj.prop}}
	   *    </div>
	   * ```
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `track by` must always be the last expression:
	   * </div>
	   * ```
	   * <div ng-repeat="model in collection | orderBy: 'id' as filtered_result track by model.id">
	   *     {{model.name}}
	   * </div>
	   * ```
	   *
	   * # Special repeat start and end points
	   * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	   * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	   * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	   * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	   *
	   * The example below makes use of this feature:
	   * ```html
	   *   <header ng-repeat-start="item in items">
	   *     Header {{ item }}
	   *   </header>
	   *   <div class="body">
	   *     Body {{ item }}
	   *   </div>
	   *   <footer ng-repeat-end>
	   *     Footer {{ item }}
	   *   </footer>
	   * ```
	   *
	   * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	   * ```html
	   *   <header>
	   *     Header A
	   *   </header>
	   *   <div class="body">
	   *     Body A
	   *   </div>
	   *   <footer>
	   *     Footer A
	   *   </footer>
	   *   <header>
	   *     Header B
	   *   </header>
	   *   <div class="body">
	   *     Body B
	   *   </div>
	   *   <footer>
	   *     Footer B
	   *   </footer>
	   * ```
	   *
	   * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	   * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	   *
	   * @animations
	   * | Animation                        | Occurs                              |
	   * |----------------------------------|-------------------------------------|
	   * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	   * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	   * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	   *
	   * See the example below for defining CSS animations with ngRepeat.
	   *
	   * @element ANY
	   * @scope
	   * @priority 1000
	   * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	   *   formats are currently supported:
	   *
	   *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	   *     is a scope expression giving the collection to enumerate.
	   *
	   *     For example: `album in artist.albums`.
	   *
	   *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	   *     and `expression` is the scope expression giving the collection to enumerate.
	   *
	   *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	   *
	   *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	   *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	   *     is specified, ng-repeat associates elements by identity. It is an error to have
	   *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	   *     mapped to the same DOM element, which is not possible.)
	   *
	   *     Note that the tracking expression must come last, after any filters, and the alias expression.
	   *
	   *     For example: `item in items` is equivalent to `item in items track by $id(item)`. This implies that the DOM elements
	   *     will be associated by item identity in the array.
	   *
	   *     For example: `item in items track by $id(item)`. A built in `$id()` function can be used to assign a unique
	   *     `$$hashKey` property to each item in the array. This property is then used as a key to associated DOM elements
	   *     with the corresponding item in the array by identity. Moving the same object in array would move the DOM
	   *     element in the same way in the DOM.
	   *
	   *     For example: `item in items track by item.id` is a typical pattern when the items come from the database. In this
	   *     case the object identity does not matter. Two objects are considered equivalent as long as their `id`
	   *     property is same.
	   *
	   *     For example: `item in items | filter:searchText track by item.id` is a pattern that might be used to apply a filter
	   *     to items in conjunction with a tracking expression.
	   *
	   *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	   *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	   *     when a filter is active on the repeater, but the filtered result set is empty.
	   *
	   *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	   *     the items have been processed through the filter.
	   *
	   *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat micro-syntax so it can be used only at the end
	   *     (and not as operator, inside an expression).
	   *
	   *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results` .
	   *
	   * @example
	   * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	   * results by name. New (entering) and removed (leaving) items are animated.
	   <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
	   <file name="index.html">
	   <div ng-controller="repeatController">
	   I have {{friends.length}} friends. They are:
	   <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	   <ul class="example-animate-container">
	   <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results">
	   [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	   </li>
	   <li class="animate-repeat" ng-if="results.length == 0">
	   <strong>No results found...</strong>
	   </li>
	   </ul>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	   </file>
	   <file name="animations.css">
	   .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	   .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	   .animate-repeat.ng-move,
	   .animate-repeat.ng-enter,
	   .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	   .animate-repeat.ng-leave.ng-leave-active,
	   .animate-repeat.ng-move,
	   .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	   .animate-repeat.ng-leave,
	   .animate-repeat.ng-move.ng-move-active,
	   .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	   </file>
	   <file name="protractor.js" type="protractor">
	   var friends = element.all(by.repeater('friend in friends'));
	
	   it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	   it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	   </file>
	   </example>
	   */
	  var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
	    var NG_REMOVED = '$$NG_REMOVED';
	    var ngRepeatMinErr = minErr('ngRepeat');
	
	    var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	      // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	      scope[valueIdentifier] = value;
	      if (keyIdentifier) scope[keyIdentifier] = key;
	      scope.$index = index;
	      scope.$first = (index === 0);
	      scope.$last = (index === (arrayLength - 1));
	      scope.$middle = !(scope.$first || scope.$last);
	      // jshint bitwise: false
	      scope.$odd = !(scope.$even = (index&1) === 0);
	      // jshint bitwise: true
	    };
	
	    var getBlockStart = function(block) {
	      return block.clone[0];
	    };
	
	    var getBlockEnd = function(block) {
	      return block.clone[block.clone.length - 1];
	    };
	
	
	    return {
	      restrict: 'A',
	      multiElement: true,
	      transclude: 'element',
	      priority: 1000,
	      terminal: true,
	      $$tlb: true,
	      compile: function ngRepeatCompile($element, $attr) {
	        var expression = $attr.ngRepeat;
	        var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
	
	        var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	        if (!match) {
	          throw ngRepeatMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
	            expression);
	        }
	
	        var lhs = match[1];
	        var rhs = match[2];
	        var aliasAs = match[3];
	        var trackByExp = match[4];
	
	        match = lhs.match(/^(?:(\s*[\$\w]+)|\(\s*([\$\w]+)\s*,\s*([\$\w]+)\s*\))$/);
	
	        if (!match) {
	          throw ngRepeatMinErr('iidexp', "'_item_' in '_item_ in _collection_' should be an identifier or '(_key_, _value_)' expression, but got '{0}'.",
	            lhs);
	        }
	        var valueIdentifier = match[3] || match[1];
	        var keyIdentifier = match[2];
	
	        if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	          throw ngRepeatMinErr('badident', "alias '{0}' is invalid --- must be a valid JS identifier which is not a reserved name.",
	            aliasAs);
	        }
	
	        var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
	        var hashFnLocals = {$id: hashKey};
	
	        if (trackByExp) {
	          trackByExpGetter = $parse(trackByExp);
	        } else {
	          trackByIdArrayFn = function(key, value) {
	            return hashKey(value);
	          };
	          trackByIdObjFn = function(key) {
	            return key;
	          };
	        }
	
	        return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	          if (trackByExpGetter) {
	            trackByIdExpFn = function(key, value, index) {
	              // assign key, value, and $index to the locals so that they can be used in hash functions
	              if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	              hashFnLocals[valueIdentifier] = value;
	              hashFnLocals.$index = index;
	              return trackByExpGetter($scope, hashFnLocals);
	            };
	          }
	
	          // Store a list of elements from previous run. This is a hash where key is the item from the
	          // iterator, and the value is objects with following properties.
	          //   - scope: bound scope
	          //   - element: previous element.
	          //   - index: position
	          //
	          // We are using no-proto object so that we don't need to guard against inherited props via
	          // hasOwnProperty.
	          var lastBlockMap = createMap();
	
	          //watch props
	          $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	            var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	            if (aliasAs) {
	              $scope[aliasAs] = collection;
	            }
	
	            if (isArrayLike(collection)) {
	              collectionKeys = collection;
	              trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	            } else {
	              trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	              // if object, extract keys, in enumeration order, unsorted
	              collectionKeys = [];
	              for (var itemKey in collection) {
	                if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
	                  collectionKeys.push(itemKey);
	                }
	              }
	            }
	
	            collectionLength = collectionKeys.length;
	            nextBlockOrder = new Array(collectionLength);
	
	            // locate existing items
	            for (index = 0; index < collectionLength; index++) {
	              key = (collection === collectionKeys) ? index : collectionKeys[index];
	              value = collection[key];
	              trackById = trackByIdFn(key, value, index);
	              if (lastBlockMap[trackById]) {
	                // found previously seen block
	                block = lastBlockMap[trackById];
	                delete lastBlockMap[trackById];
	                nextBlockMap[trackById] = block;
	                nextBlockOrder[index] = block;
	              } else if (nextBlockMap[trackById]) {
	                // if collision detected. restore lastBlockMap and throw an error
	                forEach(nextBlockOrder, function(block) {
	                  if (block && block.scope) lastBlockMap[block.id] = block;
	                });
	                throw ngRepeatMinErr('dupes',
	                  "Duplicates in a repeater are not allowed. Use 'track by' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}",
	                  expression, trackById, value);
	              } else {
	                // new never before seen block
	                nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	                nextBlockMap[trackById] = true;
	              }
	            }
	
	            // remove leftover items
	            for (var blockKey in lastBlockMap) {
	              block = lastBlockMap[blockKey];
	              elementsToRemove = getBlockNodes(block.clone);
	              $animate.leave(elementsToRemove);
	              if (elementsToRemove[0].parentNode) {
	                // if the element was not removed yet because of pending animation, mark it as deleted
	                // so that we can ignore it later
	                for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                  elementsToRemove[index][NG_REMOVED] = true;
	                }
	              }
	              block.scope.$destroy();
	            }
	
	            // we are not using forEach for perf reasons (trying to avoid #call)
	            for (index = 0; index < collectionLength; index++) {
	              key = (collection === collectionKeys) ? index : collectionKeys[index];
	              value = collection[key];
	              block = nextBlockOrder[index];
	
	              if (block.scope) {
	                // if we have already seen this object, then we need to reuse the
	                // associated scope/element
	
	                nextNode = previousNode;
	
	                // skip nodes that are already pending removal via leave animation
	                do {
	                  nextNode = nextNode.nextSibling;
	                } while (nextNode && nextNode[NG_REMOVED]);
	
	                if (getBlockStart(block) != nextNode) {
	                  // existing item which got moved
	                  $animate.move(getBlockNodes(block.clone), null, previousNode);
	                }
	                previousNode = getBlockEnd(block);
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              } else {
	                // new item which we don't know about
	                $transclude(function ngRepeatTransclude(clone, scope) {
	                  block.scope = scope;
	                  // http://jsperf.com/clone-vs-createcomment
	                  var endNode = ngRepeatEndComment.cloneNode(false);
	                  clone[clone.length++] = endNode;
	
	                  $animate.enter(clone, null, previousNode);
	                  previousNode = endNode;
	                  // Note: We only need the first/last node of the cloned nodes.
	                  // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                  // by a directive with templateUrl when its template arrives.
	                  block.clone = clone;
	                  nextBlockMap[block.id] = block;
	                  updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	                });
	              }
	            }
	            lastBlockMap = nextBlockMap;
	          });
	        };
	      }
	    };
	  }];
	
	  var NG_HIDE_CLASS = 'ng-hide';
	  var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	  /**
	   * @ngdoc directive
	   * @name ngShow
	   * @multiElement
	   *
	   * @description
	   * The `ngShow` directive shows or hides the given HTML element based on the expression
	   * provided to the `ngShow` attribute. The element is shown or hidden by removing or adding
	   * the `.ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
	   * in AngularJS and sets the display style to none (using an !important flag).
	   * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	   *
	   * ```html
	   * <!-- when $scope.myValue is truthy (element is visible) -->
	   * <div ng-show="myValue"></div>
	   *
	   * <!-- when $scope.myValue is falsy (element is hidden) -->
	   * <div ng-show="myValue" class="ng-hide"></div>
	   * ```
	   *
	   * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added to the class
	   * attribute on the element causing it to become hidden. When truthy, the `.ng-hide` CSS class is removed
	   * from the element causing the element not to appear hidden.
	   *
	   * ## Why is !important used?
	   *
	   * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
	   * can be easily overridden by heavier selectors. For example, something as simple
	   * as changing the display style on a HTML list item would make hidden elements appear visible.
	   * This also becomes a bigger issue when dealing with CSS frameworks.
	   *
	   * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
	   * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
	   * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
	   *
	   * ### Overriding `.ng-hide`
	   *
	   * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
	   * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
	   * class CSS. Note that the selector that needs to be used is actually `.ng-hide:not(.ng-hide-animate)` to cope
	   * with extra animation classes that can be added.
	   *
	   * ```css
	   * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; this is just another form of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	   * ```
	   *
	   * By default you don't need to override in CSS anything and the animations will work around the display style.
	   *
	   * ## A note about animations with `ngShow`
	   *
	   * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
	   * is true and false. This system works like the animation system present with ngClass except that
	   * you must also include the !important flag to override the display property
	   * so that you can perform an animation when the element is hidden during the time of the animation.
	   *
	   * ```css
	   * //
	   * //a working example can be found at the bottom of this page
	   * //
	   * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   /&#42; this is required as of 1.3x to properly
	 *      apply all styling in a show/hide animation &#42;/
	 *   transition: 0s linear all;
	 * }
	   *
	   * .my-element.ng-hide-add-active,
	   * .my-element.ng-hide-remove-active {
	 *   /&#42; the transition is defined in the active class &#42;/
	 *   transition: 1s linear all;
	 * }
	   *
	   * .my-element.ng-hide-add { ... }
	   * .my-element.ng-hide-add.ng-hide-add-active { ... }
	   * .my-element.ng-hide-remove { ... }
	   * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	   * ```
	   *
	   * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display
	   * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
	   *
	   * @animations
	   * | Animation                        | Occurs                              |
	   * |----------------------------------|-------------------------------------|
	   * | {@link $animate#addClass addClass} `.ng-hide`  | after the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden |
	   * | {@link $animate#removeClass removeClass}  `.ng-hide`  | after the `ngShow` expression evaluates to a truthy value and just before contents are set to visible |
	   *
	   * @element ANY
	   * @param {expression} ngShow If the {@link guide/expression expression} is truthy
	   *     then the element is shown or hidden respectively.
	   *
	   * @example
	   <example module="ngAnimate" deps="angular-animate.js" animations="true">
	   <file name="index.html">
	   Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br/>
	   <div>
	   Show:
	   <div class="check-element animate-show" ng-show="checked">
	   <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
	   </div>
	   </div>
	   <div>
	   Hide:
	   <div class="check-element animate-show" ng-hide="checked">
	   <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
	   </div>
	   </div>
	   </file>
	   <file name="glyphicons.css">
	   @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
	   </file>
	   <file name="animations.css">
	   .animate-show {
	        line-height: 20px;
	        opacity: 1;
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	
	   .animate-show.ng-hide-add, .animate-show.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	   .animate-show.ng-hide {
	        line-height: 0;
	        opacity: 0;
	        padding: 0 10px;
	      }
	
	   .check-element {
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	   </file>
	   <file name="protractor.js" type="protractor">
	   var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
	   var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));
	
	   it('should check ng-show / ng-hide', function() {
	        expect(thumbsUp.isDisplayed()).toBeFalsy();
	        expect(thumbsDown.isDisplayed()).toBeTruthy();
	
	        element(by.model('checked')).click();
	
	        expect(thumbsUp.isDisplayed()).toBeTruthy();
	        expect(thumbsDown.isDisplayed()).toBeFalsy();
	      });
	   </file>
	   </example>
	   */
	  var ngShowDirective = ['$animate', function($animate) {
	    return {
	      restrict: 'A',
	      multiElement: true,
	      link: function(scope, element, attr) {
	        scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	          // we're adding a temporary, animation-specific class for ng-hide since this way
	          // we can control when the element is actually displayed on screen without having
	          // to have a global/greedy CSS selector that breaks when other animations are run.
	          // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	          $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	            tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	          });
	        });
	      }
	    };
	  }];
	
	
	  /**
	   * @ngdoc directive
	   * @name ngHide
	   * @multiElement
	   *
	   * @description
	   * The `ngHide` directive shows or hides the given HTML element based on the expression
	   * provided to the `ngHide` attribute. The element is shown or hidden by removing or adding
	   * the `ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
	   * in AngularJS and sets the display style to none (using an !important flag).
	   * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	   *
	   * ```html
	   * <!-- when $scope.myValue is truthy (element is hidden) -->
	   * <div ng-hide="myValue" class="ng-hide"></div>
	   *
	   * <!-- when $scope.myValue is falsy (element is visible) -->
	   * <div ng-hide="myValue"></div>
	   * ```
	   *
	   * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added to the class
	   * attribute on the element causing it to become hidden. When falsy, the `.ng-hide` CSS class is removed
	   * from the element causing the element not to appear hidden.
	   *
	   * ## Why is !important used?
	   *
	   * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
	   * can be easily overridden by heavier selectors. For example, something as simple
	   * as changing the display style on a HTML list item would make hidden elements appear visible.
	   * This also becomes a bigger issue when dealing with CSS frameworks.
	   *
	   * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
	   * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
	   * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
	   *
	   * ### Overriding `.ng-hide`
	   *
	   * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
	   * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
	   * class in CSS:
	   *
	   * ```css
	   * .ng-hide {
	 *   /&#42; this is just another form of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	   * ```
	   *
	   * By default you don't need to override in CSS anything and the animations will work around the display style.
	   *
	   * ## A note about animations with `ngHide`
	   *
	   * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
	   * is true and false. This system works like the animation system present with ngClass, except that the `.ng-hide`
	   * CSS class is added and removed for you instead of your own CSS class.
	   *
	   * ```css
	   * //
	   * //a working example can be found at the bottom of this page
	   * //
	   * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: 0.5s linear all;
	 * }
	   *
	   * .my-element.ng-hide-add { ... }
	   * .my-element.ng-hide-add.ng-hide-add-active { ... }
	   * .my-element.ng-hide-remove { ... }
	   * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	   * ```
	   *
	   * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display
	   * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
	   *
	   * @animations
	   * | Animation                        | Occurs                              |
	   * |----------------------------------|-------------------------------------|
	   * | {@link $animate#addClass addClass} `.ng-hide`  | after the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden |
	   * | {@link $animate#removeClass removeClass}  `.ng-hide`  | after the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible |
	   *
	   *
	   * @element ANY
	   * @param {expression} ngHide If the {@link guide/expression expression} is truthy then
	   *     the element is shown or hidden respectively.
	   *
	   * @example
	   <example module="ngAnimate" deps="angular-animate.js" animations="true">
	   <file name="index.html">
	   Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br/>
	   <div>
	   Show:
	   <div class="check-element animate-hide" ng-show="checked">
	   <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
	   </div>
	   </div>
	   <div>
	   Hide:
	   <div class="check-element animate-hide" ng-hide="checked">
	   <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
	   </div>
	   </div>
	   </file>
	   <file name="glyphicons.css">
	   @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
	   </file>
	   <file name="animations.css">
	   .animate-hide {
	        transition: all linear 0.5s;
	        line-height: 20px;
	        opacity: 1;
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	
	   .animate-hide.ng-hide {
	        line-height: 0;
	        opacity: 0;
	        padding: 0 10px;
	      }
	
	   .check-element {
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	   </file>
	   <file name="protractor.js" type="protractor">
	   var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
	   var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));
	
	   it('should check ng-show / ng-hide', function() {
	        expect(thumbsUp.isDisplayed()).toBeFalsy();
	        expect(thumbsDown.isDisplayed()).toBeTruthy();
	
	        element(by.model('checked')).click();
	
	        expect(thumbsUp.isDisplayed()).toBeTruthy();
	        expect(thumbsDown.isDisplayed()).toBeFalsy();
	      });
	   </file>
	   </example>
	   */
	  var ngHideDirective = ['$animate', function($animate) {
	    return {
	      restrict: 'A',
	      multiElement: true,
	      link: function(scope, element, attr) {
	        scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	          // The comment inside of the ngShowDirective explains why we add and
	          // remove a temporary class for the show/hide animation
	          $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	            tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	          });
	        });
	      }
	    };
	  }];
	
	  /**
	   * @ngdoc directive
	   * @name ngStyle
	   * @restrict AC
	   *
	   * @description
	   * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	   *
	   * @element ANY
	   * @param {expression} ngStyle
	   *
	   * {@link guide/expression Expression} which evals to an
	   * object whose keys are CSS style names and values are corresponding values for those CSS
	   * keys.
	   *
	   * Since some CSS style names are not valid keys for an object, they must be quoted.
	   * See the 'background-color' style in the example below.
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	   <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	   <input type="button" value="clear" ng-click="myStyle={}">
	   <br/>
	   <span ng-style="myStyle">Sample Text</span>
	   <pre>myStyle={{myStyle}}</pre>
	   </file>
	   <file name="style.css">
	   span {
	         color: black;
	       }
	   </file>
	   <file name="protractor.js" type="protractor">
	   var colorSpan = element(by.css('span'));
	
	   it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	       });
	   </file>
	   </example>
	   */
	  var ngStyleDirective = ngDirective(function(scope, element, attr) {
	    scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	      if (oldStyles && (newStyles !== oldStyles)) {
	        forEach(oldStyles, function(val, style) { element.css(style, '');});
	      }
	      if (newStyles) element.css(newStyles);
	    }, true);
	  });
	
	  /**
	   * @ngdoc directive
	   * @name ngSwitch
	   * @restrict EA
	   *
	   * @description
	   * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	   * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	   * as specified in the template.
	   *
	   * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	   * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	   * matches the value obtained from the evaluated expression. In other words, you define a container element
	   * (where you place the directive), place an expression on the **`on="..."` attribute**
	   * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	   * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	   * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	   * attribute is displayed.
	   *
	   * <div class="alert alert-info">
	   * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	   * as literal string values to match against.
	   * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	   * value of the expression `$scope.someVal`.
	   * </div>
	
	   * @animations
	   * | Animation                        | Occurs                              |
	   * |----------------------------------|-------------------------------------|
	   * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	   * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	   *
	   * @usage
	   *
	   * ```
	   * <ANY ng-switch="expression">
	   *   <ANY ng-switch-when="matchValue1">...</ANY>
	   *   <ANY ng-switch-when="matchValue2">...</ANY>
	   *   <ANY ng-switch-default>...</ANY>
	   * </ANY>
	   * ```
	   *
	   *
	   * @scope
	   * @priority 1200
	   * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	   * On child elements add:
	   *
	   * * `ngSwitchWhen`: the case statement to match against. If match then this
	   *   case will be displayed. If the same match appears multiple times, all the
	   *   elements will be displayed.
	   * * `ngSwitchDefault`: the default case when no other case match. If there
	   *   are multiple default cases, all of them will be displayed when no other
	   *   case match.
	   *
	   *
	   * @example
	   <example module="switchExample" deps="angular-animate.js" animations="true">
	   <file name="index.html">
	   <div ng-controller="ExampleController">
	   <select ng-model="selection" ng-options="item for item in items">
	   </select>
	   <code>selection={{selection}}</code>
	   <hr/>
	   <div class="animate-switch-container"
	   ng-switch on="selection">
	   <div class="animate-switch" ng-switch-when="settings">Settings Div</div>
	   <div class="animate-switch" ng-switch-when="home">Home Span</div>
	   <div class="animate-switch" ng-switch-default>default</div>
	   </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('switchExample', ['ngAnimate'])
	   .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	   </file>
	   <file name="animations.css">
	   .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	   .animate-switch {
	        padding:10px;
	      }
	
	   .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	   .animate-switch.ng-leave.ng-leave-active,
	   .animate-switch.ng-enter {
	        top:-50px;
	      }
	   .animate-switch.ng-leave,
	   .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	   </file>
	   <file name="protractor.js" type="protractor">
	   var switchElem = element(by.css('[ng-switch]'));
	   var select = element(by.model('selection'));
	
	   it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	   it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	   it('should select default', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	   </file>
	   </example>
	   */
	  var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
	    return {
	      require: 'ngSwitch',
	
	      // asks for $scope to fool the BC controller module
	      controller: ['$scope', function ngSwitchController() {
	        this.cases = {};
	      }],
	      link: function(scope, element, attr, ngSwitchController) {
	        var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	        var spliceFactory = function(array, index) {
	          return function() { array.splice(index, 1); };
	        };
	
	        scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	          var i, ii;
	          for (i = 0, ii = previousLeaveAnimations.length; i < ii; ++i) {
	            $animate.cancel(previousLeaveAnimations[i]);
	          }
	          previousLeaveAnimations.length = 0;
	
	          for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	            var selected = getBlockNodes(selectedElements[i].clone);
	            selectedScopes[i].$destroy();
	            var promise = previousLeaveAnimations[i] = $animate.leave(selected);
	            promise.then(spliceFactory(previousLeaveAnimations, i));
	          }
	
	          selectedElements.length = 0;
	          selectedScopes.length = 0;
	
	          if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	            forEach(selectedTranscludes, function(selectedTransclude) {
	              selectedTransclude.transclude(function(caseElement, selectedScope) {
	                selectedScopes.push(selectedScope);
	                var anchor = selectedTransclude.element;
	                caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
	                var block = { clone: caseElement };
	
	                selectedElements.push(block);
	                $animate.enter(caseElement, anchor.parent(), anchor);
	              });
	            });
	          }
	        });
	      }
	    };
	  }];
	
	  var ngSwitchWhenDirective = ngDirective({
	    transclude: 'element',
	    priority: 1200,
	    require: '^ngSwitch',
	    multiElement: true,
	    link: function(scope, element, attrs, ctrl, $transclude) {
	      ctrl.cases['!' + attrs.ngSwitchWhen] = (ctrl.cases['!' + attrs.ngSwitchWhen] || []);
	      ctrl.cases['!' + attrs.ngSwitchWhen].push({ transclude: $transclude, element: element });
	    }
	  });
	
	  var ngSwitchDefaultDirective = ngDirective({
	    transclude: 'element',
	    priority: 1200,
	    require: '^ngSwitch',
	    multiElement: true,
	    link: function(scope, element, attr, ctrl, $transclude) {
	      ctrl.cases['?'] = (ctrl.cases['?'] || []);
	      ctrl.cases['?'].push({ transclude: $transclude, element: element });
	    }
	  });
	
	  /**
	   * @ngdoc directive
	   * @name ngTransclude
	   * @restrict EAC
	   *
	   * @description
	   * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	   *
	   * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	   * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	   *
	   * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	   * content of this element will be removed before the transcluded content is inserted.
	   * If the transcluded content is empty, the existing content is left intact. This lets you provide fallback content in the case
	   * that no transcluded content is provided.
	   *
	   * @element ANY
	   *
	   * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	   *                                               or its value is the same as the name of the attribute then the default slot is used.
	   *
	   * @example
	   * ### Basic transclusion
	   * This example demonstrates basic transclusion of content into a component directive.
	   * <example name="simpleTranscludeExample" module="transcludeExample">
	   *   <file name="index.html">
	   *     <script>
	   *       angular.module('transcludeExample', [])
	   *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	   *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	   *     </script>
	   *     <div ng-controller="ExampleController">
	   *       <input ng-model="title" aria-label="title"> <br/>
	   *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	   *       <pane title="{{title}}">{{text}}</pane>
	   *     </div>
	   *   </file>
	   *   <file name="protractor.js" type="protractor">
	   *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	   *   </file>
	   * </example>
	   *
	   * @example
	   * ### Transclude fallback content
	   * This example shows how to use `NgTransclude` with fallback content, that
	   * is displayed if no transcluded content is provided.
	   *
	   * <example module="transcludeFallbackContentExample">
	   * <file name="index.html">
	   * <script>
	   * angular.module('transcludeFallbackContentExample', [])
	   * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	   * </script>
	   * <!-- fallback button content -->
	   * <my-button id="fallback"></my-button>
	   * <!-- modified button content -->
	   * <my-button id="modified">
	   *   <i style="color: green;">Button2</i>
	   * </my-button>
	   * </file>
	   * <file name="protractor.js" type="protractor">
	   * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	   * </file>
	   * </example>
	   *
	   * @example
	   * ### Multi-slot transclusion
	   * This example demonstrates using multi-slot transclusion in a component directive.
	   * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	   *   <file name="index.html">
	   *    <style>
	   *      .title, .footer {
	 *        background-color: gray
	 *      }
	   *    </style>
	   *    <div ng-controller="ExampleController">
	   *      <input ng-model="title" aria-label="title"> <br/>
	   *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	   *      <pane>
	   *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	   *        <pane-body><p>{{text}}</p></pane-body>
	   *      </pane>
	   *    </div>
	   *   </file>
	   *   <file name="app.js">
	   *    angular.module('multiSlotTranscludeExample', [])
	   *     .directive('pane', function(){
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	   *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = "https://google.com";
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	   *   </file>
	   *   <file name="protractor.js" type="protractor">
	   *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	   *   </file>
	   * </example>
	   */
	  var ngTranscludeMinErr = minErr('ngTransclude');
	  var ngTranscludeDirective = ngDirective({
	    restrict: 'EAC',
	    link: function($scope, $element, $attrs, controller, $transclude) {
	
	      if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
	        // If the attribute is of the form: `ng-transclude="ng-transclude"`
	        // then treat it like the default
	        $attrs.ngTransclude = '';
	      }
	
	      function ngTranscludeCloneAttachFn(clone) {
	        if (clone.length) {
	          $element.empty();
	          $element.append(clone);
	        }
	      }
	
	      if (!$transclude) {
	        throw ngTranscludeMinErr('orphan',
	          'Illegal use of ngTransclude directive in the template! ' +
	          'No parent directive that requires a transclusion found. ' +
	          'Element: {0}',
	          startingTag($element));
	      }
	
	      // If there is no slot name defined or the slot name is not optional
	      // then transclude the slot
	      var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
	      $transclude(ngTranscludeCloneAttachFn, null, slotName);
	    }
	  });
	
	  /**
	   * @ngdoc directive
	   * @name script
	   * @restrict E
	   *
	   * @description
	   * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	   * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	   * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	   * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	   * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	   *
	   * @param {string} type Must be set to `'text/ng-template'`.
	   * @param {string} id Cache name of the template.
	   *
	   * @example
	   <example>
	   <file name="index.html">
	   <script type="text/ng-template" id="/tpl.html">
	   Content of the template.
	   </script>
	
	   <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	   <div id="tpl-content" ng-include src="currentTpl"></div>
	   </file>
	   <file name="protractor.js" type="protractor">
	   it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	   </file>
	   </example>
	   */
	  var scriptDirective = ['$templateCache', function($templateCache) {
	    return {
	      restrict: 'E',
	      terminal: true,
	      compile: function(element, attr) {
	        if (attr.type == 'text/ng-template') {
	          var templateUrl = attr.id,
	            text = element[0].text;
	
	          $templateCache.put(templateUrl, text);
	        }
	      }
	    };
	  }];
	
	  var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	  function chromeHack(optionElement) {
	    // Workaround for https://code.google.com/p/chromium/issues/detail?id=381459
	    // Adding an <option selected="selected"> element to a <select required="required"> should
	    // automatically select the new element
	    if (optionElement[0].hasAttribute('selected')) {
	      optionElement[0].selected = true;
	    }
	  }
	
	  /**
	   * @ngdoc type
	   * @name  select.SelectController
	   * @description
	   * The controller for the `<select>` directive. This provides support for reading
	   * and writing the selected value(s) of the control and also coordinates dynamically
	   * added `<option>` elements, perhaps by an `ngRepeat` directive.
	   */
	  var SelectController =
	    ['$element', '$scope', function($element, $scope) {
	
	      var self = this,
	        optionsMap = new HashMap();
	
	      // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	      self.ngModelCtrl = noopNgModelController;
	
	      // The "unknown" option is one that is prepended to the list if the viewValue
	      // does not match any of the options. When it is rendered the value of the unknown
	      // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	      //
	      // We can't just jqLite('<option>') since jqLite is not smart enough
	      // to create it in <select> and IE barfs otherwise.
	      self.unknownOption = jqLite(window.document.createElement('option'));
	      self.renderUnknownOption = function(val) {
	        var unknownVal = '? ' + hashKey(val) + ' ?';
	        self.unknownOption.val(unknownVal);
	        $element.prepend(self.unknownOption);
	        $element.val(unknownVal);
	      };
	
	      $scope.$on('$destroy', function() {
	        // disable unknown option so that we don't do work when the whole select is being destroyed
	        self.renderUnknownOption = noop;
	      });
	
	      self.removeUnknownOption = function() {
	        if (self.unknownOption.parent()) self.unknownOption.remove();
	      };
	
	
	      // Read the value of the select control, the implementation of this changes depending
	      // upon whether the select can have multiple values and whether ngOptions is at work.
	      self.readValue = function readSingleValue() {
	        self.removeUnknownOption();
	        return $element.val();
	      };
	
	
	      // Write the value to the select control, the implementation of this changes depending
	      // upon whether the select can have multiple values and whether ngOptions is at work.
	      self.writeValue = function writeSingleValue(value) {
	        if (self.hasOption(value)) {
	          self.removeUnknownOption();
	          $element.val(value);
	          if (value === '') self.emptyOption.prop('selected', true); // to make IE9 happy
	        } else {
	          if (value == null && self.emptyOption) {
	            self.removeUnknownOption();
	            $element.val('');
	          } else {
	            self.renderUnknownOption(value);
	          }
	        }
	      };
	
	
	      // Tell the select control that an option, with the given value, has been added
	      self.addOption = function(value, element) {
	        // Skip comment nodes, as they only pollute the `optionsMap`
	        if (element[0].nodeType === NODE_TYPE_COMMENT) return;
	
	        assertNotHasOwnProperty(value, '"option value"');
	        if (value === '') {
	          self.emptyOption = element;
	        }
	        var count = optionsMap.get(value) || 0;
	        optionsMap.put(value, count + 1);
	        self.ngModelCtrl.$render();
	        chromeHack(element);
	      };
	
	      // Tell the select control that an option, with the given value, has been removed
	      self.removeOption = function(value) {
	        var count = optionsMap.get(value);
	        if (count) {
	          if (count === 1) {
	            optionsMap.remove(value);
	            if (value === '') {
	              self.emptyOption = undefined;
	            }
	          } else {
	            optionsMap.put(value, count - 1);
	          }
	        }
	      };
	
	      // Check whether the select control has an option matching the given value
	      self.hasOption = function(value) {
	        return !!optionsMap.get(value);
	      };
	
	
	      self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
	
	        if (interpolateValueFn) {
	          // The value attribute is interpolated
	          var oldVal;
	          optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	            if (isDefined(oldVal)) {
	              self.removeOption(oldVal);
	            }
	            oldVal = newVal;
	            self.addOption(newVal, optionElement);
	          });
	        } else if (interpolateTextFn) {
	          // The text content is interpolated
	          optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
	            optionAttrs.$set('value', newVal);
	            if (oldVal !== newVal) {
	              self.removeOption(oldVal);
	            }
	            self.addOption(newVal, optionElement);
	          });
	        } else {
	          // The value attribute is static
	          self.addOption(optionAttrs.value, optionElement);
	        }
	
	        optionElement.on('$destroy', function() {
	          self.removeOption(optionAttrs.value);
	          self.ngModelCtrl.$render();
	        });
	      };
	    }];
	
	  /**
	   * @ngdoc directive
	   * @name select
	   * @restrict E
	   *
	   * @description
	   * HTML `SELECT` element with angular data-binding.
	   *
	   * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	   * between the scope and the `<select>` control (including setting default values).
	   * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	   * {@link ngOptions `ngOptions`} directives.
	   *
	   * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	   * to the model identified by the `ngModel` directive. With static or repeated options, this is
	   * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	   * If you want dynamic value attributes, you can use interpolation inside the value attribute.
	   *
	   * <div class="alert alert-warning">
	   * Note that the value of a `select` directive used without `ngOptions` is always a string.
	   * When the model needs to be bound to a non-string value, you must either explicitly convert it
	   * using a directive (see example below) or use `ngOptions` to specify the set of options.
	   * This is because an option element can only be bound to string values at present.
	   * </div>
	   *
	   * If the viewValue of `ngModel` does not match any of the options, then the control
	   * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	   *
	   * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	   * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	   * option. See example below for demonstration.
	   *
	   * <div class="alert alert-info">
	   * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits, such as
	   * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	   * comprehension expression, and additionally in reducing memory and increasing speed by not creating
	   * a new scope for each repeated instance.
	   * </div>
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	   *     bound to the model as an array.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds required attribute and required validation constraint to
	   * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	   * when you want to data-bind to the required attribute.
	   * @param {string=} ngChange Angular expression to be executed when selected option(s) changes due to user
	   *    interaction with the select element.
	   * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	   * set on the model on selection. See {@link ngOptions `ngOptions`}.
	   *
	   * @example
	   * ### Simple `select` elements with static options
	   *
	   * <example name="static-select" module="staticSelect">
	   * <file name="index.html">
	   * <div ng-controller="ExampleController">
	   *   <form name="myForm">
	   *     <label for="singleSelect"> Single select: </label><br>
	   *     <select name="singleSelect" ng-model="data.singleSelect">
	   *       <option value="option-1">Option 1</option>
	   *       <option value="option-2">Option 2</option>
	   *     </select><br>
	   *
	   *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	   *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	   *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	   *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	   *       <option value="option-2">Option 2</option>
	   *     </select><br>
	   *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	   *     <tt>singleSelect = {{data.singleSelect}}</tt>
	   *
	   *     <hr>
	   *     <label for="multipleSelect"> Multiple select: </label><br>
	   *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	   *       <option value="option-1">Option 1</option>
	   *       <option value="option-2">Option 2</option>
	   *       <option value="option-3">Option 3</option>
	   *     </select><br>
	   *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	   *   </form>
	   * </div>
	   * </file>
	   * <file name="app.js">
	   *  angular.module('staticSelect', [])
	   *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1',
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	   * </file>
	   *</example>
	   *
	   * ### Using `ngRepeat` to generate `select` options
	   * <example name="ngrepeat-select" module="ngrepeatSelect">
	   * <file name="index.html">
	   * <div ng-controller="ExampleController">
	   *   <form name="myForm">
	   *     <label for="repeatSelect"> Repeat select: </label>
	   *     <select name="repeatSelect" id="repeatSelect" ng-model="data.repeatSelect">
	   *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	   *     </select>
	   *   </form>
	   *   <hr>
	   *   <tt>repeatSelect = {{data.repeatSelect}}</tt><br/>
	   * </div>
	   * </file>
	   * <file name="app.js">
	   *  angular.module('ngrepeatSelect', [])
	   *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       repeatSelect: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *      };
	 *   }]);
	   * </file>
	   *</example>
	   *
	   *
	   * ### Using `select` with `ngOptions` and setting a default value
	   * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	   *
	   * <example name="select-with-default-values" module="defaultValueSelect">
	   * <file name="index.html">
	   * <div ng-controller="ExampleController">
	   *   <form name="myForm">
	   *     <label for="mySelect">Make a choice:</label>
	   *     <select name="mySelect" id="mySelect"
	   *       ng-options="option.name for option in data.availableOptions track by option.id"
	   *       ng-model="data.selectedOption"></select>
	   *   </form>
	   *   <hr>
	   *   <tt>option = {{data.selectedOption}}</tt><br/>
	   * </div>
	   * </file>
	   * <file name="app.js">
	   *  angular.module('defaultValueSelect', [])
	   *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	   * </file>
	   *</example>
	   *
	   *
	   * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	   *
	   * <example name="select-with-non-string-options" module="nonStringSelect">
	   *   <file name="index.html">
	   *     <select ng-model="model.id" convert-to-number>
	   *       <option value="0">Zero</option>
	   *       <option value="1">One</option>
	   *       <option value="2">Two</option>
	   *     </select>
	   *     {{ model }}
	   *   </file>
	   *   <file name="app.js">
	   *     angular.module('nonStringSelect', [])
	   *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	   *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	   *   </file>
	   *   <file name="protractor.js" type="protractor">
	   *     it('should initialize to model', function() {
	 *       var select = element(by.css('select'));
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	   *   </file>
	   * </example>
	   *
	   */
	  var selectDirective = function() {
	
	    return {
	      restrict: 'E',
	      require: ['select', '?ngModel'],
	      controller: SelectController,
	      priority: 1,
	      link: {
	        pre: selectPreLink,
	        post: selectPostLink
	      }
	    };
	
	    function selectPreLink(scope, element, attr, ctrls) {
	
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected) {
	              array.push(option.value);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          var items = new HashMap(value);
	          forEach(element.find('option'), function(option) {
	            option.selected = isDefined(items.get(option.value));
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	
	    function selectPostLink(scope, element, attrs, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`.
	      // This must be done in the postLink fn to prevent $render to be called before
	      // all nodes have been linked correctly.
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	    }
	  };
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	  var optionDirective = ['$interpolate', function($interpolate) {
	    return {
	      restrict: 'E',
	      priority: 100,
	      compile: function(element, attr) {
	        if (isDefined(attr.value)) {
	          // If the value attribute is defined, check if it contains an interpolation
	          var interpolateValueFn = $interpolate(attr.value, true);
	        } else {
	          // If the value attribute is not defined then we fall back to the
	          // text content of the option element, which may be interpolated
	          var interpolateTextFn = $interpolate(element.text(), true);
	          if (!interpolateTextFn) {
	            attr.$set('value', element.text());
	          }
	        }
	
	        return function(scope, element, attr) {
	          // This is an optimization over using ^^ since we don't want to have to search
	          // all the way to the root of the DOM for every single option element
	          var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	          if (selectCtrl) {
	            selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
	          }
	        };
	      }
	    };
	  }];
	
	  var styleDirective = valueFn({
	    restrict: 'E',
	    terminal: false
	  });
	
	  /**
	   * @ngdoc directive
	   * @name ngRequired
	   * @restrict A
	   *
	   * @description
	   *
	   * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	   * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	   * applied to custom controls.
	   *
	   * The directive sets the `required` attribute on the element if the Angular expression inside
	   * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	   * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	   * for more info.
	   *
	   * The validator will set the `required` error key to true if the `required` attribute is set and
	   * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	   * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	   * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	   * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	   *
	   * @example
	   * <example name="ngRequiredDirective" module="ngRequiredExample">
	   *   <file name="index.html">
	   *     <script>
	   *       angular.module('ngRequiredExample', [])
	   *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	   *     </script>
	   *     <div ng-controller="ExampleController">
	   *       <form name="form">
	   *         <label for="required">Toggle required: </label>
	   *         <input type="checkbox" ng-model="required" id="required" />
	   *         <br>
	   *         <label for="input">This input must be filled if `required` is true: </label>
	   *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	   *         <hr>
	   *         required error set? = <code>{{form.input.$error.required}}</code><br>
	   *         model = <code>{{model}}</code>
	   *       </form>
	   *     </div>
	   *   </file>
	   *   <file name="protractor.js" type="protractor">
	   var required = element(by.binding('form.input.$error.required'));
	   var model = element(by.binding('model'));
	   var input = element(by.id('input'));
	
	   it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	   *   </file>
	   * </example>
	   */
	  var requiredDirective = function() {
	    return {
	      restrict: 'A',
	      require: '?ngModel',
	      link: function(scope, elm, attr, ctrl) {
	        if (!ctrl) return;
	        attr.required = true; // force truthy in case we are on non input element
	
	        ctrl.$validators.required = function(modelValue, viewValue) {
	          return !attr.required || !ctrl.$isEmpty(viewValue);
	        };
	
	        attr.$observe('required', function() {
	          ctrl.$validate();
	        });
	      }
	    };
	  };
	
	  /**
	   * @ngdoc directive
	   * @name ngPattern
	   *
	   * @description
	   *
	   * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	   * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	   *
	   * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	   * does not match a RegExp which is obtained by evaluating the Angular expression given in the
	   * `ngPattern` attribute value:
	   * * If the expression evaluates to a RegExp object, then this is used directly.
	   * * If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	   * in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	   *
	   * <div class="alert alert-info">
	   * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   * start at the index of the last search's match, thus not taking the whole input value into
	   * account.
	   * </div>
	   *
	   * <div class="alert alert-info">
	   * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	   * differences:
	   * <ol>
	   *   <li>
	   *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	   *     not available.
	   *   </li>
	   *   <li>
	   *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	   *     interpolated.
	   *   </li>
	   * </ol>
	   * </div>
	   *
	   * @example
	   * <example name="ngPatternDirective" module="ngPatternExample">
	   *   <file name="index.html">
	   *     <script>
	   *       angular.module('ngPatternExample', [])
	   *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	   *     </script>
	   *     <div ng-controller="ExampleController">
	   *       <form name="form">
	   *         <label for="regex">Set a pattern (regex string): </label>
	   *         <input type="text" ng-model="regex" id="regex" />
	   *         <br>
	   *         <label for="input">This input is restricted by the current pattern: </label>
	   *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	   *         <hr>
	   *         input valid? = <code>{{form.input.$valid}}</code><br>
	   *         model = <code>{{model}}</code>
	   *       </form>
	   *     </div>
	   *   </file>
	   *   <file name="protractor.js" type="protractor">
	   var model = element(by.binding('model'));
	   var input = element(by.id('input'));
	
	   it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	   *   </file>
	   * </example>
	   */
	  var patternDirective = function() {
	    return {
	      restrict: 'A',
	      require: '?ngModel',
	      link: function(scope, elm, attr, ctrl) {
	        if (!ctrl) return;
	
	        var regexp, patternExp = attr.ngPattern || attr.pattern;
	        attr.$observe('pattern', function(regex) {
	          if (isString(regex) && regex.length > 0) {
	            regex = new RegExp('^' + regex + '$');
	          }
	
	          if (regex && !regex.test) {
	            throw minErr('ngPattern')('noregexp',
	              'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	              regex, startingTag(elm));
	          }
	
	          regexp = regex || undefined;
	          ctrl.$validate();
	        });
	
	        ctrl.$validators.pattern = function(modelValue, viewValue) {
	          // HTML5 pattern constraint validates the input value, so we validate the viewValue
	          return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	        };
	      }
	    };
	  };
	
	  /**
	   * @ngdoc directive
	   * @name ngMaxlength
	   *
	   * @description
	   *
	   * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	   * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	   *
	   * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	   * is longer than the integer obtained by evaluating the Angular expression given in the
	   * `ngMaxlength` attribute value.
	   *
	   * <div class="alert alert-info">
	   * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	   * differences:
	   * <ol>
	   *   <li>
	   *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	   *     validation is not available.
	   *   </li>
	   *   <li>
	   *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	   *     interpolated.
	   *   </li>
	   * </ol>
	   * </div>
	   *
	   * @example
	   * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	   *   <file name="index.html">
	   *     <script>
	   *       angular.module('ngMaxlengthExample', [])
	   *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	   *     </script>
	   *     <div ng-controller="ExampleController">
	   *       <form name="form">
	   *         <label for="maxlength">Set a maxlength: </label>
	   *         <input type="number" ng-model="maxlength" id="maxlength" />
	   *         <br>
	   *         <label for="input">This input is restricted by the current maxlength: </label>
	   *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	   *         <hr>
	   *         input valid? = <code>{{form.input.$valid}}</code><br>
	   *         model = <code>{{model}}</code>
	   *       </form>
	   *     </div>
	   *   </file>
	   *   <file name="protractor.js" type="protractor">
	   var model = element(by.binding('model'));
	   var input = element(by.id('input'));
	
	   it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	   *   </file>
	   * </example>
	   */
	  var maxlengthDirective = function() {
	    return {
	      restrict: 'A',
	      require: '?ngModel',
	      link: function(scope, elm, attr, ctrl) {
	        if (!ctrl) return;
	
	        var maxlength = -1;
	        attr.$observe('maxlength', function(value) {
	          var intVal = toInt(value);
	          maxlength = isNaN(intVal) ? -1 : intVal;
	          ctrl.$validate();
	        });
	        ctrl.$validators.maxlength = function(modelValue, viewValue) {
	          return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
	        };
	      }
	    };
	  };
	
	  /**
	   * @ngdoc directive
	   * @name ngMinlength
	   *
	   * @description
	   *
	   * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	   * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	   *
	   * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	   * is shorter than the integer obtained by evaluating the Angular expression given in the
	   * `ngMinlength` attribute value.
	   *
	   * <div class="alert alert-info">
	   * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	   * differences:
	   * <ol>
	   *   <li>
	   *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	   *     validation is not available.
	   *   </li>
	   *   <li>
	   *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	   *     interpolated.
	   *   </li>
	   * </ol>
	   * </div>
	   *
	   * @example
	   * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	   *   <file name="index.html">
	   *     <script>
	   *       angular.module('ngMinlengthExample', [])
	   *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	   *     </script>
	   *     <div ng-controller="ExampleController">
	   *       <form name="form">
	   *         <label for="minlength">Set a minlength: </label>
	   *         <input type="number" ng-model="minlength" id="minlength" />
	   *         <br>
	   *         <label for="input">This input is restricted by the current minlength: </label>
	   *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	   *         <hr>
	   *         input valid? = <code>{{form.input.$valid}}</code><br>
	   *         model = <code>{{model}}</code>
	   *       </form>
	   *     </div>
	   *   </file>
	   *   <file name="protractor.js" type="protractor">
	   var model = element(by.binding('model'));
	   var input = element(by.id('input'));
	
	   it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	   *   </file>
	   * </example>
	   */
	  var minlengthDirective = function() {
	    return {
	      restrict: 'A',
	      require: '?ngModel',
	      link: function(scope, elm, attr, ctrl) {
	        if (!ctrl) return;
	
	        var minlength = 0;
	        attr.$observe('minlength', function(value) {
	          minlength = toInt(value) || 0;
	          ctrl.$validate();
	        });
	        ctrl.$validators.minlength = function(modelValue, viewValue) {
	          return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
	        };
	      }
	    };
	  };
	
	  if (window.angular.bootstrap) {
	    //AngularJS is already loaded, so we can return here...
	    if (window.console) {
	      console.log('WARNING: Tried to load angular more than once.');
	    }
	    return;
	  }
	
	//try to bind to jquery now so that one can write jqLite(document).ready()
	//but we will rebind on bootstrap again.
	  bindJQuery();
	
	  publishExternalAPI(angular);
	
	  angular.module("ngLocale", [], ["$provide", function($provide) {
	    var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	    function getDecimals(n) {
	      n = n + '';
	      var i = n.indexOf('.');
	      return (i == -1) ? 0 : n.length - i - 1;
	    }
	
	    function getVF(n, opt_precision) {
	      var v = opt_precision;
	
	      if (undefined === v) {
	        v = Math.min(getDecimals(n), 3);
	      }
	
	      var base = Math.pow(10, v);
	      var f = ((n * base) | 0) % base;
	      return {v: v, f: f};
	    }
	
	    $provide.value("$locale", {
	      "DATETIME_FORMATS": {
	        "AMPMS": [
	          "AM",
	          "PM"
	        ],
	        "DAY": [
	          "Sunday",
	          "Monday",
	          "Tuesday",
	          "Wednesday",
	          "Thursday",
	          "Friday",
	          "Saturday"
	        ],
	        "ERANAMES": [
	          "Before Christ",
	          "Anno Domini"
	        ],
	        "ERAS": [
	          "BC",
	          "AD"
	        ],
	        "FIRSTDAYOFWEEK": 6,
	        "MONTH": [
	          "January",
	          "February",
	          "March",
	          "April",
	          "May",
	          "June",
	          "July",
	          "August",
	          "September",
	          "October",
	          "November",
	          "December"
	        ],
	        "SHORTDAY": [
	          "Sun",
	          "Mon",
	          "Tue",
	          "Wed",
	          "Thu",
	          "Fri",
	          "Sat"
	        ],
	        "SHORTMONTH": [
	          "Jan",
	          "Feb",
	          "Mar",
	          "Apr",
	          "May",
	          "Jun",
	          "Jul",
	          "Aug",
	          "Sep",
	          "Oct",
	          "Nov",
	          "Dec"
	        ],
	        "STANDALONEMONTH": [
	          "January",
	          "February",
	          "March",
	          "April",
	          "May",
	          "June",
	          "July",
	          "August",
	          "September",
	          "October",
	          "November",
	          "December"
	        ],
	        "WEEKENDRANGE": [
	          5,
	          6
	        ],
	        "fullDate": "EEEE, MMMM d, y",
	        "longDate": "MMMM d, y",
	        "medium": "MMM d, y h:mm:ss a",
	        "mediumDate": "MMM d, y",
	        "mediumTime": "h:mm:ss a",
	        "short": "M/d/yy h:mm a",
	        "shortDate": "M/d/yy",
	        "shortTime": "h:mm a"
	      },
	      "NUMBER_FORMATS": {
	        "CURRENCY_SYM": "$",
	        "DECIMAL_SEP": ".",
	        "GROUP_SEP": ",",
	        "PATTERNS": [
	          {
	            "gSize": 3,
	            "lgSize": 3,
	            "maxFrac": 3,
	            "minFrac": 0,
	            "minInt": 1,
	            "negPre": "-",
	            "negSuf": "",
	            "posPre": "",
	            "posSuf": ""
	          },
	          {
	            "gSize": 3,
	            "lgSize": 3,
	            "maxFrac": 2,
	            "minFrac": 2,
	            "minInt": 1,
	            "negPre": "-\u00a4",
	            "negSuf": "",
	            "posPre": "\u00a4",
	            "posSuf": ""
	          }
	        ]
	      },
	      "id": "en-us",
	      "localeID": "en_US",
	      "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	    });
	  }]);
	
	  jqLite(window.document).ready(function() {
	    angularInit(window.document, bootstrap);
	  });
	
	})(window);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');

/***/ },
/* 2 */
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.5.6
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngRoute
	 * @description
	 *
	 * # ngRoute
	 *
	 * The `ngRoute` module provides routing and deeplinking services and directives for angular apps.
	 *
	 * ## Example
	 * See {@link ngRoute.$route#example $route} for an example of configuring and using `ngRoute`.
	 *
	 *
	 * <div doc-module-components="ngRoute"></div>
	 */
	 /* global -ngRouteModule */
	var ngRouteModule = angular.module('ngRoute', ['ng']).
	                        provider('$route', $RouteProvider),
	    $routeMinErr = angular.$$minErr('ngRoute');
	
	/**
	 * @ngdoc provider
	 * @name $routeProvider
	 *
	 * @description
	 *
	 * Used for configuring routes.
	 *
	 * ## Example
	 * See {@link ngRoute.$route#example $route} for an example of configuring and using `ngRoute`.
	 *
	 * ## Dependencies
	 * Requires the {@link ngRoute `ngRoute`} module to be installed.
	 */
	function $RouteProvider() {
	  function inherit(parent, extra) {
	    return angular.extend(Object.create(parent), extra);
	  }
	
	  var routes = {};
	
	  /**
	   * @ngdoc method
	   * @name $routeProvider#when
	   *
	   * @param {string} path Route path (matched against `$location.path`). If `$location.path`
	   *    contains redundant trailing slash or is missing one, the route will still match and the
	   *    `$location.path` will be updated to add or drop the trailing slash to exactly match the
	   *    route definition.
	   *
	   *    * `path` can contain named groups starting with a colon: e.g. `:name`. All characters up
	   *        to the next slash are matched and stored in `$routeParams` under the given `name`
	   *        when the route matches.
	   *    * `path` can contain named groups starting with a colon and ending with a star:
	   *        e.g.`:name*`. All characters are eagerly stored in `$routeParams` under the given `name`
	   *        when the route matches.
	   *    * `path` can contain optional named groups with a question mark: e.g.`:name?`.
	   *
	   *    For example, routes like `/color/:color/largecode/:largecode*\/edit` will match
	   *    `/color/brown/largecode/code/with/slashes/edit` and extract:
	   *
	   *    * `color: brown`
	   *    * `largecode: code/with/slashes`.
	   *
	   *
	   * @param {Object} route Mapping information to be assigned to `$route.current` on route
	   *    match.
	   *
	   *    Object properties:
	   *
	   *    - `controller` – `{(string|function()=}` – Controller fn that should be associated with
	   *      newly created scope or the name of a {@link angular.Module#controller registered
	   *      controller} if passed as a string.
	   *    - `controllerAs` – `{string=}` – An identifier name for a reference to the controller.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used by {@link
	   *      ngRoute.directive:ngView ngView} or {@link ng.directive:ngInclude ngInclude} directives.
	   *      This property takes precedence over `templateUrl`.
	   *
	   *      If `template` is a function, it will be called with the following parameters:
	   *
	   *      - `{Array.<Object>}` - route parameters extracted from the current
	   *        `$location.path()` by applying the current route
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used by {@link ngRoute.directive:ngView ngView}.
	   *
	   *      If `templateUrl` is a function, it will be called with the following parameters:
	   *
	   *      - `{Array.<Object>}` - route parameters extracted from the current
	   *        `$location.path()` by applying the current route
	   *
	   *    - `resolve` - `{Object.<string, function>=}` - An optional map of dependencies which should
	   *      be injected into the controller. If any of these dependencies are promises, the router
	   *      will wait for them all to be resolved or one to be rejected before the controller is
	   *      instantiated.
	   *      If all the promises are resolved successfully, the values of the resolved promises are
	   *      injected and {@link ngRoute.$route#$routeChangeSuccess $routeChangeSuccess} event is
	   *      fired. If any of the promises are rejected the
	   *      {@link ngRoute.$route#$routeChangeError $routeChangeError} event is fired.
	   *      For easier access to the resolved dependencies from the template, the `resolve` map will
	   *      be available on the scope of the route, under `$resolve` (by default) or a custom name
	   *      specified by the `resolveAs` property (see below). This can be particularly useful, when
	   *      working with {@link angular.Module#component components} as route templates.<br />
	   *      <div class="alert alert-warning">
	   *        **Note:** If your scope already contains a property with this name, it will be hidden
	   *        or overwritten. Make sure, you specify an appropriate name for this property, that
	   *        does not collide with other properties on the scope.
	   *      </div>
	   *      The map object is:
	   *
	   *      - `key` – `{string}`: a name of a dependency to be injected into the controller.
	   *      - `factory` - `{string|function}`: If `string` then it is an alias for a service.
	   *        Otherwise if function, then it is {@link auto.$injector#invoke injected}
	   *        and the return value is treated as the dependency. If the result is a promise, it is
	   *        resolved before its value is injected into the controller. Be aware that
	   *        `ngRoute.$routeParams` will still refer to the previous route within these resolve
	   *        functions.  Use `$route.current.params` to access the new route parameters, instead.
	   *
	   *    - `resolveAs` - `{string=}` - The name under which the `resolve` map will be available on
	   *      the scope of the route. If omitted, defaults to `$resolve`.
	   *
	   *    - `redirectTo` – `{(string|function())=}` – value to update
	   *      {@link ng.$location $location} path with and trigger route redirection.
	   *
	   *      If `redirectTo` is a function, it will be called with the following parameters:
	   *
	   *      - `{Object.<string>}` - route parameters extracted from the current
	   *        `$location.path()` by applying the current route templateUrl.
	   *      - `{string}` - current `$location.path()`
	   *      - `{Object}` - current `$location.search()`
	   *
	   *      The custom `redirectTo` function is expected to return a string which will be used
	   *      to update `$location.path()` and `$location.search()`.
	   *
	   *    - `[reloadOnSearch=true]` - `{boolean=}` - reload route when only `$location.search()`
	   *      or `$location.hash()` changes.
	   *
	   *      If the option is set to `false` and url in the browser changes, then
	   *      `$routeUpdate` event is broadcasted on the root scope.
	   *
	   *    - `[caseInsensitiveMatch=false]` - `{boolean=}` - match routes without being case sensitive
	   *
	   *      If the option is set to `true`, then the particular route can be matched without being
	   *      case sensitive
	   *
	   * @returns {Object} self
	   *
	   * @description
	   * Adds a new route definition to the `$route` service.
	   */
	  this.when = function(path, route) {
	    //copy original route object to preserve params inherited from proto chain
	    var routeCopy = angular.copy(route);
	    if (angular.isUndefined(routeCopy.reloadOnSearch)) {
	      routeCopy.reloadOnSearch = true;
	    }
	    if (angular.isUndefined(routeCopy.caseInsensitiveMatch)) {
	      routeCopy.caseInsensitiveMatch = this.caseInsensitiveMatch;
	    }
	    routes[path] = angular.extend(
	      routeCopy,
	      path && pathRegExp(path, routeCopy)
	    );
	
	    // create redirection for trailing slashes
	    if (path) {
	      var redirectPath = (path[path.length - 1] == '/')
	            ? path.substr(0, path.length - 1)
	            : path + '/';
	
	      routes[redirectPath] = angular.extend(
	        {redirectTo: path},
	        pathRegExp(redirectPath, routeCopy)
	      );
	    }
	
	    return this;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $routeProvider#caseInsensitiveMatch
	   * @description
	   *
	   * A boolean property indicating if routes defined
	   * using this provider should be matched using a case insensitive
	   * algorithm. Defaults to `false`.
	   */
	  this.caseInsensitiveMatch = false;
	
	   /**
	    * @param path {string} path
	    * @param opts {Object} options
	    * @return {?Object}
	    *
	    * @description
	    * Normalizes the given path, returning a regular expression
	    * and the original path.
	    *
	    * Inspired by pathRexp in visionmedia/express/lib/utils.js.
	    */
	  function pathRegExp(path, opts) {
	    var insensitive = opts.caseInsensitiveMatch,
	        ret = {
	          originalPath: path,
	          regexp: path
	        },
	        keys = ret.keys = [];
	
	    path = path
	      .replace(/([().])/g, '\\$1')
	      .replace(/(\/)?:(\w+)(\*\?|[\?\*])?/g, function(_, slash, key, option) {
	        var optional = (option === '?' || option === '*?') ? '?' : null;
	        var star = (option === '*' || option === '*?') ? '*' : null;
	        keys.push({ name: key, optional: !!optional });
	        slash = slash || '';
	        return ''
	          + (optional ? '' : slash)
	          + '(?:'
	          + (optional ? slash : '')
	          + (star && '(.+?)' || '([^/]+)')
	          + (optional || '')
	          + ')'
	          + (optional || '');
	      })
	      .replace(/([\/$\*])/g, '\\$1');
	
	    ret.regexp = new RegExp('^' + path + '$', insensitive ? 'i' : '');
	    return ret;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $routeProvider#otherwise
	   *
	   * @description
	   * Sets route definition that will be used on route change when no other route definition
	   * is matched.
	   *
	   * @param {Object|string} params Mapping information to be assigned to `$route.current`.
	   * If called with a string, the value maps to `redirectTo`.
	   * @returns {Object} self
	   */
	  this.otherwise = function(params) {
	    if (typeof params === 'string') {
	      params = {redirectTo: params};
	    }
	    this.when(null, params);
	    return this;
	  };
	
	
	  this.$get = ['$rootScope',
	               '$location',
	               '$routeParams',
	               '$q',
	               '$injector',
	               '$templateRequest',
	               '$sce',
	      function($rootScope, $location, $routeParams, $q, $injector, $templateRequest, $sce) {
	
	    /**
	     * @ngdoc service
	     * @name $route
	     * @requires $location
	     * @requires $routeParams
	     *
	     * @property {Object} current Reference to the current route definition.
	     * The route definition contains:
	     *
	     *   - `controller`: The controller constructor as defined in the route definition.
	     *   - `locals`: A map of locals which is used by {@link ng.$controller $controller} service for
	     *     controller instantiation. The `locals` contain
	     *     the resolved values of the `resolve` map. Additionally the `locals` also contain:
	     *
	     *     - `$scope` - The current route scope.
	     *     - `$template` - The current route template HTML.
	     *
	     *     The `locals` will be assigned to the route scope's `$resolve` property. You can override
	     *     the property name, using `resolveAs` in the route definition. See
	     *     {@link ngRoute.$routeProvider $routeProvider} for more info.
	     *
	     * @property {Object} routes Object with all route configuration Objects as its properties.
	     *
	     * @description
	     * `$route` is used for deep-linking URLs to controllers and views (HTML partials).
	     * It watches `$location.url()` and tries to map the path to an existing route definition.
	     *
	     * Requires the {@link ngRoute `ngRoute`} module to be installed.
	     *
	     * You can define routes through {@link ngRoute.$routeProvider $routeProvider}'s API.
	     *
	     * The `$route` service is typically used in conjunction with the
	     * {@link ngRoute.directive:ngView `ngView`} directive and the
	     * {@link ngRoute.$routeParams `$routeParams`} service.
	     *
	     * @example
	     * This example shows how changing the URL hash causes the `$route` to match a route against the
	     * URL, and the `ngView` pulls in the partial.
	     *
	     * <example name="$route-service" module="ngRouteExample"
	     *          deps="angular-route.js" fixBase="true">
	     *   <file name="index.html">
	     *     <div ng-controller="MainController">
	     *       Choose:
	     *       <a href="Book/Moby">Moby</a> |
	     *       <a href="Book/Moby/ch/1">Moby: Ch1</a> |
	     *       <a href="Book/Gatsby">Gatsby</a> |
	     *       <a href="Book/Gatsby/ch/4?key=value">Gatsby: Ch4</a> |
	     *       <a href="Book/Scarlet">Scarlet Letter</a><br/>
	     *
	     *       <div ng-view></div>
	     *
	     *       <hr />
	     *
	     *       <pre>$location.path() = {{$location.path()}}</pre>
	     *       <pre>$route.current.templateUrl = {{$route.current.templateUrl}}</pre>
	     *       <pre>$route.current.params = {{$route.current.params}}</pre>
	     *       <pre>$route.current.scope.name = {{$route.current.scope.name}}</pre>
	     *       <pre>$routeParams = {{$routeParams}}</pre>
	     *     </div>
	     *   </file>
	     *
	     *   <file name="book.html">
	     *     controller: {{name}}<br />
	     *     Book Id: {{params.bookId}}<br />
	     *   </file>
	     *
	     *   <file name="chapter.html">
	     *     controller: {{name}}<br />
	     *     Book Id: {{params.bookId}}<br />
	     *     Chapter Id: {{params.chapterId}}
	     *   </file>
	     *
	     *   <file name="script.js">
	     *     angular.module('ngRouteExample', ['ngRoute'])
	     *
	     *      .controller('MainController', function($scope, $route, $routeParams, $location) {
	     *          $scope.$route = $route;
	     *          $scope.$location = $location;
	     *          $scope.$routeParams = $routeParams;
	     *      })
	     *
	     *      .controller('BookController', function($scope, $routeParams) {
	     *          $scope.name = "BookController";
	     *          $scope.params = $routeParams;
	     *      })
	     *
	     *      .controller('ChapterController', function($scope, $routeParams) {
	     *          $scope.name = "ChapterController";
	     *          $scope.params = $routeParams;
	     *      })
	     *
	     *     .config(function($routeProvider, $locationProvider) {
	     *       $routeProvider
	     *        .when('/Book/:bookId', {
	     *         templateUrl: 'book.html',
	     *         controller: 'BookController',
	     *         resolve: {
	     *           // I will cause a 1 second delay
	     *           delay: function($q, $timeout) {
	     *             var delay = $q.defer();
	     *             $timeout(delay.resolve, 1000);
	     *             return delay.promise;
	     *           }
	     *         }
	     *       })
	     *       .when('/Book/:bookId/ch/:chapterId', {
	     *         templateUrl: 'chapter.html',
	     *         controller: 'ChapterController'
	     *       });
	     *
	     *       // configure html5 to get links working on jsfiddle
	     *       $locationProvider.html5Mode(true);
	     *     });
	     *
	     *   </file>
	     *
	     *   <file name="protractor.js" type="protractor">
	     *     it('should load and compile correct template', function() {
	     *       element(by.linkText('Moby: Ch1')).click();
	     *       var content = element(by.css('[ng-view]')).getText();
	     *       expect(content).toMatch(/controller\: ChapterController/);
	     *       expect(content).toMatch(/Book Id\: Moby/);
	     *       expect(content).toMatch(/Chapter Id\: 1/);
	     *
	     *       element(by.partialLinkText('Scarlet')).click();
	     *
	     *       content = element(by.css('[ng-view]')).getText();
	     *       expect(content).toMatch(/controller\: BookController/);
	     *       expect(content).toMatch(/Book Id\: Scarlet/);
	     *     });
	     *   </file>
	     * </example>
	     */
	
	    /**
	     * @ngdoc event
	     * @name $route#$routeChangeStart
	     * @eventType broadcast on root scope
	     * @description
	     * Broadcasted before a route change. At this  point the route services starts
	     * resolving all of the dependencies needed for the route change to occur.
	     * Typically this involves fetching the view template as well as any dependencies
	     * defined in `resolve` route property. Once  all of the dependencies are resolved
	     * `$routeChangeSuccess` is fired.
	     *
	     * The route change (and the `$location` change that triggered it) can be prevented
	     * by calling `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on}
	     * for more details about event object.
	     *
	     * @param {Object} angularEvent Synthetic event object.
	     * @param {Route} next Future route information.
	     * @param {Route} current Current route information.
	     */
	
	    /**
	     * @ngdoc event
	     * @name $route#$routeChangeSuccess
	     * @eventType broadcast on root scope
	     * @description
	     * Broadcasted after a route change has happened successfully.
	     * The `resolve` dependencies are now available in the `current.locals` property.
	     *
	     * {@link ngRoute.directive:ngView ngView} listens for the directive
	     * to instantiate the controller and render the view.
	     *
	     * @param {Object} angularEvent Synthetic event object.
	     * @param {Route} current Current route information.
	     * @param {Route|Undefined} previous Previous route information, or undefined if current is
	     * first route entered.
	     */
	
	    /**
	     * @ngdoc event
	     * @name $route#$routeChangeError
	     * @eventType broadcast on root scope
	     * @description
	     * Broadcasted if any of the resolve promises are rejected.
	     *
	     * @param {Object} angularEvent Synthetic event object
	     * @param {Route} current Current route information.
	     * @param {Route} previous Previous route information.
	     * @param {Route} rejection Rejection of the promise. Usually the error of the failed promise.
	     */
	
	    /**
	     * @ngdoc event
	     * @name $route#$routeUpdate
	     * @eventType broadcast on root scope
	     * @description
	     * The `reloadOnSearch` property has been set to false, and we are reusing the same
	     * instance of the Controller.
	     *
	     * @param {Object} angularEvent Synthetic event object
	     * @param {Route} current Current/previous route information.
	     */
	
	    var forceReload = false,
	        preparedRoute,
	        preparedRouteIsUpdateOnly,
	        $route = {
	          routes: routes,
	
	          /**
	           * @ngdoc method
	           * @name $route#reload
	           *
	           * @description
	           * Causes `$route` service to reload the current route even if
	           * {@link ng.$location $location} hasn't changed.
	           *
	           * As a result of that, {@link ngRoute.directive:ngView ngView}
	           * creates new scope and reinstantiates the controller.
	           */
	          reload: function() {
	            forceReload = true;
	
	            var fakeLocationEvent = {
	              defaultPrevented: false,
	              preventDefault: function fakePreventDefault() {
	                this.defaultPrevented = true;
	                forceReload = false;
	              }
	            };
	
	            $rootScope.$evalAsync(function() {
	              prepareRoute(fakeLocationEvent);
	              if (!fakeLocationEvent.defaultPrevented) commitRoute();
	            });
	          },
	
	          /**
	           * @ngdoc method
	           * @name $route#updateParams
	           *
	           * @description
	           * Causes `$route` service to update the current URL, replacing
	           * current route parameters with those specified in `newParams`.
	           * Provided property names that match the route's path segment
	           * definitions will be interpolated into the location's path, while
	           * remaining properties will be treated as query params.
	           *
	           * @param {!Object<string, string>} newParams mapping of URL parameter names to values
	           */
	          updateParams: function(newParams) {
	            if (this.current && this.current.$$route) {
	              newParams = angular.extend({}, this.current.params, newParams);
	              $location.path(interpolate(this.current.$$route.originalPath, newParams));
	              // interpolate modifies newParams, only query params are left
	              $location.search(newParams);
	            } else {
	              throw $routeMinErr('norout', 'Tried updating route when with no current route');
	            }
	          }
	        };
	
	    $rootScope.$on('$locationChangeStart', prepareRoute);
	    $rootScope.$on('$locationChangeSuccess', commitRoute);
	
	    return $route;
	
	    /////////////////////////////////////////////////////
	
	    /**
	     * @param on {string} current url
	     * @param route {Object} route regexp to match the url against
	     * @return {?Object}
	     *
	     * @description
	     * Check if the route matches the current url.
	     *
	     * Inspired by match in
	     * visionmedia/express/lib/router/router.js.
	     */
	    function switchRouteMatcher(on, route) {
	      var keys = route.keys,
	          params = {};
	
	      if (!route.regexp) return null;
	
	      var m = route.regexp.exec(on);
	      if (!m) return null;
	
	      for (var i = 1, len = m.length; i < len; ++i) {
	        var key = keys[i - 1];
	
	        var val = m[i];
	
	        if (key && val) {
	          params[key.name] = val;
	        }
	      }
	      return params;
	    }
	
	    function prepareRoute($locationEvent) {
	      var lastRoute = $route.current;
	
	      preparedRoute = parseRoute();
	      preparedRouteIsUpdateOnly = preparedRoute && lastRoute && preparedRoute.$$route === lastRoute.$$route
	          && angular.equals(preparedRoute.pathParams, lastRoute.pathParams)
	          && !preparedRoute.reloadOnSearch && !forceReload;
	
	      if (!preparedRouteIsUpdateOnly && (lastRoute || preparedRoute)) {
	        if ($rootScope.$broadcast('$routeChangeStart', preparedRoute, lastRoute).defaultPrevented) {
	          if ($locationEvent) {
	            $locationEvent.preventDefault();
	          }
	        }
	      }
	    }
	
	    function commitRoute() {
	      var lastRoute = $route.current;
	      var nextRoute = preparedRoute;
	
	      if (preparedRouteIsUpdateOnly) {
	        lastRoute.params = nextRoute.params;
	        angular.copy(lastRoute.params, $routeParams);
	        $rootScope.$broadcast('$routeUpdate', lastRoute);
	      } else if (nextRoute || lastRoute) {
	        forceReload = false;
	        $route.current = nextRoute;
	        if (nextRoute) {
	          if (nextRoute.redirectTo) {
	            if (angular.isString(nextRoute.redirectTo)) {
	              $location.path(interpolate(nextRoute.redirectTo, nextRoute.params)).search(nextRoute.params)
	                       .replace();
	            } else {
	              $location.url(nextRoute.redirectTo(nextRoute.pathParams, $location.path(), $location.search()))
	                       .replace();
	            }
	          }
	        }
	
	        $q.when(nextRoute).
	          then(resolveLocals).
	          then(function(locals) {
	            // after route change
	            if (nextRoute == $route.current) {
	              if (nextRoute) {
	                nextRoute.locals = locals;
	                angular.copy(nextRoute.params, $routeParams);
	              }
	              $rootScope.$broadcast('$routeChangeSuccess', nextRoute, lastRoute);
	            }
	          }, function(error) {
	            if (nextRoute == $route.current) {
	              $rootScope.$broadcast('$routeChangeError', nextRoute, lastRoute, error);
	            }
	          });
	      }
	    }
	
	    function resolveLocals(route) {
	      if (route) {
	        var locals = angular.extend({}, route.resolve);
	        angular.forEach(locals, function(value, key) {
	          locals[key] = angular.isString(value) ?
	              $injector.get(value) :
	              $injector.invoke(value, null, null, key);
	        });
	        var template = getTemplateFor(route);
	        if (angular.isDefined(template)) {
	          locals['$template'] = template;
	        }
	        return $q.all(locals);
	      }
	    }
	
	
	    function getTemplateFor(route) {
	      var template, templateUrl;
	      if (angular.isDefined(template = route.template)) {
	        if (angular.isFunction(template)) {
	          template = template(route.params);
	        }
	      } else if (angular.isDefined(templateUrl = route.templateUrl)) {
	        if (angular.isFunction(templateUrl)) {
	          templateUrl = templateUrl(route.params);
	        }
	        if (angular.isDefined(templateUrl)) {
	          route.loadedTemplateUrl = $sce.valueOf(templateUrl);
	          template = $templateRequest(templateUrl);
	        }
	      }
	      return template;
	    }
	
	
	    /**
	     * @returns {Object} the current active route, by matching it against the URL
	     */
	    function parseRoute() {
	      // Match a route
	      var params, match;
	      angular.forEach(routes, function(route, path) {
	        if (!match && (params = switchRouteMatcher($location.path(), route))) {
	          match = inherit(route, {
	            params: angular.extend({}, $location.search(), params),
	            pathParams: params});
	          match.$$route = route;
	        }
	      });
	      // No route matched; fallback to "otherwise" route
	      return match || routes[null] && inherit(routes[null], {params: {}, pathParams:{}});
	    }
	
	    /**
	     * @returns {string} interpolation of the redirect path with the parameters
	     */
	    function interpolate(string, params) {
	      var result = [];
	      angular.forEach((string || '').split(':'), function(segment, i) {
	        if (i === 0) {
	          result.push(segment);
	        } else {
	          var segmentMatch = segment.match(/(\w+)(?:[?*])?(.*)/);
	          var key = segmentMatch[1];
	          result.push(params[key]);
	          result.push(segmentMatch[2] || '');
	          delete params[key];
	        }
	      });
	      return result.join('');
	    }
	  }];
	}
	
	ngRouteModule.provider('$routeParams', $RouteParamsProvider);
	
	
	/**
	 * @ngdoc service
	 * @name $routeParams
	 * @requires $route
	 *
	 * @description
	 * The `$routeParams` service allows you to retrieve the current set of route parameters.
	 *
	 * Requires the {@link ngRoute `ngRoute`} module to be installed.
	 *
	 * The route parameters are a combination of {@link ng.$location `$location`}'s
	 * {@link ng.$location#search `search()`} and {@link ng.$location#path `path()`}.
	 * The `path` parameters are extracted when the {@link ngRoute.$route `$route`} path is matched.
	 *
	 * In case of parameter name collision, `path` params take precedence over `search` params.
	 *
	 * The service guarantees that the identity of the `$routeParams` object will remain unchanged
	 * (but its properties will likely change) even when a route change occurs.
	 *
	 * Note that the `$routeParams` are only updated *after* a route change completes successfully.
	 * This means that you cannot rely on `$routeParams` being correct in route resolve functions.
	 * Instead you can use `$route.current.params` to access the new route's parameters.
	 *
	 * @example
	 * ```js
	 *  // Given:
	 *  // URL: http://server.com/index.html#/Chapter/1/Section/2?search=moby
	 *  // Route: /Chapter/:chapterId/Section/:sectionId
	 *  //
	 *  // Then
	 *  $routeParams ==> {chapterId:'1', sectionId:'2', search:'moby'}
	 * ```
	 */
	function $RouteParamsProvider() {
	  this.$get = function() { return {}; };
	}
	
	ngRouteModule.directive('ngView', ngViewFactory);
	ngRouteModule.directive('ngView', ngViewFillContentFactory);
	
	
	/**
	 * @ngdoc directive
	 * @name ngView
	 * @restrict ECA
	 *
	 * @description
	 * # Overview
	 * `ngView` is a directive that complements the {@link ngRoute.$route $route} service by
	 * including the rendered template of the current route into the main layout (`index.html`) file.
	 * Every time the current route changes, the included view changes with it according to the
	 * configuration of the `$route` service.
	 *
	 * Requires the {@link ngRoute `ngRoute`} module to be installed.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM |
	 * | {@link ng.$animate#leave leave}  | when the old element is removed from to the DOM  |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @knownIssue If `ngView` is contained in an asynchronously loaded template (e.g. in another
	 *             directive's templateUrl or in a template loaded using `ngInclude`), then you need to
	 *             make sure that `$route` is instantiated in time to capture the initial
	 *             `$locationChangeStart` event and load the appropriate view. One way to achieve this
	 *             is to have it as a dependency in a `.run` block:
	 *             `myModule.run(['$route', function() {}]);`
	 *
	 * @scope
	 * @priority 400
	 * @param {string=} onload Expression to evaluate whenever the view updates.
	 *
	 * @param {string=} autoscroll Whether `ngView` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the view is updated.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the `autoscroll` attribute value evaluated
	 *                    as an expression yields a truthy value.
	 * @example
	    <example name="ngView-directive" module="ngViewExample"
	             deps="angular-route.js;angular-animate.js"
	             animations="true" fixBase="true">
	      <file name="index.html">
	        <div ng-controller="MainCtrl as main">
	          Choose:
	          <a href="Book/Moby">Moby</a> |
	          <a href="Book/Moby/ch/1">Moby: Ch1</a> |
	          <a href="Book/Gatsby">Gatsby</a> |
	          <a href="Book/Gatsby/ch/4?key=value">Gatsby: Ch4</a> |
	          <a href="Book/Scarlet">Scarlet Letter</a><br/>
	
	          <div class="view-animate-container">
	            <div ng-view class="view-animate"></div>
	          </div>
	          <hr />
	
	          <pre>$location.path() = {{main.$location.path()}}</pre>
	          <pre>$route.current.templateUrl = {{main.$route.current.templateUrl}}</pre>
	          <pre>$route.current.params = {{main.$route.current.params}}</pre>
	          <pre>$routeParams = {{main.$routeParams}}</pre>
	        </div>
	      </file>
	
	      <file name="book.html">
	        <div>
	          controller: {{book.name}}<br />
	          Book Id: {{book.params.bookId}}<br />
	        </div>
	      </file>
	
	      <file name="chapter.html">
	        <div>
	          controller: {{chapter.name}}<br />
	          Book Id: {{chapter.params.bookId}}<br />
	          Chapter Id: {{chapter.params.chapterId}}
	        </div>
	      </file>
	
	      <file name="animations.css">
	        .view-animate-container {
	          position:relative;
	          height:100px!important;
	          background:white;
	          border:1px solid black;
	          height:40px;
	          overflow:hidden;
	        }
	
	        .view-animate {
	          padding:10px;
	        }
	
	        .view-animate.ng-enter, .view-animate.ng-leave {
	          transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 1.5s;
	
	          display:block;
	          width:100%;
	          border-left:1px solid black;
	
	          position:absolute;
	          top:0;
	          left:0;
	          right:0;
	          bottom:0;
	          padding:10px;
	        }
	
	        .view-animate.ng-enter {
	          left:100%;
	        }
	        .view-animate.ng-enter.ng-enter-active {
	          left:0;
	        }
	        .view-animate.ng-leave.ng-leave-active {
	          left:-100%;
	        }
	      </file>
	
	      <file name="script.js">
	        angular.module('ngViewExample', ['ngRoute', 'ngAnimate'])
	          .config(['$routeProvider', '$locationProvider',
	            function($routeProvider, $locationProvider) {
	              $routeProvider
	                .when('/Book/:bookId', {
	                  templateUrl: 'book.html',
	                  controller: 'BookCtrl',
	                  controllerAs: 'book'
	                })
	                .when('/Book/:bookId/ch/:chapterId', {
	                  templateUrl: 'chapter.html',
	                  controller: 'ChapterCtrl',
	                  controllerAs: 'chapter'
	                });
	
	              $locationProvider.html5Mode(true);
	          }])
	          .controller('MainCtrl', ['$route', '$routeParams', '$location',
	            function($route, $routeParams, $location) {
	              this.$route = $route;
	              this.$location = $location;
	              this.$routeParams = $routeParams;
	          }])
	          .controller('BookCtrl', ['$routeParams', function($routeParams) {
	            this.name = "BookCtrl";
	            this.params = $routeParams;
	          }])
	          .controller('ChapterCtrl', ['$routeParams', function($routeParams) {
	            this.name = "ChapterCtrl";
	            this.params = $routeParams;
	          }]);
	
	      </file>
	
	      <file name="protractor.js" type="protractor">
	        it('should load and compile correct template', function() {
	          element(by.linkText('Moby: Ch1')).click();
	          var content = element(by.css('[ng-view]')).getText();
	          expect(content).toMatch(/controller\: ChapterCtrl/);
	          expect(content).toMatch(/Book Id\: Moby/);
	          expect(content).toMatch(/Chapter Id\: 1/);
	
	          element(by.partialLinkText('Scarlet')).click();
	
	          content = element(by.css('[ng-view]')).getText();
	          expect(content).toMatch(/controller\: BookCtrl/);
	          expect(content).toMatch(/Book Id\: Scarlet/);
	        });
	      </file>
	    </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngView#$viewContentLoaded
	 * @eventType emit on the current ngView scope
	 * @description
	 * Emitted every time the ngView content is reloaded.
	 */
	ngViewFactory.$inject = ['$route', '$anchorScroll', '$animate'];
	function ngViewFactory($route, $anchorScroll, $animate) {
	  return {
	    restrict: 'ECA',
	    terminal: true,
	    priority: 400,
	    transclude: 'element',
	    link: function(scope, $element, attr, ctrl, $transclude) {
	        var currentScope,
	            currentElement,
	            previousLeaveAnimation,
	            autoScrollExp = attr.autoscroll,
	            onloadExp = attr.onload || '';
	
	        scope.$on('$routeChangeSuccess', update);
	        update();
	
	        function cleanupLastView() {
	          if (previousLeaveAnimation) {
	            $animate.cancel(previousLeaveAnimation);
	            previousLeaveAnimation = null;
	          }
	
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            previousLeaveAnimation = $animate.leave(currentElement);
	            previousLeaveAnimation.then(function() {
	              previousLeaveAnimation = null;
	            });
	            currentElement = null;
	          }
	        }
	
	        function update() {
	          var locals = $route.current && $route.current.locals,
	              template = locals && locals.$template;
	
	          if (angular.isDefined(template)) {
	            var newScope = scope.$new();
	            var current = $route.current;
	
	            // Note: This will also link all children of ng-view that were contained in the original
	            // html. If that content contains controllers, ... they could pollute/change the scope.
	            // However, using ng-view on an element with additional content does not make sense...
	            // Note: We can't remove them in the cloneAttchFn of $transclude as that
	            // function is called before linking the content, which would apply child
	            // directives to non existing elements.
	            var clone = $transclude(newScope, function(clone) {
	              $animate.enter(clone, null, currentElement || $element).then(function onNgViewEnter() {
	                if (angular.isDefined(autoScrollExp)
	                  && (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                  $anchorScroll();
	                }
	              });
	              cleanupLastView();
	            });
	
	            currentElement = clone;
	            currentScope = current.scope = newScope;
	            currentScope.$emit('$viewContentLoaded');
	            currentScope.$eval(onloadExp);
	          } else {
	            cleanupLastView();
	          }
	        }
	    }
	  };
	}
	
	// This directive is called during the $transclude call of the first `ngView` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngView
	// is called.
	ngViewFillContentFactory.$inject = ['$compile', '$controller', '$route'];
	function ngViewFillContentFactory($compile, $controller, $route) {
	  return {
	    restrict: 'ECA',
	    priority: -400,
	    link: function(scope, $element) {
	      var current = $route.current,
	          locals = current.locals;
	
	      $element.html(locals.$template);
	
	      var link = $compile($element.contents());
	
	      if (current.controller) {
	        locals.$scope = scope;
	        var controller = $controller(current.controller, locals);
	        if (current.controllerAs) {
	          scope[current.controllerAs] = controller;
	        }
	        $element.data('$ngControllerController', controller);
	        $element.children().data('$ngControllerController', controller);
	      }
	      scope[current.resolveAs || '$resolve'] = locals;
	
	      link(scope);
	    }
	  };
	}
	
	
	})(window, window.angular);


/***/ },
/* 3 */
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.5.6
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * # ngSanitize
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 *
	 * <div doc-module-components="ngSanitize"></div>
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   Sanitizes an html string by stripping all potentially dangerous tokens.
	 *
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	 *   then serialized back to properly escaped html string. This means that no unsafe input can make
	 *   it into the returned string.
	 *
	 *   The whitelist for URL sanitization of attribute values is configured using the functions
	 *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link ng.$compileProvider
	 *   `$compileProvider`}.
	 *
	 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getInnerHtml()).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getInnerHtml()).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getInnerHtml()).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getInnerHtml()).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $sanitizeProvider
	 *
	 * @description
	 * Creates and configures {@link $sanitize} instance.
	 */
	function $SanitizeProvider() {
	  var svgEnabled = false;
	
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    if (svgEnabled) {
	      angular.extend(validElements, svgElements);
	    }
	    return function(html) {
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#enableSvg
	   * @kind function
	   *
	   * @description
	   * Enables a subset of svg to be supported by the sanitizer.
	   *
	   * <div class="alert alert-warning">
	   *   <p>By enabling this setting without taking other precautions, you might expose your
	   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
	   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
	   *   link). Such behavior can then result in phishing incidents.</p>
	   *
	   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
	   *   tags within the sanitized content:</p>
	   *
	   *   <br>
	   *
	   *   <pre><code>
	   *   .rootOfTheIncludedContent svg {
	   *     overflow: hidden !important;
	   *   }
	   *   </code></pre>
	   * </div>
	   *
	   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
	   * @returns {boolean|ng.$sanitizeProvider} Returns the currently configured value if called
	   *    without an argument or self for chaining otherwise.
	   */
	  this.enableSvg = function(enableSvg) {
	    if (angular.isDefined(enableSvg)) {
	      svgEnabled = enableSvg;
	      return this;
	    } else {
	      return svgEnabled;
	    }
	  };
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, angular.noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// Regular Expressions for parsing tags and attributes
	var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	  // Match everything outside of normal chars and " (quote character)
	  NON_ALPHANUMERIC_REGEXP = /([^\#-~ |!])/g;
	
	
	// Good source of info about elements and attributes
	// http://dev.w3.org/html5/spec/Overview.html#semantics
	// http://simon.html5.org/html-elements
	
	// Safe Void Elements - HTML5
	// http://dev.w3.org/html5/spec/Overview.html#void-elements
	var voidElements = toMap("area,br,col,hr,img,wbr");
	
	// Elements that you can, intentionally, leave open (and which close themselves)
	// http://dev.w3.org/html5/spec/Overview.html#optional-tags
	var optionalEndTagBlockElements = toMap("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),
	    optionalEndTagInlineElements = toMap("rp,rt"),
	    optionalEndTagElements = angular.extend({},
	                                            optionalEndTagInlineElements,
	                                            optionalEndTagBlockElements);
	
	// Safe Block Elements - HTML5
	var blockElements = angular.extend({}, optionalEndTagBlockElements, toMap("address,article," +
	        "aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5," +
	        "h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul"));
	
	// Inline Elements - HTML5
	var inlineElements = angular.extend({}, optionalEndTagInlineElements, toMap("a,abbr,acronym,b," +
	        "bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s," +
	        "samp,small,span,strike,strong,sub,sup,time,tt,u,var"));
	
	// SVG Elements
	// https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	// Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
	// They can potentially allow for arbitrary javascript to be executed. See #11290
	var svgElements = toMap("circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph," +
	        "hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline," +
	        "radialGradient,rect,stop,svg,switch,text,title,tspan");
	
	// Blocked Elements (will be stripped)
	var blockedElements = toMap("script,style");
	
	var validElements = angular.extend({},
	                                   voidElements,
	                                   blockElements,
	                                   inlineElements,
	                                   optionalEndTagElements);
	
	//Attributes that have href and hence need to be sanitized
	var uriAttrs = toMap("background,cite,href,longdesc,src,xlink:href");
	
	var htmlAttrs = toMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
	    'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
	    'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
	    'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
	    'valign,value,vspace,width');
	
	// SVG attributes (without "id" and "name" attributes)
	// https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	var svgAttrs = toMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
	    'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
	    'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
	    'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
	    'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
	    'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
	    'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
	    'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
	    'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
	    'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
	    'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
	    'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
	    'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
	    'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
	    'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);
	
	var validAttrs = angular.extend({},
	                                uriAttrs,
	                                svgAttrs,
	                                htmlAttrs);
	
	function toMap(str, lowercaseKeys) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[lowercaseKeys ? angular.lowercase(items[i]) : items[i]] = true;
	  }
	  return obj;
	}
	
	var inertBodyElement;
	(function(window) {
	  var doc;
	  if (window.document && window.document.implementation) {
	    doc = window.document.implementation.createHTMLDocument("inert");
	  } else {
	    throw $sanitizeMinErr('noinert', "Can't create an inert html document");
	  }
	  var docElement = doc.documentElement || doc.getDocumentElement();
	  var bodyElements = docElement.getElementsByTagName('body');
	
	  // usually there should be only one body element in the document, but IE doesn't have any, so we need to create one
	  if (bodyElements.length === 1) {
	    inertBodyElement = bodyElements[0];
	  } else {
	    var html = doc.createElement('html');
	    inertBodyElement = doc.createElement('body');
	    html.appendChild(inertBodyElement);
	    doc.appendChild(html);
	  }
	})(window);
	
	/**
	 * @example
	 * htmlParser(htmlString, {
	 *     start: function(tag, attrs) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * });
	 *
	 * @param {string} html string
	 * @param {object} handler
	 */
	function htmlParser(html, handler) {
	  if (html === null || html === undefined) {
	    html = '';
	  } else if (typeof html !== 'string') {
	    html = '' + html;
	  }
	  inertBodyElement.innerHTML = html;
	
	  //mXSS protection
	  var mXSSAttempts = 5;
	  do {
	    if (mXSSAttempts === 0) {
	      throw $sanitizeMinErr('uinput', "Failed to sanitize html because the input is unstable");
	    }
	    mXSSAttempts--;
	
	    // strip custom-namespaced attributes on IE<=11
	    if (window.document.documentMode) {
	      stripCustomNsAttrs(inertBodyElement);
	    }
	    html = inertBodyElement.innerHTML; //trigger mXSS
	    inertBodyElement.innerHTML = html;
	  } while (html !== inertBodyElement.innerHTML);
	
	  var node = inertBodyElement.firstChild;
	  while (node) {
	    switch (node.nodeType) {
	      case 1: // ELEMENT_NODE
	        handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
	        break;
	      case 3: // TEXT NODE
	        handler.chars(node.textContent);
	        break;
	    }
	
	    var nextNode;
	    if (!(nextNode = node.firstChild)) {
	      if (node.nodeType == 1) {
	        handler.end(node.nodeName.toLowerCase());
	      }
	      nextNode = node.nextSibling;
	      if (!nextNode) {
	        while (nextNode == null) {
	          node = node.parentNode;
	          if (node === inertBodyElement) break;
	          nextNode = node.nextSibling;
	          if (node.nodeType == 1) {
	            handler.end(node.nodeName.toLowerCase());
	          }
	        }
	      }
	    }
	    node = nextNode;
	  }
	
	  while (node = inertBodyElement.firstChild) {
	    inertBodyElement.removeChild(node);
	  }
	}
	
	function attrToMap(attrs) {
	  var map = {};
	  for (var i = 0, ii = attrs.length; i < ii; i++) {
	    var attr = attrs[i];
	    map[attr.name] = attr.value;
	  }
	  return map;
	}
	
	
	/**
	 * Escapes all potentially dangerous characters, so that the
	 * resulting string can be safely inserted into attribute or
	 * element text.
	 * @param value
	 * @returns {string} escaped text
	 */
	function encodeEntities(value) {
	  return value.
	    replace(/&/g, '&amp;').
	    replace(SURROGATE_PAIR_REGEXP, function(value) {
	      var hi = value.charCodeAt(0);
	      var low = value.charCodeAt(1);
	      return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	    }).
	    replace(NON_ALPHANUMERIC_REGEXP, function(value) {
	      return '&#' + value.charCodeAt(0) + ';';
	    }).
	    replace(/</g, '&lt;').
	    replace(/>/g, '&gt;');
	}
	
	/**
	 * create an HTML/XML writer which writes to buffer
	 * @param {Array} buf use buf.join('') to get out sanitized html string
	 * @returns {object} in the form of {
	 *     start: function(tag, attrs) {},
	 *     end: function(tag) {},
	 *     chars: function(text) {},
	 *     comment: function(text) {}
	 * }
	 */
	function htmlSanitizeWriter(buf, uriValidator) {
	  var ignoreCurrentElement = false;
	  var out = angular.bind(buf, buf.push);
	  return {
	    start: function(tag, attrs) {
	      tag = angular.lowercase(tag);
	      if (!ignoreCurrentElement && blockedElements[tag]) {
	        ignoreCurrentElement = tag;
	      }
	      if (!ignoreCurrentElement && validElements[tag] === true) {
	        out('<');
	        out(tag);
	        angular.forEach(attrs, function(value, key) {
	          var lkey=angular.lowercase(key);
	          var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
	          if (validAttrs[lkey] === true &&
	            (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	            out(' ');
	            out(key);
	            out('="');
	            out(encodeEntities(value));
	            out('"');
	          }
	        });
	        out('>');
	      }
	    },
	    end: function(tag) {
	      tag = angular.lowercase(tag);
	      if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
	        out('</');
	        out(tag);
	        out('>');
	      }
	      if (tag == ignoreCurrentElement) {
	        ignoreCurrentElement = false;
	      }
	    },
	    chars: function(chars) {
	      if (!ignoreCurrentElement) {
	        out(encodeEntities(chars));
	      }
	    }
	  };
	}
	
	
	/**
	 * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
	 * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
	 * to allow any of these custom attributes. This method strips them all.
	 *
	 * @param node Root element to process
	 */
	function stripCustomNsAttrs(node) {
	  if (node.nodeType === window.Node.ELEMENT_NODE) {
	    var attrs = node.attributes;
	    for (var i = 0, l = attrs.length; i < l; i++) {
	      var attrNode = attrs[i];
	      var attrName = attrNode.name.toLowerCase();
	      if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
	        node.removeAttributeNode(attrNode);
	        i--;
	        l--;
	      }
	    }
	  }
	
	  var nextNode = node.firstChild;
	  if (nextNode) {
	    stripCustomNsAttrs(nextNode);
	  }
	
	  nextNode = node.nextSibling;
	  if (nextNode) {
	    stripCustomNsAttrs(nextNode);
	  }
	}
	
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', []).provider('$sanitize', $SanitizeProvider);
	
	/* global sanitizeText: false */
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports `http/https/ftp/mailto` and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} target Window (`_blank|_self|_parent|_top`) or named frame to open links in.
	 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
	 *
	 *    Can be one of:
	 *
	 *    - `object`: A map of attributes
	 *    - `function`: Takes the url as a parameter and returns a map of attributes
	 *
	 *    If the map of attributes contains a value for `target`, it overrides the value of
	 *    the target parameter.
	 *
	 *
	 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <th>Filter</th>
	           <th>Source</th>
	           <th>Rendered</th>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="linky-custom-attributes">
	          <td>linky custom attributes</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="script.js">
	       angular.module('linkyExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.snippet =
	             'Pretty text with some links:\n'+
	             'http://angularjs.org/,\n'+
	             'mailto:us@somewhere.org,\n'+
	             'another@somewhere.org,\n'+
	             'and one more: ftp://127.0.0.1/.';
	           $scope.snippetWithSingleURL = 'http://angularjs.org/';
	         }]);
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	
	       it('should optionally add custom attributes', function() {
	        expect(element(by.id('linky-custom-attributes')).
	            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
	      MAILTO_REGEXP = /^mailto:/i;
	
	  var linkyMinErr = angular.$$minErr('linky');
	  var isString = angular.isString;
	
	  return function(text, target, attributes) {
	    if (text == null || text === '') return text;
	    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);
	
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/www/mailto then assume mailto
	      if (!match[2] && !match[4]) {
	        url = (match[3] ? 'http://' : 'mailto:') + url;
	      }
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      var key;
	      html.push('<a ');
	      if (angular.isFunction(attributes)) {
	        attributes = attributes(url);
	      }
	      if (angular.isObject(attributes)) {
	        for (key in attributes) {
	          html.push(key + '="' + attributes[key] + '" ');
	        }
	      } else {
	        attributes = {};
	      }
	      if (angular.isDefined(target) && !('target' in attributes)) {
	        html.push('target="',
	                  target,
	                  '" ');
	      }
	      html.push('href="',
	                url.replace(/"/g, '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ },
/* 4 */
/***/ function(module, exports) {

	/*!
	 * ui-select
	 * http://github.com/angular-ui/ui-select
	 * Version: 0.17.1 - 2016-05-16T19:53:09.511Z
	 * License: MIT
	 */
	
	
	(function () { 
	"use strict";
	var KEY = {
	    TAB: 9,
	    ENTER: 13,
	    ESC: 27,
	    SPACE: 32,
	    LEFT: 37,
	    UP: 38,
	    RIGHT: 39,
	    DOWN: 40,
	    SHIFT: 16,
	    CTRL: 17,
	    ALT: 18,
	    PAGE_UP: 33,
	    PAGE_DOWN: 34,
	    HOME: 36,
	    END: 35,
	    BACKSPACE: 8,
	    DELETE: 46,
	    COMMAND: 91,
	
	    MAP: { 91 : "COMMAND", 8 : "BACKSPACE" , 9 : "TAB" , 13 : "ENTER" , 16 : "SHIFT" , 17 : "CTRL" , 18 : "ALT" , 19 : "PAUSEBREAK" , 20 : "CAPSLOCK" , 27 : "ESC" , 32 : "SPACE" , 33 : "PAGE_UP", 34 : "PAGE_DOWN" , 35 : "END" , 36 : "HOME" , 37 : "LEFT" , 38 : "UP" , 39 : "RIGHT" , 40 : "DOWN" , 43 : "+" , 44 : "PRINTSCREEN" , 45 : "INSERT" , 46 : "DELETE", 48 : "0" , 49 : "1" , 50 : "2" , 51 : "3" , 52 : "4" , 53 : "5" , 54 : "6" , 55 : "7" , 56 : "8" , 57 : "9" , 59 : ";", 61 : "=" , 65 : "A" , 66 : "B" , 67 : "C" , 68 : "D" , 69 : "E" , 70 : "F" , 71 : "G" , 72 : "H" , 73 : "I" , 74 : "J" , 75 : "K" , 76 : "L", 77 : "M" , 78 : "N" , 79 : "O" , 80 : "P" , 81 : "Q" , 82 : "R" , 83 : "S" , 84 : "T" , 85 : "U" , 86 : "V" , 87 : "W" , 88 : "X" , 89 : "Y" , 90 : "Z", 96 : "0" , 97 : "1" , 98 : "2" , 99 : "3" , 100 : "4" , 101 : "5" , 102 : "6" , 103 : "7" , 104 : "8" , 105 : "9", 106 : "*" , 107 : "+" , 109 : "-" , 110 : "." , 111 : "/", 112 : "F1" , 113 : "F2" , 114 : "F3" , 115 : "F4" , 116 : "F5" , 117 : "F6" , 118 : "F7" , 119 : "F8" , 120 : "F9" , 121 : "F10" , 122 : "F11" , 123 : "F12", 144 : "NUMLOCK" , 145 : "SCROLLLOCK" , 186 : ";" , 187 : "=" , 188 : "," , 189 : "-" , 190 : "." , 191 : "/" , 192 : "`" , 219 : "[" , 220 : "\\" , 221 : "]" , 222 : "'"
	    },
	
	    isControl: function (e) {
	        var k = e.which;
	        switch (k) {
	        case KEY.COMMAND:
	        case KEY.SHIFT:
	        case KEY.CTRL:
	        case KEY.ALT:
	            return true;
	        }
	
	        if (e.metaKey || e.ctrlKey || e.altKey) return true;
	
	        return false;
	    },
	    isFunctionKey: function (k) {
	        k = k.which ? k.which : k;
	        return k >= 112 && k <= 123;
	    },
	    isVerticalMovement: function (k){
	      return ~[KEY.UP, KEY.DOWN].indexOf(k);
	    },
	    isHorizontalMovement: function (k){
	      return ~[KEY.LEFT,KEY.RIGHT,KEY.BACKSPACE,KEY.DELETE].indexOf(k);
	    },
	    toSeparator: function (k) {
	      var sep = {ENTER:"\n",TAB:"\t",SPACE:" "}[k];
	      if (sep) return sep;
	      // return undefined for special keys other than enter, tab or space.
	      // no way to use them to cut strings.
	      return KEY[k] ? undefined : k;
	    }
	  };
	
	/**
	 * Add querySelectorAll() to jqLite.
	 *
	 * jqLite find() is limited to lookups by tag name.
	 * TODO This will change with future versions of AngularJS, to be removed when this happens
	 *
	 * See jqLite.find - why not use querySelectorAll? https://github.com/angular/angular.js/issues/3586
	 * See feat(jqLite): use querySelectorAll instead of getElementsByTagName in jqLite.find https://github.com/angular/angular.js/pull/3598
	 */
	if (angular.element.prototype.querySelectorAll === undefined) {
	  angular.element.prototype.querySelectorAll = function(selector) {
	    return angular.element(this[0].querySelectorAll(selector));
	  };
	}
	
	/**
	 * Add closest() to jqLite.
	 */
	if (angular.element.prototype.closest === undefined) {
	  angular.element.prototype.closest = function( selector) {
	    var elem = this[0];
	    var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
	
	    while (elem) {
	      if (matchesSelector.bind(elem)(selector)) {
	        return elem;
	      } else {
	        elem = elem.parentElement;
	      }
	    }
	    return false;
	  };
	}
	
	var latestId = 0;
	
	var uis = angular.module('ui.select', [])
	
	.constant('uiSelectConfig', {
	  theme: 'bootstrap',
	  searchEnabled: true,
	  sortable: false,
	  placeholder: '', // Empty by default, like HTML tag <select>
	  refreshDelay: 1000, // In milliseconds
	  closeOnSelect: true,
	  skipFocusser: false,
	  dropdownPosition: 'auto',
	  generateId: function() {
	    return latestId++;
	  },
	  appendToBody: false
	})
	
	// See Rename minErr and make it accessible from outside https://github.com/angular/angular.js/issues/6913
	.service('uiSelectMinErr', function() {
	  var minErr = angular.$$minErr('ui.select');
	  return function() {
	    var error = minErr.apply(this, arguments);
	    var message = error.message.replace(new RegExp('\nhttp://errors.angularjs.org/.*'), '');
	    return new Error(message);
	  };
	})
	
	// Recreates old behavior of ng-transclude. Used internally.
	.directive('uisTranscludeAppend', function () {
	  return {
	    link: function (scope, element, attrs, ctrl, transclude) {
	        transclude(scope, function (clone) {
	          element.append(clone);
	        });
	      }
	    };
	})
	
	/**
	 * Highlights text that matches $select.search.
	 *
	 * Taken from AngularUI Bootstrap Typeahead
	 * See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L340
	 */
	.filter('highlight', function() {
	  function escapeRegexp(queryToEscape) {
	    return ('' + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	  }
	
	  return function(matchItem, query) {
	    return query && matchItem ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<span class="ui-select-highlight">$&</span>') : matchItem;
	  };
	})
	
	/**
	 * A read-only equivalent of jQuery's offset function: http://api.jquery.com/offset/
	 *
	 * Taken from AngularUI Bootstrap Position:
	 * See https://github.com/angular-ui/bootstrap/blob/master/src/position/position.js#L70
	 */
	.factory('uisOffset',
	  ['$document', '$window',
	  function ($document, $window) {
	
	  return function(element) {
	    var boundingClientRect = element[0].getBoundingClientRect();
	    return {
	      width: boundingClientRect.width || element.prop('offsetWidth'),
	      height: boundingClientRect.height || element.prop('offsetHeight'),
	      top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
	      left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
	    };
	  };
	}]);
	
	uis.directive('uiSelectChoices',
	  ['uiSelectConfig', 'uisRepeatParser', 'uiSelectMinErr', '$compile', '$window',
	  function(uiSelectConfig, RepeatParser, uiSelectMinErr, $compile, $window) {
	
	  return {
	    restrict: 'EA',
	    require: '^uiSelect',
	    replace: true,
	    transclude: true,
	    templateUrl: function(tElement) {
	      // Needed so the uiSelect can detect the transcluded content
	      tElement.addClass('ui-select-choices');
	
	      // Gets theme attribute from parent (ui-select)
	      var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	      return theme + '/choices.tpl.html';
	    },
	
	    compile: function(tElement, tAttrs) {
	
	      if (!tAttrs.repeat) throw uiSelectMinErr('repeat', "Expected 'repeat' expression.");
	
	      // var repeat = RepeatParser.parse(attrs.repeat);
	      var groupByExp = tAttrs.groupBy;
	      var groupFilterExp = tAttrs.groupFilter;
	
	      if (groupByExp) {
	        var groups = tElement.querySelectorAll('.ui-select-choices-group');
	        if (groups.length !== 1) throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-group but got '{0}'.", groups.length);
	        groups.attr('ng-repeat', RepeatParser.getGroupNgRepeatExpression());
	      }
	
	      var parserResult = RepeatParser.parse(tAttrs.repeat);
	
	      var choices = tElement.querySelectorAll('.ui-select-choices-row');
	      if (choices.length !== 1) {
	        throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row but got '{0}'.", choices.length);
	      }
	
	      choices.attr('ng-repeat', parserResult.repeatExpression(groupByExp))
	             .attr('ng-if', '$select.open'); //Prevent unnecessary watches when dropdown is closed
	    
	
	      var rowsInner = tElement.querySelectorAll('.ui-select-choices-row-inner');
	      if (rowsInner.length !== 1) {
	        throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row-inner but got '{0}'.", rowsInner.length);
	      }
	      rowsInner.attr('uis-transclude-append', ''); //Adding uisTranscludeAppend directive to row element after choices element has ngRepeat
	
	      // If IE8 then need to target rowsInner to apply the ng-click attr as choices will not capture the event. 
	      var clickTarget = $window.document.addEventListener ? choices : rowsInner;
	      clickTarget.attr('ng-click', '$select.select(' + parserResult.itemName + ',$select.skipFocusser,$event)');
	      
	      return function link(scope, element, attrs, $select) {
	
	       
	        $select.parseRepeatAttr(attrs.repeat, groupByExp, groupFilterExp); //Result ready at $select.parserResult
	
	        $select.disableChoiceExpression = attrs.uiDisableChoice;
	        $select.onHighlightCallback = attrs.onHighlight;
	
	        $select.dropdownPosition = attrs.position ? attrs.position.toLowerCase() : uiSelectConfig.dropdownPosition;        
	
	        scope.$on('$destroy', function() {
	          choices.remove();
	        });
	
	        scope.$watch('$select.search', function(newValue) {
	          if(newValue && !$select.open && $select.multiple) $select.activate(false, true);
	          $select.activeIndex = $select.tagging.isActivated ? -1 : 0;
	          if (!attrs.minimumInputLength || $select.search.length >= attrs.minimumInputLength) {
	            $select.refresh(attrs.refresh);
	          } else {
	            $select.items = [];
	          }
	        });
	
	        attrs.$observe('refreshDelay', function() {
	          // $eval() is needed otherwise we get a string instead of a number
	          var refreshDelay = scope.$eval(attrs.refreshDelay);
	          $select.refreshDelay = refreshDelay !== undefined ? refreshDelay : uiSelectConfig.refreshDelay;
	        });
	      };
	    }
	  };
	}]);
	
	/**
	 * Contains ui-select "intelligence".
	 *
	 * The goal is to limit dependency on the DOM whenever possible and
	 * put as much logic in the controller (instead of the link functions) as possible so it can be easily tested.
	 */
	uis.controller('uiSelectCtrl',
	  ['$scope', '$element', '$timeout', '$filter', '$$uisDebounce', 'uisRepeatParser', 'uiSelectMinErr', 'uiSelectConfig', '$parse', '$injector', '$window',
	  function($scope, $element, $timeout, $filter, $$uisDebounce, RepeatParser, uiSelectMinErr, uiSelectConfig, $parse, $injector, $window) {
	
	  var ctrl = this;
	
	  var EMPTY_SEARCH = '';
	
	  ctrl.placeholder = uiSelectConfig.placeholder;
	  ctrl.searchEnabled = uiSelectConfig.searchEnabled;
	  ctrl.sortable = uiSelectConfig.sortable;
	  ctrl.refreshDelay = uiSelectConfig.refreshDelay;
	  ctrl.paste = uiSelectConfig.paste;
	
	  ctrl.removeSelected = false; //If selected item(s) should be removed from dropdown list
	  ctrl.closeOnSelect = true; //Initialized inside uiSelect directive link function
	  ctrl.skipFocusser = false; //Set to true to avoid returning focus to ctrl when item is selected
	  ctrl.search = EMPTY_SEARCH;
	
	  ctrl.activeIndex = 0; //Dropdown of choices
	  ctrl.items = []; //All available choices
	
	  ctrl.open = false;
	  ctrl.focus = false;
	  ctrl.disabled = false;
	  ctrl.selected = undefined;
	
	  ctrl.dropdownPosition = 'auto';
	
	  ctrl.focusser = undefined; //Reference to input element used to handle focus events
	  ctrl.resetSearchInput = true;
	  ctrl.multiple = undefined; // Initialized inside uiSelect directive link function
	  ctrl.disableChoiceExpression = undefined; // Initialized inside uiSelectChoices directive link function
	  ctrl.tagging = {isActivated: false, fct: undefined};
	  ctrl.taggingTokens = {isActivated: false, tokens: undefined};
	  ctrl.lockChoiceExpression = undefined; // Initialized inside uiSelectMatch directive link function
	  ctrl.clickTriggeredSelect = false;
	  ctrl.$filter = $filter;
	  ctrl.$element = $element;
	
	  // Use $injector to check for $animate and store a reference to it
	  ctrl.$animate = (function () {
	    try {
	      return $injector.get('$animate');
	    } catch (err) {
	      // $animate does not exist
	      return null;
	    }
	  })();
	
	  ctrl.searchInput = $element.querySelectorAll('input.ui-select-search');
	  if (ctrl.searchInput.length !== 1) {
	    throw uiSelectMinErr('searchInput', "Expected 1 input.ui-select-search but got '{0}'.", ctrl.searchInput.length);
	  }
	
	  ctrl.isEmpty = function() {
	    return angular.isUndefined(ctrl.selected) || ctrl.selected === null || ctrl.selected === '' || (ctrl.multiple && ctrl.selected.length === 0);
	  };
	
	  function _findIndex(collection, predicate, thisArg){
	    if (collection.findIndex){
	      return collection.findIndex(predicate, thisArg);
	    } else {
	      var list = Object(collection);
	      var length = list.length >>> 0;
	      var value;
	
	      for (var i = 0; i < length; i++) {
	        value = list[i];
	        if (predicate.call(thisArg, value, i, list)) {
	          return i;
	        }
	      }
	      return -1;
	    }
	  }
	
	  // Most of the time the user does not want to empty the search input when in typeahead mode
	  function _resetSearchInput() {
	    if (ctrl.resetSearchInput || (ctrl.resetSearchInput === undefined && uiSelectConfig.resetSearchInput)) {
	      ctrl.search = EMPTY_SEARCH;
	      //reset activeIndex
	      if (ctrl.selected && ctrl.items.length && !ctrl.multiple) {
	        ctrl.activeIndex = _findIndex(ctrl.items, function(item){
	          return angular.equals(this, item);
	        }, ctrl.selected);
	      }
	    }
	  }
	
	    function _groupsFilter(groups, groupNames) {
	      var i, j, result = [];
	      for(i = 0; i < groupNames.length ;i++){
	        for(j = 0; j < groups.length ;j++){
	          if(groups[j].name == [groupNames[i]]){
	            result.push(groups[j]);
	          }
	        }
	      }
	      return result;
	    }
	
	  // When the user clicks on ui-select, displays the dropdown list
	  ctrl.activate = function(initSearchValue, avoidReset) {
	    if (!ctrl.disabled  && !ctrl.open) {
	      if(!avoidReset) _resetSearchInput();
	
	      $scope.$broadcast('uis:activate');
	
	      ctrl.open = true;
	
	      ctrl.activeIndex = ctrl.activeIndex >= ctrl.items.length ? 0 : ctrl.activeIndex;
	
	      // ensure that the index is set to zero for tagging variants
	      // that where first option is auto-selected
	      if ( ctrl.activeIndex === -1 && ctrl.taggingLabel !== false ) {
	        ctrl.activeIndex = 0;
	      }
	
	      var container = $element.querySelectorAll('.ui-select-choices-content');
	      var searchInput = $element.querySelectorAll('.ui-select-search');
	      if (ctrl.$animate && ctrl.$animate.enabled(container[0])) {
	        var animateHandler = function(elem, phase) {
	          if (phase === 'start' && ctrl.items.length === 0) {
	            // Only focus input after the animation has finished
	            ctrl.$animate.off('removeClass', searchInput[0], animateHandler);
	            $timeout(function () {
	              ctrl.focusSearchInput(initSearchValue);
	            });
	          } else if (phase === 'close') {
	            // Only focus input after the animation has finished
	            ctrl.$animate.off('enter', container[0], animateHandler);
	            $timeout(function () {
	              ctrl.focusSearchInput(initSearchValue);
	            });
	          }
	        };
	
	        if (ctrl.items.length > 0) {
	          ctrl.$animate.on('enter', container[0], animateHandler);
	        } else {
	          ctrl.$animate.on('removeClass', searchInput[0], animateHandler);
	        }
	      } else {
	        $timeout(function () {
	          ctrl.focusSearchInput(initSearchValue);
	          if(!ctrl.tagging.isActivated && ctrl.items.length > 1) {
	            _ensureHighlightVisible();
	          }
	        });
	      }
	    }
	  };
	
	  ctrl.focusSearchInput = function (initSearchValue) {
	    ctrl.search = initSearchValue || ctrl.search;
	    ctrl.searchInput[0].focus();
	  };
	
	  ctrl.findGroupByName = function(name) {
	    return ctrl.groups && ctrl.groups.filter(function(group) {
	      return group.name === name;
	    })[0];
	  };
	
	  ctrl.parseRepeatAttr = function(repeatAttr, groupByExp, groupFilterExp) {
	    function updateGroups(items) {
	      var groupFn = $scope.$eval(groupByExp);
	      ctrl.groups = [];
	      angular.forEach(items, function(item) {
	        var groupName = angular.isFunction(groupFn) ? groupFn(item) : item[groupFn];
	        var group = ctrl.findGroupByName(groupName);
	        if(group) {
	          group.items.push(item);
	        }
	        else {
	          ctrl.groups.push({name: groupName, items: [item]});
	        }
	      });
	      if(groupFilterExp){
	        var groupFilterFn = $scope.$eval(groupFilterExp);
	        if( angular.isFunction(groupFilterFn)){
	          ctrl.groups = groupFilterFn(ctrl.groups);
	        } else if(angular.isArray(groupFilterFn)){
	          ctrl.groups = _groupsFilter(ctrl.groups, groupFilterFn);
	        }
	      }
	      ctrl.items = [];
	      ctrl.groups.forEach(function(group) {
	        ctrl.items = ctrl.items.concat(group.items);
	      });
	    }
	
	    function setPlainItems(items) {
	      ctrl.items = items;
	    }
	
	    ctrl.setItemsFn = groupByExp ? updateGroups : setPlainItems;
	
	    ctrl.parserResult = RepeatParser.parse(repeatAttr);
	
	    ctrl.isGrouped = !!groupByExp;
	    ctrl.itemProperty = ctrl.parserResult.itemName;
	
	    //If collection is an Object, convert it to Array
	
	    var originalSource = ctrl.parserResult.source;
	
	    //When an object is used as source, we better create an array and use it as 'source'
	    var createArrayFromObject = function(){
	      var origSrc = originalSource($scope);
	      $scope.$uisSource = Object.keys(origSrc).map(function(v){
	        var result = {};
	        result[ctrl.parserResult.keyName] = v;
	        result.value = origSrc[v];
	        return result;
	      });
	    };
	
	    if (ctrl.parserResult.keyName){ // Check for (key,value) syntax
	      createArrayFromObject();
	      ctrl.parserResult.source = $parse('$uisSource' + ctrl.parserResult.filters);
	      $scope.$watch(originalSource, function(newVal, oldVal){
	        if (newVal !== oldVal) createArrayFromObject();
	      }, true);
	    }
	
	    ctrl.refreshItems = function (data){
	      data = data || ctrl.parserResult.source($scope);
	      var selectedItems = ctrl.selected;
	      //TODO should implement for single mode removeSelected
	      if (ctrl.isEmpty() || (angular.isArray(selectedItems) && !selectedItems.length) || !ctrl.removeSelected) {
	        ctrl.setItemsFn(data);
	      }else{
	        if ( data !== undefined ) {
	          var filteredItems = data.filter(function(i) {
	            return selectedItems.every(function(selectedItem) {
	              return !angular.equals(i, selectedItem);
	            });
	          });
	          ctrl.setItemsFn(filteredItems);
	        }
	      }
	      if (ctrl.dropdownPosition === 'auto' || ctrl.dropdownPosition === 'up'){
	        $scope.calculateDropdownPos();
	      }
	    };
	
	    // See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L259
	    $scope.$watchCollection(ctrl.parserResult.source, function(items) {
	      if (items === undefined || items === null) {
	        // If the user specifies undefined or null => reset the collection
	        // Special case: items can be undefined if the user did not initialized the collection on the scope
	        // i.e $scope.addresses = [] is missing
	        ctrl.items = [];
	      } else {
	        if (!angular.isArray(items)) {
	          throw uiSelectMinErr('items', "Expected an array but got '{0}'.", items);
	        } else {
	          //Remove already selected items (ex: while searching)
	          //TODO Should add a test
	          ctrl.refreshItems(items);
	
	          //update the view value with fresh data from items, if there is a valid model value
	          if(angular.isDefined(ctrl.ngModel.$modelValue)) {
	            ctrl.ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	          }
	        }
	      }
	    });
	
	  };
	
	  var _refreshDelayPromise;
	
	  /**
	   * Typeahead mode: lets the user refresh the collection using his own function.
	   *
	   * See Expose $select.search for external / remote filtering https://github.com/angular-ui/ui-select/pull/31
	   */
	  ctrl.refresh = function(refreshAttr) {
	    if (refreshAttr !== undefined) {
	
	      // Debounce
	      // See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L155
	      // FYI AngularStrap typeahead does not have debouncing: https://github.com/mgcrea/angular-strap/blob/v2.0.0-rc.4/src/typeahead/typeahead.js#L177
	      if (_refreshDelayPromise) {
	        $timeout.cancel(_refreshDelayPromise);
	      }
	      _refreshDelayPromise = $timeout(function() {
	        $scope.$eval(refreshAttr);
	      }, ctrl.refreshDelay);
	    }
	  };
	
	  ctrl.isActive = function(itemScope) {
	    if ( !ctrl.open ) {
	      return false;
	    }
	    var itemIndex = ctrl.items.indexOf(itemScope[ctrl.itemProperty]);
	    var isActive =  itemIndex == ctrl.activeIndex;
	
	    if ( !isActive || itemIndex < 0 ) {
	      return false;
	    }
	
	    if (isActive && !angular.isUndefined(ctrl.onHighlightCallback)) {
	      itemScope.$eval(ctrl.onHighlightCallback);
	    }
	
	    return isActive;
	  };
	
	  ctrl.isDisabled = function(itemScope) {
	
	    if (!ctrl.open) return;
	
	    var itemIndex = ctrl.items.indexOf(itemScope[ctrl.itemProperty]);
	    var isDisabled = false;
	    var item;
	
	    if (itemIndex >= 0 && !angular.isUndefined(ctrl.disableChoiceExpression)) {
	      item = ctrl.items[itemIndex];
	      isDisabled = !!(itemScope.$eval(ctrl.disableChoiceExpression)); // force the boolean value
	      item._uiSelectChoiceDisabled = isDisabled; // store this for later reference
	    }
	
	    return isDisabled;
	  };
	
	
	  // When the user selects an item with ENTER or clicks the dropdown
	  ctrl.select = function(item, skipFocusser, $event) {
	    if (item === undefined || !item._uiSelectChoiceDisabled) {
	
	      if ( ! ctrl.items && ! ctrl.search && ! ctrl.tagging.isActivated) return;
	
	      if (!item || !item._uiSelectChoiceDisabled) {
	        if(ctrl.tagging.isActivated) {
	          // if taggingLabel is disabled, we pull from ctrl.search val
	          if ( ctrl.taggingLabel === false ) {
	            if ( ctrl.activeIndex < 0 ) {
	              item = ctrl.tagging.fct !== undefined ? ctrl.tagging.fct(ctrl.search) : ctrl.search;
	              if (!item || angular.equals( ctrl.items[0], item ) ) {
	                return;
	              }
	            } else {
	              // keyboard nav happened first, user selected from dropdown
	              item = ctrl.items[ctrl.activeIndex];
	            }
	          } else {
	            // tagging always operates at index zero, taggingLabel === false pushes
	            // the ctrl.search value without having it injected
	            if ( ctrl.activeIndex === 0 ) {
	              // ctrl.tagging pushes items to ctrl.items, so we only have empty val
	              // for `item` if it is a detected duplicate
	              if ( item === undefined ) return;
	
	              // create new item on the fly if we don't already have one;
	              // use tagging function if we have one
	              if ( ctrl.tagging.fct !== undefined && typeof item === 'string' ) {
	                item = ctrl.tagging.fct(item);
	                if (!item) return;
	              // if item type is 'string', apply the tagging label
	              } else if ( typeof item === 'string' ) {
	                // trim the trailing space
	                item = item.replace(ctrl.taggingLabel,'').trim();
	              }
	            }
	          }
	          // search ctrl.selected for dupes potentially caused by tagging and return early if found
	          if ( ctrl.selected && angular.isArray(ctrl.selected) && ctrl.selected.filter( function (selection) { return angular.equals(selection, item); }).length > 0 ) {
	            ctrl.close(skipFocusser);
	            return;
	          }
	        }
	
	        $scope.$broadcast('uis:select', item);
	
	        var locals = {};
	        locals[ctrl.parserResult.itemName] = item;
	
	        $timeout(function(){
	          ctrl.onSelectCallback($scope, {
	            $item: item,
	            $model: ctrl.parserResult.modelMapper($scope, locals)
	          });
	        });
	
	        if (ctrl.closeOnSelect) {
	          ctrl.close(skipFocusser);
	        }
	        if ($event && $event.type === 'click') {
	          ctrl.clickTriggeredSelect = true;
	        }
	      }
	    }
	  };
	
	  // Closes the dropdown
	  ctrl.close = function(skipFocusser) {
	    if (!ctrl.open) return;
	    if (ctrl.ngModel && ctrl.ngModel.$setTouched) ctrl.ngModel.$setTouched();
	    _resetSearchInput();
	    ctrl.open = false;
	
	    $scope.$broadcast('uis:close', skipFocusser);
	
	  };
	
	  ctrl.setFocus = function(){
	    if (!ctrl.focus) ctrl.focusInput[0].focus();
	  };
	
	  ctrl.clear = function($event) {
	    ctrl.select(undefined);
	    $event.stopPropagation();
	    $timeout(function() {
	      ctrl.focusser[0].focus();
	    }, 0, false);
	  };
	
	  // Toggle dropdown
	  ctrl.toggle = function(e) {
	    if (ctrl.open) {
	      ctrl.close();
	      e.preventDefault();
	      e.stopPropagation();
	    } else {
	      ctrl.activate();
	    }
	  };
	
	  ctrl.isLocked = function(itemScope, itemIndex) {
	      var isLocked, item = ctrl.selected[itemIndex];
	
	      if (item && !angular.isUndefined(ctrl.lockChoiceExpression)) {
	          isLocked = !!(itemScope.$eval(ctrl.lockChoiceExpression)); // force the boolean value
	          item._uiSelectChoiceLocked = isLocked; // store this for later reference
	      }
	
	      return isLocked;
	  };
	
	  var sizeWatch = null;
	  var updaterScheduled = false;
	  ctrl.sizeSearchInput = function() {
	
	    var input = ctrl.searchInput[0],
	        container = ctrl.searchInput.parent().parent()[0],
	        calculateContainerWidth = function() {
	          // Return the container width only if the search input is visible
	          return container.clientWidth * !!input.offsetParent;
	        },
	        updateIfVisible = function(containerWidth) {
	          if (containerWidth === 0) {
	            return false;
	          }
	          var inputWidth = containerWidth - input.offsetLeft - 10;
	          if (inputWidth < 50) inputWidth = containerWidth;
	          ctrl.searchInput.css('width', inputWidth+'px');
	          return true;
	        };
	
	    ctrl.searchInput.css('width', '10px');
	    $timeout(function() { //Give tags time to render correctly
	      if (sizeWatch === null && !updateIfVisible(calculateContainerWidth())) {
	        sizeWatch = $scope.$watch(angular.noop, function() {
	          if (!updaterScheduled) {
	            updaterScheduled = true;
	            $scope.$$postDigest(function() {
	              updaterScheduled = false;
	              if (updateIfVisible(calculateContainerWidth())) {
	                sizeWatch();
	                sizeWatch = null;
	              }
	            });
	          }
	        });
	      }
	    });
	  };
	
	  function _handleDropDownSelection(key) {
	    var processed = true;
	    switch (key) {
	      case KEY.DOWN:
	        if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	        else if (ctrl.activeIndex < ctrl.items.length - 1) { ctrl.activeIndex++; }
	        break;
	      case KEY.UP:
	        if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	        else if (ctrl.activeIndex > 0 || (ctrl.search.length === 0 && ctrl.tagging.isActivated && ctrl.activeIndex > -1)) { ctrl.activeIndex--; }
	        break;
	      case KEY.TAB:
	        if (!ctrl.multiple || ctrl.open) ctrl.select(ctrl.items[ctrl.activeIndex], true);
	        break;
	      case KEY.ENTER:
	        if(ctrl.open && (ctrl.tagging.isActivated || ctrl.activeIndex >= 0)){
	          ctrl.select(ctrl.items[ctrl.activeIndex], ctrl.skipFocusser); // Make sure at least one dropdown item is highlighted before adding if not in tagging mode
	        } else {
	          ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	        }
	        break;
	      case KEY.ESC:
	        ctrl.close();
	        break;
	      default:
	        processed = false;
	    }
	    return processed;
	  }
	
	  // Bind to keyboard shortcuts
	  ctrl.searchInput.on('keydown', function(e) {
	
	    var key = e.which;
	
	    if (~[KEY.ENTER,KEY.ESC].indexOf(key)){
	      e.preventDefault();
	      e.stopPropagation();
	    }
	
	    // if(~[KEY.ESC,KEY.TAB].indexOf(key)){
	    //   //TODO: SEGURO?
	    //   ctrl.close();
	    // }
	
	    $scope.$apply(function() {
	
	      var tagged = false;
	
	      if (ctrl.items.length > 0 || ctrl.tagging.isActivated) {
	        _handleDropDownSelection(key);
	        if ( ctrl.taggingTokens.isActivated ) {
	          for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
	            if ( ctrl.taggingTokens.tokens[i] === KEY.MAP[e.keyCode] ) {
	              // make sure there is a new value to push via tagging
	              if ( ctrl.search.length > 0 ) {
	                tagged = true;
	              }
	            }
	          }
	          if ( tagged ) {
	            $timeout(function() {
	              ctrl.searchInput.triggerHandler('tagged');
	              var newItem = ctrl.search.replace(KEY.MAP[e.keyCode],'').trim();
	              if ( ctrl.tagging.fct ) {
	                newItem = ctrl.tagging.fct( newItem );
	              }
	              if (newItem) ctrl.select(newItem, true);
	            });
	          }
	        }
	      }
	
	    });
	
	    if(KEY.isVerticalMovement(key) && ctrl.items.length > 0){
	      _ensureHighlightVisible();
	    }
	
	    if (key === KEY.ENTER || key === KEY.ESC) {
	      e.preventDefault();
	      e.stopPropagation();
	    }
	
	  });
	
	  ctrl.searchInput.on('paste', function (e) {
	    var data;
	
	    if (window.clipboardData && window.clipboardData.getData) { // IE
	      data = window.clipboardData.getData('Text');
	    } else {
	      data = (e.originalEvent || e).clipboardData.getData('text/plain');
	    }
	
	    // Prepend the current input field text to the paste buffer.
	    data = ctrl.search + data;
	
	    if (data && data.length > 0) {
	      // If tagging try to split by tokens and add items
	      if (ctrl.taggingTokens.isActivated) {
	        var items = [];
	        for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {  // split by first token that is contained in data
	          var separator = KEY.toSeparator(ctrl.taggingTokens.tokens[i]) || ctrl.taggingTokens.tokens[i];
	          if (data.indexOf(separator) > -1) {
	            items = data.split(separator);
	            break;  // only split by one token
	          }
	        }
	        if (items.length === 0) {
	          items = [data];
	        }
	        if (items.length > 0) {
	        var oldsearch = ctrl.search;
	          angular.forEach(items, function (item) {
	            var newItem = ctrl.tagging.fct ? ctrl.tagging.fct(item) : item;
	            if (newItem) {
	              ctrl.select(newItem, true);
	            }
	          });
	          ctrl.search = oldsearch || EMPTY_SEARCH;
	          e.preventDefault();
	          e.stopPropagation();
	        }
	      } else if (ctrl.paste) {
	        ctrl.paste(data);
	        ctrl.search = EMPTY_SEARCH;
	        e.preventDefault();
	        e.stopPropagation();
	      }
	    }
	  });
	
	  ctrl.searchInput.on('tagged', function() {
	    $timeout(function() {
	      _resetSearchInput();
	    });
	  });
	
	  // See https://github.com/ivaynberg/select2/blob/3.4.6/select2.js#L1431
	  function _ensureHighlightVisible() {
	    var container = $element.querySelectorAll('.ui-select-choices-content');
	    var choices = container.querySelectorAll('.ui-select-choices-row');
	    if (choices.length < 1) {
	      throw uiSelectMinErr('choices', "Expected multiple .ui-select-choices-row but got '{0}'.", choices.length);
	    }
	
	    if (ctrl.activeIndex < 0) {
	      return;
	    }
	
	    var highlighted = choices[ctrl.activeIndex];
	    var posY = highlighted.offsetTop + highlighted.clientHeight - container[0].scrollTop;
	    var height = container[0].offsetHeight;
	
	    if (posY > height) {
	      container[0].scrollTop += posY - height;
	    } else if (posY < highlighted.clientHeight) {
	      if (ctrl.isGrouped && ctrl.activeIndex === 0)
	        container[0].scrollTop = 0; //To make group header visible when going all the way up
	      else
	        container[0].scrollTop -= highlighted.clientHeight - posY;
	    }
	  }
	
	  var onResize = $$uisDebounce(function() {
	    ctrl.sizeSearchInput();
	  }, 50);
	
	  angular.element($window).bind('resize', onResize);
	
	  $scope.$on('$destroy', function() {
	    ctrl.searchInput.off('keyup keydown tagged blur paste');
	    angular.element($window).off('resize', onResize);
	  });
	}]);
	
	uis.directive('uiSelect',
	  ['$document', 'uiSelectConfig', 'uiSelectMinErr', 'uisOffset', '$compile', '$parse', '$timeout',
	  function($document, uiSelectConfig, uiSelectMinErr, uisOffset, $compile, $parse, $timeout) {
	
	  return {
	    restrict: 'EA',
	    templateUrl: function(tElement, tAttrs) {
	      var theme = tAttrs.theme || uiSelectConfig.theme;
	      return theme + (angular.isDefined(tAttrs.multiple) ? '/select-multiple.tpl.html' : '/select.tpl.html');
	    },
	    replace: true,
	    transclude: true,
	    require: ['uiSelect', '^ngModel'],
	    scope: true,
	
	    controller: 'uiSelectCtrl',
	    controllerAs: '$select',
	    compile: function(tElement, tAttrs) {
	
	      // Allow setting ngClass on uiSelect
	      var match = /{(.*)}\s*{(.*)}/.exec(tAttrs.ngClass);
	      if(match) {
	        var combined = '{'+ match[1] +', '+ match[2] +'}';
	        tAttrs.ngClass = combined;
	        tElement.attr('ng-class', combined);
	      }
	
	      //Multiple or Single depending if multiple attribute presence
	      if (angular.isDefined(tAttrs.multiple))
	        tElement.append('<ui-select-multiple/>').removeAttr('multiple');
	      else
	        tElement.append('<ui-select-single/>');
	
	      if (tAttrs.inputId)
	        tElement.querySelectorAll('input.ui-select-search')[0].id = tAttrs.inputId;
	
	      return function(scope, element, attrs, ctrls, transcludeFn) {
	
	        var $select = ctrls[0];
	        var ngModel = ctrls[1];
	
	        $select.generatedId = uiSelectConfig.generateId();
	        $select.baseTitle = attrs.title || 'Select box';
	        $select.focusserTitle = $select.baseTitle + ' focus';
	        $select.focusserId = 'focusser-' + $select.generatedId;
	
	        $select.closeOnSelect = function() {
	          if (angular.isDefined(attrs.closeOnSelect)) {
	            return $parse(attrs.closeOnSelect)();
	          } else {
	            return uiSelectConfig.closeOnSelect;
	          }
	        }();
	
	        scope.$watch('skipFocusser', function() {
	            var skipFocusser = scope.$eval(attrs.skipFocusser);
	            $select.skipFocusser = skipFocusser !== undefined ? skipFocusser : uiSelectConfig.skipFocusser;
	        });
	
	        $select.onSelectCallback = $parse(attrs.onSelect);
	        $select.onRemoveCallback = $parse(attrs.onRemove);
	
	        //Limit the number of selections allowed
	        $select.limit = (angular.isDefined(attrs.limit)) ? parseInt(attrs.limit, 10) : undefined;
	
	        //Set reference to ngModel from uiSelectCtrl
	        $select.ngModel = ngModel;
	
	        $select.choiceGrouped = function(group){
	          return $select.isGrouped && group && group.name;
	        };
	
	        if(attrs.tabindex){
	          attrs.$observe('tabindex', function(value) {
	            $select.focusInput.attr('tabindex', value);
	            element.removeAttr('tabindex');
	          });
	        }
	
	        scope.$watch('searchEnabled', function() {
	            var searchEnabled = scope.$eval(attrs.searchEnabled);
	            $select.searchEnabled = searchEnabled !== undefined ? searchEnabled : uiSelectConfig.searchEnabled;
	        });
	
	        scope.$watch('sortable', function() {
	            var sortable = scope.$eval(attrs.sortable);
	            $select.sortable = sortable !== undefined ? sortable : uiSelectConfig.sortable;
	        });
	
	        attrs.$observe('disabled', function() {
	          // No need to use $eval() (thanks to ng-disabled) since we already get a boolean instead of a string
	          $select.disabled = attrs.disabled !== undefined ? attrs.disabled : false;
	        });
	
	        attrs.$observe('resetSearchInput', function() {
	          // $eval() is needed otherwise we get a string instead of a boolean
	          var resetSearchInput = scope.$eval(attrs.resetSearchInput);
	          $select.resetSearchInput = resetSearchInput !== undefined ? resetSearchInput : true;
	        });
	
	        attrs.$observe('paste', function() {
	          $select.paste = scope.$eval(attrs.paste);
	        });
	
	        attrs.$observe('tagging', function() {
	          if(attrs.tagging !== undefined)
	          {
	            // $eval() is needed otherwise we get a string instead of a boolean
	            var taggingEval = scope.$eval(attrs.tagging);
	            $select.tagging = {isActivated: true, fct: taggingEval !== true ? taggingEval : undefined};
	          }
	          else
	          {
	            $select.tagging = {isActivated: false, fct: undefined};
	          }
	        });
	
	        attrs.$observe('taggingLabel', function() {
	          if(attrs.tagging !== undefined )
	          {
	            // check eval for FALSE, in this case, we disable the labels
	            // associated with tagging
	            if ( attrs.taggingLabel === 'false' ) {
	              $select.taggingLabel = false;
	            }
	            else
	            {
	              $select.taggingLabel = attrs.taggingLabel !== undefined ? attrs.taggingLabel : '(new)';
	            }
	          }
	        });
	
	        attrs.$observe('taggingTokens', function() {
	          if (attrs.tagging !== undefined) {
	            var tokens = attrs.taggingTokens !== undefined ? attrs.taggingTokens.split('|') : [',','ENTER'];
	            $select.taggingTokens = {isActivated: true, tokens: tokens };
	          }
	        });
	
	        //Automatically gets focus when loaded
	        if (angular.isDefined(attrs.autofocus)){
	          $timeout(function(){
	            $select.setFocus();
	          });
	        }
	
	        //Gets focus based on scope event name (e.g. focus-on='SomeEventName')
	        if (angular.isDefined(attrs.focusOn)){
	          scope.$on(attrs.focusOn, function() {
	              $timeout(function(){
	                $select.setFocus();
	              });
	          });
	        }
	
	        function onDocumentClick(e) {
	          if (!$select.open) return; //Skip it if dropdown is close
	
	          var contains = false;
	
	          if (window.jQuery) {
	            // Firefox 3.6 does not support element.contains()
	            // See Node.contains https://developer.mozilla.org/en-US/docs/Web/API/Node.contains
	            contains = window.jQuery.contains(element[0], e.target);
	          } else {
	            contains = element[0].contains(e.target);
	          }
	
	          if (!contains && !$select.clickTriggeredSelect) {
	            var skipFocusser;
	            if (!$select.skipFocusser) {
	              //Will lose focus only with certain targets
	              var focusableControls = ['input','button','textarea','select'];
	              var targetController = angular.element(e.target).controller('uiSelect'); //To check if target is other ui-select
	              skipFocusser = targetController && targetController !== $select; //To check if target is other ui-select
	              if (!skipFocusser) skipFocusser =  ~focusableControls.indexOf(e.target.tagName.toLowerCase()); //Check if target is input, button or textarea
	            } else {
	              skipFocusser = true;
	            }
	            $select.close(skipFocusser);
	            scope.$digest();
	          }
	          $select.clickTriggeredSelect = false;
	        }
	
	        // See Click everywhere but here event http://stackoverflow.com/questions/12931369
	        $document.on('click', onDocumentClick);
	
	        scope.$on('$destroy', function() {
	          $document.off('click', onDocumentClick);
	        });
	
	        // Move transcluded elements to their correct position in main template
	        transcludeFn(scope, function(clone) {
	          // See Transclude in AngularJS http://blog.omkarpatil.com/2012/11/transclude-in-angularjs.html
	
	          // One day jqLite will be replaced by jQuery and we will be able to write:
	          // var transcludedElement = clone.filter('.my-class')
	          // instead of creating a hackish DOM element:
	          var transcluded = angular.element('<div>').append(clone);
	
	          var transcludedMatch = transcluded.querySelectorAll('.ui-select-match');
	          transcludedMatch.removeAttr('ui-select-match'); //To avoid loop in case directive as attr
	          transcludedMatch.removeAttr('data-ui-select-match'); // Properly handle HTML5 data-attributes
	          if (transcludedMatch.length !== 1) {
	            throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-match but got '{0}'.", transcludedMatch.length);
	          }
	          element.querySelectorAll('.ui-select-match').replaceWith(transcludedMatch);
	
	          var transcludedChoices = transcluded.querySelectorAll('.ui-select-choices');
	          transcludedChoices.removeAttr('ui-select-choices'); //To avoid loop in case directive as attr
	          transcludedChoices.removeAttr('data-ui-select-choices'); // Properly handle HTML5 data-attributes
	          if (transcludedChoices.length !== 1) {
	            throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-choices but got '{0}'.", transcludedChoices.length);
	          }
	          element.querySelectorAll('.ui-select-choices').replaceWith(transcludedChoices);
	
	          var transcludedNoChoice = transcluded.querySelectorAll('.ui-select-no-choice');
	          transcludedNoChoice.removeAttr('ui-select-no-choice'); //To avoid loop in case directive as attr
	          transcludedNoChoice.removeAttr('data-ui-select-no-choice'); // Properly handle HTML5 data-attributes
	          if (transcludedNoChoice.length == 1) {
	            element.querySelectorAll('.ui-select-no-choice').replaceWith(transcludedNoChoice);
	          }
	        });
	
	        // Support for appending the select field to the body when its open
	        var appendToBody = scope.$eval(attrs.appendToBody);
	        if (appendToBody !== undefined ? appendToBody : uiSelectConfig.appendToBody) {
	          scope.$watch('$select.open', function(isOpen) {
	            if (isOpen) {
	              positionDropdown();
	            } else {
	              resetDropdown();
	            }
	          });
	
	          // Move the dropdown back to its original location when the scope is destroyed. Otherwise
	          // it might stick around when the user routes away or the select field is otherwise removed
	          scope.$on('$destroy', function() {
	            resetDropdown();
	          });
	        }
	
	        // Hold on to a reference to the .ui-select-container element for appendToBody support
	        var placeholder = null,
	            originalWidth = '';
	
	        function positionDropdown() {
	          // Remember the absolute position of the element
	          var offset = uisOffset(element);
	
	          // Clone the element into a placeholder element to take its original place in the DOM
	          placeholder = angular.element('<div class="ui-select-placeholder"></div>');
	          placeholder[0].style.width = offset.width + 'px';
	          placeholder[0].style.height = offset.height + 'px';
	          element.after(placeholder);
	
	          // Remember the original value of the element width inline style, so it can be restored
	          // when the dropdown is closed
	          originalWidth = element[0].style.width;
	
	          // Now move the actual dropdown element to the end of the body
	          $document.find('body').append(element);
	
	          element[0].style.position = 'absolute';
	          element[0].style.left = offset.left + 'px';
	          element[0].style.top = offset.top + 'px';
	          element[0].style.width = offset.width + 'px';
	        }
	
	        function resetDropdown() {
	          if (placeholder === null) {
	            // The dropdown has not actually been display yet, so there's nothing to reset
	            return;
	          }
	
	          // Move the dropdown element back to its original location in the DOM
	          placeholder.replaceWith(element);
	          placeholder = null;
	
	          element[0].style.position = '';
	          element[0].style.left = '';
	          element[0].style.top = '';
	          element[0].style.width = originalWidth;
	
	          // Set focus back on to the moved element
	          $select.setFocus();
	        }
	
	        // Hold on to a reference to the .ui-select-dropdown element for direction support.
	        var dropdown = null,
	            directionUpClassName = 'direction-up';
	
	        // Support changing the direction of the dropdown if there isn't enough space to render it.
	        scope.$watch('$select.open', function() {
	
	          if ($select.dropdownPosition === 'auto' || $select.dropdownPosition === 'up'){
	            scope.calculateDropdownPos();
	          }
	
	        });
	
	        var setDropdownPosUp = function(offset, offsetDropdown){
	
	          offset = offset || uisOffset(element);
	          offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	          dropdown[0].style.position = 'absolute';
	          dropdown[0].style.top = (offsetDropdown.height * -1) + 'px';
	          element.addClass(directionUpClassName);
	
	        };
	
	        var setDropdownPosDown = function(offset, offsetDropdown){
	
	          element.removeClass(directionUpClassName);
	
	          offset = offset || uisOffset(element);
	          offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	          dropdown[0].style.position = '';
	          dropdown[0].style.top = '';
	
	        };
	
	        scope.calculateDropdownPos = function(){
	
	          if ($select.open) {
	            dropdown = angular.element(element).querySelectorAll('.ui-select-dropdown');
	            if (dropdown.length === 0) {
	              return;
	            }
	
	            // Hide the dropdown so there is no flicker until $timeout is done executing.
	            dropdown[0].style.opacity = 0;
	
	            // Delay positioning the dropdown until all choices have been added so its height is correct.
	            $timeout(function(){
	
	              if ($select.dropdownPosition === 'up'){
	                  //Go UP
	                  setDropdownPosUp();
	
	              }else{ //AUTO
	
	                element.removeClass(directionUpClassName);
	
	                var offset = uisOffset(element);
	                var offsetDropdown = uisOffset(dropdown);
	
	                //https://code.google.com/p/chromium/issues/detail?id=342307#c4
	                var scrollTop = $document[0].documentElement.scrollTop || $document[0].body.scrollTop; //To make it cross browser (blink, webkit, IE, Firefox).
	
	                // Determine if the direction of the dropdown needs to be changed.
	                if (offset.top + offset.height + offsetDropdown.height > scrollTop + $document[0].documentElement.clientHeight) {
	                  //Go UP
	                  setDropdownPosUp(offset, offsetDropdown);
	                }else{
	                  //Go DOWN
	                  setDropdownPosDown(offset, offsetDropdown);
	                }
	
	              }
	
	              // Display the dropdown once it has been positioned.
	              dropdown[0].style.opacity = 1;
	            });
	          } else {
	              if (dropdown === null || dropdown.length === 0) {
	                return;
	              }
	
	              // Reset the position of the dropdown.
	              dropdown[0].style.position = '';
	              dropdown[0].style.top = '';
	              element.removeClass(directionUpClassName);
	          }
	        };
	      };
	    }
	  };
	}]);
	
	uis.directive('uiSelectMatch', ['uiSelectConfig', function(uiSelectConfig) {
	  return {
	    restrict: 'EA',
	    require: '^uiSelect',
	    replace: true,
	    transclude: true,
	    templateUrl: function(tElement) {
	      // Needed so the uiSelect can detect the transcluded content
	      tElement.addClass('ui-select-match');
	
	      var parent = tElement.parent();
	      // Gets theme attribute from parent (ui-select)
	      var theme = getAttribute(parent, 'theme') || uiSelectConfig.theme;
	      var multi = angular.isDefined(getAttribute(parent, 'multiple'));
	
	      return theme + (multi ? '/match-multiple.tpl.html' : '/match.tpl.html');      
	    },
	    link: function(scope, element, attrs, $select) {
	      $select.lockChoiceExpression = attrs.uiLockChoice;
	      attrs.$observe('placeholder', function(placeholder) {
	        $select.placeholder = placeholder !== undefined ? placeholder : uiSelectConfig.placeholder;
	      });
	
	      function setAllowClear(allow) {
	        $select.allowClear = (angular.isDefined(allow)) ? (allow === '') ? true : (allow.toLowerCase() === 'true') : false;
	      }
	
	      attrs.$observe('allowClear', setAllowClear);
	      setAllowClear(attrs.allowClear);
	
	      if($select.multiple){
	        $select.sizeSearchInput();
	      }
	
	    }
	  };
	
	  function getAttribute(elem, attribute) {
	    if (elem[0].hasAttribute(attribute))
	      return elem.attr(attribute);
	
	    if (elem[0].hasAttribute('data-' + attribute))
	      return elem.attr('data-' + attribute);
	
	    if (elem[0].hasAttribute('x-' + attribute))
	      return elem.attr('x-' + attribute);
	  }
	}]);
	
	uis.directive('uiSelectMultiple', ['uiSelectMinErr','$timeout', function(uiSelectMinErr, $timeout) {
	  return {
	    restrict: 'EA',
	    require: ['^uiSelect', '^ngModel'],
	
	    controller: ['$scope','$timeout', function($scope, $timeout){
	
	      var ctrl = this,
	          $select = $scope.$select,
	          ngModel;
	
	      if (angular.isUndefined($select.selected))
	        $select.selected = [];
	
	      //Wait for link fn to inject it
	      $scope.$evalAsync(function(){ ngModel = $scope.ngModel; });
	
	      ctrl.activeMatchIndex = -1;
	
	      ctrl.updateModel = function(){
	        ngModel.$setViewValue(Date.now()); //Set timestamp as a unique string to force changes
	        ctrl.refreshComponent();
	      };
	
	      ctrl.refreshComponent = function(){
	        //Remove already selected items
	        //e.g. When user clicks on a selection, the selected array changes and
	        //the dropdown should remove that item
	        $select.refreshItems();
	        $select.sizeSearchInput();
	      };
	
	      // Remove item from multiple select
	      ctrl.removeChoice = function(index){
	
	        var removedChoice = $select.selected[index];
	
	        // if the choice is locked, can't remove it
	        if(removedChoice._uiSelectChoiceLocked) return;
	
	        var locals = {};
	        locals[$select.parserResult.itemName] = removedChoice;
	
	        $select.selected.splice(index, 1);
	        ctrl.activeMatchIndex = -1;
	        $select.sizeSearchInput();
	
	        // Give some time for scope propagation.
	        $timeout(function(){
	          $select.onRemoveCallback($scope, {
	            $item: removedChoice,
	            $model: $select.parserResult.modelMapper($scope, locals)
	          });
	        });
	
	        ctrl.updateModel();
	
	      };
	
	      ctrl.getPlaceholder = function(){
	        //Refactor single?
	        if($select.selected && $select.selected.length) return;
	        return $select.placeholder;
	      };
	
	
	    }],
	    controllerAs: '$selectMultiple',
	
	    link: function(scope, element, attrs, ctrls) {
	
	      var $select = ctrls[0];
	      var ngModel = scope.ngModel = ctrls[1];
	      var $selectMultiple = scope.$selectMultiple;
	
	      //$select.selected = raw selected objects (ignoring any property binding)
	
	      $select.multiple = true;
	      $select.removeSelected = true;
	
	      //Input that will handle focus
	      $select.focusInput = $select.searchInput;
	
	      //Properly check for empty if set to multiple
	      ngModel.$isEmpty = function(value) {
	        return !value || value.length === 0;
	      };
	
	      //From view --> model
	      ngModel.$parsers.unshift(function () {
	        var locals = {},
	            result,
	            resultMultiple = [];
	        for (var j = $select.selected.length - 1; j >= 0; j--) {
	          locals = {};
	          locals[$select.parserResult.itemName] = $select.selected[j];
	          result = $select.parserResult.modelMapper(scope, locals);
	          resultMultiple.unshift(result);
	        }
	        return resultMultiple;
	      });
	
	      // From model --> view
	      ngModel.$formatters.unshift(function (inputValue) {
	        var data = $select.parserResult && $select.parserResult.source (scope, { $select : {search:''}}), //Overwrite $search
	            locals = {},
	            result;
	        if (!data) return inputValue;
	        var resultMultiple = [];
	        var checkFnMultiple = function(list, value){
	          if (!list || !list.length) return;
	          for (var p = list.length - 1; p >= 0; p--) {
	            locals[$select.parserResult.itemName] = list[p];
	            result = $select.parserResult.modelMapper(scope, locals);
	            if($select.parserResult.trackByExp){
	                var propsItemNameMatches = /(\w*)\./.exec($select.parserResult.trackByExp);
	                var matches = /\.([^\s]+)/.exec($select.parserResult.trackByExp);
	                if(propsItemNameMatches && propsItemNameMatches.length > 0 && propsItemNameMatches[1] == $select.parserResult.itemName){
	                  if(matches && matches.length>0 && result[matches[1]] == value[matches[1]]){
	                      resultMultiple.unshift(list[p]);
	                      return true;
	                  }
	                }
	            }
	            if (angular.equals(result,value)){
	              resultMultiple.unshift(list[p]);
	              return true;
	            }
	          }
	          return false;
	        };
	        if (!inputValue) return resultMultiple; //If ngModel was undefined
	        for (var k = inputValue.length - 1; k >= 0; k--) {
	          //Check model array of currently selected items
	          if (!checkFnMultiple($select.selected, inputValue[k])){
	            //Check model array of all items available
	            if (!checkFnMultiple(data, inputValue[k])){
	              //If not found on previous lists, just add it directly to resultMultiple
	              resultMultiple.unshift(inputValue[k]);
	            }
	          }
	        }
	        return resultMultiple;
	      });
	
	      //Watch for external model changes
	      scope.$watchCollection(function(){ return ngModel.$modelValue; }, function(newValue, oldValue) {
	        if (oldValue != newValue){
	          //update the view value with fresh data from items, if there is a valid model value
	          if(angular.isDefined(ngModel.$modelValue)) {
	            ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	          }
	          $selectMultiple.refreshComponent();
	        }
	      });
	
	      ngModel.$render = function() {
	        // Make sure that model value is array
	        if(!angular.isArray(ngModel.$viewValue)){
	          // Have tolerance for null or undefined values
	          if(angular.isUndefined(ngModel.$viewValue) || ngModel.$viewValue === null){
	            $select.selected = [];
	          } else {
	            throw uiSelectMinErr('multiarr', "Expected model value to be array but got '{0}'", ngModel.$viewValue);
	          }
	        }
	        $select.selected = ngModel.$viewValue;
	        $selectMultiple.refreshComponent();
	        scope.$evalAsync(); //To force $digest
	      };
	
	      scope.$on('uis:select', function (event, item) {
	        if($select.selected.length >= $select.limit) {
	          return;
	        }
	        $select.selected.push(item);
	        $selectMultiple.updateModel();
	      });
	
	      scope.$on('uis:activate', function () {
	        $selectMultiple.activeMatchIndex = -1;
	      });
	
	      scope.$watch('$select.disabled', function(newValue, oldValue) {
	        // As the search input field may now become visible, it may be necessary to recompute its size
	        if (oldValue && !newValue) $select.sizeSearchInput();
	      });
	
	      $select.searchInput.on('keydown', function(e) {
	        var key = e.which;
	        scope.$apply(function() {
	          var processed = false;
	          // var tagged = false; //Checkme
	          if(KEY.isHorizontalMovement(key)){
	            processed = _handleMatchSelection(key);
	          }
	          if (processed  && key != KEY.TAB) {
	            //TODO Check si el tab selecciona aun correctamente
	            //Crear test
	            e.preventDefault();
	            e.stopPropagation();
	          }
	        });
	      });
	      function _getCaretPosition(el) {
	        if(angular.isNumber(el.selectionStart)) return el.selectionStart;
	        // selectionStart is not supported in IE8 and we don't want hacky workarounds so we compromise
	        else return el.value.length;
	      }
	      // Handles selected options in "multiple" mode
	      function _handleMatchSelection(key){
	        var caretPosition = _getCaretPosition($select.searchInput[0]),
	            length = $select.selected.length,
	            // none  = -1,
	            first = 0,
	            last  = length-1,
	            curr  = $selectMultiple.activeMatchIndex,
	            next  = $selectMultiple.activeMatchIndex+1,
	            prev  = $selectMultiple.activeMatchIndex-1,
	            newIndex = curr;
	
	        if(caretPosition > 0 || ($select.search.length && key == KEY.RIGHT)) return false;
	
	        $select.close();
	
	        function getNewActiveMatchIndex(){
	          switch(key){
	            case KEY.LEFT:
	              // Select previous/first item
	              if(~$selectMultiple.activeMatchIndex) return prev;
	              // Select last item
	              else return last;
	              break;
	            case KEY.RIGHT:
	              // Open drop-down
	              if(!~$selectMultiple.activeMatchIndex || curr === last){
	                $select.activate();
	                return false;
	              }
	              // Select next/last item
	              else return next;
	              break;
	            case KEY.BACKSPACE:
	              // Remove selected item and select previous/first
	              if(~$selectMultiple.activeMatchIndex){
	                $selectMultiple.removeChoice(curr);
	                return prev;
	              }
	              // Select last item
	              else return last;
	              break;
	            case KEY.DELETE:
	              // Remove selected item and select next item
	              if(~$selectMultiple.activeMatchIndex){
	                $selectMultiple.removeChoice($selectMultiple.activeMatchIndex);
	                return curr;
	              }
	              else return false;
	          }
	        }
	
	        newIndex = getNewActiveMatchIndex();
	
	        if(!$select.selected.length || newIndex === false) $selectMultiple.activeMatchIndex = -1;
	        else $selectMultiple.activeMatchIndex = Math.min(last,Math.max(first,newIndex));
	
	        return true;
	      }
	
	      $select.searchInput.on('keyup', function(e) {
	
	        if ( ! KEY.isVerticalMovement(e.which) ) {
	          scope.$evalAsync( function () {
	            $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	          });
	        }
	        // Push a "create new" item into array if there is a search string
	        if ( $select.tagging.isActivated && $select.search.length > 0 ) {
	
	          // return early with these keys
	          if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || KEY.isVerticalMovement(e.which) ) {
	            return;
	          }
	          // always reset the activeIndex to the first item when tagging
	          $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	          // taggingLabel === false bypasses all of this
	          if ($select.taggingLabel === false) return;
	
	          var items = angular.copy( $select.items );
	          var stashArr = angular.copy( $select.items );
	          var newItem;
	          var item;
	          var hasTag = false;
	          var dupeIndex = -1;
	          var tagItems;
	          var tagItem;
	
	          // case for object tagging via transform `$select.tagging.fct` function
	          if ( $select.tagging.fct !== undefined) {
	            tagItems = $select.$filter('filter')(items,{'isTag': true});
	            if ( tagItems.length > 0 ) {
	              tagItem = tagItems[0];
	            }
	            // remove the first element, if it has the `isTag` prop we generate a new one with each keyup, shaving the previous
	            if ( items.length > 0 && tagItem ) {
	              hasTag = true;
	              items = items.slice(1,items.length);
	              stashArr = stashArr.slice(1,stashArr.length);
	            }
	            newItem = $select.tagging.fct($select.search);
	            // verify the new tag doesn't match the value of a possible selection choice or an already selected item.
	            if (
	              stashArr.some(function (origItem) {
	                 return angular.equals(origItem, newItem);
	              }) ||
	              $select.selected.some(function (origItem) {
	                return angular.equals(origItem, newItem);
	              })
	            ) {
	              scope.$evalAsync(function () {
	                $select.activeIndex = 0;
	                $select.items = items;
	              });
	              return;
	            }
	            if (newItem) newItem.isTag = true;
	          // handle newItem string and stripping dupes in tagging string context
	          } else {
	            // find any tagging items already in the $select.items array and store them
	            tagItems = $select.$filter('filter')(items,function (item) {
	              return item.match($select.taggingLabel);
	            });
	            if ( tagItems.length > 0 ) {
	              tagItem = tagItems[0];
	            }
	            item = items[0];
	            // remove existing tag item if found (should only ever be one tag item)
	            if ( item !== undefined && items.length > 0 && tagItem ) {
	              hasTag = true;
	              items = items.slice(1,items.length);
	              stashArr = stashArr.slice(1,stashArr.length);
	            }
	            newItem = $select.search+' '+$select.taggingLabel;
	            if ( _findApproxDupe($select.selected, $select.search) > -1 ) {
	              return;
	            }
	            // verify the the tag doesn't match the value of an existing item from
	            // the searched data set or the items already selected
	            if ( _findCaseInsensitiveDupe(stashArr.concat($select.selected)) ) {
	              // if there is a tag from prev iteration, strip it / queue the change
	              // and return early
	              if ( hasTag ) {
	                items = stashArr;
	                scope.$evalAsync( function () {
	                  $select.activeIndex = 0;
	                  $select.items = items;
	                });
	              }
	              return;
	            }
	            if ( _findCaseInsensitiveDupe(stashArr) ) {
	              // if there is a tag from prev iteration, strip it
	              if ( hasTag ) {
	                $select.items = stashArr.slice(1,stashArr.length);
	              }
	              return;
	            }
	          }
	          if ( hasTag ) dupeIndex = _findApproxDupe($select.selected, newItem);
	          // dupe found, shave the first item
	          if ( dupeIndex > -1 ) {
	            items = items.slice(dupeIndex+1,items.length-1);
	          } else {
	            items = [];
	            if (newItem) items.push(newItem);
	            items = items.concat(stashArr);
	          }
	          scope.$evalAsync( function () {
	            $select.activeIndex = 0;
	            $select.items = items;
	
	            if ($select.isGrouped) {
	              // update item references in groups, so that indexOf will work after angular.copy
	              var itemsWithoutTag = newItem ? items.slice(1) : items;
	              $select.setItemsFn(itemsWithoutTag);
	              if (newItem) {
	                // add tag item as a new group
	                $select.items.unshift(newItem);
	                $select.groups.unshift({name: '', items: [newItem], tagging: true});
	              }
	            }
	          });
	        }
	      });
	      function _findCaseInsensitiveDupe(arr) {
	        if ( arr === undefined || $select.search === undefined ) {
	          return false;
	        }
	        var hasDupe = arr.filter( function (origItem) {
	          if ( $select.search.toUpperCase() === undefined || origItem === undefined ) {
	            return false;
	          }
	          return origItem.toUpperCase() === $select.search.toUpperCase();
	        }).length > 0;
	
	        return hasDupe;
	      }
	      function _findApproxDupe(haystack, needle) {
	        var dupeIndex = -1;
	        if(angular.isArray(haystack)) {
	          var tempArr = angular.copy(haystack);
	          for (var i = 0; i <tempArr.length; i++) {
	            // handle the simple string version of tagging
	            if ( $select.tagging.fct === undefined ) {
	              // search the array for the match
	              if ( tempArr[i]+' '+$select.taggingLabel === needle ) {
	              dupeIndex = i;
	              }
	            // handle the object tagging implementation
	            } else {
	              var mockObj = tempArr[i];
	              if (angular.isObject(mockObj)) {
	                mockObj.isTag = true;
	              }
	              if ( angular.equals(mockObj, needle) ) {
	                dupeIndex = i;
	              }
	            }
	          }
	        }
	        return dupeIndex;
	      }
	
	      $select.searchInput.on('blur', function() {
	        $timeout(function() {
	          $selectMultiple.activeMatchIndex = -1;
	        });
	      });
	
	    }
	  };
	}]);
	
	uis.directive('uiSelectNoChoice',
	    ['uiSelectConfig', function (uiSelectConfig) {
	        return {
	            restrict: 'EA',
	            require: '^uiSelect',
	            replace: true,
	            transclude: true,
	            templateUrl: function (tElement) {
	                // Gets theme attribute from parent (ui-select)
	                var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	                return theme + '/no-choice.tpl.html';
	            }
	        };
	    }]);
	uis.directive('uiSelectSingle', ['$timeout','$compile', function($timeout, $compile) {
	  return {
	    restrict: 'EA',
	    require: ['^uiSelect', '^ngModel'],
	    link: function(scope, element, attrs, ctrls) {
	
	      var $select = ctrls[0];
	      var ngModel = ctrls[1];
	
	      //From view --> model
	      ngModel.$parsers.unshift(function (inputValue) {
	        var locals = {},
	            result;
	        locals[$select.parserResult.itemName] = inputValue;
	        result = $select.parserResult.modelMapper(scope, locals);
	        return result;
	      });
	
	      //From model --> view
	      ngModel.$formatters.unshift(function (inputValue) {
	        var data = $select.parserResult && $select.parserResult.source (scope, { $select : {search:''}}), //Overwrite $search
	            locals = {},
	            result;
	        if (data){
	          var checkFnSingle = function(d){
	            locals[$select.parserResult.itemName] = d;
	            result = $select.parserResult.modelMapper(scope, locals);
	            return result === inputValue;
	          };
	          //If possible pass same object stored in $select.selected
	          if ($select.selected && checkFnSingle($select.selected)) {
	            return $select.selected;
	          }
	          for (var i = data.length - 1; i >= 0; i--) {
	            if (checkFnSingle(data[i])) return data[i];
	          }
	        }
	        return inputValue;
	      });
	
	      //Update viewValue if model change
	      scope.$watch('$select.selected', function(newValue) {
	        if (ngModel.$viewValue !== newValue) {
	          ngModel.$setViewValue(newValue);
	        }
	      });
	
	      ngModel.$render = function() {
	        $select.selected = ngModel.$viewValue;
	      };
	
	      scope.$on('uis:select', function (event, item) {
	        $select.selected = item;
	      });
	
	      scope.$on('uis:close', function (event, skipFocusser) {
	        $timeout(function(){
	          $select.focusser.prop('disabled', false);
	          if (!skipFocusser) $select.focusser[0].focus();
	        },0,false);
	      });
	
	      scope.$on('uis:activate', function () {
	        focusser.prop('disabled', true); //Will reactivate it on .close()
	      });
	
	      //Idea from: https://github.com/ivaynberg/select2/blob/79b5bf6db918d7560bdd959109b7bcfb47edaf43/select2.js#L1954
	      var focusser = angular.element("<input ng-disabled='$select.disabled' class='ui-select-focusser ui-select-offscreen' type='text' id='{{ $select.focusserId }}' aria-label='{{ $select.focusserTitle }}' aria-haspopup='true' role='button' />");
	      $compile(focusser)(scope);
	      $select.focusser = focusser;
	
	      //Input that will handle focus
	      $select.focusInput = focusser;
	
	      element.parent().append(focusser);
	      focusser.bind("focus", function(){
	        scope.$evalAsync(function(){
	          $select.focus = true;
	        });
	      });
	      focusser.bind("blur", function(){
	        scope.$evalAsync(function(){
	          $select.focus = false;
	        });
	      });
	      focusser.bind("keydown", function(e){
	
	        if (e.which === KEY.BACKSPACE) {
	          e.preventDefault();
	          e.stopPropagation();
	          $select.select(undefined);
	          scope.$apply();
	          return;
	        }
	
	        if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
	          return;
	        }
	
	        if (e.which == KEY.DOWN  || e.which == KEY.UP || e.which == KEY.ENTER || e.which == KEY.SPACE){
	          e.preventDefault();
	          e.stopPropagation();
	          $select.activate();
	        }
	
	        scope.$digest();
	      });
	
	      focusser.bind("keyup input", function(e){
	
	        if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || e.which == KEY.ENTER || e.which === KEY.BACKSPACE) {
	          return;
	        }
	
	        $select.activate(focusser.val()); //User pressed some regular key, so we pass it to the search input
	        focusser.val('');
	        scope.$digest();
	
	      });
	
	
	    }
	  };
	}]);
	
	// Make multiple matches sortable
	uis.directive('uiSelectSort', ['$timeout', 'uiSelectConfig', 'uiSelectMinErr', function($timeout, uiSelectConfig, uiSelectMinErr) {
	  return {
	    require: ['^^uiSelect', '^ngModel'],
	    link: function(scope, element, attrs, ctrls) {
	      if (scope[attrs.uiSelectSort] === null) {
	        throw uiSelectMinErr('sort', 'Expected a list to sort');
	      }
	
	      var $select = ctrls[0];
	      var $ngModel = ctrls[1];
	
	      var options = angular.extend({
	          axis: 'horizontal'
	        },
	        scope.$eval(attrs.uiSelectSortOptions));
	
	      var axis = options.axis;
	      var draggingClassName = 'dragging';
	      var droppingClassName = 'dropping';
	      var droppingBeforeClassName = 'dropping-before';
	      var droppingAfterClassName = 'dropping-after';
	
	      scope.$watch(function(){
	        return $select.sortable;
	      }, function(newValue){
	        if (newValue) {
	          element.attr('draggable', true);
	        } else {
	          element.removeAttr('draggable');
	        }
	      });
	
	      element.on('dragstart', function(event) {
	        element.addClass(draggingClassName);
	
	        (event.dataTransfer || event.originalEvent.dataTransfer).setData('text', scope.$index.toString());
	      });
	
	      element.on('dragend', function() {
	        removeClass(draggingClassName);
	      });
	
	      var move = function(from, to) {
	        /*jshint validthis: true */
	        this.splice(to, 0, this.splice(from, 1)[0]);
	      };
	
	      var removeClass = function(className) {
	        angular.forEach($select.$element.querySelectorAll('.' + className), function(el){
	          angular.element(el).removeClass(className);
	        });
	      };
	
	      var dragOverHandler = function(event) {
	        event.preventDefault();
	
	        var offset = axis === 'vertical' ? event.offsetY || event.layerY || (event.originalEvent ? event.originalEvent.offsetY : 0) : event.offsetX || event.layerX || (event.originalEvent ? event.originalEvent.offsetX : 0);
	
	        if (offset < (this[axis === 'vertical' ? 'offsetHeight' : 'offsetWidth'] / 2)) {
	          removeClass(droppingAfterClassName);
	          element.addClass(droppingBeforeClassName);
	
	        } else {
	          removeClass(droppingBeforeClassName);
	          element.addClass(droppingAfterClassName);
	        }
	      };
	
	      var dropTimeout;
	
	      var dropHandler = function(event) {
	        event.preventDefault();
	
	        var droppedItemIndex = parseInt((event.dataTransfer || event.originalEvent.dataTransfer).getData('text'), 10);
	
	        // prevent event firing multiple times in firefox
	        $timeout.cancel(dropTimeout);
	        dropTimeout = $timeout(function() {
	          _dropHandler(droppedItemIndex);
	        }, 20);
	      };
	
	      var _dropHandler = function(droppedItemIndex) {
	        var theList = scope.$eval(attrs.uiSelectSort);
	        var itemToMove = theList[droppedItemIndex];
	        var newIndex = null;
	
	        if (element.hasClass(droppingBeforeClassName)) {
	          if (droppedItemIndex < scope.$index) {
	            newIndex = scope.$index - 1;
	          } else {
	            newIndex = scope.$index;
	          }
	        } else {
	          if (droppedItemIndex < scope.$index) {
	            newIndex = scope.$index;
	          } else {
	            newIndex = scope.$index + 1;
	          }
	        }
	
	        move.apply(theList, [droppedItemIndex, newIndex]);
	
	        $ngModel.$setViewValue(Date.now());
	
	        scope.$apply(function() {
	          scope.$emit('uiSelectSort:change', {
	            array: theList,
	            item: itemToMove,
	            from: droppedItemIndex,
	            to: newIndex
	          });
	        });
	
	        removeClass(droppingClassName);
	        removeClass(droppingBeforeClassName);
	        removeClass(droppingAfterClassName);
	
	        element.off('drop', dropHandler);
	      };
	
	      element.on('dragenter', function() {
	        if (element.hasClass(draggingClassName)) {
	          return;
	        }
	
	        element.addClass(droppingClassName);
	
	        element.on('dragover', dragOverHandler);
	        element.on('drop', dropHandler);
	      });
	
	      element.on('dragleave', function(event) {
	        if (event.target != element) {
	          return;
	        }
	
	        removeClass(droppingClassName);
	        removeClass(droppingBeforeClassName);
	        removeClass(droppingAfterClassName);
	
	        element.off('dragover', dragOverHandler);
	        element.off('drop', dropHandler);
	      });
	    }
	  };
	}]);
	
	/**
	 * Debounces functions
	 *
	 * Taken from UI Bootstrap $$debounce source code
	 * See https://github.com/angular-ui/bootstrap/blob/master/src/debounce/debounce.js
	 *
	 */
	uis.factory('$$uisDebounce', ['$timeout', function($timeout) {
	  return function(callback, debounceTime) {
	    var timeoutPromise;
	
	    return function() {
	      var self = this;
	      var args = Array.prototype.slice.call(arguments);
	      if (timeoutPromise) {
	        $timeout.cancel(timeoutPromise);
	      }
	
	      timeoutPromise = $timeout(function() {
	        callback.apply(self, args);
	      }, debounceTime);
	    };
	  };
	}]);
	
	/**
	 * Parses "repeat" attribute.
	 *
	 * Taken from AngularJS ngRepeat source code
	 * See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L211
	 *
	 * Original discussion about parsing "repeat" attribute instead of fully relying on ng-repeat:
	 * https://github.com/angular-ui/ui-select/commit/5dd63ad#commitcomment-5504697
	 */
	
	uis.service('uisRepeatParser', ['uiSelectMinErr','$parse', function(uiSelectMinErr, $parse) {
	  var self = this;
	
	  /**
	   * Example:
	   * expression = "address in addresses | filter: {street: $select.search} track by $index"
	   * itemName = "address",
	   * source = "addresses | filter: {street: $select.search}",
	   * trackByExp = "$index",
	   */
	  self.parse = function(expression) {
	
	
	    var match;
	    //var isObjectCollection = /\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)/.test(expression);
	    // If an array is used as collection
	
	    // if (isObjectCollection){
	    // 000000000000000000000000000000111111111000000000000000222222222222220033333333333333333333330000444444444444444444000000000000000055555555555000000000000000000000066666666600000000
	    match = expression.match(/^\s*(?:([\s\S]+?)\s+as\s+)?(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(\s*[\s\S]+?)?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	    // 1 Alias
	    // 2 Item
	    // 3 Key on (key,value)
	    // 4 Value on (key,value)
	    // 5 Source expression (including filters)
	    // 6 Track by
	
	    if (!match) {
	      throw uiSelectMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
	              expression);
	    }
	    
	    var source = match[5], 
	        filters = '';
	
	    // When using (key,value) ui-select requires filters to be extracted, since the object
	    // is converted to an array for $select.items 
	    // (in which case the filters need to be reapplied)
	    if (match[3]) {
	      // Remove any enclosing parenthesis
	      source = match[5].replace(/(^\()|(\)$)/g, '');
	      // match all after | but not after ||
	      var filterMatch = match[5].match(/^\s*(?:[\s\S]+?)(?:[^\|]|\|\|)+([\s\S]*)\s*$/);
	      if(filterMatch && filterMatch[1].trim()) {
	        filters = filterMatch[1];
	        source = source.replace(filters, '');
	      }      
	    }
	
	    return {
	      itemName: match[4] || match[2], // (lhs) Left-hand side,
	      keyName: match[3], //for (key, value) syntax
	      source: $parse(source),
	      filters: filters,
	      trackByExp: match[6],
	      modelMapper: $parse(match[1] || match[4] || match[2]),
	      repeatExpression: function (grouped) {
	        var expression = this.itemName + ' in ' + (grouped ? '$group.items' : '$select.items');
	        if (this.trackByExp) {
	          expression += ' track by ' + this.trackByExp;
	        }
	        return expression;
	      } 
	    };
	
	  };
	
	  self.getGroupNgRepeatExpression = function() {
	    return '$group in $select.groups';
	  };
	
	}]);
	
	}());
	angular.module("ui.select").run(["$templateCache", function($templateCache) {$templateCache.put("bootstrap/choices.tpl.html","<ul class=\"ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu\" role=\"listbox\" ng-show=\"$select.open && $select.items.length > 0\"><li class=\"ui-select-choices-group\" id=\"ui-select-choices-{{ $select.generatedId }}\"><div class=\"divider\" ng-show=\"$select.isGrouped && $index > 0\"></div><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label dropdown-header\" ng-bind=\"$group.name\"></div><div ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\" role=\"option\"><a href=\"\" class=\"ui-select-choices-row-inner\"></a></div></li></ul>");
	$templateCache.put("bootstrap/match-multiple.tpl.html","<span class=\"ui-select-match\"><span ng-repeat=\"$item in $select.selected\"><span class=\"ui-select-match-item btn btn-default btn-xs\" tabindex=\"-1\" type=\"button\" ng-disabled=\"$select.disabled\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'btn-primary\':$selectMultiple.activeMatchIndex === $index, \'select-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span class=\"close ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&nbsp;&times;</span> <span uis-transclude-append=\"\"></span></span></span></span>");
	$templateCache.put("bootstrap/match.tpl.html","<div class=\"ui-select-match\" ng-hide=\"$select.open && $select.searchEnabled\" ng-disabled=\"$select.disabled\" ng-class=\"{\'btn-default-focus\':$select.focus}\"><span tabindex=\"-1\" class=\"btn btn-default form-control ui-select-toggle\" aria-label=\"{{ $select.baseTitle }} activate\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" style=\"outline: 0;\"><span ng-show=\"$select.isEmpty()\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"ui-select-match-text pull-left\" ng-class=\"{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}\" ng-transclude=\"\"></span> <i class=\"caret pull-right\" ng-click=\"$select.toggle($event)\"></i> <a ng-show=\"$select.allowClear && !$select.isEmpty() && ($select.disabled !== true)\" aria-label=\"{{ $select.baseTitle }} clear\" style=\"margin-right: 10px\" ng-click=\"$select.clear($event)\" class=\"btn btn-xs btn-link pull-right\"><i class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></i></a></span></div>");
	$templateCache.put("bootstrap/no-choice.tpl.html","<ul class=\"ui-select-no-choice dropdown-menu\" ng-show=\"$select.items.length == 0\"><li ng-transclude=\"\"></li></ul>");
	$templateCache.put("bootstrap/select-multiple.tpl.html","<div class=\"ui-select-container ui-select-multiple ui-select-bootstrap dropdown form-control\" ng-class=\"{open: $select.open}\"><div><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" class=\"ui-select-search input-xs\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-click=\"$select.activate()\" ng-model=\"$select.search\" role=\"combobox\" aria-label=\"{{ $select.baseTitle }}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div></div>");
	$templateCache.put("bootstrap/select.tpl.html","<div class=\"ui-select-container ui-select-bootstrap dropdown\" ng-class=\"{open: $select.open}\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" aria-expanded=\"true\" aria-label=\"{{ $select.baseTitle }}\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"form-control ui-select-search\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-show=\"$select.searchEnabled && $select.open\"><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	$templateCache.put("select2/choices.tpl.html","<ul tabindex=\"-1\" class=\"ui-select-choices ui-select-choices-content select2-results\"><li class=\"ui-select-choices-group\" ng-class=\"{\'select2-result-with-children\': $select.choiceGrouped($group) }\"><div ng-show=\"$select.choiceGrouped($group)\" class=\"ui-select-choices-group-label select2-result-label\" ng-bind=\"$group.name\"></div><ul role=\"listbox\" id=\"ui-select-choices-{{ $select.generatedId }}\" ng-class=\"{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }\"><li role=\"option\" ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}\"><div class=\"select2-result-label ui-select-choices-row-inner\"></div></li></ul></li></ul>");
	$templateCache.put("select2/match-multiple.tpl.html","<span class=\"ui-select-match\"><li class=\"ui-select-match-item select2-search-choice\" ng-repeat=\"$item in $select.selected\" ng-class=\"{\'select2-search-choice-focus\':$selectMultiple.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span uis-transclude-append=\"\"></span> <a href=\"javascript:;\" class=\"ui-select-match-close select2-search-choice-close\" ng-click=\"$selectMultiple.removeChoice($index)\" tabindex=\"-1\"></a></li></span>");
	$templateCache.put("select2/match.tpl.html","<a class=\"select2-choice ui-select-match\" ng-class=\"{\'select2-default\': $select.isEmpty()}\" ng-click=\"$select.toggle($event)\" aria-label=\"{{ $select.baseTitle }} select\"><span ng-show=\"$select.isEmpty()\" class=\"select2-chosen\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"select2-chosen\" ng-transclude=\"\"></span> <abbr ng-if=\"$select.allowClear && !$select.isEmpty()\" class=\"select2-search-choice-close\" ng-click=\"$select.clear($event)\"></abbr> <span class=\"select2-arrow ui-select-toggle\"><b></b></span></a>");
	$templateCache.put("select2/select-multiple.tpl.html","<div class=\"ui-select-container ui-select-multiple select2 select2-container select2-container-multi\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}\"><ul class=\"select2-choices\"><span class=\"ui-select-match\"></span><li class=\"select2-search-field\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"select2-input ui-select-search\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-model=\"$select.search\" ng-click=\"$select.activate()\" style=\"width: 34px;\" ondrop=\"return false;\"></li></ul><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open || $select.items.length === 0}\"><div class=\"ui-select-choices\"></div></div></div>");
	$templateCache.put("select2/select.tpl.html","<div class=\"ui-select-container select2 select2-container\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}\"><div class=\"ui-select-match\"></div><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open}\"><div class=\"select2-search\" ng-show=\"$select.searchEnabled\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"ui-select-search select2-input\" ng-model=\"$select.search\"></div><div class=\"ui-select-choices\"></div></div></div>");
	$templateCache.put("selectize/choices.tpl.html","<div ng-show=\"$select.open\" class=\"ui-select-choices ui-select-dropdown selectize-dropdown single\"><div class=\"ui-select-choices-content selectize-dropdown-content\"><div class=\"ui-select-choices-group optgroup\" role=\"listbox\"><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label optgroup-header\" ng-bind=\"$group.name\"></div><div role=\"option\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\"><div class=\"option ui-select-choices-row-inner\" data-selectable=\"\"></div></div></div></div></div>");
	$templateCache.put("selectize/match.tpl.html","<div ng-hide=\"$select.searchEnabled && ($select.open || $select.isEmpty())\" class=\"ui-select-match\" ng-transclude=\"\"></div>");
	$templateCache.put("selectize/select.tpl.html","<div class=\"ui-select-container selectize-control single\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search ui-select-toggle\" ng-click=\"$select.toggle($event)\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-hide=\"!$select.searchEnabled || ($select.selected && !$select.open)\" ng-disabled=\"$select.disabled\" aria-label=\"{{ $select.baseTitle }}\"></div><div class=\"ui-select-choices\"></div></div>");}]);

/***/ },
/* 5 */
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.5.6
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/**
	 * @ngdoc module
	 * @name ngCookies
	 * @description
	 *
	 * # ngCookies
	 *
	 * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
	 *
	 *
	 * <div doc-module-components="ngCookies"></div>
	 *
	 * See {@link ngCookies.$cookies `$cookies`} for usage.
	 */
	
	
	angular.module('ngCookies', ['ng']).
	  /**
	   * @ngdoc provider
	   * @name $cookiesProvider
	   * @description
	   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
	   * */
	   provider('$cookies', [function $CookiesProvider() {
	    /**
	     * @ngdoc property
	     * @name $cookiesProvider#defaults
	     * @description
	     *
	     * Object containing default options to pass when setting cookies.
	     *
	     * The object may have following properties:
	     *
	     * - **path** - `{string}` - The cookie will be available only for this path and its
	     *   sub-paths. By default, this is the URL that appears in your `<base>` tag.
	     * - **domain** - `{string}` - The cookie will be available only for this domain and
	     *   its sub-domains. For security reasons the user agent will not accept the cookie
	     *   if the current domain is not a sub-domain of this domain or equal to it.
	     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
	     *   or a Date object indicating the exact date/time this cookie will expire.
	     * - **secure** - `{boolean}` - If `true`, then the cookie will only be available through a
	     *   secured connection.
	     *
	     * Note: By default, the address that appears in your `<base>` tag will be used as the path.
	     * This is important so that cookies will be visible for all routes when html5mode is enabled.
	     *
	     **/
	    var defaults = this.defaults = {};
	
	    function calcOptions(options) {
	      return options ? angular.extend({}, defaults, options) : defaults;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $cookies
	     *
	     * @description
	     * Provides read/write access to browser's cookies.
	     *
	     * <div class="alert alert-info">
	     * Up until Angular 1.3, `$cookies` exposed properties that represented the
	     * current browser cookie values. In version 1.4, this behavior has changed, and
	     * `$cookies` now provides a standard api of getters, setters etc.
	     * </div>
	     *
	     * Requires the {@link ngCookies `ngCookies`} module to be installed.
	     *
	     * @example
	     *
	     * ```js
	     * angular.module('cookiesExample', ['ngCookies'])
	     *   .controller('ExampleController', ['$cookies', function($cookies) {
	     *     // Retrieving a cookie
	     *     var favoriteCookie = $cookies.get('myFavorite');
	     *     // Setting a cookie
	     *     $cookies.put('myFavorite', 'oatmeal');
	     *   }]);
	     * ```
	     */
	    this.$get = ['$$cookieReader', '$$cookieWriter', function($$cookieReader, $$cookieWriter) {
	      return {
	        /**
	         * @ngdoc method
	         * @name $cookies#get
	         *
	         * @description
	         * Returns the value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {string} Raw cookie value.
	         */
	        get: function(key) {
	          return $$cookieReader()[key];
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getObject
	         *
	         * @description
	         * Returns the deserialized value of given cookie key
	         *
	         * @param {string} key Id to use for lookup.
	         * @returns {Object} Deserialized cookie value.
	         */
	        getObject: function(key) {
	          var value = this.get(key);
	          return value ? angular.fromJson(value) : value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#getAll
	         *
	         * @description
	         * Returns a key value object with all the cookies
	         *
	         * @returns {Object} All cookies
	         */
	        getAll: function() {
	          return $$cookieReader();
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#put
	         *
	         * @description
	         * Sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {string} value Raw value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        put: function(key, value, options) {
	          $$cookieWriter(key, value, calcOptions(options));
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#putObject
	         *
	         * @description
	         * Serializes and sets a value for given cookie key
	         *
	         * @param {string} key Id for the `value`.
	         * @param {Object} value Value to be stored.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        putObject: function(key, value, options) {
	          this.put(key, angular.toJson(value), options);
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cookies#remove
	         *
	         * @description
	         * Remove given cookie
	         *
	         * @param {string} key Id of the key-value pair to delete.
	         * @param {Object=} options Options object.
	         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
	         */
	        remove: function(key, options) {
	          $$cookieWriter(key, undefined, calcOptions(options));
	        }
	      };
	    }];
	  }]);
	
	angular.module('ngCookies').
	/**
	 * @ngdoc service
	 * @name $cookieStore
	 * @deprecated
	 * @requires $cookies
	 *
	 * @description
	 * Provides a key-value (string-object) storage, that is backed by session cookies.
	 * Objects put or retrieved from this storage are automatically serialized or
	 * deserialized by angular's toJson/fromJson.
	 *
	 * Requires the {@link ngCookies `ngCookies`} module to be installed.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The $cookieStore service is **deprecated**.
	 * Please use the {@link ngCookies.$cookies `$cookies`} service instead.
	 * </div>
	 *
	 * @example
	 *
	 * ```js
	 * angular.module('cookieStoreExample', ['ngCookies'])
	 *   .controller('ExampleController', ['$cookieStore', function($cookieStore) {
	 *     // Put cookie
	 *     $cookieStore.put('myFavorite','oatmeal');
	 *     // Get cookie
	 *     var favoriteCookie = $cookieStore.get('myFavorite');
	 *     // Removing a cookie
	 *     $cookieStore.remove('myFavorite');
	 *   }]);
	 * ```
	 */
	 factory('$cookieStore', ['$cookies', function($cookies) {
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $cookieStore#get
	       *
	       * @description
	       * Returns the value of given cookie key
	       *
	       * @param {string} key Id to use for lookup.
	       * @returns {Object} Deserialized cookie value, undefined if the cookie does not exist.
	       */
	      get: function(key) {
	        return $cookies.getObject(key);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $cookieStore#put
	       *
	       * @description
	       * Sets a value for given cookie key
	       *
	       * @param {string} key Id for the `value`.
	       * @param {Object} value Value to be stored.
	       */
	      put: function(key, value) {
	        $cookies.putObject(key, value);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $cookieStore#remove
	       *
	       * @description
	       * Remove given cookie
	       *
	       * @param {string} key Id of the key-value pair to delete.
	       */
	      remove: function(key) {
	        $cookies.remove(key);
	      }
	    };
	
	  }]);
	
	/**
	 * @name $$cookieWriter
	 * @requires $document
	 *
	 * @description
	 * This is a private service for writing cookies
	 *
	 * @param {string} name Cookie name
	 * @param {string=} value Cookie value (if undefined, cookie will be deleted)
	 * @param {Object=} options Object with options that need to be stored for the cookie.
	 */
	function $$CookieWriter($document, $log, $browser) {
	  var cookiePath = $browser.baseHref();
	  var rawDocument = $document[0];
	
	  function buildCookieString(name, value, options) {
	    var path, expires;
	    options = options || {};
	    expires = options.expires;
	    path = angular.isDefined(options.path) ? options.path : cookiePath;
	    if (angular.isUndefined(value)) {
	      expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
	      value = '';
	    }
	    if (angular.isString(expires)) {
	      expires = new Date(expires);
	    }
	
	    var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
	    str += path ? ';path=' + path : '';
	    str += options.domain ? ';domain=' + options.domain : '';
	    str += expires ? ';expires=' + expires.toUTCString() : '';
	    str += options.secure ? ';secure' : '';
	
	    // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
	    // - 300 cookies
	    // - 20 cookies per unique domain
	    // - 4096 bytes per cookie
	    var cookieLength = str.length + 1;
	    if (cookieLength > 4096) {
	      $log.warn("Cookie '" + name +
	        "' possibly not set or overflowed because it was too large (" +
	        cookieLength + " > 4096 bytes)!");
	    }
	
	    return str;
	  }
	
	  return function(name, value, options) {
	    rawDocument.cookie = buildCookieString(name, value, options);
	  };
	}
	
	$$CookieWriter.$inject = ['$document', '$log', '$browser'];
	
	angular.module('ngCookies').provider('$$cookieWriter', function $$CookieWriterProvider() {
	  this.$get = $$CookieWriter;
	});
	
	
	})(window, window.angular);


/***/ },
/* 6 */
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.5.6
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var $resourceMinErr = angular.$$minErr('$resource');
	
	// Helper functions and regex to lookup a dotted path on an object
	// stopping at undefined/null.  The path must be composed of ASCII
	// identifiers (just like $parse)
	var MEMBER_NAME_REGEX = /^(\.[a-zA-Z_$@][0-9a-zA-Z_$@]*)+$/;
	
	function isValidDottedPath(path) {
	  return (path != null && path !== '' && path !== 'hasOwnProperty' &&
	      MEMBER_NAME_REGEX.test('.' + path));
	}
	
	function lookupDottedPath(obj, path) {
	  if (!isValidDottedPath(path)) {
	    throw $resourceMinErr('badmember', 'Dotted member path "@{0}" is invalid.', path);
	  }
	  var keys = path.split('.');
	  for (var i = 0, ii = keys.length; i < ii && angular.isDefined(obj); i++) {
	    var key = keys[i];
	    obj = (obj !== null) ? obj[key] : undefined;
	  }
	  return obj;
	}
	
	/**
	 * Create a shallow copy of an object and clear other fields from the destination
	 */
	function shallowClearAndCopy(src, dst) {
	  dst = dst || {};
	
	  angular.forEach(dst, function(value, key) {
	    delete dst[key];
	  });
	
	  for (var key in src) {
	    if (src.hasOwnProperty(key) && !(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	      dst[key] = src[key];
	    }
	  }
	
	  return dst;
	}
	
	/**
	 * @ngdoc module
	 * @name ngResource
	 * @description
	 *
	 * # ngResource
	 *
	 * The `ngResource` module provides interaction support with RESTful services
	 * via the $resource service.
	 *
	 *
	 * <div doc-module-components="ngResource"></div>
	 *
	 * See {@link ngResource.$resource `$resource`} for usage.
	 */
	
	/**
	 * @ngdoc service
	 * @name $resource
	 * @requires $http
	 * @requires ng.$log
	 * @requires $q
	 * @requires ng.$timeout
	 *
	 * @description
	 * A factory which creates a resource object that lets you interact with
	 * [RESTful](http://en.wikipedia.org/wiki/Representational_State_Transfer) server-side data sources.
	 *
	 * The returned resource object has action methods which provide high-level behaviors without
	 * the need to interact with the low level {@link ng.$http $http} service.
	 *
	 * Requires the {@link ngResource `ngResource`} module to be installed.
	 *
	 * By default, trailing slashes will be stripped from the calculated URLs,
	 * which can pose problems with server backends that do not expect that
	 * behavior.  This can be disabled by configuring the `$resourceProvider` like
	 * this:
	 *
	 * ```js
	     app.config(['$resourceProvider', function($resourceProvider) {
	       // Don't strip trailing slashes from calculated URLs
	       $resourceProvider.defaults.stripTrailingSlashes = false;
	     }]);
	 * ```
	 *
	 * @param {string} url A parameterized URL template with parameters prefixed by `:` as in
	 *   `/user/:username`. If you are using a URL with a port number (e.g.
	 *   `http://example.com:8080/api`), it will be respected.
	 *
	 *   If you are using a url with a suffix, just add the suffix, like this:
	 *   `$resource('http://example.com/resource.json')` or `$resource('http://example.com/:id.json')`
	 *   or even `$resource('http://example.com/resource/:resource_id.:format')`
	 *   If the parameter before the suffix is empty, :resource_id in this case, then the `/.` will be
	 *   collapsed down to a single `.`.  If you need this sequence to appear and not collapse then you
	 *   can escape it with `/\.`.
	 *
	 * @param {Object=} paramDefaults Default values for `url` parameters. These can be overridden in
	 *   `actions` methods. If a parameter value is a function, it will be executed every time
	 *   when a param value needs to be obtained for a request (unless the param was overridden).
	 *
	 *   Each key value in the parameter object is first bound to url template if present and then any
	 *   excess keys are appended to the url search query after the `?`.
	 *
	 *   Given a template `/path/:verb` and parameter `{verb:'greet', salutation:'Hello'}` results in
	 *   URL `/path/greet?salutation=Hello`.
	 *
	 *   If the parameter value is prefixed with `@` then the value for that parameter will be extracted
	 *   from the corresponding property on the `data` object (provided when calling an action method).
	 *   For example, if the `defaultParam` object is `{someParam: '@someProp'}` then the value of
	 *   `someParam` will be `data.someProp`.
	 *
	 * @param {Object.<Object>=} actions Hash with declaration of custom actions that should extend
	 *   the default set of resource actions. The declaration should be created in the format of {@link
	 *   ng.$http#usage $http.config}:
	 *
	 *       {action1: {method:?, params:?, isArray:?, headers:?, ...},
	 *        action2: {method:?, params:?, isArray:?, headers:?, ...},
	 *        ...}
	 *
	 *   Where:
	 *
	 *   - **`action`** – {string} – The name of action. This name becomes the name of the method on
	 *     your resource object.
	 *   - **`method`** – {string} – Case insensitive HTTP method (e.g. `GET`, `POST`, `PUT`,
	 *     `DELETE`, `JSONP`, etc).
	 *   - **`params`** – {Object=} – Optional set of pre-bound parameters for this action. If any of
	 *     the parameter value is a function, it will be executed every time when a param value needs to
	 *     be obtained for a request (unless the param was overridden).
	 *   - **`url`** – {string} – action specific `url` override. The url templating is supported just
	 *     like for the resource-level urls.
	 *   - **`isArray`** – {boolean=} – If true then the returned object for this action is an array,
	 *     see `returns` section.
	 *   - **`transformRequest`** –
	 *     `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	 *     transform function or an array of such functions. The transform function takes the http
	 *     request body and headers and returns its transformed (typically serialized) version.
	 *     By default, transformRequest will contain one function that checks if the request data is
	 *     an object and serializes to using `angular.toJson`. To prevent this behavior, set
	 *     `transformRequest` to an empty array: `transformRequest: []`
	 *   - **`transformResponse`** –
	 *     `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	 *     transform function or an array of such functions. The transform function takes the http
	 *     response body and headers and returns its transformed (typically deserialized) version.
	 *     By default, transformResponse will contain one function that checks if the response looks
	 *     like a JSON string and deserializes it using `angular.fromJson`. To prevent this behavior,
	 *     set `transformResponse` to an empty array: `transformResponse: []`
	 *   - **`cache`** – `{boolean|Cache}` – If true, a default $http cache will be used to cache the
	 *     GET request, otherwise if a cache instance built with
	 *     {@link ng.$cacheFactory $cacheFactory}, this cache will be used for
	 *     caching.
	 *   - **`timeout`** – `{number}` – timeout in milliseconds.<br />
	 *     **Note:** In contrast to {@link ng.$http#usage $http.config}, {@link ng.$q promises} are
	 *     **not** supported in $resource, because the same value would be used for multiple requests.
	 *     If you are looking for a way to cancel requests, you should use the `cancellable` option.
	 *   - **`cancellable`** – `{boolean}` – if set to true, the request made by a "non-instance" call
	 *     will be cancelled (if not already completed) by calling `$cancelRequest()` on the call's
	 *     return value. Calling `$cancelRequest()` for a non-cancellable or an already
	 *     completed/cancelled request will have no effect.<br />
	 *   - **`withCredentials`** - `{boolean}` - whether to set the `withCredentials` flag on the
	 *     XHR object. See
	 *     [requests with credentials](https://developer.mozilla.org/en/http_access_control#section_5)
	 *     for more information.
	 *   - **`responseType`** - `{string}` - see
	 *     [requestType](https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#responseType).
	 *   - **`interceptor`** - `{Object=}` - The interceptor object has two optional methods -
	 *     `response` and `responseError`. Both `response` and `responseError` interceptors get called
	 *     with `http response` object. See {@link ng.$http $http interceptors}.
	 *
	 * @param {Object} options Hash with custom settings that should extend the
	 *   default `$resourceProvider` behavior.  The supported options are:
	 *
	 *   - **`stripTrailingSlashes`** – {boolean} – If true then the trailing
	 *   slashes from any calculated URL will be stripped. (Defaults to true.)
	 *   - **`cancellable`** – {boolean} – If true, the request made by a "non-instance" call will be
	 *   cancelled (if not already completed) by calling `$cancelRequest()` on the call's return value.
	 *   This can be overwritten per action. (Defaults to false.)
	 *
	 * @returns {Object} A resource "class" object with methods for the default set of resource actions
	 *   optionally extended with custom `actions`. The default set contains these actions:
	 *   ```js
	 *   { 'get':    {method:'GET'},
	 *     'save':   {method:'POST'},
	 *     'query':  {method:'GET', isArray:true},
	 *     'remove': {method:'DELETE'},
	 *     'delete': {method:'DELETE'} };
	 *   ```
	 *
	 *   Calling these methods invoke an {@link ng.$http} with the specified http method,
	 *   destination and parameters. When the data is returned from the server then the object is an
	 *   instance of the resource class. The actions `save`, `remove` and `delete` are available on it
	 *   as  methods with the `$` prefix. This allows you to easily perform CRUD operations (create,
	 *   read, update, delete) on server-side data like this:
	 *   ```js
	 *   var User = $resource('/user/:userId', {userId:'@id'});
	 *   var user = User.get({userId:123}, function() {
	 *     user.abc = true;
	 *     user.$save();
	 *   });
	 *   ```
	 *
	 *   It is important to realize that invoking a $resource object method immediately returns an
	 *   empty reference (object or array depending on `isArray`). Once the data is returned from the
	 *   server the existing reference is populated with the actual data. This is a useful trick since
	 *   usually the resource is assigned to a model which is then rendered by the view. Having an empty
	 *   object results in no rendering, once the data arrives from the server then the object is
	 *   populated with the data and the view automatically re-renders itself showing the new data. This
	 *   means that in most cases one never has to write a callback function for the action methods.
	 *
	 *   The action methods on the class object or instance object can be invoked with the following
	 *   parameters:
	 *
	 *   - HTTP GET "class" actions: `Resource.action([parameters], [success], [error])`
	 *   - non-GET "class" actions: `Resource.action([parameters], postData, [success], [error])`
	 *   - non-GET instance actions:  `instance.$action([parameters], [success], [error])`
	 *
	 *
	 *   Success callback is called with (value, responseHeaders) arguments, where the value is
	 *   the populated resource instance or collection object. The error callback is called
	 *   with (httpResponse) argument.
	 *
	 *   Class actions return empty instance (with additional properties below).
	 *   Instance actions return promise of the action.
	 *
	 *   The Resource instances and collections have these additional properties:
	 *
	 *   - `$promise`: the {@link ng.$q promise} of the original server interaction that created this
	 *     instance or collection.
	 *
	 *     On success, the promise is resolved with the same resource instance or collection object,
	 *     updated with data from server. This makes it easy to use in
	 *     {@link ngRoute.$routeProvider resolve section of $routeProvider.when()} to defer view
	 *     rendering until the resource(s) are loaded.
	 *
	 *     On failure, the promise is rejected with the {@link ng.$http http response} object, without
	 *     the `resource` property.
	 *
	 *     If an interceptor object was provided, the promise will instead be resolved with the value
	 *     returned by the interceptor.
	 *
	 *   - `$resolved`: `true` after first server interaction is completed (either with success or
	 *      rejection), `false` before that. Knowing if the Resource has been resolved is useful in
	 *      data-binding.
	 *
	 *   The Resource instances and collections have these additional methods:
	 *
	 *   - `$cancelRequest`: If there is a cancellable, pending request related to the instance or
	 *      collection, calling this method will abort the request.
	 *
	 * @example
	 *
	 * # Credit card resource
	 *
	 * ```js
	     // Define CreditCard class
	     var CreditCard = $resource('/user/:userId/card/:cardId',
	      {userId:123, cardId:'@id'}, {
	       charge: {method:'POST', params:{charge:true}}
	      });
	
	     // We can retrieve a collection from the server
	     var cards = CreditCard.query(function() {
	       // GET: /user/123/card
	       // server returns: [ {id:456, number:'1234', name:'Smith'} ];
	
	       var card = cards[0];
	       // each item is an instance of CreditCard
	       expect(card instanceof CreditCard).toEqual(true);
	       card.name = "J. Smith";
	       // non GET methods are mapped onto the instances
	       card.$save();
	       // POST: /user/123/card/456 {id:456, number:'1234', name:'J. Smith'}
	       // server returns: {id:456, number:'1234', name: 'J. Smith'};
	
	       // our custom method is mapped as well.
	       card.$charge({amount:9.99});
	       // POST: /user/123/card/456?amount=9.99&charge=true {id:456, number:'1234', name:'J. Smith'}
	     });
	
	     // we can create an instance as well
	     var newCard = new CreditCard({number:'0123'});
	     newCard.name = "Mike Smith";
	     newCard.$save();
	     // POST: /user/123/card {number:'0123', name:'Mike Smith'}
	     // server returns: {id:789, number:'0123', name: 'Mike Smith'};
	     expect(newCard.id).toEqual(789);
	 * ```
	 *
	 * The object returned from this function execution is a resource "class" which has "static" method
	 * for each action in the definition.
	 *
	 * Calling these methods invoke `$http` on the `url` template with the given `method`, `params` and
	 * `headers`.
	 *
	 * @example
	 *
	 * # User resource
	 *
	 * When the data is returned from the server then the object is an instance of the resource type and
	 * all of the non-GET methods are available with `$` prefix. This allows you to easily support CRUD
	 * operations (create, read, update, delete) on server-side data.
	
	   ```js
	     var User = $resource('/user/:userId', {userId:'@id'});
	     User.get({userId:123}, function(user) {
	       user.abc = true;
	       user.$save();
	     });
	   ```
	 *
	 * It's worth noting that the success callback for `get`, `query` and other methods gets passed
	 * in the response that came from the server as well as $http header getter function, so one
	 * could rewrite the above example and get access to http headers as:
	 *
	   ```js
	     var User = $resource('/user/:userId', {userId:'@id'});
	     User.get({userId:123}, function(user, getResponseHeaders){
	       user.abc = true;
	       user.$save(function(user, putResponseHeaders) {
	         //user => saved user object
	         //putResponseHeaders => $http header getter
	       });
	     });
	   ```
	 *
	 * You can also access the raw `$http` promise via the `$promise` property on the object returned
	 *
	   ```
	     var User = $resource('/user/:userId', {userId:'@id'});
	     User.get({userId:123})
	         .$promise.then(function(user) {
	           $scope.user = user;
	         });
	   ```
	 *
	 * @example
	 *
	 * # Creating a custom 'PUT' request
	 *
	 * In this example we create a custom method on our resource to make a PUT request
	 * ```js
	 *    var app = angular.module('app', ['ngResource', 'ngRoute']);
	 *
	 *    // Some APIs expect a PUT request in the format URL/object/ID
	 *    // Here we are creating an 'update' method
	 *    app.factory('Notes', ['$resource', function($resource) {
	 *    return $resource('/notes/:id', null,
	 *        {
	 *            'update': { method:'PUT' }
	 *        });
	 *    }]);
	 *
	 *    // In our controller we get the ID from the URL using ngRoute and $routeParams
	 *    // We pass in $routeParams and our Notes factory along with $scope
	 *    app.controller('NotesCtrl', ['$scope', '$routeParams', 'Notes',
	                                      function($scope, $routeParams, Notes) {
	 *    // First get a note object from the factory
	 *    var note = Notes.get({ id:$routeParams.id });
	 *    $id = note.id;
	 *
	 *    // Now call update passing in the ID first then the object you are updating
	 *    Notes.update({ id:$id }, note);
	 *
	 *    // This will PUT /notes/ID with the note object in the request payload
	 *    }]);
	 * ```
	 *
	 * @example
	 *
	 * # Cancelling requests
	 *
	 * If an action's configuration specifies that it is cancellable, you can cancel the request related
	 * to an instance or collection (as long as it is a result of a "non-instance" call):
	 *
	   ```js
	     // ...defining the `Hotel` resource...
	     var Hotel = $resource('/api/hotel/:id', {id: '@id'}, {
	       // Let's make the `query()` method cancellable
	       query: {method: 'get', isArray: true, cancellable: true}
	     });
	
	     // ...somewhere in the PlanVacationController...
	     ...
	     this.onDestinationChanged = function onDestinationChanged(destination) {
	       // We don't care about any pending request for hotels
	       // in a different destination any more
	       this.availableHotels.$cancelRequest();
	
	       // Let's query for hotels in '<destination>'
	       // (calls: /api/hotel?location=<destination>)
	       this.availableHotels = Hotel.query({location: destination});
	     };
	   ```
	 *
	 */
	angular.module('ngResource', ['ng']).
	  provider('$resource', function() {
	    var PROTOCOL_AND_DOMAIN_REGEX = /^https?:\/\/[^\/]*/;
	    var provider = this;
	
	    this.defaults = {
	      // Strip slashes by default
	      stripTrailingSlashes: true,
	
	      // Default actions configuration
	      actions: {
	        'get': {method: 'GET'},
	        'save': {method: 'POST'},
	        'query': {method: 'GET', isArray: true},
	        'remove': {method: 'DELETE'},
	        'delete': {method: 'DELETE'}
	      }
	    };
	
	    this.$get = ['$http', '$log', '$q', '$timeout', function($http, $log, $q, $timeout) {
	
	      var noop = angular.noop,
	        forEach = angular.forEach,
	        extend = angular.extend,
	        copy = angular.copy,
	        isFunction = angular.isFunction;
	
	      /**
	       * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	       * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set
	       * (pchar) allowed in path segments:
	       *    segment       = *pchar
	       *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	       *    pct-encoded   = "%" HEXDIG HEXDIG
	       *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	       *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	       *                     / "*" / "+" / "," / ";" / "="
	       */
	      function encodeUriSegment(val) {
	        return encodeUriQuery(val, true).
	          replace(/%26/gi, '&').
	          replace(/%3D/gi, '=').
	          replace(/%2B/gi, '+');
	      }
	
	
	      /**
	       * This method is intended for encoding *key* or *value* parts of query component. We need a
	       * custom method because encodeURIComponent is too aggressive and encodes stuff that doesn't
	       * have to be encoded per http://tools.ietf.org/html/rfc3986:
	       *    query       = *( pchar / "/" / "?" )
	       *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	       *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	       *    pct-encoded   = "%" HEXDIG HEXDIG
	       *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	       *                     / "*" / "+" / "," / ";" / "="
	       */
	      function encodeUriQuery(val, pctEncodeSpaces) {
	        return encodeURIComponent(val).
	          replace(/%40/gi, '@').
	          replace(/%3A/gi, ':').
	          replace(/%24/g, '$').
	          replace(/%2C/gi, ',').
	          replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	      }
	
	      function Route(template, defaults) {
	        this.template = template;
	        this.defaults = extend({}, provider.defaults, defaults);
	        this.urlParams = {};
	      }
	
	      Route.prototype = {
	        setUrlParams: function(config, params, actionUrl) {
	          var self = this,
	            url = actionUrl || self.template,
	            val,
	            encodedVal,
	            protocolAndDomain = '';
	
	          var urlParams = self.urlParams = {};
	          forEach(url.split(/\W/), function(param) {
	            if (param === 'hasOwnProperty') {
	              throw $resourceMinErr('badname', "hasOwnProperty is not a valid parameter name.");
	            }
	            if (!(new RegExp("^\\d+$").test(param)) && param &&
	              (new RegExp("(^|[^\\\\]):" + param + "(\\W|$)").test(url))) {
	              urlParams[param] = {
	                isQueryParamValue: (new RegExp("\\?.*=:" + param + "(?:\\W|$)")).test(url)
	              };
	            }
	          });
	          url = url.replace(/\\:/g, ':');
	          url = url.replace(PROTOCOL_AND_DOMAIN_REGEX, function(match) {
	            protocolAndDomain = match;
	            return '';
	          });
	
	          params = params || {};
	          forEach(self.urlParams, function(paramInfo, urlParam) {
	            val = params.hasOwnProperty(urlParam) ? params[urlParam] : self.defaults[urlParam];
	            if (angular.isDefined(val) && val !== null) {
	              if (paramInfo.isQueryParamValue) {
	                encodedVal = encodeUriQuery(val, true);
	              } else {
	                encodedVal = encodeUriSegment(val);
	              }
	              url = url.replace(new RegExp(":" + urlParam + "(\\W|$)", "g"), function(match, p1) {
	                return encodedVal + p1;
	              });
	            } else {
	              url = url.replace(new RegExp("(\/?):" + urlParam + "(\\W|$)", "g"), function(match,
	                  leadingSlashes, tail) {
	                if (tail.charAt(0) == '/') {
	                  return tail;
	                } else {
	                  return leadingSlashes + tail;
	                }
	              });
	            }
	          });
	
	          // strip trailing slashes and set the url (unless this behavior is specifically disabled)
	          if (self.defaults.stripTrailingSlashes) {
	            url = url.replace(/\/+$/, '') || '/';
	          }
	
	          // then replace collapse `/.` if found in the last URL path segment before the query
	          // E.g. `http://url.com/id./format?q=x` becomes `http://url.com/id.format?q=x`
	          url = url.replace(/\/\.(?=\w+($|\?))/, '.');
	          // replace escaped `/\.` with `/.`
	          config.url = protocolAndDomain + url.replace(/\/\\\./, '/.');
	
	
	          // set params - delegate param encoding to $http
	          forEach(params, function(value, key) {
	            if (!self.urlParams[key]) {
	              config.params = config.params || {};
	              config.params[key] = value;
	            }
	          });
	        }
	      };
	
	
	      function resourceFactory(url, paramDefaults, actions, options) {
	        var route = new Route(url, options);
	
	        actions = extend({}, provider.defaults.actions, actions);
	
	        function extractParams(data, actionParams) {
	          var ids = {};
	          actionParams = extend({}, paramDefaults, actionParams);
	          forEach(actionParams, function(value, key) {
	            if (isFunction(value)) { value = value(); }
	            ids[key] = value && value.charAt && value.charAt(0) == '@' ?
	              lookupDottedPath(data, value.substr(1)) : value;
	          });
	          return ids;
	        }
	
	        function defaultResponseInterceptor(response) {
	          return response.resource;
	        }
	
	        function Resource(value) {
	          shallowClearAndCopy(value || {}, this);
	        }
	
	        Resource.prototype.toJSON = function() {
	          var data = extend({}, this);
	          delete data.$promise;
	          delete data.$resolved;
	          return data;
	        };
	
	        forEach(actions, function(action, name) {
	          var hasBody = /^(POST|PUT|PATCH)$/i.test(action.method);
	          var numericTimeout = action.timeout;
	          var cancellable = angular.isDefined(action.cancellable) ? action.cancellable :
	              (options && angular.isDefined(options.cancellable)) ? options.cancellable :
	              provider.defaults.cancellable;
	
	          if (numericTimeout && !angular.isNumber(numericTimeout)) {
	            $log.debug('ngResource:\n' +
	                       '  Only numeric values are allowed as `timeout`.\n' +
	                       '  Promises are not supported in $resource, because the same value would ' +
	                       'be used for multiple requests. If you are looking for a way to cancel ' +
	                       'requests, you should use the `cancellable` option.');
	            delete action.timeout;
	            numericTimeout = null;
	          }
	
	          Resource[name] = function(a1, a2, a3, a4) {
	            var params = {}, data, success, error;
	
	            /* jshint -W086 */ /* (purposefully fall through case statements) */
	            switch (arguments.length) {
	              case 4:
	                error = a4;
	                success = a3;
	              //fallthrough
	              case 3:
	              case 2:
	                if (isFunction(a2)) {
	                  if (isFunction(a1)) {
	                    success = a1;
	                    error = a2;
	                    break;
	                  }
	
	                  success = a2;
	                  error = a3;
	                  //fallthrough
	                } else {
	                  params = a1;
	                  data = a2;
	                  success = a3;
	                  break;
	                }
	              case 1:
	                if (isFunction(a1)) success = a1;
	                else if (hasBody) data = a1;
	                else params = a1;
	                break;
	              case 0: break;
	              default:
	                throw $resourceMinErr('badargs',
	                  "Expected up to 4 arguments [params, data, success, error], got {0} arguments",
	                  arguments.length);
	            }
	            /* jshint +W086 */ /* (purposefully fall through case statements) */
	
	            var isInstanceCall = this instanceof Resource;
	            var value = isInstanceCall ? data : (action.isArray ? [] : new Resource(data));
	            var httpConfig = {};
	            var responseInterceptor = action.interceptor && action.interceptor.response ||
	              defaultResponseInterceptor;
	            var responseErrorInterceptor = action.interceptor && action.interceptor.responseError ||
	              undefined;
	            var timeoutDeferred;
	            var numericTimeoutPromise;
	
	            forEach(action, function(value, key) {
	              switch (key) {
	                default:
	                  httpConfig[key] = copy(value);
	                  break;
	                case 'params':
	                case 'isArray':
	                case 'interceptor':
	                case 'cancellable':
	                  break;
	              }
	            });
	
	            if (!isInstanceCall && cancellable) {
	              timeoutDeferred = $q.defer();
	              httpConfig.timeout = timeoutDeferred.promise;
	
	              if (numericTimeout) {
	                numericTimeoutPromise = $timeout(timeoutDeferred.resolve, numericTimeout);
	              }
	            }
	
	            if (hasBody) httpConfig.data = data;
	            route.setUrlParams(httpConfig,
	              extend({}, extractParams(data, action.params || {}), params),
	              action.url);
	
	            var promise = $http(httpConfig).then(function(response) {
	              var data = response.data;
	
	              if (data) {
	                // Need to convert action.isArray to boolean in case it is undefined
	                // jshint -W018
	                if (angular.isArray(data) !== (!!action.isArray)) {
	                  throw $resourceMinErr('badcfg',
	                      'Error in resource configuration for action `{0}`. Expected response to ' +
	                      'contain an {1} but got an {2} (Request: {3} {4})', name, action.isArray ? 'array' : 'object',
	                    angular.isArray(data) ? 'array' : 'object', httpConfig.method, httpConfig.url);
	                }
	                // jshint +W018
	                if (action.isArray) {
	                  value.length = 0;
	                  forEach(data, function(item) {
	                    if (typeof item === "object") {
	                      value.push(new Resource(item));
	                    } else {
	                      // Valid JSON values may be string literals, and these should not be converted
	                      // into objects. These items will not have access to the Resource prototype
	                      // methods, but unfortunately there
	                      value.push(item);
	                    }
	                  });
	                } else {
	                  var promise = value.$promise;     // Save the promise
	                  shallowClearAndCopy(data, value);
	                  value.$promise = promise;         // Restore the promise
	                }
	              }
	              response.resource = value;
	
	              return response;
	            }, function(response) {
	              (error || noop)(response);
	              return $q.reject(response);
	            });
	
	            promise['finally'](function() {
	              value.$resolved = true;
	              if (!isInstanceCall && cancellable) {
	                value.$cancelRequest = angular.noop;
	                $timeout.cancel(numericTimeoutPromise);
	                timeoutDeferred = numericTimeoutPromise = httpConfig.timeout = null;
	              }
	            });
	
	            promise = promise.then(
	              function(response) {
	                var value = responseInterceptor(response);
	                (success || noop)(value, response.headers);
	                return value;
	              },
	              responseErrorInterceptor);
	
	            if (!isInstanceCall) {
	              // we are creating instance / collection
	              // - set the initial promise
	              // - return the instance / collection
	              value.$promise = promise;
	              value.$resolved = false;
	              if (cancellable) value.$cancelRequest = timeoutDeferred.resolve;
	
	              return value;
	            }
	
	            // instance call
	            return promise;
	          };
	
	
	          Resource.prototype['$' + name] = function(params, success, error) {
	            if (isFunction(params)) {
	              error = success; success = params; params = {};
	            }
	            var result = Resource[name].call(this, params, this, success, error);
	            return result.$promise || result;
	          };
	        });
	
	        Resource.bind = function(additionalParamDefaults) {
	          return resourceFactory(url, extend({}, paramDefaults, additionalParamDefaults), actions);
	        };
	
	        return Resource;
	      }
	
	      return resourceFactory;
	    }];
	  });
	
	
	})(window, window.angular);


/***/ },
/* 7 */
/***/ function(module, exports) {

	/*
	 * ng-tasty
	 * https://github.com/Zizzamia/ng-tasty
	
	 * Version: 0.6.1 - 2016-01-01
	 * License: MIT
	 */
	angular.module("ngTasty", ["ngTasty.tpls", "ngTasty.component.table","ngTasty.filter.camelize","ngTasty.filter.cleanFieldName","ngTasty.filter.filterInt","ngTasty.filter.range","ngTasty.filter.slugify","ngTasty.service.bindTo","ngTasty.service.debounce","ngTasty.service.joinObjects","ngTasty.service.setProperty","ngTasty.service.tastyUtil","ngTasty.service.throttle","ngTasty.service.webSocket"]);
	angular.module("ngTasty.tpls", ["ngTasty.tpls.table.head","ngTasty.tpls.table.pagination"]);
	/**
	 * @ngdoc directive
	 * @name ngTasty.component.tastyTable
	 *
	 * @example
	  <table tasty-table>
	    <tbody></tbody>
	  </table>
	 *
	 */
	angular.module('ngTasty.component.table', [
	  'ngTasty.filter.cleanFieldName',
	  'ngTasty.filter.range',
	  'ngTasty.service.tastyUtil',
	  'ngTasty.tpls.table.head',
	  'ngTasty.tpls.table.pagination'
	])
	.constant('tableConfig', {
	  init: {
	    'count': 5,
	    'page': 1,
	    'sortBy': undefined,
	    'sortOrder': undefined,
	    'filterBase': 1
	  },
	  query: {
	    'page': 'page',
	    'count': 'count',
	    'sortBy': 'sort-by',
	    'sortOrder': 'sort-order'
	  },
	  bootstrapIcon: false,
	  bindOnce: true,
	  loadOnInit: false,
	  iconUp: 'fa fa-sort-up',
	  iconDown: 'fa fa-sort-down',
	  listItemsPerPage: [5, 25, 50, 100],
	  itemsPerPage: 5,
	  templateHeadUrl: 'template/table/head.html',
	  templateUrl: 'template/table/pagination.html',
	  watchResource: 'reference'
	})
	.controller('TableController', ["$scope", "$attrs", "$filter", "tableConfig", "tastyUtil", function($scope, $attrs, $filter, tableConfig, tastyUtil) {
	  var listScopeToWatch, initTable, newScopeName, initStatus,
	      updateClientSideResource, updateServerSideResource, setDirectivesValues,
	      buildClientResource, buildUrl, paramsInitialCycle, initNow, loadOnInit,
	      filterChangedPage;
	  var vm = this;
	  vm.$scope = $scope;
	  initStatus = {};
	  initNow = true;
	  paramsInitialCycle = true;
	  $scope.init = {};
	  $scope.query = {};
	  $scope.logs = {
	    'buildClientResourceCount': 0,
	    'updateServerSideResourceRunning': 0
	  };
	  $scope.theme = {};
	
	  // Each one of them is a possible attribute to start watching
	  listScopeToWatch = [
	    'bindFilters', 
	    'bindFiltersComparator',
	    'bindInit', 
	    'bindQuery', 
	    'bindResource', 
	    'bindResourceCallback', 
	    'bindWatchResource', 
	    'bindReload',
	    'bindTheme'
	  ];
	  listScopeToWatch.forEach(function (scopeName) {
	    newScopeName = scopeName.substring(4);
	    newScopeName = newScopeName.charAt(0).toLowerCase() + newScopeName.slice(1);
	    if ($attrs[scopeName]) {
	      tastyUtil.bindTo(scopeName, $scope, $attrs, newScopeName);
	    } else if ($attrs[newScopeName] && newScopeName === 'watchResource') {
	      $scope[newScopeName] = $attrs[newScopeName];
	    } else if ($attrs[newScopeName] && newScopeName === 'filtersComparator') {
	      $scope[newScopeName] = JSON.parse($attrs[newScopeName]);
	    }
	  });
	
	  // Default theme
	  vm.config = {};
	  if (angular.isObject($scope.theme)) {
	    Object.keys(tableConfig).forEach(function(key) {
	      if (angular.isDefined($scope.theme[key])) {
	        vm.config[key] = $scope.theme[key];
	      } else {
	        vm.config[key] = tableConfig[key];
	      }
	    }, vm);
	  } else {
	    vm.config = tableConfig;
	  }
	
	  // Default configs
	  $scope.query.page = $scope.query.page || vm.config.query.page;
	  $scope.query.count = $scope.query.count || vm.config.query.count;
	  $scope.query.sortBy = $scope.query.sortBy || vm.config.query.sortBy;
	  $scope.query.sortOrder = $scope.query.sortOrder || vm.config.query.sortOrder;
	
	  // Set init configs
	  if ($scope.reload && !vm.config.loadOnInit) {
	    initNow = false;
	  }
	  $scope.init.count = $scope.init.count || vm.config.init.count;
	  $scope.init.page = $scope.init.page || vm.config.init.page;
	  $scope.init.sortBy = $scope.init.sortBy || vm.config.init.sortBy;
	  $scope.init.sortOrder = $scope.init.sortOrder || vm.config.init.sortOrder;
	  if (!angular.isUndefined($scope.init.filterBase)) {
	    $scope.init.filterBase = $scope.init.filterBase;
	  } else {
	    $scope.init.filterBase = vm.config.init.filterBase;
	  }  
	  $scope.watchResource = $scope.watchResource || vm.config.watchResource;
	
	  // Defualt variables
	  var listImmutableKey =[
	    'filters',
	    'init',
	    'query',
	    'rows',
	    'header',
	    'pagination',
	    'params',
	    'sortOrder',
	    'sortBy',
	    'url'
	  ];
	  $scope.clientSide = true;
	  $scope.url = '';
	  $scope.header = {
	    'columns': []
	  };
	  $scope.rows = [];
	  $scope.params = {};
	  $scope.pagination = {
	    'count': $scope.init.count,
	    'page': $scope.init.page,
	    'pages': 1,
	    'size': 0
	  };
	  $scope.theadDirective = false;
	  $scope.paginationDirective = false; 
	
	  /* Set custom configs
	   * In the future you will have a way to change
	   * these values by an isolate optional scope variable,
	   * more info here https://github.com/angular/angular.js/issues/6404 */
	  if (!angular.isDefined($attrs.bindResource) && !angular.isDefined($attrs.bindResourceCallback)) {
	    throw new Error('Angular tastyTable directive: need the ' +
	                    'bind-resource or bind-resource-callback attribute');
	  }
	  if (angular.isDefined($attrs.bindResource)) {
	    if (!angular.isObject($scope.resource)) {
	      throw new Error('Angular tastyTable directive: the bind-resource ('+
	                      $attrs.bindResource + ') is not an object');
	    } else if (!$scope.resource.header && !$scope.resource.rows) {
	      throw new Error('Angular tastyTable directive: the bind-resource ('+
	                      $attrs.bindResource + ') has the property header or rows undefined');
	    }
	  }
	  if (angular.isDefined($attrs.bindResourceCallback)) {
	    if (!angular.isFunction($scope.resourceCallback)) {
	      throw new Error('Angular tastyTable directive: the bind-resource-callback ('+
	                      $attrs.bindResourceCallback + ') is not a function');
	    }
	    $scope.clientSide = false;
	  }   
	
	  // In TableController, by using `vm` we build an API 
	  // for other directives to talk to vm one.
	  vm.start = false;
	
	  vm.activate = function(directiveName) {
	    $scope[directiveName + 'Directive'] = true;
	    $scope.params[directiveName] = true;
	  };
	
	  vm.setParams = function(key, value) {
	    $scope.params[key] = value;
	    if (['sortBy', 'sortOrder'].indexOf(key) >= 0) {
	      $scope.header[key] = value;
	    }
	  };
	
	  vm.initTable = function (keyDirective) {
	    initStatus[keyDirective] = true;
	    if (!$scope.theadDirective && !$scope.paginationDirective) { // None of them
	      vm.start = true;
	    } else if ($scope.theadDirective && $scope.paginationDirective) { // Both directives
	      if (initStatus.thead && initStatus.pagination){
	        vm.start = true;
	      }
	    } else if ($scope.theadDirective && !$scope.paginationDirective) { // Only Thead directive
	      if (initStatus.thead){
	        vm.start = true;
	      }
	    } else if (!$scope.theadDirective && $scope.paginationDirective) { // Only Pagination directive
	      if (initStatus.pagination){
	        vm.start = true;
	      }
	    }
	
	    if (vm.start) {
	      if ($scope.clientSide) {
	        $scope.params.sortBy = $scope.resource.sortBy || $scope.init.sortBy;
	        $scope.params.sortOrder = $scope.resource.sortOrder || $scope.init.sortOrder;
	        $scope.params.page = $scope.init.page;
	        if ($scope.resource.pagination) {
	          $scope.params.page = $scope.resource.pagination.page || $scope.init.page;
	        }
	        if (initNow) {
	          $scope.$evalAsync(updateClientSideResource);
	        } 
	      } else {
	        $scope.params.sortBy = $scope.init.sortBy;
	        $scope.params.sortOrder = $scope.init.sortOrder;
	        $scope.params.page = $scope.init.page;
	        if (initNow) {
	          $scope.$evalAsync(updateServerSideResource);
	        } else if ($scope.reload) {
	          $scope.url = buildUrl($scope.params, $scope.filters);
	          $scope.reload = function () {
	            $scope.resourceCallback($scope.url, angular.copy($scope.params))
	            .then(function (resource) {
	              setDirectivesValues(resource);
	            });
	          };
	        }
	      }
	    }
	  };
	
	  vm.bindOnce = vm.config.bindOnce;
	
	  setDirectivesValues = function (resource) {
	    if (!angular.isObject(resource)) {
	      throw new Error('Angular tastyTable directive: the resource response '+
	                      'is not an object');
	    } else if (!resource.header && !resource.rows) {
	      throw new Error('Angular tastyTable directive: the resource response object '+
	                      'has the property header or rows undefined');
	    }
	    Object.keys(resource).forEach(function(key) {
	      if (listImmutableKey.indexOf(key) < 0) {
	        $scope[key] = resource[key];
	      }
	    });
	    // Assuming if one header uses just one key it's based on the new pattern.
	    // [feature request] simplified header for resources #37 by @WebReflection
	    if (resource.header.length && Object.keys(resource.header[0]).length === 1) {
	      resource.header = resource.header.map(function (header) {
	        var key = Object.keys(header)[0];
	        return {
	          key: key,
	          name: header[key]
	        };
	      });
	    }
	    $scope.header = {
	      'columns': resource.header,
	      'sortBy': $scope.params.sortBy,
	      'sortOrder': $scope.params.sortOrder
	    };
	    if (!$scope.clientSide) {
	      $scope.header.sortBy = $scope.header.sortBy || resource.sortBy;
	      $scope.header.sortOrder = $scope.header.sortOrder || resource.sortOrder;
	    }
	    $scope.rows = resource.rows;
	    if ($scope.paginationDirective) {
	      $scope.pagination.page = $scope.params.page;
	      $scope.pagination.count = $scope.params.count;
	      $scope.pagination.size = $scope.rows.length;
	      if (resource.pagination) {
	        if (resource.pagination.count) {
	          $scope.pagination.count = resource.pagination.count;
	        }
	        if (resource.pagination.page) {
	          $scope.pagination.page = resource.pagination.page;
	        }
	        if (resource.pagination.size) {
	          $scope.pagination.size = resource.pagination.size;
	        }
	      }
	      $scope.pagination.pages = Math.ceil($scope.pagination.size / $scope.pagination.count);
	      if ($scope.pagination.pages < $scope.pagination.page) {
	        $scope.params.page = $scope.pagination.pages;
	      }
	    }
	  };
	
	  buildClientResource = function(updateFrom) {
	    var fromRow, toRow, rowToShow, reverse, listSortBy;
	    $scope.logs.buildClientResourceCount += 1;
	    if ($scope.theadDirective && $scope.header.columns.length) {
	      reverse = $scope.header.sortOrder === 'asc' ? false : true;
	      listSortBy = [function(item) {
	        return $scope.header.sortBy.split('.')
	        .reduce(function (previousValue, currentValue) {
	          return previousValue[currentValue];
	        }, item);
	      }];
	      if ($scope.header.columns[0].key !== $scope.header.sortBy) {
	        listSortBy.push(function(item) {
	          return $scope.header.columns[0].key.split('.')
	          .reduce(function (previousValue, currentValue) {
	            return previousValue[currentValue];
	          }, item);
	        });
	      }
	      if ($scope.header.sortBy) {
	        $scope.rows = $filter('orderBy')($scope.rows, listSortBy, reverse);
	      }
	    }
	    if ($attrs.bindFilters) {
	      $scope.rows = $filter('filter')($scope.rows, $scope.filters, $scope.filtersComparator);
	    }
	    if ($scope.paginationDirective) {
	      $scope.pagination.count = $scope.params.count;
	      $scope.pagination.size = $scope.rows.length;
	      $scope.pagination.pages = Math.ceil($scope.rows.length / $scope.pagination.count);
	      if (updateFrom === 'filters' || 
	          $scope.pagination.page > $scope.pagination.pages) {
	        $scope.pagination.page = 1;
	        $scope.params.page = 1;
	      } else {
	        $scope.pagination.page = $scope.params.page;
	      }
	      toRow = $scope.pagination.count * $scope.pagination.page;
	      fromRow = toRow - $scope.pagination.count;
	      if (fromRow >= 0 && toRow >= 0) {
	        rowToShow = $scope.rows.slice(fromRow, toRow);
	        $scope.rows = rowToShow;
	      }
	    }
	  };
	
	  buildUrl = function(params, filters) {
	    var urlQuery, value, url, listKeyNotJoin;
	    urlQuery = {};
	    listKeyNotJoin = ['sortBy', 'sortOrder', 'page', 'count'];
	    if ($scope.theadDirective) {
	      urlQuery = tastyUtil.setProperty(urlQuery, params, 'sortBy');
	      urlQuery = tastyUtil.setProperty(urlQuery, params, 'sortOrder');
	    }
	    if ($scope.paginationDirective) {
	      urlQuery = tastyUtil.setProperty(urlQuery, params, 'page');
	      urlQuery = tastyUtil.setProperty(urlQuery, params, 'count');
	    }
	    if ($attrs.bindFilters) {
	      urlQuery = tastyUtil.joinObjects(urlQuery, filters, listKeyNotJoin);
	    }
	    return Object.keys(urlQuery).map(function(key) {
	      value = urlQuery[key];
	      if ($scope.query[key]) {
	        key = $scope.query[key];
	      }
	      return encodeURIComponent(key) + '=' + encodeURIComponent(value);
	    }).join('&');
	  };
	
	  updateClientSideResource = function (updateFrom) {
	    if ($scope.params.sortBy) {
	      $scope.resource.sortBy = $scope.params.sortBy;
	    }
	    if ($scope.params.sortOrder) {
	      $scope.resource.sortOrder = $scope.params.sortOrder;
	    }
	    if ($scope.params.page && $scope.params.count) {
	      $scope.resource.pagination = $scope.pagination;
	      $scope.resource.pagination.page = $scope.params.page;
	      $scope.resource.pagination.count = $scope.params.count;
	    }
	    setDirectivesValues($scope.resource);
	    buildClientResource(updateFrom);
	  };
	
	  updateServerSideResource = function (updateFrom) {
	    if (updateFrom === 'filters') {
	      if (Number.isInteger($scope.init.filterBase)) {
	        if ($scope.params.page !== $scope.init.filterBase) {
	          filterChangedPage = true;
	        }
	        $scope.params.page = $scope.init.filterBase;
	      }
	    }
	    $scope.url = buildUrl($scope.params, $scope.filters);
	
	    function updateServerSideResource () {
	      $scope.logs.updateServerSideResourceRunning = true;
	      var paramsObj = angular.copy($scope.params);
	      paramsObj.filters = $scope.filters;
	      $scope.resourceCallback($scope.url, paramsObj)
	      .then(function (resource) {
	        setDirectivesValues(resource);
	        $scope.logs.updateServerSideResourceRunning = false;
	      });
	    }
	
	    if ($scope.reload) {
	      $scope.reload = updateServerSideResource;
	    }
	    if ((initNow || updateFrom === 'params') &&
	        !$scope.logs.updateServerSideResourceRunning) {
	
	      if ($scope.reload) {
	        if (!filterChangedPage) {
	          updateServerSideResource();
	        }
	      } else {
	        updateServerSideResource();
	        filterChangedPage = false;
	      }
	    }
	  };
	  
	  // AngularJs $watch callbacks
	  if ($attrs.bindFilters) {
	    $scope.$watch('filters', function watchFilters (newValue, oldValue){
	      if (newValue !== oldValue) {
	        if ($scope.clientSide) {
	          $scope.$evalAsync(updateClientSideResource('filters'));
	        } else {
	          $scope.$evalAsync(updateServerSideResource('filters'));
	        }
	      }
	    }, true);
	  }
	  $scope.$watchCollection('params', function watchParams (newValue, oldValue){
	    if (newValue !== oldValue) {
	      // Run update resuorce only if we are on 
	      // the second cycle or more of `params`
	      if (paramsInitialCycle === false) {
	        if ($scope.clientSide) {
	          $scope.$evalAsync(updateClientSideResource('params'));
	        } else {
	          $scope.$evalAsync(updateServerSideResource('params'));
	        }
	      } else {
	        paramsInitialCycle = false;
	      }
	    }
	  });
	  if ($scope.resource) {
	    var watchResource = function (newValue, oldValue){
	      if (newValue !== oldValue) {
	        $scope.params.sortBy = $scope.resource.sortBy || $scope.params.sortBy;
	        $scope.params.sortOrder = $scope.resource.sortOrder || $scope.params.sortOrder;
	        $scope.$evalAsync(updateClientSideResource('resource'));
	        if (!$scope.resource.reload) {
	          $scope.resource.reload = function reloadResource () {
	            $scope.$evalAsync(updateClientSideResource('resource'));
	          };
	        }
	      }
	    };
	    if ($scope.watchResource === 'reference') {
	      $scope.$watch('resource', watchResource);
	    } else if ($scope.watchResource === 'collection') {
	      $scope.$watchCollection('resource.header', watchResource);
	      $scope.$watchCollection('resource.rows', watchResource);
	      $scope.$watchGroup(['resource.sortBy', 
	        'resource.sortOrder', 
	        'resource.pagination.count',
	        'resource.pagination.page',
	        'resource.pagination.pages',
	        'resource.pagination.size'], watchResource);
	    } else if ($scope.watchResource === 'equality') {
	      $scope.$watch('resource.header', watchResource, true);
	      $scope.$watch('resource.rows', watchResource, true);
	      $scope.$watch('resource.sortBy', watchResource, true);
	      $scope.$watch('resource.sortOrder', watchResource, true);
	      $scope.$watch('resource.pagination.count', watchResource, true);
	      $scope.$watch('resource.pagination.page', watchResource, true);
	      $scope.$watch('resource.pagination.pages', watchResource, true);
	      $scope.$watch('resource.pagination.size', watchResource, true);
	    }
	  }
	}])
	.directive('tastyTable', function(){
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: 'TableController',
	    link: function postLink(scope, element, attrs, tastyTable) {
	      if (element.find('tasty-thead').length ||
	          element[0].querySelector('[tasty-thead]')) {
	        tastyTable.activate('thead');
	      }
	      if (element.find('tasty-pagination').length ||
	          element[0].querySelector('[tasty-pagination]')) {
	        tastyTable.activate('pagination');
	      }
	      tastyTable.initTable();
	    }
	  };
	})
	
	/**
	 * @ngdoc directive
	 * @name ngTasty.component.tastyThead
	 *
	 * @example
	  <table tasty-table>
	    <thead table-head></thead>
	    <tbody></tbody>
	  </table>
	 *
	 */
	.directive('tastyThead', ["$filter", "$templateCache", "$http", "$compile", "tableConfig", "tastyUtil", function($filter, $templateCache, $http, $compile, tableConfig, tastyUtil) {
	  return {
	    restrict: 'AE',
	    require: '^tastyTable',
	    scope: {},
	    templateUrl: tableConfig.templateHeadUrl,
	    link: function postLink(scope, element, attrs, tastyTable) {
	      var newScopeName, listScopeToWatch;
	      scope.bindOnce = tastyTable.bindOnce;
	      scope.columns = [];
	      scope.bootstrapIcon = tastyTable.config.bootstrapIcon;
	      scope.iconUp = tastyTable.config.iconUp;
	      scope.iconDown = tastyTable.config.iconDown;
	
	      listScopeToWatch = [
	        'bindNotSortBy', 
	        'bindBootstrapIcon', 
	        'bindIconUp', 
	        'bindIconDown',
	        'bindTemplateUrl'
	      ];
	      listScopeToWatch.forEach(function (scopeName) {
	        newScopeName = scopeName.substring(4);
	        newScopeName = newScopeName.charAt(0).toLowerCase() + newScopeName.slice(1);
	        if (attrs[scopeName]) {
	          tastyUtil.bindTo(scopeName, scope, attrs, newScopeName);
	        } else if (attrs[newScopeName]) {
	          if (attrs[newScopeName][0] === '[') {
	            attrs[newScopeName] = attrs[newScopeName].replace(/'/g, '"');
	            scope[newScopeName] = JSON.parse(attrs[newScopeName]);
	          } else {
	            scope[newScopeName] = attrs[newScopeName];
	          }
	        }
	      });
	
	      if (scope.templateUrl) {
	        $http.get(scope.templateUrl, { cache: $templateCache })
	        .success(function(templateContent) {
	          element.replaceWith($compile(templateContent)(scope));                
	        });
	      }
	
	      function cleanSortBy (sortBy) {
	        if (sortBy) {
	          return $filter('cleanFieldName')(sortBy);
	        }
	        return undefined;
	      }
	
	      scope.setColumns = function () {
	        var width, i, active, sortable, sort, 
	            isSorted, isSortedCaret;
	        scope.columns = [];
	        if (scope.header.sortOrder === 'dsc' && 
	            scope.header.sortBy &&
	            scope.header.sortBy[0] !== '-') {
	          scope.header.sortBy = '-' + scope.header.sortBy;
	        }
	        scope.header.columns.forEach(function (column, index) {
	          column.style = column.style || {};
	          if (!angular.isArray(column.class)) {
	            column.class = [];
	          }
	          sortable = true;
	          active = false;
	          isSorted = '';
	          isSortedCaret = '';
	          // Not sort column when the key is present in the `notSortBy` list,
	          // and Not sort column when `notSortBy` is an empty list
	          // If sortable property is present in column object, then use it
	          if (angular.isArray(scope.notSortBy)) {
	            if (scope.notSortBy.length) {
	              sortable = scope.notSortBy.indexOf(column.key) < 0;
	            } else {
	              sortable = false;
	            }
	          } else {
	            if (angular.isDefined(column.sortable)) {
	              sortable = column.sortable === true;
	            }
	          }
	          if (column.key === scope.header.sortBy ||
	              '-' + column.key === scope.header.sortBy) {
	            active = true;
	          }
	          if (!angular.isDefined(column.key)) {
	            throw new Error('Angular tastyTable directive: need a key value ' +
	                            'each column table header');
	          }
	          sort = $filter('cleanFieldName')(column.key);
	          if (cleanSortBy(scope.header.sortBy) === '-' + sort) {
	            if (tastyTable.config.bootstrapIcon) {
	              isSorted = '';
	              isSortedCaret = 'caret';
	            } else {
	              isSorted = scope.iconDown;
	            }
	          } else if (cleanSortBy(scope.header.sortBy) === sort) {
	            if (tastyTable.config.bootstrapIcon) {
	              isSorted = 'dropup';
	              isSortedCaret = 'caret';
	            } else {
	              isSorted = scope.iconUp;
	            }
	          }
	          scope.columns.push({
	            'key': column.key,
	            'name': column.name,
	            'active': active,
	            'sortable': sortable,
	            'class': column.class,
	            'style': column.style,
	            'isSorted': isSorted,
	            'isSortedCaret': isSortedCaret
	          });
	        });
	        if (!tastyTable.start) {
	          // Thead it's called
	          tastyTable.initTable('thead');
	        }
	      };
	
	      scope.sortBy = function (column) {
	        if (!column.sortable) {
	          return false;
	        }
	        var columnName, sortOrder;
	        columnName = $filter('cleanFieldName')(column.key);
	        if (cleanSortBy(scope.header.sortBy) === columnName) {
	          sortOrder = 'dsc';
	        } else {
	          sortOrder = 'asc';
	        }
	        tastyTable.setParams('sortBy', column.key);
	        tastyTable.setParams('sortOrder', sortOrder);
	      };
	
	      scope.classToShow = function (column) {
	        var listClassToShow = [];
	        if (column.sortable) {
	          listClassToShow.push('sortable');
	        }
	        if (column.active) {
	          listClassToShow.push('active');
	        }
	        column.class.forEach(function getListClass (className) {
	          listClassToShow.push(className);
	        });
	        return listClassToShow;
	      };
	
	      tastyTable.$scope.$watchCollection('header', function watchHeader (newValue, oldValue){
	        if (newValue  && ((newValue !== oldValue) || !tastyTable.start)) {
	          scope.header = newValue;
	          scope.setColumns();
	        }
	      });
	    }
	  };
	}])
	
	/**
	 * @ngdoc directive
	 * @name ngTasty.component.tastyPagination
	 *
	 * @example
	  <div tasty-table>
	    <table>
	     ...
	    </table>
	    <div table-pagination></div>
	  </div>
	 *
	 */
	.directive('tastyPagination', ["$filter", "$templateCache", "$http", "$compile", "tableConfig", "tastyUtil", function($filter, $templateCache, $http, $compile, tableConfig, tastyUtil) {
	  return {
	    restrict: 'AE',
	    require: '^tastyTable',
	    scope: {},
	    templateUrl: tableConfig.templateUrl,
	    link: function postLink(scope, element, attrs, tastyTable) {
	      var getPage, setCount, setPaginationRange, setPreviousRange, 
	          setRemainingRange, setPaginationRanges, listScopeToWatch, newScopeName;
	
	      listScopeToWatch = [
	        'bindItemsPerPage', 
	        'bindListItemsPerPage', 
	        'bindTemplateUrl'
	      ];
	      listScopeToWatch.forEach(function (scopeName) {
	        newScopeName = scopeName.substring(4);
	        newScopeName = newScopeName.charAt(0).toLowerCase() + newScopeName.slice(1);
	        if (attrs[scopeName]) {
	          tastyUtil.bindTo(scopeName, scope, attrs, newScopeName);
	        } else if (attrs[newScopeName]) {
	          if (newScopeName === 'itemsPerPage') {
	            scope[newScopeName] = parseInt(attrs[newScopeName]);
	          } else {
	            try {
	              scope[newScopeName] = JSON.parse(attrs[newScopeName]);
	            } catch (err) {
	              scope[newScopeName] = attrs[newScopeName];
	            }
	          }
	        }
	      });
	      
	      if (scope.templateUrl) {
	        $http.get(scope.templateUrl, { cache: $templateCache })
	        .success(function(templateContent) {
	          element.replaceWith($compile(templateContent)(scope));                
	        });
	      }
	
	      // Default configs
	      scope.itemsPerPage = scope.itemsPerPage || tastyTable.config.itemsPerPage;
	      scope.listItemsPerPage = scope.listItemsPerPage || tastyTable.config.listItemsPerPage;
	
	      // Serve side table case
	      if (!tastyTable.$scope.clientSide) {
	        scope.itemsPerPage = tastyTable.$scope.init.count || scope.itemsPerPage;
	      }
	
	      // Internal variable
	      scope.pagination = {};
	      scope.pagMinRange = 1;
	      scope.pagMaxRange = 1;
	
	      getPage = function (numPage) {
	        tastyTable.setParams('page', numPage);
	      };
	
	      setCount = function(count) {
	        var maxItems, page;
	        scope.itemsPerPage = count;
	        maxItems = count * scope.pagination.page;
	        if (maxItems > scope.pagination.size) {
	          page = Math.ceil(scope.pagination.size / count);
	          tastyTable.setParams('page', page);
	        }
	        tastyTable.setParams('count', count);
	      };
	
	      setPaginationRange = function () {
	        var currentPage, totalPages;
	        currentPage = scope.pagination.page;
	        if (currentPage > scope.pagination.pages) {
	          currentPage = scope.pagination.pages;
	        }
	        scope.pagMinRange = (currentPage - 2) > 0 ? (currentPage - 2) : 1;
	        scope.pagMaxRange = (currentPage + 2);
	        scope.pagination.page  = currentPage;
	        setPaginationRanges();
	      };
	
	      setPreviousRange = function () {
	        if (scope.pagHideMinRange === true || scope.pagMinRange < 1) {
	          return false;
	        }
	        scope.pagMaxRange = scope.pagMinRange;
	        scope.pagMinRange = scope.pagMaxRange - 5;
	        setPaginationRanges();
	      };
	
	      setRemainingRange = function () {
	        if (scope.pagHideMaxRange === true || 
	            scope.pagMaxRange > scope.pagination.pages) {
	          return false;
	        }
	        scope.pagMinRange = scope.pagMaxRange;
	        scope.pagMaxRange = scope.pagMinRange + 5;
	        if (scope.pagMaxRange >= scope.pagination.pages) {
	          scope.pagMaxRange = scope.pagination.pages + 1;
	          scope.pagMinRange = scope.pagMaxRange - 5 + 1;
	        }
	        scope.pagMinRange = scope.pagMaxRange - 5;
	        setPaginationRanges();
	      };
	
	      setPaginationRanges =  function () {
	        scope.listItemsPerPageShow = [];
	        scope.pagMinRange = scope.pagMinRange > 0 ? scope.pagMinRange : 1;
	        scope.pagMaxRange = scope.pagMinRange + 5;
	        if (scope.pagMaxRange > scope.pagination.pages) {
	          scope.pagMaxRange = scope.pagination.pages + 1;
	        }
	        scope.pagHideMinRange = scope.pagMinRange <= 1;
	        scope.pagHideMaxRange = scope.pagMaxRange > scope.pagination.pages;
	        scope.classPageMinRange = scope.pagHideMinRange ? 'disabled' : '';
	        scope.classPageMaxRange = scope.pagHideMaxRange ? 'disabled' : '';
	
	        for (var i = scope.listItemsPerPage.length; i >= 0; i--) {
	          if (scope.pagination.size > scope.listItemsPerPage[i]) {
	            scope.listItemsPerPageShow = scope.listItemsPerPage.slice(0, (i + 2));
	            break;
	          }
	        }
	        scope.rangePage = $filter('range')([], scope.pagMinRange, scope.pagMaxRange);
	
	        if (!tastyTable.start) {
	          // Pagination it's called
	          tastyTable.initTable('pagination');
	        }
	      };
	
	      scope.classPaginationCount = function (count) {
	        if (count == scope.pagination.count) {
	          return 'active';
	        }
	        return '';
	      };
	
	      scope.classNumPage = function (numPage) {
	        if (numPage == scope.pagination.page) {
	          return 'active';
	        }
	        return false;
	      };
	
	      scope.page = {
	        'get': getPage,
	        'setCount': setCount,
	        'previous': setPreviousRange,
	        'remaining': setRemainingRange
	      };
	
	      tastyTable.$scope.$watchCollection('pagination', function watchPagination (newValue, oldValue){
	        if (newValue  && ((newValue !== oldValue) || !tastyTable.start)) {
	          scope.pagination = newValue;
	          setPaginationRange();
	        }
	      });
	
	      // Init Pagination
	      scope.page.setCount(scope.itemsPerPage);
	    }
	  };
	}]);
	
	/**
	 * @ngdoc filter
	 * @name ngTasty.filter.filterCamelize
	 * @function
	 *
	 */
	angular.module('ngTasty.filter.camelize', [])
	.filter('camelize', function() {
	  var CAMELIZE_REGEX = /(?:^|[-_ ])(\w)/g;
	  
	  return function (input, first) {
	    var isString = typeof input === 'string',
	        firstLetter = typeof first === 'undefined' ? false : !!first;
	    
	    if(typeof input === 'undefined' || 
	       input === null || 
	       (!isString && isNaN(input)) ) {
	      return '';
	    }
	
	    if(!isString){
	      return '' + input;
	    }
	    
	    return input.trim() // remove trailing spaces
	      .replace(/ +(?= )/g,'') // remove multiple WS
	      .replace(CAMELIZE_REGEX, function (_, character, pos) { // actual conversion
	        if (character && (firstLetter || pos > 0)) {
	          return character.toUpperCase();
	        } else {
	          return character;
	        }
	      });
	  };
	});
	
	/**
	 * @ngdoc filter
	 * @name ngTasty.filter.cleanFieldName
	 * @function
	 *
	 * @description
	 * Calling cleanFieldName will replace all 
	 * empty space with with -
	 *
	 * @example
	  ng-bind="key | cleanFieldName"
	 *
	 */
	angular.module('ngTasty.filter.cleanFieldName', [])
	.filter('cleanFieldName', function() {
	  return function (input) {
	    return input.replace(/[^a-zA-Z0-9-_-]+/g, '-');
	  };
	});
	
	/**
	 * @ngdoc filter
	 * @name ngTasty.filter.filterInt
	 * @function
	 *
	 */
	angular.module('ngTasty.filter.filterInt', [])
	.filter('filterInt', function() {
	  return function (input) {
	    if(/^(\-|\+)?([0-9]+|Infinity)$/.test(input)) {
	      return Number(input);
	    }
	    return NaN;
	  };
	});
	
	/**
	 * @ngdoc filter
	 * @name ngTasty.filter.range
	 * @function
	 *
	 * @description
	 * Create a list containing arithmetic progressions. The arguments must 
	 * be plain integers. If the step argument is omitted, it defaults to 1. 
	 * If the start argument is omitted, it defaults to 0.
	 *
	 * @example
	  ng-repeat="n in [] | range:1:30"
	 */
	angular.module('ngTasty.filter.range', ['ngTasty.filter.filterInt'])
	.filter('range', ["$filter", function($filter) {
	  return function(input, start, stop, step) {
	    start = $filter('filterInt')(start);
	    stop = $filter('filterInt')(stop);
	    step = $filter('filterInt')(step);
	    if (isNaN(start)) {
	      start = 0;
	    }
	    if (isNaN(stop)) {
	      stop = start;
	      start = 0;
	    }
	    if (isNaN(step)) {
	      step = 1;
	    }
	    if ((step > 0 && start >= stop) || (step < 0 && start <= stop)){
	      return [];
	    }
	    for (var i = start; step > 0 ? i < stop : i > stop; i += step){
	      input.push(i);
	    }
	    return input;
	  };
	}]);
	
	/**
	 * @author https://github.com/bogdan-alexandrescu/ - @balx
	 * @ngdoc filter
	 * @name ngTasty.filter.slugify
	 * @function
	 *
	 * @description
	 * Transform text into an ascii slug by replacing whitespaces, accentuated, 
	 * and special characters with the coresponding latin character or completely 
	 * removing them when no latin equivalent is found. This can be used safely to 
	 * generate valid URLs.
	 */
	angular.module('ngTasty.filter.slugify', [])
	.filter('slugify', function () {
	
	  var makeString = function (object) {
	    if (object == null) {
	      return '';
	    }
	    return '' + object;
	  };
	
	  var from  = 'ąàáäâãåæăćčĉęèéëêĝĥìíïîĵłľńňòóöőôõðøśșšŝťțŭùúüűûñÿýçżźž',
	      to    = 'aaaaaaaaaccceeeeeghiiiijllnnoooooooossssttuuuuuunyyczzz',
	      regex = new RegExp('[' + from + ']', 'g');
	
	  return function (str) {
	    str = makeString(str)
	    .toString() // make sure is a string
	    .toLowerCase()
	    .replace(regex, function (c){
	      var index = from.indexOf(c);
	      return to.charAt(index) || '-';
	    }) // normalize some foreign characters
	    .replace(/[^\w\-\s]+/g, '') // remove unwanted characters
	    .trim() //trim spaces
	    .replace(/\s+/g, '-') // replace any space with a dash
	    .replace(/\-\-+/g, '-'); // remove duplicate dashes
	    return str;
	  };
	});
	  
	/**
	 * @ngdoc service
	 * @name ngTasty.service.bindTo
	 * @description
	 *
	 * Set up $watches for isolate scope and controller bindings. This process
	 * only occurs for isolate scopes and new scopes with controllerAs.
	 */
	angular.module('ngTasty.service.bindTo', [])
	.factory('bindTo', ["$parse", function($parse) {
	  return function (scopeName, scope, attrs, newScopeName) {
	    var lastValue, parentGet, compare, parentSet, 
	    parentValueWatch, isolateScopeName;
	    if (!attrs[scopeName]) {
	      return;
	    }
	    parentGet = $parse(attrs[scopeName]);
	    if (parentGet.literal) {
	      compare = angular.equals;
	    } else {
	      compare = function(a,b) { return a === b || (a !== a && b !== b); };
	    }
	    if (newScopeName) {
	      isolateScopeName = newScopeName;
	    } else {
	      isolateScopeName = scopeName;
	    }
	    parentSet = parentGet.assign || function() {
	      // reset the change, or we will throw this exception on every $digest
	      lastValue = scope[scopeName] = parentGet(scopeName);
	      throw 'Expression ' + attrs[attrName] + ' is non-assignable!';
	    };
	    lastValue = scope[isolateScopeName] = parentGet(scope.$parent);
	    parentValueWatch = function parentValueWatch(parentValue) {
	      if (!compare(parentValue, scope[isolateScopeName])) {
	        // we are out of sync and need to copy
	        if (!compare(parentValue, lastValue)) {
	          // parent changed and it has precedence
	          scope[isolateScopeName] = parentValue;
	        } else {
	          // if the parent can be assigned then do so
	          parentSet(scope.$parent, parentValue = scope[isolateScopeName]);
	        }
	      }
	      return lastValue = parentValue;
	    };
	    parentValueWatch.$stateful = true;
	    scope.$parent.$watch($parse(attrs[scopeName], parentValueWatch), null, parentGet.literal);
	  };
	}]);
	
	/**
	 * @ngdoc service
	 * @name ngTasty.service.debounce
	 * @description
	 *
	 */
	angular.module('ngTasty.service.debounce', [])
	.factory('debounce', ["$timeout", function ($timeout) {
	  return function (func, wait, immediate) {
	    var args, context, debounceTimeout, timeout;
	    debounceTimeout = function() {
	      timeout = null;
	      if (!immediate) {
	        func.apply(context, args);
	      }
	    };
	    return function debounce () {
	      context = this;
	      args = arguments;
	      var callNow = immediate && !timeout;
	      $timeout.cancel(timeout);
	      timeout = $timeout(debounceTimeout, wait);
	      if (callNow) {
	        func.apply(context, args);
	      }
	    };
	  };
	}]);
	
	/**
	 * @ngdoc service
	 * @name ngTasty.service.joinObjects
	 * @description
	 *
	 */
	angular.module('ngTasty.service.joinObjects', ['ngTasty.service.setProperty'])
	.factory('joinObjects', ["setProperty", function(setProperty) {
	  return function(objOne, objTwo, listKeyNotJoin) {
	    listKeyNotJoin = listKeyNotJoin || [];
	    for (var attrname in objTwo) {
	      if (listKeyNotJoin.indexOf(attrname) < 0) {
	        setProperty(objOne, objTwo, attrname);
	      }
	    }
	    return objOne;
	  };
	}]);
	
	/**
	 * @ngdoc service
	 * @name ngTasty.service.setProperty
	 * @description
	 *
	 */
	angular.module('ngTasty.service.setProperty', [])
	.factory('setProperty', function() {
	  return function(objOne, objTwo, attrname) {
	    if (typeof objTwo[attrname] !== 'undefined' && 
	        objTwo[attrname] !== null) {
	      if (angular.isString(objTwo[attrname])) {
	        if (objTwo[attrname].length) {
	          objOne[attrname] = objTwo[attrname];
	        }
	      } else {
	        objOne[attrname] = objTwo[attrname];
	      }
	    }
	    return objOne;
	  };
	});
	
	/**
	 * @ngdoc service
	 * @name ngTasty.service.tastyUtil
	 * @description
	 *
	 */
	angular.module('ngTasty.service.tastyUtil', [
	  'ngTasty.service.bindTo',
	  'ngTasty.service.debounce',
	  'ngTasty.service.setProperty',
	  'ngTasty.service.joinObjects',
	  'ngTasty.service.throttle',
	  'ngTasty.service.webSocket'
	])
	.factory('tastyUtil', ["debounce", "setProperty", "joinObjects", "bindTo", "webSocket", "throttle", function(debounce, setProperty, joinObjects, 
	  bindTo, webSocket, throttle) {
	  return {
	    'bindTo': bindTo,
	    'debounce': debounce,
	    'setProperty': setProperty,
	    'joinObjects': joinObjects,
	    'throttle': throttle,
	    'webSocket': webSocket
	  };
	}]);
	
	/**
	 * @ngdoc service
	 * @name ngTasty.service.throttle
	 * @description
	 * # throttle
	 * Factory in ngTasty.
	 */
	angular.module('ngTasty.service.throttle', [])
	.factory('throttle', ["$timeout", function ($timeout) {
	  return function (fn, threshhold, scope) {
	    threshhold = threshhold || 250;
	    var last, promise;
	    return function throttle () {
	      var context = scope || this;
	      var now = Date.now(),
	          args = arguments;
	      if (last && now < last + threshhold) {
	        // hold on to it
	        $timeout.cancel(promise);
	        promise = $timeout(function throttleTimeout () {
	          last = now;
	          fn.apply(context, args);
	        }, threshhold);
	      } else {
	        last = now;
	        fn.apply(context, args);
	      }
	    };
	  };
	}]);
	
	/**
	 * @ngdoc service
	 * @name ngTasty.service.webSocket
	 * @description
	 * # webSocket
	 * Factory in ngTasty.
	 */
	angular.module('ngTasty.service.webSocket', [])
	.factory('webSocket', function() {
	  return function(url) {
	    /**
	     * Creates a String[1] representing a binary blob[2] function 
	     * containing the WebSocket Factory API.
	     *
	     * [1]: https://developer.mozilla.org/en-US/docs/Web/API/URL.createObjectURL
	     * [2]: https://developer.mozilla.org/en-US/docs/Web/API/Blob
	     * 
	     * @return {string}   String containing the encoded script
	     */
	    var blobURL = URL.createObjectURL(new Blob(['(', function() {
	      var WSWorker = (function() {
	        var _ws;
	
	        /**
	         * Initialize a new WebSocket using
	         * the provided URL parameters.
	         * 
	         * @param  {string} url The WebSocket URL
	         */
	        var initialize = function(url) {
	          _ws = new WebSocket(url);
	        };
	
	        /**
	         * Listens for any message coming from the WebSocket
	         * and send its content to the main JS thread using postMessage[1].
	         *
	         * [1]: https://developer.mozilla.org/en-US/docs/Web/API/Worker.postMessage
	         * 
	         */
	        var on = function() {
	          _ws.onmessage = function(response) {
	            var data = JSON.parse(response.data);
	            self.postMessage(data);
	          };
	        };
	
	        /**
	         * Sends data to the WebSocket.
	         * 
	         * @param  {string} data
	         */
	        var send = function(data) {
	          _ws.send(data);
	        };
	
	        return {
	          initialize: initialize,
	          on: on,
	          send: send
	        };
	
	      })();
	
	      /**
	       * Listens for incoming messages from the main
	       * JavaScript Thread.
	       *
	       * The commands allowed are:
	       *
	       * ws_new  ~> Calls initialize on the Web Socket Worker
	       * ws_on   ~> Register the supplied callback
	       * ws_send ~> Sends a message to the underlying WebSocket
	       *            encoding it as a string (JSON.stringify)
	       *            
	       */
	      self.addEventListener('message', function(e) {
	        switch (e.data.cmd) {
	          case 'ws_new':
	            WSWorker.initialize(e.data.url);
	            break;
	          case 'ws_on':
	            WSWorker.on();
	            break;
	          case 'ws_send':
	            WSWorker.send(JSON.stringify(e.data.data));
	            break;
	          default:
	            console.log('Unknown command: ' + e.data.cmd);
	          }
	      });
	
	    }.toString(), ')()'], { type: 'application/javascript' }));
	    
	
	    // Create a new WebSocket Worker, revoke the URL since
	    // it's not useful anymore.
	    var _worker = new Worker(blobURL);
	    URL.revokeObjectURL(blobURL);
	
	    // Tell the WebSocket Worker to init a new WebSocket
	    _worker.postMessage({ cmd: 'ws_new', url: url });
	
	
	    return {
	      /**
	       * Registers a callback to a specific Worker event listener.
	       * There are two different events:
	       *
	       * - 'all' ~> subscribes to all websocket messages
	       * - 'type'~> subscribes to all websocket messages containing
	       *            a field named 'type'.
	       *
	       * For example, WebSockets Server events like this one:
	       *
	       * {
	       *   'type': 'tweet',
	       *   'data': ...
	       * }
	       *
	       * can be handled in the following way:
	       *
	       *  ws.on('twitter', function(data) {
	       *      ...
	       *  });
	       *  
	       * @param  {string}   event The event name
	       * @param  {Function} cb    Callback with output data (first param)
	       */
	      on: function(event, cb) {
	        _worker.postMessage({ cmd: 'ws_on' });
	        _worker.addEventListener('message', function(e) {
	          if (event === 'all' || e.data.type === event) {
	            cb(e.data);
	          } 
	        });
	      },
	      /**
	       * Sends data to the WebSocket.
	       * 
	       * @param  {Any} data
	       */
	      send: function(data) {
	        _worker.postMessage({ cmd: 'ws_send', data: data });
	      }
	    };
	  };
	});
	
	(function(module) {
	try {
	  module = angular.module('ngTasty.tpls.table.head');
	} catch (e) {
	  module = angular.module('ngTasty.tpls.table.head', []);
	}
	module.run(['$templateCache', function($templateCache) {
	  $templateCache.put('template/table/head.html',
	    '<tr>\n' +
	    '  <th ng-repeat="column in columns track by $index" \n' +
	    '  ng-class="classToShow(column)"\n' +
	    '  ng-style="::column.style" ng-click="sortBy(column)">\n' +
	    '    <span ng-if="bindOnce" ng-bind="::column.name"></span>\n' +
	    '    <span ng-if="!bindOnce" ng-bind="column.name"></span>\n' +
	    '    <span ng-class="column.isSorted">\n' +
	    '      <span ng-class="column.isSortedCaret" ng-if="::bootstrapIcon"></span>\n' +
	    '    </span>\n' +
	    '  </th> \n' +
	    '</tr>');
	}]);
	})();
	
	(function(module) {
	try {
	  module = angular.module('ngTasty.tpls.table.pagination');
	} catch (e) {
	  module = angular.module('ngTasty.tpls.table.pagination', []);
	}
	module.run(['$templateCache', function($templateCache) {
	  $templateCache.put('template/table/pagination.html',
	    '<div class="row">\n' +
	    '  <div class="col-xs-3 text-left">\n' +
	    '    <div class="btn-group">\n' +
	    '      <button type="button" class="btn btn-default" \n' +
	    '      ng-repeat="count in listItemsPerPageShow" \n' +
	    '      ng-class="classPaginationCount(count)" \n' +
	    '      ng-click="page.setCount(count)" ng-bind="count"></button>\n' +
	    '    </div>\n' +
	    '  </div>\n' +
	    '  <div class="col-xs-6 text-center">\n' +
	    '    <ul class="pagination">\n' +
	    '      <li ng-class="classPageMinRange">\n' +
	    '        <a href ng-click="page.previous()">&laquo;</a>\n' +
	    '      </li>\n' +
	    '      <li ng-repeat="numPage in rangePage" ng-class="classNumPage(numPage)">\n' +
	    '        <a href ng-click="page.get(numPage)">\n' +
	    '          <span ng-bind="numPage"></span>\n' +
	    '          <span class="sr-only" ng-if="classNumPage(numPage)">(current)</span>\n' +
	    '        </a>\n' +
	    '      </li>\n' +
	    '      <li ng-class="classPageMaxRange">\n' +
	    '        <a href ng-click="page.remaining()">&raquo;</a>\n' +
	    '      </li>\n' +
	    '    </ul>\n' +
	    '  </div>\n' +
	    '  <div class="col-xs-3 text-right">\n' +
	    '    <p>Page <span ng-bind="pagination.page"></span> \n' +
	    '    of <span ng-bind="pagination.pages"></span>,\n' +
	    '    of <span ng-bind="pagination.size"></span> entries</p>\n' +
	    '  </div>\n' +
	    '</div>');
	}]);
	})();


/***/ },
/* 8 */
/***/ function(module, exports) {

	/*!
	 * ui-grid - v4.12.7 - 2024-04-12
	* http://ui-grid.info/
	 * Copyright (c) 2024 ; License: MIT 
	 */
	!function(){"use strict";angular.module("ui.grid.i18n",[]),angular.module("ui.grid",["ui.grid.i18n"])}(),function(){"use strict";angular.module("ui.grid.autoResize",["ui.grid"]).directive("uiGridAutoResize",["gridUtil",function(r){return{require:"uiGrid",scope:!1,link:function(e,n,t,o){var i;i=r.debounce(function(e,t,i,r){null!==n[0].offsetParent&&(o.grid.gridWidth=i,o.grid.gridHeight=r,o.grid.queueGridRefresh().then(function(){o.grid.api.core.raise.gridDimensionChanged(t,e,r,i)}))},400),e.$watchCollection(function(){return{width:r.elementWidth(n),height:r.elementHeight(n)}},function(e,t){angular.equals(e,t)||i(t.width,t.height,e.width,e.height)})}}}])}(),function(){"use strict";var e=angular.module("ui.grid.cellNav",["ui.grid"]);e.constant("uiGridCellNavConstants",{FEATURE_NAME:"gridCellNav",CELL_NAV_EVENT:"cellNav",direction:{LEFT:0,RIGHT:1,UP:2,DOWN:3,PG_UP:4,PG_DOWN:5},EVENT_TYPE:{KEYDOWN:0,CLICK:1,CLEAR:2}}),e.factory("uiGridCellNavFactory",["uiGridCellNavConstants","GridRowColumn",function(r,a){function e(e,t,i,r){this.rows=e.visibleRowCache,this.columns=t.visibleColumnCache,this.leftColumns=i?i.visibleColumnCache:[],this.rightColumns=r?r.visibleColumnCache:[],this.bodyContainer=e}return e.prototype.getFocusableCols=function(){return this.leftColumns.concat(this.columns,this.rightColumns).filter(function(e){return e.colDef.allowCellFocus})},e.prototype.getFocusableRows=function(){return this.rows.filter(function(e){return!1!==e.allowCellFocus})},e.prototype.getNextRowCol=function(e,t,i){switch(e){case r.direction.LEFT:return this.getRowColLeft(t,i);case r.direction.RIGHT:return this.getRowColRight(t,i);case r.direction.UP:return this.getRowColUp(t,i);case r.direction.DOWN:return this.getRowColDown(t,i);case r.direction.PG_UP:return this.getRowColPageUp(t,i);case r.direction.PG_DOWN:return this.getRowColPageDown(t,i)}},e.prototype.initializeSelection=function(){var e=this.getFocusableCols(),t=this.getFocusableRows();return 0===e.length||0===t.length?null:new a(t[0],e[0])},e.prototype.getRowColLeft=function(e,t){var i=this.getFocusableCols(),r=this.getFocusableRows(),t=i.indexOf(t),n=r.indexOf(e),o=0===(t=-1===t?1:t)?i.length-1:t-1;return new a(!(t<=o)||0===n?e:r[n-1],i[o])},e.prototype.getRowColRight=function(e,t){var i=this.getFocusableCols(),r=this.getFocusableRows(),t=i.indexOf(t),n=r.indexOf(e),o=(t=-1===t?0:t)===i.length-1?0:t+1;return!(o<=t)||n===r.length-1?new a(e,i[o]):new a(r[n+1],i[o])},e.prototype.getRowColDown=function(e,t){var i=this.getFocusableCols(),r=this.getFocusableRows(),t=i.indexOf(t),n=r.indexOf(e);return-1===t&&(t=0),n===r.length-1?new a(e,i[t]):new a(r[n+1],i[t])},e.prototype.getRowColPageDown=function(e,t){var i=this.getFocusableCols(),r=this.getFocusableRows(),t=i.indexOf(t),e=r.indexOf(e),n=(-1===t&&(t=0),this.bodyContainer.minRowsToRender());return e>=r.length-n?new a(r[r.length-1],i[t]):new a(r[e+n],i[t])},e.prototype.getRowColUp=function(e,t){var i=this.getFocusableCols(),r=this.getFocusableRows(),t=i.indexOf(t),n=r.indexOf(e);return new a(0===n?e:r[n-1],i[t=-1===t?0:t])},e.prototype.getRowColPageUp=function(e,t){var i=this.getFocusableCols(),r=this.getFocusableRows(),t=i.indexOf(t),e=r.indexOf(e),n=(-1===t&&(t=0),this.bodyContainer.minRowsToRender());return new a(e-n<0?r[0]:r[e-n],i[t])},e}]),e.service("uiGridCellNavService",["uiGridConstants","uiGridCellNavConstants","$q","uiGridCellNavFactory",function(t,i,r,n){var o={initializeGrid:function(r){r.registerColumnBuilder(o.cellNavColumnBuilder),r.cellNav={},r.cellNav.lastRowCol=null,r.cellNav.focusedCells=[],o.defaultGridOptions(r.options);var e={cellNav:{navigate:function(e,t){},viewPortKeyDown:function(e,t){},viewPortKeyPress:function(e,t){}}},t={cellNav:{scrollToFocus:function(e,t){return o.scrollToFocus(r,e,t)},getFocusedCell:function(){return r.cellNav.lastRowCol},getCurrentSelection:function(){return r.cellNav.focusedCells},rowColSelectIndex:function(e){for(var t=-1,i=0;i<r.cellNav.focusedCells.length;i++)if(r.cellNav.focusedCells[i].col.uid===e.col.uid&&r.cellNav.focusedCells[i].row.uid===e.row.uid){t=i;break}return t}}};r.api.registerEventsFromObject(e),r.api.registerMethodsFromObject(t)},defaultGridOptions:function(e){e.modifierKeysToMultiSelectCells=!0===e.modifierKeysToMultiSelectCells,e.keyDownOverrides=e.keyDownOverrides||[]},decorateRenderContainers:function(e){var t=e.hasRightContainer()?e.renderContainers.right:null,i=e.hasLeftContainer()?e.renderContainers.left:null;null!==i&&(e.renderContainers.left.cellNav=new n(e.renderContainers.body,i,t,e.renderContainers.body)),null!==t&&(e.renderContainers.right.cellNav=new n(e.renderContainers.body,t,e.renderContainers.body,i)),e.renderContainers.body.cellNav=new n(e.renderContainers.body,e.renderContainers.body,i,t)},getDirection:function(e){return e.keyCode===t.keymap.LEFT||e.keyCode===t.keymap.TAB&&e.shiftKey?i.direction.LEFT:e.keyCode===t.keymap.RIGHT||e.keyCode===t.keymap.TAB?i.direction.RIGHT:e.keyCode===t.keymap.UP||e.keyCode===t.keymap.ENTER&&e.shiftKey?i.direction.UP:e.keyCode===t.keymap.PG_UP?i.direction.PG_UP:e.keyCode===t.keymap.DOWN||e.keyCode===t.keymap.ENTER&&!e.ctrlKey&&!e.altKey?i.direction.DOWN:e.keyCode===t.keymap.PG_DOWN?i.direction.PG_DOWN:null},cellNavColumnBuilder:function(e,t,i){return e.allowCellFocus=void 0===e.allowCellFocus||e.allowCellFocus,r.all([])},scrollToFocus:function(t,e,i){var r=null,n=null;return null!=e&&(r=t.getRow(e)),null!=i&&(n=t.getColumn(i.name||i.field)),t.api.core.scrollToIfNecessary(r,n).then(function(){var e={row:r,col:n};null!==r&&null!==n&&t.cellNav.broadcastCellNav(e,null,null)})},getLeftWidth:function(e,t){var i,r=0;return t&&(i=e.renderContainers.body.visibleColumnCache.indexOf(t),e.renderContainers.body.visibleColumnCache.forEach(function(e,t){t<i&&(r+=e.drawnWidth)}),e=0===i?0:(i+1)/e.renderContainers.body.visibleColumnCache.length,r+=t.drawnWidth*e),r}};return o}]),e.directive("uiGridCellnav",["uiGridCellNavService","uiGridCellNavConstants","uiGridConstants","GridRowColumn","$compile","i18nService",function(s,u,d,c,o,g){return{replace:!0,priority:-150,require:"^uiGrid",scope:!1,controller:function(){},compile:function(){return{pre:function(e,t,i,a){var r=e,l=a.grid;s.initializeGrid(l),a.cellNav={},a.cellNav.makeRowCol=function(e){return e=e instanceof c?e:new c(e.row,e.col)},a.cellNav.getActiveCell=function(){var e=t[0].getElementsByClassName("ui-grid-cell-focus");if(0<e.length)return e[0]},a.cellNav.broadcastCellNav=l.cellNav.broadcastCellNav=function(e,t,i){t=!(void 0===t||!t),e=a.cellNav.makeRowCol(e),a.cellNav.broadcastFocus(e,t,i),r.$broadcast(u.CELL_NAV_EVENT,e,t,i)},a.cellNav.clearFocus=l.cellNav.clearFocus=function(){l.cellNav.focusedCells=[],r.$broadcast(u.CELL_NAV_EVENT)},a.cellNav.broadcastFocus=function(e,t,i){t=!(void 0===t||!t);var r=(e=a.cellNav.makeRowCol(e)).row,n=e.col,o=a.grid.api.cellNav.rowColSelectIndex(e);null===l.cellNav.lastRowCol||-1===o||l.cellNav.lastRowCol.col===n&&l.cellNav.lastRowCol.row===r?(r=new c(r,n),null!==l.cellNav.lastRowCol&&l.cellNav.lastRowCol.row===r.row&&l.cellNav.lastRowCol.col===r.col&&!l.options.enableCellEditOnFocus||(l.api.cellNav.raise.navigate(r,l.cellNav.lastRowCol,i),l.cellNav.lastRowCol=r),a.grid.options.modifierKeysToMultiSelectCells&&t?l.cellNav.focusedCells.push(e):l.cellNav.focusedCells=[e]):l.options.modifierKeysToMultiSelectCells&&t&&0<=o&&l.cellNav.focusedCells.splice(o,1)},a.cellNav.handleKeyDown=function(e){var t,i,r,n,o=s.getDirection(e);return null===o?null:(r="body",e.uiGridTargetRenderContainerId&&(r=e.uiGridTargetRenderContainerId),(t=a.grid.api.cellNav.getFocusedCell())?(i=a.grid.renderContainers[r].cellNav.getNextRowCol(o,t.row,t.col),r=a.grid.renderContainers[r].cellNav.getFocusableCols(),n=a.grid.api.cellNav.rowColSelectIndex(i),(o!==u.direction.LEFT||i.col!==r[r.length-1]||i.row!==t.row||e.keyCode!==d.keymap.TAB||!e.shiftKey)&&(o!==u.direction.RIGHT||i.col!==r[0]||i.row!==t.row||e.keyCode!==d.keymap.TAB||e.shiftKey)?(l.scrollToIfNecessary(i.row,i.col).then(function(){a.cellNav.broadcastCellNav(i,null,e)}),e.stopPropagation(),e.preventDefault(),!1):(l.cellNav.focusedCells.splice(n,1),a.cellNav.clearFocus(),!0)):void 0)}},post:function(t,i,e,r){var c=r.grid,r=!0;try{angular.module("ngAria")}catch(e){r=!1}function n(){var e='<div id="'+c.id+'-aria-speakable" class="ui-grid-a11y-ariascreenreader-speakable ui-grid-offscreen" aria-live="assertive" role="alert" aria-atomic="true" aria-hidden="false" aria-relevant="additions" >&nbsp;</div>',d=o(e)(t);i.prepend(d),t.$on(u.CELL_NAV_EVENT,function(e,t,i,r){if(!r||"focus"!==r.type){for(var n,o=[],a=c.api.cellNav.getCurrentSelection(),l=0;l<a.length;l++){s=a[l],n="";var s=(n="selectionRowHeaderCol"===s.col.field?(s.row.isSelected?g.getSafeText("search.aria.selected"):g.getSafeText("search.aria.notSelected"))+", ":n)+c.getCellDisplayValue(s.row,s.col)+(n=a[l].col,", "+g.getSafeText("headerCell.aria.column")+" "+n.displayName);o.push(s)}(r=o.toString())!==d.text().trim()&&(d[0].style.clip="rect(0px,0px,0px,0px)",d[0].innerHTML="",d[0].style.visibility="hidden",d[0].style.visibility="visible",""!==r)&&(d[0].style.clip="auto",d[0].appendChild(document.createTextNode(r+" ")),d[0].style.visibility="hidden",d[0].style.visibility="visible")}})}r&&n()}}}}}]),e.directive("uiGridRenderContainer",["$timeout","gridUtil","uiGridCellNavService","$compile","uiGridCellNavConstants",function(d,c,u,g,p){return{replace:!0,priority:-99999,require:["^uiGrid","uiGridRenderContainer","?^uiGridCellnav"],scope:!1,compile:function(){return{post:function(e,t,i,r){var n,o,a,l=r[0],s=r[1],r=r[2];l.grid.api.cellNav&&(n=s.containerId,s=l.grid,u.decorateRenderContainers(s),"body"===n)&&(l.grid.options.modifierKeysToMultiSelectCells?t.attr("aria-multiselectable",!0):t.attr("aria-multiselectable",!1),o=g('<div class="ui-grid-focuser" role="region" aria-live="assertive" aria-atomic="false" tabindex="0" aria-controls="'+s.id+"-aria-speakable "+s.id+'-grid-container" aria-owns="'+s.id+'-grid-container"></div>')(e),t.append(o),o.on("focus",function(e){e.uiGridTargetRenderContainerId=n,null===l.grid.api.cellNav.getFocusedCell()&&(e=l.grid.renderContainers[n].cellNav.getNextRowCol(p.direction.DOWN,null,null)).row&&e.col&&l.cellNav.broadcastCellNav(e)}),r.setAriaActivedescendant=function(e){t.attr("aria-activedescendant",e)},r.removeAriaActivedescendant=function(e){t.attr("aria-activedescendant")===e&&t.attr("aria-activedescendant","")},l.focus=function(){c.focus.byElement(o[0])},a=null,o.on("keydown",function(i){i.uiGridTargetRenderContainerId=n;var e=l.grid.api.cellNav.getFocusedCell();null===(l.grid.options.keyDownOverrides.some(function(t){return Object.keys(t).every(function(e){return t[e]===i[e]})})?null:l.cellNav.handleKeyDown(i))&&(l.grid.api.cellNav.raise.viewPortKeyDown(i,e,l.cellNav.handleKeyDown),a=e)}),o.on("keypress",function(e){a&&(d(function(){l.grid.api.cellNav.raise.viewPortKeyPress(e,a)},4),a=null)}),e.$on("$destroy",function(){o.off()}))}}}}}]),e.directive("uiGridViewport",function(){return{replace:!0,priority:-99999,require:["^uiGrid","^uiGridRenderContainer","?^uiGridCellnav"],scope:!1,compile:function(){return{pre:function(e,t,i,r){},post:function(e,t,i,r){var n=r[0],o=r[1];n.grid.api.cellNav&&"body"===o.containerId&&((r=n.grid).api.core.on.scrollBegin(e,function(){var e=n.grid.api.cellNav.getFocusedCell();null!==e&&o.colContainer.containsColumn(e.col)&&n.cellNav.clearFocus()}),r.api.core.on.scrollEnd(e,function(e){var t=n.grid.api.cellNav.getFocusedCell();null!==t&&o.colContainer.containsColumn(t.col)&&n.cellNav.broadcastCellNav(t)}),r.api.cellNav.on.navigate(e,function(){n.focus()}))}}}}}),e.directive("uiGridCell",["uiGridCellNavConstants","uiGridConstants","GridRowColumn",function(u,g,p){return{priority:-150,restrict:"A",require:["^uiGrid","?^uiGridCellnav"],scope:!1,link:function(i,e,t,r){var n,o,a=r[0],l=r[1];function s(e){e.preventDefault()}function d(){n.cellNav.focusedCells.some(function(e,t){return e.row===i.row&&e.col===i.col})?i.focused||(e.find("div").addClass("ui-grid-cell-focus"),e.attr("aria-selected",!0),l.setAriaActivedescendant(e.attr("id")),i.focused=!0):c()}function c(){i.focused&&(e.find("div").removeClass("ui-grid-cell-focus"),e.attr("aria-selected",!1),l.removeAriaActivedescendant(e.attr("id")),i.focused=!1)}a.grid.api.cellNav&&i.col.colDef.allowCellFocus&&(n=a.grid,i.focused=!1,e.attr("tabindex",-1),e.find("div").on("click",function(e){a.cellNav.broadcastCellNav(new p(i.row,i.col),e.ctrlKey||e.metaKey,e),e.stopPropagation(),i.$apply()}),e.on("mousedown",s),a.grid.api.edit&&(a.grid.api.edit.on.beginCellEdit(i,function(){e.off("mousedown",s)}),a.grid.api.edit.on.afterCellEdit(i,function(){e.on("mousedown",s)}),a.grid.api.edit.on.cancelCellEdit(i,function(){e.on("mousedown",s)})),d(),e.on("focus",function(e){a.cellNav.broadcastCellNav(new p(i.row,i.col),!1,e),e.stopPropagation(),i.$apply()}),i.$on(u.CELL_NAV_EVENT,d),o=a.grid.registerDataChangeCallback(function(e){c(),i.$applyAsync(d)},[g.dataChange.ROW]),i.$on("$destroy",function(){o(),e.find("div").off(),e.off()}))}}}])}(),function(){"use strict";angular.module("ui.grid").constant("uiGridConstants",{LOG_DEBUG_MESSAGES:!0,LOG_WARN_MESSAGES:!0,LOG_ERROR_MESSAGES:!0,CUSTOM_FILTERS:/CUSTOM_FILTERS/g,COL_FIELD:/COL_FIELD/g,MODEL_COL_FIELD:/MODEL_COL_FIELD/g,TOOLTIP:/title=\"TOOLTIP\"/g,DISPLAY_CELL_TEMPLATE:/DISPLAY_CELL_TEMPLATE/g,TEMPLATE_REGEXP:/<.+>/,FUNC_REGEXP:/(\([^)]*\))?$/,DOT_REGEXP:/\./g,APOS_REGEXP:/'/g,BRACKET_REGEXP:/^(.*)((?:\s*\[\s*\d+\s*\]\s*)|(?:\s*\[\s*"(?:[^"\\]|\\.)*"\s*\]\s*)|(?:\s*\[\s*'(?:[^'\\]|\\.)*'\s*\]\s*))(.*)$/,COL_CLASS_PREFIX:"ui-grid-col",ENTITY_BINDING:"$$this",events:{GRID_SCROLL:"uiGridScroll",COLUMN_MENU_SHOWN:"uiGridColMenuShown",ITEM_DRAGGING:"uiGridItemDragStart",COLUMN_HEADER_CLICK:"uiGridColumnHeaderClick"},keymap:{TAB:9,STRG:17,CAPSLOCK:20,CTRL:17,CTRLRIGHT:18,CTRLR:18,SHIFT:16,RETURN:13,ENTER:13,BACKSPACE:8,BCKSP:8,ALT:18,ALTR:17,ALTRIGHT:17,SPACE:32,WIN:91,MAC:91,FN:null,PG_UP:33,PG_DOWN:34,UP:38,DOWN:40,LEFT:37,RIGHT:39,ESC:27,DEL:46,F1:112,F2:113,F3:114,F4:115,F5:116,F6:117,F7:118,F8:119,F9:120,F10:121,F11:122,F12:123},ASC:"asc",DESC:"desc",filter:{STARTS_WITH:2,ENDS_WITH:4,EXACT:8,CONTAINS:16,GREATER_THAN:32,GREATER_THAN_OR_EQUAL:64,LESS_THAN:128,LESS_THAN_OR_EQUAL:256,NOT_EQUAL:512,SELECT:"select",INPUT:"input"},aggregationTypes:{sum:2,count:4,avg:8,min:16,max:32},CURRENCY_SYMBOLS:["¤","؋","Ar","Ƀ","฿","B/.","Br","Bs.","Bs.F.","GH₵","¢","c","Ch.","₡","C$","D","ден","دج",".د.ب","د.ع","JD","د.ك","ل.د","дин","د.ت","د.م.","د.إ","Db","$","₫","Esc","€","ƒ","Ft","FBu","FCFA","CFA","Fr","FRw","G","gr","₲","h","₴","₭","Kč","kr","kn","MK","ZK","Kz","K","L","Le","лв","E","lp","M","KM","MT","₥","Nfk","₦","Nu.","UM","T$","MOP$","₱","Pt.","£","ج.م.","LL","LS","P","Q","q","R","R$","ر.ع.","ر.ق","ر.س","៛","RM","p","Rf.","₹","₨","SRe","Rp","₪","Ksh","Sh.So.","USh","S/","SDR","сом","৳\t","WS$","₮","VT","₩","¥","zł"],scrollDirection:{UP:"up",DOWN:"down",LEFT:"left",RIGHT:"right",NONE:"none"},dataChange:{ALL:"all",EDIT:"edit",ROW:"row",COLUMN:"column",OPTIONS:"options"},scrollbars:{NEVER:0,ALWAYS:1,WHEN_NEEDED:2}})}(),angular.module("ui.grid").directive("uiGridCell",["$compile","$parse","gridUtil","uiGridConstants",function(n,e,o,s){return{priority:0,scope:!1,require:"?^uiGrid",compile:function(){return{pre:function(t,i,e,r){r&&t.col.compiledElementFn?(0,t.col.compiledElementFn)(t,function(e,t){i.append(e)}):r&&!t.col.compiledElementFn?t.col.getCompiledElementFn().then(function(e){e(t,function(e,t){i.append(e)})}).catch(angular.noop):(r=t.col.cellTemplate.replace(s.MODEL_COL_FIELD,"row.entity."+o.preEval(t.col.field)).replace(s.COL_FIELD,"grid.getCellValue(row, col)"),r=n(r)(t),i.append(r))},post:function(i,r){var n,o=i.col.getColClass(!1);function a(e){var t=r;n&&(t.removeClass(n),n=null),n=angular.isFunction(i.col.cellClass)?i.col.cellClass(i.grid,i.row,i.col,i.rowRenderIndex,i.colRenderIndex):i.col.cellClass,t.addClass(n)}r.addClass(o),i.col.cellClass&&a();var e=i.grid.registerDataChangeCallback(a,[s.dataChange.COLUMN,s.dataChange.EDIT]);var t=i.$watch("row",function(e,t){e!==t&&((n||i.col.cellClass)&&a(),(e=i.col.getColClass(!1))!==o)&&(r.removeClass(o),r.addClass(e),o=e)});function l(){e(),t()}i.$on("$destroy",l),r.on("$destroy",l)}}}}}]),angular.module("ui.grid").service("uiGridColumnMenuService",["i18nService","uiGridConstants","gridUtil",function(e,i,d){var r={initialize:function(e,t){e.grid=t.grid,(t.columnMenuScope=e).menuShown=!1},setColMenuItemWatch:function(t){var e=t.$watch("col.menuItems",function(e){void 0!==e&&e&&angular.isArray(e)?(e.forEach(function(e){void 0!==e.context&&e.context||(e.context={}),e.context.col=t.col}),t.menuItems=t.defaultMenuItems.concat(e)):t.menuItems=t.defaultMenuItems});t.$on("$destroy",e)},getGridOption:function(e,t){return void 0!==e.grid&&e.grid&&e.grid.options&&e.grid.options[t]},sortable:function(e){return Boolean(this.getGridOption(e,"enableSorting")&&void 0!==e.col&&e.col&&e.col.enableSorting)},isActiveSort:function(e,t){return Boolean(void 0!==e.col&&void 0!==e.col.sort&&void 0!==e.col.sort.direction&&e.col.sort.direction===t)},suppressRemoveSort:function(e){return Boolean(e.col&&e.col.suppressRemoveSort)},hideable:function(e){return Boolean(this.getGridOption(e,"enableHiding")&&void 0!==e.col&&e.col&&(e.col.colDef&&!1!==e.col.colDef.enableHiding||!e.col.colDef)||!this.getGridOption(e,"enableHiding")&&e.col&&e.col.colDef&&e.col.colDef.enableHiding)},getDefaultMenuItems:function(t){return[{title:function(){return e.getSafeText("sort.ascending")},icon:"ui-grid-icon-sort-alt-up",action:function(e){e.stopPropagation(),t.sortColumn(e,i.ASC)},shown:function(){return r.sortable(t)},active:function(){return r.isActiveSort(t,i.ASC)}},{title:function(){return e.getSafeText("sort.descending")},icon:"ui-grid-icon-sort-alt-down",action:function(e){e.stopPropagation(),t.sortColumn(e,i.DESC)},shown:function(){return r.sortable(t)},active:function(){return r.isActiveSort(t,i.DESC)}},{title:function(){return e.getSafeText("sort.remove")},icon:"ui-grid-icon-cancel",action:function(e){e.stopPropagation(),t.unsortColumn()},shown:function(){return r.sortable(t)&&void 0!==t.col&&void 0!==t.col.sort&&void 0!==t.col.sort.direction&&null!==t.col.sort.direction&&!r.suppressRemoveSort(t)}},{title:function(){return e.getSafeText("column.hide")},icon:"ui-grid-icon-cancel",shown:function(){return r.hideable(t)},action:function(e){e.stopPropagation(),t.hideColumn()}}]},getColumnElementPosition:function(e,t,i){var r={};return r.left=i[0].offsetLeft,r.top=i[0].offsetTop,r.parentLeft=i[0].offsetParent.offsetLeft,r.offset=0,t.grid.options.offsetLeft&&(r.offset=t.grid.options.offsetLeft),r.height=d.elementHeight(i,!0),r.width=d.elementWidth(i,!0),r},repositionMenu:function(e,t,i,r,n){var o=r[0].querySelectorAll(".ui-grid-menu"),n=d.closestElm(n,".ui-grid-render-container"),a=n.getBoundingClientRect().left-e.grid.element[0].getBoundingClientRect().left,n=n.querySelectorAll(".ui-grid-viewport")[0].scrollLeft,l=d.elementWidth(o,!0),s=t.lastMenuPaddingRight||e.lastMenuPaddingRight||10,o=(0!==o.length&&0!==o[0].querySelectorAll(".ui-grid-menu-mid").length&&(s=parseInt(d.getStyles(angular.element(o)[0]).paddingRight,10),e.lastMenuPaddingRight=s,t.lastMenuPaddingRight=s),i.left+a-n+i.parentLeft+i.width+s);o<i.offset+l&&(o=Math.max(i.left-n+i.parentLeft-s+l,i.offset+l)),r.css("left",o+"px"),r.css("top",i.top+i.height+"px")}};return r}]).directive("uiGridColumnMenu",["$timeout","gridUtil","uiGridConstants","uiGridColumnMenuService","$document",function(n,a,l,s,d){return{priority:0,scope:!0,require:"^uiGrid",templateUrl:"ui-grid/uiGridColumnMenu",replace:!0,link:function(o,i,e,t){function r(e){o.col&&(o.col.menuShown=e)}s.initialize(o,t),o.defaultMenuItems=s.getDefaultMenuItems(o),o.menuItems=o.defaultMenuItems,s.setColMenuItemWatch(o),o.showMenu=function(e,t,i){r(!1),o.col=e,r(!0);e=s.getColumnElementPosition(o,e,t);o.menuShown?(o.colElement=t,o.colElementPosition=e,o.hideThenShow=!0,o.$broadcast("hide-menu",{originalEvent:i})):(o.menuShown=!0,o.colElement=t,o.colElementPosition=e,o.$broadcast("show-menu",{originalEvent:i}))},o.hideMenu=function(e){o.menuShown=!1,r(!1),e||o.$broadcast("hide-menu")},o.$on("menu-hidden",function(){var e=angular.element(i[0].querySelector(".ui-grid-menu-items"))[0];i[0].removeAttribute("style"),o.hideThenShow?(delete o.hideThenShow,o.$broadcast("show-menu"),o.menuShown=!0):(o.hideMenu(!0),o.col&&o.col.visible&&a.focus.bySelector(d,".ui-grid-header-cell."+o.col.getColClass()+" .ui-grid-column-menu-button",o.col.grid,!1).catch(angular.noop)),e&&(e.onkeydown=null,angular.forEach(e.children,function(e){e.onkeydown=null}))}),o.$on("menu-shown",function(){n(function(){var e,n;function t(e,t,i,r){e.keyCode===l.keymap.TAB&&(t?e.preventDefault():i&&(e.preventDefault(),n[r].focus()))}s.repositionMenu(o,o.col,o.colElementPosition,i,o.colElement),o.menuItems.some(function(e){return e.shown()})&&a.focus.bySelector(d,".ui-grid-menu-items .ui-grid-menu-item:not(.ng-hide)",!0).catch(angular.noop),delete o.colElementPosition,delete o.columnElement,e=angular.element(i[0].querySelector(".ui-grid-menu-items"))[0],n=[],e&&(e.onkeydown=function(e){e.keyCode===l.keymap.ESC&&(e.preventDefault(),o.hideMenu())},e=e.querySelectorAll(".ui-grid-menu-item:not(.ng-hide)"),angular.forEach(e,function(e){null!==e.offsetParent&&this.push(e)},n),n.length)&&(1===n.length?n[0].onkeydown=function(e){t(e,!0)}:(n[0].onkeydown=function(e){t(e,!1,e.shiftKey,n.length-1)},n[n.length-1].onkeydown=function(e){t(e,!1,!e.shiftKey,0)}))})}),o.sortColumn=function(e,t){e.stopPropagation(),o.grid.sortColumn(o.col,t,!0).then(function(){o.grid.refresh(),o.hideMenu()}).catch(angular.noop)},o.unsortColumn=function(){o.col.unsort(),o.grid.refresh(),o.hideMenu()};o.hideColumn=function(){o.col.colDef.visible=!1,o.col.visible=!1,o.grid.queueGridRefresh(),o.hideMenu(),o.grid.api.core.notifyDataChange(l.dataChange.COLUMN),o.grid.api.core.raise.columnVisibilityChanged(o.col),n(function(){function t(){return a.focus.byId("grid-menu",o.grid)}var i,r,e;o.grid.columns.some(function(e,t){if(angular.equals(e,o.col))return i=t,!0}),o.grid.columns.some(function(e,t){return!!e.visible&&(t<i?void(r=e):i<t&&!r?(r=e,!0):!!(i<t&&r)||void 0)}),r?(e=r.getColClass(),a.focus.bySelector(d,".ui-grid-header-cell."+e+" .ui-grid-header-cell-primary-focus",!0).then(angular.noop,function(e){if("canceled"!==e)return t()}).catch(angular.noop)):t()})}},controller:["$scope",function(e){var t=this;e.$watch("menuItems",function(e){t.menuItems=e})}]}}]),function(){"use strict";angular.module("ui.grid").directive("uiGridFilter",["$compile","$templateCache","i18nService","gridUtil",function(n,e,t,r){return{compile:function(){return{pre:function(i,r){i.col.updateFilters=function(e){var t;r.children().remove(),e&&(void 0===(t=i.col.filterHeaderTemplate)&&""!==i.col.providedFilterHeaderTemplate?i.col.filterHeaderTemplatePromise&&i.col.filterHeaderTemplatePromise.then(function(){t=i.col.filterHeaderTemplate,r.append(n(t)(i))}):r.append(n(t)(i)))},i.$on("$destroy",function(){delete i.col.filterable,delete i.col.updateFilters})},post:function(e,i){e.aria=t.getSafeText("headerCell.aria"),e.removeFilter=function(e,t){e.term=null,r.focus.bySelector(i,".ui-grid-filter-input-"+t)}}}}}}])}(),function(){"use strict";angular.module("ui.grid").directive("uiGridFooterCell",["$timeout","gridUtil","uiGridConstants","$compile",function(e,t,a,r){return{priority:0,scope:{col:"=",row:"=",renderIndex:"="},replace:!0,require:"^uiGrid",compile:function(){return{pre:function(e,t){var i=e.col.footerCellTemplate;void 0===i&&""!==e.col.providedFooterCellTemplate?e.col.footerCellTemplatePromise&&e.col.footerCellTemplatePromise.then(function(){i=e.col.footerCellTemplate,t.append(r(i)(e))}):t.append(r(i)(e))},post:function(t,i,e,r){t.grid=r.grid;function n(){var e=i;o&&(e.removeClass(o),o=null),o=angular.isFunction(t.col.footerCellClass)?t.col.footerCellClass(t.grid,t.row,t.col,t.rowRenderIndex,t.colRenderIndex):t.col.footerCellClass,e.addClass(o)}var o,r=t.col.getColClass(!1),r=(i.addClass(r),t.col.footerCellClass&&n(),t.col.updateAggregationValue(),t.grid.registerDataChangeCallback(n,[a.dataChange.COLUMN]));t.grid.api.core.on.rowsRendered(t,t.col.updateAggregationValue),t.grid.api.core.on.rowsRendered(t,n),t.$on("$destroy",r)}}}}}])}(),function(){"use strict";angular.module("ui.grid").directive("uiGridFooter",["$templateCache","$compile","uiGridConstants","gridUtil","$timeout",function(e,a,t,l,i){return{restrict:"EA",replace:!0,require:["^uiGrid","^uiGridRenderContainer"],scope:!0,compile:function(e,t){return{pre:function(t,i,e,r){var n=r[0],o=r[1],r=(t.grid=n.grid,t.colContainer=o.colContainer,o.footer=i,t.grid.options.footerTemplate);l.getTemplate(r).then(function(e){var e=angular.element(e),e=a(e)(t);i.append(e),o&&(e=i[0].getElementsByClassName("ui-grid-footer-viewport")[0])&&(o.footerViewport=e)}).catch(angular.noop)},post:function(e,t,i,r){var n=r[0],r=r[1],n=(n.grid,l.disableAnimations(t),(r.footer=t)[0].getElementsByClassName("ui-grid-footer-viewport")[0]);n&&(r.footerViewport=n)}}}}}])}(),function(){"use strict";angular.module("ui.grid").directive("uiGridGridFooter",["$templateCache","$compile","uiGridConstants","gridUtil",function(e,n,t,o){return{restrict:"EA",replace:!0,require:"^uiGrid",scope:!0,compile:function(){return{pre:function(t,i,e,r){t.grid=r.grid;r=t.grid.options.gridFooterTemplate;o.getTemplate(r).then(function(e){e=angular.element(e),e=n(e)(t);i.append(e)}).catch(angular.noop)}}}}}])}(),function(){"use strict";angular.module("ui.grid").directive("uiGridHeaderCell",["$compile","$timeout","$window","$document","gridUtil","uiGridConstants","ScrollEvent","i18nService","$rootScope",function(r,u,e,g,t,p,i,f,m){return{priority:0,scope:{col:"=",row:"=",renderIndex:"="},require:["^uiGrid","^uiGridRenderContainer"],replace:!0,compile:function(){return{pre:function(e,t){var i=e.col.headerCellTemplate;void 0===i&&""!==e.col.providedHeaderCellTemplate?e.col.headerCellTemplatePromise&&e.col.headerCellTemplatePromise.then(function(){i=e.col.headerCellTemplate,t.append(r(i)(e))}):t.append(r(i)(e))},post:function(i,t,e,r){function n(e){e&&(void 0!==i.col.updateFilters&&i.col.updateFilters(i.col.filterable),i.col.filterable?(i.col.filters.forEach(function(e,t){c.push(i.$watch("col.filters["+t+"].term",function(e,t){e!==t&&(s.grid.api.core.raise.filterChanged(i.col),s.grid.api.core.notifyDataChange(p.dataChange.COLUMN),s.grid.queueGridRefresh())}))}),i.$on("$destroy",function(){c.forEach(function(e){e()})})):c.forEach(function(e){e()}))}function o(){var e=t,e=(a&&(e.removeClass(a),a=null),a=angular.isFunction(i.col.headerCellClass)?i.col.headerCellClass(i.grid,i.row,i.col,i.rowRenderIndex,i.colRenderIndex):i.col.headerCellClass,e.addClass(a),i.$applyAsync(function(){var e=i.grid.renderContainers.right&&i.grid.renderContainers.right.visibleColumnCache.length?i.grid.renderContainers.right:i.grid.renderContainers.body;i.isLastCol=s.grid.options&&s.grid.options.enableGridMenu&&i.col===e.visibleColumnCache[e.visibleColumnCache.length-1]}),i.sortable=Boolean(i.col.enableSorting),i.col.filterable);i.col.filterable=Boolean(s.grid.options.enableFiltering&&i.col.enableFiltering),n(e!==i.col.filterable),i.colMenu=i.col.grid.options&&!1!==i.col.grid.options.enableColumnMenus&&i.col.colDef&&!1!==i.col.colDef.enableColumnMenu,i.offAllEvents(),(i.sortable||i.colMenu)&&(i.onDownEvents(),i.$on("$destroy",function(){i.offAllEvents()}))}var a,l,s=r[0],r=r[1],r=(i.i18n={headerCell:f.getSafeText("headerCell"),sort:f.getSafeText("sort")},i.isSortPriorityVisible=function(){return i.col&&i.col.sort&&angular.isNumber(i.col.sort.priority)&&i.grid.columns.some(function(e,t){return angular.isNumber(e.sort.priority)&&e!==i.col})},i.getSortDirectionAriaLabel=function(){var e=i.col,t=e.sort&&e.sort.direction===p.ASC?i.i18n.sort.ascending:e.sort&&e.sort.direction===p.DESC?i.i18n.sort.descending:i.i18n.sort.none;return t=i.isSortPriorityVisible()?t+". "+i.i18n.headerCell.priority+" "+(e.sort.priority+1):t},i.grid=s.grid,i.renderContainer=s.grid.renderContainers[r.containerId],i.col.getColClass(!1)),d=(t.addClass(r),i.menuShown=!1,i.col.menuShown=!1,i.asc=p.ASC,i.desc=p.DESC,angular.element(t[0].querySelectorAll(".ui-grid-cell-contents"))),c=[],r=(i.downFn=function(e){e.stopPropagation(),(e=void 0!==e.originalEvent&&void 0!==e.originalEvent?e.originalEvent:e).button&&0!==e.button||(l=e.pageX,i.mousedownStartTime=(new Date).getTime(),i.mousedownTimeout=u(function(){},500),i.mousedownTimeout.then(function(){i.colMenu&&s.columnMenuScope.showMenu(i.col,t,e)}).catch(angular.noop),s.fireEvent(p.events.COLUMN_HEADER_CLICK,{event:e,columnName:i.col.colDef.name}),i.offAllEvents(),"touchstart"===e.type?(g.on("touchend",i.upFn),g.on("touchmove",i.moveFn)):"mousedown"===e.type&&(g.on("mouseup",i.upFn),g.on("mousemove",i.moveFn)))},i.upFn=function(e){e.stopPropagation(),u.cancel(i.mousedownTimeout),i.offAllEvents(),i.onDownEvents(e.type),500<(new Date).getTime()-i.mousedownStartTime||i.sortable&&i.handleClick(e)},i.handleKeyDown=function(e){32!==e.keyCode&&13!==e.keyCode||(e.preventDefault(),i.handleClick(e))},i.moveFn=function(e){0!=e.pageX-l&&(u.cancel(i.mousedownTimeout),i.offAllEvents(),i.onDownEvents(e.type))},i.clickFn=function(e){e.stopPropagation(),d.off("click",i.clickFn)},i.offAllEvents=function(){d.off("touchstart",i.downFn),d.off("mousedown",i.downFn),g.off("touchend",i.upFn),g.off("mouseup",i.upFn),g.off("touchmove",i.moveFn),g.off("mousemove",i.moveFn),d.off("click",i.clickFn)},i.onDownEvents=function(e){switch(e){case"touchmove":case"touchend":d.on("click",i.clickFn),d.on("touchstart",i.downFn),u(function(){d.on("mousedown",i.downFn)},500);break;case"mousemove":case"mouseup":d.on("click",i.clickFn),d.on("mousedown",i.downFn),u(function(){d.on("touchstart",i.downFn)},500);break;default:d.on("click",i.clickFn),d.on("touchstart",i.downFn),d.on("mousedown",i.downFn)}},o(),"columnMenu"===i.col.filterContainer&&i.col.filterable&&m.$on("menu-shown",function(){i.$applyAsync(function(){n(i.col.filterable)})}),i.grid.registerDataChangeCallback(o,[p.dataChange.COLUMN]));i.$on("$destroy",r),i.handleClick=function(e){s.grid.sortColumn(i.col,e.shiftKey).then(function(){s.columnMenuScope&&s.columnMenuScope.hideMenu(),s.grid.refresh()}).catch(angular.noop)},i.headerCellArrowKeyDown=function(e){e.keyCode!==p.keymap.SPACE&&e.keyCode!==p.keymap.ENTER||(e.preventDefault(),i.toggleMenu(e))},i.toggleMenu=function(e){e.stopPropagation(),s.columnMenuScope.menuShown&&s.columnMenuScope.col===i.col?s.columnMenuScope.hideMenu():s.columnMenuScope.showMenu(i.col,t)}}}}}}])}(),function(){"use strict";angular.module("ui.grid").directive("uiGridHeader",["$templateCache","$compile","uiGridConstants","gridUtil","$timeout","ScrollEvent",function(e,s,t,d,i,c){return{restrict:"EA",replace:!0,require:["^uiGrid","^uiGridRenderContainer"],scope:!0,compile:function(){return{pre:function(i,r,e,t){var n=t[0],o=t[1];function a(){var e=(o.header=o.colContainer.header=r)[0].getElementsByClassName("ui-grid-header-canvas");0<e.length?o.headerCanvas=o.colContainer.headerCanvas=e[0]:o.headerCanvas=null}function l(){var e,t,i;n.grid.isScrollingHorizontally||(e=d.normalizeScrollLeft(o.headerViewport,n.grid),t=o.colContainer.scrollHorizontal(e),(i=new c(n.grid,null,o.colContainer,c.Sources.ViewPortScroll)).newScrollLeft=e,-1<t&&(i.x={percentage:t}),n.grid.scrollContainers(null,i))}i.grid=n.grid,i.colContainer=o.colContainer,a(),t=i.grid.options.showHeader?i.grid.options.headerTemplate||"ui-grid/ui-grid-header":"ui-grid/ui-grid-no-header",d.getTemplate(t).then(function(e){var t,e=angular.element(e),e=s(e)(i);r.replaceWith(e),r=e,a(),o&&(t=r[0].getElementsByClassName("ui-grid-header-viewport")[0])&&(o.headerViewport=t,angular.element(t).on("scroll",l),i.$on("$destroy",function(){angular.element(t).off("scroll",l)})),i.grid.queueRefresh()}).catch(angular.noop)},post:function(e,t,i,r){var n=r[0],o=r[1];n.grid;d.disableAnimations(t);r=(o.header=t)[0].getElementsByClassName("ui-grid-header-viewport")[0];r&&(o.headerViewport=r),n&&n.grid.registerStyleComputation({priority:15,func:function(){var e=o.colContainer.visibleColumnCache,t="",i=0;return e.forEach(function(e){t+=e.getColClassDefinition(),i+=e.drawnWidth}),o.colContainer.canvasWidth=i,t}})}}}}}])}(),angular.module("ui.grid").service("uiGridGridMenuService",["gridUtil","i18nService","uiGridConstants",function(n,o,t){var a={initialize:function(e,t){(t.gridMenuScope=e).grid=t,e.registeredMenuItems=[],e.$on("$destroy",function(){e.grid&&e.grid.gridMenuScope&&(e.grid.gridMenuScope=null),e.grid&&(e.grid=null),e.registeredMenuItems&&(e.registeredMenuItems=null)}),e.registeredMenuItems=[],t.api.registerMethod("core","addToGridMenu",a.addToGridMenu),t.api.registerMethod("core","removeFromGridMenu",a.removeFromGridMenu)},addToGridMenu:function(e,t){angular.isArray(t)?e.gridMenuScope?(e.gridMenuScope.registeredMenuItems=e.gridMenuScope.registeredMenuItems||[],e.gridMenuScope.registeredMenuItems=e.gridMenuScope.registeredMenuItems.concat(t)):n.logError("Asked to addToGridMenu, but gridMenuScope not present.  Timing issue?  Please log issue with ui-grid"):n.logError("addToGridMenu: menuItems must be an array, and is not, not adding any items")},removeFromGridMenu:function(e,i){var r=-1;e&&e.gridMenuScope&&e.gridMenuScope.registeredMenuItems.forEach(function(e,t){e.id===i&&(-1<r?n.logError("removeFromGridMenu: found multiple items with the same id, removing only the last"):r=t)}),-1<r&&e.gridMenuScope.registeredMenuItems.splice(r,1)},getMenuItems:function(t){var e=[],i=(t.grid.options.gridMenuCustomItems&&(angular.isArray(t.grid.options.gridMenuCustomItems)?e=e.concat(t.grid.options.gridMenuCustomItems):n.logError("gridOptions.gridMenuCustomItems must be an array, and is not")),[{title:o.getSafeText("gridMenu.clearAllFilters"),action:function(e){t.grid.clearAllFilters()},shown:function(){return t.grid.options.enableFiltering},order:100}]);return e=(e=e.concat(i)).concat(t.registeredMenuItems),(e=!1!==t.grid.options.gridMenuShowHideColumns?e.concat(a.showHideColumns(t)):e).sort(function(e,t){return e.order-t.order}),e},showHideColumns:function(i){var r=[];return i.grid.options.columnDefs&&0!==i.grid.options.columnDefs.length&&0!==i.grid.columns.length&&(i.grid.options.gridMenuTitleFilter=i.grid.options.gridMenuTitleFilter||function(e){return e},i.grid.options.columnDefs.forEach(function(e,t){(!1!==i.grid.options.enableHiding&&!1!==e.enableHiding||e.enableHiding)&&(t={icon:n(e),action:function(e){e.stopPropagation(),a.toggleColumnVisibility(this.context.gridCol),e.target&&e.target.firstChild&&("I"===angular.element(e.target)[0].nodeName?e.target.className=n(this.context.gridCol.colDef):e.target.firstChild.className=n(this.context.gridCol.colDef))},shown:function(){return!1!==this.context.gridCol.colDef.enableHiding},context:{gridCol:i.grid.getColumn(e.name||e.field)},leaveOpen:!0,order:301+t},a.setMenuItemTitle(t,e,i.grid),r.push(t))}),r.length)&&r.unshift({title:o.getSafeText("gridMenu.columns"),order:300,templateUrl:"ui-grid/ui-grid-menu-header-item"}),r;function n(e){return!0===(e=e).visible||void 0===e.visible?"ui-grid-icon-ok":"ui-grid-icon-cancel"}},setMenuItemTitle:function(t,e,i){i=i.options.gridMenuTitleFilter(e.displayName||n.readableColumnName(e.name)||e.field);"string"==typeof i?t.title=i:i.then?(t.title="",i.then(function(e){t.title=e},function(e){t.title=e}).catch(angular.noop)):(n.logError("Expected gridMenuTitleFilter to return a string or a promise, it has returned neither, bad config"),t.title="badconfig")},toggleColumnVisibility:function(e){e.colDef.visible=!(!0===e.colDef.visible||void 0===e.colDef.visible),e.grid.refresh(),e.grid.api.core.notifyDataChange(t.dataChange.COLUMN),e.grid.api.core.raise.columnVisibilityChanged(e)}};return a}]).directive("uiGridMenuButton",["gridUtil","uiGridConstants","uiGridGridMenuService","i18nService",function(n,o,a,l){return{priority:0,scope:!0,require:["^uiGrid"],templateUrl:"ui-grid/ui-grid-menu-button",replace:!0,link:function(t,e,i,r){r=r[0];t.i18n={aria:l.getSafeText("gridMenu.aria")},a.initialize(t,r.grid),t.shown=!1,t.toggleOnKeydown=function(e){(e.keyCode===o.keymap.ENTER||e.keyCode===o.keymap.SPACE||e.keyCode===o.keymap.ESC&&t.shown)&&t.toggleMenu()},t.toggleMenu=function(){t.shown?(t.$broadcast("hide-menu"),t.shown=!1):(t.menuItems=a.getMenuItems(t),t.$broadcast("show-menu"),t.shown=!0)},t.$on("menu-hidden",function(){t.shown=!1,n.focus.bySelector(e,".ui-grid-icon-container")})}}}]),angular.module("ui.grid").directive("uiGridMenu",["$compile","$timeout","$window","$document","gridUtil","uiGridConstants","i18nService",function(l,s,d,e,c,u,g){return{priority:0,scope:{menuItems:"=",autoHide:"=?",col:"=?"},require:"?^uiGrid",templateUrl:"ui-grid/uiGridMenu",replace:!1,link:function(n,o,e,i){function a(e){e=e-i.grid.headerHeight-20,n.dynamicStyles=[".grid"+i.grid.id+" .ui-grid-menu-mid {","max-height: "+e+"px;","}"].join(" ")}n.dynamicStyles="",i&&i.grid&&i.grid.options&&i.grid.options.gridMenuTemplate&&(t=i.grid.options.gridMenuTemplate,c.getTemplate(t).then(function(e){e=angular.element(e),e=l(e)(n);o.replaceWith(e)}).catch(angular.noop));i&&(a(i.grid.gridHeight),i.grid.api.core.on.gridDimensionChanged(n,function(e,t,i,r){a(i)})),n.i18n={close:g.getSafeText("columnMenu.close")},n.showMenu=function(e,t){n.shown?n.shownMid||(n.shownMid=!0,n.$emit("menu-shown")):(n.shown=!0,s(function(){n.shownMid=!0,n.$emit("menu-shown")}));var i="click";t&&t.originalEvent&&t.originalEvent.type&&"touchstart"===t.originalEvent.type&&(i=t.originalEvent.type),angular.element(document).off("click touchstart",r),s(function(){angular.element(document).on(i,r)})},n.hideMenu=function(e){n.shown&&(n.shownMid=!1,s(function(){n.shownMid||(n.shown=!1,n.$emit("menu-hidden"))},40)),angular.element(document).off("click touchstart",r)},n.$on("hide-menu",function(e,t){n.hideMenu(e,t)}),n.$on("show-menu",function(e,t){n.showMenu(e,t)});var t,r=function(e){if(n.shown){var t=i&&i.grid&&i.grid.options?i.grid.options.disableGridMenuHideOnScroll:null;if("scroll"!==e.type||!t){if(n.col&&"columnMenu"===n.col.filterContainer){t=document.querySelector(".ui-grid-column-menu").querySelector("[ui-grid-filter]");if(t&&t.contains(e.target))return!1}n.$apply(function(){n.hideMenu()})}}};n.checkKeyDown=function(t){function e(e){e.focus(),t.preventDefault()}var i,r;t.keyCode===u.keymap.ESC?n.hideMenu():t.keyCode===u.keymap.TAB&&0<(r=o[0].querySelectorAll("button:not(.ng-hide)")).length&&(i=r[0],r=r[r.length-1],t.target.parentElement.id!==r.parentElement.id||t.shiftKey?t.target.parentElement.id===i.parentElement.id&&t.shiftKey&&e(r):e(i))},void 0!==n.autoHide&&void 0!==n.autoHide||(n.autoHide=!0),n.autoHide&&angular.element(d).on("resize",r),n.$on("$destroy",function(){angular.element(d).off("resize",r),angular.element(document).off("click touchstart",r)}),i&&n.$on("$destroy",i.grid.api.core.on.scrollBegin(n,r)),n.$on("$destroy",n.$on(u.events.ITEM_DRAGGING,r))}}}]).directive("uiGridMenuItem",["gridUtil","$compile","i18nService",function(o,r,a){return{priority:0,scope:{name:"=",active:"=",action:"=",icon:"=",shown:"=",context:"=",templateUrl:"=",leaveOpen:"=",screenReaderOnly:"="},require:["?^uiGrid"],templateUrl:"ui-grid/uiGridMenuItem",replace:!1,compile:function(){return{pre:function(t,i){t.templateUrl&&o.getTemplate(t.templateUrl).then(function(e){e=angular.element(e),e=r(e)(t);i.replaceWith(e)}).catch(angular.noop)},post:function(r,e,t,i){var n=i[0];void 0!==r.shown&&null!==r.shown||(r.shown=function(){return!0}),r.itemShown=function(){var e={};return r.context&&(e.context=r.context),void 0!==n&&n&&(e.grid=n.grid),r.shown.call(e)},r.itemAction=function(e,t){var i;e.stopPropagation(),"function"==typeof r.action&&(i={},r.context&&(i.context=r.context),void 0!==n&&n&&(i.grid=n.grid),r.action.call(i,e,t),r.leaveOpen?(i=e.target.parentElement,"I"===angular.element(e.target)[0].nodeName&&(i=i.parentElement),o.focus.bySelector(i,"button[type=button]",!0)):r.$emit("hide-menu"))},r.label=function(){var e=r.name;return e="function"==typeof r.name?r.name.call():e},r.i18n=a.get()}}}}}]),function(){"use strict";var t=angular.module("ui.grid");angular.forEach([{tag:"Src",method:"attr"},{tag:"Text",method:"text"},{tag:"Href",method:"attr"},{tag:"Class",method:"addClass"},{tag:"Html",method:"html"},{tag:"Alt",method:"attr"},{tag:"Style",method:"css"},{tag:"Value",method:"attr"},{tag:"Id",method:"attr"},{tag:"Id",directiveName:"IdGrid",method:"attr",appendGridId:!0},{tag:"Title",method:"attr"},{tag:"Label",method:"attr",aria:!0},{tag:"Labelledby",method:"attr",aria:!0},{tag:"Labelledby",directiveName:"LabelledbyGrid",appendGridId:!0,method:"attr",aria:!0},{tag:"Describedby",method:"attr",aria:!0},{tag:"Describedby",directiveName:"DescribedbyGrid",appendGridId:!0,method:"attr",aria:!0}],function(d){var e="uiGridOneBind",c=(d.aria?e+"Aria":e)+(d.directiveName||d.tag);t.directive(c,["gridUtil",function(s){return{restrict:"A",require:["?uiGrid","?^uiGrid"],link:function(n,o,e,a){var l=n.$watch(e[c],function(e){if(e){var t;switch(d.appendGridId&&(t=null,angular.forEach(e.split(" "),function(e){t=(t?t+" ":"")+function(e){var t;if(n.grid)t=n.grid;else if(n.col&&n.col.grid)t=n.col.grid;else if(!a.some(function(e){if(e&&e.grid)return t=e.grid,!0}))throw s.logError("["+c+"] A valid grid could not be found to bind id. Are you using this directive within the correct scope? Trying to generate id: [gridID]-"+e),new Error("No valid grid could be found");return e=t&&!new RegExp(t.id.toString()).test(e)?t.id.toString()+"-"+e:e}(e)}),e=t),d.method){case"attr":d.aria?o[d.method]("aria-"+d.tag.toLowerCase(),e):o[d.method](d.tag.toLowerCase(),e);break;case"addClass":if(angular.isObject(e)&&!angular.isArray(e)){var i=[],r=!1;if(angular.forEach(e,function(e,t){null!=e&&(r=!0,e)&&i.push(t)}),!r)return;e=i}if(!e)return;o.addClass(angular.isArray(e)?e.join(" "):e);break;default:o[d.method](e)}l()}},!0)}}}])})}(),function(){"use strict";var e=angular.module("ui.grid");e.directive("uiGridRenderContainer",["$timeout","$document","uiGridConstants","gridUtil","ScrollEvent",function(e,t,i,p,f){return{replace:!0,transclude:!0,templateUrl:"ui-grid/uiGridRenderContainer",require:["^uiGrid","uiGridRenderContainer"],scope:{containerId:"=",rowContainerName:"=",colContainerName:"=",bindScrollHorizontal:"=",bindScrollVertical:"=",enableVerticalScrollbar:"=",enableHorizontalScrollbar:"="},controller:"uiGridRenderContainer as RenderContainer",compile:function(){return{pre:function(e,t,i,r){var n,o=r[0],r=r[1],o=e.grid=o.grid;if(!e.rowContainerName)throw new Error("No row render container name specified");if(!e.colContainerName)throw new Error("No column render container name specified");if(!o.renderContainers[e.rowContainerName])throw new Error('Row render container "'+e.rowContainerName+'" is not registered.');if(!o.renderContainers[e.colContainerName])throw new Error('Column render container "'+e.colContainerName+'" is not registered.');n=e.rowContainer=o.renderContainers[e.rowContainerName],o=e.colContainer=o.renderContainers[e.colContainerName],r.containerId=e.containerId,r.rowContainer=n,r.colContainer=o},post:function(l,t,e,i){var s=i[0],n=i[1],d=s.grid,c=n.rowContainer,u=n.colContainer,o=null,a=null,g=d.renderContainers[l.containerId];t.addClass("ui-grid-render-container-"+l.containerId),p.on.mousewheel(t,function(e){var t,i,r=new f(d,c,u,f.Sources.RenderContainerMouseWheel);0!==e.deltaY&&(i=-1*e.deltaY*e.deltaFactor,o=n.viewport[0].scrollTop,r.verticalScrollLength=c.getVerticalScrollLength(),1<=(t=(o+i)/r.verticalScrollLength)&&o<r.verticalScrollLength&&(n.viewport[0].scrollTop=r.verticalScrollLength),t<0?t=0:1<t&&(t=1),r.y={percentage:t,pixels:i}),0!==e.deltaX&&(t=e.deltaX*e.deltaFactor,a=p.normalizeScrollLeft(n.viewport,d),r.horizontalScrollLength=u.getCanvasWidth()-u.getViewportWidth(),(i=(a+t)/r.horizontalScrollLength)<0?i=0:1<i&&(i=1),r.x={percentage:i,pixels:t}),0!==e.deltaY&&(r.atTop(o)||r.atBottom(o))||0!==e.deltaX&&(r.atLeft(a)||r.atRight(a))||(e.preventDefault(),e.stopPropagation(),r.fireThrottledScrollingEvent("",r))}),t.bind("$destroy",function(){t.unbind("keydown"),["touchstart","touchmove","touchend","keydown","wheel","mousewheel","DomMouseScroll","MozMousePixelScroll"].forEach(function(e){t.unbind(e)})}),s.grid.registerStyleComputation({priority:6,func:function(){var e,t,i="",r=u.canvasWidth,n=u.getViewportWidth(),o=c.getCanvasHeight(),a=c.getViewportHeight();return u.needsHScrollbarPlaceholder()&&(a-=d.scrollbarHeight),e=t=u.getHeaderViewportWidth(),i=(i+="\n .grid"+s.grid.id+" .ui-grid-render-container-"+l.containerId+" .ui-grid-canvas { width: "+r+"px; height: "+o+"px; }")+("\n .grid"+s.grid.id+" .ui-grid-render-container-"+l.containerId+" .ui-grid-header-canvas { width: "+(r+d.scrollbarWidth)+"px; }"),g.explicitHeaderCanvasHeight?((o=document.querySelector(".grid"+s.grid.id+" .ui-grid-render-container-body .ui-grid-header-canvas"))&&(g.explicitHeaderCanvasHeight=o.offsetHeight),i+="\n .grid"+s.grid.id+" .ui-grid-render-container-"+l.containerId+" .ui-grid-header-canvas { height: "+g.explicitHeaderCanvasHeight+"px; }"):i+="\n .grid"+s.grid.id+" .ui-grid-render-container-"+l.containerId+" .ui-grid-header-canvas { height: inherit; }",i=(i=(i=(i+="\n .grid"+s.grid.id+" .ui-grid-render-container-"+l.containerId+" .ui-grid-viewport { width: "+n+"px; height: "+a+"px; }")+("\n .grid"+s.grid.id+" .ui-grid-render-container-"+l.containerId+" .ui-grid-header-viewport { width: "+e+"px; }"))+("\n .grid"+s.grid.id+" .ui-grid-render-container-"+l.containerId+" .ui-grid-footer-canvas { width: "+(r+d.scrollbarWidth)+"px; }"))+("\n .grid"+s.grid.id+" .ui-grid-render-container-"+l.containerId+" .ui-grid-footer-viewport { width: "+t+"px; }")}})}}}}}]),e.controller("uiGridRenderContainer",["$scope","gridUtil",function(e,t){}])}(),function(){"use strict";angular.module("ui.grid").directive("uiGridRow",function(){return{replace:!0,require:["^uiGrid","^uiGridRenderContainer"],scope:{row:"=uiGridRow",rowRenderIndex:"="},compile:function(){return{pre:function(t,r,e,i){var n,o,a=i[0],i=i[1];function l(){t.row.getRowTemplateFn.then(function(e){var i=t.$new();e(i,function(e,t){n&&(n.remove(),o.$destroy()),r.empty().append(e),n=e,o=i})}).catch(angular.noop)}t.grid=a.grid,t.colContainer=i.colContainer,l(),t.$watch("row.getRowTemplateFn",function(e,t){e!==t&&l()})},post:function(e,t){e.row.element=t}}}}})}(),angular.module("ui.grid").directive("uiGridStyle",["gridUtil","$interpolate",function(e,r){return{link:function(e,i){var t=r(i.text(),!0);t&&e.$watch(t,function(e){for(var t=0;t<i.length;t++)i[t].textContent=e})}}}]),function(){"use strict";angular.module("ui.grid").directive("uiGridViewport",["gridUtil","ScrollEvent",function(c,u){return{replace:!0,scope:{},controllerAs:"Viewport",templateUrl:"ui-grid/uiGridViewport",require:["^uiGrid","^uiGridRenderContainer"],link:function(o,a,e,t){var i=t[0],r=t[1],l=(o.containerCtrl=r).rowContainer,s=r.colContainer,d=i.grid;o.grid=i.grid,o.rowContainer=r.rowContainer,o.colContainer=r.colContainer,r.viewport=a,d&&d.options&&d.options.customScroller?d.options.customScroller(a,n):a.on("scroll",n);function n(){var e=a[0].scrollTop,t=c.normalizeScrollLeft(a,d),i=l.scrollVertical(e),r=s.scrollHorizontal(t),n=new u(d,l,s,u.Sources.ViewPortScroll);n.newScrollLeft=t,n.newScrollTop=e,-1<r&&(n.x={percentage:r}),-1<i&&(n.y={percentage:i}),d.scrollContainers(o.$parent.containerId,n)}o.$parent.bindScrollVertical&&d.addVerticalScrollSync(o.$parent.containerId,function(e){r.prevScrollArgs=e,a[0].scrollTop=e.getNewScrollTop(l,r.viewport)}),o.$parent.bindScrollHorizontal&&(d.addHorizontalScrollSync(o.$parent.containerId,function(e){e=(r.prevScrollArgs=e).getNewScrollLeft(s,r.viewport);a[0].scrollLeft=c.denormalizeScrollLeft(r.viewport,e,d)}),d.addHorizontalScrollSync(o.$parent.containerId+"header",function(e){e=e.getNewScrollLeft(s,r.viewport);r.headerViewport&&(r.headerViewport.scrollLeft=c.denormalizeScrollLeft(r.viewport,e,d))}),d.addHorizontalScrollSync(o.$parent.containerId+"footer",function(e){e=e.getNewScrollLeft(s,r.viewport);r.footerViewport&&(r.footerViewport.scrollLeft=c.denormalizeScrollLeft(r.viewport,e,d))})),o.$on("$destroy",function(){a.off()})},controller:["$scope",function(r){this.rowStyle=function(){var e=r.rowContainer,t=r.colContainer,i={};return 0!==e.currentTopRow&&(e="translateY("+e.currentTopRow*e.grid.options.rowHeight+"px)",i.transform=e,i["-webkit-transform"]=e,i["-ms-transform"]=e),0!==t.currentFirstColumn&&(t.grid.isRTL()?i["margin-right"]=t.columnOffset+"px":i["margin-left"]=t.columnOffset+"px"),i}}]}}])}(),angular.module("ui.grid").directive("uiGridVisible",function(){return function(e,t,i){e.$watch(i.uiGridVisible,function(e){t[e?"removeClass":"addClass"]("ui-grid-invisible")})}}),function(){"use strict";function e(g,p,f){return{templateUrl:"ui-grid/ui-grid",scope:{uiGrid:"="},replace:!0,transclude:!0,controller:"uiGridController",compile:function(){return{post:function(o,a,e,l){var t,i,s=l.grid,r=(l.scrollbars=[],s.element=a,100),n=20,d=0;function c(){var e,t,i,r,n;s.gridWidth=o.gridWidth=p.elementWidth(a),s.canvasWidth=l.grid.gridWidth,s.gridHeight=o.gridHeight=p.elementHeight(a),s.gridHeight-s.scrollbarHeight<=s.options.rowHeight&&s.options.enableMinHeightCheck&&(e=s.options.minRowsToShow*s.options.rowHeight,t=s.options.showHeader?s.options.headerRowHeight:0,i=s.calcFooterHeight(),r=0,s.options.enableHorizontalScrollbar===f.scrollbars.ALWAYS&&(r=p.getScrollbarWidth()),n=0,angular.forEach(s.options.columnDefs,function(e){e.hasOwnProperty("filter")?n<1&&(n=1):e.hasOwnProperty("filters")&&n<e.filters.length&&(n=e.filters.length)}),!s.options.enableFiltering||n||s.options.columnDefs.length&&s.options.columnDefs.every(function(e){return!1===e.enableFiltering})||(n=1),e=t+e+i+r+n*t,a.css("height",e+"px"),s.gridHeight=o.gridHeight=p.elementHeight(a)),s.refreshCanvas(!0)}function u(){p.isVisible(a)&&(s.gridWidth=o.gridWidth=p.elementWidth(a),s.gridHeight=o.gridHeight=p.elementHeight(a),s.refreshCanvas(!0))}angular.element(g).on("resize",u),a.on("$destroy",function(){angular.element(g).off("resize",u),t(),i()}),t=o.$watch(function(){return s.hasLeftContainer()},function(e,t){e!==t&&s.refreshCanvas(!0)}),i=o.$watch(function(){return s.hasRightContainer()},function(e,t){e!==t&&s.refreshCanvas(!0)}),c(),s.renderingComplete(),function e(){a[0].offsetWidth<=0&&d<n?(setTimeout(e,r),d++):o.$applyAsync(c)}()}}}}}angular.module("ui.grid").controller("uiGridController",["$scope","$element","$attrs","gridUtil","$q","uiGridConstants","gridClassFactory","$parse","$compile",function(r,e,n,t,o,a,i,l,s){var d,c=this,u=[];function g(e){return e?e.length:0}function p(e,t){e&&e!==t&&(c.grid.options.columnDefs=r.uiGrid.columnDefs,c.grid.callDataChangeCallbacks(a.dataChange.COLUMN,{orderByColumnDefs:!0,preCompileCellTemplates:!0}))}function f(e){var t,i=[];c.grid.options.fastWatch&&(e=angular.isString(r.uiGrid.data)?c.grid.appScope.$eval(r.uiGrid.data):r.uiGrid.data),(d=e)&&(!(t=c.grid.columns.length>(c.grid.rowHeaderColumns?c.grid.rowHeaderColumns.length:0))&&!n.uiGridColumns&&0===c.grid.options.columnDefs.length&&0<e.length&&c.grid.buildColumnDefsFromData(e),!t&&(0<c.grid.options.columnDefs.length||0<e.length)&&i.push(c.grid.buildColumns().then(function(){c.grid.preCompileCellTemplates()}).catch(angular.noop)),o.all(i).then(function(){c.grid.modifyRows(d).then(function(){c.grid.redrawInPlace(!0),r.$evalAsync(function(){c.grid.refreshCanvas(!0),c.grid.callDataChangeCallbacks(a.dataChange.ROW)})}).catch(angular.noop)}).catch(angular.noop))}c.grid=i.createGrid(r.uiGrid),c.grid.appScope=c.grid.appScope||r.$parent,e.addClass("grid"+c.grid.id),c.grid.rtl="rtl"===t.getStyles(e[0]).direction,r.grid=c.grid,n.uiGridColumns&&u.push(n.$observe("uiGridColumns",function(e){c.grid.options.columnDefs=angular.isString(e)?angular.fromJson(e):e,c.grid.buildColumns().then(function(){c.grid.preCompileCellTemplates(),c.grid.refreshCanvas(!0)}).catch(angular.noop)})),c.grid.options.fastWatch?(c.uiGrid=r.uiGrid,angular.isString(r.uiGrid.data)?(u.push(r.$parent.$watch(r.uiGrid.data,f)),u.push(r.$parent.$watch(function(){if(c.grid.appScope[r.uiGrid.data])return c.grid.appScope[r.uiGrid.data].length},f))):(u.push(r.$parent.$watch(function(){return r.uiGrid.data},f)),u.push(r.$parent.$watch(function(){return g(r.uiGrid.data)},function(){f(r.uiGrid.data)}))),u.push(r.$parent.$watch(function(){return r.uiGrid.columnDefs},p)),u.push(r.$parent.$watch(function(){return g(r.uiGrid.columnDefs)},function(){p(r.uiGrid.columnDefs)}))):(angular.isString(r.uiGrid.data)?u.push(r.$parent.$watchCollection(r.uiGrid.data,f)):u.push(r.$parent.$watchCollection(function(){return r.uiGrid.data},f)),u.push(r.$parent.$watchCollection(function(){return r.uiGrid.columnDefs},p)));var m=r.$watch(function(){return c.grid.styleComputations},function(){c.grid.refreshCanvas(!0)});r.$on("$destroy",function(){u.forEach(function(e){e()}),m()}),c.fireEvent=function(e,t){t=t||{},angular.isUndefined(t.grid)&&(t.grid=c.grid),r.$broadcast(e,t)},c.innerCompile=function(e){s(e)(r)}}]),angular.module("ui.grid").directive("uiGrid",e),e.$inject=["$window","gridUtil","uiGridConstants"]}(),function(){"use strict";angular.module("ui.grid").directive("uiGridPinnedContainer",["gridUtil",function(e){return{restrict:"EA",replace:!0,template:'<div class="ui-grid-pinned-container"><div ui-grid-render-container container-id="side" row-container-name="\'body\'" col-container-name="side" bind-scroll-vertical="true" class="{{ side }} ui-grid-render-container-{{ side }}"></div></div>',scope:{side:"=uiGridPinnedContainer"},require:"^uiGrid",compile:function(){return{post:function(n,t,e,i){var o=i.grid,r=0;function a(){if("left"===n.side||"right"===n.side){for(var e=o.renderContainers[n.side].visibleColumnCache,t=0,i=0;i<e.length;i++){var r=e[i];t+=r.drawnWidth||r.width||0}return t}}t.addClass("ui-grid-pinned-container-"+n.side),"left"!==n.side&&"right"!==n.side||(o.renderContainers[n.side].getViewportWidth=function(){var t=0,e=(this.visibleColumnCache.forEach(function(e){t+=e.drawnWidth}),this.getViewportAdjustment());return t+=e.width}),o.renderContainers.body.registerViewportAdjuster(function(e){return r=a(),e.width-=r,e.side=n.side,e}),o.registerStyleComputation({priority:15,func:function(){var e="";return"left"!==n.side&&"right"!==n.side||(r=a(),t.attr("style",null),e+=".grid"+o.id+" .ui-grid-pinned-container-"+n.side+", .grid"+o.id+" .ui-grid-pinned-container-"+n.side+" .ui-grid-render-container-"+n.side+" .ui-grid-viewport { width: "+r+"px; } "),e}})}}}}}])}(),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("en",{headerCell:{aria:{defaultFilterLabel:"Filter for column",removeFilter:"Remove Filter",columnMenuButtonLabel:"Column Menu",column:"Column"},priority:"Priority:",filterLabel:"Filter for column: "},aggregate:{label:"items"},groupPanel:{description:"Drag a column header here and drop it to group by that column."},search:{aria:{selected:"Row selected",notSelected:"Row not selected"},placeholder:"Search...",showingItems:"Showing Items:",selectedItems:"Selected Items:",totalItems:"Total Items:",size:"Page Size:",first:"First Page",next:"Next Page",previous:"Previous Page",last:"Last Page"},selection:{aria:{row:"Row"},selectAll:"Select All",displayName:"Row Selection Checkbox"},menu:{text:"Choose Columns:"},sort:{ascending:"Sort Ascending",descending:"Sort Descending",none:"Sort None",remove:"Remove Sort"},column:{hide:"Hide Column"},aggregation:{count:"total rows: ",sum:"total: ",avg:"avg: ",min:"min: ",max:"max: "},pinning:{pinLeft:"Pin Left",pinRight:"Pin Right",unpin:"Unpin"},columnMenu:{close:"Close"},gridMenu:{aria:{buttonLabel:"Grid Menu"},columns:"Columns:",importerTitle:"Import file",exporterAllAsCsv:"Export all data as csv",exporterVisibleAsCsv:"Export visible data as csv",exporterSelectedAsCsv:"Export selected data as csv",exporterAllAsPdf:"Export all data as pdf",exporterVisibleAsPdf:"Export visible data as pdf",exporterSelectedAsPdf:"Export selected data as pdf",exporterAllAsExcel:"Export all data as excel",exporterVisibleAsExcel:"Export visible data as excel",exporterSelectedAsExcel:"Export selected data as excel",clearAllFilters:"Clear all filters"},importer:{noHeaders:"Column names were unable to be derived, does the file have a header?",noObjects:"Objects were not able to be derived, was there data in the file other than headers?",invalidCsv:"File was unable to be processed, is it valid CSV?",invalidJson:"File was unable to be processed, is it valid Json?",jsonNotArray:"Imported json file must contain an array, aborting."},pagination:{aria:{pageToFirst:"Page to first",pageBack:"Page back",pageSelected:"Selected page",pageForward:"Page forward",pageToLast:"Page to last"},sizes:"items per page",totalItems:"items",through:"through",of:"of"},grouping:{group:"Group",ungroup:"Ungroup",aggregate_count:"Agg: Count",aggregate_sum:"Agg: Sum",aggregate_max:"Agg: Max",aggregate_min:"Agg: Min",aggregate_avg:"Agg: Avg",aggregate_remove:"Agg: Remove"},validate:{error:"Error:",minLength:"Value should be at least THRESHOLD characters long.",maxLength:"Value should be at most THRESHOLD characters long.",required:"A value is needed."}}),e}])}]),angular.module("ui.grid").factory("Grid",["$q","$compile","$parse","gridUtil","uiGridConstants","GridOptions","GridColumn","GridRow","GridApi","rowSorter","rowSearcher","GridRenderContainer","$timeout","ScrollEvent",function(v,i,n,p,s,d,c,u,g,f,t,m,r,C){function e(e){var i=this;if(void 0===e||void 0===e.id||!e.id)throw new Error("No ID provided. An ID must be given when creating a grid.");if(!/^[_a-zA-Z0-9-]+$/.test(e.id))throw new Error("Grid id '"+e.id+'" is invalid. It must follow CSS selector syntax rules.');function t(e){i.isScrollingVertically=!1,i.api.core.raise.scrollEnd(e),i.scrollDirection=s.scrollDirection.NONE}i.id=e.id,delete e.id,i.options=d.initialize(e),i.appScope=i.options.appScopeProvider,i.headerHeight=i.options.headerRowHeight,i.footerHeight=i.calcFooterHeight(),i.columnFooterHeight=i.calcColumnFooterHeight(),i.rtl=!1,i.gridHeight=0,i.gridWidth=0,i.columnBuilders=[],i.rowBuilders=[],i.rowsProcessors=[],i.columnsProcessors=[],i.styleComputations=[],i.viewportAdjusters=[],i.rowHeaderColumns=[],i.dataChangeCallbacks={},i.verticalScrollSyncCallBackFns={},i.horizontalScrollSyncCallBackFns={},i.renderContainers={},i.renderContainers.body=new m("body",i),i.cellValueGetterCache={},i.getRowTemplateFn=null,i.rows=[],i.columns=[],i.isScrollingVertically=!1,i.isScrollingHorizontally=!1,i.scrollDirection=s.scrollDirection.NONE,i.disableScrolling=!1;var r=p.debounce(t,i.options.scrollDebounce),n=p.debounce(t,0);function o(e){i.isScrollingHorizontally=!1,i.api.core.raise.scrollEnd(e),i.scrollDirection=s.scrollDirection.NONE}var a=p.debounce(o,i.options.scrollDebounce),l=p.debounce(o,0);i.flagScrollingVertically=function(e){i.isScrollingVertically||i.isScrollingHorizontally||i.api.core.raise.scrollBegin(e),i.isScrollingVertically=!0,(0!==i.options.scrollDebounce&&e.withDelay?r:n)(e)},i.flagScrollingHorizontally=function(e){i.isScrollingVertically||i.isScrollingHorizontally||i.api.core.raise.scrollBegin(e),i.isScrollingHorizontally=!0,(0!==i.options.scrollDebounce&&e.withDelay?a:l)(e)},i.scrollbarHeight=0,i.scrollbarWidth=0,i.options.enableHorizontalScrollbar!==s.scrollbars.NEVER&&(i.scrollbarHeight=p.getScrollbarWidth()),i.options.enableVerticalScrollbar!==s.scrollbars.NEVER&&(i.scrollbarWidth=p.getScrollbarWidth()),i.api=new g(i),i.api.registerMethod("core","refresh",this.refresh),i.api.registerMethod("core","queueGridRefresh",this.queueGridRefresh),i.api.registerMethod("core","refreshRows",this.refreshRows),i.api.registerMethod("core","queueRefresh",this.queueRefresh),i.api.registerMethod("core","handleWindowResize",this.handleWindowResize),i.api.registerMethod("core","addRowHeaderColumn",this.addRowHeaderColumn),i.api.registerMethod("core","scrollToIfNecessary",function(e,t){return i.scrollToIfNecessary(e,t)}),i.api.registerMethod("core","scrollTo",function(e,t){return i.scrollTo(e,t)}),i.api.registerMethod("core","registerRowsProcessor",this.registerRowsProcessor),i.api.registerMethod("core","registerColumnsProcessor",this.registerColumnsProcessor),i.api.registerMethod("core","sortHandleNulls",f.handleNulls),i.api.registerEvent("core","sortChanged"),i.api.registerEvent("core","columnVisibilityChanged"),i.api.registerMethod("core","notifyDataChange",this.notifyDataChange),i.api.registerMethod("core","clearAllFilters",this.clearAllFilters),i.registerDataChangeCallback(i.columnRefreshCallback,[s.dataChange.COLUMN]),i.registerDataChangeCallback(i.processRowsCallback,[s.dataChange.EDIT]),i.registerDataChangeCallback(i.updateFooterHeightCallback,[s.dataChange.OPTIONS]),i.registerStyleComputation({priority:10,func:i.getFooterStyles})}e.prototype.calcFooterHeight=function(){var e;return this.hasFooter()?(e=0,this.options.showGridFooter&&(e+=this.options.gridFooterHeight),e+this.calcColumnFooterHeight()):0},e.prototype.calcColumnFooterHeight=function(){var e=0;return this.options.showColumnFooter&&(e+=this.options.columnFooterHeight),e},e.prototype.getFooterStyles=function(){var e=".grid"+this.id+" .ui-grid-footer-aggregates-row { height: "+this.options.columnFooterHeight+"px; }";return e+=" .grid"+this.id+" .ui-grid-footer-info { height: "+this.options.gridFooterHeight+"px; }"},e.prototype.hasFooter=function(){return this.options.showGridFooter||this.options.showColumnFooter},e.prototype.isRTL=function(){return this.rtl},e.prototype.registerColumnBuilder=function(e){this.columnBuilders.push(e)},e.prototype.buildColumnDefsFromData=function(e){this.options.columnDefs=p.getColumnsFromData(e,this.options.excludeProperties)},e.prototype.registerRowBuilder=function(e){this.rowBuilders.push(e)},e.prototype.registerDataChangeCallback=function(e,t,i){var r=this,n=p.nextUid();return t=t||[s.dataChange.ALL],Array.isArray(t)||p.logError("Expected types to be an array or null in registerDataChangeCallback, value passed was: "+t),this.dataChangeCallbacks[n]={callback:e,types:t,_this:i},function(){delete r.dataChangeCallbacks[n]}},e.prototype.callDataChangeCallbacks=function(i,r){angular.forEach(this.dataChangeCallbacks,function(e,t){-1===e.types.indexOf(s.dataChange.ALL)&&-1===e.types.indexOf(i)&&i!==s.dataChange.ALL||(e._this?e.callback.apply(e._this,this,r):e.callback(this,r))},this)},e.prototype.notifyDataChange=function(e){var t=s.dataChange;e===t.ALL||e===t.COLUMN||e===t.EDIT||e===t.ROW||e===t.OPTIONS?this.callDataChangeCallbacks(e):p.logError("Notified of a data change, but the type was not recognised, so no action taken, type was: "+e)},e.prototype.columnRefreshCallback=function(e,t){e.buildColumns(t),e.queueGridRefresh()},e.prototype.processRowsCallback=function(e){e.queueGridRefresh()},e.prototype.updateFooterHeightCallback=function(e){e.footerHeight=e.calcFooterHeight(),e.columnFooterHeight=e.calcColumnFooterHeight()},e.prototype.getColumn=function(t){return o(this.columns,function(e){return e.colDef.name===t})},e.prototype.getColDef=function(t){return o(this.options.columnDefs,function(e){return e.name===t})},e.prototype.assignTypes=function(){var r=this;r.options.columnDefs.forEach(function(e,t){var i;e.type||(t=new c(e,t,r),i=0<r.rows.length?r.rows[0]:null,e.type=i?p.guessType(r.getCellValue(i,t)):"string")})},e.prototype.isRowHeaderColumn=function(e){return-1!==this.rowHeaderColumns.indexOf(e)},e.prototype.addRowHeaderColumn=function(e,t,i){var r=this,n=(void 0===t&&(t=0),new c(e,p.nextUid(),r));n.isRowHeader=!0,r.isRTL()?(r.createRightContainer(),n.renderContainer="right"):(r.createLeftContainer(),n.renderContainer="left"),r.columnBuilders[0](e,n,r.options).then(function(){n.enableFiltering=!1,n.enableSorting=!1,n.enableHiding=!1,n.headerPriority=t,r.rowHeaderColumns.push(n),r.rowHeaderColumns=r.rowHeaderColumns.sort(function(e,t){return e.headerPriority-t.headerPriority}),i||r.buildColumns().then(function(){r.preCompileCellTemplates(),r.queueGridRefresh()}).catch(angular.noop)}).catch(angular.noop)},e.prototype.getOnlyDataColumns=function(){var t=this,i=[];return t.columns.forEach(function(e){-1===t.rowHeaderColumns.indexOf(e)&&i.push(e)}),i},e.prototype.buildColumns=function(e){var t={orderByColumnDefs:!1},r=(angular.extend(t,e),this),n=[],o=r.rowHeaderColumns.length;for(s=0;s<r.columns.length;s++)r.getColDef(r.columns[s].name)||(r.columns.splice(s,1),s--);for(var i=r.rowHeaderColumns.length-1;0<=i;i--)r.columns.unshift(r.rowHeaderColumns[i]);if(r.options.columnDefs.forEach(function(t,e){r.preprocessColDef(t);var i=r.getColumn(t.name);i?i.updateColumnDef(t,!1):(i=new c(t,p.nextUid(),r),r.columns.splice(e+o,0,i)),r.columnBuilders.forEach(function(e){n.push(e.call(r,t,i,r.options))})}),t.orderByColumnDefs){for(var a=r.columns.slice(0),l=Math.min(r.options.columnDefs.length,r.columns.length),s=0;s<l;s++)r.columns[s+o].name!==r.options.columnDefs[s].name?a[s+o]=r.getColumn(r.options.columnDefs[s].name):a[s+o]=r.columns[s+o];r.columns.length=0,Array.prototype.splice.apply(r.columns,[0,0].concat(a))}return v.all(n).then(function(){0<r.rows.length&&r.assignTypes(),t.preCompileCellTemplates&&r.preCompileCellTemplates()}).catch(angular.noop)},e.prototype.preCompileCellTemplate=function(e){var t=(t=e.cellTemplate.replace(s.MODEL_COL_FIELD,this.getQualifiedColField(e))).replace(s.COL_FIELD,"grid.getCellValue(row, col)");e.compiledElementFn=i(t),e.compiledElementFnDefer&&e.compiledElementFnDefer.resolve(e.compiledElementFn)},e.prototype.preCompileCellTemplates=function(){var t=this;t.columns.forEach(function(e){e.cellTemplate?t.preCompileCellTemplate(e):e.cellTemplatePromise&&e.cellTemplatePromise.then(function(){t.preCompileCellTemplate(e)}).catch(angular.noop)})},e.prototype.getQualifiedColField=function(e){var t="row.entity";return e.field===s.ENTITY_BINDING?t:p.preEval(t+"."+e.field)},e.prototype.createLeftContainer=function(){this.hasLeftContainer()||(this.renderContainers.left=new m("left",this,{disableColumnOffset:!0}))},e.prototype.createRightContainer=function(){this.hasRightContainer()||(this.renderContainers.right=new m("right",this,{disableColumnOffset:!0}))},e.prototype.hasLeftContainer=function(){return void 0!==this.renderContainers.left},e.prototype.hasRightContainer=function(){return void 0!==this.renderContainers.right},e.prototype.preprocessColDef=function(e){if(!e.field&&!e.name)throw new Error("colDef.name or colDef.field property is required");if(void 0===e.name&&void 0!==e.field){for(var t=e.field,i=2;this.getColumn(t);)t=e.field+i.toString(),i++;e.name=t}},e.prototype.newInN=function(e,t,i,r){for(var n=[],o=0;o<t.length;o++){for(var a=r?t[o][r]:t[o],l=!1,s=0;s<e.length;s++){var d=i?e[s][i]:e[s];if(this.options.rowEquality(a,d)){l=!0;break}}l||n.push(a)}return n};var o=function(e,t){var i;return e&&e.length?angular.isFunction(e.find)?e.find(t)||null:(i=null,e.every(function(e){return!t(e)||(i=e,!1)}),i):null},a=(e.prototype.getRow=function(t,e){var i=this;return e=null==e?this.rows:e,o(e,function(e){return i.options.rowEquality(e.entity,t)})},e.prototype.getRowsByKey=function(e,t,i,r){return null==t?null:(r=null==r?this.rows:r).filter(e?function(e){return null!=e.entity&&e.entity.hasOwnProperty(t)&&e.entity[t]===i}:function(e){return e.hasOwnProperty(t)&&e[t]===i})},e.prototype.findRowByKey=function(e,t,i,r){var n=null;return null!=t&&(r=null==r?this.rows:r).every(e?function(e){return null==e.entity||!e.entity.hasOwnProperty(t)||e.entity[t]!==i||(n=e,!1)}:function(e){return!e.hasOwnProperty(t)||e[t]!==i||(n=e,!1)}),n},e.prototype.modifyRows=function(e){var n=this,o=n.rows.slice(0),a=n.rowHashMap||n.createRowHashMap(),l=!0,e=(n.rowHashMap=n.createRowHashMap(),n.rows.length=0,e.forEach(function(e,t){var i,r=n.options.enableRowHashing?a.get(e):n.getRow(e,o);r&&((i=r).entity=e,i.index!==t)&&(i.index=t),i=i||n.processRowBuilders(new u(e,t,n)),n.rows.push(i),n.rowHashMap.put(e,i),i.isSelected||(l=!1)}),n.selection&&n.rows.length&&(n.selection.selectAll=l),n.assignTypes(),v.when(n.processRowsProcessors(n.rows)).then(function(e){return n.setVisibleRows(e)}).catch(angular.noop)),t=v.when(n.processColumnsProcessors(n.columns)).then(function(e){return n.setVisibleColumns(e)}).catch(angular.noop);return v.all([e,t])},e.prototype.addRows=function(e){for(var t=this,i=t.rows.length,r=0;r<e.length;r++){var n,o=t.processRowBuilders(new u(e[r],r+i,t));t.options.enableRowHashing&&(n=t.rowHashMap.get(o.entity))&&(n.row=o),t.rows.push(o)}},e.prototype.processRowBuilders=function(t){var i=this;return i.rowBuilders.forEach(function(e){e.call(i,t,i.options)}),t},e.prototype.registerStyleComputation=function(e){this.styleComputations.push(e)},e.prototype.registerRowsProcessor=function(e,t){if(!angular.isFunction(e))throw"Attempt to register non-function rows processor: "+e;this.rowsProcessors.push({processor:e,priority:t}),this.rowsProcessors.sort(function(e,t){return e.priority-t.priority})},e.prototype.removeRowsProcessor=function(i){var r=-1;this.rowsProcessors.forEach(function(e,t){e.processor===i&&(r=t)}),-1!==r&&this.rowsProcessors.splice(r,1)},e.prototype.processRowsProcessors=function(e){var n,o=this,e=e.slice(0);return 0===o.rowsProcessors.length?v.when(e):(n=v.defer(),function t(i,e){var r=o.rowsProcessors[i].processor;return v.when(r.call(o,e,o.columns)).then(function(e){if(!e)throw"Processor at index "+i+" did not return a set of renderable rows";if(!angular.isArray(e))throw"Processor at index "+i+" did not return an array";if(++i<=o.rowsProcessors.length-1)return t(i,e);n.resolve(e)}).catch(function(e){throw e})}(0,e),n.promise)},e.prototype.setVisibleRows=function(e){var t,i=this;for(t in i.renderContainers){var r=i.renderContainers[t];r.canvasHeightShouldUpdate=!0,void 0===r.visibleRowCache?r.visibleRowCache=[]:r.visibleRowCache.length=0}for(var n=0;n<e.length;n++){var o=e[n],a=void 0!==o.renderContainer&&o.renderContainer?o.renderContainer:"body";o.visible&&i.renderContainers[a].visibleRowCache.push(o)}i.api.core.raise.rowsVisibleChanged(this.api),i.api.core.raise.rowsRendered(this.api)},e.prototype.registerColumnsProcessor=function(e,t){if(!angular.isFunction(e))throw"Attempt to register non-function rows processor: "+e;this.columnsProcessors.push({processor:e,priority:t}),this.columnsProcessors.sort(function(e,t){return e.priority-t.priority})},e.prototype.removeColumnsProcessor=function(e){e=this.columnsProcessors.indexOf(e);void 0!==e&&this.columnsProcessors.splice(e,1)},e.prototype.processColumnsProcessors=function(e){var n,o=this,a=e.slice(0);return 0===o.columnsProcessors.length?v.when(a):(n=v.defer(),function t(i,e){var r=o.columnsProcessors[i].processor;return v.when(r.call(o,e,o.rows)).then(function(e){if(!e)throw"Processor at index "+i+" did not return a set of renderable rows";if(!angular.isArray(e))throw"Processor at index "+i+" did not return an array";if(++i<=o.columnsProcessors.length-1)return t(i,a);n.resolve(a)}).catch(angular.noop)}(0,a),n.promise)},e.prototype.setVisibleColumns=function(e){for(var t in this.renderContainers)this.renderContainers[t].visibleColumnCache.length=0;for(var i=0;i<e.length;i++){var r=e[i];r.visible&&(void 0!==r.renderContainer&&r.renderContainer?this.renderContainers[r.renderContainer]:this.renderContainers.body).visibleColumnCache.push(r)}},e.prototype.handleWindowResize=function(e){var t=this;return t.gridWidth=p.elementWidth(t.element),t.gridHeight=p.elementHeight(t.element),t.queueRefresh()},e.prototype.queueRefresh=function(){var e=this;return e.refreshCanceller&&r.cancel(e.refreshCanceller),e.refreshCanceller=r(function(){e.refreshCanvas(!0)}),e.refreshCanceller.then(function(){e.refreshCanceller=null}).catch(angular.noop),e.refreshCanceller},e.prototype.queueGridRefresh=function(){var e=this;return e.gridRefreshCanceller&&r.cancel(e.gridRefreshCanceller),e.gridRefreshCanceller=r(function(){e.refresh(!0)}),e.gridRefreshCanceller.then(function(){e.gridRefreshCanceller=null}).catch(angular.noop),e.gridRefreshCanceller},e.prototype.updateCanvasHeight=function(){for(var e in this.renderContainers)this.renderContainers.hasOwnProperty(e)&&(this.renderContainers[e].canvasHeightShouldUpdate=!0)},e.prototype.buildStyles=function(){var t=this;t.customStyles="",t.styleComputations.sort(function(e,t){return null===e.priority?1:null===t.priority?-1:null===e.priority&&null===t.priority?0:e.priority-t.priority}).forEach(function(e){e=e.func.call(t);angular.isString(e)&&(t.customStyles+="\n"+e)})},e.prototype.minColumnsToRender=function(){var n=this,o=this.getViewportWidth(),a=0,l=0;return n.columns.forEach(function(e,t){if(l<o)l+=e.drawnWidth,a++;else{for(var i=0,r=t;t-a<=r;r--)i+=n.columns[r].drawnWidth;i<o&&a++}}),a},e.prototype.getBodyHeight=function(){return this.getViewportHeight()},e.prototype.getViewportHeight=function(){var e=this.gridHeight-this.headerHeight-this.footerHeight;return 0<(e+=this.getViewportAdjustment().height)?e:0},e.prototype.getViewportWidth=function(){var e=this.gridWidth;return e+=this.getViewportAdjustment().width},e.prototype.getHeaderViewportWidth=function(){return this.getViewportWidth()},e.prototype.addVerticalScrollSync=function(e,t){this.verticalScrollSyncCallBackFns[e]=t},e.prototype.addHorizontalScrollSync=function(e,t){this.horizontalScrollSyncCallBackFns[e]=t},e.prototype.scrollContainers=function(e,t){if(t.y){var i=["body","left","right"];this.flagScrollingVertically(t),"body"===e?i=["left","right"]:"left"===e?i=["body","right"]:"right"===e&&(i=["body","left"]);for(var r=0;r<i.length;r++){var n=i[r];this.verticalScrollSyncCallBackFns[n]&&this.verticalScrollSyncCallBackFns[n](t)}}if(t.x){var o=["body","bodyheader","bodyfooter"];this.flagScrollingHorizontally(t),"body"===e&&(o=["bodyheader","bodyfooter"]);for(var a=0;a<o.length;a++){var l=o[a];this.horizontalScrollSyncCallBackFns[l]&&this.horizontalScrollSyncCallBackFns[l](t)}}},e.prototype.registerViewportAdjuster=function(e){this.viewportAdjusters.push(e)},e.prototype.removeViewportAdjuster=function(e){e=this.viewportAdjusters.indexOf(e);void 0!==e&&this.viewportAdjusters.splice(e,1)},e.prototype.getViewportAdjustment=function(){var t={height:0,width:0};return this.viewportAdjusters.forEach(function(e){t=e.call(this,t)}),t},e.prototype.getVisibleRowCount=function(){return this.renderContainers.body.visibleRowCache.length},e.prototype.getVisibleRows=function(){return this.renderContainers.body.visibleRowCache},e.prototype.getVisibleColumnCount=function(){return this.renderContainers.body.visibleColumnCache.length},e.prototype.searchRows=function(e){return t.search(this,e,this.columns)},e.prototype.sortByColumn=function(e){return f.sort(this,e,this.columns)},e.prototype.getCellValue=function(e,t){return void 0!==e.entity["$$"+t.uid]?e.entity["$$"+t.uid].rendered:this.options.flatEntityAccess&&void 0!==t.field?e.entity[t.field]:(t.cellValueGetterCache||(t.cellValueGetterCache=n(e.getEntityQualifiedColField(t))),t.cellValueGetterCache(e))},e.prototype.getCellDisplayValue=function(e,t){t.cellDisplayGetterCache||(i=t.cellFilter?" | "+t.cellFilter:"",void 0!==e.entity["$$"+t.uid]?t.cellDisplayGetterCache=n(e.entity["$$"+t.uid].rendered+i):this.options.flatEntityAccess&&void 0!==t.field?(r=t.field.replace(/(')|(\\)/g,"\\$&"),t.cellDisplayGetterCache=n("entity['"+r+"']"+i)):t.cellDisplayGetterCache=n(e.getEntityQualifiedColField(t)+i));var i,r=angular.extend({},e,{col:t});return t.cellDisplayGetterCache(r)},e.prototype.getNextColumnSortPriority=function(){var t=0;return this.columns.forEach(function(e){e.sort&&void 0!==e.sort.priority&&e.sort.priority>=t&&(t=e.sort.priority+1)}),t},e.prototype.resetColumnSorting=function(t){this.columns.forEach(function(e){e===t||e.suppressRemoveSort||(e.sort={})})},e.prototype.getColumnSorting=function(){var t=[];return this.columns.slice(0).sort(f.prioritySort).forEach(function(e){e.sort&&void 0!==e.sort.direction&&e.sort.direction&&(e.sort.direction===s.ASC||e.sort.direction===s.DESC)&&t.push(e)}),t},e.prototype.sortColumn=function(e,t,i){var r=this,n=null;if(void 0!==e&&e)return"boolean"==typeof t?i=t:n=t,!i||r.options&&r.options.suppressMultiSort?(r.resetColumnSorting(e),e.sort.priority=void 0,e.sort.priority=r.getNextColumnSortPriority()):void 0===e.sort.priority&&(e.sort.priority=r.getNextColumnSortPriority()),n?e.sort.direction=n:(t=((t=e.sortDirectionCycle.indexOf(e.sort&&e.sort.direction?e.sort.direction:null))+1)%e.sortDirectionCycle.length,e.colDef&&e.suppressRemoveSort&&!e.sortDirectionCycle[t]&&(t=(t+1)%e.sortDirectionCycle.length),e.sortDirectionCycle[t]?e.sort.direction=e.sortDirectionCycle[t]:a(e,r)),r.api.core.raise.sortChanged(r,r.getColumnSorting()),v.when(e);throw new Error("No column parameter provided")},function(t,e){e.columns.forEach(function(e){e.sort&&void 0!==e.sort.priority&&e.sort.priority>t.sort.priority&&--e.sort.priority}),t.sort={}});function l(e,t){return e||0<t?t:null}function h(e,t){e/=t;return e<=1?e:1}function w(e,t,i){if(h(e,t)!==i)return{percentage:h(e,t)}}function b(e,t,i){e/=t;if((e=1<e?1:e)!==i)return{percentage:e}}function y(){}return e.prototype.renderingComplete=function(){angular.isFunction(this.options.onRegisterApi)&&this.options.onRegisterApi(this.api),this.api.core.raise.renderingComplete(this.api)},e.prototype.createRowHashMap=function(){var e=new y;return e.grid=this,e},e.prototype.refresh=function(e){var t=this,i=t.processRowsProcessors(t.rows).then(function(e){t.setVisibleRows(e)}).catch(angular.noop),r=t.processColumnsProcessors(t.columns).then(function(e){t.setVisibleColumns(e)}).catch(angular.noop);return v.all([i,r]).then(function(){t.refreshCanvas(!0),t.redrawInPlace(e)}).catch(angular.noop)},e.prototype.refreshRows=function(){var t=this;return t.processRowsProcessors(t.rows).then(function(e){t.setVisibleRows(e),t.redrawInPlace(),t.refreshCanvas(!0)}).catch(angular.noop)},e.prototype.refreshCanvas=function(d){var e,t,c=this,u=v.defer(),g=[];for(e in c.renderContainers)!c.renderContainers.hasOwnProperty(e)||null===(t=c.renderContainers[e]).canvasWidth||isNaN(t.canvasWidth)||(t.header||t.headerCanvas)&&(t.explicitHeaderHeight=t.explicitHeaderHeight||null,t.explicitHeaderCanvasHeight=t.explicitHeaderCanvasHeight||null,g.push(t));return d&&c.buildStyles(),r(0<g.length?function(){function e(e,t){return e!==t&&(o=!0),t}for(var t,i,r,n,o=!1,a=0,l=0,s=0;s<g.length;s++)null===(n=g[s]).canvasWidth||isNaN(n.canvasWidth)||(n.header&&(i=n.headerHeight=e(n.headerHeight,p.outerElementHeight(n.header)),r=p.getBorderSize(n.header,"top"),t=p.getBorderSize(n.header,"bottom"),i=parseInt(i-r-t,10),n.innerHeaderHeight=i=i<0?0:i,!n.explicitHeaderHeight)&&a<i&&(a=i),n.headerCanvas&&(r=n.headerCanvasHeight=e(n.headerCanvasHeight,parseInt(p.outerElementHeight(n.headerCanvas),10)),!n.explicitHeaderCanvasHeight)&&l<r&&(l=r));for(s=0;s<g.length;s++)n=g[s],0<a&&void 0!==n.headerHeight&&null!==n.headerHeight&&(n.explicitHeaderHeight||n.headerHeight<a)&&(n.explicitHeaderHeight=e(n.explicitHeaderHeight,a)),0<l&&void 0!==n.headerCanvasHeight&&null!==n.headerCanvasHeight&&(n.explicitHeaderCanvasHeight||n.headerCanvasHeight<l)&&(n.explicitHeaderCanvasHeight=e(n.explicitHeaderCanvasHeight,l));d&&o&&c.buildStyles(),u.resolve()}:function(){u.resolve()}),u.promise},e.prototype.redrawInPlace=function(e){for(var t in this.renderContainers){var t=this.renderContainers[t],i=l(e,t.prevScrollTop),r=l(e,t.prevScrollLeft),n=e||0<i?null:t.prevScrolltopPercentage;t.adjustRows(i,n),t.adjustColumns(r)}},e.prototype.hasLeftContainerColumns=function(){return this.hasLeftContainer()&&0<this.renderContainers.left.renderedColumns.length},e.prototype.hasRightContainerColumns=function(){return this.hasRightContainer()&&0<this.renderContainers.right.renderedColumns.length},e.prototype.scrollToIfNecessary=function(e,t){var i,r=this,n=new C(r,"uiGrid.scrollToIfNecessary"),o=r.renderContainers.body.visibleRowCache,a=r.renderContainers.body.visibleColumnCache,l=(l=r.renderContainers.body.prevScrollTop)<0?0:l,s=r.renderContainers.body.prevScrollLeft,d=r.renderContainers.body.prevScrollTop+r.gridHeight-r.renderContainers.body.headerHeight-r.footerHeight-r.scrollbarHeight,c=r.renderContainers.body.prevScrollLeft+Math.ceil(r.renderContainers.body.getViewportWidth());if(null!==e&&(o=o.indexOf(e),e=r.renderContainers.body.getCanvasHeight()-r.renderContainers.body.getViewportHeight(),(o=(o=o*r.options.rowHeight)<0?0:o)<Math.floor(l)?(i=r.renderContainers.body.prevScrollTop-(l-o),t&&t.colDef&&t.colDef.enableCellEditOnFocus&&(i=i-r.footerHeight-r.scrollbarHeight),n.y=w(i,e,r.renderContainers.body.prevScrolltopPercentage)):o+r.options.rowHeight>Math.ceil(d)&&(i=o+r.options.rowHeight-d+r.renderContainers.body.prevScrollTop,n.y=w(i,e,r.renderContainers.body.prevScrolltopPercentage))),null!==t){for(var u=a.indexOf(t),l=r.renderContainers.body.getCanvasWidth()-r.renderContainers.body.getViewportWidth(),g=0,p=0;p<u;p++)g+=a[p].drawnWidth;var f,o=(o=(g=g<0?0:g)+t.drawnWidth)<0?0:o;g<s?(f=r.renderContainers.body.prevScrollLeft-(s-g),n.x=b(f,l,r.renderContainers.body.prevScrollleftPercentage)):c<o&&(f=o-c+r.renderContainers.body.prevScrollLeft,n.x=b(f,l,r.renderContainers.body.prevScrollleftPercentage))}var m,h=v.defer();return n.y||n.x?(n.withDelay=!1,r.scrollContainers("",n),m=r.api.core.on.scrollEnd(null,function(){h.resolve(n),m()})):h.resolve(),h.promise},e.prototype.scrollTo=function(e,t){var i=null,r=null;return null!=e&&(i=this.getRow(e)),null!=t&&(r=this.getColumn(t.name||t.field)),this.scrollToIfNecessary(i,r)},e.prototype.clearAllFilters=function(e,t,i){if(void 0===e&&(e=!0),void 0===t&&(t=!1),void 0===i&&(i=!1),this.columns.forEach(function(e){e.filters.forEach(function(e){e.term=void 0,t&&(e.condition=void 0),i&&(e.flags=void 0)})}),e)return this.refreshRows()},y.prototype={put:function(e,t){this[this.grid.options.rowIdentity(e)]=t},get:function(e){return this[this.grid.options.rowIdentity(e)]},remove:function(e){var t=this[e=this.grid.options.rowIdentity(e)];return delete this[e],t}},e}]),angular.module("ui.grid").factory("GridApi",["$q","$rootScope","gridUtil","uiGridConstants","GridRow",function(e,t,d,i,r){function n(e){this.grid=e,this.listeners=[],this.registerEvent("core","renderingComplete"),this.registerEvent("core","filterChanged"),this.registerMethod("core","setRowInvisible",r.prototype.setRowInvisible),this.registerMethod("core","clearRowInvisible",r.prototype.clearRowInvisible),this.registerMethod("core","getVisibleRows",this.grid.getVisibleRows),this.registerEvent("core","rowsVisibleChanged"),this.registerEvent("core","rowsRendered"),this.registerEvent("core","scrollBegin"),this.registerEvent("core","scrollEnd"),this.registerEvent("core","canvasHeightChanged"),this.registerEvent("core","gridDimensionChanged")}function c(e,i,r,n){return t.$on(e,function(e){var t=Array.prototype.slice.call(arguments);t.splice(0,1),i.apply(n||r.api,t)})}return n.prototype.suppressEvents=function(e,t){var i=this,r=angular.isArray(e)?e:[e],e=i.listeners.filter(function(t){return r.some(function(e){return t.handler===e})});e.forEach(function(e){e.dereg()}),t(),e.forEach(function(e){e.dereg=c(e.eventId,e.handler,i.grid,e._this)})},n.prototype.registerEvent=function(o,a){var l=this,e=(l[o]||(l[o]={}),l[o]),s=(e.on||(e.on={},e.raise={}),l.grid.id+o+a);e.raise[a]=function(){t.$emit.apply(t,[s].concat(Array.prototype.slice.call(arguments)))},e.on[a]=function(e,t,i){var r,n;if(null===e||void 0!==e.$on)return r={handler:t,dereg:c(s,t,l.grid,i),eventId:s,scope:e,_this:i},l.listeners.push(r),n=function(){r.dereg();var e=l.listeners.indexOf(r);l.listeners.splice(e,1)},e&&e.$on("$destroy",function(){n()}),n;d.logError("asked to listen on "+o+".on."+a+" but scope wasn't passed in the input parameters.  It is legitimate to pass null, but you've passed something else, so you probably forgot to provide scope rather than did it deliberately, not registering")}},n.prototype.registerEventsFromObject=function(e){var i=this,r=[];angular.forEach(e,function(e,t){var i={name:t,events:[]};angular.forEach(e,function(e,t){i.events.push(t)}),r.push(i)}),r.forEach(function(t){t.events.forEach(function(e){i.registerEvent(t.name,e)})})},n.prototype.registerMethod=function(e,t,i,r){this[e]||(this[e]={}),this[e][t]=d.createBoundedWrapper(r||this.grid,i)},n.prototype.registerMethodsFromObject=function(e,i){var r=this,n=[];angular.forEach(e,function(e,t){var i={name:t,methods:[]};angular.forEach(e,function(e,t){i.methods.push({name:t,fn:e})}),n.push(i)}),n.forEach(function(t){t.methods.forEach(function(e){r.registerMethod(t.name,e.name,e.fn,i)})})},n}]),angular.module("ui.grid").factory("GridColumn",["gridUtil","uiGridConstants","i18nService",function(s,d,e){function t(e,t,i){var r=this;r.grid=i,r.uid=t,r.updateColumnDef(e,!0),r.aggregationValue=void 0,r.updateAggregationValue=function(){var t,e,i;r.aggregationType?(t=0,e=r.grid.getVisibleRows(),i=function(){var t=[];return e.forEach(function(e){e=r.grid.getCellValue(e,r),e=Number(e);isNaN(e)||t.push(e)}),t},angular.isFunction(r.aggregationType)?r.aggregationValue=r.aggregationType(e,r):r.aggregationType===d.aggregationTypes.count?r.aggregationValue=r.grid.getVisibleRowCount():r.aggregationType===d.aggregationTypes.sum?(i().forEach(function(e){t+=e}),r.aggregationValue=t):r.aggregationType===d.aggregationTypes.avg?(i().forEach(function(e){t+=e}),t/=i().length,r.aggregationValue=t):r.aggregationType===d.aggregationTypes.min?r.aggregationValue=Math.min.apply(null,i()):r.aggregationType===d.aggregationTypes.max?r.aggregationValue=Math.max.apply(null,i()):r.aggregationValue=" "):r.aggregationValue=void 0},this.getAggregationValue=function(){return r.aggregationValue}}function c(e){return void 0===e.displayName?s.readableColumnName(e.name):e.displayName}return t.prototype.hideColumn=function(){this.colDef.visible=!1},t.prototype.setPropertyOrDefault=function(e,t,i){var r=this;void 0!==e[t]&&e[t]?r[t]=e[t]:void 0!==r[t]?r[t]=r[t]:r[t]=i||{}},t.prototype.updateColumnDef=function(r,e){var n=this;if(void 0===(n.colDef=r).name)throw new Error("colDef.name is required for column at index "+n.grid.options.columnDefs.indexOf(r));if(n.displayName=c(r),!angular.isNumber(n.width)||!n.hasCustomWidth||r.allowCustomWidthOverride){var t=r.width,i="Cannot parse column width '"+t+"' for column named '"+r.name+"'";if(n.hasCustomWidth=!1,angular.isString(t)||angular.isNumber(t))if(angular.isString(t))if(s.endsWith(t,"%")){var o=t.replace(/%/g,""),o=parseInt(o,10);if(isNaN(o))throw new Error(i);n.width=t}else if(t.match(/^(\d+)$/))n.width=parseInt(t.match(/^(\d+)$/)[1],10);else{if(!t.match(/^\*+$/))throw new Error(i);n.width=t}else n.width=t;else n.width="*"}function a(e){return angular.isString(e)||angular.isNumber(e)}["minWidth","maxWidth"].forEach(function(e){var t=r[e],i="Cannot parse column "+e+" '"+t+"' for column named '"+r.name+"'";if("minWidth"===e&&!a(t)&&angular.isDefined(n.grid.options.minimumColumnSize)&&(t=n.grid.options.minimumColumnSize),a(t))if(angular.isString(t)){if(!t.match(/^(\d+)$/))throw new Error(i);n[e]=parseInt(t.match(/^(\d+)$/)[1],10)}else n[e]=t;else n[e]="minWidth"===e?30:9e3}),n.field=void 0===r.field?r.name:r.field,"string"!=typeof n.field&&s.logError("Field is not a string, this is likely to break the code, Field is: "+n.field),n.name=r.name,n.displayName=c(r),n.aggregationType=angular.isDefined(r.aggregationType)?r.aggregationType:null,n.footerCellTemplate=angular.isDefined(r.footerCellTemplate)?r.footerCellTemplate:null,void 0===r.cellTooltip||!1===r.cellTooltip?n.cellTooltip=!1:!0===r.cellTooltip?n.cellTooltip=function(e,t){return n.grid.getCellValue(e,t)}:"function"==typeof r.cellTooltip?n.cellTooltip=r.cellTooltip:n.cellTooltip=function(e,t){return t.colDef.cellTooltip},void 0===r.headerTooltip||!1===r.headerTooltip?n.headerTooltip=!1:!0===r.headerTooltip?n.headerTooltip=function(e){return e.displayName}:"function"==typeof r.headerTooltip?n.headerTooltip=r.headerTooltip:n.headerTooltip=function(e){return e.colDef.headerTooltip},n.footerCellClass=r.footerCellClass,n.cellClass=r.cellClass,n.headerCellClass=r.headerCellClass,n.cellFilter=r.cellFilter||"",n.sortCellFiltered=!!r.sortCellFiltered,n.filterCellFiltered=!!r.filterCellFiltered,n.headerCellFilter=r.headerCellFilter||"",n.footerCellFilter=r.footerCellFilter||"",n.visible=s.isNullOrUndefined(r.visible)||r.visible,n.headerClass=r.headerClass,n.enableSorting=(void 0!==r.enableSorting?r:n.grid.options).enableSorting,n.sortingAlgorithm=r.sortingAlgorithm,n.sortDirectionCycle=void 0!==r.sortDirectionCycle?r.sortDirectionCycle:[null,d.ASC,d.DESC],void 0===n.suppressRemoveSort&&(n.suppressRemoveSort=void 0!==r.suppressRemoveSort&&r.suppressRemoveSort),n.enableFiltering=void 0===r.enableFiltering||r.enableFiltering,n.filterContainer=(void 0!==r.filterContainer?r:n.grid.options).filterContainer,n.setPropertyOrDefault(r,"menuItems",[]),e&&n.setPropertyOrDefault(r,"sort"),n.setPropertyOrDefault(r,"defaultSort");var l=[];r.filter?l.push(r.filter):r.filters?l=r.filters:l.push({}),e?(n.setPropertyOrDefault(r,"filter"),n.setPropertyOrDefault(r,"extraStyle"),n.setPropertyOrDefault(r,"filters",l)):n.filters.length===l.length&&n.filters.forEach(function(e,t){void 0!==l[t].placeholder&&(e.placeholder=l[t].placeholder),void 0!==l[t].ariaLabel&&(e.ariaLabel=l[t].ariaLabel),void 0!==l[t].flags&&(e.flags=l[t].flags),void 0!==l[t].type&&(e.type=l[t].type),void 0!==l[t].selectOptions&&(e.selectOptions=l[t].selectOptions)})},t.prototype.unsort=function(){var t=this.sort.priority;this.grid.columns.forEach(function(e){e.sort&&void 0!==e.sort.priority&&e.sort.priority>t&&--e.sort.priority}),this.sort={},this.grid.api.core.raise.sortChanged(this.grid,this.grid.getColumnSorting())},t.prototype.getColClass=function(e){var t=d.COL_CLASS_PREFIX+this.uid;return e?"."+t:t},t.prototype.isPinnedLeft=function(){return"left"===this.renderContainer},t.prototype.isPinnedRight=function(){return"right"===this.renderContainer},t.prototype.getColClassDefinition=function(){return" .grid"+this.grid.id+" "+this.getColClass(!0)+" { min-width: "+this.drawnWidth+"px; max-width: "+this.drawnWidth+"px; }"},t.prototype.getRenderContainer=function(){var e=this.renderContainer;return this.grid.renderContainers[e=null!==e&&""!==e&&void 0!==e?e:"body"]},t.prototype.showColumn=function(){this.colDef.visible=!0},t.prototype.getAggregationText=function(){if(this.colDef.aggregationHideLabel)return"";if(this.colDef.aggregationLabel)return this.colDef.aggregationLabel;switch(this.colDef.aggregationType){case d.aggregationTypes.count:return e.getSafeText("aggregation.count");case d.aggregationTypes.sum:return e.getSafeText("aggregation.sum");case d.aggregationTypes.avg:return e.getSafeText("aggregation.avg");case d.aggregationTypes.min:return e.getSafeText("aggregation.min");case d.aggregationTypes.max:return e.getSafeText("aggregation.max");default:return""}},t.prototype.getCellTemplate=function(){return this.cellTemplatePromise},t.prototype.getCompiledElementFn=function(){return this.compiledElementFnDefer.promise},t}]),angular.module("ui.grid").factory("GridOptions",["gridUtil","uiGridConstants",function(t,i){return{initialize:function(e){return e.onRegisterApi=e.onRegisterApi||angular.noop(),e.data=e.data||[],e.columnDefs=e.columnDefs||[],e.excludeProperties=e.excludeProperties||["$$hashKey"],e.enableRowHashing=!1!==e.enableRowHashing,e.rowIdentity=e.rowIdentity||function(e){return t.hashKey(e)},e.getRowIdentity=e.getRowIdentity||function(e){return e.$$hashKey},e.flatEntityAccess=!0===e.flatEntityAccess,e.showHeader=void 0===e.showHeader||e.showHeader,e.showHeader?e.headerRowHeight=void 0!==e.headerRowHeight?e.headerRowHeight:30:e.headerRowHeight=0,"string"==typeof e.rowHeight?e.rowHeight=parseInt(e.rowHeight)||30:e.rowHeight=e.rowHeight||30,e.minRowsToShow=void 0!==e.minRowsToShow?e.minRowsToShow:10,e.showGridFooter=!0===e.showGridFooter,e.showColumnFooter=!0===e.showColumnFooter,e.columnFooterHeight=void 0!==e.columnFooterHeight?e.columnFooterHeight:30,e.gridFooterHeight=void 0!==e.gridFooterHeight?e.gridFooterHeight:30,e.columnWidth=void 0!==e.columnWidth?e.columnWidth:50,e.maxVisibleColumnCount=void 0!==e.maxVisibleColumnCount?e.maxVisibleColumnCount:200,e.virtualizationThreshold=void 0!==e.virtualizationThreshold?e.virtualizationThreshold:20,e.columnVirtualizationThreshold=void 0!==e.columnVirtualizationThreshold?e.columnVirtualizationThreshold:10,e.excessRows=void 0!==e.excessRows?e.excessRows:4,e.scrollThreshold=void 0!==e.scrollThreshold?e.scrollThreshold:4,e.excessColumns=void 0!==e.excessColumns?e.excessColumns:4,e.aggregationCalcThrottle=void 0!==e.aggregationCalcThrottle?e.aggregationCalcThrottle:500,e.wheelScrollThrottle=void 0!==e.wheelScrollThrottle?e.wheelScrollThrottle:70,e.scrollDebounce=void 0!==e.scrollDebounce?e.scrollDebounce:300,e.enableHiding=!1!==e.enableHiding,e.enableSorting=!1!==e.enableSorting,e.suppressMultiSort=!0===e.suppressMultiSort,e.enableFiltering=!0===e.enableFiltering,e.filterContainer=void 0!==e.filterContainer?e.filterContainer:"headerCell",e.enableColumnMenus=!1!==e.enableColumnMenus,e.enableVerticalScrollbar=void 0!==e.enableVerticalScrollbar?e.enableVerticalScrollbar:i.scrollbars.ALWAYS,e.enableHorizontalScrollbar=void 0!==e.enableHorizontalScrollbar?e.enableHorizontalScrollbar:i.scrollbars.ALWAYS,e.enableMinHeightCheck=!1!==e.enableMinHeightCheck,e.minimumColumnSize=void 0!==e.minimumColumnSize?e.minimumColumnSize:30,e.rowEquality=e.rowEquality||function(e,t){return e===t},e.headerTemplate=e.headerTemplate||null,e.footerTemplate=e.footerTemplate||"ui-grid/ui-grid-footer",e.gridFooterTemplate=e.gridFooterTemplate||"ui-grid/ui-grid-grid-footer",e.rowTemplate=e.rowTemplate||"ui-grid/ui-grid-row",e.gridMenuTemplate=e.gridMenuTemplate||"ui-grid/uiGridMenu",e.disableGridMenuHideOnScroll=e.disableGridMenuHideOnScroll||!1,e.menuButtonTemplate=e.menuButtonTemplate||"ui-grid/ui-grid-menu-button",e.menuItemTemplate=e.menuItemTemplate||"ui-grid/uiGridMenuItem",e.appScopeProvider=e.appScopeProvider||null,e}}}]),angular.module("ui.grid").factory("GridRenderContainer",["gridUtil","uiGridConstants",function(b,r){function e(e,t,i){var r=this;r.name=e,r.grid=t,r.visibleRowCache=[],r.visibleColumnCache=[],r.renderedRows=[],r.renderedColumns=[],r.prevScrollTop=0,r.prevScrolltopPercentage=0,r.prevRowScrollIndex=0,r.prevScrollLeft=0,r.prevScrollleftPercentage=0,r.prevColumnScrollIndex=0,r.columnStyles="",r.viewportAdjusters=[],r.hasHScrollbar=!1,r.hasVScrollbar=!1,r.canvasHeightShouldUpdate=!0,r.$$canvasHeight=0,i&&angular.isObject(i)&&angular.extend(r,i),t.registerStyleComputation({priority:5,func:function(){return r.updateColumnWidths(),r.columnStyles}})}return e.prototype.reset=function(){this.visibleColumnCache.length=0,this.visibleRowCache.length=0,this.renderedRows.length=0,this.renderedColumns.length=0},e.prototype.containsColumn=function(e){return-1!==this.visibleColumnCache.indexOf(e)},e.prototype.minRowsToRender=function(){for(var e=0,t=0,i=this.getViewportHeight(),r=this.visibleRowCache.length-1;t<i&&0<=r;r--)t+=this.visibleRowCache[r].height,e++;return e},e.prototype.minColumnsToRender=function(){for(var e=this.getViewportWidth(),t=0,i=0,r=0;r<this.visibleColumnCache.length;r++){var n=this.visibleColumnCache[r];if(i<e)i+=n.drawnWidth||0,t++;else{for(var o=0,a=r;r-t<=a;a--)o+=this.visibleColumnCache[a].drawnWidth||0;o<e&&t++}}return t},e.prototype.getVisibleRowCount=function(){return this.visibleRowCache.length},e.prototype.registerViewportAdjuster=function(e){this.viewportAdjusters.push(e)},e.prototype.removeViewportAdjuster=function(e){e=this.viewportAdjusters.indexOf(e);-1<e&&this.viewportAdjusters.splice(e,1)},e.prototype.getViewportAdjustment=function(){var t={height:0,width:0};return this.viewportAdjusters.forEach(function(e){t=e.call(this,t)}),t},e.prototype.getMargin=function(t){var i=0;return this.viewportAdjusters.forEach(function(e){e=e.call(this,{height:0,width:0});e.side&&e.side===t&&(i+=-1*e.width)}),i},e.prototype.getViewportHeight=function(){var e=this,t=e.headerHeight||e.grid.headerHeight,t=e.grid.gridHeight-t-e.grid.footerHeight;return 0<(t+=e.getViewportAdjustment().height)?t:0},e.prototype.getViewportWidth=function(){var e=this.grid.gridWidth;return e+=this.getViewportAdjustment().width},e.prototype.getHeaderViewportWidth=function(){return this.getViewportWidth()},e.prototype.getCanvasHeight=function(){var e,t=this;return t.canvasHeightShouldUpdate&&(e=t.$$canvasHeight,t.$$canvasHeight=0,t.visibleRowCache.forEach(function(e){t.$$canvasHeight+=e.height}),t.canvasHeightShouldUpdate=!1,t.grid.api.core.raise.canvasHeightChanged(e,t.$$canvasHeight)),t.$$canvasHeight},e.prototype.getVerticalScrollLength=function(){return this.getCanvasHeight()-this.getViewportHeight()+this.grid.scrollbarHeight!==0?this.getCanvasHeight()-this.getViewportHeight()+this.grid.scrollbarHeight:-1},e.prototype.getHorizontalScrollLength=function(){return this.getCanvasWidth()-this.getViewportWidth()+this.grid.scrollbarWidth!==0?this.getCanvasWidth()-this.getViewportWidth()+this.grid.scrollbarWidth:-1},e.prototype.getCanvasWidth=function(){return this.canvasWidth},e.prototype.setRenderedRows=function(e){this.renderedRows.length=e.length;for(var t=0;t<e.length;t++)this.renderedRows[t]=e[t]},e.prototype.setRenderedColumns=function(e){this.renderedColumns.length=e.length;for(var t=0;t<e.length;t++)this.renderedColumns[t]=e[t];this.updateColumnOffset()},e.prototype.updateColumnOffset=function(){for(var e=0,t=0;t<this.currentFirstColumn;t++)e+=this.visibleColumnCache[t].drawnWidth;this.columnOffset=e},e.prototype.scrollVertical=function(e){var t,i=-1;if(e!==this.prevScrollTop)return 0<(t=e-this.prevScrollTop)&&(this.grid.scrollDirection=r.scrollDirection.DOWN),t<0&&(this.grid.scrollDirection=r.scrollDirection.UP),i=e/this.getVerticalScrollLength(),this.adjustScrollVertical(e,i=(i=1<i?1:i)<0?0:i),i},e.prototype.scrollHorizontal=function(e){var t,i=-1;if(e!==this.prevScrollLeft)return 0<(t=e-this.prevScrollLeft)&&(this.grid.scrollDirection=r.scrollDirection.RIGHT),t<0&&(this.grid.scrollDirection=r.scrollDirection.LEFT),t=this.getHorizontalScrollLength(),this.adjustScrollHorizontal(e,i=0!==t?e/t:0),i},e.prototype.adjustScrollVertical=function(e,t,i){this.prevScrollTop===e&&!i||(null==e&&(e=(this.getCanvasHeight()-this.getViewportHeight())*t),this.adjustRows(e,t,!1),this.prevScrollTop=e,this.prevScrolltopPercentage=t,this.grid.queueRefresh())},e.prototype.adjustScrollHorizontal=function(e,t,i){this.prevScrollLeft===e&&!i||(null==e&&(e=(this.getCanvasWidth()-this.getViewportWidth())*t),this.adjustColumns(e),this.prevScrollLeft=e,this.prevScrollleftPercentage=t,this.grid.queueRefresh())},e.prototype.adjustRows=function(e,t,i){var r=this,n=r.minRowsToRender(),o=r.visibleRowCache,a=o.length-n,t=(null==t&&e&&(t=e/r.getVerticalScrollLength()),Math.ceil(Math.min(a,a*t))),l=(a<t&&(t=a),[]);if(o.length>r.grid.options.virtualizationThreshold){if(null!=e){if(!r.grid.suppressParentScrollDown&&r.prevScrollTop<e&&t<r.prevRowScrollIndex+r.grid.options.scrollThreshold&&t<a)return;if(!r.grid.suppressParentScrollUp&&r.prevScrollTop>e&&t>r.prevRowScrollIndex-r.grid.options.scrollThreshold&&t<a)return}l=[Math.max(0,t-r.grid.options.excessRows),Math.min(o.length,t+n+r.grid.options.excessRows)]}else{e=r.visibleRowCache.length;l=[0,Math.max(e,n+r.grid.options.excessRows)]}r.updateViewableRowRange(l),r.prevRowScrollIndex=t},e.prototype.adjustColumns=function(e){var t=this,i=t.minColumnsToRender(),r=t.visibleColumnCache,n=r.length-i,n=Math.min(n,t.getLeftIndex(e)),e=[];e=r.length>t.grid.options.columnVirtualizationThreshold&&t.getCanvasWidth()>t.getViewportWidth()?[Math.max(0,n-t.grid.options.excessColumns),Math.min(r.length,n+i+t.grid.options.excessColumns)]:(r=t.visibleColumnCache.length,[0,Math.max(r,i+t.grid.options.excessColumns)]),t.updateViewableColumnRange(e),t.prevColumnScrollIndex=n},e.prototype.getLeftIndex=function(e){for(var t=0,i=0;i<this.visibleColumnCache.length&&!(this.visibleColumnCache[i]&&this.visibleColumnCache[i].visible&&e<=(t+=this.visibleColumnCache[i].drawnWidth));i++);return i},e.prototype.updateViewableRowRange=function(e){var t=this.visibleRowCache.slice(e[0],e[1]);this.currentTopRow=e[0],this.setRenderedRows(t)},e.prototype.updateViewableColumnRange=function(e){var t=this.visibleColumnCache.slice(e[0],e[1]);this.currentFirstColumn=e[0],this.setRenderedColumns(t)},e.prototype.headerCellWrapperStyle=function(){var e;return 0!==this.currentFirstColumn?(e=this.columnOffset,this.grid.isRTL()?{"margin-right":e+"px"}:{"margin-left":e+"px"}):null},e.prototype.updateColumnWidths=function(){var i,e,r=this,n=[],o=0,a=0,t="",l=!1,s=[],d=[],c=0,u=r.grid.getViewportWidth()-r.grid.scrollbarWidth,g=[],p=(angular.forEach(r.grid.renderContainers,function(e){g=g.concat(e.visibleColumnCache)}),g.forEach(function(e){var t,i=0;e.visible&&((l=!l&&e.colDef.pinnedRight?!0:l)&&(u+=r.grid.scrollbarWidth),angular.isNumber(e.width)?(i=e.colDef.allowFloatWidth?parseFloat(e.width):parseInt(e.width,10),a+=i,e.drawnWidth=i,s.push(e)):b.endsWith(e.width,"%")?(t=parseInt(e.width.replace(/%/g,""),10),(i=(i=e.colDef.allowFloatWidth?parseFloat(t/100*u):parseInt(t/100*u,10))>e.maxWidth?e.maxWidth:i)<e.minWidth&&(i=e.minWidth),a+=i,e.drawnWidth=i,c+=t,d.push(e)):angular.isString(e.width)&&-1!==e.width.indexOf("*")&&(o+=e.width.length,n.push(e)))}),u-a);if(0<n.length&&(i=p/o,n.forEach(function(e){var t=parseInt(e.width.length*i,10);(t=(t=e.colDef.allowFloatWidth?parseFloat(e.width.length*i):t)>e.maxWidth?e.maxWidth:t)<e.minWidth&&(t=e.minWidth),a+=t,e.drawnWidth=t})),0<n.length?e=n:0<d.length&&0===s.length&&100===c&&(e=d),!angular.isUndefined(e)){function f(e){e.drawnWidth<e.maxWidth&&0<m&&(e.drawnWidth++,a++,m--,h=!0)}for(var m=u-a,h=!0;0<m&&h;)h=!1,e.forEach(f);function v(e){e.drawnWidth>e.minWidth&&0<C&&(e.drawnWidth--,a--,C--,h=!0)}for(var C=a-u,h=!0;0<C&&h;)h=!1,e.forEach(v)}var w=0;r.visibleColumnCache.forEach(function(e){e.visible&&(w+=e.drawnWidth)}),g.forEach(function(e){t+=e.getColClassDefinition()}),r.canvasWidth=w,this.columnStyles=t},e.prototype.needsHScrollbarPlaceholder=function(){var e;return("left"===this.name||"right"===this.name&&!this.hasHScrollbar&&!this.grid.disableScrolling)&&(this.grid.options.enableHorizontalScrollbar===r.scrollbars.ALWAYS||(e=this.grid.element[0].querySelector(".ui-grid-render-container-body .ui-grid-viewport")).scrollWidth>e.offsetWidth)},e.prototype.getViewportStyle=function(){var e=this,t={},i={};return i[r.scrollbars.ALWAYS]="scroll",i[r.scrollbars.WHEN_NEEDED]="auto",e.hasHScrollbar=!1,e.hasVScrollbar=!1,e.grid.disableScrolling?(t["overflow-x"]="hidden",t["overflow-y"]="hidden"):("body"===e.name?(e.hasHScrollbar=e.grid.options.enableHorizontalScrollbar!==r.scrollbars.NEVER,e.grid.isRTL()?e.grid.hasLeftContainerColumns()||(e.hasVScrollbar=e.grid.options.enableVerticalScrollbar!==r.scrollbars.NEVER):e.grid.hasRightContainerColumns()||(e.hasVScrollbar=e.grid.options.enableVerticalScrollbar!==r.scrollbars.NEVER)):"left"===e.name?e.hasVScrollbar=!!e.grid.isRTL()&&e.grid.options.enableVerticalScrollbar!==r.scrollbars.NEVER:e.hasVScrollbar=!e.grid.isRTL()&&e.grid.options.enableVerticalScrollbar!==r.scrollbars.NEVER,t["overflow-x"]=e.hasHScrollbar?i[e.grid.options.enableHorizontalScrollbar]:"hidden",t["overflow-y"]=e.hasVScrollbar?i[e.grid.options.enableVerticalScrollbar]:"hidden"),t},e}]),angular.module("ui.grid").factory("GridRow",["gridUtil","uiGridConstants",function(r,t){function e(e,t,i){this.grid=i,this.entity=e,this.index=t,this.uid=r.nextUid(),this.visible=!0,this.isSelected=!1,this.$$height=i.options.rowHeight}return Object.defineProperty(e.prototype,"height",{get:function(){return this.$$height},set:function(e){e!==this.$$height&&(this.grid.updateCanvasHeight(),this.$$height=e)}}),e.prototype.getQualifiedColField=function(e){return"row."+this.getEntityQualifiedColField(e)},e.prototype.getEntityQualifiedColField=function(e){return e.field===t.ENTITY_BINDING?"entity":r.preEval("entity."+e.field)},e.prototype.setRowInvisible=function(e){e&&e.setThisRowInvisible&&e.setThisRowInvisible("user")},e.prototype.clearRowInvisible=function(e){e&&e.clearThisRowInvisible&&e.clearThisRowInvisible("user")},e.prototype.setThisRowInvisible=function(e,t){this.invisibleReason||(this.invisibleReason={}),this.invisibleReason[e]=!0,this.evaluateRowVisibility(t)},e.prototype.clearThisRowInvisible=function(e,t){void 0!==this.invisibleReason&&delete this.invisibleReason[e],this.evaluateRowVisibility(t)},e.prototype.evaluateRowVisibility=function(e){var i=!0;void 0!==this.invisibleReason&&angular.forEach(this.invisibleReason,function(e,t){e&&(i=!1)}),void 0!==this.visible&&this.visible===i||(this.visible=i,e)||(this.grid.queueGridRefresh(),this.grid.api.core.raise.rowsVisibleChanged(this))},e}]),function(){"use strict";angular.module("ui.grid").factory("GridRowColumn",["$parse","$filter",function(e,t){function i(e,t){if(!(this instanceof i))throw"Using GridRowColumn as a function insead of as a constructor. Must be called with `new` keyword";this.row=e,this.col=t}return i.prototype.getIntersectionValueRaw=function(){return e(this.row.getEntityQualifiedColField(this.col))(this.row)},i}])}(),angular.module("ui.grid").factory("ScrollEvent",["gridUtil",function(o){function e(e,t,i,r){var n=this;if(!e)throw new Error("grid argument is required");n.grid=e,n.source=r,n.withDelay=!0,n.sourceRowContainer=t,n.sourceColContainer=i,n.newScrollLeft=null,n.newScrollTop=null,n.x=null,n.y=null,n.verticalScrollLength=-9999999,n.horizontalScrollLength=-999999,n.type="scroll",n.fireThrottledScrollingEvent=o.throttle(function(e){n.grid.scrollContainers(e,n)},n.grid.options.wheelScrollThrottle,{trailing:!0})}return e.prototype.getNewScrollLeft=function(e,t){var i=this;if(i.newScrollLeft)return i.newScrollLeft;var r,e=e.getCanvasWidth()-e.getViewportWidth(),t=o.normalizeScrollLeft(t,i.grid);if(void 0!==i.x.percentage&&void 0!==i.x.percentage)r=i.x.percentage;else{if(void 0===i.x.pixels||void 0===i.x.pixels)throw new Error("No percentage or pixel value provided for scroll event X axis");r=i.x.percentage=(t+i.x.pixels)/e}return Math.max(0,r*e)},e.prototype.getNewScrollTop=function(e,t){var i=this;if(i.newScrollTop)return i.newScrollTop;var r,e=e.getVerticalScrollLength(),t=t[0].scrollTop;if(void 0!==i.y.percentage&&void 0!==i.y.percentage)r=i.y.percentage;else{if(void 0===i.y.pixels||void 0===i.y.pixels)throw new Error("No percentage or pixel value provided for scroll event Y axis");r=i.y.percentage=(t+i.y.pixels)/e}return Math.max(0,r*e)},e.prototype.atTop=function(e){return this.y&&(0===this.y.percentage||this.verticalScrollLength<0)&&0===e},e.prototype.atBottom=function(e){return this.y&&(1===this.y.percentage||0===this.verticalScrollLength)&&0<e},e.prototype.atLeft=function(e){return this.x&&(0===this.x.percentage||this.horizontalScrollLength<0)&&0===e},e.prototype.atRight=function(e){return this.x&&(1===this.x.percentage||0===this.horizontalScrollLength)&&0<e},e.Sources={ViewPortScroll:"ViewPortScroll",RenderContainerMouseWheel:"RenderContainerMouseWheel",RenderContainerTouchMove:"RenderContainerTouchMove",Other:99},e}]),function(){"use strict";angular.module("ui.grid").service("gridClassFactory",["gridUtil","$q","$compile","$templateCache","uiGridConstants","Grid","GridColumn","GridRow",function(s,r,n,e,d,o,t,i){var a={createGrid:function(e){(e=void 0!==e?e:{}).id=s.newId();var t,i=new o(e);return i.options.rowTemplate&&(t=r.defer(),i.getRowTemplateFn=t.promise,s.getTemplate(i.options.rowTemplate).then(function(e){e=n(e);t.resolve(e)},function(){throw new Error("Couldn't fetch/use row template '"+i.options.rowTemplate+"'")}).catch(angular.noop)),i.registerColumnBuilder(a.defaultColumnBuilder),i.registerRowBuilder(a.rowTemplateAssigner),i.registerRowsProcessor(function(e){return e.forEach(function(e){e.evaluateRowVisibility(!0)}),e},50),i.registerColumnsProcessor(function(e){return e.forEach(function(e){e.visible=!angular.isDefined(e.colDef.visible)||e.colDef.visible}),e},50),i.registerRowsProcessor(i.searchRows,100),i.options.externalSort&&angular.isFunction(i.options.externalSort)?i.registerRowsProcessor(i.options.externalSort,200):i.registerRowsProcessor(i.sortByColumn,200),i},defaultColumnBuilder:function(o,a,e){function t(i,e,t,r,n){return o[i]?a[e]=o[i]:a[e]=t,t=s.getTemplate(a[e]).then(function(e){angular.isFunction(e)&&(e=e());var t="cellTooltip"===n?"col.cellTooltip(row,col)":"col.headerTooltip(col)";return n&&!1===a[n]?e=e.replace(d.TOOLTIP,""):n&&a[n]&&(e=e.replace(d.TOOLTIP,'title="{{'+t+' CUSTOM_FILTERS }}"')),r&&(e=e.replace(d.CUSTOM_FILTERS,function(){return a[r]?"|"+a[r]:""})),s.postProcessTemplate(e).then(function(e){a[i]=e})},function(){throw new Error("Couldn't fetch/use colDef."+i+" '"+o[i]+"'")}).catch(angular.noop),l.push(t),t}var l=[];return a.cellTemplatePromise=t("cellTemplate","providedCellTemplate","ui-grid/uiGridCell","cellFilter","cellTooltip"),a.headerCellTemplatePromise=t("headerCellTemplate","providedHeaderCellTemplate","ui-grid/uiGridHeaderCell","headerCellFilter","headerTooltip"),a.footerCellTemplatePromise=t("footerCellTemplate","providedFooterCellTemplate","ui-grid/uiGridFooterCell","footerCellFilter"),a.filterHeaderTemplatePromise=t("filterHeaderTemplate","providedFilterHeaderTemplate","ui-grid/ui-grid-filter"),a.compiledElementFnDefer=r.defer(),r.all(l)},rowTemplateAssigner:function(e){var t;return e.rowTemplate?(t=r.defer(),e.getRowTemplateFn=t.promise,s.getTemplate(e.rowTemplate).then(function(e){e=n(e);t.resolve(e)},function(){throw new Error("Couldn't fetch/use row template '"+e.rowTemplate+"'")})):(e.rowTemplate=this.options.rowTemplate,e.getRowTemplateFn=this.getRowTemplateFn),e.getRowTemplateFn}};return a}])}(),function(){function r(e){return e.replace(/[|\\{}()[\]^$+?*.]/g,"\\$&").replace(/-/g,"\\x2d")}angular.module("ui.grid").service("rowSearcher",["gridUtil","uiGridConstants",function(s,l){var i=l.filter.CONTAINS,d={getTerm:function(e){return void 0===e.term?e.term:"string"==typeof(e=e.term)?e.trim():e},stripTerm:function(e){e=d.getTerm(e);return"string"==typeof e?r(e.replace(/(^\*|\*$)/g,"")):e},guessCondition:function(e){var t;return void 0!==e.term&&e.term&&(t=d.getTerm(e),/\*/.test(t))?(e=e.flags&&e.flags.caseSensitive?"":"i",t=(t=r(t)).replace(/\\\*/g,".*?"),new RegExp("^"+t+"$",e)):i},setupFilters:function(e){for(var t=[],i=0;i<e.length;i++){var r=e[i];if(r.noTerm||!s.isNullOrUndefined(r.term)){var n={},o="";switch(r.flags&&r.flags.caseSensitive||(o+="i"),s.isNullOrUndefined(r.term)||(r.rawTerm?n.term=r.term:n.term=d.stripTerm(r)),n.noTerm=r.noTerm,n.condition=r.condition||d.guessCondition(r),n.flags=angular.extend({caseSensitive:!1,date:!1},r.flags),n.condition){case l.filter.STARTS_WITH:n.startswithRE=new RegExp("^"+n.term,o);break;case l.filter.ENDS_WITH:n.endswithRE=new RegExp(n.term+"$",o);break;case l.filter.EXACT:n.exactRE=new RegExp("^"+n.term+"$",o);break;case l.filter.CONTAINS:n.containsRE=new RegExp(n.term,o)}t.push(n)}}return t},runColumnFilter:function(e,t,i,r){var n=typeof r.condition,o=r.term,a=i.filterCellFiltered?e.getCellDisplayValue(t,i):e.getCellValue(t,i);if(null==a&&(a=""),r.condition instanceof RegExp)return r.condition.test(a);if("function"==n)return r.condition(o,a,t,i);if(r.startswithRE)return r.startswithRE.test(a);if(r.endswithRE)return r.endswithRE.test(a);if(r.containsRE)return r.containsRE.test(a);if(r.exactRE)return r.exactRE.test(a);if(r.condition===l.filter.NOT_EQUAL)return!new RegExp("^"+o+"$").test(a);switch("number"==typeof a&&"string"==typeof o&&(e=parseFloat(o.replace(/\\\./,".").replace(/\\\-/,"-")),isNaN(e)||(o=e)),!0===r.flags.date&&(a=new Date(a),o=new Date(o.replace(/\\/g,""))),r.condition){case l.filter.GREATER_THAN:return o<a;case l.filter.GREATER_THAN_OR_EQUAL:return o<=a;case l.filter.LESS_THAN:return a<o;case l.filter.LESS_THAN_OR_EQUAL:return a<=o}return!0},searchColumn:function(e,t,i,r){if(!e.options.useExternalFiltering)for(var n=0;n<r.length;n++){var o=r[n];if((!s.isNullOrUndefined(o.term)&&""!==o.term||o.noTerm)&&!d.runColumnFilter(e,t,i,o))return!1}return!0}};return d.search=function(e,l,t){if(l){if(e.options.enableFiltering){for(var i=[],r=0;r<t.length;r++){var n=t[r];void 0!==n.filters&&function(e){var t=!1;return e.forEach(function(e){(!s.isNullOrUndefined(e.term)&&""!==e.term||e.noTerm)&&(t=!0)}),t}(n.filters)&&i.push({col:n,filters:d.setupFilters(n.filters)})}if(0<i.length){function o(e,t){for(var i,r,n,o,a=0;a<l.length;a++)i=e,r=l[a],n=t.col,o=t.filters,r.visible&&!d.searchColumn(i,r,n,o)&&(r.visible=!1)}for(var a=0;a<i.length;a++)o(e,i[a]);e.api.core.raise.rowsVisibleChanged&&e.api.core.raise.rowsVisibleChanged()}}return l}},d}])}(),angular.module("ui.grid").service("rowSorter",["uiGridConstants",function(c){var u={colSortFnCache:{}};function n(e){return/^\s*-?Infinity\s*$/.test(e)?parseFloat(e):parseFloat(e.replace(/[^0-9.eE-]/g,""))}return u.guessSortFn=function(e){switch(e){case"number":return u.sortNumber;case"numberStr":return u.sortNumberStr;case"boolean":return u.sortBool;case"string":return u.sortAlpha;case"date":return u.sortDate;case"object":return u.basicSort;default:throw new Error("No sorting function found for type: "+e)}},u.handleNulls=function(e,t){return null==e||null==t?null==e&&null==t?0:null==e?1:-1:null},u.basicSort=function(e,t){var i=u.handleNulls(e,t);return null!==i?i:e===t?0:e<t?-1:1},u.sortNumber=function(e,t){var i=u.handleNulls(e,t);return null!==i?i:e-t},u.sortNumberStr=function(e,t){var i,r=u.handleNulls(e,t);return null!==r?r:(r=n(e),e=n(t),t=isNaN(r),i=isNaN(e),t||i?t&&i?0:t?1:-1:r-e)},u.sortAlpha=function(e,t){var i=u.handleNulls(e,t);return null!==i?i:(i=e.toString().toLowerCase())===(e=t.toString().toLowerCase())?0:i.localeCompare(e)},u.sortDate=function(e,t){var i=u.handleNulls(e,t);return null!==i?i:(i=(e instanceof Date?e:new Date(e)).getTime())===(e=(t instanceof Date?t:new Date(t)).getTime())?0:i<e?-1:1},u.sortBool=function(e,t){var i=u.handleNulls(e,t);return null!==i?i:e&&t||!e&&!t?0:e?1:-1},u.getSortFn=function(e){var t;return u.colSortFnCache[e.colDef.name]||(null!=e.sortingAlgorithm?(u.colSortFnCache[e.colDef.name]=e.sortingAlgorithm,e.sortingAlgorithm):e.sortCellFiltered&&e.cellFilter?(u.colSortFnCache[e.colDef.name]=u.sortAlpha,u.sortAlpha):(t=u.guessSortFn(e.colDef.type))?u.colSortFnCache[e.colDef.name]=t:u.sortAlpha)},u.prioritySort=function(e,t){return e.sort&&void 0!==e.sort.priority&&t.sort&&void 0!==t.sort.priority?e.sort.priority<t.sort.priority?-1:e.sort.priority===t.sort.priority?0:1:e.sort&&void 0!==e.sort.priority?-1:t.sort&&void 0!==t.sort.priority?1:0},u.sort=function(a,e,t){if(e){if(a.options.useExternalSorting)return e;var l,s,d=[],i=[];if(t.forEach(function(e){!e.sort||e.sort.ignoreSort||!e.sort.direction||e.sort.direction!==c.ASC&&e.sort.direction!==c.DESC?e.defaultSort&&e.defaultSort.direction&&(e.defaultSort.direction===c.ASC||e.defaultSort.direction===c.DESC)&&i.push({col:e,sort:e.defaultSort}):d.push({col:e,sort:e.sort})}),d=d.sort(u.prioritySort),i=i.sort(u.prioritySort),0===(d=d.concat(i)).length)return e;e.forEach(function(e,t){e.entity.$$uiGridIndex=t});t=e.sort(function(e,t){for(var i=0,r=0;0===i&&r<d.length;){l=d[r].col,s=d[r].sort.direction;var n=u.getSortFn(l),o=function(e,t,i,r){var n;t=r.sortCellFiltered?(n=e.getCellDisplayValue(t,r),e.getCellDisplayValue(i,r)):(n=e.getCellValue(t,r),e.getCellValue(i,r));return[n,t]}(a,e,t,l),i=n(o[0],o[1],e,t,s,l);r++}return 0===i?e.entity.$$uiGridIndex-t.entity.$$uiGridIndex:s===c.ASC?i:0-i});return e.forEach(function(e,t){delete e.entity.$$uiGridIndex}),t}},u}]),function(){var C,e=angular.module("ui.grid");function w(e){var t=e;return(t=void 0!==t.length&&t.length?e[0]:t).ownerDocument.defaultView.getComputedStyle(t,null)}"function"!=typeof Function.prototype.bind&&(C=function(){var r=Array.prototype.slice;return function(e){var t=this,i=r.call(arguments,1);return i.length?function(){return arguments.length?t.apply(e,i.concat(r.call(arguments))):t.apply(e,i)}:function(){return arguments.length?t.apply(e,arguments):t.call(e)}}});var l=new RegExp("^("+/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source+")(?!px)[a-z%]+$","i"),b=/^(block|none|table(?!-c[ea]).+)/,y={position:"absolute",visibility:"hidden",display:"block"};function S(e,t,i,r,n){for(var o=i===(r?"border":"content")?4:"width"===t?1:0,a=0,l=["Top","Right","Bottom","Left"];o<4;o+=2){var s,d,c=l[o];"margin"===i&&(s=parseFloat(n[i+c]),isNaN(s)||(a+=s)),r?("content"===i&&(s=parseFloat(n["padding"+c]),isNaN(s)||(a-=s)),"margin"!==i&&(d=parseFloat(n["border"+c+"Width"]),isNaN(d)||(a-=d))):(d=parseFloat(n["padding"+c]),isNaN(d)||(a+=d),"padding"!==i&&(c=parseFloat(n["border"+c+"Width"]),isNaN(c)||(a+=c)))}return a}function x(e,t,i){var r,n=!0,o=w(e),a="border-box"===o.boxSizing;if(r<=0||null==r){if(((r=o[t])<0||null==r)&&(r=e.style[t]),l.test(r))return r;n=a&&!0,r=parseFloat(r)||0}return r+S(0,t,i||(a?"border":"content"),n,o)}var E=["0","0","0","0"],A="uiGrid-";e.service("gridUtil",["$log","$window","$document","$http","$templateCache","$timeout","$interval","$injector","$q","$interpolate","uiGridConstants",function(t,n,i,e,r,s,d,o,a,l,c){var u,g,p,f={augmentWidthOrHeight:S,getStyles:w,createBoundedWrapper:function(e,t){return function(){return t.apply(e,arguments)}},readableColumnName:function(e){return null==e?e:(e="string"!=typeof e?String(e):e).replace(/_+/g," ").replace(/^[A-Z]+$/,function(e){return e.toLowerCase()}).replace(/([\w\u00C0-\u017F]+)/g,function(e){return e.charAt(0).toUpperCase()+e.slice(1)}).replace(/(\w+?(?=[A-Z]))/g,"$1 ")},getColumnsFromData:function(e,i){var r=[];if(!e||void 0===e[0]||void 0===e[0])return[];angular.isUndefined(i)&&(i=[]);e=e[0];return angular.forEach(e,function(e,t){-1===i.indexOf(t)&&r.push({name:t})}),r},newId:(u=(new Date).getTime(),function(){return u+=1}),getTemplate:function(t){if(r.get(t))return f.postProcessTemplate(r.get(t));if(angular.isFunction(t.then))return t.then(f.postProcessTemplate).catch(angular.noop);try{if(0<angular.element(t).length)return a.when(t).then(f.postProcessTemplate).catch(angular.noop)}catch(e){}return e({method:"GET",url:t}).then(function(e){e=e.data.trim();return r.put(t,e),e},function(e){throw new Error("Could not get template "+t+": "+e)}).then(f.postProcessTemplate).catch(angular.noop)},postProcessTemplate:function(e){var t=l.startSymbol(),i=l.endSymbol();return"{{"===t&&"}}"===i||(e=(e=e.replace(/\{\{/g,t)).replace(/\}\}/g,i)),a.when(e)},guessType:function(e){var t=typeof e;switch(t){case"number":case"boolean":case"string":return t;default:return angular.isDate(e)?"date":"object"}},elementWidth:function(e){},elementHeight:function(e){},isVisible:function(e){return!!(e[0].offsetWidth||e[0].offsetHeight||e[0].getClientRects().length)},getScrollbarWidth:function(){var e=document.createElement("div"),t=(e.style.visibility="hidden",e.style.width="100px",e.style.msOverflowStyle="scrollbar",document.body.appendChild(e),e.offsetWidth),i=(e.style.overflow="scroll",e.style.position="absolute",document.createElement("div")),i=(i.style.width="100%",e.appendChild(i),i.offsetWidth);return e.parentNode.removeChild(e),t-i},swap:function(e,t,i,r){var n,o={};for(n in t)o[n]=e.style[n],e.style[n]=t[n];for(n in i=i.apply(e,r||[]),t)e.style[n]=o[n];return i},fakeElement:function(e,t,i,r){var n,o=angular.element(e).clone()[0];for(n in t)o.style[n]=t[n];return angular.element(document.body).append(o),e=i.call(o,o),angular.element(o).remove(),e},normalizeWheelEvent:function(e){var t,i,r=e||window.event,n=([].slice.call(arguments,1),0),o=0,a=0;return(r=r.originalEvent?r.originalEvent:r).wheelDelta&&(n=r.wheelDelta),a=n=r.detail?-1*r.detail:n,void 0!==r.axis&&r.axis===r.HORIZONTAL_AXIS&&(a=0,o=-1*n),r.deltaY&&(n=a=-1*r.deltaY),r.deltaX&&(n=-1*(o=r.deltaX)),void 0!==r.wheelDeltaY&&(a=r.wheelDeltaY),void 0!==r.wheelDeltaX&&(o=r.wheelDeltaX),r=Math.abs(n),(!t||r<t)&&(t=r),r=Math.max(Math.abs(a),Math.abs(o)),(!i||r<i)&&(i=r),r=0<n?"floor":"ceil",{delta:n=Math[r](n/t),deltaX:o=Math[r](o/i),deltaY:a=Math[r](a/i)}},isTouchEnabled:function(){var e;return e="ontouchstart"in n||n.DocumentTouch&&i instanceof DocumentTouch?!0:e},isNullOrUndefined:function(e){return null==e},endsWith:function(e,t){return!(!e||!t||"string"!=typeof e)&&-1!==e.indexOf(t,e.length-t.length)},arrayContainsObjectWithProperty:function(e,t,i){var r=!1;return angular.forEach(e,function(e){e[t]===i&&(r=!0)}),r},numericAndNullSort:function(e,t){return null===e?1:null===t?-1:null===e&&null===t?0:e-t},disableAnimations:function(e){var t;try{t=o.get("$animate"),1<angular.version.major||1===angular.version.major&&4<=angular.version.minor?t.enabled(e,!1):t.enabled(!1,e)}catch(e){}},enableAnimations:function(e){var t;try{return t=o.get("$animate"),1<angular.version.major||1===angular.version.major&&4<=angular.version.minor?t.enabled(e,!0):t.enabled(!0,e),t}catch(e){}},nextUid:function(){for(var e,t=E.length;t;){if(57===(e=E[--t].charCodeAt(0)))return E[t]="A",A+E.join("");if(90!==e)return E[t]=String.fromCharCode(e+1),A+E.join("");E[t]="0"}return E.unshift("0"),A+E.join("")},hashKey:function(e){var t,i=typeof e;return"object"==i&&null!==e?"function"==typeof(t=e.$$hashKey)?t=e.$$hashKey():void 0!==e.$$hashKey&&e.$$hashKey?t=e.$$hashKey:void 0===t&&(t=e.$$hashKey=f.nextUid()):t=e,i+": "+t},resetUids:function(){E=["0","0","0"]},logError:function(e){c.LOG_ERROR_MESSAGES&&t.error(e)},logWarn:function(e){c.LOG_WARN_MESSAGES&&t.warn(e)},logDebug:function(){c.LOG_DEBUG_MESSAGES&&t.debug.apply(t,arguments)}},m=(f.focus={queue:[],byId:function(i,r){this._purgeQueue();var e=s(function(){var e=(r&&r.id?r.id+"-":"")+i,t=n.document.getElementById(e);t?t.focus():f.logWarn("[focus.byId] Element id "+e+" was not found.")},0,!1);return this.queue.push(e),e},byElement:function(e){if(!angular.isElement(e))return f.logWarn("Trying to focus on an element that isn't an element."),a.reject("not-element");e=angular.element(e),this._purgeQueue();var t=s(function(){e&&e[0].focus()},0,!1);return this.queue.push(t),t},bySelector:function(t,i,e){var r=this;if(!angular.isElement(t))throw new Error("The parent element is not an element.");t=angular.element(t);function n(){var e=t[0].querySelector(i);return r.byElement(e)}return this._purgeQueue(),e?(e=s(n,0,!1),this.queue.push(e),e):n()},_purgeQueue:function(){this.queue.forEach(function(e){s.cancel(e)}),this.queue=[]}},["width","height"].forEach(function(r){var i=r.charAt(0).toUpperCase()+r.substr(1);f["element"+i]=function(e,t){var i=e;return(i=i&&void 0!==i.length&&i.length?e[0]:i)&&null!==i?(e=w(i),0===i.offsetWidth&&b.test(e.display)?f.swap(i,y,function(){return x(i,r,t)}):x(i,r,t)):null},f["outerElement"+i]=function(e,t){return e?f["element"+i].call(this,e,t?"margin":"border"):null}}),f.closestElm=function(e,t){var i,r;for(void 0!==e.length&&e.length&&(e=e[0]),["matches","webkitMatchesSelector","mozMatchesSelector","msMatchesSelector","oMatchesSelector"].some(function(e){return"function"==typeof document.body[e]&&(i=e,!0)});null!==e;){if(null!==(r=e.parentElement)&&r[i](t))return r;e=r}return null},f.type=function(e){return Function.prototype.toString.call(e.constructor).match(/function (.*?)\(/)[1]},f.getBorderSize=function(e,t){e=w(e=void 0!==e.length&&e.length?e[0]:e),t=t?"border"+t.charAt(0).toUpperCase()+t.slice(1):"border",t+="Width",e=parseInt(e[t],10);return isNaN(e)?0:e},f.detectBrowser=function(){var e,t=n.navigator.userAgent,i={chrome:/chrome/i,safari:/safari/i,firefox:/firefox/i,ie:/internet explorer|trident\//i};for(e in i)if(i[e].test(t))return e;return"unknown"},f.rtlScrollType=function e(){var t,i;return e.type||(t=angular.element('<div dir="rtl" style="width: 1px; height: 1px; position: fixed; top: 0px; left: 0px; overflow: hidden"><div style="width: 2px"><span style="display: inline-block; width: 1px"></span><span style="display: inline-block; width: 1px"></span></div></div>')[0],i="reverse",document.body.appendChild(t),0<t.scrollLeft?i="default":"undefined"!=typeof Element&&Element.prototype.scrollIntoView?(t.children[0].children[1].scrollIntoView(),t.scrollLeft<0&&(i="negative")):(t.scrollLeft=1,0===t.scrollLeft&&(i="negative")),angular.element(t).remove(),e.type=i)},f.normalizeScrollLeft=function(e,t){var i=(e=void 0!==e.length&&e.length?e[0]:e).scrollLeft;if(t.isRTL())switch(f.rtlScrollType()){case"default":return e.scrollWidth-i-e.clientWidth;case"negative":return Math.abs(i);case"reverse":return i}return i},f.denormalizeScrollLeft=function(e,t,i){if(void 0!==e.length&&e.length&&(e=e[0]),i.isRTL())switch(f.rtlScrollType()){case"default":return e.scrollWidth-e.clientWidth-t;case"negative":return-1*t;case"reverse":return t}return t},f.preEval=function(e){var t,i=c.BRACKET_REGEXP.exec(e);return i?(i[1]&&f.preEval(i[1]))+i[2]+(i[3]&&f.preEval(i[3])):(i=(e=e.replace(c.APOS_REGEXP,"\\'")).split(c.DOT_REGEXP),t=[i.shift()],angular.forEach(i,function(e){t.push(e.replace(c.FUNC_REGEXP,"']$1"))}),t.join("['"))},f.debounce=function(t,i,r){var n,o,a,l;function e(){a=this,o=arguments;var e=r&&!n;return n&&s.cancel(n),n=s(function(){n=null,r||(l=t.apply(a,o))},i,!1),l=e?t.apply(a,o):l}return e.cancel=function(){s.cancel(n),n=null},e},f.throttle=function(t,i,r){r=r||{};var n,o,a=0,l=null;function s(e){a=+new Date,t.apply(n,o),d(function(){l=null},0,1,!1)}return function(){var e;n=this,o=arguments,null===l&&(e=+new Date-a,i<e?s():r.trailing&&(l=d(s,i-e,1,!1)))}},f.on={},f.off={},f._events={},f.addOff=function(i){f.off[i]=function(e,t){t=f._events[i].indexOf(t);0<t&&f._events[i].removeAt(t)}},"onwheel"in document||9<=document.documentMode?["wheel"]:["mousewheel","DomMouseScroll","MozMousePixelScroll"]);function h(e,t){var i,r=angular.element(this),n=0,o=0,a=0;"detail"in(t=t.originalEvent?t.originalEvent:t)&&(a=-1*t.detail),"wheelDelta"in t&&(a=t.wheelDelta),"wheelDeltaY"in t&&(a=t.wheelDeltaY),"wheelDeltaX"in t&&(o=-1*t.wheelDeltaX),"axis"in t&&t.axis===t.HORIZONTAL_AXIS&&(o=-1*a,a=0),n=0===a?o:a,"deltaY"in t&&(n=a=-1*t.deltaY),"deltaX"in t&&(o=t.deltaX,0===a)&&(n=-1*o),0===a&&0===o||(1===t.deltaMode?(n*=i=r.data("mousewheel-line-height"),a*=i,o*=i):2===t.deltaMode&&(n*=i=r.data("mousewheel-page-height"),a*=i,o*=i),i=Math.max(Math.abs(a),Math.abs(o)),(!p||i<p)&&(i=p=i,"mousewheel"===t.type)&&i%120==0&&(p/=40),n=Math[1<=n?"floor":"ceil"](n/p),o=Math[1<=o?"floor":"ceil"](o/p),a=Math[1<=a?"floor":"ceil"](a/p),n={originalEvent:t,deltaX:o,deltaY:a,deltaFactor:p,preventDefault:function(){t.preventDefault()},stopPropagation:function(){t.stopPropagation()}},g&&clearTimeout(g),g=setTimeout(v,200),e.call(r[0],n))}function v(){p=null}return f.on.mousewheel=function(e,t){if(e&&t){var i,r=angular.element(e),n=(r.data("mousewheel-line-height",(e=r,i=(i=(e=angular.element(e)[0]).parentElement)||document.getElementsByTagName("body")[0],parseInt(w(i).fontSize)||parseInt(w(e).fontSize)||16)),r.data("mousewheel-page-height",f.elementHeight(r)),r.data("mousewheel-callbacks")||r.data("mousewheel-callbacks",{}),r.data("mousewheel-callbacks"));n[t]=(Function.prototype.bind||C).call(h,r[0],t);for(var o=m.length;o;)r.on(m[--o],n[t]);r.on("$destroy",function(){for(var e=m.length;e;)r.off(m[--e],n[t])})}},f.off.mousewheel=function(e,t){var i=angular.element(e),e=i.data("mousewheel-callbacks"),r=e[t];if(r)for(var n=m.length;n;)i.off(m[--n],r);delete e[t],0===Object.keys(e).length&&(i.removeData("mousewheel-line-height"),i.removeData("mousewheel-page-height"),i.removeData("mousewheel-callbacks"))},f}]),e.filter("px",function(){return function(e){return e.match(/^[\d\.]+$/)?e+"px":e}})}(),function(){var u=["uiT","uiTranslate"],t=angular.module("ui.grid.i18n");function i(d,c){return{restrict:"EA",compile:function(){return{pre:function(e,t,i){var r,n,o=u[0],a=u[1],l=i[o]||i[a]||t.html();function s(e){e=d.getSafeText(e);t.html(e)}i.$$observers&&(n=i[o]?o:a,r=i.$observe(n,function(e){e&&s(e)})),n=e.$on(c.UPDATE_EVENT,function(){r?r(i[o]||i[a]):s(l)}),e.$on("$destroy",n),s(l)}}}}}function r(i){return function(e,t){return i.getSafeText(e,t)}}t.constant("i18nConstants",{MISSING:"[MISSING]",UPDATE_EVENT:"$uiI18n",LOCALE_DIRECTIVE_ALIAS:"uiI18n",DEFAULT_LANG:"en"}),t.service("i18nService",["$log","$parse","i18nConstants","$rootScope",function(t,r,i,n){var o={_langs:{},current:null,fallback:i.DEFAULT_LANG,get:function(e){var t=this,i=t.getFallbackLang();return e!==t.fallback?angular.extend({},t._langs[i],t._langs[e.toLowerCase()]):t._langs[e.toLowerCase()]},add:function(e,t){e=e.toLowerCase();this._langs[e]||(this._langs[e]={}),angular.merge(this._langs[e],t)},getAllLangs:function(){var e=[];if(this._langs)for(var t in this._langs)e.push(t);return e},setCurrent:function(e){this.current=e.toLowerCase()},setFallback:function(e){this.fallback=e.toLowerCase()},getCurrentLang:function(){return this.current},getFallbackLang:function(){return this.fallback.toLowerCase()}};function a(e){return t.warn(i.MISSING+e),""}var l={add:function(e,t){"object"==typeof e?angular.forEach(e,function(e){e&&o.add(e,t)}):o.add(e,t)},getAllLangs:function(){return o.getAllLangs()},get:function(e){e=e||l.getCurrentLang();return o.get(e)},getSafeText:function(e,t){var t=t||l.getCurrentLang(),t=o.get(t),i=r(e);return t&&i(t)||a(e)},setCurrentLang:function(e){e&&(o.setCurrent(e),n.$broadcast(i.UPDATE_EVENT))},setFallbackLang:function(e){e&&o.setFallback(e)},getCurrentLang:function(){var e=o.getCurrentLang();return e||(e=i.DEFAULT_LANG,o.setCurrent(e)),e},getFallbackLang:function(){return o.getFallbackLang()}};return l}]),t.directive("uiI18n",["i18nService","i18nConstants",function(o,a){return{compile:function(){return{pre:function(e,t,i){var r=a.LOCALE_DIRECTIVE_ALIAS,n=e.$eval(i[r]);n?e.$watch(i[r],function(){o.setCurrentLang(n)}):i.$$observers&&i.$observe(r,function(){o.setCurrentLang(i[r]||a.DEFAULT_LANG)})}}}}}]),angular.forEach(u,function(e){t.directive(e,["i18nService","i18nConstants",i])}),angular.forEach(["t","uiTranslate"],function(e){t.filter(e,["i18nService",r])})}(),function(){"use strict";var e=angular.module("ui.grid.edit",["ui.grid"]);e.constant("uiGridEditConstants",{EDITABLE_CELL_TEMPLATE:/EDITABLE_CELL_TEMPLATE/g,EDITABLE_CELL_DIRECTIVE:/editable_cell_directive/g,events:{BEGIN_CELL_EDIT:"uiGridEventBeginCellEdit",END_CELL_EDIT:"uiGridEventEndCellEdit",CANCEL_CELL_EDIT:"uiGridEventCancelCellEdit"}}),e.service("uiGridEditService",["$q","uiGridConstants","gridUtil",function(n,t,o){var i={initializeGrid:function(e){i.defaultGridOptions(e.options),e.registerColumnBuilder(i.editColumnBuilder),e.edit={};e.api.registerEventsFromObject({edit:{afterCellEdit:function(e,t,i,r){},beginCellEdit:function(e,t,i){},cancelCellEdit:function(e,t){}}})},defaultGridOptions:function(e){e.cellEditableCondition=void 0===e.cellEditableCondition||e.cellEditableCondition,e.enableCellEditOnFocus=void 0!==e.enableCellEditOnFocus&&e.enableCellEditOnFocus},editColumnBuilder:function(t,i,e){var r=[];return t.enableCellEdit=void 0===t.enableCellEdit?void 0===e.enableCellEdit?"object"!==t.type:e.enableCellEdit:t.enableCellEdit,t.cellEditableCondition=(void 0===t.cellEditableCondition?e:t).cellEditableCondition,t.enableCellEdit&&(t.editableCellTemplate=t.editableCellTemplate||e.editableCellTemplate||"ui-grid/cellEditor",r.push(o.getTemplate(t.editableCellTemplate).then(function(e){i.editableCellTemplate=e},function(e){throw new Error("Couldn't fetch/use colDef.editableCellTemplate '"+t.editableCellTemplate+"'")}))),t.enableCellEditOnFocus=(void 0===t.enableCellEditOnFocus?e:t).enableCellEditOnFocus,n.all(r)},isStartEditKey:function(e){return!(e.metaKey||e.keyCode===t.keymap.ESC||e.keyCode===t.keymap.SHIFT||e.keyCode===t.keymap.CTRL||e.keyCode===t.keymap.ALT||e.keyCode===t.keymap.WIN||e.keyCode===t.keymap.CAPSLOCK||e.keyCode===t.keymap.LEFT||e.keyCode===t.keymap.TAB&&e.shiftKey||e.keyCode===t.keymap.RIGHT||e.keyCode===t.keymap.TAB||e.keyCode===t.keymap.UP||e.keyCode===t.keymap.ENTER&&e.shiftKey||e.keyCode===t.keymap.DOWN||e.keyCode===t.keymap.ENTER)}};return i}]),e.directive("uiGridEdit",["gridUtil","uiGridEditService",function(e,n){return{replace:!0,priority:0,require:"^uiGrid",scope:!1,compile:function(){return{pre:function(e,t,i,r){n.initializeGrid(r.grid)},post:function(e,t,i,r){}}}}}]),e.directive("uiGridViewport",["uiGridEditConstants",function(o){return{replace:!0,priority:-99998,require:["^uiGrid","^uiGridRenderContainer"],scope:!1,compile:function(){return{post:function(e,t,i,r){var n=r[0];n.grid.api.edit&&n.grid.api.cellNav&&"body"===r[1].containerId&&(e.$on(o.events.CANCEL_CELL_EDIT,function(){n.focus()}),e.$on(o.events.END_CELL_EDIT,function(){n.focus()}))}}}}}]),e.directive("uiGridCell",["$compile","$injector","$timeout","uiGridConstants","uiGridEditConstants","gridUtil","$parse","uiGridEditService","$rootScope","$q",function(y,e,S,x,E,A,R,F,T,P){return e.has("uiGridCellNavService")&&e.get("uiGridCellNavService"),{priority:-100,restrict:"A",scope:!1,require:"?^uiGrid",link:function(l,s,e,r){var d,c,u,t,g,i,n,o,a,p=!1;function f(){s.on("dblclick",w),s.on("touchstart",m),r&&r.grid.api.cellNav&&(n=r.grid.api.cellNav.on.viewPortKeyDown(l,function(e,t){null===t||t.row!==l.row||t.col!==l.col||l.col.colDef.enableCellEditOnFocus||C(e)}),i=r.grid.api.cellNav.on.navigate(l,function(e,t,i){!l.col.colDef.enableCellEditOnFocus||e.row!==l.row||e.col!==l.col||null!==i&&(!i||"click"!==i.type&&"keydown"!==i.type)||S(function(){w(i)})})),l.beginEditEventsWired=!0}function m(e){void 0!==e.originalEvent&&void 0!==e.originalEvent&&(e=e.originalEvent),s.on("touchend",h),(t=S(function(){},500)).then(function(){setTimeout(w,0),s.off("touchend",h)}).catch(angular.noop)}function h(){S.cancel(t),s.off("touchend",h)}function v(){s.off("dblclick",w),s.off("keydown",C),s.off("touchstart",m),i(),n(),l.beginEditEventsWired=!1}function C(e){F.isStartEditKey(e)&&w(e)}function w(a){l.grid.api.core.scrollToIfNecessary(l.row,l.col).then(function(){var e=a;if(!p&&function(e,t,i){return!t.isSaving&&(angular.isFunction(e.colDef.cellEditableCondition)?e.colDef.cellEditableCondition(l,i):e.colDef.cellEditableCondition)}(l.col,l.row,e)){var t=l.row.getQualifiedColField(l.col),t=(l.col.colDef.editModelField&&(t=A.preEval("row.entity."+l.col.colDef.editModelField)),u=R(t),c=u(l),d=(d=(d=l.col.editableCellTemplate).replace(x.MODEL_COL_FIELD,t)).replace(x.COL_FIELD,"grid.getCellValue(row, col)"),l.col.colDef.editDropdownFilter?"|"+l.col.colDef.editDropdownFilter:""),i=(d=d.replace(x.CUSTOM_FILTERS,t),"text");switch(l.col.colDef.type){case"boolean":i="checkbox";break;case"number":i="number";break;case"date":i="date"}d=d.replace("INPUT_TYPE",i);var t=l.col.colDef.editDropdownOptionsFunction,t=(t?P.when(t(l.row.entity,l.col.colDef)).then(function(e){l.editDropdownOptionsArray=e}):(t=l.col.colDef.editDropdownRowEntityOptionsArrayPath,l.editDropdownOptionsArray=t?function(e,t){var i=(t=(t=t.replace(/\[(\w+)\]/g,".$1")).replace(/^\./,"")).split(".");for(;i.length;){var r=i.shift();if(!(r in e))return;e=e[r]}return e}(l.row.entity,t):l.col.colDef.editDropdownOptionsArray),l.editDropdownIdLabel=l.col.colDef.editDropdownIdLabel||"id",l.editDropdownValueLabel=l.col.colDef.editDropdownValueLabel||"value",function(){p=!0,v();var e=angular.element(d);s.append(e),g=l.$new(),y(e)(g),angular.element(s.children()[0]).addClass("ui-grid-cell-contents-hidden")}),r=(T.$$phase?t():l.$apply(t),l.col.grid.api.core.on.scrollBegin(l,function(){l.grid.disableScrolling||(b(),l.grid.api.edit.raise.afterCellEdit(l.row.entity,l.col.colDef,u(l),c),r(),n(),o())})),n=l.$on(E.events.END_CELL_EDIT,function(){b(),l.grid.api.edit.raise.afterCellEdit(l.row.entity,l.col.colDef,u(l),c),n(),r(),o()}),o=l.$on(E.events.CANCEL_CELL_EDIT,function(){l.grid.disableScrolling=!1,p&&(u.assign(l,c),l.$apply(),l.grid.api.edit.raise.cancelCellEdit(l.row.entity,l.col.colDef),b()),o(),r(),n()});l.$broadcast(E.events.BEGIN_CELL_EDIT,e),S(function(){l.grid.api.edit.raise.beginCellEdit(l.row.entity,l.col.colDef,e)})}})}function b(){if(l.grid.disableScrolling=!1,p){r&&r.grid.api.cellNav&&r.focus();for(var e=angular.element(s.children()[0]),t=(g.$destroy(),s.children()),i=1;i<t.length;i++)angular.element(t[i]).remove();e.removeClass("ui-grid-cell-contents-hidden"),p=!1,f(),l.grid.api.core.notifyDataChange(x.dataChange.EDIT)}}l.col.colDef.enableCellEdit&&(i=function(){},n=function(){},(o=function(){l.col.colDef.enableCellEdit&&!1!==l.row.enableCellEdit?l.beginEditEventsWired||f():l.beginEditEventsWired&&v()})(),a=l.$watch("row",function(e,t){e!==t&&o()}),l.$on("$destroy",function(){a(),s.off()}))}}}]),e.directive("uiGridEditor",["gridUtil","uiGridConstants","uiGridEditConstants","$timeout","uiGridEditService",function(e,l,s,d,c){return{scope:!0,require:["?^uiGrid","?^uiGridRenderContainer","ngModel"],compile:function(){return{pre:function(e,t,i){},post:function(t,i,e,r){var n,o,a;r[0]&&(n=r[0]),r[1]&&(o=r[1]),r[2]&&(a=r[2]),t.$on(s.events.BEGIN_CELL_EDIT,function(){var r;d(function(){if(i[0].focus(),!i[0].select||!t.col.colDef.enableCellEditOnFocus&&n&&n.grid.api.cellNav)try{i[0].setSelectionRange(i[0].value.length,i[0].value.length)}catch(e){}else i[0].select()}),n&&n.grid.api.cellNav&&(r=n.grid.api.cellNav.on.viewPortKeyPress(t,function(e,t){var i;c.isStartEditKey(e)&&0<(i="number"==typeof e.which?e.which:e.keyCode)&&(a.$setViewValue(String.fromCharCode(i),e),a.$render()),r()})),i.on("mousedown",function(e){"checkbox"===i[0].type&&(i.off("blur",t.stopEdit),d(function(){i[0].focus(),i.on("blur",t.stopEdit)}))}),i[0]&&i[0].focus(),i.on("blur",t.stopEdit)}),t.deepEdit=!1,t.stopEdit=function(e){t.inputForm&&!t.inputForm.$valid?(e.stopPropagation(),t.$emit(s.events.CANCEL_CELL_EDIT)):t.$emit(s.events.END_CELL_EDIT),t.deepEdit=!1},i.on("click",function(e){"checkbox"!==i[0].type&&(t.deepEdit=!0,t.$applyAsync(function(){t.grid.disableScrolling=!0}))}),i.on("keydown",function(e){if(e.keyCode===l.keymap.ESC&&(e.stopPropagation(),t.$emit(s.events.CANCEL_CELL_EDIT)),!t.deepEdit||e.keyCode!==l.keymap.LEFT&&e.keyCode!==l.keymap.RIGHT&&e.keyCode!==l.keymap.UP&&e.keyCode!==l.keymap.DOWN)if(n&&n.grid.api.cellNav)e.uiGridTargetRenderContainerId=o.containerId,null!==n.cellNav.handleKeyDown(e)&&t.stopEdit(e);else switch(e.keyCode){case l.keymap.ENTER:case l.keymap.TAB:e.stopPropagation(),e.preventDefault(),t.stopEdit(e)}else e.stopPropagation();return!0}),t.$on("$destroy",function(){i.off()})}}}}}]),e.directive("uiGridEditor",["$filter",function(n){return{priority:-100,require:"?ngModel",link:function(e,t,i,r){2===angular.version.minor&&i.type&&"date"===i.type&&r&&(r.$formatters.push(function(e){return r.$setValidity(null,!e||!isNaN(e.getTime())),n("date")(e,"yyyy-MM-dd")}),r.$parsers.push(function(e){var t,i;return e&&0<e.length?(t=void 0===(e=e)||""===e||3!==(e=e.split("-")).length||(t=parseInt(e[0],10),i=parseInt(e[1],10),e=parseInt(e[2],10),i<1)||t<1||e<1?null:new Date(t,i-1,e),r.$setValidity(null,t&&!isNaN(t.getTime())),t):(r.$setValidity(null,!0),null)}))}}}]),e.directive("uiGridEditDropdown",["uiGridConstants","uiGridEditConstants","$timeout",function(a,l,s){return{require:["?^uiGrid","?^uiGridRenderContainer"],scope:!0,compile:function(){return{pre:function(e,t,i){},post:function(t,e,i,r){var n=r[0],o=r[1];t.$on(l.events.BEGIN_CELL_EDIT,function(){s(function(){e[0].focus()}),e[0].style.width=e[0].parentElement.offsetWidth-1+"px",e.on("blur",function(e){t.stopEdit(e)})}),t.stopEdit=function(e){t.$emit(l.events.END_CELL_EDIT)},e.on("keydown",function(e){if(e.keyCode===a.keymap.ESC&&(e.stopPropagation(),t.$emit(l.events.CANCEL_CELL_EDIT)),n&&n.grid.api.cellNav)e.uiGridTargetRenderContainerId=o.containerId,null!==n.cellNav.handleKeyDown(e)&&t.stopEdit(e);else switch(e.keyCode){case a.keymap.ENTER:case a.keymap.TAB:e.stopPropagation(),e.preventDefault(),t.stopEdit(e)}return!0}),t.$on("$destroy",function(){e.off()})}}}}}]),e.directive("uiGridEditFileChooser",["gridUtil","uiGridConstants","uiGridEditConstants",function(n,e,o){return{scope:!0,require:["?^uiGrid","?^uiGridRenderContainer"],compile:function(){return{pre:function(e,t,i){},post:function(i,r){r[0].addEventListener("change",function e(t){t=t.srcElement||t.target;t&&t.files&&0<t.files.length?("function"==typeof i.col.colDef.editFileChooserCallback?i.col.colDef.editFileChooserCallback(i.row,i.col,t.files):n.logError("You need to set colDef.editFileChooserCallback to use the file chooser"),t.form.reset(),i.$emit(o.events.END_CELL_EDIT)):i.$emit(o.events.CANCEL_CELL_EDIT),r[0].removeEventListener("change",e,!1)},!1),i.$on(o.events.BEGIN_CELL_EDIT,function(){r[0].focus(),r[0].select(),r.on("blur",function(){i.$emit(o.events.END_CELL_EDIT),r.off()})})}}}}}])}(),function(){"use strict";var e=angular.module("ui.grid.emptyBaseLayer",["ui.grid"]);e.service("uiGridBaseLayerService",["gridUtil","$compile",function(e,t){return{initializeGrid:function(e,t){!(e.baseLayer={emptyRows:[]})!==e.options.enableEmptyGridBaseLayer&&(e.options.enableEmptyGridBaseLayer=!t)},setNumberOfEmptyRows:function(e,t){var i=t.options.rowHeight,r=Math.ceil(e/i);if(0<r){t.baseLayer.emptyRows=[];for(var n=0;n<r;n++)t.baseLayer.emptyRows.push({})}}}}]),e.directive("uiGridEmptyBaseLayer",["gridUtil","uiGridBaseLayerService","$parse",function(e,a,n){return{require:"^uiGrid",scope:!1,compile:function(){return{pre:function(e,t,i,r){i=!1===n(i.uiGridEmptyBaseLayer)(e);a.initializeGrid(r.grid,i)},post:function(e,t,i,r){var n,o;r.grid.options.enableEmptyGridBaseLayer&&(n=r.grid.renderContainers.body,o=n.getViewportHeight(),r.grid.registerStyleComputation({func:function(){var e;return(e=n.getViewportHeight())!==o&&(o=e,1)&&a.setNumberOfEmptyRows(o,r.grid),e=o,".grid"+r.grid.id+" .ui-grid-render-container .ui-grid-empty-base-layer-container.ui-grid-canvas { height: "+e+"px; }"}}))}}}}}]),e.directive("uiGridViewport",["$compile","gridUtil","$templateCache",function(e,t,i){return{priority:-200,scope:!1,compile:function(e){var t=i.get("ui-grid/emptyBaseLayerContainer");return e.prepend(t),{pre:function(e,t,i,r){},post:function(e,t,i,r){}}}}}])}(),function(){"use strict";var e=angular.module("ui.grid.expandable",["ui.grid"]);e.service("uiGridExpandableService",["gridUtil",function(r){var n={initializeGrid:function(i){i.expandable={},i.expandable.expandedAll=!1,i.options.enableOnDblClickExpand=!1!==i.options.enableOnDblClickExpand,i.options.enableExpandable=!1!==i.options.enableExpandable,i.options.showExpandAllButton=!1!==i.options.showExpandAllButton,i.options.expandableRowHeight=i.options.expandableRowHeight||150,i.options.expandableRowHeaderWidth=i.options.expandableRowHeaderWidth||40,i.options.enableExpandable&&!i.options.expandableRowTemplate&&(r.logError("You have not set the expandableRowTemplate, disabling expandable module"),i.options.enableExpandable=!1);var e={expandable:{rowExpandedBeforeStateChanged:function(e,t,i){},rowExpandedStateChanged:function(e,t,i){},rowExpandedRendered:function(e,t,i){}}},t={expandable:{toggleRowExpansion:function(e,t){e=i.getRow(e);null!==e&&n.toggleRowExpansion(i,e,t)},expandAllRows:function(){n.expandAllRows(i)},collapseAllRows:function(){n.collapseAllRows(i)},toggleAllRows:function(){n.toggleAllRows(i)},expandRow:function(e){e=i.getRow(e);null===e||e.isExpanded||n.toggleRowExpansion(i,e)},collapseRow:function(e){e=i.getRow(e);null!==e&&e.isExpanded&&n.toggleRowExpansion(i,e)},getExpandedRows:function(){return n.getExpandedRows(i).map(function(e){return e.entity})}}};i.api.registerEventsFromObject(e),i.api.registerMethodsFromObject(t)},toggleRowExpansion:function(t,i,r){t.api.expandable.raise.rowExpandedBeforeStateChanged(i),i.isExpanded=!i.isExpanded,angular.isUndefined(i.expandedRowHeight)&&(i.expandedRowHeight=t.options.expandableRowHeight),i.isExpanded?(i.height=i.grid.options.rowHeight+i.expandedRowHeight,t.expandable.expandedAll=n.getExpandedRows(t).length===t.rows.length):(i.height=i.grid.options.rowHeight,t.expandable.expandedAll=!1),t.api.expandable.raise.rowExpandedStateChanged(i,r),function e(){i.expandedRendered?t.api.expandable.raise.rowExpandedRendered(i,r):window.setTimeout(e,100)}()},expandAllRows:function(t){t.renderContainers.body.visibleRowCache.forEach(function(e){e.isExpanded||e.entity.subGridOptions&&e.entity.subGridOptions.disableRowExpandable||n.toggleRowExpansion(t,e)}),t.expandable.expandedAll=!0,t.queueGridRefresh()},collapseAllRows:function(t){t.renderContainers.body.visibleRowCache.forEach(function(e){e.isExpanded&&n.toggleRowExpansion(t,e)}),t.expandable.expandedAll=!1,t.queueGridRefresh()},toggleAllRows:function(e){e.expandable.expandedAll?n.collapseAllRows(e):n.expandAllRows(e)},getExpandedRows:function(e){return e.rows.filter(function(e){return e.isExpanded})}};return n}]),e.directive("uiGridExpandable",["uiGridExpandableService","$templateCache",function(o,a){return{replace:!0,priority:0,require:"^uiGrid",scope:!1,compile:function(){return{pre:function(e,t,i,r){var n;o.initializeGrid(r.grid),r.grid.options.enableExpandable&&!1!==r.grid.options.enableExpandableRowHeader&&((n={name:"expandableButtons",displayName:"",exporterSuppressExport:!0,enableColumnResizing:!1,enableColumnMenu:!1,width:r.grid.options.expandableRowHeaderWidth||30}).cellTemplate=a.get("ui-grid/expandableRowHeader"),n.headerCellTemplate=a.get("ui-grid/expandableTopRowHeader"),r.grid.addRowHeaderColumn(n,-90))},post:function(e,t,i,r){}}}}}]),e.directive("uiGrid",function(){return{replace:!0,priority:599,require:"^uiGrid",scope:!1,compile:function(){return{pre:function(e,t,i,r){r.grid.api.core.on.renderingComplete(e,function(){e.row&&e.row.grid&&e.row.grid.options&&e.row.grid.options.enableExpandable&&(r.grid.parentRow=e.row)})},post:function(e,t,i,r){}}}}}),e.directive("uiGridExpandableRow",["uiGridExpandableService","$compile","uiGridConstants","gridUtil",function(e,o,t,i){return{replace:!1,priority:0,scope:!1,compile:function(){return{pre:function(r,n){i.getTemplate(r.grid.options.expandableRowTemplate).then(function(e){if(r.grid.options.expandableRowScope){var t,i=r.grid.options.expandableRowScope;for(t in i)i.hasOwnProperty(t)&&(r[t]=i[t])}e=angular.element(e),e=o(e)(r);n.append(e),r.row.element=n,r.row.expandedRendered=!0})},post:function(e,t){e.row.element=t,e.$on("$destroy",function(){e.row.expandedRendered=!1})}}}}}]),e.directive("uiGridRow",function(){return{priority:-200,scope:!1,compile:function(){return{pre:function(t,e){t.grid.options.enableExpandable&&(t.expandableRow={},t.expandableRow.shouldRenderExpand=function(){return"body"===t.colContainer.name&&!1!==t.grid.options.enableExpandable&&t.row.isExpanded&&(!t.grid.isScrollingVertically||t.row.expandedRendered)},t.expandableRow.shouldRenderFiller=function(){return t.row.isExpanded&&("body"!==t.colContainer.name||t.grid.isScrollingVertically&&!t.row.expandedRendered)},t.grid.options.enableOnDblClickExpand)&&e.on("dblclick",function(e){t.grid.api.expandable.toggleRowExpansion(t.row.entity,e)})},post:function(e,t,i,r){}}}}}),e.directive("uiGridViewport",["$compile","gridUtil","$templateCache",function(e,t,r){return{priority:-200,scope:!1,compile:function(e){var e=angular.element(e.children().children()[0]),t=r.get("ui-grid/expandableScrollFiller"),i=r.get("ui-grid/expandableRow");return e.append(i),e.append(t),{pre:function(e,t,i,r){},post:function(e,t,i,r){}}}}}])}(),function(){"use strict";var e=angular.module("ui.grid.exporter",["ui.grid"]);e.constant("uiGridExporterConstants",{featureName:"exporter",rowHeaderColName:"treeBaseRowHeaderCol",selectionRowHeaderColName:"selectionRowHeaderCol",ALL:"all",VISIBLE:"visible",SELECTED:"selected",CSV_CONTENT:"CSV_CONTENT",BUTTON_LABEL:"BUTTON_LABEL",FILE_NAME:"FILE_NAME"}),e.service("uiGridExporterService",["$filter","$q","uiGridExporterConstants","gridUtil","$compile","$interval","i18nService",function(a,r,u,c,e,n,t){var g={delay:100,type:null,initializeGrid:function(i){i.exporter={},this.defaultGridOptions(i.options);var e={exporter:{}},t={exporter:{csvExport:function(e,t){g.csvExport(i,e,t)},pdfExport:function(e,t){g.pdfExport(i,e,t)},excelExport:function(e,t){g.excelExport(i,e,t)}}};i.api.registerEventsFromObject(e),i.api.registerMethodsFromObject(t),i.api.core.addToGridMenu?g.addToMenu(i):n(function(){i.api.core.addToGridMenu&&g.addToMenu(i)},this.delay,1)},defaultGridOptions:function(e){e.exporterSuppressMenu=!0===e.exporterSuppressMenu,e.exporterMenuLabel=e.exporterMenuLabel||"Export",e.exporterSuppressColumns=e.exporterSuppressColumns||[],e.exporterCsvColumnSeparator=e.exporterCsvColumnSeparator||",",e.exporterCsvFilename=e.exporterCsvFilename||"download.csv",e.exporterPdfFilename=e.exporterPdfFilename||"download.pdf",e.exporterExcelFilename=e.exporterExcelFilename||"download.xlsx",e.exporterExcelSheetName=e.exporterExcelSheetName||"Sheet1",e.exporterOlderExcelCompatibility=!0===e.exporterOlderExcelCompatibility,e.exporterIsExcelCompatible=!0===e.exporterIsExcelCompatible,e.exporterMenuItemOrder=e.exporterMenuItemOrder||200,e.exporterPdfDefaultStyle=e.exporterPdfDefaultStyle||{fontSize:11},e.exporterPdfTableStyle=e.exporterPdfTableStyle||{margin:[0,5,0,15]},e.exporterPdfTableHeaderStyle=e.exporterPdfTableHeaderStyle||{bold:!0,fontSize:12,color:"black"},e.exporterPdfHeader=e.exporterPdfHeader||null,e.exporterPdfFooter=e.exporterPdfFooter||null,e.exporterPdfOrientation=e.exporterPdfOrientation||"landscape",e.exporterPdfPageSize=e.exporterPdfPageSize||"A4",e.exporterPdfMaxGridWidth=e.exporterPdfMaxGridWidth||720,e.exporterMenuAllData=void 0===e.exporterMenuAllData||e.exporterMenuAllData,e.exporterMenuVisibleData=void 0===e.exporterMenuVisibleData||e.exporterMenuVisibleData,e.exporterMenuSelectedData=void 0===e.exporterMenuSelectedData||e.exporterMenuSelectedData,e.exporterMenuCsv=void 0===e.exporterMenuCsv||e.exporterMenuCsv,e.exporterMenuPdf=void 0===e.exporterMenuPdf||e.exporterMenuPdf,e.exporterMenuExcel=void 0===e.exporterMenuExcel||e.exporterMenuExcel,e.exporterPdfCustomFormatter=e.exporterPdfCustomFormatter&&"function"==typeof e.exporterPdfCustomFormatter?e.exporterPdfCustomFormatter:function(e){return e},e.exporterHeaderFilterUseName=!0===e.exporterHeaderFilterUseName,e.exporterFieldCallback=e.exporterFieldCallback||i,e.exporterFieldFormatCallback=e.exporterFieldFormatCallback||function(e,t,i,r){return null},e.exporterExcelCustomFormatters=e.exporterExcelCustomFormatters||function(e,t,i){return i},e.exporterExcelHeader=e.exporterExcelHeader||function(e,t,i,r){return null},e.exporterColumnScaleFactor=e.exporterColumnScaleFactor||3.5,e.exporterFieldApplyFilters=!0===e.exporterFieldApplyFilters,e.exporterAllDataFn=e.exporterAllDataFn||null,null===e.exporterAllDataFn&&e.exporterAllDataPromise&&(e.exporterAllDataFn=e.exporterAllDataPromise)},addToMenu:function(e){e.api.core.addToGridMenu(e,[{title:t.getSafeText("gridMenu.exporterAllAsCsv"),action:function(){e.api.exporter.csvExport(u.ALL,u.ALL)},shown:function(){return e.options.exporterMenuCsv&&e.options.exporterMenuAllData},order:e.options.exporterMenuItemOrder},{title:t.getSafeText("gridMenu.exporterVisibleAsCsv"),action:function(){e.api.exporter.csvExport(u.VISIBLE,u.VISIBLE)},shown:function(){return e.options.exporterMenuCsv&&e.options.exporterMenuVisibleData},order:e.options.exporterMenuItemOrder+1},{title:t.getSafeText("gridMenu.exporterSelectedAsCsv"),action:function(){e.api.exporter.csvExport(u.SELECTED,u.VISIBLE)},shown:function(){return e.options.exporterMenuCsv&&e.options.exporterMenuSelectedData&&e.api.selection&&0<e.api.selection.getSelectedRows().length},order:e.options.exporterMenuItemOrder+2},{title:t.getSafeText("gridMenu.exporterAllAsPdf"),action:function(){e.api.exporter.pdfExport(u.ALL,u.ALL)},shown:function(){return e.options.exporterMenuPdf&&e.options.exporterMenuAllData},order:e.options.exporterMenuItemOrder+3},{title:t.getSafeText("gridMenu.exporterVisibleAsPdf"),action:function(){e.api.exporter.pdfExport(u.VISIBLE,u.VISIBLE)},shown:function(){return e.options.exporterMenuPdf&&e.options.exporterMenuVisibleData},order:e.options.exporterMenuItemOrder+4},{title:t.getSafeText("gridMenu.exporterSelectedAsPdf"),action:function(){e.api.exporter.pdfExport(u.SELECTED,u.VISIBLE)},shown:function(){return e.options.exporterMenuPdf&&e.options.exporterMenuSelectedData&&e.api.selection&&0<e.api.selection.getSelectedRows().length},order:e.options.exporterMenuItemOrder+5},{title:t.getSafeText("gridMenu.exporterAllAsExcel"),action:function(){e.api.exporter.excelExport(u.ALL,u.ALL)},shown:function(){return e.options.exporterMenuExcel&&e.options.exporterMenuAllData},order:e.options.exporterMenuItemOrder+6},{title:t.getSafeText("gridMenu.exporterVisibleAsExcel"),action:function(){e.api.exporter.excelExport(u.VISIBLE,u.VISIBLE)},shown:function(){return e.options.exporterMenuExcel&&e.options.exporterMenuVisibleData},order:e.options.exporterMenuItemOrder+7},{title:t.getSafeText("gridMenu.exporterSelectedAsExcel"),action:function(){e.api.exporter.excelExport(u.SELECTED,u.VISIBLE)},shown:function(){return e.options.exporterMenuExcel&&e.options.exporterMenuSelectedData&&e.api.selection&&0<e.api.selection.getSelectedRows().length},order:e.options.exporterMenuItemOrder+8}])},csvExport:function(i,r,n){var o=this;o.type="csv",this.loadAllDataIfNeeded(i,r,n).then(function(){var e=i.options.showHeader?o.getColumnHeaders(i,n):[],t=o.getData(i,r,n),e=o.formatAsCsv(e,t,i.options.exporterCsvColumnSeparator),t=angular.isFunction(i.options.exporterCsvFilename)?i.options.exporterCsvFilename(i,r,n):i.options.exporterCsvFilename;o.downloadFile(t,e,i.options.exporterCsvColumnSeparator,i.options.exporterOlderExcelCompatibility,i.options.exporterIsExcelCompatible)})},loadAllDataIfNeeded:function(t,e,i){return e===u.ALL&&t.rows.length!==t.options.totalItems&&t.options.exporterAllDataFn?t.options.exporterAllDataFn().then(function(e){t.modifyRows(e)}):((e=r.defer()).resolve(),e.promise)},getColumnHeaders:function(t,e){var i,r,n=[];return(e===u.ALL?t.columns:(e=t.renderContainers.left?t.renderContainers.left.visibleColumnCache.filter(function(e){return e.visible}):[],i=t.renderContainers.body?t.renderContainers.body.visibleColumnCache.filter(function(e){return e.visible}):[],r=t.renderContainers.right?t.renderContainers.right.visibleColumnCache.filter(function(e){return e.visible}):[],e.concat(i,r))).forEach(function(e){!0!==e.colDef.exporterSuppressExport&&"$$hashKey"!==e.field&&-1===t.options.exporterSuppressColumns.indexOf(e.name)&&(e={name:e.field,displayName:function(e,t){if(e.options.exporterHeaderFilter)return e.options.exporterHeaderFilterUseName?e.options.exporterHeaderFilter(t.name):e.options.exporterHeaderFilter(t.displayName);return t.headerCellFilter?a(t.headerCellFilter)(t.displayName):t.displayName}(t,e),width:e.drawnWidth||e.width,align:e.colDef.align||("number"===e.colDef.type?"right":"left")},n.push(e))}),n},getRowsFromNode:function(e){var t=[],i=e?Object.keys(e):["children"];if((1<i.length||"children"!=i[0])&&t.push(e),e&&e.children&&0<e.children.length)for(var r=0;r<e.children.length;r++)t=t.concat(this.getRowsFromNode(e.children[r]));return t},getDataSorted:function(e){if(!e.treeBase||0===e.treeBase.numberLevels)return e.rows;for(var t=[],i=0;i<e.treeBase.tree.length;i++)for(var r=this.getRowsFromNode(e.treeBase.tree[i]),n=0;n<r.length;n++)t.push(r[n].row);return t},getData:function(o,e,a,l){var t,i,r,n,s,d=[];switch(e){case u.ALL:t=this.getDataSorted(o,e,a,l);break;case u.VISIBLE:t=o.getVisibleRows();break;case u.SELECTED:o.api.selection?t=o.api.selection.getSelectedGridRows():c.logError("selection feature must be enabled to allow selected rows to be exported")}return s=a===u.ALL?o.columns:(i=o.renderContainers.left?o.renderContainers.left.visibleColumnCache.filter(function(e){return e.visible}):[],r=o.renderContainers.body?o.renderContainers.body.visibleColumnCache.filter(function(e){return e.visible}):[],n=o.renderContainers.right?o.renderContainers.right.visibleColumnCache.filter(function(e){return e.visible}):[],i.concat(r,n)),t.forEach(function(r){var n;!1!==r.exporterEnableExporting&&(n=[],s.forEach(function(e){var t,i;!e.visible&&a!==u.ALL||!0===e.colDef.exporterSuppressExport||"$$hashKey"===e.field||-1!==o.options.exporterSuppressColumns.indexOf(e.name)||(i=l?o.getCellDisplayValue(r,e):o.getCellValue(r,e),t={value:o.options.exporterFieldCallback(o,r,e,i,g.type)},(i=o.options.exporterFieldFormatCallback(o,r,e,i,g.type))&&Object.assign(t,i),e.colDef.exporterPdfAlign&&(t.alignment=e.colDef.exporterPdfAlign),n.push(t))}),d.push(n))}),d},formatAsCsv:function(e,t,i){e=e.map(function(e){return{value:e.displayName}}),e=0<e.length?this.formatRowAsCsv(this,i)(e)+"\n":"";return e+=t.map(this.formatRowAsCsv(this,i)).join("\n")},formatRowAsCsv:function(t,i){return function(e){return e.map(t.formatFieldAsCsv).join(i)}},formatFieldAsCsv:function(e){return null==e.value?"":"number"==typeof e.value?e.value:"boolean"==typeof e.value?e.value?"TRUE":"FALSE":"string"==typeof e.value?'"'+e.value.replace(/"/g,'""')+'"':"object"!=typeof e.value||e.value instanceof Date?JSON.stringify(e.value):'"'+JSON.stringify(e.value).replace(/"/g,'""')+'"'},isIE:function(){return-1!==navigator.userAgent.search(/(?:Edge|MSIE|Trident\/.*; rv:)/)?!0:!1},downloadFile:function(e,t,i,r,n){var o,a=document,l=a.createElement("a"),s="application/octet-stream;charset=utf-8",d=this.isIE();return n&&(t="sep="+i+"\r\n"+t),navigator.msSaveBlob?navigator.msSaveOrOpenBlob(new Blob([r?"\ufeff":"",t],{type:s}),e):d?(n=a.createElement("iframe"),document.body.appendChild(n),n.contentWindow.document.open("text/html","replace"),n.contentWindow.document.write(t),n.contentWindow.document.close(),n.contentWindow.focus(),n.contentWindow.document.execCommand("SaveAs",!0,e),document.body.removeChild(n),!0):("download"in l?(i=new Blob([r?"\ufeff":"",t],{type:s}),o=URL.createObjectURL(i),l.setAttribute("download",e)):(o="data: "+s+","+encodeURIComponent(t),l.setAttribute("target","_blank")),l.href=o,l.setAttribute("style","display:none;"),a.body.appendChild(l),void setTimeout(function(){var e;l.click?l.click():document.createEvent&&((e=document.createEvent("MouseEvents")).initEvent("click",!0,!0),l.dispatchEvent(e)),a.body.removeChild(l)},this.delay))},pdfExport:function(i,r,n){var o=this;o.type="pdf",this.loadAllDataIfNeeded(i,r,n).then(function(){var e=o.getColumnHeaders(i,n),t=o.getData(i,r,n),e=o.prepareAsPdf(i,e,t);o.isIE()||-1!==navigator.appVersion.indexOf("Edge")?(t=angular.isFunction(i.options.exporterPdfFilename)?i.options.exporterPdfFilename(i,r,n):i.options.exporterPdfFilename,o.downloadPDF(t,e)):pdfMake.createPdf(e).open()})},downloadPDF:function(t,e){var i,r=document,n=(r.createElement("a"),this.isIE());pdfMake.createPdf(e).getBuffer(function(e){return i=new Blob([e]),navigator.msSaveBlob?navigator.msSaveBlob(i,t):n?(e=r.createElement("iframe"),document.body.appendChild(e),e.contentWindow.document.open("text/html","replace"),e.contentWindow.document.write(i),e.contentWindow.document.close(),e.contentWindow.focus(),e.contentWindow.document.execCommand("SaveAs",!0,t),document.body.removeChild(e),!0):void 0})},prepareAsPdf:function(e,t,i){var r=this.calculatePdfHeaderWidths(e,t),t=t.map(function(e){return{text:e.displayName,style:"tableHeader"}}),i=i.map(this.formatRowAsPdf(this)),t=[t].concat(i),i={pageOrientation:e.options.exporterPdfOrientation,pageSize:e.options.exporterPdfPageSize,content:[{style:"tableStyle",table:{headerRows:1,widths:r,body:t}}],styles:{tableStyle:e.options.exporterPdfTableStyle,tableHeader:e.options.exporterPdfTableHeaderStyle},defaultStyle:e.options.exporterPdfDefaultStyle};return e.options.exporterPdfLayout&&(i.layout=e.options.exporterPdfLayout),e.options.exporterPdfHeader&&(i.header=e.options.exporterPdfHeader),e.options.exporterPdfFooter&&(i.footer=e.options.exporterPdfFooter),i=e.options.exporterPdfCustomFormatter?e.options.exporterPdfCustomFormatter(i):i},calculatePdfHeaderWidths:function(t,e){var i=0,r=(e.forEach(function(e){"number"==typeof e.width&&(i+=e.width)}),0),n=(e.forEach(function(e){var t;"*"===e.width&&(r+=100),"string"==typeof e.width&&e.width.match(/(\d)*%/)&&(t=parseInt(e.width.match(/(\d)*%/)[0]),e.width=i*t/100,r+=e.width)}),i+r);return e.map(function(e){return"*"===e.width?e.width:e.width*t.options.exporterPdfMaxGridWidth/n})},formatRowAsPdf:function(t){return function(e){return e.map(t.formatFieldAsPdfString)}},formatFieldAsPdfString:function(e){var t=null==e.value?"":"number"==typeof e.value?e.value.toString():"boolean"==typeof e.value?e.value?"TRUE":"FALSE":"string"==typeof e.value?e.value.replace(/"/g,'""'):!(e.value instanceof Date)&&"object"==typeof e.value?e.value:JSON.stringify(e.value).replace(/^"/,"").replace(/"$/,"");return t=e.alignment&&"string"==typeof e.alignment?{text:t,alignment:e.alignment}:t},formatAsExcel:function(e,t,i,r,n){for(var o=e.map(function(e){return{value:e.displayName}}),a=[],l=[],s=0;s<o.length;s++){var d="header";switch(e[s].align){case"center":d="headerCenter";break;case"right":d="headerRight"}var c=n.styles&&n.styles[d]?{style:n.styles[d].id}:null;l.push({value:o[s].value,metadata:c})}a.push(l);for(var u=t.map(this.formatRowAsExcel(this,i,r)),g=0;g<u.length;g++)a.push(u[g]);return a},formatRowAsExcel:function(n,o,a){return function(e){for(var t=[],i=0;i<e.length;i++){var r=n.formatFieldAsExcel(e[i],o,a);t.push({value:r,metadata:e[i].metadata})}return t}},formatFieldAsExcel:function(e,t,i,r){return null==e.value?"":"number"==typeof e.value||"string"==typeof e.value?e.value:"boolean"==typeof e.value?e.value?"TRUE":"FALSE":JSON.stringify(e.value)},prepareAsExcel:function(e,t,i){var r={styles:{}};return e.options.exporterExcelCustomFormatters&&(r=e.options.exporterExcelCustomFormatters(e,t,r)),e.options.exporterExcelHeader&&(angular.isFunction(e.options.exporterExcelHeader)?e.options.exporterExcelHeader(e,t,i,r):(t=e.options.exporterExcelHeader.text,e=e.options.exporterExcelHeader.style,i.data.push([{value:t,metadata:{style:r.styles[e].id}}]))),r},excelExport:function(l,s,d){var c=this;c.type="excel",this.loadAllDataIfNeeded(l,s,d).then(function(){for(var e=l.options.showHeader?c.getColumnHeaders(l,d):[],t="Sheet1",t=(l.options.exporterExcelSheetName&&(t=angular.isFunction(l.options.exporterExcelSheetName)?l.options.exporterExcelSheetName(l,s,d):l.options.exporterExcelSheetName),new ExcelBuilder.Worksheet({name:t})),i=new ExcelBuilder.Workbook,r=(i.addWorksheet(t),c.prepareAsExcel(l,i,t)),n=[],o=l.treeBase?l.treeBase.numberLevels:l.enableRowSelection?1:0;o<l.columns.length;o++)l.columns[o].field!==u.rowHeaderColName&&l.columns[o].field!==u.selectionRowHeaderColName&&n.push({width:l.columns[o].drawnWidth/l.options.exporterColumnScaleFactor});t.setColumns(n);var a=c.getData(l,s,d,l.options.exporterFieldApplyFilters),e=c.formatAsExcel(e,a,i,t,r);t.setData(t.data.concat(e)),ExcelBuilder.Builder.createFile(i,{type:"blob"}).then(function(e){var t=angular.isFunction(l.options.exporterExcelFilename)?l.options.exporterExcelFilename(l,s,d):l.options.exporterExcelFilename;c.downloadFile(t,e,l.options.exporterCsvColumnSeparator,l.options.exporterOlderExcelCompatibility)})})}};function i(e,t,i,r){var n,o;return i.cellFilter?(n=(i=i.cellFilter.match(/(?:[^:"]+|"[^"]*")+/g))[0]?i[0].replace(/[\'\"\s]/g,""):null,o=i[1]?i[1].replace(/[\'\"]/g,"").trim():null,i=i[2]?i[2].replace(/[\'\"\s]/g,""):null,a(n)(r,o,i)):r}return g}]),e.directive("uiGridExporter",["uiGridExporterConstants","uiGridExporterService","gridUtil","$compile",function(e,n,t,i){return{replace:!0,priority:0,require:"^uiGrid",scope:!1,link:function(e,t,i,r){n.initializeGrid(r.grid),r.grid.exporter.$scope=e}}}])}(),function(){"use strict";var e=angular.module("ui.grid.grouping",["ui.grid","ui.grid.treeBase"]);e.constant("uiGridGroupingConstants",{featureName:"grouping",rowHeaderColName:"treeBaseRowHeaderCol",EXPANDED:"expanded",COLLAPSED:"collapsed",aggregation:{COUNT:"count",SUM:"sum",MAX:"max",MIN:"min",AVG:"avg"}}),e.service("uiGridGroupingService",["$q","uiGridGroupingConstants","gridUtil","rowSorter","GridRow","gridClassFactory","i18nService","uiGridConstants","uiGridTreeBaseService",function(e,a,l,s,u,g,d,r,c){var p={initializeGrid:function(r,e){c.initializeGrid(r,e),r.grouping={},r.grouping.groupHeaderCache={},p.defaultGridOptions(r.options),r.registerRowsProcessor(p.groupRows,400),r.registerColumnBuilder(p.groupingColumnBuilder),r.registerColumnsProcessor(p.groupingColumnProcessor,400);var t={grouping:{aggregationChanged:{},groupingChanged:{}}},i={grouping:{getGrouping:function(e){var t=p.getGrouping(r);return t.grouping.forEach(function(e){e.colName=e.col.name,delete e.col}),t.aggregations.forEach(function(e){e.colName=e.col.name,delete e.col}),t.aggregations=t.aggregations.filter(function(e){return!e.aggregation.source||"grouping"!==e.aggregation.source}),e&&(t.rowExpandedStates=p.getRowExpandedStates(r.grouping.groupingHeaderCache)),t},setGrouping:function(e){p.setGrouping(r,e)},groupColumn:function(e){e=r.getColumn(e);p.groupColumn(r,e)},ungroupColumn:function(e){e=r.getColumn(e);p.ungroupColumn(r,e)},clearGrouping:function(){p.clearGrouping(r)},aggregateColumn:function(e,t,i){e=r.getColumn(e);p.aggregateColumn(r,e,t,i)}}};r.api.registerEventsFromObject(t),r.api.registerMethodsFromObject(i),r.api.core.on.sortChanged(e,p.tidyPriorities)},defaultGridOptions:function(e){e.enableGrouping=!1!==e.enableGrouping,e.groupingShowCounts=!1!==e.groupingShowCounts,e.groupingNullLabel=void 0===e.groupingNullLabel?"Null":e.groupingNullLabel,e.enableGroupHeaderSelection=!0===e.enableGroupHeaderSelection},groupingColumnBuilder:function(e,i,t){var r,n,o;!1!==e.enableGrouping&&(void 0===i.grouping&&void 0!==e.grouping?(i.grouping=angular.copy(e.grouping),void 0!==i.grouping.groupPriority&&-1<i.grouping.groupPriority&&(i.treeAggregationFn=c.nativeAggregations()[a.aggregation.COUNT].aggregationFn,i.treeAggregationFinalizerFn=p.groupedFinalizerFn)):void 0===i.grouping&&(i.grouping={}),void 0!==i.grouping&&void 0!==i.grouping.groupPriority&&0<=i.grouping.groupPriority&&(i.suppressRemoveSort=!0),e={name:"ui.grid.grouping.group",title:d.get().grouping.group,icon:"ui-grid-icon-indent-right",shown:function(){return void 0===this.context.col.grouping||void 0===this.context.col.grouping.groupPriority||this.context.col.grouping.groupPriority<0},action:function(){p.groupColumn(this.context.col.grid,this.context.col)}},r={name:"ui.grid.grouping.ungroup",title:d.get().grouping.ungroup,icon:"ui-grid-icon-indent-left",shown:function(){return void 0!==this.context.col.grouping&&void 0!==this.context.col.grouping.groupPriority&&0<=this.context.col.grouping.groupPriority},action:function(){p.ungroupColumn(this.context.col.grid,this.context.col)}},n={name:"ui.grid.grouping.aggregateRemove",title:d.get().grouping.aggregate_remove,shown:function(){return void 0!==this.context.col.treeAggregationFn},action:function(){p.aggregateColumn(this.context.col.grid,this.context.col,null)}},!(o=function(e,t){t=t||d.get().grouping["aggregate_"+e]||e;t={name:"ui.grid.grouping.aggregate"+e,title:t,shown:function(){return void 0===this.context.col.treeAggregation||void 0===this.context.col.treeAggregation.type||this.context.col.treeAggregation.type!==e},action:function(){p.aggregateColumn(this.context.col.grid,this.context.col,e)}};l.arrayContainsObjectWithProperty(i.menuItems,"name","ui.grid.grouping.aggregate"+e)||i.menuItems.push(t)})!==i.colDef.groupingShowGroupingMenu&&(l.arrayContainsObjectWithProperty(i.menuItems,"name","ui.grid.grouping.group")||i.menuItems.push(e),l.arrayContainsObjectWithProperty(i.menuItems,"name","ui.grid.grouping.ungroup")||i.menuItems.push(r)),!1!==i.colDef.groupingShowAggregationMenu)&&(angular.forEach(c.nativeAggregations(),function(e,t){o(t)}),angular.forEach(t.treeCustomAggregations,function(e,t){o(t,e.menuTitle)}),l.arrayContainsObjectWithProperty(i.menuItems,"name","ui.grid.grouping.aggregateRemove")||i.menuItems.push(n))},groupingColumnProcessor:function(e,t){return e=p.moveGroupColumns(this,e,t)},groupedFinalizerFn:function(e){void 0!==e.groupVal?(e.rendered=e.groupVal,this.grid.options.groupingShowCounts&&"date"!==this.colDef.type&&"object"!==this.colDef.type&&(e.rendered+=" ("+e.value+")")):e.rendered=null},moveGroupColumns:function(e,t){return!1!==e.options.moveGroupColumns&&(t.forEach(function(e,t){e.groupingPosition=t}),t.sort(function(e,t){var i=e.isRowHeader?e.headerPriority:void 0===e.grouping||void 0===e.grouping.groupPriority||e.grouping.groupPriority<0?null:e.grouping.groupPriority,r=t.isRowHeader?t.headerPriority:void 0===t.grouping||void 0===t.grouping.groupPriority||t.grouping.groupPriority<0?null:t.grouping.groupPriority;return null!==i&&null===r?-1:null!==r&&null===i?1:null!==i&&null!==r?i-r:e.groupingPosition-t.groupingPosition}),t.forEach(function(e){delete e.groupingPosition})),t},groupColumn:function(e,t){void 0===t.grouping&&(t.grouping={});var i=p.getGrouping(e);t.grouping.groupPriority=i.grouping.length,t.previousSort=angular.copy(t.sort),t.sort?void 0!==t.sort.direction&&null!==t.sort.direction||(t.sort.direction=r.ASC):t.sort={direction:r.ASC},t.treeAggregation={type:a.aggregation.COUNT,source:"grouping"},t.colDef&&angular.isFunction(t.colDef.customTreeAggregationFn)?t.treeAggregationFn=t.colDef.customTreeAggregationFn:t.treeAggregationFn=c.nativeAggregations()[a.aggregation.COUNT].aggregationFn,t.treeAggregationFinalizerFn=p.groupedFinalizerFn,e.api.grouping.raise.groupingChanged(t),e.api.core.raise.sortChanged(e,e.getColumnSorting()),e.queueGridRefresh()},ungroupColumn:function(e,t){void 0!==t.grouping&&(delete t.grouping.groupPriority,delete t.treeAggregation,delete t.customTreeAggregationFinalizer,t.previousSort&&(t.sort=t.previousSort,delete t.previousSort),p.tidyPriorities(e),e.api.grouping.raise.groupingChanged(t),e.api.core.raise.sortChanged(e,e.getColumnSorting()),e.queueGridRefresh())},aggregateColumn:function(e,t,i,r){void 0!==t.grouping&&void 0!==t.grouping.groupPriority&&0<=t.grouping.groupPriority&&p.ungroupColumn(e,t);var n={};void 0!==e.options.treeCustomAggregations[i]?n=e.options.treeCustomAggregations[i]:void 0!==c.nativeAggregations()[i]&&(n=c.nativeAggregations()[i]),t.treeAggregation={type:i,label:"string"==typeof r?r:d.get().aggregation[n.label]||n.label},t.treeAggregationFn=n.aggregationFn,t.treeAggregationFinalizerFn=n.finalizerFn,e.api.grouping.raise.aggregationChanged(t),e.queueGridRefresh()},setGrouping:function(i,e){void 0!==e&&(p.clearGrouping(i),e.grouping&&e.grouping.length&&0<e.grouping.length&&e.grouping.forEach(function(e){e=i.getColumn(e.colName);e&&p.groupColumn(i,e)}),e.aggregations&&e.aggregations.length&&e.aggregations.forEach(function(e){var t=i.getColumn(e.colName);t&&p.aggregateColumn(i,t,e.aggregation.type)}),e.rowExpandedStates)&&p.applyRowExpandedStates(i.grouping.groupingHeaderCache,e.rowExpandedStates)},clearGrouping:function(t){var e=p.getGrouping(t);0<e.grouping.length&&e.grouping.forEach(function(e){e.col||(e.col=t.getColumn(e.colName)),p.ungroupColumn(t,e.col)}),0<e.aggregations.length&&e.aggregations.forEach(function(e){e.col||(e.col=t.getColumn(e.colName)),p.aggregateColumn(t,e.col,null)})},tidyPriorities:function(e){void 0!==e&&void 0===e.grid||void 0===this.grid||(e=this.grid);var i=[],r=[],t=(e.columns.forEach(function(e,t){void 0!==e.grouping&&void 0!==e.grouping.groupPriority&&0<=e.grouping.groupPriority?i.push(e):void 0!==e.sort&&void 0!==e.sort.priority&&0<=e.sort.priority&&r.push(e)}),i.sort(function(e,t){return e.grouping.groupPriority-t.grouping.groupPriority}),i.forEach(function(e,t){e.grouping.groupPriority=t,e.suppressRemoveSort=!0,void 0===e.sort&&(e.sort={}),e.sort.priority=t}),i.length);r.sort(function(e,t){return e.sort.priority-t.sort.priority}),r.forEach(function(e){e.sort.priority=t,e.suppressRemoveSort=e.colDef.suppressRemoveSort,t++})},groupRows:function(r){if(0!==r.length){for(var n=this,o=(n.grouping.oldGroupingHeaderCache=n.grouping.groupingHeaderCache||{},n.grouping.groupingHeaderCache={},p.initialiseProcessingState(n)),e=function(e,t){var i=n.getCellValue(l,e.col);e.initialised&&0===s.getSortFn(e.col)(i,e.currentValue)||(p.insertGroupHeader(n,r,a,o,t),a++)},a=0;a<r.length;a++){var l=r[a];l.visible&&o.forEach(e)}delete n.grouping.oldGroupingHeaderCache}return r},initialiseProcessingState:function(e){var i=[];return p.getGrouping(e).grouping.forEach(function(e,t){i.push({fieldName:e.field,col:e.col,initialised:!1,currentValue:null,currentRow:null})}),i},getGrouping:function(e){var t=[],i=[];return e.columns.forEach(function(e){e.grouping&&void 0!==e.grouping.groupPriority&&0<=e.grouping.groupPriority&&t.push({field:e.field,col:e,groupPriority:e.grouping.groupPriority,grouping:e.grouping}),e.treeAggregation&&e.treeAggregation.type&&i.push({field:e.field,col:e,aggregation:e.treeAggregation})}),t.sort(function(e,t){return e.groupPriority-t.groupPriority}),t.forEach(function(e,t){e.grouping.groupPriority=t,e.groupPriority=t,delete e.grouping}),{grouping:t,aggregations:i}},insertGroupHeader:function(e,t,i,r,n){var o=r[n].col,o=e.getCellValue(t[i],o),a=o;function l(e){return angular.isObject(e)?JSON.stringify(e):e}null==o&&(a=e.options.groupingNullLabel);for(var s,d=e.grouping.oldGroupingHeaderCache,c=0;c<n;c++)d&&d[l(r[c].currentValue)]&&(d=d[l(r[c].currentValue)].children);for(d&&d[l(o)]?(s=d[l(o)].row).entity={}:(s=new u({},null,e),g.rowTemplateAssigner.call(e,s)),s.entity["$$"+r[n].col.uid]={groupVal:a},s.treeLevel=n,s.groupHeader=!0,s.internalRow=!0,s.enableCellEdit=!1,s.enableSelection=e.options.enableGroupHeaderSelection,r[n].initialised=!0,r[n].currentValue=o,r[n].currentRow=s,p.finaliseProcessingState(r,n+1),t.splice(i,0,s),d=e.grouping.groupingHeaderCache,c=0;c<n;c++)d=d[l(r[c].currentValue)].children;d[l(o)]={row:s,children:{}}},finaliseProcessingState:function(e,t){for(var i=t;i<e.length;i++)e[i].initialised=!1,e[i].currentRow=null,e[i].currentValue=null},getRowExpandedStates:function(e){var i;return void 0===e?{}:(i={},angular.forEach(e,function(e,t){i[t]={state:e.row.treeNode.state},e.children?i[t].children=p.getRowExpandedStates(e.children):i[t].children={}}),i)},applyRowExpandedStates:function(i,e){void 0!==e&&angular.forEach(e,function(e,t){i[t]&&(i[t].row.treeNode.state=e.state,e.children)&&i[t].children&&p.applyRowExpandedStates(i[t].children,e.children)})}};return p}]),e.directive("uiGridGrouping",["uiGridGroupingConstants","uiGridGroupingService",function(e,n){return{replace:!0,priority:0,require:"^uiGrid",scope:!1,compile:function(){return{pre:function(e,t,i,r){!1!==r.grid.options.enableGrouping&&n.initializeGrid(r.grid,e)},post:function(e,t,i,r){}}}}}])}(),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("ar",{headerCell:{aria:{defaultFilterLabel:"التصفيه بالعمود",removeFilter:"محو التصفيه",columnMenuButtonLabel:"قاءمه الاعمده"},priority:"أولويه : ",filterLabel:"تصفيه بالاعمده :"},aggregate:{label:"العناصر"},groupPanel:{description:"اسحب رأس العمود هنا وأسقطه لإنشاء مجموعه"},search:{placeholder:"بحث  ...",showingItems:"العناصر الظاهره :",selectedItems:"العناصر المحدده :",totalItems:"عدد العناصر :",size:"حجم الصفحه :",first:"اول صفحه",next:"الصفحه التاليه",previous:"الصفحه الصابقه",last:"الصفحه الاخيره"},menu:{text:"اختيار العمود :"},sort:{ascending:"ترتيب تصاعدى",descending:"ترتيب تنازلى",none:"عدم التحديد",remove:"حذف الترتيب"},column:{hide:"إخفاء عمود"},aggregation:{count:"عدد الصفوف: ",sum:"جمع: ",avg:"المتوسط الحسابى: ",min:"الادنى: ",max:"الاقصى: "},pinning:{pinLeft:"تثبيت لليسار",pinRight:"تثبيت لليمين",unpin:"فك التثبيت"},columnMenu:{close:"غلق"},gridMenu:{aria:{buttonLabel:"قائمه الجدول"},columns:"الاعمده:",importerTitle:"إدخال ملف",exporterAllAsCsv:"إخراج كل البيانات ك(csv)",exporterVisibleAsCsv:"إخراج كل البيانات الواضحه ك (csv)",exporterSelectedAsCsv:"إخراج كل البيانات المحدده ك (csv)",exporterAllAsPdf:"إخراج كل البيانات ك(pdf)",exporterVisibleAsPdf:"إخراج كل البيانات الواضحه ك (pdf)",exporterSelectedAsPdf:"إخراج كل البيانات المحدده ك (pdf)",clearAllFilters:"محو كل الترشيح"},importer:{noHeaders:"اسماء هؤلاء الاعمده غير واضحه، هل يوجد رأس للملف؟",noObjects:"Objects were not able to be derived, was there data in the file other than headers?",invalidCsv:"الملف غير قادر على الاتمام ، هل ال (CSV) صحيح؟",invalidJson:"الملف غير قادر على الاتمام ، هل ال (JSON) صحيح؟",jsonNotArray:"Imported json file must contain an array, aborting."},pagination:{aria:{pageToFirst:"الصفحه الاولى",pageBack:"الصفه السابقه",pageSelected:"الصفحه المحدده",pageForward:"الصفحه التاليه",pageToLast:"الصفحه الاخيره"},sizes:"عدد العناصر فى الصفحه",totalItems:"عناصر",through:"إلى",of:"من"},grouping:{group:"جمع",ungroup:"فك الجمع",aggregate_count:"جمله : العدد",aggregate_sum:"جمله : الحاصل",aggregate_max:"جمله : الاقصى",aggregate_min:"جمله : الاقل",aggregate_avg:"جمله :المتوسط ",aggregate_remove:"جمله : حذف"},validate:{error:"خطأ :",minLength:"القيمه لابد ان لا تقل عن THRESHOLD حرف.",maxLength:"القيمه لابد ان لا تزيد عن THRESHOLD حرف.",required:"مطلوب قيمه"}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("bg",{headerCell:{aria:{defaultFilterLabel:"Филттър за колоната",removeFilter:"Премахни филтър",columnMenuButtonLabel:"Меню на колоната"},priority:"Приоритет:",filterLabel:"Филтър за колоната: "},aggregate:{label:"обекти"},search:{placeholder:"Търсене...",showingItems:"Показани обекти:",selectedItems:"избрани обекти:",totalItems:"Общо:",size:"Размер на страницата:",first:"Първа страница",next:"Следваща страница",previous:"Предишна страница",last:"Последна страница"},menu:{text:"Избери колони:"},sort:{ascending:"Сортиране по възходящ ред",descending:"Сортиране по низходящ ред",none:"Без сортиране",remove:"Премахни сортирането"},column:{hide:"Скрий колоната"},aggregation:{count:"Общо редове: ",sum:"общо: ",avg:"средно: ",min:"най-малко: ",max:"най-много: "},pinning:{pinLeft:"Прикрепи вляво",pinRight:"Прикрепи вдясно",unpin:"Премахване"},columnMenu:{close:"Затвори"},gridMenu:{aria:{buttonLabel:"Меню на таблицата"},columns:"Колони:",importerTitle:"Импортиране на файл",exporterAllAsCsv:"Експортиране на данните като csv",exporterVisibleAsCsv:"Експортиране на видимите данни като csv",exporterSelectedAsCsv:"Експортиране на избраните данни като csv",exporterAllAsPdf:"Експортиране на данните като pdf",exporterVisibleAsPdf:"Експортиране на видимите данни като pdf",exporterSelectedAsPdf:"Експортиране на избраните данни като pdf",clearAllFilters:"Премахни всички филтри"},importer:{noHeaders:"Имената на колоните не успяха да бъдат извлечени, файлът има ли хедър?",noObjects:"Обектите не успяха да бъдат извлечени, файлът съдържа ли данни, различни от хедър?",invalidCsv:"Файлът не може да бъде обработеб, уверете се, че е валиден CSV файл",invalidJson:"Файлът не може да бъде обработеб, уверете се, че е валиден JSON файл",jsonNotArray:"Импортираният JSON файл трябва да съдържа масив, прекратяване."},pagination:{aria:{pageToFirst:"Към първа страница",pageBack:"Страница назад",pageSelected:"Избрана страница",pageForward:"Страница напред",pageToLast:"Към последна страница"},sizes:"обекта на страница",totalItems:"обекта",through:"до",of:"от"},grouping:{group:"Групиране",ungroup:"Премахване на групирането",aggregate_count:"Сбор: Брой",aggregate_sum:"Сбор: Сума",aggregate_max:"Сбор: Максимум",aggregate_min:"Сбор: Минимум",aggregate_avg:"Сбор: Средно",aggregate_remove:"Сбор: Премахване"},validate:{error:"Грешка:",minLength:"Стойността трябва да съдържа поне THRESHOLD символа.",maxLength:"Стойността не трябва да съдържа повече от THRESHOLD символа.",required:"Необходима е стойност."}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){var t={aggregate:{label:"položky"},groupPanel:{description:"Přesuňte záhlaví zde pro vytvoření skupiny dle sloupce."},search:{placeholder:"Hledat...",showingItems:"Zobrazuji položky:",selectedItems:"Vybrané položky:",totalItems:"Celkem položek:",size:"Velikost strany:",first:"První strana",next:"Další strana",previous:"Předchozí strana",last:"Poslední strana"},menu:{text:"Vyberte sloupec:"},sort:{ascending:"Seřadit od A-Z",descending:"Seřadit od Z-A",remove:"Odebrat seřazení"},column:{hide:"Schovat sloupec"},aggregation:{count:"celkem řádků: ",sum:"celkem: ",avg:"avg: ",min:"min.: ",max:"max.: "},pinning:{pinLeft:"Zamknout vlevo",pinRight:"Zamknout vpravo",unpin:"Odemknout"},gridMenu:{columns:"Sloupce:",importerTitle:"Importovat soubor",exporterAllAsCsv:"Exportovat všechna data do csv",exporterVisibleAsCsv:"Exportovat viditelná data do csv",exporterSelectedAsCsv:"Exportovat vybraná data do csv",exporterAllAsPdf:"Exportovat všechna data do pdf",exporterVisibleAsPdf:"Exportovat viditelná data do pdf",exporterSelectedAsPdf:"Exportovat vybraná data do pdf",exporterAllAsExcel:"Exportovat všechna data do excel",exporterVisibleAsExcel:"Exportovat viditelná data do excel",exporterSelectedAsExcel:"Exportovat vybraná data do excel",clearAllFilters:"Odstranit všechny filtry"},importer:{noHeaders:"Názvy sloupců se nepodařilo získat, obsahuje soubor záhlaví?",noObjects:"Data se nepodařilo zpracovat, obsahuje soubor řádky mimo záhlaví?",invalidCsv:"Soubor nelze zpracovat, jedná se o CSV?",invalidJson:"Soubor nelze zpracovat, je to JSON?",jsonNotArray:"Soubor musí obsahovat json. Ukončuji.."},pagination:{sizes:"položek na stránku",totalItems:"položek"},grouping:{group:"Seskupit",ungroup:"Odebrat seskupení",aggregate_count:"Agregace: Count",aggregate_sum:"Agregace: Sum",aggregate_max:"Agregace: Max",aggregate_min:"Agregace: Min",aggregate_avg:"Agregace: Avg",aggregate_remove:"Agregace: Odebrat"}};return e.add("cs",t),e.add("cz",t),e.add("cs-cz",t),e.add("cs-CZ",t),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("da",{aggregate:{label:"artikler"},groupPanel:{description:"Grupér rækker udfra en kolonne ved at trække dens overskift hertil."},search:{placeholder:"Søg...",showingItems:"Viste rækker:",selectedItems:"Valgte rækker:",totalItems:"Rækker totalt:",size:"Side størrelse:",first:"Første side",next:"Næste side",previous:"Forrige side",last:"Sidste side"},menu:{text:"Vælg kolonner:"},sort:{ascending:"Sorter stigende",descending:"Sorter faldende",none:"Sorter ingen",remove:"Fjern sortering"},column:{hide:"Skjul kolonne"},aggregation:{count:"antal rækker: ",sum:"sum: ",avg:"gns: ",min:"min: ",max:"max: "},pinning:{pinLeft:"Fastgør til venstre",pinRight:"Fastgør til højre",unpin:"Frigør"},gridMenu:{columns:"Kolonner:",importerTitle:"Importer fil",exporterAllAsCsv:"Eksporter alle data som csv",exporterVisibleAsCsv:"Eksporter synlige data som csv",exporterSelectedAsCsv:"Eksporter markerede data som csv",exporterAllAsPdf:"Eksporter alle data som pdf",exporterVisibleAsPdf:"Eksporter synlige data som pdf",exporterSelectedAsPdf:"Eksporter markerede data som pdf",exporterAllAsExcel:"Eksporter alle data som excel",exporterVisibleAsExcel:"Eksporter synlige data som excel",exporterSelectedAsExcel:"Eksporter markerede data som excel",clearAllFilters:"Clear all filters"},importer:{noHeaders:"Column names were unable to be derived, does the file have a header?",noObjects:"Objects were not able to be derived, was there data in the file other than headers?",invalidCsv:"File was unable to be processed, is it valid CSV?",invalidJson:"File was unable to be processed, is it valid Json?",jsonNotArray:"Imported json file must contain an array, aborting."},pagination:{aria:{pageToFirst:"Gå til første",pageBack:"Gå tilbage",pageSelected:"Valgte side",pageForward:"Gå frem",pageToLast:"Gå til sidste"},sizes:"genstande per side",totalItems:"genstande",through:"gennem",of:"af"}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("de",{headerCell:{aria:{defaultFilterLabel:"Filter für Spalte",removeFilter:"Filter löschen",columnMenuButtonLabel:"Spaltenmenü",column:"Spalte"},priority:"Priorität:",filterLabel:"Filter für Spalte: "},aggregate:{label:"Eintrag"},groupPanel:{description:"Ziehen Sie eine Spaltenüberschrift hierhin, um nach dieser Spalte zu gruppieren."},search:{aria:{selected:"Zeile markiert",notSelected:"Zeile nicht markiert"},placeholder:"Suche...",showingItems:"Zeige Einträge:",selectedItems:"Ausgewählte Einträge:",totalItems:"Einträge gesamt:",size:"Einträge pro Seite:",first:"Erste Seite",next:"Nächste Seite",previous:"Vorherige Seite",last:"Letzte Seite"},selection:{aria:{row:"Zeile"},selectAll:"Alle auswählen",displayName:"Zeilenauswahlkasten"},menu:{text:"Spalten auswählen:"},sort:{ascending:"aufsteigend sortieren",descending:"absteigend sortieren",none:"keine Sortierung",remove:"Sortierung zurücksetzen"},column:{hide:"Spalte ausblenden"},aggregation:{count:"Zeilen insgesamt: ",sum:"gesamt: ",avg:"Durchschnitt: ",min:"min: ",max:"max: "},pinning:{pinLeft:"Links anheften",pinRight:"Rechts anheften",unpin:"Lösen"},columnMenu:{close:"Schließen"},gridMenu:{aria:{buttonLabel:"Tabellenmenü"},columns:"Spalten:",importerTitle:"Datei importieren",exporterAllAsCsv:"Alle Daten als CSV exportieren",exporterVisibleAsCsv:"Sichtbare Daten als CSV exportieren",exporterSelectedAsCsv:"Markierte Daten als CSV exportieren",exporterAllAsPdf:"Alle Daten als PDF exportieren",exporterVisibleAsPdf:"Sichtbare Daten als PDF exportieren",exporterSelectedAsPdf:"Markierte Daten als PDF exportieren",exporterAllAsExcel:"Alle Daten als Excel exportieren",exporterVisibleAsExcel:"Sichtbare Daten als Excel exportieren",exporterSelectedAsExcel:"Markierte Daten als Excel exportieren",clearAllFilters:"Alle Filter zurücksetzen"},importer:{noHeaders:"Es konnten keine Spaltennamen ermittelt werden. Sind in der Datei Spaltendefinitionen enthalten?",noObjects:"Es konnten keine Zeileninformationen gelesen werden, Sind in der Datei außer den Spaltendefinitionen auch Daten enthalten?",invalidCsv:"Die Datei konnte nicht eingelesen werden, ist es eine gültige CSV-Datei?",invalidJson:"Die Datei konnte nicht eingelesen werden. Enthält sie gültiges JSON?",jsonNotArray:"Die importierte JSON-Datei muß ein Array enthalten. Breche Import ab."},pagination:{aria:{pageToFirst:"Zum Anfang",pageBack:"Seite zurück",pageSelected:"Ausgewählte Seite",pageForward:"Seite vor",pageToLast:"Zum Ende"},sizes:"Einträge pro Seite",totalItems:"Einträgen",through:"bis",of:"von"},grouping:{group:"Gruppieren",ungroup:"Gruppierung aufheben",aggregate_count:"Agg: Anzahl",aggregate_sum:"Agg: Summe",aggregate_max:"Agg: Maximum",aggregate_min:"Agg: Minimum",aggregate_avg:"Agg: Mittelwert",aggregate_remove:"Aggregation entfernen"},validate:{error:"Fehler:",minLength:"Der Wert sollte mindestens THRESHOLD Zeichen lang sein.",maxLength:"Der Wert sollte maximal THRESHOLD Zeichen lang sein.",required:"Ein Wert wird benötigt."}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("es-ct",{headerCell:{aria:{defaultFilterLabel:"Filtre per columna",removeFilter:"Elimina el filtre",columnMenuButtonLabel:"Menú de Columna",column:"Columna"},priority:"Priority:",filterLabel:"Filtre per columna: "},aggregate:{label:"items"},groupPanel:{description:"Arrossegueu una capçalera de columna aquí i deixeu-lo anar per agrupar per aquesta columna."},search:{aria:{selected:"Fila seleccionada",notSelected:"Fila no seleccionada"},placeholder:"Cerca...",showingItems:"Ítems Mostrats:",selectedItems:"Ítems Seleccionats:",totalItems:"Ítems Totals:",size:"Mida de la pàgina:",first:"Primera Pàgina",next:"Propera Pàgina",previous:"Pàgina Anterior",last:"Última Pàgina"},selection:{aria:{row:"Fila"},selectAll:"Seleccionar Todo",displayName:"Seleccionar Fila"},menu:{text:"Triar Columnes:"},sort:{ascending:"Ordena Ascendent",descending:"Ordena Descendent",none:"Sense Ordre",remove:"Eliminar Ordre"},column:{hide:"Amaga la Columna"},aggregation:{count:"Files Totals: ",sum:"total: ",avg:"mitjà: ",min:"mín: ",max:"màx: "},pinning:{pinLeft:"Fixar a l'Esquerra",pinRight:"Fixar a la Dreta",unpin:"Treure Fixació"},columnMenu:{close:"Tanca"},gridMenu:{aria:{buttonLabel:"Menú de Quadrícula"},columns:"Columnes:",importerTitle:"Importa el fitxer",exporterAllAsCsv:"Exporta tot com CSV",exporterVisibleAsCsv:"Exporta les dades visibles com a CSV",exporterSelectedAsCsv:"Exporta les dades seleccionades com a CSV",exporterAllAsPdf:"Exporta tot com PDF",exporterVisibleAsPdf:"Exporta les dades visibles com a PDF",exporterSelectedAsPdf:"Exporta les dades seleccionades com a PDF",exporterAllAsExcel:"Exporta tot com Excel",exporterVisibleAsExcel:"Exporta les dades visibles com Excel",exporterSelectedAsExcel:"Exporta les dades seleccionades com Excel",clearAllFilters:"Netejar tots els filtres"},importer:{noHeaders:"No va ser possible derivar els noms de les columnes, té encapçalats l'arxiu?",noObjects:"No va ser possible obtenir registres, conté dades l'arxiu, a part de les capçaleres?",invalidCsv:"No va ser possible processar l'arxiu, ¿és un CSV vàlid?",invalidJson:"No va ser possible processar l'arxiu, ¿és un JSON vàlid?",jsonNotArray:"El fitxer json importat ha de contenir una matriu, avortant."},pagination:{aria:{pageToFirst:"Page to first",pageBack:"Page back",pageSelected:"Selected page",pageForward:"Page forward",pageToLast:"Page to last"},sizes:"ítems per pàgina",totalItems:"ítems",through:"a",of:"de"},grouping:{group:"Agrupar",ungroup:"Desagrupar",aggregate_count:"Agr: Compte",aggregate_sum:"Agr: Sum",aggregate_max:"Agr: Máx",aggregate_min:"Agr: Mín",aggregate_avg:"Agr: Mitjà",aggregate_remove:"Agr: Treure"},validate:{error:"Error:",minLength:"El valor ha de tenir almenys caràcters THRESHOLD.",maxLength:"El valor ha de tenir com a màxim caràcters THRESHOLD.",required:"Un valor és necessari."}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("es",{aggregate:{label:"Artículos"},groupPanel:{description:"Arrastre un encabezado de columna aquí y suéltelo para agrupar por esa columna."},search:{placeholder:"Buscar...",showingItems:"Artículos Mostrados:",selectedItems:"Artículos Seleccionados:",totalItems:"Artículos Totales:",size:"Tamaño de Página:",first:"Primera Página",next:"Página Siguiente",previous:"Página Anterior",last:"Última Página"},selection:{aria:{row:"Fila"},selectAll:"Seleccionar Todo",displayName:"Seleccionar Fila"},menu:{text:"Elegir columnas:"},sort:{ascending:"Orden Ascendente",descending:"Orden Descendente",remove:"Sin Ordenar"},column:{hide:"Ocultar la columna"},aggregation:{count:"filas totales: ",sum:"total: ",avg:"media: ",min:"min: ",max:"max: "},pinning:{pinLeft:"Fijar a la Izquierda",pinRight:"Fijar a la Derecha",unpin:"Quitar Fijación"},gridMenu:{columns:"Columnas:",importerTitle:"Importar archivo",exporterAllAsCsv:"Exportar todo como csv",exporterVisibleAsCsv:"Exportar vista como csv",exporterSelectedAsCsv:"Exportar selección como csv",exporterAllAsPdf:"Exportar todo como pdf",exporterVisibleAsPdf:"Exportar vista como pdf",exporterSelectedAsPdf:"Exportar selección como pdf",exporterAllAsExcel:"Exportar todo como excel",exporterVisibleAsExcel:"Exportar vista como excel",exporterSelectedAsExcel:"Exportar selección como excel",clearAllFilters:"Limpiar todos los filtros"},importer:{noHeaders:"No fue posible derivar los nombres de las columnas, ¿tiene encabezados el archivo?",noObjects:"No fue posible obtener registros, ¿contiene datos el archivo, aparte de los encabezados?",invalidCsv:"No fue posible procesar el archivo, ¿es un CSV válido?",invalidJson:"No fue posible procesar el archivo, ¿es un Json válido?",jsonNotArray:"El archivo json importado debe contener un array, abortando."},pagination:{aria:{pageToFirst:"Página para primero",pageBack:"Página atrás",pageSelected:"Página seleccionada",pageForward:"Avance de página",pageToLast:"Página para durar"},through:"mediante",sizes:"registros por página",totalItems:"registros",of:"de"},grouping:{group:"Agrupar",ungroup:"Desagrupar",aggregate_count:"Agr: Cont",aggregate_sum:"Agr: Sum",aggregate_max:"Agr: Máx",aggregate_min:"Agr: Min",aggregate_avg:"Agr: Prom",aggregate_remove:"Agr: Quitar"}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("fa",{aggregate:{label:"قلم"},groupPanel:{description:"عنوان یک ستون را بگیر و به گروهی از آن ستون رها کن."},search:{placeholder:"جستجو...",showingItems:"نمایش اقلام:",selectedItems:"قلم‌های انتخاب شده:",totalItems:"مجموع اقلام:",size:"اندازه‌ی صفحه:",first:"اولین صفحه",next:"صفحه‌ی‌بعدی",previous:"صفحه‌ی‌ قبلی",last:"آخرین صفحه"},menu:{text:"ستون‌های انتخابی:"},sort:{ascending:"ترتیب صعودی",descending:"ترتیب نزولی",remove:"حذف مرتب کردن"},column:{hide:"پنهان‌کردن ستون"},aggregation:{count:"تعداد: ",sum:"مجموع: ",avg:"میانگین: ",min:"کمترین: ",max:"بیشترین: "},pinning:{pinLeft:"پین کردن سمت چپ",pinRight:"پین کردن سمت راست",unpin:"حذف پین"},gridMenu:{columns:"ستون‌ها:",importerTitle:"وارد کردن فایل",exporterAllAsCsv:"خروجی تمام داده‌ها در فایل csv",exporterVisibleAsCsv:"خروجی داده‌های قابل مشاهده در فایل csv",exporterSelectedAsCsv:"خروجی داده‌های انتخاب‌شده در فایل csv",exporterAllAsPdf:"خروجی تمام داده‌ها در فایل pdf",exporterVisibleAsPdf:"خروجی داده‌های قابل مشاهده در فایل pdf",exporterSelectedAsPdf:"خروجی داده‌های انتخاب‌شده در فایل pdf",clearAllFilters:"پاک کردن تمام فیلتر"},importer:{noHeaders:"نام ستون قابل استخراج نیست. آیا فایل عنوان دارد؟",noObjects:"اشیا قابل استخراج نیستند. آیا به جز عنوان‌ها در فایل داده وجود دارد؟",invalidCsv:"فایل قابل پردازش نیست. آیا فرمت  csv  معتبر است؟",invalidJson:"فایل قابل پردازش نیست. آیا فرمت json   معتبر است؟",jsonNotArray:"فایل json وارد شده باید حاوی آرایه باشد. عملیات ساقط شد."},pagination:{sizes:"اقلام در هر صفحه",totalItems:"اقلام",of:"از"},grouping:{group:"گروه‌بندی",ungroup:"حذف گروه‌بندی",aggregate_count:"Agg: تعداد",aggregate_sum:"Agg: جمع",aggregate_max:"Agg: بیشینه",aggregate_min:"Agg: کمینه",aggregate_avg:"Agg: میانگین",aggregate_remove:"Agg: حذف"}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("fi",{aggregate:{label:"rivit"},groupPanel:{description:"Raahaa ja pudota otsikko tähän ryhmittääksesi sarakkeen mukaan."},search:{placeholder:"Hae...",showingItems:"Näytetään rivejä:",selectedItems:"Valitut rivit:",totalItems:"Rivejä yht.:",size:"Näytä:",first:"Ensimmäinen sivu",next:"Seuraava sivu",previous:"Edellinen sivu",last:"Viimeinen sivu"},menu:{text:"Valitse sarakkeet:"},sort:{ascending:"Järjestä nouseva",descending:"Järjestä laskeva",remove:"Poista järjestys"},column:{hide:"Piilota sarake"},aggregation:{count:"Rivejä yht.: ",sum:"Summa: ",avg:"K.a.: ",min:"Min: ",max:"Max: "},pinning:{pinLeft:"Lukitse vasemmalle",pinRight:"Lukitse oikealle",unpin:"Poista lukitus"},gridMenu:{columns:"Sarakkeet:",importerTitle:"Tuo tiedosto",exporterAllAsCsv:"Vie tiedot csv-muodossa",exporterVisibleAsCsv:"Vie näkyvä tieto csv-muodossa",exporterSelectedAsCsv:"Vie valittu tieto csv-muodossa",exporterAllAsPdf:"Vie tiedot pdf-muodossa",exporterVisibleAsPdf:"Vie näkyvä tieto pdf-muodossa",exporterSelectedAsPdf:"Vie valittu tieto pdf-muodossa",exporterAllAsExcel:"Vie tiedot excel-muodossa",exporterVisibleAsExcel:"Vie näkyvä tieto excel-muodossa",exporterSelectedAsExcel:"Vie valittu tieto excel-muodossa",clearAllFilters:"Puhdista kaikki suodattimet"},importer:{noHeaders:"Sarakkeen nimiä ei voitu päätellä, onko tiedostossa otsikkoriviä?",noObjects:"Tietoja ei voitu lukea, onko tiedostossa muuta kuin otsikkot?",invalidCsv:"Tiedostoa ei voitu käsitellä, oliko se CSV-muodossa?",invalidJson:"Tiedostoa ei voitu käsitellä, oliko se JSON-muodossa?",jsonNotArray:"Tiedosto ei sisältänyt taulukkoa, lopetetaan."}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("fr",{headerCell:{aria:{defaultFilterLabel:"Filtre de la colonne",removeFilter:"Supprimer le filtre",columnMenuButtonLabel:"Menu de la colonne"},priority:"Priorité:",filterLabel:"Filtre de la colonne: "},aggregate:{label:"éléments"},groupPanel:{description:"Faites glisser une en-tête de colonne ici pour créer un groupe de colonnes."},search:{placeholder:"Recherche...",showingItems:"Affichage des éléments :",selectedItems:"Éléments sélectionnés :",totalItems:"Nombre total d'éléments:",size:"Taille de page:",first:"Première page",next:"Page Suivante",previous:"Page précédente",last:"Dernière page"},selection:{aria:{row:"Ligne"},selectAll:"Tout Sélectionner",displayName:"Sélectionnez la ligne"},menu:{text:"Choisir des colonnes :"},sort:{ascending:"Trier par ordre croissant",descending:"Trier par ordre décroissant",none:"Aucun tri",remove:"Enlever le tri"},column:{hide:"Cacher la colonne"},aggregation:{count:"lignes totales: ",sum:"total: ",avg:"moy: ",min:"min: ",max:"max: "},pinning:{pinLeft:"Épingler à gauche",pinRight:"Épingler à droite",unpin:"Détacher"},columnMenu:{close:"Fermer"},gridMenu:{aria:{buttonLabel:"Menu du tableau"},columns:"Colonnes:",importerTitle:"Importer un fichier",exporterAllAsCsv:"Exporter toutes les données en CSV",exporterVisibleAsCsv:"Exporter les données visibles en CSV",exporterSelectedAsCsv:"Exporter les données sélectionnées en CSV",exporterAllAsPdf:"Exporter toutes les données en PDF",exporterVisibleAsPdf:"Exporter les données visibles en PDF",exporterSelectedAsPdf:"Exporter les données sélectionnées en PDF",exporterAllAsExcel:"Exporter toutes les données en Excel",exporterVisibleAsExcel:"Exporter les données visibles en Excel",exporterSelectedAsExcel:"Exporter les données sélectionnées en Excel",clearAllFilters:"Nettoyez tous les filtres"},importer:{noHeaders:"Impossible de déterminer le nom des colonnes, le fichier possède-t-il une en-tête ?",noObjects:"Aucun objet trouvé, le fichier possède-t-il des données autres que l'en-tête ?",invalidCsv:"Le fichier n'a pas pu être traité, le CSV est-il valide ?",invalidJson:"Le fichier n'a pas pu être traité, le JSON est-il valide ?",jsonNotArray:"Le fichier JSON importé doit contenir un tableau, abandon."},pagination:{aria:{pageToFirst:"Aller à la première page",pageBack:"Page précédente",pageSelected:"Page sélectionnée",pageForward:"Page suivante",pageToLast:"Aller à la dernière page"},sizes:"éléments par page",totalItems:"éléments",through:"à",of:"sur"},grouping:{group:"Grouper",ungroup:"Dégrouper",aggregate_count:"Agg: Compter",aggregate_sum:"Agg: Somme",aggregate_max:"Agg: Max",aggregate_min:"Agg: Min",aggregate_avg:"Agg: Moy",aggregate_remove:"Agg: Retirer"},validate:{error:"Erreur:",minLength:"La valeur doit être supérieure ou égale à THRESHOLD caractères.",maxLength:"La valeur doit être inférieure ou égale à THRESHOLD caractères.",required:"Une valeur est nécéssaire."}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("he",{aggregate:{label:"items"},groupPanel:{description:"גרור עמודה לכאן ושחרר בכדי לקבץ עמודה זו."},search:{placeholder:"חפש...",showingItems:"מציג:",selectedItems:'סה"כ נבחרו:',totalItems:'סה"כ רשומות:',size:"תוצאות בדף:",first:"דף ראשון",next:"דף הבא",previous:"דף קודם",last:"דף אחרון"},menu:{text:"בחר עמודות:"},sort:{ascending:"סדר עולה",descending:"סדר יורד",remove:"בטל"},column:{hide:"טור הסתר"},aggregation:{count:"total rows: ",sum:"total: ",avg:"avg: ",min:"min: ",max:"max: "},gridMenu:{columns:"Columns:",importerTitle:"Import file",exporterAllAsCsv:"Export all data as csv",exporterVisibleAsCsv:"Export visible data as csv",exporterSelectedAsCsv:"Export selected data as csv",exporterAllAsPdf:"Export all data as pdf",exporterVisibleAsPdf:"Export visible data as pdf",exporterSelectedAsPdf:"Export selected data as pdf",exporterAllAsExcel:"Export all data as excel",exporterVisibleAsExcel:"Export visible data as excel",exporterSelectedAsExcel:"Export selected data as excel",clearAllFilters:"Clean all filters"},importer:{noHeaders:"Column names were unable to be derived, does the file have a header?",noObjects:"Objects were not able to be derived, was there data in the file other than headers?",invalidCsv:"File was unable to be processed, is it valid CSV?",invalidJson:"File was unable to be processed, is it valid Json?",jsonNotArray:"Imported json file must contain an array, aborting."}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("hy",{aggregate:{label:"տվյալներ"},groupPanel:{description:"Ըստ սյան խմբավորելու համար քաշեք և գցեք վերնագիրն այստեղ։"},search:{placeholder:"Փնտրում...",showingItems:"Ցուցադրված տվյալներ՝",selectedItems:"Ընտրված:",totalItems:"Ընդամենը՝",size:"Տողերի քանակը էջում՝",first:"Առաջին էջ",next:"Հաջորդ էջ",previous:"Նախորդ էջ",last:"Վերջին էջ"},menu:{text:"Ընտրել սյուները:"},sort:{ascending:"Աճման կարգով",descending:"Նվազման կարգով",remove:"Հանել "},column:{hide:"Թաքցնել սյունը"},aggregation:{count:"ընդամենը տող՝ ",sum:"ընդամենը՝ ",avg:"միջին՝ ",min:"մին՝ ",max:"մաքս՝ "},pinning:{pinLeft:"Կպցնել ձախ կողմում",pinRight:"Կպցնել աջ կողմում",unpin:"Արձակել"},gridMenu:{columns:"Սյուներ:",importerTitle:"Ներմուծել ֆայլ",exporterAllAsCsv:"Արտահանել ամբողջը CSV",exporterVisibleAsCsv:"Արտահանել երևացող տվյալները CSV",exporterSelectedAsCsv:"Արտահանել ընտրված տվյալները CSV",exporterAllAsPdf:"Արտահանել PDF",exporterVisibleAsPdf:"Արտահանել երևացող տվյալները PDF",exporterSelectedAsPdf:"Արտահանել ընտրված տվյալները PDF",exporterAllAsExcel:"Արտահանել excel",exporterVisibleAsExcel:"Արտահանել երևացող տվյալները excel",exporterSelectedAsExcel:"Արտահանել ընտրված տվյալները excel",clearAllFilters:"Մաքրել բոլոր ֆիլտրերը"},importer:{noHeaders:"Հնարավոր չեղավ որոշել սյան վերնագրերը։ Արդյո՞ք ֆայլը ունի վերնագրեր։",noObjects:"Հնարավոր չեղավ կարդալ տվյալները։ Արդյո՞ք ֆայլում կան տվյալներ։",invalidCsv:"Հնարավոր չեղավ մշակել ֆայլը։ Արդյո՞ք այն վավեր CSV է։",invalidJson:"Հնարավոր չեղավ մշակել ֆայլը։ Արդյո՞ք այն վավեր Json է։",jsonNotArray:"Ներմուծված json ֆայլը պետք է պարունակի զանգված, կասեցվում է։"}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("is",{headerCell:{aria:{defaultFilterLabel:"Sía fyrir dálk",removeFilter:"Fjarlægja síu",columnMenuButtonLabel:"Dálkavalmynd"},priority:"Forgangsröðun:",filterLabel:"Sía fyrir dálka: "},aggregate:{label:"hlutir"},groupPanel:{description:"Dragðu dálkhaus hingað til að flokka saman eftir þeim dálki."},search:{placeholder:"Leita...",showingItems:"Sýni hluti:",selectedItems:"Valdir hlutir:",totalItems:"Hlutir alls:",size:"Stærð síðu:",first:"Fyrsta síða",next:"Næsta síða",previous:"Fyrri síða",last:"Síðasta síða"},menu:{text:"Veldu dálka:"},sort:{ascending:"Raða hækkandi",descending:"Raða lækkandi",none:"Engin röðun",remove:"Fjarlægja röðun"},column:{hide:"Fela dálk"},aggregation:{count:"fjöldi raða: ",sum:"summa: ",avg:"meðaltal: ",min:"lágmark: ",max:"hámark: "},pinning:{pinLeft:"Festa til vinstri",pinRight:"Festa til hægri",unpin:"Losa"},columnMenu:{close:"Loka"},gridMenu:{aria:{buttonLabel:"Töflu valmynd"},columns:"Dálkar:",importerTitle:"Flytja inn skjal",exporterAllAsCsv:"Flytja út gögn sem csv",exporterVisibleAsCsv:"Flytja út sýnileg gögn sem csv",exporterSelectedAsCsv:"Flytja út valin gögn sem csv",exporterAllAsPdf:"Flytja út öll gögn sem pdf",exporterVisibleAsPdf:"Flytja út sýnileg gögn sem pdf",exporterSelectedAsPdf:"Flytja út valin gögn sem pdf",clearAllFilters:"Hreinsa allar síur"},importer:{noHeaders:"Ekki hægt að vinna dálkanöfn úr skjalinu, er skjalið örugglega með haus?",noObjects:"Ekki hægt að vinna hluti úr skjalinu, voru örugglega gögn í skjalinu önnur en hausinn?",invalidCsv:"Tókst ekki að vinna skjal, er það örggulega gilt CSV?",invalidJson:"Tókst ekki að vinna skjal, er það örugglega gilt Json?",jsonNotArray:"Innflutt json skjal verður að innihalda fylki, hætti við."},pagination:{aria:{pageToFirst:"Fletta að fyrstu",pageBack:"Fletta til baka",pageSelected:"Valin síða",pageForward:"Fletta áfram",pageToLast:"Fletta að síðustu"},sizes:"hlutir á síðu",totalItems:"hlutir",through:"gegnum",of:"af"},grouping:{group:"Flokka",ungroup:"Sundurliða",aggregate_count:"Fjöldi: ",aggregate_sum:"Summa: ",aggregate_max:"Hámark: ",aggregate_min:"Lágmark: ",aggregate_avg:"Meðaltal: ",aggregate_remove:"Fjarlægja: "},validate:{error:"Villa:",minLength:"Gildi ætti að vera a.m.k. THRESHOLD stafa langt.",maxLength:"Gildi ætti að vera í mesta lagi THRESHOLD stafa langt.",required:"Þarf að hafa gildi."}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("it",{aggregate:{label:"elementi"},groupPanel:{description:"Trascina un'intestazione all'interno del gruppo della colonna."},search:{placeholder:"Ricerca...",showingItems:"Mostra:",selectedItems:"Selezionati:",totalItems:"Totali:",size:"Tot Pagine:",first:"Prima",next:"Prossima",previous:"Precedente",last:"Ultima"},selection:{aria:{row:"Riga"},selectAll:"Seleccionar Todo",displayName:"Seleziona Riga"},menu:{text:"Scegli le colonne:"},sort:{ascending:"Asc.",descending:"Desc.",remove:"Annulla ordinamento"},column:{hide:"Nascondi"},aggregation:{count:"righe totali: ",sum:"tot: ",avg:"media: ",min:"minimo: ",max:"massimo: "},pinning:{pinLeft:"Blocca a sx",pinRight:"Blocca a dx",unpin:"Blocca in alto"},gridMenu:{columns:"Colonne:",importerTitle:"Importa",exporterAllAsCsv:"Esporta tutti i dati in CSV",exporterVisibleAsCsv:"Esporta i dati visibili in CSV",exporterSelectedAsCsv:"Esporta i dati selezionati in CSV",exporterAllAsPdf:"Esporta tutti i dati in PDF",exporterVisibleAsPdf:"Esporta i dati visibili in PDF",exporterSelectedAsPdf:"Esporta i dati selezionati in PDF",exporterAllAsExcel:"Esporta tutti i dati in excel",exporterVisibleAsExcel:"Esporta i dati visibili in excel",exporterSelectedAsExcel:"Esporta i dati selezionati in excel",clearAllFilters:"Pulire tutti i filtri"},importer:{noHeaders:"Impossibile reperire i nomi delle colonne, sicuro che siano indicati all'interno del file?",noObjects:"Impossibile reperire gli oggetti, sicuro che siano indicati all'interno del file?",invalidCsv:"Impossibile elaborare il file, sicuro che sia un CSV?",invalidJson:"Impossibile elaborare il file, sicuro che sia un JSON valido?",jsonNotArray:"Errore! Il file JSON da importare deve contenere un array."},pagination:{aria:{pageToFirst:"Prima",pageBack:"Indietro",pageSelected:"Pagina selezionata",pageForward:"Avanti",pageToLast:"Ultima"},sizes:"elementi per pagina",totalItems:"elementi",through:"a",of:"di"},grouping:{group:"Raggruppa",ungroup:"Separa",aggregate_count:"Agg: N. Elem.",aggregate_sum:"Agg: Somma",aggregate_max:"Agg: Massimo",aggregate_min:"Agg: Minimo",aggregate_avg:"Agg: Media",aggregate_remove:"Agg: Rimuovi"},validate:{error:"Errore:",minLength:"Lunghezza minima pari a THRESHOLD caratteri.",maxLength:"Lunghezza massima pari a THRESHOLD caratteri.",required:"Necessario inserire un valore."}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("ja",{headerCell:{aria:{defaultFilterLabel:"列のフィルター",removeFilter:"フィルターの解除",columnMenuButtonLabel:"列のメニュー"},priority:"優先度:",filterLabel:"列フィルター: "},aggregate:{label:"項目"},groupPanel:{description:"ここに列ヘッダをドラッグアンドドロップして、その列でグループ化します。"},search:{placeholder:"検索...",showingItems:"表示中の項目:",selectedItems:"選択した項目:",totalItems:"項目の総数:",size:"ページサイズ:",first:"最初のページ",next:"次のページ",previous:"前のページ",last:"前のページ"},menu:{text:"列の選択:"},sort:{ascending:"昇順に並べ替え",descending:"降順に並べ替え",none:"並べ替え無し",remove:"並べ替えの解除"},column:{hide:"列の非表示"},aggregation:{count:"行数: ",sum:"合計: ",avg:"平均: ",min:"最小: ",max:"最大: "},pinning:{pinLeft:"左に固定",pinRight:"右に固定",unpin:"固定解除"},columnMenu:{close:"閉じる"},gridMenu:{aria:{buttonLabel:"グリッドメニュー"},columns:"列の表示/非表示:",importerTitle:"ファイルのインポート",exporterAllAsCsv:"すべてのデータをCSV形式でエクスポート",exporterVisibleAsCsv:"表示中のデータをCSV形式でエクスポート",exporterSelectedAsCsv:"選択したデータをCSV形式でエクスポート",exporterAllAsPdf:"すべてのデータをPDF形式でエクスポート",exporterVisibleAsPdf:"表示中のデータをPDF形式でエクスポート",exporterSelectedAsPdf:"選択したデータをPDF形式でエクスポート",clearAllFilters:"すべてのフィルタをクリア"},importer:{noHeaders:"列名を取得できません。ファイルにヘッダが含まれていることを確認してください。",noObjects:"オブジェクトを取得できません。ファイルにヘッダ以外のデータが含まれていることを確認してください。",invalidCsv:"ファイルを処理できません。ファイルが有効なCSV形式であることを確認してください。",invalidJson:"ファイルを処理できません。ファイルが有効なJSON形式であることを確認してください。",jsonNotArray:"インポートしたJSONファイルには配列が含まれている必要があります。処理を中止します。"},pagination:{aria:{pageToFirst:"最初のページ",pageBack:"前のページ",pageSelected:"現在のページ",pageForward:"次のページ",pageToLast:"最後のページ"},sizes:"件/ページ",totalItems:"件",through:"から",of:"件/全"},grouping:{group:"グループ化",ungroup:"グループ化の解除",aggregate_count:"集計表示: 行数",aggregate_sum:"集計表示: 合計",aggregate_max:"集計表示: 最大",aggregate_min:"集計表示: 最小",aggregate_avg:"集計表示: 平均",aggregate_remove:"集計表示: 解除"},validate:{error:"Error:",minLength:"THRESHOLD 文字以上で入力してください。",maxLength:"THRESHOLD 文字以下で入力してください。",required:"値が必要です。"}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("ko",{aggregate:{label:"아이템"},groupPanel:{description:"컬럼으로 그룹핑하기 위해서는 컬럼 헤더를 끌어 떨어뜨려 주세요."},search:{placeholder:"검색...",showingItems:"항목 보여주기:",selectedItems:"선택 항목:",totalItems:"전체 항목:",size:"페이지 크기:",first:"첫번째 페이지",next:"다음 페이지",previous:"이전 페이지",last:"마지막 페이지"},menu:{text:"컬럼을 선택하세요:"},sort:{ascending:"오름차순 정렬",descending:"내림차순 정렬",remove:"소팅 제거"},column:{hide:"컬럼 제거"},aggregation:{count:"전체 갯수: ",sum:"전체: ",avg:"평균: ",min:"최소: ",max:"최대: "},pinning:{pinLeft:"왼쪽 핀",pinRight:"오른쪽 핀",unpin:"핀 제거"},gridMenu:{columns:"컬럼:",importerTitle:"파일 가져오기",exporterAllAsCsv:"csv로 모든 데이터 내보내기",exporterVisibleAsCsv:"csv로 보이는 데이터 내보내기",exporterSelectedAsCsv:"csv로 선택된 데이터 내보내기",exporterAllAsPdf:"pdf로 모든 데이터 내보내기",exporterVisibleAsPdf:"pdf로 보이는 데이터 내보내기",exporterSelectedAsPdf:"pdf로 선택 데이터 내보내기",clearAllFilters:"모든 필터를 청소"},importer:{noHeaders:"컬럼명이 지정되어 있지 않습니다. 파일에 헤더가 명시되어 있는지 확인해 주세요.",noObjects:"데이터가 지정되어 있지 않습니다. 데이터가 파일에 있는지 확인해 주세요.",invalidCsv:"파일을 처리할 수 없습니다. 올바른 csv인지 확인해 주세요.",invalidJson:"파일을 처리할 수 없습니다. 올바른 json인지 확인해 주세요.",jsonNotArray:"json 파일은 배열을 포함해야 합니다."},pagination:{sizes:"페이지당 항목",totalItems:"전체 항목"}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("nl",{aggregate:{label:"items"},groupPanel:{description:"Sleep hier een kolomnaam heen om op te groeperen."},search:{placeholder:"Zoeken...",showingItems:"Getoonde items:",selectedItems:"Geselecteerde items:",totalItems:"Totaal aantal items:",size:"Items per pagina:",first:"Eerste pagina",next:"Volgende pagina",previous:"Vorige pagina",last:"Laatste pagina"},menu:{text:"Kies kolommen:"},sort:{ascending:"Sorteer oplopend",descending:"Sorteer aflopend",remove:"Verwijder sortering"},column:{hide:"Verberg kolom"},aggregation:{count:"Aantal rijen: ",sum:"Som: ",avg:"Gemiddelde: ",min:"Min: ",max:"Max: "},pinning:{pinLeft:"Zet links vast",pinRight:"Zet rechts vast",unpin:"Maak los"},gridMenu:{columns:"Kolommen:",importerTitle:"Importeer bestand",exporterAllAsCsv:"Exporteer alle data als csv",exporterVisibleAsCsv:"Exporteer zichtbare data als csv",exporterSelectedAsCsv:"Exporteer geselecteerde data als csv",exporterAllAsPdf:"Exporteer alle data als pdf",exporterVisibleAsPdf:"Exporteer zichtbare data als pdf",exporterSelectedAsPdf:"Exporteer geselecteerde data als pdf",exporterAllAsExcel:"Exporteer alle data als excel",exporterVisibleAsExcel:"Exporteer zichtbare data als excel",exporterSelectedAsExcel:"Exporteer alle data als excel",clearAllFilters:"Alle filters wissen"},importer:{noHeaders:"Kolomnamen kunnen niet worden afgeleid. Heeft het bestand een header?",noObjects:"Objecten kunnen niet worden afgeleid. Bevat het bestand data naast de headers?",invalidCsv:"Het bestand kan niet verwerkt worden. Is het een valide csv bestand?",invalidJson:"Het bestand kan niet verwerkt worden. Is het valide json?",jsonNotArray:"Het json bestand moet een array bevatten. De actie wordt geannuleerd."},pagination:{sizes:"items per pagina",totalItems:"items",of:"van de"},grouping:{group:"Groepeer",ungroup:"Groepering opheffen",aggregate_count:"Agg: Aantal",aggregate_sum:"Agg: Som",aggregate_max:"Agg: Max",aggregate_min:"Agg: Min",aggregate_avg:"Agg: Gem",aggregate_remove:"Agg: Verwijder"}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("no",{headerCell:{aria:{defaultFilterLabel:"Filter for kolonne",removeFilter:"Fjern filter",columnMenuButtonLabel:"Kolonnemeny"},priority:"Prioritet:",filterLabel:"Filter for kolonne: "},aggregate:{label:"elementer"},groupPanel:{description:"Trekk en kolonneoverskrift hit og slipp den for å gruppere etter den kolonnen."},search:{placeholder:"Søk...",showingItems:"Viste elementer:",selectedItems:"Valgte elementer:",totalItems:"Antall elementer:",size:"Sidestørrelse:",first:"Første side",next:"Neste side",previous:"Forrige side",last:"Siste side"},menu:{text:"Velg kolonner:"},sort:{ascending:"Sortere stigende",descending:"Sortere fallende",none:"Ingen sortering",remove:"Fjern sortering"},column:{hide:"Skjul kolonne"},aggregation:{count:"antall rader: ",sum:"total: ",avg:"gjennomsnitt: ",min:"minimum: ",max:"maksimum: "},pinning:{pinLeft:"Fest til venstre",pinRight:"Fest til høyre",unpin:"Løsne"},columnMenu:{close:"Lukk"},gridMenu:{aria:{buttonLabel:"Grid Menu"},columns:"Kolonner:",importerTitle:"Importer fil",exporterAllAsCsv:"Eksporter alle data som csv",exporterVisibleAsCsv:"Eksporter synlige data som csv",exporterSelectedAsCsv:"Eksporter utvalgte data som csv",exporterAllAsPdf:"Eksporter alle data som pdf",exporterVisibleAsPdf:"Eksporter synlige data som pdf",exporterSelectedAsPdf:"Eksporter utvalgte data som pdf",exporterAllAsExcel:"Eksporter alle data som excel",exporterVisibleAsExcel:"Eksporter synlige data som excel",exporterSelectedAsExcel:"Eksporter utvalgte data som excel",clearAllFilters:"Clear all filters"},importer:{noHeaders:"Kolonnenavn kunne ikke avledes. Har filen en overskrift?",noObjects:"Objekter kunne ikke avledes. Er der andre data i filen enn overskriften?",invalidCsv:"Filen kunne ikke behandles. Er den gyldig CSV?",invalidJson:"Filen kunne ikke behandles. Er den gyldig JSON?",jsonNotArray:"Importert JSON-fil må inneholde en liste. Avbryter."},pagination:{aria:{pageToFirst:"Gå til første side",pageBack:"Gå til forrige side",pageSelected:"Valgte side",pageForward:"Gå til neste side",pageToLast:"Gå til siste side"},sizes:"elementer per side",totalItems:"elementer",through:"til",of:"av"},grouping:{group:"Gruppere",ungroup:"Fjerne gruppering",aggregate_count:"Agr: Antall",aggregate_sum:"Agr: Sum",aggregate_max:"Agr: Maksimum",aggregate_min:"Agr: Minimum",aggregate_avg:"Agr: Gjennomsnitt",aggregate_remove:"Agr: Fjern"}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("pl",{headerCell:{aria:{defaultFilterLabel:"Filtr dla kolumny",removeFilter:"Usuń filtr",columnMenuButtonLabel:"Opcje kolumny",column:"Kolumna"},priority:"Priorytet:",filterLabel:"Filtr dla kolumny: "},aggregate:{label:"pozycji"},groupPanel:{description:"Przeciągnij nagłówek kolumny tutaj, aby pogrupować według niej."},search:{aria:{selected:"Wiersz zaznaczony",notSelected:"Wiersz niezaznaczony"},placeholder:"Szukaj...",showingItems:"Widoczne pozycje:",selectedItems:"Zaznaczone pozycje:",totalItems:"Wszystkich pozycji:",size:"Rozmiar strony:",first:"Pierwsza strona",next:"Następna strona",previous:"Poprzednia strona",last:"Ostatnia strona"},menu:{text:"Wybierz kolumny:"},sort:{ascending:"Sortuj rosnąco",descending:"Sortuj malejąco",none:"Brak sortowania",remove:"Wyłącz sortowanie"},column:{hide:"Ukryj kolumnę"},aggregation:{count:"Razem pozycji: ",sum:"Razem: ",avg:"Średnia: ",min:"Min: ",max:"Max: "},pinning:{pinLeft:"Przypnij do lewej",pinRight:"Przypnij do prawej",unpin:"Odepnij"},columnMenu:{close:"Zamknij"},gridMenu:{aria:{buttonLabel:"Opcje tabeli"},columns:"Kolumny:",importerTitle:"Importuj plik",exporterAllAsCsv:"Eksportuj wszystkie dane do csv",exporterVisibleAsCsv:"Eksportuj widoczne dane do csv",exporterSelectedAsCsv:"Eksportuj zaznaczone dane do csv",exporterAllAsPdf:"Eksportuj wszystkie dane do pdf",exporterVisibleAsPdf:"Eksportuj widoczne dane do pdf",exporterSelectedAsPdf:"Eksportuj zaznaczone dane do pdf",exporterAllAsExcel:"Eksportuj wszystkie dane do excel",exporterVisibleAsExcel:"Eksportuj widoczne dane do excel",exporterSelectedAsExcel:"Eksportuj zaznaczone dane do excel",clearAllFilters:"Wyczyść filtry"},importer:{noHeaders:"Nie udało się wczytać nazw kolumn. Czy plik posiada nagłówek?",noObjects:"Nie udalo się wczytać pozycji. Czy plik zawiera dane?",invalidCsv:"Nie udało się przetworzyć pliku. Czy to prawidłowy plik CSV?",invalidJson:"Nie udało się przetworzyć pliku. Czy to prawidłowy plik JSON?",jsonNotArray:"Importowany plik JSON musi zawierać tablicę. Importowanie przerwane."},pagination:{aria:{pageToFirst:"Pierwsza strona",pageBack:"Poprzednia strona",pageSelected:"Wybrana strona",pageForward:"Następna strona",pageToLast:"Ostatnia strona"},sizes:"pozycji na stronę",totalItems:"pozycji",through:"do",of:"z"},grouping:{group:"Grupuj",ungroup:"Rozgrupuj",aggregate_count:"Zbiorczo: Razem",aggregate_sum:"Zbiorczo: Suma",aggregate_max:"Zbiorczo: Max",aggregate_min:"Zbiorczo: Min",aggregate_avg:"Zbiorczo: Średnia",aggregate_remove:"Zbiorczo: Usuń"},validate:{error:"Błąd:",minLength:"Wartość powinna składać się z co najmniej THRESHOLD znaków.",maxLength:"Wartość powinna składać się z przynajmniej THRESHOLD znaków.",required:"Wartość jest wymagana."}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("pt-br",{headerCell:{aria:{defaultFilterLabel:"Filtro por coluna",removeFilter:"Remover filtro",columnMenuButtonLabel:"Menu coluna",column:"Coluna"},priority:"Prioridade:",filterLabel:"Filtro por coluna: "},aggregate:{label:"itens"},groupPanel:{description:"Arraste e solte uma coluna aqui para agrupar por essa coluna"},search:{aria:{selected:"Linha selecionada",notSelected:"Linha não está selecionada"},placeholder:"Procurar...",showingItems:"Mostrando os Itens:",selectedItems:"Items Selecionados:",totalItems:"Total de Itens:",size:"Tamanho da Página:",first:"Primeira Página",next:"Próxima Página",previous:"Página Anterior",last:"Última Página"},selection:{aria:{row:"Linha"},selectAll:"Selecionar Tudo",displayName:"Caixa de Seleção da Linha"},menu:{text:"Selecione as colunas:"},sort:{ascending:"Ordenar Ascendente",descending:"Ordenar Descendente",none:"Nenhuma Ordem",remove:"Remover Ordenação"},column:{hide:"Esconder coluna"},aggregation:{count:"total de linhas: ",sum:"total: ",avg:"med: ",min:"min: ",max:"max: "},pinning:{pinLeft:"Fixar Esquerda",pinRight:"Fixar Direita",unpin:"Desprender"},columnMenu:{close:"Fechar"},gridMenu:{aria:{buttonLabel:"Menu Grid"},columns:"Colunas:",importerTitle:"Importar arquivo",exporterAllAsCsv:"Exportar todos os dados como csv",exporterVisibleAsCsv:"Exportar dados visíveis como csv",exporterSelectedAsCsv:"Exportar dados selecionados como csv",exporterAllAsPdf:"Exportar todos os dados como pdf",exporterVisibleAsPdf:"Exportar dados visíveis como pdf",exporterSelectedAsPdf:"Exportar dados selecionados como pdf",exporterAllAsExcel:"Exportar todos os dados como excel",exporterVisibleAsExcel:"Exportar dados visíveis como excel",exporterSelectedAsExcel:"Exportar dados selecionados como excel",clearAllFilters:"Limpar todos os filtros"},importer:{noHeaders:"Nomes de colunas não puderam ser derivados. O arquivo tem um cabeçalho?",noObjects:"Objetos não puderam ser derivados. Havia dados no arquivo, além dos cabeçalhos?",invalidCsv:"Arquivo não pode ser processado. É um CSV válido?",invalidJson:"Arquivo não pode ser processado. É um Json válido?",jsonNotArray:"Arquivo json importado tem que conter um array. Abortando."},pagination:{aria:{pageToFirst:"Primeira página",pageBack:"Página anterior",pageSelected:"Página Selecionada",pageForward:"Proxima",pageToLast:"Anterior"},sizes:"itens por página",totalItems:"itens",through:"através dos",of:"de"},grouping:{group:"Agrupar",ungroup:"Desagrupar",aggregate_count:"Agr: Contar",aggregate_sum:"Agr: Soma",aggregate_max:"Agr: Max",aggregate_min:"Agr: Min",aggregate_avg:"Agr: Med",aggregate_remove:"Agr: Remover"},validate:{error:"Erro:",minLength:"O valor deve ter, no minimo, THRESHOLD caracteres.",maxLength:"O valor deve ter, no máximo, THRESHOLD caracteres.",required:"Um valor é necessário."}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("pt",{headerCell:{aria:{defaultFilterLabel:"Filtro por coluna",removeFilter:"Remover filtro",columnMenuButtonLabel:"Menu coluna",column:"Coluna"},priority:"Prioridade:",filterLabel:"Filtro por coluna: "},aggregate:{label:"itens"},groupPanel:{description:"Arraste e solte uma coluna aqui para agrupar por essa coluna"},search:{aria:{selected:"Linha selecionada",notSelected:"Linha não está selecionada"},placeholder:"Procurar...",showingItems:"Mostrando os Itens:",selectedItems:"Itens Selecionados:",totalItems:"Total de Itens:",size:"Tamanho da Página:",first:"Primeira Página",next:"Próxima Página",previous:"Página Anterior",last:"Última Página"},selection:{aria:{row:"Linha"},selectAll:"Selecionar Tudo",displayName:"Caixa de Seleção da Linha"},menu:{text:"Selecione as colunas:"},sort:{ascending:"Ordenar Ascendente",descending:"Ordenar Descendente",none:"Nenhuma Ordem",remove:"Remover Ordenação"},column:{hide:"Esconder coluna"},aggregation:{count:"total de linhas: ",sum:"total: ",avg:"med: ",min:"min: ",max:"max: "},pinning:{pinLeft:"Fixar Esquerda",pinRight:"Fixar Direita",unpin:"Desprender"},columnMenu:{close:"Fechar"},gridMenu:{aria:{buttonLabel:"Menu Grid"},columns:"Colunas:",importerTitle:"Importar ficheiro",exporterAllAsCsv:"Exportar todos os dados como csv",exporterVisibleAsCsv:"Exportar dados visíveis como csv",exporterSelectedAsCsv:"Exportar dados selecionados como csv",exporterAllAsPdf:"Exportar todos os dados como pdf",exporterVisibleAsPdf:"Exportar dados visíveis como pdf",exporterSelectedAsPdf:"Exportar dados selecionados como pdf",exporterAllAsExcel:"Exportar todos os dados como excel",exporterVisibleAsExcel:"Exportar dados visíveis como excel",exporterSelectedAsExcel:"Exportar dados selecionados como excel",clearAllFilters:"Limpar todos os filtros"},importer:{noHeaders:"Nomes de colunas não puderam ser derivados. O ficheiro tem um cabeçalho?",noObjects:"Objetos não puderam ser derivados. Havia dados no ficheiro, além dos cabeçalhos?",invalidCsv:"Ficheiro não pode ser processado. É um CSV válido?",invalidJson:"Ficheiro não pode ser processado. É um Json válido?",jsonNotArray:"Ficheiro json importado tem que conter um array. Interrompendo."},pagination:{aria:{pageToFirst:"Primeira página",pageBack:"Página anterior",pageSelected:"Página Selecionada",pageForward:"Próxima",pageToLast:"Anterior"},sizes:"itens por página",totalItems:"itens",through:"a",of:"de"},grouping:{group:"Agrupar",ungroup:"Desagrupar",aggregate_count:"Agr: Contar",aggregate_sum:"Agr: Soma",aggregate_max:"Agr: Max",aggregate_min:"Agr: Min",aggregate_avg:"Agr: Med",aggregate_remove:"Agr: Remover"},validate:{error:"Erro:",minLength:"O valor deve ter, no minimo, THRESHOLD caracteres.",maxLength:"O valor deve ter, no máximo, THRESHOLD caracteres.",required:"Um valor é necessário."}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("ro",{headerCell:{aria:{defaultFilterLabel:"Filtru pentru coloana",removeFilter:"Sterge filtru",columnMenuButtonLabel:"Column Menu"},priority:"Prioritate:",filterLabel:"Filtru pentru coloana:"},aggregate:{label:"Elemente"},groupPanel:{description:"Trage un cap de coloana aici pentru a grupa elementele dupa coloana respectiva"},search:{placeholder:"Cauta...",showingItems:"Arata elementele:",selectedItems:"Elementele selectate:",totalItems:"Total elemente:",size:"Marime pagina:",first:"Prima pagina",next:"Pagina urmatoare",previous:"Pagina anterioara",last:"Ultima pagina"},menu:{text:"Alege coloane:"},sort:{ascending:"Ordoneaza crescator",descending:"Ordoneaza descrescator",none:"Fara ordonare",remove:"Sterge ordonarea"},column:{hide:"Ascunde coloana"},aggregation:{count:"total linii: ",sum:"total: ",avg:"medie: ",min:"min: ",max:"max: "},pinning:{pinLeft:"Pin la stanga",pinRight:"Pin la dreapta",unpin:"Sterge pinul"},columnMenu:{close:"Inchide"},gridMenu:{aria:{buttonLabel:"Grid Menu"},columns:"Coloane:",importerTitle:"Incarca fisier",exporterAllAsCsv:"Exporta toate datele ca csv",exporterVisibleAsCsv:"Exporta datele vizibile ca csv",exporterSelectedAsCsv:"Exporta datele selectate ca csv",exporterAllAsPdf:"Exporta toate datele ca pdf",exporterVisibleAsPdf:"Exporta datele vizibile ca pdf",exporterSelectedAsPdf:"Exporta datele selectate ca csv pdf",clearAllFilters:"Sterge toate filtrele"},importer:{noHeaders:"Numele coloanelor nu a putut fi incarcat, acest fisier are un header?",noObjects:"Datele nu au putut fi incarcate, exista date in fisier in afara numelor de coloane?",invalidCsv:"Fisierul nu a putut fi procesat, ati incarcat un CSV valid ?",invalidJson:"Fisierul nu a putut fi procesat, ati incarcat un Json valid?",jsonNotArray:"Json-ul incarcat trebuie sa contina un array, inchidere."},pagination:{aria:{pageToFirst:"Prima pagina",pageBack:"O pagina inapoi",pageSelected:"Pagina selectata",pageForward:"O pagina inainte",pageToLast:"Ultima pagina"},sizes:"Elemente per pagina",totalItems:"elemente",through:"prin",of:"of"},grouping:{group:"Grupeaza",ungroup:"Opreste gruparea",aggregate_count:"Agg: Count",aggregate_sum:"Agg: Sum",aggregate_max:"Agg: Max",aggregate_min:"Agg: Min",aggregate_avg:"Agg: Avg",aggregate_remove:"Agg: Remove"}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("rs-lat",{headerCell:{aria:{defaultFilterLabel:"Filter za kolonu",removeFilter:"Ukloni Filter",columnMenuButtonLabel:"Meni Kolone",column:"Kolona"},priority:"Prioritet:",filterLabel:"Filter za kolonu: "},aggregate:{label:"stavke"},groupPanel:{description:"Ovde prevuci zaglavlje kolone i spusti do grupe pored te kolone."},search:{aria:{selected:"Red odabran",notSelected:"Red nije odabran"},placeholder:"Pretraga...",showingItems:"Prikazane Stavke:",selectedItems:"Odabrane Stavke:",totalItems:"Ukupno Stavki:",size:"Veličina Stranice:",first:"Prva Stranica",next:"Sledeća Stranica",previous:"Prethodna Stranica",last:"Poslednja Stranica"},menu:{text:"Odaberite kolonu:"},sort:{ascending:"Sortiraj po rastućem redosledu",descending:"Sortiraj po opadajućem redosledu",none:"Bez Sortiranja",remove:"Ukloni Sortiranje"},column:{hide:"Sakrij Kolonu"},aggregation:{count:"ukupno redova: ",sum:"ukupno: ",avg:"prosecno: ",min:"minimum: ",max:"maksimum: "},pinning:{pinLeft:"Zakači Levo",pinRight:"Zakači Desno",unpin:"Otkači"},columnMenu:{close:"Zatvori"},gridMenu:{aria:{buttonLabel:"Rešetkasti Meni"},columns:"Kolone:",importerTitle:"Importuj fajl",exporterAllAsCsv:"Eksportuj sve podatke kao csv",exporterVisibleAsCsv:"Eksportuj vidljive podatke kao csv",exporterSelectedAsCsv:"Eksportuj obeležene podatke kao csv",exporterAllAsPdf:"Eksportuj sve podatke kao pdf",exporterVisibleAsPdf:"Eksportuj vidljive podake kao pdf",exporterSelectedAsPdf:"Eksportuj odabrane podatke kao pdf",exporterAllAsExcel:"Eksportuj sve podatke kao excel",exporterVisibleAsExcel:"Eksportuj vidljive podatke kao excel",exporterSelectedAsExcel:"Eksportuj odabrane podatke kao excel",clearAllFilters:"Obriši sve filtere"},importer:{noHeaders:"Kolone se nisu mogle podeliti, da li fajl poseduje heder?",noObjects:"Objecti nisu mogli biti podeljeni, da li je bilo i drugih podataka sem hedera?",invalidCsv:"Fajl nije bilo moguće procesirati, da li je ispravni CSV?",invalidJson:"Fajl nije bilo moguće procesirati, da li je ispravni JSON",jsonNotArray:"Importovani json fajl mora da sadrži niz, prekidam operaciju."},pagination:{aria:{pageToFirst:"Prva stranica",pageBack:"Stranica pre",pageSelected:"Odabrana stranica",pageForward:"Sledeća stranica",pageToLast:"Poslednja stranica"},sizes:"stavki po stranici",totalItems:"stavke",through:"kroz",of:"od"},grouping:{group:"Grupiši",ungroup:"Odrupiši",aggregate_count:"Agg: Broj",aggregate_sum:"Agg: Suma",aggregate_max:"Agg: Maksimum",aggregate_min:"Agg: Minimum",aggregate_avg:"Agg: Prosečna",aggregate_remove:"Agg: Ukloni"},validate:{error:"Greška:",minLength:"Vrednost bi trebala da bude duga bar THRESHOLD karaktera.",maxLength:"Vrednost bi trebalo da bude najviše duga THRESHOLD karaktera.",required:"Portreba je vrednost."}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("ru",{headerCell:{aria:{defaultFilterLabel:"Фильтр столбца",removeFilter:"Удалить фильтр",columnMenuButtonLabel:"Меню столбца"},priority:"Приоритет:",filterLabel:"Фильтр столбца: "},aggregate:{label:"элементы"},groupPanel:{description:"Для группировки по столбцу перетащите сюда его название."},search:{placeholder:"Поиск...",showingItems:"Показать элементы:",selectedItems:"Выбранные элементы:",totalItems:"Всего элементов:",size:"Размер страницы:",first:"Первая страница",next:"Следующая страница",previous:"Предыдущая страница",last:"Последняя страница"},menu:{text:"Выбрать столбцы:"},sort:{ascending:"По возрастанию",descending:"По убыванию",none:"Без сортировки",remove:"Убрать сортировку"},column:{hide:"Спрятать столбец"},aggregation:{count:"всего строк: ",sum:"итого: ",avg:"среднее: ",min:"мин: ",max:"макс: "},pinning:{pinLeft:"Закрепить слева",pinRight:"Закрепить справа",unpin:"Открепить"},columnMenu:{close:"Закрыть"},gridMenu:{aria:{buttonLabel:"Меню"},columns:"Столбцы:",importerTitle:"Импортировать файл",exporterAllAsCsv:"Экспортировать всё в CSV",exporterVisibleAsCsv:"Экспортировать видимые данные в CSV",exporterSelectedAsCsv:"Экспортировать выбранные данные в CSV",exporterAllAsPdf:"Экспортировать всё в PDF",exporterVisibleAsPdf:"Экспортировать видимые данные в PDF",exporterSelectedAsPdf:"Экспортировать выбранные данные в PDF",exporterAllAsExcel:"Экспортировать всё в Excel",exporterVisibleAsExcel:"Экспортировать видимые данные в Excel",exporterSelectedAsExcel:"Экспортировать выбранные данные в Excel",clearAllFilters:"Очистить все фильтры"},importer:{noHeaders:"Не удалось получить названия столбцов, есть ли в файле заголовок?",noObjects:"Не удалось получить данные, есть ли в файле строки кроме заголовка?",invalidCsv:"Не удалось обработать файл, это правильный CSV-файл?",invalidJson:"Не удалось обработать файл, это правильный JSON?",jsonNotArray:"Импортируемый JSON-файл должен содержать массив, операция отменена."},pagination:{aria:{pageToFirst:"Первая страница",pageBack:"Предыдущая страница",pageSelected:"Выбранная страница",pageForward:"Следующая страница",pageToLast:"Последняя страница"},sizes:"строк на страницу",totalItems:"строк",through:"по",of:"из"},grouping:{group:"Группировать",ungroup:"Разгруппировать",aggregate_count:"Группировать: Количество",aggregate_sum:"Для группы: Сумма",aggregate_max:"Для группы: Максимум",aggregate_min:"Для группы: Минимум",aggregate_avg:"Для группы: Среднее",aggregate_remove:"Для группы: Пусто"}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("sk",{headerCell:{aria:{defaultFilterLabel:"Filter pre stĺpec",removeFilter:"Odstrániť filter",columnMenuButtonLabel:"Menu pre stĺpec",column:"Stĺpec"},priority:"Priorita:",filterLabel:"Filter pre stĺpec: "},aggregate:{label:"položky"},groupPanel:{description:"Pretiahni sem názov stĺpca pre zoskupenie podľa toho stĺpca."},search:{aria:{selected:"Označený riadok",notSelected:"Neoznačený riadok"},placeholder:"Hľadaj...",showingItems:"Zobrazujem položky:",selectedItems:"Vybraté položky:",totalItems:"Počet položiek:",size:"Počet:",first:"Prvá strana",next:"Ďalšia strana",previous:"Predchádzajúca strana",last:"Posledná strana"},menu:{text:"Vyberte stĺpce:"},sort:{ascending:"Zotriediť vzostupne",descending:"Zotriediť zostupne",none:"Nezotriediť",remove:"Vymazať triedenie"},column:{hide:"Skryť stĺpec"},aggregation:{count:"počet riadkov: ",sum:"spolu: ",avg:"avg: ",min:"min: ",max:"max: "},pinning:{pinLeft:"Pripnúť vľavo",pinRight:"Pripnúť vpravo",unpin:"Odopnúť"},columnMenu:{close:"Zavrieť"},gridMenu:{aria:{buttonLabel:"Grid Menu"},columns:"Stĺpce:",importerTitle:"Importovať súbor",exporterAllAsCsv:"Exportovať všetky údaje ako CSV",exporterVisibleAsCsv:"Exportovť viditeľné údaje ako CSV",exporterSelectedAsCsv:"Exportovať označené údaje ako CSV",exporterAllAsPdf:"Exportovať všetky údaje ako pdf",exporterVisibleAsPdf:"Exportovať viditeľné údaje ako pdf",exporterSelectedAsPdf:"Exportovať označené údaje ako pdf",exporterAllAsExcel:"Exportovať všetky údaje ako excel",exporterVisibleAsExcel:"Exportovať viditeľné údaje ako excel",exporterSelectedAsExcel:"Exportovať označené údaje ako excel",clearAllFilters:"Zrušiť všetky filtre"},importer:{noHeaders:"Názvy stĺpcov sa nedali odvodiť, má súbor hlavičku?",noObjects:"Objekty nebolo možné odvodiť, existovali iné údaje v súbore ako hlavičky?",invalidCsv:"Súbor sa nepodarilo spracovať, je to platný súbor CSV?",invalidJson:"Súbor nebolo možné spracovať, je to platný súbor typu Json?",jsonNotArray:"Importovaný súbor json musí obsahovať pole, ukončujem."},pagination:{aria:{pageToFirst:"Strana na začiatok",pageBack:"Strana dozadu",pageSelected:"Označená strana",pageForward:"Strana dopredu",pageToLast:"Strana na koniec"},sizes:"položky na stranu",totalItems:"položky spolu",through:"do konca",of:"z"},grouping:{group:"Zoskupiť",ungroup:"Zrušiť zoskupenie",aggregate_count:"Agg: Počet",aggregate_sum:"Agg: Suma",aggregate_max:"Agg: Max",aggregate_min:"Agg: Min",aggregate_avg:"Agg: Avg",aggregate_remove:"Agg: Zrušiť"},validate:{error:"Chyba:",minLength:"Hodnota by mala mať aspoň THRESHOLD znakov dlhá.",maxLength:"Hodnota by mala byť maximálne THRESHOLD znakov dlhá.",required:"Vyžaduje sa hodnota."}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("sv",{headerCell:{aria:{defaultFilterLabel:"Kolumnfilter",removeFilter:"Ta bort filter",columnMenuButtonLabel:"Kolumnmeny",column:"Kolumn"},priority:"Prioritet:",filterLabel:"Filter för kolumn: "},aggregate:{label:"Poster"},groupPanel:{description:"Dra en kolumnrubrik hit och släpp den för att gruppera efter den kolumnen."},search:{aria:{selected:"Rad är vald",notSelected:"Rad är inte vald"},placeholder:"Sök...",showingItems:"Visar:",selectedItems:"Valda:",totalItems:"Antal:",size:"Sidstorlek:",first:"Första sidan",next:"Nästa sida",previous:"Föregående sida",last:"Sista sidan"},menu:{text:"Välj kolumner:"},sort:{ascending:"Sortera stigande",descending:"Sortera fallande",none:"Ingen sortering",remove:"Inaktivera sortering"},column:{hide:"Göm kolumn"},aggregation:{count:"Antal rader: ",sum:"Summa: ",avg:"Genomsnitt: ",min:"Min: ",max:"Max: "},pinning:{pinLeft:"Fäst vänster",pinRight:"Fäst höger",unpin:"Lösgör"},columnMenu:{close:"Stäng"},gridMenu:{aria:{buttonLabel:"Meny"},columns:"Kolumner:",importerTitle:"Importera fil",exporterAllAsCsv:"Exportera all data som CSV",exporterVisibleAsCsv:"Exportera synlig data som CSV",exporterSelectedAsCsv:"Exportera markerad data som CSV",exporterAllAsPdf:"Exportera all data som PDF",exporterVisibleAsPdf:"Exportera synlig data som PDF",exporterSelectedAsPdf:"Exportera markerad data som PDF",exporterAllAsExcel:"Exportera all data till Excel",exporterVisibleAsExcel:"Exportera synlig data till Excel",exporterSelectedAsExcel:"Exportera markerad data till Excel",clearAllFilters:"Nollställ alla filter"},importer:{noHeaders:"Kolumnnamn kunde inte härledas. Har filen ett sidhuvud?",noObjects:"Objekt kunde inte härledas. Har filen data undantaget sidhuvud?",invalidCsv:"Filen kunde inte behandlas, är den en giltig CSV?",invalidJson:"Filen kunde inte behandlas, är den en giltig JSON?",jsonNotArray:"Importerad JSON-fil måste innehålla ett fält. Import avbruten."},pagination:{aria:{pageToFirst:"Gå till första sidan",pageBack:"Gå en sida bakåt",pageSelected:"Vald sida",pageForward:"Gå en sida framåt",pageToLast:"Gå till sista sidan"},sizes:"Poster per sida",totalItems:"Poster",through:"genom",of:"av"},grouping:{group:"Gruppera",ungroup:"Dela upp",aggregate_count:"Agg: Antal",aggregate_sum:"Agg: Summa",aggregate_max:"Agg: Max",aggregate_min:"Agg: Min",aggregate_avg:"Agg: Genomsnitt",aggregate_remove:"Agg: Ta bort"},validate:{error:"Error:",minLength:"Värdet borde vara minst THRESHOLD tecken långt.",maxLength:"Värdet borde vara max THRESHOLD tecken långt.",required:"Ett värde krävs."}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("ta",{aggregate:{label:"உருப்படிகள்"},groupPanel:{description:"ஒரு பத்தியை குழுவாக அமைக்க அப்பத்தியின் தலைப்பை இங்கே  இழுத்து வரவும் "},search:{placeholder:"தேடல் ...",showingItems:"உருப்படிகளை காண்பித்தல்:",selectedItems:"தேர்ந்தெடுக்கப்பட்ட  உருப்படிகள்:",totalItems:"மொத்த உருப்படிகள்:",size:"பக்க அளவு: ",first:"முதல் பக்கம்",next:"அடுத்த பக்கம்",previous:"முந்தைய பக்கம் ",last:"இறுதி பக்கம்"},menu:{text:"பத்திகளை தேர்ந்தெடு:"},sort:{ascending:"மேலிருந்து கீழாக",descending:"கீழிருந்து மேலாக",remove:"வரிசையை நீக்கு"},column:{hide:"பத்தியை மறைத்து வை "},aggregation:{count:"மொத்த வரிகள்:",sum:"மொத்தம்: ",avg:"சராசரி: ",min:"குறைந்தபட்ச: ",max:"அதிகபட்ச: "},pinning:{pinLeft:"இடதுபுறமாக தைக்க ",pinRight:"வலதுபுறமாக தைக்க",unpin:"பிரி"},gridMenu:{columns:"பத்திகள்:",importerTitle:"கோப்பு : படித்தல்",exporterAllAsCsv:"எல்லா தரவுகளையும் கோப்பாக்கு: csv",exporterVisibleAsCsv:"இருக்கும் தரவுகளை கோப்பாக்கு: csv",exporterSelectedAsCsv:"தேர்ந்தெடுத்த தரவுகளை கோப்பாக்கு: csv",exporterAllAsPdf:"எல்லா தரவுகளையும் கோப்பாக்கு: pdf",exporterVisibleAsPdf:"இருக்கும் தரவுகளை கோப்பாக்கு: pdf",exporterSelectedAsPdf:"தேர்ந்தெடுத்த தரவுகளை கோப்பாக்கு: pdf",clearAllFilters:"Clear all filters"},importer:{noHeaders:"பத்தியின் தலைப்புகளை பெற இயலவில்லை, கோப்பிற்கு தலைப்பு உள்ளதா?",noObjects:"இலக்குகளை உருவாக்க முடியவில்லை, கோப்பில் தலைப்புகளை தவிர தரவு ஏதேனும் உள்ளதா? ",invalidCsv:"சரிவர நடைமுறை படுத்த இயலவில்லை, கோப்பு சரிதானா? - csv",invalidJson:"சரிவர நடைமுறை படுத்த இயலவில்லை, கோப்பு சரிதானா? - json",jsonNotArray:"படித்த கோப்பில் வரிசைகள் உள்ளது, நடைமுறை ரத்து செய் : json"},pagination:{sizes:"உருப்படிகள் / பக்கம்",totalItems:"உருப்படிகள் "},grouping:{group:"குழு",ungroup:"பிரி",aggregate_count:"மதிப்பீட்டு : எண்ணு",aggregate_sum:"மதிப்பீட்டு : கூட்டல்",aggregate_max:"மதிப்பீட்டு : அதிகபட்சம்",aggregate_min:"மதிப்பீட்டு : குறைந்தபட்சம்",aggregate_avg:"மதிப்பீட்டு : சராசரி",aggregate_remove:"மதிப்பீட்டு : நீக்கு"}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("tr",{headerCell:{aria:{defaultFilterLabel:"Sütun için filtre",removeFilter:"Filtreyi Kaldır",columnMenuButtonLabel:"Sütun Menüsü"},priority:"Öncelik:",filterLabel:"Sütun için filtre: "},aggregate:{label:"kayıtlar"},groupPanel:{description:"Sütuna göre gruplamak için sütun başlığını buraya sürükleyin ve bırakın."},search:{placeholder:"Arama...",showingItems:"Gösterilen Kayıt:",selectedItems:"Seçili Kayıt:",totalItems:"Toplam Kayıt:",size:"Sayfa Boyutu:",first:"İlk Sayfa",next:"Sonraki Sayfa",previous:"Önceki Sayfa",last:"Son Sayfa"},menu:{text:"Sütunları Seç:"},sort:{ascending:"Artan Sırada Sırala",descending:"Azalan Sırada Sırala",none:"Sıralama Yapma",remove:"Sıralamayı Kaldır"},column:{hide:"Sütunu Gizle"},aggregation:{count:"toplam satır: ",sum:"toplam: ",avg:"ort: ",min:"min: ",max:"maks: "},pinning:{pinLeft:"Sola Sabitle",pinRight:"Sağa Sabitle",unpin:"Sabitlemeyi Kaldır"},columnMenu:{close:"Kapat"},gridMenu:{aria:{buttonLabel:"Tablo Menü"},columns:"Sütunlar:",importerTitle:"Dosya içeri aktar",exporterAllAsCsv:"Bütün veriyi CSV olarak dışarı aktar",exporterVisibleAsCsv:"Görünen veriyi CSV olarak dışarı aktar",exporterSelectedAsCsv:"Seçili veriyi CSV olarak dışarı aktar",exporterAllAsPdf:"Bütün veriyi PDF olarak dışarı aktar",exporterVisibleAsPdf:"Görünen veriyi PDF olarak dışarı aktar",exporterSelectedAsPdf:"Seçili veriyi PDF olarak dışarı aktar",clearAllFilters:"Bütün filtreleri kaldır"},importer:{noHeaders:"Sütun isimleri üretilemiyor, dosyanın bir başlığı var mı?",noObjects:"Nesneler üretilemiyor, dosyada başlıktan başka bir veri var mı?",invalidCsv:"Dosya işlenemedi, geçerli bir CSV dosyası mı?",invalidJson:"Dosya işlenemedi, geçerli bir Json dosyası mı?",jsonNotArray:"Alınan Json dosyasında bir dizi bulunmalıdır, işlem iptal ediliyor."},pagination:{aria:{pageToFirst:"İlk sayfaya",pageBack:"Geri git",pageSelected:"Seçili sayfa",pageForward:"İleri git",pageToLast:"Sona git"},sizes:"Sayfadaki nesne sayısı",totalItems:"kayıtlar",through:"",of:""},grouping:{group:"Grupla",ungroup:"Gruplama",aggregate_count:"Yekun: Sayı",aggregate_sum:"Yekun: Toplam",aggregate_max:"Yekun: Maks",aggregate_min:"Yekun: Min",aggregate_avg:"Yekun: Ort",aggregate_remove:"Yekun: Sil"}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("ua",{headerCell:{aria:{defaultFilterLabel:"Фільтр стовпчика",removeFilter:"Видалити фільтр",columnMenuButtonLabel:"Меню ствпчика"},priority:"Пріоритет:",filterLabel:"Фільтр стовпчика: "},aggregate:{label:"елементи"},groupPanel:{description:"Для групування за стовпчиком перетягніть сюди його назву."},search:{placeholder:"Пошук...",showingItems:"Показати елементи:",selectedItems:"Обрані елементи:",totalItems:"Усього елементів:",size:"Розмір сторінки:",first:"Перша сторінка",next:"Наступна сторінка",previous:"Попередня сторінка",last:"Остання сторінка"},menu:{text:"Обрати ствпчики:"},sort:{ascending:"За зростанням",descending:"За спаданням",none:"Без сортування",remove:"Прибрати сортування"},column:{hide:"Приховати стовпчик"},aggregation:{count:"усього рядків: ",sum:"ітого: ",avg:"середнє: ",min:"мін: ",max:"макс: "},pinning:{pinLeft:"Закріпити ліворуч",pinRight:"Закріпити праворуч",unpin:"Відкріпити"},columnMenu:{close:"Закрити"},gridMenu:{aria:{buttonLabel:"Меню"},columns:"Стовпчики:",importerTitle:"Імпортувати файл",exporterAllAsCsv:"Експортувати все в CSV",exporterVisibleAsCsv:"Експортувати видимі дані в CSV",exporterSelectedAsCsv:"Експортувати обрані дані в CSV",exporterAllAsPdf:"Експортувати все в PDF",exporterVisibleAsPdf:"Експортувати видимі дані в PDF",exporterSelectedAsPdf:"Експортувати обрані дані в PDF",clearAllFilters:"Очистити всі фільтри"},importer:{noHeaders:"Не вдалося отримати назви стовпчиків, чи є в файлі заголовок?",noObjects:"Не вдалося отримати дані, чи є в файлі рядки окрім заголовка?",invalidCsv:"Не вдалося обробити файл, чи це коректний CSV-файл?",invalidJson:"Не вдалося обробити файл, чи це коректний JSON?",jsonNotArray:"JSON-файл що імпортується повинен містити масив, операцію скасовано."},pagination:{aria:{pageToFirst:"Перша сторінка",pageBack:"Попередня сторінка",pageSelected:"Обрана сторінка",pageForward:"Наступна сторінка",pageToLast:"Остання сторінка"},sizes:"рядків на сторінку",totalItems:"рядків",through:"по",of:"з"},grouping:{group:"Групувати",ungroup:"Розгрупувати",aggregate_count:"Групувати: Кількість",aggregate_sum:"Для групи: Сума",aggregate_max:"Для групи: Максимум",aggregate_min:"Для групи: Мінімум",aggregate_avg:"Для групи: Серднє",aggregate_remove:"Для групи: Пусто"}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("zh-cn",{headerCell:{aria:{defaultFilterLabel:"列过滤器",removeFilter:"移除过滤器",columnMenuButtonLabel:"列菜单"},priority:"优先级:",filterLabel:"列过滤器: "},aggregate:{label:"行"},groupPanel:{description:"拖曳表头到此处进行分组"},search:{placeholder:"查找",showingItems:"已显示行数：",selectedItems:"已选择行数：",totalItems:"总行数：",size:"每页显示行数：",first:"首页",next:"下一页",previous:"上一页",last:"末页"},menu:{text:"选择列："},sort:{ascending:"升序",descending:"降序",none:"无序",remove:"取消排序"},column:{hide:"隐藏列"},aggregation:{count:"计数：",sum:"求和：",avg:"均值：",min:"最小值：",max:"最大值："},pinning:{pinLeft:"左侧固定",pinRight:"右侧固定",unpin:"取消固定"},columnMenu:{close:"关闭"},gridMenu:{aria:{buttonLabel:"表格菜单"},columns:"列：",importerTitle:"导入文件",exporterAllAsCsv:"导出全部数据到CSV",exporterVisibleAsCsv:"导出可见数据到CSV",exporterSelectedAsCsv:"导出已选数据到CSV",exporterAllAsPdf:"导出全部数据到PDF",exporterVisibleAsPdf:"导出可见数据到PDF",exporterSelectedAsPdf:"导出已选数据到PDF",clearAllFilters:"清除所有过滤器"},importer:{noHeaders:"无法获取列名，确定文件包含表头？",noObjects:"无法获取数据，确定文件包含数据？",invalidCsv:"无法处理文件，确定是合法的CSV文件？",invalidJson:"无法处理文件，确定是合法的JSON文件？",jsonNotArray:"导入的文件不是JSON数组！"},pagination:{aria:{pageToFirst:"第一页",pageBack:"上一页",pageSelected:"当前页",pageForward:"下一页",pageToLast:"最后一页"},sizes:"行每页",totalItems:"行",through:"至",of:"共"},grouping:{group:"分组",ungroup:"取消分组",aggregate_count:"合计: 计数",aggregate_sum:"合计: 求和",aggregate_max:"合计: 最大",aggregate_min:"合计: 最小",aggregate_avg:"合计: 平均",aggregate_remove:"合计: 移除"}}),e}])}]),angular.module("ui.grid").config(["$provide",function(e){e.decorator("i18nService",["$delegate",function(e){return e.add("zh-tw",{aggregate:{label:"行"},groupPanel:{description:"拖曳表頭到此處進行分組"},search:{placeholder:"查找",showingItems:"已顯示行數：",selectedItems:"已選擇行數：",totalItems:"總行數：",size:"每頁顯示行數：",first:"首頁",next:"下壹頁",previous:"上壹頁",last:"末頁"},menu:{text:"選擇列："},sort:{ascending:"升序",descending:"降序",remove:"取消排序"},column:{hide:"隱藏列"},aggregation:{count:"計數：",sum:"求和：",avg:"均值：",min:"最小值：",max:"最大值："},pinning:{pinLeft:"左側固定",pinRight:"右側固定",unpin:"取消固定"},gridMenu:{columns:"列：",importerTitle:"導入文件",exporterAllAsCsv:"導出全部數據到CSV",exporterVisibleAsCsv:"導出可見數據到CSV",exporterSelectedAsCsv:"導出已選數據到CSV",exporterAllAsPdf:"導出全部數據到PDF",exporterVisibleAsPdf:"導出可見數據到PDF",exporterSelectedAsPdf:"導出已選數據到PDF",clearAllFilters:"清除所有过滤器"},importer:{noHeaders:"無法獲取列名，確定文件包含表頭？",noObjects:"無法獲取數據，確定文件包含數據？",invalidCsv:"無法處理文件，確定是合法的CSV文件？",invalidJson:"無法處理文件，確定是合法的JSON文件？",jsonNotArray:"導入的文件不是JSON數組！"},pagination:{sizes:"行每頁",totalItems:"行"}}),e}])}]),function(){"use strict";var e=angular.module("ui.grid.importer",["ui.grid"]);e.constant("uiGridImporterConstants",{featureName:"importer"}),e.service("uiGridImporterService",["$q","uiGridConstants","uiGridImporterConstants","gridUtil","$compile","$interval","i18nService","$window",function(e,r,t,n,i,o,a,l){var s={initializeGrid:function(e,t){t.importer={$scope:e},this.defaultGridOptions(t.options);var e={importer:{}},i={importer:{importFile:function(e){s.importThisFile(t,e)}}};t.api.registerEventsFromObject(e),t.api.registerMethodsFromObject(i),t.options.enableImporter&&t.options.importerShowMenu&&(t.api.core.addToGridMenu?s.addToMenu(t):o(function(){t.api.core.addToGridMenu&&s.addToMenu(t)},100,1))},defaultGridOptions:function(e){e.enableImporter||void 0===e.enableImporter?l.hasOwnProperty("File")&&l.hasOwnProperty("FileReader")&&l.hasOwnProperty("FileList")&&l.hasOwnProperty("Blob")?e.enableImporter=!0:(n.logError("The File APIs are not fully supported in this browser, grid importer cannot be used."),e.enableImporter=!1):e.enableImporter=!1,e.importerProcessHeaders=e.importerProcessHeaders||s.processHeaders,e.importerHeaderFilter=e.importerHeaderFilter||function(e){return e},e.importerErrorCallback&&"function"==typeof e.importerErrorCallback||delete e.importerErrorCallback,!0!==e.enableImporter||e.importerDataAddCallback||(n.logError("You have not set an importerDataAddCallback, importer is disabled"),e.enableImporter=!1),e.importerShowMenu=!1!==e.importerShowMenu,e.importerObjectCallback=e.importerObjectCallback||function(e,t){return t}},addToMenu:function(e){e.api.core.addToGridMenu(e,[{title:a.getSafeText("gridMenu.importerTitle"),order:150},{templateUrl:"ui-grid/importerMenuItemContainer",action:function(){this.grid.api.importer.importAFile(e)},order:151}])},importThisFile:function(e,t){var i;t?(i=new FileReader,"application/json"===t.type?i.onload=s.importJsonClosure(e):i.onload=s.importCsvClosure(e),i.readAsText(t)):n.logError("No file object provided to importThisFile, should be impossible, aborting")},importJsonClosure:function(r){return function(e){var t,i=[],e=s.parseJson(r,e);null!==e&&(e.forEach(function(e){t=s.newObject(r),angular.extend(t,e),t=r.options.importerObjectCallback(r,t),i.push(t)}),s.addObjects(r,i))}},parseJson:function(t,i){var e;try{e=JSON.parse(i.target.result)}catch(e){return void s.alertError(t,"importer.invalidJson","File could not be processed, is it valid json? Content was: ",i.target.result)}return Array.isArray(e)?e:(s.alertError(t,"importer.jsonNotarray","Import failed, file is not an array, file was: ",i.target.result),[])},importCsvClosure:function(i){return function(e){var t=s.parseCsv(e);!t||t.length<1?s.alertError(i,"importer.invalidCsv","File could not be processed, is it valid csv? Content was: ",e.target.result):(t=s.createCsvObjects(i,t))&&0!==t.length?s.addObjects(i,t):s.alertError(i,"importer.noObjects","Objects were not able to be derived, content was: ",e.target.result)}},parseCsv:function(e){e=e.target.result;return CSV.parse(e)},createCsvObjects:function(t,e){var i,r,n=t.options.importerProcessHeaders(t,e.shift());return n&&0!==n.length?(i=[],e.forEach(function(e){r=s.newObject(t),null!==e&&e.forEach(function(e,t){null!==n[t]&&(r[n[t]]=e)}),r=t.options.importerObjectCallback(t,r),i.push(r)}),i):(s.alertError(t,"importer.noHeaders","Column names could not be derived, content was: ",e),[])},processHeaders:function(e,t){var i,r=[];return e.options.columnDefs&&0!==e.options.columnDefs.length?(i=s.flattenColumnDefs(e,e.options.columnDefs),t.forEach(function(e){i[e]?r.push(i[e]):i[e.toLowerCase()]?r.push(i[e.toLowerCase()]):r.push(null)})):t.forEach(function(e){r.push(e.replace(/[^0-9a-zA-Z\-_]/g,"_"))}),r},flattenColumnDefs:function(t,e){var i={};return e.forEach(function(e){e.name&&(i[e.name]=e.field||e.name,i[e.name.toLowerCase()]=e.field||e.name),e.field&&(i[e.field]=e.field||e.name,i[e.field.toLowerCase()]=e.field||e.name),e.displayName&&(i[e.displayName]=e.field||e.name,i[e.displayName.toLowerCase()]=e.field||e.name),e.displayName&&t.options.importerHeaderFilter&&(i[t.options.importerHeaderFilter(e.displayName)]=e.field||e.name,i[t.options.importerHeaderFilter(e.displayName).toLowerCase()]=e.field||e.name)}),i},addObjects:function(e,t){var i;e.api.rowEdit&&(i=e.registerDataChangeCallback(function(){e.api.rowEdit.setRowsDirty(t),i()},[r.dataChange.ROW]),e.importer.$scope.$on("$destroy",i)),e.importer.$scope.$apply(e.options.importerDataAddCallback(e,t))},newObject:function(e){return void 0!==e.options&&void 0!==e.options.importerNewObject?new e.options.importerNewObject:{}},alertError:function(e,t,i,r){e.options.importerErrorCallback?e.options.importerErrorCallback(e,t,i,r):(l.alert(a.getSafeText(t)),n.logError(i+r))}};return s}]),e.directive("uiGridImporter",["uiGridImporterConstants","uiGridImporterService","gridUtil","$compile",function(e,n,t,i){return{replace:!0,priority:0,require:"^uiGrid",scope:!1,link:function(e,t,i,r){n.initializeGrid(e,r.grid)}}}]),e.directive("uiGridImporterMenuItem",["uiGridImporterConstants","uiGridImporterService","gridUtil","$compile",function(e,o,a,t){return{replace:!0,priority:0,require:"?^uiGrid",scope:!1,templateUrl:"ui-grid/importerMenuItem",link:function(e,t,i,r){var n;t=t[0].querySelectorAll(".ui-grid-importer-file-chooser");1!==t.length?a.logError("Found > 1 or < 1 file choosers within the menu item, error, cannot continue"):t[0].addEventListener("change",function(e){var t;(e=e.srcElement||e.target)&&e.files&&1===e.files.length&&(t=e.files[0],void 0!==r&&r?(n=r.grid,o.importThisFile(n,t),e.form.reset()):a.logError("Could not import file because UI Grid was not found."))},!1)}}}])}(),function(){"use strict";var e=angular.module("ui.grid.infiniteScroll",["ui.grid"]);e.service("uiGridInfiniteScrollService",["gridUtil","$compile","$rootScope","uiGridConstants","ScrollEvent","$q",function(e,t,a,l,o,i){var s={initializeGrid:function(i,e){s.defaultGridOptions(i.options),i.options.enableInfiniteScroll&&(i.infiniteScroll={dataLoading:!1},s.setScrollDirections(i,i.options.infiniteScrollUp,i.options.infiniteScrollDown),i.api.core.on.scrollEnd(e,s.handleScroll),e={infiniteScroll:{dataLoaded:function(e,t){return s.setScrollDirections(i,e,t),s.adjustScroll(i).then(function(){i.infiniteScroll.dataLoading=!1})},resetScroll:function(e,t){s.setScrollDirections(i,e,t),s.adjustInfiniteScrollPosition(i,0)},saveScrollPercentage:function(){i.infiniteScroll.prevScrollTop=i.renderContainers.body.prevScrollTop,i.infiniteScroll.previousVisibleRows=i.getVisibleRowCount()},dataRemovedTop:function(e,t){s.dataRemovedTop(i,e,t)},dataRemovedBottom:function(e,t){s.dataRemovedBottom(i,e,t)},setScrollDirections:function(e,t){s.setScrollDirections(i,e,t)}}},i.api.registerEventsFromObject({infiniteScroll:{needLoadMoreData:function(e,t){},needLoadMoreDataTop:function(e,t){}}}),i.api.registerMethodsFromObject(e))},defaultGridOptions:function(e){e.enableInfiniteScroll=!1!==e.enableInfiniteScroll,e.infiniteScrollRowsFromEnd=e.infiniteScrollRowsFromEnd||20,e.infiniteScrollUp=!0===e.infiniteScrollUp,e.infiniteScrollDown=!1!==e.infiniteScrollDown},setScrollDirections:function(e,t,i){e.infiniteScroll.scrollUp=!0===t,e.suppressParentScrollUp=!0===t,e.infiniteScroll.scrollDown=!1!==i,e.suppressParentScrollDown=!1!==i},handleScroll:function(e){var t;e.grid.infiniteScroll&&e.grid.infiniteScroll.dataLoading||"ui.grid.adjustInfiniteScrollPosition"===e.source||e.y&&(0===e.y.percentage?(e.grid.scrollDirection=l.scrollDirection.UP,s.loadData(e.grid)):1===e.y.percentage?(e.grid.scrollDirection=l.scrollDirection.DOWN,s.loadData(e.grid)):(t=e.grid.options.infiniteScrollRowsFromEnd/e.grid.renderContainers.body.visibleRowCache.length,e.grid.scrollDirection===l.scrollDirection.UP?e.y.percentage<=t&&s.loadData(e.grid):e.grid.scrollDirection===l.scrollDirection.DOWN&&1-e.y.percentage<=t&&s.loadData(e.grid)))},loadData:function(e){e.infiniteScroll.previousVisibleRows=e.renderContainers.body.visibleRowCache.length,e.infiniteScroll.direction=e.scrollDirection,delete e.infiniteScroll.prevScrollTop,e.scrollDirection===l.scrollDirection.UP&&e.infiniteScroll.scrollUp?(e.infiniteScroll.dataLoading=!0,e.api.infiniteScroll.raise.needLoadMoreDataTop()):e.scrollDirection!==l.scrollDirection.DOWN||!e.infiniteScroll.scrollDown||e.cellNav&&e.cellNav.lastRowCol&&e.cellNav.lastRowCol.row.index===e.infiniteScroll.previousVisibleRows-1||(e.infiniteScroll.dataLoading=!0,e.api.infiniteScroll.raise.needLoadMoreData())},adjustScroll:function(n){var o=i.defer();return a.$applyAsync(function(){var e,t=n.getViewportHeight()+n.headerHeight-n.renderContainers.body.headerHeight-n.scrollbarHeight,i=n.options.rowHeight,r=(void 0===n.infiniteScroll.direction&&s.adjustInfiniteScrollPosition(n,0),n.getVisibleRowCount());n.infiniteScroll.scrollDown&&i*r<t&&n.api.infiniteScroll.raise.needLoadMoreData(),n.infiniteScroll.direction===l.scrollDirection.UP&&(e=(n.infiniteScroll.prevScrollTop||0)+(r-n.infiniteScroll.previousVisibleRows)*i,s.adjustInfiniteScrollPosition(n,e),a.$applyAsync(function(){o.resolve()})),n.infiniteScroll.direction===l.scrollDirection.DOWN&&(e=n.infiniteScroll.prevScrollTop||n.infiniteScroll.previousVisibleRows*i-t,s.adjustInfiniteScrollPosition(n,e),a.$applyAsync(function(){o.resolve()}))},0),o.promise},adjustInfiniteScrollPosition:function(e,t){var i=new o(e,null,null,"ui.grid.adjustInfiniteScrollPosition"),r=e.getVisibleRowCount(),n=e.getViewportHeight()+e.headerHeight-e.renderContainers.body.headerHeight-e.scrollbarHeight,r=r*e.options.rowHeight-n;0===t&&e.infiniteScroll.scrollUp?i.y={pixels:1}:i.y={percentage:t/r},e.scrollContainers("",i)},dataRemovedTop:function(e,t,i){var r;s.setScrollDirections(e,t,i),t=e.renderContainers.body.visibleRowCache.length,i=e.infiniteScroll.prevScrollTop,r=e.options.rowHeight,i=i-(e.infiniteScroll.previousVisibleRows-t)*r,s.adjustInfiniteScrollPosition(e,i)},dataRemovedBottom:function(e,t,i){s.setScrollDirections(e,t,i),t=e.infiniteScroll.prevScrollTop,s.adjustInfiniteScrollPosition(e,t)}};return s}]),e.directive("uiGridInfiniteScroll",["uiGridInfiniteScrollService",function(n){return{priority:-200,scope:!1,require:"^uiGrid",compile:function(){return{pre:function(e,t,i,r){n.initializeGrid(r.grid,e)},post:function(e,t,i){}}}}}])}(),function(){"use strict";var e=angular.module("ui.grid.moveColumns",["ui.grid"]);e.service("uiGridMoveColumnService",["$q","$rootScope","$log","ScrollEvent","uiGridConstants","gridUtil",function(r,d,e,t,c,s){var u={initializeGrid:function(e){this.registerPublicApi(e),this.defaultGridOptions(e.options),e.moveColumns={orderCache:[]},e.registerColumnBuilder(this.movableColumnBuilder),e.registerDataChangeCallback(this.verifyColumnOrder,[c.dataChange.COLUMN])},registerPublicApi:function(a){var l=this,e={colMovable:{columnPositionChanged:function(e,t,i){}}},t={colMovable:{moveColumn:function(e,t){var r=a.columns;if(angular.isNumber(e)&&angular.isNumber(t)){for(var i,n=0,o=0;o<r.length;o++)(angular.isDefined(r[o].colDef.visible)&&!1===r[o].colDef.visible||!0===r[o].isRowHeader)&&n++;e>=r.length-n||t>=r.length-n?s.logError("MoveColumn: Invalid values for originalPosition, finalPosition"):l.redrawColumnAtPosition(a,(i=function(e){for(var t=e,i=0;i<=t;i++)angular.isDefined(r[i])&&(angular.isDefined(r[i].colDef.visible)&&!1===r[i].colDef.visible||!0===r[i].isRowHeader)&&t++;return t})(e),i(t))}else s.logError("MoveColumn: Please provide valid values for originalPosition and finalPosition")}}};a.api.registerEventsFromObject(e),a.api.registerMethodsFromObject(t)},defaultGridOptions:function(e){e.enableColumnMoving=!1!==e.enableColumnMoving},movableColumnBuilder:function(e,t,i){return e.enableColumnMoving=(void 0===e.enableColumnMoving?i:e).enableColumnMoving,r.all([])},updateColumnCache:function(e){e.moveColumns.orderCache=e.getOnlyDataColumns()},verifyColumnOrder:function(i){var r,n=i.rowHeaderColumns.length;angular.forEach(i.moveColumns.orderCache,function(e,t){-1!==(r=i.columns.indexOf(e))&&r-n!==t&&(e=i.columns.splice(r,1)[0],i.columns.splice(t+n,0,e))})},redrawColumnAtPosition:function(e,t,i){var r=e.columns;if(t!==i){for(var n=t<i?t+1:t-1,o=Math.min(n,i);o<=Math.max(n,i)&&!r[o].visible;o++);if(!(o>Math.max(n,i))){var a=r[t];if(a.colDef.enableColumnMoving){if(i<t)for(var l=t;i<l;l--)r[l]=r[l-1];else if(t<i)for(var s=t;s<i;s++)r[s]=r[s+1];r[i]=a,u.updateColumnCache(e),e.queueGridRefresh(),d.$applyAsync(function(){e.api.core.notifyDataChange(c.dataChange.COLUMN),e.api.colMovable.raise.columnPositionChanged(a.colDef,t,i)})}}}}};return u}]),e.directive("uiGridMoveColumns",["uiGridMoveColumnService",function(n){return{replace:!0,priority:0,require:"^uiGrid",scope:!1,compile:function(){return{pre:function(e,t,i,r){n.initializeGrid(r.grid)},post:function(e,t,i,r){}}}}}]),e.directive("uiGridHeaderCell",["$q","gridUtil","uiGridMoveColumnService","$document","$log","uiGridConstants","ScrollEvent",function(e,t,b,y,i,r,S){return{priority:-10,require:"^uiGrid",compile:function(){return{post:function(d,r,e,c){var t,u,i,g,p,f,m,h,v,n,o,a,C,w,l,s;d.col.colDef.enableColumnMoving&&(t=angular.element(r[0].querySelectorAll(".ui-grid-cell-contents")),v=f=!1,n=function(e){u=d.grid.element[0].getBoundingClientRect().left,d.grid.hasLeftContainer()&&(u+=d.grid.renderContainers.left.header[0].getBoundingClientRect().width),i=e.pageX||(e.originalEvent?e.originalEvent.pageX:0),g=0,p=u+d.grid.getViewportWidth(),"mousedown"===e.type?(y.on("mousemove",o),y.on("mouseup",a)):"touchstart"===e.type&&(y.on("touchmove",o),y.on("touchend",a))},o=function(e){var e=e.pageX||(e.originalEvent?e.originalEvent.pageX:0),t=e-i;0!=t&&(document.onselectstart=function(){return!1},v=!0,f?(s(t),i=e):l())},a=function(e){if(document.onselectstart=null,m&&(m.remove(),f=!1),w(),C(),v){for(var t,i=d.grid.columns,r=0,n=0;n<i.length&&i[n].colDef.name!==d.col.colDef.name;n++)r++;if(g<0){var o,a=0;if(d.grid.isRTL()){for(o=r+1;o<i.length;o++)if((angular.isUndefined(i[o].colDef.visible)||!0===i[o].colDef.visible)&&(a+=i[o].drawnWidth||i[o].width||i[o].colDef.width)>Math.abs(g)){b.redrawColumnAtPosition(d.grid,r,o-1);break}}else for(o=r-1;0<=o;o--)if((angular.isUndefined(i[o].colDef.visible)||!0===i[o].colDef.visible)&&(a+=i[o].drawnWidth||i[o].width||i[o].colDef.width)>Math.abs(g)){b.redrawColumnAtPosition(d.grid,r,o+1);break}a<Math.abs(g)&&(t=0,d.grid.isRTL()&&(t=i.length-1),b.redrawColumnAtPosition(d.grid,r,t))}else if(0<g){var l,s=0;if(d.grid.isRTL()){for(l=r-1;0<l;l--)if((angular.isUndefined(i[l].colDef.visible)||!0===i[l].colDef.visible)&&(s+=i[l].drawnWidth||i[l].width||i[l].colDef.width,g<s)){b.redrawColumnAtPosition(d.grid,r,l);break}}else for(l=r+1;l<i.length;l++)if((angular.isUndefined(i[l].colDef.visible)||!0===i[l].colDef.visible)&&(s+=i[l].drawnWidth||i[l].width||i[l].colDef.width,g<s)){b.redrawColumnAtPosition(d.grid,r,l-1);break}s<g&&(t=i.length-1,d.grid.isRTL()&&(t=0),b.redrawColumnAtPosition(d.grid,r,t))}}},w=function(){t.off("touchstart",n),t.off("mousedown",n),y.off("mousemove",o),y.off("touchmove",o),y.off("mouseup",a),y.off("touchend",a)},(C=function(){t.on("touchstart",n),t.on("mousedown",n)})(),l=function(){f=!0,m=r.clone(),r.parent().append(m),m.addClass("movingColumn");var e={},t=(e.left=r[0].offsetLeft+"px",d.grid.element[0].getBoundingClientRect().right),i=r[0].getBoundingClientRect().right;t<i&&(h=d.col.drawnWidth+(t-i),e.width=h+"px"),m.css(e)},s=function(e){for(var t=d.grid.columns,i=0,r=0;r<t.length;r++)!angular.isUndefined(t[r].colDef.visible)&&!0!==t[r].colDef.visible||(i+=t[r].drawnWidth||t[r].width||t[r].colDef.width);var n=m[0].getBoundingClientRect().left-1,o=m[0].getBoundingClientRect().right,a=n-u+e;a=a<p?a:p,(u<=n||0<e)&&(o<=p||e<0)?m.css({visibility:"visible",left:m[0].offsetLeft+(a<p?e:p-n)+"px"}):i>Math.ceil(c.grid.gridWidth)&&(e*=8,(o=new S(d.col.grid,null,null,"uiGridHeaderCell.moveElement")).x={pixels:e},o.grid.scrollContainers("",o));for(var l=0,s=0;s<t.length;s++)if(angular.isUndefined(t[s].colDef.visible)||!0===t[s].colDef.visible){if(t[s].colDef.name===d.col.colDef.name)break;l+=t[s].drawnWidth||t[s].width||t[s].colDef.width}void 0===d.newScrollLeft?g+=e:g=d.newScrollLeft+a-l,h<d.col.drawnWidth&&(h+=Math.abs(e),m.css({width:h+"px"}))},d.$on("$destroy",w))}}}}}])}(),function(){"use strict";var e=angular.module("ui.grid.pagination",["ng","ui.grid"]);e.service("uiGridPaginationService",["gridUtil",function(t){var e={initializeGrid:function(n){e.defaultGridOptions(n.options);var o={events:{pagination:{paginationChanged:function(e,t){}}},methods:{pagination:{getPage:function(){return n.options.enablePagination?n.options.paginationCurrentPage:null},getFirstRowIndex:function(){return n.options.useCustomPagination?n.options.paginationPageSizes.reduce(function(e,t,i){return i<n.options.paginationCurrentPage-1?e+t:e},0):(n.options.paginationCurrentPage-1)*n.options.paginationPageSize},getLastRowIndex:function(){return n.options.useCustomPagination?o.methods.pagination.getFirstRowIndex()+n.options.paginationPageSizes[n.options.paginationCurrentPage-1]-1:Math.min(n.options.paginationCurrentPage*n.options.paginationPageSize,n.options.totalItems)-1},getTotalPages:function(){return n.options.enablePagination?n.options.useCustomPagination?n.options.paginationPageSizes.length:0===n.options.totalItems?1:Math.ceil(n.options.totalItems/n.options.paginationPageSize):null},nextPage:function(){n.options.enablePagination&&(0<n.options.totalItems?n.options.paginationCurrentPage=Math.min(n.options.paginationCurrentPage+1,o.methods.pagination.getTotalPages()):n.options.paginationCurrentPage++)},previousPage:function(){n.options.enablePagination&&(n.options.paginationCurrentPage=Math.max(n.options.paginationCurrentPage-1,1))},seek:function(e){if(n.options.enablePagination){if(!angular.isNumber(e)||e<1)throw"Invalid page number: "+e;n.options.paginationCurrentPage=Math.min(e,o.methods.pagination.getTotalPages())}}}}};n.api.registerEventsFromObject(o.events),n.api.registerMethodsFromObject(o.methods);n.registerRowsProcessor(function(e){var t,i,r;return n.options.useExternalPagination||!n.options.enablePagination?e:(t=parseInt(n.options.paginationPageSize,10),parseInt(n.options.paginationCurrentPage,10),e=e.filter(function(e){return e.visible}),n.options.totalItems=e.length,i=o.methods.pagination.getFirstRowIndex(),r=o.methods.pagination.getLastRowIndex(),i>e.length&&(n.options.paginationCurrentPage=1,i=0*t),e.slice(i,r+1))},900)},defaultGridOptions:function(e){e.enablePagination=!1!==e.enablePagination,e.enablePaginationControls=!1!==e.enablePaginationControls,e.useExternalPagination=!0===e.useExternalPagination,e.useCustomPagination=!0===e.useCustomPagination,t.isNullOrUndefined(e.totalItems)&&(e.totalItems=0),t.isNullOrUndefined(e.paginationPageSizes)&&(e.paginationPageSizes=[250,500,1e3]),t.isNullOrUndefined(e.paginationPageSize)&&(0<e.paginationPageSizes.length?e.paginationPageSize=e.paginationPageSizes[0]:e.paginationPageSize=0),t.isNullOrUndefined(e.paginationCurrentPage)&&(e.paginationCurrentPage=1),t.isNullOrUndefined(e.paginationTemplate)&&(e.paginationTemplate="ui-grid/pagination")},onPaginationChanged:function(e,t,i){e.api.pagination.raise.paginationChanged(t,i),e.options.useExternalPagination||e.queueGridRefresh()}};return e}]),e.directive("uiGridPagination",["gridUtil","uiGridPaginationService",function(n,o){return{priority:-200,scope:!1,require:"uiGrid",link:{pre:function(e,t,i,r){o.initializeGrid(r.grid),n.getTemplate(r.grid.options.paginationTemplate).then(function(e){e=angular.element(e);t.append(e),r.innerCompile(e)})}}}}]),e.directive("uiGridPager",["uiGridPaginationService","uiGridConstants","gridUtil","i18nService","i18nConstants",function(d,c,u,g,p){return{priority:-200,scope:!0,require:"^uiGrid",link:function(i,t,e,r){function n(){i.paginationApi=r.grid.api.pagination,i.sizesLabel=g.getSafeText("pagination.sizes"),i.totalItemsLabel=g.getSafeText("pagination.totalItems"),i.paginationOf=g.getSafeText("pagination.of"),i.paginationThrough=g.getSafeText("pagination.through")}i.aria=g.getSafeText("pagination.aria");function o(e){e&&u.focus.bySelector(t,".ui-grid-pager-control-input")}n(),i.$on(p.UPDATE_EVENT,n);var a=r.grid.options,l=(r.grid.renderContainers.body.registerViewportAdjuster(function(e){return a.enablePaginationControls&&(e.height=e.height-u.elementHeight(t,"padding")),e}),r.grid.registerDataChangeCallback(function(e){e.options.useExternalPagination||(e.options.totalItems=e.rows.length)},[c.dataChange.ROW])),s=(i.$on("$destroy",l),i.$watch("grid.options.paginationCurrentPage + grid.options.paginationPageSize",function(e,t){e!==t&&void 0!==t&&(!angular.isNumber(a.paginationCurrentPage)||a.paginationCurrentPage<1?a.paginationCurrentPage=1:0<a.totalItems&&a.paginationCurrentPage>i.paginationApi.getTotalPages()?a.paginationCurrentPage=i.paginationApi.getTotalPages():d.onPaginationChanged(i.grid,a.paginationCurrentPage,a.paginationPageSize))}));i.$on("$destroy",function(){s()}),i.cantPageForward=function(){return i.paginationApi.getTotalPages()?i.cantPageToLast():a.data.length<1},i.cantPageToLast=function(){var e=i.paginationApi.getTotalPages();return!e||a.paginationCurrentPage>=e},i.cantPageBackward=function(){return a.paginationCurrentPage<=1};i.pageFirstPageClick=function(){i.paginationApi.seek(1),o(i.cantPageBackward())},i.pagePreviousPageClick=function(){i.paginationApi.previousPage(),o(i.cantPageBackward())},i.pageNextPageClick=function(){i.paginationApi.nextPage(),o(i.cantPageForward())},i.pageLastPageClick=function(){i.paginationApi.seek(i.paginationApi.getTotalPages()),o(i.cantPageToLast())}}}}])}(),function(){"use strict";var e=angular.module("ui.grid.pinning",["ui.grid"]);e.constant("uiGridPinningConstants",{container:{LEFT:"left",RIGHT:"right",NONE:""}}),e.service("uiGridPinningService",["gridUtil","GridRenderContainer","i18nService","uiGridPinningConstants",function(o,e,a,l){var s={initializeGrid:function(i){s.defaultGridOptions(i.options),i.registerColumnBuilder(s.pinningColumnBuilder);var e={pinning:{columnPinned:function(e,t){}}},t={pinning:{pinColumn:function(e,t){s.pinColumn(i,e,t)}}};i.api.registerEventsFromObject(e),i.api.registerMethodsFromObject(t)},defaultGridOptions:function(e){e.enablePinning=!1!==e.enablePinning,e.hidePinLeft=e.enablePinning&&e.hidePinLeft,e.hidePinRight=e.enablePinning&&e.hidePinRight},pinningColumnBuilder:function(e,t,i){var r,n;e.enablePinning=(void 0===e.enablePinning?i:e).enablePinning,e.hidePinLeft=(void 0===e.hidePinLeft?i:e).hidePinLeft,e.hidePinRight=(void 0===e.hidePinRight?i:e).hidePinRight,e.pinnedLeft?(t.renderContainer="left",t.grid.createLeftContainer()):e.pinnedRight&&(t.renderContainer="right",t.grid.createRightContainer()),e.enablePinning&&(i={name:"ui.grid.pinning.pinLeft",title:a.get().pinning.pinLeft,icon:"ui-grid-icon-left-open",shown:function(){return void 0===this.context.col.renderContainer||!this.context.col.renderContainer||"left"!==this.context.col.renderContainer},action:function(){s.pinColumn(this.context.col.grid,this.context.col,l.container.LEFT)}},r={name:"ui.grid.pinning.pinRight",title:a.get().pinning.pinRight,icon:"ui-grid-icon-right-open",shown:function(){return void 0===this.context.col.renderContainer||!this.context.col.renderContainer||"right"!==this.context.col.renderContainer},action:function(){s.pinColumn(this.context.col.grid,this.context.col,l.container.RIGHT)}},n={name:"ui.grid.pinning.unpin",title:a.get().pinning.unpin,icon:"ui-grid-icon-cancel",shown:function(){return void 0!==this.context.col.renderContainer&&null!==this.context.col.renderContainer&&"body"!==this.context.col.renderContainer},action:function(){s.pinColumn(this.context.col.grid,this.context.col,l.container.NONE)}},e.hidePinLeft||o.arrayContainsObjectWithProperty(t.menuItems,"name","ui.grid.pinning.pinLeft")||t.menuItems.push(i),e.hidePinRight||o.arrayContainsObjectWithProperty(t.menuItems,"name","ui.grid.pinning.pinRight")||t.menuItems.push(r),o.arrayContainsObjectWithProperty(t.menuItems,"name","ui.grid.pinning.unpin")||t.menuItems.push(n))},pinColumn:function(e,t,i){i===l.container.NONE?(t.renderContainer=null,t.colDef.pinnedLeft=t.colDef.pinnedRight=!1):(t.renderContainer=i)===l.container.LEFT?e.createLeftContainer():i===l.container.RIGHT&&e.createRightContainer(),e.refresh().then(function(){e.api.pinning.raise.columnPinned(t.colDef,i)})}};return s}]),e.directive("uiGridPinning",["gridUtil","uiGridPinningService",function(e,n){return{require:"uiGrid",scope:!1,compile:function(){return{pre:function(e,t,i,r){n.initializeGrid(r.grid)},post:function(e,t,i,r){}}}}}])}(),function(){"use strict";var e=angular.module("ui.grid.resizeColumns",["ui.grid"]);e.service("uiGridResizeColumnsService",["gridUtil","$q","$rootScope",function(r,n,o){return{defaultGridOptions:function(e){e.enableColumnResizing=!1!==e.enableColumnResizing,!1===e.enableColumnResize&&(e.enableColumnResizing=!1)},colResizerColumnBuilder:function(e,t,i){return e.enableColumnResizing=(void 0===e.enableColumnResizing?i:e).enableColumnResizing,!1===e.enableColumnResize&&(e.enableColumnResizing=!1),n.all([])},registerPublicApi:function(e){e.api.registerEventsFromObject({colResizable:{columnSizeChanged:function(e,t){}}})},fireColumnSizeChanged:function(e,t,i){o.$applyAsync(function(){e.api.colResizable?e.api.colResizable.raise.columnSizeChanged(t,i):r.logError("The resizeable api is not registered, this may indicate that you've included the module but not added the 'ui-grid-resize-columns' directive to your grid definition.  Cannot raise any events.")})},findTargetCol:function(e,t,i){var r=e.getRenderContainer();return"left"===t?0===(t=r.visibleColumnCache.indexOf(e))?r.visibleColumnCache[0]:r.visibleColumnCache[t-+i]:e}}}]),e.directive("uiGridResizeColumns",["gridUtil","uiGridResizeColumnsService",function(e,n){return{replace:!0,priority:0,require:"^uiGrid",scope:!1,compile:function(){return{pre:function(e,t,i,r){n.defaultGridOptions(r.grid.options),r.grid.registerColumnBuilder(n.colResizerColumnBuilder),n.registerPublicApi(r.grid)},post:function(e,t,i,r){}}}}}]),e.directive("uiGridHeaderCell",["gridUtil","$templateCache","$compile","$q","uiGridResizeColumnsService","uiGridConstants",function(e,r,s,t,d,c){return{priority:-10,require:"^uiGrid",compile:function(){return{post:function(n,o,e,t){var a,l,i,t=t.grid;t.options.enableColumnResizing&&(a=r.get("ui-grid/columnResizer"),l=1,t.isRTL()&&(n.position="left",l=-1),(i=function(){for(var e=o[0].getElementsByClassName("ui-grid-column-resizer"),t=0;t<e.length;t++)angular.element(e[t]).remove();var i=d.findTargetCol(n.col,"left",l),r=n.col.getRenderContainer();i&&0!==r.visibleColumnCache.indexOf(n.col)&&!1!==i.colDef.enableColumnResizing&&((r=angular.element(a).clone()).attr("position","left"),o.prepend(r),s(r)(n)),!1!==n.col.colDef.enableColumnResizing&&((i=angular.element(a).clone()).attr("position","right"),o.append(i),s(i)(n))})(),t=t.registerDataChangeCallback(function(){n.$applyAsync(i)},[c.dataChange.COLUMN]),n.$on("$destroy",t))}}}}}]),e.directive("uiGridColumnResizer",["$document","gridUtil","uiGridConstants","uiGridResizeColumnsService",function(h,v,C,w){var b=angular.element('<div class="ui-grid-resize-overlay"></div>');return{priority:0,scope:{col:"=",position:"@",renderIndex:"="},require:"?^uiGrid",link:function(o,a,e,l){var r=0,n=0,s=0,d=1;function c(){l.grid.refreshCanvas(!0).then(function(){l.grid.queueGridRefresh()})}function u(e,t){return e.minWidth&&t<e.minWidth?t=e.minWidth:e.maxWidth&&t>e.maxWidth&&(t=e.maxWidth),t}function i(e,t){(e=e.originalEvent?e.originalEvent:e).preventDefault(),(n=(e.targetTouches?e.targetTouches[0]:e).clientX-s)<0?n=0:n>l.grid.gridWidth&&(n=l.grid.gridWidth);var i,e=w.findTargetCol(o.col,o.position,d);!1!==e.colDef.enableColumnResizing&&(l.grid.element.hasClass("column-resizing")||l.grid.element.addClass("column-resizing"),i=n-r,i=parseInt(e.drawnWidth+i*d,10),n+=(u(e,i)-i)*d,b.css({left:n+"px"}),l.fireEvent(C.events.ITEM_DRAGGING))}function g(e){(e=e.originalEvent?e.originalEvent:e).preventDefault(),l.grid.element.removeClass("column-resizing"),b.remove();var t,i,e=(n=(e.changedTouches?e.changedTouches[0]:e).clientX-s)-r;0==e?(m(),f()):!1!==(t=w.findTargetCol(o.col,o.position,d)).colDef.enableColumnResizing&&(i=parseInt(t.drawnWidth+e*d,10),t.width=u(t,i),t.hasCustomWidth=!0,c(),w.fireColumnSizeChanged(l.grid,t.colDef,e),m(),f())}l.grid.isRTL()&&(o.position="left",d=-1),"left"===o.position?a.addClass("left"):"right"===o.position&&a.addClass("right");function t(e,t){var i,r,n;e.stopPropagation(),!1!==(e=w.findTargetCol(o.col,o.position,d)).colDef.enableColumnResizing&&(i=0,r=v.closestElm(a,".ui-grid-render-container").querySelectorAll("."+C.COL_CLASS_PREFIX+e.uid+" .ui-grid-cell-contents"),Array.prototype.forEach.call(r,function(e){var t;angular.element(e).parent().hasClass("ui-grid-header-cell")&&(t=angular.element(e).parent()[0].querySelectorAll(".ui-grid-column-menu-button")),v.fakeElement(e,{},function(e){e=angular.element(e),e.attr("style","float: left"),e=v.elementWidth(e)+2;t&&(e+=v.elementWidth(t)),i<e&&(i=e)})}),n=(r=u(e,i))-e.drawnWidth,e.width=r,e.hasCustomWidth=!0,c(),w.fireColumnSizeChanged(l.grid,e.colDef,n))}var p=function(e,t){(e=e.originalEvent?e.originalEvent:e).stopPropagation(),s=l.grid.element[0].getBoundingClientRect().left,r=(e.targetTouches?e.targetTouches[0]:e).clientX-s,l.grid.element.append(b),b.css({left:r}),"touchstart"===e.type?(h.on("touchend",g),h.on("touchmove",i),a.off("mousedown",p)):(h.on("mouseup",g),h.on("mousemove",i),a.off("touchstart",p))},f=function(){a.on("mousedown",p),a.on("touchstart",p)},m=function(){h.off("mouseup",g),h.off("touchend",g),h.off("mousemove",i),h.off("touchmove",i),a.off("mousedown",p),a.off("touchstart",p)};f();a.on("dblclick",t),a.on("$destroy",function(){a.off("dblclick",t),m()})}}}])}(),function(){"use strict";var e=angular.module("ui.grid.rowEdit",["ui.grid","ui.grid.edit","ui.grid.cellNav"]);e.constant("uiGridRowEditConstants",{}),e.service("uiGridRowEditService",["$interval","$q","uiGridConstants","uiGridRowEditConstants","gridUtil",function(r,e,t,i,o){var a={initializeGrid:function(t,i){i.rowEdit={};var e={rowEdit:{saveRow:function(e){}}},r={rowEdit:{setSavePromise:function(e,t){a.setSavePromise(i,e,t)},getDirtyRows:function(){return i.rowEdit.dirtyRows||[]},getErrorRows:function(){return i.rowEdit.errorRows||[]},flushDirtyRows:function(){return a.flushDirtyRows(i)},setRowsDirty:function(e){a.setRowsDirty(i,e)},setRowsClean:function(e){a.setRowsClean(i,e)}}};i.api.registerEventsFromObject(e),i.api.registerMethodsFromObject(r),i.api.core.on.renderingComplete(t,function(e){i.api.edit.on.afterCellEdit(t,a.endEditCell),i.api.edit.on.beginCellEdit(t,a.beginEditCell),i.api.edit.on.cancelCellEdit(t,a.cancelEditCell),i.api.cellNav&&i.api.cellNav.on.navigate(t,a.navigate)})},defaultGridOptions:function(e){},saveRow:function(t,i){var r=this;return function(){var e;return i.isSaving=!0,i.rowEditSavePromise||(e=t.api.rowEdit.raise.saveRow(i.entity),i.rowEditSavePromise?i.rowEditSavePromise.then(r.processSuccessPromise(t,i),r.processErrorPromise(t,i)):o.logError("A promise was not returned when saveRow event was raised, either nobody is listening to event, or event handler did not return a promise"),e)}},setSavePromise:function(e,t,i){e.getRow(t).rowEditSavePromise=i},processSuccessPromise:function(e,t){var i=this;return function(){delete t.isSaving,delete t.isDirty,delete t.isError,delete t.rowEditSaveTimer,delete t.rowEditSavePromise,i.removeRow(e.rowEdit.errorRows,t),i.removeRow(e.rowEdit.dirtyRows,t)}},processErrorPromise:function(e,t){return function(){delete t.isSaving,delete t.rowEditSaveTimer,delete t.rowEditSavePromise,t.isError=!0,e.rowEdit.errorRows||(e.rowEdit.errorRows=[]),a.isRowPresent(e.rowEdit.errorRows,t)||e.rowEdit.errorRows.push(t)}},removeRow:function(i,r){null!=i&&i.forEach(function(e,t){e.uid===r.uid&&i.splice(t,1)})},isRowPresent:function(e,i){var r=!1;return e.forEach(function(e,t){e.uid===i.uid&&(r=!0)}),r},flushDirtyRows:function(t){var i=[];return t.api.rowEdit.getDirtyRows().forEach(function(e){a.cancelTimer(t,e),a.saveRow(t,e)(),i.push(e.rowEditSavePromise)}),e.all(i)},endEditCell:function(e,t,i,r){var n=this.grid,e=n.getRow(e);e?i===r&&!e.isDirty||(n.rowEdit.dirtyRows||(n.rowEdit.dirtyRows=[]),e.isDirty||(e.isDirty=!0,n.rowEdit.dirtyRows.push(e)),delete e.isError,a.considerSetTimer(n,e)):o.logError("Unable to find rowEntity in grid data, dirty flag cannot be set")},beginEditCell:function(e,t){var i=this.grid,e=i.getRow(e);e?a.cancelTimer(i,e):o.logError("Unable to find rowEntity in grid data, timer cannot be cancelled")},cancelEditCell:function(e,t){var i=this.grid,e=i.getRow(e);e?a.considerSetTimer(i,e):o.logError("Unable to find rowEntity in grid data, timer cannot be set")},navigate:function(e,t){var i=this.grid;e.row.rowEditSaveTimer&&a.cancelTimer(i,e.row),t&&t.row&&t.row!==e.row&&a.considerSetTimer(i,t.row)},considerSetTimer:function(e,t){var i;a.cancelTimer(e,t),t.isDirty&&!t.isSaving&&-1!==e.options.rowEditWaitInterval&&(i=e.options.rowEditWaitInterval||2e3,t.rowEditSaveTimer=r(a.saveRow(e,t),i,1))},cancelTimer:function(e,t){t.rowEditSaveTimer&&!t.isSaving&&(r.cancel(t.rowEditSaveTimer),delete t.rowEditSaveTimer)},setRowsDirty:function(i,e){var r;e.forEach(function(e,t){(r=i.getRow(e))?(i.rowEdit.dirtyRows||(i.rowEdit.dirtyRows=[]),r.isDirty||(r.isDirty=!0,i.rowEdit.dirtyRows.push(r)),delete r.isError,a.considerSetTimer(i,r)):o.logError("requested row not found in rowEdit.setRowsDirty, row was: "+e)})},setRowsClean:function(i,e){var r;e.forEach(function(e,t){(r=i.getRow(e))?(delete r.isDirty,a.removeRow(i.rowEdit.dirtyRows,r),a.cancelTimer(i,r),delete r.isError,a.removeRow(i.rowEdit.errorRows,r)):o.logError("requested row not found in rowEdit.setRowsClean, row was: "+e)})}};return a}]),e.directive("uiGridRowEdit",["gridUtil","uiGridRowEditService","uiGridEditConstants",function(e,n,t){return{replace:!0,priority:0,require:"^uiGrid",scope:!1,compile:function(){return{pre:function(e,t,i,r){n.initializeGrid(e,r.grid)},post:function(e,t,i,r){}}}}}]),e.directive("uiGridViewport",["$compile","uiGridConstants","gridUtil","$parse",function(e,t,i,r){return{priority:-200,scope:!1,compile:function(e,t){var e=angular.element(e.children().children()[0]),i=e.attr("ng-class"),r="",r=i?i.slice(0,-1)+", 'ui-grid-row-dirty': row.isDirty, 'ui-grid-row-saving': row.isSaving, 'ui-grid-row-error': row.isError}":"{'ui-grid-row-dirty': row.isDirty, 'ui-grid-row-saving': row.isSaving, 'ui-grid-row-error': row.isError}";return e.attr("ng-class",r),{pre:function(e,t,i,r){},post:function(e,t,i,r){}}}}}])}(),function(){"use strict";var e=angular.module("ui.grid.saveState",["ui.grid","ui.grid.selection","ui.grid.cellNav","ui.grid.grouping","ui.grid.pinning","ui.grid.treeView"]);e.constant("uiGridSaveStateConstants",{featureName:"saveState"}),e.service("uiGridSaveStateService",function(){var a={initializeGrid:function(i){i.saveState={},this.defaultGridOptions(i.options);var e={saveState:{}},t={saveState:{save:function(){return a.save(i)},restore:function(e,t){return a.restore(i,e,t)}}};i.api.registerEventsFromObject(e),i.api.registerMethodsFromObject(t)},defaultGridOptions:function(e){e.saveWidths=!1!==e.saveWidths,e.saveOrder=!1!==e.saveOrder,e.saveScroll=!0===e.saveScroll,e.saveFocus=!0!==e.saveScroll&&!1!==e.saveFocus,e.saveVisible=!1!==e.saveVisible,e.saveSort=!1!==e.saveSort,e.saveFilter=!1!==e.saveFilter,e.saveSelection=!1!==e.saveSelection,e.saveGrouping=!1!==e.saveGrouping,e.saveGroupingExpandedStates=!0===e.saveGroupingExpandedStates,e.savePinning=!1!==e.savePinning,e.saveTreeView=!1!==e.saveTreeView},save:function(e){var t={};return t.columns=a.saveColumns(e),t.scrollFocus=a.saveScrollFocus(e),t.selection=a.saveSelection(e),t.grouping=a.saveGrouping(e),t.treeView=a.saveTreeView(e),t.pagination=a.savePagination(e),t},restore:function(e,t,i){return i.columns&&a.restoreColumns(e,i.columns),i.scrollFocus&&a.restoreScrollFocus(e,t,i.scrollFocus),i.selection&&a.restoreSelection(e,i.selection),i.grouping&&a.restoreGrouping(e,i.grouping),i.treeView&&a.restoreTreeView(e,i.treeView),i.pagination&&a.restorePagination(e,i.pagination),e.refresh()},saveColumns:function(i){var r=[];return i.getOnlyDataColumns().forEach(function(e){var t={};t.name=e.name,i.options.saveVisible&&(t.visible=e.visible),i.options.saveWidths&&(t.width=e.width),i.options.saveSort&&(t.sort=angular.copy(e.sort)),i.options.saveFilter&&(t.filters=[],e.filters.forEach(function(e){var i={};angular.forEach(e,function(e,t){"condition"!==t&&"$$hashKey"!==t&&"placeholder"!==t&&(i[t]=e)}),t.filters.push(i)})),i.api.pinning&&i.options.savePinning&&(t.pinned=e.renderContainer||""),r.push(t)}),r},saveScrollFocus:function(e){var t,i;return e.api.cellNav?(t={},e.options.saveFocus&&(t.focus=!0,null!==(i=e.api.cellNav.getFocusedCell()))&&(null!==i.col&&(t.colName=i.col.colDef.name),null!==i.row)&&(t.rowVal=a.getRowVal(e,i.row)),(e.options.saveScroll||e.options.saveFocus&&!t.colName&&!t.rowVal)&&(t.focus=!1,e.renderContainers.body.prevRowScrollIndex&&(t.rowVal=a.getRowVal(e,e.renderContainers.body.visibleRowCache[e.renderContainers.body.prevRowScrollIndex])),e.renderContainers.body.prevColScrollIndex)&&(t.colName=e.renderContainers.body.visibleColumnCache[e.renderContainers.body.prevColScrollIndex].name),t):{}},saveSelection:function(t){return t.api.selection&&t.options.saveSelection?t.api.selection.getSelectedGridRows().map(function(e){return a.getRowVal(t,e)}):[]},saveGrouping:function(e){return e.api.grouping&&e.options.saveGrouping?e.api.grouping.getGrouping(e.options.saveGroupingExpandedStates):{}},savePagination:function(e){return e.api.pagination&&e.options.paginationPageSize?{paginationCurrentPage:e.options.paginationCurrentPage,paginationPageSize:e.options.paginationPageSize}:{}},saveTreeView:function(e){return e.api.treeView&&e.options.saveTreeView?e.api.treeView.getTreeView():{}},getRowVal:function(e,t){var i;return t?(i={},e.options.saveRowIdentity?(i.identity=!0,i.row=e.options.saveRowIdentity(t.entity)):(i.identity=!1,i.row=e.renderContainers.body.visibleRowCache.indexOf(t)),i):null},restoreColumns:function(r,e){var n=!1;e.forEach(function(e,t){var i=r.getColumn(e.name);i&&!r.isRowHeaderColumn(i)&&(!r.options.saveVisible||i.visible===e.visible&&i.colDef.visible===e.visible||(i.visible=e.visible,i.colDef.visible=e.visible,r.api.core.raise.columnVisibilityChanged(i)),r.options.saveWidths&&i.width!==e.width&&(i.width=e.width,i.hasCustomWidth=!0),!r.options.saveSort||angular.equals(i.sort,e.sort)||void 0===i.sort&&angular.isEmpty(e.sort)||(i.sort=angular.copy(e.sort),n=!0),r.options.saveFilter&&!angular.equals(i.filters,e.filters)&&(e.filters.forEach(function(e,t){angular.extend(i.filters[t],e),void 0!==e.term&&null!==e.term||delete i.filters[t].term}),r.api.core.raise.filterChanged(i)),r.api.pinning&&r.options.savePinning&&i.renderContainer!==e.pinned&&r.api.pinning.pinColumn(i,e.pinned),-1!==(e=r.getOnlyDataColumns().indexOf(i)))&&r.options.saveOrder&&e!==t&&(e=r.columns.splice(e+r.rowHeaderColumns.length,1)[0],r.columns.splice(t+r.rowHeaderColumns.length,0,e))}),n&&r.api.core.raise.sortChanged(r,r.getColumnSorting())},restoreScrollFocus:function(e,t,i){var r,n,o;e.api.cellNav&&(i.colName&&0<(o=e.options.columnDefs.filter(function(e){return e.name===i.colName})).length&&(r=o[0]),o=(n=i.rowVal&&i.rowVal.row?i.rowVal.identity?a.findRowByIdentity(e,i.rowVal):e.renderContainers.body.visibleRowCache[i.rowVal.row]:n)&&n.entity?n.entity:null,r||o)&&(i.focus?e.api.cellNav.scrollToFocus(o,r):e.scrollTo(o,r))},restoreSelection:function(i,e){i.api.selection&&(i.api.selection.clearSelectedRows(),e.forEach(function(e){var t;e.identity?(t=a.findRowByIdentity(i,e))&&i.api.selection.selectRow(t.entity):i.api.selection.selectRowByVisibleIndex(e.row)}))},restoreGrouping:function(e,t){e.api.grouping&&null!=t&&!angular.equals(t,{})&&e.api.grouping.setGrouping(t)},restoreTreeView:function(e,t){e.api.treeView&&null!=t&&!angular.equals(t,{})&&e.api.treeView.setTreeView(t)},restorePagination:function(e,t){e.api.pagination&&e.options.paginationPageSize&&(e.options.paginationCurrentPage=t.paginationCurrentPage,e.options.paginationPageSize=t.paginationPageSize)},findRowByIdentity:function(t,i){var e;return t.options.saveRowIdentity&&0<(e=t.rows.filter(function(e){return t.options.saveRowIdentity(e.entity)===i.row})).length?e[0]:null}};return a}),e.directive("uiGridSaveState",["uiGridSaveStateConstants","uiGridSaveStateService","gridUtil","$compile",function(e,n,t,i){return{replace:!0,priority:0,require:"^uiGrid",scope:!1,link:function(e,t,i,r){n.initializeGrid(r.grid)}}}])}(),function(){"use strict";var e=angular.module("ui.grid.selection",["ui.grid"]);e.constant("uiGridSelectionConstants",{featureName:"selection",selectionRowHeaderColName:"selectionRowHeaderCol"}),angular.module("ui.grid").config(["$provide",function(e){e.decorator("GridRow",["$delegate",function(e){return e.prototype.setSelected=function(e){e!==this.isSelected&&(this.isSelected=e,this.grid.selection.selectedCount+=e?1:-1)},e.prototype.setFocused=function(e){e!==this.isFocused&&(this.grid.selection.focusedRow&&(this.grid.selection.focusedRow.isFocused=!1),this.grid.selection.focusedRow=e?this:null,this.isFocused=e)},e}])}]),e.service("uiGridSelectionService",function(){var s={initializeGrid:function(o){o.selection={lastSelectedRow:null,focusedRow:null,selectAll:!1},o.selection.selectedCount=0,s.defaultGridOptions(o.options);var e={selection:{rowFocusChanged:function(e,t,i){},rowSelectionChanged:function(e,t,i){},rowSelectionChangedBatch:function(e,t,i){}}},t={selection:{toggleRowSelection:function(e,t){e=o.getRow(e);null!=e&&null!==e&&s.toggleRowSelection(o,e,t,o.options.multiSelect,o.options.noUnselect,!0)},selectRow:function(e,t){e=o.getRow(e);null==e||null===e||e.isSelected||s.toggleRowSelection(o,e,t,o.options.multiSelect,o.options.noUnselect,!0)},selectRowByVisibleIndex:function(e,t){e=o.renderContainers.body.visibleRowCache[e];null==e||e.isSelected||s.toggleRowSelection(o,e,t,o.options.multiSelect,o.options.noUnselect,!1)},selectRowByKey:function(e,t,i,r,n){e=o.findRowByKey(e,t,i,n);null==e||e.isSelected||s.toggleRowSelection(o,e,r,o.options.multiSelect,o.options.noUnselect,!1)},unSelectRow:function(e,t){e=o.getRow(e);null!=e&&null!==e&&e.isSelected&&s.toggleRowSelection(o,e,t,o.options.multiSelect,o.options.noUnselect,!0)},unSelectRowByVisibleIndex:function(e,t){e=o.renderContainers.body.visibleRowCache[e];null!=e&&null!=e&&e.isSelected&&s.toggleRowSelection(o,e,t,o.options.multiSelect,o.options.noUnselect,!1)},unSelectRowByKey:function(e,t,i,r,n){e=o.findRowByKey(e,t,i,n);null!=e&&null!=e&&e.isSelected&&s.toggleRowSelection(o,e,r,o.options.multiSelect,o.options.noUnselect,!1)},selectAllRows:function(t){var i;!1!==o.options.multiSelect&&(i=[],o.rows.forEach(function(e){e.isSelected||!1===e.enableSelection||!1===o.options.isRowSelectable(e)||(e.setSelected(!0),s.decideRaiseSelectionEvent(o,e,i,t))}),o.selection.selectAll=!0,s.decideRaiseSelectionBatchEvent(o,i,t))},selectAllVisibleRows:function(t){var i;!1!==o.options.multiSelect&&(i=[],o.rows.forEach(function(e){e.visible?e.isSelected||!1===e.enableSelection||!1===o.options.isRowSelectable(e)||(e.setSelected(!0),s.decideRaiseSelectionEvent(o,e,i,t)):e.isSelected&&(e.setSelected(!1),s.decideRaiseSelectionEvent(o,e,i,t))}),o.selection.selectAll=!0,s.decideRaiseSelectionBatchEvent(o,i,t))},clearSelectedRows:function(e){s.clearSelectedRows(o,e)},getSelectedRows:function(){return s.mapAndFilterRowsByEntity(s.getSelectedRows(o))},getUnSelectedRows:function(){return s.mapAndFilterRowsByEntity(s.getUnSelectedRows(o))},getSelectedGridRows:function(){return s.getSelectedRows(o)},getUnSelectedGridRows:function(){return s.getUnSelectedRows(o)},getSelectedCount:function(){return o.selection.selectedCount},setMultiSelect:function(e){o.options.multiSelect=e},setModifierKeysToMultiSelect:function(e){o.options.modifierKeysToMultiSelect=e},getSelectAllState:function(){return o.selection.selectAll}}};o.api.registerEventsFromObject(e),o.api.registerMethodsFromObject(t)},defaultGridOptions:function(e){e.enableRowSelection=!1!==e.enableRowSelection,e.multiSelect=!1!==e.multiSelect,e.noUnselect=!0===e.noUnselect,e.modifierKeysToMultiSelect=!0===e.modifierKeysToMultiSelect,e.enableRowHeaderSelection=!1!==e.enableRowHeaderSelection,void 0===e.enableFullRowSelection&&(e.enableFullRowSelection=!e.enableRowHeaderSelection),e.enableFocusRowOnRowHeaderClick=!1!==e.enableFocusRowOnRowHeaderClick||!e.enableRowHeaderSelection,e.enableSelectRowOnFocus=!1!==e.enableSelectRowOnFocus,e.enableSelectAll=!1!==e.enableSelectAll,e.enableSelectionBatchEvent=!1!==e.enableSelectionBatchEvent,e.selectionRowHeaderWidth=angular.isDefined(e.selectionRowHeaderWidth)?e.selectionRowHeaderWidth:30,e.enableFooterTotalSelected=!1!==e.enableFooterTotalSelected,e.isRowSelectable=angular.isDefined(e.isRowSelectable)?e.isRowSelectable:angular.noop},toggleRowSelection:function(e,t,i,r,n,o){var a;!1===t.enableSelection||(void 0===o&&(o=!0),a=t.isSelected,r||(a?1<s.getSelectedRows(e).length&&(a=!1,s.clearSelectedRows(e,i)):s.clearSelectedRows(e,i)),a&&n)||!o&&!t.visible||(t.setSelected(!a),!0===t.isSelected&&(e.selection.lastSelectedRow=t),e.selection.selectAll=e.rows.length===s.getSelectedRows(e).length,e.api.selection.raise.rowSelectionChanged(t,i))},shiftSelect:function(e,t,i,r){if(r){for(var r=0<s.getSelectedRows(e).length?e.renderContainers.body.visibleRowCache.indexOf(e.selection.lastSelectedRow):0,n=e.renderContainers.body.visibleRowCache.indexOf(t),o=(n<r&&(t=r,r=n,n=t),[]),a=r;a<=n;a++){var l=e.renderContainers.body.visibleRowCache[a];!l||l.isSelected||!1===l.enableSelection||(l.setSelected(!0),e.selection.lastSelectedRow=l,s.decideRaiseSelectionEvent(e,l,o,i))}s.decideRaiseSelectionBatchEvent(e,o,i)}},getSelectedRows:function(e){return e.rows.filter(function(e){return e.isSelected})},getUnSelectedRows:function(e){return e.rows.filter(function(e){return!e.isSelected})},mapAndFilterRowsByEntity:function(e){return"function"==typeof e.reduce?e.reduce(function(e,t){return!t.entity.hasOwnProperty("$$hashKey")&&angular.isObject(t.entity)||e.push(t.entity),e},[]):e.filter(function(e){return e.entity.hasOwnProperty("$$hashKey")||!angular.isObject(e.entity)}).map(function(e){return e.entity})},clearSelectedRows:function(t,i){var r=[];s.getSelectedRows(t).forEach(function(e){e.isSelected&&!1!==e.enableSelection&&(e.setSelected(!1),s.decideRaiseSelectionEvent(t,e,r,i))}),t.selection.selectAll=!1,t.selection.selectedCount=0,s.decideRaiseSelectionBatchEvent(t,r,i)},decideRaiseSelectionEvent:function(e,t,i,r){e.options.enableSelectionBatchEvent?i.push(t):e.api.selection.raise.rowSelectionChanged(t,r)},decideRaiseSelectionBatchEvent:function(e,t,i){0<t.length&&e.api.selection.raise.rowSelectionChangedBatch(t,i)}};return s}),e.directive("uiGridSelection",["i18nService","uiGridSelectionConstants","uiGridSelectionService","uiGridConstants",function(s,d,c,u){return{replace:!0,priority:0,require:"^uiGrid",scope:!1,compile:function(){return{pre:function(e,t,i,r){function n(e){return e.forEach(function(e){e.enableSelection=r.grid.options.isRowSelectable(e)}),e}function o(){r.grid.options.isRowSelectable!==angular.noop&&!0!==a&&(r.grid.registerRowsProcessor(n,500),a=!0)}c.initializeGrid(r.grid),r.grid.options.enableRowHeaderSelection&&(l={name:d.selectionRowHeaderColName,displayName:s.getSafeText("selection.displayName"),width:r.grid.options.selectionRowHeaderWidth,minWidth:10,cellTemplate:"ui-grid/selectionRowHeader",headerCellTemplate:"ui-grid/selectionHeaderCell",enableColumnResizing:!1,enableColumnMenu:!1,exporterSuppressExport:!0,allowCellFocus:!0},r.grid.addRowHeaderColumn(l,0));var a=!1,l=(o(),r.grid.registerDataChangeCallback(o,[u.dataChange.OPTIONS]));e.$on("$destroy",l)},post:function(e,t,i,r){}}}}}]),e.directive("uiGridSelectionRowHeaderButtons",["$templateCache","uiGridSelectionService","gridUtil",function(e,a,l){return{replace:!0,restrict:"E",template:e.get("ui-grid/selectionRowHeaderButtons"),scope:!0,require:"^uiGrid",link:function(e,t,i,r){var n=r.grid;function o(e,t){if(t.stopPropagation(),t.shiftKey)a.shiftSelect(n,e,t,n.options.multiSelect);else if(t.ctrlKey||t.metaKey)a.toggleRowSelection(n,e,t,n.options.multiSelect,n.options.noUnselect,!1);else if(e.groupHeader){a.toggleRowSelection(n,e,t,n.options.multiSelect,n.options.noUnselect,!1);for(var i=0;i<e.treeNode.children.length;i++)a.toggleRowSelection(n,e.treeNode.children[i].row,t,n.options.multiSelect,n.options.noUnselect,!1)}else a.toggleRowSelection(n,e,t,n.options.multiSelect&&!n.options.modifierKeysToMultiSelect,n.options.noUnselect,!1);n.options.enableFocusRowOnRowHeaderClick&&e.setFocused(!e.isFocused)&&n.api.selection.raise.rowFocusChanged(e,t)}e.selectButtonClick=o,e.selectButtonKeyDown=function(e,t){32!==t.keyCode&&13!==t.keyCode||(t.preventDefault(),o(e,t))},"ie"===l.detectBrowser()&&t.on("mousedown",function(e){(e.ctrlKey||e.shiftKey)&&(e.target.onselectstart=function(){return!1},window.setTimeout(function(){e.target.onselectstart=null},0))}),e.$on("$destroy",function(){t.off()})}}}]),e.directive("uiGridSelectionSelectAllButtons",["$templateCache","uiGridSelectionService",function(e,r){return{replace:!0,restrict:"E",template:e.get("ui-grid/selectionSelectAllButtons"),scope:!1,link:function(t){var i=t.col.grid;t.headerButtonKeyDown=function(e){32!==e.keyCode&&13!==e.keyCode||(e.preventDefault(),t.headerButtonClick(e))},t.headerButtonClick=function(e){i.selection.selectAll?(r.clearSelectedRows(i,e),i.options.noUnselect&&i.api.selection.selectRowByVisibleIndex(0,e),i.selection.selectAll=!1):i.options.multiSelect&&(i.api.selection.selectAllVisibleRows(e),i.selection.selectAll=!0)}}}}]),e.directive("uiGridViewport",function(){return{priority:-200,scope:!1,compile:function(e){var e=angular.element(e[0].querySelector(".ui-grid-canvas:not(.ui-grid-empty-base-layer-container)").children[0]),t="'ui-grid-row-selected': row.isSelected, 'ui-grid-row-focused': row.isFocused}",i=e.attr("ng-class"),t=i?i.slice(0,-1)+","+t:"{"+t;return e.attr("ng-class",t),{pre:function(e,t,i,r){},post:function(e,t,i,r){}}}}}),e.directive("uiGridCell",["uiGridConstants","uiGridSelectionService",function(g,p){return{priority:-200,restrict:"A",require:"?^uiGrid",scope:!1,link:function(i,n,e,t){function r(e){o=(new Date).getTime(),a=e.changedTouches[0],n.off("click",d)}var o=0,a={},l=300,s=100,d=(t.grid.api.cellNav&&t.grid.api.cellNav.on.viewPortKeyDown(i,function(e,t){null!==t&&t.row===i.row&&t.col===i.col&&e.keyCode===g.keymap.SPACE&&"selectionRowHeaderCol"===i.col.colDef.name&&(e.preventDefault(),p.toggleRowSelection(i.grid,i.row,e,i.grid.options.multiSelect&&!i.grid.options.modifierKeysToMultiSelect,i.grid.options.noUnselect,!1),i.$apply())}),function(e){"ui-grid-icon-minus-squared"!==e.target.className&&"ui-grid-icon-plus-squared"!==e.target.className&&(n.off("touchend",c),e.shiftKey?p.shiftSelect(i.grid,i.row,e,i.grid.options.multiSelect):e.ctrlKey||e.metaKey?p.toggleRowSelection(i.grid,i.row,e,i.grid.options.multiSelect,i.grid.options.noUnselect,!1):i.grid.options.enableSelectRowOnFocus&&p.toggleRowSelection(i.grid,i.row,e,i.grid.options.multiSelect&&!i.grid.options.modifierKeysToMultiSelect,i.grid.options.noUnselect,!1),i.row.setFocused(!i.row.isFocused),i.grid.api.selection.raise.rowFocusChanged(i.row,e),i.$apply(),window.setTimeout(function(){n.on("touchend",c)},l))}),c=function(e){var t=(new Date).getTime(),i=e.changedTouches[0],t=t-o,r=Math.abs(a.clientX-i.clientX),i=Math.abs(a.clientY-i.clientY);r<s&&i<s&&t<l&&d(e),window.setTimeout(function(){n.on("click",d)},l)};function u(){i.grid.options.enableRowSelection&&i.grid.options.enableFullRowSelection&&"selectionRowHeaderCol"!==i.col.colDef.name&&(n.addClass("ui-grid-disable-selection"),n.on("touchstart",r),n.on("touchend",c),n.on("click",d),i.registered=!0)}u();t=i.grid.registerDataChangeCallback(function(){i.grid.options.enableRowSelection&&i.grid.options.enableFullRowSelection&&!i.registered?u():i.grid.options.enableRowSelection&&i.grid.options.enableFullRowSelection||!i.registered||i.registered&&(n.removeClass("ui-grid-disable-selection"),n.off("touchstart",r),n.off("touchend",c),n.off("click",d),i.registered=!1)},[g.dataChange.OPTIONS]);n.on("$destroy",t)}}}]),e.directive("uiGridGridFooter",["$compile","gridUtil",function(n,o){return{restrict:"EA",replace:!0,priority:-1e3,require:"^uiGrid",scope:!0,compile:function(){return{pre:function(t,i,e,r){r.grid.options.showGridFooter&&o.getTemplate("ui-grid/gridFooterSelectedItems").then(function(e){e=angular.element(e),e=n(e)(t);angular.element(i[0].getElementsByClassName("ui-grid-grid-footer")[0]).append(e)})},post:function(e,t,i,r){}}}}}])}(),function(){"use strict";var e=angular.module("ui.grid.treeBase",["ui.grid"]);e.constant("uiGridTreeBaseConstants",{featureName:"treeBase",rowHeaderColName:"treeBaseRowHeaderCol",EXPANDED:"expanded",COLLAPSED:"collapsed",aggregation:{COUNT:"count",SUM:"sum",MAX:"max",MIN:"min",AVG:"avg"}}),e.service("uiGridTreeBaseService",["$q","uiGridTreeBaseConstants","gridUtil","GridRow","gridClassFactory","i18nService","uiGridConstants","rowSorter",function(e,l,t,i,r,n,o,a){var s={initializeGrid:function(i){i.treeBase={},i.treeBase.numberLevels=0,i.treeBase.expandAll=!1,i.treeBase.tree=[],s.defaultGridOptions(i.options),i.registerRowsProcessor(s.treeRows,410),i.registerColumnBuilder(s.treeBaseColumnBuilder),s.createRowHeader(i);var e={treeBase:{rowExpanded:{},rowCollapsed:{}}},t={treeBase:{expandAllRows:function(){s.expandAllRows(i)},collapseAllRows:function(){s.collapseAllRows(i)},toggleRowTreeState:function(e){s.toggleRowTreeState(i,e)},expandRow:function(e,t){s.expandRow(i,e,t)},expandRowChildren:function(e){s.expandRowChildren(i,e)},collapseRow:function(e){s.collapseRow(i,e)},collapseRowChildren:function(e){s.collapseRowChildren(i,e)},getTreeExpandedState:function(){return{expandedState:s.getTreeState(i)}},setTreeState:function(e){s.setTreeState(i,e)},getRowChildren:function(e){return e.treeNode.children.map(function(e){return e.row})}}};i.api.registerEventsFromObject(e),i.api.registerMethodsFromObject(t)},defaultGridOptions:function(e){e.treeRowHeaderBaseWidth=e.treeRowHeaderBaseWidth||30,e.treeIndent=null!=e.treeIndent?e.treeIndent:10,e.showTreeRowHeader=!1!==e.showTreeRowHeader,e.showTreeExpandNoChildren=!1!==e.showTreeExpandNoChildren,e.treeRowHeaderAlwaysVisible=!1!==e.treeRowHeaderAlwaysVisible,e.treeCustomAggregations=e.treeCustomAggregations||{},e.enableExpandAll=!1!==e.enableExpandAll},treeBaseColumnBuilder:function(e,t,i){void 0!==e.customTreeAggregationFn&&(t.treeAggregationFn=e.customTreeAggregationFn),void 0!==e.treeAggregationType&&(t.treeAggregation={type:e.treeAggregationType},void 0!==i.treeCustomAggregations[e.treeAggregationType]?(t.treeAggregationFn=i.treeCustomAggregations[e.treeAggregationType].aggregationFn,t.treeAggregationFinalizerFn=i.treeCustomAggregations[e.treeAggregationType].finalizerFn,t.treeAggregation.label=i.treeCustomAggregations[e.treeAggregationType].label):void 0!==s.nativeAggregations()[e.treeAggregationType]&&(t.treeAggregationFn=s.nativeAggregations()[e.treeAggregationType].aggregationFn,t.treeAggregation.label=s.nativeAggregations()[e.treeAggregationType].label)),void 0!==e.treeAggregationLabel&&(void 0===t.treeAggregation&&(t.treeAggregation={}),t.treeAggregation.label=e.treeAggregationLabel),t.treeAggregationUpdateEntity=!1!==e.treeAggregationUpdateEntity,void 0===t.customTreeAggregationFinalizerFn&&(t.customTreeAggregationFinalizerFn=e.customTreeAggregationFinalizerFn)},createRowHeader:function(e){var t={name:l.rowHeaderColName,displayName:"",width:e.options.treeRowHeaderBaseWidth,minWidth:10,cellTemplate:"ui-grid/treeBaseRowHeader",headerCellTemplate:"ui-grid/treeBaseHeaderCell",enableColumnResizing:!1,enableColumnMenu:!1,exporterSuppressExport:!0,allowCellFocus:!0};t.visible=e.options.treeRowHeaderAlwaysVisible,e.addRowHeaderColumn(t,-100)},expandAllRows:function(t){t.treeBase.tree.forEach(function(e){s.setAllNodes(t,e,l.EXPANDED)}),t.treeBase.expandAll=!0,t.queueGridRefresh()},collapseAllRows:function(t){t.treeBase.tree.forEach(function(e){s.setAllNodes(t,e,l.COLLAPSED)}),t.treeBase.expandAll=!1,t.queueGridRefresh()},setAllNodes:function(t,e,i){void 0!==e.state&&e.state!==i&&((e.state=i)===l.EXPANDED?t.api.treeBase.raise.rowExpanded(e.row):t.api.treeBase.raise.rowCollapsed(e.row)),e.children&&e.children.forEach(function(e){s.setAllNodes(t,e,i)})},toggleRowTreeState:function(e,t){void 0===t.treeLevel||null===t.treeLevel||t.treeLevel<0||(t.treeNode.state===l.EXPANDED?s.collapseRow(e,t):s.expandRow(e,t,!1),e.queueGridRefresh())},expandRow:function(e,t,i){if(i){for(var r=[];t&&void 0!==t.treeLevel&&null!==t.treeLevel&&0<=t.treeLevel&&t.treeNode.state!==l.EXPANDED;)r.push(t),t=t.treeNode.parentRow;if(0<r.length){for(t=r.pop();t;)t.treeNode.state=l.EXPANDED,e.api.treeBase.raise.rowExpanded(t),t=r.pop();e.treeBase.expandAll=s.allExpanded(e.treeBase.tree),e.queueGridRefresh()}}else void 0===t.treeLevel||null===t.treeLevel||t.treeLevel<0||t.treeNode.state!==l.EXPANDED&&(t.treeNode.state=l.EXPANDED,e.api.treeBase.raise.rowExpanded(t),e.treeBase.expandAll=s.allExpanded(e.treeBase.tree),e.queueGridRefresh())},expandRowChildren:function(e,t){void 0===t.treeLevel||null===t.treeLevel||t.treeLevel<0||(s.setAllNodes(e,t.treeNode,l.EXPANDED),e.treeBase.expandAll=s.allExpanded(e.treeBase.tree),e.queueGridRefresh())},collapseRow:function(e,t){void 0===t.treeLevel||null===t.treeLevel||t.treeLevel<0||t.treeNode.state!==l.COLLAPSED&&(t.treeNode.state=l.COLLAPSED,e.treeBase.expandAll=!1,e.api.treeBase.raise.rowCollapsed(t),e.queueGridRefresh())},collapseRowChildren:function(e,t){void 0===t.treeLevel||null===t.treeLevel||t.treeLevel<0||(s.setAllNodes(e,t.treeNode,l.COLLAPSED),e.treeBase.expandAll=!1,e.queueGridRefresh())},allExpanded:function(e){var t=!0;return e.forEach(function(e){s.allExpandedInternal(e)||(t=!1)}),t},allExpandedInternal:function(e){var t;return!(e.children&&0<e.children.length)||e.state!==l.COLLAPSED&&(t=!0,e.children.forEach(function(e){s.allExpandedInternal(e)||(t=!1)}),t)},treeRows:function(e){return 0===e.length?(s.updateRowHeaderWidth(this),e):(this.treeBase.tree=s.createTree(this,e),s.updateRowHeaderWidth(this),s.sortTree(this),s.fixFilter(this),s.renderTree(this.treeBase.tree))},updateRowHeaderWidth:function(e){var t=e.getColumn(l.rowHeaderColName),i=e.options.treeRowHeaderBaseWidth+e.options.treeIndent*Math.max(e.treeBase.numberLevels-1,0),i=(t&&i!==t.width&&(t.width=i,e.queueRefresh()),!0);!1===e.options.showTreeRowHeader&&(i=!1),!1===e.options.treeRowHeaderAlwaysVisible&&e.treeBase.numberLevels<=0&&(i=!1),t&&t.visible!==i&&(t.visible=i,t.colDef.visible=i,e.queueGridRefresh())},renderTree:function(e){var t=[];return e.forEach(function(e){e.row.visible&&t.push(e.row),e.state===l.EXPANDED&&e.children&&0<e.children.length&&(t=t.concat(s.renderTree(e.children)))}),t},createTree:function(i,e){var r=-1,n={},o=[],a=(i.treeBase.tree=[],i.treeBase.numberLevels=0,s.getAggregations(i));for(e.forEach(function(e){if(e.internalRow||e.treeLevel===e.entity.$$treeLevel||(e.treeLevel=e.entity.$$treeLevel),e.treeLevel<=r){for(;e.treeLevel<=r;){var t=o.pop();s.finaliseAggregations(t),r--}0<o.length?s.setCurrentState(o):l.EXPANDED}void 0!==e.treeLevel&&null!==e.treeLevel&&0<=e.treeLevel&&n.hasOwnProperty(e.uid)&&o.push(n[e.uid]),(void 0===e.treeLevel||null===e.treeLevel||e.treeLevel<0)&&e.visible&&s.aggregate(i,e,o),n.hasOwnProperty(e.uid)||s.addOrUseNode(i,e,o,a),void 0!==e.treeLevel&&null!==e.treeLevel&&0<=e.treeLevel&&(n.hasOwnProperty(e.uid)||(n[e.uid]=e,o.push(e)),r++,s.setCurrentState(o)),i.treeBase.numberLevels<e.treeLevel+1&&(i.treeBase.numberLevels=e.treeLevel+1)});0<o.length;){var t=o.pop();s.finaliseAggregations(t)}return i.treeBase.tree},addOrUseNode:function(e,t,i,r){var n=[],r=(r.forEach(function(e){n.push(s.buildAggregationObject(e.col))}),{state:l.COLLAPSED,row:t,parentRow:null,aggregations:n,children:[]});t.treeNode&&(r.state=t.treeNode.state),0<i.length&&(r.parentRow=i[i.length-1]),t.treeNode=r,(0===i.length?e.treeBase.tree:i[i.length-1].treeNode.children).push(r)},setCurrentState:function(e){var t=l.EXPANDED;return e.forEach(function(e){e.treeNode.state===l.COLLAPSED&&(t=l.COLLAPSED)}),t},sortTree:function(e){e.columns.forEach(function(e){e.sort&&e.sort.ignoreSort&&delete e.sort.ignoreSort}),e.treeBase.tree=s.sortInternal(e,e.treeBase.tree)},sortInternal:function(t,e){e=e.map(function(e){return e.row}),e=(e=a.sort(t,e,t.columns)).map(function(e){return e.treeNode});return e.forEach(function(e){e.state===l.EXPANDED&&e.children&&0<e.children.length&&(e.children=s.sortInternal(t,e.children))}),e},fixFilter:function(e){var t;e.treeBase.tree.forEach(function(e){e.children&&0<e.children.length&&(t=e.row.visible,s.fixFilterInternal(e.children,t))})},fixFilterInternal:function(e,t){return e.forEach(function(e){e.row.visible&&!t&&(s.setParentsVisible(e),t=!0),e.children&&0<e.children.length&&s.fixFilterInternal(e.children,t&&e.row.visible)&&(t=!0)}),t},setParentsVisible:function(e){for(;e.parentRow;)e.parentRow.visible=!0,e=e.parentRow.treeNode},buildAggregationObject:function(e){var t={col:e};return e.treeAggregation&&e.treeAggregation.type&&(t.type=e.treeAggregation.type),e.treeAggregation&&e.treeAggregation.label&&(t.label=e.treeAggregation.label),t},getAggregations:function(t){var i=[];return t.columns.forEach(function(e){void 0!==e.treeAggregationFn&&(i.push(s.buildAggregationObject(e)),t.options.showColumnFooter)&&void 0===e.colDef.aggregationType&&e.treeAggregation&&(e.treeFooterAggregation=s.buildAggregationObject(e),e.aggregationType=s.treeFooterAggregationType)}),i},aggregate:function(n,o,e){0===e.length&&o.treeNode&&o.treeNode.aggregations&&o.treeNode.aggregations.forEach(function(e){var t,i;void 0!==e.col.treeFooterAggregation&&(t=n.getCellValue(o,e.col),i=Number(t),e.col.treeAggregationFn?e.col.treeAggregationFn(e.col.treeFooterAggregation,t,i,o):e.col.treeFooterAggregation.value=void 0)}),e.forEach(function(e,r){e.treeNode.aggregations&&e.treeNode.aggregations.forEach(function(e){var t=n.getCellValue(o,e.col),i=Number(t);e.col.treeAggregationFn(e,t,i,o),0===r&&void 0!==e.col.treeFooterAggregation&&(e.col.treeAggregationFn?e.col.treeAggregationFn(e.col.treeFooterAggregation,t,i,o):e.col.treeFooterAggregation.value=void 0)})})},nativeAggregations:function(){return{count:{label:n.get().aggregation.count,menuTitle:n.get().grouping.aggregate_count,aggregationFn:function(e,t,i){void 0===e.value?e.value=1:e.value++}},sum:{label:n.get().aggregation.sum,menuTitle:n.get().grouping.aggregate_sum,aggregationFn:function(e,t,i){isNaN(i)||(void 0===e.value?e.value=i:e.value+=i)}},min:{label:n.get().aggregation.min,menuTitle:n.get().grouping.aggregate_min,aggregationFn:function(e,t,i){(void 0===e.value||null!=t&&(t<e.value||null===e.value))&&(e.value=t)}},max:{label:n.get().aggregation.max,menuTitle:n.get().grouping.aggregate_max,aggregationFn:function(e,t,i){(void 0===e.value||null!=t&&(t>e.value||null===e.value))&&(e.value=t)}},avg:{label:n.get().aggregation.avg,menuTitle:n.get().grouping.aggregate_avg,aggregationFn:function(e,t,i){void 0===e.count?e.count=1:e.count++,isNaN(i)||(void 0===e.value||void 0===e.sum?(e.value=i,e.sum=i):(e.sum+=i,e.value=e.sum/e.count))}}}},finaliseAggregation:function(e,t){t.col.treeAggregationUpdateEntity&&void 0!==e&&void 0!==e.entity["$$"+t.col.uid]&&angular.extend(t,e.entity["$$"+t.col.uid]),"function"==typeof t.col.treeAggregationFinalizerFn&&t.col.treeAggregationFinalizerFn(t),"function"==typeof t.col.customTreeAggregationFinalizerFn&&t.col.customTreeAggregationFinalizerFn(t),void 0===t.rendered&&(t.rendered=t.label?t.label+t.value:t.value)},finaliseAggregations:function(e){null!=e&&void 0!==e.treeNode.aggregations&&e.treeNode.aggregations.forEach(function(i){var r;s.finaliseAggregation(e,i),i.col.treeAggregationUpdateEntity&&(r={},angular.forEach(i,function(e,t){i.hasOwnProperty(t)&&"col"!==t&&(r[t]=e)}),e.entity["$$"+i.col.uid]=r)})},treeFooterAggregationType:function(e,t){return s.finaliseAggregation(void 0,t.treeFooterAggregation),void 0===t.treeFooterAggregation.value||null===t.treeFooterAggregation.rendered?"":t.treeFooterAggregation.rendered}};return s}]),e.directive("uiGridTreeBaseRowHeaderButtons",["$templateCache","uiGridTreeBaseService",function(e,o){return{replace:!0,restrict:"E",template:e.get("ui-grid/treeBaseRowHeaderButtons"),scope:!0,require:"^uiGrid",link:function(i,e,t,r){var n=r.grid;i.treeButtonClass=function(e){if(n.options.showTreeExpandNoChildren&&-1<e.treeLevel||e.treeNode.children&&0<e.treeNode.children.length)return"expanded"===e.treeNode.state?"ui-grid-icon-minus-squared":"collapsed"===e.treeNode.state?"ui-grid-icon-plus-squared":void 0},i.treeButtonClick=function(e,t){t.stopPropagation(),o.toggleRowTreeState(n,e,t)},i.treeButtonKeyDown=function(e,t){32!==t.keyCode&&13!==t.keyCode||i.treeButtonClick(e,t)}}}}]),e.directive("uiGridTreeBaseExpandAllButtons",["$templateCache","uiGridTreeBaseService",function(e,r){return{replace:!0,restrict:"E",template:e.get("ui-grid/treeBaseExpandAllButtons"),scope:!1,link:function(t){var i=t.col.grid;t.headerButtonClass=function(){return 0<i.treeBase.numberLevels&&i.treeBase.expandAll?"ui-grid-icon-minus-squared":0<i.treeBase.numberLevels&&!i.treeBase.expandAll?"ui-grid-icon-plus-squared":void 0},t.headerButtonClick=function(e,t){i.treeBase.expandAll?r.collapseAllRows(i,t):r.expandAllRows(i,t)},t.headerButtonKeyDown=function(e){32!==e.keyCode&&13!==e.keyCode||t.headerButtonClick(i,e)}}}}]),e.directive("uiGridViewport",function(){return{priority:-200,scope:!1,compile:function(e){var e=angular.element(e.children().children()[0]),t=e.attr("ng-class"),i="",i=t?t.slice(0,-1)+",'ui-grid-tree-header-row': row.treeLevel > -1}":"{'ui-grid-tree-header-row': row.treeLevel > -1}";return e.attr("ng-class",i),{pre:function(e,t,i,r){},post:function(e,t,i,r){}}}}})}(),function(){"use strict";var e=angular.module("ui.grid.treeView",["ui.grid","ui.grid.treeBase"]);e.constant("uiGridTreeViewConstants",{featureName:"treeView",rowHeaderColName:"treeBaseRowHeaderCol",EXPANDED:"expanded",COLLAPSED:"collapsed",aggregation:{COUNT:"count",SUM:"sum",MAX:"max",MIN:"min",AVG:"avg"}}),e.service("uiGridTreeViewService",["$q","uiGridTreeViewConstants","uiGridTreeBaseConstants","uiGridTreeBaseService","gridUtil","GridRow","gridClassFactory","i18nService","uiGridConstants",function(e,t,i,r,n,o,a,l,s){var d={initializeGrid:function(e,t){r.initializeGrid(e,t),e.treeView={},e.registerRowsProcessor(d.adjustSorting,60);var t={treeView:{}},i={treeView:{}};e.api.registerEventsFromObject(t),e.api.registerMethodsFromObject(i)},defaultGridOptions:function(e){e.enableTreeView=!1!==e.enableTreeView},adjustSorting:function(e){return this.columns.forEach(function(e){e.sort&&(e.sort.ignoreSort=!0)}),e}};return d}]),e.directive("uiGridTreeView",["uiGridTreeViewConstants","uiGridTreeViewService","$templateCache",function(e,n,t){return{replace:!0,priority:0,require:"^uiGrid",scope:!1,compile:function(){return{pre:function(e,t,i,r){!1!==r.grid.options.enableTreeView&&n.initializeGrid(r.grid,e)},post:function(e,t,i,r){}}}}}])}(),function(){"use strict";var e=angular.module("ui.grid.validate",["ui.grid"]);e.service("uiGridValidateService",["$sce","$q","$http","i18nService","uiGridConstants",function(r,s,e,n,t){var d={validatorFactories:{},setExternalFactoryFunction:function(e){d.externalFactoryFunction=e},clearExternalFactory:function(){delete d.externalFactoryFunction},getValidatorFromExternalFactory:function(e,t){return d.externalFactoryFunction(e,t).validatorFactory(t)},getMessageFromExternalFactory:function(e,t){return d.externalFactoryFunction(e,t).messageFunction(t)},setValidator:function(e,t,i){d.validatorFactories[e]={validatorFactory:t,messageFunction:i}},getValidator:function(e,t){if(d.externalFactoryFunction){var i=d.getValidatorFromExternalFactory(e,t);if(i)return i}if(d.validatorFactories[e])return d.validatorFactories[e].validatorFactory(t);throw"Invalid validator name: "+e},getMessage:function(e,t){if(d.externalFactoryFunction){var i=d.getMessageFromExternalFactory(e,t);if(i)return i}return d.validatorFactories[e].messageFunction(t)},isInvalid:function(e,t){return e["$$invalid"+t.name]},setInvalid:function(e,t){e["$$invalid"+t.name]=!0},setValid:function(e,t){delete e["$$invalid"+t.name]},setError:function(e,t,i){e["$$errors"+t.name]||(e["$$errors"+t.name]={}),e["$$errors"+t.name][i]=!0},clearError:function(e,t,i){e["$$errors"+t.name]&&i in e["$$errors"+t.name]&&delete e["$$errors"+t.name][i]},getErrorMessages:function(e,t){var i=[];return e["$$errors"+t.name]&&0!==Object.keys(e["$$errors"+t.name]).length&&Object.keys(e["$$errors"+t.name]).sort().forEach(function(e){i.push(d.getMessage(e,t.validators[e]))}),i},getFormattedErrors:function(e,t){var i="",e=d.getErrorMessages(e,t);if(e.length)return e.forEach(function(e){i+=e+"<br/>"}),r.trustAsHtml("<p><b>"+n.getSafeText("validate.error")+"</b></p>"+i)},getTitleFormattedErrors:function(e,t){var i="",e=d.getErrorMessages(e,t);if(e.length)return e.forEach(function(e){i+=e+"\n"}),r.trustAsHtml(n.getSafeText("validate.error")+"\n"+i)},runValidators:function(e,t,n,o,a){if(n!==o){if(void 0===t.name||!t.name)throw new Error("colDef.name is required to perform validation");d.setValid(e,t);var i,r=[];for(i in t.validators){d.clearError(e,t,i);var l=d.getValidator(i,t.validators[i]),l=s.when(l(o,n,e,t)).then(function(t,i,r){return function(e){e||(d.setInvalid(t,i),d.setError(t,i,r),a&&a.api.validate.raise.validationFailed(t,i,n,o))}}(e,t,i));r.push(l)}return s.all(r)}},createDefaultValidators:function(){d.setValidator("minLength",function(i){return function(e,t){return null==t||""===t||t.length>=i}},function(e){return n.getSafeText("validate.minLength").replace("THRESHOLD",e)}),d.setValidator("maxLength",function(i){return function(e,t){return null==t||""===t||t.length<=i}},function(e){return n.getSafeText("validate.maxLength").replace("THRESHOLD",e)}),d.setValidator("required",function(i){return function(e,t){return!i||!(null==t||""===t)}},function(){return n.getSafeText("validate.required")})},initializeGrid:function(e,n){n.validate={isInvalid:d.isInvalid,getErrorMessages:d.getErrorMessages,getFormattedErrors:d.getFormattedErrors,getTitleFormattedErrors:d.getTitleFormattedErrors,runValidators:d.runValidators};var t={validate:{validationFailed:function(e,t,i,r){}}},i={validate:{isInvalid:function(e,t){return n.validate.isInvalid(e,t)},getErrorMessages:function(e,t){return n.validate.getErrorMessages(e,t)},getFormattedErrors:function(e,t){return n.validate.getFormattedErrors(e,t)},getTitleFormattedErrors:function(e,t){return n.validate.getTitleFormattedErrors(e,t)}}};n.api.registerEventsFromObject(t),n.api.registerMethodsFromObject(i),n.edit&&n.api.edit.on.afterCellEdit(e,function(e,t,i,r){n.validate.runValidators(e,t,i,r,n)}),d.createDefaultValidators()}};return d}]),e.directive("uiGridValidate",["gridUtil","uiGridValidateService",function(e,n){return{priority:0,replace:!0,require:"^uiGrid",scope:!1,compile:function(){return{pre:function(e,t,i,r){n.initializeGrid(e,r.grid)},post:function(e,t,i,r){}}}}}])}(),angular.module("ui.grid").run(["$templateCache",function(e){"use strict";e.put("ui-grid/ui-grid-filter",'<div class="ui-grid-filter-container" ng-style="col.extraStyle" ng-repeat="colFilter in col.filters" ng-class="{\'ui-grid-filter-cancel-button-hidden\' : colFilter.disableCancelFilterButton === true }"><div ng-if="colFilter.type !== \'select\'"><input type="text" class="ui-grid-filter-input ui-grid-filter-input-{{$index}}" ng-model="colFilter.term" ng-attr-placeholder="{{colFilter.placeholder || \'\'}}" aria-label="{{colFilter.ariaLabel || aria.defaultFilterLabel}}"><div role="button" class="ui-grid-filter-button" ng-click="removeFilter(colFilter, $index)" ng-if="!colFilter.disableCancelFilterButton" ng-disabled="colFilter.term === undefined || colFilter.term === null || colFilter.term === \'\'" ng-show="colFilter.term !== undefined && colFilter.term !== null && colFilter.term !== \'\'"><i class="ui-grid-icon-cancel" ui-grid-one-bind-aria-label="aria.removeFilter">&nbsp;</i></div></div><div ng-if="colFilter.type === \'select\'"><select class="ui-grid-filter-select ui-grid-filter-input-{{$index}}" ng-model="colFilter.term" ng-show="colFilter.selectOptions.length > 0" ng-attr-placeholder="{{colFilter.placeholder || aria.defaultFilterLabel}}" aria-label="{{colFilter.ariaLabel || \'\'}}" ng-options="option.value as option.label for option in colFilter.selectOptions"><option value=""></option></select><div role="button" class="ui-grid-filter-button-select" ng-click="removeFilter(colFilter, $index)" ng-if="!colFilter.disableCancelFilterButton" ng-disabled="colFilter.term === undefined || colFilter.term === null || colFilter.term === \'\'" ng-show="colFilter.term !== undefined && colFilter.term != null"><i class="ui-grid-icon-cancel" ui-grid-one-bind-aria-label="aria.removeFilter">&nbsp;</i></div></div></div>'),e.put("ui-grid/ui-grid-footer",'<div class="ui-grid-footer-panel ui-grid-footer-aggregates-row">\x3c!-- tfooter --\x3e<div class="ui-grid-footer ui-grid-footer-viewport"><div class="ui-grid-footer-canvas"><div class="ui-grid-footer-cell-wrapper" ng-style="colContainer.headerCellWrapperStyle()"><div role="row" class="ui-grid-footer-cell-row"><div ui-grid-footer-cell role="gridcell" ng-repeat="col in colContainer.renderedColumns track by col.uid" col="col" render-index="$index" class="ui-grid-footer-cell ui-grid-clearfix"></div></div></div></div></div></div>'),e.put("ui-grid/ui-grid-grid-footer",'<div class="ui-grid-footer-info ui-grid-grid-footer"><span>{{\'search.totalItems\' | t}} {{grid.rows.length}}</span> <span ng-if="grid.renderContainers.body.visibleRowCache.length !== grid.rows.length" class="ngLabel">({{"search.showingItems" | t}} {{grid.renderContainers.body.visibleRowCache.length}})</span></div>'),e.put("ui-grid/ui-grid-header",'<div role="rowgroup" class="ui-grid-header">\x3c!-- theader --\x3e<div class="ui-grid-top-panel"><div class="ui-grid-header-viewport"><div class="ui-grid-header-canvas"><div class="ui-grid-header-cell-wrapper" ng-style="colContainer.headerCellWrapperStyle()"><div role="row" class="ui-grid-header-cell-row"><div role="columnheader" class="ui-grid-header-cell ui-grid-clearfix" ng-repeat="col in colContainer.renderedColumns track by col.uid" ui-grid-header-cell col="col" render-index="$index"></div></div></div></div></div></div></div>'),e.put("ui-grid/ui-grid-menu-button",'<div class="ui-grid-menu-button"><div role="button" ui-grid-one-bind-id-grid="\'grid-menu\'" ui-grid-one-bind-aria-label="i18n.aria.buttonLabel" tabindex="0" class="ui-grid-icon-container" ng-click="toggleMenu()" ng-keydown="toggleOnKeydown($event)" aria-expanded="{{shown}}" aria-haspopup="true"><i class="ui-grid-icon-menu" ui-grid-one-bind-aria-label="i18n.aria.buttonLabel">&nbsp;</i></div><div ui-grid-menu menu-items="menuItems"></div></div>'),e.put("ui-grid/ui-grid-menu-header-item",'<li role="menuitem"><div class="ui-grid-menu-item" role="heading" aria-level="2" ng-show="itemShown()"><i aria-hidden="true">&nbsp; </i><span ng-bind="label()"></span></div></li>'),e.put("ui-grid/ui-grid-no-header",'<div class="ui-grid-top-panel"></div>'),e.put("ui-grid/ui-grid-row","<div ng-repeat=\"(colRenderIndex, col) in colContainer.renderedColumns track by col.uid\" ui-grid-one-bind-id-grid=\"rowRenderIndex + '-' + col.uid + '-cell'\" class=\"ui-grid-cell\" ng-class=\"{ 'ui-grid-row-header-cell': col.isRowHeader }\" role=\"{{col.isRowHeader ? 'rowheader' : 'gridcell'}}\" ui-grid-cell></div>"),e.put("ui-grid/ui-grid",'<div ui-i18n="en" class="ui-grid">\x3c!-- TODO (c0bra): add "scoped" attr here, eventually? --\x3e<style ui-grid-style>.grid{{ grid.id }} {\n      /* Styles for the grid */\n    }\n\n    .grid{{ grid.id }} .ui-grid-row, .grid{{ grid.id }} .ui-grid-cell, .grid{{ grid.id }} .ui-grid-cell .ui-grid-vertical-bar {\n      height: {{ grid.options.rowHeight }}px;\n    }\n\n    .grid{{ grid.id }} .ui-grid-row:last-child .ui-grid-cell {\n      border-bottom-width: {{ (((grid.getVisibleRowCount() * grid.options.rowHeight) < grid.getViewportHeight()) && \'1\') || \'0\' }}px;\n    }\n\n    {{ grid.verticalScrollbarStyles }}\n    {{ grid.horizontalScrollbarStyles }}\n\n    /*\n    .ui-grid[dir=rtl] .ui-grid-viewport {\n      padding-left: {{ grid.verticalScrollbarWidth }}px;\n    }\n    */\n\n    {{ grid.customStyles }}</style><div class="ui-grid-contents-wrapper" role="grid"><div ui-grid-menu-button ng-if="grid.options.enableGridMenu"></div><div ng-if="grid.hasLeftContainer()" style="width: 0" ui-grid-pinned-container="\'left\'"></div><div ui-grid-render-container container-id="\'body\'" col-container-name="\'body\'" row-container-name="\'body\'" bind-scroll-horizontal="true" bind-scroll-vertical="true" enable-horizontal-scrollbar="grid.options.enableHorizontalScrollbar" enable-vertical-scrollbar="grid.options.enableVerticalScrollbar"></div><div ng-if="grid.hasRightContainer()" style="width: 0" ui-grid-pinned-container="\'right\'"></div><div ui-grid-grid-footer ng-if="grid.options.showGridFooter"></div><div ui-grid-column-menu ng-if="grid.options.enableColumnMenus"></div><div ng-transclude></div></div></div>'),e.put("ui-grid/uiGridCell",'<div class="ui-grid-cell-contents" title="TOOLTIP">{{COL_FIELD CUSTOM_FILTERS}}</div>'),e.put("ui-grid/uiGridColumnMenu",'<div class="ui-grid-column-menu"><div ui-grid-menu menu-items="menuItems" col="col">\x3c!-- <div class="ui-grid-column-menu">\n    <div class="inner" ng-show="menuShown">\n      <ul>\n        <div ng-show="grid.options.enableSorting">\n          <li ng-click="sortColumn($event, asc)" ng-class="{ \'selected\' : col.sort.direction == asc }"><i class="ui-grid-icon-sort-alt-up"></i> Sort Ascending</li>\n          <li ng-click="sortColumn($event, desc)" ng-class="{ \'selected\' : col.sort.direction == desc }"><i class="ui-grid-icon-sort-alt-down"></i> Sort Descending</li>\n          <li ng-show="col.sort.direction" ng-click="unsortColumn()"><i class="ui-grid-icon-cancel"></i> Remove Sort</li>\n        </div>\n      </ul>\n    </div>\n  </div> --\x3e</div></div>'),e.put("ui-grid/uiGridFooterCell",'<div class="ui-grid-cell-contents" col-index="renderIndex"><div>{{ col.getAggregationText() + ( col.getAggregationValue() CUSTOM_FILTERS ) }}</div></div>'),e.put("ui-grid/uiGridHeaderCell",'<div role="columnheader" ng-class="{ \'sortable\': sortable, \'ui-grid-header-cell-last-col\': isLastCol }" ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'" aria-sort="{{col.sort.direction == asc ? \'ascending\' : ( col.sort.direction == desc ? \'descending\' : (!col.sort.direction ? \'none\' : \'other\'))}}"><div role="button" tabindex="0" ng-keydown="handleKeyDown($event)" class="ui-grid-cell-contents ui-grid-header-cell-primary-focus" col-index="renderIndex" title="TOOLTIP"><span class="ui-grid-header-cell-label" ui-grid-one-bind-id-grid="col.uid + \'-header-text\'">{{ col.displayName CUSTOM_FILTERS }}</span> <span ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'" ui-grid-visible="col.sort.direction" aria-label="{{getSortDirectionAriaLabel()}}"><i ng-class="{ \'ui-grid-icon-up-dir\': col.sort.direction == asc, \'ui-grid-icon-down-dir\': col.sort.direction == desc, \'ui-grid-icon-blank\': !col.sort.direction }" title="{{isSortPriorityVisible() ? i18n.headerCell.priority + \' \' + ( col.sort.priority + 1 )  : null}}" aria-hidden="true"></i> <sub ui-grid-visible="isSortPriorityVisible()" class="ui-grid-sort-priority-number">{{col.sort.priority + 1}}</sub></span></div><div role="button" tabindex="0" ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'" class="ui-grid-column-menu-button" ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false" ng-click="toggleMenu($event)" ng-keydown="headerCellArrowKeyDown($event)" ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel" aria-expanded="{{col.menuShown}}" aria-haspopup="true"><i class="ui-grid-icon-angle-down" aria-hidden="true">&nbsp;</i></div><div ui-grid-filter ng-hide="col.filterContainer === \'columnMenu\'"></div></div>'),e.put("ui-grid/uiGridMenu",'<div class="ui-grid-menu" ng-keydown="checkKeyDown($event)" ng-show="shown"><style ui-grid-style>{{dynamicStyles}}</style><div class="ui-grid-menu-mid" ng-show="shownMid"><div class="ui-grid-menu-inner" ng-if="shown"><ul role="menu" class="ui-grid-menu-items"><li ng-repeat="item in menuItems" role="menuitem" ui-grid-menu-item ui-grid-one-bind-id="\'menuitem-\'+$index" action="item.action" name="item.title" active="item.active" icon="item.icon" shown="item.shown" context="item.context" template-url="item.templateUrl" leave-open="item.leaveOpen" screen-reader-only="item.screenReaderOnly"></li><li ng-if="col.filterable && col.filterContainer === \'columnMenu\'"><div ui-grid-filter></div></li></ul></div></div></div>'),e.put("ui-grid/uiGridMenuItem",'<button type="button" class="ui-grid-menu-item" ng-click="itemAction($event, title)" ng-show="itemShown()" ng-class="{ \'ui-grid-menu-item-active\': active(), \'ui-grid-sr-only\': (!focus && screenReaderOnly) }" aria-pressed="{{active()}}" tabindex="0" ng-focus="focus=true" ng-blur="focus=false"><i ng-class="icon" aria-hidden="true">&nbsp; </i>{{ label() }}</button>'),e.put("ui-grid/uiGridRenderContainer","<div role=\"presentation\" ui-grid-one-bind-id-grid=\"containerId + '-grid-container'\" class=\"ui-grid-render-container\" ng-style=\"{ 'margin-left': colContainer.getMargin('left') + 'px', 'margin-right': colContainer.getMargin('right') + 'px' }\">\x3c!-- All of these dom elements are replaced in place --\x3e<div ui-grid-header></div><div ui-grid-viewport></div><div ng-if=\"colContainer.needsHScrollbarPlaceholder()\" class=\"ui-grid-scrollbar-placeholder\" ng-style=\"{height: colContainer.grid.scrollbarHeight + 'px'}\"></div><ui-grid-footer ng-if=\"grid.options.showColumnFooter\"></ui-grid-footer></div>"),e.put("ui-grid/uiGridViewport",'<div role="rowgroup" class="ui-grid-viewport" ng-style="colContainer.getViewportStyle()">\x3c!-- tbody --\x3e<div class="ui-grid-canvas"><div ng-repeat="(rowRenderIndex, row) in rowContainer.renderedRows track by $index" class="ui-grid-row" ng-style="Viewport.rowStyle(rowRenderIndex)"><div role="row" ui-grid-row="row" row-render-index="rowRenderIndex"></div></div></div></div>'),e.put("ui-grid/cellEditor",'<div><form name="inputForm"><input type="INPUT_TYPE" ng-class="\'colt\' + col.uid" ui-grid-editor ng-model="MODEL_COL_FIELD"></form></div>'),e.put("ui-grid/dropdownEditor",'<div><form name="inputForm"><select ng-class="\'colt\' + col.uid" ui-grid-edit-dropdown ng-model="MODEL_COL_FIELD" ng-options="field[editDropdownIdLabel] as field[editDropdownValueLabel] CUSTOM_FILTERS for field in editDropdownOptionsArray"></select></form></div>'),e.put("ui-grid/fileChooserEditor",'<div><form name="inputForm"><input ng-class="\'colt\' + col.uid" ui-grid-edit-file-chooser type="file" id="files" name="files[]" ng-model="MODEL_COL_FIELD"></form></div>'),e.put("ui-grid/emptyBaseLayerContainer",'<div class="ui-grid-empty-base-layer-container ui-grid-canvas"><div class="ui-grid-row" ng-repeat="(rowRenderIndex, row) in grid.baseLayer.emptyRows track by $index" ng-style="Viewport.rowStyle(rowRenderIndex)"><div><div><div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell {{ col.getColClass(false) }}"></div></div></div></div></div>'),e.put("ui-grid/expandableRow",'<div ui-grid-expandable-row ng-if="expandableRow.shouldRenderExpand()" class="expandableRow" style="float:left; margin-top: 1px; margin-bottom: 1px" ng-style="{width: (grid.renderContainers.body.getCanvasWidth()) + \'px\', height: row.expandedRowHeight + \'px\'}"></div>'),e.put("ui-grid/expandableRowHeader",'<div class="ui-grid-row-header-cell ui-grid-expandable-buttons-cell"><div class="ui-grid-cell-contents"><i class="clickable" ng-if="!(row.groupHeader==true || row.entity.subGridOptions.disableRowExpandable)" ng-class="{ \'ui-grid-icon-plus-squared\' : !row.isExpanded, \'ui-grid-icon-minus-squared\' : row.isExpanded }" ng-click="grid.api.expandable.toggleRowExpansion(row.entity, $event)" aria-expanded="{{!!row.isExpanded}}"></i></div></div>'),e.put("ui-grid/expandableScrollFiller","<div ng-if=\"expandableRow.shouldRenderFiller()\" ng-class=\"{scrollFiller: true, scrollFillerClass:(colContainer.name === 'body')}\" ng-style=\"{ width: (grid.getViewportWidth()) + 'px', height: row.expandedRowHeight + 2 + 'px', 'margin-left': grid.options.rowHeader.rowHeaderWidth + 'px' }\">&nbsp;</div>"),e.put("ui-grid/expandableTopRowHeader",'<div class="ui-grid-row-header-cell ui-grid-expandable-buttons-cell"><div class="ui-grid-cell-contents"><span class="ui-grid-cell-empty" ng-if="!grid.options.showExpandAllButton"></span> <button type="button" class="ui-grid-icon-button clickable" ng-if="grid.options.showExpandAllButton" ng-class="{ \'ui-grid-icon-plus-squared\' : !grid.expandable.expandedAll, \'ui-grid-icon-minus-squared\' : grid.expandable.expandedAll }" ng-click="grid.api.expandable.toggleAllRows()" aria-expanded="{{grid.expandable.expandedAll}}"></button></div></div>'),e.put("ui-grid/csvLink",'<span class="ui-grid-exporter-csv-link-span"><a href="data:text/csv;charset=UTF-8,CSV_CONTENT" download="FILE_NAME">LINK_LABEL</a></span>'),e.put("ui-grid/importerMenuItem",'<li class="ui-grid-menu-item"><form><input class="ui-grid-importer-file-chooser" type="file" id="files" name="files[]"></form></li>'),e.put("ui-grid/importerMenuItemContainer","<div ui-grid-importer-menu-item></div>"),e.put("ui-grid/pagination",'<div class="ui-grid-pager-panel" ui-grid-pager ng-show="grid.options.enablePaginationControls"><div role="navigation" class="ui-grid-pager-container"><div class="ui-grid-pager-control"><button type="button" class="ui-grid-pager-first" ui-grid-one-bind-title="aria.pageToFirst" ui-grid-one-bind-aria-label="aria.pageToFirst" ng-click="pageFirstPageClick()" ng-disabled="cantPageBackward()"><div ng-class="grid.isRTL() ? \'last-triangle\' : \'first-triangle\'"><div ng-class="grid.isRTL() ? \'last-bar-rtl\' : \'first-bar\'"></div></div></button> <button type="button" class="ui-grid-pager-previous" ui-grid-one-bind-title="aria.pageBack" ui-grid-one-bind-aria-label="aria.pageBack" ng-click="pagePreviousPageClick()" ng-disabled="cantPageBackward()"><div ng-class="grid.isRTL() ? \'last-triangle prev-triangle\' : \'first-triangle prev-triangle\'"></div></button> <input type="number" ui-grid-one-bind-title="aria.pageSelected" ui-grid-one-bind-aria-label="aria.pageSelected" class="ui-grid-pager-control-input" ng-model="grid.options.paginationCurrentPage" min="1" max="{{ paginationApi.getTotalPages() }}" step="1" required> <span class="ui-grid-pager-max-pages-number" ng-show="paginationApi.getTotalPages() > 0"><abbr ui-grid-one-bind-title="paginationOf">/ </abbr>{{ paginationApi.getTotalPages() }} </span><button type="button" class="ui-grid-pager-next" ui-grid-one-bind-title="aria.pageForward" ui-grid-one-bind-aria-label="aria.pageForward" ng-click="pageNextPageClick()" ng-disabled="cantPageForward()"><div ng-class="grid.isRTL() ? \'first-triangle next-triangle\' : \'last-triangle next-triangle\'"></div></button> <button type="button" class="ui-grid-pager-last" ui-grid-one-bind-title="aria.pageToLast" ui-grid-one-bind-aria-label="aria.pageToLast" ng-click="pageLastPageClick()" ng-disabled="cantPageToLast()"><div ng-class="grid.isRTL() ? \'first-triangle\' : \'last-triangle\'"><div ng-class="grid.isRTL() ? \'first-bar-rtl\' : \'last-bar\'"></div></div></button></div><div class="ui-grid-pager-row-count-picker" ng-if="grid.options.paginationPageSizes.length > 1 && !grid.options.useCustomPagination"><select ui-grid-one-bind-aria-labelledby-grid="\'items-per-page-label\'" ng-model="grid.options.paginationPageSize" ng-options="o as o for o in grid.options.paginationPageSizes"></select> <span ui-grid-one-bind-id-grid="\'items-per-page-label\'" class="ui-grid-pager-row-count-label">&nbsp;{{sizesLabel}}</span></div><span ng-if="grid.options.paginationPageSizes.length <= 1" class="ui-grid-pager-row-count-label">{{grid.options.paginationPageSize}}&nbsp;{{sizesLabel}}</span></div><div class="ui-grid-pager-count-container"><div class="ui-grid-pager-count"><span ng-show="grid.options.totalItems > 0">{{ 1 + paginationApi.getFirstRowIndex() }} <abbr ui-grid-one-bind-title="paginationThrough">- </abbr>{{ 1 + paginationApi.getLastRowIndex() }} {{paginationOf}} {{grid.options.totalItems}} {{totalItemsLabel}}</span></div></div></div>'),e.put("ui-grid/columnResizer",'<div ui-grid-column-resizer ng-if="grid.options.enableColumnResizing" class="ui-grid-column-resizer" col="col" position="right" render-index="renderIndex" unselectable="on"></div>'),e.put("ui-grid/gridFooterSelectedItems",'<span ng-if="grid.selection.selectedCount !== 0 && grid.options.enableFooterTotalSelected">({{"search.selectedItems" | t}} {{grid.selection.selectedCount}})</span>'),e.put("ui-grid/selectionHeaderCell",'<div>\x3c!-- <div class="ui-grid-vertical-bar">&nbsp;</div> --\x3e<div class="ui-grid-cell-contents" col-index="renderIndex"><ui-grid-selection-select-all-buttons ng-if="grid.options.enableSelectAll" role="checkbox" ng-model="grid.selection.selectAll"></ui-grid-selection-select-all-buttons></div></div>'),e.put("ui-grid/selectionRowHeader",'<div class="ui-grid-cell-contents ui-grid-disable-selection clickable"><ui-grid-selection-row-header-buttons></ui-grid-selection-row-header-buttons></div>'),e.put("ui-grid/selectionRowHeaderButtons",'<div class="ui-grid-selection-row-header-buttons ui-grid-icon-ok clickable" ng-class="{\'ui-grid-row-selected\': row.isSelected}" tabindex="0" ng-click="selectButtonClick(row, $event)" ng-keydown="selectButtonKeyDown(row, $event)" ng-attr-aria-label="{{(\'selection.aria.row\' | t) + \' \' + (row.index + 1) + \', \' + col.displayName}}" aria-checked="{{row.isSelected}}" role="checkbox" ng-model="row.isSelected">&nbsp;</div>'),e.put("ui-grid/selectionSelectAllButtons",'<div role="checkbox" tabindex="0" class="ui-grid-selection-row-header-buttons ui-grid-icon-ok" ui-grid-one-bind-aria-label="\'selection.selectAll\' | t" aria-checked="{{grid.selection.selectAll}}" ng-class="{\'ui-grid-all-selected\': grid.selection.selectAll}" ng-click="headerButtonClick($event)" ng-keydown="headerButtonKeyDown($event)"></div>'),e.put("ui-grid/treeBaseExpandAllButtons",'<div class="ui-grid-tree-base-row-header-buttons" tabindex="0" ng-class="headerButtonClass()" ng-click="headerButtonClick($event)" ng-keydown="headerButtonKeyDown($event)"></div>'),e.put("ui-grid/treeBaseHeaderCell",'<div><div class="ui-grid-cell-contents" col-index="renderIndex"><ui-grid-tree-base-expand-all-buttons ng-if="grid.options.enableExpandAll"></ui-grid-tree-base-expand-all-buttons></div></div>'),e.put("ui-grid/treeBaseRowHeader",'<div class="ui-grid-cell-contents"><ui-grid-tree-base-row-header-buttons></ui-grid-tree-base-row-header-buttons></div>'),e.put("ui-grid/treeBaseRowHeaderButtons",'<div class="ui-grid-tree-base-row-header-buttons" ng-class="{\'ui-grid-tree-base-header\': row.treeLevel > -1 }" tabindex="0" ng-keydown="treeButtonKeyDown(row, $event)" ng-click="treeButtonClick(row, $event)"><i ng-class="treeButtonClass(row)" ng-style="{\'padding-left\': grid.options.treeIndent * row.treeLevel + \'px\'}"></i> &nbsp;</div>'),e.put("ui-grid/cellTitleValidator",'<div class="ui-grid-cell-contents" ng-class="{invalid:grid.validate.isInvalid(row.entity,col.colDef)}" title="{{grid.validate.getTitleFormattedErrors(row.entity,col.colDef)}}">{{COL_FIELD CUSTOM_FILTERS}}</div>'),e.put("ui-grid/cellTooltipValidator",'<div class="ui-grid-cell-contents" ng-class="{invalid:grid.validate.isInvalid(row.entity,col.colDef)}" tooltip-html-unsafe="{{grid.validate.getFormattedErrors(row.entity,col.colDef)}}" tooltip-enable="grid.validate.isInvalid(row.entity,col.colDef)" tooltip-append-to-body="true" tooltip-placement="top" title="TOOLTIP">{{COL_FIELD CUSTOM_FILTERS}}</div>')}]);

/***/ },
/* 9 */
/***/ function(module, exports) {

	/*
	 jQuery UI Sortable plugin wrapper
	
	 @param [ui-sortable] {object} Options to pass to $.fn.sortable() merged onto ui.config
	 */
	angular
	  .module('ui.sortable', [])
	  .value('uiSortableConfig', {
	    // the default for jquery-ui sortable is "> *", we need to restrict this to
	    // ng-repeat items
	    // if the user uses
	    items: '> [ng-repeat],> [data-ng-repeat],> [x-ng-repeat]'
	  })
	  .directive('uiSortable', [
	    'uiSortableConfig',
	    '$timeout',
	    '$log',
	    function(uiSortableConfig, $timeout, $log) {
	      return {
	        require: '?ngModel',
	        scope: {
	          ngModel: '=',
	          uiSortable: '=',
	          ////Expression bindings from html.
	          create: '&uiSortableCreate',
	          // helper:'&uiSortableHelper',
	          start: '&uiSortableStart',
	          activate: '&uiSortableActivate',
	          // sort:'&uiSortableSort',
	          // change:'&uiSortableChange',
	          // over:'&uiSortableOver',
	          // out:'&uiSortableOut',
	          beforeStop: '&uiSortableBeforeStop',
	          update: '&uiSortableUpdate',
	          remove: '&uiSortableRemove',
	          receive: '&uiSortableReceive',
	          deactivate: '&uiSortableDeactivate',
	          stop: '&uiSortableStop'
	        },
	        link: function(scope, element, attrs, ngModel) {
	          var savedNodes;
	          var helper;
	
	          function combineCallbacks(first, second) {
	            var firstIsFunc = typeof first === 'function';
	            var secondIsFunc = typeof second === 'function';
	            if (firstIsFunc && secondIsFunc) {
	              return function() {
	                first.apply(this, arguments);
	                second.apply(this, arguments);
	              };
	            } else if (secondIsFunc) {
	              return second;
	            }
	            return first;
	          }
	
	          function getSortableWidgetInstance(element) {
	            // this is a fix to support jquery-ui prior to v1.11.x
	            // otherwise we should be using `element.sortable('instance')`
	            var data = element.data('ui-sortable');
	            if (
	              data &&
	              typeof data === 'object' &&
	              data.widgetFullName === 'ui-sortable'
	            ) {
	              return data;
	            }
	            return null;
	          }
	
	          function setItemChildrenWidth(item) {
	            item.children().each(function() {
	              var $el = angular.element(this);
	
	              // Preserve the with of the element
	              $el.width($el.width());
	            });
	          }
	
	          function dummyHelper(e, item) {
	            return item;
	          }
	
	          function patchSortableOption(key, value) {
	            if (callbacks[key]) {
	              if (key === 'stop') {
	                // call apply after stop
	                value = combineCallbacks(value, function() {
	                  scope.$apply();
	                });
	
	                value = combineCallbacks(value, afterStop);
	              }
	              // wrap the callback
	              value = combineCallbacks(callbacks[key], value);
	            } else if (wrappers[key]) {
	              value = wrappers[key](value);
	            }
	
	            // patch the options that need to have values set
	            if (!value && (key === 'items' || key === 'ui-model-items')) {
	              value = uiSortableConfig.items;
	            }
	
	            return value;
	          }
	
	          function patchUISortableOptions(
	            newOpts,
	            oldOpts,
	            sortableWidgetInstance
	          ) {
	            function addDummyOptionKey(value, key) {
	              if (!(key in opts)) {
	                // add the key in the opts object so that
	                // the patch function detects and handles it
	                opts[key] = null;
	              }
	            }
	            // for this directive to work we have to attach some callbacks
	            angular.forEach(callbacks, addDummyOptionKey);
	
	            // only initialize it in case we have to
	            // update some options of the sortable
	            var optsDiff = null;
	
	            if (oldOpts) {
	              // reset deleted options to default
	              var defaultOptions;
	              angular.forEach(oldOpts, function(oldValue, key) {
	                if (!newOpts || !(key in newOpts)) {
	                  if (key in directiveOpts) {
	                    if (key === 'ui-floating') {
	                      opts[key] = 'auto';
	                    } else {
	                      opts[key] = patchSortableOption(key, undefined);
	                    }
	                    return;
	                  }
	
	                  if (!defaultOptions) {
	                    defaultOptions = angular.element.ui.sortable().options;
	                  }
	                  var defaultValue = defaultOptions[key];
	                  defaultValue = patchSortableOption(key, defaultValue);
	
	                  if (!optsDiff) {
	                    optsDiff = {};
	                  }
	                  optsDiff[key] = defaultValue;
	                  opts[key] = defaultValue;
	                }
	              });
	            }
	
	            newOpts = angular.extend({}, newOpts);
	            // update changed options
	            // handle the custom option of the directive first
	            angular.forEach(newOpts, function(value, key) {
	              if (key in directiveOpts) {
	                if (
	                  key === 'ui-floating' &&
	                  (value === false || value === true) &&
	                  sortableWidgetInstance
	                ) {
	                  sortableWidgetInstance.floating = value;
	                }
	
	                if (
	                  key === 'ui-preserve-size' &&
	                  (value === false || value === true)
	                ) {
	                  var userProvidedHelper = opts.helper;
	                  newOpts.helper = function(e, item) {
	                    if (opts['ui-preserve-size'] === true) {
	                      setItemChildrenWidth(item);
	                    }
	                    return (userProvidedHelper || dummyHelper).apply(
	                      this,
	                      arguments
	                    );
	                  };
	                }
	
	                opts[key] = patchSortableOption(key, value);
	              }
	            });
	
	            // handle the normal option of the directive
	            angular.forEach(newOpts, function(value, key) {
	              if (key in directiveOpts) {
	                // the custom option of the directive are already handled
	                return;
	              }
	
	              value = patchSortableOption(key, value);
	
	              if (!optsDiff) {
	                optsDiff = {};
	              }
	              optsDiff[key] = value;
	              opts[key] = value;
	            });
	
	            return optsDiff;
	          }
	
	          function getPlaceholderElement(element) {
	            var placeholder = element.sortable('option', 'placeholder');
	
	            // placeholder.element will be a function if the placeholder, has
	            // been created (placeholder will be an object).  If it hasn't
	            // been created, either placeholder will be false if no
	            // placeholder class was given or placeholder.element will be
	            // undefined if a class was given (placeholder will be a string)
	            if (
	              placeholder &&
	              placeholder.element &&
	              typeof placeholder.element === 'function'
	            ) {
	              var result = placeholder.element();
	              // workaround for jquery ui 1.9.x,
	              // not returning jquery collection
	              result = angular.element(result);
	              return result;
	            }
	            return null;
	          }
	
	          function getPlaceholderExcludesludes(element, placeholder) {
	            // exact match with the placeholder's class attribute to handle
	            // the case that multiple connected sortables exist and
	            // the placeholder option equals the class of sortable items
	            var notCssSelector = opts['ui-model-items'].replace(/[^,]*>/g, '');
	            var excludes = element.find(
	              '[class="' +
	                placeholder.attr('class') +
	                '"]:not(' +
	                notCssSelector +
	                ')'
	            );
	            return excludes;
	          }
	
	          function hasSortingHelper(element, ui) {
	            var helperOption = element.sortable('option', 'helper');
	            return (
	              helperOption === 'clone' ||
	              (typeof helperOption === 'function' &&
	                ui.item.sortable.isCustomHelperUsed())
	            );
	          }
	
	          function getSortingHelper(element, ui /*, savedNodes*/) {
	            var result = null;
	            if (
	              hasSortingHelper(element, ui) &&
	              element.sortable('option', 'appendTo') === 'parent'
	            ) {
	              // The .ui-sortable-helper element (that's the default class name)
	              result = helper;
	            }
	            return result;
	          }
	
	          // thanks jquery-ui
	          function isFloating(item) {
	            return (
	              /left|right/.test(item.css('float')) ||
	              /inline|table-cell/.test(item.css('display'))
	            );
	          }
	
	          function getElementContext(elementScopes, element) {
	            for (var i = 0; i < elementScopes.length; i++) {
	              var c = elementScopes[i];
	              if (c.element[0] === element[0]) {
	                return c;
	              }
	            }
	          }
	
	          function afterStop(e, ui) {
	            ui.item.sortable._destroy();
	          }
	
	          // return the index of ui.item among the items
	          // we can't just do ui.item.index() because there it might have siblings
	          // which are not items
	          function getItemIndex(item) {
	            return item
	              .parent()
	              .find(opts['ui-model-items'])
	              .index(item);
	          }
	
	          var opts = {};
	
	          // directive specific options
	          var directiveOpts = {
	            'ui-floating': undefined,
	            'ui-model-items': uiSortableConfig.items,
	            'ui-preserve-size': undefined
	          };
	
	          var callbacks = {
	            create: null,
	            start: null,
	            activate: null,
	            // sort: null,
	            // change: null,
	            // over: null,
	            // out: null,
	            beforeStop: null,
	            update: null,
	            remove: null,
	            receive: null,
	            deactivate: null,
	            stop: null
	          };
	
	          var wrappers = {
	            helper: null
	          };
	
	          angular.extend(
	            opts,
	            directiveOpts,
	            uiSortableConfig,
	            scope.uiSortable
	          );
	
	          if (!angular.element.fn || !angular.element.fn.jquery) {
	            $log.error(
	              'ui.sortable: jQuery should be included before AngularJS!'
	            );
	            return;
	          }
	
	          function wireUp() {
	            // When we add or remove elements, we need the sortable to 'refresh'
	            // so it can find the new/removed elements.
	            scope.$watchCollection('ngModel', function() {
	              // Timeout to let ng-repeat modify the DOM
	              $timeout(
	                function() {
	                  // ensure that the jquery-ui-sortable widget instance
	                  // is still bound to the directive's element
	                  if (!!getSortableWidgetInstance(element)) {
	                    element.sortable('refresh');
	                  }
	                },
	                0,
	                false
	              );
	            });
	
	            callbacks.start = function(e, ui) {
	              if (opts['ui-floating'] === 'auto') {
	                // since the drag has started, the element will be
	                // absolutely positioned, so we check its siblings
	                var siblings = ui.item.siblings();
	                var sortableWidgetInstance = getSortableWidgetInstance(
	                  angular.element(e.target)
	                );
	                sortableWidgetInstance.floating = isFloating(siblings);
	              }
	
	              // Save the starting position of dragged item
	              var index = getItemIndex(ui.item);
	              ui.item.sortable = {
	                model: ngModel.$modelValue[index],
	                index: index,
	                source: element,
	                sourceList: ui.item.parent(),
	                sourceModel: ngModel.$modelValue,
	                cancel: function() {
	                  ui.item.sortable._isCanceled = true;
	                },
	                isCanceled: function() {
	                  return ui.item.sortable._isCanceled;
	                },
	                isCustomHelperUsed: function() {
	                  return !!ui.item.sortable._isCustomHelperUsed;
	                },
	                _isCanceled: false,
	                _isCustomHelperUsed: ui.item.sortable._isCustomHelperUsed,
	                _destroy: function() {
	                  angular.forEach(ui.item.sortable, function(value, key) {
	                    ui.item.sortable[key] = undefined;
	                  });
	                },
	                _connectedSortables: [],
	                _getElementContext: function(element) {
	                  return getElementContext(this._connectedSortables, element);
	                }
	              };
	            };
	
	            callbacks.activate = function(e, ui) {
	              var isSourceContext = ui.item.sortable.source === element;
	              var savedNodesOrigin = isSourceContext
	                ? ui.item.sortable.sourceList
	                : element;
	              var elementContext = {
	                element: element,
	                scope: scope,
	                isSourceContext: isSourceContext,
	                savedNodesOrigin: savedNodesOrigin
	              };
	              // save the directive's scope so that it is accessible from ui.item.sortable
	              ui.item.sortable._connectedSortables.push(elementContext);
	
	              // We need to make a copy of the current element's contents so
	              // we can restore it after sortable has messed it up.
	              // This is inside activate (instead of start) in order to save
	              // both lists when dragging between connected lists.
	              savedNodes = savedNodesOrigin.contents();
	              helper = ui.helper;
	
	              // If this list has a placeholder (the connected lists won't),
	              // don't inlcude it in saved nodes.
	              var placeholder = getPlaceholderElement(element);
	              if (placeholder && placeholder.length) {
	                var excludes = getPlaceholderExcludesludes(
	                  element,
	                  placeholder
	                );
	                savedNodes = savedNodes.not(excludes);
	              }
	            };
	
	            callbacks.update = function(e, ui) {
	              // Save current drop position but only if this is not a second
	              // update that happens when moving between lists because then
	              // the value will be overwritten with the old value
	              if (!ui.item.sortable.received) {
	                ui.item.sortable.dropindex = getItemIndex(ui.item);
	                var droptarget = ui.item
	                  .parent()
	                  .closest(
	                    '[ui-sortable], [data-ui-sortable], [x-ui-sortable]'
	                  );
	                ui.item.sortable.droptarget = droptarget;
	                ui.item.sortable.droptargetList = ui.item.parent();
	
	                var droptargetContext = ui.item.sortable._getElementContext(
	                  droptarget
	                );
	                ui.item.sortable.droptargetModel =
	                  droptargetContext.scope.ngModel;
	
	                // Cancel the sort (let ng-repeat do the sort for us)
	                // Don't cancel if this is the received list because it has
	                // already been canceled in the other list, and trying to cancel
	                // here will mess up the DOM.
	                element.sortable('cancel');
	              }
	
	              // Put the nodes back exactly the way they started (this is very
	              // important because ng-repeat uses comment elements to delineate
	              // the start and stop of repeat sections and sortable doesn't
	              // respect their order (even if we cancel, the order of the
	              // comments are still messed up).
	              var sortingHelper =
	                !ui.item.sortable.received &&
	                getSortingHelper(element, ui, savedNodes);
	              if (sortingHelper && sortingHelper.length) {
	                // Restore all the savedNodes except from the sorting helper element.
	                // That way it will be garbage collected.
	                savedNodes = savedNodes.not(sortingHelper);
	              }
	              var elementContext = ui.item.sortable._getElementContext(element);
	              savedNodes.appendTo(elementContext.savedNodesOrigin);
	
	              // If this is the target connected list then
	              // it's safe to clear the restored nodes since:
	              // update is currently running and
	              // stop is not called for the target list.
	              if (ui.item.sortable.received) {
	                savedNodes = null;
	              }
	
	              // If received is true (an item was dropped in from another list)
	              // then we add the new item to this list otherwise wait until the
	              // stop event where we will know if it was a sort or item was
	              // moved here from another list
	              if (ui.item.sortable.received && !ui.item.sortable.isCanceled()) {
	                scope.$apply(function() {
	                  ngModel.$modelValue.splice(
	                    ui.item.sortable.dropindex,
	                    0,
	                    ui.item.sortable.moved
	                  );
	                });
	                scope.$emit('ui-sortable:moved', ui);
	              }
	            };
	
	            callbacks.stop = function(e, ui) {
	              // If the received flag hasn't be set on the item, this is a
	              // normal sort, if dropindex is set, the item was moved, so move
	              // the items in the list.
	              var wasMoved =
	                'dropindex' in ui.item.sortable &&
	                !ui.item.sortable.isCanceled();
	
	              if (wasMoved && !ui.item.sortable.received) {
	                scope.$apply(function() {
	                  ngModel.$modelValue.splice(
	                    ui.item.sortable.dropindex,
	                    0,
	                    ngModel.$modelValue.splice(ui.item.sortable.index, 1)[0]
	                  );
	                });
	                scope.$emit('ui-sortable:moved', ui);
	              } else if (
	                !wasMoved &&
	                !angular.equals(
	                  element.contents().toArray(),
	                  savedNodes.toArray()
	                )
	              ) {
	                // if the item was not moved
	                // and the DOM element order has changed,
	                // then restore the elements
	                // so that the ngRepeat's comment are correct.
	
	                var sortingHelper = getSortingHelper(element, ui, savedNodes);
	                if (sortingHelper && sortingHelper.length) {
	                  // Restore all the savedNodes except from the sorting helper element.
	                  // That way it will be garbage collected.
	                  savedNodes = savedNodes.not(sortingHelper);
	                }
	                var elementContext = ui.item.sortable._getElementContext(
	                  element
	                );
	                savedNodes.appendTo(elementContext.savedNodesOrigin);
	              }
	
	              // It's now safe to clear the savedNodes and helper
	              // since stop is the last callback.
	              savedNodes = null;
	              helper = null;
	            };
	
	            callbacks.receive = function(e, ui) {
	              // An item was dropped here from another list, set a flag on the
	              // item.
	              ui.item.sortable.received = true;
	            };
	
	            callbacks.remove = function(e, ui) {
	              // Workaround for a problem observed in nested connected lists.
	              // There should be an 'update' event before 'remove' when moving
	              // elements. If the event did not fire, cancel sorting.
	              if (!('dropindex' in ui.item.sortable)) {
	                element.sortable('cancel');
	                ui.item.sortable.cancel();
	              }
	
	              // Remove the item from this list's model and copy data into item,
	              // so the next list can retrive it
	              if (!ui.item.sortable.isCanceled()) {
	                scope.$apply(function() {
	                  ui.item.sortable.moved = ngModel.$modelValue.splice(
	                    ui.item.sortable.index,
	                    1
	                  )[0];
	                });
	              }
	            };
	
	            // setup attribute handlers
	            angular.forEach(callbacks, function(value, key) {
	              callbacks[key] = combineCallbacks(callbacks[key], function() {
	                var attrHandler = scope[key];
	                var attrHandlerFn;
	                if (
	                  typeof attrHandler === 'function' &&
	                  (
	                    'uiSortable' +
	                    key.substring(0, 1).toUpperCase() +
	                    key.substring(1)
	                  ).length &&
	                  typeof (attrHandlerFn = attrHandler()) === 'function'
	                ) {
	                  attrHandlerFn.apply(this, arguments);
	                }
	              });
	            });
	
	            wrappers.helper = function(inner) {
	              if (inner && typeof inner === 'function') {
	                return function(e, item) {
	                  var oldItemSortable = item.sortable;
	                  var index = getItemIndex(item);
	
	                  item.sortable = {
	                    model: ngModel.$modelValue[index],
	                    index: index,
	                    source: element,
	                    sourceList: item.parent(),
	                    sourceModel: ngModel.$modelValue,
	                    _restore: function() {
	                      angular.forEach(item.sortable, function(value, key) {
	                        item.sortable[key] = undefined;
	                      });
	
	                      item.sortable = oldItemSortable;
	                    }
	                  };
	
	                  var innerResult = inner.apply(this, arguments);
	                  item.sortable._restore();
	                  item.sortable._isCustomHelperUsed = item !== innerResult;
	                  return innerResult;
	                };
	              }
	              return inner;
	            };
	
	            scope.$watchCollection(
	              'uiSortable',
	              function(newOpts, oldOpts) {
	                // ensure that the jquery-ui-sortable widget instance
	                // is still bound to the directive's element
	                var sortableWidgetInstance = getSortableWidgetInstance(element);
	                if (!!sortableWidgetInstance) {
	                  var optsDiff = patchUISortableOptions(
	                    newOpts,
	                    oldOpts,
	                    sortableWidgetInstance
	                  );
	
	                  if (optsDiff) {
	                    element.sortable('option', optsDiff);
	                  }
	                }
	              },
	              true
	            );
	
	            patchUISortableOptions(opts);
	          }
	
	          function init() {
	            if (ngModel) {
	              wireUp();
	            } else {
	              $log.info('ui.sortable: ngModel not provided!', element);
	            }
	
	            // Create sortable
	            element.sortable(opts);
	          }
	
	          function initIfEnabled() {
	            if (scope.uiSortable && scope.uiSortable.disabled) {
	              return false;
	            }
	
	            init();
	
	            // Stop Watcher
	            initIfEnabled.cancelWatcher();
	            initIfEnabled.cancelWatcher = angular.noop;
	
	            return true;
	          }
	
	          initIfEnabled.cancelWatcher = angular.noop;
	
	          if (!initIfEnabled()) {
	            initIfEnabled.cancelWatcher = scope.$watch(
	              'uiSortable.disabled',
	              initIfEnabled
	            );
	          }
	        }
	      };
	    }
	  ]);


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(11);
	__webpack_require__(12);
	__webpack_require__(13);
	__webpack_require__(14);
	__webpack_require__(16);
	__webpack_require__(18);
	__webpack_require__(138);
	
	var app = angular.module('app', ['ngRoute', 'ngResource', 'ngSanitize', 'ngCookies', 'ui.select', 'ui.bootstrap', 'ngFileUpload', 'angularMoment', 'ngIdle', 'ui.grid', 'ui.grid.pagination', 'ui.grid.selection', 'ui.sortable', __webpack_require__(140).name, __webpack_require__(145).name, __webpack_require__(153).name, __webpack_require__(157).name, __webpack_require__(159).name, __webpack_require__(165).name, __webpack_require__(169).name, __webpack_require__(173).name, __webpack_require__(177).name, __webpack_require__(181).name, __webpack_require__(187).name, __webpack_require__(195).name, __webpack_require__(201).name, __webpack_require__(208).name, __webpack_require__(212).name, __webpack_require__(218).name, __webpack_require__(222).name, __webpack_require__(228).name, __webpack_require__(232).name, __webpack_require__(236).name, __webpack_require__(240).name, __webpack_require__(244).name, __webpack_require__(250).name, __webpack_require__(254).name, __webpack_require__(260).name, __webpack_require__(266).name, __webpack_require__(294).name, __webpack_require__(295).name, __webpack_require__(300).name, __webpack_require__(304).name, __webpack_require__(308).name, __webpack_require__(314).name, __webpack_require__(321).name, __webpack_require__(325).name, __webpack_require__(329).name, __webpack_require__(336).name, __webpack_require__(342).name, __webpack_require__(348), __webpack_require__(354).name, __webpack_require__(369).name, __webpack_require__(380).name, __webpack_require__(387).name, __webpack_require__(397).name, __webpack_require__(401).name, __webpack_require__(409).name, __webpack_require__(415).name, __webpack_require__(421)]);
	
	app.config(__webpack_require__(423)(app));
	app.config(__webpack_require__(434)(app));
	
	app.config(['angularAuth0Provider', function (angularAuth0Provider) {
	  angularAuth0Provider.init({
	    clientID: auth0Config.ClientId,
	    domain: auth0Config.Domain,
	    responseType: 'token id_token',
	    audience: auth0Config.ApiIdentifier,
	    scope: auth0Config.Scope,
	    redirectUri: auth0Config.Callback
	  });
	}]);
	
	app.constant('AUTH_EVENTS', __webpack_require__(435));
	app.factory('authInterceptor', __webpack_require__(436));
	app.service('authService', __webpack_require__(437));
	app.service('settingsService', __webpack_require__(438));
	app.service('dataService', __webpack_require__(472));
	app.service('indexService', __webpack_require__(473));
	app.service('subNavService', __webpack_require__(474));
	app.service('dataSourceService', __webpack_require__(475));
	app.service('microApiService', __webpack_require__(476));
	app.service('formValidationService', __webpack_require__(477));
	app.service('authCallbackService', __webpack_require__(478));
	app.directive('clickOutside', __webpack_require__(479));
	
	app.run(['$injector', function ($injector) {
	  app.register = $injector.loadModule.bind($injector);
	}]);
	
	app.run(['$templateCache', function ($templateCache) {
	  $templateCache.put('gridPaginationTpl.html', __webpack_require__(480));
	}]);
	
	app.run(['$rootScope', '$location', 'authService', 'dataService', 'authCallbackService', function ($rootScope, $location, authService, dataService, authCallbackService) {
	  return $rootScope.$on('$routeChangeStart', function (event, next, current) {
	    authCallbackService.checkCallBack();
	
	    // Fix for grid add item memory issue: Always clean data when in addNewMode
	    if (dataService.addNewMode || dataService.cleanDataOnRouteChange) {
	      // Check if we're navigating to a different section entirely
	      var nextPath = next ? next.$$route.originalPath : '';
	      var backPath = dataService.backPath || '';
	
	      // If navigating to a completely different top-level section, clear addNewMode and let new page load normally
	      // Compare the first non-empty segment of each path (e.g., 'enhanced-policy-rules')
	      var nextRoot = nextPath ? nextPath.split('/')[1] : '';
	      var backRoot = backPath ? backPath.split('/')[1] : '';
	      if (nextRoot && backRoot && nextRoot !== backRoot) {
	        dataService.addNewMode = false;
	        dataService.addNewBackup = undefined;
	        dataService.cleanDataOnRouteChange = false;
	        return;
	      }
	
	      // Allow the initial transition from grid -> item edit page to proceed without cleanup.
	      // lbaResourceCtrl sets cleanDataOnRouteChange = true on load. So if we're in addNewMode but
	      // cleanDataOnRouteChange is not yet true, we're likely entering the item page; do nothing.
	      if (dataService.addNewMode && !dataService.cleanDataOnRouteChange) {
	        return;
	      }
	
	      // Ensure dataService.data exists and has proper structure
	      if (!dataService.data) {
	        dataService.data = { activeItem: undefined, items: [] };
	      }
	
	      // Restore from backup safely if backup exists
	      if (dataService.addNewBackup) {
	        if (dataService.addNewBackup.activeItem !== undefined) {
	          dataService.data.activeItem = angular.copy(dataService.addNewBackup.activeItem);
	        }
	        if (dataService.addNewBackup.items) {
	          dataService.data.items = angular.copy(dataService.addNewBackup.items);
	        }
	      }
	
	      // Exit Add New mode and clear flags when navigating away from the item page
	      dataService.addNewMode = false;
	      dataService.addNewBackup = undefined;
	      dataService.cleanDataOnRouteChange = false;
	      return;
	    }
	    if (next.$$route && (next.$$route.originalPath === '/access-denied' || next.$$route.originalPath === '/loginForm')) {
	      return;
	    }
	    if (!authService.isAuthenticated()) {
	      if (next.$$route && next.$$route.originalPath !== '/login' && next.$$route.originalPath !== '/loginForm' && next.$$route.originalPath !== '/logout' && next.$$route.originalPath !== '/access-denied') {
	        localStorage.setItem('previousState', $location.$$path);
	        authService.prevRoute = $location.path();
	        event.preventDefault();
	        $location.path('/login');
	      }
	    }
	
	    authService.isAuthorized().then(function (isAuth) {
	      if (!isAuth) {
	        $location.path('/access-denied');
	      }
	    });
	  });
	}]);
	
	app.run(['$rootScope', '$location', 'AUTH_EVENTS', 'authService', function ($rootScope, $location, AUTH_EVENTS, authService) {
	  return $rootScope.$on(AUTH_EVENTS.loginSuccess, function () {
	    if (authService.prevRoute) {
	      $location.path(authService.prevRoute);
	    } else {
	      $location.path('/');
	    }
	  });
	}]);
	
	app.run(['$rootScope', '$location', 'AUTH_EVENTS', function ($rootScope, $location, AUTH_EVENTS) {
	  return $rootScope.$on(AUTH_EVENTS.logoutSuccess, function () {
	    $location.path('/login');
	  });
	}]);
	
	app.run(['$rootScope', '$location', 'AUTH_EVENTS', function ($rootScope, $location, AUTH_EVENTS) {
	  return $rootScope.$on(AUTH_EVENTS.notAuthenticated, function () {
	    $location.path('/login');
	  });
	}]);
	
	app.run(['Idle', function (Idle) {
	  Idle.watch();
	}]);
	
	app.config(['KeepaliveProvider', 'IdleProvider', function (KeepaliveProvider, IdleProvider) {
	  IdleProvider.idle(19 * 60);
	  IdleProvider.timeout(1);
	}]).run(['$rootScope', 'authService', 'AUTH_EVENTS', function ($rootScope, authService, AUTH_EVENTS) {
	  $rootScope.$on('IdleTimeout', function () {
	    authService.logout().then(function () {
	      $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess);
	    });
	  });
	}]);
	
	exports['default'] = app;
	module.exports = exports['default'];

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * angular-ui-bootstrap
	 * http://angular-ui.github.io/bootstrap/
	
	 * Version: 0.14.3 - 2015-10-23
	 * License: MIT
	 */
	angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.position","ui.bootstrap.datepicker","ui.bootstrap.dropdown","ui.bootstrap.stackedMap","ui.bootstrap.modal","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.typeahead"]);
	angular.module("ui.bootstrap.tpls", ["template/accordion/accordion-group.html","template/accordion/accordion.html","template/alert/alert.html","template/carousel/carousel.html","template/carousel/slide.html","template/datepicker/datepicker.html","template/datepicker/day.html","template/datepicker/month.html","template/datepicker/popup.html","template/datepicker/year.html","template/modal/backdrop.html","template/modal/window.html","template/pagination/pager.html","template/pagination/pagination.html","template/tooltip/tooltip-html-popup.html","template/tooltip/tooltip-popup.html","template/tooltip/tooltip-template-popup.html","template/popover/popover-html.html","template/popover/popover-template.html","template/popover/popover.html","template/progressbar/bar.html","template/progressbar/progress.html","template/progressbar/progressbar.html","template/rating/rating.html","template/tabs/tab.html","template/tabs/tabset.html","template/timepicker/timepicker.html","template/typeahead/typeahead-match.html","template/typeahead/typeahead-popup.html"]);
	angular.module('ui.bootstrap.collapse', [])
	
	  .directive('uibCollapse', ['$animate', '$injector', function($animate, $injector) {
	    var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
	    return {
	      link: function(scope, element, attrs) {
	        function expand() {
	          element.removeClass('collapse')
	            .addClass('collapsing')
	            .attr('aria-expanded', true)
	            .attr('aria-hidden', false);
	
	          if ($animateCss) {
	            $animateCss(element, {
	              addClass: 'in',
	              easing: 'ease',
	              to: { height: element[0].scrollHeight + 'px' }
	            }).start().finally(expandDone);
	          } else {
	            $animate.addClass(element, 'in', {
	              to: { height: element[0].scrollHeight + 'px' }
	            }).then(expandDone);
	          }
	        }
	
	        function expandDone() {
	          element.removeClass('collapsing')
	            .addClass('collapse')
	            .css({height: 'auto'});
	        }
	
	        function collapse() {
	          if (!element.hasClass('collapse') && !element.hasClass('in')) {
	            return collapseDone();
	          }
	
	          element
	            // IMPORTANT: The height must be set before adding "collapsing" class.
	            // Otherwise, the browser attempts to animate from height 0 (in
	            // collapsing class) to the given height here.
	            .css({height: element[0].scrollHeight + 'px'})
	            // initially all panel collapse have the collapse class, this removal
	            // prevents the animation from jumping to collapsed state
	            .removeClass('collapse')
	            .addClass('collapsing')
	            .attr('aria-expanded', false)
	            .attr('aria-hidden', true);
	
	          if ($animateCss) {
	            $animateCss(element, {
	              removeClass: 'in',
	              to: {height: '0'}
	            }).start().finally(collapseDone);
	          } else {
	            $animate.removeClass(element, 'in', {
	              to: {height: '0'}
	            }).then(collapseDone);
	          }
	        }
	
	        function collapseDone() {
	          element.css({height: '0'}); // Required so that collapse works when animation is disabled
	          element.removeClass('collapsing')
	            .addClass('collapse');
	        }
	
	        scope.$watch(attrs.uibCollapse, function(shouldCollapse) {
	          if (shouldCollapse) {
	            collapse();
	          } else {
	            expand();
	          }
	        });
	      }
	    };
	  }]);
	
	/* Deprecated collapse below */
	
	angular.module('ui.bootstrap.collapse')
	
	  .value('$collapseSuppressWarning', false)
	
	  .directive('collapse', ['$animate', '$injector', '$log', '$collapseSuppressWarning', function($animate, $injector, $log, $collapseSuppressWarning) {
	    var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
	    return {
	      link: function(scope, element, attrs) {
	        if (!$collapseSuppressWarning) {
	          $log.warn('collapse is now deprecated. Use uib-collapse instead.');
	        }
	
	        function expand() {
	          element.removeClass('collapse')
	            .addClass('collapsing')
	            .attr('aria-expanded', true)
	            .attr('aria-hidden', false);
	
	          if ($animateCss) {
	            $animateCss(element, {
	              easing: 'ease',
	              to: { height: element[0].scrollHeight + 'px' }
	            }).start().done(expandDone);
	          } else {
	            $animate.animate(element, {}, {
	              height: element[0].scrollHeight + 'px'
	            }).then(expandDone);
	          }
	        }
	
	        function expandDone() {
	          element.removeClass('collapsing')
	            .addClass('collapse in')
	            .css({height: 'auto'});
	        }
	
	        function collapse() {
	          if (!element.hasClass('collapse') && !element.hasClass('in')) {
	            return collapseDone();
	          }
	
	          element
	            // IMPORTANT: The height must be set before adding "collapsing" class.
	            // Otherwise, the browser attempts to animate from height 0 (in
	            // collapsing class) to the given height here.
	            .css({height: element[0].scrollHeight + 'px'})
	            // initially all panel collapse have the collapse class, this removal
	            // prevents the animation from jumping to collapsed state
	            .removeClass('collapse in')
	            .addClass('collapsing')
	            .attr('aria-expanded', false)
	            .attr('aria-hidden', true);
	
	          if ($animateCss) {
	            $animateCss(element, {
	              to: {height: '0'}
	            }).start().done(collapseDone);
	          } else {
	            $animate.animate(element, {}, {
	              height: '0'
	            }).then(collapseDone);
	          }
	        }
	
	        function collapseDone() {
	          element.css({height: '0'}); // Required so that collapse works when animation is disabled
	          element.removeClass('collapsing')
	            .addClass('collapse');
	        }
	
	        scope.$watch(attrs.collapse, function(shouldCollapse) {
	          if (shouldCollapse) {
	            collapse();
	          } else {
	            expand();
	          }
	        });
	      }
	    };
	  }]);
	
	angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse'])
	
	.constant('uibAccordionConfig', {
	  closeOthers: true
	})
	
	.controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function($scope, $attrs, accordionConfig) {
	  // This array keeps track of the accordion groups
	  this.groups = [];
	
	  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
	  this.closeOthers = function(openGroup) {
	    var closeOthers = angular.isDefined($attrs.closeOthers) ?
	      $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
	    if (closeOthers) {
	      angular.forEach(this.groups, function(group) {
	        if (group !== openGroup) {
	          group.isOpen = false;
	        }
	      });
	    }
	  };
	
	  // This is called from the accordion-group directive to add itself to the accordion
	  this.addGroup = function(groupScope) {
	    var that = this;
	    this.groups.push(groupScope);
	
	    groupScope.$on('$destroy', function(event) {
	      that.removeGroup(groupScope);
	    });
	  };
	
	  // This is called from the accordion-group directive when to remove itself
	  this.removeGroup = function(group) {
	    var index = this.groups.indexOf(group);
	    if (index !== -1) {
	      this.groups.splice(index, 1);
	    }
	  };
	
	}])
	
	// The accordion directive simply sets up the directive controller
	// and adds an accordion CSS class to itself element.
	.directive('uibAccordion', function() {
	  return {
	    controller: 'UibAccordionController',
	    controllerAs: 'accordion',
	    transclude: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/accordion/accordion.html';
	    }
	  };
	})
	
	// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
	.directive('uibAccordionGroup', function() {
	  return {
	    require: '^uibAccordion',         // We need this directive to be inside an accordion
	    transclude: true,              // It transcludes the contents of the directive into the template
	    replace: true,                // The element containing the directive will be replaced with the template
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/accordion/accordion-group.html';
	    },
	    scope: {
	      heading: '@',               // Interpolate the heading attribute onto this scope
	      isOpen: '=?',
	      isDisabled: '=?'
	    },
	    controller: function() {
	      this.setHeading = function(element) {
	        this.heading = element;
	      };
	    },
	    link: function(scope, element, attrs, accordionCtrl) {
	      accordionCtrl.addGroup(scope);
	
	      scope.openClass = attrs.openClass || 'panel-open';
	      scope.panelClass = attrs.panelClass;
	      scope.$watch('isOpen', function(value) {
	        element.toggleClass(scope.openClass, !!value);
	        if (value) {
	          accordionCtrl.closeOthers(scope);
	        }
	      });
	
	      scope.toggleOpen = function($event) {
	        if (!scope.isDisabled) {
	          if (!$event || $event.which === 32) {
	            scope.isOpen = !scope.isOpen;
	          }
	        }
	      };
	    }
	  };
	})
	
	// Use accordion-heading below an accordion-group to provide a heading containing HTML
	.directive('uibAccordionHeading', function() {
	  return {
	    transclude: true,   // Grab the contents to be used as the heading
	    template: '',       // In effect remove this element!
	    replace: true,
	    require: '^uibAccordionGroup',
	    link: function(scope, element, attrs, accordionGroupCtrl, transclude) {
	      // Pass the heading to the accordion-group controller
	      // so that it can be transcluded into the right place in the template
	      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
	      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
	    }
	  };
	})
	
	// Use in the accordion-group template to indicate where you want the heading to be transcluded
	// You must provide the property on the accordion-group controller that will hold the transcluded element
	.directive('uibAccordionTransclude', function() {
	  return {
	    require: ['?^uibAccordionGroup', '?^accordionGroup'],
	    link: function(scope, element, attrs, controller) {
	      controller = controller[0] ? controller[0] : controller[1]; // Delete after we remove deprecation
	      scope.$watch(function() { return controller[attrs.uibAccordionTransclude]; }, function(heading) {
	        if (heading) {
	          element.find('span').html('');
	          element.find('span').append(heading);
	        }
	      });
	    }
	  };
	});
	
	/* Deprecated accordion below */
	
	angular.module('ui.bootstrap.accordion')
	
	  .value('$accordionSuppressWarning', false)
	
	  .controller('AccordionController', ['$scope', '$attrs', '$controller', '$log', '$accordionSuppressWarning', function($scope, $attrs, $controller, $log, $accordionSuppressWarning) {
	    if (!$accordionSuppressWarning) {
	      $log.warn('AccordionController is now deprecated. Use UibAccordionController instead.');
	    }
	
	    angular.extend(this, $controller('UibAccordionController', {
	      $scope: $scope,
	      $attrs: $attrs
	    }));
	  }])
	
	  .directive('accordion', ['$log', '$accordionSuppressWarning', function($log, $accordionSuppressWarning) {
	    return {
	      restrict: 'EA',
	      controller: 'AccordionController',
	      controllerAs: 'accordion',
	      transclude: true,
	      replace: false,
	      templateUrl: function(element, attrs) {
	        return attrs.templateUrl || 'template/accordion/accordion.html';
	      },
	      link: function() {
	        if (!$accordionSuppressWarning) {
	          $log.warn('accordion is now deprecated. Use uib-accordion instead.');
	        }
	      }
	    };
	  }])
	
	  .directive('accordionGroup', ['$log', '$accordionSuppressWarning', function($log, $accordionSuppressWarning) {
	    return {
	      require: '^accordion',         // We need this directive to be inside an accordion
	      restrict: 'EA',
	      transclude: true,              // It transcludes the contents of the directive into the template
	      replace: true,                // The element containing the directive will be replaced with the template
	      templateUrl: function(element, attrs) {
	        return attrs.templateUrl || 'template/accordion/accordion-group.html';
	      },
	      scope: {
	        heading: '@',               // Interpolate the heading attribute onto this scope
	        isOpen: '=?',
	        isDisabled: '=?'
	      },
	      controller: function() {
	        this.setHeading = function(element) {
	          this.heading = element;
	        };
	      },
	      link: function(scope, element, attrs, accordionCtrl) {
	        if (!$accordionSuppressWarning) {
	          $log.warn('accordion-group is now deprecated. Use uib-accordion-group instead.');
	        }
	
	        accordionCtrl.addGroup(scope);
	
	        scope.openClass = attrs.openClass || 'panel-open';
	        scope.panelClass = attrs.panelClass;
	        scope.$watch('isOpen', function(value) {
	          element.toggleClass(scope.openClass, !!value);
	          if (value) {
	            accordionCtrl.closeOthers(scope);
	          }
	        });
	
	        scope.toggleOpen = function($event) {
	          if (!scope.isDisabled) {
	            if (!$event || $event.which === 32) {
	              scope.isOpen = !scope.isOpen;
	            }
	          }
	        };
	      }
	    };
	  }])
	
	  .directive('accordionHeading', ['$log', '$accordionSuppressWarning', function($log, $accordionSuppressWarning) {
	    return {
	      restrict: 'EA',
	      transclude: true,   // Grab the contents to be used as the heading
	      template: '',       // In effect remove this element!
	      replace: true,
	      require: '^accordionGroup',
	      link: function(scope, element, attr, accordionGroupCtrl, transclude) {
	        if (!$accordionSuppressWarning) {
	          $log.warn('accordion-heading is now deprecated. Use uib-accordion-heading instead.');
	        }
	        // Pass the heading to the accordion-group controller
	        // so that it can be transcluded into the right place in the template
	        // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
	        accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
	      }
	    };
	  }])
	
	  .directive('accordionTransclude', ['$log', '$accordionSuppressWarning', function($log, $accordionSuppressWarning) {
	    return {
	      require: '^accordionGroup',
	      link: function(scope, element, attr, controller) {
	        if (!$accordionSuppressWarning) {
	          $log.warn('accordion-transclude is now deprecated. Use uib-accordion-transclude instead.');
	        }
	
	        scope.$watch(function() { return controller[attr.accordionTransclude]; }, function(heading) {
	          if (heading) {
	            element.find('span').html('');
	            element.find('span').append(heading);
	          }
	        });
	      }
	    };
	  }]);
	
	
	angular.module('ui.bootstrap.alert', [])
	
	.controller('UibAlertController', ['$scope', '$attrs', '$interpolate', '$timeout', function($scope, $attrs, $interpolate, $timeout) {
	  $scope.closeable = !!$attrs.close;
	
	  var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ?
	    $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;
	
	  if (dismissOnTimeout) {
	    $timeout(function() {
	      $scope.close();
	    }, parseInt(dismissOnTimeout, 10));
	  }
	}])
	
	.directive('uibAlert', function() {
	  return {
	    controller: 'UibAlertController',
	    controllerAs: 'alert',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/alert/alert.html';
	    },
	    transclude: true,
	    replace: true,
	    scope: {
	      type: '@',
	      close: '&'
	    }
	  };
	});
	
	/* Deprecated alert below */
	
	angular.module('ui.bootstrap.alert')
	
	  .value('$alertSuppressWarning', false)
	
	  .controller('AlertController', ['$scope', '$attrs', '$controller', '$log', '$alertSuppressWarning', function($scope, $attrs, $controller, $log, $alertSuppressWarning) {
	    if (!$alertSuppressWarning) {
	      $log.warn('AlertController is now deprecated. Use UibAlertController instead.');
	    }
	
	    angular.extend(this, $controller('UibAlertController', {
	      $scope: $scope,
	      $attrs: $attrs
	    }));
	  }])
	
	  .directive('alert', ['$log', '$alertSuppressWarning', function($log, $alertSuppressWarning) {
	    return {
	      controller: 'AlertController',
	      controllerAs: 'alert',
	      templateUrl: function(element, attrs) {
	        return attrs.templateUrl || 'template/alert/alert.html';
	      },
	      transclude: true,
	      replace: true,
	      scope: {
	        type: '@',
	        close: '&'
	      },
	      link: function() {
	        if (!$alertSuppressWarning) {
	          $log.warn('alert is now deprecated. Use uib-alert instead.');
	        }
	      }
	    };
	  }]);
	
	angular.module('ui.bootstrap.buttons', [])
	
	.constant('uibButtonConfig', {
	  activeClass: 'active',
	  toggleEvent: 'click'
	})
	
	.controller('UibButtonsController', ['uibButtonConfig', function(buttonConfig) {
	  this.activeClass = buttonConfig.activeClass || 'active';
	  this.toggleEvent = buttonConfig.toggleEvent || 'click';
	}])
	
	.directive('uibBtnRadio', function() {
	  return {
	    require: ['uibBtnRadio', 'ngModel'],
	    controller: 'UibButtonsController',
	    controllerAs: 'buttons',
	    link: function(scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      element.find('input').css({display: 'none'});
	
	      //model -> UI
	      ngModelCtrl.$render = function() {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
	      };
	
	      //ui->model
	      element.on(buttonsCtrl.toggleEvent, function() {
	        if (attrs.disabled) {
	          return;
	        }
	
	        var isActive = element.hasClass(buttonsCtrl.activeClass);
	
	        if (!isActive || angular.isDefined(attrs.uncheckable)) {
	          scope.$apply(function() {
	            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
	            ngModelCtrl.$render();
	          });
	        }
	      });
	    }
	  };
	})
	
	.directive('uibBtnCheckbox', function() {
	  return {
	    require: ['uibBtnCheckbox', 'ngModel'],
	    controller: 'UibButtonsController',
	    controllerAs: 'button',
	    link: function(scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      element.find('input').css({display: 'none'});
	
	      function getTrueValue() {
	        return getCheckboxValue(attrs.btnCheckboxTrue, true);
	      }
	
	      function getFalseValue() {
	        return getCheckboxValue(attrs.btnCheckboxFalse, false);
	      }
	
	      function getCheckboxValue(attribute, defaultValue) {
	        return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
	      }
	
	      //model -> UI
	      ngModelCtrl.$render = function() {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
	      };
	
	      //ui->model
	      element.on(buttonsCtrl.toggleEvent, function() {
	        if (attrs.disabled) {
	          return;
	        }
	
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
	          ngModelCtrl.$render();
	        });
	      });
	    }
	  };
	});
	
	/* Deprecated buttons below */
	
	angular.module('ui.bootstrap.buttons')
	
	  .value('$buttonsSuppressWarning', false)
	
	  .controller('ButtonsController', ['$controller', '$log', '$buttonsSuppressWarning', function($controller, $log, $buttonsSuppressWarning) {
	    if (!$buttonsSuppressWarning) {
	      $log.warn('ButtonsController is now deprecated. Use UibButtonsController instead.');
	    }
	
	    angular.extend(this, $controller('UibButtonsController'));
	  }])
	
	  .directive('btnRadio', ['$log', '$buttonsSuppressWarning', function($log, $buttonsSuppressWarning) {
	    return {
	      require: ['btnRadio', 'ngModel'],
	      controller: 'ButtonsController',
	      controllerAs: 'buttons',
	      link: function(scope, element, attrs, ctrls) {
	        if (!$buttonsSuppressWarning) {
	          $log.warn('btn-radio is now deprecated. Use uib-btn-radio instead.');
	        }
	
	        var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	        element.find('input').css({display: 'none'});
	
	        //model -> UI
	        ngModelCtrl.$render = function() {
	          element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.btnRadio)));
	        };
	
	        //ui->model
	        element.bind(buttonsCtrl.toggleEvent, function() {
	          if (attrs.disabled) {
	            return;
	          }
	
	          var isActive = element.hasClass(buttonsCtrl.activeClass);
	
	          if (!isActive || angular.isDefined(attrs.uncheckable)) {
	            scope.$apply(function() {
	              ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.btnRadio));
	              ngModelCtrl.$render();
	            });
	          }
	        });
	      }
	    };
	  }])
	
	  .directive('btnCheckbox', ['$document', '$log', '$buttonsSuppressWarning', function($document, $log, $buttonsSuppressWarning) {
	    return {
	      require: ['btnCheckbox', 'ngModel'],
	      controller: 'ButtonsController',
	      controllerAs: 'button',
	      link: function(scope, element, attrs, ctrls) {
	        if (!$buttonsSuppressWarning) {
	          $log.warn('btn-checkbox is now deprecated. Use uib-btn-checkbox instead.');
	        }
	
	        var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	        element.find('input').css({display: 'none'});
	
	        function getTrueValue() {
	          return getCheckboxValue(attrs.btnCheckboxTrue, true);
	        }
	
	        function getFalseValue() {
	          return getCheckboxValue(attrs.btnCheckboxFalse, false);
	        }
	
	        function getCheckboxValue(attributeValue, defaultValue) {
	          var val = scope.$eval(attributeValue);
	          return angular.isDefined(val) ? val : defaultValue;
	        }
	
	        //model -> UI
	        ngModelCtrl.$render = function() {
	          element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
	        };
	
	        //ui->model
	        element.bind(buttonsCtrl.toggleEvent, function() {
	          if (attrs.disabled) {
	            return;
	          }
	
	          scope.$apply(function() {
	            ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
	            ngModelCtrl.$render();
	          });
	        });
	
	        //accessibility
	        element.on('keypress', function(e) {
	          if (attrs.disabled || e.which !== 32 || $document[0].activeElement !== element[0]) {
	            return;
	          }
	
	          scope.$apply(function() {
	            ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
	            ngModelCtrl.$render();
	          });
	        });
	      }
	    };
	  }]);
	
	
	/**
	 * @ngdoc overview
	 * @name ui.bootstrap.carousel
	 *
	 * @description
	 * AngularJS version of an image carousel.
	 *
	 */
	angular.module('ui.bootstrap.carousel', [])
	
	.controller('UibCarouselController', ['$scope', '$element', '$interval', '$animate', function($scope, $element, $interval, $animate) {
	  var self = this,
	    slides = self.slides = $scope.slides = [],
	    NEW_ANIMATE = angular.version.minor >= 4,
	    NO_TRANSITION = 'uib-noTransition',
	    SLIDE_DIRECTION = 'uib-slideDirection',
	    currentIndex = -1,
	    currentInterval, isPlaying;
	  self.currentSlide = null;
	
	  var destroyed = false;
	  /* direction: "prev" or "next" */
	  self.select = $scope.select = function(nextSlide, direction) {
	    var nextIndex = $scope.indexOfSlide(nextSlide);
	    //Decide direction if it's not given
	    if (direction === undefined) {
	      direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
	    }
	    //Prevent this user-triggered transition from occurring if there is already one in progress
	    if (nextSlide && nextSlide !== self.currentSlide && !$scope.$currentTransition) {
	      goNext(nextSlide, nextIndex, direction);
	    }
	  };
	
	  function goNext(slide, index, direction) {
	    // Scope has been destroyed, stop here.
	    if (destroyed) { return; }
	
	    angular.extend(slide, {direction: direction, active: true});
	    angular.extend(self.currentSlide || {}, {direction: direction, active: false});
	    if ($animate.enabled() && !$scope.noTransition && !$scope.$currentTransition &&
	      slide.$element && self.slides.length > 1) {
	      slide.$element.data(SLIDE_DIRECTION, slide.direction);
	      if (self.currentSlide && self.currentSlide.$element) {
	        self.currentSlide.$element.data(SLIDE_DIRECTION, slide.direction);
	      }
	
	      $scope.$currentTransition = true;
	      if (NEW_ANIMATE) {
	        $animate.on('addClass', slide.$element, function(element, phase) {
	          if (phase === 'close') {
	            $scope.$currentTransition = null;
	            $animate.off('addClass', element);
	          }
	        });
	      } else {
	        slide.$element.one('$animate:close', function closeFn() {
	          $scope.$currentTransition = null;
	        });
	      }
	    }
	
	    self.currentSlide = slide;
	    currentIndex = index;
	
	    //every time you change slides, reset the timer
	    restartTimer();
	  }
	
	  $scope.$on('$destroy', function() {
	    destroyed = true;
	  });
	
	  function getSlideByIndex(index) {
	    if (angular.isUndefined(slides[index].index)) {
	      return slides[index];
	    }
	    var i, len = slides.length;
	    for (i = 0; i < slides.length; ++i) {
	      if (slides[i].index == index) {
	        return slides[i];
	      }
	    }
	  }
	
	  self.getCurrentIndex = function() {
	    if (self.currentSlide && angular.isDefined(self.currentSlide.index)) {
	      return +self.currentSlide.index;
	    }
	    return currentIndex;
	  };
	
	  /* Allow outside people to call indexOf on slides array */
	  $scope.indexOfSlide = function(slide) {
	    return angular.isDefined(slide.index) ? +slide.index : slides.indexOf(slide);
	  };
	
	  $scope.next = function() {
	    var newIndex = (self.getCurrentIndex() + 1) % slides.length;
	
	    if (newIndex === 0 && $scope.noWrap()) {
	      $scope.pause();
	      return;
	    }
	
	    return self.select(getSlideByIndex(newIndex), 'next');
	  };
	
	  $scope.prev = function() {
	    var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;
	
	    if ($scope.noWrap() && newIndex === slides.length - 1) {
	      $scope.pause();
	      return;
	    }
	
	    return self.select(getSlideByIndex(newIndex), 'prev');
	  };
	
	  $scope.isActive = function(slide) {
	     return self.currentSlide === slide;
	  };
	
	  $scope.$watch('interval', restartTimer);
	  $scope.$watchCollection('slides', resetTransition);
	  $scope.$on('$destroy', resetTimer);
	
	  function restartTimer() {
	    resetTimer();
	    var interval = +$scope.interval;
	    if (!isNaN(interval) && interval > 0) {
	      currentInterval = $interval(timerFn, interval);
	    }
	  }
	
	  function resetTimer() {
	    if (currentInterval) {
	      $interval.cancel(currentInterval);
	      currentInterval = null;
	    }
	  }
	
	  function timerFn() {
	    var interval = +$scope.interval;
	    if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
	      $scope.next();
	    } else {
	      $scope.pause();
	    }
	  }
	
	  function resetTransition(slides) {
	    if (!slides.length) {
	      $scope.$currentTransition = null;
	    }
	  }
	
	  $scope.play = function() {
	    if (!isPlaying) {
	      isPlaying = true;
	      restartTimer();
	    }
	  };
	  $scope.pause = function() {
	    if (!$scope.noPause) {
	      isPlaying = false;
	      resetTimer();
	    }
	  };
	
	  self.addSlide = function(slide, element) {
	    slide.$element = element;
	    slides.push(slide);
	    //if this is the first slide or the slide is set to active, select it
	    if (slides.length === 1 || slide.active) {
	      self.select(slides[slides.length - 1]);
	      if (slides.length === 1) {
	        $scope.play();
	      }
	    } else {
	      slide.active = false;
	    }
	  };
	
	  self.removeSlide = function(slide) {
	    if (angular.isDefined(slide.index)) {
	      slides.sort(function(a, b) {
	        return +a.index > +b.index;
	      });
	    }
	    //get the index of the slide inside the carousel
	    var index = slides.indexOf(slide);
	    slides.splice(index, 1);
	    if (slides.length > 0 && slide.active) {
	      if (index >= slides.length) {
	        self.select(slides[index - 1]);
	      } else {
	        self.select(slides[index]);
	      }
	    } else if (currentIndex > index) {
	      currentIndex--;
	    }
	
	    //clean the currentSlide when no more slide
	    if (slides.length === 0) {
	      self.currentSlide = null;
	    }
	  };
	
	  $scope.$watch('noTransition', function(noTransition) {
	    $element.data(NO_TRANSITION, noTransition);
	  });
	
	}])
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.carousel.directive:carousel
	 * @restrict EA
	 *
	 * @description
	 * Carousel is the outer container for a set of image 'slides' to showcase.
	 *
	 * @param {number=} interval The time, in milliseconds, that it will take the carousel to go to the next slide.
	 * @param {boolean=} noTransition Whether to disable transitions on the carousel.
	 * @param {boolean=} noPause Whether to disable pausing on the carousel (by default, the carousel interval pauses on hover).
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	    <uib-carousel>
	      <uib-slide>
	        <img src="http://placekitten.com/150/150" style="margin:auto;">
	        <div class="carousel-caption">
	          <p>Beautiful!</p>
	        </div>
	      </uib-slide>
	      <uib-slide>
	        <img src="http://placekitten.com/100/150" style="margin:auto;">
	        <div class="carousel-caption">
	          <p>D'aww!</p>
	        </div>
	      </uib-slide>
	    </uib-carousel>
	  </file>
	  <file name="demo.css">
	    .carousel-indicators {
	      top: auto;
	      bottom: 15px;
	    }
	  </file>
	</example>
	 */
	.directive('uibCarousel', [function() {
	  return {
	    transclude: true,
	    replace: true,
	    controller: 'UibCarouselController',
	    controllerAs: 'carousel',
	    require: 'carousel',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/carousel/carousel.html';
	    },
	    scope: {
	      interval: '=',
	      noTransition: '=',
	      noPause: '=',
	      noWrap: '&'
	    }
	  };
	}])
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.carousel.directive:slide
	 * @restrict EA
	 *
	 * @description
	 * Creates a slide inside a {@link ui.bootstrap.carousel.directive:carousel carousel}.  Must be placed as a child of a carousel element.
	 *
	 * @param {boolean=} active Model binding, whether or not this slide is currently active.
	 * @param {number=} index The index of the slide. The slides will be sorted by this parameter.
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	<div ng-controller="CarouselDemoCtrl">
	  <uib-carousel>
	    <uib-slide ng-repeat="slide in slides" active="slide.active" index="$index">
	      <img ng-src="{{slide.image}}" style="margin:auto;">
	      <div class="carousel-caption">
	        <h4>Slide {{$index}}</h4>
	        <p>{{slide.text}}</p>
	      </div>
	    </uib-slide>
	  </uib-carousel>
	  Interval, in milliseconds: <input type="number" ng-model="myInterval">
	  <br />Enter a negative number to stop the interval.
	</div>
	  </file>
	  <file name="script.js">
	function CarouselDemoCtrl($scope) {
	  $scope.myInterval = 5000;
	}
	  </file>
	  <file name="demo.css">
	    .carousel-indicators {
	      top: auto;
	      bottom: 15px;
	    }
	  </file>
	</example>
	*/
	
	.directive('uibSlide', function() {
	  return {
	    require: '^uibCarousel',
	    restrict: 'EA',
	    transclude: true,
	    replace: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/carousel/slide.html';
	    },
	    scope: {
	      active: '=?',
	      actual: '=?',
	      index: '=?'
	    },
	    link: function (scope, element, attrs, carouselCtrl) {
	      carouselCtrl.addSlide(scope, element);
	      //when the scope is destroyed then remove the slide from the current slides array
	      scope.$on('$destroy', function() {
	        carouselCtrl.removeSlide(scope);
	      });
	
	      scope.$watch('active', function(active) {
	        if (active) {
	          carouselCtrl.select(scope);
	        }
	      });
	    }
	  };
	})
	
	.animation('.item', [
	         '$injector', '$animate',
	function ($injector, $animate) {
	  var NO_TRANSITION = 'uib-noTransition',
	    SLIDE_DIRECTION = 'uib-slideDirection',
	    $animateCss = null;
	
	  if ($injector.has('$animateCss')) {
	    $animateCss = $injector.get('$animateCss');
	  }
	
	  function removeClass(element, className, callback) {
	    element.removeClass(className);
	    if (callback) {
	      callback();
	    }
	  }
	
	  return {
	    beforeAddClass: function(element, className, done) {
	      // Due to transclusion, noTransition property is on parent's scope
	      if (className == 'active' && element.parent() && element.parent().parent() &&
	          !element.parent().parent().data(NO_TRANSITION)) {
	        var stopped = false;
	        var direction = element.data(SLIDE_DIRECTION);
	        var directionClass = direction == 'next' ? 'left' : 'right';
	        var removeClassFn = removeClass.bind(this, element,
	          directionClass + ' ' + direction, done);
	        element.addClass(direction);
	
	        if ($animateCss) {
	          $animateCss(element, {addClass: directionClass})
	            .start()
	            .done(removeClassFn);
	        } else {
	          $animate.addClass(element, directionClass).then(function () {
	            if (!stopped) {
	              removeClassFn();
	            }
	            done();
	          });
	        }
	
	        return function () {
	          stopped = true;
	        };
	      }
	      done();
	    },
	    beforeRemoveClass: function (element, className, done) {
	      // Due to transclusion, noTransition property is on parent's scope
	      if (className === 'active' && element.parent() && element.parent().parent() &&
	          !element.parent().parent().data(NO_TRANSITION)) {
	        var stopped = false;
	        var direction = element.data(SLIDE_DIRECTION);
	        var directionClass = direction == 'next' ? 'left' : 'right';
	        var removeClassFn = removeClass.bind(this, element, directionClass, done);
	
	        if ($animateCss) {
	          $animateCss(element, {addClass: directionClass})
	            .start()
	            .done(removeClassFn);
	        } else {
	          $animate.addClass(element, directionClass).then(function() {
	            if (!stopped) {
	              removeClassFn();
	            }
	            done();
	          });
	        }
	        return function() {
	          stopped = true;
	        };
	      }
	      done();
	    }
	  };
	}]);
	
	/* deprecated carousel below */
	
	angular.module('ui.bootstrap.carousel')
	
	.value('$carouselSuppressWarning', false)
	
	.controller('CarouselController', ['$scope', '$element', '$controller', '$log', '$carouselSuppressWarning', function($scope, $element, $controller, $log, $carouselSuppressWarning) {
	  if (!$carouselSuppressWarning) {
	    $log.warn('CarouselController is now deprecated. Use UibCarouselController instead.');
	  }
	
	  angular.extend(this, $controller('UibCarouselController', {
	    $scope: $scope,
	    $element: $element
	  }));
	}])
	
	.directive('carousel', ['$log', '$carouselSuppressWarning', function($log, $carouselSuppressWarning) {
	  return {
	    transclude: true,
	    replace: true,
	    controller: 'CarouselController',
	    controllerAs: 'carousel',
	    require: 'carousel',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/carousel/carousel.html';
	    },
	    scope: {
	      interval: '=',
	      noTransition: '=',
	      noPause: '=',
	      noWrap: '&'
	    },
	    link: function() {
	      if (!$carouselSuppressWarning) {
	        $log.warn('carousel is now deprecated. Use uib-carousel instead.');
	      }
	    }
	  };
	}])
	
	.directive('slide', ['$log', '$carouselSuppressWarning', function($log, $carouselSuppressWarning) {
	  return {
	    require: '^carousel',
	    transclude: true,
	    replace: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/carousel/slide.html';
	    },
	    scope: {
	      active: '=?',
	      actual: '=?',
	      index: '=?'
	    },
	    link: function (scope, element, attrs, carouselCtrl) {
	      if (!$carouselSuppressWarning) {
	        $log.warn('slide is now deprecated. Use uib-slide instead.');
	      }
	
	      carouselCtrl.addSlide(scope, element);
	      //when the scope is destroyed then remove the slide from the current slides array
	      scope.$on('$destroy', function() {
	        carouselCtrl.removeSlide(scope);
	      });
	
	      scope.$watch('active', function(active) {
	        if (active) {
	          carouselCtrl.select(scope);
	        }
	      });
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.dateparser', [])
	
	.service('uibDateParser', ['$log', '$locale', 'orderByFilter', function($log, $locale, orderByFilter) {
	  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
	  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	  var localeId;
	  var formatCodeToRegex;
	
	  this.init = function() {
	    localeId = $locale.id;
	
	    this.parsers = {};
	
	    formatCodeToRegex = {
	      'yyyy': {
	        regex: '\\d{4}',
	        apply: function(value) { this.year = +value; }
	      },
	      'yy': {
	        regex: '\\d{2}',
	        apply: function(value) { this.year = +value + 2000; }
	      },
	      'y': {
	        regex: '\\d{1,4}',
	        apply: function(value) { this.year = +value; }
	      },
	      'MMMM': {
	        regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
	        apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); }
	      },
	      'MMM': {
	        regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
	        apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); }
	      },
	      'MM': {
	        regex: '0[1-9]|1[0-2]',
	        apply: function(value) { this.month = value - 1; }
	      },
	      'M': {
	        regex: '[1-9]|1[0-2]',
	        apply: function(value) { this.month = value - 1; }
	      },
	      'dd': {
	        regex: '[0-2][0-9]{1}|3[0-1]{1}',
	        apply: function(value) { this.date = +value; }
	      },
	      'd': {
	        regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
	        apply: function(value) { this.date = +value; }
	      },
	      'EEEE': {
	        regex: $locale.DATETIME_FORMATS.DAY.join('|')
	      },
	      'EEE': {
	        regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|')
	      },
	      'HH': {
	        regex: '(?:0|1)[0-9]|2[0-3]',
	        apply: function(value) { this.hours = +value; }
	      },
	      'hh': {
	        regex: '0[0-9]|1[0-2]',
	        apply: function(value) { this.hours = +value; }
	      },
	      'H': {
	        regex: '1?[0-9]|2[0-3]',
	        apply: function(value) { this.hours = +value; }
	      },
	      'h': {
	        regex: '[0-9]|1[0-2]',
	        apply: function(value) { this.hours = +value; }
	      },
	      'mm': {
	        regex: '[0-5][0-9]',
	        apply: function(value) { this.minutes = +value; }
	      },
	      'm': {
	        regex: '[0-9]|[1-5][0-9]',
	        apply: function(value) { this.minutes = +value; }
	      },
	      'sss': {
	        regex: '[0-9][0-9][0-9]',
	        apply: function(value) { this.milliseconds = +value; }
	      },
	      'ss': {
	        regex: '[0-5][0-9]',
	        apply: function(value) { this.seconds = +value; }
	      },
	      's': {
	        regex: '[0-9]|[1-5][0-9]',
	        apply: function(value) { this.seconds = +value; }
	      },
	      'a': {
	        regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
	        apply: function(value) {
	          if (this.hours === 12) {
	            this.hours = 0;
	          }
	
	          if (value === 'PM') {
	            this.hours += 12;
	          }
	        }
	      }
	    };
	  };
	
	  this.init();
	
	  function createParser(format) {
	    var map = [], regex = format.split('');
	
	    angular.forEach(formatCodeToRegex, function(data, code) {
	      var index = format.indexOf(code);
	
	      if (index > -1) {
	        format = format.split('');
	
	        regex[index] = '(' + data.regex + ')';
	        format[index] = '$'; // Custom symbol to define consumed part of format
	        for (var i = index + 1, n = index + code.length; i < n; i++) {
	          regex[i] = '';
	          format[i] = '$';
	        }
	        format = format.join('');
	
	        map.push({ index: index, apply: data.apply });
	      }
	    });
	
	    return {
	      regex: new RegExp('^' + regex.join('') + '$'),
	      map: orderByFilter(map, 'index')
	    };
	  }
	
	  this.parse = function(input, format, baseDate) {
	    if (!angular.isString(input) || !format) {
	      return input;
	    }
	
	    format = $locale.DATETIME_FORMATS[format] || format;
	    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');
	
	    if ($locale.id !== localeId) {
	      this.init();
	    }
	
	    if (!this.parsers[format]) {
	      this.parsers[format] = createParser(format);
	    }
	
	    var parser = this.parsers[format],
	        regex = parser.regex,
	        map = parser.map,
	        results = input.match(regex);
	
	    if (results && results.length) {
	      var fields, dt;
	      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
	        fields = {
	          year: baseDate.getFullYear(),
	          month: baseDate.getMonth(),
	          date: baseDate.getDate(),
	          hours: baseDate.getHours(),
	          minutes: baseDate.getMinutes(),
	          seconds: baseDate.getSeconds(),
	          milliseconds: baseDate.getMilliseconds()
	        };
	      } else {
	        if (baseDate) {
	          $log.warn('dateparser:', 'baseDate is not a valid date');
	        }
	        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
	      }
	
	      for (var i = 1, n = results.length; i < n; i++) {
	        var mapper = map[i-1];
	        if (mapper.apply) {
	          mapper.apply.call(fields, results[i]);
	        }
	      }
	
	      if (isValid(fields.year, fields.month, fields.date)) {
	        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
	          dt = new Date(baseDate);
	          dt.setFullYear(fields.year, fields.month, fields.date,
	            fields.hours, fields.minutes, fields.seconds,
	            fields.milliseconds || 0);
	        } else {
	          dt = new Date(fields.year, fields.month, fields.date,
	            fields.hours, fields.minutes, fields.seconds,
	            fields.milliseconds || 0);
	        }
	      }
	
	      return dt;
	    }
	  };
	
	  // Check if date is valid for specific month (and year for February).
	  // Month: 0 = Jan, 1 = Feb, etc
	  function isValid(year, month, date) {
	    if (date < 1) {
	      return false;
	    }
	
	    if (month === 1 && date > 28) {
	      return date === 29 && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
	    }
	
	    if (month === 3 || month === 5 || month === 8 || month === 10) {
	      return date < 31;
	    }
	
	    return true;
	  }
	}]);
	
	/* Deprecated dateparser below */
	
	angular.module('ui.bootstrap.dateparser')
	
	.value('$dateParserSuppressWarning', false)
	
	.service('dateParser', ['$log', '$dateParserSuppressWarning', 'uibDateParser', function($log, $dateParserSuppressWarning, uibDateParser) {
	  if (!$dateParserSuppressWarning) {
	    $log.warn('dateParser is now deprecated. Use uibDateParser instead.');
	  }
	
	  angular.extend(this, uibDateParser);
	}]);
	
	angular.module('ui.bootstrap.position', [])
	
	/**
	 * A set of utility methods that can be use to retrieve position of DOM elements.
	 * It is meant to be used where we need to absolute-position DOM elements in
	 * relation to other, existing elements (this is the case for tooltips, popovers,
	 * typeahead suggestions etc.).
	 */
	  .factory('$uibPosition', ['$document', '$window', function($document, $window) {
	    function getStyle(el, cssprop) {
	      if (el.currentStyle) { //IE
	        return el.currentStyle[cssprop];
	      } else if ($window.getComputedStyle) {
	        return $window.getComputedStyle(el)[cssprop];
	      }
	      // finally try and get inline style
	      return el.style[cssprop];
	    }
	
	    /**
	     * Checks if a given element is statically positioned
	     * @param element - raw DOM element
	     */
	    function isStaticPositioned(element) {
	      return (getStyle(element, 'position') || 'static' ) === 'static';
	    }
	
	    /**
	     * returns the closest, non-statically positioned parentOffset of a given element
	     * @param element
	     */
	    var parentOffsetEl = function(element) {
	      var docDomEl = $document[0];
	      var offsetParent = element.offsetParent || docDomEl;
	      while (offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent) ) {
	        offsetParent = offsetParent.offsetParent;
	      }
	      return offsetParent || docDomEl;
	    };
	
	    return {
	      /**
	       * Provides read-only equivalent of jQuery's position function:
	       * http://api.jquery.com/position/
	       */
	      position: function(element) {
	        var elBCR = this.offset(element);
	        var offsetParentBCR = { top: 0, left: 0 };
	        var offsetParentEl = parentOffsetEl(element[0]);
	        if (offsetParentEl != $document[0]) {
	          offsetParentBCR = this.offset(angular.element(offsetParentEl));
	          offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
	          offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
	        }
	
	        var boundingClientRect = element[0].getBoundingClientRect();
	        return {
	          width: boundingClientRect.width || element.prop('offsetWidth'),
	          height: boundingClientRect.height || element.prop('offsetHeight'),
	          top: elBCR.top - offsetParentBCR.top,
	          left: elBCR.left - offsetParentBCR.left
	        };
	      },
	
	      /**
	       * Provides read-only equivalent of jQuery's offset function:
	       * http://api.jquery.com/offset/
	       */
	      offset: function(element) {
	        var boundingClientRect = element[0].getBoundingClientRect();
	        return {
	          width: boundingClientRect.width || element.prop('offsetWidth'),
	          height: boundingClientRect.height || element.prop('offsetHeight'),
	          top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
	          left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
	        };
	      },
	
	      /**
	       * Provides coordinates for the targetEl in relation to hostEl
	       */
	      positionElements: function(hostEl, targetEl, positionStr, appendToBody) {
	        var positionStrParts = positionStr.split('-');
	        var pos0 = positionStrParts[0], pos1 = positionStrParts[1] || 'center';
	
	        var hostElPos,
	          targetElWidth,
	          targetElHeight,
	          targetElPos;
	
	        hostElPos = appendToBody ? this.offset(hostEl) : this.position(hostEl);
	
	        targetElWidth = targetEl.prop('offsetWidth');
	        targetElHeight = targetEl.prop('offsetHeight');
	
	        var shiftWidth = {
	          center: function() {
	            return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
	          },
	          left: function() {
	            return hostElPos.left;
	          },
	          right: function() {
	            return hostElPos.left + hostElPos.width;
	          }
	        };
	
	        var shiftHeight = {
	          center: function() {
	            return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
	          },
	          top: function() {
	            return hostElPos.top;
	          },
	          bottom: function() {
	            return hostElPos.top + hostElPos.height;
	          }
	        };
	
	        switch (pos0) {
	          case 'right':
	            targetElPos = {
	              top: shiftHeight[pos1](),
	              left: shiftWidth[pos0]()
	            };
	            break;
	          case 'left':
	            targetElPos = {
	              top: shiftHeight[pos1](),
	              left: hostElPos.left - targetElWidth
	            };
	            break;
	          case 'bottom':
	            targetElPos = {
	              top: shiftHeight[pos0](),
	              left: shiftWidth[pos1]()
	            };
	            break;
	          default:
	            targetElPos = {
	              top: hostElPos.top - targetElHeight,
	              left: shiftWidth[pos1]()
	            };
	            break;
	        }
	
	        return targetElPos;
	      }
	    };
	  }]);
	
	/* Deprecated position below */
	
	angular.module('ui.bootstrap.position')
	
	.value('$positionSuppressWarning', false)
	
	.service('$position', ['$log', '$positionSuppressWarning', '$uibPosition', function($log, $positionSuppressWarning, $uibPosition) {
	  if (!$positionSuppressWarning) {
	    $log.warn('$position is now deprecated. Use $uibPosition instead.');
	  }
	
	  angular.extend(this, $uibPosition);
	}]);
	
	angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.position'])
	
	.value('$datepickerSuppressError', false)
	
	.constant('uibDatepickerConfig', {
	  formatDay: 'dd',
	  formatMonth: 'MMMM',
	  formatYear: 'yyyy',
	  formatDayHeader: 'EEE',
	  formatDayTitle: 'MMMM yyyy',
	  formatMonthTitle: 'yyyy',
	  datepickerMode: 'day',
	  minMode: 'day',
	  maxMode: 'year',
	  showWeeks: true,
	  startingDay: 0,
	  yearRange: 20,
	  minDate: null,
	  maxDate: null,
	  shortcutPropagation: false
	})
	
	.controller('UibDatepickerController', ['$scope', '$attrs', '$parse', '$interpolate', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerSuppressError', function($scope, $attrs, $parse, $interpolate, $log, dateFilter, datepickerConfig, $datepickerSuppressError) {
	  var self = this,
	      ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl;
	
	  // Modes chain
	  this.modes = ['day', 'month', 'year'];
	
	  // Configuration attributes
	  angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle',
	                   'showWeeks', 'startingDay', 'yearRange', 'shortcutPropagation'], function(key, index) {
	    self[key] = angular.isDefined($attrs[key]) ? (index < 6 ? $interpolate($attrs[key])($scope.$parent) : $scope.$parent.$eval($attrs[key])) : datepickerConfig[key];
	  });
	
	  // Watchable date attributes
	  angular.forEach(['minDate', 'maxDate'], function(key) {
	    if ($attrs[key]) {
	      $scope.$parent.$watch($parse($attrs[key]), function(value) {
	        self[key] = value ? new Date(value) : null;
	        self.refreshView();
	      });
	    } else {
	      self[key] = datepickerConfig[key] ? new Date(datepickerConfig[key]) : null;
	    }
	  });
	
	  angular.forEach(['minMode', 'maxMode'], function(key) {
	    if ($attrs[key]) {
	      $scope.$parent.$watch($parse($attrs[key]), function(value) {
	        self[key] = angular.isDefined(value) ? value : $attrs[key];
	        $scope[key] = self[key];
	        if ((key == 'minMode' && self.modes.indexOf($scope.datepickerMode) < self.modes.indexOf(self[key])) || (key == 'maxMode' && self.modes.indexOf($scope.datepickerMode) > self.modes.indexOf(self[key]))) {
	          $scope.datepickerMode = self[key];
	        }
	      });
	    } else {
	      self[key] = datepickerConfig[key] || null;
	      $scope[key] = self[key];
	    }
	  });
	
	  $scope.datepickerMode = $scope.datepickerMode || datepickerConfig.datepickerMode;
	  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);
	
	  if (angular.isDefined($attrs.initDate)) {
	    this.activeDate = $scope.$parent.$eval($attrs.initDate) || new Date();
	    $scope.$parent.$watch($attrs.initDate, function(initDate) {
	      if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
	        self.activeDate = initDate;
	        self.refreshView();
	      }
	    });
	  } else {
	    this.activeDate = new Date();
	  }
	
	  $scope.isActive = function(dateObject) {
	    if (self.compare(dateObject.date, self.activeDate) === 0) {
	      $scope.activeDateId = dateObject.uid;
	      return true;
	    }
	    return false;
	  };
	
	  this.init = function(ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	
	    ngModelCtrl.$render = function() {
	      self.render();
	    };
	  };
	
	  this.render = function() {
	    if (ngModelCtrl.$viewValue) {
	      var date = new Date(ngModelCtrl.$viewValue),
	          isValid = !isNaN(date);
	
	      if (isValid) {
	        this.activeDate = date;
	      } else if (!$datepickerSuppressError) {
	        $log.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
	      }
	    }
	    this.refreshView();
	  };
	
	  this.refreshView = function() {
	    if (this.element) {
	      this._refreshView();
	
	      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	      ngModelCtrl.$setValidity('dateDisabled', !date || (this.element && !this.isDisabled(date)));
	    }
	  };
	
	  this.createDateObject = function(date, format) {
	    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	    return {
	      date: date,
	      label: dateFilter(date, format),
	      selected: model && this.compare(date, model) === 0,
	      disabled: this.isDisabled(date),
	      current: this.compare(date, new Date()) === 0,
	      customClass: this.customClass(date)
	    };
	  };
	
	  this.isDisabled = function(date) {
	    return ((this.minDate && this.compare(date, this.minDate) < 0) || (this.maxDate && this.compare(date, this.maxDate) > 0) || ($attrs.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode})));
	  };
	
	  this.customClass = function(date) {
	    return $scope.customClass({date: date, mode: $scope.datepickerMode});
	  };
	
	  // Split array into smaller arrays
	  this.split = function(arr, size) {
	    var arrays = [];
	    while (arr.length > 0) {
	      arrays.push(arr.splice(0, size));
	    }
	    return arrays;
	  };
	
	  $scope.select = function(date) {
	    if ($scope.datepickerMode === self.minMode) {
	      var dt = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : new Date(0, 0, 0, 0, 0, 0, 0);
	      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	      ngModelCtrl.$setViewValue(dt);
	      ngModelCtrl.$render();
	    } else {
	      self.activeDate = date;
	      $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) - 1];
	    }
	  };
	
	  $scope.move = function(direction) {
	    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
	        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
	    self.activeDate.setFullYear(year, month, 1);
	    self.refreshView();
	  };
	
	  $scope.toggleMode = function(direction) {
	    direction = direction || 1;
	
	    if (($scope.datepickerMode === self.maxMode && direction === 1) || ($scope.datepickerMode === self.minMode && direction === -1)) {
	      return;
	    }
	
	    $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) + direction];
	  };
	
	  // Key event mapper
	  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };
	
	  var focusElement = function() {
	    self.element[0].focus();
	  };
	
	  // Listen for focus requests from popup directive
	  $scope.$on('uib:datepicker.focus', focusElement);
	
	  $scope.keydown = function(evt) {
	    var key = $scope.keys[evt.which];
	
	    if (!key || evt.shiftKey || evt.altKey) {
	      return;
	    }
	
	    evt.preventDefault();
	    if (!self.shortcutPropagation) {
	      evt.stopPropagation();
	    }
	
	    if (key === 'enter' || key === 'space') {
	      if (self.isDisabled(self.activeDate)) {
	        return; // do nothing
	      }
	      $scope.select(self.activeDate);
	    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
	      $scope.toggleMode(key === 'up' ? 1 : -1);
	    } else {
	      self.handleKeyDown(key, evt);
	      self.refreshView();
	    }
	  };
	}])
	
	.controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
	  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	  this.step = { months: 1 };
	  this.element = $element;
	  function getDaysInMonth(year, month) {
	    return ((month === 1) && (year % 4 === 0) && ((year % 100 !== 0) || (year % 400 === 0))) ? 29 : DAYS_IN_MONTH[month];
	  }
	
	  this.init = function(ctrl) {
	    angular.extend(ctrl, this);
	    scope.showWeeks = ctrl.showWeeks;
	    ctrl.refreshView();
	  };
	
	  this.getDates = function(startDate, n) {
	    var dates = new Array(n), current = new Date(startDate), i = 0, date;
	    while (i < n) {
	      date = new Date(current);
	      dates[i++] = date;
	      current.setDate(current.getDate() + 1);
	    }
	    return dates;
	  };
	
	  this._refreshView = function() {
	    var year = this.activeDate.getFullYear(),
	      month = this.activeDate.getMonth(),
	      firstDayOfMonth = new Date(this.activeDate);
	
	    firstDayOfMonth.setFullYear(year, month, 1);
	
	    var difference = this.startingDay - firstDayOfMonth.getDay(),
	      numDisplayedFromPreviousMonth = (difference > 0) ? 7 - difference : - difference,
	      firstDate = new Date(firstDayOfMonth);
	
	    if (numDisplayedFromPreviousMonth > 0) {
	      firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
	    }
	
	    // 42 is the number of days on a six-month calendar
	    var days = this.getDates(firstDate, 42);
	    for (var i = 0; i < 42; i ++) {
	      days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
	        secondary: days[i].getMonth() !== month,
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.labels = new Array(7);
	    for (var j = 0; j < 7; j++) {
	      scope.labels[j] = {
	        abbr: dateFilter(days[j].date, this.formatDayHeader),
	        full: dateFilter(days[j].date, 'EEEE')
	      };
	    }
	
	    scope.title = dateFilter(this.activeDate, this.formatDayTitle);
	    scope.rows = this.split(days, 7);
	
	    if (scope.showWeeks) {
	      scope.weekNumbers = [];
	      var thursdayIndex = (4 + 7 - this.startingDay) % 7,
	          numWeeks = scope.rows.length;
	      for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
	        scope.weekNumbers.push(
	          getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
	      }
	    }
	  };
	
	  this.compare = function(date1, date2) {
	    return (new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate()));
	  };
	
	  function getISO8601WeekNumber(date) {
	    var checkDate = new Date(date);
	    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
	    var time = checkDate.getTime();
	    checkDate.setMonth(0); // Compare with Jan 1
	    checkDate.setDate(1);
	    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
	  }
	
	  this.handleKeyDown = function(key, evt) {
	    var date = this.activeDate.getDate();
	
	    if (key === 'left') {
	      date = date - 1;   // up
	    } else if (key === 'up') {
	      date = date - 7;   // down
	    } else if (key === 'right') {
	      date = date + 1;   // down
	    } else if (key === 'down') {
	      date = date + 7;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      var month = this.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
	      this.activeDate.setMonth(month, 1);
	      date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
	    } else if (key === 'home') {
	      date = 1;
	    } else if (key === 'end') {
	      date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
	    }
	    this.activeDate.setDate(date);
	  };
	}])
	
	.controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
	  this.step = { years: 1 };
	  this.element = $element;
	
	  this.init = function(ctrl) {
	    angular.extend(ctrl, this);
	    ctrl.refreshView();
	  };
	
	  this._refreshView = function() {
	    var months = new Array(12),
	        year = this.activeDate.getFullYear(),
	        date;
	
	    for (var i = 0; i < 12; i++) {
	      date = new Date(this.activeDate);
	      date.setFullYear(year, i, 1);
	      months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
	    scope.rows = this.split(months, 3);
	  };
	
	  this.compare = function(date1, date2) {
	    return new Date(date1.getFullYear(), date1.getMonth()) - new Date(date2.getFullYear(), date2.getMonth());
	  };
	
	  this.handleKeyDown = function(key, evt) {
	    var date = this.activeDate.getMonth();
	
	    if (key === 'left') {
	      date = date - 1;   // up
	    } else if (key === 'up') {
	      date = date - 3;   // down
	    } else if (key === 'right') {
	      date = date + 1;   // down
	    } else if (key === 'down') {
	      date = date + 3;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      var year = this.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
	      this.activeDate.setFullYear(year);
	    } else if (key === 'home') {
	      date = 0;
	    } else if (key === 'end') {
	      date = 11;
	    }
	    this.activeDate.setMonth(date);
	  };
	}])
	
	.controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
	  var range;
	  this.element = $element;
	
	  function getStartingYear(year) {
	    return parseInt((year - 1) / range, 10) * range + 1;
	  }
	
	  this.yearpickerInit = function() {
	    range = this.yearRange;
	    this.step = { years: range };
	  };
	
	  this._refreshView = function() {
	    var years = new Array(range), date;
	
	    for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
	      date = new Date(this.activeDate);
	      date.setFullYear(start + i, 0, 1);
	      years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.title = [years[0].label, years[range - 1].label].join(' - ');
	    scope.rows = this.split(years, 5);
	  };
	
	  this.compare = function(date1, date2) {
	    return date1.getFullYear() - date2.getFullYear();
	  };
	
	  this.handleKeyDown = function(key, evt) {
	    var date = this.activeDate.getFullYear();
	
	    if (key === 'left') {
	      date = date - 1;   // up
	    } else if (key === 'up') {
	      date = date - 5;   // down
	    } else if (key === 'right') {
	      date = date + 1;   // down
	    } else if (key === 'down') {
	      date = date + 5;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      date += (key === 'pageup' ? - 1 : 1) * this.step.years;
	    } else if (key === 'home') {
	      date = getStartingYear(this.activeDate.getFullYear());
	    } else if (key === 'end') {
	      date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
	    }
	    this.activeDate.setFullYear(date);
	  };
	}])
	
	.directive('uibDatepicker', function() {
	  return {
	    replace: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/datepicker/datepicker.html';
	    },
	    scope: {
	      datepickerMode: '=?',
	      dateDisabled: '&',
	      customClass: '&',
	      shortcutPropagation: '&?'
	    },
	    require: ['uibDatepicker', '^ngModel'],
	    controller: 'UibDatepickerController',
	    controllerAs: 'datepicker',
	    link: function(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      datepickerCtrl.init(ngModelCtrl);
	    }
	  };
	})
	
	.directive('uibDaypicker', function() {
	  return {
	    replace: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/datepicker/day.html';
	    },
	    require: ['^?uibDatepicker', 'uibDaypicker', '^?datepicker'],
	    controller: 'UibDaypickerController',
	    link: function(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0] || ctrls[2],
	        daypickerCtrl = ctrls[1];
	
	      daypickerCtrl.init(datepickerCtrl);
	    }
	  };
	})
	
	.directive('uibMonthpicker', function() {
	  return {
	    replace: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/datepicker/month.html';
	    },
	    require: ['^?uibDatepicker', 'uibMonthpicker', '^?datepicker'],
	    controller: 'UibMonthpickerController',
	    link: function(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0] || ctrls[2],
	        monthpickerCtrl = ctrls[1];
	
	      monthpickerCtrl.init(datepickerCtrl);
	    }
	  };
	})
	
	.directive('uibYearpicker', function() {
	  return {
	    replace: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/datepicker/year.html';
	    },
	    require: ['^?uibDatepicker', 'uibYearpicker', '^?datepicker'],
	    controller: 'UibYearpickerController',
	    link: function(scope, element, attrs, ctrls) {
	      var ctrl = ctrls[0] || ctrls[2];
	      angular.extend(ctrl, ctrls[1]);
	      ctrl.yearpickerInit();
	
	      ctrl.refreshView();
	    }
	  };
	})
	
	.constant('uibDatepickerPopupConfig', {
	  datepickerPopup: 'yyyy-MM-dd',
	  datepickerPopupTemplateUrl: 'template/datepicker/popup.html',
	  datepickerTemplateUrl: 'template/datepicker/datepicker.html',
	  html5Types: {
	    date: 'yyyy-MM-dd',
	    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
	    'month': 'yyyy-MM'
	  },
	  currentText: 'Today',
	  clearText: 'Clear',
	  closeText: 'Done',
	  closeOnDateSelection: true,
	  appendToBody: false,
	  showButtonBar: true,
	  onOpenFocus: true
	})
	
	.controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout',
	function(scope, element, attrs, $compile, $parse, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout) {
	  var self = this;
	  var cache = {},
	    isHtml5DateInput = false;
	  var dateFormat, closeOnDateSelection, appendToBody, onOpenFocus,
	    datepickerPopupTemplateUrl, datepickerTemplateUrl, popupEl, datepickerEl,
	    ngModel, $popup;
	
	  scope.watchData = {};
	
	  this.init = function(_ngModel_) {
	    ngModel = _ngModel_;
	    closeOnDateSelection = angular.isDefined(attrs.closeOnDateSelection) ? scope.$parent.$eval(attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection;
	    appendToBody = angular.isDefined(attrs.datepickerAppendToBody) ? scope.$parent.$eval(attrs.datepickerAppendToBody) : datepickerPopupConfig.appendToBody;
	    onOpenFocus = angular.isDefined(attrs.onOpenFocus) ? scope.$parent.$eval(attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
	    datepickerPopupTemplateUrl = angular.isDefined(attrs.datepickerPopupTemplateUrl) ? attrs.datepickerPopupTemplateUrl : datepickerPopupConfig.datepickerPopupTemplateUrl;
	    datepickerTemplateUrl = angular.isDefined(attrs.datepickerTemplateUrl) ? attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
	
	    scope.showButtonBar = angular.isDefined(attrs.showButtonBar) ? scope.$parent.$eval(attrs.showButtonBar) : datepickerPopupConfig.showButtonBar;
	
	    if (datepickerPopupConfig.html5Types[attrs.type]) {
	      dateFormat = datepickerPopupConfig.html5Types[attrs.type];
	      isHtml5DateInput = true;
	    } else {
	      dateFormat = attrs.datepickerPopup || attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
	      attrs.$observe('uibDatepickerPopup', function(value, oldValue) {
	          var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
	          // Invalidate the $modelValue to ensure that formatters re-run
	          // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
	          if (newDateFormat !== dateFormat) {
	            dateFormat = newDateFormat;
	            ngModel.$modelValue = null;
	
	            if (!dateFormat) {
	              throw new Error('uibDatepickerPopup must have a date format specified.');
	            }
	          }
	      });
	    }
	
	    if (!dateFormat) {
	      throw new Error('uibDatepickerPopup must have a date format specified.');
	    }
	
	    if (isHtml5DateInput && attrs.datepickerPopup) {
	      throw new Error('HTML5 date input types do not support custom formats.');
	    }
	
	    // popup element used to display calendar
	    popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');
	    popupEl.attr({
	      'ng-model': 'date',
	      'ng-change': 'dateSelection(date)',
	      'template-url': datepickerPopupTemplateUrl
	    });
	
	    // datepicker element
	    datepickerEl = angular.element(popupEl.children()[0]);
	    datepickerEl.attr('template-url', datepickerTemplateUrl);
	
	    if (isHtml5DateInput) {
	      if (attrs.type === 'month') {
	        datepickerEl.attr('datepicker-mode', '"month"');
	        datepickerEl.attr('min-mode', 'month');
	      }
	    }
	
	    if (attrs.datepickerOptions) {
	      var options = scope.$parent.$eval(attrs.datepickerOptions);
	      if (options && options.initDate) {
	        scope.initDate = options.initDate;
	        datepickerEl.attr('init-date', 'initDate');
	        delete options.initDate;
	      }
	      angular.forEach(options, function(value, option) {
	        datepickerEl.attr(cameltoDash(option), value);
	      });
	    }
	
	    angular.forEach(['minMode', 'maxMode', 'minDate', 'maxDate', 'datepickerMode', 'initDate', 'shortcutPropagation'], function(key) {
	      if (attrs[key]) {
	        var getAttribute = $parse(attrs[key]);
	        scope.$parent.$watch(getAttribute, function(value) {
	          scope.watchData[key] = value;
	          if (key === 'minDate' || key === 'maxDate') {
	            cache[key] = new Date(value);
	          }
	        });
	        datepickerEl.attr(cameltoDash(key), 'watchData.' + key);
	
	        // Propagate changes from datepicker to outside
	        if (key === 'datepickerMode') {
	          var setAttribute = getAttribute.assign;
	          scope.$watch('watchData.' + key, function(value, oldvalue) {
	            if (angular.isFunction(setAttribute) && value !== oldvalue) {
	              setAttribute(scope.$parent, value);
	            }
	          });
	        }
	      }
	    });
	    if (attrs.dateDisabled) {
	      datepickerEl.attr('date-disabled', 'dateDisabled({ date: date, mode: mode })');
	    }
	
	    if (attrs.showWeeks) {
	      datepickerEl.attr('show-weeks', attrs.showWeeks);
	    }
	
	    if (attrs.customClass) {
	      datepickerEl.attr('custom-class', 'customClass({ date: date, mode: mode })');
	    }
	
	    if (!isHtml5DateInput) {
	      // Internal API to maintain the correct ng-invalid-[key] class
	      ngModel.$$parserName = 'date';
	      ngModel.$validators.date = validator;
	      ngModel.$parsers.unshift(parseDate);
	      ngModel.$formatters.push(function(value) {
	        scope.date = value;
	        return ngModel.$isEmpty(value) ? value : dateFilter(value, dateFormat);
	      });
	    } else {
	      ngModel.$formatters.push(function(value) {
	        scope.date = value;
	        return value;
	      });
	    }
	
	    // Detect changes in the view from the text box
	    ngModel.$viewChangeListeners.push(function() {
	      scope.date = dateParser.parse(ngModel.$viewValue, dateFormat, scope.date);
	    });
	
	    element.bind('keydown', inputKeydownBind);
	
	    $popup = $compile(popupEl)(scope);
	    // Prevent jQuery cache memory leak (template is now redundant after linking)
	    popupEl.remove();
	
	    if (appendToBody) {
	      $document.find('body').append($popup);
	    } else {
	      element.after($popup);
	    }
	
	    scope.$on('$destroy', function() {
	      if (scope.isOpen === true) {
	        if (!$rootScope.$$phase) {
	          scope.$apply(function() {
	            scope.isOpen = false;
	          });
	        }
	      }
	
	      $popup.remove();
	      element.unbind('keydown', inputKeydownBind);
	      $document.unbind('click', documentClickBind);
	    });
	  };
	
	  scope.getText = function(key) {
	    return scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
	  };
	
	  scope.isDisabled = function(date) {
	    if (date === 'today') {
	      date = new Date();
	    }
	
	    return ((scope.watchData.minDate && scope.compare(date, cache.minDate) < 0) ||
	      (scope.watchData.maxDate && scope.compare(date, cache.maxDate) > 0));
	  };
	
	  scope.compare = function(date1, date2) {
	    return (new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate()));
	  };
	
	  // Inner change
	  scope.dateSelection = function(dt) {
	    if (angular.isDefined(dt)) {
	      scope.date = dt;
	    }
	    var date = scope.date ? dateFilter(scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
	    element.val(date);
	    ngModel.$setViewValue(date);
	
	    if (closeOnDateSelection) {
	      scope.isOpen = false;
	      element[0].focus();
	    }
	  };
	
	  scope.keydown = function(evt) {
	    if (evt.which === 27) {
	      scope.isOpen = false;
	      element[0].focus();
	    }
	  };
	
	  scope.select = function(date) {
	    if (date === 'today') {
	      var today = new Date();
	      if (angular.isDate(scope.date)) {
	        date = new Date(scope.date);
	        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
	      } else {
	        date = new Date(today.setHours(0, 0, 0, 0));
	      }
	    }
	    scope.dateSelection(date);
	  };
	
	  scope.close = function() {
	    scope.isOpen = false;
	    element[0].focus();
	  };
	
	  scope.$watch('isOpen', function(value) {
	    if (value) {
	      scope.position = appendToBody ? $position.offset(element) : $position.position(element);
	      scope.position.top = scope.position.top + element.prop('offsetHeight');
	
	      $timeout(function() {
	        if (onOpenFocus) {
	          scope.$broadcast('uib:datepicker.focus');
	        }
	        $document.bind('click', documentClickBind);
	      }, 0, false);
	    } else {
	      $document.unbind('click', documentClickBind);
	    }
	  });
	
	  function cameltoDash(string) {
	    return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
	  }
	
	  function parseDate(viewValue) {
	    if (angular.isNumber(viewValue)) {
	      // presumably timestamp to date object
	      viewValue = new Date(viewValue);
	    }
	
	    if (!viewValue) {
	      return null;
	    } else if (angular.isDate(viewValue) && !isNaN(viewValue)) {
	      return viewValue;
	    } else if (angular.isString(viewValue)) {
	      var date = dateParser.parse(viewValue, dateFormat, scope.date);
	      if (isNaN(date)) {
	        return undefined;
	      } else {
	        return date;
	      }
	    } else {
	      return undefined;
	    }
	  }
	
	  function validator(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	
	    if (!attrs.ngRequired && !value) {
	      return true;
	    }
	
	    if (angular.isNumber(value)) {
	      value = new Date(value);
	    }
	    if (!value) {
	      return true;
	    } else if (angular.isDate(value) && !isNaN(value)) {
	      return true;
	    } else if (angular.isString(value)) {
	      var date = dateParser.parse(value, dateFormat);
	      return !isNaN(date);
	    } else {
	      return false;
	    }
	  }
	
	  function documentClickBind(event) {
	    var popup = $popup[0];
	    var dpContainsTarget = element[0].contains(event.target);
	    // The popup node may not be an element node
	    // In some browsers (IE) only element nodes have the 'contains' function
	    var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
	    if (scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
	      scope.$apply(function() {
	        scope.isOpen = false;
	      });
	    }
	  }
	
	  function inputKeydownBind(evt) {
	    if (evt.which === 27 && scope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      scope.$apply(function() {
	        scope.isOpen = false;
	      });
	      element[0].focus();
	    } else if (evt.which === 40 && !scope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      scope.$apply(function() {
	        scope.isOpen = true;
	      });
	    }
	  }
	}])
	
	.directive('uibDatepickerPopup', function() {
	  return {
	    require: ['ngModel', 'uibDatepickerPopup'],
	    controller: 'UibDatepickerPopupController',
	    scope: {
	      isOpen: '=?',
	      currentText: '@',
	      clearText: '@',
	      closeText: '@',
	      dateDisabled: '&',
	      customClass: '&'
	    },
	    link: function(scope, element, attrs, ctrls) {
	      var ngModel = ctrls[0],
	        ctrl = ctrls[1];
	
	      ctrl.init(ngModel);
	    }
	  };
	})
	
	.directive('uibDatepickerPopupWrap', function() {
	  return {
	    replace: true,
	    transclude: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/datepicker/popup.html';
	    }
	  };
	});
	
	/* Deprecated datepicker below */
	
	angular.module('ui.bootstrap.datepicker')
	
	.value('$datepickerSuppressWarning', false)
	
	.controller('DatepickerController', ['$scope', '$attrs', '$parse', '$interpolate', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerSuppressError', '$datepickerSuppressWarning', function($scope, $attrs, $parse, $interpolate, $log, dateFilter, datepickerConfig, $datepickerSuppressError, $datepickerSuppressWarning) {
	  if (!$datepickerSuppressWarning) {
	    $log.warn('DatepickerController is now deprecated. Use UibDatepickerController instead.');
	  }
	
	  var self = this,
	    ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl;
	
	  this.modes = ['day', 'month', 'year'];
	
	  angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle',
	    'showWeeks', 'startingDay', 'yearRange', 'shortcutPropagation'], function(key, index) {
	    self[key] = angular.isDefined($attrs[key]) ? (index < 6 ? $interpolate($attrs[key])($scope.$parent) : $scope.$parent.$eval($attrs[key])) : datepickerConfig[key];
	  });
	
	  angular.forEach(['minDate', 'maxDate'], function(key) {
	    if ($attrs[key]) {
	      $scope.$parent.$watch($parse($attrs[key]), function(value) {
	        self[key] = value ? new Date(value) : null;
	        self.refreshView();
	      });
	    } else {
	      self[key] = datepickerConfig[key] ? new Date(datepickerConfig[key]) : null;
	    }
	  });
	
	  angular.forEach(['minMode', 'maxMode'], function(key) {
	    if ($attrs[key]) {
	      $scope.$parent.$watch($parse($attrs[key]), function(value) {
	        self[key] = angular.isDefined(value) ? value : $attrs[key];
	        $scope[key] = self[key];
	        if ((key == 'minMode' && self.modes.indexOf($scope.datepickerMode) < self.modes.indexOf(self[key])) || (key == 'maxMode' && self.modes.indexOf($scope.datepickerMode) > self.modes.indexOf(self[key]))) {
	          $scope.datepickerMode = self[key];
	        }
	      });
	    } else {
	      self[key] = datepickerConfig[key] || null;
	      $scope[key] = self[key];
	    }
	  });
	
	  $scope.datepickerMode = $scope.datepickerMode || datepickerConfig.datepickerMode;
	  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);
	
	  if (angular.isDefined($attrs.initDate)) {
	    this.activeDate = $scope.$parent.$eval($attrs.initDate) || new Date();
	    $scope.$parent.$watch($attrs.initDate, function(initDate) {
	      if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
	        self.activeDate = initDate;
	        self.refreshView();
	      }
	    });
	  } else {
	    this.activeDate = new Date();
	  }
	
	  $scope.isActive = function(dateObject) {
	    if (self.compare(dateObject.date, self.activeDate) === 0) {
	      $scope.activeDateId = dateObject.uid;
	      return true;
	    }
	    return false;
	  };
	
	  this.init = function(ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	
	    ngModelCtrl.$render = function() {
	      self.render();
	    };
	  };
	
	  this.render = function() {
	    if (ngModelCtrl.$viewValue) {
	      var date = new Date(ngModelCtrl.$viewValue),
	        isValid = !isNaN(date);
	
	      if (isValid) {
	        this.activeDate = date;
	      } else if (!$datepickerSuppressError) {
	        $log.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
	      }
	    }
	    this.refreshView();
	  };
	
	  this.refreshView = function() {
	    if (this.element) {
	      this._refreshView();
	
	      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	      ngModelCtrl.$setValidity('dateDisabled', !date || (this.element && !this.isDisabled(date)));
	    }
	  };
	
	  this.createDateObject = function(date, format) {
	    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	    return {
	      date: date,
	      label: dateFilter(date, format),
	      selected: model && this.compare(date, model) === 0,
	      disabled: this.isDisabled(date),
	      current: this.compare(date, new Date()) === 0,
	      customClass: this.customClass(date)
	    };
	  };
	
	  this.isDisabled = function(date) {
	    return ((this.minDate && this.compare(date, this.minDate) < 0) || (this.maxDate && this.compare(date, this.maxDate) > 0) || ($attrs.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode})));
	  };
	
	  this.customClass = function(date) {
	    return $scope.customClass({date: date, mode: $scope.datepickerMode});
	  };
	
	  // Split array into smaller arrays
	  this.split = function(arr, size) {
	    var arrays = [];
	    while (arr.length > 0) {
	      arrays.push(arr.splice(0, size));
	    }
	    return arrays;
	  };
	
	  this.fixTimeZone = function(date) {
	    var hours = date.getHours();
	    date.setHours(hours === 23 ? hours + 2 : 0);
	  };
	
	  $scope.select = function(date) {
	    if ($scope.datepickerMode === self.minMode) {
	      var dt = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : new Date(0, 0, 0, 0, 0, 0, 0);
	      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	      ngModelCtrl.$setViewValue(dt);
	      ngModelCtrl.$render();
	    } else {
	      self.activeDate = date;
	      $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) - 1];
	    }
	  };
	
	  $scope.move = function(direction) {
	    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
	      month = self.activeDate.getMonth() + direction * (self.step.months || 0);
	    self.activeDate.setFullYear(year, month, 1);
	    self.refreshView();
	  };
	
	  $scope.toggleMode = function(direction) {
	    direction = direction || 1;
	
	    if (($scope.datepickerMode === self.maxMode && direction === 1) || ($scope.datepickerMode === self.minMode && direction === -1)) {
	      return;
	    }
	
	    $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) + direction];
	  };
	
	  // Key event mapper
	  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };
	
	  var focusElement = function() {
	    self.element[0].focus();
	  };
	
	  $scope.$on('uib:datepicker.focus', focusElement);
	
	  $scope.keydown = function(evt) {
	    var key = $scope.keys[evt.which];
	
	    if (!key || evt.shiftKey || evt.altKey) {
	      return;
	    }
	
	    evt.preventDefault();
	    if (!self.shortcutPropagation) {
	      evt.stopPropagation();
	    }
	
	    if (key === 'enter' || key === 'space') {
	      if (self.isDisabled(self.activeDate)) {
	        return; // do nothing
	      }
	      $scope.select(self.activeDate);
	    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
	      $scope.toggleMode(key === 'up' ? 1 : -1);
	    } else {
	      self.handleKeyDown(key, evt);
	      self.refreshView();
	    }
	  };
	}])
	
	.directive('datepicker', ['$log', '$datepickerSuppressWarning', function($log, $datepickerSuppressWarning) {
	  return {
	    replace: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/datepicker/datepicker.html';
	    },
	    scope: {
	      datepickerMode: '=?',
	      dateDisabled: '&',
	      customClass: '&',
	      shortcutPropagation: '&?'
	    },
	    require: ['datepicker', '^ngModel'],
	    controller: 'DatepickerController',
	    controllerAs: 'datepicker',
	    link: function(scope, element, attrs, ctrls) {
	      if (!$datepickerSuppressWarning) {
	        $log.warn('datepicker is now deprecated. Use uib-datepicker instead.');
	      }
	
	      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      datepickerCtrl.init(ngModelCtrl);
	    }
	  };
	}])
	
	.directive('daypicker', ['$log', '$datepickerSuppressWarning', function($log, $datepickerSuppressWarning) {
	  return {
	    replace: true,
	    templateUrl: 'template/datepicker/day.html',
	    require: ['^datepicker', 'daypicker'],
	    controller: 'UibDaypickerController',
	    link: function(scope, element, attrs, ctrls) {
	      if (!$datepickerSuppressWarning) {
	        $log.warn('daypicker is now deprecated. Use uib-daypicker instead.');
	      }
	
	      var datepickerCtrl = ctrls[0],
	        daypickerCtrl = ctrls[1];
	
	      daypickerCtrl.init(datepickerCtrl);
	    }
	  };
	}])
	
	.directive('monthpicker', ['$log', '$datepickerSuppressWarning', function($log, $datepickerSuppressWarning) {
	  return {
	    replace: true,
	    templateUrl: 'template/datepicker/month.html',
	    require: ['^datepicker', 'monthpicker'],
	    controller: 'UibMonthpickerController',
	    link: function(scope, element, attrs, ctrls) {
	      if (!$datepickerSuppressWarning) {
	        $log.warn('monthpicker is now deprecated. Use uib-monthpicker instead.');
	      }
	
	      var datepickerCtrl = ctrls[0],
	        monthpickerCtrl = ctrls[1];
	
	      monthpickerCtrl.init(datepickerCtrl);
	    }
	  };
	}])
	
	.directive('yearpicker', ['$log', '$datepickerSuppressWarning', function($log, $datepickerSuppressWarning) {
	  return {
	    replace: true,
	    templateUrl: 'template/datepicker/year.html',
	    require: ['^datepicker', 'yearpicker'],
	    controller: 'UibYearpickerController',
	    link: function(scope, element, attrs, ctrls) {
	      if (!$datepickerSuppressWarning) {
	        $log.warn('yearpicker is now deprecated. Use uib-yearpicker instead.');
	      }
	
	      var ctrl = ctrls[0];
	      angular.extend(ctrl, ctrls[1]);
	      ctrl.yearpickerInit();
	
	      ctrl.refreshView();
	    }
	  };
	}])
	
	.directive('datepickerPopup', ['$log', '$datepickerSuppressWarning', function($log, $datepickerSuppressWarning) {
	  return {
	    require: ['ngModel', 'datepickerPopup'],
	    controller: 'UibDatepickerPopupController',
	    scope: {
	      isOpen: '=?',
	      currentText: '@',
	      clearText: '@',
	      closeText: '@',
	      dateDisabled: '&',
	      customClass: '&'
	    },
	    link: function(scope, element, attrs, ctrls) {
	      if (!$datepickerSuppressWarning) {
	        $log.warn('datepicker-popup is now deprecated. Use uib-datepicker-popup instead.');
	      }
	
	      var ngModel = ctrls[0],
	        ctrl = ctrls[1];
	
	      ctrl.init(ngModel);
	    }
	  };
	}])
	
	.directive('datepickerPopupWrap', ['$log', '$datepickerSuppressWarning', function($log, $datepickerSuppressWarning) {
	  return {
	    replace: true,
	    transclude: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/datepicker/popup.html';
	    },
	    link: function() {
	      if (!$datepickerSuppressWarning) {
	        $log.warn('datepicker-popup-wrap is now deprecated. Use uib-datepicker-popup-wrap instead.');
	      }
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.position'])
	
	.constant('uibDropdownConfig', {
	  openClass: 'open'
	})
	
	.service('uibDropdownService', ['$document', '$rootScope', function($document, $rootScope) {
	  var openScope = null;
	
	  this.open = function(dropdownScope) {
	    if (!openScope) {
	      $document.bind('click', closeDropdown);
	      $document.bind('keydown', keybindFilter);
	    }
	
	    if (openScope && openScope !== dropdownScope) {
	      openScope.isOpen = false;
	    }
	
	    openScope = dropdownScope;
	  };
	
	  this.close = function(dropdownScope) {
	    if (openScope === dropdownScope) {
	      openScope = null;
	      $document.unbind('click', closeDropdown);
	      $document.unbind('keydown', keybindFilter);
	    }
	  };
	
	  var closeDropdown = function(evt) {
	    // This method may still be called during the same mouse event that
	    // unbound this event handler. So check openScope before proceeding.
	    if (!openScope) { return; }
	
	    if (evt && openScope.getAutoClose() === 'disabled')  { return ; }
	
	    var toggleElement = openScope.getToggleElement();
	    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
	      return;
	    }
	
	    var dropdownElement = openScope.getDropdownElement();
	    if (evt && openScope.getAutoClose() === 'outsideClick' &&
	      dropdownElement && dropdownElement[0].contains(evt.target)) {
	      return;
	    }
	
	    openScope.isOpen = false;
	
	    if (!$rootScope.$$phase) {
	      openScope.$apply();
	    }
	  };
	
	  var keybindFilter = function(evt) {
	    if (evt.which === 27) {
	      openScope.focusToggleElement();
	      closeDropdown();
	    } else if (openScope.isKeynavEnabled() && /(38|40)/.test(evt.which) && openScope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      openScope.focusDropdownEntry(evt.which);
	    }
	  };
	}])
	
	.controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
	  var self = this,
	    scope = $scope.$new(), // create a child scope so we are not polluting original one
	    templateScope,
	    openClass = dropdownConfig.openClass,
	    getIsOpen,
	    setIsOpen = angular.noop,
	    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
	    appendToBody = false,
	    keynavEnabled =false,
	    selectedOption = null;
	
	
	  $element.addClass('dropdown');
	
	  this.init = function() {
	    if ($attrs.isOpen) {
	      getIsOpen = $parse($attrs.isOpen);
	      setIsOpen = getIsOpen.assign;
	
	      $scope.$watch(getIsOpen, function(value) {
	        scope.isOpen = !!value;
	      });
	    }
	
	    appendToBody = angular.isDefined($attrs.dropdownAppendToBody);
	    keynavEnabled = angular.isDefined($attrs.uibKeyboardNav);
	
	    if (appendToBody && self.dropdownMenu) {
	      $document.find('body').append(self.dropdownMenu);
	      $element.on('$destroy', function handleDestroyEvent() {
	        self.dropdownMenu.remove();
	      });
	    }
	  };
	
	  this.toggle = function(open) {
	    return scope.isOpen = arguments.length ? !!open : !scope.isOpen;
	  };
	
	  // Allow other directives to watch status
	  this.isOpen = function() {
	    return scope.isOpen;
	  };
	
	  scope.getToggleElement = function() {
	    return self.toggleElement;
	  };
	
	  scope.getAutoClose = function() {
	    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
	  };
	
	  scope.getElement = function() {
	    return $element;
	  };
	
	  scope.isKeynavEnabled = function() {
	    return keynavEnabled;
	  };
	
	  scope.focusDropdownEntry = function(keyCode) {
	    var elems = self.dropdownMenu ? //If append to body is used.
	      (angular.element(self.dropdownMenu).find('a')) :
	      (angular.element($element).find('ul').eq(0).find('a'));
	
	    switch (keyCode) {
	      case (40): {
	        if (!angular.isNumber(self.selectedOption)) {
	          self.selectedOption = 0;
	        } else {
	          self.selectedOption = (self.selectedOption === elems.length - 1 ?
	            self.selectedOption :
	            self.selectedOption + 1);
	        }
	        break;
	      }
	      case (38): {
	        if (!angular.isNumber(self.selectedOption)) {
	          self.selectedOption = elems.length - 1;
	        } else {
	          self.selectedOption = self.selectedOption === 0 ?
	            0 : self.selectedOption - 1;
	        }
	        break;
	      }
	    }
	    elems[self.selectedOption].focus();
	  };
	
	  scope.getDropdownElement = function() {
	    return self.dropdownMenu;
	  };
	
	  scope.focusToggleElement = function() {
	    if (self.toggleElement) {
	      self.toggleElement[0].focus();
	    }
	  };
	
	  scope.$watch('isOpen', function(isOpen, wasOpen) {
	    if (appendToBody && self.dropdownMenu) {
	      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true);
	      var css = {
	        top: pos.top + 'px',
	        display: isOpen ? 'block' : 'none'
	      };
	
	      var rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
	      if (!rightalign) {
	        css.left = pos.left + 'px';
	        css.right = 'auto';
	      } else {
	        css.left = 'auto';
	        css.right = (window.innerWidth - (pos.left + $element.prop('offsetWidth'))) + 'px';
	      }
	
	      self.dropdownMenu.css(css);
	    }
	
	    $animate[isOpen ? 'addClass' : 'removeClass']($element, openClass).then(function() {
	      if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
	        toggleInvoker($scope, { open: !!isOpen });
	      }
	    });
	
	    if (isOpen) {
	      if (self.dropdownMenuTemplateUrl) {
	        $templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent) {
	          templateScope = scope.$new();
	          $compile(tplContent.trim())(templateScope, function(dropdownElement) {
	            var newEl = dropdownElement;
	            self.dropdownMenu.replaceWith(newEl);
	            self.dropdownMenu = newEl;
	          });
	        });
	      }
	
	      scope.focusToggleElement();
	      uibDropdownService.open(scope);
	    } else {
	      if (self.dropdownMenuTemplateUrl) {
	        if (templateScope) {
	          templateScope.$destroy();
	        }
	        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
	        self.dropdownMenu.replaceWith(newEl);
	        self.dropdownMenu = newEl;
	      }
	
	      uibDropdownService.close(scope);
	      self.selectedOption = null;
	    }
	
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen($scope, isOpen);
	    }
	  });
	
	  $scope.$on('$locationChangeSuccess', function() {
	    if (scope.getAutoClose() !== 'disabled') {
	      scope.isOpen = false;
	    }
	  });
	
	  var offDestroy = $scope.$on('$destroy', function() {
	    scope.$destroy();
	  });
	  scope.$on('$destroy', offDestroy);
	}])
	
	.directive('uibDropdown', function() {
	  return {
	    controller: 'UibDropdownController',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      dropdownCtrl.init();
	    }
	  };
	})
	
	.directive('uibDropdownMenu', function() {
	  return {
	    restrict: 'AC',
	    require: '?^uibDropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
	        return;
	      }
	
	      element.addClass('dropdown-menu');
	
	      var tplUrl = attrs.templateUrl;
	      if (tplUrl) {
	        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
	      }
	
	      if (!dropdownCtrl.dropdownMenu) {
	        dropdownCtrl.dropdownMenu = element;
	      }
	    }
	  };
	})
	
	.directive('uibKeyboardNav', function() {
	  return {
	    restrict: 'A',
	    require: '?^uibDropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      element.bind('keydown', function(e) {
	        if ([38, 40].indexOf(e.which) !== -1) {
	          e.preventDefault();
	          e.stopPropagation();
	
	          var elems = dropdownCtrl.dropdownMenu.find('a');
	
	          switch (e.which) {
	            case (40): { // Down
	              if (!angular.isNumber(dropdownCtrl.selectedOption)) {
	                dropdownCtrl.selectedOption = 0;
	              } else {
	                dropdownCtrl.selectedOption = dropdownCtrl.selectedOption === elems.length -1 ?
	                  dropdownCtrl.selectedOption : dropdownCtrl.selectedOption + 1;
	              }
	              break;
	            }
	            case (38): { // Up
	              if (!angular.isNumber(dropdownCtrl.selectedOption)) {
	                dropdownCtrl.selectedOption = elems.length - 1;
	              } else {
	                dropdownCtrl.selectedOption = dropdownCtrl.selectedOption === 0 ?
	                  0 : dropdownCtrl.selectedOption - 1;
	              }
	              break;
	            }
	          }
	          elems[dropdownCtrl.selectedOption].focus();
	        }
	      });
	    }
	  };
	})
	
	.directive('uibDropdownToggle', function() {
	  return {
	    require: '?^uibDropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl) {
	        return;
	      }
	
	      element.addClass('dropdown-toggle');
	
	      dropdownCtrl.toggleElement = element;
	
	      var toggleDropdown = function(event) {
	        event.preventDefault();
	
	        if (!element.hasClass('disabled') && !attrs.disabled) {
	          scope.$apply(function() {
	            dropdownCtrl.toggle();
	          });
	        }
	      };
	
	      element.bind('click', toggleDropdown);
	
	      // WAI-ARIA
	      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
	      scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
	        element.attr('aria-expanded', !!isOpen);
	      });
	
	      scope.$on('$destroy', function() {
	        element.unbind('click', toggleDropdown);
	      });
	    }
	  };
	});
	
	/* Deprecated dropdown below */
	
	angular.module('ui.bootstrap.dropdown')
	
	.value('$dropdownSuppressWarning', false)
	
	.service('dropdownService', ['$log', '$dropdownSuppressWarning', 'uibDropdownService', function($log, $dropdownSuppressWarning, uibDropdownService) {
	  if (!$dropdownSuppressWarning) {
	    $log.warn('dropdownService is now deprecated. Use uibDropdownService instead.');
	  }
	
	  angular.extend(this, uibDropdownService);
	}])
	
	.controller('DropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', '$log', '$dropdownSuppressWarning', function($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest, $log, $dropdownSuppressWarning) {
	  if (!$dropdownSuppressWarning) {
	    $log.warn('DropdownController is now deprecated. Use UibDropdownController instead.');
	  }
	
	  var self = this,
	    scope = $scope.$new(), // create a child scope so we are not polluting original one
	    templateScope,
	    openClass = dropdownConfig.openClass,
	    getIsOpen,
	    setIsOpen = angular.noop,
	    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
	    appendToBody = false,
	    keynavEnabled =false,
	    selectedOption = null;
	
	
	  $element.addClass('dropdown');
	
	  this.init = function() {
	    if ($attrs.isOpen) {
	      getIsOpen = $parse($attrs.isOpen);
	      setIsOpen = getIsOpen.assign;
	
	      $scope.$watch(getIsOpen, function(value) {
	        scope.isOpen = !!value;
	      });
	    }
	
	    appendToBody = angular.isDefined($attrs.dropdownAppendToBody);
	    keynavEnabled = angular.isDefined($attrs.uibKeyboardNav);
	
	    if (appendToBody && self.dropdownMenu) {
	      $document.find('body').append(self.dropdownMenu);
	      $element.on('$destroy', function handleDestroyEvent() {
	        self.dropdownMenu.remove();
	      });
	    }
	  };
	
	  this.toggle = function(open) {
	    return scope.isOpen = arguments.length ? !!open : !scope.isOpen;
	  };
	
	  // Allow other directives to watch status
	  this.isOpen = function() {
	    return scope.isOpen;
	  };
	
	  scope.getToggleElement = function() {
	    return self.toggleElement;
	  };
	
	  scope.getAutoClose = function() {
	    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
	  };
	
	  scope.getElement = function() {
	    return $element;
	  };
	
	  scope.isKeynavEnabled = function() {
	    return keynavEnabled;
	  };
	
	  scope.focusDropdownEntry = function(keyCode) {
	    var elems = self.dropdownMenu ? //If append to body is used.
	      (angular.element(self.dropdownMenu).find('a')) :
	      (angular.element($element).find('ul').eq(0).find('a'));
	
	    switch (keyCode) {
	      case (40): {
	        if (!angular.isNumber(self.selectedOption)) {
	          self.selectedOption = 0;
	        } else {
	          self.selectedOption = (self.selectedOption === elems.length -1 ?
	            self.selectedOption :
	          self.selectedOption + 1);
	        }
	        break;
	      }
	      case (38): {
	        if (!angular.isNumber(self.selectedOption)) {
	          self.selectedOption = elems.length - 1;
	        } else {
	          self.selectedOption = self.selectedOption === 0 ?
	            0 : self.selectedOption - 1;
	        }
	        break;
	      }
	    }
	    elems[self.selectedOption].focus();
	  };
	
	  scope.getDropdownElement = function() {
	    return self.dropdownMenu;
	  };
	
	  scope.focusToggleElement = function() {
	    if (self.toggleElement) {
	      self.toggleElement[0].focus();
	    }
	  };
	
	  scope.$watch('isOpen', function(isOpen, wasOpen) {
	    if (appendToBody && self.dropdownMenu) {
	      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true);
	      var css = {
	        top: pos.top + 'px',
	        display: isOpen ? 'block' : 'none'
	      };
	
	      var rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
	      if (!rightalign) {
	        css.left = pos.left + 'px';
	        css.right = 'auto';
	      } else {
	        css.left = 'auto';
	        css.right = (window.innerWidth - (pos.left + $element.prop('offsetWidth'))) + 'px';
	      }
	
	      self.dropdownMenu.css(css);
	    }
	
	    $animate[isOpen ? 'addClass' : 'removeClass']($element, openClass).then(function() {
	      if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
	        toggleInvoker($scope, { open: !!isOpen });
	      }
	    });
	
	    if (isOpen) {
	      if (self.dropdownMenuTemplateUrl) {
	        $templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent) {
	          templateScope = scope.$new();
	          $compile(tplContent.trim())(templateScope, function(dropdownElement) {
	            var newEl = dropdownElement;
	            self.dropdownMenu.replaceWith(newEl);
	            self.dropdownMenu = newEl;
	          });
	        });
	      }
	
	      scope.focusToggleElement();
	      uibDropdownService.open(scope);
	    } else {
	      if (self.dropdownMenuTemplateUrl) {
	        if (templateScope) {
	          templateScope.$destroy();
	        }
	        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
	        self.dropdownMenu.replaceWith(newEl);
	        self.dropdownMenu = newEl;
	      }
	
	      uibDropdownService.close(scope);
	      self.selectedOption = null;
	    }
	
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen($scope, isOpen);
	    }
	  });
	
	  $scope.$on('$locationChangeSuccess', function() {
	    if (scope.getAutoClose() !== 'disabled') {
	      scope.isOpen = false;
	    }
	  });
	
	  var offDestroy = $scope.$on('$destroy', function() {
	    scope.$destroy();
	  });
	  scope.$on('$destroy', offDestroy);
	}])
	
	.directive('dropdown', ['$log', '$dropdownSuppressWarning', function($log, $dropdownSuppressWarning) {
	  return {
	    controller: 'DropdownController',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!$dropdownSuppressWarning) {
	        $log.warn('dropdown is now deprecated. Use uib-dropdown instead.');
	      }
	
	      dropdownCtrl.init();
	    }
	  };
	}])
	
	.directive('dropdownMenu', ['$log', '$dropdownSuppressWarning', function($log, $dropdownSuppressWarning) {
	  return {
	    restrict: 'AC',
	    require: '?^dropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
	        return;
	      }
	
	      if (!$dropdownSuppressWarning) {
	        $log.warn('dropdown-menu is now deprecated. Use uib-dropdown-menu instead.');
	      }
	
	      element.addClass('dropdown-menu');
	
	      var tplUrl = attrs.templateUrl;
	      if (tplUrl) {
	        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
	      }
	
	      if (!dropdownCtrl.dropdownMenu) {
	        dropdownCtrl.dropdownMenu = element;
	      }
	    }
	  };
	}])
	
	.directive('keyboardNav', ['$log', '$dropdownSuppressWarning', function($log, $dropdownSuppressWarning) {
	  return {
	    restrict: 'A',
	    require: '?^dropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!$dropdownSuppressWarning) {
	        $log.warn('keyboard-nav is now deprecated. Use uib-keyboard-nav instead.');
	      }
	
	      element.bind('keydown', function(e) {
	        if ([38, 40].indexOf(e.which) !== -1) {
	          e.preventDefault();
	          e.stopPropagation();
	
	          var elems = dropdownCtrl.dropdownMenu.find('a');
	
	          switch (e.which) {
	            case (40): { // Down
	              if (!angular.isNumber(dropdownCtrl.selectedOption)) {
	                dropdownCtrl.selectedOption = 0;
	              } else {
	                dropdownCtrl.selectedOption = dropdownCtrl.selectedOption === elems.length -1 ?
	                  dropdownCtrl.selectedOption : dropdownCtrl.selectedOption + 1;
	              }
	              break;
	            }
	            case (38): { // Up
	              if (!angular.isNumber(dropdownCtrl.selectedOption)) {
	                dropdownCtrl.selectedOption = elems.length - 1;
	              } else {
	                dropdownCtrl.selectedOption = dropdownCtrl.selectedOption === 0 ?
	                  0 : dropdownCtrl.selectedOption - 1;
	              }
	              break;
	            }
	          }
	          elems[dropdownCtrl.selectedOption].focus();
	        }
	      });
	    }
	  };
	}])
	
	.directive('dropdownToggle', ['$log', '$dropdownSuppressWarning', function($log, $dropdownSuppressWarning) {
	  return {
	    require: '?^dropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!$dropdownSuppressWarning) {
	        $log.warn('dropdown-toggle is now deprecated. Use uib-dropdown-toggle instead.');
	      }
	
	      if (!dropdownCtrl) {
	        return;
	      }
	
	      element.addClass('dropdown-toggle');
	
	      dropdownCtrl.toggleElement = element;
	
	      var toggleDropdown = function(event) {
	        event.preventDefault();
	
	        if (!element.hasClass('disabled') && !attrs.disabled) {
	          scope.$apply(function() {
	            dropdownCtrl.toggle();
	          });
	        }
	      };
	
	      element.bind('click', toggleDropdown);
	
	      // WAI-ARIA
	      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
	      scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
	        element.attr('aria-expanded', !!isOpen);
	      });
	
	      scope.$on('$destroy', function() {
	        element.unbind('click', toggleDropdown);
	      });
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.stackedMap', [])
	/**
	 * A helper, internal data structure that acts as a map but also allows getting / removing
	 * elements in the LIFO order
	 */
	  .factory('$$stackedMap', function() {
	    return {
	      createNew: function() {
	        var stack = [];
	
	        return {
	          add: function(key, value) {
	            stack.push({
	              key: key,
	              value: value
	            });
	          },
	          get: function(key) {
	            for (var i = 0; i < stack.length; i++) {
	              if (key == stack[i].key) {
	                return stack[i];
	              }
	            }
	          },
	          keys: function() {
	            var keys = [];
	            for (var i = 0; i < stack.length; i++) {
	              keys.push(stack[i].key);
	            }
	            return keys;
	          },
	          top: function() {
	            return stack[stack.length - 1];
	          },
	          remove: function(key) {
	            var idx = -1;
	            for (var i = 0; i < stack.length; i++) {
	              if (key == stack[i].key) {
	                idx = i;
	                break;
	              }
	            }
	            return stack.splice(idx, 1)[0];
	          },
	          removeTop: function() {
	            return stack.splice(stack.length - 1, 1)[0];
	          },
	          length: function() {
	            return stack.length;
	          }
	        };
	      }
	    };
	  });
	angular.module('ui.bootstrap.modal', ['ui.bootstrap.stackedMap'])
	/**
	 * A helper, internal data structure that stores all references attached to key
	 */
	  .factory('$$multiMap', function() {
	    return {
	      createNew: function() {
	        var map = {};
	
	        return {
	          entries: function() {
	            return Object.keys(map).map(function(key) {
	              return {
	                key: key,
	                value: map[key]
	              };
	            });
	          },
	          get: function(key) {
	            return map[key];
	          },
	          hasKey: function(key) {
	            return !!map[key];
	          },
	          keys: function() {
	            return Object.keys(map);
	          },
	          put: function(key, value) {
	            if (!map[key]) {
	              map[key] = [];
	            }
	
	            map[key].push(value);
	          },
	          remove: function(key, value) {
	            var values = map[key];
	
	            if (!values) {
	              return;
	            }
	
	            var idx = values.indexOf(value);
	
	            if (idx !== -1) {
	              values.splice(idx, 1);
	            }
	
	            if (!values.length) {
	              delete map[key];
	            }
	          }
	        };
	      }
	    };
	  })
	
	/**
	 * A helper directive for the $modal service. It creates a backdrop element.
	 */
	  .directive('uibModalBackdrop', [
	           '$animate', '$injector', '$uibModalStack',
	  function($animate ,  $injector,   $modalStack) {
	    var $animateCss = null;
	
	    if ($injector.has('$animateCss')) {
	      $animateCss = $injector.get('$animateCss');
	    }
	
	    return {
	      replace: true,
	      templateUrl: 'template/modal/backdrop.html',
	      compile: function(tElement, tAttrs) {
	        tElement.addClass(tAttrs.backdropClass);
	        return linkFn;
	      }
	    };
	
	    function linkFn(scope, element, attrs) {
	      // Temporary fix for prefixing
	      element.addClass('modal-backdrop');
	
	      if (attrs.modalInClass) {
	        if ($animateCss) {
	          $animateCss(element, {
	            addClass: attrs.modalInClass
	          }).start();
	        } else {
	          $animate.addClass(element, attrs.modalInClass);
	        }
	
	        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	          var done = setIsAsync();
	          if ($animateCss) {
	            $animateCss(element, {
	              removeClass: attrs.modalInClass
	            }).start().then(done);
	          } else {
	            $animate.removeClass(element, attrs.modalInClass).then(done);
	          }
	        });
	      }
	    }
	  }])
	
	  .directive('uibModalWindow', [
	           '$uibModalStack', '$q', '$animate', '$injector',
	  function($modalStack ,  $q ,  $animate,   $injector) {
	    var $animateCss = null;
	
	    if ($injector.has('$animateCss')) {
	      $animateCss = $injector.get('$animateCss');
	    }
	
	    return {
	      scope: {
	        index: '@'
	      },
	      replace: true,
	      transclude: true,
	      templateUrl: function(tElement, tAttrs) {
	        return tAttrs.templateUrl || 'template/modal/window.html';
	      },
	      link: function(scope, element, attrs) {
	        element.addClass(attrs.windowClass || '');
	        element.addClass(attrs.windowTopClass || '');
	        scope.size = attrs.size;
	
	        scope.close = function(evt) {
	          var modal = $modalStack.getTop();
	          if (modal && modal.value.backdrop && modal.value.backdrop !== 'static' && (evt.target === evt.currentTarget)) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            $modalStack.dismiss(modal.key, 'backdrop click');
	          }
	        };
	
	        // moved from template to fix issue #2280
	        element.on('click', scope.close);
	
	        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
	        // We can detect that by using this property in the template associated with this directive and then use
	        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
	        scope.$isRendered = true;
	
	        // Deferred object that will be resolved when this modal is render.
	        var modalRenderDeferObj = $q.defer();
	        // Observe function will be called on next digest cycle after compilation, ensuring that the DOM is ready.
	        // In order to use this way of finding whether DOM is ready, we need to observe a scope property used in modal's template.
	        attrs.$observe('modalRender', function(value) {
	          if (value == 'true') {
	            modalRenderDeferObj.resolve();
	          }
	        });
	
	        modalRenderDeferObj.promise.then(function() {
	          var animationPromise = null;
	
	          if (attrs.modalInClass) {
	            if ($animateCss) {
	              animationPromise = $animateCss(element, {
	                addClass: attrs.modalInClass
	              }).start();
	            } else {
	              animationPromise = $animate.addClass(element, attrs.modalInClass);
	            }
	
	            scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	              var done = setIsAsync();
	              if ($animateCss) {
	                $animateCss(element, {
	                  removeClass: attrs.modalInClass
	                }).start().then(done);
	              } else {
	                $animate.removeClass(element, attrs.modalInClass).then(done);
	              }
	            });
	          }
	
	
	          $q.when(animationPromise).then(function() {
	            var inputWithAutofocus = element[0].querySelector('[autofocus]');
	            /**
	             * Auto-focusing of a freshly-opened modal element causes any child elements
	             * with the autofocus attribute to lose focus. This is an issue on touch
	             * based devices which will show and then hide the onscreen keyboard.
	             * Attempts to refocus the autofocus element via JavaScript will not reopen
	             * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
	             * the modal element if the modal does not contain an autofocus element.
	             */
	            if (inputWithAutofocus) {
	              inputWithAutofocus.focus();
	            } else {
	              element[0].focus();
	            }
	          });
	
	          // Notify {@link $modalStack} that modal is rendered.
	          var modal = $modalStack.getTop();
	          if (modal) {
	            $modalStack.modalRendered(modal.key);
	          }
	        });
	      }
	    };
	  }])
	
	  .directive('uibModalAnimationClass', function() {
	    return {
	      compile: function(tElement, tAttrs) {
	        if (tAttrs.modalAnimation) {
	          tElement.addClass(tAttrs.uibModalAnimationClass);
	        }
	      }
	    };
	  })
	
	  .directive('uibModalTransclude', function() {
	    return {
	      link: function($scope, $element, $attrs, controller, $transclude) {
	        $transclude($scope.$parent, function(clone) {
	          $element.empty();
	          $element.append(clone);
	        });
	      }
	    };
	  })
	
	  .factory('$uibModalStack', [
	             '$animate', '$timeout', '$document', '$compile', '$rootScope',
	             '$q',
	             '$injector',
	             '$$multiMap',
	             '$$stackedMap',
	    function($animate ,  $timeout ,  $document ,  $compile ,  $rootScope ,
	              $q,
	              $injector,
	              $$multiMap,
	              $$stackedMap) {
	      var $animateCss = null;
	
	      if ($injector.has('$animateCss')) {
	        $animateCss = $injector.get('$animateCss');
	      }
	
	      var OPENED_MODAL_CLASS = 'modal-open';
	
	      var backdropDomEl, backdropScope;
	      var openedWindows = $$stackedMap.createNew();
	      var openedClasses = $$multiMap.createNew();
	      var $modalStack = {
	        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
	      };
	
	      //Modal focus behavior
	      var focusableElementList;
	      var focusIndex = 0;
	      var tababbleSelector = 'a[href], area[href], input:not([disabled]), ' +
	        'button:not([disabled]),select:not([disabled]), textarea:not([disabled]), ' +
	        'iframe, object, embed, *[tabindex], *[contenteditable=true]';
	
	      function backdropIndex() {
	        var topBackdropIndex = -1;
	        var opened = openedWindows.keys();
	        for (var i = 0; i < opened.length; i++) {
	          if (openedWindows.get(opened[i]).value.backdrop) {
	            topBackdropIndex = i;
	          }
	        }
	        return topBackdropIndex;
	      }
	
	      $rootScope.$watch(backdropIndex, function(newBackdropIndex) {
	        if (backdropScope) {
	          backdropScope.index = newBackdropIndex;
	        }
	      });
	
	      function removeModalWindow(modalInstance, elementToReceiveFocus) {
	        var body = $document.find('body').eq(0);
	        var modalWindow = openedWindows.get(modalInstance).value;
	
	        //clean up the stack
	        openedWindows.remove(modalInstance);
	
	        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
	          var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
	          openedClasses.remove(modalBodyClass, modalInstance);
	          body.toggleClass(modalBodyClass, openedClasses.hasKey(modalBodyClass));
	          toggleTopWindowClass(true);
	        });
	        checkRemoveBackdrop();
	
	        //move focus to specified element if available, or else to body
	        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
	          elementToReceiveFocus.focus();
	        } else {
	          body.focus();
	        }
	      }
	
	      // Add or remove "windowTopClass" from the top window in the stack
	      function toggleTopWindowClass(toggleSwitch) {
	        var modalWindow;
	
	        if (openedWindows.length() > 0) {
	          modalWindow = openedWindows.top().value;
	          modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
	        }
	      }
	
	      function checkRemoveBackdrop() {
	        //remove backdrop if no longer needed
	        if (backdropDomEl && backdropIndex() == -1) {
	          var backdropScopeRef = backdropScope;
	          removeAfterAnimate(backdropDomEl, backdropScope, function() {
	            backdropScopeRef = null;
	          });
	          backdropDomEl = undefined;
	          backdropScope = undefined;
	        }
	      }
	
	      function removeAfterAnimate(domEl, scope, done) {
	        var asyncDeferred;
	        var asyncPromise = null;
	        var setIsAsync = function() {
	          if (!asyncDeferred) {
	            asyncDeferred = $q.defer();
	            asyncPromise = asyncDeferred.promise;
	          }
	
	          return function asyncDone() {
	            asyncDeferred.resolve();
	          };
	        };
	        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);
	
	        // Note that it's intentional that asyncPromise might be null.
	        // That's when setIsAsync has not been called during the
	        // NOW_CLOSING_EVENT broadcast.
	        return $q.when(asyncPromise).then(afterAnimating);
	
	        function afterAnimating() {
	          if (afterAnimating.done) {
	            return;
	          }
	          afterAnimating.done = true;
	
	          if ($animateCss) {
	            $animateCss(domEl, {
	              event: 'leave'
	            }).start().then(function() {
	              domEl.remove();
	            });
	          } else {
	            $animate.leave(domEl);
	          }
	          scope.$destroy();
	          if (done) {
	            done();
	          }
	        }
	      }
	
	      $document.bind('keydown', function(evt) {
	        if (evt.isDefaultPrevented()) {
	          return evt;
	        }
	
	        var modal = openedWindows.top();
	        if (modal && modal.value.keyboard) {
	          switch (evt.which) {
	            case 27: {
	              evt.preventDefault();
	              $rootScope.$apply(function() {
	                $modalStack.dismiss(modal.key, 'escape key press');
	              });
	              break;
	            }
	            case 9: {
	              $modalStack.loadFocusElementList(modal);
	              var focusChanged = false;
	              if (evt.shiftKey) {
	                if ($modalStack.isFocusInFirstItem(evt)) {
	                  focusChanged = $modalStack.focusLastFocusableElement();
	                }
	              } else {
	                if ($modalStack.isFocusInLastItem(evt)) {
	                  focusChanged = $modalStack.focusFirstFocusableElement();
	                }
	              }
	
	              if (focusChanged) {
	                evt.preventDefault();
	                evt.stopPropagation();
	              }
	              break;
	            }
	          }
	        }
	      });
	
	      $modalStack.open = function(modalInstance, modal) {
	        var modalOpener = $document[0].activeElement,
	          modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;
	
	        toggleTopWindowClass(false);
	
	        openedWindows.add(modalInstance, {
	          deferred: modal.deferred,
	          renderDeferred: modal.renderDeferred,
	          modalScope: modal.scope,
	          backdrop: modal.backdrop,
	          keyboard: modal.keyboard,
	          openedClass: modal.openedClass,
	          windowTopClass: modal.windowTopClass
	        });
	
	        openedClasses.put(modalBodyClass, modalInstance);
	
	        var body = $document.find('body').eq(0),
	            currBackdropIndex = backdropIndex();
	
	        if (currBackdropIndex >= 0 && !backdropDomEl) {
	          backdropScope = $rootScope.$new(true);
	          backdropScope.index = currBackdropIndex;
	          var angularBackgroundDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
	          angularBackgroundDomEl.attr('backdrop-class', modal.backdropClass);
	          if (modal.animation) {
	            angularBackgroundDomEl.attr('modal-animation', 'true');
	          }
	          backdropDomEl = $compile(angularBackgroundDomEl)(backdropScope);
	          body.append(backdropDomEl);
	        }
	
	        var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
	        angularDomEl.attr({
	          'template-url': modal.windowTemplateUrl,
	          'window-class': modal.windowClass,
	          'window-top-class': modal.windowTopClass,
	          'size': modal.size,
	          'index': openedWindows.length() - 1,
	          'animate': 'animate'
	        }).html(modal.content);
	        if (modal.animation) {
	          angularDomEl.attr('modal-animation', 'true');
	        }
	
	        var modalDomEl = $compile(angularDomEl)(modal.scope);
	        openedWindows.top().value.modalDomEl = modalDomEl;
	        openedWindows.top().value.modalOpener = modalOpener;
	        body.append(modalDomEl);
	        body.addClass(modalBodyClass);
	
	        $modalStack.clearFocusListCache();
	      };
	
	      function broadcastClosing(modalWindow, resultOrReason, closing) {
	        return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
	      }
	
	      $modalStack.close = function(modalInstance, result) {
	        var modalWindow = openedWindows.get(modalInstance);
	        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
	          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	          modalWindow.value.deferred.resolve(result);
	          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	          return true;
	        }
	        return !modalWindow;
	      };
	
	      $modalStack.dismiss = function(modalInstance, reason) {
	        var modalWindow = openedWindows.get(modalInstance);
	        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
	          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	          modalWindow.value.deferred.reject(reason);
	          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	          return true;
	        }
	        return !modalWindow;
	      };
	
	      $modalStack.dismissAll = function(reason) {
	        var topModal = this.getTop();
	        while (topModal && this.dismiss(topModal.key, reason)) {
	          topModal = this.getTop();
	        }
	      };
	
	      $modalStack.getTop = function() {
	        return openedWindows.top();
	      };
	
	      $modalStack.modalRendered = function(modalInstance) {
	        var modalWindow = openedWindows.get(modalInstance);
	        if (modalWindow) {
	          modalWindow.value.renderDeferred.resolve();
	        }
	      };
	
	      $modalStack.focusFirstFocusableElement = function() {
	        if (focusableElementList.length > 0) {
	          focusableElementList[0].focus();
	          return true;
	        }
	        return false;
	      };
	      $modalStack.focusLastFocusableElement = function() {
	        if (focusableElementList.length > 0) {
	          focusableElementList[focusableElementList.length - 1].focus();
	          return true;
	        }
	        return false;
	      };
	
	      $modalStack.isFocusInFirstItem = function(evt) {
	        if (focusableElementList.length > 0) {
	          return (evt.target || evt.srcElement) == focusableElementList[0];
	        }
	        return false;
	      };
	
	      $modalStack.isFocusInLastItem = function(evt) {
	        if (focusableElementList.length > 0) {
	          return (evt.target || evt.srcElement) == focusableElementList[focusableElementList.length - 1];
	        }
	        return false;
	      };
	
	      $modalStack.clearFocusListCache = function() {
	        focusableElementList = [];
	        focusIndex = 0;
	      };
	
	      $modalStack.loadFocusElementList = function(modalWindow) {
	        if (focusableElementList === undefined || !focusableElementList.length) {
	          if (modalWindow) {
	            var modalDomE1 = modalWindow.value.modalDomEl;
	            if (modalDomE1 && modalDomE1.length) {
	              focusableElementList = modalDomE1[0].querySelectorAll(tababbleSelector);
	            }
	          }
	        }
	      };
	
	      return $modalStack;
	    }])
	
	  .provider('$uibModal', function() {
	    var $modalProvider = {
	      options: {
	        animation: true,
	        backdrop: true, //can also be false or 'static'
	        keyboard: true
	      },
	      $get: ['$injector', '$rootScope', '$q', '$templateRequest', '$controller', '$uibModalStack', '$modalSuppressWarning', '$log',
	        function ($injector, $rootScope, $q, $templateRequest, $controller, $modalStack, $modalSuppressWarning, $log) {
	          var $modal = {};
	
	          function getTemplatePromise(options) {
	            return options.template ? $q.when(options.template) :
	              $templateRequest(angular.isFunction(options.templateUrl) ? (options.templateUrl)() : options.templateUrl);
	          }
	
	          function getResolvePromises(resolves) {
	            var promisesArr = [];
	            angular.forEach(resolves, function(value) {
	              if (angular.isFunction(value) || angular.isArray(value)) {
	                promisesArr.push($q.when($injector.invoke(value)));
	              } else if (angular.isString(value)) {
	                promisesArr.push($q.when($injector.get(value)));
	              } else {
	                promisesArr.push($q.when(value));
	              }
	            });
	            return promisesArr;
	          }
	
	          var promiseChain = null;
	          $modal.getPromiseChain = function() {
	            return promiseChain;
	          };
	
	          $modal.open = function(modalOptions) {
	            var modalResultDeferred = $q.defer();
	            var modalOpenedDeferred = $q.defer();
	            var modalRenderDeferred = $q.defer();
	
	            //prepare an instance of a modal to be injected into controllers and returned to a caller
	            var modalInstance = {
	              result: modalResultDeferred.promise,
	              opened: modalOpenedDeferred.promise,
	              rendered: modalRenderDeferred.promise,
	              close: function (result) {
	                return $modalStack.close(modalInstance, result);
	              },
	              dismiss: function (reason) {
	                return $modalStack.dismiss(modalInstance, reason);
	              }
	            };
	
	            //merge and clean up options
	            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
	            modalOptions.resolve = modalOptions.resolve || {};
	
	            //verify options
	            if (!modalOptions.template && !modalOptions.templateUrl) {
	              throw new Error('One of template or templateUrl options is required.');
	            }
	
	            var templateAndResolvePromise =
	              $q.all([getTemplatePromise(modalOptions)].concat(getResolvePromises(modalOptions.resolve)));
	
	            function resolveWithTemplate() {
	              return templateAndResolvePromise;
	            }
	
	            // Wait for the resolution of the existing promise chain.
	            // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
	            // Then add to $modalStack and resolve opened.
	            // Finally clean up the chain variable if no subsequent modal has overwritten it.
	            var samePromise;
	            samePromise = promiseChain = $q.all([promiseChain])
	              .then(resolveWithTemplate, resolveWithTemplate)
	              .then(function resolveSuccess(tplAndVars) {
	
	                var modalScope = (modalOptions.scope || $rootScope).$new();
	                modalScope.$close = modalInstance.close;
	                modalScope.$dismiss = modalInstance.dismiss;
	
	                modalScope.$on('$destroy', function() {
	                  if (!modalScope.$$uibDestructionScheduled) {
	                    modalScope.$dismiss('$uibUnscheduledDestruction');
	                  }
	                });
	
	                var ctrlInstance, ctrlLocals = {};
	                var resolveIter = 1;
	
	                //controllers
	                if (modalOptions.controller) {
	                  ctrlLocals.$scope = modalScope;
	                  ctrlLocals.$uibModalInstance = modalInstance;
	                  Object.defineProperty(ctrlLocals, '$modalInstance', {
	                    get: function() {
	                      if (!$modalSuppressWarning) {
	                        $log.warn('$modalInstance is now deprecated. Use $uibModalInstance instead.');
	                      }
	
	                      return modalInstance;
	                    }
	                  });
	                  angular.forEach(modalOptions.resolve, function(value, key) {
	                    ctrlLocals[key] = tplAndVars[resolveIter++];
	                  });
	
	                  ctrlInstance = $controller(modalOptions.controller, ctrlLocals);
	                  if (modalOptions.controllerAs) {
	                    if (modalOptions.bindToController) {
	                      angular.extend(ctrlInstance, modalScope);
	                    }
	
	                    modalScope[modalOptions.controllerAs] = ctrlInstance;
	                  }
	                }
	
	                $modalStack.open(modalInstance, {
	                  scope: modalScope,
	                  deferred: modalResultDeferred,
	                  renderDeferred: modalRenderDeferred,
	                  content: tplAndVars[0],
	                  animation: modalOptions.animation,
	                  backdrop: modalOptions.backdrop,
	                  keyboard: modalOptions.keyboard,
	                  backdropClass: modalOptions.backdropClass,
	                  windowTopClass: modalOptions.windowTopClass,
	                  windowClass: modalOptions.windowClass,
	                  windowTemplateUrl: modalOptions.windowTemplateUrl,
	                  size: modalOptions.size,
	                  openedClass: modalOptions.openedClass
	                });
	                modalOpenedDeferred.resolve(true);
	
	            }, function resolveError(reason) {
	              modalOpenedDeferred.reject(reason);
	              modalResultDeferred.reject(reason);
	            })
	            .finally(function() {
	              if (promiseChain === samePromise) {
	                promiseChain = null;
	              }
	            });
	
	            return modalInstance;
	          };
	
	          return $modal;
	        }
	      ]
	    };
	
	    return $modalProvider;
	  });
	
	/* deprecated modal below */
	
	angular.module('ui.bootstrap.modal')
	
	  .value('$modalSuppressWarning', false)
	
	  /**
	   * A helper directive for the $modal service. It creates a backdrop element.
	   */
	  .directive('modalBackdrop', [
	    '$animate', '$injector', '$modalStack', '$log', '$modalSuppressWarning',
	    function($animate ,  $injector,   $modalStack, $log, $modalSuppressWarning) {
	      var $animateCss = null;
	
	      if ($injector.has('$animateCss')) {
	        $animateCss = $injector.get('$animateCss');
	      }
	
	      return {
	        replace: true,
	        templateUrl: 'template/modal/backdrop.html',
	        compile: function(tElement, tAttrs) {
	          tElement.addClass(tAttrs.backdropClass);
	          return linkFn;
	        }
	      };
	
	      function linkFn(scope, element, attrs) {
	        if (!$modalSuppressWarning) {
	          $log.warn('modal-backdrop is now deprecated. Use uib-modal-backdrop instead.');
	        }
	        element.addClass('modal-backdrop');
	
	        if (attrs.modalInClass) {
	          if ($animateCss) {
	            $animateCss(element, {
	              addClass: attrs.modalInClass
	            }).start();
	          } else {
	            $animate.addClass(element, attrs.modalInClass);
	          }
	
	          scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	            var done = setIsAsync();
	            if ($animateCss) {
	              $animateCss(element, {
	                removeClass: attrs.modalInClass
	              }).start().then(done);
	            } else {
	              $animate.removeClass(element, attrs.modalInClass).then(done);
	            }
	          });
	        }
	      }
	    }])
	
	  .directive('modalWindow', [
	    '$modalStack', '$q', '$animate', '$injector', '$log', '$modalSuppressWarning',
	    function($modalStack ,  $q ,  $animate,   $injector, $log, $modalSuppressWarning) {
	      var $animateCss = null;
	
	      if ($injector.has('$animateCss')) {
	        $animateCss = $injector.get('$animateCss');
	      }
	
	      return {
	        scope: {
	          index: '@'
	        },
	        replace: true,
	        transclude: true,
	        templateUrl: function(tElement, tAttrs) {
	          return tAttrs.templateUrl || 'template/modal/window.html';
	        },
	        link: function(scope, element, attrs) {
	          if (!$modalSuppressWarning) {
	            $log.warn('modal-window is now deprecated. Use uib-modal-window instead.');
	          }
	          element.addClass(attrs.windowClass || '');
	          element.addClass(attrs.windowTopClass || '');
	          scope.size = attrs.size;
	
	          scope.close = function(evt) {
	            var modal = $modalStack.getTop();
	            if (modal && modal.value.backdrop && modal.value.backdrop !== 'static' && (evt.target === evt.currentTarget)) {
	              evt.preventDefault();
	              evt.stopPropagation();
	              $modalStack.dismiss(modal.key, 'backdrop click');
	            }
	          };
	
	          // moved from template to fix issue #2280
	          element.on('click', scope.close);
	
	          // This property is only added to the scope for the purpose of detecting when this directive is rendered.
	          // We can detect that by using this property in the template associated with this directive and then use
	          // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
	          scope.$isRendered = true;
	
	          // Deferred object that will be resolved when this modal is render.
	          var modalRenderDeferObj = $q.defer();
	          // Observe function will be called on next digest cycle after compilation, ensuring that the DOM is ready.
	          // In order to use this way of finding whether DOM is ready, we need to observe a scope property used in modal's template.
	          attrs.$observe('modalRender', function(value) {
	            if (value == 'true') {
	              modalRenderDeferObj.resolve();
	            }
	          });
	
	          modalRenderDeferObj.promise.then(function() {
	            var animationPromise = null;
	
	            if (attrs.modalInClass) {
	              if ($animateCss) {
	                animationPromise = $animateCss(element, {
	                  addClass: attrs.modalInClass
	                }).start();
	              } else {
	                animationPromise = $animate.addClass(element, attrs.modalInClass);
	              }
	
	              scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	                var done = setIsAsync();
	                if ($animateCss) {
	                  $animateCss(element, {
	                    removeClass: attrs.modalInClass
	                  }).start().then(done);
	                } else {
	                  $animate.removeClass(element, attrs.modalInClass).then(done);
	                }
	              });
	            }
	
	
	            $q.when(animationPromise).then(function() {
	              var inputWithAutofocus = element[0].querySelector('[autofocus]');
	              /**
	               * Auto-focusing of a freshly-opened modal element causes any child elements
	               * with the autofocus attribute to lose focus. This is an issue on touch
	               * based devices which will show and then hide the onscreen keyboard.
	               * Attempts to refocus the autofocus element via JavaScript will not reopen
	               * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
	               * the modal element if the modal does not contain an autofocus element.
	               */
	              if (inputWithAutofocus) {
	                inputWithAutofocus.focus();
	              } else {
	                element[0].focus();
	              }
	            });
	
	            // Notify {@link $modalStack} that modal is rendered.
	            var modal = $modalStack.getTop();
	            if (modal) {
	              $modalStack.modalRendered(modal.key);
	            }
	          });
	        }
	      };
	    }])
	
	  .directive('modalAnimationClass', [
	    '$log', '$modalSuppressWarning',
	    function ($log, $modalSuppressWarning) {
	      return {
	        compile: function(tElement, tAttrs) {
	          if (!$modalSuppressWarning) {
	            $log.warn('modal-animation-class is now deprecated. Use uib-modal-animation-class instead.');
	          }
	          if (tAttrs.modalAnimation) {
	            tElement.addClass(tAttrs.modalAnimationClass);
	          }
	        }
	      };
	    }])
	
	  .directive('modalTransclude', [
	    '$log', '$modalSuppressWarning',
	    function ($log, $modalSuppressWarning) {
	    return {
	      link: function($scope, $element, $attrs, controller, $transclude) {
	        if (!$modalSuppressWarning) {
	          $log.warn('modal-transclude is now deprecated. Use uib-modal-transclude instead.');
	        }
	        $transclude($scope.$parent, function(clone) {
	          $element.empty();
	          $element.append(clone);
	        });
	      }
	    };
	  }])
	
	  .service('$modalStack', [
	    '$animate', '$timeout', '$document', '$compile', '$rootScope',
	    '$q',
	    '$injector',
	    '$$multiMap',
	    '$$stackedMap',
	    '$uibModalStack',
	    '$log',
	    '$modalSuppressWarning',
	    function($animate ,  $timeout ,  $document ,  $compile ,  $rootScope ,
	             $q,
	             $injector,
	             $$multiMap,
	             $$stackedMap,
	             $uibModalStack,
	             $log,
	             $modalSuppressWarning) {
	      if (!$modalSuppressWarning) {
	        $log.warn('$modalStack is now deprecated. Use $uibModalStack instead.');
	      }
	
	      angular.extend(this, $uibModalStack);
	    }])
	
	  .provider('$modal', ['$uibModalProvider', function($uibModalProvider) {
	    angular.extend(this, $uibModalProvider);
	
	    this.$get = ['$injector', '$log', '$modalSuppressWarning',
	      function ($injector, $log, $modalSuppressWarning) {
	        if (!$modalSuppressWarning) {
	          $log.warn('$modal is now deprecated. Use $uibModal instead.');
	        }
	
	        return $injector.invoke($uibModalProvider.$get);
	      }];
	  }]);
	
	angular.module('ui.bootstrap.pagination', [])
	.controller('UibPaginationController', ['$scope', '$attrs', '$parse', function($scope, $attrs, $parse) {
	  var self = this,
	      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
	      setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
	
	  this.init = function(ngModelCtrl_, config) {
	    ngModelCtrl = ngModelCtrl_;
	    this.config = config;
	
	    ngModelCtrl.$render = function() {
	      self.render();
	    };
	
	    if ($attrs.itemsPerPage) {
	      $scope.$parent.$watch($parse($attrs.itemsPerPage), function(value) {
	        self.itemsPerPage = parseInt(value, 10);
	        $scope.totalPages = self.calculateTotalPages();
	      });
	    } else {
	      this.itemsPerPage = config.itemsPerPage;
	    }
	
	    $scope.$watch('totalItems', function() {
	      $scope.totalPages = self.calculateTotalPages();
	    });
	
	    $scope.$watch('totalPages', function(value) {
	      setNumPages($scope.$parent, value); // Readonly variable
	
	      if ( $scope.page > value ) {
	        $scope.selectPage(value);
	      } else {
	        ngModelCtrl.$render();
	      }
	    });
	  };
	
	  this.calculateTotalPages = function() {
	    var totalPages = this.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / this.itemsPerPage);
	    return Math.max(totalPages || 0, 1);
	  };
	
	  this.render = function() {
	    $scope.page = parseInt(ngModelCtrl.$viewValue, 10) || 1;
	  };
	
	  $scope.selectPage = function(page, evt) {
	    if (evt) {
	      evt.preventDefault();
	    }
	
	    var clickAllowed = !$scope.ngDisabled || !evt;
	    if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
	      if (evt && evt.target) {
	        evt.target.blur();
	      }
	      ngModelCtrl.$setViewValue(page);
	      ngModelCtrl.$render();
	    }
	  };
	
	  $scope.getText = function(key) {
	    return $scope[key + 'Text'] || self.config[key + 'Text'];
	  };
	
	  $scope.noPrevious = function() {
	    return $scope.page === 1;
	  };
	
	  $scope.noNext = function() {
	    return $scope.page === $scope.totalPages;
	  };
	}])
	
	.constant('uibPaginationConfig', {
	  itemsPerPage: 10,
	  boundaryLinks: false,
	  directionLinks: true,
	  firstText: 'First',
	  previousText: 'Previous',
	  nextText: 'Next',
	  lastText: 'Last',
	  rotate: true
	})
	
	.directive('uibPagination', ['$parse', 'uibPaginationConfig', function($parse, paginationConfig) {
	  return {
	    restrict: 'EA',
	    scope: {
	      totalItems: '=',
	      firstText: '@',
	      previousText: '@',
	      nextText: '@',
	      lastText: '@',
	      ngDisabled:'='
	    },
	    require: ['uibPagination', '?ngModel'],
	    controller: 'UibPaginationController',
	    controllerAs: 'pagination',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/pagination/pagination.html';
	    },
	    replace: true,
	    link: function(scope, element, attrs, ctrls) {
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	         return; // do nothing if no ng-model
	      }
	
	      // Setup configuration parameters
	      var maxSize = angular.isDefined(attrs.maxSize) ? scope.$parent.$eval(attrs.maxSize) : paginationConfig.maxSize,
	          rotate = angular.isDefined(attrs.rotate) ? scope.$parent.$eval(attrs.rotate) : paginationConfig.rotate;
	      scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : paginationConfig.boundaryLinks;
	      scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : paginationConfig.directionLinks;
	
	      paginationCtrl.init(ngModelCtrl, paginationConfig);
	
	      if (attrs.maxSize) {
	        scope.$parent.$watch($parse(attrs.maxSize), function(value) {
	          maxSize = parseInt(value, 10);
	          paginationCtrl.render();
	        });
	      }
	
	      // Create page object used in template
	      function makePage(number, text, isActive) {
	        return {
	          number: number,
	          text: text,
	          active: isActive
	        };
	      }
	
	      function getPages(currentPage, totalPages) {
	        var pages = [];
	
	        // Default page limits
	        var startPage = 1, endPage = totalPages;
	        var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;
	
	        // recompute if maxSize
	        if (isMaxSized) {
	          if (rotate) {
	            // Current page is displayed in the middle of the visible ones
	            startPage = Math.max(currentPage - Math.floor(maxSize/2), 1);
	            endPage   = startPage + maxSize - 1;
	
	            // Adjust if limit is exceeded
	            if (endPage > totalPages) {
	              endPage   = totalPages;
	              startPage = endPage - maxSize + 1;
	            }
	          } else {
	            // Visible pages are paginated with maxSize
	            startPage = ((Math.ceil(currentPage / maxSize) - 1) * maxSize) + 1;
	
	            // Adjust last page if limit is exceeded
	            endPage = Math.min(startPage + maxSize - 1, totalPages);
	          }
	        }
	
	        // Add page number links
	        for (var number = startPage; number <= endPage; number++) {
	          var page = makePage(number, number, number === currentPage);
	          pages.push(page);
	        }
	
	        // Add links to move between page sets
	        if (isMaxSized && ! rotate) {
	          if (startPage > 1) {
	            var previousPageSet = makePage(startPage - 1, '...', false);
	            pages.unshift(previousPageSet);
	          }
	
	          if (endPage < totalPages) {
	            var nextPageSet = makePage(endPage + 1, '...', false);
	            pages.push(nextPageSet);
	          }
	        }
	
	        return pages;
	      }
	
	      var originalRender = paginationCtrl.render;
	      paginationCtrl.render = function() {
	        originalRender();
	        if (scope.page > 0 && scope.page <= scope.totalPages) {
	          scope.pages = getPages(scope.page, scope.totalPages);
	        }
	      };
	    }
	  };
	}])
	
	.constant('uibPagerConfig', {
	  itemsPerPage: 10,
	  previousText: '« Previous',
	  nextText: 'Next »',
	  align: true
	})
	
	.directive('uibPager', ['uibPagerConfig', function(pagerConfig) {
	  return {
	    restrict: 'EA',
	    scope: {
	      totalItems: '=',
	      previousText: '@',
	      nextText: '@',
	      ngDisabled: '='
	    },
	    require: ['uibPager', '?ngModel'],
	    controller: 'UibPaginationController',
	    controllerAs: 'pagination',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/pagination/pager.html';
	    },
	    replace: true,
	    link: function(scope, element, attrs, ctrls) {
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	         return; // do nothing if no ng-model
	      }
	
	      scope.align = angular.isDefined(attrs.align) ? scope.$parent.$eval(attrs.align) : pagerConfig.align;
	      paginationCtrl.init(ngModelCtrl, pagerConfig);
	    }
	  };
	}]);
	
	/* Deprecated Pagination Below */
	
	angular.module('ui.bootstrap.pagination')
	.value('$paginationSuppressWarning', false)
	.controller('PaginationController', ['$scope', '$attrs', '$parse', '$log', '$paginationSuppressWarning', function($scope, $attrs, $parse, $log, $paginationSuppressWarning) {
	  if (!$paginationSuppressWarning) {
	    $log.warn('PaginationController is now deprecated. Use UibPaginationController instead.');
	  }
	
	  var self = this,
	    ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
	    setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
	
	  this.init = function(ngModelCtrl_, config) {
	    ngModelCtrl = ngModelCtrl_;
	    this.config = config;
	
	    ngModelCtrl.$render = function() {
	      self.render();
	    };
	
	    if ($attrs.itemsPerPage) {
	      $scope.$parent.$watch($parse($attrs.itemsPerPage), function(value) {
	        self.itemsPerPage = parseInt(value, 10);
	        $scope.totalPages = self.calculateTotalPages();
	      });
	    } else {
	      this.itemsPerPage = config.itemsPerPage;
	    }
	
	    $scope.$watch('totalItems', function() {
	      $scope.totalPages = self.calculateTotalPages();
	    });
	
	    $scope.$watch('totalPages', function(value) {
	      setNumPages($scope.$parent, value); // Readonly variable
	
	      if ( $scope.page > value ) {
	        $scope.selectPage(value);
	      } else {
	        ngModelCtrl.$render();
	      }
	    });
	  };
	
	  this.calculateTotalPages = function() {
	    var totalPages = this.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / this.itemsPerPage);
	    return Math.max(totalPages || 0, 1);
	  };
	
	  this.render = function() {
	    $scope.page = parseInt(ngModelCtrl.$viewValue, 10) || 1;
	  };
	
	  $scope.selectPage = function(page, evt) {
	    if (evt) {
	      evt.preventDefault();
	    }
	
	    var clickAllowed = !$scope.ngDisabled || !evt;
	    if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
	      if (evt && evt.target) {
	        evt.target.blur();
	      }
	      ngModelCtrl.$setViewValue(page);
	      ngModelCtrl.$render();
	    }
	  };
	
	  $scope.getText = function(key) {
	    return $scope[key + 'Text'] || self.config[key + 'Text'];
	  };
	
	  $scope.noPrevious = function() {
	    return $scope.page === 1;
	  };
	
	  $scope.noNext = function() {
	    return $scope.page === $scope.totalPages;
	  };
	}])
	.directive('pagination', ['$parse', 'uibPaginationConfig', '$log', '$paginationSuppressWarning', function($parse, paginationConfig, $log, $paginationSuppressWarning) {
	  return {
	    restrict: 'EA',
	    scope: {
	      totalItems: '=',
	      firstText: '@',
	      previousText: '@',
	      nextText: '@',
	      lastText: '@',
	      ngDisabled:'='
	    },
	    require: ['pagination', '?ngModel'],
	    controller: 'PaginationController',
	    controllerAs: 'pagination',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/pagination/pagination.html';
	    },
	    replace: true,
	    link: function(scope, element, attrs, ctrls) {
	      if (!$paginationSuppressWarning) {
	        $log.warn('pagination is now deprecated. Use uib-pagination instead.');
	      }
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	         return; // do nothing if no ng-model
	      }
	
	      // Setup configuration parameters
	      var maxSize = angular.isDefined(attrs.maxSize) ? scope.$parent.$eval(attrs.maxSize) : paginationConfig.maxSize,
	          rotate = angular.isDefined(attrs.rotate) ? scope.$parent.$eval(attrs.rotate) : paginationConfig.rotate;
	      scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : paginationConfig.boundaryLinks;
	      scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : paginationConfig.directionLinks;
	
	      paginationCtrl.init(ngModelCtrl, paginationConfig);
	
	      if (attrs.maxSize) {
	        scope.$parent.$watch($parse(attrs.maxSize), function(value) {
	          maxSize = parseInt(value, 10);
	          paginationCtrl.render();
	        });
	      }
	
	      // Create page object used in template
	      function makePage(number, text, isActive) {
	        return {
	          number: number,
	          text: text,
	          active: isActive
	        };
	      }
	
	      function getPages(currentPage, totalPages) {
	        var pages = [];
	
	        // Default page limits
	        var startPage = 1, endPage = totalPages;
	        var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;
	
	        // recompute if maxSize
	        if (isMaxSized) {
	          if (rotate) {
	            // Current page is displayed in the middle of the visible ones
	            startPage = Math.max(currentPage - Math.floor(maxSize/2), 1);
	            endPage   = startPage + maxSize - 1;
	
	            // Adjust if limit is exceeded
	            if (endPage > totalPages) {
	              endPage   = totalPages;
	              startPage = endPage - maxSize + 1;
	            }
	          } else {
	            // Visible pages are paginated with maxSize
	            startPage = ((Math.ceil(currentPage / maxSize) - 1) * maxSize) + 1;
	
	            // Adjust last page if limit is exceeded
	            endPage = Math.min(startPage + maxSize - 1, totalPages);
	          }
	        }
	
	        // Add page number links
	        for (var number = startPage; number <= endPage; number++) {
	          var page = makePage(number, number, number === currentPage);
	          pages.push(page);
	        }
	
	        // Add links to move between page sets
	        if (isMaxSized && ! rotate) {
	          if (startPage > 1) {
	            var previousPageSet = makePage(startPage - 1, '...', false);
	            pages.unshift(previousPageSet);
	          }
	
	          if (endPage < totalPages) {
	            var nextPageSet = makePage(endPage + 1, '...', false);
	            pages.push(nextPageSet);
	          }
	        }
	
	        return pages;
	      }
	
	      var originalRender = paginationCtrl.render;
	      paginationCtrl.render = function() {
	        originalRender();
	        if (scope.page > 0 && scope.page <= scope.totalPages) {
	          scope.pages = getPages(scope.page, scope.totalPages);
	        }
	      };
	    }
	  };
	}])
	
	.directive('pager', ['uibPagerConfig', '$log', '$paginationSuppressWarning', function(pagerConfig, $log, $paginationSuppressWarning) {
	  return {
	    restrict: 'EA',
	    scope: {
	      totalItems: '=',
	      previousText: '@',
	      nextText: '@',
	      ngDisabled: '='
	    },
	    require: ['pager', '?ngModel'],
	    controller: 'PaginationController',
	    controllerAs: 'pagination',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/pagination/pager.html';
	    },
	    replace: true,
	    link: function(scope, element, attrs, ctrls) {
	      if (!$paginationSuppressWarning) {
	        $log.warn('pager is now deprecated. Use uib-pager instead.');
	      }
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	         return; // do nothing if no ng-model
	      }
	
	      scope.align = angular.isDefined(attrs.align) ? scope.$parent.$eval(attrs.align) : pagerConfig.align;
	      paginationCtrl.init(ngModelCtrl, pagerConfig);
	    }
	  };
	}]);
	
	/**
	 * The following features are still outstanding: animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, html tooltips, and selector delegation.
	 */
	angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])
	
	/**
	 * The $tooltip service creates tooltip- and popover-like directives as well as
	 * houses global options for them.
	 */
	.provider('$uibTooltip', function() {
	  // The default options tooltip and popover.
	  var defaultOptions = {
	    placement: 'top',
	    animation: true,
	    popupDelay: 0,
	    popupCloseDelay: 0,
	    useContentExp: false
	  };
	
	  // Default hide triggers for each show trigger
	  var triggerMap = {
	    'mouseenter': 'mouseleave',
	    'click': 'click',
	    'focus': 'blur',
	    'none': ''
	  };
	
	  // The options specified to the provider globally.
	  var globalOptions = {};
	
	  /**
	   * `options({})` allows global configuration of all tooltips in the
	   * application.
	   *
	   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
	   *     // place tooltips left instead of top by default
	   *     $tooltipProvider.options( { placement: 'left' } );
	   *   });
	   */
		this.options = function(value) {
			angular.extend(globalOptions, value);
		};
	
	  /**
	   * This allows you to extend the set of trigger mappings available. E.g.:
	   *
	   *   $tooltipProvider.setTriggers( 'openTrigger': 'closeTrigger' );
	   */
	  this.setTriggers = function setTriggers(triggers) {
	    angular.extend(triggerMap, triggers);
	  };
	
	  /**
	   * This is a helper function for translating camel-case to snake-case.
	   */
	  function snake_case(name) {
	    var regexp = /[A-Z]/g;
	    var separator = '-';
	    return name.replace(regexp, function(letter, pos) {
	      return (pos ? separator : '') + letter.toLowerCase();
	    });
	  }
	
	  /**
	   * Returns the actual instance of the $tooltip service.
	   * TODO support multiple triggers
	   */
	  this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
	    var openedTooltips = $$stackedMap.createNew();
	    $document.on('keypress', function(e) {
	      if (e.which === 27) {
	        var last = openedTooltips.top();
	        if (last) {
	          last.value.close();
	          openedTooltips.removeTop();
	          last = null;
	        }
	      }
	    });
	
	    return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
	      options = angular.extend({}, defaultOptions, globalOptions, options);
	
	      /**
	       * Returns an object of show and hide triggers.
	       *
	       * If a trigger is supplied,
	       * it is used to show the tooltip; otherwise, it will use the `trigger`
	       * option passed to the `$tooltipProvider.options` method; else it will
	       * default to the trigger supplied to this directive factory.
	       *
	       * The hide trigger is based on the show trigger. If the `trigger` option
	       * was passed to the `$tooltipProvider.options` method, it will use the
	       * mapped trigger from `triggerMap` or the passed trigger if the map is
	       * undefined; otherwise, it uses the `triggerMap` value of the show
	       * trigger; else it will just use the show trigger.
	       */
	      function getTriggers(trigger) {
	        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
	        var hide = show.map(function(trigger) {
	          return triggerMap[trigger] || trigger;
	        });
	        return {
	          show: show,
	          hide: hide
	        };
	      }
	
	      var directiveName = snake_case(ttType);
	
	      var startSym = $interpolate.startSymbol();
	      var endSym = $interpolate.endSymbol();
	      var template =
	        '<div '+ directiveName + '-popup '+
	          'title="' + startSym + 'title' + endSym + '" '+
	          (options.useContentExp ?
	            'content-exp="contentExp()" ' :
	            'content="' + startSym + 'content' + endSym + '" ') +
	          'placement="' + startSym + 'placement' + endSym + '" '+
	          'popup-class="' + startSym + 'popupClass' + endSym + '" '+
	          'animation="animation" ' +
	          'is-open="isOpen"' +
	          'origin-scope="origScope" ' +
	          'style="visibility: hidden; display: block; top: -9999px; left: -9999px;"' +
	          '>' +
	        '</div>';
	
	      return {
	        compile: function(tElem, tAttrs) {
	          var tooltipLinker = $compile(template);
	
	          return function link(scope, element, attrs, tooltipCtrl) {
	            var tooltip;
	            var tooltipLinkedScope;
	            var transitionTimeout;
	            var showTimeout;
	            var hideTimeout;
	            var positionTimeout;
	            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
	            var triggers = getTriggers(undefined);
	            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
	            var ttScope = scope.$new(true);
	            var repositionScheduled = false;
	            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
	            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
	            var observers = [];
	
	            var positionTooltip = function() {
	              // check if tooltip exists and is not empty
	              if (!tooltip || !tooltip.html()) { return; }
	
	              if (!positionTimeout) {
	                positionTimeout = $timeout(function() {
	                  // Reset the positioning.
	                  tooltip.css({ top: 0, left: 0 });
	
	                  // Now set the calculated positioning.
	                  var ttCss = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
	                  ttCss.top += 'px';
	                  ttCss.left += 'px';
	                  ttCss.visibility = 'visible';
	                  tooltip.css(ttCss);
	
	                  positionTimeout = null;
	                }, 0, false);
	              }
	            };
	
	            // Set up the correct scope to allow transclusion later
	            ttScope.origScope = scope;
	
	            // By default, the tooltip is not open.
	            // TODO add ability to start tooltip opened
	            ttScope.isOpen = false;
	            openedTooltips.add(ttScope, {
	              close: hide
	            });
	
	            function toggleTooltipBind() {
	              if (!ttScope.isOpen) {
	                showTooltipBind();
	              } else {
	                hideTooltipBind();
	              }
	            }
	
	            // Show the tooltip with delay if specified, otherwise show it immediately
	            function showTooltipBind() {
	              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
	                return;
	              }
	
	              cancelHide();
	              prepareTooltip();
	
	              if (ttScope.popupDelay) {
	                // Do nothing if the tooltip was already scheduled to pop-up.
	                // This happens if show is triggered multiple times before any hide is triggered.
	                if (!showTimeout) {
	                  showTimeout = $timeout(show, ttScope.popupDelay, false);
	                }
	              } else {
	                show();
	              }
	            }
	
	            function hideTooltipBind() {
	              cancelShow();
	
	              if (ttScope.popupCloseDelay) {
	                if (!hideTimeout) {
	                  hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
	                }
	              } else {
	                hide();
	              }
	            }
	
	            // Show the tooltip popup element.
	            function show() {
	              cancelShow();
	              cancelHide();
	
	              // Don't show empty tooltips.
	              if (!ttScope.content) {
	                return angular.noop;
	              }
	
	              createTooltip();
	
	              // And show the tooltip.
	              ttScope.$evalAsync(function() {
	                ttScope.isOpen = true;
	                assignIsOpen(true);
	                positionTooltip();
	              });
	            }
	
	            function cancelShow() {
	              if (showTimeout) {
	                $timeout.cancel(showTimeout);
	                showTimeout = null;
	              }
	
	              if (positionTimeout) {
	                $timeout.cancel(positionTimeout);
	                positionTimeout = null;
	              }
	            }
	
	            // Hide the tooltip popup element.
	            function hide() {
	              cancelShow();
	              cancelHide();
	
	              if (!ttScope) {
	                return;
	              }
	
	              // First things first: we don't show it anymore.
	              ttScope.$evalAsync(function() {
	                ttScope.isOpen = false;
	                assignIsOpen(false);
	                // And now we remove it from the DOM. However, if we have animation, we
	                // need to wait for it to expire beforehand.
	                // FIXME: this is a placeholder for a port of the transitions library.
	                // The fade transition in TWBS is 150ms.
	                if (ttScope.animation) {
	                  if (!transitionTimeout) {
	                    transitionTimeout = $timeout(removeTooltip, 150, false);
	                  }
	                } else {
	                  removeTooltip();
	                }
	              });
	            }
	
	            function cancelHide() {
	              if (hideTimeout) {
	                $timeout.cancel(hideTimeout);
	                hideTimeout = null;
	              }
	              if (transitionTimeout) {
	                $timeout.cancel(transitionTimeout);
	                transitionTimeout = null;
	              }
	            }
	
	            function createTooltip() {
	              // There can only be one tooltip element per directive shown at once.
	              if (tooltip) {
	                return;
	              }
	
	              tooltipLinkedScope = ttScope.$new();
	              tooltip = tooltipLinker(tooltipLinkedScope, function(tooltip) {
	                if (appendToBody) {
	                  $document.find('body').append(tooltip);
	                } else {
	                  element.after(tooltip);
	                }
	              });
	
	              prepObservers();
	            }
	
	            function removeTooltip() {
	              unregisterObservers();
	
	              transitionTimeout = null;
	              if (tooltip) {
	                tooltip.remove();
	                tooltip = null;
	              }
	              if (tooltipLinkedScope) {
	                tooltipLinkedScope.$destroy();
	                tooltipLinkedScope = null;
	              }
	            }
	
	            /**
	             * Set the inital scope values. Once
	             * the tooltip is created, the observers
	             * will be added to keep things in synch.
	             */
	            function prepareTooltip() {
	              ttScope.title = attrs[prefix + 'Title'];
	              if (contentParse) {
	                ttScope.content = contentParse(scope);
	              } else {
	                ttScope.content = attrs[ttType];
	              }
	
	              ttScope.popupClass = attrs[prefix + 'Class'];
	              ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
	
	              var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
	              var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
	              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
	              ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
	            }
	
	            function assignIsOpen(isOpen) {
	              if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
	                isOpenParse.assign(scope, isOpen);
	              }
	            }
	
	            ttScope.contentExp = function() {
	              return ttScope.content;
	            };
	
	            /**
	             * Observe the relevant attributes.
	             */
	            attrs.$observe('disabled', function(val) {
	              if (val) {
	                cancelShow();
	              }
	
	              if (val && ttScope.isOpen) {
	                hide();
	              }
	            });
	
	            if (isOpenParse) {
	              scope.$watch(isOpenParse, function(val) {
	                /*jshint -W018 */
	                if (ttScope && !val === ttScope.isOpen) {
	                  toggleTooltipBind();
	                }
	                /*jshint +W018 */
	              });
	            }
	
	            function prepObservers() {
	              observers.length = 0;
	
	              if (contentParse) {
	                observers.push(
	                  scope.$watch(contentParse, function(val) {
	                    ttScope.content = val;
	                    if (!val && ttScope.isOpen) {
	                      hide();
	                    }
	                  })
	                );
	
	                observers.push(
	                  tooltipLinkedScope.$watch(function() {
	                    if (!repositionScheduled) {
	                      repositionScheduled = true;
	                      tooltipLinkedScope.$$postDigest(function() {
	                        repositionScheduled = false;
	                        if (ttScope && ttScope.isOpen) {
	                          positionTooltip();
	                        }
	                      });
	                    }
	                  })
	                );
	              } else {
	                observers.push(
	                  attrs.$observe(ttType, function(val) {
	                    ttScope.content = val;
	                    if (!val && ttScope.isOpen) {
	                      hide();
	                    } else {
	                      positionTooltip();
	                    }
	                  })
	                );
	              }
	
	              observers.push(
	                attrs.$observe(prefix + 'Title', function(val) {
	                  ttScope.title = val;
	                  if (ttScope.isOpen) {
	                    positionTooltip();
	                  }
	                })
	              );
	
	              observers.push(
	                attrs.$observe(prefix + 'Placement', function(val) {
	                  ttScope.placement = val ? val : options.placement;
	                  if (ttScope.isOpen) {
	                    positionTooltip();
	                  }
	                })
	              );
	            }
	
	            function unregisterObservers() {
	              if (observers.length) {
	                angular.forEach(observers, function(observer) {
	                  observer();
	                });
	                observers.length = 0;
	              }
	            }
	
	            var unregisterTriggers = function() {
	              triggers.show.forEach(function(trigger) {
	                element.unbind(trigger, showTooltipBind);
	              });
	              triggers.hide.forEach(function(trigger) {
	                trigger.split(' ').forEach(function(hideTrigger) {
	                  element[0].removeEventListener(hideTrigger, hideTooltipBind);
	                });
	              });
	            };
	
	            function prepTriggers() {
	              var val = attrs[prefix + 'Trigger'];
	              unregisterTriggers();
	
	              triggers = getTriggers(val);
	
	              if (triggers.show !== 'none') {
	                triggers.show.forEach(function(trigger, idx) {
	                  // Using raw addEventListener due to jqLite/jQuery bug - #4060
	                  if (trigger === triggers.hide[idx]) {
	                    element[0].addEventListener(trigger, toggleTooltipBind);
	                  } else if (trigger) {
	                    element[0].addEventListener(trigger, showTooltipBind);
	                    triggers.hide[idx].split(' ').forEach(function(trigger) {
	                      element[0].addEventListener(trigger, hideTooltipBind);
	                    });
	                  }
	
	                  element.on('keypress', function(e) {
	                    if (e.which === 27) {
	                      hideTooltipBind();
	                    }
	                  });
	                });
	              }
	            }
	
	            prepTriggers();
	
	            var animation = scope.$eval(attrs[prefix + 'Animation']);
	            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;
	
	            var appendToBodyVal = scope.$eval(attrs[prefix + 'AppendToBody']);
	            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;
	
	            // if a tooltip is attached to <body> we need to remove it on
	            // location change as its parent scope will probably not be destroyed
	            // by the change.
	            if (appendToBody) {
	              scope.$on('$locationChangeSuccess', function closeTooltipOnLocationChangeSuccess() {
	                if (ttScope.isOpen) {
	                  hide();
	                }
	              });
	            }
	
	            // Make sure tooltip is destroyed and removed.
	            scope.$on('$destroy', function onDestroyTooltip() {
	              cancelShow();
	              cancelHide();
	              unregisterTriggers();
	              removeTooltip();
	              openedTooltips.remove(ttScope);
	              ttScope = null;
	            });
	          };
	        }
	      };
	    };
	  }];
	})
	
	// This is mostly ngInclude code but with a custom scope
	.directive('uibTooltipTemplateTransclude', [
	         '$animate', '$sce', '$compile', '$templateRequest',
	function ($animate ,  $sce ,  $compile ,  $templateRequest) {
	  return {
	    link: function(scope, elem, attrs) {
	      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);
	
	      var changeCounter = 0,
	        currentScope,
	        previousElement,
	        currentElement;
	
	      var cleanupLastIncludeContent = function() {
	        if (previousElement) {
	          previousElement.remove();
	          previousElement = null;
	        }
	
	        if (currentScope) {
	          currentScope.$destroy();
	          currentScope = null;
	        }
	
	        if (currentElement) {
	          $animate.leave(currentElement).then(function() {
	            previousElement = null;
	          });
	          previousElement = currentElement;
	          currentElement = null;
	        }
	      };
	
	      scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function(src) {
	        var thisChangeId = ++changeCounter;
	
	        if (src) {
	          //set the 2nd param to true to ignore the template request error so that the inner
	          //contents and scope can be cleaned up.
	          $templateRequest(src, true).then(function(response) {
	            if (thisChangeId !== changeCounter) { return; }
	            var newScope = origScope.$new();
	            var template = response;
	
	            var clone = $compile(template)(newScope, function(clone) {
	              cleanupLastIncludeContent();
	              $animate.enter(clone, elem);
	            });
	
	            currentScope = newScope;
	            currentElement = clone;
	
	            currentScope.$emit('$includeContentLoaded', src);
	          }, function() {
	            if (thisChangeId === changeCounter) {
	              cleanupLastIncludeContent();
	              scope.$emit('$includeContentError', src);
	            }
	          });
	          scope.$emit('$includeContentRequested', src);
	        } else {
	          cleanupLastIncludeContent();
	        }
	      });
	
	      scope.$on('$destroy', cleanupLastIncludeContent);
	    }
	  };
	}])
	
	/**
	 * Note that it's intentional that these classes are *not* applied through $animate.
	 * They must not be animated as they're expected to be present on the tooltip on
	 * initialization.
	 */
	.directive('uibTooltipClasses', function() {
	  return {
	    restrict: 'A',
	    link: function(scope, element, attrs) {
	      if (scope.placement) {
	        element.addClass(scope.placement);
	      }
	
	      if (scope.popupClass) {
	        element.addClass(scope.popupClass);
	      }
	
	      if (scope.animation()) {
	        element.addClass(attrs.tooltipAnimationClass);
	      }
	    }
	  };
	})
	
	.directive('uibTooltipPopup', function() {
	  return {
	    replace: true,
	    scope: { content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/tooltip/tooltip-popup.html',
	    link: function(scope, element) {
	      element.addClass('tooltip');
	    }
	  };
	})
	
	.directive('uibTooltip', [ '$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
	}])
	
	.directive('uibTooltipTemplatePopup', function() {
	  return {
	    replace: true,
	    scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
	      originScope: '&' },
	    templateUrl: 'template/tooltip/tooltip-template-popup.html',
	    link: function(scope, element) {
	      element.addClass('tooltip');
	    }
	  };
	})
	
	.directive('uibTooltipTemplate', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}])
	
	.directive('uibTooltipHtmlPopup', function() {
	  return {
	    replace: true,
	    scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/tooltip/tooltip-html-popup.html',
	    link: function(scope, element) {
	      element.addClass('tooltip');
	    }
	  };
	})
	
	.directive('uibTooltipHtml', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}]);
	
	/* Deprecated tooltip below */
	
	angular.module('ui.bootstrap.tooltip')
	
	.value('$tooltipSuppressWarning', false)
	
	.provider('$tooltip', ['$uibTooltipProvider', function($uibTooltipProvider) {
	  angular.extend(this, $uibTooltipProvider);
	
	  this.$get = ['$log', '$tooltipSuppressWarning', '$injector', function($log, $tooltipSuppressWarning, $injector) {
	    if (!$tooltipSuppressWarning) {
	      $log.warn('$tooltip is now deprecated. Use $uibTooltip instead.');
	    }
	
	    return $injector.invoke($uibTooltipProvider.$get);
	  }];
	}])
	
	// This is mostly ngInclude code but with a custom scope
	.directive('tooltipTemplateTransclude', [
	         '$animate', '$sce', '$compile', '$templateRequest', '$log', '$tooltipSuppressWarning',
	function ($animate ,  $sce ,  $compile ,  $templateRequest,   $log,   $tooltipSuppressWarning) {
	  return {
	    link: function(scope, elem, attrs) {
	      if (!$tooltipSuppressWarning) {
	        $log.warn('tooltip-template-transclude is now deprecated. Use uib-tooltip-template-transclude instead.');
	      }
	
	      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);
	
	      var changeCounter = 0,
	        currentScope,
	        previousElement,
	        currentElement;
	
	      var cleanupLastIncludeContent = function() {
	        if (previousElement) {
	          previousElement.remove();
	          previousElement = null;
	        }
	        if (currentScope) {
	          currentScope.$destroy();
	          currentScope = null;
	        }
	        if (currentElement) {
	          $animate.leave(currentElement).then(function() {
	            previousElement = null;
	          });
	          previousElement = currentElement;
	          currentElement = null;
	        }
	      };
	
	      scope.$watch($sce.parseAsResourceUrl(attrs.tooltipTemplateTransclude), function(src) {
	        var thisChangeId = ++changeCounter;
	
	        if (src) {
	          //set the 2nd param to true to ignore the template request error so that the inner
	          //contents and scope can be cleaned up.
	          $templateRequest(src, true).then(function(response) {
	            if (thisChangeId !== changeCounter) { return; }
	            var newScope = origScope.$new();
	            var template = response;
	
	            var clone = $compile(template)(newScope, function(clone) {
	              cleanupLastIncludeContent();
	              $animate.enter(clone, elem);
	            });
	
	            currentScope = newScope;
	            currentElement = clone;
	
	            currentScope.$emit('$includeContentLoaded', src);
	          }, function() {
	            if (thisChangeId === changeCounter) {
	              cleanupLastIncludeContent();
	              scope.$emit('$includeContentError', src);
	            }
	          });
	          scope.$emit('$includeContentRequested', src);
	        } else {
	          cleanupLastIncludeContent();
	        }
	      });
	
	      scope.$on('$destroy', cleanupLastIncludeContent);
	    }
	  };
	}])
	
	.directive('tooltipClasses', ['$log', '$tooltipSuppressWarning', function($log, $tooltipSuppressWarning) {
	  return {
	    restrict: 'A',
	    link: function(scope, element, attrs) {
	      if (!$tooltipSuppressWarning) {
	        $log.warn('tooltip-classes is now deprecated. Use uib-tooltip-classes instead.');
	      }
	
	      if (scope.placement) {
	        element.addClass(scope.placement);
	      }
	      if (scope.popupClass) {
	        element.addClass(scope.popupClass);
	      }
	      if (scope.animation()) {
	        element.addClass(attrs.tooltipAnimationClass);
	      }
	    }
	  };
	}])
	
	.directive('tooltipPopup', ['$log', '$tooltipSuppressWarning', function($log, $tooltipSuppressWarning) {
	  return {
	    replace: true,
	    scope: { content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/tooltip/tooltip-popup.html',
	    link: function(scope, element) {
	      if (!$tooltipSuppressWarning) {
	        $log.warn('tooltip-popup is now deprecated. Use uib-tooltip-popup instead.');
	      }
	
	      element.addClass('tooltip');
	    }
	  };
	}])
	
	.directive('tooltip', ['$tooltip', function($tooltip) {
	  return $tooltip('tooltip', 'tooltip', 'mouseenter');
	}])
	
	.directive('tooltipTemplatePopup', ['$log', '$tooltipSuppressWarning', function($log, $tooltipSuppressWarning) {
	  return {
	    replace: true,
	    scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
	      originScope: '&' },
	    templateUrl: 'template/tooltip/tooltip-template-popup.html',
	    link: function(scope, element) {
	      if (!$tooltipSuppressWarning) {
	        $log.warn('tooltip-template-popup is now deprecated. Use uib-tooltip-template-popup instead.');
	      }
	
	      element.addClass('tooltip');
	    }
	  };
	}])
	
	.directive('tooltipTemplate', ['$tooltip', function($tooltip) {
	  return $tooltip('tooltipTemplate', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}])
	
	.directive('tooltipHtmlPopup', ['$log', '$tooltipSuppressWarning', function($log, $tooltipSuppressWarning) {
	  return {
	    replace: true,
	    scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/tooltip/tooltip-html-popup.html',
	    link: function(scope, element) {
	      if (!$tooltipSuppressWarning) {
	        $log.warn('tooltip-html-popup is now deprecated. Use uib-tooltip-html-popup instead.');
	      }
	
	      element.addClass('tooltip');
	    }
	  };
	}])
	
	.directive('tooltipHtml', ['$tooltip', function($tooltip) {
	  return $tooltip('tooltipHtml', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}]);
	
	/**
	 * The following features are still outstanding: popup delay, animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, and selector delegatation.
	 */
	angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip'])
	
	.directive('uibPopoverTemplatePopup', function() {
	  return {
	    replace: true,
	    scope: { title: '@', contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
	      originScope: '&' },
	    templateUrl: 'template/popover/popover-template.html',
	    link: function(scope, element) {
	      element.addClass('popover');
	    }
	  };
	})
	
	.directive('uibPopoverTemplate', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
	    useContentExp: true
	  });
	}])
	
	.directive('uibPopoverHtmlPopup', function() {
	  return {
	    replace: true,
	    scope: { contentExp: '&', title: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/popover/popover-html.html',
	    link: function(scope, element) {
	      element.addClass('popover');
	    }
	  };
	})
	
	.directive('uibPopoverHtml', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
	    useContentExp: true
	  });
	}])
	
	.directive('uibPopoverPopup', function() {
	  return {
	    replace: true,
	    scope: { title: '@', content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/popover/popover.html',
	    link: function(scope, element) {
	      element.addClass('popover');
	    }
	  };
	})
	
	.directive('uibPopover', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibPopover', 'popover', 'click');
	}]);
	
	/* Deprecated popover below */
	
	angular.module('ui.bootstrap.popover')
	
	.value('$popoverSuppressWarning', false)
	
	.directive('popoverTemplatePopup', ['$log', '$popoverSuppressWarning', function($log, $popoverSuppressWarning) {
	  return {
	    replace: true,
	    scope: { title: '@', contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
	      originScope: '&' },
	    templateUrl: 'template/popover/popover-template.html',
	    link: function(scope, element) {
	      if (!$popoverSuppressWarning) {
	        $log.warn('popover-template-popup is now deprecated. Use uib-popover-template-popup instead.');
	      }
	
	      element.addClass('popover');
	    }
	  };
	}])
	
	.directive('popoverTemplate', ['$tooltip', function($tooltip) {
	  return $tooltip('popoverTemplate', 'popover', 'click', {
	    useContentExp: true
	  });
	}])
	
	.directive('popoverHtmlPopup', ['$log', '$popoverSuppressWarning', function($log, $popoverSuppressWarning) {
	  return {
	    replace: true,
	    scope: { contentExp: '&', title: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/popover/popover-html.html',
	    link: function(scope, element) {
	      if (!$popoverSuppressWarning) {
	        $log.warn('popover-html-popup is now deprecated. Use uib-popover-html-popup instead.');
	      }
	
	      element.addClass('popover');
	    }
	  };
	}])
	
	.directive('popoverHtml', ['$tooltip', function($tooltip) {
	  return $tooltip('popoverHtml', 'popover', 'click', {
	    useContentExp: true
	  });
	}])
	
	.directive('popoverPopup', ['$log', '$popoverSuppressWarning', function($log, $popoverSuppressWarning) {
	  return {
	    replace: true,
	    scope: { title: '@', content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
	    templateUrl: 'template/popover/popover.html',
	    link: function(scope, element) {
	      if (!$popoverSuppressWarning) {
	        $log.warn('popover-popup is now deprecated. Use uib-popover-popup instead.');
	      }
	
	      element.addClass('popover');
	    }
	  };
	}])
	
	.directive('popover', ['$tooltip', function($tooltip) {
	
	  return $tooltip('popover', 'popover', 'click');
	}]);
	
	angular.module('ui.bootstrap.progressbar', [])
	
	.constant('uibProgressConfig', {
	  animate: true,
	  max: 100
	})
	
	.controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function($scope, $attrs, progressConfig) {
	  var self = this,
	      animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;
	
	  this.bars = [];
	  $scope.max = angular.isDefined($scope.max) ? $scope.max : progressConfig.max;
	
	  this.addBar = function(bar, element, attrs) {
	    if (!animate) {
	      element.css({'transition': 'none'});
	    }
	
	    this.bars.push(bar);
	
	    bar.max = $scope.max;
	    bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';
	
	    bar.$watch('value', function(value) {
	      bar.recalculatePercentage();
	    });
	
	    bar.recalculatePercentage = function() {
	      var totalPercentage = self.bars.reduce(function(total, bar) {
	        bar.percent = +(100 * bar.value / bar.max).toFixed(2);
	        return total + bar.percent;
	      }, 0);
	
	      if (totalPercentage > 100) {
	        bar.percent -= totalPercentage - 100;
	      }
	    };
	
	    bar.$on('$destroy', function() {
	      element = null;
	      self.removeBar(bar);
	    });
	  };
	
	  this.removeBar = function(bar) {
	    this.bars.splice(this.bars.indexOf(bar), 1);
	    this.bars.forEach(function (bar) {
	      bar.recalculatePercentage();
	    });
	  };
	
	  $scope.$watch('max', function(max) {
	    self.bars.forEach(function(bar) {
	      bar.max = $scope.max;
	      bar.recalculatePercentage();
	    });
	  });
	}])
	
	.directive('uibProgress', function() {
	  return {
	    replace: true,
	    transclude: true,
	    controller: 'UibProgressController',
	    require: 'uibProgress',
	    scope: {
	      max: '=?'
	    },
	    templateUrl: 'template/progressbar/progress.html'
	  };
	})
	
	.directive('uibBar', function() {
	  return {
	    replace: true,
	    transclude: true,
	    require: '^uibProgress',
	    scope: {
	      value: '=',
	      type: '@'
	    },
	    templateUrl: 'template/progressbar/bar.html',
	    link: function(scope, element, attrs, progressCtrl) {
	      progressCtrl.addBar(scope, element, attrs);
	    }
	  };
	})
	
	.directive('uibProgressbar', function() {
	  return {
	    replace: true,
	    transclude: true,
	    controller: 'UibProgressController',
	    scope: {
	      value: '=',
	      max: '=?',
	      type: '@'
	    },
	    templateUrl: 'template/progressbar/progressbar.html',
	    link: function(scope, element, attrs, progressCtrl) {
	      progressCtrl.addBar(scope, angular.element(element.children()[0]), {title: attrs.title});
	    }
	  };
	});
	
	/* Deprecated progressbar below */
	
	angular.module('ui.bootstrap.progressbar')
	
	.value('$progressSuppressWarning', false)
	
	.controller('ProgressController', ['$scope', '$attrs', 'uibProgressConfig', '$log', '$progressSuppressWarning', function($scope, $attrs, progressConfig, $log, $progressSuppressWarning) {
	  if (!$progressSuppressWarning) {
	    $log.warn('ProgressController is now deprecated. Use UibProgressController instead.');
	  }
	
	  var self = this,
	    animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;
	
	  this.bars = [];
	  $scope.max = angular.isDefined($scope.max) ? $scope.max : progressConfig.max;
	
	  this.addBar = function(bar, element, attrs) {
	    if (!animate) {
	      element.css({'transition': 'none'});
	    }
	
	    this.bars.push(bar);
	
	    bar.max = $scope.max;
	    bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';
	
	    bar.$watch('value', function(value) {
	      bar.recalculatePercentage();
	    });
	
	    bar.recalculatePercentage = function() {
	      bar.percent = +(100 * bar.value / bar.max).toFixed(2);
	
	      var totalPercentage = self.bars.reduce(function(total, bar) {
	        return total + bar.percent;
	      }, 0);
	
	      if (totalPercentage > 100) {
	        bar.percent -= totalPercentage - 100;
	      }
	    };
	
	    bar.$on('$destroy', function() {
	      element = null;
	      self.removeBar(bar);
	    });
	  };
	
	  this.removeBar = function(bar) {
	    this.bars.splice(this.bars.indexOf(bar), 1);
	  };
	
	  $scope.$watch('max', function(max) {
	    self.bars.forEach(function(bar) {
	      bar.max = $scope.max;
	      bar.recalculatePercentage();
	    });
	  });
	}])
	
	.directive('progress', ['$log', '$progressSuppressWarning', function($log, $progressSuppressWarning) {
	  return {
	    replace: true,
	    transclude: true,
	    controller: 'ProgressController',
	    require: 'progress',
	    scope: {
	      max: '=?',
	      title: '@?'
	    },
	    templateUrl: 'template/progressbar/progress.html',
	    link: function() {
	      if (!$progressSuppressWarning) {
	        $log.warn('progress is now deprecated. Use uib-progress instead.');
	      }
	    }
	  };
	}])
	
	.directive('bar', ['$log', '$progressSuppressWarning', function($log, $progressSuppressWarning) {
	  return {
	    replace: true,
	    transclude: true,
	    require: '^progress',
	    scope: {
	      value: '=',
	      type: '@'
	    },
	    templateUrl: 'template/progressbar/bar.html',
	    link: function(scope, element, attrs, progressCtrl) {
	      if (!$progressSuppressWarning) {
	        $log.warn('bar is now deprecated. Use uib-bar instead.');
	      }
	      progressCtrl.addBar(scope, element);
	    }
	  };
	}])
	
	.directive('progressbar', ['$log', '$progressSuppressWarning', function($log, $progressSuppressWarning) {
	  return {
	    replace: true,
	    transclude: true,
	    controller: 'ProgressController',
	    scope: {
	      value: '=',
	      max: '=?',
	      type: '@'
	    },
	    templateUrl: 'template/progressbar/progressbar.html',
	    link: function(scope, element, attrs, progressCtrl) {
	      if (!$progressSuppressWarning) {
	        $log.warn('progressbar is now deprecated. Use uib-progressbar instead.');
	      }
	      progressCtrl.addBar(scope, angular.element(element.children()[0]), {title: attrs.title});
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.rating', [])
	
	.constant('uibRatingConfig', {
	  max: 5,
	  stateOn: null,
	  stateOff: null,
	  titles : ['one', 'two', 'three', 'four', 'five']
	})
	
	.controller('UibRatingController', ['$scope', '$attrs', 'uibRatingConfig', function($scope, $attrs, ratingConfig) {
	  var ngModelCtrl  = { $setViewValue: angular.noop };
	
	  this.init = function(ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    ngModelCtrl.$formatters.push(function(value) {
	      if (angular.isNumber(value) && value << 0 !== value) {
	        value = Math.round(value);
	      }
	      return value;
	    });
	
	    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
	    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
	    var tmpTitles = angular.isDefined($attrs.titles)  ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles ;
	    this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ?
	      tmpTitles : ratingConfig.titles;
	
	    var ratingStates = angular.isDefined($attrs.ratingStates) ?
	      $scope.$parent.$eval($attrs.ratingStates) :
	      new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
	    $scope.range = this.buildTemplateObjects(ratingStates);
	  };
	
	  this.buildTemplateObjects = function(states) {
	    for (var i = 0, n = states.length; i < n; i++) {
	      states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(i) }, states[i]);
	    }
	    return states;
	  };
	
	  this.getTitle = function(index) {
	    if (index >= this.titles.length) {
	      return index + 1;
	    } else {
	      return this.titles[index];
	    }
	  };
	
	  $scope.rate = function(value) {
	    if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
	      ngModelCtrl.$setViewValue(ngModelCtrl.$viewValue === value ? 0 : value);
	      ngModelCtrl.$render();
	    }
	  };
	
	  $scope.enter = function(value) {
	    if (!$scope.readonly) {
	      $scope.value = value;
	    }
	    $scope.onHover({value: value});
	  };
	
	  $scope.reset = function() {
	    $scope.value = ngModelCtrl.$viewValue;
	    $scope.onLeave();
	  };
	
	  $scope.onKeydown = function(evt) {
	    if (/(37|38|39|40)/.test(evt.which)) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
	    }
	  };
	
	  this.render = function() {
	    $scope.value = ngModelCtrl.$viewValue;
	  };
	}])
	
	.directive('uibRating', function() {
	  return {
	    require: ['uibRating', 'ngModel'],
	    scope: {
	      readonly: '=?',
	      onHover: '&',
	      onLeave: '&'
	    },
	    controller: 'UibRatingController',
	    templateUrl: 'template/rating/rating.html',
	    replace: true,
	    link: function(scope, element, attrs, ctrls) {
	      var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	      ratingCtrl.init(ngModelCtrl);
	    }
	  };
	});
	
	/* Deprecated rating below */
	
	angular.module('ui.bootstrap.rating')
	
	.value('$ratingSuppressWarning', false)
	
	.controller('RatingController', ['$scope', '$attrs', '$controller', '$log', '$ratingSuppressWarning', function($scope, $attrs, $controller, $log, $ratingSuppressWarning) {
	  if (!$ratingSuppressWarning) {
	    $log.warn('RatingController is now deprecated. Use UibRatingController instead.');
	  }
	
	  angular.extend(this, $controller('UibRatingController', {
	    $scope: $scope,
	    $attrs: $attrs
	  }));
	}])
	
	.directive('rating', ['$log', '$ratingSuppressWarning', function($log, $ratingSuppressWarning) {
	  return {
	    require: ['rating', 'ngModel'],
	    scope: {
	      readonly: '=?',
	      onHover: '&',
	      onLeave: '&'
	    },
	    controller: 'RatingController',
	    templateUrl: 'template/rating/rating.html',
	    replace: true,
	    link: function(scope, element, attrs, ctrls) {
	      if (!$ratingSuppressWarning) {
	        $log.warn('rating is now deprecated. Use uib-rating instead.');
	      }
	      var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	      ratingCtrl.init(ngModelCtrl);
	    }
	  };
	}]);
	
	
	/**
	 * @ngdoc overview
	 * @name ui.bootstrap.tabs
	 *
	 * @description
	 * AngularJS version of the tabs directive.
	 */
	
	angular.module('ui.bootstrap.tabs', [])
	
	.controller('UibTabsetController', ['$scope', function ($scope) {
	  var ctrl = this,
	      tabs = ctrl.tabs = $scope.tabs = [];
	
	  ctrl.select = function(selectedTab) {
	    angular.forEach(tabs, function(tab) {
	      if (tab.active && tab !== selectedTab) {
	        tab.active = false;
	        tab.onDeselect();
	        selectedTab.selectCalled = false;
	      }
	    });
	    selectedTab.active = true;
	    // only call select if it has not already been called
	    if (!selectedTab.selectCalled) {
	      selectedTab.onSelect();
	      selectedTab.selectCalled = true;
	    }
	  };
	
	  ctrl.addTab = function addTab(tab) {
	    tabs.push(tab);
	    // we can't run the select function on the first tab
	    // since that would select it twice
	    if (tabs.length === 1 && tab.active !== false) {
	      tab.active = true;
	    } else if (tab.active) {
	      ctrl.select(tab);
	    } else {
	      tab.active = false;
	    }
	  };
	
	  ctrl.removeTab = function removeTab(tab) {
	    var index = tabs.indexOf(tab);
	    //Select a new tab if the tab to be removed is selected and not destroyed
	    if (tab.active && tabs.length > 1 && !destroyed) {
	      //If this is the last tab, select the previous tab. else, the next tab.
	      var newActiveIndex = index == tabs.length - 1 ? index - 1 : index + 1;
	      ctrl.select(tabs[newActiveIndex]);
	    }
	    tabs.splice(index, 1);
	  };
	
	  var destroyed;
	  $scope.$on('$destroy', function() {
	    destroyed = true;
	  });
	}])
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.tabs.directive:tabset
	 * @restrict EA
	 *
	 * @description
	 * Tabset is the outer container for the tabs directive
	 *
	 * @param {boolean=} vertical Whether or not to use vertical styling for the tabs.
	 * @param {boolean=} justified Whether or not to use justified styling for the tabs.
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	    <uib-tabset>
	      <uib-tab heading="Tab 1"><b>First</b> Content!</uib-tab>
	      <uib-tab heading="Tab 2"><i>Second</i> Content!</uib-tab>
	    </uib-tabset>
	    <hr />
	    <uib-tabset vertical="true">
	      <uib-tab heading="Vertical Tab 1"><b>First</b> Vertical Content!</uib-tab>
	      <uib-tab heading="Vertical Tab 2"><i>Second</i> Vertical Content!</uib-tab>
	    </uib-tabset>
	    <uib-tabset justified="true">
	      <uib-tab heading="Justified Tab 1"><b>First</b> Justified Content!</uib-tab>
	      <uib-tab heading="Justified Tab 2"><i>Second</i> Justified Content!</uib-tab>
	    </uib-tabset>
	  </file>
	</example>
	 */
	.directive('uibTabset', function() {
	  return {
	    restrict: 'EA',
	    transclude: true,
	    replace: true,
	    scope: {
	      type: '@'
	    },
	    controller: 'UibTabsetController',
	    templateUrl: 'template/tabs/tabset.html',
	    link: function(scope, element, attrs) {
	      scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
	      scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
	    }
	  };
	})
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.tabs.directive:tab
	 * @restrict EA
	 *
	 * @param {string=} heading The visible heading, or title, of the tab. Set HTML headings with {@link ui.bootstrap.tabs.directive:tabHeading tabHeading}.
	 * @param {string=} select An expression to evaluate when the tab is selected.
	 * @param {boolean=} active A binding, telling whether or not this tab is selected.
	 * @param {boolean=} disabled A binding, telling whether or not this tab is disabled.
	 *
	 * @description
	 * Creates a tab with a heading and content. Must be placed within a {@link ui.bootstrap.tabs.directive:tabset tabset}.
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	    <div ng-controller="TabsDemoCtrl">
	      <button class="btn btn-small" ng-click="items[0].active = true">
	        Select item 1, using active binding
	      </button>
	      <button class="btn btn-small" ng-click="items[1].disabled = !items[1].disabled">
	        Enable/disable item 2, using disabled binding
	      </button>
	      <br />
	      <uib-tabset>
	        <uib-tab heading="Tab 1">First Tab</uib-tab>
	        <uib-tab select="alertMe()">
	          <uib-tab-heading><i class="icon-bell"></i> Alert me!</tab-heading>
	          Second Tab, with alert callback and html heading!
	        </uib-tab>
	        <uib-tab ng-repeat="item in items"
	          heading="{{item.title}}"
	          disabled="item.disabled"
	          active="item.active">
	          {{item.content}}
	        </uib-tab>
	      </uib-tabset>
	    </div>
	  </file>
	  <file name="script.js">
	    function TabsDemoCtrl($scope) {
	      $scope.items = [
	        { title:"Dynamic Title 1", content:"Dynamic Item 0" },
	        { title:"Dynamic Title 2", content:"Dynamic Item 1", disabled: true }
	      ];
	
	      $scope.alertMe = function() {
	        setTimeout(function() {
	          alert("You've selected the alert tab!");
	        });
	      };
	    };
	  </file>
	</example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ui.bootstrap.tabs.directive:tabHeading
	 * @restrict EA
	 *
	 * @description
	 * Creates an HTML heading for a {@link ui.bootstrap.tabs.directive:tab tab}. Must be placed as a child of a tab element.
	 *
	 * @example
	<example module="ui.bootstrap">
	  <file name="index.html">
	    <uib-tabset>
	      <uib-tab>
	        <uib-tab-heading><b>HTML</b> in my titles?!</tab-heading>
	        And some content, too!
	      </uib-tab>
	      <uib-tab>
	        <uib-tab-heading><i class="icon-heart"></i> Icon heading?!?</tab-heading>
	        That's right.
	      </uib-tab>
	    </uib-tabset>
	  </file>
	</example>
	 */
	.directive('uibTab', ['$parse', function($parse) {
	  return {
	    require: '^uibTabset',
	    restrict: 'EA',
	    replace: true,
	    templateUrl: 'template/tabs/tab.html',
	    transclude: true,
	    scope: {
	      active: '=?',
	      heading: '@',
	      onSelect: '&select', //This callback is called in contentHeadingTransclude
	                          //once it inserts the tab's content into the dom
	      onDeselect: '&deselect'
	    },
	    controller: function() {
	      //Empty controller so other directives can require being 'under' a tab
	    },
	    link: function(scope, elm, attrs, tabsetCtrl, transclude) {
	      scope.$watch('active', function(active) {
	        if (active) {
	          tabsetCtrl.select(scope);
	        }
	      });
	
	      scope.disabled = false;
	      if (attrs.disable) {
	        scope.$parent.$watch($parse(attrs.disable), function(value) {
	          scope.disabled = !! value;
	        });
	      }
	
	      scope.select = function() {
	        if (!scope.disabled) {
	          scope.active = true;
	        }
	      };
	
	      tabsetCtrl.addTab(scope);
	      scope.$on('$destroy', function() {
	        tabsetCtrl.removeTab(scope);
	      });
	
	      //We need to transclude later, once the content container is ready.
	      //when this link happens, we're inside a tab heading.
	      scope.$transcludeFn = transclude;
	    }
	  };
	}])
	
	.directive('uibTabHeadingTransclude', function() {
	  return {
	    restrict: 'A',
	    require: ['?^uibTab', '?^tab'], // TODO: change to '^uibTab' after deprecation removal
	    link: function(scope, elm) {
	      scope.$watch('headingElement', function updateHeadingElement(heading) {
	        if (heading) {
	          elm.html('');
	          elm.append(heading);
	        }
	      });
	    }
	  };
	})
	
	.directive('uibTabContentTransclude', function() {
	  return {
	    restrict: 'A',
	    require: ['?^uibTabset', '?^tabset'], // TODO: change to '^uibTabset' after deprecation removal
	    link: function(scope, elm, attrs) {
	      var tab = scope.$eval(attrs.uibTabContentTransclude);
	
	      //Now our tab is ready to be transcluded: both the tab heading area
	      //and the tab content area are loaded.  Transclude 'em both.
	      tab.$transcludeFn(tab.$parent, function(contents) {
	        angular.forEach(contents, function(node) {
	          if (isTabHeading(node)) {
	            //Let tabHeadingTransclude know.
	            tab.headingElement = node;
	          } else {
	            elm.append(node);
	          }
	        });
	      });
	    }
	  };
	
	  function isTabHeading(node) {
	    return node.tagName && (
	      node.hasAttribute('tab-heading') || // TODO: remove after deprecation removal
	      node.hasAttribute('data-tab-heading') || // TODO: remove after deprecation removal
	      node.hasAttribute('x-tab-heading') || // TODO: remove after deprecation removal
	      node.hasAttribute('uib-tab-heading') ||
	      node.hasAttribute('data-uib-tab-heading') ||
	      node.hasAttribute('x-uib-tab-heading') ||
	      node.tagName.toLowerCase() === 'tab-heading' || // TODO: remove after deprecation removal
	      node.tagName.toLowerCase() === 'data-tab-heading' || // TODO: remove after deprecation removal
	      node.tagName.toLowerCase() === 'x-tab-heading' || // TODO: remove after deprecation removal
	      node.tagName.toLowerCase() === 'uib-tab-heading' ||
	      node.tagName.toLowerCase() === 'data-uib-tab-heading' ||
	      node.tagName.toLowerCase() === 'x-uib-tab-heading'
	    );
	  }
	});
	
	/* deprecated tabs below */
	
	angular.module('ui.bootstrap.tabs')
	
	  .value('$tabsSuppressWarning', false)
	
	  .controller('TabsetController', ['$scope', '$controller', '$log', '$tabsSuppressWarning', function($scope, $controller, $log, $tabsSuppressWarning) {
	    if (!$tabsSuppressWarning) {
	      $log.warn('TabsetController is now deprecated. Use UibTabsetController instead.');
	    }
	
	    angular.extend(this, $controller('UibTabsetController', {
	      $scope: $scope
	    }));
	  }])
	
	  .directive('tabset', ['$log', '$tabsSuppressWarning', function($log, $tabsSuppressWarning) {
	    return {
	      restrict: 'EA',
	      transclude: true,
	      replace: true,
	      scope: {
	        type: '@'
	      },
	      controller: 'TabsetController',
	      templateUrl: 'template/tabs/tabset.html',
	      link: function(scope, element, attrs) {
	
	        if (!$tabsSuppressWarning) {
	          $log.warn('tabset is now deprecated. Use uib-tabset instead.');
	        }
	        scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
	        scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
	      }
	    };
	  }])
	
	  .directive('tab', ['$parse', '$log', '$tabsSuppressWarning', function($parse, $log, $tabsSuppressWarning) {
	    return {
	      require: '^tabset',
	      restrict: 'EA',
	      replace: true,
	      templateUrl: 'template/tabs/tab.html',
	      transclude: true,
	      scope: {
	        active: '=?',
	        heading: '@',
	        onSelect: '&select', //This callback is called in contentHeadingTransclude
	        //once it inserts the tab's content into the dom
	        onDeselect: '&deselect'
	      },
	      controller: function() {
	        //Empty controller so other directives can require being 'under' a tab
	      },
	      link: function(scope, elm, attrs, tabsetCtrl, transclude) {
	        if (!$tabsSuppressWarning) {
	          $log.warn('tab is now deprecated. Use uib-tab instead.');
	        }
	
	        scope.$watch('active', function(active) {
	          if (active) {
	            tabsetCtrl.select(scope);
	          }
	        });
	
	        scope.disabled = false;
	        if (attrs.disable) {
	          scope.$parent.$watch($parse(attrs.disable), function(value) {
	            scope.disabled = !!value;
	          });
	        }
	
	        scope.select = function() {
	          if (!scope.disabled) {
	            scope.active = true;
	          }
	        };
	
	        tabsetCtrl.addTab(scope);
	        scope.$on('$destroy', function() {
	          tabsetCtrl.removeTab(scope);
	        });
	
	        //We need to transclude later, once the content container is ready.
	        //when this link happens, we're inside a tab heading.
	        scope.$transcludeFn = transclude;
	      }
	    };
	  }])
	
	  .directive('tabHeadingTransclude', ['$log', '$tabsSuppressWarning', function($log, $tabsSuppressWarning) {
	    return {
	      restrict: 'A',
	      require: '^tab',
	      link: function(scope, elm) {
	        if (!$tabsSuppressWarning) {
	          $log.warn('tab-heading-transclude is now deprecated. Use uib-tab-heading-transclude instead.');
	        }
	
	        scope.$watch('headingElement', function updateHeadingElement(heading) {
	          if (heading) {
	            elm.html('');
	            elm.append(heading);
	          }
	        });
	      }
	    };
	  }])
	
	  .directive('tabContentTransclude', ['$log', '$tabsSuppressWarning', function($log, $tabsSuppressWarning) {
	    return {
	      restrict: 'A',
	      require: '^tabset',
	      link: function(scope, elm, attrs) {
	        if (!$tabsSuppressWarning) {
	          $log.warn('tab-content-transclude is now deprecated. Use uib-tab-content-transclude instead.');
	        }
	
	        var tab = scope.$eval(attrs.tabContentTransclude);
	
	        //Now our tab is ready to be transcluded: both the tab heading area
	        //and the tab content area are loaded.  Transclude 'em both.
	        tab.$transcludeFn(tab.$parent, function(contents) {
	          angular.forEach(contents, function(node) {
	            if (isTabHeading(node)) {
	              //Let tabHeadingTransclude know.
	              tab.headingElement = node;
	            }
	            else {
	              elm.append(node);
	            }
	          });
	        });
	      }
	    };
	
	    function isTabHeading(node) {
	      return node.tagName && (
	          node.hasAttribute('tab-heading') ||
	          node.hasAttribute('data-tab-heading') ||
	          node.hasAttribute('x-tab-heading') ||
	          node.tagName.toLowerCase() === 'tab-heading' ||
	          node.tagName.toLowerCase() === 'data-tab-heading' ||
	          node.tagName.toLowerCase() === 'x-tab-heading'
	        );
	    }
	  }]);
	
	angular.module('ui.bootstrap.timepicker', [])
	
	.constant('uibTimepickerConfig', {
	  hourStep: 1,
	  minuteStep: 1,
	  showMeridian: true,
	  meridians: null,
	  readonlyInput: false,
	  mousewheel: true,
	  arrowkeys: true,
	  showSpinners: true
	})
	
	.controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
	  var selected = new Date(),
	      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
	      meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS;
	
	  $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
	  $element.removeAttr('tabindex');
	
	  this.init = function(ngModelCtrl_, inputs) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    ngModelCtrl.$formatters.unshift(function(modelValue) {
	      return modelValue ? new Date(modelValue) : null;
	    });
	
	    var hoursInputEl = inputs.eq(0),
	        minutesInputEl = inputs.eq(1);
	
	    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;
	    if (mousewheel) {
	      this.setupMousewheelEvents(hoursInputEl, minutesInputEl);
	    }
	
	    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
	    if (arrowkeys) {
	      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl);
	    }
	
	    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
	    this.setupInputEvents(hoursInputEl, minutesInputEl);
	  };
	
	  var hourStep = timepickerConfig.hourStep;
	  if ($attrs.hourStep) {
	    $scope.$parent.$watch($parse($attrs.hourStep), function(value) {
	      hourStep = parseInt(value, 10);
	    });
	  }
	
	  var minuteStep = timepickerConfig.minuteStep;
	  if ($attrs.minuteStep) {
	    $scope.$parent.$watch($parse($attrs.minuteStep), function(value) {
	      minuteStep = parseInt(value, 10);
	    });
	  }
	
	  var min;
	  $scope.$parent.$watch($parse($attrs.min), function(value) {
	    var dt = new Date(value);
	    min = isNaN(dt) ? undefined : dt;
	  });
	
	  var max;
	  $scope.$parent.$watch($parse($attrs.max), function(value) {
	    var dt = new Date(value);
	    max = isNaN(dt) ? undefined : dt;
	  });
	
	  $scope.noIncrementHours = function() {
	    var incrementedSelected = addMinutes(selected, hourStep * 60);
	    return incrementedSelected > max ||
	      (incrementedSelected < selected && incrementedSelected < min);
	  };
	
	  $scope.noDecrementHours = function() {
	    var decrementedSelected = addMinutes(selected, -hourStep * 60);
	    return decrementedSelected < min ||
	      (decrementedSelected > selected && decrementedSelected > max);
	  };
	
	  $scope.noIncrementMinutes = function() {
	    var incrementedSelected = addMinutes(selected, minuteStep);
	    return incrementedSelected > max ||
	      (incrementedSelected < selected && incrementedSelected < min);
	  };
	
	  $scope.noDecrementMinutes = function() {
	    var decrementedSelected = addMinutes(selected, -minuteStep);
	    return decrementedSelected < min ||
	      (decrementedSelected > selected && decrementedSelected > max);
	  };
	
	  $scope.noToggleMeridian = function() {
	    if (selected.getHours() < 13) {
	      return addMinutes(selected, 12 * 60) > max;
	    } else {
	      return addMinutes(selected, -12 * 60) < min;
	    }
	  };
	
	  // 12H / 24H mode
	  $scope.showMeridian = timepickerConfig.showMeridian;
	  if ($attrs.showMeridian) {
	    $scope.$parent.$watch($parse($attrs.showMeridian), function(value) {
	      $scope.showMeridian = !!value;
	
	      if (ngModelCtrl.$error.time) {
	        // Evaluate from template
	        var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
	        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	          selected.setHours(hours);
	          refresh();
	        }
	      } else {
	        updateTemplate();
	      }
	    });
	  }
	
	  // Get $scope.hours in 24H mode if valid
	  function getHoursFromTemplate() {
	    var hours = parseInt($scope.hours, 10);
	    var valid = $scope.showMeridian ? (hours > 0 && hours < 13) : (hours >= 0 && hours < 24);
	    if (!valid) {
	      return undefined;
	    }
	
	    if ($scope.showMeridian) {
	      if (hours === 12) {
	        hours = 0;
	      }
	      if ($scope.meridian === meridians[1]) {
	        hours = hours + 12;
	      }
	    }
	    return hours;
	  }
	
	  function getMinutesFromTemplate() {
	    var minutes = parseInt($scope.minutes, 10);
	    return (minutes >= 0 && minutes < 60) ? minutes : undefined;
	  }
	
	  function pad(value) {
	    return (angular.isDefined(value) && value.toString().length < 2) ? '0' + value : value.toString();
	  }
	
	  // Respond on mousewheel spin
	  this.setupMousewheelEvents = function(hoursInputEl, minutesInputEl) {
	    var isScrollingUp = function(e) {
	      if (e.originalEvent) {
	        e = e.originalEvent;
	      }
	      //pick correct delta variable depending on event
	      var delta = (e.wheelDelta) ? e.wheelDelta : -e.deltaY;
	      return (e.detail || delta > 0);
	    };
	
	    hoursInputEl.bind('mousewheel wheel', function(e) {
	      $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
	      e.preventDefault();
	    });
	
	    minutesInputEl.bind('mousewheel wheel', function(e) {
	      $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
	      e.preventDefault();
	    });
	
	  };
	
	  // Respond on up/down arrowkeys
	  this.setupArrowkeyEvents = function(hoursInputEl, minutesInputEl) {
	    hoursInputEl.bind('keydown', function(e) {
	      if (e.which === 38) { // up
	        e.preventDefault();
	        $scope.incrementHours();
	        $scope.$apply();
	      } else if (e.which === 40) { // down
	        e.preventDefault();
	        $scope.decrementHours();
	        $scope.$apply();
	      }
	    });
	
	    minutesInputEl.bind('keydown', function(e) {
	      if (e.which === 38) { // up
	        e.preventDefault();
	        $scope.incrementMinutes();
	        $scope.$apply();
	      } else if (e.which === 40) { // down
	        e.preventDefault();
	        $scope.decrementMinutes();
	        $scope.$apply();
	      }
	    });
	  };
	
	  this.setupInputEvents = function(hoursInputEl, minutesInputEl) {
	    if ($scope.readonlyInput) {
	      $scope.updateHours = angular.noop;
	      $scope.updateMinutes = angular.noop;
	      return;
	    }
	
	    var invalidate = function(invalidHours, invalidMinutes) {
	      ngModelCtrl.$setViewValue(null);
	      ngModelCtrl.$setValidity('time', false);
	      if (angular.isDefined(invalidHours)) {
	        $scope.invalidHours = invalidHours;
	      }
	      if (angular.isDefined(invalidMinutes)) {
	        $scope.invalidMinutes = invalidMinutes;
	      }
	    };
	
	    $scope.updateHours = function() {
	      var hours = getHoursFromTemplate(),
	        minutes = getMinutesFromTemplate();
	
	      if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	        selected.setHours(hours);
	        if (selected < min || selected > max) {
	          invalidate(true);
	        } else {
	          refresh('h');
	        }
	      } else {
	        invalidate(true);
	      }
	    };
	
	    hoursInputEl.bind('blur', function(e) {
	      if (!$scope.invalidHours && $scope.hours < 10) {
	        $scope.$apply(function() {
	          $scope.hours = pad($scope.hours);
	        });
	      }
	    });
	
	    $scope.updateMinutes = function() {
	      var minutes = getMinutesFromTemplate(),
	        hours = getHoursFromTemplate();
	
	      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
	        selected.setMinutes(minutes);
	        if (selected < min || selected > max) {
	          invalidate(undefined, true);
	        } else {
	          refresh('m');
	        }
	      } else {
	        invalidate(undefined, true);
	      }
	    };
	
	    minutesInputEl.bind('blur', function(e) {
	      if (!$scope.invalidMinutes && $scope.minutes < 10) {
	        $scope.$apply(function() {
	          $scope.minutes = pad($scope.minutes);
	        });
	      }
	    });
	
	  };
	
	  this.render = function() {
	    var date = ngModelCtrl.$viewValue;
	
	    if (isNaN(date)) {
	      ngModelCtrl.$setValidity('time', false);
	      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
	    } else {
	      if (date) {
	        selected = date;
	      }
	
	      if (selected < min || selected > max) {
	        ngModelCtrl.$setValidity('time', false);
	        $scope.invalidHours = true;
	        $scope.invalidMinutes = true;
	      } else {
	        makeValid();
	      }
	      updateTemplate();
	    }
	  };
	
	  // Call internally when we know that model is valid.
	  function refresh(keyboardChange) {
	    makeValid();
	    ngModelCtrl.$setViewValue(new Date(selected));
	    updateTemplate(keyboardChange);
	  }
	
	  function makeValid() {
	    ngModelCtrl.$setValidity('time', true);
	    $scope.invalidHours = false;
	    $scope.invalidMinutes = false;
	  }
	
	  function updateTemplate(keyboardChange) {
	    var hours = selected.getHours(), minutes = selected.getMinutes();
	
	    if ($scope.showMeridian) {
	      hours = (hours === 0 || hours === 12) ? 12 : hours % 12; // Convert 24 to 12 hour system
	    }
	
	    $scope.hours = keyboardChange === 'h' ? hours : pad(hours);
	    if (keyboardChange !== 'm') {
	      $scope.minutes = pad(minutes);
	    }
	    $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
	  }
	
	  function addMinutes(date, minutes) {
	    var dt = new Date(date.getTime() + minutes * 60000);
	    var newDate = new Date(date);
	    newDate.setHours(dt.getHours(), dt.getMinutes());
	    return newDate;
	  }
	
	  function addMinutesToSelected(minutes) {
	    selected = addMinutes(selected, minutes);
	    refresh();
	  }
	
	  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ?
	    $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;
	
	  $scope.incrementHours = function() {
	    if (!$scope.noIncrementHours()) {
	      addMinutesToSelected(hourStep * 60);
	    }
	  };
	
	  $scope.decrementHours = function() {
	    if (!$scope.noDecrementHours()) {
	      addMinutesToSelected(-hourStep * 60);
	    }
	  };
	
	  $scope.incrementMinutes = function() {
	    if (!$scope.noIncrementMinutes()) {
	      addMinutesToSelected(minuteStep);
	    }
	  };
	
	  $scope.decrementMinutes = function() {
	    if (!$scope.noDecrementMinutes()) {
	      addMinutesToSelected(-minuteStep);
	    }
	  };
	
	  $scope.toggleMeridian = function() {
	    if (!$scope.noToggleMeridian()) {
	      addMinutesToSelected(12 * 60 * (selected.getHours() < 12 ? 1 : -1));
	    }
	  };
	}])
	
	.directive('uibTimepicker', function() {
	  return {
	    restrict: 'EA',
	    require: ['uibTimepicker', '?^ngModel'],
	    controller: 'UibTimepickerController',
	    controllerAs: 'timepicker',
	    replace: true,
	    scope: {},
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/timepicker/timepicker.html';
	    },
	    link: function(scope, element, attrs, ctrls) {
	      var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (ngModelCtrl) {
	        timepickerCtrl.init(ngModelCtrl, element.find('input'));
	      }
	    }
	  };
	});
	
	/* Deprecated timepicker below */
	
	angular.module('ui.bootstrap.timepicker')
	
	.value('$timepickerSuppressWarning', false)
	
	.controller('TimepickerController', ['$scope', '$element', '$attrs', '$controller', '$log', '$timepickerSuppressWarning', function($scope, $element, $attrs, $controller, $log, $timepickerSuppressWarning) {
	  if (!$timepickerSuppressWarning) {
	    $log.warn('TimepickerController is now deprecated. Use UibTimepickerController instead.');
	  }
	
	  angular.extend(this, $controller('UibTimepickerController', {
	    $scope: $scope,
	    $element: $element,
	    $attrs: $attrs
	  }));
	}])
	
	.directive('timepicker', ['$log', '$timepickerSuppressWarning', function($log, $timepickerSuppressWarning) {
	  return {
	    restrict: 'EA',
	    require: ['timepicker', '?^ngModel'],
	    controller: 'TimepickerController',
	    controllerAs: 'timepicker',
	    replace: true,
	    scope: {},
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'template/timepicker/timepicker.html';
	    },
	    link: function(scope, element, attrs, ctrls) {
	      if (!$timepickerSuppressWarning) {
	        $log.warn('timepicker is now deprecated. Use uib-timepicker instead.');
	      }
	      var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (ngModelCtrl) {
	        timepickerCtrl.init(ngModelCtrl, element.find('input'));
	      }
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.position'])
	
	/**
	 * A helper service that can parse typeahead's syntax (string provided by users)
	 * Extracted to a separate service for ease of unit testing
	 */
	  .factory('uibTypeaheadParser', ['$parse', function($parse) {
	    //                      00000111000000000000022200000000000000003333333333333330000000000044000
	    var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
	    return {
	      parse: function(input) {
	        var match = input.match(TYPEAHEAD_REGEXP);
	        if (!match) {
	          throw new Error(
	            'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
	              ' but got "' + input + '".');
	        }
	
	        return {
	          itemName: match[3],
	          source: $parse(match[4]),
	          viewMapper: $parse(match[2] || match[1]),
	          modelMapper: $parse(match[1])
	        };
	      }
	    };
	  }])
	
	  .controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$uibPosition', 'uibTypeaheadParser',
	    function(originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $position, typeaheadParser) {
	    var HOT_KEYS = [9, 13, 27, 38, 40];
	    var eventDebounceTime = 200;
	    var modelCtrl, ngModelOptions;
	    //SUPPORTED ATTRIBUTES (OPTIONS)
	
	    //minimal no of characters that needs to be entered before typeahead kicks-in
	    var minLength = originalScope.$eval(attrs.typeaheadMinLength);
	    if (!minLength && minLength !== 0) {
	      minLength = 1;
	    }
	
	    //minimal wait time after last character typed before typeahead kicks-in
	    var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;
	
	    //should it restrict model values to the ones selected from the popup only?
	    var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
	
	    //binding to a variable that indicates if matches are being retrieved asynchronously
	    var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;
	
	    //a callback executed when a match is selected
	    var onSelectCallback = $parse(attrs.typeaheadOnSelect);
	
	    //should it select highlighted popup value when losing focus?
	    var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;
	
	    //binding to a variable that indicates if there were no results after the query is completed
	    var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;
	
	    var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;
	
	    var appendToBody =  attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;
	
	    var appendToElementId =  attrs.typeaheadAppendToElementId || false;
	
	    var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;
	
	    //If input matches an item of the list exactly, select it automatically
	    var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;
	
	    //INTERNAL VARIABLES
	
	    //model setter executed upon match selection
	    var parsedModel = $parse(attrs.ngModel);
	    var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
	    var $setModelValue = function(scope, newValue) {
	      if (angular.isFunction(parsedModel(originalScope)) &&
	        ngModelOptions && ngModelOptions.$options && ngModelOptions.$options.getterSetter) {
	        return invokeModelSetter(scope, {$$$p: newValue});
	      } else {
	        return parsedModel.assign(scope, newValue);
	      }
	    };
	
	    //expressions used by typeahead
	    var parserResult = typeaheadParser.parse(attrs.uibTypeahead);
	
	    var hasFocus;
	
	    //Used to avoid bug in iOS webview where iOS keyboard does not fire
	    //mousedown & mouseup events
	    //Issue #3699
	    var selected;
	
	    //create a child scope for the typeahead directive so we are not polluting original scope
	    //with typeahead-specific data (matches, query etc.)
	    var scope = originalScope.$new();
	    var offDestroy = originalScope.$on('$destroy', function() {
	      scope.$destroy();
	    });
	    scope.$on('$destroy', offDestroy);
	
	    // WAI-ARIA
	    var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
	    element.attr({
	      'aria-autocomplete': 'list',
	      'aria-expanded': false,
	      'aria-owns': popupId
	    });
	
	    //pop-up element used to display matches
	    var popUpEl = angular.element('<div uib-typeahead-popup></div>');
	    popUpEl.attr({
	      id: popupId,
	      matches: 'matches',
	      active: 'activeIdx',
	      select: 'select(activeIdx)',
	      'move-in-progress': 'moveInProgress',
	      query: 'query',
	      position: 'position'
	    });
	    //custom item template
	    if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
	      popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
	    }
	
	    if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
	      popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
	    }
	
	    var resetMatches = function() {
	      scope.matches = [];
	      scope.activeIdx = -1;
	      element.attr('aria-expanded', false);
	    };
	
	    var getMatchId = function(index) {
	      return popupId + '-option-' + index;
	    };
	
	    // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
	    // This attribute is added or removed automatically when the `activeIdx` changes.
	    scope.$watch('activeIdx', function(index) {
	      if (index < 0) {
	        element.removeAttr('aria-activedescendant');
	      } else {
	        element.attr('aria-activedescendant', getMatchId(index));
	      }
	    });
	
	    var inputIsExactMatch = function(inputValue, index) {
	      if (scope.matches.length > index && inputValue) {
	        return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
	      }
	
	      return false;
	    };
	
	    var getMatchesAsync = function(inputValue) {
	      var locals = {$viewValue: inputValue};
	      isLoadingSetter(originalScope, true);
	      isNoResultsSetter(originalScope, false);
	      $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
	        //it might happen that several async queries were in progress if a user were typing fast
	        //but we are interested only in responses that correspond to the current view value
	        var onCurrentRequest = (inputValue === modelCtrl.$viewValue);
	        if (onCurrentRequest && hasFocus) {
	          if (matches && matches.length > 0) {
	            scope.activeIdx = focusFirst ? 0 : -1;
	            isNoResultsSetter(originalScope, false);
	            scope.matches.length = 0;
	
	            //transform labels
	            for (var i = 0; i < matches.length; i++) {
	              locals[parserResult.itemName] = matches[i];
	              scope.matches.push({
	                id: getMatchId(i),
	                label: parserResult.viewMapper(scope, locals),
	                model: matches[i]
	              });
	            }
	
	            scope.query = inputValue;
	            //position pop-up with matches - we need to re-calculate its position each time we are opening a window
	            //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
	            //due to other elements being rendered
	            recalculatePosition();
	
	            element.attr('aria-expanded', true);
	
	            //Select the single remaining option if user input matches
	            if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
	              scope.select(0);
	            }
	          } else {
	            resetMatches();
	            isNoResultsSetter(originalScope, true);
	          }
	        }
	        if (onCurrentRequest) {
	          isLoadingSetter(originalScope, false);
	        }
	      }, function() {
	        resetMatches();
	        isLoadingSetter(originalScope, false);
	        isNoResultsSetter(originalScope, true);
	      });
	    };
	
	    // bind events only if appendToBody params exist - performance feature
	    if (appendToBody) {
	      angular.element($window).bind('resize', fireRecalculating);
	      $document.find('body').bind('scroll', fireRecalculating);
	    }
	
	    // Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
	    var timeoutEventPromise;
	
	    // Default progress type
	    scope.moveInProgress = false;
	
	    function fireRecalculating() {
	      if (!scope.moveInProgress) {
	        scope.moveInProgress = true;
	        scope.$digest();
	      }
	
	      // Cancel previous timeout
	      if (timeoutEventPromise) {
	        $timeout.cancel(timeoutEventPromise);
	      }
	
	      // Debounced executing recalculate after events fired
	      timeoutEventPromise = $timeout(function() {
	        // if popup is visible
	        if (scope.matches.length) {
	          recalculatePosition();
	        }
	
	        scope.moveInProgress = false;
	      }, eventDebounceTime);
	    }
	
	    // recalculate actual position and set new values to scope
	    // after digest loop is popup in right position
	    function recalculatePosition() {
	      scope.position = appendToBody ? $position.offset(element) : $position.position(element);
	      scope.position.top += element.prop('offsetHeight');
	    }
	
	    //we need to propagate user's query so we can higlight matches
	    scope.query = undefined;
	
	    //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
	    var timeoutPromise;
	
	    var scheduleSearchWithTimeout = function(inputValue) {
	      timeoutPromise = $timeout(function() {
	        getMatchesAsync(inputValue);
	      }, waitTime);
	    };
	
	    var cancelPreviousTimeout = function() {
	      if (timeoutPromise) {
	        $timeout.cancel(timeoutPromise);
	      }
	    };
	
	    resetMatches();
	
	    scope.select = function(activeIdx) {
	      //called from within the $digest() cycle
	      var locals = {};
	      var model, item;
	
	      selected = true;
	      locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
	      model = parserResult.modelMapper(originalScope, locals);
	      $setModelValue(originalScope, model);
	      modelCtrl.$setValidity('editable', true);
	      modelCtrl.$setValidity('parse', true);
	
	      onSelectCallback(originalScope, {
	        $item: item,
	        $model: model,
	        $label: parserResult.viewMapper(originalScope, locals)
	      });
	
	      resetMatches();
	
	      //return focus to the input element if a match was selected via a mouse click event
	      // use timeout to avoid $rootScope:inprog error
	      if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
	        $timeout(function() { element[0].focus(); }, 0, false);
	      }
	    };
	
	    //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
	    element.bind('keydown', function(evt) {
	      //typeahead is open and an "interesting" key was pressed
	      if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
	        return;
	      }
	
	      // if there's nothing selected (i.e. focusFirst) and enter or tab is hit, clear the results
	      if (scope.activeIdx === -1 && (evt.which === 9 || evt.which === 13)) {
	        resetMatches();
	        scope.$digest();
	        return;
	      }
	
	      evt.preventDefault();
	
	      if (evt.which === 40) {
	        scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
	        scope.$digest();
	      } else if (evt.which === 38) {
	        scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
	        scope.$digest();
	      } else if (evt.which === 13 || evt.which === 9) {
	        scope.$apply(function () {
	          scope.select(scope.activeIdx);
	        });
	      } else if (evt.which === 27) {
	        evt.stopPropagation();
	
	        resetMatches();
	        scope.$digest();
	      }
	    });
	
	    element.bind('blur', function() {
	      if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
	        selected = true;
	        scope.$apply(function() {
	          scope.select(scope.activeIdx);
	        });
	      }
	      hasFocus = false;
	      selected = false;
	    });
	
	    // Keep reference to click handler to unbind it.
	    var dismissClickHandler = function(evt) {
	      // Issue #3973
	      // Firefox treats right click as a click on document
	      if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
	        resetMatches();
	        if (!$rootScope.$$phase) {
	          scope.$digest();
	        }
	      }
	    };
	
	    $document.bind('click', dismissClickHandler);
	
	    originalScope.$on('$destroy', function() {
	      $document.unbind('click', dismissClickHandler);
	      if (appendToBody || appendToElementId) {
	        $popup.remove();
	      }
	
	      if (appendToBody) {
	        angular.element($window).unbind('resize', fireRecalculating);
	        $document.find('body').unbind('scroll', fireRecalculating);
	      }
	      // Prevent jQuery cache memory leak
	      popUpEl.remove();
	    });
	
	    var $popup = $compile(popUpEl)(scope);
	
	    if (appendToBody) {
	      $document.find('body').append($popup);
	    } else if (appendToElementId !== false) {
	      angular.element($document[0].getElementById(appendToElementId)).append($popup);
	    } else {
	      element.after($popup);
	    }
	
	    this.init = function(_modelCtrl, _ngModelOptions) {
	      modelCtrl = _modelCtrl;
	      ngModelOptions = _ngModelOptions;
	
	      //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
	      //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
	      modelCtrl.$parsers.unshift(function(inputValue) {
	        hasFocus = true;
	
	        if (minLength === 0 || inputValue && inputValue.length >= minLength) {
	          if (waitTime > 0) {
	            cancelPreviousTimeout();
	            scheduleSearchWithTimeout(inputValue);
	          } else {
	            getMatchesAsync(inputValue);
	          }
	        } else {
	          isLoadingSetter(originalScope, false);
	          cancelPreviousTimeout();
	          resetMatches();
	        }
	
	        if (isEditable) {
	          return inputValue;
	        } else {
	          if (!inputValue) {
	            // Reset in case user had typed something previously.
	            modelCtrl.$setValidity('editable', true);
	            return null;
	          } else {
	            modelCtrl.$setValidity('editable', false);
	            return undefined;
	          }
	        }
	      });
	
	      modelCtrl.$formatters.push(function(modelValue) {
	        var candidateViewValue, emptyViewValue;
	        var locals = {};
	
	        // The validity may be set to false via $parsers (see above) if
	        // the model is restricted to selected values. If the model
	        // is set manually it is considered to be valid.
	        if (!isEditable) {
	          modelCtrl.$setValidity('editable', true);
	        }
	
	        if (inputFormatter) {
	          locals.$model = modelValue;
	          return inputFormatter(originalScope, locals);
	        } else {
	          //it might happen that we don't have enough info to properly render input value
	          //we need to check for this situation and simply return model value if we can't apply custom formatting
	          locals[parserResult.itemName] = modelValue;
	          candidateViewValue = parserResult.viewMapper(originalScope, locals);
	          locals[parserResult.itemName] = undefined;
	          emptyViewValue = parserResult.viewMapper(originalScope, locals);
	
	          return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
	        }
	      });
	    };
	  }])
	
	  .directive('uibTypeahead', function() {
	    return {
	      controller: 'UibTypeaheadController',
	      require: ['ngModel', '^?ngModelOptions', 'uibTypeahead'],
	      link: function(originalScope, element, attrs, ctrls) {
	        ctrls[2].init(ctrls[0], ctrls[1]);
	      }
	    };
	  })
	
	  .directive('uibTypeaheadPopup', function() {
	    return {
	      scope: {
	        matches: '=',
	        query: '=',
	        active: '=',
	        position: '&',
	        moveInProgress: '=',
	        select: '&'
	      },
	      replace: true,
	      templateUrl: function(element, attrs) {
	        return attrs.popupTemplateUrl || 'template/typeahead/typeahead-popup.html';
	      },
	      link: function(scope, element, attrs) {
	        scope.templateUrl = attrs.templateUrl;
	
	        scope.isOpen = function() {
	          return scope.matches.length > 0;
	        };
	
	        scope.isActive = function(matchIdx) {
	          return scope.active == matchIdx;
	        };
	
	        scope.selectActive = function(matchIdx) {
	          scope.active = matchIdx;
	        };
	
	        scope.selectMatch = function(activeIdx) {
	          scope.select({activeIdx:activeIdx});
	        };
	      }
	    };
	  })
	
	  .directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function($templateRequest, $compile, $parse) {
	    return {
	      scope: {
	        index: '=',
	        match: '=',
	        query: '='
	      },
	      link:function(scope, element, attrs) {
	        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'template/typeahead/typeahead-match.html';
	        $templateRequest(tplUrl).then(function(tplContent) {
	          $compile(tplContent.trim())(scope, function(clonedElement) {
	            element.replaceWith(clonedElement);
	          });
	        });
	      }
	    };
	  }])
	
	  .filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function($sce, $injector, $log) {
	    var isSanitizePresent;
	    isSanitizePresent = $injector.has('$sanitize');
	
	    function escapeRegexp(queryToEscape) {
	      // Regex: capture the whole query string and replace it with the string that will be used to match
	      // the results, for example if the capture is "a" the result will be \a
	      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	    }
	
	    function containsHtml(matchItem) {
	      return /<.*>/g.test(matchItem);
	    }
	
	    return function(matchItem, query) {
	      if (!isSanitizePresent && containsHtml(matchItem)) {
	        $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
	      }
	      matchItem = query? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
	      if (!isSanitizePresent) {
	        matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
	      }
	      return matchItem;
	    };
	  }]);
	
	/* Deprecated typeahead below */
	  
	angular.module('ui.bootstrap.typeahead')
	  .value('$typeaheadSuppressWarning', false)
	  .service('typeaheadParser', ['$parse', 'uibTypeaheadParser', '$log', '$typeaheadSuppressWarning', function($parse, uibTypeaheadParser, $log, $typeaheadSuppressWarning) {
	    if (!$typeaheadSuppressWarning) {
	      $log.warn('typeaheadParser is now deprecated. Use uibTypeaheadParser instead.');
	    }
	
	    return uibTypeaheadParser;
	  }])
	
	  .directive('typeahead', ['$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$uibPosition', 'typeaheadParser', '$log', '$typeaheadSuppressWarning',
	    function($compile, $parse, $q, $timeout, $document, $window, $rootScope, $position, typeaheadParser, $log, $typeaheadSuppressWarning) {
	    var HOT_KEYS = [9, 13, 27, 38, 40];
	    var eventDebounceTime = 200;
	    return {
	      require: ['ngModel', '^?ngModelOptions'],
	      link: function(originalScope, element, attrs, ctrls) {
	        if (!$typeaheadSuppressWarning) {
	          $log.warn('typeahead is now deprecated. Use uib-typeahead instead.');
	        }
	        var modelCtrl = ctrls[0];
	        var ngModelOptions = ctrls[1];
	        //SUPPORTED ATTRIBUTES (OPTIONS)
	
	        //minimal no of characters that needs to be entered before typeahead kicks-in
	        var minLength = originalScope.$eval(attrs.typeaheadMinLength);
	        if (!minLength && minLength !== 0) {
	          minLength = 1;
	        }
	
	        //minimal wait time after last character typed before typeahead kicks-in
	        var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;
	
	        //should it restrict model values to the ones selected from the popup only?
	        var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
	
	        //binding to a variable that indicates if matches are being retrieved asynchronously
	        var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;
	
	        //a callback executed when a match is selected
	        var onSelectCallback = $parse(attrs.typeaheadOnSelect);
	
	        //should it select highlighted popup value when losing focus?
	        var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;
	
	        //binding to a variable that indicates if there were no results after the query is completed
	        var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;
	
	        var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;
	
	        var appendToBody =  attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;
	
	        var appendToElementId =  attrs.typeaheadAppendToElementId || false;
	
	        var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;
	
	        //If input matches an item of the list exactly, select it automatically
	        var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;
	
	        //INTERNAL VARIABLES
	
	        //model setter executed upon match selection
	        var parsedModel = $parse(attrs.ngModel);
	        var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
	        var $setModelValue = function(scope, newValue) {
	          if (angular.isFunction(parsedModel(originalScope)) &&
	            ngModelOptions && ngModelOptions.$options && ngModelOptions.$options.getterSetter) {
	            return invokeModelSetter(scope, {$$$p: newValue});
	          } else {
	            return parsedModel.assign(scope, newValue);
	          }
	        };
	
	        //expressions used by typeahead
	        var parserResult = typeaheadParser.parse(attrs.typeahead);
	
	        var hasFocus;
	
	        //Used to avoid bug in iOS webview where iOS keyboard does not fire
	        //mousedown & mouseup events
	        //Issue #3699
	        var selected;
	
	        //create a child scope for the typeahead directive so we are not polluting original scope
	        //with typeahead-specific data (matches, query etc.)
	        var scope = originalScope.$new();
	        var offDestroy = originalScope.$on('$destroy', function() {
				    scope.$destroy();
	        });
	        scope.$on('$destroy', offDestroy);
	
	        // WAI-ARIA
	        var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
	        element.attr({
	          'aria-autocomplete': 'list',
	          'aria-expanded': false,
	          'aria-owns': popupId
	        });
	
	        //pop-up element used to display matches
	        var popUpEl = angular.element('<div typeahead-popup></div>');
	        popUpEl.attr({
	          id: popupId,
	          matches: 'matches',
	          active: 'activeIdx',
	          select: 'select(activeIdx)',
	          'move-in-progress': 'moveInProgress',
	          query: 'query',
	          position: 'position'
	        });
	        //custom item template
	        if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
	          popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
	        }
	
	        if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
	          popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
	        }
	
	        var resetMatches = function() {
	          scope.matches = [];
	          scope.activeIdx = -1;
	          element.attr('aria-expanded', false);
	        };
	
	        var getMatchId = function(index) {
	          return popupId + '-option-' + index;
	        };
	
	        // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
	        // This attribute is added or removed automatically when the `activeIdx` changes.
	        scope.$watch('activeIdx', function(index) {
	          if (index < 0) {
	            element.removeAttr('aria-activedescendant');
	          } else {
	            element.attr('aria-activedescendant', getMatchId(index));
	          }
	        });
	
	        var inputIsExactMatch = function(inputValue, index) {
	          if (scope.matches.length > index && inputValue) {
	            return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
	          }
	
	          return false;
	        };
	
	        var getMatchesAsync = function(inputValue) {
	          var locals = {$viewValue: inputValue};
	          isLoadingSetter(originalScope, true);
	          isNoResultsSetter(originalScope, false);
	          $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
	            //it might happen that several async queries were in progress if a user were typing fast
	            //but we are interested only in responses that correspond to the current view value
	            var onCurrentRequest = (inputValue === modelCtrl.$viewValue);
	            if (onCurrentRequest && hasFocus) {
	              if (matches && matches.length > 0) {
	                scope.activeIdx = focusFirst ? 0 : -1;
	                isNoResultsSetter(originalScope, false);
	                scope.matches.length = 0;
	
	                //transform labels
	                for (var i = 0; i < matches.length; i++) {
	                  locals[parserResult.itemName] = matches[i];
	                  scope.matches.push({
	                    id: getMatchId(i),
	                    label: parserResult.viewMapper(scope, locals),
	                    model: matches[i]
	                  });
	                }
	
	                scope.query = inputValue;
	                //position pop-up with matches - we need to re-calculate its position each time we are opening a window
	                //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
	                //due to other elements being rendered
	                recalculatePosition();
	
	                element.attr('aria-expanded', true);
	
	                //Select the single remaining option if user input matches
	                if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
	                  scope.select(0);
	                }
	              } else {
	                resetMatches();
	                isNoResultsSetter(originalScope, true);
	              }
	            }
	            if (onCurrentRequest) {
	              isLoadingSetter(originalScope, false);
	            }
	          }, function() {
	            resetMatches();
	            isLoadingSetter(originalScope, false);
	            isNoResultsSetter(originalScope, true);
	          });
	        };
	
	        // bind events only if appendToBody params exist - performance feature
	        if (appendToBody) {
	          angular.element($window).bind('resize', fireRecalculating);
	          $document.find('body').bind('scroll', fireRecalculating);
	        }
	
	        // Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
	        var timeoutEventPromise;
	
	        // Default progress type
	        scope.moveInProgress = false;
	
	        function fireRecalculating() {
	          if (!scope.moveInProgress) {
	            scope.moveInProgress = true;
	            scope.$digest();
	          }
	
	          // Cancel previous timeout
	          if (timeoutEventPromise) {
	            $timeout.cancel(timeoutEventPromise);
	          }
	
	          // Debounced executing recalculate after events fired
	          timeoutEventPromise = $timeout(function() {
	            // if popup is visible
	            if (scope.matches.length) {
	              recalculatePosition();
	            }
	
	            scope.moveInProgress = false;
	          }, eventDebounceTime);
	        }
	
	        // recalculate actual position and set new values to scope
	        // after digest loop is popup in right position
	        function recalculatePosition() {
	          scope.position = appendToBody ? $position.offset(element) : $position.position(element);
	          scope.position.top += element.prop('offsetHeight');
	        }
	
	        resetMatches();
	
	        //we need to propagate user's query so we can higlight matches
	        scope.query = undefined;
	
	        //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
	        var timeoutPromise;
	
	        var scheduleSearchWithTimeout = function(inputValue) {
	          timeoutPromise = $timeout(function() {
	            getMatchesAsync(inputValue);
	          }, waitTime);
	        };
	
	        var cancelPreviousTimeout = function() {
	          if (timeoutPromise) {
	            $timeout.cancel(timeoutPromise);
	          }
	        };
	
	        //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
	        //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
	        modelCtrl.$parsers.unshift(function(inputValue) {
	          hasFocus = true;
	
	          if (minLength === 0 || inputValue && inputValue.length >= minLength) {
	            if (waitTime > 0) {
	              cancelPreviousTimeout();
	              scheduleSearchWithTimeout(inputValue);
	            } else {
	              getMatchesAsync(inputValue);
	            }
	          } else {
	            isLoadingSetter(originalScope, false);
	            cancelPreviousTimeout();
	            resetMatches();
	          }
	
	          if (isEditable) {
	            return inputValue;
	          } else {
	            if (!inputValue) {
	              // Reset in case user had typed something previously.
	              modelCtrl.$setValidity('editable', true);
	              return null;
	            } else {
	              modelCtrl.$setValidity('editable', false);
	              return undefined;
	            }
	          }
	        });
	
	        modelCtrl.$formatters.push(function(modelValue) {
	          var candidateViewValue, emptyViewValue;
	          var locals = {};
	
	          // The validity may be set to false via $parsers (see above) if
	          // the model is restricted to selected values. If the model
	          // is set manually it is considered to be valid.
	          if (!isEditable) {
	            modelCtrl.$setValidity('editable', true);
	          }
	
	          if (inputFormatter) {
	            locals.$model = modelValue;
	            return inputFormatter(originalScope, locals);
	          } else {
	            //it might happen that we don't have enough info to properly render input value
	            //we need to check for this situation and simply return model value if we can't apply custom formatting
	            locals[parserResult.itemName] = modelValue;
	            candidateViewValue = parserResult.viewMapper(originalScope, locals);
	            locals[parserResult.itemName] = undefined;
	            emptyViewValue = parserResult.viewMapper(originalScope, locals);
	
	            return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
	          }
	        });
	
	        scope.select = function(activeIdx) {
	          //called from within the $digest() cycle
	          var locals = {};
	          var model, item;
	
	          selected = true;
	          locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
	          model = parserResult.modelMapper(originalScope, locals);
	          $setModelValue(originalScope, model);
	          modelCtrl.$setValidity('editable', true);
	          modelCtrl.$setValidity('parse', true);
	
	          onSelectCallback(originalScope, {
	            $item: item,
	            $model: model,
	            $label: parserResult.viewMapper(originalScope, locals)
	          });
	
	          resetMatches();
	
	          //return focus to the input element if a match was selected via a mouse click event
	          // use timeout to avoid $rootScope:inprog error
	          if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
	            $timeout(function() { element[0].focus(); }, 0, false);
	          }
	        };
	
	        //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
	        element.bind('keydown', function(evt) {
	          //typeahead is open and an "interesting" key was pressed
	          if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
	            return;
	          }
	
	          // if there's nothing selected (i.e. focusFirst) and enter or tab is hit, clear the results
	          if (scope.activeIdx === -1 && (evt.which === 9 || evt.which === 13)) {
	            resetMatches();
	            scope.$digest();
	            return;
	          }
	
	          evt.preventDefault();
	
	          if (evt.which === 40) {
	            scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
	            scope.$digest();
	          } else if (evt.which === 38) {
	            scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
	            scope.$digest();
	          } else if (evt.which === 13 || evt.which === 9) {
	            scope.$apply(function () {
	              scope.select(scope.activeIdx);
	            });
	          } else if (evt.which === 27) {
	            evt.stopPropagation();
	
	            resetMatches();
	            scope.$digest();
	          }
	        });
	
	        element.bind('blur', function() {
	          if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
	            selected = true;
	            scope.$apply(function() {
	              scope.select(scope.activeIdx);
	            });
	          }
	          hasFocus = false;
	          selected = false;
	        });
	
	        // Keep reference to click handler to unbind it.
	        var dismissClickHandler = function(evt) {
	          // Issue #3973
	          // Firefox treats right click as a click on document
	          if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
	            resetMatches();
	            if (!$rootScope.$$phase) {
	              scope.$digest();
	            }
	          }
	        };
	
	        $document.bind('click', dismissClickHandler);
	
	        originalScope.$on('$destroy', function() {
	          $document.unbind('click', dismissClickHandler);
	          if (appendToBody || appendToElementId) {
	            $popup.remove();
	          }
	
	          if (appendToBody) {
	            angular.element($window).unbind('resize', fireRecalculating);
	            $document.find('body').unbind('scroll', fireRecalculating);
	          }
	          // Prevent jQuery cache memory leak
	          popUpEl.remove();
	        });
	
	        var $popup = $compile(popUpEl)(scope);
	
	        if (appendToBody) {
	          $document.find('body').append($popup);
	        } else if (appendToElementId !== false) {
	          angular.element($document[0].getElementById(appendToElementId)).append($popup);
	        } else {
	          element.after($popup);
	        }
	      }
	    };
	  }])
	  
	  .directive('typeaheadPopup', ['$typeaheadSuppressWarning', '$log', function($typeaheadSuppressWarning, $log) {
	    return {
	      scope: {
	        matches: '=',
	        query: '=',
	        active: '=',
	        position: '&',
	        moveInProgress: '=',
	        select: '&'
	      },
	      replace: true,
	      templateUrl: function(element, attrs) {
	        return attrs.popupTemplateUrl || 'template/typeahead/typeahead-popup.html';
	      },
	      link: function(scope, element, attrs) {
	        
	        if (!$typeaheadSuppressWarning) {
	          $log.warn('typeahead-popup is now deprecated. Use uib-typeahead-popup instead.');
	        }
	        scope.templateUrl = attrs.templateUrl;
	
	        scope.isOpen = function() {
	          return scope.matches.length > 0;
	        };
	
	        scope.isActive = function(matchIdx) {
	          return scope.active == matchIdx;
	        };
	
	        scope.selectActive = function(matchIdx) {
	          scope.active = matchIdx;
	        };
	
	        scope.selectMatch = function(activeIdx) {
	          scope.select({activeIdx:activeIdx});
	        };
	      }
	    };
	  }])
	  
	  .directive('typeaheadMatch', ['$templateRequest', '$compile', '$parse', '$typeaheadSuppressWarning', '$log', function($templateRequest, $compile, $parse, $typeaheadSuppressWarning, $log) {
	    return {
	      restrict: 'EA',
	      scope: {
	        index: '=',
	        match: '=',
	        query: '='
	      },
	      link:function(scope, element, attrs) {
	        if (!$typeaheadSuppressWarning) {
	          $log.warn('typeahead-match is now deprecated. Use uib-typeahead-match instead.');
	        }
	
	        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'template/typeahead/typeahead-match.html';
	        $templateRequest(tplUrl).then(function(tplContent) {
	          $compile(tplContent.trim())(scope, function(clonedElement) {
	            element.replaceWith(clonedElement);
	          });
	        });
	      }
	    };
	  }])
	  
	  .filter('typeaheadHighlight', ['$sce', '$injector', '$log', '$typeaheadSuppressWarning', function($sce, $injector, $log, $typeaheadSuppressWarning) {
	    var isSanitizePresent;
	    isSanitizePresent = $injector.has('$sanitize');
	
	    function escapeRegexp(queryToEscape) {
	      // Regex: capture the whole query string and replace it with the string that will be used to match
	      // the results, for example if the capture is "a" the result will be \a
	      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	    }
	
	    function containsHtml(matchItem) {
	      return /<.*>/g.test(matchItem);
	    }
	
	    return function(matchItem, query) {
	      if (!$typeaheadSuppressWarning) {
	        $log.warn('typeaheadHighlight is now deprecated. Use uibTypeaheadHighlight instead.');
	      }
	
	      if (!isSanitizePresent && containsHtml(matchItem)) {
	        $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
	      }
	
	      matchItem = query? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
	      if (!isSanitizePresent) {
	        matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
	      }
	
	      return matchItem;
	    };
	  }]);
	
	angular.module("template/accordion/accordion-group.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/accordion/accordion-group.html",
	    "<div class=\"panel {{panelClass || 'panel-default'}}\">\n" +
	    "  <div class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
	    "    <h4 class=\"panel-title\">\n" +
	    "      <a href tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\"><span ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
	    "    </h4>\n" +
	    "  </div>\n" +
	    "  <div class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" +
	    "	  <div class=\"panel-body\" ng-transclude></div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/accordion/accordion.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/accordion/accordion.html",
	    "<div class=\"panel-group\" ng-transclude></div>");
	}]);
	
	angular.module("template/alert/alert.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/alert/alert.html",
	    "<div class=\"alert\" ng-class=\"['alert-' + (type || 'warning'), closeable ? 'alert-dismissible' : null]\" role=\"alert\">\n" +
	    "    <button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" +
	    "        <span aria-hidden=\"true\">&times;</span>\n" +
	    "        <span class=\"sr-only\">Close</span>\n" +
	    "    </button>\n" +
	    "    <div ng-transclude></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/carousel/carousel.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/carousel/carousel.html",
	    "<div ng-mouseenter=\"pause()\" ng-mouseleave=\"play()\" class=\"carousel\" ng-swipe-right=\"prev()\" ng-swipe-left=\"next()\">\n" +
	    "  <div class=\"carousel-inner\" ng-transclude></div>\n" +
	    "  <a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-show=\"slides.length > 1\">\n" +
	    "    <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span>\n" +
	    "    <span class=\"sr-only\">previous</span>\n" +
	    "  </a>\n" +
	    "  <a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-show=\"slides.length > 1\">\n" +
	    "    <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span>\n" +
	    "    <span class=\"sr-only\">next</span>\n" +
	    "  </a>\n" +
	    "  <ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
	    "    <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=\"select(slide)\">\n" +
	    "      <span class=\"sr-only\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\"isActive(slide)\">, currently active</span></span>\n" +
	    "    </li>\n" +
	    "  </ol>\n" +
	    "</div>");
	}]);
	
	angular.module("template/carousel/slide.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/carousel/slide.html",
	    "<div ng-class=\"{\n" +
	    "    'active': active\n" +
	    "  }\" class=\"item text-center\" ng-transclude></div>\n" +
	    "");
	}]);
	
	angular.module("template/datepicker/datepicker.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/datepicker.html",
	    "<div ng-switch=\"datepickerMode\" role=\"application\" ng-keydown=\"keydown($event)\">\n" +
	    "  <uib-daypicker ng-switch-when=\"day\" tabindex=\"0\"></uib-daypicker>\n" +
	    "  <uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\"></uib-monthpicker>\n" +
	    "  <uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\"></uib-yearpicker>\n" +
	    "</div>");
	}]);
	
	angular.module("template/datepicker/day.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/day.html",
	    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
	    "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
	    "    </tr>\n" +
	    "    <tr>\n" +
	    "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
	    "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
	    "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
	    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default btn-sm\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("template/datepicker/month.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/month.html",
	    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
	    "      <th><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
	    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("template/datepicker/popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/popup.html",
	    "<ul class=\"dropdown-menu\" dropdown-nested ng-if=\"isOpen\" style=\"display: block\" ng-style=\"{top: position.top+'px', left: position.left+'px'}\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
	    "	<li ng-transclude></li>\n" +
	    "	<li ng-if=\"showButtonBar\" style=\"padding:10px 9px 2px\">\n" +
	    "		<span class=\"btn-group pull-left\">\n" +
	    "			<button type=\"button\" class=\"btn btn-sm btn-info\" ng-click=\"select('today')\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
	    "			<button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"select(null)\">{{ getText('clear') }}</button>\n" +
	    "		</span>\n" +
	    "		<button type=\"button\" class=\"btn btn-sm btn-success pull-right\" ng-click=\"close()\">{{ getText('close') }}</button>\n" +
	    "	</li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	
	angular.module("template/datepicker/year.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/datepicker/year.html",
	    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
	    "      <th colspan=\"3\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
	    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("template/modal/backdrop.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/modal/backdrop.html",
	    "<div uib-modal-animation-class=\"fade\"\n" +
	    "     modal-in-class=\"in\"\n" +
	    "     ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n" +
	    "></div>\n" +
	    "");
	}]);
	
	angular.module("template/modal/window.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/modal/window.html",
	    "<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\"\n" +
	    "    uib-modal-animation-class=\"fade\"\n" +
	    "    modal-in-class=\"in\"\n" +
	    "    ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\">\n" +
	    "    <div class=\"modal-dialog\" ng-class=\"size ? 'modal-' + size : ''\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/pagination/pager.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/pagination/pager.html",
	    "<ul class=\"pager\">\n" +
	    "  <li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n" +
	    "  <li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	
	angular.module("template/pagination/pagination.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/pagination/pagination.html",
	    "<ul class=\"pagination\">\n" +
	    "  <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\">{{::getText('first')}}</a></li>\n" +
	    "  <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n" +
	    "  <li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\">{{page.text}}</a></li>\n" +
	    "  <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n" +
	    "  <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\">{{::getText('last')}}</a></li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	
	angular.module("template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tooltip/tooltip-html-popup.html",
	    "<div\n" +
	    "  tooltip-animation-class=\"fade\"\n" +
	    "  uib-tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"tooltip-arrow\"></div>\n" +
	    "  <div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/tooltip/tooltip-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tooltip/tooltip-popup.html",
	    "<div\n" +
	    "  tooltip-animation-class=\"fade\"\n" +
	    "  uib-tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"tooltip-arrow\"></div>\n" +
	    "  <div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tooltip/tooltip-template-popup.html",
	    "<div\n" +
	    "  tooltip-animation-class=\"fade\"\n" +
	    "  uib-tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"tooltip-arrow\"></div>\n" +
	    "  <div class=\"tooltip-inner\"\n" +
	    "    uib-tooltip-template-transclude=\"contentExp()\"\n" +
	    "    tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/popover/popover-html.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/popover/popover-html.html",
	    "<div tooltip-animation-class=\"fade\"\n" +
	    "  uib-tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"arrow\"></div>\n" +
	    "\n" +
	    "  <div class=\"popover-inner\">\n" +
	    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" +
	    "      <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/popover/popover-template.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/popover/popover-template.html",
	    "<div tooltip-animation-class=\"fade\"\n" +
	    "  uib-tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"arrow\"></div>\n" +
	    "\n" +
	    "  <div class=\"popover-inner\">\n" +
	    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" +
	    "      <div class=\"popover-content\"\n" +
	    "        uib-tooltip-template-transclude=\"contentExp()\"\n" +
	    "        tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/popover/popover.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/popover/popover.html",
	    "<div tooltip-animation-class=\"fade\"\n" +
	    "  uib-tooltip-classes\n" +
	    "  ng-class=\"{ in: isOpen() }\">\n" +
	    "  <div class=\"arrow\"></div>\n" +
	    "\n" +
	    "  <div class=\"popover-inner\">\n" +
	    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" +
	    "      <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/progressbar/bar.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/progressbar/bar.html",
	    "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" style=\"min-width: 0;\" ng-transclude></div>\n" +
	    "");
	}]);
	
	angular.module("template/progressbar/progress.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/progressbar/progress.html",
	    "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
	}]);
	
	angular.module("template/progressbar/progressbar.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/progressbar/progressbar.html",
	    "<div class=\"progress\">\n" +
	    "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" style=\"min-width: 0;\" ng-transclude></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/rating/rating.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/rating/rating.html",
	    "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\">\n" +
	    "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
	    "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\" aria-valuetext=\"{{r.title}}\"></i>\n" +
	    "</span>\n" +
	    "");
	}]);
	
	angular.module("template/tabs/tab.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tabs/tab.html",
	    "<li ng-class=\"{active: active, disabled: disabled}\">\n" +
	    "  <a href ng-click=\"select()\" uib-tab-heading-transclude>{{heading}}</a>\n" +
	    "</li>\n" +
	    "");
	}]);
	
	angular.module("template/tabs/tabset.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/tabs/tabset.html",
	    "<div>\n" +
	    "  <ul class=\"nav nav-{{type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
	    "  <div class=\"tab-content\">\n" +
	    "    <div class=\"tab-pane\" \n" +
	    "         ng-repeat=\"tab in tabs\" \n" +
	    "         ng-class=\"{active: tab.active}\"\n" +
	    "         uib-tab-content-transclude=\"tab\">\n" +
	    "    </div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("template/timepicker/timepicker.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/timepicker/timepicker.html",
	    "<table>\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
	    "      <td><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "      <td>&nbsp;</td>\n" +
	    "      <td><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "      <td ng-show=\"showMeridian\"></td>\n" +
	    "    </tr>\n" +
	    "    <tr>\n" +
	    "      <td class=\"form-group\" ng-class=\"{'has-error': invalidHours}\">\n" +
	    "        <input style=\"width:50px;\" type=\"text\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\">\n" +
	    "      </td>\n" +
	    "      <td>:</td>\n" +
	    "      <td class=\"form-group\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
	    "        <input style=\"width:50px;\" type=\"text\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\">\n" +
	    "      </td>\n" +
	    "      <td ng-show=\"showMeridian\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" +
	    "    </tr>\n" +
	    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
	    "      <td><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "      <td>&nbsp;</td>\n" +
	    "      <td><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "      <td ng-show=\"showMeridian\"></td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("template/typeahead/typeahead-match.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/typeahead/typeahead-match.html",
	    "<a href tabindex=\"-1\" ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"></a>\n" +
	    "");
	}]);
	
	angular.module("template/typeahead/typeahead-popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("template/typeahead/typeahead-popup.html",
	    "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" style=\"display: block;\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
	    "    <li ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{::match.id}}\">\n" +
	    "        <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
	    "    </li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	!angular.$$csp() && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>');if(true)module.exports='ui.bootstrap';

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(6);
	module.exports = 'ngResource';


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(5);
	module.exports = 'ngCookies';


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(15);
	module.exports = 'ngFileUpload';

/***/ },
/* 15 */
/***/ function(module, exports) {

	/**!
	 * AngularJS file upload directives and services. Supports: file upload/drop/paste, resume, cancel/abort,
	 * progress, resize, thumbnail, preview, validation and CORS
	 * FileAPI Flash shim for old browsers not supporting FormData
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 12.2.13
	 */
	
	(function () {
	  /** @namespace FileAPI.noContentTimeout */
	
	  function patchXHR(fnName, newFn) {
	    window.XMLHttpRequest.prototype[fnName] = newFn(window.XMLHttpRequest.prototype[fnName]);
	  }
	
	  function redefineProp(xhr, prop, fn) {
	    try {
	      Object.defineProperty(xhr, prop, {get: fn});
	    } catch (e) {/*ignore*/
	    }
	  }
	
	  if (!window.FileAPI) {
	    window.FileAPI = {};
	  }
	
	  if (!window.XMLHttpRequest) {
	    throw 'AJAX is not supported. XMLHttpRequest is not defined.';
	  }
	
	  FileAPI.shouldLoad = !window.FormData || FileAPI.forceLoad;
	  if (FileAPI.shouldLoad) {
	    var initializeUploadListener = function (xhr) {
	      if (!xhr.__listeners) {
	        if (!xhr.upload) xhr.upload = {};
	        xhr.__listeners = [];
	        var origAddEventListener = xhr.upload.addEventListener;
	        xhr.upload.addEventListener = function (t, fn) {
	          xhr.__listeners[t] = fn;
	          if (origAddEventListener) origAddEventListener.apply(this, arguments);
	        };
	      }
	    };
	
	    patchXHR('open', function (orig) {
	      return function (m, url, b) {
	        initializeUploadListener(this);
	        this.__url = url;
	        try {
	          orig.apply(this, [m, url, b]);
	        } catch (e) {
	          if (e.message.indexOf('Access is denied') > -1) {
	            this.__origError = e;
	            orig.apply(this, [m, '_fix_for_ie_crossdomain__', b]);
	          }
	        }
	      };
	    });
	
	    patchXHR('getResponseHeader', function (orig) {
	      return function (h) {
	        return this.__fileApiXHR && this.__fileApiXHR.getResponseHeader ? this.__fileApiXHR.getResponseHeader(h) : (orig == null ? null : orig.apply(this, [h]));
	      };
	    });
	
	    patchXHR('getAllResponseHeaders', function (orig) {
	      return function () {
	        return this.__fileApiXHR && this.__fileApiXHR.getAllResponseHeaders ? this.__fileApiXHR.getAllResponseHeaders() : (orig == null ? null : orig.apply(this));
	      };
	    });
	
	    patchXHR('abort', function (orig) {
	      return function () {
	        return this.__fileApiXHR && this.__fileApiXHR.abort ? this.__fileApiXHR.abort() : (orig == null ? null : orig.apply(this));
	      };
	    });
	
	    patchXHR('setRequestHeader', function (orig) {
	      return function (header, value) {
	        if (header === '__setXHR_') {
	          initializeUploadListener(this);
	          var val = value(this);
	          // fix for angular < 1.2.0
	          if (val instanceof Function) {
	            val(this);
	          }
	        } else {
	          this.__requestHeaders = this.__requestHeaders || {};
	          this.__requestHeaders[header] = value;
	          orig.apply(this, arguments);
	        }
	      };
	    });
	
	    patchXHR('send', function (orig) {
	      return function () {
	        var xhr = this;
	        if (arguments[0] && arguments[0].__isFileAPIShim) {
	          var formData = arguments[0];
	          var config = {
	            url: xhr.__url,
	            jsonp: false, //removes the callback form param
	            cache: true, //removes the ?fileapiXXX in the url
	            complete: function (err, fileApiXHR) {
	              if (err && angular.isString(err) && err.indexOf('#2174') !== -1) {
	                // this error seems to be fine the file is being uploaded properly.
	                err = null;
	              }
	              xhr.__completed = true;
	              if (!err && xhr.__listeners.load)
	                xhr.__listeners.load({
	                  type: 'load',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (!err && xhr.__listeners.loadend)
	                xhr.__listeners.loadend({
	                  type: 'loadend',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (err === 'abort' && xhr.__listeners.abort)
	                xhr.__listeners.abort({
	                  type: 'abort',
	                  loaded: xhr.__loaded,
	                  total: xhr.__total,
	                  target: xhr,
	                  lengthComputable: true
	                });
	              if (fileApiXHR.status !== undefined) redefineProp(xhr, 'status', function () {
	                return (fileApiXHR.status === 0 && err && err !== 'abort') ? 500 : fileApiXHR.status;
	              });
	              if (fileApiXHR.statusText !== undefined) redefineProp(xhr, 'statusText', function () {
	                return fileApiXHR.statusText;
	              });
	              redefineProp(xhr, 'readyState', function () {
	                return 4;
	              });
	              if (fileApiXHR.response !== undefined) redefineProp(xhr, 'response', function () {
	                return fileApiXHR.response;
	              });
	              var resp = fileApiXHR.responseText || (err && fileApiXHR.status === 0 && err !== 'abort' ? err : undefined);
	              redefineProp(xhr, 'responseText', function () {
	                return resp;
	              });
	              redefineProp(xhr, 'response', function () {
	                return resp;
	              });
	              if (err) redefineProp(xhr, 'err', function () {
	                return err;
	              });
	              xhr.__fileApiXHR = fileApiXHR;
	              if (xhr.onreadystatechange) xhr.onreadystatechange();
	              if (xhr.onload) xhr.onload();
	            },
	            progress: function (e) {
	              e.target = xhr;
	              if (xhr.__listeners.progress) xhr.__listeners.progress(e);
	              xhr.__total = e.total;
	              xhr.__loaded = e.loaded;
	              if (e.total === e.loaded) {
	                // fix flash issue that doesn't call complete if there is no response text from the server
	                var _this = this;
	                setTimeout(function () {
	                  if (!xhr.__completed) {
	                    xhr.getAllResponseHeaders = function () {
	                    };
	                    _this.complete(null, {status: 204, statusText: 'No Content'});
	                  }
	                }, FileAPI.noContentTimeout || 10000);
	              }
	            },
	            headers: xhr.__requestHeaders
	          };
	          config.data = {};
	          config.files = {};
	          for (var i = 0; i < formData.data.length; i++) {
	            var item = formData.data[i];
	            if (item.val != null && item.val.name != null && item.val.size != null && item.val.type != null) {
	              config.files[item.key] = item.val;
	            } else {
	              config.data[item.key] = item.val;
	            }
	          }
	
	          setTimeout(function () {
	            if (!FileAPI.hasFlash) {
	              throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
	            }
	            xhr.__fileApiXHR = FileAPI.upload(config);
	          }, 1);
	        } else {
	          if (this.__origError) {
	            throw this.__origError;
	          }
	          orig.apply(xhr, arguments);
	        }
	      };
	    });
	    window.XMLHttpRequest.__isFileAPIShim = true;
	    window.FormData = FormData = function () {
	      return {
	        append: function (key, val, name) {
	          if (val.__isFileAPIBlobShim) {
	            val = val.data[0];
	          }
	          this.data.push({
	            key: key,
	            val: val,
	            name: name
	          });
	        },
	        data: [],
	        __isFileAPIShim: true
	      };
	    };
	
	    window.Blob = Blob = function (b) {
	      return {
	        data: b,
	        __isFileAPIBlobShim: true
	      };
	    };
	  }
	
	})();
	
	(function () {
	  /** @namespace FileAPI.forceLoad */
	  /** @namespace window.FileAPI.jsUrl */
	  /** @namespace window.FileAPI.jsPath */
	
	  function isInputTypeFile(elem) {
	    return elem[0].tagName.toLowerCase() === 'input' && elem.attr('type') && elem.attr('type').toLowerCase() === 'file';
	  }
	
	  function hasFlash() {
	    try {
	      var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
	      if (fo) return true;
	    } catch (e) {
	      if (navigator.mimeTypes['application/x-shockwave-flash'] !== undefined) return true;
	    }
	    return false;
	  }
	
	  function getOffset(obj) {
	    var left = 0, top = 0;
	
	    if (window.jQuery) {
	      return jQuery(obj).offset();
	    }
	
	    if (obj.offsetParent) {
	      do {
	        left += (obj.offsetLeft - obj.scrollLeft);
	        top += (obj.offsetTop - obj.scrollTop);
	        obj = obj.offsetParent;
	      } while (obj);
	    }
	    return {
	      left: left,
	      top: top
	    };
	  }
	
	  if (FileAPI.shouldLoad) {
	    FileAPI.hasFlash = hasFlash();
	
	    //load FileAPI
	    if (FileAPI.forceLoad) {
	      FileAPI.html5 = false;
	    }
	
	    if (!FileAPI.upload) {
	      var jsUrl, basePath, script = document.createElement('script'), allScripts = document.getElementsByTagName('script'), i, index, src;
	      if (window.FileAPI.jsUrl) {
	        jsUrl = window.FileAPI.jsUrl;
	      } else if (window.FileAPI.jsPath) {
	        basePath = window.FileAPI.jsPath;
	      } else {
	        for (i = 0; i < allScripts.length; i++) {
	          src = allScripts[i].src;
	          index = src.search(/\/ng\-file\-upload[\-a-zA-z0-9\.]*\.js/);
	          if (index > -1) {
	            basePath = src.substring(0, index + 1);
	            break;
	          }
	        }
	      }
	
	      if (FileAPI.staticPath == null) FileAPI.staticPath = basePath;
	      script.setAttribute('src', jsUrl || basePath + 'FileAPI.min.js');
	      document.getElementsByTagName('head')[0].appendChild(script);
	    }
	
	    FileAPI.ngfFixIE = function (elem, fileElem, changeFn) {
	      if (!hasFlash()) {
	        throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
	      }
	      var fixInputStyle = function () {
	        var label = fileElem.parent();
	        if (elem.attr('disabled')) {
	          if (label) label.removeClass('js-fileapi-wrapper');
	        } else {
	          if (!fileElem.attr('__ngf_flash_')) {
	            fileElem.unbind('change');
	            fileElem.unbind('click');
	            fileElem.bind('change', function (evt) {
	              fileApiChangeFn.apply(this, [evt]);
	              changeFn.apply(this, [evt]);
	            });
	            fileElem.attr('__ngf_flash_', 'true');
	          }
	          label.addClass('js-fileapi-wrapper');
	          if (!isInputTypeFile(elem)) {
	            label.css('position', 'absolute')
	              .css('top', getOffset(elem[0]).top + 'px').css('left', getOffset(elem[0]).left + 'px')
	              .css('width', elem[0].offsetWidth + 'px').css('height', elem[0].offsetHeight + 'px')
	              .css('filter', 'alpha(opacity=0)').css('display', elem.css('display'))
	              .css('overflow', 'hidden').css('z-index', '900000')
	              .css('visibility', 'visible');
	            fileElem.css('width', elem[0].offsetWidth + 'px').css('height', elem[0].offsetHeight + 'px')
	              .css('position', 'absolute').css('top', '0px').css('left', '0px');
	          }
	        }
	      };
	
	      elem.bind('mouseenter', fixInputStyle);
	
	      var fileApiChangeFn = function (evt) {
	        var files = FileAPI.getFiles(evt);
	        //just a double check for #233
	        for (var i = 0; i < files.length; i++) {
	          if (files[i].size === undefined) files[i].size = 0;
	          if (files[i].name === undefined) files[i].name = 'file';
	          if (files[i].type === undefined) files[i].type = 'undefined';
	        }
	        if (!evt.target) {
	          evt.target = {};
	        }
	        evt.target.files = files;
	        // if evt.target.files is not writable use helper field
	        if (evt.target.files !== files) {
	          evt.__files_ = files;
	        }
	        (evt.__files_ || evt.target.files).item = function (i) {
	          return (evt.__files_ || evt.target.files)[i] || null;
	        };
	      };
	    };
	
	    FileAPI.disableFileInput = function (elem, disable) {
	      if (disable) {
	        elem.removeClass('js-fileapi-wrapper');
	      } else {
	        elem.addClass('js-fileapi-wrapper');
	      }
	    };
	  }
	})();
	
	if (!window.FileReader) {
	  window.FileReader = function () {
	    var _this = this, loadStarted = false;
	    this.listeners = {};
	    this.addEventListener = function (type, fn) {
	      _this.listeners[type] = _this.listeners[type] || [];
	      _this.listeners[type].push(fn);
	    };
	    this.removeEventListener = function (type, fn) {
	      if (_this.listeners[type]) _this.listeners[type].splice(_this.listeners[type].indexOf(fn), 1);
	    };
	    this.dispatchEvent = function (evt) {
	      var list = _this.listeners[evt.type];
	      if (list) {
	        for (var i = 0; i < list.length; i++) {
	          list[i].call(_this, evt);
	        }
	      }
	    };
	    this.onabort = this.onerror = this.onload = this.onloadstart = this.onloadend = this.onprogress = null;
	
	    var constructEvent = function (type, evt) {
	      var e = {type: type, target: _this, loaded: evt.loaded, total: evt.total, error: evt.error};
	      if (evt.result != null) e.target.result = evt.result;
	      return e;
	    };
	    var listener = function (evt) {
	      if (!loadStarted) {
	        loadStarted = true;
	        if (_this.onloadstart) _this.onloadstart(constructEvent('loadstart', evt));
	      }
	      var e;
	      if (evt.type === 'load') {
	        if (_this.onloadend) _this.onloadend(constructEvent('loadend', evt));
	        e = constructEvent('load', evt);
	        if (_this.onload) _this.onload(e);
	        _this.dispatchEvent(e);
	      } else if (evt.type === 'progress') {
	        e = constructEvent('progress', evt);
	        if (_this.onprogress) _this.onprogress(e);
	        _this.dispatchEvent(e);
	      } else {
	        e = constructEvent('error', evt);
	        if (_this.onerror) _this.onerror(e);
	        _this.dispatchEvent(e);
	      }
	    };
	    this.readAsDataURL = function (file) {
	      FileAPI.readAsDataURL(file, listener);
	    };
	    this.readAsText = function (file) {
	      FileAPI.readAsText(file, listener);
	    };
	  };
	}
	
	/**!
	 * AngularJS file upload directives and services. Supoorts: file upload/drop/paste, resume, cancel/abort,
	 * progress, resize, thumbnail, preview, validation and CORS
	 * @author  Danial  <danial.farid@gmail.com>
	 * @version 12.2.13
	 */
	
	if (window.XMLHttpRequest && !(window.FileAPI && FileAPI.shouldLoad)) {
	  window.XMLHttpRequest.prototype.setRequestHeader = (function (orig) {
	    return function (header, value) {
	      if (header === '__setXHR_') {
	        var val = value(this);
	        // fix for angular < 1.2.0
	        if (val instanceof Function) {
	          val(this);
	        }
	      } else {
	        orig.apply(this, arguments);
	      }
	    };
	  })(window.XMLHttpRequest.prototype.setRequestHeader);
	}
	
	var ngFileUpload = angular.module('ngFileUpload', []);
	
	ngFileUpload.version = '12.2.13';
	
	ngFileUpload.service('UploadBase', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
	  var upload = this;
	  upload.promisesCount = 0;
	
	  this.isResumeSupported = function () {
	    return window.Blob && window.Blob.prototype.slice;
	  };
	
	  var resumeSupported = this.isResumeSupported();
	
	  function sendHttp(config) {
	    config.method = config.method || 'POST';
	    config.headers = config.headers || {};
	
	    var deferred = config._deferred = config._deferred || $q.defer();
	    var promise = deferred.promise;
	
	    function notifyProgress(e) {
	      if (deferred.notify) {
	        deferred.notify(e);
	      }
	      if (promise.progressFunc) {
	        $timeout(function () {
	          promise.progressFunc(e);
	        });
	      }
	    }
	
	    function getNotifyEvent(n) {
	      if (config._start != null && resumeSupported) {
	        return {
	          loaded: n.loaded + config._start,
	          total: (config._file && config._file.size) || n.total,
	          type: n.type, config: config,
	          lengthComputable: true, target: n.target
	        };
	      } else {
	        return n;
	      }
	    }
	
	    if (!config.disableProgress) {
	      config.headers.__setXHR_ = function () {
	        return function (xhr) {
	          if (!xhr || !xhr.upload || !xhr.upload.addEventListener) return;
	          config.__XHR = xhr;
	          if (config.xhrFn) config.xhrFn(xhr);
	          xhr.upload.addEventListener('progress', function (e) {
	            e.config = config;
	            notifyProgress(getNotifyEvent(e));
	          }, false);
	          //fix for firefox not firing upload progress end, also IE8-9
	          xhr.upload.addEventListener('load', function (e) {
	            if (e.lengthComputable) {
	              e.config = config;
	              notifyProgress(getNotifyEvent(e));
	            }
	          }, false);
	        };
	      };
	    }
	
	    function uploadWithAngular() {
	      $http(config).then(function (r) {
	          if (resumeSupported && config._chunkSize && !config._finished && config._file) {
	            var fileSize = config._file && config._file.size || 0;
	            notifyProgress({
	                loaded: Math.min(config._end, fileSize),
	                total: fileSize,
	                config: config,
	                type: 'progress'
	              }
	            );
	            upload.upload(config, true);
	          } else {
	            if (config._finished) delete config._finished;
	            deferred.resolve(r);
	          }
	        }, function (e) {
	          deferred.reject(e);
	        }, function (n) {
	          deferred.notify(n);
	        }
	      );
	    }
	
	    if (!resumeSupported) {
	      uploadWithAngular();
	    } else if (config._chunkSize && config._end && !config._finished) {
	      config._start = config._end;
	      config._end += config._chunkSize;
	      uploadWithAngular();
	    } else if (config.resumeSizeUrl) {
	      $http.get(config.resumeSizeUrl).then(function (resp) {
	        if (config.resumeSizeResponseReader) {
	          config._start = config.resumeSizeResponseReader(resp.data);
	        } else {
	          config._start = parseInt((resp.data.size == null ? resp.data : resp.data.size).toString());
	        }
	        if (config._chunkSize) {
	          config._end = config._start + config._chunkSize;
	        }
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else if (config.resumeSize) {
	      config.resumeSize().then(function (size) {
	        config._start = size;
	        if (config._chunkSize) {
	          config._end = config._start + config._chunkSize;
	        }
	        uploadWithAngular();
	      }, function (e) {
	        throw e;
	      });
	    } else {
	      if (config._chunkSize) {
	        config._start = 0;
	        config._end = config._start + config._chunkSize;
	      }
	      uploadWithAngular();
	    }
	
	
	    promise.success = function (fn) {
	      promise.then(function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.error = function (fn) {
	      promise.then(null, function (response) {
	        fn(response.data, response.status, response.headers, config);
	      });
	      return promise;
	    };
	
	    promise.progress = function (fn) {
	      promise.progressFunc = fn;
	      promise.then(null, null, function (n) {
	        fn(n);
	      });
	      return promise;
	    };
	    promise.abort = promise.pause = function () {
	      if (config.__XHR) {
	        $timeout(function () {
	          config.__XHR.abort();
	        });
	      }
	      return promise;
	    };
	    promise.xhr = function (fn) {
	      config.xhrFn = (function (origXhrFn) {
	        return function () {
	          if (origXhrFn) origXhrFn.apply(promise, arguments);
	          fn.apply(promise, arguments);
	        };
	      })(config.xhrFn);
	      return promise;
	    };
	
	    upload.promisesCount++;
	    if (promise['finally'] && promise['finally'] instanceof Function) {
	      promise['finally'](function () {
	        upload.promisesCount--;
	      });
	    }
	    return promise;
	  }
	
	  this.isUploadInProgress = function () {
	    return upload.promisesCount > 0;
	  };
	
	  this.rename = function (file, name) {
	    file.ngfName = name;
	    return file;
	  };
	
	  this.jsonBlob = function (val) {
	    if (val != null && !angular.isString(val)) {
	      val = JSON.stringify(val);
	    }
	    var blob = new window.Blob([val], {type: 'application/json'});
	    blob._ngfBlob = true;
	    return blob;
	  };
	
	  this.json = function (val) {
	    return angular.toJson(val);
	  };
	
	  function copy(obj) {
	    var clone = {};
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        clone[key] = obj[key];
	      }
	    }
	    return clone;
	  }
	
	  this.isFile = function (file) {
	    return file != null && (file instanceof window.Blob || (file.flashId && file.name && file.size));
	  };
	
	  this.upload = function (config, internal) {
	    function toResumeFile(file, formData) {
	      if (file._ngfBlob) return file;
	      config._file = config._file || file;
	      if (config._start != null && resumeSupported) {
	        if (config._end && config._end >= file.size) {
	          config._finished = true;
	          config._end = file.size;
	        }
	        var slice = file.slice(config._start, config._end || file.size);
	        slice.name = file.name;
	        slice.ngfName = file.ngfName;
	        if (config._chunkSize) {
	          formData.append('_chunkSize', config._chunkSize);
	          formData.append('_currentChunkSize', config._end - config._start);
	          formData.append('_chunkNumber', Math.floor(config._start / config._chunkSize));
	          formData.append('_totalSize', config._file.size);
	        }
	        return slice;
	      }
	      return file;
	    }
	
	    function addFieldToFormData(formData, val, key) {
	      if (val !== undefined) {
	        if (angular.isDate(val)) {
	          val = val.toISOString();
	        }
	        if (angular.isString(val)) {
	          formData.append(key, val);
	        } else if (upload.isFile(val)) {
	          var file = toResumeFile(val, formData);
	          var split = key.split(',');
	          if (split[1]) {
	            file.ngfName = split[1].replace(/^\s+|\s+$/g, '');
	            key = split[0];
	          }
	          config._fileKey = config._fileKey || key;
	          formData.append(key, file, file.ngfName || file.name);
	        } else {
	          if (angular.isObject(val)) {
	            if (val.$$ngfCircularDetection) throw 'ngFileUpload: Circular reference in config.data. Make sure specified data for Upload.upload() has no circular reference: ' + key;
	
	            val.$$ngfCircularDetection = true;
	            try {
	              for (var k in val) {
	                if (val.hasOwnProperty(k) && k !== '$$ngfCircularDetection') {
	                  var objectKey = config.objectKey == null ? '[i]' : config.objectKey;
	                  if (val.length && parseInt(k) > -1) {
	                    objectKey = config.arrayKey == null ? objectKey : config.arrayKey;
	                  }
	                  addFieldToFormData(formData, val[k], key + objectKey.replace(/[ik]/g, k));
	                }
	              }
	            } finally {
	              delete val.$$ngfCircularDetection;
	            }
	          } else {
	            formData.append(key, val);
	          }
	        }
	      }
	    }
	
	    function digestConfig() {
	      config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	      config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;
	
	      config.headers = config.headers || {};
	      config.headers['Content-Type'] = undefined;
	      config.transformRequest = config.transformRequest ?
	        (angular.isArray(config.transformRequest) ?
	          config.transformRequest : [config.transformRequest]) : [];
	      config.transformRequest.push(function (data) {
	        var formData = new window.FormData(), key;
	        data = data || config.fields || {};
	        if (config.file) {
	          data.file = config.file;
	        }
	        for (key in data) {
	          if (data.hasOwnProperty(key)) {
	            var val = data[key];
	            if (config.formDataAppender) {
	              config.formDataAppender(formData, key, val);
	            } else {
	              addFieldToFormData(formData, val, key);
	            }
	          }
	        }
	
	        return formData;
	      });
	    }
	
	    if (!internal) config = copy(config);
	    if (!config._isDigested) {
	      config._isDigested = true;
	      digestConfig();
	    }
	
	    return sendHttp(config);
	  };
	
	  this.http = function (config) {
	    config = copy(config);
	    config.transformRequest = config.transformRequest || function (data) {
	        if ((window.ArrayBuffer && data instanceof window.ArrayBuffer) || data instanceof window.Blob) {
	          return data;
	        }
	        return $http.defaults.transformRequest[0].apply(this, arguments);
	      };
	    config._chunkSize = upload.translateScalars(config.resumeChunkSize);
	    config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;
	
	    return sendHttp(config);
	  };
	
	  this.translateScalars = function (str) {
	    if (angular.isString(str)) {
	      if (str.search(/kb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1024);
	      } else if (str.search(/mb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1048576);
	      } else if (str.search(/gb/i) === str.length - 2) {
	        return parseFloat(str.substring(0, str.length - 2) * 1073741824);
	      } else if (str.search(/b/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/s/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1));
	      } else if (str.search(/m/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 60);
	      } else if (str.search(/h/i) === str.length - 1) {
	        return parseFloat(str.substring(0, str.length - 1) * 3600);
	      }
	    }
	    return str;
	  };
	
	  this.urlToBlob = function(url) {
	    var defer = $q.defer();
	    $http({url: url, method: 'get', responseType: 'arraybuffer'}).then(function (resp) {
	      var arrayBufferView = new Uint8Array(resp.data);
	      var type = resp.headers('content-type') || 'image/WebP';
	      var blob = new window.Blob([arrayBufferView], {type: type});
	      var matches = url.match(/.*\/(.+?)(\?.*)?$/);
	      if (matches.length > 1) {
	        blob.name = matches[1];
	      }
	      defer.resolve(blob);
	    }, function (e) {
	      defer.reject(e);
	    });
	    return defer.promise;
	  };
	
	  this.setDefaults = function (defaults) {
	    this.defaults = defaults || {};
	  };
	
	  this.defaults = {};
	  this.version = ngFileUpload.version;
	}
	
	]);
	
	ngFileUpload.service('Upload', ['$parse', '$timeout', '$compile', '$q', 'UploadExif', function ($parse, $timeout, $compile, $q, UploadExif) {
	  var upload = UploadExif;
	  upload.getAttrWithDefaults = function (attr, name) {
	    if (attr[name] != null) return attr[name];
	    var def = upload.defaults[name];
	    return (def == null ? def : (angular.isString(def) ? def : JSON.stringify(def)));
	  };
	
	  upload.attrGetter = function (name, attr, scope, params) {
	    var attrVal = this.getAttrWithDefaults(attr, name);
	    if (scope) {
	      try {
	        if (params) {
	          return $parse(attrVal)(scope, params);
	        } else {
	          return $parse(attrVal)(scope);
	        }
	      } catch (e) {
	        // hangle string value without single qoute
	        if (name.search(/min|max|pattern/i)) {
	          return attrVal;
	        } else {
	          throw e;
	        }
	      }
	    } else {
	      return attrVal;
	    }
	  };
	
	  upload.shouldUpdateOn = function (type, attr, scope) {
	    var modelOptions = upload.attrGetter('ngfModelOptions', attr, scope);
	    if (modelOptions && modelOptions.updateOn) {
	      return modelOptions.updateOn.split(' ').indexOf(type) > -1;
	    }
	    return true;
	  };
	
	  upload.emptyPromise = function () {
	    var d = $q.defer();
	    var args = arguments;
	    $timeout(function () {
	      d.resolve.apply(d, args);
	    });
	    return d.promise;
	  };
	
	  upload.rejectPromise = function () {
	    var d = $q.defer();
	    var args = arguments;
	    $timeout(function () {
	      d.reject.apply(d, args);
	    });
	    return d.promise;
	  };
	
	  upload.happyPromise = function (promise, data) {
	    var d = $q.defer();
	    promise.then(function (result) {
	      d.resolve(result);
	    }, function (error) {
	      $timeout(function () {
	        throw error;
	      });
	      d.resolve(data);
	    });
	    return d.promise;
	  };
	
	  function applyExifRotations(files, attr, scope) {
	    var promises = [upload.emptyPromise()];
	    angular.forEach(files, function (f, i) {
	      if (f.type.indexOf('image/jpeg') === 0 && upload.attrGetter('ngfFixOrientation', attr, scope, {$file: f})) {
	        promises.push(upload.happyPromise(upload.applyExifRotation(f), f).then(function (fixedFile) {
	          files.splice(i, 1, fixedFile);
	        }));
	      }
	    });
	    return $q.all(promises);
	  }
	
	  function resizeFile(files, attr, scope, ngModel) {
	    var resizeVal = upload.attrGetter('ngfResize', attr, scope);
	    if (!resizeVal || !upload.isResizeSupported() || !files.length) return upload.emptyPromise();
	    if (resizeVal instanceof Function) {
	      var defer = $q.defer();
	      return resizeVal(files).then(function (p) {
	        resizeWithParams(p, files, attr, scope, ngModel).then(function (r) {
	          defer.resolve(r);
	        }, function (e) {
	          defer.reject(e);
	        });
	      }, function (e) {
	        defer.reject(e);
	      });
	    } else {
	      return resizeWithParams(resizeVal, files, attr, scope, ngModel);
	    }
	  }
	
	  function resizeWithParams(params, files, attr, scope, ngModel) {
	    var promises = [upload.emptyPromise()];
	
	    function handleFile(f, i) {
	      if (f.type.indexOf('image') === 0) {
	        if (params.pattern && !upload.validatePattern(f, params.pattern)) return;
	        params.resizeIf = function (width, height) {
	          return upload.attrGetter('ngfResizeIf', attr, scope,
	            {$width: width, $height: height, $file: f});
	        };
	        var promise = upload.resize(f, params);
	        promises.push(promise);
	        promise.then(function (resizedFile) {
	          files.splice(i, 1, resizedFile);
	        }, function (e) {
	          f.$error = 'resize';
	          (f.$errorMessages = (f.$errorMessages || {})).resize = true;
	          f.$errorParam = (e ? (e.message ? e.message : e) + ': ' : '') + (f && f.name);
	          ngModel.$ngfValidations.push({name: 'resize', valid: false});
	          upload.applyModelValidation(ngModel, files);
	        });
	      }
	    }
	
	    for (var i = 0; i < files.length; i++) {
	      handleFile(files[i], i);
	    }
	    return $q.all(promises);
	  }
	
	  upload.updateModel = function (ngModel, attr, scope, fileChange, files, evt, noDelay) {
	    function update(files, invalidFiles, newFiles, dupFiles, isSingleModel) {
	      attr.$$ngfPrevValidFiles = files;
	      attr.$$ngfPrevInvalidFiles = invalidFiles;
	      var file = files && files.length ? files[0] : null;
	      var invalidFile = invalidFiles && invalidFiles.length ? invalidFiles[0] : null;
	
	      if (ngModel) {
	        upload.applyModelValidation(ngModel, files);
	        ngModel.$setViewValue(isSingleModel ? file : files);
	      }
	
	      if (fileChange) {
	        $parse(fileChange)(scope, {
	          $files: files,
	          $file: file,
	          $newFiles: newFiles,
	          $duplicateFiles: dupFiles,
	          $invalidFiles: invalidFiles,
	          $invalidFile: invalidFile,
	          $event: evt
	        });
	      }
	
	      var invalidModel = upload.attrGetter('ngfModelInvalid', attr);
	      if (invalidModel) {
	        $timeout(function () {
	          $parse(invalidModel).assign(scope, isSingleModel ? invalidFile : invalidFiles);
	        });
	      }
	      $timeout(function () {
	        // scope apply changes
	      });
	    }
	
	    var allNewFiles, dupFiles = [], prevValidFiles, prevInvalidFiles,
	      invalids = [], valids = [];
	
	    function removeDuplicates() {
	      function equals(f1, f2) {
	        return f1.name === f2.name && (f1.$ngfOrigSize || f1.size) === (f2.$ngfOrigSize || f2.size) &&
	          f1.type === f2.type;
	      }
	
	      function isInPrevFiles(f) {
	        var j;
	        for (j = 0; j < prevValidFiles.length; j++) {
	          if (equals(f, prevValidFiles[j])) {
	            return true;
	          }
	        }
	        for (j = 0; j < prevInvalidFiles.length; j++) {
	          if (equals(f, prevInvalidFiles[j])) {
	            return true;
	          }
	        }
	        return false;
	      }
	
	      if (files) {
	        allNewFiles = [];
	        dupFiles = [];
	        for (var i = 0; i < files.length; i++) {
	          if (isInPrevFiles(files[i])) {
	            dupFiles.push(files[i]);
	          } else {
	            allNewFiles.push(files[i]);
	          }
	        }
	      }
	    }
	
	    function toArray(v) {
	      return angular.isArray(v) ? v : [v];
	    }
	
	    function resizeAndUpdate() {
	      function updateModel() {
	        $timeout(function () {
	          update(keep ? prevValidFiles.concat(valids) : valids,
	            keep ? prevInvalidFiles.concat(invalids) : invalids,
	            files, dupFiles, isSingleModel);
	        }, options && options.debounce ? options.debounce.change || options.debounce : 0);
	      }
	
	      var resizingFiles = validateAfterResize ? allNewFiles : valids;
	      resizeFile(resizingFiles, attr, scope, ngModel).then(function () {
	        if (validateAfterResize) {
	          upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
	            .then(function (validationResult) {
	              valids = validationResult.validsFiles;
	              invalids = validationResult.invalidsFiles;
	              updateModel();
	            });
	        } else {
	          updateModel();
	        }
	      }, function () {
	        for (var i = 0; i < resizingFiles.length; i++) {
	          var f = resizingFiles[i];
	          if (f.$error === 'resize') {
	            var index = valids.indexOf(f);
	            if (index > -1) {
	              valids.splice(index, 1);
	              invalids.push(f);
	            }
	            updateModel();
	          }
	        }
	      });
	    }
	
	    prevValidFiles = attr.$$ngfPrevValidFiles || [];
	    prevInvalidFiles = attr.$$ngfPrevInvalidFiles || [];
	    if (ngModel && ngModel.$modelValue) {
	      prevValidFiles = toArray(ngModel.$modelValue);
	    }
	
	    var keep = upload.attrGetter('ngfKeep', attr, scope);
	    allNewFiles = (files || []).slice(0);
	    if (keep === 'distinct' || upload.attrGetter('ngfKeepDistinct', attr, scope) === true) {
	      removeDuplicates(attr, scope);
	    }
	
	    var isSingleModel = !keep && !upload.attrGetter('ngfMultiple', attr, scope) && !upload.attrGetter('multiple', attr);
	
	    if (keep && !allNewFiles.length) return;
	
	    upload.attrGetter('ngfBeforeModelChange', attr, scope, {
	      $files: files,
	      $file: files && files.length ? files[0] : null,
	      $newFiles: allNewFiles,
	      $duplicateFiles: dupFiles,
	      $event: evt
	    });
	
	    var validateAfterResize = upload.attrGetter('ngfValidateAfterResize', attr, scope);
	
	    var options = upload.attrGetter('ngfModelOptions', attr, scope);
	    upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
	      .then(function (validationResult) {
	      if (noDelay) {
	        update(allNewFiles, [], files, dupFiles, isSingleModel);
	      } else {
	        if ((!options || !options.allowInvalid) && !validateAfterResize) {
	          valids = validationResult.validFiles;
	          invalids = validationResult.invalidFiles;
	        } else {
	          valids = allNewFiles;
	        }
	        if (upload.attrGetter('ngfFixOrientation', attr, scope) && upload.isExifSupported()) {
	          applyExifRotations(valids, attr, scope).then(function () {
	            resizeAndUpdate();
	          });
	        } else {
	          resizeAndUpdate();
	        }
	      }
	    });
	  };
	
	  return upload;
	}]);
	
	ngFileUpload.directive('ngfSelect', ['$parse', '$timeout', '$compile', 'Upload', function ($parse, $timeout, $compile, Upload) {
	  var generatedElems = [];
	
	  function isDelayedClickSupported(ua) {
	    // fix for android native browser < 4.4 and safari windows
	    var m = ua.match(/Android[^\d]*(\d+)\.(\d+)/);
	    if (m && m.length > 2) {
	      var v = Upload.defaults.androidFixMinorVersion || 4;
	      return parseInt(m[1]) < 4 || (parseInt(m[1]) === v && parseInt(m[2]) < v);
	    }
	
	    // safari on windows
	    return ua.indexOf('Chrome') === -1 && /.*Windows.*Safari.*/.test(ua);
	  }
	
	  function linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, upload) {
	    /** @namespace attr.ngfSelect */
	    /** @namespace attr.ngfChange */
	    /** @namespace attr.ngModel */
	    /** @namespace attr.ngfModelOptions */
	    /** @namespace attr.ngfMultiple */
	    /** @namespace attr.ngfCapture */
	    /** @namespace attr.ngfValidate */
	    /** @namespace attr.ngfKeep */
	    var attrGetter = function (name, scope) {
	      return upload.attrGetter(name, attr, scope);
	    };
	
	    function isInputTypeFile() {
	      return elem[0].tagName.toLowerCase() === 'input' && attr.type && attr.type.toLowerCase() === 'file';
	    }
	
	    function fileChangeAttr() {
	      return attrGetter('ngfChange') || attrGetter('ngfSelect');
	    }
	
	    function changeFn(evt) {
	      if (upload.shouldUpdateOn('change', attr, scope)) {
	        var fileList = evt.__files_ || (evt.target && evt.target.files), files = [];
	        /* Handle duplicate call in  IE11 */
	        if (!fileList) return;
	        for (var i = 0; i < fileList.length; i++) {
	          files.push(fileList[i]);
	        }
	        upload.updateModel(ngModel, attr, scope, fileChangeAttr(),
	          files.length ? files : null, evt);
	      }
	    }
	
	    upload.registerModelChangeValidator(ngModel, attr, scope);
	
	    var unwatches = [];
	    if (attrGetter('ngfMultiple')) {
	      unwatches.push(scope.$watch(attrGetter('ngfMultiple'), function () {
	        fileElem.attr('multiple', attrGetter('ngfMultiple', scope));
	      }));
	    }
	    if (attrGetter('ngfCapture')) {
	      unwatches.push(scope.$watch(attrGetter('ngfCapture'), function () {
	        fileElem.attr('capture', attrGetter('ngfCapture', scope));
	      }));
	    }
	    if (attrGetter('ngfAccept')) {
	      unwatches.push(scope.$watch(attrGetter('ngfAccept'), function () {
	        fileElem.attr('accept', attrGetter('ngfAccept', scope));
	      }));
	    }
	    unwatches.push(attr.$observe('accept', function () {
	      fileElem.attr('accept', attrGetter('accept'));
	    }));
	    function bindAttrToFileInput(fileElem, label) {
	      function updateId(val) {
	        fileElem.attr('id', 'ngf-' + val);
	        label.attr('id', 'ngf-label-' + val);
	      }
	
	      for (var i = 0; i < elem[0].attributes.length; i++) {
	        var attribute = elem[0].attributes[i];
	        if (attribute.name !== 'type' && attribute.name !== 'class' && attribute.name !== 'style') {
	          if (attribute.name === 'id') {
	            updateId(attribute.value);
	            unwatches.push(attr.$observe('id', updateId));
	          } else {
	            fileElem.attr(attribute.name, (!attribute.value && (attribute.name === 'required' ||
	            attribute.name === 'multiple')) ? attribute.name : attribute.value);
	          }
	        }
	      }
	    }
	
	    function createFileInput() {
	      if (isInputTypeFile()) {
	        return elem;
	      }
	
	      var fileElem = angular.element('<input type="file">');
	
	      var label = angular.element('<label>upload</label>');
	      label.css('visibility', 'hidden').css('position', 'absolute').css('overflow', 'hidden')
	        .css('width', '0px').css('height', '0px').css('border', 'none')
	        .css('margin', '0px').css('padding', '0px').attr('tabindex', '-1');
	      bindAttrToFileInput(fileElem, label);
	
	      generatedElems.push({el: elem, ref: label});
	
	      document.body.appendChild(label.append(fileElem)[0]);
	
	      return fileElem;
	    }
	
	    function clickHandler(evt) {
	      if (elem.attr('disabled')) return false;
	      if (attrGetter('ngfSelectDisabled', scope)) return;
	
	      var r = detectSwipe(evt);
	      // prevent the click if it is a swipe
	      if (r != null) return r;
	
	      resetModel(evt);
	
	      // fix for md when the element is removed from the DOM and added back #460
	      try {
	        if (!isInputTypeFile() && !document.body.contains(fileElem[0])) {
	          generatedElems.push({el: elem, ref: fileElem.parent()});
	          document.body.appendChild(fileElem.parent()[0]);
	          fileElem.bind('change', changeFn);
	        }
	      } catch (e) {/*ignore*/
	      }
	
	      if (isDelayedClickSupported(navigator.userAgent)) {
	        setTimeout(function () {
	          fileElem[0].click();
	        }, 0);
	      } else {
	        fileElem[0].click();
	      }
	
	      return false;
	    }
	
	
	    var initialTouchStartY = 0;
	    var initialTouchStartX = 0;
	
	    function detectSwipe(evt) {
	      var touches = evt.changedTouches || (evt.originalEvent && evt.originalEvent.changedTouches);
	      if (touches) {
	        if (evt.type === 'touchstart') {
	          initialTouchStartX = touches[0].clientX;
	          initialTouchStartY = touches[0].clientY;
	          return true; // don't block event default
	        } else {
	          // prevent scroll from triggering event
	          if (evt.type === 'touchend') {
	            var currentX = touches[0].clientX;
	            var currentY = touches[0].clientY;
	            if ((Math.abs(currentX - initialTouchStartX) > 20) ||
	              (Math.abs(currentY - initialTouchStartY) > 20)) {
	              evt.stopPropagation();
	              evt.preventDefault();
	              return false;
	            }
	          }
	          return true;
	        }
	      }
	    }
	
	    var fileElem = elem;
	
	    function resetModel(evt) {
	      if (upload.shouldUpdateOn('click', attr, scope) && fileElem.val()) {
	        fileElem.val(null);
	        upload.updateModel(ngModel, attr, scope, fileChangeAttr(), null, evt, true);
	      }
	    }
	
	    if (!isInputTypeFile()) {
	      fileElem = createFileInput();
	    }
	    fileElem.bind('change', changeFn);
	
	    if (!isInputTypeFile()) {
	      elem.bind('click touchstart touchend', clickHandler);
	    } else {
	      elem.bind('click', resetModel);
	    }
	
	    function ie10SameFileSelectFix(evt) {
	      if (fileElem && !fileElem.attr('__ngf_ie10_Fix_')) {
	        if (!fileElem[0].parentNode) {
	          fileElem = null;
	          return;
	        }
	        evt.preventDefault();
	        evt.stopPropagation();
	        fileElem.unbind('click');
	        var clone = fileElem.clone();
	        fileElem.replaceWith(clone);
	        fileElem = clone;
	        fileElem.attr('__ngf_ie10_Fix_', 'true');
	        fileElem.bind('change', changeFn);
	        fileElem.bind('click', ie10SameFileSelectFix);
	        fileElem[0].click();
	        return false;
	      } else {
	        fileElem.removeAttr('__ngf_ie10_Fix_');
	      }
	    }
	
	    if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
	      fileElem.bind('click', ie10SameFileSelectFix);
	    }
	
	    if (ngModel) ngModel.$formatters.push(function (val) {
	      if (val == null || val.length === 0) {
	        if (fileElem.val()) {
	          fileElem.val(null);
	        }
	      }
	      return val;
	    });
	
	    scope.$on('$destroy', function () {
	      if (!isInputTypeFile()) fileElem.parent().remove();
	      angular.forEach(unwatches, function (unwatch) {
	        unwatch();
	      });
	    });
	
	    $timeout(function () {
	      for (var i = 0; i < generatedElems.length; i++) {
	        var g = generatedElems[i];
	        if (!document.body.contains(g.el[0])) {
	          generatedElems.splice(i, 1);
	          g.ref.remove();
	        }
	      }
	    });
	
	    if (window.FileAPI && window.FileAPI.ngfFixIE) {
	      window.FileAPI.ngfFixIE(elem, fileElem, changeFn);
	    }
	  }
	
	  return {
	    restrict: 'AEC',
	    require: '?ngModel',
	    link: function (scope, elem, attr, ngModel) {
	      linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, Upload);
	    }
	  };
	}]);
	
	(function () {
	
	  ngFileUpload.service('UploadDataUrl', ['UploadBase', '$timeout', '$q', function (UploadBase, $timeout, $q) {
	    var upload = UploadBase;
	    upload.base64DataUrl = function (file) {
	      if (angular.isArray(file)) {
	        var d = $q.defer(), count = 0;
	        angular.forEach(file, function (f) {
	          upload.dataUrl(f, true)['finally'](function () {
	            count++;
	            if (count === file.length) {
	              var urls = [];
	              angular.forEach(file, function (ff) {
	                urls.push(ff.$ngfDataUrl);
	              });
	              d.resolve(urls, file);
	            }
	          });
	        });
	        return d.promise;
	      } else {
	        return upload.dataUrl(file, true);
	      }
	    };
	    upload.dataUrl = function (file, disallowObjectUrl) {
	      if (!file) return upload.emptyPromise(file, file);
	      if ((disallowObjectUrl && file.$ngfDataUrl != null) || (!disallowObjectUrl && file.$ngfBlobUrl != null)) {
	        return upload.emptyPromise(disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl, file);
	      }
	      var p = disallowObjectUrl ? file.$$ngfDataUrlPromise : file.$$ngfBlobUrlPromise;
	      if (p) return p;
	
	      var deferred = $q.defer();
	      $timeout(function () {
	        if (window.FileReader && file &&
	          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 8') === -1 || file.size < 20000) &&
	          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 9') === -1 || file.size < 4000000)) {
	          //prefer URL.createObjectURL for handling refrences to files of all sizes
	          //since it doesn´t build a large string in memory
	          var URL = window.URL || window.webkitURL;
	          if (URL && URL.createObjectURL && !disallowObjectUrl) {
	            var url;
	            try {
	              url = URL.createObjectURL(file);
	            } catch (e) {
	              $timeout(function () {
	                file.$ngfBlobUrl = '';
	                deferred.reject();
	              });
	              return;
	            }
	            $timeout(function () {
	              file.$ngfBlobUrl = url;
	              if (url) {
	                deferred.resolve(url, file);
	                upload.blobUrls = upload.blobUrls || [];
	                upload.blobUrlsTotalSize = upload.blobUrlsTotalSize || 0;
	                upload.blobUrls.push({url: url, size: file.size});
	                upload.blobUrlsTotalSize += file.size || 0;
	                var maxMemory = upload.defaults.blobUrlsMaxMemory || 268435456;
	                var maxLength = upload.defaults.blobUrlsMaxQueueSize || 200;
	                while ((upload.blobUrlsTotalSize > maxMemory || upload.blobUrls.length > maxLength) && upload.blobUrls.length > 1) {
	                  var obj = upload.blobUrls.splice(0, 1)[0];
	                  URL.revokeObjectURL(obj.url);
	                  upload.blobUrlsTotalSize -= obj.size;
	                }
	              }
	            });
	          } else {
	            var fileReader = new FileReader();
	            fileReader.onload = function (e) {
	              $timeout(function () {
	                file.$ngfDataUrl = e.target.result;
	                deferred.resolve(e.target.result, file);
	                $timeout(function () {
	                  delete file.$ngfDataUrl;
	                }, 1000);
	              });
	            };
	            fileReader.onerror = function () {
	              $timeout(function () {
	                file.$ngfDataUrl = '';
	                deferred.reject();
	              });
	            };
	            fileReader.readAsDataURL(file);
	          }
	        } else {
	          $timeout(function () {
	            file[disallowObjectUrl ? '$ngfDataUrl' : '$ngfBlobUrl'] = '';
	            deferred.reject();
	          });
	        }
	      });
	
	      if (disallowObjectUrl) {
	        p = file.$$ngfDataUrlPromise = deferred.promise;
	      } else {
	        p = file.$$ngfBlobUrlPromise = deferred.promise;
	      }
	      p['finally'](function () {
	        delete file[disallowObjectUrl ? '$$ngfDataUrlPromise' : '$$ngfBlobUrlPromise'];
	      });
	      return p;
	    };
	    return upload;
	  }]);
	
	  function getTagType(el) {
	    if (el.tagName.toLowerCase() === 'img') return 'image';
	    if (el.tagName.toLowerCase() === 'audio') return 'audio';
	    if (el.tagName.toLowerCase() === 'video') return 'video';
	    return /./;
	  }
	
	  function linkFileDirective(Upload, $timeout, scope, elem, attr, directiveName, resizeParams, isBackground) {
	    function constructDataUrl(file) {
	      var disallowObjectUrl = Upload.attrGetter('ngfNoObjectUrl', attr, scope);
	      Upload.dataUrl(file, disallowObjectUrl)['finally'](function () {
	        $timeout(function () {
	          var src = (disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl;
	          if (isBackground) {
	            elem.css('background-image', 'url(\'' + (src || '') + '\')');
	          } else {
	            elem.attr('src', src);
	          }
	          if (src) {
	            elem.removeClass('ng-hide');
	          } else {
	            elem.addClass('ng-hide');
	          }
	        });
	      });
	    }
	
	    $timeout(function () {
	      var unwatch = scope.$watch(attr[directiveName], function (file) {
	        var size = resizeParams;
	        if (directiveName === 'ngfThumbnail') {
	          if (!size) {
	            size = {
	              width: elem[0].naturalWidth || elem[0].clientWidth,
	              height: elem[0].naturalHeight || elem[0].clientHeight
	            };
	          }
	          if (size.width === 0 && window.getComputedStyle) {
	            var style = getComputedStyle(elem[0]);
	            if (style.width && style.width.indexOf('px') > -1 && style.height && style.height.indexOf('px') > -1) {
	              size = {
	                width: parseInt(style.width.slice(0, -2)),
	                height: parseInt(style.height.slice(0, -2))
	              };
	            }
	          }
	        }
	
	        if (angular.isString(file)) {
	          elem.removeClass('ng-hide');
	          if (isBackground) {
	            return elem.css('background-image', 'url(\'' + file + '\')');
	          } else {
	            return elem.attr('src', file);
	          }
	        }
	        if (file && file.type && file.type.search(getTagType(elem[0])) === 0 &&
	          (!isBackground || file.type.indexOf('image') === 0)) {
	          if (size && Upload.isResizeSupported()) {
	            size.resizeIf = function (width, height) {
	              return Upload.attrGetter('ngfResizeIf', attr, scope,
	                {$width: width, $height: height, $file: file});
	            };
	            Upload.resize(file, size).then(
	              function (f) {
	                constructDataUrl(f);
	              }, function (e) {
	                throw e;
	              }
	            );
	          } else {
	            constructDataUrl(file);
	          }
	        } else {
	          elem.addClass('ng-hide');
	        }
	      });
	
	      scope.$on('$destroy', function () {
	        unwatch();
	      });
	    });
	  }
	
	
	  /** @namespace attr.ngfSrc */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfSrc', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfSrc',
	          Upload.attrGetter('ngfResize', attr, scope), false);
	      }
	    };
	  }]);
	
	  /** @namespace attr.ngfBackground */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfBackground', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfBackground',
	          Upload.attrGetter('ngfResize', attr, scope), true);
	      }
	    };
	  }]);
	
	  /** @namespace attr.ngfThumbnail */
	  /** @namespace attr.ngfAsBackground */
	  /** @namespace attr.ngfSize */
	  /** @namespace attr.ngfNoObjectUrl */
	  ngFileUpload.directive('ngfThumbnail', ['Upload', '$timeout', function (Upload, $timeout) {
	    return {
	      restrict: 'AE',
	      link: function (scope, elem, attr) {
	        var size = Upload.attrGetter('ngfSize', attr, scope);
	        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfThumbnail', size,
	          Upload.attrGetter('ngfAsBackground', attr, scope));
	      }
	    };
	  }]);
	
	  ngFileUpload.config(['$compileProvider', function ($compileProvider) {
	    if ($compileProvider.imgSrcSanitizationWhitelist) $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
	    if ($compileProvider.aHrefSanitizationWhitelist) $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
	  }]);
	
	  ngFileUpload.filter('ngfDataUrl', ['UploadDataUrl', '$sce', function (UploadDataUrl, $sce) {
	    return function (file, disallowObjectUrl, trustedUrl) {
	      if (angular.isString(file)) {
	        return $sce.trustAsResourceUrl(file);
	      }
	      var src = file && ((disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl);
	      if (file && !src) {
	        if (!file.$ngfDataUrlFilterInProgress && angular.isObject(file)) {
	          file.$ngfDataUrlFilterInProgress = true;
	          UploadDataUrl.dataUrl(file, disallowObjectUrl);
	        }
	        return '';
	      }
	      if (file) delete file.$ngfDataUrlFilterInProgress;
	      return (file && src ? (trustedUrl ? $sce.trustAsResourceUrl(src) : src) : file) || '';
	    };
	  }]);
	
	})();
	
	ngFileUpload.service('UploadValidate', ['UploadDataUrl', '$q', '$timeout', function (UploadDataUrl, $q, $timeout) {
	  var upload = UploadDataUrl;
	
	  function globStringToRegex(str) {
	    var regexp = '', excludes = [];
	    if (str.length > 2 && str[0] === '/' && str[str.length - 1] === '/') {
	      regexp = str.substring(1, str.length - 1);
	    } else {
	      var split = str.split(',');
	      if (split.length > 1) {
	        for (var i = 0; i < split.length; i++) {
	          var r = globStringToRegex(split[i]);
	          if (r.regexp) {
	            regexp += '(' + r.regexp + ')';
	            if (i < split.length - 1) {
	              regexp += '|';
	            }
	          } else {
	            excludes = excludes.concat(r.excludes);
	          }
	        }
	      } else {
	        if (str.indexOf('!') === 0) {
	          excludes.push('^((?!' + globStringToRegex(str.substring(1)).regexp + ').)*$');
	        } else {
	          if (str.indexOf('.') === 0) {
	            str = '*' + str;
	          }
	          regexp = '^' + str.replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]', 'g'), '\\$&') + '$';
	          regexp = regexp.replace(/\\\*/g, '.*').replace(/\\\?/g, '.');
	        }
	      }
	    }
	    return {regexp: regexp, excludes: excludes};
	  }
	
	  upload.validatePattern = function (file, val) {
	    if (!val) {
	      return true;
	    }
	    var pattern = globStringToRegex(val), valid = true;
	    if (pattern.regexp && pattern.regexp.length) {
	      var regexp = new RegExp(pattern.regexp, 'i');
	      valid = (file.type != null && regexp.test(file.type)) ||
	        (file.name != null && regexp.test(file.name));
	    }
	    var len = pattern.excludes.length;
	    while (len--) {
	      var exclude = new RegExp(pattern.excludes[len], 'i');
	      valid = valid && (file.type == null || exclude.test(file.type)) &&
	        (file.name == null || exclude.test(file.name));
	    }
	    return valid;
	  };
	
	  upload.ratioToFloat = function (val) {
	    var r = val.toString(), xIndex = r.search(/[x:]/i);
	    if (xIndex > -1) {
	      r = parseFloat(r.substring(0, xIndex)) / parseFloat(r.substring(xIndex + 1));
	    } else {
	      r = parseFloat(r);
	    }
	    return r;
	  };
	
	  upload.registerModelChangeValidator = function (ngModel, attr, scope) {
	    if (ngModel) {
	      ngModel.$formatters.push(function (files) {
	        if (ngModel.$dirty) {
	          var filesArray = files;
	          if (files && !angular.isArray(files)) {
	            filesArray = [files];
	          }
	          upload.validate(filesArray, 0, ngModel, attr, scope).then(function () {
	            upload.applyModelValidation(ngModel, filesArray);
	          });
	        }
	        return files;
	      });
	    }
	  };
	
	  function markModelAsDirty(ngModel, files) {
	    if (files != null && !ngModel.$dirty) {
	      if (ngModel.$setDirty) {
	        ngModel.$setDirty();
	      } else {
	        ngModel.$dirty = true;
	      }
	    }
	  }
	
	  upload.applyModelValidation = function (ngModel, files) {
	    markModelAsDirty(ngModel, files);
	    angular.forEach(ngModel.$ngfValidations, function (validation) {
	      ngModel.$setValidity(validation.name, validation.valid);
	    });
	  };
	
	  upload.getValidationAttr = function (attr, scope, name, validationName, file) {
	    var dName = 'ngf' + name[0].toUpperCase() + name.substr(1);
	    var val = upload.attrGetter(dName, attr, scope, {$file: file});
	    if (val == null) {
	      val = upload.attrGetter('ngfValidate', attr, scope, {$file: file});
	      if (val) {
	        var split = (validationName || name).split('.');
	        val = val[split[0]];
	        if (split.length > 1) {
	          val = val && val[split[1]];
	        }
	      }
	    }
	    return val;
	  };
	
	  upload.validate = function (files, prevLength, ngModel, attr, scope) {
	    ngModel = ngModel || {};
	    ngModel.$ngfValidations = ngModel.$ngfValidations || [];
	
	    angular.forEach(ngModel.$ngfValidations, function (v) {
	      v.valid = true;
	    });
	
	    var attrGetter = function (name, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };
	
	    var ignoredErrors = (upload.attrGetter('ngfIgnoreInvalid', attr, scope) || '').split(' ');
	    var runAllValidation = upload.attrGetter('ngfRunAllValidations', attr, scope);
	
	    if (files == null || files.length === 0) {
	      return upload.emptyPromise({'validFiles': files, 'invalidFiles': []});
	    }
	
	    files = files.length === undefined ? [files] : files.slice(0);
	    var invalidFiles = [];
	
	    function validateSync(name, validationName, fn) {
	      if (files) {
	        var i = files.length, valid = null;
	        while (i--) {
	          var file = files[i];
	          if (file) {
	            var val = upload.getValidationAttr(attr, scope, name, validationName, file);
	            if (val != null) {
	              if (!fn(file, val, i)) {
	                if (ignoredErrors.indexOf(name) === -1) {
	                  file.$error = name;
	                  (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
	                  file.$errorParam = val;
	                  if (invalidFiles.indexOf(file) === -1) {
	                    invalidFiles.push(file);
	                  }
	                  if (!runAllValidation) {
	                    files.splice(i, 1);
	                  }
	                  valid = false;
	                } else {
	                  files.splice(i, 1);
	                }
	              }
	            }
	          }
	        }
	        if (valid !== null) {
	          ngModel.$ngfValidations.push({name: name, valid: valid});
	        }
	      }
	    }
	
	    validateSync('pattern', null, upload.validatePattern);
	    validateSync('minSize', 'size.min', function (file, val) {
	      return file.size + 0.1 >= upload.translateScalars(val);
	    });
	    validateSync('maxSize', 'size.max', function (file, val) {
	      return file.size - 0.1 <= upload.translateScalars(val);
	    });
	    var totalSize = 0;
	    validateSync('maxTotalSize', null, function (file, val) {
	      totalSize += file.size;
	      if (totalSize > upload.translateScalars(val)) {
	        files.splice(0, files.length);
	        return false;
	      }
	      return true;
	    });
	
	    validateSync('validateFn', null, function (file, r) {
	      return r === true || r === null || r === '';
	    });
	
	    if (!files.length) {
	      return upload.emptyPromise({'validFiles': [], 'invalidFiles': invalidFiles});
	    }
	
	    function validateAsync(name, validationName, type, asyncFn, fn) {
	      function resolveResult(defer, file, val) {
	        function resolveInternal(fn) {
	          if (fn()) {
	            if (ignoredErrors.indexOf(name) === -1) {
	              file.$error = name;
	              (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
	              file.$errorParam = val;
	              if (invalidFiles.indexOf(file) === -1) {
	                invalidFiles.push(file);
	              }
	              if (!runAllValidation) {
	                var i = files.indexOf(file);
	                if (i > -1) files.splice(i, 1);
	              }
	              defer.resolve(false);
	            } else {
	              var j = files.indexOf(file);
	              if (j > -1) files.splice(j, 1);
	              defer.resolve(true);
	            }
	          } else {
	            defer.resolve(true);
	          }
	        }
	
	        if (val != null) {
	          asyncFn(file, val).then(function (d) {
	            resolveInternal(function () {
	              return !fn(d, val);
	            });
	          }, function () {
	            resolveInternal(function () {
	              return attrGetter('ngfValidateForce', {$file: file});
	            });
	          });
	        } else {
	          defer.resolve(true);
	        }
	      }
	
	      var promises = [upload.emptyPromise(true)];
	      if (files) {
	        files = files.length === undefined ? [files] : files;
	        angular.forEach(files, function (file) {
	          var defer = $q.defer();
	          promises.push(defer.promise);
	          if (type && (file.type == null || file.type.search(type) !== 0)) {
	            defer.resolve(true);
	            return;
	          }
	          if (name === 'dimensions' && upload.attrGetter('ngfDimensions', attr) != null) {
	            upload.imageDimensions(file).then(function (d) {
	              resolveResult(defer, file,
	                attrGetter('ngfDimensions', {$file: file, $width: d.width, $height: d.height}));
	            }, function () {
	              defer.resolve(false);
	            });
	          } else if (name === 'duration' && upload.attrGetter('ngfDuration', attr) != null) {
	            upload.mediaDuration(file).then(function (d) {
	              resolveResult(defer, file,
	                attrGetter('ngfDuration', {$file: file, $duration: d}));
	            }, function () {
	              defer.resolve(false);
	            });
	          } else {
	            resolveResult(defer, file,
	              upload.getValidationAttr(attr, scope, name, validationName, file));
	          }
	        });
	      }
	      var deffer = $q.defer();
	      $q.all(promises).then(function (values) {
	        var isValid = true;
	        for (var i = 0; i < values.length; i++) {
	          if (!values[i]) {
	            isValid = false;
	            break;
	          }
	        }
	        ngModel.$ngfValidations.push({name: name, valid: isValid});
	        deffer.resolve(isValid);
	      });
	      return deffer.promise;
	    }
	
	    var deffer = $q.defer();
	    var promises = [];
	
	    promises.push(validateAsync('maxHeight', 'height.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.height <= val;
	      }));
	    promises.push(validateAsync('minHeight', 'height.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.height >= val;
	      }));
	    promises.push(validateAsync('maxWidth', 'width.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.width <= val;
	      }));
	    promises.push(validateAsync('minWidth', 'width.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return d.width >= val;
	      }));
	    promises.push(validateAsync('dimensions', null, /image/,
	      function (file, val) {
	        return upload.emptyPromise(val);
	      }, function (r) {
	        return r;
	      }));
	    promises.push(validateAsync('ratio', null, /image/,
	      this.imageDimensions, function (d, val) {
	        var split = val.toString().split(','), valid = false;
	        for (var i = 0; i < split.length; i++) {
	          if (Math.abs((d.width / d.height) - upload.ratioToFloat(split[i])) < 0.01) {
	            valid = true;
	          }
	        }
	        return valid;
	      }));
	    promises.push(validateAsync('maxRatio', 'ratio.max', /image/,
	      this.imageDimensions, function (d, val) {
	        return (d.width / d.height) - upload.ratioToFloat(val) < 0.0001;
	      }));
	    promises.push(validateAsync('minRatio', 'ratio.min', /image/,
	      this.imageDimensions, function (d, val) {
	        return (d.width / d.height) - upload.ratioToFloat(val) > -0.0001;
	      }));
	    promises.push(validateAsync('maxDuration', 'duration.max', /audio|video/,
	      this.mediaDuration, function (d, val) {
	        return d <= upload.translateScalars(val);
	      }));
	    promises.push(validateAsync('minDuration', 'duration.min', /audio|video/,
	      this.mediaDuration, function (d, val) {
	        return d >= upload.translateScalars(val);
	      }));
	    promises.push(validateAsync('duration', null, /audio|video/,
	      function (file, val) {
	        return upload.emptyPromise(val);
	      }, function (r) {
	        return r;
	      }));
	
	    promises.push(validateAsync('validateAsyncFn', null, null,
	      function (file, val) {
	        return val;
	      }, function (r) {
	        return r === true || r === null || r === '';
	      }));
	
	    $q.all(promises).then(function () {
	
	      if (runAllValidation) {
	        for (var i = 0; i < files.length; i++) {
	          var file = files[i];
	          if (file.$error) {
	            files.splice(i--, 1);
	          }
	        }
	      }
	
	      runAllValidation = false;
	      validateSync('maxFiles', null, function (file, val, i) {
	        return prevLength + i < val;
	      });
	
	      deffer.resolve({'validFiles': files, 'invalidFiles': invalidFiles});
	    });
	    return deffer.promise;
	  };
	
	  upload.imageDimensions = function (file) {
	    if (file.$ngfWidth && file.$ngfHeight) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve({width: file.$ngfWidth, height: file.$ngfHeight});
	      });
	      return d.promise;
	    }
	    if (file.$ngfDimensionPromise) return file.$ngfDimensionPromise;
	
	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('image') !== 0) {
	        deferred.reject('not image');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var img = angular.element('<img>').attr('src', dataUrl)
	          .css('visibility', 'hidden').css('position', 'fixed')
	          .css('max-width', 'none !important').css('max-height', 'none !important');
	
	        function success() {
	          var width = img[0].naturalWidth || img[0].clientWidth;
	          var height = img[0].naturalHeight || img[0].clientHeight;
	          img.remove();
	          file.$ngfWidth = width;
	          file.$ngfHeight = height;
	          deferred.resolve({width: width, height: height});
	        }
	
	        function error() {
	          img.remove();
	          deferred.reject('load error');
	        }
	
	        img.on('load', success);
	        img.on('error', error);
	
	        var secondsCounter = 0;
	        function checkLoadErrorInCaseOfNoCallback() {
	          $timeout(function () {
	            if (img[0].parentNode) {
	              if (img[0].clientWidth) {
	                success();
	              } else if (secondsCounter++ > 10) {
	                error();
	              } else {
	                checkLoadErrorInCaseOfNoCallback();
	              }
	            }
	          }, 1000);
	        }
	
	        checkLoadErrorInCaseOfNoCallback();
	
	        angular.element(document.getElementsByTagName('body')[0]).append(img);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });
	
	    file.$ngfDimensionPromise = deferred.promise;
	    file.$ngfDimensionPromise['finally'](function () {
	      delete file.$ngfDimensionPromise;
	    });
	    return file.$ngfDimensionPromise;
	  };
	
	  upload.mediaDuration = function (file) {
	    if (file.$ngfDuration) {
	      var d = $q.defer();
	      $timeout(function () {
	        d.resolve(file.$ngfDuration);
	      });
	      return d.promise;
	    }
	    if (file.$ngfDurationPromise) return file.$ngfDurationPromise;
	
	    var deferred = $q.defer();
	    $timeout(function () {
	      if (file.type.indexOf('audio') !== 0 && file.type.indexOf('video') !== 0) {
	        deferred.reject('not media');
	        return;
	      }
	      upload.dataUrl(file).then(function (dataUrl) {
	        var el = angular.element(file.type.indexOf('audio') === 0 ? '<audio>' : '<video>')
	          .attr('src', dataUrl).css('visibility', 'none').css('position', 'fixed');
	
	        function success() {
	          var duration = el[0].duration;
	          file.$ngfDuration = duration;
	          el.remove();
	          deferred.resolve(duration);
	        }
	
	        function error() {
	          el.remove();
	          deferred.reject('load error');
	        }
	
	        el.on('loadedmetadata', success);
	        el.on('error', error);
	        var count = 0;
	
	        function checkLoadError() {
	          $timeout(function () {
	            if (el[0].parentNode) {
	              if (el[0].duration) {
	                success();
	              } else if (count > 10) {
	                error();
	              } else {
	                checkLoadError();
	              }
	            }
	          }, 1000);
	        }
	
	        checkLoadError();
	
	        angular.element(document.body).append(el);
	      }, function () {
	        deferred.reject('load error');
	      });
	    });
	
	    file.$ngfDurationPromise = deferred.promise;
	    file.$ngfDurationPromise['finally'](function () {
	      delete file.$ngfDurationPromise;
	    });
	    return file.$ngfDurationPromise;
	  };
	  return upload;
	}
	]);
	
	ngFileUpload.service('UploadResize', ['UploadValidate', '$q', function (UploadValidate, $q) {
	  var upload = UploadValidate;
	
	  /**
	   * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
	   * images to fit into a certain area.
	   * Source:  http://stackoverflow.com/a/14731922
	   *
	   * @param {Number} srcWidth Source area width
	   * @param {Number} srcHeight Source area height
	   * @param {Number} maxWidth Nestable area maximum available width
	   * @param {Number} maxHeight Nestable area maximum available height
	   * @return {Object} { width, height }
	   */
	  var calculateAspectRatioFit = function (srcWidth, srcHeight, maxWidth, maxHeight, centerCrop) {
	    var ratio = centerCrop ? Math.max(maxWidth / srcWidth, maxHeight / srcHeight) :
	      Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
	    return {
	      width: srcWidth * ratio, height: srcHeight * ratio,
	      marginX: srcWidth * ratio - maxWidth, marginY: srcHeight * ratio - maxHeight
	    };
	  };
	
	  // Extracted from https://github.com/romelgomez/angular-firebase-image-upload/blob/master/app/scripts/fileUpload.js#L89
	  var resize = function (imagen, width, height, quality, type, ratio, centerCrop, resizeIf) {
	    var deferred = $q.defer();
	    var canvasElement = document.createElement('canvas');
	    var imageElement = document.createElement('img');
	    imageElement.setAttribute('style', 'visibility:hidden;position:fixed;z-index:-100000');
	    document.body.appendChild(imageElement);
	
	    imageElement.onload = function () {
	      var imgWidth = imageElement.width, imgHeight = imageElement.height;
	      imageElement.parentNode.removeChild(imageElement);
	      if (resizeIf != null && resizeIf(imgWidth, imgHeight) === false) {
	        deferred.reject('resizeIf');
	        return;
	      }
	      try {
	        if (ratio) {
	          var ratioFloat = upload.ratioToFloat(ratio);
	          var imgRatio = imgWidth / imgHeight;
	          if (imgRatio < ratioFloat) {
	            width = imgWidth;
	            height = width / ratioFloat;
	          } else {
	            height = imgHeight;
	            width = height * ratioFloat;
	          }
	        }
	        if (!width) {
	          width = imgWidth;
	        }
	        if (!height) {
	          height = imgHeight;
	        }
	        var dimensions = calculateAspectRatioFit(imgWidth, imgHeight, width, height, centerCrop);
	        canvasElement.width = Math.min(dimensions.width, width);
	        canvasElement.height = Math.min(dimensions.height, height);
	        var context = canvasElement.getContext('2d');
	        context.drawImage(imageElement,
	          Math.min(0, -dimensions.marginX / 2), Math.min(0, -dimensions.marginY / 2),
	          dimensions.width, dimensions.height);
	        deferred.resolve(canvasElement.toDataURL(type || 'image/WebP', quality || 0.934));
	      } catch (e) {
	        deferred.reject(e);
	      }
	    };
	    imageElement.onerror = function () {
	      imageElement.parentNode.removeChild(imageElement);
	      deferred.reject();
	    };
	    imageElement.src = imagen;
	    return deferred.promise;
	  };
	
	  upload.dataUrltoBlob = function (dataurl, name, origSize) {
	    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
	      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
	    while (n--) {
	      u8arr[n] = bstr.charCodeAt(n);
	    }
	    var blob = new window.Blob([u8arr], {type: mime});
	    blob.name = name;
	    blob.$ngfOrigSize = origSize;
	    return blob;
	  };
	
	  upload.isResizeSupported = function () {
	    var elem = document.createElement('canvas');
	    return window.atob && elem.getContext && elem.getContext('2d') && window.Blob;
	  };
	
	  if (upload.isResizeSupported()) {
	    // add name getter to the blob constructor prototype
	    Object.defineProperty(window.Blob.prototype, 'name', {
	      get: function () {
	        return this.$ngfName;
	      },
	      set: function (v) {
	        this.$ngfName = v;
	      },
	      configurable: true
	    });
	  }
	
	  upload.resize = function (file, options) {
	    if (file.type.indexOf('image') !== 0) return upload.emptyPromise(file);
	
	    var deferred = $q.defer();
	    upload.dataUrl(file, true).then(function (url) {
	      resize(url, options.width, options.height, options.quality, options.type || file.type,
	        options.ratio, options.centerCrop, options.resizeIf)
	        .then(function (dataUrl) {
	          if (file.type === 'image/jpeg' && options.restoreExif !== false) {
	            try {
	              dataUrl = upload.restoreExif(url, dataUrl);
	            } catch (e) {
	              setTimeout(function () {throw e;}, 1);
	            }
	          }
	          try {
	            var blob = upload.dataUrltoBlob(dataUrl, file.name, file.size);
	            deferred.resolve(blob);
	          } catch (e) {
	            deferred.reject(e);
	          }
	        }, function (r) {
	          if (r === 'resizeIf') {
	            deferred.resolve(file);
	          }
	          deferred.reject(r);
	        });
	    }, function (e) {
	      deferred.reject(e);
	    });
	    return deferred.promise;
	  };
	
	  return upload;
	}]);
	
	(function () {
	  ngFileUpload.directive('ngfDrop', ['$parse', '$timeout', '$window', 'Upload', '$http', '$q',
	    function ($parse, $timeout, $window, Upload, $http, $q) {
	      return {
	        restrict: 'AEC',
	        require: '?ngModel',
	        link: function (scope, elem, attr, ngModel) {
	          linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, Upload, $http, $q);
	        }
	      };
	    }]);
	
	  ngFileUpload.directive('ngfNoFileDrop', function () {
	    return function (scope, elem) {
	      if (dropAvailable()) elem.css('display', 'none');
	    };
	  });
	
	  ngFileUpload.directive('ngfDropAvailable', ['$parse', '$timeout', 'Upload', function ($parse, $timeout, Upload) {
	    return function (scope, elem, attr) {
	      if (dropAvailable()) {
	        var model = $parse(Upload.attrGetter('ngfDropAvailable', attr));
	        $timeout(function () {
	          model(scope);
	          if (model.assign) {
	            model.assign(scope, true);
	          }
	        });
	      }
	    };
	  }]);
	
	  function linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, upload, $http, $q) {
	    var available = dropAvailable();
	
	    var attrGetter = function (name, scope, params) {
	      return upload.attrGetter(name, attr, scope, params);
	    };
	
	    if (attrGetter('dropAvailable')) {
	      $timeout(function () {
	        if (scope[attrGetter('dropAvailable')]) {
	          scope[attrGetter('dropAvailable')].value = available;
	        } else {
	          scope[attrGetter('dropAvailable')] = available;
	        }
	      });
	    }
	    if (!available) {
	      if (attrGetter('ngfHideOnDropNotAvailable', scope) === true) {
	        elem.css('display', 'none');
	      }
	      return;
	    }
	
	    function isDisabled() {
	      return elem.attr('disabled') || attrGetter('ngfDropDisabled', scope);
	    }
	
	    if (attrGetter('ngfSelect') == null) {
	      upload.registerModelChangeValidator(ngModel, attr, scope);
	    }
	
	    var leaveTimeout = null;
	    var stopPropagation = $parse(attrGetter('ngfStopPropagation'));
	    var dragOverDelay = 1;
	    var actualDragOverClass;
	
	    elem[0].addEventListener('dragover', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      // handling dragover events from the Chrome download bar
	      if (navigator.userAgent.indexOf('Chrome') > -1) {
	        var b = evt.dataTransfer.effectAllowed;
	        evt.dataTransfer.dropEffect = ('move' === b || 'linkMove' === b) ? 'move' : 'copy';
	      }
	      $timeout.cancel(leaveTimeout);
	      if (!actualDragOverClass) {
	        actualDragOverClass = 'C';
	        calculateDragOverClass(scope, attr, evt, function (clazz) {
	          actualDragOverClass = clazz;
	          elem.addClass(actualDragOverClass);
	          attrGetter('ngfDrag', scope, {$isDragging: true, $class: actualDragOverClass, $event: evt});
	        });
	      }
	    }, false);
	    elem[0].addEventListener('dragenter', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	    }, false);
	    elem[0].addEventListener('dragleave', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      leaveTimeout = $timeout(function () {
	        if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	        actualDragOverClass = null;
	        attrGetter('ngfDrag', scope, {$isDragging: false, $event: evt});
	      }, dragOverDelay || 100);
	    }, false);
	    elem[0].addEventListener('drop', function (evt) {
	      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
	      evt.preventDefault();
	      if (stopPropagation(scope)) evt.stopPropagation();
	      if (actualDragOverClass) elem.removeClass(actualDragOverClass);
	      actualDragOverClass = null;
	      extractFilesAndUpdateModel(evt.dataTransfer, evt, 'dropUrl');
	    }, false);
	    elem[0].addEventListener('paste', function (evt) {
	      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
	        attrGetter('ngfEnableFirefoxPaste', scope)) {
	        evt.preventDefault();
	      }
	      if (isDisabled() || !upload.shouldUpdateOn('paste', attr, scope)) return;
	      extractFilesAndUpdateModel(evt.clipboardData || evt.originalEvent.clipboardData, evt, 'pasteUrl');
	    }, false);
	
	    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
	      attrGetter('ngfEnableFirefoxPaste', scope)) {
	      elem.attr('contenteditable', true);
	      elem.on('keypress', function (e) {
	        if (!e.metaKey && !e.ctrlKey) {
	          e.preventDefault();
	        }
	      });
	    }
	
	    function extractFilesAndUpdateModel(source, evt, updateOnType) {
	      if (!source) return;
	      // html needs to be calculated on the same process otherwise the data will be wiped
	      // after promise resolve or setTimeout.
	      var html;
	      try {
	        html = source && source.getData && source.getData('text/html');
	      } catch (e) {/* Fix IE11 that throw error calling getData */
	      }
	      extractFiles(source.items, source.files, attrGetter('ngfAllowDir', scope) !== false,
	        attrGetter('multiple') || attrGetter('ngfMultiple', scope)).then(function (files) {
	        if (files.length) {
	          updateModel(files, evt);
	        } else {
	          extractFilesFromHtml(updateOnType, html).then(function (files) {
	            updateModel(files, evt);
	          });
	        }
	      });
	    }
	
	    function updateModel(files, evt) {
	      upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), files, evt);
	    }
	
	    function extractFilesFromHtml(updateOn, html) {
	      if (!upload.shouldUpdateOn(updateOn, attr, scope) || typeof html !== 'string') return upload.rejectPromise([]);
	      var urls = [];
	      html.replace(/<(img src|img [^>]* src) *=\"([^\"]*)\"/gi, function (m, n, src) {
	        urls.push(src);
	      });
	      var promises = [], files = [];
	      if (urls.length) {
	        angular.forEach(urls, function (url) {
	          promises.push(upload.urlToBlob(url).then(function (blob) {
	            files.push(blob);
	          }));
	        });
	        var defer = $q.defer();
	        $q.all(promises).then(function () {
	          defer.resolve(files);
	        }, function (e) {
	          defer.reject(e);
	        });
	        return defer.promise;
	      }
	      return upload.emptyPromise();
	    }
	
	    function calculateDragOverClass(scope, attr, evt, callback) {
	      var obj = attrGetter('ngfDragOverClass', scope, {$event: evt}), dClass = 'dragover';
	      if (angular.isString(obj)) {
	        dClass = obj;
	      } else if (obj) {
	        if (obj.delay) dragOverDelay = obj.delay;
	        if (obj.accept || obj.reject) {
	          var items = evt.dataTransfer.items;
	          if (items == null || !items.length) {
	            dClass = obj.accept;
	          } else {
	            var pattern = obj.pattern || attrGetter('ngfPattern', scope, {$event: evt});
	            var len = items.length;
	            while (len--) {
	              if (!upload.validatePattern(items[len], pattern)) {
	                dClass = obj.reject;
	                break;
	              } else {
	                dClass = obj.accept;
	              }
	            }
	          }
	        }
	      }
	      callback(dClass);
	    }
	
	    function extractFiles(items, fileList, allowDir, multiple) {
	      var maxFiles = upload.getValidationAttr(attr, scope, 'maxFiles');
	      if (maxFiles == null) {
	        maxFiles = Number.MAX_VALUE;
	      }
	      var maxTotalSize = upload.getValidationAttr(attr, scope, 'maxTotalSize');
	      if (maxTotalSize == null) {
	        maxTotalSize = Number.MAX_VALUE;
	      }
	      var includeDir = attrGetter('ngfIncludeDir', scope);
	      var files = [], totalSize = 0;
	
	      function traverseFileTree(entry, path) {
	        var defer = $q.defer();
	        if (entry != null) {
	          if (entry.isDirectory) {
	            var promises = [upload.emptyPromise()];
	            if (includeDir) {
	              var file = {type: 'directory'};
	              file.name = file.path = (path || '') + entry.name;
	              files.push(file);
	            }
	            var dirReader = entry.createReader();
	            var entries = [];
	            var readEntries = function () {
	              dirReader.readEntries(function (results) {
	                try {
	                  if (!results.length) {
	                    angular.forEach(entries.slice(0), function (e) {
	                      if (files.length <= maxFiles && totalSize <= maxTotalSize) {
	                        promises.push(traverseFileTree(e, (path ? path : '') + entry.name + '/'));
	                      }
	                    });
	                    $q.all(promises).then(function () {
	                      defer.resolve();
	                    }, function (e) {
	                      defer.reject(e);
	                    });
	                  } else {
	                    entries = entries.concat(Array.prototype.slice.call(results || [], 0));
	                    readEntries();
	                  }
	                } catch (e) {
	                  defer.reject(e);
	                }
	              }, function (e) {
	                defer.reject(e);
	              });
	            };
	            readEntries();
	          } else {
	            entry.file(function (file) {
	              try {
	                file.path = (path ? path : '') + file.name;
	                if (includeDir) {
	                  file = upload.rename(file, file.path);
	                }
	                files.push(file);
	                totalSize += file.size;
	                defer.resolve();
	              } catch (e) {
	                defer.reject(e);
	              }
	            }, function (e) {
	              defer.reject(e);
	            });
	          }
	        }
	        return defer.promise;
	      }
	
	      var promises = [upload.emptyPromise()];
	
	      if (items && items.length > 0 && $window.location.protocol !== 'file:') {
	        for (var i = 0; i < items.length; i++) {
	          if (items[i].webkitGetAsEntry && items[i].webkitGetAsEntry() && items[i].webkitGetAsEntry().isDirectory) {
	            var entry = items[i].webkitGetAsEntry();
	            if (entry.isDirectory && !allowDir) {
	              continue;
	            }
	            if (entry != null) {
	              promises.push(traverseFileTree(entry));
	            }
	          } else {
	            var f = items[i].getAsFile();
	            if (f != null) {
	              files.push(f);
	              totalSize += f.size;
	            }
	          }
	          if (files.length > maxFiles || totalSize > maxTotalSize ||
	            (!multiple && files.length > 0)) break;
	        }
	      } else {
	        if (fileList != null) {
	          for (var j = 0; j < fileList.length; j++) {
	            var file = fileList.item(j);
	            if (file.type || file.size > 0) {
	              files.push(file);
	              totalSize += file.size;
	            }
	            if (files.length > maxFiles || totalSize > maxTotalSize ||
	              (!multiple && files.length > 0)) break;
	          }
	        }
	      }
	
	      var defer = $q.defer();
	      $q.all(promises).then(function () {
	        if (!multiple && !includeDir && files.length) {
	          var i = 0;
	          while (files[i] && files[i].type === 'directory') i++;
	          defer.resolve([files[i]]);
	        } else {
	          defer.resolve(files);
	        }
	      }, function (e) {
	        defer.reject(e);
	      });
	
	      return defer.promise;
	    }
	  }
	
	  function dropAvailable() {
	    var div = document.createElement('div');
	    return ('draggable' in div) && ('ondrop' in div) && !/Edge\/12./i.test(navigator.userAgent);
	  }
	
	})();
	
	// customized version of https://github.com/exif-js/exif-js
	ngFileUpload.service('UploadExif', ['UploadResize', '$q', function (UploadResize, $q) {
	  var upload = UploadResize;
	
	  upload.isExifSupported = function () {
	    return window.FileReader && new FileReader().readAsArrayBuffer && upload.isResizeSupported();
	  };
	
	  function applyTransform(ctx, orientation, width, height) {
	    switch (orientation) {
	      case 2:
	        return ctx.transform(-1, 0, 0, 1, width, 0);
	      case 3:
	        return ctx.transform(-1, 0, 0, -1, width, height);
	      case 4:
	        return ctx.transform(1, 0, 0, -1, 0, height);
	      case 5:
	        return ctx.transform(0, 1, 1, 0, 0, 0);
	      case 6:
	        return ctx.transform(0, 1, -1, 0, height, 0);
	      case 7:
	        return ctx.transform(0, -1, -1, 0, height, width);
	      case 8:
	        return ctx.transform(0, -1, 1, 0, 0, width);
	    }
	  }
	
	  upload.readOrientation = function (file) {
	    var defer = $q.defer();
	    var reader = new FileReader();
	    var slicedFile = file.slice ? file.slice(0, 64 * 1024) : file;
	    reader.readAsArrayBuffer(slicedFile);
	    reader.onerror = function (e) {
	      return defer.reject(e);
	    };
	    reader.onload = function (e) {
	      var result = {orientation: 1};
	      var view = new DataView(this.result);
	      if (view.getUint16(0, false) !== 0xFFD8) return defer.resolve(result);
	
	      var length = view.byteLength,
	        offset = 2;
	      while (offset < length) {
	        var marker = view.getUint16(offset, false);
	        offset += 2;
	        if (marker === 0xFFE1) {
	          if (view.getUint32(offset += 2, false) !== 0x45786966) return defer.resolve(result);
	
	          var little = view.getUint16(offset += 6, false) === 0x4949;
	          offset += view.getUint32(offset + 4, little);
	          var tags = view.getUint16(offset, little);
	          offset += 2;
	          for (var i = 0; i < tags; i++)
	            if (view.getUint16(offset + (i * 12), little) === 0x0112) {
	              var orientation = view.getUint16(offset + (i * 12) + 8, little);
	              if (orientation >= 2 && orientation <= 8) {
	                view.setUint16(offset + (i * 12) + 8, 1, little);
	                result.fixedArrayBuffer = e.target.result;
	              }
	              result.orientation = orientation;
	              return defer.resolve(result);
	            }
	        } else if ((marker & 0xFF00) !== 0xFF00) break;
	        else offset += view.getUint16(offset, false);
	      }
	      return defer.resolve(result);
	    };
	    return defer.promise;
	  };
	
	  function arrayBufferToBase64(buffer) {
	    var binary = '';
	    var bytes = new Uint8Array(buffer);
	    var len = bytes.byteLength;
	    for (var i = 0; i < len; i++) {
	      binary += String.fromCharCode(bytes[i]);
	    }
	    return window.btoa(binary);
	  }
	
	  upload.applyExifRotation = function (file) {
	    if (file.type.indexOf('image/jpeg') !== 0) {
	      return upload.emptyPromise(file);
	    }
	
	    var deferred = $q.defer();
	    upload.readOrientation(file).then(function (result) {
	      if (result.orientation < 2 || result.orientation > 8) {
	        return deferred.resolve(file);
	      }
	      upload.dataUrl(file, true).then(function (url) {
	        var canvas = document.createElement('canvas');
	        var img = document.createElement('img');
	
	        img.onload = function () {
	          try {
	            canvas.width = result.orientation > 4 ? img.height : img.width;
	            canvas.height = result.orientation > 4 ? img.width : img.height;
	            var ctx = canvas.getContext('2d');
	            applyTransform(ctx, result.orientation, img.width, img.height);
	            ctx.drawImage(img, 0, 0);
	            var dataUrl = canvas.toDataURL(file.type || 'image/WebP', 0.934);
	            dataUrl = upload.restoreExif(arrayBufferToBase64(result.fixedArrayBuffer), dataUrl);
	            var blob = upload.dataUrltoBlob(dataUrl, file.name);
	            deferred.resolve(blob);
	          } catch (e) {
	            return deferred.reject(e);
	          }
	        };
	        img.onerror = function () {
	          deferred.reject();
	        };
	        img.src = url;
	      }, function (e) {
	        deferred.reject(e);
	      });
	    }, function (e) {
	      deferred.reject(e);
	    });
	    return deferred.promise;
	  };
	
	  upload.restoreExif = function (orig, resized) {
	    var ExifRestorer = {};
	
	    ExifRestorer.KEY_STR = 'ABCDEFGHIJKLMNOP' +
	      'QRSTUVWXYZabcdef' +
	      'ghijklmnopqrstuv' +
	      'wxyz0123456789+/' +
	      '=';
	
	    ExifRestorer.encode64 = function (input) {
	      var output = '',
	        chr1, chr2, chr3 = '',
	        enc1, enc2, enc3, enc4 = '',
	        i = 0;
	
	      do {
	        chr1 = input[i++];
	        chr2 = input[i++];
	        chr3 = input[i++];
	
	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	        enc4 = chr3 & 63;
	
	        if (isNaN(chr2)) {
	          enc3 = enc4 = 64;
	        } else if (isNaN(chr3)) {
	          enc4 = 64;
	        }
	
	        output = output +
	          this.KEY_STR.charAt(enc1) +
	          this.KEY_STR.charAt(enc2) +
	          this.KEY_STR.charAt(enc3) +
	          this.KEY_STR.charAt(enc4);
	        chr1 = chr2 = chr3 = '';
	        enc1 = enc2 = enc3 = enc4 = '';
	      } while (i < input.length);
	
	      return output;
	    };
	
	    ExifRestorer.restore = function (origFileBase64, resizedFileBase64) {
	      if (origFileBase64.match('data:image/jpeg;base64,')) {
	        origFileBase64 = origFileBase64.replace('data:image/jpeg;base64,', '');
	      }
	
	      var rawImage = this.decode64(origFileBase64);
	      var segments = this.slice2Segments(rawImage);
	
	      var image = this.exifManipulation(resizedFileBase64, segments);
	
	      return 'data:image/jpeg;base64,' + this.encode64(image);
	    };
	
	
	    ExifRestorer.exifManipulation = function (resizedFileBase64, segments) {
	      var exifArray = this.getExifArray(segments),
	        newImageArray = this.insertExif(resizedFileBase64, exifArray);
	      return new Uint8Array(newImageArray);
	    };
	
	
	    ExifRestorer.getExifArray = function (segments) {
	      var seg;
	      for (var x = 0; x < segments.length; x++) {
	        seg = segments[x];
	        if (seg[0] === 255 & seg[1] === 225) //(ff e1)
	        {
	          return seg;
	        }
	      }
	      return [];
	    };
	
	
	    ExifRestorer.insertExif = function (resizedFileBase64, exifArray) {
	      var imageData = resizedFileBase64.replace('data:image/jpeg;base64,', ''),
	        buf = this.decode64(imageData),
	        separatePoint = buf.indexOf(255, 3),
	        mae = buf.slice(0, separatePoint),
	        ato = buf.slice(separatePoint),
	        array = mae;
	
	      array = array.concat(exifArray);
	      array = array.concat(ato);
	      return array;
	    };
	
	
	    ExifRestorer.slice2Segments = function (rawImageArray) {
	      var head = 0,
	        segments = [];
	
	      while (1) {
	        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) {
	          break;
	        }
	        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) {
	          head += 2;
	        }
	        else {
	          var length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3],
	            endPoint = head + length + 2,
	            seg = rawImageArray.slice(head, endPoint);
	          segments.push(seg);
	          head = endPoint;
	        }
	        if (head > rawImageArray.length) {
	          break;
	        }
	      }
	
	      return segments;
	    };
	
	
	    ExifRestorer.decode64 = function (input) {
	      var chr1, chr2, chr3 = '',
	        enc1, enc2, enc3, enc4 = '',
	        i = 0,
	        buf = [];
	
	      // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
	      var base64test = /[^A-Za-z0-9\+\/\=]/g;
	      if (base64test.exec(input)) {
	        console.log('There were invalid base64 characters in the input text.\n' +
	          'Valid base64 characters are A-Z, a-z, 0-9, ' + ', ' / ',and "="\n' +
	          'Expect errors in decoding.');
	      }
	      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
	
	      do {
	        enc1 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc2 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc3 = this.KEY_STR.indexOf(input.charAt(i++));
	        enc4 = this.KEY_STR.indexOf(input.charAt(i++));
	
	        chr1 = (enc1 << 2) | (enc2 >> 4);
	        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	        chr3 = ((enc3 & 3) << 6) | enc4;
	
	        buf.push(chr1);
	
	        if (enc3 !== 64) {
	          buf.push(chr2);
	        }
	        if (enc4 !== 64) {
	          buf.push(chr3);
	        }
	
	        chr1 = chr2 = chr3 = '';
	        enc1 = enc2 = enc3 = enc4 = '';
	
	      } while (i < input.length);
	
	      return buf;
	    };
	
	    return ExifRestorer.restore(orig, resized);  //<= EXIF
	  };
	
	  return upload;
	}]);
	


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.18.1';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`',
	      INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;
	
	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;
	
	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * **Security:** See
	     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
	     * — `_.template` is insecure and will be removed in v5.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            };
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	
	      // Prevent prototype pollution:
	      // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
	      // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
	      var index = -1,
	          length = path.length;
	
	      if (!length) {
	        return true;
	      }
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	
	        // Always block "__proto__" anywhere in the path if it's not expected
	        if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) {
	          return false;
	        }
	
	        // Block constructor/prototype as non-terminal traversal keys to prevent
	        // escaping the object graph into built-in constructors and prototypes.
	        if ((key === 'constructor' || key === 'prototype') && index < length - 1) {
	          return false;
	        }
	      }
	
	      var obj = parent(object, path);
	      return obj == null || delete obj[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        baseAssignValue(result, pair[0], pair[1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * **Note:** If `lower` is greater than `upper`, the values are swapped.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * // when lower is greater than upper the values are swapped
	     * _.random(5, 0);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(-5);
	     * // => an integer between -5 and 0
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Security:** `_.template` is insecure and should not be used. It will be
	     * removed in Lodash v5. Avoid untrusted input. See
	     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      arrayEach(importsKeys, function(key) {
	        if (reForbiddenIdentifierChars.test(key)) {
	          throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
	        }
	      });
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }
	
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(17)(module)))

/***/ },
/* 17 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* angular-moment.js / v1.0.1 / (c) 2013, 2014, 2015, 2016 Uri Shaked / MIT Licence */
	
	'format amd';
	/* global define */
	
	(function () {
		'use strict';
	
		function isUndefinedOrNull(val) {
			return angular.isUndefined(val) || val === null;
		}
	
		function requireMoment() {
			try {
				return __webpack_require__(19); // Using nw.js or browserify?
			} catch (e) {
				throw new Error('Please install moment via npm. Please reference to: https://github.com/urish/angular-moment'); // Add wiki/troubleshooting section?
			}
		}
	
		function angularMoment(angular, moment) {
	
			if(typeof moment === 'undefined') {
				if(true) {
					moment = requireMoment();
				}else{
					throw new Error('Moment cannot be found by angular-moment! Please reference to: https://github.com/urish/angular-moment'); // Add wiki/troubleshooting section?
				}
			}
	
			/**
			 * @ngdoc overview
			 * @name angularMoment
			 *
			 * @description
			 * angularMoment module provides moment.js functionality for angular.js apps.
			 */
			angular.module('angularMoment', [])
	
			/**
			 * @ngdoc object
			 * @name angularMoment.config:angularMomentConfig
			 *
			 * @description
			 * Common configuration of the angularMoment module
			 */
				.constant('angularMomentConfig', {
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#preprocess
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {function} A preprocessor function that will be applied on all incoming dates
					 *
					 * @description
					 * Defines a preprocessor function to apply on all input dates (e.g. the input of `am-time-ago`,
					 * `amCalendar`, etc.). The function must return a `moment` object.
					 *
					 * @example
					 *   // Causes angular-moment to always treat the input values as unix timestamps
					 *   angularMomentConfig.preprocess = function(value) {
					 * 	   return moment.unix(value);
					 *   }
					 */
					preprocess: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#timezone
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {string} The default timezone
					 *
					 * @description
					 * The default timezone (e.g. 'Europe/London'). Empty string by default (does not apply
					 * any timezone shift).
					 *
					 * NOTE: This option requires moment-timezone >= 0.3.0.
					 */
					timezone: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#format
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {string} The pre-conversion format of the date
					 *
					 * @description
					 * Specify the format of the input date. Essentially it's a
					 * default and saves you from specifying a format in every
					 * element. Overridden by element attr. Null by default.
					 */
					format: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#statefulFilters
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {boolean} Whether angular-moment filters should be stateless (or not)
					 *
					 * @description
					 * Specifies whether the filters included with angular-moment are stateful.
					 * Stateful filters will automatically re-evaluate whenever you change the timezone
					 * or locale settings, but may negatively impact performance. true by default.
					 */
					statefulFilters: true
				})
	
			/**
			 * @ngdoc object
			 * @name angularMoment.object:moment
			 *
			 * @description
			 * moment global (as provided by the moment.js library)
			 */
				.constant('moment', moment)
	
			/**
			 * @ngdoc object
			 * @name angularMoment.config:amTimeAgoConfig
			 * @module angularMoment
			 *
			 * @description
			 * configuration specific to the amTimeAgo directive
			 */
				.constant('amTimeAgoConfig', {
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#withoutSuffix
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {boolean} Whether to include a suffix in am-time-ago directive
					 *
					 * @description
					 * Defaults to false.
					 */
					withoutSuffix: false,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#serverTime
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {number} Server time in milliseconds since the epoch
					 *
					 * @description
					 * If set, time ago will be calculated relative to the given value.
					 * If null, local time will be used. Defaults to null.
					 */
					serverTime: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#titleFormat
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {string} The format of the date to be displayed in the title of the element. If null,
					 *        the directive set the title of the element.
					 *
					 * @description
					 * The format of the date used for the title of the element. null by default.
					 */
					titleFormat: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#fullDateThreshold
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {number} The minimum number of days for showing a full date instead of relative time
					 *
					 * @description
					 * The threshold for displaying a full date. The default is null, which means the date will always
					 * be relative, and full date will never be displayed.
					 */
					fullDateThreshold: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#fullDateFormat
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {string} The format to use when displaying a full date.
					 *
					 * @description
					 * Specify the format of the date when displayed as full date. null by default.
					 */
					fullDateFormat: null,
	
					fullDateThresholdUnit: 'day'
				})
	
			/**
			 * @ngdoc directive
			 * @name angularMoment.directive:amTimeAgo
			 * @module angularMoment
			 *
			 * @restrict A
			 */
				.directive('amTimeAgo', ['$window', 'moment', 'amMoment', 'amTimeAgoConfig', function ($window, moment, amMoment, amTimeAgoConfig) {
	
					return function (scope, element, attr) {
						var activeTimeout = null;
						var currentValue;
						var withoutSuffix = amTimeAgoConfig.withoutSuffix;
						var titleFormat = amTimeAgoConfig.titleFormat;
						var fullDateThreshold = amTimeAgoConfig.fullDateThreshold;
						var fullDateFormat = amTimeAgoConfig.fullDateFormat;
						var fullDateThresholdUnit = amTimeAgoConfig.fullDateThresholdUnit;
	
						var localDate = new Date().getTime();
						var modelName = attr.amTimeAgo;
						var currentFrom;
						var isTimeElement = ('TIME' === element[0].nodeName.toUpperCase());
						var setTitleTime = !element.attr('title');
	
						function getNow() {
							var now;
							if (currentFrom) {
								now = currentFrom;
							} else if (amTimeAgoConfig.serverTime) {
								var localNow = new Date().getTime();
								var nowMillis = localNow - localDate + amTimeAgoConfig.serverTime;
								now = moment(nowMillis);
							}
							else {
								now = moment();
							}
							return now;
						}
	
						function cancelTimer() {
							if (activeTimeout) {
								$window.clearTimeout(activeTimeout);
								activeTimeout = null;
							}
						}
	
						function updateTime(momentInstance) {
							var timeAgo = getNow().diff(momentInstance, fullDateThresholdUnit);
							var showFullDate = fullDateThreshold && timeAgo >= fullDateThreshold;
	
							if (showFullDate) {
								element.text(momentInstance.format(fullDateFormat));
							} else {
								element.text(momentInstance.from(getNow(), withoutSuffix));
							}
	
							if (titleFormat && setTitleTime) {
								element.attr('title', momentInstance.format(titleFormat));
							}
	
							if (!showFullDate) {
								var howOld = Math.abs(getNow().diff(momentInstance, 'minute'));
								var secondsUntilUpdate = 3600;
								if (howOld < 1) {
									secondsUntilUpdate = 1;
								} else if (howOld < 60) {
									secondsUntilUpdate = 30;
								} else if (howOld < 180) {
									secondsUntilUpdate = 300;
								}
	
								activeTimeout = $window.setTimeout(function () {
									updateTime(momentInstance);
								}, secondsUntilUpdate * 1000);
							}
						}
	
						function updateDateTimeAttr(value) {
							if (isTimeElement) {
								element.attr('datetime', value);
							}
						}
	
						function updateMoment() {
							cancelTimer();
							if (currentValue) {
								var momentValue = amMoment.preprocessDate(currentValue);
								updateTime(momentValue);
								updateDateTimeAttr(momentValue.toISOString());
							}
						}
	
						scope.$watch(modelName, function (value) {
							if (isUndefinedOrNull(value) || (value === '')) {
								cancelTimer();
								if (currentValue) {
									element.text('');
									updateDateTimeAttr('');
									currentValue = null;
								}
								return;
							}
	
							currentValue = value;
							updateMoment();
						});
	
						if (angular.isDefined(attr.amFrom)) {
							scope.$watch(attr.amFrom, function (value) {
								if (isUndefinedOrNull(value) || (value === '')) {
									currentFrom = null;
								} else {
									currentFrom = moment(value);
								}
								updateMoment();
							});
						}
	
						if (angular.isDefined(attr.amWithoutSuffix)) {
							scope.$watch(attr.amWithoutSuffix, function (value) {
								if (typeof value === 'boolean') {
									withoutSuffix = value;
									updateMoment();
								} else {
									withoutSuffix = amTimeAgoConfig.withoutSuffix;
								}
							});
						}
	
						attr.$observe('amFullDateThreshold', function (newValue) {
							fullDateThreshold = newValue;
							updateMoment();
						});
	
						attr.$observe('amFullDateFormat', function (newValue) {
							fullDateFormat = newValue;
							updateMoment();
						});
	
						attr.$observe('amFullDateThresholdUnit', function (newValue) {
							fullDateThresholdUnit = newValue;
							updateMoment();
						});
	
						scope.$on('$destroy', function () {
							cancelTimer();
						});
	
						scope.$on('amMoment:localeChanged', function () {
							updateMoment();
						});
					};
				}])
	
			/**
			 * @ngdoc service
			 * @name angularMoment.service.amMoment
			 * @module angularMoment
			 */
				.service('amMoment', ['moment', '$rootScope', '$log', 'angularMomentConfig', function (moment, $rootScope, $log, angularMomentConfig) {
					var defaultTimezone = null;
	
					/**
					 * @ngdoc function
					 * @name angularMoment.service.amMoment#changeLocale
					 * @methodOf angularMoment.service.amMoment
					 *
					 * @description
					 * Changes the locale for moment.js and updates all the am-time-ago directive instances
					 * with the new locale. Also broadcasts an `amMoment:localeChanged` event on $rootScope.
					 *
					 * @param {string} locale Locale code (e.g. en, es, ru, pt-br, etc.)
					 * @param {object} customization object of locale strings to override
					 */
					this.changeLocale = function (locale, customization) {
						var result = moment.locale(locale, customization);
						if (angular.isDefined(locale)) {
							$rootScope.$broadcast('amMoment:localeChanged');
	
						}
						return result;
					};
	
					/**
					 * @ngdoc function
					 * @name angularMoment.service.amMoment#changeTimezone
					 * @methodOf angularMoment.service.amMoment
					 *
					 * @description
					 * Changes the default timezone for amCalendar, amDateFormat and amTimeAgo. Also broadcasts an
					 * `amMoment:timezoneChanged` event on $rootScope.
					 *
					 * Note: this method works only if moment-timezone > 0.3.0 is loaded
					 *
					 * @param {string} timezone Timezone name (e.g. UTC)
					 */
					this.changeTimezone = function (timezone) {
						if (moment.tz && moment.tz.setDefault) {
							moment.tz.setDefault(timezone);
							$rootScope.$broadcast('amMoment:timezoneChanged');
						} else {
							$log.warn('angular-moment: changeTimezone() works only with moment-timezone.js v0.3.0 or greater.');
						}
						angularMomentConfig.timezone = timezone;
						defaultTimezone = timezone;
					};
	
					/**
					 * @ngdoc function
					 * @name angularMoment.service.amMoment#preprocessDate
					 * @methodOf angularMoment.service.amMoment
					 *
					 * @description
					 * Preprocess a given value and convert it into a Moment instance appropriate for use in the
					 * am-time-ago directive and the filters. The behavior of this function can be overriden by
					 * setting `angularMomentConfig.preprocess`.
					 *
					 * @param {*} value The value to be preprocessed
					 * @return {Moment} A `moment` object
					 */
					this.preprocessDate = function (value) {
						// Configure the default timezone if needed
						if (defaultTimezone !== angularMomentConfig.timezone) {
							this.changeTimezone(angularMomentConfig.timezone);
						}
	
						if (angularMomentConfig.preprocess) {
							return angularMomentConfig.preprocess(value);
						}
	
						if (!isNaN(parseFloat(value)) && isFinite(value)) {
							// Milliseconds since the epoch
							return moment(parseInt(value, 10));
						}
	
						// else just returns the value as-is.
						return moment(value);
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amParse
			 * @module angularMoment
			 */
				.filter('amParse', ['moment', function (moment) {
					return function (value, format) {
						return moment(value, format);
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amFromUnix
			 * @module angularMoment
			 */
				.filter('amFromUnix', ['moment', function (moment) {
					return function (value) {
						return moment.unix(value);
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amUtc
			 * @module angularMoment
			 */
				.filter('amUtc', ['moment', function (moment) {
					return function (value) {
						return moment.utc(value);
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amUtcOffset
			 * @module angularMoment
			 *
			 * @description
			 * Adds a UTC offset to the given timezone object. The offset can be a number of minutes, or a string such as
			 * '+0300', '-0300' or 'Z'.
			 */
				.filter('amUtcOffset', ['amMoment', function (amMoment) {
					function amUtcOffset(value, offset) {
						return amMoment.preprocessDate(value).utcOffset(offset);
					}
	
					return amUtcOffset;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amLocal
			 * @module angularMoment
			 */
				.filter('amLocal', ['moment', function (moment) {
					return function (value) {
						return moment.isMoment(value) ? value.local() : null;
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amTimezone
			 * @module angularMoment
			 *
			 * @description
			 * Apply a timezone onto a given moment object, e.g. 'America/Phoenix').
			 *
			 * You need to include moment-timezone.js for timezone support.
			 */
				.filter('amTimezone', ['amMoment', 'angularMomentConfig', '$log', function (amMoment, angularMomentConfig, $log) {
					function amTimezone(value, timezone) {
						var aMoment = amMoment.preprocessDate(value);
	
						if (!timezone) {
							return aMoment;
						}
	
						if (aMoment.tz) {
							return aMoment.tz(timezone);
						} else {
							$log.warn('angular-moment: named timezone specified but moment.tz() is undefined. Did you forget to include moment-timezone.js ?');
							return aMoment;
						}
					}
	
					return amTimezone;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amCalendar
			 * @module angularMoment
			 */
				.filter('amCalendar', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amCalendarFilter(value, referenceTime, formats) {
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						var date = amMoment.preprocessDate(value);
						return date.isValid() ? date.calendar(referenceTime, formats) : '';
					}
	
					// Since AngularJS 1.3, filters have to explicitly define being stateful
					// (this is no longer the default).
					amCalendarFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amCalendarFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amDifference
			 * @module angularMoment
			 */
				.filter('amDifference', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amDifferenceFilter(value, otherValue, unit, usePrecision) {
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						var date = amMoment.preprocessDate(value);
						var date2 = !isUndefinedOrNull(otherValue) ? amMoment.preprocessDate(otherValue) : moment();
	
						if (!date.isValid() || !date2.isValid()) {
							return '';
						}
	
						return date.diff(date2, unit, usePrecision);
					}
	
					amDifferenceFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amDifferenceFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amDateFormat
			 * @module angularMoment
			 * @function
			 */
				.filter('amDateFormat', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amDateFormatFilter(value, format) {
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						var date = amMoment.preprocessDate(value);
						if (!date.isValid()) {
							return '';
						}
	
						return date.format(format);
					}
	
					amDateFormatFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amDateFormatFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amDurationFormat
			 * @module angularMoment
			 * @function
			 */
				.filter('amDurationFormat', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amDurationFormatFilter(value, format, suffix) {
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment.duration(value, format).humanize(suffix);
					}
	
					amDurationFormatFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amDurationFormatFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amTimeAgo
			 * @module angularMoment
			 * @function
			 */
				.filter('amTimeAgo', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amTimeAgoFilter(value, suffix, from) {
						var date, dateFrom;
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						value = amMoment.preprocessDate(value);
						date = moment(value);
						if (!date.isValid()) {
							return '';
						}
	
						dateFrom = moment(from);
						if (!isUndefinedOrNull(from) && dateFrom.isValid()) {
							return date.from(dateFrom, suffix);
						}
	
						return date.fromNow(suffix);
					}
	
					amTimeAgoFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amTimeAgoFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amSubtract
			 * @module angularMoment
			 * @function
			 */
				.filter('amSubtract', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amSubtractFilter(value, amount, type) {
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment(value).subtract(parseInt(amount, 10), type);
					}
	
					amSubtractFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amSubtractFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amAdd
			 * @module angularMoment
			 * @function
			 */
				.filter('amAdd', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amAddFilter(value, amount, type) {
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment(value).add(parseInt(amount, 10), type);
					}
	
					amAddFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amAddFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amStartOf
			 * @module angularMoment
			 * @function
			 */
				.filter('amStartOf', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amStartOfFilter(value, type) {
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment(value).startOf(type);
					}
	
					amStartOfFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amStartOfFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amEndOf
			 * @module angularMoment
			 * @function
			 */
				.filter('amEndOf', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amEndOfFilter(value, type) {
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment(value).endOf(type);
					}
	
					amEndOfFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amEndOfFilter;
	 			}]);
	
			return 'angularMoment';
		}
	
		var isElectron = window && window.process && window.process.type;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(136), __webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (angularMoment), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module && module.exports && (typeof require === 'function') && !isElectron) {
			module.exports = angularMoment(require('angular'), require('moment'));
		} else {
			angularMoment(angular, (typeof global !== 'undefined' ? global : window).moment);
		}
	})();


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.18.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(20)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var string, match, dayFormat,
	        dateFormat, timeFormat, tzFormat;
	    var timezones = {
	        ' GMT': ' +0000',
	        ' EDT': ' -0400',
	        ' EST': ' -0500',
	        ' CDT': ' -0500',
	        ' CST': ' -0600',
	        ' MDT': ' -0600',
	        ' MST': ' -0700',
	        ' PDT': ' -0700',
	        ' PST': ' -0800'
	    };
	    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
	    var timezone, timezoneIndex;
	
	    string = config._i
	        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
	        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
	        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
	    match = basicRfcRegex.exec(string);
	
	    if (match) {
	        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
	        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
	        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');
	
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        if (match[1]) { // day of week given
	            var momentDate = new Date(match[2]);
	            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];
	
	            if (match[1].substr(0,3) !== momentDay) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return;
	            }
	        }
	
	        switch (match[5].length) {
	            case 2: // military
	                if (timezoneIndex === 0) {
	                    timezone = ' +0000';
	                } else {
	                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
	                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
	                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
	                }
	                break;
	            case 4: // Zone
	                timezone = timezones[match[5]];
	                break;
	            default: // UT or +/-9999
	                timezone = timezones[' GMT'];
	        }
	        match[5] = timezone;
	        config._i = match.splice(1).join('');
	        tzFormat = ' ZZ';
	        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
	        configFromStringAndFormat(config);
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString() {
	    if (!this.isValid()) {
	        return null;
	    }
	    var m = this.clone().utc();
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        return this.toDate().toISOString();
	    }
	    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.18.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)(module)))

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 21,
		"./af.js": 21,
		"./ar": 22,
		"./ar-dz": 23,
		"./ar-dz.js": 23,
		"./ar-kw": 24,
		"./ar-kw.js": 24,
		"./ar-ly": 25,
		"./ar-ly.js": 25,
		"./ar-ma": 26,
		"./ar-ma.js": 26,
		"./ar-sa": 27,
		"./ar-sa.js": 27,
		"./ar-tn": 28,
		"./ar-tn.js": 28,
		"./ar.js": 22,
		"./az": 29,
		"./az.js": 29,
		"./be": 30,
		"./be.js": 30,
		"./bg": 31,
		"./bg.js": 31,
		"./bn": 32,
		"./bn.js": 32,
		"./bo": 33,
		"./bo.js": 33,
		"./br": 34,
		"./br.js": 34,
		"./bs": 35,
		"./bs.js": 35,
		"./ca": 36,
		"./ca.js": 36,
		"./cs": 37,
		"./cs.js": 37,
		"./cv": 38,
		"./cv.js": 38,
		"./cy": 39,
		"./cy.js": 39,
		"./da": 40,
		"./da.js": 40,
		"./de": 41,
		"./de-at": 42,
		"./de-at.js": 42,
		"./de-ch": 43,
		"./de-ch.js": 43,
		"./de.js": 41,
		"./dv": 44,
		"./dv.js": 44,
		"./el": 45,
		"./el.js": 45,
		"./en-au": 46,
		"./en-au.js": 46,
		"./en-ca": 47,
		"./en-ca.js": 47,
		"./en-gb": 48,
		"./en-gb.js": 48,
		"./en-ie": 49,
		"./en-ie.js": 49,
		"./en-nz": 50,
		"./en-nz.js": 50,
		"./eo": 51,
		"./eo.js": 51,
		"./es": 52,
		"./es-do": 53,
		"./es-do.js": 53,
		"./es.js": 52,
		"./et": 54,
		"./et.js": 54,
		"./eu": 55,
		"./eu.js": 55,
		"./fa": 56,
		"./fa.js": 56,
		"./fi": 57,
		"./fi.js": 57,
		"./fo": 58,
		"./fo.js": 58,
		"./fr": 59,
		"./fr-ca": 60,
		"./fr-ca.js": 60,
		"./fr-ch": 61,
		"./fr-ch.js": 61,
		"./fr.js": 59,
		"./fy": 62,
		"./fy.js": 62,
		"./gd": 63,
		"./gd.js": 63,
		"./gl": 64,
		"./gl.js": 64,
		"./gom-latn": 65,
		"./gom-latn.js": 65,
		"./he": 66,
		"./he.js": 66,
		"./hi": 67,
		"./hi.js": 67,
		"./hr": 68,
		"./hr.js": 68,
		"./hu": 69,
		"./hu.js": 69,
		"./hy-am": 70,
		"./hy-am.js": 70,
		"./id": 71,
		"./id.js": 71,
		"./is": 72,
		"./is.js": 72,
		"./it": 73,
		"./it.js": 73,
		"./ja": 74,
		"./ja.js": 74,
		"./jv": 75,
		"./jv.js": 75,
		"./ka": 76,
		"./ka.js": 76,
		"./kk": 77,
		"./kk.js": 77,
		"./km": 78,
		"./km.js": 78,
		"./kn": 79,
		"./kn.js": 79,
		"./ko": 80,
		"./ko.js": 80,
		"./ky": 81,
		"./ky.js": 81,
		"./lb": 82,
		"./lb.js": 82,
		"./lo": 83,
		"./lo.js": 83,
		"./lt": 84,
		"./lt.js": 84,
		"./lv": 85,
		"./lv.js": 85,
		"./me": 86,
		"./me.js": 86,
		"./mi": 87,
		"./mi.js": 87,
		"./mk": 88,
		"./mk.js": 88,
		"./ml": 89,
		"./ml.js": 89,
		"./mr": 90,
		"./mr.js": 90,
		"./ms": 91,
		"./ms-my": 92,
		"./ms-my.js": 92,
		"./ms.js": 91,
		"./my": 93,
		"./my.js": 93,
		"./nb": 94,
		"./nb.js": 94,
		"./ne": 95,
		"./ne.js": 95,
		"./nl": 96,
		"./nl-be": 97,
		"./nl-be.js": 97,
		"./nl.js": 96,
		"./nn": 98,
		"./nn.js": 98,
		"./pa-in": 99,
		"./pa-in.js": 99,
		"./pl": 100,
		"./pl.js": 100,
		"./pt": 101,
		"./pt-br": 102,
		"./pt-br.js": 102,
		"./pt.js": 101,
		"./ro": 103,
		"./ro.js": 103,
		"./ru": 104,
		"./ru.js": 104,
		"./sd": 105,
		"./sd.js": 105,
		"./se": 106,
		"./se.js": 106,
		"./si": 107,
		"./si.js": 107,
		"./sk": 108,
		"./sk.js": 108,
		"./sl": 109,
		"./sl.js": 109,
		"./sq": 110,
		"./sq.js": 110,
		"./sr": 111,
		"./sr-cyrl": 112,
		"./sr-cyrl.js": 112,
		"./sr.js": 111,
		"./ss": 113,
		"./ss.js": 113,
		"./sv": 114,
		"./sv.js": 114,
		"./sw": 115,
		"./sw.js": 115,
		"./ta": 116,
		"./ta.js": 116,
		"./te": 117,
		"./te.js": 117,
		"./tet": 118,
		"./tet.js": 118,
		"./th": 119,
		"./th.js": 119,
		"./tl-ph": 120,
		"./tl-ph.js": 120,
		"./tlh": 121,
		"./tlh.js": 121,
		"./tr": 122,
		"./tr.js": 122,
		"./tzl": 123,
		"./tzl.js": 123,
		"./tzm": 124,
		"./tzm-latn": 125,
		"./tzm-latn.js": 125,
		"./tzm.js": 124,
		"./uk": 126,
		"./uk.js": 126,
		"./ur": 127,
		"./ur.js": 127,
		"./uz": 128,
		"./uz-latn": 129,
		"./uz-latn.js": 129,
		"./uz.js": 128,
		"./vi": 130,
		"./vi.js": 130,
		"./x-pseudo": 131,
		"./x-pseudo.js": 131,
		"./yo": 132,
		"./yo.js": 132,
		"./zh-cn": 133,
		"./zh-cn.js": 133,
		"./zh-hk": 134,
		"./zh-hk.js": 134,
		"./zh-tw": 135,
		"./zh-tw.js": 135
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 20;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : '[el] D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH.mm',
	        LLLL : 'dddd, D. MMMM YYYY HH.mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(19)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(137);
	module.exports = angular;


/***/ },
/* 137 */
/***/ function(module, exports) {

	/**
	 * @license AngularJS v1.5.6
	 * (c) 2010-2016 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window) {'use strict';
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * Angular. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace') . Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	  return function() {
	    var SKIP_INDEXES = 2;
	
	    var templateArgs = arguments,
	      code = templateArgs[0],
	      message = '[' + (module ? module + ':' : '') + code + '] ',
	      template = templateArgs[1],
	      paramPrefix, i;
	
	    message += template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1),
	        shiftedIndex = index + SKIP_INDEXES;
	
	      if (shiftedIndex < templateArgs.length) {
	        return toDebugString(templateArgs[shiftedIndex]);
	      }
	
	      return match;
	    });
	
	    message += '\nhttp://errors.angularjs.org/1.5.6/' +
	      (module ? module + '/' : '') + code;
	
	    for (i = SKIP_INDEXES, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	      message += paramPrefix + 'p' + (i - SKIP_INDEXES) + '=' +
	        encodeURIComponent(toDebugString(templateArgs[i]));
	    }
	
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell jshint what variables are being exported */
	/* global angular: true,
	  msie: true,
	  jqLite: true,
	  jQuery: true,
	  slice: true,
	  splice: true,
	  push: true,
	  toString: true,
	  ngMinErr: true,
	  angularModule: true,
	  uid: true,
	  REGEX_STRING_REGEXP: true,
	  VALIDITY_STATE_PROPERTY: true,
	
	  lowercase: true,
	  uppercase: true,
	  manualLowercase: true,
	  manualUppercase: true,
	  nodeName_: true,
	  isArrayLike: true,
	  forEach: true,
	  forEachSorted: true,
	  reverseParams: true,
	  nextUid: true,
	  setHashKey: true,
	  extend: true,
	  toInt: true,
	  inherit: true,
	  merge: true,
	  noop: true,
	  identity: true,
	  valueFn: true,
	  isUndefined: true,
	  isDefined: true,
	  isObject: true,
	  isBlankObject: true,
	  isString: true,
	  isNumber: true,
	  isDate: true,
	  isArray: true,
	  isFunction: true,
	  isRegExp: true,
	  isWindow: true,
	  isScope: true,
	  isFile: true,
	  isFormData: true,
	  isBlob: true,
	  isBoolean: true,
	  isPromiseLike: true,
	  trim: true,
	  escapeForRegexp: true,
	  isElement: true,
	  makeMap: true,
	  includes: true,
	  arrayRemove: true,
	  copy: true,
	  shallowCopy: true,
	  equals: true,
	  csp: true,
	  jq: true,
	  concat: true,
	  sliceArgs: true,
	  bind: true,
	  toJsonReplacer: true,
	  toJson: true,
	  fromJson: true,
	  convertTimezoneToLocal: true,
	  timezoneToOffset: true,
	  startingTag: true,
	  tryDecodeURIComponent: true,
	  parseKeyValue: true,
	  toKeyValue: true,
	  encodeUriSegment: true,
	  encodeUriQuery: true,
	  angularInit: true,
	  bootstrap: true,
	  getTestability: true,
	  snake_case: true,
	  bindJQuery: true,
	  assertArg: true,
	  assertArgFn: true,
	  assertNotHasOwnProperty: true,
	  getter: true,
	  getBlockNodes: true,
	  hasOwnProperty: true,
	  createMap: true,
	
	  NODE_TYPE_ELEMENT: true,
	  NODE_TYPE_ATTRIBUTE: true,
	  NODE_TYPE_TEXT: true,
	  NODE_TYPE_COMMENT: true,
	  NODE_TYPE_DOCUMENT: true,
	  NODE_TYPE_DOCUMENT_FRAGMENT: true,
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @installation
	 * @description
	 *
	 * # ng (core module)
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 * <div doc-module-components="ng"></div>
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var manualLowercase = function(s) {
	  /* jshint bitwise: false */
	  return isString(s)
	      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
	      : s;
	};
	var manualUppercase = function(s) {
	  /* jshint bitwise: false */
	  return isString(s)
	      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
	      : s;
	};
	
	
	// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
	// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
	// with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
	if ('i' !== 'I'.toLowerCase()) {
	  lowercase = manualLowercase;
	  uppercase = manualUppercase;
	}
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = window.document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	
	  // `null`, `undefined` and `window` are not array-like
	  if (obj == null || isWindow(obj)) return false;
	
	  // arrays, strings and jQuery/jqLite objects are array like
	  // * jqLite is either the jQuery or jqLite constructor function
	  // * we have to check the existence of jqLite first as this method is called
	  //   via the forEach method when constructing the jqLite object in the first place
	  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = "length" in Object(obj) && obj.length;
	
	  // NodeList objects (with `item` method) and
	  // other objects with suitable length characteristics are array-like
	  return isNumber(length) &&
	    (length >= 0 && ((length - 1) in obj || obj instanceof Array) || typeof obj.item == 'function');
	
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        // Need to check if hasOwnProperty exists,
	        // as on IE8 the result of querySelectorAll is an object without a hasOwnProperty function
	        if (key != 'prototype' && key != 'length' && key != 'name' && (!obj.hasOwnProperty || obj.hasOwnProperty(key))) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else if (isBlankObject(obj)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in obj) {
	        iterator.call(context, obj[key], key, obj);
	      }
	    } else if (typeof obj.hasOwnProperty === 'function') {
	      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else {
	      // Slow path for objects which do not have a method `hasOwnProperty`
	      for (key in obj) {
	        if (hasOwnProperty.call(obj, key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = Object.keys(obj).sort();
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) {iteratorFn(key, value);};
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	
	function baseExtend(dst, objs, deep) {
	  var h = dst.$$hashKey;
	
	  for (var i = 0, ii = objs.length; i < ii; ++i) {
	    var obj = objs[i];
	    if (!isObject(obj) && !isFunction(obj)) continue;
	    var keys = Object.keys(obj);
	    for (var j = 0, jj = keys.length; j < jj; j++) {
	      var key = keys[j];
	      var src = obj[key];
	
	      if (deep && isObject(src)) {
	        if (isDate(src)) {
	          dst[key] = new Date(src.valueOf());
	        } else if (isRegExp(src)) {
	          dst[key] = new RegExp(src);
	        } else if (src.nodeName) {
	          dst[key] = src.cloneNode(true);
	        } else if (isElement(src)) {
	          dst[key] = src.clone();
	        } else {
	          if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	          baseExtend(dst[key], [src], true);
	        }
	      } else {
	        dst[key] = src;
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), false);
	}
	
	
	/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/
	function merge(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), true);
	}
	
	
	
	function toInt(str) {
	  return parseInt(str, 10);
	}
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function valueRef() {return value;};}
	
	function hasCustomToString(obj) {
	  return isFunction(obj.toString) && obj.toString !== toString;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */
	function isBlankObject(value) {
	  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	var isArray = Array.isArray;
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array\]$/;
	function isTypedArray(value) {
	  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	function isArrayBuffer(obj) {
	  return toString.call(obj) === '[object ArrayBuffer]';
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\$1').
	           replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // We are a direct element.
	    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[items[i]] = true;
	  }
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) != -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	  return index;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array.
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to 'destination' an exception will be thrown.
	 *
	 * @param {*} source The source that will be used to make a copy.
	 *                   Can be any type, including primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If
	 *     provided, must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	 <example module="copyExample">
	 <file name="index.html">
	 <div ng-controller="ExampleController">
	 <form novalidate class="simple-form">
	 Name: <input type="text" ng-model="user.name" /><br />
	 E-mail: <input type="email" ng-model="user.email" /><br />
	 Gender: <input type="radio" ng-model="user.gender" value="male" />male
	 <input type="radio" ng-model="user.gender" value="female" />female<br />
	 <button ng-click="reset()">RESET</button>
	 <button ng-click="update(user)">SAVE</button>
	 </form>
	 <pre>form = {{user | json}}</pre>
	 <pre>master = {{master | json}}</pre>
	 </div>
	
	 <script>
	  angular.module('copyExample', [])
	    .controller('ExampleController', ['$scope', function($scope) {
	      $scope.master= {};
	
	      $scope.update = function(user) {
	        // Example with 1 argument
	        $scope.master= angular.copy(user);
	      };
	
	      $scope.reset = function() {
	        // Example with 2 arguments
	        angular.copy($scope.master, $scope.user);
	      };
	
	      $scope.reset();
	    }]);
	 </script>
	 </file>
	 </example>
	 */
	function copy(source, destination) {
	  var stackSource = [];
	  var stackDest = [];
	
	  if (destination) {
	    if (isTypedArray(destination) || isArrayBuffer(destination)) {
	      throw ngMinErr('cpta', "Can't copy! TypedArray destination cannot be mutated.");
	    }
	    if (source === destination) {
	      throw ngMinErr('cpi', "Can't copy! Source and destination are identical.");
	    }
	
	    // Empty the destination object
	    if (isArray(destination)) {
	      destination.length = 0;
	    } else {
	      forEach(destination, function(value, key) {
	        if (key !== '$$hashKey') {
	          delete destination[key];
	        }
	      });
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	    return copyRecurse(source, destination);
	  }
	
	  return copyElement(source);
	
	  function copyRecurse(source, destination) {
	    var h = destination.$$hashKey;
	    var key;
	    if (isArray(source)) {
	      for (var i = 0, ii = source.length; i < ii; i++) {
	        destination.push(copyElement(source[i]));
	      }
	    } else if (isBlankObject(source)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in source) {
	        destination[key] = copyElement(source[key]);
	      }
	    } else if (source && typeof source.hasOwnProperty === 'function') {
	      // Slow path, which must rely on hasOwnProperty
	      for (key in source) {
	        if (source.hasOwnProperty(key)) {
	          destination[key] = copyElement(source[key]);
	        }
	      }
	    } else {
	      // Slowest path --- hasOwnProperty can't be called as a method
	      for (key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          destination[key] = copyElement(source[key]);
	        }
	      }
	    }
	    setHashKey(destination, h);
	    return destination;
	  }
	
	  function copyElement(source) {
	    // Simple values
	    if (!isObject(source)) {
	      return source;
	    }
	
	    // Already copied values
	    var index = stackSource.indexOf(source);
	    if (index !== -1) {
	      return stackDest[index];
	    }
	
	    if (isWindow(source) || isScope(source)) {
	      throw ngMinErr('cpws',
	        "Can't copy! Making copies of Window or Scope instances is not supported.");
	    }
	
	    var needsRecurse = false;
	    var destination = copyType(source);
	
	    if (destination === undefined) {
	      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
	      needsRecurse = true;
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	
	    return needsRecurse
	      ? copyRecurse(source, destination)
	      : destination;
	  }
	
	  function copyType(source) {
	    switch (toString.call(source)) {
	      case '[object Int8Array]':
	      case '[object Int16Array]':
	      case '[object Int32Array]':
	      case '[object Float32Array]':
	      case '[object Float64Array]':
	      case '[object Uint8Array]':
	      case '[object Uint8ClampedArray]':
	      case '[object Uint16Array]':
	      case '[object Uint32Array]':
	        return new source.constructor(copyElement(source.buffer));
	
	      case '[object ArrayBuffer]':
	        //Support: IE10
	        if (!source.slice) {
	          var copied = new ArrayBuffer(source.byteLength);
	          new Uint8Array(copied).set(new Uint8Array(source));
	          return copied;
	        }
	        return source.slice(0);
	
	      case '[object Boolean]':
	      case '[object Number]':
	      case '[object String]':
	      case '[object Date]':
	        return new source.constructor(source.valueOf());
	
	      case '[object RegExp]':
	        var re = new RegExp(source.source, source.toString().match(/[^\/]*$/)[0]);
	        re.lastIndex = source.lastIndex;
	        return re;
	
	      case '[object Blob]':
	        return new source.constructor([source], {type: source.type});
	    }
	
	    if (isFunction(source.cloneNode)) {
	      return source.cloneNode(true);
	    }
	  }
	}
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 *
	 * @example
	   <example module="equalsExample" name="equalsExample">
	     <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate>
	          <h3>User 1</h3>
	          Name: <input type="text" ng-model="user1.name">
	          Age: <input type="number" ng-model="user1.age">
	
	          <h3>User 2</h3>
	          Name: <input type="text" ng-model="user2.name">
	          Age: <input type="number" ng-model="user2.age">
	
	          <div>
	            <br/>
	            <input type="button" value="Compare" ng-click="compare()">
	          </div>
	          User 1: <pre>{{user1 | json}}</pre>
	          User 2: <pre>{{user2 | json}}</pre>
	          Equal: <pre>{{result}}</pre>
	        </form>
	      </div>
	    </file>
	    <file name="script.js">
	        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.result;
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	    </file>
	  </example>
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 == t2 && t1 == 'object') {
	    if (isArray(o1)) {
	      if (!isArray(o2)) return false;
	      if ((length = o1.length) == o2.length) {
	        for (key = 0; key < length; key++) {
	          if (!equals(o1[key], o2[key])) return false;
	        }
	        return true;
	      }
	    } else if (isDate(o1)) {
	      if (!isDate(o2)) return false;
	      return equals(o1.getTime(), o2.getTime());
	    } else if (isRegExp(o1)) {
	      if (!isRegExp(o2)) return false;
	      return o1.toString() == o2.toString();
	    } else {
	      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	      keySet = createMap();
	      for (key in o1) {
	        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	        if (!equals(o1[key], o2[key])) return false;
	        keySet[key] = true;
	      }
	      for (key in o2) {
	        if (!(key in keySet) &&
	            key.charAt(0) !== '$' &&
	            isDefined(o2[key]) &&
	            !isFunction(o2[key])) return false;
	      }
	      return true;
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (!isDefined(csp.rules)) {
	
	
	    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
	                    window.document.querySelector('[data-ng-csp]'));
	
	    if (ngCspElement) {
	      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	                    ngCspElement.getAttribute('data-ng-csp');
	      csp.rules = {
	        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	      };
	    } else {
	      csp.rules = {
	        noUnsafeEval: noUnsafeEval(),
	        noInlineStyle: false
	      };
	    }
	  }
	
	  return csp.rules;
	
	  function noUnsafeEval() {
	    try {
	      /* jshint -W031, -W054 */
	      new Function('');
	      /* jshint +W031, +W054 */
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since angular looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */
	var jq = function() {
	  if (isDefined(jq.name_)) return jq.name_;
	  var el;
	  var i, ii = ngAttrPrefixes.length, prefix, name;
	  for (i = 0; i < ii; ++i) {
	    prefix = ngAttrPrefixes[i];
	    if (el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]')) {
	      name = el.getAttribute(prefix + 'jq');
	      break;
	    }
	  }
	
	  return (jq.name_ = name);
	};
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/* jshint -W101 */
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	/* jshint +W101 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  window.document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since angular uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 * @knownIssue
	 *
	 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	 * `Date.prototype.toJSON` method as follows:
	 *
	 * ```
	 * var _DatetoJSON = Date.prototype.toJSON;
	 * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	 * ```
	 *
	 * See https://github.com/angular/angular.js/pull/14221 for more information.
	 */
	function toJson(obj, pretty) {
	  if (isUndefined(obj)) return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	var ALL_COLONS = /:/g;
	function timezoneToOffset(timezone, fallback) {
	  // IE/Edge do not "understand" colon (`:`) in timezone
	  timezone = timezone.replace(ALL_COLONS, '');
	  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	  return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	
	
	function addDateMinutes(date, minutes) {
	  date = new Date(date.getTime());
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	}
	
	
	function convertTimezoneToLocal(date, timezone, reverse) {
	  reverse = reverse ? -1 : 1;
	  var dateTimezoneOffset = date.getTimezoneOffset();
	  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone();
	  try {
	    // turns out IE does not let you set .html() on elements which
	    // are not allowed to have children. So we just ignore it.
	    element.empty();
	  } catch (e) {}
	  var elemHtml = jqLite('<div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w\-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component.
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {};
	  forEach((keyValue || "").split('&'), function(keyValue) {
	    var splitPoint, key, val;
	    if (keyValue) {
	      key = keyValue = keyValue.replace(/\+/g,'%20');
	      splitPoint = keyValue.indexOf('=');
	      if (splitPoint !== -1) {
	        key = keyValue.substring(0, splitPoint);
	        val = keyValue.substring(splitPoint + 1);
	      }
	      key = tryDecodeURIComponent(key);
	      if (isDefined(key)) {
	        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query       = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.getAttribute(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * There are a few things to keep in mind when using `ngApp`:
	 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 *   found in the document will be used to define the root element to auto-bootstrap as an
	 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	 *   {@link angular.bootstrap} instead.
	 * - AngularJS applications cannot be nested within each other.
	 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	 *   {@link ngRoute.ngView `ngView`}.
	 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 *   causing animations to stop working and making the injector inaccessible from outside the app.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = "World";
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element.
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    config.strictDi = getNgAttribute(appElement, "strict-di") !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up angular application.
	 *
	 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	 *
	 * Angular will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of Angular try to work on the DOM.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 * causing animations to stop working and making the injector inaccessible from outside the app.
	 * </div>
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
	      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
	      throw ngMinErr(
	          'btstrpd',
	          "App already bootstrapped with this element '{0}'",
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of Angular on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  var jqName = jq();
	  jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
	           !jqName             ? undefined     :   // use jqLite
	                                 window[jqName];   // use jQuery specified by `ngJq`
	
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // Angular 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // Angular 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: JQLitePrototype.controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	
	    // All nodes removed from the DOM via various jQuery APIs like .remove()
	    // are passed through jQuery.cleanData. Monkey-patch this method to fire
	    // the $destroy event on all removed nodes.
	    originalCleanData = jQuery.cleanData;
	    jQuery.cleanData = function(elems) {
	      var events;
	      for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	        events = jQuery._data(elem, "events");
	        if (events && events.$destroy) {
	          jQuery(elem).triggerHandler('$destroy');
	        }
	      }
	      originalCleanData(elems);
	    };
	  } else {
	    jqLite = JQLite;
	  }
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', "Argument '{0}' is {1}", (name || '?'), (reason || "required"));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', "hasOwnProperty is not a valid {0} name", context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): update `nodes` instead of creating a new object?
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes;
	
	  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
	    if (blockNodes || nodes[i] !== node) {
	      if (!blockNodes) {
	        blockNodes = jqLite(slice.call(nodes, 0, i));
	      }
	      blockNodes.push(node);
	    }
	  }
	
	  return blockNodes || nodes;
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring angular {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving Angular
	     * modules.
	     * All modules (angular core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', "Module '{0}' is not available! You either misspelled " +
	             "the module name or forgot to load it. If registering a module ensure that you " +
	             "specify the dependencies as the second argument.", name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	           /**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */
	          decorator: invokeLaterAndSetModuleName('$provide', 'decorator'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid angular expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#component
	           * @module ng
	           * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
	           * @param {Object} options Component definition object (a simplified
	           *    {@link ng.$compile#directive-definition-object directive definition object})
	           *
	           * @description
	           * See {@link ng.$compileProvider#component $compileProvider.component()}.
	           */
	          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to register work which needs to be performed on module loading.
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */
	        function invokeLaterAndSetModuleName(provider, method) {
	          return function(recipeName, factoryFunction) {
	            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	            invokeQueue.push([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global: toDebugString: true */
	
	function serializeObject(obj) {
	  var seen = [];
	
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '...';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (isUndefined(obj)) {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  inputDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  styleDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DateProvider,
	  $DocumentProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $IntervalProvider,
	  $$HashMapProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $LocationProvider,
	  $LogProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  full: '1.5.6',    // all of these placeholder strings will be replaced by grunt's
	  major: 1,    // package task
	  minor: 5,
	  dot: 6,
	  codeName: 'arrow-stringification'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'merge': merge,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'lowercase': lowercase,
	    'uppercase': uppercase,
	    'callbacks': {counter: 0},
	    'getTestability': getTestability,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    'reloadWithDebugInfo': reloadWithDebugInfo
	  });
	
	  angularModule = setupModuleLoader(window);
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            style: styleDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $animateCss: $CoreAnimateCssProvider,
	        $$animateJs: $$CoreAnimateJsProvider,
	        $$animateQueue: $$CoreAnimateQueueProvider,
	        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
	        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $$forceReflow: $$ForceReflowProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $http: $HttpProvider,
	        $httpParamSerializer: $HttpParamSerializerProvider,
	        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	        $httpBackend: $HttpBackendProvider,
	        $xhrFactory: $xhrFactoryProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$jqLite: $$jqLiteProvider,
	        $$HashMap: $$HashMapProvider,
	        $$cookieReader: $$CookieReaderProvider
	      });
	    }
	  ]);
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global JQLitePrototype: true,
	  addEventListenerFn: true,
	  removeEventListenerFn: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true,
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to Angular's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * Angular to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in Angular are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## Angular's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/)
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/)
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/)
	 * - [`removeClass()`](http://api.jquery.com/removeClass/)
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	 * - [`unbind()`](http://api.jquery.com/unbind/) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * ## jQuery/jqLite Extras
	 * Angular also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	 * https://github.com/angular/angular.js/issues/14251 for more information.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1,
	    addEventListenerFn = function(element, type, fn) {
	      element.addEventListener(type, fn, false);
	    },
	    removeEventListenerFn = function(element, type, fn) {
	      element.removeEventListener(type, fn, false);
	    };
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	var MOZ_HACK_REGEXP = /^moz([A-Z])/;
	var MOUSE_EVENT_MAP= { mouseleave: "mouseout", mouseenter: "mouseover"};
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts snake_case to camelCase.
	 * Also there is special case for Moz prefix starting with upper case letter.
	 * @param name Name to normalize
	 */
	function camelCase(name) {
	  return name.
	    replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    }).
	    replace(MOZ_HACK_REGEXP, 'Moz$1');
	}
	
	var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:-]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
	
	var wrapMap = {
	  'option': [1, '<select multiple="multiple">', '</select>'],
	
	  'thead': [1, '<table>', '</table>'],
	  'col': [2, '<table><colgroup>', '</colgroup></table>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
	  '_default': [0, "", ""]
	};
	
	wrapMap.optgroup = wrapMap.option;
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteHasData(node) {
	  for (var key in jqCache[node.ng339]) {
	    return true;
	  }
	  return false;
	}
	
	function jqLiteCleanData(nodes) {
	  for (var i = 0, ii = nodes.length; i < ii; i++) {
	    jqLiteRemoveData(nodes[i]);
	  }
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = tmp || fragment.appendChild(context.createElement("div"));
	    tag = (TAG_NAME_REGEXP.exec(html) || ["", ""])[1].toLowerCase();
	    wrap = wrapMap[tag] || wrapMap._default;
	    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, "<$1></$2>") + wrap[2];
	
	    // Descend through wrappers to the right content
	    i = wrap[0];
	    while (i--) {
	      tmp = tmp.lastChild;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = "";
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = "";
	  fragment.innerHTML = ""; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || window.document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	function jqLiteWrapNode(node, wrapper) {
	  var parent = node.parentNode;
	
	  if (parent) {
	    parent.replaceChild(wrapper, node);
	  }
	
	  wrapper.appendChild(node);
	}
	
	
	// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains = window.Node.prototype.contains || function(arg) {
	  // jshint bitwise: false
	  return !!(this.compareDocumentPosition(arg) & 16);
	  // jshint bitwise: true
	};
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) != '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants) jqLiteRemoveData(element);
	
	  if (element.querySelectorAll) {
	    var descendants = element.querySelectorAll('*');
	    for (var i = 0, l = descendants.length; i < l; i++) {
	      jqLiteRemoveData(descendants[i]);
	    }
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        removeEventListenerFn(element, type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	
	    var removeHandler = function(type) {
	      var listenerFns = events[type];
	      if (isDefined(fn)) {
	        arrayRemove(listenerFns || [], fn);
	      }
	      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
	        removeEventListenerFn(element, type, handle);
	        delete events[type];
	      }
	    };
	
	    forEach(type.split(' '), function(type) {
	      removeHandler(type);
	      if (MOUSE_EVENT_MAP[type]) {
	        removeHandler(MOUSE_EVENT_MAP[type]);
	      }
	    });
	  }
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	      return;
	    }
	
	    if (expandoStore.handle) {
	      if (expandoStore.events.$destroy) {
	        expandoStore.handle({}, '$destroy');
	      }
	      jqLiteOff(element);
	    }
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[key] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[key];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          extend(data, key);
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((" " + (element.getAttribute('class') || '') + " ").replace(/[\n\t]/g, " ").
	      indexOf(" " + selector + " ") > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    forEach(cssClasses.split(' '), function(cssClass) {
	      element.setAttribute('class', trim(
	          (" " + (element.getAttribute('class') || '') + " ")
	          .replace(/[\n\t]/g, " ")
	          .replace(" " + trim(cssClass) + " ", " "))
	      );
	    });
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, " ");
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (existingClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        existingClasses += cssClass + ' ';
	      }
	    });
	
	    element.setAttribute('class', trim(existingClasses));
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType == NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if (isDefined(value = jqLite.data(element, names[i]))) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behavior
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: function(fn) {
	    var fired = false;
	
	    function trigger() {
	      if (fired) return;
	      fired = true;
	      fn();
	    }
	
	    // check if document is already loaded
	    if (window.document.readyState === 'complete') {
	      window.setTimeout(trigger);
	    } else {
	      this.on('DOMContentLoaded', trigger); // works for modern browsers and IE9
	      // we can not use jqLite since we are not done loading and jQuery could be loaded later.
	      // jshint -W064
	      JQLite(window).on('load', trigger); // fallback to window.onload for others
	      // jshint +W064
	    }
	  },
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(name) {
	  return ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData,
	  hasData: jqLiteHasData,
	  cleanData: jqLiteCleanData
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = camelCase(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT) {
	      return;
	    }
	    var lowercasedName = lowercase(name);
	    if (BOOLEAN_ATTR[lowercasedName]) {
	      if (isDefined(value)) {
	        if (!!value) {
	          element[name] = true;
	          element.setAttribute(name, lowercasedName);
	        } else {
	          element[name] = false;
	          element.removeAttribute(lowercasedName);
	        }
	      } else {
	        return (element[name] ||
	                 (element.attributes.getNamedItem(name) || noop).specified)
	               ? lowercasedName
	               : undefined;
	      }
	    } else if (isDefined(value)) {
	      element.setAttribute(name, value);
	    } else if (element.getAttribute) {
	      // the extra argument "2" is to get the right thing for a.href in IE, see jQuery code
	      // some elements (e.g. Document) don't have get attribute, so return undefined
	      var ret = element.getAttribute(name, 2);
	      // normalize non-existing attributes to undefined (as jQuery)
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result.length === 0 ? null : result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (isUndefined((fn.length == 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Some events have special handlers that wrap the real handler
	    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        handlerWrapper(element, event, eventFns[i]);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	function defaultHandlerWrapper(element, event, handler) {
	  handler.call(element, event);
	}
	
	function specialMouseHandlerWrapper(target, event, handler) {
	  // Refer to jQuery's implementation of mouseenter & mouseleave
	  // Read about mouseenter and mouseleave:
	  // http://www.quirksmode.org/js/events_mouse.html#link8
	  var related = event.relatedTarget;
	  // For mousenter/leave call the handler if related is outside the target.
	  // NB: No relatedTarget if the mouse left/entered the browser window
	  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
	    handler.call(target, event);
	  }
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        eventFns = events[type] = [];
	        eventFns.specialHandlerWrapper = specialHandlerWrapper;
	        if (type !== '$destroy' && !noEventListener) {
	          addEventListenerFn(element, type, handle);
	        }
	      }
	
	      eventFns.push(fn);
	    };
	
	    while (i--) {
	      type = types[i];
	      if (MOUSE_EVENT_MAP[type]) {
	        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
	        addHandler(type, undefined, true);
	      } else {
	        addHandler(type);
	      }
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        children.push(element);
	      }
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	    newElement = new JQLite(newElement);
	
	    for (var i = 0, ii = newElement.length; i < ii; i++) {
	      var node = newElement[i];
	      parent.insertBefore(node, index.nextSibling);
	      index = node;
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	
	  // bind legacy bind/unbind to on/off
	  JQLite.prototype.bind = JQLite.prototype.on;
	  JQLite.prototype.unbind = JQLite.prototype.off;
	});
	
	
	// Provider for private $$jqLite service
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType == 'function' || (objType == 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	/**
	 * HashMap which can use objects as keys
	 */
	function HashMap(array, isolatedUid) {
	  if (isolatedUid) {
	    var uid = 0;
	    this.nextUid = function() {
	      return ++uid;
	    };
	  }
	  forEach(array, this.put, this);
	}
	HashMap.prototype = {
	  /**
	   * Store key value pair
	   * @param key key to store can be any type
	   * @param value value to store can be any type
	   */
	  put: function(key, value) {
	    this[hashKey(key, this.nextUid)] = value;
	  },
	
	  /**
	   * @param key
	   * @returns {Object} the value for the key
	   */
	  get: function(key) {
	    return this[hashKey(key, this.nextUid)];
	  },
	
	  /**
	   * Remove the key/value pair
	   * @param key
	   */
	  remove: function(key) {
	    var value = this[key = hashKey(key, this.nextUid)];
	    delete this[key];
	    return value;
	  }
	};
	
	var $$HashMapProvider = [function() {
	  this.$get = [function() {
	    return HashMap;
	  }];
	}];
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running Angular app
	 * from outside Angular. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @installation
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var ARROW_ARG = /^([^\(]+?)=>/;
	var FN_ARGS = /^[^\(]*\(\s*([^\)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function stringifyFn(fn) {
	  // Support: Chrome 50-51 only
	  // Creating a new string by adding `' '` at the end, to hack around some bug in Chrome v50/51
	  // (See https://github.com/angular/angular.js/issues/14487.)
	  // TODO (gkalpak): Remove workaround when Chrome v52 is released
	  return Function.prototype.toString.call(fn) + ' ';
	}
	
	function extractArgs(fn) {
	  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
	      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
	  return args;
	}
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var args = extractArgs(fn);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        argDecl = extractArgs(fn);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * # Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ## Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ## `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ## Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * # Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * # The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * # The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	
	
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An Angular **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	 *      will be able to modify or replace the implementation of another service.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The return value of the decorator function may be the original service, or a new service
	 * that replaces (or wraps and delegates to) the original service.
	 *
	 * You can find out more about using decorators in the {@link guide/decorators} guide.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    provided and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new HashMap([], true),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', "Unknown provider: {0}", path.join(' <- '));
	          })),
	      instanceCache = {},
	      protoInstanceInjector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(
	                provider.$get, provider, undefined, serviceName);
	          }),
	      instanceInjector = protoInstanceInjector;
	
	  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
	  var runBlocks = loadModules(modulesToLoad);
	  instanceInjector = protoInstanceInjector.get('$injector');
	  instanceInjector.strictDi = strictDi;
	  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', "Provider '{0}' must define $get factory method.", name);
	    }
	    return providerCache[name + providerSuffix] = provider_;
	  }
	
	  function enforceReturnValue(name, factory) {
	    return function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', "Provider '{0}' must return a value from $get factory method.", name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.put(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) == -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          /* jshint -W022 */
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', "Failed to instantiate module {0} due to:\n{1}",
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          return cache[serviceName] = factory(serviceName, caller);
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	
	    function injectionArgs(fn, locals, serviceName) {
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
	
	      for (var i = 0, length = $inject.length; i < length; i++) {
	        var key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
	                                                         getService(key, serviceName));
	      }
	      return args;
	    }
	
	    function isClass(func) {
	      // IE 9-11 do not support classes and IE9 leaks with the code below.
	      if (msie <= 11) {
	        return false;
	      }
	      // Workaround for MS Edge.
	      // Check https://connect.microsoft.com/IE/Feedback/Details/2211653
	      return typeof func === 'function'
	        && /^(?:class\s|constructor\()/.test(stringifyFn(func));
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = injectionArgs(fn, locals, serviceName);
	      if (isArray(fn)) {
	        fn = fn[fn.length - 1];
	      }
	
	      if (!isClass(fn)) {
	        // http://jsperf.com/angularjs-invoke-apply-vs-switch
	        // #5388
	        return fn.apply(self, args);
	      } else {
	        args.unshift(null);
	        return new (Function.prototype.bind.apply(fn, args))();
	      }
	    }
	
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
	      var args = injectionArgs(Type, locals, serviceName);
	      // Empty object at position 0 is ignored for invocation with `new`, but required.
	      args.unshift(null);
	      return new (Function.prototype.bind.apply(ctor, args))();
	    }
	
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function ($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function ($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll(hash) {
	      hash = isString(hash) ? hash : $location.hash();
	      var elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash == 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	var ELEMENT_NODE = 1;
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function extractElementNode(element) {
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function splitClasses(classes) {
	  if (isString(classes)) {
	    classes = classes.split(' ');
	  }
	
	  // Use createMap() to prevent class assumptions involving property names in
	  // Object.prototype
	  var obj = createMap();
	  forEach(classes, function(klass) {
	    // sometimes the split leaves empty string values
	    // incase extra spaces were applied to the options
	    if (klass.length) {
	      obj[klass] = true;
	    }
	  });
	  return obj;
	}
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options) {
	  return isObject(options)
	      ? options
	      : {};
	}
	
	var $$CoreAnimateJsProvider = function() {
	  this.$get = noop;
	};
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider = function() {
	  var postDigestQueue = new HashMap();
	  var postDigestElements = [];
	
	  this.$get = ['$$AnimateRunner', '$rootScope',
	       function($$AnimateRunner,   $rootScope) {
	    return {
	      enabled: noop,
	      on: noop,
	      off: noop,
	      pin: noop,
	
	      push: function(element, event, options, domOperation) {
	        domOperation        && domOperation();
	
	        options = options || {};
	        options.from        && element.css(options.from);
	        options.to          && element.css(options.to);
	
	        if (options.addClass || options.removeClass) {
	          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	        }
	
	        var runner = new $$AnimateRunner(); // jshint ignore:line
	
	        // since there are no animations to run the runner needs to be
	        // notified that the animation call is complete.
	        runner.complete();
	        return runner;
	      }
	    };
	
	
	    function updateData(data, classes, value) {
	      var changed = false;
	      if (classes) {
	        classes = isString(classes) ? classes.split(' ') :
	                  isArray(classes) ? classes : [];
	        forEach(classes, function(className) {
	          if (className) {
	            changed = true;
	            data[className] = value;
	          }
	        });
	      }
	      return changed;
	    }
	
	    function handleCSSClassChanges() {
	      forEach(postDigestElements, function(element) {
	        var data = postDigestQueue.get(element);
	        if (data) {
	          var existing = splitClasses(element.attr('class'));
	          var toAdd = '';
	          var toRemove = '';
	          forEach(data, function(status, className) {
	            var hasClass = !!existing[className];
	            if (status !== hasClass) {
	              if (status) {
	                toAdd += (toAdd.length ? ' ' : '') + className;
	              } else {
	                toRemove += (toRemove.length ? ' ' : '') + className;
	              }
	            }
	          });
	
	          forEach(element, function(elm) {
	            toAdd    && jqLiteAddClass(elm, toAdd);
	            toRemove && jqLiteRemoveClass(elm, toRemove);
	          });
	          postDigestQueue.remove(element);
	        }
	      });
	      postDigestElements.length = 0;
	    }
	
	
	    function addRemoveClassesPostDigest(element, add, remove) {
	      var data = postDigestQueue.get(element) || {};
	
	      var classesAdded = updateData(data, add, true);
	      var classesRemoved = updateData(data, remove, false);
	
	      if (classesAdded || classesRemoved) {
	
	        postDigestQueue.put(element, data);
	        postDigestElements.push(element);
	
	        if (postDigestElements.length === 1) {
	          $rootScope.$$postDigest(handleCSSClassChanges);
	        }
	      }
	    }
	  }];
	};
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */
	var $AnimateProvider = ['$provide', function($provide) {
	  var provider = this;
	
	  this.$$registeredAnimations = Object.create(null);
	
	   /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    if (name && name.charAt(0) !== '.') {
	      throw $animateMinErr('notcsel', "Expecting class selector starting with '.' got '{0}'.", name);
	    }
	
	    var key = name + '-animation';
	    provider.$$registeredAnimations[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      this.$$classNameFilter = (expression instanceof RegExp) ? expression : null;
	      if (this.$$classNameFilter) {
	        var reservedRegex = new RegExp("(\\s+|\\/)" + NG_ANIMATE_CLASSNAME + "(\\s+|\\/)");
	        if (reservedRegex.test(this.$$classNameFilter.toString())) {
	          throw $animateMinErr('nongcls','$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	
	        }
	      }
	    }
	    return this.$$classNameFilter;
	  };
	
	  this.$get = ['$$animateQueue', function($$animateQueue) {
	    function domInsert(element, parentElement, afterElement) {
	      // if for some reason the previous element was removed
	      // from the dom sometime before this code runs then let's
	      // just stick to using the parent element as the anchor
	      if (afterElement) {
	        var afterNode = extractElementNode(afterElement);
	        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	          afterElement = null;
	        }
	      }
	      afterElement ? afterElement.after(element) : parentElement.prepend(element);
	    }
	
	    /**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */
	    return {
	      // we don't call it directly since non-existant arguments may
	      // be interpreted as null within the sub enabled function
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       */
	      on: $$animateQueue.on,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove listeners for all animation events from the container element
	       * $animate.off(container);
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `callback` that is set
	       * // to listen for `enter` on the given `container` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	       * addClass, removeClass, etc...), or the container element. If it is the element, all other
	       * arguments are ignored.
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */
	      off: $$animateQueue.off,
	
	      /**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the Angular application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */
	      pin: $$animateQueue.pin,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */
	      enabled: $$animateQueue.enabled,
	
	      /**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation.
	       *
	       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
	       */
	      cancel: function(runner) {
	        runner.end && runner.end();
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */
	      enter: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */
	      move: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */
	      leave: function(element, options) {
	        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	          element.remove();
	        });
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */
	      addClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addclass, className);
	        return $$animateQueue.push(element, 'addClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */
	      removeClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.removeClass = mergeClasses(options.removeClass, className);
	        return $$animateQueue.push(element, 'removeClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */
	      setClass: function(element, add, remove, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addClass, add);
	        options.removeClass = mergeClasses(options.removeClass, remove);
	        return $$animateQueue.push(element, 'setClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given classNamem, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be applied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element
	       *
	       * @return {Promise} the animation callback promise
	       */
	      animate: function(element, from, to, className, options) {
	        options = prepareAnimateOptions(options);
	        options.from = options.from ? extend(options.from, from) : from;
	        options.to   = options.to   ? extend(options.to, to)     : to;
	
	        className = className || 'ng-inline-animate';
	        options.tempClasses = mergeClasses(options.tempClasses, className);
	        return $$animateQueue.push(element, 'animate', options);
	      }
	    };
	  }];
	}];
	
	var $$AnimateAsyncRunFactoryProvider = function() {
	  this.$get = ['$$rAF', function($$rAF) {
	    var waitQueue = [];
	
	    function waitForTick(fn) {
	      waitQueue.push(fn);
	      if (waitQueue.length > 1) return;
	      $$rAF(function() {
	        for (var i = 0; i < waitQueue.length; i++) {
	          waitQueue[i]();
	        }
	        waitQueue = [];
	      });
	    }
	
	    return function() {
	      var passed = false;
	      waitForTick(function() {
	        passed = true;
	      });
	      return function(callback) {
	        passed ? callback() : waitForTick(callback);
	      };
	    };
	  }];
	};
	
	var $$AnimateRunnerFactoryProvider = function() {
	  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$document', '$timeout',
	       function($q,   $sniffer,   $$animateAsyncRun,   $document,   $timeout) {
	
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    AnimateRunner.chain = function(chain, callback) {
	      var index = 0;
	
	      next();
	      function next() {
	        if (index === chain.length) {
	          callback(true);
	          return;
	        }
	
	        chain[index](function(response) {
	          if (response === false) {
	            callback(false);
	            return;
	          }
	          index++;
	          next();
	        });
	      }
	    };
	
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      var rafTick = $$animateAsyncRun();
	      var timeoutTick = function(fn) {
	        $timeout(fn, 0, false);
	      };
	
	      this._doneCallbacks = [];
	      this._tick = function(fn) {
	        var doc = $document[0];
	
	        // the document may not be ready or attached
	        // to the module for some internal tests
	        if (doc && doc.hidden) {
	          timeoutTick(fn);
	        } else {
	          rafTick(fn);
	        }
	      };
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              status === false ? reject() : resolve();
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._tick(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	};
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */
	var $CoreAnimateCssProvider = function() {
	  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
	
	    return function(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = copy(options);
	      }
	
	      // there is no point in applying the styles since
	      // there is no animation that goes on at all in
	      // this version of $animateCss.
	      if (options.cleanupStyles) {
	        options.from = options.to = null;
	      }
	
	      if (options.from) {
	        element.css(options.from);
	        options.from = null;
	      }
	
	      /* jshint newcap: false */
	      var closed, runner = new $$AnimateRunner();
	      return {
	        start: run,
	        end: run
	      };
	
	      function run() {
	        $$rAF(function() {
	          applyAnimationContents();
	          if (!closed) {
	            runner.complete();
	          }
	          closed = true;
	        });
	        return runner;
	      }
	
	      function applyAnimationContents() {
	        if (options.addClass) {
	          element.addClass(options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          element.removeClass(options.removeClass);
	          options.removeClass = null;
	        }
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	    };
	  }];
	};
	
	/* global stripHash: true */
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer) {
	  var self = this,
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {};
	
	  self.isMock = false;
	
	  var outstandingRequestCount = 0;
	  var outstandingRequestCallbacks = [];
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = completeOutstandingRequest;
	  self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };
	
	  /**
	   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
	   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
	   */
	  function completeOutstandingRequest(fn) {
	    try {
	      fn.apply(null, sliceArgs(arguments, 1));
	    } finally {
	      outstandingRequestCount--;
	      if (outstandingRequestCount === 0) {
	        while (outstandingRequestCallbacks.length) {
	          try {
	            outstandingRequestCallbacks.pop()();
	          } catch (e) {
	            $log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function getHash(url) {
	    var index = url.indexOf('#');
	    return index === -1 ? '' : url.substr(index);
	  }
	
	  /**
	   * @private
	   * Note: this method is used only by scenario runner
	   * TODO(vojta): prefix this method with $$ ?
	   * @param {function()} callback Function that will be called when no outstanding request
	   */
	  self.notifyWhenNoOutstandingRequests = function(callback) {
	    if (outstandingRequestCount === 0) {
	      callback();
	    } else {
	      outstandingRequestCallbacks.push(callback);
	    }
	  };
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      pendingLocation = null,
	      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
	        try {
	          return history.state;
	        } catch (e) {
	          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	        }
	      };
	
	  cacheState();
	  lastHistoryState = cachedState;
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of location.href.
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, pushState/replaceState is used, otherwise
	   * location.href/location.replace is used.
	   * Returns its own instance to allow chaining
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state object to use with pushState/replaceState
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	        // Do the assignment again so that those two variables are referentially identical.
	        lastHistoryState = cachedState;
	      } else {
	        if (!sameBase) {
	          pendingLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	        if (location.href !== url) {
	          pendingLocation = url;
	        }
	      }
	      if (pendingLocation) {
	        pendingLocation = url;
	      }
	      return self;
	    // getter
	    } else {
	      // - pendingLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	      //   https://openradar.appspot.com/22186109).
	      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
	      return pendingLocation || location.href.replace(/%27/g,"'");
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    pendingLocation = null;
	    cacheState();
	    fireUrlChange();
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	    lastCachedState = cachedState;
	  }
	
	  function fireUrlChange() {
	    if (lastBrowserUrl === self.url() && lastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of angular:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in angular apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers (e.g. Opera)
	      // don't fire popstate when user change the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */
	  self.$$applicationDestroyed = function() {
	    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	  };
	
	  /**
	   * Checks whether the url has changed outside of Angular.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?\:)?\/\/[^\/]*/, '') : '';
	  };
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] of milliseconds to defer the function execution.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay) {
	    var timeoutId;
	    outstandingRequestCount++;
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      completeOutstandingRequest(fn);
	    }, delay || 0);
	    pendingDeferIds[timeoutId] = true;
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds[deferId]) {
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      completeOutstandingRequest(noop);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document',
	      function($window, $log, $sniffer, $document) {
	        return new Browser($window, $document, $log, $sniffer);
	      }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', "CacheId '{0}' is already taken!", cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = createMap(),
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = createMap(),
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $http $http} and the {@link ng.directive:script script} directive to cache
	       * templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (isUndefined(value)) return;
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry == freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry == staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          if (!(key in data)) return;
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = createMap();
	          size = 0;
	          lruHash = createMap();
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      };
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry != freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd == entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry != prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 *
	 * @description
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, or by consuming the
	 * `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (IE,
	 * element with ng-app attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your HTML:
	 * ```html
	 * <div ng-include=" 'templateId.html' "></div>
	 * ```
	 *
	 * or get it via Javascript:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 * See {@link ng.$cacheFactory $cacheFactory}.
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a "Directive Definition Object" (see below) that defines the directive properties,
	 * or just the `postLink` function (all other properties will have the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       priority: 0,
	 *       template: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // templateUrl: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       transclude: false,
	 *       restrict: 'A',
	 *       templateNamespace: 'html',
	 *       scope: false,
	 *       controller: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       controllerAs: 'stringIdentifier',
	 *       bindToController: false,
	 *       require: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       compile: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *           pre: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *           post: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // link: {
	 *       //  pre: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  post: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // link: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true, the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioral (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `true`, an object or a falsy value:
	 *
	 * * **falsy:** No scope will be created for the directive. The directive will use its parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created. The new scope rule does not apply for the root of the template
	 * since the root of the template always gets a new scope.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's element. The
	 * 'isolate' scope differs from normal scope in that it does not prototypically inherit from its parent
	 * scope. This is useful when creating reusable components, which should not accidentally read or modify
	 * data in the parent scope.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
	 *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
	 *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
	 *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
	 *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
	 *
	  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
	 *
	 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	 *   two caveats:
	 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	 *     sets the same value. That means if your bound value is an object, changes to its properties
	 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	 *     to the value has changed. In most cases, this should not be of concern, but can be important
	 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	 *     If you now change a property of the object in your parent scope, the change will not be
	 *     propagated to the isolated scope, because the identity of the object on the parent scope
	 *     has not changed. Instead you must assign a new object.
	 *
	 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	 *   back to the parent. However, it does not make this completely impossible.
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property. Additionally, a controller
	 * alias must be set, either by using `controllerAs: 'myAlias'` or by specifying the alias in the controller
	 * definition: `controller: 'myCtrl as myAlias'`.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope.
	 *
	 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	 * properties. You can access these bindings once they have been initialized by providing a controller method called
	 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	 * initialized.
	 *
	 * <div class="alert alert-warning">
	 * **Deprecation warning:** although bindings for non-ES6 class controllers are currently
	 * bound to `this` before the controller constructor is called, this use is now deprecated. Please place initialization
	 * code that relies upon bindings inside a `$onInit` method on the controller, instead.
	 * </div>
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	 *    * `scope`: (optional) override the scope.
	 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	 *    * `futureParentElement` (optional):
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkinFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	 *      then the default translusion is provided.
	 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	 *
	 * The controller can provide the following methods that act as life-cycle hooks:
	 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	 *   this element). This is a good place to put initialization code for your controller.
	 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	 *   component such as cloning the bound value to prevent accidental mutation of the outer value.
	 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	 *   components will have their `$onDestroy()` hook called before child components.
	 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	 *   suspended until that occurs.
	 *
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` property can be a string, an array or an object:
	 * * a **string** containing the name of the directive to pass to the linking function
	 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	 * linking function will be an array of controllers in the same order as the names in the `require` property
	 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	 * controllers.
	 *
	 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	 * have been constructed but before `$onInit` is called.
	 * If the name of the required controller is the same as the local name (the key), the name can be
	 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	 * See the {@link $compileProvider#component} helper for an example of how this can be used.
	 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	 * raised (unless no link function is specified and the required controllers are not being bound to the directive
	 * controller, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace` ([*DEPRECATED*!], will be removed in next major release - i.e. v2.0)
	 * specify what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using $compile in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude`
	 *     parameter of directive controllers, see there for details.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element, the entire element or multiple parts of the element contents:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	 *
	 * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
	 *
	 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	 *
	 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	 *
	 * If the element selector is prefixed with a `?` then that slot is optional.
	 *
	 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	 *
	 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	 * injectable into the directive's controller.
	 *
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, to which the clone is bound.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
	 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects the '$compile'
	        $compileProvider.directive('compile', function($compile) {
	          // directive factory creates a link function
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                 // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // when the 'compile' expression changes
	                // assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current
	                // scope.
	                // NOTE: we only compile .childNodes so that
	                // we don't get into infinite loop compiling ourselves
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'Angular';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello Angular'.
	       expect(output.getText()).toBe('Hello Angular');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('Angular!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non html
	 *        elements (e.g. SVG elements). See also the directive.controller property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to $digest which typically is done by
	 * Angular automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = $compile('<p>{{total}}</p>')(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone via the cloneAttachFn:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>'),
	 *         scope = ....;
	 *
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       //attach the clone to DOM document at the right place
	 *     });
	 *
	 *     //now we have reference to the cloned DOM via `clonedElement`
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler Angular HTML Compiler} section of the Developer Guide.
	 */
	
	var $compileMinErr = minErr('$compile');
	
	function UNINITIALIZED_VALUE() {}
	var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive\:\s*([\w\-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w\-]+)(?:\:([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	  var bindingCache = createMap();
	
	  function parseIsolateBindings(scope, directiveName, isController) {
	    var LOCAL_REGEXP = /^\s*([@&<]|=(\*?))(\??)\s*(\w*)\s*$/;
	
	    var bindings = createMap();
	
	    forEach(scope, function(definition, scopeName) {
	      if (definition in bindingCache) {
	        bindings[scopeName] = bindingCache[definition];
	        return;
	      }
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            "Invalid {3} for directive '{0}'." +
	            " Definition: {... {1}: '{2}' ...}",
	            directiveName, scopeName, definition,
	            (isController ? "controller bindings definition" :
	            "isolate scope definition"));
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	      if (match[4]) {
	        bindingCache[definition] = bindings[scopeName];
	      }
	    });
	
	    return bindings;
	  }
	
	  function parseDirectiveBindings(directive, directiveName) {
	    var bindings = {
	      isolateScope: null,
	      bindToController: null
	    };
	    if (isObject(directive.scope)) {
	      if (directive.bindToController === true) {
	        bindings.bindToController = parseIsolateBindings(directive.scope,
	                                                         directiveName, true);
	        bindings.isolateScope = {};
	      } else {
	        bindings.isolateScope = parseIsolateBindings(directive.scope,
	                                                     directiveName, false);
	      }
	    }
	    if (isObject(directive.bindToController)) {
	      bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	    }
	    if (isObject(bindings.bindToController)) {
	      var controller = directive.controller;
	      var controllerAs = directive.controllerAs;
	      if (!controller) {
	        // There is no controller, there may or may not be a controllerAs property
	        throw $compileMinErr('noctrl',
	              "Cannot bind to controller without directive '{0}'s controller.",
	              directiveName);
	      } else if (!identifierForController(controller, controllerAs)) {
	        // There is a controller, but no identifier or controllerAs property
	        throw $compileMinErr('noident',
	              "Cannot bind to controller without identifier for directive '{0}'.",
	              directiveName);
	      }
	    }
	    return bindings;
	  }
	
	  function assertValidDirectiveName(name) {
	    var letter = name.charAt(0);
	    if (!letter || letter !== lowercase(letter)) {
	      throw $compileMinErr('baddir', "Directive/Component name '{0}' is invalid. The first character must be a lowercase letter", name);
	    }
	    if (name !== name.trim()) {
	      throw $compileMinErr('baddir',
	            "Directive/Component name '{0}' is invalid. The name should not contain leading or trailing whitespaces",
	            name);
	    }
	  }
	
	  function getDirectiveRequire(directive) {
	    var require = directive.require || (directive.controller && directive.name);
	
	    if (!isArray(require) && isObject(require)) {
	      forEach(require, function(value, key) {
	        var match = value.match(REQUIRE_PREFIX_REGEXP);
	        var name = value.substring(match[0].length);
	        if (!name) require[key] = match[0] + key;
	      });
	    }
	
	    return require;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
	   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
	   *    names and the values are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	  this.directive = function registerDirective(name, directiveFactory) {
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertValidDirectiveName(name);
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = getDirectiveRequire(directive);
	                directive.restrict = directive.restrict || 'EA';
	                directive.$$moduleName = directiveFactory.$$moduleName;
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#component
	   * @module ng
	   * @param {string} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`)
	   * @param {Object} options Component definition object (a simplified
	   *    {@link ng.$compile#directive-definition-object directive definition object}),
	   *    with the following properties (all optional):
	   *
	   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *      If not present, this will default to be `$ctrl`.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used as the contents of this component.
	   *      Empty string by default.
	   *
	   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used  as the contents of this component.
	   *
	   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	   *      Component properties are always bound to the component controller and not to the scope.
	   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	   *      Disabled by default.
	   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	   *      this component's controller. The object keys specify the property names under which the required
	   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	   *    - `$...` – additional properties to attach to the directive factory function and the controller
	   *      constructor function. (This is used by the component router to annotate)
	   *
	   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	   * @description
	   * Register a **component definition** with the compiler. This is a shorthand for registering a special
	   * type of directive, which represents a self-contained UI component in your application. Such components
	   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	   *
	   * Component definitions are very simple and do not require as much configuration as defining general
	   * directives. Component definitions usually consist only of a template and a controller backing it.
	   *
	   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	   * `bindToController`. They always have **isolate scope** and are restricted to elements.
	   *
	   * Here are a few examples of how you would usually define components:
	   *
	   * ```js
	   *   var myMod = angular.module(...);
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   * ```
	   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	   *
	   * <br />
	   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	   */
	  this.component = function registerComponent(name, options) {
	    var controller = options.controller || function() {};
	
	    function factory($injector) {
	      function makeInjectable(fn) {
	        if (isFunction(fn) || isArray(fn)) {
	          return function(tElement, tAttrs) {
	            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
	          };
	        } else {
	          return fn;
	        }
	      }
	
	      var template = (!options.template && !options.templateUrl ? '' : options.template);
	      var ddo = {
	        controller: controller,
	        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
	        template: makeInjectable(template),
	        templateUrl: makeInjectable(options.templateUrl),
	        transclude: options.transclude,
	        scope: {},
	        bindToController: options.bindings || {},
	        restrict: 'E',
	        require: options.require
	      };
	
	      // Copy annotations (starting with $) over to the DDO
	      forEach(options, function(val, key) {
	        if (key.charAt(0) === '$') ddo[key] = val;
	      });
	
	      return ddo;
	    }
	
	    // TODO(pete) remove the following `forEach` before we release 1.6.0
	    // The component-router@0.2.0 looks for the annotations on the controller constructor
	    // Nothing in Angular looks for annotations on the factory function but we can't remove
	    // it from 1.5.x yet.
	
	    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	    // These could be used by libraries such as the new component router
	    forEach(options, function(val, key) {
	      if (key.charAt(0) === '$') {
	        factory[key] = val;
	        // Don't try to copy over annotations to named controller
	        if (isFunction(controller)) controller[key] = val;
	      }
	    });
	
	    factory.$inject = ['$injector'];
	
	    return this.directive(name, factory);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `$binding` data property containing an array of the binding expressions
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	
	  var TTL = 10;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#onChangesTtl
	   * @description
	   *
	   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	   * in several iterations of calls to these hooks. However if an application needs more than the default 10
	   * iterations to stabilize then you should investigate what is causing the model to continuously change during
	   * the `$onChanges` hook execution.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	   *
	   * @param {number} limit The number of `$onChanges` hook iterations.
	   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	   */
	  this.onChangesTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	      return this;
	    }
	    return TTL;
	  };
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$sce', '$animate', '$$sanitizeUri',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $sce,   $animate,   $$sanitizeUri) {
	
	    var SIMPLE_ATTR_NAME = /^\w/;
	    var specialAttrHolder = window.document.createElement('div');
	
	
	
	    var onChangesTtl = TTL;
	    // The onChanges hooks should all be run together in a single digest
	    // When changes occur, the call to trigger their hooks will be added to this queue
	    var onChangesQueue;
	
	    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	    function flushOnChangesQueue() {
	      try {
	        if (!(--onChangesTtl)) {
	          // We have hit the TTL limit so reset everything
	          onChangesQueue = undefined;
	          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
	        }
	        // We must run this hook in an apply since the $$postDigest runs outside apply
	        $rootScope.$apply(function() {
	          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
	            onChangesQueue[i]();
	          }
	          // Reset the queue to trigger a new schedule next time there is a change
	          onChangesQueue = undefined;
	        });
	      } finally {
	        onChangesTtl++;
	      }
	    }
	
	
	    function Attributes(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    }
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        //is set through this function since it may cause $updateClass to
	        //become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        if ((nodeName === 'a' && (key === 'href' || key === 'xlinkHref')) ||
	            (nodeName === 'img' && key === 'src')) {
	          // sanitize a[href] and img[src] values
	          this[key] = value = $$sanitizeUri(value, key === 'src');
	        } else if (nodeName === 'img' && key === 'srcset' && isDefined(value)) {
	          // sanitize img[srcset] values
	          var result = "";
	
	          // first check if there are spaces because it's not the same pattern
	          var trimmedSrcset = trim(value);
	          //                (   999x   ,|   999w   ,|   ,|,   )
	          var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	          var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	          // split srcset into tuple of uri and descriptor except for the last item
	          var rawUris = trimmedSrcset.split(pattern);
	
	          // for each tuples
	          var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	          for (var i = 0; i < nbrUrisWith2parts; i++) {
	            var innerIdx = i * 2;
	            // sanitize the uri
	            result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
	            // add the descriptor
	            result += (" " + trim(rawUris[innerIdx + 1]));
	          }
	
	          // split the last item into uri and descriptor
	          var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	          // sanitize the last uri
	          result += $$sanitizeUri(trim(lastTuple[0]), true);
	
	          // and add the last descriptor if any
	          if (lastTuple.length === 2) {
	            result += (" " + trim(lastTuple[1]));
	          }
	          this[key] = value = result;
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || isUndefined(value)) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            if (SIMPLE_ATTR_NAME.test(attrName)) {
	              this.$$element.attr(attrName, value);
	            } else {
	              setSpecialAttr(this.$$element[0], attrName, value);
	            }
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        $$observers && forEach($$observers[observer], function(fn) {
	          try {
	            fn(value);
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        });
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	    function setSpecialAttr(element, attrName, value) {
	      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	      // so we have to jump through some hoops to get such an attribute
	      // https://github.com/angular/angular.js/pull/13318
	      specialAttrHolder.innerHTML = "<span " + attrName + ">";
	      var attributes = specialAttrHolder.firstChild.attributes;
	      var attribute = attributes[0];
	      // We have to remove the attribute from its container element before we can add it to the destination element
	      attributes.removeNamedItem(attribute.name);
	      attribute.value = value;
	      element.attributes.setNamedItem(attribute);
	    }
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol == '{{' && endSymbol  == '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_ATTR_BINDING = /^ngAttr[A-Z]/;
	    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    compile.$$createComment = function(directiveName, comment) {
	      var content = '';
	      if (debugInfoEnabled) {
	        content = ' ' + (directiveName || '') + ': ';
	        if (comment) content += comment + ' ';
	      }
	      return window.document.createComment(content);
	    };
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	
	      var NOT_EMPTY = /\S+/;
	
	      // We can not compile top level text elements since text nodes can be merged and we will
	      // not be able to attach scope data to them, so we will wrap them in <span>
	      for (var i = 0, len = $compileNodes.length; i < len; i++) {
	        var domNode = $compileNodes[i];
	
	        if (domNode.nodeType === NODE_TYPE_TEXT && domNode.nodeValue.match(NOT_EMPTY) /* non-empty */) {
	          jqLiteWrapNode(domNode, $compileNodes[i] = window.document.createElement('span'));
	        }
	      }
	
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        assertArg(scope, 'scope');
	
	        if (previousCompileContext && previousCompileContext.needsNewScope) {
	          // A parent directive did a replace and a directive on this element asked
	          // for transclusion, which caused us to lose a layer of element on which
	          // we could hold the new transclusion scope, so we will create it manually
	          // here.
	          scope = scope.$parent.$new();
	        }
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // we must always refer to nodeList[i] since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i+=3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      }
	
	      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
	      // so that they are available inside the `controllersBoundTransclude` function
	      var boundSlots = boundTranscludeFn.$$slots = createMap();
	      for (var slotName in transcludeFn.$$slots) {
	        if (transcludeFn.$$slots[slotName]) {
	          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
	        } else {
	          boundSlots[slotName] = null;
	        }
	      }
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName_(node)), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = trim(attr.value);
	
	            // support ngAttr attribute binding
	            ngAttrName = directiveNormalize(name);
	            if (isNgAttr = NG_ATTR_BINDING.test(ngAttrName)) {
	              name = name.replace(PREFIX_REGEXP, '')
	                .substr(8).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	            }
	
	            var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
	            if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
	              attrStartName = name;
	              attrEndName = name.substr(0, name.length - 5) + 'end';
	              name = name.substr(0, name.length - 6);
	            }
	
	            nName = directiveNormalize(name.toLowerCase());
	            attrsMap[nName] = name;
	            if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	            }
	            addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	            addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                          attrEndName);
	          }
	
	          // use class as directive
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while (match = CLASS_DIRECTIVE_REGEXP.exec(className)) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          if (msie === 11) {
	            // Workaround for #11781
	            while (node.parentNode && node.nextSibling && node.nextSibling.nodeType === NODE_TYPE_TEXT) {
	              node.nodeValue = node.nodeValue + node.nextSibling.nodeValue;
	              node.parentNode.removeChild(node.nextSibling);
	            }
	          }
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          try {
	            match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	            if (match) {
	              nName = directiveNormalize(match[1]);
	              if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[2]);
	              }
	            }
	          } catch (e) {
	            // turns out that under some circumstances IE9 throws errors when one attempts to read
	            // comment's node value.
	            // Just ignore it and continue. (Can't seem to reproduce in test case.)
	          }
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    /**
	     * Given a node with an directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      "Unterminated attribute, found '{0}' but no matching '{1}' found.",
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType == NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * A function generator that is used to support both eager and lazy compilation
	     * linking function.
	     * @param eager
	     * @param $compileNodes
	     * @param transcludeFn
	     * @param maxPriority
	     * @param ignoreDirective
	     * @param previousCompileContext
	     * @returns {Function}
	     */
	    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
	      var compiled;
	
	      if (eager) {
	        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	      }
	      return function lazyCompilation() {
	        if (!compiled) {
	          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	
	          // Null out all of these references in order to make them eligible for garbage collection
	          // since this is a potentially long lived closure
	          $compileNodes = transcludeFn = previousCompileContext = null;
	        }
	        return compiled.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective = previousCompileContext.newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          didScanForMultipleTransclusion = false,
	          mightHaveMultipleTransclusionError = false,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        if (directiveValue = directive.scope) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        // If we encounter a condition that can result in transclusion on the directive,
	        // then scan ahead in the remaining directives for others that may cause a multiple
	        // transclusion error to be thrown during the compilation process.  If a matching directive
	        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
	        // compile the `transclude` function rather than doing it lazily in order to throw
	        // exceptions at the correct time
	        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
	            || (directive.transclude && !directive.$$tlb))) {
	                var candidateDirective;
	
	                for (var scanningIndex = i + 1; candidateDirective = directives[scanningIndex++];) {
	                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
	                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
	                        mightHaveMultipleTransclusionError = true;
	                        break;
	                    }
	                }
	
	                didScanForMultipleTransclusion = true;
	        }
	
	        if (!directive.templateUrl && directive.controller) {
	          directiveValue = directive.controller;
	          controllerDirectives = controllerDirectives || createMap();
	          assertNoDuplicate("'" + directiveName + "' controller",
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        if (directiveValue = directive.transclude) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue == 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            // Support: Chrome < 50
	            // https://github.com/angular/angular.js/issues/14041
	
	            // In the versions of V8 prior to Chrome 50, the document fragment that is created
	            // in the `replaceWith` function is improperly garbage collected despite still
	            // being referenced by the `parentNode` property of all of the child nodes.  By adding
	            // a reference to the fragment via a different property, we can avoid that incorrect
	            // behavior.
	            // TODO: remove this line after Chrome 50 has been released
	            $template[0].$$parentNode = $template[0].parentNode;
	
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	
	            var slots = createMap();
	
	            $template = jqLite(jqLiteClone(compileNode)).contents();
	
	            if (isObject(directiveValue)) {
	
	              // We have transclusion slots,
	              // collect them up, compile them and store their transclusion functions
	              $template = [];
	
	              var slotMap = createMap();
	              var filledSlots = createMap();
	
	              // Parse the element selectors
	              forEach(directiveValue, function(elementSelector, slotName) {
	                // If an element selector starts with a ? then it is optional
	                var optional = (elementSelector.charAt(0) === '?');
	                elementSelector = optional ? elementSelector.substring(1) : elementSelector;
	
	                slotMap[elementSelector] = slotName;
	
	                // We explicitly assign `null` since this implies that a slot was defined but not filled.
	                // Later when calling boundTransclusion functions with a slot name we only error if the
	                // slot is `undefined`
	                slots[slotName] = null;
	
	                // filledSlots contains `true` for all slots that are either optional or have been
	                // filled. This is used to check that we have not missed any required slots
	                filledSlots[slotName] = optional;
	              });
	
	              // Add the matching elements into their slot
	              forEach($compileNode.contents(), function(node) {
	                var slotName = slotMap[directiveNormalize(nodeName_(node))];
	                if (slotName) {
	                  filledSlots[slotName] = true;
	                  slots[slotName] = slots[slotName] || [];
	                  slots[slotName].push(node);
	                } else {
	                  $template.push(node);
	                }
	              });
	
	              // Check for required slots that were not filled
	              forEach(filledSlots, function(filled, slotName) {
	                if (!filled) {
	                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
	                }
	              });
	
	              for (var slotName in slots) {
	                if (slots[slotName]) {
	                  // Only define a transclusion function if the slot was filled
	                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
	                }
	              }
	            }
	
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
	                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
	            childTranscludeFn.$$slots = slots;
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  "Template for directive '{0}' must have exactly one root element. {1}",
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective || newScopeDirective) {
	              // The original directive caused the current element to be replaced but this element
	              // also needs to have a new scope, so we need to tell the template directives
	              // that they would need to get their scope from further up, if they require transclusion
	              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          /* jshint -W021 */
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	          /* jshint +W021 */
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            var context = directive.$$originalDirective || directive;
	            if (isFunction(linkFn)) {
	              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
	            attrs, scopeBindingInfo;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        controllerScope = scope;
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        } else if (newScopeDirective) {
	          controllerScope = scope.$parent;
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	          // expose the slots on the `$transclude` function
	          transcludeFn.isSlotFilled = function(slotName) {
	            return !!boundTranscludeFn.$$slots[slotName];
	          };
	        }
	
	        if (controllerDirectives) {
	          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
	        }
	
	        if (newIsolateScopeDirective) {
	          // Initialize isolate scope bindings for new isolate scope directive.
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	          isolateScope.$$isolateBindings =
	              newIsolateScopeDirective.$$isolateBindings;
	          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
	                                        isolateScope.$$isolateBindings,
	                                        newIsolateScopeDirective);
	          if (scopeBindingInfo.removeWatches) {
	            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
	          }
	        }
	
	        // Initialize bindToController bindings
	        for (var name in elementControllers) {
	          var controllerDirective = controllerDirectives[name];
	          var controller = elementControllers[name];
	          var bindings = controllerDirective.$$bindings.bindToController;
	
	          if (controller.identifier && bindings) {
	            controller.bindingInfo =
	              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          } else {
	            controller.bindingInfo = {};
	          }
	
	          var controllerResult = controller();
	          if (controllerResult !== controller.instance) {
	            // If the controller constructor has a return value, overwrite the instance
	            // from setupControllers
	            controller.instance = controllerResult;
	            $element.data('$' + controllerDirective.name + 'Controller', controllerResult);
	            controller.bindingInfo.removeWatches && controller.bindingInfo.removeWatches();
	            controller.bindingInfo =
	              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          }
	        }
	
	        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	        forEach(controllerDirectives, function(controllerDirective, name) {
	          var require = controllerDirective.require;
	          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
	            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
	          }
	        });
	
	        // Handle the init and destroy lifecycle hooks on all controllers that have them
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$onChanges)) {
	            controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
	          }
	          if (isFunction(controllerInstance.$onInit)) {
	            controllerInstance.$onInit();
	          }
	          if (isFunction(controllerInstance.$onDestroy)) {
	            controllerScope.$on('$destroy', function callOnDestroyHook() {
	              controllerInstance.$onDestroy();
	            });
	          }
	        });
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        childLinkFn && childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // Trigger $postLink lifecycle hooks
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$postLink)) {
	            controllerInstance.$postLink();
	          }
	        });
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
	          var transcludeControllers;
	          // No scope passed in:
	          if (!isScope(scope)) {
	            slotName = futureParentElement;
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          if (slotName) {
	            // slotTranscludeFn can be one of three things:
	            //  * a transclude function - a filled slot
	            //  * `null` - an optional slot that was not filled
	            //  * `undefined` - a slot that was not declared (i.e. invalid)
	            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
	            if (slotTranscludeFn) {
	              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	            } else if (isUndefined(slotTranscludeFn)) {
	              throw $compileMinErr('noslot',
	               'No parent directive that requires a transclusion with slot name "{0}". ' +
	               'Element: {1}',
	               slotName, startingTag($element));
	            }
	          } else {
	            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	          }
	        }
	      }
	    }
	
	    function getControllers(directiveName, require, $element, elementControllers) {
	      var value;
	
	      if (isString(require)) {
	        var match = require.match(REQUIRE_PREFIX_REGEXP);
	        var name = require.substring(match[0].length);
	        var inheritType = match[1] || match[3];
	        var optional = match[2] === '?';
	
	        //If only parents then start at the parent element
	        if (inheritType === '^^') {
	          $element = $element.parent();
	        //Otherwise attempt getting the controller from elementControllers in case
	        //the element is transcluded (and has no data) and to avoid .data if possible
	        } else {
	          value = elementControllers && elementControllers[name];
	          value = value && value.instance;
	        }
	
	        if (!value) {
	          var dataName = '$' + name + 'Controller';
	          value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	        }
	
	        if (!value && !optional) {
	          throw $compileMinErr('ctreq',
	              "Controller '{0}', required by directive '{1}', can't be found!",
	              name, directiveName);
	        }
	      } else if (isArray(require)) {
	        value = [];
	        for (var i = 0, ii = require.length; i < ii; i++) {
	          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	        }
	      } else if (isObject(require)) {
	        value = {};
	        forEach(require, function(controller, property) {
	          value[property] = getControllers(directiveName, controller, $element, elementControllers);
	        });
	      }
	
	      return value || null;
	    }
	
	    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
	      var elementControllers = createMap();
	      for (var controllerKey in controllerDirectives) {
	        var directive = controllerDirectives[controllerKey];
	        var locals = {
	          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	          $element: $element,
	          $attrs: attrs,
	          $transclude: transcludeFn
	        };
	
	        var controller = directive.controller;
	        if (controller == '@') {
	          controller = attrs[directive.name];
	        }
	
	        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	        // For directives with element transclusion the element is a comment.
	        // In this case .data will not attach any data.
	        // Instead, we save the controllers for the element in a local hash and attach to .data
	        // later, once we have the actual element.
	        elementControllers[directive.name] = controllerInstance;
	        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	      }
	      return elementControllers;
	    }
	
	    // Depending upon the context in which a directive finds itself it might need to have a new isolated
	    // or child scope created. For instance:
	    // * if the directive has been pulled into a template because another directive with a higher priority
	    // asked for element transclusion
	    // * if the directive itself asks for transclusion but it is at the root of a template and the original
	    // element was replaced. See https://github.com/angular/angular.js/issues/12936
	    function markDirectiveScope(directives, isolateScope, newScope) {
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          try {
	            directive = directives[i];
	            if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
	                 directive.restrict.indexOf(location) != -1) {
	              if (startAttrName) {
	                directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	              }
	              if (!directive.$$bindings) {
	                var bindings = directive.$$bindings =
	                    parseDirectiveBindings(directive, directive.name);
	                if (isObject(bindings.isolateScope)) {
	                  directive.$$isolateBindings = bindings.isolateScope;
	                }
	              }
	              tDirectives.push(directive);
	              match = directive;
	            }
	          } catch (e) { $exceptionHandler(e); }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr,
	          $element = dst.$$element;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) != '$') {
	          if (src[key] && src[key] !== value) {
	            value += (key === 'style' ? ';' : ' ') + src[key];
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        if (key == 'class') {
	          safeAddClass($element, value);
	          dst['class'] = (dst['class'] ? dst['class'] + ' ' : '') + value;
	        } else if (key == 'style') {
	          $element.attr('style', $element.attr('style') + ';' + value);
	          dst['style'] = (dst['style'] ? dst['style'] + ';' : '') + value;
	          // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	          // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	          // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        } else if (key.charAt(0) != '$' && !dst.hasOwnProperty(key)) {
	          dst[key] = value;
	          dstAttr[key] = srcAttr[key];
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length != 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  "Template for directive '{0}' must have exactly one root element. {1}",
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              // the original directive that caused the template to be loaded async required
	              // an isolate scope
	              markDirectiveScope(templateDirectives, true);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node == compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn);
	          }
	          linkQueue = null;
	        });
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	
	      function wrapModuleNameIfDefined(moduleName) {
	        return moduleName ?
	          (' (module: ' + moduleName + ')') :
	          '';
	      }
	
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = window.document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedContext(node, attrNormalizedName) {
	      if (attrNormalizedName == "srcdoc") {
	        return $sce.HTML;
	      }
	      var tag = nodeName_(node);
	      // maction[xlink:href] can source SVG.  It's not limited to <maction>.
	      if (attrNormalizedName == "xlinkHref" ||
	          (tag == "form" && attrNormalizedName == "action") ||
	          (tag != "img" && (attrNormalizedName == "src" ||
	                            attrNormalizedName == "ngSrc"))) {
	        return $sce.RESOURCE_URL;
	      }
	    }
	
	
	    function addAttrInterpolateDirective(node, directives, value, name, allOrNothing) {
	      var trustedContext = getTrustedContext(node, name);
	      allOrNothing = ALL_OR_NOTHING_ATTRS[name] || allOrNothing;
	
	      var interpolateFn = $interpolate(value, true, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	
	      if (name === "multiple" && nodeName_(node) === "select") {
	        throw $compileMinErr("selmulti",
	            "Binding to the 'multiple' attribute is not supported. Element: {0}",
	            startingTag(node));
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
	
	                if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	                  throw $compileMinErr('nodomevents',
	                      "Interpolations for HTML DOM event attributes are disallowed.  Please use the " +
	                          "ng- versions (such as ng-click instead of onclick) instead.");
	                }
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue != oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] == firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // Append all the `elementsToRemove` to a fragment. This will...
	      // - remove them from the DOM
	      // - allow them to still be traversed with .nextSibling
	      // - allow a single fragment.qSA to fetch all elements being removed
	      var fragment = window.document.createDocumentFragment();
	      for (i = 0; i < removeCount; i++) {
	        fragment.appendChild(elementsToRemove[i]);
	      }
	
	      if (jqLite.hasData(firstElementToRemove)) {
	        // Copy over user data (that includes Angular's $scope etc.). Don't copy private
	        // data here because there's no public interface in jQuery to do that and copying over
	        // event listeners (which is the main use of private data) wouldn't work anyway.
	        jqLite.data(newNode, jqLite.data(firstElementToRemove));
	
	        // Remove $destroy event listeners from `firstElementToRemove`
	        jqLite(firstElementToRemove).off('$destroy');
	      }
	
	      // Cleanup any data/listeners on the elements and children.
	      // This includes invoking the $destroy event on any elements with listeners.
	      jqLite.cleanData(fragment.querySelectorAll('*'));
	
	      // Update the jqLite collection to only contain the `newNode`
	      for (i = 1; i < removeCount; i++) {
	        delete elementsToRemove[i];
	      }
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	
	
	    // Set up $watches for isolate scope and controller bindings. This process
	    // only occurs for isolate scopes and new scopes with controllerAs.
	    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
	      var removeWatchCollection = [];
	      var initialChanges = {};
	      var changes;
	      forEach(bindings, function initializeBinding(definition, scopeName) {
	        var attrName = definition.attrName,
	        optional = definition.optional,
	        mode = definition.mode, // @, =, or &
	        lastValue,
	        parentGet, parentSet, compare, removeWatch;
	
	        switch (mode) {
	
	          case '@':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              destination[scopeName] = attrs[attrName] = void 0;
	            }
	            attrs.$observe(attrName, function(value) {
	              if (isString(value) || isBoolean(value)) {
	                var oldValue = destination[scopeName];
	                recordChanges(scopeName, value, oldValue);
	                destination[scopeName] = value;
	              }
	            });
	            attrs.$$observers[attrName].$$scope = scope;
	            lastValue = attrs[attrName];
	            if (isString(lastValue)) {
	              // If the attribute has been provided then we trigger an interpolation to ensure
	              // the value is there for use in the link fn
	              destination[scopeName] = $interpolate(lastValue)(scope);
	            } else if (isBoolean(lastValue)) {
	              // If the attributes is one of the BOOLEAN_ATTR then Angular will have converted
	              // the value to boolean rather than a string, so we special case this situation
	              destination[scopeName] = lastValue;
	            }
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	            break;
	
	          case '=':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              attrs[attrName] = void 0;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            if (parentGet.literal) {
	              compare = equals;
	            } else {
	              compare = function simpleCompare(a, b) { return a === b || (a !== a && b !== b); };
	            }
	            parentSet = parentGet.assign || function() {
	              // reset the change, or we will throw this exception on every $digest
	              lastValue = destination[scopeName] = parentGet(scope);
	              throw $compileMinErr('nonassign',
	                  "Expression '{0}' in attribute '{1}' used with directive '{2}' is non-assignable!",
	                  attrs[attrName], attrName, directive.name);
	            };
	            lastValue = destination[scopeName] = parentGet(scope);
	            var parentValueWatch = function parentValueWatch(parentValue) {
	              if (!compare(parentValue, destination[scopeName])) {
	                // we are out of sync and need to copy
	                if (!compare(parentValue, lastValue)) {
	                  // parent changed and it has precedence
	                  destination[scopeName] = parentValue;
	                } else {
	                  // if the parent can be assigned then do so
	                  parentSet(scope, parentValue = destination[scopeName]);
	                }
	              }
	              return lastValue = parentValue;
	            };
	            parentValueWatch.$stateful = true;
	            if (definition.collection) {
	              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	            } else {
	              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	            }
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '<':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              attrs[attrName] = void 0;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	
	            var initialValue = destination[scopeName] = parentGet(scope);
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	
	            removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
	              if (oldValue === newValue) {
	                if (oldValue === initialValue) return;
	                oldValue = initialValue;
	              }
	              recordChanges(scopeName, newValue, oldValue);
	              destination[scopeName] = newValue;
	            }, parentGet.literal);
	
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '&':
	            // Don't assign Object.prototype method to scope
	            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	            // Don't assign noop to destination if expression is not valid
	            if (parentGet === noop && optional) break;
	
	            destination[scopeName] = function(locals) {
	              return parentGet(scope, locals);
	            };
	            break;
	        }
	      });
	
	      function recordChanges(key, currentValue, previousValue) {
	        if (isFunction(destination.$onChanges) && currentValue !== previousValue) {
	          // If we have not already scheduled the top level onChangesQueue handler then do so now
	          if (!onChangesQueue) {
	            scope.$$postDigest(flushOnChangesQueue);
	            onChangesQueue = [];
	          }
	          // If we have not already queued a trigger of onChanges for this controller then do so now
	          if (!changes) {
	            changes = {};
	            onChangesQueue.push(triggerOnChangesHook);
	          }
	          // If the has been a change on this property already then we need to reuse the previous value
	          if (changes[key]) {
	            previousValue = changes[key].previousValue;
	          }
	          // Store this change
	          changes[key] = new SimpleChange(previousValue, currentValue);
	        }
	      }
	
	      function triggerOnChangesHook() {
	        destination.$onChanges(changes);
	        // Now clear the changes so that we schedule onChanges when more changes arrive
	        changes = undefined;
	      }
	
	      return {
	        initialChanges: initialChanges,
	        removeWatches: removeWatchCollection.length && function removeWatches() {
	          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
	            removeWatchCollection[i]();
	          }
	        }
	      };
	    }
	  }];
	}
	
	function SimpleChange(previous, current) {
	  this.previousValue = previous;
	  this.currentValue = current;
	}
	SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };
	
	
	var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return camelCase(name.replace(PREFIX_REGEXP, ''));
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in Angular:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token == tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT) {
	      splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	
	var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
	function identifierForController(controller, ident) {
	  if (ident && isString(ident)) return ident;
	  if (isString(controller)) {
	    var match = CNTRL_REG.exec(controller);
	    if (match) return match[3];
	  }
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @description
	 * The {@link ng.$controller $controller service} is used by Angular to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {},
	      globals = false;
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#has
	   * @param {string} name Controller name to check.
	   */
	  this.has = function(name) {
	    return controllers.hasOwnProperty(name);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#allowGlobals
	   * @description If called, allows `$controller` to find controller constructors on `window`
	   */
	  this.allowGlobals = function() {
	    globals = true;
	  };
	
	
	  this.$get = ['$injector', '$window', function($injector, $window) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
	     *      `window` object (not recommended)
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function $controller(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            "Badly formed controller string '{0}'. " +
	            "Must match `__name__ as __id__` or `__name__`.", expression);
	        }
	        constructor = match[1],
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true) ||
	                (globals ? getter($window, constructor, true) : undefined);
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        var instantiate;
	        return instantiate = extend(function $controllerInit() {
	          var result = $injector.invoke(expression, instance, locals, constructor);
	          if (result !== instance && (isObject(result) || isFunction(result))) {
	            instance = result;
	            if (identifier) {
	              // If result changed, re-assign controllerAs value to scope.
	              addIdentifier(locals, identifier, instance, constructor || expression.name);
	            }
	          }
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          "Cannot export controller '{0}' as '{1}'! No $scope object provided via `locals`.",
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 *
	 * @description
	 * Any uncaught exception in angular expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * ```js
	 *   angular.module('exceptionOverride', []).factory('$exceptionHandler', function() {
	 *     return function(exception, cause) {
	 *       exception.message += ' (caused by "' + cause + '")';
	 *       throw exception;
	 *     };
	 *   });
	 * ```
	 *
	 * This example will override the normal action of `$exceptionHandler`, to make angular
	 * exceptions fail hard when they happen, instead of just logging to the console.
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var $$ForceReflowProvider = function() {
	  this.$get = ['$document', function($document) {
	    return function(domNode) {
	      //the line below will force the browser to perform a repaint so
	      //that all the animated elements within the animation frame will
	      //be properly updated and drawn on screen. This is required to
	      //ensure that the preparation animation is properly flushed so that
	      //the active state picks up from there. DO NOT REMOVE THIS LINE.
	      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	      if (domNode) {
	        if (!domNode.nodeType && domNode instanceof jqLite) {
	          domNode = domNode[0];
	        }
	      } else {
	        domNode = $document[0].body;
	      }
	      return domNode.offsetWidth + 1;
	    };
	  }];
	};
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var $httpMinErr = minErr('$http');
	var $httpMinErrLegacyFn = function(method) {
	  return function() {
	    throw $httpMinErr('legacy', 'The method `{0}` on the promise returned from `$http` has been disabled.', method);
	  };
	};
	
	function serializeValue(v) {
	  if (isObject(v)) {
	    return isDate(v) ? v.toISOString() : toJson(v);
	  }
	  return v;
	}
	
	
	function $HttpParamSerializerProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D"` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   * */
	
	  this.$get = function() {
	    return function ngParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value)) return;
	        if (isArray(value)) {
	          forEach(value, function(v) {
	            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	          });
	        } else {
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	        }
	      });
	
	      return parts.join('&');
	    };
	  };
	}
	
	function $HttpParamSerializerJQLikeProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   * */
	  this.$get = function() {
	    return function jQueryLikeParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      serialize(params, '', true);
	      return parts.join('&');
	
	      function serialize(toSerialize, prefix, topLevel) {
	        if (toSerialize === null || isUndefined(toSerialize)) return;
	        if (isArray(toSerialize)) {
	          forEach(toSerialize, function(value, index) {
	            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	          });
	        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	          forEachSorted(toSerialize, function(value, key) {
	            serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	          });
	        } else {
	          parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
	        }
	      }
	    };
	  };
	}
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      if ((contentType && (contentType.indexOf(APPLICATION_JSON) === 0)) || isJsonLike(tempData)) {
	        data = fromJson(tempData);
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), i;
	
	  function fillInParsed(key, val) {
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  }
	
	  if (isString(headers)) {
	    forEach(headers.split('\n'), function(line) {
	      i = line.indexOf(':');
	      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	    });
	  } else if (isObject(headers)) {
	    forEach(headers, function(headerVal, headerKey) {
	      fillInParsed(lowercase(headerKey), trim(headerVal));
	    });
	  }
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with single an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === void 0) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns)) {
	    return fns(data, headers, status);
	  }
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 * */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   **/
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN',
	
	    paramSerializer: '$httpParamSerializer'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  var useLegacyPromise = true;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useLegacyPromiseExtensions
	   * @description
	   *
	   * Configure `$http` service to return promises without the shorthand methods `success` and `error`.
	   * This should be used to make sure that applications work without these methods.
	   *
	   * Defaults to true. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, `$http` will return a promise with the deprecated legacy `success` and `error` methods.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useLegacyPromiseExtensions = function(value) {
	    if (isDefined(value)) {
	      useLegacyPromise = !!value;
	      return this;
	    }
	    return useLegacyPromise;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   **/
	  var interceptorFactories = this.interceptors = [];
	
	  this.$get = ['$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector',
	      function($httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Make sure that default param serializer is exposed as a function
	     */
	    defaults.paramSerializer = isString(defaults.paramSerializer) ?
	      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core Angular service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     * The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with the transform
	     *     functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *
	     * A response status code between 200 and 299 is considered a success status and will result in
	     * the success callback being called. Any response status code outside of that range is
	     * considered an error status and will result in the error callback being called.
	     * Also, status codes less than -1 are normalized to zero. -1 usually means the request was
	     * aborted, e.g. using a `config.timeout`.
	     * Note that if the response is a redirect, XMLHttpRequest will transparently follow it, meaning
	     * that the outcome (success or error) will be determined by the final response status code.
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Deprecation Notice
	     * <div class="alert alert-danger">
	     *   The `$http` legacy promise methods `success` and `error` have been deprecated.
	     *   Use the standard `then` method instead.
	     *   If {@link $httpProvider#useLegacyPromiseExtensions `$httpProvider.useLegacyPromiseExtensions`} is set to
	     *   `false` then these methods will throw {@link $http:legacy `$http/legacy`} error.
	     * </div>
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - `Accept: application/json, text/plain, * / *`
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** Angular does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * Angular provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`):
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`):
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If JSON response is detected, deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory($http)` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. Angular comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * Angular will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * Angular will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. Angular provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
	     * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
	     * The header will not be set for cross-domain requests.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
	     * that only JavaScript running on your domain could have sent the request. The token must be
	     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
	     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
	     * or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple Angular apps share the
	     * same domain or subdomain, we recommend that each application uses unique cookie name.
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string}` – Absolute or relative URL of the resource that is being requested.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
	     *                        when the request succeeds or fails.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?callback=JSON_CALLBACK&name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist&callback=JSON_CALLBACK')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || "Request failed";
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      if (!isString(requestConfig.url)) {
	        throw minErr('$http')('badreq', 'Http request configuration url must be a string.  Received: {0}', requestConfig.url);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse,
	        paramSerializer: defaults.paramSerializer
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	      config.paramSerializer = isString(config.paramSerializer) ?
	        $injector.get(config.paramSerializer) : config.paramSerializer;
	
	      var serverRequest = function(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	                delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      };
	
	      var chain = [serverRequest, undefined];
	      var promise = $q.when(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          chain.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          chain.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      while (chain.length) {
	        var thenFn = chain.shift();
	        var rejectFn = chain.shift();
	
	        promise = promise.then(thenFn, rejectFn);
	      }
	
	      if (useLegacyPromise) {
	        promise.success = function(fn) {
	          assertArgFn(fn, 'fn');
	
	          promise.then(function(response) {
	            fn(response.data, response.status, response.headers, config);
	          });
	          return promise;
	        };
	
	        promise.error = function(fn) {
	          assertArgFn(fn, 'fn');
	
	          promise.then(null, function(response) {
	            fn(response.data, response.status, response.headers, config);
	          });
	          return promise;
	        };
	      } else {
	        promise.success = $httpMinErrLegacyFn('success');
	        promise.error = $httpMinErrLegacyFn('error');
	      }
	
	      return promise;
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        resp.data = transformData(response.data, response.headers, response.status,
	                                  config.transformResponse);
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	
	      function executeHeaderFns(headers, config) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn(config);
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders, shallowCopy(config));
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request.
	     *                     The name of the callback should be the string `JSON_CALLBACK`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object
	      * @returns {HttpPromise} Future object
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          url = buildUrl(config.url, config.paramSerializer(config.params));
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	              : isObject(defaults.cache) ? defaults.cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsSameOrigin(config.url)
	            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType,
	            createApplyHandlers(config.eventHandlers),
	            createApplyHandlers(config.uploadEventHandlers));
	      }
	
	      return promise;
	
	      function createApplyHandlers(eventHandlers) {
	        if (eventHandlers) {
	          var applyHandlers = {};
	          forEach(eventHandlers, function(eventHandler, key) {
	            applyHandlers[key] = function(event) {
	              if (useApplyAsync) {
	                $rootScope.$applyAsync(callEventHandler);
	              } else if ($rootScope.$$phase) {
	                callEventHandler();
	              } else {
	                $rootScope.$apply(callEventHandler);
	              }
	
	              function callEventHandler() {
	                eventHandler(event);
	              }
	            };
	          });
	          return applyHandlers;
	        }
	      }
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText) {
	        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	        status = status >= -1 ? status : 0;
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, serializedParams) {
	      if (serializedParams.length > 0) {
	        url += ((url.indexOf('?') == -1) ? '?' : '&') + serializedParams;
	      }
	      return url;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $xhrFactory
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */
	function $xhrFactoryProvider() {
	  this.$get = function() {
	    return function createXhr() {
	      return new window.XMLHttpRequest();
	    };
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $window
	 * @requires $document
	 * @requires $xhrFactory
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$window', '$document', '$xhrFactory', function($browser, $window, $document, $xhrFactory) {
	    return createHttpBackend($browser, $xhrFactory, $browser.defer, $window.angular.callbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
	    $browser.$$incOutstandingRequestCount();
	    url = url || $browser.url();
	
	    if (lowercase(method) == 'jsonp') {
	      var callbackId = '_' + (callbacks.counter++).toString(36);
	      callbacks[callbackId] = function(data) {
	        callbacks[callbackId].data = data;
	        callbacks[callbackId].called = true;
	      };
	
	      var jsonpDone = jsonpReq(url.replace('JSON_CALLBACK', 'angular.callbacks.' + callbackId),
	          callbackId, function(status, text) {
	        completeRequest(callback, status, callbacks[callbackId].data, "", text);
	        callbacks[callbackId] = noop;
	      });
	    } else {
	
	      var xhr = createXhr(method, url);
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol == 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText);
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '');
	      };
	
	      xhr.onerror = requestError;
	      xhr.onabort = requestError;
	
	      forEach(eventHandlers, function(value, key) {
	          xhr.addEventListener(key, value);
	      });
	
	      forEach(uploadEventHandlers, function(value, key) {
	        xhr.upload.addEventListener(key, value);
	      });
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(isUndefined(post) ? null : post);
	    }
	
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(timeoutRequest, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(timeoutRequest);
	    }
	
	
	    function timeoutRequest() {
	      jsonpDone && jsonpDone();
	      xhr && xhr.abort();
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (isDefined(timeoutId)) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText);
	      $browser.$$completeOutstandingRequest(noop);
	    }
	  };
	
	  function jsonpReq(url, callbackId, done) {
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = "text/javascript";
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      removeEventListenerFn(script, "load", callback);
	      removeEventListenerFn(script, "error", callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = "unknown";
	
	      if (event) {
	        if (event.type === "load" && !callbacks[callbackId].called) {
	          event = { type: "error" };
	        }
	        text = event.type;
	        status = event.type === "error" ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    addEventListenerFn(script, "load", callback);
	    addEventListenerFn(script, "error", callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	$interpolateMinErr.throwNoconcat = function(text) {
	  throw $interpolateMinErr('noconcat',
	      "Error while interpolating: {0}\nStrict Contextual Escaping disallows " +
	      "interpolations that concatenate multiple expressions when a trusted value is " +
	      "required.  See http://docs.angularjs.org/api/ng.$sce", text);
	};
	
	$interpolateMinErr.interr = function(text, err) {
	  return $interpolateMinErr('interr', "Can't interpolate: {0}\n{1}", text, err.toString());
	};
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * <div class="alert alert-danger">
	 * This feature is sometimes used to mix different markup languages, e.g. to wrap an Angular
	 * template within a Python Jinja template (or any other template language). Mixing templating
	 * languages is **very dangerous**. The embedding template language will not safely escape Angular
	 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	 * security bugs!
	 * </div>
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    } else {
	      return startSymbol;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    } else {
	      return endSymbol;
	    }
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    function unescapeText(text) {
	      return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	    }
	
	    function stringify(value) {
	      if (value == null) { // null || undefined
	        return '';
	      }
	      switch (typeof value) {
	        case 'string':
	          break;
	        case 'number':
	          value = '' + value;
	          break;
	        default:
	          value = toJson(value);
	      }
	
	      return value;
	    }
	
	    //TODO: this is the same as the constantWatchDelegate in parse.js
	    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
	      var unwatch;
	      return unwatch = scope.$watch(function constantInterpolateWatch(scope) {
	        unwatch();
	        return constantInterp(scope);
	      }, listener, objectEquality);
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'Angular'})).toEqual('Hello ANGULAR!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'Angular';
	     *   expect(exp(context)).toEqual('Hello Angular!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * ####Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example>
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @knownIssue
	     * All directives and components must use the standard `{{` `}}` interpolation symbols
	     * in their templates. If you change the application interpolation symbols the {@link $compile}
	     * service will attempt to denormalize the standard symbols to the custom symbols.
	     * The denormalization process is not clever enough to know not to replace instances of the standard
	     * symbols where they would not normally be treated as interpolation symbols. For example in the following
	     * code snippet the closing braces of the literal object will get incorrectly denormalized:
	     *
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"}}">
	     * ```
	     *
	     * The workaround is to ensure that such instances are separated by whitespace:
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"} }">
	     * ```
	     *
	     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      // Provide a quick exit and simplified result function for text with no interpolation
	      if (!text.length || text.indexOf(startSymbol) === -1) {
	        var constantInterp;
	        if (!mustHaveExpression) {
	          var unescapedText = unescapeText(text);
	          constantInterp = valueFn(unescapedText);
	          constantInterp.exp = text;
	          constantInterp.expressions = [];
	          constantInterp.$$watchDelegate = constantWatchDelegate;
	        }
	        return constantInterp;
	      }
	
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns = [],
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [];
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) != -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) != -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          parseFns.push($parse(exp, parseStringifyInterceptor));
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push('');
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for iframe[src], object[src], etc., we ensure that the value
	      // that's used is assigned or constructed by some JS code somewhere that is more testable or
	      // make it obvious that you bound the value to some user controlled value.  This helps reduce
	      // the load when auditing for XSS issues.
	      if (trustedContext && concat.length > 1) {
	          $interpolateMinErr.throwNoconcat(text);
	      }
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	          return concat.join('');
	        };
	
	        var getValue = function(value) {
	          return trustedContext ?
	            $sce.getTrusted(trustedContext, value) :
	            $sce.valueOf(value);
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              if (isFunction(listener)) {
	                listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              }
	              lastValue = currValue;
	            });
	          }
	        });
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          value = getValue(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          $exceptionHandler($interpolateMinErr.interr(text, err));
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	function $IntervalProvider() {
	  this.$get = ['$rootScope', '$window', '$q', '$$q', '$browser',
	       function($rootScope,   $window,   $q,   $$q,   $browser) {
	    var intervals = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $interval
	      *
	      * @description
	      * Angular's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	      * milliseconds.
	      *
	      * The return value of registering an interval function is a promise. This promise will be
	      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	      * run indefinitely if `count` is not defined. The value of the notification will be the
	      * number of iterations that have run.
	      * To cancel an interval, call `$interval.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	      * time.
	      *
	      * <div class="alert alert-warning">
	      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	      * with them.  In particular they are not automatically destroyed when a controller's scope or a
	      * directive's element are destroyed.
	      * You should take this into consideration and make sure to always cancel the interval at the
	      * appropriate moment.  See the example below for more details on how and when to do this.
	      * </div>
	      *
	      * @param {function()} fn A function that should be called repeatedly.
	      * @param {number} delay Number of milliseconds between each function call.
	      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	      *   indefinitely.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {promise} A promise which will be notified on each iteration.
	      *
	      * @example
	      * <example module="intervalExample">
	      * <file name="index.html">
	      *   <script>
	      *     angular.module('intervalExample', [])
	      *       .controller('ExampleController', ['$scope', '$interval',
	      *         function($scope, $interval) {
	      *           $scope.format = 'M/d/yy h:mm:ss a';
	      *           $scope.blood_1 = 100;
	      *           $scope.blood_2 = 120;
	      *
	      *           var stop;
	      *           $scope.fight = function() {
	      *             // Don't start a new fight if we are already fighting
	      *             if ( angular.isDefined(stop) ) return;
	      *
	      *             stop = $interval(function() {
	      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	      *                 $scope.blood_1 = $scope.blood_1 - 3;
	      *                 $scope.blood_2 = $scope.blood_2 - 4;
	      *               } else {
	      *                 $scope.stopFight();
	      *               }
	      *             }, 100);
	      *           };
	      *
	      *           $scope.stopFight = function() {
	      *             if (angular.isDefined(stop)) {
	      *               $interval.cancel(stop);
	      *               stop = undefined;
	      *             }
	      *           };
	      *
	      *           $scope.resetFight = function() {
	      *             $scope.blood_1 = 100;
	      *             $scope.blood_2 = 120;
	      *           };
	      *
	      *           $scope.$on('$destroy', function() {
	      *             // Make sure that the interval is destroyed too
	      *             $scope.stopFight();
	      *           });
	      *         }])
	      *       // Register the 'myCurrentTime' directive factory method.
	      *       // We inject $interval and dateFilter service since the factory method is DI.
	      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	      *         function($interval, dateFilter) {
	      *           // return the directive link function. (compile function not needed)
	      *           return function(scope, element, attrs) {
	      *             var format,  // date format
	      *                 stopTime; // so that we can cancel the time updates
	      *
	      *             // used to update the UI
	      *             function updateTime() {
	      *               element.text(dateFilter(new Date(), format));
	      *             }
	      *
	      *             // watch the expression, and update the UI on change.
	      *             scope.$watch(attrs.myCurrentTime, function(value) {
	      *               format = value;
	      *               updateTime();
	      *             });
	      *
	      *             stopTime = $interval(updateTime, 1000);
	      *
	      *             // listen on DOM destroy (removal) event, and cancel the next UI update
	      *             // to prevent updating time after the DOM element was removed.
	      *             element.on('$destroy', function() {
	      *               $interval.cancel(stopTime);
	      *             });
	      *           }
	      *         }]);
	      *   </script>
	      *
	      *   <div>
	      *     <div ng-controller="ExampleController">
	      *       <label>Date format: <input ng-model="format"></label> <hr/>
	      *       Current time is: <span my-current-time="format"></span>
	      *       <hr/>
	      *       Blood 1 : <font color='red'>{{blood_1}}</font>
	      *       Blood 2 : <font color='red'>{{blood_2}}</font>
	      *       <button type="button" data-ng-click="fight()">Fight</button>
	      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	      *     </div>
	      *   </div>
	      *
	      * </file>
	      * </example>
	      */
	    function interval(fn, delay, count, invokeApply) {
	      var hasParams = arguments.length > 4,
	          args = hasParams ? sliceArgs(arguments, 4) : [],
	          setInterval = $window.setInterval,
	          clearInterval = $window.clearInterval,
	          iteration = 0,
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise;
	
	      count = isDefined(count) ? count : 0;
	
	      promise.$$intervalId = setInterval(function tick() {
	        if (skipApply) {
	          $browser.defer(callback);
	        } else {
	          $rootScope.$evalAsync(callback);
	        }
	        deferred.notify(iteration++);
	
	        if (count > 0 && iteration >= count) {
	          deferred.resolve(iteration);
	          clearInterval(promise.$$intervalId);
	          delete intervals[promise.$$intervalId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	
	      }, delay);
	
	      intervals[promise.$$intervalId] = deferred;
	
	      return promise;
	
	      function callback() {
	        if (!hasParams) {
	          fn(iteration);
	        } else {
	          fn.apply(null, args);
	        }
	      }
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $interval#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`.
	      *
	      * @param {Promise=} promise returned by the `$interval` function.
	      * @returns {boolean} Returns `true` if the task was successfully canceled.
	      */
	    interval.cancel = function(promise) {
	      if (promise && promise.$$intervalId in intervals) {
	        intervals[promise.$$intervalId].reject('canceled');
	        $window.clearInterval(promise.$$intervalId);
	        delete intervals[promise.$$intervalId];
	        return true;
	      }
	      return false;
	    };
	
	    return interval;
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various Angular components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	
	var PATH_MATCH = /^([^\?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = encodeUriSegment(segments[i]);
	  }
	
	  return segments.join('/');
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	
	function parseAppUrl(relativeUrl, locationObj) {
	  var prefixed = (relativeUrl.charAt(0) !== '/');
	  if (prefixed) {
	    relativeUrl = '/' + relativeUrl;
	  }
	  var match = urlResolve(relativeUrl);
	  locationObj.$$path = decodeURIComponent(prefixed && match.pathname.charAt(0) === '/' ?
	      match.pathname.substring(1) : match.pathname);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) != '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	function startsWith(haystack, needle) {
	  return haystack.lastIndexOf(needle, 0) === 0;
	}
	
	/**
	 *
	 * @param {string} base
	 * @param {string} url
	 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	 *                   the expected string.
	 */
	function stripBaseUrl(base, url) {
	  if (startsWith(url, base)) {
	    return url.substr(base.length);
	  }
	}
	
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index == -1 ? url : url.substr(0, index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/(#.+)|#$/, '$1');
	}
	
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents an url
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix url path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given html5 (regular) url string into properties
	   * @param {string} url HTML5 url
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = stripBaseUrl(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  /**
	   * Compose url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
	      prevAppUrl = appUrl;
	      if (isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
	        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile == url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents url
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang url into properties
	   * @param {string} url Hashbang url
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the url starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          this.replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of Angular, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (startsWith(url, base)) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  /**
	   * Compose hashbang url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) == stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents url
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase == stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    this.$$absUrl = appBase + hashPrefix + this.$$url;
	  };
	
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full url representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full url
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return url (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New url without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url)) {
	      return this.$$url;
	    }
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current url.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current url
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current url.
	   *
	   * Note: compared to the non-angular version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given url http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current url.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current url.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current url when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) == '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current url when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the url.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given url http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length) {
	      return this.$$state;
	    }
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return function(value) {
	    if (isUndefined(value)) {
	      return this[property];
	    }
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables url rewriting for relative links.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          "$location in HTML5 mode requires a <base> tag to be present!");
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!html5Mode.rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which == 2 || event.button == 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the angular application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() != $browser.url()) {
	            $rootScope.$apply();
	            // hack to work around FF6 bug 684208 when scenario runner clicks on links
	            $window.angular['ff-684208-preventDefault'] = true;
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if (trimEmptyHash($location.absUrl()) != trimEmptyHash(initialUrl)) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (isUndefined(stripBaseUrl(appBaseNoFile, newUrl))) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	        newUrl = trimEmptyHash(newUrl);
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      var oldUrl = trimEmptyHash($browser.url());
	      var newUrl = trimEmptyHash($location.absUrl());
	      var oldState = $browser.state();
	      var currentReplace = $location.$$replace;
	      var urlOrStateChanged = oldUrl !== newUrl ||
	        ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	      if (initializing || urlOrStateChanged) {
	        initializing = false;
	
	        $rootScope.$evalAsync(function() {
	          var newUrl = $location.absUrl();
	          var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	              $location.$$state, oldState).defaultPrevented;
	
	          // if the location was changed by a `$locationChangeStart` handler then stop
	          // processing this location change
	          if ($location.absUrl() !== newUrl) return;
	
	          if (defaultPrevented) {
	            $location.$$parse(oldUrl);
	            $location.$$state = oldState;
	          } else {
	            if (urlOrStateChanged) {
	              setBrowserUrlWithFallback(newUrl, currentReplace,
	                                        oldState === $location.$$state ? null : $location.$$state);
	            }
	            afterLocationChange(oldUrl, oldState);
	          }
	        });
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	    return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      }())
	    };
	
	    function formatError(arg) {
	      if (arg instanceof Error) {
	        if (arg.stack) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop,
	          hasApply = false;
	
	      // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
	      // The reason behind this is that console.log has type "object" in IE8...
	      try {
	        hasApply = !!logFn.apply;
	      } catch (e) {}
	
	      if (hasApply) {
	        return function() {
	          var args = [];
	          forEach(arguments, function(arg) {
	            args.push(formatError(arg));
	          });
	          return logFn.apply(console, args);
	        };
	      }
	
	      // we are IE which either doesn't have window.console => this is noop and we do nothing,
	      // or we are IE where console.log doesn't have apply so we log at least first 2 args
	      return function(arg1, arg2) {
	        logFn(arg1, arg2 == null ? '' : arg2);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	// Sandboxing Angular Expressions
	// ------------------------------
	// Angular expressions are generally considered safe because these expressions only have direct
	// access to `$scope` and locals. However, one can obtain the ability to execute arbitrary JS code by
	// obtaining a reference to native JS functions such as the Function constructor.
	//
	// As an example, consider the following Angular expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// This sandboxing technique is not perfect and doesn't aim to be. The goal is to prevent exploits
	// against the expression language, but not to prevent exploits that were enabled by exposing
	// sensitive JavaScript or browser APIs on Scope. Exposing such objects on a Scope is never a good
	// practice and therefore we are not even trying to protect against interaction with an object
	// explicitly exposed in this way.
	//
	// In general, it is not possible to access a Window object from an angular expression unless a
	// window or some DOM object that has a reference to window is published onto a Scope.
	// Similarly we prevent invocations of function known to be dangerous, as well as assignments to
	// native objects.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function ensureSafeMemberName(name, fullExpression) {
	  if (name === "__defineGetter__" || name === "__defineSetter__"
	      || name === "__lookupGetter__" || name === "__lookupSetter__"
	      || name === "__proto__") {
	    throw $parseMinErr('isecfld',
	        'Attempting to access a disallowed field in Angular expressions! '
	        + 'Expression: {0}', fullExpression);
	  }
	  return name;
	}
	
	function getStringValue(name) {
	  // Property names must be strings. This means that non-string objects cannot be used
	  // as keys in an object. Any non-string object, including a number, is typecasted
	  // into a string via the toString method.
	  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	  //
	  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	  // to a string. It's not always possible. If `name` is an object and its `toString` method is
	  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	  //
	  // TypeError: Cannot convert object to primitive value
	  //
	  // For performance reasons, we don't catch this error here and allow it to propagate up the call
	  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
	  // such a 'broken' object as a key.
	  return name + '';
	}
	
	function ensureSafeObject(obj, fullExpression) {
	  // nifty check if obj is Function that is fast and works across iframes and other contexts
	  if (obj) {
	    if (obj.constructor === obj) {
	      throw $parseMinErr('isecfn',
	          'Referencing Function in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// isWindow(obj)
	        obj.window === obj) {
	      throw $parseMinErr('isecwindow',
	          'Referencing the Window in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// isElement(obj)
	        obj.children && (obj.nodeName || (obj.prop && obj.attr && obj.find))) {
	      throw $parseMinErr('isecdom',
	          'Referencing DOM nodes in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    } else if (// block Object so that we can't get hold of dangerous Object.* methods
	        obj === Object) {
	      throw $parseMinErr('isecobj',
	          'Referencing Object in Angular expressions is disallowed! Expression: {0}',
	          fullExpression);
	    }
	  }
	  return obj;
	}
	
	var CALL = Function.prototype.call;
	var APPLY = Function.prototype.apply;
	var BIND = Function.prototype.bind;
	
	function ensureSafeFunction(obj, fullExpression) {
	  if (obj) {
	    if (obj.constructor === obj) {
	      throw $parseMinErr('isecfn',
	        'Referencing Function in Angular expressions is disallowed! Expression: {0}',
	        fullExpression);
	    } else if (obj === CALL || obj === APPLY || obj === BIND) {
	      throw $parseMinErr('isecff',
	        'Referencing call, apply or bind in Angular expressions is disallowed! Expression: {0}',
	        fullExpression);
	    }
	  }
	}
	
	function ensureSafeAssignContext(obj, fullExpression) {
	  if (obj) {
	    if (obj === (0).constructor || obj === (false).constructor || obj === ''.constructor ||
	        obj === {}.constructor || obj === [].constructor || obj === Function.constructor) {
	      throw $parseMinErr('isecaf',
	        'Assigning to a constructor is disallowed! Expression: {0}', fullExpression);
	    }
	  }
	}
	
	var OPERATORS = createMap();
	forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	var ESCAPE = {"n":"\n", "f":"\f", "r":"\r", "t":"\t", "v":"\v", "'":"'", '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === "'") {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdentifierStart(this.peekMultichar())) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === "string";
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdentifierStart: function(ch) {
	    return this.options.isIdentifierStart ?
	        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierStart(ch);
	  },
	
	  isValidIdentifierStart: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isIdentifierContinue: function(ch) {
	    return this.options.isIdentifierContinue ?
	        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierContinue(ch);
	  },
	
	  isValidIdentifierContinue: function(ch, cp) {
	    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
	  },
	
	  codePointAt: function(ch) {
	    if (ch.length === 1) return ch.charCodeAt(0);
	    /*jshint bitwise: false*/
	    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
	    /*jshint bitwise: true*/
	  },
	
	  peekMultichar: function() {
	    var ch = this.text.charAt(this.index);
	    var peek = this.peek();
	    if (!peek) {
	      return ch;
	    }
	    var cp1 = ch.charCodeAt(0);
	    var cp2 = peek.charCodeAt(0);
	    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
	      return ch + peek;
	    }
	    return ch;
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch == '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch == 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) == 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) == 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    this.index += this.peekMultichar().length;
	    while (this.index < this.text.length) {
	      var ch = this.peekMultichar();
	      if (!this.isIdentifierContinue(ch)) {
	        break;
	      }
	      this.index += ch.length;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i)) {
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          }
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	var AST = function(lexer, options) {
	  this.lexer = lexer;
	  this.options = options;
	};
	
	AST.Program = 'Program';
	AST.ExpressionStatement = 'ExpressionStatement';
	AST.AssignmentExpression = 'AssignmentExpression';
	AST.ConditionalExpression = 'ConditionalExpression';
	AST.LogicalExpression = 'LogicalExpression';
	AST.BinaryExpression = 'BinaryExpression';
	AST.UnaryExpression = 'UnaryExpression';
	AST.CallExpression = 'CallExpression';
	AST.MemberExpression = 'MemberExpression';
	AST.Identifier = 'Identifier';
	AST.Literal = 'Literal';
	AST.ArrayExpression = 'ArrayExpression';
	AST.Property = 'Property';
	AST.ObjectExpression = 'ObjectExpression';
	AST.ThisExpression = 'ThisExpression';
	AST.LocalsExpression = 'LocalsExpression';
	
	// Internal use only
	AST.NGValueParameter = 'NGValueParameter';
	
	AST.prototype = {
	  ast: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.program();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    return value;
	  },
	
	  program: function() {
	    var body = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        body.push(this.expressionStatement());
	      if (!this.expect(';')) {
	        return { type: AST.Program, body: body};
	      }
	    }
	  },
	
	  expressionStatement: function() {
	    return { type: AST.ExpressionStatement, expression: this.filterChain() };
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    var token;
	    while ((token = this.expect('|'))) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var result = this.ternary();
	    if (this.expect('=')) {
	      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	    }
	    return result;
	  },
	
	  ternary: function() {
	    var test = this.logicalOR();
	    var alternate;
	    var consequent;
	    if (this.expect('?')) {
	      alternate = this.expression();
	      if (this.consume(':')) {
	        consequent = this.expression();
	        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	      }
	    }
	    return test;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    while (this.expect('||')) {
	      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    while (this.expect('&&')) {
	      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if ((token = this.expect('+', '-', '!'))) {
	      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	    } else {
	      return this.primary();
	    }
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
	      primary = copy(this.selfReferential[this.consume().text]);
	    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
	      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	        this.consume(')');
	      } else if (next.text === '[') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	        this.consume(']');
	      } else if (next.text === '.') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  filter: function(baseExpression) {
	    var args = [baseExpression];
	    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	    while (this.expect(':')) {
	      args.push(this.expression());
	    }
	
	    return result;
	  },
	
	  parseArguments: function() {
	    var args = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        args.push(this.expression());
	      } while (this.expect(','));
	    }
	    return args;
	  },
	
	  identifier: function() {
	    var token = this.consume();
	    if (!token.identifier) {
	      this.throwError('is not a valid identifier', token);
	    }
	    return { type: AST.Identifier, name: token.text };
	  },
	
	  constant: function() {
	    // TODO check that it is a constant
	    return { type: AST.Literal, value: this.consume().value };
	  },
	
	  arrayDeclaration: function() {
	    var elements = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elements.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return { type: AST.ArrayExpression, elements: elements };
	  },
	
	  object: function() {
	    var properties = [], property;
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        property = {type: AST.Property, kind: 'init'};
	        if (this.peek().constant) {
	          property.key = this.constant();
	          property.computed = false;
	          this.consume(':');
	          property.value = this.expression();
	        } else if (this.peek().identifier) {
	          property.key = this.identifier();
	          property.computed = false;
	          if (this.peek(':')) {
	            this.consume(':');
	            property.value = this.expression();
	          } else {
	            property.value = property.key;
	          }
	        } else if (this.peek('[')) {
	          this.consume('[');
	          property.key = this.expression();
	          this.consume(']');
	          property.computed = true;
	          this.consume(':');
	          property.value = this.expression();
	        } else {
	          this.throwError("invalid key", this.peek());
	        }
	        properties.push(property);
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return {type: AST.ObjectExpression, properties: properties };
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	  selfReferential: {
	    'this': {type: AST.ThisExpression },
	    '$locals': {type: AST.LocalsExpression }
	  }
	};
	
	function ifDefined(v, d) {
	  return typeof v !== 'undefined' ? v : d;
	}
	
	function plusFn(l, r) {
	  if (typeof l === 'undefined') return r;
	  if (typeof r === 'undefined') return l;
	  return l + r;
	}
	
	function isStateless($filter, filterName) {
	  var fn = $filter(filterName);
	  return !fn.$stateful;
	}
	
	function findConstantAndWatchExpressions(ast, $filter) {
	  var allConstants;
	  var argsToWatch;
	  switch (ast.type) {
	  case AST.Program:
	    allConstants = true;
	    forEach(ast.body, function(expr) {
	      findConstantAndWatchExpressions(expr.expression, $filter);
	      allConstants = allConstants && expr.expression.constant;
	    });
	    ast.constant = allConstants;
	    break;
	  case AST.Literal:
	    ast.constant = true;
	    ast.toWatch = [];
	    break;
	  case AST.UnaryExpression:
	    findConstantAndWatchExpressions(ast.argument, $filter);
	    ast.constant = ast.argument.constant;
	    ast.toWatch = ast.argument.toWatch;
	    break;
	  case AST.BinaryExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	    break;
	  case AST.LogicalExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.ConditionalExpression:
	    findConstantAndWatchExpressions(ast.test, $filter);
	    findConstantAndWatchExpressions(ast.alternate, $filter);
	    findConstantAndWatchExpressions(ast.consequent, $filter);
	    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.Identifier:
	    ast.constant = false;
	    ast.toWatch = [ast];
	    break;
	  case AST.MemberExpression:
	    findConstantAndWatchExpressions(ast.object, $filter);
	    if (ast.computed) {
	      findConstantAndWatchExpressions(ast.property, $filter);
	    }
	    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	    ast.toWatch = [ast];
	    break;
	  case AST.CallExpression:
	    allConstants = ast.filter ? isStateless($filter, ast.callee.name) : false;
	    argsToWatch = [];
	    forEach(ast.arguments, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter);
	      allConstants = allConstants && expr.constant;
	      if (!expr.constant) {
	        argsToWatch.push.apply(argsToWatch, expr.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = ast.filter && isStateless($filter, ast.callee.name) ? argsToWatch : [ast];
	    break;
	  case AST.AssignmentExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = [ast];
	    break;
	  case AST.ArrayExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.elements, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter);
	      allConstants = allConstants && expr.constant;
	      if (!expr.constant) {
	        argsToWatch.push.apply(argsToWatch, expr.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ObjectExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.properties, function(property) {
	      findConstantAndWatchExpressions(property.value, $filter);
	      allConstants = allConstants && property.value.constant && !property.computed;
	      if (!property.value.constant) {
	        argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ThisExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  case AST.LocalsExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  }
	}
	
	function getInputs(body) {
	  if (body.length != 1) return;
	  var lastExpression = body[0].expression;
	  var candidate = lastExpression.toWatch;
	  if (candidate.length !== 1) return candidate;
	  return candidate[0] !== lastExpression ? candidate : undefined;
	}
	
	function isAssignable(ast) {
	  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	}
	
	function assignableAST(ast) {
	  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	  }
	}
	
	function isLiteral(ast) {
	  return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	}
	
	function isConstant(ast) {
	  return ast.constant;
	}
	
	function ASTCompiler(astBuilder, $filter) {
	  this.astBuilder = astBuilder;
	  this.$filter = $filter;
	}
	
	ASTCompiler.prototype = {
	  compile: function(expression, expensiveChecks) {
	    var self = this;
	    var ast = this.astBuilder.ast(expression);
	    this.state = {
	      nextId: 0,
	      filters: {},
	      expensiveChecks: expensiveChecks,
	      fn: {vars: [], body: [], own: {}},
	      assign: {vars: [], body: [], own: {}},
	      inputs: []
	    };
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var extra = '';
	    var assignable;
	    this.stage = 'assign';
	    if ((assignable = assignableAST(ast))) {
	      this.state.computing = 'assign';
	      var result = this.nextId();
	      this.recurse(assignable, result);
	      this.return_(result);
	      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	    }
	    var toWatch = getInputs(ast.body);
	    self.stage = 'inputs';
	    forEach(toWatch, function(watch, key) {
	      var fnKey = 'fn' + key;
	      self.state[fnKey] = {vars: [], body: [], own: {}};
	      self.state.computing = fnKey;
	      var intoId = self.nextId();
	      self.recurse(watch, intoId);
	      self.return_(intoId);
	      self.state.inputs.push(fnKey);
	      watch.watchId = key;
	    });
	    this.state.computing = 'fn';
	    this.stage = 'main';
	    this.recurse(ast);
	    var fnString =
	      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	      '"' + this.USE + ' ' + this.STRICT + '";\n' +
	      this.filterPrefix() +
	      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	      extra +
	      this.watchFns() +
	      'return fn;';
	
	    /* jshint -W054 */
	    var fn = (new Function('$filter',
	        'ensureSafeMemberName',
	        'ensureSafeObject',
	        'ensureSafeFunction',
	        'getStringValue',
	        'ensureSafeAssignContext',
	        'ifDefined',
	        'plus',
	        'text',
	        fnString))(
	          this.$filter,
	          ensureSafeMemberName,
	          ensureSafeObject,
	          ensureSafeFunction,
	          getStringValue,
	          ensureSafeAssignContext,
	          ifDefined,
	          plusFn,
	          expression);
	    /* jshint +W054 */
	    this.state = this.stage = undefined;
	    fn.literal = isLiteral(ast);
	    fn.constant = isConstant(ast);
	    return fn;
	  },
	
	  USE: 'use',
	
	  STRICT: 'strict',
	
	  watchFns: function() {
	    var result = [];
	    var fns = this.state.inputs;
	    var self = this;
	    forEach(fns, function(name) {
	      result.push('var ' + name + '=' + self.generateFunction(name, 's'));
	    });
	    if (fns.length) {
	      result.push('fn.inputs=[' + fns.join(',') + '];');
	    }
	    return result.join('');
	  },
	
	  generateFunction: function(name, params) {
	    return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	  },
	
	  filterPrefix: function() {
	    var parts = [];
	    var self = this;
	    forEach(this.state.filters, function(id, filter) {
	      parts.push(id + '=$filter(' + self.escape(filter) + ')');
	    });
	    if (parts.length) return 'var ' + parts.join(',') + ';';
	    return '';
	  },
	
	  varsPrefix: function(section) {
	    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	  },
	
	  body: function(section) {
	    return this.state[section].body.join('');
	  },
	
	  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var left, right, self = this, args, expression, computed;
	    recursionFn = recursionFn || noop;
	    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	      intoId = intoId || this.nextId();
	      this.if_('i',
	        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	      );
	      return;
	    }
	    switch (ast.type) {
	    case AST.Program:
	      forEach(ast.body, function(expression, pos) {
	        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	        if (pos !== ast.body.length - 1) {
	          self.current().body.push(right, ';');
	        } else {
	          self.return_(right);
	        }
	      });
	      break;
	    case AST.Literal:
	      expression = this.escape(ast.value);
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.UnaryExpression:
	      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.BinaryExpression:
	      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	      if (ast.operator === '+') {
	        expression = this.plus(left, right);
	      } else if (ast.operator === '-') {
	        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	      } else {
	        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	      }
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.LogicalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.left, intoId);
	      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.ConditionalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.test, intoId);
	      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.Identifier:
	      intoId = intoId || this.nextId();
	      if (nameId) {
	        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	        nameId.computed = false;
	        nameId.name = ast.name;
	      }
	      ensureSafeMemberName(ast.name);
	      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	        function() {
	          self.if_(self.stage === 'inputs' || 's', function() {
	            if (create && create !== 1) {
	              self.if_(
	                self.not(self.nonComputedMember('s', ast.name)),
	                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	            }
	            self.assign(intoId, self.nonComputedMember('s', ast.name));
	          });
	        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	        );
	      if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.name)) {
	        self.addEnsureSafeObject(intoId);
	      }
	      recursionFn(intoId);
	      break;
	    case AST.MemberExpression:
	      left = nameId && (nameId.context = this.nextId()) || this.nextId();
	      intoId = intoId || this.nextId();
	      self.recurse(ast.object, left, undefined, function() {
	        self.if_(self.notNull(left), function() {
	          if (create && create !== 1) {
	            self.addEnsureSafeAssignContext(left);
	          }
	          if (ast.computed) {
	            right = self.nextId();
	            self.recurse(ast.property, right);
	            self.getStringValue(right);
	            self.addEnsureSafeMemberName(right);
	            if (create && create !== 1) {
	              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	            }
	            expression = self.ensureSafeObject(self.computedMember(left, right));
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = true;
	              nameId.name = right;
	            }
	          } else {
	            ensureSafeMemberName(ast.property.name);
	            if (create && create !== 1) {
	              self.if_(self.not(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	            }
	            expression = self.nonComputedMember(left, ast.property.name);
	            if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.property.name)) {
	              expression = self.ensureSafeObject(expression);
	            }
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = false;
	              nameId.name = ast.property.name;
	            }
	          }
	        }, function() {
	          self.assign(intoId, 'undefined');
	        });
	        recursionFn(intoId);
	      }, !!create);
	      break;
	    case AST.CallExpression:
	      intoId = intoId || this.nextId();
	      if (ast.filter) {
	        right = self.filter(ast.callee.name);
	        args = [];
	        forEach(ast.arguments, function(expr) {
	          var argument = self.nextId();
	          self.recurse(expr, argument);
	          args.push(argument);
	        });
	        expression = right + '(' + args.join(',') + ')';
	        self.assign(intoId, expression);
	        recursionFn(intoId);
	      } else {
	        right = self.nextId();
	        left = {};
	        args = [];
	        self.recurse(ast.callee, right, left, function() {
	          self.if_(self.notNull(right), function() {
	            self.addEnsureSafeFunction(right);
	            forEach(ast.arguments, function(expr) {
	              self.recurse(expr, self.nextId(), undefined, function(argument) {
	                args.push(self.ensureSafeObject(argument));
	              });
	            });
	            if (left.name) {
	              if (!self.state.expensiveChecks) {
	                self.addEnsureSafeObject(left.context);
	              }
	              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	            } else {
	              expression = right + '(' + args.join(',') + ')';
	            }
	            expression = self.ensureSafeObject(expression);
	            self.assign(intoId, expression);
	          }, function() {
	            self.assign(intoId, 'undefined');
	          });
	          recursionFn(intoId);
	        });
	      }
	      break;
	    case AST.AssignmentExpression:
	      right = this.nextId();
	      left = {};
	      if (!isAssignable(ast.left)) {
	        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
	      }
	      this.recurse(ast.left, undefined, left, function() {
	        self.if_(self.notNull(left.context), function() {
	          self.recurse(ast.right, right);
	          self.addEnsureSafeObject(self.member(left.context, left.name, left.computed));
	          self.addEnsureSafeAssignContext(left.context);
	          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	          self.assign(intoId, expression);
	          recursionFn(intoId || expression);
	        });
	      }, 1);
	      break;
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        self.recurse(expr, self.nextId(), undefined, function(argument) {
	          args.push(argument);
	        });
	      });
	      expression = '[' + args.join(',') + ']';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.ObjectExpression:
	      args = [];
	      computed = false;
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          computed = true;
	        }
	      });
	      if (computed) {
	        intoId = intoId || this.nextId();
	        this.assign(intoId, '{}');
	        forEach(ast.properties, function(property) {
	          if (property.computed) {
	            left = self.nextId();
	            self.recurse(property.key, left);
	          } else {
	            left = property.key.type === AST.Identifier ?
	                       property.key.name :
	                       ('' + property.key.value);
	          }
	          right = self.nextId();
	          self.recurse(property.value, right);
	          self.assign(self.member(intoId, left, property.computed), right);
	        });
	      } else {
	        forEach(ast.properties, function(property) {
	          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
	            args.push(self.escape(
	                property.key.type === AST.Identifier ? property.key.name :
	                  ('' + property.key.value)) +
	                ':' + expr);
	          });
	        });
	        expression = '{' + args.join(',') + '}';
	        this.assign(intoId, expression);
	      }
	      recursionFn(intoId || expression);
	      break;
	    case AST.ThisExpression:
	      this.assign(intoId, 's');
	      recursionFn('s');
	      break;
	    case AST.LocalsExpression:
	      this.assign(intoId, 'l');
	      recursionFn('l');
	      break;
	    case AST.NGValueParameter:
	      this.assign(intoId, 'v');
	      recursionFn('v');
	      break;
	    }
	  },
	
	  getHasOwnProperty: function(element, property) {
	    var key = element + '.' + property;
	    var own = this.current().own;
	    if (!own.hasOwnProperty(key)) {
	      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	    }
	    return own[key];
	  },
	
	  assign: function(id, value) {
	    if (!id) return;
	    this.current().body.push(id, '=', value, ';');
	    return id;
	  },
	
	  filter: function(filterName) {
	    if (!this.state.filters.hasOwnProperty(filterName)) {
	      this.state.filters[filterName] = this.nextId(true);
	    }
	    return this.state.filters[filterName];
	  },
	
	  ifDefined: function(id, defaultValue) {
	    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	  },
	
	  plus: function(left, right) {
	    return 'plus(' + left + ',' + right + ')';
	  },
	
	  return_: function(id) {
	    this.current().body.push('return ', id, ';');
	  },
	
	  if_: function(test, alternate, consequent) {
	    if (test === true) {
	      alternate();
	    } else {
	      var body = this.current().body;
	      body.push('if(', test, '){');
	      alternate();
	      body.push('}');
	      if (consequent) {
	        body.push('else{');
	        consequent();
	        body.push('}');
	      }
	    }
	  },
	
	  not: function(expression) {
	    return '!(' + expression + ')';
	  },
	
	  notNull: function(expression) {
	    return expression + '!=null';
	  },
	
	  nonComputedMember: function(left, right) {
	    var SAFE_IDENTIFIER = /[$_a-zA-Z][$_a-zA-Z0-9]*/;
	    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
	    if (SAFE_IDENTIFIER.test(right)) {
	      return left + '.' + right;
	    } else {
	      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
	    }
	  },
	
	  computedMember: function(left, right) {
	    return left + '[' + right + ']';
	  },
	
	  member: function(left, right, computed) {
	    if (computed) return this.computedMember(left, right);
	    return this.nonComputedMember(left, right);
	  },
	
	  addEnsureSafeObject: function(item) {
	    this.current().body.push(this.ensureSafeObject(item), ';');
	  },
	
	  addEnsureSafeMemberName: function(item) {
	    this.current().body.push(this.ensureSafeMemberName(item), ';');
	  },
	
	  addEnsureSafeFunction: function(item) {
	    this.current().body.push(this.ensureSafeFunction(item), ';');
	  },
	
	  addEnsureSafeAssignContext: function(item) {
	    this.current().body.push(this.ensureSafeAssignContext(item), ';');
	  },
	
	  ensureSafeObject: function(item) {
	    return 'ensureSafeObject(' + item + ',text)';
	  },
	
	  ensureSafeMemberName: function(item) {
	    return 'ensureSafeMemberName(' + item + ',text)';
	  },
	
	  ensureSafeFunction: function(item) {
	    return 'ensureSafeFunction(' + item + ',text)';
	  },
	
	  getStringValue: function(item) {
	    this.assign(item, 'getStringValue(' + item + ')');
	  },
	
	  ensureSafeAssignContext: function(item) {
	    return 'ensureSafeAssignContext(' + item + ',text)';
	  },
	
	  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var self = this;
	    return function() {
	      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	    };
	  },
	
	  lazyAssign: function(id, value) {
	    var self = this;
	    return function() {
	      self.assign(id, value);
	    };
	  },
	
	  stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	  stringEscapeFn: function(c) {
	    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	  },
	
	  escape: function(value) {
	    if (isString(value)) return "'" + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + "'";
	    if (isNumber(value)) return value.toString();
	    if (value === true) return 'true';
	    if (value === false) return 'false';
	    if (value === null) return 'null';
	    if (typeof value === 'undefined') return 'undefined';
	
	    throw $parseMinErr('esc', 'IMPOSSIBLE');
	  },
	
	  nextId: function(skip, init) {
	    var id = 'v' + (this.state.nextId++);
	    if (!skip) {
	      this.current().vars.push(id + (init ? '=' + init : ''));
	    }
	    return id;
	  },
	
	  current: function() {
	    return this.state[this.state.computing];
	  }
	};
	
	
	function ASTInterpreter(astBuilder, $filter) {
	  this.astBuilder = astBuilder;
	  this.$filter = $filter;
	}
	
	ASTInterpreter.prototype = {
	  compile: function(expression, expensiveChecks) {
	    var self = this;
	    var ast = this.astBuilder.ast(expression);
	    this.expression = expression;
	    this.expensiveChecks = expensiveChecks;
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var assignable;
	    var assign;
	    if ((assignable = assignableAST(ast))) {
	      assign = this.recurse(assignable);
	    }
	    var toWatch = getInputs(ast.body);
	    var inputs;
	    if (toWatch) {
	      inputs = [];
	      forEach(toWatch, function(watch, key) {
	        var input = self.recurse(watch);
	        watch.input = input;
	        inputs.push(input);
	        watch.watchId = key;
	      });
	    }
	    var expressions = [];
	    forEach(ast.body, function(expression) {
	      expressions.push(self.recurse(expression.expression));
	    });
	    var fn = ast.body.length === 0 ? noop :
	             ast.body.length === 1 ? expressions[0] :
	             function(scope, locals) {
	               var lastValue;
	               forEach(expressions, function(exp) {
	                 lastValue = exp(scope, locals);
	               });
	               return lastValue;
	             };
	    if (assign) {
	      fn.assign = function(scope, value, locals) {
	        return assign(scope, locals, value);
	      };
	    }
	    if (inputs) {
	      fn.inputs = inputs;
	    }
	    fn.literal = isLiteral(ast);
	    fn.constant = isConstant(ast);
	    return fn;
	  },
	
	  recurse: function(ast, context, create) {
	    var left, right, self = this, args, expression;
	    if (ast.input) {
	      return this.inputs(ast.input, ast.watchId);
	    }
	    switch (ast.type) {
	    case AST.Literal:
	      return this.value(ast.value, context);
	    case AST.UnaryExpression:
	      right = this.recurse(ast.argument);
	      return this['unary' + ast.operator](right, context);
	    case AST.BinaryExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.LogicalExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.ConditionalExpression:
	      return this['ternary?:'](
	        this.recurse(ast.test),
	        this.recurse(ast.alternate),
	        this.recurse(ast.consequent),
	        context
	      );
	    case AST.Identifier:
	      ensureSafeMemberName(ast.name, self.expression);
	      return self.identifier(ast.name,
	                             self.expensiveChecks || isPossiblyDangerousMemberName(ast.name),
	                             context, create, self.expression);
	    case AST.MemberExpression:
	      left = this.recurse(ast.object, false, !!create);
	      if (!ast.computed) {
	        ensureSafeMemberName(ast.property.name, self.expression);
	        right = ast.property.name;
	      }
	      if (ast.computed) right = this.recurse(ast.property);
	      return ast.computed ?
	        this.computedMember(left, right, context, create, self.expression) :
	        this.nonComputedMember(left, right, self.expensiveChecks, context, create, self.expression);
	    case AST.CallExpression:
	      args = [];
	      forEach(ast.arguments, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      if (ast.filter) right = this.$filter(ast.callee.name);
	      if (!ast.filter) right = this.recurse(ast.callee, true);
	      return ast.filter ?
	        function(scope, locals, assign, inputs) {
	          var values = [];
	          for (var i = 0; i < args.length; ++i) {
	            values.push(args[i](scope, locals, assign, inputs));
	          }
	          var value = right.apply(undefined, values, inputs);
	          return context ? {context: undefined, name: undefined, value: value} : value;
	        } :
	        function(scope, locals, assign, inputs) {
	          var rhs = right(scope, locals, assign, inputs);
	          var value;
	          if (rhs.value != null) {
	            ensureSafeObject(rhs.context, self.expression);
	            ensureSafeFunction(rhs.value, self.expression);
	            var values = [];
	            for (var i = 0; i < args.length; ++i) {
	              values.push(ensureSafeObject(args[i](scope, locals, assign, inputs), self.expression));
	            }
	            value = ensureSafeObject(rhs.value.apply(rhs.context, values), self.expression);
	          }
	          return context ? {value: value} : value;
	        };
	    case AST.AssignmentExpression:
	      left = this.recurse(ast.left, true, 1);
	      right = this.recurse(ast.right);
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        ensureSafeObject(lhs.value, self.expression);
	        ensureSafeAssignContext(lhs.context);
	        lhs.context[lhs.name] = rhs;
	        return context ? {value: rhs} : rhs;
	      };
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = [];
	        for (var i = 0; i < args.length; ++i) {
	          value.push(args[i](scope, locals, assign, inputs));
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          args.push({key: self.recurse(property.key),
	                     computed: true,
	                     value: self.recurse(property.value)
	          });
	        } else {
	          args.push({key: property.key.type === AST.Identifier ?
	                          property.key.name :
	                          ('' + property.key.value),
	                     computed: false,
	                     value: self.recurse(property.value)
	          });
	        }
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = {};
	        for (var i = 0; i < args.length; ++i) {
	          if (args[i].computed) {
	            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
	          } else {
	            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	          }
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ThisExpression:
	      return function(scope) {
	        return context ? {value: scope} : scope;
	      };
	    case AST.LocalsExpression:
	      return function(scope, locals) {
	        return context ? {value: locals} : locals;
	      };
	    case AST.NGValueParameter:
	      return function(scope, locals, assign) {
	        return context ? {value: assign} : assign;
	      };
	    }
	  },
	
	  'unary+': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = +arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary-': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = -arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary!': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = !argument(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary+': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = plusFn(lhs, rhs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary-': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary*': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary/': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary%': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary===': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary&&': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary||': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'ternary?:': function(test, alternate, consequent, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  value: function(value, context) {
	    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	  },
	  identifier: function(name, expensiveChecks, context, create, expression) {
	    return function(scope, locals, assign, inputs) {
	      var base = locals && (name in locals) ? locals : scope;
	      if (create && create !== 1 && base && !(base[name])) {
	        base[name] = {};
	      }
	      var value = base ? base[name] : undefined;
	      if (expensiveChecks) {
	        ensureSafeObject(value, expression);
	      }
	      if (context) {
	        return {context: base, name: name, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  computedMember: function(left, right, context, create, expression) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs;
	      var value;
	      if (lhs != null) {
	        rhs = right(scope, locals, assign, inputs);
	        rhs = getStringValue(rhs);
	        ensureSafeMemberName(rhs, expression);
	        if (create && create !== 1) {
	          ensureSafeAssignContext(lhs);
	          if (lhs && !(lhs[rhs])) {
	            lhs[rhs] = {};
	          }
	        }
	        value = lhs[rhs];
	        ensureSafeObject(value, expression);
	      }
	      if (context) {
	        return {context: lhs, name: rhs, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  nonComputedMember: function(left, right, expensiveChecks, context, create, expression) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      if (create && create !== 1) {
	        ensureSafeAssignContext(lhs);
	        if (lhs && !(lhs[right])) {
	          lhs[right] = {};
	        }
	      }
	      var value = lhs != null ? lhs[right] : undefined;
	      if (expensiveChecks || isPossiblyDangerousMemberName(right)) {
	        ensureSafeObject(value, expression);
	      }
	      if (context) {
	        return {context: lhs, name: right, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  inputs: function(input, watchId) {
	    return function(scope, value, locals, inputs) {
	      if (inputs) return inputs[watchId];
	      return input(scope, value, locals);
	    };
	  }
	};
	
	/**
	 * @constructor
	 */
	var Parser = function(lexer, $filter, options) {
	  this.lexer = lexer;
	  this.$filter = $filter;
	  this.options = options;
	  this.ast = new AST(lexer, options);
	  this.astCompiler = options.csp ? new ASTInterpreter(this.ast, $filter) :
	                                   new ASTCompiler(this.ast, $filter);
	};
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    return this.astCompiler.compile(text, this.options.expensiveChecks);
	  }
	};
	
	function isPossiblyDangerousMemberName(name) {
	  return name == 'constructor';
	}
	
	var objectValueOf = Object.prototype.valueOf;
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts Angular {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'angular'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('angular');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cacheDefault = createMap();
	  var cacheExpensive = createMap();
	  var literals = {
	    'true': true,
	    'false': false,
	    'null': null,
	    'undefined': undefined
	  };
	  var identStart, identContinue;
	
	  /**
	   * @ngdoc method
	   * @name $parseProvider#addLiteral
	   * @description
	   *
	   * Configure $parse service to add literal values that will be present as literal at expressions.
	   *
	   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	   *
	   **/
	  this.addLiteral = function(literalName, literalValue) {
	    literals[literalName] = literalValue;
	  };
	
	 /**
	  * @ngdoc method
	  * @name $parseProvider#setIdentifierFns
	  * @description
	  *
	  * Allows defining the set of characters that are allowed in Angular expressions. The function
	  * `identifierStart` will get called to know if a given character is a valid character to be the
	  * first character for an identifier. The function `identifierContinue` will get called to know if
	  * a given character is a valid character to be a follow-up identifier character. The functions
	  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	  * mind that the `string` parameter can be two characters long depending on the character
	  * representation. It is expected for the function to return `true` or `false`, whether that
	  * character is allowed or not.
	  *
	  * Since this function will be called extensivelly, keep the implementation of these functions fast,
	  * as the performance of these functions have a direct impact on the expressions parsing speed.
	  *
	  * @param {function=} identifierStart The function that will decide whether the given character is
	  *   a valid identifier start character.
	  * @param {function=} identifierContinue The function that will decide whether the given character is
	  *   a valid identifier continue character.
	  */
	  this.setIdentifierFns = function(identifierStart, identifierContinue) {
	    identStart = identifierStart;
	    identContinue = identifierContinue;
	    return this;
	  };
	
	  this.$get = ['$filter', function($filter) {
	    var noUnsafeEval = csp().noUnsafeEval;
	    var $parseOptions = {
	          csp: noUnsafeEval,
	          expensiveChecks: false,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        },
	        $parseOptionsExpensive = {
	          csp: noUnsafeEval,
	          expensiveChecks: true,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        };
	    var runningChecksEnabled = false;
	
	    $parse.$$runningExpensiveChecks = function() {
	      return runningChecksEnabled;
	    };
	
	    return $parse;
	
	    function $parse(exp, interceptorFn, expensiveChecks) {
	      var parsedExpression, oneTime, cacheKey;
	
	      expensiveChecks = expensiveChecks || runningChecksEnabled;
	
	      switch (typeof exp) {
	        case 'string':
	          exp = exp.trim();
	          cacheKey = exp;
	
	          var cache = (expensiveChecks ? cacheExpensive : cacheDefault);
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	              oneTime = true;
	              exp = exp.substring(2);
	            }
	            var parseOptions = expensiveChecks ? $parseOptionsExpensive : $parseOptions;
	            var lexer = new Lexer(parseOptions);
	            var parser = new Parser(lexer, $filter, parseOptions);
	            parsedExpression = parser.parse(exp);
	            if (parsedExpression.constant) {
	              parsedExpression.$$watchDelegate = constantWatchDelegate;
	            } else if (oneTime) {
	              parsedExpression.$$watchDelegate = parsedExpression.literal ?
	                  oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
	            } else if (parsedExpression.inputs) {
	              parsedExpression.$$watchDelegate = inputsWatchDelegate;
	            }
	            if (expensiveChecks) {
	              parsedExpression = expensiveChecksInterceptor(parsedExpression);
	            }
	            cache[cacheKey] = parsedExpression;
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return addInterceptor(noop, interceptorFn);
	      }
	    }
	
	    function expensiveChecksInterceptor(fn) {
	      if (!fn) return fn;
	      expensiveCheckFn.$$watchDelegate = fn.$$watchDelegate;
	      expensiveCheckFn.assign = expensiveChecksInterceptor(fn.assign);
	      expensiveCheckFn.constant = fn.constant;
	      expensiveCheckFn.literal = fn.literal;
	      for (var i = 0; fn.inputs && i < fn.inputs.length; ++i) {
	        fn.inputs[i] = expensiveChecksInterceptor(fn.inputs[i]);
	      }
	      expensiveCheckFn.inputs = fn.inputs;
	
	      return expensiveCheckFn;
	
	      function expensiveCheckFn(scope, locals, assign, inputs) {
	        var expensiveCheckOldValue = runningChecksEnabled;
	        runningChecksEnabled = true;
	        try {
	          return fn(scope, locals, assign, inputs);
	        } finally {
	          runningChecksEnabled = expensiveCheckOldValue;
	        }
	      }
	    }
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object') {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var inputExpressions = parsedExpression.inputs;
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf)) {
	            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	            oldInputValueOf = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      var oldInputValueOfValues = [];
	      var oldInputValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        oldInputValues[i] = null;
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i]))) {
	            oldInputValues[i] = newInputValue;
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	        }
	
	        return lastResult;
	      }, listener, objectEquality, prettyPrintExpression);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch, lastValue;
	      return unwatch = scope.$watch(function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }, function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener.apply(this, arguments);
	        }
	        if (isDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isDefined(lastValue)) {
	              unwatch();
	            }
	          });
	        }
	      }, objectEquality);
	    }
	
	    function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch, lastValue;
	      return unwatch = scope.$watch(function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }, function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener.call(this, value, old, scope);
	        }
	        if (isAllDefined(value)) {
	          scope.$$postDigest(function() {
	            if (isAllDefined(lastValue)) unwatch();
	          });
	        }
	      }, objectEquality);
	
	      function isAllDefined(value) {
	        var allDefined = true;
	        forEach(value, function(val) {
	          if (!isDefined(val)) allDefined = false;
	        });
	        return allDefined;
	      }
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch;
	      return unwatch = scope.$watch(function constantWatch(scope) {
	        unwatch();
	        return parsedExpression(scope);
	      }, listener, objectEquality);
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	      var watchDelegate = parsedExpression.$$watchDelegate;
	      var useInputs = false;
	
	      var regularWatch =
	          watchDelegate !== oneTimeLiteralWatchDelegate &&
	          watchDelegate !== oneTimeWatchDelegate;
	
	      var fn = regularWatch ? function regularInterceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        return interceptorFn(value, scope, locals);
	      } : function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
	        var value = parsedExpression(scope, locals, assign, inputs);
	        var result = interceptorFn(value, scope, locals);
	        // we only return the interceptor's result if the
	        // initial value is defined (for bind-once)
	        return isDefined(value) ? result : value;
	      };
	
	      // Propagate $$watchDelegates other then inputsWatchDelegate
	      if (parsedExpression.$$watchDelegate &&
	          parsedExpression.$$watchDelegate !== inputsWatchDelegate) {
	        fn.$$watchDelegate = parsedExpression.$$watchDelegate;
	      } else if (!interceptorFn.$stateful) {
	        // If there is an interceptor, but no watchDelegate then treat the interceptor like
	        // we treat filters - it is assumed to be a pure function unless flagged with $stateful
	        fn.$$watchDelegate = inputsWatchDelegate;
	        useInputs = !parsedExpression.inputs;
	        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	      }
	
	      return fn;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is an implementation of promises/deferred objects inspired by
	 * [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * # $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * # The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * # The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, errorCallback, notifyCallback)` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * # Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * # Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in angular, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 * # Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	function $QProvider() {
	
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler);
	  }];
	}
	
	function $$QProvider() {
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler);
	  }];
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler) {
	  var $qMinErr = minErr('$q', TypeError);
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  var defer = function() {
	    var d = new Deferred();
	    //Necessary to support unbound execution :/
	    d.resolve = simpleBind(d, d.resolve);
	    d.reject = simpleBind(d, d.reject);
	    d.notify = simpleBind(d, d.notify);
	    return d;
	  };
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  extend(Promise.prototype, {
	    then: function(onFulfilled, onRejected, progressBack) {
	      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	        return this;
	      }
	      var result = new Deferred();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result.promise;
	    },
	
	    "catch": function(callback) {
	      return this.then(null, callback);
	    },
	
	    "finally": function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, true, callback);
	      }, function(error) {
	        return handleCallback(error, false, callback);
	      }, progressBack);
	    }
	  });
	
	  //Faster, more basic than angular.bind http://jsperf.com/angular-bind-vs-custom-vs-native
	  function simpleBind(context, fn) {
	    return function(value) {
	      fn.call(context, value);
	    };
	  }
	
	  function processQueue(state) {
	    var fn, deferred, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    for (var i = 0, ii = pending.length; i < ii; ++i) {
	      deferred = pending[i][0];
	      fn = pending[i][state.status];
	      try {
	        if (isFunction(fn)) {
	          deferred.resolve(fn(state.value));
	        } else if (state.status === 1) {
	          deferred.resolve(state.value);
	        } else {
	          deferred.reject(state.value);
	        }
	      } catch (e) {
	        deferred.reject(e);
	        exceptionHandler(e);
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function Deferred() {
	    this.promise = new Promise();
	  }
	
	  extend(Deferred.prototype, {
	    resolve: function(val) {
	      if (this.promise.$$state.status) return;
	      if (val === this.promise) {
	        this.$$reject($qMinErr(
	          'qcycle',
	          "Expected promise to be resolved with value other than itself '{0}'",
	          val));
	      } else {
	        this.$$resolve(val);
	      }
	
	    },
	
	    $$resolve: function(val) {
	      var then;
	      var that = this;
	      var done = false;
	      try {
	        if ((isObject(val) || isFunction(val))) then = val && val.then;
	        if (isFunction(then)) {
	          this.promise.$$state.status = -1;
	          then.call(val, resolvePromise, rejectPromise, simpleBind(this, this.notify));
	        } else {
	          this.promise.$$state.value = val;
	          this.promise.$$state.status = 1;
	          scheduleProcessQueue(this.promise.$$state);
	        }
	      } catch (e) {
	        rejectPromise(e);
	        exceptionHandler(e);
	      }
	
	      function resolvePromise(val) {
	        if (done) return;
	        done = true;
	        that.$$resolve(val);
	      }
	      function rejectPromise(val) {
	        if (done) return;
	        done = true;
	        that.$$reject(val);
	      }
	    },
	
	    reject: function(reason) {
	      if (this.promise.$$state.status) return;
	      this.$$reject(reason);
	    },
	
	    $$reject: function(reason) {
	      this.promise.$$state.value = reason;
	      this.promise.$$state.status = 2;
	      scheduleProcessQueue(this.promise.$$state);
	    },
	
	    notify: function(progress) {
	      var callbacks = this.promise.$$state.pending;
	
	      if ((this.promise.$$state.status <= 0) && callbacks && callbacks.length) {
	        nextTick(function() {
	          var callback, result;
	          for (var i = 0, ii = callbacks.length; i < ii; i++) {
	            result = callbacks[i][0];
	            callback = callbacks[i][3];
	            try {
	              result.notify(isFunction(callback) ? callback(progress) : progress);
	            } catch (e) {
	              exceptionHandler(e);
	            }
	          }
	        });
	      }
	    }
	  });
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  var reject = function(reason) {
	    var result = new Deferred();
	    result.reject(reason);
	    return result.promise;
	  };
	
	  var makePromise = function makePromise(value, resolved) {
	    var result = new Deferred();
	    if (resolved) {
	      result.resolve(value);
	    } else {
	      result.reject(value);
	    }
	    return result.promise;
	  };
	
	  var handleCallback = function handleCallback(value, isResolved, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return makePromise(e, false);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return makePromise(value, isResolved);
	      }, function(error) {
	        return makePromise(error, false);
	      });
	    } else {
	      return makePromise(value, isResolved);
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  var when = function(value, callback, errback, progressBack) {
	    var result = new Deferred();
	    result.resolve(value);
	    return result.promise.then(callback, errback, progressBack);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	  var resolve = when;
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var deferred = new Deferred(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        if (results.hasOwnProperty(key)) return;
	        results[key] = value;
	        if (!(--counter)) deferred.resolve(results);
	      }, function(reason) {
	        if (results.hasOwnProperty(key)) return;
	        deferred.reject(reason);
	      });
	    });
	
	    if (counter === 0) {
	      deferred.resolve(results);
	    }
	
	    return deferred.promise;
	  }
	
	  var $Q = function Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', "Expected resolverFn, got '{0}'", resolver);
	    }
	
	    var deferred = new Deferred();
	
	    function resolveFn(value) {
	      deferred.resolve(value);
	    }
	
	    function rejectFn(reason) {
	      deferred.reject(reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return deferred.promise;
	  };
	
	  // Let's make the instanceof operator work for promises, so that
	  // `new $q(fn) instanceof $q` would evaluate to true.
	  $Q.prototype = Promise.prototype;
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.resolve = resolve;
	  $Q.all = all;
	
	  return $Q;
	}
	
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var raf = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    raf.supported = rafSupported;
	
	    return raf;
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$exceptionHandler', '$parse', '$browser',
	      function($exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    function cleanUpScope($scope) {
	
	      if (msie === 9) {
	        // There is a memory leak in IE9 if all child scopes are not disconnected
	        // completely when a scope is destroyed. So this code will recurse up through
	        // all this scopes children
	        //
	        // See issue https://github.com/angular/angular.js/issues/10706
	        $scope.$$childHead && cleanUpScope($scope.$$childHead);
	        $scope.$$nextSibling && cleanUpScope($scope.$$nextSibling);
	      }
	
	      // The code below works around IE9 and V8's memory leaks
	      //
	      // See:
	      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
	          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * # Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent != this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * # Example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	        var get = $parse(watchExp);
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, listener, objectEquality, get, watchExp);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: listener,
	              last: initWatchVal,
	              get: get,
	              exp: prettyPrintExpression || watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!isFunction(listener)) {
	          watcher.fn = noop;
	        }
	
	        if (!array) {
	          array = scope.$$watchers = [];
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	        incrementWatchersCount(this, 1);
	
	        return function deregisterWatch() {
	          if (arrayRemove(array, watcher) >= 0) {
	            incrementWatchersCount(scope, -1);
	          }
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via standard $watch operation and are examined on every
	       *   call to $digest() to see if any items changes.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
	            newValues[i] = value;
	            oldValues[i] = oldValue;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          if (firstRun) {
	            firstRun = false;
	            listener(newValues, newValues, self);
	          } else {
	            listener(newValues, oldValues, self);
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * # Example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        $watchCollectionInterceptor.$stateful = true;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (hasOwnProperty.call(newValue, key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!hasOwnProperty.call(newValue, key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * # Example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last, fn, get,
	            watchers,
	            length,
	            dirty, ttl = TTL,
	            next, current, target = this,
	            watchLog = [],
	            logIdx, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
	          // be reentered recursively. Calling $digest from a function passed to $applyAsync would
	          // lead to a '$digest already in progress' error.
	          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
	            try {
	              asyncTask = asyncQueue[asyncQueuePosition];
	              asyncTask.scope.$eval(asyncTask.expression, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	          asyncQueue.length = 0;
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = current.$$watchers)) {
	              // process our watches
	              length = watchers.length;
	              while (length--) {
	                try {
	                  watch = watchers[length];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    get = watch.get;
	                    if ((value = get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (typeof value === 'number' && typeof last === 'number'
	                               && isNaN(value) && isNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      fn = watch.fn;
	                      fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            if (!(next = ((current.$$watchersCount && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	        while (postDigestQueuePosition < postDigestQueue.length) {
	          try {
	            postDigestQueue[postDigestQueuePosition++]();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	        postDigestQueue.length = postDigestQueuePosition = 0;
	      },
	
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // We can't destroy a scope that has been already destroyed.
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	
	        if (this === $rootScope) {
	          //Remove handlers attached to window when $rootScope is removed
	          $browser.$$applicationDestroyed();
	        }
	
	        incrementWatchersCount(this, -this.$$watchersCount);
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent && parent.$$childHead == this) parent.$$childHead = this.$$nextSibling;
	        if (parent && parent.$$childTail == this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	        this.$$nextSibling = null;
	        cleanUpScope(this);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating Angular
	       * expressions.
	       *
	       * # Example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          });
	        }
	
	        asyncQueue.push({scope: this, expression: $parse(expr), locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in angular from outside of the angular
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the angular framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * ## Life cycle
	       *
	       * # Pseudo-Code of `$apply()`
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          try {
	            return this.$eval(expr);
	          } finally {
	            clearPhase();
	          }
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        expr && applyAsyncQueue.push($applyAsyncExpression);
	        expr = $parse(expr);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            namedListeners[indexOfListener] = null;
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            event.currentScope = null;
	            return event;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    var postDigestQueuePosition = 0;
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	    function incrementWatchersCount(current, count) {
	      do {
	        current.$$watchersCount += count;
	      } while ((current = current.$parent));
	    }
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        });
	      }
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of Angular application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */
	
	
	// the implementation is in angular.bootstrap
	
	/**
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	  var aHrefSanitizationWhitelist = /^\s*(https?|ftp|mailto|tel|file):/,
	    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationWhitelist = regexp;
	      return this;
	    }
	    return aHrefSanitizationWhitelist;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationWhitelist = regexp;
	      return this;
	    }
	    return imgSrcSanitizationWhitelist;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isImage) {
	      var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
	      var normalizedVal;
	      normalizedVal = urlResolve(uri).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  HTML: 'html',
	  CSS: 'css',
	  URL: 'url',
	  // RESOURCE_URL is a subtype of URL used in contexts where a privileged resource is sourced from a
	  // url.  (e.g. ng-include, script src, templateUrl)
	  RESOURCE_URL: 'resourceUrl',
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace('\\*\\*', '.*').
	                  replace('\\*', '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
	 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate} service.  This allows one to get/set the whitelists and blacklists used to ensure
	 * that the URLs used for sourcing Angular templates are safe.  Refer {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist} and
	 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 *
	 * For the general details about this service in Angular, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`,  `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.resourceUrlWhitelist([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
	 *    $sceDelegateProvider.resourceUrlBlacklist([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var resourceUrlWhitelist = ['self'],
	      resourceUrlBlacklist = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
	   *    provided.  This must be an array or null.  A snapshot of this array is used so further
	   *    changes to the array are ignored.
	   *
	   *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *    allowed in this array.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** an empty whitelist array will block all URLs!
	   *    </div>
	   *
	   * @return {Array} the currently set whitelist array.
	   *
	   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
	   * same origin resource requests.
	   *
	   * @description
	   * Sets/Gets the whitelist of trusted resource URLs.
	   */
	  this.resourceUrlWhitelist = function(value) {
	    if (arguments.length) {
	      resourceUrlWhitelist = adjustMatchers(value);
	    }
	    return resourceUrlWhitelist;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
	   *    provided.  This must be an array or null.  A snapshot of this array is used so further
	   *    changes to the array are ignored.
	   *
	   *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *    allowed in this array.
	   *
	   *    The typical usage for the blacklist is to **block
	   *    [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *    these would otherwise be trusted but actually return content from the redirected domain.
	   *
	   *    Finally, **the blacklist overrides the whitelist** and has the final say.
	   *
	   * @return {Array} the currently set blacklist array.
	   *
	   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
	   * is no blacklist.)
	   *
	   * @description
	   * Sets/Gets the blacklist of trusted resource URLs.
	   */
	
	  this.resourceUrlBlacklist = function(value) {
	    if (arguments.length) {
	      resourceUrlBlacklist = adjustMatchers(value);
	    }
	    return resourceUrlBlacklist;
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the whitelist allows this url.
	      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
	        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the blacklist blocked this url.
	        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
	          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns an object that is trusted by angular for use in specified strict
	     * contextual escaping contexts (such as ng-bind-html, ng-include, any src
	     * attribute interpolation, any dom event binding attribute interpolation
	     * such as for onclick,  etc.) that uses the provided value.
	     * See {@link ng.$sce $sce} for enabling strict contextual escaping.
	     *
	     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
	     *   resourceUrl, html, js and css.
	     * @param {*} value The value that that should be considered trusted/safe.
	     * @returns {*} A value that can be used to stand in for the provided `value` in places
	     * where Angular expects a $sce.trustAs() return value.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, returns it as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *      call or anything else.
	     * @returns {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Takes the result of a {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call and
	     * returns the originally supplied value if the queried context type is a supertype of the
	     * created type.  If this condition isn't satisfied, throws an exception.
	     *
	     * <div class="alert alert-danger">
	     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
	     * (XSS) vulnerability in your application.
	     * </div>
	     *
	     * @param {string} type The kind of context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call.
	     * @returns {*} The value the was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if valid in this context.  Otherwise, throws an exception.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	      // If we get here, then we may only take one of two actions.
	      // 1. sanitize the value for the requested type, or
	      // 2. throw an exception.
	      if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        return htmlSanitizer(maybeTrusted);
	      }
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/* jshint maxlen: false*/
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * # Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS requires bindings in certain
	 * contexts to result in a value that is marked as safe to use for that context.  One example of
	 * such a context is binding arbitrary html controlled by the user via `ng-bind-html`.  We refer
	 * to these contexts as privileged or SCE contexts.
	 *
	 * As of version 1.2, Angular ships with SCE enabled by default.
	 *
	 * Note:  When enabled (the default), IE<11 in quirks mode is not supported.  In this mode, IE<11 allow
	 * one to execute arbitrary javascript by the use of the expression() syntax.  Refer
	 * <http://blogs.msdn.com/b/ie/archive/2008/10/16/ending-expressions.aspx> to learn more about them.
	 * You can ensure your document is in standards mode and not quirks mode by adding `<!doctype html>`
	 * to the top of your HTML document.
	 *
	 * SCE assists in writing code in a way that (a) is secure by default and (b) makes auditing for
	 * security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV.
	 * In a more realistic example, one may be rendering user comments, blog articles, etc. via
	 * bindings.  (HTML is just one example of a context where rendering user controlled input creates
	 * security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, you want to ensure that any such bindings are disallowed unless you can
	 * determine that something explicitly says it's safe to use a value for binding in that
	 * context.  You can then audit your code (a simple grep would do) to ensure that this is only done
	 * for those values that you can easily tell are safe - because they were received from your server,
	 * sanitized by your library, etc.  You can organize your codebase to help with this - perhaps
	 * allowing only the files in a specific directory to do this.  Ensuring that the internal API
	 * exposed by that code doesn't markup arbitrary values as safe then becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * obtain values that will be accepted by SCE / privileged contexts.
	 *
	 *
	 * ## How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs the
	 * {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ## Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, Angular only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
	 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ## This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (remember to include the `ngSanitize` module) (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works.
	 *
	 * Additionally, `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
	 * through {@link ng.$sce#getTrusted $sce.getTrusted}.  SCE doesn't play a role here.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ## What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=` and `<img src=` sanitize their urls and don't constitute an SCE context. |
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
	 *
	 * ## Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      in a whitelist.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ## Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get("test_data.json", {cache: $templateCache}).success(function(userComments) {
	 *           self.userComments = userComments;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getInnerHtml())
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getInnerHtml()).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	/* jshint maxlen: 100 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE.
	   * @return {boolean} true if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the a value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way.  In some future, we
	   * may not use inheritance anymore.  That is OK because no code outside of
	   * sce.js and sceSpecs.js would need to be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} true if SCE is enabled, false otherwise.  If you want to set the value, you
	     * have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts Angular {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The kind of SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.  As such,
	     * returns an object that is trusted by angular for use in specified strict contextual
	     * escaping contexts (such as ng-bind-html, ng-include, any src attribute
	     * interpolation, any dom event binding attribute interpolation such as for onclick,  etc.)
	     * that uses the provided value.  See * {@link ng.$sce $sce} for enabling strict contextual
	     * escaping.
	     *
	     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
	     *   resourceUrl, html, js and css.
	     * @param {*} value The value that that should be considered trusted/safe.
	     * @returns {*} A value that can be used to stand in for the provided `value` in places
	     * where Angular expects a $sce.trustAs() return value.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedHtml
	     *     $sce.getTrustedHtml(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedUrl
	     *     $sce.getTrustedUrl(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedResourceUrl
	     *     $sce.getTrustedResourceUrl(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the return
	     *     value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to trustAs.
	     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedJs
	     *     $sce.getTrustedJs(value)} to obtain the original value.  (privileged directives
	     *     only accept expressions that are either literal constants or are the
	     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes the result of a {@link ng.$sce#trustAs `$sce.trustAs`}() call and returns the
	     * originally supplied value if the queried context type is a supertype of the created type.
	     * If this condition isn't satisfied, throws an exception.
	     *
	     * @param {string} type The kind of context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs `$sce.trustAs`}
	     *                         call.
	     * @returns {*} The value the was originally provided to
	     *              {@link ng.$sce#trustAs `$sce.trustAs`} if valid in this context.
	     *              Otherwise, throws an exception.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @returns {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @returns {function(context, locals)} a function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	     *      are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	     *      `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[camelCase("parse_as_" + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[camelCase("get_trusted_" + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[camelCase("trust_as_" + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        // Chrome Packaged Apps are not allowed to access `history.pushState`. They can be detected by
	        // the presence of `chrome.app.runtime` (see https://developer.chrome.com/apps/api_index)
	        isChromePackagedApp = $window.chrome && $window.chrome.app && $window.chrome.app.runtime,
	        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        vendorPrefix,
	        vendorRegex = /^(Moz|webkit|ms)(?=[A-Z])/,
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false,
	        match;
	
	    if (bodyStyle) {
	      for (var prop in bodyStyle) {
	        if (match = vendorRegex.exec(prop)) {
	          vendorPrefix = match[0];
	          vendorPrefix = vendorPrefix[0].toUpperCase() + vendorPrefix.substr(1);
	          break;
	        }
	      }
	
	      if (!vendorPrefix) {
	        vendorPrefix = ('WebkitOpacity' in bodyStyle) && 'webkit';
	      }
	
	      transitions = !!(('transition' in bodyStyle) || (vendorPrefix + 'Transition' in bodyStyle));
	      animations  = !!(('animation' in bodyStyle) || (vendorPrefix + 'Animation' in bodyStyle));
	
	      if (android && (!transitions ||  !animations)) {
	        transitions = isString(bodyStyle.webkitTransition);
	        animations = isString(bodyStyle.webkitAnimation);
	      }
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      // jshint -W018
	      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
	      // jshint +W018
	      hasEvent: function(event) {
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie <= 11) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      vendorPrefix: vendorPrefix,
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	var $templateRequestMinErr = minErr('$compile');
	
	/**
	 * @ngdoc provider
	 * @name $templateRequestProvider
	 * @description
	 * Used to configure the options passed to the {@link $http} service when making a template request.
	 *
	 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	 * requesting a template.
	 */
	function $TemplateRequestProvider() {
	
	  var httpOptions;
	
	  /**
	   * @ngdoc method
	   * @name $templateRequestProvider#httpOptions
	   * @description
	   * The options to be passed to the {@link $http} service when making the request.
	   * You can use this to override options such as the "Accept" header for template requests.
	   *
	   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	   * options if not overridden here.
	   *
	   * @param {string=} value new value for the {@link $http} options.
	   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	   */
	  this.httpOptions = function(val) {
	    if (val) {
	      httpOptions = val;
	      return this;
	    }
	    return httpOptions;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $templateRequest
	   *
	   * @description
	   * The `$templateRequest` service runs security checks then downloads the provided template using
	   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	   * when `tpl` is of type string and `$templateCache` has the matching entry.
	   *
	   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	   * can configure this via {@link $templateRequestProvider#httpOptions}.
	   *
	   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	   *
	   * @return {Promise} a promise for the HTTP response data of the given URL.
	   *
	   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	   */
	  this.$get = ['$templateCache', '$http', '$q', '$sce', function($templateCache, $http, $q, $sce) {
	
	    function handleRequestFn(tpl, ignoreRequestError) {
	      handleRequestFn.totalPendingRequests++;
	
	      // We consider the template cache holds only trusted templates, so
	      // there's no need to go through whitelisting again for keys that already
	      // are included in there. This also makes Angular accept any script
	      // directive, no matter its name. However, we still need to unwrap trusted
	      // types.
	      if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
	        tpl = $sce.getTrustedResourceUrl(tpl);
	      }
	
	      var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	      if (isArray(transformResponse)) {
	        transformResponse = transformResponse.filter(function(transformer) {
	          return transformer !== defaultHttpResponseTransform;
	        });
	      } else if (transformResponse === defaultHttpResponseTransform) {
	        transformResponse = null;
	      }
	
	      return $http.get(tpl, extend({
	          cache: $templateCache,
	          transformResponse: transformResponse
	        }, httpOptions))
	        ['finally'](function() {
	          handleRequestFn.totalPendingRequests--;
	        })
	        .then(function(response) {
	          $templateCache.put(tpl, response.data);
	          return response.data;
	        }, handleError);
	
	      function handleError(resp) {
	        if (!ignoreRequestError) {
	          throw $templateRequestMinErr('tpload', 'Failed to load template: {0} (HTTP status: {1} {2})',
	            tpl, resp.status, resp.statusText);
	        }
	        return $q.reject(resp);
	      }
	    }
	
	    handleRequestFn.totalPendingRequests = 0;
	
	    return handleRequestFn;
	  }];
	}
	
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) != -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when $timeout and $http requests are completed.
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	    var deferreds = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $timeout
	      *
	      * @description
	      * Angular's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	      * block and delegates any exceptions to
	      * {@link ng.$exceptionHandler $exceptionHandler} service.
	      *
	      * The return value of calling `$timeout` is a promise, which will be resolved when
	      * the delay has passed and the timeout function, if provided, is executed.
	      *
	      * To cancel a timeout request, call `$timeout.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	      * synchronously flush the queue of deferred functions.
	      *
	      * If you only want a promise that will be resolved after some specified delay
	      * then you can call `$timeout` without the `fn` function.
	      *
	      * @param {function()=} fn A function, whose execution should be delayed.
	      * @param {number=} [delay=0] Delay in milliseconds.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	      *   will be resolved with the return value of the `fn` function.
	      *
	      */
	    function timeout(fn, delay, invokeApply) {
	      if (!isFunction(fn)) {
	        invokeApply = delay;
	        delay = fn;
	        fn = noop;
	      }
	
	      var args = sliceArgs(arguments, 3),
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn.apply(null, args));
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        }
	        finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay);
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $timeout#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`. As a result of this, the promise will be
	      * resolved with a rejection.
	      *
	      * @param {Promise=} promise Promise returned by the `$timeout` function.
	      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	      *   canceled.
	      */
	    timeout.cancel = function(promise) {
	      if (promise && promise.$$timeoutId in deferreds) {
	        deferreds[promise.$$timeoutId].reject('canceled');
	        delete deferreds[promise.$$timeoutId];
	        return $browser.defer.cancel(promise.$$timeoutId);
	      }
	      return false;
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = window.document.createElement("a");
	var originUrl = urlResolve(window.location.href);
	
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+, Opera 7+,e etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string} url The URL to be parsed.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description    |
	 *   |---------------|----------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol including the trailing colon                              |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol
	 *   | hostname      | The hostname
	 *   | port          | The port, without ":"
	 *   | pathname      | The pathname, beginning with "/"
	 *
	 */
	function urlResolve(url) {
	  var href = url;
	
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute("href", href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: urlParsingNode.hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
	  return (parsed.protocol === originUrl.protocol &&
	          parsed.host === originUrl.host);
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In angular we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */
	function $$CookieReader($document) {
	  var rawDocument = $document[0] || {};
	  var lastCookies = {};
	  var lastCookieString = '';
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  return function() {
	    var cookieArray, cookie, i, index, name;
	    var currentCookieString = rawDocument.cookie || '';
	
	    if (currentCookieString !== lastCookieString) {
	      lastCookieString = currentCookieString;
	      cookieArray = lastCookieString.split('; ');
	      lastCookies = {};
	
	      for (i = 0; i < cookieArray.length; i++) {
	        cookie = cookieArray[i];
	        index = cookie.indexOf('=');
	        if (index > 0) { //ignore nameless cookies
	          name = safeDecodeURIComponent(cookie.substring(0, index));
	          // the first value that is seen for a cookie is the most
	          // specific one.  values for the same cookie name that
	          // follow are for less specific paths.
	          if (isUndefined(lastCookies[name])) {
	            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	          }
	        }
	      }
	    }
	    return lastCookies;
	  };
	}
	
	$$CookieReader.$inject = ['$document'];
	
	function $$CookieReaderProvider() {
	  this.$get = $$CookieReader;
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how angular filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the Angular Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * The general syntax in templates is as follows:
	 *
	 *         {{ expression [| filter_name[:parameter_value] ... ] }}
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false,
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name `$` can be used (as in `{$:"text"}`) to accept a match against any
	 *     property of the object or its nested object properties. That's equivalent to the simple
	 *     substring match with a `string` as described above. The predicate can be negated by prefixing
	 *     the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|undefined} comparator Comparator which is used in
	 *     determining if the expected value (from the filter expression) and actual value (from
	 *     the object in the array) should be considered a match.
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false|undefined`: A short hand for a function which will look for a substring match in case
	 *     insensitive way.
	 *
	 *     Primitive values are converted to strings. Objects are not compared against primitives,
	 *     unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	function filterFilter() {
	  return function(array, expression, comparator) {
	    if (!isArrayLike(array)) {
	      if (array == null) {
	        return array;
	      } else {
	        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	      }
	    }
	
	    var expressionType = getTypeForFilter(expression);
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        //jshint -W086
	      case 'object':
	        //jshint +W086
	        predicateFn = createPredicateFn(expression, comparator, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return Array.prototype.filter.call(array, predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && ('$' in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	        // Should not compare primitives against objects, unless they have custom `toString` method
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression.$, comparator, false);
	    }
	    return deepCompare(item, expression, comparator, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = getTypeForFilter(actual);
	  var expectedType = getTypeForFilter(expected);
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          if ((key.charAt(0) !== '$') && deepCompare(actual[key], expected, comparator, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === '$';
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	      break;
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val) {
	  return (val === null) ? 'null' : typeof val;
	}
	
	var MAX_DIGITS = 22;
	var DECIMAL_SEP = '.';
	var ZERO_CHAR = '0';
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser == 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(/\u00A4/g, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */
	function parse(numStr) {
	  var exponent = 0, digits, numberOfIntegerDigits;
	  var i, j, zeros;
	
	  // Decimal point?
	  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
	    numStr = numStr.replace(DECIMAL_SEP, '');
	  }
	
	  // Exponential form?
	  if ((i = numStr.search(/e/i)) > 0) {
	    // Work out the exponent.
	    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
	    numberOfIntegerDigits += +numStr.slice(i + 1);
	    numStr = numStr.substring(0, i);
	  } else if (numberOfIntegerDigits < 0) {
	    // There was no decimal point or exponent so it is an integer.
	    numberOfIntegerDigits = numStr.length;
	  }
	
	  // Count the number of leading zeros.
	  for (i = 0; numStr.charAt(i) == ZERO_CHAR; i++) {/* jshint noempty: false */}
	
	  if (i == (zeros = numStr.length)) {
	    // The digits are all zero.
	    digits = [0];
	    numberOfIntegerDigits = 1;
	  } else {
	    // Count the number of trailing zeros
	    zeros--;
	    while (numStr.charAt(zeros) == ZERO_CHAR) zeros--;
	
	    // Trailing zeros are insignificant so ignore them
	    numberOfIntegerDigits -= i;
	    digits = [];
	    // Convert string to array of digits without leading/trailing zeros.
	    for (j = 0; i <= zeros; i++, j++) {
	      digits[j] = +numStr.charAt(i);
	    }
	  }
	
	  // If the number overflows the maximum allowed digits then use an exponent.
	  if (numberOfIntegerDigits > MAX_DIGITS) {
	    digits = digits.splice(0, MAX_DIGITS - 1);
	    exponent = numberOfIntegerDigits - 1;
	    numberOfIntegerDigits = 1;
	  }
	
	  return { d: digits, e: exponent, i: numberOfIntegerDigits };
	}
	
	/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */
	function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
	    var digits = parsedNumber.d;
	    var fractionLen = digits.length - parsedNumber.i;
	
	    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
	
	    // The index of the digit to where rounding is to occur
	    var roundAt = fractionSize + parsedNumber.i;
	    var digit = digits[roundAt];
	
	    if (roundAt > 0) {
	      // Drop fractional digits beyond `roundAt`
	      digits.splice(Math.max(parsedNumber.i, roundAt));
	
	      // Set non-fractional digits beyond `roundAt` to 0
	      for (var j = roundAt; j < digits.length; j++) {
	        digits[j] = 0;
	      }
	    } else {
	      // We rounded to zero so reset the parsedNumber
	      fractionLen = Math.max(0, fractionLen);
	      parsedNumber.i = 1;
	      digits.length = Math.max(1, roundAt = fractionSize + 1);
	      digits[0] = 0;
	      for (var i = 1; i < roundAt; i++) digits[i] = 0;
	    }
	
	    if (digit >= 5) {
	      if (roundAt - 1 < 0) {
	        for (var k = 0; k > roundAt; k--) {
	          digits.unshift(0);
	          parsedNumber.i++;
	        }
	        digits.unshift(1);
	        parsedNumber.i++;
	      } else {
	        digits[roundAt - 1]++;
	      }
	    }
	
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);
	
	
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var carry = digits.reduceRight(function(carry, d, i, digits) {
	      d = d + carry;
	      digits[i] = d % 10;
	      return Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	      digits.unshift(carry);
	      parsedNumber.i++;
	    }
	}
	
	/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	
	  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
	
	  var isInfinity = !isFinite(number);
	  var isZero = false;
	  var numStr = Math.abs(number) + '',
	      formattedText = '',
	      parsedNumber;
	
	  if (isInfinity) {
	    formattedText = '\u221e';
	  } else {
	    parsedNumber = parse(numStr);
	
	    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
	
	    var digits = parsedNumber.d;
	    var integerLen = parsedNumber.i;
	    var exponent = parsedNumber.e;
	    var decimals = [];
	    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);
	
	    // pad zeros for small numbers
	    while (integerLen < 0) {
	      digits.unshift(0);
	      integerLen++;
	    }
	
	    // extract decimals digits
	    if (integerLen > 0) {
	      decimals = digits.splice(integerLen, digits.length);
	    } else {
	      decimals = digits;
	      digits = [0];
	    }
	
	    // format the integer digits with grouping separators
	    var groups = [];
	    if (digits.length >= pattern.lgSize) {
	      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	    }
	    while (digits.length > pattern.gSize) {
	      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	    }
	    if (digits.length) {
	      groups.unshift(digits.join(''));
	    }
	    formattedText = groups.join(groupSep);
	
	    // append the decimal digits
	    if (decimals.length) {
	      formattedText += decimalSep + decimals.join('');
	    }
	
	    if (exponent) {
	      formattedText += 'e+' + exponent;
	    }
	  }
	  if (number < 0 && !isZero) {
	    return pattern.negPre + formattedText + pattern.negSuf;
	  } else {
	    return pattern.posPre + formattedText + pattern.posSuf;
	  }
	}
	
	function padNumber(num, digits, trim, negWrap) {
	  var neg = '';
	  if (num < 0 || (negWrap && num <= 0)) {
	    if (negWrap) {
	      num = -num + 1;
	    } else {
	      num = -num;
	      neg = '-';
	    }
	  }
	  num = '' + num;
	  while (num.length < digits) num = ZERO_CHAR + num;
	  if (trim) {
	    num = num.substr(num.length - digits);
	  }
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim, negWrap) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset) {
	      value += offset;
	    }
	    if (value === 0 && offset == -12) value = 12;
	    return padNumber(value, size, trim, negWrap);
	  };
	}
	
	function dateStrGetter(name, shortForm, standAlone) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
	    var get = uppercase(propPrefix + name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date, formats, offset) {
	  var zone = -1 * offset;
	  var paddedZone = (zone >= 0) ? "+" : "";
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4, 0, false, true),
	    yy: dateGetter('FullYear', 2, 0, true, true),
	     y: dateGetter('FullYear', 1, 0, false, true),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	  LLLL: dateStrGetter('Month', false, true),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))(.*)/,
	    NUMBER_STRING = /^\-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'LLLL'`: Stand-alone month in year (January-December)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010\-10\-2\d \d{2}:\d{2}:\d{2} (\-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if (match = string.match(R_ISO8601_STR)) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = toInt(match[9] + match[10]);
	        tzMin = toInt(match[9] + match[11]);
	      }
	      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	      var h = toInt(match[4] || 0) - tzHour;
	      var m = toInt(match[5] || 0) - tzMin;
	      var s = toInt(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date) || !isFinite(date.getTime())) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	      date = convertTimezoneToLocal(date, timezone, true);
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	                 : value === "''" ? "'" : value.replace(/(^'|'$)/g, '').replace(/''/g, "'");
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n  "name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n    "name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @see angular.uppercase
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements
	 * are taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. If a number is used as input, it is
	 * converted to a string.
	 *
	 * @param {Array|string|number} input Source array, string or number to be limited.
	 * @param {string|number} limit The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin Index at which to begin limitation. As a negative index, `begin`
	 *     indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if input array
	 *     had less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit, begin) {
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = toInt(limit);
	    }
	    if (isNaN(limit)) return input;
	
	    if (isNumber(input)) input = input.toString();
	    if (!isArray(input) && !isString(input)) return input;
	
	    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
	
	    if (limit >= 0) {
	      return input.slice(begin, begin + limit);
	    } else {
	      if (begin === 0) {
	        return input.slice(limit, input.length);
	      } else {
	        return input.slice(Math.max(0, begin + limit), begin);
	      }
	    }
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Orders a specified `array` by the `expression` predicate. It is ordered alphabetically
	 * for strings and numerically for numbers. Note: if you notice numbers are not being sorted
	 * as expected, make sure they are actually being saved as numbers and not strings.
	 * Array-like values (e.g. NodeLists, jQuery objects, TypedArrays, Strings, etc) are also supported.
	 *
	 * @param {Array} array The array (or array-like object) to sort.
	 * @param {function(*)|string|Array.<(function(*)|string)>=} expression A predicate to be
	 *    used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `function`: Getter function. The result of this function will be sorted using the
	 *      `<`, `===`, `>` operator.
	 *    - `string`: An Angular expression. The result of this expression is used to compare elements
	 *      (for example `name` to sort by a property called `name` or `name.substr(0, 3)` to sort by
	 *      3 first characters of a property called `name`). The result of a constant expression
	 *      is interpreted as a property name to be used in comparisons (for example `"special name"`
	 *      to sort object by the value of their `special name` property). An expression can be
	 *      optionally prefixed with `+` or `-` to control ascending or descending sort order
	 *      (for example, `+name` or `-name`). If no property is provided, (e.g. `'+'`) then the array
	 *      element itself is used to compare where sorting.
	 *    - `Array`: An array of function or string predicates. The first predicate in the array
	 *      is used for sorting, but when two items are equivalent, the next predicate is used.
	 *
	 *    If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse Reverse the order of the array.
	 * @returns {Array} Sorted copy of the source array.
	 *
	 *
	 * @example
	 * The example below demonstrates a simple ngRepeat, where the data is sorted
	 * by age in descending order (predicate is set to `'-age'`).
	 * `reverse` is not set, which means it defaults to `false`.
	   <example module="orderByExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friend">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends =
	               [{name:'John', phone:'555-1212', age:10},
	                {name:'Mary', phone:'555-9876', age:19},
	                {name:'Mike', phone:'555-4321', age:21},
	                {name:'Adam', phone:'555-5678', age:35},
	                {name:'Julie', phone:'555-8765', age:29}];
	         }]);
	     </file>
	   </example>
	 *
	 * The predicate and reverse parameters can be controlled dynamically through scope properties,
	 * as shown in the next example.
	 * @example
	   <example module="orderByExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sorting predicate = {{predicate}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="predicate=''">Set to unsorted</button>
	         <table class="friend">
	           <tr>
	            <th>
	                <button ng-click="order('name')">Name</button>
	                <span class="sortorder" ng-show="predicate === 'name'" ng-class="{reverse:reverse}"></span>
	            </th>
	            <th>
	                <button ng-click="order('phone')">Phone Number</button>
	                <span class="sortorder" ng-show="predicate === 'phone'" ng-class="{reverse:reverse}"></span>
	            </th>
	            <th>
	                <button ng-click="order('age')">Age</button>
	                <span class="sortorder" ng-show="predicate === 'age'" ng-class="{reverse:reverse}"></span>
	            </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:predicate:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends =
	               [{name:'John', phone:'555-1212', age:10},
	                {name:'Mary', phone:'555-9876', age:19},
	                {name:'Mike', phone:'555-4321', age:21},
	                {name:'Adam', phone:'555-5678', age:35},
	                {name:'Julie', phone:'555-8765', age:29}];
	           $scope.predicate = 'age';
	           $scope.reverse = true;
	           $scope.order = function(predicate) {
	             $scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;
	             $scope.predicate = predicate;
	           };
	         }]);
	      </file>
	     <file name="style.css">
	       .sortorder:after {
	         content: '\25b2';
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';
	       }
	     </file>
	   </example>
	 *
	 * It's also possible to call the orderBy filter manually, by injecting `$filter`, retrieving the
	 * filter routine with `$filter('orderBy')`, and calling the returned filter routine with the
	 * desired parameters.
	 *
	 * Example:
	 *
	 * @example
	  <example module="orderByExample">
	    <file name="index.html">
	    <div ng-controller="ExampleController">
	      <pre>Sorting predicate = {{predicate}}; reverse = {{reverse}}</pre>
	      <table class="friend">
	        <tr>
	          <th>
	              <button ng-click="order('name')">Name</button>
	              <span class="sortorder" ng-show="predicate === 'name'" ng-class="{reverse:reverse}"></span>
	          </th>
	          <th>
	              <button ng-click="order('phone')">Phone Number</button>
	              <span class="sortorder" ng-show="predicate === 'phone'" ng-class="{reverse:reverse}"></span>
	          </th>
	          <th>
	              <button ng-click="order('age')">Age</button>
	              <span class="sortorder" ng-show="predicate === 'age'" ng-class="{reverse:reverse}"></span>
	          </th>
	        </tr>
	        <tr ng-repeat="friend in friends">
	          <td>{{friend.name}}</td>
	          <td>{{friend.phone}}</td>
	          <td>{{friend.age}}</td>
	        </tr>
	      </table>
	    </div>
	    </file>
	
	    <file name="script.js">
	      angular.module('orderByExample', [])
	        .controller('ExampleController', ['$scope', '$filter', function($scope, $filter) {
	          var orderBy = $filter('orderBy');
	          $scope.friends = [
	            { name: 'John',    phone: '555-1212',    age: 10 },
	            { name: 'Mary',    phone: '555-9876',    age: 19 },
	            { name: 'Mike',    phone: '555-4321',    age: 21 },
	            { name: 'Adam',    phone: '555-5678',    age: 35 },
	            { name: 'Julie',   phone: '555-8765',    age: 29 }
	          ];
	          $scope.order = function(predicate) {
	            $scope.predicate = predicate;
	            $scope.reverse = ($scope.predicate === predicate) ? !$scope.reverse : false;
	            $scope.friends = orderBy($scope.friends, predicate, $scope.reverse);
	          };
	          $scope.order('age', true);
	        }]);
	    </file>
	
	    <file name="style.css">
	       .sortorder:after {
	         content: '\25b2';
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';
	       }
	    </file>
	</example>
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder) {
	
	    if (array == null) return array;
	    if (!isArrayLike(array)) {
	      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
	    }
	
	    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	    var predicates = processPredicates(sortPredicate, reverseOrder);
	    // Add a predicate at the end that evaluates to the element index. This makes the
	    // sort stable as it works as a tie-breaker when all the input predicates cannot
	    // distinguish between two elements.
	    predicates.push({ get: function() { return {}; }, descending: reverseOrder ? -1 : 1});
	
	    // The next three lines are a version of a Swartzian Transform idiom from Perl
	    // (sometimes called the Decorate-Sort-Undecorate idiom)
	    // See https://en.wikipedia.org/wiki/Schwartzian_transform
	    var compareValues = Array.prototype.map.call(array, getComparisonObject);
	    compareValues.sort(doComparison);
	    array = compareValues.map(function(item) { return item.value; });
	
	    return array;
	
	    function getComparisonObject(value, index) {
	      return {
	        value: value,
	        predicateValues: predicates.map(function(predicate) {
	          return getPredicateValue(predicate.get(value), index);
	        })
	      };
	    }
	
	    function doComparison(v1, v2) {
	      var result = 0;
	      for (var index=0, length = predicates.length; index < length; ++index) {
	        result = compare(v1.predicateValues[index], v2.predicateValues[index]) * predicates[index].descending;
	        if (result) break;
	      }
	      return result;
	    }
	  };
	
	  function processPredicates(sortPredicate, reverseOrder) {
	    reverseOrder = reverseOrder ? -1 : 1;
	    return sortPredicate.map(function(predicate) {
	      var descending = 1, get = identity;
	
	      if (isFunction(predicate)) {
	        get = predicate;
	      } else if (isString(predicate)) {
	        if ((predicate.charAt(0) == '+' || predicate.charAt(0) == '-')) {
	          descending = predicate.charAt(0) == '-' ? -1 : 1;
	          predicate = predicate.substring(1);
	        }
	        if (predicate !== '') {
	          get = $parse(predicate);
	          if (get.constant) {
	            var key = get();
	            get = function(value) { return value[key]; };
	          }
	        }
	      }
	      return { get: get, descending: descending * reverseOrder };
	    });
	  }
	
	  function isPrimitive(value) {
	    switch (typeof value) {
	      case 'number': /* falls through */
	      case 'boolean': /* falls through */
	      case 'string':
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function objectValue(value, index) {
	    // If `valueOf` is a valid function use that
	    if (typeof value.valueOf === 'function') {
	      value = value.valueOf();
	      if (isPrimitive(value)) return value;
	    }
	    // If `toString` is a valid function and not the one from `Object.prototype` use that
	    if (hasCustomToString(value)) {
	      value = value.toString();
	      if (isPrimitive(value)) return value;
	    }
	    // We have a basic object so we use the position of the object in the collection
	    return index;
	  }
	
	  function getPredicateValue(value, index) {
	    var type = typeof value;
	    if (value === null) {
	      type = 'string';
	      value = 'null';
	    } else if (type === 'string') {
	      value = value.toLowerCase();
	    } else if (type === 'object') {
	      value = objectValue(value, index);
	    }
	    return { value: value, type: type };
	  }
	
	  function compare(v1, v2) {
	    var result = 0;
	    if (v1.type === v2.type) {
	      if (v1.value !== v2.value) {
	        result = v1.value < v2.value ? -1 : 1;
	      }
	    } else {
	      result = v1.type < v2.type ? -1 : 1;
	    }
	    return result;
	  }
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html A tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * This change permits the easy creation of action links with the `ngClick` directive
	 * without changing the location or causing page reloads, e.g.:
	 * `<a href="" ng-click="list.addItem()">Add Item</a>`
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * Angular has a chance to replace the `{{hash}}` markup with its
	 * value. Until Angular replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example>
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="master"></label><br/>
	        <input id="checkSlave" type="checkbox" ng-checked="master" aria-label="Slave input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeFalsy();
	          element(by.model('master')).click();
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readOnly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readOnly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm Angular" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	     <example>
	       <file name="index.html">
	         <label>Check me check multiple: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>Show/Hide me</summary>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName == "multiple") return;
	
	  function defaultLinkFn(scope, element, attr) {
	    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	      attr.$set(attrName, !!value);
	    });
	  }
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  var linkFn = defaultLinkFn;
	
	  if (propName === 'checked') {
	    linkFn = function(scope, element, attr) {
	      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	      if (attr.ngModel !== attr[normalized]) {
	        defaultLinkFn(scope, element, attr);
	      }
	    };
	  }
	
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: linkFn
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === "ngPattern" && attr.ngPattern.charAt(0) == "/") {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set("ngPattern", new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // on IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // we use attr[attrName] value since $set can sanitize the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  };
	});
	
	/* global -nullFormCtrl, -SUBMITTED_CLASS, addSetValidityMethod: true
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop
	},
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $pending True if at least one containing control or form is pending.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $error Is an object hash, containing references to controls or
	 *  forms with failing validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for given error name.
	 *
	 *  Built-in validation tokens:
	 *
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController(element, attrs, $scope, $animate, $interpolate) {
	  var form = this,
	      controls = [];
	
	  // init state
	  form.$error = {};
	  form.$$success = {};
	  form.$pending = undefined;
	  form.$name = $interpolate(attrs.name || attrs.ngForm || '')($scope);
	  form.$dirty = false;
	  form.$pristine = true;
	  form.$valid = true;
	  form.$invalid = false;
	  form.$submitted = false;
	  form.$$parentForm = nullFormCtrl;
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  form.$rollbackViewValue = function() {
	    forEach(controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  form.$commitViewValue = function() {
	    forEach(controls, function(control) {
	      control.$commitViewValue();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsibility to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */
	  form.$addControl = function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    controls.push(control);
	
	    if (control.$name) {
	      form[control.$name] = control;
	    }
	
	    control.$$parentForm = form;
	  };
	
	  // Private API: rename a form control
	  form.$$renameControl = function(control, newName) {
	    var oldName = control.$name;
	
	    if (form[oldName] === control) {
	      delete form[oldName];
	    }
	    form[newName] = control;
	    control.$name = newName;
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */
	  form.$removeControl = function(control) {
	    if (control.$name && form[control.$name] === control) {
	      delete form[control.$name];
	    }
	    forEach(form.$pending, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	    forEach(form.$error, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	    forEach(form.$$success, function(value, name) {
	      form.$setValidity(name, null, control);
	    });
	
	    arrayRemove(controls, control);
	    control.$$parentForm = nullFormCtrl;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setValidity
	   *
	   * @description
	   * Sets the validity of a form control.
	   *
	   * This method will also propagate to parent forms.
	   */
	  addSetValidityMethod({
	    ctrl: this,
	    $element: element,
	    set: function(object, property, controller) {
	      var list = object[property];
	      if (!list) {
	        object[property] = [controller];
	      } else {
	        var index = list.indexOf(controller);
	        if (index === -1) {
	          list.push(controller);
	        }
	      }
	    },
	    unset: function(object, property, controller) {
	      var list = object[property];
	      if (!list) {
	        return;
	      }
	      arrayRemove(list, controller);
	      if (list.length === 0) {
	        delete object[property];
	      }
	    },
	    $animate: $animate
	  });
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  form.$setDirty = function() {
	    $animate.removeClass(element, PRISTINE_CLASS);
	    $animate.addClass(element, DIRTY_CLASS);
	    form.$dirty = true;
	    form.$pristine = false;
	    form.$$parentForm.$setDirty();
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method can be called to remove the 'ng-dirty' class and set the form to its pristine
	   * state (ng-pristine class). This method will also propagate to all the controls contained
	   * in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  form.$setPristine = function() {
	    $animate.setClass(element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    form.$dirty = false;
	    form.$pristine = true;
	    form.$submitted = false;
	    forEach(controls, function(control) {
	      control.$setPristine();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  form.$setUntouched = function() {
	    forEach(controls, function(control) {
	      control.$setUntouched();
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its submitted state.
	   */
	  form.$setSubmitted = function() {
	    $animate.addClass(element, SUBMITTED_CLASS);
	    form.$submitted = true;
	    form.$$parentForm.$setSubmitted();
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
	 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
	 * sub-group of controls needs to be determined.
	 *
	 * Note: the purpose of `ngForm` is to group controls,
	 * but not to be a replacement for the `<form>` tag with all of its capabilities
	 * (e.g. posting to the server, ...).
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * # Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In Angular, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * Angular provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * # CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * # Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side Angular applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, Angular prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ## Animation Hooks
	 *
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', '$parse', function($timeout, $parse) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
	            var controller = ctrls[0];
	
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              addEventListenerFn(formElement[0], 'submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  removeEventListenerFn(formElement[0], 'submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
	            parentFormCtrl.$addControl(controller);
	
	            var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	            if (nameAttr) {
	              setter(scope, controller);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, undefined);
	                controller.$$parentForm.$$renameControl(controller, newValue);
	                setter = getSetter(controller.$name);
	                setter(scope, controller);
	              });
	            }
	            formElement.on('$destroy', function() {
	              controller.$$parentForm.$removeControl(controller);
	              setter(scope, undefined);
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	
	    function getSetter(expression) {
	      if (expression === '') {
	        //create an assignable expression, so forms with an empty name can be renamed later
	        return $parse('this[""]').assign;
	      }
	      return $parse(expression).assign || noop;
	    }
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	/* global VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  UNTOUCHED_CLASS: false,
	  TOUCHED_CLASS: false,
	  ngModelMinErr: false,
	*/
	
	// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
	// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        555555555555555555555555    666     77777777     8888888     999
	var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+\])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
	var NUMBER_REGEXP = /^\s*(\-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
	var PARTIAL_VALIDATION_TYPES = createMap();
	forEach('date,datetime-local,month,time,week'.split(','), function(type) {
	  PARTIAL_VALIDATION_TYPES[type] = true;
	});
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with angular data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <code>text = {{example.text}}</code><br/>
	           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise Angular will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	        var input = element(by.model('example.value'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	      var input = element(by.model('example.value'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise Angular will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   * ## Issues with HTML5 constraint validation
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
	   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue Angular expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            element.all(by.model('color.name')).get(0).click();
	
	            expect(color.getText()).toContain('red');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputing intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function() {
	      composing = true;
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var timeout;
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  // Some native input types (date-family) have the ability to change validity without
	  // firing any input/change events.
	  // For these event types, when native validators are present and the browser supports the type,
	  // check for validity changes on various DOM events.
	  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
	    element.on(PARTIAL_VALIDATION_EVENTS, function(ev) {
	      if (!timeout) {
	        var validity = this[VALIDITY_STATE_PROPERTY];
	        var origBadInput = validity.badInput;
	        var origTypeMismatch = validity.typeMismatch;
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
	            listener(ev);
	          }
	        });
	      }
	    });
	  }
	
	  ctrl.$render = function() {
	    // Workaround for Firefox validation #12102.
	    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	    if (element.val() !== value) {
	      element.val(value);
	    }
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, date) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) == '"' && iso.charAt(iso.length - 1) == '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (date) {
	          map = {
	            yyyy: date.getFullYear(),
	            MM: date.getMonth() + 1,
	            dd: date.getDate(),
	            HH: date.getHours(),
	            mm: date.getMinutes(),
	            ss: date.getSeconds(),
	            sss: date.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	        return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
	    badInputChecker(scope, element, attr, ctrl);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	    var timezone = ctrl && ctrl.$options && ctrl.$options.timezone;
	    var previousDate;
	
	    ctrl.$$parserName = type;
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        var parsedDate = parseDate(value, previousDate);
	        if (timezone) {
	          parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	        }
	        return parsedDate;
	      }
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        if (previousDate && timezone) {
	          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	        }
	        return $filter('date')(value, format, timezone);
	      } else {
	        previousDate = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal;
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
	      };
	      attr.$observe('min', function(val) {
	        minVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal;
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
	      };
	      attr.$observe('max', function(val) {
	        maxVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) && !isDate(val) ? parseDate(val) || undefined : val;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      return validity.badInput || validity.typeMismatch ? undefined : value;
	    });
	  }
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  ctrl.$$parserName = 'number';
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    var minVal;
	    ctrl.$validators.min = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
	    };
	
	    attr.$observe('min', function(val) {
	      if (isDefined(val) && !isNumber(val)) {
	        val = parseFloat(val, 10);
	      }
	      minVal = isNumber(val) && !isNaN(val) ? val : undefined;
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    var maxVal;
	    ctrl.$validators.max = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      if (isDefined(val) && !isNumber(val)) {
	        val = parseFloat(val, 10);
	      }
	      maxVal = isNumber(val) && !isNaN(val) ? val : undefined;
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'url';
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'email';
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    if (element[0].checked) {
	      ctrl.$setViewValue(attr.value, ev && ev.type);
	    }
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    element[0].checked = (value == ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with angular data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    value does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 *
	 * @description
	 * Binds the given expression to the value of `<option>` or {@link input[radio] `input[radio]`},
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element is set to
	 * the bound value.
	 *
	 * `ngValue` is useful when dynamically generating lists of radio buttons using
	 * {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * Likewise, `ngValue` can be used to generate `<option>` elements for
	 * the {@link select `select`} element. In that case however, only strings are supported
	 * for the `value `attribute, so the resulting `ngModel` will always be a string.
	 * Support for `select` models with non-string values is available via `ngOptions`.
	 *
	 * @element input
	 * @param {string=} ngValue angular expression, whose value will be bound to the `value` attribute
	 *   of the `input` element
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          attr.$set('value', scope.$eval(attr.ngValue));
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            attr.$set('value', value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells Angular to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before Angular compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core Angular). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
	        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	        return $sce.valueOf(val);
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	          var value = ngBindHtmlGetter(scope);
	          element.html($sce.getTrustedHtml(value) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element input
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  return ['$animate', function($animate) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var oldVal;
	
	        scope.$watch(attr[name], ngClassWatchAction, true);
	
	        attr.$observe('class', function(value) {
	          ngClassWatchAction(scope.$eval(attr[name]));
	        });
	
	
	        if (name !== 'ngClass') {
	          scope.$watch('$index', function($index, old$index) {
	            // jshint bitwise: false
	            var mod = $index & 1;
	            if (mod !== (old$index & 1)) {
	              var classes = arrayClasses(scope.$eval(attr[name]));
	              mod === selector ?
	                addClasses(classes) :
	                removeClasses(classes);
	            }
	          });
	        }
	
	        function addClasses(classes) {
	          var newClasses = digestClassCounts(classes, 1);
	          attr.$addClass(newClasses);
	        }
	
	        function removeClasses(classes) {
	          var newClasses = digestClassCounts(classes, -1);
	          attr.$removeClass(newClasses);
	        }
	
	        function digestClassCounts(classes, count) {
	          // Use createMap() to prevent class assumptions involving property
	          // names in Object.prototype
	          var classCounts = element.data('$classCounts') || createMap();
	          var classesToUpdate = [];
	          forEach(classes, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	          element.data('$classCounts', classCounts);
	          return classesToUpdate.join(' ');
	        }
	
	        function updateClasses(oldClasses, newClasses) {
	          var toAdd = arrayDifference(newClasses, oldClasses);
	          var toRemove = arrayDifference(oldClasses, newClasses);
	          toAdd = digestClassCounts(toAdd, 1);
	          toRemove = digestClassCounts(toRemove, -1);
	          if (toAdd && toAdd.length) {
	            $animate.addClass(element, toAdd);
	          }
	          if (toRemove && toRemove.length) {
	            $animate.removeClass(element, toRemove);
	          }
	        }
	
	        function ngClassWatchAction(newVal) {
	          // jshint bitwise: false
	          if (selector === true || (scope.$index & 1) === selector) {
	          // jshint bitwise: true
	            var newClasses = arrayClasses(newVal || []);
	            if (!oldVal) {
	              addClasses(newClasses);
	            } else if (!equals(newVal,oldVal)) {
	              var oldClasses = arrayClasses(oldVal);
	              updateClasses(oldClasses, newClasses);
	            }
	          }
	          if (isArray(newVal)) {
	            oldVal = newVal.map(function(v) { return shallowCopy(v); });
	          } else {
	            oldVal = shallowCopy(newVal);
	          }
	        }
	      }
	    };
	
	    function arrayDifference(tokens1, tokens2) {
	      var values = [];
	
	      outer:
	      for (var i = 0; i < tokens1.length; i++) {
	        var token = tokens1[i];
	        for (var j = 0; j < tokens2.length; j++) {
	          if (token == tokens2[j]) continue outer;
	        }
	        values.push(token);
	      }
	      return values;
	    }
	
	    function arrayClasses(classVal) {
	      var classes = [];
	      if (isArray(classVal)) {
	        forEach(classVal, function(v) {
	          classes = classes.concat(arrayClasses(v));
	        });
	        return classes;
	      } else if (isString(classVal)) {
	        return classVal.split(' ');
	      } else if (isObject(classVal)) {
	        forEach(classVal, function(v, k) {
	          if (v) {
	            classes = classes.concat(k.split(' '));
	          }
	        });
	        return classes;
	      }
	      return classVal;
	    }
	  }];
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example Example that demonstrates basic bindings via ngClass directive.
	   <example>
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   ## Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	
	
	   ## ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the Angular html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When Angular encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * If the current `$controllerProvider` is configured to use globals (via
	 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
	 * also be the name of a globally accessible constructor function (not recommended).
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the angular markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the Angular community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = "John Smith";
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'} ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = "John Smith";
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'} ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @element html
	 * @description
	 *
	 * Angular has some features that can break certain
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement these rules then you must tell Angular not to use these features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following rules affect Angular:
	 *
	 * * `unsafe-eval`: this rule forbids apps to use `eval` or `Function(string)` generated functions
	 * (among other things). Angular makes use of this in the {@link $parse} service to provide a 30%
	 * increase in the speed of evaluating Angular expressions.
	 *
	 * * `unsafe-inline`: this rule forbids apps from inject custom styles into the document. Angular
	 * makes use of this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}).
	 * To make these directives work when a CSP rule is blocking inline styles, you must link to the
	 * `angular-csp.css` in your HTML manually.
	 *
	 * If you do not provide `ngCsp` then Angular tries to autodetect if CSP is blocking unsafe-eval
	 * and automatically deactivates this feature in the {@link $parse} service. This autodetection,
	 * however, triggers a CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related Angular features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops Angular from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops Angular from optimizing $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that Angular will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous versions
	 * of Angular.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell Angular to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous versions
	 * of Angular.
	 *
	 * * Specifying only `no-unsafe-eval` tells Angular that we must not use eval, but that we can inject
	 * inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells Angular that we must not inject styles, but that we can
	 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells Angular that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	  * @example
	      // Note: the suffix `.csp` in the example name triggers
	      // csp mode in our http server!
	      <example name="example.csp" module="cspExample" ng-csp="true">
	        <file name="index.html">
	          <div ng-controller="MainController as ctrl">
	            <div>
	              <button ng-click="ctrl.inc()" id="inc">Increment</button>
	              <span id="counter">
	                {{ctrl.counter}}
	              </span>
	            </div>
	
	            <div>
	              <button ng-click="ctrl.evil()" id="evil">Evil</button>
	              <span id="evilError">
	                {{ctrl.evilError}}
	              </span>
	            </div>
	          </div>
	        </file>
	        <file name="script.js">
	           angular.module('cspExample', [])
	             .controller('MainController', function() {
	                this.counter = 0;
	                this.inc = function() {
	                  this.counter++;
	                };
	                this.evil = function() {
	                  // jshint evil:true
	                  try {
	                    eval('1+2');
	                  } catch (e) {
	                    this.evilError = e.message;
	                  }
	                };
	              });
	        </file>
	        <file name="protractor.js" type="protractor">
	          var util, webdriver;
	
	          var incBtn = element(by.id('inc'));
	          var counter = element(by.id('counter'));
	          var evilBtn = element(by.id('evil'));
	          var evilError = element(by.id('evilError'));
	
	          function getAndClearSevereErrors() {
	            return browser.manage().logs().get('browser').then(function(browserLog) {
	              return browserLog.filter(function(logEntry) {
	                return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	              });
	            });
	          }
	
	          function clearErrors() {
	            getAndClearSevereErrors();
	          }
	
	          function expectNoErrors() {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              expect(filteredLog.length).toEqual(0);
	              if (filteredLog.length) {
	                console.log('browser console errors: ' + util.inspect(filteredLog));
	              }
	            });
	          }
	
	          function expectError(regex) {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              var found = false;
	              filteredLog.forEach(function(log) {
	                if (log.message.match(regex)) {
	                  found = true;
	                }
	              });
	              if (!found) {
	                throw new Error('expected an error that matches ' + regex);
	              }
	            });
	          }
	
	          beforeEach(function() {
	            util = require('util');
	            webdriver = require('protractor/node_modules/selenium-webdriver');
	          });
	
	          // For now, we only test on Chrome,
	          // as Safari does not load the page with Protractor's injected scripts,
	          // and Firefox webdriver always disables content security policy (#6358)
	          if (browser.params.browser !== 'chrome') {
	            return;
	          }
	
	          it('should not report errors when the page is loaded', function() {
	            // clear errors so we are not dependent on previous tests
	            clearErrors();
	            // Need to reload the page as the page is already loaded when
	            // we come here
	            browser.driver.getCurrentUrl().then(function(url) {
	              browser.get(url);
	            });
	            expectNoErrors();
	          });
	
	          it('should evaluate expressions', function() {
	            expect(counter.getText()).toEqual('0');
	            incBtn.click();
	            expect(counter.getText()).toEqual('1');
	            expectNoErrors();
	          });
	
	          it('should throw and report an error when using "eval"', function() {
	            evilBtn.click();
	            expect(evilError.getText()).toMatch(/Content Security Policy/);
	            expectError(/Content Security Policy/);
	          });
	        </file>
	      </example>
	  */
	
	// ngCsp is not implemented as a proper directive any more, because we need it be processed while we
	// bootstrap the system (before $parse is instantiated), for this reason we just have
	// the csp() fn that looks for the `ng-csp` attribute anywhere in the current doc
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * angular expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
	      return {
	        restrict: 'A',
	        compile: function($element, attr) {
	          // We expose the powerful $event object on the scope that provides access to the Window,
	          // etc. that isn't protected by the fast paths in $parse.  We explicitly request better
	          // checks at the cost of speed since event handler expressions are not executed as
	          // frequently as regular change detection.
	          var fn = $parse(attr[directiveName], /* interceptorFn */ null, /* expensiveChecks */ true);
	          return function ngEventHandler(scope, element) {
	            element.on(eventName, function(event) {
	              var callback = function() {
	                fn(scope, {$event:event});
	              };
	              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
	                scope.$evalAsync(callback);
	              } else {
	                scope.$apply(callback);
	              }
	            });
	          };
	        }
	      };
	    }];
	  }
	);
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @element ANY
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 *
	 * @description
	 * Enables binding angular expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @element form
	 * @priority 0
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example>
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).then(function() {
	                previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
	 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to Angular's {@link
	 * ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @scope
	 * @priority 400
	 *
	 * @param {string} ngInclude|src angular expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [ { name: 'template1.html', url: 'template1.html'},
	              { name: 'template2.html', url: 'template2.html'} ];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser == 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser == 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).then(function() {
	              previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function() {
	            if (isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) {
	              $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).then(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (toString.call($element[0]).match(/SVG/)) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`, such as for aliasing special properties of
	 * {@link ng.directive:ngRepeat `ngRepeat`}, as seen in the demo below; and for injecting data via
	 * server side scripting. Besides these few cases, you should use {@link guide/controller controllers}
	 * rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @priority 450
	 *
	 * @element ANY
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @example
	   <example module="initExample">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * ### Example with Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Example - splitting on newline
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @element input
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      // We want to control whitespace trimming so we use this convoluted approach
	      // to access the ngList attribute, which doesn't pre-trim the attribute
	      var ngList = element.attr(attr.$attr.ngList) || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	*/
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    PENDING_CLASS = 'ng-pending',
	    EMPTY_CLASS = 'ng-empty',
	    NOT_EMPTY_CLASS = 'ng-not-empty';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 *
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	       the control reads value from the DOM. The functions are called in array order, each passing
	       its return value through to the next. The last return value is forwarded to the
	       {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	`$viewValue`}.
	
	Returning `undefined` from a parser means a parse error occurred. In that case,
	no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	       the model value changes. The functions are called in reverse array order, each passing the value through to the
	       next. The last return value is used as the actual DOM value.
	       Used to format / convert values for display in the control.
	 * ```js
	 * function formatter(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(formatter);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever the
	 *     view value has changed. It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * Angular provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if ( attrs.stripBr && html == '<br>' ) {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser == 'safari' || browser.params.browser == 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	var NgModelController = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$rootScope', '$q', '$interpolate',
	    function($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $rootScope, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	  this.$$parentForm = nullFormCtrl;
	
	  var parsedNgModel = $parse($attr.ngModel),
	      parsedNgModelAssign = parsedNgModel.assign,
	      ngModelGet = parsedNgModel,
	      ngModelSet = parsedNgModelAssign,
	      pendingDebounce = null,
	      parserValid,
	      ctrl = this;
	
	  this.$$setOptions = function(options) {
	    ctrl.$options = options;
	    if (options && options.getterSetter) {
	      var invokeModelGetter = $parse($attr.ngModel + '()'),
	          invokeModelSetter = $parse($attr.ngModel + '($$$p)');
	
	      ngModelGet = function($scope) {
	        var modelValue = parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      ngModelSet = function($scope, newValue) {
	        if (isFunction(parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: newValue});
	        } else {
	          parsedNgModelAssign($scope, newValue);
	        }
	      };
	    } else if (!parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', "Expression '{0}' is non-assignable. Element: {1}",
	          $attr.ngModel, startingTag($element));
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  this.$render = noop;
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  this.$isEmpty = function(value) {
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  };
	
	  this.$$updateEmptyClasses = function(value) {
	    if (ctrl.$isEmpty(value)) {
	      $animate.removeClass($element, NOT_EMPTY_CLASS);
	      $animate.addClass($element, EMPTY_CLASS);
	    } else {
	      $animate.removeClass($element, EMPTY_CLASS);
	      $animate.addClass($element, NOT_EMPTY_CLASS);
	    }
	  };
	
	
	  var currentValidationRunId = 0;
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setValidity
	   *
	   * @description
	   * Change the validity state, and notify the form.
	   *
	   * This method can be called within $parsers/$formatters or a custom validation implementation.
	   * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	   * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	   *
	   * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	   *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	   *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	   *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	   *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	   *        class and can be bound to as  `{{someForm.someControl.$error.myError}}` .
	   * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	   *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	   *                          Skipped is used by Angular when validators do not run because of parse errors and
	   *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	   */
	  addSetValidityMethod({
	    ctrl: this,
	    $element: $element,
	    set: function(object, property) {
	      object[property] = true;
	    },
	    unset: function(object, property) {
	      delete object[property];
	    },
	    $animate: $animate
	  });
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  this.$setPristine = function() {
	    ctrl.$dirty = false;
	    ctrl.$pristine = true;
	    $animate.removeClass($element, DIRTY_CLASS);
	    $animate.addClass($element, PRISTINE_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  this.$setDirty = function() {
	    ctrl.$dirty = true;
	    ctrl.$pristine = false;
	    $animate.removeClass($element, PRISTINE_CLASS);
	    $animate.addClass($element, DIRTY_CLASS);
	    ctrl.$$parentForm.$setDirty();
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  this.$setUntouched = function() {
	    ctrl.$touched = false;
	    ctrl.$untouched = true;
	    $animate.setClass($element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  this.$setTouched = function() {
	    ctrl.$touched = true;
	    ctrl.$untouched = false;
	    $animate.setClass($element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for a some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as blur, you can have a situation where there is a period when
	   * the `$viewValue` is out of sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because Angular's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode == 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *        <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *        empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *        <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *         <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                ng-keydown="setEmpty($event, 'value1')">
	   *         value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *        <p id="inputDescription2">With $rollbackViewValue():</p>
	   *         <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                ng-keydown="setEmpty($event, 'value2', true)">
	   *         value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */
	  this.$rollbackViewValue = function() {
	    $timeout.cancel(pendingDebounce);
	    ctrl.$viewValue = ctrl.$$lastCommittedViewValue;
	    ctrl.$render();
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  this.$validate = function() {
	    // ignore $validate before model is initialized
	    if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    var viewValue = ctrl.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = ctrl.$$rawModelValue;
	
	    var prevValid = ctrl.$valid;
	    var prevModelValue = ctrl.$modelValue;
	
	    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
	
	    ctrl.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check ctrl.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        ctrl.$modelValue = allValid ? modelValue : undefined;
	
	        if (ctrl.$modelValue !== prevModelValue) {
	          ctrl.$$writeModelToScope();
	        }
	      }
	    });
	
	  };
	
	  this.$$runValidators = function(modelValue, viewValue, doneCallback) {
	    currentValidationRunId++;
	    var localValidationRunId = currentValidationRunId;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = ctrl.$$parserName || 'parse';
	      if (isUndefined(parserValid)) {
	        setValidity(errorKey, null);
	      } else {
	        if (!parserValid) {
	          forEach(ctrl.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(ctrl.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, parserValid);
	        return parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(ctrl.$validators, function(validator, name) {
	        var result = validator(modelValue, viewValue);
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(ctrl.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(ctrl.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr('nopromise',
	            "Expected asynchronous validator to return a promise but got '{0}' instead.", promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function() {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        $q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === currentValidationRunId) {
	        ctrl.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  this.$commitViewValue = function() {
	    var viewValue = ctrl.$viewValue;
	
	    $timeout.cancel(pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (ctrl.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !ctrl.$$hasNativeValidators)) {
	      return;
	    }
	    ctrl.$$updateEmptyClasses(viewValue);
	    ctrl.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (ctrl.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  };
	
	  this.$$parseAndValidate = function() {
	    var viewValue = ctrl.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    parserValid = isUndefined(modelValue) ? undefined : true;
	
	    if (parserValid) {
	      for (var i = 0; i < ctrl.$parsers.length; i++) {
	        modelValue = ctrl.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumber(ctrl.$modelValue) && isNaN(ctrl.$modelValue)) {
	      // ctrl.$modelValue has not been touched yet...
	      ctrl.$modelValue = ngModelGet($scope);
	    }
	    var prevModelValue = ctrl.$modelValue;
	    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
	    ctrl.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      ctrl.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    ctrl.$$runValidators(modelValue, ctrl.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check ctrl.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        ctrl.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (ctrl.$modelValue !== prevModelValue) {
	        ctrl.$$writeModelToScope();
	      }
	    }
	  };
	
	  this.$$writeModelToScope = function() {
	    ngModelSet($scope, ctrl.$modelValue);
	    forEach(ctrl.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        $exceptionHandler(e);
	      }
	    });
	  };
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value sent directly for processing, finally to be applied to `$modelValue` and then the
	   * **expression** specified in the `ng-model` attribute. Lastly, all the registered change listeners,
	   * in the `$viewChangeListeners` list, are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realize that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  this.$setViewValue = function(value, trigger) {
	    ctrl.$viewValue = value;
	    if (!ctrl.$options || ctrl.$options.updateOnDefault) {
	      ctrl.$$debounceViewValueCommit(trigger);
	    }
	  };
	
	  this.$$debounceViewValueCommit = function(trigger) {
	    var debounceDelay = 0,
	        options = ctrl.$options,
	        debounce;
	
	    if (options && isDefined(options.debounce)) {
	      debounce = options.debounce;
	      if (isNumber(debounce)) {
	        debounceDelay = debounce;
	      } else if (isNumber(debounce[trigger])) {
	        debounceDelay = debounce[trigger];
	      } else if (isNumber(debounce['default'])) {
	        debounceDelay = debounce['default'];
	      }
	    }
	
	    $timeout.cancel(pendingDebounce);
	    if (debounceDelay) {
	      pendingDebounce = $timeout(function() {
	        ctrl.$commitViewValue();
	      }, debounceDelay);
	    } else if ($rootScope.$$phase) {
	      ctrl.$commitViewValue();
	    } else {
	      $scope.$apply(function() {
	        ctrl.$commitViewValue();
	      });
	    }
	  };
	
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  $scope.$watch(function ngModelWatch() {
	    var modelValue = ngModelGet($scope);
	
	    // if scope model value and ngModel value are out of sync
	    // TODO(perf): why not move this to the action fn?
	    if (modelValue !== ctrl.$modelValue &&
	       // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	       (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$modelValue = ctrl.$$rawModelValue = modelValue;
	      parserValid = undefined;
	
	      var formatters = ctrl.$formatters,
	          idx = formatters.length;
	
	      var viewValue = modelValue;
	      while (idx--) {
	        viewValue = formatters[idx](viewValue);
	      }
	      if (ctrl.$viewValue !== viewValue) {
	        ctrl.$$updateEmptyClasses(viewValue);
	        ctrl.$viewValue = ctrl.$$lastCommittedViewValue = viewValue;
	        ctrl.$render();
	
	        ctrl.$$runValidators(modelValue, viewValue, noop);
	      }
	    }
	
	    return modelValue;
	  });
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 *
	 * @element input
	 * @priority 1
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * # Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * # CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	 *     by the {@link ngModel.NgModelController#$isEmpty} method
	 *  - `ng-not-empty`: the view contains a non-empty value
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * ## Animation Hooks
	 *
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * ## Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because Angular is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || modelCtrl.$$parentForm;
	
	          modelCtrl.$$setOptions(ctrls[2] && ctrls[2].$options);
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            modelCtrl.$$parentForm.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          if (modelCtrl.$options && modelCtrl.$options.updateOn) {
	            element.on(modelCtrl.$options.updateOn, function(ev) {
	              modelCtrl.$$debounceViewValueCommit(ev && ev.type);
	            });
	          }
	
	          element.on('blur', function() {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(modelCtrl.$setTouched);
	            } else {
	              scope.$apply(modelCtrl.$setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 *
	 * @description
	 * Allows tuning how model updates are done. Using `ngModelOptions` you can specify a custom list of
	 * events that will trigger a model update and/or a debouncing delay so that the actual update only
	 * takes place when a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController `$rollbackViewValue`} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController `$rollbackViewValue`}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * `ngModelOptions` has an effect on the element it's declared on and its descendants.
	 *
	 * @param {Object} ngModelOptions options to apply to the current model. Valid keys are:
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging of the control.
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     `ng-model-options="{ updateOn: 'default blur', debounce: { 'default': 500, 'blur': 0 } }"`
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	       `ngModel` as getters/setters.
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date">`, `<input type="time">`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *
	 * @example
	
	  The following example shows how to override immediate updates. Changes on the inputs within the
	  form will update the model only when the control loses focus (blur event). If `escape` key is
	  pressed while the input field is focused, the value is reset to the value in the current model.
	
	  <example name="ngModelOptions-directive-blur" module="optionsExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ updateOn: 'blur' }"
	                   ng-keyup="cancel($event)" />
	          </label><br />
	          <label>Other data:
	            <input type="text" ng-model="user.data" />
	          </label><br />
	        </form>
	        <pre>user.name = <span ng-bind="user.name"></span></pre>
	        <pre>user.data = <span ng-bind="user.data"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.user = { name: 'John', data: '' };
	
	          $scope.cancel = function(e) {
	            if (e.keyCode == 27) {
	              $scope.userForm.userName.$rollbackViewValue();
	            }
	          };
	        }]);
	    </file>
	    <file name="protractor.js" type="protractor">
	      var model = element(by.binding('user.name'));
	      var input = element(by.model('user.name'));
	      var other = element(by.model('user.data'));
	
	      it('should allow custom events', function() {
	        input.sendKeys(' Doe');
	        input.click();
	        expect(model.getText()).toEqual('John');
	        other.click();
	        expect(model.getText()).toEqual('John Doe');
	      });
	
	      it('should $rollbackViewValue when model changes', function() {
	        input.sendKeys(' Doe');
	        expect(input.getAttribute('value')).toEqual('John Doe');
	        input.sendKeys(protractor.Key.ESCAPE);
	        expect(input.getAttribute('value')).toEqual('John');
	        other.click();
	        expect(model.getText()).toEqual('John');
	      });
	    </file>
	  </example>
	
	  This one shows how to debounce model changes. Model will be updated only 1 sec after last change.
	  If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	
	  <example name="ngModelOptions-directive-debounce" module="optionsExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ debounce: 1000 }" />
	          </label>
	          <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button>
	          <br />
	        </form>
	        <pre>user.name = <span ng-bind="user.name"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.user = { name: 'Igor' };
	        }]);
	    </file>
	  </example>
	
	  This one shows how to bind to getter/setters:
	
	  <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form name="userForm">
	          <label>Name:
	            <input type="text" name="userName"
	                   ng-model="user.name"
	                   ng-model-options="{ getterSetter: true }" />
	          </label>
	        </form>
	        <pre>user.name = <span ng-bind="user.name()"></span></pre>
	      </div>
	    </file>
	    <file name="app.js">
	      angular.module('getterSetterExample', [])
	        .controller('ExampleController', ['$scope', function($scope) {
	          var _name = 'Brian';
	          $scope.user = {
	            name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	            }
	          };
	        }]);
	    </file>
	  </example>
	 */
	var ngModelOptionsDirective = function() {
	  return {
	    restrict: 'A',
	    controller: ['$scope', '$attrs', function($scope, $attrs) {
	      var that = this;
	      this.$options = copy($scope.$eval($attrs.ngModelOptions));
	      // Allow adding/overriding bound events
	      if (isDefined(this.$options.updateOn)) {
	        this.$options.updateOnDefault = false;
	        // extract "default" pseudo-event from list of events that can trigger a model update
	        this.$options.updateOn = trim(this.$options.updateOn.replace(DEFAULT_REGEXP, function() {
	          that.$options.updateOnDefault = true;
	          return ' ';
	        }));
	      } else {
	        this.$options.updateOnDefault = true;
	      }
	    }]
	  };
	};
	
	
	
	// helper methods
	function addSetValidityMethod(context) {
	  var ctrl = context.ctrl,
	      $element = context.$element,
	      classCache = {},
	      set = context.set,
	      unset = context.unset,
	      $animate = context.$animate;
	
	  classCache[INVALID_CLASS] = !(classCache[VALID_CLASS] = $element.hasClass(VALID_CLASS));
	
	  ctrl.$setValidity = setValidity;
	
	  function setValidity(validationErrorKey, state, controller) {
	    if (isUndefined(state)) {
	      createAndSet('$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup('$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(ctrl.$error, validationErrorKey, controller);
	      unset(ctrl.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(ctrl.$error, validationErrorKey, controller);
	        set(ctrl.$$success, validationErrorKey, controller);
	      } else {
	        set(ctrl.$error, validationErrorKey, controller);
	        unset(ctrl.$$success, validationErrorKey, controller);
	      }
	    }
	    if (ctrl.$pending) {
	      cachedToggleClass(PENDING_CLASS, true);
	      ctrl.$valid = ctrl.$invalid = undefined;
	      toggleValidationCss('', null);
	    } else {
	      cachedToggleClass(PENDING_CLASS, false);
	      ctrl.$valid = isObjectEmpty(ctrl.$error);
	      ctrl.$invalid = !ctrl.$valid;
	      toggleValidationCss('', ctrl.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in ctrl.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (ctrl.$pending && ctrl.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (ctrl.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (ctrl.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(validationErrorKey, combinedState);
	    ctrl.$$parentForm.$setValidity(validationErrorKey, combinedState, ctrl);
	  }
	
	  function createAndSet(name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(className, switchValue) {
	    if (switchValue && !classCache[className]) {
	      $animate.addClass($element, className);
	      classCache[className] = true;
	    } else if (!switchValue && classCache[className]) {
	      $animate.removeClass($element, className);
	      classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 *
	 * @description
	 * The `ngNonBindable` directive tells Angular not to compile or bind the contents of the current
	 * DOM element. This is useful if the element contains what appears to be Angular directives and
	 * bindings but which should be ignored by Angular. This could be the case if you have a site that
	 * displays snippets of code, for instance.
	 *
	 * @element ANY
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	 * @example
	    <example>
	      <file name="index.html">
	        <div>Normal: {{1 + 2}}</div>
	        <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	      </file>
	      <file name="protractor.js" type="protractor">
	       it('should check ng-non-bindable', function() {
	         expect(element(by.binding('1 + 2')).getText()).toContain('3');
	         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	       });
	      </file>
	    </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/* global jqLiteRemove */
	
	var ngOptionsMinErr = minErr('ngOptions');
	
	/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of `ngOptions` to achieve a
	 * similar result. However, `ngOptions` provides some benefits such as reducing memory and
	 * increasing speed by not creating a new scope for each repeated instance, as well as providing
	 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression. `ngOptions` should be used when the `<select>` model needs to be bound
	 *  to a non-string value. This is because an option element can only be bound to string values at
	 * present.
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {comprehension_expression=} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 *
	 * @example
	    <example module="selectExample">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	// jshint maxlen: false
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555550000000006666666666666660000000777777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	                        // 1: value expression (valueFn)
	                        // 2: label expression (displayFn)
	                        // 3: group by expression (groupByFn)
	                        // 4: disable when expression (disableWhenFn)
	                        // 5: array item variable name
	                        // 6: object item key variable name
	                        // 7: object item value variable name
	                        // 8: collection expression
	                        // 9: track by expression
	// jshint maxlen: 100
	
	
	var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
	
	  function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	    var match = optionsExp.match(NG_OPTIONS_REGEXP);
	    if (!(match)) {
	      throw ngOptionsMinErr('iexp',
	        "Expected expression in form of " +
	        "'_select_ (as _label_)? for (_key_,)?_value_ in _collection_'" +
	        " but got '{0}'. Element: {1}",
	        optionsExp, startingTag(selectElement));
	    }
	
	    // Extract the parts from the ngOptions expression
	
	    // The variable name for the value of the item in the collection
	    var valueName = match[5] || match[7];
	    // The variable name for the key of the item in the collection
	    var keyName = match[6];
	
	    // An expression that generates the viewValue for an option if there is a label expression
	    var selectAs = / as /.test(match[0]) && match[1];
	    // An expression that is used to track the id of each object in the options collection
	    var trackBy = match[9];
	    // An expression that generates the viewValue for an option if there is no label expression
	    var valueFn = $parse(match[2] ? match[1] : valueName);
	    var selectAsFn = selectAs && $parse(selectAs);
	    var viewValueFn = selectAsFn || valueFn;
	    var trackByFn = trackBy && $parse(trackBy);
	
	    // Get the value by which we are going to track the option
	    // if we have a trackFn then use that (passing scope and locals)
	    // otherwise just hash the given viewValue
	    var getTrackByValueFn = trackBy ?
	                              function(value, locals) { return trackByFn(scope, locals); } :
	                              function getHashOfValue(value) { return hashKey(value); };
	    var getTrackByValue = function(value, key) {
	      return getTrackByValueFn(value, getLocals(value, key));
	    };
	
	    var displayFn = $parse(match[2] || match[1]);
	    var groupByFn = $parse(match[3] || '');
	    var disableWhenFn = $parse(match[4] || '');
	    var valuesFn = $parse(match[8]);
	
	    var locals = {};
	    var getLocals = keyName ? function(value, key) {
	      locals[keyName] = key;
	      locals[valueName] = value;
	      return locals;
	    } : function(value) {
	      locals[valueName] = value;
	      return locals;
	    };
	
	
	    function Option(selectValue, viewValue, label, group, disabled) {
	      this.selectValue = selectValue;
	      this.viewValue = viewValue;
	      this.label = label;
	      this.group = group;
	      this.disabled = disabled;
	    }
	
	    function getOptionValuesKeys(optionValues) {
	      var optionValuesKeys;
	
	      if (!keyName && isArrayLike(optionValues)) {
	        optionValuesKeys = optionValues;
	      } else {
	        // if object, extract keys, in enumeration order, unsorted
	        optionValuesKeys = [];
	        for (var itemKey in optionValues) {
	          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	            optionValuesKeys.push(itemKey);
	          }
	        }
	      }
	      return optionValuesKeys;
	    }
	
	    return {
	      trackBy: trackBy,
	      getTrackByValue: getTrackByValue,
	      getWatchables: $parse(valuesFn, function(optionValues) {
	        // Create a collection of things that we would like to watch (watchedArray)
	        // so that they can all be watched using a single $watchCollection
	        // that only runs the handler once if anything changes
	        var watchedArray = [];
	        optionValues = optionValues || [];
	
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	
	          var locals = getLocals(value, key);
	          var selectValue = getTrackByValueFn(value, locals);
	          watchedArray.push(selectValue);
	
	          // Only need to watch the displayFn if there is a specific label expression
	          if (match[2] || match[1]) {
	            var label = displayFn(scope, locals);
	            watchedArray.push(label);
	          }
	
	          // Only need to watch the disableWhenFn if there is a specific disable expression
	          if (match[4]) {
	            var disableWhen = disableWhenFn(scope, locals);
	            watchedArray.push(disableWhen);
	          }
	        }
	        return watchedArray;
	      }),
	
	      getOptions: function() {
	
	        var optionItems = [];
	        var selectValueMap = {};
	
	        // The option values were already computed in the `getWatchables` fn,
	        // which must have been called to trigger `getOptions`
	        var optionValues = valuesFn(scope) || [];
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	          var locals = getLocals(value, key);
	          var viewValue = viewValueFn(scope, locals);
	          var selectValue = getTrackByValueFn(viewValue, locals);
	          var label = displayFn(scope, locals);
	          var group = groupByFn(scope, locals);
	          var disabled = disableWhenFn(scope, locals);
	          var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	          optionItems.push(optionItem);
	          selectValueMap[selectValue] = optionItem;
	        }
	
	        return {
	          items: optionItems,
	          selectValueMap: selectValueMap,
	          getOptionFromViewValue: function(value) {
	            return selectValueMap[getTrackByValue(value)];
	          },
	          getViewValueFromOption: function(option) {
	            // If the viewValue could be an object that may be mutated by the application,
	            // we need to make a copy and not return the reference to the value on the option.
	            return trackBy ? angular.copy(option.viewValue) : option.viewValue;
	          }
	        };
	      }
	    };
	  }
	
	
	  // we can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  var optionTemplate = window.document.createElement('option'),
	      optGroupTemplate = window.document.createElement('optgroup');
	
	    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      var emptyOption;
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      var providedEmptyOption = !!emptyOption;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	      // This stores the newly created options before they are appended to the select.
	      // Since the contents are removed from the fragment when it is appended,
	      // we only need to create it once.
	      var listFragment = $document[0].createDocumentFragment();
	
	      var renderEmptyOption = function() {
	        if (!providedEmptyOption) {
	          selectElement.prepend(emptyOption);
	        }
	        selectElement.val('');
	        emptyOption.prop('selected', true); // needed for IE
	        emptyOption.attr('selected', true);
	      };
	
	      var removeEmptyOption = function() {
	        if (!providedEmptyOption) {
	          emptyOption.remove();
	        }
	      };
	
	
	      var renderUnknownOption = function() {
	        selectElement.prepend(unknownOption);
	        selectElement.val('?');
	        unknownOption.prop('selected', true); // needed for IE
	        unknownOption.attr('selected', true);
	      };
	
	      var removeUnknownOption = function() {
	        unknownOption.remove();
	      };
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          var option = options.getOptionFromViewValue(value);
	
	          if (option) {
	            // Don't update the option when it is already selected.
	            // For example, the browser will select the first option by default. In that case,
	            // most properties are set automatically - except the `selected` attribute, which we
	            // set always
	
	            if (selectElement[0].value !== option.selectValue) {
	              removeUnknownOption();
	              removeEmptyOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	            }
	
	            option.element.setAttribute('selected', 'selected');
	          } else {
	            if (value === null || providedEmptyOption) {
	              removeUnknownOption();
	              renderEmptyOption();
	            } else {
	              removeEmptyOption();
	              renderUnknownOption();
	            }
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            removeEmptyOption();
	            removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(value) {
	          options.items.forEach(function(option) {
	            option.element.selected = false;
	          });
	
	          if (value) {
	            value.forEach(function(item) {
	              var option = options.getOptionFromViewValue(item);
	              if (option) option.element.selected = true;
	            });
	          }
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	              selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	
	      if (providedEmptyOption) {
	
	        // we need to remove it before calling selectElement.empty() because otherwise IE will
	        // remove the label from the element. wtf?
	        emptyOption.remove();
	
	        // compile the element since there might be bindings in it
	        $compile(emptyOption)(scope);
	
	        // remove the class, which is added automatically because we recompile the element and it
	        // becomes the compilation root
	        emptyOption.removeClass('ng-scope');
	      } else {
	        emptyOption = jqLite(optionTemplate.cloneNode(false));
	      }
	
	      selectElement.empty();
	
	      // We need to do this here to ensure that the options object is defined
	      // when we first hit it in writeNgOptionsValue
	      updateOptions();
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	      function addOptionElement(option, parent) {
	        var optionElement = optionTemplate.cloneNode(false);
	        parent.appendChild(optionElement);
	        updateOptionElement(option, optionElement);
	      }
	
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        // NOTE: The label must be set before the value, otherwise IE10/11/EDGE create unresponsive
	        // selects in certain circumstances when multiple selects are next to each other and display
	        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	        // See https://github.com/angular/angular.js/issues/11314 for more info.
	        // This is unfortunately untestable with unit / e2e tests
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	        if (option.value !== element.value) element.value = option.selectValue;
	      }
	
	      function updateOptions() {
	        var previousValue = options && selectCtrl.readValue();
	
	        // We must remove all current options, but cannot simply set innerHTML = null
	        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
	        // must preserve.
	        // Instead, iterate over the current option elements and remove them or their optgroup
	        // parents
	        if (options) {
	
	          for (var i = options.items.length - 1; i >= 0; i--) {
	            var option = options.items[i];
	            if (option.group) {
	              jqLiteRemove(option.element.parentNode);
	            } else {
	              jqLiteRemove(option.element);
	            }
	          }
	        }
	
	        options = ngOptions.getOptions();
	
	        var groupElementMap = {};
	
	        // Ensure that the empty option is always there if it was explicitly provided
	        if (providedEmptyOption) {
	          selectElement.prepend(emptyOption);
	        }
	
	        options.items.forEach(function addOption(option) {
	          var groupElement;
	
	          if (isDefined(option.group)) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            groupElement = groupElementMap[option.group];
	
	            if (!groupElement) {
	
	              groupElement = optGroupTemplate.cloneNode(false);
	              listFragment.appendChild(groupElement);
	
	              // Update the label on the group element
	              groupElement.label = option.group;
	
	              // Store it for use later
	              groupElementMap[option.group] = groupElement;
	            }
	
	            addOptionElement(option, groupElement);
	
	          } else {
	
	            // This option is not in a group
	            addOptionElement(option, listFragment);
	          }
	        });
	
	        selectElement[0].appendChild(listFragment);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          var isNotPrimitive = ngOptions.trackBy || multiple;
	          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	
	      }
	  }
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    require: ['select', 'ngModel'],
	    link: {
	      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
	        // Deactivate the SelectController.register method to prevent
	        // option directives from accidentally registering themselves
	        // (and unwanted $destroy handlers etc.)
	        ctrls[0].registerOption = noop;
	      },
	      post: ngOptionsPostLink
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n Angular i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * # Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in Angular's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * # Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * Angular expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, Angular will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * # Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and Angular uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to explicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNumber(lastCount) && isNaN(lastCount))) {
	          watchRemover();
	          var whenExpFn = whensExpFns[count];
	          if (isUndefined(whenExpFn)) {
	            if (newVal != null) {
	              $log.debug("ngPluralize: no rule defined for '" + count + "' in " + whenExp);
	            }
	            watchRemover = noop;
	            updateElementText();
	          } else {
	            watchRemover = scope.$watch(whenExpFn, updateElementText);
	          }
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * # Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * However, there are a limitations compared to array iteration:
	 *
	 * - The JavaScript specification does not define the order of keys
	 *   returned for an object, so Angular relies on the order returned by the browser
	 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	 *   and reinstated. See the
	 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	 *   it's a prefix used by Angular for public (`$`) and private (`$$`) properties.
	 *
	 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	 *   objects, and will throw if used with one.
	 *
	 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * # Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, ngRepeat then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, ngRepeat will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * The default tracking function (which tracks items by their identity) does not allow
	 * duplicate items in arrays. This is because when there are duplicates, it is not possible
	 * to maintain a one-to-one mapping between collection items and DOM elements.
	 *
	 * If you do need to repeat duplicate items, you can substitute the default tracking behavior
	 * with your own using the `track by` expression.
	 *
	 * For example, you may track items by the index of each item in the collection, using the
	 * special scope property `$index`:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by $index">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * You may also use arbitrary expressions in `track by`, including references to custom functions
	 * on the scope:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by myTrackingFunction(n)">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * <div class="alert alert-success">
	 * If you are working with objects that have an identifier property, you should track
	 * by the identifier instead of the whole object. Should you reload your data later, `ngRepeat`
	 * will not have to rebuild the DOM elements for items it has already rendered, even if the
	 * JavaScript objects in the collection have been substituted for new ones. For large collections,
	 * this significantly improves rendering performance. If you don't have a unique identifier,
	 * `track by $index` can also provide a performance boost.
	 * </div>
	 * ```html
	 *    <div ng-repeat="model in collection track by model.id">
	 *      {{model.name}}
	 *    </div>
	 * ```
	 *
	 * When no `track by` expression is provided, it is equivalent to tracking by the built-in
	 * `$id` function, which tracks items by their identity:
	 * ```html
	 *    <div ng-repeat="obj in collection track by $id(obj)">
	 *      {{obj.prop}}
	 *    </div>
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** `track by` must always be the last expression:
	 * </div>
	 * ```
	 * <div ng-repeat="model in collection | orderBy: 'id' as filtered_result track by model.id">
	 *     {{model.name}}
	 * </div>
	 * ```
	 *
	 * # Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	 *
	 * See the example below for defining CSS animations with ngRepeat.
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     Note that the tracking expression must come last, after any filters, and the alias expression.
	 *
	 *     For example: `item in items` is equivalent to `item in items track by $id(item)`. This implies that the DOM elements
	 *     will be associated by item identity in the array.
	 *
	 *     For example: `item in items track by $id(item)`. A built in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the array. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the array by identity. Moving the same object in array would move the DOM
	 *     element in the same way in the DOM.
	 *
	 *     For example: `item in items track by item.id` is a typical pattern when the items come from the database. In this
	 *     case the object identity does not matter. Two objects are considered equivalent as long as their `id`
	 *     property is same.
	 *
	 *     For example: `item in items | filter:searchText track by item.id` is a pattern that might be used to apply a filter
	 *     to items in conjunction with a tracking expression.
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat micro-syntax so it can be used only at the end
	 *     (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results` .
	 *
	 * @example
	 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	 * results by name. New (entering) and removed (leaving) items are animated.
	  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length == 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // jshint bitwise: false
	    scope.$odd = !(scope.$even = (index&1) === 0);
	    // jshint bitwise: true
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[\$\w]+)|\(\s*([\$\w]+)\s*,\s*([\$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', "'_item_' in '_item_ in _collection_' should be an identifier or '(_key_, _value_)' expression, but got '{0}'.",
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', "alias '{0}' is invalid --- must be a valid JS identifier which is not a reserved name.",
	          aliasAs);
	      }
	
	      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
	      var hashFnLocals = {$id: hashKey};
	
	      if (trackByExp) {
	        trackByExpGetter = $parse(trackByExp);
	      } else {
	        trackByIdArrayFn = function(key, value) {
	          return hashKey(value);
	        };
	        trackByIdObjFn = function(key) {
	          return key;
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        if (trackByExpGetter) {
	          trackByIdExpFn = function(key, value, index) {
	            // assign key, value, and $index to the locals so that they can be used in hash functions
	            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	            hashFnLocals[valueIdentifier] = value;
	            hashFnLocals.$index = index;
	            return trackByExpGetter($scope, hashFnLocals);
	          };
	        }
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - element: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, in enumeration order, unsorted
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn(key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  "Duplicates in a repeater are not allowed. Use 'track by' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}",
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) != nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, previousNode);
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                $animate.enter(clone, null, previousNode);
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression
	 * provided to the `ngShow` attribute. The element is shown or hidden by removing or adding
	 * the `.ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
	 * in AngularJS and sets the display style to none (using an !important flag).
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added to the class
	 * attribute on the element causing it to become hidden. When truthy, the `.ng-hide` CSS class is removed
	 * from the element causing the element not to appear hidden.
	 *
	 * ## Why is !important used?
	 *
	 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
	 * can be easily overridden by heavier selectors. For example, something as simple
	 * as changing the display style on a HTML list item would make hidden elements appear visible.
	 * This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
	 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
	 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
	 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
	 * class CSS. Note that the selector that needs to be used is actually `.ng-hide:not(.ng-hide-animate)` to cope
	 * with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; this is just another form of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the display style.
	 *
	 * ## A note about animations with `ngShow`
	 *
	 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
	 * is true and false. This system works like the animation system present with ngClass except that
	 * you must also include the !important flag to override the display property
	 * so that you can perform an animation when the element is hidden during the time of the animation.
	 *
	 * ```css
	 * //
	 * //a working example can be found at the bottom of this page
	 * //
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   /&#42; this is required as of 1.3x to properly
	 *      apply all styling in a show/hide animation &#42;/
	 *   transition: 0s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add-active,
	 * .my-element.ng-hide-remove-active {
	 *   /&#42; the transition is defined in the active class &#42;/
	 *   transition: 1s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display
	 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`  | after the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden |
	 * | {@link $animate#removeClass removeClass}  `.ng-hide`  | after the `ngShow` expression evaluates to a truthy value and just before contents are set to visible |
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy
	 *     then the element is shown or hidden respectively.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br/>
	      <div>
	        Show:
	        <div class="check-element animate-show" ng-show="checked">
	          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
	        </div>
	      </div>
	      <div>
	        Hide:
	        <div class="check-element animate-show" ng-hide="checked">
	          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
	        </div>
	      </div>
	    </file>
	    <file name="glyphicons.css">
	      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
	    </file>
	    <file name="animations.css">
	      .animate-show {
	        line-height: 20px;
	        opacity: 1;
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	
	      .animate-show.ng-hide-add, .animate-show.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .animate-show.ng-hide {
	        line-height: 0;
	        opacity: 0;
	        padding: 0 10px;
	      }
	
	      .check-element {
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
	      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));
	
	      it('should check ng-show / ng-hide', function() {
	        expect(thumbsUp.isDisplayed()).toBeFalsy();
	        expect(thumbsDown.isDisplayed()).toBeTruthy();
	
	        element(by.model('checked')).click();
	
	        expect(thumbsUp.isDisplayed()).toBeTruthy();
	        expect(thumbsDown.isDisplayed()).toBeFalsy();
	      });
	    </file>
	  </example>
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression
	 * provided to the `ngHide` attribute. The element is shown or hidden by removing or adding
	 * the `ng-hide` CSS class onto the element. The `.ng-hide` CSS class is predefined
	 * in AngularJS and sets the display style to none (using an !important flag).
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added to the class
	 * attribute on the element causing it to become hidden. When falsy, the `.ng-hide` CSS class is removed
	 * from the element causing the element not to appear hidden.
	 *
	 * ## Why is !important used?
	 *
	 * You may be wondering why !important is used for the `.ng-hide` CSS class. This is because the `.ng-hide` selector
	 * can be easily overridden by heavier selectors. For example, something as simple
	 * as changing the display style on a HTML list item would make hidden elements appear visible.
	 * This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using !important, the show and hide behavior will work as expected despite any clash between CSS selector
	 * specificity (when !important isn't used with any conflicting styles). If a developer chooses to override the
	 * styling to change how to hide an element then it is just a matter of using !important in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none!important`. If you wish to change
	 * the hide behavior with ngShow/ngHide then this can be achieved by restating the styles for the `.ng-hide`
	 * class in CSS:
	 *
	 * ```css
	 * .ng-hide {
	 *   /&#42; this is just another form of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the display style.
	 *
	 * ## A note about animations with `ngHide`
	 *
	 * Animations in ngShow/ngHide work with the show and hide events that are triggered when the directive expression
	 * is true and false. This system works like the animation system present with ngClass, except that the `.ng-hide`
	 * CSS class is added and removed for you instead of your own CSS class.
	 *
	 * ```css
	 * //
	 * //a working example can be found at the bottom of this page
	 * //
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: 0.5s linear all;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display
	 * property to block during animation states--ngAnimate will handle the style toggling automatically for you.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`  | after the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden |
	 * | {@link $animate#removeClass removeClass}  `.ng-hide`  | after the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible |
	 *
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy then
	 *     the element is shown or hidden respectively.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      Click me: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br/>
	      <div>
	        Show:
	        <div class="check-element animate-hide" ng-show="checked">
	          <span class="glyphicon glyphicon-thumbs-up"></span> I show up when your checkbox is checked.
	        </div>
	      </div>
	      <div>
	        Hide:
	        <div class="check-element animate-hide" ng-hide="checked">
	          <span class="glyphicon glyphicon-thumbs-down"></span> I hide when your checkbox is checked.
	        </div>
	      </div>
	    </file>
	    <file name="glyphicons.css">
	      @import url(../../components/bootstrap-3.1.1/css/bootstrap.css);
	    </file>
	    <file name="animations.css">
	      .animate-hide {
	        transition: all linear 0.5s;
	        line-height: 20px;
	        opacity: 1;
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	
	      .animate-hide.ng-hide {
	        line-height: 0;
	        opacity: 0;
	        padding: 0 10px;
	      }
	
	      .check-element {
	        padding: 10px;
	        border: 1px solid black;
	        background: white;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var thumbsUp = element(by.css('span.glyphicon-thumbs-up'));
	      var thumbsDown = element(by.css('span.glyphicon-thumbs-down'));
	
	      it('should check ng-show / ng-hide', function() {
	        expect(thumbsUp.isDisplayed()).toBeFalsy();
	        expect(thumbsDown.isDisplayed()).toBeTruthy();
	
	        element(by.model('checked')).click();
	
	        expect(thumbsUp.isDisplayed()).toBeTruthy();
	        expect(thumbsDown.isDisplayed()).toBeFalsy();
	      });
	    </file>
	  </example>
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example>
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      forEach(oldStyles, function(val, style) { element.css(style, '');});
	    }
	    if (newStyles) element.css(newStyles);
	  }, true);
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function ngSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function() { array.splice(index, 1); };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	        for (i = 0, ii = previousLeaveAnimations.length; i < ii; ++i) {
	          $animate.cancel(previousLeaveAnimations[i]);
	        }
	        previousLeaveAnimations.length = 0;
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var promise = previousLeaveAnimations[i] = $animate.leave(selected);
	          promise.then(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	    ctrl.cases['!' + attrs.ngSwitchWhen] = (ctrl.cases['!' + attrs.ngSwitchWhen] || []);
	    ctrl.cases['!' + attrs.ngSwitchWhen].push({ transclude: $transclude, element: element });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	 *
	 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	 * content of this element will be removed before the transcluded content is inserted.
	 * If the transcluded content is empty, the existing content is left intact. This lets you provide fallback content in the case
	 * that no transcluded content is provided.
	 *
	 * @element ANY
	 *
	 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	 *                                               or its value is the same as the name of the attribute then the default slot is used.
	 *
	 * @example
	 * ### Basic transclusion
	 * This example demonstrates basic transclusion of content into a component directive.
	 * <example name="simpleTranscludeExample" module="transcludeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('transcludeExample', [])
	 *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input ng-model="title" aria-label="title"> <br/>
	 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *       <pane title="{{title}}">{{text}}</pane>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Transclude fallback content
	 * This example shows how to use `NgTransclude` with fallback content, that
	 * is displayed if no transcluded content is provided.
	 *
	 * <example module="transcludeFallbackContentExample">
	 * <file name="index.html">
	 * <script>
	 * angular.module('transcludeFallbackContentExample', [])
	 * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	 * </script>
	 * <!-- fallback button content -->
	 * <my-button id="fallback"></my-button>
	 * <!-- modified button content -->
	 * <my-button id="modified">
	 *   <i style="color: green;">Button2</i>
	 * </my-button>
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	 * </file>
	 * </example>
	 *
	 * @example
	 * ### Multi-slot transclusion
	 * This example demonstrates using multi-slot transclusion in a component directive.
	 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	 *   <file name="index.html">
	 *    <style>
	 *      .title, .footer {
	 *        background-color: gray
	 *      }
	 *    </style>
	 *    <div ng-controller="ExampleController">
	 *      <input ng-model="title" aria-label="title"> <br/>
	 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *      <pane>
	 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	 *        <pane-body><p>{{text}}</p></pane-body>
	 *      </pane>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('multiSlotTranscludeExample', [])
	 *     .directive('pane', function(){
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = "https://google.com";
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	 *   </file>
	 * </example>
	 */
	var ngTranscludeMinErr = minErr('ngTransclude');
	var ngTranscludeDirective = ngDirective({
	  restrict: 'EAC',
	  link: function($scope, $element, $attrs, controller, $transclude) {
	
	    if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
	      // If the attribute is of the form: `ng-transclude="ng-transclude"`
	      // then treat it like the default
	      $attrs.ngTransclude = '';
	    }
	
	    function ngTranscludeCloneAttachFn(clone) {
	      if (clone.length) {
	        $element.empty();
	        $element.append(clone);
	      }
	    }
	
	    if (!$transclude) {
	      throw ngTranscludeMinErr('orphan',
	       'Illegal use of ngTransclude directive in the template! ' +
	       'No parent directive that requires a transclusion found. ' +
	       'Element: {0}',
	       startingTag($element));
	    }
	
	    // If there is no slot name defined or the slot name is not optional
	    // then transclude the slot
	    var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
	    $transclude(ngTranscludeCloneAttachFn, null, slotName);
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example>
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type == 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	function chromeHack(optionElement) {
	  // Workaround for https://code.google.com/p/chromium/issues/detail?id=381459
	  // Adding an <option selected="selected"> element to a <select required="required"> should
	  // automatically select the new element
	  if (optionElement[0].hasAttribute('selected')) {
	    optionElement[0].selected = true;
	  }
	}
	
	/**
	 * @ngdoc type
	 * @name  select.SelectController
	 * @description
	 * The controller for the `<select>` directive. This provides support for reading
	 * and writing the selected value(s) of the control and also coordinates dynamically
	 * added `<option>` elements, perhaps by an `ngRepeat` directive.
	 */
	var SelectController =
	        ['$element', '$scope', function($element, $scope) {
	
	  var self = this,
	      optionsMap = new HashMap();
	
	  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	  self.ngModelCtrl = noopNgModelController;
	
	  // The "unknown" option is one that is prepended to the list if the viewValue
	  // does not match any of the options. When it is rendered the value of the unknown
	  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	  //
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  self.unknownOption = jqLite(window.document.createElement('option'));
	  self.renderUnknownOption = function(val) {
	    var unknownVal = '? ' + hashKey(val) + ' ?';
	    self.unknownOption.val(unknownVal);
	    $element.prepend(self.unknownOption);
	    $element.val(unknownVal);
	  };
	
	  $scope.$on('$destroy', function() {
	    // disable unknown option so that we don't do work when the whole select is being destroyed
	    self.renderUnknownOption = noop;
	  });
	
	  self.removeUnknownOption = function() {
	    if (self.unknownOption.parent()) self.unknownOption.remove();
	  };
	
	
	  // Read the value of the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.readValue = function readSingleValue() {
	    self.removeUnknownOption();
	    return $element.val();
	  };
	
	
	  // Write the value to the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.writeValue = function writeSingleValue(value) {
	    if (self.hasOption(value)) {
	      self.removeUnknownOption();
	      $element.val(value);
	      if (value === '') self.emptyOption.prop('selected', true); // to make IE9 happy
	    } else {
	      if (value == null && self.emptyOption) {
	        self.removeUnknownOption();
	        $element.val('');
	      } else {
	        self.renderUnknownOption(value);
	      }
	    }
	  };
	
	
	  // Tell the select control that an option, with the given value, has been added
	  self.addOption = function(value, element) {
	    // Skip comment nodes, as they only pollute the `optionsMap`
	    if (element[0].nodeType === NODE_TYPE_COMMENT) return;
	
	    assertNotHasOwnProperty(value, '"option value"');
	    if (value === '') {
	      self.emptyOption = element;
	    }
	    var count = optionsMap.get(value) || 0;
	    optionsMap.put(value, count + 1);
	    self.ngModelCtrl.$render();
	    chromeHack(element);
	  };
	
	  // Tell the select control that an option, with the given value, has been removed
	  self.removeOption = function(value) {
	    var count = optionsMap.get(value);
	    if (count) {
	      if (count === 1) {
	        optionsMap.remove(value);
	        if (value === '') {
	          self.emptyOption = undefined;
	        }
	      } else {
	        optionsMap.put(value, count - 1);
	      }
	    }
	  };
	
	  // Check whether the select control has an option matching the given value
	  self.hasOption = function(value) {
	    return !!optionsMap.get(value);
	  };
	
	
	  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
	
	    if (interpolateValueFn) {
	      // The value attribute is interpolated
	      var oldVal;
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	        if (isDefined(oldVal)) {
	          self.removeOption(oldVal);
	        }
	        oldVal = newVal;
	        self.addOption(newVal, optionElement);
	      });
	    } else if (interpolateTextFn) {
	      // The text content is interpolated
	      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
	        optionAttrs.$set('value', newVal);
	        if (oldVal !== newVal) {
	          self.removeOption(oldVal);
	        }
	        self.addOption(newVal, optionElement);
	      });
	    } else {
	      // The value attribute is static
	      self.addOption(optionAttrs.value, optionElement);
	    }
	
	    optionElement.on('$destroy', function() {
	      self.removeOption(optionAttrs.value);
	      self.ngModelCtrl.$render();
	    });
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `SELECT` element with angular data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * If you want dynamic value attributes, you can use interpolation inside the value attribute.
	 *
	 * <div class="alert alert-warning">
	 * Note that the value of a `select` directive used without `ngOptions` is always a string.
	 * When the model needs to be bound to a non-string value, you must either explicitly convert it
	 * using a directive (see example below) or use `ngOptions` to specify the set of options.
	 * This is because an option element can only be bound to string values at present.
	 * </div>
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * <div class="alert alert-info">
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits, such as
	 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression, and additionally in reducing memory and increasing speed by not creating
	 * a new scope for each repeated instance.
	 * </div>
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange Angular expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1',
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="ngrepeat-select" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.repeatSelect">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>repeatSelect = {{data.repeatSelect}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       repeatSelect: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 *
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 *
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       var select = element(by.css('select'));
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var selectDirective = function() {
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: SelectController,
	    priority: 1,
	    link: {
	      pre: selectPreLink,
	      post: selectPostLink
	    }
	  };
	
	  function selectPreLink(scope, element, attr, ctrls) {
	
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected) {
	              array.push(option.value);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          var items = new HashMap(value);
	          forEach(element.find('option'), function(option) {
	            option.selected = isDefined(items.get(option.value));
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	
	    function selectPostLink(scope, element, attrs, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`.
	      // This must be done in the postLink fn to prevent $render to be called before
	      // all nodes have been linked correctly.
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	    }
	};
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective = ['$interpolate', function($interpolate) {
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	      if (isDefined(attr.value)) {
	        // If the value attribute is defined, check if it contains an interpolation
	        var interpolateValueFn = $interpolate(attr.value, true);
	      } else {
	        // If the value attribute is not defined then we fall back to the
	        // text content of the option element, which may be interpolated
	        var interpolateTextFn = $interpolate(element.text(), true);
	        if (!interpolateTextFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	        // This is an optimization over using ^^ since we don't want to have to search
	        // all the way to the root of the DOM for every single option element
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        if (selectCtrl) {
	          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
	        }
	      };
	    }
	  };
	}];
	
	var styleDirective = valueFn({
	  restrict: 'E',
	  terminal: false
	});
	
	/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the Angular expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */
	var requiredDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      attr.required = true; // force truthy in case we are on non input element
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !attr.required || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function() {
	        ctrl.$validate();
	      });
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngPattern
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained by evaluating the Angular expression given in the
	 * `ngPattern` attribute value:
	 * * If the expression evaluates to a RegExp object, then this is used directly.
	 * * If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 * in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var patternDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var regexp, patternExp = attr.ngPattern || attr.pattern;
	      attr.$observe('pattern', function(regex) {
	        if (isString(regex) && regex.length > 0) {
	          regex = new RegExp('^' + regex + '$');
	        }
	
	        if (regex && !regex.test) {
	          throw minErr('ngPattern')('noregexp',
	            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	            regex, startingTag(elm));
	        }
	
	        regexp = regex || undefined;
	        ctrl.$validate();
	      });
	
	      ctrl.$validators.pattern = function(modelValue, viewValue) {
	        // HTML5 pattern constraint validates the input value, so we validate the viewValue
	        return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the Angular expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var maxlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = -1;
	      attr.$observe('maxlength', function(value) {
	        var intVal = toInt(value);
	        maxlength = isNaN(intVal) ? -1 : intVal;
	        ctrl.$validate();
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMinlength
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the Angular expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */
	var minlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = 0;
	      attr.$observe('minlength', function(value) {
	        minlength = toInt(value) || 0;
	        ctrl.$validate();
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
	      };
	    }
	  };
	};
	
	if (window.angular.bootstrap) {
	  //AngularJS is already loaded, so we can return here...
	  if (window.console) {
	    console.log('WARNING: Tried to load angular more than once.');
	  }
	  return;
	}
	
	//try to bind to jquery now so that one can write jqLite(document).ready()
	//but we will rebind on bootstrap again.
	bindJQuery();
	
	publishExternalAPI(angular);
	
	angular.module("ngLocale", [], ["$provide", function($provide) {
	var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	function getDecimals(n) {
	  n = n + '';
	  var i = n.indexOf('.');
	  return (i == -1) ? 0 : n.length - i - 1;
	}
	
	function getVF(n, opt_precision) {
	  var v = opt_precision;
	
	  if (undefined === v) {
	    v = Math.min(getDecimals(n), 3);
	  }
	
	  var base = Math.pow(10, v);
	  var f = ((n * base) | 0) % base;
	  return {v: v, f: f};
	}
	
	$provide.value("$locale", {
	  "DATETIME_FORMATS": {
	    "AMPMS": [
	      "AM",
	      "PM"
	    ],
	    "DAY": [
	      "Sunday",
	      "Monday",
	      "Tuesday",
	      "Wednesday",
	      "Thursday",
	      "Friday",
	      "Saturday"
	    ],
	    "ERANAMES": [
	      "Before Christ",
	      "Anno Domini"
	    ],
	    "ERAS": [
	      "BC",
	      "AD"
	    ],
	    "FIRSTDAYOFWEEK": 6,
	    "MONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "SHORTDAY": [
	      "Sun",
	      "Mon",
	      "Tue",
	      "Wed",
	      "Thu",
	      "Fri",
	      "Sat"
	    ],
	    "SHORTMONTH": [
	      "Jan",
	      "Feb",
	      "Mar",
	      "Apr",
	      "May",
	      "Jun",
	      "Jul",
	      "Aug",
	      "Sep",
	      "Oct",
	      "Nov",
	      "Dec"
	    ],
	    "STANDALONEMONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "WEEKENDRANGE": [
	      5,
	      6
	    ],
	    "fullDate": "EEEE, MMMM d, y",
	    "longDate": "MMMM d, y",
	    "medium": "MMM d, y h:mm:ss a",
	    "mediumDate": "MMM d, y",
	    "mediumTime": "h:mm:ss a",
	    "short": "M/d/yy h:mm a",
	    "shortDate": "M/d/yy",
	    "shortTime": "h:mm a"
	  },
	  "NUMBER_FORMATS": {
	    "CURRENCY_SYM": "$",
	    "DECIMAL_SEP": ".",
	    "GROUP_SEP": ",",
	    "PATTERNS": [
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      },
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-\u00a4",
	        "negSuf": "",
	        "posPre": "\u00a4",
	        "posSuf": ""
	      }
	    ]
	  },
	  "id": "en-us",
	  "localeID": "en_US",
	  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	});
	}]);
	
	  jqLite(window.document).ready(function() {
	    angularInit(window.document, bootstrap);
	  });
	
	})(window);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(139);
	module.exports = 'ngIdle';


/***/ },
/* 139 */
/***/ function(module, exports) {

	/*** Directives and services for responding to idle users in AngularJS
	* @author Mike Grabski <me@mikegrabski.com>
	* @version v1.3.2
	* @link https://github.com/HackedByChinese/ng-idle.git
	* @license MIT
	*/
	(function(window, angular, undefined) {
	'use strict';
	angular.module('ngIdle', ['ngIdle.keepalive', 'ngIdle.idle', 'ngIdle.countdown', 'ngIdle.title', 'ngIdle.localStorage']);
	angular.module('ngIdle.keepalive', [])
	  .provider('Keepalive', function() {
	    var options = {
	      http: null,
	      interval: 10 * 60
	    };
	
	    this.http = function(value) {
	      if (!value) throw new Error('Argument must be a string containing a URL, or an object containing the HTTP request configuration.');
	      if (angular.isString(value)) {
	        value = {
	          url: value,
	          method: 'GET'
	        };
	      }
	
	      value.cache = false;
	
	      options.http = value;
	    };
	
	    var setInterval = this.interval = function(seconds) {
	      seconds = parseInt(seconds);
	
	      if (isNaN(seconds) || seconds <= 0) throw new Error('Interval must be expressed in seconds and be greater than 0.');
	      options.interval = seconds;
	    };
	
	    this.$get = ['$rootScope', '$log', '$interval', '$http',
	      function($rootScope, $log, $interval, $http) {
	
	        var state = {
	          ping: null
	        };
	
	        function handleResponse(response) {
	          $rootScope.$broadcast('KeepaliveResponse', response.data, response.status);
	        }
	
	        function ping() {
	          $rootScope.$broadcast('Keepalive');
	
	          if (angular.isObject(options.http)) {
	            $http(options.http)
	              .then(handleResponse)
	              .catch(handleResponse);
	          }
	        }
	
	        return {
	          _options: function() {
	            return options;
	          },
	          setInterval: setInterval,
	          start: function() {
	            $interval.cancel(state.ping);
	
	            state.ping = $interval(ping, options.interval * 1000);
	            return state.ping;
	          },
	          stop: function() {
	            $interval.cancel(state.ping);
	          },
	          ping: function() {
	            ping();
	          }
	        };
	      }
	    ];
	  });
	
	angular.module('ngIdle.idle', ['ngIdle.keepalive', 'ngIdle.localStorage'])
	  .provider('Idle', function() {
	    var options = {
	      idle: 20 * 60, // in seconds (default is 20min)
	      timeout: 30, // in seconds (default is 30sec)
	      autoResume: 'idle', // lets events automatically resume (unsets idle state/resets warning)
	      interrupt: 'mousemove keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll',
	      windowInterrupt: null,
	      keepalive: true
	    };
	
	    /**
	     *  Sets the number of seconds a user can be idle before they are considered timed out.
	     *  @param {Number|Boolean} seconds A positive number representing seconds OR 0 or false to disable this feature.
	     */
	    var setTimeout = this.timeout = function(seconds) {
	      if (seconds === false) options.timeout = 0;
	      else if (angular.isNumber(seconds) && seconds >= 0) options.timeout = seconds;
	      else throw new Error('Timeout must be zero or false to disable the feature, or a positive integer (in seconds) to enable it.');
	    };
	
	    this.interrupt = function(events) {
	      options.interrupt = events;
	    };
	
	    this.windowInterrupt = function(events) {
	      options.windowInterrupt = events;
	    };
	
	    var setIdle = this.idle = function(seconds) {
	      if (seconds <= 0) throw new Error('Idle must be a value in seconds, greater than 0.');
	
	      options.idle = seconds;
	    };
	
	    this.autoResume = function(value) {
	      if (value === true) options.autoResume = 'idle';
	      else if (value === false) options.autoResume = 'off';
	      else options.autoResume = value;
	    };
	
	    this.keepalive = function(enabled) {
	      options.keepalive = enabled === true;
	    };
	
	    this.$get = ['$interval', '$log', '$rootScope', '$document', 'Keepalive', 'IdleLocalStorage', '$window',
	      function($interval, $log, $rootScope, $document, Keepalive, LocalStorage, $window) {
	        var state = {
	          idle: null,
	          timeout: null,
	          idling: false,
	          running: false,
	          countdown: null
	        };
	
	        var id = new Date().getTime();
	
	        function startKeepalive() {
	          if (!options.keepalive) return;
	
	          if (state.running) Keepalive.ping();
	
	          Keepalive.start();
	        }
	
	        function stopKeepalive() {
	          if (!options.keepalive) return;
	
	          Keepalive.stop();
	        }
	
	        function toggleState() {
	          state.idling = !state.idling;
	          var name = state.idling ? 'IdleStart' : 'IdleEnd';
	
	          if (state.idling) {
	            $rootScope.$broadcast(name);
	            stopKeepalive();
	            if (options.timeout) {
	              state.countdown = options.timeout;
	              countdown();
	              state.timeout = $interval(countdown, 1000, options.timeout, false);
	            }
	          } else {
	            startKeepalive();
	            $rootScope.$broadcast(name);
	          }
	
	          $interval.cancel(state.idle);
	        }
	
	        function countdown() {
	
	          // check not called when no longer idling
	          // possible with multiple tabs
	          if(!state.idling){
	            return;
	          }
	
	          // countdown has expired, so signal timeout
	          if (state.countdown <= 0) {
	            timeout();
	            return;
	          }
	
	          // countdown hasn't reached zero, so warn and decrement
	          $rootScope.$broadcast('IdleWarn', state.countdown);
	          state.countdown--;
	        }
	
	        function interrupted(anotherTab) {
	          $rootScope.$broadcast('IdleInterrupt', anotherTab);
	        }
	
	        function timeout() {
	          stopKeepalive();
	          $interval.cancel(state.idle);
	          $interval.cancel(state.timeout);
	
	          state.idling = true;
	          state.running = false;
	          state.countdown = 0;
	
	          $rootScope.$broadcast('IdleTimeout');
	        }
	
	        function changeOption(self, fn, value) {
	          var reset = self.running();
	
	          self.unwatch();
	          fn(value);
	          if (reset) self.watch();
	        }
	
	        function getExpiry() {
	          var obj = LocalStorage.get('expiry');
	
	          return obj && obj.time ? new Date(obj.time) : null;
	        }
	
	        function setExpiry(date) {
	          if (!date) LocalStorage.remove('expiry');
	          else LocalStorage.set('expiry', {id: id, time: date});
	        }
	
	        var svc = {
	          _options: function() {
	            return options;
	          },
	          _getNow: function() {
	            return new Date();
	          },
	          getIdle: function(){
	            return options.idle;
	          },
	          getTimeout: function(){
	            return options.timeout;
	          },
	          setIdle: function(seconds) {
	            changeOption(this, setIdle, seconds);
	          },
	          setTimeout: function(seconds) {
	            changeOption(this, setTimeout, seconds);
	          },
	          isExpired: function() {
	            var expiry = getExpiry();
	            return expiry !== null && expiry <= this._getNow();
	          },
	          running: function() {
	            return state.running;
	          },
	          idling: function() {
	            return state.idling;
	          },
	          watch: function(noExpiryUpdate) {
	            $interval.cancel(state.idle);
	            $interval.cancel(state.timeout);
	
	            // calculate the absolute expiry date, as added insurance against a browser sleeping or paused in the background
	            var timeout = !options.timeout ? 0 : options.timeout;
	            if (!noExpiryUpdate) setExpiry(new Date(new Date().getTime() + ((options.idle + timeout) * 1000)));
	
	
	            if (state.idling) toggleState(); // clears the idle state if currently idling
	            else if (!state.running) startKeepalive(); // if about to run, start keep alive
	
	            state.running = true;
	
	            state.idle = $interval(toggleState, options.idle * 1000, 0, false);
	          },
	          unwatch: function() {
	            $interval.cancel(state.idle);
	            $interval.cancel(state.timeout);
	
	            state.idling = false;
	            state.running = false;
	            setExpiry(null);
	
	            stopKeepalive();
	          },
	          interrupt: function(anotherTab) {
	            if (!state.running) return;
	
	            if (options.timeout && this.isExpired()) {
	              timeout();
	              return;
	            } else {
	              interrupted(anotherTab);
	            }
	
	            // note: you can no longer auto resume once we exceed the expiry; you will reset state by calling watch() manually
	            if (anotherTab || options.autoResume === 'idle' || (options.autoResume === 'notIdle' && !state.idling)) this.watch(anotherTab);
	          }
	        };
	
	        var lastMove = {
	          clientX: null,
	          clientY: null,
	          swap: function(event) {
	            var last = {clientX: this.clientX, clientY: this.clientY};
	            this.clientX = event.clientX;
	            this.clientY = event.clientY;
	            return last;
	          },
	          hasMoved: function(event) {
	            var last = this.swap(event);
	            if (this.clientX === null || event.movementX || event.movementY) return true;
	            else if (last.clientX != event.clientX || last.clientY != event.clientY) return true;
	            else return false;
	          }
	        };
	
	        $document.find('html').on(options.interrupt, function(event) {
	          if (event.type === 'mousemove' && event.originalEvent && event.originalEvent.movementX === 0 && event.originalEvent.movementY === 0) {
	            return; // Fix for Chrome desktop notifications, triggering mousemove event.
	          }
	
	          if (event.type !== 'mousemove' || lastMove.hasMoved(event)) {
	            svc.interrupt();
	          }
	        });
	
	        if(options.windowInterrupt) {
	          var eventList = options.windowInterrupt.split(' ');
	          var fn = function() {
	            svc.interrupt();
	          };
	
	          for(var i=0; i<eventList.length; i++) {
	            if ($window.addEventListener) $window.addEventListener(eventList[i], fn, false);
	            else $window.attachEvent(eventList[i], fn)
	          }
	        }
	
	        var wrap = function(event) {
	          if (event.key === 'ngIdle.expiry' && event.newValue && event.newValue !== event.oldValue) {
	            var val = angular.fromJson(event.newValue);
	            if (val.id === id) return;
	            svc.interrupt(true);
	          }
	        };
	
	        if ($window.addEventListener) $window.addEventListener('storage', wrap, false);
	        else if ($window.attachEvent) $window.attachEvent('onstorage', wrap);
	
	        return svc;
	      }
	    ];
	  });
	
	angular.module('ngIdle.countdown', ['ngIdle.idle'])
	  .directive('idleCountdown', ['Idle', function(Idle) {
	    return {
	      restrict: 'A',
	      scope: {
	        value: '=idleCountdown'
	      },
	      link: function($scope) {
	        // Initialize the scope's value to the configured timeout.
	        $scope.value = Idle.getTimeout();
	
	        $scope.$on('IdleWarn', function(e, countdown) {
	          $scope.$evalAsync(function() {
	            $scope.value = countdown;
	          });
	        });
	
	        $scope.$on('IdleTimeout', function() {
	          $scope.$evalAsync(function() {
	            $scope.value = 0;
	          });
	        });
	      }
	    };
	  }]);
	
	angular.module('ngIdle.title', [])
	  .provider('Title', function() {
	    var options = {
	      enabled: true
	    };
	
	    var setEnabled = this.enabled = function(enabled) {
	      options.enabled = enabled === true;
	    };
	
	    function padLeft(nr, n, str){
	      return new Array(n-String(nr).length+1).join(str||'0')+nr;
	    }
	
	    this.$get = ['$document', '$interpolate', function($document, $interpolate) {
	      var state = {
	        original: null,
	        idle: '{{minutes}}:{{seconds}} until your session times out!',
	        timedout: 'Your session has expired.'
	      };
	
	      return {
	        setEnabled: setEnabled,
	        isEnabled: function() {
	          return options.enabled;
	        },
	        original: function(val) {
	          if (angular.isUndefined(val)) return state.original;
	
	          state.original = val;
	        },
	        store: function(overwrite) {
	          if (overwrite || !state.original) state.original = this.value();
	        },
	        value: function(val) {
	          if (angular.isUndefined(val)) return $document[0].title;
	
	          $document[0].title = val;
	        },
	        idleMessage: function(val) {
	          if (angular.isUndefined(val)) return state.idle;
	
	          state.idle = val;
	        },
	        timedOutMessage: function(val) {
	          if (angular.isUndefined(val)) return state.timedout;
	
	          state.timedout = val;
	        },
	        setAsIdle: function(countdown) {
	          this.store();
	
	          var remaining = { totalSeconds: countdown };
	          remaining.minutes = Math.floor(countdown/60);
	          remaining.seconds = padLeft(countdown - remaining.minutes * 60, 2);
	
	          this.value($interpolate(this.idleMessage())(remaining));
	        },
	        setAsTimedOut: function() {
	          this.store();
	
	          this.value(this.timedOutMessage());
	        },
	        restore: function() {
	          if (this.original()) this.value(this.original());
	        }
	      };
	    }];
	  })
	  .directive('title', ['Title', function(Title) {
	      return {
	        restrict: 'E',
	        link: function($scope, $element, $attr) {
	          if (!Title.isEnabled() || $attr.idleDisabled) return;
	
	          Title.store(true);
	
	          $scope.$on('IdleStart', function() {
	            Title.original($element[0].innerText);
	          });
	
	          $scope.$on('IdleWarn', function(e, countdown) {
	            Title.setAsIdle(countdown);
	          });
	
	          $scope.$on('IdleEnd', function() {
	            Title.restore();
	          });
	
	          $scope.$on('IdleTimeout', function() {
	            Title.setAsTimedOut();
	          });
	        }
	      };
	  }]);
	
	angular.module('ngIdle.localStorage', [])
	  .service('IdleStorageAccessor', ['$window', function($window) {
	    return {
	      get: function() {
	        return $window.localStorage;
	      }
	    }
	  }])
	  .service('IdleLocalStorage', ['IdleStorageAccessor', function(IdleStorageAccessor) {
	    function AlternativeStorage() {
	      var storageMap = {};
	
	      this.setItem = function (key, value) {
	          storageMap[key] = value;
	      };
	
	      this.getItem = function (key) {
	          if(typeof storageMap[key] !== 'undefined' ) {
	              return storageMap[key];
	          }
	          return null;
	      };
	
	      this.removeItem = function (key) {
	          storageMap[key] = undefined;
	      };
	    }
	
	    function getStorage() {
	       try {
	          var s = IdleStorageAccessor.get();
	          s.setItem('ngIdleStorage', '');
	          s.removeItem('ngIdleStorage');
	
	          return s;
	       } catch(err) {
	          return new AlternativeStorage();
	       }
	    }
	
	    // Safari, in Private Browsing Mode, looks like it supports localStorage but all calls to setItem
	    // throw QuotaExceededError. We're going to detect this and just silently drop any calls to setItem
	    // to avoid the entire page breaking, without having to do a check at each usage of Storage.
	    var storage = getStorage();
	
	    return {
	      set: function(key, value) {
	        storage.setItem('ngIdle.'+key, angular.toJson(value));
	      },
	      get: function(key) {
	        return angular.fromJson(storage.getItem('ngIdle.'+key));
	      },
	      remove: function(key) {
	        storage.removeItem('ngIdle.'+key);
	      },
	      _wrapped: function() {
	        return storage;
	      }
	    };
	}]);
	
	})(window, window.angular);

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(141);
	
	var lbaRouteRoot = angular.module('app.lbaRouteRoot', []);
	
	lbaRouteRoot.component('lbaRouteRoot', {
	  bindings: {
	    target: '<'
	  },
	  controllerAs: 'vm',
	  controller: ['$rootScope', '$routeParams', 'settingsService', lbaRouteRootCtrl],
	  template: '\n<div lba-toast></div>\n\n<div lba-nav target="vm.target"></div>\n\n<div lba-loader show-loader="vm.showLoader"></div>\n\n<div class="lbaContainer">\n    <div class="wrapper">\n        <lba-bread-crumb></lba-bread-crumb>\n        <div class="content">\n          <div class="lbaContainer_nav" ng-if="$root.showSubNav">\n            <lba-sub-nav></lba-sub-nav>\n          </div>\n          <div ng-class="{ lbaContainer_fields: $root.showSubNav }">\n              <div lba-dynamic="\'lba-\' + vm.settings[vm.target].displayAs" settings="vm.settings[vm.target]"></div>\n          </div>\n        </div>\n    </div>\n</div>'
	});
	
	function lbaRouteRootCtrl($rootScope, $routeParams, settingsService) {
	  var vm = this;
	  vm.routeParams = $routeParams;
	  settingsService.settings = settingsService.get();
	  vm.settings = settingsService.settings;
	
	  if (vm.settings[vm.target].rootNode) {
	    $rootScope.showSubNav = false;
	  }
	}
	
	exports['default'] = lbaRouteRoot;
	module.exports = exports['default'];

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(142);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaRouteRoot.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaRouteRoot.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\r\n * ui-select\r\n * http://github.com/angular-ui/ui-select\r\n * Version: 0.13.2 - 2015-10-09T15:34:24.045Z\r\n * License: MIT\r\n */.ui-select-highlight{font-weight:700}.ui-select-offscreen{clip:rect(0 0 0 0)!important;width:1px!important;height:1px!important;border:0!important;margin:0!important;padding:0!important;overflow:hidden!important;position:absolute!important;outline:0!important;left:0!important;top:0!important}.ui-select-choices-row:hover{background-color:#f5f5f5}.ng-dirty.ng-invalid>a.select2-choice{border-color:#d44950}.select2-result-single{padding-left:0}.select2-locked>.select2-search-choice-close,.select-locked>.ui-select-match-close{display:none}body>.select2-container.open{z-index:9999}.ui-select-container[theme=select2].direction-up .ui-select-match{border-radius:4px;border-top-left-radius:0;border-top-right-radius:0}.ui-select-container[theme=select2].direction-up .ui-select-dropdown{border-radius:4px;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-width:1px;border-top-style:solid;box-shadow:0 -4px 8px rgba(0,0,0,.25);margin-top:-4px}.ui-select-container[theme=select2].direction-up .ui-select-dropdown .select2-search{margin-top:4px}.ui-select-container[theme=select2].direction-up.select2-dropdown-open .ui-select-match{border-bottom-color:#5897fb}.selectize-input.selectize-focus{border-color:#007fbb!important}.selectize-control>.selectize-dropdown,.selectize-control>.selectize-input>input{width:100%}.ng-dirty.ng-invalid>div.selectize-input{border-color:#d44950}.ui-select-container[theme=selectize].direction-up .ui-select-dropdown{box-shadow:0 -4px 8px rgba(0,0,0,.25);margin-top:-2px}.btn-default-focus{color:#333;background-color:#ebebeb;border-color:#adadad;text-decoration:none;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.ui-select-bootstrap .ui-select-toggle{position:relative}.ui-select-bootstrap .ui-select-toggle>.caret{position:absolute;height:10px;top:50%;right:10px;margin-top:-2px}.input-group>.ui-select-bootstrap.dropdown{position:static}.input-group>.ui-select-bootstrap>input.ui-select-search.form-control{border-radius:4px;border-top-right-radius:0;border-bottom-right-radius:0;width:100%}.input-group>.ui-select-bootstrap>input.ui-select-search.form-control.direction-up{border-radius:4px!important;border-top-right-radius:0!important;border-bottom-right-radius:0!important}.ui-select-bootstrap>.ui-select-match>.btn{text-align:left!important}.ui-select-bootstrap>.ui-select-match>.caret{position:absolute;top:45%;right:15px}.ui-select-bootstrap>.ui-select-choices{width:100%;height:auto;max-height:200px;overflow-x:hidden;margin-top:-1px;z-index:1001}body>.ui-select-bootstrap.open{z-index:1000}.ui-select-multiple.ui-select-bootstrap{height:auto;padding:3px 3px 0}.ui-select-multiple.ui-select-bootstrap input.ui-select-search{background-color:transparent!important;border:none;outline:0;height:1.666666em;margin-bottom:3px}.ui-select-multiple.ui-select-bootstrap .ui-select-match .close{font-size:1.6em;line-height:.75}.ui-select-multiple.ui-select-bootstrap .ui-select-match-item{outline:0;margin:0 3px 3px 0}.ui-select-multiple .ui-select-match-item{position:relative}.ui-select-multiple .ui-select-match-item.dropping-before:before{content:\"\";position:absolute;top:0;right:100%;height:100%;margin-right:2px;border-left:1px solid #428bca}.ui-select-multiple .ui-select-match-item.dropping-after:after{content:\"\";position:absolute;top:0;left:100%;height:100%;margin-left:2px;border-right:1px solid #428bca}.ui-select-bootstrap .ui-select-choices-row>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.ui-select-bootstrap .ui-select-choices-row>a:focus,.ui-select-bootstrap .ui-select-choices-row>a:hover{text-decoration:none;color:#262626;background-color:#f5f5f5}.ui-select-bootstrap .ui-select-choices-row.active>a{color:#fff;text-decoration:none;outline:0;background-color:#428bca}.ui-select-bootstrap .ui-select-choices-row.active.disabled>a,.ui-select-bootstrap .ui-select-choices-row.disabled>a{color:#777;cursor:not-allowed;background-color:#fff}.ui-select-match.ng-hide-add,.ui-select-search.ng-hide-add{display:none!important}.ui-select-bootstrap.ng-dirty.ng-invalid>button.btn.ui-select-match{border-color:#d44950}.ui-select-container[theme=bootstrap].direction-up .ui-select-dropdown{box-shadow:0 -4px 8px rgba(0,0,0,.25)}.ui-select-match-item.btn{white-space:inherit;text-align:left}input.form-control.ui-select-search{width:100%!important}*{-webkit-font-smoothing:antialiased;box-sizing:border-box}body{background:#fff;font-family:Open Sans,sans-serif;padding-bottom:15rem;overflow-x:hidden;overflow-y:scroll;padding-top:70px}.lbaContainer,.primaryHeader{position:relative}.primaryHeader{background:#f8f8f8;padding:2rem 0;margin-bottom:1rem}.primaryHeader h2{float:left;font-size:2.2rem;line-height:1.3;margin:0;text-transform:uppercase;vertical-align:middle}.primaryHeader h2 span{color:#666;text-transform:none;font-size:1.5rem;margin-left:1rem}.primaryHeader_actions{float:left;vertical-align:middle;margin-left:20px}.componentHeader{padding:2rem 0;position:relative;margin-bottom:1rem}.componentHeader h2{float:left;font-size:1.8rem;line-height:1.6;margin:0;text-transform:uppercase;vertical-align:middle}.componentHeader h2 span{color:#666;text-transform:none;font-size:1.5rem;margin-left:1rem}.componentHeader_actions{float:left;vertical-align:middle;margin-left:1.5rem}.wrapper{width:940px;margin:0 auto}.nav-tabs{margin:0 0 2rem}.required{font-size:1rem;display:none}.formErrors .required{color:red;display:inline}.errorWarnings{width:80%;clear:both;display:none;bottom:10px;left:10px;background:red;color:#fff;padding:1rem}.errorWarnings h3{margin:0 0 1rem}.errorWarnings a{color:#fff;text-decoration:underline}.formErrors .errorWarnings{display:block}input[type=text].ng-invalid.ng-dirty{border-color:red}.btn-lightning{color:#fff;background-color:#9ab845;border-color:#9ab845}.btn-lightning:hover{color:#fff;background-color:#8aa53e}.btn-lightning:focus{color:#fff}.ui-select-multiple.ui-select-bootstrap{position:relative;min-height:29px}.lbaModal_wrapper{position:fixed;top:0;right:0;bottom:0;left:0;overflow:auto;z-index:9001}.lbaModal{background:#fff;position:relative;width:940px;margin:0 auto}.lbaModal_heading{background:#a4c04e;color:#fff;font-size:1.5rem;font-weight:700;padding:2.2rem 2rem;margin:0}.lbaModal_content{padding:2rem}.lbaModal_buttons{padding-top:1rem;text-align:right}.lbaModal_close{color:#fff!important;position:absolute;top:1.25rem;right:1.25rem}.overlay{background:rgba(0,0,0,.8);position:fixed;top:0;left:0;right:0;bottom:0;z-index:9000}.ng-invalid-max,.ng-invalid-min{border-color:red}.copyAlltags{float:right}.copyAlltags:hover{cursor:pointer}input[type=range]{width:100%}p.validation-message{color:red}input.not-valid{border-color:red}li.menu-item-not-valid{background-color:#d9534f!important;border-radius:4px}.lbaSubHeading_heading small{white-space:pre}.enhancedPolicyTable td,.enhancedPolicyTable th{padding-right:20px}.htmlmarkup-indent{padding-left:20px}.width100{float:left;padding-left:10px}.width100 input{width:75pt}.widthLabe150{width:150px}.widthLabe150,.widthLabe150 .form-group{margin-bottom:0}.clear{clear:both}.showLineBreaks{white-space:pre}.lbaContainer{margin:20px 0 0}.lbaContainer_nav{float:left;width:18rem;margin:0 2rem 0 0}.lbaContainer_fields{float:left;width:73.5rem;padding:0 0 15rem}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaRouteRoot/src/globalStyles/_select.scss","/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaRouteRoot/src/globalStyles/_shared.scss","/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaRouteRoot/src/globalStyles/_variables.scss","/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaRouteRoot/src/components/lbaRouteRoot/lbaRouteRoot.scss"],"names":[],"mappings":"AAAA;;;;;GAKG,qBAIC,eAAiB,CACpB,qBAGG,6BACA,oBACA,qBACA,mBACA,mBACA,oBACA,0BACA,4BACA,oBACA,iBACA,eAAmB,CACtB,6BAGG,wBAAyB,CAC5B,sCAMG,oBAAqB,CACxB,uBAGG,cAAe,CAClB,AAIA,mFAGG,YAAa,CAChB,6BAGG,YAAa,CAChB,kEAIG,kBACA,yBACA,yBAA0B,CAC7B,qEAGG,kBACA,4BACA,6BAEA,qBACA,uBAEA,sCAEA,eAAgB,CACnB,qFAGG,cAAe,CAClB,wFAGG,2BAA4B,CAC/B,iCAMG,8BAAgC,CACnC,AAKA,iFAIG,UAAW,CACd,yCAIG,oBAAqB,CACxB,uEAIG,sCAEA,eAAgB,CACnB,mBAMG,WACA,yBACA,qBACA,qBACA,0CACA,oBACA,wEAAkF,CACrF,uCAGG,iBAAkB,CACrB,8CAGG,kBACA,YACA,QACA,WACA,eAAgB,CACnB,2CAKG,eAAgB,CACnB,sEAGG,kBACA,0BACA,6BACA,UAAW,CACd,mFAGG,4BACA,oCACA,sCAAwC,CAC3C,2CAIG,yBAA2B,CAC9B,6CAGG,kBACA,QACA,UAAW,CACd,wCAIG,WACA,YACA,iBACA,kBACA,gBACA,YAAa,CAChB,+BAGG,YAAa,CAChB,wCAGG,YACA,iBAAsB,CACzB,+DAGG,uCACA,YACA,UACA,kBACA,iBAAkB,CACrB,gEAGG,gBACA,eAAiB,CACpB,8DAGG,UACA,kBAAmB,CACtB,0CAGG,iBAAkB,CACrB,iEAGG,WACA,kBACA,MACA,WACA,YACA,iBACA,6BAA8B,CACjC,+DAGG,WACA,kBACA,MACA,UACA,YACA,gBACA,8BAA+B,CAClC,8CAGG,cACA,iBACA,WACA,gBACA,uBACA,WACA,kBAAmB,CACtB,wGAGG,qBACA,cACA,wBAAyB,CAC5B,qDAGG,WACA,qBACA,UACA,wBAAyB,CAC5B,qHAIG,WACA,mBACA,qBAAsB,CACzB,2DAKG,sBAAwB,CAC3B,oEAIG,oBAAqB,CACxB,uEAIG,qCAA0C,CAC7C,0BAIG,oBACA,eAAgB,CACnB,oCAIG,oBAAsB,CACzB,ECxRG,mCACA,qBAAsB,CACzB,KAGG,gBACA,iCACA,qBACA,kBACA,kBACA,gBAAiB,CACpB,AAIA,6BADG,iBAAkB,CAarB,AAZA,eAQG,mBACA,eACA,AACA,kBAAmB,CACtB,kBAGG,WACA,iBACA,gBACA,SACA,yBACA,qBAAsB,CACzB,uBAGG,WACA,oBACA,iBACA,gBAAiB,CACpB,uBAGG,WACA,sBACA,gBAAiB,CACpB,iBAOG,eACA,kBACA,kBAAmB,CACtB,oBAGG,WACA,iBACA,gBACA,SACA,yBACA,qBAAsB,CACzB,yBAGG,WACA,oBACA,iBACA,gBAAiB,CACpB,yBAGG,WACA,sBACA,kBAAmB,CACtB,SAGG,YACA,aAAc,CACjB,UAGG,eAAgB,CAClB,UAGE,eACA,YAAa,CAChB,sBAGG,UACA,cAAe,CAClB,eAGG,UACA,WACA,aACA,YACA,UACA,eACA,WACA,YAAa,CARjB,kBAWQ,eAAgB,CAXxB,iBAeQ,WACA,yBAA0B,CAC7B,2BAID,aAAc,CACjB,qCAGG,gBAAiB,CACpB,eAGG,WACA,yBACA,oBCtIgB,CDuInB,qBAGG,WACA,wBAAwC,CAC3C,qBAGG,UAAW,CACd,wCAGG,kBACA,eAAe,CAClB,kBAGG,eACA,MACA,QACA,SACA,OACA,cACA,YAAa,CAChB,UAGG,gBACA,kBACA,YACA,aAAc,CACjB,kBAGG,mBACA,WACA,iBACA,gBACA,oBACA,QAAS,CACZ,kBAGG,YAAa,CAChB,kBAGG,iBACA,gBAAiB,CACpB,gBAGG,qBACA,kBACA,YACA,aAAc,CACjB,SAGG,0BACA,eACA,MACA,OACA,QACA,SACA,YAAa,CAChB,gCAIG,gBAAiB,CACpB,aAGG,WAAY,CADhB,mBAIQ,cAAe,CAClB,kBAID,UAAW,CACd,qBAGG,SAAc,CACjB,gBAGG,gBAAiB,CACpB,uBAGG,mCACA,iBAAkB,CACrB,6BAEG,eAAgB,CACnB,gDAGO,kBAAmB,CACtB,mBAGD,iBAAkB,CACrB,UAGE,WACC,iBAAkB,CAFtB,gBAIQ,UAAa,CAChB,cAID,WACA,CAHJ,wCAGI,eAAiB,CAGhB,OAGD,UAAU,CACb,gBAEG,eAAgB,CEnQpB,cACE,eAAkB,CACnB,kBAGC,WACA,YACA,iBAAkB,CACnB,qBAGC,WACA,cACA,iBAAkB,CACnB","file":"lbaRouteRoot.scss","sourcesContent":["/*!\r\n * ui-select\r\n * http://github.com/angular-ui/ui-select\r\n * Version: 0.13.2 - 2015-10-09T15:34:24.045Z\r\n * License: MIT\r\n */\r\n\r\n/* Style when highlighting a search. */\r\n.ui-select-highlight {\r\n    font-weight: bold;\r\n}\r\n\r\n.ui-select-offscreen {\r\n    clip: rect(0 0 0 0) !important;\r\n    width: 1px !important;\r\n    height: 1px !important;\r\n    border: 0 !important;\r\n    margin: 0 !important;\r\n    padding: 0 !important;\r\n    overflow: hidden !important;\r\n    position: absolute !important;\r\n    outline: 0 !important;\r\n    left: 0px !important;\r\n    top: 0px !important;\r\n}\r\n\r\n.ui-select-choices-row:hover {\r\n    background-color: #f5f5f5;\r\n}\r\n\r\n/* Select2 theme */\r\n\r\n/* Mark invalid Select2 */\r\n.ng-dirty.ng-invalid > a.select2-choice {\r\n    border-color: #D44950;\r\n}\r\n\r\n.select2-result-single {\r\n    padding-left: 0;\r\n}\r\n\r\n.select2-locked > .select2-search-choice-close {\r\n    display: none;\r\n}\r\n\r\n.select-locked > .ui-select-match-close {\r\n    display: none;\r\n}\r\n\r\nbody > .select2-container.open {\r\n    z-index: 9999; /* The z-index Select2 applies to the select2-drop */\r\n}\r\n\r\n/* Handle up direction Select2 */\r\n.ui-select-container[theme=\"select2\"].direction-up .ui-select-match {\r\n    border-radius: 4px; /* FIXME hardcoded value :-/ */\r\n    border-top-left-radius: 0;\r\n    border-top-right-radius: 0;\r\n}\r\n\r\n.ui-select-container[theme=\"select2\"].direction-up .ui-select-dropdown {\r\n    border-radius: 4px; /* FIXME hardcoded value :-/ */\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n\r\n    border-top-width: 1px; /* FIXME hardcoded value :-/ */\r\n    border-top-style: solid;\r\n\r\n    box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.25);\r\n\r\n    margin-top: -4px; /* FIXME hardcoded value :-/ */\r\n}\r\n\r\n.ui-select-container[theme=\"select2\"].direction-up .ui-select-dropdown .select2-search {\r\n    margin-top: 4px; /* FIXME hardcoded value :-/ */\r\n}\r\n\r\n.ui-select-container[theme=\"select2\"].direction-up.select2-dropdown-open .ui-select-match {\r\n    border-bottom-color: #5897fb;\r\n}\r\n\r\n/* Selectize theme */\r\n\r\n/* Helper class to show styles when focus */\r\n.selectize-input.selectize-focus {\r\n    border-color: #007FBB !important;\r\n}\r\n\r\n/* Fix input width for Selectize theme */\r\n.selectize-control > .selectize-input > input {\r\n    width: 100%;\r\n}\r\n\r\n/* Fix dropdown width for Selectize theme */\r\n.selectize-control > .selectize-dropdown {\r\n    width: 100%;\r\n}\r\n\r\n/* Mark invalid Selectize */\r\n.ng-dirty.ng-invalid > div.selectize-input {\r\n    border-color: #D44950;\r\n}\r\n\r\n/* Handle up direction Selectize */\r\n.ui-select-container[theme=\"selectize\"].direction-up .ui-select-dropdown {\r\n    box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.25);\r\n\r\n    margin-top: -2px; /* FIXME hardcoded value :-/ */\r\n}\r\n\r\n/* Bootstrap theme */\r\n\r\n/* Helper class to show styles when focus */\r\n.btn-default-focus {\r\n    color: #333;\r\n    background-color: #EBEBEB;\r\n    border-color: #ADADAD;\r\n    text-decoration: none;\r\n    outline: 5px auto -webkit-focus-ring-color;\r\n    outline-offset: -2px;\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);\r\n}\r\n\r\n.ui-select-bootstrap .ui-select-toggle {\r\n    position: relative;\r\n}\r\n\r\n.ui-select-bootstrap .ui-select-toggle > .caret {\r\n    position: absolute;\r\n    height: 10px;\r\n    top: 50%;\r\n    right: 10px;\r\n    margin-top: -2px;\r\n}\r\n\r\n/* Fix Bootstrap dropdown position when inside a input-group */\r\n.input-group > .ui-select-bootstrap.dropdown {\r\n    /* Instead of relative */\r\n    position: static;\r\n}\r\n\r\n.input-group > .ui-select-bootstrap > input.ui-select-search.form-control {\r\n    border-radius: 4px; /* FIXME hardcoded value :-/ */\r\n    border-top-right-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    width: 100%;\r\n}\r\n\r\n.input-group > .ui-select-bootstrap > input.ui-select-search.form-control.direction-up {\r\n    border-radius: 4px !important; /* FIXME hardcoded value :-/ */\r\n    border-top-right-radius: 0 !important;\r\n    border-bottom-right-radius: 0 !important;\r\n}\r\n\r\n.ui-select-bootstrap > .ui-select-match > .btn {\r\n    /* Instead of center because of .btn */\r\n    text-align: left !important;\r\n}\r\n\r\n.ui-select-bootstrap > .ui-select-match > .caret {\r\n    position: absolute;\r\n    top: 45%;\r\n    right: 15px;\r\n}\r\n\r\n/* See Scrollable Menu with Bootstrap 3 http://stackoverflow.com/questions/19227496 */\r\n.ui-select-bootstrap > .ui-select-choices {\r\n    width: 100%;\r\n    height: auto;\r\n    max-height: 200px;\r\n    overflow-x: hidden;\r\n    margin-top: -1px;\r\n    z-index: 1001;\r\n}\r\n\r\nbody > .ui-select-bootstrap.open {\r\n    z-index: 1000; /* Standard Bootstrap dropdown z-index */\r\n}\r\n\r\n.ui-select-multiple.ui-select-bootstrap {\r\n    height: auto;\r\n    padding: 3px 3px 0 3px;\r\n}\r\n\r\n.ui-select-multiple.ui-select-bootstrap input.ui-select-search {\r\n    background-color: transparent !important; /* To prevent double background when disabled */\r\n    border: none;\r\n    outline: none;\r\n    height: 1.666666em;\r\n    margin-bottom: 3px;\r\n}\r\n\r\n.ui-select-multiple.ui-select-bootstrap .ui-select-match .close {\r\n    font-size: 1.6em;\r\n    line-height: 0.75;\r\n}\r\n\r\n.ui-select-multiple.ui-select-bootstrap .ui-select-match-item {\r\n    outline: 0;\r\n    margin: 0 3px 3px 0;\r\n}\r\n\r\n.ui-select-multiple .ui-select-match-item {\r\n    position: relative;\r\n}\r\n\r\n.ui-select-multiple .ui-select-match-item.dropping-before:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    right: 100%;\r\n    height: 100%;\r\n    margin-right: 2px;\r\n    border-left: 1px solid #428bca;\r\n}\r\n\r\n.ui-select-multiple .ui-select-match-item.dropping-after:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: 100%;\r\n    height: 100%;\r\n    margin-left: 2px;\r\n    border-right: 1px solid #428bca;\r\n}\r\n\r\n.ui-select-bootstrap .ui-select-choices-row > a {\r\n    display: block;\r\n    padding: 3px 20px;\r\n    clear: both;\r\n    font-weight: 400;\r\n    line-height: 1.42857143;\r\n    color: #333;\r\n    white-space: nowrap;\r\n}\r\n\r\n.ui-select-bootstrap .ui-select-choices-row > a:hover, .ui-select-bootstrap .ui-select-choices-row > a:focus {\r\n    text-decoration: none;\r\n    color: #262626;\r\n    background-color: #f5f5f5;\r\n}\r\n\r\n.ui-select-bootstrap .ui-select-choices-row.active > a {\r\n    color: #fff;\r\n    text-decoration: none;\r\n    outline: 0;\r\n    background-color: #428bca;\r\n}\r\n\r\n.ui-select-bootstrap .ui-select-choices-row.disabled > a,\r\n.ui-select-bootstrap .ui-select-choices-row.active.disabled > a {\r\n    color: #777;\r\n    cursor: not-allowed;\r\n    background-color: #fff;\r\n}\r\n\r\n/* fix hide/show angular animation */\r\n.ui-select-match.ng-hide-add,\r\n.ui-select-search.ng-hide-add {\r\n    display: none !important;\r\n}\r\n\r\n/* Mark invalid Bootstrap */\r\n.ui-select-bootstrap.ng-dirty.ng-invalid > button.btn.ui-select-match {\r\n    border-color: #D44950;\r\n}\r\n\r\n/* Handle up direction Bootstrap */\r\n.ui-select-container[theme=\"bootstrap\"].direction-up .ui-select-dropdown {\r\n    box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n/* Fix for extra long tag names not wrapping */\r\n.ui-select-match-item.btn {\r\n    white-space: inherit;\r\n    text-align: left;\r\n}\r\n\r\n/* Width hack */\r\ninput.form-control.ui-select-search {\r\n    width: 100% !important;\r\n}","* {\r\n    -webkit-font-smoothing: antialiased;\r\n    box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n    background: #fff;\r\n    font-family: 'Open Sans', sans-serif;\r\n    padding-bottom: 15rem;\r\n    overflow-x: hidden;\r\n    overflow-y: scroll;\r\n    padding-top: 70px;\r\n}\r\n\r\n.lbaContainer {\r\n    position: relative;\r\n}\r\n\r\n\r\n/* ==========================================================================\r\n   Primary Header\r\n   ========================================================================== */\r\n\r\n.primaryHeader {\r\n    background: #f8f8f8;\r\n    padding: 2rem 0;\r\n    position: relative;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.primaryHeader h2 {\r\n    float: left;\r\n    font-size: 2.2rem;\r\n    line-height: 1.3;\r\n    margin: 0;\r\n    text-transform: uppercase;\r\n    vertical-align: middle;\r\n}\r\n\r\n.primaryHeader h2 span {\r\n    color: #666;\r\n    text-transform: none;\r\n    font-size: 1.5rem;\r\n    margin-left: 1rem;\r\n}\r\n\r\n.primaryHeader_actions {\r\n    float: left;\r\n    vertical-align: middle;\r\n    margin-left: 20px;\r\n}\r\n\r\n/* ==========================================================================\r\n   Component Header\r\n   ========================================================================== */\r\n\r\n.componentHeader {\r\n    padding: 2rem 0;\r\n    position: relative;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.componentHeader h2 {\r\n    float: left;\r\n    font-size: 1.8rem;\r\n    line-height: 1.6;\r\n    margin: 0;\r\n    text-transform: uppercase;\r\n    vertical-align: middle;\r\n}\r\n\r\n.componentHeader h2 span {\r\n    color: #666;\r\n    text-transform: none;\r\n    font-size: 1.5rem;\r\n    margin-left: 1rem;\r\n}\r\n\r\n.componentHeader_actions {\r\n    float: left;\r\n    vertical-align: middle;\r\n    margin-left: 1.5rem;\r\n}\r\n\r\n.wrapper {\r\n    width: 940px;\r\n    margin: 0 auto;\r\n}\r\n\r\n.nav-tabs {\r\n    margin: 0 0 2rem;\r\n }\r\n\r\n.required {\r\n    font-size: 1rem;\r\n    display: none;\r\n}\r\n\r\n.formErrors .required {\r\n    color: red;\r\n    display: inline;\r\n}\r\n\r\n.errorWarnings {\r\n    width: 80%;\r\n    clear: both;\r\n    display: none;\r\n    bottom: 10px;\r\n    left: 10px;\r\n    background: red;\r\n    color: #fff;\r\n    padding: 1rem;\r\n\r\n    h3 {\r\n        margin: 0 0 1rem;\r\n    }\r\n\r\n    a {\r\n        color: #fff;\r\n        text-decoration: underline;\r\n    }\r\n}\r\n\r\n.formErrors .errorWarnings {\r\n    display: block;\r\n}\r\n\r\ninput[type=text].ng-invalid.ng-dirty {\r\n    border-color: red;\r\n}\r\n\r\n.btn-lightning {\r\n    color: #fff;\r\n    background-color: $brandGreen;\r\n    border-color: $brandGreen;\r\n}\r\n\r\n.btn-lightning:hover {\r\n    color: #fff;\r\n    background-color: darken($brandGreen, 5);\r\n}\r\n\r\n.btn-lightning:focus {\r\n    color: #fff;\r\n}\r\n\r\n.ui-select-multiple.ui-select-bootstrap {\r\n    position: relative;\r\n    min-height:29px;\r\n}\r\n\r\n.lbaModal_wrapper {\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    overflow: auto;\r\n    z-index: 9001;\r\n}\r\n\r\n.lbaModal {\r\n    background: #fff;\r\n    position: relative;\r\n    width: 940px;\r\n    margin: 0 auto;\r\n}\r\n\r\n.lbaModal_heading {\r\n    background: #a4c04e;\r\n    color: #fff;\r\n    font-size: 1.5rem;\r\n    font-weight: 700;\r\n    padding: 2.2rem 2rem;\r\n    margin: 0;\r\n}\r\n\r\n.lbaModal_content {\r\n    padding: 2rem;\r\n}\r\n\r\n.lbaModal_buttons {\r\n    padding-top: 1rem;\r\n    text-align: right;\r\n}\r\n\r\n.lbaModal_close {\r\n    color: #fff !important;\r\n    position: absolute;\r\n    top: 1.25rem;\r\n    right: 1.25rem;\r\n}\r\n\r\n.overlay {\r\n    background: rgba(0,0,0,0.8);\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    z-index: 9000;\r\n}\r\n\r\n.ng-invalid-min,\r\n.ng-invalid-max {\r\n    border-color: red;\r\n}\r\n\r\n.copyAlltags {\r\n    float: right;\r\n\r\n    &:hover {\r\n        cursor: pointer;\r\n    }\r\n}\r\n\r\ninput[type='range'] {\r\n    width: 100%;\r\n}\r\n\r\np.validation-message {\r\n    color: #ff0000;\r\n}\r\n\r\ninput.not-valid{\r\n    border-color: red;\r\n}\r\n\r\nli.menu-item-not-valid {\r\n    background-color: #d9534f !important;\r\n    border-radius: 4px;\r\n}\r\n.lbaSubHeading_heading small{\r\n    white-space: pre;\r\n}\r\n.enhancedPolicyTable{\r\n    td, th{\r\n        padding-right: 20px;\r\n    }\r\n}\r\n.htmlmarkup-indent{\r\n    padding-left: 20px;\r\n}\r\n\r\n.width100{\r\n   float: left;\r\n    padding-left: 10px;\r\n    input{\r\n        width:  100px;\r\n    }\r\n}\r\n.widthLabe150{\r\n   \r\n    width: 150px;\r\n    margin-bottom:0px;\r\n    .form-group{\r\n        margin-bottom: 0px;\r\n    }\r\n}\r\n.clear{\r\n    clear:both;\r\n}\r\n.showLineBreaks{\r\n    white-space: pre;\r\n}","$brandGreen: #9ab845;","@import \"../../globalStyles/variables\";\r\n@import \"../../globalStyles/select\";\r\n@import \"../../globalStyles/shared\";\r\n\r\n.lbaContainer {\r\n  margin: 20px 0 0 0;\r\n}\r\n\r\n.lbaContainer_nav {\r\n  float: left;\r\n  width: 18rem;\r\n  margin: 0 2rem 0 0;\r\n}\r\n\r\n.lbaContainer_fields {\r\n  float: left;\r\n  width: 73.5rem;\r\n  padding: 0 0 15rem;\r\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 143 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0;
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function createStyleElement() {
		var styleElement = document.createElement("style");
		var head = getHeadElement();
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		return styleElement;
	}
	
	function createLinkElement() {
		var linkElement = document.createElement("link");
		var head = getHeadElement();
		linkElement.rel = "stylesheet";
		head.appendChild(linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement());
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement();
			update = updateLink.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement();
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				styleElement.parentNode.removeChild(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var lbaGrid = angular.module('app.lbaGrid', ['ngTasty', 'ui.sortable']);
	
	lbaGrid.controller('lbaGridCtrl', __webpack_require__(146));
	lbaGrid.controller('lbaDeleteConfirmCtrl', __webpack_require__(148));
	lbaGrid.directive('lbaGrid', __webpack_require__(149));
	
	exports['default'] = lbaGrid;
	module.exports = exports['default'];

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _moment = __webpack_require__(19);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _configConstants = __webpack_require__(147);
	
	var _configConstants2 = _interopRequireDefault(_configConstants);
	
	var $inject = ['$location', '$scope', '$timeout', '$routeParams', '$http', 'dataService', 'dataSourceService', 'microApiService'];
	
	var lbaGridCtrl = function lbaGridCtrl($location, $scope, $timeout, $routeParams, $http, dataService, dataSourceService, microApiService) {
	  var vm = this;
	
	  vm.dataService = dataService;
	  vm.ready = false;
	  vm.canAdd = vm.settings.hasOwnProperty('gridAdd');
	  vm.filters = undefined;
	  if (dataService.backGridFilter != null && dataService.backGridFilter[vm.settings.displayName]) {
	    vm.filters = dataService.backGridFilter[vm.settings.displayName];
	  }
	  var page = 1;
	  if (dataService.backGridPage != null && dataService.backGridPage[vm.settings.displayName]) {
	    page = dataService.backGridPage[vm.settings.displayName];
	  }
	  $scope.$watch("vm.filters", function () {
	    if (vm.filters === '') {
	      vm.filters = undefined;
	    }
	  });
	  vm.onClick = onClick;
	  vm.addNew = addNew;
	  vm.getObjectPropertyValue = getObjectPropertyValue;
	  vm.getValueToDisplay = getValueToDisplay;
	  vm.isShowingDisabled = false;
	  vm.toggleDisabledData = toggleDisabledData;
	  vm.isRestEndpoint = vm.settings.isRestEndpoint || false;
	
	  vm.sortableOptions = {
	    disabled: !vm.settings.sortable,
	    stop: function stop(e, ui) {
	      var originalGridData = getGridData();
	      updateGridData(originalGridData, vm.resource.rows);
	      loadData();
	    }
	  };
	
	  loadData(true);
	
	  function processMicroService(res) {
	    vm.dataService.data.items = res.data;
	    vm.resource = {
	      header: vm.settings.gridCols,
	      rows: vm.dataService.data.items,
	      pagination: {
	        page: page
	      }
	    };
	
	    vm.ready = true;
	  }
	
	  function loadData(getData) {
	    if (vm.settings.microService) {
	      dataSourceService.dataSource = _configConstants2["default"].DATA_SOURCES.AUTH_ZERO;
	      microApiService.get({ endpoint: vm.settings.endpoint, cb: processMicroService });
	    } else {
	      if (vm.settings.endpoint && getData) {
	        dataSourceService.dataSource = _configConstants2["default"].DATA_SOURCES.ODATA;
	        dataService.data.activeItem = undefined;
	        var ODataArgs = vm.settings.ODataArgs || '';
	        if (vm.settings.ODataArgs && $routeParams) {
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = Object.entries($routeParams)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var _step$value = _slicedToArray(_step.value, 2);
	
	              var key = _step$value[0];
	              var value = _step$value[1];
	
	              if (ODataArgs.indexOf(":" + key) !== -1) {
	                ODataArgs = ODataArgs.replace(":" + key, value);
	              }
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator["return"]) {
	                _iterator["return"]();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        }
	        dataService.get(vm.settings.endpoint + ODataArgs, null, vm.isRestEndpoint).then(function (data) {
	          vm.dataService.data.items = data;
	          vm.globalData = data;
	
	          var dataToShow = filterDisabledData(vm.isShowingDisabled);
	          addDataToGrid(vm.settings.gridCols, dataToShow, page);
	        });
	      } else {
	        var rowData = prepData(getGridData());
	        vm.globalData = rowData;
	
	        var dataToShow = filterDisabledData(vm.isShowingDisabled);
	        addDataToGrid(vm.settings.gridCols, dataToShow, page);
	      }
	    }
	  }
	
	  function getGridData() {
	    if ($routeParams && Object.keys($routeParams).length != 0 && vm.settings.dataAt) {
	      var dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
	      var gridData = _.get(dataService.data.activeItem, dataLookUp);
	      return gridData;
	    } else {
	      return dataService.data.items;
	    }
	  }
	
	  function updateGridData(originalGridData, newGridData) {
	    for (var i = 0; i < originalGridData.length; i++) {
	      if (newGridData[i]) {
	        originalGridData[i] = newGridData[i];
	      }
	    }
	  }
	
	  function filterDisabledData(isDisabledShowing) {
	    var unfilteredData = vm.globalData;
	    var propertyName = vm.settings.disableProperty || "Disabled";
	
	    if (!!vm.settings.canFilterDisabled) {
	      if (!!!isDisabledShowing) {
	
	        var filteredData = [];
	
	        for (var i = 0; i < unfilteredData.length; i++) {
	          var canPushUnfilteredItem = !!vm.settings.filterUsingEnabled ? unfilteredData[i][propertyName] : !unfilteredData[i][propertyName];
	          if (canPushUnfilteredItem) {
	            filteredData.push(unfilteredData[i]);
	          }
	        }
	
	        return filteredData;
	      }
	    }
	
	    return unfilteredData;
	  }
	
	  function toggleDisabledData() {
	    vm.isShowingDisabled = !vm.isShowingDisabled;
	    var dataToShow = filterDisabledData(vm.isShowingDisabled);
	    addDataToGrid(vm.settings.gridCols, dataToShow, page);
	  }
	
	  function addDataToGrid(headers, data, page) {
	
	    vm.resource = {
	      header: headers,
	      rows: data,
	      pagination: {
	        page: page
	      }
	    };
	
	    vm.ready = true;
	  }
	
	  function onClick(data, copyItem, copyResource) {
	    if (vm.settings.disableRowClick) {
	
	      if (dataService && dataService.data && data && vm.settings.setActiveItemSubItem) {
	        dataService.data.activeItemSubItem = data;
	      } else if (dataService && dataService.data && data) {
	        dataService.data.activeItem = data;
	      }
	      return;
	    }
	
	    if (copyItem) {
	      vm.ready = false;
	
	      $timeout(function () {
	        var clonedData = angular.copy(data);
	        delete clonedData.Id;
	        if (!(clonedData[vm.settings.gridCols[0].key] instanceof Array) && !vm.settings.copyWithoutCopyText) {
	          clonedData[vm.settings.gridCols[0].key] += ' COPY';
	        }
	        vm.resource.rows.push(clonedData);
	        var dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
	        var activeItem = prepData(_.get(dataService.data.activeItem, dataLookUp));
	        activeItem.push(clonedData);
	        _.set(dataService.data.activeItem, dataLookUp, activeItem);
	        vm.copyMode = false;
	        vm.ready = true;
	      }, 0);
	
	      return;
	    }
	
	    if (copyResource) {
	      var _ret = (function () {
	        var copyResourceEndpoint = vm.settings.copyResourceEndpoint || vm.settings.endpoint;
	        var nameFieldName = vm.settings.nameFieldName || 'Name';
	
	        dataService.get(copyResourceEndpoint, data.Id).then(function (data) {
	          var duplicate = data;
	
	          if (!vm.settings.copyWithoutCopyText) {
	            duplicate[nameFieldName] = duplicate[nameFieldName] + ' COPY';
	          }
	
	          delete duplicate.Id;
	
	          vm.dataService.post(copyResourceEndpoint, duplicate, true).then(function (data) {
	            updatePath(data);
	          });
	        });
	
	        return {
	          v: undefined
	        };
	      })();
	
	      if (typeof _ret === "object") return _ret.v;
	    }
	
	    var rowIndex = 0;
	
	    // JLF: LOBT-700: undersore's findIndex was removed as it returned false positives
	    _.find(vm.resource.rows, function (item, index) {
	      if (item === data) rowIndex = index;
	    });
	
	    // JLF: LOBT-773: also caching the current page and filter on the grid as well
	    dataService.backPath = $location.$$path;
	    if (!dataService.backGridFilter) dataService.backGridFilter = {};
	    dataService.backGridFilter[vm.settings.displayName] = vm.filters;
	    if (!dataService.backGridPage) dataService.backGridPage = {};
	    dataService.backGridPage[vm.settings.displayName] = vm.resource.pagination.page || 1;
	
	    updatePath(data, rowIndex);
	  }
	
	  function addNew() {
	    dataService.backPath = $location.$$path;
	
	    if (vm.settings.gridAdd) {
	      $location.path($location.$$path + '/add');
	    } else {
	      dataService.addNewMode = true;
	      // Create backup of complete data structure before adding empty item
	      dataService.addNewBackup = angular.copy(dataService.data);
	
	      if (vm.resource.rows) {
	        vm.resource.rows.push({});
	      } else {
	        vm.resource.rows = [{}];
	      }
	      updatePath({}, vm.resource.rows.length - 1);
	    }
	  }
	
	  function updatePath(data, index) {
	
	    var displayNamePathReady = vm.settings.gridAdd || vm.settings.routeWithId ? '' : vm.settings.displayName.replace(/\s+/g, '-').toLowerCase();
	
	    if (vm.settings.pathSwitcher) {
	      displayNamePathReady = vm.settings.pathSwitcher(data);
	    }
	
	    var appendToPath = displayNamePathReady + (vm.settings.gridAdd || vm.settings.routeWithId ? data.Id : '/' + index);
	    $location.path($location.$$path + '/' + appendToPath);
	  }
	
	  function prepData(data) {
	    if (data) {
	      return data.map(function (item) {
	        return item;
	      });
	    }
	  }
	
	  function getObjectPropertyValue(obj, path) {
	    var defaultValue = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	    var formater = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	    var val = _.get(obj, path, defaultValue);
	    if (val && formater === "dateLocal") {
	      return _moment2["default"].utc(val).local().format("M/D/Y HH:mm Z");
	    }
	    return val;
	  }
	  function getValueToDisplay(val) {
	    if (val) return val;
	    if (val === "0" || val === 0) return "0";
	    return "-";
	  }
	};
	
	lbaGridCtrl.$inject = $inject;
	
	exports["default"] = lbaGridCtrl;
	module.exports = exports["default"];

/***/ },
/* 147 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = {
	  DISPLAY_AS: {
	    TEXT_INPUT: 'text-input',
	    BOOLEAN: 'boolean',
	    TIME_ZONE_SELECT: 'time-zone-select',
	    SUB_HEADING: 'sub-heading',
	    ADD_GRID_RESOURCE: 'add-grid-resource',
	    RESOURCE: 'resource',
	    GRID: 'grid',
	    PAGING_GRID: 'paging-grid',
	    TAG_INPUT: 'tag-input',
	    SELECT: 'select',
	    KEY_VALUE_PAIRS: 'key-value-pairs',
	    POINTS_OF_INTEREST: 'points-of-interest',
	    COMPANY_REFERENCE: 'company-reference',
	    SEARCH_BY: 'search-by',
	    FILE_UPLOADER: 'file-uploader',
	    COUNTRY_SELECT: 'country-select',
	    BOOLEAN_RESTRICTION_SELECT: 'boolean-restriction-select',
	    FARE_CLASS_TYPE_SELECT: 'fare-class-type-select',
	    TEXT_AREA: 'text-area',
	    MULTI_SELECT: 'multi-select',
	    GROUP: 'group',
	    TABS: 'tabs',
	    LAT_LONG_MAP_SEARCH: 'lat-long-map-search',
	    HOTEL: 'hotel',
	    LAT_LNG_MAP: 'lat-lng-map',
	    RANGE: 'range',
	    O_DATA_SELECT: 'o-data-select',
	    HOTEL_TAG_SELECT: 'hotel-tag-select',
	    FILE_DOWNLOADER: 'file-downloader',
	    VIEW_GRID: 'view-grid',
	    DATE_PICKER: 'date',
	    PER_DIEM: 'per-diem',
	    PER_DIEM_GRID_ITEM: 'per-diem-grid-item',
	    PER_DIEM_FILE_UPLOADER: 'per-diem-file-uploader',
	    TEST_FTP_CONNECTION: 'test-ftp-connection',
	    ENHANCED_LOG_ITEM: 'enhanced-log-item',
	    COMPANY_REFEREENCE_AUDIT_ITEM: 'company-reference-config-audit-item'
	  },
	  MICRO_SERVICE: {
	    DEBTORS: 'debtors'
	  },
	  DATA_SOURCES: {
	    ODATA: 'odata',
	    AUTH_ZERO: 'auth0'
	  },
	  PRODUCT_FAMILY: {
	    LB: 'Lightning Book',
	    CTM: 'CTM',
	    SupplierRelations: 'Supplier Relations'
	  },
	  FIELDS: {
	    ENHANCEDPOLICYRULES: 'EnhancedPolicyRules',
	    ENHANCEDPOLICYRULEACTIONS: 'Actions'
	  },
	  MESSAGES: {
	    NDC_TIE_SETTINGS: "<i title='For example if type NDC is selected and threshold is 0. Then Atpco will be shown unless the NDC fare is less then the Atpco.'>The selected type will only be used if the savings is greater than the defined threshold</i>"
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 148 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$uibModalInstance', 'id'];
	
	var lbaDeleteConfirmCtrl = function lbaDeleteConfirmCtrl($uibModalInstance, id) {
	  var vm = this;
	
	  vm.id = id;
	
	  vm.ok = function () {
	    $uibModalInstance.close(vm.id);
	  };
	
	  vm.cancel = function () {
	    $uibModalInstance.dismiss('cancel');
	  };
	};
	
	lbaDeleteConfirmCtrl.$inject = $inject;
	
	exports['default'] = lbaDeleteConfirmCtrl;
	module.exports = exports['default'];

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(150);
	
	var $inject = [];
	
	var lbaGrid = function lbaGrid() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '='
	    },
	    bindToController: true,
	    controller: 'lbaGridCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(152)
	  };
	};
	
	lbaGrid.$inject = $inject;
	
	exports['default'] = lbaGrid;
	module.exports = exports['default'];

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(151);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaGrid.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaGrid.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".lbaGrid{background:#fff;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);padding:2rem;margin:.75rem 0 1.5rem}.lbaGrid .lbaGrid_tools{display:flex;justify-content:space-between;margin-bottom:2rem}.lbaGrid .lbaGrid_filter{width:unset;float:unset;align-self:center}.lbaGrid .clearfix:after,.lbaGrid .clearfix:before{content:unset}.lbaGrid_name{margin:0;vertical-align:middle}.lbaGrid_add,.lbaGrid_back{float:right}.lbaGrid_table{border:1px solid #e1e1e1;table-layout:fixed}.lbaGrid_tr{cursor:pointer}.lbaGridDetails{position:relative}.lbaGridDetails_tools{position:absolute;top:0;right:0}.lbaGrid_pagination{text-align:right}.lbaGrid_pagination .pagination{margin:0}.btn_copyMode{border-color:#9ab845}.btn_copyMode,.btn_copyMode:focus,.btn_copyMode:hover{color:#fff;background:#9ab845}.copyMode:hover,.copyMode:hover td{background:#9ab845!important}.copyMode:hover td{color:#fff}.lbaGrid_noRecords{position:relative;background:#f5f5f5;display:block;padding:1rem}.hideOverflow{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaGrid/src/components/lbaGrid/lbaGrid.scss","/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaGrid/src/globalStyles/_variables.scss"],"names":[],"mappings":"AAEA,SACI,gBACA,sBACA,kBACA,4CACA,aACA,sBAA0B,CAN9B,wBASQ,aACA,8BACA,kBAAmB,CAX3B,yBAeQ,YACA,YACA,iBAAkB,CAjB1B,mDAyBQ,aAAc,CACjB,cAID,SACA,qBAAsB,CACzB,AAIA,2BAGG,WAAY,CACf,eAGG,yBACA,kBAAmB,CACtB,YAGG,cAAe,CAClB,gBAGG,iBAAkB,CACrB,sBAGG,kBACA,MACA,OAAQ,CACX,oBAGG,gBAAiB,CACpB,gCAGG,QAAS,CACZ,cAGG,oBACA,CAFJ,sDAEI,WACA,kBC1EgB,CD+Ef,AAGL,mCACI,4BAAkC,CAKjC,AANL,mBAIQ,UACA,CACH,mBAID,kBACA,mBACA,cACA,YAAa,CAChB,cAGG,uBACA,mBACA,eAAgB,CACnB","file":"lbaGrid.scss","sourcesContent":["@import \"../../globalStyles/variables\";\r\n\r\n.lbaGrid {\r\n    background: #fff;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\r\n    padding: 2rem;\r\n    margin: 0.75rem 0 1.5rem 0;\r\n\r\n    .lbaGrid_tools {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        margin-bottom: 2rem;\r\n    }\r\n    \r\n    .lbaGrid_filter {\r\n        width: unset;\r\n        float: unset;\r\n        align-self: center;\r\n    }\r\n\r\n    .clearfix::before{\r\n        content: unset;\r\n    }\r\n\r\n    .clearfix::after{\r\n        content: unset;\r\n    }\r\n}\r\n\r\n.lbaGrid_name {\r\n    margin: 0;\r\n    vertical-align: middle;\r\n}\r\n\r\n.lbaGrid_add {\r\n    float: right;\r\n}\r\n\r\n.lbaGrid_back {\r\n    float: right;\r\n}\r\n\r\n.lbaGrid_table {\r\n    border: 1px solid #e1e1e1;\r\n    table-layout: fixed;\r\n}\r\n\r\n.lbaGrid_tr {\r\n    cursor: pointer;\r\n}\r\n\r\n.lbaGridDetails {\r\n    position: relative;\r\n}\r\n\r\n.lbaGridDetails_tools {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n}\r\n\r\n.lbaGrid_pagination {\r\n    text-align: right;\r\n}\r\n\r\n.lbaGrid_pagination .pagination {\r\n    margin: 0;\r\n}\r\n\r\n.btn_copyMode {\r\n    border-color: $brandGreen;\r\n    color: #fff;\r\n    background: $brandGreen;\r\n\r\n    &:hover, &:focus {\r\n        color: #fff;\r\n        background: $brandGreen;\r\n    }\r\n}\r\n\r\n.copyMode:hover {\r\n    background: $brandGreen !important;\r\n\r\n    td {\r\n        color: #fff;\r\n        background: $brandGreen !important;\r\n    }\r\n}\r\n\r\n.lbaGrid_noRecords {\r\n    position: relative;\r\n    background: #f5f5f5;\r\n    display: block;\r\n    padding: 1rem;\r\n}\r\n\r\n.hideOverflow {\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n}\r\n","$brandGreen: #9ab845;"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 152 */
/***/ function(module, exports) {

	var v1="<div ng-if=\"!vm.dataService.addNewMode\"> <label class=\"lbaGrid_name\" ng-if=\"vm.settings.displayName\">{{ vm.settings.displayName }} listing</label> <div class=\"lbaGrid\" ng-if=\"vm.ready\"> <div class=\"lbaGrid_tools clearfix\"> <div class=\"input-group input-group-md lbaGrid_filter\" ng-if=\"vm.resource.rows.length > 0\"> <span class=\"input-group-addon\" ng-if=\"!vm.settings.sortable\"><i class=\"glyphicon glyphicon-search\"></i></span>\n<input ng-model=\"vm.filters\" type=\"text\" placeholder=\"Filter by...\" class=\"form-control lbaGrid_filter\" ng-if=\"!vm.settings.sortable\"> </div> <div ng-if=\"vm.settings.canFilterDisabled\" class=\"input-group input-group-md lbaGrid_filter\" style=\"padding-left: 20px\"> <input type=\"checkbox\" ng-click=\"vm.toggleDisabledData()\">\nShow Disabled </div> <div class=\"lbaGrid_add\"> <button ng-show=\"vm.settings.canAddNew || vm.settings.gridAdd\" ng-click=\"vm.addNew()\" class=\"btn btn-default\"><i class=\"fa fa-plus\"></i> Add new </button>\n<span ng-if=\"vm.resource.rows.length > 0\"> <button ng-show=\"vm.settings.canCopyItem\" ng-click=\"vm.copyMode = !vm.copyMode\" class=\"btn btn-default\" ng-class=\"{ 'btn_copyMode': vm.copyMode }\"><i class=\"fa fa-files-o\"></i>\nCopy</button>\n<button ng-show=\"vm.settings.canCopyResource\" ng-click=\"vm.copyResourceMode = !vm.copyResourceMode\" class=\"btn btn-default\" ng-class=\"{ 'btn_copyMode': vm.copyResourceMode }\"><i class=\"fa fa-files-o\"></i> Copy</button> </span> </div> </div> <div tasty-table bind-resource=\"vm.resource\" bind-watch-resource=\"collection\" bind-filters=\"vm.filters\" ng-if=\"vm.resource.rows.length > 0 && !vm.settings.sortable\"> <table class=\"table table-striped table-condensed table-hover lbaGrid_table\"> <thead tasty-thead></thead> <tbody ng-model=\"vm.resource.rows\"> <tr ng-repeat=\"row in rows track by $index\" class=\"lbaGrid_tr\" ng-class=\"{ 'copyMode': vm.copyMode || vm.copyResourceMode }\" ng-click=\"vm.onClick(row, vm.copyMode, vm.copyResourceMode)\"> <td class=\"hideOverflow\" ng-repeat=\"col in vm.settings.gridCols\" title=\"{{ vm.getObjectPropertyValue(row, col.key,null, col.formater) || '-' }}\"> {{ vm.getValueToDisplay(vm.getObjectPropertyValue(row, col.key,null, col.formater)) }}</td> </tr> </tbody> </table> <div tasty-pagination bind-template-url=\"'gridPaginationTpl.html'\" items-per-page=\"10\"></div> </div> <div tasty-table bind-resource=\"vm.resource\" bind-watch-resource=\"collection\" bind-filters=\"vm.filters\" ng-if=\"vm.resource.rows.length > 0 && vm.settings.sortable\"> <table class=\"table table-striped table-condensed table-hover lbaGrid_table\"> <thead tasty-thead bind-not-sort-by=\"[]\"></thead> <tbody ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.resource.rows\"> <tr ng-repeat=\"row in rows track by $index\" class=\"lbaGrid_tr\" ng-class=\"{ 'copyMode': vm.copyMode || vm.copyResourceMode }\" ng-click=\"vm.onClick(row, vm.copyMode, vm.copyResourceMode)\"> <td class=\"hideOverflow\" ng-repeat=\"col in vm.settings.gridCols\" title=\"{{ vm.getObjectPropertyValue(row, col.key,null, col.formater) || '-' }}\"> {{ vm.getValueToDisplay(vm.getObjectPropertyValue(row, col.key,null,col.formater)) }}</td> </tr> </tbody> </table> </div> <span ng-if=\"!vm.resource.rows || vm.resource.rows.length === 0\" class=\"lbaGrid_noRecords\"> No Records Found </span> <div ng-if=\"vm.settings.htmlInner\" ng-bind-html=\"vm.settings.htmlInner\"></div> </div> <div ng-if=\"vm.settings.html\" ng-bind-html=\"vm.settings.html\"></div> <div id=\"pagingGridActiveItemParent\"> <div id=\"pagingGridActiveItemWindow\"> <div class=\"pagingGridActiveItem\" id=\"pagingGridActiveItem\" ng-if=\"vm.dataService.data.activeItem\"> <div ng-repeat=\"item in vm.settings.children track by $index\"> <div lba-dynamic=\"'lba-' + item.displayAs\" settings=\"item\"></div> </div> </div> </div> </div> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaGrid.html", v1)}]);
	module.exports=v1;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaGridItem = angular.module('app.lbaGridItem', []);
	
	lbaGridItem.controller('lbaGridItemCtrl', __webpack_require__(154));
	lbaGridItem.directive('lbaGridItem', __webpack_require__(155));
	
	exports['default'] = lbaGridItem;
	module.exports = exports['default'];

/***/ },
/* 154 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$routeParams', 'dataService', 'settingsService'];
	
	var lbaGridItemCtrl = function lbaGridItemCtrl($routeParams, dataService, settingsService) {
	  var vm = this;
	  var paramId = $routeParams[vm.settings.routeParamId];
	
	  vm.ready = false;
	  vm.deleteConfirm = false;
	  vm.fields = settingsService.settings.fields;
	  vm.cancel = cancel;
	  vm.update = update;
	  vm.deleteItem = deleteItem;
	
	  if (!dataService.data.activeItem) {
	    dataService.get(vm.settings.endpoint, paramId).then(function (data) {
	      dataService.data.activeItem = data[0];
	      vm.ready = true;
	    });
	  } else {
	    vm.ready = true;
	  }
	
	  function cancel() {
	    vm.grid.cancel();
	  }
	
	  function update() {
	    vm.grid.update();
	  }
	
	  function deleteItem() {
	    if (!vm.deleteConfirm) {
	      vm.deleteConfirm = true;
	    } else {
	      vm.grid.deleteItem();
	    }
	  }
	};
	
	lbaGridItemCtrl.$inject = $inject;
	
	exports['default'] = lbaGridItemCtrl;
	module.exports = exports['default'];

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var lbaGridItem = function lbaGridItem() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaGridItemCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(156)
	  };
	};
	
	// link: function (scope, element, attrs, ctrls) {
	//   scope.vm.grid = ctrls;
	// }
	lbaGridItem.$inject = $inject;
	
	exports['default'] = lbaGridItem;
	module.exports = exports['default'];

/***/ },
/* 156 */
/***/ function(module, exports) {

	var v1="<div ng-if=\"vm.ready\"> <ng-form name=\"vm.gridItemForm\"> <h3><i class=\"fa fa-pencil-square\"></i> Edit {{ vm.settings.displayName }}</h3> <div ng-repeat=\"item in vm.settings.children track by $index\"> <div lba-dynamic=\"'lba-' + item.displayAs\" settings=\"item\"></div> </div> <div class=\"lbaModal_buttons\"> <button type=\"button\" class=\"btn lbaModal_deleteButton\" ng-class=\"{'btn-danger': vm.deleteConfirm, 'btn-link': !vm.deleteConfirm}\" ng-click=\"vm.deleteItem()\" ng-switch=\"vm.deleteConfirm\"> <span ng-switch-when=\"true\">Confirm</span>\n<span ng-switch-default>Delete</span> </button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.cancel()\">Cancel</button>\n<button type=\"submit\" class=\"btn btn-lightning\" ng-click=\"vm.update()\">Update</button> </div> </ng-form> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaGridItem.html", v1)}]);
	module.exports=v1;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaDynamic = angular.module('app.lbaDynamic', []);
	
	lbaDynamic.directive('lbaDynamic', __webpack_require__(158));
	
	exports['default'] = lbaDynamic;
	module.exports = exports['default'];

/***/ },
/* 158 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$compile'];
	var lbaDynamic = function lbaDynamic($compile) {
	  return {
	    restrict: 'A',
	    replace: false,
	    //terminal: true,  // might need these lines if compile issues occur
	    //priority: 1000,
	    link: function link(scope, element, attrs) {
	      element.attr(scope.$eval(attrs.lbaDynamic), '');
	
	      element.removeAttr('lba-dynamic');
	
	      $compile(element)(scope);
	    }
	  };
	};
	
	lbaDynamic.$inject = $inject;
	
	exports['default'] = lbaDynamic;
	module.exports = exports['default'];

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaResource = angular.module('app.lbaResource', []);
	
	lbaResource.controller('lbaResourceCtrl', __webpack_require__(160));
	lbaResource.directive('lbaResource', __webpack_require__(161));
	
	exports['default'] = lbaResource;
	module.exports = exports['default'];

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _configConstants = __webpack_require__(147);
	
	var _configConstants2 = _interopRequireDefault(_configConstants);
	
	var $inject = ['$window', '$scope', '$location', '$routeParams', '$timeout', 'dataService', 'settingsService', 'microApiService', 'dataSourceService', '$rootScope', 'moment'];
	
	var lbaResourceCtrl = function lbaResourceCtrl($window, $scope, $location, $routeParams, $timeout, dataService, settingsService, microApiService, dataSourceService, $rootScope, moment) {
	    $timeout(function () {
	        $window.scrollTo(0, 0);
	    });
	
	    var vm = this;
	    vm.save = save;
	    vm.cancel = cancel;
	    vm['delete'] = deleteItem;
	    vm.ready = false;
	    vm.fields = settingsService.settings.fields;
	    vm.deleteConfirm = false;
	    vm.cancelConfirm = false;
	    vm.itemAdded = false;
	    vm.dataService = dataService;
	    vm.showCancel = dataService.addNewMode;
	    vm.addNew = addNew;
	    vm.cancelNew = cancelNew;
	    vm.showBack = vm.settings.showBack; // flag to display back button instead of other buttons.
	    vm.continueEditing = continueEditing;
	    vm.noButtons = vm.settings.noButtons;
	    vm.validateAtLeastOneHasValueSet = vm.settings.validateAtLeastOneHasValueSet;
	    vm.hasAtLeastOneValueSet = false;
	    vm.disableAddNew = disableAddNew;
	    vm.isAddNewDisabled = isAddNewDisabled;
	    function processData(res) {
	        dataService.data.activeItem = res.data;
	        vm.ready = true;
	    }
	
	    var routeParamId = getRouteParamId();
	
	    function getRouteParamId() {
	        var routeId = vm.settings.routeParamId;
	        if (!routeId && vm.settings.endpoint !== "Settings") {
	            var keys = Object.keys($routeParams).filter(function (key) {
	                return key !== 'tab' && key !== 'subtab' && key !== 'removeIndex' && key !== 'removeParamId' && key !== 'dataAt' && key !== 'splat' && key !== 'path';
	            });
	            if (keys.length > 0) {
	                routeId = keys[0];
	            }
	        }
	        return routeId;
	    }
	    if (vm.settings.microService) {
	        dataSourceService.dataSource = _configConstants2['default'].DATA_SOURCES.AUTH_ZERO;
	        microApiService.get({ endpoint: vm.settings.endpoint + '/' + $routeParams[routeParamId], cb: processData });
	    } else {
	        if (dataService.addNewMode) {
	            dataService.cleanDataOnRouteChange = true;
	            vm.activeData = dataService.data.activeItem;
	            vm.activeItemCopy = angular.copy(dataService.data.activeItem);
	        }
	
	        if (!dataService.data.activeItem || dataService.refreshDataOnLoad) {
	            if (!vm.settings.endpoint) {
	                vm.ready = true;
	                return;
	            }
	            dataService.refreshDataOnLoad = false;
	
	            dataService.get(vm.settings.endpoint, $routeParams[routeParamId]).then(function (data) {
	                if (Array.isArray(data)) {
	                    dataService.data.activeItem = data[0];
	                    $rootScope.activeItemData = JSON.parse(JSON.stringify(dataService.data.activeItem));
	                } else {
	                    dataService.data.activeItem = data;
	                    $rootScope.activeItemData = JSON.parse(JSON.stringify(dataService.data.activeItem));
	                    if (!$rootScope.isSaved) {
	                        dataService.data.activeItem = JSON.parse(JSON.stringify($rootScope.activeItemData));
	                    } else {
	                        $rootScope.activeItemData = JSON.parse(JSON.stringify(dataService.data.activeItem));
	                        $rootScope.isSaved = false;
	                    }
	                }
	
	                checkCreditCardToken();
	
	                vm.ready = true;
	            });
	        } else {
	            vm.ready = true;
	            if (!$rootScope.isSaved && !$rootScope.isGridItemChanged) {
	                dataService.data.activeItem = JSON.parse(JSON.stringify($rootScope.activeItemData));
	                $rootScope.isGridItemDeleted = false;
	            } else {
	                $rootScope.activeItemData = JSON.parse(JSON.stringify(dataService.data.activeItem));
	                $rootScope.isSaved = false;
	                $rootScope.isGridItemChanged = false;
	            }
	        }
	    }
	
	    function save() {
	        if (!vm.resourceForm.$valid) {
	            vm.errors = vm.resourceForm.$error.required;
	            vm.formErrors = true;
	
	            return false;
	        }
	
	        if (vm.validateAtLeastOneHasValueSet && !vm.hasAtLeastOneValueSet) {
	            $rootScope.$broadcast('lbaToast:showToast', { message: 'At least one element needs to be populated', messageType: 'error' });
	            return false;
	        }
	
	        var resourceId = vm.settings.endpoint === "Settings" && dataService.data.activeItem ? dataService.data.activeItem.Id : $routeParams[routeParamId];
	
	        return dataService.patch(vm.settings.endpoint, dataService.data.activeItem, resourceId);
	    }
	
	    function cancel() {
	        if (!vm.settings.endpoint) {
	            vm.ready = true;
	            return;
	        }
	        vm.ready = false;
	
	        dataService.get(vm.settings.endpoint, $routeParams[vm.settings.routeParamId]).then(function (data) {
	            if (Array.isArray(data)) {
	                dataService.data.activeItem = data[0];
	            } else {
	                dataService.data.activeItem = data;
	            }
	
	            if (dataService.backPath) {
	                var pathToNavigate = dataService.backPath;
	                dataService.backPath = undefined;
	                $location.path(pathToNavigate);
	                return;
	            }
	
	            vm.cancelConfirm = false;
	            vm.ready = true;
	        });
	    }
	
	    function deleteItem() {
	        if (!vm.deleteConfirm) {
	            vm.deleteConfirm = true;
	        } else {
	            $rootScope.isGridItemChanged = true;
	            deleteOnBackend();
	        }
	    }
	
	    function deleteOnBackend() {
	        if (!vm.settings.deleteOnBackend) {
	            backPath();
	            return;
	        }
	
	        dataService['delete'](vm.settings.endpoint, $routeParams[routeParamId]).then(function () {
	            backPath();
	        });
	    }
	
	    function addNew() {
	        dataService.addNewMode = false;
	        dataService.cleanDataOnRouteChange = false;
	        vm.showCancel = false;
	        vm.itemAdded = true;
	        $rootScope.isGridItemChanged = true;
	    }
	    function continueEditing() {
	        vm.itemAdded = false;
	        if (vm.settings.continueEditPath) {
	
	            var index = $routeParams[vm.settings.removeParamId];
	            var itemId = $routeParams[routeParamId];
	            var actionPath = vm.settings.continueEditPath(itemId, index, dataService.data.activeItem);
	            $location.path(actionPath);
	        }
	    }
	
	    function cancelNew() {
	        // If we're in addNewMode and have a backup, restore it safely
	        if (dataService.addNewMode && dataService.addNewBackup) {
	            // Ensure dataService.data exists and has proper structure
	            if (!dataService.data) {
	                dataService.data = { activeItem: undefined, items: [] };
	            }
	
	            // Restore from backup safely
	            if (dataService.addNewBackup.activeItem !== undefined) {
	                dataService.data.activeItem = angular.copy(dataService.addNewBackup.activeItem);
	            }
	            if (dataService.addNewBackup.items) {
	                dataService.data.items = angular.copy(dataService.addNewBackup.items);
	            }
	
	            dataService.addNewMode = false;
	            dataService.addNewBackup = undefined;
	        }
	        backPath();
	    }
	
	    function backPath() {
	        var newLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
	
	        if (newLookUp.length > 1) {
	            newLookUp.pop();
	        }
	
	        var data = _.get(dataService.data.activeItem, newLookUp);
	        if (data) {
	            data.splice($routeParams[vm.settings.removeParamId], 1);
	        }
	
	        if (dataService.backPath) {
	            var pathToNavigate = dataService.backPath;
	            dataService.backPath = undefined; // Clear backPath after using it
	            $location.path(pathToNavigate);
	        } else {
	            var spiltPath = _.split($location.$$path, '/');
	            var dropTwoFromPath = _.dropRight(spiltPath, 2);
	            var rejoinPath = _.join(dropTwoFromPath, '/');
	            $location.path(rejoinPath);
	        }
	    }
	
	    function checkCreditCardToken() {
	        if (vm.settings.endpoint === "CreditCards" && !dataService.data.activeItem.Token) {
	            vm.ccTokenMissing = true;
	        }
	    }
	
	    // Returns true if the Add new button should be disabled.
	    // If settings.addNewRequiredField is provided (e.g., "Actions.$EnhancedPolicyRulesNewActionsItem.Type"),
	    // we resolve it against activeItem and require a truthy value before enabling Add new.
	    function disableAddNew() {
	        if (!vm.settings || !vm.settings.addNewRequiredField) return false;
	        try {
	            var lookUp = dataService.spiltDataAt(vm.settings.addNewRequiredField, $routeParams);
	            var val = _.get(dataService.data.activeItem, lookUp);
	            return !val; // disable when missing
	        } catch (e) {
	            return false;
	        }
	    }
	
	    function isAddNewDisabled() {
	        return vm.resourceForm.$invalid || vm.disableAddNew();
	    }
	
	    $scope.$on("ValidationStatusChanged", function (event, args) {
	        var formControl = vm.resourceForm && vm.resourceForm[args["controllerName"]];
	        if (!formControl) return;
	
	        if (args.isValid) {
	            formControl.$setValidity('customValidation', true);
	            if (vm.validateAtLeastOneHasValueSet) {
	                vm.hasAtLeastOneValueSet = !!args.value;
	            }
	        } else {
	            formControl.$setValidity('customValidation', false);
	        }
	    });
	};
	
	lbaResourceCtrl.$inject = $inject;
	
	exports['default'] = lbaResourceCtrl;
	module.exports = exports['default'];

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(162);
	
	var $inject = [];
	
	var lbaResource = function lbaResource() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaResourceCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(164)
	  };
	};
	
	lbaResource.$inject = $inject;
	
	exports['default'] = lbaResource;
	module.exports = exports['default'];

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(163);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaResource.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaResource.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".ccTokenError{color:red;display:inline}.save{background:#f9f9f9;position:fixed;right:0;bottom:0;left:0;padding:2rem;z-index:1000}.save,.save .btn{transition:all ease-in .2s}.save .btn{float:right;margin-left:1rem;width:150px;text-align:center}.itemAdded{z-index:9000;position:fixed;top:0;right:0;left:0;bottom:0;background:rgba(0,0,0,.4)}.itemAdded_content{text-align:center;margin:12rem auto 0;padding:2rem 4rem;background:#fff;width:35rem;border-radius:.4rem;box-shadow:0 0 9pt 2px rgba(0,0,0,.2)}.itemAdded_content i{font-size:3rem;color:#9ab845;margin:0 0 1rem}.itemAdded_content h3{margin:0 0 1rem}.itemAdded_content p{font-size:1rem;font-weight:600;margin:0 0 2rem}.deleteRecord{position:fixed;bottom:2rem;z-index:99999}.confirmDelete span{padding:0 1rem 0 0}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaResource/src/components/lbaResource/lbaResource.scss"],"names":[],"mappings":"AAEA,cAEE,UACA,cAAe,CAChB,MAGC,mBACA,eACA,QACA,SACA,OACA,aACA,YACA,CACD,iBADC,0BAA2B,CAS5B,AARA,WAGC,YACA,iBACA,YACA,iBACA,CACD,WAGC,aACA,eACA,MACA,QACA,OACA,SACA,yBAA0B,CAC3B,mBAGC,kBACA,oBACA,kBACA,gBACA,YACA,oBACA,qCAAuC,CAPzC,qBAUI,eACA,cACA,eAAgB,CAZpB,sBAgBI,eAAgB,CAhBpB,qBAoBI,eACA,gBACA,eAAkB,CACnB,cAID,eACA,YACA,aAAc,CACf,oBAIG,kBAAmB,CACpB","file":"lbaResource.scss","sourcesContent":["@import \"../../globalStyles/variables\";\r\n\r\n.ccTokenError\r\n{\r\n  color: red;\r\n  display: inline;\r\n}\r\n\r\n.save {\r\n  background: #f9f9f9;\r\n  position: fixed;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  padding: 2rem;\r\n  z-index: 1000;\r\n  transition: all ease-in .2s;\r\n}\r\n\r\n.save .btn {\r\n  float: right;\r\n  margin-left: 1rem;\r\n  width: 150px;\r\n  text-align: center;\r\n  transition: all ease-in .2s;\r\n}\r\n\r\n.itemAdded {\r\n  z-index: 9000;\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  left: 0;\r\n  bottom: 0;\r\n  background: rgba(0,0,0,.4);\r\n}\r\n\r\n.itemAdded_content {\r\n  text-align: center;\r\n  margin: 12rem auto 0;\r\n  padding: 2rem 4rem;\r\n  background: #fff;\r\n  width: 35rem;\r\n  border-radius: .4rem;\r\n  box-shadow: 0 0 12px 2px rgba(0,0,0,.2);\r\n\r\n  i {\r\n    font-size: 3rem;\r\n    color: $brandGreen;\r\n    margin: 0 0 1rem;\r\n  }\r\n\r\n  h3 {\r\n    margin: 0 0 1rem;\r\n  }\r\n\r\n  p {\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n    margin: 0 0 2rem 0;\r\n  }\r\n}\r\n\r\n.deleteRecord {\r\n  position: fixed;\r\n  bottom: 2rem;\r\n  z-index: 99999;\r\n}\r\n\r\n.confirmDelete {\r\n  span {\r\n    padding: 0 1rem 0 0;\r\n  }\r\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 164 */
/***/ function(module, exports) {

	var v1="<ng-form name=\"vm.resourceForm\" ng-if=\"vm.ready\"> <div class=\"ccTokenError\" ng-if=\"vm.ccTokenMissing\"> Error- Credit Card missing TokenEx token </div> <div ng-repeat=\"item in vm.settings.children track by $index\" class=\"{{item.formClass}}\"> <div lba-dynamic=\"'lba-' + item.displayAs\" settings=\"item\"></div> </div> <div class=\"deleteRecord\"> <button class=\"btn btn-link\" ng-if=\"vm.settings.canDelete && !vm.deleteConfirm && !vm.dataService.addNewMode\" ng-click=\"vm.delete()\"> <i class=\"glyphicon glyphicon-trash\"></i> Delete </button> <div ng-if=\"vm.deleteConfirm\" class=\"confirmDelete\"> <span>Are you sure?</span>\n<button class=\"btn btn-danger\" ng-click=\"vm.delete()\">Yes</button>\n<button class=\"btn btn-link\" ng-click=\"vm.deleteConfirm = false\"> Cancel </button> </div> </div> <div ng-if=\"vm.showCancel && !vm.noButtons\" class=\"save\"> <div class=\"wrapper clearfix\"> <button type=\"button\" class=\"btn btn-lightning\" ng-click=\"vm.addNew()\" ng-disabled=\"vm.isAddNewDisabled()\"> Add new </button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.cancelNew()\"> Cancel </button> </div> </div>  <div ng-if=\"vm.showBack && !vm.noButtons\" class=\"save\"> <div class=\"wrapper clearfix\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.cancel()\"> Back </button> </div> </div> <div class=\"save\" ng-if=\"!vm.showCancel && !vm.noButtons\"> <div class=\"wrapper clearfix\"> <div ng-if=\"!vm.cancelConfirm && !vm.settings.hideSave\"> <button type=\"button\" class=\"btn\" ng-class=\"{'btn-lightning': vm.resourceForm.$valid, 'btn-danger': !vm.resourceForm.$valid}\" ng-click=\"vm.save()\"> Save </button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.cancelConfirm = true\"> Cancel </button> </div> <div ng-if=\"vm.cancelConfirm\"> <p style=\"text-align: right\"> Are you sure you want to cancel all changes since the last save? </p> <button class=\"btn btn-danger\" ng-click=\"vm.cancel()\">Yes</button>\n<button class=\"btn btn-default\" ng-click=\"vm.cancelConfirm = false\"> No </button> </div> </div> </div> <div class=\"save\" ng-if=\"vm.showBack && !vm.noButtons\"> <div class=\"wrapper clearfix\"> <div ng-if=\"vm.showBack\">  <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.cancel()\"> Back </button> </div> </div> </div> </ng-form> <div class=\"itemAdded\" ng-if=\"vm.itemAdded\"> <div class=\"itemAdded_content\"> <i class=\"fa fa-check-circle\"></i> <h3>Record Added</h3> <p> Please note you still have to click save for this new record to persist. </p> <button type=\"button\" class=\"btn btn-lightning\" ng-click=\"vm.continueEditing()\"> Continue editing </button> </div> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaResource.html", v1)}]);
	module.exports=v1;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaSubHeading = angular.module('app.lbaSubHeading', []);
	
	lbaSubHeading.controller('lbaSubHeadingCtrl', __webpack_require__(166));
	lbaSubHeading.directive('lbaSubHeading', __webpack_require__(167));
	
	exports['default'] = lbaSubHeading;
	module.exports = exports['default'];

/***/ },
/* 166 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['dataService'];
	
	var lbaSubHeadingCtrl = function lbaSubHeadingCtrl(dataService) {
	  var vm = this;
	  vm.data = dataService.data.activeItem;
	};
	
	lbaSubHeadingCtrl.$inject = $inject;
	
	exports['default'] = lbaSubHeadingCtrl;
	module.exports = exports['default'];

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var lbaSubHeading = function lbaSubHeading() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '='
	    },
	    bindToController: true,
	    controller: 'lbaSubHeadingCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(168)
	  };
	};
	
	lbaSubHeading.$inject = $inject;
	
	exports['default'] = lbaSubHeading;
	module.exports = exports['default'];

/***/ },
/* 168 */
/***/ function(module, exports) {

	var v1="<div class=\"form-group lbaSubHeading\"> <h4 class=\"lbaSubHeading_heading\" ng-class=\"vm.data[vm.settings.dataAt]\"><small>{{vm.settings.label}}</small>\n{{vm.data[vm.settings.dataAt]}} <div ng-if=\"vm.settings.html\" ng-bind-html=\"vm.settings.html\"></div> </h4> <label ng-if=\"vm.settings.titleHeader\" ng-bind-html=\"vm.settings.titleHeader\"></label> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaSubHeading.html", v1)}]);
	module.exports=v1;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaTabs = angular.module('app.lbaTabs', []);
	
	lbaTabs.controller('lbaTabsCtrl', __webpack_require__(170));
	lbaTabs.directive('lbaTabs', __webpack_require__(171));
	
	exports['default'] = lbaTabs;
	module.exports = exports['default'];

/***/ },
/* 170 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$rootScope', '$location', '$routeParams', 'settingsService', 'dataService', 'subNavService'];
	
	var lbaTabsCtrl = function lbaTabsCtrl($rootScope, $location, $routeParams, settingsService, dataService, subNavService) {
	  var vm = this;
	  var paths = $location.$$path.split('/');
	  vm.dataService = dataService;
	
	  vm.showDropDown = false;
	
	  if (!dataService.data.activeItem || dataService.data.activeItem && vm.settings.routeParamId && dataService.data.activeItem.Id !== $routeParams[vm.settings.routeParamId]) {
	    dataService.get(vm.settings.endpoint, $routeParams[vm.settings.routeParamId]).then(function (data) {
	
	      if (Array.isArray(data)) {
	        dataService.data.activeItem = data[0];
	      } else {
	        dataService.data.activeItem = data;
	      }
	
	      vm.ready = true;
	    });
	  } else {
	    vm.ready = true;
	  }
	
	  vm.activeItem = paths[paths.length - 1].replace(/\s+/g, '-');
	  vm.fields = settingsService.settings.fields;
	  vm.showTab = showTab;
	  vm.clickOutside = clickOutside;
	  vm.getOptions = getOptions;
	  subNavService.navObj = createSubNav(vm.settings.children);
	
	  function showTab(tab) {
	    // JLF: LOBT-773: we must reset the grid cache with every fresh page being shown
	    dataService.backGridFilter = null;
	    dataService.backGridPage = null;
	    dataService.backViewGridFilter = null;
	    dataService.backViewGridPage = null;
	
	    paths[paths.length - 1] = tab.tabName.replace(/\s+/g, '-').toLowerCase();
	    $location.path(paths.join('/'));
	  }
	
	  function clickOutside() {
	    vm.showDropDown = false;
	  }
	
	  function getOptions() {
	    var fields = [];
	    vm.settings.children.forEach(function (item) {
	      fields.push(vm.fields[item].tabName);
	    });
	
	    return fields;
	  }
	
	  function createSubNav(data) {
	    if (data.length === 0) {
	      return [];
	    }
	
	    var nav = [];
	
	    data.forEach(function (item) {
	      var tabName = item.tabName;
	
	      nav.push({
	        name: tabName.split('-').join(' '),
	        link: buildLink(tabName),
	        active: vm.activeItem === tabName.toLowerCase()
	      });
	    });
	
	    function buildLink(tabName) {
	      paths[paths.length - 1] = tabName.replace(/\s+/g, '-').toLowerCase();
	      return paths.join('/');
	    }
	
	    $rootScope.showSubNav = true;
	    return nav;
	  }
	};
	
	lbaTabsCtrl.$inject = $inject;
	
	exports['default'] = lbaTabsCtrl;
	module.exports = exports['default'];

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var lbaTabs = function lbaTabs() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaTabsCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(172)
	  };
	};
	
	lbaTabs.$inject = $inject;
	
	exports['default'] = lbaTabs;
	module.exports = exports['default'];

/***/ },
/* 172 */
/***/ function(module, exports) {

	var v1="<div class=\"lbaTabs\" ng-if=\"vm.ready && !vm.dataService.addNewMode\" click-outside=\"vm.clickOutside()\"> <div ng-repeat=\"item in vm.settings.children track by $index\" ng-if=\"vm.activeItem === item.tabName.toLowerCase()\"> <div lba-dynamic=\"'lba-' + item.displayAs\" settings=\"item\"></div> </div> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaTabs.html", v1)}]);
	module.exports=v1;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaGroup = angular.module('app.lbaGroup', []);
	
	lbaGroup.controller('lbaGroupCtrl', __webpack_require__(174));
	lbaGroup.directive('lbaGroup', __webpack_require__(175));
	
	exports['default'] = lbaGroup;
	module.exports = exports['default'];

/***/ },
/* 174 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['settingsService'];
	
	var lbaGroupCtrl = function lbaGroupCtrl(settingsService) {
	  var vm = this;
	  vm.fields = settingsService.settings.fields;
	};
	
	lbaGroupCtrl.$inject = $inject;
	
	exports['default'] = lbaGroupCtrl;
	module.exports = exports['default'];

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var lbaGroup = function lbaGroup() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaGroupCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(176)
	  };
	};
	
	lbaGroup.$inject = $inject;
	
	exports['default'] = lbaGroup;
	module.exports = exports['default'];

/***/ },
/* 176 */
/***/ function(module, exports) {

	var v1="<section> <h3 ng-if=\"vm.settings.displayName && vm.settings.showTitle\">{{ vm.settings.displayName }}</h3> <div ng-repeat=\"item in vm.settings.children track by $index\" class=\"{{item.formClass}}\"> <div lba-dynamic=\"'lba-' + item.displayAs\" settings=\"item\"></div> </div> </section>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaGroup.html", v1)}]);
	module.exports=v1;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaTextInput = angular.module('app.lbaTextInput', []);
	
	lbaTextInput.controller('lbaTextInputCtrl', __webpack_require__(178));
	lbaTextInput.directive('lbaTextInput', __webpack_require__(179));
	
	exports['default'] = lbaTextInput;
	module.exports = exports['default'];

/***/ },
/* 178 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var $inject = ['$rootScope', '$scope', '$routeParams', '$timeout', 'dataService'];
	
	var lbaTextInputCtrl = function lbaTextInputCtrl($rootScope, $scope, $routeParams, $timeout, dataService) {
	    var vm = this;
	    var dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
	
	    vm.data = _.get(dataService.data.activeItem, dataLookUp);
	    vm.hideIfEmpty = vm.settings.hideIfEmpty && !vm.data; // hide if hideIfEmpty flag is set and the input is empty.
	    vm.inputType = vm.settings.inputType || 'text';
	    vm.min = vm.settings.min || 0;
	    vm.max = vm.settings.max || 10000000000;
	    vm.minLength = vm.settings.minLength || 0;
	    vm.maxLength = vm.settings.maxLength || 10000000000;
	    vm.validationPattern = vm.settings.validationRegex;
	    vm.isValid = true;
	    $scope.$watch(function () {
	        return dataService.data.activeItem;
	    }, function () {
	        vm.data = _.get(dataService.data.activeItem, dataLookUp);
	    });
	    $scope.$watchCollection('vm.data', function (newData, oldData) {
	
	        if (vm.validationPattern) {
	            var regex = new RegExp(vm.validationPattern);
	            vm.isValid = regex.test(vm.data || '');
	            $scope.$emit('ValidationStatusChanged', {
	                controllerName: $scope.vm.settings.dataAt,
	                value: newData,
	                isValid: vm.isValid
	            });
	        }
	
	        if (newData !== oldData) {
	            _.set(dataService.data.activeItem, dataLookUp, newData);
	        }
	    });
	
	    $rootScope.$on(vm.settings.dataAt, function () {
	        $timeout(function () {
	            vm.data = _.get(dataService.data.activeItem, dataLookUp);
	            vm.hideIfEmpty = vm.settings.hideIfEmpty && !vm.data; // hide if hideIfEmpty flag is set and the input is empty.
	        });
	    });
	};
	
	lbaTextInputCtrl.$inject = $inject;
	
	exports['default'] = lbaTextInputCtrl;
	module.exports = exports['default'];

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var lbaTextInput = function lbaTextInput() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaTextInputCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(180)
	  };
	};
	
	lbaTextInput.$inject = $inject;
	
	exports['default'] = lbaTextInput;
	module.exports = exports['default'];

/***/ },
/* 180 */
/***/ function(module, exports) {

	var v1="<div class=\"form-group\" ng-class=\"{'form-floating':vm.settings.floatingLabel}\"> <label ng-if=\"!vm.hideIfEmpty &&  vm.settings.displayName\" for=\"{{ vm.settings.dataAt }}\">{{ vm.settings.displayName }}</label> <input type=\"{{ vm.inputType }}\" class=\"form-control\" id=\"{{ vm.settings.dataAt }}\" placeholder=\"{{ vm.settings.placeholderText }}\" ng-model=\"vm.data\" ng-disabled=\"vm.settings.disabled\" ng-required=\"vm.settings.required\" name=\"{{ vm.settings.dataAt }}\" min=\"{{vm.min}}\" max=\"{{vm.max}}\" ng-minlength=\"{{ vm.minLength }}\" ng-maxlength=\"{{ vm.maxLength }}\" ng-hide=\"{{ vm.hideIfEmpty }}\" ng-class=\"{'not-valid': !vm.isValid}\"> <label ng-if=\"vm.settings.floatingLabel\" ng-bind-html=\"vm.settings.floatingLabel\" for=\"{{ vm.settings.dataAt }}\"></label> <p class=\"help-block validation-message\" ng-if=\"!vm.isValid\">{{ vm.settings.validationMessage }}</p> <small>{{vm.settings.label}}</small> <div ng-if=\"vm.settings.html\" ng-bind-html=\"vm.settings.html\"></div> <p class=\"help-block\" ng-if=\"vm.settings.helpText\">{{ vm.settings.helpText }}</p> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaTextInput.html", v1)}]);
	module.exports=v1;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaToast = angular.module('app.lbaToast', []);
	
	lbaToast.controller('lbaToastCtrl', __webpack_require__(182));
	lbaToast.directive('lbaToast', __webpack_require__(183));
	
	exports['default'] = lbaToast;
	module.exports = exports['default'];

/***/ },
/* 182 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$rootScope', '$timeout'];
	var lbaToastCtrl = function lbaToastCtrl($rootScope, $timeout) {
	  var vm = this;
	
	  $rootScope.$on('lbaToast:showToast', function (event, data) {
	    var showFor = data.messageType === 'success' ? 3000 : 8000;
	    vm.showToast = true;
	    vm.message = data.message;
	    vm.messageType = data.messageType || 'success';
	
	    if (vm.showToast) {
	      $timeout(function () {
	        vm.showToast = false;
	      }, showFor);
	    }
	  });
	};
	
	lbaToastCtrl.$inject = $inject;
	
	exports['default'] = lbaToastCtrl;
	module.exports = exports['default'];

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(184);
	
	var $inject = [];
	var lbaToast = function lbaToast() {
	  return {
	    restrict: 'A',
	    scope: {},
	    bindToController: true,
	    controller: 'lbaToastCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(186)
	  };
	};
	
	lbaToast.$inject = $inject;
	
	exports['default'] = lbaToast;
	module.exports = exports['default'];

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(185);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaToast.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaToast.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".lbaToast{position:fixed;top:9px;right:20px;background:#fff;text-align:center;padding:1rem 2rem;transition:all ease-in-out .2s;border-radius:3px;font-size:1.5rem;z-index:100000}.lbaToast.ng-hide{display:block!important;top:-50px}.lbaToast_success{color:#67c067}.lbaToast_error{color:#de5e59}.lbaToast_waiting{color:#3a85bf}.lbaToast_waitingIcon{display:inline-block;transform:translateZ(0);animation:spinner .5s infinite linear}@keyframes spinner{0%{transform:rotate(0deg)}to{transform:rotate(360deg)}}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaToast/src/components/lbaToast/lbaToast.scss"],"names":[],"mappings":"AAEA,UACI,eACA,QACA,WACA,gBACA,kBACA,kBAEA,+BACA,kBACA,iBACA,cAAe,CAClB,kBAGI,wBAEA,SAAU,CACd,kBAGG,aAAc,CACjB,gBAGG,aAAc,CACjB,kBAGG,aAAc,CACjB,sBAGG,qBACA,wBACA,qCAAuC,CAC1C,mBAGG,GACI,sBAAuB,CAE3B,GACI,wBAAyB,CAAA,CAAA","file":"lbaToast.scss","sourcesContent":["@import \"../../globalStyles/variables\";\r\n\r\n.lbaToast {\r\n    position: fixed;\r\n    top: 9px;\r\n    right: 20px;\r\n    background: #fff;\r\n    text-align: center;\r\n    padding: 1rem 2rem;\r\n    //opacity: 1;\r\n    transition: all ease-in-out 0.2s;\r\n    border-radius: 3px;\r\n    font-size: 1.5rem;\r\n    z-index: 100000;\r\n}\r\n\r\n.lbaToast.ng-hide {\r\n     display: block !important;\r\n     //opacity: 0;\r\n     top: -50px;\r\n}\r\n\r\n.lbaToast_success {\r\n    color: #67c067;\r\n}\r\n\r\n.lbaToast_error {\r\n    color: #de5e59;\r\n}\r\n\r\n.lbaToast_waiting {\r\n    color: #3a85bf;\r\n}\r\n\r\n.lbaToast_waitingIcon {\r\n    display: inline-block;\r\n    transform: translateZ(0);\r\n    animation: spinner 0.5s infinite linear;\r\n}\r\n\r\n@keyframes spinner {\r\n    0% {\r\n        transform: rotate(0deg);\r\n    }\r\n    100% {\r\n        transform: rotate(360deg);\r\n    }\r\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 186 */
/***/ function(module, exports) {

	var v1="<div class=\"lbaToast\" ng-show=\"vm.showToast\" ng-switch=\"vm.messageType\"> <span class=\"lbaToast_error\" ng-switch-when=\"error\"><i class=\"fa fa-frown-o lbaToast_errorIcon\"></i> {{ vm.message }}</span>\n<span class=\"lbaToast_success\" ng-switch-when=\"success\"><i class=\"fa fa-smile-o lbaToast_successIcon\"></i> {{ vm.message }}</span>\n<span class=\"lbaToast_waiting\" ng-switch-default><i class=\"fa fa-circle-o-notch lbaToast_waitingIcon\"></i> {{ vm.message }}</span> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaToast.html", v1)}]);
	module.exports=v1;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaNav = angular.module('app.lbaNav', []);
	
	lbaNav.controller('lbaNavCtrl', __webpack_require__(188));
	lbaNav.directive('lbaNav', __webpack_require__(190));
	
	exports['default'] = lbaNav;
	module.exports = exports['default'];

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _configSiteStructureConfigJs = __webpack_require__(189);
	
	var _configSiteStructureConfigJs2 = _interopRequireDefault(_configSiteStructureConfigJs);
	
	var _configConstantsJs = __webpack_require__(147);
	
	var _configConstantsJs2 = _interopRequireDefault(_configConstantsJs);
	
	var $inject = ['$rootScope', '$location', 'settingsService', 'authService', 'dataService', 'AUTH_EVENTS'];
	
	var lbaNavCtrl = function lbaNavCtrl($rootScope, $location, settingsService, authService, dataService, AUTH_EVENTS) {
	  var vm = this;
	
	  vm.settings = settingsService.settings;
	  vm.navActive = true;
	  vm.logout = logout;
	  vm.username = authService.getUsername();
	  vm.changePath = changePath;
	  vm.version = (window.version || '').toString();
	  vm.displayVersion = (vm.version.split('.')[0] || '0') + '.' + (vm.version.split('.')[1] || '0');
	  vm.structure = _configSiteStructureConfigJs2['default'];
	
	  if (window.showGlobalSettings) {} else {
	    vm.structure.GlobalSettings = null;
	  }
	
	  vm.products = _configConstantsJs2['default'].PRODUCT_FAMILY;
	
	  $rootScope.$on('lbaLoader:loaderState', function (event, message) {
	    vm.showSpinner = message.state;
	  });
	
	  function logout() {
	    $location.path('/logout');
	  }
	
	  function changePath(path) {
	    // JLF: LOBT-773: we must reset the grid cache with every fresh page being shown
	    dataService.backGridFilter = null;
	    dataService.backGridPage = null;
	    dataService.backViewGridFilter = null;
	    dataService.backViewGridPage = null;
	
	    dataService.refreshDataOnLoad = true;
	
	    $location.path('' + path);
	  }
	};
	
	lbaNavCtrl.$inject = $inject;
	
	exports['default'] = lbaNavCtrl;
	module.exports = exports['default'];

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _constants = __webpack_require__(147);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	exports["default"] = {
	  Debtors: {
	    displayName: "Debtors",
	    iconClass: "fa-user",
	    field: "DebtorList",
	    endpoint: "Debtors",
	    path: "debtors",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.LB
	  },
	  Settings: {
	    displayName: "Settings",
	    iconClass: "fa-cog",
	    field: "SettingsResource",
	    path: "settings",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.LB
	  },
	  GlobalSettings: {
	    displayName: "Global Settings",
	    iconClass: "fa-cog",
	    field: "GlobalSettingsList",
	    endpoint: "Settings",
	    path: "global-settings",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.LB
	  },
	  Logs: {
	    displayName: "AppInsights Logs",
	    iconClass: "fa-wrench",
	    field: "LogsResource",
	    path: "logs",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.LB
	  },
	  EnhancedLogs: {
	    displayName: "Enhanced Logs",
	    iconClass: "fa-wrench",
	    field: "EnhancedLogsGrid",
	    path: "enhanced-logs",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.LB
	  },
	  FlyAmericaAct: {
	    displayName: "Fly America Act",
	    iconClass: "fa-plane",
	    field: "FlyAmericaResource",
	    endpoint: "FlyAmericaAct",
	    path: "fly-america",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.LB
	  },
	  CreditCards: {
	    displayName: "Credit Cards",
	    iconClass: "fa-credit-card",
	    field: "CreditCardsList",
	    endpoint: "CreditCards",
	    path: "credit-cards",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.LB
	  },
	  PointsOfInterest: {
	    displayName: "Points of Interest",
	    iconClass: "fa-map-marker",
	    field: "PointsOfInterestList",
	    path: "points-of-interest",
	    endpoint: "",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.LB
	  },
	  AirlineCarriers: {
	    displayName: "Airline Carriers",
	    iconClass: "fa-plane",
	    field: "AirlineCarriersList",
	    endpoint: "AirlineCarriers",
	    path: "airline-carriers",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.LB
	  },
	  Airports: {
	    displayName: "Airports",
	    iconClass: "fa-plane",
	    field: "AirportsList",
	    endpoint: "Airports",
	    path: "airports",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.LB
	  },
	  CarSuppliers: {
	    displayName: "Car Suppliers",
	    iconClass: "fa-car",
	    field: "CarSuppliersList",
	    endpoint: "CarSuppliers",
	    path: "car-suppliers",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.LB
	  },
	  CarSupplierLocations: {
	    displayName: "Car Supplier Locations",
	    iconClass: "fa-car",
	    field: "CarSuppliersLocations",
	    endpoint: "CarSupplierLocations",
	    path: "car-supplier-locations",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.LB
	  },
	  Hotels: {
	    rootNode: true,
	    displayName: "Hotels",
	    iconClass: "fa-bed",
	    field: "HotelsList",
	    path: "hotels",
	    endpoint: "",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.LB
	  },
	  HotelSupplierMembershipPrograms: {
	    displayName: "Hotel Suppliers",
	    iconClass: "fa-bed",
	    field: "HotelSuppliersResource",
	    path: "hotel-supplier-membership-programs",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.LB
	  },
	  PerDiem: {
	    displayName: "Per Diem",
	    iconClass: "fa-bed",
	    field: "PerDiem",
	    endpoint: "PerDiem",
	    path: "per-diem",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.LB
	  },
	  RailSuppliers: {
	    displayName: "Rail Suppliers",
	    iconClass: "fa-train",
	    field: "RailSuppliersList",
	    endpoint: "RailSuppliers",
	    path: "rail-suppliers",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.LB
	  },
	  RailStations: {
	    displayName: "Rail Stations",
	    iconClass: "fa-train",
	    field: "RailStationsList",
	    endpoint: "RailStations",
	    path: "rail-stations",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.LB
	  },
	  RailCards: {
	    displayName: "Rail Cards",
	    iconClass: "fa-train",
	    field: "RailCardsList",
	    endpoint: "RailCards",
	    path: "rail-cards",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.LB
	  },
	  CompanyReferenceList: {
	    displayName: "Company Reference",
	    iconClass: "fa-cog",
	    field: "CompanyReferenceList",
	    endpoint: "CompanyReferenceList",
	    path: "company-reference-list",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.CTM
	  },
	  CompanyReferenceConfig: {
	    displayName: "Company Reference Config",
	    iconClass: "fa-cog",
	    field: "CompanyReferenceConfig",
	    endpoint: "CompanyReferenceConfig",
	    path: "company-reference-config",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.CTM
	  },
	  EnhancedPolicyRules: {
	    displayName: "Enhanced Policy Rules",
	    iconClass: "fa-cog",
	    field: "EnhancedPolicyRules",
	    endpoint: "EnhancedPolicyRules",
	    path: "enhanced-policy-rules",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.CTM
	  },
	  ProcessUploadStatus: {
	    displayName: "Process Upload Status",
	    iconClass: "fa-cog",
	    field: "ProcessUploadStatus",
	    endpoint: "ProcessUploadStatus",
	    path: "process-upload-status",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.CTM
	  },
	  SafScores: {
	    displayName: "Manage SAF Scores",
	    iconClass: "fa-cog",
	    field: "SafScoresList",
	    endpoint: "SafScores",
	    path: "saf-scores",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.CTM
	  },
	  VendorPreferenceConfigs: {
	    displayName: "Vendor Preference Config",
	    iconClass: "fa-cog",
	    field: "VendorPreferenceConfigs",
	    path: "vendor-preference-configs",
	    productFamily: _constants2["default"].PRODUCT_FAMILY.SupplierRelations
	  }
	};
	module.exports = exports["default"];

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(191);
	
	var $inject = [];
	var lbaNav = function lbaNav() {
	  return {
	    scope: {
	      target: '<'
	    },
	    restrict: 'A',
	    bindToController: true,
	    controller: 'lbaNavCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(193)
	  };
	};
	
	lbaNav.$inject = $inject;
	
	exports['default'] = lbaNav;
	module.exports = exports['default'];

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(192);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaNav.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaNav.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".lbaNav{background:#fff;position:fixed;width:100%;top:0;left:0;z-index:1001;min-height:60px;border-bottom:1px solid #ebedef}.lbaNav .wrapper,.lbaNav_logo{position:relative}.lbaNav_logo{width:149.266px;height:29px;float:left;top:1pc}.lbaNav_version{position:absolute;top:42px;left:0;font-size:10px;color:#000;width:5pc;text-align:right}.lbaNav_spinner{border:2px solid hsla(0,0%,100%,.2);border-left:2px solid #9ab845;border-radius:50%;width:15px;height:15px;position:absolute;top:21px;left:87px;opacity:0;transform:translateZ(0);animation:spinner .5s infinite linear;transition:all 2s ease-out}.lbaNav_spinner.active{transition:none;opacity:1}@keyframes spinner{0%{transform:rotate(0deg)}to{transform:rotate(360deg)}}.lbaNav_navbar{position:absolute;display:grid;grid-template-columns:50% 50%;grid-template-rows:35% 65%;left:169px;top:3pc;list-style:none;padding:0 20px;background:#f5f5f5;width:500px;height:0;overflow:hidden;transition:all 0s linear}.lbaNav_navbar .lbaNav_navbar_section{display:inline-block;vertical-align:top;width:210px;margin-right:20px}.lbaNav_navbar :first-child{grid-row:1/span 2}.lbaNav_navbar .lbaNav_navbar_section ul{margin:0;padding:0}.lbaNav_navbar .lbaNav_navbar_section li{list-style:none;display:block;vertical-align:top;margin:0 20px 20px 0;padding:0;border-radius:4px}.lbaNav_navbar li{margin:0;padding:0}.lbaNav_navbar li.active a{font-weight:700}.lbaNav_userMenu{float:left;list-style:none;margin:0 0 0 40px;padding:0;position:absolute;top:0;right:0}.lbaNav_userMenu li{color:#000;float:left;margin:0;padding:0}.lbaNav_userMenu .lbaNav_userMenu_username{padding:20px}.lbaNav_userMenu a{color:#000;text-decoration:none;display:block;padding:20px}.menu-selection{float:left;margin:9pt 0 0 20px;color:#000;padding:8px 15px;display:inline-block;border-radius:0 4px}.menu-selection span{padding:0 5px;display:inline-block}.menu-selection:hover{cursor:pointer;background:#f5f5f5}.menu-selection:hover .lbaNav_navbar{cursor:default;transition:all .2s linear;height:600px;box-shadow:1px 2px 2px rgba(0,0,0,.2)}.lbaNav_navbar h2{font-size:10px;margin:0 0 15px;padding:20px 0 0;text-transform:uppercase;font-weight:700}.lbaNav_link{height:15px;display:block;color:#000;border-radius:4px;font-size:13px}.lbaNav_link:hover{text-decoration:none;cursor:pointer}.lbaNav_link i{display:inline-block;width:15px;font-size:14px;margin:0 5px 0 0;position:relative;text-align:center}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaNav/src/components/lbaNav/lbaNav.scss"],"names":[],"mappings":"AAEA,QACE,gBACA,eACA,WACA,MACA,OACA,aACA,gBACA,+BAAgC,CACjC,AAIA,8BADC,iBAAkB,CASnB,AARA,aAGC,gBACA,YACA,WACA,AACA,OAAS,CACV,gBAGC,kBACA,SACA,OACA,eACA,WACA,UACA,gBAAiB,CAClB,gBAGC,oCACA,8BACA,kBACA,WACA,YACA,kBACA,SACA,UACA,UACA,wBACA,sCACA,0BAA2B,CAC5B,uBAGC,gBACA,SAAU,CACX,mBAGC,GACE,sBAAuB,CAEzB,GACE,wBAAyB,CAAA,CAI7B,eACE,kBACA,aACA,8BACA,2BACA,WACA,QACA,gBACA,eACA,mBACA,YACA,SACA,gBACA,wBAA0B,CAb5B,sCAgBI,qBACA,mBACA,YACA,iBAAkB,CAnBtB,4BAuBI,iBAAmB,CAvBvB,yCA2BI,SACA,SAAU,CA5Bd,yCAgCI,gBACA,cACA,mBACA,qBACA,UACA,iBAAkB,CACnB,kBAID,SACA,SAAU,CACX,2BAGC,eAAiB,CAClB,iBAGC,WACA,gBACA,kBACA,UACA,kBACA,MACA,OAAQ,CACT,oBAGC,WACA,WACA,SACA,SAAU,CACX,2CAGC,YAAa,CACd,mBAGC,WACA,qBACA,cACA,YAAa,CACd,gBAGC,WACA,oBACA,WACA,iBACA,qBACA,mBAAoB,CANtB,qBASI,cACA,oBAAqB,CAVzB,sBAcI,eACA,kBAAmB,CAfvB,qCAkBM,eACA,0BACA,aACA,qCAAsC,CACvC,kBAKH,eACA,gBACA,iBACA,yBACA,eAAiB,CAClB,aAGC,YACA,cACA,WACA,kBACA,cAAe,CAChB,mBAGC,qBACA,cAAe,CAChB,eAGC,qBACA,WACA,eACA,iBACA,kBACA,iBAAkB,CACnB","file":"lbaNav.scss","sourcesContent":["@import \"../../globalStyles/variables\";\r\n\r\n.lbaNav {\r\n  background: #fff;\r\n  position: fixed;\r\n  width: 100%;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 1001;\r\n  min-height: 60px;\r\n  border-bottom: 1px solid #EBEDEF;\r\n}\r\n\r\n.lbaNav .wrapper {\r\n  position: relative;\r\n}\r\n\r\n.lbaNav_logo {\r\n  width: 149.266px;\r\n  height: 29px;\r\n  float: left;\r\n  position: relative;\r\n  top: 16px;\r\n}\r\n\r\n.lbaNav_version {\r\n  position: absolute;\r\n  top: 42px;\r\n  left: 0;\r\n  font-size: 10px;\r\n  color: #000;\r\n  width: 80px;\r\n  text-align: right;\r\n}\r\n\r\n.lbaNav_spinner {\r\n  border: 2px solid rgba(255, 255, 255, 0.2);\r\n  border-left: 2px solid $brandGreen;\r\n  border-radius: 50%;\r\n  width: 15px;\r\n  height: 15px;\r\n  position: absolute;\r\n  top: 21px;\r\n  left: 87px;\r\n  opacity: 0;\r\n  transform: translateZ(0);\r\n  animation: spinner 0.5s infinite linear;\r\n  transition: all 2s ease-out;\r\n}\r\n\r\n.lbaNav_spinner.active {\r\n  transition: none;\r\n  opacity: 1;\r\n}\r\n\r\n@keyframes spinner {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.lbaNav_navbar {\r\n  position: absolute;\r\n  display: grid;\r\n  grid-template-columns: 50% 50%;\r\n  grid-template-rows: 35% 65%;\r\n  left: 169px;\r\n  top: 48px;\r\n  list-style: none;\r\n  padding: 0 20px;\r\n  background: #f5f5f5;\r\n  width: 500px;\r\n  height: 0;\r\n  overflow: hidden;\r\n  transition: all .0s linear;\r\n\r\n  .lbaNav_navbar_section {\r\n    display: inline-block;\r\n    vertical-align: top;\r\n    width: 210px;\r\n    margin-right: 20px;\r\n  }\r\n\r\n  :first-child {\r\n    grid-row: 1/ span 2;\r\n  }\r\n  \r\n  .lbaNav_navbar_section ul {\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n  \r\n  .lbaNav_navbar_section li {\r\n    list-style: none;\r\n    display: block;\r\n    vertical-align: top;\r\n    margin: 0 20px 20px 0;\r\n    padding: 0;\r\n    border-radius: 4px;\r\n  }\r\n}\r\n\r\n.lbaNav_navbar li {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.lbaNav_navbar li.active a {\r\n  font-weight: bold;\r\n}\r\n\r\n.lbaNav_userMenu {\r\n  float: left;\r\n  list-style: none;\r\n  margin: 0 0 0 40px;\r\n  padding: 0;\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n}\r\n\r\n.lbaNav_userMenu li {\r\n  color: #000;\r\n  float: left;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.lbaNav_userMenu .lbaNav_userMenu_username {\r\n  padding: 20px;\r\n}\r\n\r\n.lbaNav_userMenu a {\r\n  color: #000;\r\n  text-decoration: none;\r\n  display: block;\r\n  padding: 20px;\r\n}\r\n\r\n.menu-selection {\r\n  float: left;\r\n  margin: 12px 0 0 20px;\r\n  color: #000;\r\n  padding: 8px 15px;\r\n  display: inline-block;\r\n  border-radius: 0 4px;\r\n\r\n  span {\r\n    padding: 0 5px;\r\n    display: inline-block;\r\n  }\r\n\r\n  &:hover {\r\n    cursor: pointer;\r\n    background: #f5f5f5;\r\n\r\n    .lbaNav_navbar {\r\n      cursor: default;\r\n      transition: all .2s linear;\r\n      height: 600px;\r\n      box-shadow: 1px 2px 2px rgba(0,0,0,.2);\r\n    }\r\n  }\r\n}\r\n\r\n.lbaNav_navbar h2 {\r\n  font-size: 10px;\r\n  margin: 0 0 15px;\r\n  padding: 20px 0 0;\r\n  text-transform: uppercase;\r\n  font-weight: bold;\r\n}\r\n\r\n.lbaNav_link {\r\n  height: 15px;\r\n  display: block;\r\n  color: #000;\r\n  border-radius: 4px;\r\n  font-size: 13px;\r\n}\r\n\r\n.lbaNav_link:hover {\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.lbaNav_link i {\r\n  display: inline-block;\r\n  width: 15px;\r\n  font-size: 14px;\r\n  margin: 0 5px 0 0;\r\n  position: relative;\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var v1="<nav class=\"lbaNav\"> <div class=\"wrapper clearfix\"> <div class=\"lbaNav_logo\"> <img src=\"" + __webpack_require__(194) + "\"> </div> <span class=\"lbaNav_version\">Config v{{ vm.displayVersion }}</span> <div class=\"lbaNav_spinner\" ng-class=\"{ active: vm.showSpinner }\"></div> <div class=\"menu-selection\"> <i class=\"fa {{ vm.settings[vm.target].iconClass }}\"></i> <span>{{ vm.settings[vm.target].displayName }}</span> <i class=\"fa fa-caret-down\"></i> <div class=\"lbaNav_navbar\"> <div class=\"lbaNav_navbar_section\" ng-repeat=\"(productKey, productItem) in vm.products\"> <h2>{{ productItem }}</h2> <ul ng-show=\"vm.navActive\"> <li ng-repeat=\"(key, item) in vm.structure\" ng-class=\"{ active: vm.activeItem === item }\" ng-if=\"item.productFamily === productItem\"> <a ng-click=\"vm.changePath(item.path)\" class=\"lbaNav_link\"><i class=\"fa {{ item.iconClass }}\"></i> {{ item.displayName }}</a> </li> </ul> </div> </div> </div> <ul class=\"lbaNav_userMenu\"> <li class=\"lbaNav_userMenu_username\"> <span class=\"fa fa-lock\"></span> {{ vm.username }} </li> <li> <a href=\"\" ng-click=\"vm.logout()\"><span class=\"fa fa-sign-out\"></span> Logout</a> </li> </ul> </div> </nav>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaNav.html", v1)}]);
	module.exports=v1;

/***/ },
/* 194 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaLoader = angular.module('app.lbaLoader', []);
	
	lbaLoader.controller('lbaLoaderCtrl', __webpack_require__(196));
	lbaLoader.directive('lbaLoader', __webpack_require__(197));
	
	exports['default'] = lbaLoader;
	module.exports = exports['default'];

/***/ },
/* 196 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$rootScope'];
	var lbaLoaderCtrl = function lbaLoaderCtrl($rootScope) {
	  var vm = this;
	
	  $rootScope.$on('lbaLoader:loaderState', function (event, message) {
	    vm.showLoader = message.state;
	    vm.loaderText = message.text;
	  });
	};
	
	lbaLoaderCtrl.$inject = $inject;
	
	exports['default'] = lbaLoaderCtrl;
	module.exports = exports['default'];

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(198);
	
	var $inject = [];
	var lbaLoader = function lbaLoader() {
	  return {
	    restrict: 'A',
	    scope: {},
	    bindToController: true,
	    controller: 'lbaLoaderCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(200)
	  };
	};
	
	lbaLoader.$inject = $inject;
	
	exports['default'] = lbaLoader;
	module.exports = exports['default'];

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(199);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaLoader.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaLoader.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".lbaLoader{background:#fff;opacity:.8;position:fixed;top:0;left:0;right:0;bottom:0;z-index:1000}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaLoader/src/components/lbaLoader/lbaLoader.scss"],"names":[],"mappings":"AAAA,WACI,gBACA,WACA,eACA,MACA,OACA,QACA,SACA,YAAa,CAChB","file":"lbaLoader.scss","sourcesContent":[".lbaLoader {\r\n    background: #fff;\r\n    opacity: 0.8;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    z-index: 1000;\r\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 200 */
/***/ function(module, exports) {

	var v1="<div class=\"lbaLoader\" ng-if=\"vm.showLoader\"></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaLoader.html", v1)}]);
	module.exports=v1;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaAddGridResource = angular.module('app.lbaAddGridResource', []);
	
	lbaAddGridResource.controller('lbaAddGridResourceCtrl', __webpack_require__(202));
	lbaAddGridResource.controller('lbaSaveCallbackCtrl', __webpack_require__(203));
	lbaAddGridResource.directive('lbaAddGridResource', __webpack_require__(204));
	
	exports['default'] = lbaAddGridResource;
	module.exports = exports['default'];

/***/ },
/* 202 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$location', 'dataService', 'settingsService', 'microApiService'];
	
	var lbaAddGridResourceCtrl = function lbaAddGridResourceCtrl($location, dataService, settingsService, microApiService) {
	  var vm = this;
	
	  vm.fields = settingsService.settings.fields;
	  vm.formErrors = false;
	  dataService.data.activeItem = angular.copy(vm.settings.data);
	  vm.data = dataService.data.activeItem;
	  vm.indexArray = '';
	  vm.waiting = false;
	  vm.success = false;
	  vm.cancel = cancel;
	  vm.add = add;
	
	  function cancel() {
	    $location.path($location.$$path.slice(0, -3));
	  }
	
	  function add() {
	    if (!vm.addGridResourceForm.$valid) {
	      vm.formErrors = true;
	
	      return false;
	    }
	
	    vm.waiting = true;
	
	    if (vm.settings.microService) {
	      console.log('MICRO');
	    } else {
	
	      dataService.post(vm.settings.endpoint, vm.data).then(function (data) {
	        vm.waiting = false;
	        vm.success = true;
	
	        var locationPathTrimmed = $location.$$path.slice(0, -3);
	        dataService.data.activeItem = undefined;
	        if (vm.settings.continueEditPath) {
	          var actionPath = vm.settings.continueEditPath(data);
	          $location.path(actionPath);
	        } else {
	          $location.path(locationPathTrimmed + data.Id);
	        }
	      });
	    }
	  }
	};
	
	lbaAddGridResourceCtrl.$inject = $inject;
	
	exports['default'] = lbaAddGridResourceCtrl;
	module.exports = exports['default'];

/***/ },
/* 203 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$uibModalInstance', 'data'];
	
	var lbaDeleteConfirmCtrl = function lbaDeleteConfirmCtrl($uibModalInstance, data) {
	  var vm = this;
	
	  vm.displayName = data.displayName;
	  vm.id = data.Id;
	
	  vm.ok = function () {
	    document.location.reload(true);
	  };
	};
	
	lbaDeleteConfirmCtrl.$inject = $inject;
	
	exports['default'] = lbaDeleteConfirmCtrl;
	module.exports = exports['default'];

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(205);
	
	var $inject = [];
	
	var lbaAddGridResource = function lbaAddGridResource() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaAddGridResourceCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(207)
	  };
	};
	
	lbaAddGridResource.$inject = $inject;
	
	exports['default'] = lbaAddGridResource;
	module.exports = exports['default'];

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(206);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaAddGridResource.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaAddGridResource.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".lbaAddGridResource{background:#fff;position:fixed;top:75pt;left:50%;width:500px;margin-left:-250px;z-index:9001}.lbaAddGridResource_heading{background:#a4c04e;color:#fff;font-size:1.5rem;font-weight:700;padding:2rem;margin:0}.lbaAddGridResource_content{padding:2rem}.lbaAddGridResource_buttons{padding-top:1rem;text-align:right}.lbaModal_deleteButton{float:left}.overlay{background:rgba(0,0,0,.8);z-index:9000}.overlay,.success{position:fixed;top:0;left:0;right:0;bottom:0}.success{background:#fff url(\"http://i.stack.imgur.com/fHctp.gif\") 50% 50% no-repeat;z-index:9002}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaAddGridResource/src/components/lbaAddGridResource/lbaAddGridResource.scss"],"names":[],"mappings":"AAAA,oBACG,gBACA,eACA,SACA,SACA,YACA,mBACA,YAAa,CACd,4BAGA,mBACA,WACA,iBACA,gBACA,aACA,QAAS,CACV,4BAGC,YAAa,CACd,4BAGC,iBACA,gBAAiB,CAClB,uBAGC,UAAW,CACZ,SAGC,0BACA,AAKA,YAAa,CACd,kBANC,eACA,MACA,OACA,QACA,QACA,CAWD,AAVA,SAGC,4EACA,AAKA,YAAa,CACd","file":"lbaAddGridResource.scss","sourcesContent":[".lbaAddGridResource {\r\n   background: #fff;\r\n   position: fixed;\r\n   top: 100px;\r\n   left: 50%;\r\n   width: 500px;\r\n   margin-left: -250px;\r\n   z-index: 9001;\r\n }\r\n\r\n.lbaAddGridResource_heading {\r\n  background: #a4c04e;\r\n  color: #fff;\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  padding: 2rem;\r\n  margin: 0;\r\n}\r\n\r\n.lbaAddGridResource_content {\r\n  padding: 2rem;\r\n}\r\n\r\n.lbaAddGridResource_buttons {\r\n  padding-top: 1rem;\r\n  text-align: right;\r\n}\r\n\r\n.lbaModal_deleteButton {\r\n  float: left;\r\n}\r\n\r\n.overlay {\r\n  background: rgba(0,0,0,0.8);\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 9000;\r\n}\r\n\r\n.success {\r\n  background: #fff url('http://i.stack.imgur.com/fHctp.gif') 50% 50% no-repeat;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 9002;\r\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 207 */
/***/ function(module, exports) {

	var v1="<div class=\"lbaModal_wrapper\"> <div class=\"lbaModal\"> <form name=\"vm.addGridResourceForm\" ng-class=\"{ formErrors: vm.formErrors }\"> <h3 class=\"lbaModal_heading\"><i class=\"fa fa-plus-square\"></i> Add new {{ vm.settings.displayName }}</h3> <div class=\"lbaModal_content\"> <div ng-repeat=\"item in vm.settings.children track by $index\"> <div lba-dynamic=\"'lba-' + item.displayAs\" settings=\"item\"></div> </div> <div class=\"lbaModal_buttons\"> <button type=\"button\" class=\"btn btn-default\" bg-disabled=\"vm.waiting\" ng-click=\"vm.cancel()\">Cancel</button>\n<button type=\"submit\" class=\"btn btn-lightning\" bg-disabled=\"vm.waiting\" ng-click=\"vm.add()\">Add</button> </div> </div> </form> <button class=\"btn btn-link lbaModal_close\" ng-click=\"vm.cancel()\"><i class=\"fa fa-close\"></i></button> </div> </div> <div class=\"overlay\"></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaAddGridResource.html", v1)}]);
	module.exports=v1;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaBoolean = angular.module('app.lbaBoolean', []);
	
	lbaBoolean.controller('lbaBooleanCtrl', __webpack_require__(209));
	lbaBoolean.directive('lbaBoolean', __webpack_require__(210));
	
	exports['default'] = lbaBoolean;
	module.exports = exports['default'];

/***/ },
/* 209 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope', '$routeParams', 'dataService', '$timeout'];
	
	var lbaBooleanCtrl = function lbaBooleanCtrl($scope, $routeParams, dataService, $timeout) {
	  var vm = this;
	  var dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
	
	  vm.data = _.get(dataService.data.activeItem, dataLookUp);
	
	  $scope.$watchCollection('vm.data', function (newData, oldData) {
	    if (newData !== oldData) {
	      _.set(dataService.data.activeItem, dataLookUp, newData);
	    }
	    hideShowProperties(newData);
	  });
	
	  $timeout(function () {
	    return hideShowProperties(vm.data);
	  }, 150);
	  function hideShowProperties(val) {
	    if (!vm.settings.hideShowProperty) return;
	    var classKey = "." + vm.settings.hideShowProperty;
	    var className = classKey;
	    if (val) {
	      $(className).show();
	    } else {
	      $(className).hide();
	    }
	  }
	};
	
	lbaBooleanCtrl.$inject = $inject;
	
	exports['default'] = lbaBooleanCtrl;
	module.exports = exports['default'];

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	var lbaBoolean = function lbaBoolean() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaBooleanCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(211)
	  };
	};
	
	lbaBoolean.$inject = $inject;
	
	exports['default'] = lbaBoolean;
	module.exports = exports['default'];

/***/ },
/* 211 */
/***/ function(module, exports) {

	var v1="<div class=\"checkbox\"> <label for=\"{{ vm.settings.dataAt }}\"> <input type=\"checkbox\" name=\"{{ vm.settings.dataAt }}\" id=\"{{ vm.settings.dataAt }}\" ng-model=\"vm.data\" ng-disabled=\"vm.settings.disabled\" ng-required=\"vm.settings.required\">\n{{ vm.settings.displayName }} </label> <p class=\"help-block\" ng-if=\"vm.settings.helpText\">{{ vm.settings.helpText }}</p> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaBoolean.html", v1)}]);
	module.exports=v1;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaCountrySelect = angular.module('app.lbaCountrySelect', []);
	
	lbaCountrySelect.controller('lbaCountrySelectCtrl', __webpack_require__(213));
	lbaCountrySelect.directive('lbaCountrySelect', __webpack_require__(214));
	lbaCountrySelect.service('countriesService', __webpack_require__(216));
	
	exports['default'] = lbaCountrySelect;
	module.exports = exports['default'];

/***/ },
/* 213 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope', '$routeParams', '$filter', 'countriesService', 'dataService'];
	
	var lbaCountrySelectCtrl = function lbaCountrySelectCtrl($scope, $routeParams, $filter, countriesService, dataService) {
	  var vm = this;
	  var dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
	  vm.data = _.get(dataService.data.activeItem, dataLookUp);
	
	  vm.selectType = vm.settings.selectType || 'multi';
	  vm.refreshCountries = refreshCountries;
	
	  if (vm.selectType === 'multi' && !vm.data) {
	    vm.data = [];
	  }
	
	  $scope.$watchCollection('vm.data', function (newData, oldData) {
	    if (newData !== oldData) {
	      _.set(dataService.data.activeItem, dataLookUp, newData);
	    }
	  });
	
	  function refreshCountries(userSearch) {
	    var countries = countriesService.get();
	    vm.countries = $filter('filter')(countries, userSearch, false);
	  }
	};
	
	lbaCountrySelectCtrl.$inject = $inject;
	
	exports['default'] = lbaCountrySelectCtrl;
	module.exports = exports['default'];

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	var lbaCountrySelect = function lbaCountrySelect() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaCountrySelectCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(215)
	  };
	};
	
	lbaCountrySelect.$inject = $inject;
	
	exports['default'] = lbaCountrySelect;
	module.exports = exports['default'];

/***/ },
/* 215 */
/***/ function(module, exports) {

	var v1="<div class=\"form-group\" ng-switch=\"vm.selectType\"> <label for=\"{{ vm.settings.dataAt }}\">{{ vm.settings.displayName }}</label> <div ng-switch-when=\"single\"> <ui-select ng-model=\"vm.data\" ng-required=\"vm.settings.required\"> <ui-select-match allow-clear=\"true\" class=\"ui-select-match\"> {{ $select.selected.code }} </ui-select-match> <ui-select-choices repeat=\"country.code as country in vm.countries\" refresh=\"vm.refreshCountries($select.search)\" refresh-delay=\"300\"> <div>{{ country.name }} ({{ country.code }})</div> </ui-select-choices> </ui-select> </div> <div ng-switch-default> <ui-select multiple=\"multiple\" ng-model=\"vm.data\"> <ui-select-match allow-clear=\"true\" class=\"ui-select-match\"> {{ $item.code }} </ui-select-match> <ui-select-choices repeat=\"country.code as country in vm.countries\" refresh=\"vm.refreshCountries($select.search)\" refresh-delay=\"300\"> <div>{{ country.name }} ({{ country.code }})</div> </ui-select-choices> </ui-select> </div> <p class=\"help-block\" ng-if=\"vm.settings.helpText\">{{ vm.settings.helpText }}</p> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaCountrySelect.html", v1)}]);
	module.exports=v1;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var countriesJSON = __webpack_require__(217);
	
	var $inject = [];
	var countriesService = function countriesService() {
	  var service = {};
	
	  service.get = function get() {
	    return countriesJSON;
	  };
	
	  return service;
	};
	
	countriesService.$inject = $inject;
	
	exports["default"] = countriesService;
	module.exports = exports["default"];

/***/ },
/* 217 */
/***/ function(module, exports) {

	module.exports = [
		{
			"name": "Afghanistan",
			"code": "AF"
		},
		{
			"name": "Åland Islands",
			"code": "AX"
		},
		{
			"name": "Albania",
			"code": "AL"
		},
		{
			"name": "Algeria",
			"code": "DZ"
		},
		{
			"name": "American Samoa",
			"code": "AS"
		},
		{
			"name": "AndorrA",
			"code": "AD"
		},
		{
			"name": "Angola",
			"code": "AO"
		},
		{
			"name": "Anguilla",
			"code": "AI"
		},
		{
			"name": "Antarctica",
			"code": "AQ"
		},
		{
			"name": "Antigua and Barbuda",
			"code": "AG"
		},
		{
			"name": "Argentina",
			"code": "AR"
		},
		{
			"name": "Armenia",
			"code": "AM"
		},
		{
			"name": "Aruba",
			"code": "AW"
		},
		{
			"name": "Australia",
			"code": "AU"
		},
		{
			"name": "Austria",
			"code": "AT"
		},
		{
			"name": "Azerbaijan",
			"code": "AZ"
		},
		{
			"name": "Bahamas",
			"code": "BS"
		},
		{
			"name": "Bahrain",
			"code": "BH"
		},
		{
			"name": "Bangladesh",
			"code": "BD"
		},
		{
			"name": "Barbados",
			"code": "BB"
		},
		{
			"name": "Belarus",
			"code": "BY"
		},
		{
			"name": "Belgium",
			"code": "BE"
		},
		{
			"name": "Belize",
			"code": "BZ"
		},
		{
			"name": "Benin",
			"code": "BJ"
		},
		{
			"name": "Bermuda",
			"code": "BM"
		},
		{
			"name": "Bhutan",
			"code": "BT"
		},
		{
			"name": "Bolivia",
			"code": "BO"
		},
		{
			"name": "Bosnia and Herzegovina",
			"code": "BA"
		},
		{
			"name": "Botswana",
			"code": "BW"
		},
		{
			"name": "Bouvet Island",
			"code": "BV"
		},
		{
			"name": "Brazil",
			"code": "BR"
		},
		{
			"name": "British Indian Ocean Territory",
			"code": "IO"
		},
		{
			"name": "Brunei Darussalam",
			"code": "BN"
		},
		{
			"name": "Bulgaria",
			"code": "BG"
		},
		{
			"name": "Burkina Faso",
			"code": "BF"
		},
		{
			"name": "Burundi",
			"code": "BI"
		},
		{
			"name": "Cambodia",
			"code": "KH"
		},
		{
			"name": "Cameroon",
			"code": "CM"
		},
		{
			"name": "Canada",
			"code": "CA"
		},
		{
			"name": "Cape Verde",
			"code": "CV"
		},
		{
			"name": "Cayman Islands",
			"code": "KY"
		},
		{
			"name": "Central African Republic",
			"code": "CF"
		},
		{
			"name": "Chad",
			"code": "TD"
		},
		{
			"name": "Chile",
			"code": "CL"
		},
		{
			"name": "China",
			"code": "CN"
		},
		{
			"name": "Christmas Island",
			"code": "CX"
		},
		{
			"name": "Cocos (Keeling) Islands",
			"code": "CC"
		},
		{
			"name": "Colombia",
			"code": "CO"
		},
		{
			"name": "Comoros",
			"code": "KM"
		},
		{
			"name": "Congo",
			"code": "CG"
		},
		{
			"name": "Congo, The Democratic Republic of the",
			"code": "CD"
		},
		{
			"name": "Cook Islands",
			"code": "CK"
		},
		{
			"name": "Costa Rica",
			"code": "CR"
		},
		{
			"name": "Cote D\"Ivoire",
			"code": "CI"
		},
		{
			"name": "Croatia",
			"code": "HR"
		},
		{
			"name": "Cuba",
			"code": "CU"
		},
		{
			"name": "Cyprus",
			"code": "CY"
		},
		{
			"name": "Czech Republic",
			"code": "CZ"
		},
		{
			"name": "Denmark",
			"code": "DK"
		},
		{
			"name": "Djibouti",
			"code": "DJ"
		},
		{
			"name": "Dominica",
			"code": "DM"
		},
		{
			"name": "Dominican Republic",
			"code": "DO"
		},
		{
			"name": "Ecuador",
			"code": "EC"
		},
		{
			"name": "Egypt",
			"code": "EG"
		},
		{
			"name": "El Salvador",
			"code": "SV"
		},
		{
			"name": "Equatorial Guinea",
			"code": "GQ"
		},
		{
			"name": "Eritrea",
			"code": "ER"
		},
		{
			"name": "Estonia",
			"code": "EE"
		},
		{
			"name": "Ethiopia",
			"code": "ET"
		},
		{
			"name": "Falkland Islands (Malvinas)",
			"code": "FK"
		},
		{
			"name": "Faroe Islands",
			"code": "FO"
		},
		{
			"name": "Fiji",
			"code": "FJ"
		},
		{
			"name": "Finland",
			"code": "FI"
		},
		{
			"name": "France",
			"code": "FR"
		},
		{
			"name": "French Guiana",
			"code": "GF"
		},
		{
			"name": "French Polynesia",
			"code": "PF"
		},
		{
			"name": "French Southern Territories",
			"code": "TF"
		},
		{
			"name": "Gabon",
			"code": "GA"
		},
		{
			"name": "Gambia",
			"code": "GM"
		},
		{
			"name": "Georgia",
			"code": "GE"
		},
		{
			"name": "Germany",
			"code": "DE"
		},
		{
			"name": "Ghana",
			"code": "GH"
		},
		{
			"name": "Gibraltar",
			"code": "GI"
		},
		{
			"name": "Greece",
			"code": "GR"
		},
		{
			"name": "Greenland",
			"code": "GL"
		},
		{
			"name": "Grenada",
			"code": "GD"
		},
		{
			"name": "Guadeloupe",
			"code": "GP"
		},
		{
			"name": "Guam",
			"code": "GU"
		},
		{
			"name": "Guatemala",
			"code": "GT"
		},
		{
			"name": "Guernsey",
			"code": "GG"
		},
		{
			"name": "Guinea",
			"code": "GN"
		},
		{
			"name": "Guinea-Bissau",
			"code": "GW"
		},
		{
			"name": "Guyana",
			"code": "GY"
		},
		{
			"name": "Haiti",
			"code": "HT"
		},
		{
			"name": "Heard Island and Mcdonald Islands",
			"code": "HM"
		},
		{
			"name": "Holy See (Vatican City State)",
			"code": "VA"
		},
		{
			"name": "Honduras",
			"code": "HN"
		},
		{
			"name": "Hong Kong",
			"code": "HK"
		},
		{
			"name": "Hungary",
			"code": "HU"
		},
		{
			"name": "Iceland",
			"code": "IS"
		},
		{
			"name": "India",
			"code": "IN"
		},
		{
			"name": "Indonesia",
			"code": "ID"
		},
		{
			"name": "Iran, Islamic Republic Of",
			"code": "IR"
		},
		{
			"name": "Iraq",
			"code": "IQ"
		},
		{
			"name": "Ireland",
			"code": "IE"
		},
		{
			"name": "Isle of Man",
			"code": "IM"
		},
		{
			"name": "Israel",
			"code": "IL"
		},
		{
			"name": "Italy",
			"code": "IT"
		},
		{
			"name": "Jamaica",
			"code": "JM"
		},
		{
			"name": "Japan",
			"code": "JP"
		},
		{
			"name": "Jersey",
			"code": "JE"
		},
		{
			"name": "Jordan",
			"code": "JO"
		},
		{
			"name": "Kazakhstan",
			"code": "KZ"
		},
		{
			"name": "Kenya",
			"code": "KE"
		},
		{
			"name": "Kiribati",
			"code": "KI"
		},
		{
			"name": "Korea, Democratic People\"S Republic of",
			"code": "KP"
		},
		{
			"name": "Korea, Republic of",
			"code": "KR"
		},
		{
			"name": "Kuwait",
			"code": "KW"
		},
		{
			"name": "Kyrgyzstan",
			"code": "KG"
		},
		{
			"name": "Lao People\"S Democratic Republic",
			"code": "LA"
		},
		{
			"name": "Latvia",
			"code": "LV"
		},
		{
			"name": "Lebanon",
			"code": "LB"
		},
		{
			"name": "Lesotho",
			"code": "LS"
		},
		{
			"name": "Liberia",
			"code": "LR"
		},
		{
			"name": "Libyan Arab Jamahiriya",
			"code": "LY"
		},
		{
			"name": "Liechtenstein",
			"code": "LI"
		},
		{
			"name": "Lithuania",
			"code": "LT"
		},
		{
			"name": "Luxembourg",
			"code": "LU"
		},
		{
			"name": "Macao",
			"code": "MO"
		},
		{
			"name": "Macedonia, The Former Yugoslav Republic of",
			"code": "MK"
		},
		{
			"name": "Madagascar",
			"code": "MG"
		},
		{
			"name": "Malawi",
			"code": "MW"
		},
		{
			"name": "Malaysia",
			"code": "MY"
		},
		{
			"name": "Maldives",
			"code": "MV"
		},
		{
			"name": "Mali",
			"code": "ML"
		},
		{
			"name": "Malta",
			"code": "MT"
		},
		{
			"name": "Marshall Islands",
			"code": "MH"
		},
		{
			"name": "Martinique",
			"code": "MQ"
		},
		{
			"name": "Mauritania",
			"code": "MR"
		},
		{
			"name": "Mauritius",
			"code": "MU"
		},
		{
			"name": "Mayotte",
			"code": "YT"
		},
		{
			"name": "Mexico",
			"code": "MX"
		},
		{
			"name": "Micronesia, Federated States of",
			"code": "FM"
		},
		{
			"name": "Moldova, Republic of",
			"code": "MD"
		},
		{
			"name": "Monaco",
			"code": "MC"
		},
		{
			"name": "Mongolia",
			"code": "MN"
		},
		{
			"name": "Montserrat",
			"code": "MS"
		},
		{
			"name": "Morocco",
			"code": "MA"
		},
		{
			"name": "Mozambique",
			"code": "MZ"
		},
		{
			"name": "Myanmar",
			"code": "MM"
		},
		{
			"name": "Namibia",
			"code": "NA"
		},
		{
			"name": "Nauru",
			"code": "NR"
		},
		{
			"name": "Nepal",
			"code": "NP"
		},
		{
			"name": "Netherlands",
			"code": "NL"
		},
		{
			"name": "Netherlands Antilles",
			"code": "AN"
		},
		{
			"name": "New Caledonia",
			"code": "NC"
		},
		{
			"name": "New Zealand",
			"code": "NZ"
		},
		{
			"name": "Nicaragua",
			"code": "NI"
		},
		{
			"name": "Niger",
			"code": "NE"
		},
		{
			"name": "Nigeria",
			"code": "NG"
		},
		{
			"name": "Niue",
			"code": "NU"
		},
		{
			"name": "Norfolk Island",
			"code": "NF"
		},
		{
			"name": "Northern Mariana Islands",
			"code": "MP"
		},
		{
			"name": "Norway",
			"code": "NO"
		},
		{
			"name": "Oman",
			"code": "OM"
		},
		{
			"name": "Pakistan",
			"code": "PK"
		},
		{
			"name": "Palau",
			"code": "PW"
		},
		{
			"name": "Palestinian Territory, Occupied",
			"code": "PS"
		},
		{
			"name": "Panama",
			"code": "PA"
		},
		{
			"name": "Papua New Guinea",
			"code": "PG"
		},
		{
			"name": "Paraguay",
			"code": "PY"
		},
		{
			"name": "Peru",
			"code": "PE"
		},
		{
			"name": "Philippines",
			"code": "PH"
		},
		{
			"name": "Pitcairn",
			"code": "PN"
		},
		{
			"name": "Poland",
			"code": "PL"
		},
		{
			"name": "Portugal",
			"code": "PT"
		},
		{
			"name": "Puerto Rico",
			"code": "PR"
		},
		{
			"name": "Qatar",
			"code": "QA"
		},
		{
			"name": "Reunion",
			"code": "RE"
		},
		{
			"name": "Romania",
			"code": "RO"
		},
		{
			"name": "Russian Federation",
			"code": "RU"
		},
		{
			"name": "RWANDA",
			"code": "RW"
		},
		{
			"name": "Saint Helena",
			"code": "SH"
		},
		{
			"name": "Saint Kitts and Nevis",
			"code": "KN"
		},
		{
			"name": "Saint Lucia",
			"code": "LC"
		},
		{
			"name": "Saint Pierre and Miquelon",
			"code": "PM"
		},
		{
			"name": "Saint Vincent and the Grenadines",
			"code": "VC"
		},
		{
			"name": "Samoa",
			"code": "WS"
		},
		{
			"name": "San Marino",
			"code": "SM"
		},
		{
			"name": "Sao Tome and Principe",
			"code": "ST"
		},
		{
			"name": "Saudi Arabia",
			"code": "SA"
		},
		{
			"name": "Senegal",
			"code": "SN"
		},
		{
			"name": "Serbia and Montenegro",
			"code": "CS"
		},
		{
			"name": "Seychelles",
			"code": "SC"
		},
		{
			"name": "Sierra Leone",
			"code": "SL"
		},
		{
			"name": "Singapore",
			"code": "SG"
		},
		{
			"name": "Slovakia",
			"code": "SK"
		},
		{
			"name": "Slovenia",
			"code": "SI"
		},
		{
			"name": "Solomon Islands",
			"code": "SB"
		},
		{
			"name": "Somalia",
			"code": "SO"
		},
		{
			"name": "South Africa",
			"code": "ZA"
		},
		{
			"name": "South Georgia and the South Sandwich Islands",
			"code": "GS"
		},
		{
			"name": "Spain",
			"code": "ES"
		},
		{
			"name": "Sri Lanka",
			"code": "LK"
		},
		{
			"name": "Sudan",
			"code": "SD"
		},
		{
			"name": "Suriname",
			"code": "SR"
		},
		{
			"name": "Svalbard and Jan Mayen",
			"code": "SJ"
		},
		{
			"name": "Swaziland",
			"code": "SZ"
		},
		{
			"name": "Sweden",
			"code": "SE"
		},
		{
			"name": "Switzerland",
			"code": "CH"
		},
		{
			"name": "Syrian Arab Republic",
			"code": "SY"
		},
		{
			"name": "Taiwan, Province of China",
			"code": "TW"
		},
		{
			"name": "Tajikistan",
			"code": "TJ"
		},
		{
			"name": "Tanzania, United Republic of",
			"code": "TZ"
		},
		{
			"name": "Thailand",
			"code": "TH"
		},
		{
			"name": "Timor-Leste",
			"code": "TL"
		},
		{
			"name": "Togo",
			"code": "TG"
		},
		{
			"name": "Tokelau",
			"code": "TK"
		},
		{
			"name": "Tonga",
			"code": "TO"
		},
		{
			"name": "Trinidad and Tobago",
			"code": "TT"
		},
		{
			"name": "Tunisia",
			"code": "TN"
		},
		{
			"name": "Turkey",
			"code": "TR"
		},
		{
			"name": "Turkmenistan",
			"code": "TM"
		},
		{
			"name": "Turks and Caicos Islands",
			"code": "TC"
		},
		{
			"name": "Tuvalu",
			"code": "TV"
		},
		{
			"name": "Uganda",
			"code": "UG"
		},
		{
			"name": "Ukraine",
			"code": "UA"
		},
		{
			"name": "United Arab Emirates",
			"code": "AE"
		},
		{
			"name": "United Kingdom",
			"code": "GB"
		},
		{
			"name": "United States",
			"code": "US"
		},
		{
			"name": "United States Minor Outlying Islands",
			"code": "UM"
		},
		{
			"name": "Uruguay",
			"code": "UY"
		},
		{
			"name": "Uzbekistan",
			"code": "UZ"
		},
		{
			"name": "Vanuatu",
			"code": "VU"
		},
		{
			"name": "Venezuela",
			"code": "VE"
		},
		{
			"name": "Viet Nam",
			"code": "VN"
		},
		{
			"name": "Virgin Islands, British",
			"code": "VG"
		},
		{
			"name": "Virgin Islands, U.S.",
			"code": "VI"
		},
		{
			"name": "Wallis and Futuna",
			"code": "WF"
		},
		{
			"name": "Western Sahara",
			"code": "EH"
		},
		{
			"name": "Yemen",
			"code": "YE"
		},
		{
			"name": "Zambia",
			"code": "ZM"
		},
		{
			"name": "Zimbabwe",
			"code": "ZW"
		}
	];

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaTagInput = angular.module('app.lbaTagInput', []);
	
	lbaTagInput.controller('lbaTagInputCtrl', __webpack_require__(219));
	lbaTagInput.directive('lbaTagInput', __webpack_require__(220));
	
	exports['default'] = lbaTagInput;
	module.exports = exports['default'];

/***/ },
/* 219 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var $inject = ['$scope', '$routeParams', 'dataService'];
	
	var lbaTagInputCtrl = function lbaTagInputCtrl($scope, $routeParams, dataService) {
	    var vm = this;
	    var dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
	
	    vm.data = _.get(dataService.data.activeItem, dataLookUp);
	    vm.itemArray = [];
	    vm.copyStatus = 'Copy all tags to clipboard';
	    vm.copyItems = copyItems;
	    vm.validationLimit = vm.settings.validationItemLimit;
	    vm.validationPattern = vm.settings.validationRegex;
	    vm.isValid = true;
	    // Preserve any static help text configured for this field
	    vm.originalHelpText = vm.settings.helpText;
	
	    function copyTextToClipboard(text) {
	        var textArea = document.createElement("textarea");
	
	        textArea.style.position = 'fixed';
	        textArea.style.top = 0;
	        textArea.style.left = 0;
	        textArea.style.width = '2em';
	        textArea.style.height = '2em';
	        textArea.style.padding = 0;
	        textArea.style.border = 'none';
	        textArea.style.outline = 'none';
	        textArea.style.boxShadow = 'none';
	        textArea.style.background = 'transparent';
	        textArea.value = text;
	
	        document.body.appendChild(textArea);
	
	        textArea.select();
	
	        try {
	            document.execCommand('copy');
	        } catch (err) {}
	
	        document.body.removeChild(textArea);
	    }
	
	    function copyItems() {
	        copyTextToClipboard(vm.data.join(', '));
	    }
	
	    $scope.$watchCollection('vm.data', function (newData, oldData) {
	        if (newData !== oldData) {
	
	            if (vm.validationPattern) {
	                var regex = new RegExp(vm.validationPattern);
	                vm.isValid = regex.test(vm.data);
	                $scope.$emit('ValidationStatusChanged', {
	                    controllerName: $scope.vm.settings.dataAt,
	                    isValid: vm.isValid
	                });
	                // Do not override helpText here; the template will show
	                // validationMessage when invalid, and helpText otherwise.
	            }
	
	            // TODO: Put this into it's own component or utility to reuse.
	            if (vm.validationLimit) {
	                var itemCount = vm.data.length;
	                vm.isValid = !itemCount || itemCount <= vm.validationLimit;
	                $scope.$emit('ValidationStatusChanged', {
	                    controllerName: $scope.vm.settings.dataAt,
	                    isValid: vm.isValid
	                });
	                // Do not override helpText here either.
	            }
	
	            _.set(dataService.data.activeItem, dataLookUp, newData);
	        }
	    });
	
	    vm.taggingFunc = function (event) {
	        event.preventDefault();
	        var re = /\r?\n|\r/g;
	        var pasted = event.originalEvent.clipboardData.getData('text/plain').replace(re, '').trim();
	        var arr = [];
	        var end = 0;
	
	        for (var start = 0; start < pasted.length; start++) {
	            var isValidString = pasted[start];
	            if (isValidString === ' ' || isValidString === ',') continue;
	
	            if (pasted.startsWith('<regex>', start)) {
	                end = pasted.indexOf('</regex>', start) + 8;
	                arr.push(pasted.slice(start, end));
	                start = end;
	            } else {
	                end = pasted.indexOf(',', start);
	                if (end === -1) end = pasted.length;
	                arr.push(pasted.slice(start, end));
	                start = end;
	            }
	        }
	
	        vm.data = _.uniq(_.union(vm.data, arr));
	    };
	};
	
	lbaTagInputCtrl.$inject = $inject;
	
	exports['default'] = lbaTagInputCtrl;
	module.exports = exports['default'];

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	var lbaTagInput = function lbaTagInput() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '=',
	      name: '=',
	      cake: '=',
	      indexArray: '@'
	    },
	    bindToController: true,
	    controller: 'lbaTagInputCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(221)
	  };
	};
	
	lbaTagInput.$inject = $inject;
	
	exports['default'] = lbaTagInput;
	module.exports = exports['default'];

/***/ },
/* 221 */
/***/ function(module, exports) {

	var v1="<div class=\"form-group\"> <label for=\"{{ vm.settings.dataAt }}\">{{ vm.settings.displayName }}</label> <ui-select id=\"{{ vm.settings.dataAt }}\" name=\"{{ vm.settings.dataAt }}\" multiple=\"multiple\" tagging tagging-label=\"false\" ng-paste=\"vm.taggingFunc($event)\" ng-model=\"vm.data\" ng-required=\"vm.settings.required\"> <ui-select-match>{{ $item }}</ui-select-match> <ui-select-choices repeat=\"item in vm.itemArray\"> <div ng-bind-html=\"item | highlight: $select.search\"></div> </ui-select-choices> </ui-select> <a ng-click=\"vm.copyItems()\" class=\"copyAlltags\"><i class=\"fa fa-clipboard\"></i> Copy all</a> <p class=\"help-block validation-message\" ng-if=\"!vm.isValid\">{{ vm.settings.validationMessage }}</p> <div ng-if=\"vm.settings.html\" ng-bind-html=\"vm.settings.html\"></div> <p class=\"help-block\" ng-if=\"vm.isValid && vm.settings.helpText\">{{ vm.settings.helpText }}</p> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaTagInput.html", v1)}]);
	module.exports=v1;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaFileUploader = angular.module('app.lbaFileUploader', []);
	
	lbaFileUploader.controller('lbaFileUploaderCtrl', __webpack_require__(223));
	lbaFileUploader.directive('lbaFileUploader', __webpack_require__(224));
	
	exports['default'] = lbaFileUploader;
	module.exports = exports['default'];

/***/ },
/* 223 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope', '$routeParams', 'Upload', 'dataService', 'authService'];
	
	function dateTimeString(int) {
	  if (String(int).length === 1) return '0' + int;
	
	  return String(int);
	}
	
	var lbaFileUploaderCtrl = function lbaFileUploaderCtrl($scope, $routeParams, Upload, dataService, authService) {
	  var vm = this;
	  var dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
	
	  vm.data = _.get(dataService.data.activeItem, dataLookUp);
	  vm.blobUrl = blobUrl;
	  vm.progressPercentage = 0;
	  vm.uploadSuccess = false;
	  vm.uploadFailure = false;
	  vm.authService = authService;
	  vm.isEnabled = true;
	
	  if (vm.settings.isEnabledMethod) {
	    vm.isEnabled = eval(vm.settings.isEnabledMethod);
	  }
	
	  $scope.$watchCollection('vm.data', function (newData, oldData) {
	    if (newData !== oldData) {
	      _.set(dataService.data.activeItem, dataLookUp, newData);
	    }
	  });
	
	  vm.upload = function (file) {
	    vm.uploadFailure = false;
	
	    vm.filename = '';
	
	    if (!file) {
	      vm.uploadFailure = true;
	      return false;
	    }
	
	    var fileExtension = file.name.substr(file.name.lastIndexOf('.'));
	    var fileName = '';
	    var fileNameDate = new Date();
	    if (vm.settings.rawFileWithDate) {
	      fileName = dateTimeString(fileNameDate.getFullYear());
	      fileName += dateTimeString(fileNameDate.getMonth() + 1);
	      fileName += dateTimeString(fileNameDate.getDate()) + '_';
	      fileName += dateTimeString(fileNameDate.getHours());
	      fileName += dateTimeString(fileNameDate.getMinutes());
	      fileName += dateTimeString(fileNameDate.getSeconds()) + '_' + file.name.substr(0, file.name.lastIndexOf('.'));
	      fileName = fileName.replace(/[^\w\s _]/g, '');
	    } else if (vm.settings.fileNameFormat) {
	
	      fileName = dateTimeString(fileNameDate.getFullYear());
	      fileName += dateTimeString(fileNameDate.getMonth() + 1);
	      fileName += dateTimeString(fileNameDate.getDate()) + '_';
	      fileName += dateTimeString(fileNameDate.getHours());
	      fileName += dateTimeString(fileNameDate.getMinutes());
	    } else {
	      fileName = new Date() + '';
	      fileName = fileName.replace(/[^\/\d]/g, '');
	    }
	
	    if (vm.settings.fileNamePrefixProperty) {
	      fileName = dataService.data.activeItem[vm.settings.fileNamePrefixProperty] + '_' + fileName;
	    }
	
	    if (vm.settings.fileNamePrefix) {
	      fileName = vm.settings.fileNamePrefix + '_' + fileName;
	    }
	
	    if (vm.settings.fileNameSuffix) {
	      fileName = fileName + vm.settings.fileNameSuffix;
	    }
	
	    fileName += fileExtension;
	
	    Upload.upload({
	      url: endPointUrl + '/api/Upload/' + vm.settings.fileContainer + '?filename=' + fileName,
	      data: { file: file }
	    }).then(function (resp) {
	      vm.uploadSuccess = true;
	      if (!vm.settings.excludeFromPost) {
	        vm.data = resp.data;
	      } else {
	        vm.filename = resp.data;
	      }
	    }, function (resp) {
	      vm.uploadSuccess = false;
	      vm.uploadFailure = true;
	      console.log('Error status: ' + resp.status);
	    }, function (evt) {
	      vm.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	    });
	  };
	};
	
	lbaFileUploaderCtrl.$inject = $inject;
	
	exports['default'] = lbaFileUploaderCtrl;
	module.exports = exports['default'];

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(225);
	
	var $inject = [];
	var lbaFileUploader = function lbaFileUploader() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaFileUploaderCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(227)
	  };
	};
	
	lbaFileUploader.$inject = $inject;
	
	exports['default'] = lbaFileUploader;
	module.exports = exports['default'];

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(226);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaFileUploader.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaFileUploader.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".lbaFileUploader_imageContainer{background:transparent;display:inline-block;margin:1rem 0;max-width:300px}.lbaFileUploader_imageContainer img{width:100%}.lbaFileUploader_svgContainer span{background-position:50% 50%;background-repeat:no-repeat;background-size:contain;width:30px;height:20px;margin:1rem 1rem 0 0;float:left;position:relative}.lbaFileUploader_alert,.lbaFileUploader_progress{margin:1rem 0}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaFileUploader/src/components/lbaFileUploader/lbaFileUploader.scss"],"names":[],"mappings":"AAAA,gCACI,uBACA,qBACA,cACA,eAAgB,CAJpB,oCAOQ,UAAW,CACd,mCAKG,4BACA,4BACA,wBACA,WACA,YACA,qBACA,WACA,iBAAkB,CACrB,AAKJ,iDAGG,aAAc,CACjB","file":"lbaFileUploader.scss","sourcesContent":[".lbaFileUploader_imageContainer {\r\n    background: transparent;\r\n    display: inline-block;\r\n    margin: 1rem 0;\r\n    max-width: 300px;\r\n\r\n    img {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n.lbaFileUploader_svgContainer {\r\n    span {\r\n        background-position: 50% 50%;\r\n        background-repeat: no-repeat;\r\n        background-size: contain;\r\n        width: 30px;\r\n        height: 20px;\r\n        margin: 1rem 1rem 0 0;\r\n        float: left;\r\n        position: relative;\r\n    }\r\n}\r\n\r\n.lbaFileUploader_progress {\r\n    margin: 1rem 0;\r\n}\r\n\r\n.lbaFileUploader_alert {\r\n    margin: 1rem 0;\r\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 227 */
/***/ function(module, exports) {

	var v1="<div class=\"form-group\"> <label>{{ vm.settings.displayName }}</label> <div ng-if=\"!vm.isEnabled\">This is disabled</div> <div class=\"input-group\" ng-if=\"vm.isEnabled\"> <input class=\"form-control\" ng-model=\"vm.data\" type=\"text\" disabled=\"disabled\" ng-if=\"vm.data.length > 0\">\n<input class=\"form-control\" ng-model=\"vm.filename\" type=\"text\" disabled=\"disabled\" ng-if=\"vm.settings.exclude && vm.filename\">\n<span class=\"input-group-btn\"> <button class=\"btn btn-default\" type=\"button\" ngf-select=\"vm.upload($file)\" ngf-pattern=\"(vm.settings.fileAccept?vm.settings.fileAccept:'image/*,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')\" ngf-accept=\"(vm.settings.fileAccept?vm.settings.fileAccept:'image/*,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')\" ngf-max-size=\"3MB\"> Choose file</button> </span> </div> <div class=\"progress lbaFileUploader_progress\" ng-if=\"vm.progressPercentage > 0\"> <div class=\"progress-bar progress-bar-success\" role=\"progressbar\" style=\"width: {{ vm.progressPercentage }}%\"> {{ vm.progressPercentage }}% </div> </div> <div class=\"alert alert-success lbaFileUploader_alert\" role=\"alert\" ng-if=\"vm.uploadSuccess\"> <i class=\"fa fa-smile-o\" aria-hidden=\"true\"></i>\n<span class=\"sr-only\">Success:</span>\nFile upload complete </div> <div class=\"alert alert-danger lbaFileUploader_alert\" role=\"alert\" ng-if=\"vm.uploadFailure\"> <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i>\n<span class=\"sr-only\">Error:</span>\nFile upload failed </div> <div ng-if=\"vm.data.length > 0 && vm.settings.uploadType === 'image'\" class=\"lbaFileUploader_imageContainer\"> <img ng-src=\"{{ vm.blobUrl + vm.data }}\"> </div> <div ng-if=\"vm.data.length > 0 && vm.settings.uploadType === 'pdf'\" class=\"lbaFileUploader_imageContainer\"> <a ng-href=\"{{ vm.blobUrl + vm.data }}\" target=\"_blank\"><i class=\"fa fa-file-pdf-o\"></i> Download {{vm.settings.uploadType | uppercase}}</a> </div> <div ng-if=\"vm.data.length > 0 && vm.settings.uploadType === 'svg'\" class=\"lbaFileUploader_svgContainer\"> <span style=\"background-image: url('{{ vm.blobUrl + vm.data }}')\"></span> </div> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaFileUploader.html", v1)}]);
	module.exports=v1;

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaFileDownloader = angular.module('app.lbaFileDownloader', []);
	
	lbaFileDownloader.controller('lbaFileDownloaderCtrl', __webpack_require__(229));
	lbaFileDownloader.directive('lbaFileDownloader', __webpack_require__(230));
	
	exports['default'] = lbaFileDownloader;
	module.exports = exports['default'];

/***/ },
/* 229 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var $inject = ['$http', 'dataService'];
	
	var lbaFileDownloaderCtrl = function lbaFileDownloaderCtrl($http, dataService) {
	    var vm = this;
	
	    vm.download = function () {
	        console.log("Starting File Download");
	
	        var endPointController = vm.settings.endPointController;
	        var url = endPointUrl + '/api/Download/' + endPointController;
	        var parameterName = vm.settings.parameterName;
	        var parameterValue = '';
	        if (vm.settings.parameterName) {
	            parameterValue = dataService.data.activeItem[vm.settings.parameterValueFromActiveItemProperty];
	            url = endPointUrl + '/api/Download/' + endPointController + '?' + parameterName + '=' + parameterValue;
	        }
	
	        $http.get(url, { responseType: 'arraybuffer' }).success(function (data, status, headers) {
	            var octetStreamMime = 'application/octet-stream';
	            var success = false;
	            // Get the headers
	            headers = headers();
	
	            // Get the filename from the x-filename header or default from vm
	            var filename = headers['x-filename'] || parameterValue + '_' + vm.settings.fileNameSuffix;
	            // Determine the content type from the header or default to "application/octet-stream"
	            var contentType = headers['content-type'] || octetStreamMime;
	
	            try {
	                // Try using msSaveBlob if supported
	                console.log("Trying saveBlob method ...");
	                var blob = new Blob([data], { type: contentType });
	
	                if (navigator.msSaveBlob) navigator.msSaveBlob(blob, filename);else {
	                    // Try using other saveBlob implementations, if available
	                    var saveBlob = navigator.webkitSaveBlob || navigator.mozSaveBlob || navigator.saveBlob;
	
	                    if (saveBlob === undefined) throw "Not supported";
	                    saveBlob(blob, filename);
	                }
	                console.log("saveBlob succeeded");
	                success = true;
	            } catch (ex) {
	                console.log("saveBlob method failed with the following exception:");
	                console.log(ex);
	            }
	
	            if (!success) {
	                // Get the blob url creator
	                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
	                if (urlCreator) {
	                    // Try to use a download link
	                    var link = document.createElement('a');
	                    if ('download' in link) {
	                        // Try to simulate a click
	                        try {
	                            // Prepare a blob URL
	                            console.log("Trying download link method with simulated click ...");
	                            var blob = new Blob([data], { type: contentType });
	                            var url = urlCreator.createObjectURL(blob);
	                            link.setAttribute('href', url);
	
	                            // Set the download attribute (Supported in Chrome 14+ / Firefox 20+)
	                            link.setAttribute("download", filename);
	
	                            // Simulate clicking the download link
	                            var event = document.createEvent('MouseEvents');
	                            event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
	                            link.dispatchEvent(event);
	                            console.log("Download link method with simulated click succeeded");
	                            success = true;
	                        } catch (ex) {
	                            console.log("Download link method with simulated click failed with the following exception:");
	                            console.log(ex);
	                        }
	                    }
	
	                    if (!success) {
	                        // Fallback to window.location method
	                        try {
	                            // Prepare a blob URL
	                            // Use application/octet-stream when using window.location to force download
	                            console.log("Trying download link method with window.location ...");
	                            var blob = new Blob([data], { type: octetStreamMime });
	                            var url = urlCreator.createObjectURL(blob);
	                            window.location = url;
	                            console.log("Download link method with window.location succeeded");
	                            success = true;
	                        } catch (ex) {
	                            console.log("Download link method with window.location failed with the following exception:");
	                            console.log(ex);
	                        }
	                    }
	                }
	            }
	
	            if (!success) {
	                // Fallback to window.open method
	                console.log("No methods worked for saving the arraybuffer, using last resort window.open");
	                window.open(httpPath, '_blank', '');
	            }
	
	            console.log("Ending File Download");
	        }).error(function (err, x) {
	            console.log(err, x);
	        });
	
	        console.log("Ending File Download");
	    };
	};
	
	lbaFileDownloaderCtrl.$inject = $inject;
	
	exports['default'] = lbaFileDownloaderCtrl;
	module.exports = exports['default'];

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	var lbaFileDownloader = function lbaFileDownloader() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaFileDownloaderCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(231)
	  };
	};
	
	lbaFileDownloader.$inject = $inject;
	
	exports['default'] = lbaFileDownloader;
	module.exports = exports['default'];

/***/ },
/* 231 */
/***/ function(module, exports) {

	var v1="<div class=\"form-group\"> <label>{{ vm.settings.displayName }}</label> <div class=\"input-group\"> <button type=\"submit\" class=\"btn btn-default\" ng-click=\"vm.download()\">Download</button> </div> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaFileDownloader.html", v1)}]);
	module.exports=v1;

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaSelect = angular.module('app.lbaSelect', []);
	
	lbaSelect.controller('lbaSelectCtrl', __webpack_require__(233));
	lbaSelect.directive('lbaSelect', __webpack_require__(234));
	
	exports['default'] = lbaSelect;
	module.exports = exports['default'];

/***/ },
/* 233 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var $inject = ['$scope', '$routeParams', 'settingsService', 'dataService', '$timeout'];
	
	var lbaSelectCtrl = function lbaSelectCtrl($scope, $routeParams, settingsService, dataService, $timeout) {
	  var vm = this;
	  var dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
	
	  vm.data = _.get(dataService.data.activeItem, dataLookUp);
	  if (vm.settings.handleAsString) {
	    vm.data = '' + vm.data;
	  }
	
	  vm.getOptions = getOptions;
	  vm.addSelected = addSelected;
	  vm.items = getItemsToDisplay();
	
	  // if no data (i.e. field is not filled out) load default
	  if (!vm.data && vm.settings.defaultValue) {
	    vm.data = vm.settings.defaultValue;
	    _.set(dataService.data.activeItem, dataLookUp, vm.data);
	  }
	
	  // UI SELECT DOESN'T AUTO SELECT NUMBERS SO NEED TO CONVERT TO STRINGS...
	  if (vm.settings.optionsNumbers) {
	    vm.items.map(function (item) {
	      item.value = '' + item.value;
	
	      return item;
	    });
	
	    vm.data = '' + vm.data;
	  }
	
	  $scope.$watchCollection('vm.data', function (newData, oldData) {
	    if (newData !== oldData) {
	      if (vm.settings.allowNullable && newData === "") {
	        newData = null;
	      }
	
	      _.set(dataService.data.activeItem, dataLookUp, newData);
	    }
	    hideShowProperties(newData);
	  });
	
	  function getOptions(options, userInput) {
	    var opts = angular.copy(options);
	    if (userInput.length > 0) {
	      opts.unshift(userInput);
	    }
	    return opts;
	  }
	
	  function addSelected(item) {
	    if (vm.items.indexOf(item) === -1) {
	      vm.items.unshift(item);
	    }
	  }
	
	  function getItemsToDisplay() {
	    if (vm.settings.optionsAt) {
	      var options = [].concat(_toConsumableArray(settingsService.options[vm.settings.optionsAt]));
	
	      if (vm.settings.allowNullable) {
	        options.unshift(null);
	      }
	
	      return options;
	    }
	
	    if (vm.settings.rangeValuesAt) {
	      var rangeValues = settingsService.options[vm.settings.rangeValuesAt];
	
	      if (canGetRangeValues(rangeValues)) {
	        return arrayRange(rangeValues[0], rangeValues[1], 1);
	      }
	
	      console.log("There was an error displaying your range list");
	
	      return [];
	    }
	  }
	
	  function arrayRange(start, stop, step) {
	    var resultRange = Array.from({ length: (stop - start) / step + 1 }, function (value, index) {
	      var result = vm.settings.showRangeValuesReverseOrder ? stop - index * step : start + index * step;
	      return {
	        label: '' + (result > 0 ? "+" : "") + result,
	        value: result
	      };
	    });
	    return resultRange;
	  }
	
	  function canGetRangeValues(rangeValues) {
	    return rangeValues.length && rangeValues.length === 2 && typeof rangeValues[0] === "number" && typeof rangeValues[1] === "number";
	  }
	  $timeout(function () {
	    return hideShowProperties(vm.data);
	  }, 150);
	  function hideShowProperties(val) {
	    if (!vm.settings.hideShowProperty) return;
	    vm.items.forEach(function (opt) {
	      var classKey = "." + vm.settings.hideShowProperty;
	      var className = classKey + "_" + opt;
	      if (val === opt) {
	        $(className).show();
	      } else {
	        $(className).hide();
	      }
	    });
	  }
	};
	
	lbaSelectCtrl.$inject = $inject;
	
	exports['default'] = lbaSelectCtrl;
	module.exports = exports['default'];

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	
	var lbaSelect = function lbaSelect() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '=settings'
	    },
	    bindToController: true,
	    controller: 'lbaSelectCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(235)
	  };
	};
	
	lbaSelect.$inject = $inject;
	
	exports['default'] = lbaSelect;
	module.exports = exports['default'];

/***/ },
/* 235 */
/***/ function(module, exports) {

	var v1="<div class=\"form-group\"> <label for=\"{{ vm.settings.dataAt }}\">{{ vm.settings.displayName }}</label> <select ng-if=\"!vm.settings.addOptionAllowed\" id=\"{{ vm.settings.dataAt }}\" name=\"{{ vm.settings.dataAt }}\" class=\"form-control\" ng-model=\"vm.data\" ng-disabled=\"vm.settings.disabled\" ng-required=\"vm.settings.required\"> <option ng-selected=\"{{ vm.data === (item.value ? item.value : item) }}\" ng-repeat=\"item in vm.items\" value=\"{{ item.value || item }}\"> {{ item.label || item }} </option> </select> <ui-select ng-if=\"vm.settings.addOptionAllowed\" ng-model=\"vm.data\" on-select=\"vm.addSelected(vm.data)\"> <ui-select-match>{{ $select.selected }}</ui-select-match> <ui-select-choices repeat=\"item in vm.getOptions(vm.items, $select.search) | filter:$select.search\"> {{item}} </ui-select-choices> </ui-select> <p class=\"help-block\" ng-if=\"vm.settings.helpText\">{{ vm.settings.helpText }}</p> <div ng-if=\"vm.settings.html\" ng-bind-html=\"vm.settings.html\"></div> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaSelect.html", v1)}]);
	module.exports=v1;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaODataIndexMultiSelect = angular.module('app.lbaODataIndexMultiSelect', []);
	
	lbaODataIndexMultiSelect.controller('lbaODataIndexMultiSelectCtrl', __webpack_require__(237));
	lbaODataIndexMultiSelect.directive('lbaODataIndexMultiSelect', __webpack_require__(238));
	
	exports['default'] = lbaODataIndexMultiSelect;
	module.exports = exports['default'];

/***/ },
/* 237 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$window', '$scope', '$routeParams', 'dataService', '$filter', 'indexService'];
	
	var lbaODataIndexMultiSelectCtrl = function lbaODataIndexMultiSelectCtrl($window, $scope, $routeParams, dataService, $filter, indexService) {
	  var vm = this;
	  var dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
	  var identifier = dataService.data.activeItem[vm.settings.searchId];
	  var uri = $window[vm.settings.windowVar];
	
	  vm.data = _.get(dataService.data.activeItem, dataLookUp) || [];
	  vm.searchResults = [];
	  vm.thisComp = angular.copy(vm.data);
	
	  vm.refreshData = refreshData;
	  vm.itemAdded = itemAdded;
	  vm.itemRemoved = itemRemoved;
	
	  function refreshData(userSearch) {
	
	    indexService.search(uri, vm.settings.index, vm.settings.suggester, vm.settings.apiVersion, userSearch, vm.settings.searchFields, vm.settings.searchFields, vm.settings.valueField, identifier).then(function (data) {
	
	      var results = [];
	
	      data.forEach(function (result) {
	        if (_.indexOf(vm.data, result[vm.settings.valueField]) === -1) {
	          results.push(result);
	        }
	      });
	
	      vm.searchResults = results;
	    });
	  }
	
	  function cleanItems(items) {
	    var allItems = _.uniq(items);
	    return _.without(allItems, null);
	  }
	
	  function itemAdded($item) {
	    vm.data.push($item[vm.settings.valueField]);
	    _.set(dataService.data.activeItem, dataLookUp, vm.data);
	  }
	
	  function itemRemoved($item) {
	    var copy = angular.copy(vm.data);
	    var index = copy.indexOf($item[vm.settings.valueField] || $item);
	
	    if (index > -1) {
	      copy.splice(index, 1);
	    }
	
	    vm.data = copy;
	
	    _.set(dataService.data.activeItem, dataLookUp, vm.data);
	  }
	};
	
	lbaODataIndexMultiSelectCtrl.$inject = $inject;
	
	exports['default'] = lbaODataIndexMultiSelectCtrl;
	module.exports = exports['default'];

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	var lbaODataIndexMultiSelect = function lbaODataIndexMultiSelect() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaODataIndexMultiSelectCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(239)
	  };
	};
	
	lbaODataIndexMultiSelect.$inject = $inject;
	
	exports['default'] = lbaODataIndexMultiSelect;
	module.exports = exports['default'];

/***/ },
/* 239 */
/***/ function(module, exports) {

	var v1="<div class=\"form-group\"> <label for=\"{{ vm.settings.dataAt }}\">{{ vm.settings.displayName }}</label> <ui-select id=\"{{ vm.settings.dataAt }}\" name=\"{{ vm.settings.dataAt }}\" multiple=\"multiple\" ng-model=\"vm.thisComp\" on-select=\"vm.itemAdded($item)\" on-remove=\"vm.itemRemoved($item)\"> <ui-select-match>{{ $item[vm.settings.valueField] || $item }}</ui-select-match> <ui-select-choices repeat=\"item[vm.settings.valueField] as item in vm.searchResults track by $index\" refresh=\"vm.refreshData($select.search)\" refresh-delay=\"300\"> <div ng-bind-html=\"item[vm.settings.valueField] + '-' + item[vm.settings.titleField] | highlight: $select.search\"></div> </ui-select-choices> </ui-select> <p class=\"help-block\" ng-if=\"vm.settings.helpText\">{{ vm.settings.helpText }}</p> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaODataIndexMultiSelect.html", v1)}]);
	module.exports=v1;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaMultiSelect = angular.module('app.lbaMultiSelect', []);
	
	lbaMultiSelect.controller('lbaMultiSelectCtrl', __webpack_require__(241));
	lbaMultiSelect.directive('lbaMultiSelect', __webpack_require__(242));
	
	exports['default'] = lbaMultiSelect;
	module.exports = exports['default'];

/***/ },
/* 241 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope', '$routeParams', 'dataService', 'settingsService'];
	
	var lbaMultiSelectCtrl = function lbaMultiSelectCtrl($scope, $routeParams, dataService, settingsService) {
	  var vm = this;
	  var dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
	
	  vm.data = _.get(dataService.data.activeItem, dataLookUp);
	
	  vm.items = settingsService.options[vm.settings.optionsAt];
	  vm.validationPattern = vm.settings.validationRegex;
	  vm.isValid = true;
	
	  function validateData(data) {
	    if (vm.validationPattern) {
	      if (data && data.length) {
	        (function () {
	          var regex = new RegExp(vm.validationPattern);
	          vm.isValid = data.every(function (item) {
	            return item && regex.test(item);
	          });
	        })();
	      } else {
	        vm.isValid = true;
	      }
	      $scope.$emit('ValidationStatusChanged', {
	        controllerName: vm.settings.dataAt,
	        value: data,
	        isValid: vm.isValid
	      });
	    }
	  }
	
	  // Run initial validation on load
	  if (vm.validationPattern && vm.data) {
	    validateData(vm.data);
	  }
	
	  $scope.$watchCollection('vm.data', function (newData, oldData) {
	    if (newData !== oldData) {
	      if (vm.settings.transformUppercase && newData && newData.length) {
	        var transformed = newData.map(function (item) {
	          return item ? item.toUpperCase() : item;
	        });
	        if (!_.isEqual(transformed, newData)) {
	          vm.data = transformed;
	          newData = transformed;
	        }
	      }
	
	      _.set(dataService.data.activeItem, dataLookUp, newData);
	
	      validateData(newData);
	    }
	  });
	};
	
	lbaMultiSelectCtrl.$inject = $inject;
	
	exports['default'] = lbaMultiSelectCtrl;
	module.exports = exports['default'];

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	var lbaMultiSelect = function lbaMultiSelect() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaMultiSelectCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(243)
	  };
	};
	
	lbaMultiSelect.$inject = $inject;
	
	exports['default'] = lbaMultiSelect;
	module.exports = exports['default'];

/***/ },
/* 243 */
/***/ function(module, exports) {

	var v1="<div class=\"form-group\"> <label for=\"{{ vm.settings.dataAt }}\">{{ vm.settings.displayName }}</label> <ui-select ng-if=\"!vm.settings.allowFreeform\" id=\"{{ vm.settings.dataAt }}\" name=\"{{ vm.settings.dataAt }}\" multiple=\"multiple\" ng-model=\"vm.data\"> <ui-select-match>{{ $item }}</ui-select-match> <ui-select-choices repeat=\"item in vm.items | filter: $select.search\"> <div ng-bind-html=\"item | highlight: $select.search\"></div> </ui-select-choices> </ui-select> <ui-select ng-if=\"vm.settings.allowFreeform\" id=\"{{ vm.settings.dataAt }}\" name=\"{{ vm.settings.dataAt }}\" multiple=\"multiple\" tagging tagging-label=\"(new)\" tagging-tokens=\"ENTER|,\" ng-model=\"vm.data\"> <ui-select-match>{{ $item }}</ui-select-match> <ui-select-choices repeat=\"item in vm.items | filter: $select.search\"> <div ng-bind-html=\"item | highlight: $select.search\"></div> </ui-select-choices> </ui-select> <p class=\"help-block validation-message\" ng-if=\"!vm.isValid\">{{ vm.settings.validationMessage }}</p> <p class=\"help-block\" ng-if=\"vm.isValid && vm.settings.helpText\">{{ vm.settings.helpText }}</p> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaMultiSelect.html", v1)}]);
	module.exports=v1;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaKeyValuePairs = angular.module('app.lbaKeyValuePairs', []);
	
	lbaKeyValuePairs.controller('lbaKeyValuePairsCtrl', __webpack_require__(245));
	lbaKeyValuePairs.directive('lbaKeyValuePairs', __webpack_require__(246));
	
	exports['default'] = lbaKeyValuePairs;
	module.exports = exports['default'];

/***/ },
/* 245 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope', '$routeParams', 'dataService', 'settingsService'];
	
	var lbaKeyValuePairsCtrl = function lbaKeyValuePairsCtrl($scope, $routeParams, dataService, settingsService) {
	  var vm = this;
	  var dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
	
	  vm.addNew = addNew;
	  vm.remove = remove;
	  vm.getOptions = getOptions;
	  vm.addSelected = addSelected;
	
	  vm.keyOptions = settingsService.options[vm.settings.keyOptions];
	  vm.data = _.get(dataService.data.activeItem, dataLookUp);
	
	  vm.sortableOptions = {
	    disabled: false,
	    stop: function stop(e, ui) {}
	  };
	  $scope.$watchCollection('vm.data', function (newData, oldData) {
	    if (newData !== oldData) {
	      _.set(dataService.data.activeItem, dataLookUp, newData);
	    }
	  });
	
	  function addNew() {
	    if (!vm.data) {
	      vm.data = [];
	    }
	    vm.data.push({ Key: '', Value: '' });
	  }
	
	  function remove(index) {
	    vm.data.splice(index, 1);
	    vm.showRemove = [];
	  }
	
	  function getOptions(options, userInput) {
	    var opts = angular.copy(options);
	    if (userInput.length > 0) {
	      opts.unshift(userInput);
	    }
	    return opts;
	  }
	
	  function addSelected(item) {
	    if (vm.keyOptions.indexOf(item) === -1) {
	      vm.keyOptions.unshift(item);
	    }
	  }
	};
	
	lbaKeyValuePairsCtrl.$inject = $inject;
	
	exports['default'] = lbaKeyValuePairsCtrl;
	module.exports = exports['default'];

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(247);
	
	var $inject = [];
	
	var lbaKeyValuePairs = function lbaKeyValuePairs() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaKeyValuePairsCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(249)
	  };
	};
	
	lbaKeyValuePairs.$inject = $inject;
	
	exports['default'] = lbaKeyValuePairs;
	module.exports = exports['default'];

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(248);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaKeyValuePairs.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaKeyValuePairs.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".lbaKeyValuePairs_list{margin:1rem 0}.lbaKeyValuePairs_uiSelect{display:inline-block;width:30rem;margin:0 1rem 0 0}.lbaKeyValuePairs_uiSelect .form-control{width:100%}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaKeyValuePair/src/components/lbaKeyValuePair/lbaKeyValuePairs.scss"],"names":[],"mappings":"AAAA,uBACE,aAAc,CACf,2BAGC,qBACA,YACA,iBAAkB,CAHpB,yCAMI,UAAW,CACZ","file":"lbaKeyValuePairs.scss","sourcesContent":[".lbaKeyValuePairs_list {\r\n  margin: 1rem 0;\r\n}\r\n\r\n.lbaKeyValuePairs_uiSelect {\r\n  display: inline-block;\r\n  width: 30rem;\r\n  margin: 0 1rem 0 0;\r\n\r\n  .form-control {\r\n    width: 100%;\r\n  }\r\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 249 */
/***/ function(module, exports) {

	var v1="<form class=\"form-inline lbaKeyValuePairs\"> <label> {{ vm.settings.displayName }}\n<button ng-click=\"vm.addNew()\" class=\"btn btn-default\"><i class=\"fa fa-plus\"></i> Add New</button> </label> <div ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.data\"> <div ng-repeat=\"keyValue in vm.data\" class=\"lbaKeyValuePairs_list\"> <div class=\"form-group\"> <label>Key:</label> <ui-select ng-if=\"vm.keyOptions.length > 0\" class=\"lbaKeyValuePairs_uiSelect\" ng-model=\"keyValue.Key\" on-select=\"vm.addSelected(keyValue.Key)\"> <ui-select-match>{{ $select.selected }}</ui-select-match> <ui-select-choices repeat=\"item in vm.getOptions(vm.keyOptions, $select.search) | filter:$select.search\"> {{item}} </ui-select-choices> </ui-select> <input ng-if=\"!vm.keyOptions || vm.keyOptions.length === 0\" type=\"text\" ng-model=\"keyValue.Key\" class=\"form-control\"> </div> <div class=\"form-group\"> <label>Value:</label> <input type=\"text\" ng-model=\"keyValue.Value\" class=\"form-control\"> </div> <a href=\"\" ng-click=\"vm.showRemove[$index] = true\" ng-hide=\"vm.showRemove[$index]\">Remove</a>\n<button class=\"btn btn-danger\" ng-click=\"vm.remove($index)\" ng-show=\"vm.showRemove[$index]\">Confirm</button> </div> </div> </form>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaKeyValuePairs.html", v1)}]);
	module.exports=v1;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaRange = angular.module('app.lbaRange', []);
	
	lbaRange.controller('lbaRangeCtrl', __webpack_require__(251));
	lbaRange.directive('lbaRange', __webpack_require__(252));
	
	exports['default'] = lbaRange;
	module.exports = exports['default'];

/***/ },
/* 251 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope', '$routeParams', '$timeout', 'dataService'];
	
	var lbaRangeCtrl = function lbaRangeCtrl($scope, $routeParams, $timeout, dataService) {
	  var vm = this;
	  var dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
	
	  if (vm.settings.divideResultBy > 0) {
	    vm.divideResult = true;
	  }
	
	  vm.rangeModel = 0;
	  vm.min = vm.settings.min || 0;
	  vm.max = vm.settings.max || 10000000000;
	  vm.step = vm.settings.step || 1;
	  vm.units = vm.settings.units || '';
	
	  vm.updateModel = updateModel;
	
	  $scope.$watchCollection('vm.data', function (newData, oldData) {
	    if (newData !== oldData) {
	      _.set(dataService.data.activeItem, dataLookUp, newData);
	    }
	  });
	
	  var data = _.get(dataService.data.activeItem, dataLookUp);
	  vm.data = _.isUndefined(data) && _.isNumber(vm.settings.defaultValue) ? vm.settings.defaultValue : data;
	
	  if (vm.settings.defaultValue) {
	    _.set(dataService.data.activeItem, dataLookUp, vm.data);
	  }
	
	  $timeout(function () {
	    if (vm.divideResult) {
	      vm.rangeModel = vm.data * vm.settings.divideResultBy;
	    } else {
	      vm.rangeModel = vm.data;
	    }
	  });
	
	  function updateModel() {
	    if (vm.divideResult) {
	      vm.data = vm.rangeModel / vm.settings.divideResultBy;
	    } else {
	      vm.data = vm.rangeModel;
	    }
	  }
	};
	
	lbaRangeCtrl.$inject = $inject;
	
	exports['default'] = lbaRangeCtrl;
	module.exports = exports['default'];

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	var lbaRange = function lbaRange() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaRangeCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(253)
	  };
	};
	
	lbaRange.$inject = $inject;
	
	exports['default'] = lbaRange;
	module.exports = exports['default'];

/***/ },
/* 253 */
/***/ function(module, exports) {

	var v1="<div class=\"range\"> <label for=\"{{ vm.settings.dataAt }}\">{{ vm.settings.displayName }}</label> <input type=\"range\" step=\"{{vm.step}}\" min=\"{{vm.min}}\" max=\"{{vm.max}}\" ng-model=\"vm.rangeModel\" ng-change=\"vm.updateModel()\" name=\"{{ vm.settings.dataAt }}\" id=\"{{ vm.settings.dataAt }}\" ng-disabled=\"vm.settings.disabled\" ng-required=\"vm.settings.required\"> <p>Value: {{ vm.rangeModel }} {{ vm.units }}</p> <p class=\"help-block\" ng-if=\"vm.settings.helpText\">{{ vm.settings.helpText }}</p> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaRange.html", v1)}]);
	module.exports=v1;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaBreadCrumb = angular.module('app.lbaBreadCrumb', []);
	
	lbaBreadCrumb.controller('lbaBreadCrumbCtrl', __webpack_require__(255));
	lbaBreadCrumb.directive('lbaBreadCrumb', __webpack_require__(256));
	
	exports['default'] = lbaBreadCrumb;
	module.exports = exports['default'];

/***/ },
/* 255 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$location', 'dataService'];
	
	var lbaBreadCrumbCtrl = function lbaBreadCrumbCtrl($location, dataService) {
	  var vm = this;
	  var pathArray = $location.path().split('/');
	  vm.dataService = dataService;
	  pathArray.shift();
	
	  vm.pathArray = [];
	
	  pathArray.forEach(function (path) {
	    var lastItem = _.last(vm.pathArray);
	
	    if (lastItem) {
	      vm.pathArray.push({
	        url: lastItem.url + '/' + path,
	        name: path
	      });
	    } else {
	      vm.pathArray.push({
	        url: path,
	        name: path
	      });
	    }
	  });
	};
	
	lbaBreadCrumbCtrl.$inject = $inject;
	
	exports['default'] = lbaBreadCrumbCtrl;
	module.exports = exports['default'];

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(257);
	
	var $inject = [];
	
	var lbaBreadCrumb = function lbaBreadCrumb() {
	  return {
	    restrict: 'E',
	    scope: {},
	    bindToController: true,
	    controller: 'lbaBreadCrumbCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(259)
	  };
	};
	
	lbaBreadCrumb.$inject = $inject;
	
	exports['default'] = lbaBreadCrumb;
	module.exports = exports['default'];

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(258);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaBreadCrumb.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaBreadCrumb.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".lbaBreadCrumb{background:#f8f8f8;padding:1rem;margin:0 0 1rem}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaBreadCrumb/src/components/lbaBreadCrumb/lbaBreadCrumb.scss"],"names":[],"mappings":"AAAA,eACE,mBACA,aACA,eAAgB,CACjB","file":"lbaBreadCrumb.scss","sourcesContent":[".lbaBreadCrumb {\r\n  background: #f8f8f8;\r\n  padding: 1rem;\r\n  margin: 0 0 1rem;\r\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 259 */
/***/ function(module, exports) {

	var v1="<ol class=\"breadcrumb\" ng-if=\"!vm.dataService.addNewMode\"> <li ng-repeat=\"path in vm.pathArray\"> <a ng-href=\"#/{{ path.url }}\"> {{ path.name }}</a> </li> </ol>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaBreadCrumb.html", v1)}]);
	module.exports=v1;

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaHotel = angular.module('app.lbaHotel', [__webpack_require__(228).name]);
	
	lbaHotel.controller('lbaHotelCtrl', __webpack_require__(261));
	lbaHotel.directive('lbaHotel', __webpack_require__(262));
	
	exports['default'] = lbaHotel;
	module.exports = exports['default'];

/***/ },
/* 261 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$location', '$rootScope', '$q', '$http', '$filter', '$interval', '$document', 'Upload', 'authService', 'dataService'];
	
	var lbaHotelCtrl = function lbaHotelCtrl($location, $rootScope, $q, $http, $filter, $interval, $document, Upload, authService, dataService) {
	  var vm = this;
	
	  vm.tab = 'iata';
	  vm.hotelTags = [];
	
	  vm.page = 1;
	  vm.pageSize = 50;
	  vm.hasNextPage = false;
	
	  vm.hotelDownloadSettings = {
	    displayName: 'Download Hotels Data',
	    fileNameSuffix: 'Hotels.xlsx',
	    endPointController: 'Hotels'
	  };
	
	  vm.fileUploadState = { success: null, error: null, uploading: null };
	  vm.isBulkChangeAdmin = authService.getIsBulkChangeAdmin();
	
	  vm.showDisabledHotels = false;
	  vm.updateHotelsList = updateHotelsList;
	
	  vm.getHotels = getHotels;
	  vm.refreshIATA = refreshIATA;
	  vm.searchByIata = searchByIata;
	  vm.searchByHotelName = searchByHotelName;
	  vm.searchByHotelId = searchByHotelId;
	  vm.searchByHotelTags = searchByHotelTags;
	
	  vm.showEditModal = showEditModal;
	  vm.editHotel = editHotel;
	  vm.addIdentifier = addIdentifier;
	  vm.removeIdentifier = removeIdentifier;
	  vm.upload = upload;
	
	  vm.currentHotelSource = null;
	  vm.editHotelIdentifiersHasError = false;
	  vm.editHotelErrorMessage = null;
	  vm.changeTab = changeTab;
	  vm.updatePage = updatePage;
	
	  function updateHotelsList() {
	    var resetPage = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
	    if (resetPage) {
	      vm.page = 1;
	    }
	
	    switch (vm.tab) {
	      case 'iata':
	        return vm.searchByIata();
	      case 'name':
	        return vm.searchByHotelName();
	      case 'id':
	        return vm.searchByHotelId();
	      case 'tags':
	        return vm.searchByHotelTags();
	      default:
	        return vm.getHotels();
	    }
	  }
	
	  function showEditModal(hotel) {
	    if (!hotel.showEditModal) {
	      vm.currentHotelSource = hotel;
	      vm.currentHotel = angular.copy(hotel);
	      hotel.showEditModal = true;
	    } else {
	      vm.currentHotelSource = null;
	      vm.currentHotel = null;
	      hotel.showEditModal = false;
	    }
	
	    vm.editHotelErrorMessage = null;
	    setBodyScrollLock();
	  }
	
	  function setBodyScrollLock() {
	    var hasOpenModal = (vm.hotels || []).some(function (hotel) {
	      return hotel.showEditModal;
	    });
	    $document[0].body.classList.toggle('lba-modal-open', hasOpenModal);
	  }
	
	  function buildHotelsQuery(filterQuery) {
	    var skip = (vm.page - 1) * vm.pageSize;
	    var filters = [];
	
	    if (!vm.showDisabledHotels) {
	      filters.push('IsDeleted+eq+(false)');
	    } else {
	      filters.push('(IsDeleted+eq+(true)+or+IsDeleted+eq+(false))');
	    }
	
	    if (filterQuery) {
	      filters.push(filterQuery);
	    }
	
	    var filterPart = filters.length ? '$filter=' + filters.join('+and+') + '&' : '';
	
	    // Request one extra row so we know whether a next page exists.
	    return 'Hotels?' + filterPart + '$orderby=Name+asc&$top=' + (vm.pageSize + 1) + '&$skip=' + skip;
	  }
	
	  function getPagedHotels(filterQuery, type) {
	    return getData(buildHotelsQuery(filterQuery), type).then(function (data) {
	      if (!data) {
	        return;
	      }
	
	      vm.loading = false;
	
	      vm.hasNextPage = data.length > vm.pageSize;
	      vm.hotels = data.slice(0, vm.pageSize);
	    });
	  }
	
	  function getHotels() {
	    return getPagedHotels(null, 'Hotels list');
	  }
	
	  function searchByIata() {
	    if (!vm.IATA || !vm.IATA.Iata) {
	      return getHotels();
	    }
	
	    return getPagedHotels(getStringContainsQueryParameter('AirportCode', vm.IATA.Iata), 'Hotel by IATA search');
	  }
	
	  function refreshIATA(searchText) {
	    if (searchText.length > 2) {
	      var query = 'Airports?$filter=IsDeleted+eq+(false)+and+' + ('(' + getStringContainsQueryParameter('Iata', searchText)) + ('+or+' + getStringContainsQueryParameter('Name', searchText)) + ('+or+' + getStringContainsQueryParameter('City', searchText) + ')');
	
	      getData(query, "IATA search").then(function (data) {
	        if (data) {
	          vm.resultsIATA = data;
	        }
	      });
	    }
	  }
	
	  function searchByHotelName() {
	    if (!vm.hotelNameSearchText || vm.hotelNameSearchText.length <= 2) {
	      return getHotels();
	    }
	
	    return getPagedHotels(getStringContainsQueryParameter('Name', vm.hotelNameSearchText), 'Hotel Name search');
	  }
	
	  function searchByHotelId() {
	    if (!vm.hotelIdSearchText) {
	      return getHotels();
	    }
	
	    return getPagedHotels(getObjectListContainsExactValueQueryParameter('Identifiers', vm.hotelIdSearchText), 'Hotel Id search');
	  }
	
	  function searchByHotelTags() {
	    if (!vm.hotelTagsSearch || vm.hotelTagsSearch.length === 0) {
	      return getHotels();
	    }
	
	    var filterQuery = '';
	    for (var i = 0; i < vm.hotelTagsSearch.length; i++) {
	      if (i != 0) {
	        filterQuery += '+and+';
	      }
	
	      filterQuery += '' + getListContainsExactValueQueryParameter('Tags', vm.hotelTagsSearch[i]);
	    }
	
	    var query = 'Hotels?$filter=' + (vm.showDisabledHotels ? "(IsDeleted+eq+(true)+or+IsDeleted+eq+(false))+and+" : "IsDeleted+eq+(false)+and+") + filterQuery;
	
	    getData(query, "Hotel Id search").then(function (data) {
	      if (data) {
	        vm.hotels = data;
	        vm.page = 1;
	        vm.numberOfPages = getNumberOfPages();
	      }
	    });
	
	    return getPagedHotels(filterQuery, 'Hotel tags search');
	  }
	
	  function getData(query, type) {
	    var deferred = $q.defer();
	    vm.loading = true;
	    dataService.get(query).then(function (data) {
	      if (!data) {
	        throw new Error('Empty response or no response returned.');
	      }
	
	      deferred.resolve(data);
	    })['catch'](function (error) {
	      console.log(type + ' failed: ', error);
	      vm.loading = false;
	      $rootScope.$broadcast('lbaLoader:loaderState', { state: false, text: '' });
	      deferred.resolve(null);
	    });
	
	    return deferred.promise;
	  }
	
	  function updateData(query, type, hotel) {
	    var deferred = $q.defer();
	    dataService.patch("Hotels", hotel, hotel.Id, true).then(function (data) {
	      deferred.resolve(data);
	    })['catch'](function (error) {
	      console.log(type + ' failed: ', error);
	      vm.loading = false;
	      deferred.reject(error);
	    });
	
	    return deferred.promise;
	  }
	
	  function editHotel(form, hotel) {
	    clearErrors(form);
	
	    var payload = angular.copy(hotel);
	    delete payload.showEditModal;
	
	    updateData("Hotels", "Hotel update", payload).then(function (data) {
	      if (vm.currentHotelSource) {
	        angular.extend(vm.currentHotelSource, payload);
	        vm.currentHotelSource.showEditModal = false;
	      }
	
	      vm.currentHotelSource = null;
	      vm.currentHotel = null;
	      setBodyScrollLock();
	    })['catch'](function (error) {
	      if (error.error && error.error.message) {
	        vm.editHotelErrorMessage = error.error.message;
	        var errors = error.error.message.split(',');
	        errors.forEach(function (err) {
	          if (err.includes('Description')) {
	            setFieldServerError(form, 'editHotelDescription', err);
	          } else if (err.includes('Name')) {
	            setFieldServerError(form, 'editHotelName', err);
	          } else if (err.includes('Address')) {
	            setFieldServerError(form, 'editHotelAddress', err);
	          } else if (err.includes('City')) {
	            setFieldServerError(form, 'editHotelCity', err);
	          } else if (err.includes('State')) {
	            setFieldServerError(form, 'editHotelState', err);
	          } else if (err.includes('PostalCode')) {
	            setFieldServerError(form, 'editHotelPostalCode', err);
	          } else if (err.includes('CountryCode')) {
	            setFieldServerError(form, 'editHotelCountryCode', err);
	          } else if (err.includes('AirportCode')) {
	            setFieldServerError(form, 'editHotelAirportCode', err);
	          } else if (err.includes('Latitude')) {
	            setFieldServerError(form, 'editHotelLatitude', err);
	          } else if (err.includes('Longitude')) {
	            setFieldServerError(form, 'editHotelLongitude', err);
	          } else if (err.includes('Tag')) {
	            setFieldServerError(form, 'editHotelTags', err);
	          } else if (err.includes('Identifier')) {
	            setFieldServerError(form, 'editHotelIdentifiers', err, true);
	          }
	        });
	      } else {
	        vm.editHotelErrorMessage = 'Save failed. Please try again.';
	      }
	    });
	  }
	
	  function clearErrors(form) {
	    vm.editHotelErrorMessage = null;
	    vm.editHotelIdentifiersHasError = false;
	
	    ['editHotelDescription', 'editHotelName', 'editHotelAddress', 'editHotelCity', 'editHotelState', 'editHotelPostalCode', 'editHotelCountryCode', 'editHotelAirportCode', 'editHotelLatitude', 'editHotelLongitude', 'editHotelTags', 'editHotelIdentifiers'].forEach(function (fieldName) {
	      var formController = form[fieldName];
	      if (!formController || !formController.$error) {
	        return;
	      }
	
	      Object.keys(formController.$error).forEach(function (errorKey) {
	        formController.$setValidity(errorKey, true);
	      });
	    });
	  }
	
	  function setFieldServerError(form, fieldName, errorKey) {
	    var isTable = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
	    if (!isTable) {
	      var formController = form[fieldName];
	      if (!formController) {
	        return;
	      }
	
	      formController.$setValidity(errorKey, false);
	      formController.$setTouched();
	    } else {
	      vm.editHotelIdentifiersHasError = true;
	    }
	  }
	
	  function addIdentifier() {
	    if (!vm.currentHotel.Identifiers) {
	      vm.currentHotel.Identifiers = [];
	    }
	    vm.currentHotel.Identifiers.push({ Provider: '', Type: '', Value: '' });
	  }
	
	  function removeIdentifier(index) {
	    vm.currentHotel.Identifiers.splice(index, 1);
	  }
	
	  function upload(file) {
	    vm.fileUploadState.uploading = true;
	
	    var fileName = '';
	    var fileNameDate = new Date();
	
	    fileName = dateTimeString(fileNameDate.getFullYear());
	    fileName += dateTimeString(fileNameDate.getMonth() + 1);
	    fileName += dateTimeString(fileNameDate.getDate()) + '_';
	    fileName += dateTimeString(fileNameDate.getHours());
	    fileName += dateTimeString(fileNameDate.getMinutes());
	    fileName += dateTimeString(fileNameDate.getSeconds()) + '_' + file.name.substr(0, file.name.lastIndexOf('.'));
	    fileName = fileName.replace(/[^\w\s _]/g, '');
	
	    Upload.upload({
	      url: endPointUrl + '/api/Upload/HotelFileUpload?filename=' + fileName,
	      data: { file: file }
	    }).then(function (resp) {
	      console.log('SUCCESS resp: ', resp);
	      vm.fileUploadState = { success: true, error: null, uploading: false };
	    }, function (resp) {
	      console.log('ERROR resp: ', resp);
	      vm.fileUploadState = { success: null, error: true, uploading: false };
	    }, function (evt) {
	      console.log('evt: ', evt);
	    });
	  }
	
	  function changeTab(tabName) {
	    vm.tab = tabName;
	    updatePage(1);
	  }
	
	  function updatePage(index) {
	    if (index <= 0 || vm.loading) {
	      return false;
	    }
	
	    if (index > vm.page && !vm.hasNextPage) {
	      return false;
	    }
	
	    vm.page = index;
	    return vm.updateHotelsList(false);
	  }
	
	  //#region Helper Functions
	
	  // TODO: Need to be able to handle quotes. Currently does not work with '.
	  function getStringContainsQueryParameter(field, value) {
	    // The below does not work.
	    //    return `contains(tolower(${field}), tolower('${encodeURIComponent(value.replace(/'/g, "''"))}'))`;
	    // The below does not work either.
	    var odataEscaped = getODATAEscapedValue(value);
	    return encodeURIComponent('contains(tolower(' + field + '), tolower(\'' + odataEscaped + '\'))');
	  }
	
	  // TODO: Need to be able to handle quotes. Currently does not work with '.
	  function getObjectListContainsExactValueQueryParameter(field, value) {
	    var odataEscaped = getODATAEscapedValue(value);
	    return encodeURIComponent(field + '/any(i: tolower(i/Value) eq tolower(\'' + odataEscaped + '\'))');
	  }
	
	  // TODO: Need to be able to handle quotes. Currently does not work with '.
	  function getListContainsExactValueQueryParameter(field, value) {
	    var odataEscaped = getODATAEscapedValue(value);
	    return encodeURIComponent(field + '/any(i: tolower(i) eq tolower(\'' + odataEscaped + '\'))');
	  }
	
	  function getODATAEscapedValue(value) {
	    return value.replace(/'/g, "''");
	  }
	
	  function getNumberOfPages() {
	    if (vm.hotels) {
	      return Math.ceil(vm.hotels.length / vm.pageSize);
	    }
	
	    return 1;
	  }
	
	  function convert(str) {
	    return str.replace(/(?:\r\n|\r|\n)/g, '<br />');
	  }
	
	  function getNumber(num) {
	    return new Array(num);
	  }
	
	  function dateTimeString(int) {
	    if (String(int).length === 1) return '0' + int;
	
	    return String(int);
	  }
	
	  //#endregion
	
	  vm.getHotels();
	};
	
	lbaHotelCtrl.$inject = $inject;
	
	exports['default'] = lbaHotelCtrl;
	module.exports = exports['default'];

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(263);
	
	var $inject = [];
	var lbaHotel = function lbaHotel() {
	  return {
	    restrict: 'A',
	    scope: {},
	    bindToController: true,
	    controller: 'lbaHotelCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(265)
	  };
	};
	
	lbaHotel.$inject = $inject;
	
	exports['default'] = lbaHotel;
	module.exports = exports['default'];

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(264);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaHotel.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaHotel.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".lbaHotel{border-bottom:1px solid #e8e8e8;margin:0 0 1rem;padding:0 0 1rem}body.lba-modal-open{overflow:hidden}.lbaHotel_link:hover{cursor:pointer}.lbaHotel_link:hover .lbaHotel_link_info_name{text-decoration:underline}.lbaHotel_editModal{display:block}.lbaHotel_image{display:inline-block;width:200px;border:1px solid #e8e8e8;margin:0 1rem 1rem 0;padding:1rem;vertical-align:top}.lbaHotel_image img{width:75pt}.lbaHotel_flex{display:flex;justify-content:space-between}.lbaHotel_flex .lbaHotel_column{display:inline-block;width:49%;vertical-align:top}.lbaHotel_flex .lbaHotel_column p{margin:0 0 .1rem}.lbaHotel_link_info{vertical-align:top;display:inline-block;width:72rem}.lbaHotel_link_info .lbaHotel_provider_col{width:23rem}.lbaHotel_link_info_name{margin:0 0 .5rem}.lbaHotel_link_info_name h3{display:inline-block;font-weight:600;font-size:2rem;color:#3a85bf;margin:0}.lbaHotel_tags{margin:0 0 .5rem}.lbaHotel_editModal{display:flex;align-items:center;justify-content:center;position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:1050;padding:30px 15px}.lbaHotel_editModal .modal-dialog{position:relative;z-index:1;max-height:calc(100vh - 60px);display:flex;flex-direction:column;margin:0 auto}.lbaHotel_editModal .modal-content{display:flex;flex-direction:column;max-height:calc(100vh - 60px);overflow:hidden}.lbaHotel_editModal .modal-body{overflow-y:auto;flex:1}.lbaHotel_identifiersTable td,.lbaHotel_identifiersTable th{vertical-align:middle}.lbaHotel_identifiersTable--error{border:1px solid red}.lbaHotel_identifiers_deleteCol{width:50px;text-align:center}.hotelDisabled{color:red;font-size:1.2rem;text-transform:uppercase;font-weight:800}.hotelDisabled:hover{text-decoration:none}.editHotelButton{position:absolute;top:7.5rem;right:2rem;z-index:100}.editHotelButton span{margin:0 .5rem 0 0}.ng-invalid.ng-touched{border:1px solid red}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaHotel/src/components/lbaHotel/lbaHotel.scss"],"names":[],"mappings":"AAAA,UACI,gCACA,gBACA,gBAAiB,CACpB,oBAGG,eAAgB,CACnB,qBAGG,cAAe,CADnB,8CAIQ,yBAA0B,CAC7B,oBAID,aAAc,CACjB,gBAGG,qBACA,YACA,yBACA,qBACA,aACA,kBAAmB,CANvB,oBASQ,UAAY,CACf,eAID,aACA,6BAA8B,CAFlC,gCAKQ,qBACA,UACA,kBAAmB,CAP3B,kCAUY,gBAAiB,CACpB,oBAKL,mBACA,qBACA,WAAY,CAHhB,2CAMQ,WAAY,CACf,yBAID,gBAAoB,CADxB,4BAIQ,qBACA,gBACA,eACA,cACA,QAAS,CACZ,eAID,gBAAoB,CACvB,oBAGG,aACA,mBACA,uBACA,eACA,QACA,0BACA,aACA,iBAAkB,CACrB,kCAGG,kBACA,UACA,8BACA,aACA,sBACA,aAAc,CACjB,mCAGG,aACA,sBACA,8BACA,eAAgB,CACnB,gCAGG,gBACA,MAAO,CACV,4DAIO,qBAAsB,CACzB,kCAID,oBAAqB,CACxB,gCAGG,WACA,iBAAkB,CACrB,eAGG,UACA,iBACA,yBACA,eAAgB,CAJpB,qBAOQ,oBAAqB,CACxB,iBAID,kBACA,WACA,WACA,WAAY,CAJhB,sBAOQ,kBAAmB,CACtB,uBAID,oBAAqB,CACxB","file":"lbaHotel.scss","sourcesContent":[".lbaHotel {\r\n    border-bottom: 1px solid #E8E8E8;\r\n    margin: 0 0 1rem;\r\n    padding: 0 0 1rem;\r\n}\r\n\r\nbody.lba-modal-open {\r\n    overflow: hidden;\r\n}\r\n\r\n.lbaHotel_link:hover {\r\n    cursor: pointer;\r\n\r\n    .lbaHotel_link_info_name {\r\n        text-decoration: underline;\r\n    }\r\n}\r\n\r\n.lbaHotel_editModal {\r\n    display: block;\r\n}\r\n\r\n.lbaHotel_image {\r\n    display: inline-block;\r\n    width: 200px;\r\n    border: 1px solid #E8E8E8;\r\n    margin: 0 1rem 1rem 0;\r\n    padding: 1rem;\r\n    vertical-align: top;\r\n\r\n    img {\r\n        width: 100px;\r\n    }\r\n}\r\n\r\n.lbaHotel_flex {\r\n    display: flex;\r\n    justify-content: space-between;\r\n\r\n    .lbaHotel_column {\r\n        display: inline-block;\r\n        width: 49%;\r\n        vertical-align: top;\r\n\r\n        p {\r\n            margin: 0 0 .1rem;\r\n        }\r\n    }\r\n}\r\n\r\n.lbaHotel_link_info {\r\n    vertical-align: top;\r\n    display: inline-block;\r\n    width: 72rem;\r\n\r\n    .lbaHotel_provider_col {\r\n        width: 23rem;\r\n    }\r\n}\r\n\r\n.lbaHotel_link_info_name {\r\n    margin: 0 0 0.5rem 0;\r\n\r\n    h3 {\r\n        display: inline-block;\r\n        font-weight: 600;\r\n        font-size: 2rem;\r\n        color: #3a85bf;\r\n        margin: 0;\r\n    }\r\n}\r\n\r\n.lbaHotel_tags {\r\n    margin: 0 0 0.5rem 0;\r\n}\r\n\r\n.lbaHotel_editModal {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(0, 0, 0, 0.6);\r\n    z-index: 1050;\r\n    padding: 30px 15px;\r\n}\r\n\r\n.lbaHotel_editModal .modal-dialog {\r\n    position: relative;\r\n    z-index: 1;\r\n    max-height: calc(100vh - 60px);\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin: 0 auto;\r\n}\r\n\r\n.lbaHotel_editModal .modal-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    max-height: calc(100vh - 60px);\r\n    overflow: hidden;\r\n}\r\n\r\n.lbaHotel_editModal .modal-body {\r\n    overflow-y: auto;\r\n    flex: 1;\r\n}\r\n\r\n.lbaHotel_identifiersTable {\r\n    td, th {\r\n        vertical-align: middle;\r\n    }\r\n}\r\n\r\n.lbaHotel_identifiersTable--error {\r\n    border: 1px solid red;\r\n}\r\n\r\n.lbaHotel_identifiers_deleteCol {\r\n    width: 50px;\r\n    text-align: center;\r\n}\r\n\r\n.hotelDisabled {\r\n    color: red;\r\n    font-size: 1.2rem;\r\n    text-transform: uppercase;\r\n    font-weight: 800;\r\n\r\n    &:hover {\r\n        text-decoration: none;\r\n    }\r\n}\r\n\r\n.editHotelButton {\r\n    position: absolute;\r\n    top: 7.5rem;\r\n    right: 2rem;\r\n    z-index: 100;\r\n\r\n    span {\r\n        margin: 0 .5rem 0 0;\r\n    }\r\n}\r\n\r\n.ng-invalid.ng-touched {\r\n    border: 1px solid red;\r\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 265 */
/***/ function(module, exports) {

	var v1="<ul class=\"nav nav-tabs\"> <li ng-class=\"{ active: vm.tab === 'iata' }\" ng-click=\"vm.changeTab('iata')\"><a href=\"\">IATA Search</a></li> <li ng-class=\"{ active: vm.tab === 'name' }\" ng-click=\"vm.changeTab('name')\"><a href=\"\">Hotel Name Search</a></li> <li ng-class=\"{ active: vm.tab === 'id' }\" ng-click=\"vm.changeTab('id')\"><a href=\"\">Hotel External ID Search</a></li> <li ng-class=\"{ active: vm.tab === 'tags' }\" ng-click=\"vm.changeTab('tags')\"><a href=\"\">Hotel Tags</a></li> <li ng-class=\"{ active: vm.tab === 'import' }\" ng-click=\"vm.changeTab('import')\" ng-if=\"vm.isBulkChangeAdmin\"><a href=\"\">Hotel Import</a></li> </ul> <div class=\"checkbox\" ng-if=\"vm.tab != 'import'\"> <label for=\"ShowDisabledHotels\"> <input type=\"checkbox\" id=\"ShowDisabledHotels\" name=\"ShowDisabledHotels\" ng-model=\"vm.showDisabledHotels\" ng-change=\"vm.updateHotelsList()\">\nShow disabled hotels </label> </div> <div class=\"form-group\" ng-if=\"vm.tab === 'iata'\"> <ui-select ng-model=\"vm.IATA\" name=\"IATA\" id=\"IATA\" on-select=\"vm.searchByIata()\"> <ui-select-match placeholder=\"Search by IATA\" class=\"ui-select-match\"> {{ $select.selected.Name }} - IATA: {{ $select.selected.Iata }} </ui-select-match> <ui-select-choices repeat=\"item in vm.resultsIATA\" refresh=\"vm.refreshIATA($select.search)\" refresh-delay=\"500\" minimum-input-length=\"3\"> {{ item.Name }} - IATA: {{ item.Iata }} </ui-select-choices> </ui-select> </div> <div class=\"form-group\" ng-if=\"vm.tab === 'name'\"> <input type=\"text\" class=\"form-control\" placeholder=\"Search by hotel name\" ng-model=\"vm.hotelNameSearchText\" min=\"3\" ng-minlength=\"3\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.searchByHotelName()\"> </div> <div class=\"form-group\" ng-if=\"vm.tab === 'id'\"> <input type=\"text\" class=\"form-control\" placeholder=\"Search by hotel ID\" ng-model=\"vm.hotelIdSearchText\" min=\"3\" ng-minlength=\"3\" ng-model-options=\"{ debounce: 500 }\" ng-change=\"vm.searchByHotelId()\"> </div> <div class=\"form-group\" ng-if=\"vm.tab === 'tags'\"> <ui-select multiple=\"multiple\" tagging tagging-label=\"false\" ng-model=\"vm.hotelTagsSearch\" name=\"hotelTags\" on-select=\"vm.searchByHotelTags()\" on-remove=\"vm.searchByHotelTags()\"> <ui-select-match placeholder=\"Search by tags\" class=\"ui-select-match\"> {{ $item }} </ui-select-match> <ui-select-choices repeat=\"tag in vm.hotelTags | filter:$select.search\"> {{ tag }} </ui-select-choices> </ui-select> </div> <div ng-if=\"vm.tab === 'import' && vm.isBulkChangeAdmin\"> <div lba-file-downloader settings=\"vm.hotelDownloadSettings\"></div> <div class=\"form-group\"> <div id=\"upload\" class=\"btn btn-default\" ngf-select=\"vm.upload($file)\"><i class=\"fa fa-cloud-upload\"></i> Select & upload file (excel/csv)</div> </div> <p ng-if=\"vm.fileUploadState.uploading\"><i class=\"fa fa-spinner fa-spin\"></i> Uploading file...</p> <div ng-if=\"vm.fileUploadState.success\" class=\"alert alert-success\" role=\"alert\"><strong>Success!</strong> The file has been uploaded.</div> <div ng-if=\"vm.fileUploadState.error\" class=\"alert alert-danger\" role=\"alert\"><strong>Error!</strong> There was a problem uploading the file.</div> </div> <div ng-if=\"vm.tab !== 'import'\"> <div class=\"page-header\"> <h3>Hotel results\n<small ng-if=\"vm.IATA && vm.tab === 'iata'\">for {{ vm.IATA.Name }} ({{vm.IATA.Iata}})</small> </h3> </div> <nav ng-hide=\"vm.loading\"> <ul class=\"pagination\"> <li ng-class=\"{ disabled: vm.page <= 1 }\"> <a ng-click=\"vm.page > 1 && vm.updatePage(vm.page - 1)\"> <span>&laquo;</span> </a> </li> <li class=\"active\"> <a>{{ vm.page }}</a> </li> <li ng-class=\"{ disabled: !vm.hasNextPage }\"> <a ng-click=\"vm.hasNextPage && vm.updatePage(vm.page + 1)\"> <span>&raquo;</span> </a> </li> </ul> </nav> <div ng-show=\"vm.loading\"> Searching\n<span ng-if=\"vm.filtering\"> page {{ vm.page }} of {{ vm.numberOfPages }} </span> </div> <div ng-repeat=\"hotel in vm.hotels track by $index\" class=\"lbaHotel\"> <div ng-click=\"vm.showEditModal(hotel)\" class=\"lbaHotel_link\"> <div class=\"lbaHotel_link_info\"> <div class=\"lbaHotel_link_info_name\"> <h3>{{ hotel.Name }}</h3> <span ng-show=\"hotel.IsDeleted\" class=\"hotelDisabled\">(Hotel disabled)</span> </div> <div class=\"lbaHotel_tags\" ng-if=\"hotel.Tags && hotel.Tags.length\"> <i class=\"fa fa-tags\"></i> {{ hotel.Tags.join(', ') }} </div> <div> <p><strong>Id:</strong> {{ hotel.Id }}</p> <p><strong>Description:</strong> {{ hotel.Description }}</p> </div> <div class=\"lbaHotel_flex\"> <div class=\"lbaHotel_column\"> <p><strong>City:</strong> {{ hotel.City }}</p> <p><strong>Address:</strong> {{ hotel.Address }}</p> <p><strong>State:</strong> {{ hotel.State }}</p> <p><strong>CountryCode:</strong> {{ hotel.CountryCode }}</p> </div> <div class=\"lbaHotel_column\"> <p><strong>Postal Code:</strong> {{ hotel.PostalCode }}</p> <p><strong>Latitude:</strong> {{ hotel.Latitude }}</p> <p><strong>Longitude:</strong> {{ hotel.Longitude }}</p> <p><strong>Airport Code:</strong> {{ hotel.AirportCode }}</p> </div> </div> <div class=\"form-group\"> <label>Identifiers:</label> <table class=\"table table-condensed table-bordered lbaHotel_identifiersTable\" ng-if=\"hotel.Identifiers && hotel.Identifiers.length > 0\"> <thead> <tr> <th>Provider</th> <th>Type</th> <th>Value</th> </tr> </thead> <tbody> <tr ng-repeat=\"identifier in hotel.Identifiers track by $index\"> <td>{{ identifier.Provider || '-' }}</td> <td>{{ identifier.Type || '-' }}</td> <td>{{ identifier.Value || '-' }}</td> </tr> </tbody> </table> <p ng-if=\"!hotel.Identifiers || hotel.Identifiers.length === 0\">No identifiers</p> </div> </div> </div> <div ng-if=\"hotel.showEditModal\" class=\"modal lbaHotel_editModal\"> <div class=\"modal-dialog modal-lg\" role=\"document\"> <form class=\"modal-content\" name=\"editHotelForm\" ng-submit=\"vm.editHotel(editHotelForm, vm.currentHotel)\" novalidate> <div class=\"modal-header\"> <button type=\"button\" class=\"close\" ng-click=\"vm.showEditModal(hotel)\"> <span aria-hidden=\"true\">&times;</span> </button> <h4 class=\"modal-title\">{{ hotel.Name }} <span ng-show=\"hotel.IsDeleted\" class=\"hotelDisabled\">(Hotel disabled)</span> </h4> </div> <div class=\"modal-body\"> <div class=\"alert alert-danger\" role=\"alert\" ng-if=\"vm.editHotelErrorMessage\"> <i class=\"fa fa-exclamation-circle\" aria-hidden=\"true\"></i>\n<span class=\"sr-only\">Error:</span>\n{{ vm.editHotelErrorMessage }} </div> <label for=\"IsDeleted\"> <input type=\"checkbox\" id=\"IsDeleted\" name=\"IsDeleted\" ng-model=\"vm.currentHotel.IsDeleted\">\nDisabled </label> <div class=\"form-group\"> <label for=\"editModalId\">Id</label> <input type=\"text\" class=\"form-control\" id=\"editModalId\" name=\"editModalId\" placeholder=\"Id\" ng-model=\"vm.currentHotel.Id\" disabled=\"disabled\"> </div> <div class=\"form-group\"> <label for=\"editHotelName\">Name</label> <input type=\"text\" class=\"form-control\" id=\"editHotelName\" name=\"editHotelName\" placeholder=\"Name\" ng-model=\"vm.currentHotel.Name\"> </div> <div class=\"form-group\"> <label for=\"editHotelDescription\">Description</label> <input type=\"text\" class=\"form-control\" id=\"editHotelDescription\" name=\"editHotelDescription\" placeholder=\"Description\" ng-model=\"vm.currentHotel.Description\"> </div> <div class=\"form-group\"> <label for=\"editHotelAddress\">Address</label> <input type=\"text\" class=\"form-control\" id=\"editHotelAddress\" name=\"editHotelAddress\" placeholder=\"Address\" ng-model=\"vm.currentHotel.Address\"> </div> <div class=\"lbaHotel_flex\"> <div class=\"form-group lbaHotel_column\"> <label for=\"editHotelCity\">City</label> <input type=\"text\" class=\"form-control\" id=\"editHotelCity\" name=\"editHotelCity\" placeholder=\"City\" ng-model=\"vm.currentHotel.City\"> </div> <div class=\"form-group lbaHotel_column\"> <label for=\"editHotelState\">State</label> <input type=\"text\" class=\"form-control\" id=\"editHotelState\" name=\"editHotelState\" placeholder=\"State\" ng-model=\"vm.currentHotel.State\"> </div> </div> <div class=\"lbaHotel_flex\"> <div class=\"form-group lbaHotel_column\"> <label for=\"editHotelPostalCode\">Postal Code</label> <input type=\"text\" class=\"form-control\" id=\"editHotelPostalCode\" name=\"editHotelPostalCode\" placeholder=\"Postal Code\" ng-model=\"vm.currentHotel.PostalCode\"> </div> <div class=\"form-group lbaHotel_column\"> <label for=\"editHotelCountryCode\">Country Code</label> <input type=\"text\" class=\"form-control\" id=\"editHotelCountryCode\" name=\"editHotelCountryCode\" placeholder=\"Country Code\" ng-model=\"vm.currentHotel.CountryCode\"> </div> </div> <div class=\"lbaHotel_flex\"> <div class=\"form-group lbaHotel_column\"> <label for=\"editHotelLatitude\">Latitude</label> <input type=\"text\" class=\"form-control\" id=\"editHotelLatitude\" name=\"editHotelLatitude\" placeholder=\"Latitude\" ng-model=\"vm.currentHotel.Latitude\"> </div> <div class=\"form-group lbaHotel_column\"> <label for=\"editHotelLongitude\">Longitude</label> <input type=\"text\" class=\"form-control\" id=\"editHotelLongitude\" name=\"editHotelLongitude\" placeholder=\"Longitude\" ng-model=\"vm.currentHotel.Longitude\"> </div> </div> <div class=\"form-group lbaHotel_column\"> <label for=\"editHotelAirportCode\">Airport Code</label> <input type=\"text\" class=\"form-control\" id=\"editHotelAirportCode\" name=\"editHotelAirportCode\" placeholder=\"Airport Code\" ng-model=\"vm.currentHotel.AirportCode\"> </div> <div class=\"form-group\"> <label for=\"editHotelTags\">Tags</label> <ui-select multiple=\"multiple\" tagging tagging-label=\"false\" ng-model=\"vm.currentHotel.Tags\" id=\"editHotelTags\" name=\"editHotelTags\"> <ui-select-match placeholder=\"Search by tags\" class=\"ui-select-match\"> {{ $item }} </ui-select-match> <ui-select-choices repeat=\"tag in vm.currentHotel.Tags | filter:$select.search\"> {{ tag }} </ui-select-choices> </ui-select> </div> <div class=\"form-group\"> <label for=\"editHotelIdentifiers\">Identifiers</label> <div ng-class=\"{ 'lbaHotel_identifiersTable--error': vm.editHotelIdentifiersHasError }\"> <table class=\"table table-condensed table-bordered\" id=\"editHotelIdentifiers\" name=\"editHotelIdentifiers\"> <thead> <tr> <th>Provider</th> <th>Type</th> <th>Value</th> <th></th> </tr> </thead> <tbody> <tr ng-repeat=\"identifier in vm.currentHotel.Identifiers track by $index\"> <td> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"identifier.Provider\" placeholder=\"Provider\"> </td> <td> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"identifier.Type\" placeholder=\"Type\"> </td> <td> <input type=\"text\" class=\"form-control input-sm\" ng-model=\"identifier.Value\" placeholder=\"Value\"> </td> <td class=\"lbaHotel_identifiers_deleteCol\"> <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-click=\"vm.removeIdentifier($index)\"> <i class=\"fa fa-trash\"></i> </button> </td> </tr> </tbody> </table> </div> <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.addIdentifier()\"> <i class=\"fa fa-plus\"></i> Add identifier </button> </div> </div> <div class=\"modal-footer\"> <div class=\"lbaModal_buttons\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.showEditModal(hotel)\">Cancel</button>\n<button type=\"submit\" class=\"btn btn-lightning\">Save</button> </div> </div> </form> </div> </div> </div> <nav ng-hide=\"vm.loading\"> <ul class=\"pagination\"> <li ng-class=\"{ disabled: vm.page <= 1 }\"> <a ng-click=\"vm.page > 1 && vm.updatePage(vm.page - 1)\"> <span>&laquo;</span> </a> </li> <li class=\"active\"> <a>{{ vm.page }}</a> </li> <li ng-class=\"{ disabled: !vm.hasNextPage }\"> <a ng-click=\"vm.hasNextPage && vm.updatePage(vm.page + 1)\"> <span>&raquo;</span> </a> </li> </ul> </nav> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaHotel.html", v1)}]);
	module.exports=v1;

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var lbaPointsOfInterest = angular.module('app.lbaPointsOfInterest', [__webpack_require__(267).name, __webpack_require__(273).name, __webpack_require__(276).name]);
	
	lbaPointsOfInterest.controller('lbaPointsOfInterestCtrl', __webpack_require__(287));
	lbaPointsOfInterest.directive('lbaPointsOfInterest', __webpack_require__(288));
	lbaPointsOfInterest.service('pointsOfInterestService', __webpack_require__(292));
	lbaPointsOfInterest.service('lbaLeafletMapService', __webpack_require__(293));
	
	exports['default'] = lbaPointsOfInterest;
	module.exports = exports['default'];

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(268);
	
	var lbaPointsOfInterestList = angular.module('app.lbaPointsOfInterestList', [__webpack_require__(270).name]);
	
	lbaPointsOfInterestList.component('lbaPointsOfInterestList', {
	  bindings: {
	    pointsOfInterest: '=',
	    newItem: '=',
	    editItem: '=',
	    activateItem: '='
	  },
	  controller: lbaPointsOfInterestListCtrl,
	  template: '\n    <div class="lbaPointsOfInterest_list_container">\n      <h3 class="lbaPointsOfInterest_heading">\n        Locations\n      </h3>\n\n      <div class="lbaPointsOfInterest_addNew">\n        <button ng-click="$ctrl.newItem()" class="btn btn-primary"><span class="fa fa-plus"></span>New</button>\n      </div>\n\n      <div class="lbaPointsOfInterest_filter" ng-show="$ctrl.pointsOfInterest.length > 1">\n        <input type="text" ng-model="$ctrl.pointsOfInterestFilter" class="lbaPointsOfInterest_filter_input form-control" placeholder="Filter locations">\n      </div>\n      <div class="lbaPointsOfInterest_scroller">\n        <ul class="lbaPointsOfInterest_list list-group">\n          <li ng-repeat="pointOfInterest in $ctrl.pointsOfInterest | filter : {Title : $ctrl.pointsOfInterestFilter}" class="lbaPointsOfInterest_listItem_container list-group-item" ng-class="{\'active\': pointOfInterest.active}">\n            <lba-point-of-interest-list-item\n               activate-item="$ctrl.activateItem"\n               point-of-interest="pointOfInterest"\n               edit-item="$ctrl.editItem">\n            </lba-point-of-interest-list-item>\n          </li>\n        </ul>\n      </div>\n    </div>\n  '
	});
	
	function lbaPointsOfInterestListCtrl() {
	  var $ctrl = this;
	}
	
	exports['default'] = lbaPointsOfInterestList;
	module.exports = exports['default'];

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(269);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaPointsOfInterestList.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaPointsOfInterestList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".lbaPointsOfInterest_addNew .fa{font-size:1.1em;margin-right:.25em}.lbaPointsOfInterest_list{margin:0;padding:0;position:relative}.lbaPointsOfInterest_list li{padding:0}.lbaPointsOfInterest_list li:hover{background:#efefef}.lbaPointsOfInterest_scroller{height:539px;overflow:auto;margin-top:3rem}.lbaPointsOfInterest_list_container{position:relative}.lbaPointsOfInterest_heading{margin-top:0}.lbaPointsOfInterest_filter{margin:3rem 0 0}.lbaPointsOfInterest_filter_input{width:100%}.lbaPointsOfInterest_addNew{font-size:1.2rem;position:absolute;top:0;right:0}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaPointsOfInterestList/src/components/lbaPointsOfInterestList/lbaPointsOfInterestList.scss","/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaPointsOfInterestList/src/components/lbaPointsOfInterest/_helpers.scss"],"names":[],"mappings":"AAsCA,gCCpCE,gBACA,kBAAmB,CDDrB,0BACE,SACA,UACA,iBAAkB,CAHpB,6BAMI,SAAU,CANd,mCASM,kBAAmB,CACpB,8BAKH,aACA,cACA,eAAgB,CACjB,oCAGC,iBAAkB,CACnB,6BAGC,YAAa,CACd,4BAGC,eAAgB,CACjB,kCAGC,UAAW,CACZ,4BAGC,iBACA,kBACA,MACA,OAAQ,CAKT","file":"lbaPointsOfInterestList.scss","sourcesContent":["@import '../lbaPointsOfInterest/helpers';\r\n\r\n.lbaPointsOfInterest_list{\r\n  margin: 0;\r\n  padding: 0;\r\n  position: relative;\r\n\r\n  li {\r\n    padding: 0;\r\n\r\n    &:hover {\r\n      background: #efefef;\r\n    }\r\n  }\r\n}\r\n\r\n.lbaPointsOfInterest_scroller {\r\n  height: 539px;\r\n  overflow: auto;\r\n  margin-top: 3rem;\r\n}\r\n\r\n.lbaPointsOfInterest_list_container {\r\n  position: relative;\r\n}\r\n\r\n.lbaPointsOfInterest_heading {\r\n  margin-top: 0;\r\n}\r\n\r\n.lbaPointsOfInterest_filter {\r\n  margin: 3rem 0 0;\r\n}\r\n\r\n.lbaPointsOfInterest_filter_input {\r\n  width: 100%;\r\n}\r\n\r\n.lbaPointsOfInterest_addNew {\r\n  font-size: 1.2rem;\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n\r\n  .fa {\r\n    @extend %buttonIcon;\r\n  }\r\n}","\r\n%buttonIcon {\r\n  font-size: 1.1em;\r\n  margin-right: .25em;\r\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(271);
	
	var lbaPointOfInterestListItem = angular.module('app.lbaPointOfInterestListItem', []);
	
	lbaPointOfInterestListItem.component('lbaPointOfInterestListItem', {
	  bindings: {
	    pointOfInterest: '=',
	    editItem: '=',
	    activateItem: '='
	  },
	  controller: lbaPointOfInterestListItemCtrl,
	  template: '\n  <div class="lbaPointsOfInterest_listItem" ng-click="$ctrl.activateItem($ctrl.pointOfInterest)">\n      <h5 class="lbaPointsOfInterest_listItem_heading">{{ $ctrl.pointOfInterest.Title }}</h5>\n      <div class="lbaPointsOfInterest_moreInfo" ng-if="$ctrl.pointOfInterest.active">\n        <p class="lbaPointsOfInterest_listItem_description">{{ $ctrl.pointOfInterest.Description }}</p>\n        <p class="lbaPointsOfInterest_listItem_address">{{ $ctrl.pointOfInterest.Address }}</p>\n        <button class="lbaPointsOfInterest_listItem_edit" ng-click="$ctrl.editItem($ctrl.pointOfInterest)" title="Edit"><span class="fa fa-pencil-square-o"></span></button>\n      </div>\n  </div>\n  '
	});
	
	function lbaPointOfInterestListItemCtrl() {
	  var $ctrl = this;
	}
	
	exports['default'] = lbaPointOfInterestListItem;
	module.exports = exports['default'];

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(272);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaPointsOfInterestListItem.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaPointsOfInterestListItem.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".lbaPointsOfInterest_listItem_edit .fa{font-size:1.1em;margin-right:.25em}.lbaPointsOfInterest_listItem{padding:10px}.lbaPointsOfInterest_listItem_container.active{background:#eee}.lbaPointsOfInterest_listItem_container{position:relative;cursor:pointer}.lbaPointsOfInterest_listItem_edit{position:absolute;right:0;top:5px;font-size:1.3rem;background:transparent;border:0}.lbaPointsOfInterest_listItem_edit .fa{margin-right:0}.lbaPointsOfInterest_listItem_heading{margin:0;font-weight:700}.lbaPointsOfInterest_moreInfo{padding-top:15px;font-size:13px}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaPointsOfInterestListItem/src/components/lbaPointsOfInterestListItem/lbaPointsOfInterestListItem.scss","/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaPointsOfInterestListItem/src/components/lbaPointsOfInterest/_helpers.scss"],"names":[],"mappings":"AAkBA,uCChBE,gBACA,kBAAmB,CDDrB,8BACE,YAAmB,CACpB,+CAKG,eAAgB,CACjB,wCAID,kBACA,cAAe,CAChB,mCAGC,kBACA,QACA,QACA,iBACA,uBACA,QAAS,CANX,uCAUI,cAAe,CAChB,sCAID,SACA,eAAgB,CACjB,8BAGC,iBACA,cAAe,CAChB","file":"lbaPointsOfInterestListItem.scss","sourcesContent":["@import '../lbaPointsOfInterest/helpers';\r\n\r\n.lbaPointsOfInterest_listItem {\r\n  padding: 10px 10px ;\r\n}\r\n\r\n.lbaPointsOfInterest_listItem_container {\r\n\r\n  &.active {\r\n    background: #eee;\r\n  }\r\n}\r\n\r\n.lbaPointsOfInterest_listItem_container {\r\n  position: relative;\r\n  cursor: pointer;\r\n}\r\n\r\n.lbaPointsOfInterest_listItem_edit {\r\n  position: absolute;\r\n  right: 0;\r\n  top: 5px;\r\n  font-size: 1.3rem;\r\n  background: transparent;\r\n  border: 0;\r\n\r\n  .fa {\r\n    @extend %buttonIcon;\r\n    margin-right: 0;\r\n  }\r\n}\r\n\r\n.lbaPointsOfInterest_listItem_heading {\r\n  margin: 0;\r\n  font-weight: 700;\r\n}\r\n\r\n.lbaPointsOfInterest_moreInfo {\r\n  padding-top: 15px;\r\n  font-size: 13px;\r\n}","\r\n%buttonIcon {\r\n  font-size: 1.1em;\r\n  margin-right: .25em;\r\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(274);
	
	var lbaPointsOfInterestItemForm = angular.module('app.lbaPointsOfInterestItemForm', []);
	
	lbaPointsOfInterestItemForm.component('lbaPointsOfInterestItemForm', {
	  bindings: {
	    pointOfInterest: '=',
	    toggleDetail: '=',
	    saveItem: '=',
	    deleteItem: '='
	  },
	  controller: ['$scope', 'lbaLeafletMapService', lbaPointsOfInterestItemFormCtrl],
	  template: '\n    <div class="lbaPointsOfInterest_ItemForm">\n      <div class="lbaPointsOfInterest_ItemForm_header">\n        <h3 ng-if="!$ctrl.update">New</h3>\n        <h3 ng-if="$ctrl.update">Edit</h3>\n        <button class="lbaPointsOfInterest_ItemForm_back btn" ng-click="$ctrl.toggleDetail()"><span class="fa fa-chevron-left"></span></button>\n      </div>\n\n      <form>\n        <div class="form-group">\n          <label>Title</label>\n          <input type="text" ng-model="$ctrl.tempPointOfInterest.Title" placeholder="Name" class="form-control" >\n        </div>\n\n        <div class="form-group">\n          <label>Description</label>\n          <textarea ng-model="$ctrl.tempPointOfInterest.Description" placeholder="Description" class="form-control" ></textarea>\n        </div>\n\n        <div class="form-group">\n          <label>Address</label>\n          <textarea ng-model="$ctrl.tempPointOfInterest.Address" placeholder="Address" class="form-control" ng-change="$ctrl.clearErrors()" ></textarea>\n        </div>\n        <div class="form-group">\n          <div>\n            <button class="btn lbaPointsOfInterest_addPosition" ng-click="$ctrl.addPosition()" ng-disabled="$ctrl.searchingPosition"><span class="fa fa-thumb-tack"></span></button>\n            <label>Position</label>\n            <p class="error text-warning" ng-if="$ctrl.errors.position">{{$ctrl.errors.position}}</p>\n          </div>\n          <label>Longitude</label>\n          <input type="text" ng-model="$ctrl.tempPointOfInterest.Longitude" placeholder="Longitude" class="form-control" ng-class="{\'not-valid\': !$ctrl.isLongitudeValid && !$ctrl.searchingPosition}" ng-required="true">\n        </div>\n        <div class="form-group">\n        <label>Latitude</label>\n          <input type="text" ng-model="$ctrl.tempPointOfInterest.Latitude" placeholder="Latitude" class="form-control" ng-class="{\'not-valid\': !$ctrl.isLatitudeValid && !$ctrl.searchingPosition}" ng-required="true">\n        </div>\n        <div class="form-group">\n        <label>Sort Order (Descending Order)</label>\n          <input type="number" ng-model="$ctrl.tempPointOfInterest.SortOrder" placeholder="Enter sort order" class="form-control" ng-required="false">\n        </div>\n\n        <div class="form-group">\n          <p>\n            <button class="btn-primary btn lbaPointsOfInterest_saveItem" ng-click="$ctrl.savePointOfInterest()" ng-if="!$ctrl.update" ng-disabled="$ctrl.saving">Save</button>\n            <button class="btn-primary btn lbaPointsOfInterest_saveItem" ng-click="$ctrl.updatePointOfInterest()" ng-if="$ctrl.update" ng-disabled="$ctrl.saving">Update</button>\n          </p>\n        </div>\n        <div class="form-group">\n          <p>\n            <button class="btn-danger btn lbaPointsOfInterest_deleteItem" ng-click="$ctrl.deletePointOfInterest()" ng-if="$ctrl.update" ng-disabled="$ctrl.saving">Delete</button>\n          </p>\n          <p class="error text-warning">{{$ctrl.errors.delete}}</p>\n        </div>\n      </form>\n    </div>\n  '
	});
	
	function lbaPointsOfInterestItemFormCtrl($scope, lbaLeafletMapService) {
	  var longitudeErrorMessage = "Longitude must be between -180 and 180";
	  var latitudeErrorMessage = 'Latitude must be between -90 and 90';
	
	  var $ctrl = this;
	
	  $ctrl.tempPointOfInterest = {};
	  $ctrl.saving = false;
	  $ctrl.update = false;
	  $ctrl.errors = {};
	  $ctrl.isLongitudeValid = true;
	  $ctrl.isLatitudeValid = true;
	  $ctrl.searchingPosition = false;
	
	  if ($ctrl.pointOfInterest) {
	    $ctrl.update = true;
	    angular.copy($ctrl.pointOfInterest, $ctrl.tempPointOfInterest);
	  }
	
	  $ctrl.savePointOfInterest = savePointOfInterest;
	  $ctrl.deletePointOfInterest = deletePointOfInterest;
	  $ctrl.updatePointOfInterest = updatePointOfInterest;
	  $ctrl.addPosition = addPosition;
	  $ctrl.clearErrors = clearErrors;
	
	  function savePointOfInterest() {
	    if ($ctrl.isLongitudeValid && $ctrl.isLatitudeValid) {
	      $ctrl.saving = true;
	      $ctrl.saveItem($ctrl.tempPointOfInterest).then(function (result) {
	        $ctrl.saving = false;
	        $ctrl.toggleDetail();
	      });
	    } else {
	      $ctrl.errors.position = 'Please enter a valid position';
	    }
	  }
	
	  function updatePointOfInterest() {
	    if ($ctrl.isLongitudeValid && $ctrl.isLatitudeValid) {
	      $ctrl.saving = true;
	      $ctrl.saveItem($ctrl.tempPointOfInterest).then(function (result) {
	        $ctrl.toggleDetail();
	      })['catch'](function () {
	        $ctrl.errors['delete'] = 'Error updating item';
	      })['finally'](function () {
	        $ctrl.saving = false;
	      });
	    } else {
	      $ctrl.errors.position = 'Please enter a valid position';
	    }
	  }
	
	  function clearErrors() {
	    $ctrl.errors = {};
	  }
	
	  function deletePointOfInterest() {
	    $ctrl.saving = true;
	
	    $ctrl.deleteItem($ctrl.tempPointOfInterest.Id).then(function (result) {
	      $ctrl.toggleDetail();
	    })['catch'](function () {
	      $ctrl.errors['delete'] = 'Error deleting item';
	    })['finally'](function () {
	      $ctrl.saving = false;
	    });;
	  }
	
	  $scope.$watchCollection('$ctrl.tempPointOfInterest', function () {
	    // Don't show validation errors while searching for position
	    if ($ctrl.searchingPosition) {
	      return;
	    }
	
	    $ctrl.errors.position = "";
	    $ctrl.isLongitudeValid = $ctrl.tempPointOfInterest.Longitude <= 180 && $ctrl.tempPointOfInterest.Longitude >= -180;
	    $ctrl.isLatitudeValid = $ctrl.tempPointOfInterest.Latitude <= 90 && $ctrl.tempPointOfInterest.Latitude >= -90;
	
	    if (!$ctrl.isLongitudeValid) {
	      $ctrl.errors.position = getPositionMessage($ctrl.errors.position, longitudeErrorMessage);
	    }
	
	    if (!$ctrl.isLatitudeValid) {
	      $ctrl.errors.position = getPositionMessage($ctrl.errors.position, latitudeErrorMessage);
	    }
	  });
	
	  function addPosition() {
	    if ($ctrl.tempPointOfInterest.Address) {
	      $ctrl.searchingPosition = true;
	      $ctrl.errors.position = "";
	
	      lbaLeafletMapService.getPosByAddress($ctrl.tempPointOfInterest.Address).then(function (data) {
	        var resources = data.resourceSets[0].resources;
	        if (resources.length > 0) {
	          $ctrl.tempPointOfInterest.Longitude = resources[0].geocodePoints[0].coordinates[1];
	          $ctrl.tempPointOfInterest.Latitude = resources[0].geocodePoints[0].coordinates[0];
	        } else {
	          $ctrl.errors.position = 'problem recognising address';
	        }
	      })['catch'](function (data) {
	        $ctrl.errors.position = 'problem recognising address';
	      })['finally'](function () {
	        $ctrl.searchingPosition = false;
	      });
	    }
	  }
	
	  function getPositionMessage(existingMessage, message) {
	    return !!existingMessage ? existingMessage += ', ' + message : message;
	  }
	}
	
	exports['default'] = lbaPointsOfInterestItemForm;
	module.exports = exports['default'];

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(275);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaPointsOfInterestItemForm.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaPointsOfInterestItemForm.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".lbaPointsOfInterest_ItemForm_back .fa{font-size:1.1em;margin-right:.25em}.form-group{position:relative}.lbaPointsOfInterest_ItemForm_header{margin-bottom:2rem;position:relative;padding-top:5px}.lbaPointsOfInterest_ItemForm_header h3{margin-top:0}.lbaPointsOfInterest_ItemForm_back{position:absolute;right:0;top:0}.lbaPointsOfInterest_deleteItem,.lbaPointsOfInterest_saveItem{width:100%}.lbaPointsOfInterest_addPosition{position:absolute;right:0;width:21px;padding:0;height:21px;font-size:14px}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaPointsOfInterestItemForm/src/components/lbaPointsOfInterestItemForm/lbaPointsOfInterestItemForm.scss","/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaPointsOfInterestItemForm/src/components/lbaPointsOfInterest/_helpers.scss"],"names":[],"mappings":"AAgBA,uCCdE,gBACA,kBAAmB,CDDrB,YACE,iBAAkB,CACnB,qCAGC,mBACA,kBACA,eAAgB,CAHlB,wCAMI,YAAa,CACd,mCAID,kBACA,QACA,KAAM,CAKP,8DAIC,UAAW,CACZ,iCAGC,kBACA,QACA,WACA,UACA,YACA,cAAe,CAChB","file":"lbaPointsOfInterestItemForm.scss","sourcesContent":["@import '../lbaPointsOfInterest/helpers';\r\n\r\n.form-group {\r\n  position: relative;\r\n}\r\n\r\n.lbaPointsOfInterest_ItemForm_header {\r\n  margin-bottom: 2rem;\r\n  position: relative;\r\n  padding-top: 5px;\r\n\r\n  h3 {\r\n    margin-top: 0;\r\n  }\r\n}\r\n\r\n.lbaPointsOfInterest_ItemForm_back {\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n\r\n  .fa {\r\n    @extend %buttonIcon;\r\n  }\r\n}\r\n\r\n.lbaPointsOfInterest_saveItem,\r\n.lbaPointsOfInterest_deleteItem {\r\n  width: 100%;\r\n}\r\n\r\n.lbaPointsOfInterest_addPosition {\r\n  position: absolute;\r\n  right: 0;\r\n  width: 21px;\r\n  padding: 0;\r\n  height: 21px;\r\n  font-size: 14px;\r\n}","\r\n%buttonIcon {\r\n  font-size: 1.1em;\r\n  margin-right: .25em;\r\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaLeafletMap = angular.module('app.lbaLeafletMap', []);
	
	lbaLeafletMap.controller('lbaLeafletMapCtrl', __webpack_require__(277));
	lbaLeafletMap.directive('lbaLeafletMap', __webpack_require__(282));
	
	exports['default'] = lbaLeafletMap;
	module.exports = exports['default'];

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope', '$timeout', '$rootScope'];
	var bingAPIKey = 'AqkExqjquai0sfSevSrsEaOMOzaNLUqDL4xFwXBnjbRJYaLxM_gh2TlGV42cXl1R';
	__webpack_require__(278);
	__webpack_require__(279);
	
	var lbaLeafletMapCtrl = function lbaLeafletMapCtrl($scope, $timeout, $rootScope) {
	  var vm = this;
	  var mapInitialised = false;
	  vm.mapId = 'map' + $scope.$id;
	  vm.map = null;
	  vm.highlighted = null;
	
	  vm.addMarker = addMarker;
	  vm.centerMap = centerMap;
	  vm.refreshMap = refreshMap;
	  vm.highlightMarker = highlightMarker;
	  vm.removeHighlight = removeHighlight;
	
	  var defaultIcon = L.icon({
	    iconUrl: __webpack_require__(280),
	    iconSize: [20, 20],
	    iconAnchor: [10, 5]
	  });
	
	  var pinIcon = L.icon({
	    iconUrl: __webpack_require__(281),
	    iconSize: [16, 24],
	    iconAnchor: [8, 24]
	  });
	
	  $rootScope.$on('leaflet.refresh', vm.refreshMap);
	  $rootScope.$on('leaflet.highlight', vm.highlightMarker);
	  $rootScope.$on('leaflet.removeHighlight', vm.removeHighlight);
	
	  function highlightMarker(event, item) {
	    removeHighlight();
	    item.marker.activate();
	    vm.highlighted = item.marker;
	    centerMap(item);
	  }
	
	  function removeHighlight() {
	    if (vm.highlighted) vm.highlighted.deActivate();
	    vm.highlighted = null;
	  }
	
	  function init() {
	
	    var mapPos = [0, 0];
	    var zoomLevel = vm.zoomLevel || 14;
	
	    if (vm.mapCenter) {
	      mapPos = [vm.mapCenter.latitude, vm.mapCenter.longitude];
	    }
	
	    vm.map = L.map(vm.mapId).setView(mapPos, zoomLevel);
	
	    // Commented out for now until we figure out how to migrate from BING MAPS to AZURE MAPS.
	    // L.tileLayer.bing({
	    //   bingMapsKey: bingAPIKey,
	    //   imagerySet: 'Road'
	    // }).addTo(vm.map);
	
	    // Using OPENSTREETMAP instead of BING MAPS for now.
	    var osmUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
	    var osmAttribution = '© <a href="https://openstreetmap.org">OpenStreetMap</a> contributors';
	    var osm = new L.TileLayer(osmUrl, { attribution: osmAttribution });
	    vm.map.addLayer(osm);
	
	    vm.map.attributionControl.options.prefix = '';
	    mapInitialised = true;
	  }
	
	  function refreshMap() {
	    if (!mapInitialised) {
	      return;
	    }
	    if (vm.circle) vm.map.removeLayer(vm.circle);
	    if (vm.markers) vm.map.removeLayer(vm.markers);
	    if (vm.latLongPoint) vm.map.removeLayer(vm.latLongPoint);
	
	    $timeout(function () {
	      vm.markers = L.markerClusterGroup({
	        spiderfyOnMaxZoom: false,
	        showCoverageOnHover: false,
	        disableClusteringAtZoom: 17,
	        maxClusterRadius: 30
	      });
	      vm.locations.forEach(function (l, index) {
	        return addMarker(l);
	      });
	      vm.map.addLayer(vm.markers);
	      vm.centerMap();
	      addRadius(vm.includesRadius);
	    });
	  }
	
	  function addRadius(data) {
	    if (!data) {
	      return;
	    }
	    var pos = [data.lat, data.long];
	    vm.latLongPoint = L.marker(pos, { icon: defaultIcon }).addTo(vm.map);
	    vm.circle = L.circle(pos, vm.includesRadius).addTo(vm.map);
	
	    $timeout(function () {
	      vm.map.fitBounds(vm.circle.getBounds());
	    }, 1000);
	  }
	
	  function addMarker(l) {
	    var marker = createMarker(l);
	    vm.markers.addLayer(marker);
	  }
	
	  function centerMap(item) {
	
	    // leaflet and angular's digest might be causing the crash... $timeout to the rescue :)
	    $timeout(function () {
	      if (item) {
	        vm.map.setView([item.Latitude, item.Longitude], 25);
	      } else if (!vm.zoomLevel && !vm.bounds) {
	        var bounds = vm.markers.getBounds();
	        if (bounds._southWest) {
	          vm.map.fitBounds(vm.markers.getBounds());
	        }
	      } else if (vm.bounds) {
	        vm.map.fitBounds(vm.bounds);
	        vm.bounds = false;
	      }
	    }, 100);
	  }
	
	  $timeout(init);
	
	  function createMarker(l) {
	    var icon = pinIcon;
	    var pos = [l.Latitude, l.Longitude];
	    var markerContent = '<h3>' + (l.Title || l.Name) + '</h3>';
	    var marker = L.marker(pos, { icon: icon });
	
	    if (l.Description) {
	      markerContent += '<p>' + l.Description + '</p>';
	    }
	
	    markerContent += addressContent(l);
	
	    if (vm.markerOverride) {
	      if (l.Name) {
	        markerContent = '<h3>' + l.Name + '</h3>';
	        markerContent += addressContent(l);
	      } else {
	        markerContent = '<h3>' + vm.markerOverride.text + '</h3>';
	      }
	      if (vm.markerOverride.ctaText) {
	        markerContent = '<h3>' + vm.markerOverride.text + '</h3> <button class="btn btn-primary">' + vm.markerOverride.ctaText + '</button class="btn btn-primary">';
	      }
	    }
	
	    marker.activeIcon = L.divIcon({
	      className: 'my-div-icon',
	      iconAnchor: [158, 24],
	      iconSize: [0, 0],
	      html: '\n            <div class="marker-active">\n              <div class="icon marker-active_icon">\n              </div>\n              <div class="marker-active_content">\n               ' + markerContent + '\n              </div>\n            </div>\n          '
	    });
	
	    marker.activate = activate;
	    marker.deActivate = deActivate;
	
	    function addressContent(l) {
	      var content = '';
	
	      if (l.Address) {
	        content += '<p>';
	        content += '' + l.Address;
	
	        if (l.PostCode) {
	          content += ', ' + l.PostCode;
	        }
	
	        content += '</p>';
	      }
	
	      return content;
	    }
	
	    function activate() {
	      marker.originalZIndex = marker.zIndexOffset;
	      marker.setZIndexOffset(10000);
	      marker.setIcon(marker.activeIcon);
	    }
	
	    function deActivate() {
	      marker.setZIndexOffset(marker.originalZIndex);
	      marker.setIcon(icon);
	    }
	
	    function mouseout() {
	      if (!l.active) {
	        deActivate();
	        marker.off('mouseout', mouseout);
	        marker.on('mouseover', mouseover);
	      }
	    }
	
	    function mouseover() {
	      activate();
	      marker.off('mouseover', mouseover);
	      marker.on('mouseout', mouseout);
	    }
	
	    l.marker = marker;
	
	    marker.on('mouseover', mouseover);
	    marker.on('click', function () {
	      console.log('lbaLeafletMapCtrl.js line:143, click:');
	      vm.markerClick(l, true);
	    });
	
	    return marker;
	  }
	};
	
	lbaLeafletMapCtrl.$inject = $inject;
	
	exports['default'] = lbaLeafletMapCtrl;
	module.exports = exports['default'];

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	var require;var require;var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
	(function (global){
	var L = (typeof window !== "undefined" ? window['L'] : typeof global !== "undefined" ? global['L'] : null)
	var fetchJsonp = require('fetch-jsonp')
	var bboxIntersect = require('bbox-intersect')
	
	/**
	 * Converts tile xyz coordinates to Quadkey
	 * @param {Number} x
	 * @param {Number} y
	 * @param {Number} z
	 * @return {Number} Quadkey
	 */
	function toQuadKey (x, y, z) {
	  var index = ''
	  for (var i = z; i > 0; i--) {
	    var b = 0
	    var mask = 1 << (i - 1)
	    if ((x & mask) !== 0) b++
	    if ((y & mask) !== 0) b += 2
	    index += b.toString()
	  }
	  return index
	}
	
	/**
	 * Converts Leaflet BBoxString to Bing BBox
	 * @param {String} bboxString 'southwest_lng,southwest_lat,northeast_lng,northeast_lat'
	 * @return {Array} [south_lat, west_lng, north_lat, east_lng]
	 */
	function toBingBBox (bboxString) {
	  var bbox = bboxString.split(',')
	  return [bbox[1], bbox[0], bbox[3], bbox[2]]
	}
	
	var VALID_IMAGERY_SETS = ['Aerial', 'AerialWithLabels', 'Road']
	
	/**
	 * Create a new Bing Maps layer.
	 * @param {string|object} options Either a [Bing Maps Key](https://msdn.microsoft.com/en-us/library/ff428642.aspx) or an options object
	 * @param {string} options.BingMapsKey A valid Bing Maps Key (required)
	 * @param {string} [options.imagerySet=Aerial] Type of imagery, see https://msdn.microsoft.com/en-us/library/ff701716.aspx
	 * @param {string} [options.culture='en-US'] Language for labels, see https://msdn.microsoft.com/en-us/library/hh441729.aspx
	 * @return {L.TileLayer} A Leaflet TileLayer to add to your map
	 *
	 * Create a basic map
	 * @example
	 * var map = L.map('map').setView([51.505, -0.09], 13)
	 * L.TileLayer.Bing(MyBingMapsKey).addTo(map)
	 */
	L.TileLayer.Bing = L.TileLayer.extend({
	  options: {
	    bingMapsKey: null, // Required
	    imagerySet: 'Aerial',
	    culture: 'en-US',
	    minZoom: 1
	  },
	
	  statics: {
	    METADATA_URL: 'https://dev.virtualearth.net/REST/v1/Imagery/Metadata/{imagerySet}?key={bingMapsKey}&include=ImageryProviders',
	    POINT_METADATA_URL: 'https://dev.virtualearth.net/REST/v1/Imagery/Metadata/{imagerySet}/{lat},{lng}?zl={z}&key={bingMapsKey}'
	  },
	
	  initialize: function (options) {
	    if (typeof options === 'string') {
	      options = { bingMapsKey: options }
	    }
	    if (options && options.BingMapsKey) {
	      options.bingMapsKey = options.BingMapsKey
	      console.warn('use options.bingMapsKey instead of options.BingMapsKey')
	    }
	    if (!options || !options.bingMapsKey) {
	      throw new Error('Must supply options.BingMapsKey')
	    }
	    options = L.setOptions(this, options)
	    if (VALID_IMAGERY_SETS.indexOf(options.imagerySet) < 0) {
	      throw new Error("'" + options.imagerySet + "' is an invalid imagerySet, see https://github.com/gmaclennan/leaflet-bing-layer#parameters")
	    }
	    // Bing maps do not have zoom=0 tiles.
	    options.minZoom = Math.max(1, options.minZoom)
	
	    var metaDataUrl = L.Util.template(L.TileLayer.Bing.METADATA_URL, {
	      bingMapsKey: this.options.bingMapsKey,
	      imagerySet: this.options.imagerySet
	    })
	
	    this._imageryProviders = []
	    this._attributions = []
	
	    // Keep a reference to the promise so we can use it later
	    this._fetch = fetchJsonp(metaDataUrl, {jsonpCallback: 'jsonp'})
	      .then(function (response) {
	        return response.json()
	      })
	      .then(this._metaDataOnLoad.bind(this))
	      .catch(console.error.bind(console))
	
	    // for https://github.com/Leaflet/Leaflet/issues/137
	    if (!L.Browser.android) {
	      this.on('tileunload', this._onTileRemove)
	    }
	  },
	
	  createTile: function (coords, done) {
	    var tile = document.createElement('img')
	
	    L.DomEvent.on(tile, 'load', L.bind(this._tileOnLoad, this, done, tile))
	    L.DomEvent.on(tile, 'error', L.bind(this._tileOnError, this, done, tile))
	
	    if (this.options.crossOrigin) {
	      tile.crossOrigin = ''
	    }
	
	    /*
	     Alt tag is set to empty string to keep screen readers from reading URL and for compliance reasons
	     http://www.w3.org/TR/WCAG20-TECHS/H67
	    */
	    tile.alt = ''
	
	    // Don't create closure if we don't have to
	    if (this._url) {
	      tile.src = this.getTileUrl(coords)
	    } else {
	      this._fetch.then(function () {
	        tile.src = this.getTileUrl(coords)
	      }.bind(this)).catch(function (e) {
	        console.error(e)
	        done(e)
	      })
	    }
	
	    return tile
	  },
	
	  getTileUrl: function (coords) {
	    var quadkey = toQuadKey(coords.x, coords.y, coords.z)
	    return L.Util.template(this._url, {
	      quadkey: quadkey,
	      subdomain: this._getSubdomain(coords),
	      culture: this.options.culture
	    })
	  },
	
	  // Update the attribution control every time the map is moved
	  onAdd: function (map) {
	    map.on('moveend', this._updateAttribution, this)
	    L.TileLayer.prototype.onAdd.call(this, map)
	    this._attributions.forEach(function (attribution) {
	      map.attributionControl.addAttribution(attribution)
	    })
	  },
	
	  // Clean up events and remove attributions from attribution control
	  onRemove: function (map) {
	    map.off('moveend', this._updateAttribution, this)
	    this._attributions.forEach(function (attribution) {
	      map.attributionControl.removeAttribution(attribution)
	    })
	    L.TileLayer.prototype.onRemove.call(this, map)
	  },
	
	  /**
	   * Get the [Bing Imagery metadata](https://msdn.microsoft.com/en-us/library/ff701712.aspx)
	   * for a specific [`LatLng`](http://leafletjs.com/reference.html#latlng)
	   * and zoom level. If either `latlng` or `zoom` is omitted and the layer is attached
	   * to a map, the map center and current map zoom are used.
	   * @param {L.LatLng} latlng
	   * @param {Number} zoom
	   * @return {Promise} Resolves to the JSON metadata
	   */
	  getMetaData: function (latlng, zoom) {
	    if (!this._map && (!latlng || !zoom)) {
	      return Promise.reject(new Error('If layer is not attached to map, you must provide LatLng and zoom'))
	    }
	    latlng = latlng || this._map.getCenter()
	    zoom = zoom || this._map.getZoom()
	    var PointMetaDataUrl = L.Util.template(L.TileLayer.Bing.POINT_METADATA_URL, {
	      bingMapsKey: this.options.bingMapsKey,
	      imagerySet: this.options.imagerySet,
	      z: zoom,
	      lat: latlng.lat,
	      lng: latlng.lng
	    })
	    return fetchJsonp(PointMetaDataUrl, {jsonpCallback: 'jsonp'})
	      .then(function (response) {
	        return response.json()
	      })
	      .catch(console.error.bind(console))
	  },
	
	  _metaDataOnLoad: function (metaData) {
	    if (metaData.statusCode !== 200) {
	      throw new Error('Bing Imagery Metadata error: \n' + JSON.stringify(metaData, null, '  '))
	    }
	    var resource = metaData.resourceSets[0].resources[0]
	    this._url = resource.imageUrl
	    this._imageryProviders = resource.imageryProviders
	    this.options.subdomains = resource.imageUrlSubdomains
	    this._updateAttribution()
	    return Promise.resolve()
	  },
	
	  /**
	   * Update the attribution control of the map with the provider attributions
	   * within the current map bounds
	   */
	  _updateAttribution: function () {
	    var map = this._map
	    if (!map || !map.attributionControl) return
	    var zoom = map.getZoom()
	    var bbox = toBingBBox(map.getBounds().toBBoxString())
	    this._fetch.then(function () {
	      var newAttributions = this._getAttributions(bbox, zoom)
	      var prevAttributions = this._attributions
	      // Add any new provider attributions in the current area to the attribution control
	      newAttributions.forEach(function (attr) {
	        if (prevAttributions.indexOf(attr) > -1) return
	        map.attributionControl.addAttribution(attr)
	      })
	      // Remove any attributions that are no longer in the current area from the attribution control
	      prevAttributions.filter(function (attr) {
	        if (newAttributions.indexOf(attr) > -1) return
	        map.attributionControl.removeAttribution(attr)
	      })
	      this._attributions = newAttributions
	    }.bind(this))
	  },
	
	  /**
	   * Returns an array of attributions for given bbox and zoom
	   * @private
	   * @param {Array} bbox [west, south, east, north]
	   * @param {Number} zoom
	   * @return {Array} Array of attribution strings for each provider
	   */
	  _getAttributions: function (bbox, zoom) {
	    return this._imageryProviders.reduce(function (attributions, provider) {
	      for (var i = 0; i < provider.coverageAreas.length; i++) {
	        if (bboxIntersect(bbox, provider.coverageAreas[i].bbox) &&
	          zoom >= provider.coverageAreas[i].zoomMin &&
	          zoom <= provider.coverageAreas[i].zoomMax) {
	          attributions.push(provider.attribution)
	          return attributions
	        }
	      }
	      return attributions
	    }, [])
	  }
	})
	
	L.tileLayer.bing = function (options) {
	  return new L.TileLayer.Bing(options)
	}
	
	module.exports = L.TileLayer.Bing
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{"bbox-intersect":2,"fetch-jsonp":3}],2:[function(require,module,exports){
	module.exports = function(bbox1, bbox2){
	  if(!(
	      bbox1[0] > bbox2[2] ||
	      bbox1[2] < bbox2[0] ||
	      bbox1[3] < bbox2[1] ||
	      bbox1[1] > bbox2[3]
	    )){
	      return true;
	  } else {
	    return false;
	  }
	}
	},{}],3:[function(require,module,exports){
	(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
	    factory(exports, module);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, mod);
	    global.fetchJsonp = mod.exports;
	  }
	})(this, function (exports, module) {
	  'use strict';
	
	  var defaultOptions = {
	    timeout: 5000,
	    jsonpCallback: 'callback',
	    jsonpCallbackFunction: null
	  };
	
	  function generateCallbackFunction() {
	    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
	  }
	
	  // Known issue: Will throw 'Uncaught ReferenceError: callback_*** is not defined' error if request timeout
	  function clearFunction(functionName) {
	    // IE8 throws an exception when you try to delete a property on window
	    // http://stackoverflow.com/a/1824228/751089
	    try {
	      delete window[functionName];
	    } catch (e) {
	      window[functionName] = undefined;
	    }
	  }
	
	  function removeScript(scriptId) {
	    var script = document.getElementById(scriptId);
	    document.getElementsByTagName('head')[0].removeChild(script);
	  }
	
	  var fetchJsonp = function fetchJsonp(url) {
	    var options = arguments[1] === undefined ? {} : arguments[1];
	
	    var timeout = options.timeout != null ? options.timeout : defaultOptions.timeout;
	    var jsonpCallback = options.jsonpCallback != null ? options.jsonpCallback : defaultOptions.jsonpCallback;
	
	    var timeoutId = undefined;
	
	    return new Promise(function (resolve, reject) {
	      var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
	
	      window[callbackFunction] = function (response) {
	        resolve({
	          ok: true,
	          // keep consistent with fetch API
	          json: function json() {
	            return Promise.resolve(response);
	          }
	        });
	
	        if (timeoutId) clearTimeout(timeoutId);
	
	        removeScript(jsonpCallback + '_' + callbackFunction);
	
	        clearFunction(callbackFunction);
	      };
	
	      // Check if the user set their own params, and if not add a ? to start a list of params
	      url += url.indexOf('?') === -1 ? '?' : '&';
	
	      var jsonpScript = document.createElement('script');
	      jsonpScript.setAttribute('src', url + jsonpCallback + '=' + callbackFunction);
	      jsonpScript.id = jsonpCallback + '_' + callbackFunction;
	      document.getElementsByTagName('head')[0].appendChild(jsonpScript);
	
	      timeoutId = setTimeout(function () {
	        reject(new Error('JSONP request to ' + url + ' timed out'));
	
	        clearFunction(callbackFunction);
	        removeScript(jsonpCallback + '_' + callbackFunction);
	      }, timeout);
	    });
	  };
	
	  // export as global function
	  /*
	  let local;
	  if (typeof global !== 'undefined') {
	    local = global;
	  } else if (typeof self !== 'undefined') {
	    local = self;
	  } else {
	    try {
	      local = Function('return this')();
	    } catch (e) {
	      throw new Error('polyfill failed because global object is unavailable in this environment');
	    }
	  }
	  
	  local.fetchJsonp = fetchJsonp;
	  */
	
	  module.exports = fetchJsonp;
	});
	},{}]},{},[1]);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 279 */
/***/ function(module, exports) {

	/*
	 Leaflet.markercluster, Provides Beautiful Animated Marker Clustering functionality for Leaflet, a JS library for interactive maps.
	 https://github.com/Leaflet/Leaflet.markercluster
	 (c) 2012-2013, Dave Leaver, smartrak
	*/
	!function(e,t,i){L.MarkerClusterGroup=L.FeatureGroup.extend({options:{maxClusterRadius:80,iconCreateFunction:null,spiderfyOnMaxZoom:!0,showCoverageOnHover:!0,zoomToBoundsOnClick:!0,singleMarkerMode:!1,disableClusteringAtZoom:null,removeOutsideVisibleBounds:!0,animate:!0,animateAddingMarkers:!1,spiderfyDistanceMultiplier:1,spiderLegPolylineOptions:{weight:1.5,color:"#222",opacity:.5},chunkedLoading:!1,chunkInterval:200,chunkDelay:50,chunkProgress:null,polygonOptions:{}},initialize:function(e){L.Util.setOptions(this,e),this.options.iconCreateFunction||(this.options.iconCreateFunction=this._defaultIconCreateFunction),this._featureGroup=L.featureGroup(),this._featureGroup.addEventParent(this),this._nonPointGroup=L.featureGroup(),this._nonPointGroup.addEventParent(this),this._inZoomAnimation=0,this._needsClustering=[],this._needsRemoving=[],this._currentShownBounds=null,this._queue=[],this._childMarkerEventHandlers={dragstart:this._childMarkerDragStart,move:this._childMarkerMoved,dragend:this._childMarkerDragEnd};var t=L.DomUtil.TRANSITION&&this.options.animate;L.extend(this,t?this._withAnimation:this._noAnimation),this._markerCluster=t?L.MarkerCluster:L.MarkerClusterNonAnimated},addLayer:function(e){if(e instanceof L.LayerGroup)return this.addLayers([e]);if(!e.getLatLng)return this._nonPointGroup.addLayer(e),this.fire("layeradd",{layer:e}),this;if(!this._map)return this._needsClustering.push(e),this.fire("layeradd",{layer:e}),this;if(this.hasLayer(e))return this;this._unspiderfy&&this._unspiderfy(),this._addLayer(e,this._maxZoom),this.fire("layeradd",{layer:e}),this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons();var t=e,i=this._zoom;if(e.__parent)for(;t.__parent._zoom>=i;)t=t.__parent;return this._currentShownBounds.contains(t.getLatLng())&&(this.options.animateAddingMarkers?this._animationAddLayer(e,t):this._animationAddLayerNonAnimated(e,t)),this},removeLayer:function(e){return e instanceof L.LayerGroup?this.removeLayers([e]):e.getLatLng?this._map?e.__parent?(this._unspiderfy&&(this._unspiderfy(),this._unspiderfyLayer(e)),this._removeLayer(e,!0),this.fire("layerremove",{layer:e}),this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons(),e.off(this._childMarkerEventHandlers,this),this._featureGroup.hasLayer(e)&&(this._featureGroup.removeLayer(e),e.clusterShow&&e.clusterShow()),this):this:(!this._arraySplice(this._needsClustering,e)&&this.hasLayer(e)&&this._needsRemoving.push({layer:e,latlng:e._latlng}),this.fire("layerremove",{layer:e}),this):(this._nonPointGroup.removeLayer(e),this.fire("layerremove",{layer:e}),this)},addLayers:function(e,t){if(!L.Util.isArray(e))return this.addLayer(e);var i,n=this._featureGroup,r=this._nonPointGroup,s=this.options.chunkedLoading,o=this.options.chunkInterval,a=this.options.chunkProgress,h=e.length,l=0,u=!0;if(this._map){var _=(new Date).getTime(),d=L.bind(function(){for(var c=(new Date).getTime();h>l;l++){if(s&&0===l%200){var p=(new Date).getTime()-c;if(p>o)break}if(i=e[l],i instanceof L.LayerGroup)u&&(e=e.slice(),u=!1),this._extractNonGroupLayers(i,e),h=e.length;else if(i.getLatLng){if(!this.hasLayer(i)&&(this._addLayer(i,this._maxZoom),t||this.fire("layeradd",{layer:i}),i.__parent&&2===i.__parent.getChildCount())){var f=i.__parent.getAllChildMarkers(),m=f[0]===i?f[1]:f[0];n.removeLayer(m)}}else r.addLayer(i),t||this.fire("layeradd",{layer:i})}a&&a(l,h,(new Date).getTime()-_),l===h?(this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons(),this._topClusterLevel._recursivelyAddChildrenToMap(null,this._zoom,this._currentShownBounds)):setTimeout(d,this.options.chunkDelay)},this);d()}else for(var c=this._needsClustering;h>l;l++)i=e[l],i instanceof L.LayerGroup?(u&&(e=e.slice(),u=!1),this._extractNonGroupLayers(i,e),h=e.length):i.getLatLng?this.hasLayer(i)||c.push(i):r.addLayer(i);return this},removeLayers:function(e){var t,i,n=e.length,r=this._featureGroup,s=this._nonPointGroup,o=!0;if(!this._map){for(t=0;n>t;t++)i=e[t],i instanceof L.LayerGroup?(o&&(e=e.slice(),o=!1),this._extractNonGroupLayers(i,e),n=e.length):(this._arraySplice(this._needsClustering,i),s.removeLayer(i),this.hasLayer(i)&&this._needsRemoving.push({layer:i,latlng:i._latlng}),this.fire("layerremove",{layer:i}));return this}if(this._unspiderfy){this._unspiderfy();var a=e.slice(),h=n;for(t=0;h>t;t++)i=a[t],i instanceof L.LayerGroup?(this._extractNonGroupLayers(i,a),h=a.length):this._unspiderfyLayer(i)}for(t=0;n>t;t++)i=e[t],i instanceof L.LayerGroup?(o&&(e=e.slice(),o=!1),this._extractNonGroupLayers(i,e),n=e.length):i.__parent?(this._removeLayer(i,!0,!0),this.fire("layerremove",{layer:i}),r.hasLayer(i)&&(r.removeLayer(i),i.clusterShow&&i.clusterShow())):(s.removeLayer(i),this.fire("layerremove",{layer:i}));return this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons(),this._topClusterLevel._recursivelyAddChildrenToMap(null,this._zoom,this._currentShownBounds),this},clearLayers:function(){return this._map||(this._needsClustering=[],delete this._gridClusters,delete this._gridUnclustered),this._noanimationUnspiderfy&&this._noanimationUnspiderfy(),this._featureGroup.clearLayers(),this._nonPointGroup.clearLayers(),this.eachLayer(function(e){e.off(this._childMarkerEventHandlers,this),delete e.__parent},this),this._map&&this._generateInitialClusters(),this},getBounds:function(){var e=new L.LatLngBounds;this._topClusterLevel&&e.extend(this._topClusterLevel._bounds);for(var t=this._needsClustering.length-1;t>=0;t--)e.extend(this._needsClustering[t].getLatLng());return e.extend(this._nonPointGroup.getBounds()),e},eachLayer:function(e,t){var i,n,r,s=this._needsClustering.slice(),o=this._needsRemoving;for(this._topClusterLevel&&this._topClusterLevel.getAllChildMarkers(s),n=s.length-1;n>=0;n--){for(i=!0,r=o.length-1;r>=0;r--)if(o[r].layer===s[n]){i=!1;break}i&&e.call(t,s[n])}this._nonPointGroup.eachLayer(e,t)},getLayers:function(){var e=[];return this.eachLayer(function(t){e.push(t)}),e},getLayer:function(e){var t=null;return e=parseInt(e,10),this.eachLayer(function(i){L.stamp(i)===e&&(t=i)}),t},hasLayer:function(e){if(!e)return!1;var t,i=this._needsClustering;for(t=i.length-1;t>=0;t--)if(i[t]===e)return!0;for(i=this._needsRemoving,t=i.length-1;t>=0;t--)if(i[t].layer===e)return!1;return!(!e.__parent||e.__parent._group!==this)||this._nonPointGroup.hasLayer(e)},zoomToShowLayer:function(e,t){"function"!=typeof t&&(t=function(){});var i=function(){!e._icon&&!e.__parent._icon||this._inZoomAnimation||(this._map.off("moveend",i,this),this.off("animationend",i,this),e._icon?t():e.__parent._icon&&(this.once("spiderfied",t,this),e.__parent.spiderfy()))};e._icon&&this._map.getBounds().contains(e.getLatLng())?t():e.__parent._zoom<Math.round(this._map._zoom)?(this._map.on("moveend",i,this),this._map.panTo(e.getLatLng())):(this._map.on("moveend",i,this),this.on("animationend",i,this),e.__parent.zoomToBounds())},onAdd:function(e){this._map=e;var t,i,n;if(!isFinite(this._map.getMaxZoom()))throw"Map has no maxZoom specified";for(this._featureGroup.addTo(e),this._nonPointGroup.addTo(e),this._gridClusters||this._generateInitialClusters(),this._maxLat=e.options.crs.projection.MAX_LATITUDE,t=0,i=this._needsRemoving.length;i>t;t++)n=this._needsRemoving[t],n.newlatlng=n.layer._latlng,n.layer._latlng=n.latlng;for(t=0,i=this._needsRemoving.length;i>t;t++)n=this._needsRemoving[t],this._removeLayer(n.layer,!0),n.layer._latlng=n.newlatlng;this._needsRemoving=[],this._zoom=Math.round(this._map._zoom),this._currentShownBounds=this._getExpandedVisibleBounds(),this._map.on("zoomend",this._zoomEnd,this),this._map.on("moveend",this._moveEnd,this),this._spiderfierOnAdd&&this._spiderfierOnAdd(),this._bindEvents(),i=this._needsClustering,this._needsClustering=[],this.addLayers(i,!0)},onRemove:function(e){e.off("zoomend",this._zoomEnd,this),e.off("moveend",this._moveEnd,this),this._unbindEvents(),this._map._mapPane.className=this._map._mapPane.className.replace(" leaflet-cluster-anim",""),this._spiderfierOnRemove&&this._spiderfierOnRemove(),delete this._maxLat,this._hideCoverage(),this._featureGroup.remove(),this._nonPointGroup.remove(),this._featureGroup.clearLayers(),this._map=null},getVisibleParent:function(e){for(var t=e;t&&!t._icon;)t=t.__parent;return t||null},_arraySplice:function(e,t){for(var i=e.length-1;i>=0;i--)if(e[i]===t)return e.splice(i,1),!0},_removeFromGridUnclustered:function(e,t){for(var i=this._map,n=this._gridUnclustered,r=this._map.getMinZoom();t>=r&&n[t].removeObject(e,i.project(e.getLatLng(),t));t--);},_childMarkerDragStart:function(e){e.target.__dragStart=e.target._latlng},_childMarkerMoved:function(e){if(!this._ignoreMove&&!e.target.__dragStart){var t=e.target._popup&&e.target._popup.isOpen();this._moveChild(e.target,e.oldLatLng,e.latlng),t&&e.target.openPopup()}},_moveChild:function(e,t,i){e._latlng=t,this.removeLayer(e),e._latlng=i,this.addLayer(e)},_childMarkerDragEnd:function(e){e.target.__dragStart&&this._moveChild(e.target,e.target.__dragStart,e.target._latlng),delete e.target.__dragStart},_removeLayer:function(e,t,i){var n=this._gridClusters,r=this._gridUnclustered,s=this._featureGroup,o=this._map,a=this._map.getMinZoom();t&&this._removeFromGridUnclustered(e,this._maxZoom);var h,l=e.__parent,u=l._markers;for(this._arraySplice(u,e);l&&(l._childCount--,l._boundsNeedUpdate=!0,!(l._zoom<a));)t&&l._childCount<=1?(h=l._markers[0]===e?l._markers[1]:l._markers[0],n[l._zoom].removeObject(l,o.project(l._cLatLng,l._zoom)),r[l._zoom].addObject(h,o.project(h.getLatLng(),l._zoom)),this._arraySplice(l.__parent._childClusters,l),l.__parent._markers.push(h),h.__parent=l.__parent,l._icon&&(s.removeLayer(l),i||s.addLayer(h))):l._iconNeedsUpdate=!0,l=l.__parent;delete e.__parent},_isOrIsParent:function(e,t){for(;t;){if(e===t)return!0;t=t.parentNode}return!1},fire:function(e,t,i){if(t&&t.layer instanceof L.MarkerCluster){if(t.originalEvent&&this._isOrIsParent(t.layer._icon,t.originalEvent.relatedTarget))return;e="cluster"+e}L.FeatureGroup.prototype.fire.call(this,e,t,i)},listens:function(e,t){return L.FeatureGroup.prototype.listens.call(this,e,t)||L.FeatureGroup.prototype.listens.call(this,"cluster"+e,t)},_defaultIconCreateFunction:function(e){var t=e.getChildCount(),i=" marker-cluster-";return i+=10>t?"small":100>t?"medium":"large",new L.DivIcon({html:"<div><span>"+t+"</span></div>",className:"marker-cluster"+i,iconSize:new L.Point(40,40)})},_bindEvents:function(){var e=this._map,t=this.options.spiderfyOnMaxZoom,i=this.options.showCoverageOnHover,n=this.options.zoomToBoundsOnClick;(t||n)&&this.on("clusterclick",this._zoomOrSpiderfy,this),i&&(this.on("clustermouseover",this._showCoverage,this),this.on("clustermouseout",this._hideCoverage,this),e.on("zoomend",this._hideCoverage,this))},_zoomOrSpiderfy:function(e){for(var t=e.layer,i=t;1===i._childClusters.length;)i=i._childClusters[0];i._zoom===this._maxZoom&&i._childCount===t._childCount&&this.options.spiderfyOnMaxZoom?t.spiderfy():this.options.zoomToBoundsOnClick&&t.zoomToBounds(),e.originalEvent&&13===e.originalEvent.keyCode&&this._map._container.focus()},_showCoverage:function(e){var t=this._map;this._inZoomAnimation||(this._shownPolygon&&t.removeLayer(this._shownPolygon),e.layer.getChildCount()>2&&e.layer!==this._spiderfied&&(this._shownPolygon=new L.Polygon(e.layer.getConvexHull(),this.options.polygonOptions),t.addLayer(this._shownPolygon)))},_hideCoverage:function(){this._shownPolygon&&(this._map.removeLayer(this._shownPolygon),this._shownPolygon=null)},_unbindEvents:function(){var e=this.options.spiderfyOnMaxZoom,t=this.options.showCoverageOnHover,i=this.options.zoomToBoundsOnClick,n=this._map;(e||i)&&this.off("clusterclick",this._zoomOrSpiderfy,this),t&&(this.off("clustermouseover",this._showCoverage,this),this.off("clustermouseout",this._hideCoverage,this),n.off("zoomend",this._hideCoverage,this))},_zoomEnd:function(){this._map&&(this._mergeSplitClusters(),this._zoom=Math.round(this._map._zoom),this._currentShownBounds=this._getExpandedVisibleBounds())},_moveEnd:function(){if(!this._inZoomAnimation){var e=this._getExpandedVisibleBounds();this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,this._zoom,e),this._topClusterLevel._recursivelyAddChildrenToMap(null,Math.round(this._map._zoom),e),this._currentShownBounds=e}},_generateInitialClusters:function(){var e=this._map.getMaxZoom(),t=this._map.getMinZoom(),i=this.options.maxClusterRadius,n=i;"function"!=typeof i&&(n=function(){return i}),this.options.disableClusteringAtZoom&&(e=this.options.disableClusteringAtZoom-1),this._maxZoom=e,this._gridClusters={},this._gridUnclustered={};for(var r=e;r>=t;r--)this._gridClusters[r]=new L.DistanceGrid(n(r)),this._gridUnclustered[r]=new L.DistanceGrid(n(r));this._topClusterLevel=new this._markerCluster(this,t-1)},_addLayer:function(e,t){var i,n,r=this._gridClusters,s=this._gridUnclustered,o=this._map.getMinZoom();for(this.options.singleMarkerMode&&this._overrideMarkerIcon(e),e.on(this._childMarkerEventHandlers,this);t>=o;t--){i=this._map.project(e.getLatLng(),t);var a=r[t].getNearObject(i);if(a)return a._addChild(e),e.__parent=a,void 0;if(a=s[t].getNearObject(i)){var h=a.__parent;h&&this._removeLayer(a,!1);var l=new this._markerCluster(this,t,a,e);r[t].addObject(l,this._map.project(l._cLatLng,t)),a.__parent=l,e.__parent=l;var u=l;for(n=t-1;n>h._zoom;n--)u=new this._markerCluster(this,n,u),r[n].addObject(u,this._map.project(a.getLatLng(),n));return h._addChild(u),this._removeFromGridUnclustered(a,t),void 0}s[t].addObject(e,i)}this._topClusterLevel._addChild(e),e.__parent=this._topClusterLevel},_refreshClustersIcons:function(){this._featureGroup.eachLayer(function(e){e instanceof L.MarkerCluster&&e._iconNeedsUpdate&&e._updateIcon()})},_enqueue:function(e){this._queue.push(e),this._queueTimeout||(this._queueTimeout=setTimeout(L.bind(this._processQueue,this),300))},_processQueue:function(){for(var e=0;e<this._queue.length;e++)this._queue[e].call(this);this._queue.length=0,clearTimeout(this._queueTimeout),this._queueTimeout=null},_mergeSplitClusters:function(){var e=Math.round(this._map._zoom);this._processQueue(),this._zoom<e&&this._currentShownBounds.intersects(this._getExpandedVisibleBounds())?(this._animationStart(),this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,this._zoom,this._getExpandedVisibleBounds()),this._animationZoomIn(this._zoom,e)):this._zoom>e?(this._animationStart(),this._animationZoomOut(this._zoom,e)):this._moveEnd()},_getExpandedVisibleBounds:function(){return this.options.removeOutsideVisibleBounds?L.Browser.mobile?this._checkBoundsMaxLat(this._map.getBounds()):this._checkBoundsMaxLat(this._map.getBounds().pad(1)):this._mapBoundsInfinite},_checkBoundsMaxLat:function(e){var t=this._maxLat;return t!==i&&(e.getNorth()>=t&&(e._northEast.lat=1/0),e.getSouth()<=-t&&(e._southWest.lat=-1/0)),e},_animationAddLayerNonAnimated:function(e,t){if(t===e)this._featureGroup.addLayer(e);else if(2===t._childCount){t._addToMap();var i=t.getAllChildMarkers();this._featureGroup.removeLayer(i[0]),this._featureGroup.removeLayer(i[1])}else t._updateIcon()},_extractNonGroupLayers:function(e,t){var i,n=e.getLayers(),r=0;for(t=t||[];r<n.length;r++)i=n[r],i instanceof L.LayerGroup?this._extractNonGroupLayers(i,t):t.push(i);return t},_overrideMarkerIcon:function(e){var t=e.options.icon=this.options.iconCreateFunction({getChildCount:function(){return 1},getAllChildMarkers:function(){return[e]}});return t}}),L.MarkerClusterGroup.include({_mapBoundsInfinite:new L.LatLngBounds(new L.LatLng(-1/0,-1/0),new L.LatLng(1/0,1/0))}),L.MarkerClusterGroup.include({_noAnimation:{_animationStart:function(){},_animationZoomIn:function(e,t){this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,e),this._topClusterLevel._recursivelyAddChildrenToMap(null,t,this._getExpandedVisibleBounds()),this.fire("animationend")},_animationZoomOut:function(e,t){this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,e),this._topClusterLevel._recursivelyAddChildrenToMap(null,t,this._getExpandedVisibleBounds()),this.fire("animationend")},_animationAddLayer:function(e,t){this._animationAddLayerNonAnimated(e,t)}},_withAnimation:{_animationStart:function(){this._map._mapPane.className+=" leaflet-cluster-anim",this._inZoomAnimation++},_animationZoomIn:function(e,t){var i,n=this._getExpandedVisibleBounds(),r=this._featureGroup,s=this._map.getMinZoom();this._ignoreMove=!0,this._topClusterLevel._recursively(n,e,s,function(s){var o,a=s._latlng,h=s._markers;for(n.contains(a)||(a=null),s._isSingleParent()&&e+1===t?(r.removeLayer(s),s._recursivelyAddChildrenToMap(null,t,n)):(s.clusterHide(),s._recursivelyAddChildrenToMap(a,t,n)),i=h.length-1;i>=0;i--)o=h[i],n.contains(o._latlng)||r.removeLayer(o)}),this._forceLayout(),this._topClusterLevel._recursivelyBecomeVisible(n,t),r.eachLayer(function(e){e instanceof L.MarkerCluster||!e._icon||e.clusterShow()}),this._topClusterLevel._recursively(n,e,t,function(e){e._recursivelyRestoreChildPositions(t)}),this._ignoreMove=!1,this._enqueue(function(){this._topClusterLevel._recursively(n,e,s,function(e){r.removeLayer(e),e.clusterShow()}),this._animationEnd()})},_animationZoomOut:function(e,t){this._animationZoomOutSingle(this._topClusterLevel,e-1,t),this._topClusterLevel._recursivelyAddChildrenToMap(null,t,this._getExpandedVisibleBounds()),this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,e,this._getExpandedVisibleBounds())},_animationAddLayer:function(e,t){var i=this,n=this._featureGroup;n.addLayer(e),t!==e&&(t._childCount>2?(t._updateIcon(),this._forceLayout(),this._animationStart(),e._setPos(this._map.latLngToLayerPoint(t.getLatLng())),e.clusterHide(),this._enqueue(function(){n.removeLayer(e),e.clusterShow(),i._animationEnd()})):(this._forceLayout(),i._animationStart(),i._animationZoomOutSingle(t,this._map.getMaxZoom(),this._zoom)))}},_animationZoomOutSingle:function(e,t,i){var n=this._getExpandedVisibleBounds(),r=this._map.getMinZoom();e._recursivelyAnimateChildrenInAndAddSelfToMap(n,t+1,i);var s=this;this._forceLayout(),e._recursivelyBecomeVisible(n,i),this._enqueue(function(){if(1===e._childCount){var o=e._markers[0];this._ignoreMove=!0,o.setLatLng(o.getLatLng()),this._ignoreMove=!1,o.clusterShow&&o.clusterShow()}else e._recursively(n,i,r,function(e){e._recursivelyRemoveChildrenFromMap(n,t+1)});s._animationEnd()})},_animationEnd:function(){this._map&&(this._map._mapPane.className=this._map._mapPane.className.replace(" leaflet-cluster-anim","")),this._inZoomAnimation--,this.fire("animationend")},_forceLayout:function(){L.Util.falseFn(t.body.offsetWidth)}}),L.markerClusterGroup=function(e){return new L.MarkerClusterGroup(e)},L.MarkerCluster=L.Marker.extend({initialize:function(e,t,i,n){L.Marker.prototype.initialize.call(this,i?i._cLatLng||i.getLatLng():new L.LatLng(0,0),{icon:this}),this._group=e,this._zoom=t,this._markers=[],this._childClusters=[],this._childCount=0,this._iconNeedsUpdate=!0,this._boundsNeedUpdate=!0,this._bounds=new L.LatLngBounds,i&&this._addChild(i),n&&this._addChild(n)},getAllChildMarkers:function(e){e=e||[];for(var t=this._childClusters.length-1;t>=0;t--)this._childClusters[t].getAllChildMarkers(e);for(var i=this._markers.length-1;i>=0;i--)e.push(this._markers[i]);return e},getChildCount:function(){return this._childCount},zoomToBounds:function(){for(var e,t=this._childClusters.slice(),i=this._group._map,n=i.getBoundsZoom(this._bounds),r=this._zoom+1,s=i.getZoom();t.length>0&&n>r;){r++;var o=[];for(e=0;e<t.length;e++)o=o.concat(t[e]._childClusters);t=o}n>r?this._group._map.setView(this._latlng,r):s>=n?this._group._map.setView(this._latlng,s+1):this._group._map.fitBounds(this._bounds)},getBounds:function(){var e=new L.LatLngBounds;return e.extend(this._bounds),e},_updateIcon:function(){this._iconNeedsUpdate=!0,this._icon&&this.setIcon(this)},createIcon:function(){return this._iconNeedsUpdate&&(this._iconObj=this._group.options.iconCreateFunction(this),this._iconNeedsUpdate=!1),this._iconObj.createIcon()},createShadow:function(){return this._iconObj.createShadow()},_addChild:function(e,t){this._iconNeedsUpdate=!0,this._boundsNeedUpdate=!0,this._setClusterCenter(e),e instanceof L.MarkerCluster?(t||(this._childClusters.push(e),e.__parent=this),this._childCount+=e._childCount):(t||this._markers.push(e),this._childCount++),this.__parent&&this.__parent._addChild(e,!0)},_setClusterCenter:function(e){this._cLatLng||(this._cLatLng=e._cLatLng||e._latlng)},_resetBounds:function(){var e=this._bounds;e._southWest&&(e._southWest.lat=1/0,e._southWest.lng=1/0),e._northEast&&(e._northEast.lat=-1/0,e._northEast.lng=-1/0)},_recalculateBounds:function(){var e,t,i,n,r=this._markers,s=this._childClusters,o=0,a=0,h=this._childCount;if(0!==h){for(this._resetBounds(),e=0;e<r.length;e++)i=r[e]._latlng,this._bounds.extend(i),o+=i.lat,a+=i.lng;for(e=0;e<s.length;e++)t=s[e],t._boundsNeedUpdate&&t._recalculateBounds(),this._bounds.extend(t._bounds),i=t._wLatLng,n=t._childCount,o+=i.lat*n,a+=i.lng*n;this._latlng=this._wLatLng=new L.LatLng(o/h,a/h),this._boundsNeedUpdate=!1}},_addToMap:function(e){e&&(this._backupLatlng=this._latlng,this.setLatLng(e)),this._group._featureGroup.addLayer(this)},_recursivelyAnimateChildrenIn:function(e,t,i){this._recursively(e,this._group._map.getMinZoom(),i-1,function(e){var i,n,r=e._markers;for(i=r.length-1;i>=0;i--)n=r[i],n._icon&&(n._setPos(t),n.clusterHide())},function(e){var i,n,r=e._childClusters;for(i=r.length-1;i>=0;i--)n=r[i],n._icon&&(n._setPos(t),n.clusterHide())})},_recursivelyAnimateChildrenInAndAddSelfToMap:function(e,t,i){this._recursively(e,i,this._group._map.getMinZoom(),function(n){n._recursivelyAnimateChildrenIn(e,n._group._map.latLngToLayerPoint(n.getLatLng()).round(),t),n._isSingleParent()&&t-1===i?(n.clusterShow(),n._recursivelyRemoveChildrenFromMap(e,t)):n.clusterHide(),n._addToMap()})},_recursivelyBecomeVisible:function(e,t){this._recursively(e,this._group._map.getMinZoom(),t,null,function(e){e.clusterShow()})},_recursivelyAddChildrenToMap:function(e,t,i){this._recursively(i,this._group._map.getMinZoom()-1,t,function(n){if(t!==n._zoom)for(var r=n._markers.length-1;r>=0;r--){var s=n._markers[r];i.contains(s._latlng)&&(e&&(s._backupLatlng=s.getLatLng(),s.setLatLng(e),s.clusterHide&&s.clusterHide()),n._group._featureGroup.addLayer(s))}},function(t){t._addToMap(e)})},_recursivelyRestoreChildPositions:function(e){for(var t=this._markers.length-1;t>=0;t--){var i=this._markers[t];i._backupLatlng&&(i.setLatLng(i._backupLatlng),delete i._backupLatlng)}if(e-1===this._zoom)for(var n=this._childClusters.length-1;n>=0;n--)this._childClusters[n]._restorePosition();else for(var r=this._childClusters.length-1;r>=0;r--)this._childClusters[r]._recursivelyRestoreChildPositions(e)},_restorePosition:function(){this._backupLatlng&&(this.setLatLng(this._backupLatlng),delete this._backupLatlng)},_recursivelyRemoveChildrenFromMap:function(e,t,i){var n,r;this._recursively(e,this._group._map.getMinZoom()-1,t-1,function(e){for(r=e._markers.length-1;r>=0;r--)n=e._markers[r],i&&i.contains(n._latlng)||(e._group._featureGroup.removeLayer(n),n.clusterShow&&n.clusterShow())},function(e){for(r=e._childClusters.length-1;r>=0;r--)n=e._childClusters[r],i&&i.contains(n._latlng)||(e._group._featureGroup.removeLayer(n),n.clusterShow&&n.clusterShow())})},_recursively:function(e,t,i,n,r){var s,o,a=this._childClusters,h=this._zoom;if(h>=t&&(n&&n(this),r&&h===i&&r(this)),t>h||i>h)for(s=a.length-1;s>=0;s--)o=a[s],e.intersects(o._bounds)&&o._recursively(e,t,i,n,r)},_isSingleParent:function(){return this._childClusters.length>0&&this._childClusters[0]._childCount===this._childCount}}),L.Marker.include({clusterHide:function(){return this.options.opacityWhenUnclustered=this.options.opacity||1,this.setOpacity(0)},clusterShow:function(){var e=this.setOpacity(this.options.opacity||this.options.opacityWhenUnclustered);return delete this.options.opacityWhenUnclustered,e}}),L.DistanceGrid=function(e){this._cellSize=e,this._sqCellSize=e*e,this._grid={},this._objectPoint={}},L.DistanceGrid.prototype={addObject:function(e,t){var i=this._getCoord(t.x),n=this._getCoord(t.y),r=this._grid,s=r[n]=r[n]||{},o=s[i]=s[i]||[],a=L.Util.stamp(e);this._objectPoint[a]=t,o.push(e)},updateObject:function(e,t){this.removeObject(e),this.addObject(e,t)},removeObject:function(e,t){var i,n,r=this._getCoord(t.x),s=this._getCoord(t.y),o=this._grid,a=o[s]=o[s]||{},h=a[r]=a[r]||[];for(delete this._objectPoint[L.Util.stamp(e)],i=0,n=h.length;n>i;i++)if(h[i]===e)return h.splice(i,1),1===n&&delete a[r],!0},eachObject:function(e,t){var i,n,r,s,o,a,h,l=this._grid;for(i in l){o=l[i];for(n in o)for(a=o[n],r=0,s=a.length;s>r;r++)h=e.call(t,a[r]),h&&(r--,s--)}},getNearObject:function(e){var t,i,n,r,s,o,a,h,l=this._getCoord(e.x),u=this._getCoord(e.y),_=this._objectPoint,d=this._sqCellSize,c=null;for(t=u-1;u+1>=t;t++)if(r=this._grid[t])for(i=l-1;l+1>=i;i++)if(s=r[i])for(n=0,o=s.length;o>n;n++)a=s[n],h=this._sqDist(_[L.Util.stamp(a)],e),d>h&&(d=h,c=a);return c},_getCoord:function(e){return Math.floor(e/this._cellSize)},_sqDist:function(e,t){var i=t.x-e.x,n=t.y-e.y;return i*i+n*n}},function(){L.QuickHull={getDistant:function(e,t){var i=t[1].lat-t[0].lat,n=t[0].lng-t[1].lng;return n*(e.lat-t[0].lat)+i*(e.lng-t[0].lng)},findMostDistantPointFromBaseLine:function(e,t){var i,n,r,s=0,o=null,a=[];for(i=t.length-1;i>=0;i--)n=t[i],r=this.getDistant(n,e),r>0&&(a.push(n),r>s&&(s=r,o=n));return{maxPoint:o,newPoints:a}},buildConvexHull:function(e,t){var i=[],n=this.findMostDistantPointFromBaseLine(e,t);return n.maxPoint?(i=i.concat(this.buildConvexHull([e[0],n.maxPoint],n.newPoints)),i=i.concat(this.buildConvexHull([n.maxPoint,e[1]],n.newPoints))):[e[0]]},getConvexHull:function(e){var t,i=!1,n=!1,r=!1,s=!1,o=null,a=null,h=null,l=null,u=null,_=null;for(t=e.length-1;t>=0;t--){var d=e[t];(i===!1||d.lat>i)&&(o=d,i=d.lat),(n===!1||d.lat<n)&&(a=d,n=d.lat),(r===!1||d.lng>r)&&(h=d,r=d.lng),(s===!1||d.lng<s)&&(l=d,s=d.lng)}n!==i?(_=a,u=o):(_=l,u=h);var c=[].concat(this.buildConvexHull([_,u],e),this.buildConvexHull([u,_],e));return c}}}(),L.MarkerCluster.include({getConvexHull:function(){var e,t,i=this.getAllChildMarkers(),n=[];for(t=i.length-1;t>=0;t--)e=i[t].getLatLng(),n.push(e);return L.QuickHull.getConvexHull(n)}}),L.MarkerCluster.include({_2PI:2*Math.PI,_circleFootSeparation:25,_circleStartAngle:Math.PI/6,_spiralFootSeparation:28,_spiralLengthStart:11,_spiralLengthFactor:5,_circleSpiralSwitchover:9,spiderfy:function(){if(this._group._spiderfied!==this&&!this._group._inZoomAnimation){var e,t=this.getAllChildMarkers(),i=this._group,n=i._map,r=n.latLngToLayerPoint(this._latlng);this._group._unspiderfy(),this._group._spiderfied=this,t.length>=this._circleSpiralSwitchover?e=this._generatePointsSpiral(t.length,r):(r.y+=10,e=this._generatePointsCircle(t.length,r)),this._animationSpiderfy(t,e)}},unspiderfy:function(e){this._group._inZoomAnimation||(this._animationUnspiderfy(e),this._group._spiderfied=null)},_generatePointsCircle:function(e,t){var i,n,r=this._group.options.spiderfyDistanceMultiplier*this._circleFootSeparation*(2+e),s=r/this._2PI,o=this._2PI/e,a=[];for(a.length=e,i=e-1;i>=0;i--)n=this._circleStartAngle+i*o,a[i]=new L.Point(t.x+s*Math.cos(n),t.y+s*Math.sin(n))._round();return a},_generatePointsSpiral:function(e,t){var i,n=this._group.options.spiderfyDistanceMultiplier,r=n*this._spiralLengthStart,s=n*this._spiralFootSeparation,o=n*this._spiralLengthFactor*this._2PI,a=0,h=[];for(h.length=e,i=e-1;i>=0;i--)a+=s/r+5e-4*i,h[i]=new L.Point(t.x+r*Math.cos(a),t.y+r*Math.sin(a))._round(),r+=o/a;return h},_noanimationUnspiderfy:function(){var e,t,i=this._group,n=i._map,r=i._featureGroup,s=this.getAllChildMarkers();for(i._ignoreMove=!0,this.setOpacity(1),t=s.length-1;t>=0;t--)e=s[t],r.removeLayer(e),e._preSpiderfyLatlng&&(e.setLatLng(e._preSpiderfyLatlng),delete e._preSpiderfyLatlng),e.setZIndexOffset&&e.setZIndexOffset(0),e._spiderLeg&&(n.removeLayer(e._spiderLeg),delete e._spiderLeg);i.fire("unspiderfied",{cluster:this,markers:s}),i._ignoreMove=!1,i._spiderfied=null}}),L.MarkerClusterNonAnimated=L.MarkerCluster.extend({_animationSpiderfy:function(e,t){var i,n,r,s,o=this._group,a=o._map,h=o._featureGroup,l=this._group.options.spiderLegPolylineOptions;for(o._ignoreMove=!0,i=0;i<e.length;i++)s=a.layerPointToLatLng(t[i]),n=e[i],r=new L.Polyline([this._latlng,s],l),a.addLayer(r),n._spiderLeg=r,n._preSpiderfyLatlng=n._latlng,n.setLatLng(s),n.setZIndexOffset&&n.setZIndexOffset(1e6),h.addLayer(n);this.setOpacity(.3),o._ignoreMove=!1,o.fire("spiderfied",{cluster:this,markers:e})},_animationUnspiderfy:function(){this._noanimationUnspiderfy()}}),L.MarkerCluster.include({_animationSpiderfy:function(e,t){var n,r,s,o,a,h,l=this,u=this._group,_=u._map,d=u._featureGroup,c=this._latlng,p=_.latLngToLayerPoint(c),f=L.Path.SVG,m=L.extend({},this._group.options.spiderLegPolylineOptions),g=m.opacity;for(g===i&&(g=L.MarkerClusterGroup.prototype.options.spiderLegPolylineOptions.opacity),f?(m.opacity=0,m.className=(m.className||"")+" leaflet-cluster-spider-leg"):m.opacity=g,u._ignoreMove=!0,n=0;n<e.length;n++)r=e[n],h=_.layerPointToLatLng(t[n]),s=new L.Polyline([c,h],m),_.addLayer(s),r._spiderLeg=s,f&&(o=s._path,a=o.getTotalLength()+.1,o.style.strokeDasharray=a,o.style.strokeDashoffset=a),r.setZIndexOffset&&r.setZIndexOffset(1e6),r.clusterHide&&r.clusterHide(),d.addLayer(r),r._setPos&&r._setPos(p);for(u._forceLayout(),u._animationStart(),n=e.length-1;n>=0;n--)h=_.layerPointToLatLng(t[n]),r=e[n],r._preSpiderfyLatlng=r._latlng,r.setLatLng(h),r.clusterShow&&r.clusterShow(),f&&(s=r._spiderLeg,o=s._path,o.style.strokeDashoffset=0,s.setStyle({opacity:g}));this.setOpacity(.3),u._ignoreMove=!1,setTimeout(function(){u._animationEnd(),u.fire("spiderfied",{cluster:l,markers:e})},200)},_animationUnspiderfy:function(e){var t,i,n,r,s,o,a=this,h=this._group,l=h._map,u=h._featureGroup,_=e?l._latLngToNewLayerPoint(this._latlng,e.zoom,e.center):l.latLngToLayerPoint(this._latlng),d=this.getAllChildMarkers(),c=L.Path.SVG;for(h._ignoreMove=!0,h._animationStart(),this.setOpacity(1),i=d.length-1;i>=0;i--)t=d[i],t._preSpiderfyLatlng&&(t.closePopup(),t.setLatLng(t._preSpiderfyLatlng),delete t._preSpiderfyLatlng,o=!0,t._setPos&&(t._setPos(_),o=!1),t.clusterHide&&(t.clusterHide(),o=!1),o&&u.removeLayer(t),c&&(n=t._spiderLeg,r=n._path,s=r.getTotalLength()+.1,r.style.strokeDashoffset=s,n.setStyle({opacity:0})));h._ignoreMove=!1,setTimeout(function(){var e=0;for(i=d.length-1;i>=0;i--)t=d[i],t._spiderLeg&&e++;for(i=d.length-1;i>=0;i--)t=d[i],t._spiderLeg&&(t.clusterShow&&t.clusterShow(),t.setZIndexOffset&&t.setZIndexOffset(0),e>1&&u.removeLayer(t),l.removeLayer(t._spiderLeg),delete t._spiderLeg);h._animationEnd(),h.fire("unspiderfied",{cluster:a,markers:d})},200)}}),L.MarkerClusterGroup.include({_spiderfied:null,unspiderfy:function(){this._unspiderfy.apply(this,arguments)},_spiderfierOnAdd:function(){this._map.on("click",this._unspiderfyWrapper,this),this._map.options.zoomAnimation&&this._map.on("zoomstart",this._unspiderfyZoomStart,this),this._map.on("zoomend",this._noanimationUnspiderfy,this),L.Browser.touch||this._map.getRenderer(this)},_spiderfierOnRemove:function(){this._map.off("click",this._unspiderfyWrapper,this),this._map.off("zoomstart",this._unspiderfyZoomStart,this),this._map.off("zoomanim",this._unspiderfyZoomAnim,this),this._map.off("zoomend",this._noanimationUnspiderfy,this),this._noanimationUnspiderfy()},_unspiderfyZoomStart:function(){this._map&&this._map.on("zoomanim",this._unspiderfyZoomAnim,this)},_unspiderfyZoomAnim:function(e){L.DomUtil.hasClass(this._map._mapPane,"leaflet-touching")||(this._map.off("zoomanim",this._unspiderfyZoomAnim,this),this._unspiderfy(e))},_unspiderfyWrapper:function(){this._unspiderfy()},_unspiderfy:function(e){this._spiderfied&&this._spiderfied.unspiderfy(e)},_noanimationUnspiderfy:function(){this._spiderfied&&this._spiderfied._noanimationUnspiderfy()},_unspiderfyLayer:function(e){e._spiderLeg&&(this._featureGroup.removeLayer(e),e.clusterShow&&e.clusterShow(),e.setZIndexOffset&&e.setZIndexOffset(0),this._map.removeLayer(e._spiderLeg),delete e._spiderLeg)
	}}),L.MarkerClusterGroup.include({refreshClusters:function(e){return e?e instanceof L.MarkerClusterGroup?e=e._topClusterLevel.getAllChildMarkers():e instanceof L.LayerGroup?e=e._layers:e instanceof L.MarkerCluster?e=e.getAllChildMarkers():e instanceof L.Marker&&(e=[e]):e=this._topClusterLevel.getAllChildMarkers(),this._flagParentsIconsNeedUpdate(e),this._refreshClustersIcons(),this.options.singleMarkerMode&&this._refreshSingleMarkerModeMarkers(e),this},_flagParentsIconsNeedUpdate:function(e){var t,i;for(t in e)for(i=e[t].__parent;i;)i._iconNeedsUpdate=!0,i=i.__parent},_refreshSingleMarkerModeMarkers:function(e){var t,i;for(t in e)i=e[t],this.hasLayer(i)&&i.setIcon(this._overrideMarkerIcon(i))}}),L.Marker.include({refreshIconOptions:function(e,t){var i=this.options.icon;return L.setOptions(i,e),this.setIcon(i),t&&this.__parent&&this.__parent._group.refreshClusters(this),this}})}(window,document);

/***/ },
/* 280 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAUpJREFUeNq0VcFtwzAMlP3rI4BHSDaoN6gncLJBMkHaV59Jnn3Z3iAb1JnA2cDZIB7BQB99tsf2GBCCA8hATOBASKLOR4qSIzdgX+9Pc7gt8AI8e8sX4AxUs4/vzt8bDZDt4XYuzA4g3Q8SgiiBazxFouZE77iWD8RkIO5lEN8h06AUvgZ6ouZc5n2kIcc/IVNUsiM3JAi6wrf8mKDlXMKYoyH9K1PEA7haZcBrQB3fSGgzWwhhQQKnyoDPwENZsRQNx6WkvFR1qI+0Q+HCreAeredSFP5oC/AAWjfOUora2UMR65juWEu41/mEDzFLOGeBx1rHvTdClZujwBcrP4SM9znX8SRtU9k24EuyCSDbMNa2WRVTcmmuUMH2Wd1Jv+NazVi9JaVwxaYHtTnXTKFHwIJ9lhEp5zTNtbmyh0mer+ke2Ef9An4FGABwCYp2L/mX0gAAAABJRU5ErkJggg=="

/***/ },
/* 281 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAYCAYAAADzoH0MAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTExIDc5LjE1ODMyNSwgMjAxNS8wOS8xMC0wMToxMDoyMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6REI0ODlFRTkxN0UwMTFFNjg4Q0NDMTNFNkFDQUVBOTYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6REI0ODlFRTgxN0UwMTFFNjg4Q0NDMTNFNkFDQUVBOTYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NkRBNzBFM0M0OTQ4MTFFNUFERjFGRTQ3QTVGMTAwN0IiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NkRBNzBFM0Q0OTQ4MTFFNUFERjFGRTQ3QTVGMTAwN0IiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6xsVNYAAABi0lEQVR42pxUPUsDQRCdu3yQQvwDaS38BacHprA4LGNtncYqnIXkB2ilkDKNlYUpbAxWIqmEBCWFrYVNQCSVkBQJIYhv5J2s695x+OBlLnMzb2ZnNvHEwl6lHsA0wAis0v0G3oMXd4vekxnvGYnrMB3wQLJxBR5CaPojwGStEEg+aBeRivh0dFKSF6SNgDni8cyPjgoxOOT3EGw7imwVOTA7uYb2loZvgEI12AdLpOFz2iZiK/kb9MWWO/KNVSVnHmYMb2jNpKoCJfk/SiowNhwVDiwNIWMSjFWgbwW1MbCy44aWuQkTfV3jtuPcedcYJjfxBqaecpHEajtBD5vZT27iEbh0BFVSkpfMkYJ+vK5ePjaKm2t43Mk5/XNUv9YH33CegpMcyRPGyi8BKM5gWjkEWowVuwPFJTjKSB4xRpwCUP6EaWYINBkjaR2oyACm60ju8p1kChDH4Nz4PqfvDwouJ9Y6xVr13S5dJ6h+64r1M857xh/amM+SuwN2sUIX7/pni+rPaXFfAgwAqFR90CQg7JUAAAAASUVORK5CYII="

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(283);
	
	var $inject = [];
	
	var lbaLeafletMap = function lbaLeafletMap() {
	  return {
	    controller: 'lbaLeafletMapCtrl',
	    controllerAs: 'vm',
	    bindToController: true,
	    template: __webpack_require__(286),
	    scope: {
	      locations: '=',
	      mapCenter: '=',
	      zoomLevel: '<',
	      markerClick: '=',
	      bounds: '=',
	      markerOverride: '<',
	      includesRadius: '<'
	    }
	  };
	};
	
	lbaLeafletMap.$inject = $inject;
	
	exports['default'] = lbaLeafletMap;
	module.exports = exports['default'];

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(284);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaLeafletMap.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaLeafletMap.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".leaflet-image-layer,.leaflet-layer,.leaflet-map-pane canvas,.leaflet-map-pane svg,.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-pane,.leaflet-tile,.leaflet-tile-container,.leaflet-zoom-box{position:absolute;left:0;top:0}.leaflet-container{overflow:hidden;-ms-touch-action:none;touch-action:none}.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-tile{-webkit-user-select:none;-moz-user-select:none;user-select:none;-webkit-user-drag:none}.leaflet-safari .leaflet-tile{image-rendering:-webkit-optimize-contrast}.leaflet-safari .leaflet-tile-container{width:100pc;height:100pc;-webkit-transform-origin:0 0}.leaflet-marker-icon,.leaflet-marker-shadow{display:block}.leaflet-container .leaflet-marker-pane img,.leaflet-container .leaflet-overlay-pane svg,.leaflet-container .leaflet-tile-pane img,.leaflet-container img.leaflet-image-layer{max-width:none!important}.leaflet-tile{filter:inherit;visibility:hidden}.leaflet-tile-loaded{visibility:inherit}.leaflet-zoom-box{width:0;height:0;box-sizing:border-box;z-index:800}.leaflet-overlay-pane svg{-moz-user-select:none}.leaflet-pane{z-index:400}.leaflet-tile-pane{z-index:200}.leaflet-overlay-pane{z-index:400}.leaflet-shadow-pane{z-index:500}.leaflet-marker-pane{z-index:600}.leaflet-popup-pane{z-index:700}.leaflet-map-pane canvas{z-index:100}.leaflet-map-pane svg{z-index:200}.leaflet-vml-shape{width:1px;height:1px}.lvml{behavior:url(#default#VML);display:inline-block;position:absolute}.leaflet-control{position:relative;z-index:800;pointer-events:auto}.leaflet-bottom,.leaflet-top{position:absolute;z-index:1000;pointer-events:none}.leaflet-top{top:0}.leaflet-right{right:0}.leaflet-bottom{bottom:0}.leaflet-left{left:0}.leaflet-control{float:left;clear:both}.leaflet-right .leaflet-control{float:right}.leaflet-top .leaflet-control{margin-top:10px}.leaflet-bottom .leaflet-control{margin-bottom:10px}.leaflet-left .leaflet-control{margin-left:10px}.leaflet-right .leaflet-control{margin-right:10px}.leaflet-fade-anim .leaflet-tile{will-change:opacity}.leaflet-fade-anim .leaflet-popup{opacity:0;-webkit-transition:opacity .2s linear;transition:opacity .2s linear}.leaflet-fade-anim .leaflet-map-pane .leaflet-popup{opacity:1}.leaflet-zoom-animated{-webkit-transform-origin:0 0;transform-origin:0 0}.leaflet-zoom-anim .leaflet-zoom-animated{will-change:transform;-webkit-transition:-webkit-transform .25s cubic-bezier(0,0,0.25,1);transition:transform .25s cubic-bezier(0,0,0.25,1)}.leaflet-pan-anim .leaflet-tile,.leaflet-zoom-anim .leaflet-tile{-webkit-transition:none;transition:none}.leaflet-zoom-anim .leaflet-zoom-hide{visibility:hidden}.leaflet-interactive{cursor:pointer}.leaflet-grab{cursor:-moz-grab}.leaflet-crosshair,.leaflet-crosshair .leaflet-interactive{cursor:crosshair}.leaflet-control,.leaflet-popup-pane{cursor:auto}.leaflet-dragging .leaflet-grab,.leaflet-dragging .leaflet-grab .leaflet-interactive,.leaflet-dragging .leaflet-marker-draggable{cursor:move;cursor:-moz-grabbing}.leaflet-image-layer,.leaflet-marker-icon,.leaflet-marker-shadow,.leaflet-pane>svg path,.leaflet-tile-container{pointer-events:none}.leaflet-image-layer.leaflet-interactive,.leaflet-marker-icon.leaflet-interactive,.leaflet-pane>svg path.leaflet-interactive{pointer-events:auto}.leaflet-container{background:#ddd;outline:0}.leaflet-container a{color:#0078a8}.leaflet-container a.leaflet-active{outline:2px solid orange}.leaflet-zoom-box{border:2px dotted #38f;background:hsla(0,0%,100%,.5)}.leaflet-container{font:9pt/1.5 \"Helvetica Neue\",Arial,Helvetica,sans-serif}.leaflet-bar{box-shadow:0 1px 5px rgba(0,0,0,.65);border-radius:4px}.leaflet-bar a,.leaflet-bar a:hover{background-color:#fff;border-bottom:1px solid #ccc;width:26px;height:26px;line-height:26px;display:block;text-align:center;text-decoration:none;color:#000}.leaflet-bar a,.leaflet-control-layers-toggle{background-position:50% 50%;background-repeat:no-repeat;display:block}.leaflet-bar a:hover{background-color:#f4f4f4}.leaflet-bar a:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.leaflet-bar a:last-child{border-bottom-left-radius:4px;border-bottom-right-radius:4px;border-bottom:none}.leaflet-bar a.leaflet-disabled{cursor:default;background-color:#f4f4f4;color:#bbb}.leaflet-touch .leaflet-bar a{width:30px;height:30px;line-height:30px}.leaflet-control-zoom-in,.leaflet-control-zoom-out{font:bold 18px Lucida Console,Monaco,monospace;text-indent:1px}.leaflet-control-zoom-out{font-size:20px}.leaflet-touch .leaflet-control-zoom-in{font-size:22px}.leaflet-touch .leaflet-control-zoom-out{font-size:24px}.leaflet-control-layers{box-shadow:0 1px 5px rgba(0,0,0,.4);background:#fff;border-radius:5px}.leaflet-control-layers-toggle{background-image:url(https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.0.0-rc.1/images/layers.png);width:36px;height:36px}.leaflet-retina .leaflet-control-layers-toggle{background-image:url(https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.0.0-rc.1/images/layers-2x.png);background-size:26px 26px}.leaflet-touch .leaflet-control-layers-toggle{width:44px;height:44px}.leaflet-control-layers .leaflet-control-layers-list,.leaflet-control-layers-expanded .leaflet-control-layers-toggle{display:none}.leaflet-control-layers-expanded .leaflet-control-layers-list{display:block;position:relative}.leaflet-control-layers-expanded{padding:6px 10px 6px 6px;color:#333;background:#fff}.leaflet-control-layers-scrollbar{overflow-y:scroll;padding-right:5px}.leaflet-control-layers-selector{margin-top:2px;position:relative;top:1px}.leaflet-control-layers label{display:block}.leaflet-control-layers-separator{height:0;border-top:1px solid #ddd;margin:5px -10px 5px -6px}.leaflet-container .leaflet-control-attribution{background:#fff;background:hsla(0,0%,100%,.7);margin:0}.leaflet-control-attribution,.leaflet-control-scale-line{padding:0 5px;color:#333}.leaflet-control-attribution a{text-decoration:none}.leaflet-control-attribution a:hover{text-decoration:underline}.leaflet-container .leaflet-control-attribution,.leaflet-container .leaflet-control-scale{font-size:11px}.leaflet-left .leaflet-control-scale{margin-left:5px}.leaflet-bottom .leaflet-control-scale{margin-bottom:5px}.leaflet-control-scale-line{border:2px solid #777;border-top:none;line-height:1.1;padding:2px 5px 1px;font-size:11px;white-space:nowrap;overflow:hidden;box-sizing:border-box;background:#fff;background:hsla(0,0%,100%,.5)}.leaflet-control-scale-line:not(:first-child){border-top:2px solid #777;border-bottom:none;margin-top:-2px}.leaflet-control-scale-line:not(:first-child):not(:last-child){border-bottom:2px solid #777}.leaflet-touch .leaflet-bar,.leaflet-touch .leaflet-control-attribution,.leaflet-touch .leaflet-control-layers{box-shadow:none}.leaflet-touch .leaflet-bar,.leaflet-touch .leaflet-control-layers{border:2px solid rgba(0,0,0,.2);background-clip:padding-box}.leaflet-popup{position:absolute;text-align:center}.leaflet-popup-content-wrapper{padding:1px;text-align:left;border-radius:9pt}.leaflet-popup-content{margin:13px 19px;line-height:1.4}.leaflet-popup-content p{margin:18px 0}.leaflet-popup-tip-container{margin:0 auto;width:40px;height:20px;position:relative;overflow:hidden}.leaflet-popup-tip{width:17px;height:17px;padding:1px;margin:-10px auto 0;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.leaflet-popup-content-wrapper,.leaflet-popup-tip{background:#fff;color:#333;box-shadow:0 3px 14px rgba(0,0,0,.4)}.leaflet-container a.leaflet-popup-close-button{position:absolute;top:0;right:0;padding:4px 4px 0 0;border:none;text-align:center;width:18px;height:14px;font:1pc/14px Tahoma,Verdana,sans-serif;color:#c3c3c3;text-decoration:none;font-weight:700;background:transparent}.leaflet-container a.leaflet-popup-close-button:hover{color:#999}.leaflet-popup-scrolled{overflow:auto;border-bottom:1px solid #ddd;border-top:1px solid #ddd}.leaflet-oldie .leaflet-popup-content-wrapper{zoom:1}.leaflet-oldie .leaflet-popup-tip{width:24px;margin:0 auto;-ms-filter:\"progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678,M12=0.70710678,M21=-0.70710678,M22=0.70710678)\";filter:progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678,M12=0.70710678,M21=-0.70710678,M22=0.70710678)}.leaflet-oldie .leaflet-popup-tip-container{margin-top:-1px}.leaflet-oldie .leaflet-control-layers,.leaflet-oldie .leaflet-control-zoom,.leaflet-oldie .leaflet-popup-content-wrapper,.leaflet-oldie .leaflet-popup-tip{border:1px solid #999}.leaflet-div-icon{background:#fff;border:1px solid #666}.marker-active{width:300px}.lbaLeafletMap .map{width:100%;height:650px}.marker-active_content{background:#fff;box-shadow:0 0 10px rgba(0,0,0,.25);border-radius:4px;min-height:70px;position:relative;z-index:1;padding:25px;font-size:1pc}.marker-active_content h3{margin-top:0;font-size:1pc;font-weight:700}.marker-active_content p{margin-bottom:0}.marker-active_content .rating-stars{font-size:1pc}.marker-active_content .rating-stars i{margin-right:0}.marker-active_content .from{position:absolute;bottom:10px;right:15px;font-size:10px;color:#a6a8ab;margin:0}.marker-active_content .from .price{margin:0 0 0 2px;display:inline-block;font-weight:700;font-size:26px;color:#99ba48;line-height:27px}.marker-active_title{margin:0;font-size:14px;line-height:20px;width:238px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.marker-active_icon{background:url(" + __webpack_require__(285) + ") no-repeat;margin-left:150px;position:relative;z-index:1000;min-height:2pc}.marker-active_icon:after{content:'';display:block;position:absolute;bottom:0;width:0;height:0;border:0;left:2px;border-bottom:8px solid #fff;border-left:8px solid transparent;border-right:8px solid transparent}.leaflet-cluster-anim .leaflet-marker-icon,.leaflet-cluster-anim .leaflet-marker-shadow{-webkit-transition:-webkit-transform .3s ease-out,opacity .3s ease-in;transition:transform .3s ease-out,opacity .3s ease-in}.marker-cluster:hover{background:#9bb733}.leaflet-oldie .marker-cluster-large,.leaflet-oldie .marker-cluster-medium,.leaflet-oldie .marker-cluster-small,.marker-cluster-large,.marker-cluster-medium,.marker-cluster-small{background-color:#47084b}.marker-cluster{color:#fff;background-clip:padding-box;border-radius:10px;width:20px!important;height:20px!important;margin-left:-10px!important;margin-top:-10px!important}.marker-cluster div{width:20px;height:20px;text-align:center;border-radius:10px}.marker-cluster span{line-height:20px;font-size:11px}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaLeafletMap/src/components/lbaLeafletMap/leaflet.scss","/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaLeafletMap/src/components/lbaLeafletMap/lbaLeafletMap.scss"],"names":[],"mappings":"AAEA,qMAUE,kBACA,OACA,KAAM,CACP,mBAEC,gBACA,sBACA,iBAAkB,CACnB,0DAIC,yBACA,sBACA,iBACA,sBAAuB,CACxB,8BAGC,yCAA0C,CAC3C,wCAGC,YACA,aACA,4BAA6B,CAC9B,4CAGC,aAAc,CACf,8KAOC,wBAA0B,CAC3B,cAEC,eACA,iBAAkB,CACnB,qBAEC,kBAAmB,CACpB,kBAEC,QACA,SACA,AACA,sBACA,WAAY,CACb,0BAGC,qBAAsB,CACvB,cAEuB,WAAY,CAAI,mBAEhB,WAAY,CAAI,sBAChB,WAAY,CAAI,qBAChB,WAAY,CAAI,qBAChB,WAAY,CAAI,oBAChB,WAAY,CAAI,yBAEb,WAAY,CAAI,sBAChB,WAAY,CAAI,mBAGzC,UACA,UAAW,CACZ,MAEC,2BACA,qBACA,iBAAkB,CACnB,iBAMC,kBACA,YACA,mBAAoB,CACrB,6BAGC,kBACA,aACA,mBAAoB,CACrB,aAEC,KAAM,CACP,eAEC,OAAQ,CACT,gBAEC,QAAS,CACV,cAEC,MAAO,CACR,iBAEC,WACA,UAAW,CACZ,gCAEC,WAAY,CACb,8BAEC,eAAgB,CACjB,iCAEC,kBAAmB,CACpB,+BAEC,gBAAiB,CAClB,gCAEC,iBAAkB,CACnB,iCAMC,mBAAoB,CACrB,kCAEC,UACA,sCACA,AAEA,6BAA+B,CAChC,oDAEC,SAAU,CACX,uBAEC,6BACA,AACA,oBAAqB,CACtB,0CAEC,sBAAsB,AAGtB,mEACA,AAEA,kDAA4D,CAL7D,AAMA,iEAGC,wBACA,AAEA,eAAgB,CACjB,sCAGC,iBAAkB,CACnB,qBAMC,cAAe,CAChB,cAGC,gBAAoB,CACrB,2DAGC,gBAAiB,CAClB,qCAGC,WAAY,CACb,iIAIC,YACA,AACA,oBAAwB,CACzB,gHAQC,mBAAoB,CACrB,6HAKC,mBAAoB,CACrB,mBAKC,gBACA,SAAU,CACX,qBAEC,aAAc,CACf,oCAEC,wBAAyB,CAC1B,kBAEC,uBACA,6BAAiC,CAClC,mBAKC,wDAA6D,CAC9D,aAMC,qCACA,iBAAkB,CACnB,oCAGC,sBACA,6BACA,WACA,YACA,iBACA,cACA,kBACA,qBACA,UAAY,CACb,8CAGC,4BACA,4BACA,aAAc,CACf,qBAEC,wBAAyB,CAC1B,2BAEC,2BACA,2BAA4B,CAC7B,0BAEC,8BACA,+BACA,kBAAmB,CACpB,gCAEC,eACA,yBACA,UAAW,CACZ,8BAGC,WACA,YACA,gBAAiB,CAClB,mDAOC,+CACA,eAAgB,CACjB,0BAEC,cAAe,CAChB,wCAGC,cAAe,CAChB,yCAEC,cAAe,CAChB,wBAMC,oCACA,gBACA,iBAAkB,CACnB,+BAEC,kGACA,WACA,WAAY,CACb,+CAEC,qGACA,yBAA0B,CAC3B,8CAEC,WACA,WAAY,CACb,qHAGC,YAAa,CACd,8DAEC,cACA,iBAAkB,CACnB,iCAEC,yBACA,WACA,eAAgB,CACjB,kCAEC,kBACA,iBAAkB,CACnB,iCAEC,eACA,kBACA,OAAQ,CACT,8BAEC,aAAc,CACf,kCAEC,SACA,0BACA,yBAA0B,CAC3B,gDAMC,gBACA,8BACA,QAAS,CACV,yDAGC,cACA,UAAW,CACZ,+BAEC,oBAAqB,CACtB,qCAEC,yBAA0B,CAC3B,0FAGC,cAAe,CAChB,qCAEC,eAAgB,CACjB,uCAEC,iBAAkB,CACnB,4BAEC,sBACA,gBACA,gBACA,oBACA,eACA,mBACA,gBACA,AACA,sBAEA,gBACA,6BAAoC,CACrC,8CAEC,0BACA,mBACA,eAAgB,CACjB,+DAEC,4BAA6B,CAC9B,+GAKC,eAAgB,CACjB,mEAGC,gCACA,2BAA4B,CAC7B,eAMC,kBACA,iBAAkB,CACnB,+BAEC,YACA,gBACA,iBAAmB,CACpB,uBAEC,iBACA,eAAgB,CACjB,yBAEC,aAAc,CACf,6BAEC,cACA,WACA,YACA,kBACA,eAAgB,CACjB,mBAEC,WACA,YACA,YAEA,oBAEA,gCACA,AAGA,uBAAwB,CACzB,kDAGC,gBACA,WACA,oCAAsC,CACvC,gDAEC,kBACA,MACA,QACA,oBACA,YACA,kBACA,WACA,YACA,wCACA,cACA,qBACA,gBACA,sBAAuB,CACxB,sDAEC,UAAW,CACZ,wBAEC,cACA,6BACA,yBAA0B,CAC3B,8CAGC,MAAO,CACR,kCAEC,WACA,cAEA,oHACA,6GAAiH,CAClH,4CAEC,eAAgB,CACjB,4JAMC,qBAAsB,CACvB,kBAMC,gBACA,qBAAsB,CCtgBxB,eACE,WAAY,CAEb,oBAIG,WACA,YAAa,CACd,uBAID,gBACA,oCACA,kBACA,gBACA,kBACA,UACA,aACA,aAAe,CARjB,0BAWI,aACA,cACA,eAAgB,CAbpB,yBAiBI,eAAgB,CAjBpB,qCAqBI,aAAe,CArBnB,uCAwBM,cAAe,CAxBrB,6BA6BI,kBACA,YACA,WACA,eACA,cACA,QAAS,CAlCb,oCAqCM,iBACA,qBACA,gBACA,eACA,cACA,gBAAiB,CAClB,qBAKH,SACA,eACA,iBACA,YACA,uBACA,gBACA,kBAAmB,CACpB,oBAGC,mDACA,kBACA,kBACA,aACA,cAAgB,CALlB,0BAQI,WACA,cACA,kBACA,SACA,QACA,SACA,SACA,SACA,6BACA,kCACA,kCAAmC,CACpC,wFAID,sEACA,AAEA,qDAAyD,CAC1D,sBAIC,kBAAmB,CACpB,AAsBA,mLAGC,wBAAiC,CAClC,gBAGC,WACA,4BACA,mBACA,qBACA,sBACA,4BACA,0BAA4B,CAC7B,oBAEC,WACA,YAEA,kBACA,kBAAmB,CAEpB,qBAEC,iBACA,cAAe,CAEhB","file":"lbaLeafletMap.scss","sourcesContent":["/* required styles */\r\n\r\n.leaflet-pane,\r\n.leaflet-tile,\r\n.leaflet-marker-icon,\r\n.leaflet-marker-shadow,\r\n.leaflet-tile-container,\r\n.leaflet-map-pane svg,\r\n.leaflet-map-pane canvas,\r\n.leaflet-zoom-box,\r\n.leaflet-image-layer,\r\n.leaflet-layer {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n}\r\n.leaflet-container {\r\n  overflow: hidden;\r\n  -ms-touch-action: none;\r\n  touch-action: none;\r\n}\r\n.leaflet-tile,\r\n.leaflet-marker-icon,\r\n.leaflet-marker-shadow {\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  user-select: none;\r\n  -webkit-user-drag: none;\r\n}\r\n/* Safari renders non-retina tile on retina better with this, but Chrome is worse */\r\n.leaflet-safari .leaflet-tile {\r\n  image-rendering: -webkit-optimize-contrast;\r\n}\r\n/* hack that prevents hw layers \"stretching\" when loading new tiles */\r\n.leaflet-safari .leaflet-tile-container {\r\n  width: 1600px;\r\n  height: 1600px;\r\n  -webkit-transform-origin: 0 0;\r\n}\r\n.leaflet-marker-icon,\r\n.leaflet-marker-shadow {\r\n  display: block;\r\n}\r\n/* .leaflet-container svg: reset svg max-width decleration shipped in Joomla! (joomla.org) 3.x */\r\n/* .leaflet-container img: map is broken in FF if you have max-width: 100% on tiles */\r\n.leaflet-container .leaflet-overlay-pane svg,\r\n.leaflet-container .leaflet-marker-pane img,\r\n.leaflet-container .leaflet-tile-pane img,\r\n.leaflet-container img.leaflet-image-layer {\r\n  max-width: none !important;\r\n}\r\n.leaflet-tile {\r\n  filter: inherit;\r\n  visibility: hidden;\r\n}\r\n.leaflet-tile-loaded {\r\n  visibility: inherit;\r\n}\r\n.leaflet-zoom-box {\r\n  width: 0;\r\n  height: 0;\r\n  -moz-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n  z-index: 800;\r\n}\r\n/* workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=888319 */\r\n.leaflet-overlay-pane svg {\r\n  -moz-user-select: none;\r\n}\r\n\r\n.leaflet-pane         { z-index: 400; }\r\n\r\n.leaflet-tile-pane    { z-index: 200; }\r\n.leaflet-overlay-pane { z-index: 400; }\r\n.leaflet-shadow-pane  { z-index: 500; }\r\n.leaflet-marker-pane  { z-index: 600; }\r\n.leaflet-popup-pane   { z-index: 700; }\r\n\r\n.leaflet-map-pane canvas { z-index: 100; }\r\n.leaflet-map-pane svg    { z-index: 200; }\r\n\r\n.leaflet-vml-shape {\r\n  width: 1px;\r\n  height: 1px;\r\n}\r\n.lvml {\r\n  behavior: url(#default#VML);\r\n  display: inline-block;\r\n  position: absolute;\r\n}\r\n\r\n\r\n/* control positioning */\r\n\r\n.leaflet-control {\r\n  position: relative;\r\n  z-index: 800;\r\n  pointer-events: auto;\r\n}\r\n.leaflet-top,\r\n.leaflet-bottom {\r\n  position: absolute;\r\n  z-index: 1000;\r\n  pointer-events: none;\r\n}\r\n.leaflet-top {\r\n  top: 0;\r\n}\r\n.leaflet-right {\r\n  right: 0;\r\n}\r\n.leaflet-bottom {\r\n  bottom: 0;\r\n}\r\n.leaflet-left {\r\n  left: 0;\r\n}\r\n.leaflet-control {\r\n  float: left;\r\n  clear: both;\r\n}\r\n.leaflet-right .leaflet-control {\r\n  float: right;\r\n}\r\n.leaflet-top .leaflet-control {\r\n  margin-top: 10px;\r\n}\r\n.leaflet-bottom .leaflet-control {\r\n  margin-bottom: 10px;\r\n}\r\n.leaflet-left .leaflet-control {\r\n  margin-left: 10px;\r\n}\r\n.leaflet-right .leaflet-control {\r\n  margin-right: 10px;\r\n}\r\n\r\n\r\n/* zoom and fade animations */\r\n\r\n.leaflet-fade-anim .leaflet-tile {\r\n  will-change: opacity;\r\n}\r\n.leaflet-fade-anim .leaflet-popup {\r\n  opacity: 0;\r\n  -webkit-transition: opacity 0.2s linear;\r\n  -moz-transition: opacity 0.2s linear;\r\n  -o-transition: opacity 0.2s linear;\r\n  transition: opacity 0.2s linear;\r\n}\r\n.leaflet-fade-anim .leaflet-map-pane .leaflet-popup {\r\n  opacity: 1;\r\n}\r\n.leaflet-zoom-animated {\r\n  -webkit-transform-origin: 0 0;\r\n  -ms-transform-origin: 0 0;\r\n  transform-origin: 0 0;\r\n}\r\n.leaflet-zoom-anim .leaflet-zoom-animated {\r\n  will-change: transform;\r\n}\r\n.leaflet-zoom-anim .leaflet-zoom-animated {\r\n  -webkit-transition: -webkit-transform 0.25s cubic-bezier(0,0,0.25,1);\r\n  -moz-transition:    -moz-transform 0.25s cubic-bezier(0,0,0.25,1);\r\n  -o-transition:      -o-transform 0.25s cubic-bezier(0,0,0.25,1);\r\n  transition:         transform 0.25s cubic-bezier(0,0,0.25,1);\r\n}\r\n.leaflet-zoom-anim .leaflet-tile,\r\n.leaflet-pan-anim .leaflet-tile {\r\n  -webkit-transition: none;\r\n  -moz-transition: none;\r\n  -o-transition: none;\r\n  transition: none;\r\n}\r\n\r\n.leaflet-zoom-anim .leaflet-zoom-hide {\r\n  visibility: hidden;\r\n}\r\n\r\n\r\n/* cursors */\r\n\r\n.leaflet-interactive {\r\n  cursor: pointer;\r\n}\r\n.leaflet-grab {\r\n  cursor: -webkit-grab;\r\n  cursor:    -moz-grab;\r\n}\r\n.leaflet-crosshair,\r\n.leaflet-crosshair .leaflet-interactive {\r\n  cursor: crosshair;\r\n}\r\n.leaflet-popup-pane,\r\n.leaflet-control {\r\n  cursor: auto;\r\n}\r\n.leaflet-dragging .leaflet-grab,\r\n.leaflet-dragging .leaflet-grab .leaflet-interactive,\r\n.leaflet-dragging .leaflet-marker-draggable {\r\n  cursor: move;\r\n  cursor: -webkit-grabbing;\r\n  cursor:    -moz-grabbing;\r\n}\r\n\r\n/* marker & overlays interactivity */\r\n.leaflet-marker-icon,\r\n.leaflet-marker-shadow,\r\n.leaflet-image-layer,\r\n.leaflet-pane > svg path,\r\n.leaflet-tile-container {\r\n  pointer-events: none;\r\n}\r\n\r\n.leaflet-marker-icon.leaflet-interactive,\r\n.leaflet-image-layer.leaflet-interactive,\r\n.leaflet-pane > svg path.leaflet-interactive {\r\n  pointer-events: auto;\r\n}\r\n\r\n/* visual tweaks */\r\n\r\n.leaflet-container {\r\n  background: #ddd;\r\n  outline: 0;\r\n}\r\n.leaflet-container a {\r\n  color: #0078A8;\r\n}\r\n.leaflet-container a.leaflet-active {\r\n  outline: 2px solid orange;\r\n}\r\n.leaflet-zoom-box {\r\n  border: 2px dotted #38f;\r\n  background: rgba(255,255,255,0.5);\r\n}\r\n\r\n\r\n/* general typography */\r\n.leaflet-container {\r\n  font: 12px/1.5 \"Helvetica Neue\", Arial, Helvetica, sans-serif;\r\n}\r\n\r\n\r\n/* general toolbar styles */\r\n\r\n.leaflet-bar {\r\n  box-shadow: 0 1px 5px rgba(0,0,0,0.65);\r\n  border-radius: 4px;\r\n}\r\n.leaflet-bar a,\r\n.leaflet-bar a:hover {\r\n  background-color: #fff;\r\n  border-bottom: 1px solid #ccc;\r\n  width: 26px;\r\n  height: 26px;\r\n  line-height: 26px;\r\n  display: block;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  color: black;\r\n}\r\n.leaflet-bar a,\r\n.leaflet-control-layers-toggle {\r\n  background-position: 50% 50%;\r\n  background-repeat: no-repeat;\r\n  display: block;\r\n}\r\n.leaflet-bar a:hover {\r\n  background-color: #f4f4f4;\r\n}\r\n.leaflet-bar a:first-child {\r\n  border-top-left-radius: 4px;\r\n  border-top-right-radius: 4px;\r\n}\r\n.leaflet-bar a:last-child {\r\n  border-bottom-left-radius: 4px;\r\n  border-bottom-right-radius: 4px;\r\n  border-bottom: none;\r\n}\r\n.leaflet-bar a.leaflet-disabled {\r\n  cursor: default;\r\n  background-color: #f4f4f4;\r\n  color: #bbb;\r\n}\r\n\r\n.leaflet-touch .leaflet-bar a {\r\n  width: 30px;\r\n  height: 30px;\r\n  line-height: 30px;\r\n}\r\n\r\n\r\n/* zoom control */\r\n\r\n.leaflet-control-zoom-in,\r\n.leaflet-control-zoom-out {\r\n  font: bold 18px 'Lucida Console', Monaco, monospace;\r\n  text-indent: 1px;\r\n}\r\n.leaflet-control-zoom-out {\r\n  font-size: 20px;\r\n}\r\n\r\n.leaflet-touch .leaflet-control-zoom-in {\r\n  font-size: 22px;\r\n}\r\n.leaflet-touch .leaflet-control-zoom-out {\r\n  font-size: 24px;\r\n}\r\n\r\n\r\n/* layers control */\r\n\r\n.leaflet-control-layers {\r\n  box-shadow: 0 1px 5px rgba(0,0,0,0.4);\r\n  background: #fff;\r\n  border-radius: 5px;\r\n}\r\n.leaflet-control-layers-toggle {\r\n  background-image: url(https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.0.0-rc.1/images/layers.png);\r\n  width: 36px;\r\n  height: 36px;\r\n}\r\n.leaflet-retina .leaflet-control-layers-toggle {\r\n  background-image: url(https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.0.0-rc.1/images/layers-2x.png);\r\n  background-size: 26px 26px;\r\n}\r\n.leaflet-touch .leaflet-control-layers-toggle {\r\n  width: 44px;\r\n  height: 44px;\r\n}\r\n.leaflet-control-layers .leaflet-control-layers-list,\r\n.leaflet-control-layers-expanded .leaflet-control-layers-toggle {\r\n  display: none;\r\n}\r\n.leaflet-control-layers-expanded .leaflet-control-layers-list {\r\n  display: block;\r\n  position: relative;\r\n}\r\n.leaflet-control-layers-expanded {\r\n  padding: 6px 10px 6px 6px;\r\n  color: #333;\r\n  background: #fff;\r\n}\r\n.leaflet-control-layers-scrollbar {\r\n  overflow-y: scroll;\r\n  padding-right: 5px;\r\n}\r\n.leaflet-control-layers-selector {\r\n  margin-top: 2px;\r\n  position: relative;\r\n  top: 1px;\r\n}\r\n.leaflet-control-layers label {\r\n  display: block;\r\n}\r\n.leaflet-control-layers-separator {\r\n  height: 0;\r\n  border-top: 1px solid #ddd;\r\n  margin: 5px -10px 5px -6px;\r\n}\r\n\r\n\r\n/* attribution and scale controls */\r\n\r\n.leaflet-container .leaflet-control-attribution {\r\n  background: #fff;\r\n  background: rgba(255, 255, 255, 0.7);\r\n  margin: 0;\r\n}\r\n.leaflet-control-attribution,\r\n.leaflet-control-scale-line {\r\n  padding: 0 5px;\r\n  color: #333;\r\n}\r\n.leaflet-control-attribution a {\r\n  text-decoration: none;\r\n}\r\n.leaflet-control-attribution a:hover {\r\n  text-decoration: underline;\r\n}\r\n.leaflet-container .leaflet-control-attribution,\r\n.leaflet-container .leaflet-control-scale {\r\n  font-size: 11px;\r\n}\r\n.leaflet-left .leaflet-control-scale {\r\n  margin-left: 5px;\r\n}\r\n.leaflet-bottom .leaflet-control-scale {\r\n  margin-bottom: 5px;\r\n}\r\n.leaflet-control-scale-line {\r\n  border: 2px solid #777;\r\n  border-top: none;\r\n  line-height: 1.1;\r\n  padding: 2px 5px 1px;\r\n  font-size: 11px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  -moz-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n\r\n  background: #fff;\r\n  background: rgba(255, 255, 255, 0.5);\r\n}\r\n.leaflet-control-scale-line:not(:first-child) {\r\n  border-top: 2px solid #777;\r\n  border-bottom: none;\r\n  margin-top: -2px;\r\n}\r\n.leaflet-control-scale-line:not(:first-child):not(:last-child) {\r\n  border-bottom: 2px solid #777;\r\n}\r\n\r\n.leaflet-touch .leaflet-control-attribution,\r\n.leaflet-touch .leaflet-control-layers,\r\n.leaflet-touch .leaflet-bar {\r\n  box-shadow: none;\r\n}\r\n.leaflet-touch .leaflet-control-layers,\r\n.leaflet-touch .leaflet-bar {\r\n  border: 2px solid rgba(0,0,0,0.2);\r\n  background-clip: padding-box;\r\n}\r\n\r\n\r\n/* popup */\r\n\r\n.leaflet-popup {\r\n  position: absolute;\r\n  text-align: center;\r\n}\r\n.leaflet-popup-content-wrapper {\r\n  padding: 1px;\r\n  text-align: left;\r\n  border-radius: 12px;\r\n}\r\n.leaflet-popup-content {\r\n  margin: 13px 19px;\r\n  line-height: 1.4;\r\n}\r\n.leaflet-popup-content p {\r\n  margin: 18px 0;\r\n}\r\n.leaflet-popup-tip-container {\r\n  margin: 0 auto;\r\n  width: 40px;\r\n  height: 20px;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n.leaflet-popup-tip {\r\n  width: 17px;\r\n  height: 17px;\r\n  padding: 1px;\r\n\r\n  margin: -10px auto 0;\r\n\r\n  -webkit-transform: rotate(45deg);\r\n  -moz-transform: rotate(45deg);\r\n  -ms-transform: rotate(45deg);\r\n  -o-transform: rotate(45deg);\r\n  transform: rotate(45deg);\r\n}\r\n.leaflet-popup-content-wrapper,\r\n.leaflet-popup-tip {\r\n  background: white;\r\n  color: #333;\r\n  box-shadow: 0 3px 14px rgba(0,0,0,0.4);\r\n}\r\n.leaflet-container a.leaflet-popup-close-button {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  padding: 4px 4px 0 0;\r\n  border: none;\r\n  text-align: center;\r\n  width: 18px;\r\n  height: 14px;\r\n  font: 16px/14px Tahoma, Verdana, sans-serif;\r\n  color: #c3c3c3;\r\n  text-decoration: none;\r\n  font-weight: bold;\r\n  background: transparent;\r\n}\r\n.leaflet-container a.leaflet-popup-close-button:hover {\r\n  color: #999;\r\n}\r\n.leaflet-popup-scrolled {\r\n  overflow: auto;\r\n  border-bottom: 1px solid #ddd;\r\n  border-top: 1px solid #ddd;\r\n}\r\n\r\n.leaflet-oldie .leaflet-popup-content-wrapper {\r\n  zoom: 1;\r\n}\r\n.leaflet-oldie .leaflet-popup-tip {\r\n  width: 24px;\r\n  margin: 0 auto;\r\n\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678)\";\r\n  filter: progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678);\r\n}\r\n.leaflet-oldie .leaflet-popup-tip-container {\r\n  margin-top: -1px;\r\n}\r\n\r\n.leaflet-oldie .leaflet-control-zoom,\r\n.leaflet-oldie .leaflet-control-layers,\r\n.leaflet-oldie .leaflet-popup-content-wrapper,\r\n.leaflet-oldie .leaflet-popup-tip {\r\n  border: 1px solid #999;\r\n}\r\n\r\n\r\n/* div icon */\r\n\r\n.leaflet-div-icon {\r\n  background: #fff;\r\n  border: 1px solid #666;\r\n}\r\n","@import 'leaflet';\r\n\r\n\r\n.marker-active {\r\n  width: 300px;\r\n\r\n}\r\n\r\n.lbaLeafletMap {\r\n  .map {\r\n    width: 100%;\r\n    height: 650px;\r\n  }\r\n}\r\n\r\n.marker-active_content {\r\n  background: #fff;\r\n  box-shadow: 0 0 10px rgba(0,0,0,.25);\r\n  border-radius: 4px;\r\n  min-height: 70px;\r\n  position: relative;\r\n  z-index: 1;\r\n  padding: 25px;\r\n  font-size: 16px;\r\n\r\n  h3 {\r\n    margin-top: 0;\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n  }\r\n\r\n  p {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .rating-stars {\r\n    font-size: 16px;\r\n\r\n    i {\r\n      margin-right: 0;\r\n    }\r\n  }\r\n\r\n  .from {\r\n    position: absolute;\r\n    bottom: 10px;\r\n    right: 15px;\r\n    font-size: 10px;\r\n    color: #a6a8ab;\r\n    margin: 0;\r\n\r\n    .price {\r\n      margin: 0 0 0 2px;\r\n      display: inline-block;\r\n      font-weight: 700;\r\n      font-size: 26px;\r\n      color: #99ba48;\r\n      line-height: 27px;\r\n    }\r\n  }\r\n}\r\n\r\n.marker-active_title {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  line-height: 20px;\r\n  width: 238px;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n}\r\n\r\n.marker-active_icon {\r\n  background: url('./pushpin-active.png') no-repeat;\r\n  margin-left: 150px;\r\n  position: relative;\r\n  z-index: 1000;\r\n  min-height: 32px;\r\n\r\n  &:after {\r\n    content: '';\r\n    display: block;\r\n    position: absolute;\r\n    bottom: 0;\r\n    width: 0;\r\n    height: 0;\r\n    border: 0;\r\n    left: 2px;\r\n    border-bottom: 8px solid #fff;\r\n    border-left: 8px solid transparent;\r\n    border-right: 8px solid transparent;\r\n  }\r\n}\r\n\r\n.leaflet-cluster-anim .leaflet-marker-icon, .leaflet-cluster-anim .leaflet-marker-shadow {\r\n  -webkit-transition: -webkit-transform 0.3s ease-out, opacity 0.3s ease-in;\r\n  -moz-transition: -moz-transform 0.3s ease-out, opacity 0.3s ease-in;\r\n  -o-transition: -o-transform 0.3s ease-out, opacity 0.3s ease-in;\r\n  transition: transform 0.3s ease-out, opacity 0.3s ease-in;\r\n}\r\n\r\n\r\n.marker-cluster:hover {\r\n  background: #9bb733;\r\n}\r\n\r\n.marker-cluster-small {\r\n  background-color: rgba(71, 8, 75, 1);\r\n}\r\n\r\n\r\n.marker-cluster-medium {\r\n  background-color: rgba(71, 8, 75, 1);\r\n}\r\n\r\n.marker-cluster-large {\r\n  background-color: rgba(71, 8, 75, 1);\r\n}\r\n\r\n/* IE 6-8 fallback colors */\r\n.leaflet-oldie .marker-cluster-small {\r\n  background-color: rgb(71, 8, 75);\r\n}\r\n\r\n.leaflet-oldie .marker-cluster-medium {\r\n  background-color: rgb(71, 8, 75);\r\n}\r\n\r\n.leaflet-oldie .marker-cluster-large {\r\n  background-color:  rgb(71, 8, 75);\r\n}\r\n\r\n.marker-cluster {\r\n  color: #fff;\r\n  background-clip: padding-box;\r\n  border-radius: 10px;\r\n  width: 20px !important;\r\n  height: 20px !important;\r\n  margin-left: -10px !important;\r\n  margin-top: -10px !important;\r\n}\r\n.marker-cluster div {\r\n  width: 20px;\r\n  height: 20px;\r\n\r\n  text-align: center;\r\n  border-radius: 10px;\r\n  //font: 12px \"Helvetica Neue\", Arial, Helvetica, sans-serif;\r\n}\r\n.marker-cluster span {\r\n  line-height:20px;\r\n  font-size: 11px;\r\n\r\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 285 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAYCAYAAADzoH0MAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA25pVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTExIDc5LjE1ODMyNSwgMjAxNS8wOS8xMC0wMToxMDoyMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo2REE3MEUzRDQ5NDgxMUU1QURGMUZFNDdBNUYxMDA3QiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpBMkJBNjY2QzE4QTgxMUU2ODEwNTkwRUQ3RDAxMDMwMSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpBMkJBNjY2QjE4QTgxMUU2ODEwNTkwRUQ3RDAxMDMwMSIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxNSAoV2luZG93cykiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo0ODI3ZmUzMy1iN2ZiLTc3NGQtYjA4Zi1kZmZjNmNkYTlhNDMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NkRBNzBFM0Q0OTQ4MTFFNUFERjFGRTQ3QTVGMTAwN0IiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5MgV+YAAABZElEQVR42pyTvUoDQRSFx2ETFot9gTR5B2EhCZap7VPHOmgheQEhYJEyEK0ESW1lIanE/EiewWLRIrXFyhbqGTgr18nMZPHAt+zeuffs3PmJrh+OlKUU9EEXNBh7B4/gBrzIZC3eE3AH1uAUNEGNNBlbMyexDRL+oaf2q8fcRBpMOHVbn8TV5qQ0SB1/Nn12wCHp2L2zJtVcMLv4GCzAN1kwZpv0NVdb6gwUjmkXHJPqarFVZc/LwAIurTVpaG7Tf1UzBpkIxKAVKGgxp1RmDOZW0hjUHcV1jknNjcHUscdPoA0OSJsx+6xMIzxW4B6cWCbPYsFix4xMzao8ieeerYs9xQVrfo/yq6O/kMas+XMbL8G2QvGWuTvX+QMMKxgMmbtjYHQLNoHiDXOUz+ALDAIGA+Z4DRRv3swRn3FM7TMwugC5+M4ZU1UN3sBIfI8Yq2xgdMWLlvHdqShgIKed+5J+BBgAC0ZNCrqzdh0AAAAASUVORK5CYII="

/***/ },
/* 286 */
/***/ function(module, exports) {

	var v1="<div class=\"lbaLeafletMap\"> <div class=\"map\" ng-attr-id=\"{{vm.mapId}}\"></div> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaLeafletMapTemplate.html", v1)}]);
	module.exports=v1;

/***/ },
/* 287 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', 'dataService', 'pointsOfInterestService', '$timeout', '$rootScope', '$scope'];
	
	var lbaPointsOfInterestCtrl = function lbaPointsOfInterestCtrl($q, dataService, pointsOfInterestService, $timeout, $rootScope, $scope) {
	  var vm = this;
	  var debtorsEndpoint = 'Debtors';
	  var pointsOfInterestEndpoint = 'PointOfInterests';
	
	  vm.detailActive = false;
	
	  vm.refreshDebtors = refreshDebtors;
	  vm.getPointsOfInterest = getPointsOfInterest;
	  vm.toggleDetail = toggleDetail;
	  vm.editItem = editItem;
	  vm.newItem = newItem;
	  vm.saveItem = saveItem;
	  vm.deleteItem = deleteItem;
	  vm.activateItem = activateItem;
	  vm.toggleItemActive = toggleItemActive;
	  vm.activeItem = {};
	
	  function activateItem(item) {
	    $rootScope.$emit('leaflet.highlight', item);
	    toggleItemActive(item);
	  }
	
	  function toggleItemActive(item, digest) {
	    vm.activeItem.active = false;
	    vm.activeItem = item;
	
	    if (digest) {
	      $scope.$apply(function () {
	        item.active = true;
	      });
	    } else {
	      item.active = true;
	    }
	  }
	
	  function toggleDetail() {
	    vm.detailActive = !vm.detailActive;
	  }
	
	  function editItem(item) {
	    // toggle form
	    vm.activePointOfInterest = item;
	    vm.detailActive = true;
	  }
	
	  function newItem() {
	    // toggle form
	    vm.activePointOfInterest = null;
	    vm.detailActive = true;
	  }
	
	  function saveItem(item) {
	    var deferred = $q.defer();
	    pointsOfInterestService.savePointOfInterest(vm.debtor.Name, item).then(function (success) {
	      getPointsOfInterest(function () {
	        deferred.resolve(success);
	        $timeout(function () {
	          $rootScope.$emit('leaflet.refresh', vm.refreshMap);
	        });
	      });
	    })['catch'](function (data) {
	      deferred.reject(data);
	    });;
	    return deferred.promise;
	  }
	
	  function deleteItem(itemId) {
	    var deferred = $q.defer();
	    pointsOfInterestService.deletePointOfInterest({ id: itemId }).then(function (data) {
	      getPointsOfInterest(function () {
	        deferred.resolve(data);
	        $timeout(function () {
	          $rootScope.$emit('leaflet.refresh', vm.refreshMap);
	        });
	      });
	    })['catch'](function (data) {
	      deferred.reject(data);
	    });
	    return deferred.promise;
	  }
	
	  function getPointsOfInterest(cb) {
	    loadMap();
	    var optionalParameters = {
	      includeDeleted: false
	    };
	    dataService.search(pointsOfInterestEndpoint, vm.debtor.Name, 'DebtorIdentifier', null, optionalParameters).then(function (result) {
	      vm.pointsOfInterest = result;
	
	      $timeout(function () {
	        $rootScope.$emit('leaflet.refresh', vm.refreshMap);
	      });
	
	      if (typeof cb !== 'undefined') {
	        cb();
	      }
	    });
	  }
	
	  function loadMap() {
	    vm.showMap = true;
	  }
	
	  function refreshDebtors(selected) {
	    dataService.search(debtorsEndpoint, selected, 'Name', 'contains').then(function (result) {
	      vm.debtors = result;
	    });
	  }
	};
	
	lbaPointsOfInterestCtrl.$inject = $inject;
	
	exports['default'] = lbaPointsOfInterestCtrl;
	module.exports = exports['default'];

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(289);
	var $inject = [];
	var lbaPointsOfInterest = function lbaPointsOfInterest() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaPointsOfInterestCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(291)
	  };
	};
	
	lbaPointsOfInterest.$inject = $inject;
	
	exports['default'] = lbaPointsOfInterest;
	module.exports = exports['default'];

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(290);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaPointsOfInterest.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaPointsOfInterest.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".pointsOfInterest_selectDebtors{margin-bottom:3rem;position:relative;z-index:100}.lbaPointsOfInterest_map{position:relative;z-index:1}.lbaPointsOfInterest_slider{overflow:hidden}.lbaPointsOfInterest_slider_container{width:210%;box-sizing:border-box;display:block;transition:transform .4s}.lbaPointsOfInterest_slider_container.detailActive{transform:translate(-50%, 0)}.lbaPointsOfInterest_slider_col{width:50%;padding-right:5%;box-sizing:border-box;display:block;float:left}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaPointsOfInterest/src/components/lbaPointsOfInterest/lbaPointsOfInterest.scss"],"names":[],"mappings":"AAMA,gCACE,mBACA,kBACA,WAAY,CACb,yBAGC,kBACA,SAAU,CACX,4BAGC,eAAgB,CACjB,sCAGC,WACA,sBACA,cACA,wBAAyB,CAJ3B,mDAOI,4BAA4B,CAC7B,gCAID,UACA,iBACA,sBACA,cACA,UAAW,CACZ","file":"lbaPointsOfInterest.scss","sourcesContent":["@import '../lbaPointsOfInterest/helpers';\r\n\r\n.lbaPointsOfInterest {\r\n\r\n}\r\n\r\n.pointsOfInterest_selectDebtors {\r\n  margin-bottom: 3rem;\r\n  position: relative;\r\n  z-index: 100;\r\n}\r\n\r\n.lbaPointsOfInterest_map {\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.lbaPointsOfInterest_slider {\r\n  overflow: hidden;\r\n}\r\n\r\n.lbaPointsOfInterest_slider_container {\r\n  width: 210%;\r\n  box-sizing: border-box;\r\n  display: block;\r\n  transition: transform .4s;\r\n\r\n  &.detailActive {\r\n    transform: translate(-50%,0);\r\n  }\r\n}\r\n\r\n.lbaPointsOfInterest_slider_col {\r\n  width: 50%;\r\n  padding-right: 5%;\r\n  box-sizing: border-box;\r\n  display: block;\r\n  float: left;\r\n}\r\n\r\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 291 */
/***/ function(module, exports) {

	var v1="<div class=\"pointsOfInterest\"> <div class=\"pointsOfInterest_selectDebtors\"> <ui-select ng-model=\"vm.debtor\" name=\"debtors\" id=\"debtors\" on-select=\"vm.getPointsOfInterest()\"> <ui-select-match placeholder=\"Search Debtors\" class=\"ui-select-match\"> {{ $select.selected.Name }} </ui-select-match> <ui-select-choices repeat=\"debtor in vm.debtors\" refresh=\"vm.refreshDebtors($select.search)\" refresh-delay=\"200\" minimum-input-length=\"1\"> {{ debtor.Name }} </ui-select-choices> </ui-select> </div> <div class=\"pointsOfInterest_debtors_header page-header\" ng-if=\"vm.debtor\"> <h1> {{vm.debtor.Name}} </h1> </div> <div class=\"row lbaPointsOfInterest_map\"> <lba-leaflet-map ng-if=\"vm.showMap\" class=\"col-md-9\" locations=\"vm.pointsOfInterest\" marker-click=\"vm.toggleItemActive\" grid-size=\"80\"> </lba-leaflet-map> <div class=\"col-md-3\"> <div class=\"lbaPointsOfInterest_slider\"> <div class=\"lbaPointsOfInterest_slider_container\" ng-class=\"{'detailActive': vm.detailActive}\"> <div class=\"lbaPointsOfInterest_slider_col\"> <lba-points-of-interest-list ng-if=\"vm.debtor.Name\" points-of-interest=\"vm.pointsOfInterest\" new-item=\"vm.newItem\" activate-item=\"vm.activateItem\" edit-item=\"vm.editItem\"> </lba-points-of-interest-list> </div> <div class=\"lbaPointsOfInterest_slider_col\"> <lba-points-of-interest-item-form ng-if=\"vm.detailActive\" point-of-interest=\"vm.activePointOfInterest\" toggle-detail=\"vm.toggleDetail\" save-item=\"vm.saveItem\" delete-item=\"vm.deleteItem\"> </lba-points-of-interest-item-form> </div> </div> </div> </div> </div> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaPointsOfInterest.html", v1)}]);
	module.exports=v1;

/***/ },
/* 292 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var $inject = ['$q', '$timeout', 'dataService'];
	
	var pointsOfInterestService = function pointsOfInterestService($q, $timeout, dataService) {
	    var service = {};
	
	    service.savePointOfInterest = savePointOfInterest;
	    service.deletePointOfInterest = deletePointOfInterest;
	
	    function deletePointOfInterest(item) {
	        var deferred = $q.defer();
	
	        dataService['delete']('PointOfInterests', item.id).then(function () {
	            deferred.resolve({ message: 'done' });
	        })['catch'](function (data) {
	            deferred.reject(data);
	        });
	
	        return deferred.promise;
	    }
	
	    function savePointOfInterest(debtor, item) {
	        var deferred = $q.defer();
	        var itemCopy = {};
	
	        item.DebtorIdentifier = item.DebtorIdentifier || debtor;
	        item.Type = item.Type || "PointOfInterest";
	
	        item.Longitude = parseFloat(item.Longitude);
	        item.Latitude = parseFloat(item.Latitude);
	
	        item.Location = {
	            coordinates: [item.Longitude, item.Latitude],
	            type: "Point"
	        };
	
	        angular.copy(item, itemCopy);
	
	        var id = itemCopy.Id || itemCopy.id;
	
	        delete itemCopy.marker;
	        delete itemCopy.active;
	
	        // Do not send identity/system fields in create/update payloads.
	        delete itemCopy.Id;
	        delete itemCopy.id;
	        delete itemCopy.CreatedBy;
	        delete itemCopy.CreatedOn;
	        delete itemCopy.ModifiedBy;
	        delete itemCopy.ModifiedOn;
	        delete itemCopy.ETag;
	        delete itemCopy._etag;
	        delete itemCopy.PartitionKey;
	        delete itemCopy._partitionKey;
	
	        var request = id ? dataService.patch('PointOfInterests', itemCopy, id) : dataService.post('PointOfInterests', itemCopy);
	
	        request.then(function (data) {
	            deferred.resolve(data);
	        })['catch'](function (data) {
	            deferred.reject(data);
	        });
	
	        return deferred.promise;
	    }
	
	    return service;
	};
	
	pointsOfInterestService.$inject = $inject;
	
	exports['default'] = pointsOfInterestService;
	module.exports = exports['default'];

/***/ },
/* 293 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$http'];
	
	var lbaLeafletMapServiceService = function lbaLeafletMapServiceService($q, $http) {
	  var service = {};
	
	  service.getPosByAddress = function get(query) {
	    var deferred = $q.defer();
	
	    query = encodeURIComponent(query);
	    console.log('lbaLeafletMapService.js - Query:', query);
	
	    var url = 'https://nominatim.openstreetmap.org/search?format=json&q=' + query;
	
	    $http.get(url).success(function (data) {
	      var mappedData = {
	        resourceSets: [{
	          resources: []
	        }]
	      };
	
	      if (data && data.length > 0) {
	        mappedData.resourceSets[0].resources = data.map(function (item) {
	          var lat = parseFloat(item.lat);
	          var lon = parseFloat(item.lon);
	
	          return {
	            // Keep original structure for compatibility
	            point: {
	              coordinates: [lat, lon]
	            },
	            geocodePoints: [{
	              coordinates: [lat, lon]
	            }],
	            name: item.display_name,
	            address: {
	              formattedAddress: item.display_name
	            }
	          };
	        });
	      }
	
	      deferred.resolve(mappedData);
	    }).error(function (error) {
	      deferred.resolve({
	        resourceSets: [{
	          resources: []
	        }]
	      });
	    });
	
	    return deferred.promise;
	  };
	
	  return service;
	};
	
	lbaLeafletMapServiceService.$inject = $inject;
	
	exports['default'] = lbaLeafletMapServiceService;
	module.exports = exports['default'];

/***/ },
/* 294 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaRedirect = angular.module('app.lbaRedirect', []);
	
	lbaRedirect.component('lbaRedirect', {
	  controllerAs: 'vm',
	  controller: ['$location', lbaRedirectCtrl],
	  template: '<div>Redirecting...</div>'
	});
	
	function lbaRedirectCtrl($location) {
	  var currentPath = $location.path().split('/');
	  currentPath.pop();
	  $location.path(currentPath.join('/'));
	}
	
	exports['default'] = lbaRedirect;
	module.exports = exports['default'];

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaSearchBy = angular.module('app.lbaSearchBy', []);
	
	lbaSearchBy.controller('lbaSearchByCtrl', __webpack_require__(296));
	lbaSearchBy.directive('lbaSearchBy', __webpack_require__(297));
	
	exports['default'] = lbaSearchBy;
	module.exports = exports['default'];

/***/ },
/* 296 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$location', 'dataService'];
	
	var lbaSearchByCtrl = function lbaSearchByCtrl($location, dataService) {
	  var vm = this;
	  vm.search = search;
	  vm.loadResult = loadResult;
	  vm.searchTarget = vm.settings.targetChoices[0];
	  vm.searchResults = [];
	  vm.searchText = '';
	  vm.searching = false;
	
	  function search(searchString) {
	    vm.searching = true;
	    dataService.search(vm.settings.endpoint, searchString, vm.searchTarget).then(function (data) {
	      vm.searching = false;
	      vm.searchResults = data;
	    });
	  }
	
	  function loadResult(id) {
	    $location.path($location.$$path + '/' + id);
	  }
	};
	
	lbaSearchByCtrl.$inject = $inject;
	
	exports['default'] = lbaSearchByCtrl;
	module.exports = exports['default'];

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	__webpack_require__(298);
	
	var $inject = [];
	var lbaSearchBy = function lbaSearchBy() {
	    return {
	        restrict: 'A',
	        scope: {
	            settings: '<'
	        },
	        bindToController: true,
	        controller: 'lbaSearchByCtrl',
	        controllerAs: 'vm',
	        template: '\n<div class="lbaSearchBy">\n    <p>Search by:</p>\n    <select ng-model="vm.searchTarget">\n        <option ng-repeat="item in vm.settings.targetChoices">{{ item }}</option>\n    </select>\n    <input ng-model="vm.searchText" type="text">\n    <button ng-click="vm.search(vm.searchText)" ng-disabled="vm.searchText.length < 2 || vm.searching">Search</button>\n    <div class="lbaSearchBy_searching">\n        <p ng-if="vm.searching">SEARCHING...</p>\n        <p ng-if="!vm.searching">{{ vm.searchResults.length }} results.</p>\n    </div>\n    <ul>\n        <li ng-repeat="item in vm.searchResults">\n            <a ng-click="vm.loadResult(item.Id)">{{ item.Title }}</a>\n        </li>\n    </ul>\n</div>'
	    };
	};
	
	lbaSearchBy.$inject = $inject;
	
	exports['default'] = lbaSearchBy;
	module.exports = exports['default'];

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(299);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaSearchBy.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaSearchBy.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".lbaSearchBy select{width:200px;margin:0 10px 0 0}.lbaSearchBy input[type=text]{margin:0 10px 0 0}.lbaSearchBy button:disabled{opacity:.7}.lbaSearchBy ul{padding:0}.lbaSearchBy li{list-style:none}.lbaSearchBy li:hover{cursor:pointer}.lbaSearchBy_searching{padding:10px 0}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaSearchBy/src/components/lbaSearchBy/lbaSearchBy.scss"],"names":[],"mappings":"AAAA,oBAEI,YACA,iBAAkB,CAHtB,8BAOI,iBAAkB,CAPtB,6BAYM,UAAW,CAZjB,gBAiBI,SAAU,CAjBd,gBAqBI,eAAgB,CArBpB,sBAuBM,cAAe,CAChB,uBAKH,cAAe,CAEhB","file":"lbaSearchBy.scss","sourcesContent":[".lbaSearchBy {\r\n  select {\r\n    width: 200px;\r\n    margin: 0 10px 0 0;\r\n  }\r\n\r\n  input[type=text] {\r\n    margin: 0 10px 0 0;\r\n  }\r\n\r\n  button {\r\n    &:disabled {\r\n      opacity: .7;\r\n    }\r\n  }\r\n\r\n  ul {\r\n    padding: 0;\r\n  }\r\n\r\n  li {\r\n    list-style: none;\r\n    &:hover {\r\n      cursor: pointer;\r\n    }\r\n  }\r\n}\r\n\r\n.lbaSearchBy_searching {\r\n  padding: 10px 0;\r\n\r\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaTextArea = angular.module('app.lbaTextArea', []);
	
	lbaTextArea.controller('lbaTextAreaCtrl', __webpack_require__(301));
	lbaTextArea.directive('lbaTextArea', __webpack_require__(302));
	
	exports['default'] = lbaTextArea;
	module.exports = exports['default'];

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _angular = __webpack_require__(136);
	
	var $inject = ['$scope', '$routeParams', 'dataService'];
	
	var lbaTextAreaCtrl = function lbaTextAreaCtrl($scope, $routeParams, dataService) {
	    var vm = this;
	    var dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
	
	    vm.data = _.get(dataService.data.activeItem, dataLookUp);
	    vm.validationPattern = vm.settings.validationRegex;
	    vm.isValid = true;
	
	    $scope.$watch(function () {
	        return dataService.data.activeItem;
	    }, function () {
	        vm.data = _.get(dataService.data.activeItem, dataLookUp);
	        if (vm.settings.splitArrayIntoLines === true && vm.data && (0, _angular.isArray)(vm.data)) {
	            vm.data = vm.data.map(function (d) {
	                return d.replace('\r\n', '\r\n\t');
	            }).join('\r\n');
	        }
	    });
	
	    $scope.$watchCollection('vm.data', function (newData, oldData) {
	        if (vm.validationPattern) {
	            var regex = new RegExp(vm.validationPattern);
	            vm.isValid = regex.test(vm.data);
	            $scope.$emit('ValidationStatusChanged', {
	                controllerName: $scope.vm.settings.dataAt,
	                isValid: vm.isValid
	            });
	            if (!vm.isValid) {
	                vm.settings.helpText = vm.settings.validationMessage;
	            } else {
	                vm.settings.helpText = null;
	            }
	        }
	
	        if (newData !== oldData) {
	            _.set(dataService.data.activeItem, dataLookUp, newData);
	        }
	    });
	};
	
	lbaTextAreaCtrl.$inject = $inject;
	
	exports['default'] = lbaTextAreaCtrl;
	module.exports = exports['default'];

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	var lbaTextArea = function lbaTextArea() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaTextAreaCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(303)
	  };
	};
	
	lbaTextArea.$inject = $inject;
	
	exports['default'] = lbaTextArea;
	module.exports = exports['default'];

/***/ },
/* 303 */
/***/ function(module, exports) {

	var v1="<div class=\"form-group\"> <label for=\"{{ vm.settings.dataAt }}\">{{ vm.settings.displayName }}</label> <textarea type=\"text\" class=\"form-control{{(vm.settings.class?' ' + vm.settings.class:'')}}\" id=\"{{ vm.settings.dataAt }}\" name=\"{{ vm.settings.dataAt }}\" placeholder=\"{{ vm.settings.placeholderText }}\" ng-model=\"vm.data\" ng-disabled=\"vm.settings.disabled\" ng-required=\"vm.settings.required\" rows=\"10\">\r\n    </textarea>   <p class=\"help-block validation-message\" ng-if=\"!vm.isValid\">{{ vm.settings.helpText }}</p> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaTextArea.html", v1)}]);
	module.exports=v1;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaODataSelect = angular.module('app.lbaODataSelect', []);
	
	lbaODataSelect.controller('lbaODataSelectCtrl', __webpack_require__(305));
	lbaODataSelect.directive('lbaODataSelect', __webpack_require__(306));
	
	exports['default'] = lbaODataSelect;
	module.exports = exports['default'];

/***/ },
/* 305 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope', '$routeParams', 'dataService'];
	
	var lbaODataSelectCtrl = function lbaODataSelectCtrl($scope, $routeParams, dataService) {
	  var vm = this;
	  var dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
	
	  vm.data = _.get(dataService.data.activeItem, dataLookUp);
	  vm.entityIdentifier = vm.settings.entityIdentifier || "Id";
	  vm.includeDisabled = vm.settings.includeDisabled === undefined ? true : vm.settings.includeDisabled;
	  vm.filterUsingEnabled = vm.settings.filterUsingEnabled || false;
	  vm.refreshData = refreshData;
	  vm.isMultiSelect = vm.settings.isMultiSelect || false;
	  vm.queryOption = vm.settings.queryOption || "filter";
	  vm.selectProperty = vm.settings.selectProperty || "";
	
	  vm.inputTitle = vm.settings.inputTitle || "Name";
	  vm.selectChoiceName = vm.settings.selectChoiceName || "Title";
	  vm.getChoiceValue = getChoiceValue;
	
	  vm.includeOptions = vm.settings.includeOptions;
	  vm.includeOptionsPropertyToSave = vm.settings.includeOptionsPropertyToSave;
	  vm.dataSelectPropertyToCheck = vm.settings.dataSelectPropertyToCheck;
	
	  vm.additionalFilters = vm.settings.additionalFilters || [];
	  vm.additionalOptions = vm.settings.additionalOptions || [];
	  vm.showOnlySelectedField = vm.settings.showOnlySelectedField || false;
	  vm.isValid = true;
	
	  $scope.$watchCollection('vm.data', function (newData, oldData) {
	    if (!vm.isMultiSelect) {
	      vm.isValid = newData != null;
	    }
	    if (newData !== oldData) {
	      if (vm.isMultiSelect) {
	        if (!vm.deletedOrDisabled) {
	          vm.deletedOrDisabled = [];
	        }
	        _.set(dataService.data.activeItem, dataLookUp, vm.deletedOrDisabled.concat(newData));
	      } else {
	        _.set(dataService.data.activeItem, dataLookUp, newData);
	      }
	    }
	  });
	
	  function refreshData(userSearch) {
	    var optionalParameters = {
	      isMultiSelect: vm.isMultiSelect,
	      includeDisabled: vm.includeDisabled,
	      filterUsingEnabled: vm.filterUsingEnabled,
	      queryOption: vm.queryOption,
	      selectProperty: vm.selectProperty
	    };
	
	    if (userSearch === "" && vm.settings.searchAllNo === true) {
	      dataService.search(vm.settings.endpoint, vm.data, vm.settings.entityIdentifier, null, optionalParameters).then(function (data) {
	        if (vm.isMultiSelect) {
	          (function () {
	            if (!vm.data) {
	              vm.data = [];
	            }
	
	            var dataToShow = vm.data.filter(function (id) {
	              return !!data.find(function (result) {
	                return getPropertyValue(result, vm.entityIdentifier) === id;
	              }) || vm.additionalOptions.find(function (option) {
	                return getPropertyValue(option, vm.entityIdentifier) === id;
	              });
	            });
	
	            if (vm.settings.includeOptions) {
	              if (vm.includeOptionsPropertyToSave != null && vm.includeOptionsPropertyToSave != undefined && vm.dataSelectPropertyToCheck != null && vm.dataSelectPropertyToCheck != undefined) {
	
	                vm.includeOptions.forEach(function (option) {
	                  var existingIncludeOption = vm.data.find(function (data) {
	                    return getPropertyValue(data, vm.dataSelectPropertyToCheck) === getPropertyValue(option, vm.includeOptionsPropertyToSave);
	                  });
	
	                  if (existingIncludeOption) {
	                    dataToShow.push(existingIncludeOption);
	                    data.push(option);
	                  }
	                });
	              }
	            }
	
	            if (!vm.deletedOrDisabled) {
	              vm.deletedOrDisabled = vm.data.filter(function (id) {
	                return !dataToShow.find(function (result) {
	                  return result === id;
	                });
	              });
	            }
	
	            vm.data = dataToShow;
	          })();
	        }
	
	        data = applyAdditionalFilters(data);
	        data = addAdditionalOptions(data);
	
	        vm.searchResults = data;
	      })['catch'](function () {});
	      return;
	    }
	
	    dataService.search(vm.settings.endpoint, userSearch, vm.settings.searchType, vm.settings.expression, optionalParameters).then(function (data) {
	      data = applyAdditionalFilters(data);
	      data = addAdditionalOptions(data);
	
	      vm.searchResults = data;
	
	      if (vm.settings.includeOptions) {
	        vm.settings.includeOptions.forEach(function (option) {
	          if (option.Title.toLowerCase().includes(userSearch.toLowerCase()) || option.TitleInSearch.toLowerCase().includes(userSearch.toLowerCase())) {
	            var newOption = vm.settings.includeOptions;
	            vm.searchResults = vm.searchResults.concat(newOption);
	          }
	        });
	      }
	    })['catch'](function () {});
	  }
	
	  function applyAdditionalFilters(data) {
	    if (vm.settings.additionalFilters) {
	      var additionalFilters = Object.keys(vm.settings.additionalFilters);
	
	      additionalFilters.forEach(function (additionalFilter) {
	        data = data.filter(function (d) {
	          return d === null || typeof d !== 'object' || d[additionalFilter] == vm.settings.additionalFilters[additionalFilter];
	        });
	      });
	    }
	
	    return data;
	  }
	
	  function addAdditionalOptions(data) {
	    if (vm.additionalOptions) {
	      var additionalOptions = Object.keys(vm.additionalOptions);
	
	      additionalOptions.forEach(function (additionalOption) {
	        var existingOption = data.find(function (option) {
	          return getPropertyValue(option, vm.entityIdentifier) === getPropertyValue(vm.additionalOptions[additionalOption], vm.entityIdentifier);
	        });
	
	        if (!existingOption) {
	          data.push(vm.additionalOptions[additionalOption]);
	        }
	      });
	    }
	
	    return data;
	  }
	
	  function getChoiceValue(item) {
	    if (item === null || typeof item !== 'object') {
	      return item;
	    }
	
	    var property = item.IsIncludeOption ? vm.includeOptionsPropertyToSave : vm.entityIdentifier;
	    return item[property];
	  }
	
	  function getPropertyValue(item, property) {
	    if (item === null || typeof item !== 'object' || property === '') {
	      return item;
	    }
	
	    return item[property];
	  }
	};
	
	lbaODataSelectCtrl.$inject = $inject;
	
	exports['default'] = lbaODataSelectCtrl;
	module.exports = exports['default'];

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	var lbaODataSelect = function lbaODataSelect() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaODataSelectCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(307)
	  };
	};
	
	lbaODataSelect.$inject = $inject;
	
	exports['default'] = lbaODataSelect;
	module.exports = exports['default'];

/***/ },
/* 307 */
/***/ function(module, exports) {

	var v1="<div class=\"form-group\"> <label for=\"{{ vm.settings.dataAt }}\">{{ vm.settings.displayName }}</label> <ui-select ng-if=\"vm.isMultiSelect\" multiple=\"multiple\" ng-model=\"vm.data\"> <ui-select-match allow-clear=\"true\" class=\"ui-select-match\"> {{ item.Title ? $item.Title : $item[vm.inputTitle] || $item }} </ui-select-match> <ui-select-choices repeat=\"vm.getChoiceValue(item) as item in vm.searchResults\" refresh=\"vm.refreshData($select.search)\" refresh-delay=\"300\"> <div>{{ item.TitleInSearch ? item.TitleInSearch : vm.settings.showOnlySelectedField ? item[vm.selectChoiceName] || item : item[vm.selectChoiceName] ? item[vm.selectChoiceName] + ' - ' + item.Id : item }}</div> </ui-select-choices> </ui-select> <ui-select ng-if=\"!vm.isMultiSelect\" ng-model=\"vm.data\" ng-required=\"vm.settings.required\"> <ui-select-match allow-clear=\"true\" class=\"ui-select-match\"> {{ $select.selected.Title ? $select.selected.Title : $select.selected[vm.inputTitle] || $select.selected }}{{ $select.selected.Id ? \" - \" + $select.selected.Id : \"\"}} </ui-select-match> <ui-select-choices repeat=\"vm.getChoiceValue(item) as item in vm.searchResults\" refresh=\"vm.refreshData($select.search)\" refresh-delay=\"300\"> <div>{{ item.TitleInSearch ? item.TitleInSearch : item[vm.selectChoiceName] || item}}{{item.Id ? ' - ' + item.Id : \"\"}}</div> </ui-select-choices> </ui-select> <p class=\"help-block validation-message\" ng-if=\"!vm.isValid\">{{ vm.settings.validationMessage }}</p> <p class=\"help-block\" ng-if=\"vm.settings.helpText\">{{ vm.settings.helpText }}</p> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaODataSelect.html", v1)}]);
	module.exports=v1;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	//lbaTimeZoneSelect
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaTimeZoneSelect = angular.module('app.lbaTimeZoneSelect', []);
	
	lbaTimeZoneSelect.controller('lbaTimeZoneSelectCtrl', __webpack_require__(309));
	lbaTimeZoneSelect.directive('lbaTimeZoneSelect', __webpack_require__(310));
	lbaTimeZoneSelect.service('timeZoneService', __webpack_require__(312));
	
	exports['default'] = lbaTimeZoneSelect;
	module.exports = exports['default'];

/***/ },
/* 309 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope', '$routeParams', '$filter', 'dataService', 'timeZoneService'];
	
	var lbaTimeZoneSelectCtrl = function lbaTimeZoneSelectCtrl($scope, $routeParams, $filter, dataService, timeZoneService) {
	  var vm = this;
	  var dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
	
	  vm.data = _.get(dataService.data.activeItem, dataLookUp);
	
	  vm.selectType = vm.settings.selectType || 'multi';
	  vm.refreshZones = refreshZones;
	
	  function refreshZones(userSearch) {
	    var zones = timeZoneService.get();
	
	    vm.zones = $filter('filter')(zones, userSearch, false);
	  }
	
	  $scope.$watchCollection('vm.data', function (newData, oldData) {
	    if (newData !== oldData) {
	      _.set(dataService.data.activeItem, dataLookUp, newData);
	    }
	  });
	};
	
	lbaTimeZoneSelectCtrl.$inject = $inject;
	
	exports['default'] = lbaTimeZoneSelectCtrl;
	module.exports = exports['default'];

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	var lbaTimeZoneSelect = function lbaTimeZoneSelect() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaTimeZoneSelectCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(311)
	  };
	};
	
	lbaTimeZoneSelect.$inject = $inject;
	
	exports['default'] = lbaTimeZoneSelect;
	module.exports = exports['default'];

/***/ },
/* 311 */
/***/ function(module, exports) {

	var v1="<div class=\"form-group\" ng-switch=\"vm.selectType\"> <label>{{ vm.settings.displayName }}</label> <div ng-switch-when=\"single\"> <ui-select ng-model=\"vm.data\"> <ui-select-match allow-clear=\"true\" class=\"ui-select-match\"> {{ $select.selected }} </ui-select-match> <ui-select-choices repeat=\"zone in vm.zones\" refresh=\"vm.refreshZones($select.search)\" refresh-delay=\"300\"> <div>{{ zone }}</div> </ui-select-choices> </ui-select> </div> <div ng-switch-default> <ui-select multiple=\"multiple\" ng-model=\"vm.data\"> <ui-select-match allow-clear=\"true\" class=\"ui-select-match\"> {{ $item }} </ui-select-match> <ui-select-choices repeat=\"zone in vm.zones\" refresh=\"vm.refreshZones($select.search)\" refresh-delay=\"300\"> <div>{{ zone }}</div> </ui-select-choices> </ui-select> </div> <p class=\"help-block\" ng-if=\"vm.settings.helpText\">{{ vm.settings.helpText }}</p> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaTimeZoneSelect.html", v1)}]);
	module.exports=v1;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var timeZoneJSON = __webpack_require__(313);
	
	var $inject = [];
	var timeZoneService = function timeZoneService() {
	  var service = {};
	
	  service.get = function get() {
	    var zones = _.values(timeZoneJSON.zones);
	
	    return _.map(zones, function (zone) {
	      return zone.name;
	    });
	  };
	
	  return service;
	};
	
	timeZoneService.$inject = $inject;
	
	exports["default"] = timeZoneService;
	module.exports = exports["default"];

/***/ },
/* 313 */
/***/ function(module, exports) {

	module.exports = {
		"countries": {
			"AD": {
				"name": "Andorra",
				"abbr": "AD",
				"zones": [
					"Europe/Andorra"
				]
			},
			"AE": {
				"name": "United Arab Emirates",
				"abbr": "AE",
				"zones": [
					"Asia/Dubai"
				]
			},
			"AF": {
				"name": "Afghanistan",
				"abbr": "AF",
				"zones": [
					"Asia/Kabul"
				]
			},
			"AG": {
				"name": "Antigua & Barbuda",
				"abbr": "AG",
				"zones": [
					"America/Port_of_Spain"
				]
			},
			"AI": {
				"name": "Anguilla",
				"abbr": "AI",
				"zones": [
					"America/Port_of_Spain"
				]
			},
			"AL": {
				"name": "Albania",
				"abbr": "AL",
				"zones": [
					"Europe/Tirane"
				]
			},
			"AM": {
				"name": "Armenia",
				"abbr": "AM",
				"zones": [
					"Asia/Yerevan"
				]
			},
			"AO": {
				"name": "Angola",
				"abbr": "AO",
				"zones": [
					"Africa/Lagos"
				]
			},
			"AQ": {
				"name": "Antarctica",
				"abbr": "AQ",
				"zones": [
					"Antarctica/Casey",
					"Antarctica/Davis",
					"Antarctica/DumontDUrville",
					"Antarctica/Mawson",
					"Antarctica/Palmer",
					"Antarctica/Rothera",
					"Antarctica/Syowa",
					"Antarctica/Troll",
					"Antarctica/Vostok",
					"Pacific/Auckland"
				]
			},
			"AR": {
				"name": "Argentina",
				"abbr": "AR",
				"zones": [
					"America/Argentina/Buenos_Aires",
					"America/Argentina/Cordoba",
					"America/Argentina/Salta",
					"America/Argentina/Jujuy",
					"America/Argentina/Tucuman",
					"America/Argentina/Catamarca",
					"America/Argentina/La_Rioja",
					"America/Argentina/San_Juan",
					"America/Argentina/Mendoza",
					"America/Argentina/San_Luis",
					"America/Argentina/Rio_Gallegos",
					"America/Argentina/Ushuaia"
				]
			},
			"AS": {
				"name": "Samoa (American)",
				"abbr": "AS",
				"zones": [
					"Pacific/Pago_Pago"
				]
			},
			"AT": {
				"name": "Austria",
				"abbr": "AT",
				"zones": [
					"Europe/Vienna"
				]
			},
			"AU": {
				"name": "Australia",
				"abbr": "AU",
				"zones": [
					"Australia/Lord_Howe",
					"Antarctica/Macquarie",
					"Australia/Hobart",
					"Australia/Currie",
					"Australia/Melbourne",
					"Australia/Sydney",
					"Australia/Broken_Hill",
					"Australia/Brisbane",
					"Australia/Lindeman",
					"Australia/Adelaide",
					"Australia/Darwin",
					"Australia/Perth",
					"Australia/Eucla"
				]
			},
			"AW": {
				"name": "Aruba",
				"abbr": "AW",
				"zones": [
					"America/Curacao"
				]
			},
			"AX": {
				"name": "Åland Islands",
				"abbr": "AX",
				"zones": [
					"Europe/Helsinki"
				]
			},
			"AZ": {
				"name": "Azerbaijan",
				"abbr": "AZ",
				"zones": [
					"Asia/Baku"
				]
			},
			"BA": {
				"name": "Bosnia & Herzegovina",
				"abbr": "BA",
				"zones": [
					"Europe/Belgrade"
				]
			},
			"BB": {
				"name": "Barbados",
				"abbr": "BB",
				"zones": [
					"America/Barbados"
				]
			},
			"BD": {
				"name": "Bangladesh",
				"abbr": "BD",
				"zones": [
					"Asia/Dhaka"
				]
			},
			"BE": {
				"name": "Belgium",
				"abbr": "BE",
				"zones": [
					"Europe/Brussels"
				]
			},
			"BF": {
				"name": "Burkina Faso",
				"abbr": "BF",
				"zones": [
					"Africa/Abidjan"
				]
			},
			"BG": {
				"name": "Bulgaria",
				"abbr": "BG",
				"zones": [
					"Europe/Sofia"
				]
			},
			"BH": {
				"name": "Bahrain",
				"abbr": "BH",
				"zones": [
					"Asia/Qatar"
				]
			},
			"BI": {
				"name": "Burundi",
				"abbr": "BI",
				"zones": [
					"Africa/Maputo"
				]
			},
			"BJ": {
				"name": "Benin",
				"abbr": "BJ",
				"zones": [
					"Africa/Lagos"
				]
			},
			"BL": {
				"name": "St Barthelemy",
				"abbr": "BL",
				"zones": [
					"America/Port_of_Spain"
				]
			},
			"BM": {
				"name": "Bermuda",
				"abbr": "BM",
				"zones": [
					"Atlantic/Bermuda"
				]
			},
			"BN": {
				"name": "Brunei",
				"abbr": "BN",
				"zones": [
					"Asia/Brunei"
				]
			},
			"BO": {
				"name": "Bolivia",
				"abbr": "BO",
				"zones": [
					"America/La_Paz"
				]
			},
			"BQ": {
				"name": "Caribbean NL",
				"abbr": "BQ",
				"zones": [
					"America/Curacao"
				]
			},
			"BR": {
				"name": "Brazil",
				"abbr": "BR",
				"zones": [
					"America/Noronha",
					"America/Belem",
					"America/Fortaleza",
					"America/Recife",
					"America/Araguaina",
					"America/Maceio",
					"America/Bahia",
					"America/Sao_Paulo",
					"America/Campo_Grande",
					"America/Cuiaba",
					"America/Santarem",
					"America/Porto_Velho",
					"America/Boa_Vista",
					"America/Manaus",
					"America/Eirunepe",
					"America/Rio_Branco"
				]
			},
			"BS": {
				"name": "Bahamas",
				"abbr": "BS",
				"zones": [
					"America/Nassau"
				]
			},
			"BT": {
				"name": "Bhutan",
				"abbr": "BT",
				"zones": [
					"Asia/Thimphu"
				]
			},
			"BW": {
				"name": "Botswana",
				"abbr": "BW",
				"zones": [
					"Africa/Maputo"
				]
			},
			"BY": {
				"name": "Belarus",
				"abbr": "BY",
				"zones": [
					"Europe/Minsk"
				]
			},
			"BZ": {
				"name": "Belize",
				"abbr": "BZ",
				"zones": [
					"America/Belize"
				]
			},
			"CA": {
				"name": "Canada",
				"abbr": "CA",
				"zones": [
					"America/St_Johns",
					"America/Halifax",
					"America/Glace_Bay",
					"America/Moncton",
					"America/Goose_Bay",
					"America/Blanc-Sablon",
					"America/Toronto",
					"America/Nipigon",
					"America/Thunder_Bay",
					"America/Iqaluit",
					"America/Pangnirtung",
					"America/Atikokan",
					"America/Winnipeg",
					"America/Rainy_River",
					"America/Resolute",
					"America/Rankin_Inlet",
					"America/Regina",
					"America/Swift_Current",
					"America/Edmonton",
					"America/Cambridge_Bay",
					"America/Yellowknife",
					"America/Inuvik",
					"America/Creston",
					"America/Dawson_Creek",
					"America/Fort_Nelson",
					"America/Vancouver",
					"America/Whitehorse",
					"America/Dawson"
				]
			},
			"CC": {
				"name": "Cocos (Keeling) Islands",
				"abbr": "CC",
				"zones": [
					"Indian/Cocos"
				]
			},
			"CD": {
				"name": "Congo (Dem. Rep.)",
				"abbr": "CD",
				"zones": [
					"Africa/Maputo",
					"Africa/Lagos"
				]
			},
			"CF": {
				"name": "Central African Rep.",
				"abbr": "CF",
				"zones": [
					"Africa/Lagos"
				]
			},
			"CG": {
				"name": "Congo (Rep.)",
				"abbr": "CG",
				"zones": [
					"Africa/Lagos"
				]
			},
			"CH": {
				"name": "Switzerland",
				"abbr": "CH",
				"zones": [
					"Europe/Zurich"
				]
			},
			"CI": {
				"name": "Côte d'Ivoire",
				"abbr": "CI",
				"zones": [
					"Africa/Abidjan"
				]
			},
			"CK": {
				"name": "Cook Islands",
				"abbr": "CK",
				"zones": [
					"Pacific/Rarotonga"
				]
			},
			"CL": {
				"name": "Chile",
				"abbr": "CL",
				"zones": [
					"America/Santiago",
					"Pacific/Easter"
				]
			},
			"CM": {
				"name": "Cameroon",
				"abbr": "CM",
				"zones": [
					"Africa/Lagos"
				]
			},
			"CN": {
				"name": "China",
				"abbr": "CN",
				"zones": [
					"Asia/Shanghai",
					"Asia/Urumqi"
				]
			},
			"CO": {
				"name": "Colombia",
				"abbr": "CO",
				"zones": [
					"America/Bogota"
				]
			},
			"CR": {
				"name": "Costa Rica",
				"abbr": "CR",
				"zones": [
					"America/Costa_Rica"
				]
			},
			"CU": {
				"name": "Cuba",
				"abbr": "CU",
				"zones": [
					"America/Havana"
				]
			},
			"CV": {
				"name": "Cape Verde",
				"abbr": "CV",
				"zones": [
					"Atlantic/Cape_Verde"
				]
			},
			"CW": {
				"name": "Curacao",
				"abbr": "CW",
				"zones": [
					"America/Curacao"
				]
			},
			"CX": {
				"name": "Christmas Island",
				"abbr": "CX",
				"zones": [
					"Indian/Christmas"
				]
			},
			"CY": {
				"name": "Cyprus",
				"abbr": "CY",
				"zones": [
					"Asia/Nicosia"
				]
			},
			"CZ": {
				"name": "Czech Republic",
				"abbr": "CZ",
				"zones": [
					"Europe/Prague"
				]
			},
			"DE": {
				"name": "Germany",
				"abbr": "DE",
				"zones": [
					"Europe/Zurich",
					"Europe/Berlin"
				]
			},
			"DJ": {
				"name": "Djibouti",
				"abbr": "DJ",
				"zones": [
					"Africa/Nairobi"
				]
			},
			"DK": {
				"name": "Denmark",
				"abbr": "DK",
				"zones": [
					"Europe/Copenhagen"
				]
			},
			"DM": {
				"name": "Dominica",
				"abbr": "DM",
				"zones": [
					"America/Port_of_Spain"
				]
			},
			"DO": {
				"name": "Dominican Republic",
				"abbr": "DO",
				"zones": [
					"America/Santo_Domingo"
				]
			},
			"DZ": {
				"name": "Algeria",
				"abbr": "DZ",
				"zones": [
					"Africa/Algiers"
				]
			},
			"EC": {
				"name": "Ecuador",
				"abbr": "EC",
				"zones": [
					"America/Guayaquil",
					"Pacific/Galapagos"
				]
			},
			"EE": {
				"name": "Estonia",
				"abbr": "EE",
				"zones": [
					"Europe/Tallinn"
				]
			},
			"EG": {
				"name": "Egypt",
				"abbr": "EG",
				"zones": [
					"Africa/Cairo"
				]
			},
			"EH": {
				"name": "Western Sahara",
				"abbr": "EH",
				"zones": [
					"Africa/El_Aaiun"
				]
			},
			"ER": {
				"name": "Eritrea",
				"abbr": "ER",
				"zones": [
					"Africa/Nairobi"
				]
			},
			"ES": {
				"name": "Spain",
				"abbr": "ES",
				"zones": [
					"Europe/Madrid",
					"Africa/Ceuta",
					"Atlantic/Canary"
				]
			},
			"ET": {
				"name": "Ethiopia",
				"abbr": "ET",
				"zones": [
					"Africa/Nairobi"
				]
			},
			"FI": {
				"name": "Finland",
				"abbr": "FI",
				"zones": [
					"Europe/Helsinki"
				]
			},
			"FJ": {
				"name": "Fiji",
				"abbr": "FJ",
				"zones": [
					"Pacific/Fiji"
				]
			},
			"FK": {
				"name": "Falkland Islands",
				"abbr": "FK",
				"zones": [
					"Atlantic/Stanley"
				]
			},
			"FM": {
				"name": "Micronesia",
				"abbr": "FM",
				"zones": [
					"Pacific/Chuuk",
					"Pacific/Pohnpei",
					"Pacific/Kosrae"
				]
			},
			"FO": {
				"name": "Faroe Islands",
				"abbr": "FO",
				"zones": [
					"Atlantic/Faroe"
				]
			},
			"FR": {
				"name": "France",
				"abbr": "FR",
				"zones": [
					"Europe/Paris"
				]
			},
			"GA": {
				"name": "Gabon",
				"abbr": "GA",
				"zones": [
					"Africa/Lagos"
				]
			},
			"GB": {
				"name": "Britain (UK)",
				"abbr": "GB",
				"zones": [
					"Europe/London"
				]
			},
			"GD": {
				"name": "Grenada",
				"abbr": "GD",
				"zones": [
					"America/Port_of_Spain"
				]
			},
			"GE": {
				"name": "Georgia",
				"abbr": "GE",
				"zones": [
					"Asia/Tbilisi"
				]
			},
			"GF": {
				"name": "French Guiana",
				"abbr": "GF",
				"zones": [
					"America/Cayenne"
				]
			},
			"GG": {
				"name": "Guernsey",
				"abbr": "GG",
				"zones": [
					"Europe/London"
				]
			},
			"GH": {
				"name": "Ghana",
				"abbr": "GH",
				"zones": [
					"Africa/Accra"
				]
			},
			"GI": {
				"name": "Gibraltar",
				"abbr": "GI",
				"zones": [
					"Europe/Gibraltar"
				]
			},
			"GL": {
				"name": "Greenland",
				"abbr": "GL",
				"zones": [
					"America/Godthab",
					"America/Danmarkshavn",
					"America/Scoresbysund",
					"America/Thule"
				]
			},
			"GM": {
				"name": "Gambia",
				"abbr": "GM",
				"zones": [
					"Africa/Abidjan"
				]
			},
			"GN": {
				"name": "Guinea",
				"abbr": "GN",
				"zones": [
					"Africa/Abidjan"
				]
			},
			"GP": {
				"name": "Guadeloupe",
				"abbr": "GP",
				"zones": [
					"America/Port_of_Spain"
				]
			},
			"GQ": {
				"name": "Equatorial Guinea",
				"abbr": "GQ",
				"zones": [
					"Africa/Lagos"
				]
			},
			"GR": {
				"name": "Greece",
				"abbr": "GR",
				"zones": [
					"Europe/Athens"
				]
			},
			"GS": {
				"name": "South Georgia & the South Sandwich Islands",
				"abbr": "GS",
				"zones": [
					"Atlantic/South_Georgia"
				]
			},
			"GT": {
				"name": "Guatemala",
				"abbr": "GT",
				"zones": [
					"America/Guatemala"
				]
			},
			"GU": {
				"name": "Guam",
				"abbr": "GU",
				"zones": [
					"Pacific/Guam"
				]
			},
			"GW": {
				"name": "Guinea-Bissau",
				"abbr": "GW",
				"zones": [
					"Africa/Bissau"
				]
			},
			"GY": {
				"name": "Guyana",
				"abbr": "GY",
				"zones": [
					"America/Guyana"
				]
			},
			"HK": {
				"name": "Hong Kong",
				"abbr": "HK",
				"zones": [
					"Asia/Hong_Kong"
				]
			},
			"HN": {
				"name": "Honduras",
				"abbr": "HN",
				"zones": [
					"America/Tegucigalpa"
				]
			},
			"HR": {
				"name": "Croatia",
				"abbr": "HR",
				"zones": [
					"Europe/Belgrade"
				]
			},
			"HT": {
				"name": "Haiti",
				"abbr": "HT",
				"zones": [
					"America/Port-au-Prince"
				]
			},
			"HU": {
				"name": "Hungary",
				"abbr": "HU",
				"zones": [
					"Europe/Budapest"
				]
			},
			"ID": {
				"name": "Indonesia",
				"abbr": "ID",
				"zones": [
					"Asia/Jakarta",
					"Asia/Pontianak",
					"Asia/Makassar",
					"Asia/Jayapura"
				]
			},
			"IE": {
				"name": "Ireland",
				"abbr": "IE",
				"zones": [
					"Europe/Dublin"
				]
			},
			"IL": {
				"name": "Israel",
				"abbr": "IL",
				"zones": [
					"Asia/Jerusalem"
				]
			},
			"IM": {
				"name": "Isle of Man",
				"abbr": "IM",
				"zones": [
					"Europe/London"
				]
			},
			"IN": {
				"name": "India",
				"abbr": "IN",
				"zones": [
					"Asia/Kolkata"
				]
			},
			"IO": {
				"name": "British Indian Ocean Territory",
				"abbr": "IO",
				"zones": [
					"Indian/Chagos"
				]
			},
			"IQ": {
				"name": "Iraq",
				"abbr": "IQ",
				"zones": [
					"Asia/Baghdad"
				]
			},
			"IR": {
				"name": "Iran",
				"abbr": "IR",
				"zones": [
					"Asia/Tehran"
				]
			},
			"IS": {
				"name": "Iceland",
				"abbr": "IS",
				"zones": [
					"Atlantic/Reykjavik"
				]
			},
			"IT": {
				"name": "Italy",
				"abbr": "IT",
				"zones": [
					"Europe/Rome"
				]
			},
			"JE": {
				"name": "Jersey",
				"abbr": "JE",
				"zones": [
					"Europe/London"
				]
			},
			"JM": {
				"name": "Jamaica",
				"abbr": "JM",
				"zones": [
					"America/Jamaica"
				]
			},
			"JO": {
				"name": "Jordan",
				"abbr": "JO",
				"zones": [
					"Asia/Amman"
				]
			},
			"JP": {
				"name": "Japan",
				"abbr": "JP",
				"zones": [
					"Asia/Tokyo"
				]
			},
			"KE": {
				"name": "Kenya",
				"abbr": "KE",
				"zones": [
					"Africa/Nairobi"
				]
			},
			"KG": {
				"name": "Kyrgyzstan",
				"abbr": "KG",
				"zones": [
					"Asia/Bishkek"
				]
			},
			"KH": {
				"name": "Cambodia",
				"abbr": "KH",
				"zones": [
					"Asia/Bangkok"
				]
			},
			"KI": {
				"name": "Kiribati",
				"abbr": "KI",
				"zones": [
					"Pacific/Tarawa",
					"Pacific/Enderbury",
					"Pacific/Kiritimati"
				]
			},
			"KM": {
				"name": "Comoros",
				"abbr": "KM",
				"zones": [
					"Africa/Nairobi"
				]
			},
			"KN": {
				"name": "St Kitts & Nevis",
				"abbr": "KN",
				"zones": [
					"America/Port_of_Spain"
				]
			},
			"KP": {
				"name": "Korea (North)",
				"abbr": "KP",
				"zones": [
					"Asia/Pyongyang"
				]
			},
			"KR": {
				"name": "Korea (South)",
				"abbr": "KR",
				"zones": [
					"Asia/Seoul"
				]
			},
			"KW": {
				"name": "Kuwait",
				"abbr": "KW",
				"zones": [
					"Asia/Riyadh"
				]
			},
			"KY": {
				"name": "Cayman Islands",
				"abbr": "KY",
				"zones": [
					"America/Panama"
				]
			},
			"KZ": {
				"name": "Kazakhstan",
				"abbr": "KZ",
				"zones": [
					"Asia/Almaty",
					"Asia/Qyzylorda",
					"Asia/Aqtobe",
					"Asia/Aqtau",
					"Asia/Oral"
				]
			},
			"LA": {
				"name": "Laos",
				"abbr": "LA",
				"zones": [
					"Asia/Bangkok"
				]
			},
			"LB": {
				"name": "Lebanon",
				"abbr": "LB",
				"zones": [
					"Asia/Beirut"
				]
			},
			"LC": {
				"name": "St Lucia",
				"abbr": "LC",
				"zones": [
					"America/Port_of_Spain"
				]
			},
			"LI": {
				"name": "Liechtenstein",
				"abbr": "LI",
				"zones": [
					"Europe/Zurich"
				]
			},
			"LK": {
				"name": "Sri Lanka",
				"abbr": "LK",
				"zones": [
					"Asia/Colombo"
				]
			},
			"LR": {
				"name": "Liberia",
				"abbr": "LR",
				"zones": [
					"Africa/Monrovia"
				]
			},
			"LS": {
				"name": "Lesotho",
				"abbr": "LS",
				"zones": [
					"Africa/Johannesburg"
				]
			},
			"LT": {
				"name": "Lithuania",
				"abbr": "LT",
				"zones": [
					"Europe/Vilnius"
				]
			},
			"LU": {
				"name": "Luxembourg",
				"abbr": "LU",
				"zones": [
					"Europe/Luxembourg"
				]
			},
			"LV": {
				"name": "Latvia",
				"abbr": "LV",
				"zones": [
					"Europe/Riga"
				]
			},
			"LY": {
				"name": "Libya",
				"abbr": "LY",
				"zones": [
					"Africa/Tripoli"
				]
			},
			"MA": {
				"name": "Morocco",
				"abbr": "MA",
				"zones": [
					"Africa/Casablanca"
				]
			},
			"MC": {
				"name": "Monaco",
				"abbr": "MC",
				"zones": [
					"Europe/Monaco"
				]
			},
			"MD": {
				"name": "Moldova",
				"abbr": "MD",
				"zones": [
					"Europe/Chisinau"
				]
			},
			"ME": {
				"name": "Montenegro",
				"abbr": "ME",
				"zones": [
					"Europe/Belgrade"
				]
			},
			"MF": {
				"name": "St Martin (French)",
				"abbr": "MF",
				"zones": [
					"America/Port_of_Spain"
				]
			},
			"MG": {
				"name": "Madagascar",
				"abbr": "MG",
				"zones": [
					"Africa/Nairobi"
				]
			},
			"MH": {
				"name": "Marshall Islands",
				"abbr": "MH",
				"zones": [
					"Pacific/Majuro",
					"Pacific/Kwajalein"
				]
			},
			"MK": {
				"name": "Macedonia",
				"abbr": "MK",
				"zones": [
					"Europe/Belgrade"
				]
			},
			"ML": {
				"name": "Mali",
				"abbr": "ML",
				"zones": [
					"Africa/Abidjan"
				]
			},
			"MM": {
				"name": "Myanmar (Burma)",
				"abbr": "MM",
				"zones": [
					"Asia/Rangoon"
				]
			},
			"MN": {
				"name": "Mongolia",
				"abbr": "MN",
				"zones": [
					"Asia/Ulaanbaatar",
					"Asia/Hovd",
					"Asia/Choibalsan"
				]
			},
			"MO": {
				"name": "Macau",
				"abbr": "MO",
				"zones": [
					"Asia/Macau"
				]
			},
			"MP": {
				"name": "Northern Mariana Islands",
				"abbr": "MP",
				"zones": [
					"Pacific/Guam"
				]
			},
			"MQ": {
				"name": "Martinique",
				"abbr": "MQ",
				"zones": [
					"America/Martinique"
				]
			},
			"MR": {
				"name": "Mauritania",
				"abbr": "MR",
				"zones": [
					"Africa/Abidjan"
				]
			},
			"MS": {
				"name": "Montserrat",
				"abbr": "MS",
				"zones": [
					"America/Port_of_Spain"
				]
			},
			"MT": {
				"name": "Malta",
				"abbr": "MT",
				"zones": [
					"Europe/Malta"
				]
			},
			"MU": {
				"name": "Mauritius",
				"abbr": "MU",
				"zones": [
					"Indian/Mauritius"
				]
			},
			"MV": {
				"name": "Maldives",
				"abbr": "MV",
				"zones": [
					"Indian/Maldives"
				]
			},
			"MW": {
				"name": "Malawi",
				"abbr": "MW",
				"zones": [
					"Africa/Maputo"
				]
			},
			"MX": {
				"name": "Mexico",
				"abbr": "MX",
				"zones": [
					"America/Mexico_City",
					"America/Cancun",
					"America/Merida",
					"America/Monterrey",
					"America/Matamoros",
					"America/Mazatlan",
					"America/Chihuahua",
					"America/Ojinaga",
					"America/Hermosillo",
					"America/Tijuana",
					"America/Bahia_Banderas"
				]
			},
			"MY": {
				"name": "Malaysia",
				"abbr": "MY",
				"zones": [
					"Asia/Kuala_Lumpur",
					"Asia/Kuching"
				]
			},
			"MZ": {
				"name": "Mozambique",
				"abbr": "MZ",
				"zones": [
					"Africa/Maputo"
				]
			},
			"NA": {
				"name": "Namibia",
				"abbr": "NA",
				"zones": [
					"Africa/Windhoek"
				]
			},
			"NC": {
				"name": "New Caledonia",
				"abbr": "NC",
				"zones": [
					"Pacific/Noumea"
				]
			},
			"NE": {
				"name": "Niger",
				"abbr": "NE",
				"zones": [
					"Africa/Lagos"
				]
			},
			"NF": {
				"name": "Norfolk Island",
				"abbr": "NF",
				"zones": [
					"Pacific/Norfolk"
				]
			},
			"NG": {
				"name": "Nigeria",
				"abbr": "NG",
				"zones": [
					"Africa/Lagos"
				]
			},
			"NI": {
				"name": "Nicaragua",
				"abbr": "NI",
				"zones": [
					"America/Managua"
				]
			},
			"NL": {
				"name": "Netherlands",
				"abbr": "NL",
				"zones": [
					"Europe/Amsterdam"
				]
			},
			"NO": {
				"name": "Norway",
				"abbr": "NO",
				"zones": [
					"Europe/Oslo"
				]
			},
			"NP": {
				"name": "Nepal",
				"abbr": "NP",
				"zones": [
					"Asia/Kathmandu"
				]
			},
			"NR": {
				"name": "Nauru",
				"abbr": "NR",
				"zones": [
					"Pacific/Nauru"
				]
			},
			"NU": {
				"name": "Niue",
				"abbr": "NU",
				"zones": [
					"Pacific/Niue"
				]
			},
			"NZ": {
				"name": "New Zealand",
				"abbr": "NZ",
				"zones": [
					"Pacific/Auckland",
					"Pacific/Chatham"
				]
			},
			"OM": {
				"name": "Oman",
				"abbr": "OM",
				"zones": [
					"Asia/Dubai"
				]
			},
			"PA": {
				"name": "Panama",
				"abbr": "PA",
				"zones": [
					"America/Panama"
				]
			},
			"PE": {
				"name": "Peru",
				"abbr": "PE",
				"zones": [
					"America/Lima"
				]
			},
			"PF": {
				"name": "French Polynesia",
				"abbr": "PF",
				"zones": [
					"Pacific/Tahiti",
					"Pacific/Marquesas",
					"Pacific/Gambier"
				]
			},
			"PG": {
				"name": "Papua New Guinea",
				"abbr": "PG",
				"zones": [
					"Pacific/Port_Moresby",
					"Pacific/Bougainville"
				]
			},
			"PH": {
				"name": "Philippines",
				"abbr": "PH",
				"zones": [
					"Asia/Manila"
				]
			},
			"PK": {
				"name": "Pakistan",
				"abbr": "PK",
				"zones": [
					"Asia/Karachi"
				]
			},
			"PL": {
				"name": "Poland",
				"abbr": "PL",
				"zones": [
					"Europe/Warsaw"
				]
			},
			"PM": {
				"name": "St Pierre & Miquelon",
				"abbr": "PM",
				"zones": [
					"America/Miquelon"
				]
			},
			"PN": {
				"name": "Pitcairn",
				"abbr": "PN",
				"zones": [
					"Pacific/Pitcairn"
				]
			},
			"PR": {
				"name": "Puerto Rico",
				"abbr": "PR",
				"zones": [
					"America/Puerto_Rico"
				]
			},
			"PS": {
				"name": "Palestine",
				"abbr": "PS",
				"zones": [
					"Asia/Gaza",
					"Asia/Hebron"
				]
			},
			"PT": {
				"name": "Portugal",
				"abbr": "PT",
				"zones": [
					"Europe/Lisbon",
					"Atlantic/Madeira",
					"Atlantic/Azores"
				]
			},
			"PW": {
				"name": "Palau",
				"abbr": "PW",
				"zones": [
					"Pacific/Palau"
				]
			},
			"PY": {
				"name": "Paraguay",
				"abbr": "PY",
				"zones": [
					"America/Asuncion"
				]
			},
			"QA": {
				"name": "Qatar",
				"abbr": "QA",
				"zones": [
					"Asia/Qatar"
				]
			},
			"RE": {
				"name": "Réunion",
				"abbr": "RE",
				"zones": [
					"Indian/Reunion"
				]
			},
			"RO": {
				"name": "Romania",
				"abbr": "RO",
				"zones": [
					"Europe/Bucharest"
				]
			},
			"RS": {
				"name": "Serbia",
				"abbr": "RS",
				"zones": [
					"Europe/Belgrade"
				]
			},
			"RU": {
				"name": "Russia",
				"abbr": "RU",
				"zones": [
					"Europe/Kaliningrad",
					"Europe/Moscow",
					"Europe/Simferopol",
					"Europe/Volgograd",
					"Europe/Kirov",
					"Europe/Astrakhan",
					"Europe/Samara",
					"Europe/Ulyanovsk",
					"Asia/Yekaterinburg",
					"Asia/Omsk",
					"Asia/Novosibirsk",
					"Asia/Barnaul",
					"Asia/Tomsk",
					"Asia/Novokuznetsk",
					"Asia/Krasnoyarsk",
					"Asia/Irkutsk",
					"Asia/Chita",
					"Asia/Yakutsk",
					"Asia/Khandyga",
					"Asia/Vladivostok",
					"Asia/Ust-Nera",
					"Asia/Magadan",
					"Asia/Sakhalin",
					"Asia/Srednekolymsk",
					"Asia/Kamchatka",
					"Asia/Anadyr"
				]
			},
			"RW": {
				"name": "Rwanda",
				"abbr": "RW",
				"zones": [
					"Africa/Maputo"
				]
			},
			"SA": {
				"name": "Saudi Arabia",
				"abbr": "SA",
				"zones": [
					"Asia/Riyadh"
				]
			},
			"SB": {
				"name": "Solomon Islands",
				"abbr": "SB",
				"zones": [
					"Pacific/Guadalcanal"
				]
			},
			"SC": {
				"name": "Seychelles",
				"abbr": "SC",
				"zones": [
					"Indian/Mahe"
				]
			},
			"SD": {
				"name": "Sudan",
				"abbr": "SD",
				"zones": [
					"Africa/Khartoum"
				]
			},
			"SE": {
				"name": "Sweden",
				"abbr": "SE",
				"zones": [
					"Europe/Stockholm"
				]
			},
			"SG": {
				"name": "Singapore",
				"abbr": "SG",
				"zones": [
					"Asia/Singapore"
				]
			},
			"SH": {
				"name": "St Helena",
				"abbr": "SH",
				"zones": [
					"Africa/Abidjan"
				]
			},
			"SI": {
				"name": "Slovenia",
				"abbr": "SI",
				"zones": [
					"Europe/Belgrade"
				]
			},
			"SJ": {
				"name": "Svalbard & Jan Mayen",
				"abbr": "SJ",
				"zones": [
					"Europe/Oslo"
				]
			},
			"SK": {
				"name": "Slovakia",
				"abbr": "SK",
				"zones": [
					"Europe/Prague"
				]
			},
			"SL": {
				"name": "Sierra Leone",
				"abbr": "SL",
				"zones": [
					"Africa/Abidjan"
				]
			},
			"SM": {
				"name": "San Marino",
				"abbr": "SM",
				"zones": [
					"Europe/Rome"
				]
			},
			"SN": {
				"name": "Senegal",
				"abbr": "SN",
				"zones": [
					"Africa/Abidjan"
				]
			},
			"SO": {
				"name": "Somalia",
				"abbr": "SO",
				"zones": [
					"Africa/Nairobi"
				]
			},
			"SR": {
				"name": "Suriname",
				"abbr": "SR",
				"zones": [
					"America/Paramaribo"
				]
			},
			"SS": {
				"name": "South Sudan",
				"abbr": "SS",
				"zones": [
					"Africa/Khartoum"
				]
			},
			"ST": {
				"name": "Sao Tome & Principe",
				"abbr": "ST",
				"zones": [
					"Africa/Abidjan"
				]
			},
			"SV": {
				"name": "El Salvador",
				"abbr": "SV",
				"zones": [
					"America/El_Salvador"
				]
			},
			"SX": {
				"name": "St Maarten (Dutch)",
				"abbr": "SX",
				"zones": [
					"America/Curacao"
				]
			},
			"SY": {
				"name": "Syria",
				"abbr": "SY",
				"zones": [
					"Asia/Damascus"
				]
			},
			"SZ": {
				"name": "Swaziland",
				"abbr": "SZ",
				"zones": [
					"Africa/Johannesburg"
				]
			},
			"TC": {
				"name": "Turks & Caicos Is",
				"abbr": "TC",
				"zones": [
					"America/Grand_Turk"
				]
			},
			"TD": {
				"name": "Chad",
				"abbr": "TD",
				"zones": [
					"Africa/Ndjamena"
				]
			},
			"TF": {
				"name": "French Southern & Antarctic Lands",
				"abbr": "TF",
				"zones": [
					"Indian/Reunion",
					"Indian/Kerguelen"
				]
			},
			"TG": {
				"name": "Togo",
				"abbr": "TG",
				"zones": [
					"Africa/Abidjan"
				]
			},
			"TH": {
				"name": "Thailand",
				"abbr": "TH",
				"zones": [
					"Asia/Bangkok"
				]
			},
			"TJ": {
				"name": "Tajikistan",
				"abbr": "TJ",
				"zones": [
					"Asia/Dushanbe"
				]
			},
			"TK": {
				"name": "Tokelau",
				"abbr": "TK",
				"zones": [
					"Pacific/Fakaofo"
				]
			},
			"TL": {
				"name": "East Timor",
				"abbr": "TL",
				"zones": [
					"Asia/Dili"
				]
			},
			"TM": {
				"name": "Turkmenistan",
				"abbr": "TM",
				"zones": [
					"Asia/Ashgabat"
				]
			},
			"TN": {
				"name": "Tunisia",
				"abbr": "TN",
				"zones": [
					"Africa/Tunis"
				]
			},
			"TO": {
				"name": "Tonga",
				"abbr": "TO",
				"zones": [
					"Pacific/Tongatapu"
				]
			},
			"TR": {
				"name": "Turkey",
				"abbr": "TR",
				"zones": [
					"Europe/Istanbul"
				]
			},
			"TT": {
				"name": "Trinidad & Tobago",
				"abbr": "TT",
				"zones": [
					"America/Port_of_Spain"
				]
			},
			"TV": {
				"name": "Tuvalu",
				"abbr": "TV",
				"zones": [
					"Pacific/Funafuti"
				]
			},
			"TW": {
				"name": "Taiwan",
				"abbr": "TW",
				"zones": [
					"Asia/Taipei"
				]
			},
			"TZ": {
				"name": "Tanzania",
				"abbr": "TZ",
				"zones": [
					"Africa/Nairobi"
				]
			},
			"UA": {
				"name": "Ukraine",
				"abbr": "UA",
				"zones": [
					"Europe/Kiev",
					"Europe/Uzhgorod",
					"Europe/Zaporozhye"
				]
			},
			"UG": {
				"name": "Uganda",
				"abbr": "UG",
				"zones": [
					"Africa/Nairobi"
				]
			},
			"UM": {
				"name": "US minor outlying islands",
				"abbr": "UM",
				"zones": [
					"Pacific/Pago_Pago",
					"Pacific/Wake",
					"Pacific/Honolulu"
				]
			},
			"US": {
				"name": "United States",
				"abbr": "US",
				"zones": [
					"America/New_York",
					"America/Detroit",
					"America/Kentucky/Louisville",
					"America/Kentucky/Monticello",
					"America/Indiana/Indianapolis",
					"America/Indiana/Vincennes",
					"America/Indiana/Winamac",
					"America/Indiana/Marengo",
					"America/Indiana/Petersburg",
					"America/Indiana/Vevay",
					"America/Chicago",
					"America/Indiana/Tell_City",
					"America/Indiana/Knox",
					"America/Menominee",
					"America/North_Dakota/Center",
					"America/North_Dakota/New_Salem",
					"America/North_Dakota/Beulah",
					"America/Denver",
					"America/Boise",
					"America/Phoenix",
					"America/Los_Angeles",
					"America/Anchorage",
					"America/Juneau",
					"America/Sitka",
					"America/Metlakatla",
					"America/Yakutat",
					"America/Nome",
					"America/Adak",
					"Pacific/Honolulu"
				]
			},
			"UY": {
				"name": "Uruguay",
				"abbr": "UY",
				"zones": [
					"America/Montevideo"
				]
			},
			"UZ": {
				"name": "Uzbekistan",
				"abbr": "UZ",
				"zones": [
					"Asia/Samarkand",
					"Asia/Tashkent"
				]
			},
			"VA": {
				"name": "Vatican City",
				"abbr": "VA",
				"zones": [
					"Europe/Rome"
				]
			},
			"VC": {
				"name": "St Vincent",
				"abbr": "VC",
				"zones": [
					"America/Port_of_Spain"
				]
			},
			"VE": {
				"name": "Venezuela",
				"abbr": "VE",
				"zones": [
					"America/Caracas"
				]
			},
			"VG": {
				"name": "Virgin Islands (UK)",
				"abbr": "VG",
				"zones": [
					"America/Port_of_Spain"
				]
			},
			"VI": {
				"name": "Virgin Islands (US)",
				"abbr": "VI",
				"zones": [
					"America/Port_of_Spain"
				]
			},
			"VN": {
				"name": "Vietnam",
				"abbr": "VN",
				"zones": [
					"Asia/Bangkok",
					"Asia/Ho_Chi_Minh"
				]
			},
			"VU": {
				"name": "Vanuatu",
				"abbr": "VU",
				"zones": [
					"Pacific/Efate"
				]
			},
			"WF": {
				"name": "Wallis & Futuna",
				"abbr": "WF",
				"zones": [
					"Pacific/Wallis"
				]
			},
			"WS": {
				"name": "Samoa (western)",
				"abbr": "WS",
				"zones": [
					"Pacific/Apia"
				]
			},
			"YE": {
				"name": "Yemen",
				"abbr": "YE",
				"zones": [
					"Asia/Riyadh"
				]
			},
			"YT": {
				"name": "Mayotte",
				"abbr": "YT",
				"zones": [
					"Africa/Nairobi"
				]
			},
			"ZA": {
				"name": "South Africa",
				"abbr": "ZA",
				"zones": [
					"Africa/Johannesburg"
				]
			},
			"ZM": {
				"name": "Zambia",
				"abbr": "ZM",
				"zones": [
					"Africa/Maputo"
				]
			},
			"ZW": {
				"name": "Zimbabwe",
				"abbr": "ZW",
				"zones": [
					"Africa/Maputo"
				]
			}
		},
		"zones": {
			"Europe/Andorra": {
				"name": "Europe/Andorra",
				"lat": 42.5,
				"long": 1.5167,
				"countries": [
					"AD"
				],
				"comments": ""
			},
			"Asia/Dubai": {
				"name": "Asia/Dubai",
				"lat": 25.3,
				"long": 55.3,
				"countries": [
					"AE",
					"OM"
				],
				"comments": ""
			},
			"Asia/Kabul": {
				"name": "Asia/Kabul",
				"lat": 34.5167,
				"long": 69.2,
				"countries": [
					"AF"
				],
				"comments": ""
			},
			"Europe/Tirane": {
				"name": "Europe/Tirane",
				"lat": 41.3333,
				"long": 19.8333,
				"countries": [
					"AL"
				],
				"comments": ""
			},
			"Asia/Yerevan": {
				"name": "Asia/Yerevan",
				"lat": 40.1833,
				"long": 44.5,
				"countries": [
					"AM"
				],
				"comments": ""
			},
			"Antarctica/Casey": {
				"name": "Antarctica/Casey",
				"lat": -65.7167,
				"long": 110.5167,
				"countries": [
					"AQ"
				],
				"comments": "Casey"
			},
			"Antarctica/Davis": {
				"name": "Antarctica/Davis",
				"lat": -67.4167,
				"long": 77.9667,
				"countries": [
					"AQ"
				],
				"comments": "Davis"
			},
			"Antarctica/DumontDUrville": {
				"name": "Antarctica/DumontDUrville",
				"lat": -65.3333,
				"long": 140.0167,
				"countries": [
					"AQ"
				],
				"comments": "Dumont-d'Urville"
			},
			"Antarctica/Mawson": {
				"name": "Antarctica/Mawson",
				"lat": -66.4,
				"long": 62.8833,
				"countries": [
					"AQ"
				],
				"comments": "Mawson"
			},
			"Antarctica/Palmer": {
				"name": "Antarctica/Palmer",
				"lat": -63.2,
				"long": -63.9,
				"countries": [
					"AQ"
				],
				"comments": "Palmer"
			},
			"Antarctica/Rothera": {
				"name": "Antarctica/Rothera",
				"lat": -66.4333,
				"long": -67.8667,
				"countries": [
					"AQ"
				],
				"comments": "Rothera"
			},
			"Antarctica/Syowa": {
				"name": "Antarctica/Syowa",
				"lat": -68.9939,
				"long": 39.59,
				"countries": [
					"AQ"
				],
				"comments": "Syowa"
			},
			"Antarctica/Troll": {
				"name": "Antarctica/Troll",
				"lat": -71.9886,
				"long": 2.535,
				"countries": [
					"AQ"
				],
				"comments": "Troll"
			},
			"Antarctica/Vostok": {
				"name": "Antarctica/Vostok",
				"lat": -77.6,
				"long": 106.9,
				"countries": [
					"AQ"
				],
				"comments": "Vostok"
			},
			"America/Argentina/Buenos_Aires": {
				"name": "America/Argentina/Buenos_Aires",
				"lat": -33.4,
				"long": -57.55,
				"countries": [
					"AR"
				],
				"comments": "Buenos Aires (BA, CF)"
			},
			"America/Argentina/Cordoba": {
				"name": "America/Argentina/Cordoba",
				"lat": -30.6,
				"long": -63.8167,
				"countries": [
					"AR"
				],
				"comments": "Argentina (most areas: CB, CC, CN, ER, FM, MN, SE, SF)"
			},
			"America/Argentina/Salta": {
				"name": "America/Argentina/Salta",
				"lat": -23.2167,
				"long": -64.5833,
				"countries": [
					"AR"
				],
				"comments": "Salta (SA, LP, NQ, RN)"
			},
			"America/Argentina/Jujuy": {
				"name": "America/Argentina/Jujuy",
				"lat": -23.8167,
				"long": -64.7,
				"countries": [
					"AR"
				],
				"comments": "Jujuy (JY)"
			},
			"America/Argentina/Tucuman": {
				"name": "America/Argentina/Tucuman",
				"lat": -25.1833,
				"long": -64.7833,
				"countries": [
					"AR"
				],
				"comments": "Tucumán (TM)"
			},
			"America/Argentina/Catamarca": {
				"name": "America/Argentina/Catamarca",
				"lat": -27.5333,
				"long": -64.2167,
				"countries": [
					"AR"
				],
				"comments": "Catamarca (CT); Chubut (CH)"
			},
			"America/Argentina/La_Rioja": {
				"name": "America/Argentina/La_Rioja",
				"lat": -28.5667,
				"long": -65.15,
				"countries": [
					"AR"
				],
				"comments": "La Rioja (LR)"
			},
			"America/Argentina/San_Juan": {
				"name": "America/Argentina/San_Juan",
				"lat": -30.4667,
				"long": -67.4833,
				"countries": [
					"AR"
				],
				"comments": "San Juan (SJ)"
			},
			"America/Argentina/Mendoza": {
				"name": "America/Argentina/Mendoza",
				"lat": -31.1167,
				"long": -67.1833,
				"countries": [
					"AR"
				],
				"comments": "Mendoza (MZ)"
			},
			"America/Argentina/San_Luis": {
				"name": "America/Argentina/San_Luis",
				"lat": -32.6833,
				"long": -65.65,
				"countries": [
					"AR"
				],
				"comments": "San Luis (SL)"
			},
			"America/Argentina/Rio_Gallegos": {
				"name": "America/Argentina/Rio_Gallegos",
				"lat": -50.3667,
				"long": -68.7833,
				"countries": [
					"AR"
				],
				"comments": "Santa Cruz (SC)"
			},
			"America/Argentina/Ushuaia": {
				"name": "America/Argentina/Ushuaia",
				"lat": -53.2,
				"long": -67.7,
				"countries": [
					"AR"
				],
				"comments": "Tierra del Fuego (TF)"
			},
			"Pacific/Pago_Pago": {
				"name": "Pacific/Pago_Pago",
				"lat": -13.7333,
				"long": -169.3,
				"countries": [
					"AS",
					"UM"
				],
				"comments": "Samoa, Midway"
			},
			"Europe/Vienna": {
				"name": "Europe/Vienna",
				"lat": 48.2167,
				"long": 16.3333,
				"countries": [
					"AT"
				],
				"comments": ""
			},
			"Australia/Lord_Howe": {
				"name": "Australia/Lord_Howe",
				"lat": -30.45,
				"long": 159.0833,
				"countries": [
					"AU"
				],
				"comments": "Lord Howe Island"
			},
			"Antarctica/Macquarie": {
				"name": "Antarctica/Macquarie",
				"lat": -53.5,
				"long": 158.95,
				"countries": [
					"AU"
				],
				"comments": "Macquarie Island"
			},
			"Australia/Hobart": {
				"name": "Australia/Hobart",
				"lat": -41.1167,
				"long": 147.3167,
				"countries": [
					"AU"
				],
				"comments": "Tasmania (most areas)"
			},
			"Australia/Currie": {
				"name": "Australia/Currie",
				"lat": -38.0667,
				"long": 143.8667,
				"countries": [
					"AU"
				],
				"comments": "Tasmania (King Island)"
			},
			"Australia/Melbourne": {
				"name": "Australia/Melbourne",
				"lat": -36.1833,
				"long": 144.9667,
				"countries": [
					"AU"
				],
				"comments": "Victoria"
			},
			"Australia/Sydney": {
				"name": "Australia/Sydney",
				"lat": -32.1333,
				"long": 151.2167,
				"countries": [
					"AU"
				],
				"comments": "New South Wales (most areas)"
			},
			"Australia/Broken_Hill": {
				"name": "Australia/Broken_Hill",
				"lat": -30.05,
				"long": 141.45,
				"countries": [
					"AU"
				],
				"comments": "New South Wales (Yancowinna)"
			},
			"Australia/Brisbane": {
				"name": "Australia/Brisbane",
				"lat": -26.5333,
				"long": 153.0333,
				"countries": [
					"AU"
				],
				"comments": "Queensland (most areas)"
			},
			"Australia/Lindeman": {
				"name": "Australia/Lindeman",
				"lat": -19.7333,
				"long": 149,
				"countries": [
					"AU"
				],
				"comments": "Queensland (Whitsunday Islands)"
			},
			"Australia/Adelaide": {
				"name": "Australia/Adelaide",
				"lat": -33.0833,
				"long": 138.5833,
				"countries": [
					"AU"
				],
				"comments": "South Australia"
			},
			"Australia/Darwin": {
				"name": "Australia/Darwin",
				"lat": -11.5333,
				"long": 130.8333,
				"countries": [
					"AU"
				],
				"comments": "Northern Territory"
			},
			"Australia/Perth": {
				"name": "Australia/Perth",
				"lat": -30.05,
				"long": 115.85,
				"countries": [
					"AU"
				],
				"comments": "Western Australia (most areas)"
			},
			"Australia/Eucla": {
				"name": "Australia/Eucla",
				"lat": -30.2833,
				"long": 128.8667,
				"countries": [
					"AU"
				],
				"comments": "Western Australia (Eucla)"
			},
			"Asia/Baku": {
				"name": "Asia/Baku",
				"lat": 40.3833,
				"long": 49.85,
				"countries": [
					"AZ"
				],
				"comments": ""
			},
			"America/Barbados": {
				"name": "America/Barbados",
				"lat": 13.1,
				"long": -58.3833,
				"countries": [
					"BB"
				],
				"comments": ""
			},
			"Asia/Dhaka": {
				"name": "Asia/Dhaka",
				"lat": 23.7167,
				"long": 90.4167,
				"countries": [
					"BD"
				],
				"comments": ""
			},
			"Europe/Brussels": {
				"name": "Europe/Brussels",
				"lat": 50.8333,
				"long": 4.3333,
				"countries": [
					"BE"
				],
				"comments": ""
			},
			"Europe/Sofia": {
				"name": "Europe/Sofia",
				"lat": 42.6833,
				"long": 23.3167,
				"countries": [
					"BG"
				],
				"comments": ""
			},
			"Atlantic/Bermuda": {
				"name": "Atlantic/Bermuda",
				"lat": 32.2833,
				"long": -63.2333,
				"countries": [
					"BM"
				],
				"comments": ""
			},
			"Asia/Brunei": {
				"name": "Asia/Brunei",
				"lat": 4.9333,
				"long": 114.9167,
				"countries": [
					"BN"
				],
				"comments": ""
			},
			"America/La_Paz": {
				"name": "America/La_Paz",
				"lat": -15.5,
				"long": -67.85,
				"countries": [
					"BO"
				],
				"comments": ""
			},
			"America/Noronha": {
				"name": "America/Noronha",
				"lat": -2.15,
				"long": -31.5833,
				"countries": [
					"BR"
				],
				"comments": "Atlantic islands"
			},
			"America/Belem": {
				"name": "America/Belem",
				"lat": -0.55,
				"long": -47.5167,
				"countries": [
					"BR"
				],
				"comments": "Pará (east); Amapá"
			},
			"America/Fortaleza": {
				"name": "America/Fortaleza",
				"lat": -2.2833,
				"long": -37.5,
				"countries": [
					"BR"
				],
				"comments": "Brazil (northeast: MA, PI, CE, RN, PB)"
			},
			"America/Recife": {
				"name": "America/Recife",
				"lat": -7.95,
				"long": -33.1,
				"countries": [
					"BR"
				],
				"comments": "Pernambuco"
			},
			"America/Araguaina": {
				"name": "America/Araguaina",
				"lat": -6.8,
				"long": -47.8,
				"countries": [
					"BR"
				],
				"comments": "Tocantins"
			},
			"America/Maceio": {
				"name": "America/Maceio",
				"lat": -8.3333,
				"long": -34.2833,
				"countries": [
					"BR"
				],
				"comments": "Alagoas, Sergipe"
			},
			"America/Bahia": {
				"name": "America/Bahia",
				"lat": -11.0167,
				"long": -37.4833,
				"countries": [
					"BR"
				],
				"comments": "Bahia"
			},
			"America/Sao_Paulo": {
				"name": "America/Sao_Paulo",
				"lat": -22.4667,
				"long": -45.3833,
				"countries": [
					"BR"
				],
				"comments": "Brazil (southeast: GO, DF, MG, ES, RJ, SP, PR, SC, RS)"
			},
			"America/Campo_Grande": {
				"name": "America/Campo_Grande",
				"lat": -19.55,
				"long": -53.3833,
				"countries": [
					"BR"
				],
				"comments": "Mato Grosso do Sul"
			},
			"America/Cuiaba": {
				"name": "America/Cuiaba",
				"lat": -14.4167,
				"long": -55.9167,
				"countries": [
					"BR"
				],
				"comments": "Mato Grosso"
			},
			"America/Santarem": {
				"name": "America/Santarem",
				"lat": -1.5667,
				"long": -53.1333,
				"countries": [
					"BR"
				],
				"comments": "Pará (west)"
			},
			"America/Porto_Velho": {
				"name": "America/Porto_Velho",
				"lat": -7.2333,
				"long": -62.1,
				"countries": [
					"BR"
				],
				"comments": "Rondônia"
			},
			"America/Boa_Vista": {
				"name": "America/Boa_Vista",
				"lat": 2.8167,
				"long": -59.3333,
				"countries": [
					"BR"
				],
				"comments": "Roraima"
			},
			"America/Manaus": {
				"name": "America/Manaus",
				"lat": -2.8667,
				"long": -59.9833,
				"countries": [
					"BR"
				],
				"comments": "Amazonas (east)"
			},
			"America/Eirunepe": {
				"name": "America/Eirunepe",
				"lat": -5.3333,
				"long": -68.1333,
				"countries": [
					"BR"
				],
				"comments": "Amazonas (west)"
			},
			"America/Rio_Branco": {
				"name": "America/Rio_Branco",
				"lat": -8.0333,
				"long": -66.2,
				"countries": [
					"BR"
				],
				"comments": "Acre"
			},
			"America/Nassau": {
				"name": "America/Nassau",
				"lat": 25.0833,
				"long": -76.65,
				"countries": [
					"BS"
				],
				"comments": ""
			},
			"Asia/Thimphu": {
				"name": "Asia/Thimphu",
				"lat": 27.4667,
				"long": 89.65,
				"countries": [
					"BT"
				],
				"comments": ""
			},
			"Europe/Minsk": {
				"name": "Europe/Minsk",
				"lat": 53.9,
				"long": 27.5667,
				"countries": [
					"BY"
				],
				"comments": ""
			},
			"America/Belize": {
				"name": "America/Belize",
				"lat": 17.5,
				"long": -87.8,
				"countries": [
					"BZ"
				],
				"comments": ""
			},
			"America/St_Johns": {
				"name": "America/St_Johns",
				"lat": 47.5667,
				"long": -51.2833,
				"countries": [
					"CA"
				],
				"comments": "Newfoundland; Labrador (southeast)"
			},
			"America/Halifax": {
				"name": "America/Halifax",
				"lat": 44.65,
				"long": -62.4,
				"countries": [
					"CA"
				],
				"comments": "Atlantic - NS (most areas); PE"
			},
			"America/Glace_Bay": {
				"name": "America/Glace_Bay",
				"lat": 46.2,
				"long": -58.05,
				"countries": [
					"CA"
				],
				"comments": "Atlantic - NS (Cape Breton)"
			},
			"America/Moncton": {
				"name": "America/Moncton",
				"lat": 46.1,
				"long": -63.2167,
				"countries": [
					"CA"
				],
				"comments": "Atlantic - New Brunswick"
			},
			"America/Goose_Bay": {
				"name": "America/Goose_Bay",
				"lat": 53.3333,
				"long": -59.5833,
				"countries": [
					"CA"
				],
				"comments": "Atlantic - Labrador (most areas)"
			},
			"America/Blanc-Sablon": {
				"name": "America/Blanc-Sablon",
				"lat": 51.4167,
				"long": -56.8833,
				"countries": [
					"CA"
				],
				"comments": "AST - QC (Lower North Shore)"
			},
			"America/Toronto": {
				"name": "America/Toronto",
				"lat": 43.65,
				"long": -78.6167,
				"countries": [
					"CA"
				],
				"comments": "Eastern - ON, QC (most areas)"
			},
			"America/Nipigon": {
				"name": "America/Nipigon",
				"lat": 49.0167,
				"long": -87.7333,
				"countries": [
					"CA"
				],
				"comments": "Eastern - ON, QC (no DST 1967-73)"
			},
			"America/Thunder_Bay": {
				"name": "America/Thunder_Bay",
				"lat": 48.3833,
				"long": -88.75,
				"countries": [
					"CA"
				],
				"comments": "Eastern - ON (Thunder Bay)"
			},
			"America/Iqaluit": {
				"name": "America/Iqaluit",
				"lat": 63.7333,
				"long": -67.5333,
				"countries": [
					"CA"
				],
				"comments": "Eastern - NU (most east areas)"
			},
			"America/Pangnirtung": {
				"name": "America/Pangnirtung",
				"lat": 66.1333,
				"long": -64.2667,
				"countries": [
					"CA"
				],
				"comments": "Eastern - NU (Pangnirtung)"
			},
			"America/Atikokan": {
				"name": "America/Atikokan",
				"lat": 48.7586,
				"long": -90.3783,
				"countries": [
					"CA"
				],
				"comments": "EST - ON (Atikokan); NU (Coral H)"
			},
			"America/Winnipeg": {
				"name": "America/Winnipeg",
				"lat": 49.8833,
				"long": -96.85,
				"countries": [
					"CA"
				],
				"comments": "Central - ON (west); Manitoba"
			},
			"America/Rainy_River": {
				"name": "America/Rainy_River",
				"lat": 48.7167,
				"long": -93.4333,
				"countries": [
					"CA"
				],
				"comments": "Central - ON (Rainy R, Ft Frances)"
			},
			"America/Resolute": {
				"name": "America/Resolute",
				"lat": 74.6956,
				"long": -93.1708,
				"countries": [
					"CA"
				],
				"comments": "Central - NU (Resolute)"
			},
			"America/Rankin_Inlet": {
				"name": "America/Rankin_Inlet",
				"lat": 62.8167,
				"long": -91.9169,
				"countries": [
					"CA"
				],
				"comments": "Central - NU (central)"
			},
			"America/Regina": {
				"name": "America/Regina",
				"lat": 50.4,
				"long": -103.35,
				"countries": [
					"CA"
				],
				"comments": "CST - SK (most areas)"
			},
			"America/Swift_Current": {
				"name": "America/Swift_Current",
				"lat": 50.2833,
				"long": -106.1667,
				"countries": [
					"CA"
				],
				"comments": "CST - SK (midwest)"
			},
			"America/Edmonton": {
				"name": "America/Edmonton",
				"lat": 53.55,
				"long": -112.5333,
				"countries": [
					"CA"
				],
				"comments": "Mountain - AB; BC (E); SK (W)"
			},
			"America/Cambridge_Bay": {
				"name": "America/Cambridge_Bay",
				"lat": 69.1139,
				"long": -104.9472,
				"countries": [
					"CA"
				],
				"comments": "Mountain - NU (west)"
			},
			"America/Yellowknife": {
				"name": "America/Yellowknife",
				"lat": 62.45,
				"long": -113.65,
				"countries": [
					"CA"
				],
				"comments": "Mountain - NT (central)"
			},
			"America/Inuvik": {
				"name": "America/Inuvik",
				"lat": 68.3497,
				"long": -132.2833,
				"countries": [
					"CA"
				],
				"comments": "Mountain - NT (west)"
			},
			"America/Creston": {
				"name": "America/Creston",
				"lat": 49.1,
				"long": -115.4833,
				"countries": [
					"CA"
				],
				"comments": "MST - BC (Creston)"
			},
			"America/Dawson_Creek": {
				"name": "America/Dawson_Creek",
				"lat": 59.7667,
				"long": -119.7667,
				"countries": [
					"CA"
				],
				"comments": "MST - BC (Dawson Cr, Ft St John)"
			},
			"America/Fort_Nelson": {
				"name": "America/Fort_Nelson",
				"lat": 58.8,
				"long": -121.3,
				"countries": [
					"CA"
				],
				"comments": "MST - BC (Ft Nelson)"
			},
			"America/Vancouver": {
				"name": "America/Vancouver",
				"lat": 49.2667,
				"long": -122.8833,
				"countries": [
					"CA"
				],
				"comments": "Pacific - BC (most areas)"
			},
			"America/Whitehorse": {
				"name": "America/Whitehorse",
				"lat": 60.7167,
				"long": -134.95,
				"countries": [
					"CA"
				],
				"comments": "Pacific - Yukon (south)"
			},
			"America/Dawson": {
				"name": "America/Dawson",
				"lat": 64.0667,
				"long": -138.5833,
				"countries": [
					"CA"
				],
				"comments": "Pacific - Yukon (north)"
			},
			"Indian/Cocos": {
				"name": "Indian/Cocos",
				"lat": -11.8333,
				"long": 96.9167,
				"countries": [
					"CC"
				],
				"comments": ""
			},
			"Europe/Zurich": {
				"name": "Europe/Zurich",
				"lat": 47.3833,
				"long": 8.5333,
				"countries": [
					"CH",
					"DE",
					"LI"
				],
				"comments": "Swiss time"
			},
			"Africa/Abidjan": {
				"name": "Africa/Abidjan",
				"lat": 5.3167,
				"long": -3.9667,
				"countries": [
					"CI",
					"BF",
					"GM",
					"GN",
					"ML",
					"MR",
					"SH",
					"SL",
					"SN",
					"ST",
					"TG"
				],
				"comments": ""
			},
			"Pacific/Rarotonga": {
				"name": "Pacific/Rarotonga",
				"lat": -20.7667,
				"long": -158.2333,
				"countries": [
					"CK"
				],
				"comments": ""
			},
			"America/Santiago": {
				"name": "America/Santiago",
				"lat": -32.55,
				"long": -69.3333,
				"countries": [
					"CL"
				],
				"comments": "Chile (most areas)"
			},
			"Pacific/Easter": {
				"name": "Pacific/Easter",
				"lat": -26.85,
				"long": -108.5667,
				"countries": [
					"CL"
				],
				"comments": "Easter Island"
			},
			"Asia/Shanghai": {
				"name": "Asia/Shanghai",
				"lat": 31.2333,
				"long": 121.4667,
				"countries": [
					"CN"
				],
				"comments": "Beijing Time"
			},
			"Asia/Urumqi": {
				"name": "Asia/Urumqi",
				"lat": 43.8,
				"long": 87.5833,
				"countries": [
					"CN"
				],
				"comments": "Xinjiang Time"
			},
			"America/Bogota": {
				"name": "America/Bogota",
				"lat": 4.6,
				"long": -73.9167,
				"countries": [
					"CO"
				],
				"comments": ""
			},
			"America/Costa_Rica": {
				"name": "America/Costa_Rica",
				"lat": 9.9333,
				"long": -83.9167,
				"countries": [
					"CR"
				],
				"comments": ""
			},
			"America/Havana": {
				"name": "America/Havana",
				"lat": 23.1333,
				"long": -81.6333,
				"countries": [
					"CU"
				],
				"comments": ""
			},
			"Atlantic/Cape_Verde": {
				"name": "Atlantic/Cape_Verde",
				"lat": 14.9167,
				"long": -22.4833,
				"countries": [
					"CV"
				],
				"comments": ""
			},
			"America/Curacao": {
				"name": "America/Curacao",
				"lat": 12.1833,
				"long": -69,
				"countries": [
					"CW",
					"AW",
					"BQ",
					"SX"
				],
				"comments": ""
			},
			"Indian/Christmas": {
				"name": "Indian/Christmas",
				"lat": -9.5833,
				"long": 105.7167,
				"countries": [
					"CX"
				],
				"comments": ""
			},
			"Asia/Nicosia": {
				"name": "Asia/Nicosia",
				"lat": 35.1667,
				"long": 33.3667,
				"countries": [
					"CY"
				],
				"comments": ""
			},
			"Europe/Prague": {
				"name": "Europe/Prague",
				"lat": 50.0833,
				"long": 14.4333,
				"countries": [
					"CZ",
					"SK"
				],
				"comments": ""
			},
			"Europe/Berlin": {
				"name": "Europe/Berlin",
				"lat": 52.5,
				"long": 13.3667,
				"countries": [
					"DE"
				],
				"comments": "Germany (most areas)"
			},
			"Europe/Copenhagen": {
				"name": "Europe/Copenhagen",
				"lat": 55.6667,
				"long": 12.5833,
				"countries": [
					"DK"
				],
				"comments": ""
			},
			"America/Santo_Domingo": {
				"name": "America/Santo_Domingo",
				"lat": 18.4667,
				"long": -68.1,
				"countries": [
					"DO"
				],
				"comments": ""
			},
			"Africa/Algiers": {
				"name": "Africa/Algiers",
				"lat": 36.7833,
				"long": 3.05,
				"countries": [
					"DZ"
				],
				"comments": ""
			},
			"America/Guayaquil": {
				"name": "America/Guayaquil",
				"lat": -1.8333,
				"long": -78.1667,
				"countries": [
					"EC"
				],
				"comments": "Ecuador (mainland)"
			},
			"Pacific/Galapagos": {
				"name": "Pacific/Galapagos",
				"lat": 0.9,
				"long": -88.4,
				"countries": [
					"EC"
				],
				"comments": "Galápagos Islands"
			},
			"Europe/Tallinn": {
				"name": "Europe/Tallinn",
				"lat": 59.4167,
				"long": 24.75,
				"countries": [
					"EE"
				],
				"comments": ""
			},
			"Africa/Cairo": {
				"name": "Africa/Cairo",
				"lat": 30.05,
				"long": 31.25,
				"countries": [
					"EG"
				],
				"comments": ""
			},
			"Africa/El_Aaiun": {
				"name": "Africa/El_Aaiun",
				"lat": 27.15,
				"long": -12.8,
				"countries": [
					"EH"
				],
				"comments": ""
			},
			"Europe/Madrid": {
				"name": "Europe/Madrid",
				"lat": 40.4,
				"long": -2.3167,
				"countries": [
					"ES"
				],
				"comments": "Spain (mainland)"
			},
			"Africa/Ceuta": {
				"name": "Africa/Ceuta",
				"lat": 35.8833,
				"long": -4.6833,
				"countries": [
					"ES"
				],
				"comments": "Ceuta, Melilla"
			},
			"Atlantic/Canary": {
				"name": "Atlantic/Canary",
				"lat": 28.1,
				"long": -14.6,
				"countries": [
					"ES"
				],
				"comments": "Canary Islands"
			},
			"Europe/Helsinki": {
				"name": "Europe/Helsinki",
				"lat": 60.1667,
				"long": 24.9667,
				"countries": [
					"FI",
					"AX"
				],
				"comments": ""
			},
			"Pacific/Fiji": {
				"name": "Pacific/Fiji",
				"lat": -17.8667,
				"long": 178.4167,
				"countries": [
					"FJ"
				],
				"comments": ""
			},
			"Atlantic/Stanley": {
				"name": "Atlantic/Stanley",
				"lat": -50.3,
				"long": -56.15,
				"countries": [
					"FK"
				],
				"comments": ""
			},
			"Pacific/Chuuk": {
				"name": "Pacific/Chuuk",
				"lat": 7.4167,
				"long": 151.7833,
				"countries": [
					"FM"
				],
				"comments": "Chuuk/Truk, Yap"
			},
			"Pacific/Pohnpei": {
				"name": "Pacific/Pohnpei",
				"lat": 6.9667,
				"long": 158.2167,
				"countries": [
					"FM"
				],
				"comments": "Pohnpei/Ponape"
			},
			"Pacific/Kosrae": {
				"name": "Pacific/Kosrae",
				"lat": 5.3167,
				"long": 162.9833,
				"countries": [
					"FM"
				],
				"comments": "Kosrae"
			},
			"Atlantic/Faroe": {
				"name": "Atlantic/Faroe",
				"lat": 62.0167,
				"long": -5.2333,
				"countries": [
					"FO"
				],
				"comments": ""
			},
			"Europe/Paris": {
				"name": "Europe/Paris",
				"lat": 48.8667,
				"long": 2.3333,
				"countries": [
					"FR"
				],
				"comments": ""
			},
			"Europe/London": {
				"name": "Europe/London",
				"lat": 51.5083,
				"long": 0.1253,
				"countries": [
					"GB",
					"GG",
					"IM",
					"JE"
				],
				"comments": ""
			},
			"Asia/Tbilisi": {
				"name": "Asia/Tbilisi",
				"lat": 41.7167,
				"long": 44.8167,
				"countries": [
					"GE"
				],
				"comments": ""
			},
			"America/Cayenne": {
				"name": "America/Cayenne",
				"lat": 4.9333,
				"long": -51.6667,
				"countries": [
					"GF"
				],
				"comments": ""
			},
			"Africa/Accra": {
				"name": "Africa/Accra",
				"lat": 5.55,
				"long": 0.2167,
				"countries": [
					"GH"
				],
				"comments": ""
			},
			"Europe/Gibraltar": {
				"name": "Europe/Gibraltar",
				"lat": 36.1333,
				"long": -4.65,
				"countries": [
					"GI"
				],
				"comments": ""
			},
			"America/Godthab": {
				"name": "America/Godthab",
				"lat": 64.1833,
				"long": -50.2667,
				"countries": [
					"GL"
				],
				"comments": "Greenland (most areas)"
			},
			"America/Danmarkshavn": {
				"name": "America/Danmarkshavn",
				"lat": 76.7667,
				"long": -17.3333,
				"countries": [
					"GL"
				],
				"comments": "National Park (east coast)"
			},
			"America/Scoresbysund": {
				"name": "America/Scoresbysund",
				"lat": 70.4833,
				"long": -20.0333,
				"countries": [
					"GL"
				],
				"comments": "Scoresbysund/Ittoqqortoormiit"
			},
			"America/Thule": {
				"name": "America/Thule",
				"lat": 76.5667,
				"long": -67.2167,
				"countries": [
					"GL"
				],
				"comments": "Thule/Pituffik"
			},
			"Europe/Athens": {
				"name": "Europe/Athens",
				"lat": 37.9667,
				"long": 23.7167,
				"countries": [
					"GR"
				],
				"comments": ""
			},
			"Atlantic/South_Georgia": {
				"name": "Atlantic/South_Georgia",
				"lat": -53.7333,
				"long": -35.4667,
				"countries": [
					"GS"
				],
				"comments": ""
			},
			"America/Guatemala": {
				"name": "America/Guatemala",
				"lat": 14.6333,
				"long": -89.4833,
				"countries": [
					"GT"
				],
				"comments": ""
			},
			"Pacific/Guam": {
				"name": "Pacific/Guam",
				"lat": 13.4667,
				"long": 144.75,
				"countries": [
					"GU",
					"MP"
				],
				"comments": ""
			},
			"Africa/Bissau": {
				"name": "Africa/Bissau",
				"lat": 11.85,
				"long": -14.4167,
				"countries": [
					"GW"
				],
				"comments": ""
			},
			"America/Guyana": {
				"name": "America/Guyana",
				"lat": 6.8,
				"long": -57.8333,
				"countries": [
					"GY"
				],
				"comments": ""
			},
			"Asia/Hong_Kong": {
				"name": "Asia/Hong_Kong",
				"lat": 22.2833,
				"long": 114.15,
				"countries": [
					"HK"
				],
				"comments": ""
			},
			"America/Tegucigalpa": {
				"name": "America/Tegucigalpa",
				"lat": 14.1,
				"long": -86.7833,
				"countries": [
					"HN"
				],
				"comments": ""
			},
			"America/Port-au-Prince": {
				"name": "America/Port-au-Prince",
				"lat": 18.5333,
				"long": -71.6667,
				"countries": [
					"HT"
				],
				"comments": ""
			},
			"Europe/Budapest": {
				"name": "Europe/Budapest",
				"lat": 47.5,
				"long": 19.0833,
				"countries": [
					"HU"
				],
				"comments": ""
			},
			"Asia/Jakarta": {
				"name": "Asia/Jakarta",
				"lat": -5.8333,
				"long": 106.8,
				"countries": [
					"ID"
				],
				"comments": "Java, Sumatra"
			},
			"Asia/Pontianak": {
				"name": "Asia/Pontianak",
				"lat": 0.0333,
				"long": 109.3333,
				"countries": [
					"ID"
				],
				"comments": "Borneo (west, central)"
			},
			"Asia/Makassar": {
				"name": "Asia/Makassar",
				"lat": -4.8833,
				"long": 119.4,
				"countries": [
					"ID"
				],
				"comments": "Borneo (east, south); Sulawesi/Celebes, Bali, Nusa Tengarra; Timor (west)"
			},
			"Asia/Jayapura": {
				"name": "Asia/Jayapura",
				"lat": -1.4667,
				"long": 140.7,
				"countries": [
					"ID"
				],
				"comments": "New Guinea (West Papua / Irian Jaya); Malukus/Moluccas"
			},
			"Europe/Dublin": {
				"name": "Europe/Dublin",
				"lat": 53.3333,
				"long": -5.75,
				"countries": [
					"IE"
				],
				"comments": ""
			},
			"Asia/Jerusalem": {
				"name": "Asia/Jerusalem",
				"lat": 31.7806,
				"long": 35.2239,
				"countries": [
					"IL"
				],
				"comments": ""
			},
			"Asia/Kolkata": {
				"name": "Asia/Kolkata",
				"lat": 22.5333,
				"long": 88.3667,
				"countries": [
					"IN"
				],
				"comments": ""
			},
			"Indian/Chagos": {
				"name": "Indian/Chagos",
				"lat": -6.6667,
				"long": 72.4167,
				"countries": [
					"IO"
				],
				"comments": ""
			},
			"Asia/Baghdad": {
				"name": "Asia/Baghdad",
				"lat": 33.35,
				"long": 44.4167,
				"countries": [
					"IQ"
				],
				"comments": ""
			},
			"Asia/Tehran": {
				"name": "Asia/Tehran",
				"lat": 35.6667,
				"long": 51.4333,
				"countries": [
					"IR"
				],
				"comments": ""
			},
			"Atlantic/Reykjavik": {
				"name": "Atlantic/Reykjavik",
				"lat": 64.15,
				"long": -20.15,
				"countries": [
					"IS"
				],
				"comments": ""
			},
			"Europe/Rome": {
				"name": "Europe/Rome",
				"lat": 41.9,
				"long": 12.4833,
				"countries": [
					"IT",
					"SM",
					"VA"
				],
				"comments": ""
			},
			"America/Jamaica": {
				"name": "America/Jamaica",
				"lat": 17.9681,
				"long": -75.2067,
				"countries": [
					"JM"
				],
				"comments": ""
			},
			"Asia/Amman": {
				"name": "Asia/Amman",
				"lat": 31.95,
				"long": 35.9333,
				"countries": [
					"JO"
				],
				"comments": ""
			},
			"Asia/Tokyo": {
				"name": "Asia/Tokyo",
				"lat": 35.6544,
				"long": 139.7447,
				"countries": [
					"JP"
				],
				"comments": ""
			},
			"Africa/Nairobi": {
				"name": "Africa/Nairobi",
				"lat": -0.7167,
				"long": 36.8167,
				"countries": [
					"KE",
					"DJ",
					"ER",
					"ET",
					"KM",
					"MG",
					"SO",
					"TZ",
					"UG",
					"YT"
				],
				"comments": ""
			},
			"Asia/Bishkek": {
				"name": "Asia/Bishkek",
				"lat": 42.9,
				"long": 74.6,
				"countries": [
					"KG"
				],
				"comments": ""
			},
			"Pacific/Tarawa": {
				"name": "Pacific/Tarawa",
				"lat": 1.4167,
				"long": 173,
				"countries": [
					"KI"
				],
				"comments": "Gilbert Islands"
			},
			"Pacific/Enderbury": {
				"name": "Pacific/Enderbury",
				"lat": -2.8667,
				"long": -170.9167,
				"countries": [
					"KI"
				],
				"comments": "Phoenix Islands"
			},
			"Pacific/Kiritimati": {
				"name": "Pacific/Kiritimati",
				"lat": 1.8667,
				"long": -156.6667,
				"countries": [
					"KI"
				],
				"comments": "Line Islands"
			},
			"Asia/Pyongyang": {
				"name": "Asia/Pyongyang",
				"lat": 39.0167,
				"long": 125.75,
				"countries": [
					"KP"
				],
				"comments": ""
			},
			"Asia/Seoul": {
				"name": "Asia/Seoul",
				"lat": 37.55,
				"long": 126.9667,
				"countries": [
					"KR"
				],
				"comments": ""
			},
			"Asia/Almaty": {
				"name": "Asia/Almaty",
				"lat": 43.25,
				"long": 76.95,
				"countries": [
					"KZ"
				],
				"comments": "Kazakhstan (most areas)"
			},
			"Asia/Qyzylorda": {
				"name": "Asia/Qyzylorda",
				"lat": 44.8,
				"long": 65.4667,
				"countries": [
					"KZ"
				],
				"comments": "Qyzylorda/Kyzylorda/Kzyl-Orda"
			},
			"Asia/Aqtobe": {
				"name": "Asia/Aqtobe",
				"lat": 50.2833,
				"long": 57.1667,
				"countries": [
					"KZ"
				],
				"comments": "Aqtobe/Aktobe"
			},
			"Asia/Aqtau": {
				"name": "Asia/Aqtau",
				"lat": 44.5167,
				"long": 50.2667,
				"countries": [
					"KZ"
				],
				"comments": "Atyrau/Atirau/Gur'yev, Mangghystau/Mankistau"
			},
			"Asia/Oral": {
				"name": "Asia/Oral",
				"lat": 51.2167,
				"long": 51.35,
				"countries": [
					"KZ"
				],
				"comments": "West Kazakhstan"
			},
			"Asia/Beirut": {
				"name": "Asia/Beirut",
				"lat": 33.8833,
				"long": 35.5,
				"countries": [
					"LB"
				],
				"comments": ""
			},
			"Asia/Colombo": {
				"name": "Asia/Colombo",
				"lat": 6.9333,
				"long": 79.85,
				"countries": [
					"LK"
				],
				"comments": ""
			},
			"Africa/Monrovia": {
				"name": "Africa/Monrovia",
				"lat": 6.3,
				"long": -9.2167,
				"countries": [
					"LR"
				],
				"comments": ""
			},
			"Europe/Vilnius": {
				"name": "Europe/Vilnius",
				"lat": 54.6833,
				"long": 25.3167,
				"countries": [
					"LT"
				],
				"comments": ""
			},
			"Europe/Luxembourg": {
				"name": "Europe/Luxembourg",
				"lat": 49.6,
				"long": 6.15,
				"countries": [
					"LU"
				],
				"comments": ""
			},
			"Europe/Riga": {
				"name": "Europe/Riga",
				"lat": 56.95,
				"long": 24.1,
				"countries": [
					"LV"
				],
				"comments": ""
			},
			"Africa/Tripoli": {
				"name": "Africa/Tripoli",
				"lat": 32.9,
				"long": 13.1833,
				"countries": [
					"LY"
				],
				"comments": ""
			},
			"Africa/Casablanca": {
				"name": "Africa/Casablanca",
				"lat": 33.65,
				"long": -6.4167,
				"countries": [
					"MA"
				],
				"comments": ""
			},
			"Europe/Monaco": {
				"name": "Europe/Monaco",
				"lat": 43.7,
				"long": 7.3833,
				"countries": [
					"MC"
				],
				"comments": ""
			},
			"Europe/Chisinau": {
				"name": "Europe/Chisinau",
				"lat": 47,
				"long": 28.8333,
				"countries": [
					"MD"
				],
				"comments": ""
			},
			"Pacific/Majuro": {
				"name": "Pacific/Majuro",
				"lat": 7.15,
				"long": 171.2,
				"countries": [
					"MH"
				],
				"comments": "Marshall Islands (most areas)"
			},
			"Pacific/Kwajalein": {
				"name": "Pacific/Kwajalein",
				"lat": 9.0833,
				"long": 167.3333,
				"countries": [
					"MH"
				],
				"comments": "Kwajalein"
			},
			"Asia/Rangoon": {
				"name": "Asia/Rangoon",
				"lat": 16.7833,
				"long": 96.1667,
				"countries": [
					"MM"
				],
				"comments": ""
			},
			"Asia/Ulaanbaatar": {
				"name": "Asia/Ulaanbaatar",
				"lat": 47.9167,
				"long": 106.8833,
				"countries": [
					"MN"
				],
				"comments": "Mongolia (most areas)"
			},
			"Asia/Hovd": {
				"name": "Asia/Hovd",
				"lat": 48.0167,
				"long": 91.65,
				"countries": [
					"MN"
				],
				"comments": "Bayan-Ölgii, Govi-Altai, Hovd, Uvs, Zavkhan"
			},
			"Asia/Choibalsan": {
				"name": "Asia/Choibalsan",
				"lat": 48.0667,
				"long": 114.5,
				"countries": [
					"MN"
				],
				"comments": "Dornod, Sükhbaatar"
			},
			"Asia/Macau": {
				"name": "Asia/Macau",
				"lat": 22.2333,
				"long": 113.5833,
				"countries": [
					"MO"
				],
				"comments": ""
			},
			"America/Martinique": {
				"name": "America/Martinique",
				"lat": 14.6,
				"long": -60.9167,
				"countries": [
					"MQ"
				],
				"comments": ""
			},
			"Europe/Malta": {
				"name": "Europe/Malta",
				"lat": 35.9,
				"long": 14.5167,
				"countries": [
					"MT"
				],
				"comments": ""
			},
			"Indian/Mauritius": {
				"name": "Indian/Mauritius",
				"lat": -19.8333,
				"long": 57.5,
				"countries": [
					"MU"
				],
				"comments": ""
			},
			"Indian/Maldives": {
				"name": "Indian/Maldives",
				"lat": 4.1667,
				"long": 73.5,
				"countries": [
					"MV"
				],
				"comments": ""
			},
			"America/Mexico_City": {
				"name": "America/Mexico_City",
				"lat": 19.4,
				"long": -98.85,
				"countries": [
					"MX"
				],
				"comments": "Central Time"
			},
			"America/Cancun": {
				"name": "America/Cancun",
				"lat": 21.0833,
				"long": -85.2333,
				"countries": [
					"MX"
				],
				"comments": "Eastern Standard Time - Quintana Roo"
			},
			"America/Merida": {
				"name": "America/Merida",
				"lat": 20.9667,
				"long": -88.3833,
				"countries": [
					"MX"
				],
				"comments": "Central Time - Campeche, Yucatán"
			},
			"America/Monterrey": {
				"name": "America/Monterrey",
				"lat": 25.6667,
				"long": -99.6833,
				"countries": [
					"MX"
				],
				"comments": "Central Time - Durango; Coahuila, Nuevo León, Tamaulipas (most areas)"
			},
			"America/Matamoros": {
				"name": "America/Matamoros",
				"lat": 25.8333,
				"long": -96.5,
				"countries": [
					"MX"
				],
				"comments": "Central Time US - Coahuila, Nuevo León, Tamaulipas (US border)"
			},
			"America/Mazatlan": {
				"name": "America/Mazatlan",
				"lat": 23.2167,
				"long": -105.5833,
				"countries": [
					"MX"
				],
				"comments": "Mountain Time - Baja California Sur, Nayarit, Sinaloa"
			},
			"America/Chihuahua": {
				"name": "America/Chihuahua",
				"lat": 28.6333,
				"long": -105.9167,
				"countries": [
					"MX"
				],
				"comments": "Mountain Time - Chihuahua (most areas)"
			},
			"America/Ojinaga": {
				"name": "America/Ojinaga",
				"lat": 29.5667,
				"long": -103.5833,
				"countries": [
					"MX"
				],
				"comments": "Mountain Time US - Chihuahua (US border)"
			},
			"America/Hermosillo": {
				"name": "America/Hermosillo",
				"lat": 29.0667,
				"long": -109.0333,
				"countries": [
					"MX"
				],
				"comments": "Mountain Standard Time - Sonora"
			},
			"America/Tijuana": {
				"name": "America/Tijuana",
				"lat": 32.5333,
				"long": -116.9833,
				"countries": [
					"MX"
				],
				"comments": "Pacific Time US - Baja California"
			},
			"America/Bahia_Banderas": {
				"name": "America/Bahia_Banderas",
				"lat": 20.8,
				"long": -104.75,
				"countries": [
					"MX"
				],
				"comments": "Central Time - Bahía de Banderas"
			},
			"Asia/Kuala_Lumpur": {
				"name": "Asia/Kuala_Lumpur",
				"lat": 3.1667,
				"long": 101.7,
				"countries": [
					"MY"
				],
				"comments": "Malaysia (peninsula)"
			},
			"Asia/Kuching": {
				"name": "Asia/Kuching",
				"lat": 1.55,
				"long": 110.3333,
				"countries": [
					"MY"
				],
				"comments": "Sabah, Sarawak"
			},
			"Africa/Maputo": {
				"name": "Africa/Maputo",
				"lat": -24.0333,
				"long": 32.5833,
				"countries": [
					"MZ",
					"BI",
					"BW",
					"CD",
					"MW",
					"RW",
					"ZM",
					"ZW"
				],
				"comments": "Central Africa Time"
			},
			"Africa/Windhoek": {
				"name": "Africa/Windhoek",
				"lat": -21.4333,
				"long": 17.1,
				"countries": [
					"NA"
				],
				"comments": ""
			},
			"Pacific/Noumea": {
				"name": "Pacific/Noumea",
				"lat": -21.7333,
				"long": 166.45,
				"countries": [
					"NC"
				],
				"comments": ""
			},
			"Pacific/Norfolk": {
				"name": "Pacific/Norfolk",
				"lat": -28.95,
				"long": 167.9667,
				"countries": [
					"NF"
				],
				"comments": ""
			},
			"Africa/Lagos": {
				"name": "Africa/Lagos",
				"lat": 6.45,
				"long": 3.4,
				"countries": [
					"NG",
					"AO",
					"BJ",
					"CD",
					"CF",
					"CG",
					"CM",
					"GA",
					"GQ",
					"NE"
				],
				"comments": "West Africa Time"
			},
			"America/Managua": {
				"name": "America/Managua",
				"lat": 12.15,
				"long": -85.7167,
				"countries": [
					"NI"
				],
				"comments": ""
			},
			"Europe/Amsterdam": {
				"name": "Europe/Amsterdam",
				"lat": 52.3667,
				"long": 4.9,
				"countries": [
					"NL"
				],
				"comments": ""
			},
			"Europe/Oslo": {
				"name": "Europe/Oslo",
				"lat": 59.9167,
				"long": 10.75,
				"countries": [
					"NO",
					"SJ"
				],
				"comments": ""
			},
			"Asia/Kathmandu": {
				"name": "Asia/Kathmandu",
				"lat": 27.7167,
				"long": 85.3167,
				"countries": [
					"NP"
				],
				"comments": ""
			},
			"Pacific/Nauru": {
				"name": "Pacific/Nauru",
				"lat": 0.5167,
				"long": 166.9167,
				"countries": [
					"NR"
				],
				"comments": ""
			},
			"Pacific/Niue": {
				"name": "Pacific/Niue",
				"lat": -18.9833,
				"long": -168.0833,
				"countries": [
					"NU"
				],
				"comments": ""
			},
			"Pacific/Auckland": {
				"name": "Pacific/Auckland",
				"lat": -35.1333,
				"long": 174.7667,
				"countries": [
					"NZ",
					"AQ"
				],
				"comments": "New Zealand time"
			},
			"Pacific/Chatham": {
				"name": "Pacific/Chatham",
				"lat": -42.05,
				"long": -175.45,
				"countries": [
					"NZ"
				],
				"comments": "Chatham Islands"
			},
			"America/Panama": {
				"name": "America/Panama",
				"lat": 8.9667,
				"long": -78.4667,
				"countries": [
					"PA",
					"KY"
				],
				"comments": ""
			},
			"America/Lima": {
				"name": "America/Lima",
				"lat": -11.95,
				"long": -76.95,
				"countries": [
					"PE"
				],
				"comments": ""
			},
			"Pacific/Tahiti": {
				"name": "Pacific/Tahiti",
				"lat": -16.4667,
				"long": -148.4333,
				"countries": [
					"PF"
				],
				"comments": "Society Islands"
			},
			"Pacific/Marquesas": {
				"name": "Pacific/Marquesas",
				"lat": -9,
				"long": -138.5,
				"countries": [
					"PF"
				],
				"comments": "Marquesas Islands"
			},
			"Pacific/Gambier": {
				"name": "Pacific/Gambier",
				"lat": -22.8667,
				"long": -133.05,
				"countries": [
					"PF"
				],
				"comments": "Gambier Islands"
			},
			"Pacific/Port_Moresby": {
				"name": "Pacific/Port_Moresby",
				"lat": -8.5,
				"long": 147.1667,
				"countries": [
					"PG"
				],
				"comments": "Papua New Guinea (most areas)"
			},
			"Pacific/Bougainville": {
				"name": "Pacific/Bougainville",
				"lat": -5.7833,
				"long": 155.5667,
				"countries": [
					"PG"
				],
				"comments": "Bougainville"
			},
			"Asia/Manila": {
				"name": "Asia/Manila",
				"lat": 14.5833,
				"long": 121,
				"countries": [
					"PH"
				],
				"comments": ""
			},
			"Asia/Karachi": {
				"name": "Asia/Karachi",
				"lat": 24.8667,
				"long": 67.05,
				"countries": [
					"PK"
				],
				"comments": ""
			},
			"Europe/Warsaw": {
				"name": "Europe/Warsaw",
				"lat": 52.25,
				"long": 21,
				"countries": [
					"PL"
				],
				"comments": ""
			},
			"America/Miquelon": {
				"name": "America/Miquelon",
				"lat": 47.05,
				"long": -55.6667,
				"countries": [
					"PM"
				],
				"comments": ""
			},
			"Pacific/Pitcairn": {
				"name": "Pacific/Pitcairn",
				"lat": -24.9333,
				"long": -129.9167,
				"countries": [
					"PN"
				],
				"comments": ""
			},
			"America/Puerto_Rico": {
				"name": "America/Puerto_Rico",
				"lat": 18.4683,
				"long": -65.8939,
				"countries": [
					"PR"
				],
				"comments": ""
			},
			"Asia/Gaza": {
				"name": "Asia/Gaza",
				"lat": 31.5,
				"long": 34.4667,
				"countries": [
					"PS"
				],
				"comments": "Gaza Strip"
			},
			"Asia/Hebron": {
				"name": "Asia/Hebron",
				"lat": 31.5333,
				"long": 35.095,
				"countries": [
					"PS"
				],
				"comments": "West Bank"
			},
			"Europe/Lisbon": {
				"name": "Europe/Lisbon",
				"lat": 38.7167,
				"long": -8.8667,
				"countries": [
					"PT"
				],
				"comments": "Portugal (mainland)"
			},
			"Atlantic/Madeira": {
				"name": "Atlantic/Madeira",
				"lat": 32.6333,
				"long": -15.1,
				"countries": [
					"PT"
				],
				"comments": "Madeira Islands"
			},
			"Atlantic/Azores": {
				"name": "Atlantic/Azores",
				"lat": 37.7333,
				"long": -24.3333,
				"countries": [
					"PT"
				],
				"comments": "Azores"
			},
			"Pacific/Palau": {
				"name": "Pacific/Palau",
				"lat": 7.3333,
				"long": 134.4833,
				"countries": [
					"PW"
				],
				"comments": ""
			},
			"America/Asuncion": {
				"name": "America/Asuncion",
				"lat": -24.7333,
				"long": -56.3333,
				"countries": [
					"PY"
				],
				"comments": ""
			},
			"Asia/Qatar": {
				"name": "Asia/Qatar",
				"lat": 25.2833,
				"long": 51.5333,
				"countries": [
					"QA",
					"BH"
				],
				"comments": ""
			},
			"Indian/Reunion": {
				"name": "Indian/Reunion",
				"lat": -19.1333,
				"long": 55.4667,
				"countries": [
					"RE",
					"TF"
				],
				"comments": "Réunion, Crozet, Scattered Islands"
			},
			"Europe/Bucharest": {
				"name": "Europe/Bucharest",
				"lat": 44.4333,
				"long": 26.1,
				"countries": [
					"RO"
				],
				"comments": ""
			},
			"Europe/Belgrade": {
				"name": "Europe/Belgrade",
				"lat": 44.8333,
				"long": 20.5,
				"countries": [
					"RS",
					"BA",
					"HR",
					"ME",
					"MK",
					"SI"
				],
				"comments": ""
			},
			"Europe/Kaliningrad": {
				"name": "Europe/Kaliningrad",
				"lat": 54.7167,
				"long": 20.5,
				"countries": [
					"RU"
				],
				"comments": "MSK-01 - Kaliningrad"
			},
			"Europe/Moscow": {
				"name": "Europe/Moscow",
				"lat": 55.7558,
				"long": 37.6178,
				"countries": [
					"RU"
				],
				"comments": "MSK+00 - Moscow area"
			},
			"Europe/Simferopol": {
				"name": "Europe/Simferopol",
				"lat": 44.95,
				"long": 34.1,
				"countries": [
					"RU"
				],
				"comments": "MSK+00 - Crimea"
			},
			"Europe/Volgograd": {
				"name": "Europe/Volgograd",
				"lat": 48.7333,
				"long": 44.4167,
				"countries": [
					"RU"
				],
				"comments": "MSK+00 - Volgograd, Saratov"
			},
			"Europe/Kirov": {
				"name": "Europe/Kirov",
				"lat": 58.6,
				"long": 49.65,
				"countries": [
					"RU"
				],
				"comments": "MSK+00 - Kirov"
			},
			"Europe/Astrakhan": {
				"name": "Europe/Astrakhan",
				"lat": 46.35,
				"long": 48.05,
				"countries": [
					"RU"
				],
				"comments": "MSK+01 - Astrakhan"
			},
			"Europe/Samara": {
				"name": "Europe/Samara",
				"lat": 53.2,
				"long": 50.15,
				"countries": [
					"RU"
				],
				"comments": "MSK+01 - Samara, Udmurtia"
			},
			"Europe/Ulyanovsk": {
				"name": "Europe/Ulyanovsk",
				"lat": 54.3333,
				"long": 48.4,
				"countries": [
					"RU"
				],
				"comments": "MSK+01 - Ulyanovsk"
			},
			"Asia/Yekaterinburg": {
				"name": "Asia/Yekaterinburg",
				"lat": 56.85,
				"long": 60.6,
				"countries": [
					"RU"
				],
				"comments": "MSK+02 - Urals"
			},
			"Asia/Omsk": {
				"name": "Asia/Omsk",
				"lat": 55,
				"long": 73.4,
				"countries": [
					"RU"
				],
				"comments": "MSK+03 - Omsk"
			},
			"Asia/Novosibirsk": {
				"name": "Asia/Novosibirsk",
				"lat": 55.0333,
				"long": 82.9167,
				"countries": [
					"RU"
				],
				"comments": "MSK+03 - Novosibirsk"
			},
			"Asia/Barnaul": {
				"name": "Asia/Barnaul",
				"lat": 53.3667,
				"long": 83.75,
				"countries": [
					"RU"
				],
				"comments": "MSK+04 - Altai"
			},
			"Asia/Tomsk": {
				"name": "Asia/Tomsk",
				"lat": 56.5,
				"long": 84.9667,
				"countries": [
					"RU"
				],
				"comments": "MSK+04 - Tomsk"
			},
			"Asia/Novokuznetsk": {
				"name": "Asia/Novokuznetsk",
				"lat": 53.75,
				"long": 87.1167,
				"countries": [
					"RU"
				],
				"comments": "MSK+04 - Kemerovo"
			},
			"Asia/Krasnoyarsk": {
				"name": "Asia/Krasnoyarsk",
				"lat": 56.0167,
				"long": 92.8333,
				"countries": [
					"RU"
				],
				"comments": "MSK+04 - Krasnoyarsk area"
			},
			"Asia/Irkutsk": {
				"name": "Asia/Irkutsk",
				"lat": 52.2667,
				"long": 104.3333,
				"countries": [
					"RU"
				],
				"comments": "MSK+05 - Irkutsk, Buryatia"
			},
			"Asia/Chita": {
				"name": "Asia/Chita",
				"lat": 52.05,
				"long": 113.4667,
				"countries": [
					"RU"
				],
				"comments": "MSK+06 - Zabaykalsky"
			},
			"Asia/Yakutsk": {
				"name": "Asia/Yakutsk",
				"lat": 62,
				"long": 129.6667,
				"countries": [
					"RU"
				],
				"comments": "MSK+06 - Lena River"
			},
			"Asia/Khandyga": {
				"name": "Asia/Khandyga",
				"lat": 62.6564,
				"long": 135.5539,
				"countries": [
					"RU"
				],
				"comments": "MSK+06 - Tomponsky, Ust-Maysky"
			},
			"Asia/Vladivostok": {
				"name": "Asia/Vladivostok",
				"lat": 43.1667,
				"long": 131.9333,
				"countries": [
					"RU"
				],
				"comments": "MSK+07 - Amur River"
			},
			"Asia/Ust-Nera": {
				"name": "Asia/Ust-Nera",
				"lat": 64.5603,
				"long": 143.2267,
				"countries": [
					"RU"
				],
				"comments": "MSK+07 - Oymyakonsky"
			},
			"Asia/Magadan": {
				"name": "Asia/Magadan",
				"lat": 59.5667,
				"long": 150.8,
				"countries": [
					"RU"
				],
				"comments": "MSK+08 - Magadan"
			},
			"Asia/Sakhalin": {
				"name": "Asia/Sakhalin",
				"lat": 46.9667,
				"long": 142.7,
				"countries": [
					"RU"
				],
				"comments": "MSK+08 - Sakhalin Island"
			},
			"Asia/Srednekolymsk": {
				"name": "Asia/Srednekolymsk",
				"lat": 67.4667,
				"long": 153.7167,
				"countries": [
					"RU"
				],
				"comments": "MSK+08 - Sakha (E); North Kuril Is"
			},
			"Asia/Kamchatka": {
				"name": "Asia/Kamchatka",
				"lat": 53.0167,
				"long": 158.65,
				"countries": [
					"RU"
				],
				"comments": "MSK+09 - Kamchatka"
			},
			"Asia/Anadyr": {
				"name": "Asia/Anadyr",
				"lat": 64.75,
				"long": 177.4833,
				"countries": [
					"RU"
				],
				"comments": "MSK+09 - Bering Sea"
			},
			"Asia/Riyadh": {
				"name": "Asia/Riyadh",
				"lat": 24.6333,
				"long": 46.7167,
				"countries": [
					"SA",
					"KW",
					"YE"
				],
				"comments": ""
			},
			"Pacific/Guadalcanal": {
				"name": "Pacific/Guadalcanal",
				"lat": -8.4667,
				"long": 160.2,
				"countries": [
					"SB"
				],
				"comments": ""
			},
			"Indian/Mahe": {
				"name": "Indian/Mahe",
				"lat": -3.3333,
				"long": 55.4667,
				"countries": [
					"SC"
				],
				"comments": ""
			},
			"Africa/Khartoum": {
				"name": "Africa/Khartoum",
				"lat": 15.6,
				"long": 32.5333,
				"countries": [
					"SD",
					"SS"
				],
				"comments": ""
			},
			"Europe/Stockholm": {
				"name": "Europe/Stockholm",
				"lat": 59.3333,
				"long": 18.05,
				"countries": [
					"SE"
				],
				"comments": ""
			},
			"Asia/Singapore": {
				"name": "Asia/Singapore",
				"lat": 1.2833,
				"long": 103.85,
				"countries": [
					"SG"
				],
				"comments": ""
			},
			"America/Paramaribo": {
				"name": "America/Paramaribo",
				"lat": 5.8333,
				"long": -54.8333,
				"countries": [
					"SR"
				],
				"comments": ""
			},
			"America/El_Salvador": {
				"name": "America/El_Salvador",
				"lat": 13.7,
				"long": -88.8,
				"countries": [
					"SV"
				],
				"comments": ""
			},
			"Asia/Damascus": {
				"name": "Asia/Damascus",
				"lat": 33.5,
				"long": 36.3,
				"countries": [
					"SY"
				],
				"comments": ""
			},
			"America/Grand_Turk": {
				"name": "America/Grand_Turk",
				"lat": 21.4667,
				"long": -70.8667,
				"countries": [
					"TC"
				],
				"comments": ""
			},
			"Africa/Ndjamena": {
				"name": "Africa/Ndjamena",
				"lat": 12.1167,
				"long": 15.05,
				"countries": [
					"TD"
				],
				"comments": ""
			},
			"Indian/Kerguelen": {
				"name": "Indian/Kerguelen",
				"lat": -48.6472,
				"long": 70.2175,
				"countries": [
					"TF"
				],
				"comments": "Kerguelen, St Paul Island, Amsterdam Island"
			},
			"Asia/Bangkok": {
				"name": "Asia/Bangkok",
				"lat": 13.75,
				"long": 100.5167,
				"countries": [
					"TH",
					"KH",
					"LA",
					"VN"
				],
				"comments": "Indochina (most areas)"
			},
			"Asia/Dushanbe": {
				"name": "Asia/Dushanbe",
				"lat": 38.5833,
				"long": 68.8,
				"countries": [
					"TJ"
				],
				"comments": ""
			},
			"Pacific/Fakaofo": {
				"name": "Pacific/Fakaofo",
				"lat": -8.6333,
				"long": -170.7667,
				"countries": [
					"TK"
				],
				"comments": ""
			},
			"Asia/Dili": {
				"name": "Asia/Dili",
				"lat": -7.45,
				"long": 125.5833,
				"countries": [
					"TL"
				],
				"comments": ""
			},
			"Asia/Ashgabat": {
				"name": "Asia/Ashgabat",
				"lat": 37.95,
				"long": 58.3833,
				"countries": [
					"TM"
				],
				"comments": ""
			},
			"Africa/Tunis": {
				"name": "Africa/Tunis",
				"lat": 36.8,
				"long": 10.1833,
				"countries": [
					"TN"
				],
				"comments": ""
			},
			"Pacific/Tongatapu": {
				"name": "Pacific/Tongatapu",
				"lat": -20.8333,
				"long": -174.8333,
				"countries": [
					"TO"
				],
				"comments": ""
			},
			"Europe/Istanbul": {
				"name": "Europe/Istanbul",
				"lat": 41.0167,
				"long": 28.9667,
				"countries": [
					"TR"
				],
				"comments": ""
			},
			"America/Port_of_Spain": {
				"name": "America/Port_of_Spain",
				"lat": 10.65,
				"long": -60.4833,
				"countries": [
					"TT",
					"AG",
					"AI",
					"BL",
					"DM",
					"GD",
					"GP",
					"KN",
					"LC",
					"MF",
					"MS",
					"VC",
					"VG",
					"VI"
				],
				"comments": ""
			},
			"Pacific/Funafuti": {
				"name": "Pacific/Funafuti",
				"lat": -7.4833,
				"long": 179.2167,
				"countries": [
					"TV"
				],
				"comments": ""
			},
			"Asia/Taipei": {
				"name": "Asia/Taipei",
				"lat": 25.05,
				"long": 121.5,
				"countries": [
					"TW"
				],
				"comments": ""
			},
			"Europe/Kiev": {
				"name": "Europe/Kiev",
				"lat": 50.4333,
				"long": 30.5167,
				"countries": [
					"UA"
				],
				"comments": "Ukraine (most areas)"
			},
			"Europe/Uzhgorod": {
				"name": "Europe/Uzhgorod",
				"lat": 48.6167,
				"long": 22.3,
				"countries": [
					"UA"
				],
				"comments": "Ruthenia"
			},
			"Europe/Zaporozhye": {
				"name": "Europe/Zaporozhye",
				"lat": 47.8333,
				"long": 35.1667,
				"countries": [
					"UA"
				],
				"comments": "Zaporozh'ye/Zaporizhia; Lugansk/Luhansk (east)"
			},
			"Pacific/Wake": {
				"name": "Pacific/Wake",
				"lat": 19.2833,
				"long": 166.6167,
				"countries": [
					"UM"
				],
				"comments": "Wake Island"
			},
			"America/New_York": {
				"name": "America/New_York",
				"lat": 40.7142,
				"long": -73.9936,
				"countries": [
					"US"
				],
				"comments": "Eastern (most areas)"
			},
			"America/Detroit": {
				"name": "America/Detroit",
				"lat": 42.3314,
				"long": -82.9542,
				"countries": [
					"US"
				],
				"comments": "Eastern - MI (most areas)"
			},
			"America/Kentucky/Louisville": {
				"name": "America/Kentucky/Louisville",
				"lat": 38.2542,
				"long": -84.2406,
				"countries": [
					"US"
				],
				"comments": "Eastern - KY (Louisville area)"
			},
			"America/Kentucky/Monticello": {
				"name": "America/Kentucky/Monticello",
				"lat": 36.8297,
				"long": -83.1508,
				"countries": [
					"US"
				],
				"comments": "Eastern - KY (Wayne)"
			},
			"America/Indiana/Indianapolis": {
				"name": "America/Indiana/Indianapolis",
				"lat": 39.7683,
				"long": -85.8419,
				"countries": [
					"US"
				],
				"comments": "Eastern - IN (most areas)"
			},
			"America/Indiana/Vincennes": {
				"name": "America/Indiana/Vincennes",
				"lat": 38.6772,
				"long": -86.4714,
				"countries": [
					"US"
				],
				"comments": "Eastern - IN (Da, Du, K, Mn)"
			},
			"America/Indiana/Winamac": {
				"name": "America/Indiana/Winamac",
				"lat": 41.0514,
				"long": -85.3969,
				"countries": [
					"US"
				],
				"comments": "Eastern - IN (Pulaski)"
			},
			"America/Indiana/Marengo": {
				"name": "America/Indiana/Marengo",
				"lat": 38.3756,
				"long": -85.6553,
				"countries": [
					"US"
				],
				"comments": "Eastern - IN (Crawford)"
			},
			"America/Indiana/Petersburg": {
				"name": "America/Indiana/Petersburg",
				"lat": 38.4919,
				"long": -86.7214,
				"countries": [
					"US"
				],
				"comments": "Eastern - IN (Pike)"
			},
			"America/Indiana/Vevay": {
				"name": "America/Indiana/Vevay",
				"lat": 38.7478,
				"long": -84.9328,
				"countries": [
					"US"
				],
				"comments": "Eastern - IN (Switzerland)"
			},
			"America/Chicago": {
				"name": "America/Chicago",
				"lat": 41.85,
				"long": -86.35,
				"countries": [
					"US"
				],
				"comments": "Central (most areas)"
			},
			"America/Indiana/Tell_City": {
				"name": "America/Indiana/Tell_City",
				"lat": 37.9531,
				"long": -85.2386,
				"countries": [
					"US"
				],
				"comments": "Central - IN (Perry)"
			},
			"America/Indiana/Knox": {
				"name": "America/Indiana/Knox",
				"lat": 41.2958,
				"long": -85.375,
				"countries": [
					"US"
				],
				"comments": "Central - IN (Starke)"
			},
			"America/Menominee": {
				"name": "America/Menominee",
				"lat": 45.1078,
				"long": -86.3858,
				"countries": [
					"US"
				],
				"comments": "Central - MI (Wisconsin border)"
			},
			"America/North_Dakota/Center": {
				"name": "America/North_Dakota/Center",
				"lat": 47.1164,
				"long": -100.7008,
				"countries": [
					"US"
				],
				"comments": "Central - ND (Oliver)"
			},
			"America/North_Dakota/New_Salem": {
				"name": "America/North_Dakota/New_Salem",
				"lat": 46.845,
				"long": -100.5892,
				"countries": [
					"US"
				],
				"comments": "Central - ND (Morton rural)"
			},
			"America/North_Dakota/Beulah": {
				"name": "America/North_Dakota/Beulah",
				"lat": 47.2642,
				"long": -100.2222,
				"countries": [
					"US"
				],
				"comments": "Central - ND (Mercer)"
			},
			"America/Denver": {
				"name": "America/Denver",
				"lat": 39.7392,
				"long": -103.0158,
				"countries": [
					"US"
				],
				"comments": "Mountain (most areas)"
			},
			"America/Boise": {
				"name": "America/Boise",
				"lat": 43.6136,
				"long": -115.7975,
				"countries": [
					"US"
				],
				"comments": "Mountain - ID (south); OR (east)"
			},
			"America/Phoenix": {
				"name": "America/Phoenix",
				"lat": 33.4483,
				"long": -111.9267,
				"countries": [
					"US"
				],
				"comments": "MST - Arizona (except Navajo)"
			},
			"America/Los_Angeles": {
				"name": "America/Los_Angeles",
				"lat": 34.0522,
				"long": -117.7572,
				"countries": [
					"US"
				],
				"comments": "Pacific"
			},
			"America/Anchorage": {
				"name": "America/Anchorage",
				"lat": 61.2181,
				"long": -148.0997,
				"countries": [
					"US"
				],
				"comments": "Alaska (most areas)"
			},
			"America/Juneau": {
				"name": "America/Juneau",
				"lat": 58.3019,
				"long": -133.5803,
				"countries": [
					"US"
				],
				"comments": "Alaska - Juneau area"
			},
			"America/Sitka": {
				"name": "America/Sitka",
				"lat": 57.1764,
				"long": -134.6981,
				"countries": [
					"US"
				],
				"comments": "Alaska - Sitka area"
			},
			"America/Metlakatla": {
				"name": "America/Metlakatla",
				"lat": 55.1269,
				"long": -130.4236,
				"countries": [
					"US"
				],
				"comments": "Alaska - Annette Island"
			},
			"America/Yakutat": {
				"name": "America/Yakutat",
				"lat": 59.5469,
				"long": -138.2728,
				"countries": [
					"US"
				],
				"comments": "Alaska - Yakutat"
			},
			"America/Nome": {
				"name": "America/Nome",
				"lat": 64.5011,
				"long": -164.5936,
				"countries": [
					"US"
				],
				"comments": "Alaska (west)"
			},
			"America/Adak": {
				"name": "America/Adak",
				"lat": 51.88,
				"long": -175.3419,
				"countries": [
					"US"
				],
				"comments": "Aleutian Islands"
			},
			"Pacific/Honolulu": {
				"name": "Pacific/Honolulu",
				"lat": 21.3069,
				"long": -156.1417,
				"countries": [
					"US",
					"UM"
				],
				"comments": "Hawaii"
			},
			"America/Montevideo": {
				"name": "America/Montevideo",
				"lat": -33.1167,
				"long": -55.8167,
				"countries": [
					"UY"
				],
				"comments": ""
			},
			"Asia/Samarkand": {
				"name": "Asia/Samarkand",
				"lat": 39.6667,
				"long": 66.8,
				"countries": [
					"UZ"
				],
				"comments": "Uzbekistan (west)"
			},
			"Asia/Tashkent": {
				"name": "Asia/Tashkent",
				"lat": 41.3333,
				"long": 69.3,
				"countries": [
					"UZ"
				],
				"comments": "Uzbekistan (east)"
			},
			"America/Caracas": {
				"name": "America/Caracas",
				"lat": 10.5,
				"long": -65.0667,
				"countries": [
					"VE"
				],
				"comments": ""
			},
			"Asia/Ho_Chi_Minh": {
				"name": "Asia/Ho_Chi_Minh",
				"lat": 10.75,
				"long": 106.6667,
				"countries": [
					"VN"
				],
				"comments": "Vietnam (south)"
			},
			"Pacific/Efate": {
				"name": "Pacific/Efate",
				"lat": -16.3333,
				"long": 168.4167,
				"countries": [
					"VU"
				],
				"comments": ""
			},
			"Pacific/Wallis": {
				"name": "Pacific/Wallis",
				"lat": -12.7,
				"long": -175.8333,
				"countries": [
					"WF"
				],
				"comments": ""
			},
			"Pacific/Apia": {
				"name": "Pacific/Apia",
				"lat": -12.1667,
				"long": -170.2667,
				"countries": [
					"WS"
				],
				"comments": ""
			},
			"Africa/Johannesburg": {
				"name": "Africa/Johannesburg",
				"lat": -25.75,
				"long": 28,
				"countries": [
					"ZA",
					"LS",
					"SZ"
				],
				"comments": ""
			}
		}
	};

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbMap = angular.module('app.lbMap', []);
	
	lbMap.controller('lbMapController', __webpack_require__(315));
	lbMap.directive('lbMap', __webpack_require__(316));
	lbMap.service('lbMicrosoftMapsScriptService', __webpack_require__(320));
	
	exports['default'] = lbMap;
	module.exports = exports['default'];

/***/ },
/* 315 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope', 'lbMicrosoftMapsScriptService'];
	var lbMapController = function lbMapController($scope, lbMicrosoftMapsScriptService) {
	
	  var vm = this;
	
	  vm.lbMicrosoftMapsScriptService = lbMicrosoftMapsScriptService;
	  vm.map = null;
	  vm.mapId = 'map' + $scope.$id;
	  vm.showPushpin = showPushpin;
	  vm.showPushPinCluster = showPushPinCluster;
	
	  if (vm.gridSize == undefined) {
	    vm.gridSize = 30;
	  }
	
	  vm.lbMicrosoftMapsScriptService.load().then(function () {
	    var navigationBarMode = Microsoft.Maps.NavigationBarMode;
	
	    vm.map = new Microsoft.Maps.Map(document.getElementById(vm.mapId), {
	      credentials: 'AqkExqjquai0sfSevSrsEaOMOzaNLUqDL4xFwXBnjbRJYaLxM_gh2TlGV42cXl1R',
	      navigationBarMode: navigationBarMode.compact,
	      center: new Microsoft.Maps.Location(vm.mapCenter.latitude, vm.mapCenter.longitude),
	      zoom: vm.zoomLevel
	    });
	
	    if (vm.locations.length > 1) {
	      vm.showPushPinCluster(vm.locations);
	    } else {
	      vm.showPushpin(vm.locations[0]);
	    }
	  });
	
	  function createInfoBox(location, options) {
	    return new Microsoft.Maps.Infobox(getLocation(location), options);
	  }
	
	  function updateInfoBox(infoBox, item) {
	    infoBox.setHtmlContent('\n      <div id="infoboxText" style="background-color:White; border-style:solid;\n          border-width:medium; border-color:DarkOrange; min-height:100px; width: 240px; z-index: 1000000000000000000; ">\n        <b id="infoboxTitle" style="position: absolute; top: 10px; left: 10px; width: 220px; ">' + item.HotelName + '</b>\n        <a id="infoboxDescription" style="position: absolute; top: 30px; left: 10px; width: 220px; ">Description</a>\n      </div>\n    ');
	  }
	
	  function createPushpin(location, options) {
	    return new Microsoft.Maps.Pushpin(location, options);
	  }
	
	  function getLowercaseLocation(item) {
	    return { latitude: item.Latitude, longitude: item.Longitude };
	  }
	
	  function showPushpin(location) {
	    vm.map.entities.push(createPushpin(getLowercaseLocation(location), {}));
	  }
	
	  function getLocation(options) {
	    return new Microsoft.Maps.Location(options.latitude, options.longitude);
	  }
	
	  //
	  //function pushpinOver(event) {
	  //  showInfoBox(event.target.data);
	  //}
	
	  function hideInfoBox(infoBox) {
	    infoBox.setOptions({
	      visible: false
	    });
	  }
	
	  function pushpinOut(infoBox) {
	    vm.infoboxTimeout = setTimeout(function () {
	      hideInfoBox(infoBox);
	    }, 150);
	  }
	
	  function infoboxOver() {
	    clearTimeout(vm.infoboxTimeout);
	  }
	
	  function infoboxOut(infoBox) {
	    vm.infoboxTimeout = setTimeout(function () {
	      hideInfoBox(infoBox);
	    }, 150);
	  }
	
	  function showPushPinCluster(locations) {
	
	    var infoBox = createInfoBox(vm.mapCenter, { title: 'hi', showCloseButton: false });
	    console.log('lbMapController.js line:99, infoBox:', infoBox);
	
	    infoBox.setMap(vm.map);
	
	    var pushpins = locations.map(function (item) {
	      var pinLocation = getLocation(getLowercaseLocation(item));
	      var pin = createPushpin(pinLocation, {});
	
	      Microsoft.Maps.Events.addHandler(pin, 'mouseover', function () {
	
	        infoBox.setLocation(pinLocation);
	        infoBox.setOptions({ visible: true });
	        updateInfoBox(infoBox, item);
	      });
	
	      Microsoft.Maps.Events.addHandler(pin, 'mouseout', pushpinOut(infoBox));
	
	      return pin;
	    });
	
	    Microsoft.Maps.loadModule('Microsoft.Maps.Clustering', function () {
	      var clusterLayer = new Microsoft.Maps.ClusterLayer(pushpins, { gridSize: vm.gridsize });
	      vm.map.layers.insert(clusterLayer);
	    });
	  }
	};
	
	lbMapController.$inject = $inject;
	
	exports['default'] = lbMapController;
	module.exports = exports['default'];

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(317);
	
	var $inject = [];
	
	var lbMap = function lbMap() {
	  return {
	    controller: 'lbMapController',
	    controllerAs: 'vm',
	    bindToController: true,
	    template: __webpack_require__(319),
	    scope: {
	      locations: '=',
	      mapCenter: '=',
	      zoomLevel: '=',
	      gridSize: '='
	    }
	  };
	};
	
	lbMap.$inject = $inject;
	
	exports['default'] = lbMap;
	module.exports = exports['default'];

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(318);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbMap.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbMap.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".map{height:30rem;width:80rem;background:#ccc}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbMap/src/components/lbMap/lbMap.scss"],"names":[],"mappings":"AAAA,KACI,aACA,YACA,eAAgB,CACnB","file":"lbMap.scss","sourcesContent":[".map {\r\n    height: 30rem;\r\n    width: 80rem;\r\n    background: #ccc;\r\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 319 */
/***/ function(module, exports) {

	var v1="<div class=\"map\" ng-attr-id=\"{{vm.mapId}}\"></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbMapTemplate.html", v1)}]);
	module.exports=v1;

/***/ },
/* 320 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $inject = ['$q'];
	
	var lbMicrosoftMapsScriptService = function lbMicrosoftMapsScriptService($q) {
	  var service = {};
	
	  service.loaded = false;
	  service.loading = false;
	  service.promiseArray = [];
	
	  service.load = function load() {
	    var deferred = $q.defer();
	
	    if (!service.loaded && !service.loading) {
	      service.loading = true;
	      buildScript(function () {
	        deferred.resolve();
	        service.loaded = true;
	        service.loading = false;
	        service.promiseArray.forEach(function (func) {
	          func();
	        });
	      });
	    } else if (!service.loaded && service.loading) {
	      service.promiseArray.push(deferred.resolve);
	    } else if (service.loaded && !service.loading) {
	      deferred.resolve();
	    }
	
	    return deferred.promise;
	  };
	  return service;
	};
	
	function buildScript(callBack) {
	  var tag = document.createElement("script");
	  tag.src = "https://www.bing.com/api/maps/mapcontrol?callback=loadMapScenario";
	  document.getElementsByTagName("head")[0].appendChild(tag);
	
	  window.loadMapScenario = callBack;
	}
	
	lbMicrosoftMapsScriptService.$inject = $inject;
	
	exports["default"] = lbMicrosoftMapsScriptService;
	module.exports = exports["default"];

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	__webpack_require__(322);
	
	var lbaSubNav = angular.module('app.lbaSubNav', []);
	
	lbaSubNav.component('lbaSubNav', {
	    bindings: {},
	    controllerAs: 'vm',
	    controller: ['$location', 'subNavService', 'formValidationService', '$rootScope', 'dataService', controller],
	    template: __webpack_require__(324)
	});
	
	function controller($location, subNavService, formValidationService, $rootScope, dataService) {
	    var vm = this;
	    vm.subNav = subNavService;
	    $rootScope.navObj;
	    vm.showTab = showTab;
	
	    function showTab(link) {
	        // JLF: LOBT-773: we must reset the grid cache with every fresh page being shown
	        dataService.backGridFilter = null;
	        dataService.backGridPage = null;
	        dataService.backViewGridFilter = null;
	        dataService.backViewGridPage = null;
	
	        $location.path(link);
	    }
	}
	
	exports['default'] = lbaSubNav;
	module.exports = exports['default'];

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(323);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaSubNav.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaSubNav.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"lbaSubNav.scss","sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 324 */
/***/ function(module, exports) {

	var v1="<ul class=\"nav nav-pills nav-stacked lbaSubNav\"> <li ng-repeat=\"item in vm.subNav.navObj track by $index\" ng-class=\"{active: item.active }\"> <a href=\"\" ng-click=\"vm.showTab(item.link)\">{{ item.name }}</a> </li> </ul>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaSubNav.html", v1)}]);
	module.exports=v1;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaLatLongMapSearch = angular.module('app.lbaLatLongMapSearch', []);
	
	lbaLatLongMapSearch.controller('lbaLatLongMapSearchCtrl', __webpack_require__(326));
	lbaLatLongMapSearch.directive('lbaLatLongMapSearch', __webpack_require__(327));
	
	exports['default'] = lbaLatLongMapSearch;
	module.exports = exports['default'];

/***/ },
/* 326 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$rootScope', '$timeout', '$scope', '$routeParams', '$http', 'dataService', 'settingsService', 'lbaLeafletMapService'];
	
	var lbaLatLongMapSearch = function lbaLatLongMapSearch($rootScope, $timeout, $scope, $routeParams, $http, dataService, settingsService, lbaLeafletMapService) {
	  var vm = this;
	
	  var latDataLookUp = dataService.spiltDataAt(vm.settings.latField, $routeParams);
	  var longDataLookUp = dataService.spiltDataAt(vm.settings.longField, $routeParams);
	  var radiusDataLookUp = dataService.spiltDataAt(vm.settings.radiusField, $routeParams);
	  var isImperialSystemDataLookUp = dataService.spiltDataAt(vm.settings.IsImperialSystemField, $routeParams);
	
	  vm.searchForAddress = searchForAddress;
	  vm.viewLatLongOnMap = viewLatLongOnMap;
	  vm.setLatLong = setLatLong;
	  vm.mapLocations = [];
	  vm.addressLookUp = '';
	  vm.showMap = false;
	
	  $timeout(viewLatLongOnMap, 1000);
	
	  function getLat() {
	    return _.get(dataService.data.activeItem, latDataLookUp);
	  }
	
	  function getLong() {
	    return _.get(dataService.data.activeItem, longDataLookUp);
	  }
	
	  function getRadius() {
	    return _.get(dataService.data.activeItem, radiusDataLookUp);
	  }
	
	  function getIsImperialSystem() {
	    return _.get(dataService.data.activeItem, isImperialSystemDataLookUp);
	  }
	
	  function viewLatLongOnMap() {
	    vm.showMap = true;
	
	    var long = getLong();
	    var lat = getLat();
	
	    if (long === null || lat === null || long === undefined || lat === undefined) {
	      return;
	    }
	
	    vm.markerOverride = true;
	
	    var radius = getRadius() || 1;
	    if (radius) {
	      vm.radius = {
	        radius: getIsImperialSystem() ? radius * 1609.344 : radius * 1000,
	        lat: lat,
	        long: long,
	        text: 'Latitude: ' + lat + ', Longitude: ' + long
	      };
	    }
	
	    refresh();
	  }
	
	  function searchForAddress(address) {
	    if (!address) {
	      return;
	    }
	    vm.radius = null;
	    vm.markerOverride = { text: address, ctaText: 'Set as Lat/Long' };
	    lbaLeafletMapService.getPosByAddress(address).then(function (data) {
	      var resources = data.resourceSets[0].resources;
	      if (resources.length > 0) {
	        vm.mapLocations = [{
	          Longitude: resources[0].geocodePoints[0].coordinates[1],
	          Latitude: resources[0].geocodePoints[0].coordinates[0]
	        }];
	
	        refresh();
	      }
	    });
	  }
	
	  function setLatLong() {
	    _.set(dataService.data.activeItem, latDataLookUp, vm.mapLocations[0].Latitude);
	    _.set(dataService.data.activeItem, longDataLookUp, vm.mapLocations[0].Longitude);
	    $rootScope.$broadcast(vm.settings.latField, { refreshData: true });
	    $rootScope.$broadcast(vm.settings.longField, { refreshData: true });
	    vm.mapLocations = [];
	    viewLatLongOnMap();
	  }
	
	  function refresh() {
	    $timeout(function () {
	      $rootScope.$emit('leaflet.refresh', vm.refreshMap);
	    });
	  }
	};
	
	lbaLatLongMapSearch.$inject = $inject;
	
	exports['default'] = lbaLatLongMapSearch;
	module.exports = exports['default'];

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	var lbaLatLongMapSearch = function lbaLatLongMapSearch() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaLatLongMapSearchCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(328)
	  };
	};
	
	lbaLatLongMapSearch.$inject = $inject;
	
	exports['default'] = lbaLatLongMapSearch;
	module.exports = exports['default'];

/***/ },
/* 328 */
/***/ function(module, exports) {

	var v1="<div class=\"well center-block\"> <form class=\"form-inline\"> <div class=\"form-group\"> <label for=\"{{ vm.settings.dataAt }}\">{{ vm.settings.displayName }}: </label> <input ng-model=\"vm.addressLookUp\" class=\"form-control\"> </div> <button ng-click=\"vm.searchForAddress(vm.addressLookUp)\" class=\"btn btn-info\"> <i class=\"fa fa-search\"></i>&nbsp; Search </button>\n<button ng-click=\"vm.viewLatLongOnMap()\" class=\"btn btn-info\" style=\"float: right\"> <i class=\"fa fa-refresh\"></i>&nbsp; Refresh map </button> </form> <br/> <lba-leaflet-map locations=\"vm.mapLocations\" marker-click=\"vm.setLatLong\" grid-size=\"80\" marker-override=\"vm.markerOverride\" includes-radius=\"vm.radius\"> </lba-leaflet-map> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaLatLongMapSearch.html", v1)}]);
	module.exports=v1;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaLatLngMap = angular.module('app.lbaLatLngMap', []);
	
	lbaLatLngMap.controller('lbaLatLngMapCtrl', __webpack_require__(330));
	lbaLatLngMap.directive('lbaLatLngMap', __webpack_require__(332));
	
	exports['default'] = lbaLatLngMap;
	module.exports = exports['default'];

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['dataService', '$routeParams', '$scope', '$timeout', '$location'];
	var bingAPIKey = 'AqkExqjquai0sfSevSrsEaOMOzaNLUqDL4xFwXBnjbRJYaLxM_gh2TlGV42cXl1R';
	__webpack_require__(278);
	
	var lbaLeafletMapCtrl = function lbaLeafletMapCtrl(dataService, $routeParams, $scope, $timeout, $location) {
	  var vm = this;
	  var dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
	  vm.data = _.get(dataService.data.activeItem, dataLookUp);
	  vm.toggleLabels = toggleLabels;
	  vm.circles = [];
	  vm.popups = [];
	  vm.markers = [];
	  var defaultIcon = L.icon({
	    iconUrl: __webpack_require__(331),
	    iconSize: [20, 20],
	    iconAnchor: [10, 5]
	  });
	
	  var mapInitialised = false;
	  vm.mapId = 'map' + $scope.$id;
	  vm.map = null;
	
	  function init() {
	    var mapPos = [0, 0];
	    var zoomLevel = vm.zoomLevel || 1;
	
	    if (vm.mapCenter) {
	      mapPos = [vm.mapCenter.latitude, vm.mapCenter.longitude];
	    }
	
	    vm.map = L.map(vm.mapId).setView(mapPos, zoomLevel);
	
	    _.forEach(vm.data, function (data, index) {
	      if (data.Longitude !== null && data.Latitude !== null) {
	        addRadius(data, index);
	      }
	    });
	    var group = new L.featureGroup(vm.circles);
	    if (Object.keys(group.getBounds()).length > 0) {
	      vm.map.fitBounds(group.getBounds());
	    }
	
	    L.tileLayer.bing({
	      bingMapsKey: bingAPIKey,
	      imagerySet: 'Road'
	    }).addTo(vm.map);
	
	    vm.map.attributionControl.options.prefix = '';
	    mapInitialised = true;
	  }
	
	  function addRadius(data, index) {
	    var lat = data.Latitude;
	    var lng = data.Longitude;
	    var radius = data.Radius;
	
	    if (radius === null) {
	      radius = 5;
	    }
	    var pos = [lat, lng];
	    vm.circles.push(L.circle(pos, { radius: radius * 1000, lat: lat, long: lng }).addTo(vm.map));
	    addPopup(data, index);
	  }
	
	  function addPopup(data, index) {
	    var lat = data.Latitude;
	    var lng = data.Longitude;
	    var pos = [lat, lng];
	    vm.popups.push(L.popup({ closeOnClick: false }).setLatLng(pos).setContent('<a href="' + $location.absUrl() + '/policies/' + index + '">' + data.PolicyName + ' ' + (data.LocationCode ? '- ' + data.LocationCode : '') + '</a>').addTo(vm.map));
	  }
	
	  function addPin(data, index) {
	    var lat = data.Latitude;
	    var lng = data.Longitude;
	    var pos = [lat, lng];
	    vm.markers.push(L.marker(pos, { icon: defaultIcon }).addTo(vm.map));
	  }
	
	  function toggleLabels() {
	    if (vm.popups.length > 0) {
	      vm.popups.forEach(function (popup) {
	        vm.map.closePopup(popup);
	      });
	      vm.popups = [];
	      _.forEach(vm.data, function (data, index) {
	        if (data.Longitude !== null && data.Latitude !== null) {
	          addPin(data, index);
	        }
	      });
	    } else {
	      vm.markers.forEach(function (marker) {
	        marker.remove();
	      });
	      vm.markers = [];
	      _.forEach(vm.data, function (data, index) {
	        if (data.Longitude !== null && data.Latitude !== null) {
	          addPopup(data, index);
	        }
	      });
	    }
	  }
	
	  $timeout(init);
	};
	
	lbaLeafletMapCtrl.$inject = $inject;
	
	exports['default'] = lbaLeafletMapCtrl;
	module.exports = exports['default'];

/***/ },
/* 331 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAUpJREFUeNq0VcFtwzAMlP3rI4BHSDaoN6gncLJBMkHaV59Jnn3Z3iAb1JnA2cDZIB7BQB99tsf2GBCCA8hATOBASKLOR4qSIzdgX+9Pc7gt8AI8e8sX4AxUs4/vzt8bDZDt4XYuzA4g3Q8SgiiBazxFouZE77iWD8RkIO5lEN8h06AUvgZ6ouZc5n2kIcc/IVNUsiM3JAi6wrf8mKDlXMKYoyH9K1PEA7haZcBrQB3fSGgzWwhhQQKnyoDPwENZsRQNx6WkvFR1qI+0Q+HCreAeredSFP5oC/AAWjfOUora2UMR65juWEu41/mEDzFLOGeBx1rHvTdClZujwBcrP4SM9znX8SRtU9k24EuyCSDbMNa2WRVTcmmuUMH2Wd1Jv+NazVi9JaVwxaYHtTnXTKFHwIJ9lhEp5zTNtbmyh0mer+ke2Ef9An4FGABwCYp2L/mX0gAAAABJRU5ErkJggg=="

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(333);
	
	var $inject = [];
	
	var lbaLatLngMap = function lbaLatLngMap() {
	  return {
	    restrict: 'A',
	    controller: 'lbaLatLngMapCtrl',
	    controllerAs: 'vm',
	    bindToController: true,
	    template: __webpack_require__(335),
	    scope: {
	      settings: '='
	    }
	  };
	};
	
	lbaLatLngMap.$inject = $inject;
	
	exports['default'] = lbaLatLngMap;
	module.exports = exports['default'];

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(334);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaLatLngMap.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaLatLngMap.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".lbaLatLngMap_map{width:100%;height:45rem}.lbaLatLng_toggle{position:relative;top:-40px;left:10px;z-index:999}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaLatLngMap/src/components/lbaLatLngMap/lbaLatLngMap.scss"],"names":[],"mappings":"AAAA,kBACE,WACA,YAAa,CACd,kBAGC,kBACA,UACA,UACA,WAAY,CACb","file":"lbaLatLngMap.scss","sourcesContent":[".lbaLatLngMap_map {\r\n  width: 100%;\r\n  height: 45rem;\r\n}\r\n\r\n.lbaLatLng_toggle {\r\n  position: relative;\r\n  top: -40px;\r\n  left: 10px;\r\n  z-index: 999;\r\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 335 */
/***/ function(module, exports) {

	var v1="<div class=\"lbaLatLngMap\"> <label>{{ vm.settings.displayName }}</label> <div class=\"lbaLatLngMap_map\" ng-attr-id=\"{{vm.mapId}}\"></div> <div><button class=\"btn btn-default lbaLatLng_toggle\" ng-click=\"vm.toggleLabels()\">Toggle labels/pins</button></div> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/LbaLatLngMap.html", v1)}]);
	module.exports=v1;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaViewGrid = angular.module('app.lbaViewGrid', ['ngTasty']);
	
	lbaViewGrid.controller('lbaViewGridCtrl', __webpack_require__(337));
	lbaViewGrid.directive('lbaViewGrid', __webpack_require__(338));
	
	exports['default'] = lbaViewGrid;
	module.exports = exports['default'];

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	// This is the code responsible for filling the grid with data.
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _configConstants = __webpack_require__(147);
	
	var _configConstants2 = _interopRequireDefault(_configConstants);
	
	var $inject = ['$routeParams', 'dataService', 'dataSourceService'];
	
	var lbaViewGridCtrl = function lbaViewGridCtrl($routeParams, dataService, dataSourceService) {
	  var vm = this;
	  vm.dataService = dataService;
	  vm.ready = false;
	  vm.canAdd = false;
	  vm.filters = '';
	  vm.blurLog = blurLog;
	  vm.getLogs = getLogs;
	  vm.selectItem = selectItem;
	  vm.getObjectPropertyValue = getObjectPropertyValue;
	  vm.clearFilter = clearFilter;
	  var page = 1;
	
	  if (dataService.backViewGridFilter != null && dataService.backViewGridFilter[vm.settings.displayName]) {
	    vm.filters = dataService.backViewGridFilter[vm.settings.displayName];
	  }
	
	  if (dataService.backViewGridPage != null && dataService.backViewGridPage[vm.settings.displayName]) {
	    page = dataService.backViewGridPage[vm.settings.displayName];
	  }
	
	  // go to the Lightning Config Api to get the data
	  if (vm.settings.endpoint) {
	    dataSourceService.dataSource = _configConstants2['default'].DATA_SOURCES.ODATA;
	    dataService.data.activeItem = undefined;
	    getLogs();
	  } else {
	    var dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
	    var rowData = prepData(_.get(dataService.data.activeItem, dataLookUp));
	    populateGrid(rowData);
	  }
	
	  function blurLog() {
	    dataService.data.activeItem = null;
	  }
	
	  function getLogs() {
	    vm.ready = false;
	    var ODataArgs = vm.settings.ODataArgs || '';
	    dataService.get(vm.settings.endpoint + ODataArgs).then(function (data) {
	      vm.dataService.data.logs = data;
	      populateGrid(data);
	    });
	  }
	
	  function populateGrid(rowData) {
	    vm.resource = {
	      header: vm.settings.gridCols,
	      rows: rowData,
	      pagination: {
	        page: page
	      }
	    };
	
	    vm.ready = true;
	  }
	
	  function selectItem(logMessage) {
	    dataService.data.activeItem = logMessage;
	  }
	
	  function prepData(data) {
	    if (data) {
	      return data.map(function (item) {
	        return item;
	      });
	    }
	  }
	
	  function getObjectPropertyValue(obj, path) {
	    var defaultValue = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    return _.get(obj, path, defaultValue);
	  }
	
	  function clearFilter() {
	    vm.filters = '';
	  }
	};
	
	lbaViewGridCtrl.$inject = $inject;
	
	exports['default'] = lbaViewGridCtrl;
	module.exports = exports['default'];

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(339);
	
	var $inject = [];
	
	var lbaViewGrid = function lbaViewGrid() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '='
	    },
	    bindToController: true,
	    controller: 'lbaViewGridCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(341)
	  };
	};
	
	lbaViewGrid.$inject = $inject;
	
	exports['default'] = lbaViewGrid;
	module.exports = exports['default'];

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(340);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaViewGrid.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaViewGrid.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".lbaGrid{background:#fff;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);padding:2rem;margin:.75rem 0 1.5rem}.lbaGrid_tools{margin-bottom:2rem}.lbaGrid_filter{width:300px;float:left}.lbaGrid_name{margin:0;vertical-align:middle}.lbaGrid_add,.lbaGrid_back{float:right}.lbaGrid_table{border:1px solid #e1e1e1;table-layout:fixed}.lbaGrid_tr{cursor:pointer}.lbaGridDetails{position:relative}.lbaGridDetails_tools{position:absolute;top:0;right:0}.lbaGrid_pagination{text-align:right}.lbaGrid_pagination .pagination{margin:0}.btn_copyMode{border-color:#9ab845}.btn_copyMode,.btn_copyMode:focus,.btn_copyMode:hover{color:#fff;background:#9ab845}.copyMode:hover,.copyMode:hover td{background:#9ab845!important}.copyMode:hover td{color:#fff}.lbaGrid_noRecords{position:relative;background:#f5f5f5;display:block;padding:1rem}.hideOverflow{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.lbaViewGrid__row--selected td{background-color:#d3d3d3!important}.lbaViewGrid__clearIcon{position:absolute;cursor:pointer;top:10px;margin-left:-30px;z-index:9999}.lbaViewGrid__clearIcon:hover{color:#7eb6e2}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaViewGrid/src/components/lbaViewGrid/lbaViewGrid.scss","/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaViewGrid/src/globalStyles/_variables.scss"],"names":[],"mappings":"AAEA,SACI,gBACA,sBACA,kBACA,4CACA,aACA,sBAA0B,CAC7B,eAGG,kBAAmB,CACtB,gBAGG,YACA,UAAW,CACd,cAGG,SACA,qBAAsB,CACzB,AAIA,2BAGG,WAAY,CACf,eAGG,yBACA,kBAAmB,CACtB,YAGG,cAAe,CAClB,gBAGG,iBAAkB,CACrB,sBAGG,kBACA,MACA,OAAQ,CACX,oBAGG,gBAAiB,CACpB,gCAGG,QAAS,CACZ,cAGG,oBACA,CAFJ,sDAEI,WACA,kBC/DgB,CDoEf,AAGL,mCACI,4BAAkC,CAKjC,AANL,mBAIQ,UACA,CACH,mBAID,kBACA,mBACA,cACA,YAAa,CAChB,cAGG,uBACA,mBACA,eAAgB,CACnB,+BAGG,kCAAsC,CACzC,wBAGG,kBACA,eACA,SACA,kBACA,YAAa,CAChB,8BAGG,aAAc,CACjB","file":"lbaViewGrid.scss","sourcesContent":["@import \"../../globalStyles/variables\";\r\n\r\n.lbaGrid {\r\n    background: #fff;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\r\n    padding: 2rem;\r\n    margin: 0.75rem 0 1.5rem 0;\r\n}\r\n\r\n.lbaGrid_tools {\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n.lbaGrid_filter {\r\n    width: 300px;\r\n    float: left;\r\n}\r\n\r\n.lbaGrid_name {\r\n    margin: 0;\r\n    vertical-align: middle;\r\n}\r\n\r\n.lbaGrid_add {\r\n    float: right;\r\n}\r\n\r\n.lbaGrid_back {\r\n    float: right;\r\n}\r\n\r\n.lbaGrid_table {\r\n    border: 1px solid #e1e1e1;\r\n    table-layout: fixed;\r\n}\r\n\r\n.lbaGrid_tr {\r\n    cursor: pointer;\r\n}\r\n\r\n.lbaGridDetails {\r\n    position: relative;\r\n}\r\n\r\n.lbaGridDetails_tools {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n}\r\n\r\n.lbaGrid_pagination {\r\n    text-align: right;\r\n}\r\n\r\n.lbaGrid_pagination .pagination {\r\n    margin: 0;\r\n}\r\n\r\n.btn_copyMode {\r\n    border-color: $brandGreen;\r\n    color: #fff;\r\n    background: $brandGreen;\r\n\r\n    &:hover, &:focus {\r\n        color: #fff;\r\n        background: $brandGreen;\r\n    }\r\n}\r\n\r\n.copyMode:hover {\r\n    background: $brandGreen !important;\r\n\r\n    td {\r\n        color: #fff;\r\n        background: $brandGreen !important;\r\n    }\r\n}\r\n\r\n.lbaGrid_noRecords {\r\n    position: relative;\r\n    background: #f5f5f5;\r\n    display: block;\r\n    padding: 1rem;\r\n}\r\n\r\n.hideOverflow {\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n}\r\n\r\n.lbaViewGrid__row--selected td {\r\n    background-color: lightgrey !important;\r\n}\r\n\r\n.lbaViewGrid__clearIcon {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: 10px;\r\n    margin-left: -30px;\r\n    z-index: 9999;\r\n}\r\n\r\n.lbaViewGrid__clearIcon:hover {\r\n    color: #7EB6E2;\r\n}","$brandGreen: #9ab845;"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 341 */
/***/ function(module, exports) {

	var v1=" <div ng-if=\"!vm.dataService.addNewMode\"> <label class=\"lbaGrid_name\" ng-if=\"vm.settings.displayName\">{{ vm.settings.displayName }} listing</label> <div class=\"lbaGrid\" ng-if=\"vm.ready\"> <div class=\"lbaGrid_tools clearfix\">  <div class=\"input-group input-group-md lbaGrid_filter\" ng-if=\"vm.resource.rows.length > 0\"> <span class=\"input-group-addon\"><i class=\"glyphicon glyphicon-search\"></i></span>\n<input ng-keydown=\"vm.blurLog()\" ng-model=\"vm.filters\" type=\"text\" placeholder=\"Filter by...\" class=\"form-control lbaGrid_filter\">\n<span><i ng-if=\"vm.filters\" ng-click=\"vm.clearFilter()\" class=\"lbaViewGrid__clearIcon fa fa-close fa-lg fa-fw\"></i></span> </div> </div>  <div tasty-table bind-resource=\"vm.resource\" bind-watch-resource=\"collection\" bind-filters=\"vm.filters\" ng-if=\"vm.resource.rows.length > 0\"> <table class=\"table table-striped table-condensed table-hover lbaGrid_table\"> <thead tasty-thead></thead> <tbody> <tr class=\"lbaGrid_tr\" ng-repeat=\"row in rows track by $index\" ng-class=\"{ 'copyMode': vm.copyMode || vm.copyResourceMode, 'lbaViewGrid__row--selected': vm.dataService.data.activeItem == row }\" ng-click=\"vm.selectItem(row)\"> <td class=\"hideOverflow\" ng-repeat=\"col in vm.settings.gridCols\">{{ vm.getObjectPropertyValue(row, col.key) || '-' }} </td> </tr> </tbody> </table> <div tasty-pagination bind-template-url=\"'gridPaginationTpl.html'\" items-per-page=\"10\"></div> </div> <span ng-if=\"!vm.resource.rows || vm.resource.rows.length === 0\" class=\"lbaGrid_noRecords\"> No Records Found </span> <div ng-if=\"vm.dataService.data.activeItem\" ng-repeat=\"item in vm.settings.children track by $index\"> <div lba-dynamic=\"'lba-' + item.displayAs\" settings=\"item\"></div> </div> </div> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaViewGrid.html", v1)}]);
	module.exports=v1;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var lbaBooleanRestrictionSelect = angular.module('app.lbaBooleanRestrictionSelect', []).filter("booleanRestrictionDisplay", function () {
	    return function (value) {
	        switch (value) {
	            case "None":
	                return "No Restriction";
	            case "TrueOnly":
	                return "True Only";
	            case "FalseOnly":
	                return "False Only";
	            default:
	                return "";
	        }
	    };
	}).filter("refundableRestrictionDisplay", function () {
	    return function (value) {
	        switch (value) {
	            case "None":
	                return "No Restriction";
	            case "TrueOnly":
	                return "Refundable Only";
	            case "FalseOnly":
	                return "Non Refundable Only";
	            default:
	                return "";
	        }
	    };
	}).filter("changeableRestrictionDisplay", function () {
	    return function (value) {
	        switch (value) {
	            case "None":
	                return "No Restriction";
	            case "TrueOnly":
	                return "Changeable Only";
	            case "FalseOnly":
	                return "Non Changeable Only";
	            default:
	                return "";
	        }
	    };
	});
	
	lbaBooleanRestrictionSelect.controller('lbaBooleanRestrictionSelectCtrl', __webpack_require__(343));
	lbaBooleanRestrictionSelect.directive('lbaBooleanRestrictionSelect', __webpack_require__(344));
	lbaBooleanRestrictionSelect.service('booleanRestrictionService', __webpack_require__(346));
	
	exports["default"] = lbaBooleanRestrictionSelect;
	module.exports = exports["default"];

/***/ },
/* 343 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope', '$routeParams', '$filter', 'booleanRestrictionService', 'dataService'];
	
	var lbaBooleanRestrictionSelectCtrl = function lbaBooleanRestrictionSelectCtrl($scope, $routeParams, $filter, booleanRestrictionService, dataService) {
	  var vm = this;
	  var dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
	  vm.data = _.get(dataService.data.activeItem, dataLookUp);
	  vm.display = $filter(vm.settings.booleanRestrictionFilter || 'booleanRestrictionDisplay');
	  vm.booleanRestrictions = booleanRestrictionService.get();
	
	  $scope.$watchCollection('vm.data', function (newData, oldData) {
	    if (newData !== oldData) {
	      _.set(dataService.data.activeItem, dataLookUp, newData);
	    }
	  });
	};
	
	lbaBooleanRestrictionSelectCtrl.$inject = $inject;
	
	exports['default'] = lbaBooleanRestrictionSelectCtrl;
	module.exports = exports['default'];

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	var lbaBooleanRestrictionSelect = function lbaBooleanRestrictionSelect() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaBooleanRestrictionSelectCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(345)
	  };
	};
	
	lbaBooleanRestrictionSelect.$inject = $inject;
	
	exports['default'] = lbaBooleanRestrictionSelect;
	module.exports = exports['default'];

/***/ },
/* 345 */
/***/ function(module, exports) {

	var v1="<div class=\"form-group\"> <label for=\"{{ vm.settings.dataAt }}\">{{ vm.settings.displayName }}</label> <ui-select ng-model=\"vm.data\" ng-required=\"vm.settings.required\" search-enabled=\"false\"> <ui-select-match allow-clear=\"true\" class=\"ui-select-match\"> {{ vm.display($select.selected) }} </ui-select-match> <ui-select-choices repeat=\"booleanRestrictions in vm.booleanRestrictions\"> <div>{{ vm.display(booleanRestrictions) }}</div> </ui-select-choices> </ui-select> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaBooleanRestrictionSelect.html", v1)}]);
	module.exports=v1;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var booleanRestrictionsJSON = __webpack_require__(347);
	
	var $inject = [];
	var booleanRestrictionService = function booleanRestrictionService() {
	  var service = {};
	
	  service.get = function get() {
	    return booleanRestrictionsJSON;
	  };
	
	  return service;
	};
	
	booleanRestrictionService.$inject = $inject;
	
	exports["default"] = booleanRestrictionService;
	module.exports = exports["default"];

/***/ },
/* 347 */
/***/ function(module, exports) {

	module.exports = [
		"None",
		"TrueOnly",
		"FalseOnly"
	];

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var _module = angular.module('app.lbaFareClassTypeSelect', []);
	
	_module.filter("fareClassType", function () {
	    return function (value) {
	        switch (value) {
	            case "Economy":
	                return "Economy";
	            case "PremiumEconomy":
	                return "Premium Economy";
	            case "Business":
	                return "Business";
	            case "FirstClass":
	                return "First Class";
	            default:
	                return "";
	        }
	    };
	});
	_module.controller('lbaFareClassTypeSelectCtrl', __webpack_require__(349));
	_module.directive('lbaFareClassTypeSelect', __webpack_require__(350));
	_module.service('fareClassTypeService', __webpack_require__(352));
	
	exports["default"] = _module.name;
	module.exports = exports["default"];

/***/ },
/* 349 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	lbaFareClassTypeSelectCtrl.$inject = ['$scope', '$routeParams', '$filter', 'fareClassTypeService', 'dataService'];
	function lbaFareClassTypeSelectCtrl($scope, $routeParams, $filter, fareClassTypeService, dataService) {
	  var vm = this;
	  var dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
	  vm.data = _.get(dataService.data.activeItem, dataLookUp);
	  vm.display = $filter(vm.settings.fareClassTypeFilter || 'fareClassType');
	  vm.fareClassTypes = fareClassTypeService.get();
	
	  $scope.$watchCollection('vm.data', function (newData, oldData) {
	    if (newData !== oldData) {
	      _.set(dataService.data.activeItem, dataLookUp, newData);
	    }
	  });
	}
	
	exports['default'] = lbaFareClassTypeSelectCtrl;
	module.exports = exports['default'];

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	function lbaFareClassTypeSelect() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaFareClassTypeSelectCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(351)
	  };
	};
	
	exports['default'] = lbaFareClassTypeSelect;
	module.exports = exports['default'];

/***/ },
/* 351 */
/***/ function(module, exports) {

	var v1="<div class=\"form-group\"> <label for=\"{{ vm.settings.dataAt }}\">{{ vm.settings.displayName }}</label> <ui-select ng-model=\"vm.data\" ng-required=\"vm.settings.required\" search-enabled=\"false\"> <ui-select-match allow-clear=\"true\" class=\"ui-select-match\"> {{ vm.display($select.selected) }} </ui-select-match> <ui-select-choices repeat=\"fareClassTypes in vm.fareClassTypes\"> <div>{{ vm.display(fareClassTypes) }}</div> </ui-select-choices> </ui-select> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaFareClassTypeSelect.html", v1)}]);
	module.exports=v1;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var fareClassTypeOptions = __webpack_require__(353);
	
	var $inject = [];
	var fareClassTypeService = function fareClassTypeService() {
	  var service = {};
	
	  service.get = function get() {
	    return fareClassTypeOptions;
	  };
	
	  return service;
	};
	
	fareClassTypeService.$inject = $inject;
	
	exports["default"] = fareClassTypeService;
	module.exports = exports["default"];

/***/ },
/* 353 */
/***/ function(module, exports) {

	module.exports = [
		"Economy",
		"PremiumEconomy",
		"Business",
		"FirstClass"
	];

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var lbaCompanyReference = angular.module('app.lbaCompanyReference', [__webpack_require__(145).name, __webpack_require__(355).name, __webpack_require__(359).name]);
	
	lbaCompanyReference.controller('lbaCompanyReferenceCtrl', __webpack_require__(363));
	lbaCompanyReference.directive('lbaCompanyReference', __webpack_require__(364));
	lbaCompanyReference.service('companyReferenceService', __webpack_require__(368));
	
	exports['default'] = lbaCompanyReference;
	module.exports = exports['default'];

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(136);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(356);
	
	var lbaCompanyReferenceItemForm = _angular2['default'].module('app.lbaCompanyReferenceItemForm', []);
	
	lbaCompanyReferenceItemForm.component('lbaCompanyReferenceItemForm', {
	  bindings: {
	    activeCompanyReference: '=',
	    toggleDetail: '=',
	    saveItem: '=',
	    deleteItem: '=',
	    setLoadForm: '='
	  },
	  controllerAs: '$ctrl',
	  controller: ['companyReferenceService', '$rootScope', lbaCompanyReferenceItemFormCtrl],
	  template: __webpack_require__(358)
	});
	
	function lbaCompanyReferenceItemFormCtrl(companyReferenceService, $rootScope) {
	  var $ctrl = this;
	
	  $ctrl.tempCompanyReference = {};
	  $ctrl.saving = false;
	  $ctrl.update = false;
	  $ctrl.LoadForm = LoadForm;
	
	  $ctrl.saveCompanyReference = saveCompanyReference;
	  $ctrl.deleteCompanyReference = deleteCompanyReference;
	  $ctrl.updateCompanyReference = updateCompanyReference;
	  $ctrl.LoadForm = LoadForm;
	  $ctrl.progressPercent = 0;
	
	  $ctrl.setLoadForm($ctrl.LoadForm);
	  function LoadForm(_companyReference) {
	    $ctrl.activeCompanyReference = _companyReference;
	
	    $ctrl.saving = false;
	    $ctrl.validationErrors = false;
	    if (!$ctrl.activeCompanyReference) {
	      $ctrl.update = false;
	      $ctrl.tempCompanyReference = {
	        DebtorIdentifier: null,
	        ListId: null,
	        Items: []
	      };
	    } else {
	      $ctrl.update = true;
	      _angular2['default'].copy($ctrl.activeCompanyReference, $ctrl.tempCompanyReference);
	    }
	    CreateItemsText($ctrl.tempCompanyReference);
	  }
	
	  function CreateItemsText(_companyReference) {
	    _companyReference.ItemsText = "";
	    if (_companyReference.Items) {
	      _companyReference.Items.forEach(function (element) {
	        _companyReference.ItemsText += element.Value + ', ' + element.Description + '\r\n';
	      });
	    }
	  }
	  function UpdateItemsFromItemsText(_companyReference) {
	    var workingIndex = 0;
	    _companyReference.ItemsUpdate = [];
	    if (_companyReference && _companyReference.ItemsText) {
	      _companyReference.ItemsText.split(/\r\n|\r|\n/).forEach(function (line) {
	        if (line.trim() === '') {
	          return;
	        }
	
	        var charIndex = line.indexOf(',');
	        if (charIndex === -1) {
	          AddUpdateItem(_companyReference, line, line, workingIndex);
	        } else {
	          AddUpdateItem(_companyReference, line.substring(0, charIndex).trim(), line.substring(charIndex + 1).trim(), workingIndex);
	        }
	        workingIndex++;
	      });
	    }
	
	    if (_companyReference.Items && workingIndex < _companyReference.Items.length) {
	      var i = 0;
	      for (i = workingIndex; i < _companyReference.Items.length; i++) {
	        var existingItem = _angular2['default'].copy(_companyReference.Items[i]);
	        existingItem.IsDeleted = true;
	        _companyReference.ItemsUpdate.push(existingItem);
	      }
	    }
	  }
	  function AddUpdateItem(_companyReference, Value, Description, workingIndex) {
	    if (_companyReference.Items && _companyReference.Items.length > workingIndex) {
	      //Update existing
	      var existingItem = _angular2['default'].copy(_companyReference.Items[workingIndex]);
	
	      if (existingItem.DebtorIdentifier !== _companyReference.DebtorIdentifier || existingItem.ListId !== _companyReference.ListId || existingItem.Value !== Value || existingItem.Description !== Description || existingItem.IsDeleted === true) {
	        existingItem.DebtorIdentifier = _companyReference.DebtorIdentifier;
	        existingItem.ListId = _companyReference.ListId;
	        existingItem.Value = Value;
	        existingItem.Description = Description;
	        existingItem.IsDeleted = false;
	        _companyReference.ItemsUpdate.push(existingItem);
	      }
	    } else {
	      //Add New
	      _companyReference.ItemsUpdate.push({
	        DebtorIdentifier: _companyReference.DebtorIdentifier,
	        ListId: _companyReference.ListId,
	        Value: Value,
	        Description: Description,
	        IsDeleted: false
	      });
	    }
	  }
	  function ValidateForm() {
	    $ctrl.validationErrors = false;
	    if (!$ctrl.tempCompanyReference.DebtorIdentifier || !($ctrl.tempCompanyReference.DebtorIdentifier.length > 0)) {
	      $ctrl.validationErrors = true;
	    }
	    if (!$ctrl.tempCompanyReference.ListId || !($ctrl.tempCompanyReference.ListId.length > 0)) {
	      $ctrl.validationErrors = true;
	    }
	    return !$ctrl.validationErrors;
	  }
	  function saveCompanyReference() {
	
	    if (!(ValidateForm() === true)) {
	      return;
	    }
	    $ctrl.saving = true;
	    UpdateItemsFromItemsText($ctrl.tempCompanyReference);
	    SaveBlocks($ctrl.tempCompanyReference.ItemsUpdate, 0);
	  }
	
	  function updateCompanyReference() {
	    if (!(ValidateForm() === true)) {
	      return;
	    }
	    $ctrl.saving = true;
	
	    UpdateItemsFromItemsText($ctrl.tempCompanyReference);
	    SaveBlocks($ctrl.tempCompanyReference.ItemsUpdate, 0);
	  }
	
	  function SaveBlocks(items, startIndex) {
	    $ctrl.saving = true;
	    $ctrl.showProgress = true;
	    $ctrl.progressPercent = 0;
	    var chunk = 100;
	
	    var endIndex = startIndex + chunk > items.length ? items.length : startIndex + chunk;
	    if (startIndex >= items.length) {
	
	      $ctrl.showProgress = false;
	      $ctrl.progressPercent = 100;
	      $ctrl.saving = false;
	      $ctrl.toggleDetail(true);
	
	      return;
	    }
	    var temporary = items.slice(startIndex, startIndex + chunk);
	    SetProgressBar(endIndex, items.length);
	    companyReferenceService.saveCompanyReferences(temporary, true).then(function (result) {
	
	      SaveBlocks(items, endIndex);
	    });
	  }
	  function SetProgressBar(index, itemsCount) {
	
	    $ctrl.progressPercent = Math.floor(index / itemsCount * 100);
	    $ctrl.progressStatus = $ctrl.progressPercent + '% Saving ' + index.toLocaleString() + ' of ' + itemsCount.toLocaleString();
	    $ctrl.progressWidth = '{width:' + $ctrl.progressPercent + '%;}';
	  }
	
	  function deleteCompanyReference() {
	    $ctrl.saving = true;
	    $ctrl.tempCompanyReference.ItemsUpdate = [];
	    for (var i = 0; i < $ctrl.tempCompanyReference.Items.length; i++) {
	      var existingItem = _angular2['default'].copy($ctrl.tempCompanyReference.Items[i]);
	      existingItem.IsDeleted = true;
	      $ctrl.tempCompanyReference.ItemsUpdate.push(existingItem);
	    }
	    SaveBlocks($ctrl.tempCompanyReference.ItemsUpdate, 0);
	  }
	}
	
	exports['default'] = lbaCompanyReferenceItemForm;
	module.exports = exports['default'];

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(357);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaCompanyReferenceItemForm.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaCompanyReferenceItemForm.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".lbaCompanyReference_ItemForm_back .fa{font-size:1.1em;margin-right:.25em}.form-group{position:relative}.lbaCompanyReference_ItemForm_header{margin-bottom:2rem;position:relative;padding-top:5px}.lbaCompanyReference_ItemForm_header h3{margin-top:0}.lbaCompanyReference_ItemForm_back{position:absolute;right:0;top:0}.lbaCompanyReference_deleteItem,.lbaCompanyReference_saveItem{width:100%}.lbaSaveCompanyReference_progress{border-radius:.2rem;width:100%;height:33px;overflow:hidden;margin:0 auto}.progress-bar{border-radius:.2rem;display:block;height:100%;font-size:14;padding-top:7px;padding-left:10px;overflow:visible;white-space:nowrap;color:#000}.progress-bar.isLoading{transition:width 60s cubic-bezier(0,0.75,0,1);transition-delay:1s;width:95%}.progress-bar.isComplete{transition:width .3s;width:100%}.lbaCompanyReference_ItemForm .ListItems{height:300px}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaCompanyReferenceItemForm/src/components/lbaCompanyReferenceItemForm/lbaCompanyReferenceItemForm.scss","/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaCompanyReferenceItemForm/src/components/lbaCompanyReference/_helpers.scss"],"names":[],"mappings":"AAgBA,uCCdE,gBACA,kBAAmB,CDDrB,YACE,iBAAkB,CACnB,qCAGC,mBACA,kBACA,eAAgB,CAHlB,wCAMI,YAAa,CACd,mCAID,kBACA,QACA,KAAM,CAKP,8DAIC,UAAW,CACZ,kCAKC,oBAEA,WACA,YACA,gBACA,aAAc,CACf,cAQC,oBACA,cAEA,YACA,aACA,gBACA,kBACA,iBACA,mBACA,UAAU,CAXZ,wBAaI,8CACA,oBACA,SAAU,CAfd,yBAmBI,qBACA,UAAW,CACZ,yCAID,YAAa,CAEd","file":"lbaCompanyReferenceItemForm.scss","sourcesContent":["@import '../lbaCompanyReference/helpers';\r\n\r\n.form-group {\r\n  position: relative;\r\n}\r\n\r\n.lbaCompanyReference_ItemForm_header {\r\n  margin-bottom: 2rem;\r\n  position: relative;\r\n  padding-top: 5px;\r\n\r\n  h3 {\r\n    margin-top: 0;\r\n  }\r\n}\r\n\r\n.lbaCompanyReference_ItemForm_back {\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n\r\n  .fa {\r\n    @extend %buttonIcon;\r\n  }\r\n}\r\n\r\n.lbaCompanyReference_saveItem,\r\n.lbaCompanyReference_deleteItem {\r\n  width: 100%;\r\n}\r\n\r\n\r\n.lbaSaveCompanyReference_progress{\r\n  \r\n  border-radius: 0.2rem;\r\n\r\n  width: 100%;\r\n  height: 33px;\r\n  overflow: hidden;\r\n  margin: 0 auto;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n.progress-bar {\r\n  \r\n  border-radius: 0.2rem;\r\n  display: block;\r\n  \r\n  height: 100%;\r\n  font-size: 14;\r\n  padding-top: 7px;\r\n  padding-left: 10px;\r\n  overflow: visible;\r\n  white-space: nowrap;\r\n  color:#000;\r\n  &.isLoading {\r\n    transition: width 60s cubic-bezier(0,0.75,0,1);\r\n    transition-delay: 1s;\r\n    width: 95%;\r\n  }\r\n\r\n  &.isComplete {\r\n    transition: width 0.3s;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.lbaCompanyReference_ItemForm .ListItems{\r\n  height: 300px;\r\n\r\n}","\r\n%buttonIcon {\r\n  font-size: 1.1em;\r\n  margin-right: .25em;\r\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 358 */
/***/ function(module, exports) {

	var v1="<div class=\"lbaCompanyReference_ItemForm\"> <div class=\"lbaCompanyReference_ItemForm_header\"> <h3 ng-if=\"!$ctrl.update\">New</h3> <h3 ng-if=\"$ctrl.update\">Edit</h3> <button class=\"lbaCompanyReference_ItemForm_back btn\" ng-click=\"$ctrl.toggleDetail()\"><span class=\"fa fa-chevron-left\"></span></button> </div> <form> <div class=\"error text-warning\" ng-if=\"$ctrl.validationErrors\"> <div ng-if=\"!$ctrl.tempCompanyReference.DebtorIdentifier\">Debtor Idenitfier is required</div> <div ng-if=\"!$ctrl.tempCompanyReference.ListId\">ListId is required</div> </div> <div ng-if=\"$ctrl.update\"> <a href=\"/#/company-references/grid/{{$ctrl.tempCompanyReference.DebtorIdentifier}}/{{$ctrl.tempCompanyReference.ListId}}\">Manage Items in Grid View</a> </div> <div class=\"progress lbaSaveCompanyReference_progress\" ng-if=\"$ctrl.showProgress\"> <div class=\"progress-bar progress-bar-success\" role=\"progressbar\" ng-style=\"{'width':$ctrl.progressPercent + '%' }\"> {{ $ctrl.progressStatus }} </div> </div> <div class=\"form-group\"> <label>DebtorIdentifier</label> <input type=\"text\" ng-model=\"$ctrl.tempCompanyReference.DebtorIdentifier\" placeholder=\"DebtorIdentifier\" class=\"form-control\" required ng-disabled=\"$ctrl.saving\"> </div> <div class=\"form-group\"> <label>ListId</label> <input type=\"text\" ng-model=\"$ctrl.tempCompanyReference.ListId\" ng-change=\"$ctrl.tempCompanyReference.ListId = $ctrl.tempCompanyReference.ListId.toUpperCase()\" placeholder=\"ListId\" class=\"form-control\" required ng-disabled=\"$ctrl.saving\" style=\"text-transform: uppercase\"> </div> <div class=\"form-group\"> <label>Items</label> <textarea ng-model=\"$ctrl.tempCompanyReference.ItemsText\" placeholder=\"List\" class=\"form-control ListItems\" ng-disabled=\"$ctrl.saving\"></textarea> </div> <div class=\"form-group\"> <p> <button class=\"btn-primary btn lbaCompanyReference_saveItem\" ng-click=\"$ctrl.saveCompanyReference()\" ng-if=\"!$ctrl.update\" ng-disabled=\"$ctrl.saving\">Save</button>\n<button class=\"btn-primary btn lbaCompanyReference_saveItem\" ng-click=\"$ctrl.updateCompanyReference()\" ng-if=\"$ctrl.update\" ng-disabled=\"$ctrl.saving\">Update</button> </p> </div> <div class=\"form-group\"> <p> <button class=\"btn-danger btn lbaCompanyReference_deleteItem\" ng-click=\"$ctrl.deleteCompanyReference()\" ng-if=\"$ctrl.update\" ng-disabled=\"$ctrl.saving\">Delete</button> </p> <p class=\"error text-warning\">{{$ctrl.errors.delete}}</p> </div> </form> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaCompanyReferenceItemForm.html", v1)}]);
	module.exports=v1;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(360);
	
	var lbaCompanyReferenceGrid = angular.module('app.lbaCompanyReferenceGrid', []);
	
	lbaCompanyReferenceGrid.component('lbaCompanyReferenceGrid', {
	  bindings: {
	    settings: '=',
	    toggleDetail: '=',
	    saveItem: '=',
	    deleteItem: '=',
	    data: '='
	  },
	  controllerAs: 'vm',
	  controller: ['companyReferenceService', '$location', '$scope', '$timeout', '$routeParams', '$http', 'dataService', 'dataSourceService', '$rootScope', lbaCompanyReferenceGridCtrl],
	  template: __webpack_require__(362)
	});
	
	function lbaCompanyReferenceGridCtrl(companyReferenceService, $location, $scope, $timeout, $routeParams, $http, dataService, dataSourceService, $rootScope) {
	  var vm = this;
	
	  $rootScope.$on('companyReferenceGrid.refresh', vm.LoadCompanyReferences);
	
	  vm.dataService = dataService;
	  vm.ready = false;
	  //vm.canAdd = vm.settings.hasOwnProperty('gridAdd');
	  vm.filters = '';
	  if (dataService.backGridFilter != null && dataService.backGridFilter[vm.settings.displayName]) {
	    vm.filters = dataService.backGridFilter[vm.settings.displayName];
	  }
	  var page = 1;
	  if (dataService.backGridPage != null && dataService.backGridPage[vm.settings.displayName]) {
	    page = dataService.backGridPage[vm.settings.displayName];
	  }
	
	  vm.addNew = addNew;
	  vm.getObjectPropertyValue = getObjectPropertyValue;
	  vm.isShowingDisabled = false;
	  vm.onClick = onClick;
	  vm.LoadCompanyReferences = LoadCompanyReferences;
	
	  vm.LoadCompanyReferences();
	
	  function LoadCompanyReferences() {
	
	    companyReferenceService.getCompanyReferences().then(function (data) {
	      vm.data = data;
	      addDataToGrid(vm.settings.gridCols, vm.data, page);
	    });
	  }
	
	  function addDataToGrid(headers, data, page) {
	
	    vm.resource = {
	      header: headers,
	      rows: data,
	      pagination: {
	        page: page
	      }
	    };
	
	    vm.ready = true;
	  }
	
	  function addNew() {
	    vm.settings.gridItem(null, LoadCompanyReferences);
	  }
	
	  function getObjectPropertyValue(obj, path) {
	    var defaultValue = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    return _.get(obj, path, defaultValue);
	  }
	  function onClick(data, copyItem, copyResource) {
	    vm.settings.gridItem(data, LoadCompanyReferences);
	  }
	}
	
	exports['default'] = lbaCompanyReferenceGrid;
	module.exports = exports['default'];

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(361);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaCompanyReferenceGrid.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaCompanyReferenceGrid.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"lbaCompanyReferenceGrid.scss","sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 362 */
/***/ function(module, exports) {

	var v1="<div ng-if=\"!vm.dataService.addNewMode\"> <label class=\"lbaGrid_name\" ng-if=\"vm.settings.displayName\">{{ vm.settings.displayName }} listing</label> <div class=\"lbaGrid\" ng-if=\"vm.ready\"> <div class=\"lbaGrid_tools clearfix\"> <div class=\"lbaGrid_add\"> <button ng-show=\"vm.settings.canAddNew || vm.settings.gridAdd\" ng-click=\"vm.addNew()\" class=\"btn btn-default\"><i class=\"fa fa-plus\"></i> Add new </button>\n<span ng-if=\"vm.resource.rows.length > 0\"> <button ng-show=\"vm.settings.canCopyItem\" ng-click=\"vm.copyMode = !vm.copyMode\" class=\"btn btn-default\" ng-class=\"{ 'btn_copyMode': vm.copyMode }\"><i class=\"fa fa-files-o\"></i>\nCopy</button>\n<button ng-show=\"vm.settings.canCopyResource\" ng-click=\"vm.copyResourceMode = !vm.copyResourceMode\" class=\"btn btn-default\" ng-class=\"{ 'btn_copyMode': vm.copyResourceMode }\"><i class=\"fa fa-files-o\"></i> Copy</button> </span> </div> <div class=\"input-group input-group-md lbaGrid_filter\" ng-if=\"vm.resource.rows.length > 0\"> <span class=\"input-group-addon\"><i class=\"glyphicon glyphicon-search\"></i></span>\n<input ng-model=\"vm.filters\" type=\"text\" placeholder=\"Filter by...\" class=\"form-control lbaGrid_filter\"> </div> <div ng-if=\"vm.settings.canFilterDisabled\" class=\"input-group input-group-md lbaGrid_filter\" style=\"padding-left: 20px\"> <input type=\"checkbox\" ng-click=\"vm.toggleDisabledData()\">\nShow Disabled </div> </div> <div tasty-table bind-resource=\"vm.resource\" bind-watch-resource=\"collection\" bind-filters=\"vm.filters\" ng-if=\"vm.resource.rows.length > 0\"> <table class=\"table table-striped table-condensed table-hover lbaGrid_table\"> <thead tasty-thead></thead> <tbody> <tr ng-repeat=\"row in rows track by $index\" class=\"lbaGrid_tr\" ng-class=\"{ 'copyMode': vm.copyMode || vm.copyResourceMode }\" ng-click=\"vm.onClick(row, vm.copyMode, vm.copyResourceMode)\"> <td class=\"hideOverflow\" ng-repeat=\"col in vm.settings.gridCols\"> {{ vm.getObjectPropertyValue(row, col.key) || '-' }}</td> </tr> </tbody> </table> <div tasty-pagination bind-template-url=\"'gridPaginationTpl.html'\" items-per-page=\"10\"></div> </div> <span ng-if=\"!vm.resource.rows || vm.resource.rows.length === 0\" class=\"lbaGrid_noRecords\"> No Records Found </span> </div> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaCompanyReferenceGrid.html", v1)}]);
	module.exports=v1;

/***/ },
/* 363 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', 'dataService', 'companyReferenceService', '$timeout', '$rootScope', '$scope', '$http'];
	
	var lbaCompanyReferenceCtrl = function lbaCompanyReferenceCtrl($q, dataService, companyReferenceService, $timeout, $rootScope, $scope, $http) {
	  var vm = this;
	
	  vm.editorActive = false;
	
	  vm.refreshCompanyReferences = refreshCompanyReferences;
	
	  vm.toggleDetail = toggleDetail;
	  vm.editItem = editItem;
	
	  vm.activeCompanyReference = {};
	  vm.refreshCompanyReferences();
	  vm.refreshGrid = null;
	  vm.formLoad = undefined;
	  vm.setLoadForm = function (cb) {
	    vm.formLoad = cb;
	  };
	  vm.gridDetails = {
	    displayName: 'CompanyReferences',
	    dataAt: vm.CompanyReferences,
	
	    canCopyItem: false,
	    canAddNew: true,
	    gridItem: editItem,
	    gridCols: [{ name: 'DebtorIdentifier', key: 'DebtorIdentifier' }, { name: 'ListId', key: 'ListId' }, { name: 'NumberOfItems', key: 'NumberOfItems' }]
	  };
	
	  function toggleDetail(doRefresh) {
	    vm.editorActive = !vm.editorActive;
	    if (doRefresh) {
	      vm.refreshCompanyReferences();
	    }
	  }
	
	  function editItem(item, loadData) {
	    // toggle form
	
	    vm.editorActive = true;
	    vm.activeCompanyReference = item;
	    vm.refreshGrid = loadData;
	    if (!vm.activeCompanyReference) {
	      vm.activeCompanyReference = {
	        DebtorIdentifier: null,
	        ListId: null,
	        Items: []
	      };
	      vm.LoadingCompanyReference = false;
	
	      vm.formLoad(vm.activeCompanyReference);
	    } else {
	
	      vm.LoadingCompanyReference = true;
	      companyReferenceService.getCompanyReferenceItems(item.DebtorIdentifier, item.ListId).then(function (data) {
	        vm.LoadingCompanyReference = false;
	        vm.activeCompanyReference.Items = data;
	        vm.formLoad(vm.activeCompanyReference);
	      });
	    }
	  }
	
	  function refreshCompanyReferences() {
	    if (vm.refreshGrid) {
	      vm.refreshGrid();
	    } else {
	      $rootScope.$broadcast('companyReferenceGrid.refresh', 'doRefresh');
	    }
	  }
	};
	
	lbaCompanyReferenceCtrl.$inject = $inject;
	
	exports['default'] = lbaCompanyReferenceCtrl;
	module.exports = exports['default'];

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(365);
	var $inject = [];
	var lbaCompanyReference = function lbaCompanyReference() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaCompanyReferenceCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(367)
	  };
	};
	
	lbaCompanyReference.$inject = $inject;
	
	exports['default'] = lbaCompanyReference;
	module.exports = exports['default'];

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(366);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaCompanyReference.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaCompanyReference.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".companyReference_selectCompanyReference{margin-bottom:3rem;position:relative;z-index:100}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaCompanyReference/src/components/lbaCompanyReference/lbaCompanyReference.scss"],"names":[],"mappings":"AAIA,yCACE,mBACA,kBACA,WAAY,CACb","file":"lbaCompanyReference.scss","sourcesContent":["@import '../lbaCompanyReference/helpers';\r\n\r\n\r\n\r\n.companyReference_selectCompanyReference {\r\n  margin-bottom: 3rem;\r\n  position: relative;\r\n  z-index: 100;\r\n}\r\n\r\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 367 */
/***/ function(module, exports) {

	var v1="<div class=\"companyReference\"> <lba-company-reference-grid settings=\"vm.gridDetails\" data=\"vm.companyReferences\">why wont it work</lba-company-reference-grid> <div ng-if=\"vm.LoadingCompanyReference\">Loading Data Please Wait...</div> <lba-company-reference-item-form ng-if=\"vm.editorActive\" active-company-reference=\"vm.activeCompanyReference\" toggle-detail=\"vm.toggleDetail\" save-item=\"vm.saveItem\" set-load-form=\"vm.setLoadForm\"></lba-company-reference-item-form> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaCompanyReference.html", v1)}]);
	module.exports=v1;

/***/ },
/* 368 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var $inject = ['$q', 'dataService', '$timeout', '$rootScope', '$http'];
	
	var companyReferenceService = function companyReferenceService($q, dataService, $timeout, $rootScope, $http) {
	  var service = {};
	
	  service.saveCompanyReferences = saveCompanyReferences;
	  service.deleteCompanyReference = deleteCompanyReference;
	  service.getCompanyReferences = getCompanyReferences;
	  service.getCompanyReferenceItems = getCompanyReferenceItems;
	
	  function deleteCompanyReference(item) {
	    var deferred = $q.defer();
	
	    dataService.patch('CompanyReferences', { IsDeleted: true }, item.id).then(function () {
	      deferred.resolve({ message: 'done' });
	    });
	
	    return deferred.promise;
	  }
	
	  function saveCompanyReferences(data, hideMessage) {
	    var deferred = $q.defer();
	    var url = endPointUrl + '/api/CompanyReferenceList/Save';
	    var settings = {};
	
	    if (!(hideMessage === true)) {
	      $rootScope.$broadcast('lbaToast:showToast', { message: 'Posting data...', messageType: 'waiting' });
	    }
	
	    $http.post(url, data, settings).success(function (data, status, headers) {
	
	      $rootScope.isSaved = true;
	      if (!(hideMessage === true)) {
	        $rootScope.$broadcast('lbaToast:showToast', { message: 'Data saved', messageType: 'success' });
	      }
	
	      deferred.resolve(data);
	    }).error(function (data, status) {
	
	      console.error(data);
	      if (status === 412) {
	        $rootScope.$broadcast('lbaToast:showToast', { message: 'Data out of date - please refresh', messageType: 'error' });
	      } else if (status === 400) {
	        $rootScope.$broadcast('lbaToast:showToast', { message: 'Provided data is not valid - please review the data', messageType: 'error' });
	      } else {
	        $rootScope.$broadcast('lbaToast:showToast', { message: 'Error occurred', messageType: 'error' });
	      }
	
	      deferred.reject();
	    });
	
	    return deferred.promise;
	  };
	
	  function getCompanyReferences() {
	    var deferred = $q.defer();
	    $http.get(endPointUrl + '/api/CompanyReferenceList/CompanyReferenceSummary').success(function (data) {
	      deferred.resolve(data);
	    }).error(function (err, x) {
	      deferred.reject(err);
	    });
	    return deferred.promise;
	  }
	
	  function getCompanyReferenceItems(DebtorIdentifier, ListId) {
	    if (!DebtorIdentifier || !ListId) {
	      return;
	    }
	    //http://localhost:7622/odata/CompanyReferences?$filter=DebtorIdentifier+eq+('THUNDERJR0')+and+ListId+eq+('Test')
	    var query = 'CompanyReferences?$filter=DebtorIdentifier+eq+(\'' + encodeURI(DebtorIdentifier) + '\')+and+ListId+eq+(\'' + encodeURI(ListId) + '\')+and+IsDeleted+eq+(false)';
	    var deferred = $q.defer();
	    dataService.get(query).then(function (data) {
	      deferred.resolve(data);
	    });
	    return deferred.promise;
	  }
	
	  return service;
	};
	
	companyReferenceService.$inject = $inject;
	
	exports['default'] = companyReferenceService;
	module.exports = exports['default'];

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaPerDiem = angular.module('app.lbaPerDiem', [__webpack_require__(370).name]);
	
	lbaPerDiem.controller('lbaPerDiemCtrl', __webpack_require__(374));
	lbaPerDiem.directive('lbaPerDiem', __webpack_require__(375));
	lbaPerDiem.service('perDiemService', __webpack_require__(379));
	
	exports['default'] = lbaPerDiem;
	module.exports = exports['default'];

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(136);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(371);
	__webpack_require__(141);
	
	var lbaPerDiemGrid = _angular2['default'].module('app.lbaPerDiemGrid', []);
	
	lbaPerDiemGrid.component('lbaPerDiemGrid', {
	  bindings: {},
	  controllerAs: 'vm',
	  controller: ['perDiemService', '$rootScope', '$http', '$location', 'Upload', lbaPerDiemGridCtrl],
	  template: __webpack_require__(373)
	});
	
	function lbaPerDiemGridCtrl(perDiemService, $rootScope, $http, $location, Upload) {
	  var vm = this;
	  vm.getObjectPropertyValue = getObjectPropertyValue;
	  vm.onClick = onClick;
	  vm.addNew = addNew;
	
	  vm.filters = '';
	  vm.ready = false;
	
	  var gridColumns = [{ name: 'Source', key: 'Source' }, { name: 'Destination Name', key: 'DestinationName' }, { name: 'City', key: 'City' }, { name: 'Country Code', key: 'CountryCode' }, { name: 'Season Start', key: 'SeasonStart' }, { name: 'Season End', key: 'SeasonEnd' }, { name: 'Lodging Per Diem', key: 'LodgingPerDiem' }, { name: 'Effective Date', key: 'EffectiveDate' }, { name: 'Expiration Date', key: 'ExpirationDate' }];
	
	  vm.resource = {
	    header: gridColumns,
	    rows: []
	  };
	
	  vm.settings = {
	    displayName: 'Per Diem',
	    dataAt: 'PerDiemDefaultRates',
	    canCopyItem: true,
	    canAddNew: true,
	    gridCols: gridColumns
	  };
	
	  perDiemService.getData(function () {
	    vm.resource.rows = perDiemService.data;
	    vm.ready = true;
	  });
	
	  function getObjectPropertyValue(obj, path) {
	    var defaultValue = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    return _.get(obj, path, defaultValue);
	  }
	
	  function onClick(row) {
	    perDiemService.perDiemGridItem = row;
	    window.localStorage['perDiemGridItem'] = JSON.stringify(row);
	    perDiemService.perDiemGridStatus = vm.copyMode ? "copy" : "edit";
	    window.localStorage['perDiemGridStatus'] = vm.copyMode ? "copy" : "edit";
	    $location.path($location.$$path + '/data');
	  }
	
	  function addNew() {
	    perDiemService.perDiemGridStatus = "add";
	    window.localStorage['perDiemGridStatus'] = "add";
	    window.localStorage.removeItem('perDiemGridItem');
	    $location.path($location.$$path + '/data');
	  }
	}
	
	exports['default'] = lbaPerDiemGrid;
	module.exports = exports['default'];

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(372);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaPerDiemGrid.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaPerDiemGrid.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"lbaPerDiemGrid.scss","sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 373 */
/***/ function(module, exports) {

	var v1="<div class=\"lbaPerDiemGrid\"> <label class=\"lbaGrid_name\">Per Diem Data</label> <div class=\"lbaGrid\" ng-if=\"vm.ready\"> <div class=\"lbaGrid_tools clearfix\"> <div class=\"lbaGrid_add\"> <button ng-click=\"vm.addNew()\" class=\"btn btn-default\"><i class=\"fa fa-plus\"></i> Add new </button>\n<span ng-if=\"vm.resource.rows.length > 0\"> <button ng-show=\"vm.settings.canCopyItem\" ng-click=\"vm.copyMode = !vm.copyMode\" class=\"btn btn-default\" ng-class=\"{ 'btn_copyMode': vm.copyMode }\"><i class=\"fa fa-files-o\"></i>\nCopy</button>\n<button ng-show=\"vm.settings.canCopyResource\" ng-click=\"vm.copyResourceMode = !vm.copyResourceMode\" class=\"btn btn-default\" ng-class=\"{ 'btn_copyMode': vm.copyResourceMode }\"><i class=\"fa fa-files-o\"></i> Copy</button> </span> </div> <div class=\"input-group input-group-md lbaGrid_filter\" ng-if=\"vm.resource.rows.length > 0\"> <span class=\"input-group-addon\"><i class=\"glyphicon glyphicon-search\"></i></span>\n<input ng-model=\"vm.filters\" type=\"text\" placeholder=\"Filter by...\" class=\"form-control lbaGrid_filter\"> </div> </div> <div tasty-table bind-resource=\"vm.resource\" bind-watch-resource=\"collection\" bind-filters=\"vm.filters\" ng-if=\"vm.resource.rows.length > 0\"> <table class=\"table table-striped table-condensed table-hover lbaGrid_table\"> <thead tasty-thead></thead> <tbody> <tr ng-repeat=\"row in rows track by $index\" class=\"lbaGrid_tr\" ng-class=\"{ 'copyMode': vm.copyMode || vm.copyResourceMode }\" ng-click=\"vm.onClick(row, $index, vm.copyMode, vm.copyResourceMode)\"> <td class=\"hideOverflow\" ng-repeat=\"col in vm.settings.gridCols\" title=\"{{vm.getObjectPropertyValue(row, col.key) || '-' }}\"> {{ vm.getObjectPropertyValue(row, col.key) || '-' }} </td> </tr> </tbody> </table> <div tasty-pagination bind-template-url=\"'gridPaginationTpl.html'\" items-per-page=\"10\"></div> </div> <span ng-if=\"!vm.resource.rows || vm.resource.rows.length === 0\" class=\"lbaGrid_noRecords\"> No Records Found </span> </div> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaPerDiemGrid.html", v1)}]);
	module.exports=v1;

/***/ },
/* 374 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', 'dataService', 'perDiemService', '$timeout', '$rootScope', '$scope', '$http'];
	
	var lbaPerDiemCtrl = function lbaPerDiemCtrl($q, dataService, perDiemService, $timeout, $rootScope, $scope, $http) {
	  var vm = this;
	
	  vm.setActiveTab = setActiveTab;
	  vm.activeTab = "data";
	
	  function setActiveTab(id) {
	    vm.activeTab = id;
	  }
	};
	
	lbaPerDiemCtrl.$inject = $inject;
	
	exports['default'] = lbaPerDiemCtrl;
	module.exports = exports['default'];

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(376);
	var $inject = [];
	var lbaPerDiem = function lbaPerDiem() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaPerDiemCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(378)
	  };
	};
	
	lbaPerDiem.$inject = $inject;
	
	exports['default'] = lbaPerDiem;
	module.exports = exports['default'];

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(377);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaPerDiem.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaPerDiem.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"lbaPerDiem.scss","sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 378 */
/***/ function(module, exports) {

	var v1="<div class=\"perDiem\"> <div class=\"lbaContainer_nav\"> <ul class=\"nav nav-pills nav-stacked lbaSubNav\"> <li> <a href=\"\" class=\"ng-binding\" ng-click=\"vm.setActiveTab('data')\">Per Diem Data</a> </li> <li> <a href=\"#/per-diem/file-upload\" class=\"ng-binding\" ng-click=\"vm.setActiveTab('upload')\">File Upload</a> </li> </ul> </div> <div class=\"lbaContainer_fields\"> <div ng-if=\"vm.activeTab == 'data'\"> <lba-per-diem-grid></lba-per-diem-grid> </div> </div> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaPerDiem.html", v1)}]);
	module.exports=v1;

/***/ },
/* 379 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var $inject = ['$q', 'dataService', '$timeout', '$rootScope', '$http'];
	
	var perDiemService = function perDiemService($q, dataService, $timeout, $rootScope, $http) {
	    var vm = this;
	
	    vm.getData = getData;
	    vm.formatData = formatData;
	    vm.save = save;
	    vm.deletePerDiem = deletePerDiem;
	
	    function getData(_callback) {
	        var url = endPointUrl + '/api/PerDiem/Get';
	
	        $http.get(url).success(function (response, status, headers) {
	            formatData(response);
	            vm.ready = true;
	            vm.data = response;
	            _callback();
	        }).error(function (response, status) {
	            vm.ready = true;
	        });
	    }
	
	    function save(perDiem, _successCallback, _failCallback) {
	        var url = endPointUrl + '/api/PerDiem/Save';
	
	        $http.post(url, perDiem).success(function (response, status, headers) {
	            _successCallback(response, status, headers);
	        }).error(function (response, status) {
	            _failCallback(response, status);
	        });
	    }
	
	    function deletePerDiem(perDiem, _successCallback, _failCallback) {
	        var url = endPointUrl + '/api/PerDiem/Delete';
	
	        $http.post(url, perDiem).success(function (response, status, headers) {
	            _successCallback();
	        }).error(function (response, status) {
	            _failCallback();
	        });
	    }
	
	    function formatData(data) {
	        data.forEach(function (perDiem) {
	            perDiem.SeasonStart = perDiem.SeasonStartMonth + "/" + perDiem.SeasonStartDay;
	            perDiem.SeasonEnd = perDiem.SeasonEndMonth + "/" + perDiem.SeasonEndDay;
	        });
	    }
	};
	
	perDiemService.$inject = $inject;
	
	exports['default'] = perDiemService;
	module.exports = exports['default'];

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaPerDiemGridItem = angular.module('app.lbaPerDiemGridItem', []);
	
	lbaPerDiemGridItem.controller('lbaPerDiemGridItemCtrl', __webpack_require__(381));
	lbaPerDiemGridItem.directive('lbaPerDiemGridItem', __webpack_require__(383));
	lbaPerDiemGridItem.service('perDiemService', __webpack_require__(379));
	
	exports['default'] = lbaPerDiemGridItem;
	module.exports = exports['default'];

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _configFieldsPerDiem = __webpack_require__(382);
	
	var _configFieldsPerDiem2 = _interopRequireDefault(_configFieldsPerDiem);
	
	var $inject = ['$q', 'dataService', 'perDiemService', '$timeout', '$rootScope', '$scope', '$http', '$window', '$location'];
	
	var lbaPerDiemGridItemCtrl = function lbaPerDiemGridItemCtrl($q, dataService, perDiemService, $timeout, $rootScope, $scope, $http, $window, $location) {
	  var vm = this;
	  vm.hasError = false;
	  vm.addNewMode = false;
	  vm.copyNode = false;
	  vm.deleteConfirm = false;
	  vm.cancelConfirm = false;
	
	  vm.returnToGrid = returnToGrid;
	  vm.savePerDiem = savePerDiem;
	  vm.deletePerDiem = deletePerDiem;
	  vm.openEffectiveDate = openEffectiveDate;
	  vm.openExpirationDate = openExpirationDate;
	
	  vm.dateFormat = 'MM/dd/yyyy';
	  var today = new Date();
	  vm.placeholder = today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear();
	
	  vm.status = {
	    openedEffectiveDate: false,
	    openedExpirationDate: false,
	    perDiemGridStatus: perDiemService.perDiemGridStatus
	  };
	
	  vm.dateOptions = {
	    formatYear: 'yy',
	    startingDay: 0,
	    showWeeks: false
	  };
	
	  if (!vm.status.perDiemGridStatus) vm.status.perDiemGridStatus = window.localStorage['perDiemGridStatus'];
	
	  if (vm.status.perDiemGridStatus == "edit" || vm.status.perDiemGridStatus == "copy") {
	    if (perDiemService.perDiemGridItem) {
	      vm.row = perDiemService.perDiemGridItem;
	    } else {
	      var lsPerDiemGridItem = window.localStorage['perDiemGridItem'];
	      if (lsPerDiemGridItem) {
	        vm.row = angular.fromJson(lsPerDiemGridItem);
	      } else {
	        returnToGrid();
	      }
	    }
	
	    if (vm.status.perDiemGridStatus == "copy") vm.copyNode = true;
	  } else if (vm.status.perDiemGridStatus == "add") {
	    vm.addNewMode = true;
	  }
	
	  if (!vm.row) vm.row = { Source: "ContinentalUS" };
	
	  function openEffectiveDate() {
	    vm.status.openedEffectiveDate = true;
	  }
	
	  function openExpirationDate() {
	    vm.status.openedExpirationDate = true;
	  }
	
	  function returnToGrid() {
	    $location.path("/per-diem");
	  }
	
	  function savePerDiem() {
	    vm.saving = true;
	    vm.messages = "";
	
	    $rootScope.$broadcast('lbaToast:showToast', { message: 'Saving per diem...', messageType: 'waiting' });
	
	    if (!vm.row.LodgingPerDiem) vm.row.LodgingPerDiem = 0;
	    if (!vm.row.SeasonStartMonth) vm.row.SeasonStartMonth = 0;
	    if (!vm.row.SeasonStartDay) vm.row.SeasonStartDay = 0;
	    if (!vm.row.SeasonEndMonth) vm.row.SeasonEndMonth = 0;
	    if (!vm.row.SeasonEndDay) vm.row.SeasonEndDay = 0;
	
	    var perDiem = vm.row;
	    if (vm.status.perDiemGridStatus == "copy") perDiem.id = null;
	
	    perDiemService.save(perDiem, function (response, status, headers) {
	      if (response.Success) {
	        vm.hasError = false;
	        vm.addNewMode = false;
	        vm.copyNode = false;
	
	        $rootScope.$broadcast('lbaToast:showToast', { message: 'Per diem has been saved.', messageType: 'success' });
	        vm.row = response.PerDiems[0];
	        vm.status.perDiemGridStatus = "edit";
	        window.localStorage['perDiemGridItem'] = JSON.stringify(vm.row);
	        window.localStorage['perDiemGridStatus'] = "edit";
	      } else {
	        vm.hasError = true;
	        $rootScope.$broadcast('lbaToast:showToast', { message: 'There are errors.', messageType: 'error' });
	
	        if (response.Message) vm.messages = response.Message;else vm.messages = response.Messages.join("\n");
	
	        window.scrollTo(0, 0);
	      }
	
	      vm.saving = false;
	    }, function (response, status) {
	      vm.hasError = true;
	      $rootScope.$broadcast('lbaToast:showToast', { message: 'There are errors.', messageType: 'error' });
	
	      if (response.Message) vm.messages = response.Message;else vm.messages = response.Messages.join("\n");
	
	      window.scrollTo(0, 0);
	      vm.saving = false;
	    });
	  }
	
	  function deletePerDiem() {
	    var url = endPointUrl + '/api/PerDiem/Delete';
	
	    var perDiem = vm.row;
	    perDiemService.deletePerDiem(perDiem, function (response, status, headers) {
	      vm.hasError = false;
	      returnToGrid();
	      $rootScope.$broadcast('lbaToast:showToast', { message: 'Per diem has been deleted.', messageType: 'success' });
	    }, function (response, status) {
	      vm.hasError = true;
	      $rootScope.$broadcast('lbaToast:showToast', { message: 'There are errors.', messageType: 'error' });
	
	      if (response.Message) {
	        vm.messages = response.Message;
	      } else {
	        vm.messages = response.Messages.join("\n");
	      }
	
	      window.scrollTo(0, 0);
	      vm.saving = false;
	    });
	  }
	};
	
	lbaPerDiemGridItemCtrl.$inject = $inject;
	
	exports['default'] = lbaPerDiemGridItemCtrl;
	module.exports = exports['default'];

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var PerDiemManager = {
	  rootNode: true,
	  displayName: 'Per Diem',
	  iconClass: 'fa-pin',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.PER_DIEM
	};
	
	var PerDiemGridItem = {
	  displayName: 'Per Diem Grid Item',
	  iconClass: 'fa-pin',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.PER_DIEM_GRID_ITEM
	};
	
	var PerDiemFileUploader = {
	  rootNode: true,
	  displayName: 'Per Diem File Uploader',
	  iconClass: 'fa-pin',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.PER_DIEM_FILE_UPLOADER
	};
	
	exports['default'] = {
	  PerDiemManager: PerDiemManager,
	  PerDiemGridItem: PerDiemGridItem,
	  PerDiemFileUploader: PerDiemFileUploader
	};
	module.exports = exports['default'];

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(384);
	var $inject = [];
	var lbaPerDiemGridItem = function lbaPerDiemGridItem() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaPerDiemGridItemCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(386)
	  };
	};
	
	lbaPerDiemGridItem.$inject = $inject;
	
	exports['default'] = lbaPerDiemGridItem;
	module.exports = exports['default'];

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(385);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaPerDiemGridItem.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaPerDiemGridItem.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".lbaPerDiemGridItem_logs label{color:#d9534f}.lbaPerDiemGridItem_logs textarea{height:300px;width:100%;overflow-y:scroll;border-color:#d9534f}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaPerdiemGridItem/src/components/lbaPerdiemGridItem/lbaPerDiemGridItem.scss"],"names":[],"mappings":"AAEA,+BAEQ,aAAc,CAFtB,kCAMQ,aACA,WACA,kBACA,oBAAqB,CACxB","file":"lbaPerDiemGridItem.scss","sourcesContent":["@import '../lbaPerdiemGridItem/helpers';\r\n\r\n.lbaPerDiemGridItem_logs {\r\n    label {\r\n        color: #d9534f;\r\n    }\r\n\r\n    textarea {\r\n        height: 300px;\r\n        width: 100%;\r\n        overflow-y: scroll;\r\n        border-color: #d9534f;\r\n    }\r\n  }"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 386 */
/***/ function(module, exports) {

	var v1="<div class=\"perDiem\"> <div class=\"lbaContainer_nav\"> <ul class=\"nav nav-pills nav-stacked lbaSubNav\"> <li> <a href=\"#/per-diem\">Per Diem Data</a> </li> <li> <a href=\"#/per-diem/file-upload\">File Upload</a> </li> </ul> </div> <div class=\"lbaContainer_fields\"> <div class=\"lbaPerDiemGridItem_logs\" ng-if=\"vm.messages\"> <label>Logs</label> <textarea id=\"PerDiemGridItemLogs\" disabled=\"disabled\">{{ vm.messages }}</textarea> </div> <div class=\"form-group\" ng-if=\"!vm.addNewMode && !vm.copyNode\"> <label>Id</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.row.id\" disabled=\"disabled\"> </div> <div class=\"form-group\" ng-if=\"!vm.addNewMode && !vm.copyNode\"> <label>Created By</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.row.CreatedBy\" disabled=\"disabled\"> </div> <div class=\"form-group\" ng-if=\"!vm.addNewMode && !vm.copyNode\"> <label>Created On</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.row.CreatedOn\" disabled=\"disabled\"> </div> <div class=\"form-group\" ng-if=\"!vm.addNewMode && !vm.copyNode\"> <label>Modified By</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.row.ModifiedBy\" disabled=\"disabled\"> </div> <div class=\"form-group\" ng-if=\"!vm.addNewMode && !vm.copyNode\"> <label>Modified On</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.row.ModifiedOn\" disabled=\"disabled\"> </div> <div class=\"form-group\"> <label>Source</label> <div class=\"lbaPerDiemGridItem_options\"> <select class=\"form-control\" ng-disabled=\"vm.saving\" ng-model=\"vm.row.Source\"> <option value=\"ContinentalUS\" ng-selected=\"vm.row.Source == 'ContinentalUS'\">GSA - (CONUS) Continental U.S.</option> <option value=\"OCONUS\" ng-selected=\"vm.row.Source == 'OCONUS'\">Defense Department - (OCONUS) Alaska, Hawaii, U.S. possessions including Puerto Rico</option> <option value=\"Foreign\" ng-selected=\"vm.row.Source == 'Foreign'\">State Department - (Foreign) All foreign destination</option> </select> </div> </div> <div class=\"form-group\"> <label>Lodging Per Diem</label> <input type=\"number\" class=\"form-control\" min=\"0\" ng-disabled=\"vm.saving\" ng-model=\"vm.row.LodgingPerDiem\"> </div> <div class=\"form-group\"> <label>Country Code</label> <input type=\"text\" class=\"form-control\" ng-disabled=\"!vm.addNewMode && !vm.copyNode\" ng-model=\"vm.row.CountryCode\"> </div> <div class=\"form-group\"> <label>City</label> <input type=\"text\" class=\"form-control\" ng-disabled=\"vm.saving\" ng-model=\"vm.row.City\"> </div> <div class=\"form-group\"> <label>Destination Name</label> <input type=\"text\" class=\"form-control\" ng-disabled=\"vm.saving\" ng-model=\"vm.row.DestinationName\"> </div> <div class=\"form-group\"> <label>County</label> <input type=\"text\" class=\"form-control\" ng-disabled=\"vm.saving\" ng-model=\"vm.row.County\"> </div> <div class=\"form-group\"> <label>State</label> <input type=\"text\" class=\"form-control\" ng-disabled=\"vm.saving\" ng-model=\"vm.row.State\"> </div> <div class=\"form-group\"> <label>Postal Code</label> <input type=\"text\" class=\"form-control\" ng-disabled=\"vm.saving\" ng-model=\"vm.row.PostalCode\"> </div> <div class=\"form-group\"> <label>Effective Date</label> <div class=\"lbaPerDiemGridItem_datePicker\"> <div class=\"form-group\"> <p class=\"input-group\"> <input type=\"text\" class=\"form-control\" id=\"PerDiemFileUploaderExpirationDate\" placeholder=\"{{ vm.row.EffectiveDate }}\" value=\"{{ vm.row.EffectiveDate }}\" ng-disabled=\"true\" uib-datepicker-popup=\"{{ vm.dateFormat }}\" is-open=\"vm.status.openedEffectiveDate\" datepicker-options=\"vm.dateOptions\" close-text=\"Close\" ng-disabled=\"vm.saving\" ng-model=\"vm.row.EffectiveDate\"/>\n<span class=\"input-group-btn\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openEffectiveDate()\" ng-disabled=\"vm.saving\"><i class=\"glyphicon glyphicon-calendar\"></i></button> </span> </p> <small>Change the date using the calendar button.</small> <p class=\"help-block\">{{ vm.config.helpText }}</p> </div> </div> </div> <div class=\"form-group\"> <label>Expiration Date</label> <div class=\"lbaPerDiemGridItem_datePicker\"> <div class=\"form-group\"> <p class=\"input-group\"> <input type=\"text\" class=\"form-control\" id=\"PerDiemFileUploaderExpirationDate\" placeholder=\"{{ vm.row.ExpirationDate }}\" value=\"{{ vm.row.ExpirationDate }}\" ng-disabled=\"true\" uib-datepicker-popup=\"{{ vm.dateFormat }}\" is-open=\"vm.status.openedExpirationDate\" datepicker-options=\"vm.dateOptions\" close-text=\"Close\" ng-disabled=\"vm.saving\" ng-model=\"vm.row.ExpirationDate\"/>\n<span class=\"input-group-btn\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openExpirationDate()\" ng-disabled=\"vm.saving\"><i class=\"glyphicon glyphicon-calendar\"></i></button> </span> </p> <small>Change the date using the calendar button.</small> <p class=\"help-block\">{{ vm.config.helpText }}</p> </div> </div> </div> <div class=\"form-group\"> <label>Season Start Month</label> <input type=\"number\" class=\"form-control\" min=\"1\" max=\"12\" ng-disabled=\"vm.saving\" ng-model=\"vm.row.SeasonStartMonth\"> </div> <div class=\"form-group\"> <label>Season Start Day</label> <input type=\"number\" class=\"form-control\" min=\"1\" max=\"31\" ng-disabled=\"vm.saving\" ng-model=\"vm.row.SeasonStartDay\"> </div> <div class=\"form-group\"> <label>Season End Month</label> <input type=\"number\" class=\"form-control\" min=\"1\" max=\"12\" ng-disabled=\"vm.saving\" ng-model=\"vm.row.SeasonEndMonth\"> </div> <div class=\"form-group\"> <label>Season End Day</label> <input type=\"number\" class=\"form-control\" min=\"1\" max=\"31\" ng-disabled=\"vm.saving\" ng-model=\"vm.row.SeasonEndDay\"> </div> <div class=\"form-group\"> <label>Notes</label> <input type=\"text\" class=\"form-control\" ng-disabled=\"vm.saving\" ng-model=\"vm.row.Notes\"> </div> </div> </div> <div class=\"deleteRecord\"> <button class=\"btn btn-link\" ng-if=\"!vm.deleteConfirm && !vm.addNewMode && !vm.copyNode\" ng-click=\"vm.deleteConfirm = true\"> <i class=\"glyphicon glyphicon-trash\"></i> Delete </button> <div ng-if=\"vm.deleteConfirm\" class=\"confirmDelete\"> <span>Are you sure?</span>\n<button class=\"btn btn-danger\" ng-click=\"vm.deletePerDiem()\">Yes</button>\n<button class=\"btn btn-link\" ng-click=\"vm.deleteConfirm = false\">Cancel</button> </div> </div> <div class=\"save ng-scope\"> <div class=\"wrapper clearfix\"> <button type=\"button\" class=\"btn btn-lightning\" ng-click=\"vm.savePerDiem()\" ng-disabled=\"vm.disable\" ng-if=\"!vm.cancelConfirm\"> {{ vm.addNewMode || vm.copyNode ? \"Add New\" : \"Save\" }} </button>\n<button type=\"button\" class=\"btn btn-default\" ng-hide=\"vm.cancelConfirm\" ng-click=\"vm.cancelConfirm = true\" ng-disabled=\"vm.disable\">Cancel</button> <div ng-if=\"vm.cancelConfirm\"> <p style=\"text-align: right\">Are you sure you want to cancel all changes since the last save?</p> <button class=\"btn btn-danger\" ng-click=\"vm.returnToGrid()\">Yes</button>\n<button class=\"btn btn-default\" ng-click=\"vm.cancelConfirm = false\">No</button> </div> </div> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaPerDiemGridItem.html", v1)}]);
	module.exports=v1;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var lbaPerDiemFileUploader = angular.module('app.lbaPerDiemFileUploader', [__webpack_require__(388).name]);
	
	lbaPerDiemFileUploader.controller('lbaPerDiemFileUploaderCtrl', __webpack_require__(392));
	lbaPerDiemFileUploader.directive('lbaPerDiemFileUploader', __webpack_require__(395));
	lbaPerDiemFileUploader.service('perDiemService', __webpack_require__(379));
	
	exports['default'] = lbaPerDiemFileUploader;
	module.exports = exports['default'];

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaDate = angular.module('app.lbaDate', []);
	
	lbaDate.controller('lbaDateCtrl', __webpack_require__(389));
	lbaDate.directive('lbaDate', __webpack_require__(390));
	
	exports['default'] = lbaDate;
	module.exports = exports['default'];

/***/ },
/* 389 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$rootScope', '$scope', '$routeParams', '$timeout', 'dataService'];
	
	var lbaDateCtrl = function lbaDateCtrl($rootScope, $scope, $routeParams, $timeout, dataService) {
	  var vm = this;
	
	  var dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
	  var minDateLookup = [];
	  var maxDateLookup = [];
	
	  if (vm.settings.minDateAt) {
	    minDateLookup = dataService.spiltDataAt(vm.settings.minDateAt, $routeParams);
	  } else if (vm.settings.maxDateAt) {
	    maxDateLookup = dataService.spiltDataAt(vm.settings.maxDateAt, $routeParams);
	  }
	
	  vm.data = _.get(dataService.data.activeItem, dataLookUp);
	
	  vm.open = open;
	
	  vm.dateFormat = 'yyyy-MM-dd';
	
	  vm.status = {
	    opened: !!vm.settings.showDatePickerOpened
	  };
	
	  vm.dateOptions = {
	    formatYear: vm.settings.formatYear || 'yy',
	    startingDay: vm.settings.startingDay || 0,
	    showWeeks: !!vm.settings.showWeeks
	  };
	
	  function open() {
	    if (vm.settings.minDateAt) {
	      vm.minDate = _.get(dataService.data.activeItem, minDateLookup);
	    } else if (vm.settings.maxDateAt) {
	      vm.maxDate = _.get(dataService.data.activeItem, maxDateLookup);
	    }
	    vm.status.opened = true;
	  }
	
	  $scope.$watchCollection('vm.data', function (newData, oldData) {
	    if (newData !== oldData) {
	      var selectedDate = vm.settings.returnAsString ? newData.toLocaleString('sv').split(" ")[0] : newData;
	      _.set(dataService.data.activeItem, dataLookUp, selectedDate);
	    }
	  });
	
	  $rootScope.$on(vm.settings.dataAt, function () {
	    $timeout(function () {
	      vm.data = _.get(dataService.data.activeItem, dataLookUp);
	    });
	  });
	};
	
	lbaDateCtrl.$inject = $inject;
	
	exports['default'] = lbaDateCtrl;
	module.exports = exports['default'];

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	var lbaDate = function lbaDate() {
	  return {
	    restrict: 'A',
	    scope: {
	      saveTo: '=saveTo',
	      slice: '=slice',
	      index: '=index',
	      lookUp: '=lookUp',
	      settings: '=settings'
	    },
	    bindToController: true,
	    controller: 'lbaDateCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(391)
	  };
	};
	
	lbaDate.$inject = $inject;
	
	exports['default'] = lbaDate;
	module.exports = exports['default'];

/***/ },
/* 391 */
/***/ function(module, exports) {

	var v1="<div class=\"form-group\"> <label for=\"{{ vm.settings.dataAt }}\">{{ vm.settings.displayName }}</label> <p class=\"input-group\"> <input type=\"text\" class=\"form-control\" id=\"{{ vm.settings.dataAt }}\" name=\"{{ vm.settings.dataAt }}\" placeholder=\"{{ vm.settings.placeholderText }}\" ng-disabled=\"vm.settings.disabled\" ng-required=\"vm.settings.required\" ng-model=\"vm.data\" min-date=\"vm.minDate\" max-date=\"vm.maxDate\" uib-datepicker-popup=\"{{ vm.dateFormat }}\" is-open=\"vm.status.opened\" datepicker-options=\"vm.dateOptions\" close-text=\"Close\"/>\n<span class=\"input-group-btn\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.open($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button> </span> </p> <p class=\"help-block\">{{ vm.settings.helpText }}</p> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaDate.html", v1)}]);
	module.exports=v1;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(136);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(393);
	__webpack_require__(141);
	
	var $inject = ['$q', 'dataService', 'perDiemService', 'Upload', '$timeout', '$rootScope', '$scope', '$http'];
	
	var lbaPerDiemFileUploaderCtrl = function lbaPerDiemFileUploaderCtrl($q, dataService, perDiemService, Upload, $timeout, $rootScope, $scope, $http) {
	  var vm = this;
	
	  vm.messages = "";
	  vm.hasError = false;
	  vm.saving = false;
	  vm.open = open;
	
	  vm.dateFormat = 'MM/dd/yyyy';
	  var today = new Date();
	  vm.placeholder = today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear();
	
	  vm.status = {
	    opened: false
	  };
	
	  vm.dateOptions = {
	    formatYear: 'yy',
	    startingDay: 0,
	    showWeeks: false
	  };
	
	  function open() {
	    vm.status.opened = true;
	  }
	
	  function getResponseMessage(response) {
	    var data = response && response.data;
	    var messages = [];
	
	    if (!data) {
	      return 'The file upload failed.';
	    }
	
	    if (typeof data === 'string') {
	      return data;
	    }
	
	    if (Array.isArray(data.Messages)) {
	      messages = data.Messages.filter(function (message) {
	        return message;
	      });
	    }
	
	    if (Array.isArray(data.Errors)) {
	      messages = messages.concat(data.Errors.map(function (error) {
	        return error && error.Message ? error.Message : error;
	      }));
	    }
	
	    if (data.Message && messages.indexOf(data.Message) === -1) {
	      messages.push(data.Message);
	    }
	
	    if (messages.length) {
	      return messages.join("\n");
	    }
	
	    return 'The file upload failed.';
	  }
	
	  vm.upload = function (file) {
	    if (!file) {
	      return false;
	    }
	
	    vm.saving = true;
	    vm.messages = "";
	
	    $rootScope.$broadcast('lbaToast:showToast', { message: 'Uploading data...', messageType: 'waiting' });
	
	    var source = document.getElementById("PerDiemFileUploaderSource").value;
	    var expirationDate = document.getElementById("PerDiemFileUploaderExpirationDate").value;
	
	    if (!expirationDate) {
	      expirationDate = vm.placeholder;
	    }
	
	    Upload.upload({
	      url: endPointUrl + '/api/PerDiem/Upload?filename=' + file.name + '&source=' + source + '&expirationDate=' + expirationDate,
	      data: {
	        file: file
	      }
	    }).then(function (response) {
	      vm.saving = false;
	
	      if (response.data.Success) {
	        vm.hasError = false;
	        $rootScope.$broadcast('lbaToast:showToast', { message: 'File has been uploaded.', messageType: 'success' });
	      } else {
	        vm.hasError = true;
	        $rootScope.$broadcast('lbaToast:showToast', { message: 'There are errors.', messageType: 'error' });
	      }
	
	      vm.messages = getResponseMessage(response);
	    }, function (response) {
	      vm.hasError = true;
	      vm.saving = false;
	
	      vm.messages = getResponseMessage(response);
	      $rootScope.$broadcast('lbaToast:showToast', { message: vm.messages, messageType: 'error' });
	    });
	  };
	};
	
	lbaPerDiemFileUploaderCtrl.$inject = $inject;
	
	exports['default'] = lbaPerDiemFileUploaderCtrl;
	module.exports = exports['default'];

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(394);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaPerDiemFileUploader.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaPerDiemFileUploader.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".lbaPerDiemFileUploader_button,.lbaPerDiemFileUploader_expirationDate,.lbaPerDiemFileUploader_options,.lbaPerDiemFileUploader_status,.lbaPerDiemFileUploader_upload-status{margin-bottom:15px}.lbaPerDiemFileUploader_upload-status{align-items:center;display:flex;gap:8px}.lbaPerDiemFileUploader_status div{padding:10px}.lbaPerDiemFileUploader_status .lbaPerDiemFileUploader_status-success{background-color:#67c067;color:#fff}.lbaPerDiemFileUploader_status .lbaPerDiemFileUploader_status-error{background-color:#de5e59;color:#fff}.lbaPerDiemFileUploader_logs textarea{height:300px;width:100%;overflow-y:scroll}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaPerDiemFileUploader/src/components/lbaPerDiemFileUploader/lbaPerDiemFileUploader.scss"],"names":[],"mappings":"AAAA,2KAKE,kBAAmB,CACpB,sCAGC,mBACA,aACA,OAAQ,CACT,mCAIG,YAAa,CAFjB,sEAMI,yBACA,UAAY,CAPhB,oEAWI,yBACA,UAAY,CACb,sCAKC,aACA,WACA,iBAAkB,CACnB","file":"lbaPerDiemFileUploader.scss","sourcesContent":[".lbaPerDiemFileUploader_options, \r\n.lbaPerDiemFileUploader_expirationDate,\r\n.lbaPerDiemFileUploader_button,\r\n.lbaPerDiemFileUploader_upload-status,\r\n.lbaPerDiemFileUploader_status {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.lbaPerDiemFileUploader_upload-status {\r\n  align-items: center;\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.lbaPerDiemFileUploader_status {\r\n  div {\r\n    padding: 10px;\r\n  }\r\n\r\n  .lbaPerDiemFileUploader_status-success {\r\n    background-color: #67c067;\r\n    color: white;\r\n  }\r\n\r\n  .lbaPerDiemFileUploader_status-error {\r\n    background-color: #de5e59;\r\n    color: white;\r\n  }\r\n}\r\n\r\n.lbaPerDiemFileUploader_logs {\r\n  textarea {\r\n    height: 300px;\r\n    width: 100%;\r\n    overflow-y: scroll;\r\n  }\r\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(393);
	var $inject = [];
	var lbaPerDiemFileUploader = function lbaPerDiemFileUploader() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaPerDiemFileUploaderCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(396)
	  };
	};
	
	lbaPerDiemFileUploader.$inject = $inject;
	
	exports['default'] = lbaPerDiemFileUploader;
	module.exports = exports['default'];

/***/ },
/* 396 */
/***/ function(module, exports) {

	var v1="<div class=\"perDiem\"> <div class=\"lbaContainer_nav\"> <ul class=\"nav nav-pills nav-stacked lbaSubNav\"> <li> <a href=\"#/per-diem/\" class=\"ng-binding\" ng-click=\"vm.setActiveTab('data')\">Per Diem Data</a> </li> <li> <a href=\"\" class=\"ng-binding\" ng-click=\"vm.setActiveTab('upload')\">File Upload</a> </li> </ul> </div> <div class=\"lbaContainer_fields\"> <div class=\"form-group\"> <label>Source of File</label> <div class=\"lbaPerDiemFileUploader_options\"> <select class=\"form-control\" id=\"PerDiemFileUploaderSource\" ng-disabled=\"vm.saving\"> <option value=\"ContinentalUS\">GSA - (CONUS) Continental U.S.</option> <option value=\"OCONUS\">Defense Department - (OCONUS) Alaska, Hawaii, U.S. possessions including Puerto Rico </option> <option value=\"Foreign\">State Department - (Foreign) All foreign destination</option> </select> </div> <label>Expiration Date</label> <div class=\"lbaPerDiemFileUploader_expirationDate\"> <div class=\"form-group\"> <p class=\"input-group\"> <input type=\"text\" class=\"form-control\" id=\"PerDiemFileUploaderExpirationDate\" placeholder=\"{{vm.placeholder}}\" value=\"{{vm.placeholderText}}\" ng-disabled=\"true\" ng-model=\"vm.model\" uib-datepicker-popup=\"{{ vm.dateFormat }}\" is-open=\"vm.status.opened\" datepicker-options=\"vm.dateOptions\" close-text=\"Close\"/>\n<span class=\"input-group-btn\"> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.open($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button> </span> </p> <small>Change the date using the calendar button.</small> <p class=\"help-block\">{{ vm.config.helpText }}</p> </div> </div> <label>Per Diem File Upload</label> <div class=\"lbaPerDiemFileUploader_button input-group\"> <input class=\"form-control\" ng-model=\"vm.data\" type=\"text\" disabled=\"disabled\" ng-if=\"vm.data.length > 0\">\n<input class=\"form-control\" ng-model=\"vm.filename\" type=\"text\" disabled=\"disabled\" ng-if=\"vm.settings.exclude && vm.filename\"> <div> <div class=\"input-group-btn\"> <button class=\"btn btn-default\" type=\"button\" ngf-select=\"vm.upload($file)\" ng-disabled=\"vm.saving\"> Choose file</button> </div> </div> <div> <small>.xls files only. If the file is a .xlsx, convert the file to a .xls.</small> </div> </div> <div class=\"lbaPerDiemFileUploader_upload-status\" ng-if=\"vm.saving\" role=\"status\" aria-live=\"polite\"> <i class=\"fa fa-spinner fa-spin\" aria-hidden=\"true\"></i>\n<span>Uploading file and processing data...</span> </div> <div class=\"lbaPerDiemFileUploader_status\" ng-if=\"vm.messages\"> <div class=\"lbaPerDiemFileUploader_status-success\" ng-if=\"!vm.hasError\"> Upload was successful. </div> <div class=\"lbaPerDiemFileUploader_status-error\" ng-if=\"vm.hasError\"> Upload failed. </div> </div> <div class=\"lbaPerDiemFileUploader_logs\" ng-if=\"vm.messages\"> <label>Logs</label> <textarea id=\"PerDiemFileUploaderLogs\" disabled=\"disabled\">{{ vm.messages }}</textarea> </div> </div> </div> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaPerDiemFileUploader.html", v1)}]);
	module.exports=v1;

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaTestFtpConnection = angular.module('app.lbaTestFtpConnection', []);
	
	lbaTestFtpConnection.controller('lbaTestFtpConnectionCtrl', __webpack_require__(398));
	lbaTestFtpConnection.directive('lbaTestFtpConnection', __webpack_require__(399));
	
	exports['default'] = lbaTestFtpConnection;
	module.exports = exports['default'];

/***/ },
/* 398 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$http', 'dataService'];
	
	var lbaTestFtpConnectionCtrl = function lbaTestFtpConnectionCtrl($http, dataService) {
	  var vm = this;
	  vm.errorMessage = '';
	
	  function createRequest() {
	    var data = dataService.data.activeItem;
	    return {
	      CompanyReferenceConfigId: data.Id,
	      FtpHost: data.FtpHost,
	      FtpPort: data.FtpPort,
	      FtpUserName: data.FtpUserName,
	      FtpPassword: data.FtpPassword,
	      IsSFtp: data.IsSFtp,
	      FileName: data.FileName,
	      FilePath: data.FilePath
	    };
	  }
	
	  vm.onClick = function () {
	    vm.errorMessage = ' Testing Connection...';
	    var endPointController = vm.settings.endPointController;
	    var url = endPointUrl + '/' + endPointController;
	
	    var request = createRequest();
	    $http.post(url, request).success(function (response, status, headers) {
	      var connected = response.CanConnect;
	      if (!connected) {
	        vm.errorMessage = response.ErrorMessage;
	        return;
	      }
	      vm.errorMessage = 'Successfully Connected';
	      if (response.FileExist === false) {
	        vm.errorMessage += ', File not found';
	      } else if (response.FileExist === true) {
	        vm.errorMessage += ', File found';
	      }
	    }).error(function (data, status) {
	      vm.errorMessage = 'An error occurred when calling the url ' + url + '.  Return code: ' + status;
	    });
	  };
	};
	
	lbaTestFtpConnectionCtrl.$inject = $inject;
	
	exports['default'] = lbaTestFtpConnectionCtrl;
	module.exports = exports['default'];

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = [];
	var lbaTestFtpConnection = function lbaTestFtpConnection() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '<'
	    },
	    bindToController: true,
	    controller: 'lbaTestFtpConnectionCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(400)
	  };
	};
	
	lbaTestFtpConnection.$inject = $inject;
	
	exports['default'] = lbaTestFtpConnection;
	module.exports = exports['default'];

/***/ },
/* 400 */
/***/ function(module, exports) {

	var v1="<div class=\"form-group\"> <div class=\"input-group\"> <button type=\"submit\" class=\"btn btn-default\" ng-click=\"vm.onClick()\">Test Ftp Connection</button> <label id=\"errorMessage\">{{vm.errorMessage}}</label> </div> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaTestFtpConnection.html", v1)}]);
	module.exports=v1;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaPagingGrid = angular.module('app.lbaPagingGrid', ['ngTasty']);
	
	lbaPagingGrid.controller('lbaPagingGridCtrl', __webpack_require__(402));
	lbaPagingGrid.controller('lbaDeleteConfirmCtrl', __webpack_require__(403));
	lbaPagingGrid.directive('lbaPagingGrid', __webpack_require__(404));
	
	lbaPagingGrid.filter("dateDisplay", __webpack_require__(408));
	exports['default'] = lbaPagingGrid;
	module.exports = exports['default'];

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _configConstants = __webpack_require__(147);
	
	var _configConstants2 = _interopRequireDefault(_configConstants);
	
	var $inject = ['$location', '$scope', '$timeout', '$routeParams', '$http', 'dataService', 'dataSourceService', 'microApiService', 'settingsService', '$q'];
	
	var lbaPagingGridCtrl = function lbaPagingGridCtrl($location, $scope, $timeout, $routeParams, $http, dataService, dataSourceService, microApiService, settingsService, $q) {
	  var vm = this;
	
	  vm.settings.paginationPageSizes = [25, 50, 100];
	  vm.settings.paginationPageSize = 100;
	  vm.settings.pageNumber = 1;
	
	  vm.dataService = dataService;
	  vm.ready = false;
	  vm.canAdd = vm.settings.hasOwnProperty('gridAdd');
	  vm.addNew = addNew;
	  vm.refreshGrid = refreshGrid;
	  vm.settingsService = settingsService;
	  vm.filteredColumn = vm.settings.defaultFilteredColumn;
	  vm.filters = '';
	  vm.gridSort = vm.settings.defaultSort;
	
	  initializeBackPage();
	
	  vm.isShowingDisabled = false;
	
	  dataSourceService.dataSource = _configConstants2['default'].DATA_SOURCES.ODATA;
	  dataService.data.activeItem = undefined;
	  dataService.data.gotoNext = gotoNext;
	
	  // Get Data after delayInMs
	  var delayInMs = 500;
	  var timeoutPromise = undefined;
	  $scope.$watch("vm.filters", function () {
	    $timeout.cancel(timeoutPromise); //does nothing, if timeout already done
	    timeoutPromise = $timeout(function () {
	      //Set timeout
	      getData(vm.filters);
	    }, delayInMs);
	  });
	  $scope.$watch("vm.filteredColumn", function () {
	    $timeout.cancel(timeoutPromise); //does nothing, if timeout already done
	    timeoutPromise = $timeout(function () {
	      //Set timeout
	      getData(vm.filters);
	    }, delayInMs);
	  });
	
	  var getData = function getData() {
	    var searchText = arguments.length <= 0 || arguments[0] === undefined ? "" : arguments[0];
	
	    var deferred = $q.defer();
	    var url = endPointUrl + '/api/' + vm.settings.endpoint;
	    var postData = {
	      pageSize: vm.settings.paginationPageSize,
	      pageNumber: vm.settings.pageNumber - 1,
	      searchText: searchText.toLowerCase(),
	      searchType: vm.filteredColumn,
	      sort: vm.gridSort
	    };
	    var settings = {};
	    vm.searching = true;
	    $http.post(url, postData, settings).success(function (data) {
	      vm.dataService.data.items = data.Results;
	      vm.globalData = data.Results;
	
	      $scope.pagingGrid.data = data.Results;
	      $scope.pagingGrid.totalItems = data.TotalCount;
	
	      vm.ready = true;
	      vm.searching = false;
	      var currentRowIndex = getCurrentIndex();
	      dataService.data.hasNext = getNextRow(currentRowIndex + 1) != null;
	      dataService.data.hasPrevious = getNextRow(currentRowIndex - 1) != null;
	      deferred.resolve(data);
	    }).error(function (data, status) {
	      console.log('Return code: ' + status);
	      vm.searching = false;
	      deferred.reject(data);
	    });
	    return deferred.promise;
	  };
	  var gotoNext = function gotoNext(next) {
	
	    var currentRowIndex = getCurrentIndex();
	    var nextIndex = currentRowIndex + (next ? 1 : -1);
	    var row = getNextRow(nextIndex);
	    if (row) {
	      $scope.gridApi.selection.clearSelectedRows();
	      $scope.gridApi.selection.selectRow(row);
	      dataService.data.hasNext = getNextRow(nextIndex + 1) != null;
	      dataService.data.hasPrevious = getNextRow(nextIndex - 1) != null;
	    }
	  };
	  function getCurrentIndex() {
	    var currentRowIndex;
	    if (!$scope.gridApi || !$scope.gridApi.selection) {
	      return -1;
	    }
	    var selectedRows = $scope.gridApi.selection.getSelectedRows();
	    if (selectedRows.length < 1) {
	      // if nothing selected, we'll select the top row
	      currentRowIndex = -1;
	    } else {
	      // if there are multiple selected, we use the first one
	      var selectedRow = selectedRows[0];
	      var gridRow = $scope.gridApi.grid.getRow(selectedRow);
	      currentRowIndex = $scope.gridApi.grid.renderContainers.body.visibleRowCache.indexOf(gridRow);
	    }
	    return currentRowIndex;
	  }
	  function getNextRow(nextIndex) {
	    if ($scope.gridApi && $scope.gridApi.grid && $scope.gridApi.grid.renderContainers && $scope.gridApi.grid.renderContainers.body && $scope.gridApi.grid.renderContainers.body.visibleRowCache && $scope.gridApi.grid.renderContainers.body.visibleRowCache[nextIndex]) {
	      return $scope.gridApi.grid.renderContainers.body.visibleRowCache[nextIndex].entity;
	    }
	    return null;
	  }
	
	  setupGrid();
	  function addCellTitles() {
	    if (!vm.settings.gridCols) return;
	    vm.settings.gridCols.filter(function (col) {
	      return !col.cellFilter && col.field;
	    }).forEach(function (col) {
	
	      col.cellTemplate = '<div class="ui-grid-cell-contents" title="{{row.entity.' + col.field + '}}">{{row.entity.' + col.field + '}}</div>';
	    });
	  }
	  function setupGrid() {
	    addCellTitles();
	    $scope.pagingGrid = {
	      columnDefs: vm.settings.gridCols,
	      paginationPageSizes: vm.settings.paginationPageSizes,
	      paginationPageSize: vm.settings.paginationPageSize,
	      paginationCurrentPage: vm.settings.pageNumber,
	      useExternalPagination: true,
	      useExternalSorting: true,
	      enableRowSelection: true,
	      enableRowHeaderSelection: false,
	      multiSelect: false,
	      noUnselect: true,
	      onRegisterApi: function onRegisterApi(gridApi) {
	        $scope.gridApi = gridApi;
	
	        gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
	          vm.settings.pageNumber = newPage;
	          vm.settings.paginationPageSize = pageSize;
	          getData(vm.filters);
	        });
	        gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
	          vm.gridSort = [];
	          if (sortColumns.length > 0) {
	            vm.gridSort = sortColumns.map(function (col) {
	              return {
	                "column": col.field,
	                "Order": col.sort.direction
	              };
	            });
	          }
	          getData(vm.filters);
	        });
	        gridApi.selection.on.rowSelectionChanged($scope, function (row) {
	          var rowIndex = 0;
	
	          // JLF: LOBT-700: undersore's findIndex was removed as it returned false positives
	          _.find(vm.dataService.data.items, function (item, index) {
	            if (item === row.entity) rowIndex = index;
	          });
	
	          if (vm.copyResourceMode) {
	            dataService.get(vm.settings.endpoint, row.entity.id).then(function (data) {
	              var duplicate = data;
	              duplicate.Name = duplicate.Name + ' COPY';
	              delete duplicate.Id;
	
	              vm.dataService.post(vm.settings.endpoint, duplicate, true).then(function (data) {
	                data.id = data.Id;
	                updatePath(data, rowIndex);
	              });
	            });
	
	            return;
	          }
	
	          dataService.backPath = $location.$$path;
	
	          updatePath(row.entity, rowIndex);
	        });
	      }
	    };
	
	    getData();
	  }
	  function refreshGrid() {
	    var currentIndex = getCurrentIndex();
	
	    getData(vm.filters).then(function (data) {
	
	      if ($scope.gridApi.grid.rows && $scope.gridApi.grid.rows.length > currentIndex) {
	        var gridRow = $scope.gridApi.grid.rows[currentIndex];
	        if (gridRow) {
	          updatePath(gridRow.entity, currentIndex);
	        }
	      }
	    });
	  }
	
	  function addNew() {
	    dataService.backPath = $location.$$path;
	
	    if (vm.settings.gridAdd) {
	      $location.path($location.$$path + '/add');
	    } else {
	      dataService.addNewMode = true;
	      // Create backup of complete data structure before adding empty item
	      dataService.addNewBackup = angular.copy(dataService.data);
	
	      if (vm.resource.rows) {
	        vm.resource.rows.push({});
	      } else {
	        vm.resource.rows = [{}];
	      }
	      updatePath({}, vm.resource.rows.length - 1);
	    }
	  }
	
	  function updatePath(data, index) {
	    setBackPage();
	
	    if (!vm.settings.gridItem) {
	      dataService.data.activeItem = data;
	      dataService.data.gotoNext = gotoNext;
	      return;
	    }
	
	    var displayNamePathReady = vm.settings.displayName.replace(/\s+/g, '-').toLowerCase();
	
	    var appendToPath = vm.settings.gridAdd || vm.settings.gridItem ? data.id : displayNamePathReady + '/' + index;
	    $location.path($location.$$path + '/' + appendToPath);
	  }
	
	  function initializeBackPage() {
	    if (dataService.backGridFilter != null && dataService.backGridFilter[vm.settings.displayName]) {
	      vm.filters = dataService.backGridFilter[vm.settings.displayName];
	    }
	
	    if (dataService.backGridPage != null && dataService.backGridPage[vm.settings.displayName]) {
	      vm.settings.pageNumber = dataService.backGridPage[vm.settings.displayName];
	    }
	    if (dataService.backGridSort != null && dataService.backGridSort[vm.settings.displayName]) {
	      vm.gridSort = dataService.backGridSort[vm.settings.displayName];
	    }
	
	    if (dataService.backGridPageSize != null && dataService.backGridPageSize[vm.settings.displayName]) {
	      vm.settings.paginationPageSize = dataService.backGridPageSize[vm.settings.displayName];
	    }
	  }
	  function setBackPage() {
	    if (!dataService.backGridFilter) dataService.backGridFilter = [];
	    dataService.backGridFilter[vm.settings.displayName] = vm.filters;
	
	    if (!dataService.backGridPage) dataService.backGridPage = [];
	    dataService.backGridPage[vm.settings.displayName] = vm.settings.pageNumber;
	
	    if (!dataService.backGridSort) dataService.backGridSort = [];
	    dataService.backGridSort[vm.settings.displayName] = vm.gridSort;
	
	    if (!dataService.backGridPageSize) dataService.backGridPageSize = [];
	    dataService.backGridPageSize[vm.settings.displayName] = vm.settings.paginationPageSize;
	  }
	};
	
	lbaPagingGridCtrl.$inject = $inject;
	
	exports['default'] = lbaPagingGridCtrl;
	module.exports = exports['default'];

/***/ },
/* 403 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$uibModalInstance', 'id'];
	
	var lbaDeleteConfirmCtrl = function lbaDeleteConfirmCtrl($uibModalInstance, id) {
	  var vm = this;
	
	  vm.id = id;
	
	  vm.ok = function () {
	    $uibModalInstance.close(vm.id);
	  };
	
	  vm.cancel = function () {
	    $uibModalInstance.dismiss('cancel');
	  };
	};
	
	lbaDeleteConfirmCtrl.$inject = $inject;
	
	exports['default'] = lbaDeleteConfirmCtrl;
	module.exports = exports['default'];

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(405);
	
	var $inject = [];
	
	var lbaPagingGrid = function lbaPagingGrid() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '='
	    },
	    bindToController: true,
	    controller: 'lbaPagingGridCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(407)
	  };
	};
	
	lbaPagingGrid.$inject = $inject;
	
	exports['default'] = lbaPagingGrid;
	module.exports = exports['default'];

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(406);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaPagingGrid.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaPagingGrid.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".ui-grid-pager-control input{width:auto}.ui-grid-pager-row-count-picker select{padding:0}.ui-dialog-content{overflow:scroll}.spinnerpanel{padding-right:1rem}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaPagingGrid/src/components/lbaPagingGrid/lbaPagingGrid.scss"],"names":[],"mappings":"AAAA,6BACI,UAAW,CACd,uCAGG,SAAY,CACf,mBAEG,eAAgB,CAEnB,cAEG,kBAAmB,CACtB","file":"lbaPagingGrid.scss","sourcesContent":[".ui-grid-pager-control input {\r\n    width: auto;\r\n}\r\n\r\n.ui-grid-pager-row-count-picker select {\r\n    padding: 0px;\r\n}\r\n.ui-dialog-content{\r\n    overflow: scroll;\r\n    \r\n}\r\n.spinnerpanel{\r\n    padding-right: 1rem;\r\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 407 */
/***/ function(module, exports) {

	var v1="<div ng-if=\"!vm.dataService.addNewMode\"> <label class=\"lbaGrid_name\" ng-if=\"vm.settings.displayName\">{{ vm.settings.displayName }} listing</label> <div class=\"lbaGrid\" ng-if=\"vm.ready\"> <div class=\"lbaGrid_tools clearfix\"> <div class=\"lbaGrid_add\"> <button ng-show=\"vm.settings.canAddNew || vm.settings.gridAdd\" ng-click=\"vm.addNew()\" class=\"btn btn-default\"><i class=\"fa fa-plus\"></i> Add new </button>\n<span ng-if=\"vm.dataService.data.items.length > 0\"> <button ng-show=\"vm.settings.canCopyResource\" ng-click=\"vm.copyResourceMode = !vm.copyResourceMode\" class=\"btn btn-default\" ng-class=\"{ 'btn_copyMode': vm.copyResourceMode }\"><i class=\"fa fa-files-o\"></i> Copy</button> </span> </div> <div class=\"input-group input-group-md lbaGrid_filter\"> <span ng-if=\"vm.searching\" class=\"spinnerpanel\"><i class=\"fa fa-spinner fa-spin\"></i></span>\n<span class=\"input-group-addon\" ng-click=\"vm.refreshGrid()\" title=\"Refresh\"><i class=\"glyphicon glyphicon-refresh\"></i></span>\n<span class=\"input-group-addon\"><i class=\"glyphicon glyphicon-search\"></i></span> <select ng-if=\"vm.settings.filterColumns\" class=\"form-control lbaGrid_filter\" ng-model=\"vm.filteredColumn\"> <option ng-selected=\"{{ vm.filteredColumn === (item.value ? item.value : item) }}\" ng-repeat=\"item in vm.settingsService.options[vm.settings.filterColumns]\" value=\"{{ item.value || item }}\"> {{ item.label || item }} </option> </select> <input ng-model=\"vm.filters\" type=\"text\" placeholder=\"Filter by...\" class=\"form-control lbaGrid_filter\"> </div> </div> <div ui-grid=\"pagingGrid\" ui-grid-pagination ui-grid-selection class=\"lbaGrid\"></div> <div id=\"pagingGridActiveItemParent\"> <div id=\"pagingGridActiveItemWindow\"> <div class=\"pagingGridActiveItem\" id=\"pagingGridActiveItem\" ng-if=\"vm.dataService.data.activeItem\"> <div ng-repeat=\"item in vm.settings.children track by $index\"> <div lba-dynamic=\"'lba-' + item.displayAs\" settings=\"item\"></div> </div> </div> </div> </div> </div> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaPagingGrid.html", v1)}]);
	module.exports=v1;

/***/ },
/* 408 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var $inject = ['moment'];
	
	var dateFilter = function dateFilter(moment) {
	    return function (value) {
	        if (!value) return value;
	        return moment(value).format('M/D/YYYY h:mm A');
	    };
	};
	
	dateFilter.$inject = $inject;
	
	exports['default'] = dateFilter;
	module.exports = exports['default'];

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaEnhancedLogItem = angular.module('app.lbaEnhancedLogItem', []);
	
	lbaEnhancedLogItem.controller('lbaEnhancedLogItemCtrl', __webpack_require__(410));
	lbaEnhancedLogItem.directive('lbaEnhancedLogItem', __webpack_require__(411));
	
	exports['default'] = lbaEnhancedLogItem;
	module.exports = exports['default'];

/***/ },
/* 410 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope', '$routeParams', 'dataService', '$timeout'];
	
	var lbaEnhancedLogItemCtrl = function lbaEnhancedLogItemCtrl($scope, $routeParams, dataService, $timeout) {
	  var vm = this;
	  vm.item = dataService.data.activeItem;
	  vm.ShowPanel = ShowPanel;
	  vm.gotoNext = function (next) {
	    if (dataService.data.gotoNext) dataService.data.gotoNext(next);
	  };
	  $scope.$watch(function () {
	    return dataService.data.activeItem;
	  }, function () {
	    vm.item = dataService.data.activeItem;
	    formatData();
	  });
	
	  $timeout(function () {
	    $("#tabsRequest").tabs();
	    $("#tabsResponse").tabs();
	  });
	  function formatData() {
	    vm.formattedRequest = null;
	    vm.formattedResponse = null;
	    if (!vm.item) {
	      return;
	    }
	    vm.formattedRequest = prettyPrint(vm.item.RequestMessage);
	    vm.formattedResponse = prettyPrint(vm.item.ResponseMessage);
	    if (vm.item.LinkedId) {
	      var linkedItems = dataService.data.items.filter(function (d) {
	        return d.LinkedId === vm.item.LinkedId;
	      });
	      linkedItems.sort(function (a, b) {
	        return a.LinkedIndex - b.LinkedIndex;
	      });
	      if (linkedItems.length) {
	        var rq = '';
	        var rs = '';
	        linkedItems.forEach(function (item) {
	          if (item.RequestMessage) {
	            rq += item.RequestMessage;
	          }
	          if (item.ResponseMessage) {
	            rs += item.ResponseMessage;
	          }
	        });
	        vm.formattedRequest = prettyPrint(rq);
	        vm.formattedResponse = prettyPrint(rs);
	      }
	    }
	  }
	  function prettyPrint(value) {
	
	    var pretty = prettyJson(value);
	    if (pretty != null) return pretty;
	    pretty = prettyXml(value);
	    if (pretty != null) return pretty;
	    return value;
	  }
	  function prettyJson(value) {
	    try {
	      var obj = JSON.parse(value);
	      return JSON.stringify(obj, undefined, 4);
	    } catch (e) {}
	    return null;
	  }
	  function prettyXml(sourceXml) {
	    try {
	      var xmlDoc = new DOMParser().parseFromString(sourceXml, 'application/xml');
	      var xsltDoc = new DOMParser().parseFromString([
	      // describes how we want to modify the XML - indent everything
	      '<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">', '  <xsl:strip-space elements="*"/>', '  <xsl:template match="para[content-style][not(text())]">', // change to just text() to strip space in text nodes
	      '    <xsl:value-of select="normalize-space(.)"/>', '  </xsl:template>', '  <xsl:template match="node()|@*">', '    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>', '  </xsl:template>', '  <xsl:output indent="yes"/>', '</xsl:stylesheet>'].join('\n'), 'application/xml');
	
	      var xsltProcessor = new XSLTProcessor();
	      xsltProcessor.importStylesheet(xsltDoc);
	      var resultDoc = xsltProcessor.transformToDocument(xmlDoc);
	      var resultXml = new XMLSerializer().serializeToString(resultDoc);
	      if (resultXml.indexOf('Below is a rendering of the page up to the first error.') > -1) {
	        return null;
	      }
	      return resultXml;
	    } catch (e) {}
	    return null;
	  }
	  function ShowPanel(panel, panelParent, panelDialog, popupButton) {
	    var element = $("#" + panel).detach();
	    $("#" + panelDialog).append(element);
	    $("#" + popupButton).hide();
	    $("#" + panelDialog).dialog({
	      resizable: true,
	      height: 400,
	      width: 400,
	      close: function close() {
	        element = $("#" + panel).detach();
	        $("#" + panelParent).append(element);
	        $("#" + popupButton).show();
	      }
	    });
	  }
	};
	
	lbaEnhancedLogItemCtrl.$inject = $inject;
	
	exports['default'] = lbaEnhancedLogItemCtrl;
	module.exports = exports['default'];

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(412);
	var $inject = [];
	var lbaEnhancedLogItem = function lbaEnhancedLogItem() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '=',
	      name: '=',
	      cake: '=',
	      indexArray: '@'
	    },
	    bindToController: true,
	    controller: 'lbaEnhancedLogItemCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(414)
	  };
	};
	
	lbaEnhancedLogItem.$inject = $inject;
	
	exports['default'] = lbaEnhancedLogItem;
	module.exports = exports['default'];

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(413);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaEnhancedLogItem.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaEnhancedLogItem.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".EnhancedLogItem .itemDetails .itemDetailField{float:left;padding-right:2rem;width:50%}.EnhancedLogItem .RequestResponse{width:100%;height:100%}.EnhancedLogItem .RequestResponse .RequestResponseDetails{float:left;padding-right:10px}.EnhancedLogItem .RequestResponse .RequestResponseDetails span{display:block}.EnhancedLogItem .RequestResponse .RequestResponseDetails .requestResponseTabs{padding:0!important;margin:0;resize:both;overflow:scroll;width:435px;height:435px}.EnhancedLogItem .RequestResponse .RequestResponseDetails .requestResponseTabs .tabContent{width:100%;height:100%;background-color:#fff;padding:0;margin:0}.EnhancedLogItem .RequestResponse .RequestResponseDetails .requestResponseTabs .tabContent pre{background-color:#fff;border:none;padding:0;margin:0;tab-size:2px;white-space:pre-wrap;white-space:-moz-pre-wrap;white-space:-pre-wrap;white-space:-o-pre-wrap;word-wrap:break-word}.EnhancedLogItem .fieldTitle{font-weight:700}.EnhancedLogItem .clear{clear:both}.EnhancedLogItem .requestError{color:red}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaEnhancedLogItem/src/components/lbaEnhancedLogItem/lbaEnhancedLogItem.scss"],"names":[],"mappings":"AAAA,+CAGY,WACA,mBACA,SAAU,CALtB,kCAYQ,WACA,WAAY,CAbpB,0DAeY,WACA,kBAAmB,CAhB/B,+DAoBoB,aAAc,CApBlC,+EAuBgB,oBAEA,SACA,YAEA,gBACA,YACA,YAAa,CA9B7B,2FAiCoB,WACA,YACA,sBACA,UACA,QAAS,CArC7B,+FAwCwB,sBACA,YACA,UACA,SACA,aACA,qBACA,0BACA,sBACA,wBACA,oBAAqB,CAjD7C,6BA6DQ,eAAiB,CA7DzB,wBAgEQ,UAAW,CAhEnB,+BAmEQ,SAAU,CACb","file":"lbaEnhancedLogItem.scss","sourcesContent":[".EnhancedLogItem{\r\n    .itemDetails{\r\n        .itemDetailField{\r\n            float: left;\r\n            padding-right: 2rem;\r\n            width: 50%;\r\n            span{\r\n                \r\n            }\r\n        }\r\n    }\r\n    .RequestResponse{\r\n        width: 100%;\r\n        height: 100%;\r\n        .RequestResponseDetails{\r\n            float: left;\r\n            padding-right: 10px;\r\n           \r\n            \r\n            span{\r\n                    display: block;\r\n                }\r\n            .requestResponseTabs{\r\n                padding: 0px !important;\r\n\r\n                margin:0px;\r\n                resize:both;\r\n                    \r\n                overflow:scroll; /* something other than visible */\r\n                width: 435px;\r\n                height: 435px;\r\n                .tabContent{\r\n                    \r\n                    width: 100%;\r\n                    height: 100%;\r\n                    background-color: #fff;\r\n                    padding: 0;\r\n                    margin: 0;\r\n                    pre {\r\n\r\n                        background-color: #fff;\r\n                        border: none;\r\n                        padding: 0;\r\n                        margin: 0;\r\n                        tab-size: 2px;\r\n                        white-space: pre-wrap; /* Since CSS 2.1 */\r\n                        white-space: -moz-pre-wrap; /* Mozilla, since 1999 */\r\n                        white-space: -pre-wrap; /* Opera 4-6 */\r\n                        white-space: -o-pre-wrap; /* Opera 7 */\r\n                        word-wrap: break-word; /* Internet Explorer 5.5+ */\r\n                    }\r\n                    \r\n                }\r\n\r\n            }\r\n            \r\n            \r\n        }\r\n        \r\n    }\r\n    .fieldTitle{\r\n        font-weight: bold;\r\n    }\r\n    .clear{\r\n        clear: both;\r\n    }\r\n    .requestError{\r\n        color: red;\r\n    }\r\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 414 */
/***/ function(module, exports) {

	var v1="<div id=\"EnhancedLogItemParent\"> <div class=\"EnhancedLogItem\" id=\"EnhancedLogItem\"> <div class=\"itemDetails\"> <div class=\"itemDetailField\"> <span class=\"fieldTitle\">Date:</span>\n{{vm.item.RequestDate}} </div> <div class=\"itemDetailField\"> <span class=\"fieldTitle\">Type:</span>\n{{vm.item.RequestType}} </div> <div class=\"clear\"></div> </div> <div class=\"itemDetails\"> <div class=\"itemDetailField\"> <span class=\"fieldTitle\">Id:</span>\n{{vm.item.id}} </div> <div class=\"itemDetailField\"> <span class=\"fieldTitle\">Pax Id:</span>\n{{vm.item.PassengerIdentifier}} </div> <div class=\"clear\"></div> </div> <div class=\"itemDetails\"> <div class=\"itemDetailField\" ng-if=\"vm.item.LinkedId\"> <span class=\"fieldTitle\">LinkedId:</span>\n{{vm.item.LinkedId}} </div> <div class=\"itemDetailField\" ng-if=\"vm.item.LinkedId\"> <span class=\"fieldTitle\">LinkedIndex:</span>\n{{vm.item.LinkedIndex}} </div> <div class=\"clear\"></div> </div> <div class=\"RequestResponse\"> <div class=\"RequestResponseDetails\" title=\"{{(vm.item.IsError===true?'Request was an error.':'')}}\"> <span class=\"fieldTitle\" ng-class=\"{'requestError': vm.item.IsError===true, 'requestSuccess': vm.item.IsError!==true}\">Request{{(vm.item.IsError===true?' [Request Error]':'')}}:\n<button ng-click=\"vm.gotoNext(false);\" class=\"navbutton\"><i class=\"ui-icon ui-icon-arrowthick-1-w\"></i></button>\n<button ng-click=\"vm.gotoNext(true);\" class=\"navbutton\"><i class=\"ui-icon ui-icon-arrowthick-1-e\"></i></button> </span> <div id=\"tabsRequest\" class=\"requestResponseTabs\"> <ul> <li><a href=\"#tabs-RequestFormatted\">Formatted</a></li> <li><a href=\"#tabs-Request\">Raw</a></li> </ul> <div id=\"tabs-RequestFormatted\"> <div class=\"tabContent\" contenteditable><pre>{{vm.formattedRequest}}</pre></div> </div> <div id=\"tabs-Request\"> <div class=\"tabContent\" contenteditable>{{vm.item.RequestMessage}}</div> </div> </div> </div> <div class=\"RequestResponseDetails\"> <span class=\"fieldTitle\">Response:</span> <div id=\"tabsResponse\" class=\"requestResponseTabs\"> <ul> <li><a href=\"#tabs-ResponseFormatted\">Formatted</a></li> <li><a href=\"#tabs-Response\">Text</a></li> </ul> <div id=\"tabs-ResponseFormatted\"> <div class=\"tabContent\" contenteditable><pre>{{vm.formattedResponse}}</pre></div> </div> <div id=\"tabs-Response\"> <div class=\"tabContent\" contenteditable>{{vm.item.ResponseMessage}}</div> </div> </div> </div> <div class=\"clear\"></div> </div> </div> </div> <div id=\"popupButton\"><button ng-click=\"vm.ShowPanel('EnhancedLogItem','EnhancedLogItemParent','EnhancedLogItemDialog','popupButton')\" class=\"ui-icon ui-icon-extlink\" title=\"Move view to pop-out window\">Popout</button></div> <div id=\"EnhancedLogItemDialog\" title=\"Enhanced Logs Item Details\"></div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaEnhancedLogItem.html", v1)}]);
	module.exports=v1;

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var lbaCompanyReferenceConfigAuditItem = angular.module('app.lbaCompanyReferenceConfigAuditItem', []);
	
	lbaCompanyReferenceConfigAuditItem.controller('lbaCompanyReferenceConfigAuditItemCtrl', __webpack_require__(416));
	lbaCompanyReferenceConfigAuditItem.directive('lbaCompanyReferenceConfigAuditItem', __webpack_require__(417));
	
	exports['default'] = lbaCompanyReferenceConfigAuditItem;
	module.exports = exports['default'];

/***/ },
/* 416 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$scope', 'dataService', 'moment'];
	
	var lbaCompanyReferenceConfigAuditItemCtrl = function lbaCompanyReferenceConfigAuditItemCtrl($scope, dataService, moment) {
	  var vm = this;
	  vm.$onInit = function () {
	    vm.formatDateLocal = formatDateLocal;
	    vm.item = dataService.data.activeItemSubItem;
	    $scope.$watch(function () {
	      return dataService.data.activeItemSubItem;
	    }, function () {
	      vm.item = dataService.data.activeItemSubItem;
	    });
	  };
	
	  function formatDateLocal(val) {
	    return moment.utc(val).local().format("M/D/Y hh:mm:ss A Z");
	  }
	};
	
	lbaCompanyReferenceConfigAuditItemCtrl.$inject = $inject;
	
	exports['default'] = lbaCompanyReferenceConfigAuditItemCtrl;
	module.exports = exports['default'];

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	__webpack_require__(418);
	var $inject = [];
	var lbaCompanyReferenceConfigAuditItem = function lbaCompanyReferenceConfigAuditItem() {
	  return {
	    restrict: 'A',
	    scope: {
	      settings: '=',
	      name: '=',
	      cake: '=',
	      indexArray: '@'
	    },
	    bindToController: true,
	    controller: 'lbaCompanyReferenceConfigAuditItemCtrl',
	    controllerAs: 'vm',
	    template: __webpack_require__(420)
	  };
	};
	
	lbaCompanyReferenceConfigAuditItem.$inject = $inject;
	
	exports['default'] = lbaCompanyReferenceConfigAuditItem;
	module.exports = exports['default'];

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(419);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(144)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaCompanyReferenceConfigAuditItem.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js?sourceMap!./../../../node_modules/sass-loader/index.js?sourceMap!./lbaCompanyReferenceConfigAuditItem.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(143)();
	// imports
	
	
	// module
	exports.push([module.id, ".CompanyReferenceConfigAuditItem .itemDetails .itemDetailField{padding-right:2rem}.CompanyReferenceConfigAuditItem pre{background-color:#fff;border:none;padding:0;margin:0;tab-size:2px;white-space:pre-wrap;white-space:-moz-pre-wrap;white-space:-pre-wrap;white-space:-o-pre-wrap;word-wrap:break-word}.CompanyReferenceConfigAuditItem .fieldTitle{font-weight:700;width:75pt;display:inline-block}.CompanyReferenceConfigAuditItem .clear{clear:both}.CompanyReferenceConfigAuditItem .requestError{color:red}", "", {"version":3,"sources":["/../../../sass-loader/index.js?sourceMap!D:/a/1/s/src/components/lbaCompanyReferenceConfigAuditItem/src/components/lbaCompanyReferenceConfigAuditItem/lbaCompanyReferenceConfigAuditItem.scss"],"names":[],"mappings":"AAAA,+DAGY,kBAAmB,CAH/B,qCAQQ,sBACA,YACA,UACA,SACA,aACA,qBACA,0BACA,sBACA,wBACA,oBAAqB,CAjB7B,6CAoBQ,gBACA,WACA,oBAAqB,CAtB7B,wCAyBQ,UAAW,CAzBnB,+CA4BQ,SAAU,CACb","file":"lbaCompanyReferenceConfigAuditItem.scss","sourcesContent":[".CompanyReferenceConfigAuditItem{\r\n    .itemDetails{\r\n        .itemDetailField{\r\n            padding-right: 2rem;\r\n        }\r\n    }\r\n    pre {\r\n\r\n        background-color: #fff;\r\n        border: none;\r\n        padding: 0;\r\n        margin: 0;\r\n        tab-size: 2px;\r\n        white-space: pre-wrap; /* Since CSS 2.1 */\r\n        white-space: -moz-pre-wrap; /* Mozilla, since 1999 */\r\n        white-space: -pre-wrap; /* Opera 4-6 */\r\n        white-space: -o-pre-wrap; /* Opera 7 */\r\n        word-wrap: break-word; /* Internet Explorer 5.5+ */\r\n    }\r\n    .fieldTitle{\r\n        font-weight: bold;\r\n        width: 100px;\r\n        display: inline-block;\r\n    }\r\n    .clear{\r\n        clear: both;\r\n    }\r\n    .requestError{\r\n        color: red;\r\n    }\r\n}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ },
/* 420 */
/***/ function(module, exports) {

	var v1="<div id=\"CompanyReferenceConfigAuditItemParent\" ng-if=\"vm.item\"> <div class=\"CompanyReferenceConfigAuditItem\" id=\"CompanyReferenceConfigAuditItem\"> <div class=\"itemDetails\"> <div class=\"itemDetailField\"> <span class=\"fieldTitle\">CreatedOn:</span>\n{{vm.formatDateLocal(vm.item.CreatedOn)}} </div> <div class=\"itemDetailField\"> <span class=\"fieldTitle\">DateStart:</span>\n{{vm.formatDateLocal(vm.item.DateStart)}} </div> <div class=\"itemDetailField\"> <span class=\"fieldTitle\">DateEnd:</span>\n{{vm.formatDateLocal(vm.item.DateEnd)}} </div> <div class=\"itemDetailField\"> <span class=\"fieldTitle\">ActionType:</span>\n{{vm.item.ActionType}} </div> <div class=\"itemDetailField\"> <span class=\"fieldTitle\">Status:</span>\n{{vm.item.Status}} </div> <div class=\"itemDetailField\"> <div><span class=\"fieldTitle\">Notes:</span></div> <div contenteditable><pre>{{vm.item.Notes}}</pre></div> </div> </div> </div> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/lbaCompanyReferenceConfigAuditItem.html", v1)}]);
	module.exports=v1;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(422);
	module.exports = 'auth0.auth0';


/***/ },
/* 422 */
/***/ function(module, exports) {

	/******/ (function() { // webpackBootstrap
	/******/ 	"use strict";
	/******/ 	// The require scope
	/******/ 	var __webpack_require__ = {};
	/******/ 	
	/************************************************************************/
	/******/ 	/* webpack/runtime/compat get default export */
	/******/ 	!function() {
	/******/ 		// getDefaultExport function for compatibility with non-harmony modules
	/******/ 		__webpack_require__.n = function(module) {
	/******/ 			var getter = module && module.__esModule ?
	/******/ 				function() { return module['default']; } :
	/******/ 				function() { return module; };
	/******/ 			__webpack_require__.d(getter, { a: getter });
	/******/ 			return getter;
	/******/ 		};
	/******/ 	}();
	/******/ 	
	/******/ 	/* webpack/runtime/define property getters */
	/******/ 	!function() {
	/******/ 		// define getter functions for harmony exports
	/******/ 		__webpack_require__.d = function(exports, definition) {
	/******/ 			for(var key in definition) {
	/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
	/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
	/******/ 				}
	/******/ 			}
	/******/ 		};
	/******/ 	}();
	/******/ 	
	/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
	/******/ 	!function() {
	/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
	/******/ 	}();
	/******/ 	
	/************************************************************************/
	var __webpack_exports__ = {};
	
	;// CONCATENATED MODULE: external "angular"
	var external_angular_namespaceObject = angular;
	var external_angular_default = /*#__PURE__*/__webpack_require__.n(external_angular_namespaceObject);
	;// CONCATENATED MODULE: external "auth0"
	var external_auth0_namespaceObject = auth0;
	var external_auth0_default = /*#__PURE__*/__webpack_require__.n(external_auth0_namespaceObject);
	;// CONCATENATED MODULE: ./src/version.js
	/* harmony default export */ var version = ('3.1.0');
	;// CONCATENATED MODULE: ./src/index.js
	
	
	
	
	if (typeof (external_angular_default()) !== 'object') {
	  throw new Error('Angular must be loaded.');
	}
	
	if (!external_angular_default().isObject((external_auth0_default()))) {
	  throw new Error('Auth0 must be loaded.');
	}
	
	external_angular_default().module('auth0.auth0', []).provider('angularAuth0', angularAuth0);
	
	function angularAuth0() {
	  this.init = function(config) {
	    if (!config) {
	      throw new Error('Client ID and Domain are required to initialize Auth0.js');
	    }
	    if (config._telemetryInfo) {
	      config._telemetryInfo.env = external_angular_default().extend({}, this.config._telemetryInfo.env, {
	        'angular-auth0': version
	      });
	    } else {
	      config._telemetryInfo = {
	        name: 'angular-auth0',
	        version: version,
	        env: {
	          'auth0-js': (external_auth0_default()).version.raw
	        }
	      }
	    }
	    this.config = config;
	  };
	
	  this.$get = [
	    '$rootScope',
	    function($rootScope) {
	      var Auth0Js = new (external_auth0_default()).WebAuth(this.config);
	      var webAuth = {};
	      var functions = [];
	
	      for (var i in Auth0Js) {
	        if (external_angular_default().isFunction(Auth0Js[i])) {
	          functions.push(i);
	        }
	        if (external_angular_default().isObject(Auth0Js[i])) {
	          webAuth[i] = Auth0Js[i];
	        }
	      }
	
	      function wrapArguments(parameters) {
	        var lastIndex = parameters.length - 1,
	          func = parameters[lastIndex];
	        if (external_angular_default().isFunction(func)) {
	          parameters[lastIndex] = function() {
	            var args = arguments;
	            $rootScope.$evalAsync(function() {
	              func.apply(Auth0Js, args);
	            });
	          };
	        }
	        return parameters;
	      }
	
	      for (var i = 0; i < functions.length; i++) {
	        webAuth[functions[i]] = (function(name) {
	          var customFunction = function() {
	            return Auth0Js[name].apply(Auth0Js, wrapArguments(arguments));
	          };
	          return customFunction;
	        })(functions[i]);
	      }
	
	      return webAuth;
	    }
	  ];
	}
	
	/******/ })()
	;

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:true});var route=function route(entry,resolve){return {template:"<" + entry + "></" + entry + ">",resolve:{async:["$q",function($q){var defer=$q.defer();resolve(defer.resolve);return defer.promise;}]}};};var rootRouteTemplate="<lba-route-root target=\"vm.target\"></lba-route-root>";var redirectTemplate="<lba-redirect></lba-redirect>";function injectTarget(target){return target;}function rootRouteController(target){var vm=this;vm.target = target;}exports["default"] = function(app){var $inject=["$routeProvider"];var RouterConfig=function RouterConfig($routeProvider){$routeProvider.when("/",{redirectTo:"/debtors"}).when("/login",route("lb-authenticate",function(callback){return __webpack_require__.e/* nsure */(1, function(){return callback(app.register(__webpack_require__(424).name));});})).when("/access-denied",route("lb-access-denied",function(callback){return __webpack_require__.e/* nsure */(2, function(){return callback(app.register(__webpack_require__(425).name));});})).when("/logout",route("lb-logout",function(callback){return __webpack_require__.e/* nsure */(3, function(){return callback(app.register(__webpack_require__(429).name));});})).when("/loginForm",route("lba-login",function(callback){return __webpack_require__.e/* nsure */(4, function(){return callback(app.register(__webpack_require__(430).name));});})).when("/noaccess",route("lba-login",function(callback){return __webpack_require__.e/* nsure */(4/* duplicate */, function(){return callback(app.register(__webpack_require__(430).name));});})) /**
	       *************************** DEBTORS START ***************************
	       */.when("/debtors",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("DebtorList");}]}}).when("/debtors/add",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("DebtorAddResource");}]}}).when("/debtors/:debtorId",{redirectTo:"/debtors/:debtorId/info"}).when("/debtors/:debtorId/:tab",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("Debtor");}]}}).when("/debtors/:debtorId/:tab/debtor-order-number-codes",{redirectTo:"/debtors/:debtorId/:tab/debtor-order-number-codes/0"}).when("/debtors/:debtorId/:tab/debtor-order-number-codes/:debtorOrderNumberCodesIndex",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("DebtorOrderNumberCodesItem");}]}}).when("/debtors/:debtorId/:tab/terms-and-conditions",{redirectTo:"/debtors/:debtorId/:tab/terms-and-conditions/0"}).when("/debtors/:debtorId/:tab/terms-and-conditions/:debtorTermsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("TermsAndConditionsItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/",{redirectTo:"/debtors/:debtorId/:tab/itinerary-policies/0/general"}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex",{redirectTo:"/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/general"}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/:itineraryPoliciesTab",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/general/items/:ItinPolItemIndex",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesItemsItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/general/profile-attributes/:ItinPolProfileAttributesItemIndex",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesProfileAttributesItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/general/profile-attributes/:ItinPolProfileAttributesItemIndex/conditions/:EnhancedPolicyRulesConditionsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPolicyEnhancedPolicyRulesConditionsItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/flight/benchmark-policies/:flightBenchPolItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesFlightBenchmarksPoliciesItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/flight/benchmark-exceptions/:flightBenchExcItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesFlightBenchmarksExceptionsItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/flight/policies/:flightPolItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesFlightPoliciesItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/flight/policy-exceptions/:flightPolExcItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesFlightPolicyExceptionsItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/flight/lead-time-for-in-policy-booking-exceptions/:flightLessThanXPolItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesLessThanXDayExceptionsItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/flight/fly-america-policy-exceptions/:flyAmericaPolicyExceptionItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesFlightFlyAmericaPolicyExceptionsItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/flight/policy-exception-settings/:flightPolExcSetItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesFlightPolicyExceptionSettingsItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/rail/policies/:railPolItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesRailPoliciesItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/rail/policy-exceptions/:railPolExcItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesRailPolicyExceptionsItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/hotel/policies/:hotelPolItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesHotelPoliciesItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/hotel/hotel-rate-categories/:hotelRCItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesHotelRateCategoriesItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/hotel/exclude-aggregator-rates-by-chain/:hotelEACItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesHotelExcludedAggregatorChainsItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/hotel/no-hotel-policy/:hotelNHPItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesHotelNoHotelPoliciesItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/hotel-lost-savings/policy-exceptions/:hotelPolExcItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesHotelPolicyExceptionsItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/hotel-lost-savings/policy-exception-settings/:ItinPolExcSetItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesHotelPolicyExceptionSettingsItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/car/car-policies/:carPolItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesCarPoliciesItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/car/policy-exceptions/:carPolExcItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesCarPolicyExceptionsItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/car/policy-exception-settings/:carPolExcSetItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesCarPolicyExceptionSettingsItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/car/policy-preferred/:carPolPrefItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesCarPolicyPreferredItem");}]}}).when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/car/policy-restriction/:carPolRestrictedItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ItineraryPoliciesCarPolicyRestrictionItem");}]}}).when("/debtors/:debtorId/company-references/company-references/:compRefItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CompanyReferencesGridItem");}]}}).when("/debtors/:debtorId/company-references/company-references/:compRefItem/children/:compRefChildItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CompanyReferencesChildrenItem");}]}}).when("/debtors/:debtorId/company-references/company-references/:compRefItem/employee-codes/:compRefItemItemIndex",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CompanyReferencesItemsItem");}]}}).when("/debtors/:debtorId/agency/agency-credit-cards/:debtAgCCItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("AgencyCreditCardsItem");}]}}).when("/debtors/:debtorId/agency/agency-reason-codes/:debAgReCoItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("DebtorAgencyReasonCodesItem");}]}}).when("/debtors/:debtorId/agency/virtual-credit-card-configuration/:virtualCCConfig",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("DebtorAgencyVirtualCreditCardConfigurationsItem");}]}}).when("/debtors/:debtorId/agency/virtual-credit-card-configuration/:virtualCCConfig/company-reference-mappings/:companyReferenceItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingItem");}]}}).when("/debtors/:debtorId/agency/payment-configurations/:payConItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("PaymentConfigurationsItem");}]}}).when("/debtors/:debtorId/agency/payment-configurations/:payConItem/payment-types/:payConPayTypItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("PaymentTypesItem");}]}}).when("/debtors/:debtorId/agency/payment-configurations/:payConItem/payment-types/:payConPayTypItem/configurations/:payTypeConItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("PaymentTypesConfigurationsItem");}]}}).when("/debtors/:debtorId/agency/payment-configurations/:payConItem/payment-types/:payConPayTypItem/configurations/:payTypeConItem/suppliers/:payConSupItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("PaymentConfigurationsPaymentTypesConfigurationsSuppliersItem");}]}}).when("/debtors/:debtorId/flight-sectors/one-way-fare-rules/:oneWayFarRuItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("OneWayFareRulesItem");}]}}).when("/debtors/:debtorId/flight-sectors/flight-search-windows/:flightSearchWindowItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("FlightSearchWindowItem");}]}}).when("/debtors/:debtorId/flight-sectors/combinable-fare-rules/:combFareRulesItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CombinableFareRulesItem");}]}}).when("/debtors/:debtorId/flight-sectors/flight-corporate-rate-codes/:flightCorporateRateCodeItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("FlightCorporateRateCodeItem");}]}}).when("/debtors/:debtorId/flight-sectors/flight-modification-settings/:iiflightModificationSettingItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("DebtorFlightModificationSettingItem");}]}}).when("/debtors/:debtorId/flight-sectors/custom-airport-hubs/:idebtorCustomAirportHubsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("DebtorCustomAirportHubsItem");}]}}).when("/debtors/:debtorId/flight-sectors/flight-search-configuration/:iflightSearchConfigurationItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("DebtorFlightSearchConfigurationItem");}]}}).when("/debtors/:debtorId/flight-limit-passenger-policy/udid-configurations/:udidConfigItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("LimitPassengerPolicyUdidItem");}]}}).when("/debtors/:debtorId/hotel-sectors/cities/:hotConRadCitiesItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("HotelConfigurationRadiusCitiesItem");}]}}).when("/debtors/:debtorId/hotel-sectors/hotel-payment-narratives/:hotConPaymentNarrativesItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("HotelConfigurationPaymentNarrativesItem");}]}}).when("/debtors/:debtorId/hotel-sectors/hotel-amenity-filters/:hotConHotelAmenityFiltersItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("HotelConfigurationHotelAmenityFiltersItem");}]}}).when("/debtors/:debtorId/gds/gds/:GdsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("DebtorGdsItem");}]}}).when("/debtors/:debtorId/gds/gds/:GdsItem/mi-questions/:MiItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("DebtorGdsMiQuestionsItem");}]}}).when("/debtors/:debtorId/gds/gds/:GdsItem/mi-questions/:MiItem/questions/:question",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("DebtorGdsMiQuestionsItemQuestionsItem");}]}}).when("/debtors/:debtorId/gds/gds/:GdsItem/corporate-identifiers/:corpId",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("DebtorGdsCorporateIdentifiersItem");}]}}).when("/debtors/:debtorId/gds/gds/:GdsItem/passive-flight-segment-remarks/:RemarkTemplate",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("DebtorGdsPassiveFlightSegmentRemarkTemplate");}]}}).when("/debtors/:debtorId/:tab/company-reference-mappings",{redirectTo:"/debtors/:debtorId/:tab/company-reference-mappings/0"}).when("/debtors/:debtorId/:tab/company-reference-mappings/:companyReferenceItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("GroundTransportationCompanyReferenceMappingItem");}]}}).when("/debtors/:debtorId/:tab/rail-supplier-settings",{redirectTo:"/debtors/:debtorId/:tab/rail-supplier-settings/0"}).when("/debtors/:debtorId/:tab/rail-supplier-settings/:railSuppSettingItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("RailSupplierSettingsItem");}]}}) /**
	       *************************** DEBTORS END ***************************
	       */ /**
	       *************************** SETTINGS START ***************************
	       */.when("/settings",{redirectTo:"/settings/settings-misc"}).when("/settings/:tab",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("SettingsResource");}]}}).when("/settings/settings-misc/error-messages/:ErMesItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ErrorMessagesItem");}]}}).when("/settings/settings-misc/terms-and-condition/:termsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("TermsAndConditionsSettingsItem");}]}}).when("/settings/settings-misc/vehicle-defaults/:vehicleDefaultItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("VehicleDefaultsItem");}]}}).when("/settings/settings-misc/vehicle-emissions/:vehicleEmissionItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("VehicleEmissionsItem");}]}}).when("/settings/settings-misc/flight-fare-data/:flFareDataItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("FlightFareDataItem");}]}}).when("/settings/settings-misc/flight-fare-bucket-data/:ffbcFlightFareBucketClassesItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("FlightFareBucketClassesItem");}]}}).when("/settings/guest-travellers-titles/guest-travellers-titles/:gusTravTitleItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("GuestTravellersTitlesGridItem");}]}}).when("/settings/gds/gds/:GdsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("GdssettingsItem");}]}}).when("/settings/gds/gds/:GdsItem/passive-flight-segment-remarks/:RemarkTemplate",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("GdsPassiveFlightSegmentRemarkTemplate");}]}}).when("/settings/country-pnr-remarks/country-pnr-remarks/:CntPnrFinRemItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CountryPnrFinishingRemarksGridItem");}]}}).when("/settings/country-pnr-remarks/country-pnr-remarks/:CntPnrFinRemItem/gds-remarks/:GdsRemarksItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CountryPnrFinishingRemarksGdsRemarksItem");}]}}).when("/settings/sales-agents/sales-agents/:salSalesAgentsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("SalesAgentsItem");}]}}).when("/settings/per-diem/per-diem-default-rates/:pdPerDiemDefaultRatesItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("PerDiemDefaultRatesItem");}]}}).when("/settings/per-diem/per-diem-mappings/:pdPerDiemMappingsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("PerDiemMappingsItem");}]}}).when("/settings/hotel/hotel-rate-categories/:hrcHotelRateCategoriesItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("HotelRateCategoriesItem");}]}}).when("/settings/hotel/hotel-amenity-filters/:hafHotelAmenityFiltersItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("HotelAmenityFiltersItem");}]}}).when("/settings/rail/character-mappings/:rcmRailCharacterMappingsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("RailCharacterMappingsItem");}]}}).when("/settings/named-lists/named-lists/:iinamedListItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("NamedListItem");}]}}).when("/settings/country-airlines/country-airlines/:iicountryAirlineListItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CountryAirlinesItem");}]}}).when("/settings/flight/flight-modification-settings/:iiflightModificationSettingItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("FlightModificationSettingItem");}]}}).when("/settings/flight/custom-airport-hubs/:isettingsCustomAirportHubsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("SettingsCustomAirportHubsItem");}]}}).when("/settings/flight/flight-search-configuration/:iflightSearchConfigurationItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("FlightSearchConfigurationItem");}]}}).when("/settings/flight/flight-ancillary-codes/:iflightAncillaryCodesItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("FlightAncillaryCodesItem");}]}}).when("/settings/credit-card-mappings/credit-card-mappings/:ccCreditCardMappingsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CreditCardMappingsItem");}]}}) /**
	       *************************** SETTINGS END ***************************
	       */ /**
	       *************************** GLOBAL SETTINGS START ***************************
	       */.when("/global-settings",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget('GlobalSettingsList');}]}}).when("/global-settings/add",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("GlobalSettingsAddResource");}]}}).when("/global-settings/:settingsId",{redirectTo:"/global-settings/:settingsId/settings-misc"}).when("/global-settings/:settingsId/:tab",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("GlobalSettingsResource");}]}}).when("/global-settings/:settingsId/settings-misc/error-messages/:ErMesItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ErrorMessagesItem");}]}}).when("/global-settings/:settingsId/settings-misc/terms-and-condition/:termsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("TermsAndConditionsSettingsItem");}]}}).when("/global-settings/:settingsId/settings-misc/vehicle-defaults/:vehicleDefaultItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("VehicleDefaultsItem");}]}}).when("/global-settings/:settingsId/settings-misc/vehicle-emissions/:vehicleEmissionItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("VehicleEmissionsItem");}]}}).when("/global-settings/:settingsId/settings-misc/flight-fare-data/:flFareDataItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("FlightFareDataItem");}]}}).when("/global-settings/:settingsId/settings-misc/flight-fare-bucket-data/:ffbcFlightFareBucketClassesItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("FlightFareBucketClassesItem");}]}}).when("/global-settings/:settingsId/guest-travellers-titles/guest-travellers-titles/:gusTravTitleItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("GuestTravellersTitlesGridItem");}]}}).when("/global-settings/:settingsId/gds/gds/:GdsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("GdssettingsItem");}]}}).when("/global-settings/:settingsId/gds/gds/:GdsItem/passive-flight-segment-remarks/:RemarkTemplate",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("GdsPassiveFlightSegmentRemarkTemplate");}]}}).when("/global-settings/:settingsId/country-pnr-remarks/country-pnr-remarks/:CntPnrFinRemItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CountryPnrFinishingRemarksGridItem");}]}}).when("/global-settings/:settingsId/country-pnr-remarks/country-pnr-remarks/:CntPnrFinRemItem/gds-remarks/:GdsRemarksItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CountryPnrFinishingRemarksGdsRemarksItem");}]}}).when("/global-settings/:settingsId/sales-agents/sales-agents/:salSalesAgentsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("SalesAgentsItem");}]}}).when("/global-settings/:settingsId/per-diem/per-diem-default-rates/:pdPerDiemDefaultRatesItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("PerDiemDefaultRatesItem");}]}}).when("/global-settings/:settingsId/per-diem/per-diem-mappings/:pdPerDiemMappingsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("PerDiemMappingsItem");}]}}).when("/global-settings/:settingsId/hotel/hotel-rate-categories/:hrcHotelRateCategoriesItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("HotelRateCategoriesItem");}]}}).when("/global-settings/:settingsId/hotel/hotel-amenity-filters/:hafHotelAmenityFiltersItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("HotelAmenityFiltersItem");}]}}).when("/global-settings/:settingsId/rail/character-mappings/:rcmRailCharacterMappingsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("RailCharacterMappingsItem");}]}}).when("/global-settings/:settingsId/named-lists/named-lists/:iinamedListItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("NamedListItem");}]}}).when("/global-settings/:settingsId/country-airlines/country-airlines/:iicountryAirlineListItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CountryAirlinesItem");}]}}).when("/global-settings/:settingsId/flight/flight-modification-settings/:iiflightModificationSettingItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("FlightModificationSettingItem");}]}}).when("/global-settings/:settingsId/flight/custom-airport-hubs/:isettingsCustomAirportHubsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("SettingsCustomAirportHubsItem");}]}}).when("/global-settings/:settingsId/flight/flight-search-configuration/:iflightSearchConfigurationItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("FlightSearchConfigurationItem");}]}}).when("/global-settings/:settingsId/flight/flight-ancillary-codes/:iflightAncillaryCodesItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("FlightAncillaryCodesItem");}]}}).when("/global-settings/:settingsId/credit-card-mappings/credit-card-mappings/:ccCreditCardMappingsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CreditCardMappingsItem");}]}}) /**
	       *************************** GLOBAL SETTINGS END ***************************
	       */ /**
	       *************************** CREDIT CARD START ***************************
	       */.when("/credit-cards",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CreditCardsList");}]}}).when("/credit-cards/add",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CreditCardsAddResource");}]}}).when("/credit-cards/:ccId",{redirectTo:"/credit-cards/:ccId/info"}).when("/credit-cards/:ccId/:ccTab",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CreditCardsResource");}]}}) /**
	       *************************** CREDIT CARD END ***************************
	       */ /**
	       *************************** Airline Carriers START ***************************
	       */.when("/airline-carriers",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("AirlineCarriersList");}]}}).when("/airline-carriers/add",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("AirlineCarriersAddResource");}]}}).when("/airline-carriers/:airCarriersId",{redirectTo:"/airline-carriers/:airCarriersId/info"}).when("/airline-carriers/:airCarriersId/:airCarriersTab",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("AirlineCarriersResource");}]}}).when("/airline-carriers/:airCarriersId/info/country-data/:AirCountryDataItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("AirlineCarrierCountryDataGridItem");}]}}).when("/airline-carriers/:airCarriersId/info/brands/:BrandItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("AirlineCarrierBrandsBrandItem");}]}}).when("/airline-carriers/:airCarriersId/info/fare-classes/:AirCarrierFaClassItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("AirlineCarrierFareClassesGridItem");}]}}).when("/airline-carriers/:airCarriersId/info/fare-classes/:AirCarrierFaClassItem/country-fare-class/:AirFareClsCuFareClsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("AirlineCarrierFareClassesCountryFareClassItem");}]}}).when("/airline-carriers/:airCarriersId/info/gds-fare-settings/:AirFareGdsSetItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("AirlineCarrierFareGdsSettingsItem");}]}}).when("/airline-carriers/:airCarriersId/info/gds-fare-settings/:AirFareGdsSetItem/fares/:airGdsFareItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("AirlineCarrierFareGdsSettingsFaresItem");}]}}).when("/airline-carriers/:airCarriersId/info/gds-fare-settings/:AirFareGdsSetItem/fares/:airGdsFareItem/gds-fare-settings/:airCarrierGDSFarSetItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("AirlineCarrierFareGdsSettingsFaresItemFareDataItem");}]}}).when("/airline-carriers/:airCarriersId/info/loyalty-partnerships/:LoyaltyPartnershipItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("AirlineCarrierLoyaltyPartnershipsItem");}]}}) /**
	       *************************** Airline Carriers END ***************************
	       */ /**
	       *************************** Rail Suppliers START ***************************
	       */.when("/rail-suppliers",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("RailSuppliersList");}]}}).when("/rail-suppliers/add",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("RailSuppliersAddResource");}]}}).when("/rail-suppliers/:railSupId",{redirectTo:"/rail-suppliers/:railSupId/info"}).when("/rail-suppliers/:railSupId/:railSupTab",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("RailSuppliersResource");}]}}).when("/rail-suppliers/:railSupId/info/fare-classes/:railSupFareClassItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("RailSupplierFareClassesGridItem");}]}}).when("/rail-suppliers/:railSupId/info/fare-brand-name-mappings/:railSupFareBrandNameMapping",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("RailSupplierFareBrandNameMappingsGridItem");}]}}) /**
	       *************************** Rail Suppliers END ***************************
	       */ /**
	       *************************** Car Suppliers START ***************************
	       */.when("/car-suppliers",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CarSuppliersList");}]}}).when("/car-suppliers/add",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CarSuppliersAddResource");}]}}).when("/car-suppliers/:carSupId",{redirectTo:"/car-suppliers/:carSupId/info"}).when("/car-suppliers/:carSupId/:carSupTab",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CarSuppliersResource");}]}}).when("/car-suppliers/:carSupId/:carSupTab/vehicles/:CarSupVhItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CarSuppliersVehiclesGridItem");}]}}).when("/car-suppliers/:carSupId/:carSupTab/locations/:CarSupLocItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CarSuppliersLocationsGridItem");}]}}) /**
	       *************************** Car Suppliers END ***************************
	       */ /**
	       *************************** Hotels START ***************************
	       */.when("/hotels",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("HotelsList");}]}}).when("/hotels/edit/:hotelId",{template:"<lba-edit-hotel></lba-edit-hotel>"}) /**
	       *************************** Hotels END ***************************
	       */ /**
	       *************************** POI START ***************************
	       */.when("/points-of-interest",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("PointsOfInterestList");}]}}) /**
	       *************************** POI END ***************************
	       */ /**
	       *************************** airports START ***************************
	       */.when("/airports",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("AirportsList");}]}}) // TODO: Remove when testing its finished
	.when("/paging/airports",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("PagingAirportsList");}]}}) // TODO: Remove both when entire feature its finished      
	.when("/paging/airports/add",{redirectTo:"/airports/add"}).when("/paging/airports/:airportId",{redirectTo:"/airports/:airportId/info"}).when("/airports/add",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("AirportsAddResource");}]}}).when("/airports/:airportId",{redirectTo:"/airports/:airportId/info"}).when("/airports/:airportId/:airportTab",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("AirportsResource");}]}}).when("/airports/:airportId/info/fixed-base-operators/:AirportFixedBaseOperatorsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("AirportFixedBaseOperatorsItem");}]}}) /**
	       *************************** airports END ***************************
	       */ /**
	       *************************** rail stations START ***************************
	       */.when("/rail-stations",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("RailStationsList");}]}}).when("/rail-stations/add",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("RailStationsAddResource");}]}}).when("/rail-stations/:railStationId",{redirectTo:"/rail-stations/:railStationId/info"}).when("/rail-stations/:railStationId/:railStationTab",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("RailStationsResource");}]}}).when("/rail-stations/:railStationId/info/suppliers/:railStationSup",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("RailStationsSuppliersItem");}]}}) /**
	       *************************** rail stations END ***************************
	       */ /**
	       *************************** rail cards START ***************************
	       */.when("/rail-cards",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("RailCardsList");}]}}).when("/rail-cards/add",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("RailCardsAddResource");}]}}).when("/rail-cards/:railCardId",{redirectTo:"/rail-cards/:railCardId/info"}).when("/rail-cards/:railCardId/:railCardTab",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("RailCardsResource");}]}}).when("/rail-cards/:railCardId/info/accepted-suppliers/:railCardSup",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("AcceptedSuppliersItem");}]}}) /**
	       *************************** rail cards END ***************************
	       */ /**
	       *************************** car supplier locations START ***************************
	       */.when("/car-supplier-locations",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CarSuppliersLocations");}]}}).when("/car-supplier-locations/:CarSupLocItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CarSuppliersLocationsGridItem");}]}}) //carSupId
	/**
	       *************************** hotel suppliers START ***************************
	       */.when("/hotel-supplier-membership-programs",{redirectTo:"/hotel-supplier-membership-programs/hotel-suppliers-listing"}).when("/hotel-supplier-membership-programs/:tab",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("HotelSuppliersResource");}]}}).when("/hotel-supplier-membership-programs/hotel-suppliers-listing/add",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("HotelSupplierMembershipProgramsAddResource");}]}}).when("/hotel-supplier-membership-programs/hotel-suppliers-listing/:hotelSupId",{redirectTo:"/hotel-supplier-membership-programs/hotel-suppliers-listing/:hotelSupId/info"}).when("/hotel-supplier-membership-programs/hotel-suppliers-listing/:hotelSupId/:hotelSupTab",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("HotelSupplierMembershipProgramsResource");}]}}).when("/hotel-supplier-membership-programs/master-chains-index/add",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("HotelMasterChainsAddResource");}]}}).when("/hotel-supplier-membership-programs/master-chains-index/:hotelSupId",{redirectTo:"/hotel-supplier-membership-programs/master-chains-index/:hotelSupId/info"}).when("/hotel-supplier-membership-programs/master-chains-index/:hotelSupId/:hotelSupTab",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("HotelMasterChainsResource");}]}}) /**
	       *************************** hotel suppliers END ***************************
	       */ /**
	       *************************** micro-debtor START ***************************
	       */.when("/ctm-debtors",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CtmDebtorsList");}]}}).when("/ctm-debtors/add",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CtmDebtorsAddResource");}]}}).when("/ctm-debtors/:ctmDebtorId",{redirectTo:"/ctm-debtors/:ctmDebtorId/info"}).when("/ctm-debtors/:ctmDebtorId/:ctmDebtorTab",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CtmDebtorsResource");}]}}) /**
	       *************************** micro-debtor END ***************************
	       */ /**
	       *************************** AppInsight Logs START ***************************
	       */.when("/logs",{redirectTo:"/logs/appinsights-logs"}).when("/logs/:tab",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("LogResource");}]}}) /**
	       *************************** AppInsight Logs END ***************************
	       */ /**
	       *************************** Enhanced Logs START ***************************
	       */.when("/enhanced-logs",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedLogResource");}]}}) /**
	       *************************** Enhanced Logs END ***************************
	       */ /**
	       *************************** Fly America Act START ***************************
	       */.when("/fly-america/city-pair-program",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ProgramRouteResource");}]}}).when("/fly-america/fly-america-config/Config/city-pair-program",{redirectTo:"/fly-america/city-pair-program"}).when("/fly-america/fly-america-config/Config/open-skies",{redirectTo:"/fly-america/open-skies"}).when("/fly-america/fly-america-config/:id/info",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CarriersResource");}]}}).when("/fly-america/fly-america-config/:id/info/open-skies/:OpenSkiesItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("OpenSkiesItemResource");}]}}) //default-fly-america-policy-exceptions
	.when("/fly-america/fly-america-config/Config/default-fly-america-policy-exceptions",{redirectTo:"/fly-america/default-fly-america-policy-exceptions"}).when("/fly-america/fly-america-config/:id/info/default-fly-america-policy-exceptions/:DefaultFlyAmericaPolicyExceptionsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("DefaultFlyAmericaPolicyExceptionsItemResource");}]}}).when("/fly-america/city-pair-program/add",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ProgramRouteAddResource");}]}}).when("/fly-america/city-pair-program/add/info",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ProgramRouteAddResource");}]}}).when("/fly-america/city-pair-program/:id",{redirectTo:"/fly-america/city-pair-program/:id/info"}).when("/fly-america/city-pair-program/:id/info",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ProgramRouteItemResource");}]}}).when("/fly-america/city-pair-program/:flyAmericaId/info/city-pair-program/:FlyAmericaCityPairItem",{redirectTo:"/fly-america/city-pair-program/:flyAmericaId/info/city-pair-program/:FlyAmericaCityPairItem/info"}).when("/fly-america/city-pair-program/:flyAmericaId/info/city-pair-program/:FlyAmericaCityPairItem/info",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CityPairProgramItem");}]}}).when("/fly-america",{redirectTo:"/fly-america/fly-america-config/Config/info"}) /**
	       *************************** Fly America Act END ***************************
	       */ /**
	       *************************** Company Reference List Start ***************************
	       */.when("/company-reference-list",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CompanyReferenceManager");}]}}).when("/company-references",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CompanyReferenceList");}]}}).when("/company-references/grid",{redirectTo:"/company-references"}).when("/company-references/grid/:debtorId/:listId",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CompanyReferenceListFilter");}]}}).when("/company-references/add",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CompanyReferencesAddResource");}]}}).when("/company-references/grid/:debtorId/:listId/add",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CompanyReferencesAddResource");}]}}).when("/company-references/:itemId",{redirectTo:"/company-references/:itemId/info"}).when("/company-references/:itemId/:companyReferencesTab",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CompanyReferencesResource");}]}}).when("/company-references/grid/:debtorId/:listId/:itemId",{redirectTo:"/company-references/grid/:debtorId/:listId/:itemId/info"}).when("/company-references/grid/:debtorId/:listId/:itemId/:companyReferencesTab",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CompanyReferencesResource");}]}}) /**
	       *************************** Company Reference List END ***************************
	       */ /**
	       *************************** Company Reference Config Start ***************************
	       */.when("/company-reference-config",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CompanyReferenceConfig");}]}}).when("/company-reference-config/add",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CompanyReferenceConfigAddResource");}]}}).when("/company-reference-config/:companyReferenceConfigId",{redirectTo:"/company-reference-config/:companyReferenceConfigId/info"}).when("/company-reference-config/:companyReferenceConfigId/:companyReferenceConfigTab",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CompanyReferenceConfigEditResource");}]}}).when("/company-reference-config/:companyReferenceConfigId/:companyReferenceConfigTab/file-processing-logs/:logIndex",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CompanyReferenceConfigEditResourceViewLog");}]}}) /**
	       *************************** Company Reference Config END ***************************
	       */ /**
	       *************************** Per Diem START ***************************
	       */.when("/per-diem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("PerDiemManager");}]}}).when("/per-diem/data",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("PerDiemGridItem");}]}}).when("/per-diem/file-upload",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("PerDiemFileUploader");}]}}) /**
	       *************************** Per Diem END ***************************
	       */ /*************************** Enhanced Policy Rules START ***************************
	       */.when("/enhanced-policy-rules",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyRules");}]}}).when("/enhanced-policy-rules/add",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyRulesAddResource");}]}}).when("/enhanced-policy-rules/:enhancedPolicyRulesId",{redirectTo:"/enhanced-policy-rules/:enhancedPolicyRulesId/info"}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/display-message/",{redirectTo:"/enhanced-policy-rules/:enhancedPolicyRulesId/info"}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/policy-message/",{redirectTo:"/enhanced-policy-rules/:enhancedPolicyRulesId/info"}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/policy/",{redirectTo:"/enhanced-policy-rules/:enhancedPolicyRulesId/info"}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/force-credit-card/",{redirectTo:"/enhanced-policy-rules/:enhancedPolicyRulesId/info"}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/:enhancedPolicyRulesTab",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyRulesEditResource");}]}}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/:EnhancedPolicyRulesNewActionsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyRulesNewActionsItem");}]}}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/display-message/:EnhancedPolicyRulesActionsDisplayMessageItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyRulesActionsDisplayMessageItem");}]}}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/message-popup/:EnhancedPolicyRulesActionsDisplayMessageItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyRulesActionsMessagePopupItem");}]}}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/policy-message/:EnhancedPolicyRulesActionsDisplayMessageItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyRulesActionsPolicyMessageItem");}]}}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/set-out-of-policy/:EnhancedPolicyRulesActionsDisplayMessageItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyRulesActionsSetOutOfPolicyItem");}]}}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/policy/:EnhancedPolicyRulesActionsDisplayMessageItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyRulesActionsPolicyItem");}]}}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/force-credit-card/:EnhancedPolicyRulesActionsForceCreditCardItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyRulesActionsForceCreditCardItem");}]}}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/force-credit-card/:EnhancedPolicyRulesActionsForceCreditCardItem/credit-card-matching/:CreditCardMatching",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyRulesActionsForceCreditCardCreditCardMatchingItem");}]}}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/pnr-remarks/:EnhancedPolicyRulesActionsPnrRemarksItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyRulesActionsPnrRemarksItem");}]}}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/pnr-remarks/:EnhancedPolicyRulesActionsPnrRemarksItem/gds-remarks/:EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem");}]}}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/pnr-extra-action/:EnhancedPolicyRulesActionsPnrExtraActionItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyRulesActionsPnrExtraActionItem");}]}}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/pnr-extra-action/:EnhancedPolicyRulesActionsPnrExtraActionItem/profile-moves/:EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem");}]}}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/pnr-extra-action/:EnhancedPolicyRulesActionsPnrExtraActionItem/queue-placements/:EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem");}]}}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/policy-settings/:EnhancedPolicyRulesActionsPolicySettingsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyRulesActionsPolicySettingsItem");}]}}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/policy-settings/:EnhancedPolicyRulesActionsPolicySettingsItem/flight-modification-settings/:iiflightModificationSettingItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyFlightModificationSettingItem");}]}}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/policy-settings/:EnhancedPolicyRulesActionsPolicySettingsItem/flight-search-configuration/:iflightSearchConfigurationItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyFlightSearchConfigurationItem");}]}}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/conditions/:EnhancedPolicyRulesConditionsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyRulesConditionsItem");}]}}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/debtors/:EnhancedPolicyRulesDebtorsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyRulesDebtorsItem");}]}}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/limit-passenger-policy/:EnhancedPolicyRulesActionsLimitPassengerItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyRulesActionsLimitPassengerItem");}]}}).when("/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/limit-passenger-policy/:EnhancedPolicyRulesActionsLimitPassengerItem/udid-configurations/:EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem");}]}}) /**
	       *************************** Enhanced Policy Rules END ***************************
	       */ /*************************** Process Upload Status START ***************************
	       */.when("/process-upload-status",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ProcessUploadStatus");}]}}).when("/process-upload-status/:processUploadStatusId",{redirectTo:"/process-upload-status/:processUploadStatusId/info"}).when("/process-upload-status/:processUploadStatusId/:processUploadStatusTab",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("ProcessUploadStatusViewResource");}]}}) /**
	       *************************** Process Upload Status END ***************************
	       */ /*************************** Manage SAF Scores START ****************************/.when("/saf-scores",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("SafScoresList");}]}}).when("/saf-scores/:safScoresId",{redirectTo:"/saf-scores/:safScoresId/info"}).when("/saf-scores/:safScoresId",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("SafScoresResource");}]}}) /***************************** Manage SAF Scores END ****************************/ /**
	       *************************** Vendor Preference Config START ***************************
	       */.when("/vendor-preference-configs",{redirectTo:"/vendor-preference-configs/campaigns"}).when("/vendor-preference-configs/:tab",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("VendorPreferenceConfigs");}]}}).when("/vendor-preference-configs/rules/add",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("RulesGridItemAddResource");}]}}).when("/vendor-preference-configs/rules/:rRulesItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("RulesGridItem");}]}}).when("/vendor-preference-configs/rules/flight/:rRulesItem/routing-pairs/:rtPairItemId",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("AirPrefRtPairItem");}]}}).when("/vendor-preference-configs/rules/flight/:rRulesItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("RulesGridFlightItem");}]}}).when("/vendor-preference-configs/campaigns/add",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CampaignsGridItemAddResource");}]}}).when("/vendor-preference-configs/campaigns/:cCampaignsItem",{template:rootRouteTemplate,controller:["targetName",rootRouteController],controllerAs:"vm",resolve:{targetName:[function(){return injectTarget("CampaignsGridItem");}]}}) /**
	       *************************** Vendor Preference Config END ***************************
	       */.otherwise({template:redirectTemplate,controller:[rootRouteController],controllerAs:"vm"});};RouterConfig.$inject = $inject;return RouterConfig;};module.exports = exports["default"];

/***/ },
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	exports['default'] = function (app) {
	  var $inject = ['$httpProvider'];
	
	  var AuthConfig = function AuthConfig($httpProvider) {
	    $httpProvider.defaults.useXDomain = true;
	    delete $httpProvider.defaults.headers.common['X-Requested-With'];
	
	    $httpProvider.interceptors.push('authInterceptor');
	  };
	
	  AuthConfig.$inject = $inject;
	
	  return AuthConfig;
	};
	
	module.exports = exports['default'];

/***/ },
/* 435 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var authConstants = {
	  loginSuccess: 'auth-login-success',
	  loginFailed: 'auth-login-failed',
	  logoutSuccess: 'auth-logout-success',
	  sessionTimeout: 'auth-session-timeout',
	  notAuthenticated: 'auth-not-authenticated',
	  notAuthorized: 'auth-not-authorized'
	};
	
	exports['default'] = authConstants;
	module.exports = exports['default'];

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _configConstants = __webpack_require__(147);
	
	var _configConstants2 = _interopRequireDefault(_configConstants);
	
	var $inject = ['$q', '$injector', '$rootScope', 'AUTH_EVENTS', 'dataSourceService'];
	
	var authInterceptor = function authInterceptor($q, $injector, $rootScope, AUTH_EVENTS, dataSourceService) {
	  var factory = {};
	  factory.request = request;
	  factory.responseError = responseError;
	
	  function request(config) {
	    if (dataSourceService.dataSource === _configConstants2['default'].DATA_SOURCES.ODATA) {
	      var authService = $injector.get('authService');
	      var accessToken = authService.getAccessToken();
	
	      if (accessToken) {
	        config.headers.Authorization = 'Bearer ' + accessToken;
	      } else {
	        $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
	      }
	    }
	
	    return config;
	  }
	
	  function responseError(rejection) {
	    var deferred = $q.defer();
	
	    if (rejection.status === 401 && dataSourceService.dataSource === _configConstants2['default'].DATA_SOURCES.ODATA) {
	      (function () {
	        var authService = $injector.get('authService');
	        var refreshToken = authService.getRefreshToken();
	
	        if (refreshToken) {
	          authService.refresh().then(function (response) {
	            _retryHttpRequest(rejection.config, deferred);
	          }, function () {
	            authService.logout();
	            deferred.reject(rejection);
	          });
	        } else {
	          $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
	          deferred.reject(rejection);
	        }
	      })();
	    } else {
	      deferred.reject(rejection);
	    }
	
	    return deferred.promise;
	  }
	
	  return factory;
	};
	
	authInterceptor.$inject = $inject;
	
	exports['default'] = authInterceptor;
	module.exports = exports['default'];

/***/ },
/* 437 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$http', '$httpParamSerializer', 'moment', '$location'];
	
	var authService = function authService($q, $http, $httpParamSerializer, moment, $location) {
	  var service = {
	    prevRoute: undefined,
	    getUsername: getUsername,
	    login: login,
	    logout: logout,
	    refresh: refresh,
	    getOauth: getOauth,
	    clearOauth: clearOauth,
	    getAccessToken: getAccessToken,
	    getRefreshToken: getRefreshToken,
	    isAuthenticated: isAuthenticated,
	    setBulkChangeAdmin: setBulkChangeAdmin,
	    getIsBulkChangeAdmin: getIsBulkChangeAdmin,
	    setCanUploadRegionalMobileContactDetails: setCanUploadRegionalMobileContactDetails,
	    getCanUploadRegionalMobileContactDetails: getCanUploadRegionalMobileContactDetails,
	    storeAuth: storeAuth,
	    isAuthorized: isAuthorized
	  };
	
	  var CLIENT_ID = '40cd37d4-267a-43ca-99d3-f5bd67b8e58d';
	
	  function getUsername() {
	    return service.getOauth().username;
	  }
	
	  function login(username, password) {
	    var data = {
	      client_id: CLIENT_ID,
	      grant_type: 'password',
	      username: username,
	      password: password
	    };
	
	    var req = {
	      method: 'POST',
	      url: endPointUrl + '/Token',
	      headers: {
	        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
	      },
	      data: $httpParamSerializer(data)
	    };
	
	    return $http(req).then(function (data) {
	      var oauth = data.data;
	      oauth.expires_at = moment().add(oauth.expires_in, 's').format('x');
	      oauth.username = username;
	
	      service.storeAuth(oauth);
	    });
	  }
	
	  function logout() {
	    var deferred = $q.defer();
	    if (auth0Config.Enabled) {
	      $location.path('/logout');
	    } else {
	      service.clearOauth();
	    }
	    deferred.resolve();
	
	    return deferred.promise;
	  }
	
	  function refresh() {
	    var data = {
	      client_id: CLIENT_ID,
	      grant_type: 'refresh_token',
	      refresh_token: getRefreshToken()
	    };
	
	    var req = {
	      method: 'POST',
	      url: endPointUrl + '/Token',
	      headers: {
	        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
	      },
	      data: $httpParamSerializer(data)
	    };
	
	    return $http(req).then(function (data) {
	      var oauth = {};
	      oauth.refresh_token = data.refresh_token;
	      oauth.access_token = data.access_token;
	
	      service.storeAuth(oauth);
	    });
	  }
	
	  function setBulkChangeAdmin() {
	
	    var deferred = $q.defer();
	    var oauth = getOauth();
	    if (!oauth) {
	      deferred.resolve();
	      return deferred.promise;
	    }
	    var req = {
	      method: 'POST',
	      url: endPointUrl + '/api/Upload/CanImportConfiguration',
	      headers: {
	        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
	      }
	    };
	    $http(req).then(function (data) {
	      var bulkDataResponse = JSON.stringify(data.data);
	      localStorage.setItem('CanImportConfiguration', bulkDataResponse);
	
	      deferred.resolve(data.data);
	    }, function (error, status) {
	
	      console.log('error', error);
	      if (error.status === 401 || error.status === 403) {
	        deferred.reject(error);
	      }
	    });
	    return deferred.promise;
	  }
	
	  function getIsBulkChangeAdmin() {
	    var data = JSON.parse(localStorage.getItem('CanImportConfiguration'));
	    return data;
	  }
	
	  function setCanUploadRegionalMobileContactDetails() {
	    var deferred = $q.defer();
	    var req = {
	      method: 'POST',
	      url: endPointUrl + '/api/Upload/CanUploadRegionalMobileContactDetails',
	      headers: {
	        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
	      }
	    };
	
	    $http(req).then(function (data) {
	      localStorage.setItem('CanUploadRegionalMobileContactDetails', JSON.stringify(data.data));
	      deferred.resolve(data.data);
	    });
	    return deferred.promise;
	  }
	
	  function getCanUploadRegionalMobileContactDetails() {
	    return JSON.parse(localStorage.getItem('CanUploadRegionalMobileContactDetails'));
	  }
	
	  function storeAuth(oauth) {
	    if (!oauth.expires_at && oauth.expires_in) {
	      oauth.expires_at = moment().add(oauth.expires_in, 's').format('x');
	    }
	
	    localStorage.setItem('oauth', JSON.stringify(oauth));
	    setBulkChangeAdmin();
	    setCanUploadRegionalMobileContactDetails();
	  }
	  function getOauth() {
	    return JSON.parse(localStorage.getItem('oauth'));
	  }
	
	  function clearOauth() {
	    return localStorage.removeItem('oauth');
	  }
	
	  function getAccessToken() {
	    var oauth = service.getOauth();
	
	    return oauth ? oauth.access_token : '';
	  }
	
	  function getRefreshToken() {
	    var oauth = service.getOauth();
	
	    return oauth ? oauth.refresh_token : '';
	  }
	
	  function isAuthenticated() {
	    var oauth = service.getOauth();
	    return oauth && oauth.expires_at && oauth.expires_at > Date.now();
	  }
	  function isAuthorized() {
	    var deferred = $q.defer();
	    setBulkChangeAdmin().then(function () {
	      deferred.resolve(true);
	    }, function (error) {
	      deferred.resolve(false);
	    });
	    return deferred.promise;
	  }
	
	  return service;
	};
	
	authService.$inject = $inject;
	
	exports['default'] = authService;
	module.exports = exports['default'];

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var fieldOptionsConfig = __webpack_require__(439);
	var fieldsConfig = __webpack_require__(440);
	
	var $inject = [];
	var settingsService = function settingsService() {
	
	  var service = {
	    settings: undefined,
	    options: undefined,
	    get: get
	  };
	
	  function get() {
	    service.options = fieldOptionsConfig;
	    return fieldsConfig;
	  }
	
	  return service;
	};
	
	settingsService.$inject = $inject;
	
	exports["default"] = settingsService;
	module.exports = exports["default"];

/***/ },
/* 439 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = {
	  approvalLevels: ["Passive", "PreTrip", "None"],
	  expiryMonths: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
	  expiryYears: ["2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025", "2026", "2027", "2028", "2029", "2030", "2031", "2032", "2033", "2034", "2035", "2036", "2037", "2038", "2039", "2040", "2041", "2042", "2043", "2044", "2045", "2046", "2047", "2048", "2049", "2050", "2051", "2052", "2053", "2054", "2055", "2056", "2057", "2058", "2059", "2060", "2061", "2062", "2063", "2064", "2065", "2066", "2067", "2068", "2069", "2070", "2071", "2072", "2073", "2074", "2075", "2076", "2077", "2078", "2079", "2080", "2081", "2082", "2083", "2084", "2085"],
	  cardType: [{
	    label: "Visa",
	    value: "VI"
	  }, {
	    label: "American Express",
	    value: "AX"
	  }, {
	    label: "BC Card",
	    value: "BC"
	  }, {
	    label: "MasterCard",
	    value: "CA"
	  }, {
	    label: "Discover",
	    value: "DS"
	  }, {
	    label: "Diners Club",
	    value: "DC"
	  }, {
	    label: "Carta Si",
	    value: "T"
	  }, {
	    label: "Carte Bleue",
	    value: "R"
	  }, {
	    label: "Visa Electron",
	    value: "E"
	  }, {
	    label: "Japan Credit Bureau",
	    value: "JC"
	  }, {
	    label: "Maestro",
	    value: "TO"
	  }, {
	    label: "AirPlus Card",
	    value: "TP"
	  }],
	  SegmentTypes: ["Flight", "Rail", "Car", "Hotel", "GroundTransport"],
	  SectionType: ["Summary", "UserHold", "Exchange"],
	  AirlinePolicyTypes: ["PreferredCarriers", "ShowAll"],
	  FlightFlyAmericaPolicyType: ["NotEnabled", "EnforceCompliance", "EnforceComplianceNoOpenSkies", "ShowButNotEnforce"],
	  HotelApplyVirtualCreditCardTypes: [{
	    label: "Use agency VCC config",
	    value: "UseagencyVCCconfig"
	  }, {
	    label: "Optional",
	    value: "Optional"
	  }, {
	    label: "Mandatory",
	    value: "Mandatory"
	  }, {
	    label: "Disabled",
	    value: "Disabled"
	  }],
	  HotelPolicyTypes: ["ShowOnlyPreferred", "PreferredFirst"],
	  HotelPerNightRateDisplayTypes: [{
	    label: "Highest",
	    value: "Highest"
	  }, {
	    label: "Average",
	    value: "Average"
	  }],
	  HotelRateCategoriesCategories: ["Government", "Military", "Travel Industry", "Contract Rates"],
	  HotelRateCategoriesPriorities: ["No priority", "No priority, but show on initial results", "Always display first", "Always display first regardless of Sort or Filter"],
	  HotelExcludedAggregatorChainsAggregators: ["Booking.com", "Expedia"],
	  SettingsHotelPreferredTagsSourceType: ["None", "UseFlagInGDSResponse", "UseHotelDatabaseConfig"],
	  DebtorHotelPreferredTagsSourceType: ["SystemSettings", "UseFlagInGDSResponse", "UseHotelDatabaseConfig"],
	  DebtorHotelConfigTagsToIgnoreFromDatabaseSourceType: ["SystemSettings", "Customize"],
	  PerDiemMappingsTypes: ["Country", "City", "County"],
	  UnusedTicketProviderTypes: ["Sabre Profile", "Elysian Towers", "Banx", "Southwest Direct RTF"],
	  VendorPreferenceRangeValues: [-5, 5],
	  ItineraryValidatorTypes: ["SegmentError", "ChurningActions", "DuplicateTrips", "ShoppingCartDuplicateSegment", "CompanyReferenceValidator"],
	  FlightTypes: ["Single", "Return"],
	  PriceToleranceType: ["Amount", "Percentage"],
	  GdsFareSearchGroupType: ["Individual", "Bundled"],
	  GdsFareSearchSearchType: ["Unknown", "Branded", "NonBranded", "BrandedSingleFares", "BrandedMultipleFares", "BrandedOneWay", "BrandedSingleFaresOneWay", "BrandedMultipleFaresOneWay"],
	  GDSProviders: ["Expedia", "Sabre", "SabreNdc", "Flight Booking Engine", "Jetstar", "Rex", "Travelfusion", "AgentWare", "Conferma", "EventsAir", "FareLogix", "Groundspan", "Amadeus"],
	  GDSProvidersPrimary: ["Sabre", "Amadeus"],
	  HotelRateTypes: ["Government", "Military", "Travel Industry", "Other Sabre Rates", "Booking.com", "Expedia"],
	  HotelConfigurationRadius: [{
	    label: "N/A",
	    value: null
	  }, {
	    label: "2",
	    value: 2
	  }, {
	    label: "5",
	    value: 5
	  }, {
	    label: "10",
	    value: 10
	  }, {
	    label: "15",
	    value: 15
	  }, {
	    label: "25",
	    value: 25
	  }, {
	    label: "50",
	    value: 50
	  }, {
	    label: "100",
	    value: 100
	  }],
	  RadiusOptions: [{
	    label: "2",
	    value: 2
	  }, {
	    label: "5",
	    value: 5
	  }, {
	    label: "10",
	    value: 10
	  }, {
	    label: "15",
	    value: 15
	  }, {
	    label: "25",
	    value: 25
	  }, {
	    label: "50",
	    value: 50
	  }, {
	    label: "100",
	    value: 100
	  }],
	  TravellerConfigurationSources: [{
	    label: "Tramada",
	    value: "Tramada"
	  }, {
	    label: "Sabre",
	    value: "Sabre"
	  }],
	  PaymentTypes: ["Invoice"],
	  SectorTypes: ["Flight", "Rail", "Hotel", "Car", "GroundTransport"],
	  PolicyTypes: ["Include", "Exclude"],
	  CompanyReferencesFlags: ["GuestTravellerTrue", "GuestTravellerFalse", "FlightInPolicy", "FlightOutPolicy", "HotelInPolicy", "HotelOutPolicy", "CarInPolicy", "CarOutPolicy", "RailInPolicy", "RailOutPolicy", "InternationalFalse", "InternationalTrue"],
	  GDSSettingsOptions: ["AvailableCities", "VehicleCodes", "QuoteCurrency", "AvailableCountries", "Identifier", "ExcludedCarriers", "ExcludedOperatingCarriers", "DisableAggregators", "AdditionalFareCodeRequests", "DiversityPercentage", "DiversityLowFareBucketOptions", "DiversityLowFareBucketFareCutOff", "DiversityPriceWeight", "DiversityTravelTimeWeight", "DiversityTimeOfDayWeight", "DiversityStopsNumberWeight", "DiversityTimeWindowHours", "DiversityTimeWindowPercentage", "DiversityOperatingDuplicateWeight", "DiversityCarrierPreferenceWeight", "DiversityCarrierPreferenceOnline", "DiversityCarrierPreferenceDefaultOptions", "DiversityInboundOutboundPairingWeight", "DiversityInboundOutboundPairingDuplicates", "DiversitySetDiversityParameters", "FinishingRemarks", "Username", "Password", "AgentLogin-", "AgentPassword-", "SourceOrganization", "ServiceTag", "RailItineraryCount", "FlightItineraryCount", "SouthwestAccountNumber", "ClientId", "PaidSeatsEnabled", "EventId", "OnlineIndicator", "IncludePenaltyInfo", "SeparatePnrCarriers", "WritePassiveFightSegment", "IncludePreferredCarriersInMainSearch", "CarriersExcludePricingFareBasisCodes", "PassiveFlightSegmentOthTemplate", "RepriceDisableAlternateFareShopping", "CarLocationDefaultRadius", "UnusedTickets", "BFMSearchV2", "BFMVersion6", "BFMSearchV2DistinctCarriers", "BFMSearchV2DistinctCabins", "BFMPreferredCarrierDedicatedSearch", "BFMRefundabledDedicatedSearch", "BFMUnbrandedDedicatedSearch", "NotAllowUnusedTicket", "CorporateCode", "RepriceCombinableThresholdAmount", "MyBookingsLive", "AirBookRetryRebook", "AirPriceSmartPriceV2", "AirPriceAcceptablePriceIncrease", "AirPriceAcceptablePriceDecrease", "AirPriceDisableBrandCode", "SplitTicketingCarriers", "HotelShopKeyEnabled", "HotelShopKeyMaxCalls", "HotelBookGDSviaCSL", "HotelRateKeyEnabled", "EnableModifyBookingForBookingDotCom", "GroundIncludeRateID", "DisplayAicraftNameOnSearchResult", "CompanyReferenceInvoiceRmkReg", "CompanyReferenceAlphaRmkReg", "RepriceGroupByAccountCode", "GroundspanForceMasterCardTypeMC", "EnableAtpcoShopping", "EnableNdcShopping", "EnableLccShopping", "DisableFlightSearch", "EnableBfmRestFlightSearch", "BFMNumberOfTrips", "PreferNDCSourceOnTie", "RepriceGroupByRefundability", "UserDefinedValues", "RepriceSingleTicketCarriers", "EnableEnhancedLogging", "EnableFindMoreFlights", "NdcShowIcon", "AllowMultiCityInternational", "EnableHotelFailureRebook", "EnableMultiCityCombined", "FlightBookRemovePriceQuotes", "ExchangeBookRemovePriceQuotes", "EnableRailRestShopping", "CarRequestShowButNotAllow", "AllowGuestMultiplePassengerPnr", "EnableNoExchangeWhenVoidable", "RepriceGroupByBrandCarriers", "CarDepositCodes", "RepriceRailEnabled", "EnableSameCrrSplitTktDiffPNRs", "SameCrrSplitTktDiffPNRAirlines", "RepriceOnewayFaresGroupByCarrier", "NdcFareIconText", "DisablePaymentPreselectV2", "EnableNoSplitNdcBookings", "PkgViewToggleText", "PkgViewToggleDefaultOn", "IncAgyEmailNdcBookingRq", "AgyEmailNdcRq", "ExchMaxSolutions", "ExchKeepOriginalBrand", "ExchSingleBrandedFare", "ExchIgnoreAllDayForTimeWindow", "ExchTimeWindowPlus", "ExchTimeWindowMinus", "ExchKeepBookingClass", "EnableFlightFilterMixedBrands", "FilterMixBrandsOnlyCarriers", "NoSeatmapCarriers", "DisableHotelRefactor", "AllowMultiDKCreditCards", "HotelMaxPageCount", "HotelAvailabilityPageSize", "HotelQueryDetailCount", "HotelQueryDetailsRatingCount", "HotelSlowQueryWarningNumSec", "WriteSabreFopUsage", "EnableCSPaymentMethods", "EnableEnhancedCarBook", "EnableCarTravelerEmail", "CarBookAcceptablePriceIncrease", "FlightDefaultSortingThresholdMin", "FlightDefaultSortOrder", "GroundspanBookGdsType", "EnableCarFopCollectionV2", "NdcCarriersContactRefusedIndicator", "BFMDirectFlightsPriority", "NdcCarriersRequireNotification", "EnableFlightPackageResponse", "EnableFlightAirportLocationType", "NdcExchangeInstantPurchaseCarriers", "BFMVendorPrefApplicabilityAtLeastOne", "BFMCarrierFilterValidatingCarrier", "RepriceDisable", "RailPriceAcceptablePriceIncrease", "RailPriceAcceptablePriceDecrease", "EnableWriteGuestPeNameNumber", "FlightSearchTimeFilterDefaultToAll", "FlightSearchTimeFilterHide", "EnableApprovalUpdateFailOnWarnings", "ApprovalUpdateFailBccEmails", "MaxFlightSearchConfigurations", "EnableExchBookBargainFinderRebook", "FlightGstStateCode", "FlightSearchLogResultsTimer", "EnableHotelFailureRebookModify", "EnableMyBookingsQueryV2", "AirPointOfSaleCountryCode", "AirIsArc", "EnableRailCurrentItineraryStops", "RepriceNoSplitIntlBookings", "HotelSearchGooglePlacesCategoryLimit", "RefundAbilityHandlingType", "EnableNewSeatMapUi", "PostBookingSeatCarriers", "EnableHomeSearchV2", "EnabledSummaryTravelServices", "EnableExpiredRebook", "EnablePreTripManageBookingsFeed", "EnableManageBookingV2", "EnableExchangeShopLogging", "GuestTravelerTitleRequired", "DisableRecentHotelScores", "TripBookingAccountInformation"],
	  SuppliersSettingsOptions: ["TravelAgentAccount"],
	  PaymentSuppliers: ["Sabre", "Trainline", "EuroStar"],
	  CarPolicyTypes: ["Include", "Exclude"],
	  DeliveryCollectionSupport: ["NotImported", "Unknown", "DeliveryAvailable", "CollectionAvailable", "DeliveryAndCollectionAvailable"],
	  DurationTypeOptions: [null, "TotalDuration", "AirTimeOnly", "SectorTime"],
	  AirportClassificationOptions: ["", "5", "4", "3", "2"],
	  RemarkType: ["AlphaCoded", "Historical", "Invoice", "Itinerary"],
	  SourceFieldType: ["CompanyRef", "Department", "CostCenter", "ProjectCode"],
	  ConditionalApplyTypes: ["OriginDestination", "AnyStopEnRoute"],
	  DebtorFopHandlingTypes: ["UseGuarantee", "UseDefined", "NoAction"],
	  CarTypeDuplicateHandlingTypes: ["ContractOverCheapest", "Cheapest", "ContractAndNon", "ContractAndNonOnlyIfCheaper"],
	  CollectionOperationType: ["Count", "None", "Sum", "AllItems", "AtLeastOneItem"],
	  OperatorType: ["Contains", "Equals", "GreaterThan", "GreaterThanOrEqualTo", "LessThan", "LessThanOrEqualTo", "NotContains", "NotEqualTo"],
	  ConditionType: ["Boolean", "Char", "DateTime", "DateTimeOffset", "Decimal", "Double", "Int32", "Int64", "Single", "String"],
	  ActionType: ["DisplayMessage", "ExcludeFare", "ExcludeFromLLF", "ForceCreditCard", "PnrRemarks", "ShowButNotAllow", "SetOutOfPolicy", "SetInPolicy", "MessagePopup", "PnrExtraAction", "PolicySettings", "LimitPassengerPolicy"],
	  CardApplicationType: ["Exclude", "Optional", "Only", "ExcludeAllBut"],
	  SectorType: ["Air", "Car", "Hotel", "Ground", "Rail"],
	  CardSectorType: ["Air", "Car", "Hotel", "Ground", "Rail", "PaidSeats"],
	  MessagePlacementType: ["Homepage", "CarResults", "FlightResults", "HotelResults", "GroundResults", "RailResults", "SummaryPage", "SeatMap"],
	  FlighLowLogicFareTimeWindowType: ["CompanyTimeWindow", "DefinedTimeWindow"],
	  FlighLowLogicFareContractType: ["DoesNotMatter", "ContractCarrierOnly"],
	  FlighLowLogicFareStopType: ["DoesNotMatter", "Fewest", "NonStop", "Stop1", "Stop2", "SameOrBetter"],
	  RefundabilityOptions: ["DoesNotMatter", "RefundableOnly", "CheapestOnPlane"],
	  PlacementType: ['SummaryPage', 'HomeSearch'],
	  AgencyVirtualPaymentProviderType: [{
	    label: "Conferma Pay",
	    value: "ConfermaPay"
	  }],
	  AgencySectorTypes: ["Hotel"],
	  AgencyApplyVirtualCreditCardType: [{
	    label: "Disable",
	    value: "Disable"
	  }, {
	    label: "Optional",
	    value: "Optional"
	  }, {
	    label: "Mandatory",
	    value: "Mandatory"
	  }],
	  EnhancedLogsSearchTypes: ["PassengerIdentifier", "RequestMessage", "ResponseMessage", "Id", "IsError", "RequestType", "LinkedId"],
	  ProcessUploadStatusSearchTypes: ["UploadedFilename", "UploadedBy", "Status", "Notes"],
	  VenderPrefRuleProductType: ["Hotel", "Flight"],
	  VenderPrefAirPrefStopPriority: ["NotSet", "NonStops", "OneStop", "TwoStop", "ThreeStop"],
	  VenderPrefAirPrefSortingType: ["PriorityCarrier", "DepartureTime", "StopCount", "Price", "Duration"],
	  ItineraryPoliciesHotelBenchmarkingBenchmarkAgainst: ["Preferred", "NonPreferred", "LowestAvailable", "UseStarRating"],
	  ItineraryPoliciesHotelBenchmarkingStarRating: [{
	    label: "1",
	    value: "Rating1"
	  }, {
	    label: "2",
	    value: "Rating2"
	  }, {
	    label: "3",
	    value: "Rating3"
	  }, {
	    label: "4",
	    value: "Rating4"
	  }, {
	    label: "5",
	    value: "Rating5"
	  }, {
	    label: "Equivalent Star Rating",
	    value: "Equivalent"
	  }, {
	    label: "No Minimum",
	    value: "NoMinimum"
	  }],
	  DebtorMultiPaxPnrHandlingType: ["NotAllowed", "SingleProfiledWithGuests", "AllMultiPassengers", "AskOnHomeSearch"],
	  PolicyDebtorMultiPaxPnrHandlingType: ["DebtorConfiguration", "NotAllowed", "SingleProfiledWithGuests", "AllMultiPassengers", "AskOnHomeSearch"],
	  HomeSearchDefaultSelectionOptions: ["Flight", "Hotel", "Car", "Rail", "Ground"],
	  ProfileTypes: ["TVL", "CRP", "AGY", "AGT", "OPX", "GRP", "ALC"],
	  QueueActionTypes: ["AutoTicketing", "AuthorisationHold", "TeamRejection", "Cancel", "Modification", "UserHold", "SeatPurchase", "AncillaryPurchase"],
	  PaidSeatsEnabledType: ["DebtorConfiguration", "Yes", "No"],
	  DebtorAgentClaimedRemarkHandlingType: ["Debtor", "SystemSettings"],
	  FlightCabins: ["-", "Economy", "PremiumEconomy", "Business", "PremiumBusiness", "First", "PremiumFirst"],
	  PassengerTypes: ["ADT", "GCF", "GDP", "GVT", "GVZ", "GST", "SEA"],
	  FlightSearchConfigurationQueryItemsType: ["Single", "Multi", "Exclude"],
	  FlightSearchConfigurationQueryItemsTypeMultiOnly: ["Multi"],
	  FlightSearchConfigurationType: ["Append", "Replace"],
	  FlightNdcAtpcoTieSettingsApplicationType: ["Inherit", "NotConfigured", "Ndc", "Atpco"],
	  FlightNdcAtpcoTieSettingsThresholdType: ["Amount", "Percentage"],
	  PenaltySearchTypes: ["NotSet", "Refundable", "NonRefundable", "Exchangeable", "ExchangeableWithoutPenalty", "RefundableWithoutPenalty", "ExchangeableRefundable", "ExchangeableRefundableWithoutPenalty", "NoVoluntaryChangeInfo"],
	  FlightCorporateRateCodeType: ["SNAP", "BusinessAccountNumber", "CLID", "Qualifier"],
	  DebtorIdentificationType: ["LightningConfigDk", "DefinedGroupCode", "DefinedDks"],
	  UdidConfigurationType: ["StaticUdid", "CompanyReference", "AgencyReasonCode"],
	  PolicyRestrictionType: ["ExcludeFlight", "ShowButNotAllow", "PolicyViolation", "MessagePopup"],
	  ProfileAttributeSourceType: ["Sabre", "Elysian"],
	  DebtorPolicyGuestTravelType: ["EnableArrangerOnly", "Enable", "Disable"],
	  EnableNewUiHandlingType: ['SystemSettings', 'Disabled', 'Enabled'],
	  BoolNullableType: ["false", "true"],
	  DiversityHandlingType: ["Dimensions", "Parameters", "DimensionsAndParameters", "None"],
	  FlightConfigurationPriority: ["DirectFlights", "Price", "Time", "Vendor"],
	  TaxDisplayMode: ["SystemSettings", "Include", "Exclude"]
	};
	module.exports = exports["default"];

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _railCardsJs = __webpack_require__(441);
	
	var _railCardsJs2 = _interopRequireDefault(_railCardsJs);
	
	var _hotelSuppliersJs = __webpack_require__(442);
	
	var _hotelSuppliersJs2 = _interopRequireDefault(_hotelSuppliersJs);
	
	var _railStationsJs = __webpack_require__(443);
	
	var _railStationsJs2 = _interopRequireDefault(_railStationsJs);
	
	var _airportsJs = __webpack_require__(444);
	
	var _airportsJs2 = _interopRequireDefault(_airportsJs);
	
	var _pointsOfInterestJs = __webpack_require__(445);
	
	var _pointsOfInterestJs2 = _interopRequireDefault(_pointsOfInterestJs);
	
	var _hotelsJs = __webpack_require__(446);
	
	var _hotelsJs2 = _interopRequireDefault(_hotelsJs);
	
	var _carSuppliersLocationsJs = __webpack_require__(447);
	
	var _carSuppliersLocationsJs2 = _interopRequireDefault(_carSuppliersLocationsJs);
	
	var _carSuppliersJs = __webpack_require__(448);
	
	var _carSuppliersJs2 = _interopRequireDefault(_carSuppliersJs);
	
	var _railSuppliersJs = __webpack_require__(449);
	
	var _railSuppliersJs2 = _interopRequireDefault(_railSuppliersJs);
	
	var _airlineCarriersJs = __webpack_require__(450);
	
	var _airlineCarriersJs2 = _interopRequireDefault(_airlineCarriersJs);
	
	var _creditCardsJs = __webpack_require__(451);
	
	var _creditCardsJs2 = _interopRequireDefault(_creditCardsJs);
	
	var _settingsResourceJs = __webpack_require__(452);
	
	var _settingsResourceJs2 = _interopRequireDefault(_settingsResourceJs);
	
	var _globalSettingsResourceJs = __webpack_require__(453);
	
	var _globalSettingsResourceJs2 = _interopRequireDefault(_globalSettingsResourceJs);
	
	var _debtorsJs = __webpack_require__(454);
	
	var _debtorsJs2 = _interopRequireDefault(_debtorsJs);
	
	var _ctmDebtorsJs = __webpack_require__(458);
	
	var _ctmDebtorsJs2 = _interopRequireDefault(_ctmDebtorsJs);
	
	var _logsJs = __webpack_require__(459);
	
	var _logsJs2 = _interopRequireDefault(_logsJs);
	
	var _enhancedLogsJs = __webpack_require__(460);
	
	var _enhancedLogsJs2 = _interopRequireDefault(_enhancedLogsJs);
	
	var _flyAmericaActJs = __webpack_require__(461);
	
	var _flyAmericaActJs2 = _interopRequireDefault(_flyAmericaActJs);
	
	var _companyReferenceListJs = __webpack_require__(462);
	
	var _companyReferenceListJs2 = _interopRequireDefault(_companyReferenceListJs);
	
	var _companyReferenceConfigJs = __webpack_require__(463);
	
	var _companyReferenceConfigJs2 = _interopRequireDefault(_companyReferenceConfigJs);
	
	var _enhancedPolicyRulesJs = __webpack_require__(464);
	
	var _enhancedPolicyRulesJs2 = _interopRequireDefault(_enhancedPolicyRulesJs);
	
	var _processUploadStatusJs = __webpack_require__(469);
	
	var _processUploadStatusJs2 = _interopRequireDefault(_processUploadStatusJs);
	
	var _perDiemJs = __webpack_require__(382);
	
	var _perDiemJs2 = _interopRequireDefault(_perDiemJs);
	
	var _vendorPreferenceConfigsJs = __webpack_require__(470);
	
	var _vendorPreferenceConfigsJs2 = _interopRequireDefault(_vendorPreferenceConfigsJs);
	
	var _safScoresJs = __webpack_require__(471);
	
	var _safScoresJs2 = _interopRequireDefault(_safScoresJs);
	
	exports['default'] = Object.assign({}, _railCardsJs2['default'], _hotelSuppliersJs2['default'], _railStationsJs2['default'], _airportsJs2['default'], _pointsOfInterestJs2['default'], _hotelsJs2['default'], _carSuppliersLocationsJs2['default'], _carSuppliersJs2['default'], _railSuppliersJs2['default'], _airlineCarriersJs2['default'], _creditCardsJs2['default'], _settingsResourceJs2['default'], _globalSettingsResourceJs2['default'], _debtorsJs2['default'], _ctmDebtorsJs2['default'], _logsJs2['default'], _enhancedLogsJs2['default'], _flyAmericaActJs2['default'], _companyReferenceListJs2['default'], _companyReferenceConfigJs2['default'], _enhancedPolicyRulesJs2['default'], _processUploadStatusJs2['default'], _perDiemJs2['default'], _vendorPreferenceConfigsJs2['default'], _safScoresJs2['default']);
	module.exports = exports['default'];

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var AcceptedSuppliersSupplierCode = {
	  displayName: 'Supplier Code',
	  dataAt: 'AcceptedSuppliers.$railCardSup.SupplierCode',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var AcceptedSuppliersSupplier = {
	  displayName: 'Supplier',
	  dataAt: 'AcceptedSuppliers.$railCardSup.Supplier',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var AcceptedSuppliersItem = {
	  displayName: 'Accepted Suppliers',
	  dataAt: 'AcceptedSuppliers.$railCardSup',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [AcceptedSuppliersSupplier, AcceptedSuppliersSupplierCode],
	  endpoint: 'RailCards',
	  routeParamId: 'railCardId',
	  removeParamId: 'railCardSup',
	  canDelete: true
	};
	
	var AcceptedSuppliers = {
	  displayName: 'Accepted Suppliers',
	  dataAt: 'AcceptedSuppliers',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: AcceptedSuppliersItem,
	  gridCols: [{ name: 'Supplier', key: 'Supplier' }, { name: 'Supplier Code', key: 'SupplierCode' }]
	};
	
	var InternalCode = {
	  displayName: 'Internal Code',
	  dataAt: 'InternalCode',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var IssuerCode = {
	  displayName: 'Issuer Code',
	  dataAt: 'IssuerCode',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var OriginAcceptingCountryCode = {
	  displayName: 'Origin Accepting Country Code',
	  dataAt: 'OriginAcceptingCountryCode',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT
	};
	
	var RailCardsHomeCountryCode = {
	  displayName: 'Home Country Code',
	  dataAt: 'HomeCountryCode',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.COUNTRY_SELECT,
	  selectType: 'single'
	};
	
	var InternalName = {
	  displayName: 'Internal Name',
	  dataAt: 'InternalName',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var RailCardLocalName = {
	  displayName: 'Rail Card Local Name',
	  dataAt: 'RailCardLocalName',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var RailCardsAddResource = {
	  displayAs: _constantsJs2['default'].DISPLAY_AS.ADD_GRID_RESOURCE,
	  displayName: 'Rail Cards',
	  data: {
	    RailCardLocalName: '',
	    InternalName: '',
	    HomeCountryCode: '',
	    OriginAcceptingCountryCode: [],
	    IssuerCode: '',
	    InternalCode: '',
	    AcceptedSuppliers: []
	  },
	  dataAt: '',
	  children: [RailCardLocalName, InternalName, RailCardsHomeCountryCode, OriginAcceptingCountryCode, IssuerCode, InternalCode],
	  endpoint: 'RailCards'
	};
	
	var RailCardsResource = {
	  displayName: 'Rail Cards',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  dataAt: '',
	  children: [RailCardLocalName, InternalName, RailCardsHomeCountryCode, OriginAcceptingCountryCode, IssuerCode, InternalCode, AcceptedSuppliers],
	  endpoint: 'RailCards',
	  routeParamId: 'railCardId'
	};
	
	var RailCardsList = {
	  rootNode: true,
	  displayName: 'Rail Cards',
	  endpoint: 'RailCards',
	  iconClass: 'fa-train',
	  dataAt: '',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  gridItem: RailCardsResource,
	  gridAdd: RailCardsAddResource,
	  gridCols: [{ name: 'Name', key: 'RailCardLocalName' }, { name: 'Internal Name', key: 'InternalName' }]
	};
	
	exports['default'] = {
	  RailCardsList: RailCardsList,
	  RailCardsResource: RailCardsResource,
	  RailCardsAddResource: RailCardsAddResource,
	  RailCardLocalName: RailCardLocalName,
	  InternalName: InternalName,
	  RailCardsHomeCountryCode: RailCardsHomeCountryCode,
	  OriginAcceptingCountryCode: OriginAcceptingCountryCode,
	  IssuerCode: IssuerCode,
	  InternalCode: InternalCode,
	  AcceptedSuppliers: AcceptedSuppliers,
	  AcceptedSuppliersItem: AcceptedSuppliersItem,
	  AcceptedSuppliersSupplier: AcceptedSuppliersSupplier,
	  AcceptedSuppliersSupplierCode: AcceptedSuppliersSupplierCode
	};
	module.exports = exports['default'];

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	/// STARTING HOTEL SUPPLIERS LISTING
	var HotelSupplierModifiedOn = {
	  displayName: "Modified On",
	  dataAt: "ModifiedOn",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var HotelSupplierModifiedBy = {
	  displayName: "Modified By",
	  dataAt: "ModifiedBy",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var HotelSupplierCreatedOn = {
	  displayName: "Created On",
	  dataAt: "CreatedOn",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var HotelSupplierCreatedBy = {
	  displayName: "Created By",
	  dataAt: "CreatedBy",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var HotelSupplierLoyaltyPartnershipMembershipCodes = {
	  displayName: "Hotel Loyalty Partners",
	  dataAt: "LoyaltyPartnerMembershipCodes",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var HotelSupplierCode = {
	  displayName: "Hotel Membership Code",
	  dataAt: "MembershipCode",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var HotelSupplierName = {
	  displayName: "Name",
	  dataAt: "Name",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var HotelSupplierId = {
	  displayName: "Identifier",
	  dataAt: "Id",
	  disabled: true,
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var HotelSuppliersAdminPanel = {
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  tabName: "Admin",
	  children: [HotelSupplierCreatedBy, HotelSupplierCreatedOn, HotelSupplierModifiedBy, HotelSupplierModifiedOn]
	};
	
	var HotelSuppliersTabsInfoPanel = {
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  tabName: "Info",
	  children: [HotelSupplierId, HotelSupplierName, HotelSupplierCode, HotelSupplierLoyaltyPartnershipMembershipCodes]
	};
	
	var HotelSuppliersMembershipCode = {
	  displayName: "Membership Code",
	  dataAt: "MembershipCode",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var HotelSuppliersName = {
	  displayName: "Name",
	  dataAt: "Name",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var HotelSuppliersTabs = {
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TABS,
	  children: [HotelSuppliersTabsInfoPanel, HotelSuppliersAdminPanel]
	};
	
	var HotelSuppliersNameLabel = {
	  dataAt: "Name",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SUB_HEADING,
	  label: "Name:"
	};
	
	var HotelSupplierMembershipProgramsAddResource = {
	  displayAs: _constantsJs2["default"].DISPLAY_AS.ADD_GRID_RESOURCE,
	  displayName: "Hotel Supplier",
	  data: { Name: "", MembershipCode: "" },
	  dataAt: "",
	  children: [HotelSuppliersName, HotelSuppliersMembershipCode],
	  endpoint: "HotelSupplierMembershipPrograms"
	};
	
	var HotelSupplierMembershipProgramsResource = {
	  displayName: "Hotel Suppliers",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  dataAt: "",
	  children: [HotelSuppliersNameLabel, HotelSuppliersTabs],
	  endpoint: "HotelSupplierMembershipPrograms",
	  routeParamId: "hotelSupId",
	  removeParamId: "hotelSupTab",
	  canDelete: true,
	  deleteOnBackend: true
	};
	
	var HotelSupplierMembershipProgramsList = {
	  rootNode: true,
	  displayName: "Hotel Suppliers",
	  endpoint: "HotelSupplierMembershipPrograms",
	  iconClass: "fa-bed",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  gridItem: HotelSupplierMembershipProgramsResource,
	  gridAdd: HotelSupplierMembershipProgramsAddResource,
	  gridCols: [{ name: "Name", key: "Name" }, { name: "Hotel Membership Code", key: "MembershipCode" }, { name: "Hotel Loyalty Partners", key: "LoyaltyPartnerMembershipCodes" }]
	};
	/// ENDING HOTEL SUPPLIERS LISTING
	
	/// STARTING HOTEL MASTER CHAINS
	var HotelMasterChainModifiedOn = {
	  displayName: "Modified On",
	  dataAt: "ModifiedOn",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var HotelMasterChainModifiedBy = {
	  displayName: "Modified By",
	  dataAt: "ModifiedBy",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var HotelMasterChainCreatedOn = {
	  displayName: "Created On",
	  dataAt: "CreatedOn",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var HotelMasterChainCreatedBy = {
	  displayName: "Created By",
	  dataAt: "CreatedBy",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var HotelMasterChainCode = {
	  displayName: "Master Chain Code",
	  dataAt: "MasterChainCode",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var HotelMasterChainName = {
	  displayName: "Name",
	  dataAt: "Name",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var HotelMasterChainId = {
	  displayName: "Identifier",
	  dataAt: "Id",
	  disabled: true,
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var HotelMasterChainsAdminPanel = {
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  tabName: "Admin",
	  children: [HotelMasterChainCreatedBy, HotelMasterChainCreatedOn, HotelMasterChainModifiedBy, HotelMasterChainModifiedOn]
	};
	
	var HotelMasterChainsTabsInfoPanel = {
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  tabName: "Info",
	  children: [HotelMasterChainId, HotelMasterChainName, HotelMasterChainCode]
	};
	
	var HotelMasterChainsCode = {
	  displayName: "Master Chain Code",
	  dataAt: "MasterChainCode",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var HotelMasterChainsName = {
	  displayName: "Name",
	  dataAt: "Name",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var HotelMasterChainsTabs = {
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TABS,
	  children: [HotelMasterChainsTabsInfoPanel, HotelMasterChainsAdminPanel]
	};
	
	var HotelMasterChainsNameLabel = {
	  dataAt: "Name",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SUB_HEADING,
	  label: "Name:"
	};
	
	var HotelMasterChainsAddResource = {
	  displayAs: _constantsJs2["default"].DISPLAY_AS.ADD_GRID_RESOURCE,
	  displayName: "Hotel Master Chain",
	  data: { Name: "", MasterChainCode: "" },
	  dataAt: "",
	  children: [HotelMasterChainsName, HotelMasterChainsCode],
	  endpoint: "HotelMasterChains"
	};
	
	var HotelMasterChainsResource = {
	  displayName: "Hotel Suppliers",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  dataAt: "",
	  children: [HotelMasterChainsNameLabel, HotelMasterChainsTabs],
	  endpoint: "HotelMasterChains",
	  routeParamId: "hotelSupId",
	  removeParamId: "hotelSupTab",
	  canDelete: true,
	  deleteOnBackend: true
	};
	
	var HotelMasterChainsList = {
	  rootNode: true,
	  displayName: "Master Chains Index",
	  endpoint: "HotelMasterChains",
	  iconClass: "fa-bed",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  gridItem: HotelMasterChainsResource,
	  gridAdd: HotelMasterChainsAddResource,
	  gridCols: [{ name: "Name", key: "Name" }, { name: "Master Chain Code", key: "MasterChainCode" }]
	};
	/// ENDING HOTEL MASTER CHAINS
	
	var HotelSupplierMembershipProgramsTabsMasterChainsIndexPanel = {
	  tabName: "Master-Chains-Index",
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  children: [HotelMasterChainsList]
	};
	
	var HotelSupplierMembershipProgramsTabsHotelSuppliersListingPanel = {
	  tabName: "Hotel-Suppliers-Listing",
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  children: [HotelSupplierMembershipProgramsList]
	};
	
	var HotelSupplierMembershipProgramsTabs = {
	  displayName: "Hotel Suppliers",
	  iconClass: "fa-bed",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TABS,
	  children: [HotelSupplierMembershipProgramsTabsHotelSuppliersListingPanel, HotelSupplierMembershipProgramsTabsMasterChainsIndexPanel]
	};
	
	var HotelSuppliersResource = {
	  rootNode: true,
	  displayName: "Hotel Suppliers",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  iconClass: "fa-bed",
	  dataAt: "",
	  children: [HotelSupplierMembershipProgramsTabs],
	  endpoint: "HotelSupplierMembershipPrograms",
	  hideSave: true
	};
	
	exports["default"] = {
	  HotelSuppliersResource: HotelSuppliersResource,
	  HotelSupplierMembershipProgramsTabs: HotelSupplierMembershipProgramsTabs,
	  HotelSupplierMembershipProgramsTabsHotelSuppliersListingPanel: HotelSupplierMembershipProgramsTabsHotelSuppliersListingPanel,
	  HotelSupplierMembershipProgramsTabsMasterChainsIndexPanel: HotelSupplierMembershipProgramsTabsMasterChainsIndexPanel,
	
	  HotelSupplierMembershipProgramsList: HotelSupplierMembershipProgramsList,
	  HotelSupplierMembershipProgramsResource: HotelSupplierMembershipProgramsResource,
	  HotelSupplierMembershipProgramsAddResource: HotelSupplierMembershipProgramsAddResource,
	  HotelSuppliersNameLabel: HotelSuppliersNameLabel,
	  HotelSuppliersTabs: HotelSuppliersTabs,
	  HotelSuppliersName: HotelSuppliersName,
	  HotelSuppliersMembershipCode: HotelSuppliersMembershipCode,
	  HotelSuppliersTabsInfoPanel: HotelSuppliersTabsInfoPanel,
	  HotelSuppliersAdminPanel: HotelSuppliersAdminPanel,
	  HotelSupplierId: HotelSupplierId,
	  HotelSupplierName: HotelSupplierName,
	  HotelSupplierCode: HotelSupplierCode,
	  HotelSupplierLoyaltyPartnershipMembershipCodes: HotelSupplierLoyaltyPartnershipMembershipCodes,
	  HotelSupplierCreatedBy: HotelSupplierCreatedBy,
	  HotelSupplierCreatedOn: HotelSupplierCreatedOn,
	  HotelSupplierModifiedBy: HotelSupplierModifiedBy,
	  HotelSupplierModifiedOn: HotelSupplierModifiedOn,
	
	  HotelMasterChainsList: HotelMasterChainsList,
	  HotelMasterChainsResource: HotelMasterChainsResource,
	  HotelMasterChainsAddResource: HotelMasterChainsAddResource,
	  HotelMasterChainsNameLabel: HotelMasterChainsNameLabel,
	  HotelMasterChainsTabs: HotelMasterChainsTabs,
	  HotelMasterChainsName: HotelMasterChainsName,
	  HotelMasterChainsCode: HotelMasterChainsCode,
	  HotelMasterChainsTabsInfoPanel: HotelMasterChainsTabsInfoPanel,
	  HotelMasterChainsAdminPanel: HotelMasterChainsAdminPanel,
	  HotelMasterChainId: HotelMasterChainId,
	  HotelMasterChainName: HotelMasterChainName,
	  HotelMasterChainCode: HotelMasterChainCode,
	  HotelMasterChainCreatedBy: HotelMasterChainCreatedBy,
	  HotelMasterChainCreatedOn: HotelMasterChainCreatedOn,
	  HotelMasterChainModifiedBy: HotelMasterChainModifiedBy,
	  HotelMasterChainModifiedOn: HotelMasterChainModifiedOn
	};
	module.exports = exports["default"];

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var RailStationsSuppliersCode = {
	  displayName: 'Code',
	  dataAt: 'Suppliers.$railStationSup.Code',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var RailStationsSuppliersSupplier = {
	  displayName: 'Supplier',
	  dataAt: 'Suppliers.$railStationSup.Supplier',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var RailStationsSuppliersItem = {
	  displayName: 'Suppliers',
	  dataAt: 'Suppliers.$railStationSup',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [RailStationsSuppliersSupplier, RailStationsSuppliersCode],
	  endpoint: 'RailStations',
	  routeParamId: 'railStationId',
	  removeParamId: 'railStationSup',
	  canDelete: true
	};
	
	var RailStationsSuppliers = {
	  displayName: 'Suppliers',
	  dataAt: 'Suppliers',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: RailStationsSuppliersItem,
	  gridCols: [{ name: 'Supplier', key: 'Supplier' }, { name: 'Code', key: 'Code' }]
	};
	
	var RailStationsIsDeleted = {
	  displayName: 'Deleted',
	  dataAt: 'IsDeleted',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.BOOLEAN
	};
	
	var RailStationsUtcOffsetHours = {
	  displayName: 'UTC Offset Hours',
	  dataAt: 'UtcOffsetHours',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  inputType: 'number',
	  min: 0,
	  max: 12,
	  'default': 0,
	  required: true
	};
	
	var RailStationsTimeZoneRegionName = {
	  displayName: 'Time Zone Region Name',
	  dataAt: 'TimeZoneRegionName',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TIME_ZONE_SELECT,
	  selectType: 'single',
	  required: true
	};
	
	var RailStationsLatitude = {
	  displayName: 'Latitude',
	  dataAt: 'Latitude',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  inputType: 'number',
	  min: -9999999999,
	  max: 9999999999,
	  required: true
	};
	
	var RailStationsLongitude = {
	  displayName: 'Longitude',
	  dataAt: 'Longitude',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  inputType: 'number',
	  min: -9999999999,
	  max: 9999999999,
	  required: true
	};
	
	var RailStationsIata = {
	  displayName: 'IATA',
	  dataAt: 'Iata',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var RailStationsCountryName = {
	  displayName: 'CountryCode',
	  dataAt: 'CountryCode',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.COUNTRY_SELECT,
	  selectType: 'single',
	  required: true
	};
	
	var RailStationsCode = {
	  displayName: 'Code',
	  dataAt: 'Code',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var RailStationsCityName = {
	  displayName: 'City Name',
	  dataAt: 'CityName',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var RailStationsCityLongitude = {
	  displayName: 'City Longitude',
	  dataAt: 'CityLongitude',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  inputType: 'number',
	  min: -9999999999,
	  max: 9999999999,
	  required: true
	};
	
	var RailStationsCityLatitude = {
	  displayName: 'City Latitude',
	  dataAt: 'CityLatitude',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  inputType: 'number',
	  min: -9999999999,
	  max: 9999999999,
	  required: true
	};
	
	var RailStationsCityCode = {
	  displayName: 'City Code',
	  dataAt: 'CityCode',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var RailStationsName = {
	  displayName: 'Name',
	  dataAt: 'Name',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var RailStationsId = {
	  displayName: 'Id',
	  dataAt: 'Id',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var RailStationsNameLabel = { dataAt: 'Name', displayAs: _constantsJs2['default'].DISPLAY_AS.SUB_HEADING, label: 'Name:' };
	
	var RailStationsAddResource = {
	  displayAs: _constantsJs2['default'].DISPLAY_AS.ADD_GRID_RESOURCE,
	  displayName: 'Rail Stations',
	  data: {
	    Name: '',
	    CityCode: '',
	    CityLatitude: 0,
	    CityLongitude: 0,
	    CityName: '',
	    Code: '',
	    CountryCode: '',
	    CountryName: '',
	    Iata: '',
	    Latitude: 0,
	    Longitude: 0,
	    IsDeleted: false,
	    Suppliers: []
	  },
	  dataAt: '',
	  children: [RailStationsName, RailStationsCityCode, RailStationsCityLatitude, RailStationsCityLongitude, RailStationsCityName, RailStationsCode, RailStationsCountryName, RailStationsIata, RailStationsLongitude, RailStationsLatitude, RailStationsTimeZoneRegionName, RailStationsUtcOffsetHours],
	  endpoint: 'RailStations'
	};
	
	var RailStationsResource = {
	  displayName: 'Rail Stations',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  dataAt: '',
	  children: [RailStationsNameLabel, RailStationsId, RailStationsName, RailStationsCityCode, RailStationsCityLatitude, RailStationsCityLongitude, RailStationsCityName, RailStationsCode, RailStationsCountryName, RailStationsIata, RailStationsLongitude, RailStationsLatitude, RailStationsTimeZoneRegionName, RailStationsUtcOffsetHours, RailStationsIsDeleted, RailStationsSuppliers],
	  routeParamId: 'railStationId',
	  endpoint: 'RailStations'
	};
	
	var RailStationsList = {
	  rootNode: true,
	  displayName: 'Rail Stations',
	  endpoint: 'RailStations',
	  iconClass: 'fa-train',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  gridItem: RailStationsResource,
	  gridAdd: RailStationsAddResource,
	  gridCols: [{ name: 'Name', key: 'Name' }, { name: 'CityName', key: 'CityName' }]
	};
	
	exports['default'] = {
	  RailStationsList: RailStationsList,
	  RailStationsResource: RailStationsResource,
	  RailStationsAddResource: RailStationsAddResource,
	  RailStationsNameLabel: RailStationsNameLabel,
	  RailStationsId: RailStationsId,
	  RailStationsName: RailStationsName,
	  RailStationsCityCode: RailStationsCityCode,
	  RailStationsCityLatitude: RailStationsCityLatitude,
	  RailStationsCityLongitude: RailStationsCityLongitude,
	  RailStationsCityName: RailStationsCityName,
	  RailStationsCode: RailStationsCode,
	  RailStationsCountryName: RailStationsCountryName,
	  RailStationsIata: RailStationsIata,
	  RailStationsLongitude: RailStationsLongitude,
	  RailStationsLatitude: RailStationsLatitude,
	  RailStationsTimeZoneRegionName: RailStationsTimeZoneRegionName,
	  RailStationsUtcOffsetHours: RailStationsUtcOffsetHours,
	  RailStationsIsDeleted: RailStationsIsDeleted,
	  RailStationsSuppliers: RailStationsSuppliers,
	  RailStationsSuppliersItem: RailStationsSuppliersItem,
	  RailStationsSuppliersSupplier: RailStationsSuppliersSupplier,
	  RailStationsSuppliersCode: RailStationsSuppliersCode
	};
	module.exports = exports['default'];

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var AirportsIsEnabled = {
	  displayName: 'Enabled',
	  dataAt: 'IsEnabled',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.BOOLEAN
	};
	
	var AirportsIsDeleted = {
	  displayName: 'Deleted',
	  dataAt: 'IsDeleted',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.BOOLEAN
	};
	
	var AirportsKeepAlive = {
	  displayName: 'Keep Alive',
	  dataAt: 'KeepAlive',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.BOOLEAN
	};
	
	var AirportsClassification = {
	  displayName: 'Classification',
	  dataAt: 'Classification',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var AirportsElevationFeet = {
	  displayName: 'ElevationFeet',
	  dataAt: 'ElevationFeet',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var AirportsLongitude = {
	  displayName: 'Longitude',
	  dataAt: 'Longitude',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var AirportsLatitude = {
	  displayName: 'Latitude',
	  dataAt: 'Latitude',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var AirportsUtcOffsetHours = {
	  displayName: 'UTC Offset Hours',
	  dataAt: 'UtcOffsetHours',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var AirportsTimeZoneRegionName = {
	  displayName: 'Time Zone Region Name',
	  dataAt: 'TimeZoneRegionName',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TIME_ZONE_SELECT,
	  selectType: 'single',
	  required: true
	};
	
	var AirportsCityLongitude = {
	  displayName: 'City Longitude',
	  dataAt: 'CityLongitude',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var AirportsCityLatitude = {
	  displayName: 'City Latitude',
	  dataAt: 'CityLatitude',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var AirportsCountryCode = {
	  displayName: 'Country Code',
	  dataAt: 'CountryCode',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.COUNTRY_SELECT,
	  selectType: 'single',
	  required: true
	};
	
	var AirportsCityCode = {
	  displayName: 'City Code',
	  dataAt: 'CityCode',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var AirportsCity = {
	  displayName: 'City',
	  dataAt: 'City',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var AirportsIcao = {
	  displayName: 'ICAO',
	  dataAt: 'Icao',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var AirportsIata = {
	  displayName: 'IATA',
	  dataAt: 'Iata',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var AirportsFs = {
	  displayName: 'FS',
	  dataAt: 'Fs',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var AirportGroupCode = {
	  displayName: 'Group Code',
	  dataAt: 'AirportGroupCode',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var AirportGroupName = {
	  displayName: 'Group Name',
	  dataAt: 'AirportGroupName',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var AirportsName = {
	  displayName: 'Name',
	  dataAt: 'Name',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var AirportsId = {
	  displayName: 'Id',
	  dataAt: 'Id',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var AirportsStateCode = {
	  displayName: 'State Code',
	  dataAt: 'StateCode',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var AirportsCountryName = {
	  displayName: 'Country Name',
	  dataAt: 'CountryName',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var AirportsRegionName = {
	  displayName: 'Region Name',
	  dataAt: 'RegionName',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var AirportsNameLabel = { dataAt: 'Name', displayAs: _constantsJs2['default'].DISPLAY_AS.SUB_HEADING, label: 'Name:' };
	
	var FixedBaseOperatorAirline = {
	  displayName: 'Airline',
	  dataAt: 'FixedBaseOperators.$AirportFixedBaseOperatorsItem.Airline',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	var FixedBaseOperatorBuilding = {
	  displayName: 'Building',
	  dataAt: 'FixedBaseOperators.$AirportFixedBaseOperatorsItem.Building',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	var FixedBaseOperatorAddress = {
	  displayName: 'Address',
	  dataAt: 'FixedBaseOperators.$AirportFixedBaseOperatorsItem.Address',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	var FixedBaseOperatorCity = {
	  displayName: 'City',
	  dataAt: 'FixedBaseOperators.$AirportFixedBaseOperatorsItem.City',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	var FixedBaseOperatorState = {
	  displayName: 'State',
	  dataAt: 'FixedBaseOperators.$AirportFixedBaseOperatorsItem.State',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	var FixedBaseOperatorCountry = {
	  displayName: 'Country',
	  dataAt: 'FixedBaseOperators.$AirportFixedBaseOperatorsItem.Country',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	var FixedBaseOperatorPostalCode = {
	  displayName: 'PostalCode',
	  dataAt: 'FixedBaseOperators.$AirportFixedBaseOperatorsItem.PostalCode',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var AirportFixedBaseOperatorsItem = {
	  displayName: 'Item',
	  dataAt: 'FixedBaseOperators.$AirportFixedBaseOperatorsItem',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [FixedBaseOperatorAirline, FixedBaseOperatorBuilding, FixedBaseOperatorAddress, FixedBaseOperatorCity, FixedBaseOperatorState, FixedBaseOperatorCountry, FixedBaseOperatorPostalCode],
	  endpoint: 'Airports',
	  routeParamId: 'airportsId',
	  removeParamId: 'AirportFixedBaseOperatorsItem',
	  canDelete: true
	};
	
	var AirportFixedBaseOperators = {
	  displayName: 'Fixed Base Operators',
	  dataAt: 'FixedBaseOperators',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: AirportFixedBaseOperatorsItem,
	  gridCols: [{ name: 'Airline', key: 'Airline' }, { name: 'Building', key: 'Building' }, { name: 'Address', key: 'Address' }]
	};
	
	var AirportsAddResource = {
	  displayAs: _constantsJs2['default'].DISPLAY_AS.ADD_GRID_RESOURCE,
	  displayName: 'Airports',
	  data: {
	    Name: '',
	    Fs: '',
	    Iata: '',
	    Icao: '',
	    City: '',
	    CityCode: '',
	    CountryCode: '',
	    CountryName: '',
	    RegionName: '',
	    TimeZoneRegionName: '',
	    UtcOffsetHours: '',
	    Latitude: '',
	    Longitude: '',
	    ElevationFeet: '',
	    Classification: '',
	    AirportGroupName: '',
	    AirportGroupCode: ''
	  },
	  dataAt: '',
	  children: [AirportsName, AirportGroupName, AirportGroupCode, AirportsFs, AirportsIata, AirportsIcao, AirportsCity, AirportsCityCode, AirportsCountryCode, AirportsStateCode, AirportsCountryName, AirportsRegionName, AirportsCityLatitude, AirportsCityLongitude, AirportsTimeZoneRegionName, AirportsUtcOffsetHours, AirportsLongitude, AirportsLatitude, AirportsElevationFeet, AirportsClassification],
	  endpoint: 'Airports'
	};
	
	var AirportsResource = {
	  displayName: 'Airports',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  iconClass: 'fa-plane',
	  dataAt: '',
	  children: [AirportsNameLabel, AirportsId, AirportsName, AirportGroupName, AirportGroupCode, AirportsFs, AirportsIata, AirportsIcao, AirportsCity, AirportsCityCode, AirportsCountryCode, AirportsStateCode, AirportsCountryName, AirportsRegionName, AirportsCityLatitude, AirportsCityLongitude, AirportsTimeZoneRegionName, AirportsUtcOffsetHours, AirportsLatitude, AirportsLongitude, AirportsElevationFeet, AirportsClassification, AirportFixedBaseOperators, AirportsIsDeleted, AirportsIsEnabled, AirportsKeepAlive],
	  endpoint: 'Airports',
	  routeParamId: 'airportId'
	};
	
	// TODO: Remove when entire feature is it's finished
	var AirportsList = {
	  rootNode: true,
	  displayName: 'Airports',
	  iconClass: 'fa-plane',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  gridItem: AirportsResource,
	  gridAdd: AirportsAddResource,
	  endpoint: 'Airports',
	  gridCols: [{ name: 'Name', key: 'Name' }, { name: 'City', key: 'City' }, { name: 'Iata', key: 'Iata' }]
	};
	
	var PagingAirportsList = {
	  rootNode: true,
	  displayName: 'Airports',
	  iconClass: 'fa-plane',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.PAGING_GRID,
	  gridItem: AirportsResource,
	  gridAdd: AirportsAddResource,
	  canCopyResource: true,
	  endpoint: 'Airports',
	  gridCols: [{ name: 'Name', field: 'Name' }, { name: 'City', field: 'City' }, { name: 'Iata', field: 'Iata' }]
	};
	
	exports['default'] = {
	  AirportsList: AirportsList,
	  PagingAirportsList: PagingAirportsList,
	  AirportsResource: AirportsResource,
	  AirportsAddResource: AirportsAddResource,
	  AirportsNameLabel: AirportsNameLabel,
	  AirportsId: AirportsId,
	  AirportsName: AirportsName,
	  AirportGroupName: AirportGroupName,
	  AirportGroupCode: AirportGroupCode,
	  AirportsFs: AirportsFs,
	  AirportsIata: AirportsIata,
	  AirportsIcao: AirportsIcao,
	  AirportsCity: AirportsCity,
	  AirportsCityCode: AirportsCityCode,
	  AirportsCountryCode: AirportsCountryCode,
	  AirportsCityLatitude: AirportsCityLatitude,
	  AirportsCityLongitude: AirportsCityLongitude,
	  AirportsStateCode: AirportsStateCode,
	  AirportsCountryName: AirportsCountryName,
	  AirportsRegionName: AirportsRegionName,
	  AirportsTimeZoneRegionName: AirportsTimeZoneRegionName,
	  AirportsUtcOffsetHours: AirportsUtcOffsetHours,
	  AirportsLatitude: AirportsLatitude,
	  AirportsLongitude: AirportsLongitude,
	  AirportsElevationFeet: AirportsElevationFeet,
	  AirportsClassification: AirportsClassification,
	  AirportsIsDeleted: AirportsIsDeleted,
	  AirportsIsEnabled: AirportsIsEnabled,
	  AirportsKeepAlive: AirportsKeepAlive,
	  FixedBaseOperatorAirline: FixedBaseOperatorAirline, FixedBaseOperatorBuilding: FixedBaseOperatorBuilding, FixedBaseOperatorAddress: FixedBaseOperatorAddress, FixedBaseOperatorCity: FixedBaseOperatorCity, FixedBaseOperatorState: FixedBaseOperatorState, FixedBaseOperatorCountry: FixedBaseOperatorCountry, FixedBaseOperatorPostalCode: FixedBaseOperatorPostalCode, AirportFixedBaseOperators: AirportFixedBaseOperators, AirportFixedBaseOperatorsItem: AirportFixedBaseOperatorsItem
	};
	module.exports = exports['default'];

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var PointsOfInterestList = {
	  rootNode: true,
	  displayName: 'Points of interest',
	  iconClass: 'fa-pin',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.POINTS_OF_INTEREST
	};
	
	exports['default'] = {
	  PointsOfInterestList: PointsOfInterestList
	};
	module.exports = exports['default'];

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var HotelsList = {
	  rootNode: true,
	  displayName: 'Hotels',
	  iconClass: 'fa-hotel',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.HOTEL
	};
	
	exports['default'] = {
	  HotelsList: HotelsList
	};
	module.exports = exports['default'];

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var CarSuppliersLocationsDeliveryCollectionSupport = {
	  displayName: 'Delivery Collection Support',
	  dataAt: "DeliveryCollectionSupport",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.SELECT,
	  optionsAt: "DeliveryCollectionSupport"
	};
	
	var CarSuppliersLocationsLongitude = {
	  displayName: 'Longitude',
	  dataAt: 'Longitude',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  inputType: 'number',
	  min: -9999999999,
	  max: 9999999999
	};
	
	var CarSuppliersLocationsLatitude = {
	  displayName: "Latitude",
	  dataAt: "Latitude",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  inputType: "number",
	  min: -9999999999,
	  max: 9999999999
	};
	
	var CarSuppliersLocationsCountryCode = {
	  displayName: "Country Code",
	  dataAt: "CountryCode",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.COUNTRY_SELECT,
	  selectType: "single"
	};
	
	var CarSuppliersLocationsStateCode = {
	  displayName: "State Code",
	  dataAt: "StateCode",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var CarSuppliersLocationsLocationName = {
	  displayName: "Location Name",
	  dataAt: "LocationName",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var CarSuppliersLocationsAddressLine = {
	  displayName: "Address Line",
	  dataAt: "AddressLine",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var CarSuppliersLocationsNoRateReturned = {
	  displayName: "No Rate Returned",
	  dataAt: "NoRateReturned",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.BOOLEAN
	};
	
	var CarSuppliersLocationsCityName = {
	  displayName: "City Name",
	  dataAt: "CityName",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var CarSuppliersLocationsLocationCode = {
	  displayName: "Location Code",
	  dataAt: "LocationCode",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var CarSuppliersLocationsExtendedLocationCode = {
	  displayName: "Extended Location Code",
	  dataAt: "ExtendedLocationCode",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var CarSuppliersLocationsTitle = {
	  displayName: "Title",
	  dataAt: "Title",
	  displayAs: "text-input"
	};
	
	var CarSuppliersLocationsGridItem = {
	  displayName: "Car Supplier Location",
	  dataAt: "",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [CarSuppliersLocationsTitle, CarSuppliersLocationsExtendedLocationCode, CarSuppliersLocationsLocationCode, CarSuppliersLocationsLocationName, CarSuppliersLocationsNoRateReturned, CarSuppliersLocationsAddressLine, CarSuppliersLocationsCityName, CarSuppliersLocationsStateCode, CarSuppliersLocationsCountryCode, CarSuppliersLocationsLatitude, CarSuppliersLocationsLongitude, CarSuppliersLocationsDeliveryCollectionSupport],
	  endpoint: "CarSupplierLocations",
	  routeParamId: "CarSupLocItem"
	};
	
	var CarSuppliersLocations = {
	  rootNode: true,
	  displayName: 'Car Supplier Locations',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.SEARCH_BY,
	  endpoint: 'CarSupplierLocations',
	  targetChoices: ['Title', 'SupplierCode', 'LocationCode', 'AddressLine', 'CityName', 'CountryCode']
	};
	
	exports['default'] = {
	  CarSuppliersLocations: CarSuppliersLocations,
	  CarSuppliersLocationsGridItem: CarSuppliersLocationsGridItem,
	  CarSuppliersLocationsTitle: CarSuppliersLocationsTitle,
	  CarSuppliersLocationsExtendedLocationCode: CarSuppliersLocationsExtendedLocationCode,
	  CarSuppliersLocationsLocationCode: CarSuppliersLocationsLocationCode,
	  CarSuppliersLocationsLocationName: CarSuppliersLocationsLocationName,
	  CarSuppliersLocationsNoRateReturned: CarSuppliersLocationsNoRateReturned,
	  CarSuppliersLocationsAddressLine: CarSuppliersLocationsAddressLine,
	  CarSuppliersLocationsCityName: CarSuppliersLocationsCityName,
	  CarSuppliersLocationsStateCode: CarSuppliersLocationsStateCode,
	  CarSuppliersLocationsCountryCode: CarSuppliersLocationsCountryCode,
	  CarSuppliersLocationsLatitude: CarSuppliersLocationsLatitude,
	  CarSuppliersLocationsLongitude: CarSuppliersLocationsLongitude,
	  CarSuppliersLocationsDeliveryCollectionSupport: CarSuppliersLocationsDeliveryCollectionSupport
	};
	module.exports = exports['default'];

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var CarSuppliersChainLogo = {
	  displayName: 'Chain Logo',
	  dataAt: 'ChainLogo',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.FILE_UPLOADER,
	  fileContainer: 'CarSupplier',
	  uploadType: 'image'
	};
	
	var CarSuppliersCompanyShortName = {
	  displayName: 'Company Short Name',
	  dataAt: 'CompanyShortName',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var CarSuppliersId = {
	  displayName: 'Id',
	  dataAt: 'Id',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var CarSuppliersTabsInfoPanel = {
	  dataAt: '',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GROUP,
	  tabName: 'Info',
	  children: [CarSuppliersId, CarSuppliersTitle, CarSuppliersCode, CarSuppliersCompanyShortName, CarSuppliersChainLogo]
	};
	
	var CarSuppliersCode = { displayName: 'Code', dataAt: 'Code', displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT };
	
	var CarSuppliersTitle = {
	  displayName: 'Title',
	  dataAt: 'Title',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var CarSuppliersTabs = {
	  dataAt: '',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TABS,
	  children: [CarSuppliersTabsInfoPanel]
	};
	
	var CarSuppliersNameLabel = { dataAt: 'Title', displayAs: _constantsJs2['default'].DISPLAY_AS.SUB_HEADING, label: 'Title:' };
	
	var CarSuppliersAddResource = {
	  displayAs: _constantsJs2['default'].DISPLAY_AS.ADD_GRID_RESOURCE,
	  displayName: 'Car Supplier',
	  data: { Title: '', Code: '' },
	  dataAt: '',
	  children: [CarSuppliersTitle, CarSuppliersCode],
	  endpoint: 'CarSuppliers'
	};
	
	var CarSuppliersResource = {
	  displayName: 'Car Suppliers',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  dataAt: '',
	  children: [CarSuppliersNameLabel, CarSuppliersTabs],
	  endpoint: 'CarSuppliers',
	  routeParamId: 'carSupId'
	};
	
	var CarSuppliersList = {
	  rootNode: true,
	  displayName: 'Car Suppliers',
	  endpoint: 'CarSuppliers',
	  iconClass: 'fa-car',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  gridItem: CarSuppliersResource,
	  gridAdd: CarSuppliersAddResource,
	  gridCols: [{ name: 'Title', key: 'Title' }, { name: 'Code', key: 'Code' }]
	};
	
	exports['default'] = {
	  CarSuppliersList: CarSuppliersList,
	  CarSuppliersResource: CarSuppliersResource,
	  CarSuppliersAddResource: CarSuppliersAddResource,
	  CarSuppliersNameLabel: CarSuppliersNameLabel,
	  CarSuppliersTabs: CarSuppliersTabs,
	  CarSuppliersTitle: CarSuppliersTitle,
	  CarSuppliersCode: CarSuppliersCode,
	  CarSuppliersTabsInfoPanel: CarSuppliersTabsInfoPanel,
	  CarSuppliersId: CarSuppliersId,
	  CarSuppliersCompanyShortName: CarSuppliersCompanyShortName,
	  CarSuppliersChainLogo: CarSuppliersChainLogo
	};
	module.exports = exports['default'];

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var RailSupplierFareClassName = {
	  displayName: 'Supplier Fare Class Names',
	  dataAt: 'FareClasses.$railSupFareClassItem.SupplierFareClassName',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT
	};
	
	var RailSupplierFareClassesGroupType = {
	  displayName: 'Group Type',
	  dataAt: 'FareClasses.$railSupFareClassItem.GroupType',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var RailSupplierFareClassesBookingCodes = {
	  displayName: 'Booking Codes',
	  dataAt: 'FareClasses.$railSupFareClassItem.BookingCodes',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT
	};
	
	var RailSupplierFareClassesTitle = {
	  displayName: 'Title',
	  dataAt: 'FareClasses.$railSupFareClassItem.Title',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var RailSupplierFareBrandNameMappingDisplayName = {
	  displayName: 'Display Name',
	  dataAt: 'FareBrandNameMappings.$railSupFareBrandNameMapping.Display',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var RailSupplierFareBrandNameMappingName = {
	  displayName: 'Fare Name',
	  dataAt: 'FareBrandNameMappings.$railSupFareBrandNameMapping.FareName',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var RailSupplierFareBrandNameMappingsGridItem = {
	  displayName: 'Fare Brand Name Mappings',
	  dataAt: 'FareBrandNameMappings.$railSupFareBrandNameMapping',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [RailSupplierFareBrandNameMappingName, RailSupplierFareBrandNameMappingDisplayName],
	  endpoint: 'RailSuppliers',
	  routeParamId: 'railSupId',
	  removeParamId: 'railSupFareBrandNameMapping',
	  canDelete: true
	};
	
	var RailSupplierFareClassesGridItem = {
	  displayName: 'Fare Class',
	  dataAt: 'FareClasses.$railSupFareClassItem',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [RailSupplierFareClassesTitle, RailSupplierFareClassesBookingCodes, RailSupplierFareClassesGroupType, RailSupplierFareClassName],
	  endpoint: 'RailSuppliers',
	  routeParamId: 'railSupId',
	  removeParamId: 'railSupFareClassItem',
	  canDelete: true
	};
	
	var RailSupplierModifiedOn = {
	  displayName: 'Modified On',
	  dataAt: 'ModifiedOn',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var RailSupplierModifiedBy = {
	  displayName: 'Modified By',
	  dataAt: 'ModifiedBy',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var RailSupplierCreatedOn = {
	  displayName: 'Created On',
	  dataAt: 'CreatedOn',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var RailSupplierCreatedBy = {
	  displayName: 'Created By',
	  dataAt: 'CreatedBy',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var RailSupplierFareRulesDocument = {
	  displayName: 'Fare Rules Document',
	  dataAt: 'FareRulesDocument',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.FILE_UPLOADER,
	  fileContainer: 'RailFareRule',
	  uploadType: 'pdf'
	};
	
	var RailSupplierFareClasses = {
	  displayName: 'Fare Classes',
	  dataAt: 'FareClasses',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  canAddNew: true,
	  gridItem: RailSupplierFareClassesGridItem,
	  gridCols: [{ name: 'Title', key: 'Title' }, { name: 'Group Type', key: 'GroupType' }]
	};
	
	var RailSupplierFareBrandNameMappings = {
	  displayName: 'Fare Brand Name Mappings',
	  dataAt: 'FareBrandNameMappings',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  canAddNew: true,
	  gridItem: RailSupplierFareBrandNameMappingsGridItem,
	  gridCols: [{ name: 'Fare Name', key: 'FareName' }, { name: 'Display', key: 'Display' }]
	};
	
	var RailSupplierSupplierLogoUrl = {
	  displayName: 'Supplier Logo Url',
	  dataAt: 'SupplierLogoUrl',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.FILE_UPLOADER,
	  fileContainer: 'RailSupplier',
	  uploadType: 'image'
	};
	
	var RailSupplierCheckInUrl = {
	  displayName: 'Check-in Url',
	  dataAt: 'CheckInUrl',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var RailSupplierId = {
	  displayName: 'Identifier',
	  dataAt: 'Id',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var RailSuppliersAdminPanel = {
	  dataAt: '',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GROUP,
	  tabName: 'Admin',
	  children: [RailSupplierCreatedBy, RailSupplierCreatedOn, RailSupplierModifiedBy, RailSupplierModifiedOn]
	};
	
	var RailSuppliersInfoPanel = {
	  dataAt: '',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GROUP,
	  tabName: 'Info',
	  children: [RailSupplierId, RailSupplierTitle, RailSupplierCode, RailSupplierCheckInUrl, RailSupplierSupplierLogoUrl, RailSupplierFareClasses, RailSupplierFareBrandNameMappings, RailSupplierFareRulesDocument]
	};
	
	var RailSupplierCode = { displayName: 'Code', dataAt: 'Code', displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT };
	
	var RailSupplierTitle = {
	  displayName: 'Title',
	  dataAt: 'Title',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var RailSuppliersTabs = {
	  dataAt: '',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TABS,
	  children: [RailSuppliersInfoPanel, RailSuppliersAdminPanel],
	  endpoint: 'RailSuppliers'
	};
	
	var RailSuppliersAddResource = {
	  displayAs: _constantsJs2['default'].DISPLAY_AS.ADD_GRID_RESOURCE,
	  displayName: 'Rail Supplier',
	  data: { Title: '', Code: '' },
	  dataAt: '',
	  children: [RailSupplierTitle, RailSupplierCode],
	  endpoint: 'RailSuppliers'
	};
	
	var RailSuppliersResource = {
	  displayName: 'Rail Supplier',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  iconClass: 'fa-train',
	  children: [RailSuppliersTabs],
	  endpoint: 'RailSuppliers',
	  routeParamId: 'railSupId'
	};
	
	var RailSuppliersList = {
	  rootNode: true,
	  displayName: 'Rail Suppliers',
	  endpoint: 'RailSuppliers',
	  iconClass: 'fa-train',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  gridItem: RailSuppliersResource,
	  gridAdd: RailSuppliersAddResource,
	  gridCols: [{ name: 'Title', key: 'Title' }, { name: 'Code', key: 'Code' }]
	};
	
	exports['default'] = {
	  RailSuppliersList: RailSuppliersList,
	  RailSuppliersResource: RailSuppliersResource,
	  RailSuppliersAddResource: RailSuppliersAddResource,
	  RailSuppliersTabs: RailSuppliersTabs,
	  RailSupplierTitle: RailSupplierTitle,
	  RailSupplierCode: RailSupplierCode,
	  RailSuppliersInfoPanel: RailSuppliersInfoPanel,
	  RailSuppliersAdminPanel: RailSuppliersAdminPanel,
	  RailSupplierId: RailSupplierId,
	  RailSupplierCheckInUrl: RailSupplierCheckInUrl,
	  RailSupplierSupplierLogoUrl: RailSupplierSupplierLogoUrl,
	  RailSupplierFareClasses: RailSupplierFareClasses,
	  RailSupplierFareBrandNameMappings: RailSupplierFareBrandNameMappings,
	  RailSupplierFareRulesDocument: RailSupplierFareRulesDocument,
	  RailSupplierCreatedBy: RailSupplierCreatedBy,
	  RailSupplierCreatedOn: RailSupplierCreatedOn,
	  RailSupplierModifiedBy: RailSupplierModifiedBy,
	  RailSupplierModifiedOn: RailSupplierModifiedOn,
	  RailSupplierFareClassesGridItem: RailSupplierFareClassesGridItem,
	  RailSupplierFareBrandNameMappingsGridItem: RailSupplierFareBrandNameMappingsGridItem,
	  RailSupplierFareClassesTitle: RailSupplierFareClassesTitle,
	  RailSupplierFareBrandNameMappingName: RailSupplierFareBrandNameMappingName,
	  RailSupplierFareBrandNameMappingDisplayName: RailSupplierFareBrandNameMappingDisplayName,
	  RailSupplierFareClassesBookingCodes: RailSupplierFareClassesBookingCodes,
	  RailSupplierFareClassesGroupType: RailSupplierFareClassesGroupType,
	  RailSupplierFareClassName: RailSupplierFareClassName
	};
	module.exports = exports['default'];

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var AirlineCarrierFareGdsSettingsFaresItemFareDataItemSpecifiedPassengerTypesOnly = {
	  displayName: 'Specified Passenger Types Only',
	  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData.$airCarrierGDSFarSetItem.SpecifiedPassengerTypesOnly',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.BOOLEAN
	};
	
	var AirlineCarrierFareGdsSettingsFaresItemFareDataItemCabinType = {
	  displayName: 'CabinType',
	  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData.$airCarrierGDSFarSetItem.CabinType',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var AirlineCarrierFareGdsSettingsFaresItemFareDataItemPrivateFares = {
	  displayName: 'Private Fares',
	  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData.$airCarrierGDSFarSetItem.PrivateFares',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT
	};
	
	var AirlineCarrierFareGdsSettingsFaresItemFareDataItemPassengerTypes = {
	  displayName: 'Passenger Type Codes',
	  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData.$airCarrierGDSFarSetItem.PassengerTypes',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT
	};
	
	var AirlineCarrierFareGdsSettingsFaresItemFareDataItemRateCodes = {
	  displayName: 'Rate Codes (Corporate Code/Snap Code)',
	  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData.$airCarrierGDSFarSetItem.RateCodes',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT
	};
	
	var AirlineCarrierFareGdsSettingsFaresItemFareDataItemFareClass = {
	  displayName: 'Fare Class',
	  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData.$airCarrierGDSFarSetItem.FareClass',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var AirlineCarrierFareGdsSettingsFaresItemFareDataItem = {
	  displayName: 'Item',
	  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData.$airCarrierGDSFarSetItem',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [AirlineCarrierFareGdsSettingsFaresItemFareDataItemFareClass, AirlineCarrierFareGdsSettingsFaresItemFareDataItemRateCodes, AirlineCarrierFareGdsSettingsFaresItemFareDataItemPassengerTypes, AirlineCarrierFareGdsSettingsFaresItemFareDataItemPrivateFares, AirlineCarrierFareGdsSettingsFaresItemFareDataItemCabinType, AirlineCarrierFareGdsSettingsFaresItemFareDataItemSpecifiedPassengerTypesOnly],
	  endpoint: 'AirlineCarriers',
	  routeParamId: 'airCarriersId',
	  removeParamId: 'airCarrierGDSFarSetItem',
	  canDelete: true
	};
	
	var AirlineCarrierFareGdsSettingsFaresItemFareData = {
	  displayName: 'GDS Fare Settings',
	  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.FareData',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: AirlineCarrierFareGdsSettingsFaresItemFareDataItem,
	  gridCols: [{ name: 'FareClass', key: 'FareClass' }, { name: 'RateCodes', key: 'RateCodes' }, { name: 'PassengerTypes', key: 'PassengerTypes' }, { name: 'PrivateFares', key: 'PrivateFares' }, { name: 'CabinType', key: 'CabinType' }]
	};
	
	var AirlineCarrierFareGdsSettingsFaresItemFareDataItemExcludedTaxCodes = {
	  displayName: 'Excluded Tax Codes',
	  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.ExcludedTaxCodes',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT
	};
	
	var AirlineCarrierFareGdsSettingsFaresItemFareDataItemSearchType = {
	  displayName: 'Search Type',
	  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.SearchType',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.SELECT,
	  optionsAt: 'GdsFareSearchSearchType'
	};
	
	var AirlineCarrierFareGdsSettingsFaresItemFareDataItemSearchGroupType = {
	  displayName: 'Search Group Type',
	  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.SearchGroupType',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.SELECT,
	  optionsAt: 'GdsFareSearchGroupType'
	};
	
	var AirlineCarrierFareGdsSettingsFaresItemFareDataItemCountries = {
	  displayName: 'Countries',
	  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem.Countries',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT
	};
	
	var AirlineCarrierFareClassesCountryFareClassFareBasisCodes = {
	  displayName: 'Fare Basis Codes',
	  dataAt: 'FareClasses.$AirCarrierFaClassItem.CountryFareClasses.$AirFareClsCuFareClsItem.FareBasisCodes',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT
	};
	
	var AirlineCarrierFareClassesCountryFareClassBookingCodes = {
	  displayName: 'Booking Codes',
	  dataAt: 'FareClasses.$AirCarrierFaClassItem.CountryFareClasses.$AirFareClsCuFareClsItem.BookingCodes',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT
	};
	
	var AirlineCarrierFareClassesCountryFareClassBrandName = {
	  displayName: 'Brand Name',
	  dataAt: 'FareClasses.$AirCarrierFaClassItem.CountryFareClasses.$AirFareClsCuFareClsItem.BrandName',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var AirlineCarrierFareClassesCountryFareClassCountries = {
	  displayName: 'Countries',
	  dataAt: 'FareClasses.$AirCarrierFaClassItem.CountryFareClasses.$AirFareClsCuFareClsItem.Countries',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT
	};
	
	var AirlineCarrierFareGdsSettingsFaresItem = {
	  displayName: 'Item',
	  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares.$airGdsFareItem',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [AirlineCarrierFareGdsSettingsFaresItemFareDataItemCountries, AirlineCarrierFareGdsSettingsFaresItemFareDataItemSearchGroupType, AirlineCarrierFareGdsSettingsFaresItemFareDataItemSearchType, AirlineCarrierFareGdsSettingsFaresItemFareDataItemExcludedTaxCodes, AirlineCarrierFareGdsSettingsFaresItemFareData],
	  endpoint: 'AirlineCarriers',
	  routeParamId: 'airCarriersId',
	  removeParamId: 'airGdsFareItem',
	  canDelete: true
	};
	
	var AirlineCarrierFareClassesCountryFareClassItem = {
	  displayName: 'Item',
	  dataAt: 'FareClasses.$AirCarrierFaClassItem.CountryFareClasses.$AirFareClsCuFareClsItem',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [AirlineCarrierFareClassesCountryFareClassCountries, AirlineCarrierFareClassesCountryFareClassBrandName, AirlineCarrierFareClassesCountryFareClassBookingCodes, AirlineCarrierFareClassesCountryFareClassFareBasisCodes],
	  endpoint: 'AirlineCarriers',
	  routeParamId: 'airCarriersId',
	  removeParamId: 'AirFareClsCuFareClsItem',
	  canDelete: true
	};
	
	var AirlineCarrierFareGdsSettingsFares = {
	  displayName: 'Fares',
	  dataAt: 'GdsSettings.$AirFareGdsSetItem.Fares',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: AirlineCarrierFareGdsSettingsFaresItem,
	  gridCols: [{ name: 'Countries', key: 'Countries' }, { name: 'SearchGroupType', key: 'SearchGroupType' }, { name: 'SearchType', key: 'SearchType' }, { name: 'ExcludedTaxCodes', key: 'ExcludedTaxCodes' }]
	};
	
	var AirlineCarrierFareGdsSettingsPreferredCountries = {
	  displayName: 'Preferred Country Pairs',
	  dataAt: 'GdsSettings.$AirFareGdsSetItem.PreferredCountries',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT
	};
	
	var AirlineCarrierFareGdsSettingsName = {
	  displayName: 'Name',
	  dataAt: 'GdsSettings.$AirFareGdsSetItem.Name',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var AirlineCarrierFareClassesCountryFareClass = {
	  displayName: 'Country Fare Class',
	  dataAt: 'FareClasses.$AirCarrierFaClassItem.CountryFareClasses',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: AirlineCarrierFareClassesCountryFareClassItem,
	  gridCols: [{ name: 'Countries', key: 'Countries' }, { name: 'Brand Name', key: 'BrandName' }, { name: 'BookingCodes', key: 'BookingCodes' }, { name: 'FareBasisCodes', key: 'FareBasisCodes' }]
	};
	
	var AirlineCarrierFareClassesGroupType = {
	  displayName: 'Group Type',
	  dataAt: 'FareClasses.$AirCarrierFaClassItem.GroupType',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var AirlineCarrierFareClassesFareBasisCodes = {
	  displayName: 'Fare Basis Codes',
	  dataAt: 'FareClasses.$AirCarrierFaClassItem.FareBasisCodes',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT
	};
	
	var AirlineCarrierFareClassesRefundableRestriction = {
	  displayName: 'Refundable Restriction',
	  dataAt: 'FareClasses.$AirCarrierFaClassItem.RefundableRestriction',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.BOOLEAN_RESTRICTION_SELECT,
	  booleanRestrictionFilter: 'refundableRestrictionDisplay',
	  required: false
	};
	
	var AirlineCarrierFareClassesBookingCodes = {
	  displayName: 'Booking Codes',
	  dataAt: 'FareClasses.$AirCarrierFaClassItem.BookingCodes',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT
	};
	
	var AirlineCarrierFareClassesBrandName = {
	  displayName: 'Brand Name',
	  dataAt: 'FareClasses.$AirCarrierFaClassItem.BrandName',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var AirlineCarrierFareClassesTitle = {
	  displayName: 'Title',
	  dataAt: 'FareClasses.$AirCarrierFaClassItem.Title',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var AirlineCarrierCountryCheckInUrl = {
	  displayName: 'Check-in Url',
	  dataAt: 'CountryData.$AirCountryDataItem.CheckInUrl',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var AirlineCarrierCountryDataCountry = {
	  displayName: 'Country Data',
	  dataAt: 'CountryData.$AirCountryDataItem.Country',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var AirlineCarrierFareGdsSettingsItem = {
	  displayName: 'Item',
	  dataAt: 'GdsSettings.$AirFareGdsSetItem',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [AirlineCarrierFareGdsSettingsName, AirlineCarrierFareGdsSettingsPreferredCountries, AirlineCarrierFareGdsSettingsFares],
	  endpoint: 'AirlineCarriers',
	  routeParamId: 'airCarriersId',
	  removeParamId: 'AirFareGdsSetItem',
	  canDelete: true
	};
	
	var AirlineCarrierFareClassesGridItem = {
	  displayName: 'Fare Class',
	  dataAt: 'FareClasses.$AirCarrierFaClassItem',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [AirlineCarrierFareClassesTitle, AirlineCarrierFareClassesBrandName, AirlineCarrierFareClassesBookingCodes, AirlineCarrierFareClassesFareBasisCodes, AirlineCarrierFareClassesRefundableRestriction, AirlineCarrierFareClassesGroupType, AirlineCarrierFareClassesCountryFareClass],
	  endpoint: 'AirlineCarriers',
	  routeParamId: 'airCarriersId',
	  removeParamId: 'AirCarrierFaClassItem',
	  canDelete: true
	};
	
	var AirlineCarrierCountryDataGridItem = {
	  displayName: 'Country Data',
	  dataAt: 'CountryData.$AirCountryDataItem',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [AirlineCarrierCountryDataCountry, AirlineCarrierCountryCheckInUrl],
	  endpoint: 'AirlineCarriers',
	  routeParamId: 'airCarriersId',
	  removeParamId: 'AirCountryDataItem',
	  canDelete: true
	};
	
	var AirlineCarrierModifiedOn = {
	  displayName: 'Modified On',
	  dataAt: 'ModifiedOn',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var AirlineCarrierModifiedBy = {
	  displayName: 'Modified By',
	  dataAt: 'ModifiedBy',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var AirlineCarrierCreatedOn = {
	  displayName: 'Created On',
	  dataAt: 'CreatedOn',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var AirlineCarrierCreatedBy = {
	  displayName: 'Created By',
	  dataAt: 'CreatedBy',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var AirlineCarrierPartnerAirlines = {
	  displayName: 'Partner Airlines',
	  dataAt: 'PartnerAirlines',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT
	};
	
	var AirlineCarrierLoyaltyPartnershipsSegmentSpecific = {
	  displayName: 'Segment Specific',
	  dataAt: 'LoyaltyPartnerships.$LoyaltyPartnershipItem.SegmentSpecific',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.BOOLEAN
	};
	
	var AirlineCarrierLoyaltyPartnershipsPartnerCode = {
	  displayName: 'Partner Code',
	  dataAt: 'LoyaltyPartnerships.$LoyaltyPartnershipItem.PartnerCode',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var AirlineCarrierLoyaltyPartnershipsItem = {
	  displayName: 'Loyalty Partnerships',
	  dataAt: 'LoyaltyPartnerships.$LoyaltyPartnershipItem',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [AirlineCarrierLoyaltyPartnershipsPartnerCode, AirlineCarrierLoyaltyPartnershipsSegmentSpecific],
	  endpoint: 'AirlineCarriers',
	  routeParamId: 'airCarriersId',
	  removeParamId: 'LoyaltyPartnershipItem',
	  canDelete: true
	};
	
	var AirlineCarrierLoyaltyPartnerships = {
	  displayName: 'Loyalty Partnerships',
	  dataAt: 'LoyaltyPartnerships',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: AirlineCarrierLoyaltyPartnershipsItem,
	  gridCols: [{ name: 'Partner Code', key: 'PartnerCode' }, { name: 'Segment Specific', key: 'SegmentSpecific' }]
	};
	
	var AirlineCarrierFareRulesDocument = {
	  displayName: 'Fare Rules Document',
	  dataAt: 'FareRulesDocument',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.FILE_UPLOADER,
	  fileContainer: 'FlightFareRule',
	  uploadType: 'pdf'
	};
	
	var AirlineCarrierFareGdsSettings = {
	  displayName: 'GDS Fare Settings',
	  dataAt: 'GdsSettings',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: AirlineCarrierFareGdsSettingsItem,
	  gridCols: [{ name: 'Name', key: 'Name' }, { name: 'Preferred Countries', key: 'PreferredCountries' }]
	};
	
	var AirlineCarrierBrandsBrandItemBrandId = {
	  displayName: 'Brand Id',
	  dataAt: 'Brands.$BrandItem.BrandId',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  label: "Brand Id supports Regular Expressions. Regular Expressions must contain ^ or $, otherwise will be treated as not a Regular Expression."
	};
	
	var AirlineCarrierBrandsBrandItemFareClass = {
	  displayName: 'Fare Class',
	  dataAt: 'Brands.$BrandItem.FareClass',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.FARE_CLASS_TYPE_SELECT,
	  required: false
	};
	
	var AirlineCarrierBrandsBrandItemIsBasic = {
	  displayName: 'Basic',
	  dataAt: 'Brands.$BrandItem.IsBasic',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.BOOLEAN
	};
	var AirlineCarrierBrandsBrandItemIsRefundable = {
	  displayName: 'Refundable',
	  dataAt: 'Brands.$BrandItem.IsRefundable',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.BOOLEAN
	};
	var AirlineCarrierBrandsBrandItem = {
	  displayName: 'Brand',
	  dataAt: 'Brands.$BrandItem',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [AirlineCarrierBrandsBrandItemBrandId, AirlineCarrierBrandsBrandItemFareClass, AirlineCarrierBrandsBrandItemIsBasic, AirlineCarrierBrandsBrandItemIsRefundable],
	  endpoint: 'AirlineCarriers',
	  routeParamId: 'airCarriersId',
	  removeParamId: 'BrandItem',
	  canDelete: true
	};
	
	var AirlineCarrierBrands = {
	  displayName: 'Brands',
	  dataAt: 'Brands',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  canAddNew: true,
	  gridItem: AirlineCarrierBrandsBrandItem,
	  gridCols: [{ name: 'Brand Id', key: 'BrandId' }, { name: 'Basic', key: 'IsBasic' }, { name: 'Refundable', key: 'IsRefundable' }, { name: 'FareClass', key: 'FareClass' }]
	};
	
	var AirlineCarrierFareClasses = {
	  displayName: 'Fare Classes',
	  dataAt: 'FareClasses',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  canAddNew: true,
	  gridItem: AirlineCarrierFareClassesGridItem,
	  gridCols: [{ name: 'Title', key: 'Title' }, { name: 'Brand Name', key: 'BrandName' }, { name: 'Group Type', key: 'GroupType' }, { name: 'Booking Codes', key: 'BookingCodes' }, { name: 'Fare Basis Codes', key: 'FareBasisCodes' }]
	};
	
	var AirlineCarrierCountryData = {
	  displayName: 'Country Data',
	  dataAt: 'CountryData',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  canAddNew: true,
	  gridItem: AirlineCarrierCountryDataGridItem,
	  gridCols: [{ name: 'Country', key: 'Country' }, { name: 'Check-in Url', key: 'CheckInUrl' }]
	};
	
	var AirlineCarrierMediumImageUrl = {
	  displayName: 'Medium Image Url',
	  dataAt: 'MediumImageUrl',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.FILE_UPLOADER,
	  fileContainer: 'FlightCarrier',
	  uploadType: 'image'
	};
	
	var AirlineCarrierCarrierLogoUrl = {
	  displayName: 'Carrier Logo Url',
	  dataAt: 'CarrierLogoUrl',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.FILE_UPLOADER,
	  fileContainer: 'FlightCarrier',
	  uploadType: 'image'
	};
	
	var AirlineCarrierBookableFlightNumbers = {
	  displayName: 'Bookable Flight Numbers',
	  dataAt: 'BookableFlightNumbers',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT
	};
	
	var AirlineCarrierCheckInUrl = {
	  displayName: 'Check-in Url',
	  dataAt: 'CheckInUrl',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var AirlineCarrierId = {
	  displayName: 'Identifier',
	  dataAt: 'Id',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var AirlineCarriersAdminPanel = {
	  dataAt: '',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GROUP,
	  tabName: 'Admin',
	  children: [AirlineCarrierCreatedBy, AirlineCarrierCreatedOn, AirlineCarrierModifiedBy, AirlineCarrierModifiedOn]
	};
	
	var AirlineCarrierInternationalFlightNumbers = {
	  displayName: "International Flight Numbers",
	  dataAt: "InternationalFlightNumbers",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT
	};
	
	var AirlineCarrierEnableDynamicFareClassification = {
	  displayName: 'Enable Dynamic Fare Bucketing',
	  dataAt: 'EnableDynamicFareClassification',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.BOOLEAN
	};
	
	var AirlineCarrierEnableMultipleFaresPerFareClass = {
	  displayName: 'Enable Multiple Fares Per Fare Class',
	  dataAt: 'EnableMultipleFaresPerFareClass',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.BOOLEAN
	};
	
	var AirlineCarrierTitle = {
	  displayName: 'Title',
	  dataAt: 'Title',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var AirlineCarrierCode = { displayName: 'Code', dataAt: 'Code', displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT };
	
	var AirlineCarriersInfoPanel = {
	  dataAt: '',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GROUP,
	  tabName: 'Info',
	  children: [AirlineCarrierEnableDynamicFareClassification, AirlineCarrierEnableMultipleFaresPerFareClass, AirlineCarrierId, AirlineCarrierTitle, AirlineCarrierCode, AirlineCarrierCheckInUrl, AirlineCarrierBookableFlightNumbers, AirlineCarrierInternationalFlightNumbers, AirlineCarrierCarrierLogoUrl, AirlineCarrierMediumImageUrl, AirlineCarrierCountryData, AirlineCarrierBrands, AirlineCarrierFareClasses, AirlineCarrierFareGdsSettings, AirlineCarrierFareRulesDocument, AirlineCarrierPartnerAirlines, AirlineCarrierLoyaltyPartnerships]
	};
	
	var AirlineCarriersTabs = {
	  dataAt: '',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TABS,
	  children: [AirlineCarriersInfoPanel, AirlineCarriersAdminPanel]
	};
	
	var AirlineCarrierNameLabel = { dataAt: 'Title', displayAs: _constantsJs2['default'].DISPLAY_AS.SUB_HEADING, label: 'Title:' };
	
	var AirlineCarriersAddResource = {
	  displayAs: _constantsJs2['default'].DISPLAY_AS.ADD_GRID_RESOURCE,
	  displayName: 'Airline Carrier',
	  data: { Title: '', Code: '' },
	  dataAt: '',
	  children: [AirlineCarrierTitle, AirlineCarrierCode],
	  endpoint: 'AirlineCarriers'
	};
	
	var AirlineCarriersResource = {
	  displayName: 'Airline Carrier',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  dataAt: '',
	  children: [AirlineCarrierNameLabel, AirlineCarriersTabs],
	  endpoint: 'AirlineCarriers',
	  routeParamId: 'airCarriersId'
	};
	
	var AirlineCarriersList = {
	  rootNode: true,
	  displayName: 'Airline Carriers',
	  endpoint: 'AirlineCarriers',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  gridItem: AirlineCarriersResource,
	  gridAdd: AirlineCarriersAddResource,
	  iconClass: 'fa-plane',
	  gridCols: [{ name: 'Title', key: 'Title' }, { name: 'Code', key: 'Code' }]
	};
	
	exports['default'] = {
	  AirlineCarriersList: AirlineCarriersList,
	  AirlineCarriersResource: AirlineCarriersResource,
	  AirlineCarriersAddResource: AirlineCarriersAddResource,
	  AirlineCarrierNameLabel: AirlineCarrierNameLabel,
	  AirlineCarriersTabs: AirlineCarriersTabs,
	  AirlineCarrierTitle: AirlineCarrierTitle,
	  AirlineCarrierCode: AirlineCarrierCode,
	  AirlineCarriersInfoPanel: AirlineCarriersInfoPanel,
	  AirlineCarriersAdminPanel: AirlineCarriersAdminPanel,
	  AirlineCarrierId: AirlineCarrierId,
	  AirlineCarrierCheckInUrl: AirlineCarrierCheckInUrl,
	  AirlineCarrierBookableFlightNumbers: AirlineCarrierBookableFlightNumbers,
	  AirlineCarrierCarrierLogoUrl: AirlineCarrierCarrierLogoUrl,
	  AirlineCarrierMediumImageUrl: AirlineCarrierMediumImageUrl,
	  AirlineCarrierCountryData: AirlineCarrierCountryData,
	  AirlineCarrierFareClasses: AirlineCarrierFareClasses,
	  AirlineCarrierFareGdsSettings: AirlineCarrierFareGdsSettings,
	  AirlineCarrierFareRulesDocument: AirlineCarrierFareRulesDocument,
	  AirlineCarrierPartnerAirlines: AirlineCarrierPartnerAirlines,
	  AirlineCarrierLoyaltyPartnerships: AirlineCarrierLoyaltyPartnerships,
	  AirlineCarrierLoyaltyPartnershipsItem: AirlineCarrierLoyaltyPartnershipsItem,
	  AirlineCarrierLoyaltyPartnershipsPartnerCode: AirlineCarrierLoyaltyPartnershipsPartnerCode,
	  AirlineCarrierLoyaltyPartnershipsSegmentSpecific: AirlineCarrierLoyaltyPartnershipsSegmentSpecific,
	  AirlineCarrierCreatedBy: AirlineCarrierCreatedBy,
	  AirlineCarrierCreatedOn: AirlineCarrierCreatedOn,
	  AirlineCarrierModifiedBy: AirlineCarrierModifiedBy,
	  AirlineCarrierModifiedOn: AirlineCarrierModifiedOn,
	  AirlineCarrierCountryDataGridItem: AirlineCarrierCountryDataGridItem,
	  AirlineCarrierFareClassesGridItem: AirlineCarrierFareClassesGridItem,
	  AirlineCarrierFareGdsSettingsItem: AirlineCarrierFareGdsSettingsItem,
	  AirlineCarrierCountryDataCountry: AirlineCarrierCountryDataCountry,
	  AirlineCarrierCountryCheckInUrl: AirlineCarrierCountryCheckInUrl,
	  AirlineCarrierFareClassesTitle: AirlineCarrierFareClassesTitle,
	  AirlineCarrierFareClassesBrandName: AirlineCarrierFareClassesBrandName,
	  AirlineCarrierFareClassesBookingCodes: AirlineCarrierFareClassesBookingCodes,
	  AirlineCarrierFareClassesFareBasisCodes: AirlineCarrierFareClassesFareBasisCodes,
	  AirlineCarrierFareClassesGroupType: AirlineCarrierFareClassesGroupType,
	  AirlineCarrierFareClassesCountryFareClass: AirlineCarrierFareClassesCountryFareClass,
	  AirlineCarrierFareGdsSettingsName: AirlineCarrierFareGdsSettingsName,
	  AirlineCarrierFareGdsSettingsPreferredCountries: AirlineCarrierFareGdsSettingsPreferredCountries,
	  AirlineCarrierFareGdsSettingsFares: AirlineCarrierFareGdsSettingsFares,
	  AirlineCarrierFareClassesCountryFareClassItem: AirlineCarrierFareClassesCountryFareClassItem,
	  AirlineCarrierFareGdsSettingsFaresItem: AirlineCarrierFareGdsSettingsFaresItem,
	  AirlineCarrierFareClassesCountryFareClassCountries: AirlineCarrierFareClassesCountryFareClassCountries,
	  AirlineCarrierFareClassesCountryFareClassBrandName: AirlineCarrierFareClassesCountryFareClassBrandName,
	  AirlineCarrierFareClassesCountryFareClassBookingCodes: AirlineCarrierFareClassesCountryFareClassBookingCodes,
	  AirlineCarrierFareClassesCountryFareClassFareBasisCodes: AirlineCarrierFareClassesCountryFareClassFareBasisCodes,
	  AirlineCarrierFareGdsSettingsFaresItemFareDataItemCountries: AirlineCarrierFareGdsSettingsFaresItemFareDataItemCountries,
	  AirlineCarrierFareGdsSettingsFaresItemFareDataItemSearchGroupType: AirlineCarrierFareGdsSettingsFaresItemFareDataItemSearchGroupType,
	  AirlineCarrierFareGdsSettingsFaresItemFareDataItemSearchType: AirlineCarrierFareGdsSettingsFaresItemFareDataItemSearchType,
	  AirlineCarrierFareGdsSettingsFaresItemFareDataItemExcludedTaxCodes: AirlineCarrierFareGdsSettingsFaresItemFareDataItemExcludedTaxCodes,
	  AirlineCarrierFareGdsSettingsFaresItemFareData: AirlineCarrierFareGdsSettingsFaresItemFareData,
	  AirlineCarrierFareGdsSettingsFaresItemFareDataItem: AirlineCarrierFareGdsSettingsFaresItemFareDataItem,
	  AirlineCarrierFareGdsSettingsFaresItemFareDataItemFareClass: AirlineCarrierFareGdsSettingsFaresItemFareDataItemFareClass,
	  AirlineCarrierFareGdsSettingsFaresItemFareDataItemRateCodes: AirlineCarrierFareGdsSettingsFaresItemFareDataItemRateCodes,
	  AirlineCarrierFareGdsSettingsFaresItemFareDataItemPassengerTypes: AirlineCarrierFareGdsSettingsFaresItemFareDataItemPassengerTypes,
	  AirlineCarrierFareGdsSettingsFaresItemFareDataItemPrivateFares: AirlineCarrierFareGdsSettingsFaresItemFareDataItemPrivateFares,
	  AirlineCarrierFareGdsSettingsFaresItemFareDataItemCabinType: AirlineCarrierFareGdsSettingsFaresItemFareDataItemCabinType,
	  AirlineCarrierFareGdsSettingsFaresItemFareDataItemSpecifiedPassengerTypesOnly: AirlineCarrierFareGdsSettingsFaresItemFareDataItemSpecifiedPassengerTypesOnly,
	  AirlineCarrierEnableDynamicFareClassification: AirlineCarrierEnableDynamicFareClassification,
	  AirlineCarrierEnableMultipleFaresPerFareClass: AirlineCarrierEnableMultipleFaresPerFareClass,
	  AirlineCarrierBrands: AirlineCarrierBrands,
	  AirlineCarrierBrandsBrandItem: AirlineCarrierBrandsBrandItem,
	  AirlineCarrierBrandsBrandItemBrandId: AirlineCarrierBrandsBrandItemBrandId,
	  AirlineCarrierBrandsBrandItemFareClass: AirlineCarrierBrandsBrandItemFareClass,
	  AirlineCarrierBrandsBrandItemIsBasic: AirlineCarrierBrandsBrandItemIsBasic,
	  AirlineCarrierBrandsBrandItemIsRefundable: AirlineCarrierBrandsBrandItemIsRefundable
	};
	module.exports = exports['default'];

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var ModifiedOn = {
	  displayName: 'Modified on',
	  dataAt: 'ModifiedOn',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var ModifiedBy = {
	  displayName: 'Modified by',
	  dataAt: 'ModifiedBy',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var CreatedOn = {
	  displayName: 'Created on',
	  dataAt: 'CreatedOn',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var CreatedBy = {
	  displayName: 'Created by',
	  dataAt: 'CreatedBy',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var Id = {
	  displayName: 'Identifier',
	  dataAt: 'Id',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var AdminPanel = {
	  tabName: 'Admin',
	  dataAt: '',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GROUP,
	  children: [CreatedBy, CreatedOn, ModifiedBy, ModifiedOn]
	};
	
	var ExpiryYear = {
	  displayName: 'Expiry Year',
	  dataAt: 'ExpiryYear',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.SELECT,
	  optionsAt: 'expiryYears',
	  required: true
	};
	
	var ExpiryMonth = {
	  displayName: 'Expiry Month',
	  dataAt: 'ExpiryMonth',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.SELECT,
	  optionsAt: 'expiryMonths',
	  required: true
	};
	
	var DisplayNumber = {
	  displayName: 'Card Number',
	  dataAt: 'DisplayNumber',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var CardHolder = {
	  displayName: 'Card Holder',
	  dataAt: 'CardHolder',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var CardType = {
	  displayName: 'Card Type',
	  dataAt: 'CardType',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.SELECT,
	  optionsAt: 'cardType',
	  required: true
	};
	
	var CardTitle = {
	  displayName: 'Card Title',
	  dataAt: 'Title',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var Remarks = {
	  displayName: 'Remarks',
	  dataAt: 'Remarks',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var CreditCardInfoPanel = {
	  dataAt: '',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GROUP,
	  tabName: 'Info',
	  children: [Id, CardTitle, CardType, CardHolder, Remarks, DisplayNumber, ExpiryMonth, ExpiryYear]
	};
	
	var CreditCardTabs = {
	  dataAt: '',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TABS,
	  children: [CreditCardInfoPanel, AdminPanel]
	};
	
	var CreditCardsAddResource = {
	  displayAs: _constantsJs2['default'].DISPLAY_AS.ADD_GRID_RESOURCE,
	  displayName: 'Credit Card',
	  data: {
	    CardType: '',
	    CardHolder: '',
	    DisplayNumber: '',
	    ExpiryMonth: '',
	    ExpiryYear: ''
	  },
	  dataAt: '',
	  children: [CardTitle, CardType, CardHolder, Remarks, DisplayNumber, ExpiryMonth, ExpiryYear],
	  endpoint: 'CreditCards'
	};
	
	var CreditCardsResource = {
	  displayName: 'Credit Card',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  dataAt: '',
	  children: [CreditCardTabs],
	  endpoint: 'CreditCards',
	  routeParamId: 'ccId',
	  canDelete: true,
	  deleteOnBackend: true
	};
	
	var CreditCardsList = {
	  rootNode: true,
	  displayName: 'Credit Cards',
	  endpoint: 'CreditCards',
	  iconClass: 'fa-credit-card',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  gridItem: CreditCardsResource,
	  gridAdd: CreditCardsAddResource,
	  gridCols: [{ name: 'Title', key: 'Title' }, { name: 'Number', key: 'DisplayNumber' }, { name: 'Card Holder', key: 'CardHolder' }, { name: 'Remarks', key: 'Remarks' }, { name: 'Card Type', key: 'CardType' }, { name: 'Expiry Month', key: 'ExpiryMonth' }, { name: 'Expiry Year', key: 'ExpiryYear' }]
	};
	
	exports['default'] = {
	  CreditCardsList: CreditCardsList,
	  CreditCardsResource: CreditCardsResource,
	  CreditCardsAddResource: CreditCardsAddResource,
	  CreditCardTabs: CreditCardTabs,
	  CardTitle: CardTitle,
	  CardType: CardType,
	  CardHolder: CardHolder,
	  DisplayNumber: DisplayNumber,
	  ExpiryMonth: ExpiryMonth,
	  ExpiryYear: ExpiryYear,
	  CreditCardInfoPanel: CreditCardInfoPanel,
	  AdminPanel: AdminPanel,
	  Id: Id,
	  CreatedBy: CreatedBy,
	  CreatedOn: CreatedOn,
	  ModifiedBy: ModifiedBy,
	  ModifiedOn: ModifiedOn
	};
	module.exports = exports['default'];

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var CountryPnrFinishingRemarksGdsRemarksSeatRemarks = {
	  displayName: "Seat Remarks",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.GdsRemarks.$GdsRemarksItem.SeatRemarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksGdsRemarksAncillaryRemarks = {
	  displayName: "Ancillary Remarks",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.GdsRemarks.$GdsRemarksItem.AncillaryRemarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksGdsRemarksFinishingRemarksExclusions = {
	  displayName: "Finishing Remarks Exclusions",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.GdsRemarks.$GdsRemarksItem.FinishingRemarks.Exclusions",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksGdsRemarksFinishingRemarksRemarks = {
	  displayName: "Finishing Remarks",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.GdsRemarks.$GdsRemarksItem.FinishingRemarks.Remarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksGdsRemarksName = {
	  displayName: "Name",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.GdsRemarks.$GdsRemarksItem.Name",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var CountryPnrFinishingRemarksGdsRemarksItem = {
	  displayName: "Item",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.GdsRemarks.$GdsRemarksItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [CountryPnrFinishingRemarksGdsRemarksName, CountryPnrFinishingRemarksGdsRemarksFinishingRemarksRemarks, CountryPnrFinishingRemarksGdsRemarksFinishingRemarksExclusions, CountryPnrFinishingRemarksGdsRemarksSeatRemarks, CountryPnrFinishingRemarksGdsRemarksAncillaryRemarks],
	  endpoint: "Settings",
	  removeParamId: "GdsRemarksItem",
	  canDelete: true
	};
	
	var GdsSettings = {
	  displayName: "Settings",
	  dataAt: "Gds.$GdsItem.Settings",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.KEY_VALUE_PAIRS,
	  keyOptions: "GDSSettingsOptions"
	};
	
	var UnusedTicketSettings = {
	  displayName: "Enabled Unused Ticket Providers",
	  dataAt: "EnabledUnusedTicketProviders",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.MULTI_SELECT,
	  optionsAt: "UnusedTicketProviderTypes"
	};
	
	var DateFormatLongSettings = {
	  displayName: "Date Format Long",
	  dataAt: "DateTimeSettings.DateFormatLong",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  label: "Default format: MMM Do YYYY."
	};
	
	var DateFormatMediumSettings = {
	  displayName: "Date Format Medium",
	  dataAt: "DateTimeSettings.DateFormatMedium",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  label: "Default format: MMM DD, YYYY."
	};
	
	var DateFormatShortSettings = {
	  displayName: "Date Format Short",
	  dataAt: "DateTimeSettings.DateFormatShort",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  label: "Default format: MM/DD/YYYY."
	};
	
	var DatetimeFormatLongSettings = {
	  displayName: "Datetime Format",
	  dataAt: "DateTimeSettings.DateTimeFormatLong",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  label: "Default format: ddd, MMM D YYYY [at] h:mm a."
	};
	
	var TimeFormatLongSettings = {
	  displayName: "Time Format Long",
	  dataAt: "DateTimeSettings.TimeFormatLong",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  label: "Default format: h:mm a."
	};
	
	var ItineraryValidatorSettings = {
	  displayName: "Enabled Itinerary Validators",
	  dataAt: "EnabledItineraryValidators",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.MULTI_SELECT,
	  optionsAt: "ItineraryValidatorTypes"
	};
	
	var BookingThreshold = {
	  displayName: "Booking Threshold (In Minutes)",
	  dataAt: "BookingThresholdInMinutes",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RANGE,
	  min: 0,
	  max: 36000,
	  step: 15,
	  defaultValue: 0,
	  units: "minutes"
	};
	
	var GdsEnabled = {
	  displayName: "Enabled",
	  dataAt: "Gds.$GdsItem.Enabled",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	var GdsName = {
	  displayName: "Name",
	  dataAt: "Gds.$GdsItem.Name",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var GdsPassiveFlightSegmentRemarkTemplate = {
	  displayName: "Item",
	  dataAt: "Gds.$GdsItem.PassiveFlightSegmentRemarks.$RemarkTemplate",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [{
	    displayName: "Type",
	    dataAt: "Gds.$GdsItem.PassiveFlightSegmentRemarks.$RemarkTemplate.Type",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	    optionsAt: "RemarkType"
	  }, {
	    displayName: "Template",
	    dataAt: "Gds.$GdsItem.PassiveFlightSegmentRemarks.$RemarkTemplate.Template",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	  }],
	  endpoint: "Settings",
	  removeParamId: "RemarkTemplate",
	  canDelete: true
	};
	
	var GdsPassiveFlightSegmentRemarks = {
	  displayName: "Passive Flight Segment Remarks",
	  dataAt: "Gds.$GdsItem.PassiveFlightSegmentRemarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: GdsPassiveFlightSegmentRemarkTemplate,
	  gridCols: [{ name: "Type", key: "Type" }, { name: "Template", key: "Template" }]
	};
	
	var GuestTravellersTitlesEnabled = {
	  displayName: "Enabled",
	  dataAt: "GuestTravellersTitles.$gusTravTitleItem.Enabled",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	var GuestTravellersTitlesValid = {
	  displayName: "Valid",
	  dataAt: "GuestTravellersTitles.$gusTravTitleItem.Valid",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	var GuestTravellersTitlesIsDeleted = {
	  displayName: "Deleted",
	  dataAt: "GuestTravellersTitles.$gusTravTitleItem.IsDeleted",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	var GuestTravellersTitlesDisplayOrder = {
	  displayName: "Display Order",
	  dataAt: "GuestTravellersTitles.$gusTravTitleItem.DisplayOrder",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var GuestTravellersTitlesName = {
	  displayName: "Name",
	  dataAt: "GuestTravellersTitles.$gusTravTitleItem.Name",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var GuestTravellersTitlesCode = {
	  displayName: "Code",
	  dataAt: "GuestTravellersTitles.$gusTravTitleItem.Code",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var VehicleDefaultsImageUrl = {
	  displayName: "Image Url",
	  dataAt: "VehicleDefaults.$vehicleDefaultItem.ImageUrl",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.FILE_UPLOADER,
	  fileContainer: "CarSupplier",
	  uploadType: "image"
	};
	
	var VehicleDefaultsTypeCode = {
	  displayName: "Type Code",
	  dataAt: "VehicleDefaults.$vehicleDefaultItem.TypeCode",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var VehicleDefaultsCategoryCode = {
	  displayName: "Category Code",
	  dataAt: "VehicleDefaults.$vehicleDefaultItem.CategoryCode",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var VehicleDefaultsName = {
	  displayName: "Name",
	  dataAt: "VehicleDefaults.$vehicleDefaultItem.Name",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var TermsAndConditionsSectionType = {
	  displayName: "Section Type",
	  dataAt: "TermsAndConditions.$termsItem.SectionType",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "SectionType"
	};
	
	var TermsAndConditionsText = {
	  displayName: "Text",
	  dataAt: "TermsAndConditions.$termsItem.Text",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_AREA
	};
	
	var TermsAndConditionsSegmentTypes = {
	  displayName: "Segment Types",
	  dataAt: "TermsAndConditions.$termsItem.SegmentTypes",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.MULTI_SELECT,
	  optionsAt: "SegmentTypes"
	};
	
	var TermsAndConditionsCountries = {
	  displayName: "Countries",
	  dataAt: "TermsAndConditions.$termsItem.Countries",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var FlightFareDataFareClassType = {
	  displayName: "Type",
	  dataAt: "FlightFareData.$flFareDataItem.Type",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.FARE_CLASS_TYPE_SELECT,
	  required: true
	};
	
	var FlightFareDataMixedTypeRestriction = {
	  displayName: "Mixed Type Restriction",
	  dataAt: "FlightFareData.$flFareDataItem.MixedTypeRestriction",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN_RESTRICTION_SELECT,
	  required: true
	};
	
	var FlightFareDataRefundableRestriction = {
	  displayName: "Refundable Restriction",
	  dataAt: "FlightFareData.$flFareDataItem.RefundableRestriction",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN_RESTRICTION_SELECT,
	  booleanRestrictionFilter: "refundableRestrictionDisplay",
	  required: true
	};
	
	var FlightFareDataRefundPenaltyRestriction = {
	  displayName: "Refund Penalty Restriction",
	  dataAt: "FlightFareData.$flFareDataItem.RefundPenaltyRestriction",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN_RESTRICTION_SELECT,
	  required: true
	};
	
	var FlightFareDataChangeableRestriction = {
	  displayName: "Changeable Restriction",
	  dataAt: "FlightFareData.$flFareDataItem.ChangeableRestriction",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN_RESTRICTION_SELECT,
	  booleanRestrictionFilter: "changeableRestrictionDisplay",
	  required: true
	};
	
	var FlightFareDataBasicRestriction = {
	  displayName: "Basic Restriction",
	  dataAt: "FlightFareData.$flFareDataItem.BasicRestriction",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN_RESTRICTION_SELECT,
	  required: true
	};
	
	var FlightFareDataName = {
	  displayName: "Name",
	  dataAt: "FlightFareData.$flFareDataItem.Name",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var ErrorMessagesValue = {
	  displayName: "Value",
	  dataAt: "ErrorMessages.$ErMesItem.Value",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var ErrorMessagesKey = {
	  displayName: "Key",
	  dataAt: "ErrorMessages.$ErMesItem.Key",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var ErrorMessagesUseRegularExpressions = {
	  displayName: "Use Regular Expressions",
	  dataAt: "ErrorMessages.$ErMesItem.UseRegularExpressions",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	var FlightFareBucketClassesFareClasses = {
	  displayName: "Fare Classes",
	  dataAt: "FlightFareBucketClasses.$ffbcFlightFareBucketClassesItem.FareClasses",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var FlightFareBucketClassesSort = {
	  displayName: "Sort",
	  dataAt: "FlightFareBucketClasses.$ffbcFlightFareBucketClassesItem.Sort",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  inputType: "number"
	};
	
	var FlightFareBucketClassesName = {
	  displayName: "Name",
	  dataAt: "FlightFareBucketClasses.$ffbcFlightFareBucketClassesItem.Name",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var SalesAgentsIsEnabled = {
	  displayName: "Is Enabled",
	  dataAt: "SalesAgents.$salSalesAgentsItem.IsEnabled",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	var SalesAgentsName = {
	  displayName: "Name",
	  dataAt: "SalesAgents.$salSalesAgentsItem.Name",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var SalesAgentsCode = {
	  displayName: "Code",
	  dataAt: "SalesAgents.$salSalesAgentsItem.Code",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var PerDiemDefaultRatesEffectiveDate = {
	  displayName: "Effective Date",
	  dataAt: "PerDiemDefaultRates.$pdPerDiemDefaultRatesItem.EffectiveDate",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var PerDiemDefaultRatesCountry = {
	  displayName: "Country",
	  dataAt: "PerDiemDefaultRates.$pdPerDiemDefaultRatesItem.Country",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var PerDiemDefaultRatesAmount = {
	  displayName: "Amount",
	  dataAt: "PerDiemDefaultRates.$pdPerDiemDefaultRatesItem.Amount",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var PerDiemMappingsValue = {
	  displayName: "Value",
	  dataAt: "PerDiemMappings.$pdPerDiemMappingsItem.Value",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var PerDiemMappingsAlternateValues = {
	  displayName: "Alternate Values",
	  dataAt: "PerDiemMappings.$pdPerDiemMappingsItem.AlternateValues",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var PerDiemMappingsType = {
	  displayName: "Type",
	  dataAt: "PerDiemMappings.$pdPerDiemMappingsItem.Type",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "PerDiemMappingsTypes",
	  defaultValue: "City"
	};
	
	var HotelRateCategoriesName = {
	  displayName: "Rate Category Name",
	  dataAt: "HotelRateCategories.$hrcHotelRateCategoriesItem.Name",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var HotelRateCategoriesKeywords = {
	  displayName: "Keywords",
	  dataAt: "HotelRateCategories.$hrcHotelRateCategoriesItem.Keywords",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var HotelRateCategoriesContractCodes = {
	  displayName: "Contract Codes",
	  dataAt: "HotelRateCategories.$hrcHotelRateCategoriesItem.ContractCodes",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var HotelRateCategoriesSabreSourceType = {
	  displayName: "Sabre Source Type",
	  dataAt: "HotelRateCategories.$hrcHotelRateCategoriesItem.SabreSourceType",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var HotelRateCategoriesFilterDisplayName = {
	  displayName: "Filter Display Name",
	  dataAt: "HotelRateCategories.$hrcHotelRateCategoriesItem.FilterDisplayName",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var HotelRateCategoriesLogoUrl = {
	  displayName: "Upload Rate Logo",
	  dataAt: "HotelRateCategories.$hrcHotelRateCategoriesItem.LogoUrl",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.FILE_UPLOADER,
	  fileContainer: 'RateCategory',
	  uploadType: 'svg'
	};
	
	var HotelRateCategoriesDisplayOnTop = {
	  displayName: "Display On Top",
	  dataAt: "HotelRateCategories.$hrcHotelRateCategoriesItem.DisplayOnTop",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	var HotelRateCategoriesIsAggregator = {
	  displayName: "Show this as an aggregator",
	  dataAt: "HotelRateCategories.$hrcHotelRateCategoriesItem.IsAggregator",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	var HotelAmenityFiltersDisplayName = {
	  displayName: "Display Name",
	  dataAt: "HotelAmenityFilters.$hafHotelAmenityFiltersItem.DisplayName",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var HotelAmenityFiltersMostPopular = {
	  displayName: "Show in Most Popular Category",
	  dataAt: "HotelAmenityFilters.$hafHotelAmenityFiltersItem.MostPopular",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	var HotelAmenityFiltersAmenities = {
	  displayName: "Amenities",
	  dataAt: "HotelAmenityFilters.$hafHotelAmenityFiltersItem.Amenities",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var RailCharacterMappingsSpecialCharacter = {
	  displayName: "Special Character",
	  dataAt: "RailCharacterMappings.$rcmRailCharacterMappingsItem.SpecialCharacter",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var RailCharacterMappingsSystemCharacter = {
	  displayName: "System Character",
	  dataAt: "RailCharacterMappings.$rcmRailCharacterMappingsItem.SystemCharacter",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var CountryPnrFinishingRemarksGdsRemarksGrid = {
	  displayName: "Gds Remarks",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.GdsRemarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: CountryPnrFinishingRemarksGdsRemarksItem,
	  gridCols: [{ name: "Name", key: "Name" }]
	};
	
	var CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredRemarksRemarks = {
	  displayName: "Expired Remarks",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ExpiredRemarks.Remarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredRemarksExclusions = {
	  displayName: "Expired Remarks Exclusions",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ExpiredRemarks.Exclusions",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksNonRefundableRemarks = {
	  displayName: "Declined Remarks NonRefundable Remarks",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.DeclinedRemarksNonRefundable.Remarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksNonRefundableExclusions = {
	  displayName: "Declined Remarks NonRefundable Exclusions",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.DeclinedRemarksNonRefundable.Exclusions",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksRemarks = {
	  displayName: "Declined Remarks",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.DeclinedRemarks.Remarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksExclusions = {
	  displayName: "Declined Remarks Exclusions",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.DeclinedRemarks.Exclusions",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksAdditionalPnrRemarksApprovalRemarksRemarks = {
	  displayName: "Approval Remarks",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ApprovalRemarks.Remarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksAdditionalPnrRemarksApprovalRemarksExclusions = {
	  displayName: "Approval Remarks Exclusions",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ApprovalRemarks.Exclusions",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksAdditionalPnrRemarksCancelRemarksRemarks = {
	  displayName: "Cancel Remarks",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.CancelRemarks.Remarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksAdditionalPnrRemarksCancelRemarksExclusions = {
	  displayName: "Cancel Remarks Exclusions",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.CancelRemarks.Exclusions",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksAdditionalPnrRemarksModifyRemarksRemarks = {
	  displayName: "Modify Remarks",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ModifyRemarks.Remarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksAdditionalPnrRemarksModifyRemarksExclusions = {
	  displayName: "Modify Remarks Exclusions",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ModifyRemarks.Exclusions",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksAdditionalPnrRemarksUserHoldRemarksRemarks = {
	  displayName: "User Hold Remarks",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.UserHoldRemarks.Remarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksAdditionalPnrRemarksUserHoldRemarksExclusions = {
	  displayName: "User Hold Remarks Exclusions",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.UserHoldRemarks.Exclusions",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredUserHoldRemarksRemarks = {
	  displayName: "Expired User Hold Remarks",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ExpiredUserHoldRemarks.Remarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredUserHoldRemarksExclusions = {
	  displayName: "Expired User Hold Remarks Exclusions",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ExpiredUserHoldRemarks.Exclusions",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	//
	var CountryPnrFinishingRemarksAdditionalPnrRemarksConfirmedUserHoldRemarksRemarks = {
	  displayName: "Confirmed User Hold Remarks",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ConfirmedUserHoldRemarks.Remarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksAdditionalPnrRemarksConfirmedUserHoldRemarksExclusions = {
	  displayName: "Confirmed User Hold Remarks Exclusions",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ConfirmedUserHoldRemarks.Exclusions",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksAdditionalPnrRemarksFinishBookingRemarksRemarks = {
	  displayName: "Finish Booking Remarks",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.FinishBookingRemarks.Remarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksAdditionalPnrRemarksFinisherBookingRemarksExclusions = {
	  displayName: "Finish Booking Remarks Exclusions",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.FinishBookingRemarks.Exclusions",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	//
	
	var CountryPnrFinishingRemarksPnrFinishingRemarksGuestTravellerRemarksRemarks = {
	  displayName: "Guest Traveller Remarks",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.PnrFinishingRemarks.GuestTravellerRemarks.Remarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksPnrFinishingRemarksGuestTravellerRemarksExclusions = {
	  displayName: "Guest Traveller Remarks Exclusions",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.PnrFinishingRemarks.GuestTravellerRemarks.Exclusions",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksPnrFinishingRemarksPreTripApprovalRemarksRemarks = {
	  displayName: "Pre Trip Approval Remarks Remarks",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.PnrFinishingRemarks.PreTripApprovalRemarks.Remarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksPnrFinishingRemarksPreTripApprovalRemarksExclusions = {
	  displayName: "Pre Trip Approval Remarks Exclusions",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.PnrFinishingRemarks.PreTripApprovalRemarks.Exclusions",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksHostCommands = {
	  displayName: "Host Commands",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.HostCommands",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksHostCommandsInfo = {
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SUB_HEADING,
	  html: "<ol start='0'>" + "<li>Debtor</li>" + "<li>ItineraryPassenger</li>" + "<li>object CurrentUser</li>" + "<li>CreditCardDetails</li>" + "<li>string PassengerCreditCardShortYear</li>" + "<li>List&ltAirTicket&gt</li>" + "<li>List&ltRailTicket&gt</li>" + "</ol>"
	};
	
	var CountryPnrFinishingRemarksPnrFinishingRemarksStandardRemarks = {
	  displayName: "Standard Remarks",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.PnrFinishingRemarks.StandardRemarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksPnrFinishingRemarksStandardRemarksInfo = {
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SUB_HEADING,
	  html: "<ol start='0'>" + "<li>Itinerary</li>" + "<li>ItineraryPassenger</li>" + "<li>List&ltItineraryPassengerHotel&gt</li>" + "<li>List&ltItineraryPassengerFlight&gt</li>" + "<li>List&ltItineraryPassengerCar&gt</li>" + "<li>Debtor</li>" + "<li>string Role</li>" + "<li>object GuestTraveller</li>" + "<li>ItineraryPassengerApprover</li>" + "<li>List&ltItineraryPassengerRail&gt</li>" + "<li>{ TimePolicyCode, TimePolicyTitle, IsInTimePolicy, LeadTimeForInPolicyBooking }</li>" + "<li>List&ltItineraryPassengerGroundTrans&gt</li>" + "<li>DateTime.Now</li>" + "<li>List&ltAirTicket&gt</li>" + "<li>List&ltRailTicket&gt</li>" + "<li>List&ltVirtualPayments&gt</li>" + "<li>List&ltVirtualPaymentCanceled&gt</li>" + "<li>{ LoggedInUserEmail, LoggedInUserName, LoggedInEmployeeCode, LoggedInEmployeeNumber, LoggedInEmployeeDepartment, LoggedInEmployeeCostCenter, LoggedInUserRole }</li>" + "</ol>"
	};
	
	var CountryPnrFinishingRemarksPnrFinishingRemarksExclusionRemarks = {
	  displayName: "Exclusion Remarks",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.PnrFinishingRemarks.ExclusionRemarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryPnrFinishingRemarksCountryCode = {
	  displayName: "Country Code",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.CountryCode",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.COUNTRY_SELECT,
	  selectType: "single"
	};
	
	var CreditCardMappingsCardProvider = {
	  displayName: "Card Provider",
	  dataAt: "CreditCardMappings.$ccCreditCardMappingsItem.CardProvider",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var CreditCardMappingsCardTypes = {
	  displayName: "Card Types",
	  dataAt: "CreditCardMappings.$ccCreditCardMappingsItem.CardTypes",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var GdssettingsItem = {
	  displayName: "Gds Item",
	  dataAt: "Gds.$GdsItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [GdsName, GdsEnabled, {
	    displayAs: _constantsJs2["default"].DISPLAY_AS.SUB_HEADING,
	    html: "<a href=\"https://trvlcorp.sharepoint.com/:x:/r/sites/ctmna-Technology/Shared%20Documents/Lightning/LightningConfig_GdsKeywords.xlsx?d=w67300e626de94f7b8e6bb5f3366ffa29&csf=1&web=1&e=ttOATy\" target=\"_blank\">Sharepoint - GDS Keyword Dictionary</a>"
	  }, GdsSettings, GdsPassiveFlightSegmentRemarks],
	  endpoint: "Settings",
	  removeParamId: "GdsItem",
	  canDelete: true
	};
	
	var GuestTravellersTitlesGroup = {
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  dataAt: "",
	  children: [GuestTravellersTitlesCode, GuestTravellersTitlesName, GuestTravellersTitlesDisplayOrder, GuestTravellersTitlesIsDeleted, GuestTravellersTitlesValid, GuestTravellersTitlesEnabled]
	};
	
	var VehicleDefaultsItem = {
	  displayName: "Item",
	  dataAt: "VehicleDefaults.$vehicleDefaultItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [VehicleDefaultsName, VehicleDefaultsCategoryCode, VehicleDefaultsTypeCode, {
	    displayAs: _constantsJs2["default"].DISPLAY_AS.SUB_HEADING,
	    label: "Type Code: Single Alpha character for Sabre.Car TypeCode and full VehicleType name for Ground Transport"
	  }, VehicleDefaultsImageUrl],
	  endpoint: "Settings",
	  removeParamId: "vehicleDefaultItem",
	  canDelete: true
	};
	
	var VehicleEmissionCarCategoryCodes = {
	  displayName: "Car Category Codes",
	  dataAt: "VehicleEmissions.$vehicleEmissionItem.CarCategoryCodes",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var VehicleEmissionFuelCodes = {
	  displayName: "Fuel Codes",
	  dataAt: "VehicleEmissions.$vehicleEmissionItem.FuelCodes",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var VehicleEmissionValue = {
	  displayName: "Kilograms of Carbon Dioxide Per Kilometer (Kg CO2 per Km)",
	  dataAt: "VehicleEmissions.$vehicleEmissionItem.EmissionValuePerKm",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var VehicleEmissionsItem = {
	  displayName: "Item",
	  dataAt: "VehicleEmissions.$vehicleEmissionItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [VehicleEmissionCarCategoryCodes, VehicleEmissionFuelCodes, VehicleEmissionValue],
	  endpoint: "Settings",
	  removeParamId: "vehicleEmissionItem",
	  canDelete: true
	};
	
	var TermsAndConditionsSettingsItem = {
	  displayName: "Item",
	  dataAt: "TermsAndConditions.$termsItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [TermsAndConditionsSectionType, TermsAndConditionsCountries, TermsAndConditionsSegmentTypes, TermsAndConditionsText],
	  endpoint: "Settings",
	  removeParamId: "termsItem",
	  canDelete: true
	};
	
	var FlightFareDataItem = {
	  displayName: "Item",
	  dataAt: "FlightFareData.$flFareDataItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [FlightFareDataName, FlightFareDataFareClassType, FlightFareDataMixedTypeRestriction, FlightFareDataRefundableRestriction, FlightFareDataRefundPenaltyRestriction, FlightFareDataChangeableRestriction, FlightFareDataBasicRestriction],
	  endpoint: "Settings",
	  removeParamId: "flFareDataItem",
	  canDelete: true
	};
	
	var ErrorMessagesItem = {
	  displayName: "Item",
	  dataAt: "ErrorMessages.$ErMesItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [ErrorMessagesKey, ErrorMessagesValue, ErrorMessagesUseRegularExpressions],
	  endpoint: "Settings",
	  removeParamId: "ErMesItem",
	  canDelete: true
	};
	
	var FlightFareBucketClassesItem = {
	  displayName: "Item",
	  dataAt: "FlightFareBucketClasses.$ffbcFlightFareBucketClassesItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [FlightFareBucketClassesName, FlightFareBucketClassesSort, FlightFareBucketClassesFareClasses],
	  endpoint: "Settings",
	  removeParamId: "ffbcFlightFareBucketClassesItem",
	  canDelete: true
	};
	
	var SalesAgentsItem = {
	  displayName: "Item",
	  dataAt: "SalesAgents.$salSalesAgentsItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [SalesAgentsIsEnabled, SalesAgentsName, SalesAgentsCode],
	  endpoint: "Settings",
	  removeParamId: "salSalesAgentsItem",
	  canDelete: true
	};
	
	var PerDiemDefaultRatesItem = {
	  displayName: "Item",
	  dataAt: "PerDiemDefaultRates.$pdPerDiemDefaultRatesItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [PerDiemDefaultRatesEffectiveDate, PerDiemDefaultRatesCountry, PerDiemDefaultRatesAmount],
	  endpoint: "Settings",
	  removeParamId: "pdPerDiemDefaultRatesItem",
	  canDelete: true
	};
	
	var PerDiemMappingsItem = {
	  displayName: "Item",
	  dataAt: "PerDiemMappings.$pdPerDiemMappingsItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [PerDiemMappingsValue, PerDiemMappingsAlternateValues, PerDiemMappingsType],
	  endpoint: "Settings",
	  removeParamId: "pdPerDiemMappingsItem",
	  canDelete: true
	};
	
	var HotelRateCategoriesItem = {
	  displayName: "Item",
	  dataAt: "HotelRateCategories.$hrcHotelRateCategoriesItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [HotelRateCategoriesName, HotelRateCategoriesKeywords, HotelRateCategoriesContractCodes, HotelRateCategoriesSabreSourceType, HotelRateCategoriesFilterDisplayName, HotelRateCategoriesDisplayOnTop, HotelRateCategoriesIsAggregator, HotelRateCategoriesLogoUrl],
	  endpoint: "Settings",
	  removeParamId: "hrcHotelRateCategoriesItem",
	  canDelete: true
	};
	
	var HotelAmenityFiltersItem = {
	  displayName: "Item",
	  dataAt: "HotelAmenityFilters.$hafHotelAmenityFiltersItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [HotelAmenityFiltersDisplayName, HotelAmenityFiltersMostPopular, HotelAmenityFiltersAmenities],
	  endpoint: "Settings",
	  removeParamId: "hafHotelAmenityFiltersItem",
	  canDelete: true
	};
	
	var RailCharacterMappingsItem = {
	  displayName: "Item",
	  dataAt: "RailCharacterMappings.$rcmRailCharacterMappingsItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [RailCharacterMappingsSpecialCharacter, RailCharacterMappingsSystemCharacter],
	  endpoint: "Settings",
	  removeParamId: "rcmRailCharacterMappingsItem",
	  canDelete: true
	};
	
	var CountryPnrFinishingRemarksGridItem = {
	  displayName: "Country PNR Finishing Remark",
	  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [CountryPnrFinishingRemarksCountryCode, CountryPnrFinishingRemarksPnrFinishingRemarksExclusionRemarks, CountryPnrFinishingRemarksPnrFinishingRemarksStandardRemarks, CountryPnrFinishingRemarksPnrFinishingRemarksStandardRemarksInfo, CountryPnrFinishingRemarksHostCommands, CountryPnrFinishingRemarksHostCommandsInfo, CountryPnrFinishingRemarksPnrFinishingRemarksPreTripApprovalRemarksExclusions, CountryPnrFinishingRemarksPnrFinishingRemarksPreTripApprovalRemarksRemarks, CountryPnrFinishingRemarksPnrFinishingRemarksGuestTravellerRemarksExclusions, CountryPnrFinishingRemarksPnrFinishingRemarksGuestTravellerRemarksRemarks, CountryPnrFinishingRemarksAdditionalPnrRemarksApprovalRemarksExclusions, CountryPnrFinishingRemarksAdditionalPnrRemarksApprovalRemarksRemarks, CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksExclusions, CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksRemarks, CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksNonRefundableExclusions, CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksNonRefundableRemarks, CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredRemarksExclusions, CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredRemarksRemarks, CountryPnrFinishingRemarksAdditionalPnrRemarksCancelRemarksRemarks, CountryPnrFinishingRemarksAdditionalPnrRemarksCancelRemarksExclusions, CountryPnrFinishingRemarksAdditionalPnrRemarksModifyRemarksRemarks, CountryPnrFinishingRemarksAdditionalPnrRemarksModifyRemarksExclusions, CountryPnrFinishingRemarksAdditionalPnrRemarksUserHoldRemarksRemarks, CountryPnrFinishingRemarksAdditionalPnrRemarksUserHoldRemarksExclusions, CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredUserHoldRemarksRemarks, CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredUserHoldRemarksExclusions, CountryPnrFinishingRemarksAdditionalPnrRemarksConfirmedUserHoldRemarksRemarks, CountryPnrFinishingRemarksAdditionalPnrRemarksConfirmedUserHoldRemarksExclusions, CountryPnrFinishingRemarksAdditionalPnrRemarksFinishBookingRemarksRemarks, CountryPnrFinishingRemarksAdditionalPnrRemarksFinisherBookingRemarksExclusions, CountryPnrFinishingRemarksGdsRemarksGrid],
	  endpoint: "Settings",
	  routeParamId: "",
	  removeParamId: "CntPnrFinRemItem",
	  canDelete: true
	};
	
	var CreditCardMappingsItem = {
	  displayName: "Item",
	  dataAt: "CreditCardMappings.$ccCreditCardMappingsItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [CreditCardMappingsCardProvider, CreditCardMappingsCardTypes],
	  endpoint: "Settings",
	  removeParamId: "ccCreditCardMappingsItem",
	  canDelete: true
	};
	
	var Gdssettings = {
	  displayName: "Gds",
	  dataAt: "Gds",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: GdssettingsItem,
	  gridCols: [{ name: "Name", key: "Name" }, { name: "Enabled", key: "Enabled" }]
	};
	
	var PnrFinishingRemarksPanelStandardRemarks = {
	  displayName: "Standard Remarks",
	  dataAt: "PnrFinishingRemarks.StandardRemarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var PnrFinishingRemarksPanelPreTripApprovalRemarks = {
	  displayName: "Pre Trip Approval Remarks",
	  dataAt: "PnrFinishingRemarks.PreTripApprovalRemarks.Remarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var PnrFinishingRemarksPanelPreTripApprovalExclusions = {
	  displayName: "Pre Trip Approval Exclusions",
	  dataAt: "PnrFinishingRemarks.PreTripApprovalRemarks.Exclusions",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var PnrFinishingRemarksPanelGuestTravellerRemarks = {
	  displayName: "Guest Traveller Remarks",
	  dataAt: "PnrFinishingRemarks.GuestTravellerRemarks.Remarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var PnrFinishingRemarksPanelGuestTravellerExclusions = {
	  displayName: "Guest Traveller Exclusion Remarks",
	  dataAt: "PnrFinishingRemarks.GuestTravellerRemarks.Exclusions",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var GuestTravellersTitlesGridItem = {
	  displayName: "Guest Travellers Title",
	  dataAt: "GuestTravellersTitles.$gusTravTitleItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [GuestTravellersTitlesGroup],
	  endpoint: "Settings",
	  removeParamId: "gusTravTitleItem",
	  canDelete: true
	};
	
	var AdditionalPnrRemarksExpiredRemarks = {
	  displayName: "Expired Remarks",
	  dataAt: "AdditionalPnrRemarks.ExpiredRemarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var AdditionalPnrRemarksDeclinedRemarksNonRefundable = {
	  displayName: "Declined Remarks Non-refundable",
	  dataAt: "AdditionalPnrRemarks.DeclinedRemarksNonRefundable",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var AdditionalPnrRemarksDeclinedRemarks = {
	  displayName: "Declined Remarks",
	  dataAt: "AdditionalPnrRemarks.DeclinedRemarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var AdditionalPnrRemarksApprovalRemarks = {
	  displayName: "Approval Remarks",
	  dataAt: "AdditionalPnrRemarks.ApprovalRemarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var AdditionalPnrRemarksCancelRemarks = {
	  displayName: "Cancel Remarks",
	  dataAt: "AdditionalPnrRemarks.CancelRemarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var AdditionalPnrRemarksModifyRemarks = {
	  displayName: "Modify Remarks",
	  dataAt: "AdditionalPnrRemarks.ModifyRemarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var AdditionalPnrRemarksUserHoldRemarks = {
	  displayName: "User Hold Remarks",
	  dataAt: "AdditionalPnrRemarks.UserHoldRemarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var AdditionalPnrRemarksExpiredUserHoldRemarks = {
	  displayName: "Expired User Hold Remarks",
	  dataAt: "AdditionalPnrRemarks.ExpiredUserHoldRemarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var AdditionalPnrRemarksConfirmedUserHoldRemarks = {
	  displayName: "Confirmed User Hold Remarks",
	  dataAt: "AdditionalPnrRemarks.ConfirmedUserHoldRemarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var AdditionalPnrRemarksFinishBookingRemarks = {
	  displayName: "Finish Booking Remarks",
	  dataAt: "AdditionalPnrRemarks.FinishBookingRemarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var VehicleDefaultsGrid = {
	  displayName: "Vehicle Defaults",
	  dataAt: "VehicleDefaults",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: VehicleDefaultsItem,
	  gridCols: [{ name: "Name", key: "Name" }, { name: "Category Code", key: "CategoryCode" }, { name: "Type Code", key: "TypeCode" }]
	};
	
	var VehicleEmissionsGrid = {
	  displayName: "Vehicle Emissions",
	  dataAt: "VehicleEmissions",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canAddNew: true,
	  gridItem: VehicleEmissionsItem,
	  gridCols: [{ name: "Car Codes", key: "CarCategoryCodes" }, { name: "Fuel Codes", key: "FuelCodes" }, { name: "Kg CO2 per Km", key: "EmissionValuePerKm" }]
	};
	
	var TermsAndConditionsGrid = {
	  displayName: "Terms and Condition",
	  dataAt: "TermsAndConditions",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: TermsAndConditionsSettingsItem,
	  gridCols: [{ name: "SectionType", key: "SectionType" }, { name: "Countries", key: "Countries" }, { name: "SegmentTypes", key: "SegmentTypes" }]
	};
	
	var FlightFareDataGrid = {
	  displayName: "Flight Fare Data",
	  dataAt: "FlightFareData",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: FlightFareDataItem,
	  gridCols: [{ name: "Name", key: "Name" }]
	};
	
	var DefaultFareRules = {
	  displayName: "Default Fare Rules",
	  dataAt: "DefaultFareRules",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var HotelPreferredTagsSourceType = {
	  displayName: "CTM Preferred Tier Labels",
	  dataAt: "HotelPreferredTagsSourceType",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "SettingsHotelPreferredTagsSourceType"
	};
	
	var HotelTagsToIgnoreFromDatabase = {
	  displayName: "Tags to Ignore",
	  dataAt: "HotelTagsToIgnoreFromDatabase",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.O_DATA_SELECT,
	  endpoint: "Hotels/GetAllTags",
	  searchAllNo: true,
	  isMultiSelect: true,
	  showOnlySelectedField: true
	};
	
	var HotelDepositRequiredAndPrepayKeywords = {
	  displayName: "Hotel Deposit/Prepay keywords",
	  dataAt: "HotelDepositRequiredAndPrepayKeywords",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var HotelNonRefundableKeywords = {
	  displayName: "Hotel Non-Refundable keywords",
	  dataAt: "HotelNonRefundableKeywords",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var HotelOtherExcludedKeywords = {
	  displayName: "Hotel Other Excluded Keywords",
	  dataAt: "HotelOtherExcludedKeywords",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var ExcludedHotelChains = {
	  displayName: "Excluded Chains",
	  dataAt: "ExcludedHotelChains",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var ExcludedHotels = {
	  displayName: "Excluded Hotels",
	  dataAt: "ExcludedHotels",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var RateKeywordsIdRequired = {
	  displayName: "Rate Keywords that show ID Required Message",
	  dataAt: "RateKeywordsIdRequired",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var ErrorMessagesGrid = {
	  displayName: "Error Messages",
	  dataAt: "ErrorMessages",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: ErrorMessagesItem,
	  gridCols: [{ name: "Key", key: "Key" }]
	};
	
	var MinimumHotelRating = {
	  displayName: "Minimum Hotel Rating",
	  dataAt: "MinimumHotelRating",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  inputType: "number",
	  min: 0,
	  max: 4
	};
	
	var SettingsRadiusDistance = {
	  displayName: "Hotel Radius Distance",
	  dataAt: "RadiusDistance",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  inputType: "number",
	  min: 0,
	  max: 9999999999
	};
	
	var LimitCountries = {
	  displayName: "Limit Countries",
	  dataAt: "LimitCountries",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var FlightFareBucketClassesGrid = {
	  displayName: "Flight Fare Bucket Data",
	  dataAt: "FlightFareBucketClasses",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: FlightFareBucketClassesItem,
	  gridCols: [{ name: "Name", key: "Name" }, { name: "Classes", key: "FareClasses" }, { name: "Sort", key: "Sort" }]
	};
	
	var FlightFareClasses = {
	  displayName: "Flight Fare Classes",
	  dataAt: "FlightFareClasses",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var SalesAgentRemark = {
	  displayName: "Remarks",
	  dataAt: "SalesAgentRemark",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var SalesAgentsGrid = {
	  tabName: "Sales-Agents",
	  displayName: "Sales Agents",
	  dataAt: "SalesAgents",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: SalesAgentsItem,
	  gridCols: [{ name: "Name", key: "Name" }, { name: "Code", key: "Code" }]
	};
	
	var PerDiemDefaultRatesGrid = {
	  tabName: "per-diem-default-rates",
	  displayName: "Per Diem Default Rates",
	  dataAt: "PerDiemDefaultRates",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: PerDiemDefaultRatesItem,
	  gridCols: [{ name: "Effective Date", key: "EffectiveDate" }, { name: "Country", key: "Country" }, { name: "Amount", key: "Amount" }]
	};
	
	var PerDiemMappingsGrid = {
	  tabName: "per-diem-mappings",
	  displayName: "Per Diem Mappings",
	  dataAt: "PerDiemMappings",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: PerDiemMappingsItem,
	  gridCols: [{ name: "Value", key: "Value" }, { name: "Alternate Values", key: "AlternateValues" }, { name: "Type", key: "Type" }]
	};
	
	var HotelRateCategoriesGrid = {
	  tabName: "Hotel-Rate-Categories",
	  displayName: "Hotel Rate Categories",
	  dataAt: "HotelRateCategories",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: HotelRateCategoriesItem,
	  gridCols: [{ name: "Rate Category Name", key: "Name" }, { name: "Keywords", key: "Keywords" }, { name: "Contract Codes", key: "ContractCodes" }, { name: "Source Type", key: "SabreSourceType" }, { name: "Icon", key: "LogoUrl" }, { name: "Display On Top", key: "DisplayOnTop" }, { name: "Aggregator", key: "IsAggregator" }, { name: "Filter Display Name", key: "FilterDisplayName" }],
	  sortable: true,
	  htmlInner: "<small>All rows are shown. <br/>Sort rows by dragging and dropping to desired order for shopping results.</small>"
	};
	
	var HotelAmenityFiltersGrid = {
	  tabName: "hotel-amenity-filters",
	  displayName: "Hotel Amenity Filters",
	  dataAt: "HotelAmenityFilters",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: HotelAmenityFiltersItem,
	  gridCols: [{ name: "Display Name", key: "DisplayName" }, { name: "Amenities", key: "Amenities" }, { name: "Most Popular", key: "MostPopular" }]
	};
	
	var RailCharacterMappingsGrid = {
	  tabName: "character-mappings",
	  displayName: "Character Mappings",
	  dataAt: "RailCharacterMappings",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: RailCharacterMappingsItem,
	  gridCols: [{ name: "Special Character", key: "SpecialCharacter" }, { name: "System Character", key: "SystemCharacter" }]
	};
	
	var Id = {
	  displayName: "Identifier",
	  dataAt: "Id",
	  disabled: true,
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var CountryPnrFinishingRemarksGrid = {
	  tabName: "Country-PNR-Remarks",
	  displayName: "Country PNR Remarks",
	  dataAt: "CountryPnrFinishingRemarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: CountryPnrFinishingRemarksGridItem,
	  gridCols: [{ name: "Country Code", key: "CountryCode" }]
	};
	
	var CreditCardMappingsGrid = {
	  tabName: "credit-card-mappings",
	  displayName: "Credit Card Mappings",
	  dataAt: "CreditCardMappings",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: CreditCardMappingsItem,
	  gridCols: [{ name: "Card Provider", key: "CardProvider" }, { name: "Card Types", key: "CardTypes" }]
	};
	
	var SettingsGDSPanel = {
	  dataAt: "",
	  tabName: "GDS",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  children: [Gdssettings]
	};
	
	var PnrFinishingRemarksPanel = {
	  tabName: "PNR-Finishing-Remarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  dataAt: "PnrFinishingRemarks",
	  children: [PnrFinishingRemarksPanelGuestTravellerExclusions, PnrFinishingRemarksPanelGuestTravellerRemarks, PnrFinishingRemarksPanelPreTripApprovalExclusions, PnrFinishingRemarksPanelPreTripApprovalRemarks, PnrFinishingRemarksPanelStandardRemarks]
	};
	
	var GuestTravellersTitlesPanel = {
	  tabName: "Guest-Travellers-Titles",
	  displayName: "Guest Travellers Titles",
	  dataAt: "GuestTravellersTitles",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: GuestTravellersTitlesGridItem,
	  gridCols: [{ name: "Name", key: "Name" }, { name: "Code", key: "Code" }, { name: "Display Order", key: "DisplayOrder" }]
	};
	
	var ApprovalPanel = {
	  tabName: "Approvals",
	  displayName: "Approvals",
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  children: [{
	    displayAs: _constantsJs2["default"].DISPLAY_AS.SUB_HEADING,
	    html: "<h4>Agent Claimed Remark</h4><small>When remark text is populated User hold and approval expiry will not occur when defined remark exist in booking.</small>"
	  }, {
	    displayName: "Agent Claimed Remark Type",
	    dataAt: "ApprovalClaimedRemark.RemarkType",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	    optionsAt: "RemarkType"
	  }, {
	    displayName: "Agent Claimed Remark Text",
	    dataAt: "ApprovalClaimedRemark.RemarkText",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	    html: "<small><i>Leave blank to not pause ticketing.</i> Remark Text can be a regular expression</small>"
	  }, {
	    displayName: "Agent Claimed Remark Code",
	    dataAt: "ApprovalClaimedRemark.RemarkCode",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	    label: "Optional value used when remark type is Alpha-Coded"
	  }]
	};
	
	var AdditionalPnrRemarksPanel = {
	  tabName: "Additional-PNR-Remarks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  dataAt: "",
	  children: [AdditionalPnrRemarksApprovalRemarks, AdditionalPnrRemarksDeclinedRemarks, AdditionalPnrRemarksDeclinedRemarksNonRefundable, AdditionalPnrRemarksExpiredRemarks, AdditionalPnrRemarksCancelRemarks, AdditionalPnrRemarksModifyRemarks, AdditionalPnrRemarksUserHoldRemarks, AdditionalPnrRemarksExpiredUserHoldRemarks, AdditionalPnrRemarksConfirmedUserHoldRemarks, AdditionalPnrRemarksFinishBookingRemarks]
	};
	
	var IsFlightSearchUniversalProductAttributesTabEnabled = {
	  displayName: "Enable Flight Search Universal Product Attributes Tab",
	  dataAt: "IsFlightSearchUniversalProductAttributesTabEnabled",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	var FlightSearchUniversalProductAttributesTabLabel = {
	  displayName: "Flight Search Universal Product Attributes Tab Label",
	  dataAt: "FlightSearchUniversalProductAttributesTabLabel",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var IsFlightSearchUniversalProductAttributesShortcutEnabled = {
	  displayName: "Enable Flight Search Universal Product Attributes Shortcut",
	  dataAt: "IsFlightSearchUniversalProductAttributesShortcutEnabled",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	var FlightSearchUniversalProductAttributesShortcutLabel = {
	  displayName: "Flight Search Universal Product Attributes Shortcut Label",
	  dataAt: "FlightSearchUniversalProductAttributesShortcutLabel",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	var ConfigReportDownloader = {
	  displayName: "Config Report Download",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.FILE_DOWNLOADER,
	  fileNameSuffix: "DebtorConfigReport.xlsx",
	  endPointController: "DebtorConfigReport"
	};
	
	var ConfigFileUploader = {
	  displayName: 'Upload Bulk Changes',
	  dataAt: 'MediumImageUrl',
	  displayAs: _constantsJs2["default"].DISPLAY_AS.FILE_UPLOADER,
	  fileContainer: 'ImportConfiguration',
	  uploadType: 'xlsx',
	  rawFileWithDate: true,
	  isEnabledMethod: "vm.authService.getIsBulkChangeAdmin()"
	};
	
	var RegionalMobileContactDetailsFileUploader = {
	  displayName: 'Upload Regional Mobile Contact Details',
	  dataAt: 'MediumImageUrl',
	  displayAs: _constantsJs2["default"].DISPLAY_AS.FILE_UPLOADER,
	  fileContainer: 'RegionalMobileContactDetailsUpload',
	  uploadType: 'xlsx',
	  rawFileWithDate: true,
	  isEnabledMethod: "vm.authService.getCanUploadRegionalMobileContactDetails()"
	};
	
	var EnableNewUiSystemSetting = {
	  displayName: "Enable New UI",
	  dataAt: "EnableNewUi",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	var TaxDisplayModeSystemSetting = {
	  displayName: "Shopping Results - Rate Display Include Taxes",
	  dataAt: "IncludeHotelTax",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	var SettingsMiscPanel = {
	  tabName: "Settings-Misc",
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  children: [Id, FlightFareClasses, FlightFareBucketClassesGrid, LimitCountries, ItineraryValidatorSettings, BookingThreshold, ErrorMessagesGrid, DefaultFareRules, FlightFareDataGrid, TermsAndConditionsGrid, VehicleDefaultsGrid, VehicleEmissionsGrid, IsFlightSearchUniversalProductAttributesTabEnabled, FlightSearchUniversalProductAttributesTabLabel, IsFlightSearchUniversalProductAttributesShortcutEnabled, FlightSearchUniversalProductAttributesShortcutLabel, EnableNewUiSystemSetting]
	};
	
	var ConfigReportPanel = {
	  tabName: "Debtor-Config-Report",
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  children: [{
	    displayAs: _constantsJs2["default"].DISPLAY_AS.SUB_HEADING,
	    label: "Configuration Report For all debtors in the system​​"
	  }, ConfigReportDownloader, ConfigFileUploader, RegionalMobileContactDetailsFileUploader, {
	    displayAs: _constantsJs2["default"].DISPLAY_AS.SUB_HEADING,
	    html: "<h4><small>Sheets supported" + "<ul>" + "<li>Debtor<ul>" + "<li>Fields handled<ul>" + "<li><b>DebtorId</b> used to identify debtor. Debtor Id must exist for the row to be processed</li>" + "</ul></li>" + "</ul></li>" + "<li>Company Reference<ul>" + "<li>Fields handled<ul>" + "<li><b>DebtorId</b>, <b>Index</b> and <b>Code</b> used to identify Company Reference. Index and Code must exist for the row to be processed</li>" + "<li>Ignored Fields. Only used for reference purposes<ul>" + "<li>DebtorName, DebtorTitle, DebtorIsDeleted, DebtorIsDisabled</li>" + "</ul></li>" + "</ul></li>" + "</ul></li>" + "<li>Policy<ul>" + "<li>Fields handled<ul>" + "<li><b>DebtorId</b> and <b>PolicyCode</b> used to identify Policy. Policy Code must exist for the row to be processed</li>" + "<li>Ignored Fields. Only used for reference purposes<ul>" + "<li>DebtorName, DebtorTitle, DebtorIsDeleted, DebtorIsDisabled</li>" + "</ul></li>" + "</ul></li>" + "</ul></li>" + "<li>FlightPolicy<ul>" + "<li>Fields handled<ul>" + "<li><b>DebtorId</b> and <b>PolicyCode</b> used to identify policy. Policy Code must exist for the row to be processed</li>" + "<li>Ignored Fields. Only used for reference purposes<ul>" + "<li>DebtorName, DebtorTitle, DebtorIsDeleted, DebtorIsDisabled</li>" + "</ul></li>" + "</ul></li>" + "</ul></li>" + "<li>FlightPolicyItems<ul>" + "<li>Fields handled<ul>" + "<li><b>DebtorId</b>, <b>PolicyCode</b> and <b>PolicyIndex</b> are used to identify policy. Policy must exist for the row to be processed</li>" + "<li>Ignored Fields. Only used for reference purposes<ul>" + "<li>DebtorName, DebtorTitle, DebtorIsDeleted, DebtorIsDisabled, PolicyTitle, PolicyCountries, PolicyLevel, </br>" + "BreakPolicyEscalationApprovalLevel, PolicyEmployeCodes, PolicyAgencyReasonCodes</li>" + "</ul></li>" + "</ul></li>" + "</ul></li>" + "<li>HotelPolicy<ul>" + "<li>Fields handled<ul>" + "<li><b>DebtorId</b> and <b>PolicyCode</b> used to identify policy. Policy Code must exist for the row to be processed</li>" + "<li>Ignored Fields. Only used for reference purposes<ul>" + "<li>DebtorName, DebtorTitle, DebtorIsDeleted, DebtorIsDisabled</li>" + "</ul></li>" + "</ul></li>" + "</ul></li>" + "<li>HotelPolicyItems<ul>" + "<li>Fields handled<ul>" + "<li><b>DebtorId</b>, <b>PolicyCode</b> and <b>PolicyIndex</b> are used to identify policy. Policy must exist for the row to be processed</li>" + "<li>Ignored Fields. Only used for reference purposes<ul>" + "<li>DebtorName, DebtorTitle, DebtorIsDeleted, DebtorIsDisabled, PolicyTitle, PolicyCountries, PolicyLevel, </br>" + "BreakPolicyEscalationApprovalLevel, PolicyEmployeCodes, PolicyAgencyReasonCodes</li>" + "</ul></li>" + "</ul></li>" + "</ul></li>" + "<li>CarPolicy<ul>" + "<li>Fields handled<ul>" + "<li><b>DebtorId</b> and <b>PolicyCode</b> used to identify policy. Policy Code must exist for the row to be processed</li>" + "<li>Ignored Fields. Only used for reference purposes<ul>" + "<li>DebtorName, DebtorTitle, DebtorIsDeleted, DebtorIsDisabled</li>" + "</ul></li>" + "</ul></li>" + "</ul></li>" + "<li>CarPolicyItems<ul>" + "<li>Fields handled<ul>" + "<li><b>DebtorId</b>, <b>PolicyCode</b> and <b>PolicyIndex</b> are used to identify policy. Policy must exist for the row to be processed</li>" + "<li>Ignored Fields. Only used for reference purposes<ul>" + "<li>DebtorName, DebtorTitle, DebtorIsDeleted, DebtorIsDisabled, PolicyTitle, PolicyCountries, PolicyLevel,  </br>" + "BreakPolicyEscalationApprovalLevel, PolicyEmployeCodes, PolicyAgencyReasonCodes</li>" + "</ul></li>" + "</ul></li>" + "</ul></li>" + "<li>RailPolicy<ul>" + "<li>Fields handled<ul>" + "<li><b>DebtorId</b> and <b>PolicyCode</b> used to identify policy. Policy Code must exist for the row to be processed</li>" + "<li>Ignored Fields. Only used for reference purposes<ul>" + "<li>DebtorName, DebtorTitle, DebtorIsDeleted, DebtorIsDisabled, PolicyTitle, PolicyCountries, PolicyLevel,  </br>" + "BreakPolicyEscalationApprovalLevel, PolicyEmployeCodes, PolicyAgencyReasonCodes, PolicyListings</li>" + "</ul></li>" + "</ul></li>" + "</ul></li>" + "<li>GdsSettings<ul>" + "<li>Fields handled<ul>" + "<li><b>DebtorId</b> and <b>GDSName</b> used to identify policy</li>" + "<li>Ignored Fields. Only used for reference purposes<ul>" + "<li>DebtorName, DebtorTitle, DebtorIsDeleted, DebtorIsDisabled</li>" + "</ul></li>" + "</ul></li>" + "</ul></li>" + "<li>GdsSettingsKeywords<ul>" + "<li>Row replacement note items are read in a group by Debtor and GdsSettings. Rows in upload will replace current GdsSettingsKeywords in GdsSetting</li>" + "<li>Fields handled<ul>" + "<li><b>DebtorId</b> and <b>GDSName</b> used to identify policy</li>" + "<li>Ignored Fields. Only used for reference purposes<ul>" + "<li>DebtorName, DebtorTitle, DebtorIsDeleted, DebtorIsDisabled, GDSEnabled</li>" + "</ul></li>" + "</ul></li>" + "</ul></li>" + "</ul></small></h4>"
	  }]
	};
	
	var SalesAgentsPanel = {
	  tabName: "Sales-Agents",
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  children: [SalesAgentRemark, SalesAgentsGrid]
	};
	
	var HotelPanel = {
	  tabName: "Hotel",
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  children: [SettingsRadiusDistance, MinimumHotelRating, TaxDisplayModeSystemSetting, HotelPreferredTagsSourceType, HotelTagsToIgnoreFromDatabase, HotelDepositRequiredAndPrepayKeywords, HotelNonRefundableKeywords, HotelOtherExcludedKeywords, ExcludedHotelChains, ExcludedHotels, RateKeywordsIdRequired, HotelRateCategoriesGrid, HotelAmenityFiltersGrid]
	};
	
	var RailPanel = {
	  tabName: "Rail",
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  children: [RailCharacterMappingsGrid, {
	    displayAs: _constantsJs2["default"].DISPLAY_AS.SUB_HEADING,
	    html: "<h4>Rail Ticketing Configuration</h4><br/><small>When remark text is populated system will pause ticketing until remark exist in the Sabre booking.<br/>If no remark is set then system will ticket rail reservation immediately.</small>"
	  }, {
	    displayName: "Rail Ticketing Remark Type",
	    dataAt: "RailTicketingRemark.RemarkType",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	    optionsAt: "RemarkType"
	  }, {
	    displayName: "Rail Ticketing Remark Text",
	    dataAt: "RailTicketingRemark.RemarkText",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	    html: "<small><i>Leave blank to not pause ticketing.</i> Remark Text can be a regular expression</small>"
	  }, {
	    displayName: "Rail Ticketing Remark Code",
	    dataAt: "RailTicketingRemark.RemarkCode",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	    label: "Optional value used when remark type is Alpha-Coded"
	  }]
	};
	
	var PerDiemPanel = {
	  tabName: "Per-Diem",
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  children: [PerDiemDefaultRatesGrid, PerDiemMappingsGrid]
	};
	
	var UnusedTicketPanel = {
	  tabName: "Unused-Tickets",
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  children: [UnusedTicketSettings]
	};
	
	var DatetimeFormatPanel = {
	  tabName: "Datetime-Format",
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  children: [DateFormatLongSettings, DateFormatMediumSettings, DateFormatShortSettings, DatetimeFormatLongSettings, TimeFormatLongSettings]
	};
	
	var CreditCardMappingsPanel = {
	  tabName: "Credit-Card-Mappings",
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  children: [CreditCardMappingsGrid]
	};
	
	//Named List
	var NamedListName = {
	  displayName: "List Name",
	  dataAt: "NamedLists.$iinamedListItem.Name",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var NamedListValues = {
	  displayName: "List Values",
	  dataAt: "NamedLists.$iinamedListItem.Values",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var NamedListItem = {
	  displayName: "Item",
	  dataAt: "NamedLists.$iinamedListItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [NamedListName, NamedListValues],
	  endpoint: "Settings",
	  removeParamId: "iinamedListItem",
	  canDelete: true
	};
	
	var NamedListsGrid = {
	  tabName: "Named-Lists",
	  displayName: "Named Lists",
	  dataAt: "NamedLists",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: NamedListItem,
	  gridCols: [{ name: "Name", key: "Name" }, { name: "Values", key: "Values" }]
	};
	
	var NamedListsPanel = {
	  tabName: "Named-Lists",
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  children: [NamedListsGrid]
	};
	//End Named List
	
	//Country Airlines
	var CountryAirlinesCountryCodes = {
	  displayName: "CountryCodes",
	  dataAt: "CountryAirlines.$iicountryAirlineListItem.CountryCodes",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryAirlinesCountryAirlines = {
	  displayName: "Airlines",
	  dataAt: "CountryAirlines.$iicountryAirlineListItem.Airlines",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryAirlinesCountryIsOriginDestinationInList = {
	  displayName: "IsOriginDestinationInList",
	  dataAt: "CountryAirlines.$iicountryAirlineListItem.IsOriginDestinationInList",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	var CountryAirlinesItem = {
	  displayName: "Item",
	  dataAt: "CountryAirlines.$iicountryAirlineListItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [CountryAirlinesCountryCodes, CountryAirlinesCountryIsOriginDestinationInList, CountryAirlinesCountryAirlines],
	  endpoint: "Settings",
	  removeParamId: "iicountryAirlineListItem",
	  canDelete: true
	};
	
	var CountryAirlinesGrid = {
	  tabName: "Country-Airlines",
	  displayName: "Country Airlines",
	  dataAt: "CountryAirlines",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: CountryAirlinesItem,
	  gridCols: [{ name: "CountryCodes", key: "CountryCodes" }, { name: "Airlines", key: "Airlines" }]
	};
	
	var CountryAirlinesPanel = {
	  tabName: "Country-Airlines",
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  children: [CountryAirlinesGrid]
	};
	//End Country Airlines
	
	//Start FlightModificationSettings
	var FlightModificationSettingGdsProviders = {
	  displayName: "Gds Providers",
	  dataAt: "FlightModificationSettings.$iiflightModificationSettingItem.GdsProviders",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.MULTI_SELECT,
	  optionsAt: "GDSProviders"
	};
	
	var FlightModificationSettingCarriersExcluded = {
	  displayName: "Carriers Excluded",
	  dataAt: "FlightModificationSettings.$iiflightModificationSettingItem.CarriersExcluded",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT,
	  validationRegex: "^$|^[A-Za-z0-9]{2}(?:[\\s,]+[A-Za-z0-9]{2})*$",
	  validationMessage: "Use 2-character carrier codes (letters or numbers), e.g., AA, F9."
	};
	
	var FlightModificationSettingCarriersIncluded = {
	  displayName: "Carriers Included",
	  dataAt: "FlightModificationSettings.$iiflightModificationSettingItem.CarriersIncluded",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT,
	  validationRegex: "^$|^[A-Za-z0-9]{2}(?:[\\s,]+[A-Za-z0-9]{2})*$",
	  validationMessage: "Use 2-character carrier codes (letters or numbers), e.g., AA, F9."
	};
	
	var FlightModificationSettingEnableCancelRebook = {
	  displayName: "Enable Cancel Rebook",
	  dataAt: "FlightModificationSettings.$iiflightModificationSettingItem.EnableCancelRebook",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	var FlightModificationSettingEnableExchanges = {
	  displayName: "Enable Exchanges",
	  dataAt: "FlightModificationSettings.$iiflightModificationSettingItem.EnableExchanges",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	var FlightModificationSettingEnableAdd = {
	  displayName: "Enable Add",
	  dataAt: "FlightModificationSettings.$iiflightModificationSettingItem.EnableAdd",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	var FlightModificationSettingItem = {
	  displayName: "Item",
	  dataAt: "FlightModificationSettings.$iiflightModificationSettingItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [FlightModificationSettingGdsProviders, FlightModificationSettingCarriersExcluded, FlightModificationSettingCarriersIncluded, FlightModificationSettingEnableCancelRebook, FlightModificationSettingEnableExchanges, FlightModificationSettingEnableAdd],
	  endpoint: "Settings",
	  removeParamId: "iiflightModificationSettingItem",
	  canDelete: true
	};
	var FlightModificationSettingsGrid = {
	  tabName: "Flight-Modification-Settings",
	  displayName: "Flight Modification Settings",
	  dataAt: "FlightModificationSettings",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  copyWithoutCopyText: true,
	  gridItem: FlightModificationSettingItem,
	  gridCols: [{ name: "Providers", key: "GdsProviders" }, { name: "CancelRebook", key: "EnableCancelRebook" }, { name: "Exchanges", key: "EnableExchanges" }, { name: "Add", key: "EnableAdd" }, { name: "Excluded", key: "CarriersExcluded" }, { name: "Included", key: "CarriersIncluded" }]
	};
	
	//End FlightModificationSettings
	
	// Start Custom Airport Hub
	var SettingsCustomAirportHubName = {
	  displayName: "Name",
	  dataAt: "CustomAirportHubs.$isettingsCustomAirportHubsItem.Name",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var SettingsCustomAirportHubAirports = {
	  displayName: "Airports",
	  dataAt: "CustomAirportHubs.$isettingsCustomAirportHubsItem.Airports",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var SettingsCustomAirportHubsItem = {
	  displayName: "Item",
	  dataAt: "CustomAirportHubs.$isettingsCustomAirportHubsItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [SettingsCustomAirportHubName, SettingsCustomAirportHubAirports],
	  endpoint: "Settings",
	  removeParamId: "isettingsCustomAirportHubsItem",
	  canDelete: true
	};
	
	var SettingsCustomAirportHubsGrid = {
	  tabName: "Custom-Airport-Hubs",
	  displayName: "Custom Airport Hubs",
	  dataAt: "CustomAirportHubs",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  copyWithoutCopyText: true,
	  gridItem: SettingsCustomAirportHubsItem,
	  gridCols: [{ name: "Name", key: "Name" }, { name: "Airports", key: "Airports" }]
	};
	// End Custom Airport Hub
	
	//Start FlightSearch
	var FlightSearchConfigurationCarrierType = {
	  displayName: "Carrier Type",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.CarrierType",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "FlightSearchConfigurationQueryItemsType",
	  helpText: "Single: 1 search performed which includes all defined carriers. Multi: 1 search for each carrier defined."
	};
	
	var FlightSearchConfigurationCarriers = {
	  displayName: "Carriers",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.Carriers",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT,
	  html: "<span class=\"help-block\">" + "Named lists are supported. Wrap name in ~ characters. Example: ~ExcludedCarriers~<br/><br />" + "Enter XX with carrier type = Multi will perform an exclusion with all the other carriers excluded.<br/>" + "Example: XX, AA entered as values will perform 2 queries. 1 with AA and another with excluding AA and any other configured excluded carriers." + "</span>"
	};
	
	var FlightSearchConfigurationExcludeCarriers = {
	  displayName: "Exclude Carriers",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.ExcludeCarriers",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT,
	  helpText: "Named lists are supported. Wrap name in ~ characters. Example: ~ExcludedCarriers~"
	};
	
	var FlightSearchConfigurationCabinType = {
	  displayName: "Cabin Type",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.CabinType",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "FlightSearchConfigurationQueryItemsTypeMultiOnly",
	  helpText: "Sabre only supports single cabin queries. Therefore Multi is the only available option."
	};
	var FlightSearchConfigurationCabins = {
	  displayName: "Cabins",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.Cabins",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.MULTI_SELECT,
	  optionsAt: "FlightCabins"
	};
	var FlightSearchPassengerTypes = {
	  displayName: "Passenger Types",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.PassengerTypes",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.MULTI_SELECT,
	  optionsAt: "PassengerTypes",
	  allowFreeform: true,
	  transformUppercase: true,
	  validationRegex: "^[A-Z0-9]{3}$",
	  validationMessage: "Each passenger type must be exactly 3 alphanumeric characters"
	};
	var FlightSearchConfigurationIncDebtorPreferred = {
	  displayName: "Include Debtor Preferred",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.IncDebtorPreferred",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	var FlightSearchConfigurationRefundableSearch = {
	  displayName: "Penalty Search Type",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.RefundableSearchTypes",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.MULTI_SELECT,
	  optionsAt: "PenaltySearchTypes"
	};
	
	var FlightSearchConfigurationUnbrandedSearch = {
	  displayName: "Unbranded Search",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.UnbrandedSearch",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	var FlightSearchConfigurationEnableATPCO = {
	  displayName: "Enable ATPCO",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.EnableATPCO",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	var FlightSearchConfigurationEnableNDC = {
	  displayName: "Enable NDC",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.EnableNDC",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN,
	  helpText: "Leave Enabled ATPCO and Enabled NDC un-checked to use Debtor Configuration."
	};
	var FlightSearchConfigurationMaxStopsQuantity = {
	  displayName: "Max Stops Quantity",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.MaxStopsQuantity",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  inputType: "number"
	};
	var FlightSearchConfigurationCountryOrigin = {
	  displayName: "Origin Countries",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.CountryOrigin",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT,
	  helpText: "If set, query will only be used if Origin country codes are in the list. ** Named list support"
	};
	var FlightSearchConfigurationCountryDestination = {
	  displayName: "Destination Countries",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.CountryDestination",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT,
	  helpText: "If set, query will only be used if Destination country codes are in the list. ** Named list support"
	};
	
	var FlightSearchConfigurationPriority = {
	  displayName: "Priority",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.Priority",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.MULTI_SELECT,
	  optionsAt: "FlightConfigurationPriority",
	  html: "Leave blank for system configuration. Enter the order of priority. First 1 in list is the highest priority."
	};
	
	var FlightSearchConfigurationKeepSameCabin = {
	  displayName: "Keep Same Cabin",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.KeepSameCabin",
	  helpText: "BFM Configuration leave blank for default configuration",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "BoolNullableType",
	  handleAsString: true,
	  allowNullable: true
	};
	
	var FlightSearchConfigurationFareFocusRulesExclude = {
	  displayName: "Fare Focus Rules Exclude",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.FareFocusRulesExclude",
	  helpText: "BFM Configuration leave blank for default configuration",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "BoolNullableType",
	  handleAsString: true,
	  allowNullable: true
	};
	var FlightSearchConfigurationOfferControlRulesExclude = {
	  displayName: "Offer Control Rules Exclude",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.OfferControlRulesExclude",
	  helpText: "BFM Configuration leave blank for default configuration",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "BoolNullableType",
	  handleAsString: true,
	  allowNullable: true
	};
	var FlightSearchConfigurationItineraryCount = {
	  displayName: "Itinerary Count",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.ItineraryCount",
	  helpText: "BFM Configuration leave blank for default configuration",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  inputType: "number"
	};
	var FlightSearchConfigurationNumTrips = {
	  displayName: "Num Trips",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.NumTrips",
	  helpText: "BFM Configuration leave blank for default configuration",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  inputType: "number"
	};
	var FlightSearchConfigurationVendorPrefApplicabilityAtLeastOne = {
	  displayName: "Vendor Pref Applicability AtLeast One",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.VendorPrefApplicabilityAtLeastOne",
	  helpText: "BFM Configuration leave blank for default configuration",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "BoolNullableType",
	  handleAsString: true,
	  allowNullable: true
	};
	var FlightSearchConfigurationCarrierFilterApplyValidatingCarrier = {
	  displayName: "Carrier Filter Apply Validating Carrier",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.CarrierFilterApplyValidatingCarrier",
	  helpText: "BFM Configuration leave blank for default configuration",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "BoolNullableType",
	  handleAsString: true,
	  allowNullable: true
	};
	var FlightSearchConfigurationDiversityHandling = {
	  displayName: "Diversity Handling",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.DiversityHandling",
	  helpText: "BFM Configuration leave blank for default configuration",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "DiversityHandlingType"
	};
	
	var FlightSearchConfigurationAdditionalNonStopsPercentage = {
	  displayName: "Additional NonStops Percentage",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.AdditionalNonStopsPercentage",
	  helpText: "BFM Configuration leave blank for default configuration",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  inputType: "number"
	};
	var FlightSearchConfigurationLowFareBucketFareCutOffPercentage = {
	  displayName: "Low Fare Bucket Fare Cut Off Percentage",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.LowFareBucketFareCutOffPercentage",
	  helpText: "BFM Configuration leave blank for default configuration",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  inputType: "number"
	};
	var FlightSearchConfigurationLowFareBucketOptionsPercentage = {
	  displayName: "Low FareBucket Options Percentage",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.LowFareBucketOptionsPercentage",
	  helpText: "BFM Configuration leave blank for default configuration.",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  inputType: "number"
	};
	var FlightSearchConfigurationSetBrandedFareOptions = {
	  displayName: "Set BrandedF are Options",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.SetBrandedFareOptions",
	  helpText: "When not checked system will use system configuration. To override check this box and set Multiple and Single branded fare values below.",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	var FlightSearchConfigurationMultipleBrandedFare = {
	  displayName: "Multiple Branded Fare",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.MultipleBrandedFare",
	  helpText: "BFM Configuration leave blank for default configuration. Ignored when Set Branded Fare Options = false",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "BoolNullableType",
	  handleAsString: true,
	  allowNullable: true
	};
	var FlightSearchConfigurationSingleBrandedFare = {
	  displayName: "Single Branded Fare",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.SingleBrandedFare",
	  helpText: "BFM Configuration leave blank for default configuration. Ignored when Set Branded Fare Options = false",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "BoolNullableType",
	  handleAsString: true,
	  allowNullable: true
	};
	
	var FlightSearchConfigurationTimeWindowsOutbound = {
	  displayName: "Time Windows Outbound",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.TimeWindowsOutbound",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT,
	  html: "List of time windows. <br/>- use for empty value. This means system will use configured time window. Either none or configured default time window. <br/>" + "Format: HHmmHHmm example: 12002359 Begin time in HHmm followed by end time HHmm. Note end time 2400 is not valid. Enter 2359.<br/> " + "Example all day: 00002359<br/>" + "Enter number for plus or minus range. Example 120 will be plus and minus 120 min from chosen depart time."
	};
	
	var FlightSearchConfigurationTimeWindowRange = {
	  displayName: "Time Window Range (Min)",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.TimeWindowRange",
	  helpText: "Overrides configuration with defined plus and minus time wondow for searched for time.",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  inputType: "number"
	};
	
	var FlightSearchConfigurationIsCombinable = {
	  displayName: "Is Combinable",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.IsCombinable",
	  helpText: "Search configuration is only included if doing a combinable search or not. Leave blank or not set to always include.",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "BoolNullableType",
	  handleAsString: true,
	  allowNullable: true
	};
	var FlightSearchConfigurationIncludeCountryCarriers = {
	  displayName: "Include Country Carriers",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.IncludeCountryCarriers",
	  helpText: "System to include Country Carriers in carrier list. Based on origin and destination countries.",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "BoolNullableType",
	  handleAsString: true,
	  allowNullable: true
	};
	
	var FlightSearchConfigurationItem = {
	  displayName: "Item",
	  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [FlightSearchConfigurationCarrierType, FlightSearchConfigurationCarriers, FlightSearchConfigurationExcludeCarriers, FlightSearchConfigurationCabinType, FlightSearchConfigurationCabins, FlightSearchConfigurationRefundableSearch, FlightSearchPassengerTypes, FlightSearchConfigurationIncDebtorPreferred, FlightSearchConfigurationUnbrandedSearch, FlightSearchConfigurationEnableATPCO, FlightSearchConfigurationEnableNDC, FlightSearchConfigurationMaxStopsQuantity, FlightSearchConfigurationCountryOrigin, FlightSearchConfigurationCountryDestination, FlightSearchConfigurationIsCombinable, FlightSearchConfigurationIncludeCountryCarriers, FlightSearchConfigurationTimeWindowsOutbound, FlightSearchConfigurationTimeWindowRange, FlightSearchConfigurationPriority, FlightSearchConfigurationKeepSameCabin, FlightSearchConfigurationFareFocusRulesExclude, FlightSearchConfigurationOfferControlRulesExclude, FlightSearchConfigurationItineraryCount, FlightSearchConfigurationNumTrips, FlightSearchConfigurationVendorPrefApplicabilityAtLeastOne, FlightSearchConfigurationCarrierFilterApplyValidatingCarrier, FlightSearchConfigurationDiversityHandling, FlightSearchConfigurationAdditionalNonStopsPercentage, FlightSearchConfigurationLowFareBucketFareCutOffPercentage, FlightSearchConfigurationLowFareBucketOptionsPercentage, FlightSearchConfigurationSetBrandedFareOptions, FlightSearchConfigurationMultipleBrandedFare, FlightSearchConfigurationSingleBrandedFare],
	  endpoint: "Settings",
	  removeParamId: "iflightSearchConfigurationItem",
	  canDelete: true
	};
	var FlightSearchGrid = {
	  tabName: "Flight-Search-Configuration",
	  displayName: "Flight Search Configuration",
	  dataAt: "FlightSearch.Queries",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  copyWithoutCopyText: true,
	  gridItem: FlightSearchConfigurationItem,
	  gridCols: [{ name: "CrrT", key: "CarrierType" }, { name: "Crrs", key: "Carriers" }, { name: "ExCrrs", key: "ExcludeCarriers" }, { name: "CbnT", key: "CabinType" }, { name: "Cbn", key: "Cabins" }, { name: "Rfd", key: "RefundableSearchTypes" }, { name: "Pax", key: "PassengerTypes" }, { name: "Pref", key: "IncDebtorPreferred" }, { name: "UnBrd", key: "UnbrandedSearch" }, { name: "ATPCO", key: "EnableATPCO" }, { name: "NDC", key: "EnableNDC" }, { name: "Stp", key: "MaxStopsQuantity" }, { name: "Org", key: "CountryOrigin" }, { name: "Dst", key: "CountryDestination" }]
	};
	//End FlightSearch
	
	//Start FlightAncillaryCodesConfiguration
	var FlightAncillaryCodesAncillaryType = {
	  displayName: "Ancillary Type",
	  dataAt: "FlightAncillaryCodes.$iflightAncillaryCodesItem.AncillaryType",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  helpText: "Type of Ancillary, as shown in Sabre or the GDS"
	};
	
	var FlightAncillaryCodesAncillaryName = {
	  displayName: "Ancillary Name",
	  dataAt: "FlightAncillaryCodes.$iflightAncillaryCodesItem.DisplayName",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  maxLength: 50,
	  helpText: "Display name, as it will be shown here in config."
	};
	
	var FlightAncillaryCodesAncillaryRequireFreeFormText = {
	  displayName: "Require Free Form Text",
	  dataAt: "FlightAncillaryCodes.$iflightAncillaryCodesItem.RequireFreeFormText",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN,
	  helpText: "If the SSR message for this ancillary requires free form text, indicate true or false."
	};
	
	var FlightAncillaryCodesAncillaryFreeFormText = {
	  displayName: "Free Form Text",
	  dataAt: "FlightAncillaryCodes.$iflightAncillaryCodesItem.FreeFormText",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  maxLength: 100,
	  helpText: "Free form text for this ancillary, if applicable."
	};
	
	var FlightAncillaryCodesAncillaryCode = {
	  displayName: "Ancillary Code",
	  dataAt: "FlightAncillaryCodes.$iflightAncillaryCodesItem.Code",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  maxLength: 10,
	  helpText: "Ancillary code"
	};
	
	var FlightAncillaryCodesAncillaryFreeOfCost = {
	  displayName: "Free Of Cost",
	  dataAt: "FlightAncillaryCodes.$iflightAncillaryCodesItem.FreeOfCost",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN,
	  helpText: "Indicates if the ancillary is free of cost"
	};
	
	var FlightAncillaryCodesAncillaryIsEnabled = {
	  displayName: "Enabled",
	  dataAt: "FlightAncillaryCodes.$iflightAncillaryCodesItem.IsEnabled",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN,
	  helpText: "Indicates if the ancillary is enabled"
	};
	
	var FlightAncillaryCodesAncillaryProviders = {
	  displayName: "Providers",
	  dataAt: "FlightAncillaryCodes.$iflightAncillaryCodesItem.Providers",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.MULTI_SELECT,
	  optionsAt: "GDSProviders",
	  helpText: "GDS Providers associated with this ancillary"
	};
	
	var FlightAncillaryCodesItem = {
	  displayName: "Item",
	  dataAt: "FlightAncillaryCodes",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [FlightAncillaryCodesAncillaryType, FlightAncillaryCodesAncillaryName, FlightAncillaryCodesAncillaryRequireFreeFormText, FlightAncillaryCodesAncillaryFreeFormText, FlightAncillaryCodesAncillaryCode, FlightAncillaryCodesAncillaryFreeOfCost, FlightAncillaryCodesAncillaryIsEnabled, FlightAncillaryCodesAncillaryProviders],
	  endpoint: "Settings",
	  removeParamId: "iflightAncillaryCodesItem",
	  canDelete: true
	};
	
	var FlightAncillaryCodesGrid = {
	  tabName: "Flight-Ancillary-Codes",
	  displayName: "Flight Ancillary Codes",
	  dataAt: "FlightAncillaryCodes",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  copyWithoutCopyText: true,
	  gridItem: FlightAncillaryCodesItem,
	  gridCols: [{ name: "Ancillary Type", key: "AncillaryType" }, { name: "Display Name", key: "DisplayName" }, { name: "Require Free Form Text", key: "RequireFreeFormText" }, { name: "Free Form Text", key: "FreeFormText" }, { name: "Code", key: "Code" }, { name: "Free Of Cost", key: "FreeOfCost" }, { name: "Enabled", key: "IsEnabled" }, { name: "Providers", key: "Providers" }]
	};
	//End FlightAncillaryCodesConfiguration
	
	//Start FlightNdcAtpcoTieSettings
	var FlightNdcAtpcoTieSettingsApplicationType = {
	  displayName: "NDC ATPCO Tie Settings Application Type",
	  dataAt: "FlightNdcAtpcoTieSettings.ApplicationType",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "FlightNdcAtpcoTieSettingsApplicationType",
	  html: _constantsJs2["default"].MESSAGES.NDC_TIE_SETTINGS
	};
	
	var FlightNdcAtpcoTieSettingsThresholdType = {
	  displayName: "NDC ATPCO Tie Settings Threshold Type",
	  dataAt: "FlightNdcAtpcoTieSettings.ThresholdType",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "FlightNdcAtpcoTieSettingsThresholdType"
	};
	
	var FlightNdcAtpcoTieSettingsThresholdValue = {
	  displayName: "NDC ATPCO Tie Settings Threshold Value",
	  dataAt: "FlightNdcAtpcoTieSettings.ThresholdValue",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  inputType: "number"
	};
	//End FlightNdcAtpcoTieSettings
	
	var FlightPanel = {
	  tabName: "Flight",
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  children: [FlightModificationSettingsGrid, FlightSearchGrid, FlightAncillaryCodesGrid, FlightNdcAtpcoTieSettingsApplicationType, FlightNdcAtpcoTieSettingsThresholdType, FlightNdcAtpcoTieSettingsThresholdValue, SettingsCustomAirportHubsGrid]
	};
	
	var SettingsTabs = {
	  displayName: "Settings",
	  iconClass: "fa-cog",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TABS,
	  children: [SettingsMiscPanel, ApprovalPanel, AdditionalPnrRemarksPanel, GuestTravellersTitlesPanel, PnrFinishingRemarksPanel, SettingsGDSPanel, CountryPnrFinishingRemarksGrid, SalesAgentsPanel, HotelPanel, RailPanel, FlightPanel, PerDiemPanel, ConfigReportPanel, UnusedTicketPanel, DatetimeFormatPanel, NamedListsPanel, CreditCardMappingsPanel, CountryAirlinesPanel]
	};
	
	var SettingsResource = {
	  rootNode: true,
	  displayName: "Settings",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  iconClass: "fa-cog",
	  dataAt: "",
	  children: [SettingsTabs],
	  endpoint: "Settings"
	};
	
	exports["default"] = {
	  SettingsResource: SettingsResource,
	  SettingsTabs: SettingsTabs,
	  SettingsMiscPanel: SettingsMiscPanel,
	  AdditionalPnrRemarksPanel: AdditionalPnrRemarksPanel,
	  GuestTravellersTitlesPanel: GuestTravellersTitlesPanel,
	  PnrFinishingRemarksPanel: PnrFinishingRemarksPanel,
	  SettingsGDSPanel: SettingsGDSPanel,
	  UnusedTicketPanel: UnusedTicketPanel,
	  DatetimeFormatPanel: DatetimeFormatPanel,
	  CountryPnrFinishingRemarksGrid: CountryPnrFinishingRemarksGrid,
	  ApprovalPanel: ApprovalPanel,
	  SalesAgentsPanel: SalesAgentsPanel,
	  HotelPanel: HotelPanel,
	  RailPanel: RailPanel,
	  FlightPanel: FlightPanel,
	  PerDiemPanel: PerDiemPanel,
	  NamedListsPanel: NamedListsPanel,
	  CreditCardMappingsPanel: CreditCardMappingsPanel,
	  CountryAirlinesPanel: CountryAirlinesPanel,
	  Id: Id,
	  FlightFareClasses: FlightFareClasses,
	  FlightFareBucketClassesGrid: FlightFareBucketClassesGrid,
	  SalesAgentRemark: SalesAgentRemark,
	  SalesAgentsGrid: SalesAgentsGrid,
	  PerDiemDefaultRatesGrid: PerDiemDefaultRatesGrid,
	  PerDiemMappingsGrid: PerDiemMappingsGrid,
	  RailCharacterMappingsGrid: RailCharacterMappingsGrid,
	  LimitCountries: LimitCountries,
	  SettingsRadiusDistance: SettingsRadiusDistance,
	  MinimumHotelRating: MinimumHotelRating,
	  HotelRateCategoriesGrid: HotelRateCategoriesGrid,
	  HotelAmenityFiltersGrid: HotelAmenityFiltersGrid,
	  ErrorMessagesGrid: ErrorMessagesGrid,
	  DefaultFareRules: DefaultFareRules,
	  FlightFareDataGrid: FlightFareDataGrid,
	  TermsAndConditionsGrid: TermsAndConditionsGrid,
	  VehicleDefaultsGrid: VehicleDefaultsGrid,
	  VehicleEmissionsGrid: VehicleEmissionsGrid,
	  CreditCardMappingsGrid: CreditCardMappingsGrid,
	  AdditionalPnrRemarksApprovalRemarks: AdditionalPnrRemarksApprovalRemarks,
	  AdditionalPnrRemarksDeclinedRemarks: AdditionalPnrRemarksDeclinedRemarks,
	  AdditionalPnrRemarksDeclinedRemarksNonRefundable: AdditionalPnrRemarksDeclinedRemarksNonRefundable,
	  AdditionalPnrRemarksExpiredRemarks: AdditionalPnrRemarksExpiredRemarks,
	  AdditionalPnrRemarksCancelRemarks: AdditionalPnrRemarksCancelRemarks,
	  AdditionalPnrRemarksModifyRemarks: AdditionalPnrRemarksModifyRemarks,
	  AdditionalPnrRemarksUserHoldRemarks: AdditionalPnrRemarksUserHoldRemarks,
	  AdditionalPnrRemarksExpiredUserHoldRemarks: AdditionalPnrRemarksExpiredUserHoldRemarks,
	  AdditionalPnrRemarksConfirmedUserHoldRemarks: AdditionalPnrRemarksConfirmedUserHoldRemarks,
	  AdditionalPnrRemarksFinishBookingRemarks: AdditionalPnrRemarksFinishBookingRemarks,
	  GuestTravellersTitlesGridItem: GuestTravellersTitlesGridItem,
	  PnrFinishingRemarksPanelGuestTravellerExclusions: PnrFinishingRemarksPanelGuestTravellerExclusions,
	  PnrFinishingRemarksPanelGuestTravellerRemarks: PnrFinishingRemarksPanelGuestTravellerRemarks,
	  PnrFinishingRemarksPanelPreTripApprovalExclusions: PnrFinishingRemarksPanelPreTripApprovalExclusions,
	  PnrFinishingRemarksPanelPreTripApprovalRemarks: PnrFinishingRemarksPanelPreTripApprovalRemarks,
	  PnrFinishingRemarksPanelStandardRemarks: PnrFinishingRemarksPanelStandardRemarks,
	  Gdssettings: Gdssettings,
	  CountryPnrFinishingRemarksGridItem: CountryPnrFinishingRemarksGridItem,
	  FlightFareBucketClassesItem: FlightFareBucketClassesItem,
	  SalesAgentsItem: SalesAgentsItem,
	  PerDiemDefaultRatesItem: PerDiemDefaultRatesItem,
	  PerDiemMappingsItem: PerDiemMappingsItem,
	  HotelRateCategoriesItem: HotelRateCategoriesItem,
	  HotelAmenityFiltersItem: HotelAmenityFiltersItem,
	  RailCharacterMappingsItem: RailCharacterMappingsItem,
	  ErrorMessagesItem: ErrorMessagesItem,
	  FlightFareDataItem: FlightFareDataItem,
	  TermsAndConditionsSettingsItem: TermsAndConditionsSettingsItem,
	  VehicleDefaultsItem: VehicleDefaultsItem,
	  VehicleEmissionsItem: VehicleEmissionsItem,
	  CreditCardMappingsItem: CreditCardMappingsItem,
	  GuestTravellersTitlesGroup: GuestTravellersTitlesGroup,
	  GdssettingsItem: GdssettingsItem,
	  CountryPnrFinishingRemarksCountryCode: CountryPnrFinishingRemarksCountryCode,
	  CountryPnrFinishingRemarksPnrFinishingRemarksExclusionRemarks: CountryPnrFinishingRemarksPnrFinishingRemarksExclusionRemarks,
	  CountryPnrFinishingRemarksPnrFinishingRemarksStandardRemarks: CountryPnrFinishingRemarksPnrFinishingRemarksStandardRemarks,
	  CountryPnrFinishingRemarksHostCommands: CountryPnrFinishingRemarksHostCommands,
	  CountryPnrFinishingRemarksPnrFinishingRemarksPreTripApprovalRemarksExclusions: CountryPnrFinishingRemarksPnrFinishingRemarksPreTripApprovalRemarksExclusions,
	  CountryPnrFinishingRemarksPnrFinishingRemarksPreTripApprovalRemarksRemarks: CountryPnrFinishingRemarksPnrFinishingRemarksPreTripApprovalRemarksRemarks,
	  CountryPnrFinishingRemarksPnrFinishingRemarksGuestTravellerRemarksExclusions: CountryPnrFinishingRemarksPnrFinishingRemarksGuestTravellerRemarksExclusions,
	  CountryPnrFinishingRemarksPnrFinishingRemarksGuestTravellerRemarksRemarks: CountryPnrFinishingRemarksPnrFinishingRemarksGuestTravellerRemarksRemarks,
	  CountryPnrFinishingRemarksAdditionalPnrRemarksApprovalRemarksExclusions: CountryPnrFinishingRemarksAdditionalPnrRemarksApprovalRemarksExclusions,
	  CountryPnrFinishingRemarksAdditionalPnrRemarksApprovalRemarksRemarks: CountryPnrFinishingRemarksAdditionalPnrRemarksApprovalRemarksRemarks,
	  CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksExclusions: CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksExclusions,
	  CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksRemarks: CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksRemarks,
	  CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksNonRefundableExclusions: CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksNonRefundableExclusions,
	  CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksNonRefundableRemarks: CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksNonRefundableRemarks,
	  CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredRemarksExclusions: CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredRemarksExclusions,
	  CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredRemarksRemarks: CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredRemarksRemarks,
	  CountryPnrFinishingRemarksAdditionalPnrRemarksCancelRemarksRemarks: CountryPnrFinishingRemarksAdditionalPnrRemarksCancelRemarksRemarks,
	  CountryPnrFinishingRemarksAdditionalPnrRemarksCancelRemarksExclusions: CountryPnrFinishingRemarksAdditionalPnrRemarksCancelRemarksExclusions,
	  CountryPnrFinishingRemarksAdditionalPnrRemarksModifyRemarksRemarks: CountryPnrFinishingRemarksAdditionalPnrRemarksModifyRemarksRemarks,
	  CountryPnrFinishingRemarksAdditionalPnrRemarksModifyRemarksExclusions: CountryPnrFinishingRemarksAdditionalPnrRemarksModifyRemarksExclusions,
	  CountryPnrFinishingRemarksAdditionalPnrRemarksUserHoldRemarksRemarks: CountryPnrFinishingRemarksAdditionalPnrRemarksUserHoldRemarksRemarks,
	  CountryPnrFinishingRemarksAdditionalPnrRemarksUserHoldRemarksExclusions: CountryPnrFinishingRemarksAdditionalPnrRemarksUserHoldRemarksExclusions,
	  CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredUserHoldRemarksExclusions: CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredUserHoldRemarksExclusions,
	  CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredUserHoldRemarksRemarks: CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredUserHoldRemarksRemarks,
	  CountryPnrFinishingRemarksGdsRemarksGrid: CountryPnrFinishingRemarksGdsRemarksGrid,
	  FlightFareBucketClassesName: FlightFareBucketClassesName,
	  FlightFareBucketClassesSort: FlightFareBucketClassesSort,
	  FlightFareBucketClassesFareClasses: FlightFareBucketClassesFareClasses,
	  SalesAgentsIsEnabled: SalesAgentsIsEnabled,
	  SalesAgentsName: SalesAgentsName,
	  SalesAgentsCode: SalesAgentsCode,
	  PerDiemDefaultRatesEffectiveDate: PerDiemDefaultRatesEffectiveDate,
	  PerDiemDefaultRatesCountry: PerDiemDefaultRatesCountry,
	  PerDiemDefaultRatesAmount: PerDiemDefaultRatesAmount,
	  PerDiemMappingsValue: PerDiemMappingsValue,
	  PerDiemMappingsAlternateValues: PerDiemMappingsAlternateValues,
	  PerDiemMappingsType: PerDiemMappingsType,
	  HotelRateCategoriesName: HotelRateCategoriesName,
	  HotelRateCategoriesKeywords: HotelRateCategoriesKeywords,
	  HotelRateCategoriesContractCodes: HotelRateCategoriesContractCodes,
	  HotelRateCategoriesSabreSourceType: HotelRateCategoriesSabreSourceType,
	  HotelRateCategoriesFilterDisplayName: HotelRateCategoriesFilterDisplayName,
	  HotelRateCategoriesLogoUrl: HotelRateCategoriesLogoUrl,
	  HotelRateCategoriesDisplayOnTop: HotelRateCategoriesDisplayOnTop,
	  HotelRateCategoriesIsAggregator: HotelRateCategoriesIsAggregator,
	  HotelAmenityFiltersDisplayName: HotelAmenityFiltersDisplayName,
	  HotelAmenityFiltersAmenities: HotelAmenityFiltersAmenities,
	  HotelAmenityFiltersMostPopular: HotelAmenityFiltersMostPopular,
	  RailCharacterMappingsSpecialCharacter: RailCharacterMappingsSpecialCharacter,
	  RailCharacterMappingsSystemCharacter: RailCharacterMappingsSystemCharacter,
	  ErrorMessagesKey: ErrorMessagesKey,
	  ErrorMessagesValue: ErrorMessagesValue,
	  ErrorMessagesUseRegularExpressions: ErrorMessagesUseRegularExpressions,
	  FlightFareDataName: FlightFareDataName,
	  FlightFareDataFareClassType: FlightFareDataFareClassType,
	  FlightFareDataMixedTypeRestriction: FlightFareDataMixedTypeRestriction,
	  FlightFareDataRefundableRestriction: FlightFareDataRefundableRestriction,
	  FlightFareDataRefundPenaltyRestriction: FlightFareDataRefundPenaltyRestriction,
	  FlightFareDataChangeableRestriction: FlightFareDataChangeableRestriction,
	  FlightFareDataBasicRestriction: FlightFareDataBasicRestriction,
	  TermsAndConditionsSectionType: TermsAndConditionsSectionType,
	  TermsAndConditionsCountries: TermsAndConditionsCountries,
	  TermsAndConditionsSegmentTypes: TermsAndConditionsSegmentTypes,
	  TermsAndConditionsText: TermsAndConditionsText,
	  VehicleDefaultsName: VehicleDefaultsName,
	  VehicleDefaultsCategoryCode: VehicleDefaultsCategoryCode,
	  VehicleDefaultsTypeCode: VehicleDefaultsTypeCode,
	  VehicleDefaultsImageUrl: VehicleDefaultsImageUrl,
	  GuestTravellersTitlesCode: GuestTravellersTitlesCode,
	  GuestTravellersTitlesName: GuestTravellersTitlesName,
	  GuestTravellersTitlesDisplayOrder: GuestTravellersTitlesDisplayOrder,
	  GuestTravellersTitlesIsDeleted: GuestTravellersTitlesIsDeleted,
	  GuestTravellersTitlesValid: GuestTravellersTitlesValid,
	  GuestTravellersTitlesEnabled: GuestTravellersTitlesEnabled,
	  GdsName: GdsName,
	  GdsEnabled: GdsEnabled,
	  GdsSettings: GdsSettings,
	  CountryPnrFinishingRemarksGdsRemarksItem: CountryPnrFinishingRemarksGdsRemarksItem,
	  CountryPnrFinishingRemarksGdsRemarksName: CountryPnrFinishingRemarksGdsRemarksName,
	  CountryPnrFinishingRemarksGdsRemarksFinishingRemarksRemarks: CountryPnrFinishingRemarksGdsRemarksFinishingRemarksRemarks,
	  CountryPnrFinishingRemarksGdsRemarksFinishingRemarksExclusions: CountryPnrFinishingRemarksGdsRemarksFinishingRemarksExclusions,
	  CountryPnrFinishingRemarksGdsRemarksSeatRemarks: CountryPnrFinishingRemarksGdsRemarksSeatRemarks,
	  CountryPnrFinishingRemarksGdsRemarksAncillaryRemarks: CountryPnrFinishingRemarksGdsRemarksAncillaryRemarks,
	  GdsPassiveFlightSegmentRemarkTemplate: GdsPassiveFlightSegmentRemarkTemplate,
	  ConfigReportPanel: ConfigReportPanel,
	  ConfigReportDownloader: ConfigReportDownloader,
	  ConfigFileUploader: ConfigFileUploader,
	  RegionalMobileContactDetailsFileUploader: RegionalMobileContactDetailsFileUploader,
	  HotelPreferredTagsSourceType: HotelPreferredTagsSourceType,
	  HotelTagsToIgnoreFromDatabase: HotelTagsToIgnoreFromDatabase,
	  HotelDepositRequiredAndPrepayKeywords: HotelDepositRequiredAndPrepayKeywords,
	  HotelNonRefundableKeywords: HotelNonRefundableKeywords,
	  HotelOtherExcludedKeywords: HotelOtherExcludedKeywords,
	  ItineraryValidatorSettings: ItineraryValidatorSettings,
	  BookingThreshold: BookingThreshold,
	  NamedListItem: NamedListItem,
	  FlightModificationSettingItem: FlightModificationSettingItem,
	  SettingsCustomAirportHubsItem: SettingsCustomAirportHubsItem,
	  SettingsCustomAirportHubName: SettingsCustomAirportHubName,
	  SettingsCustomAirportHubAirports: SettingsCustomAirportHubAirports,
	  FlightSearchConfigurationItem: FlightSearchConfigurationItem,
	  CreditCardMappingsCardProvider: CreditCardMappingsCardProvider,
	  CreditCardMappingsCardTypes: CreditCardMappingsCardTypes,
	  EnableNewUiSystemSetting: EnableNewUiSystemSetting,
	  CountryAirlinesItem: CountryAirlinesItem,
	  FlightAncillaryCodesItem: FlightAncillaryCodesItem,
	  TaxDisplayModeSystemSetting: TaxDisplayModeSystemSetting
	};
	module.exports = exports["default"];

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var _fieldsSettingsResourceJs = __webpack_require__(452);
	
	var Disabled = {
	  displayName: "DISABLED",
	  dataAt: "Disabled",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.BOOLEAN
	};
	
	var IsDefault = {
	  displayName: 'Default Settings',
	  dataAt: 'IsDefault',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.SELECT,
	  optionsAt: 'BoolNullableType',
	  defaultValue: "false",
	  handleAsString: true,
	  allowNullable: false,
	  hideShowProperty: 'IsDefault',
	  helpText: "Only 1 Settings should be set as default. If set, this will be the default Settings that is returned if there is no matching Settings for a debtor's Home Country Code."
	};
	
	var CountryCodes = {
	  displayName: 'Debtor Home Country Codes',
	  dataAt: 'CountryCodes',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT,
	  formClass: 'IsDefault_false',
	  helpText: "Requires at least one Country Code if is not Default Settings. If blank, saving will fail."
	};
	
	var GlobalSettingsMiscPanel = {
	  tabName: "Settings-Misc",
	  dataAt: "",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GROUP,
	  children: [_fieldsSettingsResourceJs.Id, Disabled, IsDefault, CountryCodes, _fieldsSettingsResourceJs.FlightFareClasses, _fieldsSettingsResourceJs.FlightFareBucketClassesGrid, _fieldsSettingsResourceJs.LimitCountries, _fieldsSettingsResourceJs.ItineraryValidatorSettings, _fieldsSettingsResourceJs.BookingThreshold, _fieldsSettingsResourceJs.ErrorMessagesGrid, _fieldsSettingsResourceJs.DefaultFareRules, _fieldsSettingsResourceJs.FlightFareDataGrid, _fieldsSettingsResourceJs.TermsAndConditionsGrid, _fieldsSettingsResourceJs.VehicleDefaultsGrid, _fieldsSettingsResourceJs.VehicleEmissionsGrid, _fieldsSettingsResourceJs.IsFlightSearchUniversalProductAttributesTabEnabled, _fieldsSettingsResourceJs.FlightSearchUniversalProductAttributesTabLabel, _fieldsSettingsResourceJs.IsFlightSearchUniversalProductAttributesShortcutEnabled, _fieldsSettingsResourceJs.FlightSearchUniversalProductAttributesShortcutLabel, _fieldsSettingsResourceJs.EnableNewUiSystemSetting]
	};
	
	var GlobalSettingsTabs = {
	  displayName: "Settings",
	  iconClass: "fa-cog",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TABS,
	  children: [GlobalSettingsMiscPanel, _fieldsSettingsResourceJs.ApprovalPanel, _fieldsSettingsResourceJs.AdditionalPnrRemarksPanel, _fieldsSettingsResourceJs.GuestTravellersTitlesPanel, _fieldsSettingsResourceJs.PnrFinishingRemarksPanel, _fieldsSettingsResourceJs.SettingsGDSPanel, _fieldsSettingsResourceJs.CountryPnrFinishingRemarksGrid, _fieldsSettingsResourceJs.SalesAgentsPanel, _fieldsSettingsResourceJs.HotelPanel, _fieldsSettingsResourceJs.RailPanel, _fieldsSettingsResourceJs.FlightPanel, _fieldsSettingsResourceJs.PerDiemPanel, _fieldsSettingsResourceJs.ConfigReportPanel, _fieldsSettingsResourceJs.UnusedTicketPanel, _fieldsSettingsResourceJs.DatetimeFormatPanel, _fieldsSettingsResourceJs.NamedListsPanel, _fieldsSettingsResourceJs.CreditCardMappingsPanel, _fieldsSettingsResourceJs.CountryAirlinesPanel]
	};
	
	var GlobalSettingsAddResource = {
	  displayAs: _constantsJs2['default'].DISPLAY_AS.ADD_GRID_RESOURCE,
	  displayName: "Global Settings",
	  data: {
	    IsDefault: false,
	    CountryCodes: []
	  },
	  children: [IsDefault, CountryCodes],
	  endpoint: "GlobalSettings"
	};
	
	var GlobalSettingsResource = {
	  displayName: 'Settings',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  dataAt: '',
	  iconClass: 'fa-cog',
	  children: [GlobalSettingsTabs],
	  endpoint: 'GlobalSettings',
	  routeParamId: 'settingsId'
	};
	
	var GlobalSettingsList = {
	  rootNode: true,
	  displayName: 'Global Settings',
	  endpoint: 'GlobalSettings',
	  ODataArgs: '?$select=Id,IsDefault,CountryCodes,Disabled',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  gridItem: GlobalSettingsResource,
	  gridAdd: GlobalSettingsAddResource,
	  canCopyResource: true,
	  copyWithoutCopyText: true,
	  canFilterDisabled: true,
	  disableProperty: 'Disabled',
	  iconClass: 'fa-cog',
	  gridCols: [{ name: 'Default Settings', key: 'IsDefault' }, { name: 'Debtor Home Country Codes', key: 'CountryCodes' }, { name: 'Disabled', key: 'Disabled' }]
	};
	
	exports['default'] = {
	  GlobalSettingsList: GlobalSettingsList,
	  GlobalSettingsResource: GlobalSettingsResource,
	  GlobalSettingsAddResource: GlobalSettingsAddResource,
	  GlobalSettingsTabs: GlobalSettingsTabs,
	  GlobalSettingsMiscPanel: GlobalSettingsMiscPanel,
	  Disabled: Disabled,
	  IsDefault: IsDefault,
	  CountryCodes: CountryCodes
	};
	module.exports = exports['default'];

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports,'__esModule',{value:true});function _interopRequireDefault(obj){return obj && obj.__esModule?obj:{'default':obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i < arr.length;i++) arr2[i] = arr[i];return arr2;}else {return Array.from(arr);}}var _constantsJs=__webpack_require__(147);var _constantsJs2=_interopRequireDefault(_constantsJs);var _componentsDebtorsAgencyVirtualCreditCardConfiguration=__webpack_require__(455);var _componentsDebtorsProfileAttribute=__webpack_require__(456);var PaymentConfigurationsPaymentTypesConfigurationsSuppliersSettings={displayName:"Settings",dataAt:"PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Configurations.$payTypeConItem.Suppliers.$payConSupItem.Settings",displayAs:_constantsJs2['default'].DISPLAY_AS.KEY_VALUE_PAIRS,keyOptions:"SuppliersSettingsOptions"};var PaymentConfigurationsPaymentTypesConfigurationsSuppliersName={displayName:"Name",dataAt:"PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Configurations.$payTypeConItem.Suppliers.$payConSupItem.Name",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var PaymentConfigurationsPaymentTypesConfigurationsSuppliersItem={displayName:"Suppliers",dataAt:"PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Configurations.$payTypeConItem.Suppliers.$payConSupItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[PaymentConfigurationsPaymentTypesConfigurationsSuppliersName,PaymentConfigurationsPaymentTypesConfigurationsSuppliersSettings],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"payConSupItem",canDelete:true};var DebtorGdsPassiveFlightSegmentRemarkTemplate={displayName:"Item",dataAt:"Gds.$GdsItem.PassiveFlightSegmentRemarks.$RemarkTemplate",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[{displayName:"Type",dataAt:"Gds.$GdsItem.PassiveFlightSegmentRemarks.$RemarkTemplate.Type",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"RemarkType"},{displayName:"Template",dataAt:"Gds.$GdsItem.PassiveFlightSegmentRemarks.$RemarkTemplate.Template",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT}],endpoint:"Debtors",removeParamId:"RemarkTemplate",canDelete:true};var GdsPassiveFlightSegmentRemarks={displayName:"Passive Flight Segment Remarks",dataAt:"Gds.$GdsItem.PassiveFlightSegmentRemarks",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:DebtorGdsPassiveFlightSegmentRemarkTemplate,gridCols:[{name:"Type",key:"Type"},{name:"Template",key:"Template"}]};var DebtorGdsMiQuestionsItemQuestionsItemAnswerFormat={displayName:"Answer Format",dataAt:"Gds.$GdsItem.MiQuestions.$MiItem.Questions.$question.AnswerFormat",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorGdsMiQuestionsItemQuestionsItemQuestion={displayName:"Question",dataAt:"Gds.$GdsItem.MiQuestions.$MiItem.Questions.$question.Question",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var PaymentConfigurationsPaymentTypesConfigurationsSuppliers={displayName:"Suppliers",dataAt:"PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Configurations.$payTypeConItem.Suppliers",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:PaymentConfigurationsPaymentTypesConfigurationsSuppliersItem,gridCols:[{name:"Name",key:"Name"}]};var PaymentConfigurationsPaymentTypesConfigurationsSector={displayName:"Sector",dataAt:"PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Configurations.$payTypeConItem.Sector",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"SectorTypes"};var ItineraryPoliciesCarPolicyRestrictionPolicyType={displayName:"Policy Type",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction.$carPolRestrictedItem.PolicyType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"CarPolicyTypes"};var ItineraryPoliciesCarPolicyRestrictionMaximumDailyRate={displayName:"Maximum Daily Rate",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction.$carPolRestrictedItem.MaximumDailyRate",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var ItineraryPoliciesCarPolicyRestrictionSipps={displayName:"Sipps",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction.$carPolRestrictedItem.Sipps",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesCarPolicyRestrictionCountryCodes={displayName:"Country Codes",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction.$carPolRestrictedItem.CountryCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesCarPolicyRestrictionLocationCodes={displayName:"Location Codes",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction.$carPolRestrictedItem.LocationCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesCarPolicyRestrictionSuppliers={displayName:"Suppliers",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction.$carPolRestrictedItem.Suppliers",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesCarPolicyPreferredSipps={displayName:"Sipps",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyPreferred.$carPolPrefItem.Sipps",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesCarPolicyPreferredCountryCodes={displayName:"Country Codes",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyPreferred.$carPolPrefItem.CountryCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesCarPolicyPreferredLocationCodes={displayName:"Location Codes",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyPreferred.$carPolPrefItem.LocationCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesCarPolicyPreferredSuppliers={displayName:"Suppliers",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyPreferred.$carPolPrefItem.Suppliers",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesCarPolicyExceptionSettingsSipps={displayName:"Sipps",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem.Sipps",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesCarPolicyExceptionSettingsSuppliers={displayName:"Supplier Codes",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem.Suppliers",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesCarPolicyExceptionSettingsCountryCodes={displayName:"Country Codes",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem.CountryCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesCarPolicyExceptionSettingsLocationCodes={displayName:"Location Codes",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem.LocationCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesCarPolicyExceptionSettingsMaximumDailyRate={displayName:"Maximum Daily Rate",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem.MaximumDailyRate",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var ItineraryPoliciesCarPolicyExceptionSettingsSupplierCode={displayName:"Supplier Code (depreciated)",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem.SupplierCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesCarPolicyExceptionSettingsCountryCode={displayName:"Country Code (depreciated)",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem.CountryCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesCarPolicyExceptionSettingsLocationCode={displayName:"Location Code (depreciated)",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem.LocationCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesCarPolicyExceptionsCountries={displayName:"Countries",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptions.$carPolExcItem.Countries",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesCarPolicyExceptionsCode={displayName:"Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptions.$carPolExcItem.Code",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesCarPolicyExceptionsTitle={displayName:"Title",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptions.$carPolExcItem.Title",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesCarPoliciesAllowDeliveryAndCollection={displayName:"Allow Delivery And Collection",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.AllowDeliveryAndCollection",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var ItineraryPoliciesCarPoliciesCostCentres={displayName:"Debtor Cost Centres",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.CostCentres",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesCarPoliciesDepartments={displayName:"Debtor Departments",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.Departments",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesCarPoliciesRate={displayName:"Car Policies Rate",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.Rate",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesCarPoliciesCorporateCode={displayName:"Car Policies Corporate Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.CorporateCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesCarPoliciesGuaranteeText={displayName:"Car Policies Guarantee Text",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.GuaranteeText",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesCarPoliciesDebtorRateOverTravelerId={displayName:"Car Policies Use Debtor Rate Over Traveler ID",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.DebtorRateOverTravelerId",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var ItineraryPoliciesCarPoliciesSupplierTitle={displayName:"Car Policies Supplier Title",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.Supplier.Title",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesCarPoliciesSupplierCode={displayName:"Car Policies Supplier Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.Supplier.Code",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesCarPoliciesName={displayName:"Car Policy Name",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.Name",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesCarPoliciesBillingReference={displayName:"Car Billing Reference",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.BillingReference",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesCarPoliciesUseCompanyRefCodeForBillingRef={displayName:"Car Billing Reference Use Company Reference Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem.UseCompanyRefCodeForBillingRef",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var ItineraryPoliciesCarPoliciesUseCompanyRefCodeForBillingRefSub={displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,label:"Billing Reference = CompanyReference.Code. If Company Reference is not found or is empty then no Billing Reference is sent."};var ItineraryPoliciesCarDisableCar={displayName:"Disable Car",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.DisableCar",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var ItineraryPoliciesHotelPolicyExceptionSettingsLatLong={displayName:"Address Search",displayAs:_constantsJs2['default'].DISPLAY_AS.LAT_LONG_MAP_SEARCH,latField:"ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.Latitude",longField:"ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.Longitude",radiusField:"ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.Radius",hotelsField:"ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.HotelIDs",IsImperialSystemField:"HotelConfiguration.IsImperialSystem"};var ItineraryPoliciesHotelPolicyExceptionSettingsLongitude={displayName:"Longitude",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.Longitude",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number",min:-9999999999,max:9999999999};var ItineraryPoliciesHotelPolicyExceptionSettingsLatitude={displayName:"Latitude",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.Latitude",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number",min:-9999999999,max:9999999999};var ItineraryPoliciesHotelPolicyExceptionSettingsName={displayName:"Name",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.Name",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesHotelPolicyExceptionSettingsLocationCode={displayName:"Location Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.LocationCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesHotelPolicyExceptionSettingsAirportCodes={displayName:"Airport Codes",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.AirportCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT,html:"<small>If there are multiple airports in a city location, identify all airports here. Use the codes that the Sabre hotels are associated to in that area.</small>"};var ItineraryPoliciesHotelPolicyExceptionSettingsHotelIDs={displayName:"Hotel IDs",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.HotelIDs",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesHotelPolicyExceptionSettingsCountryCode={displayName:"Country Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.CountryCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesHotelPolicyExceptionSettingsMaximumDailyRate={displayName:"Maximum Daily Rate",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.MaximumDailyRate",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number",html:"<small>If Maximum Daily Rate is blank or is set to zero then the system will apply the Price Tolerance against the Hotel Lost Savings calculation, otherwise the Price Tolerance will be applied against the Maximum Daily Rate amount.</small>"};var ItineraryPoliciesHotelPolicyExceptionSettingsPriceTolerance={displayName:"Price Tolerance",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.PriceTolerance",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var ItineraryPoliciesHotelPolicyExceptionSettingsPriceToleranceType={displayName:"Price Tolerance Type",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.PriceToleranceType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"PriceToleranceType"};var ItineraryPoliciesHotelPolicyExceptionSettingsRadius={displayName:"Radius",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem.Radius",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var ItineraryPoliciesHotelPolicyExceptionsCountries={displayName:"Countries",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptions.$hotelPolExcItem.Countries",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesHotelPolicyExceptionsCode={displayName:"Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptions.$hotelPolExcItem.Code",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesHotelPolicyExceptionsTitle={displayName:"Title",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptions.$hotelPolExcItem.Title",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesHotelRateCategoriesCategory={displayName:"Rate Category",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.RateCategories.$hotelRCItem.Category",defaultValue:"Government",displayAs:_constantsJs2['default'].DISPLAY_AS.O_DATA_SELECT,endpoint:"Settings",queryOption:"select",selectProperty:"HotelRateCategories",selectChoiceName:"Name",entityIdentifier:"Name",searchAllNo:true,inputTitle:"Name",required:true,validationMessage:"Rate Category is required."};var ItineraryPoliciesHotelRateCategoriesPriority={displayName:"Display Priority",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.RateCategories.$hotelRCItem.Priority",optionsAt:"HotelRateCategoriesPriorities",defaultValue:"No priority",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT};var ItineraryPoliciesHotelExcludedAggregatorChainsAggregator={displayName:"Aggregator",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.ExcludedAggregatorChains.$hotelEACItem.Aggregator",displayAs:_constantsJs2['default'].DISPLAY_AS.O_DATA_SELECT,endpoint:"Settings",queryOption:"select",selectProperty:"HotelRateCategories",inputTitle:"Name",selectChoiceName:"Name",entityIdentifier:"Name",searchAllNo:true,isMultiSelect:false,additionalFilters:{"IsAggregator":true},showOnlySelectedField:true};var ItineraryPoliciesHotelExcludedAggregatorChainsChains={displayName:"Exclude from:",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.ExcludedAggregatorChains.$hotelEACItem.Chains",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesHotelNoHotelPoliciesTitle={displayName:"Title",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.NoHotelPolicies.$hotelNHPItem.Title",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesHotelNoHotelPoliciesCode={displayName:"Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.NoHotelPolicies.$hotelNHPItem.Code",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesHotelNoHotelPoliciesInfo={displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,label:"(Only active when Overnight Hotel Prompt is enabled)"};var ItineraryPoliciesHotelPoliciesLatLong={displayName:"Address Search",displayAs:_constantsJs2['default'].DISPLAY_AS.LAT_LONG_MAP_SEARCH,latField:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Latitude",longField:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Longitude",radiusField:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Radius",IsImperialSystemField:"HotelConfiguration.IsImperialSystem",additionalPlots:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Hotels"};var ItineraryPoliciesHotelPoliciesLongitude={displayName:"Policy Longitude",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Longitude",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number",min:-9999999999,max:9999999999};var ItineraryPoliciesHotelPoliciesLatitude={displayName:"Policy Latitude",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Latitude",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number",min:-9999999999,max:9999999999};var ItineraryPoliciesHotelPoliciesRadius={displayName:"Policy Radius",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Radius",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var ItineraryPoliciesHotelPoliciesExcludedHotels={displayName:"Excluded Hotels",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.ExcludedHotels",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesHotelPoliciesExcludedChainCodes={displayName:"Excluded Chains",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.ExcludedChainCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesHotelPoliciesMinimumHotelRating={displayName:"Minimum Hotel Rating",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.MinimumHotelRating",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number",min:0,max:4};var ItineraryPoliciesHotelPoliciesMaximumHotelRating={displayName:"Maximum Hotel Rating",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.MaximumHotelRating",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number",min:0,max:4};var ItineraryPoliciesHotelPoliciesPostCode={displayName:"Post Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.PostCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesHotelPoliciesCountryCode={displayName:"Hotel Policies Country Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.CountryCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesHotelPoliciesLocationCode={displayName:"Hotel Policies Location Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.LocationCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesHotelPoliciesRateMax={displayName:"Hotel Policies Maximum Rate",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Rate.Max",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var ItineraryPoliciesHotelPoliciesRateMin={displayName:"Hotel Policies Minimum Rate",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Rate.Min",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var ItineraryPoliciesHotelPoliciesMostPreferredHotels={displayName:"Most Preferred Hotel IDs",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.MostPreferredHotels",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesHotelPoliciesMostPreferredChainCodes={displayName:"Most Preferred Hotel Chains",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.MostPreferredChainCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesHotelPoliciesHighlyPreferredHotels={displayName:"Highly Preferred Hotel IDs",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.HighlyPreferredHotels",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesHotelPoliciesHighlyPreferredChainCodes={displayName:"Highly Preferred Hotel Chains",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.HighlyPreferredChainCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesHotelPoliciesHotels={displayName:"Preferred Hotel IDs",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.Hotels",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesHotelPoliciesChainCodes={displayName:"Preferred Hotel Chains",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.ChainCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesHotelPoliciesPolicyName={displayName:"Hotel Policy Name",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem.PolicyName",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesHotelDisableHotel={displayName:"Disable Hotel",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.DisableHotel",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var ItineraryPoliciesRailPolicyExceptionsCountries={displayName:"Countries",dataAt:"ItineraryPolicies.$ItinPolIndex.Rail.PolicyExceptions.$railPolExcItem.Countries",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesRailPolicyExceptionsCode={displayName:"Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Rail.PolicyExceptions.$railPolExcItem.Code",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesRailPolicyExceptionsTitle={displayName:"Title",dataAt:"ItineraryPolicies.$ItinPolIndex.Rail.PolicyExceptions.$railPolExcItem.Title",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesRailPoliciesGroupTypes={displayName:"Group Types",dataAt:"ItineraryPolicies.$ItinPolIndex.Rail.Policies.$railPolItem.GroupTypes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesRailPoliciesPolicyType={displayName:"Policy Type",dataAt:"ItineraryPolicies.$ItinPolIndex.Rail.Policies.$railPolItem.PolicyType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"PolicyTypes"};var ItineraryPoliciesRailPoliciesSuppliers={displayName:"Suppliers",dataAt:"ItineraryPolicies.$ItinPolIndex.Rail.Policies.$railPolItem.Suppliers",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesRailPoliciesCorporateCode={displayName:"Corporate Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Rail.Policies.$railPolItem.CorporateCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesRailDisableRail={displayName:"Disable Rail",dataAt:"ItineraryPolicies.$ItinPolIndex.Rail.DisableRail",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var ItineraryPoliciesFlightPolicyExceptionSettingsBenchmarkMostDirect={displayName:"Benchmark Most Direct",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.BenchmarkMostDirect",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var ItineraryPoliciesFlightPolicyExceptionSettingsFlightType={displayName:"Flight Type",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.FlightType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"FlightTypes"};var ItineraryPoliciesFlightPolicyExceptionSettingsLowestFareGroupType={displayName:"Lowest Fare Group Type",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.LowestFareGroupType",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesFlightPolicyExceptionSettingsPriceTolerance={displayName:"Price Tolerance",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.PriceTolerance",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var ItineraryPoliciesFlightPolicyExceptionSettingsPriceToleranceType={displayName:"Price Tolerance Type",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.PriceToleranceType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"PriceToleranceType"};var ItineraryPoliciesFlightPolicyExceptionSettingsGroupTypes={displayName:"Group Types",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.GroupTypes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesFlightPolicyExceptionSettingsDurationTo={displayName:"Duration To",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.DurationTo",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var ItineraryPoliciesFlightPolicyExceptionSettingsDurationFrom={displayName:"Duration From",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.DurationFrom",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var ItineraryPoliciesFlightPolicyExceptionSettingsDestinationCountryCode={displayName:"Destination Country Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.DestinationCountryCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesFlightPolicyExceptionSettingsOriginCountryCode={displayName:"Origin Country Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem.OriginCountryCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesFlightPolicyExceptionsCountries={displayName:"Countries",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptions.$flightPolExcItem.Countries",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesFlightPolicyExceptionsCode={displayName:"Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptions.$flightPolExcItem.Code",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesFlightPolicyExceptionsTitle={displayName:"Title",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptions.$flightPolExcItem.Title",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesLessThanXDayExceptionsTitle={displayName:"Title",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyLessThanXDays.$flightLessThanXPolItem.Title",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesLessThanXDayExceptionsCode={displayName:"Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyLessThanXDays.$flightLessThanXPolItem.Code",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesFlightFlyAmericaPolicyExceptionsTitle={displayName:"Title",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.FlyAmericaPolicy.FlyAmericaPolicyExceptions.$flyAmericaPolicyExceptionItem.Title",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesFlightFlyAmericaPolicyExceptionsCode={displayName:"Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.FlyAmericaPolicy.FlyAmericaPolicyExceptions.$flyAmericaPolicyExceptionItem.Code",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesFlightPoliciesPolicyType={displayName:"Policy Type",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.PolicyType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"PolicyTypes"};var ItineraryPoliciesFlightPoliciesFareClasses={displayName:"Fare Classes",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.FareClasses",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesFlightPoliciesBrandCodes={displayName:"Brand Codes",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.BrandCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesFlightPoliciesGroupTypes={displayName:"Group Types",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.GroupTypes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesFlightPoliciesDurationTo={displayName:"Duration To",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.DurationTo",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var ItineraryPoliciesFlightPoliciesDurationFrom={displayName:"Duration From",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.DurationFrom",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var ItineraryPoliciesFlightPoliciesDurationType={displayName:"Duration Type",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.DurationType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"DurationTypeOptions"};var ItineraryPoliciesFlightPoliciesDestinationCountryCode={displayName:"Destination Country Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.DestinationCountryCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesFlightPoliciesOriginCountryCode={displayName:"Origin Country Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.OriginCountryCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesFlightPoliciesOriginLocationCode={displayName:"Origin Location Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.OriginLocationCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesFlightPoliciesDestinationLocationCode={displayName:"Destination Location Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.DestinationLocationCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesFlightPoliciesBookingCodes={displayName:"Booking Codes",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.BookingCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPolicyFlightWeight={displayName:"Weight (Highest weight will apply in conflicting policy settings)",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.Weight",displayAs:_constantsJs2['default'].DISPLAY_AS.RANGE,min:0,max:1000,step:1};var ItineraryPolicyFlightWeightSub={displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,label:"Exclude of the same weight will be applied over an include."};var ItineraryPoliciesFlightPoliciesCarrier={displayName:"Carrier",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem.Carrier",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesFlightBenchmarksExceptionsOriginLocationCode={displayName:"Origin Location Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Exceptions.$flightBenchExcItem.OriginLocationCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesFlightBenchmarksExceptionsDestinationLocationCode={displayName:"Destination Location Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Exceptions.$flightBenchExcItem.DestinationLocationCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesFlightBenchmarksExceptionsCarrier={displayName:"Carrier",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Exceptions.$flightBenchExcItem.Carrier",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesFlightBenchmarksPoliciesBookingCodes={displayName:"Booking Codes",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Policies.$flightBenchPolItem.BookingCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesFlightBenchmarksPoliciesCarrier={displayName:"Carrier",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Policies.$flightBenchPolItem.Carrier",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesItemsTitle={displayName:"Title",dataAt:"ItineraryPolicies.$ItinPolIndex.Items.$ItinPolItemIndex.Title",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesItemsCode={displayName:"Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Items.$ItinPolItemIndex.Code",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorGdsMiQuestionsItemQuestionsItem={displayName:"Question",dataAt:"Gds.$GdsItem.MiQuestions.$MiItem.Questions.$question",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[DebtorGdsMiQuestionsItemQuestionsItemQuestion,DebtorGdsMiQuestionsItemQuestionsItemAnswerFormat],endpoint:"Debtors",removeParamId:"question",canDelete:true};var PaymentTypesConfigurationsItem={displayName:"Configuration",dataAt:"PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Configurations.$payTypeConItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[PaymentConfigurationsPaymentTypesConfigurationsSector,PaymentConfigurationsPaymentTypesConfigurationsSuppliers],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"payTypeConItem",canDelete:true};var ItineraryPoliciesCarPolicyRestrictionItem={displayName:"Policy Restriction",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction.$carPolRestrictedItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[ItineraryPoliciesCarPolicyRestrictionSuppliers,ItineraryPoliciesCarPolicyRestrictionLocationCodes,ItineraryPoliciesCarPolicyRestrictionCountryCodes,ItineraryPoliciesCarPolicyRestrictionSipps,ItineraryPoliciesCarPolicyRestrictionMaximumDailyRate,ItineraryPoliciesCarPolicyRestrictionPolicyType],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"carPolRestrictedItem",canDelete:true};var ItineraryPoliciesCarPolicyPreferredItem={displayName:"Policy Preferred",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyPreferred.$carPolPrefItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[ItineraryPoliciesCarPolicyPreferredSuppliers,ItineraryPoliciesCarPolicyPreferredLocationCodes,ItineraryPoliciesCarPolicyPreferredCountryCodes,ItineraryPoliciesCarPolicyPreferredSipps],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"carPolPrefItem",canDelete:true};var ItineraryPoliciesCarPolicyExceptionSettingsItem={displayName:"Policy Exception Settings",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings.$carPolExcSetItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[ItineraryPoliciesCarPolicyExceptionSettingsLocationCode,ItineraryPoliciesCarPolicyExceptionSettingsCountryCode,ItineraryPoliciesCarPolicyExceptionSettingsSupplierCode,ItineraryPoliciesCarPolicyExceptionSettingsMaximumDailyRate,ItineraryPoliciesCarPolicyExceptionSettingsLocationCodes,ItineraryPoliciesCarPolicyExceptionSettingsCountryCodes,ItineraryPoliciesCarPolicyExceptionSettingsSuppliers,ItineraryPoliciesCarPolicyExceptionSettingsSipps],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"carPolExcSetItem",canDelete:true};var ItineraryPoliciesCarPolicyExceptionsItem={displayName:"Item",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptions.$carPolExcItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[ItineraryPoliciesCarPolicyExceptionsTitle,ItineraryPoliciesCarPolicyExceptionsCode,ItineraryPoliciesCarPolicyExceptionsCountries],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"carPolExcItem",canDelete:true};var ItineraryPoliciesLessThanXDayExceptionsItem={displayName:"Item",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyLessThanXDays.$flightLessThanXPolItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[ItineraryPoliciesLessThanXDayExceptionsTitle,ItineraryPoliciesLessThanXDayExceptionsCode],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"flightLessThanXPolItem",canDelete:true};var ItineraryPoliciesFlightFlyAmericaPolicyExceptionsItem={displayName:"Item",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.FlyAmericaPolicy.FlyAmericaPolicyExceptions.$flyAmericaPolicyExceptionItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[ItineraryPoliciesFlightFlyAmericaPolicyExceptionsTitle,ItineraryPoliciesFlightFlyAmericaPolicyExceptionsCode],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"flyAmericaPolicyExceptionItem",canDelete:true};var ItineraryPoliciesCarPoliciesItem={displayName:"Car Policy",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.Policies.$carPolItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[ItineraryPoliciesCarPoliciesName,ItineraryPoliciesCarPoliciesSupplierCode,ItineraryPoliciesCarPoliciesSupplierTitle,ItineraryPoliciesCarPoliciesCorporateCode,ItineraryPoliciesCarPoliciesGuaranteeText,ItineraryPoliciesCarPoliciesRate,ItineraryPoliciesCarPoliciesDebtorRateOverTravelerId,ItineraryPoliciesCarPoliciesBillingReference,ItineraryPoliciesCarPoliciesUseCompanyRefCodeForBillingRef,ItineraryPoliciesCarPoliciesUseCompanyRefCodeForBillingRefSub,ItineraryPoliciesCarPoliciesDepartments,ItineraryPoliciesCarPoliciesCostCentres,ItineraryPoliciesCarPoliciesAllowDeliveryAndCollection],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"carPolItem",canDelete:true};var ItineraryPoliciesHotelPoliciesItem={displayName:"Hotel Policy",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies.$hotelPolItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[ItineraryPoliciesHotelPoliciesPolicyName,ItineraryPoliciesHotelPoliciesMostPreferredHotels,ItineraryPoliciesHotelPoliciesMostPreferredChainCodes,ItineraryPoliciesHotelPoliciesHighlyPreferredHotels,ItineraryPoliciesHotelPoliciesHighlyPreferredChainCodes,ItineraryPoliciesHotelPoliciesHotels,ItineraryPoliciesHotelPoliciesChainCodes,ItineraryPoliciesHotelPoliciesRateMax,ItineraryPoliciesHotelPoliciesLocationCode,ItineraryPoliciesHotelPoliciesCountryCode,ItineraryPoliciesHotelPoliciesPostCode,ItineraryPoliciesHotelPoliciesMinimumHotelRating,ItineraryPoliciesHotelPoliciesMaximumHotelRating,ItineraryPoliciesHotelPoliciesExcludedChainCodes,ItineraryPoliciesHotelPoliciesExcludedHotels,ItineraryPoliciesHotelPoliciesRadius,ItineraryPoliciesHotelPoliciesLatitude,ItineraryPoliciesHotelPoliciesLongitude,ItineraryPoliciesHotelPoliciesLatLong],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"hotelPolItem",canDelete:true};var ItineraryPoliciesHotelRateCategoriesItem={displayName:"Item",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.RateCategories.$hotelRCItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[ItineraryPoliciesHotelRateCategoriesCategory,ItineraryPoliciesHotelRateCategoriesPriority],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"hotelRCItem",canDelete:true};var ItineraryPoliciesHotelExcludedAggregatorChainsItem={displayName:"Item",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.ExcludedAggregatorChains.$hotelEACItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[ItineraryPoliciesHotelExcludedAggregatorChainsAggregator,ItineraryPoliciesHotelExcludedAggregatorChainsChains],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"hotelEACItem",canDelete:true};var ItineraryPoliciesHotelNoHotelPoliciesItem={displayName:"Item",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.NoHotelPolicies.$hotelNHPItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[ItineraryPoliciesHotelNoHotelPoliciesTitle,ItineraryPoliciesHotelNoHotelPoliciesCode],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"hotelNHPItem",canDelete:true};var ItineraryPoliciesRailPolicyExceptionsItem={displayName:"Item",dataAt:"ItineraryPolicies.$ItinPolIndex.Rail.PolicyExceptions.$railPolExcItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[ItineraryPoliciesRailPolicyExceptionsTitle,ItineraryPoliciesRailPolicyExceptionsCode,ItineraryPoliciesRailPolicyExceptionsCountries],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"railPolExcItem",canDelete:true};var ItineraryPoliciesRailPoliciesItem={displayName:"Policy",dataAt:"ItineraryPolicies.$ItinPolIndex.Rail.Policies.$railPolItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[ItineraryPoliciesRailPoliciesSuppliers,ItineraryPoliciesRailPoliciesCorporateCode,ItineraryPoliciesRailPoliciesPolicyType,ItineraryPoliciesRailPoliciesGroupTypes],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"railPolItem",canDelete:true};var ItineraryPoliciesFlightPolicyExceptionSettingsItem={displayName:"Item",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings.$flightPolExcSetItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[ItineraryPoliciesFlightPolicyExceptionSettingsOriginCountryCode,ItineraryPoliciesFlightPolicyExceptionSettingsDestinationCountryCode,ItineraryPoliciesFlightPolicyExceptionSettingsDurationFrom,ItineraryPoliciesFlightPolicyExceptionSettingsDurationTo,ItineraryPoliciesFlightPolicyExceptionSettingsGroupTypes,ItineraryPoliciesFlightPolicyExceptionSettingsPriceTolerance,ItineraryPoliciesFlightPolicyExceptionSettingsPriceToleranceType,ItineraryPoliciesFlightPolicyExceptionSettingsLowestFareGroupType,ItineraryPoliciesFlightPolicyExceptionSettingsFlightType,ItineraryPoliciesFlightPolicyExceptionSettingsBenchmarkMostDirect],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"flightPolExcSetItem",canDelete:true};var ItineraryPoliciesFlightPolicyExceptionsItem={displayName:"Item",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptions.$flightPolExcItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[ItineraryPoliciesFlightPolicyExceptionsTitle,ItineraryPoliciesFlightPolicyExceptionsCode,ItineraryPoliciesFlightPolicyExceptionsCountries],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"flightPolExcItem",canDelete:true};var ItineraryPoliciesFlightPoliciesItem={displayName:"Policy",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Policies.$flightPolItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[ItineraryPolicyFlightWeight,ItineraryPolicyFlightWeightSub,ItineraryPoliciesFlightPoliciesCarrier,ItineraryPoliciesFlightPoliciesBookingCodes,ItineraryPoliciesFlightPoliciesDestinationLocationCode,ItineraryPoliciesFlightPoliciesOriginLocationCode,ItineraryPoliciesFlightPoliciesOriginCountryCode,ItineraryPoliciesFlightPoliciesDestinationCountryCode,ItineraryPoliciesFlightPoliciesDurationType,ItineraryPoliciesFlightPoliciesDurationFrom,ItineraryPoliciesFlightPoliciesDurationTo,ItineraryPoliciesFlightPoliciesGroupTypes,ItineraryPoliciesFlightPoliciesFareClasses,ItineraryPoliciesFlightPoliciesBrandCodes,ItineraryPoliciesFlightPoliciesPolicyType],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"flightPolItem",canDelete:true};var ItineraryPoliciesFlightBenchmarksExceptionsItem={displayName:"Item",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Exceptions.$flightBenchExcItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[ItineraryPoliciesFlightBenchmarksExceptionsCarrier,ItineraryPoliciesFlightBenchmarksExceptionsDestinationLocationCode,ItineraryPoliciesFlightBenchmarksExceptionsOriginLocationCode],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"flightBenchExcItem",canDelete:true};var ItineraryPoliciesFlightBenchmarksPoliciesItem={displayName:"Item",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Policies.$flightBenchPolItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[ItineraryPoliciesFlightBenchmarksPoliciesCarrier,ItineraryPoliciesFlightBenchmarksPoliciesBookingCodes],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"flightBenchPolItem",canDelete:true};var ItineraryPoliciesItemsItem={displayName:"Item",dataAt:"ItineraryPolicies.$ItinPolIndex.Items.$ItinPolItemIndex",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,label:"Employee code from profile"},ItineraryPoliciesItemsCode,ItineraryPoliciesItemsTitle],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"ItinPolItemIndex",canDelete:true};var DebtorGdsCorporateIdentifiersItemCorporateCode={displayName:"Corporate Code",dataAt:"Gds.$GdsItem.CorporateIdentifiers.$corpId.CorporateCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorGdsCorporateIdentifiersItemSupplierCode={displayName:"Supplier Code",dataAt:"Gds.$GdsItem.CorporateIdentifiers.$corpId.SupplierCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorGdsMiQuestionsItemQuestions={displayName:"Questions",dataAt:"Gds.$GdsItem.MiQuestions.$MiItem.Questions",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:DebtorGdsMiQuestionsItemQuestionsItem,gridCols:[{name:"Question",key:"Question"},{name:"Answer Format",key:"AnswerFormat"}]};var DebtorGdsMiQuestionsItemSupplier={displayName:"Supplier",dataAt:"Gds.$GdsItem.MiQuestions.$MiItem.Supplier",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var PaymentConfigurationsPaymentTypesConfigurations={displayName:"Configurations",dataAt:"PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Configurations",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:PaymentTypesConfigurationsItem,gridCols:[{name:"Sector",key:"Sector"}]};var PaymentConfigurationsPaymentTypesIsOptionalPaymentType={displayName:"Is Optional Payment",dataAt:"PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.IsOptionalPaymentType",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var PaymentConfigurationsPaymentTypesType={displayName:"Type",dataAt:"PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem.Type",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"PaymentTypes"};var CompanyReferencesChildrenMandatory={displayName:"Mandatory",dataAt:"CompanyReferences.$compRefItem.Children.$compRefChildItem.Mandatory",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var CompanyReferencesChildrenFlags={displayName:"Flags",dataAt:"CompanyReferences.$compRefItem.Children.$compRefChildItem.Flags",displayAs:_constantsJs2['default'].DISPLAY_AS.MULTI_SELECT,optionsAt:"CompanyReferencesFlags"};var CompanyReferencesChildrenOptions={displayName:"Options",dataAt:"CompanyReferences.$compRefItem.Children.$compRefChildItem.Options",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT,helpText:"Use a pipe | to delineate a value and display. \r\nExample: Y|Yes \r\nThis will display Yes to the booker and capture Y as the value."};var CompanyReferencesChildrenTitle={displayName:"Title",dataAt:"CompanyReferences.$compRefItem.Children.$compRefChildItem.Title",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,validationMessage:"Title is required. Max length 100",validationRegex:"^.{1,100}$"};var CompanyReferencesChildrenPlaceHolderText={displayName:"PlaceHolder Text",dataAt:"CompanyReferences.$compRefItem.Children.$compRefChildItem.PlaceHolderText",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var CompanyReferencesChildrenCode={displayName:"Code",dataAt:"CompanyReferences.$compRefItem.Children.$compRefChildItem.Code",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,validationMessage:"Code is required. Max length 50",validationRegex:"^.{1,50}$"};var CompanyReferencesChildrenListId={displayName:"ListId",dataAt:"CompanyReferences.$compRefItem.Children.$compRefChildItem.ListId",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var CompanyReferencesChildrenMatch={displayName:"Match",dataAt:"CompanyReferences.$compRefItem.Children.$compRefChildItem.Match",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesCarPolicyRestriction={displayName:"Policy Restriction",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyRestriction",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:ItineraryPoliciesCarPolicyRestrictionItem,gridCols:[{name:"PolicyType",key:"PolicyType"},{name:"Suppliers",key:"Suppliers"},{name:"Sipps",key:"Sipps"},{name:"MaxRate",key:"MaximumDailyRate"},{name:"Location",key:"LocationCodes"},{name:"Country",key:"CountryCodes"}]};var ItineraryPoliciesCarPolicyPreferred={displayName:"Policy Preferred",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyPreferred",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:ItineraryPoliciesCarPolicyPreferredItem,gridCols:[{name:"Suppliers",key:"Suppliers"},{name:"Sipps",key:"Sipps"},{name:"LocationCodes",key:"LocationCodes"},{name:"CountryCodes",key:"CountryCodes"}]};var ItineraryPoliciesCarPolicyExceptionSettings={displayName:"Policy Exception Settings",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptionSettings",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:ItineraryPoliciesCarPolicyExceptionSettingsItem,gridCols:[{name:"Location",key:"LocationCodes"},{name:"Country",key:"CountryCodes"},{name:"Suppliers",key:"Suppliers"},{name:"Sipps",key:"Sipps"},{name:"Max Rate",key:"MaximumDailyRate"}]};var ItineraryPoliciesCarPolicyExceptions={displayName:"Policy Exceptions",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.PolicyExceptions",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:ItineraryPoliciesCarPolicyExceptionsItem,gridCols:[{name:"Title",key:"Title"},{name:"Code",key:"Code"}]};var ItineraryPoliciesCarSettingsExcludedRates={displayName:"Car Excluded Rates",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.Settings.ExcludedRates",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesCarSettingsExcludedProviders={displayName:"Car Excluded Providers",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.Settings.ExcludedProviders",displayAs:_constantsJs2['default'].DISPLAY_AS.MULTI_SELECT,optionsAt:"GDSProviders"};var ItineraryPoliciesCarSettingsRateCodes={displayName:"Car Rate Codes",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.Settings.RateCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesCarTypeDuplicateHandling={displayName:"Car Type Duplicate Handling",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.CarTypeDuplicateHandling",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"CarTypeDuplicateHandlingTypes"};var ItineraryPoliciesCarSettingsShowRatesWithDeposits={displayName:"Show Rates that Require Deposits (Sabre Only)",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.ShowRatesWithDeposits",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var ItineraryPoliciesCarPolicies={displayName:"Car Policies",dataAt:"ItineraryPolicies.$ItinPolIndex.Car.Policies",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:ItineraryPoliciesCarPoliciesItem,gridCols:[{name:"Policy Name",key:"Name"},{name:"Corporate Code",key:"CorporateCode"},{name:"Rate",key:"Rate"},{name:"Supplier",key:"Supplier.Title"},{name:"Code",key:"Supplier.Code"}]};var ItineraryPoliciesHotelPoliciesLatLngMap={displayName:"Policies Lat Long Map",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies",displayAs:_constantsJs2['default'].DISPLAY_AS.LAT_LNG_MAP};var ItineraryPoliciesHotelDefaultPolicyRateMax={displayName:"Hotel Policy Default Maximum Rate",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.DefaultPolicy.Rate.Max",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var ItineraryPoliciesHotelDefaultPolicyRateMin={displayName:"Hotel Policy Default Minimum Rate",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.DefaultPolicy.Rate.Min",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var ItineraryPoliciesHotelSettingsExcludeDepositRequiredAndPrepayRates={displayName:"Exclude Rates That Require Deposit/Prepay (Sabre Only)",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Settings.ExcludeDepositRequiredAndPrepayRates",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var ItineraryPoliciesHotelSettingsExcludeHotelOtherExcludedKeywords={displayName:"Exclude Other Rates By System-level Keywords (Sourced from Sabre)",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Settings.ExcludeHotelOtherExcludedKeywords",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var ItineraryPoliciesHotelSettingsExcludeNonRefundableRates={displayName:"Exclude Non-Refundable Rates (Sourced from Sabre)",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Settings.ExcludeNonRefundableRates",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN}; // this should be removed in teh future
	var ItineraryPoliciesHotelDefaultPolicyBenchmarkPreferredAgainstCheapestPreferred={displayName:"Benchmark Preferred Against Cheapest Preferred",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.DefaultPolicy.BenchmarkPreferredAgainstCheapestPreferred",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var ItineraryPoliciesHotelSettingsExcludedRates={displayName:"Hotel Excluded Rates",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Settings.ExcludedRates",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesHotelSettingsIncludedRates={displayName:"Restrict Rates by Keyword",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Settings.RestrictRatesByKeywords",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesHotelSettingsExcludedProviders={displayName:"Hotel Excluded Providers",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Settings.ExcludedProviders",displayAs:_constantsJs2['default'].DISPLAY_AS.MULTI_SELECT,optionsAt:"GDSProviders"};var ItineraryPoliciesHotelSettingsExcludedAggregators={displayName:"Hotel Excluded Aggregators",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Settings.ExcludedAggregators",displayAs:_constantsJs2['default'].DISPLAY_AS.O_DATA_SELECT,endpoint:"Settings",queryOption:"select",selectProperty:"HotelRateCategories",inputTitle:"Name",selectChoiceName:"Name",entityIdentifier:"Name",searchAllNo:true,isMultiSelect:true,additionalFilters:{"IsAggregator":true},showOnlySelectedField:true};var HotelEnableAggregators={displayName:"Hotel Excluded Providers",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Settings.ExcludedProviders",displayAs:_constantsJs2['default'].DISPLAY_AS.MULTI_SELECT,optionsAt:"GDSProviders"};var ItineraryPoliciesHotelSettingsRateCodes={displayName:"Hotel Rate Codes",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Settings.RateCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesHotelSettingsApplyVirtualCreditCard={displayName:"Apply Virtual Credit Card",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Settings.ApplyVirtualCreditCard",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"HotelApplyVirtualCreditCardTypes",defaultValue:"UseagencyVCCconfig"};var ItineraryPoliciesHotelSettingsPolicyType={displayName:"Hotel Policy Type",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Settings.PolicyType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"HotelPolicyTypes",defaultValue:"PreferredFirst"};var ItineraryPoliciesHotelSettingsPerNightRateDisplay={displayName:"Per Night Rate Display",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Settings.PerNightRateDisplay",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"HotelPerNightRateDisplayTypes",defaultValue:"Highest"};var ItineraryPoliciesHotelPolicies={displayName:"Policies",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Policies",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:ItineraryPoliciesHotelPoliciesItem,gridCols:[{name:"Policy Name",key:"PolicyName"},{name:"Location Code",key:"LocationCode"},{name:"Country Code",key:"CountryCode"}]};var ItineraryPoliciesHotelRateCategories={displayName:"Hotel Rate Categories",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.RateCategories",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:ItineraryPoliciesHotelRateCategoriesItem,gridCols:[{name:"Rate Category",key:"Category"},{name:"Priority",key:"Priority"}],sortable:true,htmlInner:"<small>All rows are shown. <br/>Sort rows by dragging and dropping to desired order for shopping results.</small>"};var ItineraryPoliciesHotelExcludedAggregatorChains={displayName:"Exclude Aggregator Rates by Chain",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.ExcludedAggregatorChains",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:ItineraryPoliciesHotelExcludedAggregatorChainsItem,gridCols:[{name:"Aggregator",key:"Aggregator"},{name:"Chains",key:"Chains"}]};var ItineraryPoliciesHotelNoHotelPolicies={displayName:"No Hotel Policy",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.NoHotelPolicies",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:ItineraryPoliciesHotelNoHotelPoliciesItem,gridCols:[{name:"Title",key:"Title"},{name:"Code",key:"Code"}]};var ItineraryPoliciesHotelSettingsEnablePerDiemRates={displayName:"Per Diem Rates Enabled",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Settings.EnablePerDiemRates",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var ItineraryPoliciesHotelSettingsShowRatesWithinPerDiem={displayName:"Show Only Rates Within Per Diem",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Settings.ShowRatesWithinPerDiem",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var ItineraryPoliciesRailExcludedSuppliers={displayName:"Rail Excluded Suppliers",dataAt:"ItineraryPolicies.$ItinPolIndex.Rail.ExcludedSuppliers",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesRailPolicyExceptions={displayName:"Policy Exceptions",dataAt:"ItineraryPolicies.$ItinPolIndex.Rail.PolicyExceptions",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:ItineraryPoliciesRailPolicyExceptionsItem,gridCols:[{name:"Title",key:"Title"},{name:"Code",key:"Code"}]};var ItineraryPoliciesRailPolicies={displayName:"Policies",dataAt:"ItineraryPolicies.$ItinPolIndex.Rail.Policies",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:ItineraryPoliciesRailPoliciesItem,gridCols:[{name:"Suppliers",key:"Suppliers"},{name:"Corporate Code",key:"CorporateCode"},{name:"Policy Type",key:"PolicyType"},{name:"Group Type",key:"GroupTypes"}]};var ItineraryPoliciesFlightPolicyExceptionSettings={displayName:"Policy Exception Settings",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionSettings",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:ItineraryPoliciesFlightPolicyExceptionSettingsItem,gridCols:[{name:"Origin",key:"OriginCountryCode"},{name:"Dest",key:"DestinationCountryCode"},{name:"Type",key:"FlightType"},{name:"LLFGroup",key:"LowestFareGroupType"},{name:"GroupTypes",key:"GroupTypes"},{name:"MostDirect",key:"BenchmarkMostDirect"},{name:"Tolerance",key:"PriceTolerance"}]};var ItineraryPoliciesFlightPolicyExceptionExcludedCarriers={displayName:"Policy Exception Excluded Carriers",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptionExcludedCarriers",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT,validationRegex:"^$|^[A-Za-z0-9]{2}(?:[\\s,]+[A-Za-z0-9]{2})*$",validationMessage:"Use 2-character carrier codes (letters or numbers), e.g., AA, F9."};var ItineraryPoliciesFlightEnableAncillaryFees={displayName:"Policy Enable Ancillary Fees",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.EnableAncillaryFees",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var ItineraryPoliciesFlightAncillaryFeeCodes={displayName:"Policy Ancillary Fee Codes",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.AncillaryFeeCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesFlightPolicyLeadTimeForInPolicyBooking={displayName:"Lead Time for In-Policy Booking",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyLeadTimeForInPolicyBooking",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT}; //validationRegex: '[0-9]',
	//validationMessage: 'Only numbers'
	var ItineraryPoliciesFlightPolicyExceptions={displayName:"Policy Exceptions",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyExceptions",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:ItineraryPoliciesFlightPolicyExceptionsItem,gridCols:[{name:"Title",key:"Title"},{name:"Code",key:"Code"}]};var ItineraryPoliciesFlightSettingsRateCodes={displayName:"Flight Rate Codes",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Settings.RateCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT,validationItemLimit:"4",validationMessage:"The number of RateCodes is not allowed. Max 4."};var ItineraryPoliciesFlightSettingsPolicyType={displayName:"Flight Policy Type",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Settings.PolicyType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"AirlinePolicyTypes"};var ItineraryPoliciesFlightFlyAmericaActPolicyType={displayName:"Fly America Act Policy Type",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.FlyAmericaPolicy.FlyAmericaPolicyType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"FlightFlyAmericaPolicyType"};var ItineraryPoliciesFlightFlyAmericaPolicyEnableExcludeNonCompliantFlights={displayName:"Fly America Act Exclude Non Compliant Flights",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.FlyAmericaPolicy.FlyAmericaActExcludeNonCompliantFlights",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var ItineraryPoliciesFlightSettingsExcludedRates={displayName:"Flight Excluded Rates",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Settings.ExcludedRates",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesFlightSettingsExcludedProviders={displayName:"Flight Excluded Providers",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Settings.ExcludedProviders",displayAs:_constantsJs2['default'].DISPLAY_AS.MULTI_SELECT,optionsAt:"GDSProviders"};var ItineraryPoliciesFlightPolicies={displayName:"Policies",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Policies",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:ItineraryPoliciesFlightPoliciesItem,gridCols:[{name:"Crr",key:"Carrier"},{name:"CtyDest",key:"DestinationLocationCode"},{name:"CtyOrig",key:"OriginLocationCode"},{name:"CtryDest",key:"DestinationCountryCode"},{name:"CtryOrig",key:"OriginCountryCode"},{name:"Policy",key:"PolicyType"},{name:"Duration",key:"DurationType"},{name:"Groups",key:"GroupTypes"},{name:"FareCls",key:"FareClasses"},{name:"Brand",key:"BrandCodes"},{name:"Weight",key:"Weight"}]};var ItineraryPoliciesFlightBenchmarksExceptions={displayName:"Benchmark Exceptions",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Exceptions",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:ItineraryPoliciesFlightBenchmarksExceptionsItem,gridCols:[{name:"Carrier",key:"Carrier"},{name:"DestinationLocationCode",key:"DestinationLocationCode"},{name:"OriginLocationCode",key:"OriginLocationCode"}]};var ItineraryPoliciesFlightLowLogicFareTimeWindowType={displayName:'Time Window',dataAt:'ItineraryPolicies.$ItinPolIndex.Flight.FlightLowestLogicalFareSettings.TimeWindowType',displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:'FlighLowLogicFareTimeWindowType',defaultValue:'CompanyTimeWindow'};var ItineraryPoliciesFlightLowLogicFareTimeWindowDefinedType={displayName:'Time Window Value',dataAt:'ItineraryPolicies.$ItinPolIndex.Flight.FlightLowestLogicalFareSettings.TimeWindow',displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ItineraryPoliciesFlightLowLogicFareContractType={displayName:'Has Contract',dataAt:'ItineraryPolicies.$ItinPolIndex.Flight.FlightLowestLogicalFareSettings.ContractType',displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:'FlighLowLogicFareContractType',defaultValue:'DoesNotMatter'};var ItineraryPoliciesFlightLowLogicFareStopType={displayName:'Number of Stops',dataAt:'ItineraryPolicies.$ItinPolIndex.Flight.FlightLowestLogicalFareSettings.StopType',displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:'FlighLowLogicFareStopType',defaultValue:'DoesNotMatter'};var ItineraryPoliciesFlightLowLogicFareRefundability={displayName:'Refundability',dataAt:'ItineraryPolicies.$ItinPolIndex.Flight.FlightLowestLogicalFareSettings.RefundType',displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:'RefundabilityOptions',defaultValue:'DoesNotMatter'};var ItineraryPoliciesLessThanXDayExceptions={displayName:"Lead Time for In-Policy Booking Exceptions",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PolicyLessThanXDays",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:ItineraryPoliciesLessThanXDayExceptionsItem,gridCols:[{name:"Title",key:"Title"},{name:"Code",key:"Code"}]};var ItineraryPoliciesFlightFlyAmericaPolicyExceptions={displayName:"Fly America Policy Exceptions",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.FlyAmericaPolicy.FlyAmericaPolicyExceptions",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:ItineraryPoliciesFlightFlyAmericaPolicyExceptionsItem,gridCols:[{name:"Title",key:"Title"},{name:"Code",key:"Code"}]};var ItineraryPoliciesFlightBenchmarksPolicies={displayName:"Benchmark Policies",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.Benchmarks.Policies",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:ItineraryPoliciesFlightBenchmarksPoliciesItem,gridCols:[{name:"Carrier",key:"Carrier"}]};var ItineraryPoliciesFlightLowLogicFare={tabName:'Flight-Lowest-Logical-Fare',dataAt:'',displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,children:[ItineraryPoliciesFlightLowLogicFareTimeWindowType,ItineraryPoliciesFlightLowLogicFareTimeWindowDefinedType,ItineraryPoliciesFlightLowLogicFareContractType,ItineraryPoliciesFlightLowLogicFareStopType,ItineraryPoliciesFlightLowLogicFareRefundability]};var ItineraryPoliciesFlightDisableFlight={displayName:"Disable Flight",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.DisableFlight",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var ItineraryPoliciesPaidSeatsEnabledType={displayName:"Enable Paid Seats",dataAt:"ItineraryPolicies.$ItinPolIndex.Flight.PaidSeatsEnabled",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,defaultValue:"DebtorConfiguration",optionsAt:"PaidSeatsEnabledType"};var ItineraryPoliciesGroundTransportationPreferredVendors={displayName:"Preferred Vendors",dataAt:"ItineraryPolicies.$ItinPolIndex.GroundTransportation.PreferredVendors",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesGroundTransportationExcludedVendors={displayName:"Excluded Vendors",dataAt:"ItineraryPolicies.$ItinPolIndex.GroundTransportation.ExcludedVendors",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesGroundTransportationDisableGroundTransportation={displayName:"Disable Ground Transportation",dataAt:"ItineraryPolicies.$ItinPolIndex.GroundTransportation.DisableGroundTransportation",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var ItineraryPoliciesGroundTransportationIgnoreProviderPreferred={displayName:"Ignore Provider Preferred",dataAt:"ItineraryPolicies.$ItinPolIndex.GroundTransportation.IgnoreProviderPreferred",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var ItineraryPoliciesItems={displayName:"Items",dataAt:"ItineraryPolicies.$ItinPolIndex.Items",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:ItineraryPoliciesItemsItem,gridCols:[{name:"Code",key:"Code"},{name:"Title",key:"Title"}]};var ItineraryPoliciesAgencyReasonCodes={displayName:"Agency Reason Codes",dataAt:"ItineraryPolicies.$ItinPolIndex.AgencyReasonCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ItineraryPoliciesMultiPaxPnrHandlingType={displayName:"Multi Passenger Pnr Handling",dataAt:"ItineraryPolicies.$ItinPolIndex.PolicyMultiPaxPnrHandling",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"PolicyDebtorMultiPaxPnrHandlingType",defaultValue:"DebtorConfiguration"};var ItineraryPoliciesGuestTravelType={displayName:"Guest Traveler",dataAt:"ItineraryPolicies.$ItinPolIndex.PolicyGuestTravelType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"DebtorPolicyGuestTravelType",defaultValue:"EnableArrangerOnly"};var DebtorApproversTravellersEmail={displayName:"Email",dataAt:"DebtorApprovers.$debtorApproversIndex.Travellers.$travellersIndex.Email",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"email"};var DebtorApproversTravellersTitle={displayName:"Title",dataAt:"DebtorApprovers.$debtorApproversIndex.Travellers.$travellersIndex.Title",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorApproversTravellersId={displayName:"Id",dataAt:"DebtorApprovers.$debtorApproversIndex.Travellers.$travellersIndex.Id",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorGdsCorporateIdentifiersItem={displayName:"Corporate Identifiers Item",dataAt:"Gds.$GdsItem.CorporateIdentifiers.$corpId",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[DebtorGdsCorporateIdentifiersItemSupplierCode,DebtorGdsCorporateIdentifiersItemCorporateCode],endpoint:"Debtors",removeParamId:"corpId",canDelete:true};var DebtorGdsMiQuestionsItem={displayName:"Mi Questions Item",dataAt:"Gds.$GdsItem.MiQuestions.$MiItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[DebtorGdsMiQuestionsItemSupplier,DebtorGdsMiQuestionsItemQuestions],endpoint:"Debtors",removeParamId:"MiItem",canDelete:true};var PaymentTypesItem={displayName:"Payment Type",dataAt:"PaymentConfigurations.$payConItem.PaymentTypes.$payConPayTypItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[PaymentConfigurationsPaymentTypesType,PaymentConfigurationsPaymentTypesIsOptionalPaymentType,PaymentConfigurationsPaymentTypesConfigurations],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"payConPayTypItem",canDelete:true};var CompanyReferencesChildrenItem={displayName:"Children",dataAt:"CompanyReferences.$compRefItem.Children.$compRefChildItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[CompanyReferencesChildrenMatch,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,label:"Match options"},{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,label:"Default: value equals parent value"},{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,label:"Regular Expression: prepending <regex> to value match value. Example: <regex>^[0-9]{1,1}"},CompanyReferencesChildrenCode,CompanyReferencesChildrenTitle,CompanyReferencesChildrenPlaceHolderText,CompanyReferencesChildrenListId,CompanyReferencesChildrenOptions,CompanyReferencesChildrenFlags,CompanyReferencesChildrenMandatory],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"compRefChildItem",canDelete:true};var ItineraryPoliciesCar={tabName:"Car",dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,children:[ItineraryPoliciesCarDisableCar,ItineraryPoliciesCarPolicies,ItineraryPoliciesCarTypeDuplicateHandling,ItineraryPoliciesCarSettingsShowRatesWithDeposits,ItineraryPoliciesCarSettingsRateCodes,ItineraryPoliciesCarSettingsExcludedProviders,ItineraryPoliciesCarSettingsExcludedRates,ItineraryPoliciesCarPolicyExceptions,ItineraryPoliciesCarPolicyExceptionSettings,ItineraryPoliciesCarPolicyPreferred,ItineraryPoliciesCarPolicyRestriction]};var ItineraryPoliciesHotel={tabName:"Hotel",dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,children:[ItineraryPoliciesHotelDisableHotel,ItineraryPoliciesHotelPolicies,ItineraryPoliciesHotelSettingsApplyVirtualCreditCard,ItineraryPoliciesHotelSettingsPolicyType,ItineraryPoliciesHotelSettingsPerNightRateDisplay,ItineraryPoliciesHotelSettingsRateCodes,ItineraryPoliciesHotelNoHotelPolicies,ItineraryPoliciesHotelNoHotelPoliciesInfo,ItineraryPoliciesHotelRateCategories,ItineraryPoliciesHotelSettingsEnablePerDiemRates,ItineraryPoliciesHotelSettingsShowRatesWithinPerDiem,ItineraryPoliciesHotelSettingsExcludedProviders,ItineraryPoliciesHotelSettingsExcludedAggregators,ItineraryPoliciesHotelExcludedAggregatorChains,ItineraryPoliciesHotelSettingsIncludedRates,ItineraryPoliciesHotelSettingsExcludedRates,ItineraryPoliciesHotelSettingsExcludeDepositRequiredAndPrepayRates,ItineraryPoliciesHotelSettingsExcludeNonRefundableRates,ItineraryPoliciesHotelSettingsExcludeHotelOtherExcludedKeywords,ItineraryPoliciesHotelDefaultPolicyRateMax,ItineraryPoliciesHotelPoliciesLatLngMap]};var ItineraryPoliciesHotelPolicyExceptionSettingsItem={displayName:"Policy Exception Settings",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings.$ItinPolExcSetItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[ItineraryPoliciesHotelPolicyExceptionSettingsName,ItineraryPoliciesHotelPolicyExceptionSettingsLocationCode,ItineraryPoliciesHotelPolicyExceptionSettingsAirportCodes,ItineraryPoliciesHotelPolicyExceptionSettingsHotelIDs,ItineraryPoliciesHotelPolicyExceptionSettingsCountryCode,ItineraryPoliciesHotelPolicyExceptionSettingsMaximumDailyRate,ItineraryPoliciesHotelPolicyExceptionSettingsPriceTolerance,ItineraryPoliciesHotelPolicyExceptionSettingsPriceToleranceType,ItineraryPoliciesHotelPolicyExceptionSettingsRadius,ItineraryPoliciesHotelPolicyExceptionSettingsLatitude,ItineraryPoliciesHotelPolicyExceptionSettingsLongitude,ItineraryPoliciesHotelPolicyExceptionSettingsLatLong],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"ItinPolExcSetItem",canDelete:true};var ItineraryPoliciesHotelPolicyExceptionsItem={displayName:"Item",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptions.$hotelPolExcItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[ItineraryPoliciesHotelPolicyExceptionsTitle,ItineraryPoliciesHotelPolicyExceptionsCode,ItineraryPoliciesHotelPolicyExceptionsCountries],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"hotelPolExcItem",canDelete:true};var ItineraryPoliciesHotelPolicyExceptions={displayName:"Policy Exceptions",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptions",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:ItineraryPoliciesHotelPolicyExceptionsItem,gridCols:[{name:"Title",key:"Title"},{name:"Code",key:"Code"}]};var ItineraryPoliciesHotelPolicyExceptionSettings={displayName:"Policy Exception Settings",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.PolicyExceptionSettings",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:ItineraryPoliciesHotelPolicyExceptionSettingsItem,gridCols:[{name:"Name",key:"Name"},{name:"Location Code",key:"LocationCode"},{name:"Airport Codes",key:"AirportCodes"},{name:"Country Code",key:"CountryCode"},{name:"Maximum Daily Rate",key:"MaximumDailyRate"}]};var ItineraryPoliciesHotelBenchmarkingPreferredBenchmarkAgainst={displayName:"Benchmark Against",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Benchmarking.Preferred.BenchmarkAgainst",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"ItineraryPoliciesHotelBenchmarkingBenchmarkAgainst"};var ItineraryPoliciesHotelBenchmarkingPreferredStarRatingMinimum={displayName:"Star Rating Minimum",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Benchmarking.Preferred.StarRatingMinimum",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"ItineraryPoliciesHotelBenchmarkingStarRating"};var ItineraryPoliciesHotelBenchmarkingPreferredExcludeRateCategoriesForBenchmark={displayName:"Exclude Rate Categories For Benchmark",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Benchmarking.Preferred.ExcludeRateCategoriesForBenchmark",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT,html:"<p class='help-block'>Type the <strong>Rate Categories</strong> from <a href='/#/settings/hotel' target='_blank'>System Settings - Hotel</a></p>"};var ItineraryPoliciesHotelBenchmarkingNonPreferredBenchmarkAgainst={displayName:"Benchmark Against",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Benchmarking.NonPreferred.BenchmarkAgainst",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"ItineraryPoliciesHotelBenchmarkingBenchmarkAgainst"};var ItineraryPoliciesHotelBenchmarkingNonPreferredStarRatingMinimum={displayName:"Star Rating Minimum",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Benchmarking.NonPreferred.StarRatingMinimum",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"ItineraryPoliciesHotelBenchmarkingStarRating"};var ItineraryPoliciesHotelBenchmarkingNonPreferredExcludeRateCategoriesForBenchmark={displayName:"Exclude Rate Categories For Benchmark",dataAt:"ItineraryPolicies.$ItinPolIndex.Hotel.Benchmarking.NonPreferred.ExcludeRateCategoriesForBenchmark",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT,html:"<p class='help-block'>Type the <strong>Rate Categories</strong> from <a href='/#/settings/hotel' target='_blank'>System Settings - Hotel</a></p>"};var ItineraryPoliciesHotelBenchmarking={tabName:'Hotel-Lost-Savings',dataAt:'',displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,children:[ItineraryPoliciesHotelDefaultPolicyBenchmarkPreferredAgainstCheapestPreferred,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,html:"<br/><h4>Benchmarking Preferred</h4>"},ItineraryPoliciesHotelBenchmarkingPreferredBenchmarkAgainst,ItineraryPoliciesHotelBenchmarkingPreferredStarRatingMinimum,ItineraryPoliciesHotelBenchmarkingPreferredExcludeRateCategoriesForBenchmark,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,html:"<br/><h4>Benchmarking Non-Preferred</h4>"},ItineraryPoliciesHotelBenchmarkingNonPreferredBenchmarkAgainst,ItineraryPoliciesHotelBenchmarkingNonPreferredStarRatingMinimum,ItineraryPoliciesHotelBenchmarkingNonPreferredExcludeRateCategoriesForBenchmark,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,html:"<br/><br/>"},ItineraryPoliciesHotelPolicyExceptions,ItineraryPoliciesHotelPolicyExceptionSettings]};var ItineraryPoliciesRail={tabName:"Rail",dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,children:[ItineraryPoliciesRailDisableRail,ItineraryPoliciesRailPolicies,ItineraryPoliciesRailPolicyExceptions,ItineraryPoliciesRailExcludedSuppliers]};var ItineraryPoliciesFlight={tabName:"Flight",dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,children:[ItineraryPoliciesPaidSeatsEnabledType,ItineraryPoliciesFlightDisableFlight,ItineraryPoliciesFlightBenchmarksPolicies,ItineraryPoliciesFlightBenchmarksExceptions,ItineraryPoliciesFlightPolicies,ItineraryPoliciesFlightSettingsExcludedProviders,ItineraryPoliciesFlightSettingsExcludedRates,ItineraryPoliciesFlightSettingsPolicyType,ItineraryPoliciesFlightSettingsRateCodes,ItineraryPoliciesFlightEnableAncillaryFees,ItineraryPoliciesFlightAncillaryFeeCodes,ItineraryPoliciesFlightPolicyExceptions,ItineraryPoliciesFlightPolicyExceptionExcludedCarriers,ItineraryPoliciesFlightPolicyExceptionSettings,ItineraryPoliciesFlightPolicyLeadTimeForInPolicyBooking,ItineraryPoliciesLessThanXDayExceptions,ItineraryPoliciesFlightFlyAmericaActPolicyType,ItineraryPoliciesFlightFlyAmericaPolicyEnableExcludeNonCompliantFlights,ItineraryPoliciesFlightFlyAmericaPolicyExceptions,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,label:"Leave Fly America Policy Exceptions empty to use system default exceptions."}]};var ItineraryPoliciesGroundTransportation={tabName:"Ground",dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,children:[ItineraryPoliciesGroundTransportationDisableGroundTransportation,ItineraryPoliciesGroundTransportationIgnoreProviderPreferred,ItineraryPoliciesGroundTransportationPreferredVendors,ItineraryPoliciesGroundTransportationExcludedVendors]};var ItineraryPoliciesGeneral={tabName:"General",dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,children:[ItineraryPoliciesItems,ItineraryPoliciesAgencyReasonCodes,ItineraryPoliciesMultiPaxPnrHandlingType,ItineraryPoliciesGuestTravelType,_componentsDebtorsProfileAttribute.ItineraryPoliciesProfileAttributesItems]};var DebtorApproversTravellersItem={displayName:"Debtor Approver",dataAt:"DebtorApprovers.$debtorApproversIndex.Travellers.$travellersIndex",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[DebtorApproversTravellersId,DebtorApproversTravellersTitle,DebtorApproversTravellersEmail],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"travellersIndex",canDelete:true};var DebtorGdsCorporateIdentifiers={displayName:"Corporate Identifiers",dataAt:"Gds.$GdsItem.CorporateIdentifiers",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:DebtorGdsCorporateIdentifiersItem,gridCols:[{name:"Supplier Code",key:"SupplierCode"},{name:"Corporate Code",key:"CorporateCode"}]};var DebtorGdsMiQuestions={displayName:"Mi Questions",dataAt:"Gds.$GdsItem.MiQuestions",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:DebtorGdsMiQuestionsItem,gridCols:[{name:"Supplier",key:"Supplier"}]};var DebtorGdsSettings={displayName:"Settings",dataAt:"Gds.$GdsItem.Settings",displayAs:_constantsJs2['default'].DISPLAY_AS.KEY_VALUE_PAIRS,keyOptions:"GDSSettingsOptions"};var DebtorGdsEnabled={displayName:"Enabled",dataAt:"Gds.$GdsItem.Enabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var DebtorGdsName={displayName:"Name",dataAt:"Gds.$GdsItem.Name",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var HotelConfigurationPaymentNarrativesIsDomesticOnly={displayName:"Is Domestic Only",dataAt:"HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem.IsDomesticOnly",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var HotelConfigurationPaymentNarrativesAggregators={displayName:"Hotel Aggregators",dataAt:"HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem.Aggregators",displayAs:_constantsJs2['default'].DISPLAY_AS.O_DATA_SELECT,endpoint:"Settings",queryOption:"select",selectProperty:"HotelRateCategories",inputTitle:"Name",selectChoiceName:"Name",entityIdentifier:"Name",searchAllNo:true,isMultiSelect:true,additionalFilters:{"IsAggregator":true},additionalOptions:[{Name:"Sabre",IsAggregator:true}],showOnlySelectedField:true};var HotelConfigurationPaymentNarrativesProviders={displayName:"Hotel Providers",dataAt:"HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem.Providers",displayAs:_constantsJs2['default'].DISPLAY_AS.MULTI_SELECT,optionsAt:"GDSProviders"};var HotelConfigurationPaymentNarrativesServiceFeeCode={displayName:"Service Fee Code (max 100 characters)",dataAt:"HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem.ServiceFeeCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,maxLength:100};var HotelConfigurationPaymentNarrativesPaymentInstructions={displayName:"Hotel Payment Instructions",dataAt:"HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem.PaymentInstructions",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var HotelConfigurationPaymentNarrativesPaymentNarrative={displayName:"Hotel Payment Narrative (max 50 characters)",dataAt:"HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem.PaymentNarrative",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,maxLength:50};var HotelConfigurationPaymentNarrativesPaymentCode={displayName:"Hotel Payment Code (max 20 characters)",dataAt:"HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem.PaymentCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,maxLength:20};var HotelConfigurationRadiusCitiesRadius={displayName:"Radius",dataAt:"HotelConfiguration.Radius.Cities.$hotConRadCitiesItem.Radius",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"RadiusOptions",optionsNumbers:true,required:true};var HotelConfigurationRadiusCitiesCityCode={displayName:"CityCode",dataAt:"HotelConfiguration.Radius.Cities.$hotConRadCitiesItem.CityCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var HotelConfigurationHotelAmenityFiltersDisplayName={displayName:"Display Name",dataAt:"HotelConfiguration.HotelAmenityFilters.$hotConHotelAmenityFiltersItem.DisplayName",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var HotelConfigurationHotelAmenityFiltersMostPopular={displayName:"Show in Most Popular Category",dataAt:"HotelConfiguration.HotelAmenityFilters.$hotConHotelAmenityFiltersItem.MostPopular",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var HotelConfigurationHotelAmenityFiltersAmenities={displayName:"Amenities",dataAt:"HotelConfiguration.HotelAmenityFilters.$hotConHotelAmenityFiltersItem.Amenities",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var RailSupplierSettingsSettings={displayName:"Settings",dataAt:"RailConfiguration.RailSupplierSettings.$railSuppSettingItem.Settings",displayAs:_constantsJs2['default'].DISPLAY_AS.KEY_VALUE_PAIRS};var RailSupplierSettingsCode={displayName:"Code",dataAt:"RailConfiguration.RailSupplierSettings.$railSuppSettingItem.Code",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var RailSupplierSettingsName={displayName:"Name",dataAt:"RailConfiguration.RailSupplierSettings.$railSuppSettingItem.Name",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var FlightSearchWindowsDestinations={displayName:"Destinations",dataAt:"FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem.Destinations",displayAs:_constantsJs2['default'].DISPLAY_AS.COUNTRY_SELECT};var FlightSearchWindowsOrigins={displayName:"Origins",dataAt:"FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem.Origins",displayAs:_constantsJs2['default'].DISPLAY_AS.COUNTRY_SELECT};var FlightSearchWindowsFlightPolicyDepartureWindowTo={displayName:"Policy Departure Window To",dataAt:"FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem.FlightPolicyDepartureWindowTo",displayAs:_constantsJs2['default'].DISPLAY_AS.RANGE,min:15,max:720,step:15,defaultValue:3,divideResultBy:60,units:"minutes"};var FlightSearchWindowsFlightPolicyDepartureWindowFrom={displayName:"Policy Departure Window From",dataAt:"FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem.FlightPolicyDepartureWindowFrom",displayAs:_constantsJs2['default'].DISPLAY_AS.RANGE,min:15,max:720,step:15,defaultValue:3,divideResultBy:60,units:"minutes"};var FlightSearchWindowsFlightSearchWindowTo={displayName:"Search Window To",dataAt:"FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem.FlightSearchWindowTo",displayAs:_constantsJs2['default'].DISPLAY_AS.RANGE,min:15,max:720,step:15,defaultValue:3,divideResultBy:60,units:"minutes"};var FlightSearchWindowsFlightSearchWindowFrom={displayName:"Search Window From",dataAt:"FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem.FlightSearchWindowFrom",displayAs:_constantsJs2['default'].DISPLAY_AS.RANGE,min:15,max:720,step:15,defaultValue:3,divideResultBy:60,units:"minutes"};var FlightSearchWindowsIsAllDaySearch={displayName:"Is All Day Search",dataAt:"FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem.IsAllDaySearch",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var CombinableFareRulesDestination={displayName:"Destination",dataAt:"FlightConfiguration.CombinableFareRules.$combFareRulesItem.Destination",displayAs:_constantsJs2['default'].DISPLAY_AS.COUNTRY_SELECT,selectType:"single"};var CombinableFareRulesOrigin={displayName:"Origin",dataAt:"FlightConfiguration.CombinableFareRules.$combFareRulesItem.Origin",displayAs:_constantsJs2['default'].DISPLAY_AS.COUNTRY_SELECT,selectType:"single"};var OneWayFareRulesDestination={displayName:"Destination",dataAt:"FlightConfiguration.OneWayFareRules.$oneWayFarRuItem.Destination",displayAs:_constantsJs2['default'].DISPLAY_AS.COUNTRY_SELECT,selectType:"single"};var OneWayFareRulesOrigin={displayName:"Origin",dataAt:"FlightConfiguration.OneWayFareRules.$oneWayFarRuItem.Origin",displayAs:_constantsJs2['default'].DISPLAY_AS.COUNTRY_SELECT,selectType:"single"};var PaymentConfigurationsPaymentTypes={displayName:"Payment Types",dataAt:"PaymentConfigurations.$payConItem.PaymentTypes",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:PaymentTypesItem,gridCols:[{name:"Type",key:"Type"}]};var PaymentConfigurationsProvider={displayName:"Provider",dataAt:"PaymentConfigurations.$payConItem.Provider",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"GDSProviders"};var DebtorAgencyReasonCodesTitle={displayName:"Title",dataAt:"DebtorAgencyReasonCodes.$debAgReCoItem.Title",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorAgencyReasonCodesCode={displayName:"Code",dataAt:"DebtorAgencyReasonCodes.$debAgReCoItem.Code",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var AgencyCreditCardsItemModifiedOn={displayName:"Modified On",dataAt:"DebtorAgencyCreditCards.$debtAgCCItem.ModifiedOn",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,disabled:true};var AgencyCreditCardsItemModifiedBy={displayName:"Modified By",dataAt:"DebtorAgencyCreditCards.$debtAgCCItem.ModifiedBy",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,disabled:true};var AgencyCreditCardsItemCreatedOn={displayName:"Created On",dataAt:"DebtorAgencyCreditCards.$debtAgCCItem.CreatedOn",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,disabled:true};var AgencyCreditCardsItemCreatedBy={displayName:"Created By",dataAt:"DebtorAgencyCreditCards.$debtAgCCItem.CreatedBy",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,disabled:true};var SegmentTypes={displayName:"Segment Types",dataAt:"DebtorAgencyCreditCards.$debtAgCCItem.SegmentTypes",displayAs:_constantsJs2['default'].DISPLAY_AS.MULTI_SELECT,optionsAt:"SegmentTypes"};var CreditCardId={displayName:"Credit Card Id",dataAt:"DebtorAgencyCreditCards.$debtAgCCItem.CreditCardId",displayAs:_constantsJs2['default'].DISPLAY_AS.O_DATA_SELECT,endpoint:"CreditCards",searchAllNo:true};var AgencyCreditCardsItemId={displayName:"Id",dataAt:"DebtorAgencyCreditCards.$debtAgCCItem.Id",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,disabled:true};var AgencyCreditCardsItemTitle={displayName:"Title",dataAt:"DebtorAgencyCreditCards.$debtAgCCItem.Title",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var CompanyReferencesChildren={displayName:"Children",dataAt:"CompanyReferences.$compRefItem.Children",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:CompanyReferencesChildrenItem,gridCols:[{name:"Match",key:"Match"},{name:"Code",key:"Code"},{name:"Title",key:"Title"},{name:"Mandatory",key:"Mandatory"},{name:"ListId",key:"ListId"}]};var CompanyReferencesMandatory={displayName:"Mandatory",dataAt:"CompanyReferences.$compRefItem.Mandatory",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var CompanyReferencesFlags={displayName:"Flags",dataAt:"CompanyReferences.$compRefItem.Flags",displayAs:_constantsJs2['default'].DISPLAY_AS.MULTI_SELECT,optionsAt:"CompanyReferencesFlags"};var CompanyReferencesOptions={displayName:"Options",dataAt:"CompanyReferences.$compRefItem.Options",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT,helpText:"Use a pipe | to delineate a value and display. \r\nExample: Y|Yes \r\nThis will display Yes to the booker and capture Y as the value."};var CompanyReferencesTitle={displayName:"Title",dataAt:"CompanyReferences.$compRefItem.Title",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,required:true,validationMessage:"Title is required. Max length 100",validationRegex:"^.{1,100}$"};var CompanyReferencesPlaceHolderText={displayName:"PlaceHolder Text",dataAt:"CompanyReferences.$compRefItem.PlaceHolderText",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var CompanyReferencesCode={displayName:"Code",dataAt:"CompanyReferences.$compRefItem.Code",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,required:true,validationMessage:"Code is required. Max length 50",validationRegex:"^.{1,50}$"};var CompanyReferencesListId={displayName:"ListId",dataAt:"CompanyReferences.$compRefItem.ListId",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var CompanyReferencesPlacementType={displayName:'Placement',dataAt:'CompanyReferences.$compRefItem.PlacementType',displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:'PlacementType'};var ItineraryPoliciesTabs={dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.TABS,children:[ItineraryPoliciesGeneral,ItineraryPoliciesFlight,ItineraryPoliciesFlightLowLogicFare,ItineraryPoliciesRail,ItineraryPoliciesHotel,ItineraryPoliciesHotelBenchmarking,ItineraryPoliciesCar,ItineraryPoliciesGroundTransportation]};var ItineraryPoliciesBreakPolicyEscalationApprovalLevel={displayName:"Break Policy Escalation Approval Level",dataAt:"ItineraryPolicies.$ItinPolIndex.BreakPolicyEscalationApprovalLevel",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"approvalLevels"};var ItineraryPoliciesApprovalLevel={displayName:"Approval Level",dataAt:"ItineraryPolicies.$ItinPolIndex.ApprovalLevel",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"approvalLevels"};var ItineraryPoliciesCountries={displayName:"Countries",dataAt:"ItineraryPolicies.$ItinPolIndex.Countries",displayAs:_constantsJs2['default'].DISPLAY_AS.COUNTRY_SELECT};var ItineraryPoliciesTitle={displayName:"Title",dataAt:"ItineraryPolicies.$ItinPolIndex.Title",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,maxLength:30};var ItineraryPoliciesCode={displayName:"Code",dataAt:"ItineraryPolicies.$ItinPolIndex.Code",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,maxLength:30};var TermsAndConditionsSectionType={displayName:"Section Type",dataAt:"TermsAndConditions.$debtorTermsItem.SectionType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"SectionType"};var TermsAndConditionsText={displayName:"Text",dataAt:"TermsAndConditions.$debtorTermsItem.Text",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_AREA};var TermsAndConditionsSegmentTypes={displayName:"Segment Types",dataAt:"TermsAndConditions.$debtorTermsItem.SegmentTypes",displayAs:_constantsJs2['default'].DISPLAY_AS.MULTI_SELECT,optionsAt:"SegmentTypes"};var TermsAndConditionsCountries={displayName:"Countries",dataAt:"TermsAndConditions.$debtorTermsItem.Countries",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var DebtorOrderNumberCodesTitle={displayName:"Title",dataAt:"DebtorOrderNumberCodes.$debtorOrderNumberCodesIndex.Title",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,required:true};var DebtorOrderNumberCodesCode={displayName:"Code",dataAt:"DebtorOrderNumberCodes.$debtorOrderNumberCodesIndex.Code",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,required:true};var DebtorGdsItem={displayName:"Gds Item",dataAt:"Gds.$GdsItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[DebtorGdsName,DebtorGdsEnabled,DebtorGdsSettings,DebtorGdsMiQuestions,DebtorGdsCorporateIdentifiers,GdsPassiveFlightSegmentRemarks],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"GdsItem",canDelete:true};var HotelConfigurationPaymentNarrativesItem={displayName:"Hotel Payment Narrative",dataAt:"HotelConfiguration.PaymentNarratives.$hotConPaymentNarrativesItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[HotelConfigurationPaymentNarrativesPaymentCode,HotelConfigurationPaymentNarrativesPaymentNarrative,HotelConfigurationPaymentNarrativesPaymentInstructions,HotelConfigurationPaymentNarrativesServiceFeeCode,HotelConfigurationPaymentNarrativesProviders,HotelConfigurationPaymentNarrativesAggregators,HotelConfigurationPaymentNarrativesIsDomesticOnly],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"hotConPaymentNarrativesItem",canDelete:true};var HotelConfigurationRadiusCitiesItem={displayName:"City Radius",dataAt:"HotelConfiguration.Radius.Cities.$hotConRadCitiesItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[HotelConfigurationRadiusCitiesCityCode,HotelConfigurationRadiusCitiesRadius],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"hotConRadCitiesItem",canDelete:true};var HotelConfigurationHotelAmenityFiltersItem={displayName:"Hotel Amenity Filters",dataAt:"HotelConfiguration.HotelAmenityFilters.$hotConHotelAmenityFiltersItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[HotelConfigurationHotelAmenityFiltersDisplayName,HotelConfigurationHotelAmenityFiltersMostPopular,HotelConfigurationHotelAmenityFiltersAmenities],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"hotConHotelAmenityFiltersItem",canDelete:true};var RailSupplierSettingsItem={displayName:"Item",dataAt:"RailConfiguration.RailSupplierSettings.$railSuppSettingItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[RailSupplierSettingsName,RailSupplierSettingsCode,RailSupplierSettingsSettings],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"$railSuppSettingItem",canDelete:true};var FlightSearchWindowItem={displayName:"Flight Search Window",dataAt:"FlightConfiguration.FlightWindowSettings.$flightSearchWindowItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[FlightSearchWindowsIsAllDaySearch,FlightSearchWindowsFlightSearchWindowFrom,FlightSearchWindowsFlightSearchWindowTo,FlightSearchWindowsFlightPolicyDepartureWindowFrom,FlightSearchWindowsFlightPolicyDepartureWindowTo,FlightSearchWindowsOrigins,FlightSearchWindowsDestinations],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"$flightSearchWindowItem",canDelete:true};var CombinableFareRulesItem={displayName:"Combinable Fare Rule",dataAt:"FlightConfiguration.CombinableFareRules.$combFareRulesItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[CombinableFareRulesOrigin,CombinableFareRulesDestination],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"combFareRulesItem",canDelete:true};var OneWayFareRulesItem={displayName:"One Way Fare Rule",dataAt:"FlightConfiguration.OneWayFareRules.$oneWayFarRuItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[OneWayFareRulesOrigin,OneWayFareRulesDestination],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"oneWayFarRuItem",canDelete:true};var PaymentConfigurationsItem={displayName:"Payment Configuration",dataAt:"PaymentConfigurations.$payConItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[PaymentConfigurationsProvider,PaymentConfigurationsPaymentTypes],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"payConItem",canDelete:true};var DebtorAgencyReasonCodesItem={displayName:"Agency Reason Codes Item",dataAt:"DebtorAgencyReasonCodes.$debAgReCoItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[DebtorAgencyReasonCodesCode,DebtorAgencyReasonCodesTitle],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"debAgReCoItem",canDelete:true};var AgencyCreditCardsItem={displayName:"Agency Credit Card",dataAt:"DebtorAgencyCreditCards.$debtAgCCItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[AgencyCreditCardsItemTitle,AgencyCreditCardsItemId,CreditCardId,SegmentTypes,AgencyCreditCardsItemCreatedBy,AgencyCreditCardsItemCreatedOn,AgencyCreditCardsItemModifiedBy,AgencyCreditCardsItemModifiedOn],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"debtAgCCItem",canDelete:true};var CompanyReferencesItemsItemTitle={displayName:"Title",dataAt:"CompanyReferences.$compRefItem.Items.$compRefItemItemIndex.Title",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var CompanyReferencesItemsItemCode={displayName:"Code",dataAt:"CompanyReferences.$compRefItem.Items.$compRefItemItemIndex.Code",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var CompanyReferencesItemsItem={displayName:"Item",dataAt:"CompanyReferences.$compRefItem.Items.$compRefItemItemIndex",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[CompanyReferencesItemsItemCode,CompanyReferencesItemsItemTitle],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"compRefItemItemIndex",canDelete:true};var CompanyReferencesItems={displayName:"Employee Codes",dataAt:"CompanyReferences.$compRefItem.Items",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:CompanyReferencesItemsItem,gridCols:[{name:"Code",key:"Code"},{name:"Title",key:"Title"},{name:"ListId",key:"ListId"}]};var CompanyReferencesGridItem={displayName:"Company References",dataAt:"CompanyReferences.$compRefItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[CompanyReferencesCode,CompanyReferencesTitle,CompanyReferencesPlaceHolderText,CompanyReferencesPlacementType,CompanyReferencesListId,CompanyReferencesOptions,CompanyReferencesFlags,CompanyReferencesMandatory,CompanyReferencesChildren,CompanyReferencesItems],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"compRefItem",canDelete:true};var ItineraryPoliciesItem={displayName:"Itinerary Policy",dataAt:"ItineraryPolicies",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[ItineraryPoliciesCode,ItineraryPoliciesTitle,ItineraryPoliciesCountries,ItineraryPoliciesApprovalLevel,ItineraryPoliciesBreakPolicyEscalationApprovalLevel,ItineraryPoliciesTabs],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"ItinPolIndex",canDelete:true};var TermsAndConditionsItem={displayName:"Item",dataAt:"TermsAndConditions",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[TermsAndConditionsSectionType,TermsAndConditionsCountries,TermsAndConditionsSegmentTypes,TermsAndConditionsText],endpoint:"Debtors",removeParamId:"debtorTermsItem",canDelete:true};var DebtorOrderNumberCodesItem={displayName:"Debtor Order Number Codes",dataAt:"DebtorOrderNumberCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[DebtorOrderNumberCodesCode,DebtorOrderNumberCodesTitle],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"debtorOrderNumberCodesIndex",canDelete:true};var ModifiedOn={displayName:"Modified on",dataAt:"ModifiedOn",disabled:true,displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ModifiedBy={displayName:"Modified by",dataAt:"ModifiedBy",disabled:true,displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var CreatedOn={displayName:"Created on",dataAt:"CreatedOn",disabled:true,displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var CreatedBy={displayName:"Created by",dataAt:"CreatedBy",disabled:true,displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var TramadaConfigurationDatabase={displayName:"Tramada Configuration Database",dataAt:"TramadaConfiguration.Database",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var TramadaConfigurationDebtorAuthCode={displayName:"Tramada Configuration Debtor Auth Code",dataAt:"TramadaConfiguration.DebtorAuthCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var TramadaConfigurationDebtorId={displayName:"Tramada Configuration Debtor Id",dataAt:"TramadaConfiguration.DebtorId",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var TramadaConfigurationAgencyId={displayName:"Tramada Configuration Agency Id",dataAt:"TramadaConfiguration.AgencyId",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var PccCity={displayName:"Pcc City",dataAt:"SabreConfiguration.PccCity",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var Pcc={displayName:"Pcc",dataAt:"SabreConfiguration.Pcc",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var TeamRejectionQueue={label:"Queue",dataAt:"SabreConfiguration.TeamRejectionQueue",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number",formClass:"width100"};var ModificationQueue={label:"Queue",dataAt:"SabreConfiguration.ModificationQueue",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number",formClass:"width100"};var UserHoldQueue={label:"Queue",dataAt:"SabreConfiguration.UserHoldQueue",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number",formClass:"width100"};var AutoTicketingQueue={label:"Queue",dataAt:"SabreConfiguration.AutoTicketingQueue",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number",formClass:"width100"};var AuthorisationHoldQueue={label:"Queue",dataAt:"SabreConfiguration.AuthorisationHoldQueue",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number",formClass:"width100"};var CancelQueue={label:"Queue",dataAt:"SabreConfiguration.CancelQueue",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number",formClass:"width100"}; //QueuePCC
	var TeamRejectionQueuePcc={label:"Pcc",dataAt:"SabreConfiguration.TeamRejectionQueuePcc",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,formClass:"width100",maxLength:4};var ModificationQueuePcc={label:"Pcc",dataAt:"SabreConfiguration.ModificationQueuePcc",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,formClass:"width100",maxLength:4};var UserHoldQueuePcc={label:"Pcc",dataAt:"SabreConfiguration.UserHoldQueuePcc",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,formClass:"width100",maxLength:4};var AutoTicketingQueuePcc={label:"Pcc",dataAt:"SabreConfiguration.AutoTicketingQueuePcc",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,formClass:"width100",maxLength:4};var AuthorisationHoldQueuePcc={label:"Pcc",dataAt:"SabreConfiguration.AuthorisationHoldQueuePcc",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,formClass:"width100",maxLength:4};var CancelQueuePcc={dataAt:"SabreConfiguration.CancelQueuePcc",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,formClass:"width100",maxLength:4,label:"Pcc"};var DebtorGds={displayName:"Gds",dataAt:"Gds",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:DebtorGdsItem,gridCols:[{name:"Name",key:"Name"},{name:"Enabled",key:"Enabled"}]};var DebtorLimitCountries={displayName:"Limit Countries",dataAt:"LimitCountries",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT,helpText:"Named lists are supported. Wrap name in ~ characters. Example: ~AllowedCountries~"};var DebtorLimitAirportClassification={displayName:"Limit Airport Classification",dataAt:"LimitAirportClassification",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"AirportClassificationOptions"};var HotelConfigurationTags={displayName:"Hotel Tagging",dataAt:"HotelConfiguration.Tags",displayAs:_constantsJs2['default'].DISPLAY_AS.HOTEL_TAG_SELECT};var HotelConfigurationAggregators={displayName:"Enable Aggregators",dataAt:"HotelConfiguration.Aggregators",displayAs:_constantsJs2['default'].DISPLAY_AS.O_DATA_SELECT,endpoint:"Settings",queryOption:"select",selectProperty:"HotelRateCategories",inputTitle:"Name",selectChoiceName:"Name",entityIdentifier:"Name",searchAllNo:true,isMultiSelect:true,additionalFilters:{"IsAggregator":true},showOnlySelectedField:true};var HotelConfigurationPaymentNarratives={displayName:"Hotel Payment Narratives",dataAt:"HotelConfiguration.PaymentNarratives",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:HotelConfigurationPaymentNarrativesItem,gridCols:[{name:"Payment Narrative",key:"PaymentNarrative"},{name:"Providers",key:"Providers"},{name:"Aggregators",key:"Aggregators"},{name:"Is Domestic Only",key:"IsDomesticOnly"}]};var HotelConfigurationRadiusCities={displayName:"Cities",dataAt:"HotelConfiguration.Radius.Cities",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:HotelConfigurationRadiusCitiesItem,gridCols:[{name:"CityCode",key:"CityCode"},{name:"Radius",key:"Radius"}]};var HotelConfigurationRadiusDefaultRadius={displayName:"Default Radius (defaults to kilometers unless imperial system is checked)",dataAt:"HotelConfiguration.Radius.DefaultRadius",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"HotelConfigurationRadius",optionsNumbers:true,required:false};var HotelConfigurationIsImperialSystem={displayName:"Imperial System",dataAt:"IsImperialSystem",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var HotelConfigurationEnableOvernightHotelPrompt={displayName:"Enable Overnight Hotel Prompt",dataAt:"HotelConfiguration.EnableOvernightHotelPrompt",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var HotelConfigurationHotelAmenityFiltersGrid={displayName:"Hotel Amenity Filters",dataAt:"HotelConfiguration.HotelAmenityFilters",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:HotelConfigurationHotelAmenityFiltersItem,gridCols:[{name:"Display Name",key:"DisplayName"},{name:"Amenities",key:"Amenities"},{name:"Most Popular",key:"MostPopular"}]};var EnableGroundTransportationConfiguration={displayName:"Enable",dataAt:"GroundTransportationConfiguration.Enable",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var GroundTransportationConfigurationUiTitle={displayName:"Ground Transportation UI Title",dataAt:"GroundTransportationConfiguration.GroundTransportationUiTitle",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var GroundTransportationConfigurationVehicleTypes={displayName:"Vehicle Types",dataAt:"GroundTransportationConfiguration.VehicleTypes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var GroundTransportationCompanyReferenceMappingFieldId={displayName:"Field Id",dataAt:"GroundTransportationConfiguration.CompanyReferenceMappings.$companyReferenceItem.GroundFieldId",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var GroundTransportationCompanyReferenceMappingCode={displayName:"Code",dataAt:"GroundTransportationConfiguration.CompanyReferenceMappings.$companyReferenceItem.CompanyReferenceCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var GroundTransportationCompanyReferenceMappingItem={displayName:"Item",dataAt:"GroundTransportationConfiguration.CompanyReferenceMappings.$companyReferenceItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[GroundTransportationCompanyReferenceMappingCode,GroundTransportationCompanyReferenceMappingFieldId],endpoint:"Debtors",routeParamId:"debtorId",canDelete:true};var GroundTransportationCompanyReferenceMapping={displayName:"Company Reference Mappings",dataAt:"GroundTransportationConfiguration.CompanyReferenceMappings",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:GroundTransportationCompanyReferenceMappingItem,gridCols:[{name:"Code",key:"CompanyReferenceCode"},{name:"Field Id",key:"GroundFieldId"}]};var RailSupplierSettings={displayName:"Rail Supplier Settings",dataAt:"RailConfiguration.RailSupplierSettings",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:RailSupplierSettingsItem,gridCols:[{name:"Name",key:"Name"},{name:"Code",key:"Code"}]};var UnusedTicketSettings={displayName:"Enabled Unused Ticket Providers",dataAt:"FlightConfiguration.UnusedTicketConfiguration.EnabledUnusedTicketProviders",displayAs:_constantsJs2['default'].DISPLAY_AS.MULTI_SELECT,optionsAt:"UnusedTicketProviderTypes"};var EnableUnusedTicketDebtorSettings={displayName:"Use Unused Ticket Debtor Configuration",dataAt:"FlightConfiguration.UnusedTicketConfiguration.IsUsingDebtorSettings",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var BookingThreshold={displayName:"Booking Threshold (In Minutes)",dataAt:"BookingThresholdInMinutes",displayAs:_constantsJs2['default'].DISPLAY_AS.RANGE,min:0,max:36000,step:15,defaultValue:0,units:"minutes"};var TtlThresholdFlight={displayName:"Flight Ttl Threshold (In Minutes)",dataAt:"TtlThreshold.Flight",displayAs:_constantsJs2['default'].DISPLAY_AS.RANGE,min:0,max:36000,step:15,defaultValue:0,units:"minutes"};var TtlThresholdHotel={displayName:"Hotel Ttl Threshold (In Minutes)",dataAt:"TtlThreshold.Hotel",displayAs:_constantsJs2['default'].DISPLAY_AS.RANGE,min:0,max:36000,step:15,defaultValue:0,units:"minutes"};var TtlThresholdCar={displayName:"Car Ttl Threshold (In Minutes)",dataAt:"TtlThreshold.Car",displayAs:_constantsJs2['default'].DISPLAY_AS.RANGE,min:0,max:36000,step:15,defaultValue:0,units:"minutes"};var TtlThresholdRail={displayName:"Rail Ttl Threshold (In Minutes)",dataAt:"TtlThreshold.Rail",displayAs:_constantsJs2['default'].DISPLAY_AS.RANGE,min:0,max:36000,step:15,defaultValue:0,units:"minutes"};var TtlThresholdGround={displayName:"Ground Ttl Threshold (In Minutes)",dataAt:"TtlThreshold.Ground",displayAs:_constantsJs2['default'].DISPLAY_AS.RANGE,min:0,max:36000,step:15,defaultValue:0,units:"minutes"};var HomeSearchDefaultSelection={displayName:"Home Search Default Selection",dataAt:"HomeSearchDefaultSelection",displayAs:_constantsJs2['default'].DISPLAY_AS.MULTI_SELECT,optionsAt:"HomeSearchDefaultSelectionOptions",helpText:"Leave empty for current behaviour"};var EnableItineraryValidatorDebtorSettings={displayName:"Use Itinerary Validator Debtor Configuration",dataAt:"ItineraryValidatorConfiguration.IsUsingDebtorSettings",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN,hideShowProperty:"IsUsingDebtorSettings"};var ItineraryValidatorSettings={displayName:"Enabled Itinerary Validators",dataAt:"ItineraryValidatorConfiguration.EnabledItineraryValidators",displayAs:_constantsJs2['default'].DISPLAY_AS.MULTI_SELECT,optionsAt:"ItineraryValidatorTypes",formClass:"IsUsingDebtorSettings"};var EnableParallelSearches={displayName:"Enable Parallel Searches",dataAt:"ParallelSearchesConfiguration.EnableParallelSearches",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var DisableLoyaltyPrograms={displayName:"Disable Loyalty Programs",dataAt:"DisableLoyaltyPrograms",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var RailConfiguration={displayName:"Rail Enabled",dataAt:"RailConfiguration.Enabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var FlightConfigurationRiskEngineFlightThresholdLimit={displayName:"Risk Engine Flight Threshold Limit",dataAt:"FlightConfiguration.RiskEngineFlightThresholdLimit",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var FlightExcludeAirports={displayName:"Exclude Airports",dataAt:"FlightConfiguration.ExcludeAirports",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var FlightSearchWindows={displayName:"Flight Search Windows",dataAt:"FlightConfiguration.FlightWindowSettings",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:FlightSearchWindowItem,gridCols:[{name:"Origins",key:"Origins"},{name:"Destinations",key:"Destinations"}]};var CombinableFareRules={displayName:"Combinable Fare Rules",dataAt:"FlightConfiguration.CombinableFareRules",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:CombinableFareRulesItem,gridCols:[{name:"Origin",key:"Origin"},{name:"Destination",key:"Destination"}]};var OneWayFareRules={displayName:"One Way Fare Rules",dataAt:"FlightConfiguration.OneWayFareRules",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:OneWayFareRulesItem,gridCols:[{name:"Origin",key:"Origin"},{name:"Destination",key:"Destination"}]};var FlightPolicyDepatureWindowTo={displayName:"Depature Window To",dataAt:"FlightConfiguration.FlightPolicyDepatureWindowTo",displayAs:_constantsJs2['default'].DISPLAY_AS.RANGE,min:15,max:720,step:15,divideResultBy:60,units:"minutes"};var FlightPolicyDepatureWindowFrom={displayName:"Depature Window From",dataAt:"FlightConfiguration.FlightPolicyDepatureWindowFrom",displayAs:_constantsJs2['default'].DISPLAY_AS.RANGE,min:15,max:720,step:15,divideResultBy:60,units:"minutes"};var FlightCorporateRateCode={displayName:"Corporate Rate Code",dataAt:"FlightConfiguration.CorporateRateCodes.$flightCorporateRateCodeItem.CorporateRateCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var FlightCorporateRateCodeCarriers={displayName:"Carriers",dataAt:"FlightConfiguration.CorporateRateCodes.$flightCorporateRateCodeItem.Carriers",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT,html:"Optional: Only required with NDC. When shopping ATPCO fares system does not require carrier.",validationRegex:"^$|^[A-Za-z0-9]{2}(?:[\\s,]+[A-Za-z0-9]{2})*$",validationMessage:"Use 2-character carrier codes (letters or numbers), e.g., AA, F9."};var FlightCorporateRateCodeGdsProviders={displayName:"Gds Providers",dataAt:"FlightConfiguration.CorporateRateCodes.$flightCorporateRateCodeItem.GdsProviders",displayAs:_constantsJs2['default'].DISPLAY_AS.MULTI_SELECT,optionsAt:"GDSProviders",helpText:"Optional: Use to force only with specific provider."};var FlightCorporateRateCodeType={displayName:"Rate Code Type",dataAt:"FlightConfiguration.CorporateRateCodes.$flightCorporateRateCodeItem.RateCodeType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"FlightCorporateRateCodeType",hideShowProperty:"FlightCorporateRateCodeType"};var FlightCorporateRateCodeValue={displayName:"Rate Code Value",dataAt:"FlightConfiguration.CorporateRateCodes.$flightCorporateRateCodeItem.RateCodeValue",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,formClass:"FlightCorporateRateCodeType_Qualifier"};var FlightCorporateRateCodeItem={displayName:"Flight Corporate Rate Code",dataAt:"FlightConfiguration.CorporateRateCodes.$flightCorporateRateCodeItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[FlightCorporateRateCode,FlightCorporateRateCodeCarriers,FlightCorporateRateCodeGdsProviders,FlightCorporateRateCodeType,FlightCorporateRateCodeValue],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"flightCorporateRateCodeItem",canDelete:true};var FlightCorporateRateCodes={displayName:"Flight Corporate Rate Codes",dataAt:"FlightConfiguration.CorporateRateCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:FlightCorporateRateCodeItem,gridCols:[{name:"CorporateRateCode",key:"CorporateRateCode"},{name:"Carriers",key:"Carriers"},{name:"GdsProviders",key:"GdsProviders"},{name:"RateCodeType",key:"RateCodeType"},{name:"RateCodeValue",key:"RateCodeValue"}],html:"Coporate Rate codes can be used instead of Policy Rate Codes. System will pull from both places."};var PaymentConfigurations={displayName:"Payment Configurations",dataAt:"PaymentConfigurations",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:PaymentConfigurationsItem,gridCols:[{name:"Provider",key:"Provider"}]};var DebtorAgencyPostcode={displayName:"Agency Postcode",dataAt:"DebtorAgency.Postcode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,validationRegex:"^[0-9]{5}(?:-[0-9]{4})?$",validationMessage:"Not a valid postal code"};var DebtorAgencyState={displayName:"Agency State",dataAt:"DebtorAgency.State",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorAgencyCity={displayName:"Agency City",dataAt:"DebtorAgency.City",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorAgencyStreet={displayName:"Agency Street",dataAt:"DebtorAgency.Street",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorAgencyAddress={displayName:"Agency Address",dataAt:"DebtorAgency.Address",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorAgencyEmail={displayName:"Agency Email",dataAt:"DebtorAgency.Email",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorModificationAlertEmails={displayName:"Modification Alert Emails",dataAt:"DebtorAgency.ModificationAlertEmails",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var DebtorConfirmationAlertEmails={displayName:"Confirmation Alert Emails",dataAt:"DebtorAgency.ConfirmationAlertEmails",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var DebtorCancellationAlertEmails={displayName:"Cancellation Alert Emails",dataAt:"DebtorAgency.CancellationAlertEmails",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var DebtorAgencySendConfirmationToTraveler={displayName:"Send Confirmation Email to Traveler",dataAt:"DebtorAgency.SendConfirmationToTraveler",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var DebtorAgencySendConfirmationToBooker={displayName:"Send Confirmation Email to Booker",dataAt:"DebtorAgency.SendConfirmationToBooker",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var DebtorAgencyConfirmationEmailHeaderText={displayName:"Confirmation Email Custom Header",dataAt:"DebtorAgency.ConfirmationEmailHeaderText",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_AREA,validationMessage:"Max length 250",validationRegex:"^.{0,250}$"};var DebtorAgencyConfirmationEmailFooterText={displayName:"Confirmation Email Custom Footer",dataAt:"DebtorAgency.ConfirmationEmailFooterText",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_AREA,validationMessage:"Max length 250",validationRegex:"^.{0,250}$"};var DebtorAgencyPhone={displayName:"Agency Phone",dataAt:"DebtorAgency.Phone",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorAgencyReasonCodes={displayName:"Agency Reason Codes",dataAt:"DebtorAgencyReasonCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:DebtorAgencyReasonCodesItem,gridCols:[{name:"Code",key:"Code"},{name:"Title",key:"Title"}]};var AllowArrangerFormsOfPayment={displayName:"Allow Arranger Forms of Payment",dataAt:"AllowArrangerFormsOfPayment",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var AgencyReasonDisplayName={displayName:"Reason for travel display name",dataAt:"AgencyReasonDisplayName",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var AgencyCreditCards={displayName:"Agency Credit Cards",dataAt:"DebtorAgencyCreditCards",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:AgencyCreditCardsItem,gridCols:[{name:"Title",key:"Title"},{name:"Credit Card Id",key:"CreditCardId"}]};var CompanyReferencesGrid={displayName:"Company References",dataAt:"CompanyReferences",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:CompanyReferencesGridItem,gridCols:[{name:"Code",key:"Code"},{name:"Title",key:"Title"},{name:'Placement',key:'PlacementType'},{name:"Mandatory",key:"Mandatory"},{name:"ListId",key:"ListId"}]};var ItineraryPolicies={displayName:"Itinerary Policies",dataAt:"ItineraryPolicies",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:ItineraryPoliciesItem,gridCols:[{name:"Code",key:"Code"},{name:"Title",key:"Title"}]};var DebtorApproverFileDownloader={displayName:"Approver File Download",dataAt:"DebtorApproverFileDownloader",displayAs:_constantsJs2['default'].DISPLAY_AS.FILE_DOWNLOADER,fileNameSuffix:"Approvers.xlsx",parameterValueFromActiveItemProperty:"Name",parameterName:"debtorIdentifier",endPointController:"DebtorApproverDownload"};var DebtorApproverFileUpload={displayName:"Approver File Upload",dataAt:"DebtorApproverFileUpload",displayAs:_constantsJs2['default'].DISPLAY_AS.FILE_UPLOADER,fileContainer:"DebtorApproverBatchUpload",uploadType:"xlsx",fileNamePrefixProperty:"Name",fileNameFormat:"yyyymmdd",excludeFromPost:true};var RestrictSelfApproval={displayName:"Restrict Self Approval",dataAt:"RestrictSelfApproval",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var DebtorApprovalsCommentEnabled={displayName:"Free Format Approval Reason",dataAt:"Approvals.Comment.Enabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var DebtorApprovalRestrictionThresholdMin={dataAt:"Approvals.ApprovalRestrictionThresholdMin",displayAs:_constantsJs2['default'].DISPLAY_AS.RANGE,min:0,max:720,step:15,units:"minutes"};var DebtorApprovalRestrictionThresholdMinTitle={displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,html:"<h4>Approval Restriction Threshold</h4><small>Threshold time to restrict booking. For example, if TTL is 120 minutes from Now booking will not be allowed.</small>"};var DebtorCTMApproveStatusLookupEnabled={displayName:"CTM Approve Status Lookup",dataAt:"IsCTMApproveStatusLookupEnabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var DebtorCTMApprovePendingRestrictModify={displayName:"Restrict Modifications on CTM Approve Status Pending",dataAt:"CTMApprovePendingRestrictModify",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var DebtorBookingConfirmationWebHookUrl={displayName:"Booking Confirmation Web Hook",dataAt:"BookingConfirmationWebhookUrl",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var TermsAndConditions={displayName:"Terms and Conditions",dataAt:"TermsAndConditions",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:TermsAndConditionsItem,gridCols:[{name:"SectionType",key:"SectionType"},{name:"Countries",key:"Countries"},{name:"SegmentTypes",key:"SegmentTypes"}]};var DebtorMultiPaxPnrHandlingType={displayName:"Multi Passenger Pnr Handling",dataAt:"TravellerConfiguration.MultiPaxPnrHandling",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"DebtorMultiPaxPnrHandlingType",defaultValue:"NotAllowed"};var MultiPaxPnrHandlingText={displayName:"Multi Passenger Pnr Handling Question Text",dataAt:"TravellerConfiguration.MultiPaxPnrHandlingText",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,html:"Default Text: Create single booking for all passengers."};var TravellerConfigurationGuestTravellerProfileName={displayName:"Traveller Configuration Guest Profile Name",dataAt:"TravellerConfiguration.GuestTravellerProfileName",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var TravellerConfigurationProfilePnrBuilder={displayName:"Traveller Configuration Profile PNR Builder",dataAt:"TravellerConfiguration.ProfilePnrBuilder",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var TravellerConfigurationPcc={displayName:"Traveller Configuration Pcc",dataAt:"TravellerConfiguration.Pcc",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var TravellerConfigurationSource={displayName:"Traveller Configuration Source",dataAt:"TravellerConfiguration.Source",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"TravellerConfigurationSources"};var PointsOfInterestFileUploader={displayName:"Points Of Interest File Upload",dataAt:"PointsOfInterestFile",displayAs:_constantsJs2['default'].DISPLAY_AS.FILE_UPLOADER,fileContainer:"PointOfInterestBatchUpload",uploadType:"xlsx",fileNamePrefixProperty:"Name",fileNameSuffix:"_poi_import",fileNameFormat:"yyyymmdd",excludeFromPost:true};var ShowPoiOnTop={displayName:"Show Points of Interest at top of list",dataAt:"ShowPoiOnTop",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var HostCommands={displayName:"Host Commands",dataAt:"HostCommands",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var AdditionalPnrRemarksAncillary={displayName:"Ancillary Remarks",dataAt:"AdditionalPnrRemarksAncillary",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var HomeCountryCode={displayName:"Home Country Code",dataAt:"HomeCountryCode",displayAs:_constantsJs2['default'].DISPLAY_AS.COUNTRY_SELECT,selectType:"single"};var DomesticCountryCodes={displayName:"Domestic Country Codes",dataAt:"DomesticCountryCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var DebtorOrderNumberCodes={displayName:"Debtor Order Number Codes",dataAt:"DebtorOrderNumberCodes",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:DebtorOrderNumberCodesItem,gridCols:[{name:"Code",key:"Code"},{name:"Title",key:"Title"}]};var AdditionalPnrRemarks={displayName:"Additional Pnr Remarks",dataAt:"AdditionalPnrRemarks",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var AdditionalPnrRemarksModify={displayName:"Additional Pnr Modify Remarks",dataAt:"AdditionalPnrRemarksModify",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var AdditionalPnrRemarksCancel={displayName:"Additional Pnr Cancel Remarks",dataAt:"AdditionalPnrRemarksCancel",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var AdditionalPnrUserHoldRemarks={displayName:"Additional Pnr User Hold Remarks",dataAt:"AdditionalPnrUserHoldRemarks",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var AdditionalPnrUserHoldConfirmedRemarks={displayName:"Additional Pnr User Hold Confirmed Remarks",dataAt:"AdditionalPnrRemarksUserHoldConfirmed",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var AdditionalFinishBookingRemarks={displayName:"Additional Finish Booking Remarks",dataAt:"AdditionalPnrRemarksFinishBooking",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var AdditionalPnrRemarksGuestTraveler={displayName:"Additional Guest Traveler Remarks",dataAt:"AdditionalPnrRemarksGuestTraveler",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var ProfileCompanySize={displayName:"Profile Company Size (no. of people)",dataAt:"Profile.CompanySize",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ProfileIndustry={displayName:"Profile Industry",dataAt:"Profile.Industry",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ProfileAfterHoursPhoneNumber={displayName:"Profile After Hours Phone Number",dataAt:"Profile.AfterHoursPhoneNumber",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ProfileDaytimePhoneNumber={displayName:"Profile Daytime Phone Number",dataAt:"Profile.DaytimePhoneNumber",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ProfileCompanyIdentifier={displayName:"Profile Company Identifier (Business number)",dataAt:"Profile.CompanyIdentifier",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorAddressCountryCode={displayName:"Debtor Address Country Code",dataAt:"DebtorAddress.CountryCode",displayAs:_constantsJs2['default'].DISPLAY_AS.COUNTRY_SELECT,selectType:"single"};var DebtorAddressPostcode={displayName:"Debtor Address Postcode",dataAt:"DebtorAddress.Postcode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,validationRegex:"^[0-9]{5}(?:-[0-9]{4})?$",validationMessage:"Not a valid postal code"};var DebtorAddressState={displayName:"Debtor Address State",dataAt:"DebtorAddress.State",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorAddressCityCode={displayName:"Debtor Address City Code",dataAt:"DebtorAddress.CityCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorAddressCity={displayName:"Debtor Address City",dataAt:"DebtorAddress.City",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorAddressStreet={displayName:"Debtor Address Street",dataAt:"DebtorAddress.Street",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorAddressAddress={displayName:"Debtor Address",dataAt:"DebtorAddress.Address",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorAddressLastname={displayName:"Debtor Address Last name",dataAt:"DebtorAddress.Lastname",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorAddressFirstname={displayName:"Debtor Address First name",dataAt:"DebtorAddress.Firstname",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorSupportCurrencyCode={displayName:"Debtor Support Currency Code",dataAt:"DebtorSupport.CurrencyCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorSupportEmailAddress={displayName:"Debtor Support Email",dataAt:"DebtorSupport.EmailAddress",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"email"};var DebtorSupportPhoneNumber={displayName:"Debtor Support Phone Number",dataAt:"DebtorSupport.PhoneNumber",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DepartmentEnabled={displayName:"Department Editable",dataAt:"Department.Enabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var DepartmentMandatory={displayName:"Department Selection Mandatory",dataAt:"Department.Mandatory",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var DepartmentDisplayName={displayName:"Department Display Name",dataAt:"DepartmentDisplayName",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var CostCentreEnabled={displayName:"Cost Center Editable",dataAt:"CostCentre.Enabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var CostCentreMandatory={displayName:"Cost Center Selection Mandatory",dataAt:"CostCentre.Mandatory",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var CostCentreDisplayName={displayName:"Cost Center Display Name",dataAt:"CostCentreDisplayName",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var OrderNumberDisplayName={displayName:"Order Number Display Name",dataAt:"OrderNumberDisplayName",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var ConsultingTeamEmail={displayName:"Consulting Team Email",dataAt:"ConsultingTeamEmail",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT, //inputType: 'email',
	validationRegex:"^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,6}$",validationMessage:"required or not a valid email address"};var DebtorName={displayName:"Debtor Name",dataAt:"Name",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,validationRegex:"^(?!s*$).+",validationMessage:"Name is required"};var OrderNumberEnabled={displayName:"Order Number Enabled",dataAt:"OrderNumberEnabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var OrderNumberMandatory={displayName:"Order Number Selection Mandatory",dataAt:"OrderNumberMandatory",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var EnablePreBookSeatSelection={displayName:"Enable Pre-Booking Seat Selection",dataAt:"FlightConfiguration.EnablePreBookSeatSelection",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN}; //LimitPassengerPolicy
	var EnablePassengerLimit={displayName:"Enable Limit Passenger Policy",dataAt:"FlightConfiguration.LimitPassengerPolicy.IsEnabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var FlightConfigurationPassengerLimit={displayName:"Limit Count",dataAt:"FlightConfiguration.LimitPassengerPolicy.LimitCount",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"}; //LimitPassengerPolicy-DebtorIdentification
	var LimitPassengerPolicyDebtorIdentificationType={displayName:"Type",dataAt:"FlightConfiguration.LimitPassengerPolicy.DebtorIdentification.DebtorIdentificationType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"DebtorIdentificationType",hideShowProperty:"DebtorIdentificationType"};var LimitPassengerPolicyDebtorIdentificationDefinedDks={displayName:"DefinedDks",dataAt:"FlightConfiguration.LimitPassengerPolicy.DebtorIdentification.DefinedDks",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT,formClass:"DebtorIdentificationType_DefinedDks"};var LimitPassengerPolicyDebtorIdentificationGroupCodeValue={displayName:"GroupCodeValue",dataAt:"FlightConfiguration.LimitPassengerPolicy.DebtorIdentification.GroupCodeValue",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,formClass:"DebtorIdentificationType_DefinedGroupCode"}; //LimitPassengerPolicy-UdidConfigurations
	var LimitPassengerPolicyUdidConfigurationType={displayName:"Type",dataAt:"FlightConfiguration.LimitPassengerPolicy.UdidConfigurations.$udidConfigItem.UdidType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"UdidConfigurationType",hideShowProperty:"UdidConfigurationType"};var LimitPassengerPolicyUdidStaticPreTripCode={displayName:"PreTripCode",dataAt:"FlightConfiguration.LimitPassengerPolicy.UdidConfigurations.$udidConfigItem.PreTripCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,formClass:"UdidConfigurationType_StaticUdid"};var LimitPassengerPolicyUdidStaticValue={displayName:"Value",dataAt:"FlightConfiguration.LimitPassengerPolicy.UdidConfigurations.$udidConfigItem.Value",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,formClass:"UdidConfigurationType_StaticUdid"};var LimitPassengerPolicyUdidCompanyReferencePreTripCode={displayName:"PreTripCode",dataAt:"FlightConfiguration.LimitPassengerPolicy.UdidConfigurations.$udidConfigItem.PreTripCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,formClass:"UdidConfigurationType_CompanyReference"};var LimitPassengerPolicyUdidCompanyReferenceCompanyRefCode={displayName:"Code",dataAt:"FlightConfiguration.LimitPassengerPolicy.UdidConfigurations.$udidConfigItem.Value",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,formClass:"UdidConfigurationType_CompanyReference"};var LimitPassengerPolicyUdidAgencyReasonCodePreTripCode={displayName:"PreTripCode",dataAt:"FlightConfiguration.LimitPassengerPolicy.UdidConfigurations.$udidConfigItem.PreTripCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,formClass:"UdidConfigurationType_AgencyReasonCode"};var LimitPassengerPolicyUdidItem={displayName:"Udid Config",dataAt:"FlightConfiguration.LimitPassengerPolicy.UdidConfigurations.$udidConfigItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[LimitPassengerPolicyUdidConfigurationType,LimitPassengerPolicyUdidStaticPreTripCode,LimitPassengerPolicyUdidStaticValue,LimitPassengerPolicyUdidCompanyReferenceCompanyRefCode,LimitPassengerPolicyUdidCompanyReferencePreTripCode,LimitPassengerPolicyUdidAgencyReasonCodePreTripCode],endpoint:"Debtors",routeParamId:"debtorId",removeParamId:"udidConfigItem",canDelete:true};var UdidConfigurations={displayName:"Udid Configurations",dataAt:"FlightConfiguration.LimitPassengerPolicy.UdidConfigurations",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:false,canAddNew:true,gridItem:LimitPassengerPolicyUdidItem,gridCols:[{name:"Type",key:"UdidType"},{name:"PreTripCode",key:"PreTripCode"},{name:"Value",key:"Value"}]}; //LimitPassengerPolicy-PolicyRestriction
	var LimitPassengerPolicyRestrictiontionRestrictionType={displayName:"Type",dataAt:"FlightConfiguration.LimitPassengerPolicy.PolicyRestriction.RestrictionType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"PolicyRestrictionType",hideShowProperty:"PolicyRestrictionType"};var LimitPassengerPolicyRestrictionShowButNotAllowMessage={displayName:"Message",dataAt:"FlightConfiguration.LimitPassengerPolicy.PolicyRestriction.DisplayMessage.Message",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_AREA,formClass:"PolicyRestrictionType_ShowButNotAllow"};var LimitPassengerPolicyRestrictionDisplayMessageTitle={displayName:"Title",dataAt:"FlightConfiguration.LimitPassengerPolicy.PolicyRestriction.DisplayMessage.Title",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,formClass:"PolicyRestrictionType_MessagePopup"};var LimitPassengerPolicyRestrictionDisplayMessage={displayName:"Message",dataAt:"FlightConfiguration.LimitPassengerPolicy.PolicyRestriction.DisplayMessage.Message",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_AREA,formClass:"PolicyRestrictionType_MessagePopup"};var LimitPassengerPolicyRestrictionSetOutOfPolicyMessage={displayName:"Message",dataAt:"FlightConfiguration.LimitPassengerPolicy.PolicyRestriction.DisplayMessage.Message",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_AREA,formClass:"PolicyRestrictionType_PolicyViolation"};var LimitPassengerPolicyRestrictionSetOutOfPolicyListId={displayName:"ListId",dataAt:"FlightConfiguration.LimitPassengerPolicy.PolicyRestriction.PolicyViolation.ListId",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,formClass:"PolicyRestrictionType_PolicyViolation",html:"Company Reference ListId to pull option values to choose from."};var LimitPassengerPolicyRestrictionSetOutOfPolicyRemarkFormat={displayName:"RemarkFormat",dataAt:"FlightConfiguration.LimitPassengerPolicy.PolicyRestriction.PolicyViolation.RemarkFormat",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,formClass:"PolicyRestrictionType_PolicyViolation",html:"Smart.Format used to write remark to booking.<br/>Exmple: .S*UD110 VIOLATION CODE {Value}<br/><i>Properties</i>" + "<ul><li>ValueDescription</li><li>Value</li></ul>"};var DisableColleagueSeatMapDisplay={displayName:"Colleague Seat Map Display Disabled",dataAt:"FlightConfiguration.DisableColleagueSeatMapDisplay",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var EnableSharedFlightOptions={displayName:"Enable Shared Flight Options",dataAt:"FlightConfiguration.EnableSharedFlightOptions",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var CollectContactInformationForNDCBookings={displayName:"Collect Contact Information for NDC Bookings",dataAt:"FlightConfiguration.CollectContactInformationForNDCBookings",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var EnableFareCodeDisplay={displayName:"Fare Code Display Enabled",dataAt:"FlightConfiguration.EnableFareCodeDisplay",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var DisableTravelRequirements={displayName:"Disable Travel Requirements",dataAt:"FlightConfiguration.DisableTravelRequirements",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var EnableMobileAirBooking={displayName:"Enable Mobile Air Booking",dataAt:"FlightConfiguration.EnableMobileAirBooking",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var EnableMobileHotelBooking={displayName:"Enable Mobile Hotel Booking",dataAt:"HotelConfiguration.EnableMobileHotelBooking",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var EnableMobileRailBooking={displayName:"Enable Mobile Rail Booking",dataAt:"RailConfiguration.EnableMobileRailBooking",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var EnableMobileCarBooking={displayName:"Enable Mobile Car Booking",dataAt:"CarConfiguration.EnableMobileCarBooking",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var EnabledAggregatorsForMobileHotelBooking={displayName:"Enable Aggregators for Mobile Hotel Booking",dataAt:"HotelConfiguration.EnabledAggregatorsForMobileHotelBooking",displayAs:_constantsJs2['default'].DISPLAY_AS.O_DATA_SELECT,endpoint:"Settings",queryOption:"select",selectProperty:"HotelRateCategories",inputTitle:"Name",selectChoiceName:"Name",entityIdentifier:"Name",searchAllNo:true,isMultiSelect:true,additionalFilters:{"IsAggregator":true},showOnlySelectedField:true};var EnableCSL={displayName:"Enable CSL",dataAt:"HotelConfiguration.EnableCSL",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var HotelConfigurationDisplayTax={displayName:"Rate Display - Tax Inclusion Override",dataAt:"HotelConfiguration.TaxDisplayMode",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"TaxDisplayMode"};var HotelConfigurationPreferredTagsSourceType={displayName:"CTM Preferred Tier Labels",dataAt:"HotelConfiguration.PreferredTagsSourceType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"DebtorHotelPreferredTagsSourceType"};var HotelConfigurationTagsToIgnoreFromDatabaseSourceType={displayName:"Hotel Config Tags to Ignore from Database",dataAt:"HotelConfiguration.TagsToIgnoreFromDatabaseSourceType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"DebtorHotelConfigTagsToIgnoreFromDatabaseSourceType",hideShowProperty:"HotelConfigurationTagsToIgnoreFromDatabaseSourceType"};var HotelConfigurationTagsToIgnoreFromDatabase={displayName:"Tags to Ignore",dataAt:"HotelConfiguration.TagsToIgnoreFromDatabase",displayAs:_constantsJs2['default'].DISPLAY_AS.O_DATA_SELECT,formClass:"HotelConfigurationTagsToIgnoreFromDatabaseSourceType_Customize",endpoint:"Hotels/GetAllTags",searchAllNo:true,isMultiSelect:true,showOnlySelectedField:true};var EnableHotelAllowedCardRestriction={displayName:"Enable Hotel Allowed Card Restriction",dataAt:"HotelConfiguration.EnableHotelAllowedCardRestriction",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var EnableSabreHotelDisplayOrder={displayName:"Enable Sabre Hotel Display Order",dataAt:"HotelConfiguration.EnableSabreHotelDisplayOrder",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var HideSoldOutHotels={displayName:"Default to hide hotels with sold out / out of policy rates",dataAt:"HotelConfiguration.HideSoldOutHotels",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var ExpandAdvancedHotelSearchOptions={displayName:"Expand advanced hotel search options",dataAt:"HotelConfiguration.ExpandAdvancedHotelSearchOptions",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var HotelQuickSearchEnabled={displayName:"Enable Hotel Quick Search (POC)",dataAt:"HotelConfiguration.QuickSearch.Enabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var HotelQuickSearchInitialPageCount={displayName:"Hotel Quick Search Initial Page Count",dataAt:"HotelConfiguration.QuickSearch.InitialPageCount",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var HotelQuickSearchAutoLoad={displayName:"Hotel Quick Search Auto Load",dataAt:"HotelConfiguration.QuickSearch.AutoLoad",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var IataId={displayName:"Hotel IATA ID (Sabre / AGT field)",dataAt:"HotelConfiguration.IataId",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var GuestTraveller={displayName:"Guest Traveller Enabled",dataAt:"GuestTraveller.Enabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var GuestTravellerDeptCostCenterFop={displayName:"Guest Traveller Enabled Department and Cost Center Fop Handling",dataAt:"GuestTraveller.EnableGuestDeptCostCtrFopHandling",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var GuestTravellerAllowTempCards={displayName:"Guest Traveller Allow Temp/Personal Cards",dataAt:"GuestTraveller.GuestTravellerAllowTempCards",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var GuestTravellerAllowTempCardsSub={displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,label:"Guest Traveler Allow Temp/Personal Cards. Overrides Debtor Settings configured for Temp Cards."};var ShowCommentToTravelAgent={displayName:"Show Comment to Travel Agent",dataAt:"ShowCommentToTravelAgent",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var CancelBookingEnabled={displayName:"Cancel Booking Enabled",dataAt:"CancelBookingEnabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var UserHoldEnabled={displayName:"User Hold Enabled",dataAt:"UserHoldEnabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var CancellationWindowMinutes={displayName:"Cancellation Window in Minutes",dataAt:"CancellationWindowMinutes",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var OfflinePnrEnabled={displayName:"Offline PNR Enabled",dataAt:"OfflinePnrEnabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var AdditionalTravelerInfo={displayName:"Additional Traveler Information Enabled",dataAt:"GuestTraveller.AdditionalTravelerInfo",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var PaymentMethodDisabled={displayName:"Payment Methods Disabled",dataAt:"PaymentMethodDisabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN,helpText:"Disables temporary form of payment."};var PaymentMethodSelectionMandatory={displayName:"Payment Method Selection Mandatory",dataAt:"PaymentMethodSelectionMandatory",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN,helpText:"When checked system will not default form of payment."};var Disabled={displayName:"DISABLED",dataAt:"Disabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var TestAccount={displayName:"TEST ACCOUNT",dataAt:"DebtorIsTest",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var FareDebugging={displayName:"Fare Debugging Enabled",dataAt:"IsFareDebuggingEnabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var EnableCarAiRecommendation={displayName:"Enable Car AI Recommendations",dataAt:"AiMlConfigs.IsCarAIRecommendationsEnabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var EnableHotelAiRecommendation={displayName:"Enable Hotel AI Recommendations",dataAt:"AiMlConfigs.IsHotelAIRecommendationsEnabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var EnableModificationCar={displayName:"Enable Car Modify",dataAt:"Modifications.IsCarModifyEnabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var EnableModificationHotel={displayName:"Enable Hotel Modify",dataAt:"Modifications.IsHotelModifyEnabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var EnableModificationAir={displayName:"Enable Air Modify",dataAt:"Modifications.IsAirModifyEnabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var EnableModificationGround={displayName:"Enable Ground Modify",dataAt:"Modifications.IsGroundModifyEnabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var EnableModificationRail={displayName:"Enable Rail Modify",dataAt:"Modifications.IsRailModifyEnabled",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var HotelCarFopHandlingType={displayName:"Hotel Car Only Booking Fop Handling Type",dataAt:"HotelCarOnlyFopHandling.FopHandlingType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"DebtorFopHandlingTypes"};var HotelCarDefinedCreditCardId={displayName:"Hotel Car Only Booking Fop Defined Credit Card Id",dataAt:"HotelCarOnlyFopHandling.DefinedCreditCardId",displayAs:_constantsJs2['default'].DISPLAY_AS.O_DATA_SELECT,endpoint:"CreditCards",searchType:"Title",expression:"contains",searchAllNo:true};var EnableHonoluluTripFeed={displayName:"Enable Honolulu TripFeed",dataAt:"MobileConfigs.UseHonoluluTripFeed",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var Title={displayName:"Title",dataAt:"Title",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,required:true};var Id={displayName:"Identifier",dataAt:"Id",disabled:true,displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DateFormatLongSettings={displayName:"Date Format Long",dataAt:"DateTimeSettings.DateFormatLong",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,label:"Default format: MMM Do YYYY."};var DateFormatMediumSettings={displayName:"Date Format Medium",dataAt:"DateTimeSettings.DateFormatMedium",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,label:"Default format: MMM DD, YYYY."};var DateFormatShortSettings={displayName:"Date Format Short",dataAt:"DateTimeSettings.DateFormatShort",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,label:"Default format: MM/DD/YYYY."};var DatetimeFormatLongSettings={displayName:"Datetime Format",dataAt:"DateTimeSettings.DateTimeFormatLong",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,label:"Default format: ddd, MMM D YYYY [at] h:mm a."};var TimeFormatLongSettings={displayName:"Time Format Long",dataAt:"DateTimeSettings.TimeFormatLong",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,label:"Default format: h:mm a."};var EnableNewUiHandlingType={displayName:"Enable New UI",dataAt:"EnableNewUiHandlingType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"EnableNewUiHandlingType"};var AdminPanel={tabName:"Admin",dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,children:[CreatedBy,CreatedOn,ModifiedBy,ModifiedOn]};var DatetimeFormatPanel={tabName:"Datetime-Format",dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,children:[DateFormatLongSettings,DateFormatMediumSettings,DateFormatShortSettings,DatetimeFormatLongSettings,TimeFormatLongSettings]};var TramadaConfigurationPanel={dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,tabName:"Tramada",children:[TramadaConfigurationAgencyId,TramadaConfigurationDebtorId,TramadaConfigurationDebtorAuthCode,TramadaConfigurationDatabase]};var GdsProviderPrimary={displayName:"Gds Provider Primary",dataAt:"GdsProviderPrimary",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"GDSProvidersPrimary"}; ///GDS Amedeus Configuration
	var GdsAmadeusBranch={displayName:"Debtor Branch",dataAt:"GdsConfigurationAmadeus.Branch",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var buildAmadeusQueueFields=function buildAmadeusQueueFields(queueName,title){var dataAt='GdsConfigurationAmadeus.' + queueName;return [{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,titleHeader:title,formClass:"clear"},{displayName:"Queue Number",dataAt:dataAt + '.Number',displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number",min:1,formClass:"width100"},{displayName:"Category",dataAt:dataAt + '.Category',displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,formClass:"width100"},{displayName:"Office",dataAt:dataAt + '.Office',displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,formClass:"width100",helpText:"Optional. Leave blank to use the Amadeus debtor branch."}];};var GDSPanel={dataAt:"",tabName:"GDS",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,children:[DebtorGds,GdsProviderPrimary,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,html:"<div><h2>Sabre Gds Configuration</h2></div>"},Pcc,PccCity,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,html:"<h4>Queue Placements</h4><small>Leave Pcc blank to leverage debtor Pcc.</small>"},{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,titleHeader:"Authorisation Hold",formClass:"widthLabe150 clear"},AuthorisationHoldQueuePcc,AuthorisationHoldQueue,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,titleHeader:"Auto Ticketing",formClass:"widthLabe150 clear"},AutoTicketingQueuePcc,AutoTicketingQueue,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,titleHeader:"Team Rejection",formClass:"widthLabe150 clear"},TeamRejectionQueuePcc,TeamRejectionQueue,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,titleHeader:"Cancel",formClass:"widthLabe150 clear"},CancelQueuePcc,CancelQueue,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,titleHeader:"Modification",formClass:"widthLabe150 clear"},ModificationQueuePcc,ModificationQueue,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,titleHeader:"User Hold",formClass:"widthLabe150 clear"},UserHoldQueuePcc,UserHoldQueue,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,formClass:"clear",html:"<div><h2>Amadeus Gds Configuration</h2></div>"},GdsAmadeusBranch].concat(_toConsumableArray(buildAmadeusQueueFields("AuthorisationHoldQueue","Authorisation Hold Queue")),_toConsumableArray(buildAmadeusQueueFields("AutoTicketingQueue","Auto Ticketing Queue")),_toConsumableArray(buildAmadeusQueueFields("CancelQueue","Cancellation Queue")),_toConsumableArray(buildAmadeusQueueFields("ModificationQueue","Modification Queue")),_toConsumableArray(buildAmadeusQueueFields("UserHoldQueue","User Hold Queue")),_toConsumableArray(buildAmadeusQueueFields("TeamRejectionQueue","Team Rejection Queue")))};var UnusedTicketPanel={dataAt:"",tabName:"Unused-Tickets",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,children:[EnableUnusedTicketDebtorSettings,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,label:"When Use Unused Ticket Debtor Configuration is checked, the below providers will be leveraged. When not checked system settings will be leveraged."},UnusedTicketSettings]};var AllSectorConfigPanel={dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,tabName:"All-Sectors",children:[DebtorLimitCountries,DebtorLimitAirportClassification,EnableCarAiRecommendation,EnableHotelAiRecommendation,EnableModificationCar,EnableModificationHotel,EnableModificationAir,EnableModificationGround,EnableModificationRail,EnableParallelSearches,DisableLoyaltyPrograms,EnableItineraryValidatorDebtorSettings,ItineraryValidatorSettings,BookingThreshold,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,html:"TTL Threshold: Amount of time to subtract from the calculated last time to cancel. The default value is 1 hour when not set.<br/>" + "<small>Example: Hotel booked 30 days in the future and last date to cancel is 25 days in the future then default TTL will be 24 days and 23 hours from booking.</small><br/>"},TtlThresholdFlight,TtlThresholdHotel,TtlThresholdCar,TtlThresholdRail,TtlThresholdGround,HomeSearchDefaultSelection]};var MobileConfigPanel={dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,tabName:"Mobile",children:[EnableMobileAirBooking,EnableMobileHotelBooking,EnableMobileRailBooking,EnableMobileCarBooking,EnableHonoluluTripFeed,EnabledAggregatorsForMobileHotelBooking]};var HotelConfigurationPanel={dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,tabName:"Hotel-Sectors",children:[HotelConfigurationEnableOvernightHotelPrompt,HotelConfigurationIsImperialSystem,EnableCSL,EnableHotelAllowedCardRestriction,EnableSabreHotelDisplayOrder,HideSoldOutHotels,ExpandAdvancedHotelSearchOptions,IataId,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,label:"Override Sabre TJR with /AGT field."},HotelConfigurationAggregators,HotelConfigurationRadiusDefaultRadius,HotelConfigurationDisplayTax,HotelConfigurationPreferredTagsSourceType,HotelConfigurationTagsToIgnoreFromDatabaseSourceType,HotelConfigurationTagsToIgnoreFromDatabase,HotelConfigurationRadiusCities,HotelConfigurationHotelAmenityFiltersGrid,HotelConfigurationPaymentNarratives,HotelConfigurationTags,HotelQuickSearchEnabled,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,label:"Dark release POC used for testing only."},HotelQuickSearchInitialPageCount,HotelQuickSearchAutoLoad]};var RailConfigPanel={dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,tabName:"Rail-Sectors",children:[RailConfiguration,RailSupplierSettings,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,html:"<h4>Rail Ticketing Configuration</h4><br/><small>When remark text is populated system will pause ticketing until remark exist in the Sabre booking.<br/>If no remark is set then system will ticket rail reservation immediately.</small>"},{displayName:"Rail Ticketing Use Debtor Setting",dataAt:"RailConfiguration.RailTicketingRemark.UserDebtorSetting",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN,helpText:"When not checked system setting will be used."},{displayName:"Rail Ticketing Remark Type",dataAt:"RailConfiguration.RailTicketingRemark.RemarkType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"RemarkType"},{displayName:"Rail Ticketing Remark Text",dataAt:"RailConfiguration.RailTicketingRemark.RemarkText",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,html:"<small><i>Leave blank to not pause ticketing.</i> Remark Text can be a regular expression</small>"},{displayName:"Rail Ticketing Remark Code",dataAt:"RailConfiguration.RailTicketingRemark.RemarkCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,label:"Optional value used when remark type is Alpha-Coded"},{displayName:"Additional Confirmation Emails (max 2)",dataAt:"RailConfiguration.AdditionalConfirmationEmails",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT,validationItemLimit:2}]}; //Start FlightModificationSettingGdsProviders
	var FlightModificationSettingGdsProviders={displayName:"Gds Providers",dataAt:"FlightConfiguration.FlightModificationSettings.$iiflightModificationSettingItem.GdsProviders",displayAs:_constantsJs2['default'].DISPLAY_AS.MULTI_SELECT,optionsAt:"GDSProviders"};var FlightModificationSettingCarriersExcluded={displayName:"Carriers Excluded",dataAt:"FlightConfiguration.FlightModificationSettings.$iiflightModificationSettingItem.CarriersExcluded",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT,validationRegex:"^$|^[A-Za-z0-9]{2}(?:[\\s,]+[A-Za-z0-9]{2})*$",validationMessage:"Use 2-character carrier codes (letters or numbers), e.g., AA, F9."};var FlightModificationSettingCarriersIncluded={displayName:"Carriers Included",dataAt:"FlightConfiguration.FlightModificationSettings.$iiflightModificationSettingItem.CarriersIncluded",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT,validationRegex:"^$|^[A-Za-z0-9]{2}(?:[\\s,]+[A-Za-z0-9]{2})*$",validationMessage:"Use 2-character carrier codes (letters or numbers), e.g., AA, F9."};var FlightModificationSettingEnableCancelRebook={displayName:"Enable Cancel Rebook",dataAt:"FlightConfiguration.FlightModificationSettings.$iiflightModificationSettingItem.EnableCancelRebook",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var FlightModificationSettingEnableExchanges={displayName:"Enable Exchanges",dataAt:"FlightConfiguration.FlightModificationSettings.$iiflightModificationSettingItem.EnableExchanges",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var FlightModificationSettingEnableAdd={displayName:"Enable Add",dataAt:"FlightConfiguration.FlightModificationSettings.$iiflightModificationSettingItem.EnableAdd",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var DebtorFlightModificationSettingItem={displayName:"Item",dataAt:"FlightConfiguration.FlightModificationSettings.$iiflightModificationSettingItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[FlightModificationSettingGdsProviders,FlightModificationSettingCarriersExcluded,FlightModificationSettingCarriersIncluded,FlightModificationSettingEnableCancelRebook,FlightModificationSettingEnableExchanges,FlightModificationSettingEnableAdd],endpoint:"Debtors",removeParamId:"iiflightModificationSettingItem",canDelete:true};var FlightModificationSettingsGrid={tabName:"Flight-Modification-Settings",displayName:"Flight Modification Settings",dataAt:"FlightConfiguration.FlightModificationSettings",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,gridItem:DebtorFlightModificationSettingItem,copyWithoutCopyText:true,gridCols:[{name:"Providers",key:"GdsProviders"},{name:"CancelRebook",key:"EnableCancelRebook"},{name:"Exchanges",key:"EnableExchanges"},{name:"Add",key:"EnableAdd"},{name:"Excluded",key:"CarriersExcluded"},{name:"Included",key:"CarriersIncluded"}]}; //End FlightModificationSettingGdsProviders
	//Start FlightSearch
	var FlightSearchConfigurationConfigurationType={displayName:"Flight Search Configuration Type",dataAt:"FlightConfiguration.FlightSearch.ConfigurationType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"FlightSearchConfigurationType"};var FlightSearchConfigurationCarrierType={displayName:"Carrier Type",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.CarrierType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"FlightSearchConfigurationQueryItemsType",helpText:"Single: 1 search performed which includes all defined carriers. Multi: 1 search for each carrier defined."};var FlightSearchConfigurationCarriers={displayName:"Carriers",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.Carriers",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT,html:"<span class=\"help-block\">" + "Named lists are supported. Wrap name in ~ characters. Example: ~ExcludedCarriers~<br/><br />" + "Enter XX with carrier type = Multi will perform an exclusion with all the other carriers excluded.<br/>" + "Example: XX, AA entered as values will perform 2 queries. 1 with AA and another with excluding AA and any other configured excluded carriers." + "</span>"};var FlightSearchConfigurationExcludeCarriers={displayName:"Exclude Carriers",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.ExcludeCarriers",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT,helpText:"Named lists are supported. Wrap name in ~ characters. Example: ~ExcludedCarriers~"};var FlightSearchConfigurationCabinType={displayName:"Cabin Type",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.CabinType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"FlightSearchConfigurationQueryItemsTypeMultiOnly",helpText:"Sabre only supports single cabin queries. Therefore Multi is the only available option."};var FlightSearchConfigurationCabins={displayName:"Cabins",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.Cabins",displayAs:_constantsJs2['default'].DISPLAY_AS.MULTI_SELECT,optionsAt:"FlightCabins"};var FlightSearchPassengerTypes={displayName:"Passenger Types",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.PassengerTypes",displayAs:_constantsJs2['default'].DISPLAY_AS.MULTI_SELECT,optionsAt:"PassengerTypes",allowFreeform:true,transformUppercase:true,validationRegex:"^[A-Z0-9]{3}$",validationMessage:"Each passenger type must be exactly 3 alphanumeric characters"};var FlightSearchConfigurationIncDebtorPreferred={displayName:"Include Debtor Preferred",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.IncDebtorPreferred",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var FlightSearchConfigurationRefundableSearch={displayName:"Penalty Search Type",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.RefundableSearchTypes",displayAs:_constantsJs2['default'].DISPLAY_AS.MULTI_SELECT,optionsAt:"PenaltySearchTypes"};var FlightSearchConfigurationUnbrandedSearch={displayName:"Unbranded Search",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.UnbrandedSearch",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var FlightSearchConfigurationEnableATPCO={displayName:"Enable ATPCO",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.EnableATPCO",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var FlightSearchConfigurationEnableNDC={displayName:"Enable NDC",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.EnableNDC",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN,helpText:"Leave Enabled ATPCO and Enabled NDC un-checked to use Debtor Configuration."};var FlightSearchConfigurationMaxStopsQuantity={displayName:"Max Stops Quantity",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.MaxStopsQuantity",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var FlightSearchConfigurationCountryOrigin={displayName:"Origin Countries",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.CountryOrigin",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT,helpText:"If set, query will only be used if Origin country codes are in the list. ** Named list support"};var FlightSearchConfigurationCountryDestination={displayName:"Destination Countries",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.CountryDestination",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT,helpText:"If set, query will only be used if Destination country codes are in the list. ** Named list support"};var FlightSearchConfigurationPriority={displayName:"Priority",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.Priority",displayAs:_constantsJs2['default'].DISPLAY_AS.MULTI_SELECT,optionsAt:"FlightConfigurationPriority",html:"Leave blank for system configuration. Enter the order of priority. First 1 in list is the highest priority."};var FlightSearchConfigurationKeepSameCabin={displayName:"Keep Same Cabin",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.KeepSameCabin",helpText:"BFM Configuration leave blank for default configuration",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"BoolNullableType",handleAsString:true,allowNullable:true};var FlightSearchConfigurationFareFocusRulesExclude={displayName:"Fare Focus Rules Exclude",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.FareFocusRulesExclude",helpText:"BFM Configuration leave blank for default configuration",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"BoolNullableType",handleAsString:true,allowNullable:true};var FlightSearchConfigurationOfferControlRulesExclude={displayName:"Offer Control Rules Exclude",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.OfferControlRulesExclude",helpText:"BFM Configuration leave blank for default configuration",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"BoolNullableType",handleAsString:true,allowNullable:true};var FlightSearchConfigurationItineraryCount={displayName:"Itinerary Count",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.ItineraryCount",helpText:"BFM Configuration leave blank for default configuration",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var FlightSearchConfigurationNumTrips={displayName:"Num Trips",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.NumTrips",helpText:"BFM Configuration leave blank for default configuration",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var FlightSearchConfigurationVendorPrefApplicabilityAtLeastOne={displayName:"Vendor Pref Applicability AtLeast One",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.VendorPrefApplicabilityAtLeastOne",helpText:"BFM Configuration leave blank for default configuration",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"BoolNullableType",handleAsString:true,allowNullable:true};var FlightSearchConfigurationCarrierFilterApplyValidatingCarrier={displayName:"Carrier Filter Apply Validating Carrier",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.CarrierFilterApplyValidatingCarrier",helpText:"BFM Configuration leave blank for default configuration",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"BoolNullableType",handleAsString:true,allowNullable:true};var FlightSearchConfigurationDiversityHandling={displayName:"Diversity Handling",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.DiversityHandling",helpText:"BFM Configuration leave blank for default configuration",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"DiversityHandlingType"};var FlightSearchConfigurationAdditionalNonStopsPercentage={displayName:"Additional NonStops Percentage",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.AdditionalNonStopsPercentage",helpText:"BFM Configuration leave blank for default configuration",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var FlightSearchConfigurationLowFareBucketFareCutOffPercentage={displayName:"Low Fare Bucket Fare Cut Off Percentage",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.LowFareBucketFareCutOffPercentage",helpText:"BFM Configuration leave blank for default configuration",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var FlightSearchConfigurationLowFareBucketOptionsPercentage={displayName:"Low FareBucket Options Percentage",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.LowFareBucketOptionsPercentage",helpText:"BFM Configuration leave blank for default configuration.",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var FlightSearchConfigurationSetBrandedFareOptions={displayName:"Set BrandedF are Options",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.SetBrandedFareOptions",helpText:"When not checked system will use system configuration. To override check this box and set Multiple and Single branded fare values below.",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN};var FlightSearchConfigurationMultipleBrandedFare={displayName:"Multiple Branded Fare",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.MultipleBrandedFare",helpText:"BFM Configuration leave blank for default configuration. Ignored when Set Branded Fare Options = false",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"BoolNullableType",handleAsString:true,allowNullable:true};var FlightSearchConfigurationSingleBrandedFare={displayName:"Single Branded Fare",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.SingleBrandedFare",helpText:"BFM Configuration leave blank for default configuration. Ignored when Set Branded Fare Options = false",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"BoolNullableType",handleAsString:true,allowNullable:true};var FlightSearchConfigurationTimeWindowsOutbound={displayName:"Time Windows Outbound",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.TimeWindowsOutbound",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT,html:"List of time windows. <br/>- use for empty value. This means system will use configured time window. Either none or configured default time window. <br/>" + "Format: HHmmHHmm example: 12002359 Begin time in HHmm followed by end time HHmm. Note end time 2400 is not valid. Enter 2359.<br/> " + "Example all day: 00002359<br/>" + "Enter number for plus or minus range. Example 120 will be plus and minus 120 min from chosen depart time."};var FlightSearchConfigurationTimeWindowRange={displayName:"Time Window Range (Min)",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.TimeWindowRange",helpText:"Overrides configuration with defined plus and minus time wondow for searched for time. Enter number of minutes to define range for search time.",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"};var FlightSearchConfigurationIsCombinable={displayName:"Is Combinable",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.IsCombinable",helpText:"Search configuration is only included if doing a combinable search or not. Leave blank or not set to always include.",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"BoolNullableType",handleAsString:true,allowNullable:true};var FlightSearchConfigurationIncludeCountryCarriers={displayName:"Include Country Carriers",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem.IncludeCountryCarriers",helpText:"System to include Country Carriers in carrier list. Based on origin and destination countries.",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"BoolNullableType",handleAsString:true,allowNullable:true};var DebtorFlightSearchConfigurationItem={displayName:"Item",dataAt:"FlightConfiguration.FlightSearch.Queries.$iflightSearchConfigurationItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[FlightSearchConfigurationCarrierType,FlightSearchConfigurationCarriers,FlightSearchConfigurationExcludeCarriers,FlightSearchConfigurationCabinType,FlightSearchConfigurationCabins,FlightSearchConfigurationRefundableSearch,FlightSearchPassengerTypes,FlightSearchConfigurationIncDebtorPreferred,FlightSearchConfigurationUnbrandedSearch,FlightSearchConfigurationEnableATPCO,FlightSearchConfigurationEnableNDC,FlightSearchConfigurationMaxStopsQuantity,FlightSearchConfigurationCountryOrigin,FlightSearchConfigurationCountryDestination,FlightSearchConfigurationIsCombinable,FlightSearchConfigurationIncludeCountryCarriers,FlightSearchConfigurationTimeWindowsOutbound,FlightSearchConfigurationTimeWindowRange,FlightSearchConfigurationPriority,FlightSearchConfigurationKeepSameCabin,FlightSearchConfigurationFareFocusRulesExclude,FlightSearchConfigurationOfferControlRulesExclude,FlightSearchConfigurationItineraryCount,FlightSearchConfigurationNumTrips,FlightSearchConfigurationVendorPrefApplicabilityAtLeastOne,FlightSearchConfigurationCarrierFilterApplyValidatingCarrier,FlightSearchConfigurationDiversityHandling,FlightSearchConfigurationAdditionalNonStopsPercentage,FlightSearchConfigurationLowFareBucketFareCutOffPercentage,FlightSearchConfigurationLowFareBucketOptionsPercentage,FlightSearchConfigurationSetBrandedFareOptions,FlightSearchConfigurationMultipleBrandedFare,FlightSearchConfigurationSingleBrandedFare],endpoint:"Debtors",removeParamId:"iflightSearchConfigurationItem",canDelete:true};var FlightSearchGrid={tabName:"Flight-Search-Configuration",displayName:"Flight Search Configuration",dataAt:"FlightConfiguration.FlightSearch.Queries",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,copyWithoutCopyText:true,gridItem:DebtorFlightSearchConfigurationItem,gridCols:[{name:"CrrT",key:"CarrierType"},{name:"Crrs",key:"Carriers"},{name:"ExCrrs",key:"ExcludeCarriers"},{name:"CbnT",key:"CabinType"},{name:"Cbn",key:"Cabins"},{name:"Rfd",key:"RefundableSearchTypes"},{name:"Pax",key:"PassengerTypes"},{name:"Pref",key:"IncDebtorPreferred"},{name:"UnBrd",key:"UnbrandedSearch"},{name:"ATPCO",key:"EnableATPCO"},{name:"NDC",key:"EnableNDC"},{name:"Stp",key:"MaxStopsQuantity"},{name:"Org",key:"CountryOrigin"},{name:"Dst",key:"CountryDestination"}]}; //End FlightSearch
	//Start Custom Airport Hubs
	var DebtorCustomAirportHubName={displayName:"Name",dataAt:"FlightConfiguration.CustomAirportHubs.$idebtorCustomAirportHubsItem.Name",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT};var DebtorCustomAirportHubAirports={displayName:"Airports",dataAt:"FlightConfiguration.CustomAirportHubs.$idebtorCustomAirportHubsItem.Airports",displayAs:_constantsJs2['default'].DISPLAY_AS.TAG_INPUT};var DebtorCustomAirportHubsItem={displayName:"Item",dataAt:"FlightConfiguration.CustomAirportHubs.$idebtorCustomAirportHubsItem",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,children:[DebtorCustomAirportHubName,DebtorCustomAirportHubAirports],endpoint:"Debtors",removeParamId:"idebtorCustomAirportHubsItem",canDelete:true};var DebtorCustomAirportHubsGrid={tabName:"Custom-Airport-Hubs",displayName:"Custom Airport Hubs",dataAt:"FlightConfiguration.CustomAirportHubs",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,canCopyItem:true,canAddNew:true,copyWithoutCopyText:true,gridItem:DebtorCustomAirportHubsItem,gridCols:[{name:"Name",key:"Name"},{name:"Airports",key:"Airports"}]}; //End Custom Airport Hubs
	//Start FlightNdcAtpcoTieSettings
	var FlightNdcAtpcoTieSettingsApplicationType={displayName:"NDC ATPCO Tie Settings Application Type",dataAt:"FlightConfiguration.FlightNdcAtpcoTieSettings.ApplicationType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"FlightNdcAtpcoTieSettingsApplicationType",html:_constantsJs2['default'].MESSAGES.NDC_TIE_SETTINGS};var FlightNdcAtpcoTieSettingsThresholdType={displayName:"NDC ATPCO Tie Settings Threshold Type",dataAt:"FlightConfiguration.FlightNdcAtpcoTieSettings.ThresholdType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"FlightNdcAtpcoTieSettingsThresholdType"};var FlightNdcAtpcoTieSettingsThresholdValue={displayName:"NDC ATPCO Tie Settings Threshold Value",dataAt:"FlightConfiguration.FlightNdcAtpcoTieSettings.ThresholdValue",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,inputType:"number"}; //End FlightNdcAtpcoTieSettings
	var FlightConfigPanel={dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,tabName:"Flight-Sectors",children:[EnablePreBookSeatSelection,EnableFareCodeDisplay,DisableTravelRequirements,DisableColleagueSeatMapDisplay,EnableSharedFlightOptions,CollectContactInformationForNDCBookings,FlightPolicyDepatureWindowFrom,FlightPolicyDepatureWindowTo,OneWayFareRules,CombinableFareRules,FlightSearchWindows,FlightConfigurationRiskEngineFlightThresholdLimit,FlightExcludeAirports,FlightCorporateRateCodes,FlightModificationSettingsGrid,FlightSearchConfigurationConfigurationType,FlightSearchGrid,FlightNdcAtpcoTieSettingsApplicationType,FlightNdcAtpcoTieSettingsThresholdType,FlightNdcAtpcoTieSettingsThresholdValue,DebtorCustomAirportHubsGrid]};var FlightLimitPassengerPolicy={dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,tabName:"Flight-Limit-Passenger-Policy",children:[EnablePassengerLimit,FlightConfigurationPassengerLimit,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,html:"<h4>Debtor Identification</h4>"},LimitPassengerPolicyDebtorIdentificationType,LimitPassengerPolicyDebtorIdentificationDefinedDks,LimitPassengerPolicyDebtorIdentificationGroupCodeValue,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,html:"<h4>Udid Configurations</h4>"},UdidConfigurations,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,html:"<h4>Policy Restrictions</h4>"},LimitPassengerPolicyRestrictiontionRestrictionType,LimitPassengerPolicyRestrictionShowButNotAllowMessage,LimitPassengerPolicyRestrictionDisplayMessageTitle,LimitPassengerPolicyRestrictionDisplayMessage,LimitPassengerPolicyRestrictionSetOutOfPolicyMessage,LimitPassengerPolicyRestrictionSetOutOfPolicyListId,LimitPassengerPolicyRestrictionSetOutOfPolicyRemarkFormat]};var GroundConfigurationPanel={dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,tabName:"Ground-Sectors",children:[EnableGroundTransportationConfiguration,GroundTransportationConfigurationUiTitle,GroundTransportationConfigurationVehicleTypes,GroundTransportationCompanyReferenceMapping,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,label:"All defined Company Reference Mappings will be sent to Groundspan during the booking process."},{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,label:"GDS Setting UserDefinedValues will be ignored if Company Reference Mappings exist."}]};var Agency={dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,tabName:"Agency",children:[AgencyCreditCards,AgencyReasonDisplayName,DebtorAgencyReasonCodes,DebtorAgencyAddress,DebtorAgencyStreet,DebtorAgencyCity,DebtorAgencyState,DebtorAgencyPostcode,DebtorAgencyEmail,DebtorAgencyPhone,_componentsDebtorsAgencyVirtualCreditCardConfiguration.DebtorAgencyVirtualCreditCardConfigurations,PaymentConfigurations,HotelCarFopHandlingType,HotelCarDefinedCreditCardId,DebtorModificationAlertEmails,DebtorConfirmationAlertEmails,DebtorCancellationAlertEmails,DebtorAgencySendConfirmationToTraveler,DebtorAgencySendConfirmationToBooker,DebtorAgencyConfirmationEmailHeaderText,DebtorAgencyConfirmationEmailFooterText]};var CompanyReferencesPanel={dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,tabName:"Company-References",children:[CompanyReferencesGrid]};var PoliciesPanel={tabName:"Policies",dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,children:[ItineraryPolicies]};var ApprovalsPanel={tabName:"Approvals",dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,children:[DebtorBookingConfirmationWebHookUrl,DebtorApprovalsCommentEnabled,RestrictSelfApproval,DebtorCTMApproveStatusLookupEnabled,DebtorCTMApprovePendingRestrictModify,{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,html:"<h4>Agent Claimed Remark</h4><small>When remark text is populated User hold and approval expiry will not occur when defined remark exist in booking.</small>"},{displayName:"Agent Claimed Remark Type",dataAt:"Approvals.ApprovalClaimedRemark.RemarkType",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"RemarkType"},{displayName:"Agent Claimed Remark Text",dataAt:"Approvals.ApprovalClaimedRemark.RemarkText",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,html:"<small><i>Leave blank to not pause ticketing.</i> Remark Text can be a regular expression</small>"},{displayName:"Agent Claimed Remark Code",dataAt:"Approvals.ApprovalClaimedRemark.RemarkCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,label:"Optional value used when remark type is Alpha-Coded"},{displayName:"Debtor Agent Claimed Remark Handling",dataAt:"Approvals.ApprovalClaimedRemark.DebtorAgentClaimedRemarkHandling",displayAs:_constantsJs2['default'].DISPLAY_AS.SELECT,optionsAt:"DebtorAgentClaimedRemarkHandlingType",defaultValue:"Debtor"},DebtorApprovalRestrictionThresholdMinTitle,DebtorApprovalRestrictionThresholdMin]};var InfoPanel={dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,tabName:"Info",children:[Id,Title,DebtorName,ConsultingTeamEmail,Disabled,TestAccount,EnableNewUiHandlingType,GuestTraveller,GuestTravellerDeptCostCenterFop,GuestTravellerAllowTempCards,GuestTravellerAllowTempCardsSub,AllowArrangerFormsOfPayment,PaymentMethodDisabled,PaymentMethodSelectionMandatory,ShowCommentToTravelAgent,AdditionalTravelerInfo,CancelBookingEnabled,UserHoldEnabled,CancellationWindowMinutes,OfflinePnrEnabled,OrderNumberMandatory,OrderNumberEnabled,OrderNumberDisplayName,CostCentreMandatory,CostCentreEnabled,CostCentreDisplayName,DepartmentMandatory,DepartmentEnabled,DepartmentDisplayName,FareDebugging,ProfileCompanyIdentifier,ProfileDaytimePhoneNumber,ProfileAfterHoursPhoneNumber,ProfileIndustry,ProfileCompanySize,DebtorOrderNumberCodes,HomeCountryCode,DomesticCountryCodes,PointsOfInterestFileUploader,ShowPoiOnTop,TravellerConfigurationSource,TravellerConfigurationPcc,TravellerConfigurationGuestTravellerProfileName,TravellerConfigurationProfilePnrBuilder,TermsAndConditions,DebtorMultiPaxPnrHandlingType,MultiPaxPnrHandlingText]};var ItineraryTicketingPanel={tabName:"Booking-TAW",dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,children:[{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,label:"Configure how TAW is written to the Sabre PNR."},{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,label:"7TAW{​​PCC}​​{​​TTL Date}​​{​​Queue Number}​​/{​​TTL Time}​​/{​​Short Text}​​"},{displayName:"Include TTL Date and Time in TAW entry",dataAt:"ApplyTicketingTimeLimit",displayAs:_constantsJs2['default'].DISPLAY_AS.BOOLEAN},{displayName:"Pseudo City Code",dataAt:"TicketingPseudoCityCode",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT},{displayName:"Queue Number",dataAt:"TicketingQueue",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT},{displayName:"Taw Text - Confirmed",dataAt:"TicketingTawTextConfirmed",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT},{displayName:"Taw Text - User Hold",dataAt:"TicketingTawTextUserHold",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT},{displayName:"Taw Text - Approval",dataAt:"TicketingTawTextApproval",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT},{displayName:"Taw Text - Canceled",dataAt:"TicketingTawTextCanceled",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT},{displayName:"Taw Text - Modify",dataAt:"TicketingTawTextModify",displayAs:_constantsJs2['default'].DISPLAY_AS.TEXT_INPUT},{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,label:"Use keyword {ModifyTrans} to add the transaction info of the modification. Example: AIR HOTEL CAR"},{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,label:"TTL is derived from the stored fare"},{displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,label:"If no stored fare, TTL is calcualted using the GDS -> PCC City timezone and 24 hours from time of booking​​"}]};var DebtorRemarksTab={tabName:"Debtor-Remarks",dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,children:[AdditionalPnrUserHoldRemarks,AdditionalPnrRemarksCancel,AdditionalPnrRemarksModify,AdditionalPnrRemarks,AdditionalPnrUserHoldConfirmedRemarks,AdditionalFinishBookingRemarks,AdditionalPnrRemarksGuestTraveler,AdditionalPnrRemarksAncillary,HostCommands]};var DebtorInfoTab={tabName:"Debtor-Info",dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.GROUP,children:[DebtorSupportPhoneNumber,DebtorSupportEmailAddress,DebtorSupportCurrencyCode,DebtorAddressFirstname,DebtorAddressLastname,DebtorAddressAddress,DebtorAddressStreet,DebtorAddressCity,DebtorAddressCityCode,DebtorAddressState,DebtorAddressPostcode,DebtorAddressCountryCode]};var DebtorTabs={dataAt:"",displayAs:_constantsJs2['default'].DISPLAY_AS.TABS,children:[InfoPanel,ApprovalsPanel,PoliciesPanel,CompanyReferencesPanel,Agency,DebtorInfoTab,FlightConfigPanel,FlightLimitPassengerPolicy,UnusedTicketPanel,RailConfigPanel,HotelConfigurationPanel,GroundConfigurationPanel,AllSectorConfigPanel,MobileConfigPanel,GDSPanel,ItineraryTicketingPanel,DebtorRemarksTab,AdminPanel,DatetimeFormatPanel]};var DebtorNameLabel={dataAt:"Name",displayAs:_constantsJs2['default'].DISPLAY_AS.SUB_HEADING,label:"Name:"};var DebtorAddResource={displayAs:_constantsJs2['default'].DISPLAY_AS.ADD_GRID_RESOURCE,displayName:"Debtor",data:{Name:"",ConsultingTeamEmail:"",FlightConfiguration:{FlightPolicyDepatureWindowFrom:3,FlightPolicyDepatureWindowTo:3},HotelConfiguration:{Radius:{DefaultRadius:null}}},children:[DebtorName,ConsultingTeamEmail],endpoint:"Debtors"};var Debtor={displayName:"Debtor",displayAs:_constantsJs2['default'].DISPLAY_AS.RESOURCE,dataAt:"",iconClass:"fa-user",children:[DebtorNameLabel,DebtorTabs],endpoint:"Debtors",routeParamId:"debtorId"};var DebtorList={rootNode:true,displayName:"Debtors",endpoint:"Debtors",ODataArgs:"?$select=Id,Name,Title,ConsultingTeamEmail,Disabled",displayAs:_constantsJs2['default'].DISPLAY_AS.GRID,gridItem:Debtor,gridAdd:DebtorAddResource,canCopyResource:true,canFilterDisabled:true,disableProperty:"Disabled",iconClass:"fa-user",gridCols:[{name:"Name",key:"Name"},{name:"Title",key:"Title"},{name:"Email",key:"ConsultingTeamEmail"}]};exports['default'] = {DebtorList:DebtorList,Debtor:Debtor,DebtorAddResource:DebtorAddResource,DebtorNameLabel:DebtorNameLabel,DebtorTabs:DebtorTabs,DebtorName:DebtorName,ConsultingTeamEmail:ConsultingTeamEmail,InfoPanel:InfoPanel,ApprovalsPanel:ApprovalsPanel,PoliciesPanel:PoliciesPanel,CompanyReferencesPanel:CompanyReferencesPanel,Agency:Agency,FlightConfigPanel:FlightConfigPanel,FlightLimitPassengerPolicy:FlightLimitPassengerPolicy,RailConfigPanel:RailConfigPanel,HotelConfigurationPanel:HotelConfigurationPanel,GroundConfigurationPanel:GroundConfigurationPanel,AllSectorConfigPanel:AllSectorConfigPanel,MobileConfigPanel:MobileConfigPanel,GDSPanel:GDSPanel,UnusedTicketPanel:UnusedTicketPanel,TramadaConfigurationPanel:TramadaConfigurationPanel,AdminPanel:AdminPanel,DatetimeFormatPanel:DatetimeFormatPanel,Id:Id,Title:Title,Disabled:Disabled,TestAccount:TestAccount,FareDebugging:FareDebugging,GuestTraveller:GuestTraveller,GuestTravellerDeptCostCenterFop:GuestTravellerDeptCostCenterFop,OrderNumberMandatory:OrderNumberMandatory,OrderNumberEnabled:OrderNumberEnabled,CancelBookingEnabled:CancelBookingEnabled,OfflinePnrEnabled:OfflinePnrEnabled,OrderNumberDisplayName:OrderNumberDisplayName,CostCentreMandatory:CostCentreMandatory,CostCentreEnabled:CostCentreEnabled,CostCentreDisplayName:CostCentreDisplayName,DepartmentMandatory:DepartmentMandatory,DepartmentEnabled:DepartmentEnabled,DepartmentDisplayName:DepartmentDisplayName,PaymentMethodSelectionMandatory:PaymentMethodSelectionMandatory,DebtorSupportPhoneNumber:DebtorSupportPhoneNumber,DebtorSupportEmailAddress:DebtorSupportEmailAddress,DebtorSupportCurrencyCode:DebtorSupportCurrencyCode,DebtorAddressFirstname:DebtorAddressFirstname,DebtorAddressLastname:DebtorAddressLastname,DebtorAddressAddress:DebtorAddressAddress,DebtorAddressStreet:DebtorAddressStreet,DebtorAddressCity:DebtorAddressCity,DebtorAddressCityCode:DebtorAddressCityCode,DebtorAddressState:DebtorAddressState,DebtorAddressPostcode:DebtorAddressPostcode,DebtorAddressCountryCode:DebtorAddressCountryCode,ProfileCompanyIdentifier:ProfileCompanyIdentifier,ProfileDaytimePhoneNumber:ProfileDaytimePhoneNumber,ProfileAfterHoursPhoneNumber:ProfileAfterHoursPhoneNumber,ProfileIndustry:ProfileIndustry,ProfileCompanySize:ProfileCompanySize,AdditionalPnrRemarks:AdditionalPnrRemarks,DebtorOrderNumberCodes:DebtorOrderNumberCodes,HomeCountryCode:HomeCountryCode,DomesticCountryCodes:DomesticCountryCodes,HostCommands:HostCommands,AdditionalPnrRemarksAncillary:AdditionalPnrRemarksAncillary,PointsOfInterestFileUploader:PointsOfInterestFileUploader,ShowPoiOnTop:ShowPoiOnTop,TravellerConfigurationSource:TravellerConfigurationSource,TravellerConfigurationPcc:TravellerConfigurationPcc,TravellerConfigurationGuestTravellerProfileName:TravellerConfigurationGuestTravellerProfileName,TermsAndConditions:TermsAndConditions,DebtorMultiPaxPnrHandlingType:DebtorMultiPaxPnrHandlingType,MultiPaxPnrHandlingText:MultiPaxPnrHandlingText,DebtorBookingConfirmationWebHookUrl:DebtorBookingConfirmationWebHookUrl,DebtorApprovalsCommentEnabled:DebtorApprovalsCommentEnabled,DebtorApprovalRestrictionThresholdMinTitle:DebtorApprovalRestrictionThresholdMinTitle,DebtorApprovalRestrictionThresholdMin:DebtorApprovalRestrictionThresholdMin,DebtorCTMApproveStatusLookupEnabled:DebtorCTMApproveStatusLookupEnabled,DebtorCTMApprovePendingRestrictModify:DebtorCTMApprovePendingRestrictModify,RestrictSelfApproval:RestrictSelfApproval,ItineraryPolicies:ItineraryPolicies,CompanyReferencesGrid:CompanyReferencesGrid,AllowArrangerFormsOfPayment:AllowArrangerFormsOfPayment,AgencyCreditCards:AgencyCreditCards,AgencyReasonDisplayName:AgencyReasonDisplayName,DebtorAgencyReasonCodes:DebtorAgencyReasonCodes,DebtorAgencyAddress:DebtorAgencyAddress,DebtorAgencyStreet:DebtorAgencyStreet,DebtorAgencyCity:DebtorAgencyCity,DebtorAgencyState:DebtorAgencyState,DebtorAgencyPostcode:DebtorAgencyPostcode,DebtorAgencyEmail:DebtorAgencyEmail,DebtorModificationAlertEmails:DebtorModificationAlertEmails,DebtorConfirmationAlertEmails:DebtorConfirmationAlertEmails,DebtorCancellationAlertEmails:DebtorCancellationAlertEmails,DebtorAgencySendConfirmationToTraveler:DebtorAgencySendConfirmationToTraveler,DebtorAgencySendConfirmationToBooker:DebtorAgencySendConfirmationToBooker,DebtorAgencyConfirmationEmailHeaderText:DebtorAgencyConfirmationEmailHeaderText,DebtorAgencyConfirmationEmailFooterText:DebtorAgencyConfirmationEmailFooterText,DebtorAgencyPhone:DebtorAgencyPhone,DebtorAgencyVirtualCreditCardConfigurationsProvider:_componentsDebtorsAgencyVirtualCreditCardConfiguration.DebtorAgencyVirtualCreditCardConfigurationsProvider,DebtorAgencyVirtualCreditCardConfigurationsRegionalConsumerId:_componentsDebtorsAgencyVirtualCreditCardConfiguration.DebtorAgencyVirtualCreditCardConfigurationsRegionalConsumerId,DebtorAgencyVirtualCreditCardConfigurationsCacCode:_componentsDebtorsAgencyVirtualCreditCardConfiguration.DebtorAgencyVirtualCreditCardConfigurationsCacCode,DebtorAgencyVirtualCreditCardConfigurationsCustomNameDisplayed:_componentsDebtorsAgencyVirtualCreditCardConfiguration.DebtorAgencyVirtualCreditCardConfigurationsCustomNameDisplayed,DebtorAgencyVirtualCreditCardConfigurationsSectorTypes:_componentsDebtorsAgencyVirtualCreditCardConfiguration.DebtorAgencyVirtualCreditCardConfigurationsSectorTypes,DebtorAgencyVirtualCreditCardConfigurationsProvidersAllowed:_componentsDebtorsAgencyVirtualCreditCardConfiguration.DebtorAgencyVirtualCreditCardConfigurationsProvidersAllowed,DebtorAgencyVirtualCreditCardConfigurationsAggregatorsAllowed:_componentsDebtorsAgencyVirtualCreditCardConfiguration.DebtorAgencyVirtualCreditCardConfigurationsAggregatorsAllowed,DebtorAgencyVirtualCreditCardConfigurationsVirtualCreditCardApplicationType:_componentsDebtorsAgencyVirtualCreditCardConfiguration.DebtorAgencyVirtualCreditCardConfigurationsVirtualCreditCardApplicationType,DebtorAgencyVirtualCreditCardConfigurationsPaymentInformation:_componentsDebtorsAgencyVirtualCreditCardConfiguration.DebtorAgencyVirtualCreditCardConfigurationsPaymentInformation,DebtorAgencyVirtualCreditCardConfigurationsItem:_componentsDebtorsAgencyVirtualCreditCardConfiguration.DebtorAgencyVirtualCreditCardConfigurationsItem,DebtorAgencyVirtualCreditCardConfigurations:_componentsDebtorsAgencyVirtualCreditCardConfiguration.DebtorAgencyVirtualCreditCardConfigurations,DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldType:_componentsDebtorsAgencyVirtualCreditCardConfiguration.DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldType,DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldCode:_componentsDebtorsAgencyVirtualCreditCardConfiguration.DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldCode,DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingCustomDataKey:_componentsDebtorsAgencyVirtualCreditCardConfiguration.DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingCustomDataKey,DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingReportKey:_componentsDebtorsAgencyVirtualCreditCardConfiguration.DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingReportKey,DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingItem:_componentsDebtorsAgencyVirtualCreditCardConfiguration.DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingItem,DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappings:_componentsDebtorsAgencyVirtualCreditCardConfiguration.DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappings,DebtorAgencyVirtualCreditCardConfigurationsNotificationEmail:_componentsDebtorsAgencyVirtualCreditCardConfiguration.DebtorAgencyVirtualCreditCardConfigurationsNotificationEmail,PaymentConfigurations:PaymentConfigurations,FlightPolicyDepatureWindowFrom:FlightPolicyDepatureWindowFrom,FlightPolicyDepatureWindowTo:FlightPolicyDepatureWindowTo,UdidConfigurations:UdidConfigurations,OneWayFareRules:OneWayFareRules,CombinableFareRules:CombinableFareRules,FlightSearchWindows:FlightSearchWindows,FlightConfigurationRiskEngineFlightThresholdLimit:FlightConfigurationRiskEngineFlightThresholdLimit,FlightExcludeAirports:FlightExcludeAirports,RailConfiguration:RailConfiguration,RailSupplierSettings:RailSupplierSettings,HotelConfigurationEnableOvernightHotelPrompt:HotelConfigurationEnableOvernightHotelPrompt,HotelConfigurationIsImperialSystem:HotelConfigurationIsImperialSystem,HotelConfigurationRadiusDefaultRadius:HotelConfigurationRadiusDefaultRadius,HotelConfigurationRadiusCities:HotelConfigurationRadiusCities,HotelConfigurationPaymentNarratives:HotelConfigurationPaymentNarratives,HotelConfigurationTags:HotelConfigurationTags,HotelConfigurationAggregators:HotelConfigurationAggregators,HotelConfigurationHotelAmenityFiltersGrid:HotelConfigurationHotelAmenityFiltersGrid,EnableGroundTransportationConfiguration:EnableGroundTransportationConfiguration,GroundTransportationConfigurationUiTitle:GroundTransportationConfigurationUiTitle,GroundTransportationConfigurationVehicleTypes:GroundTransportationConfigurationVehicleTypes,GroundTransportationCompanyReferenceMapping:GroundTransportationCompanyReferenceMapping,GroundTransportationCompanyReferenceMappingItem:GroundTransportationCompanyReferenceMappingItem,GroundTransportationCompanyReferenceMappingCode:GroundTransportationCompanyReferenceMappingCode,GroundTransportationCompanyReferenceMappingFieldId:GroundTransportationCompanyReferenceMappingFieldId,DebtorLimitCountries:DebtorLimitCountries,DebtorLimitAirportClassification:DebtorLimitAirportClassification,DebtorGds:DebtorGds,UnusedTicketSettings:UnusedTicketSettings,EnableUnusedTicketDebtorSettings:EnableUnusedTicketDebtorSettings,AuthorisationHoldQueue:AuthorisationHoldQueue,AutoTicketingQueue:AutoTicketingQueue,Pcc:Pcc,PccCity:PccCity,TeamRejectionQueue:TeamRejectionQueue,CancelQueue:CancelQueue,ModificationQueue:ModificationQueue,UserHoldQueue:UserHoldQueue,TramadaConfigurationAgencyId:TramadaConfigurationAgencyId,TramadaConfigurationDebtorId:TramadaConfigurationDebtorId,TramadaConfigurationDebtorAuthCode:TramadaConfigurationDebtorAuthCode,TramadaConfigurationDatabase:TramadaConfigurationDatabase,CreatedBy:CreatedBy,CreatedOn:CreatedOn,ModifiedBy:ModifiedBy,ModifiedOn:ModifiedOn,DebtorOrderNumberCodesItem:DebtorOrderNumberCodesItem,TermsAndConditionsItem:TermsAndConditionsItem,ItineraryPoliciesItem:ItineraryPoliciesItem,CompanyReferencesGridItem:CompanyReferencesGridItem,AgencyCreditCardsItem:AgencyCreditCardsItem,DebtorAgencyReasonCodesItem:DebtorAgencyReasonCodesItem,PaymentConfigurationsItem:PaymentConfigurationsItem,OneWayFareRulesItem:OneWayFareRulesItem,CombinableFareRulesItem:CombinableFareRulesItem,FlightSearchWindowItem:FlightSearchWindowItem,RailSupplierSettingsItem:RailSupplierSettingsItem,HotelConfigurationRadiusCitiesItem:HotelConfigurationRadiusCitiesItem,HotelConfigurationPaymentNarrativesItem:HotelConfigurationPaymentNarrativesItem,HotelConfigurationHotelAmenityFiltersItem:HotelConfigurationHotelAmenityFiltersItem,DebtorGdsItem:DebtorGdsItem,LimitPassengerPolicyUdidItem:LimitPassengerPolicyUdidItem,DebtorOrderNumberCodesCode:DebtorOrderNumberCodesCode,DebtorOrderNumberCodesTitle:DebtorOrderNumberCodesTitle,TermsAndConditionsSectionType:TermsAndConditionsSectionType,TermsAndConditionsCountries:TermsAndConditionsCountries,TermsAndConditionsSegmentTypes:TermsAndConditionsSegmentTypes,TermsAndConditionsText:TermsAndConditionsText,ItineraryPoliciesCode:ItineraryPoliciesCode,ItineraryPoliciesTitle:ItineraryPoliciesTitle,ItineraryPoliciesCountries:ItineraryPoliciesCountries,ItineraryPoliciesApprovalLevel:ItineraryPoliciesApprovalLevel,ItineraryPoliciesBreakPolicyEscalationApprovalLevel:ItineraryPoliciesBreakPolicyEscalationApprovalLevel,ItineraryPoliciesTabs:ItineraryPoliciesTabs,CompanyReferencesCode:CompanyReferencesCode,CompanyReferencesTitle:CompanyReferencesTitle,CompanyReferencesPlaceHolderText:CompanyReferencesPlaceHolderText,CompanyReferencesListId:CompanyReferencesListId,CompanyReferencesOptions:CompanyReferencesOptions,CompanyReferencesFlags:CompanyReferencesFlags,CompanyReferencesMandatory:CompanyReferencesMandatory,CompanyReferencesChildren:CompanyReferencesChildren,CompanyReferencesPlacementType:CompanyReferencesPlacementType,AgencyCreditCardsItemTitle:AgencyCreditCardsItemTitle,AgencyCreditCardsItemId:AgencyCreditCardsItemId,CreditCardId:CreditCardId,SegmentTypes:SegmentTypes,AgencyCreditCardsItemCreatedBy:AgencyCreditCardsItemCreatedBy,AgencyCreditCardsItemCreatedOn:AgencyCreditCardsItemCreatedOn,AgencyCreditCardsItemModifiedBy:AgencyCreditCardsItemModifiedBy,AgencyCreditCardsItemModifiedOn:AgencyCreditCardsItemModifiedOn,DebtorAgencyReasonCodesCode:DebtorAgencyReasonCodesCode,DebtorAgencyReasonCodesTitle:DebtorAgencyReasonCodesTitle,PaymentConfigurationsProvider:PaymentConfigurationsProvider,PaymentConfigurationsPaymentTypes:PaymentConfigurationsPaymentTypes,OneWayFareRulesOrigin:OneWayFareRulesOrigin,OneWayFareRulesDestination:OneWayFareRulesDestination,CombinableFareRulesOrigin:CombinableFareRulesOrigin,CombinableFareRulesDestination:CombinableFareRulesDestination,FlightSearchWindowsIsAllDaySearch:FlightSearchWindowsIsAllDaySearch,FlightSearchWindowsFlightSearchWindowFrom:FlightSearchWindowsFlightSearchWindowFrom,FlightSearchWindowsFlightSearchWindowTo:FlightSearchWindowsFlightSearchWindowTo,FlightSearchWindowsFlightPolicyDepartureWindowFrom:FlightSearchWindowsFlightPolicyDepartureWindowFrom,FlightSearchWindowsFlightPolicyDepartureWindowTo:FlightSearchWindowsFlightPolicyDepartureWindowTo,FlightSearchWindowsOrigins:FlightSearchWindowsOrigins,FlightSearchWindowsDestinations:FlightSearchWindowsDestinations,RailSupplierSettingsName:RailSupplierSettingsName,RailSupplierSettingsCode:RailSupplierSettingsCode,RailSupplierSettingsSettings:RailSupplierSettingsSettings,HotelConfigurationRadiusCitiesCityCode:HotelConfigurationRadiusCitiesCityCode,HotelConfigurationRadiusCitiesRadius:HotelConfigurationRadiusCitiesRadius,HotelConfigurationPaymentNarrativesPaymentCode:HotelConfigurationPaymentNarrativesPaymentCode,HotelConfigurationPaymentNarrativesPaymentNarrative:HotelConfigurationPaymentNarrativesPaymentNarrative,HotelConfigurationPaymentNarrativesPaymentInstructions:HotelConfigurationPaymentNarrativesPaymentInstructions,HotelConfigurationPaymentNarrativesServiceFeeCode:HotelConfigurationPaymentNarrativesServiceFeeCode,HotelConfigurationPaymentNarrativesProviders:HotelConfigurationPaymentNarrativesProviders,HotelConfigurationPaymentNarrativesAggregators:HotelConfigurationPaymentNarrativesAggregators,HotelConfigurationPaymentNarrativesIsDomesticOnly:HotelConfigurationPaymentNarrativesIsDomesticOnly,HotelConfigurationHotelAmenityFiltersDisplayName:HotelConfigurationHotelAmenityFiltersDisplayName,HotelConfigurationHotelAmenityFiltersMostPopular:HotelConfigurationHotelAmenityFiltersMostPopular,HotelConfigurationHotelAmenityFiltersAmenities:HotelConfigurationHotelAmenityFiltersAmenities,DebtorGdsName:DebtorGdsName,DebtorGdsEnabled:DebtorGdsEnabled,DebtorGdsSettings:DebtorGdsSettings,DebtorGdsMiQuestions:DebtorGdsMiQuestions,DebtorGdsCorporateIdentifiers:DebtorGdsCorporateIdentifiers,ItineraryPoliciesGeneral:ItineraryPoliciesGeneral,ItineraryPoliciesFlight:ItineraryPoliciesFlight,ItineraryPoliciesRail:ItineraryPoliciesRail,ItineraryPoliciesHotel:ItineraryPoliciesHotel,ItineraryPoliciesCar:ItineraryPoliciesCar,ItineraryPoliciesGroundTransportation:ItineraryPoliciesGroundTransportation,CompanyReferencesChildrenItem:CompanyReferencesChildrenItem,PaymentTypesItem:PaymentTypesItem,DebtorGdsMiQuestionsItem:DebtorGdsMiQuestionsItem,DebtorGdsCorporateIdentifiersItem:DebtorGdsCorporateIdentifiersItem,DebtorApproversTravellersId:DebtorApproversTravellersId,DebtorApproversTravellersTitle:DebtorApproversTravellersTitle,DebtorApproversTravellersEmail:DebtorApproversTravellersEmail,ItineraryPoliciesItems:ItineraryPoliciesItems,ItineraryPoliciesAgencyReasonCodes:ItineraryPoliciesAgencyReasonCodes,ItineraryPoliciesMultiPaxPnrHandlingType:ItineraryPoliciesMultiPaxPnrHandlingType,ItineraryPoliciesFlightBenchmarksPolicies:ItineraryPoliciesFlightBenchmarksPolicies,ItineraryPoliciesFlightBenchmarksExceptions:ItineraryPoliciesFlightBenchmarksExceptions,ItineraryPoliciesFlightPolicies:ItineraryPoliciesFlightPolicies,ItineraryPoliciesFlightSettingsExcludedProviders:ItineraryPoliciesFlightSettingsExcludedProviders,ItineraryPoliciesFlightSettingsExcludedRates:ItineraryPoliciesFlightSettingsExcludedRates,ItineraryPoliciesFlightSettingsPolicyType:ItineraryPoliciesFlightSettingsPolicyType,ItineraryPoliciesFlightSettingsRateCodes:ItineraryPoliciesFlightSettingsRateCodes,ItineraryPoliciesFlightPolicyExceptions:ItineraryPoliciesFlightPolicyExceptions,ItineraryPoliciesFlightPolicyExceptionExcludedCarriers:ItineraryPoliciesFlightPolicyExceptionExcludedCarriers,ItineraryPoliciesFlightPolicyLeadTimeForInPolicyBooking:ItineraryPoliciesFlightPolicyLeadTimeForInPolicyBooking,ItineraryPoliciesFlightPolicyExceptionSettings:ItineraryPoliciesFlightPolicyExceptionSettings,ItineraryPoliciesFlightFlyAmericaActPolicyType:ItineraryPoliciesFlightFlyAmericaActPolicyType,ItineraryPoliciesFlightFlyAmericaPolicyEnableExcludeNonCompliantFlights:ItineraryPoliciesFlightFlyAmericaPolicyEnableExcludeNonCompliantFlights,ItineraryPoliciesFlightFlyAmericaPolicyExceptions:ItineraryPoliciesFlightFlyAmericaPolicyExceptions,ItineraryPoliciesFlightLowLogicFare:ItineraryPoliciesFlightLowLogicFare,ItineraryPoliciesFlightLowLogicFareTimeWindowType:ItineraryPoliciesFlightLowLogicFareTimeWindowType,ItineraryPoliciesFlightLowLogicFareTimeWindowDefinedType:ItineraryPoliciesFlightLowLogicFareTimeWindowDefinedType,ItineraryPoliciesFlightLowLogicFareContractType:ItineraryPoliciesFlightLowLogicFareContractType,ItineraryPoliciesFlightLowLogicFareStopType:ItineraryPoliciesFlightLowLogicFareStopType,ItineraryPoliciesFlightLowLogicFareRefundability:ItineraryPoliciesFlightLowLogicFareRefundability,ItineraryPoliciesFlightDisableFlight:ItineraryPoliciesFlightDisableFlight,ItineraryPoliciesPaidSeatsEnabledType:ItineraryPoliciesPaidSeatsEnabledType,ItineraryPoliciesRailPolicies:ItineraryPoliciesRailPolicies,ItineraryPoliciesRailPolicyExceptions:ItineraryPoliciesRailPolicyExceptions,ItineraryPoliciesRailExcludedSuppliers:ItineraryPoliciesRailExcludedSuppliers,ItineraryPoliciesHotelPolicies:ItineraryPoliciesHotelPolicies,ItineraryPoliciesHotelSettingsApplyVirtualCreditCard:ItineraryPoliciesHotelSettingsApplyVirtualCreditCard,ItineraryPoliciesHotelSettingsPolicyType:ItineraryPoliciesHotelSettingsPolicyType,ItineraryPoliciesHotelSettingsPerNightRateDisplay:ItineraryPoliciesHotelSettingsPerNightRateDisplay,ItineraryPoliciesHotelSettingsRateCodes:ItineraryPoliciesHotelSettingsRateCodes,ItineraryPoliciesHotelRateCategories:ItineraryPoliciesHotelRateCategories,ItineraryPoliciesHotelRateCategoriesCategory:ItineraryPoliciesHotelRateCategoriesCategory,ItineraryPoliciesHotelRateCategoriesPriority:ItineraryPoliciesHotelRateCategoriesPriority,ItineraryPoliciesHotelSettingsEnablePerDiemRates:ItineraryPoliciesHotelSettingsEnablePerDiemRates,ItineraryPoliciesHotelSettingsShowRatesWithinPerDiem:ItineraryPoliciesHotelSettingsShowRatesWithinPerDiem,ItineraryPoliciesHotelSettingsExcludedProviders:ItineraryPoliciesHotelSettingsExcludedProviders,ItineraryPoliciesHotelSettingsExcludedAggregators:ItineraryPoliciesHotelSettingsExcludedAggregators,ItineraryPoliciesHotelExcludedAggregatorChains:ItineraryPoliciesHotelExcludedAggregatorChains,ItineraryPoliciesHotelExcludedAggregatorChainsAggregator:ItineraryPoliciesHotelExcludedAggregatorChainsAggregator,ItineraryPoliciesHotelExcludedAggregatorChainsChains:ItineraryPoliciesHotelExcludedAggregatorChainsChains,ItineraryPoliciesHotelNoHotelPolicies:ItineraryPoliciesHotelNoHotelPolicies,ItineraryPoliciesHotelNoHotelPoliciesTitle:ItineraryPoliciesHotelNoHotelPoliciesTitle,ItineraryPoliciesHotelNoHotelPoliciesCode:ItineraryPoliciesHotelNoHotelPoliciesCode,ItineraryPoliciesHotelNoHotelPoliciesInfo:ItineraryPoliciesHotelNoHotelPoliciesInfo,ItineraryPoliciesHotelSettingsIncludedRates:ItineraryPoliciesHotelSettingsIncludedRates,ItineraryPoliciesHotelSettingsExcludedRates:ItineraryPoliciesHotelSettingsExcludedRates,ItineraryPoliciesHotelSettingsExcludeDepositRequiredAndPrepayRates:ItineraryPoliciesHotelSettingsExcludeDepositRequiredAndPrepayRates,ItineraryPoliciesHotelSettingsExcludeNonRefundableRates:ItineraryPoliciesHotelSettingsExcludeNonRefundableRates,ItineraryPoliciesHotelSettingsExcludeHotelOtherExcludedKeywords:ItineraryPoliciesHotelSettingsExcludeHotelOtherExcludedKeywords,ItineraryPoliciesHotelPolicyExceptions:ItineraryPoliciesHotelPolicyExceptions,ItineraryPoliciesHotelDefaultPolicyRateMin:ItineraryPoliciesHotelDefaultPolicyRateMin,ItineraryPoliciesHotelDefaultPolicyRateMax:ItineraryPoliciesHotelDefaultPolicyRateMax,ItineraryPoliciesHotelPolicyExceptionSettings:ItineraryPoliciesHotelPolicyExceptionSettings,ItineraryPoliciesHotelPoliciesLatLngMap:ItineraryPoliciesHotelPoliciesLatLngMap,ItineraryPoliciesCarPolicies:ItineraryPoliciesCarPolicies,ItineraryPoliciesCarTypeDuplicateHandling:ItineraryPoliciesCarTypeDuplicateHandling,ItineraryPoliciesCarSettingsShowRatesWithDeposits:ItineraryPoliciesCarSettingsShowRatesWithDeposits,ItineraryPoliciesCarSettingsRateCodes:ItineraryPoliciesCarSettingsRateCodes,ItineraryPoliciesCarSettingsExcludedProviders:ItineraryPoliciesCarSettingsExcludedProviders,ItineraryPoliciesCarSettingsExcludedRates:ItineraryPoliciesCarSettingsExcludedRates,ItineraryPoliciesCarPolicyExceptions:ItineraryPoliciesCarPolicyExceptions,ItineraryPoliciesCarPolicyExceptionSettings:ItineraryPoliciesCarPolicyExceptionSettings,ItineraryPoliciesCarPolicyPreferred:ItineraryPoliciesCarPolicyPreferred,ItineraryPoliciesCarPolicyRestriction:ItineraryPoliciesCarPolicyRestriction,ItineraryPoliciesGroundTransportationPreferredVendors:ItineraryPoliciesGroundTransportationPreferredVendors,ItineraryPoliciesGroundTransportationExcludedVendors:ItineraryPoliciesGroundTransportationExcludedVendors,ItineraryPoliciesGroundTransportationDisableGroundTransportation:ItineraryPoliciesGroundTransportationDisableGroundTransportation,ItineraryPoliciesGroundTransportationIgnoreProviderPreferred:ItineraryPoliciesGroundTransportationIgnoreProviderPreferred,CompanyReferencesChildrenMatch:CompanyReferencesChildrenMatch,CompanyReferencesChildrenCode:CompanyReferencesChildrenCode,CompanyReferencesChildrenTitle:CompanyReferencesChildrenTitle,CompanyReferencesChildrenPlaceHolderText:CompanyReferencesChildrenPlaceHolderText,CompanyReferencesChildrenListId:CompanyReferencesChildrenListId,CompanyReferencesChildrenOptions:CompanyReferencesChildrenOptions,CompanyReferencesChildrenFlags:CompanyReferencesChildrenFlags,CompanyReferencesChildrenMandatory:CompanyReferencesChildrenMandatory,PaymentConfigurationsPaymentTypesType:PaymentConfigurationsPaymentTypesType,PaymentConfigurationsPaymentTypesIsOptionalPaymentType:PaymentConfigurationsPaymentTypesIsOptionalPaymentType,PaymentConfigurationsPaymentTypesConfigurations:PaymentConfigurationsPaymentTypesConfigurations,DebtorGdsMiQuestionsItemSupplier:DebtorGdsMiQuestionsItemSupplier,DebtorGdsMiQuestionsItemQuestions:DebtorGdsMiQuestionsItemQuestions,DebtorGdsCorporateIdentifiersItemSupplierCode:DebtorGdsCorporateIdentifiersItemSupplierCode,DebtorGdsCorporateIdentifiersItemCorporateCode:DebtorGdsCorporateIdentifiersItemCorporateCode,ItineraryPoliciesItemsItem:ItineraryPoliciesItemsItem,ItineraryPoliciesFlightBenchmarksPoliciesItem:ItineraryPoliciesFlightBenchmarksPoliciesItem,ItineraryPoliciesFlightBenchmarksExceptionsItem:ItineraryPoliciesFlightBenchmarksExceptionsItem,ItineraryPoliciesFlightPoliciesItem:ItineraryPoliciesFlightPoliciesItem,ItineraryPoliciesFlightPolicyExceptionsItem:ItineraryPoliciesFlightPolicyExceptionsItem,ItineraryPoliciesFlightPolicyExceptionSettingsItem:ItineraryPoliciesFlightPolicyExceptionSettingsItem,ItineraryPoliciesLessThanXDayExceptionsItem:ItineraryPoliciesLessThanXDayExceptionsItem,ItineraryPoliciesFlightFlyAmericaPolicyExceptionsItem:ItineraryPoliciesFlightFlyAmericaPolicyExceptionsItem,ItineraryPoliciesRailPoliciesItem:ItineraryPoliciesRailPoliciesItem,ItineraryPoliciesRailPolicyExceptionsItem:ItineraryPoliciesRailPolicyExceptionsItem,ItineraryPoliciesHotelPoliciesItem:ItineraryPoliciesHotelPoliciesItem,ItineraryPoliciesHotelPolicyExceptionsItem:ItineraryPoliciesHotelPolicyExceptionsItem,ItineraryPoliciesHotelPolicyExceptionSettingsItem:ItineraryPoliciesHotelPolicyExceptionSettingsItem,ItineraryPoliciesHotelRateCategoriesItem:ItineraryPoliciesHotelRateCategoriesItem,ItineraryPoliciesHotelExcludedAggregatorChainsItem:ItineraryPoliciesHotelExcludedAggregatorChainsItem,ItineraryPoliciesHotelNoHotelPoliciesItem:ItineraryPoliciesHotelNoHotelPoliciesItem,ItineraryPoliciesCarPoliciesItem:ItineraryPoliciesCarPoliciesItem,ItineraryPoliciesCarPolicyExceptionsItem:ItineraryPoliciesCarPolicyExceptionsItem,ItineraryPoliciesCarPolicyExceptionSettingsItem:ItineraryPoliciesCarPolicyExceptionSettingsItem,ItineraryPoliciesCarPolicyPreferredItem:ItineraryPoliciesCarPolicyPreferredItem,ItineraryPoliciesCarPolicyRestrictionItem:ItineraryPoliciesCarPolicyRestrictionItem,PaymentTypesConfigurationsItem:PaymentTypesConfigurationsItem,DebtorGdsMiQuestionsItemQuestionsItem:DebtorGdsMiQuestionsItemQuestionsItem,ItineraryPoliciesItemsCode:ItineraryPoliciesItemsCode,ItineraryPoliciesItemsTitle:ItineraryPoliciesItemsTitle,ItineraryPoliciesFlightBenchmarksPoliciesCarrier:ItineraryPoliciesFlightBenchmarksPoliciesCarrier,ItineraryPoliciesFlightBenchmarksPoliciesBookingCodes:ItineraryPoliciesFlightBenchmarksPoliciesBookingCodes,ItineraryPoliciesFlightBenchmarksExceptionsCarrier:ItineraryPoliciesFlightBenchmarksExceptionsCarrier,ItineraryPoliciesFlightBenchmarksExceptionsDestinationLocationCode:ItineraryPoliciesFlightBenchmarksExceptionsDestinationLocationCode,ItineraryPoliciesFlightBenchmarksExceptionsOriginLocationCode:ItineraryPoliciesFlightBenchmarksExceptionsOriginLocationCode,ItineraryPolicyFlightWeight:ItineraryPolicyFlightWeight,ItineraryPolicyFlightWeightSub:ItineraryPolicyFlightWeightSub,ItineraryPoliciesFlightPoliciesCarrier:ItineraryPoliciesFlightPoliciesCarrier,ItineraryPoliciesFlightPoliciesBookingCodes:ItineraryPoliciesFlightPoliciesBookingCodes,ItineraryPoliciesFlightPoliciesDestinationLocationCode:ItineraryPoliciesFlightPoliciesDestinationLocationCode,ItineraryPoliciesFlightPoliciesOriginLocationCode:ItineraryPoliciesFlightPoliciesOriginLocationCode,ItineraryPoliciesFlightPoliciesOriginCountryCode:ItineraryPoliciesFlightPoliciesOriginCountryCode,ItineraryPoliciesFlightPoliciesDestinationCountryCode:ItineraryPoliciesFlightPoliciesDestinationCountryCode,ItineraryPoliciesFlightPoliciesDurationType:ItineraryPoliciesFlightPoliciesDurationType,ItineraryPoliciesFlightPoliciesDurationFrom:ItineraryPoliciesFlightPoliciesDurationFrom,ItineraryPoliciesFlightPoliciesDurationTo:ItineraryPoliciesFlightPoliciesDurationTo,ItineraryPoliciesFlightPoliciesGroupTypes:ItineraryPoliciesFlightPoliciesGroupTypes,ItineraryPoliciesFlightPoliciesFareClasses:ItineraryPoliciesFlightPoliciesFareClasses,ItineraryPoliciesFlightPoliciesBrandCodes:ItineraryPoliciesFlightPoliciesBrandCodes,ItineraryPoliciesFlightPoliciesPolicyType:ItineraryPoliciesFlightPoliciesPolicyType,ItineraryPoliciesFlightPolicyExceptionsTitle:ItineraryPoliciesFlightPolicyExceptionsTitle,ItineraryPoliciesFlightPolicyExceptionsCode:ItineraryPoliciesFlightPolicyExceptionsCode,ItineraryPoliciesFlightPolicyExceptionsCountries:ItineraryPoliciesFlightPolicyExceptionsCountries,ItineraryPoliciesFlightPolicyExceptionSettingsOriginCountryCode:ItineraryPoliciesFlightPolicyExceptionSettingsOriginCountryCode,ItineraryPoliciesFlightPolicyExceptionSettingsDestinationCountryCode:ItineraryPoliciesFlightPolicyExceptionSettingsDestinationCountryCode,ItineraryPoliciesFlightPolicyExceptionSettingsDurationFrom:ItineraryPoliciesFlightPolicyExceptionSettingsDurationFrom,ItineraryPoliciesFlightPolicyExceptionSettingsDurationTo:ItineraryPoliciesFlightPolicyExceptionSettingsDurationTo,ItineraryPoliciesFlightPolicyExceptionSettingsGroupTypes:ItineraryPoliciesFlightPolicyExceptionSettingsGroupTypes,ItineraryPoliciesFlightPolicyExceptionSettingsPriceTolerance:ItineraryPoliciesFlightPolicyExceptionSettingsPriceTolerance,ItineraryPoliciesFlightPolicyExceptionSettingsPriceToleranceType:ItineraryPoliciesFlightPolicyExceptionSettingsPriceToleranceType,ItineraryPoliciesFlightPolicyExceptionSettingsLowestFareGroupType:ItineraryPoliciesFlightPolicyExceptionSettingsLowestFareGroupType,ItineraryPoliciesFlightPolicyExceptionSettingsFlightType:ItineraryPoliciesFlightPolicyExceptionSettingsFlightType,ItineraryPoliciesFlightPolicyExceptionSettingsBenchmarkMostDirect:ItineraryPoliciesFlightPolicyExceptionSettingsBenchmarkMostDirect,ItineraryPoliciesRailPoliciesSuppliers:ItineraryPoliciesRailPoliciesSuppliers,ItineraryPoliciesRailPoliciesCorporateCode:ItineraryPoliciesRailPoliciesCorporateCode,ItineraryPoliciesRailPoliciesPolicyType:ItineraryPoliciesRailPoliciesPolicyType,ItineraryPoliciesRailPoliciesGroupTypes:ItineraryPoliciesRailPoliciesGroupTypes,ItineraryPoliciesRailPolicyExceptionsTitle:ItineraryPoliciesRailPolicyExceptionsTitle,ItineraryPoliciesRailPolicyExceptionsCode:ItineraryPoliciesRailPolicyExceptionsCode,ItineraryPoliciesRailPolicyExceptionsCountries:ItineraryPoliciesRailPolicyExceptionsCountries,ItineraryPoliciesRailDisableRail:ItineraryPoliciesRailDisableRail,ItineraryPoliciesHotelPoliciesPolicyName:ItineraryPoliciesHotelPoliciesPolicyName,ItineraryPoliciesHotelDisableHotel:ItineraryPoliciesHotelDisableHotel,ItineraryPoliciesHotelPoliciesMostPreferredHotels:ItineraryPoliciesHotelPoliciesMostPreferredHotels,ItineraryPoliciesHotelPoliciesMostPreferredChainCodes:ItineraryPoliciesHotelPoliciesMostPreferredChainCodes,ItineraryPoliciesHotelPoliciesHighlyPreferredHotels:ItineraryPoliciesHotelPoliciesHighlyPreferredHotels,ItineraryPoliciesHotelPoliciesHighlyPreferredChainCodes:ItineraryPoliciesHotelPoliciesHighlyPreferredChainCodes,ItineraryPoliciesHotelPoliciesHotels:ItineraryPoliciesHotelPoliciesHotels,ItineraryPoliciesHotelPoliciesChainCodes:ItineraryPoliciesHotelPoliciesChainCodes,ItineraryPoliciesHotelPoliciesRateMin:ItineraryPoliciesHotelPoliciesRateMin,ItineraryPoliciesHotelPoliciesRateMax:ItineraryPoliciesHotelPoliciesRateMax,ItineraryPoliciesHotelPoliciesLocationCode:ItineraryPoliciesHotelPoliciesLocationCode,ItineraryPoliciesHotelPoliciesCountryCode:ItineraryPoliciesHotelPoliciesCountryCode,ItineraryPoliciesHotelPoliciesPostCode:ItineraryPoliciesHotelPoliciesPostCode,ItineraryPoliciesHotelPoliciesMinimumHotelRating:ItineraryPoliciesHotelPoliciesMinimumHotelRating,ItineraryPoliciesHotelPoliciesExcludedChainCodes:ItineraryPoliciesHotelPoliciesExcludedChainCodes,ItineraryPoliciesHotelPoliciesExcludedHotels:ItineraryPoliciesHotelPoliciesExcludedHotels,ItineraryPoliciesHotelPoliciesRadius:ItineraryPoliciesHotelPoliciesRadius,ItineraryPoliciesHotelPoliciesLatitude:ItineraryPoliciesHotelPoliciesLatitude,ItineraryPoliciesHotelPoliciesLongitude:ItineraryPoliciesHotelPoliciesLongitude,ItineraryPoliciesHotelPoliciesLatLong:ItineraryPoliciesHotelPoliciesLatLong,ItineraryPoliciesHotelPolicyExceptionsTitle:ItineraryPoliciesHotelPolicyExceptionsTitle,ItineraryPoliciesHotelPolicyExceptionsCode:ItineraryPoliciesHotelPolicyExceptionsCode,ItineraryPoliciesHotelPolicyExceptionsCountries:ItineraryPoliciesHotelPolicyExceptionsCountries,ItineraryPoliciesHotelPolicyExceptionSettingsName:ItineraryPoliciesHotelPolicyExceptionSettingsName,ItineraryPoliciesHotelPolicyExceptionSettingsLocationCode:ItineraryPoliciesHotelPolicyExceptionSettingsLocationCode,ItineraryPoliciesHotelPolicyExceptionSettingsAirportCodes:ItineraryPoliciesHotelPolicyExceptionSettingsAirportCodes,ItineraryPoliciesHotelPolicyExceptionSettingsHotelIDs:ItineraryPoliciesHotelPolicyExceptionSettingsHotelIDs,ItineraryPoliciesHotelPolicyExceptionSettingsCountryCode:ItineraryPoliciesHotelPolicyExceptionSettingsCountryCode,ItineraryPoliciesHotelPolicyExceptionSettingsMaximumDailyRate:ItineraryPoliciesHotelPolicyExceptionSettingsMaximumDailyRate,ItineraryPoliciesHotelPolicyExceptionSettingsPriceTolerance:ItineraryPoliciesHotelPolicyExceptionSettingsPriceTolerance,ItineraryPoliciesHotelPolicyExceptionSettingsPriceToleranceType:ItineraryPoliciesHotelPolicyExceptionSettingsPriceToleranceType,ItineraryPoliciesHotelPolicyExceptionSettingsRadius:ItineraryPoliciesHotelPolicyExceptionSettingsRadius,ItineraryPoliciesHotelPolicyExceptionSettingsLatitude:ItineraryPoliciesHotelPolicyExceptionSettingsLatitude,ItineraryPoliciesHotelPolicyExceptionSettingsLongitude:ItineraryPoliciesHotelPolicyExceptionSettingsLongitude,ItineraryPoliciesHotelPolicyExceptionSettingsLatLong:ItineraryPoliciesHotelPolicyExceptionSettingsLatLong,ItineraryPoliciesCarPoliciesName:ItineraryPoliciesCarPoliciesName,ItineraryPoliciesCarPoliciesBillingReference:ItineraryPoliciesCarPoliciesBillingReference,ItineraryPoliciesCarPoliciesUseCompanyRefCodeForBillingRef:ItineraryPoliciesCarPoliciesUseCompanyRefCodeForBillingRef,ItineraryPoliciesCarPoliciesUseCompanyRefCodeForBillingRefSub:ItineraryPoliciesCarPoliciesUseCompanyRefCodeForBillingRefSub,ItineraryPoliciesCarDisableCar:ItineraryPoliciesCarDisableCar,ItineraryPoliciesCarPoliciesSupplierCode:ItineraryPoliciesCarPoliciesSupplierCode,ItineraryPoliciesCarPoliciesSupplierTitle:ItineraryPoliciesCarPoliciesSupplierTitle,ItineraryPoliciesCarPoliciesCorporateCode:ItineraryPoliciesCarPoliciesCorporateCode,ItineraryPoliciesCarPoliciesGuaranteeText:ItineraryPoliciesCarPoliciesGuaranteeText,ItineraryPoliciesCarPoliciesDebtorRateOverTravelerId:ItineraryPoliciesCarPoliciesDebtorRateOverTravelerId,ItineraryPoliciesCarPoliciesRate:ItineraryPoliciesCarPoliciesRate,ItineraryPoliciesCarPoliciesDepartments:ItineraryPoliciesCarPoliciesDepartments,ItineraryPoliciesCarPoliciesCostCentres:ItineraryPoliciesCarPoliciesCostCentres,ItineraryPoliciesCarPoliciesAllowDeliveryAndCollection:ItineraryPoliciesCarPoliciesAllowDeliveryAndCollection,ItineraryPoliciesCarPolicyExceptionsTitle:ItineraryPoliciesCarPolicyExceptionsTitle,ItineraryPoliciesCarPolicyExceptionsCode:ItineraryPoliciesCarPolicyExceptionsCode,ItineraryPoliciesCarPolicyExceptionsCountries:ItineraryPoliciesCarPolicyExceptionsCountries,ItineraryPoliciesCarPolicyExceptionSettingsLocationCode:ItineraryPoliciesCarPolicyExceptionSettingsLocationCode,ItineraryPoliciesCarPolicyExceptionSettingsCountryCode:ItineraryPoliciesCarPolicyExceptionSettingsCountryCode,ItineraryPoliciesCarPolicyExceptionSettingsSupplierCode:ItineraryPoliciesCarPolicyExceptionSettingsSupplierCode,ItineraryPoliciesCarPolicyExceptionSettingsMaximumDailyRate:ItineraryPoliciesCarPolicyExceptionSettingsMaximumDailyRate,ItineraryPoliciesCarPolicyExceptionSettingsLocationCodes:ItineraryPoliciesCarPolicyExceptionSettingsLocationCodes,ItineraryPoliciesCarPolicyExceptionSettingsCountryCodes:ItineraryPoliciesCarPolicyExceptionSettingsCountryCodes,ItineraryPoliciesCarPolicyExceptionSettingsSuppliers:ItineraryPoliciesCarPolicyExceptionSettingsSuppliers,ItineraryPoliciesCarPolicyExceptionSettingsSipps:ItineraryPoliciesCarPolicyExceptionSettingsSipps,ItineraryPoliciesCarPolicyPreferredSuppliers:ItineraryPoliciesCarPolicyPreferredSuppliers,ItineraryPoliciesCarPolicyPreferredLocationCodes:ItineraryPoliciesCarPolicyPreferredLocationCodes,ItineraryPoliciesCarPolicyPreferredCountryCodes:ItineraryPoliciesCarPolicyPreferredCountryCodes,ItineraryPoliciesCarPolicyPreferredSipps:ItineraryPoliciesCarPolicyPreferredSipps,ItineraryPoliciesCarPolicyRestrictionSuppliers:ItineraryPoliciesCarPolicyRestrictionSuppliers,ItineraryPoliciesCarPolicyRestrictionLocationCodes:ItineraryPoliciesCarPolicyRestrictionLocationCodes,ItineraryPoliciesCarPolicyRestrictionCountryCodes:ItineraryPoliciesCarPolicyRestrictionCountryCodes,ItineraryPoliciesCarPolicyRestrictionSipps:ItineraryPoliciesCarPolicyRestrictionSipps,ItineraryPoliciesCarPolicyRestrictionMaximumDailyRate:ItineraryPoliciesCarPolicyRestrictionMaximumDailyRate,ItineraryPoliciesCarPolicyRestrictionPolicyType:ItineraryPoliciesCarPolicyRestrictionPolicyType,PaymentConfigurationsPaymentTypesConfigurationsSector:PaymentConfigurationsPaymentTypesConfigurationsSector,PaymentConfigurationsPaymentTypesConfigurationsSuppliers:PaymentConfigurationsPaymentTypesConfigurationsSuppliers,DebtorGdsMiQuestionsItemQuestionsItemQuestion:DebtorGdsMiQuestionsItemQuestionsItemQuestion,DebtorGdsMiQuestionsItemQuestionsItemAnswerFormat:DebtorGdsMiQuestionsItemQuestionsItemAnswerFormat,PaymentConfigurationsPaymentTypesConfigurationsSuppliersItem:PaymentConfigurationsPaymentTypesConfigurationsSuppliersItem,PaymentConfigurationsPaymentTypesConfigurationsSuppliersName:PaymentConfigurationsPaymentTypesConfigurationsSuppliersName,PaymentConfigurationsPaymentTypesConfigurationsSuppliersSettings:PaymentConfigurationsPaymentTypesConfigurationsSuppliersSettings,EnableCarAiRecommendation:EnableCarAiRecommendation,EnableHotelAiRecommendation:EnableHotelAiRecommendation,CompanyReferencesItemsItem:CompanyReferencesItemsItem,DebtorGdsPassiveFlightSegmentRemarkTemplate:DebtorGdsPassiveFlightSegmentRemarkTemplate,EnableHonoluluTripFeed:EnableHonoluluTripFeed,HotelCarFopHandlingType:HotelCarFopHandlingType,HotelCarDefinedCreditCardId:HotelCarDefinedCreditCardId,DebtorRemarksTab:DebtorRemarksTab,DebtorInfoTab:DebtorInfoTab,EnableModificationCar:EnableModificationCar,EnableModificationHotel:EnableModificationHotel,EnableModificationAir:EnableModificationAir,EnableModificationGround:EnableModificationGround,EnableModificationRail:EnableModificationRail,EnableItineraryValidatorDebtorSettings:EnableItineraryValidatorDebtorSettings,ItineraryValidatorSettings:ItineraryValidatorSettings,BookingThreshold:BookingThreshold,FlightCorporateRateCodes:FlightCorporateRateCodes,FlightCorporateRateCodeItem:FlightCorporateRateCodeItem,FlightCorporateRateCodeCarriers:FlightCorporateRateCodeCarriers,FlightCorporateRateCode:FlightCorporateRateCode,FlightCorporateRateCodeGdsProviders:FlightCorporateRateCodeGdsProviders,FlightCorporateRateCodeType:FlightCorporateRateCodeType,FlightCorporateRateCodeValue:FlightCorporateRateCodeValue,ItineraryPoliciesFlightEnableAncillaryFees:ItineraryPoliciesFlightEnableAncillaryFees,ItineraryPoliciesFlightAncillaryFeeCodes:ItineraryPoliciesFlightAncillaryFeeCodes,DebtorFlightModificationSettingItem:DebtorFlightModificationSettingItem,DebtorFlightSearchConfigurationItem:DebtorFlightSearchConfigurationItem,LimitPassengerPolicyUdidConfigurationType:LimitPassengerPolicyUdidConfigurationType,ItineraryPoliciesProfileAttributeSourceType:_componentsDebtorsProfileAttribute.ItineraryPoliciesProfileAttributeSourceType,ItineraryPoliciesProfileAttributesItem:_componentsDebtorsProfileAttribute.ItineraryPoliciesProfileAttributesItem,ItineraryPoliciesProfileAttributesItems:_componentsDebtorsProfileAttribute.ItineraryPoliciesProfileAttributesItems,ItineraryPolicyEnhancedPolicyRulesConditionsItem:_componentsDebtorsProfileAttribute.ItineraryPolicyEnhancedPolicyRulesConditionsItem,ItineraryPolicyEnhancedPolicyRulesConditions:_componentsDebtorsProfileAttribute.ItineraryPolicyEnhancedPolicyRulesConditions,DebtorCustomAirportHubsItem:DebtorCustomAirportHubsItem,DebtorCustomAirportHubName:DebtorCustomAirportHubName,DebtorCustomAirportHubAirports:DebtorCustomAirportHubAirports};module.exports = exports['default'];

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var DebtorAgencyVirtualCreditCardConfigurationsProvider = {
	  displayName: "Virtual Payment Provider",
	  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.VirtualPaymentProvider",
	  optionsAt: "AgencyVirtualPaymentProviderType",
	  defaultValue: "ConfermaPay",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  required: true
	};
	
	exports.DebtorAgencyVirtualCreditCardConfigurationsProvider = DebtorAgencyVirtualCreditCardConfigurationsProvider;
	var DebtorAgencyVirtualCreditCardConfigurationsRegionalConsumerId = {
	  displayName: "Regional Credentials Identifier (Consumer)",
	  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.RegionalConsumerId",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  required: false
	};
	
	exports.DebtorAgencyVirtualCreditCardConfigurationsRegionalConsumerId = DebtorAgencyVirtualCreditCardConfigurationsRegionalConsumerId;
	var DebtorAgencyVirtualCreditCardConfigurationsCacCode = {
	  displayName: "CAC code",
	  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.CacCode",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	exports.DebtorAgencyVirtualCreditCardConfigurationsCacCode = DebtorAgencyVirtualCreditCardConfigurationsCacCode;
	var DebtorAgencyVirtualCreditCardConfigurationsCustomNameDisplayed = {
	  displayName: "Custom name to be displayed",
	  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.CustomNameDisplayed",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	exports.DebtorAgencyVirtualCreditCardConfigurationsCustomNameDisplayed = DebtorAgencyVirtualCreditCardConfigurationsCustomNameDisplayed;
	var DebtorAgencyVirtualCreditCardConfigurationsSectorTypes = {
	  displayName: "Sector Types",
	  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.SectorTypes",
	  optionsAt: "AgencySectorTypes",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.MULTI_SELECT
	};
	
	exports.DebtorAgencyVirtualCreditCardConfigurationsSectorTypes = DebtorAgencyVirtualCreditCardConfigurationsSectorTypes;
	var DebtorAgencyVirtualCreditCardConfigurationsProvidersAllowed = {
	  displayName: "Providers Allowed",
	  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.ProvidersAllowed",
	  optionsAt: "GDSProviders",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.MULTI_SELECT,
	  label: "If empty then all providers are allowed"
	};
	
	exports.DebtorAgencyVirtualCreditCardConfigurationsProvidersAllowed = DebtorAgencyVirtualCreditCardConfigurationsProvidersAllowed;
	var DebtorAgencyVirtualCreditCardConfigurationsAggregatorsAllowed = {
	  displayName: "Aggregators Allowed",
	  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.AggregatorsAllowed",
	  optionsAt: "AggregatorsAllowed",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.O_DATA_SELECT,
	  endpoint: "Settings",
	  queryOption: "select",
	  selectProperty: "HotelRateCategories",
	  inputTitle: "Name",
	  selectChoiceName: "Name",
	  entityIdentifier: "Name",
	  searchAllNo: true,
	  isMultiSelect: true,
	  additionalFilters: {
	    "IsAggregator": true
	  },
	  showOnlySelectedField: true,
	  label: "If empty then all aggregators are allowed"
	};
	
	exports.DebtorAgencyVirtualCreditCardConfigurationsAggregatorsAllowed = DebtorAgencyVirtualCreditCardConfigurationsAggregatorsAllowed;
	var DebtorAgencyVirtualCreditCardConfigurationsVirtualCreditCardApplicationType = {
	  displayName: "Apply Virtual Credit Card",
	  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.VirtualCreditCardApplicationType",
	  optionsAt: "AgencyApplyVirtualCreditCardType",
	  defaultValue: "Disable",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  required: true
	};
	
	exports.DebtorAgencyVirtualCreditCardConfigurationsVirtualCreditCardApplicationType = DebtorAgencyVirtualCreditCardConfigurationsVirtualCreditCardApplicationType;
	var DebtorAgencyVirtualCreditCardConfigurationsPaymentInformation = {
	  displayName: "Payment Information",
	  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.PaymentInformation",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  maxLength: 200,
	  validationRegex: "^[\" %$@£&;!+[\\]'¬`\\~|=^*/}\{)(?:#\\w,\.\-\<\>]*$",
	  validationMessage: "There are invalid characters"
	};
	
	exports.DebtorAgencyVirtualCreditCardConfigurationsPaymentInformation = DebtorAgencyVirtualCreditCardConfigurationsPaymentInformation;
	var DebtorAgencyVirtualCreditCardConfigurationsNotificationEmail = {
	  displayName: "Notification Email",
	  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.NotificationEmail",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  inputType: "email",
	  required: false
	};
	
	exports.DebtorAgencyVirtualCreditCardConfigurationsNotificationEmail = DebtorAgencyVirtualCreditCardConfigurationsNotificationEmail;
	var DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldType = {
	  displayName: "Source Field Type",
	  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.CompanyReferenceMappings.$companyReferenceItem.SourceField.Type",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "SourceFieldType"
	};
	
	exports.DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldType = DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldType;
	var DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldCode = {
	  displayName: "Source Field Code",
	  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.CompanyReferenceMappings.$companyReferenceItem.SourceField.Code",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	exports.DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldCode = DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldCode;
	var DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldCodeSub = {
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SUB_HEADING,
	  label: "Source field code should only be populated if the source field type is Company Reference."
	};
	
	var DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingCustomDataKey = {
	  displayName: "Custom Data Key",
	  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.CompanyReferenceMappings.$companyReferenceItem.CustomDataKey",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	exports.DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingCustomDataKey = DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingCustomDataKey;
	var DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingReportKey = {
	  displayName: "Report Key",
	  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.CompanyReferenceMappings.$companyReferenceItem.ReportKey",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	exports.DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingReportKey = DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingReportKey;
	var DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingItem = {
	  displayName: "Item",
	  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.CompanyReferenceMappings.$companyReferenceItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldType, DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldCode, DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldCodeSub, DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingCustomDataKey, DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingReportKey],
	  endpoint: "Debtors",
	  routeParamId: "debtorId",
	  removeParamId: "companyReferenceItem",
	  canDelete: true
	};
	
	exports.DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingItem = DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingItem;
	var DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMapping = {
	  displayName: "Company Reference Mappings",
	  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.CompanyReferenceMappings",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canAddNew: true,
	  gridItem: DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingItem,
	  gridCols: [{ name: "Source Field Type", key: "SourceField.Type" }, { name: "Source Field Code", key: "SourceField.Code" }, { name: "Custom Data Key", key: "CustomDataKey" }, { name: "Report Key", key: "ReportKey" }]
	};
	
	exports.DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMapping = DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMapping;
	var DebtorAgencyVirtualCreditCardConfigurationsItem = {
	  displayName: "Virtual Credit Card Configuration Item",
	  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [DebtorAgencyVirtualCreditCardConfigurationsProvider, DebtorAgencyVirtualCreditCardConfigurationsRegionalConsumerId, DebtorAgencyVirtualCreditCardConfigurationsCacCode, DebtorAgencyVirtualCreditCardConfigurationsCustomNameDisplayed, DebtorAgencyVirtualCreditCardConfigurationsSectorTypes, DebtorAgencyVirtualCreditCardConfigurationsProvidersAllowed, DebtorAgencyVirtualCreditCardConfigurationsAggregatorsAllowed, DebtorAgencyVirtualCreditCardConfigurationsVirtualCreditCardApplicationType, DebtorAgencyVirtualCreditCardConfigurationsPaymentInformation, DebtorAgencyVirtualCreditCardConfigurationsNotificationEmail, DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMapping],
	  endpoint: "Debtors",
	  routeParamId: "debtorId",
	  removeParamId: "virtualCCConfig",
	  canDelete: true
	};
	
	exports.DebtorAgencyVirtualCreditCardConfigurationsItem = DebtorAgencyVirtualCreditCardConfigurationsItem;
	var DebtorAgencyVirtualCreditCardConfigurations = {
	  displayName: "Virtual Credit Card Configuration",
	  dataAt: "DebtorAgencyVirtualCreditCardConfigurations",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: DebtorAgencyVirtualCreditCardConfigurationsItem,
	  gridCols: [{
	    name: "Provider",
	    key: "VirtualPaymentProvider"
	  }, {
	    name: "CAC Code",
	    key: "CacCode"
	  }, {
	    name: "Custom Name",
	    key: "CustomNameDisplayed"
	  }, {
	    name: "Sector",
	    key: "SectorTypesInfo"
	  }]
	};
	exports.DebtorAgencyVirtualCreditCardConfigurations = DebtorAgencyVirtualCreditCardConfigurations;

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var _formsConditionsJs = __webpack_require__(457);
	
	var conditionsDataAtValue = "ItineraryPolicies.$ItinPolIndex.ProfileAttributes.$ItinPolProfileAttributesItemIndex.";
	var routeParamId = "debtorId";
	var endpoint = "Debtors";
	
	var ItineraryPolicyEnhancedPolicyRulesConditionsItem = (0, _formsConditionsJs.EnhancedPolicyRulesConditionsItemFn)(conditionsDataAtValue, routeParamId, endpoint);
	exports.ItineraryPolicyEnhancedPolicyRulesConditionsItem = ItineraryPolicyEnhancedPolicyRulesConditionsItem;
	var ItineraryPolicyEnhancedPolicyRulesConditions = (0, _formsConditionsJs.EnhancedPolicyRulesConditionsFn)(conditionsDataAtValue);
	
	exports.ItineraryPolicyEnhancedPolicyRulesConditions = ItineraryPolicyEnhancedPolicyRulesConditions;
	var ItineraryPoliciesProfileAttributeSourceType = {
	  displayName: "Profile Attribute Type",
	  dataAt: "ItineraryPolicies.$ItinPolIndex.ProfileAttributes.$ItinPolProfileAttributesItemIndex.ProfileSource",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "ProfileAttributeSourceType"
	};
	
	exports.ItineraryPoliciesProfileAttributeSourceType = ItineraryPoliciesProfileAttributeSourceType;
	var ItineraryPoliciesProfileAttributesItem = {
	  displayName: "Profile Attribute",
	  dataAt: "ItineraryPolicies.$ItinPolIndex.ProfileAttributes.$ItinPolProfileAttributesItemIndex",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [ItineraryPoliciesProfileAttributeSourceType, ItineraryPolicyEnhancedPolicyRulesConditions],
	  endpoint: endpoint,
	  routeParamId: routeParamId,
	  removeParamId: "ItinPolProfileAttributesItemIndex",
	  canDelete: true
	};
	
	exports.ItineraryPoliciesProfileAttributesItem = ItineraryPoliciesProfileAttributesItem;
	var ItineraryPoliciesProfileAttributesItems = {
	  displayName: "Profile Attributes",
	  dataAt: "ItineraryPolicies.$ItinPolIndex.ProfileAttributes",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  copyWithoutCopyText: true,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: ItineraryPoliciesProfileAttributesItem,
	  gridCols: [{ name: "Profile Source Type", key: "ProfileSource" }, { name: "Info", key: "ConditionInfo" }]
	};
	exports.ItineraryPoliciesProfileAttributesItems = ItineraryPoliciesProfileAttributesItems;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var EnhancedPolicyRulesConditionsCollectionOperationTypeFn = function EnhancedPolicyRulesConditionsCollectionOperationTypeFn(dataAt) {
	    return {
	        displayName: "Collection Operation Type",
	        dataAt: (dataAt || "") + "Conditions.$EnhancedPolicyRulesConditionsItem.CollectionOperationType",
	        optionsAt: "CollectionOperationType",
	        required: true,
	        displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	        defaultValue: "None",
	        helpText: "When working with a collection. If you need to count the number of items or sum the items then you use this field."
	    };
	};
	
	exports.EnhancedPolicyRulesConditionsCollectionOperationTypeFn = EnhancedPolicyRulesConditionsCollectionOperationTypeFn;
	var EnhancedPolicyRulesConditionsIsExpressionFn = function EnhancedPolicyRulesConditionsIsExpressionFn(dataAt) {
	    return {
	        displayName: "Evaluate as a mathmatical expression?",
	        dataAt: (dataAt || "") + "Conditions.$EnhancedPolicyRulesConditionsItem.IsExpression",
	        displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN,
	        helpText: "For example, format returns 2+2. The value when returned using an expression will be 4."
	    };
	};
	
	exports.EnhancedPolicyRulesConditionsIsExpressionFn = EnhancedPolicyRulesConditionsIsExpressionFn;
	var EnhancedPolicyRulesConditionsIsCollectionFn = function EnhancedPolicyRulesConditionsIsCollectionFn(dataAt) {
	    return {
	        displayName: "Is Collection?",
	        dataAt: (dataAt || "") + "Conditions.$EnhancedPolicyRulesConditionsItem.IsCollection",
	        displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN,
	        helpText: "Does the source format return more than one value? If so mark as a collection."
	    };
	};
	
	exports.EnhancedPolicyRulesConditionsIsCollectionFn = EnhancedPolicyRulesConditionsIsCollectionFn;
	var EnhancedPolicyRulesConditionsOperatorTypeFn = function EnhancedPolicyRulesConditionsOperatorTypeFn(dataAt) {
	    return {
	        displayName: "Operator Type",
	        dataAt: (dataAt || "") + "Conditions.$EnhancedPolicyRulesConditionsItem.OperatorType",
	        optionsAt: "OperatorType",
	        required: true,
	        displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	        defaultValue: "Equals",
	        html: "Contains and NotContains with two values has a special range validation. <br/> " + "Example Contains with values 1 and 10 will validate that Source Format is a value of >=1 and <=10. <br/> " + "Range will apply to all Type string and numbers."
	    };
	};
	
	exports.EnhancedPolicyRulesConditionsOperatorTypeFn = EnhancedPolicyRulesConditionsOperatorTypeFn;
	var EnhancedPolicyRulesConditionsSourceFormatFn = function EnhancedPolicyRulesConditionsSourceFormatFn(dataAt) {
	    return {
	        displayName: "Source Format",
	        dataAt: (dataAt || "") + "Conditions.$EnhancedPolicyRulesConditionsItem.SourceFormat",
	        displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	    };
	};
	
	exports.EnhancedPolicyRulesConditionsSourceFormatFn = EnhancedPolicyRulesConditionsSourceFormatFn;
	var EnhancedPolicyRulesConditionsConditionTypeFn = function EnhancedPolicyRulesConditionsConditionTypeFn(dataAt) {
	    return {
	        displayName: "Type",
	        dataAt: (dataAt || "") + "Conditions.$EnhancedPolicyRulesConditionsItem.Type",
	        optionsAt: "ConditionType",
	        required: true,
	        displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	        defaultValue: "String"
	    };
	};
	
	exports.EnhancedPolicyRulesConditionsConditionTypeFn = EnhancedPolicyRulesConditionsConditionTypeFn;
	var EnhancedPolicyRulesConditionsValuesFn = function EnhancedPolicyRulesConditionsValuesFn(dataAt) {
	    return {
	        displayName: "Values",
	        dataAt: (dataAt || "") + "Conditions.$EnhancedPolicyRulesConditionsItem.Values",
	        displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	    };
	};
	
	exports.EnhancedPolicyRulesConditionsValuesFn = EnhancedPolicyRulesConditionsValuesFn;
	var EnhancedPolicyRulesConditionsItemFn = function EnhancedPolicyRulesConditionsItemFn(dataAt) {
	    var routeParamId = arguments.length <= 1 || arguments[1] === undefined ? "enhancedPolicyRulesId" : arguments[1];
	    var endpoint = arguments.length <= 2 || arguments[2] === undefined ? "EnhancedPolicyRules" : arguments[2];
	    return {
	        displayName: "Conditions",
	        dataAt: (dataAt || "") + "Conditions.$EnhancedPolicyRulesConditionsItem",
	        displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	        children: [EnhancedPolicyRulesConditionsSourceFormatFn(dataAt), EnhancedPolicyRulesConditionsIsExpressionFn(dataAt), EnhancedPolicyRulesConditionsIsCollectionFn(dataAt), EnhancedPolicyRulesConditionsCollectionOperationTypeFn(dataAt), EnhancedPolicyRulesConditionsOperatorTypeFn(dataAt), EnhancedPolicyRulesConditionsValuesFn(dataAt), {
	            displayAs: _constantsJs2["default"].DISPLAY_AS.SUB_HEADING,
	            html: "<b>Format</b can be entered in Values but you must include the full format unlike the Source Format where currly brackets are automatically added.<br/>" + "<div class='htmlmarkup-indent'>Example: {Flight.ArrivalDateTime.Date}<br/>" + "Example Array:  {Flight.ConnectingFlights:{Carrier}|##split##}<br/></div>" + "<b>Named List</b><div class='htmlmarkup-indent'>Named list can be entered as a value. Append ~ to the beginning and end to annotate a named list. <br/>Example: ~CountriesOfConcern~</div>"
	        }, EnhancedPolicyRulesConditionsConditionTypeFn(dataAt), {
	            displayAs: _constantsJs2["default"].DISPLAY_AS.SUB_HEADING,
	            html: "Enhanced Policy uses SmartFormat to build a conditional statement<br/>" + "See the data dictionary on <a href=\"https://trvlcorp.sharepoint.com/sites/ctmna-Technology/SitePages/Lightning-Enhanced-Policy.aspx\" target=\"_blank\">SharePoint: Lightning-Enhanced-Policy</a><br/>" + "SmartFormat Wiki: <a href=\"https://github.com/axuno/SmartFormat/wiki\" target=\"_blank\">github.com/axuno/SmartFormat/wiki</a>" + ""
	        }, {
	            displayAs: _constantsJs2["default"].DISPLAY_AS.SUB_HEADING,
	            html: "<b>Some fields are only available for certain rules.</b><br/>" + "<ul>" + "<li>SearchCritera, Fare and Flight are fields used in fare validations like Exclude Fare, Show But Not Allow or Exclude From LLF</li>" + "<li>Flights, Cars, Hotels, Rails, Grounds are properties used in Form of Payment rules</li>" + "<li>CurrentDate, Itinerary, Passenger and User are available for all rules</li>" + "</ul>" + ""
	        }, {
	            displayAs: _constantsJs2["default"].DISPLAY_AS.SUB_HEADING,
	            html: "<h4><b>Collections</b></h4>When accessing a propterty of a collection you need to use a colon.<br/>Example: Cars:{Supplier}<br/> Example: Flights:{Carrier}<br/>" + " Example: Fare.BrandId:<br/>" + "<i><b>Notice the colon at the end of BrandId. This is because Fare is NOT a collection and BrandId is.</b></i>"
	        }, {
	            displayAs: _constantsJs2["default"].DISPLAY_AS.SUB_HEADING,
	            html: "<h4><b>Non-Collections</b></h4>When accessing a propterty of a non-collection you need to use a period.<br/> Example: Itinerary.TravelPolicyCode"
	        }, {
	            displayAs: _constantsJs2["default"].DISPLAY_AS.SUB_HEADING,
	            html: "" + "<table class=\"enhancedPolicyTable\">" + "<tr><th>Field</th><th>Format</th></tr>" + "<tr><td>Fare Brand Id (Collection)</td><td>Fare.BrandId:</td></tr>" + "<tr><td>Fare RBD Code (Collection)</td><td>Fare.ResBookCode:</td></tr>" + "<tr><td>Fare Amount</td><td>Fare.Amount</td></tr>" + "<tr><td>Fare Cabin</td><td>Fare.CabinCode</td></tr>" + "<tr><td>Fare Class</td><td>Fare.FareClassType</td></tr>" + "<tr><td>Fare Refundability</td><td>Fare.Refundable</td></tr>" + "<tr><td>Flight Equipment Code</td><td>Flight.AircraftType</td></tr>" + "<tr><td>Flight Carrier</td><td>Flight.Carrier</td></tr>" + "<tr><td>Flight Departure City</td><td>Flight.DestinationLocationCode</td></tr>" + "<tr><td>Flight Origin City</td><td>Flight.OriginLocationCode</td></tr>" + "<tr><td>Flight Departure Country</td><td>Flight.DestinationCountryCode</td></tr>" + "<tr><td>Flight Origin Country</td><td>Flight.OriginCountryCode</td></tr>" + "<tr><td>Flight #Stops</td><td>Flight.Stops</td></tr>" + "<tr><td>SearchCritera Destination Location Code</td><td>SearchCriteria.Destination.Code</td></tr>" + "<tr><td>SearchCritera Destination Country Code</td><td>SearchCriteria.Destination.CountryCode</td></tr>" + "<tr><td>SearchCritera Destination Intl</td><td>SearchCriteria.Destination.IsInternational</td></tr>" + "<tr><td>SearchCritera Origin Intl</td><td>SearchCriteria.Origin.IsInternational</td></tr>" + "<tr><td>User Email</td><td>User.LoggedInUserEmail</td></tr>" + "<tr><td>User Role</td><td>User.LoggedInUserRole</td></tr>" + "<tr><td>User Name</td><td>User.LoggedInUserName</td></tr>" + "<tr><td>CurrentDate</td><td>CurrentDate</td></tr>" + "<tr><td>Flights contain carrier (Collection)</td><td>Flights:{Carrier}</td></tr>" + "</table>" + ""
	        }],
	        endpoint: endpoint,
	        routeParamId: routeParamId,
	        removeParamId: "EnhancedPolicyRulesConditionsItem",
	        canDelete: true
	    };
	};
	
	exports.EnhancedPolicyRulesConditionsItemFn = EnhancedPolicyRulesConditionsItemFn;
	var EnhancedPolicyRulesConditionsFn = function EnhancedPolicyRulesConditionsFn(dataAt) {
	    return {
	        displayName: "Conditions",
	        dataAt: (dataAt || "") + "Conditions",
	        displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	        canAddNew: true,
	        gridItem: EnhancedPolicyRulesConditionsItemFn(dataAt),
	        gridCols: [{ name: "Collection Operation Type", key: "CollectionOperationType" }, { name: "Is Collection", key: "IsCollection" }, { name: "Operator Type", key: "OperatorType" }, { name: "Type", key: "Type" }, { name: "Source Format", key: "SourceFormat" }]
	    };
	};
	exports.EnhancedPolicyRulesConditionsFn = EnhancedPolicyRulesConditionsFn;

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var CtmDebtorsIsEnabled = {
	  displayName: 'Is Enabled',
	  dataAt: 'IsEnabled',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.BOOLEAN
	};
	
	var CtmDebtorsPCC = {
	  displayName: 'PCC',
	  dataAt: 'Pcc',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var CtmDebtorsHomeCountry = {
	  displayName: 'Home Country',
	  dataAt: 'HomeCountry',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.COUNTRY_SELECT,
	  selectType: 'single',
	  required: true
	};
	
	var CtmDebtorsLogo = {
	  displayName: 'Logo',
	  dataAt: 'Logo',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var CtmDebtorsTitle = {
	  displayName: 'Title',
	  dataAt: 'Name',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var CtmDebtorsIdentifier = {
	  displayName: 'Identifier',
	  dataAt: 'Id',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true,
	  minLength: 10
	};
	
	var CtmDebtorsAddResource = {
	  displayAs: _constantsJs2['default'].DISPLAY_AS.ADD_GRID_RESOURCE,
	  displayName: 'CTM Debtor',
	  data: {
	    Id: '',
	    Name: '',
	    Logo: '',
	    HomeCountry: '',
	    IsEnabled: false
	  },
	  dataAt: '',
	  children: [CtmDebtorsIdentifier, CtmDebtorsTitle, CtmDebtorsLogo, CtmDebtorsHomeCountry],
	  microService: true,
	  endpoint: _constantsJs2['default'].MICRO_SERVICE.DEBTORS
	};
	
	var CtmDebtorsResource = {
	  displayName: 'CTM Debtors',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  dataAt: '',
	  children: [CtmDebtorsIdentifier, CtmDebtorsTitle, CtmDebtorsLogo, CtmDebtorsHomeCountry, CtmDebtorsPCC, CtmDebtorsIsEnabled],
	  microService: true,
	  endpoint: _constantsJs2['default'].MICRO_SERVICE.DEBTORS,
	  iconClass: 'fa-user',
	  routeParamId: 'ctmDebtorId'
	};
	
	var CtmDebtorsList = {
	  rootNode: true,
	  displayName: 'CTM Debtors',
	  microService: true,
	  endpoint: _constantsJs2['default'].MICRO_SERVICE.DEBTORS,
	  iconClass: 'fa-user',
	  dataAt: '',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  gridItem: CtmDebtorsResource, //RailCardsResource,
	  gridAdd: CtmDebtorsAddResource, //RailCardsAddResource,
	  gridCols: [{ name: 'Identifier', key: 'Id' }, { name: 'Title', key: 'Name' }, { name: 'Home Country', key: 'HomeCountry' }, { name: 'Is Enabled', key: 'IsEnabled' }]
	};
	
	exports['default'] = {
	  CtmDebtorsList: CtmDebtorsList,
	  CtmDebtorsResource: CtmDebtorsResource,
	  CtmDebtorsAddResource: CtmDebtorsAddResource,
	  CtmDebtorsIdentifier: CtmDebtorsIdentifier,
	  CtmDebtorsTitle: CtmDebtorsTitle,
	  CtmDebtorsHomeCountry: CtmDebtorsHomeCountry,
	  CtmDebtorsPCC: CtmDebtorsPCC,
	  CtmDebtorsIsEnabled: CtmDebtorsIsEnabled
	};
	module.exports = exports['default'];

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	/* Property Definitions */
	var LogTime = {
	  display: 'Log Time',
	  dataAt: 'LogTime',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var Email = {
	  displayName: "Email",
	  dataAt: "Email",
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  hideIfEmpty: true
	};
	
	var DebtorIdentifier = {
	  displayName: "Debtor",
	  dataAt: "DebtorIdentifier",
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  hideIfEmpty: true
	};
	
	var Pnr = {
	  displayName: "PNR",
	  dataAt: "Pnr",
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  hideIfEmpty: true
	};
	
	var ProfileName = {
	  displayName: "Profile",
	  dataAt: "ProfileName",
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  hideIfEmpty: true
	};
	
	var Firstname = {
	  displayName: "First Name",
	  dataAt: "Firstname",
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  hideIfEmpty: true
	};
	
	var Lastname = {
	  displayName: "Last Name",
	  dataAt: "Lastname",
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  hideIfEmpty: true
	};
	
	var CreatedOn = {
	  displayName: 'Created on',
	  dataAt: 'CreatedOn',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var CreatedBy = {
	  displayName: 'Created by',
	  dataAt: 'CreatedBy',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var Id = {
	  displayName: 'Identifier',
	  dataAt: 'Id',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var LogType = {
	  displayName: 'Type',
	  dataAt: 'LogType',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true,
	  required: false
	};
	
	var LogLevel = {
	  displayName: 'Type',
	  dataAt: 'LogLevel',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true,
	  required: false
	};
	
	var RoleName = {
	  displayName: 'Application',
	  dataAt: 'RoleName',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true,
	  required: false
	};
	
	var LogMessage = {
	  displayName: 'Log Message',
	  dataAt: 'LogMessage',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_AREA
	};
	
	var ModifiedOn = {
	  displayName: 'Modified on',
	  dataAt: 'ModifiedOn',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var ModifiedBy = {
	  displayName: 'Modified by',
	  dataAt: 'ModifiedBy',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	// Choose what properties display in the Admin page
	var AdminPanel = {
	  tabName: 'Admin',
	  dataAt: '',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GROUP,
	  children: [CreatedBy, CreatedOn, ModifiedBy, ModifiedOn]
	};
	
	// lbaViewGrid attributes. This is also where you define which columns appear in the ViewGrid.
	var LogsList = {
	  rootNode: true,
	  displayName: 'AppInsights Logs',
	  endpoint: 'Logs',
	  iconClass: 'fa-hammer',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.VIEW_GRID,
	  canCopyItem: false,
	  canAddNew: false,
	  children: [LogMessage],
	  gridCols: [{ name: 'Type', key: 'LogLevel' }, { name: 'Email', key: 'Email' }, { name: 'DebtorIdentifier', key: 'DebtorIdentifier' }, { name: 'Log Time', key: 'LogTime' }]
	};
	
	var LogResource = {
	  rootNode: true,
	  displayName: "AppInsights Logs",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  iconClass: "fa-cog",
	  dataAt: "",
	  children: [LogsList],
	  endpoint: "Logs"
	};
	
	exports['default'] = {
	  LogResource: LogResource,
	  LogsList: LogsList,
	  AdminPanel: AdminPanel,
	  Id: Id,
	  CreatedBy: CreatedBy,
	  CreatedOn: CreatedOn,
	  ModifiedBy: ModifiedBy,
	  ModifiedOn: ModifiedOn,
	  LogType: LogType,
	  RoleName: RoleName,
	  LogLevel: LogLevel,
	  LogMessage: LogMessage,
	  Email: Email,
	  DebtorIdentifier: DebtorIdentifier,
	  LogTime: LogTime,
	  Pnr: Pnr,
	  ProfileName: ProfileName,
	  Firstname: Firstname,
	  Lastname: Lastname
	};
	module.exports = exports['default'];

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var EnhancedLogsItem = {
	  displayAs: _constantsJs2['default'].DISPLAY_AS.ENHANCED_LOG_ITEM
	};
	
	var EnhancedLogsId = {
	  displayName: 'Identifier',
	  dataAt: 'id',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var EnhancedLogsPassengerIdentifier = {
	  displayName: 'Passenger Identifier',
	  dataAt: 'PassengerIdentifier',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var EnhancedLogsRequestDateTime = {
	  displayName: 'Request Date Time',
	  dataAt: 'RequestDate',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var EnhancedLogsIsError = {
	  displayName: 'Is Error',
	  dataAt: 'IsError',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var EnhancedLogsRequestType = {
	  displayName: 'Request Type',
	  dataAt: 'RequestType',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var EnhancedLogsRequestMessage = {
	  displayName: 'Request Message',
	  dataAt: 'RequestMessage',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_AREA,
	  disabled: true
	};
	
	var EnhancedLogsResponseMessage = {
	  displayName: 'Response Message',
	  dataAt: 'ResponseMessage',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_AREA,
	  disabled: true
	};
	
	var EnhancedLogsGrid = {
	  rootNode: true,
	  displayName: 'Enhanced Logs',
	  iconClass: 'fa-hammer',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.PAGING_GRID,
	  canCopyItem: false,
	  canAddNew: false,
	  endpoint: 'EnhancedLogging',
	  gridCols: [{ name: 'RequestDate', field: 'RequestDate', cellFilter: 'dateDisplay', width: '165' }, { name: 'IsError', field: 'IsError', width: '50' }, { name: 'RequestType', field: 'RequestType', width: '200' }, { name: 'RequestMessage', field: 'RequestMessage' }, { name: 'ResponseMessage', field: 'ResponseMessage' }],
	  children: [EnhancedLogsItem],
	  filterColumns: "EnhancedLogsSearchTypes",
	  defaultFilteredColumn: "PassengerIdentifier",
	  defaultSort: [{
	    "column": "RequestDate",
	    "Order": "Desc"
	  }]
	};
	
	var EnhancedLogResource = {
	  rootNode: true,
	  displayName: "Enhanced Logs",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  iconClass: "fa-cog",
	  dataAt: "",
	  children: [EnhancedLogsGrid],
	  noButtons: true
	};
	
	exports['default'] = {
	  EnhancedLogsGrid: EnhancedLogsGrid,
	  EnhancedLogsId: EnhancedLogsId,
	  EnhancedLogsPassengerIdentifier: EnhancedLogsPassengerIdentifier,
	  EnhancedLogsRequestDateTime: EnhancedLogsRequestDateTime,
	  EnhancedLogsIsError: EnhancedLogsIsError,
	  EnhancedLogsRequestType: EnhancedLogsRequestType,
	  EnhancedLogsRequestMessage: EnhancedLogsRequestMessage,
	  EnhancedLogsResponseMessage: EnhancedLogsResponseMessage,
	  EnhancedLogResource: EnhancedLogResource,
	  EnhancedLogsItem: EnhancedLogsItem
	};
	module.exports = exports['default'];

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var FlyAmericaNameLabel = { dataAt: 'Name', displayAs: _constantsJs2['default'].DISPLAY_AS.SUB_HEADING, label: 'Name:' };
	
	var USCarriers = {
	  displayName: 'US Carriers',
	  dataAt: 'USCarrierCodes',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT
	};
	
	var ModifiedOn = {
	  displayName: 'Modified on',
	  dataAt: 'ModifiedOn',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var ModifiedBy = {
	  displayName: 'Modified by',
	  dataAt: 'ModifiedBy',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var CreatedOn = {
	  displayName: 'Created on',
	  dataAt: 'CreatedOn',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var CreatedBy = {
	  displayName: 'Created by',
	  dataAt: 'CreatedBy',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var UploadedBy = {
	  displayName: 'Uploaded by',
	  dataAt: 'UploadedBy',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var UploadedWhen = {
	  displayName: 'Uploaded On',
	  dataAt: 'UploadedWhen',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var IsDeleted = {
	  displayName: 'Delete',
	  dataAt: 'IsDeleted',
	  disabled: false,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.BOOLEAN
	};
	
	var FlyAmericaId = {
	  displayName: 'Id',
	  dataAt: 'Id',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var CarrierCodes = {
	  displayName: 'CarrierCodes',
	  dataAt: 'CarrierCodes',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT
	};
	
	var CountryCodes = {
	  displayName: 'CountryCodes',
	  dataAt: 'CountryCodes',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT
	};
	
	var ConditionalApply = {
	  displayName: 'ConditionalApply',
	  dataAt: 'ConditionalApply',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.SELECT,
	  optionsAt: 'ConditionalApplyTypes'
	};
	
	var ApplyCityPairProgram = {
	  displayName: 'ApplyCityPairProgram',
	  dataAt: 'ApplyCityPairProgram',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.BOOLEAN
	};
	
	var ValidFrom = {
	  displayName: 'From',
	  dataAt: 'ValidFrom',
	  disabled: false,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var ValidTo = {
	  displayName: 'To',
	  dataAt: 'ValidTo',
	  disabled: false,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var UploadedRouteCount = {
	  displayName: 'Count',
	  dataAt: 'UploadedRouteCount',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var FlyAmericaConfigOpenSkiesName = {
	  displayName: 'Name',
	  dataAt: 'OpenSkies.$OpenSkiesItem.Name',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: false
	};
	
	var FlyAmericaConfigOpenSkiesCountryCodes = {
	  displayName: 'Country Codes',
	  dataAt: 'OpenSkies.$OpenSkiesItem.CountryCodes',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT,
	  disabled: false
	};
	
	var FlyAmericaConfigOpenSkiesCarrierCodes = {
	  displayName: 'Carrier Codes',
	  dataAt: 'OpenSkies.$OpenSkiesItem.CarrierCodes',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT,
	  disabled: false
	};
	
	var FlyAmericaConfigOpenSkiesApplyCityPairProgram = {
	  displayName: 'Apply City Pair Program',
	  dataAt: 'OpenSkies.$OpenSkiesItem.ApplyCityPairProgram',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.BOOLEAN,
	  disabled: false
	};
	
	var FlyAmericaConfigOpenSkiesConditionalApply = {
	  displayName: 'Conditional Apply',
	  dataAt: 'OpenSkies.$OpenSkiesItem.ConditionalApply',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.SELECT,
	  optionsAt: 'ConditionalApplyTypes',
	  disabled: false
	};
	
	var OpenSkiesItemResource = {
	  displayName: 'Open Skies Agreement',
	  dataAt: 'OpenSkies.$OpenSkiesItem',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [FlyAmericaConfigOpenSkiesName, FlyAmericaConfigOpenSkiesCountryCodes, FlyAmericaConfigOpenSkiesCarrierCodes, FlyAmericaConfigOpenSkiesApplyCityPairProgram, FlyAmericaConfigOpenSkiesConditionalApply],
	  showBack: false, // Show the Back button. This will hide the other buttons in lbaResource.
	  endpoint: "FlyAmericaConfigs",
	  routeParamId: 'id',
	  removeParamId: 'OpenSkiesItem',
	  canDelete: true
	};
	
	var OpenSkiesList = {
	  displayName: 'Open Skies',
	  iconClass: 'fa-plane',
	  dataAt: 'OpenSkies',
	  canAddNew: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  gridItem: OpenSkiesItemResource,
	  gridCols: [{ name: 'Name', key: 'Name' }, { name: 'Country Codes', key: 'CountryCodes' }, { name: 'Carrier Codes', key: 'CarrierCodes' }]
	};
	
	var FlyAmericaPolicyExceptionsTitle = {
	  displayName: 'Title',
	  dataAt: 'DefaultFlyAmericaPolicyExceptions.$DefaultFlyAmericaPolicyExceptionsItem.Title',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: false
	};
	var FlyAmericaPolicyExceptionsCode = {
	  displayName: 'Code',
	  dataAt: 'DefaultFlyAmericaPolicyExceptions.$DefaultFlyAmericaPolicyExceptionsItem.Code',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: false
	};
	
	var DefaultFlyAmericaPolicyExceptionsItemResource = {
	  displayName: 'Fly America Policy Exception',
	  dataAt: 'DefaultFlyAmericaPolicyExceptions.$DefaultFlyAmericaPolicyExceptionsItem',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [FlyAmericaPolicyExceptionsTitle, FlyAmericaPolicyExceptionsCode],
	  showBack: false, // Show the Back button. This will hide the other buttons in lbaResource.
	  endpoint: "FlyAmericaConfigs",
	  routeParamId: 'id',
	  removeParamId: 'DefaultFlyAmericaPolicyExceptionsItem',
	  canDelete: true
	};
	
	var DefaultFlyAmericaPolicyExceptionsList = {
	  displayName: 'Default Fly America Policy Exceptions',
	  iconClass: 'fa-plane',
	  dataAt: 'DefaultFlyAmericaPolicyExceptions',
	  canAddNew: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  gridItem: DefaultFlyAmericaPolicyExceptionsItemResource,
	  gridCols: [{ name: 'Code', key: 'Code' }, { name: 'Title', key: 'Title' }]
	};
	
	var ProgramRouteFileUpload = {
	  displayName: 'City Pair Program File Upload',
	  dataAt: 'ProgramRouteFileUpload',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.FILE_UPLOADER,
	  fileContainer: 'ProgramRouteFileUpload',
	  uploadType: 'xlsx',
	  fileNamePrefix: 'ProgramRoutesFile',
	  fileNameFormat: 'yyyymmdd',
	  excludeFromPost: true,
	  fileAccept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
	};
	
	var ProgramRouteFileDownload = {
	  displayName: 'City Pair Program File Download',
	  dataAt: 'ProgramRouteFileDownload',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.FILE_DOWNLOADER,
	  fileNameSuffix: 'ProgramRoutes.xlsx',
	  parameterValueFromActiveItemProperty: 'Id',
	  parameterName: 'Id',
	  endPointController: 'ProgramRouteDownload'
	};
	
	var FlyAmericaConfigCityPairProgramOrigin = {
	  displayName: 'Origin',
	  dataAt: 'CityPairProgram.$FlyAmericaCityPairItem.Origin',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: false
	};
	
	var FlyAmericaConfigCityPairProgramDestination = {
	  displayName: 'Destination',
	  dataAt: 'CityPairProgram.$FlyAmericaCityPairItem.Destination',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: false
	};
	
	var FlyAmericaConfigCityPairProgramValidFrom = {
	  displayName: 'Valid From',
	  dataAt: 'CityPairProgram.$FlyAmericaCityPairItem.ValidFrom',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: false
	};
	
	var FlyAmericaConfigCityPairProgramValidTo = {
	  displayName: 'Valid To',
	  dataAt: 'CityPairProgram.$FlyAmericaCityPairItem.ValidTo',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: false
	};
	
	var CityPairProgram = {
	  displayName: 'City Pair Program',
	  dataAt: 'CityPairProgram',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: CityPairProgramItem,
	  gridCols: [{ name: 'Origin', key: 'Origin' }, { name: 'Destination', key: 'Destination' }, { name: 'ValidFrom', key: 'ValidFrom' }, { name: 'ValidTo', key: 'ValidTo' }]
	};
	var CityPairProgramItem = {
	  displayName: 'City Pair',
	  dataAt: 'CityPairProgram.$CityPairProgramItem',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [FlyAmericaTabs, FlyAmericaConfigCityPairProgramOrigin, FlyAmericaConfigCityPairProgramDestination, FlyAmericaConfigCityPairProgramValidFrom, FlyAmericaConfigCityPairProgramValidTo],
	  showBack: false, // Show the Back button. This will hide the other buttons in lbaResource.
	  endpoint: "FlyAmericaConfigs",
	  routeParamId: 'flyAmericaId',
	  removeParamId: 'FlyAmericaCityPairItem',
	  canDelete: true
	};
	
	var ProgramRouteItemResource = {
	  rootNode: true,
	  displayName: 'FlyAmericaConfigs',
	  dataAt: '',
	  //dataAt: 'ProgramRoutes.$ProgramRoutesItem',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [FlyAmericaId, ValidFrom, ValidTo, UploadedBy, UploadedWhen, ProgramRouteFileDownload, UploadedRouteCount, CityPairProgram, IsDeleted],
	  showBack: false, // Show the Back button. This will hide the other buttons in lbaResource.
	  endpoint: "FlyAmericaConfigs",
	  routeParamId: 'id',
	  removeParamId: 'removeId'
	};
	
	var ProgramRouteAddResource = {
	  displayAs: _constantsJs2['default'].DISPLAY_AS.ADD_GRID_RESOURCE,
	  displayName: 'FlyAmericaConfigs',
	  data: {
	    Name: ''
	  },
	  dataAt: '',
	  children: [FlyAmericaNameLabel, FlyAmericaId],
	  endpoint: "FlyAmericaConfigs"
	  //endpoint: "FlyAmericaConfigs$filter=DocType eq 'OpenSkies'"
	};
	
	var ProgramRoutesList = {
	  rootNode: true,
	  displayName: 'City Pair Program',
	  //dataAt: 'ProgramRoutes',
	  iconClass: 'fa-plane',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  gridItem: ProgramRouteItemResource,
	  gridAdd: ProgramRouteAddResource,
	  canAddNew: true,
	  ODataArgs: "?$filter=DocType eq 'CityPairProgram'",
	  //ODataArgs: '?$select=Id,Name,Title,ConsultingTeamEmail,DebtorApprovalLevel,Disabled$&$filter=DocType eq 'ProgramRoute'',
	  endpoint: "FlyAmericaConfigs",
	  gridCols: [{ name: 'From', key: 'ValidFrom' }, { name: 'To', key: 'ValidTo' }, { name: 'Count', key: 'UploadedRouteCount' }, { name: 'Uploaded by', key: 'UploadedBy' }, { name: 'Uploaded On', key: 'UploadedWhen' }]
	};
	
	var FlyAmericaActConfigPanel = {
	  dataAt: '',
	  tabName: 'Fly-America-Config',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GROUP,
	  children: [FlyAmericaId, USCarriers, OpenSkiesList, DefaultFlyAmericaPolicyExceptionsList]
	};
	
	var ProgramRoutePanel = {
	  dataAt: '',
	  tabName: 'City-Pair-Program',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GROUP,
	  children: [ProgramRouteFileUpload, {
	    displayAs: _constantsJs2['default'].DISPLAY_AS.SUB_HEADING,
	    label: "Excel Files Only. Required columns are shown below"
	  }, {
	    displayAs: _constantsJs2['default'].DISPLAY_AS.SUB_HEADING,
	    label: "Option 1 [Origin, Destination, ValidFrom, ValidTo]"
	  }, {
	    displayAs: _constantsJs2['default'].DISPLAY_AS.SUB_HEADING,
	    label: "Option 2 [ORIGIN_AIRPORT_ABBREV, DESTINATION_AIRPORT_ABBREV, EFFECTIVE_DATE, EFFECTIVE_DATE]"
	  }, ProgramRoutesList]
	};
	
	var AdminPanel = {
	  tabName: 'Admin',
	  dataAt: '',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GROUP,
	  children: [CreatedBy, CreatedOn, ModifiedBy, ModifiedOn]
	};
	
	var FlyAmericaTabs = {
	  dataAt: '',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TABS,
	  children: [FlyAmericaActConfigPanel, ProgramRoutePanel]
	};
	
	var ProgramRouteTabs = {
	  dataAt: '',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TABS,
	  children: [ProgramRoutePanel, AdminPanel]
	};
	
	var CarriersResource = {
	  rootNode: true,
	  displayName: 'FlyAmericaConfigs',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  dataAt: '',
	  children: [FlyAmericaTabs, FlyAmericaActConfigPanel],
	  showBack: false, // Show the Back button. This will hide the other buttons in lbaResource.
	  endpoint: 'FlyAmericaConfigs',
	  routeParamId: "id"
	};
	
	var ProgramRouteResource = {
	  rootNode: true,
	  displayName: "FlyAmericaConfigs",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  dataAt: '',
	  children: [FlyAmericaTabs],
	  showBack: false, // Show the Back button. This will hide the other buttons in lbaResource.
	  endpoint: "FlyAmericaConfigs?$filter=DocType eq 'ProgramRoute'"
	};
	// const ProgramRouteResource = {
	//   rootNode: true,
	//   displayName: "FlyAmericaConfigs",
	//   displayAs: constants.DISPLAY_AS.RESOURCE,
	//   dataAt: '',
	//   children: [FlyAmericaTabs],
	//   showBack: false,// Show the Back button. This will hide the other buttons in lbaResource.
	//   endpoint: "FlyAmericaConfigs"
	// };
	
	exports['default'] = {
	  FlyAmericaId: FlyAmericaId,
	  USCarriers: USCarriers,
	  FlyAmericaActConfigPanel: FlyAmericaActConfigPanel,
	  FlyAmericaTabs: FlyAmericaTabs,
	  //OpenSkiesAddResource,
	  OpenSkiesItemResource: OpenSkiesItemResource,
	  CarriersResource: CarriersResource,
	  CountryCodes: CountryCodes,
	  CarrierCodes: CarrierCodes,
	  ApplyCityPairProgram: ApplyCityPairProgram,
	  ConditionalApply: ConditionalApply,
	  FlyAmericaNameLabel: FlyAmericaNameLabel,
	  ProgramRouteFileUpload: ProgramRouteFileUpload,
	  ProgramRoutePanel: ProgramRoutePanel,
	  ProgramRouteResource: ProgramRouteResource,
	  ProgramRouteFileDownload: ProgramRouteFileDownload,
	  ProgramRouteItemResource: ProgramRouteItemResource,
	  ProgramRouteAddResource: ProgramRouteAddResource,
	  CityPairProgram: CityPairProgram,
	  CityPairProgramItem: CityPairProgramItem,
	  FlyAmericaConfigCityPairProgramOrigin: FlyAmericaConfigCityPairProgramOrigin,
	  FlyAmericaConfigCityPairProgramDestination: FlyAmericaConfigCityPairProgramDestination,
	  FlyAmericaConfigCityPairProgramValidFrom: FlyAmericaConfigCityPairProgramValidFrom,
	  FlyAmericaConfigCityPairProgramValidTo: FlyAmericaConfigCityPairProgramValidTo,
	  OpenSkiesList: OpenSkiesList,
	  FlyAmericaConfigOpenSkiesName: FlyAmericaConfigOpenSkiesName,
	  FlyAmericaConfigOpenSkiesCountryCodes: FlyAmericaConfigOpenSkiesCountryCodes,
	  FlyAmericaConfigOpenSkiesCarrierCodes: FlyAmericaConfigOpenSkiesCarrierCodes,
	  FlyAmericaConfigOpenSkiesApplyCityPairProgram: FlyAmericaConfigOpenSkiesApplyCityPairProgram,
	  FlyAmericaConfigOpenSkiesConditionalApply: FlyAmericaConfigOpenSkiesConditionalApply,
	  DefaultFlyAmericaPolicyExceptionsList: DefaultFlyAmericaPolicyExceptionsList,
	  DefaultFlyAmericaPolicyExceptionsItemResource: DefaultFlyAmericaPolicyExceptionsItemResource,
	  FlyAmericaPolicyExceptionsTitle: FlyAmericaPolicyExceptionsTitle,
	  FlyAmericaPolicyExceptionsCode: FlyAmericaPolicyExceptionsCode,
	  UploadedBy: UploadedBy,
	  UploadedWhen: UploadedWhen,
	  IsDeleted: IsDeleted,
	  ValidFrom: ValidFrom,
	  ValidTo: ValidTo,
	  UploadedRouteCount: UploadedRouteCount
	};
	module.exports = exports['default'];

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var ModifiedOn = {
	  displayName: 'Modified on',
	  dataAt: 'ModifiedOn',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var ModifiedBy = {
	  displayName: 'Modified by',
	  dataAt: 'ModifiedBy',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var CreatedOn = {
	  displayName: 'Created on',
	  dataAt: 'CreatedOn',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var CreatedBy = {
	  displayName: 'Created by',
	  dataAt: 'CreatedBy',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var UploadedBy = {
	  displayName: 'Uploaded by',
	  dataAt: 'UploadedBy',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var UploadedWhen = {
	  displayName: 'Uploaded On',
	  dataAt: 'UploadedWhen',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var IsDeleted = {
	  displayName: 'Delete',
	  dataAt: 'IsDeleted',
	  disabled: false,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.BOOLEAN
	};
	
	var CompanyReferenceListId = {
	  displayName: 'Id',
	  dataAt: 'Id',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var CompanyReferenceListDebtorIdentifier = {
	  displayName: 'DebtorIdentifier',
	  dataAt: 'DebtorIdentifier',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: false
	};
	var CompanyReferenceListListId = {
	  displayName: 'ListId',
	  dataAt: 'ListId',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: false
	};
	var CompanyReferenceListValue = {
	  displayName: 'Value',
	  dataAt: 'Value',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: false
	};
	var CompanyReferenceListDescription = {
	  displayName: 'Description',
	  dataAt: 'Description',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: false
	};
	
	var CompanyReferencesAddResource = {
	  displayName: 'Company References',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.ADD_GRID_RESOURCE,
	  dataAt: '',
	  data: {
	    DebtorIdentifier: '',
	    ListId: '',
	    Value: '',
	    Description: ''
	  },
	  children: [CompanyReferenceListDebtorIdentifier, CompanyReferenceListListId, CompanyReferenceListValue, CompanyReferenceListDescription],
	  showBack: false, // Show the Back button. This will hide the other buttons in lbaResource.
	  endpoint: "CompanyReferences"
	
	};
	
	var CompanyReferencesResource = {
	  displayName: 'Company References',
	  iconClass: 'fa-plane',
	  dataAt: '',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [IsDeleted, CompanyReferenceListDebtorIdentifier, CompanyReferenceListListId, CompanyReferenceListValue, CompanyReferenceListDescription, ModifiedOn, ModifiedBy, CreatedOn, CreatedBy],
	  showBack: false, // Show the Back button. This will hide the other buttons in lbaResource.
	  endpoint: "CompanyReferences",
	  routeParamId: 'itemId',
	  removeParamId: 'itemId',
	  canDelete: false
	};
	
	var CompanyReferenceList = {
	  rootNode: true,
	  displayName: 'Company Reference (Top 1000)',
	  iconClass: 'fa-plane',
	
	  canAddNew: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  gridAdd: CompanyReferencesAddResource,
	  gridItem: CompanyReferencesResource,
	  gridCols: [{ name: 'DebtorIdentifier', key: 'DebtorIdentifier' }, { name: 'ListId', key: 'ListId' }, { name: 'Value', key: 'Value' }, { name: 'Description', key: 'Description' }],
	  endpoint: 'CompanyReferences',
	  ODataArgs: '?$filter=IsDeleted+eq+(false)&$top=1000'
	
	};
	var CompanyReferenceListFilter = {
	  rootNode: true,
	  displayName: 'Company Reference',
	  iconClass: 'fa-plane',
	
	  canAddNew: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  gridAdd: CompanyReferencesAddResource,
	  gridItem: CompanyReferencesResource,
	  gridCols: [{ name: 'DebtorIdentifier', key: 'DebtorIdentifier' }, { name: 'ListId', key: 'ListId' }, { name: 'Value', key: 'Value' }, { name: 'Description', key: 'Description' }],
	  endpoint: "CompanyReferences",
	  ODataArgs: "?$filter=IsDeleted+eq+(false)+and+DebtorIdentifier+eq+(':debtorId')+and+ListId+eq+(':listId')"
	
	};
	
	var CompanyReferenceManager = {
	  rootNode: true,
	  displayName: 'Company Reference Summary',
	  iconClass: 'fa-pin',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.COMPANY_REFERENCE
	};
	
	exports['default'] = {
	  CompanyReferenceManager: CompanyReferenceManager,
	  CompanyReferencesResource: CompanyReferencesResource,
	  CompanyReferencesAddResource: CompanyReferencesAddResource,
	  ModifiedOn: ModifiedOn,
	  CreatedOn: CreatedOn,
	  ModifiedBy: ModifiedBy,
	  CreatedBy: CreatedBy,
	  UploadedBy: UploadedBy,
	  UploadedWhen: UploadedWhen,
	  IsDeleted: IsDeleted,
	  CompanyReferenceList: CompanyReferenceList,
	  CompanyReferenceListFilter: CompanyReferenceListFilter,
	  CompanyReferenceListDescription: CompanyReferenceListDescription,
	  CompanyReferenceListValue: CompanyReferenceListValue,
	  CompanyReferenceListListId: CompanyReferenceListListId,
	  CompanyReferenceListDebtorIdentifier: CompanyReferenceListDebtorIdentifier,
	  CompanyReferenceListId: CompanyReferenceListId
	
	};
	module.exports = exports['default'];

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var CompanyReferenceConfigId = {
	  displayName: 'Id',
	  dataAt: 'Id',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var DebtorIdentifier = {
	  displayName: 'DebtorIdentifier',
	  dataAt: 'DebtorIdentifier',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: false
	};
	
	var ListId = {
	  displayName: 'ListId',
	  dataAt: 'ListId',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: false
	};
	
	var FtpHost = {
	  displayName: 'Ftp Host',
	  dataAt: 'FtpHost',
	  disabled: false,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var FtpPort = {
	  displayName: 'Ftp Port',
	  dataAt: 'FtpPort',
	  disabled: false,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var FtpUserName = {
	  displayName: 'Ftp User Name',
	  dataAt: 'FtpUserName',
	  disabled: false,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var FtpPassword = {
	  displayName: 'Ftp Password',
	  dataAt: 'FtpPassword',
	  disabled: false,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var IsFtp = {
	  displayName: 'Use Secure Ftp (SFtp)',
	  dataAt: 'IsSFtp',
	  disabled: false,
	  'default': false,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.BOOLEAN
	};
	
	var TestFtpConnection = {
	  disabled: false,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEST_FTP_CONNECTION,
	  endPointController: "api/companyreferenceconfig/checkftp"
	};
	
	var FileName = {
	  displayName: 'File Name (csv only)',
	  dataAt: 'FileName',
	  disabled: false,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var FilePath = {
	  displayName: 'File Path',
	  dataAt: 'FilePath',
	  disabled: false,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var forceImportNextRun = {
	  displayName: 'Force Import Next Run',
	  dataAt: 'ForceImportNextRun',
	  disabled: false,
	  'default': false,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.BOOLEAN
	};
	var alertEmails = {
	  displayName: 'Alert Emails (Comma separate emails)',
	  dataAt: 'AlertEmails',
	  disabled: false,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	var IsDisabled = {
	  displayName: 'Is Config Disabled',
	  dataAt: 'IsDisabled',
	  disabled: false,
	  'default': false,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.BOOLEAN
	};
	
	var ImportProcessStatusMessage = {
	  displayName: 'Status Message',
	  dataAt: 'ImportProcessStatusMessage',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var CsvFileRequirementTitle = {
	  displayAs: _constantsJs2['default'].DISPLAY_AS.SUB_HEADING,
	  label: "Comma-delimited (csv) files only.  Required format shown below:"
	};
	
	var CsvFileFormatLine1 = {
	  displayAs: _constantsJs2['default'].DISPLAY_AS.SUB_HEADING,
	  label: "Value,Description  <=== Row 1/Column Header, this is required to be on line 1 in the file"
	};
	
	var CsvFileFormatLine2 = {
	  displayAs: _constantsJs2['default'].DISPLAY_AS.SUB_HEADING,
	  label: "my value,someDescription  <=== Subsequent data starts on line 2"
	};
	
	var CompanyReferenceViewResourceFilename = {
	  displayName: "FileName",
	  dataAt: "FileName",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	var CompanyReferenceViewResourceImportProcessAttemptDate = {
	  displayName: "ImportProcessAttemptDate",
	  dataAt: "ImportProcessAttemptDate",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	var CompanyReferenceViewResourceImportProcessCompleteDate = {
	  displayName: "ImportProcessCompleteDate",
	  dataAt: "ImportProcessCompleteDate",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	var CompanyReferenceViewResourceWasFileFoundOnFtp = {
	  displayName: "WasFileFoundOnFtp",
	  dataAt: "WasFileFoundOnFtp",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	var CompanyReferenceViewResourceWasDownloadSuccessful = {
	  displayName: "WasDownloadSuccessful",
	  dataAt: "WasDownloadSuccessful",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	var CompanyReferenceViewResourceFileDownloadProgress = {
	  displayName: "FileDownloadProgress",
	  dataAt: "FileDownloadProgress",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var CompanyReferenceViewResourceProcessAttemptCount = {
	  displayName: "ProcessAttemptCount",
	  dataAt: "ProcessAttemptCount",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var CompanyReferenceViewResourceWasDataSaveSuccessful = {
	  displayName: "WasDataSaveSuccessful",
	  dataAt: "WasDataSaveSuccessful",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	var CompanyReferenceViewResourceErrors = {
	  displayName: "Errors",
	  dataAt: "Errors",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_AREA,
	  disabled: false,
	  'class': "showLineBreaks",
	  splitArrayIntoLines: true
	};
	
	var FileLogGrid = {
	  canAddNew: false,
	  canCopyItem: false,
	  disableRowClick: false,
	  displayName: 'File Processing Logs',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  dataAt: 'FileProcessingLog',
	  gridCols: [{ name: 'File Name', key: 'FileName' }, { name: 'Import Attempted', key: 'ImportProcessAttemptDate', formater: 'dateLocal' }, { name: 'Import Completed', key: 'ImportProcessCompleteDate', formater: 'dateLocal' }, { name: 'File Found on FTP', key: 'WasFileFoundOnFtp' }, { name: 'Downloaded Successfully', key: 'WasDownloadSuccessful' }, { name: 'Total % Downloaded', key: 'FileDownloadProgress' }, { name: 'Saved To Database Successfully', key: 'WasDataSaveSuccessful' }, { name: 'Import Attempt Count', key: 'ProcessAttemptCount' }, { name: 'Errors', key: 'Errors' }]
	};
	var CompanyRefernenceAuditItem = {
	  displayAs: _constantsJs2['default'].DISPLAY_AS.COMPANY_REFEREENCE_AUDIT_ITEM,
	  dataAt: 'ImportLogs.$companyRefernenceAuditItem'
	};
	var auditLogGrid = {
	  canAddNew: false,
	  canCopyItem: false,
	  displayName: 'Audit Logs',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  disableRowClick: true,
	  setActiveItemSubItem: true,
	  dataAt: 'ImportLogs',
	  gridCols: [{ name: 'CreatedOn', key: 'CreatedOn', formater: 'dateLocal' }, { name: 'DateStart', key: 'DateStart', formater: 'dateLocal' }, { name: 'DateEnd', key: 'DateEnd', formater: 'dateLocal' }, { name: 'ActionType', key: 'ActionType' }, { name: 'Status', key: 'Status' }, { name: 'Notes', key: 'Notes' }],
	  children: [CompanyRefernenceAuditItem]
	};
	
	var FileLogGridViewItem = {
	  canAddNew: false,
	  canCopyItem: false,
	  disableRowClick: true,
	  displayName: 'File Processing Logs',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  dataAt: 'FileProcessingLog',
	  gridCols: [{ name: 'File Name', key: 'FileName' }, { name: 'Import Attempted', key: 'ImportProcessAttemptDate', formater: 'dateLocal' }, { name: 'Import Completed', key: 'ImportProcessCompleteDate', formater: 'dateLocal' }, { name: 'File Found on FTP', key: 'WasFileFoundOnFtp' }, { name: 'Downloaded Successfully', key: 'WasDownloadSuccessful' }, { name: 'Total % Downloaded', key: 'FileDownloadProgress' }, { name: 'Saved To Database Successfully', key: 'WasDataSaveSuccessful' }, { name: 'Import Attempt Count', key: 'ProcessAttemptCount' }, { name: 'Errors', key: 'Errors' }],
	  children: [CompanyReferenceViewResourceFilename, CompanyReferenceViewResourceImportProcessAttemptDate, CompanyReferenceViewResourceImportProcessCompleteDate, CompanyReferenceViewResourceWasFileFoundOnFtp, CompanyReferenceViewResourceWasDownloadSuccessful, CompanyReferenceViewResourceFileDownloadProgress, CompanyReferenceViewResourceProcessAttemptCount, CompanyReferenceViewResourceWasDataSaveSuccessful, CompanyReferenceViewResourceErrors]
	};
	var CompanyReferenceConfigAddResource = {
	  displayAs: _constantsJs2['default'].DISPLAY_AS.ADD_GRID_RESOURCE,
	  displayName: 'Company Reference Config',
	  data: {
	    DebtorIdentifier: '',
	    ListId: '',
	    FileName: '',
	    FilePath: '',
	    FtpHost: '',
	    FtpPort: null,
	    FtpUserName: '',
	    FtpPassword: '',
	    IsSFtp: false,
	    IsDisabled: false,
	    ForceImportNextRun: false,
	    AlertEmails: ''
	  },
	  dataAt: '',
	  children: [DebtorIdentifier, ListId, FtpHost, FtpPort, FtpUserName, FtpPassword, IsFtp, TestFtpConnection, FileName, CsvFileRequirementTitle, CsvFileFormatLine1, CsvFileFormatLine2, FilePath, IsDisabled, forceImportNextRun, alertEmails],
	  endpoint: 'CompanyReferenceConfig'
	};
	
	var CompanyReferenceConfigEditResource = {
	  displayName: 'Company Reference Config',
	  iconClass: 'fa-gear',
	  dataAt: '',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [ImportProcessStatusMessage, CompanyReferenceConfigId, DebtorIdentifier, ListId, FtpHost, FtpPort, FtpUserName, FtpPassword, IsFtp, TestFtpConnection, FileName, CsvFileRequirementTitle, CsvFileFormatLine1, CsvFileFormatLine2, FilePath, IsDisabled, forceImportNextRun, alertEmails, FileLogGrid, auditLogGrid],
	  showBack: false, // Show the Back button. This will hide the other buttons in lbaResource.
	  endpoint: 'CompanyReferenceConfig',
	  routeParamId: 'companyReferenceConfigId',
	  removeParamId: 'companyReferenceConfigId',
	  canDelete: true,
	  deleteOnBackend: true
	};
	
	var CompanyReferenceConfigEditResourceViewLog = {
	  displayName: 'Company Reference Config',
	  iconClass: 'fa-gear',
	  dataAt: '',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [FileLogGridViewItem],
	  showBack: false, // Show the Back button. This will hide the other buttons in lbaResource.
	  endpoint: 'CompanyReferenceConfig',
	  routeParamId: 'companyReferenceConfigId',
	  removeParamId: 'companyReferenceConfigId',
	  canDelete: false,
	  noButtons: true
	};
	
	var CompanyReferenceConfigGrid = {
	  canAddNew: true,
	  displayName: 'Company Reference Config',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  gridItem: CompanyReferenceConfigEditResource,
	  gridAdd: CompanyReferenceConfigAddResource,
	  gridCols: [{ name: 'DebtorIdentifier', key: 'DebtorIdentifier' }, { name: 'ListId', key: 'ListId' }, { name: 'FileName', key: 'FileName' }, { name: 'FtpHost', key: 'FtpHost' }, { name: 'Import Completed Date', key: 'ImportProcessCompleteDate', formater: 'dateLocal' }, { name: 'Enabled', key: 'IsEnabled' }, { name: 'Status Message', key: 'ImportProcessStatusMessage' }],
	  endpoint: 'CompanyReferenceConfig'
	};
	
	var CompanyReferenceConfig = {
	  rootNode: true,
	  iconClass: 'fa-gear',
	  displayName: 'Company Reference Config',
	  showTitle: false,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GROUP,
	  children: [CompanyReferenceConfigGrid, CsvFileRequirementTitle, CsvFileFormatLine1, CsvFileFormatLine2]
	};
	
	exports['default'] = {
	  CompanyReferenceConfig: CompanyReferenceConfig,
	  CompanyReferenceConfigGrid: CompanyReferenceConfigGrid,
	  CompanyReferenceConfigEditResource: CompanyReferenceConfigEditResource,
	  CompanyReferenceConfigAddResource: CompanyReferenceConfigAddResource,
	  CompanyReferenceConfigId: CompanyReferenceConfigId,
	  CsvFileRequirementTitle: CsvFileRequirementTitle,
	  CsvFileFormatLine1: CsvFileFormatLine1,
	  CsvFileFormatLine2: CsvFileFormatLine2,
	  DebtorIdentifier: DebtorIdentifier,
	  ListId: ListId,
	  FtpHost: FtpHost,
	  FtpPort: FtpPort,
	  FtpUserName: FtpUserName,
	  FtpPassword: FtpPassword,
	  IsFtp: IsFtp,
	  FileName: FileName,
	  IsDisabled: IsDisabled,
	  CompanyReferenceConfigEditResourceViewLog: CompanyReferenceConfigEditResourceViewLog
	};
	module.exports = exports['default'];

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.enhancedPolicyActionRoute = enhancedPolicyActionRoute;
	exports.getEnhancePolicyPath = getEnhancePolicyPath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var _enhancedPolicyRulesPnrRemarks = __webpack_require__(465);
	
	var _enhancedPolicyRulesPnrExtraAction = __webpack_require__(466);
	
	var _componentsFormsConditionsJs = __webpack_require__(457);
	
	var _enhancedPolicyRulesPolicySettings = __webpack_require__(467);
	
	var _enhancedPolicyRulesLimitPassengerJs = __webpack_require__(468);
	
	// --- START Debtors
	
	var EnhancedPolicyRulesDebtorsDebtorIdentifier = {
	  displayName: "Debtor Identifier",
	  dataAt: "Debtors.$EnhancedPolicyRulesDebtorsItem.DebtorIdentifier",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var EnhancedPolicyRulesDebtorsPolicyCodes = {
	  displayName: "Policy Codes",
	  dataAt: "Debtors.$EnhancedPolicyRulesDebtorsItem.PolicyCodes",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT
	};
	
	var EnhancedPolicyRulesDebtorsCountryCodes = {
	  displayName: "Debtor Country Codes",
	  dataAt: "Debtors.$EnhancedPolicyRulesDebtorsItem.CountryCodes",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TAG_INPUT
	};
	
	var EnhancedPolicyRulesDebtorsItem = {
	  displayName: "Debtors",
	  dataAt: "Debtors.$EnhancedPolicyRulesDebtorsItem",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [EnhancedPolicyRulesDebtorsDebtorIdentifier, EnhancedPolicyRulesDebtorsPolicyCodes, EnhancedPolicyRulesDebtorsCountryCodes],
	  endpoint: "EnhancedPolicyRules",
	  routeParamId: "enhancedPolicyRulesId",
	  removeParamId: "EnhancedPolicyRulesDebtorsItem",
	  canDelete: true
	};
	
	var EnhancedPolicyRulesDebtors = {
	  displayName: "Debtors",
	  dataAt: "Debtors",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  canAddNew: true,
	  gridItem: EnhancedPolicyRulesDebtorsItem,
	  gridCols: [{ name: "Debtor Identifier", key: "DebtorIdentifier" }, { name: "Policy Codes", key: "PolicyCodes" }, { name: "Debtor Country Codes", key: "CountryCodes" }]
	};
	
	// --- END Debtors
	
	// --- START Conditions
	
	var EnhancedPolicyRulesConditionsCollectionOperationType = (0, _componentsFormsConditionsJs.EnhancedPolicyRulesConditionsCollectionOperationTypeFn)();
	var EnhancedPolicyRulesConditionsIsExpression = (0, _componentsFormsConditionsJs.EnhancedPolicyRulesConditionsIsExpressionFn)();
	var EnhancedPolicyRulesConditionsIsCollection = (0, _componentsFormsConditionsJs.EnhancedPolicyRulesConditionsIsCollectionFn)();
	var EnhancedPolicyRulesConditionsOperatorType = (0, _componentsFormsConditionsJs.EnhancedPolicyRulesConditionsOperatorTypeFn)();
	var EnhancedPolicyRulesConditionsSourceFormat = (0, _componentsFormsConditionsJs.EnhancedPolicyRulesConditionsSourceFormatFn)();
	var EnhancedPolicyRulesConditionsConditionType = (0, _componentsFormsConditionsJs.EnhancedPolicyRulesConditionsConditionTypeFn)();
	var EnhancedPolicyRulesConditionsValues = (0, _componentsFormsConditionsJs.EnhancedPolicyRulesConditionsValuesFn)();
	var EnhancedPolicyRulesConditionsItem = (0, _componentsFormsConditionsJs.EnhancedPolicyRulesConditionsItemFn)();
	var EnhancedPolicyRulesConditions = (0, _componentsFormsConditionsJs.EnhancedPolicyRulesConditionsFn)();
	
	// --- END Conditions
	
	// --- START Actions
	
	var EnhancedPolicyRulesActionsNewActionsItemType = {
	  displayName: "Type",
	  dataAt: "Actions.$EnhancedPolicyRulesNewActionsItem.Type",
	  optionsAt: "ActionType",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.SELECT
	};
	
	var EnhancedPolicyRulesActionsDisplayMessageType = {
	  displayName: "Type",
	  disabled: true,
	  dataAt: "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem.Type",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var EnhancedPolicyRulesActionsDisplayTitle = {
	  displayName: "Title",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem.DisplayMessage.Title",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  validationRegex: "^.{0,70}$",
	  validationMessage: "The maximum length for the title is 70 characters"
	};
	
	var EnhancedPolicyRulesActionsDisplayMessage = {
	  displayName: "Message",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem.DisplayMessage.Message",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_AREA
	};
	
	var EnhancedPolicyRulesActionsMessagePlacementType = {
	  displayName: "Message Placement Type",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem.DisplayMessage.MessagePlacementType",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.SELECT,
	  optionsAt: "MessagePlacementType"
	};
	
	var EnhancedPolicyRulesActionsMessageSectorTypes = {
	  displayName: "Message Sector Types",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem.DisplayMessage.MessageSectorTypes",
	  optionsAt: "SectorType",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.MULTI_SELECT
	};
	
	var EnhancedPolicyRulesActionsForceCreditCardType = {
	  displayName: "Type",
	  disabled: true,
	  dataAt: "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem.Type",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var EnhancedPolicyRulesActionsForceCreditCardCardApplicationType = {
	  displayName: "CardApplicationType",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem.ForceCreditCard.CardApplicationType",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.SELECT,
	  optionsAt: "CardApplicationType"
	};
	
	var EnhancedPolicyRulesActionsForceCreditCardCardIdentifier = {
	  displayName: "CardIdentifier",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem.ForceCreditCard.CardIdentifier",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.O_DATA_SELECT,
	  endpoint: "CreditCards",
	  searchType: "Title",
	  expression: "contains",
	  searchAllNo: true
	};
	
	var EnhancedPolicyRulesActionsForceCreditCardCardSectorTypes = {
	  displayName: "CardSectorTypes",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem.ForceCreditCard.CardSectorTypes",
	  optionsAt: "CardSectorType",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.MULTI_SELECT
	};
	
	var EnhancedPolicyRulesActionsSectorTypes = {
	  displayName: "Sector Type",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem.SectorType",
	  optionsAt: "SectorType",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.SELECT
	};
	var EnhancedPolicyRulesActionsPolicyViolationListId = {
	  displayName: "ListId",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem.PolicyViolation.ListId",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  html: "Company Reference ListId to pull option values to choose from."
	};
	var EnhancedPolicyRulesActionsPolicyViolationRemarkFormat = {
	  displayName: "RemarkFormat",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem.PolicyViolation.RemarkFormat",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  html: "Smart.Format used to write remark to booking.<br/>Exmple: .S*UD110 VIOLATION CODE {Value}-{Flight.FlightNumber}<br/><i>Properties</i>" + "<ul><li>ValueDescription</li><li>Value</li><li>Flight</li></ul>"
	};
	
	var EnhancedPolicyRulesActionsSetOutOfPolicyItem = {
	  displayName: "Actions Set Out Of Policy",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [EnhancedPolicyRulesActionsDisplayMessageType, EnhancedPolicyRulesActionsSectorTypes, EnhancedPolicyRulesActionsDisplayMessage, EnhancedPolicyRulesActionsPolicyViolationListId, EnhancedPolicyRulesActionsPolicyViolationRemarkFormat],
	  endpoint: "EnhancedPolicyRules",
	  routeParamId: "enhancedPolicyRulesId",
	  removeParamId: "EnhancedPolicyRulesActionsDisplayMessageItem",
	  canDelete: true
	};
	
	var EnhancedPolicyRulesActionsDisplayMessageItem = {
	  displayName: "Actions Display Message",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [EnhancedPolicyRulesActionsDisplayMessageType, EnhancedPolicyRulesActionsDisplayTitle, EnhancedPolicyRulesActionsDisplayMessage, EnhancedPolicyRulesActionsMessagePlacementType, EnhancedPolicyRulesActionsMessageSectorTypes],
	  endpoint: "EnhancedPolicyRules",
	  routeParamId: "enhancedPolicyRulesId",
	  removeParamId: "EnhancedPolicyRulesActionsDisplayMessageItem",
	  canDelete: true
	};
	
	var EnhancedPolicyRulesActionsMessagePopupItem = {
	  displayName: "Actions Message Popup",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [EnhancedPolicyRulesActionsDisplayMessageType, EnhancedPolicyRulesActionsDisplayTitle, EnhancedPolicyRulesActionsDisplayMessage, EnhancedPolicyRulesActionsMessageSectorTypes],
	  endpoint: "EnhancedPolicyRules",
	  routeParamId: "enhancedPolicyRulesId",
	  removeParamId: "EnhancedPolicyRulesActionsDisplayMessageItem",
	  canDelete: true
	};
	
	var EnhancedPolicyRulesActionsPolicyMessageItem = {
	  displayName: "Actions Display Message",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [EnhancedPolicyRulesActionsDisplayMessageType, EnhancedPolicyRulesActionsSectorTypes, EnhancedPolicyRulesActionsDisplayMessage],
	  endpoint: "EnhancedPolicyRules",
	  routeParamId: "enhancedPolicyRulesId",
	  removeParamId: "EnhancedPolicyRulesActionsDisplayMessageItem",
	  canDelete: true
	};
	
	var EnhancedPolicyRulesActionsPolicyItem = {
	  displayName: "Policy Item",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsDisplayMessageItem",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [EnhancedPolicyRulesActionsDisplayMessageType, EnhancedPolicyRulesActionsSectorTypes],
	  endpoint: "EnhancedPolicyRules",
	  routeParamId: "enhancedPolicyRulesId",
	  removeParamId: "EnhancedPolicyRulesActionsDisplayMessageItem",
	  canDelete: true
	};
	
	var EnhancedPolicyRulesActionsPnrRemarksItem = {
	  displayName: "Actions Pnr Remarks",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [_enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksExclusionRemarks, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksStandardRemarks, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksStandardRemarksInfo, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksHostCommands, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksHostCommandsInfo, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksPreTripApprovalRemarksExclusions, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksPreTripApprovalRemarks, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksGuestTravellerRemarksExclusions, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksGuestTravellerRemarks, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksApprovalRemarksExclusions, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksApprovalRemarks, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarksExclusions, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarks, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarksNonRefundableExclusions, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarksNonRefundableRemarks, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksExpiredRemarksExclusions, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksExpiredRemarks, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksCancelRemarksExclusions, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksCancelRemarks, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksModifyRemarksExclusions, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksModifyRemarksRemarks, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksUserHoldRemarksExclusions, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksUserHoldRemarks, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksExpiredUserHoldRemarksExclusions, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksExpiredUserHoldRemarks, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksConfirmedUserHoldRemarksExclusions, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksConfirmedUserHoldRemarks, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksFinisherBookingRemarksExclusions, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksFinishBookingRemarksRemarks, _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksGdsRemarksGrid],
	  endpoint: "EnhancedPolicyRules",
	  routeParamId: "enhancedPolicyRulesId",
	  removeParamId: "EnhancedPolicyRulesActionsPnrRemarksItem",
	  canDelete: true
	};
	
	var EnhancedPolicyRulesActionsPnrExtraActionItem = {
	  displayName: "Actions Pnr Remarks",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [_enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionEmailBooking, _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionEmailModification, _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionEmailCancel, _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionEmaiApproval, _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionEmailError, _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionProfileMovesGrid, _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsGrid],
	  endpoint: "EnhancedPolicyRules",
	  routeParamId: "enhancedPolicyRulesId",
	  removeParamId: "EnhancedPolicyRulesActionsPnrExtraActionItem",
	  canDelete: true
	};
	
	var EnhancedPolicyRulesActionsCardMatchingItemType = {
	  displayName: "Card Type",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem.ForceCreditCard.CreditCardMatches.$CreditCardMatching.Type",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  validationRegex: "^(?:(?:undefined|null|)$|[A-Z]{2})$",
	  validationMessage: "Please enter only 2 letters in capital letters here"
	};
	
	var EnhancedPolicyRulesActionsCardMatchingItemExpirationMonth = {
	  displayName: "Expiration Month",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem.ForceCreditCard.CreditCardMatches.$CreditCardMatching.ExpirationMonth",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  validationRegex: "^(?:(?:undefined|null|)$|0[1-9]|1[0-2])$",
	  validationMessage: "Please enter only 2 digits and a number lower than 12 here"
	};
	
	var EnhancedPolicyRulesActionsCardMatchingItemExpirationYear = {
	  displayName: "Expiration Year",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem.ForceCreditCard.CreditCardMatches.$CreditCardMatching.ExpirationYear",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  validationRegex: "^\\d{4}$|undefined|null|^$",
	  validationMessage: "Please enter only 4 digits here"
	};
	
	var EnhancedPolicyRulesActionsCardMatchingItemCreditNumberLast4 = {
	  displayName: "Last Four Credit Card Digits",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem.ForceCreditCard.CreditCardMatches.$CreditCardMatching.CreditNumberLast4",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  validationRegex: "^\\d{0,4}$|undefined|null|^$",
	  validationMessage: "Please enter only 4 digits here"
	};
	
	var EnhancedPolicyRulesActionsCardMatchingItemCreditNumberFirst4 = {
	  displayName: "First Four Credit Card Digits",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem.ForceCreditCard.CreditCardMatches.$CreditCardMatching.CreditNumberFirst4",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  validationRegex: "^\\d{0,4}$|undefined|null|^$",
	  validationMessage: "Please enter only 4 digits here"
	};
	
	var EnhancedPolicyRulesActionsForceCreditCardCreditCardMatchingItem = {
	  displayName: "Credit Card Matching",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem.ForceCreditCard.CreditCardMatches.$CreditCardMatching",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [EnhancedPolicyRulesActionsCardMatchingItemCreditNumberFirst4, EnhancedPolicyRulesActionsCardMatchingItemCreditNumberLast4, EnhancedPolicyRulesActionsCardMatchingItemExpirationYear, EnhancedPolicyRulesActionsCardMatchingItemExpirationMonth, EnhancedPolicyRulesActionsCardMatchingItemType],
	  endpoint: "EnhancedPolicyRules",
	  routeParamId: "enhancedPolicyRulesId",
	  removeParamId: "CreditCardMatching",
	  validateAtLeastOneHasValueSet: "true",
	  canDelete: true
	};
	
	var EnhancedPolicyRulesActionsForceCreditCardCreditCardMatching = {
	  rootNode: true,
	  displayName: "Credit Card Matching",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem.ForceCreditCard.CreditCardMatches",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  canAddNew: true,
	  gridItem: EnhancedPolicyRulesActionsForceCreditCardCreditCardMatchingItem,
	  gridCols: [{ name: "First Four Credit Card Digits", key: "CreditNumberFirst4" }, { name: "Last Four Credit Card Digits", key: "CreditNumberLast4" }, { name: "Expiration Year", key: "ExpirationYear" }, { name: "Expiration Month", key: "ExpirationMonth" }, { name: "Card Type", key: "Type" }]
	};
	
	var EnhancedPolicyRulesActionsForceCreditCardItem = {
	  displayName: "Actions Force Credit Card",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsForceCreditCardItem",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [EnhancedPolicyRulesActionsForceCreditCardType, EnhancedPolicyRulesActionsForceCreditCardCardApplicationType, EnhancedPolicyRulesActionsForceCreditCardCardIdentifier, EnhancedPolicyRulesActionsForceCreditCardCardSectorTypes, EnhancedPolicyRulesActionsForceCreditCardCreditCardMatching],
	  endpoint: "EnhancedPolicyRules",
	  routeParamId: "enhancedPolicyRulesId",
	  removeParamId: "EnhancedPolicyRulesActionsForceCreditCardItem",
	  canDelete: true
	};
	
	var EnhancedPolicyRulesNewActionsItem = {
	  displayName: "Actions",
	  dataAt: "Actions.$EnhancedPolicyRulesNewActionsItem",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [EnhancedPolicyRulesActionsNewActionsItemType],
	  endpoint: "EnhancedPolicyRules",
	  routeParamId: "enhancedPolicyRulesId",
	  removeParamId: "EnhancedPolicyRulesNewActionsItem",
	  canDelete: true,
	  showAddNewOnOpen: true,
	  addNewRequiredField: "Actions.$EnhancedPolicyRulesNewActionsItem.Type",
	  continueEditPath: getEnhancePolicyPath
	};
	
	var EnhancedPolicyRulesActions = {
	  displayName: "Actions",
	  dataAt: "Actions",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  canAddNew: true,
	  pathSwitcher: enhancedPolicyActionRoute,
	  gridItem: EnhancedPolicyRulesNewActionsItem,
	  gridCols: [{ name: "Type", key: "Type" }, {
	    name: "Info",
	    key: "ActionInfo"
	  }]
	};
	
	// --- END Actions
	
	var EnhancedPolicyRulesName = {
	  displayName: "Name",
	  dataAt: "Name",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var EnhancedPolicyRulesIsEnabled = {
	  displayName: "Is Enabled",
	  dataAt: "IsEnabled",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.BOOLEAN
	};
	
	var EnhancedPolicyRulesEditResource = {
	  displayName: "Enhanced Policy Rules",
	  iconClass: "fa-gear",
	  dataAt: "",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  children: [EnhancedPolicyRulesName, EnhancedPolicyRulesIsEnabled, EnhancedPolicyRulesActions, EnhancedPolicyRulesConditions, EnhancedPolicyRulesDebtors],
	  showBack: false, // Show the Back button. This will hide the other buttons in lbaResource.
	  endpoint: "EnhancedPolicyRules",
	  routeParamId: "enhancedPolicyRulesId",
	  removeParamId: "enhancedPolicyRulesId",
	  canDelete: true,
	  deleteOnBackend: true
	};
	
	var EnhancedPolicyRulesAddResource = {
	  displayAs: _constantsJs2['default'].DISPLAY_AS.ADD_GRID_RESOURCE,
	  displayName: "Enhanced Policy Rules",
	  data: {
	    Id: "",
	    Name: ""
	  },
	  dataAt: "",
	  children: [EnhancedPolicyRulesName],
	  endpoint: "EnhancedPolicyRules"
	};
	
	var EnhancedPolicyRulesGrid = {
	  canAddNew: true,
	  canCopyResource: true,
	  displayName: "Enhanced Policy Rules",
	  displayAs: _constantsJs2['default'].DISPLAY_AS.PAGING_GRID,
	  gridItem: EnhancedPolicyRulesEditResource,
	  gridAdd: EnhancedPolicyRulesAddResource,
	  gridCols: [{ name: "Name", field: "Name" }, { name: "Debtors", field: "DebtorItems" }, { name: "Actions", field: "ActionItems" }, { name: "Enabled", field: "IsEnabled" }, { name: "ModifiedOn", field: "ModifiedOn", cellFilter: 'dateDisplay', width: '165' }],
	  endpoint: "EnhancedPolicyRules"
	};
	
	var EnhancedPolicyRules = {
	  rootNode: true,
	  iconClass: "fa-gear",
	  displayName: "Enhanced Policy Rules",
	  showTitle: false,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GROUP,
	  children: [EnhancedPolicyRulesGrid]
	};
	
	function enhancedPolicyActionRoute(props) {
	  switch (props.Type) {
	    case "ForceCreditCard":
	      return 'actions/force-credit-card';
	    case "DisplayMessage":
	      return 'actions/display-message';
	    case "ShowButNotAllow":
	      return 'actions/policy-message';
	    case "SetOutOfPolicy":
	      return 'actions/set-out-of-policy';
	    case "MessagePopup":
	      return 'actions/message-popup';
	    case "SetInPolicy":
	    case "ExcludeFromLLF":
	    case "ExcludeFare":
	      return 'actions/policy';
	    case "PnrRemarks":
	      return 'actions/pnr-remarks';
	    case "PnrExtraAction":
	      return 'actions/pnr-extra-action';
	    case "PolicySettings":
	      return 'actions/policy-settings';
	    case "LimitPassengerPolicy":
	      return 'actions/limit-passenger-policy';
	    default:
	      return 'actions';
	  }
	}
	
	;
	
	function getEnhancePolicyPath(itemId, index, activeItem) {
	  var actionItem = activeItem.Actions[index];
	  var displayNamePathReady = enhancedPolicyActionRoute(actionItem);
	  return '/enhanced-policy-rules/' + itemId + '/info/' + displayNamePathReady + '/' + index;
	}
	
	exports['default'] = {
	  EnhancedPolicyRulesDebtors: EnhancedPolicyRulesDebtors,
	  EnhancedPolicyRulesDebtorsItem: EnhancedPolicyRulesDebtorsItem,
	  EnhancedPolicyRulesDebtorsDebtorIdentifier: EnhancedPolicyRulesDebtorsDebtorIdentifier,
	  EnhancedPolicyRulesDebtorsPolicyCodes: EnhancedPolicyRulesDebtorsPolicyCodes,
	  EnhancedPolicyRulesDebtorsCountryCodes: EnhancedPolicyRulesDebtorsCountryCodes,
	
	  EnhancedPolicyRulesConditionsCollectionOperationType: EnhancedPolicyRulesConditionsCollectionOperationType,
	  EnhancedPolicyRulesConditionsIsExpression: EnhancedPolicyRulesConditionsIsExpression,
	  EnhancedPolicyRulesConditionsIsCollection: EnhancedPolicyRulesConditionsIsCollection,
	  EnhancedPolicyRulesConditionsOperatorType: EnhancedPolicyRulesConditionsOperatorType,
	  EnhancedPolicyRulesConditionsSourceFormat: EnhancedPolicyRulesConditionsSourceFormat,
	  EnhancedPolicyRulesConditionsConditionType: EnhancedPolicyRulesConditionsConditionType,
	  EnhancedPolicyRulesConditionsValues: EnhancedPolicyRulesConditionsValues,
	  EnhancedPolicyRulesConditions: EnhancedPolicyRulesConditions,
	  EnhancedPolicyRulesConditionsItem: EnhancedPolicyRulesConditionsItem,
	
	  EnhancedPolicyRulesActionsDisplayMessageType: EnhancedPolicyRulesActionsDisplayMessageType,
	  EnhancedPolicyRulesActionsForceCreditCardType: EnhancedPolicyRulesActionsForceCreditCardType,
	  EnhancedPolicyRulesActionsDisplayTitle: EnhancedPolicyRulesActionsDisplayTitle,
	  EnhancedPolicyRulesActionsDisplayMessage: EnhancedPolicyRulesActionsDisplayMessage,
	  EnhancedPolicyRulesActionsMessagePlacementType: EnhancedPolicyRulesActionsMessagePlacementType,
	  EnhancedPolicyRulesActionsMessageSectorTypes: EnhancedPolicyRulesActionsMessageSectorTypes,
	  EnhancedPolicyRulesActionsForceCreditCardCardApplicationType: EnhancedPolicyRulesActionsForceCreditCardCardApplicationType,
	  EnhancedPolicyRulesActionsForceCreditCardCardIdentifier: EnhancedPolicyRulesActionsForceCreditCardCardIdentifier,
	  EnhancedPolicyRulesActionsForceCreditCardCardSectorTypes: EnhancedPolicyRulesActionsForceCreditCardCardSectorTypes,
	  EnhancedPolicyRulesActionsForceCreditCardItem: EnhancedPolicyRulesActionsForceCreditCardItem,
	  EnhancedPolicyRulesActionsDisplayMessageItem: EnhancedPolicyRulesActionsDisplayMessageItem,
	  EnhancedPolicyRulesActionsPolicyMessageItem: EnhancedPolicyRulesActionsPolicyMessageItem,
	  EnhancedPolicyRulesActionsPolicyItem: EnhancedPolicyRulesActionsPolicyItem,
	  EnhancedPolicyRulesActionsPnrRemarksItem: EnhancedPolicyRulesActionsPnrRemarksItem,
	  EnhancedPolicyRulesActionsNewActionsItemType: EnhancedPolicyRulesActionsNewActionsItemType,
	  EnhancedPolicyRulesNewActionsItem: EnhancedPolicyRulesNewActionsItem,
	  EnhancedPolicyRulesActions: EnhancedPolicyRulesActions,
	  EnhancedPolicyRulesActionsForceCreditCardCreditCardMatching: EnhancedPolicyRulesActionsForceCreditCardCreditCardMatching,
	  EnhancedPolicyRulesActionsForceCreditCardCreditCardMatchingItem: EnhancedPolicyRulesActionsForceCreditCardCreditCardMatchingItem,
	  EnhancedPolicyRulesActionsCardMatchingItemCreditNumberFirst4: EnhancedPolicyRulesActionsCardMatchingItemCreditNumberFirst4,
	  EnhancedPolicyRulesActionsCardMatchingItemCreditNumberLast4: EnhancedPolicyRulesActionsCardMatchingItemCreditNumberLast4,
	  EnhancedPolicyRulesActionsCardMatchingItemExpirationYear: EnhancedPolicyRulesActionsCardMatchingItemExpirationYear,
	  EnhancedPolicyRulesActionsCardMatchingItemExpirationMonth: EnhancedPolicyRulesActionsCardMatchingItemExpirationMonth,
	  EnhancedPolicyRulesActionsCardMatchingItemType: EnhancedPolicyRulesActionsCardMatchingItemType,
	  EnhancedPolicyRules: EnhancedPolicyRules,
	  EnhancedPolicyRulesGrid: EnhancedPolicyRulesGrid,
	  EnhancedPolicyRulesAddResource: EnhancedPolicyRulesAddResource,
	  EnhancedPolicyRulesEditResource: EnhancedPolicyRulesEditResource,
	  EnhancedPolicyRulesName: EnhancedPolicyRulesName,
	  EnhancedPolicyRulesIsEnabled: EnhancedPolicyRulesIsEnabled,
	
	  EnhancedPolicyRulesActionsMessagePopupItem: EnhancedPolicyRulesActionsMessagePopupItem,
	  EnhancedPolicyRulesActionsSetOutOfPolicyItem: EnhancedPolicyRulesActionsSetOutOfPolicyItem,
	  EnhancedPolicyRulesActionsPolicyViolationListId: EnhancedPolicyRulesActionsPolicyViolationListId,
	  EnhancedPolicyRulesActionsPolicyViolationRemarkFormat: EnhancedPolicyRulesActionsPolicyViolationRemarkFormat,
	  EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem: _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem,
	  EnhancedPolicyRulesActionsPnrRemarksGdsRemarksName: _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksGdsRemarksName,
	  EnhancedPolicyRulesActionsPnrRemarksGdsRemarksFinishingRemarksExclusions: _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksGdsRemarksFinishingRemarksExclusions,
	  EnhancedPolicyRulesActionsPnrRemarksGdsRemarksFinishingRemarks: _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksGdsRemarksFinishingRemarks,
	  EnhancedPolicyRulesActionsPnrRemarksGdsRemarksSeatRemarks: _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksGdsRemarksSeatRemarks,
	  EnhancedPolicyRulesActionsPnrRemarksGdsRemarksAncillaryRemarks: _enhancedPolicyRulesPnrRemarks.EnhancedPolicyRulesActionsPnrRemarksGdsRemarksAncillaryRemarks,
	
	  EnhancedPolicyRulesActionsPnrExtraActionItem: EnhancedPolicyRulesActionsPnrExtraActionItem,
	  EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem: _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem,
	  EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem: _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem,
	  EnhancedPolicyRulesActionsPnrExtraActionEmailBooking: _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionEmailBooking,
	  EnhancedPolicyRulesActionsPnrExtraActionEmailModification: _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionEmailModification,
	  EnhancedPolicyRulesActionsPnrExtraActionEmailCancel: _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionEmailCancel,
	  EnhancedPolicyRulesActionsPnrExtraActionEmaiApproval: _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionEmaiApproval,
	  EnhancedPolicyRulesActionsPnrExtraActionEmailError: _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionEmailError,
	  EnhancedPolicyRulesActionsPnrExtraActionProfileMoveProfileId: _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionProfileMoveProfileId,
	  EnhancedPolicyRulesActionsPnrExtraActionProfileMoveProfileTypeCode: _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionProfileMoveProfileTypeCode,
	  EnhancedPolicyRulesActionsPnrExtraActionProfileMovePcc: _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionProfileMovePcc,
	  EnhancedPolicyRulesActionsPnrExtraActionProfileMovePnrBuilder: _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionProfileMovePnrBuilder,
	  EnhancedPolicyRulesActionsPnrExtraActionProfileMovesGrid: _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionProfileMovesGrid,
	  EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsQueueActionType: _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsQueueActionType,
	  EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsNumber: _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsNumber,
	  EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsPcc: _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsPcc,
	  EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsPrefatoryInstructionCode: _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsPrefatoryInstructionCode,
	  EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsGrid: _enhancedPolicyRulesPnrExtraAction.EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsGrid,
	
	  EnhancedPolicyFlightModificationSettingItem: _enhancedPolicyRulesPolicySettings.EnhancedPolicyFlightModificationSettingItem,
	  EnhancedPolicyRulesActionsPolicySettingsItem: _enhancedPolicyRulesPolicySettings.EnhancedPolicyRulesActionsPolicySettingsItem,
	  EnhancedPolicyFlightSearchConfigurationItem: _enhancedPolicyRulesPolicySettings.EnhancedPolicyFlightSearchConfigurationItem,
	
	  EnhancedPolicyRulesActionsLimitPassengerItem: _enhancedPolicyRulesLimitPassengerJs.EnhancedPolicyRulesActionsLimitPassengerItem,
	  EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem: _enhancedPolicyRulesLimitPassengerJs.EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem
	};

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var EnhancedPolicyRulesActionsPnrRemarksExclusionRemarks = {
	    displayName: "Exclusion Remarks",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.PnrFinishingRemarks.ExclusionRemarks",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksExclusionRemarks = EnhancedPolicyRulesActionsPnrRemarksExclusionRemarks;
	var EnhancedPolicyRulesActionsPnrRemarksStandardRemarks = {
	    displayName: "Standard Remarks",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.PnrFinishingRemarks.StandardRemarks",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksStandardRemarks = EnhancedPolicyRulesActionsPnrRemarksStandardRemarks;
	var EnhancedPolicyRulesActionsPnrRemarksStandardRemarksInfo = {
	    displayAs: _constantsJs2["default"].DISPLAY_AS.SUB_HEADING,
	    html: "<ol start='0'>" + "<li>Itinerary</li>" + "<li>ItineraryPassenger</li>" + "<li>List&ltItineraryPassengerHotel&gt</li>" + "<li>List&ltItineraryPassengerFlight&gt</li>" + "<li>List&ltItineraryPassengerCar&gt</li>" + "<li>Debtor</li>" + "<li>string Role</li>" + "<li>object GuestTraveller</li>" + "<li>ItineraryPassengerApprover</li>" + "<li>List&ltItineraryPassengerRail&gt</li>" + "<li>{ TimePolicyCode, TimePolicyTitle, IsInTimePolicy, LeadTimeForInPolicyBooking }</li>" + "<li>List&ltItineraryPassengerGroundTrans&gt</li>" + "<li>DateTime.Now</li>" + "<li>List&ltAirTicket&gt</li>" + "<li>List&ltRailTicket&gt</li>" + "<li>List&ltVirtualPayments&gt</li>" + "<li>List&ltVirtualPaymentCanceled&gt</li>" + "<li>{ LoggedInUserEmail, LoggedInUserName, LoggedInEmployeeCode, LoggedInEmployeeNumber, LoggedInEmployeeDepartment, LoggedInEmployeeCostCenter, LoggedInUserRole }</li>" + "</ol>"
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksStandardRemarksInfo = EnhancedPolicyRulesActionsPnrRemarksStandardRemarksInfo;
	var EnhancedPolicyRulesActionsPnrRemarksHostCommands = {
	    displayName: "Host Commands",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.HostCommands",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksHostCommands = EnhancedPolicyRulesActionsPnrRemarksHostCommands;
	var EnhancedPolicyRulesActionsPnrRemarksHostCommandsInfo = {
	    displayAs: _constantsJs2["default"].DISPLAY_AS.SUB_HEADING,
	    html: "<ol start='0'>" + "<li>Debtor</li>" + "<li>ItineraryPassenger</li>" + "<li>object CurrentUser</li>" + "<li>CreditCardDetails</li>" + "<li>string PassengerCreditCardShortYear</li>" + "<li>List&ltAirTicket&gt</li>" + "<li>List&ltRailTicket&gt</li>" + "</ol>"
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksHostCommandsInfo = EnhancedPolicyRulesActionsPnrRemarksHostCommandsInfo;
	var EnhancedPolicyRulesActionsPnrRemarksPreTripApprovalRemarksExclusions = {
	    displayName: "Pre Trip Approval Remarks Exclusions",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.PnrFinishingRemarks.PreTripApprovalRemarks.Exclusions",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksPreTripApprovalRemarksExclusions = EnhancedPolicyRulesActionsPnrRemarksPreTripApprovalRemarksExclusions;
	var EnhancedPolicyRulesActionsPnrRemarksPreTripApprovalRemarks = {
	    displayName: "Pre Trip Approval Remarks",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.PnrFinishingRemarks.PreTripApprovalRemarks.Remarks",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksPreTripApprovalRemarks = EnhancedPolicyRulesActionsPnrRemarksPreTripApprovalRemarks;
	var EnhancedPolicyRulesActionsPnrRemarksGuestTravellerRemarksExclusions = {
	    displayName: "Guest Traveller Remarks Exclusions",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.PnrFinishingRemarks.GuestTravellerRemarks.Exclusions",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksGuestTravellerRemarksExclusions = EnhancedPolicyRulesActionsPnrRemarksGuestTravellerRemarksExclusions;
	var EnhancedPolicyRulesActionsPnrRemarksGuestTravellerRemarks = {
	    displayName: "Guest Traveller Remarks",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.PnrFinishingRemarks.GuestTravellerRemarks.Remarks",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksGuestTravellerRemarks = EnhancedPolicyRulesActionsPnrRemarksGuestTravellerRemarks;
	var EnhancedPolicyRulesActionsPnrRemarksApprovalRemarksExclusions = {
	    displayName: "Approval Remarks Exclusions",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.ApprovalRemarks.Exclusions",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksApprovalRemarksExclusions = EnhancedPolicyRulesActionsPnrRemarksApprovalRemarksExclusions;
	var EnhancedPolicyRulesActionsPnrRemarksApprovalRemarks = {
	    displayName: "Approval Remarks",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.ApprovalRemarks.Remarks",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksApprovalRemarks = EnhancedPolicyRulesActionsPnrRemarksApprovalRemarks;
	var EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarksExclusions = {
	    displayName: "Declined Remarks Exclusions",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.DeclinedRemarks.Exclusions",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarksExclusions = EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarksExclusions;
	var EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarks = {
	    displayName: "Declined Remarks",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.DeclinedRemarks.Remarks",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarks = EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarks;
	var EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarksNonRefundableExclusions = {
	    displayName: "Declined Remarks NonRefundable Exclusions",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.DeclinedRemarksNonRefundable.Exclusions",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarksNonRefundableExclusions = EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarksNonRefundableExclusions;
	var EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarksNonRefundableRemarks = {
	    displayName: "Declined Remarks NonRefundable Remarks",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.DeclinedRemarksNonRefundable.Remarks",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarksNonRefundableRemarks = EnhancedPolicyRulesActionsPnrRemarksDeclinedRemarksNonRefundableRemarks;
	var EnhancedPolicyRulesActionsPnrRemarksExpiredRemarksExclusions = {
	    displayName: "Expired Remarks Exclusions",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.ExpiredRemarks.Exclusions",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksExpiredRemarksExclusions = EnhancedPolicyRulesActionsPnrRemarksExpiredRemarksExclusions;
	var EnhancedPolicyRulesActionsPnrRemarksExpiredRemarks = {
	    displayName: "Expired Remarks",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.ExpiredRemarks.Remarks",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksExpiredRemarks = EnhancedPolicyRulesActionsPnrRemarksExpiredRemarks;
	var EnhancedPolicyRulesActionsPnrRemarksCancelRemarksExclusions = {
	    displayName: "Cancel Remarks Exclusions",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.CancelRemarks.Exclusions",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksCancelRemarksExclusions = EnhancedPolicyRulesActionsPnrRemarksCancelRemarksExclusions;
	var EnhancedPolicyRulesActionsPnrRemarksCancelRemarks = {
	    displayName: "Cancel Remarks",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.CancelRemarks.Remarks",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksCancelRemarks = EnhancedPolicyRulesActionsPnrRemarksCancelRemarks;
	var EnhancedPolicyRulesActionsPnrRemarksModifyRemarksExclusions = {
	    displayName: "Modify Remarks Exclusions",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.ModifyRemarks.Exclusions",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksModifyRemarksExclusions = EnhancedPolicyRulesActionsPnrRemarksModifyRemarksExclusions;
	var EnhancedPolicyRulesActionsPnrRemarksModifyRemarksRemarks = {
	    displayName: "Modify Remarks",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.ModifyRemarks.Remarks",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksModifyRemarksRemarks = EnhancedPolicyRulesActionsPnrRemarksModifyRemarksRemarks;
	var EnhancedPolicyRulesActionsPnrRemarksUserHoldRemarksExclusions = {
	    displayName: "User Hold Remarks Exclusions",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.UserHoldRemarks.Exclusions",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksUserHoldRemarksExclusions = EnhancedPolicyRulesActionsPnrRemarksUserHoldRemarksExclusions;
	var EnhancedPolicyRulesActionsPnrRemarksUserHoldRemarks = {
	    displayName: "User Hold Remarks",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.UserHoldRemarks.Remarks",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksUserHoldRemarks = EnhancedPolicyRulesActionsPnrRemarksUserHoldRemarks;
	var EnhancedPolicyRulesActionsPnrRemarksExpiredUserHoldRemarksExclusions = {
	    displayName: "Expired User Hold Remarks Exclusions",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.ExpiredUserHoldRemarks.Exclusions",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksExpiredUserHoldRemarksExclusions = EnhancedPolicyRulesActionsPnrRemarksExpiredUserHoldRemarksExclusions;
	var EnhancedPolicyRulesActionsPnrRemarksExpiredUserHoldRemarks = {
	    displayName: "Expired User Hold Remarks",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.ExpiredUserHoldRemarks.Remarks",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksExpiredUserHoldRemarks = EnhancedPolicyRulesActionsPnrRemarksExpiredUserHoldRemarks;
	var EnhancedPolicyRulesActionsPnrRemarksConfirmedUserHoldRemarksExclusions = {
	    displayName: "Confirmed User Hold Remarks Exclusions",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.ConfirmedUserHoldRemarks.Exclusions",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksConfirmedUserHoldRemarksExclusions = EnhancedPolicyRulesActionsPnrRemarksConfirmedUserHoldRemarksExclusions;
	var EnhancedPolicyRulesActionsPnrRemarksConfirmedUserHoldRemarks = {
	    displayName: "Confirmed User Hold Remarks",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.ConfirmedUserHoldRemarks.Remarks",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksConfirmedUserHoldRemarks = EnhancedPolicyRulesActionsPnrRemarksConfirmedUserHoldRemarks;
	var EnhancedPolicyRulesActionsPnrRemarksFinisherBookingRemarksExclusions = {
	    displayName: "Finish Booking Remarks Exclusions",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.FinishBookingRemarks.Exclusions",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksFinisherBookingRemarksExclusions = EnhancedPolicyRulesActionsPnrRemarksFinisherBookingRemarksExclusions;
	var EnhancedPolicyRulesActionsPnrRemarksFinishBookingRemarksRemarks = {
	    displayName: "Finish Booking Remarks",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.AdditionalPnrRemarks.FinishBookingRemarks.Remarks",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksFinishBookingRemarksRemarks = EnhancedPolicyRulesActionsPnrRemarksFinishBookingRemarksRemarks;
	var EnhancedPolicyRulesActionsPnrRemarksGdsRemarksName = {
	    displayName: "Name",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.GdsRemarks.$EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem.Name",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksGdsRemarksName = EnhancedPolicyRulesActionsPnrRemarksGdsRemarksName;
	var EnhancedPolicyRulesActionsPnrRemarksGdsRemarksFinishingRemarksExclusions = {
	    displayName: "Finishing Remarks Exclusions",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.GdsRemarks.$EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem.FinishingRemarks.Exclusions",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksGdsRemarksFinishingRemarksExclusions = EnhancedPolicyRulesActionsPnrRemarksGdsRemarksFinishingRemarksExclusions;
	var EnhancedPolicyRulesActionsPnrRemarksGdsRemarksFinishingRemarks = {
	    displayName: "Finishing Remarks",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.GdsRemarks.$EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem.FinishingRemarks.Remarks",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksGdsRemarksFinishingRemarks = EnhancedPolicyRulesActionsPnrRemarksGdsRemarksFinishingRemarks;
	var EnhancedPolicyRulesActionsPnrRemarksGdsRemarksSeatRemarks = {
	    displayName: "Seat Remarks",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.GdsRemarks.$EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem.SeatRemarks",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksGdsRemarksSeatRemarks = EnhancedPolicyRulesActionsPnrRemarksGdsRemarksSeatRemarks;
	var EnhancedPolicyRulesActionsPnrRemarksGdsRemarksAncillaryRemarks = {
	    displayName: "Ancillary Remarks",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.GdsRemarks.$EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem.AncillaryRemarks",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksGdsRemarksAncillaryRemarks = EnhancedPolicyRulesActionsPnrRemarksGdsRemarksAncillaryRemarks;
	var EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem = {
	    displayName: "Item",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.GdsRemarks.$EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	    children: [EnhancedPolicyRulesActionsPnrRemarksGdsRemarksName, EnhancedPolicyRulesActionsPnrRemarksGdsRemarksFinishingRemarksExclusions, EnhancedPolicyRulesActionsPnrRemarksGdsRemarksFinishingRemarks, EnhancedPolicyRulesActionsPnrRemarksGdsRemarksSeatRemarks, EnhancedPolicyRulesActionsPnrRemarksGdsRemarksAncillaryRemarks],
	    endpoint: "EnhancedPolicyRules",
	    removeParamId: "EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem",
	    canDelete: true
	};
	
	exports.EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem = EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem;
	var EnhancedPolicyRulesActionsPnrRemarksGdsRemarksGrid = {
	    displayName: "Gds Remarks",
	    dataAt: "Actions.$EnhancedPolicyRulesActionsPnrRemarksItem.PnrRemarks.GdsRemarks",
	    displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	    canCopyItem: true,
	    canAddNew: true,
	    gridItem: EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem,
	    gridCols: [{ name: "Name", key: "Name" }]
	};
	exports.EnhancedPolicyRulesActionsPnrRemarksGdsRemarksGrid = EnhancedPolicyRulesActionsPnrRemarksGdsRemarksGrid;

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var EnhancedPolicyRulesActionsPnrExtraActionEmailBooking = {
	  displayName: "Email Booking",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.EmailBooking",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	exports.EnhancedPolicyRulesActionsPnrExtraActionEmailBooking = EnhancedPolicyRulesActionsPnrExtraActionEmailBooking;
	var EnhancedPolicyRulesActionsPnrExtraActionEmailModification = {
	  displayName: "Email Modification",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.EmailModification",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	exports.EnhancedPolicyRulesActionsPnrExtraActionEmailModification = EnhancedPolicyRulesActionsPnrExtraActionEmailModification;
	var EnhancedPolicyRulesActionsPnrExtraActionEmailCancel = {
	  displayName: "Email Cancel",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.EmailCancel",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	exports.EnhancedPolicyRulesActionsPnrExtraActionEmailCancel = EnhancedPolicyRulesActionsPnrExtraActionEmailCancel;
	var EnhancedPolicyRulesActionsPnrExtraActionEmaiApproval = {
	  displayName: "Email Approval",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.EmaiApproval",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	exports.EnhancedPolicyRulesActionsPnrExtraActionEmaiApproval = EnhancedPolicyRulesActionsPnrExtraActionEmaiApproval;
	var EnhancedPolicyRulesActionsPnrExtraActionEmailError = {
	  displayName: "Email Error",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.EmailError",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrExtraActionEmailError = EnhancedPolicyRulesActionsPnrExtraActionEmailError;
	var EnhancedPolicyRulesActionsPnrExtraActionProfileMoveProfileId = {
	  displayName: "ProfileId",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.ProfileMoves.$EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem.ProfileId",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  validationRegex: "^\\d+$|undefined|null|^$",
	  validationMessage: "Please enter only numerical digits here"
	};
	exports.EnhancedPolicyRulesActionsPnrExtraActionProfileMoveProfileId = EnhancedPolicyRulesActionsPnrExtraActionProfileMoveProfileId;
	var EnhancedPolicyRulesActionsPnrExtraActionProfileMoveProfileTypeCode = {
	  displayName: "ProfileTypeCode",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.ProfileMoves.$EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem.ProfileTypeCode",
	  optionsAt: "ProfileTypes",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT
	};
	
	exports.EnhancedPolicyRulesActionsPnrExtraActionProfileMoveProfileTypeCode = EnhancedPolicyRulesActionsPnrExtraActionProfileMoveProfileTypeCode;
	var EnhancedPolicyRulesActionsPnrExtraActionProfileMovePcc = {
	  displayName: "Pcc",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.ProfileMoves.$EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem.Pcc",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  validationRegex: "^[a-zA-Z0-9]{4,4}$|undefined|null|^$",
	  validationMessage: "Please enter only 4 alpha numerical characters"
	};
	
	exports.EnhancedPolicyRulesActionsPnrExtraActionProfileMovePcc = EnhancedPolicyRulesActionsPnrExtraActionProfileMovePcc;
	var EnhancedPolicyRulesActionsPnrExtraActionProfileMovePnrBuilder = {
	  displayName: "PnrBuilder",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.ProfileMoves.$EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem.PnrBuilder",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	exports.EnhancedPolicyRulesActionsPnrExtraActionProfileMovePnrBuilder = EnhancedPolicyRulesActionsPnrExtraActionProfileMovePnrBuilder;
	var EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem = {
	  displayName: "Item",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.ProfileMoves.$EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [EnhancedPolicyRulesActionsPnrExtraActionProfileMoveProfileId, EnhancedPolicyRulesActionsPnrExtraActionProfileMoveProfileTypeCode, EnhancedPolicyRulesActionsPnrExtraActionProfileMovePcc, EnhancedPolicyRulesActionsPnrExtraActionProfileMovePnrBuilder],
	  endpoint: "EnhancedPolicyRules",
	  removeParamId: "EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem",
	  canDelete: true
	};
	
	exports.EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem = EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem;
	var EnhancedPolicyRulesActionsPnrExtraActionProfileMovesGrid = {
	  displayName: "Profile Moves",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.ProfileMoves",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem,
	  gridCols: [{ name: "ProfileId", key: "ProfileId" }, { name: "ProfileTypeCode", key: "ProfileTypeCode" }, { name: "Pcc", key: "Pcc" }, { name: "PnrBuilder", key: "PnrBuilder" }]
	};
	
	exports.EnhancedPolicyRulesActionsPnrExtraActionProfileMovesGrid = EnhancedPolicyRulesActionsPnrExtraActionProfileMovesGrid;
	var EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsQueueActionType = {
	  displayName: "Queue Action",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.QueuePlacements.$EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem.QueueActionType",
	  optionsAt: "QueueActionTypes",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT
	};
	
	exports.EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsQueueActionType = EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsQueueActionType;
	var EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsNumber = {
	  displayName: "Number",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.QueuePlacements.$EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem.Number",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  validationRegex: "^[0-9]{1,3}$|undefined|null|^$",
	  validationMessage: "Please enter only valid queue numbers"
	};
	exports.EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsNumber = EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsNumber;
	var EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsPcc = {
	  displayName: "Pcc",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.QueuePlacements.$EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem.Pcc",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  validationRegex: "^[a-zA-Z0-9]{4,4}$|undefined|null|^$",
	  validationMessage: "Please enter only 4 Alpha Numeric Characters",
	  label: "Optional, leave blank to use debtor configured Pcc."
	};
	exports.EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsPcc = EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsPcc;
	var EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsPrefatoryInstructionCode = {
	  displayName: "Prefactory Code",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.QueuePlacements.$EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem.PrefatoryInstructionCode",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  validationRegex: "^[0-9]{1,3}$|undefined|null|^$",
	  validationMessage: "Please enter only valid prefactory codes",
	  label: "Optional, leave blank to use prefactory code used along with queue action selected."
	};
	exports.EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsPrefatoryInstructionCode = EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsPrefatoryInstructionCode;
	var EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem = {
	  displayName: "Item",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.QueuePlacements.$EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsQueueActionType, EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsNumber, EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsPcc, EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsPrefatoryInstructionCode],
	  endpoint: "EnhancedPolicyRules",
	  removeParamId: "EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem",
	  canDelete: true
	};
	
	exports.EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem = EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem;
	var EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsGrid = {
	  displayName: "Queue Placements",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPnrExtraActionItem.PnrExtraAction.QueuePlacements",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem,
	  gridCols: [{ name: "QueueActionType", key: "QueueActionType" }, { name: "Number", key: "Number" }, { name: "Pcc", key: "Pcc" }, { name: "PrefatoryInstructionCode", key: "PrefatoryInstructionCode" }]
	};
	exports.EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsGrid = EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsGrid;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var EnhancedPolicyWeight = {
	  displayName: "Weight (Highest weight will apply in conflicting policy settings)",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.Weight",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RANGE,
	  min: 0,
	  max: 1000,
	  step: 1
	};
	
	exports.EnhancedPolicyWeight = EnhancedPolicyWeight;
	var TravellerConfigurationProfilePnrBuilder = {
	  displayName: "Traveler Configuration Profile PNR Builder",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.ProfilePnrBuilder",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var ApplyVirtualCreditCard = {
	  displayName: "Apply Virtual Credit Card",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.ApplyVirtualCreditCard",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "HotelApplyVirtualCreditCardTypes",
	  defaultValue: null,
	  allowNullable: true
	};
	
	exports.ApplyVirtualCreditCard = ApplyVirtualCreditCard;
	//Start FlightModificationSettingGdsProviders
	var FlightModificationSettingGdsProviders = {
	  displayName: "Gds Providers",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightModificationSettings.$iiflightModificationSettingItem.GdsProviders",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.MULTI_SELECT,
	  optionsAt: "GDSProviders"
	};
	
	exports.FlightModificationSettingGdsProviders = FlightModificationSettingGdsProviders;
	var FlightModificationSettingCarriersExcluded = {
	  displayName: "Carriers Excluded",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightModificationSettings.$iiflightModificationSettingItem.CarriersExcluded",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.FlightModificationSettingCarriersExcluded = FlightModificationSettingCarriersExcluded;
	var FlightModificationSettingCarriersIncluded = {
	  displayName: "Carriers Included",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightModificationSettings.$iiflightModificationSettingItem.CarriersIncluded",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	exports.FlightModificationSettingCarriersIncluded = FlightModificationSettingCarriersIncluded;
	var FlightModificationSettingEnableCancelRebook = {
	  displayName: "Enable Cancel Rebook",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightModificationSettings.$iiflightModificationSettingItem.EnableCancelRebook",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	exports.FlightModificationSettingEnableCancelRebook = FlightModificationSettingEnableCancelRebook;
	var FlightModificationSettingEnableExchanges = {
	  displayName: "Enable Exchanges",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightModificationSettings.$iiflightModificationSettingItem.EnableExchanges",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	exports.FlightModificationSettingEnableExchanges = FlightModificationSettingEnableExchanges;
	var FlightModificationSettingEnableAdd = {
	  displayName: "Enable Add",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightModificationSettings.$iiflightModificationSettingItem.EnableAdd",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	exports.FlightModificationSettingEnableAdd = FlightModificationSettingEnableAdd;
	var EnhancedPolicyFlightModificationSettingItem = {
	  displayName: "Item",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightModificationSettings.$iiflightModificationSettingItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [FlightModificationSettingGdsProviders, FlightModificationSettingCarriersExcluded, FlightModificationSettingCarriersIncluded, FlightModificationSettingEnableCancelRebook, FlightModificationSettingEnableExchanges, FlightModificationSettingEnableAdd],
	  endpoint: "EnhancedPolicyRules",
	  removeParamId: "iiflightModificationSettingItem",
	  canDelete: true
	};
	exports.EnhancedPolicyFlightModificationSettingItem = EnhancedPolicyFlightModificationSettingItem;
	var EnhancedPolicyFlightModificationSettingsGrid = {
	  tabName: "Flight-Modification-Settings",
	  displayName: "Flight Modification Settings",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightModificationSettings",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  copyWithoutCopyText: true,
	  gridItem: EnhancedPolicyFlightModificationSettingItem,
	  gridCols: [{ name: "Providers", key: "GdsProviders" }, { name: "CancelRebook", key: "EnableCancelRebook" }, { name: "Exchanges", key: "EnableExchanges" }, { name: "Add", key: "EnableAdd" }, { name: "Excluded", key: "CarriersExcluded" }, { name: "Included", key: "CarriersIncluded" }]
	};
	exports.EnhancedPolicyFlightModificationSettingsGrid = EnhancedPolicyFlightModificationSettingsGrid;
	//End FlightModificationSettingGdsProviders
	
	//Start FlightSearch
	var EnhancedPolicyFlightSearchConfigurationConfigurationType = {
	  displayName: "Flight Search Configuration Type",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.ConfigurationType",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "FlightSearchConfigurationType"
	};
	
	exports.EnhancedPolicyFlightSearchConfigurationConfigurationType = EnhancedPolicyFlightSearchConfigurationConfigurationType;
	var FlightSearchConfigurationCarrierType = {
	  displayName: "Carrier Type",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.CarrierType",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "FlightSearchConfigurationQueryItemsType",
	  helpText: "Single: 1 search performed which includes all defined carriers. Multi: 1 search for each carrier defined."
	};
	
	exports.FlightSearchConfigurationCarrierType = FlightSearchConfigurationCarrierType;
	var FlightSearchConfigurationCarriers = {
	  displayName: "Carriers",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.Carriers",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT,
	  html: "<span class=\"help-block\">" + "Named lists are supported. Wrap name in ~ characters. Example: ~ExcludedCarriers~<br/><br />" + "Enter XX with carrier type = Multi will perform an exclusion with all the other carriers excluded.<br/>" + "Example: XX, AA entered as values will perform 2 queries. 1 with AA and another with excluding AA and any other configured excluded carriers." + "</span>"
	};
	
	exports.FlightSearchConfigurationCarriers = FlightSearchConfigurationCarriers;
	var FlightSearchConfigurationExcludeCarriers = {
	  displayName: "Exclude Carriers",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.ExcludeCarriers",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT,
	  helpText: "Named lists are supported. Wrap name in ~ characters. Example: ~ExcludedCarriers~"
	};
	
	exports.FlightSearchConfigurationExcludeCarriers = FlightSearchConfigurationExcludeCarriers;
	var FlightSearchConfigurationCabinType = {
	  displayName: "Cabin Type",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.CabinType",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "FlightSearchConfigurationQueryItemsTypeMultiOnly",
	  helpText: "Sabre only supports single cabin queries. Therefore Multi is the only available option."
	};
	
	exports.FlightSearchConfigurationCabinType = FlightSearchConfigurationCabinType;
	var FlightSearchConfigurationCabins = {
	  displayName: "Cabins",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.Cabins",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.MULTI_SELECT,
	  optionsAt: "FlightCabins"
	};
	
	exports.FlightSearchConfigurationCabins = FlightSearchConfigurationCabins;
	var FlightSearchPassengerTypes = {
	  displayName: "Passenger Types",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.PassengerTypes",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.MULTI_SELECT,
	  optionsAt: "PassengerTypes",
	  allowFreeform: true,
	  transformUppercase: true,
	  validationRegex: "^[A-Z0-9]{3}$",
	  validationMessage: "Each passenger type must be exactly 3 alphanumeric characters"
	};
	
	exports.FlightSearchPassengerTypes = FlightSearchPassengerTypes;
	var FlightSearchConfigurationIncDebtorPreferred = {
	  displayName: "Include Debtor Preferred",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.IncDebtorPreferred",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	exports.FlightSearchConfigurationIncDebtorPreferred = FlightSearchConfigurationIncDebtorPreferred;
	var FlightSearchConfigurationRefundableSearch = {
	  displayName: "Penalty Search Type",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.RefundableSearchTypes",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.MULTI_SELECT,
	  optionsAt: "PenaltySearchTypes"
	};
	
	exports.FlightSearchConfigurationRefundableSearch = FlightSearchConfigurationRefundableSearch;
	var FlightSearchConfigurationUnbrandedSearch = {
	  displayName: "Unbranded Search",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.UnbrandedSearch",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	exports.FlightSearchConfigurationUnbrandedSearch = FlightSearchConfigurationUnbrandedSearch;
	var FlightSearchConfigurationEnableATPCO = {
	  displayName: "Enable ATPCO",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.EnableATPCO",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	exports.FlightSearchConfigurationEnableATPCO = FlightSearchConfigurationEnableATPCO;
	var FlightSearchConfigurationEnableNDC = {
	  displayName: "Enable NDC",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.EnableNDC",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN,
	  helpText: "Leave Enabled ATPCO and Enabled NDC un-checked to use Debtor Configuration."
	};
	exports.FlightSearchConfigurationEnableNDC = FlightSearchConfigurationEnableNDC;
	var FlightSearchConfigurationMaxStopsQuantity = {
	  displayName: "Max Stops Quantity",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.MaxStopsQuantity",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  inputType: "number"
	};
	exports.FlightSearchConfigurationMaxStopsQuantity = FlightSearchConfigurationMaxStopsQuantity;
	var FlightSearchConfigurationCountryOrigin = {
	  displayName: "Origin Countries",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.CountryOrigin",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT,
	  helpText: "If set, query will only be used if Origin country codes are in the list. ** Named list support"
	};
	exports.FlightSearchConfigurationCountryOrigin = FlightSearchConfigurationCountryOrigin;
	var FlightSearchConfigurationCountryDestination = {
	  displayName: "Destination Countries",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.CountryDestination",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT,
	  helpText: "If set, query will only be used if Destination country codes are in the list. ** Named list support"
	};
	
	exports.FlightSearchConfigurationCountryDestination = FlightSearchConfigurationCountryDestination;
	var FlightSearchConfigurationPriority = {
	  displayName: "Priority",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.Priority",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.MULTI_SELECT,
	  optionsAt: "FlightConfigurationPriority",
	  html: "Leave blank for system configuration. Enter the order of priority. First 1 in list is the highest priority."
	};
	
	var FlightSearchConfigurationKeepSameCabin = {
	  displayName: "Keep Same Cabin",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.KeepSameCabin",
	  helpText: "BFM Configuration leave blank for default configuration",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "BoolNullableType",
	  handleAsString: true,
	  allowNullable: true
	};
	
	var FlightSearchConfigurationFareFocusRulesExclude = {
	  displayName: "Fare Focus Rules Exclude",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.FareFocusRulesExclude",
	  helpText: "BFM Configuration leave blank for default configuration",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "BoolNullableType",
	  handleAsString: true,
	  allowNullable: true
	};
	var FlightSearchConfigurationOfferControlRulesExclude = {
	  displayName: "Offer Control Rules Exclude",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.OfferControlRulesExclude",
	  helpText: "BFM Configuration leave blank for default configuration",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "BoolNullableType",
	  handleAsString: true,
	  allowNullable: true
	};
	var FlightSearchConfigurationItineraryCount = {
	  displayName: "Itinerary Count",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.ItineraryCount",
	  helpText: "BFM Configuration leave blank for default configuration",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  inputType: "number"
	};
	var FlightSearchConfigurationNumTrips = {
	  displayName: "Num Trips",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.NumTrips",
	  helpText: "BFM Configuration leave blank for default configuration",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  inputType: "number"
	};
	var FlightSearchConfigurationVendorPrefApplicabilityAtLeastOne = {
	  displayName: "Vendor Pref Applicability AtLeast One",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.VendorPrefApplicabilityAtLeastOne",
	  helpText: "BFM Configuration leave blank for default configuration",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "BoolNullableType",
	  handleAsString: true,
	  allowNullable: true
	};
	var FlightSearchConfigurationCarrierFilterApplyValidatingCarrier = {
	  displayName: "Carrier Filter Apply Validating Carrier",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.CarrierFilterApplyValidatingCarrier",
	  helpText: "BFM Configuration leave blank for default configuration",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "BoolNullableType",
	  handleAsString: true,
	  allowNullable: true
	};
	var FlightSearchConfigurationDiversityHandling = {
	  displayName: "Carrier Filter Apply Validating Carrier",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.DiversityHandling",
	  helpText: "BFM Configuration leave blank for default configuration",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "DiversityHandlingType"
	};
	
	var FlightSearchConfigurationAdditionalNonStopsPercentage = {
	  displayName: "Additional NonStops Percentage",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.AdditionalNonStopsPercentage",
	  helpText: "BFM Configuration leave blank for default configuration",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  inputType: "number"
	};
	var FlightSearchConfigurationLowFareBucketFareCutOffPercentage = {
	  displayName: "Low Fare Bucket Fare Cut Off Percentage",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.LowFareBucketFareCutOffPercentage",
	  helpText: "BFM Configuration leave blank for default configuration",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  inputType: "number"
	};
	var FlightSearchConfigurationLowFareBucketOptionsPercentage = {
	  displayName: "Low FareBucket Options Percentage",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.LowFareBucketOptionsPercentage",
	  helpText: "BFM Configuration leave blank for default configuration.",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  inputType: "number"
	};
	var FlightSearchConfigurationSetBrandedFareOptions = {
	  displayName: "Set BrandedF are Options",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.SetBrandedFareOptions",
	  helpText: "When not checked system will use system configuration. To override check this box and set Multiple and Single branded fare values below.",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	var FlightSearchConfigurationMultipleBrandedFare = {
	  displayName: "Multiple Branded Fare",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.MultipleBrandedFare",
	  helpText: "BFM Configuration leave blank for default configuration. Ignored when Set Branded Fare Options = false",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "BoolNullableType",
	  handleAsString: true,
	  allowNullable: true
	};
	var FlightSearchConfigurationSingleBrandedFare = {
	  displayName: "Single Branded Fare",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.SingleBrandedFare",
	  helpText: "BFM Configuration leave blank for default configuration. Ignored when Set Branded Fare Options = false",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "BoolNullableType",
	  handleAsString: true,
	  allowNullable: true
	};
	
	var FlightSearchConfigurationTimeWindowsOutbound = {
	  displayName: "Time Windows Outbound",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.TimeWindowsOutbound",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT,
	  html: "List of time windows. <br/>- use for empty value. This means system will use configured time window. Either none or configured default time window. <br/>" + "Format: HHmmHHmm example: 12002359 Begin time in HHmm followed by end time HHmm. Note end time 2400 is not valid. Enter 2359.<br/> " + "Example all day: 00002359<br/>" + "Enter number for plus or minus range. Example 120 will be plus and minus 120 min from chosen depart time."
	};
	
	var FlightSearchConfigurationTimeWindowRange = {
	  displayName: "Time Window Range (Min)",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.TimeWindowRange",
	  helpText: "Overrides configuration with defined plus and minus time wondow for searched for time.",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  inputType: "number"
	};
	
	var FlightSearchConfigurationIsCombinable = {
	  displayName: "Is Combinable",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.IsCombinable",
	  helpText: "Search configuration is only included if doing a combinable search or not. Leave blank or not set to always include.",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "BoolNullableType",
	  handleAsString: true,
	  allowNullable: true
	};
	var FlightSearchConfigurationIncludeCountryCarriers = {
	  displayName: "Include Country Carriers",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem.IncludeCountryCarriers",
	  helpText: "System to include Country Carriers in carrier list. Based on origin and destination countries.",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "BoolNullableType",
	  handleAsString: true,
	  allowNullable: true
	};
	
	var EnhancedPolicyFlightSearchConfigurationItem = {
	  displayName: "Item",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries.$iflightSearchConfigurationItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [FlightSearchConfigurationCarrierType, FlightSearchConfigurationCarriers, FlightSearchConfigurationExcludeCarriers, FlightSearchConfigurationCabinType, FlightSearchConfigurationCabins, FlightSearchConfigurationRefundableSearch, FlightSearchPassengerTypes, FlightSearchConfigurationIncDebtorPreferred, FlightSearchConfigurationUnbrandedSearch, FlightSearchConfigurationEnableATPCO, FlightSearchConfigurationEnableNDC, FlightSearchConfigurationMaxStopsQuantity, FlightSearchConfigurationCountryOrigin, FlightSearchConfigurationCountryDestination, FlightSearchConfigurationIsCombinable, FlightSearchConfigurationIncludeCountryCarriers, FlightSearchConfigurationTimeWindowsOutbound, FlightSearchConfigurationTimeWindowRange, FlightSearchConfigurationPriority, FlightSearchConfigurationKeepSameCabin, FlightSearchConfigurationFareFocusRulesExclude, FlightSearchConfigurationOfferControlRulesExclude, FlightSearchConfigurationItineraryCount, FlightSearchConfigurationNumTrips, FlightSearchConfigurationVendorPrefApplicabilityAtLeastOne, FlightSearchConfigurationCarrierFilterApplyValidatingCarrier, FlightSearchConfigurationDiversityHandling, FlightSearchConfigurationAdditionalNonStopsPercentage, FlightSearchConfigurationLowFareBucketFareCutOffPercentage, FlightSearchConfigurationLowFareBucketOptionsPercentage, FlightSearchConfigurationSetBrandedFareOptions, FlightSearchConfigurationMultipleBrandedFare, FlightSearchConfigurationSingleBrandedFare],
	  endpoint: "EnhancedPolicyRules",
	  removeParamId: "iflightSearchConfigurationItem",
	  canDelete: true
	};
	exports.EnhancedPolicyFlightSearchConfigurationItem = EnhancedPolicyFlightSearchConfigurationItem;
	var EnhancedPolicyFlightSearchGrid = {
	  tabName: "Flight-Search-Configuration",
	  displayName: "Flight Search Configuration",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightSearch.Queries",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  copyWithoutCopyText: true,
	  gridItem: EnhancedPolicyFlightSearchConfigurationItem,
	  gridCols: [{ name: "CrrT", key: "CarrierType" }, { name: "Crrs", key: "Carriers" }, { name: "ExCrrs", key: "ExcludeCarriers" }, { name: "CbnT", key: "CabinType" }, { name: "Cbn", key: "Cabins" }, { name: "Rfd", key: "RefundableSearchTypes" }, { name: "Pax", key: "PassengerTypes" }, { name: "Pref", key: "IncDebtorPreferred" }, { name: "UnBrd", key: "UnbrandedSearch" }, { name: "ATPCO", key: "EnableATPCO" }, { name: "NDC", key: "EnableNDC" }, { name: "Stp", key: "MaxStopsQuantity" }, { name: "Org", key: "CountryOrigin" }, { name: "Dst", key: "CountryDestination" }]
	};
	exports.EnhancedPolicyFlightSearchGrid = EnhancedPolicyFlightSearchGrid;
	//End FlightSearch
	
	//Start FlightNdcAtpcoTieSettings
	var FlightNdcAtpcoTieSettingsApplicationType = {
	  displayName: "NDC ATPCO Tie Settings Application Type",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightNdcAtpcoTieSettings.ApplicationType",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "FlightNdcAtpcoTieSettingsApplicationType",
	  allowNullable: true,
	  html: _constantsJs2["default"].MESSAGES.NDC_TIE_SETTINGS
	};
	
	var FlightNdcAtpcoTieSettingsThresholdType = {
	  displayName: "NDC ATPCO Tie Settings Threshold Type",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightNdcAtpcoTieSettings.ThresholdType",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "FlightNdcAtpcoTieSettingsThresholdType"
	};
	
	var FlightNdcAtpcoTieSettingsThresholdValue = {
	  displayName: "NDC ATPCO Tie Settings Threshold Value",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.FlightNdcAtpcoTieSettings.ThresholdValue",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  inputType: "number"
	};
	//End FlightNdcAtpcoTieSettings
	
	var DebtorAgencyConfirmationEmailHeaderText = {
	  displayName: "Confirmation Email Custom Header",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.ConfirmationEmailHeaderText",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_AREA,
	  validationMessage: "Max length 250",
	  validationRegex: "^.{1,250}$"
	};
	
	var DebtorAgencyConfirmationEmailFooterText = {
	  displayName: "Confirmation Email Custom Footer",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.ConfirmationEmailFooterText",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_AREA,
	  validationMessage: "Max length 250",
	  validationRegex: "^.{1,250}$"
	};
	
	var EnableNewUiHandlingTypeEnhancedPolicy = {
	  displayName: "Enable New UI",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem.PolicySettings.EnableNewUiHandlingType",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "EnableNewUiHandlingType",
	  allowNullable: true,
	  defaultValue: null
	};
	
	var EnhancedPolicyRulesActionsPolicySettingsItem = {
	  displayName: "Actions Policy Settings",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsPolicySettingsItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [EnhancedPolicyWeight, ApplyVirtualCreditCard, TravellerConfigurationProfilePnrBuilder, EnhancedPolicyFlightModificationSettingsGrid, EnhancedPolicyFlightSearchConfigurationConfigurationType, EnhancedPolicyFlightSearchGrid, FlightNdcAtpcoTieSettingsApplicationType, FlightNdcAtpcoTieSettingsThresholdType, FlightNdcAtpcoTieSettingsThresholdValue, DebtorAgencyConfirmationEmailHeaderText, DebtorAgencyConfirmationEmailFooterText, EnableNewUiHandlingTypeEnhancedPolicy],
	  endpoint: "EnhancedPolicyRules",
	  routeParamId: "enhancedPolicyRulesId",
	  removeParamId: "EnhancedPolicyRulesActionsPolicySettingsItem",
	  canDelete: true
	};
	exports.EnhancedPolicyRulesActionsPolicySettingsItem = EnhancedPolicyRulesActionsPolicySettingsItem;

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	//LimitPassengerPolicy
	
	var EnhancedPolicyRulesLimitPassengerEnablePassengerLimit = {
	  displayName: "Enable Limit Passenger Policy",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.IsEnabled",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	var EnhancedPolicyRulesLimitPassengerFlightConfigurationPassengerLimit = {
	  displayName: "Limit Count",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.LimitCount",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  inputType: "number"
	};
	
	//LimitPassengerPolicy-DebtorIdentification
	
	var EnhancedPolicyRulesLimitPassengerDebtorIdentificationType = {
	  displayName: "Type",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.DebtorIdentification.DebtorIdentificationType",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "DebtorIdentificationType",
	  hideShowProperty: "DebtorIdentificationType"
	};
	
	var EnhancedPolicyRulesLimitPassengerDebtorIdentificationDefinedDks = {
	  displayName: "DefinedDks",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.DebtorIdentification.DefinedDks",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT,
	  formClass: "DebtorIdentificationType_DefinedDks"
	};
	
	var EnhancedPolicyRulesLimitPassengerDebtorIdentificationGroupCodeValue = {
	  displayName: "GroupCodeValue",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.DebtorIdentification.GroupCodeValue",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  formClass: "DebtorIdentificationType_DefinedGroupCode"
	};
	
	//LimitPassengerPolicy-UdidConfigurations
	
	var EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationType = {
	  displayName: "Type",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.UdidConfigurations.$EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem.UdidType",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "UdidConfigurationType",
	  hideShowProperty: "UdidConfigurationType"
	};
	
	var EnhancedPolicyRulesLimitPassengerPolicyUdidStaticPreTripCode = {
	  displayName: "PreTripCode",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.UdidConfigurations.$EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem.PreTripCode",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  formClass: "UdidConfigurationType_StaticUdid"
	};
	
	var EnhancedPolicyRulesLimitPassengerPolicyUdidStaticValue = {
	  displayName: "Value",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.UdidConfigurations.$EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem.Value",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  formClass: "UdidConfigurationType_StaticUdid"
	};
	
	var EnhancedPolicyRulesLimitPassengerPolicyUdidCompanyReferencePreTripCode = {
	  displayName: "PreTripCode",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.UdidConfigurations.$EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem.PreTripCode",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  formClass: "UdidConfigurationType_CompanyReference"
	};
	
	var EnhancedPolicyRulesLimitPassengerPolicyUdidCompanyReferenceCompanyRefCode = {
	  displayName: "Code",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.UdidConfigurations.$EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem.Value",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  formClass: "UdidConfigurationType_CompanyReference"
	};
	
	var EnhancedPolicyRulesLimitPassengerPolicyUdidAgencyReasonCodePreTripCode = {
	  displayName: "PreTripCode",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.UdidConfigurations.$EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem.PreTripCode",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  formClass: "UdidConfigurationType_AgencyReasonCode"
	};
	
	var EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem = {
	  displayName: "Uuid Configuration",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.UdidConfigurations.$EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationType, EnhancedPolicyRulesLimitPassengerPolicyUdidStaticPreTripCode, EnhancedPolicyRulesLimitPassengerPolicyUdidStaticValue, EnhancedPolicyRulesLimitPassengerPolicyUdidCompanyReferencePreTripCode, EnhancedPolicyRulesLimitPassengerPolicyUdidCompanyReferenceCompanyRefCode, EnhancedPolicyRulesLimitPassengerPolicyUdidAgencyReasonCodePreTripCode],
	  endpoint: "EnhancedPolicyRules",
	  routeParamId: "enhancedPolicyRulesId",
	  removeParamId: "EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem",
	  canDelete: true
	};
	
	exports.EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem = EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem;
	var EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsGrid = {
	  displayName: "Udid Configurations",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.UdidConfigurations",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: false,
	  canAddNew: true,
	  gridItem: EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem,
	  gridCols: [{ name: "Type", key: "UdidType" }, { name: "PreTripCode", key: "PreTripCode" }, { name: "Value", key: "Value" }]
	};
	
	//LimitPassengerPolicy-PolicyRestriction
	
	var EnhancedPolicyRulesLimitPassengerPolicyRestrictiontionRestrictionType = {
	  displayName: "Type",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.PolicyRestriction.RestrictionType",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "PolicyRestrictionType",
	  hideShowProperty: "PolicyRestrictionType"
	};
	
	var EnhancedPolicyRulesLimitPassengerPolicyRestrictionShowButNotAllowMessage = {
	  displayName: "Message",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.PolicyRestriction.DisplayMessage.Message",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_AREA,
	  formClass: "PolicyRestrictionType_ShowButNotAllow"
	};
	
	var EnhancedPolicyRulesLimitPassengerPolicyRestrictionDisplayMessageTitle = {
	  displayName: "Title",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.PolicyRestriction.DisplayMessage.Title",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  formClass: "PolicyRestrictionType_MessagePopup"
	};
	
	var EnhancedPolicyRulesLimitPassengerPolicyRestrictionDisplayMessage = {
	  displayName: "Message",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.PolicyRestriction.DisplayMessage.Message",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_AREA,
	  formClass: "PolicyRestrictionType_MessagePopup"
	};
	
	var EnhancedPolicyRulesLimitPassengerPolicyRestrictionSetOutOfPolicyMessage = {
	  displayName: "Message",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.PolicyRestriction.DisplayMessage.Message",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_AREA,
	  formClass: "PolicyRestrictionType_PolicyViolation"
	};
	
	var EnhancedPolicyRulesLimitPassengerPolicyRestrictionSetOutOfPolicyListId = {
	  displayName: "ListId",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.PolicyRestriction.PolicyViolation.ListId",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  formClass: "PolicyRestrictionType_PolicyViolation",
	  html: "Company Reference ListId to pull option values to choose from."
	};
	
	var EnhancedPolicyRulesLimitPassengerPolicyRestrictionSetOutOfPolicyRemarkFormat = {
	  displayName: "RemarkFormat",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem.LimitPassengerPolicy.PolicyRestriction.PolicyViolation.RemarkFormat",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  formClass: "PolicyRestrictionType_PolicyViolation",
	  html: "Smart.Format used to write remark to booking.<br/>Exmple: .S*UD110 VIOLATION CODE {Value}<br/><i>Properties</i>" + "<ul><li>ValueDescription</li><li>Value</li></ul>"
	};
	
	var EnhancedPolicyRulesActionsLimitPassengerItem = {
	  displayName: "Actions Limit Passenger",
	  dataAt: "Actions.$EnhancedPolicyRulesActionsLimitPassengerItem",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [EnhancedPolicyRulesLimitPassengerEnablePassengerLimit, EnhancedPolicyRulesLimitPassengerFlightConfigurationPassengerLimit,, {
	    displayAs: _constantsJs2["default"].DISPLAY_AS.SUB_HEADING,
	    html: "<h4>Debtor Identification</h4>"
	  }, EnhancedPolicyRulesLimitPassengerDebtorIdentificationType, EnhancedPolicyRulesLimitPassengerDebtorIdentificationDefinedDks, EnhancedPolicyRulesLimitPassengerDebtorIdentificationGroupCodeValue, {
	    displayAs: _constantsJs2["default"].DISPLAY_AS.SUB_HEADING,
	    html: "<h4>Udid Configurations</h4>"
	  }, EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsGrid, {
	    displayAs: _constantsJs2["default"].DISPLAY_AS.SUB_HEADING,
	    html: "<h4>Policy Restrictions</h4>"
	  }, EnhancedPolicyRulesLimitPassengerPolicyRestrictiontionRestrictionType, EnhancedPolicyRulesLimitPassengerPolicyRestrictionDisplayMessageTitle, EnhancedPolicyRulesLimitPassengerPolicyRestrictionDisplayMessage, EnhancedPolicyRulesLimitPassengerPolicyRestrictionShowButNotAllowMessage, EnhancedPolicyRulesLimitPassengerPolicyRestrictionSetOutOfPolicyMessage, EnhancedPolicyRulesLimitPassengerPolicyRestrictionSetOutOfPolicyListId, EnhancedPolicyRulesLimitPassengerPolicyRestrictionSetOutOfPolicyRemarkFormat],
	  endpoint: "EnhancedPolicyRules",
	  routeParamId: "enhancedPolicyRulesId",
	  removeParamId: "EnhancedPolicyRulesActionsLimitPassengerItem",
	  canDelete: true
	};
	exports.EnhancedPolicyRulesActionsLimitPassengerItem = EnhancedPolicyRulesActionsLimitPassengerItem;

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var ProcessUploadStatusUploadedFilename = {
	  displayName: "Uploaded Filename",
	  dataAt: "UploadedFilename",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var ProcessUploadStatusProcessType = {
	  displayName: "ProcessType",
	  dataAt: "ProcessType",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var ProcessUploadStatusUploadedBy = {
	  displayName: "Uploaded By",
	  dataAt: "UploadedBy",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var ProcessUploadStatusUploadedOn = {
	  displayName: "Uploaded On",
	  dataAt: "UploadedOn",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var ProcessUploadStatusLastStatusChange = {
	  displayName: "Last Status Change",
	  dataAt: "LastStatusChange",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var ProcessUploadStatusStatus = {
	  displayName: "Status",
	  dataAt: "Status",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var ProcessUploadStatusNotes = {
	  displayName: "Notes",
	  dataAt: "Notes",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_AREA,
	  disabled: true
	};
	
	var ProcessUploadStatusViewResource = {
	  displayName: "Process Upload Status",
	  iconClass: "fa-gear",
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [ProcessUploadStatusUploadedFilename, ProcessUploadStatusProcessType, ProcessUploadStatusUploadedBy, ProcessUploadStatusUploadedOn, ProcessUploadStatusLastStatusChange, ProcessUploadStatusStatus, ProcessUploadStatusNotes],
	  showBack: true,
	  endpoint: "ProcessUploadStatus",
	  routeParamId: "processUploadStatusId"
	};
	
	var ProcessUploadStatusGrid = {
	  displayName: "Process Upload Status",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.PAGING_GRID,
	  gridCols: [{ name: "UploadedFilename", field: "UploadedFilename" }, { name: "ProcessType", field: "ProcessType" }, { name: "UploadedBy", field: "UploadedBy" }, { name: "UploadedOn", field: "UploadedOn", cellFilter: 'dateDisplay', width: '165' }, { name: "LastStatusChange", field: "LastStatusChange", cellFilter: 'dateDisplay', width: '165' }, { name: "Status", field: "Status" }, { name: "Notes", field: "Notes" }],
	  children: [ProcessUploadStatusUploadedFilename, ProcessUploadStatusUploadedBy, ProcessUploadStatusUploadedOn, ProcessUploadStatusLastStatusChange, ProcessUploadStatusStatus, ProcessUploadStatusNotes],
	  endpoint: "ProcessUploadStatus",
	  filterColumns: "ProcessUploadStatusSearchTypes",
	  defaultFilteredColumn: "UploadedFilename"
	};
	
	var ProcessUploadStatus = {
	  rootNode: true,
	  iconClass: "fa-gear",
	  displayName: "Process Upload Status",
	  showTitle: false,
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  children: [ProcessUploadStatusGrid]
	};
	
	exports["default"] = {
	  ProcessUploadStatus: ProcessUploadStatus,
	  ProcessUploadStatusGrid: ProcessUploadStatusGrid,
	  ProcessUploadStatusViewResource: ProcessUploadStatusViewResource,
	  ProcessUploadStatusUploadedFilename: ProcessUploadStatusUploadedFilename,
	  ProcessUploadStatusUploadedBy: ProcessUploadStatusUploadedBy,
	  ProcessUploadStatusUploadedOn: ProcessUploadStatusUploadedOn,
	  ProcessUploadStatusLastStatusChange: ProcessUploadStatusLastStatusChange,
	  ProcessUploadStatusStatus: ProcessUploadStatusStatus,
	  ProcessUploadStatusNotes: ProcessUploadStatusNotes
	};
	module.exports = exports["default"];

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRulePath = getRulePath;
	exports.getRulePathRoute = getRulePathRoute;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var EndDate = {
	  displayName: 'End date',
	  dataAt: "EndDate",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.DATE_PICKER,
	  disabled: true,
	  returnAsString: true,
	  minDateAt: "StartDate"
	};
	var StartDate = {
	  displayName: 'Start date',
	  dataAt: "StartDate",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.DATE_PICKER,
	  disabled: true,
	  returnAsString: true,
	  maxDateAt: "EndDate"
	};
	
	var CampaignModifiedOn = {
	  displayName: 'Modified On',
	  dataAt: 'ModifiedOn',
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var CampaignModifiedBy = {
	  displayName: 'Modified By',
	  dataAt: 'ModifiedBy',
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var CampaignCreatedOn = {
	  displayName: 'Created On',
	  dataAt: 'CreatedOn',
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var CampaignCreatedBy = {
	  displayName: 'Created By',
	  dataAt: 'CreatedBy',
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT,
	  disabled: true
	};
	
	var CampaignEnabled = {
	  displayName: "Enabled",
	  dataAt: "Enabled",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	var CampaignDebtors = {
	  displayName: "Debtor(s)",
	  dataAt: "Debtors",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.O_DATA_SELECT,
	  endpoint: "Debtors",
	  searchType: "Title",
	  expression: "contains",
	  inputTitle: "Title",
	  selectChoiceName: "Title",
	  entityIdentifier: "Name",
	  searchAllNo: true,
	  isMultiSelect: true,
	  includeDisabled: false,
	  includeOptions: [{
	    Id: "*",
	    Title: "All Debtors",
	    TitleInSearch: "*Apply to All Debtors",
	    IsIncludeOption: true
	  }],
	  includeOptionsPropertyToSave: "Id",
	  dataSelectPropertyToCheck: ""
	};
	
	var CampaignRules = {
	  displayName: "Rule(s)",
	  dataAt: "Rules",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.O_DATA_SELECT,
	  endpoint: "VendorPreferenceConfigRules",
	  searchType: "RuleName",
	  expression: "contains",
	  inputTitle: "RuleName",
	  selectChoiceName: "RuleName",
	  searchAllNo: true,
	  isMultiSelect: true,
	  includeDisabled: false,
	  filterUsingEnabled: true
	};
	
	var CampaignDescription = {
	  displayName: "Description",
	  dataAt: "CampaignDescription",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var CampaignName = {
	  displayName: "Name",
	  dataAt: "CampaignName",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var RuleEnabled = {
	  displayName: "Enabled",
	  dataAt: "Enabled",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.BOOLEAN
	};
	
	var Priority = {
	  displayName: "Priority",
	  dataAt: "Priority",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  rangeValuesAt: "VendorPreferenceRangeValues",
	  showRangeValuesReverseOrder: true,
	  optionsNumbers: true
	};
	
	var HotelIDs = {
	  displayName: "Hotel IDs",
	  dataAt: "HotelIDs",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var HotelChainCodes = {
	  displayName: "Hotel master chain code(s)",
	  dataAt: "HotelChainCodes",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var RuleDescription = {
	  displayName: "Rule description",
	  dataAt: "Description",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var RuleName = {
	  displayName: "Rule name",
	  dataAt: "RuleName",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TEXT_INPUT
	};
	
	var AirPrefWeight = {
	  displayName: "Weight",
	  dataAt: "AirPref.AirPrefWeight",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RANGE,
	  min: 0,
	  max: 100,
	  step: 1,
	  defaultValue: 0,
	  units: "Units",
	  helpText: "When multiple rules are found to be applied the higher weighted rule will be used."
	};
	
	var RuleProductType = {
	  displayName: "Product Type",
	  dataAt: "ProductType",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "VenderPrefRuleProductType"
	};
	
	var AirPrefAirlinesPriority = {
	  displayName: "Priority Airlines",
	  dataAt: "AirPref.AirlinesPrioritized",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var AirPrefAirlinesExcluded = {
	  displayName: "Airlines Excluded",
	  dataAt: "AirPref.AirlinesExcluded",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	
	var AirPrefRtPairOriginCountries = {
	  displayName: "Origin Countries",
	  dataAt: "AirPref.RoutingPairs.$rtPairItemId.OriginCountries",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	var AirPrefRtPairOriginAirportCodes = {
	  displayName: "Origin Airport Codes",
	  dataAt: "AirPref.RoutingPairs.$rtPairItemId.OriginAirportCodes",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	var AirPrefRtPairDestinationCountries = {
	  displayName: "Destination Countries",
	  dataAt: "AirPref.RoutingPairs.$rtPairItemId.DestinationCountries",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	var AirPrefRtPairDestinationAirportCodes = {
	  displayName: "Destination Airport Codes",
	  dataAt: "AirPref.RoutingPairs.$rtPairItemId.DestinationAirportCodes",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TAG_INPUT
	};
	var AirPrefRtPairItem = {
	  displayName: "Routing Pair Item",
	  dataAt: "AirPref.RoutingPairs.$rtPairItemId",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [AirPrefRtPairOriginCountries, AirPrefRtPairOriginAirportCodes, AirPrefRtPairDestinationCountries, AirPrefRtPairDestinationAirportCodes],
	  endpoint: "VendorPreferenceConfigRules",
	  removeParamId: "rtPairItemId",
	  canDelete: true,
	  routeParamId: "rRulesItem"
	};
	var AirPrefRtPairs = {
	  displayName: "Routing Pairs",
	  dataAt: "AirPref.RoutingPairs",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyItem: true,
	  canAddNew: true,
	  gridItem: AirPrefRtPairItem,
	  gridCols: [{ name: "OriginCountries", key: "OriginCountries" }, { name: "OriginAirportCodes", key: "OriginAirportCodes" }, { name: "DestinationCountries", key: "DestinationCountries" }, { name: "DestinationAirportCodes", key: "DestinationAirportCodes" }]
	};
	
	var AirPrefThresholdMinutesPlus = {
	  displayName: "Threshold Plus Minutes",
	  dataAt: "AirPref.ThresholdMinutesPlus",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RANGE,
	  min: 0,
	  max: 1000,
	  step: 15,
	  defaultValue: 0,
	  units: "minutes"
	};
	
	var AirPrefThresholdMinutesMinues = {
	  displayName: "Threshold Minues Minutes",
	  dataAt: "AirPref.ThresholdMinutesMinus",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RANGE,
	  min: 0,
	  max: 1000,
	  step: 15,
	  defaultValue: 0,
	  units: "minutes"
	};
	
	var AirPrefStopPriority = {
	  displayName: "Stop Priority",
	  dataAt: "AirPref.StopPriority",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.SELECT,
	  optionsAt: "VenderPrefAirPrefStopPriority"
	};
	
	var AirPrefSortOrder = {
	  displayName: "Sort Order",
	  dataAt: "AirPref.SortOrder",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.MULTI_SELECT,
	  optionsAt: "VenderPrefAirPrefSortingType"
	};
	
	var RulesGridItem = {
	  displayName: "Item",
	  dataAt: "Rules",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [RuleProductType, RuleName, RuleDescription, HotelChainCodes, HotelIDs, Priority, RuleEnabled],
	  endpoint: "VendorPreferenceConfigRules",
	  routeParamId: "rRulesItem",
	  deleteOnBackend: true,
	  canDelete: true
	};
	
	var RulesGridFlightItem = {
	  displayName: "Item",
	  dataAt: "Rules",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [RuleEnabled, RuleName, RuleDescription, RuleProductType, AirPrefWeight, AirPrefSortOrder, AirPrefAirlinesPriority, AirPrefAirlinesExcluded, AirPrefThresholdMinutesPlus, AirPrefThresholdMinutesMinues, AirPrefStopPriority, AirPrefRtPairs],
	  endpoint: "VendorPreferenceConfigRules",
	  routeParamId: "rRulesItem",
	  deleteOnBackend: true,
	  canDelete: true
	};
	
	var RulesGridItemAddResource = {
	  displayAs: _constantsJs2["default"].DISPLAY_AS.ADD_GRID_RESOURCE,
	  displayName: "Rules",
	  data: { RuleName: "" },
	  dataAt: "",
	  children: [RuleName, RuleProductType],
	  endpoint: "VendorPreferenceConfigRules",
	  continueEditPath: getRulePath
	};
	
	function getRulePath(data) {
	  var displayNamePathReady = getRulePathRoute(data);
	  return '/vendor-preference-configs/rules/' + displayNamePathReady + data.Id;
	}
	
	function getRulePathRoute(data) {
	  switch (data.ProductType) {
	    case "Flight":
	      return 'flight/';
	    case "Hotel":
	    default:
	      return '';
	  }
	}
	
	;
	
	var RulesGrid = {
	  rootNode: true,
	  displayName: "Rules",
	  nameFieldName: "RuleName",
	  endpoint: "VendorPreferenceConfigRules",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyResource: true,
	  canAddNew: true,
	  gridItem: RulesGridItem,
	  gridAdd: RulesGridItemAddResource,
	  canFilterDisabled: true,
	  disableProperty: "Enabled",
	  filterUsingEnabled: true,
	  gridCols: [{ name: "Product", key: "ProductType" }, { name: "Rule Name", key: "RuleName" }, { name: "Description", key: "Description" }, { name: "Enabled", key: "Enabled" }, { name: "Rule Details", key: "RuleDesc", colWidth: "300" }],
	  pathSwitcher: getRulePathRoute
	};
	
	var CampaignsGridItem = {
	  displayName: "Item",
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  children: [CampaignName, CampaignDescription, StartDate, EndDate, CampaignRules, CampaignDebtors, CampaignEnabled, CampaignCreatedBy, CampaignCreatedOn, CampaignModifiedBy, CampaignModifiedOn],
	  endpoint: "VendorPreferenceConfigCampaigns",
	  routeParamId: "cCampaignsItem",
	  deleteOnBackend: true,
	  canDelete: true
	};
	
	var CampaignsGridItemAddResource = {
	  displayAs: _constantsJs2["default"].DISPLAY_AS.ADD_GRID_RESOURCE,
	  displayName: "Campaign",
	  data: { CampaignName: "" },
	  dataAt: "",
	  children: [CampaignName],
	  endpoint: "VendorPreferenceConfigCampaigns"
	};
	
	var CampaignsGrid = {
	  rootNode: true,
	  displayName: "Campaigns",
	  nameFieldName: "CampaignName",
	  endpoint: "CampaignsEager",
	  copyResourceEndpoint: "VendorPreferenceConfigCampaigns",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GRID,
	  canCopyResource: true,
	  canAddNew: true,
	  gridItem: CampaignsGridItem,
	  gridAdd: CampaignsGridItemAddResource,
	  canFilterDisabled: true,
	  disableProperty: "Enabled",
	  filterUsingEnabled: true,
	  isRestEndpoint: true,
	  gridCols: [{ name: "Name", key: "CampaignName" }, { name: "Description", key: "CampaignDescription" }, { name: "Start date", key: "StartDate" }, { name: "End date", key: "EndDate" }, { name: "Rule name", key: "Rules" }, { name: "Debtor", key: "Debtors" }, { name: "Enabled", key: "Enabled" }]
	};
	
	var CampaignsTab = {
	  tabName: "Campaigns",
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  children: [CampaignsGrid]
	};
	
	var RulesTab = {
	  tabName: "Rules",
	  dataAt: "",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.GROUP,
	  children: [RulesGrid]
	};
	
	var VendorPreferenceConfigsTab = {
	  displayName: "Vendor",
	  iconClass: "fa-cog",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.TABS,
	  children: [CampaignsTab, RulesTab]
	};
	
	var VendorPreferenceConfigs = {
	  rootNode: true,
	  displayName: "Vendor Preference Config",
	  displayAs: _constantsJs2["default"].DISPLAY_AS.RESOURCE,
	  iconClass: "fa-cog",
	  dataAt: "",
	  endpoint: "VendorPreferenceConfigCampaigns",
	  children: [VendorPreferenceConfigsTab],
	  hideSave: true
	};
	
	exports["default"] = {
	  VendorPreferenceConfigs: VendorPreferenceConfigs,
	  VendorPreferenceConfigsTab: VendorPreferenceConfigsTab,
	  RulesTab: RulesTab,
	  CampaignsTab: CampaignsTab,
	  CampaignsGrid: CampaignsGrid,
	  CampaignsGridItem: CampaignsGridItem,
	  CampaignsGridItemAddResource: CampaignsGridItemAddResource,
	  RulesGrid: RulesGrid,
	  RulesGridItem: RulesGridItem,
	  RulesGridItemAddResource: RulesGridItemAddResource,
	  RuleName: RuleName,
	  RuleDescription: RuleDescription,
	  HotelChainCodes: HotelChainCodes,
	  Priority: Priority,
	  RuleEnabled: RuleEnabled,
	  CampaignName: CampaignName,
	  CampaignDescription: CampaignDescription,
	  StartDate: StartDate,
	  EndDate: EndDate,
	  CampaignRules: CampaignRules,
	  CampaignDebtors: CampaignDebtors,
	  CampaignEnabled: CampaignEnabled,
	  CampaignCreatedBy: CampaignCreatedBy,
	  CampaignCreatedOn: CampaignCreatedOn,
	  CampaignModifiedBy: CampaignModifiedBy,
	  CampaignModifiedOn: CampaignModifiedOn,
	  RuleProductType: RuleProductType,
	  RulesGridFlightItem: RulesGridFlightItem,
	  AirPrefRtPairItem: AirPrefRtPairItem
	};

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _constantsJs = __webpack_require__(147);
	
	var _constantsJs2 = _interopRequireDefault(_constantsJs);
	
	var ModifiedOn = {
	  displayName: 'Modified on',
	  dataAt: 'ModifiedOn',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var ModifiedBy = {
	  displayName: 'Modified by',
	  dataAt: 'ModifiedBy',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var CreatedOn = {
	  displayName: 'Created on',
	  dataAt: 'CreatedOn',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var CreatedBy = {
	  displayName: 'Created by',
	  dataAt: 'CreatedBy',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var Id = {
	  displayName: 'Identifier',
	  dataAt: 'Id',
	  disabled: true,
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT
	};
	
	var CarrierSustainabilityRating = {
	  displayName: 'Carrier Sustainability Rating',
	  dataAt: 'CarrierSustainabilityRating',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var CarrierName = {
	  displayName: 'Carrier Name',
	  dataAt: 'CarrierName',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var IATACarrierCode = {
	  displayName: 'IATA Carrier Code',
	  dataAt: 'IATACarrierCode',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var ICAOCarrierCode = {
	  displayName: 'ICAO Carrier Code',
	  dataAt: 'ICAOCarrierCode',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.TEXT_INPUT,
	  required: true
	};
	
	var SafScoresResource = {
	  displayName: 'Saf Score',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.RESOURCE,
	  dataAt: '',
	  children: [Id, CarrierSustainabilityRating, CarrierName, IATACarrierCode, ICAOCarrierCode, CreatedOn, CreatedBy, ModifiedOn, ModifiedBy],
	  endpoint: 'SafScores',
	  routeParamId: 'safScoresId',
	  hideSave: true
	};
	
	var SafScoresList = {
	  rootNode: true,
	  displayName: 'Saf Scores',
	  endpoint: 'SafScores',
	  iconClass: 'fa-cog',
	  displayAs: _constantsJs2['default'].DISPLAY_AS.GRID,
	  gridItem: SafScoresResource,
	  routeWithId: true,
	  gridCols: [{ name: 'IATACarrierCode', key: 'IATACarrierCode' }, { name: 'CarrierSustainabilityRating', key: 'CarrierSustainabilityRating' }, { name: 'CarrierName', key: 'CarrierName' }, { name: 'ICAOCarrierCode', key: 'ICAOCarrierCode' }]
	};
	
	exports['default'] = {
	  ModifiedOn: ModifiedOn,
	  ModifiedBy: ModifiedBy,
	  CreatedOn: CreatedOn,
	  CreatedBy: CreatedBy,
	  Id: Id,
	  CarrierSustainabilityRating: CarrierSustainabilityRating,
	  CarrierName: CarrierName,
	  IATACarrierCode: IATACarrierCode,
	  ICAOCarrierCode: ICAOCarrierCode,
	  SafScoresResource: SafScoresResource,
	  SafScoresList: SafScoresList
	};
	module.exports = exports['default'];

/***/ },
/* 472 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	var $inject = ['$q', '$http', '$rootScope'];
	
	var dataService = function dataService($q, $http, $rootScope) {
	    var service = {
	        data: {
	            activeItem: undefined,
	            items: []
	        },
	        addNewMode: false,
	        addNewBackup: undefined,
	        cleanDataOnRouteChange: false,
	        refreshDataOnLoad: false,
	        get: get,
	        post: post,
	        spiltDataAt: spiltDataAt
	    };
	
	    service.search = function search(endpoint, searchTerm, searchType, expression) {
	        var optionalParameters = arguments.length <= 4 || arguments[4] === undefined ? {} : arguments[4];
	
	        var optionalDefaultParameters = {
	            includeDeleted: true,
	            isMultiSelect: false,
	            includeDisabled: true,
	            filterUsingEnabled: false,
	            queryOption: "filter",
	            selectProperty: ""
	        };
	        optionalParameters = Object.assign({}, optionalDefaultParameters, optionalParameters);
	        var isSelectQueryOption = optionalParameters.queryOption === "select" && !!optionalParameters.selectProperty;
	        var deferred = $q.defer();
	        var type = searchType || 'Id';
	        var qs = '';
	        expression = expression || 'eq';
	
	        if (optionalParameters.queryOption === "filter") {
	            if (expression === 'contains') {
	                var searchTermToLower = searchTerm.toLowerCase().trim();
	
	                expression = 'contains(tolower(' + type + '), \'' + searchTermToLower + '\')';
	            } else {
	                if (optionalParameters.isMultiSelect) {
	                    (function () {
	                        var expressionArray = [];
	                        searchTerm.forEach(function (term) {
	                            return expressionArray.push(type + ' eq \'' + term + '\'');
	                        });
	                        expression = expressionArray.length > 1 ? '(' + expressionArray.join(" or ") + ')' : expressionArray;
	                    })();
	                } else {
	                    expression = type + ' eq \'' + searchTerm + '\'';
	                }
	            }
	
	            if (searchTerm) {
	                qs = endPointUrl + '/odata/' + endpoint + '?$filter=' + expression;
	            } else {
	                qs = endPointUrl + '/odata/' + endpoint;
	            }
	        }
	
	        if (isSelectQueryOption) {
	            qs += endPointUrl + '/odata/' + endpoint + '?$select=' + optionalParameters.selectProperty;
	        }
	
	        if (!optionalParameters.includeDeleted) {
	            if (qs.indexOf('$filter') === -1) {
	                qs += '?$filter=&IsDeleted ne true';
	            } else {
	                qs += ' and IsDeleted ne true';
	            }
	        }
	
	        if (!optionalParameters.includeDisabled) {
	            if (qs.indexOf('$filter') === -1) {
	                qs += '?$filter=&' + (optionalParameters.filterUsingEnabled ? "Enabled" : "Disabled") + ' eq ' + (optionalParameters.filterUsingEnabled ? "true" : "false");
	            } else {
	                qs += ' and ' + (optionalParameters.filterUsingEnabled ? "Enabled" : "Disabled") + ' eq ' + (optionalParameters.filterUsingEnabled ? "true" : "false");
	            }
	        }
	
	        $http.get(qs).success(function (data) {
	            console.log(data);
	
	            var responseData = data.value || data;
	
	            if (isSelectQueryOption) {
	                responseData = data['' + optionalParameters.selectProperty];
	            }
	
	            deferred.resolve(responseData);
	        }).error(function (err, x) {
	            console.log(err, x);
	            deferred.reject(err);
	        });
	
	        return deferred.promise;
	    };
	
	    function get(query, id, isRestEndpoint) {
	        $rootScope.$broadcast('lbaLoader:loaderState', { state: true });
	
	        var deferred = $q.defer();
	        var restClientType = isRestEndpoint ? 'api' : 'odata';
	        var url = id ? endPointUrl + '/' + restClientType + '/' + query + '(\'' + id + '\')' : endPointUrl + '/' + restClientType + '/' + query;
	
	        $http.get(url).success(function (data, status, headers) {
	            var ETag = headers('ETag');
	            if (ETag) {
	                sessionStorage.setItem('ETag', ETag);
	            }
	            $rootScope.$broadcast('lbaLoader:loaderState', { state: false, text: '' });
	            $rootScope.$broadcast('lbaToast:showToast', { message: 'Data fetched', messageType: 'success' });
	
	            var responseData = data.value || data;
	
	            deferred.resolve(responseData);
	        }).error(function (err, x) {
	            console.log(err, x);
	            deferred.reject(err);
	        });
	
	        return deferred.promise;
	    }
	
	    function post(query, data, noETag) {
	        var deferred = $q.defer();
	        var url = endPointUrl + '/odata/' + query;
	        var settings = {};
	        if (!noETag) {
	            settings.headers = {
	                'If-Match': sessionStorage.getItem('ETag')
	            };
	        }
	        $rootScope.$broadcast('lbaToast:showToast', { message: 'Posting data...', messageType: 'waiting' });
	
	        $http.post(url, data, settings).success(function (data, status, headers) {
	            $rootScope.isSaved = true;
	            var ETag = headers('ETag');
	            if (ETag) {
	                sessionStorage.setItem('ETag', ETag);
	            }
	            $rootScope.$broadcast('lbaToast:showToast', { message: 'Data saved', messageType: 'success' });
	            deferred.resolve(data);
	        }).error(function (data, status) {
	            console.error(data);
	            if (status === 412) {
	                $rootScope.$broadcast('lbaToast:showToast', { message: 'Data out of date - please refresh', messageType: 'error' });
	            } else if (status === 400) {
	                $rootScope.$broadcast('lbaToast:showToast', { message: 'Provided data is not valid - please review the data', messageType: 'error' });
	            } else {
	                $rootScope.$broadcast('lbaToast:showToast', { message: 'Error occurred', messageType: 'error' });
	            }
	
	            deferred.reject();
	        });
	
	        return deferred.promise;
	    };
	
	    function spiltDataAt(dataAt, routeParams) {
	        return dataAt.split('.').map(function (x) {
	            if (x.startsWith('$')) {
	                x = routeParams[x.substring(1)];
	            }
	            return x;
	        });
	    }
	
	    service['delete'] = function deleteId(resource, id) {
	        var deferred = $q.defer();
	
	        $http['delete'](endPointUrl + '/odata/' + resource + '(\'' + id + '\')').success(function (data) {
	            deferred.resolve(data);
	        }).error(function (data) {
	            deferred.reject(data);
	        });
	
	        return deferred.promise;
	    };
	
	    service.patch = function patchResource(resource, data, id, noETag) {
	        var deferred = $q.defer();
	
	        var settings = {};
	        if (!noETag) {
	            settings.headers = {
	                'If-Match': sessionStorage.getItem('ETag')
	            };
	        }
	        $rootScope.$broadcast('lbaToast:showToast', { message: 'Updating data...', messageType: 'waiting' });
	
	        if (!noETag) {
	            settings.headers = {
	                'If-Match': sessionStorage.getItem('ETag')
	            };
	        }
	        $http.patch(endPointUrl + '/odata/' + resource + '(\'' + id + '\')', data, settings).success(function (data, status, headers) {
	            $rootScope.isSaved = true;
	            var ETag = headers('ETag');
	            if (ETag) {
	                sessionStorage.setItem('ETag', ETag);
	            }
	            $rootScope.$broadcast('lbaToast:showToast', { message: 'Data saved', messageType: 'success' });
	            deferred.resolve(data);
	        }).error(function (data, status) {
	            console.error(data);
	            if (status === 412) {
	                $rootScope.$broadcast('lbaToast:showToast', { message: 'Data out of date - please refresh', messageType: 'error' });
	            } else if (status === 400) {
	                $rootScope.$broadcast('lbaToast:showToast', { message: 'Provided data is not valid - please review the data', messageType: 'error' });
	            } else {
	                $rootScope.$broadcast('lbaToast:showToast', { message: 'Error occurred', messageType: 'error' });
	            }
	            deferred.reject(data);
	        });
	
	        return deferred.promise;
	    };
	
	    return service;
	};
	
	dataService.$inject = $inject;
	
	exports['default'] = dataService;
	module.exports = exports['default'];

/***/ },
/* 473 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$http'];
	
	var indexService = function indexService($q, $http) {
	  var service = {};
	
	  service.search = function search(uri, index, suggestor, apiVersion, expression, searchFields, returnFields, uniqueField, identifier) {
	    var deferred = $q.defer();
	
	    if (!expression) {
	      deferred.reject();
	      return deferred.promise;
	    }
	
	    var searchFieldsCommaSeparated = searchFields.join(',');
	    var returnFieldsCommaSeparated = returnFields.join(',');
	
	    var qs = uri.url + '/indexes/' + index + 'index/docs/suggest?suggesterName=' + suggestor + '&search=' + expression + '&searchFields=' + searchFieldsCommaSeparated + ('&$select=' + returnFieldsCommaSeparated + '&fuzzy=false&api-version=' + apiVersion + '&api-key=' + uri.key + '&$filter=DebtorCode eq \'' + identifier + '\'');
	
	    $http.get(qs).success(function (data) {
	      var responseData = _.uniqBy(data.value, uniqueField) || _.uniqBy(data, uniqueField);
	      deferred.resolve(responseData);
	    }).error(function (err, x) {
	      deferred.reject(err);
	    });
	
	    return deferred.promise;
	  };
	
	  return service;
	};
	
	indexService.$inject = $inject;
	
	exports['default'] = indexService;
	module.exports = exports['default'];

/***/ },
/* 474 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$q', '$http', '$rootScope'];
	
	var subNavService = function subNavService() {
	  var service = {
	    navObj: {}
	  };
	
	  return service;
	};
	
	subNavService.$inject = $inject;
	
	exports['default'] = subNavService;
	module.exports = exports['default'];

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _configConstantsJs = __webpack_require__(147);
	
	var _configConstantsJs2 = _interopRequireDefault(_configConstantsJs);
	
	var $inject = [];
	
	var dataSourceService = function dataSourceService() {
	  var service = {
	    dataSource: _configConstantsJs2['default'].DATA_SOURCES.ODATA
	  };
	
	  return service;
	};
	
	dataSourceService.$inject = $inject;
	
	exports['default'] = dataSourceService;
	module.exports = exports['default'];

/***/ },
/* 476 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$rootScope', '$q', '$http', '$httpParamSerializer'];
	
	var microApiService = function microApiService($rootScope, $q, $http, $httpParamSerializer) {
	  var service = {
	    get: get
	  };
	
	  function refreshToken(params) {
	    console.log('refreshToken');
	    $http({
	      method: 'POST',
	      url: 'https://travelctm-au-development.au.auth0.com/oauth/token',
	      headers: {
	        'Content-Type': 'application/json'
	      },
	      data: {
	        grant_type: 'client_credentials',
	        client_id: 'ubScpD9HcbGzuV2HhUX98G7LZlCTeak6',
	        client_secret: 'jXZsSsXQyMta5Dm-KAB-XvGSy1MrEptu1YfnIV8ufSfElBIjyyLX4DZKG3I_koI7',
	        audience: 'http://debtor'
	      }
	    }).then(function (response) {
	      sessionStorage.setItem('microServiceToken', response.data.access_token);
	      get(params);
	    });
	  }
	
	  function get(params) {
	    $rootScope.$broadcast('lbaLoader:loaderState', { state: true });
	    var microServiceToken = sessionStorage.getItem('microServiceToken');
	
	    if (!microServiceToken) refreshToken(params);
	
	    $http({
	      method: 'GET',
	      url: 'https://debtor-dev.ctmdevelopment.com/v1/' + params.endpoint,
	      headers: {
	        'Authorization': 'Bearer ' + microServiceToken,
	        'Content-Type': 'application/json'
	      }
	    }).then(function (response) {
	      $rootScope.$broadcast('lbaLoader:loaderState', { state: false });
	      $rootScope.$broadcast('lbaToast:showToast', { message: 'Data fetched', messageType: 'success' });
	
	      params.cb(response);
	    }, function (error) {
	      if (error.status === 401) {
	        refreshToken(params);
	      }
	      console.log(error);
	    });
	  }
	
	  return service;
	};
	
	microApiService.$inject = $inject;
	
	exports['default'] = microApiService;
	module.exports = exports['default'];

/***/ },
/* 477 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var $inject = [];
	
	var formValidationService = function formValidationService() {
	    var service = {
	        menuItems: [],
	        setMenuItems: setMenuItems
	    };
	
	    function setMenuItems(navMenuItems) {
	        service.menuItems = navMenuItems;
	    }
	
	    return service;
	};
	
	formValidationService.$inject = $inject;
	
	exports["default"] = formValidationService;
	module.exports = exports["default"];

/***/ },
/* 478 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$location', 'authService', '$window'];
	
	var authCallbackService = function authCallbackService($location, authService, $window) {
	  var service = {};
	  service.checkCallBack = checkCallBack;
	  function checkCallBack() {
	    var path = $location.$$path;
	    if (path && path.includes('access_token=')) {
	      (function () {
	        var contents = path.substring(path.indexOf('access_token='));
	        var parmStr = contents.split('&');
	        var parms = [];
	        parmStr.forEach(function (str) {
	          var item = str.split('=');
	          if (item.length == 2) {
	            parms[item[0]] = item[1];
	          }
	        });
	        if (parms['access_token'] && parms['expires_in']) {
	          authService.storeAuth({
	            expires_in: parms['expires_in'],
	            access_token: parms['access_token'],
	            username: getUsername(parms['id_token'])
	          });
	          var previousState = localStorage.getItem('previousState');
	          console.log('authCallbackService.previousState', previousState);
	          if (previousState && !previousState.includes('login')) {
	            $location.path(previousState);
	          }
	        }
	      })();
	    }
	  }
	
	  function getUsername(jwtToken) {
	    if (!jwtToken) return;
	
	    var parts = jwtToken.split('.');
	    if (!parts.length1 == 3) return;
	    try {
	      var decodedHeader = JSON.parse($window.atob(parts[0]));
	      var decodedPayload = JSON.parse($window.atob(parts[1]));
	      var signature = parts[2];
	      if (decodedPayload && decodedPayload['https://www.ctmsmart.com/username']) {
	        return decodedPayload['https://www.ctmsmart.com/username'];
	      }
	    } catch (e) {
	      console.log('Error decoding username: ' + e.message);
	    }
	  }
	  return service;
	};
	
	authCallbackService.$inject = $inject;
	
	exports['default'] = authCallbackService;
	module.exports = exports['default'];

/***/ },
/* 479 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var $inject = ['$document'];
	var clickOutside = function clickOutside($document) {
	  return {
	    restrict: 'A',
	    scope: {
	      clickOutside: '&'
	    },
	    link: function link(scope, el) {
	      $document.on('mousedown', eventHandler);
	
	      scope.$on('$destroy', function () {
	        $document.off('mousedown', eventHandler);
	      });
	
	      function eventHandler(e) {
	        if (el !== e.target && !el[0].contains(e.target)) {
	          scope.$apply(function () {
	            scope.$eval(scope.clickOutside);
	          });
	        }
	      }
	    }
	  };
	};
	
	clickOutside.$inject = $inject;
	
	exports['default'] = clickOutside;
	module.exports = exports['default'];

/***/ },
/* 480 */
/***/ function(module, exports) {

	var v1="<div class=\"lbaGrid_pagination clearfix\"> <ul class=\"pagination\"> <li ng-class=\"classPageMinRange\"> <a href ng-click=\"page.previous()\">&laquo;</a> </li> <li ng-repeat=\"numPage in rangePage\" ng-class=\"classNumPage(numPage)\"> <a href ng-click=\"page.get(numPage)\"> <span ng-bind=\"numPage\"></span>\n<span class=\"sr-only\" ng-if=\"classNumPage(numPage)\">(current)</span> </a> </li> <li ng-class=\"classPageMaxRange\"> <a href ng-click=\"page.remaining()\">&raquo;</a> </li> </ul> </div>";
	window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("[dir]/[dir]/gridPaginationTpl.html", v1)}]);
	module.exports=v1;

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// app.js